
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6af0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6af0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("bKtXt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomListItemText = $d65d0d91bfae4777$var$CustomListItemText;
module.exports.default = $d65d0d91bfae4777$var$TemporaryDrawer;

var $d65d0d91bfae4777$var$React = $d65d0d91bfae4777$var$_interopRequireWildcard((parcelRequire("acw62")));

var $d65d0d91bfae4777$var$_Box = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $d65d0d91bfae4777$var$_Drawer = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("cPtMf")));

var $d65d0d91bfae4777$var$_List = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("ib3g2")));

var $d65d0d91bfae4777$var$_ListItemButton = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("iVzhN")));

var $d65d0d91bfae4777$var$_ListItemIcon = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("2fe4K")));

var $d65d0d91bfae4777$var$_ListItemText = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("djLZl")));

var $d65d0d91bfae4777$var$_Divider = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("g6BeY")));

var $d65d0d91bfae4777$var$_Menu = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("apGHQ")));

var $d65d0d91bfae4777$var$_Hub = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("eNVql")));

var $d65d0d91bfae4777$var$_Home = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("dLCr5")));

var $d65d0d91bfae4777$var$_Group = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("8fkqf")));

var $d65d0d91bfae4777$var$_Help = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("eGRb8")));

var $d65d0d91bfae4777$var$_AddAlert = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("1f5SY")));

var $d65d0d91bfae4777$var$_CurrencyPound = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("5vmDh")));

var $d65d0d91bfae4777$var$_OnlinePrediction = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("12Iz0")));

var $d65d0d91bfae4777$var$_GridView = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("78dTG")));

var $d65d0d91bfae4777$var$_Logout = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("3ytJg")));

var $gwjoH = parcelRequire("gwjoH");

var $d65d0d91bfae4777$var$_devtank_logo = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("yugLx")));

var $d65d0d91bfae4777$var$_osmLogo = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("6SOfv")));

var $d65d0d91bfae4777$var$_Button = $d65d0d91bfae4777$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $9xY2t = parcelRequire("9xY2t");

var $ayMG0 = parcelRequire("ayMG0");
function $d65d0d91bfae4777$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $d65d0d91bfae4777$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d65d0d91bfae4777$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const $d65d0d91bfae4777$var$BRAND_GREEN = '#1D9E75';
function $d65d0d91bfae4777$var$CustomListItemText({ ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_ListItemText.default, {
        ...props,
        sx: {
            '& .MuiListItemText-primary': {
                fontFamily: "'Syne', sans-serif",
                fontSize: 14,
                fontWeight: 500,
                color: 'var(--color-text-primary)'
            }
        }
    });
}
function $d65d0d91bfae4777$var$NavItem({ to: to, icon: icon, label: label, disabled: disabled, onClick: onClick, external: external }) {
    const location = (0, $gwjoH.useLocation)();
    const isActive = to ? location.pathname === to : false;
    const linkProps = external ? {} : to && !disabled ? {
        component: $gwjoH.Link,
        to: to
    } : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d65d0d91bfae4777$var$_ListItemButton.default, {
        onClick: onClick,
        disabled: disabled,
        ...linkProps,
        sx: {
            borderRadius: 2,
            mx: 1,
            mb: 0.5,
            transition: 'background 0.15s ease',
            background: isActive ? 'rgba(29,158,117,0.12)' : 'transparent',
            '&:hover': {
                background: isActive ? 'rgba(29,158,117,0.18)' : 'rgba(255,255,255,0.05)'
            },
            '& .MuiListItemIcon-root': {
                color: isActive ? $d65d0d91bfae4777$var$BRAND_GREEN : 'var(--color-text-secondary)',
                minWidth: 38,
                transition: 'color 0.15s ease'
            },
            '&:hover .MuiListItemIcon-root': {
                color: $d65d0d91bfae4777$var$BRAND_GREEN
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_ListItemIcon.default, {
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$CustomListItemText, {
                primary: label
            }),
            isActive && /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Box.default, {
                sx: {
                    width: 3,
                    height: 18,
                    borderRadius: 2,
                    background: $d65d0d91bfae4777$var$BRAND_GREEN,
                    ml: 1,
                    flexShrink: 0
                }
            })
        ]
    });
}
function $d65d0d91bfae4777$var$TemporaryDrawer({ user: user, isAdmin: isAdmin }) {
    const [open, setOpen] = $d65d0d91bfae4777$var$React.useState(false);
    const close = ()=>setOpen(false);
    const NAV_ITEMS = [
        {
            to: '/',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Home.default, {}),
            label: 'Home',
            onClick: close
        },
        {
            to: '/overview',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Hub.default, {}),
            label: 'Overview',
            onClick: close
        },
        {
            to: '/sensor-status',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_OnlinePrediction.default, {}),
            label: 'Status',
            onClick: close
        },
        {
            to: '/dashboard-list',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_GridView.default, {}),
            label: 'Dashboard List',
            onClick: close
        },
        {
            to: '/users',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Group.default, {}),
            label: 'Users',
            onClick: close,
            disabled: !isAdmin
        },
        {
            to: '/alerts',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_AddAlert.default, {}),
            label: 'Alerts',
            onClick: close,
            disabled: !isAdmin
        },
        {
            to: '/tariffs',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_CurrencyPound.default, {}),
            label: 'Tariffs',
            onClick: close,
            disabled: !isAdmin
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Help.default, {}),
            label: 'User Manual',
            onClick: ()=>{
                close();
                window.open('/skylight_user_manual.html', '_blank');
            },
            external: true
        }
    ];
    const DrawerList = /*#__PURE__*/ (0, $ayMG0.jsxs)($d65d0d91bfae4777$var$_Box.default, {
        sx: {
            width: 260,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            py: 1.5,
            background: 'var(--color-bg-secondary)'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d65d0d91bfae4777$var$_Box.default, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            justifyContent: 'center',
                            px: 2,
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_osmLogo.default, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Divider.default, {
                        sx: {
                            borderColor: 'var(--color-border-primary, rgba(255,255,255,0.08))',
                            mb: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_List.default, {
                        component: "nav",
                        sx: {
                            px: 0.5
                        },
                        children: NAV_ITEMS.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$NavItem, {
                                ...item
                            }, item.label))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Box.default, {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    px: 2,
                    pt: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_devtank_logo.default, {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d65d0d91bfae4777$var$_Box.default, {
        component: "header",
        sx: {
            width: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 1.5,
            py: 0.75,
            background: 'var(--color-bg-secondary)',
            boxShadow: '0 1px 0 rgba(255,255,255,0.06), 0 4px 12px rgba(0,0,0,0.15)',
            mb: '20px',
            position: 'sticky',
            top: 0,
            zIndex: 100
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Menu.default, {
                    "data-testid": "menu-button",
                    onClick: ()=>setOpen(true),
                    sx: {
                        fontSize: 26,
                        color: 'var(--color-text-secondary)',
                        cursor: 'pointer',
                        transition: 'transform 0.25s ease, color 0.2s ease',
                        '&:hover': {
                            transform: 'rotate(90deg) scale(1.1)',
                            color: $d65d0d91bfae4777$var$BRAND_GREEN
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Link, {
                to: "/",
                style: {
                    textDecoration: 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($d65d0d91bfae4777$var$_Box.default, {
                    component: "span",
                    sx: {
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 22,
                        fontWeight: 700,
                        letterSpacing: '-0.5px',
                        userSelect: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Box.default, {
                            component: "span",
                            sx: {
                                color: $d65d0d91bfae4777$var$BRAND_GREEN
                            },
                            children: "sky"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Box.default, {
                            component: "span",
                            sx: {
                                color: 'var(--color-text-primary, #fff)'
                            },
                            children: "light"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Button.default, {
                variant: "outlined",
                size: "small",
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Logout.default, {
                    sx: {
                        fontSize: '14px !important'
                    }
                }),
                onClick: ()=>(0, $9xY2t.logout)(),
                sx: {
                    fontFamily: "'DM Mono', monospace",
                    fontSize: 11,
                    fontWeight: 500,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: 'var(--color-text-secondary)',
                    borderColor: 'var(--color-border-primary, rgba(255,255,255,0.15))',
                    borderRadius: 2,
                    px: 1.5,
                    py: 0.5,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        borderColor: $d65d0d91bfae4777$var$BRAND_GREEN,
                        color: $d65d0d91bfae4777$var$BRAND_GREEN,
                        background: 'rgba(29,158,117,0.06)'
                    }
                },
                children: "Logout"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d65d0d91bfae4777$var$_Drawer.default, {
                open: open,
                onClose: close,
                PaperProps: {
                    sx: {
                        background: 'var(--color-bg-secondary)',
                        boxShadow: '4px 0 24px rgba(0,0,0,0.3)'
                    }
                },
                children: DrawerList
            })
        ]
    });
}

});
parcelRegister("e5o5x", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $02a57cc52715b250$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $02a57cc52715b250$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $02a57cc52715b250$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $02a57cc52715b250$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $02a57cc52715b250$var$_Box.default;
    }
});

var $02a57cc52715b250$var$_Box = $02a57cc52715b250$require$_interopRequireDefault((parcelRequire("03mUs")));

var $02a57cc52715b250$var$_boxClasses = $02a57cc52715b250$require$_interopRequireWildcard((parcelRequire("hOwN9")));
Object.keys($02a57cc52715b250$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($02a57cc52715b250$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $02a57cc52715b250$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $02a57cc52715b250$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("3pEGv", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $27c3440315f0d929$var$_typeof = $41YNz.default;
function $27c3440315f0d929$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = $27c3440315f0d929$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $27c3440315f0d929$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = $27c3440315f0d929$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("03mUs", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $00a20d475386f68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $izOUK = parcelRequire("izOUK");

var $00a20d475386f68c$var$_propTypes = $00a20d475386f68c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aXEQ8 = parcelRequire("aXEQ8");

var $8xDHs = parcelRequire("8xDHs");

var $00a20d475386f68c$var$_identifier = $00a20d475386f68c$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $00a20d475386f68c$var$_boxClasses = $00a20d475386f68c$require$_interopRequireDefault((parcelRequire("hOwN9")));
const $00a20d475386f68c$var$defaultTheme = (0, $8xDHs.createTheme)();
const $00a20d475386f68c$var$Box = (0, $izOUK.createBox)({
    themeId: $00a20d475386f68c$var$_identifier.default,
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: $00a20d475386f68c$var$_boxClasses.default.root,
    generateClassName: $aXEQ8.unstable_ClassNameGenerator.generate
});
var $00a20d475386f68c$var$_default = module.exports.default = $00a20d475386f68c$var$Box;

});
parcelRegister("izOUK", function(module, exports) {
/**
 * @mui/system v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d862fd65d58a79bb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d862fd65d58a79bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d862fd65d58a79bb$var$_exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Box.default;
    }
});
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Container.default;
    }
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_RtlProvider.default;
    }
});
Object.defineProperty(module.exports, "Stack", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $bOOlK.StyledEngineProvider;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "borders", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_borders.default;
    }
});
Object.defineProperty(module.exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.default;
    }
});
Object.defineProperty(module.exports, "compose", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_compose.default;
    }
});
Object.defineProperty(module.exports, "createBox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBox.default;
    }
});
Object.defineProperty(module.exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "createContainer", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createContainer.default;
    }
});
Object.defineProperty(module.exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createSpacing.default;
    }
});
Object.defineProperty(module.exports, "createStyled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createStyled.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bOOlK.css;
    }
});
Object.defineProperty(module.exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "display", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_display.default;
    }
});
module.exports.experimental_sx = $d862fd65d58a79bb$var$experimental_sx;
Object.defineProperty(module.exports, "flexbox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_flexbox.default;
    }
});
Object.defineProperty(module.exports, "getPath", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getPath;
    }
});
Object.defineProperty(module.exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getStyleValue;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.getThemeProps;
    }
});
Object.defineProperty(module.exports, "grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssGrid.default;
    }
});
Object.defineProperty(module.exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.handleBreakpoints;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bOOlK.keyframes;
    }
});
Object.defineProperty(module.exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty(module.exports, "palette", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_palette.default;
    }
});
Object.defineProperty(module.exports, "positions", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_positions.default;
    }
});
Object.defineProperty(module.exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_responsivePropType.default;
    }
});
Object.defineProperty(module.exports, "shadows", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shadows.default;
    }
});
Object.defineProperty(module.exports, "shape", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shape.default;
    }
});
Object.defineProperty(module.exports, "sizing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_sizing.default;
    }
});
Object.defineProperty(module.exports, "spacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_spacing.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "typography", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_typography.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createGetCssVar.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssVarsParser.default;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty(module.exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty(module.exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_getThemeValue.default;
    }
});
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty(module.exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useMediaQuery.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeWithoutDefault.default;
    }
});

var $d862fd65d58a79bb$var$_formatMuiErrorMessage = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $bOOlK = parcelRequire("bOOlK");

var $d862fd65d58a79bb$var$_GlobalStyles = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fJztl")));

var $d862fd65d58a79bb$var$_borders = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7G2Ky")));
Object.keys($d862fd65d58a79bb$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_borders[key];
        }
    });
});

var $d862fd65d58a79bb$var$_breakpoints = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9mzYC")));

var $d862fd65d58a79bb$var$_cssContainerQueries = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d862fd65d58a79bb$var$_compose = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $d862fd65d58a79bb$var$_display = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $d862fd65d58a79bb$var$_flexbox = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fbcSN")));
Object.keys($d862fd65d58a79bb$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_flexbox[key];
        }
    });
});

var $d862fd65d58a79bb$var$_cssGrid = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bvdLQ")));
Object.keys($d862fd65d58a79bb$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_cssGrid[key];
        }
    });
});

var $d862fd65d58a79bb$var$_palette = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7Izgs")));
Object.keys($d862fd65d58a79bb$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_palette[key];
        }
    });
});

var $d862fd65d58a79bb$var$_positions = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9cp7R")));
Object.keys($d862fd65d58a79bb$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_positions[key];
        }
    });
});

var $d862fd65d58a79bb$var$_shadows = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $d862fd65d58a79bb$var$_sizing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("lk86k")));
Object.keys($d862fd65d58a79bb$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_sizing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_spacing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8ZgMs")));
Object.keys($d862fd65d58a79bb$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_spacing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_style = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fuavR")));

var $d862fd65d58a79bb$var$_typography = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("6a6uc")));
Object.keys($d862fd65d58a79bb$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_typography[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styleFunctionSx = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $d862fd65d58a79bb$var$_getThemeValue = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fykTt")));

var $d862fd65d58a79bb$var$_Box = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8XfTG")));
Object.keys($d862fd65d58a79bb$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Box[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createBox = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $d862fd65d58a79bb$var$_createStyled = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bbeCr")));
Object.keys($d862fd65d58a79bb$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_createStyled[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styled = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kpukb")));

var $d862fd65d58a79bb$var$_createTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $d862fd65d58a79bb$var$_createBreakpoints = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d862fd65d58a79bb$var$_createSpacing = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d862fd65d58a79bb$var$_shape = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d862fd65d58a79bb$var$_useThemeProps = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("2LgDM")));

var $d862fd65d58a79bb$var$_useTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("lywMB")));

var $d862fd65d58a79bb$var$_useThemeWithoutDefault = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("f18iq")));

var $d862fd65d58a79bb$var$_useMediaQuery = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("8h4LK")));

var $h61zw = parcelRequire("h61zw");
Object.keys($h61zw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $h61zw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h61zw[key];
        }
    });
});

var $d862fd65d58a79bb$var$_ThemeProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $d862fd65d58a79bb$var$_memoTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5Ts1H")));

var $d862fd65d58a79bb$var$_createCssVarsProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $d862fd65d58a79bb$var$_createGetCssVar = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hKuOr")));

var $d862fd65d58a79bb$var$_cssVarsParser = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ejFX8")));

var $d862fd65d58a79bb$var$_prepareCssVars = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5magr")));

var $d862fd65d58a79bb$var$_createCssVarsTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("73CWR")));

var $d862fd65d58a79bb$var$_responsivePropType = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $d862fd65d58a79bb$var$_RtlProvider = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9uEev")));
Object.keys($d862fd65d58a79bb$var$_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_RtlProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_RtlProvider[key];
        }
    });
});

var $1RRq5 = parcelRequire("1RRq5");
Object.keys($1RRq5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1RRq5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1RRq5[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createContainer = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("689Qv")));

var $d862fd65d58a79bb$var$_Container = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("jYQTJ")));
Object.keys($d862fd65d58a79bb$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Container[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Container[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Grid = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $gxueG = parcelRequire("gxueG");
Object.keys($gxueG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gxueG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxueG[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Stack = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $106Hq = parcelRequire("106Hq");
Object.keys($106Hq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $106Hq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $106Hq[key];
        }
    });
});
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d862fd65d58a79bb$var$experimental_sx() {
    throw new Error((0, $d862fd65d58a79bb$var$_formatMuiErrorMessage.default)(19));
} /** ----------------- */  /** Layout components */ 

});
parcelRegister("4Z6Nd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a1220d25e8f9182$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3a1220d25e8f9182$var$_formatMuiErrorMessage.default;
    }
});

var $3a1220d25e8f9182$var$_formatMuiErrorMessage = $3a1220d25e8f9182$require$_interopRequireDefault((parcelRequire("3goXx")));

});
parcelRegister("3goXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26063a188a6d1521$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $26063a188a6d1521$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("bOOlK", function(module, exports) {
/**
 * @mui/styled-engine v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $89ab6b9e702438b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_StyledEngineProvider.default;
    }
});
Object.defineProperty(module.exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return $eP9YU.T;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.default = $89ab6b9e702438b4$var$styled;
module.exports.internal_mutateStyles = $89ab6b9e702438b4$var$internal_mutateStyles;
module.exports.internal_serializeStyles = $89ab6b9e702438b4$var$internal_serializeStyles;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});

var $89ab6b9e702438b4$var$_styled = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("5rflj")));

var $8rteH = parcelRequire("8rteH");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
var $jjlaj = parcelRequire("jjlaj");

var $89ab6b9e702438b4$var$_StyledEngineProvider = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("dDJuN")));

var $89ab6b9e702438b4$var$_GlobalStyles = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("gfxtG")));
function $89ab6b9e702438b4$var$styled(tag, options) {
    const stylesFactory = (0, $89ab6b9e702438b4$var$_styled.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_serializeStyles(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
}

});
parcelRegister("5rflj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("dDJuN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9ee2355c3bd069c6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9ee2355c3bd069c6$var$_StyledEngineProvider.default;
    }
});

var $9ee2355c3bd069c6$var$_StyledEngineProvider = $9ee2355c3bd069c6$require$_interopRequireDefault((parcelRequire("2BuCw")));

});
parcelRegister("2BuCw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1e56ca0825dc344f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1e56ca0825dc344f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEST_INTERNALS_DO_NOT_USE = void 0;
module.exports.default = $1e56ca0825dc344f$var$StyledEngineProvider;

var $1e56ca0825dc344f$var$React = $1e56ca0825dc344f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1e56ca0825dc344f$var$_propTypes = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $eP9YU = parcelRequire("eP9YU");

var $1e56ca0825dc344f$var$_cache = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("a9M6v")));

var $jmRmf = parcelRequire("jmRmf");

var $ayMG0 = parcelRequire("ayMG0");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const $1e56ca0825dc344f$var$cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
const $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE = module.exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $1e56ca0825dc344f$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $1e56ca0825dc344f$var$_cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $1e56ca0825dc344f$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $1e56ca0825dc344f$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$1e56ca0825dc344f$var$insertionPoint) {
        $1e56ca0825dc344f$var$insertionPoint = document.createElement('meta');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($1e56ca0825dc344f$var$insertionPoint);
    }
}
function $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends $jmRmf.StyleSheet {
            insert(rule, options) {
                if ($1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert) return $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $1e56ca0825dc344f$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $1e56ca0825dc344f$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $1e56ca0825dc344f$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $1e56ca0825dc344f$var$StyledEngineProvider(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $1e56ca0825dc344f$var$React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1e56ca0825dc344f$var$cacheMap.has(cacheKey)) return $1e56ca0825dc344f$var$cacheMap.get(cacheKey);
        const fresh = $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer);
        $1e56ca0825dc344f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.C, {
        value: cache,
        children: children
    }) : children;
}

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});




parcelRegister("gfxtG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bd48040d38052821$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bd48040d38052821$var$_GlobalStyles.default;
    }
});

var $bd48040d38052821$var$_GlobalStyles = $bd48040d38052821$require$_interopRequireDefault((parcelRequire("bBbjn")));

});
parcelRegister("bBbjn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $871beca1e2477cf0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $871beca1e2477cf0$var$GlobalStyles;

var $871beca1e2477cf0$var$_propTypes = $871beca1e2477cf0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$var$GlobalStyles(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jjlaj.Global, {
        styles: globalStyles
    });
}

});



parcelRegister("fJztl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b7469308f94dcda5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b7469308f94dcda5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b7469308f94dcda5$var$_GlobalStyles.default;
    }
});

var $b7469308f94dcda5$var$_GlobalStyles = $b7469308f94dcda5$require$_interopRequireWildcard((parcelRequire("csO1Z")));
Object.keys($b7469308f94dcda5$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b7469308f94dcda5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b7469308f94dcda5$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b7469308f94dcda5$var$_GlobalStyles[key];
        }
    });
});

});
parcelRegister("csO1Z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $912ee8b2b484e556$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $912ee8b2b484e556$var$_propTypes = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $912ee8b2b484e556$var$_useTheme = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $912ee8b2b484e556$var$wrapGlobalLayer(styles) {
    const serialized = (0, $bOOlK.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $912ee8b2b484e556$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $912ee8b2b484e556$var$_useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $912ee8b2b484e556$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
        styles: globalStyles
    });
}
var $912ee8b2b484e556$var$_default = module.exports.default = $912ee8b2b484e556$var$GlobalStyles;

});
parcelRegister("lywMB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb1633f194eccc90$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb1633f194eccc90$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb1633f194eccc90$var$_useTheme.default;
    }
});

var $fb1633f194eccc90$var$_useTheme = $fb1633f194eccc90$require$_interopRequireWildcard((parcelRequire("cpDNV")));
Object.keys($fb1633f194eccc90$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb1633f194eccc90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb1633f194eccc90$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb1633f194eccc90$var$_useTheme[key];
        }
    });
});

});
parcelRegister("cpDNV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9096b21b03fc4ec3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $9096b21b03fc4ec3$var$_createTheme = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9096b21b03fc4ec3$var$_useThemeWithoutDefault = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("f18iq")));
const $9096b21b03fc4ec3$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $9096b21b03fc4ec3$var$_createTheme.default)();
function $9096b21b03fc4ec3$var$useTheme(defaultTheme = $9096b21b03fc4ec3$var$systemDefaultTheme) {
    return (0, $9096b21b03fc4ec3$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $9096b21b03fc4ec3$var$_default = module.exports.default = $9096b21b03fc4ec3$var$useTheme;

});
parcelRegister("1dhnG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0e247cd7faad5b27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_applyStyles.default;
    }
});

var $0e247cd7faad5b27$var$_createTheme = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("i6Yz2")));

var $0e247cd7faad5b27$var$_createBreakpoints = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $0e247cd7faad5b27$var$_applyStyles = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("e1wfH")));

});
parcelRegister("i6Yz2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2f7c454ab1ec68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f7c454ab1ec68c$var$_deepmerge = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $d2f7c454ab1ec68c$var$_createBreakpoints = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d2f7c454ab1ec68c$var$_cssContainerQueries = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d2f7c454ab1ec68c$var$_shape = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d2f7c454ab1ec68c$var$_createSpacing = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d2f7c454ab1ec68c$var$_styleFunctionSx = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("jUGyl")));

var $d2f7c454ab1ec68c$var$_defaultSxConfig = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("epNpO")));

var $d2f7c454ab1ec68c$var$_applyStyles = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("e1wfH")));
function $d2f7c454ab1ec68c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $d2f7c454ab1ec68c$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $d2f7c454ab1ec68c$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $d2f7c454ab1ec68c$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$d2f7c454ab1ec68c$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $d2f7c454ab1ec68c$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $d2f7c454ab1ec68c$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $d2f7c454ab1ec68c$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$d2f7c454ab1ec68c$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $d2f7c454ab1ec68c$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d2f7c454ab1ec68c$var$_default = module.exports.default = $d2f7c454ab1ec68c$var$createTheme;

});
parcelRegister("bQ4jM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $89e7e67df7bfe402$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $89e7e67df7bfe402$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $89e7e67df7bfe402$var$_deepmerge.default;
    }
});

var $89e7e67df7bfe402$var$_deepmerge = $89e7e67df7bfe402$require$_interopRequireWildcard((parcelRequire("7lnJD")));
Object.keys($89e7e67df7bfe402$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($89e7e67df7bfe402$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $89e7e67df7bfe402$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $89e7e67df7bfe402$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("7lnJD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $558ce7df2a941302$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $558ce7df2a941302$var$deepmerge;
module.exports.isPlainObject = $558ce7df2a941302$var$isPlainObject;

var $558ce7df2a941302$var$React = $558ce7df2a941302$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $558ce7df2a941302$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $558ce7df2a941302$var$deepClone(source) {
    if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source) || (0, $4jPKB.isValidElementType)(source) || !$558ce7df2a941302$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $558ce7df2a941302$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $558ce7df2a941302$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($558ce7df2a941302$var$isPlainObject(target) && $558ce7df2a941302$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source[key]) || (0, $4jPKB.isValidElementType)(source[key])) output[key] = source[key];
        else if ($558ce7df2a941302$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $558ce7df2a941302$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $558ce7df2a941302$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $558ce7df2a941302$var$isPlainObject(source[key]) ? $558ce7df2a941302$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                    case $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});




parcelRegister("hVW0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $d0e4c1a921a97ae9$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $d0e4c1a921a97ae9$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $d0e4c1a921a97ae9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $d0e4c1a921a97ae9$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $d0e4c1a921a97ae9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("18kGB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d3695a183c24848$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $0d3695a183c24848$var$_cssContainerQueries = $0d3695a183c24848$require$_interopRequireWildcard((parcelRequire("hkwSq")));

});
parcelRegister("hkwSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9ddce8fd7553cea$var$cssContainerQueries;
module.exports.getContainerQuery = $c9ddce8fd7553cea$var$getContainerQuery;
module.exports.isCqShorthand = $c9ddce8fd7553cea$var$isCqShorthand;
module.exports.sortContainerQueries = $c9ddce8fd7553cea$var$sortContainerQueries;
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $c9ddce8fd7553cea$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $c9ddce8fd7553cea$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $c9ddce8fd7553cea$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $c9ddce8fd7553cea$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("5H6wp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $425606f5c9c02d28$var$shape = {
    borderRadius: 4
};
var $425606f5c9c02d28$var$_default = module.exports.default = $425606f5c9c02d28$var$shape;

});

parcelRegister("5pAhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0b6db0539d6afd$var$createSpacing;

var $8ZgMs = parcelRequire("8ZgMs");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $3f0b6db0539d6afd$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $8ZgMs.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8ZgMs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68b10981a323f192$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68b10981a323f192$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68b10981a323f192$var$_spacing.default;
    }
});

var $68b10981a323f192$var$_spacing = $68b10981a323f192$require$_interopRequireWildcard((parcelRequire("lJr29")));
Object.keys($68b10981a323f192$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68b10981a323f192$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68b10981a323f192$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68b10981a323f192$var$_spacing[key];
        }
    });
});

});
parcelRegister("lJr29", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd22c53f9de5e49d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $fd22c53f9de5e49d$var$createUnarySpacing;
module.exports.createUnaryUnit = $fd22c53f9de5e49d$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue;
module.exports.getValue = $fd22c53f9de5e49d$var$getValue;
module.exports.margin = $fd22c53f9de5e49d$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $fd22c53f9de5e49d$var$padding;
module.exports.paddingKeys = void 0;

var $fd22c53f9de5e49d$var$_responsivePropType = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");

var $fuavR = parcelRequire("fuavR");

var $fd22c53f9de5e49d$var$_merge = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fd22c53f9de5e49d$var$_memoize = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("iaYJn")));
const $fd22c53f9de5e49d$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $fd22c53f9de5e49d$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $fd22c53f9de5e49d$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fd22c53f9de5e49d$var$getCssProperties = (0, $fd22c53f9de5e49d$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fd22c53f9de5e49d$var$aliases[prop]) prop = $fd22c53f9de5e49d$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $fd22c53f9de5e49d$var$properties[a];
    const direction = $fd22c53f9de5e49d$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fd22c53f9de5e49d$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $fd22c53f9de5e49d$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $fd22c53f9de5e49d$var$spacingKeys = [
    ...$fd22c53f9de5e49d$var$marginKeys,
    ...$fd22c53f9de5e49d$var$paddingKeys
];
function $fd22c53f9de5e49d$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $fuavR.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $fd22c53f9de5e49d$var$createUnarySpacing(theme) {
    return $fd22c53f9de5e49d$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $fd22c53f9de5e49d$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fd22c53f9de5e49d$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $fd22c53f9de5e49d$var$getCssProperties(prop);
    const styleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $fd22c53f9de5e49d$var$style(props, keys) {
    const transformer = $fd22c53f9de5e49d$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer)).reduce($fd22c53f9de5e49d$var$_merge.default, {});
}
function $fd22c53f9de5e49d$var$margin(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$marginKeys);
}
$fd22c53f9de5e49d$var$margin.propTypes = {};
$fd22c53f9de5e49d$var$margin.filterProps = $fd22c53f9de5e49d$var$marginKeys;
function $fd22c53f9de5e49d$var$padding(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$paddingKeys);
}
$fd22c53f9de5e49d$var$padding.propTypes = {};
$fd22c53f9de5e49d$var$padding.filterProps = $fd22c53f9de5e49d$var$paddingKeys;
function $fd22c53f9de5e49d$var$spacing(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$spacingKeys);
}
$fd22c53f9de5e49d$var$spacing.propTypes = {};
$fd22c53f9de5e49d$var$spacing.filterProps = $fd22c53f9de5e49d$var$spacingKeys;
var $fd22c53f9de5e49d$var$_default = module.exports.default = $fd22c53f9de5e49d$var$spacing;

});
parcelRegister("h7FAc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c773589584969aa7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c773589584969aa7$var$_responsivePropType.default;
    }
});

var $c773589584969aa7$var$_responsivePropType = $c773589584969aa7$require$_interopRequireDefault((parcelRequire("aLDOi")));

});
parcelRegister("aLDOi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7d6d2ca3605e13f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6d2ca3605e13f8$var$_propTypes = $7d6d2ca3605e13f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $7d6d2ca3605e13f8$var$responsivePropType = {};
var $7d6d2ca3605e13f8$var$_default = module.exports.default = $7d6d2ca3605e13f8$var$responsivePropType;

});


parcelRegister("9mzYC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d12135a7affaa27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d12135a7affaa27$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d12135a7affaa27$var$_breakpoints.default;
    }
});

var $6d12135a7affaa27$var$_breakpoints = $6d12135a7affaa27$require$_interopRequireWildcard((parcelRequire("1D6M1")));
Object.keys($6d12135a7affaa27$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d12135a7affaa27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d12135a7affaa27$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d12135a7affaa27$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("1D6M1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12feb01311e15547$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $12feb01311e15547$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $12feb01311e15547$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $12feb01311e15547$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $12feb01311e15547$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $12feb01311e15547$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $12feb01311e15547$var$resolveBreakpointValues;
module.exports.values = void 0;

var $12feb01311e15547$var$_propTypes = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12feb01311e15547$var$_deepmerge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $12feb01311e15547$var$_merge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("3naDD")));

var $18kGB = parcelRequire("18kGB");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $12feb01311e15547$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $12feb01311e15547$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$12feb01311e15547$var$values[key]}px)`
};
const $12feb01311e15547$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $12feb01311e15547$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $12feb01311e15547$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $18kGB.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $18kGB.getContainerQuery)(theme.containerQueries ? theme : $12feb01311e15547$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $12feb01311e15547$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $12feb01311e15547$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $12feb01311e15547$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $12feb01311e15547$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $12feb01311e15547$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $12feb01311e15547$var$_deepmerge.default)(prev, next), {});
    return $12feb01311e15547$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $12feb01311e15547$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $12feb01311e15547$var$_default = module.exports.default = $12feb01311e15547$var$breakpoints;

});
parcelRegister("3naDD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $274bc59c460c5c83$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $274bc59c460c5c83$var$_merge.default;
    }
});

var $274bc59c460c5c83$var$_merge = $274bc59c460c5c83$require$_interopRequireDefault((parcelRequire("jb2Pw")));

});
parcelRegister("jb2Pw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $df613d60ccca226b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df613d60ccca226b$var$_deepmerge = $df613d60ccca226b$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $df613d60ccca226b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $df613d60ccca226b$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $df613d60ccca226b$var$_default = module.exports.default = $df613d60ccca226b$var$merge;

});




parcelRegister("fuavR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b461d00304dae97f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b461d00304dae97f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b461d00304dae97f$var$_style.default;
    }
});

var $b461d00304dae97f$var$_style = $b461d00304dae97f$require$_interopRequireWildcard((parcelRequire("5Wz76")));
Object.keys($b461d00304dae97f$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b461d00304dae97f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b461d00304dae97f$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b461d00304dae97f$var$_style[key];
        }
    });
});

});
parcelRegister("5Wz76", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $453d9b5a5bc206c2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $453d9b5a5bc206c2$var$getPath;
module.exports.getStyleValue = $453d9b5a5bc206c2$var$getStyleValue;

var $453d9b5a5bc206c2$var$_capitalize = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("4O6za")));

var $453d9b5a5bc206c2$var$_responsivePropType = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");
function $453d9b5a5bc206c2$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $453d9b5a5bc206c2$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $453d9b5a5bc206c2$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $453d9b5a5bc206c2$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $453d9b5a5bc206c2$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $453d9b5a5bc206c2$var$_default = module.exports.default = $453d9b5a5bc206c2$var$style;

});
parcelRegister("4O6za", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3800ecdd7c2cde61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3800ecdd7c2cde61$var$_capitalize.default;
    }
});

var $3800ecdd7c2cde61$var$_capitalize = $3800ecdd7c2cde61$require$_interopRequireDefault((parcelRequire("afs59")));

});
parcelRegister("afs59", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $776116989b0b93ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $776116989b0b93ea$var$capitalize;

var $776116989b0b93ea$var$_formatMuiErrorMessage = $776116989b0b93ea$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $776116989b0b93ea$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $776116989b0b93ea$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("iaYJn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d3b8450df3f074ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d3b8450df3f074ab$var$_memoize.default;
    }
});

var $d3b8450df3f074ab$var$_memoize = $d3b8450df3f074ab$require$_interopRequireDefault((parcelRequire("9Z7Cd")));

});
parcelRegister("9Z7Cd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $744fb7d21d4e0357$var$memoize;
function $744fb7d21d4e0357$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});





parcelRegister("jUGyl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7f4416c1e9a283b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx;

var $e7f4416c1e9a283b$var$_capitalize = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("4O6za")));

var $e7f4416c1e9a283b$var$_merge = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fuavR = parcelRequire("fuavR");

var $9mzYC = parcelRequire("9mzYC");

var $18kGB = parcelRequire("18kGB");

var $e7f4416c1e9a283b$var$_defaultSxConfig = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("epNpO")));
function $e7f4416c1e9a283b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e7f4416c1e9a283b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $fuavR.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $fuavR.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $fuavR.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $e7f4416c1e9a283b$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $e7f4416c1e9a283b$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $9mzYC.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e7f4416c1e9a283b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $9mzYC.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e7f4416c1e9a283b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e7f4416c1e9a283b$var$styleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx();
$e7f4416c1e9a283b$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e7f4416c1e9a283b$var$_default = module.exports.default = $e7f4416c1e9a283b$var$styleFunctionSx;

});
parcelRegister("epNpO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ZgMs = parcelRequire("8ZgMs");

var $7G2Ky = parcelRequire("7G2Ky");

var $bvdLQ = parcelRequire("bvdLQ");

var $7Izgs = parcelRequire("7Izgs");

var $lk86k = parcelRequire("lk86k");
const $a7e9bb596240d630$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $7G2Ky.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $7Izgs.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    // spacing
    p: {
        style: $8ZgMs.padding
    },
    pt: {
        style: $8ZgMs.padding
    },
    pr: {
        style: $8ZgMs.padding
    },
    pb: {
        style: $8ZgMs.padding
    },
    pl: {
        style: $8ZgMs.padding
    },
    px: {
        style: $8ZgMs.padding
    },
    py: {
        style: $8ZgMs.padding
    },
    padding: {
        style: $8ZgMs.padding
    },
    paddingTop: {
        style: $8ZgMs.padding
    },
    paddingRight: {
        style: $8ZgMs.padding
    },
    paddingBottom: {
        style: $8ZgMs.padding
    },
    paddingLeft: {
        style: $8ZgMs.padding
    },
    paddingX: {
        style: $8ZgMs.padding
    },
    paddingY: {
        style: $8ZgMs.padding
    },
    paddingInline: {
        style: $8ZgMs.padding
    },
    paddingInlineStart: {
        style: $8ZgMs.padding
    },
    paddingInlineEnd: {
        style: $8ZgMs.padding
    },
    paddingBlock: {
        style: $8ZgMs.padding
    },
    paddingBlockStart: {
        style: $8ZgMs.padding
    },
    paddingBlockEnd: {
        style: $8ZgMs.padding
    },
    m: {
        style: $8ZgMs.margin
    },
    mt: {
        style: $8ZgMs.margin
    },
    mr: {
        style: $8ZgMs.margin
    },
    mb: {
        style: $8ZgMs.margin
    },
    ml: {
        style: $8ZgMs.margin
    },
    mx: {
        style: $8ZgMs.margin
    },
    my: {
        style: $8ZgMs.margin
    },
    margin: {
        style: $8ZgMs.margin
    },
    marginTop: {
        style: $8ZgMs.margin
    },
    marginRight: {
        style: $8ZgMs.margin
    },
    marginBottom: {
        style: $8ZgMs.margin
    },
    marginLeft: {
        style: $8ZgMs.margin
    },
    marginX: {
        style: $8ZgMs.margin
    },
    marginY: {
        style: $8ZgMs.margin
    },
    marginInline: {
        style: $8ZgMs.margin
    },
    marginInlineStart: {
        style: $8ZgMs.margin
    },
    marginInlineEnd: {
        style: $8ZgMs.margin
    },
    marginBlock: {
        style: $8ZgMs.margin
    },
    marginBlockStart: {
        style: $8ZgMs.margin
    },
    marginBlockEnd: {
        style: $8ZgMs.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $bvdLQ.gap
    },
    rowGap: {
        style: $bvdLQ.rowGap
    },
    columnGap: {
        style: $bvdLQ.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $lk86k.sizingTransform
    },
    maxWidth: {
        style: $lk86k.maxWidth
    },
    minWidth: {
        transform: $lk86k.sizingTransform
    },
    height: {
        transform: $lk86k.sizingTransform
    },
    maxHeight: {
        transform: $lk86k.sizingTransform
    },
    minHeight: {
        transform: $lk86k.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a7e9bb596240d630$var$_default = module.exports.default = $a7e9bb596240d630$var$defaultSxConfig;

});
parcelRegister("7G2Ky", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $596e96b5ea46c9bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $596e96b5ea46c9bd$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $596e96b5ea46c9bd$var$_borders.default;
    }
});

var $596e96b5ea46c9bd$var$_borders = $596e96b5ea46c9bd$require$_interopRequireWildcard((parcelRequire("ey2Y4")));
Object.keys($596e96b5ea46c9bd$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($596e96b5ea46c9bd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $596e96b5ea46c9bd$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $596e96b5ea46c9bd$var$_borders[key];
        }
    });
});

});
parcelRegister("ey2Y4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a9768b07cfcbed12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $a9768b07cfcbed12$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $a9768b07cfcbed12$var$_responsivePropType = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $a9768b07cfcbed12$var$_style = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a9768b07cfcbed12$var$_compose = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");
function $a9768b07cfcbed12$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a9768b07cfcbed12$var$createBorderStyle(prop, transform) {
    return (0, $a9768b07cfcbed12$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a9768b07cfcbed12$var$border = module.exports.border = $a9768b07cfcbed12$var$createBorderStyle('border', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderTop = module.exports.borderTop = $a9768b07cfcbed12$var$createBorderStyle('borderTop', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderRight = module.exports.borderRight = $a9768b07cfcbed12$var$createBorderStyle('borderRight', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderBottom = module.exports.borderBottom = $a9768b07cfcbed12$var$createBorderStyle('borderBottom', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderLeft = module.exports.borderLeft = $a9768b07cfcbed12$var$createBorderStyle('borderLeft', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderColor = module.exports.borderColor = $a9768b07cfcbed12$var$createBorderStyle('borderColor');
const $a9768b07cfcbed12$var$borderTopColor = module.exports.borderTopColor = $a9768b07cfcbed12$var$createBorderStyle('borderTopColor');
const $a9768b07cfcbed12$var$borderRightColor = module.exports.borderRightColor = $a9768b07cfcbed12$var$createBorderStyle('borderRightColor');
const $a9768b07cfcbed12$var$borderBottomColor = module.exports.borderBottomColor = $a9768b07cfcbed12$var$createBorderStyle('borderBottomColor');
const $a9768b07cfcbed12$var$borderLeftColor = module.exports.borderLeftColor = $a9768b07cfcbed12$var$createBorderStyle('borderLeftColor');
const $a9768b07cfcbed12$var$outline = module.exports.outline = $a9768b07cfcbed12$var$createBorderStyle('outline', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$outlineColor = module.exports.outlineColor = $a9768b07cfcbed12$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $a9768b07cfcbed12$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $a9768b07cfcbed12$var$borderRadius;
$a9768b07cfcbed12$var$borderRadius.propTypes = {};
$a9768b07cfcbed12$var$borderRadius.filterProps = [
    'borderRadius'
];
const $a9768b07cfcbed12$var$borders = (0, $a9768b07cfcbed12$var$_compose.default)($a9768b07cfcbed12$var$border, $a9768b07cfcbed12$var$borderTop, $a9768b07cfcbed12$var$borderRight, $a9768b07cfcbed12$var$borderBottom, $a9768b07cfcbed12$var$borderLeft, $a9768b07cfcbed12$var$borderColor, $a9768b07cfcbed12$var$borderTopColor, $a9768b07cfcbed12$var$borderRightColor, $a9768b07cfcbed12$var$borderBottomColor, $a9768b07cfcbed12$var$borderLeftColor, $a9768b07cfcbed12$var$borderRadius, $a9768b07cfcbed12$var$outline, $a9768b07cfcbed12$var$outlineColor);
var $a9768b07cfcbed12$var$_default = module.exports.default = $a9768b07cfcbed12$var$borders;

});
parcelRegister("79Mi4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $535ed5230f7674fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $535ed5230f7674fe$var$_compose.default;
    }
});

var $535ed5230f7674fe$var$_compose = $535ed5230f7674fe$require$_interopRequireDefault((parcelRequire("8J1Q9")));

});
parcelRegister("8J1Q9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65a3f4214179460a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a3f4214179460a$var$_merge = $65a3f4214179460a$require$_interopRequireDefault((parcelRequire("3naDD")));
function $65a3f4214179460a$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $65a3f4214179460a$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $65a3f4214179460a$var$_default = module.exports.default = $65a3f4214179460a$var$compose;

});




parcelRegister("bvdLQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85fd458c5ff1d64f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85fd458c5ff1d64f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85fd458c5ff1d64f$var$_cssGrid.default;
    }
});

var $85fd458c5ff1d64f$var$_cssGrid = $85fd458c5ff1d64f$require$_interopRequireWildcard((parcelRequire("guYP5")));
Object.keys($85fd458c5ff1d64f$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85fd458c5ff1d64f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85fd458c5ff1d64f$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85fd458c5ff1d64f$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("guYP5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c02ea0e0a59e3ff1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $c02ea0e0a59e3ff1$var$_style = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $c02ea0e0a59e3ff1$var$_compose = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");

var $c02ea0e0a59e3ff1$var$_responsivePropType = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("h7FAc")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $c02ea0e0a59e3ff1$var$gap;
$c02ea0e0a59e3ff1$var$gap.propTypes = {};
$c02ea0e0a59e3ff1$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $c02ea0e0a59e3ff1$var$columnGap;
$c02ea0e0a59e3ff1$var$columnGap.propTypes = {};
$c02ea0e0a59e3ff1$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $c02ea0e0a59e3ff1$var$rowGap;
$c02ea0e0a59e3ff1$var$rowGap.propTypes = {};
$c02ea0e0a59e3ff1$var$rowGap.filterProps = [
    'rowGap'
];
const $c02ea0e0a59e3ff1$var$gridColumn = module.exports.gridColumn = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridColumn'
});
const $c02ea0e0a59e3ff1$var$gridRow = module.exports.gridRow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridRow'
});
const $c02ea0e0a59e3ff1$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $c02ea0e0a59e3ff1$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $c02ea0e0a59e3ff1$var$gridAutoRows = module.exports.gridAutoRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $c02ea0e0a59e3ff1$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $c02ea0e0a59e3ff1$var$gridArea = module.exports.gridArea = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridArea'
});
const $c02ea0e0a59e3ff1$var$grid = (0, $c02ea0e0a59e3ff1$var$_compose.default)($c02ea0e0a59e3ff1$var$gap, $c02ea0e0a59e3ff1$var$columnGap, $c02ea0e0a59e3ff1$var$rowGap, $c02ea0e0a59e3ff1$var$gridColumn, $c02ea0e0a59e3ff1$var$gridRow, $c02ea0e0a59e3ff1$var$gridAutoFlow, $c02ea0e0a59e3ff1$var$gridAutoColumns, $c02ea0e0a59e3ff1$var$gridAutoRows, $c02ea0e0a59e3ff1$var$gridTemplateColumns, $c02ea0e0a59e3ff1$var$gridTemplateRows, $c02ea0e0a59e3ff1$var$gridTemplateAreas, $c02ea0e0a59e3ff1$var$gridArea);
var $c02ea0e0a59e3ff1$var$_default = module.exports.default = $c02ea0e0a59e3ff1$var$grid;

});


parcelRegister("7Izgs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59e7ff3bb6005a45$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59e7ff3bb6005a45$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59e7ff3bb6005a45$var$_palette.default;
    }
});

var $59e7ff3bb6005a45$var$_palette = $59e7ff3bb6005a45$require$_interopRequireWildcard((parcelRequire("hQFW7")));
Object.keys($59e7ff3bb6005a45$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59e7ff3bb6005a45$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59e7ff3bb6005a45$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59e7ff3bb6005a45$var$_palette[key];
        }
    });
});

});
parcelRegister("hQFW7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cfe7d2b3f50e7c96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $cfe7d2b3f50e7c96$var$paletteTransform;

var $cfe7d2b3f50e7c96$var$_style = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("fuavR")));

var $cfe7d2b3f50e7c96$var$_compose = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("79Mi4")));
function $cfe7d2b3f50e7c96$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $cfe7d2b3f50e7c96$var$color = module.exports.color = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$bgcolor = module.exports.bgcolor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$backgroundColor = module.exports.backgroundColor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$palette = (0, $cfe7d2b3f50e7c96$var$_compose.default)($cfe7d2b3f50e7c96$var$color, $cfe7d2b3f50e7c96$var$bgcolor, $cfe7d2b3f50e7c96$var$backgroundColor);
var $cfe7d2b3f50e7c96$var$_default = module.exports.default = $cfe7d2b3f50e7c96$var$palette;

});


parcelRegister("lk86k", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f861bfedd540c484$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f861bfedd540c484$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f861bfedd540c484$var$_sizing.default;
    }
});

var $f861bfedd540c484$var$_sizing = $f861bfedd540c484$require$_interopRequireWildcard((parcelRequire("8hW4G")));
Object.keys($f861bfedd540c484$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f861bfedd540c484$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f861bfedd540c484$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f861bfedd540c484$var$_sizing[key];
        }
    });
});

});
parcelRegister("8hW4G", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $608cf5a5bac56020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $608cf5a5bac56020$var$sizingTransform;
module.exports.width = void 0;

var $608cf5a5bac56020$var$_style = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("fuavR")));

var $608cf5a5bac56020$var$_compose = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $9mzYC = parcelRequire("9mzYC");
function $608cf5a5bac56020$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $608cf5a5bac56020$var$width = module.exports.width = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $9mzYC.values[propValue];
            if (!breakpoint) return {
                maxWidth: $608cf5a5bac56020$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $608cf5a5bac56020$var$maxWidth;
$608cf5a5bac56020$var$maxWidth.filterProps = [
    'maxWidth'
];
const $608cf5a5bac56020$var$minWidth = module.exports.minWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minWidth',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$height = module.exports.height = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxHeight = module.exports.maxHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'maxHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$minHeight = module.exports.minHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeWidth = module.exports.sizeWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeHeight = module.exports.sizeHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$boxSizing = module.exports.boxSizing = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'boxSizing'
});
const $608cf5a5bac56020$var$sizing = (0, $608cf5a5bac56020$var$_compose.default)($608cf5a5bac56020$var$width, $608cf5a5bac56020$var$maxWidth, $608cf5a5bac56020$var$minWidth, $608cf5a5bac56020$var$height, $608cf5a5bac56020$var$maxHeight, $608cf5a5bac56020$var$minHeight, $608cf5a5bac56020$var$boxSizing);
var $608cf5a5bac56020$var$_default = module.exports.default = $608cf5a5bac56020$var$sizing;

});




parcelRegister("e1wfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35a2d48af09cdf6$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a35a2d48af09cdf6$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("f18iq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $aeed627b69a58b85$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aeed627b69a58b85$var$_useThemeWithoutDefault.default;
    }
});

var $aeed627b69a58b85$var$_useThemeWithoutDefault = $aeed627b69a58b85$require$_interopRequireDefault((parcelRequire("7zQRf")));

});
parcelRegister("7zQRf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5844cdc266ab80c7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5844cdc266ab80c7$var$React = $5844cdc266ab80c7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bOOlK = parcelRequire("bOOlK");
function $5844cdc266ab80c7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5844cdc266ab80c7$var$useTheme(defaultTheme = null) {
    const contextTheme = $5844cdc266ab80c7$var$React.useContext($bOOlK.ThemeContext);
    return !contextTheme || $5844cdc266ab80c7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5844cdc266ab80c7$var$_default = module.exports.default = $5844cdc266ab80c7$var$useTheme;

});






parcelRegister("9p2mw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d8847f8b6214b1a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d8847f8b6214b1a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d8847f8b6214b1a$var$_display.default;
    }
});

var $6d8847f8b6214b1a$var$_display = $6d8847f8b6214b1a$require$_interopRequireWildcard((parcelRequire("71hhb")));
Object.keys($6d8847f8b6214b1a$var$_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d8847f8b6214b1a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d8847f8b6214b1a$var$_display[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d8847f8b6214b1a$var$_display[key];
        }
    });
});

});
parcelRegister("71hhb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c60716a78df046$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.whiteSpace = module.exports.visibility = module.exports.textOverflow = module.exports.overflow = module.exports.displayRaw = module.exports.displayPrint = module.exports.default = void 0;

var $51c60716a78df046$var$_style = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("fuavR")));

var $51c60716a78df046$var$_compose = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $51c60716a78df046$var$displayPrint = module.exports.displayPrint = (0, $51c60716a78df046$var$_style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const $51c60716a78df046$var$displayRaw = module.exports.displayRaw = (0, $51c60716a78df046$var$_style.default)({
    prop: 'display'
});
const $51c60716a78df046$var$overflow = module.exports.overflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'overflow'
});
const $51c60716a78df046$var$textOverflow = module.exports.textOverflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'textOverflow'
});
const $51c60716a78df046$var$visibility = module.exports.visibility = (0, $51c60716a78df046$var$_style.default)({
    prop: 'visibility'
});
const $51c60716a78df046$var$whiteSpace = module.exports.whiteSpace = (0, $51c60716a78df046$var$_style.default)({
    prop: 'whiteSpace'
});
var $51c60716a78df046$var$_default = module.exports.default = (0, $51c60716a78df046$var$_compose.default)($51c60716a78df046$var$displayPrint, $51c60716a78df046$var$displayRaw, $51c60716a78df046$var$overflow, $51c60716a78df046$var$textOverflow, $51c60716a78df046$var$visibility, $51c60716a78df046$var$whiteSpace);

});


parcelRegister("fbcSN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b0d1e058eea97628$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b0d1e058eea97628$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b0d1e058eea97628$var$_flexbox.default;
    }
});

var $b0d1e058eea97628$var$_flexbox = $b0d1e058eea97628$require$_interopRequireWildcard((parcelRequire("44hET")));
Object.keys($b0d1e058eea97628$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b0d1e058eea97628$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b0d1e058eea97628$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b0d1e058eea97628$var$_flexbox[key];
        }
    });
});

});
parcelRegister("44hET", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f653bbfbf134bed$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.order = module.exports.justifySelf = module.exports.justifyItems = module.exports.justifyContent = module.exports.flexWrap = module.exports.flexShrink = module.exports.flexGrow = module.exports.flexDirection = module.exports.flexBasis = module.exports.flex = module.exports.default = module.exports.alignSelf = module.exports.alignItems = module.exports.alignContent = void 0;

var $2f653bbfbf134bed$var$_style = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("fuavR")));

var $2f653bbfbf134bed$var$_compose = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $2f653bbfbf134bed$var$flexBasis = module.exports.flexBasis = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexBasis'
});
const $2f653bbfbf134bed$var$flexDirection = module.exports.flexDirection = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexDirection'
});
const $2f653bbfbf134bed$var$flexWrap = module.exports.flexWrap = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexWrap'
});
const $2f653bbfbf134bed$var$justifyContent = module.exports.justifyContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyContent'
});
const $2f653bbfbf134bed$var$alignItems = module.exports.alignItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignItems'
});
const $2f653bbfbf134bed$var$alignContent = module.exports.alignContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignContent'
});
const $2f653bbfbf134bed$var$order = module.exports.order = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'order'
});
const $2f653bbfbf134bed$var$flex = module.exports.flex = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flex'
});
const $2f653bbfbf134bed$var$flexGrow = module.exports.flexGrow = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexGrow'
});
const $2f653bbfbf134bed$var$flexShrink = module.exports.flexShrink = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexShrink'
});
const $2f653bbfbf134bed$var$alignSelf = module.exports.alignSelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignSelf'
});
const $2f653bbfbf134bed$var$justifyItems = module.exports.justifyItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyItems'
});
const $2f653bbfbf134bed$var$justifySelf = module.exports.justifySelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifySelf'
});
const $2f653bbfbf134bed$var$flexbox = (0, $2f653bbfbf134bed$var$_compose.default)($2f653bbfbf134bed$var$flexBasis, $2f653bbfbf134bed$var$flexDirection, $2f653bbfbf134bed$var$flexWrap, $2f653bbfbf134bed$var$justifyContent, $2f653bbfbf134bed$var$alignItems, $2f653bbfbf134bed$var$alignContent, $2f653bbfbf134bed$var$order, $2f653bbfbf134bed$var$flex, $2f653bbfbf134bed$var$flexGrow, $2f653bbfbf134bed$var$flexShrink, $2f653bbfbf134bed$var$alignSelf, $2f653bbfbf134bed$var$justifyItems, $2f653bbfbf134bed$var$justifySelf);
var $2f653bbfbf134bed$var$_default = module.exports.default = $2f653bbfbf134bed$var$flexbox;

});


parcelRegister("9cp7R", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6b28b985c7e8e846$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6b28b985c7e8e846$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6b28b985c7e8e846$var$_positions.default;
    }
});

var $6b28b985c7e8e846$var$_positions = $6b28b985c7e8e846$require$_interopRequireWildcard((parcelRequire("ijOcq")));
Object.keys($6b28b985c7e8e846$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6b28b985c7e8e846$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6b28b985c7e8e846$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6b28b985c7e8e846$var$_positions[key];
        }
    });
});

});
parcelRegister("ijOcq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d560f0ea711888c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zIndex = module.exports.top = module.exports.right = module.exports.position = module.exports.left = module.exports.default = module.exports.bottom = void 0;

var $d560f0ea711888c1$var$_style = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $d560f0ea711888c1$var$_compose = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $d560f0ea711888c1$var$position = module.exports.position = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'position'
});
const $d560f0ea711888c1$var$zIndex = module.exports.zIndex = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const $d560f0ea711888c1$var$top = module.exports.top = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'top'
});
const $d560f0ea711888c1$var$right = module.exports.right = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'right'
});
const $d560f0ea711888c1$var$bottom = module.exports.bottom = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'bottom'
});
const $d560f0ea711888c1$var$left = module.exports.left = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'left'
});
var $d560f0ea711888c1$var$_default = module.exports.default = (0, $d560f0ea711888c1$var$_compose.default)($d560f0ea711888c1$var$position, $d560f0ea711888c1$var$zIndex, $d560f0ea711888c1$var$top, $d560f0ea711888c1$var$right, $d560f0ea711888c1$var$bottom, $d560f0ea711888c1$var$left);

});


parcelRegister("euxvJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8cddc970265def5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a8cddc970265def5$var$_shadows.default;
    }
});

var $a8cddc970265def5$var$_shadows = $a8cddc970265def5$require$_interopRequireDefault((parcelRequire("do9dk")));

});
parcelRegister("do9dk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9bf4a9f1ed138aac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bf4a9f1ed138aac$var$_style = $9bf4a9f1ed138aac$require$_interopRequireDefault((parcelRequire("fuavR")));
const $9bf4a9f1ed138aac$var$boxShadow = (0, $9bf4a9f1ed138aac$var$_style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $9bf4a9f1ed138aac$var$_default = module.exports.default = $9bf4a9f1ed138aac$var$boxShadow;

});


parcelRegister("6a6uc", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $47c8b53a4e972b5f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $47c8b53a4e972b5f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $47c8b53a4e972b5f$var$_typography.default;
    }
});

var $47c8b53a4e972b5f$var$_typography = $47c8b53a4e972b5f$require$_interopRequireWildcard((parcelRequire("e7BDK")));
Object.keys($47c8b53a4e972b5f$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($47c8b53a4e972b5f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $47c8b53a4e972b5f$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47c8b53a4e972b5f$var$_typography[key];
        }
    });
});

});
parcelRegister("e7BDK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a47eeaab0be0bf30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typographyVariant = module.exports.textTransform = module.exports.textAlign = module.exports.lineHeight = module.exports.letterSpacing = module.exports.fontWeight = module.exports.fontStyle = module.exports.fontSize = module.exports.fontFamily = module.exports.default = void 0;

var $a47eeaab0be0bf30$var$_style = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a47eeaab0be0bf30$var$_compose = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $a47eeaab0be0bf30$var$fontFamily = module.exports.fontFamily = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontSize = module.exports.fontSize = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontStyle = module.exports.fontStyle = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontWeight = module.exports.fontWeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$letterSpacing = module.exports.letterSpacing = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'letterSpacing'
});
const $a47eeaab0be0bf30$var$textTransform = module.exports.textTransform = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textTransform'
});
const $a47eeaab0be0bf30$var$lineHeight = module.exports.lineHeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'lineHeight'
});
const $a47eeaab0be0bf30$var$textAlign = module.exports.textAlign = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textAlign'
});
const $a47eeaab0be0bf30$var$typographyVariant = module.exports.typographyVariant = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$typography = (0, $a47eeaab0be0bf30$var$_compose.default)($a47eeaab0be0bf30$var$typographyVariant, $a47eeaab0be0bf30$var$fontFamily, $a47eeaab0be0bf30$var$fontSize, $a47eeaab0be0bf30$var$fontStyle, $a47eeaab0be0bf30$var$fontWeight, $a47eeaab0be0bf30$var$letterSpacing, $a47eeaab0be0bf30$var$lineHeight, $a47eeaab0be0bf30$var$textAlign, $a47eeaab0be0bf30$var$textTransform);
var $a47eeaab0be0bf30$var$_default = module.exports.default = $a47eeaab0be0bf30$var$typography;

});


parcelRegister("l6FST", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5daa5e44059b221$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5daa5e44059b221$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_defaultSxConfig.default;
    }
});

var $f5daa5e44059b221$var$_styleFunctionSx = $f5daa5e44059b221$require$_interopRequireWildcard((parcelRequire("jUGyl")));

var $f5daa5e44059b221$var$_extendSxProp = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("i3YEE")));

var $f5daa5e44059b221$var$_defaultSxConfig = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("epNpO")));

});
parcelRegister("i3YEE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2678e896d0416ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2678e896d0416ce$var$extendSxProp;

var $bQ4jM = parcelRequire("bQ4jM");

var $d2678e896d0416ce$var$_defaultSxConfig = $d2678e896d0416ce$require$_interopRequireDefault((parcelRequire("epNpO")));
const $d2678e896d0416ce$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $d2678e896d0416ce$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d2678e896d0416ce$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $d2678e896d0416ce$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $bQ4jM.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("fykTt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b52a3d10487329b6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b52a3d10487329b6$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b52a3d10487329b6$var$_getThemeValue.default;
    }
});

var $b52a3d10487329b6$var$_getThemeValue = $b52a3d10487329b6$require$_interopRequireWildcard((parcelRequire("bbSQf")));
Object.keys($b52a3d10487329b6$var$_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b52a3d10487329b6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b52a3d10487329b6$var$_getThemeValue[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b52a3d10487329b6$var$_getThemeValue[key];
        }
    });
});

});
parcelRegister("bbSQf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $825b4332527bbf7e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styleFunctionMapping = module.exports.propToStyleFunction = module.exports.default = void 0;

var $825b4332527bbf7e$var$_borders = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7G2Ky")));

var $825b4332527bbf7e$var$_display = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $825b4332527bbf7e$var$_flexbox = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("fbcSN")));

var $825b4332527bbf7e$var$_cssGrid = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("bvdLQ")));

var $825b4332527bbf7e$var$_positions = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9cp7R")));

var $825b4332527bbf7e$var$_palette = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7Izgs")));

var $825b4332527bbf7e$var$_shadows = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $825b4332527bbf7e$var$_sizing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("lk86k")));

var $825b4332527bbf7e$var$_spacing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("8ZgMs")));

var $825b4332527bbf7e$var$_typography = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("6a6uc")));
const $825b4332527bbf7e$var$filterPropsMapping = {
    borders: $825b4332527bbf7e$var$_borders.default.filterProps,
    display: $825b4332527bbf7e$var$_display.default.filterProps,
    flexbox: $825b4332527bbf7e$var$_flexbox.default.filterProps,
    grid: $825b4332527bbf7e$var$_cssGrid.default.filterProps,
    positions: $825b4332527bbf7e$var$_positions.default.filterProps,
    palette: $825b4332527bbf7e$var$_palette.default.filterProps,
    shadows: $825b4332527bbf7e$var$_shadows.default.filterProps,
    sizing: $825b4332527bbf7e$var$_sizing.default.filterProps,
    spacing: $825b4332527bbf7e$var$_spacing.default.filterProps,
    typography: $825b4332527bbf7e$var$_typography.default.filterProps
};
const $825b4332527bbf7e$var$styleFunctionMapping = module.exports.styleFunctionMapping = {
    borders: $825b4332527bbf7e$var$_borders.default,
    display: $825b4332527bbf7e$var$_display.default,
    flexbox: $825b4332527bbf7e$var$_flexbox.default,
    grid: $825b4332527bbf7e$var$_cssGrid.default,
    positions: $825b4332527bbf7e$var$_positions.default,
    palette: $825b4332527bbf7e$var$_palette.default,
    shadows: $825b4332527bbf7e$var$_shadows.default,
    sizing: $825b4332527bbf7e$var$_sizing.default,
    spacing: $825b4332527bbf7e$var$_spacing.default,
    typography: $825b4332527bbf7e$var$_typography.default
};
const $825b4332527bbf7e$var$propToStyleFunction = module.exports.propToStyleFunction = Object.keys($825b4332527bbf7e$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $825b4332527bbf7e$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $825b4332527bbf7e$var$styleFunctionMapping[styleFnName];
    });
    return acc;
}, {});
function $825b4332527bbf7e$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $825b4332527bbf7e$var$propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $825b4332527bbf7e$var$_default = module.exports.default = $825b4332527bbf7e$var$getThemeValue;

});


parcelRegister("8XfTG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68502a45a27be93d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68502a45a27be93d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68502a45a27be93d$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_Box.default;
    }
});

var $68502a45a27be93d$var$_Box = $68502a45a27be93d$require$_interopRequireDefault((parcelRequire("767bZ")));

var $68502a45a27be93d$var$_boxClasses = $68502a45a27be93d$require$_interopRequireWildcard((parcelRequire("7b5dP")));
Object.keys($68502a45a27be93d$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68502a45a27be93d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68502a45a27be93d$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68502a45a27be93d$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("767bZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $52aeac2e4081d4b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52aeac2e4081d4b0$var$_propTypes = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $52aeac2e4081d4b0$var$_ClassNameGenerator = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("aYaRV")));

var $52aeac2e4081d4b0$var$_createBox = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $52aeac2e4081d4b0$var$_boxClasses = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7b5dP")));
const $52aeac2e4081d4b0$var$Box = (0, $52aeac2e4081d4b0$var$_createBox.default)({
    defaultClassName: $52aeac2e4081d4b0$var$_boxClasses.default.root,
    generateClassName: $52aeac2e4081d4b0$var$_ClassNameGenerator.default.generate
});
var $52aeac2e4081d4b0$var$_default = module.exports.default = $52aeac2e4081d4b0$var$Box;

});
parcelRegister("aYaRV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7fc7f047a82393ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7fc7f047a82393ea$var$_ClassNameGenerator.default;
    }
});

var $7fc7f047a82393ea$var$_ClassNameGenerator = $7fc7f047a82393ea$require$_interopRequireDefault((parcelRequire("jyJSW")));

});
parcelRegister("jyJSW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e3d4c91c63801eeb$var$defaultGenerator = (componentName)=>componentName;
const $e3d4c91c63801eeb$var$createClassNameGenerator = ()=>{
    let generate = $e3d4c91c63801eeb$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e3d4c91c63801eeb$var$defaultGenerator;
        }
    };
};
const $e3d4c91c63801eeb$var$ClassNameGenerator = $e3d4c91c63801eeb$var$createClassNameGenerator();
var $e3d4c91c63801eeb$var$_default = module.exports.default = $e3d4c91c63801eeb$var$ClassNameGenerator;

});


parcelRegister("7SBe1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5bca73b38b7b68b2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5bca73b38b7b68b2$var$_createBox.default;
    }
});

var $5bca73b38b7b68b2$var$_createBox = $5bca73b38b7b68b2$require$_interopRequireDefault((parcelRequire("310Oe")));

});
parcelRegister("310Oe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $232217c4f59982d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $232217c4f59982d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $232217c4f59982d0$var$createBox;

var $232217c4f59982d0$var$React = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $232217c4f59982d0$var$_clsx = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $232217c4f59982d0$var$_styledEngine = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("bOOlK")));

var $232217c4f59982d0$var$_styleFunctionSx = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $232217c4f59982d0$var$_useTheme = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $232217c4f59982d0$var$createBox(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $232217c4f59982d0$var$_styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })($232217c4f59982d0$var$_styleFunctionSx.default);
    const Box = /*#__PURE__*/ $232217c4f59982d0$var$React.forwardRef(function Box(inProps, ref) {
        const theme = (0, $232217c4f59982d0$var$_useTheme.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $232217c4f59982d0$var$_styleFunctionSx.extendSxProp)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $232217c4f59982d0$var$_clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});
parcelRegister("9QePP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});



parcelRegister("7b5dP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $539d9c7f6e95ee22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $539d9c7f6e95ee22$var$_generateUtilityClasses = $539d9c7f6e95ee22$require$_interopRequireDefault((parcelRequire("5nY49")));
const $539d9c7f6e95ee22$var$boxClasses = (0, $539d9c7f6e95ee22$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $539d9c7f6e95ee22$var$_default = module.exports.default = $539d9c7f6e95ee22$var$boxClasses;

});
parcelRegister("5nY49", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3ebdb19980d19cf7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3ebdb19980d19cf7$var$_generateUtilityClasses.default;
    }
});

var $3ebdb19980d19cf7$var$_generateUtilityClasses = $3ebdb19980d19cf7$require$_interopRequireDefault((parcelRequire("6q0pz")));

});
parcelRegister("6q0pz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ac57d7e2ab16278$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ac57d7e2ab16278$var$generateUtilityClasses;

var $4ac57d7e2ab16278$var$_generateUtilityClass = $4ac57d7e2ab16278$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ac57d7e2ab16278$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4ac57d7e2ab16278$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("b14cZ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80530d69cb5af7b9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80530d69cb5af7b9$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80530d69cb5af7b9$var$_generateUtilityClass.default;
    }
});

var $80530d69cb5af7b9$var$_generateUtilityClass = $80530d69cb5af7b9$require$_interopRequireWildcard((parcelRequire("8nnml")));
Object.keys($80530d69cb5af7b9$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80530d69cb5af7b9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80530d69cb5af7b9$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80530d69cb5af7b9$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("8nnml", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $61929767e33fc474$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61929767e33fc474$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $61929767e33fc474$var$isGlobalState;

var $61929767e33fc474$var$_ClassNameGenerator = $61929767e33fc474$require$_interopRequireDefault((parcelRequire("aYaRV")));
const $61929767e33fc474$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $61929767e33fc474$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $61929767e33fc474$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$61929767e33fc474$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $61929767e33fc474$var$isGlobalState(slot) {
    return $61929767e33fc474$var$globalStateClasses[slot] !== undefined;
}

});







parcelRegister("bbeCr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $823c0fd313341cc1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $823c0fd313341cc1$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $823c0fd313341cc1$var$_createStyled.default;
    }
});

var $823c0fd313341cc1$var$_createStyled = $823c0fd313341cc1$require$_interopRequireWildcard((parcelRequire("b8EC5")));
Object.keys($823c0fd313341cc1$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($823c0fd313341cc1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $823c0fd313341cc1$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $823c0fd313341cc1$var$_createStyled[key];
        }
    });
});

});
parcelRegister("b8EC5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $81bff209823fdfab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $81bff209823fdfab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81bff209823fdfab$var$createStyled;
module.exports.shouldForwardProp = $81bff209823fdfab$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $81bff209823fdfab$var$_styledEngine = $81bff209823fdfab$require$_interopRequireWildcard((parcelRequire("bOOlK")));

var $bQ4jM = parcelRequire("bQ4jM");

var $81bff209823fdfab$var$_capitalize = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4O6za")));

var $81bff209823fdfab$var$_getDisplayName = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("3cLs1")));

var $81bff209823fdfab$var$_createTheme = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $81bff209823fdfab$var$_styleFunctionSx = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("l6FST")));

var $81bff209823fdfab$var$_preprocessStyles = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $81bff209823fdfab$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $81bff209823fdfab$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $81bff209823fdfab$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $81bff209823fdfab$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $81bff209823fdfab$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $81bff209823fdfab$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $81bff209823fdfab$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$81bff209823fdfab$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $81bff209823fdfab$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $81bff209823fdfab$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $81bff209823fdfab$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $81bff209823fdfab$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $81bff209823fdfab$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $81bff209823fdfab$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $81bff209823fdfab$var$defaultOverridesResolver($81bff209823fdfab$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $81bff209823fdfab$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($81bff209823fdfab$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $81bff209823fdfab$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $81bff209823fdfab$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $bQ4jM.isPlainObject)(style)) {
                const serialized = (0, $81bff209823fdfab$var$_preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $81bff209823fdfab$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $81bff209823fdfab$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $81bff209823fdfab$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $81bff209823fdfab$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push($81bff209823fdfab$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $81bff209823fdfab$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $81bff209823fdfab$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $81bff209823fdfab$var$_getDisplayName.default)(tag)})`;
}
function $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $81bff209823fdfab$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $81bff209823fdfab$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $81bff209823fdfab$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("3cLs1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25574cdde2068c11$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $25574cdde2068c11$var$_getDisplayName.default;
    }
});

var $25574cdde2068c11$var$_getDisplayName = $25574cdde2068c11$require$_interopRequireDefault((parcelRequire("98zty")));

});
parcelRegister("98zty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a706129b6f614d1$var$getDisplayName;

var $4jPKB = parcelRequire("4jPKB");
function $6a706129b6f614d1$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $6a706129b6f614d1$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $6a706129b6f614d1$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $6a706129b6f614d1$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $6a706129b6f614d1$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $4jPKB.ForwardRef:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $4jPKB.Memo:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("4bg7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30b4b2e6e89e9da3$var$preprocessStyles;

var $bOOlK = parcelRequire("bOOlK");
function $30b4b2e6e89e9da3$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bOOlK.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bOOlK.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("kpukb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $edbdaa418a42b560$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edbdaa418a42b560$var$_styled.default;
    }
});

var $edbdaa418a42b560$var$_styled = $edbdaa418a42b560$require$_interopRequireDefault((parcelRequire("haNZP")));

});
parcelRegister("haNZP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c80a270d52203b73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c80a270d52203b73$var$_createStyled = $c80a270d52203b73$require$_interopRequireDefault((parcelRequire("bbeCr")));
const $c80a270d52203b73$var$styled = (0, $c80a270d52203b73$var$_createStyled.default)();
var $c80a270d52203b73$var$_default = module.exports.default = $c80a270d52203b73$var$styled;

});


parcelRegister("2LgDM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $202ce10b3dfaac20$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_getThemeProps.default;
    }
});

var $202ce10b3dfaac20$var$_useThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("lfKzS")));

var $202ce10b3dfaac20$var$_getThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("6wACh")));

});
parcelRegister("lfKzS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f78f2110a61a7e24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78f2110a61a7e24$var$useThemeProps;

var $f78f2110a61a7e24$var$_getThemeProps = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("6wACh")));

var $f78f2110a61a7e24$var$_useTheme = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("lywMB")));
function $f78f2110a61a7e24$var$useThemeProps({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f78f2110a61a7e24$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f78f2110a61a7e24$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("6wACh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c022282094d7502$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c022282094d7502$var$getThemeProps;

var $4c022282094d7502$var$_resolveProps = $4c022282094d7502$require$_interopRequireDefault((parcelRequire("7T9kw")));
function $4c022282094d7502$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4c022282094d7502$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("7T9kw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5be4e83746700573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5be4e83746700573$var$_resolveProps.default;
    }
});

var $5be4e83746700573$var$_resolveProps = $5be4e83746700573$require$_interopRequireDefault((parcelRequire("jgIf5")));

});
parcelRegister("jgIf5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e071d488489a190f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e071d488489a190f$var$resolveProps;

var $e071d488489a190f$var$_clsx = $e071d488489a190f$require$_interopRequireDefault((parcelRequire("9QePP")));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function $e071d488489a190f$var$resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $e071d488489a190f$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $e071d488489a190f$var$_clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});





parcelRegister("8h4LK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $60639c4e52e8e25a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $60639c4e52e8e25a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $60639c4e52e8e25a$var$_useMediaQuery.default;
    }
});

var $60639c4e52e8e25a$var$_useMediaQuery = $60639c4e52e8e25a$require$_interopRequireWildcard((parcelRequire("78KYM")));
Object.keys($60639c4e52e8e25a$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($60639c4e52e8e25a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $60639c4e52e8e25a$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $60639c4e52e8e25a$var$_useMediaQuery[key];
        }
    });
});

});
parcelRegister("78KYM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $532db8df695edb5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $532db8df695edb5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery;

var $532db8df695edb5e$var$React = $532db8df695edb5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $532db8df695edb5e$var$_useEnhancedEffect = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2LgDM = parcelRequire("2LgDM");

var $532db8df695edb5e$var$_useThemeWithoutDefault = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("f18iq")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $532db8df695edb5e$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $532db8df695edb5e$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $532db8df695edb5e$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $532db8df695edb5e$var$safeReact = {
    ...$532db8df695edb5e$var$React
};
const $532db8df695edb5e$var$maybeReactUseSyncExternalStore = $532db8df695edb5e$var$safeReact.useSyncExternalStore;
function $532db8df695edb5e$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $532db8df695edb5e$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $532db8df695edb5e$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $532db8df695edb5e$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $532db8df695edb5e$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $532db8df695edb5e$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $532db8df695edb5e$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $2LgDM.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $532db8df695edb5e$var$maybeReactUseSyncExternalStore !== undefined ? $532db8df695edb5e$var$useMediaQueryNew : $532db8df695edb5e$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $532db8df695edb5e$var$useMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery();
var $532db8df695edb5e$var$_default = module.exports.default = $532db8df695edb5e$var$useMediaQuery;

});
parcelRegister("jdWO4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dfecd8f934112f3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dfecd8f934112f3d$var$_useEnhancedEffect.default;
    }
});

var $dfecd8f934112f3d$var$_useEnhancedEffect = $dfecd8f934112f3d$require$_interopRequireDefault((parcelRequire("89ISn")));

});
parcelRegister("89ISn", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5f01f96cc9bd1b3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f01f96cc9bd1b3c$var$React = $5f01f96cc9bd1b3c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $5f01f96cc9bd1b3c$var$useEnhancedEffect = typeof window !== 'undefined' ? $5f01f96cc9bd1b3c$var$React.useLayoutEffect : $5f01f96cc9bd1b3c$var$React.useEffect;
var $5f01f96cc9bd1b3c$var$_default = module.exports.default = $5f01f96cc9bd1b3c$var$useEnhancedEffect;

});




parcelRegister("h61zw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i0NBZ = parcelRequire("i0NBZ");
Object.keys($i0NBZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i0NBZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i0NBZ[key];
        }
    });
});

});
parcelRegister("i0NBZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1ceb5f718f3f33e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $d1ceb5f718f3f33e$var$alpha;
module.exports.blend = $d1ceb5f718f3f33e$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $d1ceb5f718f3f33e$var$darken;
module.exports.decomposeColor = $d1ceb5f718f3f33e$var$decomposeColor;
module.exports.emphasize = $d1ceb5f718f3f33e$var$emphasize;
module.exports.getContrastRatio = $d1ceb5f718f3f33e$var$getContrastRatio;
module.exports.getLuminance = $d1ceb5f718f3f33e$var$getLuminance;
module.exports.hexToRgb = $d1ceb5f718f3f33e$var$hexToRgb;
module.exports.hslToRgb = $d1ceb5f718f3f33e$var$hslToRgb;
module.exports.lighten = $d1ceb5f718f3f33e$var$lighten;
module.exports.private_safeAlpha = $d1ceb5f718f3f33e$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $d1ceb5f718f3f33e$var$private_safeDarken;
module.exports.private_safeEmphasize = $d1ceb5f718f3f33e$var$private_safeEmphasize;
module.exports.private_safeLighten = $d1ceb5f718f3f33e$var$private_safeLighten;
module.exports.recomposeColor = $d1ceb5f718f3f33e$var$recomposeColor;
module.exports.rgbToHex = $d1ceb5f718f3f33e$var$rgbToHex;

var $d1ceb5f718f3f33e$var$_formatMuiErrorMessage = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $d1ceb5f718f3f33e$var$_clamp = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("3zA0b")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d1ceb5f718f3f33e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $d1ceb5f718f3f33e$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $d1ceb5f718f3f33e$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d1ceb5f718f3f33e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $d1ceb5f718f3f33e$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $d1ceb5f718f3f33e$var$colorChannel = (color)=>{
    const decomposedColor = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $d1ceb5f718f3f33e$var$colorChannel;
const $d1ceb5f718f3f33e$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $d1ceb5f718f3f33e$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $d1ceb5f718f3f33e$var$private_safeColorChannel;
function $d1ceb5f718f3f33e$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $d1ceb5f718f3f33e$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return `#${values.map((n, i)=>$d1ceb5f718f3f33e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $d1ceb5f718f3f33e$var$hslToRgb(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $d1ceb5f718f3f33e$var$getLuminance(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $d1ceb5f718f3f33e$var$getContrastRatio(foreground, background) {
    const lumA = $d1ceb5f718f3f33e$var$getLuminance(foreground);
    const lumB = $d1ceb5f718f3f33e$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$alpha(color, value) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    value = $d1ceb5f718f3f33e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeAlpha(color, value, warning) {
    try {
        return $d1ceb5f718f3f33e$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$darken(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$lighten(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$emphasize(color, coefficient = 0.15) {
    return $d1ceb5f718f3f33e$var$getLuminance(color) > 0.5 ? $d1ceb5f718f3f33e$var$darken(color, coefficient) : $d1ceb5f718f3f33e$var$lighten(color, coefficient);
}
function $d1ceb5f718f3f33e$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $d1ceb5f718f3f33e$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d1ceb5f718f3f33e$var$decomposeColor(background);
    const overlayColor = $d1ceb5f718f3f33e$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("3zA0b", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29a0913aac547ce8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $29a0913aac547ce8$var$_clamp.default;
    }
});

var $29a0913aac547ce8$var$_clamp = $29a0913aac547ce8$require$_interopRequireDefault((parcelRequire("4CRKF")));

});
parcelRegister("4CRKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $35e4680625b68240$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $35e4680625b68240$var$_default = module.exports.default = $35e4680625b68240$var$clamp;

});




parcelRegister("ixP4k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d802ec3fa7ccc11e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d802ec3fa7ccc11e$var$_ThemeProvider.default;
    }
});

var $d802ec3fa7ccc11e$var$_ThemeProvider = $d802ec3fa7ccc11e$require$_interopRequireDefault((parcelRequire("411Qv")));

});
parcelRegister("411Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2ec8aff4a7c0cf18$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2ec8aff4a7c0cf18$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ec8aff4a7c0cf18$var$React = $2ec8aff4a7c0cf18$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2ec8aff4a7c0cf18$var$_propTypes = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3YuG2 = parcelRequire("3YuG2");

var $2ec8aff4a7c0cf18$var$_exactProp = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $bOOlK = parcelRequire("bOOlK");

var $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("f18iq")));

var $2ec8aff4a7c0cf18$var$_RtlProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("9uEev")));

var $2ec8aff4a7c0cf18$var$_DefaultPropsProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("buuO7")));

var $2ec8aff4a7c0cf18$var$_useLayerOrder = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("66f2w")));

var $ayMG0 = parcelRequire("ayMG0");
const $2ec8aff4a7c0cf18$var$EMPTY_THEME = {};
function $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2ec8aff4a7c0cf18$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2ec8aff4a7c0cf18$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault.default)($2ec8aff4a7c0cf18$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $3YuG2.useTheme)() || $2ec8aff4a7c0cf18$var$EMPTY_THEME;
    const engineTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $2ec8aff4a7c0cf18$var$_useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3YuG2.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ec8aff4a7c0cf18$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($2ec8aff4a7c0cf18$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $2ec8aff4a7c0cf18$var$_default = module.exports.default = $2ec8aff4a7c0cf18$var$ThemeProvider;

});
parcelRegister("3YuG2", function(module, exports) {
/**
 * @mui/private-theming v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2e4ec584c6273f12$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2e4ec584c6273f12$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2e4ec584c6273f12$var$_exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_useTheme.default;
    }
});

var $2e4ec584c6273f12$var$_ThemeProvider = $2e4ec584c6273f12$require$_interopRequireWildcard((parcelRequire("bAAZQ")));
Object.keys($2e4ec584c6273f12$var$_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2e4ec584c6273f12$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2e4ec584c6273f12$var$_ThemeProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2e4ec584c6273f12$var$_ThemeProvider[key];
        }
    });
});

var $2e4ec584c6273f12$var$_useTheme = $2e4ec584c6273f12$require$_interopRequireDefault((parcelRequire("l03D8")));

});
parcelRegister("bAAZQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $86ffc1375996ef3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_nested.default;
    }
});

var $86ffc1375996ef3d$var$_ThemeProvider = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("lYrbz")));

var $86ffc1375996ef3d$var$_nested = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("2NPLA")));

});
parcelRegister("lYrbz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fff44a152eb20ab0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fff44a152eb20ab0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fff44a152eb20ab0$var$React = $fff44a152eb20ab0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fff44a152eb20ab0$var$_propTypes = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fff44a152eb20ab0$var$_exactProp = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $fff44a152eb20ab0$var$_ThemeContext = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("fHPaR")));

var $fff44a152eb20ab0$var$_useTheme = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("l03D8")));

var $fff44a152eb20ab0$var$_nested = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("2NPLA")));

var $ayMG0 = parcelRequire("ayMG0");
// To support composition of theme.
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fff44a152eb20ab0$var$_useTheme.default)();
    const theme = $fff44a152eb20ab0$var$React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[$fff44a152eb20ab0$var$_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fff44a152eb20ab0$var$_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$var$_default = module.exports.default = $fff44a152eb20ab0$var$ThemeProvider;

});
parcelRegister("5S3aN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $446475069c751d22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $446475069c751d22$var$_exactProp.default;
    }
});

var $446475069c751d22$var$_exactProp = $446475069c751d22$require$_interopRequireDefault((parcelRequire("9RGCL")));

});
parcelRegister("9RGCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72ea20960eca48cd$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $72ea20960eca48cd$var$specialProperty = 'exact-prop: \u200b';
function $72ea20960eca48cd$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("fHPaR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b6f2914bcc222460$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6f2914bcc222460$var$React = $b6f2914bcc222460$require$_interopRequireWildcard((parcelRequire("acw62")));
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $b6f2914bcc222460$var$React.createContext(null);
var $b6f2914bcc222460$var$_default = module.exports.default = $b6f2914bcc222460$var$ThemeContext;

});

parcelRegister("l03D8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f49c69f16b6a34af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f49c69f16b6a34af$var$_useTheme.default;
    }
});

var $f49c69f16b6a34af$var$_useTheme = $f49c69f16b6a34af$require$_interopRequireDefault((parcelRequire("lT1cX")));

});
parcelRegister("lT1cX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $feefabedf550ce3f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $feefabedf550ce3f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feefabedf550ce3f$var$useTheme;

var $feefabedf550ce3f$var$React = $feefabedf550ce3f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $feefabedf550ce3f$var$_ThemeContext = $feefabedf550ce3f$require$_interopRequireDefault((parcelRequire("fHPaR")));
function $feefabedf550ce3f$var$useTheme() {
    const theme = $feefabedf550ce3f$var$React.useContext($feefabedf550ce3f$var$_ThemeContext.default);
    return theme;
}

});


parcelRegister("2NPLA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$var$_default = module.exports.default = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});




parcelRegister("9uEev", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e961fcfc1c15c66$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e961fcfc1c15c66$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $6e961fcfc1c15c66$var$React = $6e961fcfc1c15c66$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e961fcfc1c15c66$var$_propTypes = $6e961fcfc1c15c66$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $6e961fcfc1c15c66$var$RtlContext = /*#__PURE__*/ $6e961fcfc1c15c66$var$React.createContext();
function $6e961fcfc1c15c66$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6e961fcfc1c15c66$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $6e961fcfc1c15c66$var$useRtl = ()=>{
    const value = $6e961fcfc1c15c66$var$React.useContext($6e961fcfc1c15c66$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $6e961fcfc1c15c66$var$useRtl;
var $6e961fcfc1c15c66$var$_default = module.exports.default = $6e961fcfc1c15c66$var$RtlProvider;

});

parcelRegister("buuO7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85da64c4cc661dcb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $85da64c4cc661dcb$var$_DefaultPropsProvider = $85da64c4cc661dcb$require$_interopRequireWildcard((parcelRequire("k3xKF")));

});
parcelRegister("k3xKF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e99e44d394b0848b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e99e44d394b0848b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $e99e44d394b0848b$var$useDefaultProps;

var $e99e44d394b0848b$var$React = $e99e44d394b0848b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e99e44d394b0848b$var$_propTypes = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e99e44d394b0848b$var$_resolveProps = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ayMG0 = parcelRequire("ayMG0");
const $e99e44d394b0848b$var$PropsContext = /*#__PURE__*/ $e99e44d394b0848b$var$React.createContext(undefined);
function $e99e44d394b0848b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e99e44d394b0848b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $e99e44d394b0848b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $e99e44d394b0848b$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $e99e44d394b0848b$var$React.useContext($e99e44d394b0848b$var$PropsContext);
    return $e99e44d394b0848b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e99e44d394b0848b$var$_default = module.exports.default = $e99e44d394b0848b$var$DefaultPropsProvider;

});


parcelRegister("66f2w", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $470ef830d3f406b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $470ef830d3f406b4$var$useLayerOrder;

var $470ef830d3f406b4$var$_useEnhancedEffect = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $470ef830d3f406b4$var$_useId = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("hwliF")));

var $470ef830d3f406b4$var$_GlobalStyles = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("fJztl")));

var $470ef830d3f406b4$var$_useThemeWithoutDefault = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("f18iq")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function $470ef830d3f406b4$var$useLayerOrder(theme) {
    const upperTheme = (0, $470ef830d3f406b4$var$_useThemeWithoutDefault.default)();
    const id = (0, $470ef830d3f406b4$var$_useId.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $470ef830d3f406b4$var$_useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($470ef830d3f406b4$var$_GlobalStyles.default, {
        styles: layerOrder
    });
}

});
parcelRegister("hwliF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cc15f294b94b87be$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cc15f294b94b87be$var$_useId.default;
    }
});

var $cc15f294b94b87be$var$_useId = $cc15f294b94b87be$require$_interopRequireDefault((parcelRequire("4NWyA")));

});
parcelRegister("4NWyA", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $37f92932f8526401$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37f92932f8526401$var$useId;

var $37f92932f8526401$var$React = $37f92932f8526401$require$_interopRequireWildcard((parcelRequire("acw62")));
let $37f92932f8526401$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $37f92932f8526401$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $37f92932f8526401$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $37f92932f8526401$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $37f92932f8526401$var$globalId += 1;
            setDefaultId(`mui-${$37f92932f8526401$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $37f92932f8526401$var$safeReact = {
    ...$37f92932f8526401$var$React
};
const $37f92932f8526401$var$maybeReactUseId = $37f92932f8526401$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $37f92932f8526401$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($37f92932f8526401$var$maybeReactUseId !== undefined) {
        const reactId = $37f92932f8526401$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $37f92932f8526401$var$useGlobalId(idOverride);
}

});





parcelRegister("5Ts1H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44a7d4485060e536$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44a7d4485060e536$var$unstable_memoTheme;

var $44a7d4485060e536$var$_preprocessStyles = $44a7d4485060e536$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $44a7d4485060e536$var$arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function $44a7d4485060e536$var$unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $44a7d4485060e536$var$arg.theme = props.theme;
            value = (0, $44a7d4485060e536$var$_preprocessStyles.default)(styleFn($44a7d4485060e536$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("3Vfwq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2db2bc563e7e5e69$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2db2bc563e7e5e69$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $2db2bc563e7e5e69$var$createCssVarsProvider;

var $2db2bc563e7e5e69$var$React = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2db2bc563e7e5e69$var$_propTypes = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $3YuG2 = parcelRequire("3YuG2");

var $2db2bc563e7e5e69$var$_useEnhancedEffect = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2db2bc563e7e5e69$var$_ThemeProvider = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $2db2bc563e7e5e69$var$_InitColorSchemeScript = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("79OI6")));

var $2db2bc563e7e5e69$var$_useCurrentColorScheme = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("srPro")));

var $ayMG0 = parcelRequire("ayMG0");
const $2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $2db2bc563e7e5e69$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $2db2bc563e7e5e69$var$React.createContext(undefined);
    const useColorScheme = ()=>$2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $2db2bc563e7e5e69$var$React.useRef(false);
        const upperTheme = (0, $3YuG2.useTheme)();
        const ctx = $2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $2db2bc563e7e5e69$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $2db2bc563e7e5e69$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $2db2bc563e7e5e69$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $2db2bc563e7e5e69$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($2db2bc563e7e5e69$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2db2bc563e7e5e69$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $2db2bc563e7e5e69$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("79OI6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $5360b5aae8294a93$var$InitColorSchemeScript;

var $ayMG0 = parcelRequire("ayMG0");
const $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $5360b5aae8294a93$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else if (attribute !== '.%s') setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("srPro", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $055833d66b0d6531$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $055833d66b0d6531$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $055833d66b0d6531$var$useCurrentColorScheme;
module.exports.getColorScheme = $055833d66b0d6531$var$getColorScheme;
module.exports.getSystemMode = $055833d66b0d6531$var$getSystemMode;

var $055833d66b0d6531$var$React = $055833d66b0d6531$require$_interopRequireWildcard((parcelRequire("acw62")));

var $79OI6 = parcelRequire("79OI6");

var $055833d66b0d6531$var$_localStorageManager = $055833d66b0d6531$require$_interopRequireDefault((parcelRequire("emFGB")));
function $055833d66b0d6531$var$noop() {}
function $055833d66b0d6531$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $055833d66b0d6531$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $055833d66b0d6531$var$getColorScheme(state) {
    return $055833d66b0d6531$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $055833d66b0d6531$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $79OI6.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $79OI6.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $055833d66b0d6531$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $055833d66b0d6531$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $055833d66b0d6531$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $055833d66b0d6531$var$React.useState(noSsr || !isMultiSchemes);
    $055833d66b0d6531$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $055833d66b0d6531$var$getColorScheme(state);
    const setMode = $055833d66b0d6531$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $055833d66b0d6531$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $055833d66b0d6531$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $055833d66b0d6531$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $055833d66b0d6531$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $055833d66b0d6531$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $055833d66b0d6531$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("emFGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $a75374c871ddabd4$var$noop() {}
const $a75374c871ddabd4$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a75374c871ddabd4$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a75374c871ddabd4$var$_default = module.exports.default = $a75374c871ddabd4$var$localStorageManager;

});



parcelRegister("hKuOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cebea242efdc3891$var$createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $cebea242efdc3891$var$createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("ejFX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $a6c361fa93759ec5$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a6c361fa93759ec5$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $a6c361fa93759ec5$var$assignNestedKeys;
const $a6c361fa93759ec5$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $a6c361fa93759ec5$var$walkObjectDeep;
const $a6c361fa93759ec5$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $a6c361fa93759ec5$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a6c361fa93759ec5$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $a6c361fa93759ec5$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $a6c361fa93759ec5$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $a6c361fa93759ec5$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});

parcelRegister("5magr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e66f819b409e224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e66f819b409e224$var$_deepmerge = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3e66f819b409e224$var$_cssVarsParser = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("ejFX8")));
function $3e66f819b409e224$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3e66f819b409e224$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $3e66f819b409e224$var$_default = module.exports.default = $3e66f819b409e224$var$prepareCssVars;

});

parcelRegister("73CWR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5237068774af7ee7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5237068774af7ee7$var$_prepareCssVars = $5237068774af7ee7$require$_interopRequireDefault((parcelRequire("5magr")));

var $9wccP = parcelRequire("9wccP");

var $79OI6 = parcelRequire("79OI6");
function $5237068774af7ee7$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$79OI6.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $5237068774af7ee7$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $9wccP.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $5237068774af7ee7$var$_default = module.exports.default = $5237068774af7ee7$var$createCssVarsTheme;

});
parcelRegister("9wccP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $6ee0921037829b98$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $6ee0921037829b98$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("1RRq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = module.exports.prerelease = module.exports.patch = module.exports.minor = module.exports.major = module.exports.default = void 0;
const $15c42dbad1fc53b5$var$version = module.exports.version = "7.3.9";
const $15c42dbad1fc53b5$var$major = module.exports.major = Number("7");
const $15c42dbad1fc53b5$var$minor = module.exports.minor = Number("3");
const $15c42dbad1fc53b5$var$patch = module.exports.patch = Number("9");
const $15c42dbad1fc53b5$var$prerelease = module.exports.prerelease = undefined;
var $15c42dbad1fc53b5$var$_default = module.exports.default = $15c42dbad1fc53b5$var$version;

});

parcelRegister("689Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $476b209a249f8c65$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $476b209a249f8c65$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $476b209a249f8c65$var$createContainer;

var $476b209a249f8c65$var$React = $476b209a249f8c65$require$_interopRequireWildcard((parcelRequire("acw62")));

var $476b209a249f8c65$var$_propTypes = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $476b209a249f8c65$var$_clsx = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("9QePP")));

var $476b209a249f8c65$var$_generateUtilityClass = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $476b209a249f8c65$var$_composeClasses = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $476b209a249f8c65$var$_capitalize = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("4O6za")));

var $476b209a249f8c65$var$_useThemeProps = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $476b209a249f8c65$var$_styled = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("kpukb")));

var $476b209a249f8c65$var$_createTheme = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ayMG0 = parcelRequire("ayMG0");
const $476b209a249f8c65$var$defaultTheme = (0, $476b209a249f8c65$var$_createTheme.default)();
const $476b209a249f8c65$var$defaultCreateStyledComponent = (0, $476b209a249f8c65$var$_styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $476b209a249f8c65$var$useThemePropsDefault = (inProps)=>(0, $476b209a249f8c65$var$_useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $476b209a249f8c65$var$defaultTheme
    });
const $476b209a249f8c65$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $476b209a249f8c65$var$_generateUtilityClass.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $476b209a249f8c65$var$_composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function $476b209a249f8c65$var$createContainer(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $476b209a249f8c65$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $476b209a249f8c65$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $476b209a249f8c65$var$React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $476b209a249f8c65$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $476b209a249f8c65$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});
parcelRegister("3Hg1x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b11d13e9f9cf7db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b11d13e9f9cf7db$var$_composeClasses.default;
    }
});

var $2b11d13e9f9cf7db$var$_composeClasses = $2b11d13e9f9cf7db$require$_interopRequireDefault((parcelRequire("5m3Us")));

});
parcelRegister("5m3Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e620a2ee867e5d5$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $3e620a2ee867e5d5$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});



parcelRegister("jYQTJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e8bca752eef9579e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e8bca752eef9579e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e8bca752eef9579e$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_Container.default;
    }
});

var $e8bca752eef9579e$var$_Container = $e8bca752eef9579e$require$_interopRequireDefault((parcelRequire("gRSQN")));

var $e8bca752eef9579e$var$_containerClasses = $e8bca752eef9579e$require$_interopRequireWildcard((parcelRequire("brfSx")));
Object.keys($e8bca752eef9579e$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e8bca752eef9579e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e8bca752eef9579e$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e8bca752eef9579e$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("gRSQN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c47c24bbe2a0d6f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c47c24bbe2a0d6f8$var$_propTypes = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c47c24bbe2a0d6f8$var$_createContainer = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("689Qv")));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const $c47c24bbe2a0d6f8$var$Container = (0, $c47c24bbe2a0d6f8$var$_createContainer.default)();
var $c47c24bbe2a0d6f8$var$_default = module.exports.default = $c47c24bbe2a0d6f8$var$Container;

});

parcelRegister("brfSx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $853e8880b5f4e64d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $853e8880b5f4e64d$var$getContainerUtilityClass;

var $853e8880b5f4e64d$var$_generateUtilityClasses = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $853e8880b5f4e64d$var$_generateUtilityClass = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $853e8880b5f4e64d$var$getContainerUtilityClass(slot) {
    return (0, $853e8880b5f4e64d$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $853e8880b5f4e64d$var$containerClasses = (0, $853e8880b5f4e64d$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $853e8880b5f4e64d$var$_default = module.exports.default = $853e8880b5f4e64d$var$containerClasses;

});


parcelRegister("dy2yf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9dd06e03e834ae16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd06e03e834ae16$var$_propTypes = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9dd06e03e834ae16$var$_createGrid = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("h0TiG")));
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const $9dd06e03e834ae16$var$Grid = (0, $9dd06e03e834ae16$var$_createGrid.default)();
var $9dd06e03e834ae16$var$_default = module.exports.default = $9dd06e03e834ae16$var$Grid;

});
parcelRegister("h0TiG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c62d554115d846cf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c62d554115d846cf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c62d554115d846cf$var$createGrid;

var $c62d554115d846cf$var$React = $c62d554115d846cf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c62d554115d846cf$var$_propTypes = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c62d554115d846cf$var$_clsx = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c62d554115d846cf$var$_isMuiElement = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("5yr9V")));

var $c62d554115d846cf$var$_generateUtilityClass = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $c62d554115d846cf$var$_composeClasses = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $c62d554115d846cf$var$_styled = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("kpukb")));

var $c62d554115d846cf$var$_useThemeProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $c62d554115d846cf$var$_useTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("lywMB")));

var $l6FST = parcelRequire("l6FST");

var $c62d554115d846cf$var$_createTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ggHhD = parcelRequire("ggHhD");

var $c62d554115d846cf$var$_deleteLegacyGridProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("g9pbx")));

var $ayMG0 = parcelRequire("ayMG0");
const $c62d554115d846cf$var$defaultTheme = (0, $c62d554115d846cf$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $c62d554115d846cf$var$defaultCreateStyledComponent = (0, $c62d554115d846cf$var$_styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $c62d554115d846cf$var$useThemePropsDefault(props) {
    return (0, $c62d554115d846cf$var$_useThemeProps.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $c62d554115d846cf$var$defaultTheme
    });
}
function $c62d554115d846cf$var$createGrid(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c62d554115d846cf$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c62d554115d846cf$var$useThemePropsDefault, useTheme: useTheme = $c62d554115d846cf$var$_useTheme.default, componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $ggHhD.generateDirectionClasses)(direction),
                ...(0, $ggHhD.generateSizeClassNames)(size),
                ...container ? (0, $ggHhD.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $c62d554115d846cf$var$_composeClasses.default)(slots, (slot)=>(0, $c62d554115d846cf$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent($ggHhD.generateGridColumnsStyles, $ggHhD.generateGridColumnSpacingStyles, $ggHhD.generateGridRowSpacingStyles, $ggHhD.generateGridSizeStyles, $ggHhD.generateGridDirectionStyles, $ggHhD.generateGridStyles, $ggHhD.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ $c62d554115d846cf$var$React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $l6FST.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $c62d554115d846cf$var$_deleteLegacyGridProps.default)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $c62d554115d846cf$var$_clsx.default)(classes.root, className),
            ...other,
            children: $c62d554115d846cf$var$React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $c62d554115d846cf$var$React.isValidElement(child) && (0, $c62d554115d846cf$var$_isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $c62d554115d846cf$var$React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("5yr9V", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40b531ef992288aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $40b531ef992288aa$var$_isMuiElement.default;
    }
});

var $40b531ef992288aa$var$_isMuiElement = $40b531ef992288aa$require$_interopRequireDefault((parcelRequire("cr6gy")));

});
parcelRegister("cr6gy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $90dcddf03243cc11$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90dcddf03243cc11$var$isMuiElement;

var $90dcddf03243cc11$var$React = $90dcddf03243cc11$require$_interopRequireWildcard((parcelRequire("acw62")));
function $90dcddf03243cc11$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $90dcddf03243cc11$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("ggHhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSpacingClassNames = module.exports.generateSizeClassNames = module.exports.generateGridStyles = module.exports.generateGridSizeStyles = module.exports.generateGridRowSpacingStyles = module.exports.generateGridOffsetStyles = module.exports.generateGridDirectionStyles = module.exports.generateGridColumnsStyles = module.exports.generateGridColumnSpacingStyles = module.exports.generateDirectionClasses = void 0;

var $99OVR = parcelRequire("99OVR");
function $bd7fb721dfb6dcf0$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $bd7fb721dfb6dcf0$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $bd7fb721dfb6dcf0$var$selfColumnsVar = '--Grid-columns';
const $bd7fb721dfb6dcf0$var$parentColumnsVar = '--Grid-parent-columns';
const $bd7fb721dfb6dcf0$var$generateGridSizeStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - (var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - ${value}) * (var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridSizeStyles = $bd7fb721dfb6dcf0$var$generateGridSizeStyles;
const $bd7fb721dfb6dcf0$var$generateGridOffsetStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) + var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridOffsetStyles = $bd7fb721dfb6dcf0$var$generateGridOffsetStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnsStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$bd7fb721dfb6dcf0$var$selfColumnsVar]: 12
    };
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$selfColumnsVar]: columns,
            '> *': {
                [$bd7fb721dfb6dcf0$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnsStyles = $bd7fb721dfb6dcf0$var$generateGridColumnsStyles;
const $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridRowSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridDirectionStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
module.exports.generateGridDirectionStyles = $bd7fb721dfb6dcf0$var$generateGridDirectionStyles;
const $bd7fb721dfb6dcf0$var$generateGridStyles = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')}) var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')})`
        }
    };
};
module.exports.generateGridStyles = $bd7fb721dfb6dcf0$var$generateGridStyles;
const $bd7fb721dfb6dcf0$var$generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
module.exports.generateSizeClassNames = $bd7fb721dfb6dcf0$var$generateSizeClassNames;
const $bd7fb721dfb6dcf0$var$generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
module.exports.generateSpacingClassNames = $bd7fb721dfb6dcf0$var$generateSpacingClassNames;
const $bd7fb721dfb6dcf0$var$generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
module.exports.generateDirectionClasses = $bd7fb721dfb6dcf0$var$generateDirectionClasses;

});
parcelRegister("99OVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseBreakpoints = module.exports.filterBreakpointKeys = void 0;
const $6aac76618a3aa479$var$filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
module.exports.filterBreakpointKeys = $6aac76618a3aa479$var$filterBreakpointKeys;
const $6aac76618a3aa479$var$traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6aac76618a3aa479$var$filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
module.exports.traverseBreakpoints = $6aac76618a3aa479$var$traverseBreakpoints;

});


parcelRegister("g9pbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc2105d70693a6c1$var$deleteLegacyGridProps;
const $bc2105d70693a6c1$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $bc2105d70693a6c1$var$warnedAboutProps = [];
/**
 * Deletes the legacy Grid component props from the `props` object and warns once about them if found.
 *
 * @param {object} props The props object to remove the legacy Grid props from.
 * @param {Breakpoints} breakpoints The breakpoints object.
 */ function $bc2105d70693a6c1$var$deleteLegacyGridProps(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

});



parcelRegister("gxueG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c0a72ea334f236a5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c0a72ea334f236a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c0a72ea334f236a5$var$_exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty(module.exports, "createGrid", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_createGrid.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_gridClasses.default;
    }
});
Object.defineProperty(module.exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateDirectionClasses;
    }
});
Object.defineProperty(module.exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSizeClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSpacingClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return $99OVR.traverseBreakpoints;
    }
});

var $c0a72ea334f236a5$var$_Grid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $c0a72ea334f236a5$var$_createGrid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("h0TiG")));

var $9GB8a = parcelRequire("9GB8a");
Object.keys($9GB8a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9GB8a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9GB8a[key];
        }
    });
});

var $c0a72ea334f236a5$var$_gridClasses = $c0a72ea334f236a5$require$_interopRequireWildcard((parcelRequire("8HLwS")));
Object.keys($c0a72ea334f236a5$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c0a72ea334f236a5$var$_gridClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0a72ea334f236a5$var$_gridClasses[key];
        }
    });
});

var $99OVR = parcelRequire("99OVR");

var $ggHhD = parcelRequire("ggHhD");

});
parcelRegister("9GB8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8HLwS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65673535bf7c146f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $65673535bf7c146f$var$getGridUtilityClass;

var $65673535bf7c146f$var$_generateUtilityClasses = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $65673535bf7c146f$var$_generateUtilityClass = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $65673535bf7c146f$var$getGridUtilityClass(slot) {
    return (0, $65673535bf7c146f$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $65673535bf7c146f$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $65673535bf7c146f$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $65673535bf7c146f$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $65673535bf7c146f$var$GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $65673535bf7c146f$var$gridClasses = (0, $65673535bf7c146f$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...$65673535bf7c146f$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$65673535bf7c146f$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$65673535bf7c146f$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $65673535bf7c146f$var$_default = module.exports.default = $65673535bf7c146f$var$gridClasses;

});


parcelRegister("kgIUX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec1824feff65c009$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec1824feff65c009$var$_propTypes = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ec1824feff65c009$var$_createStack = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("4N1IS")));
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $ec1824feff65c009$var$Stack = (0, $ec1824feff65c009$var$_createStack.default)();
var $ec1824feff65c009$var$_default = module.exports.default = $ec1824feff65c009$var$Stack;

});
parcelRegister("4N1IS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $37cd131ec442ac03$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $37cd131ec442ac03$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37cd131ec442ac03$var$createStack;
module.exports.style = void 0;

var $37cd131ec442ac03$var$React = $37cd131ec442ac03$require$_interopRequireWildcard((parcelRequire("acw62")));

var $37cd131ec442ac03$var$_propTypes = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $37cd131ec442ac03$var$_clsx = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("9QePP")));

var $37cd131ec442ac03$var$_deepmerge = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $37cd131ec442ac03$var$_generateUtilityClass = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $37cd131ec442ac03$var$_composeClasses = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $37cd131ec442ac03$var$_styled = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("kpukb")));

var $37cd131ec442ac03$var$_useThemeProps = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $l6FST = parcelRequire("l6FST");

var $37cd131ec442ac03$var$_createTheme = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9mzYC = parcelRequire("9mzYC");

var $8ZgMs = parcelRequire("8ZgMs");

var $ayMG0 = parcelRequire("ayMG0");
const $37cd131ec442ac03$var$defaultTheme = (0, $37cd131ec442ac03$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $37cd131ec442ac03$var$defaultCreateStyledComponent = (0, $37cd131ec442ac03$var$_styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $37cd131ec442ac03$var$useThemePropsDefault(props) {
    return (0, $37cd131ec442ac03$var$_useThemeProps.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $37cd131ec442ac03$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $37cd131ec442ac03$var$joinChildren(children, separator) {
    const childrenArray = $37cd131ec442ac03$var$React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $37cd131ec442ac03$var$React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $37cd131ec442ac03$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $37cd131ec442ac03$var$style = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $8ZgMs.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$37cd131ec442ac03$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $8ZgMs.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $37cd131ec442ac03$var$_deepmerge.default)(styles, (0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $9mzYC.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
module.exports.style = $37cd131ec442ac03$var$style;
function $37cd131ec442ac03$var$createStack(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $37cd131ec442ac03$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $37cd131ec442ac03$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $37cd131ec442ac03$var$_composeClasses.default)(slots, (slot)=>(0, $37cd131ec442ac03$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($37cd131ec442ac03$var$style);
    const Stack = /*#__PURE__*/ $37cd131ec442ac03$var$React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $l6FST.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $37cd131ec442ac03$var$_clsx.default)(classes.root, className),
            ...other,
            children: divider ? $37cd131ec442ac03$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});


parcelRegister("106Hq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0baafce1ff534af1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0baafce1ff534af1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0baafce1ff534af1$var$_exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty(module.exports, "createStack", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_createStack.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_stackClasses.default;
    }
});

var $0baafce1ff534af1$var$_Stack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $0baafce1ff534af1$var$_createStack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("4N1IS")));

var $19rVF = parcelRequire("19rVF");
Object.keys($19rVF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $19rVF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19rVF[key];
        }
    });
});

var $0baafce1ff534af1$var$_stackClasses = $0baafce1ff534af1$require$_interopRequireWildcard((parcelRequire("eh1Yu")));
Object.keys($0baafce1ff534af1$var$_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0baafce1ff534af1$var$_stackClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0baafce1ff534af1$var$_stackClasses[key];
        }
    });
});

});
parcelRegister("19rVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eh1Yu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a6442f55ec27dd44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $a6442f55ec27dd44$var$getStackUtilityClass;

var $a6442f55ec27dd44$var$_generateUtilityClasses = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a6442f55ec27dd44$var$_generateUtilityClass = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a6442f55ec27dd44$var$getStackUtilityClass(slot) {
    return (0, $a6442f55ec27dd44$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $a6442f55ec27dd44$var$stackClasses = (0, $a6442f55ec27dd44$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $a6442f55ec27dd44$var$_default = module.exports.default = $a6442f55ec27dd44$var$stackClasses;

});



parcelRegister("aXEQ8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7faf1807a5669751$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "unstable_ClassNameGenerator", {
    enumerable: true,
    get: function() {
        return $7faf1807a5669751$var$_ClassNameGenerator.default;
    }
});

var $7faf1807a5669751$var$_ClassNameGenerator = $7faf1807a5669751$require$_interopRequireDefault((parcelRequire("aYaRV")));

});

parcelRegister("8xDHs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $019ad789c5f8c324$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $019ad789c5f8c324$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $019ad789c5f8c324$var$_exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $izOUK.StyledEngineProvider;
    }
});
Object.defineProperty(module.exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_identifier.default;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_adaptV4Theme.default;
    }
});
Object.defineProperty(module.exports, "alpha", {
    enumerable: true,
    get: function() {
        return $izOUK.alpha;
    }
});
Object.defineProperty(module.exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createColorScheme.default;
    }
});
Object.defineProperty(module.exports, "createStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createStyles.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $izOUK.css;
    }
});
Object.defineProperty(module.exports, "darken", {
    enumerable: true,
    get: function() {
        return $izOUK.darken;
    }
});
Object.defineProperty(module.exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return $izOUK.decomposeColor;
    }
});
Object.defineProperty(module.exports, "duration", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.duration;
    }
});
Object.defineProperty(module.exports, "easing", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.easing;
    }
});
Object.defineProperty(module.exports, "emphasize", {
    enumerable: true,
    get: function() {
        return $izOUK.emphasize;
    }
});
Object.defineProperty(module.exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_experimental_extendTheme.default;
    }
});
module.exports.experimental_sx = $019ad789c5f8c324$var$experimental_sx;
Object.defineProperty(module.exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createThemeWithVars.default;
    }
});
Object.defineProperty(module.exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return $izOUK.getContrastRatio;
    }
});
Object.defineProperty(module.exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return $izOUK.getLuminance;
    }
});
Object.defineProperty(module.exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_getOverlayAlpha.default;
    }
});
Object.defineProperty(module.exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return $izOUK.hexToRgb;
    }
});
Object.defineProperty(module.exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return $izOUK.hslToRgb;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $izOUK.keyframes;
    }
});
Object.defineProperty(module.exports, "lighten", {
    enumerable: true,
    get: function() {
        return $izOUK.lighten;
    }
});
Object.defineProperty(module.exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_makeStyles.default;
    }
});
Object.defineProperty(module.exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMixins.default;
    }
});
Object.defineProperty(module.exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTypography.default;
    }
});
Object.defineProperty(module.exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_excludeVariablesFromRoot.default;
    }
});
Object.defineProperty(module.exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return $izOUK.recomposeColor;
    }
});
Object.defineProperty(module.exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_responsiveFontSizes.default;
    }
});
Object.defineProperty(module.exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return $izOUK.rgbToHex;
    }
});
Object.defineProperty(module.exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $68N2H.unstable_createBreakpoints;
    }
});
Object.defineProperty(module.exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMuiStrictModeTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return $18jQK.getUnit;
    }
});
Object.defineProperty(module.exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return $18jQK.toUnitless;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "withStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withStyles.default;
    }
});
Object.defineProperty(module.exports, "withTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withTheme.default;
    }
});

var $019ad789c5f8c324$var$_formatMuiErrorMessage = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $019ad789c5f8c324$var$_identifier = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $019ad789c5f8c324$var$_adaptV4Theme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2baoW")));

var $izOUK = parcelRequire("izOUK");

var $68N2H = parcelRequire("68N2H");

var $019ad789c5f8c324$var$_createTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $019ad789c5f8c324$var$_createMuiStrictModeTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("5fr1m")));

var $019ad789c5f8c324$var$_createStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("22wy2")));

var $18jQK = parcelRequire("18jQK");

var $019ad789c5f8c324$var$_responsiveFontSizes = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eoBMT")));

var $019ad789c5f8c324$var$_createTransitions = $019ad789c5f8c324$require$_interopRequireWildcard((parcelRequire("bmoVh")));

var $019ad789c5f8c324$var$_createColorScheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2JzIB")));

var $019ad789c5f8c324$var$_useTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("14H9o")));

var $019ad789c5f8c324$var$_useThemeProps = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6g9fa")));

var $019ad789c5f8c324$var$_styled = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d8seH")));

var $019ad789c5f8c324$var$_ThemeProvider = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("gRp5N")));

var $019ad789c5f8c324$var$_makeStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kLL7M")));

var $019ad789c5f8c324$var$_withStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("7i0uy")));

var $019ad789c5f8c324$var$_withTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("lXubi")));

var $b0NgK = parcelRequire("b0NgK");
Object.keys($b0NgK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($019ad789c5f8c324$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b0NgK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b0NgK[key];
        }
    });
});

var $019ad789c5f8c324$var$_createThemeWithVars = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $019ad789c5f8c324$var$_experimental_extendTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("dj1n2")));

var $019ad789c5f8c324$var$_getOverlayAlpha = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("35vyj")));

var $019ad789c5f8c324$var$_shouldSkipGeneratingVar = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $019ad789c5f8c324$var$_createTypography = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $019ad789c5f8c324$var$_createMixins = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6plKN")));

var $019ad789c5f8c324$var$_excludeVariablesFromRoot = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kKEhy")));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function $019ad789c5f8c324$var$experimental_sx() {
    throw new Error((0, $019ad789c5f8c324$var$_formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme

});
parcelRegister("4jPsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3250d9bb994a2d02$var$_default = module.exports.default = '$$material';

});

parcelRegister("2baoW", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1964ad5a35c9e3e3$var$adaptV4Theme;

var $izOUK = parcelRequire("izOUK");
function $1964ad5a35c9e3e3$var$adaptV4Theme(inputTheme) {
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $izOUK.createSpacing)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $izOUK.createBreakpoints)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

});

parcelRegister("68N2H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $47898848065fef37$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $47898848065fef37$var$_createBreakpoints.default;
    }
});

var $47898848065fef37$var$_createBreakpoints = $47898848065fef37$require$_interopRequireDefault((parcelRequire("hVW0x")));

});

parcelRegister("ijOKP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d5615f18e5cd04fc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5615f18e5cd04fc$var$createTheme;

var $d5615f18e5cd04fc$var$_createPalette = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $d5615f18e5cd04fc$var$_createThemeWithVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $d5615f18e5cd04fc$var$_createThemeNoVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("8v3fy")));
// eslint-disable-next-line consistent-return
function $d5615f18e5cd04fc$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $d5615f18e5cd04fc$var$_createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $d5615f18e5cd04fc$var$createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $d5615f18e5cd04fc$var$_createThemeWithVars.default)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("4Gk6P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $368aaef25f6a2997$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contrastColor = $368aaef25f6a2997$var$contrastColor;
module.exports.dark = void 0;
module.exports.default = $368aaef25f6a2997$var$createPalette;
module.exports.light = void 0;

var $368aaef25f6a2997$var$_formatMuiErrorMessage = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $368aaef25f6a2997$var$_deepmerge = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $h61zw = parcelRequire("h61zw");

var $368aaef25f6a2997$var$_common = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dzxhF")));

var $368aaef25f6a2997$var$_grey = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("eU5ou")));

var $368aaef25f6a2997$var$_purple = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("kSXRh")));

var $368aaef25f6a2997$var$_red = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("ln9F4")));

var $368aaef25f6a2997$var$_orange = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dMYym")));

var $368aaef25f6a2997$var$_blue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bKnBV")));

var $368aaef25f6a2997$var$_lightBlue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("iDVue")));

var $368aaef25f6a2997$var$_green = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("e4nxq")));
function $368aaef25f6a2997$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: $368aaef25f6a2997$var$_common.default.white,
            default: $368aaef25f6a2997$var$_common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $368aaef25f6a2997$var$light = module.exports.light = $368aaef25f6a2997$var$getLight();
function $368aaef25f6a2997$var$getDark() {
    return {
        text: {
            primary: $368aaef25f6a2997$var$_common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: $368aaef25f6a2997$var$_common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $368aaef25f6a2997$var$dark = module.exports.dark = $368aaef25f6a2997$var$getDark();
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $h61zw.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $h61zw.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_blue.default[200],
        light: $368aaef25f6a2997$var$_blue.default[50],
        dark: $368aaef25f6a2997$var$_blue.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_blue.default[700],
        light: $368aaef25f6a2997$var$_blue.default[400],
        dark: $368aaef25f6a2997$var$_blue.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_purple.default[200],
        light: $368aaef25f6a2997$var$_purple.default[50],
        dark: $368aaef25f6a2997$var$_purple.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_purple.default[500],
        light: $368aaef25f6a2997$var$_purple.default[300],
        dark: $368aaef25f6a2997$var$_purple.default[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_red.default[500],
        light: $368aaef25f6a2997$var$_red.default[300],
        dark: $368aaef25f6a2997$var$_red.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_red.default[700],
        light: $368aaef25f6a2997$var$_red.default[400],
        dark: $368aaef25f6a2997$var$_red.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_lightBlue.default[400],
        light: $368aaef25f6a2997$var$_lightBlue.default[300],
        dark: $368aaef25f6a2997$var$_lightBlue.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_lightBlue.default[700],
        light: $368aaef25f6a2997$var$_lightBlue.default[500],
        dark: $368aaef25f6a2997$var$_lightBlue.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_green.default[400],
        light: $368aaef25f6a2997$var$_green.default[300],
        dark: $368aaef25f6a2997$var$_green.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_green.default[800],
        light: $368aaef25f6a2997$var$_green.default[500],
        dark: $368aaef25f6a2997$var$_green.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_orange.default[400],
        light: $368aaef25f6a2997$var$_orange.default[300],
        dark: $368aaef25f6a2997$var$_orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: $368aaef25f6a2997$var$_orange.default[500],
        dark: $368aaef25f6a2997$var$_orange.default[900]
    };
}
// Use the same name as the experimental CSS `contrast-color` function.
function $368aaef25f6a2997$var$contrastColor(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $368aaef25f6a2997$var$createPalette(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $368aaef25f6a2997$var$contrastColor(background);
        const contrastText = (0, $h61zw.getContrastRatio)(background, $368aaef25f6a2997$var$dark.text.primary) >= contrastThreshold ? $368aaef25f6a2997$var$dark.text.primary : $368aaef25f6a2997$var$light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $368aaef25f6a2997$var$_formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $368aaef25f6a2997$var$_formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $368aaef25f6a2997$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $368aaef25f6a2997$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $368aaef25f6a2997$var$getLight();
    else if (mode === 'dark') modeHydrated = $368aaef25f6a2997$var$getDark();
    const paletteOutput = (0, $368aaef25f6a2997$var$_deepmerge.default)({
        // A collection of common colors.
        common: {
            ...$368aaef25f6a2997$var$_common.default
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: $368aaef25f6a2997$var$_grey.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("dzxhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$var$_default = module.exports.default = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$var$_default = module.exports.default = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$var$_default = module.exports.default = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$var$_default = module.exports.default = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$var$_default = module.exports.default = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$var$_default = module.exports.default = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$var$_default = module.exports.default = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$var$_default = module.exports.default = $a3e3b29cd31a116f$var$green;

});


parcelRegister("eLI0w", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ac07976fc01fdfa9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ac07976fc01fdfa9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetCssVar = void 0;
module.exports.default = $ac07976fc01fdfa9$var$createThemeWithVars;

var $ac07976fc01fdfa9$var$_formatMuiErrorMessage = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $ac07976fc01fdfa9$var$_deepmerge = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $izOUK = parcelRequire("izOUK");

var $8ZgMs = parcelRequire("8ZgMs");

var $fckAO = parcelRequire("fckAO");

var $ac07976fc01fdfa9$var$_styleFunctionSx = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $h61zw = parcelRequire("h61zw");

var $ac07976fc01fdfa9$var$_createThemeNoVars = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("8v3fy")));

var $ac07976fc01fdfa9$var$_createColorScheme = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("2JzIB")));

var $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $ac07976fc01fdfa9$var$_createGetSelector = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("9yYvT")));

var $2ICMq = parcelRequire("2ICMq");

var $4Gk6P = parcelRequire("4Gk6P");
function $ac07976fc01fdfa9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ac07976fc01fdfa9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ac07976fc01fdfa9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $h61zw.hslToRgb)(color);
}
function $ac07976fc01fdfa9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ac07976fc01fdfa9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ac07976fc01fdfa9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ac07976fc01fdfa9$var$createGetCssVar = (cssVarPrefix = 'mui')=>(0, $izOUK.unstable_createGetCssVar)(cssVarPrefix);
module.exports.createGetCssVar = $ac07976fc01fdfa9$var$createGetCssVar;
function $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $ac07976fc01fdfa9$var$_createColorScheme.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ac07976fc01fdfa9$var$_createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $ac07976fc01fdfa9$var$_createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $ac07976fc01fdfa9$var$_createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function $ac07976fc01fdfa9$var$createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ac07976fc01fdfa9$var$createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $ac07976fc01fdfa9$var$_formatMuiErrorMessage.default)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $fckAO.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ac07976fc01fdfa9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#fff');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#000');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === $h61zw.private_safeAlpha) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === $h61zw.private_safeDarken) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === $h61zw.private_safeLighten) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $ac07976fc01fdfa9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.8);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>colorSpace ? $4Gk6P.dark.text.primary : palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', colorMix($h61zw.private_safeLighten, (0, $h61zw.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.98);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>colorSpace ? $4Gk6P.light.text.primary : palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', colorMix($h61zw.private_safeDarken, (0, $h61zw.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'paper');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'background');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'onBackground');
        $ac07976fc01fdfa9$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ac07976fc01fdfa9$var$setColor(palette[color], 'mainChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.main)));
                if (colors.light) $ac07976fc01fdfa9$var$setColor(palette[color], 'lightChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.light)));
                if (colors.dark) $ac07976fc01fdfa9$var$setColor(palette[color], 'darkChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.dark)));
                if (colors.contrastText) $ac07976fc01fdfa9$var$setColor(palette[color], 'contrastTextChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'primary');
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $ac07976fc01fdfa9$var$_deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $ac07976fc01fdfa9$var$_createGetSelector.default)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $fckAO.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $izOUK.createSpacing)(input.spacing, (0, $8ZgMs.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $fckAO.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...$ac07976fc01fdfa9$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $ac07976fc01fdfa9$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fckAO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b107f34b17d36dd1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $9wccP.createGetColorSchemeSelector;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareTypographyVars.default;
    }
});

var $b107f34b17d36dd1$var$_createCssVarsProvider = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $b107f34b17d36dd1$var$_prepareCssVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("5magr")));

var $b107f34b17d36dd1$var$_prepareTypographyVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("ikjX2")));

var $b107f34b17d36dd1$var$_createCssVarsTheme = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("73CWR")));

var $9wccP = parcelRequire("9wccP");

});
parcelRegister("ikjX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d579922b6de2dbd6$var$prepareTypographyVars;
function $d579922b6de2dbd6$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});


parcelRegister("8v3fy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6303bd594dbbe1c5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6303bd594dbbe1c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6303bd594dbbe1c5$var$_formatMuiErrorMessage = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $6303bd594dbbe1c5$var$_deepmerge = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $6303bd594dbbe1c5$var$_styleFunctionSx = $6303bd594dbbe1c5$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $6303bd594dbbe1c5$var$_createTheme = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $h61zw = parcelRequire("h61zw");

var $6303bd594dbbe1c5$var$_generateUtilityClass = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $6303bd594dbbe1c5$var$_createMixins = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("6plKN")));

var $6303bd594dbbe1c5$var$_createPalette = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $6303bd594dbbe1c5$var$_createTypography = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $6303bd594dbbe1c5$var$_shadows = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("jtCFx")));

var $6303bd594dbbe1c5$var$_createTransitions = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bmoVh")));

var $6303bd594dbbe1c5$var$_zIndex = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("lhXgK")));

var $2ICMq = parcelRequire("2ICMq");
function $6303bd594dbbe1c5$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $6303bd594dbbe1c5$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $6303bd594dbbe1c5$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $h61zw.alpha)(color, $6303bd594dbbe1c5$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$6303bd594dbbe1c5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h61zw.lighten)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$6303bd594dbbe1c5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h61zw.darken)(color, coefficient);
        }
    });
}
function $6303bd594dbbe1c5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $6303bd594dbbe1c5$var$_formatMuiErrorMessage.default)(20));
    const palette = (0, $6303bd594dbbe1c5$var$_createPalette.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $6303bd594dbbe1c5$var$_createTheme.default)(options);
    let muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(systemTheme, {
        mixins: (0, $6303bd594dbbe1c5$var$_createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: $6303bd594dbbe1c5$var$_shadows.default.slice(),
        typography: (0, $6303bd594dbbe1c5$var$_createTypography.default)(palette, typographyInput),
        transitions: (0, $6303bd594dbbe1c5$var$_createTransitions.default)(transitionsInput),
        zIndex: {
            ...$6303bd594dbbe1c5$var$_zIndex.default
        }
    });
    muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $6303bd594dbbe1c5$var$_deepmerge.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...$6303bd594dbbe1c5$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6303bd594dbbe1c5$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    $6303bd594dbbe1c5$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $6303bd594dbbe1c5$var$_default = module.exports.default = $6303bd594dbbe1c5$var$createThemeNoVars;

});
parcelRegister("6plKN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4aa5f3b4975f3e4c$var$createMixins;
function $4aa5f3b4975f3e4c$var$createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("d6q8u", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $98a01bf22de9dc59$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98a01bf22de9dc59$var$createTypography;

var $98a01bf22de9dc59$var$_deepmerge = $98a01bf22de9dc59$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function $98a01bf22de9dc59$var$createTypography(palette, typography) {
    const { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
                letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $98a01bf22de9dc59$var$_deepmerge.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$var$_default = module.exports.default = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $845514f3678d3888$var$createTransitions;
module.exports.easing = module.exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $845514f3678d3888$var$easing = module.exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const $845514f3678d3888$var$duration = module.exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $845514f3678d3888$var$createTransitions(inputTransitions) {
    const mergedEasing = {
        ...$845514f3678d3888$var$easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$845514f3678d3888$var$duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("lhXgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$var$_default = module.exports.default = $f7f9291b6f07cefb$var$zIndex;

});

parcelRegister("2ICMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTheme = $1fadc5be6a14f8c8$var$stringifyTheme;

var $bQ4jM = parcelRequire("bQ4jM");
/* eslint-disable import/prefer-default-export */ function $1fadc5be6a14f8c8$var$isSerializable(val) {
    return (0, $bQ4jM.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function $1fadc5be6a14f8c8$var$stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$1fadc5be6a14f8c8$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $bQ4jM.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("2JzIB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fdb7dab8864519b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fdb7dab8864519b$var$createColorScheme;
module.exports.getOpacity = $1fdb7dab8864519b$var$getOpacity;
module.exports.getOverlays = $1fdb7dab8864519b$var$getOverlays;

var $1fdb7dab8864519b$var$_createPalette = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $1fdb7dab8864519b$var$_getOverlayAlpha = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("35vyj")));
const $1fdb7dab8864519b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $1fdb7dab8864519b$var$_getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $1fdb7dab8864519b$var$getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $1fdb7dab8864519b$var$getOverlays(mode) {
    return mode === 'dark' ? $1fdb7dab8864519b$var$defaultDarkOverlays : [];
}
function $1fdb7dab8864519b$var$createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $1fdb7dab8864519b$var$_createPalette.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$1fdb7dab8864519b$var$getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || $1fdb7dab8864519b$var$getOverlays(palette.mode),
        ...other
    };
}

});
parcelRegister("35vyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23fa506264c010ed$var$getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $23fa506264c010ed$var$getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("fPRn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b87504e8f71bd950$var$shouldSkipGeneratingVar;
function $b87504e8f71bd950$var$shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9yYvT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6f663abbabfb57a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f663abbabfb57a0$var$_excludeVariablesFromRoot = $6f663abbabfb57a0$require$_interopRequireDefault((parcelRequire("kKEhy")));
var $6f663abbabfb57a0$var$_default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $6f663abbabfb57a0$var$_excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
module.exports.default = $6f663abbabfb57a0$var$_default;

});
parcelRegister("kKEhy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$var$_default = module.exports.default = $f1b759b2363a287f$var$excludeVariablesFromRoot;

});




parcelRegister("5fr1m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d23504439aa8524$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d23504439aa8524$var$createMuiStrictModeTheme;

var $3d23504439aa8524$var$_deepmerge = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3d23504439aa8524$var$_createTheme = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("ijOKP")));
function $3d23504439aa8524$var$createMuiStrictModeTheme(options, ...args) {
    return (0, $3d23504439aa8524$var$_createTheme.default)((0, $3d23504439aa8524$var$_deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

});

parcelRegister("22wy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17c504046cb9a64c$var$createStyles;
let $17c504046cb9a64c$var$warnedOnce = false;
// To remove in v6
function $17c504046cb9a64c$var$createStyles(styles) {
    if (!$17c504046cb9a64c$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $17c504046cb9a64c$var$warnedOnce = true;
    }
    return styles;
}

});

parcelRegister("18jQK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignProperty = $0d35ef8a52a98e99$var$alignProperty;
module.exports.convertLength = $0d35ef8a52a98e99$var$convertLength;
module.exports.fontGrid = $0d35ef8a52a98e99$var$fontGrid;
module.exports.getUnit = $0d35ef8a52a98e99$var$getUnit;
module.exports.isUnitless = $0d35ef8a52a98e99$var$isUnitless;
module.exports.responsiveProperty = $0d35ef8a52a98e99$var$responsiveProperty;
module.exports.toUnitless = $0d35ef8a52a98e99$var$toUnitless;
function $0d35ef8a52a98e99$var$isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function $0d35ef8a52a98e99$var$getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function $0d35ef8a52a98e99$var$toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function $0d35ef8a52a98e99$var$convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$var$getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$var$toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$var$alignProperty({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function $0d35ef8a52a98e99$var$fontGrid({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function $0d35ef8a52a98e99$var$responsiveProperty({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("eoBMT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a7b09e624fa460c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7b09e624fa460c3$var$responsiveFontSizes;

var $a7b09e624fa460c3$var$_formatMuiErrorMessage = $a7b09e624fa460c3$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $18jQK = parcelRequire("18jQK");
function $a7b09e624fa460c3$var$responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $18jQK.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $18jQK.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $a7b09e624fa460c3$var$_formatMuiErrorMessage.default)(6));
        if (!(0, $18jQK.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $18jQK.alignProperty)({
                size: value,
                grid: (0, $18jQK.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, $18jQK.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform: transform
            })
        };
    });
    return theme;
}

});

parcelRegister("14H9o", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0c87a2f38cd49c7a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0c87a2f38cd49c7a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c87a2f38cd49c7a$var$useTheme;

var $0c87a2f38cd49c7a$var$React = $0c87a2f38cd49c7a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $0c87a2f38cd49c7a$var$_defaultTheme = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0c87a2f38cd49c7a$var$_identifier = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $0c87a2f38cd49c7a$var$useTheme() {
    const theme = (0, $izOUK.useTheme)($0c87a2f38cd49c7a$var$_defaultTheme.default);
    return theme[$0c87a2f38cd49c7a$var$_identifier.default] || theme;
}

});
parcelRegister("jR9F1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e74a75f0176cf8e3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74a75f0176cf8e3$var$_createTheme = $e74a75f0176cf8e3$require$_interopRequireDefault((parcelRequire("ijOKP")));
const $e74a75f0176cf8e3$var$defaultTheme = (0, $e74a75f0176cf8e3$var$_createTheme.default)();
var $e74a75f0176cf8e3$var$_default = module.exports.default = $e74a75f0176cf8e3$var$defaultTheme;

});


parcelRegister("6g9fa", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $48eb684ebe9272b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb684ebe9272b4$var$useThemeProps;

var $48eb684ebe9272b4$var$_useThemeProps = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $48eb684ebe9272b4$var$_defaultTheme = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $48eb684ebe9272b4$var$_identifier = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $48eb684ebe9272b4$var$useThemeProps({ props: props, name: name }) {
    return (0, $48eb684ebe9272b4$var$_useThemeProps.default)({
        props: props,
        name: name,
        defaultTheme: $48eb684ebe9272b4$var$_defaultTheme.default,
        themeId: $48eb684ebe9272b4$var$_identifier.default
    });
}

});

parcelRegister("d8seH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0277c5e26ff0d56c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_rootShouldForwardProp.default;
    }
});
Object.defineProperty(module.exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_slotShouldForwardProp.default;
    }
});

var $0277c5e26ff0d56c$var$_createStyled = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("bbeCr")));

var $0277c5e26ff0d56c$var$_defaultTheme = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0277c5e26ff0d56c$var$_identifier = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $0277c5e26ff0d56c$var$_rootShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $0277c5e26ff0d56c$var$_slotShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $0277c5e26ff0d56c$var$styled = (0, $0277c5e26ff0d56c$var$_createStyled.default)({
    themeId: $0277c5e26ff0d56c$var$_identifier.default,
    defaultTheme: $0277c5e26ff0d56c$var$_defaultTheme.default,
    rootShouldForwardProp: $0277c5e26ff0d56c$var$_rootShouldForwardProp.default
});
var $0277c5e26ff0d56c$var$_default = module.exports.default = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("8Uq77", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $67c7cf568a060c3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67c7cf568a060c3d$var$_slotShouldForwardProp = $67c7cf568a060c3d$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $67c7cf568a060c3d$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$var$_default = module.exports.default = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$var$_default = module.exports.default = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("gRp5N", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c4650f6dac4940cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c4650f6dac4940cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4650f6dac4940cb$var$ThemeProvider;

var $c4650f6dac4940cb$var$React = $c4650f6dac4940cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c4650f6dac4940cb$var$_ThemeProviderNoVars = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("6osfi")));

var $b0NgK = parcelRequire("b0NgK");

var $c4650f6dac4940cb$var$_identifier = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $c4650f6dac4940cb$var$ThemeProvider({ theme: theme, ...props }) {
    const noVarsTheme = $c4650f6dac4940cb$var$React.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = $c4650f6dac4940cb$var$_identifier.default in theme ? theme[$c4650f6dac4940cb$var$_identifier.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)($c4650f6dac4940cb$var$_ThemeProviderNoVars.default, {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b0NgK.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

});
parcelRegister("6osfi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a7ae4f41d656e46$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a7ae4f41d656e46$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a7ae4f41d656e46$var$ThemeProviderNoVars;

var $4a7ae4f41d656e46$var$React = $4a7ae4f41d656e46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $4a7ae4f41d656e46$var$_identifier = $4a7ae4f41d656e46$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $4a7ae4f41d656e46$var$ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = $4a7ae4f41d656e46$var$_identifier.default in themeInput ? themeInput[$4a7ae4f41d656e46$var$_identifier.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($izOUK.ThemeProvider, {
        ...props,
        themeId: scopedTheme ? $4a7ae4f41d656e46$var$_identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

});

parcelRegister("b0NgK", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8045e99d413e4782$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CssVarsProvider = void 0;
module.exports.Experimental_CssVarsProvider = $8045e99d413e4782$var$Experimental_CssVarsProvider;
module.exports.useColorScheme = module.exports.getInitColorSchemeScript = void 0;

var $8045e99d413e4782$var$_styleFunctionSx = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("l6FST")));

var $izOUK = parcelRequire("izOUK");

var $8045e99d413e4782$var$_createTheme = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $8045e99d413e4782$var$_createTypography = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $8045e99d413e4782$var$_identifier = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $3K3i6 = parcelRequire("3K3i6");

var $ayMG0 = parcelRequire("ayMG0");
const { CssVarsProvider: $8045e99d413e4782$var$InternalCssVarsProvider, useColorScheme: $8045e99d413e4782$var$useColorScheme, getInitColorSchemeScript: $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript } = (0, $izOUK.unstable_createCssVarsProvider)({
    themeId: $8045e99d413e4782$var$_identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $8045e99d413e4782$var$_createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: $3K3i6.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: $3K3i6.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: $3K3i6.defaultConfig.defaultLightColorScheme,
        dark: $3K3i6.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $8045e99d413e4782$var$_createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $8045e99d413e4782$var$_styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
module.exports.useColorScheme = $8045e99d413e4782$var$useColorScheme;
let $8045e99d413e4782$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $8045e99d413e4782$var$Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8045e99d413e4782$var$InternalCssVarsProvider, {
        ...props
    });
}
let $8045e99d413e4782$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $8045e99d413e4782$var$getInitColorSchemeScript = (params)=>{
    if (!$8045e99d413e4782$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $8045e99d413e4782$var$warnedInitScriptOnce = true;
    }
    return $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ module.exports.getInitColorSchemeScript = $8045e99d413e4782$var$getInitColorSchemeScript;
const $8045e99d413e4782$var$CssVarsProvider = module.exports.CssVarsProvider = $8045e99d413e4782$var$InternalCssVarsProvider;

});
parcelRegister("3K3i6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b983880bbf899cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.default = void 0;

var $2b983880bbf899cb$var$_propTypes = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2b983880bbf899cb$var$_InitColorSchemeScript = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("5UPwK")));

var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$var$defaultConfig = module.exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $2b983880bbf899cb$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $2b983880bbf899cb$var$defaultConfig.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $2b983880bbf899cb$var$defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = $2b983880bbf899cb$var$defaultConfig.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2b983880bbf899cb$var$_InitColorSchemeScript.default, {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $2b983880bbf899cb$var$_default = module.exports.default = $2b983880bbf899cb$var$InitColorSchemeScript;

});
parcelRegister("5UPwK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44ea26ea463a672a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $44ea26ea463a672a$var$_InitColorSchemeScript.default;
    }
});

var $44ea26ea463a672a$var$_InitColorSchemeScript = $44ea26ea463a672a$require$_interopRequireDefault((parcelRequire("79OI6")));

});




parcelRegister("kLL7M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f1ecc062bbad3379$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1ecc062bbad3379$var$makeStyles;

var $f1ecc062bbad3379$var$_formatMuiErrorMessage = $f1ecc062bbad3379$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $f1ecc062bbad3379$var$makeStyles() {
    throw new Error((0, $f1ecc062bbad3379$var$_formatMuiErrorMessage.default)(14));
}

});

parcelRegister("7i0uy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $015e9f5cd865f1ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $015e9f5cd865f1ca$var$withStyles;

var $015e9f5cd865f1ca$var$_formatMuiErrorMessage = $015e9f5cd865f1ca$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $015e9f5cd865f1ca$var$withStyles() {
    throw new Error((0, $015e9f5cd865f1ca$var$_formatMuiErrorMessage.default)(15));
}

});

parcelRegister("lXubi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ffc685059eb0526f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffc685059eb0526f$var$withTheme;

var $ffc685059eb0526f$var$_formatMuiErrorMessage = $ffc685059eb0526f$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $ffc685059eb0526f$var$withTheme() {
    throw new Error((0, $ffc685059eb0526f$var$_formatMuiErrorMessage.default)(16));
}

});

parcelRegister("dj1n2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9afe1ce524e8f62d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9afe1ce524e8f62d$var$deprecatedExtendTheme;

var $9afe1ce524e8f62d$var$_createThemeWithVars = $9afe1ce524e8f62d$require$_interopRequireDefault((parcelRequire("eLI0w")));
let $9afe1ce524e8f62d$var$warnedOnce = false;
function $9afe1ce524e8f62d$var$deprecatedExtendTheme(...args) {
    if (!$9afe1ce524e8f62d$var$warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        $9afe1ce524e8f62d$var$warnedOnce = true;
    }
    return (0, $9afe1ce524e8f62d$var$_createThemeWithVars.default)(...args);
}

});


parcelRegister("hOwN9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cf808af3a1d339c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf808af3a1d339c9$var$_generateUtilityClasses = $cf808af3a1d339c9$require$_interopRequireDefault((parcelRequire("5nY49")));
const $cf808af3a1d339c9$var$boxClasses = (0, $cf808af3a1d339c9$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$var$_default = module.exports.default = $cf808af3a1d339c9$var$boxClasses;

});



parcelRegister("cPtMf", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $957158966c1dd989$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $957158966c1dd989$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $957158966c1dd989$var$_exportNames = {
    drawerClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $957158966c1dd989$var$_Drawer.default;
    }
});
Object.defineProperty(module.exports, "drawerClasses", {
    enumerable: true,
    get: function() {
        return $957158966c1dd989$var$_drawerClasses.default;
    }
});

var $957158966c1dd989$var$_Drawer = $957158966c1dd989$require$_interopRequireDefault((parcelRequire("2Ed4H")));

var $957158966c1dd989$var$_drawerClasses = $957158966c1dd989$require$_interopRequireWildcard((parcelRequire("4G59M")));
Object.keys($957158966c1dd989$var$_drawerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($957158966c1dd989$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $957158966c1dd989$var$_drawerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $957158966c1dd989$var$_drawerClasses[key];
        }
    });
});

});
parcelRegister("2Ed4H", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1ed9758f3bc045cc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1ed9758f3bc045cc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAnchor = $1ed9758f3bc045cc$var$getAnchor;
module.exports.isHorizontal = $1ed9758f3bc045cc$var$isHorizontal;

var $1ed9758f3bc045cc$var$React = $1ed9758f3bc045cc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1ed9758f3bc045cc$var$_propTypes = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1ed9758f3bc045cc$var$_clsx = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1ed9758f3bc045cc$var$_integerPropType = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $1ed9758f3bc045cc$var$_composeClasses = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $1ed9758f3bc045cc$var$_Modal = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("8vVVd")));

var $1ed9758f3bc045cc$var$_Slide = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("bQRpD")));

var $1ed9758f3bc045cc$var$_Paper = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $1ed9758f3bc045cc$var$_capitalize = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $1ed9758f3bc045cc$var$_rootShouldForwardProp = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $1ed9758f3bc045cc$var$_memoTheme = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $4G59M = parcelRequire("4G59M");

var $1ed9758f3bc045cc$var$_useSlot = $1ed9758f3bc045cc$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $1ed9758f3bc045cc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        ownerState.variant === 'temporary' && styles.modal
    ];
};
const $1ed9758f3bc045cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $1ed9758f3bc045cc$var$_capitalize.default)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $1ed9758f3bc045cc$var$_capitalize.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $1ed9758f3bc045cc$var$_capitalize.default)(anchor)}`
        ]
    };
    return (0, $1ed9758f3bc045cc$var$_composeClasses.default)(slots, $4G59M.getDrawerUtilityClass, classes);
};
const $1ed9758f3bc045cc$var$DrawerRoot = (0, $aAbgT.styled)($1ed9758f3bc045cc$var$_Modal.default, {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})((0, $1ed9758f3bc045cc$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $1ed9758f3bc045cc$var$DrawerDockedRoot = (0, $aAbgT.styled)('div', {
    shouldForwardProp: $1ed9758f3bc045cc$var$_rootShouldForwardProp.default,
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $1ed9758f3bc045cc$var$DrawerPaper = (0, $aAbgT.styled)($1ed9758f3bc045cc$var$_Paper.default, {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $1ed9758f3bc045cc$var$_capitalize.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $1ed9758f3bc045cc$var$_capitalize.default)(ownerState.anchor)}`]
        ];
    }
})((0, $1ed9758f3bc045cc$var$_memoTheme.default)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $1ed9758f3bc045cc$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $1ed9758f3bc045cc$var$isHorizontal(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $1ed9758f3bc045cc$var$getAnchor({ direction: direction }, anchor) {
    return direction === 'rtl' && $1ed9758f3bc045cc$var$isHorizontal(anchor) ? $1ed9758f3bc045cc$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $1ed9758f3bc045cc$var$Drawer = /*#__PURE__*/ $1ed9758f3bc045cc$var$React.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $aAbgT.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $1ed9758f3bc045cc$var$React.useRef(false);
    $1ed9758f3bc045cc$var$React.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $1ed9758f3bc045cc$var$getAnchor({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $1ed9758f3bc045cc$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $hGPki.mergeSlotProps)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $1ed9758f3bc045cc$var$DrawerRoot,
        className: (0, $1ed9758f3bc045cc$var$_clsx.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('paper', {
        elementType: $1ed9758f3bc045cc$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $1ed9758f3bc045cc$var$_clsx.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true,
            ...variant === 'temporary' && {
                role: 'dialog',
                'aria-modal': 'true'
            }
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('docked', {
        elementType: $1ed9758f3bc045cc$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $1ed9758f3bc045cc$var$_clsx.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $1ed9758f3bc045cc$var$_useSlot.default)('transition', {
        elementType: $1ed9758f3bc045cc$var$_Slide.default,
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $1ed9758f3bc045cc$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var $1ed9758f3bc045cc$var$_default = module.exports.default = $1ed9758f3bc045cc$var$Drawer;

});
parcelRegister("cxaSP", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $92010252191041d3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $92010252191041d3$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $92010252191041d3$var$_integerPropType.default;
    }
});

var $92010252191041d3$var$_integerPropType = $92010252191041d3$require$_interopRequireWildcard((parcelRequire("gsOpJ")));
Object.keys($92010252191041d3$var$_integerPropType).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($92010252191041d3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $92010252191041d3$var$_integerPropType[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $92010252191041d3$var$_integerPropType[key];
        }
    });
});

});
parcelRegister("gsOpJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTypeByValue = $bfc65e0b974ee482$var$getTypeByValue;
function $bfc65e0b974ee482$var$getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
function $bfc65e0b974ee482$var$requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !Number.isInteger(propValue)) {
        const propType = $bfc65e0b974ee482$var$getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function $bfc65e0b974ee482$var$validator(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return $bfc65e0b974ee482$var$requiredInteger(props, propName, componentName, location);
}
function $bfc65e0b974ee482$var$validatorNoop() {
    return null;
}
$bfc65e0b974ee482$var$validator.isRequired = $bfc65e0b974ee482$var$requiredInteger;
$bfc65e0b974ee482$var$validatorNoop.isRequired = $bfc65e0b974ee482$var$validatorNoop;
const $bfc65e0b974ee482$var$integerPropType = $bfc65e0b974ee482$var$validatorNoop;
var $bfc65e0b974ee482$var$_default = module.exports.default = $bfc65e0b974ee482$var$integerPropType;

});


parcelRegister("8vVVd", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $632e260cb6e75f90$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $632e260cb6e75f90$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $632e260cb6e75f90$var$_exportNames = {
    ModalManager: true,
    modalClasses: true
};
Object.defineProperty(module.exports, "ModalManager", {
    enumerable: true,
    get: function() {
        return $75CP6.ModalManager;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $632e260cb6e75f90$var$_Modal.default;
    }
});
Object.defineProperty(module.exports, "modalClasses", {
    enumerable: true,
    get: function() {
        return $632e260cb6e75f90$var$_modalClasses.default;
    }
});

var $75CP6 = parcelRequire("75CP6");

var $632e260cb6e75f90$var$_Modal = $632e260cb6e75f90$require$_interopRequireDefault((parcelRequire("118QM")));

var $632e260cb6e75f90$var$_modalClasses = $632e260cb6e75f90$require$_interopRequireWildcard((parcelRequire("16KGQ")));
Object.keys($632e260cb6e75f90$var$_modalClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($632e260cb6e75f90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $632e260cb6e75f90$var$_modalClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $632e260cb6e75f90$var$_modalClasses[key];
        }
    });
});

});
parcelRegister("75CP6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $52971d86e2bcd483$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModalManager = void 0;
module.exports.ariaHidden = $52971d86e2bcd483$var$ariaHidden;

var $52971d86e2bcd483$var$_ownerWindow = $52971d86e2bcd483$require$_interopRequireDefault((parcelRequire("4Rhws")));

var $52971d86e2bcd483$var$_ownerDocument = $52971d86e2bcd483$require$_interopRequireDefault((parcelRequire("43fuO")));

var $52971d86e2bcd483$var$_getScrollbarSize = $52971d86e2bcd483$require$_interopRequireDefault((parcelRequire("71aFq")));
// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $52971d86e2bcd483$var$_ownerDocument.default)(container);
    if (doc.body === container) return (0, $52971d86e2bcd483$var$_ownerWindow.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$var$ariaHidden(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseFloat((0, $52971d86e2bcd483$var$_ownerWindow.default)(element).getComputedStyle(element).paddingRight) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$var$ariaHidden(element, hide);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $52971d86e2bcd483$var$_getScrollbarSize.default)((0, $52971d86e2bcd483$var$_ownerWindow.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $52971d86e2bcd483$var$_ownerDocument.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $52971d86e2bcd483$var$_ownerDocument.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $52971d86e2bcd483$var$_ownerWindow.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ class $52971d86e2bcd483$var$ModalManager {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$var$ariaHidden(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$var$ariaHidden(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$var$ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}
module.exports.ModalManager = $52971d86e2bcd483$var$ModalManager;

});
parcelRegister("4Rhws", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3899b44489cdde78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3899b44489cdde78$var$_ownerWindow.default;
    }
});

var $3899b44489cdde78$var$_ownerWindow = $3899b44489cdde78$require$_interopRequireDefault((parcelRequire("l4FpR")));

});
parcelRegister("l4FpR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f57a191378fb6173$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f57a191378fb6173$var$ownerWindow;

var $f57a191378fb6173$var$_ownerDocument = $f57a191378fb6173$require$_interopRequireDefault((parcelRequire("43fuO")));
function $f57a191378fb6173$var$ownerWindow(node) {
    const doc = (0, $f57a191378fb6173$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});
parcelRegister("43fuO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f33766ba7c82ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f33766ba7c82ed1$var$_ownerDocument.default;
    }
});

var $2f33766ba7c82ed1$var$_ownerDocument = $2f33766ba7c82ed1$require$_interopRequireDefault((parcelRequire("49EPw")));

});
parcelRegister("49EPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3067acab6211afec$var$ownerDocument;
function $3067acab6211afec$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});




parcelRegister("71aFq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c0e6a6ca0c4663$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $51c0e6a6ca0c4663$var$_getScrollbarSize.default;
    }
});

var $51c0e6a6ca0c4663$var$_getScrollbarSize = $51c0e6a6ca0c4663$require$_interopRequireDefault((parcelRequire("2Fa2r")));

});
parcelRegister("2Fa2r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f0732850f39cffc$var$getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $1f0732850f39cffc$var$getScrollbarSize(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});



parcelRegister("118QM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0bdcbfecdf3275a2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0bdcbfecdf3275a2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bdcbfecdf3275a2$var$React = $0bdcbfecdf3275a2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0bdcbfecdf3275a2$var$_propTypes = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0bdcbfecdf3275a2$var$_clsx = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0bdcbfecdf3275a2$var$_HTMLElementType = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $0bdcbfecdf3275a2$var$_elementAcceptingRef = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("igTUE")));

var $0bdcbfecdf3275a2$var$_composeClasses = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0bdcbfecdf3275a2$var$_Unstable_TrapFocus = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("c94Y8")));

var $0bdcbfecdf3275a2$var$_Portal = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("cJgE8")));

var $aAbgT = parcelRequire("aAbgT");

var $0bdcbfecdf3275a2$var$_memoTheme = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $0bdcbfecdf3275a2$var$_Backdrop = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("bXwVR")));

var $0bdcbfecdf3275a2$var$_useModal = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("lkowv")));

var $16KGQ = parcelRequire("16KGQ");

var $0bdcbfecdf3275a2$var$_useSlot = $0bdcbfecdf3275a2$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $0bdcbfecdf3275a2$var$_composeClasses.default)(slots, $16KGQ.getModalUtilityClass, classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $0bdcbfecdf3275a2$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $aAbgT.styled)($0bdcbfecdf3275a2$var$_Backdrop.default, {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $0bdcbfecdf3275a2$var$React.forwardRef(function Modal(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $0bdcbfecdf3275a2$var$_useModal.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $0bdcbfecdf3275a2$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $0bdcbfecdf3275a2$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $0bdcbfecdf3275a2$var$_clsx.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $0bdcbfecdf3275a2$var$_useSlot.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $0bdcbfecdf3275a2$var$_clsx.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0bdcbfecdf3275a2$var$_Portal.default, {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($0bdcbfecdf3275a2$var$_Unstable_TrapFocus.default, {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $0bdcbfecdf3275a2$var$React.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $0bdcbfecdf3275a2$var$_default = module.exports.default = $0bdcbfecdf3275a2$var$Modal;

});
parcelRegister("cIfK5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9415ce3192d3b08c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9415ce3192d3b08c$var$_HTMLElementType.default;
    }
});

var $9415ce3192d3b08c$var$_HTMLElementType = $9415ce3192d3b08c$require$_interopRequireDefault((parcelRequire("8F42D")));

});
parcelRegister("8F42D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64e549a55fe24dd8$var$HTMLElementType;
function $64e549a55fe24dd8$var$HTMLElementType(props, propName, componentName, location, propFullName) {
    return null;
}

});


parcelRegister("igTUE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d4d517b73cdaa5e7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d4d517b73cdaa5e7$var$_elementAcceptingRef.default;
    }
});

var $d4d517b73cdaa5e7$var$_elementAcceptingRef = $d4d517b73cdaa5e7$require$_interopRequireDefault((parcelRequire("9kjow")));

});
parcelRegister("9kjow", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6ca506ac7edb93a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ca506ac7edb93a5$var$_propTypes = $6ca506ac7edb93a5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6ca506ac7edb93a5$var$_chainPropTypes = $6ca506ac7edb93a5$require$_interopRequireDefault((parcelRequire("abVWF")));
function $6ca506ac7edb93a5$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $6ca506ac7edb93a5$var$acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !$6ca506ac7edb93a5$var$isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const $6ca506ac7edb93a5$var$elementAcceptingRef = (0, $6ca506ac7edb93a5$var$_chainPropTypes.default)($6ca506ac7edb93a5$var$_propTypes.default.element, $6ca506ac7edb93a5$var$acceptingRef);
$6ca506ac7edb93a5$var$elementAcceptingRef.isRequired = (0, $6ca506ac7edb93a5$var$_chainPropTypes.default)($6ca506ac7edb93a5$var$_propTypes.default.element.isRequired, $6ca506ac7edb93a5$var$acceptingRef);
var $6ca506ac7edb93a5$var$_default = module.exports.default = $6ca506ac7edb93a5$var$elementAcceptingRef;

});
parcelRegister("abVWF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $76b7e12fe7b0c8f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $76b7e12fe7b0c8f4$var$_chainPropTypes.default;
    }
});

var $76b7e12fe7b0c8f4$var$_chainPropTypes = $76b7e12fe7b0c8f4$require$_interopRequireDefault((parcelRequire("8jTls")));

});
parcelRegister("8jTls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60eb0778cff380af$var$chainPropTypes;
function $60eb0778cff380af$var$chainPropTypes(propType1, propType2) {
    return ()=>null;
}

});




parcelRegister("c94Y8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8d7a2e093d9aaa46$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8d7a2e093d9aaa46$var$_FocusTrap.default;
    }
});

var $8d7a2e093d9aaa46$var$_FocusTrap = $8d7a2e093d9aaa46$require$_interopRequireDefault((parcelRequire("kRwxQ")));

});
parcelRegister("kRwxQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f30200a1e85b3f20$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f30200a1e85b3f20$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f30200a1e85b3f20$var$React = $f30200a1e85b3f20$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f30200a1e85b3f20$var$_propTypes = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f30200a1e85b3f20$var$_useForkRef = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $f30200a1e85b3f20$var$_ownerDocument = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("43fuO")));

var $f30200a1e85b3f20$var$_getReactElementRef = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $f30200a1e85b3f20$var$_exactProp = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $f30200a1e85b3f20$var$_elementAcceptingRef = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("igTUE")));

var $f30200a1e85b3f20$var$_getActiveElement = $f30200a1e85b3f20$require$_interopRequireDefault((parcelRequire("6uU67")));

var $ayMG0 = parcelRequire("ayMG0");
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $f30200a1e85b3f20$var$React.useRef(false);
    const sentinelStart = $f30200a1e85b3f20$var$React.useRef(null);
    const sentinelEnd = $f30200a1e85b3f20$var$React.useRef(null);
    const nodeToRestore = $f30200a1e85b3f20$var$React.useRef(null);
    const reactFocusEventTarget = $f30200a1e85b3f20$var$React.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $f30200a1e85b3f20$var$React.useRef(false);
    const rootRef = $f30200a1e85b3f20$var$React.useRef(null);
    const handleRef = (0, $f30200a1e85b3f20$var$_useForkRef.default)((0, $f30200a1e85b3f20$var$_getReactElementRef.default)(children), rootRef);
    const lastKeydown = $f30200a1e85b3f20$var$React.useRef(null);
    $f30200a1e85b3f20$var$React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $f30200a1e85b3f20$var$React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f30200a1e85b3f20$var$_ownerDocument.default)(rootRef.current);
        const activeElement = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
        if (!rootRef.current.contains(activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $f30200a1e85b3f20$var$React.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f30200a1e85b3f20$var$_ownerDocument.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            const activeElement = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
            // Make sure the next tab starts from the right place.
            // activeElement refers to the origin.
            if (activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            const activeEl = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(activeEl)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (activeEl !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            const activeEl = (0, $f30200a1e85b3f20$var$_getActiveElement.default)(doc);
            if (activeEl && activeEl.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f30200a1e85b3f20$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $f30200a1e85b3f20$var$React.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$var$_default = module.exports.default = $f30200a1e85b3f20$var$FocusTrap;

});
parcelRegister("e4pKA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a3e569e96d60bae8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3e569e96d60bae8$var$_useForkRef.default;
    }
});

var $a3e569e96d60bae8$var$_useForkRef = $a3e569e96d60bae8$require$_interopRequireDefault((parcelRequire("kv0Da")));

});
parcelRegister("kv0Da", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eec73129f1331d63$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec73129f1331d63$var$useForkRef;

var $eec73129f1331d63$var$React = $eec73129f1331d63$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $eec73129f1331d63$var$useForkRef(...refs) {
    const cleanupRef = $eec73129f1331d63$var$React.useRef(undefined);
    const refEffect = $eec73129f1331d63$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $eec73129f1331d63$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("2B4J6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1e42b4067cc53dea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1e42b4067cc53dea$var$_getReactElementRef.default;
    }
});

var $1e42b4067cc53dea$var$_getReactElementRef = $1e42b4067cc53dea$require$_interopRequireDefault((parcelRequire("4UzRg")));

});
parcelRegister("4UzRg", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3938350e2a221962$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3938350e2a221962$var$getReactElementRef;

var $3938350e2a221962$var$React = $3938350e2a221962$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Returns the ref of a React element handling differences between React 19 and older versions.
 * It will throw runtime error if the element is not a valid React element.
 *
 * @param element React.ReactElement
 * @returns React.Ref<any> | null
 */ function $3938350e2a221962$var$getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($3938350e2a221962$var$React.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});


parcelRegister("6uU67", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4bb10f3e537aa943$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bb10f3e537aa943$var$_getActiveElement = $4bb10f3e537aa943$require$_interopRequireDefault((parcelRequire("auqlt")));
var $4bb10f3e537aa943$var$_default = module.exports.default = $4bb10f3e537aa943$var$_getActiveElement.default;

});
parcelRegister("auqlt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7a312461c420a305$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7a312461c420a305$var$_getActiveElement.default;
    }
});

var $7a312461c420a305$var$_getActiveElement = $7a312461c420a305$require$_interopRequireDefault((parcelRequire("ffAmm")));

});
parcelRegister("ffAmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1a47605ee2f1b8f$var$activeElement;
/**
 * Gets the actual active element, traversing through shadow roots if necessary.
 *
 * When an element inside a shadow root has focus, `document.activeElement` returns
 * the shadow host element. This function recursively traverses shadow roots to find
 * the actual focused element.
 *
 * @param root - The document or shadow root to start the search from.
 * @returns The actual focused element, or null if no element has focus.
 *
 * @example
 * // In a shadow DOM context
 * const activeElement = getActiveElement(document);
 * // Returns the actual focused element inside the shadow root
 *
 * @example
 * // Starting from a specific document
 * const activeElement = getActiveElement(ownerDocument(element));
 */ function $b1a47605ee2f1b8f$var$activeElement(doc) {
    let element = doc.activeElement;
    while(element?.shadowRoot?.activeElement != null)element = element.shadowRoot.activeElement;
    return element;
}

});





parcelRegister("cJgE8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $944699a2e7967149$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $944699a2e7967149$var$_Portal.default;
    }
});

var $944699a2e7967149$var$_Portal = $944699a2e7967149$require$_interopRequireDefault((parcelRequire("2Q995")));

});
parcelRegister("2Q995", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2117883cc21a32b2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2117883cc21a32b2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2117883cc21a32b2$var$React = $2117883cc21a32b2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2117883cc21a32b2$var$ReactDOM = $2117883cc21a32b2$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $2117883cc21a32b2$var$_propTypes = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2117883cc21a32b2$var$_useEnhancedEffect = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2117883cc21a32b2$var$_useForkRef = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $2117883cc21a32b2$var$_setRef = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("dGvj8")));

var $2117883cc21a32b2$var$_getReactElementRef = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $2117883cc21a32b2$var$_exactProp = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $2117883cc21a32b2$var$_HTMLElementType = $2117883cc21a32b2$require$_interopRequireDefault((parcelRequire("cIfK5")));
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $2117883cc21a32b2$var$React.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $2117883cc21a32b2$var$React.useState(null);
    const handleRef = (0, $2117883cc21a32b2$var$_useForkRef.default)(/*#__PURE__*/ $2117883cc21a32b2$var$React.isValidElement(children) ? (0, $2117883cc21a32b2$var$_getReactElementRef.default)(children) : null, forwardedRef);
    (0, $2117883cc21a32b2$var$_useEnhancedEffect.default)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $2117883cc21a32b2$var$_useEnhancedEffect.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $2117883cc21a32b2$var$_setRef.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $2117883cc21a32b2$var$_setRef.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $2117883cc21a32b2$var$React.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $2117883cc21a32b2$var$React.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $2117883cc21a32b2$var$ReactDOM.createPortal(children, mountNode) : mountNode;
});
var $2117883cc21a32b2$var$_default = module.exports.default = $2117883cc21a32b2$var$Portal;

});
parcelRegister("dGvj8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9f677ba749dc745d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9f677ba749dc745d$var$_setRef.default;
    }
});

var $9f677ba749dc745d$var$_setRef = $9f677ba749dc745d$require$_interopRequireDefault((parcelRequire("01n9P")));

});
parcelRegister("01n9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00420eb250698fce$var$setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $00420eb250698fce$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});




parcelRegister("aAbgT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7b460279bb5c09c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $izOUK.css;
    }
});
module.exports.globalCss = $7b460279bb5c09c1$var$globalCss;
module.exports.internal_createExtendSxProp = $7b460279bb5c09c1$var$internal_createExtendSxProp;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $izOUK.keyframes;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_useTheme.default;
    }
});

var $l6FST = parcelRequire("l6FST");

var $7b460279bb5c09c1$var$_useTheme = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("14H9o")));

var $7b460279bb5c09c1$var$_GlobalStyles = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("kjVW8")));

var $ayMG0 = parcelRequire("ayMG0");

var $izOUK = parcelRequire("izOUK");

var $7b460279bb5c09c1$var$_styled = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("d8seH")));
function $7b460279bb5c09c1$var$globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)($7b460279bb5c09c1$var$_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $7b460279bb5c09c1$var$internal_createExtendSxProp() {
    return $l6FST.extendSxProp;
}

});
parcelRegister("kjVW8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ecb286025e88fbf5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ecb286025e88fbf5$var$_GlobalStyles.default;
    }
});

var $ecb286025e88fbf5$var$_GlobalStyles = $ecb286025e88fbf5$require$_interopRequireDefault((parcelRequire("ldx2z")));

});
parcelRegister("ldx2z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $03fc756f7adfd498$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03fc756f7adfd498$var$_propTypes = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $03fc756f7adfd498$var$_defaultTheme = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $03fc756f7adfd498$var$_identifier = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($izOUK.GlobalStyles, {
        ...props,
        defaultTheme: $03fc756f7adfd498$var$_defaultTheme.default,
        themeId: $03fc756f7adfd498$var$_identifier.default
    });
}
var $03fc756f7adfd498$var$_default = module.exports.default = $03fc756f7adfd498$var$GlobalStyles;

});



parcelRegister("aeD7H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $izOUK = parcelRequire("izOUK");
const $77398f38c6229912$var$memoTheme = $izOUK.unstable_memoTheme;
var $77398f38c6229912$var$_default = module.exports.default = $77398f38c6229912$var$memoTheme;

});

parcelRegister("hL1nr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ced7e4e89ca5cfee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $ced7e4e89ca5cfee$var$_DefaultPropsProvider = $ced7e4e89ca5cfee$require$_interopRequireWildcard((parcelRequire("1iOpW")));

});
parcelRegister("1iOpW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0f2e94b8fca67639$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0f2e94b8fca67639$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $0f2e94b8fca67639$var$useDefaultProps;

var $0f2e94b8fca67639$var$React = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0f2e94b8fca67639$var$_propTypes = $0f2e94b8fca67639$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0f2e94b8fca67639$var$_DefaultPropsProvider = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("buuO7")));

var $ayMG0 = parcelRequire("ayMG0");
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0f2e94b8fca67639$var$_DefaultPropsProvider.default, {
        ...props
    });
}
var $0f2e94b8fca67639$var$_default = module.exports.default = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$var$useDefaultProps(params) {
    return (0, $0f2e94b8fca67639$var$_DefaultPropsProvider.useDefaultProps)(params);
}

});


parcelRegister("bXwVR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8b4ec012404cb259$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8b4ec012404cb259$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8b4ec012404cb259$var$_exportNames = {
    backdropClasses: true
};
Object.defineProperty(module.exports, "backdropClasses", {
    enumerable: true,
    get: function() {
        return $8b4ec012404cb259$var$_backdropClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8b4ec012404cb259$var$_Backdrop.default;
    }
});

var $8b4ec012404cb259$var$_Backdrop = $8b4ec012404cb259$require$_interopRequireDefault((parcelRequire("6cr7d")));

var $8b4ec012404cb259$var$_backdropClasses = $8b4ec012404cb259$require$_interopRequireWildcard((parcelRequire("7ViEK")));
Object.keys($8b4ec012404cb259$var$_backdropClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($8b4ec012404cb259$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8b4ec012404cb259$var$_backdropClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8b4ec012404cb259$var$_backdropClasses[key];
        }
    });
});

});
parcelRegister("6cr7d", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4838e5a14e330013$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4838e5a14e330013$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4838e5a14e330013$var$React = $4838e5a14e330013$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4838e5a14e330013$var$_propTypes = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4838e5a14e330013$var$_clsx = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4838e5a14e330013$var$_composeClasses = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4838e5a14e330013$var$_useSlot = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("6lpak")));

var $4838e5a14e330013$var$_Fade = $4838e5a14e330013$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $7ViEK = parcelRequire("7ViEK");

var $ayMG0 = parcelRequire("ayMG0");
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $4838e5a14e330013$var$_composeClasses.default)(slots, $7ViEK.getBackdropUtilityClass, classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $4838e5a14e330013$var$React.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $4838e5a14e330013$var$_useSlot.default)('root', {
        elementType: $4838e5a14e330013$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $4838e5a14e330013$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $4838e5a14e330013$var$_useSlot.default)('transition', {
        elementType: $4838e5a14e330013$var$_Fade.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            ref: ref,
            children: children
        })
    });
});
var $4838e5a14e330013$var$_default = module.exports.default = $4838e5a14e330013$var$Backdrop;

});
parcelRegister("6lpak", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $49e8399bd2388464$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49e8399bd2388464$var$useSlot;

var $49e8399bd2388464$var$_useForkRef = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $49e8399bd2388464$var$_appendOwnerState = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("fByHY")));

var $49e8399bd2388464$var$_resolveComponentProps = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("jzekU")));

var $49e8399bd2388464$var$_mergeSlotProps = $49e8399bd2388464$require$_interopRequireDefault((parcelRequire("dfy9C")));
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */ function $49e8399bd2388464$var$useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $49e8399bd2388464$var$_resolveComponentProps.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $49e8399bd2388464$var$_mergeSlotProps.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $49e8399bd2388464$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $49e8399bd2388464$var$_appendOwnerState.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("fByHY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b5c53c0db043a190$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b5c53c0db043a190$var$_appendOwnerState.default;
    }
});

var $b5c53c0db043a190$var$_appendOwnerState = $b5c53c0db043a190$require$_interopRequireDefault((parcelRequire("SxCI4")));

});
parcelRegister("SxCI4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0a3f2028457854eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a3f2028457854eb$var$_isHostComponent = $0a3f2028457854eb$require$_interopRequireDefault((parcelRequire("7jqh1")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $0a3f2028457854eb$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $0a3f2028457854eb$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $0a3f2028457854eb$var$_default = module.exports.default = $0a3f2028457854eb$var$appendOwnerState;

});
parcelRegister("7jqh1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $552eb02447a4b108$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $552eb02447a4b108$var$_isHostComponent.default;
    }
});

var $552eb02447a4b108$var$_isHostComponent = $552eb02447a4b108$require$_interopRequireDefault((parcelRequire("1cVk7")));

});
parcelRegister("1cVk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $0e1360ab77873eb8$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $0e1360ab77873eb8$var$_default = module.exports.default = $0e1360ab77873eb8$var$isHostComponent;

});




parcelRegister("jzekU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e3ec68142ab190e2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e3ec68142ab190e2$var$_resolveComponentProps.default;
    }
});

var $e3ec68142ab190e2$var$_resolveComponentProps = $e3ec68142ab190e2$require$_interopRequireDefault((parcelRequire("cgoZX")));

});
parcelRegister("cgoZX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $8eda5ecc2288dedf$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $8eda5ecc2288dedf$var$_default = module.exports.default = $8eda5ecc2288dedf$var$resolveComponentProps;

});


parcelRegister("dfy9C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a572b623f6aa29c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a572b623f6aa29c$var$_mergeSlotProps.default;
    }
});

var $9a572b623f6aa29c$var$_mergeSlotProps = $9a572b623f6aa29c$require$_interopRequireDefault((parcelRequire("3vQQW")));

});
parcelRegister("3vQQW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28ed43d991ccc074$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28ed43d991ccc074$var$_clsx = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("9QePP")));

var $28ed43d991ccc074$var$_extractEventHandlers = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $28ed43d991ccc074$var$_omitEventHandlers = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("dgDmX")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $28ed43d991ccc074$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $28ed43d991ccc074$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $28ed43d991ccc074$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $28ed43d991ccc074$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $28ed43d991ccc074$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $28ed43d991ccc074$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $28ed43d991ccc074$var$_default = module.exports.default = $28ed43d991ccc074$var$mergeSlotProps;

});
parcelRegister("bhYgh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $838006f6038ae26f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $838006f6038ae26f$var$_extractEventHandlers.default;
    }
});

var $838006f6038ae26f$var$_extractEventHandlers = $838006f6038ae26f$require$_interopRequireDefault((parcelRequire("foye3")));

});
parcelRegister("foye3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $b353a56c2b32b8fb$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $b353a56c2b32b8fb$var$_default = module.exports.default = $b353a56c2b32b8fb$var$extractEventHandlers;

});


parcelRegister("dgDmX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a8b4ee879070d7d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a8b4ee879070d7d$var$_omitEventHandlers.default;
    }
});

var $9a8b4ee879070d7d$var$_omitEventHandlers = $9a8b4ee879070d7d$require$_interopRequireDefault((parcelRequire("21PNK")));

});
parcelRegister("21PNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $17a3db7502283a72$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $17a3db7502283a72$var$_default = module.exports.default = $17a3db7502283a72$var$omitEventHandlers;

});





parcelRegister("5iZHj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3dce7e103df60065$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3dce7e103df60065$var$_Fade.default;
    }
});

var $3dce7e103df60065$var$_Fade = $3dce7e103df60065$require$_interopRequireDefault((parcelRequire("86f4a")));

});
parcelRegister("86f4a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5e5a92158e7d9bd4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5e5a92158e7d9bd4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e5a92158e7d9bd4$var$React = $5e5a92158e7d9bd4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5e5a92158e7d9bd4$var$_propTypes = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $5e5a92158e7d9bd4$var$_elementAcceptingRef = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("igTUE")));

var $5e5a92158e7d9bd4$var$_getReactElementRef = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $5e5a92158e7d9bd4$var$_useForkRef = $5e5a92158e7d9bd4$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ayMG0 = parcelRequire("ayMG0");
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $5e5a92158e7d9bd4$var$React.forwardRef(function Fade(props, ref) {
    const theme = (0, $aAbgT.useTheme)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $1mPeS.default, ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $5e5a92158e7d9bd4$var$React.useRef(null);
    const handleRef = (0, $5e5a92158e7d9bd4$var$_useForkRef.default)(nodeRef, (0, $5e5a92158e7d9bd4$var$_getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $5e5a92158e7d9bd4$var$React.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5e5a92158e7d9bd4$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $5e5a92158e7d9bd4$var$_default = module.exports.default = $5e5a92158e7d9bd4$var$Fade;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("hweuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransitionProps = $cc10aae84e3e4b9c$var$getTransitionProps;
module.exports.reflow = void 0;
const $cc10aae84e3e4b9c$var$reflow = (node)=>node.scrollTop;
module.exports.reflow = $cc10aae84e3e4b9c$var$reflow;
function $cc10aae84e3e4b9c$var$getTransitionProps(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});

parcelRegister("9Rgf1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $72d5a979b2ad8bc9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72d5a979b2ad8bc9$var$_useForkRef = $72d5a979b2ad8bc9$require$_interopRequireDefault((parcelRequire("e4pKA")));
var $72d5a979b2ad8bc9$var$_default = module.exports.default = $72d5a979b2ad8bc9$var$_useForkRef.default;

});



parcelRegister("7ViEK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5c4c540114ae85ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBackdropUtilityClass = $5c4c540114ae85ab$var$getBackdropUtilityClass;

var $5c4c540114ae85ab$var$_generateUtilityClasses = $5c4c540114ae85ab$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5c4c540114ae85ab$var$_generateUtilityClass = $5c4c540114ae85ab$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5c4c540114ae85ab$var$getBackdropUtilityClass(slot) {
    return (0, $5c4c540114ae85ab$var$_generateUtilityClass.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $5c4c540114ae85ab$var$_generateUtilityClasses.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$var$_default = module.exports.default = $5c4c540114ae85ab$var$backdropClasses;

});



parcelRegister("lkowv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f86e7d122c1fa324$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f86e7d122c1fa324$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f86e7d122c1fa324$var$React = $f86e7d122c1fa324$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f86e7d122c1fa324$var$_ownerDocument = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("43fuO")));

var $f86e7d122c1fa324$var$_useForkRef = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $f86e7d122c1fa324$var$_useEventCallback = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $f86e7d122c1fa324$var$_createChainedFunction = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("7QInQ")));

var $f86e7d122c1fa324$var$_extractEventHandlers = $f86e7d122c1fa324$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $75CP6 = parcelRequire("75CP6");
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $f86e7d122c1fa324$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$manager = new $75CP6.ModalManager();
function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $f86e7d122c1fa324$var$React.useRef({});
    const mountNodeRef = $f86e7d122c1fa324$var$React.useRef(null);
    const modalRef = $f86e7d122c1fa324$var$React.useRef(null);
    const handleRef = (0, $f86e7d122c1fa324$var$_useForkRef.default)(modalRef, rootRef);
    const [exited, setExited] = $f86e7d122c1fa324$var$React.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $f86e7d122c1fa324$var$_ownerDocument.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $f86e7d122c1fa324$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $f86e7d122c1fa324$var$_useEventCallback.default)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        $f86e7d122c1fa324$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$f86e7d122c1fa324$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $f86e7d122c1fa324$var$_useEventCallback.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $75CP6.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $f86e7d122c1fa324$var$React.useCallback(()=>{
        $f86e7d122c1fa324$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $f86e7d122c1fa324$var$React.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $f86e7d122c1fa324$var$React.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f86e7d122c1fa324$var$_extractEventHandlers.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $f86e7d122c1fa324$var$_createChainedFunction.default)(handleEnter, children?.props.onEnter ?? $f86e7d122c1fa324$var$noop),
            onExited: (0, $f86e7d122c1fa324$var$_createChainedFunction.default)(handleExited, children?.props.onExited ?? $f86e7d122c1fa324$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$var$_default = module.exports.default = $f86e7d122c1fa324$var$useModal;

});
parcelRegister("6Lbjo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ebfe8299138c5c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ebfe8299138c5c5$var$_useEventCallback.default;
    }
});

var $4ebfe8299138c5c5$var$_useEventCallback = $4ebfe8299138c5c5$require$_interopRequireDefault((parcelRequire("iDWdC")));

});
parcelRegister("iDWdC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d9290782162abf54$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9290782162abf54$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9290782162abf54$var$React = $d9290782162abf54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d9290782162abf54$var$_useEnhancedEffect = $d9290782162abf54$require$_interopRequireDefault((parcelRequire("jdWO4")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $d9290782162abf54$var$useEventCallback(fn) {
    const ref = $d9290782162abf54$var$React.useRef(fn);
    (0, $d9290782162abf54$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $d9290782162abf54$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $d9290782162abf54$var$_default = module.exports.default = $d9290782162abf54$var$useEventCallback;

});


parcelRegister("7QInQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5b6fd168e06dd390$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5b6fd168e06dd390$var$_createChainedFunction.default;
    }
});

var $5b6fd168e06dd390$var$_createChainedFunction = $5b6fd168e06dd390$require$_interopRequireDefault((parcelRequire("ZfLEz")));

});
parcelRegister("ZfLEz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b81edbcaacf3a52$var$createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $0b81edbcaacf3a52$var$createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});



parcelRegister("16KGQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0cea91a79e26c98a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getModalUtilityClass = $0cea91a79e26c98a$var$getModalUtilityClass;

var $0cea91a79e26c98a$var$_generateUtilityClasses = $0cea91a79e26c98a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $0cea91a79e26c98a$var$_generateUtilityClass = $0cea91a79e26c98a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $0cea91a79e26c98a$var$getModalUtilityClass(slot) {
    return (0, $0cea91a79e26c98a$var$_generateUtilityClass.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $0cea91a79e26c98a$var$_generateUtilityClasses.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$var$_default = module.exports.default = $0cea91a79e26c98a$var$modalClasses;

});



parcelRegister("bQRpD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8a0dfba99a405f81$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8a0dfba99a405f81$var$_Slide.default;
    }
});

var $8a0dfba99a405f81$var$_Slide = $8a0dfba99a405f81$require$_interopRequireDefault((parcelRequire("6FKde")));

});
parcelRegister("6FKde", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4dba6b402693f5d6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4dba6b402693f5d6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.setTranslateValue = $4dba6b402693f5d6$var$setTranslateValue;

var $4dba6b402693f5d6$var$React = $4dba6b402693f5d6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4dba6b402693f5d6$var$_propTypes = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $4dba6b402693f5d6$var$_chainPropTypes = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("abVWF")));

var $4dba6b402693f5d6$var$_HTMLElementType = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $4dba6b402693f5d6$var$_elementAcceptingRef = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("igTUE")));

var $4dba6b402693f5d6$var$_getReactElementRef = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $4dba6b402693f5d6$var$_isLayoutSupported = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("6toKj")));

var $4dba6b402693f5d6$var$_debounce = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $4dba6b402693f5d6$var$_useForkRef = $4dba6b402693f5d6$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $hGPki.ownerWindow)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$var$setTranslateValue(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $4dba6b402693f5d6$var$React.forwardRef(function Slide(props, ref) {
    const theme = (0, $aAbgT.useTheme)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $1mPeS.default, ...other } = props;
    const childrenRef = $4dba6b402693f5d6$var$React.useRef(null);
    const handleRef = (0, $4dba6b402693f5d6$var$_useForkRef.default)((0, $4dba6b402693f5d6$var$_getReactElementRef.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4dba6b402693f5d6$var$setTranslateValue(direction, node, containerProp);
        (0, $hweuE.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$var$setTranslateValue(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $4dba6b402693f5d6$var$React.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$var$setTranslateValue(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $4dba6b402693f5d6$var$React.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $4dba6b402693f5d6$var$_debounce.default)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$var$setTranslateValue(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $hGPki.ownerWindow)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $4dba6b402693f5d6$var$React.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $4dba6b402693f5d6$var$React.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $4dba6b402693f5d6$var$_default = module.exports.default = $4dba6b402693f5d6$var$Slide;

});
parcelRegister("6toKj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b68a591cb35890b$var$isLayoutSupported;
function $4b68a591cb35890b$var$isLayoutSupported() {
    return !(/jsdom|HappyDOM/.test(window.navigator.userAgent) || // TODO(v9): Remove the test environment check
    // eslint-disable-next-line mui/consistent-production-guard
    false);
}

});

parcelRegister("1iGrQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0f2866359d6621f3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f2866359d6621f3$var$_debounce = $0f2866359d6621f3$require$_interopRequireDefault((parcelRequire("9NXOO")));
var $0f2866359d6621f3$var$_default = module.exports.default = $0f2866359d6621f3$var$_debounce.default;

});
parcelRegister("9NXOO", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $723717646d90af53$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $723717646d90af53$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $723717646d90af53$var$_debounce.default;
    }
});

var $723717646d90af53$var$_debounce = $723717646d90af53$require$_interopRequireWildcard((parcelRequire("7VOF5")));
Object.keys($723717646d90af53$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($723717646d90af53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $723717646d90af53$var$_debounce[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $723717646d90af53$var$_debounce[key];
        }
    });
});

});
parcelRegister("7VOF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c6527a444bb8d00$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $5c6527a444bb8d00$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});



parcelRegister("hGPki", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ce0e2c401cd11493$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "capitalize", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_capitalize.default;
    }
});
Object.defineProperty(module.exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_createChainedFunction.default;
    }
});
Object.defineProperty(module.exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_createSvgIcon.default;
    }
});
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_debounce.default;
    }
});
Object.defineProperty(module.exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_deprecatedPropType.default;
    }
});
Object.defineProperty(module.exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_isMuiElement.default;
    }
});
Object.defineProperty(module.exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_mergeSlotProps.default;
    }
});
Object.defineProperty(module.exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_ownerDocument.default;
    }
});
Object.defineProperty(module.exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_ownerWindow.default;
    }
});
Object.defineProperty(module.exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_requirePropFactory.default;
    }
});
Object.defineProperty(module.exports, "setRef", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_setRef.default;
    }
});
module.exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useEnhancedEffect.default;
    }
});
Object.defineProperty(module.exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useId.default;
    }
});
Object.defineProperty(module.exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_unsupportedProp.default;
    }
});
Object.defineProperty(module.exports, "useControlled", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useControlled.default;
    }
});
Object.defineProperty(module.exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useEventCallback.default;
    }
});
Object.defineProperty(module.exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useForkRef.default;
    }
});

var $ce0e2c401cd11493$var$_ClassNameGenerator = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("aYaRV")));

var $ce0e2c401cd11493$var$_capitalize = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ce0e2c401cd11493$var$_createChainedFunction = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("5gbhl")));

var $ce0e2c401cd11493$var$_createSvgIcon = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ce0e2c401cd11493$var$_debounce = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $ce0e2c401cd11493$var$_deprecatedPropType = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gIZJw")));

var $ce0e2c401cd11493$var$_isMuiElement = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $ce0e2c401cd11493$var$_memoTheme = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ce0e2c401cd11493$var$_ownerDocument = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $ce0e2c401cd11493$var$_ownerWindow = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $ce0e2c401cd11493$var$_requirePropFactory = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $ce0e2c401cd11493$var$_setRef = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("e6E85")));

var $ce0e2c401cd11493$var$_useEnhancedEffect = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("khjmj")));

var $ce0e2c401cd11493$var$_useId = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $ce0e2c401cd11493$var$_unsupportedProp = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $ce0e2c401cd11493$var$_useControlled = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("3yddg")));

var $ce0e2c401cd11493$var$_useEventCallback = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $ce0e2c401cd11493$var$_useForkRef = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ce0e2c401cd11493$var$_mergeSlotProps = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("f8X1n")));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const $ce0e2c401cd11493$var$unstable_ClassNameGenerator = module.exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        $ce0e2c401cd11493$var$_ClassNameGenerator.default.configure(generator);
    }
};

});
parcelRegister("jTnBY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7b578196486f177$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7b578196486f177$var$_capitalize = $e7b578196486f177$require$_interopRequireDefault((parcelRequire("4O6za")));
var $e7b578196486f177$var$_default = module.exports.default = $e7b578196486f177$var$_capitalize.default;

});

parcelRegister("5gbhl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d47321b9fcbcb38$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d47321b9fcbcb38$var$_createChainedFunction = $3d47321b9fcbcb38$require$_interopRequireDefault((parcelRequire("7QInQ")));
var $3d47321b9fcbcb38$var$_default = module.exports.default = $3d47321b9fcbcb38$var$_createChainedFunction.default;

});

parcelRegister("bbT5Q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $825b752ac2a74c27$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $825b752ac2a74c27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $825b752ac2a74c27$var$createSvgIcon;

var $825b752ac2a74c27$var$React = $825b752ac2a74c27$require$_interopRequireWildcard((parcelRequire("acw62")));

var $825b752ac2a74c27$var$_SvgIcon = $825b752ac2a74c27$require$_interopRequireDefault((parcelRequire("loOwp")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Private module reserved for @mui packages.
 */ function $825b752ac2a74c27$var$createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($825b752ac2a74c27$var$_SvgIcon.default, {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = $825b752ac2a74c27$var$_SvgIcon.default.muiName;
    return /*#__PURE__*/ $825b752ac2a74c27$var$React.memo(/*#__PURE__*/ $825b752ac2a74c27$var$React.forwardRef(Component));
}

});
parcelRegister("loOwp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f943077249b43968$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f943077249b43968$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f943077249b43968$var$_exportNames = {
    svgIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f943077249b43968$var$_SvgIcon.default;
    }
});
Object.defineProperty(module.exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return $f943077249b43968$var$_svgIconClasses.default;
    }
});

var $f943077249b43968$var$_SvgIcon = $f943077249b43968$require$_interopRequireDefault((parcelRequire("3ErGR")));

var $f943077249b43968$var$_svgIconClasses = $f943077249b43968$require$_interopRequireWildcard((parcelRequire("aiIP4")));
Object.keys($f943077249b43968$var$_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f943077249b43968$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f943077249b43968$var$_svgIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f943077249b43968$var$_svgIconClasses[key];
        }
    });
});

});
parcelRegister("3ErGR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2a8a963e5702921b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2a8a963e5702921b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a8a963e5702921b$var$React = $2a8a963e5702921b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2a8a963e5702921b$var$_propTypes = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2a8a963e5702921b$var$_clsx = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2a8a963e5702921b$var$_composeClasses = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2a8a963e5702921b$var$_capitalize = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $2a8a963e5702921b$var$_memoTheme = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $2a8a963e5702921b$var$_capitalize.default)(color)}`,
            `fontSize${(0, $2a8a963e5702921b$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $2a8a963e5702921b$var$_composeClasses.default)(slots, $aiIP4.getSvgIconUtilityClass, classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $aAbgT.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $2a8a963e5702921b$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $2a8a963e5702921b$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $2a8a963e5702921b$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $2a8a963e5702921b$var$React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $2a8a963e5702921b$var$React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, {
        as: component,
        className: (0, $2a8a963e5702921b$var$_clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$var$_default = module.exports.default = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("aiIP4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $77fe5ab326d42cdb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSvgIconUtilityClass = $77fe5ab326d42cdb$var$getSvgIconUtilityClass;

var $77fe5ab326d42cdb$var$_generateUtilityClasses = $77fe5ab326d42cdb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $77fe5ab326d42cdb$var$_generateUtilityClass = $77fe5ab326d42cdb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $77fe5ab326d42cdb$var$getSvgIconUtilityClass(slot) {
    return (0, $77fe5ab326d42cdb$var$_generateUtilityClass.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $77fe5ab326d42cdb$var$_generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$var$_default = module.exports.default = $77fe5ab326d42cdb$var$svgIconClasses;

});




parcelRegister("gIZJw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c2d0a44fb35b2388$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2d0a44fb35b2388$var$_deprecatedPropType = $c2d0a44fb35b2388$require$_interopRequireDefault((parcelRequire("aDYnb")));
var $c2d0a44fb35b2388$var$_default = module.exports.default = $c2d0a44fb35b2388$var$_deprecatedPropType.default;

});
parcelRegister("aDYnb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7bfc60b9ae966df9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7bfc60b9ae966df9$var$_deprecatedPropType.default;
    }
});

var $7bfc60b9ae966df9$var$_deprecatedPropType = $7bfc60b9ae966df9$require$_interopRequireDefault((parcelRequire("6icuG")));

});
parcelRegister("6icuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $494e1d8c1b97aa71$var$deprecatedPropType;
function $494e1d8c1b97aa71$var$deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

});



parcelRegister("cpXNi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90a633ad7a979daa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90a633ad7a979daa$var$_isMuiElement = $90a633ad7a979daa$require$_interopRequireDefault((parcelRequire("5yr9V")));
var $90a633ad7a979daa$var$_default = module.exports.default = $90a633ad7a979daa$var$_isMuiElement.default;

});

parcelRegister("gzyUk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c10afe25107351d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10afe25107351d9$var$_ownerDocument = $c10afe25107351d9$require$_interopRequireDefault((parcelRequire("43fuO")));
var $c10afe25107351d9$var$_default = module.exports.default = $c10afe25107351d9$var$_ownerDocument.default;

});

parcelRegister("9Evvr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $707049eb9639aeac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $707049eb9639aeac$var$_ownerWindow = $707049eb9639aeac$require$_interopRequireDefault((parcelRequire("4Rhws")));
var $707049eb9639aeac$var$_default = module.exports.default = $707049eb9639aeac$var$_ownerWindow.default;

});

parcelRegister("3VqP0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2dbb80310490cb08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dbb80310490cb08$var$_requirePropFactory = $2dbb80310490cb08$require$_interopRequireDefault((parcelRequire("2IZ5o")));
var $2dbb80310490cb08$var$_default = module.exports.default = $2dbb80310490cb08$var$_requirePropFactory.default;

});
parcelRegister("2IZ5o", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fbf133d7c4f4f16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1fbf133d7c4f4f16$var$_requirePropFactory.default;
    }
});

var $1fbf133d7c4f4f16$var$_requirePropFactory = $1fbf133d7c4f4f16$require$_interopRequireDefault((parcelRequire("iJohf")));

});
parcelRegister("iJohf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da2f42eafa577c28$var$requirePropFactory;
function $da2f42eafa577c28$var$requirePropFactory(componentNameInError, Component) {
    return ()=>()=>null;
}

});



parcelRegister("e6E85", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a450c11ad3ab84fa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a450c11ad3ab84fa$var$_setRef = $a450c11ad3ab84fa$require$_interopRequireDefault((parcelRequire("dGvj8")));
var $a450c11ad3ab84fa$var$_default = module.exports.default = $a450c11ad3ab84fa$var$_setRef.default;

});

parcelRegister("khjmj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec346974df496fc5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec346974df496fc5$var$_useEnhancedEffect = $ec346974df496fc5$require$_interopRequireDefault((parcelRequire("jdWO4")));
var $ec346974df496fc5$var$_default = module.exports.default = $ec346974df496fc5$var$_useEnhancedEffect.default;

});

parcelRegister("5A6d3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4105219ee6538ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4105219ee6538ed1$var$_useId = $4105219ee6538ed1$require$_interopRequireDefault((parcelRequire("hwliF")));
var $4105219ee6538ed1$var$_default = module.exports.default = $4105219ee6538ed1$var$_useId.default;

});

parcelRegister("gUzNi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c4fda44a4aac44a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4fda44a4aac44a5$var$_unsupportedProp = $c4fda44a4aac44a5$require$_interopRequireDefault((parcelRequire("kf98i")));
var $c4fda44a4aac44a5$var$_default = module.exports.default = $c4fda44a4aac44a5$var$_unsupportedProp.default;

});
parcelRegister("kf98i", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ebcc4af23e3dfede$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ebcc4af23e3dfede$var$_unsupportedProp.default;
    }
});

var $ebcc4af23e3dfede$var$_unsupportedProp = $ebcc4af23e3dfede$require$_interopRequireDefault((parcelRequire("hgZZv")));

});
parcelRegister("hgZZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9340465e04eedf1$var$unsupportedProp;
function $c9340465e04eedf1$var$unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

});



parcelRegister("3yddg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $295ecbe78b5bad73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295ecbe78b5bad73$var$_useControlled = $295ecbe78b5bad73$require$_interopRequireDefault((parcelRequire("iSpB2")));
var $295ecbe78b5bad73$var$_default = module.exports.default = $295ecbe78b5bad73$var$_useControlled.default;

});
parcelRegister("iSpB2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dbe1201302318660$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dbe1201302318660$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dbe1201302318660$var$_useControlled.default;
    }
});

var $dbe1201302318660$var$_useControlled = $dbe1201302318660$require$_interopRequireWildcard((parcelRequire("cEttN")));
Object.keys($dbe1201302318660$var$_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dbe1201302318660$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dbe1201302318660$var$_useControlled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dbe1201302318660$var$_useControlled[key];
        }
    });
});

});
parcelRegister("cEttN", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $936016844ea5135f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $936016844ea5135f$var$useControlled;

var $936016844ea5135f$var$React = $936016844ea5135f$require$_interopRequireWildcard((parcelRequire("acw62")));
function $936016844ea5135f$var$useControlled(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $936016844ea5135f$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $936016844ea5135f$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $936016844ea5135f$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});



parcelRegister("4o7uD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $331f3746e6346411$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $331f3746e6346411$var$_useEventCallback = $331f3746e6346411$require$_interopRequireDefault((parcelRequire("6Lbjo")));
var $331f3746e6346411$var$_default = module.exports.default = $331f3746e6346411$var$_useEventCallback.default;

});

parcelRegister("f8X1n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b06562c0a3ca8f02$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b06562c0a3ca8f02$var$mergeSlotProps;

var $b06562c0a3ca8f02$var$_clsx = $b06562c0a3ca8f02$require$_interopRequireDefault((parcelRequire("9QePP")));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $b06562c0a3ca8f02$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $b06562c0a3ca8f02$var$mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($b06562c0a3ca8f02$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $b06562c0a3ca8f02$var$_clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $b06562c0a3ca8f02$var$_clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});




parcelRegister("juRJQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e31a80f86c785b2c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e31a80f86c785b2c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e31a80f86c785b2c$var$_exportNames = {
    paperClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e31a80f86c785b2c$var$_Paper.default;
    }
});
Object.defineProperty(module.exports, "paperClasses", {
    enumerable: true,
    get: function() {
        return $e31a80f86c785b2c$var$_paperClasses.default;
    }
});

var $e31a80f86c785b2c$var$_Paper = $e31a80f86c785b2c$require$_interopRequireDefault((parcelRequire("7Frhn")));

var $e31a80f86c785b2c$var$_paperClasses = $e31a80f86c785b2c$require$_interopRequireWildcard((parcelRequire("6LfkK")));
Object.keys($e31a80f86c785b2c$var$_paperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e31a80f86c785b2c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e31a80f86c785b2c$var$_paperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e31a80f86c785b2c$var$_paperClasses[key];
        }
    });
});

});
parcelRegister("7Frhn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $595185d0d7275c3b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $595185d0d7275c3b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $595185d0d7275c3b$var$React = $595185d0d7275c3b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $595185d0d7275c3b$var$_propTypes = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $595185d0d7275c3b$var$_clsx = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $595185d0d7275c3b$var$_integerPropType = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $595185d0d7275c3b$var$_chainPropTypes = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("abVWF")));

var $595185d0d7275c3b$var$_composeClasses = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $595185d0d7275c3b$var$_memoTheme = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $595185d0d7275c3b$var$_getOverlayAlpha = $595185d0d7275c3b$require$_interopRequireDefault((parcelRequire("35vyj")));

var $6LfkK = parcelRequire("6LfkK");

var $ayMG0 = parcelRequire("ayMG0");
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $595185d0d7275c3b$var$_composeClasses.default)(slots, $6LfkK.getPaperUtilityClass, classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $595185d0d7275c3b$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $595185d0d7275c3b$var$React.forwardRef(function Paper(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $aAbgT.useTheme)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $595185d0d7275c3b$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $h61zw.alpha)('#fff', (0, $595185d0d7275c3b$var$_getOverlayAlpha.default)(elevation))}, ${(0, $h61zw.alpha)('#fff', (0, $595185d0d7275c3b$var$_getOverlayAlpha.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $595185d0d7275c3b$var$_default = module.exports.default = $595185d0d7275c3b$var$Paper;

});
parcelRegister("6LfkK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ec306d48089c2c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaperUtilityClass = $4ec306d48089c2c9$var$getPaperUtilityClass;

var $4ec306d48089c2c9$var$_generateUtilityClasses = $4ec306d48089c2c9$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4ec306d48089c2c9$var$_generateUtilityClass = $4ec306d48089c2c9$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ec306d48089c2c9$var$getPaperUtilityClass(slot) {
    return (0, $4ec306d48089c2c9$var$_generateUtilityClass.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $4ec306d48089c2c9$var$_generateUtilityClasses.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$var$_default = module.exports.default = $4ec306d48089c2c9$var$paperClasses;

});



parcelRegister("4G59M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $367f15b5d414b8d7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDrawerUtilityClass = $367f15b5d414b8d7$var$getDrawerUtilityClass;

var $367f15b5d414b8d7$var$_generateUtilityClasses = $367f15b5d414b8d7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $367f15b5d414b8d7$var$_generateUtilityClass = $367f15b5d414b8d7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $367f15b5d414b8d7$var$getDrawerUtilityClass(slot) {
    return (0, $367f15b5d414b8d7$var$_generateUtilityClass.default)('MuiDrawer', slot);
}
const $367f15b5d414b8d7$var$drawerClasses = (0, $367f15b5d414b8d7$var$_generateUtilityClasses.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $367f15b5d414b8d7$var$_default = module.exports.default = $367f15b5d414b8d7$var$drawerClasses;

});



parcelRegister("ib3g2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d3bbc7f720921ac7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d3bbc7f720921ac7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d3bbc7f720921ac7$var$_exportNames = {
    listClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d3bbc7f720921ac7$var$_List.default;
    }
});
Object.defineProperty(module.exports, "listClasses", {
    enumerable: true,
    get: function() {
        return $d3bbc7f720921ac7$var$_listClasses.default;
    }
});

var $d3bbc7f720921ac7$var$_List = $d3bbc7f720921ac7$require$_interopRequireDefault((parcelRequire("8AyZl")));

var $d3bbc7f720921ac7$var$_listClasses = $d3bbc7f720921ac7$require$_interopRequireWildcard((parcelRequire("eUMjp")));
Object.keys($d3bbc7f720921ac7$var$_listClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d3bbc7f720921ac7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d3bbc7f720921ac7$var$_listClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d3bbc7f720921ac7$var$_listClasses[key];
        }
    });
});

});
parcelRegister("8AyZl", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $640cd381f5e8b3ea$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $640cd381f5e8b3ea$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $640cd381f5e8b3ea$var$React = $640cd381f5e8b3ea$require$_interopRequireWildcard((parcelRequire("acw62")));

var $640cd381f5e8b3ea$var$_propTypes = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $640cd381f5e8b3ea$var$_clsx = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("9QePP")));

var $640cd381f5e8b3ea$var$_composeClasses = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $640cd381f5e8b3ea$var$_ListContext = $640cd381f5e8b3ea$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $eUMjp = parcelRequire("eUMjp");

var $ayMG0 = parcelRequire("ayMG0");
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $640cd381f5e8b3ea$var$_composeClasses.default)(slots, $eUMjp.getListUtilityClass, classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $aAbgT.styled)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $640cd381f5e8b3ea$var$React.forwardRef(function List(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $640cd381f5e8b3ea$var$React.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($640cd381f5e8b3ea$var$_ListContext.default.Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, {
            as: component,
            className: (0, $640cd381f5e8b3ea$var$_clsx.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $640cd381f5e8b3ea$var$_default = module.exports.default = $640cd381f5e8b3ea$var$List;

});
parcelRegister("3W6ht", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2ddba918a398c481$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ddba918a398c481$var$React = $2ddba918a398c481$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $2ddba918a398c481$var$React.createContext({});
var $2ddba918a398c481$var$_default = module.exports.default = $2ddba918a398c481$var$ListContext;

});

parcelRegister("eUMjp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adbbc5717e0d0350$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListUtilityClass = $adbbc5717e0d0350$var$getListUtilityClass;

var $adbbc5717e0d0350$var$_generateUtilityClasses = $adbbc5717e0d0350$require$_interopRequireDefault((parcelRequire("5nY49")));

var $adbbc5717e0d0350$var$_generateUtilityClass = $adbbc5717e0d0350$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $adbbc5717e0d0350$var$getListUtilityClass(slot) {
    return (0, $adbbc5717e0d0350$var$_generateUtilityClass.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $adbbc5717e0d0350$var$_generateUtilityClasses.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$var$_default = module.exports.default = $adbbc5717e0d0350$var$listClasses;

});



parcelRegister("iVzhN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dc78ebeb7704024e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dc78ebeb7704024e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dc78ebeb7704024e$var$_exportNames = {
    listItemButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dc78ebeb7704024e$var$_ListItemButton.default;
    }
});
Object.defineProperty(module.exports, "listItemButtonClasses", {
    enumerable: true,
    get: function() {
        return $dc78ebeb7704024e$var$_listItemButtonClasses.default;
    }
});

var $dc78ebeb7704024e$var$_ListItemButton = $dc78ebeb7704024e$require$_interopRequireDefault((parcelRequire("cSDx2")));

var $dc78ebeb7704024e$var$_listItemButtonClasses = $dc78ebeb7704024e$require$_interopRequireWildcard((parcelRequire("dUgGz")));
Object.keys($dc78ebeb7704024e$var$_listItemButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dc78ebeb7704024e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dc78ebeb7704024e$var$_listItemButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dc78ebeb7704024e$var$_listItemButtonClasses[key];
        }
    });
});

});
parcelRegister("cSDx2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $960931686a59e228$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $960931686a59e228$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overridesResolver = module.exports.default = void 0;

var $960931686a59e228$var$React = $960931686a59e228$require$_interopRequireWildcard((parcelRequire("acw62")));

var $960931686a59e228$var$_propTypes = $960931686a59e228$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $960931686a59e228$var$_clsx = $960931686a59e228$require$_interopRequireDefault((parcelRequire("9QePP")));

var $960931686a59e228$var$_composeClasses = $960931686a59e228$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $960931686a59e228$var$_memoTheme = $960931686a59e228$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $960931686a59e228$var$_rootShouldForwardProp = $960931686a59e228$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $960931686a59e228$var$_ButtonBase = $960931686a59e228$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $960931686a59e228$var$_useEnhancedEffect = $960931686a59e228$require$_interopRequireDefault((parcelRequire("khjmj")));

var $960931686a59e228$var$_useForkRef = $960931686a59e228$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $960931686a59e228$var$_ListContext = $960931686a59e228$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $960931686a59e228$var$_listItemButtonClasses = $960931686a59e228$require$_interopRequireWildcard((parcelRequire("dUgGz")));

var $ayMG0 = parcelRequire("ayMG0");
const $960931686a59e228$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
module.exports.overridesResolver = $960931686a59e228$var$overridesResolver;
const $960931686a59e228$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $960931686a59e228$var$_composeClasses.default)(slots, $960931686a59e228$var$_listItemButtonClasses.getListItemButtonUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $960931686a59e228$var$ListItemButtonRoot = (0, $aAbgT.styled)($960931686a59e228$var$_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, $960931686a59e228$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $960931686a59e228$var$overridesResolver
})((0, $960931686a59e228$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${$960931686a59e228$var$_listItemButtonClasses.default.focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$960931686a59e228$var$_listItemButtonClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $960931686a59e228$var$ListItemButton = /*#__PURE__*/ $960931686a59e228$var$React.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className, ...other } = props;
    const context = $960931686a59e228$var$React.useContext($960931686a59e228$var$_ListContext.default);
    const childContext = $960931686a59e228$var$React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $960931686a59e228$var$React.useRef(null);
    (0, $960931686a59e228$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    };
    const classes = $960931686a59e228$var$useUtilityClasses(ownerState);
    const handleRef = (0, $960931686a59e228$var$_useForkRef.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($960931686a59e228$var$ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $960931686a59e228$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $960931686a59e228$var$_clsx.default)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var $960931686a59e228$var$_default = module.exports.default = $960931686a59e228$var$ListItemButton;

});
parcelRegister("hhs3r", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c949c943dfbcd61d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c949c943dfbcd61d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c949c943dfbcd61d$var$_exportNames = {
    buttonBaseClasses: true,
    touchRippleClasses: true
};
Object.defineProperty(module.exports, "buttonBaseClasses", {
    enumerable: true,
    get: function() {
        return $c949c943dfbcd61d$var$_buttonBaseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c949c943dfbcd61d$var$_ButtonBase.default;
    }
});
Object.defineProperty(module.exports, "touchRippleClasses", {
    enumerable: true,
    get: function() {
        return $c949c943dfbcd61d$var$_touchRippleClasses.default;
    }
});

var $c949c943dfbcd61d$var$_ButtonBase = $c949c943dfbcd61d$require$_interopRequireDefault((parcelRequire("6n0Ko")));

var $c949c943dfbcd61d$var$_buttonBaseClasses = $c949c943dfbcd61d$require$_interopRequireWildcard((parcelRequire("5JO1P")));
Object.keys($c949c943dfbcd61d$var$_buttonBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c949c943dfbcd61d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c949c943dfbcd61d$var$_buttonBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c949c943dfbcd61d$var$_buttonBaseClasses[key];
        }
    });
});

var $c949c943dfbcd61d$var$_touchRippleClasses = $c949c943dfbcd61d$require$_interopRequireWildcard((parcelRequire("a4Mf7")));
Object.keys($c949c943dfbcd61d$var$_touchRippleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c949c943dfbcd61d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c949c943dfbcd61d$var$_touchRippleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c949c943dfbcd61d$var$_touchRippleClasses[key];
        }
    });
});

});
parcelRegister("6n0Ko", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a35786d89db9dda$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a35786d89db9dda$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ButtonBaseRoot = void 0;

var $4a35786d89db9dda$var$React = $4a35786d89db9dda$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4a35786d89db9dda$var$_propTypes = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4a35786d89db9dda$var$_clsx = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4a35786d89db9dda$var$_refType = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $4a35786d89db9dda$var$_elementTypeAcceptingRef = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $4a35786d89db9dda$var$_composeClasses = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $4a35786d89db9dda$var$_isFocusVisible = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("cS73m")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4a35786d89db9dda$var$_useForkRef = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $4a35786d89db9dda$var$_useEventCallback = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $4a35786d89db9dda$var$_useLazyRipple = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("dQknY")));

var $4a35786d89db9dda$var$_TouchRipple = $4a35786d89db9dda$require$_interopRequireDefault((parcelRequire("brF9L")));

var $4a35786d89db9dda$var$_buttonBaseClasses = $4a35786d89db9dda$require$_interopRequireWildcard((parcelRequire("5JO1P")));

var $ayMG0 = parcelRequire("ayMG0");
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $4a35786d89db9dda$var$_composeClasses.default)(slots, $4a35786d89db9dda$var$_buttonBaseClasses.getButtonBaseUtilityClass, classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$var$ButtonBaseRoot = module.exports.ButtonBaseRoot = (0, $aAbgT.styled)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${$4a35786d89db9dda$var$_buttonBaseClasses.default.disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $4a35786d89db9dda$var$React.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $4a35786d89db9dda$var$React.useRef(null);
    const ripple = (0, $4a35786d89db9dda$var$_useLazyRipple.default)();
    const handleRippleRef = (0, $4a35786d89db9dda$var$_useForkRef.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $4a35786d89db9dda$var$React.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $4a35786d89db9dda$var$React.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $4a35786d89db9dda$var$React.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $4a35786d89db9dda$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $4a35786d89db9dda$var$_isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        const hasFormAttributes = !!other.formAction;
        // ButtonBase was defaulting to type="button" when no type prop was provided, which prevented form submission and broke formAction functionality.
        // The fix checks for form-related attributes and skips the default type to allow the browser's natural submit behavior (type="submit").
        buttonProps.type = type === undefined && !hasFormAttributes ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4a35786d89db9dda$var$_useForkRef.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$var$ButtonBaseRoot, {
        as: ComponentProp,
        className: (0, $4a35786d89db9dda$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)($4a35786d89db9dda$var$_TouchRipple.default, {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $4a35786d89db9dda$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $4a35786d89db9dda$var$_useEventCallback.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $4a35786d89db9dda$var$_default = module.exports.default = $4a35786d89db9dda$var$ButtonBase;

});
parcelRegister("b3gjr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $80bca0e241370467$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80bca0e241370467$var$_refType.default;
    }
});

var $80bca0e241370467$var$_refType = $80bca0e241370467$require$_interopRequireDefault((parcelRequire("5g2TU")));

});
parcelRegister("5g2TU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d40b2611b4cd7ef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d40b2611b4cd7ef$var$_propTypes = $3d40b2611b4cd7ef$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $3d40b2611b4cd7ef$var$refType = $3d40b2611b4cd7ef$var$_propTypes.default.oneOfType([
    $3d40b2611b4cd7ef$var$_propTypes.default.func,
    $3d40b2611b4cd7ef$var$_propTypes.default.object
]);
var $3d40b2611b4cd7ef$var$_default = module.exports.default = $3d40b2611b4cd7ef$var$refType;

});


parcelRegister("g6PKz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bba559669a6b05ba$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bba559669a6b05ba$var$_elementTypeAcceptingRef.default;
    }
});

var $bba559669a6b05ba$var$_elementTypeAcceptingRef = $bba559669a6b05ba$require$_interopRequireDefault((parcelRequire("ipGOY")));

});
parcelRegister("ipGOY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d67bc73532990cfc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d67bc73532990cfc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d67bc73532990cfc$var$_propTypes = $d67bc73532990cfc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d67bc73532990cfc$var$React = $d67bc73532990cfc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d67bc73532990cfc$var$_chainPropTypes = $d67bc73532990cfc$require$_interopRequireDefault((parcelRequire("abVWF")));
function $d67bc73532990cfc$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $d67bc73532990cfc$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$d67bc73532990cfc$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (propValue === $d67bc73532990cfc$var$React.Fragment) warningHint = 'Did you accidentally provide a React.Fragment instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $d67bc73532990cfc$var$_default = module.exports.default = (0, $d67bc73532990cfc$var$_chainPropTypes.default)($d67bc73532990cfc$var$_propTypes.default.elementType, $d67bc73532990cfc$var$elementTypeAcceptingRef);

});


parcelRegister("cS73m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $95efffca1849a5b5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $95efffca1849a5b5$var$_isFocusVisible.default;
    }
});

var $95efffca1849a5b5$var$_isFocusVisible = $95efffca1849a5b5$require$_interopRequireDefault((parcelRequire("clXxf")));

});
parcelRegister("clXxf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fe5a0a4a52682b2$var$isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $8fe5a0a4a52682b2$var$isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});


parcelRegister("dQknY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a13ff1df58a097d2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a13ff1df58a097d2$var$_useLazyRipple.default;
    }
});

var $a13ff1df58a097d2$var$_useLazyRipple = $a13ff1df58a097d2$require$_interopRequireDefault((parcelRequire("ju2Oo")));

});
parcelRegister("ju2Oo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e2f30007e7be7ff3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e2f30007e7be7ff3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyRipple = void 0;
module.exports.default = $e2f30007e7be7ff3$var$useLazyRipple;

var $e2f30007e7be7ff3$var$React = $e2f30007e7be7ff3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e2f30007e7be7ff3$var$_useLazyRef = $e2f30007e7be7ff3$require$_interopRequireDefault((parcelRequire("doV3C")));
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ class $e2f30007e7be7ff3$var$LazyRipple {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $e2f30007e7be7ff3$var$LazyRipple();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $e2f30007e7be7ff3$var$_useLazyRef.default)($e2f30007e7be7ff3$var$LazyRipple.create).current;
        const [shouldMount, setShouldMount] = $e2f30007e7be7ff3$var$React.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $e2f30007e7be7ff3$var$React.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $e2f30007e7be7ff3$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
module.exports.LazyRipple = $e2f30007e7be7ff3$var$LazyRipple;
function $e2f30007e7be7ff3$var$useLazyRipple() {
    return $e2f30007e7be7ff3$var$LazyRipple.use();
}
function $e2f30007e7be7ff3$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("doV3C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c19c6af0ae205c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9c19c6af0ae205c1$var$_useLazyRef.default;
    }
});

var $9c19c6af0ae205c1$var$_useLazyRef = $9c19c6af0ae205c1$require$_interopRequireDefault((parcelRequire("5vBDv")));

});
parcelRegister("5vBDv", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $402d0abe25ac8831$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $402d0abe25ac8831$var$useLazyRef;

var $402d0abe25ac8831$var$React = $402d0abe25ac8831$require$_interopRequireWildcard((parcelRequire("acw62")));
const $402d0abe25ac8831$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $402d0abe25ac8831$var$useLazyRef(init, initArg) {
    const ref = $402d0abe25ac8831$var$React.useRef($402d0abe25ac8831$var$UNINITIALIZED);
    if (ref.current === $402d0abe25ac8831$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});




parcelRegister("brF9L", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $855224273a002a0f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $855224273a002a0f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TouchRippleRoot = module.exports.TouchRippleRipple = module.exports.DELAY_RIPPLE = void 0;

var $855224273a002a0f$var$React = $855224273a002a0f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $855224273a002a0f$var$_propTypes = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jEvxL = parcelRequire("jEvxL");

var $855224273a002a0f$var$_clsx = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $855224273a002a0f$var$_useTimeout = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("drY8V")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $855224273a002a0f$var$_Ripple = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("hruNq")));

var $855224273a002a0f$var$_touchRippleClasses = $855224273a002a0f$require$_interopRequireDefault((parcelRequire("a4Mf7")));

var $ayMG0 = parcelRequire("ayMG0");
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$var$DELAY_RIPPLE = module.exports.DELAY_RIPPLE = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $855224273a002a0f$var$exitKeyframe = (0, $aAbgT.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $855224273a002a0f$var$pulsateKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $855224273a002a0f$var$TouchRippleRoot = module.exports.TouchRippleRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $855224273a002a0f$var$TouchRippleRipple = module.exports.TouchRippleRipple = (0, $aAbgT.styled)($855224273a002a0f$var$_Ripple.default, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${$855224273a002a0f$var$_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$855224273a002a0f$var$enterKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${$855224273a002a0f$var$_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${$855224273a002a0f$var$_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${$855224273a002a0f$var$_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${$855224273a002a0f$var$exitKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${$855224273a002a0f$var$_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$855224273a002a0f$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $855224273a002a0f$var$React.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $855224273a002a0f$var$React.useState([]);
    const nextKey = $855224273a002a0f$var$React.useRef(0);
    const rippleCallback = $855224273a002a0f$var$React.useRef(null);
    $855224273a002a0f$var$React.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $855224273a002a0f$var$React.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $855224273a002a0f$var$_useTimeout.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $855224273a002a0f$var$React.useRef(null);
    const container = $855224273a002a0f$var$React.useRef(null);
    const startCommit = $855224273a002a0f$var$React.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$var$TouchRippleRipple, {
                    classes: {
                        ripple: (0, $855224273a002a0f$var$_clsx.default)(classes.ripple, $855224273a002a0f$var$_touchRippleClasses.default.ripple),
                        rippleVisible: (0, $855224273a002a0f$var$_clsx.default)(classes.rippleVisible, $855224273a002a0f$var$_touchRippleClasses.default.rippleVisible),
                        ripplePulsate: (0, $855224273a002a0f$var$_clsx.default)(classes.ripplePulsate, $855224273a002a0f$var$_touchRippleClasses.default.ripplePulsate),
                        child: (0, $855224273a002a0f$var$_clsx.default)(classes.child, $855224273a002a0f$var$_touchRippleClasses.default.child),
                        childLeaving: (0, $855224273a002a0f$var$_clsx.default)(classes.childLeaving, $855224273a002a0f$var$_touchRippleClasses.default.childLeaving),
                        childPulsate: (0, $855224273a002a0f$var$_clsx.default)(classes.childPulsate, $855224273a002a0f$var$_touchRippleClasses.default.childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $855224273a002a0f$var$React.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touch devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$var$DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $855224273a002a0f$var$React.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $855224273a002a0f$var$React.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $855224273a002a0f$var$React.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$var$TouchRippleRoot, {
        className: (0, $855224273a002a0f$var$_clsx.default)($855224273a002a0f$var$_touchRippleClasses.default.root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($jEvxL.default, {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $855224273a002a0f$var$_default = module.exports.default = $855224273a002a0f$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("drY8V", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9cac7318e3bb01ed$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $9cac7318e3bb01ed$var$_useTimeout.Timeout;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9cac7318e3bb01ed$var$_useTimeout.default;
    }
});

var $9cac7318e3bb01ed$var$_useTimeout = $9cac7318e3bb01ed$require$_interopRequireWildcard((parcelRequire("lAE8L")));

});
parcelRegister("lAE8L", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fb7c18ce8a63cbff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $fb7c18ce8a63cbff$var$useTimeout;

var $fb7c18ce8a63cbff$var$_useLazyRef = $fb7c18ce8a63cbff$require$_interopRequireDefault((parcelRequire("5vBDv")));

var $fb7c18ce8a63cbff$var$_useOnMount = $fb7c18ce8a63cbff$require$_interopRequireDefault((parcelRequire("kWo5z")));
class $fb7c18ce8a63cbff$var$Timeout {
    static create() {
        return new $fb7c18ce8a63cbff$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $fb7c18ce8a63cbff$var$Timeout;
function $fb7c18ce8a63cbff$var$useTimeout() {
    const timeout = (0, $fb7c18ce8a63cbff$var$_useLazyRef.default)($fb7c18ce8a63cbff$var$Timeout.create).current;
    (0, $fb7c18ce8a63cbff$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("kWo5z", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f3ebe8fe644f0aa5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3ebe8fe644f0aa5$var$useOnMount;

var $f3ebe8fe644f0aa5$var$React = $f3ebe8fe644f0aa5$require$_interopRequireWildcard((parcelRequire("acw62")));
const $f3ebe8fe644f0aa5$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $f3ebe8fe644f0aa5$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $f3ebe8fe644f0aa5$var$React.useEffect(fn, $f3ebe8fe644f0aa5$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});



parcelRegister("hruNq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cb2cd8c78d72bd92$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cb2cd8c78d72bd92$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb2cd8c78d72bd92$var$React = $cb2cd8c78d72bd92$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cb2cd8c78d72bd92$var$_propTypes = $cb2cd8c78d72bd92$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cb2cd8c78d72bd92$var$_clsx = $cb2cd8c78d72bd92$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $cb2cd8c78d72bd92$var$React.useState(false);
    const rippleClassName = (0, $cb2cd8c78d72bd92$var$_clsx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $cb2cd8c78d72bd92$var$_clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $cb2cd8c78d72bd92$var$React.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$var$_default = module.exports.default = $cb2cd8c78d72bd92$var$Ripple;

});

parcelRegister("a4Mf7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $755fb323846f60d4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTouchRippleUtilityClass = $755fb323846f60d4$var$getTouchRippleUtilityClass;

var $755fb323846f60d4$var$_generateUtilityClasses = $755fb323846f60d4$require$_interopRequireDefault((parcelRequire("5nY49")));

var $755fb323846f60d4$var$_generateUtilityClass = $755fb323846f60d4$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $755fb323846f60d4$var$getTouchRippleUtilityClass(slot) {
    return (0, $755fb323846f60d4$var$_generateUtilityClass.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $755fb323846f60d4$var$_generateUtilityClasses.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$var$_default = module.exports.default = $755fb323846f60d4$var$touchRippleClasses;

});


parcelRegister("5JO1P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $42d7f65840078ec1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonBaseUtilityClass = $42d7f65840078ec1$var$getButtonBaseUtilityClass;

var $42d7f65840078ec1$var$_generateUtilityClasses = $42d7f65840078ec1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $42d7f65840078ec1$var$_generateUtilityClass = $42d7f65840078ec1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $42d7f65840078ec1$var$getButtonBaseUtilityClass(slot) {
    return (0, $42d7f65840078ec1$var$_generateUtilityClass.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $42d7f65840078ec1$var$_generateUtilityClasses.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$var$_default = module.exports.default = $42d7f65840078ec1$var$buttonBaseClasses;

});



parcelRegister("dUgGz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a1fd72c2634274a8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemButtonUtilityClass = $a1fd72c2634274a8$var$getListItemButtonUtilityClass;

var $a1fd72c2634274a8$var$_generateUtilityClasses = $a1fd72c2634274a8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a1fd72c2634274a8$var$_generateUtilityClass = $a1fd72c2634274a8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a1fd72c2634274a8$var$getListItemButtonUtilityClass(slot) {
    return (0, $a1fd72c2634274a8$var$_generateUtilityClass.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $a1fd72c2634274a8$var$_generateUtilityClasses.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$var$_default = module.exports.default = $a1fd72c2634274a8$var$listItemButtonClasses;

});



parcelRegister("2fe4K", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1a27e69578e2c56e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1a27e69578e2c56e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1a27e69578e2c56e$var$_exportNames = {
    listItemIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1a27e69578e2c56e$var$_ListItemIcon.default;
    }
});
Object.defineProperty(module.exports, "listItemIconClasses", {
    enumerable: true,
    get: function() {
        return $1a27e69578e2c56e$var$_listItemIconClasses.default;
    }
});

var $1a27e69578e2c56e$var$_ListItemIcon = $1a27e69578e2c56e$require$_interopRequireDefault((parcelRequire("bjZRT")));

var $1a27e69578e2c56e$var$_listItemIconClasses = $1a27e69578e2c56e$require$_interopRequireWildcard((parcelRequire("doXfV")));
Object.keys($1a27e69578e2c56e$var$_listItemIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1a27e69578e2c56e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1a27e69578e2c56e$var$_listItemIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1a27e69578e2c56e$var$_listItemIconClasses[key];
        }
    });
});

});
parcelRegister("bjZRT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $83e175cb7e49d325$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $83e175cb7e49d325$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83e175cb7e49d325$var$React = $83e175cb7e49d325$require$_interopRequireWildcard((parcelRequire("acw62")));

var $83e175cb7e49d325$var$_propTypes = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $83e175cb7e49d325$var$_clsx = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("9QePP")));

var $83e175cb7e49d325$var$_composeClasses = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $83e175cb7e49d325$var$_memoTheme = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $doXfV = parcelRequire("doXfV");

var $83e175cb7e49d325$var$_ListContext = $83e175cb7e49d325$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $ayMG0 = parcelRequire("ayMG0");
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $83e175cb7e49d325$var$_composeClasses.default)(slots, $doXfV.getListItemIconUtilityClass, classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $83e175cb7e49d325$var$_memoTheme.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $83e175cb7e49d325$var$React.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $83e175cb7e49d325$var$React.useContext($83e175cb7e49d325$var$_ListContext.default);
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, {
        className: (0, $83e175cb7e49d325$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $83e175cb7e49d325$var$_default = module.exports.default = $83e175cb7e49d325$var$ListItemIcon;

});
parcelRegister("doXfV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c1b7b40cd19f5fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemIconUtilityClass = $9c1b7b40cd19f5fe$var$getListItemIconUtilityClass;

var $9c1b7b40cd19f5fe$var$_generateUtilityClasses = $9c1b7b40cd19f5fe$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9c1b7b40cd19f5fe$var$_generateUtilityClass = $9c1b7b40cd19f5fe$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9c1b7b40cd19f5fe$var$getListItemIconUtilityClass(slot) {
    return (0, $9c1b7b40cd19f5fe$var$_generateUtilityClass.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $9c1b7b40cd19f5fe$var$_generateUtilityClasses.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$var$_default = module.exports.default = $9c1b7b40cd19f5fe$var$listItemIconClasses;

});



parcelRegister("djLZl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9b22463c6c37319f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9b22463c6c37319f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9b22463c6c37319f$var$_exportNames = {
    listItemTextClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9b22463c6c37319f$var$_ListItemText.default;
    }
});
Object.defineProperty(module.exports, "listItemTextClasses", {
    enumerable: true,
    get: function() {
        return $9b22463c6c37319f$var$_listItemTextClasses.default;
    }
});

var $9b22463c6c37319f$var$_ListItemText = $9b22463c6c37319f$require$_interopRequireDefault((parcelRequire("19ocJ")));

var $9b22463c6c37319f$var$_listItemTextClasses = $9b22463c6c37319f$require$_interopRequireWildcard((parcelRequire("guz4p")));
Object.keys($9b22463c6c37319f$var$_listItemTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9b22463c6c37319f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9b22463c6c37319f$var$_listItemTextClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9b22463c6c37319f$var$_listItemTextClasses[key];
        }
    });
});

});
parcelRegister("19ocJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0d696835f9b43a35$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0d696835f9b43a35$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d696835f9b43a35$var$React = $0d696835f9b43a35$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0d696835f9b43a35$var$_propTypes = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0d696835f9b43a35$var$_clsx = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0d696835f9b43a35$var$_composeClasses = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0d696835f9b43a35$var$_Typography = $0d696835f9b43a35$require$_interopRequireWildcard((parcelRequire("2dUd7")));

var $0d696835f9b43a35$var$_ListContext = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $0d696835f9b43a35$var$_listItemTextClasses = $0d696835f9b43a35$require$_interopRequireWildcard((parcelRequire("guz4p")));

var $0d696835f9b43a35$var$_useSlot = $0d696835f9b43a35$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $0d696835f9b43a35$var$_composeClasses.default)(slots, $0d696835f9b43a35$var$_listItemTextClasses.getListItemTextUtilityClass, classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$0d696835f9b43a35$var$_listItemTextClasses.default.primary}`]: styles.primary
            },
            {
                [`& .${$0d696835f9b43a35$var$_listItemTextClasses.default.secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${$0d696835f9b43a35$var$_Typography.typographyClasses.root}:where(& .${$0d696835f9b43a35$var$_listItemTextClasses.default.primary}), .${$0d696835f9b43a35$var$_Typography.typographyClasses.root}:where(& .${$0d696835f9b43a35$var$_listItemTextClasses.default.secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $0d696835f9b43a35$var$React.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $0d696835f9b43a35$var$React.useContext($0d696835f9b43a35$var$_ListContext.default);
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $0d696835f9b43a35$var$_useSlot.default)('root', {
        className: (0, $0d696835f9b43a35$var$_clsx.default)(classes.root, className),
        elementType: $0d696835f9b43a35$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $0d696835f9b43a35$var$_useSlot.default)('primary', {
        className: classes.primary,
        elementType: $0d696835f9b43a35$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $0d696835f9b43a35$var$_useSlot.default)('secondary', {
        className: classes.secondary,
        elementType: $0d696835f9b43a35$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== $0d696835f9b43a35$var$_Typography.default && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== $0d696835f9b43a35$var$_Typography.default && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $0d696835f9b43a35$var$_default = module.exports.default = $0d696835f9b43a35$var$ListItemText;

});
parcelRegister("2dUd7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $19e865ef3ed82f53$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $19e865ef3ed82f53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $19e865ef3ed82f53$var$_exportNames = {
    typographyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $19e865ef3ed82f53$var$_Typography.default;
    }
});
Object.defineProperty(module.exports, "typographyClasses", {
    enumerable: true,
    get: function() {
        return $19e865ef3ed82f53$var$_typographyClasses.default;
    }
});

var $19e865ef3ed82f53$var$_Typography = $19e865ef3ed82f53$require$_interopRequireDefault((parcelRequire("3bYfT")));

var $19e865ef3ed82f53$var$_typographyClasses = $19e865ef3ed82f53$require$_interopRequireWildcard((parcelRequire("bhKtZ")));
Object.keys($19e865ef3ed82f53$var$_typographyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($19e865ef3ed82f53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $19e865ef3ed82f53$var$_typographyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19e865ef3ed82f53$var$_typographyClasses[key];
        }
    });
});

});
parcelRegister("3bYfT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2531239e3a525689$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2531239e3a525689$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TypographyRoot = void 0;

var $2531239e3a525689$var$React = $2531239e3a525689$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2531239e3a525689$var$_propTypes = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2531239e3a525689$var$_clsx = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2531239e3a525689$var$_composeClasses = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $2531239e3a525689$var$_memoTheme = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $2531239e3a525689$var$_capitalize = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2531239e3a525689$var$_createSimplePaletteValueFilter = $2531239e3a525689$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $bhKtZ = parcelRequire("bhKtZ");

var $ayMG0 = parcelRequire("ayMG0");
const $2531239e3a525689$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $2531239e3a525689$var$extendSxProp = (0, $aAbgT.internal_createExtendSxProp)();
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $2531239e3a525689$var$_capitalize.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $2531239e3a525689$var$_composeClasses.default)(slots, $bhKtZ.getTypographyUtilityClass, classes);
};
const $2531239e3a525689$var$TypographyRoot = module.exports.TypographyRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $2531239e3a525689$var$_capitalize.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $2531239e3a525689$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $2531239e3a525689$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $2531239e3a525689$var$_capitalize.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $2531239e3a525689$var$React.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$2531239e3a525689$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $2531239e3a525689$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$var$TypographyRoot, {
        as: Component,
        ref: ref,
        className: (0, $2531239e3a525689$var$_clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $2531239e3a525689$var$_default = module.exports.default = $2531239e3a525689$var$Typography;

});
parcelRegister("1Anyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $127b6c47a683862d$var$createSimplePaletteValueFilter;
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $127b6c47a683862d$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $127b6c47a683862d$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$127b6c47a683862d$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
/**
 * Creates a filter function used to filter simple palette color options.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns ([, value]: [any, PaletteColorOptions]) => boolean
 */ function $127b6c47a683862d$var$createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $127b6c47a683862d$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("bhKtZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $837556bdf75d281f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTypographyUtilityClass = $837556bdf75d281f$var$getTypographyUtilityClass;

var $837556bdf75d281f$var$_generateUtilityClasses = $837556bdf75d281f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $837556bdf75d281f$var$_generateUtilityClass = $837556bdf75d281f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $837556bdf75d281f$var$getTypographyUtilityClass(slot) {
    return (0, $837556bdf75d281f$var$_generateUtilityClass.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $837556bdf75d281f$var$_generateUtilityClasses.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$var$_default = module.exports.default = $837556bdf75d281f$var$typographyClasses;

});



parcelRegister("guz4p", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c01aa6ddbe5e68bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemTextUtilityClass = $c01aa6ddbe5e68bd$var$getListItemTextUtilityClass;

var $c01aa6ddbe5e68bd$var$_generateUtilityClasses = $c01aa6ddbe5e68bd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c01aa6ddbe5e68bd$var$_generateUtilityClass = $c01aa6ddbe5e68bd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c01aa6ddbe5e68bd$var$getListItemTextUtilityClass(slot) {
    return (0, $c01aa6ddbe5e68bd$var$_generateUtilityClass.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $c01aa6ddbe5e68bd$var$_generateUtilityClasses.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$var$_default = module.exports.default = $c01aa6ddbe5e68bd$var$listItemTextClasses;

});



parcelRegister("g6BeY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bb9a180c0f91ff1f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bb9a180c0f91ff1f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bb9a180c0f91ff1f$var$_exportNames = {
    dividerClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bb9a180c0f91ff1f$var$_Divider.default;
    }
});
Object.defineProperty(module.exports, "dividerClasses", {
    enumerable: true,
    get: function() {
        return $bb9a180c0f91ff1f$var$_dividerClasses.default;
    }
});

var $bb9a180c0f91ff1f$var$_Divider = $bb9a180c0f91ff1f$require$_interopRequireDefault((parcelRequire("lkxXU")));

var $bb9a180c0f91ff1f$var$_dividerClasses = $bb9a180c0f91ff1f$require$_interopRequireWildcard((parcelRequire("cbVYE")));
Object.keys($bb9a180c0f91ff1f$var$_dividerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bb9a180c0f91ff1f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bb9a180c0f91ff1f$var$_dividerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bb9a180c0f91ff1f$var$_dividerClasses[key];
        }
    });
});

});
parcelRegister("lkxXU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f875d00b2138afe4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f875d00b2138afe4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f875d00b2138afe4$var$React = $f875d00b2138afe4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f875d00b2138afe4$var$_propTypes = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f875d00b2138afe4$var$_clsx = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f875d00b2138afe4$var$_composeClasses = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $f875d00b2138afe4$var$_memoTheme = $f875d00b2138afe4$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $cbVYE = parcelRequire("cbVYE");

var $ayMG0 = parcelRequire("ayMG0");
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $f875d00b2138afe4$var$_composeClasses.default)(slots, $cbVYE.getDividerUtilityClass, classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $f875d00b2138afe4$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$DividerWrapper = (0, $aAbgT.styled)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $f875d00b2138afe4$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $f875d00b2138afe4$var$React.forwardRef(function Divider(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, {
        as: component,
        className: (0, $f875d00b2138afe4$var$_clsx.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($f875d00b2138afe4$var$Divider) $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$var$_default = module.exports.default = $f875d00b2138afe4$var$Divider;

});
parcelRegister("cbVYE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $024a60f892d3fa61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDividerUtilityClass = $024a60f892d3fa61$var$getDividerUtilityClass;

var $024a60f892d3fa61$var$_generateUtilityClasses = $024a60f892d3fa61$require$_interopRequireDefault((parcelRequire("5nY49")));

var $024a60f892d3fa61$var$_generateUtilityClass = $024a60f892d3fa61$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $024a60f892d3fa61$var$getDividerUtilityClass(slot) {
    return (0, $024a60f892d3fa61$var$_generateUtilityClass.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $024a60f892d3fa61$var$_generateUtilityClasses.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$var$_default = module.exports.default = $024a60f892d3fa61$var$dividerClasses;

});



parcelRegister("apGHQ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $794d5dbdb05a5402$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $794d5dbdb05a5402$var$_createSvgIcon = $794d5dbdb05a5402$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $794d5dbdb05a5402$var$_default = module.exports.default = (0, $794d5dbdb05a5402$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

});
parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $hGPki.createSvgIcon;
    }
});

var $hGPki = parcelRequire("hGPki");

});


parcelRegister("eNVql", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ac722f816c73bdbb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac722f816c73bdbb$var$_createSvgIcon = $ac722f816c73bdbb$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ac722f816c73bdbb$var$_default = module.exports.default = (0, $ac722f816c73bdbb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.4 18.2c.38.5.6 1.12.6 1.8 0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3c.44 0 .85.09 1.23.26l1.41-1.77c-.92-1.03-1.29-2.39-1.09-3.69l-2.03-.68c-.54.83-1.46 1.38-2.52 1.38-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3c0 .07 0 .14-.01.21l2.03.68c.64-1.21 1.82-2.09 3.22-2.32V5.91C9.96 5.57 9 4.4 9 3c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.4-.96 2.57-2.25 2.91v2.16c1.4.23 2.58 1.11 3.22 2.32L18 9.71V9.5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3c-1.06 0-1.98-.55-2.52-1.37l-2.03.68c.2 1.29-.16 2.65-1.09 3.69l1.41 1.77Q17.34 17 18 17c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3c0-.68.22-1.3.6-1.8l-1.41-1.77c-1.35.75-3.01.76-4.37 0z"
}), 'Hub');

});

parcelRegister("dLCr5", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a05d7ab14403c256$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a05d7ab14403c256$var$_createSvgIcon = $a05d7ab14403c256$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a05d7ab14403c256$var$_default = module.exports.default = (0, $a05d7ab14403c256$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');

});

parcelRegister("8fkqf", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $600f90e204abd777$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $600f90e204abd777$var$_createSvgIcon = $600f90e204abd777$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $600f90e204abd777$var$_default = module.exports.default = (0, $600f90e204abd777$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), 'Group');

});

parcelRegister("eGRb8", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ab1e3d19a10d5b36$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab1e3d19a10d5b36$var$_createSvgIcon = $ab1e3d19a10d5b36$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ab1e3d19a10d5b36$var$_default = module.exports.default = (0, $ab1e3d19a10d5b36$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), 'Help');

});

parcelRegister("1f5SY", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $0e7bc1f1ffa38c8c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7bc1f1ffa38c8c$var$_createSvgIcon = $0e7bc1f1ffa38c8c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $0e7bc1f1ffa38c8c$var$_default = module.exports.default = (0, $0e7bc1f1ffa38c8c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3z"
}), 'AddAlert');

});

parcelRegister("5vmDh", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4021675e69fd18da$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4021675e69fd18da$var$_createSvgIcon = $4021675e69fd18da$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4021675e69fd18da$var$_default = module.exports.default = (0, $4021675e69fd18da$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4 0-.35-.03-.69-.08-1H14v-2H9.82C9 10.42 8 9.6 8 8c0-1.93 1.57-3.5 3.5-3.5 1.5 0 2.79.95 3.28 2.28L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.49 4H6v2h2.47c.08.31.13.64.13 1 0 2.7-2.6 4-2.6 4v2z"
}), 'CurrencyPound');

});

parcelRegister("12Iz0", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $0c288bc09d5c62b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c288bc09d5c62b3$var$_createSvgIcon = $0c288bc09d5c62b3$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $0c288bc09d5c62b3$var$_default = module.exports.default = (0, $0c288bc09d5c62b3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 11.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5C8.5 9.57 10.07 8 12 8s3.5 1.57 3.5 3.5m-2.5 6h-2V19h2zm9-5.5c0-2.76-1.12-5.26-2.93-7.07l-1.06 1.06C19.55 7.53 20.5 9.66 20.5 12s-.95 4.47-2.49 6.01l1.06 1.06C20.88 17.26 22 14.76 22 12M3.5 12c0-2.34.95-4.47 2.49-6.01L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.06-1.06C4.45 16.47 3.5 14.34 3.5 12m14 0c0 1.52-.62 2.89-1.61 3.89l1.06 1.06C18.22 15.68 19 13.93 19 12s-.78-3.68-2.05-4.95l-1.06 1.06c.99 1 1.61 2.37 1.61 3.89M7.05 16.95l1.06-1.06c-1-1-1.61-2.37-1.61-3.89s.62-2.89 1.61-3.89L7.05 7.05C5.78 8.32 5 10.07 5 12s.78 3.68 2.05 4.95"
}), 'OnlinePrediction');

});

parcelRegister("78dTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $53140f70f5116e76$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53140f70f5116e76$var$_createSvgIcon = $53140f70f5116e76$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $53140f70f5116e76$var$_default = module.exports.default = (0, $53140f70f5116e76$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    fillRule: "evenodd",
    d: "M3 3v8h8V3zm6 6H5V5h4zm-6 4v8h8v-8zm6 6H5v-4h4zm4-16v8h8V3zm6 6h-4V5h4zm-6 4v8h8v-8zm6 6h-4v-4h4z"
}), 'GridView');

});

parcelRegister("3ytJg", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $296b9ba8285fcfec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $296b9ba8285fcfec$var$_createSvgIcon = $296b9ba8285fcfec$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $296b9ba8285fcfec$var$_default = module.exports.default = (0, $296b9ba8285fcfec$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"
}), 'Logout');

});

parcelRegister("gwjoH", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $c700d8a3a13e01e9$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $c700d8a3a13e01e9$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $c700d8a3a13e01e9$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "Navigate", () => $c700d8a3a13e01e9$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $c700d8a3a13e01e9$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $c700d8a3a13e01e9$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $c700d8a3a13e01e9$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "BrowserRouter", () => $c700d8a3a13e01e9$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $c700d8a3a13e01e9$export$a6c7ac8248d6e38a);
/**
 * react-router v7.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $c700d8a3a13e01e9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-LFPYN7LY.mjs"
});
var $c700d8a3a13e01e9$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $c700d8a3a13e01e9$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $c700d8a3a13e01e9$var$__typeError("Cannot " + msg);
var $c700d8a3a13e01e9$var$__privateGet = (obj, member, getter)=>($c700d8a3a13e01e9$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $c700d8a3a13e01e9$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $c700d8a3a13e01e9$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $c700d8a3a13e01e9$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($c700d8a3a13e01e9$export$e19cd5f9376f8cee || {});
var $c700d8a3a13e01e9$var$PopStateEventType = "popstate";
function $c700d8a3a13e01e9$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $c700d8a3a13e01e9$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $c700d8a3a13e01e9$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $c700d8a3a13e01e9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $c700d8a3a13e01e9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $c700d8a3a13e01e9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $c700d8a3a13e01e9$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $c700d8a3a13e01e9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    }
    return $c700d8a3a13e01e9$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $c700d8a3a13e01e9$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $c700d8a3a13e01e9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c700d8a3a13e01e9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $c700d8a3a13e01e9$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c700d8a3a13e01e9$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c700d8a3a13e01e9$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $c700d8a3a13e01e9$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $c700d8a3a13e01e9$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $c700d8a3a13e01e9$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c700d8a3a13e01e9$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $c700d8a3a13e01e9$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $c700d8a3a13e01e9$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c700d8a3a13e01e9$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $c700d8a3a13e01e9$var$isLocation(to) ? to : $c700d8a3a13e01e9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c700d8a3a13e01e9$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $c700d8a3a13e01e9$var$isLocation(to) ? to : $c700d8a3a13e01e9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c700d8a3a13e01e9$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $c700d8a3a13e01e9$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($c700d8a3a13e01e9$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($c700d8a3a13e01e9$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $c700d8a3a13e01e9$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $c700d8a3a13e01e9$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $c700d8a3a13e01e9$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $c700d8a3a13e01e9$var$_map;
var $c700d8a3a13e01e9$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $c700d8a3a13e01e9$var$__privateAdd(this, $c700d8a3a13e01e9$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($c700d8a3a13e01e9$var$__privateGet(this, $c700d8a3a13e01e9$var$_map).has(context)) return $c700d8a3a13e01e9$var$__privateGet(this, $c700d8a3a13e01e9$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $c700d8a3a13e01e9$var$__privateGet(this, $c700d8a3a13e01e9$var$_map).set(context, value);
    }
};
$c700d8a3a13e01e9$var$_map = new WeakMap();
var $c700d8a3a13e01e9$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c700d8a3a13e01e9$var$isUnsupportedLazyRouteObjectKey(key) {
    return $c700d8a3a13e01e9$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $c700d8a3a13e01e9$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $c700d8a3a13e01e9$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $c700d8a3a13e01e9$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $c700d8a3a13e01e9$var$isIndexRoute(route) {
    return route.index === true;
}
function $c700d8a3a13e01e9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c700d8a3a13e01e9$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $c700d8a3a13e01e9$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($c700d8a3a13e01e9$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $c700d8a3a13e01e9$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $c700d8a3a13e01e9$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $c700d8a3a13e01e9$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $c700d8a3a13e01e9$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $c700d8a3a13e01e9$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $c700d8a3a13e01e9$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c700d8a3a13e01e9$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c700d8a3a13e01e9$var$flattenRoutes(routes);
    $c700d8a3a13e01e9$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $c700d8a3a13e01e9$var$decodePath(pathname);
        matches = $c700d8a3a13e01e9$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $c700d8a3a13e01e9$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $c700d8a3a13e01e9$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $c700d8a3a13e01e9$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c700d8a3a13e01e9$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $c700d8a3a13e01e9$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c700d8a3a13e01e9$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $c700d8a3a13e01e9$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $c700d8a3a13e01e9$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c700d8a3a13e01e9$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c700d8a3a13e01e9$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $c700d8a3a13e01e9$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $c700d8a3a13e01e9$var$paramRe = /^:[\w-]+$/;
var $c700d8a3a13e01e9$var$dynamicSegmentValue = 3;
var $c700d8a3a13e01e9$var$indexRouteValue = 2;
var $c700d8a3a13e01e9$var$emptySegmentValue = 1;
var $c700d8a3a13e01e9$var$staticSegmentValue = 10;
var $c700d8a3a13e01e9$var$splatPenalty = -2;
var $c700d8a3a13e01e9$var$isSplat = (s)=>s === "*";
function $c700d8a3a13e01e9$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c700d8a3a13e01e9$var$isSplat)) initialScore += $c700d8a3a13e01e9$var$splatPenalty;
    if (index) initialScore += $c700d8a3a13e01e9$var$indexRouteValue;
    return segments.filter((s)=>!$c700d8a3a13e01e9$var$isSplat(s)).reduce((score, segment)=>score + ($c700d8a3a13e01e9$var$paramRe.test(segment) ? $c700d8a3a13e01e9$var$dynamicSegmentValue : segment === "" ? $c700d8a3a13e01e9$var$emptySegmentValue : $c700d8a3a13e01e9$var$staticSegmentValue), initialScore);
}
function $c700d8a3a13e01e9$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c700d8a3a13e01e9$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c700d8a3a13e01e9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $c700d8a3a13e01e9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c700d8a3a13e01e9$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c700d8a3a13e01e9$var$normalizePathname($c700d8a3a13e01e9$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c700d8a3a13e01e9$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $c700d8a3a13e01e9$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c700d8a3a13e01e9$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $c700d8a3a13e01e9$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $c700d8a3a13e01e9$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $c700d8a3a13e01e9$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c700d8a3a13e01e9$var$compilePath(path, caseSensitive = false, end = true) {
    $c700d8a3a13e01e9$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $c700d8a3a13e01e9$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $c700d8a3a13e01e9$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $c700d8a3a13e01e9$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $c700d8a3a13e01e9$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
        basename,
        pathname
    ]);
}
var $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c700d8a3a13e01e9$var$isAbsoluteUrl = (url)=>$c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX.test(url);
function $c700d8a3a13e01e9$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = toPathname.replace(/\/\/+/g, "/");
        if (toPathname.startsWith("/")) pathname = $c700d8a3a13e01e9$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $c700d8a3a13e01e9$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $c700d8a3a13e01e9$var$normalizeSearch(search),
        hash: $c700d8a3a13e01e9$var$normalizeHash(hash)
    };
}
function $c700d8a3a13e01e9$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c700d8a3a13e01e9$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $c700d8a3a13e01e9$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $c700d8a3a13e01e9$var$getResolveToMatches(matches) {
    let pathMatches = $c700d8a3a13e01e9$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $c700d8a3a13e01e9$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $c700d8a3a13e01e9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $c700d8a3a13e01e9$var$getInvalidPathError("?", "pathname", "search", to));
        $c700d8a3a13e01e9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $c700d8a3a13e01e9$var$getInvalidPathError("#", "pathname", "hash", to));
        $c700d8a3a13e01e9$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $c700d8a3a13e01e9$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c700d8a3a13e01e9$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $c700d8a3a13e01e9$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $c700d8a3a13e01e9$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $c700d8a3a13e01e9$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $c700d8a3a13e01e9$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $c700d8a3a13e01e9$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $c700d8a3a13e01e9$export$4051a07651545597(data2, init) {
    return new $c700d8a3a13e01e9$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $c700d8a3a13e01e9$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $c700d8a3a13e01e9$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $c700d8a3a13e01e9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $c700d8a3a13e01e9$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $c700d8a3a13e01e9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $c700d8a3a13e01e9$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $c700d8a3a13e01e9$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $c700d8a3a13e01e9$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $c700d8a3a13e01e9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $c700d8a3a13e01e9$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($c700d8a3a13e01e9$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $c700d8a3a13e01e9$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $c700d8a3a13e01e9$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $c700d8a3a13e01e9$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $c700d8a3a13e01e9$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $c700d8a3a13e01e9$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $c700d8a3a13e01e9$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $c700d8a3a13e01e9$var$wrapImpl(aggregated[key], original, (...args)=>$c700d8a3a13e01e9$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $c700d8a3a13e01e9$var$wrapImpl(aggregated.middleware, original, (...args)=>$c700d8a3a13e01e9$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $c700d8a3a13e01e9$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $c700d8a3a13e01e9$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $c700d8a3a13e01e9$export$fe53371bee54353d(to) : ".",
                ...$c700d8a3a13e01e9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $c700d8a3a13e01e9$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$c700d8a3a13e01e9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $c700d8a3a13e01e9$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $c700d8a3a13e01e9$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $c700d8a3a13e01e9$var$getReadonlyRequest(request),
            context: context != null ? $c700d8a3a13e01e9$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $c700d8a3a13e01e9$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $c700d8a3a13e01e9$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $c700d8a3a13e01e9$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $c700d8a3a13e01e9$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $c700d8a3a13e01e9$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $c700d8a3a13e01e9$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $c700d8a3a13e01e9$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $c700d8a3a13e01e9$var$getReadonlyContext(context)
    };
}
function $c700d8a3a13e01e9$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $c700d8a3a13e01e9$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $c700d8a3a13e01e9$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $c700d8a3a13e01e9$var$getReadonlyContext(context) {
    if ($c700d8a3a13e01e9$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $c700d8a3a13e01e9$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $c700d8a3a13e01e9$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $c700d8a3a13e01e9$var$objectProtoNames;
}
// lib/router/router.ts
var $c700d8a3a13e01e9$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $c700d8a3a13e01e9$var$validMutationMethods = new Set($c700d8a3a13e01e9$var$validMutationMethodsArr);
var $c700d8a3a13e01e9$var$validRequestMethodsArr = [
    "GET",
    ...$c700d8a3a13e01e9$var$validMutationMethodsArr
];
var $c700d8a3a13e01e9$var$validRequestMethods = new Set($c700d8a3a13e01e9$var$validRequestMethodsArr);
var $c700d8a3a13e01e9$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $c700d8a3a13e01e9$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $c700d8a3a13e01e9$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $c700d8a3a13e01e9$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $c700d8a3a13e01e9$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $c700d8a3a13e01e9$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $c700d8a3a13e01e9$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $c700d8a3a13e01e9$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $c700d8a3a13e01e9$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $c700d8a3a13e01e9$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $c700d8a3a13e01e9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$c700d8a3a13e01e9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $c700d8a3a13e01e9$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c700d8a3a13e01e9$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = relevantMatches.every((m)=>{
                let status = $c700d8a3a13e01e9$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                return !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $c700d8a3a13e01e9$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $c700d8a3a13e01e9$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $c700d8a3a13e01e9$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $c700d8a3a13e01e9$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$c700d8a3a13e01e9$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c700d8a3a13e01e9$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $c700d8a3a13e01e9$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $c700d8a3a13e01e9$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c700d8a3a13e01e9$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $c700d8a3a13e01e9$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $c700d8a3a13e01e9$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $c700d8a3a13e01e9$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $c700d8a3a13e01e9$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $c700d8a3a13e01e9$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $c700d8a3a13e01e9$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $c700d8a3a13e01e9$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $c700d8a3a13e01e9$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $c700d8a3a13e01e9$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($c700d8a3a13e01e9$var$isErrorResult(result) && $c700d8a3a13e01e9$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $c700d8a3a13e01e9$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$c700d8a3a13e01e9$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $c700d8a3a13e01e9$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $c700d8a3a13e01e9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $c700d8a3a13e01e9$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $c700d8a3a13e01e9$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $c700d8a3a13e01e9$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $c700d8a3a13e01e9$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $c700d8a3a13e01e9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $c700d8a3a13e01e9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$c700d8a3a13e01e9$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $c700d8a3a13e01e9$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $c700d8a3a13e01e9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $c700d8a3a13e01e9$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $c700d8a3a13e01e9$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c700d8a3a13e01e9$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $c700d8a3a13e01e9$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c700d8a3a13e01e9$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $c700d8a3a13e01e9$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($c700d8a3a13e01e9$var$isRedirectResult(actionResult) || $c700d8a3a13e01e9$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($c700d8a3a13e01e9$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $c700d8a3a13e01e9$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($c700d8a3a13e01e9$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c700d8a3a13e01e9$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c700d8a3a13e01e9$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $c700d8a3a13e01e9$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $c700d8a3a13e01e9$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $c700d8a3a13e01e9$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $c700d8a3a13e01e9$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $c700d8a3a13e01e9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $c700d8a3a13e01e9$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $c700d8a3a13e01e9$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c700d8a3a13e01e9$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $c700d8a3a13e01e9$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
            return;
        }
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $c700d8a3a13e01e9$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $c700d8a3a13e01e9$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $c700d8a3a13e01e9$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($c700d8a3a13e01e9$var$isAbsoluteUrl(location)) {
                const url = $c700d8a3a13e01e9$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $c700d8a3a13e01e9$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $c700d8a3a13e01e9$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($c700d8a3a13e01e9$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $c700d8a3a13e01e9$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $c700d8a3a13e01e9$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($c700d8a3a13e01e9$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $c700d8a3a13e01e9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $c700d8a3a13e01e9$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $c700d8a3a13e01e9$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $c700d8a3a13e01e9$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c700d8a3a13e01e9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c700d8a3a13e01e9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c700d8a3a13e01e9$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c700d8a3a13e01e9$export$386d57f03f0b2883;
        $c700d8a3a13e01e9$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $c700d8a3a13e01e9$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $c700d8a3a13e01e9$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$c700d8a3a13e01e9$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $c700d8a3a13e01e9$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $c700d8a3a13e01e9$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $c700d8a3a13e01e9$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $c700d8a3a13e01e9$export$3336b097a6fbc59a(routes, opts) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $c700d8a3a13e01e9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$c700d8a3a13e01e9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $c700d8a3a13e01e9$var$createLocation("", $c700d8a3a13e01e9$export$fe53371bee54353d(url), null, "default");
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        if (!$c700d8a3a13e01e9$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(requestContext instanceof $c700d8a3a13e01e9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $c700d8a3a13e01e9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $c700d8a3a13e01e9$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($c700d8a3a13e01e9$export$6e80290866a84dd4(error)) return error;
                    if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $c700d8a3a13e01e9$export$f2680fa305b734ca(error.status, error.statusText, await $c700d8a3a13e01e9$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(error)) error = $c700d8a3a13e01e9$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $c700d8a3a13e01e9$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $c700d8a3a13e01e9$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $c700d8a3a13e01e9$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $c700d8a3a13e01e9$var$createLocation("", $c700d8a3a13e01e9$export$fe53371bee54353d(url), null, "default");
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        if (!$c700d8a3a13e01e9$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c700d8a3a13e01e9$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c700d8a3a13e01e9$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c700d8a3a13e01e9$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(requestContext instanceof $c700d8a3a13e01e9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $c700d8a3a13e01e9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $c700d8a3a13e01e9$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($c700d8a3a13e01e9$var$dataWithResponseInitToResponse(error));
                if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $c700d8a3a13e01e9$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $c700d8a3a13e01e9$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($c700d8a3a13e01e9$var$isDataStrategyResult(e) && $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($c700d8a3a13e01e9$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $c700d8a3a13e01e9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($c700d8a3a13e01e9$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c700d8a3a13e01e9$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c700d8a3a13e01e9$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $c700d8a3a13e01e9$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $c700d8a3a13e01e9$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $c700d8a3a13e01e9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $c700d8a3a13e01e9$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $c700d8a3a13e01e9$var$callDataStrategyImpl(dataStrategy || $c700d8a3a13e01e9$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($c700d8a3a13e01e9$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $c700d8a3a13e01e9$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result.result)) throw $c700d8a3a13e01e9$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $c700d8a3a13e01e9$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $c700d8a3a13e01e9$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $c700d8a3a13e01e9$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $c700d8a3a13e01e9$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $c700d8a3a13e01e9$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $c700d8a3a13e01e9$var$resolveTo(to ? to : ".", $c700d8a3a13e01e9$var$getResolveToMatches(contextualMatches), $c700d8a3a13e01e9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $c700d8a3a13e01e9$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $c700d8a3a13e01e9$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $c700d8a3a13e01e9$export$fe53371bee54353d(path);
}
function $c700d8a3a13e01e9$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$c700d8a3a13e01e9$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c700d8a3a13e01e9$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c700d8a3a13e01e9$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $c700d8a3a13e01e9$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $c700d8a3a13e01e9$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$c700d8a3a13e01e9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$c700d8a3a13e01e9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $c700d8a3a13e01e9$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $c700d8a3a13e01e9$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $c700d8a3a13e01e9$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $c700d8a3a13e01e9$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $c700d8a3a13e01e9$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $c700d8a3a13e01e9$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $c700d8a3a13e01e9$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $c700d8a3a13e01e9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $c700d8a3a13e01e9$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $c700d8a3a13e01e9$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($c700d8a3a13e01e9$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($c700d8a3a13e01e9$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $c700d8a3a13e01e9$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $c700d8a3a13e01e9$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($c700d8a3a13e01e9$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $c700d8a3a13e01e9$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $c700d8a3a13e01e9$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $c700d8a3a13e01e9$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c700d8a3a13e01e9$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $c700d8a3a13e01e9$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $c700d8a3a13e01e9$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$c700d8a3a13e01e9$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $c700d8a3a13e01e9$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $c700d8a3a13e01e9$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$c700d8a3a13e01e9$var$isSameRoute(aChild, bChild))) ?? false;
}
var $c700d8a3a13e01e9$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $c700d8a3a13e01e9$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $c700d8a3a13e01e9$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $c700d8a3a13e01e9$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $c700d8a3a13e01e9$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $c700d8a3a13e01e9$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $c700d8a3a13e01e9$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $c700d8a3a13e01e9$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $c700d8a3a13e01e9$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $c700d8a3a13e01e9$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $c700d8a3a13e01e9$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $c700d8a3a13e01e9$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $c700d8a3a13e01e9$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $c700d8a3a13e01e9$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $c700d8a3a13e01e9$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $c700d8a3a13e01e9$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $c700d8a3a13e01e9$var$isNonNullable(value) {
    return value !== void 0;
}
function $c700d8a3a13e01e9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $c700d8a3a13e01e9$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($c700d8a3a13e01e9$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $c700d8a3a13e01e9$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $c700d8a3a13e01e9$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $c700d8a3a13e01e9$var$defaultDataStrategy(args);
    return $c700d8a3a13e01e9$var$runClientMiddlewarePipeline(args, ()=>$c700d8a3a13e01e9$var$defaultDataStrategy(args));
}
function $c700d8a3a13e01e9$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $c700d8a3a13e01e9$var$runMiddlewarePipeline(args, handler, processResult, $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result) ? $c700d8a3a13e01e9$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $c700d8a3a13e01e9$var$runClientMiddlewarePipeline(args, handler) {
    return $c700d8a3a13e01e9$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($c700d8a3a13e01e9$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $c700d8a3a13e01e9$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $c700d8a3a13e01e9$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $c700d8a3a13e01e9$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $c700d8a3a13e01e9$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $c700d8a3a13e01e9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $c700d8a3a13e01e9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $c700d8a3a13e01e9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $c700d8a3a13e01e9$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $c700d8a3a13e01e9$var$loadLazyRoute(match.route, $c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $c700d8a3a13e01e9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $c700d8a3a13e01e9$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $c700d8a3a13e01e9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $c700d8a3a13e01e9$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $c700d8a3a13e01e9$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $c700d8a3a13e01e9$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $c700d8a3a13e01e9$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $c700d8a3a13e01e9$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $c700d8a3a13e01e9$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $c700d8a3a13e01e9$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $c700d8a3a13e01e9$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $c700d8a3a13e01e9$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $c700d8a3a13e01e9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $c700d8a3a13e01e9$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$c700d8a3a13e01e9$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $c700d8a3a13e01e9$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $c700d8a3a13e01e9$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($c700d8a3a13e01e9$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $c700d8a3a13e01e9$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $c700d8a3a13e01e9$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c700d8a3a13e01e9$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $c700d8a3a13e01e9$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $c700d8a3a13e01e9$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $c700d8a3a13e01e9$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $c700d8a3a13e01e9$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $c700d8a3a13e01e9$export$f5708dca728d7177(!$c700d8a3a13e01e9$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $c700d8a3a13e01e9$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $c700d8a3a13e01e9$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c700d8a3a13e01e9$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $c700d8a3a13e01e9$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $c700d8a3a13e01e9$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($c700d8a3a13e01e9$var$isRedirectResult(result)) $c700d8a3a13e01e9$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $c700d8a3a13e01e9$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c700d8a3a13e01e9$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $c700d8a3a13e01e9$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $c700d8a3a13e01e9$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $c700d8a3a13e01e9$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c700d8a3a13e01e9$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c700d8a3a13e01e9$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $c700d8a3a13e01e9$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $c700d8a3a13e01e9$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $c700d8a3a13e01e9$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(path) : path;
    return $c700d8a3a13e01e9$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $c700d8a3a13e01e9$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $c700d8a3a13e01e9$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $c700d8a3a13e01e9$var$dataWithResponseInitToErrorResponse(data2) {
    return new $c700d8a3a13e01e9$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $c700d8a3a13e01e9$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $c700d8a3a13e01e9$var$isDataStrategyResult(value));
}
function $c700d8a3a13e01e9$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $c700d8a3a13e01e9$var$isRedirectDataStrategyResult(result) {
    return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result.result) && $c700d8a3a13e01e9$var$redirectStatusCodes.has(result.result.status);
}
function $c700d8a3a13e01e9$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $c700d8a3a13e01e9$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c700d8a3a13e01e9$export$794b2760043cf8cd(statusCode) {
    return $c700d8a3a13e01e9$var$redirectStatusCodes.has(statusCode);
}
function $c700d8a3a13e01e9$export$6e80290866a84dd4(result) {
    return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result) && $c700d8a3a13e01e9$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $c700d8a3a13e01e9$var$isValidMethod(method) {
    return $c700d8a3a13e01e9$var$validRequestMethods.has(method.toUpperCase());
}
function $c700d8a3a13e01e9$export$cbae47800eb95bc3(method) {
    return $c700d8a3a13e01e9$var$validMutationMethods.has(method.toUpperCase());
}
function $c700d8a3a13e01e9$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $c700d8a3a13e01e9$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c700d8a3a13e01e9$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $c700d8a3a13e01e9$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $c700d8a3a13e01e9$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $c700d8a3a13e01e9$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $c700d8a3a13e01e9$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $c700d8a3a13e01e9$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $c700d8a3a13e01e9$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $c700d8a3a13e01e9$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $c700d8a3a13e01e9$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($c700d8a3a13e01e9$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $c700d8a3a13e01e9$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($c700d8a3a13e01e9$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $c700d8a3a13e01e9$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $c700d8a3a13e01e9$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $c700d8a3a13e01e9$export$2eeee58951ff3c1c = $acw62.createContext(null);
$c700d8a3a13e01e9$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $c700d8a3a13e01e9$export$315e3ffb01f217 = $acw62.createContext(null);
$c700d8a3a13e01e9$export$315e3ffb01f217.displayName = "DataRouterState";
var $c700d8a3a13e01e9$export$717f757c655223f1 = $acw62.createContext(false);
function $c700d8a3a13e01e9$var$useIsRSCRouterContext() {
    return $acw62.useContext($c700d8a3a13e01e9$export$717f757c655223f1);
}
var $c700d8a3a13e01e9$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$c700d8a3a13e01e9$export$3681f408decb40d1.displayName = "ViewTransition";
var $c700d8a3a13e01e9$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$c700d8a3a13e01e9$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $c700d8a3a13e01e9$var$AwaitContext = $acw62.createContext(null);
$c700d8a3a13e01e9$var$AwaitContext.displayName = "Await";
var $c700d8a3a13e01e9$export$2666c20e15407622 = (props)=>$acw62.createElement($c700d8a3a13e01e9$var$AwaitContext.Provider, props);
var $c700d8a3a13e01e9$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$c700d8a3a13e01e9$export$3044ab7fdabeaee6.displayName = "Navigation";
var $c700d8a3a13e01e9$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$c700d8a3a13e01e9$export$e6a44b110a0c44d3.displayName = "Location";
var $c700d8a3a13e01e9$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$c700d8a3a13e01e9$export$aac280ed165a4397.displayName = "Route";
var $c700d8a3a13e01e9$var$RouteErrorContext = $acw62.createContext(null);
$c700d8a3a13e01e9$var$RouteErrorContext.displayName = "RouteError";
var $c700d8a3a13e01e9$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $c700d8a3a13e01e9$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $c700d8a3a13e01e9$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $c700d8a3a13e01e9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $c700d8a3a13e01e9$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$c700d8a3a13e01e9$var$ERROR_DIGEST_BASE}:${$c700d8a3a13e01e9$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $c700d8a3a13e01e9$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$c700d8a3a13e01e9$var$ERROR_DIGEST_BASE}:${$c700d8a3a13e01e9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $c700d8a3a13e01e9$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $c700d8a3a13e01e9$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $c700d8a3a13e01e9$export$9c954a9d03d32f4a() {
    return $acw62.useContext($c700d8a3a13e01e9$export$e6a44b110a0c44d3) != null;
}
function $c700d8a3a13e01e9$export$45d76561a5302f2b() {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($c700d8a3a13e01e9$export$e6a44b110a0c44d3).location;
}
function $c700d8a3a13e01e9$export$1b3f31771c5d07c() {
    return $acw62.useContext($c700d8a3a13e01e9$export$e6a44b110a0c44d3).navigationType;
}
function $c700d8a3a13e01e9$export$6c330e8992e8a295(pattern) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$c700d8a3a13e01e9$export$81336c211d5ff295(pattern, $c700d8a3a13e01e9$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $c700d8a3a13e01e9$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $c700d8a3a13e01e9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $c700d8a3a13e01e9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    return isDataRoute ? $c700d8a3a13e01e9$var$useNavigateStable() : $c700d8a3a13e01e9$var$useNavigateUnstable();
}
function $c700d8a3a13e01e9$var$useNavigateUnstable() {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($c700d8a3a13e01e9$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $c700d8a3a13e01e9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $c700d8a3a13e01e9$var$warning(activeRef.current, $c700d8a3a13e01e9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $c700d8a3a13e01e9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $c700d8a3a13e01e9$var$OutletContext = $acw62.createContext(null);
function $c700d8a3a13e01e9$export$4138103a3ae699cc() {
    return $acw62.useContext($c700d8a3a13e01e9$var$OutletContext);
}
function $c700d8a3a13e01e9$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $c700d8a3a13e01e9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($c700d8a3a13e01e9$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$c700d8a3a13e01e9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $c700d8a3a13e01e9$export$5d3fca4a98652595(routes, locationArg) {
    return $c700d8a3a13e01e9$var$useRoutesImpl(routes, locationArg);
}
function $c700d8a3a13e01e9$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $c700d8a3a13e01e9$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $c700d8a3a13e01e9$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
        $c700d8a3a13e01e9$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $c700d8a3a13e01e9$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $c700d8a3a13e01e9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $c700d8a3a13e01e9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $c700d8a3a13e01e9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $c700d8a3a13e01e9$var$DefaultErrorComponent() {
    let error = $c700d8a3a13e01e9$export$ed527bf60f6e05f2();
    let message = $c700d8a3a13e01e9$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $c700d8a3a13e01e9$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$DefaultErrorComponent, null);
var $c700d8a3a13e01e9$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $c700d8a3a13e01e9$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$c700d8a3a13e01e9$var$RenderErrorBoundary.contextType = $c700d8a3a13e01e9$export$717f757c655223f1;
var $c700d8a3a13e01e9$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $c700d8a3a13e01e9$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $c700d8a3a13e01e9$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $c700d8a3a13e01e9$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $c700d8a3a13e01e9$var$parseToInfo(redirect2.location, basename);
            if ($c700d8a3a13e01e9$var$isBrowser && !$c700d8a3a13e01e9$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $c700d8a3a13e01e9$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $c700d8a3a13e01e9$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $c700d8a3a13e01e9$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $c700d8a3a13e01e9$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $c700d8a3a13e01e9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $c700d8a3a13e01e9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $c700d8a3a13e01e9$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    $c700d8a3a13e01e9$export$f5708dca728d7177(ctx, $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $c700d8a3a13e01e9$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    $c700d8a3a13e01e9$export$f5708dca728d7177(state, $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName));
    return state;
}
function $c700d8a3a13e01e9$var$useRouteContext(hookName) {
    let route = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    $c700d8a3a13e01e9$export$f5708dca728d7177(route, $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName));
    return route;
}
function $c700d8a3a13e01e9$var$useCurrentRouteId(hookName) {
    let route = $c700d8a3a13e01e9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $c700d8a3a13e01e9$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $c700d8a3a13e01e9$var$useRouteId() {
    return $c700d8a3a13e01e9$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $c700d8a3a13e01e9$export$d0fd4b7106de2769() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $c700d8a3a13e01e9$export$600dc272ed516c15() {
    let dataRouterContext = $c700d8a3a13e01e9$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $c700d8a3a13e01e9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $c700d8a3a13e01e9$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$c700d8a3a13e01e9$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $c700d8a3a13e01e9$export$1448a5050d252c4d() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $c700d8a3a13e01e9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $c700d8a3a13e01e9$export$fd5d37484eab868d(routeId) {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $c700d8a3a13e01e9$export$fdc00f3f26066d5e() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $c700d8a3a13e01e9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $c700d8a3a13e01e9$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($c700d8a3a13e01e9$var$RouteErrorContext);
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $c700d8a3a13e01e9$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $c700d8a3a13e01e9$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($c700d8a3a13e01e9$var$AwaitContext);
    return value?._data;
}
function $c700d8a3a13e01e9$export$17f53340677d5831() {
    let value = $acw62.useContext($c700d8a3a13e01e9$var$AwaitContext);
    return value?._error;
}
var $c700d8a3a13e01e9$var$blockerId = 0;
function $c700d8a3a13e01e9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $c700d8a3a13e01e9$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $c700d8a3a13e01e9$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $c700d8a3a13e01e9$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$c700d8a3a13e01e9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $c700d8a3a13e01e9$export$386d57f03f0b2883;
}
function $c700d8a3a13e01e9$var$useNavigateStable() {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $c700d8a3a13e01e9$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $c700d8a3a13e01e9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $c700d8a3a13e01e9$var$warning(activeRef.current, $c700d8a3a13e01e9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $c700d8a3a13e01e9$var$alreadyWarned = {};
function $c700d8a3a13e01e9$var$warningOnce(key, cond, message) {
    if (!cond && !$c700d8a3a13e01e9$var$alreadyWarned[key]) {
        $c700d8a3a13e01e9$var$alreadyWarned[key] = true;
        $c700d8a3a13e01e9$var$warning(false, message);
    }
}
function $c700d8a3a13e01e9$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $c700d8a3a13e01e9$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $c700d8a3a13e01e9$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $c700d8a3a13e01e9$var$alreadyWarned2 = {};
function $c700d8a3a13e01e9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$c700d8a3a13e01e9$var$alreadyWarned2[message]) {
        $c700d8a3a13e01e9$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $c700d8a3a13e01e9$var$USE_OPTIMISTIC = "useOptimistic";
var $c700d8a3a13e01e9$var$useOptimisticImpl = $acw62[$c700d8a3a13e01e9$var$USE_OPTIMISTIC];
var $c700d8a3a13e01e9$var$stableUseOptimisticSetter = ()=>void 0;
function $c700d8a3a13e01e9$var$useOptimisticSafe(val) {
    if ($c700d8a3a13e01e9$var$useOptimisticImpl) return $c700d8a3a13e01e9$var$useOptimisticImpl(val);
    else return [
        val,
        $c700d8a3a13e01e9$var$stableUseOptimisticSetter
    ];
}
function $c700d8a3a13e01e9$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
            if (route.element) $c700d8a3a13e01e9$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $c700d8a3a13e01e9$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
            if (route.errorElement) $c700d8a3a13e01e9$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $c700d8a3a13e01e9$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $c700d8a3a13e01e9$export$f30f7e456d254e83(routes, opts) {
    return $c700d8a3a13e01e9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $c700d8a3a13e01e9$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $c700d8a3a13e01e9$export$e2fd2c03906469db,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $c700d8a3a13e01e9$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $c700d8a3a13e01e9$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $c700d8a3a13e01e9$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $c700d8a3a13e01e9$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $c700d8a3a13e01e9$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $c700d8a3a13e01e9$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$c700d8a3a13e01e9$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c700d8a3a13e01e9$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$c700d8a3a13e01e9$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $c700d8a3a13e01e9$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $c700d8a3a13e01e9$var$MemoizedDataRoutes = $acw62.memo($c700d8a3a13e01e9$var$DataRoutes);
function $c700d8a3a13e01e9$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $c700d8a3a13e01e9$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $c700d8a3a13e01e9$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $c700d8a3a13e01e9$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $c700d8a3a13e01e9$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    $c700d8a3a13e01e9$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let navigate = $c700d8a3a13e01e9$export$9770f232ac06a008();
    let path = $c700d8a3a13e01e9$var$resolveTo(to, $c700d8a3a13e01e9$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $c700d8a3a13e01e9$export$910ae8079b2c2852(props) {
    return $c700d8a3a13e01e9$export$a3be3530d8e40d0b(props.context);
}
function $c700d8a3a13e01e9$export$e7b0ac011bb776c6(props) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $c700d8a3a13e01e9$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(!$c700d8a3a13e01e9$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $c700d8a3a13e01e9$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $c700d8a3a13e01e9$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $c700d8a3a13e01e9$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $c700d8a3a13e01e9$export$5d3fca4a98652595($c700d8a3a13e01e9$export$16da398f5434bdec(children), location);
}
function $c700d8a3a13e01e9$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$ResolveAwait, null, children));
}
var $c700d8a3a13e01e9$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $c700d8a3a13e01e9$var$ResolveAwait({ children: children }) {
    let data2 = $c700d8a3a13e01e9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $c700d8a3a13e01e9$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $c700d8a3a13e01e9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $c700d8a3a13e01e9$export$f5708dca728d7177(element.type === $c700d8a3a13e01e9$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $c700d8a3a13e01e9$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $c700d8a3a13e01e9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $c700d8a3a13e01e9$export$9b5b6d122dea0c88 = $c700d8a3a13e01e9$export$16da398f5434bdec;
function $c700d8a3a13e01e9$export$daf73786167a7f72(matches) {
    return $c700d8a3a13e01e9$var$_renderMatches(matches);
}
function $c700d8a3a13e01e9$var$useRouteComponentProps() {
    return {
        params: $c700d8a3a13e01e9$export$99eaa27ddbbb95ef(),
        loaderData: $c700d8a3a13e01e9$export$1448a5050d252c4d(),
        actionData: $c700d8a3a13e01e9$export$fdc00f3f26066d5e(),
        matches: $c700d8a3a13e01e9$export$2378eb7f5ff86053()
    };
}
function $c700d8a3a13e01e9$export$6c4f3826290c37af({ children: children }) {
    const props = $c700d8a3a13e01e9$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $c700d8a3a13e01e9$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $c700d8a3a13e01e9$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $c700d8a3a13e01e9$var$useHydrateFallbackProps() {
    return {
        params: $c700d8a3a13e01e9$export$99eaa27ddbbb95ef(),
        loaderData: $c700d8a3a13e01e9$export$1448a5050d252c4d(),
        actionData: $c700d8a3a13e01e9$export$fdc00f3f26066d5e()
    };
}
function $c700d8a3a13e01e9$export$f8cff34f39c1932a({ children: children }) {
    const props = $c700d8a3a13e01e9$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $c700d8a3a13e01e9$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $c700d8a3a13e01e9$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $c700d8a3a13e01e9$var$useErrorBoundaryProps() {
    return {
        params: $c700d8a3a13e01e9$export$99eaa27ddbbb95ef(),
        loaderData: $c700d8a3a13e01e9$export$1448a5050d252c4d(),
        actionData: $c700d8a3a13e01e9$export$fdc00f3f26066d5e(),
        error: $c700d8a3a13e01e9$export$ed527bf60f6e05f2()
    };
}
function $c700d8a3a13e01e9$export$e5afde5c4b6d747b({ children: children }) {
    const props = $c700d8a3a13e01e9$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $c700d8a3a13e01e9$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $c700d8a3a13e01e9$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $c700d8a3a13e01e9$var$defaultMethod = "get";
var $c700d8a3a13e01e9$var$defaultEncType = "application/x-www-form-urlencoded";
function $c700d8a3a13e01e9$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $c700d8a3a13e01e9$var$isButtonElement(object) {
    return $c700d8a3a13e01e9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c700d8a3a13e01e9$var$isFormElement(object) {
    return $c700d8a3a13e01e9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c700d8a3a13e01e9$var$isInputElement(object) {
    return $c700d8a3a13e01e9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c700d8a3a13e01e9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c700d8a3a13e01e9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c700d8a3a13e01e9$var$isModifiedEvent(event);
}
function $c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c700d8a3a13e01e9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $c700d8a3a13e01e9$var$_formDataSupportsSubmitter = null;
function $c700d8a3a13e01e9$var$isFormDataSubmitterSupported() {
    if ($c700d8a3a13e01e9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c700d8a3a13e01e9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c700d8a3a13e01e9$var$_formDataSupportsSubmitter = true;
    }
    return $c700d8a3a13e01e9$var$_formDataSupportsSubmitter;
}
var $c700d8a3a13e01e9$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c700d8a3a13e01e9$var$getFormEncType(encType) {
    if (encType != null && !$c700d8a3a13e01e9$var$supportedFormEncTypes.has(encType)) {
        $c700d8a3a13e01e9$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$c700d8a3a13e01e9$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $c700d8a3a13e01e9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c700d8a3a13e01e9$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $c700d8a3a13e01e9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $c700d8a3a13e01e9$var$defaultMethod;
        encType = $c700d8a3a13e01e9$var$getFormEncType(target.getAttribute("enctype")) || $c700d8a3a13e01e9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c700d8a3a13e01e9$var$isButtonElement(target) || $c700d8a3a13e01e9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $c700d8a3a13e01e9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c700d8a3a13e01e9$var$defaultMethod;
        encType = $c700d8a3a13e01e9$var$getFormEncType(target.getAttribute("formenctype")) || $c700d8a3a13e01e9$var$getFormEncType(form.getAttribute("enctype")) || $c700d8a3a13e01e9$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$c700d8a3a13e01e9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c700d8a3a13e01e9$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $c700d8a3a13e01e9$var$defaultMethod;
        action = null;
        encType = $c700d8a3a13e01e9$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $c700d8a3a13e01e9$var$HOLE = -1;
var $c700d8a3a13e01e9$var$NAN = -2;
var $c700d8a3a13e01e9$var$NEGATIVE_INFINITY = -3;
var $c700d8a3a13e01e9$var$NEGATIVE_ZERO = -4;
var $c700d8a3a13e01e9$var$NULL = -5;
var $c700d8a3a13e01e9$var$POSITIVE_INFINITY = -6;
var $c700d8a3a13e01e9$var$UNDEFINED = -7;
var $c700d8a3a13e01e9$var$TYPE_BIGINT = "B";
var $c700d8a3a13e01e9$var$TYPE_DATE = "D";
var $c700d8a3a13e01e9$var$TYPE_ERROR = "E";
var $c700d8a3a13e01e9$var$TYPE_MAP = "M";
var $c700d8a3a13e01e9$var$TYPE_NULL_OBJECT = "N";
var $c700d8a3a13e01e9$var$TYPE_PROMISE = "P";
var $c700d8a3a13e01e9$var$TYPE_REGEXP = "R";
var $c700d8a3a13e01e9$var$TYPE_SET = "S";
var $c700d8a3a13e01e9$var$TYPE_SYMBOL = "Y";
var $c700d8a3a13e01e9$var$TYPE_URL = "U";
var $c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $c700d8a3a13e01e9$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $c700d8a3a13e01e9$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $c700d8a3a13e01e9$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $c700d8a3a13e01e9$var$UNDEFINED;
    if (input === null) return $c700d8a3a13e01e9$var$NULL;
    if (Number.isNaN(input)) return $c700d8a3a13e01e9$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $c700d8a3a13e01e9$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $c700d8a3a13e01e9$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $c700d8a3a13e01e9$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $c700d8a3a13e01e9$var$stringify.call(this, input, index);
    return index;
}
function $c700d8a3a13e01e9$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$c700d8a3a13e01e9$var$flatten.call(this, k)}":${$c700d8a3a13e01e9$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$c700d8a3a13e01e9$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c700d8a3a13e01e9$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $c700d8a3a13e01e9$var$flatten.call(this, input2[i]) : $c700d8a3a13e01e9$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$c700d8a3a13e01e9$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $c700d8a3a13e01e9$var$flatten.call(this, k),
                                    $c700d8a3a13e01e9$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($c700d8a3a13e01e9$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c700d8a3a13e01e9$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c700d8a3a13e01e9$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $c700d8a3a13e01e9$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $c700d8a3a13e01e9$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $c700d8a3a13e01e9$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $c700d8a3a13e01e9$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $c700d8a3a13e01e9$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $c700d8a3a13e01e9$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $c700d8a3a13e01e9$var$hydrate.call(this, startIndex);
}
function $c700d8a3a13e01e9$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $c700d8a3a13e01e9$var$UNDEFINED:
                set(void 0);
                continue;
            case $c700d8a3a13e01e9$var$NULL:
                set(null);
                continue;
            case $c700d8a3a13e01e9$var$NAN:
                set(NaN);
                continue;
            case $c700d8a3a13e01e9$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $c700d8a3a13e01e9$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $c700d8a3a13e01e9$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $c700d8a3a13e01e9$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $c700d8a3a13e01e9$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $c700d8a3a13e01e9$var$globalObj && $c700d8a3a13e01e9$var$globalObj[errorType] ? new $c700d8a3a13e01e9$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $c700d8a3a13e01e9$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $c700d8a3a13e01e9$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $c700d8a3a13e01e9$var$Deferred2();
    const reader = readable.pipeThrough($c700d8a3a13e01e9$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $c700d8a3a13e01e9$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $c700d8a3a13e01e9$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $c700d8a3a13e01e9$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $c700d8a3a13e01e9$var$unflatten.call(this, line)
    };
}
async function $c700d8a3a13e01e9$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $c700d8a3a13e01e9$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $c700d8a3a13e01e9$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $c700d8a3a13e01e9$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $c700d8a3a13e01e9$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $c700d8a3a13e01e9$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal, onComplete: onComplete } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $c700d8a3a13e01e9$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $c700d8a3a13e01e9$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_PROMISE}${deferredId}:[["${$c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $c700d8a3a13e01e9$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_ERROR}${deferredId}:[["${$c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            onComplete?.();
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $c700d8a3a13e01e9$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $c700d8a3a13e01e9$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $c700d8a3a13e01e9$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $c700d8a3a13e01e9$export$4cf11838cdc2a8a8(html) {
    return html.replace($c700d8a3a13e01e9$var$ESCAPE_REGEX, (match)=>$c700d8a3a13e01e9$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $c700d8a3a13e01e9$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $c700d8a3a13e01e9$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $c700d8a3a13e01e9$var$SingleFetchNoResultError = class extends Error {
};
var $c700d8a3a13e01e9$export$ae9272e641ead836 = 202;
var $c700d8a3a13e01e9$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $c700d8a3a13e01e9$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $c700d8a3a13e01e9$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $c700d8a3a13e01e9$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $c700d8a3a13e01e9$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $c700d8a3a13e01e9$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $c700d8a3a13e01e9$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $c700d8a3a13e01e9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $c700d8a3a13e01e9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $c700d8a3a13e01e9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $c700d8a3a13e01e9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $c700d8a3a13e01e9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $c700d8a3a13e01e9$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result.result) || $c700d8a3a13e01e9$export$972111febbeef05b(result.result) || $c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $c700d8a3a13e01e9$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $c700d8a3a13e01e9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $c700d8a3a13e01e9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$c700d8a3a13e01e9$var$createDeferred2());
    let singleFetchDfd = $c700d8a3a13e01e9$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $c700d8a3a13e01e9$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $c700d8a3a13e01e9$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $c700d8a3a13e01e9$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $c700d8a3a13e01e9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $c700d8a3a13e01e9$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $c700d8a3a13e01e9$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $c700d8a3a13e01e9$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $c700d8a3a13e01e9$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $c700d8a3a13e01e9$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $c700d8a3a13e01e9$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $c700d8a3a13e01e9$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $c700d8a3a13e01e9$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $c700d8a3a13e01e9$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $c700d8a3a13e01e9$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($c700d8a3a13e01e9$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $c700d8a3a13e01e9$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $c700d8a3a13e01e9$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($c700d8a3a13e01e9$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$c700d8a3a13e01e9$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $c700d8a3a13e01e9$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $c700d8a3a13e01e9$export$4023ad4ecd4126a2(body, global) {
    return $c700d8a3a13e01e9$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $c700d8a3a13e01e9$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$c700d8a3a13e01e9$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $c700d8a3a13e01e9$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $c700d8a3a13e01e9$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $c700d8a3a13e01e9$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $c700d8a3a13e01e9$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $c700d8a3a13e01e9$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $c700d8a3a13e01e9$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $c700d8a3a13e01e9$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $c700d8a3a13e01e9$var$getModuleLinkHrefs(matches, manifest);
    return $c700d8a3a13e01e9$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $c700d8a3a13e01e9$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $c700d8a3a13e01e9$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $c700d8a3a13e01e9$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($c700d8a3a13e01e9$var$prefetchStyleLink));
}
async function $c700d8a3a13e01e9$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$c700d8a3a13e01e9$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$c700d8a3a13e01e9$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$c700d8a3a13e01e9$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($c700d8a3a13e01e9$var$prefetchStyleLink));
}
async function $c700d8a3a13e01e9$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $c700d8a3a13e01e9$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $c700d8a3a13e01e9$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $c700d8a3a13e01e9$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $c700d8a3a13e01e9$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $c700d8a3a13e01e9$var$dedupeLinkDescriptors(links.flat(1).filter($c700d8a3a13e01e9$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $c700d8a3a13e01e9$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $c700d8a3a13e01e9$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $c700d8a3a13e01e9$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $c700d8a3a13e01e9$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $c700d8a3a13e01e9$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $c700d8a3a13e01e9$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$c700d8a3a13e01e9$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($c700d8a3a13e01e9$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $c700d8a3a13e01e9$var$_isPreloadSupported;
function $c700d8a3a13e01e9$var$isPreloadSupported() {
    if ($c700d8a3a13e01e9$var$_isPreloadSupported !== void 0) return $c700d8a3a13e01e9$var$_isPreloadSupported;
    let el = document.createElement("link");
    $c700d8a3a13e01e9$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $c700d8a3a13e01e9$var$_isPreloadSupported;
}
function $c700d8a3a13e01e9$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $c700d8a3a13e01e9$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $c700d8a3a13e01e9$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $c700d8a3a13e01e9$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $c700d8a3a13e01e9$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RemixRootDefaultErrorBoundary, {
            error: $c700d8a3a13e01e9$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $c700d8a3a13e01e9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $c700d8a3a13e01e9$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$c700d8a3a13e01e9$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $c700d8a3a13e01e9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $c700d8a3a13e01e9$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $c700d8a3a13e01e9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $c700d8a3a13e01e9$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $c700d8a3a13e01e9$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $c700d8a3a13e01e9$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $c700d8a3a13e01e9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $c700d8a3a13e01e9$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $c700d8a3a13e01e9$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $c700d8a3a13e01e9$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$c700d8a3a13e01e9$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $c700d8a3a13e01e9$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $c700d8a3a13e01e9$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $c700d8a3a13e01e9$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $c700d8a3a13e01e9$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $c700d8a3a13e01e9$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $c700d8a3a13e01e9$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $c700d8a3a13e01e9$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $c700d8a3a13e01e9$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $c700d8a3a13e01e9$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $c700d8a3a13e01e9$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $c700d8a3a13e01e9$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $c700d8a3a13e01e9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $c700d8a3a13e01e9$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $c700d8a3a13e01e9$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $c700d8a3a13e01e9$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $c700d8a3a13e01e9$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $c700d8a3a13e01e9$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $c700d8a3a13e01e9$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $c700d8a3a13e01e9$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $c700d8a3a13e01e9$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $c700d8a3a13e01e9$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $c700d8a3a13e01e9$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $c700d8a3a13e01e9$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $c700d8a3a13e01e9$var$nextPaths = /* @__PURE__ */ new Set();
var $c700d8a3a13e01e9$var$discoveredPathsMaxSize = 1e3;
var $c700d8a3a13e01e9$var$discoveredPaths = /* @__PURE__ */ new Set();
var $c700d8a3a13e01e9$var$URL_LIMIT = 7680;
function $c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $c700d8a3a13e01e9$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $c700d8a3a13e01e9$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($c700d8a3a13e01e9$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $c700d8a3a13e01e9$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $c700d8a3a13e01e9$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $c700d8a3a13e01e9$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$c700d8a3a13e01e9$var$discoveredPaths.has(pathname)) $c700d8a3a13e01e9$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($c700d8a3a13e01e9$var$nextPaths.keys()).filter((path)=>{
                if ($c700d8a3a13e01e9$var$discoveredPaths.has(path)) {
                    $c700d8a3a13e01e9$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $c700d8a3a13e01e9$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $c700d8a3a13e01e9$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $c700d8a3a13e01e9$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $c700d8a3a13e01e9$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($c700d8a3a13e01e9$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $c700d8a3a13e01e9$var$URL_LIMIT) {
        $c700d8a3a13e01e9$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$c700d8a3a13e01e9$var$addToFifoQueue(p, $c700d8a3a13e01e9$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $c700d8a3a13e01e9$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $c700d8a3a13e01e9$var$addToFifoQueue(path, queue) {
    if (queue.size >= $c700d8a3a13e01e9$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $c700d8a3a13e01e9$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $c700d8a3a13e01e9$var$useDataRouterContext2() {
    let context = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    $c700d8a3a13e01e9$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $c700d8a3a13e01e9$var$useDataRouterStateContext() {
    let context = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    $c700d8a3a13e01e9$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $c700d8a3a13e01e9$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$c700d8a3a13e01e9$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $c700d8a3a13e01e9$var$useFrameworkContext() {
    let context = $acw62.useContext($c700d8a3a13e01e9$export$208d6a3bc3aa62bd);
    $c700d8a3a13e01e9$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $c700d8a3a13e01e9$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($c700d8a3a13e01e9$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $c700d8a3a13e01e9$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $c700d8a3a13e01e9$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $c700d8a3a13e01e9$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $c700d8a3a13e01e9$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $c700d8a3a13e01e9$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $c700d8a3a13e01e9$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $c700d8a3a13e01e9$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$c700d8a3a13e01e9$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $c700d8a3a13e01e9$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $c700d8a3a13e01e9$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let matches = $c700d8a3a13e01e9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$c700d8a3a13e01e9$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$c700d8a3a13e01e9$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$c700d8a3a13e01e9$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $c700d8a3a13e01e9$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$c700d8a3a13e01e9$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $c700d8a3a13e01e9$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $c700d8a3a13e01e9$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $c700d8a3a13e01e9$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { basename: basename } = $c700d8a3a13e01e9$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $c700d8a3a13e01e9$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $c700d8a3a13e01e9$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $c700d8a3a13e01e9$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let _matches = $c700d8a3a13e01e9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$c700d8a3a13e01e9$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $c700d8a3a13e01e9$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $c700d8a3a13e01e9$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $c700d8a3a13e01e9$var$isHydrated = false;
function $c700d8a3a13e01e9$export$3be068dde909e563() {
    $c700d8a3a13e01e9$var$isHydrated = true;
}
function $c700d8a3a13e01e9$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $c700d8a3a13e01e9$var$useDataRouterContext2();
    let { matches: routerMatches } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let isRSCRouterContext = $c700d8a3a13e01e9$var$useIsRSCRouterContext();
    let enableFogOfWar = $c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $c700d8a3a13e01e9$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $c700d8a3a13e01e9$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $c700d8a3a13e01e9$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($c700d8a3a13e01e9$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $c700d8a3a13e01e9$var$isHydrated || isRSCRouterContext ? [] : $c700d8a3a13e01e9$var$dedupe(manifest.entry.imports.concat($c700d8a3a13e01e9$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $c700d8a3a13e01e9$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $c700d8a3a13e01e9$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $c700d8a3a13e01e9$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $c700d8a3a13e01e9$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $c700d8a3a13e01e9$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $c700d8a3a13e01e9$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($c700d8a3a13e01e9$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $c700d8a3a13e01e9$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $c700d8a3a13e01e9$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$ff0bf87698939488, null) : null)));
}
var $c700d8a3a13e01e9$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($c700d8a3a13e01e9$var$isBrowser2) window.__reactRouterVersion = "7.13.1";
} catch (e) {}
function $c700d8a3a13e01e9$export$1f3f55432a00e06d(routes, opts) {
    return $c700d8a3a13e01e9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $c700d8a3a13e01e9$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $c700d8a3a13e01e9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e,
        hydrationRouteProperties: $c700d8a3a13e01e9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $c700d8a3a13e01e9$export$1ba7ed8a3a7b3765(routes, opts) {
    return $c700d8a3a13e01e9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $c700d8a3a13e01e9$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $c700d8a3a13e01e9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e,
        hydrationRouteProperties: $c700d8a3a13e01e9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $c700d8a3a13e01e9$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $c700d8a3a13e01e9$var$deserializeErrors(state.errors)
    };
    return state;
}
function $c700d8a3a13e01e9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $c700d8a3a13e01e9$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $c700d8a3a13e01e9$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $c700d8a3a13e01e9$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $c700d8a3a13e01e9$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $c700d8a3a13e01e9$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $c700d8a3a13e01e9$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$c700d8a3a13e01e9$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c700d8a3a13e01e9$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $c700d8a3a13e01e9$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $c700d8a3a13e01e9$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $c700d8a3a13e01e9$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $c700d8a3a13e01e9$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $c700d8a3a13e01e9$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $c700d8a3a13e01e9$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$c700d8a3a13e01e9$export$a6c7ac8248d6e38a.displayName = "Link";
var $c700d8a3a13e01e9$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c700d8a3a13e01e9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $c700d8a3a13e01e9$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$c700d8a3a13e01e9$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $c700d8a3a13e01e9$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $c700d8a3a13e01e9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let submit = $c700d8a3a13e01e9$export$47c85c6e3a081d3();
    let formAction = $c700d8a3a13e01e9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$c700d8a3a13e01e9$export$a7fed597f4b8afd8.displayName = "Form";
function $c700d8a3a13e01e9$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($c700d8a3a13e01e9$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let matches = $c700d8a3a13e01e9$export$2378eb7f5ff86053();
    $c700d8a3a13e01e9$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $c700d8a3a13e01e9$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$c700d8a3a13e01e9$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $c700d8a3a13e01e9$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $c700d8a3a13e01e9$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    $c700d8a3a13e01e9$export$f5708dca728d7177(ctx, $c700d8a3a13e01e9$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $c700d8a3a13e01e9$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    $c700d8a3a13e01e9$export$f5708dca728d7177(state, $c700d8a3a13e01e9$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $c700d8a3a13e01e9$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $c700d8a3a13e01e9$export$9770f232ac06a008();
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let path = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($c700d8a3a13e01e9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $c700d8a3a13e01e9$export$fe53371bee54353d(location) === $c700d8a3a13e01e9$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $c700d8a3a13e01e9$export$f1a78c17382fe22a(defaultInit) {
    $c700d8a3a13e01e9$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c700d8a3a13e01e9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $c700d8a3a13e01e9$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $c700d8a3a13e01e9$var$fetcherId = 0;
var $c700d8a3a13e01e9$var$getUniqueFetcherId = ()=>`__${String(++$c700d8a3a13e01e9$var$fetcherId)}__`;
function $c700d8a3a13e01e9$export$47c85c6e3a081d3() {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let currentRouteId = $c700d8a3a13e01e9$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c700d8a3a13e01e9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c700d8a3a13e01e9$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $c700d8a3a13e01e9$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$c700d8a3a13e01e9$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $c700d8a3a13e01e9$export$fe53371bee54353d(path);
}
function $c700d8a3a13e01e9$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $c700d8a3a13e01e9$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($c700d8a3a13e01e9$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $c700d8a3a13e01e9$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $c700d8a3a13e01e9$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $c700d8a3a13e01e9$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $c700d8a3a13e01e9$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $c700d8a3a13e01e9$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $c700d8a3a13e01e9$export$fa996778a3a31087() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $c700d8a3a13e01e9$var$savedScrollPositions = {};
function $c700d8a3a13e01e9$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $c700d8a3a13e01e9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $c700d8a3a13e01e9$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c700d8a3a13e01e9$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let matches = $c700d8a3a13e01e9$export$2378eb7f5ff86053();
    let navigation = $c700d8a3a13e01e9$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $c700d8a3a13e01e9$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $c700d8a3a13e01e9$var$getScrollRestorationKey(location, matches, basename, getKey);
            $c700d8a3a13e01e9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c700d8a3a13e01e9$var$savedScrollPositions));
        } catch (error) {
            $c700d8a3a13e01e9$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c700d8a3a13e01e9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($c700d8a3a13e01e9$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$c700d8a3a13e01e9$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $c700d8a3a13e01e9$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $c700d8a3a13e01e9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $c700d8a3a13e01e9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $c700d8a3a13e01e9$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $c700d8a3a13e01e9$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $c700d8a3a13e01e9$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($c700d8a3a13e01e9$export$3681f408decb40d1);
    $c700d8a3a13e01e9$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $c700d8a3a13e01e9$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $c700d8a3a13e01e9$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $c700d8a3a13e01e9$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $c700d8a3a13e01e9$export$81336c211d5ff295(path.pathname, nextPath) != null || $c700d8a3a13e01e9$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $c700d8a3a13e01e9$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $c700d8a3a13e01e9$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $c700d8a3a13e01e9$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $c700d8a3a13e01e9$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $c700d8a3a13e01e9$var$serializeErrors(context.errors)
        };
        let json = $c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $c700d8a3a13e01e9$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($c700d8a3a13e01e9$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $c700d8a3a13e01e9$var$getStatelessNavigator() {
    return {
        createHref: $c700d8a3a13e01e9$var$createHref,
        encodeLocation: $c700d8a3a13e01e9$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $c700d8a3a13e01e9$export$69163f0b72ec60d9(routes, opts) {
    return $c700d8a3a13e01e9$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e
    });
}
function $c700d8a3a13e01e9$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(routes, $c700d8a3a13e01e9$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $c700d8a3a13e01e9$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $c700d8a3a13e01e9$var$createHref,
        encodeLocation: $c700d8a3a13e01e9$var$encodeLocation,
        getFetcher () {
            return $c700d8a3a13e01e9$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $c700d8a3a13e01e9$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $c700d8a3a13e01e9$var$createHref(to) {
    return typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
}
function $c700d8a3a13e01e9$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

});

parcelRegister("yugLx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e6e100db9c6be6a$var$DevtankLogoComponent;

var $ayMG0 = parcelRequire("ayMG0");
function $0e6e100db9c6be6a$var$DevtankLogoComponent() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "devtank-logo",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "187",
            height: "61",
            version: "1.1",
            viewBox: "0 0 2245.3 742.4",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                transform: "translate(412.22 -347.78)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m-1.4286 1021.6c-91.986-2.9623-150.38-18.907-189.31-51.69-22.37-18.839-39.659-49.326-44.611-78.665-4.8068-28.475-3.7092-87.015 1.9593-104.5 7.4642-23.024 20.404-36.67 37.92-39.992 5.7916-1.0983 24.913-1.3774 27.459-0.40066 1.3607 0.52214 1.5818 3.1033 1.5818 18.465 0 21.102 0.76453 19.928-12.982 19.928-8.5433 0-9.2651 0.1636-11.537 2.6149-3.1292 3.3765-5.9329 10.956-8.1513 22.038-2.5203 12.59-2.5295 53.657-0.015 67.347 12.582 68.503 60.145 96.122 181.69 105.5 44.988 3.4703 84.064 3.6801 597 3.2053 489.27-0.45294 537.65-0.74376 614.5-3.6937 163.83-6.289 240.47-20.656 308-57.738 28.717-15.77 46.228-28.06 61.576-43.22 16.931-16.724 27.586-33.588 31.915-50.514 2.4215-9.4679 2.534-15.406 0.4265-22.502-2.1671-7.2977-9.7442-14.885-17.948-17.972-11.923-4.487-17.21-5.0255-49.528-5.0439-22.9-0.013-30.989-0.33169-32.274-1.2716-1.5289-1.1179-1.6855-3.2092-1.4412-19.25l0.2741-17.996 29.5-0.29579c17.33-0.17376 33.581 0.16596 39.392 0.82349 37.091 4.1969 63.022 24.021 70.292 53.738 2.5737 10.52 2.1261 27.372-1.0508 39.571-9.2127 35.375-38.967 72.164-79.633 98.461-53.95 34.888-100.44 52.96-167.5 65.109-52.989 9.6008-128.06 15.44-222 17.266-65.633 1.2759-1127.8 1.8975-1165.5 0.6821zm-128.96-151.79c-1.6622-3.1058-1.417-195.16 0.25205-197.44 1.2084-1.6526 4.6516-1.7344 56.25-1.3356 57.372 0.44339 62.61 0.80718 76.158 5.2902 18.687 6.1831 32.757 18.1 40.643 34.424 8.9835 18.594 13.48 43.948 12.31 69.415-1.9876 43.266-15.177 70.614-39.749 82.418-17.297 8.3094-25.991 9.1666-92.97 9.1666-50.248 0-51.891-0.0601-52.894-1.9343zm108.12-39.871c17.415-5.798 26.316-23.165 27.557-53.771 1.4347-35.385-7.7398-56.286-28.03-63.856-4.5673-1.7042-8.5838-1.98-33.931-2.3303l-28.75-0.39724v123.3l28.25-0.36488c25.93-0.33492 28.796-0.5468 34.903-2.5799zm213.85 40.685c-33.804-3.4012-53.76-16.885-67.09-45.33-12.95-27.634-14.353-68.643-3.3983-99.293 5.0811-14.216 10.324-22.312 21.883-33.791 7.9438-7.8887 11.709-10.821 17.605-13.708 14.125-6.917 15.211-7.0385 66.961-7.493 43.498-0.38195 46.543-0.29553 47.75 1.355 1.5472 2.1159 1.8191 32.993 0.31159 35.381-0.80572 1.2763-6.8795 1.5844-40.735 2.0663-43.391 0.61761-46.414 0.9804-54.433 6.5309-8.7387 6.049-13.345 15.291-14.529 29.153l-0.61936 7.25h55.04c49.267 0 55.103 0.16592 55.647 1.5818 0.79102 2.0614 0.79102 32.775 0 34.836-0.54332 1.4159-6.3794 1.5818-55.638 1.5818h-55.031l0.64399 5.4794c1.3129 11.171 7.0294 22.212 14.154 27.337 10.848 7.8044 19.931 9.1833 60.494 9.1833 28.522 0 33.047 0.20666 34.412 1.5714 1.2976 1.2976 1.5714 4.3588 1.5714 17.566 0 9.1129-0.44538 16.827-1.0352 17.929-0.997 1.8629-2.4081 1.9294-38.25 1.8014-20.468-0.0731-41.04-0.51773-45.715-0.9881zm241.16-0.62902c-4.162-7.986-82.242-195.58-81.977-196.96 0.31824-1.655 2.1535-1.8119 23.832-2.0379 12.918-0.13466 24.079 0.13541 24.803 0.60015 0.7241 0.46475 13.686 32.525 28.805 71.245s27.861 70.775 28.316 71.232c0.45526 0.45794 5.7991-11.692 11.875-27 6.0761-15.308 18.533-46.733 27.682-69.833s17.291-43.012 18.093-44.25c1.4435-2.2275 1.6919-2.25 24.813-2.25 19.007 0 23.575 0.2656 24.539 1.4268 0.95025 1.145-7.145 20.453-40.983 97.75-23.192 52.978-42.806 97.561-43.587 99.073l-1.4198 2.75h-21.939c-19.88 0-22.025-0.16422-22.851-1.75zm228.31 0.51957c-0.26348-0.69826-0.59024-54.145-0.72613-118.77l-0.24707-117.5-571.27-0.50345-0.60253-2.2483c-0.78402-2.9255-0.78365-30.572 4.6e-4 -33.498l0.60297-2.25h704.28c641.29 0 704.33 0.14148 704.88 1.5818 0.8998 2.3448 0.7066 33.713-0.2166 35.167-0.6312 0.99419-81.403 1.3-396.23 1.5l-395.44 0.25125-1 237-21.774 0.26957c-16.878 0.20896-21.882-0.0159-22.253-1zm120.93-0.16624c-0.2948-0.76817 5.7295-15.731 13.387-33.25 7.6578-17.519 26.893-61.553 42.744-97.853s29.253-66.571 29.782-67.269c0.7367-0.97249 6.1221-1.206 23.062-1l22.102 0.26876 9.3261 22c5.1294 12.1 10.616 25.15 12.192 29 1.5765 3.85 16.134 38.448 32.351 76.885 16.217 38.437 29.249 70.499 28.961 71.25-0.4226 1.1013-5.2255 1.3648-24.882 1.3648-22.176 0-24.441-0.15678-25.291-1.75-0.719-1.348-24.749-62.672-55.35-141.25-1.0547-2.7084-2.1443-0.0989-40.71 97.5-8.9106 22.55-16.859 42.012-17.662 43.25-1.4484 2.2303-1.6716 2.25-25.47 2.25-19.629 0-24.106-0.25477-24.544-1.3967zm293.07 0.16703c-0.2664-0.6987-0.3682-45.82-0.2265-100.27l0.2578-99 27.615-0.26558c21.329-0.20513 27.847 0.0225 28.634 1 0.5604 0.69607 17.609 32.295 37.885 70.22l36.866 68.954 0.517-69.954c0.2844-38.475 0.6219-70.067 0.75-70.204 0.1282-0.1375 9.6349-0.25 21.126-0.25 18.129 0 20.973 0.20924 21.5 1.5818 0.7933 2.0673 0.7933 195.77 0 197.84-0.5321 1.3868-3.8418 1.5818-26.845 1.5818-23.746 0-26.382-0.16622-27.75-1.75-1.4335-1.6588-16.017-27.612-57.856-102.96-10.143-18.267-18.776-33.23-19.185-33.25-0.4087-0.0205-0.8587 30.9-1 68.713l-0.2569 68.75-20.774 0.27036c-16.075 0.20921-20.883-0.017-21.258-1zm261-7.9e-4c-0.2662-0.69826-0.3679-45.82-0.2262-100.27l0.2578-99h44l0.2601 45.83c0.149 26.247 0.6406 45.689 1.1505 45.5 0.4896-0.18147 3.3247-3.48 6.3001-7.33 46.575-60.265 61.51-79.454 63.628-81.75l2.536-2.75h27.754c19.03 0 27.967 0.34421 28.431 1.0951 0.9235 1.4944 0.4689 2.067-33.848 42.629-16.647 19.677-33.98 40.184-38.518 45.571l-8.2505 9.7949 6.279 8.1225c3.4534 4.4674 20.794 26.61 38.534 49.205 17.74 22.595 32.134 41.758 31.987 42.583-0.2296 1.2838-4.3111 1.5382-28.316 1.7652-28.038 0.26516-28.049 0.26447-30.069-2-1.1117-1.2459-7.6323-10.14-14.49-19.765-6.858-9.625-21.446-30.074-32.417-45.441l-19.948-27.941-1 94.882-21.774 0.26957c-16.876 0.20893-21.883-0.016-22.258-1zm197.98-227.03c-0.2665-0.69455-0.3649-14.082-0.2186-29.75l0.266-28.487 78.5-0.2753c43.175-0.15142 79.512-0.0304 80.75 0.26905l2.25 0.54435v28.874c0 25.407-0.1899 28.947-1.5818 29.481-0.87 0.33385-37.109 0.60699-80.531 0.60699-62.665 0-79.05-0.26048-79.434-1.2628zm-1441.9-86.088c-1.7172-1.2556-1.8034-2.5761-1.2249-18.75 1.0929-30.556 7.2809-51.171 21.732-72.399 14.08-20.684 36.391-36.81 55.083-39.815 10.506-1.6886 447.09-1.7077 457.7-0.02 14.776 2.3518 35.659 15.606 47.924 30.417 11.924 14.398 19.668 29.851 25.016 49.917 2.2943 8.6082 2.5416 11.424 2.6348 30l0.10288 20.5h-38l-0.66728-17c-0.77042-19.628-2.6351-28.36-8.8173-41.293-6.9379-14.513-16.42-24.822-28.456-30.938-10.898-5.5374 1.79-5.2469-228.56-5.2333-137.82 8e-3 -215.03 0.36479-217.81 1.0062-15.982 3.6861-31.929 18.074-40.165 36.237-5.6087 12.37-7.2389 20.631-7.7395 39.22-0.37846 14.054-0.73612 17.217-2.0638 18.25-2.3632 1.8393-34.155 1.752-36.689-0.10075z",
                        fill: "#ccc"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m24.571 1022.1c-35.309-1.0647-61.945-2.5596-77.443-4.3463-98.036-11.302-150.99-42.05-174.5-101.32-7.6145-19.196-11.05-41.977-11.054-73.294-2e-3 -19.383 1.9734-42.144 4.488-51.711 3.9139-14.89 11.867-28.8 20.271-35.456 2.2371-1.7718 6.6936-4.4459 9.9033-5.9424 5.5302-2.5784 6.6216-2.7216 20.836-2.734l15-0.013v36l-10 0.5c-5.5 0.27496-10.979 1.0602-12.175 1.745-10.095 5.7789-15.305 53.294-9.8187 89.559 10.228 67.615 57.96 97.258 172.49 107.12 42.616 3.6709 54.101 3.7332 609.5 3.3045 537.36-0.41477 557.29-0.53265 630.5-3.7304 142.51-6.2245 215.18-19.575 278.44-51.151 15.04-7.5076 39.196-21.864 51.061-30.346 38.331-27.402 61.897-67.437 54.605-92.765-2.7652-9.605-13.064-17.663-27.344-21.394-4.9107-1.2831-13.483-1.7662-39.76-2.2408l-33.5-0.60503-0.5458-36.67 36.773 0.40775c35.649 0.39529 37.064 0.486 46.284 2.9669 28.083 7.5559 45.974 22.957 53.69 46.217 2.3816 7.1799 2.6773 9.58 2.6585 21.578-0.016 10.518-0.4789 15.163-2.0934 21.031-10.27 37.322-37.451 71.293-78.766 98.442-97.343 63.965-184.69 80.292-451.5 84.394-45.799 0.7042-1055.6 1.1279-1078 0.4523zm-154.54-152.57c-0.26203-0.6875-0.36041-45.35-0.21862-99.25l0.2578-98 50-0.3123c54.061-0.33767 64.843 0.27108 79.463 4.4867 13.094 3.7757 21.356 8.5917 30.537 17.801 8.5111 8.5373 12.471 15.217 17.124 28.882 9.0178 26.485 9.8025 66.692 1.838 94.175-9.0139 31.105-27.153 47.242-58.462 52.009-12.955 1.9724-119.8 2.1569-120.54 0.20816zm98.326-36.785c15.866-2.5747 24.443-8.6786 30.488-21.696 11.019-23.732 9.824-65.325-2.4284-84.491-6.1108-9.5593-14.775-14.773-27.846-16.755-4.519-0.68538-16.84-1.0153-31-0.83003l-23.5 0.30746-0.25934 61c-0.14263 33.55-0.0443 61.562 0.21862 62.25 0.60411 1.58 44.837 1.7548 54.327 0.21471zm220.21 36.916c-26.415-3.0671-43.563-12.895-56.545-32.406-6.8279-10.262-11.515-21.645-14.607-35.475-2.0613-9.2198-2.3403-12.999-2.2882-31 0.0657-22.729 1.3982-31.187 7.3358-46.559 4.9528-12.823 9.8179-20.147 20.605-31.019 8.1444-8.2086 11.511-10.832 18.142-14.138 13.716-6.838 19.458-7.4154 70.358-7.0744l43.5 0.29144 0.27471 16.868c0.18878 11.591-0.0841 17.3-0.87244 18.25-0.93486 1.1264-7.4033 1.3822-34.952 1.3822-18.593 0-37.325 0.46887-41.628 1.0419-14.351 1.9115-23.851 8.2889-28.919 19.412-2.217 4.8665-4.3804 15.1-4.396 20.796l-8e-3 2.75h54.3c40.9 0 54.596 0.29613 55.5 1.2 0.83695 0.83695 1.2 6.2222 1.2 17.8s-0.36305 16.963-1.2 17.8c-0.90393 0.90393-14.625 1.2-55.614 1.2h-54.414l0.66577 4.75c1.814 12.942 7.6597 24.14 15.215 29.144 11.34 7.5113 21.907 9.0606 61.974 9.0861 25.252 0.0161 31.344 0.28071 32.275 1.402 0.78831 0.94986 1.0612 6.6587 0.87244 18.25l-0.27471 16.868-39.5 0.12592c-21.725 0.0693-42.875-0.26597-47-0.74494zm243.21-3.6122c-20.443-47.587-80.214-190.9-80.214-192.33 0-1.8648 0.90891-1.94 23.477-1.94 23.249 0 23.491 0.0219 24.932 2.25 0.80005 1.2375 13.651 33.518 28.558 71.735s27.489 69.87 27.959 70.341c0.77937 0.77937 10.209-22.391 45.307-111.33 6.6201-16.775 12.481-31.062 13.024-31.75 1.4253-1.8038 47.598-1.8038 48.274 0 0.25735 0.6875-18.832 45.35-42.421 99.25l-42.889 98-43.958 0.53756zm229.54-113.52-0.2541-118.25-284.9-0.25174c-208.59-0.1843-285.26-0.55192-286.25-1.3724-1.8709-1.5527-1.9626-34.125-0.10037-35.664 0.85928-0.71034 220.99-0.82675 704.25-0.37244l703 0.66089 0.2747 16.868c0.1888 11.591-0.084 17.3-0.8724 18.25-0.9727 1.172-61.194 1.3822-396.02 1.3822h-394.88v116.92c0 64.305-0.27314 117.63-0.60699 118.5-0.52731 1.3742-3.4145 1.5818-21.996 1.5818h-21.389zm121.25 116.96c0-0.71102 19.303-45.374 42.896-99.25l42.896-97.957 43.955-0.53759 3.7683 8.7688c23.398 54.446 79.341 188.69 78.918 189.38-0.3029 0.49015-11.241 0.89118-24.306 0.89118h-23.756l-1.4897-3.25c-0.8193-1.7875-13.615-34.405-28.435-72.484-14.82-38.079-27.319-69.117-27.776-68.973-0.4565 0.14331-5.9005 13.074-12.098 28.734-6.1971 15.66-18.823 47.598-28.057 70.973-9.2343 23.375-17.233 43.062-17.775 43.75-1.4557 1.847-48.74 1.8055-48.74-0.0428zm292.61-0.28903c-0.9195-2.3963-0.6965-194.73 0.2275-196.18 0.6234-0.98222 6.9335-1.2066 28.119-1l27.315 0.2664 17.148 32c9.4311 17.6 26.356 49.212 37.61 70.25 11.254 21.038 20.799 38.25 21.211 38.25 0.4119 0 0.8645-31.612 1.0057-70.25l0.2568-70.25h41v198l-26.114 0.26634c-20.129 0.20529-26.348-0.0239-27.133-1-0.9691-1.2046-7.302-12.482-56.024-99.766-11.513-20.625-21.337-37.388-21.831-37.25-0.5165 0.14371-1.0072 29.564-1.1549 69.25l-0.2569 69h-20.386c-17.667 0-20.467-0.21098-20.993-1.5818zm261 0c-0.7933-2.0673-0.7933-193.77 0-195.84 0.5273-1.3742 3.4149-1.5818 22-1.5818h21.393v45.941c0 26.835 0.382 46.177 0.9186 46.509 0.5052 0.31225 8.1328-8.7737 16.95-20.191 8.8174-11.417 24.952-32.234 35.855-46.259l19.824-25.5 27.41-0.26641c15.354-0.14923 27.806 0.13026 28.311 0.63545 0.9407 0.94061-0.1316 2.2554-49.769 61.026-18.697 22.137-28.985 35.094-28.958 36.47 0.024 1.2378 11.755 17.045 27.927 37.634 15.337 19.525 32.302 41.125 37.701 48 5.3989 6.875 9.8192 13.07 9.8229 13.766 0.01 0.99729-5.9818 1.2093-28.243 1l-28.25-0.26557-33.5-46.925c-18.425-25.809-34.062-47.109-34.75-47.333-0.9882-0.32307-1.25 9.5567-1.25 47.175v47.583h-21.393c-18.585 0-21.473-0.20761-22-1.5818zm198.39-254.31c0-25.424 0.1899-28.966 1.5818-29.5 2.067-0.79319 155.77-0.79319 157.84 0 1.3919 0.53411 1.5818 4.0758 1.5818 29.5v28.893h-161zm-1442.7-58.652c-1.1254-2.9329 0.50873-36.765 2.1231-43.955 5.4818-24.413 16.258-45.121 31.48-60.489 8.7551-8.8393 16.819-14.552 28.356-20.088 15.206-7.2964 0.8389-6.8886 242.7-6.8876 228.82 1e-3 224.24-0.0839 236.81 4.3852 21.666 7.7024 42.498 27.251 54.434 51.079 8.7772 17.523 12.543 33.655 13.432 57.533 0.55089 14.799 0.43537 16.714-1.1011 18.25-1.4776 1.4776-3.9222 1.7165-17.563 1.7165-8.7157 0-16.559-0.27314-17.429-0.60699-1.2902-0.49511-1.5833-2.3844-1.59-10.25-0.0222-26.03-5.0946-44.723-16.456-60.645-8.5286-11.952-22.096-21.214-34.423-23.5-7.3957-1.3714-424.83-1.3714-432.23 0-9.6145 1.7828-19.552 7.458-28.025 16.005-6.2467 6.3014-8.5718 9.5987-12.763 18.101-7.2706 14.747-9.125 22.85-9.9314 43.396l-0.66728 17-18.273 0.27265c-15.943 0.23788-18.35 0.0699-18.883-1.3176z",
                        fill: "#b1b1b1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m26.071 1022.1c-4.95-0.1656-19.575-0.7735-32.5-1.3509-139.45-6.2288-208.02-44.244-227.09-125.9-6.512-27.878-6.4521-78.38 0.12287-103.59 6.312-24.205 20.48-40.065 38.855-43.495 8.2582-1.5412 24.621-1.3037 26.016 0.37771 0.7869 0.94816 1.0612 6.529 0.87244 17.75l-0.27533 16.367-10.303 0.62558c-8.8653 0.53827-10.643 0.9452-12.741 2.916-6.9714 6.5493-10.386 21.743-11.163 49.665-1.3593 48.887 8.0561 79.075 31.712 101.68 29.866 28.534 78.21 41.824 173.99 47.831 29.633 1.8586 1056.6 1.8721 1126 0.0149 172.96-4.6276 249.7-13.023 314.4-34.396 33.834-11.177 73.794-31.742 101.16-52.062 40.126-29.791 62.445-72.615 49.879-95.703-3.4526-6.3436-7.0136-9.4822-15.028-13.246-10.99-5.1606-17.1-5.9448-51.912-6.6624l-32-0.65969v-35l34 0.054c30.57 0.0485 34.958 0.26332 43.5 2.1296 19.573 4.2764 33.076 11.297 43.823 22.786 7.7529 8.2879 12.674 17.159 15.318 27.613 2.915 11.527 2.2746 30.44-1.4532 42.917-13.751 46.025-54.084 85.623-122.69 120.45-76.609 38.894-163.03 52.429-368.5 57.713-37.377 0.9613-1087.3 2.0759-1114 1.1826zm-155-152.5c-0.28205-0.73968-0.39681-45.445-0.25502-99.345l0.2578-98 46-0.30652c27.767-0.18503 50.786 0.12492 58.073 0.78196 25.39 2.289 40.251 8.0594 53.598 20.81 6.9008 6.593 8.675 9.0326 12.859 17.681 8.7876 18.166 12.407 36.22 12.335 61.533-0.0758 26.742-3.1339 42.622-11.554 60-6.6906 13.808-15.224 22.667-27.81 28.874-16.252 8.0141-19.296 8.3302-85.245 8.8558-47.765 0.38061-57.834 0.2277-58.258-0.88474zm102.42-37.311c12.723-3.1481 19.485-8.4377 25.162-19.684 5.3398-10.578 7.0964-19.402 7.6342-38.35 0.40916-14.415 0.17776-18.474-1.5216-26.69-3.3854-16.369-11.033-28.629-21.044-33.736-8.6486-4.4122-14.485-5.2524-40.313-5.8038-13.568-0.28967-25.831-0.23524-27.25 0.12096l-2.5804 0.64764v62.398c0 48.944 0.26951 62.522 1.25 62.974 0.6875 0.31699 12.725 0.38163 26.75 0.14365 18.694-0.3172 27.212-0.85619 31.913-2.0195zm221.09 37.365c-26.477-2.3382-40.227-8.0362-53.752-22.274-17.4-18.317-25.568-42.638-25.568-76.124 0-17.73 1.5888-29.061 5.8911-42.016 9.4351-28.409 30.377-49.348 55.176-55.165 6.8919-1.6169 12.754-1.819 52.754-1.819h45l0.27258 17.629 0.27259 17.629-37.773 0.54993c-20.797 0.30277-39.979 1.031-42.682 1.6203-15.55 3.3906-25.528 13.241-28.435 28.071-0.96925 4.9446-1.5148 11.368-1.2526 14.75 0.0762 0.98367 11.815 1.25 55.097 1.25h55v36h-54.893c-43.003 0-54.992 0.27076-55.352 1.25-0.7576 2.0623 2.204 14.883 4.7182 20.425 3.3489 7.3819 9.4514 13.569 16.506 16.735 10.846 4.8674 17.715 5.6547 54.793 6.2801l34.273 0.57809-0.27253 17.616-0.27253 17.616-35 0.11875c-19.25 0.0653-39.275-0.25877-44.5-0.72019zm239.08-0.74872c-3.7544-7.0152-82.042-194.81-81.644-195.84 0.70848-1.8463 44.446-1.8986 46.734-0.0559 0.85359 0.6875 5.6372 11.825 10.63 24.75 24.015 62.164 46.245 118.45 47.136 119.34 0.65249 0.65249 1.3654-2e-3 2.0937-1.9235 10.019-26.426 55.703-140.38 56.793-141.66 1.3346-1.5702 3.7863-1.75 23.864-1.75 19.267 0 22.459 0.21491 22.97 1.5465 0.52296 1.3628-82.396 192.9-84.939 196.2-0.7153 0.92924-6.3105 1.25-21.805 1.25-19.256 0-20.918-0.1408-21.833-1.8502zm228.39 0.62052c-0.26364-0.6987-0.59054-54.145-0.72643-118.77l-0.24707-117.5-571.5-0.50345v-35.997h702.8c545.29 0 703.07 0.26894 704 1.2 1.3744 1.3744 1.7118 31.446 0.3764 33.549-0.6312 0.99419-81.403 1.3-396.23 1.5l-395.44 0.25125-1 237-20.774 0.27036c-16.077 0.20924-20.882-0.0168-21.253-1zm121.75-1.5204c0.4646-2.8317 83.299-192.76 85.045-195 0.7249-0.92885 6.3328-1.25 21.827-1.25h20.852l1.4092 2.75c4.7649 9.2986 81.654 193.78 81.228 194.89-0.4208 1.0966-5.0396 1.3633-23.61 1.3633h-23.086l-2.2834-5.25c-1.2558-2.8875-14.165-35.739-28.687-73.002-14.522-37.264-26.792-67.623-27.267-67.465s-8.2567 18.947-17.293 41.752c-35.891 90.578-40.713 102.49-41.766 103.2-0.6012 0.40408-11.382 0.74158-23.957 0.75l-22.864 0.0153 0.4512-2.75zm292.24 1.5212c-0.2665-0.69917-0.3686-45.371-0.2268-99.271l0.2578-98 53.454-0.53258 2.3429 3.7663c1.2886 2.0715 13.393 24.466 26.899 49.766 43.653 81.772 47.292 88.473 48.053 88.487 0.4125 7e-3 0.75-31.397 0.75-69.787 0-52.956 0.2896-70.09 1.2-71 1.6916-1.6916 37.908-1.6916 39.6 0 1.7404 1.7404 1.7404 194.86 0 196.6-1.3452 1.3452-49.412 1.7515-51.421 0.43469-0.6164-0.40408-17.659-30.435-37.873-66.735-20.214-36.3-37.935-67.8-39.379-70l-2.6266-4-1 141-19.773 0.27122c-15.274 0.2095-19.884-0.018-20.258-1zm261-8.6e-4c-0.2663-0.6987-0.3682-45.37-0.2264-99.27l0.2578-98h42l0.2599 46.75c0.1429 25.712 0.5929 46.75 1 46.75 0.8985-4e-5 -1.4511 2.9672 39.197-49.5 18.322-23.65 33.815-43.331 34.428-43.735s13.152-0.74158 27.865-0.75c21.168-0.0121 26.75 0.25357 26.75 1.2732 0 0.7087-18 22.584-40 48.612s-40 47.729-40 48.225 17.1 22.715 38 49.375 38 49.154 38 49.987c0 1.3138-3.5272 1.5113-26.75 1.498-14.712-8e-3 -27.249-0.34592-27.86-0.75-0.6104-0.40408-16.263-21.997-34.784-47.985s-34.104-47.25-34.631-47.25c-0.5918 0-1.0556 18.207-1.2163 47.75l-0.2597 47.75-20.774 0.27036c-16.075 0.20921-20.883-0.017-21.258-1zm197.98-227.03c-0.2668-0.69531-0.3652-13.633-0.2186-28.75l0.2665-27.486 160.5-0.5119v58.012h-80.031c-63.582 0-80.131-0.25984-80.516-1.2642zm-1443.1-87.322c-0.97816-2.549 0.55465-30.481 2.1861-39.837 6.444-36.953 28.676-68.282 58.55-82.508 17.461-8.3153-6.3249-7.5285 238.44-7.8862 228.42-0.33384 227.91-0.34231 240.42 3.9619 32.637 11.226 58.266 43.113 66.77 83.077 1.3029 6.1223 1.7681 12.966 1.7862 26.278l0.0244 18h-36l-0.64816-17c-0.76166-19.977-2.6219-28.364-9.315-42-8.7222-17.77-21.211-29.065-37.468-33.888-4.9219-1.4603-25.565-1.6104-220-1.5996-231.38 0.0128-218.75-0.27508-229.57 5.2342-12.219 6.2248-21.778 16.839-29.048 32.254-6.2638 13.282-7.7303 20.276-8.3864 40l-0.56551 17-18.273 0.27265c-16.134 0.24073-18.346 0.0817-18.899-1.3591z",
                        fill: "#8e8e8e"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m17.721 1021.7c-65.504-2.2013-114.51-9.206-150.35-21.492-12.806-4.3893-33.721-14.584-44.297-21.593-10.156-6.7303-28.706-25.084-35.224-34.851-13.671-20.488-21.964-44.83-25.207-73.992-1.639-14.738-0.61967-52.768 1.769-66 5.0708-28.09 14.878-44.708 30.848-52.272 6.5324-3.094 7.4115-3.2423 21.196-3.5745 11.258-0.2713 14.567-0.0541 15.235 1 0.96665 1.5253 1.2097 29.834 0.27702 32.265-0.49088 1.2792-2.3176 1.5818-9.5497 1.5818-10.24 0-13.615 1.2613-16.656 6.2258-2.7708 4.5229-5.9033 15.637-7.2646 25.774-1.731 12.89-1.4306 46.428 0.53124 59.311 9.9162 65.118 50.895 94.138 150.55 106.61 46.266 5.7924 12.538 5.4432 564 5.839 491.93 0.35304 593.13-0.0701 670.5-2.8036 162.53-5.7425 240.05-18.833 306-51.674 15.97-7.952 39.82-22.089 52.42-31.071 12.238-8.7238 28.476-24.272 36.671-35.113 7.416-9.8098 15.694-25.788 17.906-34.562 2.2051-8.7465 1.9406-20.973-0.5741-26.54-4.1347-9.1532-13.252-15.762-26.923-19.517-5.4386-1.4934-11.888-1.8574-39.5-2.2288-23.435-0.31522-33.212-0.77873-33.735-1.5993-0.9809-1.5414-0.9479-30.821 0.036-32.37 1.296-2.0395 62.25-1.9022 73.633 0.16589 35.48 6.4462 57.182 25.22 63.139 54.619 8.5775 42.332-23.114 95.378-79.074 132.36-78.796 52.07-151.86 71.33-303.5 80.008-34.791 1.9909-69.234 3.3599-102.5 4.0741-14.85 0.3188-33.075 0.8545-40.5 1.1905-20.76 0.9394-1062.2 1.1566-1089.9 0.2273zm-146.16-151.76c-0.63998-0.21621-0.98669-34.909-0.98669-98.731v-98.398l2.4672-0.61921c1.3569-0.34057 24.869-0.40943 52.25-0.15302 38.962 0.36487 51.848 0.80971 59.283 2.0465 39.314 6.54 56.799 23.927 66.176 65.807 2.0608 9.2041 2.3218 12.93 2.3031 32.88-0.0273 29.084-2.5262 42.794-10.965 60.157-6.6984 13.783-16.051 23.011-29.623 29.229-14.464 6.627-16.709 6.8806-64.391 7.273-23.65 0.19465-50.318 0.46353-59.263 0.59751s-16.707 0.0936-17.25-0.0897zm105.06-37.981c12.145-3.9689 17.905-9.1931 23.361-21.186 10.764-23.66 9.4837-65.386-2.5856-84.266-6.3773-9.9759-15.423-15.491-29.031-17.699-3.4576-0.5611-17.199-1.0236-30.537-1.0277l-24.25-8e-3v127.2l28.25-0.44045c25.43-0.39649 28.903-0.65384 34.792-2.5785zm225.25 37.662c-29.501-1.4562-45.142-6.8446-58.818-20.263-18.285-17.941-27.467-44.045-27.467-78.085 0-23.564 4.6426-43.41 14.073-60.158 6.0535-10.751 20.793-25.552 30.415-30.542 13.983-7.2513 14.413-7.2982 67-7.2993l47-1e-3v34l-39 0.62414c-24.739 0.39591-40.631 1.055-43.461 1.8024-10.694 2.8246-19.257 9.8874-23.585 19.453-2.4146 5.3361-5.104 20.482-4.101 23.096 0.50362 1.3124 7.6408 1.54 55.363 1.7652l54.785 0.25852v35l-54.785 0.25856c-47.292 0.22319-54.862 0.46104-55.353 1.7391-0.93463 2.4356 2.5408 15.989 5.7432 22.398 4.8203 9.6464 11.582 14.461 25.725 18.32 6.8614 1.8718 11.408 2.1549 43.169 2.6884l35.5 0.59631 0.27361 17.25c0.21331 13.448-7e-3 17.25-1 17.249-0.70048-7.2e-4 -14.099 0.11178-29.774 0.25-15.675 0.13821-34.441-0.042-41.703-0.4004zm233.08-0.3483c-0.72783-0.55-3.3019-5.725-5.7203-11.5s-20.655-49.067-40.525-96.205-36.128-86.4-36.128-87.25c0-1.348 2.9235-1.5446 22.965-1.5446 21.925 0 23.013 0.0903 24.033 1.9959 0.58749 1.0977 13.212 33.094 28.056 71.104 14.843 38.009 27.465 70 28.048 71.09 0.58337 1.09 1.3485 1.694 1.7004 1.3422 0.35181-0.35182 13.526-33.128 29.277-72.836l28.637-72.196 23.642-0.2681c13.003-0.14745 23.647 0.0776 23.653 0.5 0.0197 1.3834-84.285 193.73-85.493 195.06-1.4782 1.6249-40.073 2.2716-42.144 0.70612zm227.95-0.32143c-1.0829-1.0812-1.3234-22.665-1.3234-118.75v-117.43l-571.5-0.50345v-35l701-0.2725c385.55-0.14987 702.02-0.0262 703.27 0.27495 2.269 0.54637 2.273 0.58163 2 17.772l-0.2735 17.225-791.5 0.5025v118.03c0 107.01-0.14857 118.09-1.5916 118.64-0.87537 0.33592-9.9548 0.65929-20.177 0.71862-14.185 0.0823-18.898-0.20496-19.908-1.2136zm121.4 0.64601c-1.3829-0.85082 82.666-193.56 85.518-196.07 1.7369-1.5336 4.294-1.75 20.68-1.75 13.395 0 19.184 0.35504 20.41 1.2519 2.2779 1.6656 83.675 194.96 82.642 196.25-1.0259 1.2804-44.847 1.0247-46.141-0.26924-0.5127-0.51267-13.445-32.975-28.739-72.139-15.294-39.164-28.304-71.704-28.912-72.312-0.807-0.80699-1.3573-0.45413-2.0393 1.3076-10.711 27.669-56.607 142.66-57.196 143.3-0.9472 1.0294-44.59 1.4449-46.224 0.44004zm292.71-0.12427c-1.2201-0.68397-1.4265-14.896-1.4265-98.215 0-95.288 0.042-97.438 1.9343-98.45 2.0266-1.0846 46.819-1.4768 50.668-0.44364 1.5534 0.41698 7.2785 10.265 21.937 37.736 10.91 20.445 22.162 41.447 25.005 46.672 2.843 5.225 11.12 20.641 18.394 34.259s13.638 24.503 14.144 24.191c0.544-0.33622 0.9185-29.447 0.9185-71.402 0-63.669 0.16-70.895 1.5818-71.441 2.0618-0.79118 34.775-0.79118 36.836 0 1.4276 0.5478 1.5818 10.201 1.5818 99 0 78.017-0.2589 98.405-1.25 98.451-10.332 0.48159-50.15-0.0698-50.748-0.70275-0.827-0.87403-10.28-17.716-52.956-94.356-13.323-23.925-24.858-44.159-25.634-44.964-1.2157-1.2613-1.4135 8.1664-1.4267 68-0.01 38.205-0.3823 70.043-0.8308 70.749-0.9362 1.4754-36.24 2.3097-38.727 0.91511zm374.31 0.48414c-1.2483-0.23808-43.212-57.923-67.607-92.934-1.2455-1.7875-2.6838-3.25-3.1964-3.25-0.5624 0-0.938 18.538-0.9472 46.75-0.01 25.712-0.3784 47.322-0.8222 48.021-0.6191 0.97546-5.5602 1.2082-21.235 1l-20.428-0.27127-0.2584-97.5c-0.2407-90.776-0.1413-97.586 1.4411-98.75 1.213-0.89218 6.9202-1.25 19.937-1.25 15.246 0 18.495 0.25774 19.809 1.5714 1.383 1.3831 1.5714 7.0912 1.5714 47.622 0 42.169 0.1354 45.939 1.6058 44.718 0.8831-0.73296 17.539-21.887 37.013-47.009 22.742-29.338 36.207-45.891 37.644-46.276 3.5163-0.94245 49.079-0.69697 50.609 0.27268 0.7545 0.47797 1.2045 1.3211 1 1.8736-0.2046 0.55252-17.922 21.751-39.372 47.108s-39.132 46.92-39.294 47.918c-0.1767 1.0898 4.2348 7.5891 11.035 16.258 6.2313 7.9434 22.96 29.293 37.174 47.443 14.215 18.15 26.3 33.573 26.857 34.274 0.5569 0.70079 0.733 1.5538 0.3912 1.8955-0.6251 0.62516-49.84 1.1038-52.928 0.51474zm84.836-227.76c-1.3464-1.3464-1.5714-5.2224-1.5714-27.066 0-15.662 0.3993-26.24 1.0352-27.429 1.0101-1.8874 2.9589-1.9343 80.5-1.9343h79.465v58h-78.929c-70.42 0-79.098-0.1694-80.5-1.5714zm-1442.9-86.072c-1.0924-1.0924-0.8008-27.732 0.39042-35.665 7.312-48.694 38.495-85.782 79.128-94.111 6.8874-1.4119 30.732-1.5778 224-1.5584 210.29 0.021 216.54 0.0754 225.06 1.9604 26.8 5.9259 51.162 26.053 65.128 53.806 4.4108 8.7653 8.8545 21.817 11.137 32.711 2.2179 10.586 3.2522 39.849 1.4838 41.98-1.035 1.2472-4.1998 1.5205-17.604 1.5205-14.543 0-16.445-0.19271-17.274-1.75-0.51223-0.9625-1.1388-9.175-1.3923-18.25-0.57666-20.639-3.3014-31.128-11.892-45.779-4.7228-8.0547-17.027-20.093-24.585-24.053-12.395-6.4945 1.1564-6.1335-230.27-6.1335-231.38 0-217.85-0.35946-230.27 6.1209-9.7116 5.0689-21.186 17.203-27.078 28.634-6.9609 13.506-9.6526 24.989-10.481 44.71l-0.67177 16-17.061 0.2728c-9.3833 0.15004-17.371-0.0375-17.75-0.41667z",
                        fill: "#717171"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m35.571 1022.2c-28.8-0.5472-70.117-3.3704-94-6.423-42.779-5.4679-70.643-12.873-97.5-25.914-46.618-22.635-70.509-56.02-80.165-112.03-2.8234-16.375-2.5436-56.227 0.50881-72.462 5.2645-27.999 14.447-44.638 28.854-52.283 7.5482-4.0052 15.464-5.4475 27.803-5.0654l10 0.30968 0.27561 16.425c0.20926 12.471-0.0315 16.62-1 17.235-0.70159 0.44524-5.2828 0.81643-10.18 0.82485l-8.9048 0.0153-3.6514 3.8385c-7.6333 8.0243-10.489 23.305-10.496 56.162-6e-3 29.042 2.3926 44.806 9.459 62.17 6.4331 15.808 19.675 32.539 33.498 42.324 26.777 18.955 67.295 30.196 129.5 35.927 44.775 4.1256 38.195 4.0792 578 4.0749 518.68-4e-3 561.68-0.23861 648.5-3.5345 182.42-6.9254 258.37-24.138 338.29-76.669 27.25-17.91 46.315-38.148 57.206-60.726 13.442-27.867 9.469-47.991-11.376-57.618-11.017-5.0883-18.406-5.9467-51.331-5.9636-16.386-8e-3 -30.366-0.37961-31.068-0.82485-0.9685-0.61463-1.2093-4.764-1-17.235l0.2756-16.425 29.5-0.27859c41.096-0.38811 56.336 2.1172 74.564 12.257 7.9836 4.4411 19.745 15.693 23.939 22.902 7.7707 13.356 10.605 29.21 8.1712 45.713-5.7332 38.882-34.107 76.89-80.175 107.4-78.839 52.209-154.34 71.709-309.5 79.94-108.55 5.7579-114.94 5.8147-677.5 6.0198-283.8 0.1034-522.52 0.064-530.5-0.087zm-164.39-153.94c-0.7933-2.0673-0.7933-191.77 0-193.84 0.54214-1.4128 5.878-1.5818 49.949-1.5818 63.368 0 74.473 1.2907 92.944 10.802 10.064 5.1822 21.938 17.278 26.699 27.198 12.717 26.498 16.179 65.436 8.8165 99.171-3.8154 17.482-12.046 33.175-22.174 42.282-5.9026 5.3069-18.722 11.885-27.341 14.03-11.459 2.8515-25.281 3.4827-76.643 3.4999-46.179 0.0155-51.707-0.15002-52.25-1.5645zm101.67-34.89c17.126-3.6291 26.604-14.089 31.978-35.295 1.9154-7.5572 2.2057-11.293 2.1548-27.734-0.0501-16.168-0.37563-20.149-2.1843-26.707-4.1577-15.076-11.544-25.852-21.04-30.696-8.6548-4.4153-15.272-5.1482-43.916-4.8632l-26.774 0.26638-0.25927 62c-0.1426 34.1-0.0442 62.562 0.21861 63.25 0.7255 1.8977 50.693 1.7126 59.821-0.22149zm224.22 35.83c-15.321-1.7464-22.082-2.9165-28.5-4.9321-36.663-11.514-57.725-55.791-51.95-109.22 4.0962-37.9 23.995-67.489 52.295-77.762 10.522-3.8193 19.454-4.4488 63.121-4.4488 36.757 0 41.388 0.17472 41.928 1.5818 1.1845 3.0867 0.67155 30.954-0.59301 32.218-0.88739 0.88739-10.331 1.202-36.25 1.2076-19.516 4e-3 -37.931 0.47065-41.55 1.0525-12.795 2.0569-22.223 8.5258-27.445 18.832-2.716 5.3597-4.8764 16.623-4.3696 22.78l0.31499 3.8275 110 1v33l-110 1-0.34376 2.4347c-0.51515 3.6487 1.7004 13.684 4.3375 19.647 2.9552 6.6822 9.5945 13.923 15.521 16.925 10.653 5.3982 13.84 5.7765 52.479 6.2292 22.898 0.26831 36.45 0.80132 37.25 1.4651 0.90588 0.75181 1.2572 5.1776 1.2572 15.839 0 8.1377-0.27314 15.508-0.60699 16.378-0.53968 1.4064-4.6702 1.5652-37.25 1.432-20.154-0.0824-37.993-0.30372-39.643-0.49181zm234.21-7.5888c-26.158-61.08-78.613-187.12-78.172-187.83 0.68059-1.1012 43.425-1.2621 45.057-0.16955 0.60333 0.40408 13.738 33.135 29.187 72.735 15.559 39.88 28.676 72.12 29.403 72.269 0.86498 0.1774 4.7891-8.5217 11.503-25.5 5.6046-14.173 18.378-46.469 28.386-71.769s18.64-46.562 19.182-47.25c1.5429-1.9545 45.742-1.7906 45.742 0.1697 0 0.78083-19.078 44.993-42.396 98.25l-42.396 96.83-41.954 0.53904zm231.95 7.5638c-0.36667-0.36666-0.66667-53.412-0.66667-117.88 0-97.195-0.2306-117.4-1.3504-118.33-0.98867-0.82052-77.662-1.1881-286.25-1.3724l-284.9-0.25174v-33h1406v33l-394.9 0.25126c-289.92 0.18446-395.26 0.5493-396.25 1.3724-1.1206 0.93003-1.351 21.219-1.351 119v117.88h-19.833c-10.908 0-20.133-0.3-20.5-0.66667zm121.33-0.75609c0-0.78252 19.062-44.995 42.361-98.25l42.361-96.827 41.987-0.53893 2.564 5.7695c6.8128 15.33 79.727 189.29 79.727 190.21 0 1.6415-45.619 1.4541-46.315-0.1902-0.291-0.6875-13.119-33.425-28.506-72.75-16.158-41.295-28.548-71.612-29.328-71.765-1.3767-0.2699-4.1073 6.3832-41.15 100.26-9.3316 23.65-17.412 43.562-17.956 44.25-0.7386 0.93329-6.6591 1.25-23.367 1.25-18.685 0-22.378-0.2348-22.378-1.4228zm292-97.072v-98.538l53.422 0.53267 38.039 71.228c20.921 39.175 38.598 71.238 39.282 71.25 0.9774 0.0172 1.2983-15.222 1.5-71.228l0.2567-71.25h39v196l-50.459 0.53426-2.0966-3.2671c-1.1532-1.7969-19.05-33.606-39.77-70.686-20.72-37.08-38.124-67.343-38.674-67.25-0.65 0.10949-1.175 24.755-1.5 70.419l-0.5 70.25-38.5 0.54319zm261-5e-3v-98.541l40.5 0.54141 0.5 47c0.31 29.14 0.8662 47 1.4637 47 0.53 0 15.956-19.35 34.279-43s34.9-44.912 36.836-47.25l3.5207-4.25h26.45c14.548 0 26.448 0.3375 26.444 0.75 0 0.4125-18.003 22.049-40 48.081-21.997 26.032-39.994 47.77-39.994 48.306s17.1 22.779 38 49.428c20.9 26.649 38 48.898 38 49.444 0 0.62971-9.6063 0.99109-26.345 0.99109-23.824 0-26.496-0.16743-27.918-1.75-0.8652-0.9625-16.476-22.675-34.691-48.25-18.215-25.575-33.772-46.645-34.572-46.821-1.2542-0.2772-1.4902 6.3316-1.7141 48l-0.2596 48.321-40.5 0.54141v-98.541zm198.67-129.17c-0.3667-0.36666-0.6667-12.967-0.6667-28v-27.333h78.418c43.13 0 79.13-0.27314 80-0.60699 1.4197-0.54478 1.5818 2.325 1.5818 28v28.607h-79.333c-43.633 0-79.633-0.3-80-0.66667zm-1442.6-86.254c-1.1596-0.73411-1.2926-3.8388-0.75994-17.735 0.69392-18.103 2.1272-27.169 6.2952-39.82 12.933-39.254 42.117-66.479 77.782-72.561 4.1166-0.70192 76.522-0.94284 223.59-0.74395l217.5 0.29413 8.5 2.8562c27.281 9.1668 46.944 26.565 60.438 53.475 8.808 17.566 12.554 34.986 12.559 58.404l3e-3 15.75h-34.74l-0.54176-16.25c-0.62936-18.878-2.656-28.59-8.5851-41.144-8.9361-18.92-23.092-31.756-39.826-36.115-4.9901-1.2998-33.283-1.4917-219.91-1.4917-211.01 0-214.28 0.0294-220.54 1.9896-20.423 6.3936-35.765 23.941-43.465 49.714-2.244 7.5104-2.7023 11.282-3.1351 25.797-0.32656 10.953-0.90672 17.261-1.6309 17.735-1.6082 1.0512-31.845 0.9112-33.53-0.15521z",
                        fill: "#4e4e4e"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m29.571 1021.8c-55.882-1.7862-105.47-7.3992-138.36-15.662-72.861-18.305-112.97-56.234-124.62-117.84-1.1438-6.05-2.6296-13.475-3.3019-16.5-1.6409-7.3837-1.6511-50.549-0.0137-58 0.66472-3.025 2.3369-10.848 3.7159-17.384 4.7308-22.422 14.378-37.309 28.524-44.012 6.3916-3.0288 6.9054-3.1046 21.051-3.1046h14.5v32l-9.6832 0.5c-7.7711 0.40127-10.238 0.91534-12.494 2.6033-5.3783 4.0248-9.2871 14.761-11.411 31.342-1.6767 13.089-1.3666 45.629 0.55625 58.366 6.8424 45.324 29.127 72.769 73.032 89.943 32.255 12.617 77.441 19.654 146 22.738 29.208 1.3137 999.15 1.3218 1076 9e-3 256.87-4.3882 340.21-18.079 426.7-70.098 31.449-18.913 49.825-34.88 64.159-55.746 5.4254-7.8981 12.297-22.441 14.232-30.118 2.506-9.9446 1.6296-22.029-2.0933-28.861-4.5952-8.434-12.396-13.587-26.334-17.395-6.7774-1.8517-11.448-2.1643-40.169-2.6884l-32.5-0.5931-0.2767-15.365c-0.2018-11.211 0.063-15.775 0.9796-16.879 1.0923-1.3162 5.4336-1.439 33.277-0.94178 34.092 0.60887 41.1 1.3838 55.307 6.1151 23.631 7.8698 41.152 26.441 45.825 48.571 2.0409 9.6651 1.3626 26.449-1.5089 37.341-9.4248 35.748-40.102 72.351-83.401 99.508-93.53 58.664-172.76 73.992-414.7 80.225-22.275 0.5738-43.875 1.2297-48 1.4575-12.828 0.7085-1033.3 1.1633-1055 0.4701zm-157.54-153.25c-0.26204-0.6875-0.36042-44.9-0.21862-98.25l0.25783-97 51 0.044c61.215 0.0528 69.881 0.97771 88 9.3914 23.042 10.7 36.031 32.653 40.547 68.532 1.5389 12.226 0.66516 43.967-1.5011 54.532-6.9765 34.025-23.255 53.308-50.67 60.021-11.585 2.8366-34.81 3.9138-85.158 3.9494-32.526 0.023-41.887-0.24729-42.258-1.2204zm102.96-35.141c12.458-3.5222 19.327-9.1075 24.929-20.271 6.4634-12.88 9.7233-35.456 7.7802-53.879-2.1471-20.356-6.6562-31.838-16.005-40.756-10.376-9.8971-20.281-11.944-55.629-11.496l-23 0.2917-0.25921 63c-0.14257 34.65-0.0263 63.609 0.25838 64.354 0.81138 2.122 53.784 1.0576 61.926-1.2443zm225.57 35.323c-24.502-1.4252-39.041-5.7173-51.5-15.203-14.464-11.012-25.053-29.54-30.137-52.73-1.5041-6.8614-1.857-12.645-1.8309-30 0.0289-19.168 0.28801-22.529 2.3894-30.989 7.1043-28.6 22.943-50.034 44.392-60.071 11.591-5.4241 17.307-5.9403 65.774-5.9403h43.912v32.819l-38.25 0.45213c-40.288 0.47622-44.429 0.90158-53.295 5.4743-5.3765 2.773-12.083 10.191-14.988 16.58-2.3803 5.2346-5.1353 21.492-4.0994 24.192 0.48315 1.259 8.2997 1.5026 55.347 1.7247l54.785 0.25856v33l-54.785 0.25856c-47.101 0.22229-54.864 0.46462-55.348 1.7278-0.86821 2.2625 2.231 15.955 4.9609 21.918 4.9358 10.781 12.923 16.846 27.348 20.765 7.0957 1.9278 11.11 2.1683 43.098 2.5827l35.274 0.45695-0.27371 16.645-0.2737 16.645-29.5 0.10904c-16.225 0.06-35.575-0.24434-43-0.67625zm235.23 0.23298c-1.1654-0.73972-80.547-187.8-81.874-192.93l-0.58656-2.2691 45.411 0.53813 28.279 72.457c15.553 39.851 28.719 72.604 29.258 72.783s1.421-0.25115 1.9613-0.95697c0.54024-0.70581 13.755-33.571 29.366-73.033l28.384-71.75h22.891c17.905 0 22.785 0.27227 22.405 1.25-5.0748 13.069-84.467 192.62-85.563 193.5-1.7688 1.4283-37.746 1.8029-39.932 0.41577zm227.91-0.49213c-0.8303-1.0004-1.2042-32.948-1.39-118.77l-0.25415-117.4-571-1v-33h1404l0.2742 16.749 0.2741 16.749-791.55 0.5025-1 237-19.11 0.2711c-15.204 0.21569-19.342-9e-3 -20.246-1.0975zm121.43 0.44298c-0.5254-0.85 82.688-192.32 84.691-194.87 1.1373-1.4483 38.31-1.8074 40.542-0.39161 1.5461 0.98059 83.206 194.3 82.536 195.39-0.6326 1.0332-42.523 0.92138-44.162-0.11784-0.7262-0.46047-14.041-33.416-29.588-73.235-17.798-45.584-28.805-72.502-29.718-72.68-1.0522-0.20501-5.938 11.049-17.799 41-35.824 90.458-41.428 104.31-42.48 105.02-1.5689 1.0534-43.368 0.94124-44.022-0.11807zm291.89-0.36662c-0.2621-0.6875-0.3604-44.9-0.2186-98.25l0.2578-97 51.449-0.53366 2.4091 3.7668c1.325 2.0718 18.497 33.917 38.16 70.767s36.208 67.577 36.766 68.283c3.0232 3.8206 3.2185 0.0946 3.7153-70.866l0.5-71.417h37v196l-24 0.24467c-13.2 0.13457-24.515-0.0904-25.144-0.5-0.629-0.40957-18.331-31.57-39.338-69.245-42.034-75.385-40.66-73-42.041-73-0.6266 0-0.9769 25.206-0.9769 70.3 0 53.344-0.2894 70.589-1.2 71.5-1.7422 1.7422-36.674 1.6955-37.339-0.05zm261 0c-0.2621-0.6875-0.3604-44.9-0.2186-98.25l0.2578-97 18.87-0.27251c13.072-0.18877 19.294 0.0793 20.25 0.87245 1.1365 0.9432 1.3796 9.3171 1.3796 47.522 0 37.822 0.2443 46.378 1.3242 46.378 0.7284 0 17.266-20.582 36.75-45.738 19.484-25.156 36.213-46.531 37.176-47.5 1.5778-1.5882 4.2044-1.7615 26.691-1.7615 15.201 0 25.177 0.38252 25.546 0.97952 0.5088 0.82312-22.651 28.753-69.192 83.443-5.1122 6.0072-9.2949 11.697-9.2949 12.644 0 0.9468 17.051 23.482 37.891 50.078s37.689 48.694 37.441 49.106-11.899 0.75-25.891 0.75c-23.164 0-25.598-0.16078-27.191-1.7965-0.9625-0.98806-16.825-23.03-35.25-48.981-18.425-25.952-34.062-47.193-34.75-47.204-0.9828-0.0148-1.25 10.198-1.25 47.781 0 35.844-0.3001 48.1-1.2 49-1.7451 1.7452-38.673 1.6982-39.339-0.05zm198.64-227.12c-0.8044-0.96919-1.0609-9.1273-0.8725-27.75l0.2669-26.377 159.5-0.51197v56.012h-78.878c-65.644 0-79.069-0.23031-80.017-1.3728zm-1443.1-99.877c0.0299-21.506 2.1265-33.314 9.1271-51.403 7.6215-19.694 23.735-39.856 40.529-50.71 7.3265-4.7352 19.62-10.173 25.532-11.294 1.8106-0.34325 3.9236-1.1233 4.6956-1.7334 2.0907-1.6522 442.85-1.5743 446.19 0.0789 1.3208 0.65349 5.0719 1.9277 8.3358 2.8315s9.3389 3.3554 13.5 5.4478c36.388 18.298 58.947 60.425 57.853 108.03l-0.28733 12.5h-34l-0.63282-17.5c-0.68262-18.877-2.1199-25.985-7.778-38.464-9.105-20.081-26.626-35.216-44.523-38.461-4.1135-0.74572-70.372-1.0704-216-1.0583-176.45 0.0146-211.13 0.24195-216.69 1.421-17.579 3.7261-32.321 16.405-41.931 36.062-6.7254 13.757-8.9009 23.402-9.6423 42.75l-0.60357 15.75h-33.701l0.0198-14.25z",
                        fill: "#313131"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m21.071 1020.9c3.1707-0.3819-2.5003-0.8741-15.5-1.3454-66.498-2.4104-118.05-11.56-154.22-27.374-41.272-18.042-68.768-48.232-80.359-88.23-2.7467-9.4782-6.3844-28.562-6.4925-34.06-0.0549-2.795-0.24072-3.1387-0.85132-1.5751-0.47498 1.2163-1.0687-3.4249-1.5152-11.844-0.8174-15.414 0.20123-40.635 1.5549-38.499 0.56321 0.88864 0.85748 0.15884 0.86972-2.157 0.0273-5.1712 2.7863-20.05 5.1473-27.759 3.1125-10.163 9.3967-21.487 15.075-27.166 8.8378-8.8378 20.088-12.47 36.789-11.877l8.5 0.30169 0.54956 31.259-9.5126 0.41605c-11.632 0.50876-13.728 1.7569-18.237 10.862-5.4233 10.951-6.8055 21.47-6.7627 51.462 0.042 29.412 1.0643 37.376 7.1628 55.797 4.9776 15.036 11.772 26.149 22.8 37.296 10.24 10.35 17.166 15.298 31.182 22.277 30.974 15.424 67.359 22.632 142.82 28.292 12.026 0.90201 136.35 1.2946 500.5 1.5805 537.51 0.42195 626.6-0.16422 724-4.7634 162.02-7.6505 236.47-26.021 312.79-77.183 24.602-16.49 44.705-37.826 54.93-58.297 5.781-11.574 7.7222-19.087 7.7506-30 0.023-8.9727-0.2634-10.59-2.792-15.739-4.6835-9.5375-13.9-15.527-29.682-19.287-6.0911-1.4514-13.375-1.873-38.775-2.2439l-31.275-0.45677 0.5496-31.273 26-0.30543c39.77-0.4672 54.611 1.671 72.5 10.445 17.29 8.4806 30.256 24.29 34.529 42.101 2.7728 11.557 1.6985 29.76-2.5234 42.759-12.09 37.226-40.827 69.584-87.005 97.971-16.881 10.377-44.312 24.688-59.586 31.088-73.581 30.827-174 43.07-378.91 46.194-28.946 0.4412-44.498 0.973-38 1.2993 6.05 0.3038-227.5 0.5706-519 0.5929-291.5 0.022-527.75-0.2305-525-0.5617zm-148.5-249.67v-97.583l53.25 0.45605c57.461 0.49211 62.06 0.86291 77.506 6.2497 14.814 5.1663 26.971 14.734 34.202 26.918 4.46 7.5152 10.365 25.316 12.62 38.043 3.9174 22.11 1.5248 57.845-5.1251 76.547-6.1776 17.374-17.727 31.678-30.467 37.733-16.905 8.0352-28.589 9.1824-93.737 9.2038l-48.25 0.0158v-97.583zm101.5 63.126c14.279-3.8174 21.171-9.4435 27.001-22.043 5.8457-12.633 7.0002-19.57 6.9893-42-0.0107-21.941-0.89149-27.281-6.4755-39.259-3.5398-7.5929-11.613-16.385-17.794-19.377-8.7754-4.2481-14.533-5.0161-41.806-5.5758-18.777-0.3854-26.692-0.21087-28.25 0.62296l-2.1644 1.1584v63.415c0 59.31 0.11328 63.486 1.75 64.514 2.827 1.7751 53.177 0.56812 60.75-1.4563zm220.51 33.34c-10.71-0.94989-18.193-2.2907-25.508-4.5709-25.621-7.9861-44.379-32.748-49.857-65.812-6.3484-38.319 1.2483-74.642 20.341-97.259 6.8273-8.0875 16.671-16.001 24.408-19.62 11.765-5.5044 15.538-5.8794 63.858-6.348l44.75-0.43399v31.929l-36.75 0.51473c-39.771 0.55704-46.468 1.311-54.748 6.1631-6.0005 3.5165-13.044 11.715-15.342 17.857-2.5909 6.9249-4.5285 22.548-3.0215 24.364 0.89732 1.0812 11.389 1.3333 55.484 1.3333h54.378v32h-54.378c-43.828 0-54.59 0.25617-55.473 1.3204-1.3544 1.6319-0.0145 10.851 2.7412 18.861 5.1798 15.055 14.046 22.147 33.11 26.482 4.7018 1.0693 15.837 1.6343 40.25 2.0424l33.75 0.56415v31.73l-34.25-0.13752c-18.838-0.0756-38.521-0.51635-43.742-0.97936zm240.07-1.1124c-0.48832-1.2489-18.541-44.121-40.118-95.271-21.576-51.15-39.448-94.021-39.716-95.27l-0.48589-2.2698 43.522 0.53968 20.908 53.5c36.789 94.137 36.114 92.5 38.157 92.5 1.4494 0 3.1226-3.2253 7.7816-15 3.2643-8.25 12.273-30.975 20.019-50.5s17.91-45.175 22.586-57c4.6757-11.825 8.9536-22.062 9.5065-22.75 0.74608-0.92778 6.3717-1.25 21.824-1.25 11.45 0 21.026 0.3375 21.28 0.75s-18.542 44.175-41.769 97.25l-42.231 96.5-20.189 0.27076c-20.179 0.27062-20.189 0.26962-21.077-2zm229.59 1.5626c-0.36667-0.36666-0.66667-53.377-0.66667-117.8 0-89.77-0.28033-117.41-1.2-118.33-0.92772-0.92772-65.822-1.2-286-1.2h-284.8v-32.001l1403.5 0.50142v31l-394.9 0.25126c-289.92 0.18446-395.26 0.5493-396.25 1.3724-1.1206 0.93003-1.351 21.219-1.351 119v117.88h-18.833c-10.358 0-19.133-0.3-19.5-0.66667zm121.33 0.095c0-0.4555 72.38-166.17 82.422-188.7l2.5715-5.7707 40.221 0.54143 33.937 80.5c18.665 44.275 37.024 87.843 40.797 96.818 4.5546 10.834 6.4634 16.47 5.68 16.771-0.6489 0.24903-10.569 0.33083-22.045 0.1818l-20.865-0.27097-22.85-58.5c-12.568-32.175-25.404-65.159-28.526-73.298-4.8328-12.6-5.9658-14.753-7.6307-14.5-2.0929 0.31864-0.071-4.554-40.166 96.798-10.335 26.125-19.241 48.062-19.79 48.75-0.7433 0.92985-6.4744 1.25-22.377 1.25-11.758 0-21.378-0.25727-21.378-0.57171zm292-96.923v-97.539l51.5 0.53376 15.808 29.5c8.6943 16.225 25.288 47.275 36.874 69 24.459 45.862 24.538 46 26.393 46 1.2004 0 1.4503-10.82 1.6684-72.25l0.2566-72.25h37v194l-49.049 0.53395-1.6126-2.767c-1.5031-2.579-9.6756-17.228-59.144-106.02-14.062-25.238-19.556-34.25-20.882-34.25-1.713 0-1.8115 3.4123-2.0558 71.25l-0.2567 71.25-36.5 0.54512zm261-6e-3v-97.543l38.5 0.54319 0.5 47.5c0.4294 40.793 0.7066 47.5 1.9629 47.5 0.8046 0 17.231-20.328 36.502-45.172 19.272-24.845 36.048-46.332 37.28-47.75l2.2413-2.5777h25.09c13.8 0 24.94 0.36788 24.757 0.81751-0.2774 0.68035-45.16 53.988-71.583 85.02-3.9875 4.6831-7.25 9.2928-7.25 10.244s13.357 18.759 29.682 39.574c43.071 54.915 45.278 57.769 45.299 58.594 0.01 0.4125-11.355 0.75-25.256 0.75h-25.275l-34.92-49c-23.884-33.514-35.487-49-36.716-49-1.6997 0-1.8098 2.6101-2.0554 48.75l-0.2595 48.75-38.5 0.54319zm277-129.49-78.5-0.50915-0.2663-26.75-0.2664-26.75h77.935c42.864 0 78.646-0.27314 79.516-0.60699 1.4193-0.54462 1.5818 2.281 1.5818 27.5 0 15.459-0.3375 27.999-0.75 27.866s-36.075-0.46997-79.25-0.75zm-1521.6-102.73c0.82331-18.455 3.0638-30.992 7.9932-44.727 11.913-33.193 37.671-58.193 67.528-65.539 4.1691-1.0258 6.9051-1.9578 6.0801-2.0711s0.75-0.55647 3.5-0.9848c6.0211-0.93783 424.55-1.2319 433.42-0.30451 3.9123 0.40891 5.726 0.95883 4.8967 1.4847-0.91028 0.57721-0.54489 0.84271 1.1828 0.85947 4.7523 0.0461 21.841 6.6999 29.656 11.547 14.949 9.272 30.353 27.112 38.788 44.923 7.6422 16.136 10.524 29.538 11.244 52.286l0.57735 18.25h-33.01l-0.52744-16.75c-0.43379-13.776-0.9657-18.259-2.9955-25.25-7.5054-25.848-22.242-43.434-42.34-50.526l-6.893-2.4323-216.14-0.0211c-212.81-0.0208-216.24 0.01-222.57 1.9642-19.726 6.0927-35.822 24.526-43.417 49.718-2.296 7.6168-2.7148 11.11-3.1226 26.047l-0.47084 17.25h-34.075l0.70148-15.724z"
                    })
                ]
            })
        })
    });
}

});

parcelRegister("6SOfv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cbfa313971884846$var$OSMLogoComponent;

var $ayMG0 = parcelRequire("ayMG0");
function $cbfa313971884846$var$OSMLogoComponent() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "osm-logo",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "105.75",
            height: "81.75",
            version: "1.1",
            viewBox: "0 0 423 327",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m27.815 23.294c-11.606 3.5713-17.11 29.486-19.884 40-10.217 38.725-17.269 96.384 13.899 128 13.504 13.697 32.665 17.282 46.971 29.595 11.696 10.068 16.344 26.334 32.015 31.861 13.602 4.797 35.619 2.697 40.072-13.452 3.761-13.641-5.533-21.258-16.072-27.947-3.42-2.17-14.104-6.734-12.654-11.999 2.702-9.813 22.781 0.86 29.654-0.383 5.095-0.922 10.215-5.166 5.566-10.142-13.613-14.568-57.879-14.869-54.196 13.471 2.0815 16.017 24.102 15.975 28.374 29.014 1.807 5.514-5.612 8.199-9.744 7.453-13.16-2.378-28.397-11.874-31.76-25.467-2.2681-9.167 0.7153-17.843 1.5902-27 0.838-8.77-0.8593-17.596-3.2577-26-8.1988-28.731-26.19-53.575-37.561-81-7.6769-18.516-8.4973-37.039-13.012-56m-3 12c7.7513 61.014 61.419 111.11 47 174-22.112-10.34-23.997-44.323-43-58l28 54c-51.585-17.565-55.809-77.82-48.246-124 2.24-13.678 5.5884-36.265 16.246-46m86 78.465c-19.681 3.542-28.907 21.835-25.536 40.535 1.4772 8.193 8.6038 22.616 18.517 22.638 5.315 0.012 6.641-6.541 5.312-10.638-1.997-6.161-7.12-10.393-8.47-17-2.4088-11.793 8.604-25.291 21.177-21.347 18.599 5.834 9.874 25.879 5.086 37.347-1.716 4.107-2.02 10.916 3.933 10.836 12.746-0.17 17.733-19.797 17.966-29.836 0.516-22.163-16.007-36.491-37.985-32.535m61 65.535c6.527 0.018 13.551 2.087 20 0.606 15.861-3.645 17.45-27.67 6.895-37.381-6.72-6.183-14.825-3.325-22.895-3.229-4.85 0.058-14.023-1.829-16.972 3.152-3.851 6.504-1.063 21.398-1.027 28.852 0.025 5.227-1.158 20.379 2.027 24.397 8.289 10.458 11.678-12.673 11.972-16.397m52-14c5.538-1.028 11.659-0.129 17-1.804 8.482-2.661 13.133-13.158 5.856-19.806-12.905-11.787-37.034-3.067-37.815 14.61-0.576 13.049 7.361 21.259 19.959 23.38 5.56 0.937 14.999 0.229 17.968-5.434 4.557-8.694-17.963-7.243-22.968-10.946m33-25c0 10.333-0.07 20.668 1e-3 31 0.026 3.811 0.482 9.465 5.895 8.458 2.804-0.522 3.64-3.017 4.165-5.473 1.296-6.066 0.326-13.519 3.796-18.941 4.635-7.241 12.502-5.075 13.839 2.956 0.438 2.635 0.529 5.348 0.88 8 0.53 4.018 0.682 8.003 1.424 12 2.932-0.025 6.953 0.362 9.258-1.858 5.337-5.142 2.509-28.196-2.402-32.914-7.658-7.356-26.886-3.2-36.856-3.228m-17 10v2c-5.582 2.355-10.369 2.109-16 0v-2h16m-58.999 1.36c10.054-1.759 13.811 11.754 2.998 13.396-9.815 1.491-13.522-11.556-2.998-13.396m161.31 38.669c-4.468 2.904-2.152 9.689-3.917 13.827-1.275 2.989-5.557 3.645-5.735 7.198-0.22 4.38 4.787 6.971 5.904 10.961 2.125 7.588-0.367 16.708 2.948 23.966 2.583 5.654 13.921 8.342 19.168 4.84 8.739-5.832-7.14-13.269-7.623-18.822-0.349-3.999-0.472-9.444 2.455-12.57 2.264-2.418 6.426-2.727 7.109-6.482 1.038-5.703-5.274-4.894-7.61-8.264-2.883-4.16-2.087-21.552-12.699-14.654m-32.314 60.971c0-8.226-1.8-20.965 3.653-27.867 4.825-6.106 16.047-2.184 16.898-12.114 0.904-10.558-16.312-1.55-20.551-1.416-3.867 0.122-8.004-2.747-11.697-0.42-4.748 2.992-3.303 12.1-3.303 16.817 0 13.812-1.872 25.983 15 25m-142 1c0-4.406 0.199-8.627 0.715-13 0.353-2.993 0.265-5.993 0.286-9 0.045-6.503 5.739-14.483 11.061-5.941 4.053 6.505-1.277 31.654 11.894 28.328 11.071-2.795 0.128-33.288 14.043-31.921 11.037 1.084 6.637 21.57 9.739 28.401 1.917 4.219 8.512 4.8 11.083 0.83 5.071-7.832 0.203-37.24-8.836-40.803-8.371-3.3-15.237 4.029-22.985 2.274-3.834-0.868-7.059-3.397-11-3.951-5.049-0.71-9.966 1.435-15 1.328-4.132-0.088-10.051-1.996-13.566 1.058-2.653 2.306-2.416 6.213-2.433 9.397-0.038 7.105-3.021 24.968 1.741 30.566 2.975 3.497 9.178 2.434 13.258 2.434m80-44.347c-14.629 4.588-17.587 29.31-6.815 38.957 9.911 8.874 19.841 3.178 30.815 1.6 3.646-0.524 8.318 0.769 11.721-0.813 3.111-1.446 3.186-5.447 3.264-8.397 0.195-7.323 2.5-22.705-2.588-28.682-2.964-3.483-6.699-1.151-10.397-1.243-8.555-0.214-17.164-4.194-26-1.422m11.015 15.825c8.692-1.897 12.234 11.546 2.97 13.228-9.222 1.674-11.977-11.263-2.97-13.228m21.985 42.522h13c-2e-3 -2.892 0.651-7.144-1.603-9.397-7.053-7.046-12.473 3.305-11.397 9.397m-182 28h2c2.898 6.971 9.449 30.897 18.986 30.222 8.493-0.6 14.217-23.496 17.014-30.222h2c5.004 13.628-0.082 31.947 19 32 0-18.054-0.869-36.095-3.282-54-1.328-9.848-7.336-17.276-18.504-12.397-6.262 2.736-7.756 16.619-10.026 22.397-1.045 2.662-2.615 7.793-6.217 7.793-3.33 0-5.418-4.301-6.697-6.793-4.699-9.152-5.636-24.085-18.274-23.995-2.9019 0.02-6.2034 0.031-8.2585 2.429-2.9231 3.409-2.7298 10.307-3.3163 14.566-1.7938 13.023-5.8375 31.056-3.0811 43.981 1.2143 5.694 9.0329 8.18 12.492 2.791 4.8863-7.614 3.4362-20.166 6.1644-28.772m211.23-31.243c-5.187 2.251-3.074 9.934-4.83 14.11-1.234 2.935-5.359 3.846-5.62 7.24-0.356 4.632 5.08 7.516 6.008 11.908 2.433 11.505-0.038 37.596 21.066 28.382 10.492-4.581-6.369-14.437-6.793-19.397-0.33-3.851-0.216-8.66 2.455-11.722 2.133-2.446 6.314-2.931 7.149-6.411 1.539-6.412-5.13-5.474-7.639-9.184-3.127-4.623-1.093-19.571-11.796-14.926m-121.23 19.687c-29.938 4.464-23.526 48.066 6 44.267 31.282-4.025 24.161-48.765-6-44.267m93.603 0.58399c-2.393 1.895-1.51 6.318-1.693 8.972-0.567 8.237-2.795 22.034 0.693 29.772 1.543 3.422 7.056 4.043 9.963 2.049 2.779-1.906 2.418-5.872 2.433-8.821 0.043-8.062 2.964-23.434-0.602-30.682-1.49-3.028-8.368-3.211-10.794-1.29m104.4-0.028c-4e-3 6.047-0.99 11.96-1 18-7e-3 4.461-0.349 33.032 11.262 21.397 5.703-5.716 1.344-17.572 6.441-24.264 3.287-4.315 8.635-3.987 13.254-5.746 2.932-1.117 7.447-5.26 4.972-8.784-1.644-2.34-6.488-1.696-8.929-1.56-8.837 0.492-16.953 0.95699-26 0.95699m-37 0.533c-13.279 3.207-19.023 20.512-11.348 31.463 5.75 8.205 15.948 10.496 25.348 8.323 14.031-3.243 19.841-20.719 11.351-32.279-5.627-7.662-16.473-9.651-25.351-7.507m-94 40.467c3.162 0 7.917 0.798 10.411-1.603 5.563-5.355 3.124-28.071-1.69-33.183-7.572-8.043-15.875-2.687-24.721-2.572-3.819 0.05-9.118-3.043-12.397 0.104-3.517 3.377-1.603 13.763-1.603 18.254 0 5.195-2.671 20.219 5.039 20.793 13.338 0.994 1.775-32.615 17.917-28.976 7.624 1.719 6.783 21.114 7.044 27.183m101-29.562c11.606-1.37 13.345 16.982 1.999 18.398-12.597 1.573-14.341-16.941-1.999-18.398m-167 0.996c12.364-3.363 18.066 15.377 5.981 19.051-12.567 3.821-18.356-15.684-5.981-19.051z",
                fill: "#61b907"
            })
        })
    });
}

});

parcelRegister("bBQKz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $873c117b1fb2dd29$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $873c117b1fb2dd29$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $873c117b1fb2dd29$var$_exportNames = {
    buttonClasses: true
};
Object.defineProperty(module.exports, "buttonClasses", {
    enumerable: true,
    get: function() {
        return $873c117b1fb2dd29$var$_buttonClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $873c117b1fb2dd29$var$_Button.default;
    }
});

var $873c117b1fb2dd29$var$_Button = $873c117b1fb2dd29$require$_interopRequireDefault((parcelRequire("6lXkL")));

var $873c117b1fb2dd29$var$_buttonClasses = $873c117b1fb2dd29$require$_interopRequireWildcard((parcelRequire("1xAC3")));
Object.keys($873c117b1fb2dd29$var$_buttonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($873c117b1fb2dd29$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $873c117b1fb2dd29$var$_buttonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $873c117b1fb2dd29$var$_buttonClasses[key];
        }
    });
});

});
parcelRegister("6lXkL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a02bab8c70a697b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a02bab8c70a697b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a02bab8c70a697b$var$React = $4a02bab8c70a697b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4a02bab8c70a697b$var$_propTypes = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4a02bab8c70a697b$var$_clsx = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4a02bab8c70a697b$var$_resolveProps = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $4a02bab8c70a697b$var$_composeClasses = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hGPki = parcelRequire("hGPki");

var $4a02bab8c70a697b$var$_rootShouldForwardProp = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $4a02bab8c70a697b$var$_memoTheme = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $4a02bab8c70a697b$var$_ButtonBase = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $4a02bab8c70a697b$var$_CircularProgress = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("1sBf1")));

var $4a02bab8c70a697b$var$_capitalize = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $4a02bab8c70a697b$var$_createSimplePaletteValueFilter = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $4a02bab8c70a697b$var$_buttonClasses = $4a02bab8c70a697b$require$_interopRequireWildcard((parcelRequire("1xAC3")));

var $4a02bab8c70a697b$var$_ButtonGroupContext = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("bwtSM")));

var $4a02bab8c70a697b$var$_ButtonGroupButtonContext = $4a02bab8c70a697b$require$_interopRequireDefault((parcelRequire("3eDio")));

var $ayMG0 = parcelRequire("ayMG0");
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $4a02bab8c70a697b$var$_capitalize.default)(color)}`,
            `size${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`,
            `${variant}Size${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`,
            `color${(0, $4a02bab8c70a697b$var$_capitalize.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $4a02bab8c70a697b$var$_capitalize.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $4a02bab8c70a697b$var$_composeClasses.default)(slots, $4a02bab8c70a697b$var$_buttonClasses.getButtonUtilityClass, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $4a02bab8c70a697b$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $4a02bab8c70a697b$var$ButtonRoot = (0, $aAbgT.styled)($4a02bab8c70a697b$var$_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, $4a02bab8c70a697b$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.color)}`],
            styles[`size${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $4a02bab8c70a697b$var$_memoTheme.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $4a02bab8c70a697b$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${$4a02bab8c70a697b$var$_buttonClasses.default.loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $4a02bab8c70a697b$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIndicator = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder = (0, $aAbgT.styled)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $4a02bab8c70a697b$var$React.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $4a02bab8c70a697b$var$React.useContext($4a02bab8c70a697b$var$_ButtonGroupContext.default);
    const buttonGroupButtonContextPositionClassName = $4a02bab8c70a697b$var$React.useContext($4a02bab8c70a697b$var$_ButtonGroupButtonContext.default);
    const resolvedProps = (0, $4a02bab8c70a697b$var$_resolveProps.default)(contextProps, inProps);
    const props = (0, $hL1nr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $hGPki.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $4a02bab8c70a697b$var$_clsx.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $4a02bab8c70a697b$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $4a02bab8c70a697b$var$_default = module.exports.default = $4a02bab8c70a697b$var$Button;

});
parcelRegister("1sBf1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $11054b4f9cc1bbd6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $11054b4f9cc1bbd6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $11054b4f9cc1bbd6$var$_exportNames = {
    circularProgressClasses: true
};
Object.defineProperty(module.exports, "circularProgressClasses", {
    enumerable: true,
    get: function() {
        return $11054b4f9cc1bbd6$var$_circularProgressClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $11054b4f9cc1bbd6$var$_CircularProgress.default;
    }
});

var $11054b4f9cc1bbd6$var$_CircularProgress = $11054b4f9cc1bbd6$require$_interopRequireDefault((parcelRequire("2cPwN")));

var $11054b4f9cc1bbd6$var$_circularProgressClasses = $11054b4f9cc1bbd6$require$_interopRequireWildcard((parcelRequire("fPJfA")));
Object.keys($11054b4f9cc1bbd6$var$_circularProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($11054b4f9cc1bbd6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $11054b4f9cc1bbd6$var$_circularProgressClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $11054b4f9cc1bbd6$var$_circularProgressClasses[key];
        }
    });
});

});
parcelRegister("2cPwN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $19b4ac261663afa8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $19b4ac261663afa8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19b4ac261663afa8$var$React = $19b4ac261663afa8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $19b4ac261663afa8$var$_propTypes = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $19b4ac261663afa8$var$_clsx = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $19b4ac261663afa8$var$_chainPropTypes = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("abVWF")));

var $19b4ac261663afa8$var$_composeClasses = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $19b4ac261663afa8$var$_memoTheme = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $19b4ac261663afa8$var$_capitalize = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $19b4ac261663afa8$var$_createSimplePaletteValueFilter = $19b4ac261663afa8$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $fPJfA = parcelRequire("fPJfA");

var $ayMG0 = parcelRequire("ayMG0");
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $aAbgT.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $19b4ac261663afa8$var$rotateAnimation = typeof $19b4ac261663afa8$var$circularRotateKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $19b4ac261663afa8$var$dashAnimation = typeof $19b4ac261663afa8$var$circularDashKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $19b4ac261663afa8$var$_capitalize.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $19b4ac261663afa8$var$_capitalize.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $19b4ac261663afa8$var$_composeClasses.default)(slots, $fPJfA.getCircularProgressUtilityClass, classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $19b4ac261663afa8$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $19b4ac261663afa8$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $19b4ac261663afa8$var$rotateAnimation || {
                    animation: `${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $19b4ac261663afa8$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $aAbgT.styled)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $aAbgT.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $19b4ac261663afa8$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $19b4ac261663afa8$var$_memoTheme.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $19b4ac261663afa8$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $19b4ac261663afa8$var$CircularProgressTrack = (0, $aAbgT.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $19b4ac261663afa8$var$_memoTheme.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $19b4ac261663afa8$var$React.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, {
        className: (0, $19b4ac261663afa8$var$_clsx.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $19b4ac261663afa8$var$SIZE,
                    cy: $19b4ac261663afa8$var$SIZE,
                    r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $19b4ac261663afa8$var$SIZE,
                    cy: $19b4ac261663afa8$var$SIZE,
                    r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $19b4ac261663afa8$var$_default = module.exports.default = $19b4ac261663afa8$var$CircularProgress;

});
parcelRegister("fPJfA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b86eb8364bb4993c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCircularProgressUtilityClass = $b86eb8364bb4993c$var$getCircularProgressUtilityClass;

var $b86eb8364bb4993c$var$_generateUtilityClasses = $b86eb8364bb4993c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b86eb8364bb4993c$var$_generateUtilityClass = $b86eb8364bb4993c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $b86eb8364bb4993c$var$getCircularProgressUtilityClass(slot) {
    return (0, $b86eb8364bb4993c$var$_generateUtilityClass.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $b86eb8364bb4993c$var$_generateUtilityClasses.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$var$_default = module.exports.default = $b86eb8364bb4993c$var$circularProgressClasses;

});



parcelRegister("1xAC3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $11f546081ba06ace$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonUtilityClass = $11f546081ba06ace$var$getButtonUtilityClass;

var $11f546081ba06ace$var$_generateUtilityClasses = $11f546081ba06ace$require$_interopRequireDefault((parcelRequire("5nY49")));

var $11f546081ba06ace$var$_generateUtilityClass = $11f546081ba06ace$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $11f546081ba06ace$var$getButtonUtilityClass(slot) {
    return (0, $11f546081ba06ace$var$_generateUtilityClass.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $11f546081ba06ace$var$_generateUtilityClasses.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $11f546081ba06ace$var$_default = module.exports.default = $11f546081ba06ace$var$buttonClasses;

});

parcelRegister("bwtSM", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8639dcef822d5d4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8639dcef822d5d4c$var$React = $8639dcef822d5d4c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $8639dcef822d5d4c$var$React.createContext({});
var $8639dcef822d5d4c$var$_default = module.exports.default = $8639dcef822d5d4c$var$ButtonGroupContext;

});

parcelRegister("3eDio", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $25b1293270900846$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25b1293270900846$var$React = $25b1293270900846$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $25b1293270900846$var$React.createContext(undefined);
var $25b1293270900846$var$_default = module.exports.default = $25b1293270900846$var$ButtonGroupButtonContext;

});



parcelRegister("9xY2t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getToken = $8b95c1797996d21f$var$getToken;
module.exports.getUser = $8b95c1797996d21f$var$getUser;
module.exports.getUserGroups = $8b95c1797996d21f$var$getUserGroups;
module.exports.isAdmin = $8b95c1797996d21f$var$isAdmin;
module.exports.login = $8b95c1797996d21f$var$login;
module.exports.logout = $8b95c1797996d21f$var$logout;

var $8b95c1797996d21f$var$_auth = $8b95c1797996d21f$var$_interopRequireDefault((parcelRequire("ca6gO")));

var $8b95c1797996d21f$var$_config = $8b95c1797996d21f$var$_interopRequireDefault((parcelRequire("cWZn2")));
function $8b95c1797996d21f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
async function $8b95c1797996d21f$var$getUser() {
    return $8b95c1797996d21f$var$_auth.default.getUser();
}
async function $8b95c1797996d21f$var$login() {
    return $8b95c1797996d21f$var$_auth.default.signinRedirect();
}
async function $8b95c1797996d21f$var$logout() {
    await $8b95c1797996d21f$var$_auth.default.removeUser();
    await $8b95c1797996d21f$var$_auth.default.clearStaleState();
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = `${$8b95c1797996d21f$var$_config.default.authority}/logout`;
}
async function $8b95c1797996d21f$var$getToken() {
    const user = await $8b95c1797996d21f$var$_auth.default.getUser();
    if (!user || user.expired) try {
        const refreshed = await $8b95c1797996d21f$var$_auth.default.signinSilent();
        return refreshed?.access_token ?? null;
    } catch  {
        return null;
    }
    return user.access_token;
}
async function $8b95c1797996d21f$var$getUserGroups() {
    const user = await $8b95c1797996d21f$var$_auth.default.getUser();
    if (!user) return [];
    try {
        const res = await fetch(`${$8b95c1797996d21f$var$_config.default.authority}/api/oidc/userinfo`, {
            headers: {
                Authorization: `Bearer ${user.access_token}`
            }
        });
        const info = await res.json();
        return info.groups ?? [];
    } catch  {
        return [];
    }
}
function $8b95c1797996d21f$var$isAdmin(user) {
    if (!user) return false;
    const groups = user.profile.groups ?? [];
    return groups.includes('admin');
}

});
parcelRegister("ca6gO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8vz7t = parcelRequire("8vz7t");

var $cf77be3416c541fd$var$_config = $cf77be3416c541fd$var$_interopRequireDefault((parcelRequire("cWZn2")));
function $cf77be3416c541fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf77be3416c541fd$var$userManager = new $8vz7t.UserManager({
    authority: $cf77be3416c541fd$var$_config.default.authority,
    client_id: $cf77be3416c541fd$var$_config.default.client_id,
    client_secret: $cf77be3416c541fd$var$_config.default.client_secret,
    redirect_uri: `${window.location.protocol}//${window.location.host}/callback`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
    response_type: 'code',
    scope: 'openid profile email groups',
    userStore: new $8vz7t.WebStorageStateStore({
        store: window.localStorage
    }),
    token_endpoint_auth_method: 'client_secret_post'
});
var $cf77be3416c541fd$var$_default = module.exports.default = $cf77be3416c541fd$var$userManager;

});
parcelRegister("8vz7t", function(module, exports) {
"use strict";
var $631c75f8a3fcffe9$var$__defProp = Object.defineProperty;
var $631c75f8a3fcffe9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $631c75f8a3fcffe9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $631c75f8a3fcffe9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $631c75f8a3fcffe9$var$__export = (target, all)=>{
    for(var name in all)$631c75f8a3fcffe9$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $631c75f8a3fcffe9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $631c75f8a3fcffe9$var$__getOwnPropNames(from))if (!$631c75f8a3fcffe9$var$__hasOwnProp.call(to, key) && key !== except) $631c75f8a3fcffe9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $631c75f8a3fcffe9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $631c75f8a3fcffe9$var$__toCommonJS = (mod)=>$631c75f8a3fcffe9$var$__copyProps($631c75f8a3fcffe9$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $631c75f8a3fcffe9$var$index_exports = {};
$631c75f8a3fcffe9$var$__export($631c75f8a3fcffe9$var$index_exports, {
    AccessTokenEvents: ()=>$631c75f8a3fcffe9$var$AccessTokenEvents,
    CheckSessionIFrame: ()=>$631c75f8a3fcffe9$var$CheckSessionIFrame,
    DPoPState: ()=>$631c75f8a3fcffe9$var$DPoPState,
    ErrorResponse: ()=>$631c75f8a3fcffe9$var$ErrorResponse,
    ErrorTimeout: ()=>$631c75f8a3fcffe9$var$ErrorTimeout,
    InMemoryWebStorage: ()=>$631c75f8a3fcffe9$var$InMemoryWebStorage,
    IndexedDbDPoPStore: ()=>$631c75f8a3fcffe9$var$IndexedDbDPoPStore,
    Log: ()=>$631c75f8a3fcffe9$var$Log,
    Logger: ()=>$631c75f8a3fcffe9$var$Logger,
    MetadataService: ()=>$631c75f8a3fcffe9$var$MetadataService,
    OidcClient: ()=>$631c75f8a3fcffe9$var$OidcClient,
    OidcClientSettingsStore: ()=>$631c75f8a3fcffe9$var$OidcClientSettingsStore,
    SessionMonitor: ()=>$631c75f8a3fcffe9$var$SessionMonitor,
    SigninResponse: ()=>$631c75f8a3fcffe9$var$SigninResponse,
    SigninState: ()=>$631c75f8a3fcffe9$var$SigninState,
    SignoutResponse: ()=>$631c75f8a3fcffe9$var$SignoutResponse,
    State: ()=>$631c75f8a3fcffe9$var$State,
    User: ()=>$631c75f8a3fcffe9$var$User,
    UserManager: ()=>$631c75f8a3fcffe9$var$UserManager,
    UserManagerSettingsStore: ()=>$631c75f8a3fcffe9$var$UserManagerSettingsStore,
    Version: ()=>$631c75f8a3fcffe9$var$Version,
    WebStorageStateStore: ()=>$631c75f8a3fcffe9$var$WebStorageStateStore
});
module.exports = $631c75f8a3fcffe9$var$__toCommonJS($631c75f8a3fcffe9$var$index_exports);
// src/utils/Logger.ts
var $631c75f8a3fcffe9$var$nopLogger = {
    debug: ()=>void 0,
    info: ()=>void 0,
    warn: ()=>void 0,
    error: ()=>void 0
};
var $631c75f8a3fcffe9$var$level;
var $631c75f8a3fcffe9$var$logger;
var $631c75f8a3fcffe9$var$Log = /* @__PURE__ */ ((Log2)=>{
    Log2[Log2["NONE"] = 0] = "NONE";
    Log2[Log2["ERROR"] = 1] = "ERROR";
    Log2[Log2["WARN"] = 2] = "WARN";
    Log2[Log2["INFO"] = 3] = "INFO";
    Log2[Log2["DEBUG"] = 4] = "DEBUG";
    return Log2;
})($631c75f8a3fcffe9$var$Log || {});
((Log2)=>{
    function reset() {
        $631c75f8a3fcffe9$var$level = 3 /* INFO */ ;
        $631c75f8a3fcffe9$var$logger = $631c75f8a3fcffe9$var$nopLogger;
    }
    Log2.reset = reset;
    function setLevel(value) {
        if (!(0 /* NONE */  <= value && value <= 4 /* DEBUG */ )) throw new Error("Invalid log level");
        $631c75f8a3fcffe9$var$level = value;
    }
    Log2.setLevel = setLevel;
    function setLogger(value) {
        $631c75f8a3fcffe9$var$logger = value;
    }
    Log2.setLogger = setLogger;
})($631c75f8a3fcffe9$var$Log || ($631c75f8a3fcffe9$var$Log = {}));
var $631c75f8a3fcffe9$var$Logger = class _Logger {
    constructor(_name){
        this._name = _name;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ debug(...args) {
        if ($631c75f8a3fcffe9$var$level >= 4 /* DEBUG */ ) $631c75f8a3fcffe9$var$logger.debug(_Logger._format(this._name, this._method), ...args);
    }
    info(...args) {
        if ($631c75f8a3fcffe9$var$level >= 3 /* INFO */ ) $631c75f8a3fcffe9$var$logger.info(_Logger._format(this._name, this._method), ...args);
    }
    warn(...args) {
        if ($631c75f8a3fcffe9$var$level >= 2 /* WARN */ ) $631c75f8a3fcffe9$var$logger.warn(_Logger._format(this._name, this._method), ...args);
    }
    error(...args) {
        if ($631c75f8a3fcffe9$var$level >= 1 /* ERROR */ ) $631c75f8a3fcffe9$var$logger.error(_Logger._format(this._name, this._method), ...args);
    }
    /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */ throw(err) {
        this.error(err);
        throw err;
    }
    create(method) {
        const methodLogger = Object.create(this);
        methodLogger._method = method;
        methodLogger.debug("begin");
        return methodLogger;
    }
    static createStatic(name, staticMethod) {
        const staticLogger = new _Logger(`${name}.${staticMethod}`);
        staticLogger.debug("begin");
        return staticLogger;
    }
    static _format(name, method) {
        const prefix = `[${name}]`;
        return method ? `${prefix} ${method}:` : prefix;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ // helpers for static class methods
    static debug(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 4 /* DEBUG */ ) $631c75f8a3fcffe9$var$logger.debug(_Logger._format(name), ...args);
    }
    static info(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 3 /* INFO */ ) $631c75f8a3fcffe9$var$logger.info(_Logger._format(name), ...args);
    }
    static warn(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 2 /* WARN */ ) $631c75f8a3fcffe9$var$logger.warn(_Logger._format(name), ...args);
    }
    static error(name, ...args) {
        if ($631c75f8a3fcffe9$var$level >= 1 /* ERROR */ ) $631c75f8a3fcffe9$var$logger.error(_Logger._format(name), ...args);
    }
};
$631c75f8a3fcffe9$var$Log.reset();

var $cVqez = parcelRequire("cVqez");
var $631c75f8a3fcffe9$var$JwtUtils = class {
    // IMPORTANT: doesn't validate the token
    static decode(token) {
        try {
            return (0, $cVqez.jwtDecode)(token);
        } catch (err) {
            $631c75f8a3fcffe9$var$Logger.error("JwtUtils.decode", err);
            throw err;
        }
    }
    static async generateSignedJwt(header, payload, privateKey) {
        const encodedHeader = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign({
            name: "ECDSA",
            hash: {
                name: "SHA-256"
            }
        }, privateKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
    static async generateSignedJwtWithHmac(header, payload, secretKey) {
        const encodedHeader = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
        const encodedPayload = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
        const encodedToken = `${encodedHeader}.${encodedPayload}`;
        const signature = await window.crypto.subtle.sign("HMAC", secretKey, new TextEncoder().encode(encodedToken));
        const encodedSignature = $631c75f8a3fcffe9$var$CryptoUtils.encodeBase64Url(new Uint8Array(signature));
        return `${encodedToken}.${encodedSignature}`;
    }
};
// src/utils/CryptoUtils.ts
var $631c75f8a3fcffe9$var$UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var $631c75f8a3fcffe9$var$toBase64 = (val)=>btoa([
        ...new Uint8Array(val)
    ].map((chr)=>String.fromCharCode(chr)).join(""));
var $631c75f8a3fcffe9$var$_CryptoUtils = class _CryptoUtils {
    static _randomWord() {
        const arr = new Uint32Array(1);
        crypto.getRandomValues(arr);
        return arr[0];
    }
    /**
   * Generates RFC4122 version 4 guid
   */ static generateUUIDv4() {
        const uuid = $631c75f8a3fcffe9$var$UUID_V4_TEMPLATE.replace(/[018]/g, (c)=>(+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
        return uuid.replace(/-/g, "");
    }
    /**
   * PKCE: Generate a code verifier
   */ static generateCodeVerifier() {
        return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
    }
    /**
   * PKCE: Generate a code challenge
   */ static async generateCodeChallenge(code_verifier) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
            const encoder = new TextEncoder();
            const data = encoder.encode(code_verifier);
            const hashed = await crypto.subtle.digest("SHA-256", data);
            return $631c75f8a3fcffe9$var$toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (err) {
            $631c75f8a3fcffe9$var$Logger.error("CryptoUtils.generateCodeChallenge", err);
            throw err;
        }
    }
    /**
   * Generates a base64-encoded string for a basic auth header
   */ static generateBasicAuth(client_id, client_secret) {
        const encoder = new TextEncoder();
        const data = encoder.encode([
            client_id,
            client_secret
        ].join(":"));
        return $631c75f8a3fcffe9$var$toBase64(data);
    }
    /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */ static async hash(alg, message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
        return new Uint8Array(hashBuffer);
    }
    /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */ static async customCalculateJwkThumbprint(jwk) {
        let jsonObject;
        switch(jwk.kty){
            case "RSA":
                jsonObject = {
                    "e": jwk.e,
                    "kty": jwk.kty,
                    "n": jwk.n
                };
                break;
            case "EC":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x,
                    "y": jwk.y
                };
                break;
            case "OKP":
                jsonObject = {
                    "crv": jwk.crv,
                    "kty": jwk.kty,
                    "x": jwk.x
                };
                break;
            case "oct":
                jsonObject = {
                    "crv": jwk.k,
                    "kty": jwk.kty
                };
                break;
            default:
                throw new Error("Unknown jwk type");
        }
        const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
        return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
    }
    static async generateDPoPProof({ url: url, accessToken: accessToken, httpMethod: httpMethod, keyPair: keyPair, nonce: nonce }) {
        let hashedToken;
        let encodedHash;
        const payload = {
            "jti": window.crypto.randomUUID(),
            "htm": httpMethod != null ? httpMethod : "GET",
            "htu": url,
            "iat": Math.floor(Date.now() / 1e3)
        };
        if (accessToken) {
            hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
            encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
            payload.ath = encodedHash;
        }
        if (nonce) payload.nonce = nonce;
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            const header = {
                "alg": "ES256",
                "typ": "dpop+jwt",
                "jwk": {
                    "crv": publicJwk.crv,
                    "kty": publicJwk.kty,
                    "x": publicJwk.x,
                    "y": publicJwk.y
                }
            };
            return await $631c75f8a3fcffe9$var$JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Error exporting dpop public key: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPJkt(keyPair) {
        try {
            const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
            return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
        } catch (err) {
            if (err instanceof TypeError) throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
            else throw err;
        }
    }
    static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign",
            "verify"
        ]);
    }
    /**
   * Generates a client assertion JWT for client_secret_jwt authentication
   * @param client_id The client identifier
   * @param client_secret The client secret
   * @param audience The token endpoint URL (audience)
   * @param algorithm The HMAC algorithm to use (HS256, HS384, HS512). Defaults to HS256
   */ static async generateClientAssertionJwt(client_id, client_secret, audience, algorithm = "HS256") {
        const now = Math.floor(Date.now() / 1e3);
        const header = {
            "alg": algorithm,
            "typ": "JWT"
        };
        const payload = {
            "iss": client_id,
            "sub": client_id,
            "aud": audience,
            "jti": _CryptoUtils.generateUUIDv4(),
            "exp": now + 300,
            // 5 minutes
            "iat": now
        };
        const hashMap = {
            "HS256": "SHA-256",
            "HS384": "SHA-384",
            "HS512": "SHA-512"
        };
        const hashFunction = hashMap[algorithm];
        if (!hashFunction) throw new Error(`Unsupported algorithm: ${algorithm}. Supported algorithms are: HS256, HS384, HS512`);
        const encoder = new TextEncoder();
        const secretKey = await crypto.subtle.importKey("raw", encoder.encode(client_secret), {
            name: "HMAC",
            hash: hashFunction
        }, false, [
            "sign"
        ]);
        return await $631c75f8a3fcffe9$var$JwtUtils.generateSignedJwtWithHmac(header, payload, secretKey);
    }
};
/**
 * Generates a base64url encoded string
 */ $631c75f8a3fcffe9$var$_CryptoUtils.encodeBase64Url = (input)=>{
    return $631c75f8a3fcffe9$var$toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var $631c75f8a3fcffe9$var$CryptoUtils = $631c75f8a3fcffe9$var$_CryptoUtils;
// src/utils/Event.ts
var $631c75f8a3fcffe9$var$Event = class {
    constructor(_name){
        this._name = _name;
        this._callbacks = [];
        this._logger = new $631c75f8a3fcffe9$var$Logger(`Event('${this._name}')`);
    }
    addHandler(cb) {
        this._callbacks.push(cb);
        return ()=>this.removeHandler(cb);
    }
    removeHandler(cb) {
        const idx = this._callbacks.lastIndexOf(cb);
        if (idx >= 0) this._callbacks.splice(idx, 1);
    }
    async raise(...ev) {
        this._logger.debug("raise:", ...ev);
        for (const cb of this._callbacks)await cb(...ev);
    }
};
// src/utils/PopupUtils.ts
var $631c75f8a3fcffe9$var$PopupUtils = class {
    /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */ static center({ ...features }) {
        var _a, _b, _c;
        if (features.width == null) features.width = (_a = [
            800,
            720,
            600,
            480
        ].find((width)=>width <= window.outerWidth / 1.618)) != null ? _a : 360;
        (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
        if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
        return features;
    }
    static serialize(features) {
        return Object.entries(features).filter(([, value])=>value != null).map(([key, value])=>`${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
    }
};
// src/utils/Timer.ts
var $631c75f8a3fcffe9$var$Timer = class _Timer extends $631c75f8a3fcffe9$var$Event {
    constructor(){
        super(...arguments);
        this._logger = new $631c75f8a3fcffe9$var$Logger(`Timer('${this._name}')`);
        this._timerHandle = null;
        this._expiration = 0;
        this._callback = ()=>{
            const diff = this._expiration - _Timer.getEpochTime();
            this._logger.debug("timer completes in", diff);
            if (this._expiration <= _Timer.getEpochTime()) {
                this.cancel();
                super.raise();
            }
        };
    }
    // get the time
    static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
    }
    init(durationInSeconds) {
        const logger2 = this._logger.create("init");
        durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
        const expiration = _Timer.getEpochTime() + durationInSeconds;
        if (this.expiration === expiration && this._timerHandle) {
            logger2.debug("skipping since already initialized for expiration at", this.expiration);
            return;
        }
        this.cancel();
        logger2.debug("using duration", durationInSeconds);
        this._expiration = expiration;
        const timerDurationInSeconds = Math.min(durationInSeconds, 5);
        this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
    get expiration() {
        return this._expiration;
    }
    cancel() {
        this._logger.create("cancel");
        if (this._timerHandle) {
            clearInterval(this._timerHandle);
            this._timerHandle = null;
        }
    }
};
// src/utils/UrlUtils.ts
var $631c75f8a3fcffe9$var$UrlUtils = class {
    static readParams(url, responseMode = "query") {
        if (!url) throw new TypeError("Invalid URL");
        const parsedUrl = new URL(url, "http://127.0.0.1");
        const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
        return new URLSearchParams(params.slice(1));
    }
};
var $631c75f8a3fcffe9$var$URL_STATE_DELIMITER = ";";
// src/errors/ErrorResponse.ts
var $631c75f8a3fcffe9$var$ErrorResponse = class extends Error {
    constructor(args, form){
        var _a, _b, _c;
        super(args.error_description || args.error || "");
        this.form = form;
        /** Marker to detect class: "ErrorResponse" */ this.name = "ErrorResponse";
        if (!args.error) {
            $631c75f8a3fcffe9$var$Logger.error("ErrorResponse", "No error passed");
            throw new Error("No error passed");
        }
        this.error = args.error;
        this.error_description = (_a = args.error_description) != null ? _a : null;
        this.error_uri = (_b = args.error_uri) != null ? _b : null;
        this.state = args.userState;
        this.session_state = (_c = args.session_state) != null ? _c : null;
        this.url_state = args.url_state;
    }
};
// src/errors/ErrorTimeout.ts
var $631c75f8a3fcffe9$var$ErrorTimeout = class extends Error {
    constructor(message){
        super(message);
        /** Marker to detect class: "ErrorTimeout" */ this.name = "ErrorTimeout";
    }
};
// src/AccessTokenEvents.ts
var $631c75f8a3fcffe9$var$AccessTokenEvents = class {
    constructor(args){
        this._logger = new $631c75f8a3fcffe9$var$Logger("AccessTokenEvents");
        this._expiringTimer = new $631c75f8a3fcffe9$var$Timer("Access token expiring");
        this._expiredTimer = new $631c75f8a3fcffe9$var$Timer("Access token expired");
        this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
    }
    async load(container) {
        const logger2 = this._logger.create("load");
        if (container.access_token && container.expires_in !== void 0) {
            const duration = container.expires_in;
            logger2.debug("access token present, remaining duration:", duration);
            if (duration > 0) {
                let expiring = duration - this._expiringNotificationTimeInSeconds;
                if (expiring <= 0) expiring = 1;
                logger2.debug("registering expiring timer, raising in", expiring, "seconds");
                this._expiringTimer.init(expiring);
            } else {
                logger2.debug("canceling existing expiring timer because we're past expiration.");
                this._expiringTimer.cancel();
            }
            const expired = duration + 1;
            logger2.debug("registering expired timer, raising in", expired, "seconds");
            this._expiredTimer.init(expired);
        } else {
            this._expiringTimer.cancel();
            this._expiredTimer.cancel();
        }
    }
    async unload() {
        this._logger.debug("unload: canceling existing access token timers");
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
    }
    /**
   * Add callback: Raised prior to the access token expiring.
   */ addAccessTokenExpiring(cb) {
        return this._expiringTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised prior to the access token expiring.
   */ removeAccessTokenExpiring(cb) {
        this._expiringTimer.removeHandler(cb);
    }
    /**
   * Add callback: Raised after the access token has expired.
   */ addAccessTokenExpired(cb) {
        return this._expiredTimer.addHandler(cb);
    }
    /**
   * Remove callback: Raised after the access token has expired.
   */ removeAccessTokenExpired(cb) {
        this._expiredTimer.removeHandler(cb);
    }
};
// src/CheckSessionIFrame.ts
var $631c75f8a3fcffe9$var$CheckSessionIFrame = class {
    constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError){
        this._callback = _callback;
        this._client_id = _client_id;
        this._intervalInSeconds = _intervalInSeconds;
        this._stopOnError = _stopOnError;
        this._logger = new $631c75f8a3fcffe9$var$Logger("CheckSessionIFrame");
        this._timer = null;
        this._session_state = null;
        this._message = (e)=>{
            if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
                if (e.data === "error") {
                    this._logger.error("error message from check session op iframe");
                    if (this._stopOnError) this.stop();
                } else if (e.data === "changed") {
                    this._logger.debug("changed message from check session op iframe");
                    this.stop();
                    this._callback();
                } else this._logger.debug(e.data + " message from check session op iframe");
            }
        };
        const parsedUrl = new URL(url);
        this._frame_origin = parsedUrl.origin;
        this._frame = window.document.createElement("iframe");
        this._frame.style.visibility = "hidden";
        this._frame.style.position = "fixed";
        this._frame.style.left = "-1000px";
        this._frame.style.top = "0";
        this._frame.width = "0";
        this._frame.height = "0";
        this._frame.src = parsedUrl.href;
    }
    load() {
        return new Promise((resolve)=>{
            this._frame.onload = ()=>{
                resolve();
            };
            window.document.body.appendChild(this._frame);
            window.addEventListener("message", this._message, false);
        });
    }
    start(session_state) {
        if (this._session_state === session_state) return;
        this._logger.create("start");
        this.stop();
        this._session_state = session_state;
        const send = ()=>{
            if (!this._frame.contentWindow || !this._session_state) return;
            this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        send();
        this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
    stop() {
        this._logger.create("stop");
        this._session_state = null;
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }
};
// src/InMemoryWebStorage.ts
var $631c75f8a3fcffe9$var$InMemoryWebStorage = class {
    constructor(){
        this._logger = new $631c75f8a3fcffe9$var$Logger("InMemoryWebStorage");
        this._data = {};
    }
    clear() {
        this._logger.create("clear");
        this._data = {};
    }
    getItem(key) {
        this._logger.create(`getItem('${key}')`);
        return this._data[key];
    }
    setItem(key, value) {
        this._logger.create(`setItem('${key}')`);
        this._data[key] = value;
    }
    removeItem(key) {
        this._logger.create(`removeItem('${key}')`);
        delete this._data[key];
    }
    get length() {
        return Object.getOwnPropertyNames(this._data).length;
    }
    key(index) {
        return Object.getOwnPropertyNames(this._data)[index];
    }
};
// src/errors/ErrorDPoPNonce.ts
var $631c75f8a3fcffe9$var$ErrorDPoPNonce = class extends Error {
    constructor(nonce, message){
        super(message);
        /** Marker to detect class: "ErrorDPoPNonce" */ this.name = "ErrorDPoPNonce";
        this.nonce = nonce;
    }
};
// src/JsonService.ts
var $631c75f8a3fcffe9$var$JsonService = class {
    constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}){
        this._jwtHandler = _jwtHandler;
        this._extraHeaders = _extraHeaders;
        this._logger = new $631c75f8a3fcffe9$var$Logger("JsonService");
        this._contentTypes = [];
        this._contentTypes.push(...additionalContentTypes, "application/json");
        if (_jwtHandler) this._contentTypes.push("application/jwt");
    }
    async fetchWithTimeout(input, init = {}) {
        const { timeoutInSeconds: timeoutInSeconds, ...initFetch } = init;
        if (!timeoutInSeconds) return await fetch(input, initFetch);
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeoutInSeconds * 1e3);
        try {
            const response = await fetch(input, {
                ...init,
                signal: controller.signal
            });
            return response;
        } catch (err) {
            if (err instanceof DOMException && err.name === "AbortError") throw new $631c75f8a3fcffe9$var$ErrorTimeout("Network timed out");
            throw err;
        } finally{
            clearTimeout(timeoutId);
        }
    }
    async getJson(url, { token: token, credentials: credentials, timeoutInSeconds: timeoutInSeconds } = {}) {
        const logger2 = this._logger.create("getJson");
        const headers = {
            "Accept": this._contentTypes.join(", ")
        };
        if (token) {
            logger2.debug("token passed, setting Authorization header");
            headers["Authorization"] = "Bearer " + token;
        }
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                timeoutInSeconds: timeoutInSeconds,
                credentials: credentials
            });
        } catch (err) {
            logger2.error("Network Error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
        if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) return await this._jwtHandler(await response.text());
        let json;
        try {
            json = await response.json();
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (json.error) throw new $631c75f8a3fcffe9$var$ErrorResponse(json);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    async postForm(url, { body: body, basicAuth: basicAuth, timeoutInSeconds: timeoutInSeconds, initCredentials: initCredentials, extraHeaders: extraHeaders }) {
        const logger2 = this._logger.create("postForm");
        const headers = {
            "Accept": this._contentTypes.join(", "),
            "Content-Type": "application/x-www-form-urlencoded",
            ...extraHeaders
        };
        if (basicAuth !== void 0) headers["Authorization"] = "Basic " + basicAuth;
        this._appendExtraHeaders(headers);
        let response;
        try {
            logger2.debug("url:", url);
            response = await this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
            });
        } catch (err) {
            logger2.error("Network error");
            throw err;
        }
        logger2.debug("HTTP response received, status", response.status);
        const contentType = response.headers.get("Content-Type");
        if (contentType && !this._contentTypes.find((item)=>contentType.startsWith(item))) throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
        const responseText = await response.text();
        let json = {};
        if (responseText) try {
            json = JSON.parse(responseText);
        } catch (err) {
            logger2.error("Error parsing JSON response", err);
            if (response.ok) throw err;
            throw new Error(`${response.statusText} (${response.status})`);
        }
        if (!response.ok) {
            logger2.error("Error from server:", json);
            if (response.headers.has("dpop-nonce")) {
                const nonce = response.headers.get("dpop-nonce");
                throw new $631c75f8a3fcffe9$var$ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
            }
            if (json.error) throw new $631c75f8a3fcffe9$var$ErrorResponse(json, body);
            throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
        }
        return json;
    }
    _appendExtraHeaders(headers) {
        const logger2 = this._logger.create("appendExtraHeaders");
        const customKeys = Object.keys(this._extraHeaders);
        const protectedHeaders = [
            "accept",
            "content-type"
        ];
        const preventOverride = [
            "authorization"
        ];
        if (customKeys.length === 0) return;
        customKeys.forEach((headerName)=>{
            if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
                logger2.warn("Protected header could not be set", headerName, protectedHeaders);
                return;
            }
            if (preventOverride.includes(headerName.toLocaleLowerCase()) && Object.keys(headers).includes(headerName)) {
                logger2.warn("Header could not be overridden", headerName, preventOverride);
                return;
            }
            const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
            if (content && content !== "") headers[headerName] = content;
        });
    }
};
// src/MetadataService.ts
var $631c75f8a3fcffe9$var$MetadataService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("MetadataService");
        this._signingKeys = null;
        this._metadata = null;
        this._metadataUrl = this._settings.metadataUrl;
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService([
            "application/jwk-set+json"
        ], null, this._settings.extraHeaders);
        if (this._settings.signingKeys) {
            this._logger.debug("using signingKeys from settings");
            this._signingKeys = this._settings.signingKeys;
        }
        if (this._settings.metadata) {
            this._logger.debug("using metadata from settings");
            this._metadata = this._settings.metadata;
        }
        if (this._settings.fetchRequestCredentials) {
            this._logger.debug("using fetchRequestCredentials from settings");
            this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
        }
    }
    resetSigningKeys() {
        this._signingKeys = null;
    }
    async getMetadata() {
        const logger2 = this._logger.create("getMetadata");
        if (this._metadata) {
            logger2.debug("using cached values");
            return this._metadata;
        }
        if (!this._metadataUrl) {
            logger2.throw(new Error("No authority or metadataUrl configured on settings"));
            throw null;
        }
        logger2.debug("getting metadata from", this._metadataUrl);
        const metadata = await this._jsonService.getJson(this._metadataUrl, {
            credentials: this._fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("merging remote JSON with seed metadata");
        this._metadata = Object.assign({}, metadata, this._settings.metadataSeed);
        return this._metadata;
    }
    getIssuer() {
        return this._getMetadataProperty("issuer");
    }
    getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
    }
    getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
    }
    getTokenEndpoint(optional = true) {
        return this._getMetadataProperty("token_endpoint", optional);
    }
    getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
    }
    getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
    }
    getRevocationEndpoint(optional = true) {
        return this._getMetadataProperty("revocation_endpoint", optional);
    }
    getKeysEndpoint(optional = true) {
        return this._getMetadataProperty("jwks_uri", optional);
    }
    async _getMetadataProperty(name, optional = false) {
        const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
        const metadata = await this.getMetadata();
        logger2.debug("resolved");
        if (metadata[name] === void 0) {
            if (optional === true) {
                logger2.warn("Metadata does not contain optional property");
                return void 0;
            }
            logger2.throw(new Error("Metadata does not contain property " + name));
        }
        return metadata[name];
    }
    async getSigningKeys() {
        const logger2 = this._logger.create("getSigningKeys");
        if (this._signingKeys) {
            logger2.debug("returning signingKeys from cache");
            return this._signingKeys;
        }
        const jwks_uri = await this.getKeysEndpoint(false);
        logger2.debug("got jwks_uri", jwks_uri);
        const keySet = await this._jsonService.getJson(jwks_uri, {
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got key set", keySet);
        if (!Array.isArray(keySet.keys)) {
            logger2.throw(new Error("Missing keys on keyset"));
            throw null;
        }
        this._signingKeys = keySet.keys;
        return this._signingKeys;
    }
};
// src/WebStorageStateStore.ts
var $631c75f8a3fcffe9$var$WebStorageStateStore = class {
    constructor({ prefix: prefix = "oidc.", store: store = localStorage } = {}){
        this._logger = new $631c75f8a3fcffe9$var$Logger("WebStorageStateStore");
        this._store = store;
        this._prefix = prefix;
    }
    async set(key, value) {
        this._logger.create(`set('${key}')`);
        key = this._prefix + key;
        await this._store.setItem(key, value);
    }
    async get(key) {
        this._logger.create(`get('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        return item;
    }
    async remove(key) {
        this._logger.create(`remove('${key}')`);
        key = this._prefix + key;
        const item = await this._store.getItem(key);
        await this._store.removeItem(key);
        return item;
    }
    async getAllKeys() {
        this._logger.create("getAllKeys");
        const len = await this._store.length;
        const keys = [];
        for(let index = 0; index < len; index++){
            const key = await this._store.key(index);
            if (key && key.indexOf(this._prefix) === 0) keys.push(key.substr(this._prefix.length));
        }
        return keys;
    }
};
// src/OidcClientSettings.ts
var $631c75f8a3fcffe9$var$DefaultResponseType = "code";
var $631c75f8a3fcffe9$var$DefaultScope = "openid";
var $631c75f8a3fcffe9$var$DefaultClientAuthentication = "client_secret_post";
var $631c75f8a3fcffe9$var$DefaultStaleStateAgeInSeconds = 900;
var $631c75f8a3fcffe9$var$OidcClientSettingsStore = class {
    constructor({ authority: // metadata related
    authority, metadataUrl: metadataUrl, metadata: metadata, signingKeys: signingKeys, metadataSeed: metadataSeed, client_id: // client related
    client_id, client_secret: client_secret, response_type: response_type = $631c75f8a3fcffe9$var$DefaultResponseType, scope: scope = $631c75f8a3fcffe9$var$DefaultScope, redirect_uri: redirect_uri, post_logout_redirect_uri: post_logout_redirect_uri, client_authentication: client_authentication = $631c75f8a3fcffe9$var$DefaultClientAuthentication, token_endpoint_auth_signing_alg: token_endpoint_auth_signing_alg = "HS256", prompt: // optional protocol
    prompt, display: display, max_age: max_age, ui_locales: ui_locales, acr_values: acr_values, resource: resource, response_mode: response_mode, filterProtocolClaims: // behavior flags
    filterProtocolClaims = true, loadUserInfo: loadUserInfo = false, requestTimeoutInSeconds: requestTimeoutInSeconds, staleStateAgeInSeconds: staleStateAgeInSeconds = $631c75f8a3fcffe9$var$DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: mergeClaimsStrategy = {
        array: "replace"
    }, disablePKCE: disablePKCE = false, stateStore: // other behavior
    stateStore, revokeTokenAdditionalContentTypes: revokeTokenAdditionalContentTypes, fetchRequestCredentials: fetchRequestCredentials, refreshTokenAllowedScope: refreshTokenAllowedScope, extraQueryParams: // extra
    extraQueryParams = {}, extraTokenParams: extraTokenParams = {}, extraHeaders: extraHeaders = {}, dpop: dpop, omitScopeWhenRequesting: omitScopeWhenRequesting = false }){
        var _a;
        this.authority = authority;
        if (metadataUrl) this.metadataUrl = metadataUrl;
        else {
            this.metadataUrl = authority;
            if (authority) {
                if (!this.metadataUrl.endsWith("/")) this.metadataUrl += "/";
                this.metadataUrl += ".well-known/openid-configuration";
            }
        }
        this.metadata = metadata;
        this.metadataSeed = metadataSeed;
        this.signingKeys = signingKeys;
        this.client_id = client_id;
        this.client_secret = client_secret;
        this.response_type = response_type;
        this.scope = scope;
        this.redirect_uri = redirect_uri;
        this.post_logout_redirect_uri = post_logout_redirect_uri;
        this.client_authentication = client_authentication;
        this.token_endpoint_auth_signing_alg = token_endpoint_auth_signing_alg;
        this.prompt = prompt;
        this.display = display;
        this.max_age = max_age;
        this.ui_locales = ui_locales;
        this.acr_values = acr_values;
        this.resource = resource;
        this.response_mode = response_mode;
        this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
        this.loadUserInfo = !!loadUserInfo;
        this.staleStateAgeInSeconds = staleStateAgeInSeconds;
        this.mergeClaimsStrategy = mergeClaimsStrategy;
        this.omitScopeWhenRequesting = omitScopeWhenRequesting;
        this.disablePKCE = !!disablePKCE;
        this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
        this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
        this.requestTimeoutInSeconds = requestTimeoutInSeconds;
        if (stateStore) this.stateStore = stateStore;
        else {
            const store = typeof window !== "undefined" ? window.localStorage : new $631c75f8a3fcffe9$var$InMemoryWebStorage();
            this.stateStore = new $631c75f8a3fcffe9$var$WebStorageStateStore({
                store: store
            });
        }
        this.refreshTokenAllowedScope = refreshTokenAllowedScope;
        this.extraQueryParams = extraQueryParams;
        this.extraTokenParams = extraTokenParams;
        this.extraHeaders = extraHeaders;
        this.dpop = dpop;
        if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) throw new Error("A DPoPStore is required when dpop is enabled");
    }
};
// src/UserInfoService.ts
var $631c75f8a3fcffe9$var$UserInfoService = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserInfoService");
        this._getClaimsFromJwt = async (responseText)=>{
            const logger2 = this._logger.create("_getClaimsFromJwt");
            try {
                const payload = $631c75f8a3fcffe9$var$JwtUtils.decode(responseText);
                logger2.debug("JWT decoding successful");
                return payload;
            } catch (err) {
                logger2.error("Error parsing JWT response");
                throw err;
            }
        };
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
    }
    async getClaims(token) {
        const logger2 = this._logger.create("getClaims");
        if (!token) this._logger.throw(new Error("No token passed"));
        const url = await this._metadataService.getUserInfoEndpoint();
        logger2.debug("got userinfo url", url);
        const claims = await this._jsonService.getJson(url, {
            token: token,
            credentials: this._settings.fetchRequestCredentials,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got claims", claims);
        return claims;
    }
};
// src/TokenClient.ts
var $631c75f8a3fcffe9$var$TokenClient = class {
    constructor(_settings, _metadataService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("TokenClient");
        this._jsonService = new $631c75f8a3fcffe9$var$JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
    }
    /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */ async exchangeCode({ grant_type: grant_type = "authorization_code", redirect_uri: redirect_uri = this._settings.redirect_uri, client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeCode");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!redirect_uri) logger2.throw(new Error("A redirect_uri is required"));
        if (!args.code) logger2.throw(new Error("A code is required"));
        const params = new URLSearchParams({
            grant_type: grant_type,
            redirect_uri: redirect_uri
        });
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */ async exchangeCredentials({ grant_type: grant_type = "password", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, scope: scope = this._settings.scope, ...args }) {
        const logger2 = this._logger.create("exchangeCredentials");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        if (!this._settings.omitScopeWhenRequesting) params.set("scope", scope);
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */ async exchangeRefreshToken({ grant_type: grant_type = "refresh_token", client_id: client_id = this._settings.client_id, client_secret: client_secret = this._settings.client_secret, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, ...args }) {
        const logger2 = this._logger.create("exchangeRefreshToken");
        if (!client_id) logger2.throw(new Error("A client_id is required"));
        if (!args.refresh_token) logger2.throw(new Error("A refresh_token is required"));
        const params = new URLSearchParams({
            grant_type: grant_type
        });
        for (const [key, value] of Object.entries(args)){
            if (Array.isArray(value)) value.forEach((param)=>params.append(key, param));
            else if (value != null) params.set(key, value);
        }
        if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && (client_secret === void 0 || client_secret === null)) {
            logger2.throw(new Error("A client_secret is required"));
            throw null;
        }
        let basicAuth;
        const url = await this._metadataService.getTokenEndpoint(false);
        switch(this._settings.client_authentication){
            case "client_secret_basic":
                basicAuth = $631c75f8a3fcffe9$var$CryptoUtils.generateBasicAuth(client_id, client_secret);
                break;
            case "client_secret_post":
                params.append("client_id", client_id);
                if (client_secret) params.append("client_secret", client_secret);
                break;
            case "client_secret_jwt":
                {
                    const clientAssertion = await $631c75f8a3fcffe9$var$CryptoUtils.generateClientAssertionJwt(client_id, client_secret, url, this._settings.token_endpoint_auth_signing_alg);
                    params.append("client_id", client_id);
                    params.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer");
                    params.append("client_assertion", clientAssertion);
                    break;
                }
        }
        logger2.debug("got token endpoint");
        const response = await this._jsonService.postForm(url, {
            body: params,
            basicAuth: basicAuth,
            timeoutInSeconds: timeoutInSeconds,
            initCredentials: this._settings.fetchRequestCredentials,
            extraHeaders: extraHeaders
        });
        logger2.debug("got response");
        return response;
    }
    /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */ async revoke(args) {
        var _a;
        const logger2 = this._logger.create("revoke");
        if (!args.token) logger2.throw(new Error("A token is required"));
        const url = await this._metadataService.getRevocationEndpoint(false);
        logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(args))if (value != null) params.set(key, value);
        params.set("client_id", this._settings.client_id);
        if (this._settings.client_secret) params.set("client_secret", this._settings.client_secret);
        await this._jsonService.postForm(url, {
            body: params,
            timeoutInSeconds: this._settings.requestTimeoutInSeconds
        });
        logger2.debug("got response");
    }
};
// src/ResponseValidator.ts
var $631c75f8a3fcffe9$var$ResponseValidator = class {
    constructor(_settings, _metadataService, _claimsService){
        this._settings = _settings;
        this._metadataService = _metadataService;
        this._claimsService = _claimsService;
        this._logger = new $631c75f8a3fcffe9$var$Logger("ResponseValidator");
        this._userInfoService = new $631c75f8a3fcffe9$var$UserInfoService(this._settings, this._metadataService);
        this._tokenClient = new $631c75f8a3fcffe9$var$TokenClient(this._settings, this._metadataService);
    }
    async validateSigninResponse(response, state, extraHeaders) {
        const logger2 = this._logger.create("validateSigninResponse");
        this._processSigninState(response, state);
        logger2.debug("state processed");
        await this._processCode(response, state, extraHeaders);
        logger2.debug("code processed");
        if (response.isOpenId) this._validateIdTokenAttributes(response, "", state.nonce);
        logger2.debug("tokens validated");
        await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
        logger2.debug("claims processed");
    }
    async validateCredentialsResponse(response, skipUserInfo) {
        const logger2 = this._logger.create("validateCredentialsResponse");
        const shouldValidateSubClaim = response.isOpenId && !!response.id_token;
        if (shouldValidateSubClaim) this._validateIdTokenAttributes(response);
        logger2.debug("tokens validated");
        await this._processClaims(response, skipUserInfo, shouldValidateSubClaim);
        logger2.debug("claims processed");
    }
    async validateRefreshResponse(response, state) {
        var _a, _b;
        const logger2 = this._logger.create("validateRefreshResponse");
        response.userState = state.data;
        (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
        (_b = response.scope) != null ? _b : response.scope = state.scope;
        if (response.isOpenId && !!response.id_token) {
            this._validateIdTokenAttributes(response, state.id_token);
            logger2.debug("ID Token validated");
        }
        if (!response.id_token) {
            response.id_token = state.id_token;
            response.profile = state.profile;
        }
        const hasIdToken = response.isOpenId && !!response.id_token;
        await this._processClaims(response, false, hasIdToken);
        logger2.debug("claims processed");
    }
    validateSignoutResponse(response, state) {
        const logger2 = this._logger.create("validateSignoutResponse");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        logger2.debug("state validated");
        response.userState = state.data;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
        }
    }
    _processSigninState(response, state) {
        var _a;
        const logger2 = this._logger.create("_processSigninState");
        if (state.id !== response.state) logger2.throw(new Error("State does not match"));
        if (!state.client_id) logger2.throw(new Error("No client_id on state"));
        if (!state.authority) logger2.throw(new Error("No authority on state"));
        if (this._settings.authority !== state.authority) logger2.throw(new Error("authority mismatch on settings vs. signin state"));
        if (this._settings.client_id && this._settings.client_id !== state.client_id) logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
        logger2.debug("state validated");
        response.userState = state.data;
        response.url_state = state.url_state;
        (_a = response.scope) != null ? _a : response.scope = state.scope;
        if (response.error) {
            logger2.warn("Response was error", response.error);
            throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
        }
        if (state.code_verifier && !response.code) logger2.throw(new Error("Expected code in response"));
    }
    async _processClaims(response, skipUserInfo = false, validateSub = true) {
        const logger2 = this._logger.create("_processClaims");
        response.profile = this._claimsService.filterProtocolClaims(response.profile);
        if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
            logger2.debug("not loading user info");
            return;
        }
        logger2.debug("loading user info");
        const claims = await this._userInfoService.getClaims(response.access_token);
        logger2.debug("user info claims received from user info endpoint");
        if (validateSub && claims.sub !== response.profile.sub) logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
        response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
        logger2.debug("user info claims received, updated profile:", response.profile);
    }
    async _processCode(response, state, extraHeaders) {
        const logger2 = this._logger.create("_processCode");
        if (response.code) {
            logger2.debug("Validating code");
            const tokenResponse = await this._tokenClient.exchangeCode({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier,
                extraHeaders: extraHeaders,
                ...state.extraTokenParams
            });
            Object.assign(response, tokenResponse);
        } else logger2.debug("No code to process");
    }
    _validateIdTokenAttributes(response, existingToken, nonce) {
        var _a;
        const logger2 = this._logger.create("_validateIdTokenAttributes");
        logger2.debug("decoding ID Token JWT");
        const incoming = $631c75f8a3fcffe9$var$JwtUtils.decode((_a = response.id_token) != null ? _a : "");
        if (!incoming.sub) logger2.throw(new Error("ID Token is missing a subject claim"));
        if (nonce && incoming.nonce !== nonce) logger2.throw(new Error("nonce in id_token does not match nonce in client storage"));
        if (existingToken) {
            const existing = $631c75f8a3fcffe9$var$JwtUtils.decode(existingToken);
            if (incoming.sub !== existing.sub) logger2.throw(new Error("sub in id_token does not match current sub"));
            if (incoming.auth_time && incoming.auth_time !== existing.auth_time) logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
            if (incoming.azp && incoming.azp !== existing.azp) logger2.throw(new Error("azp in id_token does not match original azp"));
            if (!incoming.azp && existing.azp) logger2.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        response.profile = incoming;
    }
};
// src/State.ts
var $631c75f8a3fcffe9$var$State = class _State {
    constructor(args){
        this.id = args.id || $631c75f8a3fcffe9$var$CryptoUtils.generateUUIDv4();
        this.data = args.data;
        if (args.created && args.created > 0) this.created = args.created;
        else this.created = $631c75f8a3fcffe9$var$Timer.getEpochTime();
        this.request_type = args.request_type;
        this.url_state = args.url_state;
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("State").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("State", "fromStorageString");
        return Promise.resolve(new _State(JSON.parse(storageString)));
    }
    static async clearStaleState(storage, age) {
        const logger2 = $631c75f8a3fcffe9$var$Logger.createStatic("State", "clearStaleState");
        const cutoff = $631c75f8a3fcffe9$var$Timer.getEpochTime() - age;
        const keys = await storage.getAllKeys();
        logger2.debug("got keys", keys);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const item = await storage.get(key);
            let remove = false;
            if (item) try {
                const state = await _State.fromStorageString(item);
                logger2.debug("got item from key:", key, state.created);
                if (state.created <= cutoff) remove = true;
            } catch (err) {
                logger2.error("Error parsing state for key:", key, err);
                remove = true;
            }
            else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
            }
            if (remove) {
                logger2.debug("removed item for key:", key);
                storage.remove(key);
            }
        }
    }
};
// src/SigninState.ts
var $631c75f8a3fcffe9$var$SigninState = class _SigninState extends $631c75f8a3fcffe9$var$State {
    constructor(args){
        super(args);
        this.code_verifier = args.code_verifier;
        this.code_challenge = args.code_challenge;
        this.authority = args.authority;
        this.client_id = args.client_id;
        this.redirect_uri = args.redirect_uri;
        this.scope = args.scope;
        this.client_secret = args.client_secret;
        this.extraTokenParams = args.extraTokenParams;
        this.response_mode = args.response_mode;
        this.skipUserInfo = args.skipUserInfo;
        this.nonce = args.nonce;
    }
    static async create(args) {
        const code_verifier = args.code_verifier === true ? $631c75f8a3fcffe9$var$CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
        const code_challenge = code_verifier ? await $631c75f8a3fcffe9$var$CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
        return new _SigninState({
            ...args,
            code_verifier: code_verifier,
            code_challenge: code_challenge
        });
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("SigninState").create("toStorageString");
        return JSON.stringify({
            id: this.id,
            data: this.data,
            created: this.created,
            request_type: this.request_type,
            url_state: this.url_state,
            code_verifier: this.code_verifier,
            authority: this.authority,
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            scope: this.scope,
            client_secret: this.client_secret,
            extraTokenParams: this.extraTokenParams,
            response_mode: this.response_mode,
            skipUserInfo: this.skipUserInfo,
            nonce: this.nonce
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("SigninState", "fromStorageString");
        const data = JSON.parse(storageString);
        return _SigninState.create(data);
    }
};
// src/SigninRequest.ts
var $631c75f8a3fcffe9$var$_SigninRequest = class _SigninRequest {
    constructor(args){
        this.url = args.url;
        this.state = args.state;
    }
    static async create({ url: // mandatory
    url, authority: authority, client_id: client_id, redirect_uri: redirect_uri, response_type: response_type, scope: scope, state_data: // optional
    state_data, response_mode: response_mode, request_type: request_type, client_secret: client_secret, nonce: nonce, url_state: url_state, resource: resource, skipUserInfo: skipUserInfo, extraQueryParams: extraQueryParams, extraTokenParams: extraTokenParams, disablePKCE: disablePKCE, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting, ...optionalParams }) {
        if (!url) {
            this._logger.error("create: No url passed");
            throw new Error("url");
        }
        if (!client_id) {
            this._logger.error("create: No client_id passed");
            throw new Error("client_id");
        }
        if (!redirect_uri) {
            this._logger.error("create: No redirect_uri passed");
            throw new Error("redirect_uri");
        }
        if (!response_type) {
            this._logger.error("create: No response_type passed");
            throw new Error("response_type");
        }
        if (!scope) {
            this._logger.error("create: No scope passed");
            throw new Error("scope");
        }
        if (!authority) {
            this._logger.error("create: No authority passed");
            throw new Error("authority");
        }
        const state = await $631c75f8a3fcffe9$var$SigninState.create({
            data: state_data,
            request_type: request_type,
            url_state: url_state,
            code_verifier: !disablePKCE,
            client_id: client_id,
            authority: authority,
            redirect_uri: redirect_uri,
            response_mode: response_mode,
            client_secret: client_secret,
            scope: scope,
            extraTokenParams: extraTokenParams,
            skipUserInfo: skipUserInfo,
            nonce: nonce
        });
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.append("client_id", client_id);
        parsedUrl.searchParams.append("redirect_uri", redirect_uri);
        parsedUrl.searchParams.append("response_type", response_type);
        if (!omitScopeWhenRequesting) parsedUrl.searchParams.append("scope", scope);
        if (nonce) parsedUrl.searchParams.append("nonce", nonce);
        if (dpopJkt) parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
        let stateParam = state.id;
        if (url_state) stateParam = `${stateParam}${$631c75f8a3fcffe9$var$URL_STATE_DELIMITER}${url_state}`;
        parsedUrl.searchParams.append("state", stateParam);
        if (state.code_challenge) {
            parsedUrl.searchParams.append("code_challenge", state.code_challenge);
            parsedUrl.searchParams.append("code_challenge_method", "S256");
        }
        if (resource) {
            const resources = Array.isArray(resource) ? resource : [
                resource
            ];
            resources.forEach((r)=>parsedUrl.searchParams.append("resource", r));
        }
        for (const [key, value] of Object.entries({
            response_mode: response_mode,
            ...optionalParams,
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        return new _SigninRequest({
            url: parsedUrl.href,
            state: state
        });
    }
};
$631c75f8a3fcffe9$var$_SigninRequest._logger = new $631c75f8a3fcffe9$var$Logger("SigninRequest");
var $631c75f8a3fcffe9$var$SigninRequest = $631c75f8a3fcffe9$var$_SigninRequest;
// src/SigninResponse.ts
var $631c75f8a3fcffe9$var$OidcScope = "openid";
var $631c75f8a3fcffe9$var$SigninResponse = class {
    constructor(params){
        /** @see {@link User.access_token} */ this.access_token = "";
        /** @see {@link User.token_type} */ this.token_type = "";
        /** @see {@link User.profile} */ this.profile = {};
        this.state = params.get("state");
        this.session_state = params.get("session_state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
        this.code = params.get("code");
    }
    get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (typeof value === "string") value = Number(value);
        if (value !== void 0 && value >= 0) this.expires_at = Math.floor(value) + $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    get isOpenId() {
        var _a;
        return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes($631c75f8a3fcffe9$var$OidcScope)) || !!this.id_token;
    }
};
// src/SignoutRequest.ts
var $631c75f8a3fcffe9$var$SignoutRequest = class {
    constructor({ url: url, state_data: state_data, id_token_hint: id_token_hint, post_logout_redirect_uri: post_logout_redirect_uri, extraQueryParams: extraQueryParams, request_type: request_type, client_id: client_id, url_state: url_state }){
        this._logger = new $631c75f8a3fcffe9$var$Logger("SignoutRequest");
        if (!url) {
            this._logger.error("ctor: No url passed");
            throw new Error("url");
        }
        const parsedUrl = new URL(url);
        if (id_token_hint) parsedUrl.searchParams.append("id_token_hint", id_token_hint);
        if (client_id) parsedUrl.searchParams.append("client_id", client_id);
        if (post_logout_redirect_uri) {
            parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
            if (state_data || url_state) {
                this.state = new $631c75f8a3fcffe9$var$State({
                    data: state_data,
                    request_type: request_type,
                    url_state: url_state
                });
                let stateParam = this.state.id;
                if (url_state) stateParam = `${stateParam}${$631c75f8a3fcffe9$var$URL_STATE_DELIMITER}${url_state}`;
                parsedUrl.searchParams.append("state", stateParam);
            }
        }
        for (const [key, value] of Object.entries({
            ...extraQueryParams
        }))if (value != null) parsedUrl.searchParams.append(key, value.toString());
        this.url = parsedUrl.href;
    }
};
// src/SignoutResponse.ts
var $631c75f8a3fcffe9$var$SignoutResponse = class {
    constructor(params){
        this.state = params.get("state");
        if (this.state) {
            const splitState = decodeURIComponent(this.state).split($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
            this.state = splitState[0];
            if (splitState.length > 1) this.url_state = splitState.slice(1).join($631c75f8a3fcffe9$var$URL_STATE_DELIMITER);
        }
        this.error = params.get("error");
        this.error_description = params.get("error_description");
        this.error_uri = params.get("error_uri");
    }
};
// src/ClaimsService.ts
var $631c75f8a3fcffe9$var$DefaultProtocolClaims = [
    "nbf",
    "jti",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "at_hash"
];
var $631c75f8a3fcffe9$var$InternalRequiredProtocolClaims = [
    "sub",
    "iss",
    "aud",
    "exp",
    "iat"
];
var $631c75f8a3fcffe9$var$ClaimsService = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("ClaimsService");
    }
    filterProtocolClaims(claims) {
        const result = {
            ...claims
        };
        if (this._settings.filterProtocolClaims) {
            let protocolClaims;
            if (Array.isArray(this._settings.filterProtocolClaims)) protocolClaims = this._settings.filterProtocolClaims;
            else protocolClaims = $631c75f8a3fcffe9$var$DefaultProtocolClaims;
            for (const claim of protocolClaims)if (!$631c75f8a3fcffe9$var$InternalRequiredProtocolClaims.includes(claim)) delete result[claim];
        }
        return result;
    }
    mergeClaims(claims1, claims2) {
        const result = {
            ...claims1
        };
        for (const [claim, values] of Object.entries(claims2))if (result[claim] !== values) {
            if (Array.isArray(result[claim]) || Array.isArray(values)) {
                if (this._settings.mergeClaimsStrategy.array == "replace") result[claim] = values;
                else {
                    const mergedValues = Array.isArray(result[claim]) ? result[claim] : [
                        result[claim]
                    ];
                    for (const value of Array.isArray(values) ? values : [
                        values
                    ])if (!mergedValues.includes(value)) mergedValues.push(value);
                    result[claim] = mergedValues;
                }
            } else if (typeof result[claim] === "object" && typeof values === "object") result[claim] = this.mergeClaims(result[claim], values);
            else result[claim] = values;
        }
        return result;
    }
};
// src/DPoPStore.ts
var $631c75f8a3fcffe9$var$DPoPState = class {
    constructor(keys, nonce){
        this.keys = keys;
        this.nonce = nonce;
    }
};
// src/OidcClient.ts
var $631c75f8a3fcffe9$var$OidcClient = class {
    constructor(settings, metadataService){
        this._logger = new $631c75f8a3fcffe9$var$Logger("OidcClient");
        this.settings = settings instanceof $631c75f8a3fcffe9$var$OidcClientSettingsStore ? settings : new $631c75f8a3fcffe9$var$OidcClientSettingsStore(settings);
        this.metadataService = metadataService != null ? metadataService : new $631c75f8a3fcffe9$var$MetadataService(this.settings);
        this._claimsService = new $631c75f8a3fcffe9$var$ClaimsService(this.settings);
        this._validator = new $631c75f8a3fcffe9$var$ResponseValidator(this.settings, this.metadataService, this._claimsService);
        this._tokenClient = new $631c75f8a3fcffe9$var$TokenClient(this.settings, this.metadataService);
    }
    async createSigninRequest({ state: state, request: request, request_uri: request_uri, request_type: request_type, id_token_hint: id_token_hint, login_hint: login_hint, skipUserInfo: skipUserInfo, nonce: nonce, url_state: url_state, response_type: response_type = this.settings.response_type, scope: scope = this.settings.scope, redirect_uri: redirect_uri = this.settings.redirect_uri, prompt: prompt = this.settings.prompt, display: display = this.settings.display, max_age: max_age = this.settings.max_age, ui_locales: ui_locales = this.settings.ui_locales, acr_values: acr_values = this.settings.acr_values, resource: resource = this.settings.resource, response_mode: response_mode = this.settings.response_mode, extraQueryParams: extraQueryParams = this.settings.extraQueryParams, extraTokenParams: extraTokenParams = this.settings.extraTokenParams, dpopJkt: dpopJkt, omitScopeWhenRequesting: omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting }) {
        const logger2 = this._logger.create("createSigninRequest");
        if (response_type !== "code") throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const url = await this.metadataService.getAuthorizationEndpoint();
        logger2.debug("Received authorization endpoint", url);
        const signinRequest = await $631c75f8a3fcffe9$var$SigninRequest.create({
            url: url,
            authority: this.settings.authority,
            client_id: this.settings.client_id,
            redirect_uri: redirect_uri,
            response_type: response_type,
            scope: scope,
            state_data: state,
            url_state: url_state,
            prompt: prompt,
            display: display,
            max_age: max_age,
            ui_locales: ui_locales,
            id_token_hint: id_token_hint,
            login_hint: login_hint,
            acr_values: acr_values,
            dpopJkt: dpopJkt,
            resource: resource,
            request: request,
            request_uri: request_uri,
            extraQueryParams: extraQueryParams,
            extraTokenParams: extraTokenParams,
            request_type: request_type,
            response_mode: response_mode,
            client_secret: this.settings.client_secret,
            skipUserInfo: skipUserInfo,
            nonce: nonce,
            disablePKCE: this.settings.disablePKCE,
            omitScopeWhenRequesting: omitScopeWhenRequesting
        });
        await this.clearStaleState();
        const signinState = signinRequest.state;
        await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
        return signinRequest;
    }
    async readSigninResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSigninResponseState");
        const response = new $631c75f8a3fcffe9$var$SigninResponse($631c75f8a3fcffe9$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.throw(new Error("No state in response"));
            throw null;
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $631c75f8a3fcffe9$var$SigninState.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSigninResponse(url, extraHeaders, removeState = true) {
        const logger2 = this._logger.create("processSigninResponse");
        const { state: state, response: response } = await this.readSigninResponseState(url, removeState);
        logger2.debug("received state from storage; validating response");
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        try {
            await this._validator.validateSigninResponse(response, state, extraHeaders);
        } catch (err) {
            if (err instanceof $631c75f8a3fcffe9$var$ErrorDPoPNonce && this.settings.dpop) {
                const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                extraHeaders["DPoP"] = dpopProof;
                await this._validator.validateSigninResponse(response, state, extraHeaders);
            } else throw err;
        }
        return response;
    }
    async getDpopProof(dpopStore, nonce) {
        let keyPair;
        let dpopState;
        if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
            keyPair = await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $631c75f8a3fcffe9$var$DPoPState(keyPair, nonce);
            await dpopStore.set(this.settings.client_id, dpopState);
        } else {
            dpopState = await dpopStore.get(this.settings.client_id);
            if (dpopState.nonce !== nonce && nonce) {
                dpopState.nonce = nonce;
                await dpopStore.set(this.settings.client_id, dpopState);
            }
        }
        return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPProof({
            url: await this.metadataService.getTokenEndpoint(false),
            httpMethod: "POST",
            keyPair: dpopState.keys,
            nonce: dpopState.nonce
        });
    }
    async processResourceOwnerPasswordCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false, extraTokenParams: extraTokenParams = {} }) {
        const tokenResponse = await this._tokenClient.exchangeCredentials({
            username: username,
            password: password,
            ...extraTokenParams
        });
        const signinResponse = new $631c75f8a3fcffe9$var$SigninResponse(new URLSearchParams());
        Object.assign(signinResponse, tokenResponse);
        await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
        return signinResponse;
    }
    async useRefreshToken({ state: state, redirect_uri: redirect_uri, resource: resource, timeoutInSeconds: timeoutInSeconds, extraHeaders: extraHeaders, extraTokenParams: extraTokenParams }) {
        var _a;
        const logger2 = this._logger.create("useRefreshToken");
        let scope;
        if (this.settings.refreshTokenAllowedScope === void 0) scope = state.scope;
        else {
            const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
            const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
            scope = providedScopes.filter((s)=>allowableScopes.includes(s)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
            const dpopProof = await this.getDpopProof(this.settings.dpop.store);
            extraHeaders = {
                ...extraHeaders,
                "DPoP": dpopProof
            };
        }
        let result;
        try {
            result = await this._tokenClient.exchangeRefreshToken({
                refresh_token: state.refresh_token,
                scope: // provide the (possible filtered) scope list
                scope,
                redirect_uri: redirect_uri,
                resource: resource,
                timeoutInSeconds: timeoutInSeconds,
                extraHeaders: extraHeaders,
                ...extraTokenParams
            });
        } catch (err) {
            if (err instanceof $631c75f8a3fcffe9$var$ErrorDPoPNonce && this.settings.dpop) {
                extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
                result = await this._tokenClient.exchangeRefreshToken({
                    refresh_token: state.refresh_token,
                    scope: // provide the (possible filtered) scope list
                    scope,
                    redirect_uri: redirect_uri,
                    resource: resource,
                    timeoutInSeconds: timeoutInSeconds,
                    extraHeaders: extraHeaders,
                    ...extraTokenParams
                });
            } else throw err;
        }
        const response = new $631c75f8a3fcffe9$var$SigninResponse(new URLSearchParams());
        Object.assign(response, result);
        logger2.debug("validating response", response);
        await this._validator.validateRefreshResponse(response, {
            ...state,
            scope: // override the scope in the state handed over to the validator
            // so it can set the granted scope to the requested scope in case none is included in the response
            scope
        });
        return response;
    }
    async createSignoutRequest({ state: state, id_token_hint: id_token_hint, client_id: client_id, request_type: request_type, url_state: url_state, post_logout_redirect_uri: post_logout_redirect_uri = this.settings.post_logout_redirect_uri, extraQueryParams: extraQueryParams = this.settings.extraQueryParams } = {}) {
        const logger2 = this._logger.create("createSignoutRequest");
        const url = await this.metadataService.getEndSessionEndpoint();
        if (!url) {
            logger2.throw(new Error("No end session endpoint"));
            throw null;
        }
        logger2.debug("Received end session endpoint", url);
        if (!client_id && post_logout_redirect_uri && !id_token_hint) client_id = this.settings.client_id;
        const request = new $631c75f8a3fcffe9$var$SignoutRequest({
            url: url,
            id_token_hint: id_token_hint,
            client_id: client_id,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state_data: state,
            extraQueryParams: extraQueryParams,
            request_type: request_type,
            url_state: url_state
        });
        await this.clearStaleState();
        const signoutState = request.state;
        if (signoutState) {
            logger2.debug("Signout request has state to persist");
            await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
        }
        return request;
    }
    async readSignoutResponseState(url, removeState = false) {
        const logger2 = this._logger.create("readSignoutResponseState");
        const response = new $631c75f8a3fcffe9$var$SignoutResponse($631c75f8a3fcffe9$var$UrlUtils.readParams(url, this.settings.response_mode));
        if (!response.state) {
            logger2.debug("No state in response");
            if (response.error) {
                logger2.warn("Response was error:", response.error);
                throw new $631c75f8a3fcffe9$var$ErrorResponse(response);
            }
            return {
                state: void 0,
                response: response
            };
        }
        const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
        if (!storedStateString) {
            logger2.throw(new Error("No matching state found in storage"));
            throw null;
        }
        const state = await $631c75f8a3fcffe9$var$State.fromStorageString(storedStateString);
        return {
            state: state,
            response: response
        };
    }
    async processSignoutResponse(url) {
        const logger2 = this._logger.create("processSignoutResponse");
        const { state: state, response: response } = await this.readSignoutResponseState(url, true);
        if (state) {
            logger2.debug("Received state from storage; validating response");
            this._validator.validateSignoutResponse(response, state);
        } else logger2.debug("No state from storage; skipping response validation");
        return response;
    }
    clearStaleState() {
        this._logger.create("clearStaleState");
        return $631c75f8a3fcffe9$var$State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
    async revokeToken(token, type) {
        this._logger.create("revokeToken");
        return await this._tokenClient.revoke({
            token: token,
            token_type_hint: type
        });
    }
};
// src/SessionMonitor.ts
var $631c75f8a3fcffe9$var$SessionMonitor = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $631c75f8a3fcffe9$var$Logger("SessionMonitor");
        this._start = async (user)=>{
            const session_state = user.session_state;
            if (!session_state) return;
            const logger2 = this._logger.create("_start");
            if (user.profile) {
                this._sub = user.profile.sub;
                logger2.debug("session_state", session_state, ", sub", this._sub);
            } else {
                this._sub = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
            }
            if (this._checkSessionIFrame) {
                this._checkSessionIFrame.start(session_state);
                return;
            }
            try {
                const url = await this._userManager.metadataService.getCheckSessionIframe();
                if (url) {
                    logger2.debug("initializing check session iframe");
                    const client_id = this._userManager.settings.client_id;
                    const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
                    const stopOnError = this._userManager.settings.stopCheckSessionOnError;
                    const checkSessionIFrame = new $631c75f8a3fcffe9$var$CheckSessionIFrame(this._callback, client_id, url, intervalInSeconds, stopOnError);
                    await checkSessionIFrame.load();
                    this._checkSessionIFrame = checkSessionIFrame;
                    checkSessionIFrame.start(session_state);
                } else logger2.warn("no check session iframe found in the metadata");
            } catch (err) {
                logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
            }
        };
        this._stop = ()=>{
            const logger2 = this._logger.create("_stop");
            this._sub = void 0;
            if (this._checkSessionIFrame) this._checkSessionIFrame.stop();
            if (this._userManager.settings.monitorAnonymousSession) {
                const timerHandle = setInterval(async ()=>{
                    clearInterval(timerHandle);
                    try {
                        const session = await this._userManager.querySessionStatus();
                        if (session) {
                            const tmpUser = {
                                session_state: session.session_state,
                                profile: session.sub ? {
                                    sub: session.sub
                                } : null
                            };
                            this._start(tmpUser);
                        }
                    } catch (err) {
                        logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
                    }
                }, 1e3);
            }
        };
        this._callback = async ()=>{
            const logger2 = this._logger.create("_callback");
            try {
                const session = await this._userManager.querySessionStatus();
                let raiseEvent = true;
                if (session && this._checkSessionIFrame) {
                    if (session.sub === this._sub) {
                        raiseEvent = false;
                        this._checkSessionIFrame.start(session.session_state);
                        logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                        await this._userManager.events._raiseUserSessionChanged();
                    } else logger2.debug("different subject signed into OP", session.sub);
                } else logger2.debug("subject no longer signed into OP");
                if (raiseEvent) {
                    if (this._sub) await this._userManager.events._raiseUserSignedOut();
                    else await this._userManager.events._raiseUserSignedIn();
                } else logger2.debug("no change in session detected, no event to raise");
            } catch (err) {
                if (this._sub) {
                    logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
                    await this._userManager.events._raiseUserSignedOut();
                }
            }
        };
        if (!_userManager) this._logger.throw(new Error("No user manager passed"));
        this._userManager.events.addUserLoaded(this._start);
        this._userManager.events.addUserUnloaded(this._stop);
        this._init().catch((err)=>{
            this._logger.error(err);
        });
    }
    async _init() {
        this._logger.create("_init");
        const user = await this._userManager.getUser();
        if (user) this._start(user);
        else if (this._userManager.settings.monitorAnonymousSession) {
            const session = await this._userManager.querySessionStatus();
            if (session) {
                const tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub ? {
                        sub: session.sub
                    } : null
                };
                this._start(tmpUser);
            }
        }
    }
};
// src/User.ts
var $631c75f8a3fcffe9$var$User = class _User {
    constructor(args){
        var _a;
        this.id_token = args.id_token;
        this.session_state = (_a = args.session_state) != null ? _a : null;
        this.access_token = args.access_token;
        this.refresh_token = args.refresh_token;
        this.token_type = args.token_type;
        this.scope = args.scope;
        this.profile = args.profile;
        this.expires_at = args.expires_at;
        this.state = args.userState;
        this.url_state = args.url_state;
    }
    /** Computed number of seconds the access token has remaining. */ get expires_in() {
        if (this.expires_at === void 0) return void 0;
        return this.expires_at - $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    set expires_in(value) {
        if (value !== void 0) this.expires_at = Math.floor(value) + $631c75f8a3fcffe9$var$Timer.getEpochTime();
    }
    /** Computed value indicating if the access token is expired. */ get expired() {
        const expires_in = this.expires_in;
        if (expires_in === void 0) return void 0;
        return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */ get scopes() {
        var _a, _b;
        return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
    toStorageString() {
        new $631c75f8a3fcffe9$var$Logger("User").create("toStorageString");
        return JSON.stringify({
            id_token: this.id_token,
            session_state: this.session_state,
            access_token: this.access_token,
            refresh_token: this.refresh_token,
            token_type: this.token_type,
            scope: this.scope,
            profile: this.profile,
            expires_at: this.expires_at
        });
    }
    static fromStorageString(storageString) {
        $631c75f8a3fcffe9$var$Logger.createStatic("User", "fromStorageString");
        return new _User(JSON.parse(storageString));
    }
};
// src/navigators/AbstractChildWindow.ts
var $631c75f8a3fcffe9$var$messageSource = "oidc-client";
var $631c75f8a3fcffe9$var$AbstractChildWindow = class {
    constructor(){
        this._abort = new $631c75f8a3fcffe9$var$Event("Window navigation aborted");
        this._disposeHandlers = /* @__PURE__ */ new Set();
        this._window = null;
    }
    async navigate(params) {
        const logger2 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        logger2.debug("setting URL in window");
        this._window.location.replace(params.url);
        const { url: url, keepOpen: keepOpen } = await new Promise((resolve, reject)=>{
            const listener = (e)=>{
                var _a;
                const data = e.data;
                const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                if (e.origin !== origin || (data == null ? void 0 : data.source) !== $631c75f8a3fcffe9$var$messageSource) return;
                try {
                    const state = $631c75f8a3fcffe9$var$UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) logger2.warn("no state found in response url");
                    if (e.source !== this._window && state !== params.state) return;
                } catch  {
                    this._dispose();
                    reject(new Error("Invalid response from window"));
                }
                resolve(data);
            };
            window.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>window.removeEventListener("message", listener, false));
            const channel = new BroadcastChannel(`oidc-client-popup-${params.state}`);
            channel.addEventListener("message", listener, false);
            this._disposeHandlers.add(()=>channel.close());
            this._disposeHandlers.add(this._abort.addHandler((reason)=>{
                this._dispose();
                reject(reason);
            }));
        });
        logger2.debug("got response from window");
        this._dispose();
        if (!keepOpen) this.close();
        return {
            url: url
        };
    }
    _dispose() {
        this._logger.create("_dispose");
        for (const dispose of this._disposeHandlers)dispose();
        this._disposeHandlers.clear();
    }
    static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
        const msgData = {
            source: $631c75f8a3fcffe9$var$messageSource,
            url: url,
            keepOpen: keepOpen
        };
        const logger2 = new $631c75f8a3fcffe9$var$Logger("_notifyParent");
        if (parent) {
            logger2.debug("With parent. Using parent.postMessage.");
            parent.postMessage(msgData, targetOrigin);
        } else {
            logger2.debug("No parent. Using BroadcastChannel.");
            const state = new URL(url).searchParams.get("state");
            if (!state) throw new Error("No parent and no state in URL. Can't complete notification.");
            const channel = new BroadcastChannel(`oidc-client-popup-${state}`);
            channel.postMessage(msgData);
            channel.close();
        }
    }
};
// src/UserManagerSettings.ts
var $631c75f8a3fcffe9$var$DefaultPopupWindowFeatures = {
    location: false,
    toolbar: false,
    height: 640,
    closePopupWindowAfterInSeconds: -1
};
var $631c75f8a3fcffe9$var$DefaultPopupTarget = "_blank";
var $631c75f8a3fcffe9$var$DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var $631c75f8a3fcffe9$var$DefaultCheckSessionIntervalInSeconds = 2;
var $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds = 10;
var $631c75f8a3fcffe9$var$UserManagerSettingsStore = class extends $631c75f8a3fcffe9$var$OidcClientSettingsStore {
    constructor(args){
        const { popup_redirect_uri: popup_redirect_uri = args.redirect_uri, popup_post_logout_redirect_uri: popup_post_logout_redirect_uri = args.post_logout_redirect_uri, popupWindowFeatures: popupWindowFeatures = $631c75f8a3fcffe9$var$DefaultPopupWindowFeatures, popupWindowTarget: popupWindowTarget = $631c75f8a3fcffe9$var$DefaultPopupTarget, redirectMethod: redirectMethod = "assign", redirectTarget: redirectTarget = "self", iframeNotifyParentOrigin: iframeNotifyParentOrigin = args.iframeNotifyParentOrigin, iframeScriptOrigin: iframeScriptOrigin = args.iframeScriptOrigin, requestTimeoutInSeconds: requestTimeoutInSeconds, silent_redirect_uri: silent_redirect_uri = args.redirect_uri, silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, automaticSilentRenew: automaticSilentRenew = true, validateSubOnSilentRenew: validateSubOnSilentRenew = true, includeIdTokenInSilentRenew: includeIdTokenInSilentRenew = false, monitorSession: monitorSession = false, monitorAnonymousSession: monitorAnonymousSession = false, checkSessionIntervalInSeconds: checkSessionIntervalInSeconds = $631c75f8a3fcffe9$var$DefaultCheckSessionIntervalInSeconds, query_status_response_type: query_status_response_type = "code", stopCheckSessionOnError: stopCheckSessionOnError = true, revokeTokenTypes: revokeTokenTypes = [
            "access_token",
            "refresh_token"
        ], revokeTokensOnSignout: revokeTokensOnSignout = false, includeIdTokenInSilentSignout: includeIdTokenInSilentSignout = false, accessTokenExpiringNotificationTimeInSeconds: accessTokenExpiringNotificationTimeInSeconds = $631c75f8a3fcffe9$var$DefaultAccessTokenExpiringNotificationTimeInSeconds, maxSilentRenewTimeoutRetries: maxSilentRenewTimeoutRetries, userStore: userStore } = args;
        super(args);
        this.popup_redirect_uri = popup_redirect_uri;
        this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
        this.popupWindowFeatures = popupWindowFeatures;
        this.popupWindowTarget = popupWindowTarget;
        this.redirectMethod = redirectMethod;
        this.redirectTarget = redirectTarget;
        this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
        this.iframeScriptOrigin = iframeScriptOrigin;
        this.silent_redirect_uri = silent_redirect_uri;
        this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds;
        this.automaticSilentRenew = automaticSilentRenew;
        this.validateSubOnSilentRenew = validateSubOnSilentRenew;
        this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
        this.monitorSession = monitorSession;
        this.monitorAnonymousSession = monitorAnonymousSession;
        this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
        this.stopCheckSessionOnError = stopCheckSessionOnError;
        this.query_status_response_type = query_status_response_type;
        this.revokeTokenTypes = revokeTokenTypes;
        this.revokeTokensOnSignout = revokeTokensOnSignout;
        this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
        this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
        this.maxSilentRenewTimeoutRetries = maxSilentRenewTimeoutRetries;
        if (userStore) this.userStore = userStore;
        else {
            const store = typeof window !== "undefined" ? window.sessionStorage : new $631c75f8a3fcffe9$var$InMemoryWebStorage();
            this.userStore = new $631c75f8a3fcffe9$var$WebStorageStateStore({
                store: store
            });
        }
    }
};
// src/navigators/IFrameWindow.ts
var $631c75f8a3fcffe9$var$IFrameWindow = class _IFrameWindow extends $631c75f8a3fcffe9$var$AbstractChildWindow {
    constructor({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = $631c75f8a3fcffe9$var$DefaultSilentRequestTimeoutInSeconds }){
        super();
        this._logger = new $631c75f8a3fcffe9$var$Logger("IFrameWindow");
        this._timeoutInSeconds = silentRequestTimeoutInSeconds;
        this._frame = _IFrameWindow.createHiddenIframe();
        this._window = this._frame.contentWindow;
    }
    static createHiddenIframe() {
        const iframe = window.document.createElement("iframe");
        iframe.style.visibility = "hidden";
        iframe.style.position = "fixed";
        iframe.style.left = "-1000px";
        iframe.style.top = "0";
        iframe.width = "0";
        iframe.height = "0";
        window.document.body.appendChild(iframe);
        return iframe;
    }
    async navigate(params) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const timer = setTimeout(()=>void this._abort.raise(new $631c75f8a3fcffe9$var$ErrorTimeout("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
        this._disposeHandlers.add(()=>clearTimeout(timer));
        return await super.navigate(params);
    }
    close() {
        var _a;
        if (this._frame) {
            if (this._frame.parentNode) {
                this._frame.addEventListener("load", (ev)=>{
                    var _a2;
                    const frame = ev.target;
                    (_a2 = frame.parentNode) == null || _a2.removeChild(frame);
                    this._abort.raise(new Error("IFrame removed from DOM"));
                }, true);
                (_a = this._frame.contentWindow) == null || _a.location.replace("about:blank");
            }
            this._frame = null;
        }
        this._window = null;
    }
    static notifyParent(url, targetOrigin) {
        return super._notifyParent(window.parent, url, false, targetOrigin);
    }
};
// src/navigators/IFrameNavigator.ts
var $631c75f8a3fcffe9$var$IFrameNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("IFrameNavigator");
    }
    async prepare({ silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds }) {
        return new $631c75f8a3fcffe9$var$IFrameWindow({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
    }
    async callback(url) {
        this._logger.create("callback");
        $631c75f8a3fcffe9$var$IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
    }
};
// src/navigators/PopupWindow.ts
var $631c75f8a3fcffe9$var$checkForPopupClosedInterval = 500;
var $631c75f8a3fcffe9$var$second = 1e3;
var $631c75f8a3fcffe9$var$PopupWindow = class extends $631c75f8a3fcffe9$var$AbstractChildWindow {
    constructor({ popupWindowTarget: popupWindowTarget = $631c75f8a3fcffe9$var$DefaultPopupTarget, popupWindowFeatures: popupWindowFeatures = {}, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }){
        super();
        this._logger = new $631c75f8a3fcffe9$var$Logger("PopupWindow");
        const centeredPopup = $631c75f8a3fcffe9$var$PopupUtils.center({
            ...$631c75f8a3fcffe9$var$DefaultPopupWindowFeatures,
            ...popupWindowFeatures
        });
        this._window = window.open(void 0, popupWindowTarget, $631c75f8a3fcffe9$var$PopupUtils.serialize(centeredPopup));
        this.abortOnClose = Boolean(popupAbortOnClose);
        if (popupSignal) popupSignal.addEventListener("abort", ()=>{
            var _a;
            this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
        });
        if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) setTimeout(()=>{
            if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
                this._abort.raise(new Error("Popup blocked by user"));
                return;
            }
            this.close();
        }, popupWindowFeatures.closePopupWindowAfterInSeconds * $631c75f8a3fcffe9$var$second);
    }
    async navigate(params) {
        var _a;
        (_a = this._window) == null || _a.focus();
        const popupClosedInterval = setInterval(()=>{
            if (!this._window || this._window.closed) {
                this._logger.debug("Popup closed by user or isolated by redirect");
                clearPopupClosedInterval();
                this._disposeHandlers.delete(clearPopupClosedInterval);
                if (this.abortOnClose) this._abort.raise(new Error("Popup closed by user"));
            }
        }, $631c75f8a3fcffe9$var$checkForPopupClosedInterval);
        const clearPopupClosedInterval = ()=>clearInterval(popupClosedInterval);
        this._disposeHandlers.add(clearPopupClosedInterval);
        return await super.navigate(params);
    }
    close() {
        if (this._window) {
            if (!this._window.closed) {
                this._window.close();
                this._abort.raise(new Error("Popup closed"));
            }
        }
        this._window = null;
    }
    static notifyOpener(url, keepOpen) {
        super._notifyParent(window.opener, url, keepOpen);
        if (!keepOpen && !window.opener) window.close();
    }
};
// src/navigators/PopupNavigator.ts
var $631c75f8a3fcffe9$var$PopupNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("PopupNavigator");
    }
    async prepare({ popupWindowFeatures: popupWindowFeatures = this._settings.popupWindowFeatures, popupWindowTarget: popupWindowTarget = this._settings.popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose }) {
        return new $631c75f8a3fcffe9$var$PopupWindow({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
    }
    async callback(url, { keepOpen: keepOpen = false }) {
        this._logger.create("callback");
        $631c75f8a3fcffe9$var$PopupWindow.notifyOpener(url, keepOpen);
    }
};
// src/navigators/RedirectNavigator.ts
var $631c75f8a3fcffe9$var$RedirectNavigator = class {
    constructor(_settings){
        this._settings = _settings;
        this._logger = new $631c75f8a3fcffe9$var$Logger("RedirectNavigator");
    }
    async prepare({ redirectMethod: redirectMethod = this._settings.redirectMethod, redirectTarget: redirectTarget = this._settings.redirectTarget }) {
        var _a;
        this._logger.create("prepare");
        let targetWindow = window.self;
        if (redirectTarget === "top") targetWindow = (_a = window.top) != null ? _a : window.self;
        const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
        let abort;
        return {
            navigate: async (params)=>{
                this._logger.create("navigate");
                const promise = new Promise((resolve, reject)=>{
                    abort = reject;
                    window.addEventListener("pageshow", ()=>resolve(window.location.href));
                    redirect(params.url);
                });
                return await promise;
            },
            close: ()=>{
                this._logger.create("close");
                abort == null || abort(new Error("Redirect aborted"));
                targetWindow.stop();
            }
        };
    }
    async callback() {
        return;
    }
};
// src/UserManagerEvents.ts
var $631c75f8a3fcffe9$var$UserManagerEvents = class extends $631c75f8a3fcffe9$var$AccessTokenEvents {
    constructor(settings){
        super({
            expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
        });
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserManagerEvents");
        this._userLoaded = new $631c75f8a3fcffe9$var$Event("User loaded");
        this._userUnloaded = new $631c75f8a3fcffe9$var$Event("User unloaded");
        this._silentRenewError = new $631c75f8a3fcffe9$var$Event("Silent renew error");
        this._userSignedIn = new $631c75f8a3fcffe9$var$Event("User signed in");
        this._userSignedOut = new $631c75f8a3fcffe9$var$Event("User signed out");
        this._userSessionChanged = new $631c75f8a3fcffe9$var$Event("User session changed");
    }
    async load(user, raiseEvent = true) {
        await super.load(user);
        if (raiseEvent) await this._userLoaded.raise(user);
    }
    async unload() {
        await super.unload();
        await this._userUnloaded.raise();
    }
    /**
   * Add callback: Raised when a user session has been established (or re-established).
   */ addUserLoaded(cb) {
        return this._userLoaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */ removeUserLoaded(cb) {
        return this._userLoaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when a user session has been terminated.
   */ addUserUnloaded(cb) {
        return this._userUnloaded.addHandler(cb);
    }
    /**
   * Remove callback: Raised when a user session has been terminated.
   */ removeUserUnloaded(cb) {
        return this._userUnloaded.removeHandler(cb);
    }
    /**
   * Add callback: Raised when the automatic silent renew has failed.
   */ addSilentRenewError(cb) {
        return this._silentRenewError.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */ removeSilentRenewError(cb) {
        return this._silentRenewError.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseSilentRenewError(e) {
        await this._silentRenewError.raise(e);
    }
    /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedIn(cb) {
        return this._userSignedIn.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */ removeUserSignedIn(cb) {
        this._userSignedIn.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
    }
    /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSignedOut(cb) {
        return this._userSignedOut.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */ removeUserSignedOut(cb) {
        this._userSignedOut.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
    }
    /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */ addUserSessionChanged(cb) {
        return this._userSessionChanged.addHandler(cb);
    }
    /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */ removeUserSessionChanged(cb) {
        this._userSessionChanged.removeHandler(cb);
    }
    /**
   * @internal
   */ async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
    }
};
// src/SilentRenewService.ts
var $631c75f8a3fcffe9$var$SilentRenewService = class {
    constructor(_userManager){
        this._userManager = _userManager;
        this._logger = new $631c75f8a3fcffe9$var$Logger("SilentRenewService");
        this._isStarted = false;
        this._retryTimer = new $631c75f8a3fcffe9$var$Timer("Retry Silent Renew");
        this._timeoutRetryCount = 0;
        this._tokenExpiring = async ()=>{
            const logger2 = this._logger.create("_tokenExpiring");
            try {
                await this._userManager.signinSilent();
                this._timeoutRetryCount = 0;
                logger2.debug("silent token renewal successful");
            } catch (err) {
                if (err instanceof $631c75f8a3fcffe9$var$ErrorTimeout) {
                    this._timeoutRetryCount++;
                    const maxRetries = this._userManager.settings.maxSilentRenewTimeoutRetries;
                    const hasReachedLimit = maxRetries !== void 0 && this._timeoutRetryCount > maxRetries;
                    if (hasReachedLimit) {
                        logger2.error(`Timeout retry limit reached (${this._timeoutRetryCount} > ${maxRetries}), raising silentRenewError:`, err);
                        this._timeoutRetryCount = 0;
                        await this._userManager.events._raiseSilentRenewError(err);
                        return;
                    }
                    logger2.warn(`ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`, err);
                    this._retryTimer.init(5);
                    return;
                }
                logger2.error("Error from signinSilent:", err);
                this._timeoutRetryCount = 0;
                await this._userManager.events._raiseSilentRenewError(err);
            }
        };
    }
    async start() {
        const logger2 = this._logger.create("start");
        if (!this._isStarted) {
            this._isStarted = true;
            this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
            this._retryTimer.addHandler(this._tokenExpiring);
            try {
                await this._userManager.getUser();
            } catch (err) {
                logger2.error("getUser error", err);
            }
        }
    }
    stop() {
        if (this._isStarted) {
            this._retryTimer.cancel();
            this._retryTimer.removeHandler(this._tokenExpiring);
            this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
            this._isStarted = false;
        }
    }
};
// src/RefreshState.ts
var $631c75f8a3fcffe9$var$RefreshState = class {
    constructor(args){
        this.refresh_token = args.refresh_token;
        this.id_token = args.id_token;
        this.session_state = args.session_state;
        this.scope = args.scope;
        this.profile = args.profile;
        this.data = args.state;
    }
};
// src/UserManager.ts
var $631c75f8a3fcffe9$var$UserManager = class {
    constructor(settings, redirectNavigator, popupNavigator, iframeNavigator){
        this._logger = new $631c75f8a3fcffe9$var$Logger("UserManager");
        this.settings = new $631c75f8a3fcffe9$var$UserManagerSettingsStore(settings);
        this._client = new $631c75f8a3fcffe9$var$OidcClient(settings);
        this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new $631c75f8a3fcffe9$var$RedirectNavigator(this.settings);
        this._popupNavigator = popupNavigator != null ? popupNavigator : new $631c75f8a3fcffe9$var$PopupNavigator(this.settings);
        this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new $631c75f8a3fcffe9$var$IFrameNavigator(this.settings);
        this._events = new $631c75f8a3fcffe9$var$UserManagerEvents(this.settings);
        this._silentRenewService = new $631c75f8a3fcffe9$var$SilentRenewService(this);
        if (this.settings.automaticSilentRenew) this.startSilentRenew();
        this._sessionMonitor = null;
        if (this.settings.monitorSession) this._sessionMonitor = new $631c75f8a3fcffe9$var$SessionMonitor(this);
    }
    /**
   * Get object used to register for events raised by the `UserManager`.
   */ get events() {
        return this._events;
    }
    /**
   * Get object used to access the metadata configuration of the identity provider.
   */ get metadataService() {
        return this._client.metadataService;
    }
    /**
   * Load the `User` object for the currently authenticated user.
   *
   * @param raiseEvent - If `true`, the `UserLoaded` event will be raised. Defaults to false.
   * @returns A promise
   */ async getUser(raiseEvent = false) {
        const logger2 = this._logger.create("getUser");
        const user = await this._loadUser();
        if (user) {
            logger2.info("user loaded");
            await this._events.load(user, raiseEvent);
            return user;
        }
        logger2.info("user not found in storage");
        return null;
    }
    /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */ async removeUser() {
        const logger2 = this._logger.create("removeUser");
        await this.storeUser(null);
        logger2.info("user removed from storage");
        await this._events.unload();
    }
    /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */ async signinRedirect(args = {}) {
        var _a;
        this._logger.create("signinRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signinStart({
            request_type: "si:r",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
    }
    /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */ async signinRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinRedirectCallback");
        const user = await this._signinEnd(url);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */ async signinResourceOwnerCredentials({ username: username, password: password, skipUserInfo: skipUserInfo = false }) {
        const logger2 = this._logger.create("signinResourceOwnerCredential");
        const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
            username: username,
            password: password,
            skipUserInfo: skipUserInfo,
            extraTokenParams: this.settings.extraTokenParams
        });
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse);
        if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
        else logger2.info("no subject");
        return user;
    }
    /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */ async signinPopup(args = {}) {
        var _a;
        const logger2 = this._logger.create("signinPopup");
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, popupAbortOnClose: popupAbortOnClose, ...requestArgs } = args;
        const url = this.settings.popup_redirect_uri;
        if (!url) logger2.throw(new Error("No popup_redirect_uri configured"));
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal,
            popupAbortOnClose: popupAbortOnClose
        });
        const user = await this._signin({
            request_type: "si:p",
            redirect_uri: url,
            display: "popup",
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle);
        if (user) {
            if (user.profile && user.profile.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */ async signinSilent(args = {}) {
        var _a, _b;
        const logger2 = this._logger.create("signinSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        let user = await this._loadUser();
        if (!args.forceIframeAuth && (user == null ? void 0 : user.refresh_token)) {
            logger2.debug("using refresh token");
            const state = new $631c75f8a3fcffe9$var$RefreshState(user);
            return await this._useRefreshToken({
                state: state,
                redirect_uri: requestArgs.redirect_uri,
                resource: requestArgs.resource,
                extraTokenParams: requestArgs.extraTokenParams,
                timeoutInSeconds: silentRequestTimeoutInSeconds
            });
        }
        let dpopJkt;
        if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        let verifySub;
        if (user && this.settings.validateSubOnSilentRenew) {
            logger2.debug("subject prior to silent renew:", user.profile.sub);
            verifySub = user.profile.sub;
        }
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        user = await this._signin({
            request_type: "si:s",
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            dpopJkt: dpopJkt,
            ...requestArgs
        }, handle, verifySub);
        if (user) {
            if ((_b = user.profile) == null ? void 0 : _b.sub) logger2.info("success, signed in subject", user.profile.sub);
            else logger2.info("no subject");
        }
        return user;
    }
    async _useRefreshToken(args) {
        const response = await this._client.useRefreshToken({
            timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
            ...args
        });
        const user = new $631c75f8a3fcffe9$var$User({
            ...args.state,
            ...response
        });
        await this.storeUser(user);
        await this._events.load(user);
        return user;
    }
    /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */ async signinSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */ async signinCallback(url = window.location.href) {
        const { state: state } = await this._client.readSigninResponseState(url);
        switch(state.request_type){
            case "si:r":
                return await this.signinRedirectCallback(url);
            case "si:p":
                await this.signinPopupCallback(url);
                break;
            case "si:s":
                await this.signinSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */ async signoutCallback(url = window.location.href, keepOpen = false) {
        const { state: state } = await this._client.readSignoutResponseState(url);
        if (!state) return void 0;
        switch(state.request_type){
            case "so:r":
                return await this.signoutRedirectCallback(url);
            case "so:p":
                await this.signoutPopupCallback(url, keepOpen);
                break;
            case "so:s":
                await this.signoutSilentCallback(url);
                break;
            default:
                throw new Error("invalid request_type in state");
        }
        return void 0;
    }
    /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */ async querySessionStatus(args = {}) {
        const logger2 = this._logger.create("querySessionStatus");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const url = this.settings.silent_redirect_uri;
        if (!url) logger2.throw(new Error("No silent_redirect_uri configured"));
        const user = await this._loadUser();
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        const navResponse = await this._signinStart({
            request_type: "si:s",
            // this acts like a signin silent
            redirect_uri: url,
            prompt: "none",
            id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
            response_type: this.settings.query_status_response_type,
            scope: "openid",
            skipUserInfo: true,
            ...requestArgs
        }, handle);
        try {
            const extraHeaders = {};
            const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
            logger2.debug("got signin response");
            if (signinResponse.session_state && signinResponse.profile.sub) {
                logger2.info("success for subject", signinResponse.profile.sub);
                return {
                    session_state: signinResponse.session_state,
                    sub: signinResponse.profile.sub
                };
            }
            logger2.info("success, user not authenticated");
            return null;
        } catch (err) {
            if (this.settings.monitorAnonymousSession && err instanceof $631c75f8a3fcffe9$var$ErrorResponse) switch(err.error){
                case "login_required":
                case "consent_required":
                case "interaction_required":
                case "account_selection_required":
                    logger2.info("success for anonymous user");
                    return {
                        session_state: err.session_state
                    };
            }
            throw err;
        }
    }
    async _signin(args, handle, verifySub) {
        const navResponse = await this._signinStart(args, handle);
        return await this._signinEnd(navResponse.url, verifySub);
    }
    async _signinStart(args, handle) {
        const logger2 = this._logger.create("_signinStart");
        try {
            const signinRequest = await this._client.createSigninRequest(args);
            logger2.debug("got signin request");
            return await handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signinEnd(url, verifySub) {
        const logger2 = this._logger.create("_signinEnd");
        const extraHeaders = {};
        const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
        logger2.debug("got signin response");
        const user = await this._buildUser(signinResponse, verifySub);
        return user;
    }
    async _buildUser(signinResponse, verifySub) {
        const logger2 = this._logger.create("_buildUser");
        const user = new $631c75f8a3fcffe9$var$User(signinResponse);
        if (verifySub) {
            if (verifySub !== user.profile.sub) {
                logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
                throw new $631c75f8a3fcffe9$var$ErrorResponse({
                    ...signinResponse,
                    error: "login_required"
                });
            }
            logger2.debug("current user matches user returned from signin");
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
        return user;
    }
    /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutRedirect(args = {}) {
        const logger2 = this._logger.create("signoutRedirect");
        const { redirectMethod: redirectMethod, ...requestArgs } = args;
        const handle = await this._redirectNavigator.prepare({
            redirectMethod: redirectMethod
        });
        await this._signoutStart({
            request_type: "so:r",
            post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutRedirectCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutRedirectCallback");
        const response = await this._signoutEnd(url);
        logger2.info("success");
        return response;
    }
    /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */ async signoutPopup(args = {}) {
        const logger2 = this._logger.create("signoutPopup");
        const { popupWindowFeatures: popupWindowFeatures, popupWindowTarget: popupWindowTarget, popupSignal: popupSignal, ...requestArgs } = args;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._popupNavigator.prepare({
            popupWindowFeatures: popupWindowFeatures,
            popupWindowTarget: popupWindowTarget,
            popupSignal: popupSignal
        });
        await this._signout({
            request_type: "so:p",
            post_logout_redirect_uri: url,
            // we're putting a dummy entry in here because we
            // need a unique id from the state for notification
            // to the parent window, which is necessary if we
            // plan to return back to the client after signout
            // and so we can close the popup after signout
            state: url == null ? void 0 : {},
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutPopupCallback(url = window.location.href, keepOpen = false) {
        const logger2 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(url, {
            keepOpen: keepOpen
        });
        logger2.info("success");
    }
    async _signout(args, handle) {
        const navResponse = await this._signoutStart(args, handle);
        return await this._signoutEnd(navResponse.url);
    }
    async _signoutStart(args = {}, handle) {
        var _a;
        const logger2 = this._logger.create("_signoutStart");
        try {
            const user = await this._loadUser();
            logger2.debug("loaded current user from storage");
            if (this.settings.revokeTokensOnSignout) await this._revokeInternal(user);
            const id_token = args.id_token_hint || user && user.id_token;
            if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
            }
            await this.removeUser();
            logger2.debug("user removed, creating signout request");
            const signoutRequest = await this._client.createSignoutRequest(args);
            logger2.debug("got signout request");
            return await handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
                scriptOrigin: this.settings.iframeScriptOrigin
            });
        } catch (err) {
            logger2.debug("error after preparing navigator, closing navigator window");
            handle.close();
            throw err;
        }
    }
    async _signoutEnd(url) {
        const logger2 = this._logger.create("_signoutEnd");
        const signoutResponse = await this._client.processSignoutResponse(url);
        logger2.debug("got signout response");
        return signoutResponse;
    }
    /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */ async signoutSilent(args = {}) {
        var _a;
        const logger2 = this._logger.create("signoutSilent");
        const { silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds, ...requestArgs } = args;
        const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
        const url = this.settings.popup_post_logout_redirect_uri;
        const handle = await this._iframeNavigator.prepare({
            silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
        });
        await this._signout({
            request_type: "so:s",
            post_logout_redirect_uri: url,
            id_token_hint: id_token_hint,
            ...requestArgs
        }, handle);
        logger2.info("success");
    }
    /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */ async signoutSilentCallback(url = window.location.href) {
        const logger2 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(url);
        logger2.info("success");
    }
    async revokeTokens(types) {
        const user = await this._loadUser();
        await this._revokeInternal(user, types);
    }
    async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
        const logger2 = this._logger.create("_revokeInternal");
        if (!user) return;
        const typesPresent = types.filter((type)=>typeof user[type] === "string");
        if (!typesPresent.length) {
            logger2.debug("no need to revoke due to no token(s)");
            return;
        }
        for (const type of typesPresent){
            await this._client.revokeToken(user[type], type);
            logger2.info(`${type} revoked successfully`);
            if (type !== "access_token") user[type] = null;
        }
        await this.storeUser(user);
        logger2.debug("user stored");
        await this._events.load(user);
    }
    /**
   * Enables silent renew for the `UserManager`.
   */ startSilentRenew() {
        this._logger.create("startSilentRenew");
        this._silentRenewService.start();
    }
    /**
   * Disables silent renew for the `UserManager`.
   */ stopSilentRenew() {
        this._silentRenewService.stop();
    }
    get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
    }
    async _loadUser() {
        const logger2 = this._logger.create("_loadUser");
        const storageString = await this.settings.userStore.get(this._userStoreKey);
        if (storageString) {
            logger2.debug("user storageString loaded");
            return $631c75f8a3fcffe9$var$User.fromStorageString(storageString);
        }
        logger2.debug("no user storageString");
        return null;
    }
    async storeUser(user) {
        const logger2 = this._logger.create("storeUser");
        if (user) {
            logger2.debug("storing user");
            const storageString = user.toStorageString();
            await this.settings.userStore.set(this._userStoreKey, storageString);
        } else {
            this._logger.debug("removing user");
            await this.settings.userStore.remove(this._userStoreKey);
            if (this.settings.dpop) await this.settings.dpop.store.remove(this.settings.client_id);
        }
    }
    /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */ async clearStaleState() {
        await this._client.clearStaleState();
    }
    /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */ async dpopProof(url, user, httpMethod, nonce) {
        var _a, _b;
        const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
        if (dpopState) return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPProof({
            url: url,
            accessToken: user == null ? void 0 : user.access_token,
            httpMethod: httpMethod,
            keyPair: dpopState.keys,
            nonce: nonce
        });
        return void 0;
    }
    async generateDPoPJkt(dpopSettings) {
        let dpopState = await dpopSettings.store.get(this.settings.client_id);
        if (!dpopState) {
            const dpopKeys = await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPKeys();
            dpopState = new $631c75f8a3fcffe9$var$DPoPState(dpopKeys);
            await dpopSettings.store.set(this.settings.client_id, dpopState);
        }
        return await $631c75f8a3fcffe9$var$CryptoUtils.generateDPoPJkt(dpopState.keys);
    }
};
// package.json
var $631c75f8a3fcffe9$var$version = "3.5.0";
// src/Version.ts
var $631c75f8a3fcffe9$var$Version = $631c75f8a3fcffe9$var$version;
// src/IndexedDbDPoPStore.ts
var $631c75f8a3fcffe9$var$IndexedDbDPoPStore = class {
    constructor(){
        this._dbName = "oidc";
        this._storeName = "dpop";
    }
    async set(key, value) {
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            str.put(value, key);
            return this.promisifyRequest(str.transaction);
        });
    }
    async get(key) {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.get(key));
        });
    }
    async remove(key) {
        const item = await this.get(key);
        const store = await this.createStore(this._dbName, this._storeName);
        await store("readwrite", (str)=>{
            return this.promisifyRequest(str.delete(key));
        });
        return item;
    }
    async getAllKeys() {
        const store = await this.createStore(this._dbName, this._storeName);
        return await store("readonly", (str)=>{
            return this.promisifyRequest(str.getAllKeys());
        });
    }
    promisifyRequest(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    async createStore(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const db = await this.promisifyRequest(request);
        return async (txMode, callback)=>{
            const tx = db.transaction(storeName, txMode);
            const store = tx.objectStore(storeName);
            return await callback(store);
        };
    }
};

});
parcelRegister("cVqez", function(module, exports) {

$parcel$export(module.exports, "jwtDecode", () => $968f28756c67bd23$export$fa1e2fb699b7861e);
class $968f28756c67bd23$export$b9721ef022f71a68 extends Error {
}
$968f28756c67bd23$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $968f28756c67bd23$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $968f28756c67bd23$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $968f28756c67bd23$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $968f28756c67bd23$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $968f28756c67bd23$var$base64UrlDecode(part);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

});


parcelRegister("cWZn2", function(module, exports) {
"use strict";
module.exports = JSON.parse("{\"authority\":\"https://unbar-rothon-auth.osmm.devtank.co.uk\",\"client_id\":\"osm-portal\",\"client_secret\":\"v6fCdRbiWpMUtDF7h3FfylV5obxVHVBN\",\"apiUrl\":\"https://unbar-rothon-portal.osmm.devtank.co.uk/internal\",\"dbApi\":\"https://unbar-rothon-portal.osmm.devtank.co.uk/api\",\"dbToken\":\"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiY3VzdG9tZXIifQ.i5gCvMMOd6vSZ1eiQCZ5jkPvS0FElwDdf8RwSj1-4KM\"}");

});




parcelRegister("01ZMx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5ba8080e55344a9$var$Home;

var $acw62 = parcelRequire("acw62");

var $b5ba8080e55344a9$var$_Box = $b5ba8080e55344a9$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $b5ba8080e55344a9$var$_Typography = $b5ba8080e55344a9$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $b5ba8080e55344a9$var$_SensorStatusGrid = $b5ba8080e55344a9$var$_interopRequireDefault((parcelRequire("czgkK")));

var $b5ba8080e55344a9$var$_SummaryTable = $b5ba8080e55344a9$var$_interopRequireDefault((parcelRequire("iiKJS")));

var $b5ba8080e55344a9$var$_FiringAlertsTable = $b5ba8080e55344a9$var$_interopRequireDefault((parcelRequire("4pWyw")));

var $9xY2t = parcelRequire("9xY2t");

var $3u6kV = parcelRequire("3u6kV");

var $ayMG0 = parcelRequire("ayMG0");
function $b5ba8080e55344a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b5ba8080e55344a9$var$UTILITY_LABELS = {
    electricity: 'electricity',
    gas: 'gas',
    water: 'water'
};
function $b5ba8080e55344a9$var$pctChange(current, previous) {
    if (previous === 0) return 0;
    return (current - previous) / previous * 100;
}
function $b5ba8080e55344a9$var$generateAnalysis(summary, perOsm) {
    const paragraphs = [];
    const elecDiff = summary.electricity.current - summary.electricity.previous;
    const elecPct = summary.electricity.previous > 0 ? Math.abs($b5ba8080e55344a9$var$pctChange(summary.electricity.current, summary.electricity.previous)).toFixed(1) : null;
    if (elecPct !== null) paragraphs.push(elecDiff > 0 ? `Overall electricity costs have increased by ${elecPct}% compared to last month (\xa3${summary.electricity.current.toFixed(2)} vs \xa3${summary.electricity.previous.toFixed(2)}), suggesting higher consumption across monitored devices.` : `Overall electricity costs have decreased by ${elecPct}% compared to last month (\xa3${summary.electricity.current.toFixed(2)} vs \xa3${summary.electricity.previous.toFixed(2)}), indicating improved efficiency or reduced usage.`);
    const gasDiff = summary.gas.current - summary.gas.previous;
    const gasPct = summary.gas.previous > 0 ? Math.abs($b5ba8080e55344a9$var$pctChange(summary.gas.current, summary.gas.previous)).toFixed(1) : null;
    if (gasPct !== null) paragraphs.push(gasDiff > 0 ? `Gas costs have risen by ${gasPct}% this month (\xa3${summary.gas.current.toFixed(2)} vs \xa3${summary.gas.previous.toFixed(2)}), which may reflect increased heating or cooking demand.` : `Gas costs have fallen by ${gasPct}% this month (\xa3${summary.gas.current.toFixed(2)} vs \xa3${summary.gas.previous.toFixed(2)}), suggesting reduced heating or cooking usage.`);
    else paragraphs.push('No gas meter data is available for comparison at this time.');
    const waterDiff = summary.water.current - summary.water.previous;
    const waterPct = summary.water.previous > 0 ? Math.abs($b5ba8080e55344a9$var$pctChange(summary.water.current, summary.water.previous)).toFixed(1) : null;
    if (waterPct !== null) paragraphs.push(waterDiff > 0 ? `Water costs have increased by ${waterPct}% compared to last month (\xa3${summary.water.current.toFixed(2)} vs \xa3${summary.water.previous.toFixed(2)}). Consider reviewing water usage patterns across the site.` : `Water costs are down by ${waterPct}% compared to last month (\xa3${summary.water.current.toFixed(2)} vs \xa3${summary.water.previous.toFixed(2)}), which is a positive trend.`);
    else paragraphs.push('No water meter data is available for comparison at this time.');
    const movers = perOsm.filter((o)=>o.previous > 0).map((o)=>({
            osm_name: o.osm_name,
            utility: $b5ba8080e55344a9$var$UTILITY_LABELS[o.utility],
            pct: $b5ba8080e55344a9$var$pctChange(o.current, o.previous)
        }));
    const increases = [
        ...movers
    ].filter((m)=>m.pct > 0).sort((a, b)=>b.pct - a.pct).slice(0, 3);
    const decreases = [
        ...movers
    ].filter((m)=>m.pct < 0).sort((a, b)=>a.pct - b.pct).slice(0, 3);
    if (increases.length > 0) {
        const list = increases.map((m)=>`${m.osm_name} (${m.utility}, +${m.pct.toFixed(1)}%)`).join(', ');
        paragraphs.push(`The locations showing the largest cost increases this month are: ${list}. These may warrant closer inspection to identify the cause of the rise.`);
    }
    if (decreases.length > 0) {
        const list = decreases.map((m)=>`${m.osm_name} (${m.utility}, ${m.pct.toFixed(1)}%)`).join(', ');
        paragraphs.push(`The locations with the largest cost reductions are: ${list}. This suggests improved efficiency or reduced activity in these areas.`);
    }
    if (increases.length === 0 && decreases.length === 0) paragraphs.push('Insufficient historical data is available to compare individual location costs at this time.');
    return paragraphs;
}
function $b5ba8080e55344a9$var$Panel({ title: title, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b5ba8080e55344a9$var$_Box.default, {
        sx: {
            background: 'var(--color-bg-secondary)',
            borderRadius: 3,
            p: '1.25rem 1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Typography.default, {
                sx: {
                    fontFamily: "'Syne', sans-serif",
                    fontSize: 13,
                    fontWeight: 600,
                    color: 'var(--color-text-primary)',
                    m: 0
                },
                children: title
            }),
            children
        ]
    });
}
function $b5ba8080e55344a9$var$Home() {
    const [username, setUsername] = (0, $acw62.useState)('');
    const [configs, setConfigs] = (0, $acw62.useState)([]);
    const [summaryData, setSummaryData] = (0, $acw62.useState)(null);
    const [perOsmData, setPerOsmData] = (0, $acw62.useState)([]);
    const [channels, setChannels] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        (0, $9xY2t.getUser)().then((user)=>{
            if (user) setUsername(user.profile.preferred_username ?? '');
        });
        (0, $3u6kV.getOsmNames)().then(async (cfgs)=>{
            setConfigs(cfgs);
            // Fetch channels for all configs
            const allChannels = await Promise.all(cfgs.map((c)=>(0, $3u6kV.getChannels)(c.id).catch(()=>[])));
            setChannels(allChannels.flat());
        }).catch(console.error);
    }, []);
    const handleSummaryData = (0, $acw62.useCallback)((summary, perOsm)=>{
        setSummaryData(summary);
        setPerOsmData(perOsm);
    }, []);
    const analysisParagraphs = summaryData ? $b5ba8080e55344a9$var$generateAnalysis(summaryData, perOsmData) : null;
    const now = new Date().toLocaleString('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b5ba8080e55344a9$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            maxWidth: 1280,
            margin: '0 auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($b5ba8080e55344a9$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: 'space-between',
                    mb: 3,
                    flexWrap: 'wrap',
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($b5ba8080e55344a9$var$_Typography.default, {
                            sx: {
                                fontFamily: "'Syne', sans-serif",
                                fontSize: 20,
                                fontWeight: 600,
                                color: 'var(--color-text-primary)'
                            },
                            children: [
                                "Hello,",
                                ' ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Box.default, {
                                    component: "span",
                                    sx: {
                                        color: '#1D9E75'
                                    },
                                    children: username || "\u2026"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Typography.default, {
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 12,
                            color: 'var(--color-text-secondary)'
                        },
                        children: now
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "home-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$Panel, {
                        title: "Sensor Status",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_SensorStatusGrid.default, {
                            configs: configs
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$Panel, {
                        title: "30 Day Cost Summary",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_SummaryTable.default, {
                            configs: configs,
                            channels: channels,
                            onDataLoaded: handleSummaryData
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$Panel, {
                        title: "Analysis",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Box.default, {
                            sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1.5
                            },
                            children: analysisParagraphs ? analysisParagraphs.map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Typography.default, {
                                    sx: {
                                        fontFamily: "'DM Mono', monospace",
                                        fontSize: 12,
                                        color: 'var(--color-text-secondary)',
                                        lineHeight: 1.7
                                    },
                                    children: p
                                }, i)) : /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 12,
                                    color: 'var(--color-text-secondary)'
                                },
                                children: "Loading analysis\u2026"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$Panel, {
                        title: "Alerts",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b5ba8080e55344a9$var$_FiringAlertsTable.default, {})
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("czgkK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8006d94a5c3b5ed9$var$SensorStatusGrid;

var $8006d94a5c3b5ed9$var$_react = $8006d94a5c3b5ed9$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8006d94a5c3b5ed9$var$_Box = $8006d94a5c3b5ed9$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $8006d94a5c3b5ed9$var$_Typography = $8006d94a5c3b5ed9$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $8006d94a5c3b5ed9$var$_CircularProgress = $8006d94a5c3b5ed9$var$_interopRequireDefault((parcelRequire("1sBf1")));

var $3u6kV = parcelRequire("3u6kV");

var $ayMG0 = parcelRequire("ayMG0");
function $8006d94a5c3b5ed9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $8006d94a5c3b5ed9$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($8006d94a5c3b5ed9$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const $8006d94a5c3b5ed9$var$OFFLINE_THRESHOLD_MS = 1800000; // 30 minutes
async function $8006d94a5c3b5ed9$var$getLastSeen(osmName) {
    const now = new Date();
    const from = new Date(now.getTime() - 86400000); // look back 24h
    for (const meas of [
        'SND',
        'LGHT'
    ])try {
        const rows = await (0, $3u6kV.getData)('pg_sf_ds', 'bucket', from.toISOString(), now.toISOString(), meas, osmName);
        if (rows?.length) {
            const latest = rows[rows.length - 1];
            const ts = latest.bucket ?? latest.time ?? latest.timestamp;
            if (ts) return new Date(ts);
        }
    } catch  {
    // try next measurement
    }
    return null;
}
function $8006d94a5c3b5ed9$var$formatLastSeen(date) {
    if (!date) return 'No data';
    const diffMs = Date.now() - date.getTime();
    const diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 1) return 'Just now';
    if (diffMin < 60) return `${diffMin}m ago`;
    const diffH = Math.floor(diffMin / 60);
    if (diffH < 24) return `${diffH}h ago`;
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short'
    });
}
function $8006d94a5c3b5ed9$var$SensorStatusGrid({ configs: configs }) {
    const [statuses, setStatuses] = (0, $8006d94a5c3b5ed9$var$_react.useState)([]);
    const [loading, setLoading] = (0, $8006d94a5c3b5ed9$var$_react.useState)(true);
    (0, $8006d94a5c3b5ed9$var$_react.useEffect)(()=>{
        if (!configs.length) return;
        async function load() {
            const results = await Promise.all(configs.map(async (c)=>{
                const lastSeen = await $8006d94a5c3b5ed9$var$getLastSeen(c.osm_name);
                const online = lastSeen !== null && Date.now() - lastSeen.getTime() < $8006d94a5c3b5ed9$var$OFFLINE_THRESHOLD_MS;
                return {
                    osm_name: c.osm_name,
                    description: c.description,
                    lastSeen: lastSeen,
                    online: online
                };
            }));
            setStatuses(results);
            setLoading(false);
        }
        load();
    }, [
        configs
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Box.default, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_CircularProgress.default, {
            size: 24,
            sx: {
                color: '#1D9E75'
            }
        })
    });
    const online = statuses.filter((s)=>s.online).length;
    const offline = statuses.filter((s)=>!s.online).length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
                sx: {
                    display: 'flex',
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Box.default, {
                                sx: {
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#1D9E75',
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    color: 'var(--color-text-secondary)'
                                },
                                children: [
                                    online,
                                    " online"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Box.default, {
                                sx: {
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#993C1D',
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    color: 'var(--color-text-secondary)'
                                },
                                children: [
                                    offline,
                                    " offline"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Box.default, {
                sx: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                    gap: 1
                },
                children: statuses.map((sensor)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                            p: '10px 12px',
                            borderRadius: 2,
                            background: 'var(--color-bg-tertiary, rgba(255,255,255,0.04))',
                            borderLeft: `3px solid ${sensor.online ? '#1D9E75' : '#993C1D'}`,
                            transition: 'opacity 0.2s',
                            opacity: sensor.online ? 1 : 0.7
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'Syne', sans-serif",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: 'var(--color-text-primary)',
                                    lineHeight: 1.3,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: sensor.description?.trim() || sensor.osm_name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8006d94a5c3b5ed9$var$_Box.default, {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Box.default, {
                                                sx: {
                                                    width: 6,
                                                    height: 6,
                                                    borderRadius: '50%',
                                                    flexShrink: 0,
                                                    background: sensor.online ? '#1D9E75' : '#993C1D',
                                                    boxShadow: sensor.online ? '0 0 6px rgba(29,158,117,0.6)' : '0 0 6px rgba(153,60,29,0.4)'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Typography.default, {
                                                sx: {
                                                    fontFamily: "'DM Mono', monospace",
                                                    fontSize: 10,
                                                    color: sensor.online ? '#1D9E75' : '#993C1D',
                                                    fontWeight: 600,
                                                    letterSpacing: '0.04em'
                                                },
                                                children: sensor.online ? 'Online' : 'Offline'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8006d94a5c3b5ed9$var$_Typography.default, {
                                        sx: {
                                            fontFamily: "'DM Mono', monospace",
                                            fontSize: 10,
                                            color: 'var(--color-text-secondary)'
                                        },
                                        children: $8006d94a5c3b5ed9$var$formatLastSeen(sensor.lastSeen)
                                    })
                                ]
                            })
                        ]
                    }, sensor.osm_name))
            })
        ]
    });
}

});
parcelRegister("3u6kV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAlert = $488bc2deb3b9875a$var$createAlert;
module.exports.createChannel = $488bc2deb3b9875a$var$createChannel;
module.exports.createContactPoint = $488bc2deb3b9875a$var$createContactPoint;
module.exports.createDashboardWidget = $488bc2deb3b9875a$var$createDashboardWidget;
module.exports.createTariff = $488bc2deb3b9875a$var$createTariff;
module.exports.deleteAlert = $488bc2deb3b9875a$var$deleteAlert;
module.exports.deleteChannel = $488bc2deb3b9875a$var$deleteChannel;
module.exports.deleteContactPoint = $488bc2deb3b9875a$var$deleteContactPoint;
module.exports.deleteDashboardWidget = $488bc2deb3b9875a$var$deleteDashboardWidget;
module.exports.deleteTariff = $488bc2deb3b9875a$var$deleteTariff;
module.exports.getAirQuality = $488bc2deb3b9875a$var$getAirQuality;
module.exports.getAlertStatuses = $488bc2deb3b9875a$var$getAlertStatuses;
module.exports.getAlerts = $488bc2deb3b9875a$var$getAlerts;
module.exports.getChannels = $488bc2deb3b9875a$var$getChannels;
module.exports.getChannelsForOsm = $488bc2deb3b9875a$var$getChannelsForOsm;
module.exports.getContactPoints = $488bc2deb3b9875a$var$getContactPoints;
module.exports.getDashboardWidgets = $488bc2deb3b9875a$var$getDashboardWidgets;
module.exports.getData = $488bc2deb3b9875a$var$getData;
module.exports.getElectricityCost = $488bc2deb3b9875a$var$getElectricityCost;
module.exports.getElectricityKwh = $488bc2deb3b9875a$var$getElectricityKwh;
module.exports.getGasCost = $488bc2deb3b9875a$var$getGasCost;
module.exports.getImportConsumption = $488bc2deb3b9875a$var$getImportConsumption;
module.exports.getImportCost = $488bc2deb3b9875a$var$getImportCost;
module.exports.getMeasurements = $488bc2deb3b9875a$var$getMeasurements;
module.exports.getOsmLocations = $488bc2deb3b9875a$var$getOsmLocations;
module.exports.getOsmNames = $488bc2deb3b9875a$var$getOsmNames;
module.exports.getPulseConsumption = $488bc2deb3b9875a$var$getPulseConsumption;
module.exports.getTariffs = $488bc2deb3b9875a$var$getTariffs;
module.exports.getThreePhaseCurrent = $488bc2deb3b9875a$var$getThreePhaseCurrent;
module.exports.getVibration = $488bc2deb3b9875a$var$getVibration;
module.exports.getWaterCost = $488bc2deb3b9875a$var$getWaterCost;
module.exports.reorderDashboardWidgets = $488bc2deb3b9875a$var$reorderDashboardWidgets;
module.exports.resetWidgetsToDefault = $488bc2deb3b9875a$var$resetWidgetsToDefault;
module.exports.silenceAlert = $488bc2deb3b9875a$var$silenceAlert;
module.exports.updateAlert = $488bc2deb3b9875a$var$updateAlert;
module.exports.updateChannel = $488bc2deb3b9875a$var$updateChannel;
module.exports.updateContactPoint = $488bc2deb3b9875a$var$updateContactPoint;
module.exports.updateDashboardConfig = $488bc2deb3b9875a$var$updateDashboardConfig;
module.exports.updateDashboardWidget = $488bc2deb3b9875a$var$updateDashboardWidget;
module.exports.updateTariff = $488bc2deb3b9875a$var$updateTariff;

var $488bc2deb3b9875a$var$_config = $488bc2deb3b9875a$var$_interopRequireDefault((parcelRequire("cWZn2")));
function $488bc2deb3b9875a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $488bc2deb3b9875a$var$DB_API = $488bc2deb3b9875a$var$_config.default.dbApi;
const $488bc2deb3b9875a$var$TOKEN = $488bc2deb3b9875a$var$_config.default.dbToken;
async function $488bc2deb3b9875a$var$doFetch(url, token = $488bc2deb3b9875a$var$TOKEN) {
    const res = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();
}
async function $488bc2deb3b9875a$var$doMutate(url, method, body, extraHeaders = {}) {
    const res = await fetch(url, {
        method: method,
        headers: {
            Authorization: `Bearer ${$488bc2deb3b9875a$var$TOKEN}`,
            'Content-Type': 'application/json',
            'Prefer': 'return=representation',
            ...extraHeaders
        },
        body: body ? JSON.stringify(body) : undefined
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    if (res.status === 204) return null;
    return res.json();
}
async function $488bc2deb3b9875a$var$getData(dbTable, timeField, timeFrom, timeTo, meas, osmName) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/${dbTable}`);
    url.searchParams.set(timeField, `lt.${timeTo}`);
    url.searchParams.append(timeField, `gt.${timeFrom}`);
    url.searchParams.set('name', `eq.${meas}`);
    if (osmName) url.searchParams.set('osm_name', `eq.${osmName}`);
    url.searchParams.set('order', timeField);
    return $488bc2deb3b9875a$var$doFetch(url);
}
async function $488bc2deb3b9875a$var$updateDashboardConfig(id, changes) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config`);
    url.searchParams.set('id', `eq.${id}`);
    const result = await $488bc2deb3b9875a$var$doMutate(url, 'PATCH', changes);
    return result[0];
}
async function $488bc2deb3b9875a$var$getOsmNames() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config`);
    url.searchParams.set('select', 'id,unit_id,serial_number,osm_name,description');
    return $488bc2deb3b9875a$var$doFetch(url);
}
async function $488bc2deb3b9875a$var$getChannels(configId) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config_channels`);
    url.searchParams.set('config_id', `eq.${configId}`);
    url.searchParams.set('select', 'id,config_id,type,channel,pulse_div,calorific_kwh,label');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$getChannelsForOsm(osmName) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config_channels`);
    url.searchParams.set('select', 'id,config_id,type,channel,pulse_div,calorific_kwh,label,dashboard_config!inner(osm_name)');
    url.searchParams.set('dashboard_config.osm_name', `eq.${osmName}`);
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$createChannel(channel) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config_channels`);
    const result = await $488bc2deb3b9875a$var$doMutate(url, 'POST', channel);
    return result[0];
}
async function $488bc2deb3b9875a$var$updateChannel(id, changes) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config_channels`);
    url.searchParams.set('id', `eq.${id}`);
    const result = await $488bc2deb3b9875a$var$doMutate(url, 'PATCH', changes);
    return result[0];
}
async function $488bc2deb3b9875a$var$deleteChannel(id) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_config_channels`);
    url.searchParams.set('id', `eq.${id}`);
    await $488bc2deb3b9875a$var$doMutate(url, 'DELETE');
}
async function $488bc2deb3b9875a$var$getMeasurements() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/measurement`);
    url.searchParams.set('select', 'id,name');
    url.searchParams.append('name', 'not.like.*_min');
    url.searchParams.append('name', 'not.like.*_max');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$getOsmLocations() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/osm`);
    url.searchParams.set('select', 'id,name');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$resetWidgetsToDefault(osmName) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/reset_widgets_for_osm`);
    await $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName
    });
}
// Alerts
async function $488bc2deb3b9875a$var$getAlerts() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/alerts`);
    url.searchParams.set('select', 'id,name,measurement_id,osm_ids,operator,threshold,duration_minutes');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$createAlert(alert) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/alerts`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', alert);
}
async function $488bc2deb3b9875a$var$updateAlert(id, changes) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/alerts`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'PATCH', changes);
}
async function $488bc2deb3b9875a$var$deleteAlert(id) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/alerts`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'DELETE');
}
async function $488bc2deb3b9875a$var$getAlertStatuses() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/alerts`);
    url.searchParams.set('select', 'id,name,operator,threshold,duration_minutes,is_active,silenced_until,osm_ids,measurement(name),alert_state(breaching_since,last_notified)');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$silenceAlert(id, silencedUntil, isActive) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/alerts`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'PATCH', {
        silenced_until: silencedUntil,
        is_active: isActive
    });
}
// Contact points
async function $488bc2deb3b9875a$var$getContactPoints() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/contact_points`);
    url.searchParams.set('select', 'id,email,notify_every_hours');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$createContactPoint(cp) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/contact_points`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', cp);
}
async function $488bc2deb3b9875a$var$updateContactPoint(id, changes) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/contact_points`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'PATCH', changes);
}
async function $488bc2deb3b9875a$var$deleteContactPoint(id) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/contact_points`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'DELETE');
}
// Tariffs
async function $488bc2deb3b9875a$var$getTariffs() {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/tariffs`);
    url.searchParams.set('select', 'id,rate,weekday,valid_from,valid_to,tag,start_hour,end_hour');
    url.searchParams.set('order', 'id');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$createTariff(tariff) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/tariffs`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', tariff);
}
async function $488bc2deb3b9875a$var$updateTariff(id, changes) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/tariffs`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'PATCH', changes);
}
async function $488bc2deb3b9875a$var$deleteTariff(id) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/tariffs`);
    url.searchParams.set('id', `eq.${id}`);
    return $488bc2deb3b9875a$var$doMutate(url, 'DELETE');
}
// Dashboard Widgets
async function $488bc2deb3b9875a$var$getDashboardWidgets(osmName) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_widgets`);
    url.searchParams.set('osm_name', `eq.${osmName}`);
    url.searchParams.set('order', 'layout_order');
    url.searchParams.set('select', 'id,osm_name,chart_type,title,colour,min_value,max_value,layout_order,widget_type_id,config');
    return $488bc2deb3b9875a$var$doFetch(url, $488bc2deb3b9875a$var$TOKEN);
}
async function $488bc2deb3b9875a$var$createDashboardWidget(widget) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_widgets`);
    const result = await $488bc2deb3b9875a$var$doMutate(url, 'POST', widget);
    return result[0];
}
async function $488bc2deb3b9875a$var$updateDashboardWidget(id, changes) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_widgets`);
    url.searchParams.set('id', `eq.${id}`);
    const result = await $488bc2deb3b9875a$var$doMutate(url, 'PATCH', changes);
    return result[0];
}
async function $488bc2deb3b9875a$var$deleteDashboardWidget(id) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/dashboard_widgets`);
    url.searchParams.set('id', `eq.${id}`);
    await $488bc2deb3b9875a$var$doMutate(url, 'DELETE');
}
async function $488bc2deb3b9875a$var$reorderDashboardWidgets(widgets) {
    await Promise.all(widgets.map(({ id: id, layout_order: layout_order })=>$488bc2deb3b9875a$var$updateDashboardWidget(id, {
            layout_order: layout_order
        })));
}
// Dashboard Widget Calculations
async function $488bc2deb3b9875a$var$getElectricityCost(osmName, from, to) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_electricity_cost`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to
    });
}
async function $488bc2deb3b9875a$var$getPulseConsumption(osmName, from, to, channel, pulseDiv = 1.0) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_pulse_consumption`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to,
        p_channel: channel,
        p_pulse_div: pulseDiv
    });
}
async function $488bc2deb3b9875a$var$getGasCost(osmName, from, to, channel, pulseDiv = 1.0, caloricKwh = 11.1354133333) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_gas_cost`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to,
        p_channel: channel,
        p_pulse_div: pulseDiv,
        p_calorific_kwh: caloricKwh
    });
}
async function $488bc2deb3b9875a$var$getWaterCost(osmName, from, to, channel, pulseDiv = 1.0) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_water_cost`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to,
        p_channel: channel,
        p_pulse_div: pulseDiv
    });
}
async function $488bc2deb3b9875a$var$getVibration(osmName, from, to) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_vibration`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to
    });
}
async function $488bc2deb3b9875a$var$getImportCost(osmName, from, to, tag = 'elec') {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_import_cost`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to,
        p_tag: tag
    });
}
async function $488bc2deb3b9875a$var$getImportConsumption(osmName, from, to) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_import_consumption`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to
    });
}
async function $488bc2deb3b9875a$var$getElectricityKwh(osmName, from, to) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_electricity_kwh`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to
    });
}
async function $488bc2deb3b9875a$var$getAirQuality(osmName, from, to) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_air_quality`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to
    });
}
async function $488bc2deb3b9875a$var$getThreePhaseCurrent(osmName, from, to) {
    const url = new URL(`${$488bc2deb3b9875a$var$DB_API}/rpc/get_three_phase_current`);
    return $488bc2deb3b9875a$var$doMutate(url, 'POST', {
        p_osm_name: osmName,
        p_from: from,
        p_to: to
    });
}

});


parcelRegister("iiKJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c40091edde53bee4$var$SummaryTable;

var $c40091edde53bee4$var$React = $c40091edde53bee4$var$_interopRequireWildcard((parcelRequire("acw62")));

var $c40091edde53bee4$var$_Table = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("bGe9g")));

var $c40091edde53bee4$var$_TableBody = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("5hLrb")));

var $c40091edde53bee4$var$_TableCell = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("hjoMW")));

var $c40091edde53bee4$var$_TableContainer = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("12YAp")));

var $c40091edde53bee4$var$_TableHead = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("g2Lhl")));

var $c40091edde53bee4$var$_TableRow = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("7IILB")));

var $c40091edde53bee4$var$_CircularProgress = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("1sBf1")));

var $c40091edde53bee4$var$_Box = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $c40091edde53bee4$var$_Typography = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $c40091edde53bee4$var$_TrendingDown = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("EOFWj")));

var $c40091edde53bee4$var$_TrendingUp = $c40091edde53bee4$var$_interopRequireDefault((parcelRequire("hUM4k")));

var $3u6kV = parcelRequire("3u6kV");

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $c40091edde53bee4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $c40091edde53bee4$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c40091edde53bee4$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $c40091edde53bee4$var$sumCosts(data) {
    return data.reduce((acc, d)=>acc + Number(d.cost_gbp), 0);
}
const $c40091edde53bee4$var$headCellSx = {
    fontFamily: "'Syne', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'var(--color-text-secondary)',
    background: 'transparent',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    py: 1.25
};
const $c40091edde53bee4$var$bodyCellSx = {
    fontFamily: "'DM Mono', monospace",
    fontSize: 13,
    color: 'var(--color-text-primary)',
    borderBottom: '1px solid rgba(255,255,255,0.04)',
    py: 1.25,
    background: 'transparent'
};
function $c40091edde53bee4$var$SummaryTable({ configs: configs, channels: channels, onDataLoaded: onDataLoaded }) {
    const [rows, setRows] = $c40091edde53bee4$var$React.useState([]);
    const [loading, setLoading] = $c40091edde53bee4$var$React.useState(true);
    const [error, setError] = $c40091edde53bee4$var$React.useState(null);
    $c40091edde53bee4$var$React.useEffect(()=>{
        if (!configs.length) return;
        async function load() {
            try {
                const now = (0, $dOn5J.nowISOString)();
                const lastMonth = (0, $dOn5J.lastMonthISOString)();
                const twoAgo = (0, $dOn5J.twoMonthsAgoISOString)();
                const perOsm = [];
                // ── Electricity ───────────────────────────────────────────────────────
                const elecResults = await Promise.all(configs.map((c)=>Promise.all([
                        (0, $3u6kV.getElectricityCost)(c.osm_name, lastMonth, now).catch(()=>[]),
                        (0, $3u6kV.getElectricityCost)(c.osm_name, twoAgo, lastMonth).catch(()=>[])
                    ])));
                let elecCurrent = 0, elecPrevious = 0;
                elecResults.forEach(([cur, prev], i)=>{
                    const c = $c40091edde53bee4$var$sumCosts(cur), p = $c40091edde53bee4$var$sumCosts(prev);
                    elecCurrent += c;
                    elecPrevious += p;
                    perOsm.push({
                        osm_name: configs[i].osm_name,
                        utility: 'electricity',
                        current: c,
                        previous: p
                    });
                });
                // ── Gas — all channels across all configs ─────────────────────────────
                const gasChannels = channels.filter((ch)=>ch.type === 'gas');
                const gasResults = await Promise.all(gasChannels.map((ch)=>{
                    const cfg = configs.find((c)=>c.id === ch.config_id);
                    if (!cfg) return Promise.resolve([
                        [],
                        []
                    ]);
                    return Promise.all([
                        (0, $3u6kV.getGasCost)(cfg.osm_name, lastMonth, now, ch.channel, ch.pulse_div, ch.calorific_kwh ?? 11.1354133333).catch(()=>[]),
                        (0, $3u6kV.getGasCost)(cfg.osm_name, twoAgo, lastMonth, ch.channel, ch.pulse_div, ch.calorific_kwh ?? 11.1354133333).catch(()=>[])
                    ]);
                }));
                let gasCurrent = 0, gasPrevious = 0;
                gasResults.forEach(([cur, prev], i)=>{
                    const c = $c40091edde53bee4$var$sumCosts(cur), p = $c40091edde53bee4$var$sumCosts(prev);
                    gasCurrent += c;
                    gasPrevious += p;
                    const cfg = configs.find((co)=>co.id === gasChannels[i].config_id);
                    if (cfg) perOsm.push({
                        osm_name: cfg.osm_name,
                        utility: 'gas',
                        current: c,
                        previous: p
                    });
                });
                // ── Water — all channels across all configs ───────────────────────────
                const waterChannels = channels.filter((ch)=>ch.type === 'water');
                const waterResults = await Promise.all(waterChannels.map((ch)=>{
                    const cfg = configs.find((c)=>c.id === ch.config_id);
                    if (!cfg) return Promise.resolve([
                        [],
                        []
                    ]);
                    return Promise.all([
                        (0, $3u6kV.getWaterCost)(cfg.osm_name, lastMonth, now, ch.channel, ch.pulse_div).catch(()=>[]),
                        (0, $3u6kV.getWaterCost)(cfg.osm_name, twoAgo, lastMonth, ch.channel, ch.pulse_div).catch(()=>[])
                    ]);
                }));
                let waterCurrent = 0, waterPrevious = 0;
                waterResults.forEach(([cur, prev], i)=>{
                    const c = $c40091edde53bee4$var$sumCosts(cur), p = $c40091edde53bee4$var$sumCosts(prev);
                    waterCurrent += c;
                    waterPrevious += p;
                    const cfg = configs.find((co)=>co.id === waterChannels[i].config_id);
                    if (cfg) perOsm.push({
                        osm_name: cfg.osm_name,
                        utility: 'water',
                        current: c,
                        previous: p
                    });
                });
                setRows([
                    {
                        parameter: 'Electricity',
                        currentValue: elecCurrent,
                        previousValue: elecPrevious
                    },
                    {
                        parameter: 'Gas',
                        currentValue: gasCurrent,
                        previousValue: gasPrevious
                    },
                    {
                        parameter: 'Water',
                        currentValue: waterCurrent,
                        previousValue: waterPrevious
                    }
                ]);
                onDataLoaded?.({
                    electricity: {
                        current: elecCurrent,
                        previous: elecPrevious
                    },
                    gas: {
                        current: gasCurrent,
                        previous: gasPrevious
                    },
                    water: {
                        current: waterCurrent,
                        previous: waterPrevious
                    }
                }, perOsm);
            } catch (err) {
                setError(err.message);
            } finally{
                setLoading(false);
            }
        }
        load();
    }, [
        configs,
        channels
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_Box.default, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_CircularProgress.default, {
            size: 24,
            sx: {
                color: '#1D9E75'
            }
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)($c40091edde53bee4$var$_Typography.default, {
        sx: {
            fontFamily: "'DM Mono', monospace",
            fontSize: 12,
            color: '#993C1D'
        },
        children: [
            "Error: ",
            error
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableContainer.default, {
        sx: {
            background: 'transparent'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($c40091edde53bee4$var$_Table.default, {
            "aria-label": "summary table",
            size: "small",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableHead.default, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($c40091edde53bee4$var$_TableRow.default, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableCell.default, {
                                align: "left",
                                sx: $c40091edde53bee4$var$headCellSx,
                                children: "Utility"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableCell.default, {
                                align: "right",
                                sx: $c40091edde53bee4$var$headCellSx,
                                children: "Last 30 Days"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableCell.default, {
                                align: "right",
                                sx: $c40091edde53bee4$var$headCellSx,
                                children: "Prev 30 Days"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableCell.default, {
                                align: "center",
                                sx: $c40091edde53bee4$var$headCellSx,
                                children: "Trend"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableBody.default, {
                    children: rows.map((row)=>{
                        const improved = row.currentValue <= row.previousValue;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)($c40091edde53bee4$var$_TableRow.default, {
                            sx: {
                                '&:last-child td': {
                                    border: 0
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableCell.default, {
                                    align: "left",
                                    sx: {
                                        ...$c40091edde53bee4$var$bodyCellSx,
                                        color: 'var(--color-text-secondary)',
                                        fontFamily: "'Syne', sans-serif",
                                        fontWeight: 500,
                                        fontSize: 12
                                    },
                                    children: row.parameter
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($c40091edde53bee4$var$_TableCell.default, {
                                    align: "right",
                                    sx: $c40091edde53bee4$var$bodyCellSx,
                                    children: [
                                        "\xA3",
                                        row.currentValue.toFixed(2)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($c40091edde53bee4$var$_TableCell.default, {
                                    align: "right",
                                    sx: {
                                        ...$c40091edde53bee4$var$bodyCellSx,
                                        color: 'var(--color-text-secondary)'
                                    },
                                    children: [
                                        "\xA3",
                                        row.previousValue.toFixed(2)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TableCell.default, {
                                    align: "center",
                                    sx: $c40091edde53bee4$var$bodyCellSx,
                                    children: improved ? /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TrendingDown.default, {
                                        sx: {
                                            fontSize: 18,
                                            color: '#1D9E75'
                                        }
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($c40091edde53bee4$var$_TrendingUp.default, {
                                        sx: {
                                            fontSize: 18,
                                            color: '#993C1D'
                                        }
                                    })
                                })
                            ]
                        }, row.parameter);
                    })
                })
            ]
        })
    });
}

});
parcelRegister("bGe9g", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $880e97827fd7145b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $880e97827fd7145b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $880e97827fd7145b$var$_exportNames = {
    tableClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $880e97827fd7145b$var$_Table.default;
    }
});
Object.defineProperty(module.exports, "tableClasses", {
    enumerable: true,
    get: function() {
        return $880e97827fd7145b$var$_tableClasses.default;
    }
});

var $880e97827fd7145b$var$_Table = $880e97827fd7145b$require$_interopRequireDefault((parcelRequire("30hyv")));

var $880e97827fd7145b$var$_tableClasses = $880e97827fd7145b$require$_interopRequireWildcard((parcelRequire("5kXxI")));
Object.keys($880e97827fd7145b$var$_tableClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($880e97827fd7145b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $880e97827fd7145b$var$_tableClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $880e97827fd7145b$var$_tableClasses[key];
        }
    });
});

});
parcelRegister("30hyv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $22fefd5f207422b3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $22fefd5f207422b3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22fefd5f207422b3$var$React = $22fefd5f207422b3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $22fefd5f207422b3$var$_propTypes = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $22fefd5f207422b3$var$_clsx = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $22fefd5f207422b3$var$_composeClasses = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $22fefd5f207422b3$var$_TableContext = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("jWrFr")));

var $aAbgT = parcelRequire("aAbgT");

var $22fefd5f207422b3$var$_memoTheme = $22fefd5f207422b3$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $5kXxI = parcelRequire("5kXxI");

var $ayMG0 = parcelRequire("ayMG0");
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $22fefd5f207422b3$var$_composeClasses.default)(slots, $5kXxI.getTableUtilityClass, classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $aAbgT.styled)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $22fefd5f207422b3$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $22fefd5f207422b3$var$React.forwardRef(function Table(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $22fefd5f207422b3$var$React.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$_TableContext.default.Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, {
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $22fefd5f207422b3$var$_clsx.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $22fefd5f207422b3$var$_default = module.exports.default = $22fefd5f207422b3$var$Table;

});
parcelRegister("jWrFr", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e848e543ed3bf349$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e848e543ed3bf349$var$React = $e848e543ed3bf349$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $e848e543ed3bf349$var$React.createContext();
var $e848e543ed3bf349$var$_default = module.exports.default = $e848e543ed3bf349$var$TableContext;

});

parcelRegister("5kXxI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e2d01fd3f88b8c8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableUtilityClass = $3e2d01fd3f88b8c8$var$getTableUtilityClass;

var $3e2d01fd3f88b8c8$var$_generateUtilityClasses = $3e2d01fd3f88b8c8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3e2d01fd3f88b8c8$var$_generateUtilityClass = $3e2d01fd3f88b8c8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3e2d01fd3f88b8c8$var$getTableUtilityClass(slot) {
    return (0, $3e2d01fd3f88b8c8$var$_generateUtilityClass.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $3e2d01fd3f88b8c8$var$_generateUtilityClasses.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$var$_default = module.exports.default = $3e2d01fd3f88b8c8$var$tableClasses;

});



parcelRegister("5hLrb", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3d935658447069c3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3d935658447069c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3d935658447069c3$var$_exportNames = {
    tableBodyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3d935658447069c3$var$_TableBody.default;
    }
});
Object.defineProperty(module.exports, "tableBodyClasses", {
    enumerable: true,
    get: function() {
        return $3d935658447069c3$var$_tableBodyClasses.default;
    }
});

var $3d935658447069c3$var$_TableBody = $3d935658447069c3$require$_interopRequireDefault((parcelRequire("QpuKB")));

var $3d935658447069c3$var$_tableBodyClasses = $3d935658447069c3$require$_interopRequireWildcard((parcelRequire("dfSTK")));
Object.keys($3d935658447069c3$var$_tableBodyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3d935658447069c3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3d935658447069c3$var$_tableBodyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3d935658447069c3$var$_tableBodyClasses[key];
        }
    });
});

});
parcelRegister("QpuKB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $09d8a23708c3ccc9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $09d8a23708c3ccc9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09d8a23708c3ccc9$var$React = $09d8a23708c3ccc9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $09d8a23708c3ccc9$var$_propTypes = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09d8a23708c3ccc9$var$_clsx = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("9QePP")));

var $09d8a23708c3ccc9$var$_composeClasses = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $09d8a23708c3ccc9$var$_Tablelvl2Context = $09d8a23708c3ccc9$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $dfSTK = parcelRequire("dfSTK");

var $ayMG0 = parcelRequire("ayMG0");
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $09d8a23708c3ccc9$var$_composeClasses.default)(slots, $dfSTK.getTableBodyUtilityClass, classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $aAbgT.styled)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $09d8a23708c3ccc9$var$React.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$_Tablelvl2Context.default.Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, {
            className: (0, $09d8a23708c3ccc9$var$_clsx.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $09d8a23708c3ccc9$var$_default = module.exports.default = $09d8a23708c3ccc9$var$TableBody;

});
parcelRegister("RbMj7", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $09fe163f52c859c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09fe163f52c859c8$var$React = $09fe163f52c859c8$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $09fe163f52c859c8$var$React.createContext();
var $09fe163f52c859c8$var$_default = module.exports.default = $09fe163f52c859c8$var$Tablelvl2Context;

});

parcelRegister("dfSTK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a6742b7048414d1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableBodyUtilityClass = $9a6742b7048414d1$var$getTableBodyUtilityClass;

var $9a6742b7048414d1$var$_generateUtilityClasses = $9a6742b7048414d1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9a6742b7048414d1$var$_generateUtilityClass = $9a6742b7048414d1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9a6742b7048414d1$var$getTableBodyUtilityClass(slot) {
    return (0, $9a6742b7048414d1$var$_generateUtilityClass.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $9a6742b7048414d1$var$_generateUtilityClasses.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$var$_default = module.exports.default = $9a6742b7048414d1$var$tableBodyClasses;

});



parcelRegister("hjoMW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c9a7707bc8e823db$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c9a7707bc8e823db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c9a7707bc8e823db$var$_exportNames = {
    tableCellClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c9a7707bc8e823db$var$_TableCell.default;
    }
});
Object.defineProperty(module.exports, "tableCellClasses", {
    enumerable: true,
    get: function() {
        return $c9a7707bc8e823db$var$_tableCellClasses.default;
    }
});

var $c9a7707bc8e823db$var$_TableCell = $c9a7707bc8e823db$require$_interopRequireDefault((parcelRequire("elyLx")));

var $c9a7707bc8e823db$var$_tableCellClasses = $c9a7707bc8e823db$require$_interopRequireWildcard((parcelRequire("ev9nI")));
Object.keys($c9a7707bc8e823db$var$_tableCellClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c9a7707bc8e823db$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c9a7707bc8e823db$var$_tableCellClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c9a7707bc8e823db$var$_tableCellClasses[key];
        }
    });
});

});
parcelRegister("elyLx", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a71dfe9e22152ea2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a71dfe9e22152ea2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a71dfe9e22152ea2$var$React = $a71dfe9e22152ea2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a71dfe9e22152ea2$var$_propTypes = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a71dfe9e22152ea2$var$_clsx = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a71dfe9e22152ea2$var$_composeClasses = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a71dfe9e22152ea2$var$_capitalize = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $a71dfe9e22152ea2$var$_TableContext = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("jWrFr")));

var $a71dfe9e22152ea2$var$_Tablelvl2Context = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $a71dfe9e22152ea2$var$_memoTheme = $a71dfe9e22152ea2$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a71dfe9e22152ea2$var$_tableCellClasses = $a71dfe9e22152ea2$require$_interopRequireWildcard((parcelRequire("ev9nI")));

var $ayMG0 = parcelRequire("ayMG0");
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $a71dfe9e22152ea2$var$_capitalize.default)(align)}`,
            padding !== 'normal' && `padding${(0, $a71dfe9e22152ea2$var$_capitalize.default)(padding)}`,
            `size${(0, $a71dfe9e22152ea2$var$_capitalize.default)(size)}`
        ]
    };
    return (0, $a71dfe9e22152ea2$var$_composeClasses.default)(slots, $a71dfe9e22152ea2$var$_tableCellClasses.getTableCellUtilityClass, classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $aAbgT.styled)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $a71dfe9e22152ea2$var$_capitalize.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $a71dfe9e22152ea2$var$_capitalize.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $a71dfe9e22152ea2$var$_capitalize.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $a71dfe9e22152ea2$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? theme.lighten(theme.alpha(theme.palette.divider, 1), 0.88) : theme.darken(theme.alpha(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${$a71dfe9e22152ea2$var$_tableCellClasses.default.paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $a71dfe9e22152ea2$var$React.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $a71dfe9e22152ea2$var$React.useContext($a71dfe9e22152ea2$var$_TableContext.default);
    const tablelvl2 = $a71dfe9e22152ea2$var$React.useContext($a71dfe9e22152ea2$var$_Tablelvl2Context.default);
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $a71dfe9e22152ea2$var$_clsx.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $a71dfe9e22152ea2$var$_default = module.exports.default = $a71dfe9e22152ea2$var$TableCell;

});
parcelRegister("ev9nI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8eb3ce62ab46dc7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableCellUtilityClass = $a8eb3ce62ab46dc7$var$getTableCellUtilityClass;

var $a8eb3ce62ab46dc7$var$_generateUtilityClasses = $a8eb3ce62ab46dc7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a8eb3ce62ab46dc7$var$_generateUtilityClass = $a8eb3ce62ab46dc7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a8eb3ce62ab46dc7$var$getTableCellUtilityClass(slot) {
    return (0, $a8eb3ce62ab46dc7$var$_generateUtilityClass.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $a8eb3ce62ab46dc7$var$_generateUtilityClasses.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$var$_default = module.exports.default = $a8eb3ce62ab46dc7$var$tableCellClasses;

});



parcelRegister("12YAp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0c34f9894e705401$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0c34f9894e705401$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0c34f9894e705401$var$_exportNames = {
    tableContainerClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0c34f9894e705401$var$_TableContainer.default;
    }
});
Object.defineProperty(module.exports, "tableContainerClasses", {
    enumerable: true,
    get: function() {
        return $0c34f9894e705401$var$_tableContainerClasses.default;
    }
});

var $0c34f9894e705401$var$_TableContainer = $0c34f9894e705401$require$_interopRequireDefault((parcelRequire("81yMd")));

var $0c34f9894e705401$var$_tableContainerClasses = $0c34f9894e705401$require$_interopRequireWildcard((parcelRequire("lNHXc")));
Object.keys($0c34f9894e705401$var$_tableContainerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0c34f9894e705401$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0c34f9894e705401$var$_tableContainerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0c34f9894e705401$var$_tableContainerClasses[key];
        }
    });
});

});
parcelRegister("81yMd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5d7964a6269b66c8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5d7964a6269b66c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d7964a6269b66c8$var$React = $5d7964a6269b66c8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5d7964a6269b66c8$var$_propTypes = $5d7964a6269b66c8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5d7964a6269b66c8$var$_clsx = $5d7964a6269b66c8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5d7964a6269b66c8$var$_composeClasses = $5d7964a6269b66c8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $lNHXc = parcelRequire("lNHXc");

var $ayMG0 = parcelRequire("ayMG0");
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5d7964a6269b66c8$var$_composeClasses.default)(slots, $lNHXc.getTableContainerUtilityClass, classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $5d7964a6269b66c8$var$React.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $5d7964a6269b66c8$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $5d7964a6269b66c8$var$_default = module.exports.default = $5d7964a6269b66c8$var$TableContainer;

});
parcelRegister("lNHXc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fdf044e88b1c9ad4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableContainerUtilityClass = $fdf044e88b1c9ad4$var$getTableContainerUtilityClass;

var $fdf044e88b1c9ad4$var$_generateUtilityClasses = $fdf044e88b1c9ad4$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fdf044e88b1c9ad4$var$_generateUtilityClass = $fdf044e88b1c9ad4$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fdf044e88b1c9ad4$var$getTableContainerUtilityClass(slot) {
    return (0, $fdf044e88b1c9ad4$var$_generateUtilityClass.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $fdf044e88b1c9ad4$var$_generateUtilityClasses.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$var$_default = module.exports.default = $fdf044e88b1c9ad4$var$tableContainerClasses;

});



parcelRegister("g2Lhl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bae181d386a885e4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bae181d386a885e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bae181d386a885e4$var$_exportNames = {
    tableHeadClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bae181d386a885e4$var$_TableHead.default;
    }
});
Object.defineProperty(module.exports, "tableHeadClasses", {
    enumerable: true,
    get: function() {
        return $bae181d386a885e4$var$_tableHeadClasses.default;
    }
});

var $bae181d386a885e4$var$_TableHead = $bae181d386a885e4$require$_interopRequireDefault((parcelRequire("hjXJ8")));

var $bae181d386a885e4$var$_tableHeadClasses = $bae181d386a885e4$require$_interopRequireWildcard((parcelRequire("hMbPk")));
Object.keys($bae181d386a885e4$var$_tableHeadClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bae181d386a885e4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bae181d386a885e4$var$_tableHeadClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bae181d386a885e4$var$_tableHeadClasses[key];
        }
    });
});

});
parcelRegister("hjXJ8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c9c28a8e795911dc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c9c28a8e795911dc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9c28a8e795911dc$var$React = $c9c28a8e795911dc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c9c28a8e795911dc$var$_propTypes = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c9c28a8e795911dc$var$_clsx = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c9c28a8e795911dc$var$_composeClasses = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $c9c28a8e795911dc$var$_Tablelvl2Context = $c9c28a8e795911dc$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $hMbPk = parcelRequire("hMbPk");

var $ayMG0 = parcelRequire("ayMG0");
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $c9c28a8e795911dc$var$_composeClasses.default)(slots, $hMbPk.getTableHeadUtilityClass, classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $aAbgT.styled)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $c9c28a8e795911dc$var$React.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$_Tablelvl2Context.default.Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, {
            as: component,
            className: (0, $c9c28a8e795911dc$var$_clsx.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $c9c28a8e795911dc$var$_default = module.exports.default = $c9c28a8e795911dc$var$TableHead;

});
parcelRegister("hMbPk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cf1017f12785ebe4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableHeadUtilityClass = $cf1017f12785ebe4$var$getTableHeadUtilityClass;

var $cf1017f12785ebe4$var$_generateUtilityClasses = $cf1017f12785ebe4$require$_interopRequireDefault((parcelRequire("5nY49")));

var $cf1017f12785ebe4$var$_generateUtilityClass = $cf1017f12785ebe4$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $cf1017f12785ebe4$var$getTableHeadUtilityClass(slot) {
    return (0, $cf1017f12785ebe4$var$_generateUtilityClass.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $cf1017f12785ebe4$var$_generateUtilityClasses.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$var$_default = module.exports.default = $cf1017f12785ebe4$var$tableHeadClasses;

});



parcelRegister("7IILB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59ef5e314ba45566$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $59ef5e314ba45566$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59ef5e314ba45566$var$_exportNames = {
    tableRowClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59ef5e314ba45566$var$_TableRow.default;
    }
});
Object.defineProperty(module.exports, "tableRowClasses", {
    enumerable: true,
    get: function() {
        return $59ef5e314ba45566$var$_tableRowClasses.default;
    }
});

var $59ef5e314ba45566$var$_TableRow = $59ef5e314ba45566$require$_interopRequireDefault((parcelRequire("2XjE0")));

var $59ef5e314ba45566$var$_tableRowClasses = $59ef5e314ba45566$require$_interopRequireWildcard((parcelRequire("4iLi6")));
Object.keys($59ef5e314ba45566$var$_tableRowClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59ef5e314ba45566$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59ef5e314ba45566$var$_tableRowClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59ef5e314ba45566$var$_tableRowClasses[key];
        }
    });
});

});
parcelRegister("2XjE0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $22705465ad6920f8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $22705465ad6920f8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22705465ad6920f8$var$React = $22705465ad6920f8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $22705465ad6920f8$var$_propTypes = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $22705465ad6920f8$var$_clsx = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $22705465ad6920f8$var$_composeClasses = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $22705465ad6920f8$var$_Tablelvl2Context = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $22705465ad6920f8$var$_memoTheme = $22705465ad6920f8$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $22705465ad6920f8$var$_tableRowClasses = $22705465ad6920f8$require$_interopRequireWildcard((parcelRequire("4iLi6")));

var $ayMG0 = parcelRequire("ayMG0");
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $22705465ad6920f8$var$_composeClasses.default)(slots, $22705465ad6920f8$var$_tableRowClasses.getTableRowUtilityClass, classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $aAbgT.styled)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $22705465ad6920f8$var$_memoTheme.default)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${$22705465ad6920f8$var$_tableRowClasses.default.hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${$22705465ad6920f8$var$_tableRowClasses.default.selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
            }
        }
    })));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $22705465ad6920f8$var$React.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $22705465ad6920f8$var$React.useContext($22705465ad6920f8$var$_Tablelvl2Context.default);
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $22705465ad6920f8$var$_clsx.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $22705465ad6920f8$var$_default = module.exports.default = $22705465ad6920f8$var$TableRow;

});
parcelRegister("4iLi6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $321d86e199abda5b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableRowUtilityClass = $321d86e199abda5b$var$getTableRowUtilityClass;

var $321d86e199abda5b$var$_generateUtilityClasses = $321d86e199abda5b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $321d86e199abda5b$var$_generateUtilityClass = $321d86e199abda5b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $321d86e199abda5b$var$getTableRowUtilityClass(slot) {
    return (0, $321d86e199abda5b$var$_generateUtilityClass.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $321d86e199abda5b$var$_generateUtilityClasses.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$var$_default = module.exports.default = $321d86e199abda5b$var$tableRowClasses;

});



parcelRegister("EOFWj", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $07ab0ba0f215ac14$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0ba0f215ac14$var$_createSvgIcon = $07ab0ba0f215ac14$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $07ab0ba0f215ac14$var$_default = module.exports.default = (0, $07ab0ba0f215ac14$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
}), 'TrendingDown');

});

parcelRegister("hUM4k", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d0acf412599e5ed5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0acf412599e5ed5$var$_createSvgIcon = $d0acf412599e5ed5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d0acf412599e5ed5$var$_default = module.exports.default = (0, $d0acf412599e5ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
}), 'TrendingUp');

});

parcelRegister("dOn5J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DESC_MAP = void 0;
module.exports.delay = $28770b279d7ab5b1$var$delay;
module.exports.extractUnit = $28770b279d7ab5b1$var$extractUnit;
module.exports.lastMonthISOString = $28770b279d7ab5b1$var$lastMonthISOString;
module.exports.nowISOString = $28770b279d7ab5b1$var$nowISOString;
module.exports.subtractMinutes = $28770b279d7ab5b1$var$subtractMinutes;
module.exports.twoMonthsAgoISOString = $28770b279d7ab5b1$var$twoMonthsAgoISOString;
module.exports.yesterdayISOString = $28770b279d7ab5b1$var$yesterdayISOString;
function $28770b279d7ab5b1$var$delay(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $28770b279d7ab5b1$var$extractUnit(fullUnit) {
    const match = fullUnit.match(/\(([^)]+)\)/);
    return match ? match[1] : fullUnit;
}
function $28770b279d7ab5b1$var$nowISOString() {
    return new Date().toISOString();
}
function $28770b279d7ab5b1$var$yesterdayISOString() {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date.toISOString();
}
function $28770b279d7ab5b1$var$lastMonthISOString() {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    date.setHours(0, 0, 0, 0);
    return date.toISOString();
}
function $28770b279d7ab5b1$var$twoMonthsAgoISOString() {
    const date = new Date();
    date.setDate(date.getDate() - 60);
    date.setHours(0, 0, 0, 0);
    return date.toISOString();
}
function $28770b279d7ab5b1$var$subtractMinutes(minutes) {
    const now = new Date();
    return new Date(now.getTime() - Number(minutes) * 60000).toISOString();
}
const $28770b279d7ab5b1$var$DESC_MAP = module.exports.DESC_MAP = {
    PM1: "Particulates (1 \u03BCm)",
    PM4: "Particulates (4 \u03BCm)",
    PM10: "Particulates (10 \u03BCm)",
    PM25: "Particulates (2.5 \u03BCm)",
    CC1: 'Phase 1 Current (mA)',
    CC2: 'Phase 2 Current (mA)',
    CC3: 'Phase 3 Current (mA)',
    TMP2: "Temperature Ext. Probe (\xb0C)",
    TMP5: "Temperature (\xb0C)",
    HUM2: 'Humidity (%)',
    CNT1: 'Pulse Channel 1 (Gas/Water)',
    CNT2: 'Pulse Channel 2 (Gas/Water)',
    LGHT: 'Light (Lux)',
    SND: 'Sound (dB)',
    NOX: 'Nitrogen Oxide Index',
    VOC: 'Volatile Compound Index',
    ZRV1: 'Z-Axis RMS Velocity (mm/sec)',
    XRV1: 'X-Axis RMS Velocity (mm/sec)',
    ZPV1: 'Z-Axis Peak Velocity (mm/sec)',
    XPV1: 'X-Axis Peak Velocity (mm/sec)',
    Imp: 'Imported kWh (Main Incomer)',
    VP1: 'Voltage Phase 1 (Main Incomer)',
    VP2: 'Voltage Phase 2 (Main Incomer)',
    VP3: 'Voltage Phase 3 (Main Incomer)',
    AP1: 'Ampere Phase 1 (Main Incomer)',
    AP2: 'Ampere Phase 2 (Main Incomer)',
    AP3: 'Ampere Phase 3 (Main Incomer)',
    PF: 'Power Factor (Main Incomer)'
};

});


parcelRegister("4pWyw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a37c4c2c5b970659$var$FiringAlertsTable;

var $a37c4c2c5b970659$var$React = $a37c4c2c5b970659$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a37c4c2c5b970659$var$_Table = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("bGe9g")));

var $a37c4c2c5b970659$var$_TableBody = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("5hLrb")));

var $a37c4c2c5b970659$var$_TableCell = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("hjoMW")));

var $a37c4c2c5b970659$var$_TableContainer = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("12YAp")));

var $a37c4c2c5b970659$var$_TableHead = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("g2Lhl")));

var $a37c4c2c5b970659$var$_TableRow = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("7IILB")));

var $a37c4c2c5b970659$var$_CircularProgress = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("1sBf1")));

var $a37c4c2c5b970659$var$_Box = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $a37c4c2c5b970659$var$_Typography = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $a37c4c2c5b970659$var$_CheckCircle = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("hmTQO")));

var $a37c4c2c5b970659$var$_NotificationsActive = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("eSW5k")));

var $a37c4c2c5b970659$var$_PauseCircle = $a37c4c2c5b970659$var$_interopRequireDefault((parcelRequire("bQAQI")));

var $3u6kV = parcelRequire("3u6kV");

var $ayMG0 = parcelRequire("ayMG0");
function $a37c4c2c5b970659$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $a37c4c2c5b970659$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($a37c4c2c5b970659$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $a37c4c2c5b970659$var$getStatusMeta(alert) {
    if (!alert.is_active) return {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_CheckCircle.default, {
            sx: {
                fontSize: '16px !important',
                color: '#888780 !important'
            }
        }),
        label: 'Inactive',
        color: '#888780'
    };
    const now = new Date();
    if (alert.silenced_until && new Date(alert.silenced_until) > now) return {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_PauseCircle.default, {
            sx: {
                fontSize: '16px !important',
                color: '#BA7517 !important'
            }
        }),
        label: 'Silenced',
        color: '#BA7517'
    };
    if (alert.alert_state?.breaching_since) return {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_NotificationsActive.default, {
            sx: {
                fontSize: '16px !important',
                color: '#993C1D !important'
            }
        }),
        label: 'Firing',
        color: '#993C1D'
    };
    return {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_CheckCircle.default, {
            sx: {
                fontSize: '16px !important',
                color: '#1D9E75 !important'
            }
        }),
        label: 'OK',
        color: '#1D9E75'
    };
}
const $a37c4c2c5b970659$var$SEVERITY_ORDER = {
    Firing: 0,
    Silenced: 1,
    OK: 2,
    Inactive: 3
};
function $a37c4c2c5b970659$var$sortAlerts(alerts) {
    return [
        ...alerts
    ].sort((a, b)=>{
        const aLabel = $a37c4c2c5b970659$var$getStatusMeta(a).label;
        const bLabel = $a37c4c2c5b970659$var$getStatusMeta(b).label;
        return ($a37c4c2c5b970659$var$SEVERITY_ORDER[aLabel] ?? 99) - ($a37c4c2c5b970659$var$SEVERITY_ORDER[bLabel] ?? 99);
    });
}
function $a37c4c2c5b970659$var$resolveLocation(osm_ids, osmMap) {
    if (!osm_ids?.length) return 'All';
    return osm_ids.map((id)=>osmMap.get(id) ?? String(id)).join(', ');
}
const $a37c4c2c5b970659$var$headCellSx = {
    fontFamily: "'Syne', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'var(--color-text-secondary)',
    background: 'transparent',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    py: 1.25
};
const $a37c4c2c5b970659$var$bodyCellSx = {
    fontFamily: "'DM Mono', monospace",
    fontSize: 12,
    color: 'var(--color-text-primary)',
    borderBottom: '1px solid rgba(255,255,255,0.04)',
    py: 1,
    background: 'transparent'
};
function $a37c4c2c5b970659$var$FiringAlertsTable() {
    const [alerts, setAlerts] = $a37c4c2c5b970659$var$React.useState([]);
    const [osmMap, setOsmMap] = $a37c4c2c5b970659$var$React.useState(new Map());
    const [loading, setLoading] = $a37c4c2c5b970659$var$React.useState(true);
    const [error, setError] = $a37c4c2c5b970659$var$React.useState(null);
    $a37c4c2c5b970659$var$React.useEffect(()=>{
        Promise.all([
            (0, $3u6kV.getAlertStatuses)(),
            (0, $3u6kV.getOsmLocations)()
        ]).then(([alertData, osmData])=>{
            setAlerts($a37c4c2c5b970659$var$sortAlerts(alertData));
            setOsmMap(new Map(osmData.map((o)=>[
                    o.id,
                    o.name
                ])));
        }).catch((err)=>setError(err.message)).finally(()=>setLoading(false));
    }, []);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_Box.default, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_CircularProgress.default, {
            size: 24,
            sx: {
                color: '#1D9E75'
            }
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)($a37c4c2c5b970659$var$_Typography.default, {
        sx: {
            fontFamily: "'DM Mono', monospace",
            fontSize: 12,
            color: '#993C1D'
        },
        children: [
            "Error: ",
            error
        ]
    });
    if (!alerts.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_Typography.default, {
        sx: {
            fontFamily: "'DM Mono', monospace",
            fontSize: 12,
            color: 'var(--color-text-secondary)'
        },
        children: "No alerts configured."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableContainer.default, {
        sx: {
            background: 'transparent',
            maxHeight: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($a37c4c2c5b970659$var$_Table.default, {
            stickyHeader: true,
            size: "small",
            "aria-label": "alerts table",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableHead.default, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($a37c4c2c5b970659$var$_TableRow.default, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableCell.default, {
                                align: "left",
                                sx: $a37c4c2c5b970659$var$headCellSx,
                                children: "Alert"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableCell.default, {
                                align: "left",
                                sx: $a37c4c2c5b970659$var$headCellSx,
                                children: "Location"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableCell.default, {
                                align: "center",
                                sx: $a37c4c2c5b970659$var$headCellSx,
                                children: "Status"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableBody.default, {
                    children: alerts.map((alert)=>{
                        const { icon: icon, label: label, color: color } = $a37c4c2c5b970659$var$getStatusMeta(alert);
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)($a37c4c2c5b970659$var$_TableRow.default, {
                            sx: {
                                '&:last-child td': {
                                    border: 0
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableCell.default, {
                                    align: "left",
                                    sx: {
                                        ...$a37c4c2c5b970659$var$bodyCellSx,
                                        fontFamily: "'Syne', sans-serif",
                                        fontWeight: 500,
                                        fontSize: 12,
                                        color: 'var(--color-text-primary)'
                                    },
                                    children: alert.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableCell.default, {
                                    align: "left",
                                    sx: {
                                        ...$a37c4c2c5b970659$var$bodyCellSx,
                                        color: 'var(--color-text-secondary)'
                                    },
                                    children: $a37c4c2c5b970659$var$resolveLocation(alert.osm_ids, osmMap)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_TableCell.default, {
                                    align: "center",
                                    sx: $a37c4c2c5b970659$var$bodyCellSx,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($a37c4c2c5b970659$var$_Box.default, {
                                        sx: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 0.75,
                                            color: color
                                        },
                                        children: [
                                            icon,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($a37c4c2c5b970659$var$_Typography.default, {
                                                sx: {
                                                    fontFamily: "'DM Mono', monospace",
                                                    fontSize: 11,
                                                    color: color
                                                },
                                                children: label
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, alert.id);
                    })
                })
            ]
        })
    });
}

});
parcelRegister("hmTQO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ca4fd08777d4e412$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca4fd08777d4e412$var$_createSvgIcon = $ca4fd08777d4e412$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ca4fd08777d4e412$var$_default = module.exports.default = (0, $ca4fd08777d4e412$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');

});

parcelRegister("eSW5k", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ad632a474182d1b7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad632a474182d1b7$var$_createSvgIcon = $ad632a474182d1b7$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ad632a474182d1b7$var$_default = module.exports.default = (0, $ad632a474182d1b7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.58 4.08 6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42m12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42M18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18q.15-.36.15-.78h-4c.01 1.1.9 2 2.01 2"
}), 'NotificationsActive');

});

parcelRegister("bQAQI", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8a012288c1f8ed5b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a012288c1f8ed5b$var$_createSvgIcon = $8a012288c1f8ed5b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8a012288c1f8ed5b$var$_default = module.exports.default = (0, $8a012288c1f8ed5b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 14H9V8h2zm4 0h-2V8h2z"
}), 'PauseCircle');

});



parcelRegister("1dmEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d3d5c15f4130d5dc$var$Dashboard;

var $gwjoH = parcelRequire("gwjoH");

var $ayMG0 = parcelRequire("ayMG0");
function $d3d5c15f4130d5dc$var$Dashboard() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Outlet, {});
}

});

parcelRegister("d74V5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5675f1b4a147042$var$TariffPage;

var $b5675f1b4a147042$var$_Box = $b5675f1b4a147042$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $b5675f1b4a147042$var$_Typography = $b5675f1b4a147042$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $b5675f1b4a147042$var$_TariffTable = $b5675f1b4a147042$var$_interopRequireDefault((parcelRequire("dkeqX")));

var $ayMG0 = parcelRequire("ayMG0");
function $b5675f1b4a147042$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $b5675f1b4a147042$var$TariffPage() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b5675f1b4a147042$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '75vw',
            margin: '0 auto',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b5675f1b4a147042$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($b5675f1b4a147042$var$_Typography.default, {
                    sx: {
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 20,
                        fontWeight: 600,
                        color: '#1D9E75',
                        mb: 3
                    },
                    children: "Tariffs"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b5675f1b4a147042$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.25rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($b5675f1b4a147042$var$_TariffTable.default, {})
            })
        ]
    });
}

});
parcelRegister("dkeqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ade0ff6c6780888$var$TariffTable;

var $6ade0ff6c6780888$var$_react = $6ade0ff6c6780888$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6ade0ff6c6780888$var$_ReusableDataGrid = $6ade0ff6c6780888$var$_interopRequireDefault((parcelRequire("16S3t")));

var $3u6kV = parcelRequire("3u6kV");

var $b2c6k = parcelRequire("b2c6k");

var $6ade0ff6c6780888$var$_TextField = $6ade0ff6c6780888$var$_interopRequireDefault((parcelRequire("hABDe")));

var $ayMG0 = parcelRequire("ayMG0");
function $6ade0ff6c6780888$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $6ade0ff6c6780888$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6ade0ff6c6780888$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $6ade0ff6c6780888$var$TimeEditCell(params) {
    const { id: id, field: field, value: value } = params;
    const apiRef = (0, $b2c6k.useGridApiContext)();
    const toTimeString = (v)=>{
        const h = Math.floor(v).toString().padStart(2, '0');
        const m = Math.round(v % 1 * 60).toString().padStart(2, '0');
        return `${h}:${m}`;
    };
    const fromTimeString = (s)=>{
        const [h, m] = s.split(':').map(Number);
        return h + m / 60;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ade0ff6c6780888$var$_TextField.default, {
        type: "time",
        value: toTimeString(value ?? 0),
        onChange: (e)=>apiRef.current.setEditCellValue({
                id: id,
                field: field,
                value: fromTimeString(e.target.value)
            }),
        size: "small",
        InputLabelProps: {
            shrink: true
        },
        sx: {
            width: '100%',
            '& .MuiOutlinedInput-root': {
                fontFamily: "'DM Mono', monospace",
                fontSize: 13,
                '& fieldset': {
                    borderColor: 'rgba(255,255,255,0.12)'
                },
                '&:hover fieldset': {
                    borderColor: '#1D9E75'
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#1D9E75'
                }
            }
        }
    });
}
const $6ade0ff6c6780888$var$TAG_MAP = {
    elec: 'Electricity',
    gas: 'Gas',
    water: 'Water'
};
const $6ade0ff6c6780888$var$TAG_REVERSE_MAP = {
    Electricity: 'elec',
    Gas: 'gas',
    Water: 'water'
};
const $6ade0ff6c6780888$var$defaultRow = {
    type: 'Electricity',
    rate: 0,
    startHour: 0,
    endHour: 24,
    dayType: 0,
    validFrom: new Date('2020-01-01'),
    validTo: null
};
const $6ade0ff6c6780888$var$columns = [
    {
        field: 'type',
        headerName: 'Type',
        type: 'singleSelect',
        minWidth: 80,
        flex: 1,
        valueOptions: [
            'Electricity',
            'Gas',
            'Water'
        ],
        editable: true
    },
    {
        field: 'rate',
        headerName: 'Rate',
        type: 'number',
        minWidth: 80,
        flex: 0.75,
        align: 'left',
        headerAlign: 'left',
        editable: true,
        valueFormatter: (value)=>value != null ? `\xa3${Number(value).toLocaleString('en-GB', {
                minimumFractionDigits: 2
            })}` : ''
    },
    {
        field: 'startHour',
        headerName: 'Start Hour',
        type: 'number',
        minWidth: 80,
        flex: 0.75,
        editable: true,
        valueFormatter: (value)=>{
            if (value == null) return '';
            const h = Math.floor(value).toString().padStart(2, '0');
            const m = Math.round(value % 1 * 60).toString().padStart(2, '0');
            return `${h}:${m}`;
        },
        renderEditCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6ade0ff6c6780888$var$TimeEditCell, {
                ...params
            })
    },
    {
        field: 'endHour',
        headerName: 'End Hour',
        type: 'number',
        minWidth: 80,
        flex: 0.75,
        editable: true,
        valueFormatter: (value)=>{
            if (value == null) return '';
            const h = Math.floor(value).toString().padStart(2, '0');
            const m = Math.round(value % 1 * 60).toString().padStart(2, '0');
            return `${h}:${m}`;
        },
        renderEditCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6ade0ff6c6780888$var$TimeEditCell, {
                ...params
            })
    },
    {
        field: 'dayType',
        headerName: 'Weekday',
        type: 'singleSelect',
        minWidth: 80,
        flex: 1,
        editable: true,
        valueOptions: [
            {
                value: 7,
                label: 'All'
            },
            {
                value: 0,
                label: 'Monday'
            },
            {
                value: 1,
                label: 'Tuesday'
            },
            {
                value: 2,
                label: 'Wednesday'
            },
            {
                value: 3,
                label: 'Thursday'
            },
            {
                value: 4,
                label: 'Friday'
            },
            {
                value: 5,
                label: 'Saturday'
            },
            {
                value: 6,
                label: 'Sunday'
            }
        ]
    },
    {
        field: 'validFrom',
        headerName: 'Valid From',
        type: 'date',
        minWidth: 100,
        flex: 1,
        editable: true,
        valueFormatter: (params)=>params?.toLocaleDateString('en-GB')
    },
    {
        field: 'validTo',
        headerName: 'Valid To',
        type: 'date',
        minWidth: 100,
        flex: 1,
        editable: true,
        valueFormatter: (params)=>params?.toLocaleDateString('en-GB') ?? ''
    }
];
const $6ade0ff6c6780888$var$mapRow = (row)=>({
        id: row.id,
        type: $6ade0ff6c6780888$var$TAG_MAP[row.tag] ?? row.tag,
        rate: row.rate,
        startHour: row.start_hour,
        endHour: row.end_hour,
        dayType: row.weekday,
        validFrom: row.valid_from ? new Date(row.valid_from) : null,
        validTo: row.valid_to ? new Date(row.valid_to) : null
    });
function $6ade0ff6c6780888$var$TariffTable() {
    const [initialRows, setInitialRows] = (0, $6ade0ff6c6780888$var$_react.useState)([]);
    (0, $6ade0ff6c6780888$var$_react.useEffect)(()=>{
        (0, $3u6kV.getTariffs)().then((data)=>setInitialRows(data.map($6ade0ff6c6780888$var$mapRow))).catch((err)=>console.error('Failed to fetch tariffs:', err));
    }, []);
    const handleSaveRow = async (row)=>{
        const basePayload = {
            rate: row.rate,
            valid_from: row.validFrom instanceof Date ? row.validFrom.toISOString() : row.validFrom,
            valid_to: row.validTo instanceof Date ? row.validTo.toISOString() : row.validTo ?? null,
            tag: $6ade0ff6c6780888$var$TAG_REVERSE_MAP[row.type] ?? row.type,
            start_hour: row.startHour,
            end_hour: row.endHour
        };
        if (row.dayType === 7 && !row.isNew) {
            await (0, $3u6kV.deleteTariff)(row.id);
            await Promise.all([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map((weekday)=>(0, $3u6kV.createTariff)({
                    ...basePayload,
                    weekday: weekday
                })));
            (0, $3u6kV.getTariffs)().then((data)=>setInitialRows(data.map($6ade0ff6c6780888$var$mapRow)));
            return {
                ...row,
                isNew: false
            };
        }
        if (row.isNew) {
            const weekdays = row.dayType === 7 ? [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ] : [
                row.dayType
            ];
            const results = await Promise.all(weekdays.map((weekday)=>(0, $3u6kV.createTariff)({
                    ...basePayload,
                    weekday: weekday
                })));
            return {
                ...row,
                id: results[0][0].id,
                isNew: false
            };
        }
        await (0, $3u6kV.updateTariff)(row.id, {
            ...basePayload,
            weekday: row.dayType
        });
        return {
            ...row,
            isNew: false
        };
    };
    const handleDeleteRow = async (row)=>{
        await (0, $3u6kV.deleteTariff)(row.id);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ade0ff6c6780888$var$_ReusableDataGrid.default, {
        defaultRow: $6ade0ff6c6780888$var$defaultRow,
        initialRows: initialRows,
        columns: $6ade0ff6c6780888$var$columns,
        height: "75vh",
        width: "100%",
        onSaveRow: handleSaveRow,
        onDeleteRow: handleDeleteRow
    });
}

});
parcelRegister("16S3t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d182abb1ebb104fc$var$ReusableDataGrid;

var $d182abb1ebb104fc$var$React = $d182abb1ebb104fc$var$_interopRequireWildcard((parcelRequire("acw62")));

var $d182abb1ebb104fc$var$_Box = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $d182abb1ebb104fc$var$_Tooltip = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("tEWAm")));

var $d182abb1ebb104fc$var$_Add = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("7tqxO")));

var $d182abb1ebb104fc$var$_Edit = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("c3r8Q")));

var $d182abb1ebb104fc$var$_DeleteOutlined = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("a1rcD")));

var $d182abb1ebb104fc$var$_Save = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("9wvX1")));

var $d182abb1ebb104fc$var$_Close = $d182abb1ebb104fc$var$_interopRequireDefault((parcelRequire("dqlTG")));

var $b2c6k = parcelRequire("b2c6k");

var $ayMG0 = parcelRequire("ayMG0");
function $d182abb1ebb104fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $d182abb1ebb104fc$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d182abb1ebb104fc$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const $d182abb1ebb104fc$var$BRAND_GREEN = '#1D9E75';
const $d182abb1ebb104fc$var$dataGridSx = {
    border: 'none',
    background: 'transparent',
    fontFamily: "'DM Mono', monospace",
    '& .MuiDataGrid-columnHeader': {
        background: `${$d182abb1ebb104fc$var$BRAND_GREEN} !important`,
        color: '#ffffff !important',
        fontFamily: "'Syne', sans-serif",
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase'
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#ffffff !important'
    },
    '& .MuiDataGrid-columnSeparator': {
        display: 'none'
    },
    '& .MuiDataGrid-sortIcon': {
        color: '#ffffff !important'
    },
    '& .MuiDataGrid-menuIconButton': {
        color: '#ffffff !important'
    },
    '& .MuiDataGrid-row': {
        borderBottom: '1px solid rgba(255,255,255,0.04)',
        background: 'transparent'
    },
    '& .MuiDataGrid-row:hover': {
        background: 'rgba(255,255,255,0.02)'
    },
    '& .MuiDataGrid-cell': {
        border: 'none',
        background: 'transparent',
        fontFamily: "'DM Mono', monospace",
        fontSize: 13,
        color: 'var(--color-text-primary)'
    },
    '& .MuiDataGrid-footerContainer': {
        borderTop: '1px solid rgba(255,255,255,0.06)',
        background: 'transparent'
    },
    '& .MuiTablePagination-root': {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary)'
    },
    '& .MuiDataGrid-toolbarContainer': {
        justifyContent: 'flex-end',
        pb: 1
    }
};
let $d182abb1ebb104fc$var$idCounter = 0;
function $d182abb1ebb104fc$var$EditToolbar({ setRows: setRows, setRowModesModel: setRowModesModel, defaultRow: defaultRow }) {
    const handleClick = ()=>{
        $d182abb1ebb104fc$var$idCounter += 1;
        setRows((oldRows)=>[
                {
                    ...defaultRow,
                    id: $d182abb1ebb104fc$var$idCounter,
                    isNew: true
                },
                ...oldRows
            ]);
        setRowModesModel((oldModel)=>({
                ...oldModel,
                [$d182abb1ebb104fc$var$idCounter]: {
                    mode: $b2c6k.GridRowModes.Edit,
                    fieldToFocus: Object.keys(defaultRow)[0]
                }
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.GridToolbarContainer, {
        sx: {
            justifyContent: 'flex-end',
            pb: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_Tooltip.default, {
            title: "Add rule",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($d182abb1ebb104fc$var$_Box.default, {
                component: "button",
                onClick: handleClick,
                sx: {
                    border: '1px solid rgba(255,255,255,0.12)',
                    background: 'transparent',
                    cursor: 'pointer',
                    borderRadius: 1.5,
                    p: '4px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    color: $d182abb1ebb104fc$var$BRAND_GREEN,
                    fontFamily: "'DM Mono', monospace",
                    fontSize: 11,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    transition: 'all 0.15s ease',
                    '&:hover': {
                        borderColor: $d182abb1ebb104fc$var$BRAND_GREEN,
                        background: 'rgba(29,158,117,0.08)'
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_Add.default, {
                        sx: {
                            fontSize: '14px !important',
                            padding: '0 !important'
                        }
                    }),
                    "Add"
                ]
            })
        })
    });
}
function $d182abb1ebb104fc$var$ReusableDataGrid({ defaultRow: defaultRow, columns: columns, height: height = '100%', width: width = '100%', initialRows: initialRows, onSaveRow: onSaveRow, onDeleteRow: onDeleteRow }) {
    const [rows, setRows] = $d182abb1ebb104fc$var$React.useState([]);
    const [rowModesModel, setRowModesModel] = $d182abb1ebb104fc$var$React.useState({});
    const handleRowEditStop = (params, event)=>{
        if (params.reason === $b2c6k.GridRowEditStopReasons.rowFocusOut) event.defaultMuiPrevented = true;
    };
    const handleEditClick = (id)=>()=>setRowModesModel({
                ...rowModesModel,
                [id]: {
                    mode: $b2c6k.GridRowModes.Edit
                }
            });
    const handleSaveClick = (id)=>()=>setRowModesModel({
                ...rowModesModel,
                [id]: {
                    mode: $b2c6k.GridRowModes.View
                }
            });
    const handleCancelClick = (id)=>()=>{
            setRowModesModel({
                ...rowModesModel,
                [id]: {
                    mode: $b2c6k.GridRowModes.View,
                    ignoreModifications: true
                }
            });
            const editedRow = rows.find((r)=>r.id === id);
            if (editedRow?.isNew) setRows(rows.filter((r)=>r.id !== id));
        };
    const handleDeleteClick = (id)=>async ()=>{
            const row = rows.find((r)=>r.id === id);
            if (onDeleteRow && row && !row.isNew) await onDeleteRow(row);
            setRows(rows.filter((r)=>r.id !== id));
        };
    const processRowUpdate = async (newRow)=>{
        let savedRow = {
            ...newRow,
            isNew: false
        };
        if (onSaveRow) savedRow = await onSaveRow(newRow);
        setRows(rows.map((r)=>r.id === newRow.id ? savedRow : r));
        return savedRow;
    };
    $d182abb1ebb104fc$var$React.useEffect(()=>{
        if (initialRows) {
            setRows(initialRows);
            const maxId = initialRows.reduce((max, row)=>Math.max(max, row.id ?? 0), 0);
            $d182abb1ebb104fc$var$idCounter = maxId;
        }
    }, [
        initialRows
    ]);
    const iconSx = (color)=>({
            color: `${color} !important`,
            '& svg': {
                fontSize: '16px !important',
                padding: '0 !important'
            }
        });
    const columnsWithActions = [
        ...columns,
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            minWidth: 100,
            flex: 0.5,
            getActions: ({ id: id })=>{
                const isInEditMode = rowModesModel[id]?.mode === $b2c6k.GridRowModes.Edit;
                if (isInEditMode) return [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.GridActionsCellItem, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_Save.default, {}),
                        label: "Save",
                        onClick: handleSaveClick(id),
                        sx: iconSx($d182abb1ebb104fc$var$BRAND_GREEN)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.GridActionsCellItem, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_Close.default, {}),
                        label: "Cancel",
                        onClick: handleCancelClick(id),
                        sx: iconSx('var(--color-text-secondary)')
                    })
                ];
                return [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.GridActionsCellItem, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_Edit.default, {}),
                        label: "Edit",
                        onClick: handleEditClick(id),
                        sx: iconSx($d182abb1ebb104fc$var$BRAND_GREEN)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.GridActionsCellItem, {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_DeleteOutlined.default, {}),
                        label: "Delete",
                        onClick: handleDeleteClick(id),
                        sx: iconSx('#993C1D')
                    })
                ];
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d182abb1ebb104fc$var$_Box.default, {
        sx: {
            width: width,
            height: height,
            minHeight: height
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.DataGrid, {
            rows: rows,
            columns: columnsWithActions,
            editMode: "row",
            rowModesModel: rowModesModel,
            onRowModesModelChange: setRowModesModel,
            processRowUpdate: processRowUpdate,
            onRowEditStop: handleRowEditStop,
            pageSizeOptions: [
                5,
                10,
                25,
                {
                    value: -1,
                    label: 'All'
                }
            ],
            initialState: {
                pagination: {
                    paginationModel: {
                        pageSize: -1
                    }
                }
            },
            slots: {
                toolbar: $d182abb1ebb104fc$var$EditToolbar
            },
            slotProps: {
                toolbar: {
                    setRows: setRows,
                    setRowModesModel: setRowModesModel,
                    defaultRow: defaultRow
                }
            },
            showToolbar: true,
            autoHeight: false,
            sx: {
                ...$d182abb1ebb104fc$var$dataGridSx,
                height: '100%'
            }
        })
    });
}

});
parcelRegister("tEWAm", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $05927828b8d9f8ec$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $05927828b8d9f8ec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $05927828b8d9f8ec$var$_exportNames = {
    tooltipClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $05927828b8d9f8ec$var$_Tooltip.default;
    }
});
Object.defineProperty(module.exports, "tooltipClasses", {
    enumerable: true,
    get: function() {
        return $05927828b8d9f8ec$var$_tooltipClasses.default;
    }
});

var $05927828b8d9f8ec$var$_Tooltip = $05927828b8d9f8ec$require$_interopRequireDefault((parcelRequire("cVXaD")));

var $05927828b8d9f8ec$var$_tooltipClasses = $05927828b8d9f8ec$require$_interopRequireWildcard((parcelRequire("eVjpW")));
Object.keys($05927828b8d9f8ec$var$_tooltipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($05927828b8d9f8ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $05927828b8d9f8ec$var$_tooltipClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $05927828b8d9f8ec$var$_tooltipClasses[key];
        }
    });
});

});
parcelRegister("cVXaD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $96a8b4f445fd9172$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $96a8b4f445fd9172$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.testReset = $96a8b4f445fd9172$var$testReset;

var $96a8b4f445fd9172$var$React = $96a8b4f445fd9172$require$_interopRequireWildcard((parcelRequire("acw62")));

var $96a8b4f445fd9172$var$_propTypes = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $96a8b4f445fd9172$var$_clsx = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("9QePP")));

var $96a8b4f445fd9172$var$_useTimeout = $96a8b4f445fd9172$require$_interopRequireWildcard((parcelRequire("drY8V")));

var $96a8b4f445fd9172$var$_elementAcceptingRef = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("igTUE")));

var $96a8b4f445fd9172$var$_composeClasses = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $96a8b4f445fd9172$var$_isFocusVisible = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("cS73m")));

var $96a8b4f445fd9172$var$_getReactElementRef = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $aAbgT = parcelRequire("aAbgT");

var $96a8b4f445fd9172$var$_memoTheme = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $96a8b4f445fd9172$var$_capitalize = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $96a8b4f445fd9172$var$_Grow = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $96a8b4f445fd9172$var$_Popper = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $96a8b4f445fd9172$var$_useEventCallback = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $96a8b4f445fd9172$var$_useForkRef = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $96a8b4f445fd9172$var$_useId = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $96a8b4f445fd9172$var$_useControlled = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("3yddg")));

var $96a8b4f445fd9172$var$_useSlot = $96a8b4f445fd9172$require$_interopRequireDefault((parcelRequire("6lpak")));

var $96a8b4f445fd9172$var$_tooltipClasses = $96a8b4f445fd9172$require$_interopRequireWildcard((parcelRequire("eVjpW")));

var $ayMG0 = parcelRequire("ayMG0");
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $96a8b4f445fd9172$var$_capitalize.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $96a8b4f445fd9172$var$_composeClasses.default)(slots, $96a8b4f445fd9172$var$_tooltipClasses.getTooltipUtilityClass, classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $aAbgT.styled)($96a8b4f445fd9172$var$_Popper.default, {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $96a8b4f445fd9172$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${$96a8b4f445fd9172$var$_tooltipClasses.default.arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $aAbgT.styled)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $96a8b4f445fd9172$var$_capitalize.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $96a8b4f445fd9172$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${$96a8b4f445fd9172$var$_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $aAbgT.styled)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $96a8b4f445fd9172$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new $96a8b4f445fd9172$var$_useTimeout.Timeout();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$var$testReset() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $96a8b4f445fd9172$var$React.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $96a8b4f445fd9172$var$React.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $aAbgT.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const [childNode, setChildNode] = $96a8b4f445fd9172$var$React.useState();
    const [arrowRef, setArrowRef] = $96a8b4f445fd9172$var$React.useState(null);
    const ignoreNonTouchEvents = $96a8b4f445fd9172$var$React.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const enterTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const leaveTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const touchTimer = (0, $96a8b4f445fd9172$var$_useTimeout.default)();
    const [openState, setOpenState] = (0, $96a8b4f445fd9172$var$_useControlled.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $96a8b4f445fd9172$var$_useId.default)(idProp);
    const prevUserSelect = $96a8b4f445fd9172$var$React.useRef();
    const stopTouchInteraction = (0, $96a8b4f445fd9172$var$_useEventCallback.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $96a8b4f445fd9172$var$React.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $96a8b4f445fd9172$var$_useEventCallback.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $96a8b4f445fd9172$var$React.useState(false);
    const handleBlur = (event)=>{
        // Needed for https://github.com/mui/material-ui/issues/45373
        const target = event?.target ?? childNode;
        if (!target || !(0, $96a8b4f445fd9172$var$_isFocusVisible.default)(target)) {
            setChildIsFocusVisible(false);
            // InputBase can call onBlur() without an event when the input becomes disabled.
            // Tooltip must not assume an event object exists.
            const closeEvent = event ?? new Event('blur');
            // `new Event('blur')` has `target/currentTarget === null`, but Tooltip's close logic
            // (and user callbacks like onClose) may expect them to reference the anchor element.
            if (!event && target) {
                Object.defineProperty(closeEvent, 'target', {
                    value: target
                });
                Object.defineProperty(closeEvent, 'currentTarget', {
                    value: target
                });
            }
            handleMouseLeave(closeEvent);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $96a8b4f445fd9172$var$_isFocusVisible.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $96a8b4f445fd9172$var$React.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $96a8b4f445fd9172$var$_useForkRef.default)((0, $96a8b4f445fd9172$var$_getReactElementRef.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $96a8b4f445fd9172$var$React.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $96a8b4f445fd9172$var$_clsx.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $96a8b4f445fd9172$var$React.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('popper', {
        elementType: $96a8b4f445fd9172$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $96a8b4f445fd9172$var$_clsx.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('transition', {
        elementType: $96a8b4f445fd9172$var$_Grow.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('tooltip', {
        elementType: $96a8b4f445fd9172$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $96a8b4f445fd9172$var$_useSlot.default)('arrow', {
        elementType: $96a8b4f445fd9172$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($96a8b4f445fd9172$var$React.Fragment, {
        children: [
            /*#__PURE__*/ $96a8b4f445fd9172$var$React.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperSlot, {
                as: PopperComponentProp ?? $96a8b4f445fd9172$var$_Popper.default,
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $96a8b4f445fd9172$var$_default = module.exports.default = $96a8b4f445fd9172$var$Tooltip;

});
parcelRegister("6dJ4n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $012b35560897a029$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $012b35560897a029$var$_Grow.default;
    }
});

var $012b35560897a029$var$_Grow = $012b35560897a029$require$_interopRequireDefault((parcelRequire("iscuz")));

});
parcelRegister("iscuz", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d6f4882a3b1c59f2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d6f4882a3b1c59f2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6f4882a3b1c59f2$var$React = $d6f4882a3b1c59f2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d6f4882a3b1c59f2$var$_propTypes = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d6f4882a3b1c59f2$var$_useTimeout = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("drY8V")));

var $d6f4882a3b1c59f2$var$_elementAcceptingRef = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("igTUE")));

var $d6f4882a3b1c59f2$var$_getReactElementRef = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $1mPeS = parcelRequire("1mPeS");

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $d6f4882a3b1c59f2$var$_useForkRef = $d6f4882a3b1c59f2$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ayMG0 = parcelRequire("ayMG0");
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $d6f4882a3b1c59f2$var$React.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $1mPeS.default, ...other } = props;
    const timer = (0, $d6f4882a3b1c59f2$var$_useTimeout.default)();
    const autoTimeout = $d6f4882a3b1c59f2$var$React.useRef();
    const theme = (0, $aAbgT.useTheme)();
    const nodeRef = $d6f4882a3b1c59f2$var$React.useRef(null);
    const handleRef = (0, $d6f4882a3b1c59f2$var$_useForkRef.default)(nodeRef, (0, $d6f4882a3b1c59f2$var$_getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $d6f4882a3b1c59f2$var$React.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$d6f4882a3b1c59f2$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($d6f4882a3b1c59f2$var$Grow) $d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$var$_default = module.exports.default = $d6f4882a3b1c59f2$var$Grow;

});


parcelRegister("eWJe7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ae19908c5516ff78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ae19908c5516ff78$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ae19908c5516ff78$var$_Popper.default;
    }
});

var $ae19908c5516ff78$var$_Popper = $ae19908c5516ff78$require$_interopRequireDefault((parcelRequire("e76iu")));

var $g3XLf = parcelRequire("g3XLf");
Object.keys($g3XLf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ae19908c5516ff78$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $g3XLf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g3XLf[key];
        }
    });
});

});
parcelRegister("e76iu", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a4669aa090d445bd$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a4669aa090d445bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9uEev = parcelRequire("9uEev");

var $a4669aa090d445bd$var$_refType = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $a4669aa090d445bd$var$_HTMLElementType = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $a4669aa090d445bd$var$_propTypes = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a4669aa090d445bd$var$React = $a4669aa090d445bd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a4669aa090d445bd$var$_BasePopper = $a4669aa090d445bd$require$_interopRequireDefault((parcelRequire("7JHF2")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $a4669aa090d445bd$var$PopperRoot = (0, $aAbgT.styled)($a4669aa090d445bd$var$_BasePopper.default, {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $a4669aa090d445bd$var$React.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $9uEev.useRtl)();
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $a4669aa090d445bd$var$_default = module.exports.default = $a4669aa090d445bd$var$Popper;

});
parcelRegister("7JHF2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5a1e9a841ed0d0fc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5a1e9a841ed0d0fc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a1e9a841ed0d0fc$var$React = $5a1e9a841ed0d0fc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5a1e9a841ed0d0fc$var$_ownerDocument = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("43fuO")));

var $5a1e9a841ed0d0fc$var$_useEnhancedEffect = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $5a1e9a841ed0d0fc$var$_useForkRef = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $5a1e9a841ed0d0fc$var$_chainPropTypes = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("abVWF")));

var $5a1e9a841ed0d0fc$var$_HTMLElementType = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $5a1e9a841ed0d0fc$var$_refType = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $3tUi5 = parcelRequire("3tUi5");

var $5a1e9a841ed0d0fc$var$_propTypes = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5a1e9a841ed0d0fc$var$_composeClasses = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5a1e9a841ed0d0fc$var$_useSlotProps = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("839K0")));

var $5a1e9a841ed0d0fc$var$_isLayoutSupported = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("6toKj")));

var $5a1e9a841ed0d0fc$var$_Portal = $5a1e9a841ed0d0fc$require$_interopRequireDefault((parcelRequire("cJgE8")));

var $g3XLf = parcelRequire("g3XLf");

var $ayMG0 = parcelRequire("ayMG0");
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5a1e9a841ed0d0fc$var$_composeClasses.default)(slots, $g3XLf.getPopperUtilityClass, classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $5a1e9a841ed0d0fc$var$React.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $5a1e9a841ed0d0fc$var$React.useRef(null);
    const ownRef = (0, $5a1e9a841ed0d0fc$var$_useForkRef.default)(tooltipRef, forwardedRef);
    const popperRef = $5a1e9a841ed0d0fc$var$React.useRef(null);
    const handlePopperRef = (0, $5a1e9a841ed0d0fc$var$_useForkRef.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $5a1e9a841ed0d0fc$var$React.useRef(handlePopperRef);
    (0, $5a1e9a841ed0d0fc$var$_useEnhancedEffect.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $5a1e9a841ed0d0fc$var$React.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $5a1e9a841ed0d0fc$var$React.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $5a1e9a841ed0d0fc$var$React.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $5a1e9a841ed0d0fc$var$React.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $5a1e9a841ed0d0fc$var$React.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $5a1e9a841ed0d0fc$var$_useEnhancedEffect.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $5a1e9a841ed0d0fc$var$_useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $5a1e9a841ed0d0fc$var$React.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $5a1e9a841ed0d0fc$var$React.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $5a1e9a841ed0d0fc$var$_ownerDocument.default)(resolvedAnchorEl).body : (0, $5a1e9a841ed0d0fc$var$_ownerDocument.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$_Portal.default, {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $5a1e9a841ed0d0fc$var$_default = module.exports.default = $5a1e9a841ed0d0fc$var$Popper;

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("839K0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5dc628ec8311fc9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5dc628ec8311fc9a$var$_useSlotProps.default;
    }
});

var $5dc628ec8311fc9a$var$_useSlotProps = $5dc628ec8311fc9a$require$_interopRequireDefault((parcelRequire("jjoya")));

});
parcelRegister("jjoya", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e0f2d5c8a2ef3c7f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0f2d5c8a2ef3c7f$var$_useForkRef = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $e0f2d5c8a2ef3c7f$var$_appendOwnerState = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("fByHY")));

var $e0f2d5c8a2ef3c7f$var$_mergeSlotProps = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("dfy9C")));

var $e0f2d5c8a2ef3c7f$var$_resolveComponentProps = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("jzekU")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $e0f2d5c8a2ef3c7f$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $e0f2d5c8a2ef3c7f$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $e0f2d5c8a2ef3c7f$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $e0f2d5c8a2ef3c7f$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $e0f2d5c8a2ef3c7f$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $e0f2d5c8a2ef3c7f$var$_default = module.exports.default = $e0f2d5c8a2ef3c7f$var$useSlotProps;

});


parcelRegister("g3XLf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bb1b487b0ea8f7b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPopperUtilityClass = $bb1b487b0ea8f7b1$var$getPopperUtilityClass;

var $bb1b487b0ea8f7b1$var$_generateUtilityClasses = $bb1b487b0ea8f7b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $bb1b487b0ea8f7b1$var$_generateUtilityClass = $bb1b487b0ea8f7b1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $bb1b487b0ea8f7b1$var$getPopperUtilityClass(slot) {
    return (0, $bb1b487b0ea8f7b1$var$_generateUtilityClass.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $bb1b487b0ea8f7b1$var$_generateUtilityClasses.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$var$_default = module.exports.default = $bb1b487b0ea8f7b1$var$popperClasses;

});




parcelRegister("eVjpW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $add5737403c6a16a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTooltipUtilityClass = $add5737403c6a16a$var$getTooltipUtilityClass;

var $add5737403c6a16a$var$_generateUtilityClasses = $add5737403c6a16a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $add5737403c6a16a$var$_generateUtilityClass = $add5737403c6a16a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $add5737403c6a16a$var$getTooltipUtilityClass(slot) {
    return (0, $add5737403c6a16a$var$_generateUtilityClass.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $add5737403c6a16a$var$_generateUtilityClasses.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$var$_default = module.exports.default = $add5737403c6a16a$var$tooltipClasses;

});



parcelRegister("7tqxO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $570fd50501d08ed5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $570fd50501d08ed5$var$_createSvgIcon = $570fd50501d08ed5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $570fd50501d08ed5$var$_default = module.exports.default = (0, $570fd50501d08ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

});

parcelRegister("c3r8Q", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8c6ad197f63b3f3e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $8c6ad197f63b3f3e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = module.exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');

});

parcelRegister("a1rcD", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $74bf1943d3532cc6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74bf1943d3532cc6$var$_createSvgIcon = $74bf1943d3532cc6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $74bf1943d3532cc6$var$_default = module.exports.default = (0, $74bf1943d3532cc6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 9v10H8V9zm-1.5-6h-5l-1 1H5v2h14V4h-3.5zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2z"
}), 'DeleteOutlined');

});

parcelRegister("9wvX1", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $6eefe30025c8ad9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6eefe30025c8ad9a$var$_createSvgIcon = $6eefe30025c8ad9a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6eefe30025c8ad9a$var$_default = module.exports.default = (0, $6eefe30025c8ad9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');

});

parcelRegister("dqlTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9c5eb05f9740712a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $9c5eb05f9740712a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = module.exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("b2c6k", function(module, exports) {
/**
 * @mui/x-data-grid v8.27.4
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $808944a671b11c1c$var$_exportNames = {
    useGridApiContext: true,
    useGridApiRef: true,
    useGridRootProps: true,
    GridColumnHeaders: true,
    GridColumnMenu: true,
    GRID_COLUMN_MENU_SLOTS: true,
    GRID_COLUMN_MENU_SLOT_PROPS: true
};
Object.defineProperty(module.exports, "GRID_COLUMN_MENU_SLOTS", {
    enumerable: true,
    get: function() {
        return $4IPMC.GRID_COLUMN_MENU_SLOTS;
    }
});
Object.defineProperty(module.exports, "GRID_COLUMN_MENU_SLOT_PROPS", {
    enumerable: true,
    get: function() {
        return $4IPMC.GRID_COLUMN_MENU_SLOT_PROPS;
    }
});
Object.defineProperty(module.exports, "GridColumnHeaders", {
    enumerable: true,
    get: function() {
        return $sLaj5.GridColumnHeaders;
    }
});
Object.defineProperty(module.exports, "GridColumnMenu", {
    enumerable: true,
    get: function() {
        return $4IPMC.GridColumnMenu;
    }
});
Object.defineProperty(module.exports, "useGridApiContext", {
    enumerable: true,
    get: function() {
        return $bDyDY.useGridApiContext;
    }
});
Object.defineProperty(module.exports, "useGridApiRef", {
    enumerable: true,
    get: function() {
        return $17r5z.useGridApiRef;
    }
});
Object.defineProperty(module.exports, "useGridRootProps", {
    enumerable: true,
    get: function() {
        return $jDpXp.useGridRootProps;
    }
});


var $bDyDY = parcelRequire("bDyDY");

var $17r5z = parcelRequire("17r5z");

var $jDpXp = parcelRequire("jDpXp");

var $5hhnM = parcelRequire("5hhnM");
Object.keys($5hhnM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5hhnM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5hhnM[key];
        }
    });
});

var $Lyax4 = parcelRequire("Lyax4");
Object.keys($Lyax4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $Lyax4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $Lyax4[key];
        }
    });
});

var $7jHEF = parcelRequire("7jHEF");
Object.keys($7jHEF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7jHEF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7jHEF[key];
        }
    });
});

var $1kYRD = parcelRequire("1kYRD");
Object.keys($1kYRD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1kYRD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1kYRD[key];
        }
    });
});

var $iAdzh = parcelRequire("iAdzh");
Object.keys($iAdzh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iAdzh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iAdzh[key];
        }
    });
});

var $42Qr7 = parcelRequire("42Qr7");
Object.keys($42Qr7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $42Qr7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $42Qr7[key];
        }
    });
});

var $lHSlE = parcelRequire("lHSlE");
Object.keys($lHSlE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lHSlE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lHSlE[key];
        }
    });
});

var $ehhGY = parcelRequire("ehhGY");
Object.keys($ehhGY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ehhGY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ehhGY[key];
        }
    });
});

var $2W9i3 = parcelRequire("2W9i3");
Object.keys($2W9i3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($808944a671b11c1c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2W9i3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2W9i3[key];
        }
    });
});

var $sLaj5 = parcelRequire("sLaj5");

var $4IPMC = parcelRequire("4IPMC");

});
parcelRegister("bDyDY", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $878e35c228656139$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridApiContext = $878e35c228656139$var$useGridApiContext;

var $878e35c228656139$var$React = $878e35c228656139$require$_interopRequireWildcard((parcelRequire("acw62")));

var $YSznt = parcelRequire("YSznt");
function $878e35c228656139$var$useGridApiContext() {
    const apiRef = $878e35c228656139$var$React.useContext($YSznt.GridApiContext);
    if (apiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return apiRef;
}

});
parcelRegister("YSznt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0b6fef1928293673$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridApiContext = void 0;

var $0b6fef1928293673$var$React = $0b6fef1928293673$require$_interopRequireWildcard((parcelRequire("acw62")));
const $0b6fef1928293673$var$GridApiContext = module.exports.GridApiContext = /*#__PURE__*/ $0b6fef1928293673$var$React.createContext(undefined);

});


parcelRegister("17r5z", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0d0b75328ed00f71$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridApiRef = void 0;

var $0d0b75328ed00f71$var$React = $0d0b75328ed00f71$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Hook that instantiate a [[GridApiRef]].
 */ const $0d0b75328ed00f71$var$useGridApiRef = ()=>$0d0b75328ed00f71$var$React.useRef(null);
module.exports.useGridApiRef = $0d0b75328ed00f71$var$useGridApiRef;

});

parcelRegister("jDpXp", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e4b5cb616f3aaa8a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRootProps = void 0;

var $e4b5cb616f3aaa8a$var$React = $e4b5cb616f3aaa8a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $96LtV = parcelRequire("96LtV");
const $e4b5cb616f3aaa8a$var$useGridRootProps = ()=>{
    const contextValue = $e4b5cb616f3aaa8a$var$React.useContext($96LtV.GridRootPropsContext);
    if (!contextValue) throw new Error('MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};
module.exports.useGridRootProps = $e4b5cb616f3aaa8a$var$useGridRootProps;

});
parcelRegister("96LtV", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6a19817c134c532b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRootPropsContext = void 0;

var $6a19817c134c532b$var$React = $6a19817c134c532b$require$_interopRequireWildcard((parcelRequire("acw62")));
const $6a19817c134c532b$var$GridRootPropsContext = module.exports.GridRootPropsContext = /*#__PURE__*/ $6a19817c134c532b$var$React.createContext(undefined);

});


parcelRegister("5hhnM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1J2kR = parcelRequire("1J2kR");
Object.keys($1J2kR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1J2kR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1J2kR[key];
        }
    });
});

});
parcelRegister("1J2kR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $141bce2f2738cba8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $141bce2f2738cba8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataGrid = void 0;

var $141bce2f2738cba8$var$_extends2 = $141bce2f2738cba8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $141bce2f2738cba8$var$React = $141bce2f2738cba8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $141bce2f2738cba8$var$_propTypes = $141bce2f2738cba8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $Lyax4 = parcelRequire("Lyax4");

var $5tnRA = parcelRequire("5tnRA");

var $8TaLs = parcelRequire("8TaLs");

var $6SlAg = parcelRequire("6SlAg");

var $8gdrr = parcelRequire("8gdrr");

var $NPScz = parcelRequire("NPScz");

var $eu7ae = parcelRequire("eu7ae");

var $5W2Ws = parcelRequire("5W2Ws");

var $hiKx5 = parcelRequire("hiKx5");


var $5LM2M = parcelRequire("5LM2M");

var $30tkX = parcelRequire("30tkX");

var $ayMG0 = parcelRequire("ayMG0");
const $141bce2f2738cba8$var$configuration = {
    hooks: {
        useCSSVariables: $5LM2M.useMaterialCSSVariables,
        useGridAriaAttributes: $5tnRA.useGridAriaAttributes,
        useGridRowAriaAttributes: $8TaLs.useGridRowAriaAttributes,
        useGridRowsOverridableMethods: $6SlAg.useGridRowsOverridableMethods,
        useGridParamsOverridableMethods: $8gdrr.useGridParamsOverridableMethods,
        useIsCellEditable: $NPScz.useIsCellEditable,
        useCellAggregationResult: ()=>null,
        useFilterValueGetter: (apiRef)=>apiRef.current.getRowValue
    }
};
const $141bce2f2738cba8$var$DataGridRaw = function DataGrid(inProps, ref) {
    const props = (0, $hiKx5.useDataGridProps)(inProps);
    const privateApiRef = (0, $30tkX.useGridApiInitialization)(props.apiRef, props);
    (0, $5W2Ws.useDataGridComponent)(privateApiRef, props, $141bce2f2738cba8$var$configuration);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eu7ae.GridContextProvider, {
        privateApiRef: privateApiRef,
        configuration: $141bce2f2738cba8$var$configuration,
        props: props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($Lyax4.GridRoot, (0, $141bce2f2738cba8$var$_extends2.default)({
            className: props.className,
            style: props.style,
            sx: props.sx
        }, props.slotProps?.root, {
            ref: ref
        }))
    });
};
/**
 * Features:
 * - [DataGrid](https://mui.com/x/react-data-grid/features/)
 *
 * API:
 * - [DataGrid API](https://mui.com/x/api/data-grid/data-grid/)
 */ const $141bce2f2738cba8$var$DataGrid = module.exports.DataGrid = /*#__PURE__*/ $141bce2f2738cba8$var$React.memo((0, $fYxgT.forwardRef)($141bce2f2738cba8$var$DataGridRaw));
$141bce2f2738cba8$var$DataGridRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: $141bce2f2738cba8$var$_propTypes.default.shape({
        current: $141bce2f2738cba8$var$_propTypes.default.object
    }),
    /**
   * The `aria-label` of the Data Grid.
   */ 'aria-label': $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * The `id` of the element containing a label for the Data Grid.
   */ 'aria-labelledby': $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */ autoHeight: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: $141bce2f2738cba8$var$_propTypes.default.shape({
        columns: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.string),
        disableColumnVirtualization: $141bce2f2738cba8$var$_propTypes.default.bool,
        expand: $141bce2f2738cba8$var$_propTypes.default.bool,
        includeHeaders: $141bce2f2738cba8$var$_propTypes.default.bool,
        includeOutliers: $141bce2f2738cba8$var$_propTypes.default.bool,
        outliersFactor: $141bce2f2738cba8$var$_propTypes.default.number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: $141bce2f2738cba8$var$_propTypes.default.object,
    className: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */ columnBufferPx: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering in the columns menu.
   * @default 150
   */ columnFilterDebounceMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */ columnGroupHeaderHeight: $141bce2f2738cba8$var$_propTypes.default.number,
    columnGroupingModel: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Set of columns of type [[GridColDef]][].
   */ columns: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.object).isRequired,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * The data source object.
   */ dataSource: $141bce2f2738cba8$var$_propTypes.default.shape({
        getRows: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        updateRow: $141bce2f2738cba8$var$_propTypes.default.func
    }),
    /**
   * Data source cache object.
   */ dataSourceCache: $141bce2f2738cba8$var$_propTypes.default.shape({
        clear: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        get: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        set: $141bce2f2738cba8$var$_propTypes.default.func.isRequired
    }),
    /**
   * If positive, the Data Grid will periodically revalidate data source rows by
   * re-fetching them from the server when the cache entry has expired.
   * Set to `0` to disable polling.
   * @default 0
   */ dataSourceRevalidateMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */ disableColumnSorting: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */ disableMultipleRowSelection: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the Data Grid will not use the exclude model optimization when selecting all rows.
   * @default false
   */ disableRowSelectionExcludeModel: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'cell',
        'row'
    ]),
    /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */ estimatedRowCount: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: $141bce2f2738cba8$var$_propTypes.default.shape({
        warnIfFocusStateIsNotSynced: $141bce2f2738cba8$var$_propTypes.default.bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'client',
        'server'
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: $141bce2f2738cba8$var$_propTypes.default.shape({
        items: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.shape({
            field: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
            id: $141bce2f2738cba8$var$_propTypes.default.oneOfType([
                $141bce2f2738cba8$var$_propTypes.default.number,
                $141bce2f2738cba8$var$_propTypes.default.string
            ]),
            operator: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
            value: $141bce2f2738cba8$var$_propTypes.default.any
        })).isRequired,
        logicOperator: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: $141bce2f2738cba8$var$_propTypes.default.bool,
        quickFilterLogicOperator: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: $141bce2f2738cba8$var$_propTypes.default.array
    }),
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Return the id of a given [[GridRowModel]].
   * Ensure the reference of this prop is stable to avoid performance implications.
   * It could be done by either defining the prop outside of the component or by memoizing it.
   */ getRowId: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ ignoreValueFormatterDuringExport: $141bce2f2738cba8$var$_propTypes.default.oneOfType([
        $141bce2f2738cba8$var$_propTypes.default.shape({
            clipboardExport: $141bce2f2738cba8$var$_propTypes.default.bool,
            csvExport: $141bce2f2738cba8$var$_propTypes.default.bool
        }),
        $141bce2f2738cba8$var$_propTypes.default.bool
    ]),
    /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */ isRowSelectable: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * The label of the Data Grid.
   * If the `showToolbar` prop is `true`, the label will be displayed in the toolbar and applied to the `aria-label` attribute of the grid.
   * If the `showToolbar` prop is `false`, the label will not be visible but will be applied to the `aria-label` attribute of the grid.
   */ label: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */ loading: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: $141bce2f2738cba8$var$_propTypes.default.shape({
        debug: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        error: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        info: $141bce2f2738cba8$var$_propTypes.default.func.isRequired,
        warn: $141bce2f2738cba8$var$_propTypes.default.func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: $141bce2f2738cba8$var$_propTypes.default.string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */ onColumnHeaderContextMenu: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a data source request fails.
   * @param {GridGetRowsError | GridUpdateRowError} error The data source error object.
   */ onDataSourceError: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */ onDensityChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */ onPaginationMetaChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback called when `processRowUpdate()` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.oneOfType([
        $141bce2f2738cba8$var$_propTypes.default.number,
        $141bce2f2738cba8$var$_propTypes.default.shape({
            label: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
            value: $141bce2f2738cba8$var$_propTypes.default.number.isRequired
        })
    ]).isRequired),
    pagination: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        true
    ]),
    /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */ paginationMeta: $141bce2f2738cba8$var$_propTypes.default.shape({
        hasNextPage: $141bce2f2738cba8$var$_propTypes.default.bool
    }),
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: $141bce2f2738cba8$var$_propTypes.default.shape({
        page: $141bce2f2738cba8$var$_propTypes.default.number.isRequired,
        pageSize: $141bce2f2738cba8$var$_propTypes.default.number.isRequired
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: $141bce2f2738cba8$var$_propTypes.default.func,
    /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */ resizeThrottleMs: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */ rowBufferPx: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */ rowCount: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */ rows: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.object),
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: $141bce2f2738cba8$var$_propTypes.default/* @typescript-to-proptypes-ignore */ .shape({
        ids: $141bce2f2738cba8$var$_propTypes.default.instanceOf(Set).isRequired,
        type: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'exclude',
            'include'
        ]).isRequired
    }),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'border',
        'margin'
    ]),
    /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */ rowSpanning: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: $141bce2f2738cba8$var$_propTypes.default.number,
    /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */ showCellVerticalBorder: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */ showColumnVerticalBorder: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * If `true`, the toolbar is displayed.
   * @default false
   */ showToolbar: $141bce2f2738cba8$var$_propTypes.default.bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Overridable components.
   */ slots: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: $141bce2f2738cba8$var$_propTypes.default.oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.shape({
        field: $141bce2f2738cba8$var$_propTypes.default.string.isRequired,
        sort: $141bce2f2738cba8$var$_propTypes.default.oneOf([
            'asc',
            'desc'
        ])
    })),
    style: $141bce2f2738cba8$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $141bce2f2738cba8$var$_propTypes.default.oneOfType([
        $141bce2f2738cba8$var$_propTypes.default.arrayOf($141bce2f2738cba8$var$_propTypes.default.oneOfType([
            $141bce2f2738cba8$var$_propTypes.default.func,
            $141bce2f2738cba8$var$_propTypes.default.object,
            $141bce2f2738cba8$var$_propTypes.default.bool
        ])),
        $141bce2f2738cba8$var$_propTypes.default.func,
        $141bce2f2738cba8$var$_propTypes.default.object
    ]),
    /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */ virtualizeColumnsWithAutoRowHeight: $141bce2f2738cba8$var$_propTypes.default.bool
};

});
parcelRegister("fYxgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $XSDP3 = parcelRequire("XSDP3");
Object.keys($XSDP3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $XSDP3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $XSDP3[key];
        }
    });
});

});
parcelRegister("XSDP3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0b3fe56d0e4918e1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0b3fe56d0e4918e1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forwardRef = void 0;

var $0b3fe56d0e4918e1$var$React = $0b3fe56d0e4918e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0b3fe56d0e4918e1$var$_reactMajor = $0b3fe56d0e4918e1$require$_interopRequireDefault((parcelRequire("eKs5z")));
// Compatibility shim that ensures stable props object for forwardRef components
// Fixes https://github.com/facebook/react/issues/31613
// We ensure that the ref is always present in the props object (even if that's not the case for older versions of React) to avoid the footgun of spreading props over the ref in the newer versions of React.
// Footgun: <Component ref={ref} {...props} /> will break past React 19, but the types will now warn us that we should use <Component {...props} ref={ref} /> instead.
const $0b3fe56d0e4918e1$var$forwardRef = (render)=>{
    if ($0b3fe56d0e4918e1$var$_reactMajor.default >= 19) {
        const Component = (props)=>render(props, props.ref ?? null);
        Component.displayName = render.displayName ?? render.name;
        return Component;
    }
    return /*#__PURE__*/ $0b3fe56d0e4918e1$var$React.forwardRef(render);
};
module.exports.forwardRef = $0b3fe56d0e4918e1$var$forwardRef;

});
parcelRegister("eKs5z", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $abcb26696ab6da01$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abcb26696ab6da01$var$React = $abcb26696ab6da01$require$_interopRequireWildcard((parcelRequire("acw62")));
var $abcb26696ab6da01$var$_default = module.exports.default = parseInt($abcb26696ab6da01$var$React.version, 10);

});



parcelRegister("Lyax4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $08eee520e810d520$var$_exportNames = {
    GridPagination: true
};
Object.defineProperty(module.exports, "GridPagination", {
    enumerable: true,
    get: function() {
        return $fuqu4.GridPagination;
    }
});

var $kjNGZ = parcelRequire("kjNGZ");
Object.keys($kjNGZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kjNGZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kjNGZ[key];
        }
    });
});

var $721t2 = parcelRequire("721t2");
Object.keys($721t2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $721t2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $721t2[key];
        }
    });
});

var $l5ITy = parcelRequire("l5ITy");
Object.keys($l5ITy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $l5ITy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l5ITy[key];
        }
    });
});

var $9cGVj = parcelRequire("9cGVj");
Object.keys($9cGVj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9cGVj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9cGVj[key];
        }
    });
});

var $8fd6O = parcelRequire("8fd6O");
Object.keys($8fd6O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8fd6O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8fd6O[key];
        }
    });
});

var $fWql6 = parcelRequire("fWql6");
Object.keys($fWql6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fWql6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fWql6[key];
        }
    });
});

var $famrf = parcelRequire("famrf");
Object.keys($famrf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $famrf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $famrf[key];
        }
    });
});

var $b2LZd = parcelRequire("b2LZd");
Object.keys($b2LZd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b2LZd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b2LZd[key];
        }
    });
});

var $54yWP = parcelRequire("54yWP");
Object.keys($54yWP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $54yWP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $54yWP[key];
        }
    });
});

var $iPqov = parcelRequire("iPqov");
Object.keys($iPqov).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iPqov[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iPqov[key];
        }
    });
});

var $YSznt = parcelRequire("YSznt");
Object.keys($YSznt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $YSznt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $YSznt[key];
        }
    });
});

var $jIkp9 = parcelRequire("jIkp9");
Object.keys($jIkp9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jIkp9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jIkp9[key];
        }
    });
});

var $hHwPs = parcelRequire("hHwPs");
Object.keys($hHwPs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hHwPs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hHwPs[key];
        }
    });
});

var $4YSVE = parcelRequire("4YSVE");
Object.keys($4YSVE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4YSVE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4YSVE[key];
        }
    });
});

var $28JSg = parcelRequire("28JSg");
Object.keys($28JSg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $28JSg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $28JSg[key];
        }
    });
});

var $7Mzkc = parcelRequire("7Mzkc");
Object.keys($7Mzkc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7Mzkc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Mzkc[key];
        }
    });
});

var $fuqu4 = parcelRequire("fuqu4");

var $l3iPY = parcelRequire("l3iPY");
Object.keys($l3iPY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $l3iPY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l3iPY[key];
        }
    });
});

var $kWPQR = parcelRequire("kWPQR");
Object.keys($kWPQR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kWPQR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kWPQR[key];
        }
    });
});

var $fNKx6 = parcelRequire("fNKx6");
Object.keys($fNKx6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fNKx6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fNKx6[key];
        }
    });
});

var $7Rjhy = parcelRequire("7Rjhy");
Object.keys($7Rjhy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7Rjhy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Rjhy[key];
        }
    });
});

var $kRqcm = parcelRequire("kRqcm");
Object.keys($kRqcm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kRqcm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kRqcm[key];
        }
    });
});

var $gQzuM = parcelRequire("gQzuM");
Object.keys($gQzuM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gQzuM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gQzuM[key];
        }
    });
});

var $dFywN = parcelRequire("dFywN");
Object.keys($dFywN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dFywN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dFywN[key];
        }
    });
});

var $6qO8T = parcelRequire("6qO8T");
Object.keys($6qO8T).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6qO8T[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6qO8T[key];
        }
    });
});

var $fuO2w = parcelRequire("fuO2w");
Object.keys($fuO2w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($08eee520e810d520$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fuO2w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fuO2w[key];
        }
    });
});

});
parcelRegister("kjNGZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kL0ag = parcelRequire("kL0ag");
Object.keys($kL0ag).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kL0ag[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kL0ag[key];
        }
    });
});

var $ew3Bl = parcelRequire("ew3Bl");
Object.keys($ew3Bl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ew3Bl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ew3Bl[key];
        }
    });
});

});
parcelRegister("kL0ag", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GridBody", {
    enumerable: true,
    get: function() {
        return $1etk0.GridVirtualScroller;
    }
});

var $1etk0 = parcelRequire("1etk0");

});
parcelRegister("1etk0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0e5dd7e9e576a614$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0e5dd7e9e576a614$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridVirtualScroller = $0e5dd7e9e576a614$var$GridVirtualScroller;

var $0e5dd7e9e576a614$var$_extends2 = $0e5dd7e9e576a614$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0e5dd7e9e576a614$var$React = $0e5dd7e9e576a614$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $0e5dd7e9e576a614$var$_composeClasses = $0e5dd7e9e576a614$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $61HyH = parcelRequire("61HyH");

var $eFlT8 = parcelRequire("eFlT8");

var $575FW = parcelRequire("575FW");

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $5H1vo = parcelRequire("5H1vo");

var $dDKMM = parcelRequire("dDKMM");

var $dS4gY = parcelRequire("dS4gY");

var $kcb79 = parcelRequire("kcb79");

var $8yMKs = parcelRequire("8yMKs");

var $lLmsJ = parcelRequire("lLmsJ");

var $a8jkJ = parcelRequire("a8jkJ");

var $5v0S6 = parcelRequire("5v0S6");

var $cv3bf = parcelRequire("cv3bf");

var $5qaTL = parcelRequire("5qaTL");

var $6ru7t = parcelRequire("6ru7t");

var $7IHuX = parcelRequire("7IHuX");

var $ayMG0 = parcelRequire("ayMG0");
const $0e5dd7e9e576a614$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hasScrollX: hasScrollX, hasPinnedRight: hasPinnedRight, loadingOverlayVariant: loadingOverlayVariant, overlayType: overlayType } = ownerState;
    const hideContent = loadingOverlayVariant === 'skeleton' || overlayType === 'noColumnsOverlay';
    const slots = {
        root: [
            'main',
            hasPinnedRight && 'main--hasPinnedRight',
            hideContent && 'main--hiddenContent'
        ],
        scroller: [
            'virtualScroller',
            hasScrollX && 'virtualScroller--hasScrollX'
        ]
    };
    return (0, $0e5dd7e9e576a614$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $0e5dd7e9e576a614$var$Scroller = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScroller,
            ownerState.hasScrollX && styles['virtualScroller--hasScrollX']
        ];
    }
})({
    position: 'relative',
    height: '100%',
    flexGrow: 1,
    overflow: 'scroll',
    scrollbarWidth: 'none' /* Firefox */ ,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        display: 'none' /* Safari and Chrome */ 
    },
    '@media print': {
        overflow: 'hidden'
    },
    // See https://github.com/mui/mui-x/issues/10547
    zIndex: 0
});
const $0e5dd7e9e576a614$var$hasPinnedRightSelector = (apiRef)=>apiRef.current.state.dimensions.rightPinnedWidth > 0;
function $0e5dd7e9e576a614$var$GridVirtualScroller(props) {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const hasScrollY = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridHasScrollYSelector);
    const hasScrollX = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridHasScrollXSelector);
    const hasPinnedRight = (0, $5sOMZ.useGridSelector)(apiRef, $0e5dd7e9e576a614$var$hasPinnedRightSelector);
    const hasBottomFiller = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridHasBottomFillerSelector);
    const { overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant } = (0, $dDKMM.useGridOverlays)(apiRef, rootProps);
    const Overlay = rootProps.slots?.[overlayType];
    const ownerState = {
        classes: rootProps.classes,
        hasScrollX: hasScrollX,
        hasPinnedRight: hasPinnedRight,
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
    const classes = $0e5dd7e9e576a614$var$useUtilityClasses(ownerState);
    const virtualScroller = (0, $7IHuX.useGridVirtualizer)().api.getters;
    const { getContainerProps: getContainerProps, getScrollerProps: getScrollerProps, getContentProps: getContentProps, getPositionerProps: getPositionerProps, getScrollbarVerticalProps: getScrollbarVerticalProps, getScrollbarHorizontalProps: getScrollbarHorizontalProps, getRows: getRows, getScrollAreaProps: getScrollAreaProps } = virtualScroller;
    const rows = getRows(undefined, (0, $eFlT8.gridRowTreeSelector)(apiRef));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($kcb79.GridMainContainer, (0, $0e5dd7e9e576a614$var$_extends2.default)({
        className: classes.root
    }, getContainerProps(), {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($575FW.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "left"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)($575FW.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "right"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)($575FW.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "up"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsx)($575FW.GridScrollArea, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                scrollDirection: "down"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$Scroller, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                className: classes.scroller
            }, getScrollerProps(), {
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($8yMKs.GridTopContainer, {
                        children: [
                            !rootProps.listView && /*#__PURE__*/ (0, $ayMG0.jsx)($dS4gY.GridHeaders, {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pinnedRows, {
                                position: "top",
                                virtualScroller: virtualScroller
                            })
                        ]
                    }),
                    overlayType && /*#__PURE__*/ (0, $ayMG0.jsx)($6ru7t.GridOverlayWrapper, {
                        overlayType: overlayType,
                        loadingOverlayVariant: loadingOverlayVariant,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Overlay, (0, $0e5dd7e9e576a614$var$_extends2.default)({}, rootProps.slotProps?.[overlayType]))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($lLmsJ.GridVirtualScrollerContent, (0, $0e5dd7e9e576a614$var$_extends2.default)({}, getContentProps(), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($5v0S6.GridVirtualScrollerRenderZone, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                            role: "rowgroup"
                        }, getPositionerProps(), {
                            children: [
                                rows,
                                /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.detailPanels, {
                                    virtualScroller: virtualScroller
                                })
                            ]
                        }))
                    })),
                    hasBottomFiller && /*#__PURE__*/ (0, $ayMG0.jsx)($a8jkJ.GridVirtualScrollerFiller, {
                        rowsLength: rows.length
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.bottomContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pinnedRows, {
                            position: "bottom",
                            virtualScroller: virtualScroller
                        })
                    })
                ]
            })),
            hasScrollX && /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$React.Fragment, {
                children: [
                    rootProps.pinnedColumnsSectionSeparator?.endsWith('shadow') && /*#__PURE__*/ (0, $ayMG0.jsx)($5qaTL.GridScrollShadows, {
                        position: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cv3bf.GridVirtualScrollbar, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                        position: "horizontal"
                    }, getScrollbarHorizontalProps()))
                ]
            }),
            hasScrollY && /*#__PURE__*/ (0, $ayMG0.jsxs)($0e5dd7e9e576a614$var$React.Fragment, {
                children: [
                    rootProps.pinnedRowsSectionSeparator?.endsWith('shadow') && /*#__PURE__*/ (0, $ayMG0.jsx)($5qaTL.GridScrollShadows, {
                        position: "vertical"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cv3bf.GridVirtualScrollbar, (0, $0e5dd7e9e576a614$var$_extends2.default)({
                        position: "vertical"
                    }, getScrollbarVerticalProps()))
                ]
            }),
            hasScrollX && hasScrollY && /*#__PURE__*/ (0, $ayMG0.jsx)($cv3bf.ScrollbarCorner, {
                "aria-hidden": "true"
            }),
            props.children
        ]
    }));
}

});
parcelRegister("61HyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridVerticalScrollbarWidthSelector = module.exports.gridRowHeightSelector = module.exports.gridHorizontalScrollbarHeightSelector = module.exports.gridHeaderHeightSelector = module.exports.gridHeaderFilterHeightSelector = module.exports.gridHasScrollYSelector = module.exports.gridHasScrollXSelector = module.exports.gridHasFillerSelector = module.exports.gridHasBottomFillerSelector = module.exports.gridGroupHeaderHeightSelector = module.exports.gridDimensionsSelector = module.exports.gridContentHeightSelector = module.exports.gridColumnsTotalWidthSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $46349fe7fabb2b4d$var$gridDimensionsSelector = module.exports.gridDimensionsSelector = (0, $cgQ4y.createRootSelector)((state)=>state.dimensions);
/**
 * Get the summed width of all the visible columns.
 * @category Visible Columns
 */ const $46349fe7fabb2b4d$var$gridColumnsTotalWidthSelector = module.exports.gridColumnsTotalWidthSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.columnsTotalWidth);
const $46349fe7fabb2b4d$var$gridRowHeightSelector = module.exports.gridRowHeightSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.rowHeight);
const $46349fe7fabb2b4d$var$gridContentHeightSelector = module.exports.gridContentHeightSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.contentSize.height);
const $46349fe7fabb2b4d$var$gridHasScrollXSelector = module.exports.gridHasScrollXSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollX);
const $46349fe7fabb2b4d$var$gridHasScrollYSelector = module.exports.gridHasScrollYSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollY);
const $46349fe7fabb2b4d$var$gridHasFillerSelector = module.exports.gridHasFillerSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width);
const $46349fe7fabb2b4d$var$gridHeaderHeightSelector = module.exports.gridHeaderHeightSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.headerHeight);
const $46349fe7fabb2b4d$var$gridGroupHeaderHeightSelector = module.exports.gridGroupHeaderHeightSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.groupHeaderHeight);
const $46349fe7fabb2b4d$var$gridHeaderFilterHeightSelector = module.exports.gridHeaderFilterHeightSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.headerFilterHeight);
const $46349fe7fabb2b4d$var$gridHorizontalScrollbarHeightSelector = module.exports.gridHorizontalScrollbarHeightSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
const $46349fe7fabb2b4d$var$gridVerticalScrollbarWidthSelector = module.exports.gridVerticalScrollbarWidthSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, (dimensions)=>dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
const $46349fe7fabb2b4d$var$gridHasBottomFillerSelector = module.exports.gridHasBottomFillerSelector = (0, $cgQ4y.createSelector)($46349fe7fabb2b4d$var$gridDimensionsSelector, $46349fe7fabb2b4d$var$gridHorizontalScrollbarHeightSelector, (dimensions, height)=>{
    const needsLastRowBorder = dimensions.viewportOuterSize.height - dimensions.minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return false;
    return true;
});

});
parcelRegister("cgQ4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSelectorMemoized = module.exports.createSelector = module.exports.createRootSelector = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $8eef5f2af445e503$var$createSelector = (...args)=>{
    const baseSelector = (0, $8P0MD.createSelector)(...args);
    const selector = (apiRef, a1, a2, a3)=>baseSelector($8eef5f2af445e503$var$unwrapIfNeeded(apiRef), a1, a2, a3);
    return selector;
};
module.exports.createSelector = $8eef5f2af445e503$var$createSelector;
const $8eef5f2af445e503$var$createSelectorMemoized = (...args)=>{
    const baseSelector = (0, $8P0MD.createSelectorMemoized)(...args);
    const selector = (apiRef, a1, a2, a3)=>baseSelector($8eef5f2af445e503$var$unwrapIfNeeded(apiRef), a1, a2, a3);
    return selector;
};
/**
 * Used to create the root selector for a feature. It assumes that the state is already initialized
 * and strips from the types the possibility of `apiRef` being `null`.
 * Users are warned about this in our documentation https://mui.com/x/react-data-grid/state/#direct-selector-access
 */ module.exports.createSelectorMemoized = $8eef5f2af445e503$var$createSelectorMemoized;
const $8eef5f2af445e503$var$createRootSelector = (fn)=>(apiRef, args)=>fn($8eef5f2af445e503$var$unwrapIfNeeded(apiRef), args);
module.exports.createRootSelector = $8eef5f2af445e503$var$createRootSelector;
function $8eef5f2af445e503$var$unwrapIfNeeded(refOrState) {
    if ('current' in refOrState) return refOrState.current.state;
    return refOrState;
}

});
parcelRegister("8P0MD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fpQ5K = parcelRequire("fpQ5K");
Object.keys($fpQ5K).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fpQ5K[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fpQ5K[key];
        }
    });
});

var $fUNcs = parcelRequire("fUNcs");
Object.keys($fUNcs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fUNcs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fUNcs[key];
        }
    });
});

var $1P7mS = parcelRequire("1P7mS");
Object.keys($1P7mS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1P7mS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1P7mS[key];
        }
    });
});

var $ebxov = parcelRequire("ebxov");
Object.keys($ebxov).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ebxov[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ebxov[key];
        }
    });
});

});
parcelRegister("fpQ5K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSelectorMemoizedWithOptions = module.exports.createSelectorMemoized = module.exports.createSelector = void 0;

var $4KtEQ = parcelRequire("4KtEQ");
/* eslint-disable no-underscore-dangle */ // __cacheKey__
const $b3919923ab8efcb8$var$reselectCreateSelector = (0, $4KtEQ.createSelectorCreator)({
    memoize: $4KtEQ.lruMemoize,
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
/* eslint-disable id-denylist */ const $b3919923ab8efcb8$var$createSelector = (a, b, c, d, e, f, g, h, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    if (a && b && c && d && e && f && g && h) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        const vf = f(state, a1, a2, a3);
        const vg = g(state, a1, a2, a3);
        return h(va, vb, vc, vd, ve, vf, vg, a1, a2, a3);
    };
    else if (a && b && c && d && e && f && g) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        const vf = f(state, a1, a2, a3);
        return g(va, vb, vc, vd, ve, vf, a1, a2, a3);
    };
    else if (a && b && c && d && e && f) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        return f(va, vb, vc, vd, ve, a1, a2, a3);
    };
    else if (a && b && c && d && e) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        return e(va, vb, vc, vd, a1, a2, a3);
    };
    else if (a && b && c && d) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        return d(va, vb, vc, a1, a2, a3);
    };
    else if (a && b && c) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        return c(va, vb, a1, a2, a3);
    };
    else if (a && b) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        return b(va, a1, a2, a3);
    };
    else if (a) selector = a;
    else throw new Error('Missing arguments');
    return selector;
};
/* eslint-enable id-denylist */ module.exports.createSelector = $b3919923ab8efcb8$var$createSelector;
const $b3919923ab8efcb8$var$createSelectorMemoizedWithOptions = (options)=>(...inputs)=>{
        const cache = new WeakMap();
        let nextCacheId = 1;
        const combiner = inputs[inputs.length - 1];
        const nSelectors = inputs.length - 1 || 1;
        // (s1, s2, ..., sN, a1, a2, a3) => { ... }
        const argsLength = Math.max(combiner.length - nSelectors, 0);
        if (argsLength > 3) throw new Error('Unsupported number of arguments');
        // prettier-ignore
        const selector = (state, a1, a2, a3)=>{
            let cacheKey = state.__cacheKey__;
            if (!cacheKey) {
                cacheKey = {
                    id: nextCacheId
                };
                state.__cacheKey__ = cacheKey;
                nextCacheId += 1;
            }
            let fn = cache.get(cacheKey);
            if (!fn) {
                const selectors = inputs.length === 1 ? [
                    (x)=>x,
                    combiner
                ] : inputs;
                let reselectArgs = inputs;
                const selectorArgs = [
                    undefined,
                    undefined,
                    undefined
                ];
                switch(argsLength){
                    case 0:
                        break;
                    case 1:
                        reselectArgs = [
                            ...selectors.slice(0, -1),
                            ()=>selectorArgs[0],
                            combiner
                        ];
                        break;
                    case 2:
                        reselectArgs = [
                            ...selectors.slice(0, -1),
                            ()=>selectorArgs[0],
                            ()=>selectorArgs[1],
                            combiner
                        ];
                        break;
                    case 3:
                        reselectArgs = [
                            ...selectors.slice(0, -1),
                            ()=>selectorArgs[0],
                            ()=>selectorArgs[1],
                            ()=>selectorArgs[2],
                            combiner
                        ];
                        break;
                    default:
                        throw new Error('Unsupported number of arguments');
                }
                if (options) reselectArgs = [
                    ...reselectArgs,
                    options
                ];
                fn = $b3919923ab8efcb8$var$reselectCreateSelector(...reselectArgs);
                fn.selectorArgs = selectorArgs;
                cache.set(cacheKey, fn);
            }
            /* eslint-disable no-fallthrough */ switch(argsLength){
                case 3:
                    fn.selectorArgs[2] = a3;
                case 2:
                    fn.selectorArgs[1] = a2;
                case 1:
                    fn.selectorArgs[0] = a1;
                case 0:
                default:
            }
            switch(argsLength){
                case 0:
                    return fn(state);
                case 1:
                    return fn(state, a1);
                case 2:
                    return fn(state, a1, a2);
                case 3:
                    return fn(state, a1, a2, a3);
                default:
                    throw new Error('unreachable');
            }
        };
        return selector;
    };
module.exports.createSelectorMemoizedWithOptions = $b3919923ab8efcb8$var$createSelectorMemoizedWithOptions;
const $b3919923ab8efcb8$var$createSelectorMemoized = module.exports.createSelectorMemoized = $b3919923ab8efcb8$var$createSelectorMemoizedWithOptions();

});
parcelRegister("4KtEQ", function(module, exports) {

$parcel$export(module.exports, "lruMemoize", () => $375276bea32f9eda$export$d8ead1d92249919b);
$parcel$export(module.exports, "createSelectorCreator", () => $375276bea32f9eda$export$5943f4447f6ef248);
var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});

});


parcelRegister("fUNcs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b962400ee8aa786f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b962400ee8aa786f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useStore = $b962400ee8aa786f$var$useStore;

var $b962400ee8aa786f$var$React = $b962400ee8aa786f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $hfliI = parcelRequire("hfliI");

var $9b0Yv = parcelRequire("9b0Yv");

var $b962400ee8aa786f$var$_reactMajor = $b962400ee8aa786f$require$_interopRequireDefault((parcelRequire("eKs5z")));
/* We need to import the shim because React 17 does not support the `useSyncExternalStore` API.
 * More info: https://github.com/mui/mui-x/issues/18303#issuecomment-2958392341 */ /* Some tests fail in R18 with the raw useSyncExternalStore. It may be possible to make it work
 * but for now we only enable it for R19+. */ const $b962400ee8aa786f$var$canUseRawUseSyncExternalStore = $b962400ee8aa786f$var$_reactMajor.default >= 19;
const $b962400ee8aa786f$var$useStoreImplementation = $b962400ee8aa786f$var$canUseRawUseSyncExternalStore ? $b962400ee8aa786f$var$useStoreR19 : $b962400ee8aa786f$var$useStoreLegacy;
function $b962400ee8aa786f$var$useStore(store, selector, a1, a2, a3) {
    return $b962400ee8aa786f$var$useStoreImplementation(store, selector, a1, a2, a3);
}
function $b962400ee8aa786f$var$useStoreR19(store, selector, a1, a2, a3) {
    const getSelection = $b962400ee8aa786f$var$React.useCallback(()=>selector(store.getSnapshot(), a1, a2, a3), [
        store,
        selector,
        a1,
        a2,
        a3
    ]);
    return (0, $hfliI.useSyncExternalStore)(store.subscribe, getSelection, getSelection);
}
function $b962400ee8aa786f$var$useStoreLegacy(store, selector, a1, a2, a3) {
    return (0, $9b0Yv.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, (state)=>selector(state, a1, a2, a3));
}

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});


parcelRegister("9b0Yv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i5mAx"));

});
parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});



parcelRegister("1P7mS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $154044f791287af0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useStoreEffect = $154044f791287af0$var$useStoreEffect;

var $154044f791287af0$var$_useLazyRef = $154044f791287af0$require$_interopRequireDefault((parcelRequire("doV3C")));

var $154044f791287af0$var$_useOnMount = $154044f791287af0$require$_interopRequireDefault((parcelRequire("fGtMU")));
const $154044f791287af0$var$noop = ()=>{};
/**
 * An Effect implementation for the Store. This should be used for side-effects only. To
 * compute and store derived state, use `createSelectorMemoized` instead.
 */ function $154044f791287af0$var$useStoreEffect(store, selector, effect) {
    const instance = (0, $154044f791287af0$var$_useLazyRef.default)($154044f791287af0$var$initialize, {
        store: store,
        selector: selector
    }).current;
    instance.effect = effect;
    (0, $154044f791287af0$var$_useOnMount.default)(instance.onMount);
}
// `useLazyRef` typings are incorrect, `params` should not be optional
function $154044f791287af0$var$initialize(params) {
    const { store: store, selector: selector } = params;
    let previousState = selector(store.state);
    const instance = {
        effect: $154044f791287af0$var$noop,
        dispose: null,
        // We want a single subscription done right away and cleared on unmount only,
        // but React triggers `useOnMount` multiple times in dev, so we need to manage
        // the subscription anyway.
        subscribe: ()=>{
            instance.dispose ?? (instance.dispose = store.subscribe((state)=>{
                const nextState = selector(state);
                if (!Object.is(previousState, nextState)) {
                    const prev = previousState;
                    previousState = nextState;
                    instance.effect(prev, nextState);
                }
            }));
        },
        onMount: ()=>{
            instance.subscribe();
            return ()=>{
                instance.dispose?.();
                instance.dispose = null;
            };
        }
    };
    instance.subscribe();
    return instance;
}

});
parcelRegister("fGtMU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b6b1e281249837b9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b6b1e281249837b9$var$_useOnMount.default;
    }
});

var $b6b1e281249837b9$var$_useOnMount = $b6b1e281249837b9$require$_interopRequireDefault((parcelRequire("kWo5z")));

});


parcelRegister("ebxov", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a53bff302fde4700$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Store = void 0;

var $a53bff302fde4700$var$_extends2 = $a53bff302fde4700$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fUNcs = parcelRequire("fUNcs");
/* eslint-disable no-cond-assign */ class $a53bff302fde4700$var$Store {
    // HACK: `any` fixes adding listeners that accept partial state.
    // Internal state to handle recursive `setState()` calls
    static create(state) {
        return new $a53bff302fde4700$var$Store(state);
    }
    constructor(state){
        this.state = state;
        this.listeners = new Set();
        this.updateTick = 0;
    }
    subscribe = (fn)=>{
        this.listeners.add(fn);
        return ()=>{
            this.listeners.delete(fn);
        };
    };
    /**
   * Returns the current state snapshot. Meant for usage with `useSyncExternalStore`.
   * If you want to access the state, use the `state` property instead.
   */ getSnapshot = ()=>{
        return this.state;
    };
    setState(newState) {
        this.state = newState;
        this.updateTick += 1;
        const currentTick = this.updateTick;
        const it = this.listeners.values();
        let result;
        while(result = it.next(), !result.done){
            if (currentTick !== this.updateTick) // If the tick has changed, a recursive `setState` call has been made,
            // and it has already notified all listeners.
            return;
            const listener = result.value;
            listener(newState);
        }
    }
    update(changes) {
        for(const key in changes)if (!Object.is(this.state[key], changes[key])) {
            this.setState((0, $a53bff302fde4700$var$_extends2.default)({}, this.state, changes));
            return;
        }
    }
    set(key, value) {
        if (!Object.is(this.state[key], value)) this.setState((0, $a53bff302fde4700$var$_extends2.default)({}, this.state, {
            [key]: value
        }));
    }
    use = (selector, a1, a2, a3)=>{
        return (0, $fUNcs.useStore)(this, selector, a1, a2, a3);
    };
}
module.exports.Store = $a53bff302fde4700$var$Store;

});




parcelRegister("eFlT8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $aad5df8f504205b0$var$_exportNames = {
    gridRowCountSelector: true,
    gridRowsLoadingSelector: true,
    gridTopLevelRowCountSelector: true,
    gridRowsLookupSelector: true,
    gridRowTreeSelector: true,
    gridRowGroupingNameSelector: true,
    gridRowTreeDepthsSelector: true,
    gridRowMaximumTreeDepthSelector: true,
    gridDataRowIdsSelector: true,
    gridRowNodeSelector: true,
    gridRowSelector: true,
    GRID_ROOT_GROUP_ID: true,
    checkGridRowIdIsValid: true,
    isAutogeneratedRow: true
};
Object.defineProperty(module.exports, "GRID_ROOT_GROUP_ID", {
    enumerable: true,
    get: function() {
        return $7sDf4.GRID_ROOT_GROUP_ID;
    }
});
Object.defineProperty(module.exports, "checkGridRowIdIsValid", {
    enumerable: true,
    get: function() {
        return $7sDf4.checkGridRowIdIsValid;
    }
});
Object.defineProperty(module.exports, "gridDataRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridDataRowIdsSelector;
    }
});
Object.defineProperty(module.exports, "gridRowCountSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowCountSelector;
    }
});
Object.defineProperty(module.exports, "gridRowGroupingNameSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowGroupingNameSelector;
    }
});
Object.defineProperty(module.exports, "gridRowMaximumTreeDepthSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowMaximumTreeDepthSelector;
    }
});
Object.defineProperty(module.exports, "gridRowNodeSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowNodeSelector;
    }
});
Object.defineProperty(module.exports, "gridRowSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowSelector;
    }
});
Object.defineProperty(module.exports, "gridRowTreeDepthsSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowTreeDepthsSelector;
    }
});
Object.defineProperty(module.exports, "gridRowTreeSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowTreeSelector;
    }
});
Object.defineProperty(module.exports, "gridRowsLoadingSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowsLoadingSelector;
    }
});
Object.defineProperty(module.exports, "gridRowsLookupSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridRowsLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridTopLevelRowCountSelector", {
    enumerable: true,
    get: function() {
        return $goCyd.gridTopLevelRowCountSelector;
    }
});
Object.defineProperty(module.exports, "isAutogeneratedRow", {
    enumerable: true,
    get: function() {
        return $7sDf4.isAutogeneratedRow;
    }
});

var $bdqIg = parcelRequire("bdqIg");
Object.keys($bdqIg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($aad5df8f504205b0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bdqIg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bdqIg[key];
        }
    });
});

var $8SgvK = parcelRequire("8SgvK");
Object.keys($8SgvK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($aad5df8f504205b0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8SgvK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8SgvK[key];
        }
    });
});

var $goCyd = parcelRequire("goCyd");

var $7sDf4 = parcelRequire("7sDf4");

});
parcelRegister("bdqIg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridRowsMetaSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $82a5a13765976ef2$var$gridRowsMetaSelector = module.exports.gridRowsMetaSelector = (0, $cgQ4y.createRootSelector)((state)=>state.rowsMeta);

});

parcelRegister("8SgvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("goCyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridTopLevelRowCountSelector = module.exports.gridRowsStateSelector = module.exports.gridRowsLookupSelector = module.exports.gridRowsLoadingSelector = module.exports.gridRowTreeSelector = module.exports.gridRowTreeDepthsSelector = module.exports.gridRowSelector = module.exports.gridRowNodeSelector = module.exports.gridRowMaximumTreeDepthSelector = module.exports.gridRowGroupsToFetchSelector = module.exports.gridRowGroupingNameSelector = module.exports.gridRowCountSelector = module.exports.gridPinnedRowsSelector = module.exports.gridPinnedRowsCountSelector = module.exports.gridDataRowsSelector = module.exports.gridDataRowIdsSelector = module.exports.gridAdditionalRowGroupsSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $befccaa56b49492d$var$gridRowsStateSelector = module.exports.gridRowsStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.rows);
const $befccaa56b49492d$var$gridRowCountSelector = module.exports.gridRowCountSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalRowCount);
const $befccaa56b49492d$var$gridRowsLoadingSelector = module.exports.gridRowsLoadingSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.loading);
const $befccaa56b49492d$var$gridTopLevelRowCountSelector = module.exports.gridTopLevelRowCountSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
// TODO rows v6: Rename
const $befccaa56b49492d$var$gridRowsLookupSelector = module.exports.gridRowsLookupSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIdToModelLookup);
/**
 * @category Rows
 */ const $befccaa56b49492d$var$gridRowSelector = module.exports.gridRowSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsLookupSelector, (rows, id)=>rows[id]);
const $befccaa56b49492d$var$gridRowTreeSelector = module.exports.gridRowTreeSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.tree);
/**
 * @category Rows
 */ const $befccaa56b49492d$var$gridRowNodeSelector = module.exports.gridRowNodeSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowTreeSelector, (rowTree, rowId)=>rowTree[rowId]);
const $befccaa56b49492d$var$gridRowGroupsToFetchSelector = module.exports.gridRowGroupsToFetchSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupsToFetch);
const $befccaa56b49492d$var$gridRowGroupingNameSelector = module.exports.gridRowGroupingNameSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.groupingName);
const $befccaa56b49492d$var$gridRowTreeDepthsSelector = module.exports.gridRowTreeDepthsSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.treeDepths);
const $befccaa56b49492d$var$gridRowMaximumTreeDepthSelector = module.exports.gridRowMaximumTreeDepthSelector = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return (entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] ?? 0) + 1;
});
/**
 * @category Rows
 */ const $befccaa56b49492d$var$gridDataRowIdsSelector = module.exports.gridDataRowIdsSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows.dataRowIds);
const $befccaa56b49492d$var$gridDataRowsSelector = module.exports.gridDataRowsSelector = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$var$gridDataRowIdsSelector, $befccaa56b49492d$var$gridRowsLookupSelector, (dataRowIds, rowsLookup)=>dataRowIds.reduce((acc, id)=>{
        if (!rowsLookup[id]) return acc;
        acc.push(rowsLookup[id]);
        return acc;
    }, []));
/**
 * @ignore - do not document.
 */ const $befccaa56b49492d$var$gridAdditionalRowGroupsSelector = module.exports.gridAdditionalRowGroupsSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridRowsStateSelector, (rows)=>rows?.additionalRowGroups);
/**
 * @ignore - do not document.
 */ const $befccaa56b49492d$var$gridPinnedRowsSelector = module.exports.gridPinnedRowsSelector = (0, $cgQ4y.createSelectorMemoized)($befccaa56b49492d$var$gridAdditionalRowGroupsSelector, (additionalRowGroups)=>{
    const rawPinnedRows = additionalRowGroups?.pinnedRows;
    return {
        bottom: rawPinnedRows?.bottom?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? [],
        top: rawPinnedRows?.top?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? []
    };
});
/**
 * @ignore - do not document.
 */ const $befccaa56b49492d$var$gridPinnedRowsCountSelector = module.exports.gridPinnedRowsCountSelector = (0, $cgQ4y.createSelector)($befccaa56b49492d$var$gridPinnedRowsSelector, (pinnedRows)=>{
    return (pinnedRows?.top?.length || 0) + (pinnedRows?.bottom?.length || 0);
});

});

parcelRegister("7sDf4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0166dd44615cae0d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildRootGroup = module.exports.GRID_ROOT_GROUP_ID = module.exports.GRID_ID_AUTOGENERATED = void 0;
module.exports.checkGridRowIdIsValid = $0166dd44615cae0d$var$checkGridRowIdIsValid;
module.exports.computeRowsUpdates = $0166dd44615cae0d$var$computeRowsUpdates;
module.exports.updateCacheWithNewRows = module.exports.rowHeightWarning = module.exports.minimalContentHeight = module.exports.isAutogeneratedRowNode = module.exports.isAutogeneratedRow = module.exports.getValidRowHeight = module.exports.getTreeNodeDescendants = module.exports.getTopLevelRowCount = module.exports.getRowsStateFromCache = module.exports.getRowValue = module.exports.getRowIdFromRowModel = module.exports.getRowHeightWarning = module.exports.createRowsInternalCache = void 0;

var $0166dd44615cae0d$var$_extends2 = $0166dd44615cae0d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $goCyd = parcelRequire("goCyd");
const $0166dd44615cae0d$var$GRID_ROOT_GROUP_ID = module.exports.GRID_ROOT_GROUP_ID = `auto-generated-group-node-root`;
const $0166dd44615cae0d$var$GRID_ID_AUTOGENERATED = module.exports.GRID_ID_AUTOGENERATED = Symbol('mui.id_autogenerated');
const $0166dd44615cae0d$var$buildRootGroup = ()=>({
        type: 'group',
        id: $0166dd44615cae0d$var$GRID_ROOT_GROUP_ID,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
/**
 * A helper function to check if the id provided is valid.
 * @param {GridRowId} id Id as [[GridRowId]].
 * @param {GridRowModel | Partial<GridRowModel>} row Row as [[GridRowModel]].
 * @param {string} detailErrorMessage A custom error message to display for invalid IDs
 */ module.exports.buildRootGroup = $0166dd44615cae0d$var$buildRootGroup;
function $0166dd44615cae0d$var$checkGridRowIdIsValid(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI X: The Data Grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $0166dd44615cae0d$var$getRowIdFromRowModel = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $0166dd44615cae0d$var$checkGridRowIdIsValid(id, rowModel, detailErrorMessage);
    return id;
};
module.exports.getRowIdFromRowModel = $0166dd44615cae0d$var$getRowIdFromRowModel;
const $0166dd44615cae0d$var$getRowValue = (row, colDef, apiRef)=>{
    const field = colDef.field;
    if (!colDef || !colDef.valueGetter) return row[field];
    const value = row[colDef.field];
    return colDef.valueGetter(value, row, colDef, apiRef);
};
module.exports.getRowValue = $0166dd44615cae0d$var$getRowValue;
const $0166dd44615cae0d$var$createRowsInternalCache = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $0166dd44615cae0d$var$getRowIdFromRowModel(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
module.exports.createRowsInternalCache = $0166dd44615cae0d$var$createRowsInternalCache;
const $0166dd44615cae0d$var$getTopLevelRowCount = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$0166dd44615cae0d$var$GRID_ROOT_GROUP_ID];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
module.exports.getTopLevelRowCount = $0166dd44615cae0d$var$getTopLevelRowCount;
const $0166dd44615cae0d$var$getRowsStateFromCache = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths, previousGroupsToFetch: previousGroupsToFetch })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName, groupsToFetch: groupsToFetch = [] } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup,
        previousGroupsToFetch: previousGroupsToFetch
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $0166dd44615cae0d$var$_extends2.default)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $0166dd44615cae0d$var$getTopLevelRowCount({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp,
        groupsToFetch: groupsToFetch
    });
};
module.exports.getRowsStateFromCache = $0166dd44615cae0d$var$getRowsStateFromCache;
const $0166dd44615cae0d$var$isAutogeneratedRow = (row)=>$0166dd44615cae0d$var$GRID_ID_AUTOGENERATED in row;
module.exports.isAutogeneratedRow = $0166dd44615cae0d$var$isAutogeneratedRow;
const $0166dd44615cae0d$var$isAutogeneratedRowNode = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
module.exports.isAutogeneratedRowNode = $0166dd44615cae0d$var$isAutogeneratedRowNode;
const $0166dd44615cae0d$var$getTreeNodeDescendants = (tree, parentId, skipAutoGeneratedRows, directChildrenOnly)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$0166dd44615cae0d$var$isAutogeneratedRowNode(tree[child])) validDescendants.push(child);
        if (directChildrenOnly) continue;
        const childDescendants = $0166dd44615cae0d$var$getTreeNodeDescendants(tree, child, skipAutoGeneratedRows, directChildrenOnly);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
module.exports.getTreeNodeDescendants = $0166dd44615cae0d$var$getTreeNodeDescendants;
const $0166dd44615cae0d$var$updateCacheWithNewRows = ({ previousCache: previousCache, getRowId: getRowId, updates: updates, groupKeys: groupKeys })=>{
    if (previousCache.updates.type === 'full') throw new Error('MUI X: Unable to prepare a partial update if a full update is not applied yet.');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$var$getRowIdFromRowModel(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $0166dd44615cae0d$var$_extends2.default)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...previousCache.updates.actions.insert ?? []
            ],
            modify: [
                ...previousCache.updates.actions.modify ?? []
            ],
            remove: [
                ...previousCache.updates.actions.remove ?? []
            ]
        },
        idToActionLookup: (0, $0166dd44615cae0d$var$_extends2.default)({}, previousCache.updates.idToActionLookup),
        groupKeys: groupKeys
    };
    const dataRowIdToModelLookup = (0, $0166dd44615cae0d$var$_extends2.default)({}, previousCache.dataRowIdToModelLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $0166dd44615cae0d$var$_extends2.default)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
module.exports.updateCacheWithNewRows = $0166dd44615cae0d$var$updateCacheWithNewRows;
const $0166dd44615cae0d$var$minimalContentHeight = module.exports.minimalContentHeight = 'var(--DataGrid-overlayHeight, calc(var(--height) * 2))';
function $0166dd44615cae0d$var$computeRowsUpdates(apiRef, updates, getRowId) {
    const nonPinnedRowsUpdates = [];
    updates.forEach((update)=>{
        const id = $0166dd44615cae0d$var$getRowIdFromRowModel(update, getRowId, 'A row was provided without id when calling updateRows():');
        const rowNode = (0, $goCyd.gridRowNodeSelector)(apiRef, id);
        if (rowNode?.type === 'pinnedRow') {
            // @ts-ignore because otherwise `release:build` doesn't work
            const pinnedRowsCache = apiRef.current.caches.pinnedRows;
            const prevModel = pinnedRowsCache.idLookup[id];
            if (prevModel) pinnedRowsCache.idLookup[id] = (0, $0166dd44615cae0d$var$_extends2.default)({}, prevModel, update);
        } else nonPinnedRowsUpdates.push(update);
    });
    return nonPinnedRowsUpdates;
}
let $0166dd44615cae0d$var$warnedOnceInvalidRowHeight = false;
const $0166dd44615cae0d$var$getValidRowHeight = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
module.exports.getValidRowHeight = $0166dd44615cae0d$var$getValidRowHeight;
const $0166dd44615cae0d$var$rowHeightWarning = module.exports.rowHeightWarning = [
    `MUI X: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $0166dd44615cae0d$var$getRowHeightWarning = module.exports.getRowHeightWarning = [
    `MUI X: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');

});


parcelRegister("575FW", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3b92023a13ae6811$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3b92023a13ae6811$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridScrollArea = void 0;

var $3b92023a13ae6811$var$_extends2 = $3b92023a13ae6811$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3b92023a13ae6811$var$React = $3b92023a13ae6811$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3b92023a13ae6811$var$_useEventCallback = $3b92023a13ae6811$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $3b92023a13ae6811$var$_composeClasses = $3b92023a13ae6811$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $2nKmT = parcelRequire("2nKmT");

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $7jHEF = parcelRequire("7jHEF");

var $bDyDY = parcelRequire("bDyDY");

var $g8PwW = parcelRequire("g8PwW");

var $5sOMZ = parcelRequire("5sOMZ");

var $61HyH = parcelRequire("61HyH");

var $fD9f4 = parcelRequire("fD9f4");

var $5oDOG = parcelRequire("5oDOG");

var $i0LyH = parcelRequire("i0LyH");

var $cgQ4y = parcelRequire("cgQ4y");

var $bdqIg = parcelRequire("bdqIg");

var $ayMG0 = parcelRequire("ayMG0");
const $3b92023a13ae6811$var$CLIFF = 1;
const $3b92023a13ae6811$var$SLOP = 1.5;
const $3b92023a13ae6811$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollArea',
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $3b92023a13ae6811$var$_composeClasses.default)(slots, $7jHEF.getDataGridUtilityClass, classes);
};
const $3b92023a13ae6811$var$GridScrollAreaRawRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scrollArea,
            styles[`scrollArea--${ownerState.scrollDirection}`]
        ];
    }
})(()=>({
        position: 'absolute',
        zIndex: 101,
        // Horizontal scroll areas
        [`&.${$7jHEF.gridClasses['scrollArea--left']}`]: {
            top: 0,
            left: 0,
            width: 20,
            bottom: 0
        },
        [`&.${$7jHEF.gridClasses['scrollArea--right']}`]: {
            top: 0,
            right: 0,
            width: 20,
            bottom: 0
        },
        // Vertical scroll areas
        [`&.${$7jHEF.gridClasses['scrollArea--up']}`]: {
            top: 0,
            left: 0,
            right: 0,
            height: 20
        },
        [`&.${$7jHEF.gridClasses['scrollArea--down']}`]: {
            bottom: 0,
            left: 0,
            right: 0,
            height: 20
        }
    }));
const $3b92023a13ae6811$var$offsetSelector = (0, $cgQ4y.createSelector)($61HyH.gridDimensionsSelector, (dimensions, direction)=>{
    if (direction === 'left') return dimensions.leftPinnedWidth;
    if (direction === 'right') return dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    // For vertical scroll areas, we don't need horizontal offset
    return 0;
});
function $3b92023a13ae6811$var$GridScrollAreaWrapper(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const [dragDirection, setDragDirection] = $3b92023a13ae6811$var$React.useState('none');
    // Listen for both column and row drag events
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderDragStart', ()=>setDragDirection('horizontal'));
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderDragEnd', ()=>setDragDirection('none'));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowDragStart', ()=>setDragDirection('vertical'));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowDragEnd', ()=>setDragDirection('none'));
    if (dragDirection === 'none') return null;
    if (dragDirection === 'horizontal') return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridHorizontalScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridVerticalScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props));
}
function $3b92023a13ae6811$var$GridHorizontalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $3b92023a13ae6811$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const timeout = (0, $5oDOG.useTimeout)();
    const densityFactor = (0, $5sOMZ.useGridSelector)(apiRef, $fD9f4.gridDensityFactorSelector);
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridColumnsTotalWidthSelector);
    const sideOffset = (0, $5sOMZ.useGridSelector)(apiRef, $3b92023a13ae6811$var$offsetSelector, scrollDirection);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef);
        if (scrollDirection === 'left') // Only render if the user has not reached yet the start of the list
        return scrollPosition.current.left > 0;
        if (scrollDirection === 'right') {
            // Only render if the user has not reached yet the end of the list
            const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalHeaderHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, rootProps);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const style = (0, $3b92023a13ae6811$var$_extends2.default)({
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    }, scrollDirection === 'left' ? {
        left: sideOffset
    } : {}, scrollDirection === 'right' ? {
        right: sideOffset
    } : {});
    const handleDragOver = (0, $3b92023a13ae6811$var$_useEventCallback.default)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === 'right') offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $3b92023a13ae6811$var$CLIFF) * $3b92023a13ae6811$var$SLOP + $3b92023a13ae6811$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
function $3b92023a13ae6811$var$GridVerticalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $3b92023a13ae6811$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const timeout = (0, $5oDOG.useTimeout)();
    const rowsMeta = (0, $5sOMZ.useGridSelector)(apiRef, $bdqIg.gridRowsMetaSelector);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $61HyH.gridDimensionsSelector)(apiRef);
        if (scrollDirection === 'up') // Only render if the user has not reached yet the top of the list
        return scrollPosition.current.top > 0;
        if (scrollDirection === 'down') {
            // Only render if the user has not reached yet the bottom of the list
            const totalRowsHeight = rowsMeta.currentPageTotalHeight || 0;
            const maxScrollTop = totalRowsHeight - dimensions.viewportInnerSize.height - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
            return scrollPosition.current.top < maxScrollTop;
        }
        return false;
    };
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalHeaderHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, rootProps);
    const style = {
        top: scrollDirection === 'up' ? totalHeaderHeight : undefined,
        bottom: scrollDirection === 'down' ? 0 : undefined
    };
    const handleDragOver = (0, $3b92023a13ae6811$var$_useEventCallback.default)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'up') offset = event.clientY - rootRef.current.getBoundingClientRect().bottom;
        else if (scrollDirection === 'down') offset = Math.max(1, event.clientY - rootRef.current.getBoundingClientRect().top);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $3b92023a13ae6811$var$CLIFF) * $3b92023a13ae6811$var$SLOP + $3b92023a13ae6811$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left,
                top: scrollPosition.current.top + offset
            });
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaContent, (0, $3b92023a13ae6811$var$_extends2.default)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
const $3b92023a13ae6811$var$GridScrollAreaContent = (0, $fYxgT.forwardRef)(function GridScrollAreaContent(props, ref) {
    const { scrollDirection: scrollDirection, getCanScrollMore: getCanScrollMore, style: style, handleDragOver: handleDragOver } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const [canScrollMore, setCanScrollMore] = $3b92023a13ae6811$var$React.useState(getCanScrollMore);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $3b92023a13ae6811$var$_extends2.default)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $3b92023a13ae6811$var$useUtilityClasses(ownerState);
    const handleScrolling = ()=>{
        setCanScrollMore(getCanScrollMore);
    };
    (0, $g8PwW.useGridEvent)(apiRef, 'scrollPositionChange', handleScrolling);
    if (!canScrollMore) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3b92023a13ae6811$var$GridScrollAreaRawRoot, {
        ref: ref,
        className: classes.root,
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
});
const $3b92023a13ae6811$var$GridScrollArea = module.exports.GridScrollArea = (0, $2nKmT.fastMemo)($3b92023a13ae6811$var$GridScrollAreaWrapper);

});
parcelRegister("2nKmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "fastMemo", {
    enumerable: true,
    get: function() {
        return $lpqkk.fastMemo;
    }
});

var $lpqkk = parcelRequire("lpqkk");

});
parcelRegister("lpqkk", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f9605ab7c59a9c8a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fastMemo = $f9605ab7c59a9c8a$var$fastMemo;

var $f9605ab7c59a9c8a$var$React = $f9605ab7c59a9c8a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $325pS = parcelRequire("325pS");
function $f9605ab7c59a9c8a$var$fastMemo(component) {
    return /*#__PURE__*/ $f9605ab7c59a9c8a$var$React.memo(component, $325pS.fastObjectShallowCompare);
}

});
parcelRegister("325pS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "fastObjectShallowCompare", {
    enumerable: true,
    get: function() {
        return $i3Zsf.fastObjectShallowCompare;
    }
});

var $i3Zsf = parcelRequire("i3Zsf");

});
parcelRegister("i3Zsf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fastObjectShallowCompare = $d2682d6f1fe72d29$var$fastObjectShallowCompare;
const $d2682d6f1fe72d29$var$is = Object.is;
/**
 * Fast shallow compare for objects.
 * @returns true if objects are equal.
 */ function $d2682d6f1fe72d29$var$fastObjectShallowCompare(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$d2682d6f1fe72d29$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}

});




parcelRegister("7jHEF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l4ujy = parcelRequire("l4ujy");
Object.keys($l4ujy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l4ujy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l4ujy[key];
        }
    });
});

var $hHZTP = parcelRequire("hHZTP");
Object.keys($hHZTP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hHZTP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hHZTP[key];
        }
    });
});

var $5H1vo = parcelRequire("5H1vo");
Object.keys($5H1vo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5H1vo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5H1vo[key];
        }
    });
});

var $iVTh1 = parcelRequire("iVTh1");
Object.keys($iVTh1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iVTh1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iVTh1[key];
        }
    });
});

});
parcelRegister("l4ujy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_EXPERIMENTAL_ENABLED = void 0;
// A guide to feature toggling (deprecated)
//
// The feature toggle is:
// - independent from the NODE_ENV
// - isn't pruning code in production, as the objective is to eventually ship the code.
// - doesn't allow to cherry-pick which feature to enable
//
// By default, the experimental features are only enabled in:
// - the local environment
// - the pull request previews
//
// Reviewers can force the value with the local storage and the GRID_EXPERIMENTAL_ENABLED key:
// - 'true' => force it to be enabled
// - 'false' => force it to be disabled
//
// Developers (users) are discouraged to enable the experimental feature by setting the GRID_EXPERIMENTAL_ENABLED env.
// Instead, prefer exposing experimental APIs, for instance, a prop or a new `unstable_` module.
const $f5717c864dbc0f49$var$GRID_EXPERIMENTAL_ENABLED = module.exports.GRID_EXPERIMENTAL_ENABLED = false;

});

parcelRegister("hHZTP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_DEFAULT_LOCALE_TEXT = void 0;
const $ce4677c59813cb05$var$GRID_DEFAULT_LOCALE_TEXT = module.exports.GRID_DEFAULT_LOCALE_TEXT = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    noColumnsOverlayLabel: 'No columns',
    noColumnsOverlayManageColumns: 'Manage columns',
    emptyPivotOverlayLabel: 'Add fields to rows, columns, and values to create a pivot table',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Undo/redo toolbar button text
    toolbarUndo: 'Undo',
    toolbarRedo: 'Redo',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Toolbar pivot button
    toolbarPivot: 'Pivot',
    // Toolbar charts button
    toolbarCharts: 'Charts',
    // Toolbar AI Assistant button
    toolbarAssistant: 'AI Assistant',
    // Columns management text
    columnsManagementSearchTitle: 'Search',
    columnsManagementNoColumns: 'No columns',
    columnsManagementShowHideAllText: 'Show/Hide All',
    columnsManagementReset: 'Reset',
    columnsManagementDeleteIconLabel: 'Clear',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorDoesNotContain: 'does not contain',
    filterOperatorEquals: 'equals',
    filterOperatorDoesNotEqual: 'does not equal',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorDoesNotContain: 'Does not contain',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorDoesNotEqual: 'Does not equal',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    headerFilterClear: 'Clear filter',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuAriaLabel: (columnName)=>`${columnName} column menu`,
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    columnMenuManagePivot: 'Manage pivot',
    columnMenuManageCharts: 'Manage charts',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Long text cell
    longTextCellExpandLabel: 'Expand',
    longTextCellCollapseLabel: 'Collapse',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Pagination
    paginationRowsPerPage: 'Rows per page:',
    paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
        if (!estimated) return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
        const estimatedLabel = estimated && estimated > to ? `around ${estimated}` : `more than ${to}`;
        return `${from}\u{2013}${to} of ${count !== -1 ? count : estimatedLabel}`;
    },
    paginationItemAriaLabel: (type)=>{
        if (type === 'first') return 'Go to first page';
        if (type === 'last') return 'Go to last page';
        if (type === 'next') return 'Go to next page';
        // if (type === 'previous') {
        return 'Go to previous page';
    },
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelNone: 'none',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size',
    // Pivot panel
    pivotToggleLabel: 'Pivot',
    pivotRows: 'Rows',
    pivotColumns: 'Columns',
    pivotValues: 'Values',
    pivotCloseButton: 'Close pivot settings',
    pivotSearchButton: 'Search fields',
    pivotSearchControlPlaceholder: 'Search fields',
    pivotSearchControlLabel: 'Search fields',
    pivotSearchControlClear: 'Clear search',
    pivotNoFields: 'No fields',
    pivotMenuMoveUp: 'Move up',
    pivotMenuMoveDown: 'Move down',
    pivotMenuMoveToTop: 'Move to top',
    pivotMenuMoveToBottom: 'Move to bottom',
    pivotMenuRows: 'Rows',
    pivotMenuColumns: 'Columns',
    pivotMenuValues: 'Values',
    pivotMenuOptions: 'Field options',
    pivotMenuAddToRows: 'Add to Rows',
    pivotMenuAddToColumns: 'Add to Columns',
    pivotMenuAddToValues: 'Add to Values',
    pivotMenuRemove: 'Remove',
    pivotDragToRows: 'Drag here to create rows',
    pivotDragToColumns: 'Drag here to create columns',
    pivotDragToValues: 'Drag here to create values',
    pivotYearColumnHeaderName: '(Year)',
    pivotQuarterColumnHeaderName: '(Quarter)',
    // Charts configuration panel
    chartsNoCharts: 'There are no charts available',
    chartsChartNotSelected: 'Select a chart type to configure its options',
    chartsTabChart: 'Chart',
    chartsTabFields: 'Fields',
    chartsTabCustomize: 'Customize',
    chartsCloseButton: 'Close charts configuration',
    chartsSyncButtonLabel: 'Sync chart',
    chartsSearchPlaceholder: 'Search fields',
    chartsSearchLabel: 'Search fields',
    chartsSearchClear: 'Clear search',
    chartsNoFields: 'No fields',
    chartsFieldBlocked: 'This field cannot be added to any section',
    chartsCategories: 'Categories',
    chartsSeries: 'Series',
    chartsMenuAddToDimensions: (dimensionLabel)=>`Add to ${dimensionLabel}`,
    chartsMenuAddToValues: (valuesLabel)=>`Add to ${valuesLabel}`,
    chartsMenuMoveUp: 'Move up',
    chartsMenuMoveDown: 'Move down',
    chartsMenuMoveToTop: 'Move to top',
    chartsMenuMoveToBottom: 'Move to bottom',
    chartsMenuOptions: 'Field options',
    chartsMenuRemove: 'Remove',
    chartsDragToDimensions: (dimensionLabel)=>`Drag here to use column as ${dimensionLabel}`,
    chartsDragToValues: (valuesLabel)=>`Drag here to use column as ${valuesLabel}`,
    // AI Assistant panel
    aiAssistantPanelTitle: 'AI Assistant',
    aiAssistantPanelClose: 'Close AI Assistant',
    aiAssistantPanelNewConversation: 'New conversation',
    aiAssistantPanelConversationHistory: 'Conversation history',
    aiAssistantPanelEmptyConversation: 'No prompt history',
    aiAssistantSuggestions: 'Suggestions',
    // Prompt field
    promptFieldLabel: 'Prompt',
    promptFieldPlaceholder: "Type a prompt\u2026",
    promptFieldPlaceholderWithRecording: "Type or record a prompt\u2026",
    promptFieldPlaceholderListening: "Listening for prompt\u2026",
    promptFieldSpeechRecognitionNotSupported: 'Speech recognition is not supported in this browser',
    promptFieldSend: 'Send',
    promptFieldRecord: 'Record',
    promptFieldStopRecording: 'Stop recording',
    // Prompt
    promptRerun: 'Run again',
    promptProcessing: "Processing\u2026",
    promptAppliedChanges: 'Applied changes',
    // Prompt changes
    promptChangeGroupDescription: (column)=>`Group by ${column}`,
    promptChangeAggregationLabel: (column, aggregation)=>`${column} (${aggregation})`,
    promptChangeAggregationDescription: (column, aggregation)=>`Aggregate ${column} (${aggregation})`,
    promptChangeFilterLabel: (column, operator, value)=>{
        if (operator === 'is any of') return `${column} is any of: ${value}`;
        return `${column} ${operator} ${value}`;
    },
    promptChangeFilterDescription: (column, operator, value)=>{
        if (operator === 'is any of') return `Filter where ${column} is any of: ${value}`;
        return `Filter where ${column} ${operator} ${value}`;
    },
    promptChangeSortDescription: (column, direction)=>`Sort by ${column} (${direction})`,
    promptChangePivotEnableLabel: 'Pivot',
    promptChangePivotEnableDescription: 'Enable pivot',
    promptChangePivotColumnsLabel: (count)=>`Columns (${count})`,
    promptChangePivotColumnsDescription: (column, direction)=>`${column}${direction ? ` (${direction})` : ''}`,
    promptChangePivotRowsLabel: (count)=>`Rows (${count})`,
    promptChangePivotValuesLabel: (count)=>`Values (${count})`,
    promptChangePivotValuesDescription: (column, aggregation)=>`${column} (${aggregation})`,
    promptChangeChartsLabel: (dimensionsCount, valuesCount)=>`Dimensions (${dimensionsCount}), Values (${valuesCount})`
};

});

parcelRegister("5H1vo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $425222d9b2251c12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDataGridUtilityClass = $425222d9b2251c12$var$getDataGridUtilityClass;
module.exports.gridClasses = void 0;

var $425222d9b2251c12$var$_generateUtilityClass = $425222d9b2251c12$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $425222d9b2251c12$var$_generateUtilityClasses = $425222d9b2251c12$require$_interopRequireDefault((parcelRequire("5nY49")));
function $425222d9b2251c12$var$getDataGridUtilityClass(slot) {
    return (0, $425222d9b2251c12$var$_generateUtilityClass.default)('MuiDataGrid', slot);
}
const $425222d9b2251c12$var$gridClasses = module.exports.gridClasses = (0, $425222d9b2251c12$var$_generateUtilityClasses.default)('MuiDataGrid', [
    'aiAssistantPanel',
    'aiAssistantPanelHeader',
    'aiAssistantPanelTitleContainer',
    'aiAssistantPanelTitle',
    'aiAssistantPanelBody',
    'aiAssistantPanelEmptyText',
    'aiAssistantPanelFooter',
    'aiAssistantPanelConversation',
    'aiAssistantPanelConversationList',
    'aiAssistantPanelConversationTitle',
    'aiAssistantPanelSuggestions',
    'aiAssistantPanelSuggestionsList',
    'aiAssistantPanelSuggestionsItem',
    'aiAssistantPanelSuggestionsLabel',
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'aggregationRowOverlayWrapper',
    'autoHeight',
    'autosizing',
    'mainContent',
    'withSidePanel',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--flex',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--pinnedLeft',
    'cell--pinnedRight',
    'cell--selectionMode',
    'cell',
    'cellCheckbox',
    'cellEmpty',
    'cellSkeleton',
    'cellOffsetLeft',
    'checkboxInput',
    'collapsible',
    'collapsibleTrigger',
    'collapsibleIcon',
    'collapsiblePanel',
    'columnHeader',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader--pinnedLeft',
    'columnHeader--pinnedRight',
    'columnHeader--last',
    'columnHeader--siblingFocused',
    'columnHeader--filter',
    'columnHeaderFilterInput',
    'columnHeaderFilterOperatorLabel',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeaders',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsManagement',
    'columnsManagementRow',
    'columnsManagementHeader',
    'columnsManagementSearchInput',
    'columnsManagementFooter',
    'columnsManagementScrollArea',
    'columnsManagementEmptyText',
    'container--top',
    'container--bottom',
    'detailPanel',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'longTextCell',
    'longTextCellContent',
    'longTextCellExpandButton',
    'longTextCellCollapseButton',
    'longTextCellPopup',
    'longTextCellPopperContent',
    'editLongTextCell',
    'editLongTextCellValue',
    'editLongTextCellPopup',
    'editLongTextCellPopperContent',
    'editLongTextCellTextarea',
    'filler',
    'filler--borderBottom',
    'filler--pinnedLeft',
    'filler--pinnedRight',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'main--hasPinnedRight',
    'main--hiddenContent',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'root--noToolbar',
    'row',
    'row--editable',
    'row--editing',
    'row--firstVisible',
    'row--lastVisible',
    // TODO v9: Rename to `cell--dragging`
    'row--dragging',
    'row--beingDragged',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'row--borderBottom',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'rowReorderIcon',
    'rowSkeleton',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea--up',
    'scrollArea--down',
    'scrollArea',
    'scrollbar',
    'scrollbar--vertical',
    'scrollbar--horizontal',
    'scrollbarFiller',
    'scrollbarFiller--pinnedRight',
    'scrollShadow',
    'scrollShadow--vertical',
    'scrollShadow--horizontal',
    'selectedRowCount',
    'sortButton',
    'sortIcon',
    'shadowScrollArea',
    'sidebar',
    'sidebarHeader',
    'toolbarContainer',
    'toolbar',
    'toolbarLabel',
    'toolbarDivider',
    'toolbarFilterList',
    'toolbarQuickFilter',
    'toolbarQuickFilterTrigger',
    'toolbarQuickFilterControl',
    'virtualScroller',
    'virtualScroller--hasScrollX',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'withVerticalBorder',
    'withBorderColor',
    'cell--withRightBorder',
    'cell--withLeftBorder',
    'columnHeader--withRightBorder',
    'columnHeader--withLeftBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'treeDataGroupingCellLoadingContainer',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'groupingCriteriaCellLoadingContainer',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pivotPanelAvailableFields',
    'pivotPanelField',
    'pivotPanelField--sorted',
    'pivotPanelFieldActionContainer',
    'pivotPanelFieldCheckbox',
    'pivotPanelFieldDragIcon',
    'pivotPanelFieldList',
    'pivotPanelFieldName',
    'pivotPanelHeader',
    'pivotPanelPlaceholder',
    'pivotPanelScrollArea',
    'pivotPanelSearchContainer',
    'pivotPanelSection',
    'pivotPanelSectionTitle',
    'pivotPanelSections',
    'pivotPanelSwitch',
    'pivotPanelSwitchLabel',
    'prompt',
    'promptContent',
    'promptText',
    'promptFeedback',
    'promptChangeList',
    'promptChangesToggle',
    'promptChangesToggleIcon',
    'promptIcon',
    'promptIconContainer',
    'promptError',
    'promptAction'
]);

});

parcelRegister("iVTh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridSignature = void 0;
/**
 * Signal to the underlying logic what version of the public component API
 * of the Data Grid is exposed.
 */ let $dc886d040ec4e87c$var$GridSignature = module.exports.GridSignature = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    GridSignature["DataGridPremium"] = "DataGridPremium";
    return GridSignature;
}({});

});


parcelRegister("g8PwW", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $bc055d85bc2d0e70$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.internal_registryContainer = void 0;
module.exports.unstable_resetCleanupTracking = $bc055d85bc2d0e70$var$unstable_resetCleanupTracking;
module.exports.useGridEvent = $bc055d85bc2d0e70$var$useGridEvent;
module.exports.useGridEventPriority = $bc055d85bc2d0e70$var$useGridEventPriority;

var $bc055d85bc2d0e70$var$React = $bc055d85bc2d0e70$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7j5jX = parcelRequire("7j5jX");

var $gCT87 = parcelRequire("gCT87");
// Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
// Check https://github.com/facebook/react/issues/15317 to get more information
// We use class to make it easier to detect in heap snapshots by name
class $bc055d85bc2d0e70$var$ObjectToBeRetainedByReact {
    static create() {
        return new $bc055d85bc2d0e70$var$ObjectToBeRetainedByReact();
    }
}
const $bc055d85bc2d0e70$var$registryContainer = {
    current: $bc055d85bc2d0e70$var$createRegistry()
};
let $bc055d85bc2d0e70$var$cleanupTokensCounter = 0;
function $bc055d85bc2d0e70$var$useGridEvent(apiRef, eventName, handler, options) {
    const objectRetainedByReact = $bc055d85bc2d0e70$var$React.useState($bc055d85bc2d0e70$var$ObjectToBeRetainedByReact.create)[0];
    const subscription = $bc055d85bc2d0e70$var$React.useRef(null);
    const handlerRef = $bc055d85bc2d0e70$var$React.useRef(null);
    handlerRef.current = handler;
    const cleanupTokenRef = $bc055d85bc2d0e70$var$React.useRef(null);
    if (!subscription.current && handlerRef.current) {
        const enhancedHandler = (params, event, details)=>{
            // Check for the existence of the event once more to avoid Safari 26 issue
            // https://github.com/mui/mui-x/issues/20159
            if (event && !event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
        };
        subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
        $bc055d85bc2d0e70$var$cleanupTokensCounter += 1;
        cleanupTokenRef.current = {
            cleanupToken: $bc055d85bc2d0e70$var$cleanupTokensCounter
        };
        $bc055d85bc2d0e70$var$registryContainer.current.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
        ()=>{
            subscription.current?.();
            subscription.current = null;
            cleanupTokenRef.current = null;
        }, cleanupTokenRef.current);
    } else if (!handlerRef.current && subscription.current) {
        subscription.current();
        subscription.current = null;
        if (cleanupTokenRef.current) {
            $bc055d85bc2d0e70$var$registryContainer.current.unregister(cleanupTokenRef.current);
            cleanupTokenRef.current = null;
        }
    }
    $bc055d85bc2d0e70$var$React.useEffect(()=>{
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                // Check for the existence of the event once more to avoid Safari 26 issue
                // https://github.com/mui/mui-x/issues/20159
                if (event && !event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
        }
        if (cleanupTokenRef.current && $bc055d85bc2d0e70$var$registryContainer.current) {
            // If the effect was called, it means that this render was committed
            // so we can trust the cleanup function to remove the listener.
            $bc055d85bc2d0e70$var$registryContainer.current.unregister(cleanupTokenRef.current);
            cleanupTokenRef.current = null;
        }
        return ()=>{
            subscription.current?.();
            subscription.current = null;
        };
    }, [
        apiRef,
        eventName,
        options
    ]);
}
const $bc055d85bc2d0e70$var$OPTIONS_IS_FIRST = {
    isFirst: true
};
function $bc055d85bc2d0e70$var$useGridEventPriority(apiRef, eventName, handler) {
    $bc055d85bc2d0e70$var$useGridEvent(apiRef, eventName, handler, $bc055d85bc2d0e70$var$OPTIONS_IS_FIRST);
}
// TODO: move to @mui/x-data-grid/internals
// eslint-disable-next-line @typescript-eslint/naming-convention
function $bc055d85bc2d0e70$var$unstable_resetCleanupTracking() {
    $bc055d85bc2d0e70$var$registryContainer.current?.reset();
    $bc055d85bc2d0e70$var$registryContainer.current = $bc055d85bc2d0e70$var$createRegistry();
}
// eslint-disable-next-line @typescript-eslint/naming-convention
const $bc055d85bc2d0e70$var$internal_registryContainer = module.exports.internal_registryContainer = $bc055d85bc2d0e70$var$registryContainer;
function $bc055d85bc2d0e70$var$createRegistry() {
    return typeof FinalizationRegistry !== 'undefined' ? new $gCT87.FinalizationRegistryBasedCleanupTracking() : new $7j5jX.TimerBasedCleanupTracking();
}

});
parcelRegister("7j5jX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimerBasedCleanupTracking = void 0;
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $551e6f5a35c0c62f$var$TimerBasedCleanupTracking {
    timeouts = new Map();
    cleanupTimeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS;
    constructor(timeout = $551e6f5a35c0c62f$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}
module.exports.TimerBasedCleanupTracking = $551e6f5a35c0c62f$var$TimerBasedCleanupTracking;

});

parcelRegister("gCT87", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FinalizationRegistryBasedCleanupTracking = void 0;
class $c1aaf59f4b0a47d9$var$FinalizationRegistryBasedCleanupTracking {
    registry = new FinalizationRegistry((unsubscribe)=>{
        if (typeof unsubscribe === 'function') unsubscribe();
    });
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    reset() {}
}
module.exports.FinalizationRegistryBasedCleanupTracking = $c1aaf59f4b0a47d9$var$FinalizationRegistryBasedCleanupTracking;

});


parcelRegister("5sOMZ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3fa6f6f21ffa38ee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.objectShallowCompare = module.exports.argsEqual = void 0;
module.exports.useGridSelector = $3fa6f6f21ffa38ee$var$useGridSelector;

var $3fa6f6f21ffa38ee$var$React = $3fa6f6f21ffa38ee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $325pS = parcelRequire("325pS");

var $9Y8Cp = parcelRequire("9Y8Cp");

var $hfliI = parcelRequire("hfliI");

var $7O6ub = parcelRequire("7O6ub");
const $3fa6f6f21ffa38ee$var$defaultCompare = Object.is;
const $3fa6f6f21ffa38ee$var$objectShallowCompare = module.exports.objectShallowCompare = $325pS.fastObjectShallowCompare;
const $3fa6f6f21ffa38ee$var$arrayShallowCompare = (a, b)=>{
    if (a === b) return true;
    return a.length === b.length && a.every((v, i)=>v === b[i]);
};
const $3fa6f6f21ffa38ee$var$argsEqual = (prev, curr)=>{
    let fn = Object.is;
    if (curr instanceof Array) fn = $3fa6f6f21ffa38ee$var$arrayShallowCompare;
    else if (curr instanceof Object) fn = $3fa6f6f21ffa38ee$var$objectShallowCompare;
    return fn(prev, curr);
};
module.exports.argsEqual = $3fa6f6f21ffa38ee$var$argsEqual;
const $3fa6f6f21ffa38ee$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null,
        args: undefined
    });
const $3fa6f6f21ffa38ee$var$EMPTY = [];
const $3fa6f6f21ffa38ee$var$emptyGetSnapshot = ()=>null;
function $3fa6f6f21ffa38ee$var$useGridSelector(apiRef, selector, args, equals = $3fa6f6f21ffa38ee$var$defaultCompare) {
    if (!apiRef.current.state) (0, $9Y8Cp.warnOnce)([
        'MUI X: `useGridSelector` has been called before the initialization of the state.',
        'This hook can only be used inside the context of the grid.'
    ]);
    const refs = (0, $7O6ub.useLazyRef)($3fa6f6f21ffa38ee$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $3fa6f6f21ffa38ee$var$React.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : selector(apiRef, args));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const prevArgs = refs.current.args;
    refs.current.args = args;
    if (didInit && !$3fa6f6f21ffa38ee$var$argsEqual(prevArgs, args)) {
        const newState = refs.current.selector(apiRef, refs.current.args);
        if (!refs.current.equals(refs.current.state, newState)) {
            refs.current.state = newState;
            setState(newState);
        }
    }
    const subscribe = $3fa6f6f21ffa38ee$var$React.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = refs.current.selector(apiRef, refs.current.args);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $3fa6f6f21ffa38ee$var$EMPTY);
    const unsubscribe = $3fa6f6f21ffa38ee$var$React.useCallback(()=>{
        // Fixes issue in React Strict Mode, where getSnapshot is not called
        if (!refs.current.subscription) subscribe();
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3fa6f6f21ffa38ee$var$EMPTY);
    (0, $hfliI.useSyncExternalStore)(unsubscribe, subscribe, $3fa6f6f21ffa38ee$var$emptyGetSnapshot);
    return state;
}

});
parcelRegister("9Y8Cp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "clearWarningsCache", {
    enumerable: true,
    get: function() {
        return $3BDjL.clearWarningsCache;
    }
});
Object.defineProperty(module.exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return $3BDjL.warnOnce;
    }
});

var $3BDjL = parcelRequire("3BDjL");

});
parcelRegister("3BDjL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearWarningsCache = $2a03537a78f99f35$var$clearWarningsCache;
module.exports.warnOnce = $2a03537a78f99f35$var$warnOnce;
const $2a03537a78f99f35$var$warnedOnceCache = new Set();
/**
 * Logs a message to the console on development mode. The warning will only be logged once.
 *
 * The message is the log's cache key. Two identical messages will only be logged once.
 *
 * This function is a no-op in production.
 *
 * @param message the message to log
 * @param gravity the gravity of the warning. Defaults to `'warning'`.
 * @returns
 */ function $2a03537a78f99f35$var$warnOnce(message, gravity = 'warning') {
    return;
}
function $2a03537a78f99f35$var$clearWarningsCache() {
    $2a03537a78f99f35$var$warnedOnceCache.clear();
}

});


parcelRegister("7O6ub", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5af23bdc14a3ba8d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useLazyRef", {
    enumerable: true,
    get: function() {
        return $5af23bdc14a3ba8d$var$_useLazyRef.default;
    }
});

var $5af23bdc14a3ba8d$var$_useLazyRef = $5af23bdc14a3ba8d$require$_interopRequireDefault((parcelRequire("doV3C")));

});


parcelRegister("fD9f4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridDensitySelector = module.exports.gridDensityFactorSelector = module.exports.COMPACT_DENSITY_FACTOR = module.exports.COMFORTABLE_DENSITY_FACTOR = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $b611aad21a5b677d$var$COMPACT_DENSITY_FACTOR = module.exports.COMPACT_DENSITY_FACTOR = 0.7;
const $b611aad21a5b677d$var$COMFORTABLE_DENSITY_FACTOR = module.exports.COMFORTABLE_DENSITY_FACTOR = 1.3;
const $b611aad21a5b677d$var$DENSITY_FACTORS = {
    compact: $b611aad21a5b677d$var$COMPACT_DENSITY_FACTOR,
    comfortable: $b611aad21a5b677d$var$COMFORTABLE_DENSITY_FACTOR,
    standard: 1
};
const $b611aad21a5b677d$var$gridDensitySelector = module.exports.gridDensitySelector = (0, $cgQ4y.createRootSelector)((state)=>state.density);
const $b611aad21a5b677d$var$gridDensityFactorSelector = module.exports.gridDensityFactorSelector = (0, $cgQ4y.createSelector)($b611aad21a5b677d$var$gridDensitySelector, (density)=>$b611aad21a5b677d$var$DENSITY_FACTORS[density]);

});

parcelRegister("5oDOG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3ede1456da2c476e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useTimeout", {
    enumerable: true,
    get: function() {
        return $3ede1456da2c476e$var$_useTimeout.default;
    }
});

var $3ede1456da2c476e$var$_useTimeout = $3ede1456da2c476e$require$_interopRequireDefault((parcelRequire("drY8V")));

});

parcelRegister("i0LyH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1cd1e3fd8558ad5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyInitialState = module.exports.COLUMNS_DIMENSION_PROPERTIES = void 0;
module.exports.computeFlexColumnsWidth = $d1cd1e3fd8558ad5$var$computeFlexColumnsWidth;
module.exports.createColumnsState = void 0;
module.exports.getDefaultColTypeDef = $d1cd1e3fd8558ad5$var$getDefaultColTypeDef;
module.exports.getFirstNonSpannedColumnToRender = $d1cd1e3fd8558ad5$var$getFirstNonSpannedColumnToRender;
module.exports.getTotalHeaderHeight = $d1cd1e3fd8558ad5$var$getTotalHeaderHeight;
module.exports.hydrateColumnsWidth = void 0;

var $d1cd1e3fd8558ad5$var$_extends2 = $d1cd1e3fd8558ad5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d1cd1e3fd8558ad5$var$_resolveProps = $d1cd1e3fd8558ad5$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ehhGY = parcelRequire("ehhGY");

var $jQEEt = parcelRequire("jQEEt");

var $lR3Vo = parcelRequire("lR3Vo");

var $fD9f4 = parcelRequire("fD9f4");

var $6forD = parcelRequire("6forD");

var $hMyIf = parcelRequire("hMyIf");
const $d1cd1e3fd8558ad5$var$COLUMNS_DIMENSION_PROPERTIES = module.exports.COLUMNS_DIMENSION_PROPERTIES = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
const $d1cd1e3fd8558ad5$var$COLUMN_TYPES = (0, $ehhGY.getGridDefaultColumnTypes)();
/**
 * Computes width for flex columns.
 * Based on CSS Flexbox specification:
 * https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
 */ function $d1cd1e3fd8558ad5$var$computeFlexColumnsWidth({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
/**
 * Compute the `computedWidth` (ie: the width the column should have during rendering) based on the `width` / `flex` / `minWidth` / `maxWidth` properties of `GridColDef`.
 * The columns already have been merged with there `type` default values for `minWidth`, `maxWidth` and `width`, thus the `!` for those properties below.
 * TODO: Unit test this function in depth and only keep basic cases for the whole grid testing.
 * TODO: Improve the `GridColDef` typing to reflect the fact that `minWidth` / `maxWidth` and `width` can't be null after the merge with the `type` default values.
 */ const $d1cd1e3fd8558ad5$var$hydrateColumnsWidth = (rawState, dimensions)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute their minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        let column = rawState.lookup[columnField];
        let computedWidth = 0;
        let isFlex = false;
        if (rawState.columnVisibilityModel[columnField] !== false) {
            if (column.flex && column.flex > 0) {
                totalFlexUnits += column.flex;
                isFlex = true;
            } else computedWidth = (0, $lR3Vo.clamp)(column.width || $ehhGY.GRID_STRING_COL_DEF.width, column.minWidth || $ehhGY.GRID_STRING_COL_DEF.minWidth, column.maxWidth || $ehhGY.GRID_STRING_COL_DEF.maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
        }
        if (column.computedWidth !== computedWidth) column = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, column, {
            computedWidth: computedWidth
        });
        if (isFlex) flexColumns.push(column);
        columnsLookup[columnField] = column;
    });
    const availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    const initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        const computedColumnWidths = $d1cd1e3fd8558ad5$var$computeFlexColumnsWidth({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field] = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, columnsLookup[field], {
                computedWidth: computedColumnWidths[field].computedWidth
            });
        });
    }
    return (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, rawState, {
        lookup: columnsLookup
    });
};
/**
 * Apply the order and the dimensions of the initial state.
 * The columns not registered in `orderedFields` will be placed after the imported columns.
 */ module.exports.hydrateColumnsWidth = $d1cd1e3fd8558ad5$var$hydrateColumnsWidth;
const $d1cd1e3fd8558ad5$var$applyInitialState = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
module.exports.applyInitialState = $d1cd1e3fd8558ad5$var$applyInitialState;
function $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(type) {
    let colDef = $d1cd1e3fd8558ad5$var$COLUMN_TYPES[$ehhGY.DEFAULT_GRID_COL_TYPE_KEY];
    if (type && $d1cd1e3fd8558ad5$var$COLUMN_TYPES[type]) colDef = $d1cd1e3fd8558ad5$var$COLUMN_TYPES[type];
    return colDef;
}
const $d1cd1e3fd8558ad5$var$createColumnsState = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnVisibilityModel: columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false, updateInitialVisibilityModel: updateInitialVisibilityModel = false })=>{
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel,
        initialColumnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $jQEEt.gridColumnsStateSelector)(apiRef);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: keepOnlyColumnsToUpsert ? {} : (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, currentState.lookup),
            columnVisibilityModel: columnVisibilityModel,
            initialColumnVisibilityModel: updateInitialVisibilityModel ? columnVisibilityModel : currentState.initialColumnVisibilityModel
        };
    }
    const columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
        for(const key in columnsState.lookup)if (Object.prototype.hasOwnProperty.call(columnsState.lookup, key)) columnsToKeep[key] = false;
    }
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $d1cd1e3fd8558ad5$var$COLUMNS_DIMENSION_PROPERTIES.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        const mergedProps = (0, $d1cd1e3fd8558ad5$var$_extends2.default)({}, $d1cd1e3fd8558ad5$var$getDefaultColTypeDef(newColumn.type), {
            hasBeenResized: hasBeenResized,
            field: field
        });
        let key;
        for(key in newColumn)if (newColumn[key] !== undefined && key !== 'field') mergedProps[key] = newColumn[key];
        columnsState.lookup[field] = (0, $d1cd1e3fd8558ad5$var$_resolveProps.default)(existingState, mergedProps);
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $d1cd1e3fd8558ad5$var$applyInitialState(columnsStateWithPreProcessing, initialState);
    return $d1cd1e3fd8558ad5$var$hydrateColumnsWidth(columnsStateWithPortableColumns, apiRef.current.getRootDimensions?.() ?? undefined);
};
module.exports.createColumnsState = $d1cd1e3fd8558ad5$var$createColumnsState;
function $d1cd1e3fd8558ad5$var$getFirstNonSpannedColumnToRender({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn && firstNonSpannedColumnToRender >= 0){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
function $d1cd1e3fd8558ad5$var$getTotalHeaderHeight(apiRef, props) {
    if (props.listView) return 0;
    const densityFactor = (0, $fD9f4.gridDensityFactorSelector)(apiRef);
    const maxDepth = (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
    const isHeaderFilteringEnabled = (0, $6forD.gridHeaderFilteringEnabledSelector)(apiRef);
    const columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const columnGroupHeadersHeight = Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * densityFactor);
    const filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight + columnGroupHeadersHeight * maxDepth + filterHeadersHeight;
}

});
parcelRegister("ehhGY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8z2XQ = parcelRequire("8z2XQ");
Object.keys($8z2XQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8z2XQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8z2XQ[key];
        }
    });
});

var $iNueb = parcelRequire("iNueb");
Object.keys($iNueb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iNueb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iNueb[key];
        }
    });
});

var $5bG6h = parcelRequire("5bG6h");
Object.keys($5bG6h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5bG6h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5bG6h[key];
        }
    });
});

var $axs1H = parcelRequire("axs1H");
Object.keys($axs1H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $axs1H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $axs1H[key];
        }
    });
});

var $e79LH = parcelRequire("e79LH");
Object.keys($e79LH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e79LH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e79LH[key];
        }
    });
});

var $2LzSK = parcelRequire("2LzSK");
Object.keys($2LzSK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2LzSK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2LzSK[key];
        }
    });
});

var $bSL2h = parcelRequire("bSL2h");
Object.keys($bSL2h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bSL2h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bSL2h[key];
        }
    });
});

var $4SEnU = parcelRequire("4SEnU");
Object.keys($4SEnU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4SEnU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4SEnU[key];
        }
    });
});

var $jWu8a = parcelRequire("jWu8a");
Object.keys($jWu8a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jWu8a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jWu8a[key];
        }
    });
});

var $5GOJA = parcelRequire("5GOJA");
Object.keys($5GOJA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5GOJA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5GOJA[key];
        }
    });
});

var $8SI7h = parcelRequire("8SI7h");
Object.keys($8SI7h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8SI7h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8SI7h[key];
        }
    });
});

var $hIUWG = parcelRequire("hIUWG");
Object.keys($hIUWG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hIUWG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hIUWG[key];
        }
    });
});

var $hKY94 = parcelRequire("hKY94");
Object.keys($hKY94).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hKY94[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hKY94[key];
        }
    });
});

var $5rUcf = parcelRequire("5rUcf");
Object.keys($5rUcf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5rUcf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5rUcf[key];
        }
    });
});

});
parcelRegister("8z2XQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $63c3e445c9bf0af1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_ACTIONS_COL_DEF = module.exports.GRID_ACTIONS_COLUMN_TYPE = void 0;

var $63c3e445c9bf0af1$var$_extends2 = $63c3e445c9bf0af1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bSL2h = parcelRequire("bSL2h");

var $cc312 = parcelRequire("cc312");
const $63c3e445c9bf0af1$var$GRID_ACTIONS_COLUMN_TYPE = module.exports.GRID_ACTIONS_COLUMN_TYPE = 'actions';
const $63c3e445c9bf0af1$var$GRID_ACTIONS_COL_DEF = module.exports.GRID_ACTIONS_COL_DEF = (0, $63c3e445c9bf0af1$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    width: 100,
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: $cc312.renderActionsCell,
    getApplyQuickFilterFn: ()=>null
});

});
parcelRegister("bSL2h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_STRING_COL_DEF = void 0;

var $4QDBh = parcelRequire("4QDBh");

var $h8fXG = parcelRequire("h8fXG");

var $hKY94 = parcelRequire("hKY94");
/**
 * TODO: Move pro and premium properties outside of this Community file
 */ const $8a69393405f257b1$var$GRID_STRING_COL_DEF = module.exports.GRID_STRING_COL_DEF = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    chartable: true,
    editable: false,
    sortComparator: $h8fXG.gridStringOrNumberComparator,
    type: 'string',
    align: 'left',
    filterOperators: (0, $hKY94.getGridStringOperators)(),
    renderEditCell: $4QDBh.renderEditInputCell,
    getApplyQuickFilterFn: $hKY94.getGridStringQuickFilterFn
};

});
parcelRegister("4QDBh", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $387abc8f0fc4c9a9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $387abc8f0fc4c9a9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderEditInputCell = module.exports.GridEditInputCell = void 0;

var $387abc8f0fc4c9a9$var$_extends2 = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $387abc8f0fc4c9a9$var$_objectWithoutPropertiesLoose2 = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("c05no")));

var $387abc8f0fc4c9a9$var$React = $387abc8f0fc4c9a9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $387abc8f0fc4c9a9$var$_composeClasses = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $387abc8f0fc4c9a9$var$_useEnhancedEffect = $387abc8f0fc4c9a9$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $j0vMH = parcelRequire("j0vMH");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $387abc8f0fc4c9a9$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange",
    "slotProps"
];
const $387abc8f0fc4c9a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $387abc8f0fc4c9a9$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $387abc8f0fc4c9a9$var$GridEditInputCellRoot = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'EditInputCell'
})({
    font: $hbuUJ.vars.typography.font.body,
    padding: '1px 0',
    '& input': {
        padding: '0 16px',
        height: '100%'
    }
});
const $387abc8f0fc4c9a9$var$GridEditInputCell = module.exports.GridEditInputCell = (0, $fYxgT.forwardRef)((props, ref)=>{
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange, slotProps: slotProps } = props, other = (0, $387abc8f0fc4c9a9$var$_objectWithoutPropertiesLoose2.default)(props, $387abc8f0fc4c9a9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $387abc8f0fc4c9a9$var$React.useRef(null);
    const [valueState, setValueState] = $387abc8f0fc4c9a9$var$React.useState(value);
    const classes = $387abc8f0fc4c9a9$var$useUtilityClasses(rootProps);
    const handleChange = $387abc8f0fc4c9a9$var$React.useCallback(async (event)=>{
        const newValue = event.target.value;
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
        if (onValueChange) await onValueChange(event, newValue);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $387abc8f0fc4c9a9$var$React.useEffect(()=>{
        if (meta?.changeReason !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $387abc8f0fc4c9a9$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$var$GridEditInputCellRoot, (0, $387abc8f0fc4c9a9$var$_extends2.default)({
        as: rootProps.slots.baseInput,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState ?? '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other, slotProps?.root, {
        ref: ref
    }));
});
const $387abc8f0fc4c9a9$var$renderEditInputCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($387abc8f0fc4c9a9$var$GridEditInputCell, (0, $387abc8f0fc4c9a9$var$_extends2.default)({}, params));
module.exports.renderEditInputCell = $387abc8f0fc4c9a9$var$renderEditInputCell;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j0vMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotRendered = $dd66ac2a2c256d30$var$NotRendered;
function $dd66ac2a2c256d30$var$NotRendered(_props) {
    throw new Error('Failed assertion: should not be rendered');
}

});

parcelRegister("hbuUJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c82b71a32bc2a7f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.vars = void 0;

var $c82b71a32bc2a7f4$var$_extends2 = $c82b71a32bc2a7f4$require$_interopRequireDefault((parcelRequire("3p9rK")));
// NOTE: Breakpoints can't come from the theme because we need access to them at
// initialization time and media-queries can't use CSS variables. For users with
// custom breakpoints, we might want to provide a way to configure them globally
// instead of through the theme.
const $c82b71a32bc2a7f4$var$breakpoints = {
    values: {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    },
    up: (key)=>{
        const values = $c82b71a32bc2a7f4$var$breakpoints.values;
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}px)`;
    }
};
const $c82b71a32bc2a7f4$var$keys = {
    spacingUnit: '--DataGrid-t-spacing-unit',
    /* Variables */ colors: {
        border: {
            base: '--DataGrid-t-color-border-base'
        },
        foreground: {
            base: '--DataGrid-t-color-foreground-base',
            muted: '--DataGrid-t-color-foreground-muted',
            accent: '--DataGrid-t-color-foreground-accent',
            disabled: '--DataGrid-t-color-foreground-disabled',
            error: '--DataGrid-t-color-foreground-error'
        },
        background: {
            base: '--DataGrid-t-color-background-base',
            overlay: '--DataGrid-t-color-background-overlay',
            backdrop: '--DataGrid-t-color-background-backdrop'
        },
        interactive: {
            hover: '--DataGrid-t-color-interactive-hover',
            hoverOpacity: '--DataGrid-t-color-interactive-hover-opacity',
            focus: '--DataGrid-t-color-interactive-focus',
            focusOpacity: '--DataGrid-t-color-interactive-focus-opacity',
            disabled: '--DataGrid-t-color-interactive-disabled',
            disabledOpacity: '--DataGrid-t-color-interactive-disabled-opacity',
            selected: '--DataGrid-t-color-interactive-selected',
            selectedOpacity: '--DataGrid-t-color-interactive-selected-opacity'
        }
    },
    header: {
        background: {
            base: '--DataGrid-t-header-background-base'
        }
    },
    cell: {
        background: {
            pinned: '--DataGrid-t-cell-background-pinned'
        }
    },
    radius: {
        base: '--DataGrid-t-radius-base'
    },
    typography: {
        font: {
            body: '--DataGrid-t-typography-font-body',
            small: '--DataGrid-t-typography-font-small',
            large: '--DataGrid-t-typography-font-large'
        },
        fontFamily: {
            base: '--DataGrid-t-typography-font-family-base'
        },
        fontWeight: {
            light: '--DataGrid-t-typography-font-weight-light',
            regular: '--DataGrid-t-typography-font-weight-regular',
            medium: '--DataGrid-t-typography-font-weight-medium',
            bold: '--DataGrid-t-typography-font-weight-bold'
        }
    },
    transitions: {
        easing: {
            easeIn: '--DataGrid-t-transition-easing-ease-in',
            easeOut: '--DataGrid-t-transition-easing-ease-out',
            easeInOut: '--DataGrid-t-transition-easing-ease-in-out'
        },
        duration: {
            short: '--DataGrid-t-transition-duration-short',
            base: '--DataGrid-t-transition-duration-base',
            long: '--DataGrid-t-transition-duration-long'
        }
    },
    shadows: {
        base: '--DataGrid-t-shadow-base',
        overlay: '--DataGrid-t-shadow-overlay'
    },
    zIndex: {
        panel: '--DataGrid-t-z-index-panel',
        menu: '--DataGrid-t-z-index-menu'
    }
};
const $c82b71a32bc2a7f4$var$values = $c82b71a32bc2a7f4$var$wrap($c82b71a32bc2a7f4$var$keys);
const $c82b71a32bc2a7f4$var$vars = module.exports.vars = (0, $c82b71a32bc2a7f4$var$_extends2.default)({
    breakpoints: $c82b71a32bc2a7f4$var$breakpoints,
    spacing: $c82b71a32bc2a7f4$var$spacing,
    transition: $c82b71a32bc2a7f4$var$transition,
    keys: $c82b71a32bc2a7f4$var$keys
}, $c82b71a32bc2a7f4$var$values);
function $c82b71a32bc2a7f4$var$spacing(a, b, c, d) {
    /* eslint-disable prefer-template */ if (a === undefined) return $c82b71a32bc2a7f4$var$spacingString(1);
    if (b === undefined) return $c82b71a32bc2a7f4$var$spacingString(a);
    if (c === undefined) return $c82b71a32bc2a7f4$var$spacingString(a) + ' ' + $c82b71a32bc2a7f4$var$spacingString(b);
    if (d === undefined) return $c82b71a32bc2a7f4$var$spacingString(a) + ' ' + $c82b71a32bc2a7f4$var$spacingString(b) + ' ' + $c82b71a32bc2a7f4$var$spacingString(c);
    return $c82b71a32bc2a7f4$var$spacingString(a) + ' ' + $c82b71a32bc2a7f4$var$spacingString(b) + ' ' + $c82b71a32bc2a7f4$var$spacingString(c) + ' ' + $c82b71a32bc2a7f4$var$spacingString(d);
/* eslint-enable prefer-template */ }
function $c82b71a32bc2a7f4$var$spacingString(value) {
    if (value === 0) return '0';
    return `calc(var(--DataGrid-t-spacing-unit) * ${value})`;
}
function $c82b71a32bc2a7f4$var$transition(props, options) {
    const { duration: duration = $c82b71a32bc2a7f4$var$vars.transitions.duration.base, easing: easing = $c82b71a32bc2a7f4$var$vars.transitions.easing.easeInOut, delay: delay = 0 } = options ?? {};
    return props.map((prop)=>`${prop} ${duration} ${easing} ${delay}ms`).join(', ');
}
function $c82b71a32bc2a7f4$var$wrap(input) {
    if (typeof input === 'string') return `var(${input})`;
    const result = {};
    for(const key in input)if (Object.hasOwn(input, key)) result[key] = $c82b71a32bc2a7f4$var$wrap(input[key]);
    return result;
}

});


parcelRegister("h8fXG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c78f90aae54b126e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sanitizeSortModel = module.exports.mergeStateWithSortModel = module.exports.gridStringOrNumberComparator = module.exports.gridNumberComparator = module.exports.gridDateComparator = module.exports.getNextGridSortDirection = module.exports.buildAggregatedSortingApplier = void 0;

var $c78f90aae54b126e$var$_extends2 = $c78f90aae54b126e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $goCyd = parcelRequire("goCyd");
const $c78f90aae54b126e$var$sanitizeSortModel = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) {
        (0, $9Y8Cp.warnOnce)([
            'MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.',
            'If you are using the community version of the Data Grid, this prop is always `true`.'
        ], 'error');
        return [
            model[0]
        ];
    }
    return model;
};
module.exports.sanitizeSortModel = $c78f90aae54b126e$var$sanitizeSortModel;
const $c78f90aae54b126e$var$mergeStateWithSortModel = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $c78f90aae54b126e$var$_extends2.default)({}, state, {
            sorting: (0, $c78f90aae54b126e$var$_extends2.default)({}, state.sorting, {
                sortModel: $c78f90aae54b126e$var$sanitizeSortModel(sortModel, disableMultipleColumnsSorting)
            })
        });
module.exports.mergeStateWithSortModel = $c78f90aae54b126e$var$mergeStateWithSortModel;
const $c78f90aae54b126e$var$isDesc = (direction)=>direction === 'desc';
/**
 * @name sortValueGetter
 * @param {GridRowId} id The id of the row.
 * @param {string} field The field to sort by.
 *
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $c78f90aae54b126e$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column || sortItem.sort === null) return null;
    let comparator;
    if (column.getSortComparator) comparator = column.getSortComparator(sortItem.sort);
    else comparator = $c78f90aae54b126e$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    if (!comparator) return null;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: (0, $goCyd.gridRowNodeSelector)(apiRef, id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $c78f90aae54b126e$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
/**
 * Generates a method to easily sort a list of rows according to the current sort model.
 * @param {GridSortModel} sortModel The model with which we want to sort the rows.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridSortingModelApplier | null} A method that generates a list of sorted row ids from a list of rows according to the current sort model. If `null`, we consider that the rows should remain in the order there were provided.
 */ const $c78f90aae54b126e$var$buildAggregatedSortingApplier = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$c78f90aae54b126e$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$c78f90aae54b126e$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
module.exports.buildAggregatedSortingApplier = $c78f90aae54b126e$var$buildAggregatedSortingApplier;
const $c78f90aae54b126e$var$getNextGridSortDirection = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
module.exports.getNextGridSortDirection = $c78f90aae54b126e$var$getNextGridSortDirection;
const $c78f90aae54b126e$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $c78f90aae54b126e$var$collator = new Intl.Collator();
const $c78f90aae54b126e$var$gridStringOrNumberComparator = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $c78f90aae54b126e$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
module.exports.gridStringOrNumberComparator = $c78f90aae54b126e$var$gridStringOrNumberComparator;
const $c78f90aae54b126e$var$gridNumberComparator = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
module.exports.gridNumberComparator = $c78f90aae54b126e$var$gridNumberComparator;
const $c78f90aae54b126e$var$gridDateComparator = (value1, value2)=>{
    const nillResult = $c78f90aae54b126e$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};
module.exports.gridDateComparator = $c78f90aae54b126e$var$gridDateComparator;

});

parcelRegister("hKY94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridStringQuickFilterFn = module.exports.getGridStringOperators = void 0;

var $g7hyo = parcelRequire("g7hyo");

var $lR3Vo = parcelRequire("lR3Vo");

var $6tiPX = parcelRequire("6tiPX");

var $14dIX = parcelRequire("14dIX");
const $ced5632839836707$var$getGridStringQuickFilterFn = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $lR3Vo.escapeRegExp)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $14dIX.removeDiacritics)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
module.exports.getGridStringQuickFilterFn = $ced5632839836707$var$getGridStringQuickFilterFn;
const $ced5632839836707$var$createContainsFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const filterRegex = new RegExp((0, $lR3Vo.escapeRegExp)(trimmedValue), 'i');
        return (value)=>{
            if (value == null) return negate;
            const matches = filterRegex.test(String(value));
            return negate ? !matches : matches;
        };
    };
const $ced5632839836707$var$createEqualityFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const collator = new Intl.Collator(undefined, {
            sensitivity: 'base',
            usage: 'search'
        });
        return (value)=>{
            if (value == null) return negate;
            const isEqual = collator.compare(trimmedValue, value.toString()) === 0;
            return negate ? !isEqual : isEqual;
        };
    };
const $ced5632839836707$var$createEmptyFilterFn = (negate)=>()=>{
        return (value)=>{
            const isEmpty = value === '' || value == null;
            return negate ? !isEmpty : isEmpty;
        };
    };
const $ced5632839836707$var$getGridStringOperators = (disableTrim = false)=>[
        {
            value: 'contains',
            getApplyFilterFn: $ced5632839836707$var$createContainsFilterFn(disableTrim, false),
            InputComponent: $g7hyo.GridFilterInputValue
        },
        {
            value: 'doesNotContain',
            getApplyFilterFn: $ced5632839836707$var$createContainsFilterFn(disableTrim, true),
            InputComponent: $g7hyo.GridFilterInputValue
        },
        {
            value: 'equals',
            getApplyFilterFn: $ced5632839836707$var$createEqualityFilterFn(disableTrim, false),
            InputComponent: $g7hyo.GridFilterInputValue
        },
        {
            value: 'doesNotEqual',
            getApplyFilterFn: $ced5632839836707$var$createEqualityFilterFn(disableTrim, true),
            InputComponent: $g7hyo.GridFilterInputValue
        },
        {
            value: 'startsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $lR3Vo.escapeRegExp)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue
        },
        {
            value: 'endsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $lR3Vo.escapeRegExp)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: $ced5632839836707$var$createEmptyFilterFn(false),
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: $ced5632839836707$var$createEmptyFilterFn(true),
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: $6tiPX.GridFilterInputMultipleValue
        }
    ];
module.exports.getGridStringOperators = $ced5632839836707$var$getGridStringOperators;

});
parcelRegister("g7hyo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bbbaea9771a9f69f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bbbaea9771a9f69f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterInputValue = $bbbaea9771a9f69f$var$GridFilterInputValue;

var $bbbaea9771a9f69f$var$_extends2 = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bbbaea9771a9f69f$var$_objectWithoutPropertiesLoose2 = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("c05no")));

var $bbbaea9771a9f69f$var$React = $bbbaea9771a9f69f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bbbaea9771a9f69f$var$_propTypes = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bbbaea9771a9f69f$var$_useId = $bbbaea9771a9f69f$require$_interopRequireDefault((parcelRequire("hwliF")));

var $5oDOG = parcelRequire("5oDOG");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $bbbaea9771a9f69f$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "slotProps",
    "clearButton",
    "headerFilterMenu"
];
function $bbbaea9771a9f69f$var$GridFilterInputValue(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, slotProps: slotProps, clearButton: clearButton, headerFilterMenu: headerFilterMenu } = props, other = (0, $bbbaea9771a9f69f$var$_objectWithoutPropertiesLoose2.default)(props, $bbbaea9771a9f69f$var$_excluded);
    const textFieldProps = slotProps?.root;
    const filterTimeout = (0, $5oDOG.useTimeout)();
    const [filterValueState, setFilterValueState] = $bbbaea9771a9f69f$var$React.useState($bbbaea9771a9f69f$var$sanitizeFilterItemValue(item.value));
    const [applying, setIsApplying] = $bbbaea9771a9f69f$var$React.useState(false);
    const id = (0, $bbbaea9771a9f69f$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $bbbaea9771a9f69f$var$React.useCallback((event)=>{
        const value = $bbbaea9771a9f69f$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $bbbaea9771a9f69f$var$_extends2.default)({}, item, {
                value: type === 'number' && !Number.isNaN(Number(value)) ? Number(value) : value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        filterTimeout,
        rootProps.filterDebounceMs,
        item,
        type,
        id,
        applyValue
    ]);
    $bbbaea9771a9f69f$var$React.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value == null) setFilterValueState($bbbaea9771a9f69f$var$sanitizeFilterItemValue(item.value));
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($bbbaea9771a9f69f$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $bbbaea9771a9f69f$var$_extends2.default)({
                id: id,
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                value: filterValueState ?? '',
                onChange: onFilterChange,
                type: type || 'text',
                disabled: disabled,
                slotProps: (0, $bbbaea9771a9f69f$var$_extends2.default)({}, textFieldProps?.slotProps, {
                    input: (0, $bbbaea9771a9f69f$var$_extends2.default)({
                        endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                            fontSize: "small",
                            color: "action"
                        }) : null
                    }, textFieldProps?.slotProps?.input),
                    htmlInput: (0, $bbbaea9771a9f69f$var$_extends2.default)({
                        tabIndex: tabIndex
                    }, textFieldProps?.slotProps?.htmlInput)
                }),
                inputRef: focusElementRef
            }, rootProps.slotProps?.baseTextField, other, textFieldProps)),
            headerFilterMenu,
            clearButton
        ]
    });
}
function $bbbaea9771a9f69f$var$sanitizeFilterItemValue(value) {
    if (value == null || value === '') return undefined;
    return String(value);
}

});

parcelRegister("lR3Vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clamp = void 0;
module.exports.createRandomNumberGenerator = $fe919794eb3b24e8$var$createRandomNumberGenerator;
module.exports.deepClone = $fe919794eb3b24e8$var$deepClone;
module.exports.escapeRegExp = $fe919794eb3b24e8$var$escapeRegExp;
module.exports.eslintUseValue = $fe919794eb3b24e8$var$eslintUseValue;
module.exports.isFunction = $fe919794eb3b24e8$var$isFunction;
module.exports.isNumber = $fe919794eb3b24e8$var$isNumber;
module.exports.isObject = $fe919794eb3b24e8$var$isObject;
module.exports.localStorageAvailable = $fe919794eb3b24e8$var$localStorageAvailable;
module.exports.range = $fe919794eb3b24e8$var$range;
module.exports.runIf = void 0;
function $fe919794eb3b24e8$var$isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $fe919794eb3b24e8$var$isFunction(value) {
    return typeof value === 'function';
}
function $fe919794eb3b24e8$var$isObject(value) {
    return typeof value === 'object' && value !== null;
}
function $fe919794eb3b24e8$var$localStorageAvailable() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $fe919794eb3b24e8$var$escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
/**
 * Follows the CSS specification behavior for min and max
 * If min > max, then the min have priority
 */ const $fe919794eb3b24e8$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
/**
 * Create an array containing the range [from, to[
 */ module.exports.clamp = $fe919794eb3b24e8$var$clamp;
function $fe919794eb3b24e8$var$range(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $fe919794eb3b24e8$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
/**
 * Create a random number generator from a seed. The seed
 * ensures that the random number generator produces the
 * same sequence of 'random' numbers on every render. It
 * returns a function that generates a random number between
 * a specified min and max.
 */ function $fe919794eb3b24e8$var$createRandomNumberGenerator(seed) {
    const random = $fe919794eb3b24e8$var$mulberry32(seed);
    return (min, max)=>min + (max - min) * random();
}
function $fe919794eb3b24e8$var$deepClone(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
/**
 * Mark a value as used so eslint doesn't complain. Use this instead
 * of a `eslint-disable-next-line react-hooks/exhaustive-deps` because
 * that hint disables checks on all values instead of just one.
 */ function $fe919794eb3b24e8$var$eslintUseValue(_) {}
const $fe919794eb3b24e8$var$runIf = (condition, fn)=>(...params)=>{
        if (condition) fn(...params);
    };
module.exports.runIf = $fe919794eb3b24e8$var$runIf;

});

parcelRegister("6tiPX", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4b64102825ff1e40$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4b64102825ff1e40$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterInputMultipleValue = $4b64102825ff1e40$var$GridFilterInputMultipleValue;

var $4b64102825ff1e40$var$_extends2 = $4b64102825ff1e40$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4b64102825ff1e40$var$React = $4b64102825ff1e40$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4b64102825ff1e40$var$_propTypes = $4b64102825ff1e40$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4b64102825ff1e40$var$_useId = $4b64102825ff1e40$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $4b64102825ff1e40$var$GridFilterInputMultipleValue(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps } = props;
    const id = (0, $4b64102825ff1e40$var$_useId.default)();
    const [options, setOptions] = $4b64102825ff1e40$var$React.useState([]);
    const [filterValueState, setFilterValueState] = $4b64102825ff1e40$var$React.useState(item.value || []);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    $4b64102825ff1e40$var$React.useEffect(()=>{
        const itemValue = item.value ?? [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $4b64102825ff1e40$var$React.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $4b64102825ff1e40$var$_extends2.default)({}, item, {
            value: [
                ...value.map((filterItemValue)=>type === 'number' ? Number(filterItemValue) : filterItemValue)
            ]
        }));
    }, [
        applyValue,
        item,
        type
    ]);
    const handleInputChange = $4b64102825ff1e40$var$React.useCallback((event, value)=>{
        if (value === '') setOptions([]);
        else setOptions([
            value
        ]);
    }, [
        setOptions
    ]);
    const BaseAutocomplete = rootProps.slots.baseAutocomplete;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(BaseAutocomplete, (0, $4b64102825ff1e40$var$_extends2.default)({
        multiple: true,
        freeSolo: true,
        options: options,
        id: id,
        value: filterValueState,
        onChange: handleChange,
        onInputChange: handleInputChange,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        slotProps: {
            textField: {
                type: type || 'text',
                inputRef: focusElementRef
            }
        }
    }, slotProps?.root));
}

});

parcelRegister("14dIX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0c70cf7c1343c218$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldQuickFilterExcludeHiddenColumns = module.exports.sanitizeFilterModel = module.exports.removeDiacritics = module.exports.passFilterLogic = module.exports.mergeStateWithFilterModel = module.exports.cleanFilterItem = module.exports.buildAggregatedFilterApplier = void 0;

var $0c70cf7c1343c218$var$_extends2 = $0c70cf7c1343c218$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $42Qr7 = parcelRequire("42Qr7");

var $l4QMb = parcelRequire("l4QMb");

var $dmvst = parcelRequire("dmvst");

var $jy68d = parcelRequire("jy68d");
let $0c70cf7c1343c218$var$hasEval;
function $0c70cf7c1343c218$var$getHasEval() {
    if ($0c70cf7c1343c218$var$hasEval !== undefined) return $0c70cf7c1343c218$var$hasEval;
    try {
        // eslint-disable-next-line no-new-func
        $0c70cf7c1343c218$var$hasEval = new Function('return true')();
    } catch (_) {
        $0c70cf7c1343c218$var$hasEval = false;
    }
    return $0c70cf7c1343c218$var$hasEval;
}
/**
 * Adds default values to the optional fields of a filter items.
 * @param {GridFilterItem} item The raw filter item.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @return {GridFilterItem} The clean filter item with an uniq ID and an always-defined operator.
 * TODO: Make the typing reflect the different between GridFilterInputItem and GridFilterItem.
 */ const $0c70cf7c1343c218$var$cleanFilterItem = (item, apiRef)=>{
    const cleanItem = (0, $0c70cf7c1343c218$var$_extends2.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $jy68d.gridColumnLookupSelector)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
module.exports.cleanFilterItem = $0c70cf7c1343c218$var$cleanFilterItem;
const $0c70cf7c1343c218$var$sanitizeFilterModel = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        (0, $9Y8Cp.warnOnce)([
            'MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.',
            'If you are using the community version of the Data Grid, this prop is always `true`.'
        ], 'error');
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemsWithoutIds) (0, $9Y8Cp.warnOnce)('MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.', 'error');
    if (hasItemWithoutOperator) (0, $9Y8Cp.warnOnce)('MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.', 'error');
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $0c70cf7c1343c218$var$_extends2.default)({}, model, {
        items: items.map((item)=>$0c70cf7c1343c218$var$cleanFilterItem(item, apiRef))
    });
    if (model.items !== items) return (0, $0c70cf7c1343c218$var$_extends2.default)({}, model, {
        items: items
    });
    return model;
};
module.exports.sanitizeFilterModel = $0c70cf7c1343c218$var$sanitizeFilterModel;
const $0c70cf7c1343c218$var$mergeStateWithFilterModel = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $0c70cf7c1343c218$var$_extends2.default)({}, filteringState, {
            filterModel: $0c70cf7c1343c218$var$sanitizeFilterModel(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
module.exports.mergeStateWithFilterModel = $0c70cf7c1343c218$var$mergeStateWithFilterModel;
const $0c70cf7c1343c218$var$removeDiacritics = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
module.exports.removeDiacritics = $0c70cf7c1343c218$var$removeDiacritics;
const $0c70cf7c1343c218$var$getFilterCallbackFromItem = (filterItem, filterValueGetter, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? filterItem.value?.map((x)=>parser(x, undefined, column, apiRef)) : parser(filterItem.value, undefined, column, apiRef);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $0c70cf7c1343c218$var$removeDiacritics(parsedValue);
    const newFilterItem = (0, $0c70cf7c1343c218$var$_extends2.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!filterOperators?.length) throw new Error(`MUI X: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI X: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const publicApiRef = (0, $dmvst.getPublicApiRef)(apiRef);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        item: newFilterItem,
        fn: (row)=>{
            let value = filterValueGetter(row, column);
            if (ignoreDiacritics) value = $0c70cf7c1343c218$var$removeDiacritics(value);
            return applyFilterOnRow(value, row, column, publicApiRef);
        }
    };
};
let $0c70cf7c1343c218$var$filterItemsApplierId = 1;
/**
 * @name filterValueGetter
 * @param {GridRowModel} row The row to get the value from.
 * @param {GridColDef} column The column that the filter is applied on.
 *
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {FilterValueGetterFn} filterValueGetter The function to get the value to filter by.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier = (filterModel, filterValueGetter, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, filterValueGetter, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$0c70cf7c1343c218$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.fn(row);
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, for example `{ [dynamicKey]: value }`.
    // eslint-disable-next-line no-new-func
    const filterItemCore = new Function('appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i} ? false : appliers[${i}].fn(row),`).join('\n')}
};

return result$$;`.replaceAll('$$', String($0c70cf7c1343c218$var$filterItemsApplierId)));
    $0c70cf7c1343c218$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(appliers, row, shouldApplyItem);
    return filterItem;
};
const $0c70cf7c1343c218$var$shouldQuickFilterExcludeHiddenColumns = (filterModel)=>{
    return filterModel.quickFilterExcludeHiddenColumns ?? true;
};
/**
 * @name filterValueGetter
 * @param {GridRowModel} row The row to get the value from.
 * @param {GridColDef} column The column that the filter is applied on.
 *
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {FilterValueGetterFn} filterValueGetter The function to get the value to filter by.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ module.exports.shouldQuickFilterExcludeHiddenColumns = $0c70cf7c1343c218$var$shouldQuickFilterExcludeHiddenColumns;
const $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier = (filterModel, filterValueGetter, apiRef)=>{
    const quickFilterValues = filterModel.quickFilterValues?.filter(Boolean) ?? [];
    if (quickFilterValues.length === 0) return null;
    const allColumnFields = (0, $jy68d.gridColumnFieldsSelector)(apiRef);
    const columnVisibilityModel = (0, $jy68d.gridColumnVisibilityModelSelector)(apiRef);
    let columnFields;
    if ($0c70cf7c1343c218$var$shouldQuickFilterExcludeHiddenColumns(filterModel)) // Do not use gridVisibleColumnFieldsSelector here, because quick filter won't work in the list view mode
    // See https://github.com/mui/mui-x/issues/19145
    columnFields = allColumnFields.filter((field)=>columnVisibilityModel[field] !== false);
    else columnFields = allColumnFields;
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $dmvst.getPublicApiRef)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column?.getApplyQuickFilterFn;
        if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $0c70cf7c1343c218$var$removeDiacritics(quickFilterValue) : quickFilterValue;
                return {
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        /* eslint-disable no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = filterValueGetter(row, column);
                if (applier.fn === null) continue;
                if (ignoreDiacritics) value = $0c70cf7c1343c218$var$removeDiacritics(value);
                const isMatching = applier.fn(value, row, column, publicApiRef);
                if (isMatching) {
                    result[filterValue] = true;
                    continue outer;
                }
            }
            result[filterValue] = false;
        }
        return result;
    };
};
const $0c70cf7c1343c218$var$buildAggregatedFilterApplier = (filterModel, filterValueGetter, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $0c70cf7c1343c218$var$buildAggregatedFilterItemsApplier(filterModel, filterValueGetter, apiRef, disableEval);
    const isRowMatchingQuickFilter = $0c70cf7c1343c218$var$buildAggregatedQuickFilterApplier(filterModel, filterValueGetter, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        result.passingFilterItems = isRowMatchingFilterItems?.(row, shouldApplyFilter) ?? null;
        result.passingQuickFilterValues = isRowMatchingQuickFilter?.(row, shouldApplyFilter) ?? null;
    };
};
module.exports.buildAggregatedFilterApplier = $0c70cf7c1343c218$var$buildAggregatedFilterApplier;
const $0c70cf7c1343c218$var$isNotNull = (result)=>result != null;
const $0c70cf7c1343c218$var$filterModelItems = (cache, filterValueGetter, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$0c70cf7c1343c218$var$getFilterCallbackFromItem(item, filterValueGetter, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $0c70cf7c1343c218$var$passFilterLogic = (allFilterItemResults, allQuickFilterResults, filterModel, filterValueGetter, apiRef, cache)=>{
    const cleanedFilterItems = $0c70cf7c1343c218$var$filterModelItems(cache, filterValueGetter, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($0c70cf7c1343c218$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($0c70cf7c1343c218$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = filterModel.logicOperator ?? (0, $l4QMb.getDefaultGridFilterModel)().logicOperator;
        if (logicOperator === $42Qr7.GridLogicOperator.And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = filterModel.quickFilterLogicOperator ?? (0, $l4QMb.getDefaultGridFilterModel)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === $42Qr7.GridLogicOperator.And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};
module.exports.passFilterLogic = $0c70cf7c1343c218$var$passFilterLogic;

});
parcelRegister("42Qr7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2f20061a3ca46e99$var$_exportNames = {
    createRowSelectionManager: true
};
Object.defineProperty(module.exports, "createRowSelectionManager", {
    enumerable: true,
    get: function() {
        return $cgG30.createRowSelectionManager;
    }
});

var $5L07x = parcelRequire("5L07x");
Object.keys($5L07x).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5L07x[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5L07x[key];
        }
    });
});

var $iDyTD = parcelRequire("iDyTD");
Object.keys($iDyTD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iDyTD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iDyTD[key];
        }
    });
});

var $8HWOK = parcelRequire("8HWOK");
Object.keys($8HWOK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8HWOK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8HWOK[key];
        }
    });
});

var $jkRzp = parcelRequire("jkRzp");
Object.keys($jkRzp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jkRzp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jkRzp[key];
        }
    });
});

var $hhTVL = parcelRequire("hhTVL");
Object.keys($hhTVL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hhTVL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hhTVL[key];
        }
    });
});

var $9jXuN = parcelRequire("9jXuN");
Object.keys($9jXuN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9jXuN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9jXuN[key];
        }
    });
});

var $9kr1j = parcelRequire("9kr1j");
Object.keys($9kr1j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9kr1j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9kr1j[key];
        }
    });
});

var $hvfyU = parcelRequire("hvfyU");
Object.keys($hvfyU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hvfyU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hvfyU[key];
        }
    });
});

var $dZs3Z = parcelRequire("dZs3Z");
Object.keys($dZs3Z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dZs3Z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dZs3Z[key];
        }
    });
});

var $l4noO = parcelRequire("l4noO");
Object.keys($l4noO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $l4noO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l4noO[key];
        }
    });
});

var $eRkYG = parcelRequire("eRkYG");
Object.keys($eRkYG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eRkYG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eRkYG[key];
        }
    });
});

var $cgG30 = parcelRequire("cgG30");

var $bgHBx = parcelRequire("bgHBx");
Object.keys($bgHBx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bgHBx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bgHBx[key];
        }
    });
});

var $17It0 = parcelRequire("17It0");
Object.keys($17It0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $17It0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $17It0[key];
        }
    });
});

var $5tuKf = parcelRequire("5tuKf");
Object.keys($5tuKf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5tuKf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5tuKf[key];
        }
    });
});

var $3roLK = parcelRequire("3roLK");
Object.keys($3roLK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3roLK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3roLK[key];
        }
    });
});

var $gECC7 = parcelRequire("gECC7");
Object.keys($gECC7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gECC7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gECC7[key];
        }
    });
});

var $c0emy = parcelRequire("c0emy");
Object.keys($c0emy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c0emy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0emy[key];
        }
    });
});

var $1tGqH = parcelRequire("1tGqH");
Object.keys($1tGqH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1tGqH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1tGqH[key];
        }
    });
});

var $09XdJ = parcelRequire("09XdJ");
Object.keys($09XdJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $09XdJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $09XdJ[key];
        }
    });
});

var $9jsP5 = parcelRequire("9jsP5");
Object.keys($9jsP5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9jsP5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9jsP5[key];
        }
    });
});

var $gkM3N = parcelRequire("gkM3N");
Object.keys($gkM3N).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gkM3N[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gkM3N[key];
        }
    });
});

var $j57st = parcelRequire("j57st");
Object.keys($j57st).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $j57st[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j57st[key];
        }
    });
});

var $fzLcb = parcelRequire("fzLcb");
Object.keys($fzLcb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2f20061a3ca46e99$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fzLcb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fzLcb[key];
        }
    });
});

});
parcelRegister("5L07x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dvmjJ = parcelRequire("dvmjJ");
Object.keys($dvmjJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dvmjJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dvmjJ[key];
        }
    });
});

var $l24fg = parcelRequire("l24fg");
Object.keys($l24fg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l24fg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l24fg[key];
        }
    });
});

});
parcelRegister("dvmjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l24fg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("iDyTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8HWOK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jkRzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRowModes = module.exports.GridEditModes = module.exports.GridCellModes = void 0;
var $e139707caeafbfd6$var$GridEditModes = module.exports.GridEditModes = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($e139707caeafbfd6$var$GridEditModes || {});
var $e139707caeafbfd6$var$GridCellModes = module.exports.GridCellModes = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($e139707caeafbfd6$var$GridCellModes || {});
var $e139707caeafbfd6$var$GridRowModes = module.exports.GridRowModes = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($e139707caeafbfd6$var$GridRowModes || {});

});

parcelRegister("hhTVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9jXuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridLogicOperator = void 0;
/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $6c940a0517b1c6d5$var$GridLogicOperator = module.exports.GridLogicOperator = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($6c940a0517b1c6d5$var$GridLogicOperator || {});

});

parcelRegister("9kr1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hvfyU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dZs3Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l4noO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eRkYG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cgG30", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createRowSelectionManager = void 0;
class $8ee7986d138c7e40$var$IncludeManager {
    constructor(model){
        this.data = model.ids;
    }
    has(id) {
        return this.data.has(id);
    }
    select(id) {
        this.data.add(id);
    }
    unselect(id) {
        this.data.delete(id);
    }
}
class $8ee7986d138c7e40$var$ExcludeManager {
    constructor(model){
        this.data = model.ids;
    }
    has(id) {
        return !this.data.has(id);
    }
    select(id) {
        this.data.delete(id);
    }
    unselect(id) {
        this.data.add(id);
    }
}
const $8ee7986d138c7e40$var$createRowSelectionManager = (model)=>{
    if (model.type === 'include') return new $8ee7986d138c7e40$var$IncludeManager(model);
    return new $8ee7986d138c7e40$var$ExcludeManager(model);
};
module.exports.createRowSelectionManager = $8ee7986d138c7e40$var$createRowSelectionManager;

});

parcelRegister("bgHBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2t9QD = parcelRequire("2t9QD");
Object.keys($2t9QD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2t9QD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2t9QD[key];
        }
    });
});

var $gXVdq = parcelRequire("gXVdq");
Object.keys($gXVdq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gXVdq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gXVdq[key];
        }
    });
});

var $2pAk5 = parcelRequire("2pAk5");
Object.keys($2pAk5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2pAk5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2pAk5[key];
        }
    });
});

var $f2t4l = parcelRequire("f2t4l");
Object.keys($f2t4l).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $f2t4l[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f2t4l[key];
        }
    });
});

var $iNfie = parcelRequire("iNfie");
Object.keys($iNfie).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iNfie[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iNfie[key];
        }
    });
});

var $jfE7J = parcelRequire("jfE7J");
Object.keys($jfE7J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jfE7J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jfE7J[key];
        }
    });
});

var $3N6Z4 = parcelRequire("3N6Z4");
Object.keys($3N6Z4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3N6Z4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3N6Z4[key];
        }
    });
});

var $6kaae = parcelRequire("6kaae");
Object.keys($6kaae).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6kaae[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6kaae[key];
        }
    });
});

var $4NUyv = parcelRequire("4NUyv");
Object.keys($4NUyv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4NUyv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4NUyv[key];
        }
    });
});

var $8lFIH = parcelRequire("8lFIH");
Object.keys($8lFIH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8lFIH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8lFIH[key];
        }
    });
});

var $iNNvC = parcelRequire("iNNvC");
Object.keys($iNNvC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iNNvC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iNNvC[key];
        }
    });
});

var $cjhWA = parcelRequire("cjhWA");
Object.keys($cjhWA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cjhWA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cjhWA[key];
        }
    });
});

var $expI9 = parcelRequire("expI9");
Object.keys($expI9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $expI9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $expI9[key];
        }
    });
});

});
parcelRegister("2t9QD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gXVdq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2pAk5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("f2t4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iNfie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridCellEditStopReasons = module.exports.GridCellEditStartReasons = void 0;
/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $dae8aa7db1c69e5a$var$GridCellEditStartReasons = module.exports.GridCellEditStartReasons = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($dae8aa7db1c69e5a$var$GridCellEditStartReasons || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $dae8aa7db1c69e5a$var$GridCellEditStopReasons = module.exports.GridCellEditStopReasons = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($dae8aa7db1c69e5a$var$GridCellEditStopReasons || {}); /**
 * Params passed to the `cellEditStop event.
 */  // https://github.com/mui/mui-x/pull/3738#discussion_r798504277

});

parcelRegister("jfE7J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRowEditStopReasons = module.exports.GridRowEditStartReasons = void 0;
/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master-detail row panels](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $e03e8aca644cf2db$var$GridRowEditStartReasons = module.exports.GridRowEditStartReasons = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($e03e8aca644cf2db$var$GridRowEditStartReasons || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $e03e8aca644cf2db$var$GridRowEditStopReasons = module.exports.GridRowEditStopReasons = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($e03e8aca644cf2db$var$GridRowEditStopReasons || {}); /**
 * Object passed as parameter in the row `getRowSpacing` callback prop.
 * @demos
 *   - [Row spacing](/x/react-data-grid/row-height/#row-spacing)
 */  /**
 * The getRowSpacing return value.
 */  // https://github.com/mui/mui-x/pull/3738#discussion_r798504277

});

parcelRegister("3N6Z4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6kaae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4NUyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8lFIH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iNNvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cjhWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("expI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("17It0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5tuKf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3roLK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gECC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gCFiK = parcelRequire("gCFiK");
Object.keys($gCFiK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gCFiK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gCFiK[key];
        }
    });
});

var $lXIwC = parcelRequire("lXIwC");
Object.keys($lXIwC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lXIwC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lXIwC[key];
        }
    });
});

var $e1j0t = parcelRequire("e1j0t");
Object.keys($e1j0t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $e1j0t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e1j0t[key];
        }
    });
});

var $30gzF = parcelRequire("30gzF");
Object.keys($30gzF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $30gzF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $30gzF[key];
        }
    });
});

var $ccyBN = parcelRequire("ccyBN");
Object.keys($ccyBN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ccyBN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ccyBN[key];
        }
    });
});

var $BiXFb = parcelRequire("BiXFb");
Object.keys($BiXFb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $BiXFb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $BiXFb[key];
        }
    });
});

var $eUkwf = parcelRequire("eUkwf");
Object.keys($eUkwf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eUkwf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eUkwf[key];
        }
    });
});

var $k4HiI = parcelRequire("k4HiI");
Object.keys($k4HiI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k4HiI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k4HiI[key];
        }
    });
});

var $anfO9 = parcelRequire("anfO9");
Object.keys($anfO9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $anfO9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $anfO9[key];
        }
    });
});

var $bW994 = parcelRequire("bW994");
Object.keys($bW994).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bW994[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bW994[key];
        }
    });
});

var $1JHDA = parcelRequire("1JHDA");
Object.keys($1JHDA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1JHDA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1JHDA[key];
        }
    });
});

});
parcelRegister("gCFiK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lXIwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("e1j0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("30gzF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ccyBN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("BiXFb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eUkwf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("k4HiI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("anfO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bW994", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1JHDA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("c0emy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1tGqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("09XdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9jsP5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gkM3N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $frOK7 = parcelRequire("frOK7");
Object.keys($frOK7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $frOK7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $frOK7[key];
        }
    });
});

var $34wwU = parcelRequire("34wwU");
Object.keys($34wwU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $34wwU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $34wwU[key];
        }
    });
});

var $fIxDv = parcelRequire("fIxDv");
Object.keys($fIxDv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fIxDv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fIxDv[key];
        }
    });
});

});
parcelRegister("frOK7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("34wwU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fIxDv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("j57st", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLeaf = $de4444ff1794c3fb$var$isLeaf;
function $de4444ff1794c3fb$var$isLeaf(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 * @param {GridColumnGroupHeaderParams} params The parameters of the column group header.
 * @returns {string} The class name to be added to the column group header cell.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 

});

parcelRegister("fzLcb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("l4QMb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultGridFilterModel = module.exports.defaultGridFilterLookup = void 0;

var $9jXuN = parcelRequire("9jXuN");
const $f582e8f6fdde33c9$var$defaultGridFilterLookup = module.exports.defaultGridFilterLookup = {
    filteredRowsLookup: {},
    filteredChildrenCountLookup: {},
    filteredDescendantCountLookup: {}
};
const $f582e8f6fdde33c9$var$getDefaultGridFilterModel = ()=>({
        items: [],
        logicOperator: $9jXuN.GridLogicOperator.And,
        quickFilterValues: [],
        quickFilterLogicOperator: $9jXuN.GridLogicOperator.And
    });
/**
 * @param {GridValidRowModel} row The model of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 * @param {GridAggregatedFilterItemApplierResult} result The previous result of the filtering engine.
 */ /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ module.exports.getDefaultGridFilterModel = $f582e8f6fdde33c9$var$getDefaultGridFilterModel;

});

parcelRegister("dmvst", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPublicApiRef = $9ba5bb68a0cac1c6$var$getPublicApiRef;
function $9ba5bb68a0cac1c6$var$getPublicApiRef(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}

});

parcelRegister("jy68d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e3b5f2e67362f55f$var$_exportNames = {
    gridColumnsStateSelector: true,
    gridColumnFieldsSelector: true,
    gridColumnLookupSelector: true,
    gridColumnVisibilityModelSelector: true,
    gridColumnDefinitionsSelector: true,
    gridVisibleColumnDefinitionsSelector: true,
    gridVisibleColumnFieldsSelector: true,
    gridPinnedColumnsSelector: true,
    gridVisiblePinnedColumnDefinitionsSelector: true,
    gridColumnPositionsSelector: true,
    gridFilterableColumnDefinitionsSelector: true,
    gridFilterableColumnLookupSelector: true,
    gridHasColSpanSelector: true
};
Object.defineProperty(module.exports, "gridColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridColumnDefinitionsSelector;
    }
});
Object.defineProperty(module.exports, "gridColumnFieldsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridColumnFieldsSelector;
    }
});
Object.defineProperty(module.exports, "gridColumnLookupSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridColumnLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridColumnPositionsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridColumnPositionsSelector;
    }
});
Object.defineProperty(module.exports, "gridColumnVisibilityModelSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridColumnVisibilityModelSelector;
    }
});
Object.defineProperty(module.exports, "gridColumnsStateSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridColumnsStateSelector;
    }
});
Object.defineProperty(module.exports, "gridFilterableColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridFilterableColumnDefinitionsSelector;
    }
});
Object.defineProperty(module.exports, "gridFilterableColumnLookupSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridFilterableColumnLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridHasColSpanSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridHasColSpanSelector;
    }
});
Object.defineProperty(module.exports, "gridPinnedColumnsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridPinnedColumnsSelector;
    }
});
Object.defineProperty(module.exports, "gridVisibleColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridVisibleColumnDefinitionsSelector;
    }
});
Object.defineProperty(module.exports, "gridVisibleColumnFieldsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridVisibleColumnFieldsSelector;
    }
});
Object.defineProperty(module.exports, "gridVisiblePinnedColumnDefinitionsSelector", {
    enumerable: true,
    get: function() {
        return $jQEEt.gridVisiblePinnedColumnDefinitionsSelector;
    }
});

var $jQEEt = parcelRequire("jQEEt");

var $4ZMWQ = parcelRequire("4ZMWQ");
Object.keys($4ZMWQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e3b5f2e67362f55f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4ZMWQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4ZMWQ[key];
        }
    });
});

});
parcelRegister("jQEEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridVisiblePinnedColumnDefinitionsSelector = module.exports.gridVisibleColumnFieldsSelector = module.exports.gridVisibleColumnDefinitionsSelector = module.exports.gridPinnedColumnsSelector = module.exports.gridInitialColumnVisibilityModelSelector = module.exports.gridHasColSpanSelector = module.exports.gridFilterableColumnLookupSelector = module.exports.gridFilterableColumnDefinitionsSelector = module.exports.gridExistingPinnedColumnSelector = module.exports.gridColumnsStateSelector = module.exports.gridColumnVisibilityModelSelector = module.exports.gridColumnPositionsSelector = module.exports.gridColumnLookupSelector = module.exports.gridColumnFieldsSelector = module.exports.gridColumnDefinitionsSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $9Yhwe = parcelRequire("9Yhwe");

var $RWGMa = parcelRequire("RWGMa");
/**
 * Get the columns state
 * @category Columns
 */ const $e732684465924d20$var$gridColumnsStateSelector = module.exports.gridColumnsStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.columns);
/**
 * Get an array of column fields in the order rendered on screen.
 * @category Columns
 */ const $e732684465924d20$var$gridColumnFieldsSelector = module.exports.gridColumnFieldsSelector = (0, $cgQ4y.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.orderedFields);
/**
 * Get the columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Columns
 */ const $e732684465924d20$var$gridColumnLookupSelector = module.exports.gridColumnLookupSelector = (0, $cgQ4y.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.lookup);
/**
 * Get an array of column definitions in the order rendered on screen..
 * @category Columns
 */ const $e732684465924d20$var$gridColumnDefinitionsSelector = module.exports.gridColumnDefinitionsSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridColumnFieldsSelector, $e732684465924d20$var$gridColumnLookupSelector, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
/**
 * Get the column visibility model, containing the visibility status of each column.
 * If a column is not registered in the model, it is visible.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridColumnVisibilityModelSelector = module.exports.gridColumnVisibilityModelSelector = (0, $cgQ4y.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.columnVisibilityModel);
/**
 * Get the "initial" column visibility model, containing the visibility status of each column.
 * It is updated when the `columns` prop is updated or when `updateColumns` API method is called.
 * If a column is not registered in the model, it is visible.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridInitialColumnVisibilityModelSelector = module.exports.gridInitialColumnVisibilityModelSelector = (0, $cgQ4y.createSelector)($e732684465924d20$var$gridColumnsStateSelector, (columnsState)=>columnsState.initialColumnVisibilityModel);
/**
 * Get the visible columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Visible Columns
 */ const $e732684465924d20$var$gridVisibleColumnDefinitionsSelector = module.exports.gridVisibleColumnDefinitionsSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, $e732684465924d20$var$gridColumnVisibilityModelSelector, $RWGMa.gridListViewSelector, $RWGMa.gridListColumnSelector, (columns, columnVisibilityModel, listView, listColumn)=>listView && listColumn ? [
        listColumn
    ] : columns.filter((column)=>columnVisibilityModel[column.field] !== false));
/**
 * Get the field of each visible column.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridVisibleColumnFieldsSelector = module.exports.gridVisibleColumnFieldsSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridVisibleColumnDefinitionsSelector, (visibleColumns)=>visibleColumns.map((column)=>column.field));
/**
 * Get the visible pinned columns model.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridPinnedColumnsSelector = module.exports.gridPinnedColumnsSelector = (0, $cgQ4y.createRootSelector)((state)=>state.pinnedColumns);
/**
 * Get all existing pinned columns. Place the columns on the side that depends on the rtl state.
 * @category Pinned Columns
 * @ignore - Do not document
 */ const $e732684465924d20$var$gridExistingPinnedColumnSelector = module.exports.gridExistingPinnedColumnSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridPinnedColumnsSelector, $e732684465924d20$var$gridColumnFieldsSelector, $9Yhwe.gridIsRtlSelector, (model, orderedFields, isRtl)=>$e732684465924d20$var$filterMissingColumns(model, orderedFields, isRtl));
/**
 * Get the visible pinned columns.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridVisiblePinnedColumnDefinitionsSelector = module.exports.gridVisiblePinnedColumnDefinitionsSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridColumnsStateSelector, $e732684465924d20$var$gridPinnedColumnsSelector, $e732684465924d20$var$gridVisibleColumnFieldsSelector, $9Yhwe.gridIsRtlSelector, $RWGMa.gridListViewSelector, (columnsState, model, visibleColumnFields, isRtl, listView)=>{
    if (listView) return $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS;
    const visiblePinnedFields = $e732684465924d20$var$filterMissingColumns(model, visibleColumnFields, isRtl);
    const visiblePinnedColumns = {
        left: visiblePinnedFields.left.map((field)=>columnsState.lookup[field]),
        right: visiblePinnedFields.right.map((field)=>columnsState.lookup[field])
    };
    return visiblePinnedColumns;
});
function $e732684465924d20$var$filterMissingColumns(pinnedColumns, columns, invert) {
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS;
    if (pinnedColumns.left?.length === 0 && pinnedColumns.right?.length === 0) return $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS;
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return {
        left: rightPinnedColumns,
        right: leftPinnedColumns
    };
    return {
        left: leftPinnedColumns,
        right: rightPinnedColumns
    };
}
/**
 * Get the left position in pixel of each visible columns relative to the left of the first column.
 * @category Visible Columns
 */ const $e732684465924d20$var$gridColumnPositionsSelector = module.exports.gridColumnPositionsSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridVisibleColumnDefinitionsSelector, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
/**
 * Get the filterable columns as an array.
 * @category Columns
 */ const $e732684465924d20$var$gridFilterableColumnDefinitionsSelector = module.exports.gridFilterableColumnDefinitionsSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, (columns)=>columns.filter((col)=>col.filterable));
/**
 * Get the filterable columns as a lookup (an object containing the field for keys and the definition for values).
 * @category Columns
 */ const $e732684465924d20$var$gridFilterableColumnLookupSelector = module.exports.gridFilterableColumnLookupSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
/**
 * Checks if some column has a colSpan field.
 * @category Columns
 * @ignore - Do not document
 */ const $e732684465924d20$var$gridHasColSpanSelector = module.exports.gridHasColSpanSelector = (0, $cgQ4y.createSelectorMemoized)($e732684465924d20$var$gridColumnDefinitionsSelector, (columns)=>columns.some((column)=>column.colSpan !== undefined));

});
parcelRegister("4ZMWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPinnedColumnPosition = module.exports.EMPTY_PINNED_COLUMN_FIELDS = void 0;
let $3a32d3fdbf8b29fd$var$GridPinnedColumnPosition = module.exports.GridPinnedColumnPosition = /*#__PURE__*/ function(GridPinnedColumnPosition) {
    GridPinnedColumnPosition["LEFT"] = "left";
    GridPinnedColumnPosition["RIGHT"] = "right";
    return GridPinnedColumnPosition;
}({});
const $3a32d3fdbf8b29fd$var$EMPTY_PINNED_COLUMN_FIELDS = module.exports.EMPTY_PINNED_COLUMN_FIELDS = {
    left: [],
    right: []
};

});

parcelRegister("9Yhwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridIsRtlSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
/**
 * Get the theme state
 * @category Core
 */ const $74274e8a7594bea9$var$gridIsRtlSelector = module.exports.gridIsRtlSelector = (0, $cgQ4y.createRootSelector)((state)=>state.isRtl);

});

parcelRegister("RWGMa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8BltG = parcelRequire("8BltG");
Object.keys($8BltG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8BltG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8BltG[key];
        }
    });
});

});
parcelRegister("8BltG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridListViewSelector = module.exports.gridListColumnSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
/**
 * Get the list view state
 * @category List View
 * @ignore - Do not document
 */ const $6432707a9c80427e$var$gridListViewSelector = module.exports.gridListViewSelector = (0, $cgQ4y.createRootSelector)((state)=>state.props.listView ?? false);
/**
 * Get the list column definition
 * @category List View
 * @ignore - Do not document
 */ const $6432707a9c80427e$var$gridListColumnSelector = module.exports.gridListColumnSelector = (0, $cgQ4y.createRootSelector)((state)=>state.listViewColumn);

});







parcelRegister("cc312", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8e08f1e439e1e2b5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8e08f1e439e1e2b5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridActionsCell = $8e08f1e439e1e2b5$var$GridActionsCell;
module.exports.renderActionsCell = void 0;

var $8e08f1e439e1e2b5$var$_extends2 = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8e08f1e439e1e2b5$var$_objectWithoutPropertiesLoose2 = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("c05no")));

var $8e08f1e439e1e2b5$var$React = $8e08f1e439e1e2b5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8e08f1e439e1e2b5$var$_propTypes = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9uEev = parcelRequire("9uEev");

var $8e08f1e439e1e2b5$var$_useId = $8e08f1e439e1e2b5$require$_interopRequireDefault((parcelRequire("hwliF")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $5H1vo = parcelRequire("5H1vo");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $7vSxY = parcelRequire("7vSxY");

var $ayMG0 = parcelRequire("ayMG0");
const $8e08f1e439e1e2b5$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "onMenuOpen",
    "onMenuClose",
    "children",
    "suppressChildrenValidation"
];
const $8e08f1e439e1e2b5$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $8e08f1e439e1e2b5$var$GridActionsCell(props) {
    const { id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, children: children, suppressChildrenValidation: suppressChildrenValidation } = props, other = (0, $8e08f1e439e1e2b5$var$_objectWithoutPropertiesLoose2.default)(props, $8e08f1e439e1e2b5$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $8e08f1e439e1e2b5$var$React.useState(-1);
    const [open, setOpen] = $8e08f1e439e1e2b5$var$React.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootRef = $8e08f1e439e1e2b5$var$React.useRef(null);
    const buttonRef = $8e08f1e439e1e2b5$var$React.useRef(null);
    const ignoreCallToFocus = $8e08f1e439e1e2b5$var$React.useRef(false);
    const touchRippleRefs = $8e08f1e439e1e2b5$var$React.useRef({});
    const isRtl = (0, $9uEev.useRtl)();
    const menuId = (0, $8e08f1e439e1e2b5$var$_useId.default)();
    const buttonId = (0, $8e08f1e439e1e2b5$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const rowParams = apiRef.current.getRowParams(id);
    const actions = [];
    $8e08f1e439e1e2b5$var$React.Children.forEach(children, (child)=>{
        // Unwrap React.Fragment
        if (/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.isValidElement(child)) {
            if (child.type === $8e08f1e439e1e2b5$var$React.Fragment) $8e08f1e439e1e2b5$var$React.Children.forEach(child.props.children, (fragChild)=>{
                if (/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.isValidElement(fragChild)) actions.push(fragChild);
            });
            else if (child.type === $7vSxY.GridActionsCellItem || suppressChildrenValidation) actions.push(child);
            else {
                const childType = typeof child.type === 'function' ? child.type.name : child.type;
                (0, $9Y8Cp.warnOnce)(`MUI X: Invalid child type in \`GridActionsCell\`. Expected \`GridActionsCellItem\` or \`React.Fragment\`, got \`${childType}\`.
If this is intentional, you can suppress this warning by passing the \`suppressChildrenValidation\` prop to \`GridActionsCell\`.`, 'error');
            }
        }
    });
    const iconButtons = actions.filter((option)=>!option.props.showInMenu);
    const menuButtons = actions.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $8e08f1e439e1e2b5$var$React.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref?.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $8e08f1e439e1e2b5$var$React.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    const firstFocusableButtonIndex = actions.findIndex((o)=>!o.props.disabled);
    $8e08f1e439e1e2b5$var$React.useEffect(()=>{
        if (hasFocus && focusedButtonIndex === -1) setFocusedButtonIndex(firstFocusableButtonIndex);
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus,
        focusedButtonIndex,
        firstFocusableButtonIndex
    ]);
    $8e08f1e439e1e2b5$var$React.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = (event)=>{
        if (onMenuOpen && !onMenuOpen(rowParams, event)) return;
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = (event)=>{
        if (onMenuClose && !onMenuClose(rowParams, event)) return;
        setOpen(false);
    };
    const toggleMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (open) hideMenu(event);
        else showMenu(event);
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            if (index < 0 || index > actions.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = isRtl ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return actions[index + indexMod]?.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    // role="menu" requires at least one child element
    const attributes = numberOfButtons > 0 ? {
        role: 'menu',
        onKeyDown: handleRootKeyDown
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8e08f1e439e1e2b5$var$_extends2.default)({
        ref: rootRef,
        tabIndex: -1,
        className: $5H1vo.gridClasses.actionsCell
    }, attributes, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $8e08f1e439e1e2b5$var$_extends2.default)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: toggleMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($ch6XH.GridMenu, {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuList, {
                    id: menuId,
                    className: $5H1vo.gridClasses.menuList,
                    "aria-labelledby": buttonId,
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $8e08f1e439e1e2b5$var$React.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
// Temporary wrapper for backward compatibility.
// Only used to support `getActions` method in `GridColDef`.
// TODO(v9): Remove this wrapper and the default `renderCell` in gridActionsColDef
function $8e08f1e439e1e2b5$var$GridActionsCellWrapper(props) {
    const { colDef: colDef, id: id } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    if (!$8e08f1e439e1e2b5$var$hasActions(colDef)) throw new Error('MUI X: Missing the `getActions` property in the `GridColDef`.');
    const actions = colDef.getActions(apiRef.current.getRowParams(id));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8e08f1e439e1e2b5$var$GridActionsCell, (0, $8e08f1e439e1e2b5$var$_extends2.default)({
        suppressChildrenValidation: true
    }, props, {
        children: actions
    }));
}
const $8e08f1e439e1e2b5$var$renderActionsCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8e08f1e439e1e2b5$var$GridActionsCellWrapper, (0, $8e08f1e439e1e2b5$var$_extends2.default)({}, params));
module.exports.renderActionsCell = $8e08f1e439e1e2b5$var$renderActionsCell;

});
parcelRegister("ch6XH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8efc7911d5661cb8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8efc7911d5661cb8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridMenu = $8efc7911d5661cb8$var$GridMenu;

var $8efc7911d5661cb8$var$_extends2 = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8efc7911d5661cb8$var$_objectWithoutPropertiesLoose2 = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("c05no")));

var $8efc7911d5661cb8$var$React = $8efc7911d5661cb8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8efc7911d5661cb8$var$_propTypes = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8efc7911d5661cb8$var$_clsx = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8efc7911d5661cb8$var$_composeClasses = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8efc7911d5661cb8$var$_useEnhancedEffect = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8efc7911d5661cb8$var$_HTMLElementType = $8efc7911d5661cb8$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $8xDHs = parcelRequire("8xDHs");

var $dMF9H = parcelRequire("dMF9H");

var $hbuUJ = parcelRequire("hbuUJ");

var $3DWC3 = parcelRequire("3DWC3");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $j0vMH = parcelRequire("j0vMH");

var $ayMG0 = parcelRequire("ayMG0");
const $8efc7911d5661cb8$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $8efc7911d5661cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $8efc7911d5661cb8$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $8efc7911d5661cb8$var$GridMenuRoot = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'Menu'
})({
    zIndex: $hbuUJ.vars.zIndex.menu,
    [`& .${$5H1vo.gridClasses.menuList}`]: {
        outline: 0
    }
});
function $8efc7911d5661cb8$var$GridMenu(props) {
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $8efc7911d5661cb8$var$_objectWithoutPropertiesLoose2.default)(props, $8efc7911d5661cb8$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $8efc7911d5661cb8$var$useUtilityClasses(rootProps);
    const variablesClass = (0, $3DWC3.useCSSVariablesClass)();
    const savedFocusRef = $8efc7911d5661cb8$var$React.useRef(null);
    (0, $8efc7911d5661cb8$var$_useEnhancedEffect.default)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            savedFocusRef.current?.focus?.();
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $8efc7911d5661cb8$var$React.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target?.contains(event.target))) return;
        onClose(event);
    };
    const handleKeyDown = (event)=>{
        if ((0, $dMF9H.isHideMenuKey)(event.key)) onClose(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8efc7911d5661cb8$var$GridMenuRoot, (0, $8efc7911d5661cb8$var$_extends2.default)({
        as: rootProps.slots.basePopper,
        className: (0, $8efc7911d5661cb8$var$_clsx.default)(classes.root, className, variablesClass),
        ownerState: rootProps,
        open: open,
        target: target,
        transition: true,
        placement: position,
        onClickAway: handleClickAway,
        onExited: onExited,
        clickAwayMouseEvent: "onMouseDown",
        onKeyDown: handleKeyDown
    }, other, rootProps.slotProps?.basePopper, {
        children: children
    }));
}

});
parcelRegister("dMF9H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCopyShortcut = $a08faead7d1bb429$var$isCopyShortcut;
module.exports.isNavigationKey = module.exports.isKeyboardEvent = module.exports.isHideMenuKey = void 0;
module.exports.isPasteShortcut = $a08faead7d1bb429$var$isPasteShortcut;
module.exports.isPrintableKey = $a08faead7d1bb429$var$isPrintableKey;
module.exports.isRedoShortcut = $a08faead7d1bb429$var$isRedoShortcut;
module.exports.isUndoShortcut = $a08faead7d1bb429$var$isUndoShortcut;
// Non printable keys have a name, for example "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// So event.key.length === 1 is often enough.
//
// However, we also need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
function $a08faead7d1bb429$var$isPrintableKey(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $a08faead7d1bb429$var$isNavigationKey = (key)=>key.indexOf('Arrow') === 0 || key.indexOf('Page') === 0 || key === ' ' || key === 'Home' || key === 'End';
module.exports.isNavigationKey = $a08faead7d1bb429$var$isNavigationKey;
const $a08faead7d1bb429$var$isKeyboardEvent = (event)=>!!event.key;
module.exports.isKeyboardEvent = $a08faead7d1bb429$var$isKeyboardEvent;
const $a08faead7d1bb429$var$isHideMenuKey = (key)=>key === 'Tab' || key === 'Escape';
// In theory, on macOS, ctrl + v doesn't trigger a paste, so the function should return false.
// However, maybe it's overkill to fix, so let's be lazy.
module.exports.isHideMenuKey = $a08faead7d1bb429$var$isHideMenuKey;
function $a08faead7d1bb429$var$isPasteShortcut(event) {
    return (event.ctrlKey || event.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
    // for example, it would be another letter on a Dvorak physical keyboard.
    // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
    // for example, it would be ה on a Hebrew keyboard layout.
    // https://github.com/w3c/uievents/issues/377 could be a long-term solution
    String.fromCharCode(event.keyCode) === 'V' && !event.shiftKey && !event.altKey;
}
// Checks if the keyboard event corresponds to the copy shortcut (CTRL+C or CMD+C) across different localization keyboards.
function $a08faead7d1bb429$var$isCopyShortcut(event) {
    return (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'C' && !event.shiftKey && !event.altKey;
}
function $a08faead7d1bb429$var$isUndoShortcut(event) {
    return (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'Z' && !event.shiftKey && !event.altKey;
}
function $a08faead7d1bb429$var$isRedoShortcut(event) {
    return (event.ctrlKey || event.metaKey) && (String.fromCharCode(event.keyCode) === 'Z' && event.shiftKey || String.fromCharCode(event.keyCode) === 'Y' && !event.shiftKey) && !event.altKey;
}

});

parcelRegister("3DWC3", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2a727ae4835cc807$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridCSSVariablesContext = $2a727ae4835cc807$var$GridCSSVariablesContext;
module.exports.GridPortalWrapper = $2a727ae4835cc807$var$GridPortalWrapper;
module.exports.useCSSVariablesClass = $2a727ae4835cc807$var$useCSSVariablesClass;
module.exports.useCSSVariablesContext = $2a727ae4835cc807$var$useCSSVariablesContext;

var $2a727ae4835cc807$var$React = $2a727ae4835cc807$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");

var $3J8MS = parcelRequire("3J8MS");

var $ayMG0 = parcelRequire("ayMG0");
const $2a727ae4835cc807$var$CLASSNAME_PREFIX = 'MuiDataGridVariables';
const $2a727ae4835cc807$var$CSSVariablesContext = /*#__PURE__*/ $2a727ae4835cc807$var$React.createContext({
    className: 'unset',
    tag: /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
        href: "/unset"
    })
});
function $2a727ae4835cc807$var$useCSSVariablesClass() {
    return $2a727ae4835cc807$var$React.useContext($2a727ae4835cc807$var$CSSVariablesContext).className;
}
function $2a727ae4835cc807$var$useCSSVariablesContext() {
    return $2a727ae4835cc807$var$React.useContext($2a727ae4835cc807$var$CSSVariablesContext);
}
function $2a727ae4835cc807$var$GridPortalWrapper({ children: children }) {
    const className = $2a727ae4835cc807$var$useCSSVariablesClass();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: className,
        children: children
    });
}
function $2a727ae4835cc807$var$GridCSSVariablesContext(props) {
    const config = (0, $3J8MS.useGridConfiguration)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const description = config.hooks.useCSSVariables();
    const context = $2a727ae4835cc807$var$React.useMemo(()=>{
        const className = `${$2a727ae4835cc807$var$CLASSNAME_PREFIX}-${description.id}`;
        const cssString = `.${className}{${$2a727ae4835cc807$var$variablesToString(description.variables)}}`;
        const tag = /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
            href: `/${className}`,
            nonce: rootProps.nonce,
            children: cssString
        });
        return {
            className: className,
            tag: tag
        };
    }, [
        rootProps.nonce,
        description
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2a727ae4835cc807$var$CSSVariablesContext.Provider, {
        value: context,
        children: props.children
    });
}
function $2a727ae4835cc807$var$variablesToString(variables) {
    let output = '';
    for(const key in variables)if (Object.hasOwn(variables, key) && variables[key] !== undefined) output += `${key}:${variables[key]};`;
    return output;
}

});
parcelRegister("3J8MS", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2b6c64068d1db0b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridConfiguration = void 0;

var $2b6c64068d1db0b4$var$React = $2b6c64068d1db0b4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jdJe4 = parcelRequire("jdJe4");
const $2b6c64068d1db0b4$var$useGridConfiguration = ()=>{
    const configuration = $2b6c64068d1db0b4$var$React.useContext($jdJe4.GridConfigurationContext);
    if (configuration === undefined) throw new Error([
        'MUI X: Could not find the Data Grid configuration context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return configuration;
};
module.exports.useGridConfiguration = $2b6c64068d1db0b4$var$useGridConfiguration;

});
parcelRegister("jdJe4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $dfe2502031b16236$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridConfigurationContext = void 0;

var $dfe2502031b16236$var$React = $dfe2502031b16236$require$_interopRequireWildcard((parcelRequire("acw62")));
const $dfe2502031b16236$var$GridConfigurationContext = module.exports.GridConfigurationContext = /*#__PURE__*/ $dfe2502031b16236$var$React.createContext(undefined);

});




parcelRegister("7vSxY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5785bd871901a1ec$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5785bd871901a1ec$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridActionsCellItem = void 0;

var $5785bd871901a1ec$var$_extends2 = $5785bd871901a1ec$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5785bd871901a1ec$var$_objectWithoutPropertiesLoose2 = $5785bd871901a1ec$require$_interopRequireDefault((parcelRequire("c05no")));

var $5785bd871901a1ec$var$React = $5785bd871901a1ec$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $5785bd871901a1ec$var$_excluded = [
    "label",
    "icon",
    "showInMenu",
    "onClick"
], $5785bd871901a1ec$var$_excluded2 = [
    "label",
    "icon",
    "showInMenu",
    "onClick",
    "closeMenuOnClick",
    "closeMenu"
];
const $5785bd871901a1ec$var$GridActionsCellItem = module.exports.GridActionsCellItem = (0, $fYxgT.forwardRef)((props, ref)=>{
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (!props.showInMenu) {
        const { label: label, icon: icon, onClick: onClick } = props, other = (0, $5785bd871901a1ec$var$_objectWithoutPropertiesLoose2.default)(props, $5785bd871901a1ec$var$_excluded);
        const handleClick = (event)=>{
            onClick?.(event);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $5785bd871901a1ec$var$_extends2.default)({
            size: "small",
            role: "menuitem",
            "aria-label": label
        }, other, {
            onClick: handleClick
        }, rootProps.slotProps?.baseIconButton, {
            ref: ref,
            children: /*#__PURE__*/ $5785bd871901a1ec$var$React.cloneElement(icon, {
                fontSize: 'small'
            })
        }));
    }
    const { label: label, icon: icon, onClick: onClick, closeMenuOnClick: closeMenuOnClick = true, closeMenu: closeMenu } = props, other = (0, $5785bd871901a1ec$var$_objectWithoutPropertiesLoose2.default)(props, $5785bd871901a1ec$var$_excluded2);
    const handleClick = (event)=>{
        onClick?.(event);
        if (closeMenuOnClick) closeMenu?.();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $5785bd871901a1ec$var$_extends2.default)({
        ref: ref
    }, other, {
        onClick: handleClick,
        iconStart: icon,
        children: label
    }));
});

});



parcelRegister("iNueb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $daf44030e7d36790$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_BOOLEAN_COL_DEF = void 0;

var $daf44030e7d36790$var$_extends2 = $daf44030e7d36790$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bSL2h = parcelRequire("bSL2h");

var $8vJu2 = parcelRequire("8vJu2");

var $hsZ0E = parcelRequire("hsZ0E");

var $h8fXG = parcelRequire("h8fXG");

var $jWu8a = parcelRequire("jWu8a");
const $daf44030e7d36790$var$gridBooleanFormatter = (value, row, column, apiRef)=>{
    return value ? apiRef.current.getLocaleText('booleanCellTrueLabel') : apiRef.current.getLocaleText('booleanCellFalseLabel');
};
const $daf44030e7d36790$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $daf44030e7d36790$var$GRID_BOOLEAN_COL_DEF = module.exports.GRID_BOOLEAN_COL_DEF = (0, $daf44030e7d36790$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    type: 'boolean',
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    renderCell: $8vJu2.renderBooleanCell,
    renderEditCell: $hsZ0E.renderEditBooleanCell,
    sortComparator: $h8fXG.gridNumberComparator,
    valueFormatter: $daf44030e7d36790$var$gridBooleanFormatter,
    filterOperators: (0, $jWu8a.getGridBooleanOperators)(),
    getApplyQuickFilterFn: ()=>null,
    // @ts-ignore
    chartable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$daf44030e7d36790$var$stringToBoolean(value)
});

});
parcelRegister("8vJu2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6324800d89fce0fa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6324800d89fce0fa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderBooleanCell = module.exports.GridBooleanCell = void 0;

var $6324800d89fce0fa$var$_extends2 = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6324800d89fce0fa$var$_objectWithoutPropertiesLoose2 = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("c05no")));

var $6324800d89fce0fa$var$React = $6324800d89fce0fa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6324800d89fce0fa$var$_propTypes = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6324800d89fce0fa$var$_composeClasses = $6324800d89fce0fa$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $7sDf4 = parcelRequire("7sDf4");

var $jZka4 = parcelRequire("jZka4");

var $aJbWC = parcelRequire("aJbWC");

var $ayMG0 = parcelRequire("ayMG0");
const $6324800d89fce0fa$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "hideDescendantCount"
];
const $6324800d89fce0fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $6324800d89fce0fa$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $6324800d89fce0fa$var$GridBooleanCellRaw(props) {
    const { value: value, rowNode: rowNode } = props, other = (0, $6324800d89fce0fa$var$_objectWithoutPropertiesLoose2.default)(props, $6324800d89fce0fa$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $6324800d89fce0fa$var$useUtilityClasses(ownerState);
    const maxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $goCyd.gridRowMaximumTreeDepthSelector);
    const isServerSideRowGroupingRow = // @ts-expect-error - Access tree data prop
    maxDepth > 0 && rowNode.type === 'group' && rootProps.treeData === false;
    const Icon = $6324800d89fce0fa$var$React.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    if (isServerSideRowGroupingRow && value === undefined) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $6324800d89fce0fa$var$_extends2.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
const $6324800d89fce0fa$var$GridBooleanCell = module.exports.GridBooleanCell = /*#__PURE__*/ $6324800d89fce0fa$var$React.memo($6324800d89fce0fa$var$GridBooleanCellRaw);
const $6324800d89fce0fa$var$renderBooleanCell = (params)=>{
    if (params.field !== $jZka4.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD && (0, $7sDf4.isAutogeneratedRowNode)(params.rowNode)) {
        const aggregationMetaData = params.aggregation;
        if (!aggregationMetaData) return '';
        if (aggregationMetaData.position === 'footer') return /*#__PURE__*/ (0, $ayMG0.jsx)($aJbWC.GridFooterCell, (0, $6324800d89fce0fa$var$_extends2.default)({}, params));
        return params.formattedValue;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6324800d89fce0fa$var$GridBooleanCell, (0, $6324800d89fce0fa$var$_extends2.default)({}, params));
};
module.exports.renderBooleanCell = $6324800d89fce0fa$var$renderBooleanCell;

});
parcelRegister("jZka4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PinnedColumnPosition = module.exports.GRID_TREE_DATA_GROUPING_FIELD = module.exports.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = module.exports.GRID_DETAIL_PANEL_TOGGLE_FIELD = void 0;
const $e8d35a7c12bdaa1d$var$GRID_TREE_DATA_GROUPING_FIELD = module.exports.GRID_TREE_DATA_GROUPING_FIELD = '__tree_data_group__';
const $e8d35a7c12bdaa1d$var$GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = module.exports.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = '__row_group_by_columns_group__';
const $e8d35a7c12bdaa1d$var$GRID_DETAIL_PANEL_TOGGLE_FIELD = module.exports.GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';
let $e8d35a7c12bdaa1d$var$PinnedColumnPosition = module.exports.PinnedColumnPosition = /*#__PURE__*/ function(PinnedColumnPosition) {
    PinnedColumnPosition[PinnedColumnPosition["NONE"] = 0] = "NONE";
    PinnedColumnPosition[PinnedColumnPosition["LEFT"] = 1] = "LEFT";
    PinnedColumnPosition[PinnedColumnPosition["RIGHT"] = 2] = "RIGHT";
    PinnedColumnPosition[PinnedColumnPosition["VIRTUAL"] = 3] = "VIRTUAL";
    return PinnedColumnPosition;
}({});

});

parcelRegister("aJbWC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7cf75f4ac931239e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7cf75f4ac931239e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFooterCell = void 0;

var $7cf75f4ac931239e$var$_extends2 = $7cf75f4ac931239e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7cf75f4ac931239e$var$_objectWithoutPropertiesLoose2 = $7cf75f4ac931239e$require$_interopRequireDefault((parcelRequire("c05no")));

var $7cf75f4ac931239e$var$React = $7cf75f4ac931239e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7cf75f4ac931239e$var$_composeClasses = $7cf75f4ac931239e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $hbuUJ = parcelRequire("hbuUJ");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $7cf75f4ac931239e$var$_excluded = [
    "formattedValue",
    "colDef",
    "cellMode",
    "row",
    "api",
    "id",
    "value",
    "rowNode",
    "field",
    "hasFocus",
    "tabIndex",
    "isEditable"
];
const $7cf75f4ac931239e$var$GridFooterCellRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterCell'
})({
    fontWeight: $hbuUJ.vars.typography.fontWeight.medium,
    color: $hbuUJ.vars.colors.foreground.accent
});
const $7cf75f4ac931239e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerCell'
        ]
    };
    return (0, $7cf75f4ac931239e$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $7cf75f4ac931239e$var$GridFooterCellRaw(props) {
    const { formattedValue: formattedValue } = props, other = (0, $7cf75f4ac931239e$var$_objectWithoutPropertiesLoose2.default)(props, $7cf75f4ac931239e$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $7cf75f4ac931239e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7cf75f4ac931239e$var$GridFooterCellRoot, (0, $7cf75f4ac931239e$var$_extends2.default)({
        ownerState: ownerState,
        className: classes.root
    }, other, {
        children: formattedValue
    }));
}
const $7cf75f4ac931239e$var$GridFooterCell = module.exports.GridFooterCell = /*#__PURE__*/ $7cf75f4ac931239e$var$React.memo($7cf75f4ac931239e$var$GridFooterCellRaw);

});


parcelRegister("hsZ0E", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cb74606ec716e4c3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cb74606ec716e4c3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridEditBooleanCell = $cb74606ec716e4c3$var$GridEditBooleanCell;
module.exports.renderEditBooleanCell = void 0;

var $cb74606ec716e4c3$var$_extends2 = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $cb74606ec716e4c3$var$_objectWithoutPropertiesLoose2 = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("c05no")));

var $cb74606ec716e4c3$var$React = $cb74606ec716e4c3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cb74606ec716e4c3$var$_propTypes = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cb74606ec716e4c3$var$_clsx = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cb74606ec716e4c3$var$_composeClasses = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $cb74606ec716e4c3$var$_useId = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("hwliF")));

var $cb74606ec716e4c3$var$_useEnhancedEffect = $cb74606ec716e4c3$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $cb74606ec716e4c3$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $cb74606ec716e4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $cb74606ec716e4c3$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $cb74606ec716e4c3$var$GridEditBooleanCell(props) {
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $cb74606ec716e4c3$var$_objectWithoutPropertiesLoose2.default)(props, $cb74606ec716e4c3$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $cb74606ec716e4c3$var$React.useRef(null);
    const id = (0, $cb74606ec716e4c3$var$_useId.default)();
    const [valueState, setValueState] = $cb74606ec716e4c3$var$React.useState(value);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $cb74606ec716e4c3$var$useUtilityClasses(ownerState);
    const handleChange = $cb74606ec716e4c3$var$React.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $cb74606ec716e4c3$var$React.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $cb74606ec716e4c3$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("label", (0, $cb74606ec716e4c3$var$_extends2.default)({
        htmlFor: id,
        className: (0, $cb74606ec716e4c3$var$_clsx.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $cb74606ec716e4c3$var$_extends2.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, rootProps.slotProps?.baseCheckbox))
    }));
}
const $cb74606ec716e4c3$var$renderEditBooleanCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cb74606ec716e4c3$var$GridEditBooleanCell, (0, $cb74606ec716e4c3$var$_extends2.default)({}, params));
module.exports.renderEditBooleanCell = $cb74606ec716e4c3$var$renderEditBooleanCell;

});

parcelRegister("jWu8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridBooleanOperators = void 0;

var $hAdXB = parcelRequire("hAdXB");
const $e84ace6ba51eccb1$var$getGridBooleanOperators = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                const sanitizedValue = (0, $hAdXB.sanitizeFilterItemValue)(filterItem.value);
                if (sanitizedValue === undefined) return null;
                return (value)=>Boolean(value) === sanitizedValue;
            },
            InputComponent: $hAdXB.GridFilterInputBoolean
        }
    ];
module.exports.getGridBooleanOperators = $e84ace6ba51eccb1$var$getGridBooleanOperators;

});
parcelRegister("hAdXB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ccd0a0b443bb9406$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ccd0a0b443bb9406$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterInputBoolean = $ccd0a0b443bb9406$var$GridFilterInputBoolean;
module.exports.sanitizeFilterItemValue = $ccd0a0b443bb9406$var$sanitizeFilterItemValue;

var $ccd0a0b443bb9406$var$_extends2 = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ccd0a0b443bb9406$var$_objectWithoutPropertiesLoose2 = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("c05no")));

var $ccd0a0b443bb9406$var$React = $ccd0a0b443bb9406$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ccd0a0b443bb9406$var$_propTypes = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ccd0a0b443bb9406$var$_refType = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $ccd0a0b443bb9406$var$_useId = $ccd0a0b443bb9406$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ccd0a0b443bb9406$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "headerFilterMenu",
    "clearButton",
    "tabIndex",
    "slotProps"
];
function $ccd0a0b443bb9406$var$GridFilterInputBoolean(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, headerFilterMenu: headerFilterMenu, clearButton: clearButton, tabIndex: tabIndex, slotProps: slotProps } = props, other = (0, $ccd0a0b443bb9406$var$_objectWithoutPropertiesLoose2.default)(props, $ccd0a0b443bb9406$var$_excluded);
    const [filterValueState, setFilterValueState] = $ccd0a0b443bb9406$var$React.useState($ccd0a0b443bb9406$var$sanitizeFilterItemValue(item.value));
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const labelId = (0, $ccd0a0b443bb9406$var$_useId.default)();
    const selectId = (0, $ccd0a0b443bb9406$var$_useId.default)();
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const onFilterChange = $ccd0a0b443bb9406$var$React.useCallback((event)=>{
        const value = $ccd0a0b443bb9406$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        applyValue((0, $ccd0a0b443bb9406$var$_extends2.default)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $ccd0a0b443bb9406$var$React.useEffect(()=>{
        setFilterValueState($ccd0a0b443bb9406$var$sanitizeFilterItemValue(item.value));
    }, [
        item.value
    ]);
    const label = slotProps?.root.label ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    const rootSlotProps = slotProps?.root.slotProps;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ccd0a0b443bb9406$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseSelect, (0, $ccd0a0b443bb9406$var$_extends2.default)({
                fullWidth: true,
                labelId: labelId,
                id: selectId,
                label: label,
                value: filterValueState === undefined ? '' : String(filterValueState),
                onChange: onFilterChange,
                native: isSelectNative,
                slotProps: {
                    htmlInput: (0, $ccd0a0b443bb9406$var$_extends2.default)({
                        ref: focusElementRef,
                        tabIndex: tabIndex
                    }, rootSlotProps?.htmlInput)
                }
            }, baseSelectProps, other, slotProps?.root, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $ccd0a0b443bb9406$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "",
                        children: apiRef.current.getLocaleText('filterValueAny')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $ccd0a0b443bb9406$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "true",
                        children: apiRef.current.getLocaleText('filterValueTrue')
                    })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelectOption, (0, $ccd0a0b443bb9406$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "false",
                        children: apiRef.current.getLocaleText('filterValueFalse')
                    }))
                ]
            })),
            headerFilterMenu,
            clearButton
        ]
    });
}
function $ccd0a0b443bb9406$var$sanitizeFilterItemValue(value) {
    if (String(value).toLowerCase() === 'true') return true;
    if (String(value).toLowerCase() === 'false') return false;
    return undefined;
}

});



parcelRegister("5bG6h", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3c6ea315aeb792f9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_CHECKBOX_SELECTION_FIELD = module.exports.GRID_CHECKBOX_SELECTION_COL_DEF = void 0;

var $3c6ea315aeb792f9$var$_extends2 = $3c6ea315aeb792f9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fgOJy = parcelRequire("fgOJy");

var $4l3r5 = parcelRequire("4l3r5");

var $iNueb = parcelRequire("iNueb");

var $180lm = parcelRequire("180lm");

var $ayMG0 = parcelRequire("ayMG0");
const $3c6ea315aeb792f9$var$GRID_CHECKBOX_SELECTION_FIELD = module.exports.GRID_CHECKBOX_SELECTION_FIELD = '__check__';
const $3c6ea315aeb792f9$var$GRID_CHECKBOX_SELECTION_COL_DEF = module.exports.GRID_CHECKBOX_SELECTION_COL_DEF = (0, $3c6ea315aeb792f9$var$_extends2.default)({}, $iNueb.GRID_BOOLEAN_COL_DEF, {
    type: 'custom',
    field: $3c6ea315aeb792f9$var$GRID_CHECKBOX_SELECTION_FIELD,
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: ()=>null,
    display: 'flex',
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = (0, $180lm.gridRowIdSelector)(apiRef, row);
        return apiRef.current.isRowSelected(rowId);
    },
    rowSpanValueGetter: (_, row, column, apiRef)=>(0, $180lm.gridRowIdSelector)(apiRef, row),
    renderHeader: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($4l3r5.GridHeaderCheckbox, (0, $3c6ea315aeb792f9$var$_extends2.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($fgOJy.GridCellCheckboxRenderer, (0, $3c6ea315aeb792f9$var$_extends2.default)({}, params))
});

});
parcelRegister("fgOJy", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b1dfb45352a7562a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b1dfb45352a7562a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridCellCheckboxRenderer = module.exports.GridCellCheckboxForwardRef = void 0;

var $b1dfb45352a7562a$var$_extends2 = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b1dfb45352a7562a$var$_objectWithoutPropertiesLoose2 = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("c05no")));

var $b1dfb45352a7562a$var$React = $b1dfb45352a7562a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b1dfb45352a7562a$var$_propTypes = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b1dfb45352a7562a$var$_clsx = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b1dfb45352a7562a$var$_composeClasses = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $b1dfb45352a7562a$var$_useEventCallback = $b1dfb45352a7562a$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $5sOMZ = parcelRequire("5sOMZ");

var $iN63z = parcelRequire("iN63z");

var $ayMG0 = parcelRequire("ayMG0");
const $b1dfb45352a7562a$var$_excluded = [
    "field",
    "id",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $b1dfb45352a7562a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $b1dfb45352a7562a$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $b1dfb45352a7562a$var$GridCellCheckboxForwardRef = module.exports.GridCellCheckboxForwardRef = (0, $fYxgT.forwardRef)(function GridCellCheckboxRenderer(props, ref) {
    const { field: field, id: id, rowNode: rowNode, tabIndex: tabIndex } = props, other = (0, $b1dfb45352a7562a$var$_objectWithoutPropertiesLoose2.default)(props, $b1dfb45352a7562a$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $b1dfb45352a7562a$var$useUtilityClasses(ownerState);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked, isSelectable: isSelectable } = (0, $5sOMZ.useGridSelector)(apiRef, $iN63z.checkboxPropsSelector, {
        groupId: id,
        autoSelectParents: rootProps.rowSelectionPropagation?.parents ?? false
    }, $5sOMZ.objectShallowCompare);
    const disabled = !isSelectable;
    const handleChange = (event)=>{
        if (disabled) return;
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $b1dfb45352a7562a$var$React.useLayoutEffect(()=>{
        if (tabIndex === 0 && !disabled) {
            const element = apiRef.current.getCellElement(id, field);
            if (element) element.tabIndex = -1;
        }
    }, [
        apiRef,
        tabIndex,
        id,
        field,
        disabled
    ]);
    const handleKeyDown = (0, $b1dfb45352a7562a$var$_useEventCallback.default)((event)=>{
        if (event.key === ' ') // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
        if (disabled) return;
    });
    const handleClick = (0, $b1dfb45352a7562a$var$_useEventCallback.default)((event)=>{
        if (disabled) {
            event.preventDefault();
            return;
        }
    });
    const handleMouseDown = (0, $b1dfb45352a7562a$var$_useEventCallback.default)(()=>{
        if (disabled) return;
    });
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const label = apiRef.current.getLocaleText(isChecked && !isIndeterminate ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $b1dfb45352a7562a$var$_extends2.default)({
        tabIndex: disabled ? -1 : tabIndex,
        checked: isChecked && !isIndeterminate,
        onChange: handleChange,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        className: (0, $b1dfb45352a7562a$var$_clsx.default)(classes.root, disabled && 'Mui-disabled'),
        disabled: disabled,
        material: {
            disableRipple: disabled
        },
        slotProps: {
            htmlInput: {
                'aria-disabled': disabled || undefined,
                'aria-label': label,
                name: 'select_row'
            }
        },
        onKeyDown: handleKeyDown,
        indeterminate: isIndeterminate
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});
const $b1dfb45352a7562a$var$GridCellCheckboxRenderer = module.exports.GridCellCheckboxRenderer = $b1dfb45352a7562a$var$GridCellCheckboxForwardRef;

});
parcelRegister("iN63z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findRowsToSelect = module.exports.findRowsToDeselect = module.exports.checkboxPropsSelector = module.exports.ROW_SELECTION_PROPAGATION_DEFAULT = void 0;
module.exports.isMultipleRowSelectionEnabled = $dae18049c8685698$var$isMultipleRowSelectionEnabled;

var $iVTh1 = parcelRequire("iVTh1");

var $7sDf4 = parcelRequire("7sDf4");

var $k278Q = parcelRequire("k278Q");

var $iU3u2 = parcelRequire("iU3u2");

var $av74L = parcelRequire("av74L");

var $goCyd = parcelRequire("goCyd");

var $cgQ4y = parcelRequire("cgQ4y");

var $jy68d = parcelRequire("jy68d");

var $180lm = parcelRequire("180lm");
const $dae18049c8685698$var$ROW_SELECTION_PROPAGATION_DEFAULT = module.exports.ROW_SELECTION_PROPAGATION_DEFAULT = {
    parents: true,
    descendants: true
};
function $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, groupId) {
    const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
    const sortedRowIds = (0, $iU3u2.gridSortedRowIdsSelector)(apiRef);
    const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
    const groupNode = rowTree[groupId];
    if (!groupNode || groupNode.type !== 'group') return [];
    const descendants = [];
    const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
    for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
        const id = sortedRowIds[index];
        if (filteredRowsLookup[id] !== false && apiRef.current.isRowSelectable(id)) descendants.push(id);
    }
    return descendants;
}
const $dae18049c8685698$var$checkboxPropsSelector = module.exports.checkboxPropsSelector = (0, $cgQ4y.createSelector)($jy68d.gridColumnDefinitionsSelector, $goCyd.gridRowTreeSelector, $k278Q.gridFilteredRowsLookupSelector, $av74L.gridRowSelectionManagerSelector, $goCyd.gridRowsLookupSelector, $180lm.gridRowSelectableSelector, (columns, rowTree, filteredRowsLookup, rowSelectionManager, rowsLookup, isRowSelectable, { groupId: groupId, autoSelectParents: autoSelectParents })=>{
    const groupNode = rowTree[groupId];
    const rowParams = {
        id: groupId,
        row: rowsLookup[groupId],
        columns: columns
    };
    let isSelectable = true;
    if (typeof isRowSelectable === 'function' && rowsLookup[groupId]) isSelectable = isRowSelectable(rowParams);
    if (!groupNode || groupNode.type !== 'group' || rowSelectionManager.has(groupId)) return {
        isIndeterminate: false,
        isChecked: rowSelectionManager.has(groupId),
        isSelectable: isSelectable
    };
    let hasSelectedDescendant = false;
    let hasUnSelectedDescendant = false;
    const traverseDescendants = (itemToTraverseId)=>{
        if (filteredRowsLookup[itemToTraverseId] === false || // Perf: Skip checking the rest of the descendants if we already
        // know that there is a selected and an unselected descendant
        hasSelectedDescendant && hasUnSelectedDescendant) return;
        const node = rowTree[itemToTraverseId];
        if (node?.type === 'group') node.children.forEach(traverseDescendants);
        // Check if row is selectable before considering it for parent selection state
        const descendantRowParams = {
            id: itemToTraverseId,
            row: rowsLookup[itemToTraverseId],
            columns: columns
        };
        const rowIsSelectable = typeof isRowSelectable === 'function' && rowsLookup[itemToTraverseId] ? isRowSelectable(descendantRowParams) : true;
        // Only consider selectable rows when determining parent selection state
        if (rowIsSelectable) {
            if (rowSelectionManager.has(itemToTraverseId)) hasSelectedDescendant = true;
            else hasUnSelectedDescendant = true;
        }
    };
    traverseDescendants(groupId);
    return {
        isIndeterminate: hasSelectedDescendant && hasUnSelectedDescendant,
        isChecked: autoSelectParents ? hasSelectedDescendant && !hasUnSelectedDescendant : false,
        isSelectable: isSelectable
    };
});
function $dae18049c8685698$var$isMultipleRowSelectionEnabled(props) {
    if (props.signature === $iVTh1.GridSignature.DataGrid) // DataGrid Community has multiple row selection enabled only if checkbox selection is enabled.
    return props.checkboxSelection && props.disableMultipleRowSelection !== true;
    return !props.disableMultipleRowSelection;
}
const $dae18049c8685698$var$getRowNodeParents = (tree, id)=>{
    const parents = [];
    let parent = id;
    while(parent != null && parent !== $7sDf4.GRID_ROOT_GROUP_ID){
        const node = tree[parent];
        if (!node) return parents;
        parents.push(parent);
        parent = node.parent;
    }
    return parents;
};
const $dae18049c8685698$var$getFilteredRowNodeSiblings = (tree, filteredRows, id)=>{
    const node = tree[id];
    if (!node) return [];
    const parent = node.parent;
    if (parent == null) return [];
    const parentNode = tree[parent];
    return parentNode.children.filter((childId)=>childId !== id && filteredRows[childId] !== false);
};
const $dae18049c8685698$var$findRowsToSelect = (apiRef, tree, selectedRow, autoSelectDescendants, autoSelectParents, addRow, rowSelectionManager = (0, $av74L.gridRowSelectionManagerSelector)(apiRef))=>{
    const filteredRows = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
    const selectedDescendants = new Set([]);
    if (!autoSelectDescendants && !autoSelectParents || filteredRows[selectedRow] === false) return;
    if (autoSelectDescendants) {
        const rowNode = tree[selectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, selectedRow);
            descendants.forEach((rowId)=>{
                addRow(rowId);
                selectedDescendants.add(rowId);
            });
        }
    }
    if (autoSelectParents) {
        const checkAllDescendantsSelected = (rowId)=>{
            const node = tree[rowId];
            if (!node) return false;
            // For non-group nodes, check if it's selected or if it's non-selectable
            if (node.type !== 'group') {
                // If the row is selectable, it must be selected
                if (apiRef.current.isRowSelectable(rowId)) return rowSelectionManager.has(rowId) || selectedDescendants.has(rowId);
                // Non-selectable rows don't affect parent selection
                return true;
            }
            // For group nodes, check if it's selected or all its children are selected
            if (rowSelectionManager.has(rowId) || selectedDescendants.has(rowId)) return true;
            // Recursively check all children
            return node.children.every(checkAllDescendantsSelected);
        };
        const traverseParents = (rowId)=>{
            const siblings = $dae18049c8685698$var$getFilteredRowNodeSiblings(tree, filteredRows, rowId);
            // Check if all selectable siblings are selected
            const allSelectableSiblingsSelected = siblings.every((siblingId)=>{
                // Non-selectable siblings don't affect parent selection
                if (!apiRef.current.isRowSelectable(siblingId)) return true;
                return checkAllDescendantsSelected(siblingId);
            });
            if (siblings.length === 0 || allSelectableSiblingsSelected) {
                const rowNode = tree[rowId];
                const parent = rowNode?.parent;
                if (parent != null && parent !== $7sDf4.GRID_ROOT_GROUP_ID && apiRef.current.isRowSelectable(parent)) {
                    addRow(parent);
                    selectedDescendants.add(parent);
                    traverseParents(parent);
                }
            }
        };
        // For root level rows, we don't need to traverse parents
        const rowNode = tree[selectedRow];
        if (!rowNode || rowNode.parent === $7sDf4.GRID_ROOT_GROUP_ID) return;
        traverseParents(selectedRow);
    }
};
module.exports.findRowsToSelect = $dae18049c8685698$var$findRowsToSelect;
const $dae18049c8685698$var$findRowsToDeselect = (apiRef, tree, deselectedRow, autoSelectDescendants, autoSelectParents, removeRow)=>{
    const rowSelectionManager = (0, $av74L.gridRowSelectionManagerSelector)(apiRef);
    if (!autoSelectParents && !autoSelectDescendants) return;
    if (autoSelectParents) {
        const allParents = $dae18049c8685698$var$getRowNodeParents(tree, deselectedRow);
        allParents.forEach((parent)=>{
            const isSelected = rowSelectionManager.has(parent);
            if (isSelected) removeRow(parent);
        });
    }
    if (autoSelectDescendants) {
        const rowNode = tree[deselectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $dae18049c8685698$var$getGridRowGroupSelectableDescendants(apiRef, deselectedRow);
            descendants.forEach((descendant)=>{
                removeRow(descendant);
            });
        }
    }
};
module.exports.findRowsToDeselect = $dae18049c8685698$var$findRowsToDeselect;

});
parcelRegister("k278Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridVisibleRowsLookupSelector = module.exports.gridQuickFilterValuesSelector = module.exports.gridFilteredTopLevelRowCountSelector = module.exports.gridFilteredSortedTopLevelRowEntriesSelector = module.exports.gridFilteredSortedRowIdsSelector = module.exports.gridFilteredSortedRowEntriesSelector = module.exports.gridFilteredSortedDepthRowEntriesSelector = module.exports.gridFilteredRowsLookupSelector = module.exports.gridFilteredRowCountSelector = module.exports.gridFilteredDescendantRowCountSelector = module.exports.gridFilteredDescendantCountLookupSelector = module.exports.gridFilteredChildrenCountLookupSelector = module.exports.gridFilterModelSelector = module.exports.gridFilterActiveItemsSelector = module.exports.gridFilterActiveItemsLookupSelector = module.exports.gridExpandedSortedRowTreeLevelPositionLookupSelector = module.exports.gridExpandedSortedRowIndexLookupSelector = module.exports.gridExpandedSortedRowIdsSelector = module.exports.gridExpandedSortedRowEntriesSelector = module.exports.gridExpandedRowCountSelector = void 0;

var $7w6sa = parcelRequire("7w6sa");

var $cgQ4y = parcelRequire("cgQ4y");

var $iU3u2 = parcelRequire("iU3u2");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");
/**
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilterStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.filter);
/**
 * Get the current filter model.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilterModelSelector = module.exports.gridFilterModelSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
/**
 * Get the current quick filter values.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridQuickFilterValuesSelector = module.exports.gridQuickFilterValuesSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterModelSelector, (filterModel)=>filterModel.quickFilterValues);
/**
 * @category Visible rows
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridVisibleRowsLookupSelector = module.exports.gridVisibleRowsLookupSelector = (0, $cgQ4y.createRootSelector)((state)=>state.visibleRowsLookup);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilteredRowsLookupSelector = module.exports.gridFilteredRowsLookupSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilteredChildrenCountLookupSelector = module.exports.gridFilteredChildrenCountLookupSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredChildrenCountLookup);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilteredDescendantCountLookupSelector = module.exports.gridFilteredDescendantCountLookupSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
/**
 * Get the id and the model of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridExpandedSortedRowEntriesSelector = module.exports.gridExpandedSortedRowEntriesSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridVisibleRowsLookupSelector, $iU3u2.gridSortedRowEntriesSelector, (visibleRowsLookup, sortedRows)=>{
    if ((0, $7w6sa.isObjectEmpty)(visibleRowsLookup)) return sortedRows;
    return sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false);
});
/**
 * Get the id of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridExpandedSortedRowIdsSelector = module.exports.gridExpandedSortedRowIdsSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridExpandedSortedRowEntriesSelector, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
/**
 * Get the id and the model of the rows accessible after the filtering process.
 * Contains the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector = module.exports.gridFilteredSortedRowEntriesSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridFilteredRowsLookupSelector, $iU3u2.gridSortedRowEntriesSelector, (filteredRowsLookup, sortedRows)=>(0, $7w6sa.isObjectEmpty)(filteredRowsLookup) ? sortedRows : sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
/**
 * Get the id of the rows accessible after the filtering process.
 * Contains the collapsed children.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedRowIdsSelector = module.exports.gridFilteredSortedRowIdsSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
/**
 * Get the ids to position in the current tree level lookup of the rows accessible after the filtering process.
 * Does not contain the collapsed children.
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridExpandedSortedRowTreeLevelPositionLookupSelector = module.exports.gridExpandedSortedRowTreeLevelPositionLookupSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridExpandedSortedRowIdsSelector, $goCyd.gridRowTreeSelector, (visibleSortedRowIds, rowTree)=>{
    const depthPositionCounter = {};
    let lastDepth = 0;
    return visibleSortedRowIds.reduce((acc, rowId)=>{
        const rowNode = rowTree[rowId];
        if (!depthPositionCounter[rowNode.depth]) depthPositionCounter[rowNode.depth] = 0;
        // going deeper in the tree should reset the counter
        // since it might have been used in some other branch at the same level, up in the tree
        // going back up should keep the counter and continue where it left off
        if (rowNode.depth > lastDepth) depthPositionCounter[rowNode.depth] = 0;
        lastDepth = rowNode.depth;
        depthPositionCounter[rowNode.depth] += 1;
        acc[rowId] = depthPositionCounter[rowNode.depth];
        return acc;
    }, {});
});
/**
 * Get the id and the model of the rows per depth level, accessible after the filtering process.
 * Returns an array of arrays, where each array index contains the rows for the depth level equal to the index.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedDepthRowEntriesSelector = module.exports.gridFilteredSortedDepthRowEntriesSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector, $goCyd.gridRowTreeSelector, $goCyd.gridRowMaximumTreeDepthSelector, (sortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return [
        sortedRows
    ];
    return sortedRows.reduce((acc, row)=>{
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) return acc;
        if (!acc[depth]) acc[depth] = [];
        acc[depth].push(row);
        return acc;
    }, [
        []
    ]);
});
/**
 * Get the id and the model of the top level rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredSortedTopLevelRowEntriesSelector = module.exports.gridFilteredSortedTopLevelRowEntriesSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilteredSortedDepthRowEntriesSelector, (filteredSortedDepthRows)=>filteredSortedDepthRows[0] ?? []);
/**
 * Get the amount of rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridExpandedRowCountSelector = module.exports.gridExpandedRowCountSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridExpandedSortedRowEntriesSelector, (visibleSortedRows)=>visibleSortedRows.length);
/**
 * Get the amount of top level rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredTopLevelRowCountSelector = module.exports.gridFilteredTopLevelRowCountSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilteredSortedTopLevelRowEntriesSelector, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
/**
 * Get the amount of rows accessible after the filtering process.
 * Includes top level and descendant rows.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredRowCountSelector = module.exports.gridFilteredRowCountSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilteredSortedRowEntriesSelector, (filteredSortedRowEntries)=>filteredSortedRowEntries.length);
/**
 * Get the amount of descendant rows accessible after the filtering process.
 * @category Filtering
 */ const $e95988b653de2e96$var$gridFilteredDescendantRowCountSelector = module.exports.gridFilteredDescendantRowCountSelector = (0, $cgQ4y.createSelector)($e95988b653de2e96$var$gridFilteredRowCountSelector, $e95988b653de2e96$var$gridFilteredTopLevelRowCountSelector, (totalRowCount, topLevelRowCount)=>totalRowCount - topLevelRowCount);
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilterActiveItemsSelector = module.exports.gridFilterActiveItemsSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridFilterModelSelector, $jQEEt.gridColumnLookupSelector, (filterModel, columnLookup)=>filterModel.items?.filter((item)=>{
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!column?.filterOperators || column?.filterOperators?.length === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && item.value?.toString() !== '';
    }));
/**
 * @category Filtering
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridFilterActiveItemsLookupSelector = module.exports.gridFilterActiveItemsLookupSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridFilterActiveItemsSelector, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});
/**
 * Get the index lookup for expanded (visible) rows only.
 * Does not include collapsed children.
 * @ignore - do not document.
 */ const $e95988b653de2e96$var$gridExpandedSortedRowIndexLookupSelector = module.exports.gridExpandedSortedRowIndexLookupSelector = (0, $cgQ4y.createSelectorMemoized)($e95988b653de2e96$var$gridExpandedSortedRowIdsSelector, (expandedSortedIds)=>{
    return expandedSortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});

});
parcelRegister("7w6sa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isObjectEmpty", {
    enumerable: true,
    get: function() {
        return $7ktWu.isObjectEmpty;
    }
});

var $7ktWu = parcelRequire("7ktWu");

});
parcelRegister("7ktWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isObjectEmpty = $5561a094c2d5818a$var$isObjectEmpty;
function $5561a094c2d5818a$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}

});


parcelRegister("iU3u2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridSortedRowIndexLookupSelector = module.exports.gridSortedRowIdsSelector = module.exports.gridSortedRowEntriesSelector = module.exports.gridSortModelSelector = module.exports.gridSortColumnLookupSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");

var $goCyd = parcelRequire("goCyd");

var $7sDf4 = parcelRequire("7sDf4");
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortingStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.sorting);
/**
 * Get the id of the rows after the sorting process.
 * @category Sorting
 */ const $dc3028b3b629fae7$var$gridSortedRowIdsSelector = module.exports.gridSortedRowIdsSelector = (0, $cgQ4y.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
/**
 * Get the id and the model of the rows after the sorting process.
 * @category Sorting
 */ const $dc3028b3b629fae7$var$gridSortedRowEntriesSelector = module.exports.gridSortedRowEntriesSelector = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$var$gridSortedRowIdsSelector, $goCyd.gridRowsLookupSelector, $goCyd.gridRowTreeSelector, (sortedIds, idRowsLookup, rowTree)=>sortedIds.reduce((acc, id)=>{
        const model = idRowsLookup[id];
        if (model) acc.push({
            id: id,
            model: model
        });
        else {
            const rowNode = rowTree[id];
            if (rowNode && (0, $7sDf4.isAutogeneratedRowNode)(rowNode)) acc.push({
                id: id,
                model: {
                    [$7sDf4.GRID_ID_AUTOGENERATED]: id
                }
            });
        }
        return acc;
    }, []));
/**
 * Get the current sorting model.
 * @category Sorting
 */ const $dc3028b3b629fae7$var$gridSortModelSelector = module.exports.gridSortModelSelector = (0, $cgQ4y.createSelector)($dc3028b3b629fae7$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortColumnLookupSelector = module.exports.gridSortColumnLookupSelector = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$var$gridSortModelSelector, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});
/**
 * @category Sorting
 * @ignore - do not document.
 */ const $dc3028b3b629fae7$var$gridSortedRowIndexLookupSelector = module.exports.gridSortedRowIndexLookupSelector = (0, $cgQ4y.createSelectorMemoized)($dc3028b3b629fae7$var$gridSortedRowIdsSelector, (sortedIds)=>{
    return sortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});

});


parcelRegister("av74L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridRowSelectionStateSelector = module.exports.gridRowSelectionManagerSelector = module.exports.gridRowSelectionIdsSelector = module.exports.gridRowSelectionCountSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");

var $goCyd = parcelRequire("goCyd");

var $k278Q = parcelRequire("k278Q");

var $cgG30 = parcelRequire("cgG30");
const $7a5249c135fd39c1$var$gridRowSelectionStateSelector = module.exports.gridRowSelectionStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.rowSelection);
const $7a5249c135fd39c1$var$gridRowSelectionManagerSelector = module.exports.gridRowSelectionManagerSelector = (0, $cgQ4y.createSelectorMemoized)($7a5249c135fd39c1$var$gridRowSelectionStateSelector, $cgG30.createRowSelectionManager);
const $7a5249c135fd39c1$var$gridRowSelectionCountSelector = module.exports.gridRowSelectionCountSelector = (0, $cgQ4y.createSelector)($7a5249c135fd39c1$var$gridRowSelectionStateSelector, $k278Q.gridFilteredRowCountSelector, (selection, filteredRowCount)=>{
    if (selection.type === 'include') return selection.ids.size;
    // In exclude selection, all rows are selectable.
    return filteredRowCount - selection.ids.size;
});
const $7a5249c135fd39c1$var$gridRowSelectionIdsSelector = module.exports.gridRowSelectionIdsSelector = (0, $cgQ4y.createSelectorMemoized)($7a5249c135fd39c1$var$gridRowSelectionStateSelector, $goCyd.gridRowsLookupSelector, $goCyd.gridDataRowIdsSelector, (selectionModel, rowsLookup, rowIds)=>{
    const map = new Map();
    if (selectionModel.type === 'include') for (const id of selectionModel.ids)map.set(id, rowsLookup[id]);
    else for(let i = 0; i < rowIds.length; i += 1){
        const id = rowIds[i];
        if (!selectionModel.ids.has(id)) map.set(id, rowsLookup[id]);
    }
    return map;
});

});

parcelRegister("180lm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridRowSelectableSelector = module.exports.gridRowIdSelector = void 0;

var $7sDf4 = parcelRequire("7sDf4");

var $cgQ4y = parcelRequire("cgQ4y");
/**
 * Get the row id for a given row
 * @param apiRef - The grid api reference
 * @param {GridRowModel} row - The row to get the id for
 * @returns {GridRowId} The row id
 */ const $0d26ce0880758663$var$gridRowIdSelector = module.exports.gridRowIdSelector = (0, $cgQ4y.createRootSelector)((state, row)=>{
    if ($7sDf4.GRID_ID_AUTOGENERATED in row) return row[$7sDf4.GRID_ID_AUTOGENERATED];
    return state.props.getRowId ? state.props.getRowId(row) : row.id;
});
const $0d26ce0880758663$var$gridRowSelectableSelector = module.exports.gridRowSelectableSelector = (0, $cgQ4y.createRootSelector)((state)=>{
    return state.props.isRowSelectable;
});

});



parcelRegister("4l3r5", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $328bc9e57e6b696b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $328bc9e57e6b696b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridHeaderCheckbox = void 0;

var $328bc9e57e6b696b$var$_extends2 = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $328bc9e57e6b696b$var$_objectWithoutPropertiesLoose2 = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("c05no")));

var $328bc9e57e6b696b$var$React = $328bc9e57e6b696b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $328bc9e57e6b696b$var$_propTypes = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $328bc9e57e6b696b$var$_composeClasses = $328bc9e57e6b696b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $iN63z = parcelRequire("iN63z");

var $5sOMZ = parcelRequire("5sOMZ");

var $drCmI = parcelRequire("drCmI");

var $av74L = parcelRequire("av74L");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $k278Q = parcelRequire("k278Q");

var $gPWuj = parcelRequire("gPWuj");

var $cgG30 = parcelRequire("cgG30");

var $ayMG0 = parcelRequire("ayMG0");
const $328bc9e57e6b696b$var$_excluded = [
    "field",
    "colDef"
];
const $328bc9e57e6b696b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $328bc9e57e6b696b$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $328bc9e57e6b696b$var$GridHeaderCheckbox = module.exports.GridHeaderCheckbox = (0, $fYxgT.forwardRef)(function GridHeaderCheckbox(props, ref) {
    const other = (0, $328bc9e57e6b696b$var$_objectWithoutPropertiesLoose2.default)(props, $328bc9e57e6b696b$var$_excluded);
    const [, forceUpdate] = $328bc9e57e6b696b$var$React.useState(false);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $328bc9e57e6b696b$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, $drCmI.gridTabIndexColumnHeaderSelector);
    const selection = (0, $5sOMZ.useGridSelector)(apiRef, $av74L.gridRowSelectionStateSelector);
    const visibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridExpandedSortedRowIdsSelector);
    const paginatedVisibleRowIds = (0, $5sOMZ.useGridSelector)(apiRef, $gPWuj.gridPaginatedVisibleSortedGridRowIdsSelector);
    const filteredSelection = $328bc9e57e6b696b$var$React.useMemo(()=>{
        const isRowSelectable = rootProps.isRowSelectable;
        if (typeof isRowSelectable !== 'function') return selection;
        if (selection.type === 'exclude') return selection;
        // selection.type === 'include'
        const selectionModel = {
            type: 'include',
            ids: new Set()
        };
        for (const id of selection.ids){
            if (rootProps.keepNonExistentRowsSelected) selectionModel.ids.add(id);
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) continue;
            if (isRowSelectable(apiRef.current.getRowParams(id))) selectionModel.ids.add(id);
        }
        return selectionModel;
    }, [
        apiRef,
        rootProps.isRowSelectable,
        rootProps.keepNonExistentRowsSelected,
        selection
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $328bc9e57e6b696b$var$React.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly || rootProps.paginationMode === 'server' ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to a Set to make O(1) checking if a row exists or not
        const candidates = new Set();
        for(let i = 0; i < rowIds.length; i += 1){
            const id = rowIds[i];
            if (!apiRef.current.getRow(id)) continue;
            if (apiRef.current.isRowSelectable(id)) candidates.add(id);
        }
        return candidates;
    }, [
        apiRef,
        rootProps.pagination,
        rootProps.paginationMode,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $328bc9e57e6b696b$var$React.useMemo(()=>{
        const selectionManager = (0, $cgG30.createRowSelectionManager)(filteredSelection);
        let size = 0;
        for (const id of selectionCandidates)if (selectionManager.has(id)) size += 1;
        return size;
    }, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = $328bc9e57e6b696b$var$React.useMemo(()=>{
        if (currentSelectionSize === 0) return false;
        const selectionManager = (0, $cgG30.createRowSelectionManager)(filteredSelection);
        for (const rowId of selectionCandidates){
            if (!selectionManager.has(rowId)) return true;
        }
        return false;
    }, [
        currentSelectionSize,
        filteredSelection,
        selectionCandidates
    ]);
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $328bc9e57e6b696b$var$React.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $328bc9e57e6b696b$var$React.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $328bc9e57e6b696b$var$React.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $328bc9e57e6b696b$var$React.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked && !isIndeterminate ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $328bc9e57e6b696b$var$_extends2.default)({
        indeterminate: isIndeterminate,
        checked: isChecked && !isIndeterminate,
        onChange: handleChange,
        className: classes.root,
        slotProps: {
            htmlInput: {
                'aria-label': label,
                name: 'select_all_rows'
            }
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !(0, $iN63z.isMultipleRowSelectionEnabled)(rootProps)
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});

});
parcelRegister("drCmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridTabIndexStateSelector = module.exports.gridTabIndexColumnHeaderSelector = module.exports.gridTabIndexColumnHeaderFilterSelector = module.exports.gridTabIndexColumnGroupHeaderSelector = module.exports.gridTabIndexCellSelector = module.exports.gridFocusStateSelector = module.exports.gridFocusColumnHeaderSelector = module.exports.gridFocusColumnHeaderFilterSelector = module.exports.gridFocusColumnGroupHeaderSelector = module.exports.gridFocusCellSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $9c9b8e89fddd633d$var$gridFocusStateSelector = module.exports.gridFocusStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.focus);
const $9c9b8e89fddd633d$var$gridFocusCellSelector = module.exports.gridFocusCellSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.cell);
const $9c9b8e89fddd633d$var$gridFocusColumnHeaderSelector = module.exports.gridFocusColumnHeaderSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.columnHeader);
const $9c9b8e89fddd633d$var$gridFocusColumnHeaderFilterSelector = module.exports.gridFocusColumnHeaderFilterSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.columnHeaderFilter);
const $9c9b8e89fddd633d$var$gridFocusColumnGroupHeaderSelector = module.exports.gridFocusColumnGroupHeaderSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridFocusStateSelector, (focusState)=>focusState.columnGroupHeader);
const $9c9b8e89fddd633d$var$gridTabIndexStateSelector = module.exports.gridTabIndexStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.tabIndex);
const $9c9b8e89fddd633d$var$gridTabIndexCellSelector = module.exports.gridTabIndexCellSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.cell);
const $9c9b8e89fddd633d$var$gridTabIndexColumnHeaderSelector = module.exports.gridTabIndexColumnHeaderSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.columnHeader);
const $9c9b8e89fddd633d$var$gridTabIndexColumnHeaderFilterSelector = module.exports.gridTabIndexColumnHeaderFilterSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.columnHeaderFilter);
const $9c9b8e89fddd633d$var$gridTabIndexColumnGroupHeaderSelector = module.exports.gridTabIndexColumnGroupHeaderSelector = (0, $cgQ4y.createSelector)($9c9b8e89fddd633d$var$gridTabIndexStateSelector, (state)=>state.columnGroupHeader);

});

parcelRegister("gPWuj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridVisibleRowsSelector = module.exports.gridPaginationSelector = module.exports.gridPaginationRowRangeSelector = module.exports.gridPaginationRowCountSelector = module.exports.gridPaginationModelSelector = module.exports.gridPaginationMetaSelector = module.exports.gridPaginationEnabledClientSideSelector = module.exports.gridPaginatedVisibleSortedGridRowIdsSelector = module.exports.gridPaginatedVisibleSortedGridRowEntriesSelector = module.exports.gridPageSizeSelector = module.exports.gridPageSelector = module.exports.gridPageCountSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");

var $k278Q = parcelRequire("k278Q");

var $goCyd = parcelRequire("goCyd");

var $baj2X = parcelRequire("baj2X");
const $c41ec74257ca380c$var$ALL_RESULTS_PAGE_VALUE = -1;
/**
 * @category Pagination
 * @ignore - do not document.
 */ const $c41ec74257ca380c$var$gridPaginationSelector = module.exports.gridPaginationSelector = (0, $cgQ4y.createRootSelector)((state)=>state.pagination);
/**
 * @category Pagination
 * @ignore - do not document.
 */ const $c41ec74257ca380c$var$gridPaginationEnabledClientSideSelector = module.exports.gridPaginationEnabledClientSideSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.enabled && pagination.paginationMode === 'client');
/**
 * Get the pagination model
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationModelSelector = module.exports.gridPaginationModelSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.paginationModel);
/**
 * Get the row count
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationRowCountSelector = module.exports.gridPaginationRowCountSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.rowCount);
/**
 * Get the pagination meta
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationMetaSelector = module.exports.gridPaginationMetaSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationSelector, (pagination)=>pagination.meta);
/**
 * Get the index of the page to render if the pagination is enabled
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPageSelector = module.exports.gridPageSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationModelSelector, (paginationModel)=>paginationModel.page);
/**
 * Get the maximum amount of rows to display on a single page if the pagination is enabled
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPageSizeSelector = module.exports.gridPageSizeSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationModelSelector, (paginationModel)=>paginationModel.pageSize);
/**
 * Get the amount of pages needed to display all the rows if the pagination is enabled
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPageCountSelector = module.exports.gridPageCountSelector = (0, $cgQ4y.createSelector)($c41ec74257ca380c$var$gridPaginationModelSelector, $c41ec74257ca380c$var$gridPaginationRowCountSelector, (paginationModel, rowCount)=>(0, $baj2X.getPageCount)(rowCount, paginationModel.pageSize, paginationModel.page));
/**
 * Get the index of the first and the last row to include in the current page if the pagination is enabled.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginationRowRangeSelector = module.exports.gridPaginationRowRangeSelector = (0, $cgQ4y.createSelectorMemoized)($c41ec74257ca380c$var$gridPaginationEnabledClientSideSelector, $c41ec74257ca380c$var$gridPaginationModelSelector, $goCyd.gridRowTreeSelector, $goCyd.gridRowMaximumTreeDepthSelector, $k278Q.gridExpandedSortedRowEntriesSelector, $k278Q.gridFilteredSortedTopLevelRowEntriesSelector, (clientSidePaginationEnabled, paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    if (!clientSidePaginationEnabled) return null;
    if (!visibleSortedRowEntries || visibleSortedRowEntries.length === 0) return null;
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = paginationModel.pageSize === $c41ec74257ca380c$var$ALL_RESULTS_PAGE_VALUE ? visibleTopLevelRowCount - 1 : Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
/**
 * Get the id and the model of each row to include in the current page if the pagination is enabled.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginatedVisibleSortedGridRowEntriesSelector = module.exports.gridPaginatedVisibleSortedGridRowEntriesSelector = (0, $cgQ4y.createSelectorMemoized)($k278Q.gridExpandedSortedRowEntriesSelector, $c41ec74257ca380c$var$gridPaginationRowRangeSelector, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
/**
 * Get the id of each row to include in the current page if the pagination is enabled.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridPaginatedVisibleSortedGridRowIdsSelector = module.exports.gridPaginatedVisibleSortedGridRowIdsSelector = (0, $cgQ4y.createSelectorMemoized)($k278Q.gridExpandedSortedRowIdsSelector, $c41ec74257ca380c$var$gridPaginationRowRangeSelector, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
/**
 * Get the rows, range and rowIndex lookup map after filtering and sorting.
 * Does not contain the collapsed children.
 * @category Pagination
 */ const $c41ec74257ca380c$var$gridVisibleRowsSelector = module.exports.gridVisibleRowsSelector = (0, $cgQ4y.createSelectorMemoized)($c41ec74257ca380c$var$gridPaginationEnabledClientSideSelector, $c41ec74257ca380c$var$gridPaginationRowRangeSelector, $c41ec74257ca380c$var$gridPaginatedVisibleSortedGridRowEntriesSelector, $k278Q.gridExpandedSortedRowEntriesSelector, (clientPaginationEnabled, paginationRowRange, paginationRows, expandedSortedRowEntries)=>{
    if (clientPaginationEnabled) return {
        rows: paginationRows,
        range: paginationRowRange,
        rowIdToIndexMap: paginationRows.reduce((lookup, row, index)=>{
            lookup.set(row.id, index);
            return lookup;
        }, new Map())
    };
    return {
        rows: expandedSortedRowEntries,
        range: expandedSortedRowEntries.length === 0 ? null : {
            firstRowIndex: 0,
            lastRowIndex: expandedSortedRowEntries.length - 1
        },
        rowIdToIndexMap: expandedSortedRowEntries.reduce((lookup, row, index)=>{
            lookup.set(row.id, index);
            return lookup;
        }, new Map())
    };
});

});
parcelRegister("baj2X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throwIfPageSizeExceedsTheLimit = module.exports.getValidPage = module.exports.getPageCount = module.exports.getDefaultGridPaginationModel = module.exports.defaultPageSize = void 0;

var $iVTh1 = parcelRequire("iVTh1");
const $820f672e99dc58bd$var$MAX_PAGE_SIZE = 100;
const $820f672e99dc58bd$var$defaultPageSize = (autoPageSize)=>autoPageSize ? 0 : 100;
module.exports.defaultPageSize = $820f672e99dc58bd$var$defaultPageSize;
const $820f672e99dc58bd$var$getPageCount = (rowCount, pageSize, page)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    if (rowCount === -1) // With unknown row-count, we can assume a page after the current one
    return page + 2;
    return 0;
};
module.exports.getPageCount = $820f672e99dc58bd$var$getPageCount;
const $820f672e99dc58bd$var$getDefaultGridPaginationModel = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
module.exports.getDefaultGridPaginationModel = $820f672e99dc58bd$var$getDefaultGridPaginationModel;
const $820f672e99dc58bd$var$getValidPage = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
module.exports.getValidPage = $820f672e99dc58bd$var$getValidPage;
const $820f672e99dc58bd$var$throwIfPageSizeExceedsTheLimit = (pageSize, signatureProp)=>{
    if (signatureProp === $iVTh1.GridSignature.DataGrid && pageSize > $820f672e99dc58bd$var$MAX_PAGE_SIZE) throw new Error([
        'MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};
module.exports.throwIfPageSizeExceedsTheLimit = $820f672e99dc58bd$var$throwIfPageSizeExceedsTheLimit;

});




parcelRegister("axs1H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7ac2b9e608be0423$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridDateTimeFormatter = module.exports.gridDateFormatter = module.exports.GRID_DATE_COL_DEF = module.exports.GRID_DATETIME_COL_DEF = void 0;

var $7ac2b9e608be0423$var$_extends2 = $7ac2b9e608be0423$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $h8fXG = parcelRequire("h8fXG");

var $5GOJA = parcelRequire("5GOJA");

var $bSL2h = parcelRequire("bSL2h");

var $3D30W = parcelRequire("3D30W");

var $180lm = parcelRequire("180lm");

var $7sDf4 = parcelRequire("7sDf4");
function $7ac2b9e608be0423$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI X: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
const $7ac2b9e608be0423$var$gridDateFormatter = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $180lm.gridRowIdSelector)(apiRef, row);
    if ((0, $7sDf4.isAutogeneratedRow)(row) && !(value instanceof Date)) return value;
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleDateString();
};
module.exports.gridDateFormatter = $7ac2b9e608be0423$var$gridDateFormatter;
const $7ac2b9e608be0423$var$gridDateTimeFormatter = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $180lm.gridRowIdSelector)(apiRef, row);
    if ((0, $7sDf4.isAutogeneratedRow)(row) && !(value instanceof Date)) return value;
    $7ac2b9e608be0423$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleString();
};
module.exports.gridDateTimeFormatter = $7ac2b9e608be0423$var$gridDateTimeFormatter;
const $7ac2b9e608be0423$var$GRID_DATE_COL_DEF = module.exports.GRID_DATE_COL_DEF = (0, $7ac2b9e608be0423$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    type: 'date',
    sortComparator: $h8fXG.gridDateComparator,
    valueFormatter: $7ac2b9e608be0423$var$gridDateFormatter,
    filterOperators: (0, $5GOJA.getGridDateOperators)(),
    renderEditCell: $3D30W.renderEditDateCell,
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $7ac2b9e608be0423$var$GRID_DATETIME_COL_DEF = module.exports.GRID_DATETIME_COL_DEF = (0, $7ac2b9e608be0423$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    type: 'dateTime',
    sortComparator: $h8fXG.gridDateComparator,
    valueFormatter: $7ac2b9e608be0423$var$gridDateTimeFormatter,
    filterOperators: (0, $5GOJA.getGridDateOperators)(true),
    renderEditCell: $3D30W.renderEditDateCell,
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});

});
parcelRegister("5GOJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridDateOperators = void 0;

var $5y3Nn = parcelRequire("5y3Nn");
function $42483ac831686fc7$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepRawComparison) {
    if (!filterItem.value) return null;
    const date = new Date(filterItem.value);
    if (showTime) date.setSeconds(0, 0);
    else {
        // In GMT-X timezone, the date will be one day behind.
        // For 2022-08-16:
        // GMT+2: Tue Aug 16 2022 02:00:00 GMT+0200
        // GMT-4: Mon Aug 15 2022 20:00:00 GMT-0400
        //
        // We need to add the offset before resetting the hours.
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        date.setHours(0, 0, 0, 0);
    }
    const time = date.getTime();
    return (value)=>{
        if (!value) return false;
        if (keepRawComparison) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        if (showTime) dateCopy.setSeconds(0, 0);
        else dateCopy.setHours(0, 0, 0, 0);
        return compareFn(dateCopy.getTime(), time);
    };
}
const $42483ac831686fc7$var$getGridDateOperators = (showTime)=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: $5y3Nn.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: $5y3Nn.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime, showTime);
            },
            InputComponent: $5y3Nn.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime, showTime);
            },
            InputComponent: $5y3Nn.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, true);
            },
            InputComponent: $5y3Nn.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFn: (filterItem)=>{
                return $42483ac831686fc7$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime, showTime);
            },
            InputComponent: $5y3Nn.GridFilterInputDate,
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];
module.exports.getGridDateOperators = $42483ac831686fc7$var$getGridDateOperators;

});
parcelRegister("5y3Nn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $40a3126b9e135d1e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $40a3126b9e135d1e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterInputDate = $40a3126b9e135d1e$var$GridFilterInputDate;

var $40a3126b9e135d1e$var$_extends2 = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $40a3126b9e135d1e$var$_objectWithoutPropertiesLoose2 = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("c05no")));

var $40a3126b9e135d1e$var$React = $40a3126b9e135d1e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $40a3126b9e135d1e$var$_propTypes = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $40a3126b9e135d1e$var$_useId = $40a3126b9e135d1e$require$_interopRequireDefault((parcelRequire("hwliF")));

var $5oDOG = parcelRequire("5oDOG");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $40a3126b9e135d1e$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "slotProps",
    "isFilterActive",
    "headerFilterMenu",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $40a3126b9e135d1e$var$convertFilterItemValueToInputValue(itemValue, inputType) {
    if (itemValue == null) return '';
    const dateCopy = new Date(itemValue);
    if (Number.isNaN(dateCopy.getTime())) return '';
    if (inputType === 'date') return dateCopy.toISOString().substring(0, 10);
    if (inputType === 'datetime-local') {
        // The date picker expects the date to be in the local timezone.
        // But .toISOString() converts it to UTC with zero offset.
        // So we need to subtract the timezone offset.
        dateCopy.setMinutes(dateCopy.getMinutes() - dateCopy.getTimezoneOffset());
        return dateCopy.toISOString().substring(0, 19);
    }
    return dateCopy.toISOString().substring(0, 10);
}
function $40a3126b9e135d1e$var$GridFilterInputDate(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps, headerFilterMenu: headerFilterMenu, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $40a3126b9e135d1e$var$_objectWithoutPropertiesLoose2.default)(props, $40a3126b9e135d1e$var$_excluded);
    const rootSlotProps = slotProps?.root.slotProps;
    const filterTimeout = (0, $5oDOG.useTimeout)();
    const [filterValueState, setFilterValueState] = $40a3126b9e135d1e$var$React.useState(()=>$40a3126b9e135d1e$var$convertFilterItemValueToInputValue(item.value, type));
    const [applying, setIsApplying] = $40a3126b9e135d1e$var$React.useState(false);
    const id = (0, $40a3126b9e135d1e$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const onFilterChange = $40a3126b9e135d1e$var$React.useCallback((event)=>{
        filterTimeout.clear();
        const value = event.target.value;
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const date = new Date(value);
            applyValue((0, $40a3126b9e135d1e$var$_extends2.default)({}, item, {
                value: Number.isNaN(date.getTime()) ? undefined : date
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $40a3126b9e135d1e$var$React.useEffect(()=>{
        const value = $40a3126b9e135d1e$var$convertFilterItemValueToInputValue(item.value, type);
        setFilterValueState(value);
    }, [
        item.value,
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($40a3126b9e135d1e$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTextField, (0, $40a3126b9e135d1e$var$_extends2.default)({
                fullWidth: true,
                id: id,
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                value: filterValueState,
                onChange: onFilterChange,
                type: type || 'text',
                disabled: disabled,
                inputRef: focusElementRef,
                slotProps: (0, $40a3126b9e135d1e$var$_extends2.default)({}, rootSlotProps, {
                    input: (0, $40a3126b9e135d1e$var$_extends2.default)({
                        endAdornment: applying ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.loadIcon, {
                            fontSize: "small",
                            color: "action"
                        }) : null
                    }, rootSlotProps?.input),
                    htmlInput: (0, $40a3126b9e135d1e$var$_extends2.default)({
                        max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                        tabIndex: tabIndex
                    }, rootSlotProps?.htmlInput)
                })
            }, rootProps.slotProps?.baseTextField, other, slotProps?.root)),
            headerFilterMenu,
            clearButton
        ]
    });
}

});


parcelRegister("3D30W", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2a475a2a246869fc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2a475a2a246869fc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridEditDateCell = $2a475a2a246869fc$var$GridEditDateCell;
module.exports.renderEditDateCell = void 0;

var $2a475a2a246869fc$var$_extends2 = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2a475a2a246869fc$var$_objectWithoutPropertiesLoose2 = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("c05no")));

var $2a475a2a246869fc$var$React = $2a475a2a246869fc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2a475a2a246869fc$var$_propTypes = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2a475a2a246869fc$var$_composeClasses = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2a475a2a246869fc$var$_useEnhancedEffect = $2a475a2a246869fc$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8xDHs = parcelRequire("8xDHs");

var $j0vMH = parcelRequire("j0vMH");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $2a475a2a246869fc$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange",
    "slotProps"
];
const $2a475a2a246869fc$var$StyledInputBase = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    slot: 'internal'
})({
    fontSize: 'inherit'
});
const $2a475a2a246869fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $2a475a2a246869fc$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $2a475a2a246869fc$var$GridEditDateCell(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, onValueChange: onValueChange, slotProps: slotProps } = props, other = (0, $2a475a2a246869fc$var$_objectWithoutPropertiesLoose2.default)(props, $2a475a2a246869fc$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const inputRef = $2a475a2a246869fc$var$React.useRef(null);
    const valueTransformed = $2a475a2a246869fc$var$React.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp ?? '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $2a475a2a246869fc$var$React.useState(valueTransformed);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $2a475a2a246869fc$var$useUtilityClasses(ownerState);
    const parseValueToDate = $2a475a2a246869fc$var$React.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $2a475a2a246869fc$var$React.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $2a475a2a246869fc$var$React.useEffect(()=>{
        setValueState((state)=>{
            if (valueTransformed.parsed !== state.parsed && valueTransformed.parsed?.getTime() !== state.parsed?.getTime()) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $2a475a2a246869fc$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$var$StyledInputBase, (0, $2a475a2a246869fc$var$_extends2.default)({
        as: rootProps.slots.baseInput,
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        value: valueState.formatted,
        onChange: handleChange
    }, other, slotProps?.root, {
        slotProps: {
            htmlInput: (0, $2a475a2a246869fc$var$_extends2.default)({
                max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
            }, slotProps?.root?.slotProps?.htmlInput)
        }
    }));
}
const $2a475a2a246869fc$var$renderEditDateCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2a475a2a246869fc$var$GridEditDateCell, (0, $2a475a2a246869fc$var$_extends2.default)({}, params));
module.exports.renderEditDateCell = $2a475a2a246869fc$var$renderEditDateCell;

});


parcelRegister("e79LH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a4694bea3e886bc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_NUMERIC_COL_DEF = void 0;

var $a4694bea3e886bc3$var$_extends2 = $a4694bea3e886bc3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $h8fXG = parcelRequire("h8fXG");

var $lR3Vo = parcelRequire("lR3Vo");

var $8SI7h = parcelRequire("8SI7h");

var $bSL2h = parcelRequire("bSL2h");
const $a4694bea3e886bc3$var$GRID_NUMERIC_COL_DEF = module.exports.GRID_NUMERIC_COL_DEF = (0, $a4694bea3e886bc3$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: $h8fXG.gridNumberComparator,
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: (value)=>(0, $lR3Vo.isNumber)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $8SI7h.getGridNumericOperators)(),
    getApplyQuickFilterFn: $8SI7h.getGridNumericQuickFilterFn
});

});
parcelRegister("8SI7h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridNumericQuickFilterFn = module.exports.getGridNumericOperators = void 0;

var $g7hyo = parcelRequire("g7hyo");

var $6tiPX = parcelRequire("6tiPX");
const $67759673d54fca41$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $67759673d54fca41$var$getGridNumericQuickFilterFn = (value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $67759673d54fca41$var$parseNumericValue(columnValue) === $67759673d54fca41$var$parseNumericValue(value);
    };
};
module.exports.getGridNumericQuickFilterFn = $67759673d54fca41$var$getGridNumericQuickFilterFn;
const $67759673d54fca41$var$getGridNumericOperators = ()=>[
        {
            value: '=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $67759673d54fca41$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $67759673d54fca41$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: $g7hyo.GridFilterInputValue,
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: $6tiPX.GridFilterInputMultipleValue,
            InputComponentProps: {
                type: 'number'
            }
        }
    ];
module.exports.getGridNumericOperators = $67759673d54fca41$var$getGridNumericOperators;

});


parcelRegister("2LzSK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $203bce01501b8211$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_SINGLE_SELECT_COL_DEF = void 0;

var $203bce01501b8211$var$_extends2 = $203bce01501b8211$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bSL2h = parcelRequire("bSL2h");

var $7cMVI = parcelRequire("7cMVI");

var $hIUWG = parcelRequire("hIUWG");

var $5z7Pl = parcelRequire("5z7Pl");

var $lR3Vo = parcelRequire("lR3Vo");

var $180lm = parcelRequire("180lm");
const $203bce01501b8211$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $203bce01501b8211$var$defaultGetOptionValue = (value)=>{
    return (0, $lR3Vo.isObject)(value) ? value.value : value;
};
const $203bce01501b8211$var$defaultGetOptionLabel = (value)=>{
    return (0, $lR3Vo.isObject)(value) ? value.label : String(value);
};
const $203bce01501b8211$var$GRID_SINGLE_SELECT_COL_DEF = module.exports.GRID_SINGLE_SELECT_COL_DEF = (0, $203bce01501b8211$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    type: 'singleSelect',
    getOptionLabel: $203bce01501b8211$var$defaultGetOptionLabel,
    getOptionValue: $203bce01501b8211$var$defaultGetOptionValue,
    valueFormatter (value, row, colDef, apiRef) {
        const rowId = (0, $180lm.gridRowIdSelector)(apiRef, row);
        if (!(0, $5z7Pl.isSingleSelectColDef)(colDef)) return '';
        const valueOptions = (0, $5z7Pl.getValueOptions)(colDef, {
            id: rowId,
            row: row
        });
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$203bce01501b8211$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: $7cMVI.renderEditSingleSelectCell,
    filterOperators: (0, $hIUWG.getGridSingleSelectOperators)(),
    // @ts-ignore
    pastedValueParser: (value, row, column)=>{
        const colDef = column;
        const valueOptions = (0, $5z7Pl.getValueOptions)(colDef) || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});

});
parcelRegister("7cMVI", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $53ef9bd93fd99a94$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $53ef9bd93fd99a94$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridEditSingleSelectCell = $53ef9bd93fd99a94$var$GridEditSingleSelectCell;
module.exports.renderEditSingleSelectCell = void 0;

var $53ef9bd93fd99a94$var$_extends2 = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $53ef9bd93fd99a94$var$_objectWithoutPropertiesLoose2 = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("c05no")));

var $53ef9bd93fd99a94$var$_react = $53ef9bd93fd99a94$require$_interopRequireWildcard((parcelRequire("acw62")));
var $53ef9bd93fd99a94$var$React = $53ef9bd93fd99a94$var$_react;

var $53ef9bd93fd99a94$var$_propTypes = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $53ef9bd93fd99a94$var$_useEnhancedEffect = $53ef9bd93fd99a94$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $iNfie = parcelRequire("iNfie");

var $jDpXp = parcelRequire("jDpXp");

var $jkRzp = parcelRequire("jkRzp");

var $5z7Pl = parcelRequire("5z7Pl");

var $bDyDY = parcelRequire("bDyDY");

var $ayMG0 = parcelRequire("ayMG0");
const $53ef9bd93fd99a94$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen",
    "slotProps"
];
function $53ef9bd93fd99a94$var$isKeyboardEvent(event) {
    return 'key' in event && !!event.key;
}
function $53ef9bd93fd99a94$var$GridEditSingleSelectCell(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === $jkRzp.GridEditModes.Cell, slotProps: slotProps } = props, other = (0, $53ef9bd93fd99a94$var$_objectWithoutPropertiesLoose2.default)(props, $53ef9bd93fd99a94$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ref = $53ef9bd93fd99a94$var$React.useRef(null);
    const inputRef = $53ef9bd93fd99a94$var$React.useRef(null);
    const [open, setOpen] = $53ef9bd93fd99a94$var$React.useState(initialOpen);
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    (0, $53ef9bd93fd99a94$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus) inputRef.current?.focus();
    }, [
        hasFocus
    ]);
    if (!(0, $5z7Pl.isSingleSelectColDef)(colDef)) return null;
    const valueOptions = (0, $5z7Pl.getValueOptions)(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) return null;
    const getOptionValue = colDef.getOptionValue;
    const getOptionLabel = colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $5z7Pl.isSingleSelectColDef)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $5z7Pl.getValueFromValueOptions)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === $jkRzp.GridEditModes.Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || event.key === 'Escape') {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $53ef9bd93fd99a94$var$_extends2.default)({}, params, {
                reason: event.key === 'Escape' ? $iNfie.GridCellEditStopReasons.escapeKeyDown : $iNfie.GridCellEditStopReasons.cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($53ef9bd93fd99a94$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $53ef9bd93fd99a94$var$_extends2.default)({
        ref: ref,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        onClose: handleClose,
        error: error,
        native: isSelectNative,
        fullWidth: true,
        slotProps: {
            htmlInput: {
                ref: inputRef
            }
        }
    }, other, slotProps?.root, rootProps.slotProps?.baseSelect, {
        children: valueOptions.map((valueOption)=>{
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $53ef9bd93fd99a94$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $53ef9bd93fd99a94$var$_extends2.default)({}, rootProps.slotProps?.baseSelectOption || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $53ef9bd93fd99a94$var$renderEditSingleSelectCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($53ef9bd93fd99a94$var$GridEditSingleSelectCell, (0, $53ef9bd93fd99a94$var$_extends2.default)({}, params));
module.exports.renderEditSingleSelectCell = $53ef9bd93fd99a94$var$renderEditSingleSelectCell;

});
parcelRegister("5z7Pl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40d64af47d07faaf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getValueFromValueOptions = $40d64af47d07faaf$var$getValueFromValueOptions;
module.exports.getValueOptions = $40d64af47d07faaf$var$getValueOptions;
module.exports.isSingleSelectColDef = $40d64af47d07faaf$var$isSingleSelectColDef;

var $40d64af47d07faaf$var$_extends2 = $40d64af47d07faaf$require$_interopRequireDefault((parcelRequire("3p9rK")));
function $40d64af47d07faaf$var$isSingleSelectColDef(colDef) {
    return colDef?.type === 'singleSelect';
}
function $40d64af47d07faaf$var$getValueOptions(column, additionalParams) {
    if (!column) return undefined;
    return typeof column.valueOptions === 'function' ? column.valueOptions((0, $40d64af47d07faaf$var$_extends2.default)({
        field: column.field
    }, additionalParams)) : column.valueOptions;
}
function $40d64af47d07faaf$var$getValueFromValueOptions(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}

});


parcelRegister("hIUWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridSingleSelectOperators = void 0;

var $4UMDV = parcelRequire("4UMDV");

var $DRQFc = parcelRequire("DRQFc");

var $lR3Vo = parcelRequire("lR3Vo");
const $ce72b7e51ff8300c$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $lR3Vo.isObject)(value)) return value;
    return value.value;
};
const $ce72b7e51ff8300c$var$getGridSingleSelectOperators = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) === $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: $4UMDV.GridFilterInputSingleSelect
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$ce72b7e51ff8300c$var$parseObjectValue(value) !== $ce72b7e51ff8300c$var$parseObjectValue(filterItem.value);
            },
            InputComponent: $4UMDV.GridFilterInputSingleSelect
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($ce72b7e51ff8300c$var$parseObjectValue);
                return (value)=>filterItemValues.includes($ce72b7e51ff8300c$var$parseObjectValue(value));
            },
            InputComponent: $DRQFc.GridFilterInputMultipleSingleSelect
        }
    ];
module.exports.getGridSingleSelectOperators = $ce72b7e51ff8300c$var$getGridSingleSelectOperators;

});
parcelRegister("4UMDV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $39421fe28cb0a5f3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $39421fe28cb0a5f3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterInputSingleSelect = $39421fe28cb0a5f3$var$GridFilterInputSingleSelect;

var $39421fe28cb0a5f3$var$_objectWithoutPropertiesLoose2 = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("c05no")));

var $39421fe28cb0a5f3$var$_extends2 = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $39421fe28cb0a5f3$var$_react = $39421fe28cb0a5f3$require$_interopRequireWildcard((parcelRequire("acw62")));
var $39421fe28cb0a5f3$var$React = $39421fe28cb0a5f3$var$_react;

var $39421fe28cb0a5f3$var$_propTypes = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $39421fe28cb0a5f3$var$_useId = $39421fe28cb0a5f3$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");

var $5z7Pl = parcelRequire("5z7Pl");

var $ayMG0 = parcelRequire("ayMG0");
const $39421fe28cb0a5f3$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "isFilterActive",
    "clearButton",
    "headerFilterMenu",
    "slotProps"
];
const $39421fe28cb0a5f3$var$renderSingleSelectOptions = ({ column: column, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = [
        '',
        ...(0, $5z7Pl.getValueOptions)(column) || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        let label = getOptionLabel(option);
        if (label === '') label = "\u2003"; // To force the height of the empty option
        return /*#__PURE__*/ (0, $39421fe28cb0a5f3$var$_react.createElement)(OptionComponent, (0, $39421fe28cb0a5f3$var$_extends2.default)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
function $39421fe28cb0a5f3$var$GridFilterInputSingleSelect(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, clearButton: clearButton, headerFilterMenu: headerFilterMenu, slotProps: slotProps } = props, other = (0, $39421fe28cb0a5f3$var$_objectWithoutPropertiesLoose2.default)(props, $39421fe28cb0a5f3$var$_excluded);
    const filterValue = item.value ?? '';
    const id = (0, $39421fe28cb0a5f3$var$_useId.default)();
    const labelId = (0, $39421fe28cb0a5f3$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isSelectNative = rootProps.slotProps?.baseSelect?.native ?? false;
    const resolvedColumn = apiRef.current.getColumn(item.field);
    const getOptionValue = resolvedColumn.getOptionValue;
    const getOptionLabel = resolvedColumn.getOptionLabel;
    const currentValueOptions = $39421fe28cb0a5f3$var$React.useMemo(()=>{
        return (0, $5z7Pl.getValueOptions)(resolvedColumn);
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $39421fe28cb0a5f3$var$React.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $5z7Pl.getValueFromValueOptions)(value, currentValueOptions, getOptionValue);
        applyValue((0, $39421fe28cb0a5f3$var$_extends2.default)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    if (!resolvedColumn || !(0, $5z7Pl.isSingleSelectColDef)(resolvedColumn)) return null;
    const label = slotProps?.root.label ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($39421fe28cb0a5f3$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSelect, (0, $39421fe28cb0a5f3$var$_extends2.default)({
                fullWidth: true,
                id: id,
                label: label,
                labelId: labelId,
                value: filterValue,
                onChange: onFilterChange,
                slotProps: {
                    htmlInput: (0, $39421fe28cb0a5f3$var$_extends2.default)({
                        tabIndex: tabIndex,
                        ref: focusElementRef,
                        type: type || 'text',
                        placeholder: slotProps?.root.placeholder ?? apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                    }, slotProps?.root.slotProps?.htmlInput)
                },
                native: isSelectNative
            }, rootProps.slotProps?.baseSelect, other, slotProps?.root, {
                children: $39421fe28cb0a5f3$var$renderSingleSelectOptions({
                    column: resolvedColumn,
                    OptionComponent: rootProps.slots.baseSelectOption,
                    getOptionLabel: getOptionLabel,
                    getOptionValue: getOptionValue,
                    isSelectNative: isSelectNative,
                    baseSelectOptionProps: rootProps.slotProps?.baseSelectOption
                })
            })),
            headerFilterMenu,
            clearButton
        ]
    });
}

});

parcelRegister("DRQFc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $077d69ce451095d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $077d69ce451095d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterInputMultipleSingleSelect = $077d69ce451095d0$var$GridFilterInputMultipleSingleSelect;

var $077d69ce451095d0$var$_extends2 = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $077d69ce451095d0$var$_objectWithoutPropertiesLoose2 = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("c05no")));

var $077d69ce451095d0$var$React = $077d69ce451095d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $077d69ce451095d0$var$_propTypes = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $077d69ce451095d0$var$_useId = $077d69ce451095d0$require$_interopRequireDefault((parcelRequire("hwliF")));

var $jDpXp = parcelRequire("jDpXp");

var $5z7Pl = parcelRequire("5z7Pl");

var $ayMG0 = parcelRequire("ayMG0");
const $077d69ce451095d0$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "slotProps"
];
function $077d69ce451095d0$var$GridFilterInputMultipleSingleSelect(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps } = props, other = (0, $077d69ce451095d0$var$_objectWithoutPropertiesLoose2.default)(props, $077d69ce451095d0$var$_excluded);
    const id = (0, $077d69ce451095d0$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const resolvedColumn = apiRef.current.getColumn(item.field);
    const getOptionValue = resolvedColumn.getOptionValue;
    const getOptionLabel = resolvedColumn.getOptionLabel;
    const isOptionEqualToValue = $077d69ce451095d0$var$React.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $077d69ce451095d0$var$React.useMemo(()=>{
        return (0, $5z7Pl.getValueOptions)(resolvedColumn) || [];
    }, [
        resolvedColumn
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $077d69ce451095d0$var$React.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        return item.value.reduce((acc, value)=>{
            const resolvedValue = resolvedValueOptions.find((v)=>getOptionValue(v) === value);
            if (resolvedValue != null) acc.push(resolvedValue);
            return acc;
        }, []);
    }, [
        getOptionValue,
        item.value,
        resolvedValueOptions
    ]);
    const handleChange = $077d69ce451095d0$var$React.useCallback((event, value)=>{
        applyValue((0, $077d69ce451095d0$var$_extends2.default)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    if (!resolvedColumn || !(0, $5z7Pl.isSingleSelectColDef)(resolvedColumn)) return null;
    const BaseAutocomplete = rootProps.slots.baseAutocomplete;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(BaseAutocomplete, (0, $077d69ce451095d0$var$_extends2.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        slotProps: {
            textField: {
                type: type || 'text',
                inputRef: focusElementRef
            }
        }
    }, other, slotProps?.root));
}

});



parcelRegister("4SEnU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $38db882209cf5ffd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRID_LONG_TEXT_COL_DEF = void 0;

var $38db882209cf5ffd$var$_extends2 = $38db882209cf5ffd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bSL2h = parcelRequire("bSL2h");

var $7CNB5 = parcelRequire("7CNB5");

var $vPZmP = parcelRequire("vPZmP");
const $38db882209cf5ffd$var$GRID_LONG_TEXT_COL_DEF = module.exports.GRID_LONG_TEXT_COL_DEF = (0, $38db882209cf5ffd$var$_extends2.default)({}, $bSL2h.GRID_STRING_COL_DEF, {
    type: 'longText',
    display: 'flex',
    renderCell: $7CNB5.renderLongTextCell,
    renderEditCell: $vPZmP.renderEditLongTextCell
});

});
parcelRegister("7CNB5", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $58d28df4e9c6c429$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $58d28df4e9c6c429$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridLongTextCell = $58d28df4e9c6c429$var$GridLongTextCell;
module.exports.renderLongTextCell = void 0;

var $58d28df4e9c6c429$var$_extends2 = $58d28df4e9c6c429$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $58d28df4e9c6c429$var$React = $58d28df4e9c6c429$require$_interopRequireWildcard((parcelRequire("acw62")));

var $58d28df4e9c6c429$var$_clsx = $58d28df4e9c6c429$require$_interopRequireDefault((parcelRequire("9QePP")));

var $58d28df4e9c6c429$var$_composeClasses = $58d28df4e9c6c429$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $61HyH = parcelRequire("61HyH");

var $j0vMH = parcelRequire("j0vMH");

var $hbuUJ = parcelRequire("hbuUJ");

var $ayMG0 = parcelRequire("ayMG0");
const $58d28df4e9c6c429$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'longTextCell'
        ],
        content: [
            'longTextCellContent'
        ],
        expandButton: [
            'longTextCellExpandButton'
        ],
        collapseButton: [
            'longTextCellCollapseButton'
        ],
        popup: [
            'longTextCellPopup'
        ],
        popperContent: [
            'longTextCellPopperContent'
        ]
    };
    return (0, $58d28df4e9c6c429$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $58d28df4e9c6c429$var$GridLongTextCellRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'LongTextCell'
})({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative'
});
const $58d28df4e9c6c429$var$GridLongTextCellContent = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'LongTextCellContent'
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1
});
const $58d28df4e9c6c429$var$GridLongTextCellPopperContent = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'LongTextCellPopperContent'
})(({ theme: theme })=>(0, $58d28df4e9c6c429$var$_extends2.default)({}, theme.typography.body2, {
        letterSpacing: 'normal',
        paddingBlock: 15.5,
        paddingInline: 9,
        maxHeight: 156,
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        width: 'var(--_width)',
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        boxSizing: 'border-box'
    }));
const $58d28df4e9c6c429$var$GridLongTextCellCornerButton = (0, $8xDHs.styled)('button', {
    name: 'MuiDataGrid',
    slot: 'LongTextCellCornerButton'
})(({ theme: theme })=>({
        lineHeight: 0,
        position: 'absolute',
        bottom: 1,
        right: 0,
        border: '1px solid',
        color: (theme.vars || theme).palette.text.secondary,
        borderColor: (theme.vars || theme).palette.divider,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: 0,
        fontSize: '0.875rem',
        padding: 2,
        '&:focus-visible': {
            outline: 'none'
        },
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.background.paper,
            color: (theme.vars || theme).palette.text.primary
        },
        [`&.${$5H1vo.gridClasses.longTextCellExpandButton}`]: {
            right: -9,
            opacity: 0,
            [`.${$5H1vo.gridClasses.longTextCell}:hover &, .${$5H1vo.gridClasses.longTextCell}.Mui-focused &`]: {
                opacity: 1
            }
        },
        [`&.${$5H1vo.gridClasses.longTextCellCollapseButton}`]: {
            bottom: 2,
            right: 2,
            border: 'none'
        }
    }));
const $58d28df4e9c6c429$var$GridLongTextCellPopper = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'LongTextCellPopper'
})(({ theme: theme })=>({
        zIndex: $hbuUJ.vars.zIndex.menu,
        background: (theme.vars || theme).palette.background.paper,
        '&[data-popper-reference-hidden]': {
            visibility: 'hidden',
            pointerEvents: 'none'
        }
    }));
function $58d28df4e9c6c429$var$GridLongTextCell(props) {
    const { id: id, value: value = '', colDef: colDef, hasFocus: hasFocus, slotProps: slotProps, renderContent: renderContent } = props;
    const popupId = `${id}-${colDef.field}-longtext-popup`;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const classes = $58d28df4e9c6c429$var$useUtilityClasses(rootProps);
    const rowHeight = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridRowHeightSelector);
    const [popupOpen, setPopupOpen] = $58d28df4e9c6c429$var$React.useState(false);
    const cellRef = $58d28df4e9c6c429$var$React.useRef(null);
    const cornerButtonRef = $58d28df4e9c6c429$var$React.useRef(null);
    $58d28df4e9c6c429$var$React.useEffect(()=>{
        if (hasFocus && !popupOpen) {
            if (cornerButtonRef.current && cornerButtonRef.current !== document.activeElement) cornerButtonRef.current.focus();
        }
        if (!hasFocus) setPopupOpen(false);
    }, [
        hasFocus,
        popupOpen
    ]);
    const handleExpandClick = (event)=>{
        // event.detail === 0 means keyboard-triggered click (Enter keyup on focused button)
        // Ignore these to prevent popup from opening when focus moves to this cell via Enter
        if (event.detail === 0) return;
        event.stopPropagation();
        setPopupOpen(true);
    };
    const handleExpandKeyDown = (event)=>{
        if (event.key === ' ' && !event.shiftKey) {
            event.preventDefault(); // Prevent native button click on keyup
            event.stopPropagation(); // Prevent grid row selection
            setPopupOpen((prev)=>!prev);
        }
        if (event.key === 'Escape' && popupOpen) {
            event.stopPropagation(); // Prevent grid cell navigation
            setPopupOpen(false);
        }
    };
    const handleClickAway = ()=>{
        setPopupOpen(false);
    };
    const handleCollapseClick = (event)=>{
        event.stopPropagation();
        setPopupOpen(false);
        apiRef.current.getCellElement(id, colDef.field)?.focus();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($58d28df4e9c6c429$var$GridLongTextCellRoot, (0, $58d28df4e9c6c429$var$_extends2.default)({
        ref: cellRef
    }, slotProps?.root, {
        className: (0, $58d28df4e9c6c429$var$_clsx.default)(classes.root, slotProps?.root?.className, hasFocus && 'Mui-focused'),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($58d28df4e9c6c429$var$GridLongTextCellContent, (0, $58d28df4e9c6c429$var$_extends2.default)({}, slotProps?.content, {
                className: (0, $58d28df4e9c6c429$var$_clsx.default)(classes.content, slotProps?.content?.className),
                children: value
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($58d28df4e9c6c429$var$GridLongTextCellCornerButton, (0, $58d28df4e9c6c429$var$_extends2.default)({
                ref: cornerButtonRef,
                "aria-label": `${value}, ${apiRef.current.getLocaleText('longTextCellExpandLabel')}`,
                "aria-haspopup": "dialog",
                "aria-controls": popupOpen ? popupId : undefined,
                "aria-expanded": popupOpen,
                "aria-keyshortcuts": "Space",
                tabIndex: 0
            }, slotProps?.expandButton, {
                className: (0, $58d28df4e9c6c429$var$_clsx.default)(classes.expandButton, slotProps?.expandButton?.className),
                onClick: handleExpandClick,
                onKeyDown: handleExpandKeyDown,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.longTextCellExpandIcon, {
                    fontSize: "inherit"
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($58d28df4e9c6c429$var$GridLongTextCellPopper, (0, $58d28df4e9c6c429$var$_extends2.default)({
                id: popupId,
                role: "dialog",
                "aria-label": colDef.headerName || colDef.field,
                as: rootProps.slots.basePopper,
                ownerState: rootProps,
                open: popupOpen,
                target: cellRef.current,
                placement: "bottom-start",
                onClickAway: handleClickAway,
                clickAwayMouseEvent: "onMouseDown",
                flip: true,
                material: {
                    container: cellRef.current?.closest('[role="row"]'),
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [
                                    -10,
                                    -rowHeight
                                ]
                            }
                        }
                    ]
                }
            }, slotProps?.popper, {
                className: (0, $58d28df4e9c6c429$var$_clsx.default)(classes.popup, slotProps?.popper?.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($58d28df4e9c6c429$var$GridLongTextCellPopperContent, (0, $58d28df4e9c6c429$var$_extends2.default)({
                    tabIndex: -1,
                    onKeyDown: (event)=>{
                        if (event.key === 'Escape') {
                            event.stopPropagation();
                            setPopupOpen(false);
                            apiRef.current.getCellElement(id, colDef.field)?.focus();
                        }
                    }
                }, slotProps?.popperContent, {
                    className: (0, $58d28df4e9c6c429$var$_clsx.default)(classes.popperContent, slotProps?.popperContent?.className),
                    style: (0, $58d28df4e9c6c429$var$_extends2.default)({
                        '--_width': `${colDef.computedWidth}px`
                    }, slotProps?.popperContent?.style),
                    children: [
                        renderContent ? renderContent(value) : value,
                        /*#__PURE__*/ (0, $ayMG0.jsx)($58d28df4e9c6c429$var$GridLongTextCellCornerButton, (0, $58d28df4e9c6c429$var$_extends2.default)({
                            "aria-label": apiRef.current.getLocaleText('longTextCellCollapseLabel'),
                            "aria-keyshortcuts": "Escape"
                        }, slotProps?.collapseButton, {
                            className: (0, $58d28df4e9c6c429$var$_clsx.default)(classes.collapseButton, slotProps?.collapseButton?.className),
                            onClick: handleCollapseClick,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.longTextCellCollapseIcon, {
                                fontSize: "inherit"
                            })
                        }))
                    ]
                }))
            }))
        ]
    }));
}
const $58d28df4e9c6c429$var$renderLongTextCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($58d28df4e9c6c429$var$GridLongTextCell, (0, $58d28df4e9c6c429$var$_extends2.default)({}, params));
module.exports.renderLongTextCell = $58d28df4e9c6c429$var$renderLongTextCell;

});

parcelRegister("vPZmP", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $05fb39419d2a1978$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $05fb39419d2a1978$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridEditLongTextCell = $05fb39419d2a1978$var$GridEditLongTextCell;
module.exports.renderEditLongTextCell = void 0;

var $05fb39419d2a1978$var$_extends2 = $05fb39419d2a1978$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $05fb39419d2a1978$var$React = $05fb39419d2a1978$require$_interopRequireWildcard((parcelRequire("acw62")));

var $05fb39419d2a1978$var$_clsx = $05fb39419d2a1978$require$_interopRequireDefault((parcelRequire("9QePP")));

var $05fb39419d2a1978$var$_composeClasses = $05fb39419d2a1978$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $05fb39419d2a1978$var$_useEnhancedEffect = $05fb39419d2a1978$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8xDHs = parcelRequire("8xDHs");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $61HyH = parcelRequire("61HyH");

var $j0vMH = parcelRequire("j0vMH");

var $hbuUJ = parcelRequire("hbuUJ");

var $ayMG0 = parcelRequire("ayMG0");
const $05fb39419d2a1978$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editLongTextCell'
        ],
        value: [
            'editLongTextCellValue'
        ],
        popup: [
            'editLongTextCellPopup'
        ],
        popperContent: [
            'editLongTextCellPopperContent'
        ],
        textarea: [
            'editLongTextCellTextarea'
        ]
    };
    return (0, $05fb39419d2a1978$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $05fb39419d2a1978$var$GridEditLongTextCellTextarea = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'EditLongTextCellTextarea'
})(({ theme: theme })=>(0, $05fb39419d2a1978$var$_extends2.default)({
        width: '100%',
        padding: 0
    }, theme.typography.body2, {
        letterSpacing: 'normal',
        outline: 'none',
        background: 'transparent',
        border: 'none',
        resize: 'vertical'
    }));
const $05fb39419d2a1978$var$GridEditLongTextCellRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'EditLongTextCell'
})({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative'
});
const $05fb39419d2a1978$var$GridEditLongTextCellValue = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'EditLongTextCellValue'
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    paddingInline: 10
});
const $05fb39419d2a1978$var$GridEditLongTextCellPopper = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'EditLongTextCellPopper'
})(({ theme: theme })=>({
        zIndex: $hbuUJ.vars.zIndex.menu,
        background: (theme.vars || theme).palette.background.paper,
        '&[data-popper-reference-hidden]': {
            opacity: 0 // use opacity to preserve focus.
        }
    }));
const $05fb39419d2a1978$var$GridEditLongTextCellPopperContent = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'EditLongTextCellPopperContent'
})(({ theme: theme })=>(0, $05fb39419d2a1978$var$_extends2.default)({}, theme.typography.body2, {
        letterSpacing: 'normal',
        paddingBlock: 15.5,
        paddingInline: 9,
        height: 'max-content',
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        width: 'var(--_width)',
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        boxShadow: (theme.vars || theme).shadows[4],
        boxSizing: 'border-box'
    }));
function $05fb39419d2a1978$var$GridEditLongTextCell(props) {
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, cellMode: cellMode, slotProps: slotProps } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const classes = $05fb39419d2a1978$var$useUtilityClasses(rootProps);
    const rowHeight = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridRowHeightSelector);
    const [valueState, setValueState] = $05fb39419d2a1978$var$React.useState(value);
    const [anchorEl, setAnchorEl] = $05fb39419d2a1978$var$React.useState(null);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    const popupId = `${id}-${field}-longtext-edit-popup`;
    // Only show popup when this cell has focus
    // This fixes editMode="row" where all cells enter edit mode simultaneously
    const showPopup = hasFocus && Boolean(anchorEl);
    $05fb39419d2a1978$var$React.useEffect(()=>{
        if (meta?.changeReason !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($05fb39419d2a1978$var$GridEditLongTextCellRoot, (0, $05fb39419d2a1978$var$_extends2.default)({
        tabIndex: cellMode === 'edit' && rootProps.editMode === 'row' ? 0 : undefined,
        ref: setAnchorEl,
        "aria-controls": showPopup ? popupId : undefined,
        "aria-expanded": showPopup
    }, slotProps?.root, {
        className: (0, $05fb39419d2a1978$var$_clsx.default)(classes.root, slotProps?.root?.className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($05fb39419d2a1978$var$GridEditLongTextCellValue, (0, $05fb39419d2a1978$var$_extends2.default)({}, slotProps?.value, {
                className: (0, $05fb39419d2a1978$var$_clsx.default)(classes.value, slotProps?.value?.className),
                children: valueState
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($05fb39419d2a1978$var$GridEditLongTextCellPopper, (0, $05fb39419d2a1978$var$_extends2.default)({
                as: rootProps.slots.basePopper,
                ownerState: rootProps,
                id: popupId,
                role: "dialog",
                "aria-label": colDef.headerName || field,
                open: showPopup,
                target: anchorEl,
                placement: "bottom-start",
                flip: true,
                material: {
                    container: anchorEl?.closest('[role="row"]'),
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [
                                    -1,
                                    -rowHeight
                                ]
                            }
                        }
                    ]
                }
            }, slotProps?.popper, {
                className: (0, $05fb39419d2a1978$var$_clsx.default)(classes.popup, slotProps?.popper?.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($05fb39419d2a1978$var$GridEditLongTextCellPopperContent, (0, $05fb39419d2a1978$var$_extends2.default)({}, slotProps?.popperContent, {
                    className: (0, $05fb39419d2a1978$var$_clsx.default)(classes.popperContent, slotProps?.popperContent?.className),
                    style: {
                        '--_width': `${colDef.computedWidth}px`
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($05fb39419d2a1978$var$GridEditLongTextarea, (0, $05fb39419d2a1978$var$_extends2.default)({}, props, {
                        valueState: valueState,
                        setValueState: setValueState
                    }))
                }))
            }))
        ]
    }));
}
function $05fb39419d2a1978$var$GridEditLongTextarea(props) {
    const { id: id, field: field, colDef: colDef, debounceMs: debounceMs = 200, onValueChange: onValueChange, valueState: valueState, setValueState: setValueState, hasFocus: hasFocus, slotProps: slotProps } = props;
    const textareaRef = $05fb39419d2a1978$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $05fb39419d2a1978$var$useUtilityClasses(rootProps);
    (0, $05fb39419d2a1978$var$_useEnhancedEffect.default)(()=>{
        if (hasFocus && textareaRef.current) {
            // preventScroll: the popper is portaled into the GridRow, so focusing
            // without it triggers the browser to scroll the grid container which is undesirable.
            textareaRef.current.focus({
                preventScroll: true
            });
            // Move cursor to end of text
            const length = textareaRef.current.value.length;
            textareaRef.current.setSelectionRange(length, length);
        }
    }, [
        hasFocus
    ]);
    const handleChange = $05fb39419d2a1978$var$React.useCallback(async (event)=>{
        const newValue = event.target.value;
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
        if (onValueChange) await onValueChange(event, newValue);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange,
        setValueState
    ]);
    const handleKeyDown = $05fb39419d2a1978$var$React.useCallback((event)=>{
        if (event.key === 'Enter' && event.shiftKey) // Shift+Enter: let textarea handle newline, stop propagation to prevent grid from exiting edit
        event.stopPropagation();
        if (rootProps.editMode === 'cell' && event.key === 'Escape') apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: true
        });
    }, [
        apiRef,
        field,
        id,
        rootProps.editMode
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05fb39419d2a1978$var$GridEditLongTextCellTextarea, (0, $05fb39419d2a1978$var$_extends2.default)({
        ref: textareaRef,
        as: rootProps.slots.baseTextarea,
        ownerState: rootProps,
        "aria-label": colDef.headerName || field,
        value: valueState ?? '',
        onChange: handleChange,
        onKeyDown: handleKeyDown
    }, slotProps?.textarea, {
        className: (0, $05fb39419d2a1978$var$_clsx.default)(classes.textarea, slotProps?.textarea?.className)
    }));
}
const $05fb39419d2a1978$var$renderEditLongTextCell = (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($05fb39419d2a1978$var$GridEditLongTextCell, (0, $05fb39419d2a1978$var$_extends2.default)({}, params));
module.exports.renderEditLongTextCell = $05fb39419d2a1978$var$renderEditLongTextCell;

});


parcelRegister("5rUcf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridDefaultColumnTypes = module.exports.DEFAULT_GRID_COL_TYPE_KEY = void 0;

var $bSL2h = parcelRequire("bSL2h");

var $e79LH = parcelRequire("e79LH");

var $axs1H = parcelRequire("axs1H");

var $iNueb = parcelRequire("iNueb");

var $2LzSK = parcelRequire("2LzSK");

var $8z2XQ = parcelRequire("8z2XQ");

var $4SEnU = parcelRequire("4SEnU");
const $3f7b10d3cc3b3307$var$DEFAULT_GRID_COL_TYPE_KEY = module.exports.DEFAULT_GRID_COL_TYPE_KEY = 'string';
const $3f7b10d3cc3b3307$var$getGridDefaultColumnTypes = ()=>{
    const nativeColumnTypes = {
        string: $bSL2h.GRID_STRING_COL_DEF,
        number: $e79LH.GRID_NUMERIC_COL_DEF,
        date: $axs1H.GRID_DATE_COL_DEF,
        dateTime: $axs1H.GRID_DATETIME_COL_DEF,
        boolean: $iNueb.GRID_BOOLEAN_COL_DEF,
        singleSelect: $2LzSK.GRID_SINGLE_SELECT_COL_DEF,
        [$8z2XQ.GRID_ACTIONS_COLUMN_TYPE]: $8z2XQ.GRID_ACTIONS_COL_DEF,
        custom: $bSL2h.GRID_STRING_COL_DEF,
        longText: $4SEnU.GRID_LONG_TEXT_COL_DEF
    };
    return nativeColumnTypes;
};
module.exports.getGridDefaultColumnTypes = $3f7b10d3cc3b3307$var$getGridDefaultColumnTypes;

});


parcelRegister("6forD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridHeaderFilteringStateSelector = module.exports.gridHeaderFilteringMenuSelector = module.exports.gridHeaderFilteringEnabledSelector = module.exports.gridHeaderFilteringEditFieldSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $48c71b00043b47b4$var$gridHeaderFilteringStateSelector = module.exports.gridHeaderFilteringStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.headerFiltering);
const $48c71b00043b47b4$var$gridHeaderFilteringEnabledSelector = module.exports.gridHeaderFilteringEnabledSelector = (0, $cgQ4y.createSelector)($48c71b00043b47b4$var$gridHeaderFilteringStateSelector, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
(headerFilteringState)=>headerFilteringState?.enabled ?? false);
const $48c71b00043b47b4$var$gridHeaderFilteringEditFieldSelector = module.exports.gridHeaderFilteringEditFieldSelector = (0, $cgQ4y.createSelector)($48c71b00043b47b4$var$gridHeaderFilteringStateSelector, (headerFilteringState)=>headerFilteringState.editing);
const $48c71b00043b47b4$var$gridHeaderFilteringMenuSelector = module.exports.gridHeaderFilteringMenuSelector = (0, $cgQ4y.createSelector)($48c71b00043b47b4$var$gridHeaderFilteringStateSelector, (headerFilteringState)=>headerFilteringState.menuOpen);

});

parcelRegister("hMyIf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridColumnGroupsUnwrappedModelSelector = module.exports.gridColumnGroupsLookupSelector = module.exports.gridColumnGroupsHeaderStructureSelector = module.exports.gridColumnGroupsHeaderMaxDepthSelector = module.exports.gridColumnGroupingSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
/**
 * @category ColumnGrouping
 * @ignore - do not document.
 */ const $cf21d895912d975b$var$gridColumnGroupingSelector = module.exports.gridColumnGroupingSelector = (0, $cgQ4y.createRootSelector)((state)=>state.columnGrouping);
const $cf21d895912d975b$var$gridColumnGroupsUnwrappedModelSelector = module.exports.gridColumnGroupsUnwrappedModelSelector = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.unwrappedGroupingModel ?? {});
const $cf21d895912d975b$var$gridColumnGroupsLookupSelector = module.exports.gridColumnGroupsLookupSelector = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.lookup ?? {});
const $cf21d895912d975b$var$gridColumnGroupsHeaderStructureSelector = module.exports.gridColumnGroupsHeaderStructureSelector = (0, $cgQ4y.createSelectorMemoized)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.headerStructure ?? []);
const $cf21d895912d975b$var$gridColumnGroupsHeaderMaxDepthSelector = module.exports.gridColumnGroupsHeaderMaxDepthSelector = (0, $cgQ4y.createSelector)($cf21d895912d975b$var$gridColumnGroupingSelector, (columnGrouping)=>columnGrouping?.maxDepth ?? 0);

});



parcelRegister("er55f", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a82787d0b1c2b050$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPrivateApiContext = void 0;
module.exports.useGridPrivateApiContext = $a82787d0b1c2b050$var$useGridPrivateApiContext;

var $a82787d0b1c2b050$var$React = $a82787d0b1c2b050$require$_interopRequireWildcard((parcelRequire("acw62")));
const $a82787d0b1c2b050$var$GridPrivateApiContext = module.exports.GridPrivateApiContext = /*#__PURE__*/ $a82787d0b1c2b050$var$React.createContext(undefined);
function $a82787d0b1c2b050$var$useGridPrivateApiContext() {
    const privateApiRef = $a82787d0b1c2b050$var$React.useContext($a82787d0b1c2b050$var$GridPrivateApiContext);
    if (privateApiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return privateApiRef;
}

});

parcelRegister("dDKMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridOverlays = void 0;

var $5LeoO = parcelRequire("5LeoO");

var $13Ynj = parcelRequire("13Ynj");

var $eFlT8 = parcelRequire("eFlT8");

var $goCyd = parcelRequire("goCyd");

var $jy68d = parcelRequire("jy68d");

var $3ULRg = parcelRequire("3ULRg");
/**
 * Uses the grid state to determine which overlay to display.
 * Returns the active overlay type and the active loading overlay variant.
 */ const $9ee3358fa4255e5b$var$useGridOverlays = (apiRef, props)=>{
    const totalRowCount = (0, $5LeoO.useGridSelector)(apiRef, $eFlT8.gridRowCountSelector);
    const visibleRowCount = (0, $5LeoO.useGridSelector)(apiRef, $13Ynj.gridExpandedRowCountSelector);
    const pinnedRowsCount = (0, $5LeoO.useGridSelector)(apiRef, $goCyd.gridPinnedRowsCountSelector);
    const visibleColumns = (0, $5LeoO.useGridSelector)(apiRef, $jy68d.gridVisibleColumnDefinitionsSelector);
    const noRows = totalRowCount === 0 && pinnedRowsCount === 0;
    const loading = (0, $5LeoO.useGridSelector)(apiRef, $eFlT8.gridRowsLoadingSelector);
    const pivotActive = (0, $5LeoO.useGridSelector)(apiRef, $3ULRg.gridPivotActiveSelector);
    const showNoRowsOverlay = !loading && noRows;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    const showNoColumnsOverlay = !loading && visibleColumns.length === 0;
    const showEmptyPivotOverlay = showNoRowsOverlay && pivotActive;
    let overlayType = null;
    let loadingOverlayVariant = null;
    if (showNoRowsOverlay) overlayType = 'noRowsOverlay';
    if (showNoColumnsOverlay) overlayType = 'noColumnsOverlay';
    if (showEmptyPivotOverlay) overlayType = 'emptyPivotOverlay';
    if (showNoResultsOverlay) overlayType = 'noResultsOverlay';
    if (loading) {
        overlayType = 'loadingOverlay';
        loadingOverlayVariant = props.slotProps?.loadingOverlay?.[noRows ? 'noRowsVariant' : 'variant'] ?? (noRows ? 'skeleton' : 'linear-progress');
    }
    return {
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
};
module.exports.useGridOverlays = $9ee3358fa4255e5b$var$useGridOverlays;

});
parcelRegister("5LeoO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $431c82ec73ef367c$var$_exportNames = {
    useGridEvent: true,
    useGridEventPriority: true,
    unstable_resetCleanupTracking: true,
    useGridSelector: true
};
Object.defineProperty(module.exports, "unstable_resetCleanupTracking", {
    enumerable: true,
    get: function() {
        return $g8PwW.unstable_resetCleanupTracking;
    }
});
Object.defineProperty(module.exports, "useGridEvent", {
    enumerable: true,
    get: function() {
        return $g8PwW.useGridEvent;
    }
});
Object.defineProperty(module.exports, "useGridEventPriority", {
    enumerable: true,
    get: function() {
        return $g8PwW.useGridEventPriority;
    }
});
Object.defineProperty(module.exports, "useGridSelector", {
    enumerable: true,
    get: function() {
        return $5sOMZ.useGridSelector;
    }
});

var $fF5vr = parcelRequire("fF5vr");
Object.keys($fF5vr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fF5vr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fF5vr[key];
        }
    });
});

var $g8PwW = parcelRequire("g8PwW");

var $ivFej = parcelRequire("ivFej");
Object.keys($ivFej).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ivFej[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ivFej[key];
        }
    });
});

var $luu6e = parcelRequire("luu6e");
Object.keys($luu6e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $luu6e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $luu6e[key];
        }
    });
});

var $5sOMZ = parcelRequire("5sOMZ");

var $dRE9O = parcelRequire("dRE9O");
Object.keys($dRE9O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dRE9O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dRE9O[key];
        }
    });
});

var $bc8LN = parcelRequire("bc8LN");
Object.keys($bc8LN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bc8LN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bc8LN[key];
        }
    });
});

var $cZouL = parcelRequire("cZouL");
Object.keys($cZouL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cZouL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cZouL[key];
        }
    });
});

var $jukhl = parcelRequire("jukhl");
Object.keys($jukhl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($431c82ec73ef367c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jukhl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jukhl[key];
        }
    });
});

});
parcelRegister("fF5vr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7HpzD = parcelRequire("7HpzD");
Object.keys($7HpzD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7HpzD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7HpzD[key];
        }
    });
});

});
parcelRegister("7HpzD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $59b062f6b1a80246$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $59b062f6b1a80246$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRunOnce = void 0;

var $59b062f6b1a80246$var$React = $59b062f6b1a80246$require$_interopRequireWildcard((parcelRequire("acw62")));

var $59b062f6b1a80246$var$_useEnhancedEffect = $59b062f6b1a80246$require$_interopRequireDefault((parcelRequire("jdWO4")));
const $59b062f6b1a80246$var$noop = ()=>{};
/**
 * Runs an effect once, when `condition` is true.
 */ const $59b062f6b1a80246$var$useRunOnce = (condition, effect)=>{
    const didRun = $59b062f6b1a80246$var$React.useRef(false);
    (0, $59b062f6b1a80246$var$_useEnhancedEffect.default)(()=>{
        if (didRun.current || !condition) return $59b062f6b1a80246$var$noop;
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};
module.exports.useRunOnce = $59b062f6b1a80246$var$useRunOnce;

});


parcelRegister("ivFej", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d79b1aa4f5237e85$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d79b1aa4f5237e85$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridApiMethod = $d79b1aa4f5237e85$var$useGridApiMethod;

var $d79b1aa4f5237e85$var$React = $d79b1aa4f5237e85$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d79b1aa4f5237e85$var$_useEnhancedEffect = $d79b1aa4f5237e85$require$_interopRequireDefault((parcelRequire("jdWO4")));
function $d79b1aa4f5237e85$var$useGridApiMethod(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $d79b1aa4f5237e85$var$React.useRef(true);
    (0, $d79b1aa4f5237e85$var$_useEnhancedEffect.default)(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}

});

parcelRegister("luu6e", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fa53bf7350a63511$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridLogger = $fa53bf7350a63511$var$useGridLogger;

var $fa53bf7350a63511$var$React = $fa53bf7350a63511$require$_interopRequireWildcard((parcelRequire("acw62")));
function $fa53bf7350a63511$var$useGridLogger(privateApiRef, name) {
    const logger = $fa53bf7350a63511$var$React.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}

});

parcelRegister("dRE9O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridNativeEventListener = void 0;

var $luu6e = parcelRequire("luu6e");

var $g8PwW = parcelRequire("g8PwW");
const $a17f600338696a2d$var$useGridNativeEventListener = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useNativeEventListener');
    (0, $g8PwW.useGridEventPriority)(apiRef, 'rootMount', ()=>{
        const targetElement = ref();
        if (!targetElement || !eventName) return undefined;
        logger.debug(`Binding native ${eventName} event`);
        targetElement.addEventListener(eventName, handler, options);
        return ()=>{
            logger.debug(`Clearing native ${eventName} event`);
            targetElement.removeEventListener(eventName, handler, options);
        };
    });
};
module.exports.useGridNativeEventListener = $a17f600338696a2d$var$useGridNativeEventListener;

});

parcelRegister("bc8LN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fT7NQ = parcelRequire("fT7NQ");
Object.keys($fT7NQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fT7NQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fT7NQ[key];
        }
    });
});

});
parcelRegister("fT7NQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eq0r7 = parcelRequire("eq0r7");
Object.keys($eq0r7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eq0r7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eq0r7[key];
        }
    });
});

});
parcelRegister("eq0r7", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a7f3d508cdc25770$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFirstRender = $a7f3d508cdc25770$var$useFirstRender;

var $a7f3d508cdc25770$var$React = $a7f3d508cdc25770$require$_interopRequireWildcard((parcelRequire("acw62")));
function $a7f3d508cdc25770$var$useFirstRender(callback) {
    const isFirstRender = $a7f3d508cdc25770$var$React.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
}

});



parcelRegister("cZouL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $974e2ec20df6d801$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useOnMount", {
    enumerable: true,
    get: function() {
        return $974e2ec20df6d801$var$_useOnMount.default;
    }
});

var $974e2ec20df6d801$var$_useOnMount = $974e2ec20df6d801$require$_interopRequireDefault((parcelRequire("fGtMU")));

});

parcelRegister("jukhl", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e3008c977e3d8041$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRunOncePerLoop = $e3008c977e3d8041$var$useRunOncePerLoop;

var $e3008c977e3d8041$var$React = $e3008c977e3d8041$require$_interopRequireWildcard((parcelRequire("acw62")));
function $e3008c977e3d8041$var$useRunOncePerLoop(callback) {
    const scheduledCallbackRef = $e3008c977e3d8041$var$React.useRef(null);
    const schedule = $e3008c977e3d8041$var$React.useCallback((...args)=>{
        // for robustness, a fallback in case we don't react to state updates and layoutEffect is not run
        // if we react to state updates, layoutEffect will run before microtasks
        if (!scheduledCallbackRef.current) queueMicrotask(()=>{
            if (scheduledCallbackRef.current) scheduledCallbackRef.current();
        });
        scheduledCallbackRef.current = ()=>{
            scheduledCallbackRef.current = null;
            callback(...args);
        };
    }, [
        callback
    ]);
    $e3008c977e3d8041$var$React.useLayoutEffect(()=>{
        if (scheduledCallbackRef.current) scheduledCallbackRef.current();
    });
    return {
        schedule: schedule,
        cancel: ()=>{
            if (scheduledCallbackRef.current) {
                scheduledCallbackRef.current = null;
                return true;
            }
            return false;
        }
    };
}

});


parcelRegister("13Ynj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "getDefaultGridFilterModel", {
    enumerable: true,
    get: function() {
        return $l4QMb.getDefaultGridFilterModel;
    }
});
Object.defineProperty(module.exports, "gridExpandedRowCountSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridExpandedRowCountSelector;
    }
});
Object.defineProperty(module.exports, "gridExpandedSortedRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridExpandedSortedRowEntriesSelector;
    }
});
Object.defineProperty(module.exports, "gridExpandedSortedRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridExpandedSortedRowIdsSelector;
    }
});
Object.defineProperty(module.exports, "gridExpandedSortedRowIndexLookupSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridExpandedSortedRowIndexLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridFilterActiveItemsLookupSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilterActiveItemsLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridFilterActiveItemsSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilterActiveItemsSelector;
    }
});
Object.defineProperty(module.exports, "gridFilterModelSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilterModelSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredDescendantCountLookupSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredDescendantCountLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredDescendantRowCountSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredDescendantRowCountSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredRowCountSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredRowCountSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredRowsLookupSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredRowsLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredSortedRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredSortedRowEntriesSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredSortedRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredSortedRowIdsSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredSortedTopLevelRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredSortedTopLevelRowEntriesSelector;
    }
});
Object.defineProperty(module.exports, "gridFilteredTopLevelRowCountSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridFilteredTopLevelRowCountSelector;
    }
});
Object.defineProperty(module.exports, "gridQuickFilterValuesSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridQuickFilterValuesSelector;
    }
});
Object.defineProperty(module.exports, "gridVisibleRowsLookupSelector", {
    enumerable: true,
    get: function() {
        return $k278Q.gridVisibleRowsLookupSelector;
    }
});

var $l4QMb = parcelRequire("l4QMb");

var $k278Q = parcelRequire("k278Q");

});

parcelRegister("3ULRg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ll2EI = parcelRequire("ll2EI");
Object.keys($ll2EI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ll2EI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ll2EI[key];
        }
    });
});

var $3h197 = parcelRequire("3h197");
Object.keys($3h197).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3h197[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3h197[key];
        }
    });
});

});
parcelRegister("ll2EI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3h197", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridPivotInitialColumnsSelector = module.exports.gridPivotActiveSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $2623d93ce2942d3c$var$gridPivotingStateSelector = (0, $cgQ4y.createRootSelector)(// @ts-ignore
(state)=>state.pivoting);
const $2623d93ce2942d3c$var$gridPivotActiveSelector = module.exports.gridPivotActiveSelector = (0, $cgQ4y.createSelector)($2623d93ce2942d3c$var$gridPivotingStateSelector, (pivoting)=>pivoting?.active);
const $2623d93ce2942d3c$var$emptyColumns = new Map();
const $2623d93ce2942d3c$var$gridPivotInitialColumnsSelector = module.exports.gridPivotInitialColumnsSelector = (0, $cgQ4y.createSelector)($2623d93ce2942d3c$var$gridPivotingStateSelector, (pivoting)=>pivoting?.initialColumns || $2623d93ce2942d3c$var$emptyColumns);

});



parcelRegister("dS4gY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a193a1fff9f5c318$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridHeaders = void 0;

var $a193a1fff9f5c318$var$_extends2 = $a193a1fff9f5c318$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2nKmT = parcelRequire("2nKmT");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $iU3u2 = parcelRequire("iU3u2");

var $drCmI = parcelRequire("drCmI");

var $hMyIf = parcelRequire("hMyIf");

var $eOaSX = parcelRequire("eOaSX");

var $ayMG0 = parcelRequire("ayMG0");
function $a193a1fff9f5c318$var$GridHeaders() {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridVisibleColumnDefinitionsSelector);
    const filterColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridFilterActiveItemsLookupSelector);
    const sortColumnLookup = (0, $5sOMZ.useGridSelector)(apiRef, $iU3u2.gridSortColumnLookupSelector);
    const columnHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, $drCmI.gridTabIndexColumnHeaderSelector);
    const hasNoCellTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $drCmI.gridTabIndexCellSelector)(apiRef) === null);
    const columnGroupHeaderTabIndexState = (0, $5sOMZ.useGridSelector)(apiRef, $drCmI.gridTabIndexColumnGroupHeaderSelector);
    const columnHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, $drCmI.gridFocusColumnHeaderSelector);
    const columnGroupHeaderFocus = (0, $5sOMZ.useGridSelector)(apiRef, $drCmI.gridFocusColumnGroupHeaderSelector);
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector);
    const columnMenuState = (0, $5sOMZ.useGridSelector)(apiRef, $eOaSX.gridColumnMenuSelector);
    const columnVisibility = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnVisibilityModelSelector);
    const columnGroupsHeaderStructure = (0, $5sOMZ.useGridSelector)(apiRef, $hMyIf.gridColumnGroupsHeaderStructureSelector);
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && hasNoCellTabIndexState);
    const columnsContainerRef = apiRef.current.columnHeadersContainerRef;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaders, (0, $a193a1fff9f5c318$var$_extends2.default)({
        ref: columnsContainerRef,
        visibleColumns: visibleColumns,
        filterColumnLookup: filterColumnLookup,
        sortColumnLookup: sortColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, rootProps.slotProps?.columnHeaders));
}
const $a193a1fff9f5c318$var$MemoizedGridHeaders = module.exports.GridHeaders = (0, $2nKmT.fastMemo)($a193a1fff9f5c318$var$GridHeaders);

});
parcelRegister("eOaSX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridColumnMenuSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $ac7e2dd161e207a6$var$gridColumnMenuSelector = module.exports.gridColumnMenuSelector = (0, $cgQ4y.createRootSelector)((state)=>state.columnMenu);

});


parcelRegister("kcb79", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eb3d8cbc702f4647$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eb3d8cbc702f4647$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridMainContainer = void 0;

var $eb3d8cbc702f4647$var$_extends2 = $eb3d8cbc702f4647$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $eb3d8cbc702f4647$var$React = $eb3d8cbc702f4647$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $3J8MS = parcelRequire("3J8MS");

var $ayMG0 = parcelRequire("ayMG0");
const $eb3d8cbc702f4647$var$GridPanelAnchor = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    position: 'absolute',
    top: `var(--DataGrid-headersTotalHeight)`,
    left: 0,
    width: 'calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))'
});
const $eb3d8cbc702f4647$var$Element = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState, loadingOverlayVariant: loadingOverlayVariant, overlayType: overlayType } = props;
        const hideContent = loadingOverlayVariant === 'skeleton' || overlayType === 'noColumnsOverlay';
        return [
            styles.main,
            ownerState.hasPinnedRight && styles['main--hasPinnedRight'],
            hideContent && styles['main--hiddenContent']
        ];
    }
})({
    flexGrow: 1,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
});
const $eb3d8cbc702f4647$var$GridMainContainer = module.exports.GridMainContainer = (0, $fYxgT.forwardRef)((props, ref)=>{
    const { ownerState: ownerState } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const configuration = (0, $3J8MS.useGridConfiguration)();
    const ariaAttributes = configuration.hooks.useGridAriaAttributes();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($eb3d8cbc702f4647$var$Element, (0, $eb3d8cbc702f4647$var$_extends2.default)({
        ownerState: ownerState,
        className: props.className,
        tabIndex: -1
    }, ariaAttributes, rootProps.slotProps?.main, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($eb3d8cbc702f4647$var$GridPanelAnchor, {
                role: "presentation",
                "data-id": "gridPanelAnchor"
            }),
            props.children
        ]
    }));
});

});

parcelRegister("8yMKs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $63b75016458d5774$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $63b75016458d5774$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridTopContainer = $63b75016458d5774$var$GridTopContainer;

var $63b75016458d5774$var$_extends2 = $63b75016458d5774$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $63b75016458d5774$var$React = $63b75016458d5774$require$_interopRequireWildcard((parcelRequire("acw62")));

var $63b75016458d5774$var$_clsx = $63b75016458d5774$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $63b75016458d5774$var$_composeClasses = $63b75016458d5774$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $63b75016458d5774$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'topContainer'
        ]
    };
    return (0, $63b75016458d5774$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, {});
};
const $63b75016458d5774$var$Element = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    position: 'sticky',
    zIndex: 40,
    top: 0
});
function $63b75016458d5774$var$GridTopContainer(props) {
    const classes = $63b75016458d5774$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($63b75016458d5774$var$Element, (0, $63b75016458d5774$var$_extends2.default)({}, props, {
        className: (0, $63b75016458d5774$var$_clsx.default)(classes.root, $5H1vo.gridClasses['container--top']),
        role: "presentation"
    }));
}

});

parcelRegister("lLmsJ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fd7f69586e4a3224$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fd7f69586e4a3224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridVirtualScrollerContent = void 0;

var $fd7f69586e4a3224$var$_extends2 = $fd7f69586e4a3224$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fd7f69586e4a3224$var$React = $fd7f69586e4a3224$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fd7f69586e4a3224$var$_clsx = $fd7f69586e4a3224$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $fd7f69586e4a3224$var$_composeClasses = $fd7f69586e4a3224$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $fd7f69586e4a3224$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $fd7f69586e4a3224$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $fd7f69586e4a3224$var$VirtualScrollerContentRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScrollerContent,
            ownerState.overflowedContent && styles['virtualScrollerContent--overflowed']
        ];
    }
})({});
const $fd7f69586e4a3224$var$GridVirtualScrollerContent = module.exports.GridVirtualScrollerContent = (0, $fYxgT.forwardRef)(function GridVirtualScrollerContent(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const overflowedContent = !rootProps.autoHeight && props.style?.minHeight === 'auto';
    const classes = $fd7f69586e4a3224$var$useUtilityClasses(rootProps, overflowedContent);
    const ownerState = {
        classes: rootProps.classes,
        overflowedContent: overflowedContent
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fd7f69586e4a3224$var$VirtualScrollerContentRoot, (0, $fd7f69586e4a3224$var$_extends2.default)({}, props, {
        ownerState: ownerState,
        className: (0, $fd7f69586e4a3224$var$_clsx.default)(classes.root, props.className),
        ref: ref
    }));
});

});

parcelRegister("a8jkJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7609a5f754a72e14$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridVirtualScrollerFiller = void 0;

var $7609a5f754a72e14$var$React = $7609a5f754a72e14$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $2nKmT = parcelRequire("2nKmT");

var $hbuUJ = parcelRequire("hbuUJ");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $iGtHu = parcelRequire("iGtHu");

var $7jHEF = parcelRequire("7jHEF");

var $ayMG0 = parcelRequire("ayMG0");
const $7609a5f754a72e14$var$Filler = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    display: 'flex',
    flexDirection: 'row',
    width: 'var(--DataGrid-rowWidth)',
    boxSizing: 'border-box'
});
const $7609a5f754a72e14$var$Pinned = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    position: 'sticky',
    height: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid var(--rowBorderColor)',
    backgroundColor: $hbuUJ.vars.cell.background.pinned
});
const $7609a5f754a72e14$var$PinnedLeft = (0, $8xDHs.styled)($7609a5f754a72e14$var$Pinned, {
    slot: 'internal'
})({
    left: 0
});
const $7609a5f754a72e14$var$PinnedRight = (0, $8xDHs.styled)($7609a5f754a72e14$var$Pinned, {
    slot: 'internal'
})({
    right: 0
});
const $7609a5f754a72e14$var$Main = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    flexGrow: 1,
    borderTop: '1px solid var(--rowBorderColor)'
});
function $7609a5f754a72e14$var$GridVirtualScrollerFiller({ rowsLength: rowsLength }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const { viewportOuterSize: viewportOuterSize, minimumSize: minimumSize, hasScrollX: hasScrollX, hasScrollY: hasScrollY, scrollbarSize: scrollbarSize, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = (0, $5sOMZ.useGridSelector)(apiRef, $iGtHu.gridDimensionsSelector);
    const height = hasScrollX ? scrollbarSize : 0;
    const needsLastRowBorder = viewportOuterSize.height - minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7609a5f754a72e14$var$Filler, {
        className: $7jHEF.gridClasses.filler,
        role: "presentation",
        style: {
            height: height,
            '--rowBorderColor': rowsLength === 0 ? 'transparent' : 'var(--DataGrid-rowBorderColor)'
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$PinnedLeft, {
                className: $7jHEF.gridClasses['filler--pinnedLeft'],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($7609a5f754a72e14$var$PinnedRight, {
                className: $7jHEF.gridClasses['filler--pinnedRight'],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
const $7609a5f754a72e14$var$Memoized = module.exports.GridVirtualScrollerFiller = (0, $2nKmT.fastMemo)($7609a5f754a72e14$var$GridVirtualScrollerFiller);

});
parcelRegister("iGtHu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "gridColumnsTotalWidthSelector", {
    enumerable: true,
    get: function() {
        return $61HyH.gridColumnsTotalWidthSelector;
    }
});
Object.defineProperty(module.exports, "gridDimensionsSelector", {
    enumerable: true,
    get: function() {
        return $61HyH.gridDimensionsSelector;
    }
});

var $61HyH = parcelRequire("61HyH");

});


parcelRegister("5v0S6", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $401086177e70acda$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $401086177e70acda$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridVirtualScrollerRenderZone = void 0;

var $401086177e70acda$var$_extends2 = $401086177e70acda$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $401086177e70acda$var$React = $401086177e70acda$require$_interopRequireWildcard((parcelRequire("acw62")));

var $401086177e70acda$var$_clsx = $401086177e70acda$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $401086177e70acda$var$_composeClasses = $401086177e70acda$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $401086177e70acda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $401086177e70acda$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $401086177e70acda$var$VirtualScrollerRenderZoneRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone'
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $401086177e70acda$var$GridVirtualScrollerRenderZone = module.exports.GridVirtualScrollerRenderZone = (0, $fYxgT.forwardRef)(function GridVirtualScrollerRenderZone(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $401086177e70acda$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($401086177e70acda$var$VirtualScrollerRenderZoneRoot, (0, $401086177e70acda$var$_extends2.default)({
        ownerState: rootProps
    }, props, {
        className: (0, $401086177e70acda$var$_clsx.default)(classes.root, props.className),
        ref: ref
    }));
});

});

parcelRegister("cv3bf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $919ad8d5ff9ebb8c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $919ad8d5ff9ebb8c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scrollbarSizeCssExpression = module.exports.ScrollbarCorner = module.exports.GridVirtualScrollbar = void 0;

var $919ad8d5ff9ebb8c$var$React = $919ad8d5ff9ebb8c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $919ad8d5ff9ebb8c$var$_useEventCallback = $919ad8d5ff9ebb8c$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $919ad8d5ff9ebb8c$var$_useForkRef = $919ad8d5ff9ebb8c$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $919ad8d5ff9ebb8c$var$_composeClasses = $919ad8d5ff9ebb8c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $cZouL = parcelRequire("cZouL");

var $er55f = parcelRequire("er55f");

var $iAdzh = parcelRequire("iAdzh");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $919ad8d5ff9ebb8c$var$useUtilityClasses = (ownerState, position)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollbar',
            `scrollbar--${position}`
        ],
        content: [
            'scrollbarContent'
        ]
    };
    return (0, $919ad8d5ff9ebb8c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
// In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
// their size to be 0px throughout all the calculations, but the floating scrollbar container does need
// to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
// don't have a method to find the required size for scrollbars on those platforms.
const $919ad8d5ff9ebb8c$var$scrollbarSizeCssExpression = module.exports.scrollbarSizeCssExpression = 'calc(max(var(--DataGrid-scrollbarSize), 14px))';
const $919ad8d5ff9ebb8c$var$Scrollbar = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    position: 'absolute',
    display: 'inline-block',
    zIndex: 60,
    '&:hover': {
        zIndex: 70
    },
    '--size': $919ad8d5ff9ebb8c$var$scrollbarSizeCssExpression
});
const $919ad8d5ff9ebb8c$var$ScrollbarVertical = (0, $8xDHs.styled)($919ad8d5ff9ebb8c$var$Scrollbar, {
    slot: 'internal'
})({
    width: 'var(--size)',
    height: 'calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-headersTotalHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))',
    overflowY: 'auto',
    overflowX: 'hidden',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        width: 'var(--size)'
    },
    top: 'var(--DataGrid-headersTotalHeight)',
    right: 0
});
const $919ad8d5ff9ebb8c$var$ScrollbarHorizontal = (0, $8xDHs.styled)($919ad8d5ff9ebb8c$var$Scrollbar, {
    slot: 'internal'
})({
    width: 'calc(var(--DataGrid-hasScrollX) * (100% - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))',
    height: 'var(--size)',
    overflowY: 'hidden',
    overflowX: 'auto',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        height: 'var(--size)'
    },
    bottom: 0
});
const $919ad8d5ff9ebb8c$var$ScrollbarCorner = module.exports.ScrollbarCorner = (0, $8xDHs.styled)($919ad8d5ff9ebb8c$var$Scrollbar, {
    slot: 'internal'
})({
    width: 'var(--size)',
    height: 'var(--size)',
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    '@media print': {
        display: 'none'
    }
});
const $919ad8d5ff9ebb8c$var$GridVirtualScrollbar = module.exports.GridVirtualScrollbar = (0, $fYxgT.forwardRef)(function GridVirtualScrollbar(props, ref) {
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isLocked = $919ad8d5ff9ebb8c$var$React.useRef(false);
    const lastPosition = $919ad8d5ff9ebb8c$var$React.useRef(0);
    const scrollbarRef = $919ad8d5ff9ebb8c$var$React.useRef(null);
    const classes = $919ad8d5ff9ebb8c$var$useUtilityClasses(rootProps, props.position);
    const dimensions = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridDimensionsSelector);
    const propertyDimension = props.position === 'vertical' ? 'height' : 'width';
    const propertyScroll = props.position === 'vertical' ? 'scrollTop' : 'scrollLeft';
    const propertyScrollPosition = props.position === 'vertical' ? 'top' : 'left';
    const scrollbarInnerSize = props.position === 'horizontal' ? dimensions.minimumSize.width : dimensions.minimumSize.height - dimensions.headersTotalHeight;
    const onScrollerScroll = (0, $919ad8d5ff9ebb8c$var$_useEventCallback.default)(()=>{
        const scrollbar = scrollbarRef.current;
        const scrollPosition = props.scrollPosition.current;
        if (!scrollbar) return;
        if (scrollPosition[propertyScrollPosition] === lastPosition.current) return;
        lastPosition.current = scrollPosition[propertyScrollPosition];
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        scrollbar[propertyScroll] = props.scrollPosition.current[propertyScrollPosition];
    });
    const onScrollbarScroll = (0, $919ad8d5ff9ebb8c$var$_useEventCallback.default)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (!scrollbar) return;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        scroller[propertyScroll] = scrollbar[propertyScroll];
    });
    (0, $cZouL.useOnMount)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        const options = {
            passive: true
        };
        scroller.addEventListener('scroll', onScrollerScroll, options);
        scrollbar.addEventListener('scroll', onScrollbarScroll, options);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollerScroll, options);
            scrollbar.removeEventListener('scroll', onScrollbarScroll, options);
        };
    });
    const Container = props.position === 'vertical' ? $919ad8d5ff9ebb8c$var$ScrollbarVertical : $919ad8d5ff9ebb8c$var$ScrollbarHorizontal;
    const scrollbarInnerStyle = $919ad8d5ff9ebb8c$var$React.useMemo(()=>({
            [propertyDimension]: `${scrollbarInnerSize}px`
        }), [
        propertyDimension,
        scrollbarInnerSize
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Container, {
        ref: (0, $919ad8d5ff9ebb8c$var$_useForkRef.default)(ref, scrollbarRef),
        className: classes.root,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: (event)=>{
            event.target.blur();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: classes.content,
            style: scrollbarInnerStyle
        })
    });
});

});
parcelRegister("iAdzh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hM6eU = parcelRequire("hM6eU");
Object.keys($hM6eU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hM6eU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hM6eU[key];
        }
    });
});

var $5LeoO = parcelRequire("5LeoO");
Object.keys($5LeoO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5LeoO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5LeoO[key];
        }
    });
});

var $9FCuu = parcelRequire("9FCuu");
Object.keys($9FCuu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9FCuu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9FCuu[key];
        }
    });
});

});
parcelRegister("hM6eU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9nGCh = parcelRequire("9nGCh");
Object.keys($9nGCh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9nGCh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9nGCh[key];
        }
    });
});

var $jy68d = parcelRequire("jy68d");
Object.keys($jy68d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jy68d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jy68d[key];
        }
    });
});

var $krj7i = parcelRequire("krj7i");
Object.keys($krj7i).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $krj7i[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $krj7i[key];
        }
    });
});

var $ceg7e = parcelRequire("ceg7e");
Object.keys($ceg7e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ceg7e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ceg7e[key];
        }
    });
});

var $h181e = parcelRequire("h181e");
Object.keys($h181e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h181e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h181e[key];
        }
    });
});

var $4RMdJ = parcelRequire("4RMdJ");
Object.keys($4RMdJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4RMdJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4RMdJ[key];
        }
    });
});

var $13Ynj = parcelRequire("13Ynj");
Object.keys($13Ynj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $13Ynj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $13Ynj[key];
        }
    });
});

var $fI50C = parcelRequire("fI50C");
Object.keys($fI50C).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fI50C[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fI50C[key];
        }
    });
});

var $RWGMa = parcelRequire("RWGMa");
Object.keys($RWGMa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $RWGMa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $RWGMa[key];
        }
    });
});

var $b2EyI = parcelRequire("b2EyI");
Object.keys($b2EyI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b2EyI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b2EyI[key];
        }
    });
});

var $8R7gU = parcelRequire("8R7gU");
Object.keys($8R7gU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8R7gU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8R7gU[key];
        }
    });
});

var $eFlT8 = parcelRequire("eFlT8");
Object.keys($eFlT8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eFlT8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eFlT8[key];
        }
    });
});

var $4XcWL = parcelRequire("4XcWL");
Object.keys($4XcWL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4XcWL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4XcWL[key];
        }
    });
});

var $2ywsT = parcelRequire("2ywsT");
Object.keys($2ywsT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2ywsT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ywsT[key];
        }
    });
});

var $iGtHu = parcelRequire("iGtHu");
Object.keys($iGtHu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iGtHu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iGtHu[key];
        }
    });
});

var $jvemY = parcelRequire("jvemY");
Object.keys($jvemY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jvemY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jvemY[key];
        }
    });
});

var $40Iyj = parcelRequire("40Iyj");
Object.keys($40Iyj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $40Iyj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $40Iyj[key];
        }
    });
});

var $cMkcn = parcelRequire("cMkcn");
Object.keys($cMkcn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cMkcn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cMkcn[key];
        }
    });
});

var $aqJRW = parcelRequire("aqJRW");
Object.keys($aqJRW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aqJRW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aqJRW[key];
        }
    });
});

var $d2Z0A = parcelRequire("d2Z0A");
Object.keys($d2Z0A).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d2Z0A[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d2Z0A[key];
        }
    });
});

});
parcelRegister("9nGCh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5jAso = parcelRequire("5jAso");
Object.keys($5jAso).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5jAso[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5jAso[key];
        }
    });
});

var $eOaSX = parcelRequire("eOaSX");
Object.keys($eOaSX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eOaSX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eOaSX[key];
        }
    });
});

});
parcelRegister("5jAso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("krj7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hMyIf = parcelRequire("hMyIf");
Object.keys($hMyIf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hMyIf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hMyIf[key];
        }
    });
});

});

parcelRegister("ceg7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fh3fi = parcelRequire("fh3fi");
Object.keys($fh3fi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fh3fi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fh3fi[key];
        }
    });
});

var $ccBKB = parcelRequire("ccBKB");
Object.keys($ccBKB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ccBKB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ccBKB[key];
        }
    });
});

var $6lOsW = parcelRequire("6lOsW");
Object.keys($6lOsW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6lOsW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6lOsW[key];
        }
    });
});

});
parcelRegister("fh3fi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridResizingColumnFieldSelector = module.exports.gridColumnResizeSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $02dea0df2ecb5d58$var$gridColumnResizeSelector = module.exports.gridColumnResizeSelector = (0, $cgQ4y.createRootSelector)((state)=>state.columnResize);
const $02dea0df2ecb5d58$var$gridResizingColumnFieldSelector = module.exports.gridResizingColumnFieldSelector = (0, $cgQ4y.createSelector)($02dea0df2ecb5d58$var$gridColumnResizeSelector, (columnResize)=>columnResize.resizingColumnField);

});

parcelRegister("ccBKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6lOsW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_GRID_AUTOSIZE_OPTIONS = void 0;
const $49fbd9b1282fca98$var$DEFAULT_GRID_AUTOSIZE_OPTIONS = module.exports.DEFAULT_GRID_AUTOSIZE_OPTIONS = {
    includeHeaders: true,
    includeHeaderFilters: false,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false,
    disableColumnVirtualization: true
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 

});


parcelRegister("h181e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aIkqp = parcelRequire("aIkqp");
Object.keys($aIkqp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aIkqp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aIkqp[key];
        }
    });
});

var $fD9f4 = parcelRequire("fD9f4");
Object.keys($fD9f4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fD9f4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fD9f4[key];
        }
    });
});

});
parcelRegister("aIkqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("4RMdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5Rfo7 = parcelRequire("5Rfo7");
Object.keys($5Rfo7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $5Rfo7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5Rfo7[key];
        }
    });
});

});
parcelRegister("5Rfo7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridRowIsEditingSelector = module.exports.gridEditRowsStateSelector = module.exports.gridEditCellStateSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");

var $jkRzp = parcelRequire("jkRzp");
/**
 * Select the row editing state.
 */ const $443dd6b911893b50$var$gridEditRowsStateSelector = module.exports.gridEditRowsStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.editRows);
const $443dd6b911893b50$var$gridRowIsEditingSelector = module.exports.gridRowIsEditingSelector = (0, $cgQ4y.createSelector)($443dd6b911893b50$var$gridEditRowsStateSelector, (editRows, { rowId: rowId, editMode: editMode })=>editMode === $jkRzp.GridEditModes.Row && Boolean(editRows[rowId]));
const $443dd6b911893b50$var$gridEditCellStateSelector = module.exports.gridEditCellStateSelector = (0, $cgQ4y.createSelector)($443dd6b911893b50$var$gridEditRowsStateSelector, (editRows, { rowId: rowId, field: field })=>editRows[rowId]?.[field] ?? null);

});


parcelRegister("fI50C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $drCmI = parcelRequire("drCmI");
Object.keys($drCmI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $drCmI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $drCmI[key];
        }
    });
});

var $nDBmJ = parcelRequire("nDBmJ");
Object.keys($nDBmJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $nDBmJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $nDBmJ[key];
        }
    });
});

});
parcelRegister("nDBmJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("b2EyI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gPWuj = parcelRequire("gPWuj");
Object.keys($gPWuj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gPWuj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gPWuj[key];
        }
    });
});

});

parcelRegister("8R7gU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6728e9ffb7926382$var$_exportNames = {
    gridPreferencePanelStateSelector: true
};
Object.defineProperty(module.exports, "gridPreferencePanelStateSelector", {
    enumerable: true,
    get: function() {
        return $6X2Yd.gridPreferencePanelStateSelector;
    }
});

var $6X2Yd = parcelRequire("6X2Yd");

var $lJTzA = parcelRequire("lJTzA");
Object.keys($lJTzA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6728e9ffb7926382$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lJTzA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lJTzA[key];
        }
    });
});

var $3PCYS = parcelRequire("3PCYS");
Object.keys($3PCYS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6728e9ffb7926382$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3PCYS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3PCYS[key];
        }
    });
});

});
parcelRegister("6X2Yd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridPreferencePanelStateSelector = module.exports.gridPreferencePanelSelectorWithLabel = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $50fa8e974bf84473$var$gridPreferencePanelStateSelector = module.exports.gridPreferencePanelStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.preferencePanel);
const $50fa8e974bf84473$var$gridPreferencePanelSelectorWithLabel = module.exports.gridPreferencePanelSelectorWithLabel = (0, $cgQ4y.createSelector)($50fa8e974bf84473$var$gridPreferencePanelStateSelector, (panel, labelId)=>{
    if (panel.open && panel.labelId === labelId) return true;
    return false;
});

});

parcelRegister("lJTzA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3PCYS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPreferencePanelsValue = void 0;
var $2ca45f4bbfed6878$var$GridPreferencePanelsValue = module.exports.GridPreferencePanelsValue = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    GridPreferencePanelsValue["aiAssistant"] = "aiAssistant";
    return GridPreferencePanelsValue;
}($2ca45f4bbfed6878$var$GridPreferencePanelsValue || {});

});


parcelRegister("4XcWL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $av74L = parcelRequire("av74L");
Object.keys($av74L).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $av74L[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $av74L[key];
        }
    });
});

});

parcelRegister("2ywsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "gridDateComparator", {
    enumerable: true,
    get: function() {
        return $h8fXG.gridDateComparator;
    }
});
Object.defineProperty(module.exports, "gridNumberComparator", {
    enumerable: true,
    get: function() {
        return $h8fXG.gridNumberComparator;
    }
});
Object.defineProperty(module.exports, "gridSortColumnLookupSelector", {
    enumerable: true,
    get: function() {
        return $iU3u2.gridSortColumnLookupSelector;
    }
});
Object.defineProperty(module.exports, "gridSortModelSelector", {
    enumerable: true,
    get: function() {
        return $iU3u2.gridSortModelSelector;
    }
});
Object.defineProperty(module.exports, "gridSortedRowEntriesSelector", {
    enumerable: true,
    get: function() {
        return $iU3u2.gridSortedRowEntriesSelector;
    }
});
Object.defineProperty(module.exports, "gridSortedRowIdsSelector", {
    enumerable: true,
    get: function() {
        return $iU3u2.gridSortedRowIdsSelector;
    }
});
Object.defineProperty(module.exports, "gridStringOrNumberComparator", {
    enumerable: true,
    get: function() {
        return $h8fXG.gridStringOrNumberComparator;
    }
});

var $iU3u2 = parcelRequire("iU3u2");

var $h8fXG = parcelRequire("h8fXG");

});

parcelRegister("jvemY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("40Iyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6forD = parcelRequire("6forD");
Object.keys($6forD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6forD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6forD[key];
        }
    });
});

});

parcelRegister("cMkcn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94d9a2be66e71282$var$_exportNames = {
    EMPTY_RENDER_CONTEXT: true
};
Object.defineProperty(module.exports, "EMPTY_RENDER_CONTEXT", {
    enumerable: true,
    get: function() {
        return $l8hgY.EMPTY_RENDER_CONTEXT;
    }
});

var $l8hgY = parcelRequire("l8hgY");

var $dfzFI = parcelRequire("dfzFI");
Object.keys($dfzFI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($94d9a2be66e71282$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dfzFI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dfzFI[key];
        }
    });
});

var $9upDV = parcelRequire("9upDV");
Object.keys($9upDV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($94d9a2be66e71282$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9upDV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9upDV[key];
        }
    });
});

});
parcelRegister("l8hgY", function(module, exports) {
/**
 * @mui/x-virtualizer v0.3.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iBaWd = parcelRequire("iBaWd");
Object.keys($iBaWd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iBaWd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iBaWd[key];
        }
    });
});

var $br5oA = parcelRequire("br5oA");
Object.keys($br5oA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $br5oA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $br5oA[key];
        }
    });
});

var $4k7kH = parcelRequire("4k7kH");
Object.keys($4k7kH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4k7kH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4k7kH[key];
        }
    });
});

});
parcelRegister("iBaWd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d8a42ab8ec8ec106$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useVirtualizer = void 0;

var $d8a42ab8ec8ec106$var$_extends2 = $d8a42ab8ec8ec106$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d8a42ab8ec8ec106$var$_useLazyRef = $d8a42ab8ec8ec106$require$_interopRequireDefault((parcelRequire("doV3C")));

var $8P0MD = parcelRequire("8P0MD");

var $7NmXL = parcelRequire("7NmXL");

var $h8348 = parcelRequire("h8348");

var $hgVKp = parcelRequire("hgVKp");

var $2YrdJ = parcelRequire("2YrdJ");

var $EPOBk = parcelRequire("EPOBk");

var $4k7kH = parcelRequire("4k7kH");
/* eslint-disable jsdoc/require-param-type */ /* eslint-disable jsdoc/require-param-description */ /* eslint-disable jsdoc/require-returns-type */ const $d8a42ab8ec8ec106$var$FEATURES = [
    $h8348.Dimensions,
    $EPOBk.Virtualization,
    $7NmXL.Colspan,
    $2YrdJ.Rowspan,
    $hgVKp.Keyboard
];
const $d8a42ab8ec8ec106$var$useVirtualizer = (params)=>{
    const paramsWithDefault = $d8a42ab8ec8ec106$var$mergeDefaults(params, $4k7kH.DEFAULT_PARAMS);
    const store = (0, $d8a42ab8ec8ec106$var$_useLazyRef.default)(()=>{
        return new $8P0MD.Store($d8a42ab8ec8ec106$var$FEATURES.map((f)=>f.initialize(paramsWithDefault)).reduce((state, partial)=>Object.assign(state, partial), {}));
    }).current;
    const api = {};
    for (const feature of $d8a42ab8ec8ec106$var$FEATURES)Object.assign(api, feature.use(store, paramsWithDefault, api));
    return {
        store: store,
        api: api
    };
};
module.exports.useVirtualizer = $d8a42ab8ec8ec106$var$useVirtualizer;
function $d8a42ab8ec8ec106$var$mergeDefaults(params, defaults) {
    const result = (0, $d8a42ab8ec8ec106$var$_extends2.default)({}, params);
    for(const key in defaults)if (Object.hasOwn(defaults, key)) {
        const value = defaults[key];
        if (value !== null && typeof value === 'object' && !Array.isArray(value)) result[key] = $d8a42ab8ec8ec106$var$mergeDefaults(params[key] ?? {}, value);
        else result[key] = params[key] ?? value;
    }
    return result;
}

});
parcelRegister("7NmXL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5aceebfd588d01cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Colspan = void 0;

var $5aceebfd588d01cb$var$_useEventCallback = $5aceebfd588d01cb$require$_interopRequireDefault((parcelRequire("6Lbjo")));
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $5aceebfd588d01cb$var$selectors = {};
const $5aceebfd588d01cb$var$Colspan = module.exports.Colspan = {
    initialize: $5aceebfd588d01cb$var$initializeState,
    use: $5aceebfd588d01cb$var$useColspan,
    selectors: $5aceebfd588d01cb$var$selectors
};
function $5aceebfd588d01cb$var$initializeState(_params) {
    return {
        colspanMap: new Map()
    };
}
function $5aceebfd588d01cb$var$useColspan(store, params, api) {
    const getColspan = params.colspan?.getColspan;
    const resetColSpan = ()=>{
        store.state.colspanMap = new Map();
    };
    const getCellColSpanInfo = (rowId, columnIndex)=>{
        return store.state.colspanMap.get(rowId)?.[columnIndex];
    };
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = (0, $5aceebfd588d01cb$var$_useEventCallback.default)(getColspan ? (rowId, minFirstColumn, maxLastColumn, columns)=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = $5aceebfd588d01cb$var$calculateCellColSpan(store.state.colspanMap, i, rowId, minFirstColumn, maxLastColumn, columns, getColspan);
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    } : ()=>{});
    api.calculateColSpan = calculateColSpan;
    return {
        resetColSpan: resetColSpan,
        getCellColSpanInfo: getCellColSpanInfo,
        calculateColSpan: calculateColSpan
    };
}
function $5aceebfd588d01cb$var$calculateCellColSpan(lookup, columnIndex, rowId, minFirstColumnIndex, maxLastColumnIndex, columns, getColspan) {
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const colSpan = getColspan(rowId, column, columnIndex);
    if (!colSpan || colSpan === 1) {
        $5aceebfd588d01cb$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: 1,
                width: column.computedWidth
            }
        });
        return {
            colSpan: 1
        };
    }
    let width = column.computedWidth;
    for(let j = 1; j < colSpan; j += 1){
        const nextColumnIndex = columnIndex + j;
        // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
        if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
            const nextColumn = columns[nextColumnIndex];
            width += nextColumn.computedWidth;
            $5aceebfd588d01cb$var$setCellColSpanInfo(lookup, rowId, columnIndex + j, {
                spannedByColSpan: true,
                rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                leftVisibleCellIndex: columnIndex
            });
        }
        $5aceebfd588d01cb$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: colSpan,
                width: width
            }
        });
    }
    return {
        colSpan: colSpan
    };
}
function $5aceebfd588d01cb$var$setCellColSpanInfo(colspanMap, rowId, columnIndex, cellColSpanInfo) {
    let columnInfo = colspanMap.get(rowId);
    if (!columnInfo) {
        columnInfo = {};
        colspanMap.set(rowId, columnInfo);
    }
    columnInfo[columnIndex] = cellColSpanInfo;
}

});

parcelRegister("h8348", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c7858fce4e25e1aa$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c7858fce4e25e1aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dimensions = void 0;
module.exports.observeRootNode = $c7858fce4e25e1aa$var$observeRootNode;

var $c7858fce4e25e1aa$var$_extends2 = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c7858fce4e25e1aa$var$React = $c7858fce4e25e1aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c7858fce4e25e1aa$var$_ownerDocument = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("43fuO")));

var $c7858fce4e25e1aa$var$_useLazyRef = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("doV3C")));

var $c7858fce4e25e1aa$var$_useEnhancedEffect = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $c7858fce4e25e1aa$var$_useEventCallback = $c7858fce4e25e1aa$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9gpDF = parcelRequire("9gpDF");

var $e9lLm = parcelRequire("e9lLm");

var $fCm8e = parcelRequire("fCm8e");

var $8P0MD = parcelRequire("8P0MD");

var $6gwDn = parcelRequire("6gwDn");
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ /* eslint-disable no-underscore-dangle */ const $c7858fce4e25e1aa$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $6gwDn.Size.EMPTY,
    viewportOuterSize: $6gwDn.Size.EMPTY,
    viewportInnerSize: $6gwDn.Size.EMPTY,
    contentSize: $6gwDn.Size.EMPTY,
    minimumSize: $6gwDn.Size.EMPTY,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0,
    autoHeight: false,
    minimalContentHeight: undefined
};
const $c7858fce4e25e1aa$var$selectors = {
    rootSize: (state)=>state.rootSize,
    dimensions: (state)=>state.dimensions,
    rowHeight: (state)=>state.dimensions.rowHeight,
    columnsTotalWidth: (state)=>state.dimensions.columnsTotalWidth,
    contentHeight: (state)=>state.dimensions.contentSize.height,
    autoHeight: (state)=>state.dimensions.autoHeight,
    minimalContentHeight: (state)=>state.dimensions.minimalContentHeight,
    rowsMeta: (state)=>state.rowsMeta,
    rowPositions: (state)=>state.rowsMeta.positions,
    columnPositions: (0, $8P0MD.createSelectorMemoized)((_, columns)=>{
        const positions = [];
        let currentPosition = 0;
        for(let i = 0; i < columns.length; i += 1){
            positions.push(currentPosition);
            currentPosition += columns[i].computedWidth;
        }
        return positions;
    }),
    needsHorizontalScrollbar: (state)=>state.dimensions.viewportOuterSize.width > 0 && state.dimensions.columnsTotalWidth > state.dimensions.viewportOuterSize.width
};
const $c7858fce4e25e1aa$var$Dimensions = module.exports.Dimensions = {
    initialize: $c7858fce4e25e1aa$var$initializeState,
    use: $c7858fce4e25e1aa$var$useDimensions,
    selectors: $c7858fce4e25e1aa$var$selectors
};
function $c7858fce4e25e1aa$var$initializeState(params) {
    const dimensions = (0, $c7858fce4e25e1aa$var$_extends2.default)({}, $c7858fce4e25e1aa$var$EMPTY_DIMENSIONS, params.dimensions, {
        autoHeight: params.dimensions.autoHeight,
        minimalContentHeight: params.dimensions.minimalContentHeight
    });
    const { rowCount: rowCount } = params;
    const { rowHeight: rowHeight } = dimensions;
    const rowsMeta = {
        currentPageTotalHeight: rowCount * rowHeight,
        positions: Array.from({
            length: rowCount
        }, (_, i)=>i * rowHeight),
        pinnedTopRowsTotalHeight: 0,
        pinnedBottomRowsTotalHeight: 0
    };
    const rowHeights = new Map();
    return {
        rootSize: $6gwDn.Size.EMPTY,
        dimensions: dimensions,
        rowsMeta: rowsMeta,
        rowHeights: rowHeights
    };
}
function $c7858fce4e25e1aa$var$useDimensions(store, params, _api) {
    const isFirstSizing = $c7858fce4e25e1aa$var$React.useRef(true);
    const { layout: layout, dimensions: { rowHeight: rowHeight, columnsTotalWidth: columnsTotalWidth, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth, topPinnedHeight: topPinnedHeight, bottomPinnedHeight: bottomPinnedHeight }, onResize: onResize } = params;
    const updateDimensions = $c7858fce4e25e1aa$var$React.useCallback((firstUpdate)=>{
        if (firstUpdate) isFirstSizing.current = false;
        if (isFirstSizing.current) return;
        const containerNode = layout.refs.container.current;
        const rootSize = $c7858fce4e25e1aa$var$selectors.rootSize(store.state);
        const rowsMeta = $c7858fce4e25e1aa$var$selectors.rowsMeta(store.state);
        // All the floating point dimensions should be rounded to .1 decimal places to avoid subpixel rendering issues
        // https://github.com/mui/mui-x/issues/9550#issuecomment-1619020477
        // https://github.com/mui/mui-x/issues/15721
        const scrollbarSize = $c7858fce4e25e1aa$var$measureScrollbarSize(containerNode, params.dimensions.scrollbarSize);
        const topContainerHeight = topPinnedHeight + rowsMeta.pinnedTopRowsTotalHeight;
        const bottomContainerHeight = bottomPinnedHeight + rowsMeta.pinnedBottomRowsTotalHeight;
        const contentSize = {
            width: columnsTotalWidth,
            height: (0, $fCm8e.roundToDecimalPlaces)(rowsMeta.currentPageTotalHeight, 1)
        };
        let viewportOuterSize;
        let viewportInnerSize;
        let hasScrollX = false;
        let hasScrollY = false;
        if (params.dimensions.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootSize.width);
            viewportOuterSize = {
                width: rootSize.width,
                height: topContainerHeight + bottomContainerHeight + contentSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - (hasScrollY ? scrollbarSize : 0)),
                height: Math.max(0, viewportOuterSize.height - (hasScrollX ? scrollbarSize : 0))
            };
        } else {
            viewportOuterSize = {
                width: rootSize.width,
                height: rootSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width),
                height: Math.max(0, viewportOuterSize.height - topContainerHeight - bottomContainerHeight)
            };
            const content = contentSize;
            const container = viewportInnerSize;
            const hasScrollXIfNoYScrollBar = content.width > container.width;
            const hasScrollYIfNoXScrollBar = content.height > container.height;
            if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
                hasScrollY = hasScrollYIfNoXScrollBar;
                hasScrollX = content.width + (hasScrollY ? scrollbarSize : 0) > container.width;
                // We recalculate the scroll y to consider the size of the x scrollbar.
                if (hasScrollX) hasScrollY = content.height + scrollbarSize > container.height;
            }
            if (hasScrollY) viewportInnerSize.width -= scrollbarSize;
            if (hasScrollX) viewportInnerSize.height -= scrollbarSize;
        }
        if (params.disableHorizontalScroll) hasScrollX = false;
        if (params.disableVerticalScroll) hasScrollY = false;
        const rowWidth = Math.max(viewportOuterSize.width, columnsTotalWidth + (hasScrollY ? scrollbarSize : 0));
        const minimumSize = {
            width: columnsTotalWidth,
            height: topContainerHeight + contentSize.height + bottomContainerHeight
        };
        const newDimensions = {
            isReady: true,
            root: rootSize,
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            contentSize: contentSize,
            minimumSize: minimumSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollbarSize: scrollbarSize,
            rowWidth: rowWidth,
            rowHeight: rowHeight,
            columnsTotalWidth: columnsTotalWidth,
            leftPinnedWidth: leftPinnedWidth,
            rightPinnedWidth: rightPinnedWidth,
            topContainerHeight: topContainerHeight,
            bottomContainerHeight: bottomContainerHeight,
            autoHeight: params.dimensions.autoHeight,
            minimalContentHeight: params.dimensions.minimalContentHeight
        };
        const prevDimensions = store.state.dimensions;
        if ((0, $e9lLm.isDeepEqual)(prevDimensions, newDimensions)) return;
        store.update({
            dimensions: newDimensions
        });
        onResize?.(newDimensions.root);
    }, [
        store,
        layout.refs.container,
        params.dimensions.scrollbarSize,
        params.dimensions.autoHeight,
        params.dimensions.minimalContentHeight,
        params.disableHorizontalScroll,
        params.disableVerticalScroll,
        onResize,
        rowHeight,
        columnsTotalWidth,
        leftPinnedWidth,
        rightPinnedWidth,
        topPinnedHeight,
        bottomPinnedHeight
    ]);
    const { resizeThrottleMs: resizeThrottleMs } = params;
    const updateDimensionCallback = (0, $c7858fce4e25e1aa$var$_useEventCallback.default)(updateDimensions);
    const debouncedUpdateDimensions = $c7858fce4e25e1aa$var$React.useMemo(()=>resizeThrottleMs > 0 ? (0, $9gpDF.throttle)(updateDimensionCallback, resizeThrottleMs) : undefined, [
        resizeThrottleMs,
        updateDimensionCallback
    ]);
    $c7858fce4e25e1aa$var$React.useEffect(()=>debouncedUpdateDimensions?.clear, [
        debouncedUpdateDimensions
    ]);
    (0, $c7858fce4e25e1aa$var$_useEnhancedEffect.default)(updateDimensions, [
        updateDimensions
    ]);
    (0, $c7858fce4e25e1aa$var$_useEnhancedEffect.default)(()=>{
        store.update({
            dimensions: (0, $c7858fce4e25e1aa$var$_extends2.default)({}, store.state.dimensions, {
                autoHeight: params.dimensions.autoHeight,
                minimalContentHeight: params.dimensions.minimalContentHeight
            })
        });
    }, [
        store,
        params.dimensions.autoHeight,
        params.dimensions.minimalContentHeight
    ]);
    const rowsMeta = $c7858fce4e25e1aa$var$useRowsMeta(store, params, updateDimensions);
    return {
        updateDimensions: updateDimensions,
        debouncedUpdateDimensions: debouncedUpdateDimensions,
        rowsMeta: rowsMeta
    };
}
function $c7858fce4e25e1aa$var$useRowsMeta(store, params, updateDimensions) {
    const heightCache = store.state.rowHeights;
    const { rows: rows, getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = params;
    const lastMeasuredRowIndex = $c7858fce4e25e1aa$var$React.useRef(-1);
    const hasRowWithAutoHeight = $c7858fce4e25e1aa$var$React.useRef(false);
    const isHeightMetaValid = $c7858fce4e25e1aa$var$React.useRef(false);
    const pinnedRows = params.pinnedRows;
    const rowHeight = (0, $8P0MD.useStore)(store, $c7858fce4e25e1aa$var$selectors.rowHeight);
    const getRowHeightEntry = (0, $c7858fce4e25e1aa$var$_useEventCallback.default)((rowId)=>{
        let entry = heightCache.get(rowId);
        if (entry === undefined) {
            entry = {
                content: store.state.dimensions.rowHeight,
                spacingTop: 0,
                spacingBottom: 0,
                detail: 0,
                autoHeight: false,
                needsFirstMeasurement: true
            };
            heightCache.set(rowId, entry);
        }
        return entry;
    });
    const { applyRowHeight: applyRowHeight } = params;
    const processHeightEntry = $c7858fce4e25e1aa$var$React.useCallback((row)=>{
        // HACK: rowHeight trails behind the most up-to-date value just enough to
        // mess the initial rowsMeta hydration :/
        $c7858fce4e25e1aa$var$eslintUseValue(rowHeight);
        const dimensions = $c7858fce4e25e1aa$var$selectors.dimensions(store.state);
        const baseRowHeight = dimensions.rowHeight;
        const entry = getRowHeightEntry(row.id);
        if (!getRowHeightProp) {
            entry.content = baseRowHeight;
            entry.needsFirstMeasurement = false;
        } else {
            const rowHeightFromUser = getRowHeightProp(row);
            if (rowHeightFromUser === 'auto') {
                if (entry.needsFirstMeasurement) {
                    const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight(row) : baseRowHeight;
                    // If the row was not measured yet use the estimated row height
                    entry.content = estimatedRowHeight ?? baseRowHeight;
                }
                hasRowWithAutoHeight.current = true;
                entry.autoHeight = true;
            } else {
                // Default back to base rowHeight if getRowHeight returns null value.
                entry.content = rowHeightFromUser ?? dimensions.rowHeight;
                entry.needsFirstMeasurement = false;
                entry.autoHeight = false;
            }
        }
        if (getRowSpacing) {
            const spacing = getRowSpacing(row);
            entry.spacingTop = spacing.top ?? 0;
            entry.spacingBottom = spacing.bottom ?? 0;
        } else {
            entry.spacingTop = 0;
            entry.spacingBottom = 0;
        }
        applyRowHeight?.(entry, row);
        return entry;
    }, [
        store,
        getRowHeightProp,
        getRowHeightEntry,
        getEstimatedRowHeight,
        rowHeight,
        getRowSpacing,
        applyRowHeight
    ]);
    const hydrateRowsMeta = $c7858fce4e25e1aa$var$React.useCallback(()=>{
        hasRowWithAutoHeight.current = false;
        const pinnedTopRowsTotalHeight = pinnedRows?.top.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0) ?? 0;
        const pinnedBottomRowsTotalHeight = pinnedRows?.bottom.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0) ?? 0;
        const positions = [];
        const currentPageTotalHeight = rows.reduce((acc, row)=>{
            positions.push(acc);
            const entry = processHeightEntry(row);
            const total = entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
            return acc + total;
        }, 0);
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        const didHeightsChange = pinnedTopRowsTotalHeight !== store.state.rowsMeta.pinnedTopRowsTotalHeight || pinnedBottomRowsTotalHeight !== store.state.rowsMeta.pinnedBottomRowsTotalHeight || currentPageTotalHeight !== store.state.rowsMeta.currentPageTotalHeight;
        const rowsMeta = {
            currentPageTotalHeight: currentPageTotalHeight,
            positions: positions,
            pinnedTopRowsTotalHeight: pinnedTopRowsTotalHeight,
            pinnedBottomRowsTotalHeight: pinnedBottomRowsTotalHeight
        };
        store.set('rowsMeta', rowsMeta);
        if (didHeightsChange) updateDimensions();
        isHeightMetaValid.current = true;
    }, [
        store,
        pinnedRows,
        rows,
        processHeightEntry,
        updateDimensions
    ]);
    const hydrateRowsMetaLatest = (0, $c7858fce4e25e1aa$var$_useEventCallback.default)(hydrateRowsMeta);
    const getRowHeight = (rowId)=>{
        return heightCache.get(rowId)?.content ?? $c7858fce4e25e1aa$var$selectors.rowHeight(store.state);
    };
    const storeRowHeightMeasurement = (id, height)=>{
        const entry = getRowHeightEntry(id);
        const didChange = entry.content !== height;
        entry.needsFirstMeasurement = false;
        entry.content = height;
        isHeightMetaValid.current && (isHeightMetaValid.current = !didChange);
    };
    const rowHasAutoHeight = (id)=>{
        return heightCache.get(id)?.autoHeight ?? false;
    };
    const getLastMeasuredRowIndex = ()=>{
        return lastMeasuredRowIndex.current;
    };
    const setLastMeasuredRowIndex = (index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    };
    const resetRowHeights = ()=>{
        heightCache.clear();
        hydrateRowsMeta();
    };
    const resizeObserver = (0, $c7858fce4e25e1aa$var$_useLazyRef.default)(()=>typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver((entries)=>{
            for(let i = 0; i < entries.length; i += 1){
                const entry = entries[i];
                const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
                const rowId = entry.target.__mui_id;
                const focusedVirtualRowId = params.focusedVirtualCell?.()?.id;
                if (focusedVirtualRowId === rowId && height === 0) // Focused virtual row has 0 height.
                // We don't want to store it to avoid scroll jumping.
                // https://github.com/mui/mui-x/issues/14726
                return;
                storeRowHeightMeasurement(rowId, height);
            }
            if (!isHeightMetaValid.current) // Avoids "ResizeObserver loop completed with undelivered notifications" error
            requestAnimationFrame(()=>{
                hydrateRowsMetaLatest();
            });
        })).current;
    const observeRowHeight = (element, rowId)=>{
        element.__mui_id = rowId;
        resizeObserver?.observe(element);
        return ()=>resizeObserver?.unobserve(element);
    };
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    (0, $c7858fce4e25e1aa$var$_useEnhancedEffect.default)(()=>{
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    return {
        getRowHeight: getRowHeight,
        setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        storeRowHeightMeasurement: storeRowHeightMeasurement,
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        resetRowHeights: resetRowHeights
    };
}
function $c7858fce4e25e1aa$var$observeRootNode(node, store, setRootSize) {
    if (!node) return undefined;
    const bounds = node.getBoundingClientRect();
    const initialSize = {
        width: (0, $fCm8e.roundToDecimalPlaces)(bounds.width, 1),
        height: (0, $fCm8e.roundToDecimalPlaces)(bounds.height, 1)
    };
    if (store.state.rootSize === $6gwDn.Size.EMPTY || !$6gwDn.Size.equals(initialSize, store.state.rootSize)) setRootSize(initialSize);
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry])=>{
        if (!entry) return;
        const rootSize = {
            width: (0, $fCm8e.roundToDecimalPlaces)(entry.contentRect.width, 1),
            height: (0, $fCm8e.roundToDecimalPlaces)(entry.contentRect.height, 1)
        };
        if (!$6gwDn.Size.equals(rootSize, store.state.rootSize)) setRootSize(rootSize);
    });
    observer.observe(node);
    return ()=>{
        observer.disconnect();
    };
}
const $c7858fce4e25e1aa$var$scrollbarSizeCache = new WeakMap();
function $c7858fce4e25e1aa$var$measureScrollbarSize(element, scrollbarSize) {
    if (scrollbarSize !== undefined) return scrollbarSize;
    if (element === null) return 0;
    const cachedSize = $c7858fce4e25e1aa$var$scrollbarSizeCache.get(element);
    if (cachedSize !== undefined) return cachedSize;
    const doc = (0, $c7858fce4e25e1aa$var$_ownerDocument.default)(element);
    const scrollDiv = doc.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.className = 'scrollDiv';
    element.appendChild(scrollDiv);
    const size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    element.removeChild(scrollDiv);
    $c7858fce4e25e1aa$var$scrollbarSizeCache.set(element, size);
    return size;
}
function $c7858fce4e25e1aa$var$eslintUseValue(_) {}

});
parcelRegister("9gpDF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fskyi = parcelRequire("fskyi");
Object.keys($fskyi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fskyi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fskyi[key];
        }
    });
});

});
parcelRegister("fskyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.throttle = $b40969c224b3d72c$var$throttle;
function $b40969c224b3d72c$var$throttle(func, wait = 166) {
    let timeout;
    let lastArgs;
    const later = ()=>{
        timeout = undefined;
        func(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (timeout === undefined) timeout = setTimeout(later, wait);
    }
    throttled.clear = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
    };
    return throttled;
}

});


parcelRegister("e9lLm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cUY0R = parcelRequire("cUY0R");
Object.keys($cUY0R).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cUY0R[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cUY0R[key];
        }
    });
});

});
parcelRegister("cUY0R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDeepEqual = $9679444e8beccb55$var$isDeepEqual;
/**
 * Based on `fast-deep-equal`
 *
 * MIT License
 *
 * Copyright (c) 2017 Evgeny Poberezkin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * Check if two values are deeply equal.
 */ function $9679444e8beccb55$var$isDeepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$9679444e8beccb55$var$isDeepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$9679444e8beccb55$var$isDeepEqual(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$9679444e8beccb55$var$isDeepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}

});


parcelRegister("fCm8e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.roundToDecimalPlaces = $b5eb928c08dc82e9$var$roundToDecimalPlaces;
function $b5eb928c08dc82e9$var$roundToDecimalPlaces(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}

});

parcelRegister("6gwDn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hW0vN = parcelRequire("hW0vN");
Object.keys($hW0vN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hW0vN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hW0vN[key];
        }
    });
});

var $d0DEV = parcelRequire("d0DEV");
Object.keys($d0DEV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d0DEV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d0DEV[key];
        }
    });
});

var $2vWCe = parcelRequire("2vWCe");
Object.keys($2vWCe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2vWCe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2vWCe[key];
        }
    });
});

var $idjQn = parcelRequire("idjQn");
Object.keys($idjQn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $idjQn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $idjQn[key];
        }
    });
});

});
parcelRegister("hW0vN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Size = module.exports.ScrollPosition = module.exports.ScrollDirection = module.exports.PinnedRows = module.exports.PinnedColumns = void 0;
/* eslint-disable @typescript-eslint/no-redeclare */ const $d0e8401b7b465117$var$Size = module.exports.Size = {
    EMPTY: {
        width: 0,
        height: 0
    },
    equals: (a, b)=>a.width === b.width && a.height === b.height
};
// TODO
const $d0e8401b7b465117$var$PinnedRows = module.exports.PinnedRows = {
    EMPTY: {
        top: [],
        bottom: []
    }
};
const $d0e8401b7b465117$var$PinnedColumns = module.exports.PinnedColumns = {
    EMPTY: {
        left: [],
        right: []
    }
};
const $d0e8401b7b465117$var$ScrollPosition = module.exports.ScrollPosition = {
    EMPTY: {
        top: 0,
        left: 0
    },
    equals: (a, b)=>a.top === b.top && a.left === b.left
};
let $d0e8401b7b465117$var$ScrollDirection = module.exports.ScrollDirection = /*#__PURE__*/ function(ScrollDirection) {
    ScrollDirection[ScrollDirection["NONE"] = 0] = "NONE";
    ScrollDirection[ScrollDirection["UP"] = 1] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 2] = "DOWN";
    ScrollDirection[ScrollDirection["LEFT"] = 3] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 4] = "RIGHT";
    return ScrollDirection;
}({});
(function(_ScrollDirection) {
    function forDelta(dx, dy) {
        if (dx === 0 && dy === 0) return $d0e8401b7b465117$var$ScrollDirection.NONE;
        /* eslint-disable */ if (Math.abs(dy) >= Math.abs(dx)) {
            if (dy > 0) return $d0e8401b7b465117$var$ScrollDirection.DOWN;
            else return $d0e8401b7b465117$var$ScrollDirection.UP;
        } else {
            if (dx > 0) return $d0e8401b7b465117$var$ScrollDirection.RIGHT;
            else return $d0e8401b7b465117$var$ScrollDirection.LEFT;
        }
    /* eslint-enable */ }
    _ScrollDirection.forDelta = forDelta;
})($d0e8401b7b465117$var$ScrollDirection || (module.exports.ScrollDirection = $d0e8401b7b465117$var$ScrollDirection = {}));

});

parcelRegister("d0DEV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2vWCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("idjQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("hgVKp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Keyboard = void 0;

var $h8348 = parcelRequire("h8348");

var $EPOBk = parcelRequire("EPOBk");
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $c930b9bb9e7ac1dd$var$selectors = {};
const $c930b9bb9e7ac1dd$var$Keyboard = module.exports.Keyboard = {
    initialize: $c930b9bb9e7ac1dd$var$initializeState,
    use: $c930b9bb9e7ac1dd$var$useKeyboard,
    selectors: $c930b9bb9e7ac1dd$var$selectors
};
function $c930b9bb9e7ac1dd$var$initializeState(_params) {
    return {};
}
function $c930b9bb9e7ac1dd$var$useKeyboard(store, params, _api) {
    const getViewportPageSize = ()=>{
        const dimensions = $h8348.Dimensions.selectors.dimensions(store.state);
        if (!dimensions.isReady) return 0;
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (params.getRowHeight) {
            const renderContext = $EPOBk.Virtualization.selectors.renderContext(store.state);
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, params.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / dimensions.rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, params.rows.length);
    };
    return {
        getViewportPageSize: getViewportPageSize
    };
}

});
parcelRegister("EPOBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $15OTL = parcelRequire("15OTL");
Object.keys($15OTL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $15OTL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $15OTL[key];
        }
    });
});

var $9xceS = parcelRequire("9xceS");
Object.keys($9xceS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9xceS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9xceS[key];
        }
    });
});

});
parcelRegister("15OTL", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0cbdbd6cfbca1f04$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0cbdbd6cfbca1f04$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LayoutList = module.exports.LayoutDataGridLegacy = module.exports.LayoutDataGrid = module.exports.Layout = void 0;

var $0cbdbd6cfbca1f04$var$_useForkRef = $0cbdbd6cfbca1f04$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $0cbdbd6cfbca1f04$var$_useEventCallback = $0cbdbd6cfbca1f04$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $0cbdbd6cfbca1f04$var$platform = $0cbdbd6cfbca1f04$require$_interopRequireWildcard((parcelRequire("44S7j")));

var $8P0MD = parcelRequire("8P0MD");

var $h8348 = parcelRequire("h8348");

var $9xceS = parcelRequire("9xceS");
/* eslint-disable react-hooks/rules-of-hooks */ class $0cbdbd6cfbca1f04$var$Layout {
    static elements = [
        'scroller',
        'container'
    ];
    constructor(refs){
        this.refs = refs;
    }
    refSetter(name) {
        return (node)=>{
            if (node && this.refs[name].current !== node) this.refs[name].current = node;
        };
    }
}
module.exports.Layout = $0cbdbd6cfbca1f04$var$Layout;
class $0cbdbd6cfbca1f04$var$LayoutDataGrid extends $0cbdbd6cfbca1f04$var$Layout {
    static elements = [
        'scroller',
        'container',
        'content',
        'positioner',
        'scrollbarVertical',
        'scrollbarHorizontal'
    ];
    use(store, _params, _api, layoutParams) {
        const { scrollerRef: scrollerRef, containerRef: containerRef } = layoutParams;
        const scrollbarVerticalRef = (0, $0cbdbd6cfbca1f04$var$_useEventCallback.default)(this.refSetter('scrollbarVertical'));
        const scrollbarHorizontalRef = (0, $0cbdbd6cfbca1f04$var$_useEventCallback.default)(this.refSetter('scrollbarHorizontal'));
        store.state.virtualization.context = {
            scrollerRef: scrollerRef,
            containerRef: containerRef,
            scrollbarVerticalRef: scrollbarVerticalRef,
            scrollbarHorizontalRef: scrollbarHorizontalRef
        };
    }
    static selectors = {
        containerProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.context, (context)=>({
                ref: context.containerRef
            })),
        scrollerProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.context, $h8348.Dimensions.selectors.autoHeight, $h8348.Dimensions.selectors.needsHorizontalScrollbar, (context, autoHeight, needsHorizontalScrollbar)=>({
                ref: context.scrollerRef,
                style: {
                    overflowX: !needsHorizontalScrollbar ? 'hidden' : undefined,
                    overflowY: autoHeight ? 'hidden' : undefined
                },
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $0cbdbd6cfbca1f04$var$platform.isFirefox ? -1 : undefined
            })),
        contentProps: (0, $8P0MD.createSelectorMemoized)($h8348.Dimensions.selectors.contentHeight, $h8348.Dimensions.selectors.minimalContentHeight, $h8348.Dimensions.selectors.columnsTotalWidth, $h8348.Dimensions.selectors.needsHorizontalScrollbar, (contentHeight, minimalContentHeight, columnsTotalWidth, needsHorizontalScrollbar)=>({
                style: {
                    width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
                    flexBasis: contentHeight === 0 ? minimalContentHeight : contentHeight,
                    flexShrink: 0
                },
                role: 'presentation'
            })),
        positionerProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.offsetTop, (offsetTop)=>({
                style: {
                    transform: `translate3d(0, ${offsetTop}px, 0)`
                }
            })),
        scrollbarHorizontalProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.context, $9xceS.Virtualization.selectors.scrollPosition, (context, scrollPosition)=>({
                ref: context.scrollbarHorizontalRef,
                scrollPosition: scrollPosition
            })),
        scrollbarVerticalProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.context, $9xceS.Virtualization.selectors.scrollPosition, (context, scrollPosition)=>({
                ref: context.scrollbarVerticalRef,
                scrollPosition: scrollPosition
            })),
        scrollAreaProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.scrollPosition, (scrollPosition)=>({
                scrollPosition: scrollPosition
            }))
    };
}
// The current virtualizer API is exposed on one of the DataGrid slots, so we need to keep
// the old API for backward compatibility. This API prevents using fine-grained reactivity
// as all props are returned in a single object, so everything re-renders on any change.
//
// TODO(v9): Remove the legacy API.
module.exports.LayoutDataGrid = $0cbdbd6cfbca1f04$var$LayoutDataGrid;
class $0cbdbd6cfbca1f04$var$LayoutDataGridLegacy extends $0cbdbd6cfbca1f04$var$LayoutDataGrid {
    use(store, _params, _api, layoutParams) {
        super.use(store, _params, _api, layoutParams);
        const containerProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.containerProps);
        const scrollerProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollerProps);
        const contentProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.contentProps);
        const positionerProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.positionerProps);
        const scrollbarVerticalProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollbarVerticalProps);
        const scrollbarHorizontalProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollbarHorizontalProps);
        const scrollAreaProps = store.use($0cbdbd6cfbca1f04$var$LayoutDataGrid.selectors.scrollAreaProps);
        return {
            getContainerProps: ()=>containerProps,
            getScrollerProps: ()=>scrollerProps,
            getContentProps: ()=>contentProps,
            getPositionerProps: ()=>positionerProps,
            getScrollbarVerticalProps: ()=>scrollbarVerticalProps,
            getScrollbarHorizontalProps: ()=>scrollbarHorizontalProps,
            getScrollAreaProps: ()=>scrollAreaProps
        };
    }
}
module.exports.LayoutDataGridLegacy = $0cbdbd6cfbca1f04$var$LayoutDataGridLegacy;
class $0cbdbd6cfbca1f04$var$LayoutList extends $0cbdbd6cfbca1f04$var$Layout {
    static elements = [
        'scroller',
        'container',
        'content',
        'positioner'
    ];
    use(store, _params, _api, layoutParams) {
        const { scrollerRef: scrollerRef, containerRef: containerRef } = layoutParams;
        const mergedRef = (0, $0cbdbd6cfbca1f04$var$_useForkRef.default)(scrollerRef, containerRef);
        store.state.virtualization.context = {
            mergedRef: mergedRef
        };
    }
    static selectors = {
        containerProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.context, $h8348.Dimensions.selectors.autoHeight, $h8348.Dimensions.selectors.needsHorizontalScrollbar, (context, autoHeight, needsHorizontalScrollbar)=>({
                ref: context.mergedRef,
                style: {
                    overflowX: !needsHorizontalScrollbar ? 'hidden' : undefined,
                    overflowY: autoHeight ? 'hidden' : undefined,
                    position: 'relative'
                },
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $0cbdbd6cfbca1f04$var$platform.isFirefox ? -1 : undefined
            })),
        contentProps: (0, $8P0MD.createSelectorMemoized)($h8348.Dimensions.selectors.contentHeight, (contentHeight)=>{
            return {
                style: {
                    position: 'absolute',
                    display: 'inline-block',
                    width: '100%',
                    height: contentHeight,
                    top: 0,
                    left: 0,
                    zIndex: -1
                },
                role: 'presentation'
            };
        }),
        positionerProps: (0, $8P0MD.createSelectorMemoized)($9xceS.Virtualization.selectors.offsetTop, (offsetTop)=>({
                style: {
                    height: offsetTop
                }
            }))
    };
}
module.exports.LayoutList = $0cbdbd6cfbca1f04$var$LayoutList;

});
parcelRegister("44S7j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJSDOM = module.exports.isFirefox = module.exports.default = void 0;
const $2f8183a962423c9d$var$userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : 'empty';
const $2f8183a962423c9d$var$isFirefox = module.exports.isFirefox = $2f8183a962423c9d$var$userAgent.includes('firefox');
const $2f8183a962423c9d$var$isJSDOM = module.exports.isJSDOM = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);
var $2f8183a962423c9d$var$_default = module.exports.default = {
    isFirefox: $2f8183a962423c9d$var$isFirefox,
    isJSDOM: $2f8183a962423c9d$var$isJSDOM
};

});

parcelRegister("9xceS", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6f10b085fd1b645e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6f10b085fd1b645e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Virtualization = module.exports.EMPTY_RENDER_CONTEXT = void 0;
module.exports.areRenderContextsEqual = $6f10b085fd1b645e$var$areRenderContextsEqual;
module.exports.computeOffsetLeft = $6f10b085fd1b645e$var$computeOffsetLeft;
module.exports.roundToDecimalPlaces = $6f10b085fd1b645e$var$roundToDecimalPlaces;

var $6f10b085fd1b645e$var$_extends2 = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6f10b085fd1b645e$var$React = $6f10b085fd1b645e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6f10b085fd1b645e$var$ReactDOM = $6f10b085fd1b645e$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $6f10b085fd1b645e$var$_useLazyRef = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("doV3C")));

var $6f10b085fd1b645e$var$_useTimeout = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("drY8V")));

var $6f10b085fd1b645e$var$_useEventCallback = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $6f10b085fd1b645e$var$_useEnhancedEffect = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $6f10b085fd1b645e$var$platform = $6f10b085fd1b645e$require$_interopRequireWildcard((parcelRequire("44S7j")));

var $fF5vr = parcelRequire("fF5vr");

var $8P0MD = parcelRequire("8P0MD");

var $6f10b085fd1b645e$var$_reactMajor = $6f10b085fd1b645e$require$_interopRequireDefault((parcelRequire("eKs5z")));

var $hW0vN = parcelRequire("hW0vN");

var $h8348 = parcelRequire("h8348");

var $6gwDn = parcelRequire("6gwDn");
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $6f10b085fd1b645e$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
const $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH = 50;
const $6f10b085fd1b645e$var$EMPTY_SCROLL_POSITION = {
    top: 0,
    left: 0
};
const $6f10b085fd1b645e$var$EMPTY_DETAIL_PANELS = Object.freeze(new Map());
const $6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT = module.exports.EMPTY_RENDER_CONTEXT = {
    firstRowIndex: 0,
    lastRowIndex: 0,
    firstColumnIndex: 0,
    lastColumnIndex: 0
};
const $6f10b085fd1b645e$var$selectors = (()=>{
    const firstRowIndexSelector = (0, $8P0MD.createSelector)((state)=>state.virtualization.renderContext.firstRowIndex);
    return {
        store: (0, $8P0MD.createSelector)((state)=>state.virtualization),
        renderContext: (0, $8P0MD.createSelector)((state)=>state.virtualization.renderContext),
        enabledForRows: (0, $8P0MD.createSelector)((state)=>state.virtualization.enabledForRows),
        enabledForColumns: (0, $8P0MD.createSelector)((state)=>state.virtualization.enabledForColumns),
        offsetTop: (0, $8P0MD.createSelector)($h8348.Dimensions.selectors.rowPositions, firstRowIndexSelector, (rowPositions, firstRowIndex)=>rowPositions[firstRowIndex] ?? 0),
        context: (0, $8P0MD.createSelector)((state)=>state.virtualization.context),
        scrollPosition: (0, $8P0MD.createSelector)((state)=>state.virtualization.scrollPosition)
    };
})();
const $6f10b085fd1b645e$var$Virtualization = module.exports.Virtualization = {
    initialize: $6f10b085fd1b645e$var$initializeState,
    use: $6f10b085fd1b645e$var$useVirtualization,
    selectors: $6f10b085fd1b645e$var$selectors
};
function $6f10b085fd1b645e$var$initializeState(params) {
    const state = {
        virtualization: (0, $6f10b085fd1b645e$var$_extends2.default)({
            enabled: !$6f10b085fd1b645e$var$platform.isJSDOM,
            enabledForRows: !$6f10b085fd1b645e$var$platform.isJSDOM,
            enabledForColumns: !$6f10b085fd1b645e$var$platform.isJSDOM,
            renderContext: $6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT,
            props: params.layout.constructor.elements.reduce((acc, key)=>(acc[key], acc), {}),
            context: {},
            scrollPosition: {
                current: $6gwDn.ScrollPosition.EMPTY
            }
        }, params.initialState?.virtualization),
        // FIXME: refactor once the state shape is settled
        getters: null
    };
    return state;
}
/** APIs to override for colspan/rowspan */ function $6f10b085fd1b645e$var$useVirtualization(store, params, api) {
    const { layout: layout, dimensions: { rowHeight: rowHeight, columnsTotalWidth: columnsTotalWidth = 0 }, virtualization: { isRtl: isRtl = false, rowBufferPx: rowBufferPx = 150, columnBufferPx: columnBufferPx = 150 }, colspan: colspan, initialState: initialState, rows: rows, range: range, columns: columns, pinnedRows: pinnedRows = $hW0vN.PinnedRows.EMPTY, pinnedColumns: pinnedColumns = $hW0vN.PinnedColumns.EMPTY, onWheel: onWheel, onTouchMove: onTouchMove, onRenderContextChange: onRenderContextChange, onScrollChange: onScrollChange, scrollReset: scrollReset, renderRow: renderRow, renderInfiniteLoadingTrigger: renderInfiniteLoadingTrigger } = params;
    const hasBottomPinnedRows = pinnedRows.bottom.length > 0;
    const [panels, setPanels] = $6f10b085fd1b645e$var$React.useState($6f10b085fd1b645e$var$EMPTY_DETAIL_PANELS);
    const isUpdateScheduled = $6f10b085fd1b645e$var$React.useRef(false);
    const isRenderContextReady = $6f10b085fd1b645e$var$React.useRef(false);
    const renderContext = (0, $8P0MD.useStore)(store, $6f10b085fd1b645e$var$selectors.renderContext);
    const enabledForRows = (0, $8P0MD.useStore)(store, $6f10b085fd1b645e$var$selectors.enabledForRows);
    const enabledForColumns = (0, $8P0MD.useStore)(store, $6f10b085fd1b645e$var$selectors.enabledForColumns);
    const contentHeight = (0, $8P0MD.useStore)(store, $h8348.Dimensions.selectors.contentHeight);
    /*
   * Scroll context logic
   * ====================
   * We only render the cells contained in the `renderContext`. However, when the user starts scrolling the grid
   * in a direction, we want to render as many cells as possible in that direction, as to avoid presenting white
   * areas if the user scrolls too fast/far and the viewport ends up in a region we haven't rendered yet. To render
   * more cells, we store some offsets to add to the viewport in `scrollCache.buffer`. Those offsets make the render
   * context wider in the direction the user is going, but also makes the buffer around the viewport `0` for the
   * dimension (horizontal or vertical) in which the user is not scrolling. So if the normal viewport is 8 columns
   * wide, with a 1 column buffer (10 columns total), then we want it to be exactly 8 columns wide during vertical
   * scroll.
   * However, we don't want the rows in the old context to re-render from e.g. 10 columns to 8 columns, because that's
   * work that's not necessary. Thus we store the context at the start of the scroll in `frozenContext`, and the rows
   * that are part of this old context will keep their same render context as to avoid re-rendering.
   */ const scrollPosition = $6f10b085fd1b645e$var$React.useRef(initialState?.scroll ?? $6f10b085fd1b645e$var$EMPTY_SCROLL_POSITION);
    const ignoreNextScrollEvent = $6f10b085fd1b645e$var$React.useRef(false);
    const previousContextScrollPosition = $6f10b085fd1b645e$var$React.useRef($6f10b085fd1b645e$var$EMPTY_SCROLL_POSITION);
    const previousRowContext = $6f10b085fd1b645e$var$React.useRef($6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT);
    const scrollTimeout = (0, $6f10b085fd1b645e$var$_useTimeout.default)();
    const frozenContext = $6f10b085fd1b645e$var$React.useRef(undefined);
    const scrollCache = (0, $6f10b085fd1b645e$var$_useLazyRef.default)(()=>$6f10b085fd1b645e$var$createScrollCache(isRtl, rowBufferPx, columnBufferPx, rowHeight * 15, $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH * 6)).current;
    const updateRenderContext = $6f10b085fd1b645e$var$React.useCallback((nextRenderContext)=>{
        if (!$6f10b085fd1b645e$var$areRenderContextsEqual(nextRenderContext, store.state.virtualization.renderContext)) store.set('virtualization', (0, $6f10b085fd1b645e$var$_extends2.default)({}, store.state.virtualization, {
            renderContext: nextRenderContext,
            scrollPosition: {
                current: (0, $6f10b085fd1b645e$var$_extends2.default)({}, scrollPosition.current)
            }
        }));
        // The lazy-loading hook is listening to `renderedRowsIntervalChange`,
        // but only does something if we already have a render context, because
        // otherwise we would call an update directly on mount
        const isReady = $h8348.Dimensions.selectors.dimensions(store.state).isReady;
        const didRowsIntervalChange = nextRenderContext.firstRowIndex !== previousRowContext.current.firstRowIndex || nextRenderContext.lastRowIndex !== previousRowContext.current.lastRowIndex;
        if (isReady && didRowsIntervalChange) {
            previousRowContext.current = nextRenderContext;
            onRenderContextChange?.(nextRenderContext);
        }
        previousContextScrollPosition.current = scrollPosition.current;
    }, [
        store,
        onRenderContextChange
    ]);
    const triggerUpdateRenderContext = (0, $6f10b085fd1b645e$var$_useEventCallback.default)(()=>{
        const scroller = layout.refs.scroller.current;
        if (!scroller) return undefined;
        const dimensions = $h8348.Dimensions.selectors.dimensions(store.state);
        const maxScrollTop = Math.ceil(dimensions.contentSize.height - dimensions.viewportInnerSize.height);
        const maxScrollLeft = Math.ceil(dimensions.contentSize.width - dimensions.viewportInnerSize.width);
        // Clamp the scroll position to the viewport to avoid re-calculating the render context for scroll bounce
        const newScroll = {
            top: $6f10b085fd1b645e$var$clamp(scroller.scrollTop, 0, maxScrollTop),
            left: isRtl ? $6f10b085fd1b645e$var$clamp(scroller.scrollLeft, -Math.abs(maxScrollLeft), 0) : $6f10b085fd1b645e$var$clamp(scroller.scrollLeft, 0, maxScrollLeft)
        };
        const dx = newScroll.left - scrollPosition.current.left;
        const dy = newScroll.top - scrollPosition.current.top;
        const isScrolling = dx !== 0 || dy !== 0;
        scrollPosition.current = newScroll;
        const direction = isScrolling ? $6gwDn.ScrollDirection.forDelta(dx, dy) : $6gwDn.ScrollDirection.NONE;
        // Since previous render, we have scrolled...
        const rowScroll = Math.abs(scrollPosition.current.top - previousContextScrollPosition.current.top);
        const columnScroll = Math.abs(scrollPosition.current.left - previousContextScrollPosition.current.left);
        // PERF: use the computed minimum column width instead of a static one
        const didCrossThreshold = rowScroll >= rowHeight || columnScroll >= $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH;
        const didChangeDirection = scrollCache.direction !== direction;
        const shouldUpdate = didCrossThreshold || didChangeDirection;
        if (!shouldUpdate) {
            store.set('virtualization', (0, $6f10b085fd1b645e$var$_extends2.default)({}, store.state.virtualization, {
                scrollPosition: {
                    current: (0, $6f10b085fd1b645e$var$_extends2.default)({}, scrollPosition.current)
                }
            }));
            return renderContext;
        }
        // Render a new context
        if (didChangeDirection) switch(direction){
            case $6gwDn.ScrollDirection.NONE:
            case $6gwDn.ScrollDirection.LEFT:
            case $6gwDn.ScrollDirection.RIGHT:
                frozenContext.current = undefined;
                break;
            default:
                frozenContext.current = renderContext;
                break;
        }
        scrollCache.direction = direction;
        scrollCache.buffer = $6f10b085fd1b645e$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, rowHeight * 15, $6f10b085fd1b645e$var$MINIMUM_COLUMN_WIDTH * 6);
        const inputs = $6f10b085fd1b645e$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns);
        const nextRenderContext = $6f10b085fd1b645e$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        if (!$6f10b085fd1b645e$var$areRenderContextsEqual(nextRenderContext, renderContext)) {
            // Prevents batching render context changes
            $6f10b085fd1b645e$var$ReactDOM.flushSync(()=>{
                updateRenderContext(nextRenderContext);
            });
            scrollTimeout.start(1000, triggerUpdateRenderContext);
        } else store.set('virtualization', (0, $6f10b085fd1b645e$var$_extends2.default)({}, store.state.virtualization, {
            scrollPosition: {
                current: (0, $6f10b085fd1b645e$var$_extends2.default)({}, scrollPosition.current)
            }
        }));
        return nextRenderContext;
    });
    const forceUpdateRenderContext = ()=>{
        // skip update if dimensions are not ready and virtualization is enabled
        if (!$h8348.Dimensions.selectors.dimensions(store.state).isReady && (enabledForRows || enabledForColumns)) return;
        const inputs = $6f10b085fd1b645e$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns);
        const nextRenderContext = $6f10b085fd1b645e$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        // Reset the frozen context when the render context changes, see the illustration in https://github.com/mui/mui-x/pull/12353
        frozenContext.current = undefined;
        updateRenderContext(nextRenderContext);
    };
    const forceUpdateRenderContextCallback = (0, $6f10b085fd1b645e$var$_useEventCallback.default)(forceUpdateRenderContext);
    (0, $8P0MD.useStoreEffect)(store, $h8348.Dimensions.selectors.dimensions, (previous, next)=>{
        if (next.isReady) forceUpdateRenderContext();
    });
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (isUpdateScheduled.current) {
            forceUpdateRenderContext();
            isUpdateScheduled.current = false;
        }
    });
    const scheduleUpdateRenderContext = ()=>{
        isUpdateScheduled.current = true;
    };
    const handleScroll = (0, $6f10b085fd1b645e$var$_useEventCallback.default)(()=>{
        if (ignoreNextScrollEvent.current) {
            ignoreNextScrollEvent.current = false;
            return;
        }
        const nextRenderContext = triggerUpdateRenderContext();
        if (nextRenderContext) onScrollChange?.(scrollPosition.current, nextRenderContext);
    });
    /**
   * HACK: unstable_rowTree fixes the issue described below, but does it by tightly coupling this
   * section of code to the DataGrid's rowTree model. The `unstable_rowTree` param is a temporary
   * solution to decouple the code.
   */ const getRows = (rowParams = {}, unstable_rowTree)=>{
        if (!rowParams.rows && !range) return [];
        let baseRenderContext = renderContext;
        if (rowParams.renderContext) {
            baseRenderContext = rowParams.renderContext;
            baseRenderContext.firstColumnIndex = renderContext.firstColumnIndex;
            baseRenderContext.lastColumnIndex = renderContext.lastColumnIndex;
        }
        const isLastSection = !hasBottomPinnedRows && rowParams.position === undefined || hasBottomPinnedRows && rowParams.position === 'bottom';
        const isPinnedSection = rowParams.position !== undefined;
        let rowIndexOffset;
        switch(rowParams.position){
            case 'top':
                rowIndexOffset = 0;
                break;
            case 'bottom':
                rowIndexOffset = pinnedRows.top.length + rows.length;
                break;
            case undefined:
            default:
                rowIndexOffset = pinnedRows.top.length;
                break;
        }
        const rowModels = rowParams.rows ?? rows;
        const firstRowToRender = baseRenderContext.firstRowIndex;
        const lastRowToRender = Math.min(baseRenderContext.lastRowIndex, rowModels.length);
        const rowIndexes = rowParams.rows ? $6f10b085fd1b645e$var$createRange(0, rowParams.rows.length) : $6f10b085fd1b645e$var$createRange(firstRowToRender, lastRowToRender);
        let virtualRowIndex = -1;
        const focusedVirtualCell = params.focusedVirtualCell?.();
        if (!isPinnedSection && focusedVirtualCell) {
            if (focusedVirtualCell.rowIndex < firstRowToRender) {
                rowIndexes.unshift(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
            if (focusedVirtualCell.rowIndex > lastRowToRender) {
                rowIndexes.push(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
        }
        const rowElements = [];
        const columnPositions = $h8348.Dimensions.selectors.columnPositions(store.state, columns);
        rowIndexes.forEach((rowIndexInPage)=>{
            const { id: id, model: model } = rowModels[rowIndexInPage];
            // In certain cases, the state might already be updated and `params.rows` (which sets `rowModels`)
            // contains stale data.
            // In that case, skip any further row processing.
            // See:
            // - https://github.com/mui/mui-x/issues/16638
            // - https://github.com/mui/mui-x/issues/17022
            if (unstable_rowTree && !unstable_rowTree[id]) return;
            const rowIndex = (range?.firstRowIndex || 0) + rowIndexOffset + rowIndexInPage;
            // NOTE: This is an expensive feature, the colSpan code could be optimized.
            if (colspan?.enabled) {
                const minFirstColumn = pinnedColumns.left.length;
                const maxLastColumn = columns.length - pinnedColumns.right.length;
                api.calculateColSpan(id, minFirstColumn, maxLastColumn, columns);
                if (pinnedColumns.left.length > 0) api.calculateColSpan(id, 0, pinnedColumns.left.length, columns);
                if (pinnedColumns.right.length > 0) api.calculateColSpan(id, columns.length - pinnedColumns.right.length, columns.length, columns);
            }
            const baseRowHeight = !api.rowsMeta.rowHasAutoHeight(id) ? api.rowsMeta.getRowHeight(id) : 'auto';
            let isFirstVisible = false;
            if (rowParams.position === undefined) isFirstVisible = rowIndexInPage === 0;
            let isLastVisible = false;
            const isLastVisibleInSection = rowIndexInPage === rowModels.length - 1;
            if (isLastSection) {
                if (!isPinnedSection) {
                    const lastIndex = rows.length - 1;
                    const isLastVisibleRowIndex = rowIndexInPage === lastIndex;
                    if (isLastVisibleRowIndex) isLastVisible = true;
                } else isLastVisible = isLastVisibleInSection;
            }
            let currentRenderContext = baseRenderContext;
            if (frozenContext.current && rowIndexInPage >= frozenContext.current.firstRowIndex && rowIndexInPage < frozenContext.current.lastRowIndex) currentRenderContext = frozenContext.current;
            const isVirtualFocusRow = rowIndexInPage === virtualRowIndex;
            const isVirtualFocusColumn = focusedVirtualCell?.rowIndex === rowIndex;
            const offsetLeft = $6f10b085fd1b645e$var$computeOffsetLeft(columnPositions, currentRenderContext, pinnedColumns.left.length);
            const showBottomBorder = isLastVisibleInSection && rowParams.position === 'top';
            const firstColumnIndex = currentRenderContext.firstColumnIndex;
            const lastColumnIndex = currentRenderContext.lastColumnIndex;
            rowElements.push(renderRow({
                id: id,
                model: model,
                rowIndex: rowIndex,
                offsetLeft: offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                baseRowHeight: baseRowHeight,
                firstColumnIndex: firstColumnIndex,
                lastColumnIndex: lastColumnIndex,
                focusedColumnIndex: isVirtualFocusColumn ? focusedVirtualCell.columnIndex : undefined,
                isFirstVisible: isFirstVisible,
                isLastVisible: isLastVisible,
                isVirtualFocusRow: isVirtualFocusRow,
                showBottomBorder: showBottomBorder
            }));
            if (isVirtualFocusRow) return;
            const panel = panels.get(id);
            if (panel) rowElements.push(panel);
            if (rowParams.position === undefined && isLastVisibleInSection && renderInfiniteLoadingTrigger) rowElements.push(renderInfiniteLoadingTrigger(id));
        });
        return rowElements;
    };
    const scrollRestoreCallback = $6f10b085fd1b645e$var$React.useRef(null);
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (!isRenderContextReady.current) return;
        forceUpdateRenderContextCallback();
    }, [
        enabledForColumns,
        enabledForRows,
        forceUpdateRenderContextCallback
    ]);
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (layout.refs.scroller.current) layout.refs.scroller.current.scrollLeft = 0;
    }, [
        layout.refs.scroller,
        scrollReset
    ]);
    (0, $fF5vr.useRunOnce)(renderContext !== $6f10b085fd1b645e$var$EMPTY_RENDER_CONTEXT, ()=>{
        onScrollChange?.(scrollPosition.current, renderContext);
        isRenderContextReady.current = true;
        if (initialState?.scroll && layout.refs.scroller.current) {
            const scroller = layout.refs.scroller.current;
            const { top: top, left: left } = initialState.scroll;
            const isScrollRestored = {
                top: !(top > 0),
                left: !(left > 0)
            };
            if (!isScrollRestored.left && columnsTotalWidth) {
                scroller.scrollLeft = left;
                isScrollRestored.left = true;
                ignoreNextScrollEvent.current = true;
            }
            // To restore the vertical scroll, we need to wait until the rows are available in the DOM (otherwise
            // there's nowhere to scroll). We still set the scrollTop to the initial value at this point in case
            // there already are rows rendered in the DOM, but we only confirm `isScrollRestored.top = true` in the
            // asynchronous callback below.
            if (!isScrollRestored.top && contentHeight) {
                scroller.scrollTop = top;
                ignoreNextScrollEvent.current = true;
            }
            if (!isScrollRestored.top || !isScrollRestored.left) scrollRestoreCallback.current = (columnsTotalWidthCurrent, contentHeightCurrent)=>{
                if (!isScrollRestored.left && columnsTotalWidthCurrent) {
                    scroller.scrollLeft = left;
                    isScrollRestored.left = true;
                    ignoreNextScrollEvent.current = true;
                }
                if (!isScrollRestored.top && contentHeightCurrent) {
                    scroller.scrollTop = top;
                    isScrollRestored.top = true;
                    ignoreNextScrollEvent.current = true;
                }
                if (isScrollRestored.left && isScrollRestored.top) scrollRestoreCallback.current = null;
            };
        }
    });
    (0, $8P0MD.useStoreEffect)(store, $h8348.Dimensions.selectors.dimensions, forceUpdateRenderContext);
    (0, $6f10b085fd1b645e$var$_useEnhancedEffect.default)(()=>{
        if (layout.refs.scroller) scrollRestoreCallback.current?.(columnsTotalWidth, contentHeight);
    }, [
        layout.refs.scroller,
        columnsTotalWidth,
        contentHeight
    ]);
    const isFirstSizing = $6f10b085fd1b645e$var$React.useRef(true);
    const containerRef = $6f10b085fd1b645e$var$useRefCallback((node)=>{
        layout.refs.container.current = node;
        const unsubscribe = (0, $h8348.observeRootNode)(node, store, (rootSize)=>{
            if (rootSize.width === 0 && rootSize.height === 0 && store.state.rootSize.height !== 0 && store.state.rootSize.width !== 0) return;
            store.state.rootSize = rootSize;
            if (isFirstSizing.current || !api.debouncedUpdateDimensions) {
                // We want to initialize the grid dimensions as soon as possible to avoid flickering
                api.updateDimensions(isFirstSizing.current);
                isFirstSizing.current = false;
            } else api.debouncedUpdateDimensions();
        });
        return ()=>{
            unsubscribe?.();
            layout.refs.container.current = null;
        };
    });
    const scrollerRef = $6f10b085fd1b645e$var$useRefCallback((node)=>{
        layout.refs.scroller.current = node;
        const opts = {
            passive: true
        };
        node.addEventListener('scroll', handleScroll, opts);
        node.addEventListener('wheel', onWheel, opts);
        node.addEventListener('touchmove', onTouchMove, opts);
        return ()=>{
            node.removeEventListener('scroll', handleScroll, opts);
            node.removeEventListener('wheel', onWheel, opts);
            node.removeEventListener('touchmove', onTouchMove, opts);
            layout.refs.scroller.current = null;
        };
    });
    const layoutParams = {
        containerRef: containerRef,
        scrollerRef: scrollerRef
    };
    const layoutAPI = layout.use(store, params, api, layoutParams);
    const getters = (0, $6f10b085fd1b645e$var$_extends2.default)({
        setPanels: setPanels,
        getRows: getRows,
        rows: params.rows
    }, layoutAPI);
    return (0, $6f10b085fd1b645e$var$_extends2.default)({
        getters: getters,
        setPanels: setPanels,
        forceUpdateRenderContext: forceUpdateRenderContext,
        scheduleUpdateRenderContext: scheduleUpdateRenderContext
    }, $6f10b085fd1b645e$var$createSpanningAPI());
}
function $6f10b085fd1b645e$var$useRefCallback(fn) {
    const refCleanup = $6f10b085fd1b645e$var$React.useRef(undefined);
    const refCallback = (0, $6f10b085fd1b645e$var$_useEventCallback.default)((node)=>{
        if (!node) {
            // Cleanup for R18
            refCleanup.current?.();
            return;
        }
        refCleanup.current = fn(node);
        if ($6f10b085fd1b645e$var$_reactMajor.default >= 19) /* eslint-disable-next-line consistent-return */ return refCleanup.current;
    });
    return refCallback;
}
function $6f10b085fd1b645e$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns) {
    const dimensions = $h8348.Dimensions.selectors.dimensions(store.state);
    const rows = params.rows;
    const range = params.range;
    const columns = params.columns;
    const hiddenCellsOriginMap = api.getHiddenCellsOrigin();
    const lastRowId = params.rows.at(-1)?.id;
    const lastColumn = columns.at(-1);
    return {
        api: api,
        enabledForRows: enabledForRows,
        enabledForColumns: enabledForColumns,
        autoHeight: dimensions.autoHeight,
        rowBufferPx: params.virtualization.rowBufferPx,
        columnBufferPx: params.virtualization.columnBufferPx,
        leftPinnedWidth: dimensions.leftPinnedWidth,
        columnsTotalWidth: dimensions.columnsTotalWidth,
        viewportInnerWidth: dimensions.viewportInnerSize.width,
        viewportInnerHeight: dimensions.viewportInnerSize.height,
        lastRowHeight: lastRowId !== undefined ? api.rowsMeta.getRowHeight(lastRowId) : 0,
        lastColumnWidth: lastColumn?.computedWidth ?? 0,
        rowsMeta: $h8348.Dimensions.selectors.rowsMeta(store.state),
        columnPositions: $h8348.Dimensions.selectors.columnPositions(store.state, params.columns),
        rows: rows,
        range: range,
        pinnedColumns: params.pinnedColumns,
        columns: columns,
        hiddenCellsOriginMap: hiddenCellsOriginMap,
        virtualizeColumnsWithAutoRowHeight: params.virtualizeColumnsWithAutoRowHeight
    };
}
function $6f10b085fd1b645e$var$computeRenderContext(inputs, scrollPosition, scrollCache) {
    const renderContext = {
        firstRowIndex: 0,
        lastRowIndex: inputs.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: inputs.columns.length
    };
    const { top: top, left: left } = scrollPosition;
    const realLeft = Math.abs(left) + inputs.leftPinnedWidth;
    if (inputs.enabledForRows) {
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        let firstRowIndex = Math.min($6f10b085fd1b645e$var$getNearestIndexToRender(inputs, top, {
            atStart: true,
            lastPosition: inputs.rowsMeta.positions[inputs.rowsMeta.positions.length - 1] + inputs.lastRowHeight
        }), inputs.rowsMeta.positions.length - 1);
        // If any of the cells in the `firstRowIndex` is hidden due to an extended row span,
        // Make sure the row from where the rowSpan is originated is visible.
        const rowSpanHiddenCellOrigin = inputs.hiddenCellsOriginMap[firstRowIndex];
        if (rowSpanHiddenCellOrigin) {
            const minSpannedRowIndex = Math.min(...Object.values(rowSpanHiddenCellOrigin));
            firstRowIndex = Math.min(firstRowIndex, minSpannedRowIndex);
        }
        const lastRowIndex = inputs.autoHeight ? firstRowIndex + inputs.rows.length : $6f10b085fd1b645e$var$getNearestIndexToRender(inputs, top + inputs.viewportInnerHeight);
        renderContext.firstRowIndex = firstRowIndex;
        renderContext.lastRowIndex = lastRowIndex;
    }
    // XXX
    // if (inputs.listView) {
    //   return {
    //     ...renderContext,
    //     lastColumnIndex: 1,
    //   };
    // }
    if (inputs.enabledForColumns) {
        let firstColumnIndex = 0;
        let lastColumnIndex = inputs.columnPositions.length;
        let hasRowWithAutoHeight = false;
        const [firstRowToRender, lastRowToRender] = $6f10b085fd1b645e$var$getIndexesToRender({
            firstIndex: renderContext.firstRowIndex,
            lastIndex: renderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: inputs.rows.length,
            bufferBefore: scrollCache.buffer.rowBefore,
            bufferAfter: scrollCache.buffer.rowAfter,
            positions: inputs.rowsMeta.positions,
            lastSize: inputs.lastRowHeight
        });
        if (!inputs.virtualizeColumnsWithAutoRowHeight) for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
            const row = inputs.rows[i];
            hasRowWithAutoHeight = inputs.api.rowsMeta.rowHasAutoHeight(row.id);
        }
        if (!hasRowWithAutoHeight || inputs.virtualizeColumnsWithAutoRowHeight) {
            firstColumnIndex = $6f10b085fd1b645e$var$binarySearch(realLeft, inputs.columnPositions, {
                atStart: true,
                lastPosition: inputs.columnsTotalWidth
            });
            lastColumnIndex = $6f10b085fd1b645e$var$binarySearch(realLeft + inputs.viewportInnerWidth, inputs.columnPositions);
        }
        renderContext.firstColumnIndex = firstColumnIndex;
        renderContext.lastColumnIndex = lastColumnIndex;
    }
    const actualRenderContext = $6f10b085fd1b645e$var$deriveRenderContext(inputs, renderContext, scrollCache);
    return actualRenderContext;
}
function $6f10b085fd1b645e$var$getNearestIndexToRender(inputs, offset, options) {
    const lastMeasuredIndexRelativeToAllRows = inputs.api.rowsMeta.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if (inputs.range?.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= inputs.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = $6f10b085fd1b645e$var$clamp(lastMeasuredIndexRelativeToAllRows - (inputs.range?.firstRowIndex || 0), 0, inputs.rowsMeta.positions.length);
    if (allRowsMeasured || inputs.rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $6f10b085fd1b645e$var$binarySearch(offset, inputs.rowsMeta.positions, options);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $6f10b085fd1b645e$var$exponentialSearch(offset, inputs.rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage, options);
}
/**
 * Accepts as input a raw render context (the area visible in the viewport) and adds
 * computes the actual render context based on pinned elements, buffer dimensions and
 * spanning.
 */ function $6f10b085fd1b645e$var$deriveRenderContext(inputs, nextRenderContext, scrollCache) {
    const [firstRowToRender, lastRowToRender] = $6f10b085fd1b645e$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstRowIndex,
        lastIndex: nextRenderContext.lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: inputs.rows.length,
        bufferBefore: scrollCache.buffer.rowBefore,
        bufferAfter: scrollCache.buffer.rowAfter,
        positions: inputs.rowsMeta.positions,
        lastSize: inputs.lastRowHeight
    });
    const [initialFirstColumnToRender, lastColumnToRender] = $6f10b085fd1b645e$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstColumnIndex,
        lastIndex: nextRenderContext.lastColumnIndex,
        minFirstIndex: inputs.pinnedColumns?.left.length ?? 0,
        maxLastIndex: inputs.columns.length - (inputs.pinnedColumns?.right.length ?? 0),
        bufferBefore: scrollCache.buffer.columnBefore,
        bufferAfter: scrollCache.buffer.columnAfter,
        positions: inputs.columnPositions,
        lastSize: inputs.lastColumnWidth
    });
    const firstColumnToRender = $6f10b085fd1b645e$var$getFirstNonSpannedColumnToRender({
        api: inputs.api,
        firstColumnToRender: initialFirstColumnToRender,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: inputs.rows
    });
    return {
        firstRowIndex: firstRowToRender,
        lastRowIndex: lastRowToRender,
        firstColumnIndex: firstColumnToRender,
        lastColumnIndex: lastColumnToRender
    };
}
/**
 * Use binary search to avoid looping through all possible positions.
 * The `options.atStart` provides the possibility to match for the first element that
 * intersects the screen, even if said element's start position is before `offset`. In
 * other words, we search for `offset + width`.
 */ function $6f10b085fd1b645e$var$binarySearch(offset, positions, options, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const position = positions[pivot];
    let isBefore;
    if (options?.atStart) {
        const width = (pivot === positions.length - 1 ? options.lastPosition : positions[pivot + 1]) - position;
        isBefore = offset - width < position;
    } else isBefore = offset <= position;
    return isBefore ? $6f10b085fd1b645e$var$binarySearch(offset, positions, options, sliceStart, pivot) : $6f10b085fd1b645e$var$binarySearch(offset, positions, options, pivot + 1, sliceEnd);
}
function $6f10b085fd1b645e$var$exponentialSearch(offset, positions, index, options) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $6f10b085fd1b645e$var$binarySearch(offset, positions, options, Math.floor(index / 2), Math.min(index, positions.length));
}
function $6f10b085fd1b645e$var$getIndexesToRender({ firstIndex: firstIndex, lastIndex: lastIndex, bufferBefore: bufferBefore, bufferAfter: bufferAfter, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex, positions: positions, lastSize: lastSize }) {
    const firstPosition = positions[firstIndex] - bufferBefore;
    const lastPosition = positions[lastIndex] + bufferAfter;
    const firstIndexPadded = $6f10b085fd1b645e$var$binarySearch(firstPosition, positions, {
        atStart: true,
        lastPosition: positions[positions.length - 1] + lastSize
    });
    const lastIndexPadded = $6f10b085fd1b645e$var$binarySearch(lastPosition, positions);
    return [
        $6f10b085fd1b645e$var$clamp(firstIndexPadded, minFirstIndex, maxLastIndex),
        $6f10b085fd1b645e$var$clamp(lastIndexPadded, minFirstIndex, maxLastIndex)
    ];
}
function $6f10b085fd1b645e$var$areRenderContextsEqual(context1, context2) {
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
}
function $6f10b085fd1b645e$var$computeOffsetLeft(columnPositions, renderContext, pinnedLeftLength) {
    const left = (columnPositions[renderContext.firstColumnIndex] ?? 0) - (columnPositions[pinnedLeftLength] ?? 0);
    return Math.abs(left);
}
function $6f10b085fd1b645e$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    if (isRtl) switch(direction){
        case $6gwDn.ScrollDirection.LEFT:
            direction = $6gwDn.ScrollDirection.RIGHT;
            break;
        case $6gwDn.ScrollDirection.RIGHT:
            direction = $6gwDn.ScrollDirection.LEFT;
            break;
        default:
    }
    switch(direction){
        case $6gwDn.ScrollDirection.NONE:
            return {
                rowAfter: rowBufferPx,
                rowBefore: rowBufferPx,
                columnAfter: columnBufferPx,
                columnBefore: columnBufferPx
            };
        case $6gwDn.ScrollDirection.LEFT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: horizontalBuffer
            };
        case $6gwDn.ScrollDirection.RIGHT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: horizontalBuffer,
                columnBefore: 0
            };
        case $6gwDn.ScrollDirection.UP:
            return {
                rowAfter: 0,
                rowBefore: verticalBuffer,
                columnAfter: 0,
                columnBefore: 0
            };
        case $6gwDn.ScrollDirection.DOWN:
            return {
                rowAfter: verticalBuffer,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: 0
            };
        default:
            // eslint unable to figure out enum exhaustiveness
            throw new Error('unreachable');
    }
}
function $6f10b085fd1b645e$var$createScrollCache(isRtl, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    return {
        direction: $6gwDn.ScrollDirection.NONE,
        buffer: $6f10b085fd1b645e$var$bufferForDirection(isRtl, $6gwDn.ScrollDirection.NONE, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)
    };
}
function $6f10b085fd1b645e$var$createRange(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
function $6f10b085fd1b645e$var$getFirstNonSpannedColumnToRender({ api: api, firstColumnToRender: firstColumnToRender, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn && firstNonSpannedColumnToRender >= 0){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = api.getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
/** Placeholder API functions for colspan & rowspan to re-implement */ function $6f10b085fd1b645e$var$createSpanningAPI() {
    const getCellColSpanInfo = ()=>{
        throw new Error('Unimplemented: colspan feature is required');
    };
    const calculateColSpan = ()=>{
        throw new Error('Unimplemented: colspan feature is required');
    };
    const getHiddenCellsOrigin = ()=>{
        throw new Error('Unimplemented: rowspan feature is required');
    };
    return {
        getCellColSpanInfo: getCellColSpanInfo,
        calculateColSpan: calculateColSpan,
        getHiddenCellsOrigin: getHiddenCellsOrigin
    };
}
function $6f10b085fd1b645e$var$roundToDecimalPlaces(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}

});




parcelRegister("2YrdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rowspan = void 0;
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $22a64ccc246ff905$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $22a64ccc246ff905$var$EMPTY_CACHES = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $22a64ccc246ff905$var$selectors = {
    state: (state)=>state.rowSpanning,
    hiddenCells: (state)=>state.rowSpanning.caches.hiddenCells,
    spannedCells: (state)=>state.rowSpanning.caches.spannedCells,
    hiddenCellsOriginMap: (state)=>state.rowSpanning.caches.hiddenCellOriginMap
};
const $22a64ccc246ff905$var$Rowspan = module.exports.Rowspan = {
    initialize: $22a64ccc246ff905$var$initializeState,
    use: $22a64ccc246ff905$var$useRowspan,
    selectors: $22a64ccc246ff905$var$selectors
};
function $22a64ccc246ff905$var$initializeState(params) {
    return {
        rowSpanning: params.initialState?.rowSpanning ?? {
            caches: $22a64ccc246ff905$var$EMPTY_CACHES,
            processedRange: $22a64ccc246ff905$var$EMPTY_RANGE
        }
    };
}
function $22a64ccc246ff905$var$useRowspan(store, _params, _api) {
    const getHiddenCellsOrigin = ()=>$22a64ccc246ff905$var$selectors.hiddenCellsOriginMap(store.state);
    return {
        getHiddenCellsOrigin: getHiddenCellsOrigin
    };
}

});

parcelRegister("4k7kH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_PARAMS = module.exports.DEFAULT_COLUMNS = void 0;
const $325eb7d3aa123984$var$DEFAULT_COLUMNS = module.exports.DEFAULT_COLUMNS = [
    {
        field: 'DEFAULT_COLUMN'
    }
];
const $325eb7d3aa123984$var$DEFAULT_PARAMS = module.exports.DEFAULT_PARAMS = {
    resizeThrottleMs: 100,
    columns: $325eb7d3aa123984$var$DEFAULT_COLUMNS,
    dimensions: {
        autoHeight: false,
        columnsTotalWidth: 0,
        leftPinnedWidth: 0,
        rightPinnedWidth: 0,
        topPinnedHeight: 0,
        bottomPinnedHeight: 0
    },
    virtualization: {
        isRtl: false,
        rowBufferPx: 150,
        columnBufferPx: 150
    }
};

});


parcelRegister("br5oA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7NmXL = parcelRequire("7NmXL");
Object.keys($7NmXL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7NmXL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7NmXL[key];
        }
    });
});

var $h8348 = parcelRequire("h8348");
Object.keys($h8348).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h8348[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h8348[key];
        }
    });
});

var $hgVKp = parcelRequire("hgVKp");
Object.keys($hgVKp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hgVKp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hgVKp[key];
        }
    });
});

var $2YrdJ = parcelRequire("2YrdJ");
Object.keys($2YrdJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2YrdJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2YrdJ[key];
        }
    });
});

var $EPOBk = parcelRequire("EPOBk");
Object.keys($EPOBk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $EPOBk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $EPOBk[key];
        }
    });
});

});


parcelRegister("dfzFI", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9a5858bc9bdcaed0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9a5858bc9bdcaed0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridVirtualization = $9a5858bc9bdcaed0$var$useGridVirtualization;
module.exports.virtualizationStateInitializer = void 0;

var $9a5858bc9bdcaed0$var$_extends2 = $9a5858bc9bdcaed0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9a5858bc9bdcaed0$var$React = $9a5858bc9bdcaed0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $l8hgY = parcelRequire("l8hgY");

var $hWI6v = parcelRequire("hWI6v");

var $ivFej = parcelRequire("ivFej");

var $5LeoO = parcelRequire("5LeoO");
const $9a5858bc9bdcaed0$var$HAS_LAYOUT = !$hWI6v.isJSDOM;
// HACK: Typescript doesn't use the alias name ("GridVirtualizationState") and changes
// the autogenerated docs result, but this would otherwise be just:
//   export type GridVirtualizationState = VirtualizationState;
// XXX: We want to use the virtualizer as the source of truth for its state, but this needs to
// stay because some parts of the grid require the `virtualization` state during initialization.
const $9a5858bc9bdcaed0$var$virtualizationStateInitializer = (state, props)=>{
    const { disableVirtualization: disableVirtualization, autoHeight: autoHeight } = props;
    const virtualization = {
        enabled: !disableVirtualization && $9a5858bc9bdcaed0$var$HAS_LAYOUT,
        enabledForColumns: !disableVirtualization && $9a5858bc9bdcaed0$var$HAS_LAYOUT,
        enabledForRows: !disableVirtualization && !autoHeight && $9a5858bc9bdcaed0$var$HAS_LAYOUT,
        renderContext: $l8hgY.EMPTY_RENDER_CONTEXT
    };
    return (0, $9a5858bc9bdcaed0$var$_extends2.default)({}, state, {
        virtualization: virtualization
    });
};
module.exports.virtualizationStateInitializer = $9a5858bc9bdcaed0$var$virtualizationStateInitializer;
function $9a5858bc9bdcaed0$var$useGridVirtualization(apiRef, rootProps) {
    const { autoHeight: autoHeight, disableVirtualization: disableVirtualization } = rootProps;
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        const { virtualizer: virtualizer } = apiRef.current;
        enabled && (enabled = $9a5858bc9bdcaed0$var$HAS_LAYOUT);
        const snapshot = virtualizer.store.getSnapshot();
        if (snapshot.virtualization.enabled === enabled && snapshot.virtualization.enabledForRows === enabled && snapshot.virtualization.enabledForColumns === enabled) return;
        virtualizer.store.set('virtualization', (0, $9a5858bc9bdcaed0$var$_extends2.default)({}, virtualizer.store.state.virtualization, {
            enabled: enabled,
            enabledForColumns: enabled,
            enabledForRows: enabled && !autoHeight
        }));
    };
    const setColumnVirtualization = (enabled)=>{
        const { virtualizer: virtualizer } = apiRef.current;
        enabled && (enabled = $9a5858bc9bdcaed0$var$HAS_LAYOUT);
        const snapshot = virtualizer.store.getSnapshot();
        if (snapshot.virtualization.enabledForColumns === enabled) return;
        virtualizer.store.set('virtualization', (0, $9a5858bc9bdcaed0$var$_extends2.default)({}, virtualizer.store.state.virtualization, {
            enabledForColumns: enabled
        }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $ivFej.useGridApiMethod)(apiRef, api, 'public');
    const forceUpdateRenderContext = ()=>{
        const { virtualizer: virtualizer } = apiRef.current;
        virtualizer?.api.scheduleUpdateRenderContext();
    };
    apiRef.current.register('private', {
        updateRenderContext: forceUpdateRenderContext
    });
    /*
   * EFFECTS
   */ (0, $5LeoO.useGridEventPriority)(apiRef, 'sortedRowsSet', forceUpdateRenderContext);
    (0, $5LeoO.useGridEventPriority)(apiRef, 'paginationModelChange', forceUpdateRenderContext);
    (0, $5LeoO.useGridEventPriority)(apiRef, 'columnsChange', forceUpdateRenderContext);
    /* eslint-disable react-hooks/exhaustive-deps */ $9a5858bc9bdcaed0$var$React.useEffect(()=>{
        if (!apiRef.current.virtualizer) return;
        setVirtualization(!rootProps.disableVirtualization);
    }, [
        apiRef,
        disableVirtualization,
        autoHeight
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }

});
parcelRegister("hWI6v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJSDOM = void 0;
const $d10a1095bdae3394$var$isJSDOM = module.exports.isJSDOM = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);

});


parcelRegister("9upDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridVirtualizationSelector = module.exports.gridVirtualizationRowEnabledSelector = module.exports.gridVirtualizationEnabledSelector = module.exports.gridVirtualizationColumnEnabledSelector = module.exports.gridRenderContextSelector = module.exports.gridRenderContextColumnsSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
/**
 * Get the columns state
 * @category Virtualization
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationSelector = module.exports.gridVirtualizationSelector = (0, $cgQ4y.createRootSelector)((state)=>state.virtualization);
/**
 * Get the enabled state for virtualization
 * @category Virtualization
 * @deprecated Use `gridVirtualizationColumnEnabledSelector` and `gridVirtualizationRowEnabledSelector`
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationEnabledSelector = module.exports.gridVirtualizationEnabledSelector = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.enabled);
/**
 * Get the enabled state for column virtualization
 * @category Virtualization
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationColumnEnabledSelector = module.exports.gridVirtualizationColumnEnabledSelector = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.enabledForColumns);
/**
 * Get the enabled state for row virtualization
 * @category Virtualization
 */ const $6e8ace88dee0fb7c$var$gridVirtualizationRowEnabledSelector = module.exports.gridVirtualizationRowEnabledSelector = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.enabledForRows);
/**
 * Get the render context
 * @category Virtualization
 * @ignore - do not document.
 */ const $6e8ace88dee0fb7c$var$gridRenderContextSelector = module.exports.gridRenderContextSelector = (0, $cgQ4y.createSelector)($6e8ace88dee0fb7c$var$gridVirtualizationSelector, (state)=>state.renderContext);
const $6e8ace88dee0fb7c$var$firstColumnIndexSelector = (0, $cgQ4y.createRootSelector)((state)=>state.virtualization.renderContext.firstColumnIndex);
const $6e8ace88dee0fb7c$var$lastColumnIndexSelector = (0, $cgQ4y.createRootSelector)((state)=>state.virtualization.renderContext.lastColumnIndex);
/**
 * Get the render context, with only columns filled in.
 * This is cached, so it can be used to only re-render when the column interval changes.
 * @category Virtualization
 * @ignore - do not document.
 */ const $6e8ace88dee0fb7c$var$gridRenderContextColumnsSelector = module.exports.gridRenderContextColumnsSelector = (0, $cgQ4y.createSelectorMemoized)($6e8ace88dee0fb7c$var$firstColumnIndexSelector, $6e8ace88dee0fb7c$var$lastColumnIndexSelector, (firstColumnIndex, lastColumnIndex)=>({
        firstColumnIndex: firstColumnIndex,
        lastColumnIndex: lastColumnIndex
    }));

});


parcelRegister("aqJRW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GridDataSourceCacheDefault", {
    enumerable: true,
    get: function() {
        return $7eBdF.GridDataSourceCacheDefault;
    }
});
Object.defineProperty(module.exports, "GridGetRowsError", {
    enumerable: true,
    get: function() {
        return $ehAc1.GridGetRowsError;
    }
});
Object.defineProperty(module.exports, "GridUpdateRowError", {
    enumerable: true,
    get: function() {
        return $ehAc1.GridUpdateRowError;
    }
});

var $7eBdF = parcelRequire("7eBdF");

var $ehAc1 = parcelRequire("ehAc1");

});
parcelRegister("7eBdF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridDataSourceCacheDefault = void 0;
module.exports.getKeyDefault = $5446b637625dfefc$var$getKeyDefault;
function $5446b637625dfefc$var$getKeyDefault(params) {
    return JSON.stringify([
        params.filterModel,
        params.sortModel,
        params.start,
        params.end
    ]);
}
class $5446b637625dfefc$var$GridDataSourceCacheDefault {
    constructor({ ttl: ttl = 300000, getKey: getKey = $5446b637625dfefc$var$getKeyDefault }){
        this.cache = {};
        this.ttl = ttl;
        this.getKey = getKey;
    }
    set(key, value) {
        const keyString = this.getKey(key);
        const expiry = Date.now() + this.ttl;
        this.cache[keyString] = {
            value: value,
            expiry: expiry
        };
    }
    get(key) {
        const keyString = this.getKey(key);
        const entry = this.cache[keyString];
        if (!entry) return undefined;
        if (Date.now() > entry.expiry) {
            delete this.cache[keyString];
            return undefined;
        }
        return entry.value;
    }
    clear() {
        this.cache = {};
    }
}
module.exports.GridDataSourceCacheDefault = $5446b637625dfefc$var$GridDataSourceCacheDefault;

});

parcelRegister("ehAc1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridUpdateRowError = module.exports.GridGetRowsError = void 0;
class $a65eba665b419180$var$GridGetRowsError extends Error {
    /**
   * The parameters used in the failed request
   */ /**
   * The original error that caused this error
   */ constructor(options){
        super(options.message);
        this.name = 'GridGetRowsError';
        this.params = options.params;
        this.cause = options.cause;
    }
}
module.exports.GridGetRowsError = $a65eba665b419180$var$GridGetRowsError;
class $a65eba665b419180$var$GridUpdateRowError extends Error {
    /**
   * The parameters used in the failed request
   */ /**
   * The original error that caused this error
   */ constructor(options){
        super(options.message);
        this.name = 'GridUpdateRowError';
        this.params = options.params;
        this.cause = options.cause;
    }
}
module.exports.GridUpdateRowError = $a65eba665b419180$var$GridUpdateRowError;

});


parcelRegister("d2Z0A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("9FCuu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "gridRowIdSelector", {
    enumerable: true,
    get: function() {
        return $180lm.gridRowIdSelector;
    }
});

var $180lm = parcelRequire("180lm");

});



parcelRegister("5qaTL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3f27d5a87ea29815$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3f27d5a87ea29815$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridScrollShadows = $3f27d5a87ea29815$var$GridScrollShadows;

var $3f27d5a87ea29815$var$React = $3f27d5a87ea29815$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $9uEev = parcelRequire("9uEev");

var $3f27d5a87ea29815$var$_composeClasses = $3f27d5a87ea29815$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $iAdzh = parcelRequire("iAdzh");

var $goCyd = parcelRequire("goCyd");

var $jDpXp = parcelRequire("jDpXp");

var $hbuUJ = parcelRequire("hbuUJ");

var $er55f = parcelRequire("er55f");

var $61HyH = parcelRequire("61HyH");

var $7jHEF = parcelRequire("7jHEF");

var $ayMG0 = parcelRequire("ayMG0");
const $3f27d5a87ea29815$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'scrollShadow',
            `scrollShadow--${position}`
        ]
    };
    return (0, $3f27d5a87ea29815$var$_composeClasses.default)(slots, $7jHEF.getDataGridUtilityClass, classes);
};
const $3f27d5a87ea29815$var$ScrollShadow = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollShadow',
    overridesResolver: (props, styles)=>[
            styles.root,
            styles[props.position]
        ]
})(({ theme: theme })=>({
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        transition: $hbuUJ.vars.transition([
            'box-shadow'
        ], {
            duration: $hbuUJ.vars.transitions.duration.short
        }),
        '--length': theme.palette.mode === 'dark' ? '8px' : '6px',
        '--length-inverse': 'calc(var(--length) * -1)',
        '--opacity': theme.palette.mode === 'dark' ? '0.7' : '0.18',
        '--blur': 'var(--length)',
        '--spread': 'calc(var(--length) * -1)',
        '--color': '0, 0, 0',
        '--color-start': 'rgba(var(--color), calc(var(--hasScrollStart) * var(--opacity)))',
        '--color-end': 'rgba(var(--color), calc(var(--hasScrollEnd) * var(--opacity)))',
        variants: [
            {
                props: {
                    position: 'vertical'
                },
                style: {
                    top: 'var(--DataGrid-topContainerHeight)',
                    bottom: 'calc(var(--DataGrid-bottomContainerHeight) + var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))',
                    boxShadow: 'inset 0 var(--length) var(--blur) var(--spread) var(--color-start), inset 0 var(--length-inverse) var(--blur) var(--spread) var(--color-end)'
                }
            },
            {
                props: {
                    position: 'horizontal'
                },
                style: {
                    left: 'var(--DataGrid-leftPinnedWidth)',
                    right: 'calc(var(--DataGrid-rightPinnedWidth) + var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
                    boxShadow: 'inset var(--length) 0 var(--blur) var(--spread) var(--color-start), inset var(--length-inverse) 0 var(--blur) var(--spread) var(--color-end)'
                }
            }
        ]
    }));
function $3f27d5a87ea29815$var$GridScrollShadows(props) {
    const { position: position } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        position: position
    };
    const classes = $3f27d5a87ea29815$var$useUtilityClasses(ownerState);
    const ref = $3f27d5a87ea29815$var$React.useRef(null);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const hasScrollX = (0, $iAdzh.useGridSelector)(apiRef, $61HyH.gridHasScrollXSelector);
    const hasScrollY = (0, $iAdzh.useGridSelector)(apiRef, $61HyH.gridHasScrollYSelector);
    const pinnedRows = (0, $iAdzh.useGridSelector)(apiRef, $goCyd.gridPinnedRowsSelector);
    const pinnedColumns = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridPinnedColumnsSelector);
    const initialScrollable = position === 'vertical' ? hasScrollY && pinnedRows?.bottom?.length > 0 : hasScrollX && pinnedColumns?.right?.length !== undefined && pinnedColumns?.right?.length > 0;
    const isRtl = (0, $9uEev.useRtl)();
    const updateScrollShadowVisibility = $3f27d5a87ea29815$var$React.useCallback((scrollPosition)=>{
        if (!ref.current) return;
        // Math.abs to convert negative scroll position (RTL) to positive
        const scroll = Math.abs(Math.round(scrollPosition));
        const dimensions = (0, $iAdzh.gridDimensionsSelector)(apiRef);
        const maxScroll = Math.round(dimensions.contentSize[position === 'vertical' ? 'height' : 'width'] - dimensions.viewportInnerSize[position === 'vertical' ? 'height' : 'width']);
        const hasPinnedStart = position === 'vertical' ? pinnedRows?.top?.length > 0 : pinnedColumns?.left?.length !== undefined && pinnedColumns?.left?.length > 0;
        const hasPinnedEnd = position === 'vertical' ? pinnedRows?.bottom?.length > 0 : pinnedColumns?.right?.length !== undefined && pinnedColumns?.right?.length > 0;
        const scrollIsNotAtStart = isRtl ? scroll < maxScroll : scroll > 0;
        const scrollIsNotAtEnd = isRtl ? scroll > 0 : scroll < maxScroll;
        ref.current.style.setProperty('--hasScrollStart', hasPinnedStart && scrollIsNotAtStart ? '1' : '0');
        ref.current.style.setProperty('--hasScrollEnd', hasPinnedEnd && scrollIsNotAtEnd ? '1' : '0');
    }, [
        pinnedRows,
        pinnedColumns,
        isRtl,
        position,
        apiRef
    ]);
    const handleScrolling = (scrollParams)=>{
        updateScrollShadowVisibility(scrollParams[position === 'vertical' ? 'top' : 'left']);
    };
    const handleColumnResizeStop = ()=>{
        if (position === 'horizontal') updateScrollShadowVisibility(apiRef.current.virtualScrollerRef?.current?.scrollLeft || 0);
    };
    (0, $iAdzh.useGridEvent)(apiRef, 'scrollPositionChange', handleScrolling);
    (0, $iAdzh.useGridEvent)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    $3f27d5a87ea29815$var$React.useEffect(()=>{
        updateScrollShadowVisibility((position === 'horizontal' ? apiRef.current.virtualScrollerRef?.current?.scrollLeft : apiRef.current.virtualScrollerRef?.current?.scrollTop) ?? 0);
    }, [
        updateScrollShadowVisibility,
        apiRef,
        position
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3f27d5a87ea29815$var$ScrollShadow, {
        className: classes.root,
        ownerState: ownerState,
        ref: ref,
        style: {
            '--hasScrollStart': 0,
            '--hasScrollEnd': initialScrollable ? '1' : '0'
        }
    });
}

});

parcelRegister("6ru7t", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4b0ca0cb82103871$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4b0ca0cb82103871$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridOverlayWrapper = $4b0ca0cb82103871$var$GridOverlayWrapper;

var $4b0ca0cb82103871$var$_extends2 = $4b0ca0cb82103871$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4b0ca0cb82103871$var$React = $4b0ca0cb82103871$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4b0ca0cb82103871$var$_propTypes = $4b0ca0cb82103871$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $4b0ca0cb82103871$var$_composeClasses = $4b0ca0cb82103871$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $7sDf4 = parcelRequire("7sDf4");

var $5sOMZ = parcelRequire("5sOMZ");

var $iGtHu = parcelRequire("iGtHu");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $4b0ca0cb82103871$var$GridOverlayWrapperRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant' && prop !== 'right'
})(({ overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant, right: right })=>// Skeleton overlay should flow with the scroll container and not be sticky
    loadingOverlayVariant !== 'skeleton' ? {
        position: 'sticky',
        // To stay in place while scrolling
        top: 'var(--DataGrid-headersTotalHeight)',
        // TODO: take pinned rows into account
        left: 0,
        right: `${right}px`,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    } : {});
const $4b0ca0cb82103871$var$GridOverlayWrapperInner = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant'
})({});
const $4b0ca0cb82103871$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $4b0ca0cb82103871$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $4b0ca0cb82103871$var$GridOverlayWrapper(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const dimensions = (0, $5sOMZ.useGridSelector)(apiRef, $iGtHu.gridDimensionsSelector);
    let height = Math.max(dimensions.viewportOuterSize.height - dimensions.topContainerHeight - dimensions.bottomContainerHeight - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0), 0);
    if (height === 0) height = $7sDf4.minimalContentHeight;
    const classes = $4b0ca0cb82103871$var$useUtilityClasses((0, $4b0ca0cb82103871$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperRoot, (0, $4b0ca0cb82103871$var$_extends2.default)({
        className: classes.root
    }, props, {
        right: dimensions.columnsTotalWidth - dimensions.viewportOuterSize.width,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4b0ca0cb82103871$var$GridOverlayWrapperInner, (0, $4b0ca0cb82103871$var$_extends2.default)({
            className: classes.inner,
            style: {
                height: height,
                width: dimensions.viewportOuterSize.width
            }
        }, props))
    }));
}

});

parcelRegister("7IHuX", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59ee6250fa043d54$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $59ee6250fa043d54$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridVirtualizer = $59ee6250fa043d54$var$useGridVirtualizer;

var $59ee6250fa043d54$var$_extends2 = $59ee6250fa043d54$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $59ee6250fa043d54$var$React = $59ee6250fa043d54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $59ee6250fa043d54$var$_useLazyRef = $59ee6250fa043d54$require$_interopRequireDefault((parcelRequire("doV3C")));

var $59ee6250fa043d54$var$_useEventCallback = $59ee6250fa043d54$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9uEev = parcelRequire("9uEev");

var $fCm8e = parcelRequire("fCm8e");

var $cvyxi = parcelRequire("cvyxi");

var $8P0MD = parcelRequire("8P0MD");

var $l8hgY = parcelRequire("l8hgY");

var $bc8LN = parcelRequire("bc8LN");

var $cgQ4y = parcelRequire("cgQ4y");

var $5sOMZ = parcelRequire("5sOMZ");

var $61HyH = parcelRequire("61HyH");

var $h181e = parcelRequire("h181e");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");

var $aJApm = parcelRequire("aJApm");

var $b2EyI = parcelRequire("b2EyI");

var $98F89 = parcelRequire("98F89");

var $4XcWL = parcelRequire("4XcWL");

var $1kYRD = parcelRequire("1kYRD");

var $7sDf4 = parcelRequire("7sDf4");

var $i0LyH = parcelRequire("i0LyH");

var $dDKMM = parcelRequire("dDKMM");

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");

var $jBRsK = parcelRequire("jBRsK");

var $lR3Vo = parcelRequire("lR3Vo");

var $ayMG0 = parcelRequire("ayMG0");
const $59ee6250fa043d54$var$columnsTotalWidthSelector = (0, $cgQ4y.createSelector)($jQEEt.gridVisibleColumnDefinitionsSelector, $jQEEt.gridColumnPositionsSelector, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $fCm8e.roundToDecimalPlaces)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
/** Translates virtualizer state to grid state */ const $59ee6250fa043d54$var$addGridDimensionsCreator = ()=>(0, $cvyxi.lruMemoize)((dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight)=>{
        return (0, $59ee6250fa043d54$var$_extends2.default)({}, dimensions, {
            headerHeight: headerHeight,
            groupHeaderHeight: groupHeaderHeight,
            headerFilterHeight: headerFilterHeight,
            headersTotalHeight: headersTotalHeight
        });
    }, {
        maxSize: 1
    });
/**
 * Virtualizer setup
 */ function $59ee6250fa043d54$var$useGridVirtualizer() {
    const isRtl = (0, $9uEev.useRtl)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const { listView: listView } = rootProps;
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridVisibleColumnDefinitionsSelector);
    const pinnedRows = (0, $5sOMZ.useGridSelector)(apiRef, $goCyd.gridPinnedRowsSelector);
    const pinnedColumns = (0, $jQEEt.gridVisiblePinnedColumnDefinitionsSelector)(apiRef);
    const rowSelectionManager = (0, $5sOMZ.useGridSelector)(apiRef, $4XcWL.gridRowSelectionManagerSelector);
    const isRowSelected = $59ee6250fa043d54$var$React.useCallback((id)=>rowSelectionManager.has(id) && apiRef.current.isRowSelectable(id), [
        rowSelectionManager,
        apiRef
    ]);
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef);
    const hasColSpan = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridHasColSpanSelector);
    const verticalScrollbarWidth = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridVerticalScrollbarWidthSelector);
    const hasFiller = (0, $5sOMZ.useGridSelector)(apiRef, $61HyH.gridHasFillerSelector);
    const { autoHeight: autoHeight } = rootProps;
    const scrollReset = listView;
    // <DIMENSIONS>
    const density = (0, $5sOMZ.useGridSelector)(apiRef, $h181e.gridDensityFactorSelector);
    const baseRowHeight = (0, $7sDf4.getValidRowHeight)(rootProps.rowHeight, $1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, $7sDf4.rowHeightWarning);
    const rowHeight = Math.floor(baseRowHeight * density);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * density);
    const groupHeaderHeight = Math.floor((rootProps.columnGroupHeaderHeight ?? rootProps.columnHeaderHeight) * density);
    const headerFilterHeight = Math.floor((rootProps.headerFilterHeight ?? rootProps.columnHeaderHeight) * density);
    const columnsTotalWidth = (0, $5sOMZ.useGridSelector)(apiRef, $59ee6250fa043d54$var$columnsTotalWidthSelector);
    const headersTotalHeight = (0, $i0LyH.getTotalHeaderHeight)(apiRef, rootProps);
    const leftPinnedWidth = pinnedColumns.left.reduce((w, col)=>w + col.computedWidth, 0);
    const rightPinnedWidth = pinnedColumns.right.reduce((w, col)=>w + col.computedWidth, 0);
    const overlayState = (0, $dDKMM.useGridOverlays)(apiRef, rootProps);
    const dimensionsParams = {
        rowHeight: rowHeight,
        headerHeight: headerHeight,
        columnsTotalWidth: columnsTotalWidth,
        leftPinnedWidth: leftPinnedWidth,
        rightPinnedWidth: rightPinnedWidth,
        topPinnedHeight: headersTotalHeight,
        bottomPinnedHeight: 0,
        autoHeight: autoHeight,
        minimalContentHeight: $7sDf4.minimalContentHeight,
        scrollbarSize: rootProps.scrollbarSize
    };
    const addGridDimensions = (0, $59ee6250fa043d54$var$_useLazyRef.default)($59ee6250fa043d54$var$addGridDimensionsCreator).current;
    // </DIMENSIONS>
    // <ROWS_META>
    const dataRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $goCyd.gridRowCountSelector);
    const pagination = (0, $5sOMZ.useGridSelector)(apiRef, $b2EyI.gridPaginationSelector);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    const { getRowHeight: getRowHeight, getEstimatedRowHeight: getEstimatedRowHeight, getRowSpacing: getRowSpacing } = rootProps;
    // </ROWS_META>
    const RowSlot = rootProps.slots.row;
    const rowSlotProps = rootProps.slotProps?.row;
    const focusedVirtualCell = (0, $5sOMZ.useGridSelector)(apiRef, $98F89.gridFocusedVirtualCellSelector);
    // We need it to trigger a new render, but rowsMeta needs access to the latest value, hence we cannot pass it to the focusedVirtualCell callback in the virtualizer params
    (0, $lR3Vo.eslintUseValue)(focusedVirtualCell);
    const layout = (0, $59ee6250fa043d54$var$_useLazyRef.default)(()=>new $l8hgY.LayoutDataGridLegacy({
            container: apiRef.current.mainElementRef,
            scroller: apiRef.current.virtualScrollerRef,
            scrollbarVertical: apiRef.current.virtualScrollbarVerticalRef,
            scrollbarHorizontal: apiRef.current.virtualScrollbarHorizontalRef
        })).current;
    const virtualizer = (0, $l8hgY.useVirtualizer)({
        layout: layout,
        dimensions: dimensionsParams,
        virtualization: {
            isRtl: isRtl,
            rowBufferPx: rootProps.rowBufferPx,
            columnBufferPx: rootProps.columnBufferPx
        },
        colspan: {
            enabled: hasColSpan,
            getColspan: $59ee6250fa043d54$var$React.useCallback((rowId, column)=>{
                if (typeof column.colSpan === 'function') {
                    const row = apiRef.current.getRow(rowId);
                    const value = apiRef.current.getRowValue(row, column);
                    return column.colSpan(value, row, column, apiRef) ?? 0;
                }
                return column.colSpan ?? 1;
            }, [
                apiRef
            ])
        },
        initialState: {
            scroll: rootProps.initialState?.scroll,
            rowSpanning: apiRef.current.state.rowSpanning,
            virtualization: apiRef.current.state.virtualization
        },
        rows: currentPage.rows,
        range: currentPage.range,
        rowCount: rowCount,
        columns: visibleColumns,
        pinnedRows: pinnedRows,
        pinnedColumns: pinnedColumns,
        disableHorizontalScroll: listView,
        disableVerticalScroll: overlayState.overlayType === 'noColumnsOverlay' || overlayState.loadingOverlayVariant === 'skeleton',
        getRowHeight: $59ee6250fa043d54$var$React.useMemo(()=>{
            if (!getRowHeight) return undefined;
            return (rowEntry)=>getRowHeight((0, $59ee6250fa043d54$var$_extends2.default)({}, rowEntry, {
                    densityFactor: density
                }));
        }, [
            getRowHeight,
            density
        ]),
        getEstimatedRowHeight: $59ee6250fa043d54$var$React.useMemo(()=>getEstimatedRowHeight ? (rowEntry)=>getEstimatedRowHeight((0, $59ee6250fa043d54$var$_extends2.default)({}, rowEntry, {
                    densityFactor: density
                })) : undefined, [
            getEstimatedRowHeight,
            density
        ]),
        getRowSpacing: $59ee6250fa043d54$var$React.useMemo(()=>getRowSpacing ? (rowEntry)=>{
                const indexRelativeToCurrentPage = currentPage.rowIdToIndexMap.get(rowEntry.id) ?? -1;
                const visibility = {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage: indexRelativeToCurrentPage
                };
                return getRowSpacing((0, $59ee6250fa043d54$var$_extends2.default)({}, rowEntry, visibility, {
                    indexRelativeToCurrentPage: apiRef.current.getRowIndexRelativeToVisibleRows(rowEntry.id)
                }));
            } : undefined, [
            apiRef,
            getRowSpacing,
            currentPage.rows,
            currentPage.rowIdToIndexMap
        ]),
        applyRowHeight: (0, $59ee6250fa043d54$var$_useEventCallback.default)((entry, row)=>apiRef.current.unstable_applyPipeProcessors('rowHeight', entry, row)),
        virtualizeColumnsWithAutoRowHeight: rootProps.virtualizeColumnsWithAutoRowHeight,
        focusedVirtualCell: (0, $59ee6250fa043d54$var$_useEventCallback.default)(()=>(0, $98F89.gridFocusedVirtualCellSelector)(apiRef)),
        resizeThrottleMs: rootProps.resizeThrottleMs,
        onResize: (0, $59ee6250fa043d54$var$_useEventCallback.default)((size)=>apiRef.current.publishEvent('resize', size)),
        onWheel: (0, $59ee6250fa043d54$var$_useEventCallback.default)((event)=>{
            apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
        }),
        onTouchMove: (0, $59ee6250fa043d54$var$_useEventCallback.default)((event)=>{
            apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
        }),
        onRenderContextChange: (0, $59ee6250fa043d54$var$_useEventCallback.default)((nextRenderContext)=>{
            apiRef.current.publishEvent('renderedRowsIntervalChange', nextRenderContext);
        }),
        onScrollChange: $59ee6250fa043d54$var$React.useCallback((scrollPosition, nextRenderContext)=>{
            apiRef.current.publishEvent('scrollPositionChange', {
                top: scrollPosition.top,
                left: scrollPosition.left,
                renderContext: nextRenderContext
            });
        }, [
            apiRef
        ]),
        scrollReset: scrollReset,
        renderRow: $59ee6250fa043d54$var$React.useCallback((params)=>/*#__PURE__*/ (0, $ayMG0.jsx)(RowSlot, (0, $59ee6250fa043d54$var$_extends2.default)({
                row: params.model,
                rowId: params.id,
                index: params.rowIndex,
                selected: isRowSelected(params.id),
                offsetLeft: params.offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                rowHeight: params.baseRowHeight,
                pinnedColumns: pinnedColumns,
                visibleColumns: visibleColumns,
                firstColumnIndex: params.firstColumnIndex,
                lastColumnIndex: params.lastColumnIndex,
                focusedColumnIndex: params.focusedColumnIndex,
                isFirstVisible: params.isFirstVisible,
                isLastVisible: params.isLastVisible,
                isNotVisible: params.isVirtualFocusRow,
                showBottomBorder: params.showBottomBorder,
                scrollbarWidth: verticalScrollbarWidth,
                gridHasFiller: hasFiller
            }, rowSlotProps), params.id), [
            columnsTotalWidth,
            hasFiller,
            isRowSelected,
            pinnedColumns,
            RowSlot,
            rowSlotProps,
            verticalScrollbarWidth,
            visibleColumns
        ]),
        renderInfiniteLoadingTrigger: $59ee6250fa043d54$var$React.useCallback((id)=>apiRef.current.getInfiniteLoadingTriggerElement?.({
                lastRowId: id
            }), [
            apiRef
        ])
    });
    // HACK: Keep the grid's store in sync with the virtualizer store. We set up the
    // subscription in the render phase rather than in an effect because other grid
    // initialization code runs between those two moments.
    //
    // TODO(v9): Remove this
    (0, $bc8LN.useFirstRender)(()=>{
        apiRef.current.store.state.dimensions = addGridDimensions(virtualizer.store.state.dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight);
        apiRef.current.store.state.rowsMeta = virtualizer.store.state.rowsMeta;
        apiRef.current.store.state.virtualization = virtualizer.store.state.virtualization;
    });
    (0, $8P0MD.useStoreEffect)(virtualizer.store, $l8hgY.Dimensions.selectors.dimensions, (_, dimensions)=>{
        if (!dimensions.isReady) return;
        apiRef.current.setState((gridState)=>(0, $59ee6250fa043d54$var$_extends2.default)({}, gridState, {
                dimensions: addGridDimensions(dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight)
            }));
    });
    (0, $8P0MD.useStoreEffect)(virtualizer.store, $l8hgY.Dimensions.selectors.rowsMeta, (_, rowsMeta)=>{
        if (rowsMeta !== apiRef.current.state.rowsMeta) apiRef.current.setState((gridState)=>(0, $59ee6250fa043d54$var$_extends2.default)({}, gridState, {
                rowsMeta: rowsMeta
            }));
    });
    (0, $8P0MD.useStoreEffect)(virtualizer.store, $l8hgY.Virtualization.selectors.store, (_, virtualization)=>{
        if (virtualization.renderContext === $l8hgY.EMPTY_RENDER_CONTEXT) return;
        if (virtualization !== apiRef.current.state.virtualization) apiRef.current.setState((gridState)=>(0, $59ee6250fa043d54$var$_extends2.default)({}, gridState, {
                virtualization: virtualization
            }));
    });
    apiRef.current.register('private', {
        virtualizer: virtualizer
    });
    (0, $jBRsK.useGridRowsMeta)(apiRef, rootProps);
    return virtualizer;
}

});
parcelRegister("cvyxi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "lruMemoize", {
    enumerable: true,
    get: function() {
        return $4KtEQ.lruMemoize;
    }
});

var $4KtEQ = parcelRequire("4KtEQ");

});

parcelRegister("aJApm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridVisibleRows = module.exports.getVisibleRows = void 0;

var $gPWuj = parcelRequire("gPWuj");

var $5LeoO = parcelRequire("5LeoO");
const $7d0a5941a1add073$var$getVisibleRows = (apiRef, props)=>{
    return (0, $gPWuj.gridVisibleRowsSelector)(apiRef);
};
/**
 * Computes the list of rows that are reachable by scroll.
 * Depending on whether pagination is enabled, it will return the rows in the current page.
 * - If the pagination is disabled or in server mode, it equals all the visible rows.
 * - If the row tree has several layers, it contains up to `state.pageSize` top level rows and all their descendants.
 * - If the row tree is flat, it only contains up to `state.pageSize` rows.
 */ module.exports.getVisibleRows = $7d0a5941a1add073$var$getVisibleRows;
const $7d0a5941a1add073$var$useGridVisibleRows = (apiRef, props)=>{
    return (0, $5LeoO.useGridSelector)(apiRef, $gPWuj.gridVisibleRowsSelector);
};
module.exports.useGridVisibleRows = $7d0a5941a1add073$var$useGridVisibleRows;

});

parcelRegister("98F89", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a74c410c8e04714$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridFocusedVirtualCellSelector = void 0;

var $6a74c410c8e04714$var$_extends2 = $6a74c410c8e04714$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $cgQ4y = parcelRequire("cgQ4y");

var $jQEEt = parcelRequire("jQEEt");

var $9upDV = parcelRequire("9upDV");

var $fI50C = parcelRequire("fI50C");

var $b2EyI = parcelRequire("b2EyI");
const $6a74c410c8e04714$var$gridIsFocusedCellOutOfContext = (0, $cgQ4y.createSelector)($fI50C.gridFocusCellSelector, $9upDV.gridRenderContextSelector, $b2EyI.gridVisibleRowsSelector, $jQEEt.gridVisibleColumnDefinitionsSelector, (focusedCell, renderContext, currentPage, visibleColumns)=>{
    if (!focusedCell) return false;
    const rowIndex = currentPage.rowIdToIndexMap.get(focusedCell.id);
    const columnIndex = visibleColumns.slice(renderContext.firstColumnIndex, renderContext.lastColumnIndex).findIndex((column)=>column.field === focusedCell.field);
    const isInRenderContext = rowIndex !== undefined && columnIndex !== -1 && rowIndex >= renderContext.firstRowIndex && rowIndex <= renderContext.lastRowIndex;
    return !isInRenderContext;
});
const $6a74c410c8e04714$var$gridFocusedVirtualCellSelector = module.exports.gridFocusedVirtualCellSelector = (0, $cgQ4y.createSelectorMemoized)($6a74c410c8e04714$var$gridIsFocusedCellOutOfContext, $jQEEt.gridVisibleColumnDefinitionsSelector, $b2EyI.gridVisibleRowsSelector, $fI50C.gridFocusCellSelector, (isFocusedCellOutOfRenderContext, visibleColumns, currentPage, focusedCell)=>{
    if (!isFocusedCellOutOfRenderContext) return null;
    const rowIndex = currentPage.rowIdToIndexMap.get(focusedCell.id);
    if (rowIndex === undefined) return null;
    const columnIndex = visibleColumns.findIndex((column)=>column.field === focusedCell.field);
    if (columnIndex === -1) return null;
    return (0, $6a74c410c8e04714$var$_extends2.default)({}, focusedCell, {
        rowIndex: rowIndex,
        columnIndex: columnIndex
    });
});

});

parcelRegister("1kYRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DATA_GRID_PROPS_DEFAULT_VALUES = void 0;

var $jkRzp = parcelRequire("jkRzp");
/**
 * The default values of `DataGridPropsWithDefaultValues` to inject in the props of DataGrid.
 */ const $0f96df060f8ddda5$var$DATA_GRID_PROPS_DEFAULT_VALUES = module.exports.DATA_GRID_PROPS_DEFAULT_VALUES = {
    autoHeight: false,
    autoPageSize: false,
    autosizeOnMount: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    clipboardCopyCellDelimiter: '\t',
    columnBufferPx: 150,
    columnFilterDebounceMs: 150,
    columnHeaderHeight: 56,
    disableAutosize: false,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnReorder: false,
    disableColumnResize: false,
    disableColumnSelector: false,
    disableColumnSorting: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleColumnsSorting: false,
    disableMultipleRowSelection: false,
    dataSourceRevalidateMs: 0,
    disableRowSelectionOnClick: false,
    disableRowSelectionExcludeModel: false,
    disableVirtualization: false,
    editMode: $jkRzp.GridEditModes.Cell,
    filterDebounceMs: 150,
    filterMode: 'client',
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    ignoreValueFormatterDuringExport: false,
    keepColumnPositionIfDraggedOutside: false,
    keepNonExistentRowsSelected: false,
    loading: false,
    logger: console,
    logLevel: 'error',
    pageSizeOptions: [
        25,
        50,
        100
    ],
    pagination: false,
    paginationMode: 'client',
    resizeThrottleMs: 60,
    rowBufferPx: 150,
    rowHeight: 52,
    rows: [],
    rowSelection: true,
    rowSpacingType: 'margin',
    rowSpanning: false,
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    showToolbar: false,
    sortingMode: 'client',
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    throttleRowsMs: 0,
    virtualizeColumnsWithAutoRowHeight: false,
    tabNavigation: 'none'
};

});

parcelRegister("jBRsK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e46af192720967f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowsMeta = module.exports.rowsMetaStateInitializer = void 0;

var $e46af192720967f4$var$_extends2 = $e46af192720967f4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ivFej = parcelRequire("ivFej");

var $gPWuj = parcelRequire("gPWuj");

var $2hRnp = parcelRequire("2hRnp");

var $goCyd = parcelRequire("goCyd");

var $61HyH = parcelRequire("61HyH");
const $e46af192720967f4$var$rowsMetaStateInitializer = (state, props, apiRef)=>{
    // FIXME: This should be handled in the virtualizer eventually, but there are interdependencies
    // between state initializers that need to be untangled carefully.
    const baseRowHeight = (0, $61HyH.gridRowHeightSelector)(apiRef);
    const dataRowCount = (0, $goCyd.gridRowCountSelector)(apiRef);
    const pagination = (0, $gPWuj.gridPaginationSelector)(apiRef);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    return (0, $e46af192720967f4$var$_extends2.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: rowCount * baseRowHeight,
            positions: Array.from({
                length: rowCount
            }, (_, i)=>i * baseRowHeight),
            pinnedTopRowsTotalHeight: 0,
            pinnedBottomRowsTotalHeight: 0
        }
    });
};
/**
 * @requires useGridPageSize (method)
 * @requires useGridPage (method)
 */ module.exports.rowsMetaStateInitializer = $e46af192720967f4$var$rowsMetaStateInitializer;
const $e46af192720967f4$var$useGridRowsMeta = (apiRef, _props)=>{
    const virtualizer = apiRef.current.virtualizer;
    const { getRowHeight: getRowHeight, setLastMeasuredRowIndex: setLastMeasuredRowIndex, storeRowHeightMeasurement: storeRowHeightMeasurement, resetRowHeights: resetRowHeights, hydrateRowsMeta: hydrateRowsMeta, observeRowHeight: observeRowHeight, rowHasAutoHeight: rowHasAutoHeight, getRowHeightEntry: getRowHeightEntry, getLastMeasuredRowIndex: getLastMeasuredRowIndex } = virtualizer.api.rowsMeta;
    (0, $2hRnp.useGridRegisterPipeApplier)(apiRef, 'rowHeight', hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_getRowHeight: getRowHeight,
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_storeRowHeightMeasurement: storeRowHeightMeasurement,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex
    };
    (0, $ivFej.useGridApiMethod)(apiRef, rowsMetaApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowsMetaPrivateApi, 'private');
};
module.exports.useGridRowsMeta = $e46af192720967f4$var$useGridRowsMeta;

});
parcelRegister("2hRnp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9muTB = parcelRequire("9muTB");
Object.keys($9muTB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9muTB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9muTB[key];
        }
    });
});

var $c4Tvs = parcelRequire("c4Tvs");
Object.keys($c4Tvs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c4Tvs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c4Tvs[key];
        }
    });
});

var $2kdmP = parcelRequire("2kdmP");
Object.keys($2kdmP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2kdmP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2kdmP[key];
        }
    });
});

var $1xynw = parcelRequire("1xynw");
Object.keys($1xynw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1xynw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1xynw[key];
        }
    });
});

});
parcelRegister("9muTB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("c4Tvs", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8cb0ea30b515dc96$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8cb0ea30b515dc96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridPipeProcessing = void 0;

var $8cb0ea30b515dc96$var$_objectWithoutPropertiesLoose2 = $8cb0ea30b515dc96$require$_interopRequireDefault((parcelRequire("c05no")));

var $8cb0ea30b515dc96$var$_toPropertyKey2 = $8cb0ea30b515dc96$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $8cb0ea30b515dc96$var$React = $8cb0ea30b515dc96$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivFej = parcelRequire("ivFej");
/**
 * Implement the Pipeline Pattern
 *
 * More information and detailed example in (TODO add link to technical doc when ready)
 *
 * Some plugins contains custom logic to enrich data provided by other plugins or components.
 * For instance, the row grouping plugin needs to add / remove the grouping columns when the grid columns are updated.
 *
 * =====================================================================================================================
 *
 * The plugin containing the custom logic must use:
 *
 * - `useGridRegisterPipeProcessor` to register their processor.
 *
 * - `apiRef.current.requestPipeProcessorsApplication` to imperatively re-apply a group.
 *   This method should be used in last resort.
 *   Most of the time, the application should be triggered by an update on the deps of the processor.
 *
 * =====================================================================================================================
 *
 * The plugin or component that needs to enrich its data must use:
 *
 * - `apiRef.current.unstable_applyPipeProcessors` to run in chain all the processors of a given group.
 *
 * - `useGridRegisterPipeApplier` to re-apply the whole pipe when requested.
 *   The applier will be called when:
 *   * a processor is registered.
 *   * `apiRef.current.requestPipeProcessorsApplication` is called for the given group.
 */ const $8cb0ea30b515dc96$var$useGridPipeProcessing = (apiRef)=>{
    const cache = $8cb0ea30b515dc96$var$React.useRef({});
    const isRunning = $8cb0ea30b515dc96$var$React.useRef(false);
    const runAppliers = $8cb0ea30b515dc96$var$React.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $8cb0ea30b515dc96$var$React.useCallback((group, id, processor)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {},
            processorsUpdated: false
        };
        const groupCache = cache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            groupCache.processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
            groupCache.processorsUpdated = true;
        }
        return ()=>{
            cache.current[group].processors.set(id, null);
            cache.current[group].processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
        };
    }, []);
    const registerPipeApplier = $8cb0ea30b515dc96$var$React.useCallback((group, id, applier)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {},
            processorsUpdated: false
        };
        cache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = cache.current[group].appliers, otherAppliers = (0, $8cb0ea30b515dc96$var$_objectWithoutPropertiesLoose2.default)(_appliers, [
                id
            ].map($8cb0ea30b515dc96$var$_toPropertyKey2.default));
            cache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $8cb0ea30b515dc96$var$React.useCallback((group)=>{
        runAppliers(cache.current[group]);
    }, [
        runAppliers
    ]);
    const runAppliersForPendingProcessors = $8cb0ea30b515dc96$var$React.useCallback(()=>{
        for(const group in cache.current){
            if (!Object.prototype.hasOwnProperty.call(cache.current, group)) continue;
            const groupCache = cache.current[group];
            if (groupCache.processorsUpdated) {
                groupCache.processorsUpdated = false;
                runAppliers(groupCache);
            }
        }
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $8cb0ea30b515dc96$var$React.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!cache.current[group]) return value;
        const processors = cache.current[group].processorsAsArray;
        let result = value;
        for(let i = 0; i < processors.length; i += 1)result = processors[i](result, context);
        return result;
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication,
        runAppliersForPendingProcessors: runAppliersForPendingProcessors
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $ivFej.useGridApiMethod)(apiRef, preProcessingPrivateApi, 'private');
    (0, $ivFej.useGridApiMethod)(apiRef, preProcessingPublicApi, 'public');
};
module.exports.useGridPipeProcessing = $8cb0ea30b515dc96$var$useGridPipeProcessing;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("2kdmP", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $1b17d17d1651bc2f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRegisterPipeProcessor = void 0;

var $1b17d17d1651bc2f$var$React = $1b17d17d1651bc2f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bc8LN = parcelRequire("bc8LN");
const $1b17d17d1651bc2f$var$useGridRegisterPipeProcessor = (apiRef, group, callback, enabled = true)=>{
    const cleanup = $1b17d17d1651bc2f$var$React.useRef(null);
    const id = $1b17d17d1651bc2f$var$React.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $1b17d17d1651bc2f$var$React.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        if (enabled) registerPreProcessor();
    });
    const isFirstRender = $1b17d17d1651bc2f$var$React.useRef(true);
    $1b17d17d1651bc2f$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else if (enabled) registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor,
        enabled
    ]);
};
module.exports.useGridRegisterPipeProcessor = $1b17d17d1651bc2f$var$useGridRegisterPipeProcessor;

});

parcelRegister("1xynw", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $11f38a5cdcd4928d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRegisterPipeApplier = void 0;

var $11f38a5cdcd4928d$var$React = $11f38a5cdcd4928d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bc8LN = parcelRequire("bc8LN");
const $11f38a5cdcd4928d$var$useGridRegisterPipeApplier = (apiRef, group, callback)=>{
    const cleanup = $11f38a5cdcd4928d$var$React.useRef(null);
    const id = $11f38a5cdcd4928d$var$React.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $11f38a5cdcd4928d$var$React.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $11f38a5cdcd4928d$var$React.useRef(true);
    $11f38a5cdcd4928d$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};
module.exports.useGridRegisterPipeApplier = $11f38a5cdcd4928d$var$useGridRegisterPipeApplier;

});






parcelRegister("ew3Bl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a916d8fa7c7fb6bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFooterPlaceholder = $a916d8fa7c7fb6bb$var$GridFooterPlaceholder;

var $a916d8fa7c7fb6bb$var$_extends2 = $a916d8fa7c7fb6bb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $a916d8fa7c7fb6bb$var$GridFooterPlaceholder() {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footer, (0, $a916d8fa7c7fb6bb$var$_extends2.default)({}, rootProps.slotProps?.footer /* FIXME: typing error */ ));
}

});


parcelRegister("721t2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $51e9dbb1a242f696$var$_exportNames = {
    GridCell: true
};
Object.defineProperty(module.exports, "GridCell", {
    enumerable: true,
    get: function() {
        return $6X2NG.GridCell;
    }
});

var $6X2NG = parcelRequire("6X2NG");

var $8vJu2 = parcelRequire("8vJu2");
Object.keys($8vJu2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8vJu2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8vJu2[key];
        }
    });
});

var $hsZ0E = parcelRequire("hsZ0E");
Object.keys($hsZ0E).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hsZ0E[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hsZ0E[key];
        }
    });
});

var $3D30W = parcelRequire("3D30W");
Object.keys($3D30W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3D30W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3D30W[key];
        }
    });
});

var $4QDBh = parcelRequire("4QDBh");
Object.keys($4QDBh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4QDBh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4QDBh[key];
        }
    });
});

var $7cMVI = parcelRequire("7cMVI");
Object.keys($7cMVI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7cMVI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7cMVI[key];
        }
    });
});

var $cc312 = parcelRequire("cc312");
Object.keys($cc312).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cc312[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cc312[key];
        }
    });
});

var $7vSxY = parcelRequire("7vSxY");
Object.keys($7vSxY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7vSxY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7vSxY[key];
        }
    });
});

var $etLiE = parcelRequire("etLiE");
Object.keys($etLiE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $etLiE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $etLiE[key];
        }
    });
});

var $7CNB5 = parcelRequire("7CNB5");
Object.keys($7CNB5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7CNB5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7CNB5[key];
        }
    });
});

var $vPZmP = parcelRequire("vPZmP");
Object.keys($vPZmP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($51e9dbb1a242f696$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $vPZmP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $vPZmP[key];
        }
    });
});

});
parcelRegister("6X2NG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $50fa6cd6ff946acb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $50fa6cd6ff946acb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridPinnedColumnPositionLookup = module.exports.GridCell = void 0;

var $50fa6cd6ff946acb$var$_extends2 = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $50fa6cd6ff946acb$var$_objectWithoutPropertiesLoose2 = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("c05no")));

var $50fa6cd6ff946acb$var$React = $50fa6cd6ff946acb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $50fa6cd6ff946acb$var$_propTypes = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $50fa6cd6ff946acb$var$_clsx = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $50fa6cd6ff946acb$var$_useForkRef = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $50fa6cd6ff946acb$var$_composeClasses = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $50fa6cd6ff946acb$var$_ownerDocument = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("43fuO")));

var $50fa6cd6ff946acb$var$_capitalize = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("4O6za")));

var $2nKmT = parcelRequire("2nKmT");

var $9uEev = parcelRequire("9uEev");

var $fYxgT = parcelRequire("fYxgT");

var $8P0MD = parcelRequire("8P0MD");

var $l8hgY = parcelRequire("l8hgY");

var $50fa6cd6ff946acb$var$_useEnhancedEffect = $50fa6cd6ff946acb$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $g2vKb = parcelRequire("g2vKb");

var $5H1vo = parcelRequire("5H1vo");

var $42Qr7 = parcelRequire("42Qr7");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $drCmI = parcelRequire("drCmI");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $jZka4 = parcelRequire("jZka4");

var $er55f = parcelRequire("er55f");

var $5Rfo7 = parcelRequire("5Rfo7");

var $94sAG = parcelRequire("94sAG");

var $3J8MS = parcelRequire("3J8MS");

var $ayMG0 = parcelRequire("ayMG0");
const $50fa6cd6ff946acb$var$_excluded = [
    "column",
    "row",
    "rowId",
    "rowNode",
    "align",
    "children",
    "colIndex",
    "width",
    "className",
    "style",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "pinnedOffset",
    "pinnedPosition",
    "showRightBorder",
    "showLeftBorder",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $50fa6cd6ff946acb$var$_excluded2 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $50fa6cd6ff946acb$var$gridPinnedColumnPositionLookup = module.exports.gridPinnedColumnPositionLookup = {
    [$jZka4.PinnedColumnPosition.LEFT]: $4ZMWQ.GridPinnedColumnPosition.LEFT,
    [$jZka4.PinnedColumnPosition.RIGHT]: $4ZMWQ.GridPinnedColumnPosition.RIGHT,
    [$jZka4.PinnedColumnPosition.NONE]: undefined,
    [$jZka4.PinnedColumnPosition.VIRTUAL]: undefined
};
const $50fa6cd6ff946acb$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $50fa6cd6ff946acb$var$_capitalize.default)(align)}`,
            isSelected && 'selected',
            isEditable && 'cell--editable',
            showLeftBorder && 'cell--withLeftBorder',
            showRightBorder && 'cell--withRightBorder',
            pinnedPosition === $jZka4.PinnedColumnPosition.LEFT && 'cell--pinnedLeft',
            pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT && 'cell--pinnedRight',
            isSelectionMode && !isEditable && 'cell--selectionMode'
        ]
    };
    return (0, $50fa6cd6ff946acb$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
let $50fa6cd6ff946acb$var$warnedOnce = false;
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $50fa6cd6ff946acb$var$GridCell = (0, $fYxgT.forwardRef)(function GridCell(props, ref) {
    const { column: column, row: row, rowId: rowId, rowNode: rowNode, align: align, colIndex: colIndex, width: width, className: className, style: styleProp, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, pinnedOffset: pinnedOffset, pinnedPosition: pinnedPosition, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $50fa6cd6ff946acb$var$_objectWithoutPropertiesLoose2.default)(props, $50fa6cd6ff946acb$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const field = column.field;
    const editCellState = (0, $5sOMZ.useGridSelector)(apiRef, $5Rfo7.gridEditCellStateSelector, {
        rowId: rowId,
        field: field
    });
    const config = (0, $3J8MS.useGridConfiguration)();
    const cellAggregationResult = config.hooks.useCellAggregationResult(rowId, field);
    const cellMode = editCellState ? $42Qr7.GridCellModes.Edit : $42Qr7.GridCellModes.View;
    const { value: forcedValue, formattedValue: forcedFormattedValue } = cellAggregationResult || {};
    const cellParams = apiRef.current.getCellParamsForRow(rowId, field, row, {
        colDef: column,
        cellMode: cellMode,
        rowNode: rowNode,
        tabIndex: (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
            const cellTabIndex = (0, $drCmI.gridTabIndexCellSelector)(apiRef);
            return cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === rowId ? 0 : -1;
        }),
        hasFocus: (0, $5sOMZ.useGridSelector)(apiRef, ()=>{
            const focus = (0, $drCmI.gridFocusCellSelector)(apiRef);
            return focus?.id === rowId && focus.field === field;
        }),
        value: forcedValue,
        formattedValue: forcedFormattedValue
    });
    cellParams.api = apiRef.current;
    // Subscribe to changes of the `isCellEditable` API result to ensure cells re-render.
    // We don't use the result.
    // Subscription will trigger a new call of `getCellParamsForRow` above which will recompute the correct value of `isEditable`.
    // This is to ensure both of the following cases work:
    // - https://github.com/mui/mui-x/issues/19732
    // - https://github.com/mui/mui-x/issues/20143
    (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.isCellEditable(cellParams));
    const isSelected = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const store = apiRef.current.virtualizer.store;
    const hiddenCells = (0, $8P0MD.useStore)(store, $l8hgY.Rowspan.selectors.hiddenCells);
    const spannedCells = (0, $8P0MD.useStore)(store, $l8hgY.Rowspan.selectors.spannedCells);
    const { hasFocus: hasFocus, isEditable: isEditable = false, value: value } = cellParams;
    const tabIndex = (cellMode === 'view' || !isEditable) && column.type !== 'actions' ? cellParams.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    // There is a hidden grid state access in `applyPipeProcessor('cellClassName', ...)`
    const pipesClassName = (0, $5sOMZ.useGridSelector)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
            id: rowId,
            field: field
        }).filter(Boolean).join(' '));
    const classNames = [
        pipesClassName
    ];
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParams) : column.cellClassName);
    if (column.display === 'flex') classNames.push($5H1vo.gridClasses['cell--flex']);
    if (getCellClassName) classNames.push(getCellClassName(cellParams));
    const valueToRender = cellParams.formattedValue ?? value;
    const cellRef = $50fa6cd6ff946acb$var$React.useRef(null);
    const handleRef = (0, $50fa6cd6ff946acb$var$_useForkRef.default)(ref, cellRef);
    const isSelectionMode = rootProps.cellSelection ?? false;
    const ownerState = {
        align: align,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        pinnedPosition: pinnedPosition,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $50fa6cd6ff946acb$var$useUtilityClasses(ownerState);
    const publishMouseUp = $50fa6cd6ff946acb$var$React.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $50fa6cd6ff946acb$var$React.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $50fa6cd6ff946acb$var$React.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const isCellRowSpanned = hiddenCells[rowId]?.[colIndex] ?? false;
    const rowSpan = spannedCells[rowId]?.[colIndex] ?? 1;
    const style = $50fa6cd6ff946acb$var$React.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            height: 0,
            border: 0
        };
        const cellStyle = (0, $94sAG.attachPinnedStyle)((0, $50fa6cd6ff946acb$var$_extends2.default)({
            '--width': `${width}px`
        }, styleProp), isRtl, pinnedPosition, pinnedOffset);
        const isLeftPinned = pinnedPosition === $jZka4.PinnedColumnPosition.LEFT;
        const isRightPinned = pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT;
        if (rowSpan > 1) {
            cellStyle.height = `calc(var(--height) * ${rowSpan})`;
            cellStyle.zIndex = 10;
            if (isLeftPinned || isRightPinned) cellStyle.zIndex = 40;
        }
        return cellStyle;
    }, [
        width,
        isNotVisible,
        styleProp,
        pinnedOffset,
        pinnedPosition,
        isRtl,
        rowSpan
    ]);
    (0, $50fa6cd6ff946acb$var$_useEnhancedEffect.default)(()=>{
        if (!hasFocus || cellMode === $42Qr7.GridCellModes.Edit) return;
        const doc = (0, $50fa6cd6ff946acb$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || cellRef.current;
            if ((0, $g2vKb.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (isCellRowSpanned) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-colindex": colIndex,
        role: "presentation",
        style: (0, $50fa6cd6ff946acb$var$_extends2.default)({
            width: 'var(--width)'
        }, style)
    });
    let handleFocus = other.onFocus;
    var event;
    let children;
    let title;
    if (editCellState === null && column.renderCell) children = column.renderCell(cellParams);
    if (editCellState !== null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $50fa6cd6ff946acb$var$_objectWithoutPropertiesLoose2.default)(editCellState, $50fa6cd6ff946acb$var$_excluded2);
        const formattedValue = column.valueFormatter ? column.valueFormatter(editCellState.value, updatedRow, column, apiRef) : cellParams.formattedValue;
        const params = (0, $50fa6cd6ff946acb$var$_extends2.default)({}, cellParams, {
            row: updatedRow,
            formattedValue: formattedValue
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push($5H1vo.gridClasses['cell--editing']);
        classNames.push(rootClasses?.['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender?.toString();
        children = valueString;
        title = valueString;
    }
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $50fa6cd6ff946acb$var$_extends2.default)({
        className: (0, $50fa6cd6ff946acb$var$_clsx.default)(classes.root, classNames, className),
        role: "gridcell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        "aria-rowspan": rowSpan,
        style: style,
        title: title,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        ref: handleRef,
        children: children
    }));
});
const $50fa6cd6ff946acb$var$MemoizedGridCell = module.exports.GridCell = (0, $2nKmT.fastMemo)($50fa6cd6ff946acb$var$GridCell);

});
parcelRegister("g2vKb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesSupportPreventScroll = $bad574edb71acea7$var$doesSupportPreventScroll;
// Based on https://stackoverflow.com/a/59518678
let $bad574edb71acea7$var$cachedSupportsPreventScroll;
function $bad574edb71acea7$var$doesSupportPreventScroll() {
    if ($bad574edb71acea7$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $bad574edb71acea7$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $bad574edb71acea7$var$cachedSupportsPreventScroll;
}

});

parcelRegister("94sAG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4Yqqs = parcelRequire("4Yqqs");
Object.keys($4Yqqs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4Yqqs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Yqqs[key];
        }
    });
});

var $dSN1H = parcelRequire("dSN1H");
Object.keys($dSN1H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dSN1H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dSN1H[key];
        }
    });
});

var $gRn8b = parcelRequire("gRn8b");
Object.keys($gRn8b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gRn8b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gRn8b[key];
        }
    });
});

var $kpwEY = parcelRequire("kpwEY");
Object.keys($kpwEY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kpwEY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kpwEY[key];
        }
    });
});

var $7Vdaf = parcelRequire("7Vdaf");
Object.keys($7Vdaf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Vdaf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7Vdaf[key];
        }
    });
});

});
parcelRegister("4Yqqs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $39f1439fa7b8d5d4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeSlots = $39f1439fa7b8d5d4$var$computeSlots;

var $39f1439fa7b8d5d4$var$_extends2 = $39f1439fa7b8d5d4$require$_interopRequireDefault((parcelRequire("3p9rK")));
function $39f1439fa7b8d5d4$var$computeSlots({ defaultSlots: defaultSlots, slots: slots }) {
    const overrides = slots;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $39f1439fa7b8d5d4$var$_extends2.default)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}

});

parcelRegister("dSN1H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.propValidatorsDataGrid = void 0;
module.exports.validateProps = $a1b65922f847acc6$var$validateProps;

var $9Y8Cp = parcelRequire("9Y8Cp");

var $lR3Vo = parcelRequire("lR3Vo");

var $iVTh1 = parcelRequire("iVTh1");
const $a1b65922f847acc6$var$propValidatorsDataGrid = module.exports.propValidatorsDataGrid = [
    (props)=>props.autoPageSize && props.autoHeight && [
            'MUI X: `<DataGrid autoPageSize={true} autoHeight={true} />` are not valid props.',
            'You cannot use both the `autoPageSize` and `autoHeight` props at the same time because `autoHeight` scales the height of the Data Grid according to the `pageSize`.',
            '',
            'Please remove one of these two props.'
        ].join('\n') || undefined,
    (props)=>props.paginationMode === 'client' && props.paginationMeta != null && [
            'MUI X: Usage of the `paginationMeta` prop with client-side pagination (`paginationMode="client"`) has no effect.',
            '`paginationMeta` is only meant to be used with `paginationMode="server"`.'
        ].join('\n') || undefined,
    (props)=>props.signature === $iVTh1.GridSignature.DataGrid && props.paginationMode === 'client' && (0, $lR3Vo.isNumber)(props.rowCount) && [
            'MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect.',
            '`rowCount` is only meant to be used with `paginationMode="server"`.'
        ].join('\n') || undefined,
    (props)=>props.paginationMode === 'server' && props.rowCount == null && !props.dataSource && [
            "MUI X: The `rowCount` prop must be passed using `paginationMode='server'`",
            'For more detail, see http://mui.com/components/data-grid/pagination/#index-based-pagination'
        ].join('\n') || undefined
];
function $a1b65922f847acc6$var$validateProps(props, validators) {
    validators.forEach((validator)=>{
        const message = validator(props);
        if (message) (0, $9Y8Cp.warnOnce)(message, 'error');
    });
}

});

parcelRegister("gRn8b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isGroupingColumn = module.exports.getRowGroupingCriteriaFromGroupingField = void 0;

var $jZka4 = parcelRequire("jZka4");
const $c46389eb8540b1dc$var$getRowGroupingCriteriaFromGroupingField = (groupingColDefField)=>{
    const match = groupingColDefField.match(/^__row_group_by_columns_group_(.*)__$/);
    if (!match) return null;
    return match[1];
};
module.exports.getRowGroupingCriteriaFromGroupingField = $c46389eb8540b1dc$var$getRowGroupingCriteriaFromGroupingField;
const $c46389eb8540b1dc$var$isGroupingColumn = (field)=>field === $jZka4.GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD || $c46389eb8540b1dc$var$getRowGroupingCriteriaFromGroupingField(field) !== null;
module.exports.isGroupingColumn = $c46389eb8540b1dc$var$isGroupingColumn;

});

parcelRegister("kpwEY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attachPinnedStyle = $edbf7a081e32bed0$var$attachPinnedStyle;

var $eV2As = parcelRequire("eV2As");
function $edbf7a081e32bed0$var$attachPinnedStyle(style, isRtl, pinnedPosition, pinnedOffset) {
    const side = (0, $eV2As.rtlFlipSide)(pinnedPosition, isRtl);
    if (!side || pinnedOffset === undefined) return style;
    style[side] = pinnedOffset;
    return style;
}

});
parcelRegister("eV2As", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rtlFlipSide = void 0;

var $jZka4 = parcelRequire("jZka4");
const $02cd8e055a355186$var$rtlFlipSide = (position, isRtl)=>{
    if (!position) return undefined;
    if (!isRtl) {
        if (position === $jZka4.PinnedColumnPosition.LEFT) return 'left';
        if (position === $jZka4.PinnedColumnPosition.RIGHT) return 'right';
    } else {
        if (position === $jZka4.PinnedColumnPosition.LEFT) return 'right';
        if (position === $jZka4.PinnedColumnPosition.RIGHT) return 'left';
    }
    return undefined;
};
module.exports.rtlFlipSide = $02cd8e055a355186$var$rtlFlipSide;

});


parcelRegister("7Vdaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TestCache = void 0;

var $7eBdF = parcelRequire("7eBdF");
class $5c48116f72f2a548$var$TestCache {
    constructor(){
        this.cache = new Map();
    }
    set(key, value) {
        this.cache.set((0, $7eBdF.getKeyDefault)(key), value);
    }
    get(key) {
        return this.cache.get((0, $7eBdF.getKeyDefault)(key));
    }
    size() {
        return this.cache.size;
    }
    clear() {
        this.cache.clear();
    }
}
module.exports.TestCache = $5c48116f72f2a548$var$TestCache;

});



parcelRegister("etLiE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8a876e822978977$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a8a876e822978977$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridSkeletonCell = void 0;

var $a8a876e822978977$var$_extends2 = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a8a876e822978977$var$_objectWithoutPropertiesLoose2 = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("c05no")));

var $a8a876e822978977$var$React = $a8a876e822978977$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a8a876e822978977$var$_propTypes = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a8a876e822978977$var$_clsx = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a8a876e822978977$var$_composeClasses = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a8a876e822978977$var$_capitalize = $a8a876e822978977$require$_interopRequireDefault((parcelRequire("4O6za")));

var $2nKmT = parcelRequire("2nKmT");

var $lR3Vo = parcelRequire("lR3Vo");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $a8a876e822978977$var$_excluded = [
    "field",
    "type",
    "align",
    "width",
    "height",
    "empty",
    "style",
    "className"
];
const $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE = '1.3em';
const $a8a876e822978977$var$CONTENT_HEIGHT = '1.2em';
const $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE = [
    40,
    80
];
const $a8a876e822978977$var$CONTENT_WIDTH_RANGE_BY_TYPE = {
    number: [
        40,
        60
    ],
    string: [
        40,
        80
    ],
    date: [
        40,
        60
    ],
    dateTime: [
        60,
        80
    ],
    singleSelect: [
        40,
        80
    ]
};
const $a8a876e822978977$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes, empty: empty } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${align ? (0, $a8a876e822978977$var$_capitalize.default)(align) : 'Left'}`,
            empty && 'cellEmpty'
        ]
    };
    return (0, $a8a876e822978977$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $a8a876e822978977$var$randomNumberGenerator = (0, $lR3Vo.createRandomNumberGenerator)(12345);
function $a8a876e822978977$var$GridSkeletonCell(props) {
    const { field: field, type: type, align: align, width: width, height: height, empty: empty = false, style: style, className: className } = props, other = (0, $a8a876e822978977$var$_objectWithoutPropertiesLoose2.default)(props, $a8a876e822978977$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        align: align,
        empty: empty
    };
    const classes = $a8a876e822978977$var$useUtilityClasses(ownerState);
    // Memo prevents the non-circular skeleton widths changing to random widths on every render
    const skeletonProps = $a8a876e822978977$var$React.useMemo(()=>{
        const isCircularContent = type === 'boolean' || type === 'actions';
        if (isCircularContent) return {
            variant: 'circular',
            width: $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE,
            height: $a8a876e822978977$var$CIRCULAR_CONTENT_SIZE
        };
        // The width of the skeleton is a random number between the min and max values
        // The min and max values are determined by the type of the column
        const [min, max] = type ? $a8a876e822978977$var$CONTENT_WIDTH_RANGE_BY_TYPE[type] ?? $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE : $a8a876e822978977$var$DEFAULT_CONTENT_WIDTH_RANGE;
        return {
            variant: 'text',
            width: `${Math.round($a8a876e822978977$var$randomNumberGenerator(min, max))}%`,
            height: $a8a876e822978977$var$CONTENT_HEIGHT
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $a8a876e822978977$var$_extends2.default)({
        "data-field": field,
        className: (0, $a8a876e822978977$var$_clsx.default)(classes.root, className),
        style: (0, $a8a876e822978977$var$_extends2.default)({
            height: height,
            maxWidth: width,
            minWidth: width
        }, style)
    }, other, {
        children: !empty && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseSkeleton, (0, $a8a876e822978977$var$_extends2.default)({}, skeletonProps))
    }));
}
const $a8a876e822978977$var$Memoized = module.exports.GridSkeletonCell = (0, $2nKmT.fastMemo)($a8a876e822978977$var$GridSkeletonCell);

});


parcelRegister("l5ITy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9PaJs = parcelRequire("9PaJs");
Object.keys($9PaJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9PaJs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9PaJs[key];
        }
    });
});

var $jgcq7 = parcelRequire("jgcq7");
Object.keys($jgcq7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jgcq7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jgcq7[key];
        }
    });
});

var $809Ep = parcelRequire("809Ep");
Object.keys($809Ep).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $809Ep[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $809Ep[key];
        }
    });
});

var $02G4S = parcelRequire("02G4S");
Object.keys($02G4S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $02G4S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $02G4S[key];
        }
    });
});

});
parcelRegister("9PaJs", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $727133a3c635b8ae$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $727133a3c635b8ae$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRoot = void 0;

var $727133a3c635b8ae$var$_extends2 = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $727133a3c635b8ae$var$_objectWithoutPropertiesLoose2 = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("c05no")));

var $727133a3c635b8ae$var$React = $727133a3c635b8ae$require$_interopRequireWildcard((parcelRequire("acw62")));

var $727133a3c635b8ae$var$_propTypes = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $727133a3c635b8ae$var$_clsx = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("9QePP")));

var $727133a3c635b8ae$var$_useForkRef = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $727133a3c635b8ae$var$_capitalize = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("4O6za")));

var $727133a3c635b8ae$var$_composeClasses = $727133a3c635b8ae$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2nKmT = parcelRequire("2nKmT");

var $fYxgT = parcelRequire("fYxgT");

var $aOz2q = parcelRequire("aOz2q");

var $3DWC3 = parcelRequire("3DWC3");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $fD9f4 = parcelRequire("fD9f4");

var $bX8Ys = parcelRequire("bX8Ys");

var $hHwPs = parcelRequire("hHwPs");

var $kjNGZ = parcelRequire("kjNGZ");

var $ayMG0 = parcelRequire("ayMG0");
const $727133a3c635b8ae$var$_excluded = [
    "className",
    "children",
    "sidePanel"
];
const $727133a3c635b8ae$var$useUtilityClasses = (ownerState, density)=>{
    const { autoHeight: autoHeight, classes: classes, showCellVerticalBorder: showCellVerticalBorder } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $727133a3c635b8ae$var$_capitalize.default)(density)}`,
            ownerState.slots.toolbar === null && 'root--noToolbar',
            'withBorderColor',
            showCellVerticalBorder && 'withVerticalBorder'
        ]
    };
    return (0, $727133a3c635b8ae$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $727133a3c635b8ae$var$GridRoot = (0, $fYxgT.forwardRef)(function GridRoot(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { className: className, children: children, sidePanel: sidePanel } = props, other = (0, $727133a3c635b8ae$var$_objectWithoutPropertiesLoose2.default)(props, $727133a3c635b8ae$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const density = (0, $5sOMZ.useGridSelector)(apiRef, $fD9f4.gridDensitySelector);
    const rootElementRef = apiRef.current.rootElementRef;
    const rootMountCallback = $727133a3c635b8ae$var$React.useCallback((node)=>{
        if (node === null) return;
        apiRef.current.publishEvent('rootMount', node);
    }, [
        apiRef
    ]);
    const handleRef = (0, $727133a3c635b8ae$var$_useForkRef.default)(rootElementRef, ref, rootMountCallback);
    const ownerState = rootProps;
    const classes = $727133a3c635b8ae$var$useUtilityClasses(ownerState, density);
    const cssVariables = (0, $3DWC3.useCSSVariablesContext)();
    const isSSR = (0, $bX8Ys.useIsSSR)();
    if (isSSR) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($aOz2q.GridRootStyles, (0, $727133a3c635b8ae$var$_extends2.default)({
        className: (0, $727133a3c635b8ae$var$_clsx.default)(classes.root, className, cssVariables.className, sidePanel && $5H1vo.gridClasses.withSidePanel),
        ownerState: ownerState
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: $5H1vo.gridClasses.mainContent,
                role: "presentation",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($hHwPs.GridHeader, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($kjNGZ.GridBody, {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($kjNGZ.GridFooterPlaceholder, {})
                ]
            }),
            sidePanel,
            cssVariables.tag
        ]
    }));
});
const $727133a3c635b8ae$var$MemoizedGridRoot = module.exports.GridRoot = (0, $2nKmT.fastMemo)($727133a3c635b8ae$var$GridRoot);

});
parcelRegister("aOz2q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsColorMix = module.exports.colorMixIfSupported = module.exports.GridRootStyles = void 0;

var $8xDHs = parcelRequire("8xDHs");

var $5H1vo = parcelRequire("5H1vo");

var $hbuUJ = parcelRequire("hbuUJ");

var $5sOMZ = parcelRequire("5sOMZ");

var $er55f = parcelRequire("er55f");
const $7df9c0c298ff1f9f$var$columnSeparatorTargetSize = 10;
const $7df9c0c298ff1f9f$var$columnSeparatorOffset = -5;
const $7df9c0c298ff1f9f$var$focusOutlineWidth = 1;
const $7df9c0c298ff1f9f$var$separatorIconDragStyles = {
    width: 3,
    rx: 1.5,
    x: 10.5
};
// Emotion thinks it knows better than us which selector we should use.
// https://github.com/emotion-js/emotion/issues/1105#issuecomment-1722524968
const $7df9c0c298ff1f9f$var$ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
const $7df9c0c298ff1f9f$var$shouldShowBorderTopRightRadiusSelector = (apiRef)=>!apiRef.current.state.dimensions.isReady ? apiRef.current.state.dimensions.scrollbarSize === 0 : apiRef.current.state.dimensions.hasScrollX && (!apiRef.current.state.dimensions.hasScrollY || apiRef.current.state.dimensions.scrollbarSize === 0);
const $7df9c0c298ff1f9f$var$elementOverrides = {
    root: [
        'autoHeight',
        'autosizing',
        'root--densityStandard',
        'root--densityComfortable',
        'root--densityCompact',
        'root--disableUserSelection',
        'root--noToolbar',
        'withVerticalBorder'
    ],
    children: [
        'actionsCell',
        'booleanCell',
        'cell',
        'cell--editable',
        'cell--editing',
        'cell--flex',
        'cell--pinnedLeft',
        'cell--pinnedRight',
        'cell--rangeBottom',
        'cell--rangeLeft',
        'cell--rangeRight',
        'cell--rangeTop',
        'cell--selectionMode',
        'cell--textCenter',
        'cell--textLeft',
        'cell--textRight',
        'cell--withLeftBorder',
        'cell--withRightBorder',
        'cellCheckbox',
        'cellEmpty',
        'cellOffsetLeft',
        'cellSkeleton',
        'checkboxInput',
        'columnHeader',
        'columnHeader--alignCenter',
        'columnHeader--alignLeft',
        'columnHeader--alignRight',
        'columnHeader--dragging',
        'columnHeader--emptyGroup',
        'columnHeader--filledGroup',
        'columnHeader--filtered',
        'columnHeader--last',
        'columnHeader--moving',
        'columnHeader--numeric',
        'columnHeader--pinnedLeft',
        'columnHeader--pinnedRight',
        'columnHeader--siblingFocused',
        'columnHeader--sortable',
        'columnHeader--sorted',
        'columnHeader--withLeftBorder',
        'columnHeader--withRightBorder',
        'columnHeaderCheckbox',
        'columnHeaderDraggableContainer',
        'columnHeaderTitleContainer',
        'columnHeaderTitleContainerContent',
        'columnSeparator',
        'columnSeparator--resizable',
        'columnSeparator--resizing',
        'columnSeparator--sideLeft',
        'columnSeparator--sideRight',
        'container--bottom',
        'container--top',
        'detailPanelToggleCell',
        'detailPanelToggleCell--expanded',
        'editBooleanCell',
        'filterIcon',
        'filler--borderBottom',
        'filler--pinnedLeft',
        'filler--pinnedRight',
        'groupingCriteriaCell',
        'groupingCriteriaCellLoadingContainer',
        'groupingCriteriaCellToggle',
        'headerFilterRow',
        'iconSeparator',
        'menuIcon',
        'menuIconButton',
        'menuList',
        'menuOpen',
        'overlayWrapperInner',
        'pinnedRows',
        'pinnedRows--bottom',
        'pinnedRows--top',
        'row',
        'row--borderBottom',
        'row--detailPanelExpanded',
        'row--dragging',
        'row--dynamicHeight',
        'row--editable',
        'row--editing',
        'row--firstVisible',
        'row--lastVisible',
        'rowReorderCell',
        'rowReorderCell--draggable',
        'rowReorderCellContainer',
        'rowReorderCellPlaceholder',
        'rowSkeleton',
        'scrollbar',
        'scrollbar--horizontal',
        'scrollbar--vertical',
        'scrollbarFiller',
        'scrollbarFiller--pinnedRight',
        'sortIcon',
        'treeDataGroupingCell',
        'treeDataGroupingCellLoadingContainer',
        'treeDataGroupingCellToggle',
        'withBorderColor',
        'row--beingDragged'
    ]
};
const $7df9c0c298ff1f9f$var$GridRootStyles = module.exports.GridRootStyles = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        // Root overrides
        const overrides = [
            styles.root
        ];
        $7df9c0c298ff1f9f$var$elementOverrides.root.forEach((key)=>{
            overrides.push({
                [`&.${$5H1vo.gridClasses[key]}`]: styles[key]
            });
        });
        // Child element overrides
        // - Only declare overrides here for class names that are not applied to `styled` components.
        // - For `styled` components, declare overrides in the component itself.
        $7df9c0c298ff1f9f$var$elementOverrides.children.forEach((key)=>{
            overrides.push({
                [`& .${$5H1vo.gridClasses[key]}`]: styles[key]
            });
        });
        return overrides;
    }
})(()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const shouldShowBorderTopRightRadius = (0, $5sOMZ.useGridSelector)(apiRef, $7df9c0c298ff1f9f$var$shouldShowBorderTopRightRadiusSelector);
    const baseBackground = $hbuUJ.vars.colors.background.base;
    const headerBackground = $hbuUJ.vars.header.background.base;
    const pinnedBackground = $hbuUJ.vars.cell.background.pinned;
    const hoverColor = $7df9c0c298ff1f9f$var$removeOpacity($hbuUJ.vars.colors.interactive.hover);
    const hoverOpacity = $hbuUJ.vars.colors.interactive.hoverOpacity;
    const selectedColor = $hbuUJ.vars.colors.interactive.selected;
    const selectedOpacity = $hbuUJ.vars.colors.interactive.selectedOpacity;
    const selectedHoverColor = selectedColor;
    const selectedHoverOpacity = `calc(${selectedOpacity} + ${hoverOpacity})`;
    const fallbackColors = {
        hover: $hbuUJ.vars.colors.interactive.hover,
        selected: selectedColor,
        selectedHover: selectedColor
    };
    const hoverBackground = $7df9c0c298ff1f9f$var$mix(baseBackground, hoverColor, hoverOpacity, fallbackColors.hover);
    const selectedBackground = $7df9c0c298ff1f9f$var$mix(baseBackground, selectedColor, selectedOpacity, fallbackColors.selected);
    const selectedHoverBackground = $7df9c0c298ff1f9f$var$mix(baseBackground, selectedHoverColor, selectedHoverOpacity, fallbackColors.selectedHover);
    const pinnedHoverBackground = $7df9c0c298ff1f9f$var$mix(pinnedBackground, hoverColor, hoverOpacity, fallbackColors.hover);
    const pinnedSelectedBackground = $7df9c0c298ff1f9f$var$mix(pinnedBackground, selectedColor, selectedOpacity, fallbackColors.selected);
    const pinnedSelectedHoverBackground = $7df9c0c298ff1f9f$var$mix(pinnedBackground, selectedHoverColor, selectedHoverOpacity, fallbackColors.selectedHover);
    const getPinnedBackgroundStyles = (backgroundColor)=>({
            [`& .${$5H1vo.gridClasses['cell--pinnedLeft']}, & .${$5H1vo.gridClasses['cell--pinnedRight']}`]: {
                backgroundColor: backgroundColor,
                '&.Mui-selected': {
                    backgroundColor: $7df9c0c298ff1f9f$var$mix(backgroundColor, selectedBackground, selectedOpacity, fallbackColors.selected),
                    '&:hover': {
                        backgroundColor: $7df9c0c298ff1f9f$var$mix(backgroundColor, selectedHoverBackground, selectedHoverOpacity, fallbackColors.selectedHover)
                    }
                }
            }
        });
    const pinnedHoverStyles = getPinnedBackgroundStyles(pinnedHoverBackground);
    const pinnedSelectedStyles = getPinnedBackgroundStyles(pinnedSelectedBackground);
    const pinnedSelectedHoverStyles = getPinnedBackgroundStyles(pinnedSelectedHoverBackground);
    const selectedStyles = {
        backgroundColor: selectedBackground,
        '&:hover': {
            backgroundColor: selectedHoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: selectedBackground
            }
        }
    };
    const gridStyle = {
        '--unstable_DataGrid-radius': $hbuUJ.vars.radius.base,
        '--unstable_DataGrid-headWeight': $hbuUJ.vars.typography.fontWeight.medium,
        '--DataGrid-rowBorderColor': $hbuUJ.vars.colors.border.base,
        '--DataGrid-cellOffsetMultiplier': 2,
        '--DataGrid-width': '0px',
        '--DataGrid-hasScrollX': '0',
        '--DataGrid-hasScrollY': '0',
        '--DataGrid-scrollbarSize': '10px',
        '--DataGrid-rowWidth': '0px',
        '--DataGrid-columnsTotalWidth': '0px',
        '--DataGrid-leftPinnedWidth': '0px',
        '--DataGrid-rightPinnedWidth': '0px',
        '--DataGrid-headerHeight': '0px',
        '--DataGrid-headersTotalHeight': '0px',
        '--DataGrid-topContainerHeight': '0px',
        '--DataGrid-bottomContainerHeight': '0px',
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: $hbuUJ.vars.colors.border.base,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        backgroundColor: $hbuUJ.vars.colors.background.base,
        color: $hbuUJ.vars.colors.foreground.base,
        font: $hbuUJ.vars.typography.font.body,
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflow: 'hidden',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        transform: 'translate(0, 0)',
        // Create a stacking context to keep scrollbars from showing on top
        [`.${$5H1vo.gridClasses.main} > *:first-child${$7df9c0c298ff1f9f$var$ignoreSsrWarning}`]: {
            borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
            borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
        },
        [`&.${$5H1vo.gridClasses.autoHeight}`]: {
            height: 'auto'
        },
        [`&.${$5H1vo.gridClasses.autosizing}`]: {
            [`& .${$5H1vo.gridClasses.columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            '@media (hover: hover)': {
                [`& .${$5H1vo.gridClasses.menuIcon}`]: {
                    width: '0 !important',
                    visibility: 'hidden !important'
                }
            },
            [`& .${$5H1vo.gridClasses.cell}`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap',
                minWidth: 'max-content !important',
                maxWidth: 'max-content !important'
            },
            [`& .${$5H1vo.gridClasses.groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${$5H1vo.gridClasses.treeDataGroupingCell}`]: {
                width: 'unset'
            },
            [`& .${$5H1vo.gridClasses['columnHeader--filter']}`]: {
                flex: 'none !important',
                width: 'unset !important'
            }
        },
        [`&.${$5H1vo.gridClasses.withSidePanel}`]: {
            flexDirection: 'row'
        },
        [`& .${$5H1vo.gridClasses.mainContent}`]: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            flex: 1
        },
        [`& .${$5H1vo.gridClasses.columnHeader}, & .${$5H1vo.gridClasses.cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${$5H1vo.gridClasses.columnHeader}:focus-within, & .${$5H1vo.gridClasses.cell}:focus-within`]: {
            outline: `solid ${$7df9c0c298ff1f9f$var$setOpacity($hbuUJ.vars.colors.interactive.focus, 0.5)} ${$7df9c0c298ff1f9f$var$focusOutlineWidth}px`,
            outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
        },
        [`& .${$5H1vo.gridClasses.columnHeader}:focus, & .${$5H1vo.gridClasses.cell}:focus`]: {
            outline: `solid ${$hbuUJ.vars.colors.interactive.focus} ${$7df9c0c298ff1f9f$var$focusOutlineWidth}px`,
            outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
        },
        // Hide the column separator when:
        // - the column is focused and has an outline
        // - the next column is focused and has an outline
        // - the column has a left or right border
        // - the next column is pinned right and has a left border
        [`& .${$5H1vo.gridClasses.columnHeader}:focus,
      & .${$5H1vo.gridClasses['columnHeader--withLeftBorder']},
      & .${$5H1vo.gridClasses['columnHeader--withRightBorder']},
      & .${$5H1vo.gridClasses['columnHeader--siblingFocused']}
      `]: {
            [`& .${$5H1vo.gridClasses.columnSeparator}`]: {
                opacity: 0
            },
            // Show resizable separators at all times on touch devices
            '@media (hover: none)': {
                [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}`]: {
                    opacity: 1
                }
            },
            [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}:hover`]: {
                opacity: 1
            }
        },
        [`&.${$5H1vo.gridClasses['root--noToolbar']} [aria-rowindex="1"] [aria-colindex="1"]`]: {
            borderTopLeftRadius: 'calc(var(--unstable_DataGrid-radius) - 1px)'
        },
        [`&.${$5H1vo.gridClasses['root--noToolbar']} [aria-rowindex="1"] .${$5H1vo.gridClasses['columnHeader--last']}`]: {
            borderTopRightRadius: shouldShowBorderTopRightRadius ? 'calc(var(--unstable_DataGrid-radius) - 1px)' : undefined
        },
        [`& .${$5H1vo.gridClasses.columnHeaderCheckbox}, & .${$5H1vo.gridClasses.cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${$5H1vo.gridClasses.columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: headerBackground
        },
        [`& .${$5H1vo.gridClasses.columnHeader} .${$5H1vo.gridClasses.sortButton}`]: {
            backgroundColor: $hbuUJ.vars.header.background.base
        },
        [`& .${$5H1vo.gridClasses['columnHeader--filter']}`]: {
            paddingTop: 8,
            paddingBottom: 8,
            paddingRight: 5,
            minHeight: 'min-content',
            overflow: 'hidden'
        },
        [`&.${$5H1vo.gridClasses['root--densityCompact']} .${$5H1vo.gridClasses['columnHeader--filter']}`]: {
            paddingTop: 4,
            paddingBottom: 4
        },
        [`& .${$5H1vo.gridClasses['virtualScroller--hasScrollX']} .${$5H1vo.gridClasses['columnHeader--last']}`]: {
            overflow: 'hidden'
        },
        [`& .${$5H1vo.gridClasses['pivotPanelField--sorted']} .${$5H1vo.gridClasses.iconButtonContainer},
      & .${$5H1vo.gridClasses['columnHeader--sorted']} .${$5H1vo.gridClasses.iconButtonContainer},
      & .${$5H1vo.gridClasses['columnHeader--filtered']} .${$5H1vo.gridClasses.iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton},
      & .${$5H1vo.gridClasses.columnHeader}:not(.${$5H1vo.gridClasses['columnHeader--sorted']}) .${$5H1vo.gridClasses.sortButton}`]: {
            opacity: 0,
            transition: $hbuUJ.vars.transition([
                'opacity'
            ], {
                duration: $hbuUJ.vars.transitions.duration.short
            })
        },
        [`& .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: $hbuUJ.vars.spacing(0.25),
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        [`& .${$5H1vo.gridClasses.columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--filledGroup']} .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${$5H1vo.gridClasses.sortIcon}, & .${$5H1vo.gridClasses.filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignCenter']} .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignRight']} .${$5H1vo.gridClasses.columnHeaderDraggableContainer}, & .${$5H1vo.gridClasses['columnHeader--alignRight']} .${$5H1vo.gridClasses.columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignCenter']} .${$5H1vo.gridClasses.menuIcon}`]: {
            marginLeft: 'auto'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--alignRight']} .${$5H1vo.gridClasses.menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -5
        },
        [`& .${$5H1vo.gridClasses['columnHeader--moving']}`]: {
            backgroundColor: hoverBackground
        },
        [`& .${$5H1vo.gridClasses['columnHeader--pinnedLeft']}, & .${$5H1vo.gridClasses['columnHeader--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 40,
            // Should be above the column separator
            background: $hbuUJ.vars.header.background.base
        },
        [`& .${$5H1vo.gridClasses.columnSeparator}`]: {
            position: 'absolute',
            overflow: 'hidden',
            zIndex: 30,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: $7df9c0c298ff1f9f$var$columnSeparatorTargetSize,
            color: $hbuUJ.vars.colors.border.base
        },
        [`& .${$5H1vo.gridClasses.columnHeaders}`]: {
            width: 'var(--DataGrid-rowWidth)',
            backgroundColor: headerBackground
        },
        '@media (hover: hover)': {
            [`& .${$5H1vo.gridClasses.columnHeader}:hover`]: {
                [`& .${$5H1vo.gridClasses.menuIcon}`]: {
                    width: 'auto',
                    visibility: 'visible'
                },
                [`& .${$5H1vo.gridClasses.iconButtonContainer}`]: {
                    visibility: 'visible',
                    width: 'auto'
                }
            },
            [`& .${$5H1vo.gridClasses.columnHeader}:not(.${$5H1vo.gridClasses['columnHeader--sorted']}):hover .${$5H1vo.gridClasses.sortButton},
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}):hover .${$5H1vo.gridClasses.sortButton},
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton}:focus-visible`]: {
                opacity: 1
            },
            // Add opacity only to the button content to avoid affecting the background color
            [`& .${$5H1vo.gridClasses.columnHeader}:not(.${$5H1vo.gridClasses['columnHeader--sorted']}):hover .${$5H1vo.gridClasses.sortButton} > *,
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}):hover .${$5H1vo.gridClasses.sortButton} > *,
        & .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton}:focus-visible > *`]: {
                opacity: 0.78
            },
            [`& .${$5H1vo.gridClasses.pivotPanelFieldActionContainer} button:hover`]: {
                backgroundColor: $hbuUJ.vars.colors.background.base
            }
        },
        '@media (hover: none)': {
            [`& .${$5H1vo.gridClasses.columnHeader} .${$5H1vo.gridClasses.menuIcon}`]: {
                width: 'auto',
                visibility: 'visible'
            },
            [`& .${$5H1vo.gridClasses.columnHeader}:focus,
        & .${$5H1vo.gridClasses['columnHeader--siblingFocused']}`]: {
                [`.${$5H1vo.gridClasses['columnSeparator--resizable']}`]: {
                    color: $hbuUJ.vars.colors.foreground.accent
                }
            },
            [`& .${$5H1vo.gridClasses.pivotPanelField}:not(.${$5H1vo.gridClasses['pivotPanelField--sorted']}) .${$5H1vo.gridClasses.sortButton}`]: {
                opacity: 0.78
            }
        },
        // Hide the column separator when the column has border and it is not resizable
        // In this case, this column separator may block interaction with the separator from the adjacent column that is resizable
        [`& .${$5H1vo.gridClasses['columnHeader--withLeftBorder']} .${$5H1vo.gridClasses['columnSeparator--sideLeft']}:not(.${$5H1vo.gridClasses['columnSeparator--resizable']}), & .${$5H1vo.gridClasses['columnHeader--withRightBorder']} .${$5H1vo.gridClasses['columnSeparator--sideRight']}:not(.${$5H1vo.gridClasses['columnSeparator--resizable']})`]: {
            display: 'none'
        },
        [`& .${$5H1vo.gridClasses['columnSeparator--sideLeft']}`]: {
            left: $7df9c0c298ff1f9f$var$columnSeparatorOffset
        },
        [`& .${$5H1vo.gridClasses['columnSeparator--sideRight']}`]: {
            right: $7df9c0c298ff1f9f$var$columnSeparatorOffset
        },
        [`& .${$5H1vo.gridClasses['columnHeader--withRightBorder']} .${$5H1vo.gridClasses['columnSeparator--sideLeft']}`]: {
            left: $7df9c0c298ff1f9f$var$columnSeparatorOffset - 0.5
        },
        [`& .${$5H1vo.gridClasses['columnHeader--withRightBorder']} .${$5H1vo.gridClasses['columnSeparator--sideRight']}`]: {
            right: $7df9c0c298ff1f9f$var$columnSeparatorOffset - 0.5
        },
        [`& .${$5H1vo.gridClasses['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            [`&.${$5H1vo.gridClasses['columnSeparator--resizing']}`]: {
                color: $hbuUJ.vars.colors.foreground.accent
            },
            // Always appear as draggable on touch devices
            '@media (hover: none)': {
                [`& .${$5H1vo.gridClasses.iconSeparator} rect`]: $7df9c0c298ff1f9f$var$separatorIconDragStyles
            },
            '@media (hover: hover)': {
                '&:hover': {
                    color: $hbuUJ.vars.colors.foreground.accent,
                    [`& .${$5H1vo.gridClasses.iconSeparator} rect`]: $7df9c0c298ff1f9f$var$separatorIconDragStyles
                }
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${$5H1vo.gridClasses.iconSeparator}`]: {
            color: 'inherit',
            transition: $hbuUJ.vars.transition([
                'color',
                'width'
            ], {
                duration: $hbuUJ.vars.transitions.duration.short
            })
        },
        [`& .${$5H1vo.gridClasses.menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -5,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${$5H1vo.gridClasses.menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${$5H1vo.gridClasses.headerFilterRow}`]: {
            [`& .${$5H1vo.gridClasses.columnHeader}, & .${$5H1vo.gridClasses.scrollbarFiller}`]: {
                boxSizing: 'border-box',
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            }
        },
        /* Bottom border of the top-container */ [`& .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.columnHeader},
      & .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.filler},
      & .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.scrollbarFiller}`]: {
            borderBottom: `1px solid var(--DataGrid-rowBorderColor)`
        },
        [`& .${$5H1vo.gridClasses['row--borderBottom']} .${$5H1vo.gridClasses.cell}`]: {
            borderBottom: `1px solid var(--rowBorderColor)`
        },
        /* Row styles */ [`.${$5H1vo.gridClasses.row}`]: {
            display: 'flex',
            width: 'var(--DataGrid-rowWidth)',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '--rowBorderColor': 'var(--DataGrid-rowBorderColor)',
            [`&.${$5H1vo.gridClasses['row--firstVisible']}`]: {
                '--rowBorderColor': 'transparent'
            },
            '&:hover': {
                backgroundColor: hoverBackground,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${$5H1vo.gridClasses.rowSkeleton}:hover`]: {
                backgroundColor: 'transparent'
            },
            '&.Mui-selected': selectedStyles,
            position: 'relative'
        },
        /* Cell styles */ [`& .${$5H1vo.gridClasses.cell}`]: {
            flex: '0 0 auto',
            height: 'var(--height)',
            width: 'var(--width)',
            lineHeight: 'calc(var(--height) - 1px)',
            // -1px for the border
            boxSizing: 'border-box',
            borderTop: `1px solid var(--rowBorderColor)`,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&.Mui-selected': selectedStyles
        },
        [`& .${$5H1vo.gridClasses['virtualScrollerContent--overflowed']} .${$5H1vo.gridClasses['row--lastVisible']} .${$5H1vo.gridClasses.cell}`]: {
            borderTopColor: 'transparent'
        },
        [`& .${$5H1vo.gridClasses.pinnedRows} .${$5H1vo.gridClasses.row}, .${$5H1vo.gridClasses.aggregationRowOverlayWrapper} .${$5H1vo.gridClasses.row}`]: {
            backgroundColor: pinnedBackground,
            '&:hover': {
                backgroundColor: pinnedHoverBackground
            }
        },
        [`& .${$5H1vo.gridClasses['pinnedRows--top']} :first-of-type`]: {
            [`& .${$5H1vo.gridClasses.cell}, .${$5H1vo.gridClasses.scrollbarFiller}`]: {
                borderTop: 'none'
            }
        },
        [`&.${$5H1vo.gridClasses['root--disableUserSelection']}`]: {
            userSelect: 'none'
        },
        [`& .${$5H1vo.gridClasses['row--dynamicHeight']} > .${$5H1vo.gridClasses.cell}`]: {
            whiteSpace: 'initial',
            lineHeight: 'inherit'
        },
        [`& .${$5H1vo.gridClasses.cellEmpty}`]: {
            flex: 1,
            padding: 0,
            height: 'unset'
        },
        [`& .${$5H1vo.gridClasses.cell}.${$5H1vo.gridClasses['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${$5H1vo.gridClasses.cell}.${$5H1vo.gridClasses['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: $hbuUJ.vars.shadows.base,
            backgroundColor: $hbuUJ.vars.colors.background.overlay,
            '&:focus-within': {
                outline: `${$7df9c0c298ff1f9f$var$focusOutlineWidth}px solid ${$hbuUJ.vars.colors.interactive.focus}`,
                outlineOffset: $7df9c0c298ff1f9f$var$focusOutlineWidth * -1
            }
        },
        [`& .${$5H1vo.gridClasses['cell--editing']}`]: {
            '& .MuiInputBase-root': {
                height: '100%'
            }
        },
        [`& .${$5H1vo.gridClasses['row--editing']}`]: {
            boxShadow: $hbuUJ.vars.shadows.base
        },
        [`& .${$5H1vo.gridClasses['row--editing']} .${$5H1vo.gridClasses.cell}`]: {
            boxShadow: 'none',
            backgroundColor: $hbuUJ.vars.colors.background.overlay
        },
        [`& .${$5H1vo.gridClasses.editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${$5H1vo.gridClasses.booleanCell}[data-value="true"]`]: {
            color: $hbuUJ.vars.colors.foreground.muted
        },
        [`& .${$5H1vo.gridClasses.booleanCell}[data-value="false"]`]: {
            color: $hbuUJ.vars.colors.foreground.disabled
        },
        [`& .${$5H1vo.gridClasses.actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: $hbuUJ.vars.spacing(1)
        },
        [`& .${$5H1vo.gridClasses.rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: $hbuUJ.vars.colors.interactive.disabledOpacity
        },
        [`& .${$5H1vo.gridClasses['rowReorderCell--draggable']}`]: {
            cursor: 'grab',
            opacity: 1
        },
        [`& .${$5H1vo.gridClasses.rowReorderCellContainer}`]: {
            padding: 0,
            display: 'flex',
            alignItems: 'stretch'
        },
        [`.${$5H1vo.gridClasses.withBorderColor}`]: {
            borderColor: $hbuUJ.vars.colors.border.base
        },
        [`& .${$5H1vo.gridClasses['cell--withLeftBorder']}, & .${$5H1vo.gridClasses['columnHeader--withLeftBorder']}`]: {
            borderLeftColor: 'var(--DataGrid-rowBorderColor)',
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid'
        },
        [`& .${$5H1vo.gridClasses['cell--withRightBorder']}, & .${$5H1vo.gridClasses['columnHeader--withRightBorder']}`]: {
            borderRightColor: 'var(--DataGrid-rowBorderColor)',
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${$5H1vo.gridClasses['cell--flex']}`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'inherit'
        },
        [`& .${$5H1vo.gridClasses['cell--textLeft']}`]: {
            textAlign: 'left',
            justifyContent: 'flex-start'
        },
        [`& .${$5H1vo.gridClasses['cell--textRight']}`]: {
            textAlign: 'right',
            justifyContent: 'flex-end'
        },
        [`& .${$5H1vo.gridClasses['cell--textCenter']}`]: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        [`& .${$5H1vo.gridClasses['cell--pinnedLeft']}, & .${$5H1vo.gridClasses['cell--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 30,
            background: $hbuUJ.vars.cell.background.pinned,
            '&.Mui-selected': {
                backgroundColor: pinnedSelectedBackground
            }
        },
        [`& .${$5H1vo.gridClasses.row}`]: {
            '&:hover': pinnedHoverStyles,
            '&.Mui-selected': pinnedSelectedStyles,
            '&.Mui-selected:hover': pinnedSelectedHoverStyles
        },
        [`& .${$5H1vo.gridClasses.cellOffsetLeft}`]: {
            flex: '0 0 auto',
            display: 'inline-block'
        },
        [`& .${$5H1vo.gridClasses.cellSkeleton}`]: {
            flex: '0 0 auto',
            height: '100%',
            display: 'inline-flex',
            alignItems: 'center'
        },
        [`& .${$5H1vo.gridClasses.columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${$5H1vo.gridClasses.rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${$5H1vo.gridClasses['columnHeader--dragging']}`]: {
            background: $hbuUJ.vars.colors.background.overlay,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: $hbuUJ.vars.colors.interactive.disabledOpacity
        },
        [`& .${$5H1vo.gridClasses['row--dragging']}`]: {
            background: $hbuUJ.vars.colors.background.overlay,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            border: '1px solid var(--DataGrid-rowBorderColor)',
            color: $hbuUJ.vars.colors.foreground.base,
            transform: 'translateZ(0)',
            [`& .${$5H1vo.gridClasses.rowReorderCellPlaceholder}`]: {
                padding: '0 6px',
                display: 'flex'
            }
        },
        [`& .${$5H1vo.gridClasses.treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${$5H1vo.gridClasses.treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: $hbuUJ.vars.spacing(2)
        },
        [`& .${$5H1vo.gridClasses.treeDataGroupingCellLoadingContainer}, .${$5H1vo.gridClasses.groupingCriteriaCellLoadingContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        [`& .${$5H1vo.gridClasses.groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${$5H1vo.gridClasses.groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: $hbuUJ.vars.spacing(2)
        },
        /* ScrollbarFiller styles */ [`& .${$5H1vo.gridClasses.columnHeaders} .${$5H1vo.gridClasses.scrollbarFiller}`]: {
            backgroundColor: headerBackground
        },
        [`.${$5H1vo.gridClasses.scrollbarFiller}`]: {
            minWidth: 'calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
            alignSelf: 'stretch',
            backgroundColor: headerBackground,
            [`&.${$5H1vo.gridClasses['scrollbarFiller--pinnedRight']}`]: {
                position: 'sticky',
                zIndex: 40,
                // Should be above the column separator
                right: 0
            }
        },
        [`& .${$5H1vo.gridClasses.filler}`]: {
            flex: '1 0 auto'
        },
        [`& .${$5H1vo.gridClasses['filler--borderBottom']}`]: {
            borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
        },
        [`& .${$5H1vo.gridClasses.columnHeaders} .${$5H1vo.gridClasses.filler}`]: {
            backgroundColor: headerBackground
        },
        /* Used when skeleton/no columns overlay is visible */ [`& .${$5H1vo.gridClasses['main--hiddenContent']}`]: {
            [`& .${$5H1vo.gridClasses.virtualScrollerContent}`]: {
                // We use visibility hidden so that the virtual scroller content retains its height.
                // Position fixed is used to remove the virtual scroller content from the flow.
                // https://github.com/mui/mui-x/issues/14061
                position: 'fixed',
                visibility: 'hidden'
            },
            // Hide grid content
            [`& .${$5H1vo.gridClasses.pinnedRows}`]: {
                display: 'none'
            }
        },
        [`& .${$5H1vo.gridClasses['row--beingDragged']}`]: {
            color: $hbuUJ.vars.colors.foreground.disabled,
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    };
    return gridStyle;
});
function $7df9c0c298ff1f9f$var$setOpacity(color, opacity) {
    return `rgba(from ${color} r g b / ${opacity})`;
}
function $7df9c0c298ff1f9f$var$removeOpacity(color) {
    return $7df9c0c298ff1f9f$var$setOpacity(color, 1);
}
const $7df9c0c298ff1f9f$var$supportsColorMix = module.exports.supportsColorMix = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('color', 'color-mix(in srgb, red 50%, blue 50%)');
const $7df9c0c298ff1f9f$var$colorMixIfSupported = (colorMixValue, fallback)=>{
    if (!$7df9c0c298ff1f9f$var$supportsColorMix) return fallback;
    return colorMixValue;
};
module.exports.colorMixIfSupported = $7df9c0c298ff1f9f$var$colorMixIfSupported;
function $7df9c0c298ff1f9f$var$mix(background, overlay, opacity, fallback) {
    return $7df9c0c298ff1f9f$var$colorMixIfSupported(`color-mix(in srgb,${background}, ${overlay} calc(${opacity} * 100%))`, fallback);
}

});

parcelRegister("bX8Ys", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsSSR = void 0;

var $hfliI = parcelRequire("hfliI");
const $8b3c2a77bf85fdbc$var$emptySubscribe = ()=>()=>{};
const $8b3c2a77bf85fdbc$var$clientSnapshot = ()=>false;
const $8b3c2a77bf85fdbc$var$serverSnapshot = ()=>true;
const $8b3c2a77bf85fdbc$var$useIsSSR = ()=>(0, $hfliI.useSyncExternalStore)($8b3c2a77bf85fdbc$var$emptySubscribe, $8b3c2a77bf85fdbc$var$clientSnapshot, $8b3c2a77bf85fdbc$var$serverSnapshot);
module.exports.useIsSSR = $8b3c2a77bf85fdbc$var$useIsSSR;

});

parcelRegister("hHwPs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ce2feaf42932ccbe$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ce2feaf42932ccbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridHeader = $ce2feaf42932ccbe$var$GridHeader;

var $ce2feaf42932ccbe$var$_extends2 = $ce2feaf42932ccbe$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ce2feaf42932ccbe$var$React = $ce2feaf42932ccbe$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");

var $tZfVk = parcelRequire("tZfVk");

var $ayMG0 = parcelRequire("ayMG0");
function $ce2feaf42932ccbe$var$GridHeader() {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ce2feaf42932ccbe$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($tZfVk.GridPreferencesPanel, {}),
            rootProps.showToolbar && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.toolbar, (0, $ce2feaf42932ccbe$var$_extends2.default)({}, rootProps.slotProps?.toolbar))
        ]
    });
}

});
parcelRegister("tZfVk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05a239ae20a1382d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPreferencesPanel = $05a239ae20a1382d$var$GridPreferencesPanel;

var $05a239ae20a1382d$var$_extends2 = $05a239ae20a1382d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $7fn0i = parcelRequire("7fn0i");

var $ayMG0 = parcelRequire("ayMG0");
function $05a239ae20a1382d$var$GridPreferencesPanel() {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columns = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnDefinitionsSelector);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const preferencePanelState = (0, $5sOMZ.useGridSelector)(apiRef, $6X2Yd.gridPreferencePanelStateSelector);
    const { columnsPanelTriggerRef: columnsPanelTriggerRef, filterPanelTriggerRef: filterPanelTriggerRef, aiAssistantPanelTriggerRef: aiAssistantPanelTriggerRef } = (0, $7fn0i.useGridPanelContext)();
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, preferencePanelState.openedPanelValue ?? $3PCYS.GridPreferencePanelsValue.filters);
    let target = null;
    switch(preferencePanelState.openedPanelValue){
        case $3PCYS.GridPreferencePanelsValue.filters:
            target = filterPanelTriggerRef.current;
            break;
        case $3PCYS.GridPreferencePanelsValue.columns:
            target = columnsPanelTriggerRef.current;
            break;
        case $3PCYS.GridPreferencePanelsValue.aiAssistant:
            target = aiAssistantPanelTriggerRef.current;
            break;
        default:
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.panel, (0, $05a239ae20a1382d$var$_extends2.default)({
        id: preferencePanelState.panelId,
        open: columns.length > 0 && preferencePanelState.open,
        "aria-labelledby": preferencePanelState.labelId,
        target: target,
        onClose: ()=>apiRef.current.hidePreferences()
    }, rootProps.slotProps?.panel, {
        children: panelContent
    }));
}

});
parcelRegister("7fn0i", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $546bc72d2cea638d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPanelContext = void 0;
module.exports.GridPanelContextProvider = $546bc72d2cea638d$var$GridPanelContextProvider;
module.exports.useGridPanelContext = $546bc72d2cea638d$var$useGridPanelContext;

var $546bc72d2cea638d$var$React = $546bc72d2cea638d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $546bc72d2cea638d$var$GridPanelContext = module.exports.GridPanelContext = /*#__PURE__*/ $546bc72d2cea638d$var$React.createContext(undefined);
function $546bc72d2cea638d$var$useGridPanelContext() {
    const context = $546bc72d2cea638d$var$React.useContext($546bc72d2cea638d$var$GridPanelContext);
    if (context === undefined) throw new Error('MUI X: Missing context.');
    return context;
}
function $546bc72d2cea638d$var$GridPanelContextProvider({ children: children }) {
    const columnsPanelTriggerRef = $546bc72d2cea638d$var$React.useRef(null);
    const filterPanelTriggerRef = $546bc72d2cea638d$var$React.useRef(null);
    const aiAssistantPanelTriggerRef = $546bc72d2cea638d$var$React.useRef(null);
    const value = $546bc72d2cea638d$var$React.useMemo(()=>({
            columnsPanelTriggerRef: columnsPanelTriggerRef,
            filterPanelTriggerRef: filterPanelTriggerRef,
            aiAssistantPanelTriggerRef: aiAssistantPanelTriggerRef
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($546bc72d2cea638d$var$GridPanelContext.Provider, {
        value: value,
        children: children
    });
}

});




parcelRegister("jgcq7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e05925554f74d684$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e05925554f74d684$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFooterContainer = void 0;

var $e05925554f74d684$var$_extends2 = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e05925554f74d684$var$_objectWithoutPropertiesLoose2 = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("c05no")));

var $e05925554f74d684$var$React = $e05925554f74d684$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e05925554f74d684$var$_propTypes = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e05925554f74d684$var$_clsx = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e05925554f74d684$var$_composeClasses = $e05925554f74d684$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e05925554f74d684$var$_excluded = [
    "className"
];
const $e05925554f74d684$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $e05925554f74d684$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $e05925554f74d684$var$GridFooterContainerRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer'
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $e05925554f74d684$var$GridFooterContainer = module.exports.GridFooterContainer = (0, $fYxgT.forwardRef)(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $e05925554f74d684$var$_objectWithoutPropertiesLoose2.default)(props, $e05925554f74d684$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $e05925554f74d684$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e05925554f74d684$var$GridFooterContainerRoot, (0, $e05925554f74d684$var$_extends2.default)({
        className: (0, $e05925554f74d684$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});

parcelRegister("809Ep", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0180de2e65ebf290$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0180de2e65ebf290$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridOverlay = void 0;

var $0180de2e65ebf290$var$_extends2 = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0180de2e65ebf290$var$_objectWithoutPropertiesLoose2 = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("c05no")));

var $0180de2e65ebf290$var$React = $0180de2e65ebf290$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0180de2e65ebf290$var$_propTypes = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0180de2e65ebf290$var$_clsx = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0180de2e65ebf290$var$_composeClasses = $0180de2e65ebf290$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $0180de2e65ebf290$var$_excluded = [
    "className"
];
const $0180de2e65ebf290$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $0180de2e65ebf290$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $0180de2e65ebf290$var$GridOverlayRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay'
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    gap: $hbuUJ.vars.spacing(1),
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textWrap: 'balance',
    backgroundColor: $hbuUJ.vars.colors.background.backdrop
});
const $0180de2e65ebf290$var$GridOverlay = module.exports.GridOverlay = (0, $fYxgT.forwardRef)(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $0180de2e65ebf290$var$_objectWithoutPropertiesLoose2.default)(props, $0180de2e65ebf290$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0180de2e65ebf290$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0180de2e65ebf290$var$GridOverlayRoot, (0, $0180de2e65ebf290$var$_extends2.default)({
        className: (0, $0180de2e65ebf290$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});

parcelRegister("02G4S", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0080d3bf74adddb6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0080d3bf74adddb6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbarContainer = void 0;

var $0080d3bf74adddb6$var$_extends2 = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0080d3bf74adddb6$var$_objectWithoutPropertiesLoose2 = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("c05no")));

var $0080d3bf74adddb6$var$React = $0080d3bf74adddb6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0080d3bf74adddb6$var$_propTypes = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0080d3bf74adddb6$var$_clsx = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $0080d3bf74adddb6$var$_composeClasses = $0080d3bf74adddb6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $6qO8T = parcelRequire("6qO8T");

var $ayMG0 = parcelRequire("ayMG0");
const $0080d3bf74adddb6$var$_excluded = [
    "className",
    "children"
];
const $0080d3bf74adddb6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarContainer'
        ]
    };
    return (0, $0080d3bf74adddb6$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $0080d3bf74adddb6$var$GridToolbarContainerRoot = (0, $izOUK.styled)($6qO8T.Toolbar, {
    name: 'MuiDataGrid',
    slot: 'ToolbarContainer',
    shouldForwardProp: (prop)=>prop !== 'ownerState'
})({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: $hbuUJ.vars.spacing(1),
    padding: $hbuUJ.vars.spacing(0.5),
    minHeight: 'auto'
});
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/toolbar/ Toolbar} component instead. This component will be removed in a future major release.
 */ const $0080d3bf74adddb6$var$GridToolbarContainer = module.exports.GridToolbarContainer = (0, $fYxgT.forwardRef)(function GridToolbarContainer(props, ref) {
    const { className: className, children: children } = props, other = (0, $0080d3bf74adddb6$var$_objectWithoutPropertiesLoose2.default)(props, $0080d3bf74adddb6$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $0080d3bf74adddb6$var$useUtilityClasses(rootProps);
    if (!children) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0080d3bf74adddb6$var$GridToolbarContainerRoot, (0, $0080d3bf74adddb6$var$_extends2.default)({
        className: (0, $0080d3bf74adddb6$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: children
    }));
});

});
parcelRegister("6qO8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iBOz6 = parcelRequire("iBOz6");
Object.keys($iBOz6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iBOz6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iBOz6[key];
        }
    });
});

var $6xDvC = parcelRequire("6xDvC");
Object.keys($6xDvC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6xDvC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6xDvC[key];
        }
    });
});

});
parcelRegister("iBOz6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d8c2e7e50975603c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d8c2e7e50975603c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Toolbar = void 0;

var $d8c2e7e50975603c$var$_extends2 = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d8c2e7e50975603c$var$_objectWithoutPropertiesLoose2 = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("c05no")));

var $d8c2e7e50975603c$var$React = $d8c2e7e50975603c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d8c2e7e50975603c$var$_propTypes = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $d8c2e7e50975603c$var$_composeClasses = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d8c2e7e50975603c$var$_clsx = $d8c2e7e50975603c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $djki7 = parcelRequire("djki7");

var $jDpXp = parcelRequire("jDpXp");

var $a4LwK = parcelRequire("a4LwK");

var $ayMG0 = parcelRequire("ayMG0");
const $d8c2e7e50975603c$var$_excluded = [
    "render",
    "className"
];
const $d8c2e7e50975603c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbar'
        ]
    };
    return (0, $d8c2e7e50975603c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $d8c2e7e50975603c$var$ToolbarRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'Toolbar'
})({
    flex: '0 1 1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    gap: $hbuUJ.vars.spacing(0.25),
    padding: $hbuUJ.vars.spacing(0.75),
    minHeight: 52,
    boxSizing: 'border-box',
    borderBottom: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
/**
 * The top level Toolbar component that provides context to child components.
 * It renders a styled `<div />` element.
 *
 * Demos:
 *
 * - [Toolbar](https://mui.com/x/react-data-grid/components/toolbar/)
 *
 * API:
 *
 * - [Toolbar API](https://mui.com/x/api/data-grid/toolbar/)
 */ const $d8c2e7e50975603c$var$Toolbar = module.exports.Toolbar = (0, $fYxgT.forwardRef)(function Toolbar(props, ref) {
    const { render: render, className: className } = props, other = (0, $d8c2e7e50975603c$var$_objectWithoutPropertiesLoose2.default)(props, $d8c2e7e50975603c$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $d8c2e7e50975603c$var$useUtilityClasses(rootProps);
    const [focusableItemId, setFocusableItemId] = $d8c2e7e50975603c$var$React.useState(null);
    const [items, setItems] = $d8c2e7e50975603c$var$React.useState([]);
    const getSortedItems = $d8c2e7e50975603c$var$React.useCallback(()=>items.sort($a4LwK.sortByDocumentPosition), [
        items
    ]);
    const findEnabledItem = $d8c2e7e50975603c$var$React.useCallback((startIndex, step, wrap = true)=>{
        let index = startIndex;
        const sortedItems = getSortedItems();
        const itemCount = sortedItems.length;
        // Look for enabled items in the specified direction
        for(let i = 0; i < itemCount; i += 1){
            index += step;
            // Handle wrapping around the ends
            if (index >= itemCount) {
                if (!wrap) return -1;
                index = 0;
            } else if (index < 0) {
                if (!wrap) return -1;
                index = itemCount - 1;
            }
            // Return if we found an enabled item
            if (!sortedItems[index].ref.current?.disabled && sortedItems[index].ref.current?.ariaDisabled !== 'true') return index;
        }
        // If we've checked all items and found none enabled
        return -1;
    }, [
        getSortedItems
    ]);
    const registerItem = $d8c2e7e50975603c$var$React.useCallback((id, itemRef)=>{
        setItems((prevItems)=>[
                ...prevItems,
                {
                    id: id,
                    ref: itemRef
                }
            ]);
    }, []);
    const unregisterItem = $d8c2e7e50975603c$var$React.useCallback((id)=>{
        setItems((prevItems)=>prevItems.filter((i)=>i.id !== id));
    }, []);
    const onItemKeyDown = $d8c2e7e50975603c$var$React.useCallback((event)=>{
        if (!focusableItemId) return;
        const sortedItems = getSortedItems();
        const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
        let newIndex = -1;
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, 1);
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, -1);
        } else if (event.key === 'Home') {
            event.preventDefault();
            newIndex = findEnabledItem(-1, 1, false);
        } else if (event.key === 'End') {
            event.preventDefault();
            newIndex = findEnabledItem(sortedItems.length, -1, false);
        }
        // TODO: Check why this is necessary
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        focusableItemId,
        findEnabledItem
    ]);
    const onItemFocus = $d8c2e7e50975603c$var$React.useCallback((id)=>{
        if (focusableItemId !== id) setFocusableItemId(id);
    }, [
        focusableItemId,
        setFocusableItemId
    ]);
    const onItemDisabled = $d8c2e7e50975603c$var$React.useCallback((id)=>{
        const sortedItems = getSortedItems();
        const currentIndex = sortedItems.findIndex((item)=>item.id === id);
        const newIndex = findEnabledItem(currentIndex, 1);
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    $d8c2e7e50975603c$var$React.useEffect(()=>{
        const sortedItems = getSortedItems();
        if (sortedItems.length > 0) {
            // Set initial focusable item
            if (!focusableItemId) {
                setFocusableItemId(sortedItems[0].id);
                return;
            }
            const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
            if (!sortedItems[focusableItemIndex]) {
                // Last item has been removed from the items array
                const item = sortedItems[sortedItems.length - 1];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            } else if (focusableItemIndex === -1) {
                // Focused item has been removed from the items array
                const item = sortedItems[focusableItemIndex];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    const contextValue = $d8c2e7e50975603c$var$React.useMemo(()=>({
            focusableItemId: focusableItemId,
            registerItem: registerItem,
            unregisterItem: unregisterItem,
            onItemKeyDown: onItemKeyDown,
            onItemFocus: onItemFocus,
            onItemDisabled: onItemDisabled
        }), [
        focusableItemId,
        registerItem,
        unregisterItem,
        onItemKeyDown,
        onItemFocus,
        onItemDisabled
    ]);
    const element = (0, $QvFCk.useComponentRenderer)($d8c2e7e50975603c$var$ToolbarRoot, render, (0, $d8c2e7e50975603c$var$_extends2.default)({
        role: 'toolbar',
        'aria-orientation': 'horizontal',
        'aria-label': rootProps.label || undefined,
        className: (0, $d8c2e7e50975603c$var$_clsx.default)(classes.root, className)
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($djki7.ToolbarContext.Provider, {
        value: contextValue,
        children: element
    });
});

});
parcelRegister("QvFCk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6Yqs6 = parcelRequire("6Yqs6");
Object.keys($6Yqs6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6Yqs6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6Yqs6[key];
        }
    });
});

});
parcelRegister("6Yqs6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $513cdd862df13332$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $513cdd862df13332$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useComponentRenderer = $513cdd862df13332$var$useComponentRenderer;

var $513cdd862df13332$var$_extends2 = $513cdd862df13332$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $513cdd862df13332$var$React = $513cdd862df13332$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Resolves the rendering logic for a component.
 * Handles three scenarios:
 * 1. A render function that receives props and state
 * 2. A React element
 * 3. A default element
 *
 * @ignore - internal hook.
 */ function $513cdd862df13332$var$useComponentRenderer(defaultElement, render, props, state = {}) {
    if (typeof render === 'function') return render(props, state);
    if (render) {
        if (render.props.className) props.className = $513cdd862df13332$var$mergeClassNames(render.props.className, props.className);
        if (render.props.style || props.style) props.style = (0, $513cdd862df13332$var$_extends2.default)({}, props.style, render.props.style);
        return /*#__PURE__*/ $513cdd862df13332$var$React.cloneElement(render, props);
    }
    return /*#__PURE__*/ $513cdd862df13332$var$React.createElement(defaultElement, props);
}
function $513cdd862df13332$var$mergeClassNames(className, otherClassName) {
    if (!className || !otherClassName) return className || otherClassName;
    return `${className} ${otherClassName}`;
}

});


parcelRegister("djki7", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9b0cca25f33cbe1b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToolbarContext = void 0;
module.exports.useToolbarContext = $9b0cca25f33cbe1b$var$useToolbarContext;

var $9b0cca25f33cbe1b$var$React = $9b0cca25f33cbe1b$require$_interopRequireWildcard((parcelRequire("acw62")));
const $9b0cca25f33cbe1b$var$ToolbarContext = module.exports.ToolbarContext = /*#__PURE__*/ $9b0cca25f33cbe1b$var$React.createContext(undefined);
function $9b0cca25f33cbe1b$var$useToolbarContext() {
    const context = $9b0cca25f33cbe1b$var$React.useContext($9b0cca25f33cbe1b$var$ToolbarContext);
    if (context === undefined) throw new Error('MUI X: Missing context. Toolbar subcomponents must be placed within a <Toolbar /> component.');
    return context;
}

});

parcelRegister("a4LwK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortByDocumentPosition = $755f2504bb16c6c8$var$sortByDocumentPosition;
/* eslint-disable no-bitwise */ function $755f2504bb16c6c8$var$sortByDocumentPosition(a, b) {
    if (!a.ref.current || !b.ref.current) return 0;
    const position = a.ref.current.compareDocumentPosition(b.ref.current);
    if (!position) return 0;
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}

});


parcelRegister("6xDvC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4c3478cdd4144942$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4c3478cdd4144942$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToolbarButton = void 0;

var $4c3478cdd4144942$var$_extends2 = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4c3478cdd4144942$var$_objectWithoutPropertiesLoose2 = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("c05no")));

var $4c3478cdd4144942$var$React = $4c3478cdd4144942$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4c3478cdd4144942$var$_propTypes = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4c3478cdd4144942$var$_useForkRef = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $4c3478cdd4144942$var$_useId = $4c3478cdd4144942$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $jDpXp = parcelRequire("jDpXp");

var $djki7 = parcelRequire("djki7");

var $ayMG0 = parcelRequire("ayMG0");
const $4c3478cdd4144942$var$_excluded = [
    "render",
    "onKeyDown",
    "onFocus",
    "disabled",
    "aria-disabled"
];
/**
 * A button for performing actions from the toolbar.
 * It renders the `baseIconButton` slot.
 *
 * Demos:
 *
 * - [Toolbar](https://mui.com/x/react-data-grid/components/toolbar/)
 *
 * API:
 *
 * - [ToolbarButton API](https://mui.com/x/api/data-grid/toolbar-button/)
 */ const $4c3478cdd4144942$var$ToolbarButton = module.exports.ToolbarButton = (0, $fYxgT.forwardRef)(function ToolbarButton(props, ref) {
    const { render: render, onKeyDown: onKeyDown, onFocus: onFocus, disabled: disabled, 'aria-disabled': ariaDisabled } = props, other = (0, $4c3478cdd4144942$var$_objectWithoutPropertiesLoose2.default)(props, $4c3478cdd4144942$var$_excluded);
    const id = (0, $4c3478cdd4144942$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const buttonRef = $4c3478cdd4144942$var$React.useRef(null);
    const handleRef = (0, $4c3478cdd4144942$var$_useForkRef.default)(buttonRef, ref);
    const { focusableItemId: focusableItemId, registerItem: registerItem, unregisterItem: unregisterItem, onItemKeyDown: onItemKeyDown, onItemFocus: onItemFocus, onItemDisabled: onItemDisabled } = (0, $djki7.useToolbarContext)();
    const handleKeyDown = (event)=>{
        onItemKeyDown(event);
        onKeyDown?.(event);
    };
    const handleFocus = (event)=>{
        onItemFocus(id);
        onFocus?.(event);
    };
    $4c3478cdd4144942$var$React.useEffect(()=>{
        registerItem(id, buttonRef);
        return ()=>unregisterItem(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const previousDisabled = $4c3478cdd4144942$var$React.useRef(disabled);
    $4c3478cdd4144942$var$React.useEffect(()=>{
        if (previousDisabled.current !== disabled && disabled === true) onItemDisabled(id, disabled);
        previousDisabled.current = disabled;
    }, [
        disabled,
        id,
        onItemDisabled
    ]);
    const previousAriaDisabled = $4c3478cdd4144942$var$React.useRef(ariaDisabled);
    $4c3478cdd4144942$var$React.useEffect(()=>{
        if (previousAriaDisabled.current !== ariaDisabled && ariaDisabled === true) onItemDisabled(id, true);
        previousAriaDisabled.current = ariaDisabled;
    }, [
        ariaDisabled,
        id,
        onItemDisabled
    ]);
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseIconButton, render, (0, $4c3478cdd4144942$var$_extends2.default)({}, rootProps.slotProps?.baseIconButton, {
        tabIndex: focusableItemId === id ? 0 : -1
    }, other, {
        disabled: disabled,
        'aria-disabled': ariaDisabled,
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        ref: handleRef
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4c3478cdd4144942$var$React.Fragment, {
        children: element
    });
});

});




parcelRegister("9cGVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bfoLE = parcelRequire("bfoLE");
Object.keys($bfoLE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bfoLE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bfoLE[key];
        }
    });
});

var $c0AIV = parcelRequire("c0AIV");
Object.keys($c0AIV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $c0AIV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0AIV[key];
        }
    });
});

var $960Cz = parcelRequire("960Cz");
Object.keys($960Cz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $960Cz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $960Cz[key];
        }
    });
});

var $k8xn5 = parcelRequire("k8xn5");
Object.keys($k8xn5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k8xn5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k8xn5[key];
        }
    });
});

var $2jUq6 = parcelRequire("2jUq6");
Object.keys($2jUq6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2jUq6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2jUq6[key];
        }
    });
});

});
parcelRegister("bfoLE", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $83044eba4b8e40dc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83044eba4b8e40dc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaderItem = void 0;

var $83044eba4b8e40dc$var$_extends2 = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $83044eba4b8e40dc$var$React = $83044eba4b8e40dc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $83044eba4b8e40dc$var$_propTypes = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $83044eba4b8e40dc$var$_clsx = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $83044eba4b8e40dc$var$_composeClasses = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $83044eba4b8e40dc$var$_useId = $83044eba4b8e40dc$require$_interopRequireDefault((parcelRequire("hwliF")));

var $2nKmT = parcelRequire("2nKmT");

var $9uEev = parcelRequire("9uEev");

var $g2vKb = parcelRequire("g2vKb");

var $er55f = parcelRequire("er55f");

var $5pZ0O = parcelRequire("5pZ0O");

var $6ZYGg = parcelRequire("6ZYGg");

var $le8d8 = parcelRequire("le8d8");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $4cOaX = parcelRequire("4cOaX");

var $KtEo5 = parcelRequire("KtEo5");

var $jZka4 = parcelRequire("jZka4");

var $94sAG = parcelRequire("94sAG");

var $ayMG0 = parcelRequire("ayMG0");
const $83044eba4b8e40dc$var$useUtilityClasses = (ownerState)=>{
    const { disableColumnSorting: disableColumnSorting } = (0, $jDpXp.useGridRootProps)();
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, filterItemsCounter: filterItemsCounter, pinnedPosition: pinnedPosition, isSiblingFocused: isSiblingFocused } = ownerState;
    const isColumnSortable = colDef.sortable && !disableColumnSorting;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            isColumnSortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === $jZka4.PinnedColumnPosition.LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT && 'columnHeader--pinnedRight',
            // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
            // See https://github.com/mui/mui-x/pull/14559
            isSiblingFocused && 'columnHeader--siblingFocused'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $83044eba4b8e40dc$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $83044eba4b8e40dc$var$GridColumnHeaderItem(props) {
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, isLast: isLast, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const headerCellRef = $83044eba4b8e40dc$var$React.useRef(null);
    const columnMenuId = (0, $83044eba4b8e40dc$var$_useId.default)();
    const columnMenuButtonId = (0, $83044eba4b8e40dc$var$_useId.default)();
    const iconButtonRef = $83044eba4b8e40dc$var$React.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $83044eba4b8e40dc$var$React.useState(columnMenuOpen);
    const columnMenuSlotProps = rootProps.slotProps?.columnMenu;
    const columnMenuComponent = rootProps.slots.columnMenu;
    const defaultSlots = columnMenuComponent?.defaultSlots;
    const defaultSlotProps = columnMenuComponent?.defaultSlotProps;
    const hasKnownDefaultColumnMenu = defaultSlots != null && defaultSlotProps != null;
    const columnMenuItemKeys = $83044eba4b8e40dc$var$React.useMemo(()=>{
        if (!hasKnownDefaultColumnMenu) return [];
        return (0, $5pZ0O.getColumnMenuItemKeys)({
            apiRef: apiRef,
            colDef: colDef,
            defaultSlots: defaultSlots,
            defaultSlotProps: defaultSlotProps,
            slots: columnMenuSlotProps?.slots,
            slotProps: columnMenuSlotProps?.slotProps
        });
    }, [
        apiRef,
        colDef,
        defaultSlotProps,
        defaultSlots,
        hasKnownDefaultColumnMenu,
        columnMenuSlotProps?.slotProps,
        columnMenuSlotProps?.slots
    ]);
    // If we don't have a "known" default column menu (i.e. a custom menu component
    // without `defaultSlots` / `defaultSlotProps` statics), we treat it as opaque
    // and assume it has items, so we always show the column menu icon.
    // Only the built-in/default menu path can hide the icon when there are no items.
    const hasColumnMenuItems = !hasKnownDefaultColumnMenu || columnMenuItemKeys.length > 0;
    const isDraggable = !rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder;
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $83044eba4b8e40dc$var$_extends2.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    const classes = $83044eba4b8e40dc$var$useUtilityClasses(ownerState);
    const publish = $83044eba4b8e40dc$var$React.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $83044eba4b8e40dc$var$React.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onContextMenu: publish('columnHeaderContextMenu'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $83044eba4b8e40dc$var$React.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEndCapture: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $83044eba4b8e40dc$var$React.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $83044eba4b8e40dc$var$React.useEffect(()=>{
        if (!showColumnMenuIcon && columnMenuOpen) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    $83044eba4b8e40dc$var$React.useEffect(()=>{
        if (hasKnownDefaultColumnMenu && columnMenuOpen && !hasColumnMenuItems) apiRef.current.hideColumnMenu();
    }, [
        apiRef,
        columnMenuOpen,
        hasColumnMenuItems,
        hasKnownDefaultColumnMenu
    ]);
    const handleExited = $83044eba4b8e40dc$var$React.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && hasColumnMenuItems && /*#__PURE__*/ (0, $ayMG0.jsx)($6ZYGg.ColumnHeaderMenuIcon, {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $ayMG0.jsx)($le8d8.GridColumnHeaderMenu, {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: rootProps.slotProps?.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)($83044eba4b8e40dc$var$React.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $83044eba4b8e40dc$var$_extends2.default)({
                field: colDef.field,
                counter: filterItemsCounter
            }, rootProps.slotProps?.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnHeaderSortIcon, (0, $83044eba4b8e40dc$var$_extends2.default)({
                field: colDef.field,
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            }, rootProps.slotProps?.columnHeaderSortIcon))
        ]
    });
    $83044eba4b8e40dc$var$React.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $g2vKb.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = colDef.headerName ?? colDef.field;
    const style = $83044eba4b8e40dc$var$React.useMemo(()=>(0, $94sAG.attachPinnedStyle)((0, $83044eba4b8e40dc$var$_extends2.default)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4cOaX.GridGenericColumnHeaderItem, (0, $83044eba4b8e40dc$var$_extends2.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: (0, $83044eba4b8e40dc$var$_clsx.default)(headerClassName, isLast && $5H1vo.gridClasses['columnHeader--last']),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
const $83044eba4b8e40dc$var$Memoized = module.exports.GridColumnHeaderItem = (0, $2nKmT.fastMemo)($83044eba4b8e40dc$var$GridColumnHeaderItem);

});
parcelRegister("5pZ0O", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3f1e9d4e88f2068d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getColumnMenuItemKeys = $3f1e9d4e88f2068d$var$getColumnMenuItemKeys;

var $3f1e9d4e88f2068d$var$_extends2 = $3f1e9d4e88f2068d$require$_interopRequireDefault((parcelRequire("3p9rK")));
/**
 * Returns the list of column menu item keys (sorted by `displayOrder`) that should be rendered for a given column.
 * This is shared between the column header (to know if menu is empty) and the menu itself (to render items).
 */ function $3f1e9d4e88f2068d$var$getColumnMenuItemKeys(params) {
    const { apiRef: apiRef, colDef: colDef, defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {} } = params;
    const processedComponents = (0, $3f1e9d4e88f2068d$var$_extends2.default)({}, defaultSlots, slots);
    let processedSlotProps = defaultSlotProps;
    if (slotProps && Object.keys(slotProps).length > 0) {
        const mergedProps = (0, $3f1e9d4e88f2068d$var$_extends2.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $3f1e9d4e88f2068d$var$_extends2.default)({}, currentSlotProps, slotProps[key] || {});
        });
        processedSlotProps = mergedProps;
    }
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], colDef);
    const defaultComponentKeys = Object.keys(defaultSlots);
    const userItems = Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    const uniqueItems = Array.from(new Set([
        ...defaultItems,
        ...userItems
    ]));
    const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
    return cleansedItems.sort((a, b)=>{
        const leftItemProps = processedSlotProps[a];
        const rightItemProps = processedSlotProps[b];
        const leftDisplayOrder = Number.isFinite(leftItemProps?.displayOrder) ? leftItemProps.displayOrder : 100;
        const rightDisplayOrder = Number.isFinite(rightItemProps?.displayOrder) ? rightItemProps.displayOrder : 100;
        return leftDisplayOrder - rightDisplayOrder;
    });
}

});

parcelRegister("6ZYGg", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5187827afc33a627$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5187827afc33a627$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColumnHeaderMenuIcon = void 0;

var $5187827afc33a627$var$_extends2 = $5187827afc33a627$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5187827afc33a627$var$React = $5187827afc33a627$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5187827afc33a627$var$_composeClasses = $5187827afc33a627$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $5187827afc33a627$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $5187827afc33a627$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $5187827afc33a627$var$ColumnHeaderMenuIcon = module.exports.ColumnHeaderMenuIcon = /*#__PURE__*/ $5187827afc33a627$var$React.memo((props)=>{
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $5187827afc33a627$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $5187827afc33a627$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $5187827afc33a627$var$React.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    const columnName = colDef.headerName ?? colDef.field;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $5187827afc33a627$var$_extends2.default)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, rootProps.slotProps?.baseTooltip, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $5187827afc33a627$var$_extends2.default)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuAriaLabel')(columnName),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "inherit"
                })
            }))
        }))
    });
});

});

parcelRegister("le8d8", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f741464eaaf59d11$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f741464eaaf59d11$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaderMenu = $f741464eaaf59d11$var$GridColumnHeaderMenu;

var $f741464eaaf59d11$var$_extends2 = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f741464eaaf59d11$var$React = $f741464eaaf59d11$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f741464eaaf59d11$var$_propTypes = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f741464eaaf59d11$var$_useEventCallback = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $f741464eaaf59d11$var$_HTMLElementType = $f741464eaaf59d11$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $bDyDY = parcelRequire("bDyDY");

var $ch6XH = parcelRequire("ch6XH");

var $ayMG0 = parcelRequire("ayMG0");
function $f741464eaaf59d11$var$GridColumnHeaderMenu({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $f741464eaaf59d11$var$_useEventCallback.default)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target?.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ch6XH.GridMenu, {
        position: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContentComponent, (0, $f741464eaaf59d11$var$_extends2.default)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}

});

parcelRegister("4cOaX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $30ff34474d4fdbcc$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $30ff34474d4fdbcc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridGenericColumnHeaderItem = void 0;

var $30ff34474d4fdbcc$var$_extends2 = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $30ff34474d4fdbcc$var$_objectWithoutPropertiesLoose2 = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("c05no")));

var $30ff34474d4fdbcc$var$React = $30ff34474d4fdbcc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $30ff34474d4fdbcc$var$_clsx = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("9QePP")));

var $30ff34474d4fdbcc$var$_useForkRef = $30ff34474d4fdbcc$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $2jUq6 = parcelRequire("2jUq6");

var $c0AIV = parcelRequire("c0AIV");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $30ff34474d4fdbcc$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "style"
];
const $30ff34474d4fdbcc$var$GridGenericColumnHeaderItem = module.exports.GridGenericColumnHeaderItem = (0, $fYxgT.forwardRef)(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps, style: style } = props, other = (0, $30ff34474d4fdbcc$var$_objectWithoutPropertiesLoose2.default)(props, $30ff34474d4fdbcc$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const headerCellRef = $30ff34474d4fdbcc$var$React.useRef(null);
    const handleRef = (0, $30ff34474d4fdbcc$var$_useForkRef.default)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $30ff34474d4fdbcc$var$_extends2.default)({
        className: (0, $30ff34474d4fdbcc$var$_clsx.default)(classes.root, headerClassName),
        style: (0, $30ff34474d4fdbcc$var$_extends2.default)({}, style, {
            width: width
        }),
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $30ff34474d4fdbcc$var$_extends2.default)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $ayMG0.jsx)($2jUq6.GridColumnHeaderTitle, {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c0AIV.GridColumnHeaderSeparator, (0, $30ff34474d4fdbcc$var$_extends2.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});

});
parcelRegister("2jUq6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1b091ef728f7a646$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1b091ef728f7a646$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaderTitle = $1b091ef728f7a646$var$GridColumnHeaderTitle;

var $1b091ef728f7a646$var$_extends2 = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1b091ef728f7a646$var$_objectWithoutPropertiesLoose2 = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("c05no")));

var $1b091ef728f7a646$var$React = $1b091ef728f7a646$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1b091ef728f7a646$var$_propTypes = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1b091ef728f7a646$var$_clsx = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1b091ef728f7a646$var$_composeClasses = $1b091ef728f7a646$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $KtEo5 = parcelRequire("KtEo5");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1b091ef728f7a646$var$_excluded = [
    "className",
    "aria-label"
];
const $1b091ef728f7a646$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $1b091ef728f7a646$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $1b091ef728f7a646$var$GridColumnHeaderTitleRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle'
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)',
    lineHeight: 'normal'
});
const $1b091ef728f7a646$var$ColumnHeaderInnerTitle = (0, $fYxgT.forwardRef)(function ColumnHeaderInnerTitle(props, ref) {
    // Tooltip adds aria-label to the props, which is not needed since the children prop is a string
    // See https://github.com/mui/mui-x/pull/14482
    const { className: className } = props, other = (0, $1b091ef728f7a646$var$_objectWithoutPropertiesLoose2.default)(props, $1b091ef728f7a646$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1b091ef728f7a646$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$GridColumnHeaderTitleRoot, (0, $1b091ef728f7a646$var$_extends2.default)({
        className: (0, $1b091ef728f7a646$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $1b091ef728f7a646$var$GridColumnHeaderTitle(props) {
    const { label: label, description: description } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const titleRef = $1b091ef728f7a646$var$React.useRef(null);
    const [tooltip, setTooltip] = $1b091ef728f7a646$var$React.useState('');
    const handleMouseOver = $1b091ef728f7a646$var$React.useCallback(()=>{
        if (!description && titleRef?.current) {
            const isOver = (0, $KtEo5.isOverflown)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $1b091ef728f7a646$var$_extends2.default)({
        title: description || tooltip
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b091ef728f7a646$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}

});
parcelRegister("KtEo5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeOperandAttributeSelector = $08bb4bf24f47b880$var$escapeOperandAttributeSelector;
module.exports.findGridCellElementsFromCol = $08bb4bf24f47b880$var$findGridCellElementsFromCol;
module.exports.findGridCells = $08bb4bf24f47b880$var$findGridCells;
module.exports.findGridElement = $08bb4bf24f47b880$var$findGridElement;
module.exports.findGridHeader = $08bb4bf24f47b880$var$findGridHeader;
module.exports.findGridHeaderFilter = $08bb4bf24f47b880$var$findGridHeaderFilter;
module.exports.findGroupHeaderElementsFromField = $08bb4bf24f47b880$var$findGroupHeaderElementsFromField;
module.exports.findHeaderElementFromField = $08bb4bf24f47b880$var$findHeaderElementFromField;
module.exports.findLeftPinnedCellsAfterCol = $08bb4bf24f47b880$var$findLeftPinnedCellsAfterCol;
module.exports.findLeftPinnedHeadersAfterCol = $08bb4bf24f47b880$var$findLeftPinnedHeadersAfterCol;
module.exports.findParentElementFromClassName = $08bb4bf24f47b880$var$findParentElementFromClassName;
module.exports.findRightPinnedCellsBeforeCol = $08bb4bf24f47b880$var$findRightPinnedCellsBeforeCol;
module.exports.findRightPinnedHeadersBeforeCol = $08bb4bf24f47b880$var$findRightPinnedHeadersBeforeCol;
module.exports.getActiveElement = void 0;
module.exports.getFieldFromHeaderElem = $08bb4bf24f47b880$var$getFieldFromHeaderElem;
module.exports.getFieldsFromGroupHeaderElem = $08bb4bf24f47b880$var$getFieldsFromGroupHeaderElem;
module.exports.getGridCellElement = $08bb4bf24f47b880$var$getGridCellElement;
module.exports.getGridColumnHeaderElement = $08bb4bf24f47b880$var$getGridColumnHeaderElement;
module.exports.getGridRowElement = $08bb4bf24f47b880$var$getGridRowElement;
module.exports.isEventTargetInPortal = $08bb4bf24f47b880$var$isEventTargetInPortal;
module.exports.isOverflown = $08bb4bf24f47b880$var$isOverflown;

var $5H1vo = parcelRequire("5H1vo");
function $08bb4bf24f47b880$var$isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $08bb4bf24f47b880$var$findParentElementFromClassName(elem, className) {
    return elem.closest(`.${className}`);
}
// TODO, eventually replaces this function with CSS.escape, once available in jsdom, either added manually or built in
// https://github.com/jsdom/jsdom/issues/1550#issuecomment-236734471
function $08bb4bf24f47b880$var$escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $08bb4bf24f47b880$var$getGridColumnHeaderElement(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`);
}
function $08bb4bf24f47b880$var$getGridRowElementSelector(id) {
    return `.${$5H1vo.gridClasses.row}[data-id="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(String(id))}"]`;
}
function $08bb4bf24f47b880$var$getGridRowElement(root, id) {
    return root.querySelector($08bb4bf24f47b880$var$getGridRowElementSelector(id));
}
function $08bb4bf24f47b880$var$getGridCellElement(root, { id: id, field: field }) {
    const rowSelector = $08bb4bf24f47b880$var$getGridRowElementSelector(id);
    const cellSelector = `.${$5H1vo.gridClasses.cell}[data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $08bb4bf24f47b880$var$getActiveElement = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $08bb4bf24f47b880$var$getActiveElement(activeEl.shadowRoot);
    return activeEl;
};
module.exports.getActiveElement = $08bb4bf24f47b880$var$getActiveElement;
function $08bb4bf24f47b880$var$isEventTargetInPortal(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function $08bb4bf24f47b880$var$getFieldFromHeaderElem(colCellEl) {
    return colCellEl.getAttribute('data-field');
}
function $08bb4bf24f47b880$var$findHeaderElementFromField(elem, field) {
    return elem.querySelector(`[data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`);
}
function $08bb4bf24f47b880$var$getFieldsFromGroupHeaderElem(colCellEl) {
    return colCellEl.getAttribute('data-fields').slice(2, -2).split('-|-');
}
function $08bb4bf24f47b880$var$findGroupHeaderElementsFromField(elem, field) {
    return Array.from(elem.querySelectorAll(`[data-fields*="|-${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}-|"]`) ?? []);
}
function $08bb4bf24f47b880$var$findGridCellElementsFromCol(col, api) {
    const root = $08bb4bf24f47b880$var$findParentElementFromClassName(col, $5H1vo.gridClasses.root);
    if (!root) throw new Error('MUI X: The root element is not found.');
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!api.virtualScrollerRef?.current) return [];
    $08bb4bf24f47b880$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $08bb4bf24f47b880$var$findGridElement(api, klass) {
    return api.rootElementRef.current.querySelector(`.${$5H1vo.gridClasses[klass]}`);
}
const $08bb4bf24f47b880$var$findPinnedCells = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (colIndex === null) return [];
    const cells = [];
    $08bb4bf24f47b880$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        rowElement.querySelectorAll(`.${$5H1vo.gridClasses[position === 'left' ? 'cell--pinnedLeft' : 'cell--pinnedRight']}`).forEach((cell)=>{
            const currentColIndex = $08bb4bf24f47b880$var$parseCellColIndex(cell);
            if (currentColIndex !== null && filterFn(currentColIndex)) cells.push(cell);
        });
    });
    return cells;
};
function $08bb4bf24f47b880$var$findLeftPinnedCellsAfterCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'right' : 'left',
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $08bb4bf24f47b880$var$findRightPinnedCellsBeforeCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'left' : 'right',
        filterFn: (index)=>isRtl ? index > colIndex : index < colIndex
    });
}
const $08bb4bf24f47b880$var$findPinnedHeaders = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (!api.columnHeadersContainerRef?.current) return [];
    if (colIndex === null) return [];
    const elements = [];
    api.columnHeadersContainerRef.current.querySelectorAll(`.${$5H1vo.gridClasses[position === 'left' ? 'columnHeader--pinnedLeft' : 'columnHeader--pinnedRight']}`).forEach((element)=>{
        const currentColIndex = $08bb4bf24f47b880$var$parseCellColIndex(element);
        if (currentColIndex !== null && filterFn(currentColIndex, element)) elements.push(element);
    });
    return elements;
};
function $08bb4bf24f47b880$var$findLeftPinnedHeadersAfterCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'right' : 'left',
        colIndex: colIndex,
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $08bb4bf24f47b880$var$findRightPinnedHeadersBeforeCol(api, col, isRtl) {
    const colIndex = $08bb4bf24f47b880$var$parseCellColIndex(col);
    return $08bb4bf24f47b880$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'left' : 'right',
        colIndex: colIndex,
        filterFn: (index, element)=>{
            if (element.classList.contains($5H1vo.gridClasses['columnHeader--last'])) return false;
            return isRtl ? index > colIndex : index < colIndex;
        }
    });
}
function $08bb4bf24f47b880$var$findGridHeader(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > div > [data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"][role="columnheader"]`);
}
function $08bb4bf24f47b880$var$findGridHeaderFilter(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > .${$5H1vo.gridClasses.headerFilterRow} > [data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"]`);
}
function $08bb4bf24f47b880$var$findGridCells(api, field) {
    const container = api.virtualScrollerRef.current;
    return Array.from(container.querySelectorAll(`:scope > div > div > div > [data-field="${$08bb4bf24f47b880$var$escapeOperandAttributeSelector(field)}"][role="gridcell"]`));
}
function $08bb4bf24f47b880$var$queryRows(api) {
    return api.virtualScrollerRef.current.querySelectorAll(// Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${$5H1vo.gridClasses.row}`);
}
function $08bb4bf24f47b880$var$parseCellColIndex(col) {
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return null;
    return Number(ariaColIndex) - 1;
}

});


parcelRegister("c0AIV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8be1f8ad99c6bade$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8be1f8ad99c6bade$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaderSeparatorSides = module.exports.GridColumnHeaderSeparator = void 0;

var $8be1f8ad99c6bade$var$_extends2 = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8be1f8ad99c6bade$var$_objectWithoutPropertiesLoose2 = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("c05no")));

var $8be1f8ad99c6bade$var$React = $8be1f8ad99c6bade$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8be1f8ad99c6bade$var$_propTypes = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8be1f8ad99c6bade$var$_composeClasses = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8be1f8ad99c6bade$var$_capitalize = $8be1f8ad99c6bade$require$_interopRequireDefault((parcelRequire("4O6za")));

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $8be1f8ad99c6bade$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorSides = module.exports.GridColumnHeaderSeparatorSides = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($8be1f8ad99c6bade$var$GridColumnHeaderSeparatorSides || {});
const $8be1f8ad99c6bade$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $8be1f8ad99c6bade$var$_capitalize.default)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $8be1f8ad99c6bade$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $8be1f8ad99c6bade$var$GridColumnHeaderSeparatorSides.Right } = props, other = (0, $8be1f8ad99c6bade$var$_objectWithoutPropertiesLoose2.default)(props, $8be1f8ad99c6bade$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $8be1f8ad99c6bade$var$_extends2.default)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $8be1f8ad99c6bade$var$useUtilityClasses(ownerState);
    const stopClick = $8be1f8ad99c6bade$var$React.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $ayMG0.jsx)("div", (0, $8be1f8ad99c6bade$var$_extends2.default)({
        className: classes.root,
        style: {
            minHeight: height
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $8be1f8ad99c6bade$var$GridColumnHeaderSeparator = module.exports.GridColumnHeaderSeparator = /*#__PURE__*/ $8be1f8ad99c6bade$var$React.memo($8be1f8ad99c6bade$var$GridColumnHeaderSeparatorRaw);

});



parcelRegister("960Cz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $69f527f26ff57ed6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $69f527f26ff57ed6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaderSortIcon = void 0;

var $69f527f26ff57ed6$var$_extends2 = $69f527f26ff57ed6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $69f527f26ff57ed6$var$React = $69f527f26ff57ed6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $69f527f26ff57ed6$var$_propTypes = $69f527f26ff57ed6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $j4crP = parcelRequire("j4crP");

var $6l6HT = parcelRequire("6l6HT");

var $ayMG0 = parcelRequire("ayMG0");
function $69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($j4crP.GridIconButtonContainer, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($6l6HT.GridColumnSortButton, (0, $69f527f26ff57ed6$var$_extends2.default)({}, props, {
            tabIndex: -1
        }))
    });
}
const $69f527f26ff57ed6$var$GridColumnHeaderSortIcon = module.exports.GridColumnHeaderSortIcon = /*#__PURE__*/ $69f527f26ff57ed6$var$React.memo($69f527f26ff57ed6$var$GridColumnHeaderSortIconRaw);

});
parcelRegister("j4crP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $de180beae3cc7fe7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $de180beae3cc7fe7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridIconButtonContainer = void 0;

var $de180beae3cc7fe7$var$_extends2 = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $de180beae3cc7fe7$var$_objectWithoutPropertiesLoose2 = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("c05no")));

var $de180beae3cc7fe7$var$React = $de180beae3cc7fe7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $de180beae3cc7fe7$var$_clsx = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $de180beae3cc7fe7$var$_composeClasses = $de180beae3cc7fe7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $de180beae3cc7fe7$var$_excluded = [
    "className"
];
const $de180beae3cc7fe7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $de180beae3cc7fe7$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $de180beae3cc7fe7$var$GridIconButtonContainerRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer'
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $de180beae3cc7fe7$var$GridIconButtonContainer = module.exports.GridIconButtonContainer = (0, $fYxgT.forwardRef)(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $de180beae3cc7fe7$var$_objectWithoutPropertiesLoose2.default)(props, $de180beae3cc7fe7$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $de180beae3cc7fe7$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($de180beae3cc7fe7$var$GridIconButtonContainerRoot, (0, $de180beae3cc7fe7$var$_extends2.default)({
        className: (0, $de180beae3cc7fe7$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});

parcelRegister("6l6HT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $49d9e81a7977b781$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $49d9e81a7977b781$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnSortButton = $49d9e81a7977b781$var$GridColumnSortButton;

var $49d9e81a7977b781$var$_objectWithoutPropertiesLoose2 = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("c05no")));

var $49d9e81a7977b781$var$_extends2 = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $49d9e81a7977b781$var$React = $49d9e81a7977b781$require$_interopRequireWildcard((parcelRequire("acw62")));

var $49d9e81a7977b781$var$_propTypes = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $49d9e81a7977b781$var$_composeClasses = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $49d9e81a7977b781$var$_clsx = $49d9e81a7977b781$require$_interopRequireDefault((parcelRequire("9QePP")));

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $hbuUJ = parcelRequire("hbuUJ");

var $j0vMH = parcelRequire("j0vMH");

var $ayMG0 = parcelRequire("ayMG0");
const $49d9e81a7977b781$var$_excluded = [
    "direction",
    "index",
    "sortingOrder",
    "disabled",
    "className"
];
const $49d9e81a7977b781$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'sortButton'
        ],
        icon: [
            'sortIcon'
        ]
    };
    return (0, $49d9e81a7977b781$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $49d9e81a7977b781$var$GridColumnSortButtonRoot = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'SortButton'
})({
    transition: $hbuUJ.vars.transition([
        'opacity'
    ], {
        duration: $hbuUJ.vars.transitions.duration.short,
        easing: $hbuUJ.vars.transitions.easing.easeInOut
    })
});
function $49d9e81a7977b781$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $49d9e81a7977b781$var$_extends2.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $49d9e81a7977b781$var$GridColumnSortButton(props) {
    const { direction: direction, index: index, sortingOrder: sortingOrder, disabled: disabled, className: className } = props, other = (0, $49d9e81a7977b781$var$_objectWithoutPropertiesLoose2.default)(props, $49d9e81a7977b781$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $49d9e81a7977b781$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $49d9e81a7977b781$var$useUtilityClasses(ownerState);
    const iconElement = $49d9e81a7977b781$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)($49d9e81a7977b781$var$GridColumnSortButtonRoot, (0, $49d9e81a7977b781$var$_extends2.default)({
        as: rootProps.slots.baseIconButton,
        ownerState: ownerState,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small",
        disabled: disabled,
        className: (0, $49d9e81a7977b781$var$_clsx.default)(classes.root, className)
    }, rootProps.slotProps?.baseIconButton, other, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $49d9e81a7977b781$var$_extends2.default)({
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                index != null && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: index,
                    color: "default",
                    overlap: "circular",
                    children: iconButton
                }),
                index == null && iconButton
            ]
        })
    }));
}

});


parcelRegister("k8xn5", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ea8e70d6ac9b663f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ea8e70d6ac9b663f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaderFilterIconButton = $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButtonWrapped;

var $ea8e70d6ac9b663f$var$_extends2 = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ea8e70d6ac9b663f$var$React = $ea8e70d6ac9b663f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ea8e70d6ac9b663f$var$_propTypes = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ea8e70d6ac9b663f$var$_composeClasses = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ea8e70d6ac9b663f$var$_useId = $ea8e70d6ac9b663f$require$_interopRequireDefault((parcelRequire("hwliF")));

var $iAdzh = parcelRequire("iAdzh");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $j4crP = parcelRequire("j4crP");

var $ayMG0 = parcelRequire("ayMG0");
const $ea8e70d6ac9b663f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $ea8e70d6ac9b663f$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButtonWrapped(props) {
    if (!props.counter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton, (0, $ea8e70d6ac9b663f$var$_extends2.default)({}, props));
}
function $ea8e70d6ac9b663f$var$GridColumnHeaderFilterIconButton(props) {
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = (0, $ea8e70d6ac9b663f$var$_extends2.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = $ea8e70d6ac9b663f$var$useUtilityClasses(ownerState);
    const labelId = (0, $ea8e70d6ac9b663f$var$_useId.default)();
    const isOpen = (0, $iAdzh.useGridSelector)(apiRef, $6X2Yd.gridPreferencePanelSelectorWithLabel, labelId);
    const panelId = (0, $ea8e70d6ac9b663f$var$_useId.default)();
    const toggleFilter = $ea8e70d6ac9b663f$var$React.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef);
        if (open && openedPanelValue === $3PCYS.GridPreferencePanelsValue.filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const iconButton = /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $ea8e70d6ac9b663f$var$_extends2.default)({
        id: labelId,
        onClick: toggleFilter,
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": isOpen ? panelId : undefined
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $ea8e70d6ac9b663f$var$_extends2.default)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($j4crP.GridIconButtonContainer, {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}

});


parcelRegister("8fd6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fgOJy = parcelRequire("fgOJy");
Object.keys($fgOJy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fgOJy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fgOJy[key];
        }
    });
});

var $4l3r5 = parcelRequire("4l3r5");
Object.keys($4l3r5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4l3r5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4l3r5[key];
        }
    });
});

});

parcelRegister("fWql6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridVisibilityOffIcon = module.exports.GridViewStreamIcon = module.exports.GridViewHeadlineIcon = module.exports.GridViewColumnIcon = module.exports.GridUndoIcon = module.exports.GridTripleDotsVerticalIcon = module.exports.GridTableRowsIcon = module.exports.GridSeparatorIcon = module.exports.GridSearchIcon = module.exports.GridRemoveIcon = module.exports.GridRedoIcon = module.exports.GridMoreVertIcon = module.exports.GridMenuIcon = module.exports.GridLongTextCellExpandIcon = module.exports.GridLongTextCellCollapseIcon = module.exports.GridLoadIcon = module.exports.GridKeyboardArrowRight = module.exports.GridFilterListIcon = module.exports.GridFilterAltIcon = module.exports.GridExpandMoreIcon = module.exports.GridDragIcon = module.exports.GridDownloadIcon = module.exports.GridDeleteIcon = module.exports.GridDeleteForeverIcon = module.exports.GridColumnIcon = module.exports.GridCloseIcon = module.exports.GridClearIcon = module.exports.GridCheckIcon = module.exports.GridCheckCircleIcon = module.exports.GridArrowUpwardIcon = module.exports.GridArrowDownwardIcon = module.exports.GridAddIcon = void 0;

var $c69f0 = parcelRequire("c69f0");

var $ayMG0 = parcelRequire("ayMG0");
const $b9b0b441ce479047$var$GridArrowUpwardIcon = module.exports.GridArrowUpwardIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $b9b0b441ce479047$var$GridArrowDownwardIcon = module.exports.GridArrowDownwardIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $b9b0b441ce479047$var$GridKeyboardArrowRight = module.exports.GridKeyboardArrowRight = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $b9b0b441ce479047$var$GridExpandMoreIcon = module.exports.GridExpandMoreIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $b9b0b441ce479047$var$GridFilterListIcon = module.exports.GridFilterListIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $b9b0b441ce479047$var$GridFilterAltIcon = module.exports.GridFilterAltIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $b9b0b441ce479047$var$GridSearchIcon = module.exports.GridSearchIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $b9b0b441ce479047$var$GridMenuIcon = module.exports.GridMenuIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $b9b0b441ce479047$var$GridCheckCircleIcon = module.exports.GridCheckCircleIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $b9b0b441ce479047$var$GridUndoIcon = module.exports.GridUndoIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8"
}), 'Undo');
const $b9b0b441ce479047$var$GridRedoIcon = module.exports.GridRedoIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7z"
}), 'Redo');
const $b9b0b441ce479047$var$GridColumnIcon = module.exports.GridColumnIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), 'ColumnIcon');
const $b9b0b441ce479047$var$GridSeparatorIcon = module.exports.GridSeparatorIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
    width: "1",
    height: "24",
    x: "11.5",
    rx: "0.5"
}), 'Separator');
const $b9b0b441ce479047$var$GridViewHeadlineIcon = module.exports.GridViewHeadlineIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $b9b0b441ce479047$var$GridTableRowsIcon = module.exports.GridTableRowsIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $b9b0b441ce479047$var$GridViewStreamIcon = module.exports.GridViewStreamIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $b9b0b441ce479047$var$GridTripleDotsVerticalIcon = module.exports.GridTripleDotsVerticalIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $b9b0b441ce479047$var$GridCloseIcon = module.exports.GridCloseIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $b9b0b441ce479047$var$GridAddIcon = module.exports.GridAddIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $b9b0b441ce479047$var$GridRemoveIcon = module.exports.GridRemoveIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $b9b0b441ce479047$var$GridLoadIcon = module.exports.GridLoadIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $b9b0b441ce479047$var$GridDragIcon = module.exports.GridDragIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $b9b0b441ce479047$var$GridCheckIcon = module.exports.GridCheckIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $b9b0b441ce479047$var$GridMoreVertIcon = module.exports.GridMoreVertIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $b9b0b441ce479047$var$GridVisibilityOffIcon = module.exports.GridVisibilityOffIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $b9b0b441ce479047$var$GridViewColumnIcon = module.exports.GridViewColumnIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("g", {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $b9b0b441ce479047$var$GridClearIcon = module.exports.GridClearIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Clear');
const $b9b0b441ce479047$var$GridDeleteIcon = module.exports.GridDeleteIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $b9b0b441ce479047$var$GridDeleteForeverIcon = module.exports.GridDeleteForeverIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $b9b0b441ce479047$var$GridDownloadIcon = module.exports.GridDownloadIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');
const $b9b0b441ce479047$var$GridLongTextCellExpandIcon = module.exports.GridLongTextCellExpandIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
}), 'OpenInFull');
const $b9b0b441ce479047$var$GridLongTextCellCollapseIcon = module.exports.GridLongTextCellCollapseIcon = (0, $c69f0.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5z"
}), 'NorthWest');

});
parcelRegister("c69f0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSvgIcon = void 0;

var $hGPki = parcelRequire("hGPki");
const $8ced36a16719fbed$var$createSvgIcon = module.exports.createSvgIcon = $hGPki.createSvgIcon;

});


parcelRegister("famrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7kBtL = parcelRequire("7kBtL");
Object.keys($7kBtL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7kBtL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7kBtL[key];
        }
    });
});

var $ch6XH = parcelRequire("ch6XH");
Object.keys($ch6XH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ch6XH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ch6XH[key];
        }
    });
});

});
parcelRegister("7kBtL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5567793dda12fa70$var$_exportNames = {
    GridGenericColumnMenu: true
};
Object.defineProperty(module.exports, "GridGenericColumnMenu", {
    enumerable: true,
    get: function() {
        return $59mZx.GridGenericColumnMenu;
    }
});

var $le8d8 = parcelRequire("le8d8");
Object.keys($le8d8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $le8d8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $le8d8[key];
        }
    });
});

var $713h2 = parcelRequire("713h2");
Object.keys($713h2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $713h2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $713h2[key];
        }
    });
});

var $unHVj = parcelRequire("unHVj");
Object.keys($unHVj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $unHVj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $unHVj[key];
        }
    });
});

var $59mZx = parcelRequire("59mZx");

var $fEzzu = parcelRequire("fEzzu");
Object.keys($fEzzu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5567793dda12fa70$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fEzzu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fEzzu[key];
        }
    });
});

});
parcelRegister("713h2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("unHVj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $05b53142b9ab08e6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $05b53142b9ab08e6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnMenuContainer = void 0;

var $05b53142b9ab08e6$var$_extends2 = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $05b53142b9ab08e6$var$_objectWithoutPropertiesLoose2 = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("c05no")));

var $05b53142b9ab08e6$var$_clsx = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $05b53142b9ab08e6$var$_propTypes = $05b53142b9ab08e6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $05b53142b9ab08e6$var$React = $05b53142b9ab08e6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $dMF9H = parcelRequire("dMF9H");

var $j0vMH = parcelRequire("j0vMH");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $05b53142b9ab08e6$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $05b53142b9ab08e6$var$StyledMenuList = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    slot: 'internal'
})(()=>({
        minWidth: 248
    }));
function $05b53142b9ab08e6$var$handleMenuScrollCapture(event) {
    if (!event.currentTarget.contains(event.target)) return;
    event.stopPropagation();
}
const $05b53142b9ab08e6$var$GridColumnMenuContainer = module.exports.GridColumnMenuContainer = (0, $fYxgT.forwardRef)(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $05b53142b9ab08e6$var$_objectWithoutPropertiesLoose2.default)(props, $05b53142b9ab08e6$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const handleListKeyDown = $05b53142b9ab08e6$var$React.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $dMF9H.isHideMenuKey)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05b53142b9ab08e6$var$StyledMenuList, (0, $05b53142b9ab08e6$var$_extends2.default)({
        as: rootProps.slots.baseMenuList,
        id: id,
        className: (0, $05b53142b9ab08e6$var$_clsx.default)($5H1vo.gridClasses.menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        onWheel: $05b53142b9ab08e6$var$handleMenuScrollCapture,
        onTouchMove: $05b53142b9ab08e6$var$handleMenuScrollCapture,
        autoFocus: open
    }, other, {
        ref: ref,
        children: children
    }));
});

});

parcelRegister("59mZx", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3bffa0a776b5a050$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridGenericColumnMenu = module.exports.GridColumnMenu = module.exports.GRID_COLUMN_MENU_SLOT_PROPS = module.exports.GRID_COLUMN_MENU_SLOTS = void 0;

var $3bffa0a776b5a050$var$_extends2 = $3bffa0a776b5a050$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3bffa0a776b5a050$var$_objectWithoutPropertiesLoose2 = $3bffa0a776b5a050$require$_interopRequireDefault((parcelRequire("c05no")));

var $3bffa0a776b5a050$var$_propTypes = $3bffa0a776b5a050$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jsV9n = parcelRequire("jsV9n");

var $unHVj = parcelRequire("unHVj");

var $6bz5h = parcelRequire("6bz5h");

var $cYNu4 = parcelRequire("cYNu4");

var $cKFTH = parcelRequire("cKFTH");

var $ayMG0 = parcelRequire("ayMG0");
const $3bffa0a776b5a050$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOTS = module.exports.GRID_COLUMN_MENU_SLOTS = {
    columnMenuSortItem: $cKFTH.GridColumnMenuSortItem,
    columnMenuFilterItem: $cYNu4.GridColumnMenuFilterItem,
    columnMenuColumnsItem: $6bz5h.GridColumnMenuColumnsItem
};
const $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOT_PROPS = module.exports.GRID_COLUMN_MENU_SLOT_PROPS = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $3bffa0a776b5a050$var$GridGenericColumnMenu = module.exports.GridGenericColumnMenu = (0, $fYxgT.forwardRef)(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $3bffa0a776b5a050$var$_objectWithoutPropertiesLoose2.default)(props, $3bffa0a776b5a050$var$_excluded);
    const orderedSlots = (0, $jsV9n.useGridColumnMenuSlots)((0, $3bffa0a776b5a050$var$_extends2.default)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($unHVj.GridColumnMenuContainer, (0, $3bffa0a776b5a050$var$_extends2.default)({}, other, {
        ref: ref,
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $3bffa0a776b5a050$var$_extends2.default)({}, otherProps), index))
    }));
});
const $3bffa0a776b5a050$var$GridColumnMenu = module.exports.GridColumnMenu = (0, $fYxgT.forwardRef)(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bffa0a776b5a050$var$GridGenericColumnMenu, (0, $3bffa0a776b5a050$var$_extends2.default)({}, props, {
        ref: ref,
        defaultSlots: $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOTS,
        defaultSlotProps: $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOT_PROPS
    }));
});
$3bffa0a776b5a050$var$GridColumnMenu.defaultSlots = $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOTS;
$3bffa0a776b5a050$var$GridColumnMenu.defaultSlotProps = $3bffa0a776b5a050$var$GRID_COLUMN_MENU_SLOT_PROPS;

});
parcelRegister("jsV9n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e2bcf6b15e7fbab3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e2bcf6b15e7fbab3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridColumnMenuSlots = void 0;

var $e2bcf6b15e7fbab3$var$_objectWithoutPropertiesLoose2 = $e2bcf6b15e7fbab3$require$_interopRequireDefault((parcelRequire("c05no")));

var $e2bcf6b15e7fbab3$var$_extends2 = $e2bcf6b15e7fbab3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e2bcf6b15e7fbab3$var$React = $e2bcf6b15e7fbab3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");

var $5pZ0O = parcelRequire("5pZ0O");
const $e2bcf6b15e7fbab3$var$_excluded = [
    "displayOrder"
];
const $e2bcf6b15e7fbab3$var$useGridColumnMenuSlots = (props)=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $e2bcf6b15e7fbab3$var$React.useMemo(()=>(0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $e2bcf6b15e7fbab3$var$React.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    return $e2bcf6b15e7fbab3$var$React.useMemo(()=>{
        const sortedKeys = (0, $5pZ0O.getColumnMenuItemKeys)({
            apiRef: apiRef,
            colDef: colDef,
            defaultSlots: defaultSlots,
            defaultSlotProps: defaultSlotProps,
            slots: slots,
            slotProps: slotProps
        });
        return sortedKeys.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $e2bcf6b15e7fbab3$var$_objectWithoutPropertiesLoose2.default)(processedComponentProps, $e2bcf6b15e7fbab3$var$_excluded);
                itemProps = (0, $e2bcf6b15e7fbab3$var$_extends2.default)({}, itemProps, customProps);
            }
            return addDividers && index !== sortedKeys.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    rootProps.slots.baseDivider,
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        apiRef,
        colDef,
        defaultSlotProps,
        defaultSlots,
        hideMenu,
        processedComponents,
        processedSlotProps,
        slotProps,
        slots,
        rootProps.slots.baseDivider
    ]);
};
module.exports.useGridColumnMenuSlots = $e2bcf6b15e7fbab3$var$useGridColumnMenuSlots;

});

parcelRegister("6bz5h", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $480efc1ffdb54f08$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $480efc1ffdb54f08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnMenuColumnsItem = $480efc1ffdb54f08$var$GridColumnMenuColumnsItem;

var $480efc1ffdb54f08$var$_extends2 = $480efc1ffdb54f08$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $480efc1ffdb54f08$var$React = $480efc1ffdb54f08$require$_interopRequireWildcard((parcelRequire("acw62")));

var $480efc1ffdb54f08$var$_propTypes = $480efc1ffdb54f08$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9udtZ = parcelRequire("9udtZ");

var $kGBL7 = parcelRequire("kGBL7");

var $ayMG0 = parcelRequire("ayMG0");
function $480efc1ffdb54f08$var$GridColumnMenuColumnsItem(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($480efc1ffdb54f08$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9udtZ.GridColumnMenuHideItem, (0, $480efc1ffdb54f08$var$_extends2.default)({}, props)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($kGBL7.GridColumnMenuManageItem, (0, $480efc1ffdb54f08$var$_extends2.default)({}, props))
        ]
    });
}

});
parcelRegister("9udtZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e815fc52eaddbf2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e815fc52eaddbf2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnMenuHideItem = $6e815fc52eaddbf2$var$GridColumnMenuHideItem;

var $6e815fc52eaddbf2$var$React = $6e815fc52eaddbf2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e815fc52eaddbf2$var$_propTypes = $6e815fc52eaddbf2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $jy68d = parcelRequire("jy68d");

var $ayMG0 = parcelRequire("ayMG0");
function $6e815fc52eaddbf2$var$GridColumnMenuHideItem(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $jy68d.gridVisibleColumnDefinitionsSelector)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $6e815fc52eaddbf2$var$React.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
        onClick: toggleColumn,
        disabled: disabled,
        iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuHideIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuHideColumn')
    });
}

});

parcelRegister("kGBL7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f0f5050f3d38da77$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f0f5050f3d38da77$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnMenuManageItem = $f0f5050f3d38da77$var$GridColumnMenuManageItem;

var $f0f5050f3d38da77$var$React = $f0f5050f3d38da77$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f0f5050f3d38da77$var$_propTypes = $f0f5050f3d38da77$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f0f5050f3d38da77$var$GridColumnMenuManageItem(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showColumns = $f0f5050f3d38da77$var$React.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences($3PCYS.GridPreferencePanelsValue.columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
        onClick: showColumns,
        iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuManageColumns')
    });
}

});


parcelRegister("cYNu4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $97317925c823a2fa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $97317925c823a2fa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnMenuFilterItem = $97317925c823a2fa$var$GridColumnMenuFilterItem;

var $97317925c823a2fa$var$React = $97317925c823a2fa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $97317925c823a2fa$var$_propTypes = $97317925c823a2fa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $97317925c823a2fa$var$GridColumnMenuFilterItem(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const showFilter = $97317925c823a2fa$var$React.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
        onClick: showFilter,
        iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuFilterIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuFilter')
    });
}

});

parcelRegister("cKFTH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $948a47da9ef72c3c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $948a47da9ef72c3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnMenuSortItem = $948a47da9ef72c3c$var$GridColumnMenuSortItem;

var $948a47da9ef72c3c$var$React = $948a47da9ef72c3c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $948a47da9ef72c3c$var$_propTypes = $948a47da9ef72c3c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5sOMZ = parcelRequire("5sOMZ");

var $iU3u2 = parcelRequire("iU3u2");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $948a47da9ef72c3c$var$GridColumnMenuSortItem(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, $iU3u2.gridSortModelSelector);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const sortDirection = $948a47da9ef72c3c$var$React.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem?.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const onSortMenuItemClick = $948a47da9ef72c3c$var$React.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        const allowMultipleSorting = rootProps.multipleColumnsSortingMode === 'always';
        apiRef.current.sortColumn(colDef.field, direction === sortDirection ? null : direction, allowMultipleSorting);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection,
        rootProps.multipleColumnsSortingMode
    ]);
    if (rootProps.disableColumnSorting || !colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($948a47da9ef72c3c$var$React.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                    fontSize: "small"
                }),
                children: getLabel('columnMenuSortAsc')
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                iconStart: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                    fontSize: "small"
                }),
                children: getLabel('columnMenuSortDesc')
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                iconStart: rootProps.slots.columnMenuUnsortIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnMenuUnsortIcon, {
                    fontSize: "small"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                children: apiRef.current.getLocaleText('columnMenuUnsort')
            }) : null
        ]
    });
}

});


parcelRegister("fEzzu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6bz5h = parcelRequire("6bz5h");
Object.keys($6bz5h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6bz5h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6bz5h[key];
        }
    });
});

var $kGBL7 = parcelRequire("kGBL7");
Object.keys($kGBL7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kGBL7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kGBL7[key];
        }
    });
});

var $cYNu4 = parcelRequire("cYNu4");
Object.keys($cYNu4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cYNu4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cYNu4[key];
        }
    });
});

var $9udtZ = parcelRequire("9udtZ");
Object.keys($9udtZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9udtZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9udtZ[key];
        }
    });
});

var $cKFTH = parcelRequire("cKFTH");
Object.keys($cKFTH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cKFTH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cKFTH[key];
        }
    });
});

});



parcelRegister("b2LZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l98cE = parcelRequire("l98cE");
Object.keys($l98cE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $l98cE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $l98cE[key];
        }
    });
});

var $kfa8b = parcelRequire("kfa8b");
Object.keys($kfa8b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kfa8b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kfa8b[key];
        }
    });
});

var $hbQyH = parcelRequire("hbQyH");
Object.keys($hbQyH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hbQyH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hbQyH[key];
        }
    });
});

var $ip3sX = parcelRequire("ip3sX");
Object.keys($ip3sX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ip3sX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ip3sX[key];
        }
    });
});

var $cpUTD = parcelRequire("cpUTD");
Object.keys($cpUTD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cpUTD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cpUTD[key];
        }
    });
});

var $dQ4Fi = parcelRequire("dQ4Fi");
Object.keys($dQ4Fi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dQ4Fi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dQ4Fi[key];
        }
    });
});

var $adAlP = parcelRequire("adAlP");
Object.keys($adAlP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $adAlP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $adAlP[key];
        }
    });
});

});
parcelRegister("l98cE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f650cd2c2e66a414$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnsPanel = $f650cd2c2e66a414$var$GridColumnsPanel;

var $f650cd2c2e66a414$var$_extends2 = $f650cd2c2e66a414$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $dQ4Fi = parcelRequire("dQ4Fi");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
function $f650cd2c2e66a414$var$GridColumnsPanel(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($dQ4Fi.GridPanelWrapper, (0, $f650cd2c2e66a414$var$_extends2.default)({}, props, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnsManagement, (0, $f650cd2c2e66a414$var$_extends2.default)({}, rootProps.slotProps?.columnsManagement))
    }));
}

});
parcelRegister("dQ4Fi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a133c015d593f0ef$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a133c015d593f0ef$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPanelWrapper = void 0;

var $a133c015d593f0ef$var$_extends2 = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a133c015d593f0ef$var$_objectWithoutPropertiesLoose2 = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("c05no")));

var $a133c015d593f0ef$var$React = $a133c015d593f0ef$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a133c015d593f0ef$var$_clsx = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $a133c015d593f0ef$var$_composeClasses = $a133c015d593f0ef$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $a133c015d593f0ef$var$_excluded = [
    "className"
];
const $a133c015d593f0ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $a133c015d593f0ef$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $a133c015d593f0ef$var$GridPanelWrapperRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper'
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $a133c015d593f0ef$var$GridPanelWrapper = module.exports.GridPanelWrapper = (0, $fYxgT.forwardRef)(function GridPanelWrapper(props, ref) {
    const { className: className } = props, other = (0, $a133c015d593f0ef$var$_objectWithoutPropertiesLoose2.default)(props, $a133c015d593f0ef$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a133c015d593f0ef$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a133c015d593f0ef$var$GridPanelWrapperRoot, (0, $a133c015d593f0ef$var$_extends2.default)({
        tabIndex: -1,
        className: (0, $a133c015d593f0ef$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});

});


parcelRegister("kfa8b", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ebcd112530bc7823$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ebcd112530bc7823$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridPanelClasses = module.exports.GridPanel = void 0;

var $ebcd112530bc7823$var$_extends2 = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ebcd112530bc7823$var$_objectWithoutPropertiesLoose2 = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("c05no")));

var $ebcd112530bc7823$var$React = $ebcd112530bc7823$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ebcd112530bc7823$var$_propTypes = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ebcd112530bc7823$var$_clsx = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $ebcd112530bc7823$var$_generateUtilityClasses = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ebcd112530bc7823$var$_useEventCallback = $ebcd112530bc7823$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $3DWC3 = parcelRequire("3DWC3");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $j0vMH = parcelRequire("j0vMH");

var $ayMG0 = parcelRequire("ayMG0");
const $ebcd112530bc7823$var$_excluded = [
    "children",
    "className",
    "classes",
    "onClose"
];
const $ebcd112530bc7823$var$gridPanelClasses = module.exports.gridPanelClasses = (0, $ebcd112530bc7823$var$_generateUtilityClasses.default)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $ebcd112530bc7823$var$GridPanelRoot = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'panel'
})({
    zIndex: $hbuUJ.vars.zIndex.panel
});
const $ebcd112530bc7823$var$GridPanelContent = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'panelContent'
})({
    backgroundColor: $hbuUJ.vars.colors.background.overlay,
    borderRadius: $hbuUJ.vars.radius.base,
    boxShadow: $hbuUJ.vars.shadows.overlay,
    display: 'flex',
    maxWidth: `calc(100vw - ${$hbuUJ.vars.spacing(2)})`,
    overflow: 'auto'
});
const $ebcd112530bc7823$var$GridPanel = module.exports.GridPanel = (0, $fYxgT.forwardRef)((props, ref)=>{
    const { children: children, className: className, onClose: onClose } = props, other = (0, $ebcd112530bc7823$var$_objectWithoutPropertiesLoose2.default)(props, $ebcd112530bc7823$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $ebcd112530bc7823$var$gridPanelClasses;
    const [isPlaced, setIsPlaced] = $ebcd112530bc7823$var$React.useState(false);
    const variablesClass = (0, $3DWC3.useCSSVariablesClass)();
    const onDidShow = (0, $ebcd112530bc7823$var$_useEventCallback.default)(()=>setIsPlaced(true));
    const onDidHide = (0, $ebcd112530bc7823$var$_useEventCallback.default)(()=>setIsPlaced(false));
    const handleClickAway = (0, $ebcd112530bc7823$var$_useEventCallback.default)(()=>{
        onClose?.();
    });
    const handleKeyDown = (0, $ebcd112530bc7823$var$_useEventCallback.default)((event)=>{
        if (event.key === 'Escape') onClose?.();
    });
    const [fallbackTarget, setFallbackTarget] = $ebcd112530bc7823$var$React.useState(null);
    $ebcd112530bc7823$var$React.useEffect(()=>{
        const panelAnchor = apiRef.current.rootElementRef?.current?.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) setFallbackTarget(panelAnchor);
    }, [
        apiRef
    ]);
    if (!fallbackTarget) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPanelRoot, (0, $ebcd112530bc7823$var$_extends2.default)({
        as: rootProps.slots.basePopper,
        ownerState: rootProps,
        placement: "bottom-end",
        className: (0, $ebcd112530bc7823$var$_clsx.default)(classes.panel, className, variablesClass),
        flip: true,
        onDidShow: onDidShow,
        onDidHide: onDidHide,
        onClickAway: handleClickAway,
        clickAwayMouseEvent: "onPointerUp",
        clickAwayTouchEvent: false,
        focusTrap: true
    }, other, rootProps.slotProps?.basePopper, {
        target: props.target ?? fallbackTarget,
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ebcd112530bc7823$var$GridPanelContent, {
            className: classes.paper,
            ownerState: rootProps,
            onKeyDown: handleKeyDown,
            children: isPlaced && children
        })
    }));
});

});

parcelRegister("hbQyH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c83c3bce08f2b302$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c83c3bce08f2b302$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPanelContent = $c83c3bce08f2b302$var$GridPanelContent;

var $c83c3bce08f2b302$var$_extends2 = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c83c3bce08f2b302$var$_objectWithoutPropertiesLoose2 = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("c05no")));

var $c83c3bce08f2b302$var$React = $c83c3bce08f2b302$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c83c3bce08f2b302$var$_propTypes = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c83c3bce08f2b302$var$_clsx = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $c83c3bce08f2b302$var$_composeClasses = $c83c3bce08f2b302$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $c83c3bce08f2b302$var$_excluded = [
    "className"
];
const $c83c3bce08f2b302$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $c83c3bce08f2b302$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $c83c3bce08f2b302$var$GridPanelContentRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent'
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400,
    padding: $hbuUJ.vars.spacing(2.5, 1.5, 2, 1),
    gap: $hbuUJ.vars.spacing(2.5)
});
function $c83c3bce08f2b302$var$GridPanelContent(props) {
    const { className: className } = props, other = (0, $c83c3bce08f2b302$var$_objectWithoutPropertiesLoose2.default)(props, $c83c3bce08f2b302$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $c83c3bce08f2b302$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c83c3bce08f2b302$var$GridPanelContentRoot, (0, $c83c3bce08f2b302$var$_extends2.default)({
        className: (0, $c83c3bce08f2b302$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("ip3sX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d65d401151f46b4c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d65d401151f46b4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPanelFooter = $d65d401151f46b4c$var$GridPanelFooter;

var $d65d401151f46b4c$var$_extends2 = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d65d401151f46b4c$var$_objectWithoutPropertiesLoose2 = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("c05no")));

var $d65d401151f46b4c$var$React = $d65d401151f46b4c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d65d401151f46b4c$var$_propTypes = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d65d401151f46b4c$var$_clsx = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $d65d401151f46b4c$var$_composeClasses = $d65d401151f46b4c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $d65d401151f46b4c$var$_excluded = [
    "className"
];
const $d65d401151f46b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $d65d401151f46b4c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $d65d401151f46b4c$var$GridPanelFooterRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter'
})({
    padding: $hbuUJ.vars.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
function $d65d401151f46b4c$var$GridPanelFooter(props) {
    const { className: className } = props, other = (0, $d65d401151f46b4c$var$_objectWithoutPropertiesLoose2.default)(props, $d65d401151f46b4c$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $d65d401151f46b4c$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d65d401151f46b4c$var$GridPanelFooterRoot, (0, $d65d401151f46b4c$var$_extends2.default)({
        className: (0, $d65d401151f46b4c$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("cpUTD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90a3f4450bddbd27$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $90a3f4450bddbd27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPanelHeader = $90a3f4450bddbd27$var$GridPanelHeader;

var $90a3f4450bddbd27$var$_extends2 = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $90a3f4450bddbd27$var$_objectWithoutPropertiesLoose2 = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("c05no")));

var $90a3f4450bddbd27$var$React = $90a3f4450bddbd27$require$_interopRequireWildcard((parcelRequire("acw62")));

var $90a3f4450bddbd27$var$_propTypes = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $90a3f4450bddbd27$var$_clsx = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $90a3f4450bddbd27$var$_composeClasses = $90a3f4450bddbd27$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $90a3f4450bddbd27$var$_excluded = [
    "className"
];
const $90a3f4450bddbd27$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelHeader'
        ]
    };
    return (0, $90a3f4450bddbd27$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $90a3f4450bddbd27$var$GridPanelHeaderRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelHeader'
})({
    padding: $hbuUJ.vars.spacing(1)
});
function $90a3f4450bddbd27$var$GridPanelHeader(props) {
    const { className: className } = props, other = (0, $90a3f4450bddbd27$var$_objectWithoutPropertiesLoose2.default)(props, $90a3f4450bddbd27$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $90a3f4450bddbd27$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($90a3f4450bddbd27$var$GridPanelHeaderRoot, (0, $90a3f4450bddbd27$var$_extends2.default)({
        className: (0, $90a3f4450bddbd27$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other));
}

});

parcelRegister("adAlP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $770750dea3c0eca8$var$_exportNames = {
    GridFilterInputValue: true,
    GridFilterInputBoolean: true,
    GridFilterPanel: true
};
Object.defineProperty(module.exports, "GridFilterInputBoolean", {
    enumerable: true,
    get: function() {
        return $hAdXB.GridFilterInputBoolean;
    }
});
Object.defineProperty(module.exports, "GridFilterInputValue", {
    enumerable: true,
    get: function() {
        return $g7hyo.GridFilterInputValue;
    }
});
Object.defineProperty(module.exports, "GridFilterPanel", {
    enumerable: true,
    get: function() {
        return $kWNEF.GridFilterPanel;
    }
});

var $9De9Z = parcelRequire("9De9Z");
Object.keys($9De9Z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9De9Z[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9De9Z[key];
        }
    });
});

var $g7hyo = parcelRequire("g7hyo");

var $5y3Nn = parcelRequire("5y3Nn");
Object.keys($5y3Nn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5y3Nn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5y3Nn[key];
        }
    });
});

var $4UMDV = parcelRequire("4UMDV");
Object.keys($4UMDV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4UMDV[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4UMDV[key];
        }
    });
});

var $hAdXB = parcelRequire("hAdXB");

var $kWNEF = parcelRequire("kWNEF");

var $6tiPX = parcelRequire("6tiPX");
Object.keys($6tiPX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6tiPX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6tiPX[key];
        }
    });
});

var $DRQFc = parcelRequire("DRQFc");
Object.keys($DRQFc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($770750dea3c0eca8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $DRQFc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $DRQFc[key];
        }
    });
});

});
parcelRegister("9De9Z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7032bd7e5a458ec9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7032bd7e5a458ec9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFilterForm = void 0;

var $7032bd7e5a458ec9$var$_extends2 = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7032bd7e5a458ec9$var$_objectWithoutPropertiesLoose2 = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("c05no")));

var $7032bd7e5a458ec9$var$_react = $7032bd7e5a458ec9$require$_interopRequireWildcard((parcelRequire("acw62")));
var $7032bd7e5a458ec9$var$React = $7032bd7e5a458ec9$var$_react;

var $7032bd7e5a458ec9$var$_propTypes = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7032bd7e5a458ec9$var$_clsx = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7032bd7e5a458ec9$var$_composeClasses = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $7032bd7e5a458ec9$var$_useId = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("hwliF")));

var $7032bd7e5a458ec9$var$_capitalize = $7032bd7e5a458ec9$require$_interopRequireDefault((parcelRequire("4O6za")));

var $8xDHs = parcelRequire("8xDHs");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $jQEEt = parcelRequire("jQEEt");

var $k278Q = parcelRequire("k278Q");

var $5sOMZ = parcelRequire("5sOMZ");

var $9jXuN = parcelRequire("9jXuN");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $5z7Pl = parcelRequire("5z7Pl");

var $3ULRg = parcelRequire("3ULRg");

var $ayMG0 = parcelRequire("ayMG0");
const $7032bd7e5a458ec9$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "readOnly",
    "children"
], $7032bd7e5a458ec9$var$_excluded2 = [
    "InputComponentProps"
];
const $7032bd7e5a458ec9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $7032bd7e5a458ec9$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $7032bd7e5a458ec9$var$GridFilterFormRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm'
})({
    display: 'flex',
    gap: $hbuUJ.vars.spacing(1.5)
});
const $7032bd7e5a458ec9$var$FilterFormDeleteIcon = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon'
})({
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7032bd7e5a458ec9$var$FilterFormLogicOperatorInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput'
})({
    minWidth: 75,
    justifyContent: 'end'
});
const $7032bd7e5a458ec9$var$FilterFormColumnInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput'
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormOperatorInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput'
})({
    width: 150
});
const $7032bd7e5a458ec9$var$FilterFormValueInput = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput'
})({
    width: 190
});
const $7032bd7e5a458ec9$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case $9jXuN.GridLogicOperator.And:
            return 'filterPanelOperatorAnd';
        case $9jXuN.GridLogicOperator.Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $7032bd7e5a458ec9$var$getColumnLabel = (col)=>col.headerName || col.field;
const $7032bd7e5a458ec9$var$collator = new Intl.Collator();
const $7032bd7e5a458ec9$var$GridFilterForm = module.exports.GridFilterForm = (0, $fYxgT.forwardRef)(function GridFilterForm(props, ref) {
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        $9jXuN.GridLogicOperator.And,
        $9jXuN.GridLogicOperator.Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {}, readOnly: readOnly } = props, other = (0, $7032bd7e5a458ec9$var$_objectWithoutPropertiesLoose2.default)(props, $7032bd7e5a458ec9$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnLookup = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnLookupSelector);
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridFilterableColumnDefinitionsSelector);
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridFilterModelSelector);
    const columnSelectId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const columnSelectLabelId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const operatorSelectId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const operatorSelectLabelId = (0, $7032bd7e5a458ec9$var$_useId.default)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $7032bd7e5a458ec9$var$useUtilityClasses(rootProps);
    const valueRef = $7032bd7e5a458ec9$var$React.useRef(null);
    const filterSelectorRef = $7032bd7e5a458ec9$var$React.useRef(null);
    const multiFilterOperator = filterModel.logicOperator ?? $9jXuN.GridLogicOperator.And;
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isBaseSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $7032bd7e5a458ec9$var$_objectWithoutPropertiesLoose2.default)(valueInputProps, $7032bd7e5a458ec9$var$_excluded2);
    const pivotActive = (0, $5sOMZ.useGridSelector)(apiRef, $3ULRg.gridPivotActiveSelector);
    const initialColumns = (0, $5sOMZ.useGridSelector)(apiRef, $3ULRg.gridPivotInitialColumnsSelector);
    const { filteredColumns: filteredColumns, selectedField: selectedField } = $7032bd7e5a458ec9$var$React.useMemo(()=>{
        let itemField = item.field;
        // Yields a valid value if the current filter belongs to a column that is not filterable
        const selectedNonFilterableColumn = columnLookup[item.field].filterable === false ? columnLookup[item.field] : null;
        if (selectedNonFilterableColumn) return {
            filteredColumns: [
                selectedNonFilterableColumn
            ],
            selectedField: itemField
        };
        if (pivotActive) return {
            filteredColumns: filterableColumns.filter((column)=>initialColumns.get(column.field) !== undefined),
            selectedField: itemField
        };
        if (filterColumns === undefined || typeof filterColumns !== 'function') return {
            filteredColumns: filterableColumns,
            selectedField: itemField
        };
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: filterModel?.items || []
        });
        return {
            filteredColumns: filterableColumns.filter((column)=>{
                const isFieldIncluded = filteredFields.includes(column.field);
                if (column.field === item.field && !isFieldIncluded) itemField = undefined;
                return isFieldIncluded;
            }),
            selectedField: itemField
        };
    }, [
        item.field,
        columnLookup,
        pivotActive,
        filterColumns,
        filterableColumns,
        filterModel?.items,
        initialColumns
    ]);
    const sortedFilteredColumns = $7032bd7e5a458ec9$var$React.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$7032bd7e5a458ec9$var$collator.compare($7032bd7e5a458ec9$var$getColumnLabel(a), $7032bd7e5a458ec9$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $7032bd7e5a458ec9$var$React.useMemo(()=>{
        if (!item.operator || !currentColumn) return null;
        return currentColumn.filterOperators?.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $7032bd7e5a458ec9$var$React.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseFilterValue = !newOperator.InputComponent || newOperator.InputComponent !== currentOperator?.InputComponent || column.type !== currentColumn.type;
        let filterValue = eraseFilterValue ? undefined : item.value;
        // Check filter value against the new valueOptions
        if (column.type === 'singleSelect' && filterValue !== undefined) {
            const colDef = column;
            const valueOptions = (0, $5z7Pl.getValueOptions)(colDef);
            if (Array.isArray(filterValue)) filterValue = filterValue.filter((val)=>{
                return(// Only keep values that are in the new value options
                (0, $5z7Pl.getValueFromValueOptions)(val, valueOptions, colDef?.getOptionValue) !== undefined);
            });
            else if ((0, $5z7Pl.getValueFromValueOptions)(item.value, valueOptions, colDef?.getOptionValue) === undefined) // Reset the filter value if it is not in the new value options
            filterValue = undefined;
        }
        applyFilterChanges((0, $7032bd7e5a458ec9$var$_extends2.default)({}, item, {
            field: field,
            operator: newOperator.value,
            value: filterValue
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $7032bd7e5a458ec9$var$React.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn?.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !newOperator?.InputComponent || newOperator?.InputComponent !== currentOperator?.InputComponent;
        applyFilterChanges((0, $7032bd7e5a458ec9$var$_extends2.default)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $7032bd7e5a458ec9$var$React.useCallback((event)=>{
        const logicOperator = event.target.value === $9jXuN.GridLogicOperator.And.toString() ? $9jXuN.GridLogicOperator.And : $9jXuN.GridLogicOperator.Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        deleteFilter(item);
    };
    $7032bd7e5a458ec9$var$React.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator?.InputComponent) valueRef?.current?.focus();
                else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7032bd7e5a458ec9$var$GridFilterFormRoot, (0, $7032bd7e5a458ec9$var$_extends2.default)({
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormDeleteIcon, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, deleteIconProps, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.deleteIcon, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small",
                    disabled: readOnly
                }, rootProps.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormLogicOperatorInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                as: rootProps.slots.baseSelect,
                sx: [
                    hasLogicOperatorColumn ? {
                        display: 'flex'
                    } : {
                        display: 'none'
                    },
                    showMultiFilterOperators ? {
                        visibility: 'visible'
                    } : {
                        visibility: 'hidden'
                    },
                    logicOperatorInputProps.sx
                ],
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.logicOperatorInput, logicOperatorInputProps.className),
                ownerState: rootProps
            }, logicOperatorInputProps, {
                size: "small",
                slotProps: {
                    htmlInput: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    }
                },
                value: multiFilterOperator ?? '',
                onChange: changeLogicOperator,
                disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                native: isBaseSelectNative
            }, rootProps.slotProps?.baseSelect, {
                children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $7032bd7e5a458ec9$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: logicOperator.toString(),
                        value: logicOperator.toString()
                    }), apiRef.current.getLocaleText($7032bd7e5a458ec9$var$getLogicOperatorLocaleKey(logicOperator))))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormColumnInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                as: rootProps.slots.baseSelect
            }, columnInputProps, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.columnInput, columnInputProps.className),
                ownerState: rootProps,
                size: "small",
                labelId: columnSelectLabelId,
                id: columnSelectId,
                label: apiRef.current.getLocaleText('filterPanelColumns'),
                value: selectedField ?? '',
                onChange: changeColumn,
                native: isBaseSelectNative,
                disabled: readOnly
            }, rootProps.slotProps?.baseSelect, {
                children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $7032bd7e5a458ec9$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: col.field,
                        value: col.field
                    }), $7032bd7e5a458ec9$var$getColumnLabel(col)))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormOperatorInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                as: rootProps.slots.baseSelect,
                size: "small"
            }, operatorInputProps, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.operatorInput, operatorInputProps.className),
                ownerState: rootProps,
                labelId: operatorSelectLabelId,
                label: apiRef.current.getLocaleText('filterPanelOperator'),
                id: operatorSelectId,
                value: item.operator,
                onChange: changeOperator,
                native: isBaseSelectNative,
                inputRef: filterSelectorRef,
                disabled: readOnly
            }, rootProps.slotProps?.baseSelect, {
                children: currentColumn?.filterOperators?.map((operator)=>/*#__PURE__*/ (0, $7032bd7e5a458ec9$var$_react.createElement)(rootProps.slots.baseSelectOption, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: operator.value,
                        value: operator.value
                    }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $7032bd7e5a458ec9$var$_capitalize.default)(operator.value)}`)))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7032bd7e5a458ec9$var$FilterFormValueInput, (0, $7032bd7e5a458ec9$var$_extends2.default)({}, valueInputPropsOther, {
                className: (0, $7032bd7e5a458ec9$var$_clsx.default)(classes.valueInput, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator?.InputComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(currentOperator.InputComponent, (0, $7032bd7e5a458ec9$var$_extends2.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef,
                    disabled: readOnly,
                    slotProps: {
                        root: {
                            size: 'small'
                        }
                    }
                }, currentOperator.InputComponentProps, InputComponentProps), item.field) : null
            }))
        ]
    }));
});
 /**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 *
 * API:
 * - [GridFilterForm API](https://mui.com/x/api/data-grid/grid-filter-form/)
 */ 
});

parcelRegister("kWNEF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f3ffbde2bea4efe2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f3ffbde2bea4efe2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGridFilter = module.exports.GridFilterPanel = void 0;

var $f3ffbde2bea4efe2$var$_extends2 = $f3ffbde2bea4efe2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f3ffbde2bea4efe2$var$_objectWithoutPropertiesLoose2 = $f3ffbde2bea4efe2$require$_interopRequireDefault((parcelRequire("c05no")));

var $f3ffbde2bea4efe2$var$React = $f3ffbde2bea4efe2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f3ffbde2bea4efe2$var$_propTypes = $f3ffbde2bea4efe2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $9jXuN = parcelRequire("9jXuN");

var $bDyDY = parcelRequire("bDyDY");

var $hbQyH = parcelRequire("hbQyH");

var $ip3sX = parcelRequire("ip3sX");

var $dQ4Fi = parcelRequire("dQ4Fi");

var $9De9Z = parcelRequire("9De9Z");

var $jDpXp = parcelRequire("jDpXp");

var $5sOMZ = parcelRequire("5sOMZ");

var $k278Q = parcelRequire("k278Q");

var $jQEEt = parcelRequire("jQEEt");

var $ayMG0 = parcelRequire("ayMG0");
const $f3ffbde2bea4efe2$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $f3ffbde2bea4efe2$var$getGridFilter = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
module.exports.getGridFilter = $f3ffbde2bea4efe2$var$getGridFilter;
const $f3ffbde2bea4efe2$var$GridFilterPanel = module.exports.GridFilterPanel = (0, $fYxgT.forwardRef)(function GridFilterPanel(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const filterModel = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridFilterModelSelector);
    const filterableColumns = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridFilterableColumnDefinitionsSelector);
    const filterableColumnsLookup = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridFilterableColumnLookupSelector);
    const lastFilterRef = $f3ffbde2bea4efe2$var$React.useRef(null);
    const placeholderFilter = $f3ffbde2bea4efe2$var$React.useRef(null);
    const { logicOperators: logicOperators = [
        $9jXuN.GridLogicOperator.And,
        $9jXuN.GridLogicOperator.Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $f3ffbde2bea4efe2$var$_objectWithoutPropertiesLoose2.default)(props, $f3ffbde2bea4efe2$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $f3ffbde2bea4efe2$var$React.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: filterModel?.items || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>colDef.filterOperators?.length);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$var$getGridFilter(nextColumnWithOperator);
    }, [
        filterModel?.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $f3ffbde2bea4efe2$var$getGridFilter(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $f3ffbde2bea4efe2$var$React.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const { readOnlyFilters: readOnlyFilters, validFilters: validFilters } = $f3ffbde2bea4efe2$var$React.useMemo(()=>items.reduce((acc, item)=>{
            if (filterableColumnsLookup[item.field]) acc.validFilters.push(item);
            else acc.readOnlyFilters.push(item);
            return acc;
        }, {
            readOnlyFilters: [],
            validFilters: []
        }), [
        items,
        filterableColumnsLookup
    ]);
    const addNewFilter = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    }, [
        apiRef,
        getNewFilter,
        items
    ]);
    const deleteFilter = $f3ffbde2bea4efe2$var$React.useCallback((item)=>{
        const shouldCloseFilterPanel = validFilters.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        validFilters.length
    ]);
    const handleRemoveAll = $f3ffbde2bea4efe2$var$React.useCallback(()=>{
        if (validFilters.length === 1 && validFilters[0].value === undefined) {
            apiRef.current.deleteFilterItem(validFilters[0]);
            return apiRef.current.hideFilterPanel();
        }
        return apiRef.current.setFilterModel((0, $f3ffbde2bea4efe2$var$_extends2.default)({}, filterModel, {
            items: readOnlyFilters
        }), 'removeAllFilterItems');
    }, [
        apiRef,
        readOnlyFilters,
        filterModel,
        validFilters
    ]);
    $f3ffbde2bea4efe2$var$React.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $f3ffbde2bea4efe2$var$React.useEffect(()=>{
        if (validFilters.length > 0) lastFilterRef.current.focus();
    }, [
        validFilters.length
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dQ4Fi.GridPanelWrapper, (0, $f3ffbde2bea4efe2$var$_extends2.default)({}, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($hbQyH.GridPanelContent, {
                children: [
                    readOnlyFilters.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9De9Z.GridFilterForm, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: index > 0,
                            disableMultiFilterOperator: index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: null,
                            readOnly: true,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index : item.id)),
                    validFilters.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9De9Z.GridFilterForm, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: readOnlyFilters.length + index > 0,
                            disableMultiFilterOperator: readOnlyFilters.length + index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: index === validFilters.length - 1 ? lastFilterRef : null,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index + readOnlyFilters.length : item.id))
                ]
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $ayMG0.jsxs)($ip3sX.GridPanelFooter, {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableRemoveAllButton && validFilters.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $f3ffbde2bea4efe2$var$_extends2.default)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});
 /**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 *
 * API:
 * - [GridFilterPanel API](https://mui.com/x/api/data-grid/grid-filter-panel/)
 */ 
});



parcelRegister("54yWP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ix5g = parcelRequire("4ix5g");
Object.keys($4ix5g).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4ix5g[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4ix5g[key];
        }
    });
});

});
parcelRegister("4ix5g", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-use-before-define */ 'use client';

var $3pEGv = parcelRequire("3pEGv");
var $321281a63dc6186b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $321281a63dc6186b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnsManagement = $321281a63dc6186b$var$GridColumnsManagement;

var $321281a63dc6186b$var$_extends2 = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $321281a63dc6186b$var$React = $321281a63dc6186b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $321281a63dc6186b$var$_propTypes = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $321281a63dc6186b$var$_composeClasses = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $321281a63dc6186b$var$_debounce = $321281a63dc6186b$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $8xDHs = parcelRequire("8xDHs");

var $9MvHs = parcelRequire("9MvHs");

var $hbuUJ = parcelRequire("hbuUJ");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $btuMW = parcelRequire("btuMW");

var $j0vMH = parcelRequire("j0vMH");

var $7Rjhy = parcelRequire("7Rjhy");

var $3h197 = parcelRequire("3h197");

var $ayMG0 = parcelRequire("ayMG0");
const $321281a63dc6186b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsManagement'
        ],
        header: [
            'columnsManagementHeader'
        ],
        searchInput: [
            'columnsManagementSearchInput'
        ],
        footer: [
            'columnsManagementFooter'
        ],
        row: [
            'columnsManagementRow'
        ]
    };
    return (0, $321281a63dc6186b$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $321281a63dc6186b$var$collator = new Intl.Collator();
function $321281a63dc6186b$var$GridColumnsManagement(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const searchInputRef = $321281a63dc6186b$var$React.useRef(null);
    const initialColumnVisibilityModel = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridInitialColumnVisibilityModelSelector);
    const columnVisibilityModel = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnVisibilityModelSelector);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [searchValue, setSearchValue] = $321281a63dc6186b$var$React.useState('');
    const classes = $321281a63dc6186b$var$useUtilityClasses(rootProps);
    const columnDefinitions = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnDefinitionsSelector);
    const pivotActive = (0, $5sOMZ.useGridSelector)(apiRef, $3h197.gridPivotActiveSelector);
    const pivotInitialColumns = (0, $5sOMZ.useGridSelector)(apiRef, $3h197.gridPivotInitialColumnsSelector);
    const columns = $321281a63dc6186b$var$React.useMemo(()=>pivotActive ? Array.from(pivotInitialColumns.values()) : columnDefinitions, [
        pivotActive,
        pivotInitialColumns,
        columnDefinitions
    ]);
    const { sort: sort, searchPredicate: searchPredicate = $btuMW.defaultSearchPredicate, autoFocusSearchField: autoFocusSearchField = true, disableShowHideToggle: disableShowHideToggle = false, disableResetButton: disableResetButton = false, toggleAllMode: toggleAllMode = 'all', getTogglableColumns: getTogglableColumns, searchInputProps: searchInputProps, searchDebounceMs: searchDebounceMs = rootProps.columnFilterDebounceMs } = props;
    const debouncedFilter = $321281a63dc6186b$var$React.useMemo(()=>(0, $321281a63dc6186b$var$_debounce.default)((value)=>{
            setSearchValue(value);
        }, searchDebounceMs ?? 150), [
        searchDebounceMs
    ]);
    const isResetDisabled = $321281a63dc6186b$var$React.useMemo(()=>(0, $btuMW.checkColumnVisibilityModelsSame)(columnVisibilityModel, initialColumnVisibilityModel), [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    const sortedColumns = $321281a63dc6186b$var$React.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$321281a63dc6186b$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$321281a63dc6186b$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const currentColumns = $321281a63dc6186b$var$React.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const toggleAllColumns = $321281a63dc6186b$var$React.useCallback((isVisible)=>{
        const currentModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const newModel = (0, $321281a63dc6186b$var$_extends2.default)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === 'filteredOnly' ? currentColumns : columns).forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    const handleSearchValueChange = $321281a63dc6186b$var$React.useCallback((event)=>{
        debouncedFilter(event.target.value);
    }, [
        debouncedFilter
    ]);
    const hideableColumns = $321281a63dc6186b$var$React.useMemo(()=>currentColumns.filter((col)=>col.hideable), [
        currentColumns
    ]);
    const allHideableColumnsVisible = $321281a63dc6186b$var$React.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const allHideableColumnsHidden = $321281a63dc6186b$var$React.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] === false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const firstSwitchRef = $321281a63dc6186b$var$React.useRef(null);
    $321281a63dc6186b$var$React.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current?.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    const handleSearchReset = $321281a63dc6186b$var$React.useCallback(()=>{
        setSearchValue('');
        if (searchInputRef.current) {
            searchInputRef.current.value = '';
            searchInputRef.current.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$SearchInput, (0, $321281a63dc6186b$var$_extends2.default)({
                    as: rootProps.slots.baseTextField,
                    ownerState: rootProps,
                    placeholder: apiRef.current.getLocaleText('columnsManagementSearchTitle'),
                    inputRef: searchInputRef,
                    className: classes.searchInput,
                    onChange: handleSearchValueChange,
                    size: "small",
                    type: "search",
                    slotProps: {
                        input: {
                            startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {
                                fontSize: "small"
                            }),
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, (0, $321281a63dc6186b$var$_extends2.default)({
                                size: "small",
                                "aria-label": apiRef.current.getLocaleText('columnsManagementDeleteIconLabel'),
                                style: searchValue ? {
                                    visibility: 'visible'
                                } : {
                                    visibility: 'hidden'
                                },
                                tabIndex: -1,
                                onClick: handleSearchReset,
                                edge: "end"
                            }, rootProps.slotProps?.baseIconButton, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterClearIcon, {
                                    fontSize: "small"
                                })
                            }))
                        },
                        htmlInput: {
                            'aria-label': apiRef.current.getLocaleText('columnsManagementSearchTitle')
                        }
                    },
                    autoComplete: "off",
                    fullWidth: true
                }, rootProps.slotProps?.baseTextField, searchInputProps))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementScrollArea, {
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$GridColumnsManagementBody, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: [
                        currentColumns.map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementRow, (0, $321281a63dc6186b$var$_extends2.default)({
                                as: rootProps.slots.baseCheckbox,
                                className: classes.row,
                                disabled: column.hideable === false || pivotActive,
                                checked: columnVisibilityModel[column.field] !== false,
                                onChange: toggleColumn,
                                name: column.field,
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined,
                                label: column.headerName || column.field,
                                density: "compact",
                                fullWidth: true
                            }, rootProps.slotProps?.baseCheckbox), column.field)),
                        currentColumns.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($321281a63dc6186b$var$GridColumnsManagementEmptyText, {
                            ownerState: rootProps,
                            children: apiRef.current.getLocaleText('columnsManagementNoColumns')
                        })
                    ]
                })
            }),
            !disableShowHideToggle || !disableResetButton ? /*#__PURE__*/ (0, $ayMG0.jsxs)($321281a63dc6186b$var$GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseCheckbox, (0, $321281a63dc6186b$var$_extends2.default)({
                        disabled: hideableColumns.length === 0 || pivotActive,
                        checked: allHideableColumnsVisible,
                        indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                        onChange: ()=>toggleAllColumns(!allHideableColumnsVisible),
                        name: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                        label: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                        density: "compact"
                    }, rootProps.slotProps?.baseCheckbox)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    !disableResetButton ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $321281a63dc6186b$var$_extends2.default)({
                        onClick: ()=>apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel),
                        disabled: isResetDisabled || pivotActive
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('columnsManagementReset')
                    })) : null
                ]
            }) : null
        ]
    });
}
const $321281a63dc6186b$var$GridColumnsManagementBody = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagement'
})({
    display: 'flex',
    flexDirection: 'column',
    padding: $hbuUJ.vars.spacing(0.5, 1.5)
});
const $321281a63dc6186b$var$GridColumnsManagementScrollArea = (0, $8xDHs.styled)($7Rjhy.GridShadowScrollArea, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementScrollArea'
})({
    maxHeight: 300
});
const $321281a63dc6186b$var$GridColumnsManagementHeader = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementHeader'
})({
    padding: $hbuUJ.vars.spacing(1.5, 2),
    borderBottom: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
const $321281a63dc6186b$var$SearchInput = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementSearchInput'
})({
    [`& .${$9MvHs.inputBaseClasses.input}::-webkit-search-decoration,
      & .${$9MvHs.inputBaseClasses.input}::-webkit-search-cancel-button,
      & .${$9MvHs.inputBaseClasses.input}::-webkit-search-results-button,
      & .${$9MvHs.inputBaseClasses.input}::-webkit-search-results-decoration`]: {
        /* clears the 'X' icon from Chrome */ display: 'none'
    }
});
const $321281a63dc6186b$var$GridColumnsManagementFooter = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementFooter'
})({
    padding: $hbuUJ.vars.spacing(1, 1, 1, 1.5),
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${$hbuUJ.vars.colors.border.base}`
});
const $321281a63dc6186b$var$GridColumnsManagementEmptyText = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementEmptyText'
})({
    padding: $hbuUJ.vars.spacing(1, 0),
    alignSelf: 'center',
    font: $hbuUJ.vars.typography.font.body
});
const $321281a63dc6186b$var$GridColumnsManagementRow = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementRow'
})({});

});
parcelRegister("9MvHs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $71f12fb6991c55a7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $71f12fb6991c55a7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $71f12fb6991c55a7$var$_exportNames = {
    inputBaseClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $71f12fb6991c55a7$var$_InputBase.default;
    }
});
Object.defineProperty(module.exports, "inputBaseClasses", {
    enumerable: true,
    get: function() {
        return $71f12fb6991c55a7$var$_inputBaseClasses.default;
    }
});

var $71f12fb6991c55a7$var$_InputBase = $71f12fb6991c55a7$require$_interopRequireDefault((parcelRequire("95gUw")));

var $71f12fb6991c55a7$var$_inputBaseClasses = $71f12fb6991c55a7$require$_interopRequireWildcard((parcelRequire("dmljZ")));
Object.keys($71f12fb6991c55a7$var$_inputBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($71f12fb6991c55a7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $71f12fb6991c55a7$var$_inputBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $71f12fb6991c55a7$var$_inputBaseClasses[key];
        }
    });
});

});
parcelRegister("95gUw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $69d1b2c99a8dc649$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $69d1b2c99a8dc649$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rootOverridesResolver = module.exports.inputOverridesResolver = module.exports.default = module.exports.InputBaseRoot = module.exports.InputBaseInput = void 0;

var $69d1b2c99a8dc649$var$_formatMuiErrorMessage = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $69d1b2c99a8dc649$var$React = $69d1b2c99a8dc649$require$_interopRequireWildcard((parcelRequire("acw62")));

var $69d1b2c99a8dc649$var$_propTypes = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $69d1b2c99a8dc649$var$_clsx = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("9QePP")));

var $69d1b2c99a8dc649$var$_elementTypeAcceptingRef = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $69d1b2c99a8dc649$var$_refType = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $69d1b2c99a8dc649$var$_composeClasses = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $69d1b2c99a8dc649$var$_isHostComponent = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $69d1b2c99a8dc649$var$_TextareaAutosize = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("3vH0x")));

var $69d1b2c99a8dc649$var$_formControlState = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("aaphR")));

var $69d1b2c99a8dc649$var$_FormControlContext = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("blr6C")));

var $69d1b2c99a8dc649$var$_useFormControl = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $aAbgT = parcelRequire("aAbgT");

var $69d1b2c99a8dc649$var$_memoTheme = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $69d1b2c99a8dc649$var$_capitalize = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $69d1b2c99a8dc649$var$_useForkRef = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $69d1b2c99a8dc649$var$_useEnhancedEffect = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("khjmj")));

var $2BbKU = parcelRequire("2BbKU");

var $69d1b2c99a8dc649$var$_inputBaseClasses = $69d1b2c99a8dc649$require$_interopRequireWildcard((parcelRequire("dmljZ")));

var $ayMG0 = parcelRequire("ayMG0");
var $69d1b2c99a8dc649$var$_InputGlobalStyles;
const $69d1b2c99a8dc649$var$rootOverridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $69d1b2c99a8dc649$var$_capitalize.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
module.exports.rootOverridesResolver = $69d1b2c99a8dc649$var$rootOverridesResolver;
const $69d1b2c99a8dc649$var$inputOverridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
module.exports.inputOverridesResolver = $69d1b2c99a8dc649$var$inputOverridesResolver;
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $69d1b2c99a8dc649$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $69d1b2c99a8dc649$var$_capitalize.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $69d1b2c99a8dc649$var$_composeClasses.default)(slots, $69d1b2c99a8dc649$var$_inputBaseClasses.getInputBaseUtilityClass, classes);
};
const $69d1b2c99a8dc649$var$InputBaseRoot = module.exports.InputBaseRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$var$rootOverridesResolver
})((0, $69d1b2c99a8dc649$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${$69d1b2c99a8dc649$var$_inputBaseClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $69d1b2c99a8dc649$var$InputBaseInput = module.exports.InputBaseInput = (0, $aAbgT.styled)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$var$inputOverridesResolver
})((0, $69d1b2c99a8dc649$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${$69d1b2c99a8dc649$var$_inputBaseClasses.default.formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${$69d1b2c99a8dc649$var$_inputBaseClasses.default.disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $69d1b2c99a8dc649$var$InputGlobalStyles = (0, $aAbgT.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $69d1b2c99a8dc649$var$React.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $69d1b2c99a8dc649$var$React.useRef(value != null);
    const inputRef = $69d1b2c99a8dc649$var$React.useRef();
    const handleInputRefWarning = $69d1b2c99a8dc649$var$React.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $69d1b2c99a8dc649$var$_useForkRef.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $69d1b2c99a8dc649$var$React.useState(false);
    const muiFormControl = (0, $69d1b2c99a8dc649$var$_useFormControl.default)();
    const fcs = (0, $69d1b2c99a8dc649$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $69d1b2c99a8dc649$var$React.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $69d1b2c99a8dc649$var$_useEnhancedEffect.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $69d1b2c99a8dc649$var$_formatMuiErrorMessage.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = $69d1b2c99a8dc649$var$_TextareaAutosize.default;
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$var$InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$var$InputBaseInput;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($69d1b2c99a8dc649$var$React.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $69d1b2c99a8dc649$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($69d1b2c99a8dc649$var$_InputGlobalStyles || ($69d1b2c99a8dc649$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $69d1b2c99a8dc649$var$_isHostComponent.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $69d1b2c99a8dc649$var$_clsx.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$_FormControlContext.default.Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $69d1b2c99a8dc649$var$_isHostComponent.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $69d1b2c99a8dc649$var$_clsx.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $69d1b2c99a8dc649$var$_default = module.exports.default = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("3vH0x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28e5a0c586f490cf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $28e5a0c586f490cf$var$_TextareaAutosize.default;
    }
});

var $28e5a0c586f490cf$var$_TextareaAutosize = $28e5a0c586f490cf$require$_interopRequireDefault((parcelRequire("gSRTE")));

});
parcelRegister("gSRTE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $032c0e7078a9cb7d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $032c0e7078a9cb7d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $032c0e7078a9cb7d$var$React = $032c0e7078a9cb7d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $032c0e7078a9cb7d$var$_propTypes = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $032c0e7078a9cb7d$var$_debounce = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $032c0e7078a9cb7d$var$_useForkRef = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $032c0e7078a9cb7d$var$_useEnhancedEffect = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $032c0e7078a9cb7d$var$_useEventCallback = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $032c0e7078a9cb7d$var$_ownerWindow = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("4Rhws")));

var $ayMG0 = parcelRequire("ayMG0");
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $032c0e7078a9cb7d$var$React.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $032c0e7078a9cb7d$var$React.useRef(value != null);
    const textareaRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const handleRef = (0, $032c0e7078a9cb7d$var$_useForkRef.default)(forwardedRef, textareaRef);
    const heightRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const hiddenTextareaRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const calculateTextareaStyles = $032c0e7078a9cb7d$var$React.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $032c0e7078a9cb7d$var$_ownerWindow.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $032c0e7078a9cb7d$var$_useEventCallback.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $032c0e7078a9cb7d$var$React.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $032c0e7078a9cb7d$var$React.useRef(-1);
    (0, $032c0e7078a9cb7d$var$_useEnhancedEffect.default)(()=>{
        const debouncedHandleResize = (0, $032c0e7078a9cb7d$var$_debounce.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $032c0e7078a9cb7d$var$_ownerWindow.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $032c0e7078a9cb7d$var$_useEnhancedEffect.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($032c0e7078a9cb7d$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$032c0e7078a9cb7d$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $032c0e7078a9cb7d$var$_default = module.exports.default = $032c0e7078a9cb7d$var$TextareaAutosize;

});


parcelRegister("aaphR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $766e740713576b8d$var$formControlState;
function $766e740713576b8d$var$formControlState({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("blr6C", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8426ae8303951a73$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8426ae8303951a73$var$React = $8426ae8303951a73$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $8426ae8303951a73$var$React.createContext(undefined);
var $8426ae8303951a73$var$_default = module.exports.default = $8426ae8303951a73$var$FormControlContext;

});

parcelRegister("cJQfW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $946238fa82894619$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $946238fa82894619$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $946238fa82894619$var$useFormControl;

var $946238fa82894619$var$React = $946238fa82894619$require$_interopRequireWildcard((parcelRequire("acw62")));

var $946238fa82894619$var$_FormControlContext = $946238fa82894619$require$_interopRequireDefault((parcelRequire("blr6C")));
function $946238fa82894619$var$useFormControl() {
    return $946238fa82894619$var$React.useContext($946238fa82894619$var$_FormControlContext.default);
}

});

parcelRegister("2BbKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValue = $1e4827e2a850b1f0$var$hasValue;
module.exports.isAdornedStart = $1e4827e2a850b1f0$var$isAdornedStart;
module.exports.isFilled = $1e4827e2a850b1f0$var$isFilled;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$var$hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function $1e4827e2a850b1f0$var$isFilled(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$var$hasValue(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$var$hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function $1e4827e2a850b1f0$var$isAdornedStart(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dmljZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9b9dde6aa920e08c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputBaseUtilityClass = $9b9dde6aa920e08c$var$getInputBaseUtilityClass;

var $9b9dde6aa920e08c$var$_generateUtilityClasses = $9b9dde6aa920e08c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9b9dde6aa920e08c$var$_generateUtilityClass = $9b9dde6aa920e08c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9b9dde6aa920e08c$var$getInputBaseUtilityClass(slot) {
    return (0, $9b9dde6aa920e08c$var$_generateUtilityClass.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $9b9dde6aa920e08c$var$_generateUtilityClasses.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$var$_default = module.exports.default = $9b9dde6aa920e08c$var$inputBaseClasses;

});



parcelRegister("btuMW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultSearchPredicate = module.exports.checkColumnVisibilityModelsSame = void 0;
const $85aa4911010e7c41$var$checkColumnVisibilityModelsSame = (a, b)=>{
    // Filter `false` values only, as `true` and not having a key are the same
    const aFalseValues = new Set(Object.keys(a).filter((key)=>a[key] === false));
    const bFalseValues = new Set(Object.keys(b).filter((key)=>b[key] === false));
    if (aFalseValues.size !== bFalseValues.size) return false;
    let result = true;
    aFalseValues.forEach((key)=>{
        if (!bFalseValues.has(key)) result = false;
    });
    return result;
};
module.exports.checkColumnVisibilityModelsSame = $85aa4911010e7c41$var$checkColumnVisibilityModelsSame;
const $85aa4911010e7c41$var$defaultSearchPredicate = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
module.exports.defaultSearchPredicate = $85aa4911010e7c41$var$defaultSearchPredicate;

});

parcelRegister("7Rjhy", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5b8c70a8582b44e6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5b8c70a8582b44e6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridShadowScrollArea = void 0;

var $5b8c70a8582b44e6$var$_extends2 = $5b8c70a8582b44e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5b8c70a8582b44e6$var$_objectWithoutPropertiesLoose2 = $5b8c70a8582b44e6$require$_interopRequireDefault((parcelRequire("c05no")));

var $5b8c70a8582b44e6$var$React = $5b8c70a8582b44e6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5b8c70a8582b44e6$var$_propTypes = $5b8c70a8582b44e6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $ayMG0 = parcelRequire("ayMG0");
const $5b8c70a8582b44e6$var$_excluded = [
    "children"
];
const $5b8c70a8582b44e6$var$reveal = (0, $izOUK.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $5b8c70a8582b44e6$var$detectScroll = (0, $izOUK.keyframes)({
    'from, to': {
        '--scrollable': '" "'
    }
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $5b8c70a8582b44e6$var$ShadowScrollArea = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ShadowScrollArea'
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  animation: ${$5b8c70a8582b44e6$var$detectScroll};
  animation-timeline: --scroll-timeline;
  animation-fill-mode: none;
  box-sizing: border-box;
  overflow: auto;
  scrollbar-width: thin;
  scroll-timeline: --scroll-timeline block;

  &::before,
  &::after {
    content: '';
    flex-shrink: 0;
    display: block;
    position: sticky;
    left: 0;
    width: 100%;
    height: 4px;
    animation: ${$5b8c70a8582b44e6$var$reveal} linear both;
    animation-timeline: --scroll-timeline;

    // Custom property toggle trick:
    // - Detects if the element is scrollable
    // - https://css-tricks.com/the-css-custom-property-toggle-trick/
    --visibility-scrollable: var(--scrollable) visible;
    --visibility-not-scrollable: hidden;
    visibility: var(--visibility-scrollable, var(--visibility-not-scrollable));
  }

  &::before {
    top: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0, transparent 100%);
    animation-range: 0 4px;
  }

  &::after {
    bottom: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.05) 0, transparent 100%);
    animation-direction: reverse;
    animation-range: calc(100% - 4px) 100%;
  }
`;
/**
 * Adds scroll shadows above and below content in a scrollable container.
 */ const $5b8c70a8582b44e6$var$GridShadowScrollArea = module.exports.GridShadowScrollArea = (0, $fYxgT.forwardRef)(function GridShadowScrollArea(props, ref) {
    const { children: children } = props, other = (0, $5b8c70a8582b44e6$var$_objectWithoutPropertiesLoose2.default)(props, $5b8c70a8582b44e6$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5b8c70a8582b44e6$var$ShadowScrollArea, (0, $5b8c70a8582b44e6$var$_extends2.default)({}, other, {
        ref: ref,
        children: children
    }));
});

});



parcelRegister("iPqov", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $db5176c392a1c83e$var$_exportNames = {
    GridCsvExportMenuItem: true,
    GridPrintExportMenuItem: true,
    GridToolbarExport: true
};
Object.defineProperty(module.exports, "GridCsvExportMenuItem", {
    enumerable: true,
    get: function() {
        return $1v4Qb.GridCsvExportMenuItem;
    }
});
Object.defineProperty(module.exports, "GridPrintExportMenuItem", {
    enumerable: true,
    get: function() {
        return $1v4Qb.GridPrintExportMenuItem;
    }
});
Object.defineProperty(module.exports, "GridToolbarExport", {
    enumerable: true,
    get: function() {
        return $1v4Qb.GridToolbarExport;
    }
});

var $4OPqi = parcelRequire("4OPqi");
Object.keys($4OPqi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4OPqi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4OPqi[key];
        }
    });
});

var $909IQ = parcelRequire("909IQ");
Object.keys($909IQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $909IQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $909IQ[key];
        }
    });
});

var $bijAb = parcelRequire("bijAb");
Object.keys($bijAb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bijAb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bijAb[key];
        }
    });
});

var $1v4Qb = parcelRequire("1v4Qb");

var $7jaBE = parcelRequire("7jaBE");
Object.keys($7jaBE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7jaBE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7jaBE[key];
        }
    });
});

var $03n8N = parcelRequire("03n8N");
Object.keys($03n8N).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $03n8N[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $03n8N[key];
        }
    });
});

var $1kFTA = parcelRequire("1kFTA");
Object.keys($1kFTA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($db5176c392a1c83e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1kFTA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1kFTA[key];
        }
    });
});

});
parcelRegister("4OPqi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3823b87e39c2fb28$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbar = void 0;

var $3823b87e39c2fb28$var$_extends2 = $3823b87e39c2fb28$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3823b87e39c2fb28$var$_objectWithoutPropertiesLoose2 = $3823b87e39c2fb28$require$_interopRequireDefault((parcelRequire("c05no")));

var $3823b87e39c2fb28$var$_propTypes = $3823b87e39c2fb28$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $02G4S = parcelRequire("02G4S");

var $909IQ = parcelRequire("909IQ");

var $bijAb = parcelRequire("bijAb");

var $7jaBE = parcelRequire("7jaBE");

var $1v4Qb = parcelRequire("1v4Qb");

var $jDpXp = parcelRequire("jDpXp");

var $1kFTA = parcelRequire("1kFTA");

var $dR2yi = parcelRequire("dR2yi");

var $ayMG0 = parcelRequire("ayMG0");
const $3823b87e39c2fb28$var$_excluded = [
    "className",
    "csvOptions",
    "printOptions",
    "excelOptions",
    "showQuickFilter",
    "quickFilterProps"
];
/**
 * @deprecated Use the `showToolbar` prop to show the default toolbar instead. This component will be removed in a future major release.
 */ const $3823b87e39c2fb28$var$GridToolbar = module.exports.GridToolbar = (0, $fYxgT.forwardRef)(function GridToolbar(props, ref) {
    // TODO v7: think about where export option should be passed.
    // from slotProps={{ toolbarExport: { ...exportOption } }} seems to be more appropriate
    const _ref = props, { csvOptions: csvOptions, printOptions: printOptions, excelOptions: excelOptions, showQuickFilter: showQuickFilter = true, quickFilterProps: quickFilterProps = {} } = _ref, other = (0, $3823b87e39c2fb28$var$_objectWithoutPropertiesLoose2.default)(_ref, $3823b87e39c2fb28$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    if (rootProps.disableColumnFilter && rootProps.disableColumnSelector && rootProps.disableDensitySelector && !showQuickFilter) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($02G4S.GridToolbarContainer, (0, $3823b87e39c2fb28$var$_extends2.default)({}, other, {
        ref: ref,
        children: [
            rootProps.label && /*#__PURE__*/ (0, $ayMG0.jsx)($dR2yi.GridToolbarLabel, {
                children: rootProps.label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($909IQ.GridToolbarColumnsButton, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7jaBE.GridToolbarFilterButton, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($bijAb.GridToolbarDensitySelector, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($1v4Qb.GridToolbarExport, {
                csvOptions: csvOptions,
                printOptions: printOptions,
                excelOptions: excelOptions
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1
                }
            }),
            showQuickFilter && /*#__PURE__*/ (0, $ayMG0.jsx)($1kFTA.GridToolbarQuickFilter, (0, $3823b87e39c2fb28$var$_extends2.default)({}, quickFilterProps))
        ]
    }));
});

});
parcelRegister("909IQ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $68dba7cc326760eb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68dba7cc326760eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbarColumnsButton = void 0;

var $68dba7cc326760eb$var$_extends2 = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $68dba7cc326760eb$var$React = $68dba7cc326760eb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $68dba7cc326760eb$var$_propTypes = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $68dba7cc326760eb$var$_useId = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");

var $68dba7cc326760eb$var$_useForkRef = $68dba7cc326760eb$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $5sOMZ = parcelRequire("5sOMZ");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $7fn0i = parcelRequire("7fn0i");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/columns-panel/ Columns Panel Trigger} component instead. This component will be removed in a future major release.
 */ const $68dba7cc326760eb$var$GridToolbarColumnsButton = module.exports.GridToolbarColumnsButton = (0, $fYxgT.forwardRef)(function GridToolbarColumnsButton(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const columnButtonId = (0, $68dba7cc326760eb$var$_useId.default)();
    const columnPanelId = (0, $68dba7cc326760eb$var$_useId.default)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { columnsPanelTriggerRef: columnsPanelTriggerRef } = (0, $7fn0i.useGridPanelContext)();
    const preferencePanel = (0, $5sOMZ.useGridSelector)(apiRef, $6X2Yd.gridPreferencePanelStateSelector);
    const handleRef = (0, $68dba7cc326760eb$var$_useForkRef.default)(ref, columnsPanelTriggerRef);
    const showColumns = (event)=>{
        if (preferencePanel.open && preferencePanel.openedPanelValue === $3PCYS.GridPreferencePanelsValue.columns) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($3PCYS.GridPreferencePanelsValue.columns, columnPanelId, columnButtonId);
        buttonProps.onClick?.(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnSelector) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === columnPanelId;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $68dba7cc326760eb$var$_extends2.default)({
        title: apiRef.current.getLocaleText('toolbarColumnsLabel'),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, tooltipProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $68dba7cc326760eb$var$_extends2.default)({
            id: columnButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText('toolbarColumnsLabel'),
            "aria-haspopup": "menu",
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? columnPanelId : undefined,
            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnSelectorIcon, {})
        }, rootProps.slotProps?.baseButton, buttonProps, {
            onPointerUp: (event)=>{
                if (preferencePanel.open) event.stopPropagation();
                buttonProps.onPointerUp?.(event);
            },
            onClick: showColumns,
            ref: handleRef,
            children: apiRef.current.getLocaleText('toolbarColumns')
        }))
    }));
});

});

parcelRegister("bijAb", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $839090d5c761d720$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $839090d5c761d720$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbarDensitySelector = void 0;

var $839090d5c761d720$var$_extends2 = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $839090d5c761d720$var$React = $839090d5c761d720$require$_interopRequireWildcard((parcelRequire("acw62")));

var $839090d5c761d720$var$_propTypes = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $839090d5c761d720$var$_useId = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("hwliF")));

var $839090d5c761d720$var$_useForkRef = $839090d5c761d720$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $fD9f4 = parcelRequire("fD9f4");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @deprecated See {@link https://mui.com/x/react-data-grid/accessibility/#set-the-density-programmatically Accessibility—Set the density programmatically} for an example of adding a density selector to the toolbar. This component will be removed in a future major release.
 */ const $839090d5c761d720$var$GridToolbarDensitySelector = module.exports.GridToolbarDensitySelector = (0, $fYxgT.forwardRef)(function GridToolbarDensitySelector(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const density = (0, $5sOMZ.useGridSelector)(apiRef, $fD9f4.gridDensitySelector);
    const densityButtonId = (0, $839090d5c761d720$var$_useId.default)();
    const densityMenuId = (0, $839090d5c761d720$var$_useId.default)();
    const [open, setOpen] = $839090d5c761d720$var$React.useState(false);
    const buttonRef = $839090d5c761d720$var$React.useRef(null);
    const handleRef = (0, $839090d5c761d720$var$_useForkRef.default)(ref, buttonRef);
    const densityOptions = [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityCompactIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityCompact'),
            value: 'compact'
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityStandardIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityStandard'),
            value: 'standard'
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityComfortableIcon, {}),
            label: apiRef.current.getLocaleText('toolbarDensityComfortable'),
            value: 'comfortable'
        }
    ];
    const startIcon = $839090d5c761d720$var$React.useMemo(()=>{
        switch(density){
            case 'compact':
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityCompactIcon, {});
            case 'comfortable':
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityComfortableIcon, {});
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.densityStandardIcon, {});
        }
    }, [
        density,
        rootProps
    ]);
    const handleDensitySelectorOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleDensitySelectorClose = ()=>{
        setOpen(false);
    };
    const handleDensityUpdate = (newDensity)=>{
        apiRef.current.setDensity(newDensity);
        setOpen(false);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableDensitySelector) return null;
    const densityElements = densityOptions.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, {
            onClick: ()=>handleDensityUpdate(option.value),
            selected: option.value === density,
            iconStart: option.icon,
            children: option.label
        }, index));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($839090d5c761d720$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $839090d5c761d720$var$_extends2.default)({
                title: apiRef.current.getLocaleText('toolbarDensityLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $839090d5c761d720$var$_extends2.default)({
                    size: "small",
                    startIcon: startIcon,
                    "aria-label": apiRef.current.getLocaleText('toolbarDensityLabel'),
                    "aria-haspopup": "menu",
                    "aria-expanded": open,
                    "aria-controls": open ? densityMenuId : undefined,
                    id: densityButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleDensitySelectorOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarDensity')
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ch6XH.GridMenu, {
                open: open,
                target: buttonRef.current,
                onClose: handleDensitySelectorClose,
                position: "bottom-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuList, {
                    id: densityMenuId,
                    className: $5H1vo.gridClasses.menuList,
                    "aria-labelledby": densityButtonId,
                    autoFocusItem: open,
                    children: densityElements
                })
            })
        ]
    });
});

});

parcelRegister("7jaBE", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $552288f2e6707b2c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $552288f2e6707b2c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbarFilterButton = void 0;

var $552288f2e6707b2c$var$_extends2 = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $552288f2e6707b2c$var$React = $552288f2e6707b2c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $552288f2e6707b2c$var$_propTypes = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $552288f2e6707b2c$var$_composeClasses = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $552288f2e6707b2c$var$_capitalize = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("4O6za")));

var $552288f2e6707b2c$var$_useId = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("hwliF")));

var $552288f2e6707b2c$var$_useForkRef = $552288f2e6707b2c$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $k278Q = parcelRequire("k278Q");

var $6X2Yd = parcelRequire("6X2Yd");

var $3PCYS = parcelRequire("3PCYS");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $7fn0i = parcelRequire("7fn0i");

var $ayMG0 = parcelRequire("ayMG0");
const $552288f2e6707b2c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarFilterList'
        ]
    };
    return (0, $552288f2e6707b2c$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $552288f2e6707b2c$var$GridToolbarFilterListRoot = (0, $8xDHs.styled)('ul', {
    name: 'MuiDataGrid',
    slot: 'ToolbarFilterList'
})({
    margin: $hbuUJ.vars.spacing(1, 1, 0.5),
    padding: $hbuUJ.vars.spacing(0, 1)
});
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/filter-panel/ Filter Panel Trigger} component instead. This component will be removed in a future major release.
 */ const $552288f2e6707b2c$var$GridToolbarFilterButton = module.exports.GridToolbarFilterButton = (0, $fYxgT.forwardRef)(function GridToolbarFilterButton(props, ref) {
    const { slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const badgeProps = slotProps.badge || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const activeFilters = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridFilterActiveItemsSelector);
    const lookup = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnLookupSelector);
    const preferencePanel = (0, $5sOMZ.useGridSelector)(apiRef, $6X2Yd.gridPreferencePanelStateSelector);
    const classes = $552288f2e6707b2c$var$useUtilityClasses(rootProps);
    const filterButtonId = (0, $552288f2e6707b2c$var$_useId.default)();
    const filterPanelId = (0, $552288f2e6707b2c$var$_useId.default)();
    const { filterPanelTriggerRef: filterPanelTriggerRef } = (0, $7fn0i.useGridPanelContext)();
    const handleRef = (0, $552288f2e6707b2c$var$_useForkRef.default)(ref, filterPanelTriggerRef);
    const tooltipContentNode = $552288f2e6707b2c$var$React.useMemo(()=>{
        if (preferencePanel.open) return apiRef.current.getLocaleText('toolbarFiltersTooltipHide');
        if (activeFilters.length === 0) return apiRef.current.getLocaleText('toolbarFiltersTooltipShow');
        const getOperatorLabel = (item)=>lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator).label || apiRef.current.getLocaleText(`filterOperator${(0, $552288f2e6707b2c$var$_capitalize.default)(item.operator)}`).toString();
        const getFilterItemValue = (item)=>{
            const { getValueAsString: getValueAsString } = lookup[item.field].filterOperators.find((operator)=>operator.value === item.operator);
            return getValueAsString ? getValueAsString(item.value) : item.value;
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                apiRef.current.getLocaleText('toolbarFiltersTooltipActive')(activeFilters.length),
                /*#__PURE__*/ (0, $ayMG0.jsx)($552288f2e6707b2c$var$GridToolbarFilterListRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: activeFilters.map((item, index)=>(0, $552288f2e6707b2c$var$_extends2.default)({}, lookup[item.field] && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            children: `${lookup[item.field].headerName || item.field}
                  ${getOperatorLabel(item)}
                  ${// implicit check for null and undefined
                            item.value != null ? getFilterItemValue(item) : ''}`
                        }, index)))
                })
            ]
        });
    }, [
        apiRef,
        rootProps,
        preferencePanel.open,
        activeFilters,
        lookup,
        classes
    ]);
    const toggleFilter = (event)=>{
        const { open: open, openedPanelValue: openedPanelValue } = preferencePanel;
        if (open && openedPanelValue === $3PCYS.GridPreferencePanelsValue.filters) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($3PCYS.GridPreferencePanelsValue.filters, filterPanelId, filterButtonId);
        buttonProps.onClick?.(event);
    };
    // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnFilter) return null;
    const isOpen = preferencePanel.open && preferencePanel.panelId === filterPanelId;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $552288f2e6707b2c$var$_extends2.default)({
        title: tooltipContentNode,
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, tooltipProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $552288f2e6707b2c$var$_extends2.default)({
            id: filterButtonId,
            size: "small",
            "aria-label": apiRef.current.getLocaleText('toolbarFiltersLabel'),
            "aria-controls": isOpen ? filterPanelId : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, (0, $552288f2e6707b2c$var$_extends2.default)({
                badgeContent: activeFilters.length,
                color: "primary"
            }, rootProps.slotProps?.baseBadge, badgeProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.openFilterButtonIcon, {})
            }))
        }, rootProps.slotProps?.baseButton, buttonProps, {
            onClick: toggleFilter,
            onPointerUp: (event)=>{
                if (preferencePanel.open) event.stopPropagation();
                buttonProps.onPointerUp?.(event);
            },
            ref: handleRef,
            children: apiRef.current.getLocaleText('toolbarFilters')
        }))
    }));
});

});

parcelRegister("1v4Qb", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $117c70f90fd64960$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $117c70f90fd64960$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridCsvExportMenuItem = $117c70f90fd64960$var$GridCsvExportMenuItem;
module.exports.GridPrintExportMenuItem = $117c70f90fd64960$var$GridPrintExportMenuItem;
module.exports.GridToolbarExport = void 0;

var $117c70f90fd64960$var$_extends2 = $117c70f90fd64960$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $117c70f90fd64960$var$_objectWithoutPropertiesLoose2 = $117c70f90fd64960$require$_interopRequireDefault((parcelRequire("c05no")));

var $117c70f90fd64960$var$React = $117c70f90fd64960$require$_interopRequireWildcard((parcelRequire("acw62")));

var $117c70f90fd64960$var$_propTypes = $117c70f90fd64960$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $03n8N = parcelRequire("03n8N");

var $ayMG0 = parcelRequire("ayMG0");
const $117c70f90fd64960$var$_excluded = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded2 = [
    "hideMenu",
    "options"
], $117c70f90fd64960$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $117c70f90fd64960$var$GridCsvExportMenuItem(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $117c70f90fd64960$var$_objectWithoutPropertiesLoose2.default)(props, $117c70f90fd64960$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $117c70f90fd64960$var$_extends2.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function $117c70f90fd64960$var$GridPrintExportMenuItem(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $117c70f90fd64960$var$_objectWithoutPropertiesLoose2.default)(props, $117c70f90fd64960$var$_excluded2);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $117c70f90fd64960$var$_extends2.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/export/ Export} components instead. This component will be removed in a future major release.
 */ const $117c70f90fd64960$var$GridToolbarExport = module.exports.GridToolbarExport = (0, $fYxgT.forwardRef)(function GridToolbarExport(props, ref) {
    const _ref = props, { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = _ref, other = (0, $117c70f90fd64960$var$_objectWithoutPropertiesLoose2.default)(_ref, $117c70f90fd64960$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($03n8N.GridToolbarExportContainer, (0, $117c70f90fd64960$var$_extends2.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $117c70f90fd64960$var$React.cloneElement(button.component, {
                key: index
            }))
    }));
});

});
parcelRegister("03n8N", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $00a23b3a9224b6aa$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $00a23b3a9224b6aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbarExportContainer = void 0;

var $00a23b3a9224b6aa$var$_extends2 = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $00a23b3a9224b6aa$var$React = $00a23b3a9224b6aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $00a23b3a9224b6aa$var$_propTypes = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $00a23b3a9224b6aa$var$_useId = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("hwliF")));

var $00a23b3a9224b6aa$var$_useForkRef = $00a23b3a9224b6aa$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $ch6XH = parcelRequire("ch6XH");

var $jDpXp = parcelRequire("jDpXp");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $00a23b3a9224b6aa$var$GridToolbarExportContainer = module.exports.GridToolbarExportContainer = (0, $fYxgT.forwardRef)(function GridToolbarExportContainer(props, ref) {
    const { children: children, slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const exportButtonId = (0, $00a23b3a9224b6aa$var$_useId.default)();
    const exportMenuId = (0, $00a23b3a9224b6aa$var$_useId.default)();
    const [open, setOpen] = $00a23b3a9224b6aa$var$React.useState(false);
    const buttonRef = $00a23b3a9224b6aa$var$React.useRef(null);
    const handleRef = (0, $00a23b3a9224b6aa$var$_useForkRef.default)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    if (children == null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($00a23b3a9224b6aa$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, (0, $00a23b3a9224b6aa$var$_extends2.default)({
                title: apiRef.current.getLocaleText('toolbarExportLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $00a23b3a9224b6aa$var$_extends2.default)({
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleMenuOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarExport')
                }))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ch6XH.GridMenu, {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuList, {
                    id: exportMenuId,
                    className: $5H1vo.gridClasses.menuList,
                    "aria-labelledby": exportButtonId,
                    autoFocusItem: open,
                    children: $00a23b3a9224b6aa$var$React.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $00a23b3a9224b6aa$var$React.isValidElement(child)) return child;
                        return /*#__PURE__*/ $00a23b3a9224b6aa$var$React.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});

});


parcelRegister("1kFTA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0f88284c0023fb16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbarQuickFilter = $0f88284c0023fb16$var$GridToolbarQuickFilter;

var $0f88284c0023fb16$var$_extends2 = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0f88284c0023fb16$var$_objectWithoutPropertiesLoose2 = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("c05no")));

var $0f88284c0023fb16$var$_propTypes = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0f88284c0023fb16$var$_composeClasses = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $0f88284c0023fb16$var$_clsx = $0f88284c0023fb16$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7jHEF = parcelRequire("7jHEF");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $fuO2w = parcelRequire("fuO2w");

var $6qO8T = parcelRequire("6qO8T");

var $hbuUJ = parcelRequire("hbuUJ");

var $ayMG0 = parcelRequire("ayMG0");
const $0f88284c0023fb16$var$_excluded = [
    "quickFilterParser",
    "quickFilterFormatter",
    "debounceMs",
    "className",
    "slotProps"
], $0f88284c0023fb16$var$_excluded2 = [
    "ref",
    "slotProps"
];
const $0f88284c0023fb16$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarQuickFilter'
        ],
        trigger: [
            'toolbarQuickFilterTrigger'
        ],
        control: [
            'toolbarQuickFilterControl'
        ]
    };
    return (0, $0f88284c0023fb16$var$_composeClasses.default)(slots, $7jHEF.getDataGridUtilityClass, classes);
};
const $0f88284c0023fb16$var$GridQuickFilterRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilter'
})({
    display: 'grid',
    alignItems: 'center'
});
const $0f88284c0023fb16$var$GridQuickFilterTrigger = (0, $8xDHs.styled)($6qO8T.ToolbarButton, {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilterTrigger'
})(({ ownerState: ownerState })=>({
        gridArea: '1 / 1',
        width: 'min-content',
        height: 'min-content',
        zIndex: 1,
        opacity: ownerState.expanded ? 0 : 1,
        pointerEvents: ownerState.expanded ? 'none' : 'auto',
        transition: $hbuUJ.vars.transition([
            'opacity'
        ])
    }));
// TODO: Use NotRendered from /utils/assert
// Currently causes react-docgen to fail
const $0f88284c0023fb16$var$GridQuickFilterTextField = (0, $8xDHs.styled)((_props)=>{
    throw new Error('Failed assertion: should not be rendered');
}, {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilterControl'
})(({ ownerState: ownerState })=>({
        gridArea: '1 / 1',
        overflowX: 'clip',
        width: ownerState.expanded ? 260 : 'var(--trigger-width)',
        opacity: ownerState.expanded ? 1 : 0,
        transition: $hbuUJ.vars.transition([
            'width',
            'opacity'
        ])
    }));
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/quick-filter/ Quick Filter} component instead. This component will be removed in a future major release.
 */ function $0f88284c0023fb16$var$GridToolbarQuickFilter(props) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        expanded: false
    };
    const classes = $0f88284c0023fb16$var$useUtilityClasses(ownerState);
    const { quickFilterParser: quickFilterParser, quickFilterFormatter: quickFilterFormatter, debounceMs: debounceMs, className: className, slotProps: slotProps } = props, other = (0, $0f88284c0023fb16$var$_objectWithoutPropertiesLoose2.default)(props, $0f88284c0023fb16$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fuO2w.QuickFilter, {
        parser: quickFilterParser,
        formatter: quickFilterFormatter,
        debounceMs: debounceMs,
        render: (quickFilterProps, state)=>{
            const currentOwnerState = (0, $0f88284c0023fb16$var$_extends2.default)({}, ownerState, {
                expanded: state.expanded
            });
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($0f88284c0023fb16$var$GridQuickFilterRoot, (0, $0f88284c0023fb16$var$_extends2.default)({}, quickFilterProps, {
                className: (0, $0f88284c0023fb16$var$_clsx.default)(classes.root, className),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fuO2w.QuickFilterTrigger, {
                        render: (triggerProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                                title: apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
                                enterDelay: 0 // Prevents tooltip lagging behind transitioning trigger element
                                ,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($0f88284c0023fb16$var$GridQuickFilterTrigger, (0, $0f88284c0023fb16$var$_extends2.default)({
                                    className: classes.trigger
                                }, triggerProps, {
                                    ownerState: currentOwnerState,
                                    color: "default",
                                    "aria-disabled": state.expanded,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {
                                        fontSize: "small"
                                    })
                                }))
                            })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fuO2w.QuickFilterControl, {
                        render: (_ref)=>{
                            let { ref: ref, slotProps: controlSlotProps } = _ref, controlProps = (0, $0f88284c0023fb16$var$_objectWithoutPropertiesLoose2.default)(_ref, $0f88284c0023fb16$var$_excluded2);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($0f88284c0023fb16$var$GridQuickFilterTextField, (0, $0f88284c0023fb16$var$_extends2.default)({
                                as: rootProps.slots.baseTextField,
                                className: classes.control,
                                ownerState: currentOwnerState,
                                inputRef: ref,
                                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
                                placeholder: apiRef.current.getLocaleText('toolbarQuickFilterPlaceholder'),
                                size: "small",
                                slotProps: (0, $0f88284c0023fb16$var$_extends2.default)({
                                    input: (0, $0f88284c0023fb16$var$_extends2.default)({
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterIcon, {
                                            fontSize: "small"
                                        }),
                                        endAdornment: controlProps.value ? /*#__PURE__*/ (0, $ayMG0.jsx)($fuO2w.QuickFilterClear, {
                                            render: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseIconButton, {
                                                size: "small",
                                                edge: "end",
                                                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterDeleteIconLabel'),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.quickFilterClearIcon, {
                                                    fontSize: "small"
                                                })
                                            })
                                        }) : null
                                    }, controlSlotProps?.input)
                                }, controlSlotProps)
                            }, rootProps.slotProps?.baseTextField, controlProps, slotProps?.root, other));
                        }
                    })
                ]
            }));
        }
    });
}
 /**
 * Demos:
 * - [Filtering - overview](https://mui.com/x/react-data-grid/filtering/)
 * - [Filtering - quick filter](https://mui.com/x/react-data-grid/filtering/quick-filter/)
 *
 * API:
 * - [GridToolbarQuickFilter API](https://mui.com/x/api/data-grid/grid-toolbar-quick-filter/)
 */ 
});
parcelRegister("fuO2w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kIvmf = parcelRequire("kIvmf");
Object.keys($kIvmf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kIvmf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kIvmf[key];
        }
    });
});

var $fpkqS = parcelRequire("fpkqS");
Object.keys($fpkqS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fpkqS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fpkqS[key];
        }
    });
});

var $6qW4a = parcelRequire("6qW4a");
Object.keys($6qW4a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6qW4a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6qW4a[key];
        }
    });
});

var $gMaZt = parcelRequire("gMaZt");
Object.keys($gMaZt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gMaZt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gMaZt[key];
        }
    });
});

});
parcelRegister("kIvmf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f1503dbb52e68089$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f1503dbb52e68089$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuickFilter = $f1503dbb52e68089$var$QuickFilter;

var $f1503dbb52e68089$var$_extends2 = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f1503dbb52e68089$var$_objectWithoutPropertiesLoose2 = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("c05no")));

var $f1503dbb52e68089$var$React = $f1503dbb52e68089$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f1503dbb52e68089$var$_propTypes = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f1503dbb52e68089$var$_debounce = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $f1503dbb52e68089$var$_useEnhancedEffect = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $f1503dbb52e68089$var$_useId = $f1503dbb52e68089$require$_interopRequireDefault((parcelRequire("hwliF")));

var $e9lLm = parcelRequire("e9lLm");

var $QvFCk = parcelRequire("QvFCk");

var $5hKSU = parcelRequire("5hKSU");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $13Ynj = parcelRequire("13Ynj");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $f1503dbb52e68089$var$_excluded = [
    "render",
    "className",
    "parser",
    "formatter",
    "debounceMs",
    "defaultExpanded",
    "expanded",
    "onExpandedChange"
];
const $f1503dbb52e68089$var$DEFAULT_PARSER = (searchText)=>searchText.split(' ').filter((word)=>word !== '');
const $f1503dbb52e68089$var$DEFAULT_FORMATTER = (values)=>values.join(' ');
/**
 * The top level Quick Filter component that provides context to child components.
 * It renders a `<div />` element.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilter API](https://mui.com/x/api/data-grid/quick-filter/)
 */ function $f1503dbb52e68089$var$QuickFilter(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { render: render, className: className, parser: parser = $f1503dbb52e68089$var$DEFAULT_PARSER, formatter: formatter = $f1503dbb52e68089$var$DEFAULT_FORMATTER, debounceMs: debounceMs = rootProps.filterDebounceMs, defaultExpanded: defaultExpanded, expanded: expanded, onExpandedChange: onExpandedChange } = props, other = (0, $f1503dbb52e68089$var$_objectWithoutPropertiesLoose2.default)(props, $f1503dbb52e68089$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const controlRef = $f1503dbb52e68089$var$React.useRef(null);
    const triggerRef = $f1503dbb52e68089$var$React.useRef(null);
    const quickFilterValues = (0, $5sOMZ.useGridSelector)(apiRef, $13Ynj.gridQuickFilterValuesSelector);
    const [value, setValue] = $f1503dbb52e68089$var$React.useState(formatter(quickFilterValues ?? []));
    const [internalExpanded, setInternalExpanded] = $f1503dbb52e68089$var$React.useState(defaultExpanded ?? value.length > 0);
    const expandedValue = expanded ?? internalExpanded;
    const state = $f1503dbb52e68089$var$React.useMemo(()=>({
            value: value,
            expanded: expandedValue
        }), [
        value,
        expandedValue
    ]);
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const ref = $f1503dbb52e68089$var$React.useRef(null);
    const controlId = (0, $f1503dbb52e68089$var$_useId.default)();
    const handleExpandedChange = $f1503dbb52e68089$var$React.useCallback((newExpanded)=>{
        if (onExpandedChange) onExpandedChange(newExpanded);
        if (expanded === undefined) setInternalExpanded(newExpanded);
    }, [
        onExpandedChange,
        expanded
    ]);
    const prevQuickFilterValuesRef = $f1503dbb52e68089$var$React.useRef(quickFilterValues);
    $f1503dbb52e68089$var$React.useEffect(()=>{
        if (!(0, $e9lLm.isDeepEqual)(prevQuickFilterValuesRef.current, quickFilterValues)) {
            // The model of quick filter value has been updated
            prevQuickFilterValuesRef.current = quickFilterValues;
            // Update the input value if needed to match the new model
            setValue((prevSearchValue)=>(0, $e9lLm.isDeepEqual)(parser(prevSearchValue), quickFilterValues) ? prevSearchValue : formatter(quickFilterValues ?? []));
        }
    }, [
        quickFilterValues,
        formatter,
        parser
    ]);
    const isFirstRender = $f1503dbb52e68089$var$React.useRef(true);
    const previousExpandedValue = $f1503dbb52e68089$var$React.useRef(expandedValue);
    $f1503dbb52e68089$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        // Ensure the expanded state has actually changed before focusing
        if (previousExpandedValue.current !== expandedValue) {
            if (expandedValue) // Ensures the focus does not interupt CSS transitions and animations on the control
            requestAnimationFrame(()=>{
                controlRef.current?.focus({
                    preventScroll: true
                });
            });
            else triggerRef.current?.focus({
                preventScroll: true
            });
            previousExpandedValue.current = expandedValue;
        }
    }, [
        expandedValue
    ]);
    const setQuickFilterValueDebounced = $f1503dbb52e68089$var$React.useMemo(()=>(0, $f1503dbb52e68089$var$_debounce.default)((newValue)=>{
            const newQuickFilterValues = parser(newValue);
            prevQuickFilterValuesRef.current = newQuickFilterValues;
            apiRef.current.setQuickFilterValues(newQuickFilterValues);
        }, debounceMs), [
        apiRef,
        debounceMs,
        parser
    ]);
    $f1503dbb52e68089$var$React.useEffect(()=>setQuickFilterValueDebounced.clear, [
        setQuickFilterValueDebounced
    ]);
    const handleValueChange = $f1503dbb52e68089$var$React.useCallback((event)=>{
        const newValue = event.target.value;
        setValue(newValue);
        setQuickFilterValueDebounced(newValue);
    }, [
        setQuickFilterValueDebounced
    ]);
    const handleClearValue = $f1503dbb52e68089$var$React.useCallback(()=>{
        setValue('');
        apiRef.current.setQuickFilterValues([]);
        controlRef.current?.focus();
    }, [
        apiRef,
        controlRef
    ]);
    const contextValue = $f1503dbb52e68089$var$React.useMemo(()=>({
            controlRef: controlRef,
            triggerRef: triggerRef,
            state: state,
            controlId: controlId,
            clearValue: handleClearValue,
            onValueChange: handleValueChange,
            onExpandedChange: handleExpandedChange
        }), [
        controlId,
        state,
        handleValueChange,
        handleClearValue,
        handleExpandedChange
    ]);
    (0, $f1503dbb52e68089$var$_useEnhancedEffect.default)(()=>{
        if (ref.current && triggerRef.current) ref.current.style.setProperty('--trigger-width', `${triggerRef.current?.offsetWidth}px`);
    }, []);
    const element = (0, $QvFCk.useComponentRenderer)('div', render, (0, $f1503dbb52e68089$var$_extends2.default)({
        className: resolvedClassName
    }, other, {
        ref: ref
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5hKSU.QuickFilterContext.Provider, {
        value: contextValue,
        children: element
    });
}

});
parcelRegister("5hKSU", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3d92e8977302638c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuickFilterContext = void 0;
module.exports.useQuickFilterContext = $3d92e8977302638c$var$useQuickFilterContext;

var $3d92e8977302638c$var$React = $3d92e8977302638c$require$_interopRequireWildcard((parcelRequire("acw62")));
const $3d92e8977302638c$var$QuickFilterContext = module.exports.QuickFilterContext = /*#__PURE__*/ $3d92e8977302638c$var$React.createContext(undefined);
function $3d92e8977302638c$var$useQuickFilterContext() {
    const context = $3d92e8977302638c$var$React.useContext($3d92e8977302638c$var$QuickFilterContext);
    if (context === undefined) throw new Error('MUI X: Missing context. Quick Filter subcomponents must be placed within a <QuickFilter /> component.');
    return context;
}

});


parcelRegister("fpkqS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b3790a443808d1d4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b3790a443808d1d4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuickFilterControl = void 0;

var $b3790a443808d1d4$var$_extends2 = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b3790a443808d1d4$var$_objectWithoutPropertiesLoose2 = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("c05no")));

var $b3790a443808d1d4$var$React = $b3790a443808d1d4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b3790a443808d1d4$var$_propTypes = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b3790a443808d1d4$var$_useForkRef = $b3790a443808d1d4$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $jDpXp = parcelRequire("jDpXp");

var $5hKSU = parcelRequire("5hKSU");

var $ayMG0 = parcelRequire("ayMG0");
const $b3790a443808d1d4$var$_excluded = [
    "render",
    "className",
    "slotProps",
    "onKeyDown",
    "onChange"
];
/**
 * A component that takes user input and filters row data.
 * It renders the `baseTextField` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterControl API](https://mui.com/x/api/data-grid/quick-filter-control/)
 */ const $b3790a443808d1d4$var$QuickFilterControl = module.exports.QuickFilterControl = (0, $fYxgT.forwardRef)(function QuickFilterControl(props, ref) {
    const { render: render, className: className, slotProps: slotProps, onKeyDown: onKeyDown, onChange: onChange } = props, other = (0, $b3790a443808d1d4$var$_objectWithoutPropertiesLoose2.default)(props, $b3790a443808d1d4$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { state: state, controlId: controlId, controlRef: controlRef, onValueChange: onValueChange, onExpandedChange: onExpandedChange, clearValue: clearValue } = (0, $5hKSU.useQuickFilterContext)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleRef = (0, $b3790a443808d1d4$var$_useForkRef.default)(controlRef, ref);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            if (state.value === '') onExpandedChange(false);
            else clearValue();
        }
        onKeyDown?.(event);
    };
    const handleBlur = (event)=>{
        if (state.value === '') onExpandedChange(false);
        slotProps?.htmlInput?.onBlur?.(event);
    };
    const handleChange = (event)=>{
        if (!state.expanded) onExpandedChange(true);
        onValueChange(event);
        onChange?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseTextField, render, (0, $b3790a443808d1d4$var$_extends2.default)({}, rootProps.slotProps?.baseTextField, {
        slotProps: (0, $b3790a443808d1d4$var$_extends2.default)({
            htmlInput: (0, $b3790a443808d1d4$var$_extends2.default)({
                role: 'searchbox',
                id: controlId,
                tabIndex: state.expanded ? undefined : -1
            }, slotProps?.htmlInput, {
                onBlur: handleBlur
            })
        }, slotProps),
        value: state.value,
        className: resolvedClassName
    }, other, {
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b3790a443808d1d4$var$React.Fragment, {
        children: element
    });
});

});

parcelRegister("6qW4a", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4af2368034d886c8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4af2368034d886c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuickFilterClear = void 0;

var $4af2368034d886c8$var$_extends2 = $4af2368034d886c8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4af2368034d886c8$var$_objectWithoutPropertiesLoose2 = $4af2368034d886c8$require$_interopRequireDefault((parcelRequire("c05no")));

var $4af2368034d886c8$var$React = $4af2368034d886c8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4af2368034d886c8$var$_propTypes = $4af2368034d886c8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $jDpXp = parcelRequire("jDpXp");

var $5hKSU = parcelRequire("5hKSU");

var $ayMG0 = parcelRequire("ayMG0");
const $4af2368034d886c8$var$_excluded = [
    "render",
    "className",
    "onClick"
];
/**
 * A button that resets the filter value.
 * It renders the `baseIconButton` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterClear API](https://mui.com/x/api/data-grid/quick-filter-clear/)
 */ const $4af2368034d886c8$var$QuickFilterClear = module.exports.QuickFilterClear = (0, $fYxgT.forwardRef)(function QuickFilterClear(props, ref) {
    const { render: render, className: className, onClick: onClick } = props, other = (0, $4af2368034d886c8$var$_objectWithoutPropertiesLoose2.default)(props, $4af2368034d886c8$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { state: state, clearValue: clearValue } = (0, $5hKSU.useQuickFilterContext)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleClick = (event)=>{
        clearValue();
        onClick?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseIconButton, render, (0, $4af2368034d886c8$var$_extends2.default)({}, rootProps.slotProps?.baseIconButton, {
        className: resolvedClassName,
        tabIndex: -1
    }, other, {
        onClick: handleClick,
        ref: ref
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4af2368034d886c8$var$React.Fragment, {
        children: element
    });
});

});

parcelRegister("gMaZt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c369a7865021bd20$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c369a7865021bd20$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuickFilterTrigger = void 0;

var $c369a7865021bd20$var$_extends2 = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c369a7865021bd20$var$_objectWithoutPropertiesLoose2 = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("c05no")));

var $c369a7865021bd20$var$React = $c369a7865021bd20$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c369a7865021bd20$var$_propTypes = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $c369a7865021bd20$var$_useForkRef = $c369a7865021bd20$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $jDpXp = parcelRequire("jDpXp");

var $5hKSU = parcelRequire("5hKSU");

var $ayMG0 = parcelRequire("ayMG0");
const $c369a7865021bd20$var$_excluded = [
    "render",
    "className",
    "onClick"
];
/**
 * A button that expands/collapses the quick filter.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterTrigger API](https://mui.com/x/api/data-grid/quick-filter-trigger/)
 */ const $c369a7865021bd20$var$QuickFilterTrigger = module.exports.QuickFilterTrigger = (0, $fYxgT.forwardRef)(function QuickFilterTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick } = props, other = (0, $c369a7865021bd20$var$_objectWithoutPropertiesLoose2.default)(props, $c369a7865021bd20$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { state: state, controlId: controlId, onExpandedChange: onExpandedChange, triggerRef: triggerRef } = (0, $5hKSU.useQuickFilterContext)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleRef = (0, $c369a7865021bd20$var$_useForkRef.default)(triggerRef, ref);
    const handleClick = (event)=>{
        onExpandedChange(!state.expanded);
        onClick?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $c369a7865021bd20$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        className: resolvedClassName,
        'aria-controls': controlId,
        'aria-expanded': state.expanded
    }, other, {
        onClick: handleClick,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c369a7865021bd20$var$React.Fragment, {
        children: element
    });
});

});



parcelRegister("dR2yi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a162346a6ee1b52f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a162346a6ee1b52f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridToolbar = $a162346a6ee1b52f$var$GridToolbar;
module.exports.GridToolbarDivider = $a162346a6ee1b52f$var$GridToolbarDivider;
module.exports.GridToolbarLabel = $a162346a6ee1b52f$var$GridToolbarLabel;

var $a162346a6ee1b52f$var$_extends2 = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2 = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("c05no")));

var $a162346a6ee1b52f$var$React = $a162346a6ee1b52f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a162346a6ee1b52f$var$_propTypes = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a162346a6ee1b52f$var$_useId = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("hwliF")));

var $8xDHs = parcelRequire("8xDHs");

var $a162346a6ee1b52f$var$_composeClasses = $a162346a6ee1b52f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ch6XH = parcelRequire("ch6XH");

var $iBOz6 = parcelRequire("iBOz6");

var $6xDvC = parcelRequire("6xDvC");

var $dFywN = parcelRequire("dFywN");

var $kRqcm = parcelRequire("kRqcm");

var $gQzuM = parcelRequire("gQzuM");

var $1kFTA = parcelRequire("1kFTA");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $j0vMH = parcelRequire("j0vMH");

var $hbuUJ = parcelRequire("hbuUJ");

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $a162346a6ee1b52f$var$_excluded = [
    "className"
], $a162346a6ee1b52f$var$_excluded2 = [
    "className"
], $a162346a6ee1b52f$var$_excluded3 = [
    "showQuickFilter",
    "quickFilterProps",
    "csvOptions",
    "printOptions",
    "mainControls",
    "additionalExportMenuItems"
];
const $a162346a6ee1b52f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        divider: [
            'toolbarDivider'
        ],
        label: [
            'toolbarLabel'
        ]
    };
    return (0, $a162346a6ee1b52f$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $a162346a6ee1b52f$var$Divider = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    name: 'MuiDataGrid',
    slot: 'ToolbarDivider'
})({
    height: '50%',
    margin: $hbuUJ.vars.spacing(0, 0.5)
});
const $a162346a6ee1b52f$var$Label = (0, $8xDHs.styled)('span', {
    name: 'MuiDataGrid',
    slot: 'ToolbarLabel'
})({
    flex: 1,
    font: $hbuUJ.vars.typography.font.large,
    fontWeight: $hbuUJ.vars.typography.fontWeight.medium,
    margin: $hbuUJ.vars.spacing(0, 0.5),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
function $a162346a6ee1b52f$var$GridToolbarDivider(props) {
    const other = (0, $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2.default)(props, $a162346a6ee1b52f$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a162346a6ee1b52f$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$Divider, (0, $a162346a6ee1b52f$var$_extends2.default)({
        as: rootProps.slots.baseDivider,
        orientation: "vertical",
        className: classes.divider
    }, other));
}
function $a162346a6ee1b52f$var$GridToolbarLabel(props) {
    const other = (0, $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2.default)(props, $a162346a6ee1b52f$var$_excluded2);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $a162346a6ee1b52f$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$Label, (0, $a162346a6ee1b52f$var$_extends2.default)({
        className: classes.label
    }, other));
}
function $a162346a6ee1b52f$var$GridToolbar(props) {
    const { showQuickFilter: showQuickFilter = true, quickFilterProps: quickFilterProps, csvOptions: csvOptions, printOptions: printOptions, mainControls: mainControls, additionalExportMenuItems: additionalExportMenuItems } = props, other = (0, $a162346a6ee1b52f$var$_objectWithoutPropertiesLoose2.default)(props, $a162346a6ee1b52f$var$_excluded3);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [exportMenuOpen, setExportMenuOpen] = $a162346a6ee1b52f$var$React.useState(false);
    const exportMenuTriggerRef = $a162346a6ee1b52f$var$React.useRef(null);
    const exportMenuId = (0, $a162346a6ee1b52f$var$_useId.default)();
    const exportMenuTriggerId = (0, $a162346a6ee1b52f$var$_useId.default)();
    const showExportMenu = !csvOptions?.disableToolbarButton || !printOptions?.disableToolbarButton || additionalExportMenuItems;
    const closeExportMenu = ()=>setExportMenuOpen(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($iBOz6.Toolbar, (0, $a162346a6ee1b52f$var$_extends2.default)({}, other, {
        children: [
            rootProps.label && /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$GridToolbarLabel, {
                children: rootProps.label
            }),
            mainControls || /*#__PURE__*/ (0, $ayMG0.jsxs)($a162346a6ee1b52f$var$React.Fragment, {
                children: [
                    !rootProps.disableColumnSelector && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                        title: apiRef.current.getLocaleText('toolbarColumns'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($kRqcm.ColumnsPanelTrigger, {
                            render: /*#__PURE__*/ (0, $ayMG0.jsx)($6xDvC.ToolbarButton, {}),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.columnSelectorIcon, {
                                fontSize: "small"
                            })
                        })
                    }),
                    !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                        title: apiRef.current.getLocaleText('toolbarFilters'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($dFywN.FilterPanelTrigger, {
                            render: (triggerProps, state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6xDvC.ToolbarButton, (0, $a162346a6ee1b52f$var$_extends2.default)({}, triggerProps, {
                                    color: state.filterCount > 0 ? 'primary' : 'default',
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseBadge, {
                                        badgeContent: state.filterCount,
                                        color: "primary",
                                        variant: "dot",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.openFilterButtonIcon, {
                                            fontSize: "small"
                                        })
                                    })
                                }))
                        })
                    })
                ]
            }),
            showExportMenu && (!rootProps.disableColumnFilter || !rootProps.disableColumnSelector) && /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$GridToolbarDivider, {}),
            showExportMenu && /*#__PURE__*/ (0, $ayMG0.jsxs)($a162346a6ee1b52f$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseTooltip, {
                        title: apiRef.current.getLocaleText('toolbarExport'),
                        disableInteractive: exportMenuOpen,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($6xDvC.ToolbarButton, {
                            ref: exportMenuTriggerRef,
                            id: exportMenuTriggerId,
                            "aria-controls": exportMenuId,
                            "aria-haspopup": "true",
                            "aria-expanded": exportMenuOpen ? 'true' : undefined,
                            onClick: ()=>setExportMenuOpen(!exportMenuOpen),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.exportIcon, {
                                fontSize: "small"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ch6XH.GridMenu, {
                        target: exportMenuTriggerRef.current,
                        open: exportMenuOpen,
                        onClose: closeExportMenu,
                        position: "bottom-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(rootProps.slots.baseMenuList, (0, $a162346a6ee1b52f$var$_extends2.default)({
                            id: exportMenuId,
                            "aria-labelledby": exportMenuTriggerId,
                            autoFocusItem: true
                        }, rootProps.slotProps?.baseMenuList, {
                            children: [
                                !printOptions?.disableToolbarButton && /*#__PURE__*/ (0, $ayMG0.jsx)($gQzuM.ExportPrint, {
                                    render: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $a162346a6ee1b52f$var$_extends2.default)({}, rootProps.slotProps?.baseMenuItem)),
                                    options: printOptions,
                                    onClick: closeExportMenu,
                                    children: apiRef.current.getLocaleText('toolbarExportPrint')
                                }),
                                !csvOptions?.disableToolbarButton && /*#__PURE__*/ (0, $ayMG0.jsx)($gQzuM.ExportCsv, {
                                    render: /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseMenuItem, (0, $a162346a6ee1b52f$var$_extends2.default)({}, rootProps.slotProps?.baseMenuItem)),
                                    options: csvOptions,
                                    onClick: closeExportMenu,
                                    children: apiRef.current.getLocaleText('toolbarExportCSV')
                                }),
                                additionalExportMenuItems?.(closeExportMenu)
                            ]
                        }))
                    })
                ]
            }),
            showQuickFilter && /*#__PURE__*/ (0, $ayMG0.jsxs)($a162346a6ee1b52f$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($a162346a6ee1b52f$var$GridToolbarDivider, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1kFTA.GridToolbarQuickFilter, (0, $a162346a6ee1b52f$var$_extends2.default)({}, quickFilterProps))
                ]
            })
        ]
    }));
}

});
parcelRegister("dFywN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7BMcP = parcelRequire("7BMcP");
Object.keys($7BMcP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7BMcP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7BMcP[key];
        }
    });
});

});
parcelRegister("7BMcP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $58a161c9a8edc0d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $58a161c9a8edc0d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FilterPanelTrigger = void 0;

var $58a161c9a8edc0d0$var$_extends2 = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $58a161c9a8edc0d0$var$_objectWithoutPropertiesLoose2 = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("c05no")));

var $58a161c9a8edc0d0$var$React = $58a161c9a8edc0d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $58a161c9a8edc0d0$var$_propTypes = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $58a161c9a8edc0d0$var$_useId = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $58a161c9a8edc0d0$var$_useForkRef = $58a161c9a8edc0d0$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $7fn0i = parcelRequire("7fn0i");

var $bDyDY = parcelRequire("bDyDY");

var $iAdzh = parcelRequire("iAdzh");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $58a161c9a8edc0d0$var$_excluded = [
    "render",
    "className",
    "onClick",
    "onPointerUp"
];
/**
 * A button that opens and closes the filter panel.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Filter Panel](https://mui.com/x/react-data-grid/components/filter-panel/)
 *
 * API:
 *
 * - [FilterPanelTrigger API](https://mui.com/x/api/data-grid/filter-panel-trigger/)
 */ const $58a161c9a8edc0d0$var$FilterPanelTrigger = module.exports.FilterPanelTrigger = (0, $fYxgT.forwardRef)(function FilterPanelTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick, onPointerUp: onPointerUp } = props, other = (0, $58a161c9a8edc0d0$var$_objectWithoutPropertiesLoose2.default)(props, $58a161c9a8edc0d0$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const buttonId = (0, $58a161c9a8edc0d0$var$_useId.default)();
    const panelId = (0, $58a161c9a8edc0d0$var$_useId.default)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const panelState = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridPreferencePanelStateSelector);
    const open = panelState.open && panelState.openedPanelValue === $iAdzh.GridPreferencePanelsValue.filters;
    const activeFilters = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridFilterActiveItemsSelector);
    const filterCount = activeFilters.length;
    const state = {
        open: open,
        filterCount: filterCount
    };
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const { filterPanelTriggerRef: filterPanelTriggerRef } = (0, $7fn0i.useGridPanelContext)();
    const handleRef = (0, $58a161c9a8edc0d0$var$_useForkRef.default)(ref, filterPanelTriggerRef);
    const handleClick = (event)=>{
        if (open) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($iAdzh.GridPreferencePanelsValue.filters, panelId, buttonId);
        onClick?.(event);
    };
    const handlePointerUp = (event)=>{
        if (open) event.stopPropagation();
        onPointerUp?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $58a161c9a8edc0d0$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        id: buttonId,
        'aria-haspopup': 'true',
        'aria-expanded': open ? 'true' : undefined,
        'aria-controls': open ? panelId : undefined,
        onClick: handleClick,
        onPointerUp: handlePointerUp,
        className: resolvedClassName
    }, other, {
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($58a161c9a8edc0d0$var$React.Fragment, {
        children: element
    });
});

});


parcelRegister("kRqcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4o83a = parcelRequire("4o83a");
Object.keys($4o83a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4o83a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4o83a[key];
        }
    });
});

});
parcelRegister("4o83a", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $331fa5ea82256f21$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $331fa5ea82256f21$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColumnsPanelTrigger = void 0;

var $331fa5ea82256f21$var$_extends2 = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $331fa5ea82256f21$var$_objectWithoutPropertiesLoose2 = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("c05no")));

var $331fa5ea82256f21$var$React = $331fa5ea82256f21$require$_interopRequireWildcard((parcelRequire("acw62")));

var $331fa5ea82256f21$var$_propTypes = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $331fa5ea82256f21$var$_useId = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fYxgT = parcelRequire("fYxgT");

var $331fa5ea82256f21$var$_useForkRef = $331fa5ea82256f21$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $QvFCk = parcelRequire("QvFCk");

var $7fn0i = parcelRequire("7fn0i");

var $bDyDY = parcelRequire("bDyDY");

var $iAdzh = parcelRequire("iAdzh");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $331fa5ea82256f21$var$_excluded = [
    "render",
    "className",
    "onClick",
    "onPointerUp"
];
/**
 * A button that opens and closes the columns panel.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Columns Panel](https://mui.com/x/react-data-grid/components/columns-panel/)
 *
 * API:
 *
 * - [ColumnsPanelTrigger API](https://mui.com/x/api/data-grid/columns-panel-trigger/)
 */ const $331fa5ea82256f21$var$ColumnsPanelTrigger = module.exports.ColumnsPanelTrigger = (0, $fYxgT.forwardRef)(function ColumnsPanelTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick, onPointerUp: onPointerUp } = props, other = (0, $331fa5ea82256f21$var$_objectWithoutPropertiesLoose2.default)(props, $331fa5ea82256f21$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const buttonId = (0, $331fa5ea82256f21$var$_useId.default)();
    const panelId = (0, $331fa5ea82256f21$var$_useId.default)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const panelState = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridPreferencePanelStateSelector);
    const open = panelState.open && panelState.openedPanelValue === $iAdzh.GridPreferencePanelsValue.columns;
    const state = {
        open: open
    };
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const { columnsPanelTriggerRef: columnsPanelTriggerRef } = (0, $7fn0i.useGridPanelContext)();
    const handleRef = (0, $331fa5ea82256f21$var$_useForkRef.default)(ref, columnsPanelTriggerRef);
    const handleClick = (event)=>{
        if (open) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences($iAdzh.GridPreferencePanelsValue.columns, panelId, buttonId);
        onClick?.(event);
    };
    const handlePointerUp = (event)=>{
        if (open) event.stopPropagation();
        onPointerUp?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $331fa5ea82256f21$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        id: buttonId,
        'aria-haspopup': 'true',
        'aria-expanded': open ? 'true' : undefined,
        'aria-controls': open ? panelId : undefined,
        className: resolvedClassName
    }, other, {
        onPointerUp: handlePointerUp,
        onClick: handleClick,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($331fa5ea82256f21$var$React.Fragment, {
        children: element
    });
});

});


parcelRegister("gQzuM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $64JJj = parcelRequire("64JJj");
Object.keys($64JJj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $64JJj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $64JJj[key];
        }
    });
});

var $k6hhg = parcelRequire("k6hhg");
Object.keys($k6hhg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $k6hhg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k6hhg[key];
        }
    });
});

});
parcelRegister("64JJj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $46c696c5f6e02a46$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $46c696c5f6e02a46$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExportCsv = void 0;

var $46c696c5f6e02a46$var$_extends2 = $46c696c5f6e02a46$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $46c696c5f6e02a46$var$_objectWithoutPropertiesLoose2 = $46c696c5f6e02a46$require$_interopRequireDefault((parcelRequire("c05no")));

var $46c696c5f6e02a46$var$React = $46c696c5f6e02a46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $46c696c5f6e02a46$var$_propTypes = $46c696c5f6e02a46$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $46c696c5f6e02a46$var$_excluded = [
    "render",
    "options",
    "onClick"
];
/**
 * A button that triggers a CSV export.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Export](https://mui.com/x/react-data-grid/components/export/)
 *
 * API:
 *
 * - [ExportCsv API](https://mui.com/x/api/data-grid/export-csv/)
 */ const $46c696c5f6e02a46$var$ExportCsv = module.exports.ExportCsv = (0, $fYxgT.forwardRef)(function ExportCsv(props, ref) {
    const { render: render, options: options, onClick: onClick } = props, other = (0, $46c696c5f6e02a46$var$_objectWithoutPropertiesLoose2.default)(props, $46c696c5f6e02a46$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const handleClick = (event)=>{
        apiRef.current.exportDataAsCsv(options);
        onClick?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $46c696c5f6e02a46$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        onClick: handleClick
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($46c696c5f6e02a46$var$React.Fragment, {
        children: element
    });
});

});

parcelRegister("k6hhg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ea21c527355822bd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ea21c527355822bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExportPrint = void 0;

var $ea21c527355822bd$var$_extends2 = $ea21c527355822bd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ea21c527355822bd$var$_objectWithoutPropertiesLoose2 = $ea21c527355822bd$require$_interopRequireDefault((parcelRequire("c05no")));

var $ea21c527355822bd$var$React = $ea21c527355822bd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ea21c527355822bd$var$_propTypes = $ea21c527355822bd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $QvFCk = parcelRequire("QvFCk");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $ea21c527355822bd$var$_excluded = [
    "render",
    "options",
    "onClick"
];
/**
 * A button that triggers a print export.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Export](https://mui.com/x/react-data-grid/components/export/)
 *
 * API:
 *
 * - [ExportPrint API](https://mui.com/x/api/data-grid/export-print/)
 */ const $ea21c527355822bd$var$ExportPrint = module.exports.ExportPrint = (0, $fYxgT.forwardRef)(function ExportPrint(props, ref) {
    const { render: render, options: options, onClick: onClick } = props, other = (0, $ea21c527355822bd$var$_objectWithoutPropertiesLoose2.default)(props, $ea21c527355822bd$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const handleClick = (event)=>{
        apiRef.current.exportDataAsPrint(options);
        onClick?.(event);
    };
    const element = (0, $QvFCk.useComponentRenderer)(rootProps.slots.baseButton, render, (0, $ea21c527355822bd$var$_extends2.default)({}, rootProps.slotProps?.baseButton, {
        onClick: handleClick
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ea21c527355822bd$var$React.Fragment, {
        children: element
    });
});

});





parcelRegister("jIkp9", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e5a1f44ff53ee1a6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridFooter = void 0;

var $e5a1f44ff53ee1a6$var$_extends2 = $e5a1f44ff53ee1a6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e5a1f44ff53ee1a6$var$_propTypes = $e5a1f44ff53ee1a6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");

var $k278Q = parcelRequire("k278Q");

var $bDyDY = parcelRequire("bDyDY");

var $fNKx6 = parcelRequire("fNKx6");

var $jgcq7 = parcelRequire("jgcq7");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $e5a1f44ff53ee1a6$var$GridFooter = module.exports.GridFooter = (0, $fYxgT.forwardRef)(function GridFooter(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const totalTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $goCyd.gridTopLevelRowCountSelector);
    const selectedRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $av74L.gridRowSelectionCountSelector);
    const visibleTopLevelRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridFilteredTopLevelRowCountSelector);
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($fNKx6.GridSelectedRowCount, {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.footerRowCount, (0, $e5a1f44ff53ee1a6$var$_extends2.default)({}, rootProps.slotProps?.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.pagination, (0, $e5a1f44ff53ee1a6$var$_extends2.default)({}, rootProps.slotProps?.pagination));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($jgcq7.GridFooterContainer, (0, $e5a1f44ff53ee1a6$var$_extends2.default)({}, props, {
        ref: ref,
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});

});
parcelRegister("fNKx6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b80f871a1017d664$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b80f871a1017d664$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridSelectedRowCount = void 0;

var $b80f871a1017d664$var$_extends2 = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b80f871a1017d664$var$_objectWithoutPropertiesLoose2 = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("c05no")));

var $b80f871a1017d664$var$React = $b80f871a1017d664$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b80f871a1017d664$var$_propTypes = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b80f871a1017d664$var$_clsx = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b80f871a1017d664$var$_composeClasses = $b80f871a1017d664$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $b80f871a1017d664$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $b80f871a1017d664$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $b80f871a1017d664$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $b80f871a1017d664$var$GridSelectedRowCountRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount'
})({
    alignItems: 'center',
    display: 'flex',
    margin: $hbuUJ.vars.spacing(0, 2),
    visibility: 'hidden',
    width: 0,
    height: 0,
    [$hbuUJ.vars.breakpoints.up('sm')]: {
        visibility: 'visible',
        width: 'auto',
        height: 'auto'
    }
});
const $b80f871a1017d664$var$GridSelectedRowCount = module.exports.GridSelectedRowCount = (0, $fYxgT.forwardRef)(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $b80f871a1017d664$var$_objectWithoutPropertiesLoose2.default)(props, $b80f871a1017d664$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $b80f871a1017d664$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b80f871a1017d664$var$GridSelectedRowCountRoot, (0, $b80f871a1017d664$var$_extends2.default)({
        className: (0, $b80f871a1017d664$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: rowSelectedText
    }));
});

});


parcelRegister("4YSVE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3a075fc4ca1dcd85$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3a075fc4ca1dcd85$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridLoadingOverlay = void 0;

var $3a075fc4ca1dcd85$var$_extends2 = $3a075fc4ca1dcd85$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3a075fc4ca1dcd85$var$_objectWithoutPropertiesLoose2 = $3a075fc4ca1dcd85$require$_interopRequireDefault((parcelRequire("c05no")));

var $3a075fc4ca1dcd85$var$React = $3a075fc4ca1dcd85$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3a075fc4ca1dcd85$var$_propTypes = $3a075fc4ca1dcd85$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $809Ep = parcelRequire("809Ep");

var $hZJKl = parcelRequire("hZJKl");

var $bDyDY = parcelRequire("bDyDY");

var $iAdzh = parcelRequire("iAdzh");

var $ayMG0 = parcelRequire("ayMG0");
const $3a075fc4ca1dcd85$var$_excluded = [
    "variant",
    "noRowsVariant",
    "style"
];
const $3a075fc4ca1dcd85$var$LOADING_VARIANTS = {
    'circular-progress': {
        component: (rootProps)=>rootProps.slots.baseCircularProgress,
        style: {}
    },
    'linear-progress': {
        component: (rootProps)=>rootProps.slots.baseLinearProgress,
        style: {
            display: 'block'
        }
    },
    skeleton: {
        component: ()=>$hZJKl.GridSkeletonLoadingOverlay,
        style: {
            display: 'block'
        }
    }
};
const $3a075fc4ca1dcd85$var$GridLoadingOverlay = module.exports.GridLoadingOverlay = (0, $fYxgT.forwardRef)(function GridLoadingOverlay(props, ref) {
    const { variant: variant = 'linear-progress', noRowsVariant: noRowsVariant = 'skeleton', style: style } = props, other = (0, $3a075fc4ca1dcd85$var$_objectWithoutPropertiesLoose2.default)(props, $3a075fc4ca1dcd85$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const rowsCount = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridRowCountSelector);
    const activeVariant = $3a075fc4ca1dcd85$var$LOADING_VARIANTS[rowsCount === 0 ? noRowsVariant : variant];
    const Component = activeVariant.component(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($809Ep.GridOverlay, (0, $3a075fc4ca1dcd85$var$_extends2.default)({
        style: (0, $3a075fc4ca1dcd85$var$_extends2.default)({}, activeVariant.style, style)
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {})
    }));
});

});
parcelRegister("hZJKl", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d19b9e7dfc56bad3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d19b9e7dfc56bad3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridSkeletonLoadingOverlayInner = module.exports.GridSkeletonLoadingOverlay = void 0;

var $d19b9e7dfc56bad3$var$_extends2 = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d19b9e7dfc56bad3$var$_objectWithoutPropertiesLoose2 = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("c05no")));

var $d19b9e7dfc56bad3$var$React = $d19b9e7dfc56bad3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d19b9e7dfc56bad3$var$_clsx = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $d19b9e7dfc56bad3$var$_useForkRef = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $d19b9e7dfc56bad3$var$_composeClasses = $d19b9e7dfc56bad3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $iAdzh = parcelRequire("iAdzh");

var $jZka4 = parcelRequire("jZka4");

var $61HyH = parcelRequire("61HyH");

var $5H1vo = parcelRequire("5H1vo");

var $jWPPy = parcelRequire("jWPPy");

var $lbNvN = parcelRequire("lbNvN");

var $KtEo5 = parcelRequire("KtEo5");

var $eV2As = parcelRequire("eV2As");

var $94sAG = parcelRequire("94sAG");

var $ayMG0 = parcelRequire("ayMG0");
const $d19b9e7dfc56bad3$var$_excluded = [
    "skeletonRowsCount",
    "visibleColumns",
    "showFirstRowBorder"
];
const $d19b9e7dfc56bad3$var$SkeletonOverlay = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'SkeletonLoadingOverlay'
})({
    minWidth: '100%',
    width: 'max-content',
    // prevents overflow: clip; cutting off the x axis
    height: '100%',
    overflow: 'clip' // y axis is hidden while the x axis is allowed to overflow
});
const $d19b9e7dfc56bad3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'skeletonLoadingOverlay'
        ]
    };
    return (0, $d19b9e7dfc56bad3$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $d19b9e7dfc56bad3$var$getColIndex = (el)=>parseInt(el.getAttribute('data-colindex'), 10);
const $d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlayInner = module.exports.GridSkeletonLoadingOverlayInner = (0, $fYxgT.forwardRef)(function GridSkeletonLoadingOverlayInner(props, forwardedRef) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { slots: slots } = rootProps;
    const isRtl = (0, $9uEev.useRtl)();
    const classes = $d19b9e7dfc56bad3$var$useUtilityClasses({
        classes: rootProps.classes
    });
    const ref = $d19b9e7dfc56bad3$var$React.useRef(null);
    const handleRef = (0, $d19b9e7dfc56bad3$var$_useForkRef.default)(ref, forwardedRef);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const dimensions = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridDimensionsSelector);
    const totalWidth = (0, $iAdzh.useGridSelector)(apiRef, $61HyH.gridColumnsTotalWidthSelector);
    const positions = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridColumnPositionsSelector);
    const inViewportCount = $d19b9e7dfc56bad3$var$React.useMemo(()=>positions.filter((value)=>value <= totalWidth).length, [
        totalWidth,
        positions
    ]);
    const { skeletonRowsCount: skeletonRowsCount, visibleColumns: visibleColumns, showFirstRowBorder: showFirstRowBorder } = props, other = (0, $d19b9e7dfc56bad3$var$_objectWithoutPropertiesLoose2.default)(props, $d19b9e7dfc56bad3$var$_excluded);
    const allVisibleColumns = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridVisibleColumnDefinitionsSelector);
    const columns = $d19b9e7dfc56bad3$var$React.useMemo(()=>allVisibleColumns.slice(0, inViewportCount), [
        allVisibleColumns,
        inViewportCount
    ]);
    const pinnedColumns = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridVisiblePinnedColumnDefinitionsSelector);
    const getPinnedPosition = $d19b9e7dfc56bad3$var$React.useCallback((field)=>{
        if (pinnedColumns.left.findIndex((col)=>col.field === field) !== -1) return $jZka4.PinnedColumnPosition.LEFT;
        if (pinnedColumns.right.findIndex((col)=>col.field === field) !== -1) return $jZka4.PinnedColumnPosition.RIGHT;
        return undefined;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const children = $d19b9e7dfc56bad3$var$React.useMemo(()=>{
        const array = [];
        for(let i = 0; i < skeletonRowsCount; i += 1){
            const rowCells = [];
            for(let colIndex = 0; colIndex < columns.length; colIndex += 1){
                const column = columns[colIndex];
                const pinnedPosition = getPinnedPosition(column.field);
                const isPinnedLeft = pinnedPosition === $jZka4.PinnedColumnPosition.LEFT;
                const isPinnedRight = pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT;
                const pinnedSide = (0, $eV2As.rtlFlipSide)(pinnedPosition, isRtl);
                const sectionLength = pinnedSide ? pinnedColumns[pinnedSide].length // pinned section
                 : columns.length - pinnedColumns.left.length - pinnedColumns.right.length; // middle section
                const sectionIndex = pinnedSide ? pinnedColumns[pinnedSide].findIndex((col)=>col.field === column.field) // pinned section
                 : colIndex - pinnedColumns.left.length; // middle section
                const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
                const pinnedStyle = (0, $94sAG.attachPinnedStyle)({}, isRtl, pinnedPosition, (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, column.computedWidth, colIndex, positions, dimensions.columnsTotalWidth, scrollbarWidth));
                const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
                const showRightBorder = (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, sectionIndex, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
                const showLeftBorder = (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, sectionIndex, rootProps.showCellVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
                const isLastColumn = colIndex === columns.length - 1;
                const isFirstPinnedRight = isPinnedRight && sectionIndex === 0;
                const hasFillerBefore = isFirstPinnedRight && gridHasFiller;
                const hasFillerAfter = isLastColumn && !isFirstPinnedRight && gridHasFiller;
                const expandedWidth = dimensions.viewportOuterSize.width - dimensions.columnsTotalWidth;
                const emptyCellWidth = Math.max(0, expandedWidth);
                const emptyCell = /*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    width: emptyCellWidth,
                    empty: true
                }, `skeleton-filler-column-${i}`);
                if (hasFillerBefore) rowCells.push(emptyCell);
                rowCells.push(/*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
                    field: column.field,
                    type: column.type,
                    align: column.align,
                    width: "var(--width)",
                    height: dimensions.rowHeight,
                    "data-colindex": colIndex,
                    empty: visibleColumns && !visibleColumns.has(column.field),
                    className: (0, $d19b9e7dfc56bad3$var$_clsx.default)(isPinnedLeft && $5H1vo.gridClasses['cell--pinnedLeft'], isPinnedRight && $5H1vo.gridClasses['cell--pinnedRight'], showRightBorder && $5H1vo.gridClasses['cell--withRightBorder'], showLeftBorder && $5H1vo.gridClasses['cell--withLeftBorder']),
                    style: (0, $d19b9e7dfc56bad3$var$_extends2.default)({
                        '--width': `${column.computedWidth}px`
                    }, pinnedStyle)
                }, `skeleton-column-${i}-${column.field}`));
                if (hasFillerAfter) rowCells.push(emptyCell);
            }
            array.push(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $d19b9e7dfc56bad3$var$_clsx.default)($5H1vo.gridClasses.row, $5H1vo.gridClasses.rowSkeleton, i === 0 && !showFirstRowBorder && $5H1vo.gridClasses['row--firstVisible']),
                children: rowCells
            }, `skeleton-row-${i}`));
        }
        return array;
    }, [
        skeletonRowsCount,
        columns,
        getPinnedPosition,
        isRtl,
        pinnedColumns,
        dimensions.hasScrollY,
        dimensions.scrollbarSize,
        dimensions.columnsTotalWidth,
        dimensions.viewportOuterSize.width,
        dimensions.rowHeight,
        positions,
        rootProps.showCellVerticalBorder,
        rootProps.pinnedColumnsSectionSeparator,
        slots,
        visibleColumns,
        showFirstRowBorder
    ]);
    // Sync the column resize of the overlay columns with the grid
    const handleColumnResize = (params)=>{
        const { colDef: colDef, width: width } = params;
        const cells = ref.current?.querySelectorAll(`[data-field="${(0, $KtEo5.escapeOperandAttributeSelector)(colDef.field)}"]`);
        if (!cells) throw new Error('MUI X: Expected skeleton cells to be defined with `data-field` attribute.');
        const resizedColIndex = columns.findIndex((col)=>col.field === colDef.field);
        const pinnedPosition = getPinnedPosition(colDef.field);
        const isPinnedLeft = pinnedPosition === $jZka4.PinnedColumnPosition.LEFT;
        const isPinnedRight = pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT;
        const currentWidth = getComputedStyle(cells[0]).getPropertyValue('--width');
        const delta = parseInt(currentWidth, 10) - width;
        if (cells) cells.forEach((element)=>{
            element.style.setProperty('--width', `${width}px`);
        });
        if (isPinnedLeft) {
            const pinnedCells = ref.current?.querySelectorAll(`.${$5H1vo.gridClasses['cell--pinnedLeft']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $d19b9e7dfc56bad3$var$getColIndex(element);
                if (colIndex > resizedColIndex) element.style.left = `${parseInt(getComputedStyle(element).left, 10) - delta}px`;
            });
        }
        if (isPinnedRight) {
            const pinnedCells = ref.current?.querySelectorAll(`.${$5H1vo.gridClasses['cell--pinnedRight']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $d19b9e7dfc56bad3$var$getColIndex(element);
                if (colIndex < resizedColIndex) element.style.right = `${parseInt(getComputedStyle(element).right, 10) + delta}px`;
            });
        }
    };
    (0, $iAdzh.useGridEvent)(apiRef, 'columnResize', handleColumnResize);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d19b9e7dfc56bad3$var$SkeletonOverlay, (0, $d19b9e7dfc56bad3$var$_extends2.default)({
        className: classes.root
    }, other, {
        ref: handleRef,
        children: children
    }));
});
const $d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlay = module.exports.GridSkeletonLoadingOverlay = (0, $fYxgT.forwardRef)(function GridSkeletonLoadingOverlay(props, forwardedRef) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const dimensions = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridDimensionsSelector);
    const viewportHeight = dimensions?.viewportInnerSize.height ?? 0;
    const skeletonRowsCount = Math.ceil(viewportHeight / dimensions.rowHeight);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d19b9e7dfc56bad3$var$GridSkeletonLoadingOverlayInner, (0, $d19b9e7dfc56bad3$var$_extends2.default)({}, props, {
        skeletonRowsCount: skeletonRowsCount,
        ref: forwardedRef
    }));
});

});
parcelRegister("jWPPy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPinnedCellOffset = void 0;

var $jZka4 = parcelRequire("jZka4");
const $e85ba38bf3b586f5$var$getPinnedCellOffset = (pinnedPosition, computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth)=>{
    let pinnedOffset;
    switch(pinnedPosition){
        case $jZka4.PinnedColumnPosition.LEFT:
            pinnedOffset = columnPositions[columnIndex];
            break;
        case $jZka4.PinnedColumnPosition.RIGHT:
            pinnedOffset = columnsTotalWidth - columnPositions[columnIndex] - computedWidth + scrollbarWidth;
            break;
        default:
            pinnedOffset = undefined;
            break;
    }
    // XXX: fix this properly
    if (Number.isNaN(pinnedOffset)) pinnedOffset = undefined;
    return pinnedOffset;
};
module.exports.getPinnedCellOffset = $e85ba38bf3b586f5$var$getPinnedCellOffset;

});

parcelRegister("lbNvN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldCellShowRightBorder = module.exports.shouldCellShowLeftBorder = void 0;

var $jZka4 = parcelRequire("jZka4");
const $f6d1081691c64c11$var$shouldCellShowRightBorder = (pinnedPosition, indexInSection, sectionLength, showCellVerticalBorderRootProp, gridHasFiller, pinnedColumnsSectionSeparatorRootProp)=>{
    const isSectionLastCell = indexInSection === sectionLength - 1;
    if (pinnedColumnsSectionSeparatorRootProp?.startsWith('border') && pinnedPosition === $jZka4.PinnedColumnPosition.LEFT && isSectionLastCell) return true;
    if (showCellVerticalBorderRootProp) {
        if (pinnedPosition === $jZka4.PinnedColumnPosition.LEFT) return true;
        if (pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT) return !isSectionLastCell;
        // pinnedPosition === undefined, middle section
        return !isSectionLastCell || gridHasFiller;
    }
    return false;
};
module.exports.shouldCellShowRightBorder = $f6d1081691c64c11$var$shouldCellShowRightBorder;
const $f6d1081691c64c11$var$shouldCellShowLeftBorder = (pinnedPosition, indexInSection, showCellVerticalBorderRootProp, pinnedColumnsSectionSeparatorRootProp)=>{
    if (pinnedColumnsSectionSeparatorRootProp?.startsWith('border')) return pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT && indexInSection === 0;
    return showCellVerticalBorderRootProp && pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT && indexInSection === 0;
};
module.exports.shouldCellShowLeftBorder = $f6d1081691c64c11$var$shouldCellShowLeftBorder;

});



parcelRegister("28JSg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $18efe9c687188074$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridNoRowsOverlay = void 0;

var $18efe9c687188074$var$_extends2 = $18efe9c687188074$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $18efe9c687188074$var$_propTypes = $18efe9c687188074$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $18efe9c687188074$var$GridNoRowsOverlay = module.exports.GridNoRowsOverlay = (0, $fYxgT.forwardRef)(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($809Ep.GridOverlay, (0, $18efe9c687188074$var$_extends2.default)({}, props, {
        ref: ref,
        children: noRowsLabel
    }));
});

});

parcelRegister("7Mzkc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0176544dd696ebe6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridNoColumnsOverlay = void 0;

var $0176544dd696ebe6$var$_extends2 = $0176544dd696ebe6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0176544dd696ebe6$var$_propTypes = $0176544dd696ebe6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fYxgT = parcelRequire("fYxgT");

var $jDpXp = parcelRequire("jDpXp");

var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $3PCYS = parcelRequire("3PCYS");

var $iAdzh = parcelRequire("iAdzh");

var $ayMG0 = parcelRequire("ayMG0");
const $0176544dd696ebe6$var$GridNoColumnsOverlay = module.exports.GridNoColumnsOverlay = (0, $fYxgT.forwardRef)(function GridNoColumnsOverlay(props, ref) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columns = (0, $iAdzh.useGridSelector)(apiRef, $iAdzh.gridColumnFieldsSelector);
    const handleOpenManageColumns = ()=>{
        apiRef.current.showPreferences($3PCYS.GridPreferencePanelsValue.columns);
    };
    const showManageColumnsButton = !rootProps.disableColumnSelector && columns.length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($809Ep.GridOverlay, (0, $0176544dd696ebe6$var$_extends2.default)({}, props, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('noColumnsOverlayLabel'),
            showManageColumnsButton && /*#__PURE__*/ (0, $ayMG0.jsx)(rootProps.slots.baseButton, (0, $0176544dd696ebe6$var$_extends2.default)({
                size: "small"
            }, rootProps.slotProps?.baseButton, {
                onClick: handleOpenManageColumns,
                children: apiRef.current.getLocaleText('noColumnsOverlayManageColumns')
            }))
        ]
    }));
});

});

parcelRegister("fuqu4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b46e33860b6061fb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b46e33860b6061fb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPagination = $b46e33860b6061fb$var$GridPagination;

var $b46e33860b6061fb$var$_extends2 = $b46e33860b6061fb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b46e33860b6061fb$var$React = $b46e33860b6061fb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $b46e33860b6061fb$var$_propTypes = $b46e33860b6061fb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $j0vMH = parcelRequire("j0vMH");

var $5sOMZ = parcelRequire("5sOMZ");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");

var $gPWuj = parcelRequire("gPWuj");

var $ayMG0 = parcelRequire("ayMG0");
const $b46e33860b6061fb$var$GridPaginationRoot = (0, $8xDHs.styled)($j0vMH.NotRendered, {
    slot: 'internal'
})({
    maxHeight: 'calc(100% + 1px)',
    // border width
    flexGrow: 1
});
function $b46e33860b6061fb$var$GridPagination() {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, $gPWuj.gridPaginationModelSelector);
    const rowCount = (0, $5sOMZ.useGridSelector)(apiRef, $gPWuj.gridPaginationRowCountSelector);
    const pageCount = (0, $5sOMZ.useGridSelector)(apiRef, $gPWuj.gridPageCountSelector);
    const { paginationMode: paginationMode, loading: loading } = rootProps;
    const disabled = rowCount === -1 && paginationMode === 'server' && loading;
    const lastPage = $b46e33860b6061fb$var$React.useMemo(()=>Math.max(0, pageCount - 1), [
        pageCount
    ]);
    const computedPage = $b46e33860b6061fb$var$React.useMemo(()=>{
        if (rowCount === -1) return paginationModel.page;
        return paginationModel.page <= lastPage ? paginationModel.page : lastPage;
    }, [
        lastPage,
        paginationModel.page,
        rowCount
    ]);
    const handlePageSizeChange = $b46e33860b6061fb$var$React.useCallback((pageSize)=>{
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $b46e33860b6061fb$var$React.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46e33860b6061fb$var$GridPaginationRoot, (0, $b46e33860b6061fb$var$_extends2.default)({
        as: rootProps.slots.basePagination,
        count: rowCount,
        page: computedPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange,
        disabled: disabled
    }, rootProps.slotProps?.basePagination));
}

});

parcelRegister("l3iPY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f5387d79a8532a8d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5387d79a8532a8d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRowCount = void 0;

var $f5387d79a8532a8d$var$_extends2 = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f5387d79a8532a8d$var$_objectWithoutPropertiesLoose2 = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("c05no")));

var $f5387d79a8532a8d$var$React = $f5387d79a8532a8d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f5387d79a8532a8d$var$_propTypes = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f5387d79a8532a8d$var$_clsx = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f5387d79a8532a8d$var$_composeClasses = $f5387d79a8532a8d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $hbuUJ = parcelRequire("hbuUJ");

var $bDyDY = parcelRequire("bDyDY");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $f5387d79a8532a8d$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $f5387d79a8532a8d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $f5387d79a8532a8d$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $f5387d79a8532a8d$var$GridRowCountRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount'
})({
    alignItems: 'center',
    display: 'flex',
    margin: $hbuUJ.vars.spacing(0, 2)
});
const $f5387d79a8532a8d$var$GridRowCount = module.exports.GridRowCount = (0, $fYxgT.forwardRef)(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $f5387d79a8532a8d$var$_objectWithoutPropertiesLoose2.default)(props, $f5387d79a8532a8d$var$_excluded);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const ownerState = (0, $jDpXp.useGridRootProps)();
    const classes = $f5387d79a8532a8d$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f5387d79a8532a8d$var$GridRowCountRoot, (0, $f5387d79a8532a8d$var$_extends2.default)({
        className: (0, $f5387d79a8532a8d$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});

});

parcelRegister("kWPQR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f40172132c7a6c94$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f40172132c7a6c94$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRow = void 0;

var $f40172132c7a6c94$var$_extends2 = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f40172132c7a6c94$var$_objectWithoutPropertiesLoose2 = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("c05no")));

var $f40172132c7a6c94$var$React = $f40172132c7a6c94$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f40172132c7a6c94$var$_propTypes = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f40172132c7a6c94$var$_clsx = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f40172132c7a6c94$var$_useForkRef = $f40172132c7a6c94$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $2nKmT = parcelRequire("2nKmT");

var $fYxgT = parcelRequire("fYxgT");

var $7w6sa = parcelRequire("7w6sa");

var $jkRzp = parcelRequire("jkRzp");

var $5H1vo = parcelRequire("5H1vo");

var $4P61c = parcelRequire("4P61c");

var $jDpXp = parcelRequire("jDpXp");

var $lbNvN = parcelRequire("lbNvN");

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $aJApm = parcelRequire("aJApm");

var $KtEo5 = parcelRequire("KtEo5");

var $5bG6h = parcelRequire("5bG6h");

var $8z2XQ = parcelRequire("8z2XQ");

var $jZka4 = parcelRequire("jZka4");

var $iU3u2 = parcelRequire("iU3u2");

var $goCyd = parcelRequire("goCyd");

var $5Rfo7 = parcelRequire("5Rfo7");

var $8o0w1 = parcelRequire("8o0w1");

var $3pyi5 = parcelRequire("3pyi5");

var $jWPPy = parcelRequire("jWPPy");

var $3J8MS = parcelRequire("3J8MS");

var $er55f = parcelRequire("er55f");

var $cgQ4y = parcelRequire("cgQ4y");

var $ayMG0 = parcelRequire("ayMG0");
const $f40172132c7a6c94$var$_excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "rowHeight",
    "className",
    "visibleColumns",
    "pinnedColumns",
    "offsetLeft",
    "columnsTotalWidth",
    "firstColumnIndex",
    "lastColumnIndex",
    "focusedColumnIndex",
    "isFirstVisible",
    "isLastVisible",
    "isNotVisible",
    "showBottomBorder",
    "scrollbarWidth",
    "gridHasFiller",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $f40172132c7a6c94$var$isRowReorderingEnabledSelector = (0, $cgQ4y.createSelector)($5Rfo7.gridEditRowsStateSelector, (editRows, { rowReordering: rowReordering, treeData: treeData })=>{
    if (!rowReordering || treeData) return false;
    const isEditingRows = !(0, $7w6sa.isObjectEmpty)(editRows);
    return !isEditingRows;
});
const $f40172132c7a6c94$var$GridRow = (0, $fYxgT.forwardRef)(function GridRow(props, refProp) {
    const { selected: selected, rowId: rowId, row: row, index: index, style: styleProp, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, pinnedColumns: pinnedColumns, offsetLeft: offsetLeft, columnsTotalWidth: columnsTotalWidth, firstColumnIndex: firstColumnIndex, lastColumnIndex: lastColumnIndex, focusedColumnIndex: focusedColumnIndex, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, isNotVisible: isNotVisible, showBottomBorder: showBottomBorder, scrollbarWidth: scrollbarWidth, gridHasFiller: gridHasFiller, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $f40172132c7a6c94$var$_objectWithoutPropertiesLoose2.default)(props, $f40172132c7a6c94$var$_excluded);
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const configuration = (0, $3J8MS.useGridConfiguration)();
    const ref = $f40172132c7a6c94$var$React.useRef(null);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const currentPage = (0, $aJApm.useGridVisibleRows)(apiRef, rootProps);
    const sortModel = (0, $5sOMZ.useGridSelector)(apiRef, $iU3u2.gridSortModelSelector);
    const columnPositions = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridColumnPositionsSelector);
    const rowReordering = rootProps.rowReordering;
    const treeData = rootProps.treeData;
    const isRowReorderingEnabled = (0, $5sOMZ.useGridSelector)(apiRef, $f40172132c7a6c94$var$isRowReorderingEnabledSelector, {
        rowReordering: rowReordering,
        treeData: treeData
    });
    const isRowDragActive = (0, $5sOMZ.useGridSelector)(apiRef, $8o0w1.gridIsRowDragActiveSelector);
    const handleRef = (0, $f40172132c7a6c94$var$_useForkRef.default)(ref, refProp);
    const rowNode = (0, $goCyd.gridRowNodeSelector)(apiRef, rowId);
    const editing = (0, $5sOMZ.useGridSelector)(apiRef, $5Rfo7.gridRowIsEditingSelector, {
        rowId: rowId,
        editMode: rootProps.editMode
    });
    const editable = rootProps.editMode === $jkRzp.GridEditModes.Row;
    const hasFocusCell = focusedColumnIndex !== undefined;
    const hasVirtualFocusCellLeft = hasFocusCell && focusedColumnIndex >= pinnedColumns.left.length && focusedColumnIndex < firstColumnIndex;
    const hasVirtualFocusCellRight = hasFocusCell && focusedColumnIndex < visibleColumns.length - pinnedColumns.right.length && focusedColumnIndex >= lastColumnIndex;
    const classes = (0, $4P61c.composeGridClasses)(rootProps.classes, {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isFirstVisible && 'row--firstVisible',
            isLastVisible && 'row--lastVisible',
            showBottomBorder && 'row--borderBottom',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    });
    const getRowAriaAttributes = configuration.hooks.useGridRowAriaAttributes();
    $f40172132c7a6c94$var$React.useLayoutEffect(()=>{
        if (currentPage.range) {
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // Pinned rows are not part of the visible rows
            if (rowIndex !== undefined) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        if (ref.current && rowHeight === 'auto') return apiRef.current.observeRowHeight(ref.current, rowId);
        return undefined;
    }, [
        apiRef,
        currentPage.range,
        rowHeight,
        rowId
    ]);
    const publish = $f40172132c7a6c94$var$React.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $f40172132c7a6c94$var$React.useCallback((event)=>{
        const cell = (0, $KtEo5.findParentElementFromClassName)(event.target, $5H1vo.gridClasses.cell);
        const field = cell?.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF.field) return;
            // User opened a detail panel
            if (field === $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === $jkRzp.GridCellModes.Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column?.type === $8z2XQ.GRID_ACTIONS_COLUMN_TYPE) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const heightEntry = (0, $5sOMZ.useGridSelector)(apiRef, ()=>(0, $f40172132c7a6c94$var$_extends2.default)({}, apiRef.current.getRowHeightEntry(rowId)), undefined, $5sOMZ.objectShallowCompare);
    const style = $f40172132c7a6c94$var$React.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $f40172132c7a6c94$var$_extends2.default)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            // max-height doesn't support "auto"
            minHeight: rowHeight,
            '--height': typeof rowHeight === 'number' ? `${rowHeight}px` : rowHeight
        });
        if (heightEntry.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = heightEntry.spacingTop;
        }
        if (heightEntry.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += heightEntry.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        heightEntry.spacingTop,
        heightEntry.spacingBottom,
        rootProps.rowSpacingType
    ]);
    // HACK: Sometimes, the rowNode has already been removed from the state but the row is still rendered.
    if (!rowNode) return null;
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    const ariaAttributes = getRowAriaAttributes(rowNode, index);
    if (typeof rootProps.getRowClassName === 'function') {
        const indexRelativeToCurrentPage = index - (currentPage.range?.firstRowIndex || 0);
        const rowParams = (0, $f40172132c7a6c94$var$_extends2.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const getCell = (column, indexInSection, indexRelativeToAllColumns, sectionLength, pinnedPosition = $jZka4.PinnedColumnPosition.NONE)=>{
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo?.spannedByColSpan) return null;
        const width = cellColSpanInfo?.cellProps.width ?? column.computedWidth;
        const colSpan = cellColSpanInfo?.cellProps.colSpan ?? 1;
        const pinnedOffset = (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, column.computedWidth, indexRelativeToAllColumns, columnPositions, columnsTotalWidth, scrollbarWidth);
        if (rowNode.type === 'skeletonRow') return /*#__PURE__*/ (0, $ayMG0.jsx)(slots.skeletonCell, {
            type: column.type,
            width: width,
            height: rowHeight,
            field: column.field,
            align: column.align
        }, column.field);
        // when the cell is a reorder cell we are not allowing to reorder the col
        // fixes https://github.com/mui/mui-x/issues/11126
        const isReorderCell = column.field === '__reorder__';
        const canReorderColumn = !(disableColumnReorder || column.disableReorder);
        const canReorderRow = isRowReorderingEnabled && !sortModel.length;
        const disableDragEvents = !(canReorderColumn || isReorderCell && canReorderRow || isRowDragActive);
        const cellIsNotVisible = pinnedPosition === $jZka4.PinnedColumnPosition.VIRTUAL;
        const showLeftBorder = (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, indexInSection, rootProps.showCellVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
        const showRightBorder = (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(slots.cell, (0, $f40172132c7a6c94$var$_extends2.default)({
            column: column,
            width: width,
            rowId: rowId,
            align: column.align || 'left',
            colIndex: indexRelativeToAllColumns,
            colSpan: colSpan,
            disableDragEvents: disableDragEvents,
            isNotVisible: cellIsNotVisible,
            pinnedOffset: pinnedOffset,
            pinnedPosition: pinnedPosition,
            showLeftBorder: showLeftBorder,
            showRightBorder: showRightBorder,
            row: row,
            rowNode: rowNode
        }, slotProps?.cell), column.field);
    };
    const leftCells = pinnedColumns.left.map((column, i)=>{
        const indexRelativeToAllColumns = i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.left.length, $jZka4.PinnedColumnPosition.LEFT);
    });
    const rightCells = pinnedColumns.right.map((column, i)=>{
        const indexRelativeToAllColumns = visibleColumns.length - pinnedColumns.right.length + i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.right.length, $jZka4.PinnedColumnPosition.RIGHT);
    });
    const middleColumnsLength = visibleColumns.length - pinnedColumns.left.length - pinnedColumns.right.length;
    const cells = [];
    if (hasVirtualFocusCellLeft) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, $jZka4.PinnedColumnPosition.VIRTUAL));
    for(let i = firstColumnIndex; i < lastColumnIndex; i += 1){
        const column = visibleColumns[i];
        const indexInSection = i - pinnedColumns.left.length;
        if (!column) continue;
        cells.push(getCell(column, indexInSection, i, middleColumnsLength));
    }
    if (hasVirtualFocusCellRight) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, $jZka4.PinnedColumnPosition.VIRTUAL));
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $f40172132c7a6c94$var$_extends2.default)({
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $f40172132c7a6c94$var$_clsx.default)(...rowClassNames, classes.root, className),
        style: style
    }, ariaAttributes, eventHandlers, other, {
        ref: handleRef,
        children: [
            leftCells,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "presentation",
                className: $5H1vo.gridClasses.cellOffsetLeft,
                style: {
                    width: offsetLeft
                }
            }),
            cells,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "presentation",
                className: (0, $f40172132c7a6c94$var$_clsx.default)($5H1vo.gridClasses.cell, $5H1vo.gridClasses.cellEmpty)
            }),
            rightCells,
            /*#__PURE__*/ (0, $ayMG0.jsx)($3pyi5.GridRowDragAndDropOverlay, {
                rowId: rowId
            })
        ]
    }));
});
const $f40172132c7a6c94$var$MemoizedGridRow = module.exports.GridRow = (0, $2nKmT.fastMemo)($f40172132c7a6c94$var$GridRow);

});
parcelRegister("4P61c", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $383097f5e5f6c068$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.composeGridClasses = $383097f5e5f6c068$var$composeGridClasses;

var $383097f5e5f6c068$var$_composeClasses = $383097f5e5f6c068$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5H1vo = parcelRequire("5H1vo");
function $383097f5e5f6c068$var$composeGridClasses(classes, slots) {
    return (0, $383097f5e5f6c068$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
}

});

parcelRegister("8o0w1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridRowReorderStateSelector = module.exports.gridRowDropTargetSelector = module.exports.gridRowDropTargetRowIdSelector = module.exports.gridRowDropPositionSelector = module.exports.gridIsRowDragActiveSelector = module.exports.gridDraggedRowIdSelector = void 0;

var $cgQ4y = parcelRequire("cgQ4y");
const $61b0f70231b1e493$var$gridRowReorderStateSelector = module.exports.gridRowReorderStateSelector = (0, $cgQ4y.createRootSelector)((state)=>state.rowReorder);
const $61b0f70231b1e493$var$gridIsRowDragActiveSelector = module.exports.gridIsRowDragActiveSelector = (0, $cgQ4y.createSelector)($61b0f70231b1e493$var$gridRowReorderStateSelector, (rowReorder)=>rowReorder?.isActive ?? false);
// Selector for the entire drop target state
const $61b0f70231b1e493$var$gridRowDropTargetSelector = module.exports.gridRowDropTargetSelector = (0, $cgQ4y.createSelector)($61b0f70231b1e493$var$gridRowReorderStateSelector, (rowReorder)=>rowReorder?.dropTarget ?? {
        rowId: null,
        position: null
    });
const $61b0f70231b1e493$var$gridRowDropTargetRowIdSelector = module.exports.gridRowDropTargetRowIdSelector = (0, $cgQ4y.createSelector)($61b0f70231b1e493$var$gridRowDropTargetSelector, (dropTarget)=>dropTarget.rowId ?? null);
// Selector for a specific row's drop position
const $61b0f70231b1e493$var$gridRowDropPositionSelector = module.exports.gridRowDropPositionSelector = (0, $cgQ4y.createSelector)($61b0f70231b1e493$var$gridRowDropTargetSelector, (dropTarget, rowId)=>{
    if (dropTarget.rowId === rowId) return dropTarget.position;
    return null;
});
// Selector for the dragged row ID
const $61b0f70231b1e493$var$gridDraggedRowIdSelector = module.exports.gridDraggedRowIdSelector = (0, $cgQ4y.createSelector)($61b0f70231b1e493$var$gridRowReorderStateSelector, (rowReorder)=>rowReorder?.draggedRowId ?? null);

});

parcelRegister("3pyi5", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $27be4e54a8466a0c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $27be4e54a8466a0c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRowDragAndDropOverlay = void 0;

var $27be4e54a8466a0c$var$_extends2 = $27be4e54a8466a0c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $27be4e54a8466a0c$var$React = $27be4e54a8466a0c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $bbeCr = parcelRequire("bbeCr");

var $er55f = parcelRequire("er55f");

var $5sOMZ = parcelRequire("5sOMZ");

var $8o0w1 = parcelRequire("8o0w1");

var $ayMG0 = parcelRequire("ayMG0");
const $27be4e54a8466a0c$var$GridRowDragAndDropOverlayRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'RowDragOverlay',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'action'
})(({ theme: theme, action: action })=>(0, $27be4e54a8466a0c$var$_extends2.default)({
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 1
    }, action === 'above' && {
        '&::before': {
            pointerEvents: 'none',
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: (theme.vars || theme).palette.primary.main
        }
    }, action === 'below' && {
        '&::after': {
            pointerEvents: 'none',
            content: '""',
            position: 'absolute',
            bottom: '-2px',
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: (theme.vars || theme).palette.primary.main
        }
    }, action === 'inside' && {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.1)` : (0, $8xDHs.alpha)(theme.palette.primary.main, 0.1)
    }));
const $27be4e54a8466a0c$var$GridRowDragAndDropOverlay = module.exports.GridRowDragAndDropOverlay = /*#__PURE__*/ $27be4e54a8466a0c$var$React.memo(function GridRowDragAndDropOverlay(props) {
    const { rowId: rowId, className: className } = props;
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const dropPosition = (0, $5sOMZ.useGridSelector)(apiRef, $8o0w1.gridRowDropPositionSelector, rowId);
    if (!dropPosition) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($27be4e54a8466a0c$var$GridRowDragAndDropOverlayRoot, {
        action: dropPosition,
        className: className
    });
});

});



parcelRegister("5tnRA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridAriaAttributes = void 0;

var $jQEEt = parcelRequire("jQEEt");

var $5sOMZ = parcelRequire("5sOMZ");

var $jDpXp = parcelRequire("jDpXp");

var $hMyIf = parcelRequire("hMyIf");

var $goCyd = parcelRequire("goCyd");

var $er55f = parcelRequire("er55f");

var $iN63z = parcelRequire("iN63z");

var $k278Q = parcelRequire("k278Q");
const $3fc22bf49019df83$var$useGridAriaAttributes = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const visibleColumns = (0, $5sOMZ.useGridSelector)(apiRef, $jQEEt.gridVisibleColumnDefinitionsSelector);
    const accessibleRowCount = (0, $5sOMZ.useGridSelector)(apiRef, $k278Q.gridExpandedRowCountSelector);
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector);
    const pinnedRowsCount = (0, $5sOMZ.useGridSelector)(apiRef, $goCyd.gridPinnedRowsCountSelector);
    const ariaLabel = rootProps['aria-label'];
    const ariaLabelledby = rootProps['aria-labelledby'];
    // `aria-label` and `aria-labelledby` should take precedence over `label`
    const shouldUseLabelAsAriaLabel = !ariaLabel && !ariaLabelledby && rootProps.label;
    return {
        role: 'grid',
        'aria-label': shouldUseLabelAsAriaLabel ? rootProps.label : ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + accessibleRowCount,
        'aria-multiselectable': (0, $iN63z.isMultipleRowSelectionEnabled)(rootProps)
    };
};
module.exports.useGridAriaAttributes = $3fc22bf49019df83$var$useGridAriaAttributes;

});

parcelRegister("8TaLs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $678bcf5a7d335a8a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowAriaAttributes = void 0;

var $678bcf5a7d335a8a$var$React = $678bcf5a7d335a8a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5sOMZ = parcelRequire("5sOMZ");

var $hMyIf = parcelRequire("hMyIf");

var $er55f = parcelRequire("er55f");
const $678bcf5a7d335a8a$var$useGridRowAriaAttributes = ()=>{
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const headerGroupingMaxDepth = (0, $5sOMZ.useGridSelector)(apiRef, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector);
    return $678bcf5a7d335a8a$var$React.useCallback((rowNode, index)=>{
        const ariaAttributes = {};
        const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
        ariaAttributes['aria-rowindex'] = ariaRowIndex;
        // XXX: fix this properly
        if (rowNode && apiRef.current.isRowSelectable(rowNode.id)) ariaAttributes['aria-selected'] = apiRef.current.isRowSelected(rowNode.id);
        return ariaAttributes;
    }, [
        apiRef,
        headerGroupingMaxDepth
    ]);
};
module.exports.useGridRowAriaAttributes = $678bcf5a7d335a8a$var$useGridRowAriaAttributes;

});

parcelRegister("6SlAg", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $50188751eb2724d1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $50188751eb2724d1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowsOverridableMethods = void 0;

var $50188751eb2724d1$var$_extends2 = $50188751eb2724d1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $50188751eb2724d1$var$React = $50188751eb2724d1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $goCyd = parcelRequire("goCyd");

var $k278Q = parcelRequire("k278Q");

var $7sDf4 = parcelRequire("7sDf4");
const $50188751eb2724d1$var$useGridRowsOverridableMethods = (apiRef)=>{
    const setRowPosition = $50188751eb2724d1$var$React.useCallback((sourceRowId, targetRowId, position)=>{
        const sourceNode = (0, $goCyd.gridRowNodeSelector)(apiRef, sourceRowId);
        const targetNode = (0, $goCyd.gridRowNodeSelector)(apiRef, targetRowId);
        if (!sourceNode) throw new Error(`MUI X: No row with id #${sourceRowId} found.`);
        if (!targetNode) throw new Error(`MUI X: No row with id #${targetRowId} found.`);
        if (sourceNode.type !== 'leaf') throw new Error(`MUI X: The row reordering does not support reordering of footer or grouping rows.`);
        if (position === 'inside') throw new Error(`MUI X: The 'inside' position is only supported for tree data. Use 'above' or 'below' for flat data.`);
        // Get the target index from the targetRowId using the lookup selector
        const sortedFilteredRowIndexLookup = (0, $k278Q.gridExpandedSortedRowIndexLookupSelector)(apiRef);
        const targetRowIndexUnadjusted = sortedFilteredRowIndexLookup[targetRowId];
        if (targetRowIndexUnadjusted === undefined) throw new Error(`MUI X: Target row with id #${targetRowId} not found in current view.`);
        const sourceRowIndex = sortedFilteredRowIndexLookup[sourceRowId];
        if (sourceRowIndex === undefined) throw new Error(`MUI X: Source row with id #${sourceRowId} not found in current view.`);
        const dragDirection = targetRowIndexUnadjusted < sourceRowIndex ? 'up' : 'down';
        let targetRowIndex;
        if (dragDirection === 'up') targetRowIndex = position === 'above' ? targetRowIndexUnadjusted : targetRowIndexUnadjusted + 1;
        else targetRowIndex = position === 'above' ? targetRowIndexUnadjusted - 1 : targetRowIndexUnadjusted;
        if (targetRowIndex === sourceRowIndex) return;
        apiRef.current.setState((state)=>{
            const group = (0, $goCyd.gridRowTreeSelector)(apiRef)[$7sDf4.GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetRowIndex, 0, updatedRows.splice(sourceRowIndex, 1)[0]);
            return (0, $50188751eb2724d1$var$_extends2.default)({}, state, {
                rows: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows, {
                    tree: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows.tree, {
                        [$7sDf4.GRID_ROOT_GROUP_ID]: (0, $50188751eb2724d1$var$_extends2.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef
    ]);
    const setRowIndex = $50188751eb2724d1$var$React.useCallback((rowId, targetIndex)=>{
        const node = (0, $goCyd.gridRowNodeSelector)(apiRef, rowId);
        if (!node) throw new Error(`MUI X: No row with id #${rowId} found.`);
        if (node.type !== 'leaf') throw new Error(`MUI X: The row reordering does not support reordering of footer or grouping rows.`);
        apiRef.current.setState((state)=>{
            const group = (0, $goCyd.gridRowTreeSelector)(apiRef)[$7sDf4.GRID_ROOT_GROUP_ID];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $50188751eb2724d1$var$_extends2.default)({}, state, {
                rows: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows, {
                    tree: (0, $50188751eb2724d1$var$_extends2.default)({}, state.rows.tree, {
                        [$7sDf4.GRID_ROOT_GROUP_ID]: (0, $50188751eb2724d1$var$_extends2.default)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef
    ]);
    return {
        setRowIndex: setRowIndex,
        setRowPosition: setRowPosition
    };
};
module.exports.useGridRowsOverridableMethods = $50188751eb2724d1$var$useGridRowsOverridableMethods;

});

parcelRegister("8gdrr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $603a3e97252d3bf4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridParamsOverridableMethods = void 0;

var $603a3e97252d3bf4$var$React = $603a3e97252d3bf4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7sDf4 = parcelRequire("7sDf4");
const $603a3e97252d3bf4$var$useGridParamsOverridableMethods = (apiRef)=>{
    const getCellValue = $603a3e97252d3bf4$var$React.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if (!row) throw new Error(`No row with id #${id} found`);
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowValue = $603a3e97252d3bf4$var$React.useCallback((row, colDef)=>(0, $7sDf4.getRowValue)(row, colDef, apiRef), [
        apiRef
    ]);
    const getRowFormattedValue = $603a3e97252d3bf4$var$React.useCallback((row, colDef)=>{
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    return {
        getCellValue: getCellValue,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue
    };
};
module.exports.useGridParamsOverridableMethods = $603a3e97252d3bf4$var$useGridParamsOverridableMethods;

});

parcelRegister("NPScz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $095cd0a8de7ac37d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsCellEditable = void 0;

var $095cd0a8de7ac37d$var$React = $095cd0a8de7ac37d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7sDf4 = parcelRequire("7sDf4");
/**
 * Default implementation of the cell editable condition hook
 */ const $095cd0a8de7ac37d$var$useIsCellEditable = ()=>$095cd0a8de7ac37d$var$React.useCallback((params)=>!(0, $7sDf4.isAutogeneratedRowNode)(params.rowNode), []);
module.exports.useIsCellEditable = $095cd0a8de7ac37d$var$useIsCellEditable;

});

parcelRegister("eu7ae", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a8b96ca779d42ed2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridContextProvider = $a8b96ca779d42ed2$var$GridContextProvider;

var $a8b96ca779d42ed2$var$React = $a8b96ca779d42ed2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $YSznt = parcelRequire("YSznt");

var $er55f = parcelRequire("er55f");

var $96LtV = parcelRequire("96LtV");

var $jdJe4 = parcelRequire("jdJe4");

var $7fn0i = parcelRequire("7fn0i");

var $3DWC3 = parcelRequire("3DWC3");

var $ayMG0 = parcelRequire("ayMG0");
function $a8b96ca779d42ed2$var$GridContextProvider({ privateApiRef: privateApiRef, configuration: configuration, props: props, children: children }) {
    const apiRef = $a8b96ca779d42ed2$var$React.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jdJe4.GridConfigurationContext.Provider, {
        value: configuration,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($96LtV.GridRootPropsContext.Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($er55f.GridPrivateApiContext.Provider, {
                value: privateApiRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($YSznt.GridApiContext.Provider, {
                    value: apiRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($7fn0i.GridPanelContextProvider, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3DWC3.GridCSSVariablesContext, {
                            children: children
                        })
                    })
                })
            })
        })
    });
}

});

parcelRegister("5W2Ws", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4524a6bb6d2f99a9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDataGridComponent = void 0;

var $4524a6bb6d2f99a9$var$React = $4524a6bb6d2f99a9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fT7NQ = parcelRequire("fT7NQ");

var $2ly38 = parcelRequire("2ly38");

var $n73Rs = parcelRequire("n73Rs");

var $DJVd0 = parcelRequire("DJVd0");

var $ervnQ = parcelRequire("ervnQ");

var $8JOxm = parcelRequire("8JOxm");

var $izeLD = parcelRequire("izeLD");

var $gU8sa = parcelRequire("gU8sa");

var $4D37q = parcelRequire("4D37q");

var $cx8m0 = parcelRequire("cx8m0");

var $1lT2X = parcelRequire("1lT2X");

var $12xQD = parcelRequire("12xQD");

var $3m1KX = parcelRequire("3m1KX");

var $4epuR = parcelRequire("4epuR");

var $fTRdy = parcelRequire("fTRdy");

var $2MkZt = parcelRequire("2MkZt");

var $5lqAx = parcelRequire("5lqAx");

var $6p8lp = parcelRequire("6p8lp");

var $cURqP = parcelRequire("cURqP");

var $5WmMt = parcelRequire("5WmMt");

var $jOu9i = parcelRequire("jOu9i");

var $gaDPW = parcelRequire("gaDPW");

var $2oqux = parcelRequire("2oqux");

var $Anab1 = parcelRequire("Anab1");

var $jBRsK = parcelRequire("jBRsK");

var $lb6pq = parcelRequire("lb6pq");

var $2H9Fl = parcelRequire("2H9Fl");

var $aFlgz = parcelRequire("aFlgz");

var $cMkcn = parcelRequire("cMkcn");

var $jDB9E = parcelRequire("jDB9E");

var $1n8rV = parcelRequire("1n8rV");

var $kbNad = parcelRequire("kbNad");

var $lWGH3 = parcelRequire("lWGH3");

var $b7mzS = parcelRequire("b7mzS");
const $4524a6bb6d2f99a9$var$useDataGridComponent = (apiRef, props, configuration)=>{
    (0, $2ly38.useGridInitialization)(apiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $5WmMt.useGridRowSelectionPreProcessors)(apiRef, props);
    (0, $5lqAx.useGridRowsPreProcessors)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $n73Rs.useGridInitializeState)($lWGH3.propsStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($cURqP.rowSelectionStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($8JOxm.columnsStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($2MkZt.rowsStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($3m1KX.paginationStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($fTRdy.editingStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($1lT2X.focusStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($jOu9i.sortingStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($4epuR.preferencePanelStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($cx8m0.filterStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($1n8rV.rowSpanningStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($izeLD.densityStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($jDB9E.columnResizeStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($ervnQ.columnMenuStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($aFlgz.columnGroupsStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($cMkcn.virtualizationStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($Anab1.dimensionsStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($jBRsK.rowsMetaStateInitializer, apiRef, props);
    (0, $n73Rs.useGridInitializeState)($kbNad.listViewStateInitializer, apiRef, props);
    (0, $12xQD.useGridKeyboardNavigation)(apiRef, props);
    (0, $cURqP.useGridRowSelection)(apiRef, props);
    (0, $8JOxm.useGridColumns)(apiRef, props);
    (0, $2MkZt.useGridRows)(apiRef, props, configuration);
    (0, $1n8rV.useGridRowSpanning)(apiRef, props);
    (0, $6p8lp.useGridParamsApi)(apiRef, props, configuration);
    (0, $2H9Fl.useGridColumnSpanning)(apiRef);
    (0, $aFlgz.useGridColumnGrouping)(apiRef, props);
    (0, $fTRdy.useGridEditing)(apiRef, props, configuration);
    (0, $1lT2X.useGridFocus)(apiRef, props);
    (0, $4epuR.useGridPreferencesPanel)(apiRef, props);
    (0, $cx8m0.useGridFilter)(apiRef, props, configuration);
    (0, $jOu9i.useGridSorting)(apiRef, props);
    (0, $izeLD.useGridDensity)(apiRef, props);
    (0, $jDB9E.useGridColumnResize)(apiRef, props);
    (0, $3m1KX.useGridPagination)(apiRef, props);
    (0, $gaDPW.useGridScroll)(apiRef, props);
    (0, $ervnQ.useGridColumnMenu)(apiRef);
    (0, $gU8sa.useGridCsvExport)(apiRef, props);
    (0, $4D37q.useGridPrintExport)(apiRef, props);
    (0, $DJVd0.useGridClipboard)(apiRef, props);
    (0, $Anab1.useGridDimensions)(apiRef, props);
    (0, $2oqux.useGridEvents)(apiRef, props);
    (0, $lb6pq.useGridStatePersistence)(apiRef);
    (0, $cMkcn.useGridVirtualization)(apiRef, props);
    (0, $kbNad.useGridListView)(apiRef, props);
    (0, $b7mzS.useGridDataSource)(apiRef, props);
    // Should be the last thing to run, because all pre-processors should have been registered by now.
    (0, $fT7NQ.useFirstRender)(()=>{
        apiRef.current.runAppliersForPendingProcessors();
    });
    $4524a6bb6d2f99a9$var$React.useEffect(()=>{
        apiRef.current.runAppliersForPendingProcessors();
    });
};
module.exports.useDataGridComponent = $4524a6bb6d2f99a9$var$useDataGridComponent;

});
parcelRegister("2ly38", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridInitialization = void 0;

var $aALnq = parcelRequire("aALnq");

var $hbsqJ = parcelRequire("hbsqJ");

var $eCZBN = parcelRequire("eCZBN");

var $bPgEz = parcelRequire("bPgEz");

var $2hRnp = parcelRequire("2hRnp");

var $5ErGu = parcelRequire("5ErGu");

var $bh93C = parcelRequire("bh93C");

var $lWGH3 = parcelRequire("lWGH3");
/**
 * Initialize the technical pieces of the DataGrid (logger, state, ...) that any DataGrid implementation needs
 */ const $1b57f47831f90cfc$var$useGridInitialization = (privateApiRef, props)=>{
    (0, $aALnq.useGridRefs)(privateApiRef);
    (0, $lWGH3.useGridProps)(privateApiRef, props);
    (0, $hbsqJ.useGridIsRtl)(privateApiRef);
    (0, $eCZBN.useGridLoggerFactory)(privateApiRef, props);
    (0, $bh93C.useGridStateInitialization)(privateApiRef);
    (0, $2hRnp.useGridPipeProcessing)(privateApiRef);
    (0, $5ErGu.useGridStrategyProcessing)(privateApiRef);
    (0, $bPgEz.useGridLocaleText)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
};
module.exports.useGridInitialization = $1b57f47831f90cfc$var$useGridInitialization;

});
parcelRegister("aALnq", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $7b6204383fd9652e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRefs = void 0;

var $7b6204383fd9652e$var$React = $7b6204383fd9652e$require$_interopRequireWildcard((parcelRequire("acw62")));
const $7b6204383fd9652e$var$useGridRefs = (apiRef)=>{
    const rootElementRef = $7b6204383fd9652e$var$React.useRef(null);
    const mainElementRef = $7b6204383fd9652e$var$React.useRef(null);
    const virtualScrollerRef = $7b6204383fd9652e$var$React.useRef(null);
    const virtualScrollbarVerticalRef = $7b6204383fd9652e$var$React.useRef(null);
    const virtualScrollbarHorizontalRef = $7b6204383fd9652e$var$React.useRef(null);
    const columnHeadersContainerRef = $7b6204383fd9652e$var$React.useRef(null);
    apiRef.current.register('public', {
        rootElementRef: rootElementRef
    });
    apiRef.current.register('private', {
        mainElementRef: mainElementRef,
        virtualScrollerRef: virtualScrollerRef,
        virtualScrollbarVerticalRef: virtualScrollbarVerticalRef,
        virtualScrollbarHorizontalRef: virtualScrollbarHorizontalRef,
        columnHeadersContainerRef: columnHeadersContainerRef
    });
};
module.exports.useGridRefs = $7b6204383fd9652e$var$useGridRefs;

});

parcelRegister("hbsqJ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c829845f6b031fe6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c829845f6b031fe6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridIsRtl = void 0;

var $c829845f6b031fe6$var$_extends2 = $c829845f6b031fe6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c829845f6b031fe6$var$React = $c829845f6b031fe6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");
const $c829845f6b031fe6$var$useGridIsRtl = (apiRef)=>{
    const isRtl = (0, $9uEev.useRtl)();
    if (apiRef.current.state.isRtl === undefined) apiRef.current.state.isRtl = isRtl;
    const isFirstEffect = $c829845f6b031fe6$var$React.useRef(true);
    $c829845f6b031fe6$var$React.useEffect(()=>{
        if (isFirstEffect.current) isFirstEffect.current = false;
        else apiRef.current.setState((state)=>(0, $c829845f6b031fe6$var$_extends2.default)({}, state, {
                isRtl: isRtl
            }));
    }, [
        apiRef,
        isRtl
    ]);
};
module.exports.useGridIsRtl = $c829845f6b031fe6$var$useGridIsRtl;

});

parcelRegister("eCZBN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $aa6467766a16a196$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridLoggerFactory = void 0;

var $aa6467766a16a196$var$React = $aa6467766a16a196$require$_interopRequireWildcard((parcelRequire("acw62")));

var $lR3Vo = parcelRequire("lR3Vo");

var $5LeoO = parcelRequire("5LeoO");
const $aa6467766a16a196$var$forceDebug = (0, $lR3Vo.localStorageAvailable)() && window.localStorage.getItem('DEBUG') != null;
const $aa6467766a16a196$var$noop = ()=>{};
const $aa6467766a16a196$var$noopLogger = {
    debug: $aa6467766a16a196$var$noop,
    info: $aa6467766a16a196$var$noop,
    warn: $aa6467766a16a196$var$noop,
    error: $aa6467766a16a196$var$noop
};
const $aa6467766a16a196$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $aa6467766a16a196$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $aa6467766a16a196$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI X: Log level ${logLevel} not recognized.`);
    const logger = $aa6467766a16a196$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI X: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $aa6467766a16a196$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $aa6467766a16a196$var$useGridLoggerFactory = (apiRef, props)=>{
    const getLogger = $aa6467766a16a196$var$React.useCallback((name)=>{
        if ($aa6467766a16a196$var$forceDebug) return $aa6467766a16a196$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $aa6467766a16a196$var$noopLogger;
        return $aa6467766a16a196$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $5LeoO.useGridApiMethod)(apiRef, {
        getLogger: getLogger
    }, 'private');
};
module.exports.useGridLoggerFactory = $aa6467766a16a196$var$useGridLoggerFactory;

});

parcelRegister("bPgEz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $89c1602309335bde$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridLocaleText = void 0;

var $89c1602309335bde$var$React = $89c1602309335bde$require$_interopRequireWildcard((parcelRequire("acw62")));
const $89c1602309335bde$var$useGridLocaleText = (apiRef, props)=>{
    const getLocaleText = $89c1602309335bde$var$React.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};
module.exports.useGridLocaleText = $89c1602309335bde$var$useGridLocaleText;

});

parcelRegister("5ErGu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lMwZC = parcelRequire("lMwZC");
Object.keys($lMwZC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lMwZC[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lMwZC[key];
        }
    });
});

var $kmoo4 = parcelRequire("kmoo4");
Object.keys($kmoo4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kmoo4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kmoo4[key];
        }
    });
});

var $42J2j = parcelRequire("42J2j");
Object.keys($42J2j).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $42J2j[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $42J2j[key];
        }
    });
});

});
parcelRegister("lMwZC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridStrategyGroup = void 0;
let $fdb7ac5a4616b4fe$var$GridStrategyGroup = module.exports.GridStrategyGroup = /*#__PURE__*/ function(GridStrategyGroup) {
    GridStrategyGroup["DataSource"] = "dataSource";
    GridStrategyGroup["RowTree"] = "rowTree";
    return GridStrategyGroup;
}({});

});

parcelRegister("kmoo4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ed28c789ae16a4b3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRegisterStrategyProcessor = void 0;

var $ed28c789ae16a4b3$var$React = $ed28c789ae16a4b3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bc8LN = parcelRequire("bc8LN");
const $ed28c789ae16a4b3$var$useGridRegisterStrategyProcessor = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $ed28c789ae16a4b3$var$React.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $bc8LN.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $ed28c789ae16a4b3$var$React.useRef(true);
    $ed28c789ae16a4b3$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};
module.exports.useGridRegisterStrategyProcessor = $ed28c789ae16a4b3$var$useGridRegisterStrategyProcessor;

});

parcelRegister("42J2j", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2f1a4898f1e92309$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2f1a4898f1e92309$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridStrategyProcessing = module.exports.GRID_STRATEGIES_PROCESSORS = module.exports.GRID_DEFAULT_STRATEGY = void 0;

var $2f1a4898f1e92309$var$_objectWithoutPropertiesLoose2 = $2f1a4898f1e92309$require$_interopRequireDefault((parcelRequire("c05no")));

var $2f1a4898f1e92309$var$_toPropertyKey2 = $2f1a4898f1e92309$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $2f1a4898f1e92309$var$React = $2f1a4898f1e92309$require$_interopRequireWildcard((parcelRequire("acw62")));

var $lMwZC = parcelRequire("lMwZC");

var $ivFej = parcelRequire("ivFej");
const $2f1a4898f1e92309$var$GRID_DEFAULT_STRATEGY = module.exports.GRID_DEFAULT_STRATEGY = 'none';
const $2f1a4898f1e92309$var$GRID_STRATEGIES_PROCESSORS = module.exports.GRID_STRATEGIES_PROCESSORS = {
    dataSourceRowsUpdate: $lMwZC.GridStrategyGroup.DataSource,
    rowTreeCreation: $lMwZC.GridStrategyGroup.RowTree,
    filtering: $lMwZC.GridStrategyGroup.RowTree,
    sorting: $lMwZC.GridStrategyGroup.RowTree,
    visibleRowsLookupCreation: $lMwZC.GridStrategyGroup.RowTree
};
/**
 * Implements a variant of the Strategy Pattern (see https://en.wikipedia.org/wiki/Strategy_pattern)
 *
 * More information and detailed example in (TODO add link to technical doc when ready)
 *
 * Some plugins contains custom logic that must only be applied if the right strategy is active.
 * For instance, the row grouping plugin has a custom filtering algorithm.
 * This algorithm must be applied by the filtering plugin if the row grouping is the current way of grouping rows,
 * but not if the tree data is the current way of grouping rows.
 *
 * =====================================================================================================================
 *
 * The plugin containing the custom logic must use:
 *
 * - `useGridRegisterStrategyProcessor` to register their processor.
 *   When the processor of the active strategy changes, it will fire `"activeStrategyProcessorChange"` to re-apply the processor.
 *
 * - `apiRef.current.setStrategyAvailability` to tell if their strategy can be used.
 *
 * =====================================================================================================================
 *
 * The plugin or component that needs to apply the custom logic of the current strategy must use:
 *
 * - `apiRef.current.applyStrategyProcessor` to run the processor of the active strategy for a given processor name.
 *
 * - the "strategyAvailabilityChange" event to update something when the active strategy changes.
 *    Warning: Be careful not to apply the processor several times.
 *    For instance "rowsSet" is fired by `useGridRows` whenever the active strategy changes.
 *    So listening to both would most likely run your logic twice.
 *
 * - The "activeStrategyProcessorChange" event to update something when the processor of the active strategy changes.
 *
 * =====================================================================================================================
 *
 * Each processor name is part of a strategy group which can only have one active strategy at the time.
 * There are two active groups named `rowTree` and `dataSource`.
 */ const $2f1a4898f1e92309$var$useGridStrategyProcessing = (apiRef)=>{
    const availableStrategies = $2f1a4898f1e92309$var$React.useRef(new Map());
    const strategiesCache = $2f1a4898f1e92309$var$React.useRef({});
    const registerStrategyProcessor = $2f1a4898f1e92309$var$React.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $2f1a4898f1e92309$var$_objectWithoutPropertiesLoose2.default)(_ref, [
                strategyName
            ].map($2f1a4898f1e92309$var$_toPropertyKey2.default));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($2f1a4898f1e92309$var$GRID_STRATEGIES_PROCESSORS[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $2f1a4898f1e92309$var$React.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($2f1a4898f1e92309$var$GRID_STRATEGIES_PROCESSORS[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $2f1a4898f1e92309$var$React.useCallback((strategyGroup)=>{
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return availableStrategyEntry?.[0] ?? $2f1a4898f1e92309$var$GRID_DEFAULT_STRATEGY;
    }, []);
    const setStrategyAvailability = $2f1a4898f1e92309$var$React.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $ivFej.useGridApiMethod)(apiRef, strategyProcessingApi, 'private');
};
module.exports.useGridStrategyProcessing = $2f1a4898f1e92309$var$useGridStrategyProcessing;

});


parcelRegister("bh93C", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $83584edf0ae98213$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83584edf0ae98213$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridStateInitialization = void 0;

var $83584edf0ae98213$var$_extends2 = $83584edf0ae98213$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $83584edf0ae98213$var$React = $83584edf0ae98213$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5LeoO = parcelRequire("5LeoO");

var $lR3Vo = parcelRequire("lR3Vo");
const $83584edf0ae98213$var$useGridStateInitialization = (apiRef)=>{
    const controlStateMapRef = $83584edf0ae98213$var$React.useRef({});
    const registerControlState = $83584edf0ae98213$var$React.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $83584edf0ae98213$var$React.useCallback((state, reason)=>{
        let newState;
        if ((0, $lR3Vo.isFunction)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        const apiRefWithNewState = {
            current: {
                state: newState
            }
        };
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef);
            const newSubState = controlState.stateSelector(apiRefWithNewState);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(apiRefWithNewState);
            if (controlState.propOnChange && hasPropChanged) controlState.propOnChange(model, {
                reason: reason,
                api: apiRef.current
            });
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef
    ]);
    const updateControlState = $83584edf0ae98213$var$React.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $83584edf0ae98213$var$_extends2.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const publicStateApi = {
        setState: setState
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $5LeoO.useGridApiMethod)(apiRef, publicStateApi, 'public');
    (0, $5LeoO.useGridApiMethod)(apiRef, privateStateApi, 'private');
};
module.exports.useGridStateInitialization = $83584edf0ae98213$var$useGridStateInitialization;

});

parcelRegister("lWGH3", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ffa021c6a8a175c3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ffa021c6a8a175c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridProps = module.exports.propsStateInitializer = void 0;

var $ffa021c6a8a175c3$var$_extends2 = $ffa021c6a8a175c3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ffa021c6a8a175c3$var$React = $ffa021c6a8a175c3$require$_interopRequireWildcard((parcelRequire("acw62")));
const $ffa021c6a8a175c3$var$propsStateInitializer = (state, props)=>{
    return (0, $ffa021c6a8a175c3$var$_extends2.default)({}, state, {
        props: {
            listView: props.listView,
            getRowId: props.getRowId,
            isCellEditable: props.isCellEditable,
            isRowSelectable: props.isRowSelectable,
            dataSource: props.dataSource
        }
    });
};
module.exports.propsStateInitializer = $ffa021c6a8a175c3$var$propsStateInitializer;
const $ffa021c6a8a175c3$var$useGridProps = (apiRef, props)=>{
    const isFirstRender = $ffa021c6a8a175c3$var$React.useRef(true);
    $ffa021c6a8a175c3$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        apiRef.current.setState((state)=>(0, $ffa021c6a8a175c3$var$_extends2.default)({}, state, {
                props: {
                    listView: props.listView,
                    getRowId: props.getRowId,
                    isCellEditable: props.isCellEditable,
                    isRowSelectable: props.isRowSelectable,
                    dataSource: props.dataSource
                }
            }));
    }, [
        apiRef,
        props.listView,
        props.getRowId,
        props.isCellEditable,
        props.isRowSelectable,
        props.dataSource
    ]);
};
module.exports.useGridProps = $ffa021c6a8a175c3$var$useGridProps;

});


parcelRegister("n73Rs", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0457a051e38141f4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridInitializeState = void 0;

var $0457a051e38141f4$var$React = $0457a051e38141f4$require$_interopRequireWildcard((parcelRequire("acw62")));
const $0457a051e38141f4$var$useGridInitializeState = (initializer, privateApiRef, props, key)=>{
    const previousKey = $0457a051e38141f4$var$React.useRef(key);
    const isInitialized = $0457a051e38141f4$var$React.useRef(false);
    if (key !== previousKey.current) {
        isInitialized.current = false;
        previousKey.current = key;
    }
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};
module.exports.useGridInitializeState = $0457a051e38141f4$var$useGridInitializeState;

});

parcelRegister("DJVd0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $077743baf33b26c9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridClipboard = void 0;

var $077743baf33b26c9$var$React = $077743baf33b26c9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5LeoO = parcelRequire("5LeoO");

var $drCmI = parcelRequire("drCmI");

var $k5aPx = parcelRequire("k5aPx");

var $dMF9H = parcelRequire("dMF9H");

var $4XcWL = parcelRequire("4XcWL");
function $077743baf33b26c9$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $077743baf33b26c9$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $077743baf33b26c9$var$writeToClipboardPolyfill(data);
    });
    else $077743baf33b26c9$var$writeToClipboardPolyfill(data);
}
function $077743baf33b26c9$var$hasNativeSelection(element) {
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if (window.getSelection()?.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
/**
 * @requires useGridCsvExport (method)
 * @requires useGridSelection (method)
 */ const $077743baf33b26c9$var$useGridClipboard = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $077743baf33b26c9$var$React.useCallback((event)=>{
        if (!(0, $dMF9H.isCopyShortcut)(event)) return;
        // Do nothing if there's a native selection
        if ($077743baf33b26c9$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRowsCount = (0, $4XcWL.gridRowSelectionCountSelector)(apiRef);
        if (selectedRowsCount > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false,
            escapeFormulas: false
        });
        else {
            const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $k5aPx.serializeCellValue)(cellParams, {
                    csvOptions: {
                        delimiter: clipboardCopyCellDelimiter,
                        shouldAppendQuotes: false,
                        escapeFormulas: false
                    },
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $077743baf33b26c9$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $5LeoO.useGridNativeEventListener)(apiRef, ()=>apiRef.current.rootElementRef.current, 'keydown', handleCopy);
    (0, $5LeoO.useGridEventPriority)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};
module.exports.useGridClipboard = $077743baf33b26c9$var$useGridClipboard;

});
parcelRegister("k5aPx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildCSV = $e9ecacf5d98b0bad$var$buildCSV;
module.exports.serializeCellValue = void 0;

var $9Y8Cp = parcelRequire("9Y8Cp");

var $ehhGY = parcelRequire("ehhGY");
function $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions) {
    if (value === null || value === undefined) return '';
    const valueStr = typeof value === 'string' ? value : `${value}`;
    if (csvOptions.shouldAppendQuotes || csvOptions.escapeFormulas) {
        const escapedValue = valueStr.replace(/"/g, '""');
        if (csvOptions.escapeFormulas) {
            // See https://owasp.org/www-community/attacks/CSV_Injection
            if ([
                '=',
                '+',
                '-',
                '@',
                '\t',
                '\r'
            ].includes(escapedValue[0])) return `"'${escapedValue}"`;
        }
        // Make sure value containing delimiter or line break won't be split into multiple cells
        if ([
            csvOptions.delimiter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>valueStr.includes(delimiter))) return `"${escapedValue}"`;
        return escapedValue;
    }
    return valueStr;
}
const $e9ecacf5d98b0bad$var$serializeCellValue = (cellParams, options)=>{
    const { csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') value = cellParams.value?.toISOString();
        else if (typeof cellParams.value?.toString === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $e9ecacf5d98b0bad$var$sanitizeCellValue(value, csvOptions);
};
module.exports.serializeCellValue = $e9ecacf5d98b0bad$var$serializeCellValue;
class $e9ecacf5d98b0bad$var$CSVRow {
    rowString = '';
    isEmpty = true;
    constructor(options){
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.csvOptions.delimiter;
        if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.csvOptions);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $e9ecacf5d98b0bad$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        if (String(cellParams.formattedValue) === '[object Object]') (0, $9Y8Cp.warnOnce)([
            'MUI X: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.',
            'You can provide a `valueFormatter` with a string representation to be used.'
        ]);
        row.addValue($e9ecacf5d98b0bad$var$serializeCellValue(cellParams, {
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        }));
    });
    return row.getRowString();
};
function $e9ecacf5d98b0bad$var$buildCSV(options) {
    const { columns: columns, rowIds: rowIds, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$e9ecacf5d98b0bad$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        })}\r\n`, '').trim();
    if (!csvOptions.includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== $ehhGY.GRID_CHECKBOX_SELECTION_COL_DEF.field);
    const headerRows = [];
    if (csvOptions.includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $e9ecacf5d98b0bad$var$CSVRow({
                csvOptions: csvOptions,
                sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $e9ecacf5d98b0bad$var$CSVRow({
        csvOptions: csvOptions,
        sanitizeCellValue: $e9ecacf5d98b0bad$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}

});


parcelRegister("ervnQ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a83bee6df207757d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a83bee6df207757d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridColumnMenu = module.exports.columnMenuStateInitializer = void 0;

var $a83bee6df207757d$var$_extends2 = $a83bee6df207757d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a83bee6df207757d$var$React = $a83bee6df207757d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5LeoO = parcelRequire("5LeoO");

var $eOaSX = parcelRequire("eOaSX");

var $jQEEt = parcelRequire("jQEEt");
const $a83bee6df207757d$var$columnMenuStateInitializer = (state)=>(0, $a83bee6df207757d$var$_extends2.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
/**
 * @requires useGridColumnResize (event)
 * @requires useGridInfiniteLoader (event)
 */ module.exports.columnMenuStateInitializer = $a83bee6df207757d$var$columnMenuStateInitializer;
const $a83bee6df207757d$var$useGridColumnMenu = (apiRef)=>{
    const logger = (0, $5LeoO.useGridLogger)(apiRef, 'useGridColumnMenu');
    const subscriptionRefs = $a83bee6df207757d$var$React.useRef({});
    const unsubscribeFromScrollChange = $a83bee6df207757d$var$React.useCallback(()=>{
        subscriptionRefs.current.wheel?.();
        subscriptionRefs.current.touchMove?.();
    }, []);
    const subscribeToScrollChange = $a83bee6df207757d$var$React.useCallback(()=>{
        unsubscribeFromScrollChange();
        subscriptionRefs.current.wheel = apiRef.current.subscribeEvent('virtualScrollerWheel', apiRef.current.hideColumnMenu);
        subscriptionRefs.current.touchMove = apiRef.current.subscribeEvent('virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
    }, [
        apiRef,
        unsubscribeFromScrollChange
    ]);
    /**
   * API METHODS
   */ const showColumnMenu = $a83bee6df207757d$var$React.useCallback((field)=>{
        const columnMenuState = (0, $eOaSX.gridColumnMenuSelector)(apiRef);
        const newState = {
            open: true,
            field: field
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                if (state.columnMenu.open && state.columnMenu.field === field) return state;
                logger.debug('Opening Column Menu');
                subscribeToScrollChange();
                return (0, $a83bee6df207757d$var$_extends2.default)({}, state, {
                    columnMenu: {
                        open: true,
                        field: field
                    }
                });
            });
            apiRef.current.hidePreferences();
        }
    }, [
        apiRef,
        logger,
        subscribeToScrollChange
    ]);
    const hideColumnMenu = $a83bee6df207757d$var$React.useCallback(()=>{
        const columnMenuState = (0, $eOaSX.gridColumnMenuSelector)(apiRef);
        if (columnMenuState.field) {
            const columnLookup = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
            const columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
            const orderedFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const newState = {
            open: false,
            field: undefined
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) apiRef.current.setState((state)=>{
            logger.debug('Hiding Column Menu');
            unsubscribeFromScrollChange();
            return (0, $a83bee6df207757d$var$_extends2.default)({}, state, {
                columnMenu: newState
            });
        });
    }, [
        apiRef,
        logger,
        unsubscribeFromScrollChange
    ]);
    const toggleColumnMenu = $a83bee6df207757d$var$React.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $eOaSX.gridColumnMenuSelector)(apiRef);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $5LeoO.useGridApiMethod)(apiRef, columnMenuApi, 'public');
    (0, $5LeoO.useGridEvent)(apiRef, 'columnResizeStart', hideColumnMenu);
};
module.exports.useGridColumnMenu = $a83bee6df207757d$var$useGridColumnMenu;

});

parcelRegister("8JOxm", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $65c9ba4e90cd61b6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $65c9ba4e90cd61b6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.columnsStateInitializer = void 0;
module.exports.useGridColumns = $65c9ba4e90cd61b6$var$useGridColumns;

var $65c9ba4e90cd61b6$var$_extends2 = $65c9ba4e90cd61b6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $65c9ba4e90cd61b6$var$React = $65c9ba4e90cd61b6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $iVTh1 = parcelRequire("iVTh1");

var $g8PwW = parcelRequire("g8PwW");

var $2hRnp = parcelRequire("2hRnp");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $i0LyH = parcelRequire("i0LyH");

var $8R7gU = parcelRequire("8R7gU");

var $3h197 = parcelRequire("3h197");

var $ayMG0 = parcelRequire("ayMG0");
const $65c9ba4e90cd61b6$var$columnsStateInitializer = (state, props, apiRef)=>{
    apiRef.current.caches.columns = {
        lastColumnsProp: props.columns
    };
    const columnsState = (0, $i0LyH.createColumnsState)({
        apiRef: apiRef,
        columnsToUpsert: props.columns,
        initialState: props.initialState?.columns,
        columnVisibilityModel: props.columnVisibilityModel ?? props.initialState?.columns?.columnVisibilityModel ?? {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, state, {
        columns: columnsState,
        // In pro/premium, this part of the state is defined. We give it an empty but defined value
        // for the community version.
        pinnedColumns: state.pinnedColumns ?? $4ZMWQ.EMPTY_PINNED_COLUMN_FIELDS
    });
};
/**
 * @requires useGridParamsApi (method)
 * @requires useGridDimensions (method, event) - can be after
 * TODO: Impossible priority - useGridParamsApi also needs to be after useGridColumns
 */ module.exports.columnsStateInitializer = $65c9ba4e90cd61b6$var$columnsStateInitializer;
function $65c9ba4e90cd61b6$var$useGridColumns(apiRef, props) {
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridColumns');
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: $jQEEt.gridColumnVisibilityModelSelector,
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $65c9ba4e90cd61b6$var$React.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState($65c9ba4e90cd61b6$var$mergeColumnsState(columnsState));
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $65c9ba4e90cd61b6$var$React.useCallback((field)=>(0, $jQEEt.gridColumnLookupSelector)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $65c9ba4e90cd61b6$var$React.useCallback(()=>(0, $jQEEt.gridColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $65c9ba4e90cd61b6$var$React.useCallback(()=>(0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $65c9ba4e90cd61b6$var$React.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef) : (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $65c9ba4e90cd61b6$var$React.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $jQEEt.gridColumnPositionsSelector)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $65c9ba4e90cd61b6$var$React.useCallback((model)=>{
        const currentModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, state, {
                    columns: (0, $i0LyH.createColumnsState)({
                        apiRef: apiRef,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.updateRenderContext?.();
        }
    }, [
        apiRef
    ]);
    const updateColumns = $65c9ba4e90cd61b6$var$React.useCallback((columns)=>{
        let columnsToUpdate = columns;
        if ((0, $3h197.gridPivotActiveSelector)(apiRef)) {
            const nonPivotColumns = [];
            const pivotColumns = [];
            const pivotInitialColumns = (0, $3h197.gridPivotInitialColumnsSelector)(apiRef);
            columns.forEach((column)=>{
                const isNonPivotColumn = pivotInitialColumns.has(column.field);
                if (isNonPivotColumn) nonPivotColumns.push(column);
                else pivotColumns.push(column);
            });
            if (nonPivotColumns.length > 0) apiRef.current.updateNonPivotColumns(nonPivotColumns);
            if (pivotColumns.length === 0) return;
            columnsToUpdate = pivotColumns;
        }
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: columnsToUpdate,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false,
            updateInitialVisibilityModel: true
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState
    ]);
    const setColumnVisibility = $65c9ba4e90cd61b6$var$React.useCallback((field, isVisible)=>{
        const columnVisibilityModel = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const isCurrentlyVisible = columnVisibilityModel[field] ?? true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $65c9ba4e90cd61b6$var$React.useCallback((field)=>{
        const allColumns = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $65c9ba4e90cd61b6$var$React.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $65c9ba4e90cd61b6$var$_extends2.default)({}, (0, $jQEEt.gridColumnsStateSelector)(apiRef), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $65c9ba4e90cd61b6$var$React.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $jQEEt.gridColumnsStateSelector)(apiRef);
        const column = columnsState.lookup[field];
        const newColumn = (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $i0LyH.hydrateColumnsWidth)((0, $65c9ba4e90cd61b6$var$_extends2.default)({}, columnsState, {
            lookup: (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), apiRef.current.getRootDimensions()));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, columnReorderApi, props.signature === $iVTh1.GridSignature.DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $65c9ba4e90cd61b6$var$React.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys(props.initialState?.columns?.columnVisibilityModel ?? {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $jQEEt.gridColumnFieldsSelector)(apiRef);
        const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                $i0LyH.COLUMNS_DIMENSION_PROPERTIES.forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        props.initialState?.columns
    ]);
    const stateRestorePreProcessing = $65c9ba4e90cd61b6$var$React.useCallback((params, context)=>{
        const initialState = context.stateToRestore.columns;
        const columnVisibilityModelToImport = initialState?.columnVisibilityModel;
        if (initialState == null) return params;
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        if (initialState != null) apiRef.current.setState((prevState)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState, {
                columns: (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState.columns, {
                    lookup: columnsState.lookup,
                    orderedFields: columnsState.orderedFields,
                    initialColumnVisibilityModel: columnsState.initialColumnVisibilityModel
                })
            }));
        // separate column visibility model state update as it can be controlled
        // https://github.com/mui/mui-x/issues/17681#issuecomment-3012528602
        if (columnVisibilityModelToImport != null) apiRef.current.setState((prevState)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState, {
                columns: (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, prevState.columns, {
                    columnVisibilityModel: columnVisibilityModelToImport
                })
            }));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef
    ]);
    const preferencePanelPreProcessing = $65c9ba4e90cd61b6$var$React.useCallback((initialValue, value)=>{
        if (value === $8R7gU.GridPreferencePanelsValue.columns) {
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ColumnsPanel, (0, $65c9ba4e90cd61b6$var$_extends2.default)({}, props.slotProps?.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        props.slotProps?.columnsPanel
    ]);
    const addColumnMenuItems = $65c9ba4e90cd61b6$var$React.useCallback((columnMenuItems)=>{
        const isPivotActive = (0, $3h197.gridPivotActiveSelector)(apiRef);
        if (props.disableColumnSelector || isPivotActive) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector,
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /*
   * EVENTS
   */ const prevInnerWidth = $65c9ba4e90cd61b6$var$React.useRef(null);
    const handleGridSizeChange = (size)=>{
        if (prevInnerWidth.current !== size.width) {
            prevInnerWidth.current = size.width;
            const hasFlexColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).some((col)=>col.flex && col.flex > 0);
            if (!hasFlexColumns) return;
            setGridColumnsState((0, $i0LyH.hydrateColumnsWidth)((0, $jQEEt.gridColumnsStateSelector)(apiRef), apiRef.current.getRootDimensions()));
        }
    };
    (0, $g8PwW.useGridEvent)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $65c9ba4e90cd61b6$var$React.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    (0, $2hRnp.useGridRegisterPipeApplier)(apiRef, 'hydrateColumns', hydrateColumns);
    /*
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    $65c9ba4e90cd61b6$var$React.useEffect(()=>{
        if (apiRef.current.caches.columns.lastColumnsProp === props.columns) return;
        apiRef.current.caches.columns.lastColumnsProp = props.columns;
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        const columnsState = (0, $i0LyH.createColumnsState)({
            apiRef: apiRef,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true,
            updateInitialVisibilityModel: true,
            columnVisibilityModel: props.columnVisibilityModel
        });
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        props.columnVisibilityModel
    ]);
    $65c9ba4e90cd61b6$var$React.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
function $65c9ba4e90cd61b6$var$mergeColumnsState(columnsState) {
    return (state)=>(0, $65c9ba4e90cd61b6$var$_extends2.default)({}, state, {
            columns: columnsState
        });
}

});

parcelRegister("izeLD", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d846f35585bafc86$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d846f35585bafc86$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridDensity = module.exports.densityStateInitializer = void 0;

var $d846f35585bafc86$var$_extends2 = $d846f35585bafc86$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d846f35585bafc86$var$React = $d846f35585bafc86$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d846f35585bafc86$var$_useEventCallback = $d846f35585bafc86$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $luu6e = parcelRequire("luu6e");

var $ivFej = parcelRequire("ivFej");

var $fD9f4 = parcelRequire("fD9f4");

var $2hRnp = parcelRequire("2hRnp");
const $d846f35585bafc86$var$densityStateInitializer = (state, props)=>(0, $d846f35585bafc86$var$_extends2.default)({}, state, {
        density: props.initialState?.density ?? props.density ?? 'standard'
    });
module.exports.densityStateInitializer = $d846f35585bafc86$var$densityStateInitializer;
const $d846f35585bafc86$var$useGridDensity = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useDensity');
    apiRef.current.registerControlState({
        stateId: 'density',
        propModel: props.density,
        propOnChange: props.onDensityChange,
        stateSelector: $fD9f4.gridDensitySelector,
        changeEvent: 'densityChange'
    });
    const setDensity = (0, $d846f35585bafc86$var$_useEventCallback.default)((newDensity)=>{
        const currentDensity = (0, $fD9f4.gridDensitySelector)(apiRef);
        if (currentDensity === newDensity) return;
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>(0, $d846f35585bafc86$var$_extends2.default)({}, state, {
                density: newDensity
            }));
    });
    const densityApi = {
        setDensity: setDensity
    };
    (0, $ivFej.useGridApiMethod)(apiRef, densityApi, 'public');
    const stateExportPreProcessing = $d846f35585bafc86$var$React.useCallback((prevState, context)=>{
        const exportedDensity = (0, $fD9f4.gridDensitySelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `density` is controlled
        props.density != null || // Always export if the `density` has been initialized
        props.initialState?.density != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $d846f35585bafc86$var$_extends2.default)({}, prevState, {
            density: exportedDensity
        });
    }, [
        apiRef,
        props.density,
        props.initialState?.density
    ]);
    const stateRestorePreProcessing = $d846f35585bafc86$var$React.useCallback((params, context)=>{
        const restoredDensity = context.stateToRestore?.density ? context.stateToRestore.density : (0, $fD9f4.gridDensitySelector)(apiRef);
        apiRef.current.setState((state)=>(0, $d846f35585bafc86$var$_extends2.default)({}, state, {
                density: restoredDensity
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    $d846f35585bafc86$var$React.useEffect(()=>{
        if (props.density) apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
};
module.exports.useGridDensity = $d846f35585bafc86$var$useGridDensity;

});

parcelRegister("gU8sa", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c4e86ef235136df5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridCsvExport = void 0;

var $c4e86ef235136df5$var$React = $c4e86ef235136df5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $8boSz = parcelRequire("8boSz");

var $k5aPx = parcelRequire("k5aPx");

var $jSbr9 = parcelRequire("jSbr9");

var $2hRnp = parcelRequire("2hRnp");

var $iPqov = parcelRequire("iPqov");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridSelection (state)
 * @requires useGridParamsApi (method)
 */ const $c4e86ef235136df5$var$useGridCsvExport = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $c4e86ef235136df5$var$React.useCallback((options = {})=>{
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $jSbr9.getColumnsToExport)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = options.getRowsToExport ?? $jSbr9.defaultGetRowsToExport;
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $k5aPx.buildCSV)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: options.shouldAppendQuotes ?? true,
                includeHeaders: options.includeHeaders ?? true,
                includeColumnGroupsHeaders: options.includeColumnGroupsHeaders ?? true,
                escapeFormulas: options.escapeFormulas ?? true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $c4e86ef235136df5$var$React.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options?.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $8boSz.exportAs)(blob, 'csv', options?.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $ivFej.useGridApiMethod)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $c4e86ef235136df5$var$React.useCallback((initialValue, options)=>{
        if (options.csvOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)($iPqov.GridCsvExportMenuItem, {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};
module.exports.useGridCsvExport = $c4e86ef235136df5$var$useGridCsvExport;

});
parcelRegister("8boSz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exportAs = $5f52a64decff8320$var$exportAs;
/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $5f52a64decff8320$var$exportAs(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI X: exportAs not supported.');
}

});

parcelRegister("jSbr9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getColumnsToExport = module.exports.defaultGetRowsToExport = void 0;

var $jy68d = parcelRequire("jy68d");

var $13Ynj = parcelRequire("13Ynj");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");
const $e77bee9f62f5124d$var$getColumnsToExport = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $jy68d.gridColumnDefinitionsSelector)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $jy68d.gridVisibleColumnDefinitionsSelector)(apiRef);
    return validColumns.filter((column)=>column.disableExport !== true);
};
module.exports.getColumnsToExport = $e77bee9f62f5124d$var$getColumnsToExport;
const $e77bee9f62f5124d$var$defaultGetRowsToExport = ({ apiRef: apiRef })=>{
    const filteredSortedRowIds = (0, $13Ynj.gridFilteredSortedRowIdsSelector)(apiRef);
    const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
    const selectedRowsCount = (0, $av74L.gridRowSelectionCountSelector)(apiRef);
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsIds = pinnedRows?.top?.map((row)=>row.id) || [];
    const bottomPinnedRowsIds = pinnedRows?.bottom?.map((row)=>row.id) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRowsCount > 0) {
        const selectedRows = (0, $av74L.gridRowSelectionIdsSelector)(apiRef);
        return bodyRows.filter((id)=>selectedRows.has(id));
    }
    return bodyRows;
};
module.exports.defaultGetRowsToExport = $e77bee9f62f5124d$var$defaultGetRowsToExport;

});


parcelRegister("4D37q", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $35ed394581d01f61$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $35ed394581d01f61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridPrintExport = void 0;

var $35ed394581d01f61$var$_extends2 = $35ed394581d01f61$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $35ed394581d01f61$var$React = $35ed394581d01f61$require$_interopRequireWildcard((parcelRequire("acw62")));

var $35ed394581d01f61$var$_ownerDocument = $35ed394581d01f61$require$_interopRequireDefault((parcelRequire("43fuO")));

var $etJ3H = parcelRequire("etJ3H");

var $luu6e = parcelRequire("luu6e");

var $k278Q = parcelRequire("k278Q");

var $jQEEt = parcelRequire("jQEEt");

var $5H1vo = parcelRequire("5H1vo");

var $ivFej = parcelRequire("ivFej");

var $7sDf4 = parcelRequire("7sDf4");

var $jSbr9 = parcelRequire("jSbr9");

var $87jE6 = parcelRequire("87jE6");

var $2hRnp = parcelRequire("2hRnp");

var $iPqov = parcelRequire("iPqov");

var $5bG6h = parcelRequire("5bG6h");

var $cv3bf = parcelRequire("cv3bf");

var $ayMG0 = parcelRequire("ayMG0");
const $35ed394581d01f61$var$DEBUG_MODE = false;
function $35ed394581d01f61$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $35ed394581d01f61$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    if ($35ed394581d01f61$var$DEBUG_MODE) {
        iframeEl.style.width = '100%';
        iframeEl.style.height = '10000px';
    }
    iframeEl.title = title || document.title;
    return iframeEl;
}
/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridParamsApi (method)
 */ const $35ed394581d01f61$var$useGridPrintExport = (apiRef, props)=>{
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPrintExport');
    const doc = $35ed394581d01f61$var$React.useRef(null);
    const previousGridState = $35ed394581d01f61$var$React.useRef(null);
    const previousColumnVisibility = $35ed394581d01f61$var$React.useRef({});
    const previousRows = $35ed394581d01f61$var$React.useRef([]);
    const previousVirtualizationState = $35ed394581d01f61$var$React.useRef(null);
    $35ed394581d01f61$var$React.useEffect(()=>{
        doc.current = (0, $35ed394581d01f61$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
    }, [
        apiRef,
        hasRootReference
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $35ed394581d01f61$var$React.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $jSbr9.getColumnsToExport)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[$5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF.field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $35ed394581d01f61$var$React.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.reduce((acc, id)=>{
            const row = apiRef.current.getRow(id);
            if (!row[$7sDf4.GRID_ID_AUTOGENERATED]) acc.push(row);
            return acc;
        }, []);
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $35ed394581d01f61$var$React.useCallback((printWindow, options)=>{
        const normalizeOptions = (0, $35ed394581d01f61$var$_extends2.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        const virtualScrollerContent = gridClone.querySelector(`.${$5H1vo.gridClasses.virtualScrollerContent}`);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${$5H1vo.gridClasses.main}`);
        gridMain.style.overflow = 'visible';
        gridClone.querySelector(`.${$5H1vo.gridClasses.virtualScrollerRenderZone}`).style.position = 'static';
        virtualScrollerContent.style.flexBasis = 'auto';
        gridClone.querySelector(`.${$5H1vo.gridClasses['scrollbar--vertical']}`)?.remove();
        if (!(virtualScrollerContent.nextSibling instanceof HTMLElement && virtualScrollerContent.nextSibling.classList.contains($5H1vo.gridClasses.filler))) {
            const filler = document.createElement('div');
            filler.style.height = $cv3bf.scrollbarSizeCssExpression;
            virtualScrollerContent.insertAdjacentElement('afterend', filler);
        }
        const gridFooterElement = gridClone.querySelector(`.${$5H1vo.gridClasses.footerContainer}`);
        if (normalizeOptions.hideToolbar) gridClone.querySelector(`.${$5H1vo.gridClasses.toolbar}`)?.remove();
        if (normalizeOptions.hideFooter && gridFooterElement) gridFooterElement.remove();
        gridClone.style.height = 'auto';
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        if (!normalizeOptions.hideFooter && gridFooterElement) // the footer is always being placed at the bottom of the page as if all rows are exported
        // so if getRowsToExport is being used to only export a subset of rows then we need to
        // adjust the footer position to be correctly placed at the bottom of the grid
        gridFooterElement.style.width = '100%';
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        // To avoid an empty page in start on Chromium based browsers
        printDoc.body.style.marginTop = '0px';
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        let stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            stylesheetLoadPromises = (0, $etJ3H.loadStyleSheets)(printDoc, root);
        }
        // Trigger print
        if (!$35ed394581d01f61$var$DEBUG_MODE) // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc
    ]);
    const handlePrintWindowAfterPrint = $35ed394581d01f61$var$React.useCallback((printWindow)=>{
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!previousGridState.current?.columns?.columnVisibilityModel) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.setState((state)=>(0, $35ed394581d01f61$var$_extends2.default)({}, state, {
                virtualization: previousVirtualizationState.current
            }));
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $35ed394581d01f61$var$React.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI X: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $jQEEt.gridColumnVisibilityModelSelector)(apiRef);
        previousRows.current = apiRef.current.getSortedRows().filter((row)=>!row[$7sDf4.GRID_ID_AUTOGENERATED]);
        if (props.pagination) {
            const visibleRowCount = (0, $k278Q.gridExpandedRowCountSelector)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $35ed394581d01f61$var$_extends2.default)({}, state, {
                    pagination: (0, $35ed394581d01f61$var$_extends2.default)({}, state.pagination, {
                        paginationModel: (0, $87jE6.getDerivedPaginationModel)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        'DataGridPro', paginationModel)
                    })
                }));
        }
        previousVirtualizationState.current = apiRef.current.state.virtualization;
        apiRef.current.unstable_setVirtualization(false);
        await updateGridColumnsForPrint(options?.fields, options?.allColumns, options?.includeCheckboxes);
        updateGridRowsForPrint(options?.getRowsToExport ?? $jSbr9.defaultGetRowsToExport);
        await $35ed394581d01f61$var$raf(); // wait for the state changes to take action
        const printWindow = $35ed394581d01f61$var$buildPrintWindow(options?.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $ivFej.useGridApiMethod)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $35ed394581d01f61$var$React.useCallback((initialValue, options)=>{
        if (options.printOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $ayMG0.jsx)($iPqov.GridPrintExportMenuItem, {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportMenu', addExportMenuButtons);
};
module.exports.useGridPrintExport = $35ed394581d01f61$var$useGridPrintExport;

});
parcelRegister("etJ3H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "loadStyleSheets", {
    enumerable: true,
    get: function() {
        return $d0Z7S.loadStyleSheets;
    }
});

var $d0Z7S = parcelRequire("d0Z7S");

});
parcelRegister("d0Z7S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadStyleSheets = $979ab0ccf5767d07$var$loadStyleSheets;
/**
 * Loads all stylesheets from the given root element into the document.
 * @returns an array of promises that resolve when each stylesheet is loaded
 * @param document Document to load stylesheets into
 * @param root Document or ShadowRoot to load stylesheets from
 * @param nonce Optional nonce to set on style elements for CSP compliance
 */ function $979ab0ccf5767d07$var$loadStyleSheets(document, root, nonce) {
    const stylesheetLoadPromises = [];
    const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
    for(let i = 0; i < headStyleElements.length; i += 1){
        const node = headStyleElements[i];
        const newHeadStyleElement = document.createElement(node.tagName);
        if (node.tagName === 'STYLE') {
            const sheet = node.sheet;
            if (sheet) {
                let styleCSS = '';
                for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                newHeadStyleElement.appendChild(document.createTextNode(styleCSS));
            }
        } else if (node.getAttribute('href')) {
            for(let j = 0; j < node.attributes.length; j += 1){
                const attr = node.attributes[j];
                if (attr) newHeadStyleElement.setAttribute(attr.nodeName, attr.nodeValue || '');
            }
            stylesheetLoadPromises.push(new Promise((resolve)=>{
                newHeadStyleElement.addEventListener('load', ()=>resolve());
            }));
        }
        if (nonce) newHeadStyleElement.setAttribute('nonce', nonce);
        document.head.appendChild(newHeadStyleElement);
        if (nonce) // I don't understand why we need to set the nonce again after appending the element, but I've tested it, and it's
        // the only way I could find to fix Chrome's warning about a CSP violation.
        newHeadStyleElement.setAttribute('nonce', nonce);
    }
    return stylesheetLoadPromises;
}

});


parcelRegister("87jE6", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5e8e37726d5ba261$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5e8e37726d5ba261$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridPaginationModel = module.exports.getDerivedPaginationModel = void 0;

var $5e8e37726d5ba261$var$_extends2 = $5e8e37726d5ba261$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5e8e37726d5ba261$var$React = $5e8e37726d5ba261$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5e8e37726d5ba261$var$_debounce = $5e8e37726d5ba261$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $e9lLm = parcelRequire("e9lLm");

var $k278Q = parcelRequire("k278Q");

var $h181e = parcelRequire("h181e");

var $5LeoO = parcelRequire("5LeoO");

var $2hRnp = parcelRequire("2hRnp");

var $gPWuj = parcelRequire("gPWuj");

var $baj2X = parcelRequire("baj2X");
const $5e8e37726d5ba261$var$getDerivedPaginationModel = (paginationState, signature, paginationModelProp)=>{
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = paginationModelProp?.pageSize ?? paginationModel.pageSize;
    const page = paginationModelProp?.page ?? paginationModel.page;
    const pageCount = (0, $baj2X.getPageCount)(rowCount, pageSize, page);
    if (paginationModelProp && (paginationModelProp?.page !== paginationModel.page || paginationModelProp?.pageSize !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = pageSize === -1 ? 0 : (0, $baj2X.getValidPage)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $5e8e37726d5ba261$var$_extends2.default)({}, paginationModel, {
        page: validPage
    });
    (0, $baj2X.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, signature);
    return paginationModel;
};
/**
 * @requires useGridFilter (state)
 * @requires useGridDimensions (event) - can be after
 */ module.exports.getDerivedPaginationModel = $5e8e37726d5ba261$var$getDerivedPaginationModel;
const $5e8e37726d5ba261$var$useGridPaginationModel = (apiRef, props)=>{
    const logger = (0, $5LeoO.useGridLogger)(apiRef, 'useGridPaginationModel');
    const densityFactor = (0, $5LeoO.useGridSelector)(apiRef, $h181e.gridDensityFactorSelector);
    const previousFilterModel = $5e8e37726d5ba261$var$React.useRef((0, $k278Q.gridFilterModelSelector)(apiRef));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'paginationModel',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: $gPWuj.gridPaginationModelSelector,
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $5e8e37726d5ba261$var$React.useCallback((page)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const debouncedSetPage = $5e8e37726d5ba261$var$React.useMemo(()=>(0, $5e8e37726d5ba261$var$_debounce.default)(setPage, 0), [
        setPage
    ]);
    const setPageSize = $5e8e37726d5ba261$var$React.useCallback((pageSize)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $5e8e37726d5ba261$var$React.useCallback((paginationModel)=>{
        const currentModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$var$getDerivedPaginationModel(state.pagination, props.signature, paginationModel)
                })
            }), 'setPaginationModel');
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $5LeoO.useGridApiMethod)(apiRef, paginationModelApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $5e8e37726d5ba261$var$React.useCallback((prevState, context)=>{
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        props.initialState?.pagination?.paginationModel != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $baj2X.defaultPageSize)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $5e8e37726d5ba261$var$_extends2.default)({}, prevState, {
            pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        props.initialState?.pagination?.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $5e8e37726d5ba261$var$React.useCallback((params, context)=>{
        const paginationModel = context.stateToRestore.pagination?.paginationModel ? (0, $5e8e37726d5ba261$var$_extends2.default)({}, (0, $baj2X.getDefaultGridPaginationModel)(props.autoPageSize), context.stateToRestore.pagination?.paginationModel) : (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$var$getDerivedPaginationModel(state.pagination, props.signature, paginationModel)
                })
            }), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (apiRef.current.virtualScrollerRef?.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $5e8e37726d5ba261$var$React.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions();
        const maximumPageSizeWithoutScrollBar = Math.max(1, Math.floor(dimensions.viewportInnerSize.height / rowHeight));
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $5e8e37726d5ba261$var$React.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel.page === 0) return;
        const pageCount = (0, $gPWuj.gridPageCountSelector)(apiRef);
        if (paginationModel.page > pageCount - 1) queueMicrotask(()=>{
            debouncedSetPage(Math.max(0, pageCount - 1));
        });
    }, [
        apiRef,
        debouncedSetPage
    ]);
    /**
   * Goes to the first row of the grid
   */ const navigateToStart = $5e8e37726d5ba261$var$React.useCallback(()=>{
        const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
        if (paginationModel.page !== 0) debouncedSetPage(0);
        // If the page was not changed it might be needed to scroll to the top
        const scrollPosition = apiRef.current.getScrollPosition();
        if (scrollPosition.top !== 0) apiRef.current.scroll({
            top: 0
        });
    }, [
        apiRef,
        debouncedSetPage
    ]);
    const debouncedNavigateToStart = $5e8e37726d5ba261$var$React.useMemo(()=>(0, $5e8e37726d5ba261$var$_debounce.default)(navigateToStart, 0), [
        navigateToStart
    ]);
    /**
   * Resets the page only if the active items or quick filter has changed from the last time.
   * This is to avoid resetting the page when the filter model is changed
   * because of and update of the operator from an item that does not have the value
   * or reseting when the filter panel is just opened
   */ const handleFilterModelChange = $5e8e37726d5ba261$var$React.useCallback((filterModel)=>{
        const currentActiveFilters = (0, $5e8e37726d5ba261$var$_extends2.default)({}, filterModel, {
            // replace items with the active items
            items: (0, $k278Q.gridFilterActiveItemsSelector)(apiRef)
        });
        if ((0, $e9lLm.isDeepEqual)(currentActiveFilters, previousFilterModel.current)) return;
        previousFilterModel.current = currentActiveFilters;
        debouncedNavigateToStart();
    }, [
        apiRef,
        debouncedNavigateToStart
    ]);
    (0, $5LeoO.useGridEvent)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $5LeoO.useGridEvent)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    (0, $5LeoO.useGridEvent)(apiRef, 'rowCountChange', handleRowCountChange);
    (0, $5LeoO.useGridEvent)(apiRef, 'sortModelChange', debouncedNavigateToStart);
    (0, $5LeoO.useGridEvent)(apiRef, 'filterModelChange', handleFilterModelChange);
    /**
   * EFFECTS
   */ const isFirstRender = $5e8e37726d5ba261$var$React.useRef(true);
    $5e8e37726d5ba261$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!props.pagination) return;
        apiRef.current.setState((state)=>(0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationModel: $5e8e37726d5ba261$var$getDerivedPaginationModel(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.signature,
        props.pagination
    ]);
    $5e8e37726d5ba261$var$React.useEffect(()=>{
        apiRef.current.setState((state)=>{
            const isEnabled = props.pagination === true;
            if (state.pagination.paginationMode === props.paginationMode && state.pagination.enabled === isEnabled) return state;
            return (0, $5e8e37726d5ba261$var$_extends2.default)({}, state, {
                pagination: (0, $5e8e37726d5ba261$var$_extends2.default)({}, state.pagination, {
                    paginationMode: props.paginationMode,
                    enabled: isEnabled
                })
            });
        });
    }, [
        apiRef,
        props.paginationMode,
        props.pagination
    ]);
    $5e8e37726d5ba261$var$React.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};
module.exports.useGridPaginationModel = $5e8e37726d5ba261$var$useGridPaginationModel;

});


parcelRegister("cx8m0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $91ff0c015e83a086$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $91ff0c015e83a086$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridFilter = module.exports.filterStateInitializer = void 0;

var $91ff0c015e83a086$var$_extends2 = $91ff0c015e83a086$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $91ff0c015e83a086$var$React = $91ff0c015e83a086$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cvyxi = parcelRequire("cvyxi");

var $91ff0c015e83a086$var$_useEnhancedEffect = $91ff0c015e83a086$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $e9lLm = parcelRequire("e9lLm");

var $7O6ub = parcelRequire("7O6ub");

var $g8PwW = parcelRequire("g8PwW");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $3PCYS = parcelRequire("3PCYS");

var $l4QMb = parcelRequire("l4QMb");

var $k278Q = parcelRequire("k278Q");

var $bc8LN = parcelRequire("bc8LN");

var $eFlT8 = parcelRequire("eFlT8");

var $2hRnp = parcelRequire("2hRnp");

var $5ErGu = parcelRequire("5ErGu");

var $14dIX = parcelRequire("14dIX");

var $ayMG0 = parcelRequire("ayMG0");
const $91ff0c015e83a086$var$filterStateInitializer = (state, props, apiRef)=>{
    const filterModel = props.filterModel ?? props.initialState?.filter?.filterModel ?? (0, $l4QMb.getDefaultGridFilterModel)();
    return (0, $91ff0c015e83a086$var$_extends2.default)({}, state, {
        filter: (0, $91ff0c015e83a086$var$_extends2.default)({
            filterModel: (0, $14dIX.sanitizeFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef)
        }, $l4QMb.defaultGridFilterLookup),
        visibleRowsLookup: {}
    });
};
module.exports.filterStateInitializer = $91ff0c015e83a086$var$filterStateInitializer;
const $91ff0c015e83a086$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $91ff0c015e83a086$var$createMemoizedValues() {
    return (0, $cvyxi.lruMemoize)(Object.values);
}
/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 * @requires useGridRows (event)
 */ const $91ff0c015e83a086$var$useGridFilter = (apiRef, props, configuration)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: $k278Q.gridFilterModelSelector,
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $91ff0c015e83a086$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
            const filterState = apiRef.current.getFilterState(filterModel);
            const newState = (0, $91ff0c015e83a086$var$_extends2.default)({}, state, {
                filter: (0, $91ff0c015e83a086$var$_extends2.default)({}, state.filter, filterState)
            });
            const visibleRowsLookupState = $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $91ff0c015e83a086$var$_extends2.default)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef
    ]);
    const addColumnMenuItem = $91ff0c015e83a086$var$React.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const upsertFilterItem = $91ff0c015e83a086$var$React.useCallback((item)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $91ff0c015e83a086$var$React.useCallback((items)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = existingItems.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: existingItems
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $91ff0c015e83a086$var$React.useCallback((itemToDelete)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $91ff0c015e83a086$var$React.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = column.filterOperators?.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof filterOperator?.requiresFilterValue === 'undefined' ? true : filterOperator?.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $14dIX.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $14dIX.cleanFilterItem)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences($3PCYS.GridPreferencePanelsValue.filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $91ff0c015e83a086$var$React.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $91ff0c015e83a086$var$React.useCallback((logicOperator)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $91ff0c015e83a086$var$React.useCallback((values)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if ((0, $e9lLm.isDeepEqual)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $91ff0c015e83a086$var$React.useCallback((model, reason)=>{
        const currentModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $14dIX.mergeStateWithFilterModel)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const getFilterState = $91ff0c015e83a086$var$React.useCallback((inputFilterModel)=>{
        const filterModel = (0, $14dIX.sanitizeFilterModel)(inputFilterModel, props.disableMultipleColumnsFiltering, apiRef);
        const filterValueGetter = configuration.hooks.useFilterValueGetter(apiRef, props);
        const isRowMatchingFilters = props.filterMode === 'client' ? (0, $14dIX.buildAggregatedFilterApplier)(filterModel, filterValueGetter, apiRef, props.disableEval) : null;
        const filterResult = apiRef.current.applyStrategyProcessor('filtering', {
            isRowMatchingFilters: isRowMatchingFilters,
            filterModel: filterModel ?? (0, $l4QMb.getDefaultGridFilterModel)(),
            filterValueGetter: filterValueGetter
        });
        return (0, $91ff0c015e83a086$var$_extends2.default)({}, filterResult, {
            filterModel: filterModel
        });
    }, [
        apiRef,
        configuration.hooks,
        props
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: updateFilteredRows,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics,
        getFilterState: getFilterState
    };
    (0, $ivFej.useGridApiMethod)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $91ff0c015e83a086$var$React.useCallback((prevState, context)=>{
        const filterModelToExport = (0, $k278Q.gridFilterModelSelector)(apiRef);
        // Remove the additional `fromInput` property from the filter model
        filterModelToExport.items.forEach((item)=>{
            delete item.fromInput;
        });
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        props.initialState?.filter?.filterModel != null || // Export if the model is not equal to the default value
        !(0, $e9lLm.isDeepEqual)(filterModelToExport, (0, $l4QMb.getDefaultGridFilterModel)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $91ff0c015e83a086$var$_extends2.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        props.initialState?.filter?.filterModel
    ]);
    const stateRestorePreProcessing = $91ff0c015e83a086$var$React.useCallback((params, context)=>{
        const filterModel = context.stateToRestore.filter?.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $14dIX.mergeStateWithFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $91ff0c015e83a086$var$_extends2.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $91ff0c015e83a086$var$React.useCallback((initialValue, value)=>{
        if (value === $3PCYS.GridPreferencePanelsValue.filters) {
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(FilterPanel, (0, $91ff0c015e83a086$var$_extends2.default)({}, props.slotProps?.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        props.slotProps?.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $7O6ub.useLazyRef)($91ff0c015e83a086$var$createMemoizedValues);
    const flatFilteringMethod = $91ff0c015e83a086$var$React.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters || !params.filterModel.items.length && !params.filterModel.quickFilterValues?.length) return $l4QMb.defaultGridFilterLookup;
        const dataRowIdToModelLookup = (0, $eFlT8.gridRowsLookupSelector)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $14dIX.passFilterLogic)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, params.filterValueGetter, apiRef, filterCache);
            if (!isRowPassing) filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredChildrenCountLookup: {},
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $5ErGu.useGridRegisterStrategyProcessor)(apiRef, $5ErGu.GRID_DEFAULT_STRATEGY, 'filtering', flatFilteringMethod);
    (0, $5ErGu.useGridRegisterStrategyProcessor)(apiRef, $5ErGu.GRID_DEFAULT_STRATEGY, 'visibleRowsLookupCreation', $91ff0c015e83a086$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $91ff0c015e83a086$var$React.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const columnsLookup = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && columnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $91ff0c015e83a086$var$_extends2.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $91ff0c015e83a086$var$React.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $91ff0c015e83a086$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $91ff0c015e83a086$var$_extends2.default)({}, state, {
                visibleRowsLookup: $91ff0c015e83a086$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
    }, [
        apiRef
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        if (filterModel.quickFilterValues?.length && (0, $14dIX.shouldQuickFilterExcludeHiddenColumns)(filterModel)) // re-apply filters because the quick filter results may have changed
        updateFilteredRows();
    });
    /**
   * 1ST RENDER
   */ (0, $bc8LN.useFirstRender)(()=>{
        if (props.signature === 'DataGrid') updateFilteredRows();
    });
    /**
   * EFFECTS
   */ (0, $91ff0c015e83a086$var$_useEnhancedEffect.default)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};
module.exports.useGridFilter = $91ff0c015e83a086$var$useGridFilter;

});

parcelRegister("1lT2X", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0fc273bc52ff1742$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0fc273bc52ff1742$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridFocus = module.exports.focusStateInitializer = void 0;

var $0fc273bc52ff1742$var$_extends2 = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0fc273bc52ff1742$var$React = $0fc273bc52ff1742$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0fc273bc52ff1742$var$_debounce = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $0fc273bc52ff1742$var$_useEventCallback = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $0fc273bc52ff1742$var$_ownerDocument = $0fc273bc52ff1742$require$_interopRequireDefault((parcelRequire("43fuO")));

var $5H1vo = parcelRequire("5H1vo");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $g8PwW = parcelRequire("g8PwW");

var $dMF9H = parcelRequire("dMF9H");

var $drCmI = parcelRequire("drCmI");

var $g2vKb = parcelRequire("g2vKb");

var $jQEEt = parcelRequire("jQEEt");

var $aJApm = parcelRequire("aJApm");

var $lR3Vo = parcelRequire("lR3Vo");

var $goCyd = parcelRequire("goCyd");
const $0fc273bc52ff1742$var$focusStateInitializer = (state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
/**
 * @requires useGridParamsApi (method)
 * @requires useGridRows (method)
 * @requires useGridEditing (event)
 */ module.exports.focusStateInitializer = $0fc273bc52ff1742$var$focusStateInitializer;
const $0fc273bc52ff1742$var$useGridFocus = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridFocus');
    const lastClickedCell = $0fc273bc52ff1742$var$React.useRef(null);
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const publishCellFocusOut = $0fc273bc52ff1742$var$React.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $0fc273bc52ff1742$var$React.useCallback((id, field)=>{
        const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (focusedCell?.id === id && focusedCell?.field === field) {
            /**
       * Check if the state matches the actual DOM focus. They can get out of sync after `updateRows()` remounts the cell.
       */ if (apiRef.current.getCellMode(id, field) !== 'view') return;
            const cellElement = apiRef.current.getCellElement(id, field);
            if (!cellElement) return;
            const gridRoot = apiRef.current.rootElementRef.current;
            const doc = (0, $0fc273bc52ff1742$var$_ownerDocument.default)(gridRoot);
            const activeElement = doc.activeElement;
            // We can take focus if:
            // - Focus is inside the grid, OR
            // - Focus is "lost" (on body/documentElement/null, e.g., after cell remount during undo/redo)
            // We should NOT take focus if it's intentionally outside the grid (e.g., in a Portal/Dialog).
            // React synthetic events bubble through the React component tree, not the DOM tree,
            // so events from Portal content can trigger this code even though focus is elsewhere.
            // This avoids https://github.com/mui/mui-x/issues/21063
            const allowTakingFocus = !activeElement || activeElement === doc.body || activeElement === doc.documentElement || gridRoot?.contains(activeElement);
            if (!allowTakingFocus) return;
            if (cellElement.contains(doc.activeElement)) return;
            if ((0, $g2vKb.doesSupportPreventScroll)()) cellElement.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                cellElement.focus();
                apiRef.current.scroll(scrollPosition);
            }
            return;
        }
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $0fc273bc52ff1742$var$React.useCallback((field, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $0fc273bc52ff1742$var$React.useCallback((field, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $0fc273bc52ff1742$var$React.useCallback((field, depth, event = {})=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $0fc273bc52ff1742$var$React.useCallback(()=>(0, $drCmI.gridFocusColumnGroupHeaderSelector)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $0fc273bc52ff1742$var$React.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $goCyd.gridPinnedRowsSelector)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $lR3Vo.clamp)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $lR3Vo.clamp)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $0fc273bc52ff1742$var$React.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $0fc273bc52ff1742$var$React.useCallback((params, event)=>{
        if ((0, $dMF9H.isPasteShortcut)(event) || event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $dMF9H.isNavigationKey)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $0fc273bc52ff1742$var$React.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $0fc273bc52ff1742$var$React.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $drCmI.gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $0fc273bc52ff1742$var$React.useCallback((_, event)=>{
        if (event.relatedTarget?.getAttribute('class')?.includes($5H1vo.gridClasses.columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $0fc273bc52ff1742$var$React.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $0fc273bc52ff1742$var$React.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if (cellParams?.id === focusedCell.id && cellParams?.field === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement?.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $0fc273bc52ff1742$var$React.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (cell?.id !== params.id || cell?.field !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowsSet = $0fc273bc52ff1742$var$React.useCallback(()=>{
        const cell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        // If the focused cell is in a row which does not exist anymore,
        // focus previous row or remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) {
            const lastFocusedRowId = cell.id;
            let nextRowId = null;
            if (typeof lastFocusedRowId !== 'undefined') {
                const rowEl = apiRef.current.getRowElement(lastFocusedRowId);
                const lastFocusedRowIndex = rowEl?.dataset.rowindex ? Number(rowEl?.dataset.rowindex) : 0;
                const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
                    pagination: props.pagination,
                    paginationMode: props.paginationMode
                });
                const nextRow = currentPage.rows[(0, $lR3Vo.clamp)(lastFocusedRowIndex, 0, currentPage.rows.length - 1)];
                nextRowId = nextRow?.id ?? null;
            }
            apiRef.current.setState((state)=>(0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                    focus: {
                        cell: nextRowId === null ? null : {
                            id: nextRowId,
                            field: cell.field
                        },
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
        }
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const debouncedHandleRowsSet = $0fc273bc52ff1742$var$React.useMemo(()=>(0, $0fc273bc52ff1742$var$_debounce.default)(handleRowsSet, 0), [
        handleRowsSet
    ]);
    const handlePaginationModelChange = (0, $0fc273bc52ff1742$var$_useEventCallback.default)(()=>{
        const currentFocusedCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $aJApm.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage || currentPage.rows.length === 0) return;
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $0fc273bc52ff1742$var$_extends2.default)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $ivFej.useGridApiMethod)(apiRef, focusApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, focusPrivateApi, 'private');
    $0fc273bc52ff1742$var$React.useEffect(()=>{
        const doc = (0, $0fc273bc52ff1742$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        hasRootReference,
        handleDocumentClick
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $g8PwW.useGridEvent)(apiRef, 'rowsSet', debouncedHandleRowsSet);
    (0, $g8PwW.useGridEvent)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};
module.exports.useGridFocus = $0fc273bc52ff1742$var$useGridFocus;

});

parcelRegister("12xQD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0c203bd54aeaf237$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridKeyboardNavigation = void 0;

var $0c203bd54aeaf237$var$React = $0c203bd54aeaf237$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $jZka4 = parcelRequire("jZka4");

var $gRn8b = parcelRequire("gRn8b");

var $jQEEt = parcelRequire("jQEEt");

var $luu6e = parcelRequire("luu6e");

var $g8PwW = parcelRequire("g8PwW");

var $k278Q = parcelRequire("k278Q");

var $5bG6h = parcelRequire("5bG6h");

var $5H1vo = parcelRequire("5H1vo");

var $jkRzp = parcelRequire("jkRzp");

var $dMF9H = parcelRequire("dMF9H");

var $fI50C = parcelRequire("fI50C");

var $hMyIf = parcelRequire("hMyIf");

var $6forD = parcelRequire("6forD");

var $2hRnp = parcelRequire("2hRnp");

var $KtEo5 = parcelRequire("KtEo5");

var $39zQf = parcelRequire("39zQf");

var $cgQ4y = parcelRequire("cgQ4y");

var $b2EyI = parcelRequire("b2EyI");

var $goCyd = parcelRequire("goCyd");
const $0c203bd54aeaf237$var$gridVisibleRowsWithPinnedRowsSelector = (0, $cgQ4y.createSelectorMemoized)($b2EyI.gridVisibleRowsSelector, $goCyd.gridPinnedRowsSelector, (visibleRows, pinnedRows)=>{
    return (pinnedRows.top || []).concat(visibleRows.rows, pinnedRows.bottom || []);
});
/**
 * @requires useGridSorting (method) - can be after
 * @requires useGridFilter (state) - can be after
 * @requires useGridColumns (state, method) - can be after
 * @requires useGridDimensions (method) - can be after
 * @requires useGridFocus (method) - can be after
 * @requires useGridScroll (method) - can be after
 * @requires useGridColumnSpanning (method) - can be after
 */ const $0c203bd54aeaf237$var$useGridKeyboardNavigation = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridKeyboardNavigation');
    const isRtl = (0, $9uEev.useRtl)();
    const getCurrentPageRows = $0c203bd54aeaf237$var$React.useCallback(()=>{
        return $0c203bd54aeaf237$var$gridVisibleRowsWithPinnedRowsSelector(apiRef);
    }, [
        apiRef
    ]);
    const headerFilteringEnabled = props.signature !== 'DataGrid' && props.headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {GridRowId} rowId index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * @param {string} rowSpanScanDirection Which direction to search to find the next cell not hidden by `rowSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $0c203bd54aeaf237$var$React.useCallback((colIndex, rowId, closestColumnToUse = 'left', rowSpanScanDirection = 'up')=>{
        const visibleSortedRows = (0, $k278Q.gridExpandedSortedRowEntriesSelector)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        const field = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef)[colIndex];
        const nonRowSpannedRowId = (0, $39zQf.findNonRowSpannedCell)(apiRef, rowId, colIndex, rowSpanScanDirection);
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === nonRowSpannedRowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        apiRef.current.setCellFocus(nonRowSpannedRowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = $0c203bd54aeaf237$var$React.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $0c203bd54aeaf237$var$React.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $0c203bd54aeaf237$var$React.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $0c203bd54aeaf237$var$React.useCallback((rowIndex)=>{
        return getCurrentPageRows()[rowIndex]?.id;
    }, [
        getCurrentPageRows
    ]);
    const handleColumnHeaderKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${$5H1vo.gridClasses.columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== $5bG6h.GRID_CHECKBOX_SELECTION_COL_DEF.field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        if (!(0, $dMF9H.isNavigationKey)(event.key) && event.key !== 'Tab' && event.key !== 'Enter') return;
        // Tab key is only allowed if tabbing is enabled for header/all, or if we are tabbing to the content area while `tabNavigation` is enabled for content only
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'content' && event.shiftKey)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length > 0 ? currentPageRows.length - 1 : null;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        const columnGroupMaxDepth = (0, $hMyIf.gridColumnGroupsHeaderMaxDepthSelector)(apiRef);
        let shouldPreventDefault = true;
        // If we are tabbing inside the header area while only content `tabNavigation` is enabled, go to the first cell
        if (event.key === 'Tab' && props.tabNavigation === 'content' && !event.shiftKey) {
            if (firstRowIndexInPage !== null) {
                goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                event.preventDefault();
            }
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $39zQf.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $39zQf.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case 'Tab':
                if (event.shiftKey) {
                    // if the key is pressed on the first column header, Shift+Tab should go to the group header if it is there or allow default behavior
                    if (colIndexBefore === firstColIndex) {
                        if (columnGroupMaxDepth > 0) goToGroupHeader(lastColIndex, columnGroupMaxDepth - 1, event);
                        else shouldPreventDefault = false;
                    } else goToHeader(colIndexBefore - 1, event);
                } else if (colIndexBefore === lastColIndex) {
                    // the key is pressed at the last column header. go to the first header filter or the first cell
                    if (headerFilteringEnabled) goToHeaderFilter(firstColIndex, event);
                    else if (props.tabNavigation === 'all' && firstRowIndexInPage !== null) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                    else shouldPreventDefault = false;
                } else goToHeader(colIndexBefore + 1, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        isRtl,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        const isEditing = (0, $6forD.gridHeaderFilteringEditFieldSelector)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $6forD.gridHeaderFilteringMenuSelector)(apiRef) === params.field;
        if (isHeaderMenuOpen || isEditing && event.key !== 'Tab') return;
        if (!(0, $dMF9H.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled for header/all, or if we are tabbing to the content area while `tabNavigation` is enabled for content only
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'content' && event.shiftKey)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length > 0 ? currentPageRows.length - 1 : null;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        let shouldPreventDefault = true;
        // If we are tabbing inside the header area while only content `tabNavigation` is enabled, go to the first cell
        if (event.key === 'Tab' && props.tabNavigation === 'content' && !event.shiftKey) {
            if (firstRowIndexInPage !== null) {
                goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                event.preventDefault();
            }
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $39zQf.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $39zQf.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case 'Tab':
                if (event.shiftKey) {
                    // if the key is pressed on the first header filter, Shift+Tab should go to the column header
                    if (colIndexBefore === firstColIndex) goToHeader(lastColIndex, event);
                    else goToHeaderFilter(colIndexBefore - 1, event);
                } else if (colIndexBefore === lastColIndex) {
                    // the key is pressed at the last header filter.
                    // this point can be reached if `tabNavigation` is enabled for all content or just header.
                    // if it is not enabled for all content or there is no data, then do not focus on the first cell
                    if (props.tabNavigation === 'all' && firstRowIndexInPage !== null) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                    else shouldPreventDefault = false;
                } else goToHeaderFilter(colIndexBefore + 1, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        goToHeaderFilter,
        isRtl,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        const focusedColumnGroup = (0, $fI50C.gridFocusColumnGroupHeaderSelector)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        if (!(0, $dMF9H.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled for header/all, or if we are tabbing to the content area while `tabNavigation` is enabled for content only
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'content' && event.shiftKey)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length > 0 ? currentPageRows.length - 1 : null;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        let shouldPreventDefault = true;
        // If we are tabbing inside the header area while only content `tabNavigation` is enabled, go to the first cell
        if (event.key === 'Tab' && props.tabNavigation === 'content' && !event.shiftKey) {
            if (firstRowIndexInPage !== null) {
                goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                event.preventDefault();
            }
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case 'Tab':
                if (event.shiftKey) {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    const targetColIndex = currentColIndex - remainingLeftColumns - 1;
                    if (targetColIndex < firstColIndex) {
                        if (depth === 0) // if the key is pressed on the first column group header at the top level, Shift+Tab should allow default behavior
                        shouldPreventDefault = false;
                        else // Navigate to last column group header at the previous depth
                        goToGroupHeader(lastColIndex, currentDepth - 1, event);
                    } else goToGroupHeader(targetColIndex, currentDepth, event);
                } else {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    const targetColIndex = currentColIndex + remainingRightColumns + 1;
                    if (targetColIndex > lastColIndex && depth === maxDepth - 1) // the key is pressed at the last column group header at the deepest level. go to the first column header
                    goToHeader(firstColIndex, event);
                    else if (targetColIndex > lastColIndex) // go down a depth level
                    goToGroupHeader(firstColIndex, currentDepth + 1, event);
                    else goToGroupHeader(targetColIndex, currentDepth, event);
                }
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $0c203bd54aeaf237$var$React.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === $jkRzp.GridCellModes.Edit || !(0, $dMF9H.isNavigationKey)(event.key) && event.key !== 'Tab') return;
        // Tab key is only allowed if tabbing is enabled or if we are tabbing to the header area while `tabNavigation` is enabled for header only (with Shift+Tab)
        if (event.key === 'Tab' && (props.tabNavigation === 'none' || props.tabNavigation === 'header' && !event.shiftKey)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const currentPageRows = getCurrentPageRows();
        if (currentPageRows.length === 0) return;
        const previousAreaNavigationFn = headerFilteringEnabled ? goToHeaderFilter : goToHeader;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = Math.max(0, (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1);
        let shouldPreventDefault = true;
        // If we are tabbing inside the content area while only header `tabNavigation` is enabled, go to the last header filter or column header
        if (event.key === 'Tab' && props.tabNavigation === 'header' && event.shiftKey) {
            previousAreaNavigationFn(lastColIndex, event);
            event.preventDefault();
            return;
        }
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1), isRtl ? 'right' : 'left', 'down');
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else previousAreaNavigationFn(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $39zQf.getRightColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $39zQf.getLeftColumnIndex)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                if (event.shiftKey) {
                    // if the key is pressed on the first cell, Shift+Tab should go to the last column header
                    // same is if `tabNavigation` is enabled for header only
                    if (colIndexBefore === firstColIndex && rowIndexBefore === firstRowIndexInPage) {
                        if (props.tabNavigation === 'all') previousAreaNavigationFn(lastColIndex, event);
                        else shouldPreventDefault = false;
                    } else if (colIndexBefore === firstColIndex) goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore - 1));
                    else goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                } else if (colIndexBefore === lastColIndex) {
                    // the key is pressed at the last column. if it is also the last row, do not to anything to allow the default behavior
                    // otherwise, go to the first column of the next row
                    if (rowIndexBefore !== lastRowIndexInPage) goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore + 1));
                    else shouldPreventDefault = false;
                } else goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD) break;
                    const colDef = params.colDef;
                    if (colDef && (colDef.field === $jZka4.GRID_TREE_DATA_GROUPING_FIELD || (0, $gRn8b.isGroupingColumn)(colDef.field))) break;
                    if (colDef && colDef.type === 'longText') break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        props.tabNavigation,
        getCurrentPageRows,
        isRtl,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = $0c203bd54aeaf237$var$React.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $g8PwW.useGridEvent)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellKeyDown', handleCellKeyDown);
};
module.exports.useGridKeyboardNavigation = $0c203bd54aeaf237$var$useGridKeyboardNavigation;

});
parcelRegister("39zQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findNonRowSpannedCell = $24be03c588f8c679$var$findNonRowSpannedCell;
module.exports.getRightColumnIndex = module.exports.getLeftColumnIndex = void 0;

var $l8hgY = parcelRequire("l8hgY");

var $k278Q = parcelRequire("k278Q");
const $24be03c588f8c679$var$getLeftColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (!isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
module.exports.getLeftColumnIndex = $24be03c588f8c679$var$getLeftColumnIndex;
const $24be03c588f8c679$var$getRightColumnIndex = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (!isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
module.exports.getRightColumnIndex = $24be03c588f8c679$var$getRightColumnIndex;
function $24be03c588f8c679$var$findNonRowSpannedCell(apiRef, rowId, colIndex, rowSpanScanDirection) {
    const rowSpanHiddenCells = $l8hgY.Rowspan.selectors.hiddenCells(apiRef.current.virtualizer.store.state);
    if (!rowSpanHiddenCells[rowId]?.[colIndex]) return rowId;
    const filteredSortedRowIds = (0, $k278Q.gridFilteredSortedRowIdsSelector)(apiRef);
    // find closest non row spanned cell in the given `rowSpanScanDirection`
    let nextRowIndex = filteredSortedRowIds.indexOf(rowId) + (rowSpanScanDirection === 'down' ? 1 : -1);
    while(nextRowIndex >= 0 && nextRowIndex < filteredSortedRowIds.length){
        const nextRowId = filteredSortedRowIds[nextRowIndex];
        if (!rowSpanHiddenCells[nextRowId]?.[colIndex]) return nextRowId;
        nextRowIndex += rowSpanScanDirection === 'down' ? 1 : -1;
    }
    return rowId;
}

});


parcelRegister("3m1KX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2714c9ed9cdf2996$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridPagination = module.exports.paginationStateInitializer = void 0;

var $2714c9ed9cdf2996$var$_extends2 = $2714c9ed9cdf2996$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $baj2X = parcelRequire("baj2X");

var $87jE6 = parcelRequire("87jE6");

var $hVzRt = parcelRequire("hVzRt");

var $hT3rk = parcelRequire("hT3rk");
const $2714c9ed9cdf2996$var$paginationStateInitializer = (state, props)=>{
    const paginationModel = (0, $2714c9ed9cdf2996$var$_extends2.default)({}, (0, $baj2X.getDefaultGridPaginationModel)(props.autoPageSize), props.paginationModel ?? props.initialState?.pagination?.paginationModel);
    (0, $baj2X.throwIfPageSizeExceedsTheLimit)(paginationModel.pageSize, props.signature);
    const rowCount = props.rowCount ?? props.initialState?.pagination?.rowCount ?? (props.paginationMode === 'client' ? state.rows?.totalRowCount : undefined);
    const meta = props.paginationMeta ?? props.initialState?.pagination?.meta ?? {};
    return (0, $2714c9ed9cdf2996$var$_extends2.default)({}, state, {
        pagination: (0, $2714c9ed9cdf2996$var$_extends2.default)({}, state.pagination, {
            paginationModel: paginationModel,
            rowCount: rowCount,
            meta: meta,
            enabled: props.pagination === true,
            paginationMode: props.paginationMode
        })
    });
};
/**
 * @requires useGridFilter (state)
 * @requires useGridDimensions (event) - can be after
 */ module.exports.paginationStateInitializer = $2714c9ed9cdf2996$var$paginationStateInitializer;
const $2714c9ed9cdf2996$var$useGridPagination = (apiRef, props)=>{
    (0, $hT3rk.useGridPaginationMeta)(apiRef, props);
    (0, $87jE6.useGridPaginationModel)(apiRef, props);
    (0, $hVzRt.useGridRowCount)(apiRef, props);
};
module.exports.useGridPagination = $2714c9ed9cdf2996$var$useGridPagination;

});
parcelRegister("hVzRt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d0d393dcade2390b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d0d393dcade2390b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowCount = void 0;

var $d0d393dcade2390b$var$_extends2 = $d0d393dcade2390b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d0d393dcade2390b$var$React = $d0d393dcade2390b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d0d393dcade2390b$var$_useLazyRef = $d0d393dcade2390b$require$_interopRequireDefault((parcelRequire("doV3C")));

var $8P0MD = parcelRequire("8P0MD");

var $13Ynj = parcelRequire("13Ynj");

var $5LeoO = parcelRequire("5LeoO");

var $2hRnp = parcelRequire("2hRnp");

var $gPWuj = parcelRequire("gPWuj");
const $d0d393dcade2390b$var$useGridRowCount = (apiRef, props)=>{
    const logger = (0, $5LeoO.useGridLogger)(apiRef, 'useGridRowCount');
    const previousPageSize = (0, $d0d393dcade2390b$var$_useLazyRef.default)(()=>(0, $gPWuj.gridPaginationModelSelector)(apiRef).pageSize);
    apiRef.current.registerControlState({
        stateId: 'paginationRowCount',
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: $gPWuj.gridPaginationRowCountSelector,
        changeEvent: 'rowCountChange'
    });
    /**
   * API METHODS
   */ const setRowCount = $d0d393dcade2390b$var$React.useCallback((newRowCount)=>{
        const rowCountState = (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        if (rowCountState === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $d0d393dcade2390b$var$_extends2.default)({}, state, {
                pagination: (0, $d0d393dcade2390b$var$_extends2.default)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $5LeoO.useGridApiMethod)(apiRef, paginationRowCountApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $d0d393dcade2390b$var$React.useCallback((prevState, context)=>{
        const exportedRowCount = (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        props.initialState?.pagination?.rowCount != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $d0d393dcade2390b$var$_extends2.default)({}, prevState, {
            pagination: (0, $d0d393dcade2390b$var$_extends2.default)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        props.initialState?.pagination?.rowCount
    ]);
    const stateRestorePreProcessing = $d0d393dcade2390b$var$React.useCallback((params, context)=>{
        const restoredRowCount = context.stateToRestore.pagination?.rowCount ? context.stateToRestore.pagination.rowCount : (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $d0d393dcade2390b$var$_extends2.default)({}, state, {
                pagination: (0, $d0d393dcade2390b$var$_extends2.default)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = $d0d393dcade2390b$var$React.useCallback((model)=>{
        if (props.paginationMode === 'client' || !previousPageSize.current) return;
        if (model.pageSize !== previousPageSize.current) {
            previousPageSize.current = model.pageSize;
            const rowCountState = (0, $gPWuj.gridPaginationRowCountSelector)(apiRef);
            if (rowCountState === -1) // Row count unknown and page size changed, reset the page
            apiRef.current.setPage(0);
        }
    }, [
        props.paginationMode,
        previousPageSize,
        apiRef
    ]);
    (0, $5LeoO.useGridEvent)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    /**
   * EFFECTS
   */ $d0d393dcade2390b$var$React.useEffect(()=>{
        if (props.paginationMode === 'server' && props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        props.paginationMode,
        props.rowCount
    ]);
    (0, $8P0MD.useStoreEffect)(// typings not supported currently, but methods work
    apiRef.current.store, ()=>{
        const isLastPage = (0, $gPWuj.gridPaginationMetaSelector)(apiRef).hasNextPage === false;
        if (isLastPage) return true;
        if (props.paginationMode === 'client') return (0, $13Ynj.gridFilteredTopLevelRowCountSelector)(apiRef);
        return undefined;
    }, (_, isLastPageOrRowCount)=>{
        if (isLastPageOrRowCount === true && (0, $gPWuj.gridPaginationRowCountSelector)(apiRef) !== -1) {
            const visibleTopLevelRowCount = (0, $13Ynj.gridFilteredTopLevelRowCountSelector)(apiRef);
            const paginationModel = (0, $gPWuj.gridPaginationModelSelector)(apiRef);
            apiRef.current.setRowCount(paginationModel.pageSize * paginationModel.page + visibleTopLevelRowCount);
        } else if (typeof isLastPageOrRowCount === 'number') apiRef.current.setRowCount(isLastPageOrRowCount);
    });
    $d0d393dcade2390b$var$React.useEffect(()=>{
        if (props.paginationMode === 'client') apiRef.current.setRowCount((0, $13Ynj.gridFilteredTopLevelRowCountSelector)(apiRef));
    }, [
        apiRef,
        props.paginationMode
    ]);
};
module.exports.useGridRowCount = $d0d393dcade2390b$var$useGridRowCount;

});

parcelRegister("hT3rk", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d05a3dc983bf505e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d05a3dc983bf505e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridPaginationMeta = void 0;

var $d05a3dc983bf505e$var$_extends2 = $d05a3dc983bf505e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d05a3dc983bf505e$var$React = $d05a3dc983bf505e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5LeoO = parcelRequire("5LeoO");

var $2hRnp = parcelRequire("2hRnp");

var $gPWuj = parcelRequire("gPWuj");
const $d05a3dc983bf505e$var$useGridPaginationMeta = (apiRef, props)=>{
    const logger = (0, $5LeoO.useGridLogger)(apiRef, 'useGridPaginationMeta');
    apiRef.current.registerControlState({
        stateId: 'paginationMeta',
        propModel: props.paginationMeta,
        propOnChange: props.onPaginationMetaChange,
        stateSelector: $gPWuj.gridPaginationMetaSelector,
        changeEvent: 'paginationMetaChange'
    });
    /**
   * API METHODS
   */ const setPaginationMeta = $d05a3dc983bf505e$var$React.useCallback((newPaginationMeta)=>{
        const paginationMeta = (0, $gPWuj.gridPaginationMetaSelector)(apiRef);
        if (paginationMeta === newPaginationMeta) return;
        logger.debug("Setting 'paginationMeta' to", newPaginationMeta);
        apiRef.current.setState((state)=>(0, $d05a3dc983bf505e$var$_extends2.default)({}, state, {
                pagination: (0, $d05a3dc983bf505e$var$_extends2.default)({}, state.pagination, {
                    meta: newPaginationMeta
                })
            }));
    }, [
        apiRef,
        logger
    ]);
    const paginationMetaApi = {
        setPaginationMeta: setPaginationMeta
    };
    (0, $5LeoO.useGridApiMethod)(apiRef, paginationMetaApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $d05a3dc983bf505e$var$React.useCallback((prevState, context)=>{
        const exportedPaginationMeta = (0, $gPWuj.gridPaginationMetaSelector)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
        props.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
        props.initialState?.pagination?.meta != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $d05a3dc983bf505e$var$_extends2.default)({}, prevState, {
            pagination: (0, $d05a3dc983bf505e$var$_extends2.default)({}, prevState.pagination, {
                meta: exportedPaginationMeta
            })
        });
    }, [
        apiRef,
        props.paginationMeta,
        props.initialState?.pagination?.meta
    ]);
    const stateRestorePreProcessing = $d05a3dc983bf505e$var$React.useCallback((params, context)=>{
        const restoredPaginationMeta = context.stateToRestore.pagination?.meta ? context.stateToRestore.pagination.meta : (0, $gPWuj.gridPaginationMetaSelector)(apiRef);
        apiRef.current.setState((state)=>(0, $d05a3dc983bf505e$var$_extends2.default)({}, state, {
                pagination: (0, $d05a3dc983bf505e$var$_extends2.default)({}, state.pagination, {
                    meta: restoredPaginationMeta
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $d05a3dc983bf505e$var$React.useEffect(()=>{
        if (props.paginationMeta) apiRef.current.setPaginationMeta(props.paginationMeta);
    }, [
        apiRef,
        props.paginationMeta
    ]);
};
module.exports.useGridPaginationMeta = $d05a3dc983bf505e$var$useGridPaginationMeta;

});


parcelRegister("4epuR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $314c3f5b8282a42e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $314c3f5b8282a42e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridPreferencesPanel = module.exports.preferencePanelStateInitializer = void 0;

var $314c3f5b8282a42e$var$_extends2 = $314c3f5b8282a42e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $314c3f5b8282a42e$var$React = $314c3f5b8282a42e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $2hRnp = parcelRequire("2hRnp");

var $6X2Yd = parcelRequire("6X2Yd");
const $314c3f5b8282a42e$var$preferencePanelStateInitializer = (state, props)=>(0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
        preferencePanel: props.initialState?.preferencePanel ?? {
            open: false
        }
    });
/**
 * TODO: Add a single `setPreferencePanel` method to avoid multiple `setState`
 */ module.exports.preferencePanelStateInitializer = $314c3f5b8282a42e$var$preferencePanelStateInitializer;
const $314c3f5b8282a42e$var$useGridPreferencesPanel = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridPreferencesPanel');
    /**
   * API METHODS
   */ const hidePreferences = $314c3f5b8282a42e$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (!state.preferencePanel.open) return state;
            logger.debug('Hiding Preferences Panel');
            const preferencePanelState = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef);
            apiRef.current.publishEvent('preferencePanelClose', {
                openedPanelValue: preferencePanelState.openedPanelValue
            });
            return (0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const showPreferences = $314c3f5b8282a42e$var$React.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        apiRef.current.setState((state)=>(0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
                preferencePanel: (0, $314c3f5b8282a42e$var$_extends2.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
    }, [
        logger,
        apiRef
    ]);
    (0, $ivFej.useGridApiMethod)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferences
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $314c3f5b8282a42e$var$React.useCallback((prevState, context)=>{
        const preferencePanelToExport = (0, $6X2Yd.gridPreferencePanelStateSelector)(apiRef);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        props.initialState?.preferencePanel != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $314c3f5b8282a42e$var$_extends2.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        props.initialState?.preferencePanel
    ]);
    const stateRestorePreProcessing = $314c3f5b8282a42e$var$React.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $314c3f5b8282a42e$var$_extends2.default)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
};
module.exports.useGridPreferencesPanel = $314c3f5b8282a42e$var$useGridPreferencesPanel;

});

parcelRegister("fTRdy", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b93545fe9a3b3245$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b93545fe9a3b3245$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridEditing = module.exports.editingStateInitializer = void 0;

var $b93545fe9a3b3245$var$_extends2 = $b93545fe9a3b3245$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b93545fe9a3b3245$var$React = $b93545fe9a3b3245$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivFej = parcelRequire("ivFej");

var $3uAik = parcelRequire("3uAik");

var $jkRzp = parcelRequire("jkRzp");

var $h652i = parcelRequire("h652i");

var $5Rfo7 = parcelRequire("5Rfo7");
const $b93545fe9a3b3245$var$editingStateInitializer = (state)=>(0, $b93545fe9a3b3245$var$_extends2.default)({}, state, {
        editRows: {}
    });
module.exports.editingStateInitializer = $b93545fe9a3b3245$var$editingStateInitializer;
const $b93545fe9a3b3245$var$useGridEditing = (apiRef, props, configuration)=>{
    (0, $3uAik.useGridCellEditing)(apiRef, props);
    (0, $h652i.useGridRowEditing)(apiRef, props);
    const debounceMap = $b93545fe9a3b3245$var$React.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditableFn = configuration.hooks.useIsCellEditable(apiRef, props);
    const isCellEditable = $b93545fe9a3b3245$var$React.useCallback((params)=>{
        if (!isCellEditableFn(params)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp,
        isCellEditableFn
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $b93545fe9a3b3245$var$React.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $b93545fe9a3b3245$var$React.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $b93545fe9a3b3245$var$React.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === $jkRzp.GridEditModes.Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === $jkRzp.GridCellModes.Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $b93545fe9a3b3245$var$React.useCallback((id, field)=>{
        return props.editMode === $jkRzp.GridEditModes.Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $b93545fe9a3b3245$var$React.useCallback((id, field)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        return editingState[id]?.[field] ?? null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingSharedApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingSharedPrivateApi, 'private');
};
module.exports.useGridEditing = $b93545fe9a3b3245$var$useGridEditing;

});
parcelRegister("3uAik", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $28b053c97cee4bd6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $28b053c97cee4bd6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridCellEditing = void 0;

var $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2 = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("c05no")));

var $28b053c97cee4bd6$var$_toPropertyKey2 = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $28b053c97cee4bd6$var$_extends2 = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $28b053c97cee4bd6$var$React = $28b053c97cee4bd6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $28b053c97cee4bd6$var$_useEventCallback = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $28b053c97cee4bd6$var$_useEnhancedEffect = $28b053c97cee4bd6$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $e9lLm = parcelRequire("e9lLm");

var $g8PwW = parcelRequire("g8PwW");

var $jkRzp = parcelRequire("jkRzp");

var $ivFej = parcelRequire("ivFej");

var $5Rfo7 = parcelRequire("5Rfo7");

var $dMF9H = parcelRequire("dMF9H");

var $goCyd = parcelRequire("goCyd");

var $lR3Vo = parcelRequire("lR3Vo");

var $iNfie = parcelRequire("iNfie");

var $a4Ou4 = parcelRequire("a4Ou4");
const $28b053c97cee4bd6$var$_excluded = [
    "id",
    "field"
], $28b053c97cee4bd6$var$_excluded2 = [
    "id",
    "field"
];
const $28b053c97cee4bd6$var$useGridCellEditing = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $28b053c97cee4bd6$var$React.useState({});
    const cellModesModelRef = $28b053c97cee4bd6$var$React.useRef(cellModesModel);
    const prevCellModesModel = $28b053c97cee4bd6$var$React.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === $jkRzp.GridEditModes.Cell) callback(...args);
        };
    const throwIfNotEditable = $28b053c97cee4bd6$var$React.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $28b053c97cee4bd6$var$React.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $28b053c97cee4bd6$var$React.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === $jkRzp.GridCellModes.Edit) return;
        const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
            reason: $iNfie.GridCellEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $28b053c97cee4bd6$var$React.useCallback((params, event)=>{
        if (params.cellMode === $jkRzp.GridCellModes.View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === $jkRzp.GridCellModes.View) return;
        const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
            reason: $iNfie.GridCellEditStopReasons.cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $28b053c97cee4bd6$var$React.useCallback((params, event)=>{
        if (params.cellMode === $jkRzp.GridCellModes.Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = $iNfie.GridCellEditStopReasons.escapeKeyDown;
            else if (event.key === 'Enter') reason = $iNfie.GridCellEditStopReasons.enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? $iNfie.GridCellEditStopReasons.shiftTabKeyDown : $iNfie.GridCellEditStopReasons.tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $dMF9H.isPrintableKey)(event)) reason = $iNfie.GridCellEditStartReasons.printableKeyDown;
            else if ((0, $dMF9H.isPasteShortcut)(event)) reason = $iNfie.GridCellEditStartReasons.pasteKeyDown;
            else if (event.key === 'Enter') {
                reason = $iNfie.GridCellEditStartReasons.enterKeyDown;
                event.preventDefault();
            } else if (event.key === 'Backspace' || event.key === 'Delete') reason = $iNfie.GridCellEditStartReasons.deleteKeyDown;
            if (reason) {
                const newParams = (0, $28b053c97cee4bd6$var$_extends2.default)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === $iNfie.GridCellEditStartReasons.printableKeyDown || reason === $iNfie.GridCellEditStartReasons.deleteKeyDown || reason === $iNfie.GridCellEditStartReasons.pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === $iNfie.GridCellEditStopReasons.enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === $iNfie.GridCellEditStopReasons.tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === $iNfie.GridCellEditStopReasons.shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    const runIfNoFieldErrors = (callback)=>async (...args)=>{
            if (callback) {
                const { id: id, field: field } = args[0];
                const editRowsState = apiRef.current.state.editRows;
                const hasFieldErrors = editRowsState[id][field]?.error;
                if (!hasFieldErrors) callback(...args);
            }
        };
    (0, $g8PwW.useGridEvent)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $g8PwW.useGridEventPriority)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'cellEditStop', runIfNoFieldErrors(props.onCellEditStop));
    const getCellMode = $28b053c97cee4bd6$var$React.useCallback((id, field)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? $jkRzp.GridCellModes.Edit : $jkRzp.GridCellModes.View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $28b053c97cee4bd6$var$_useEventCallback.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $28b053c97cee4bd6$var$React.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $28b053c97cee4bd6$var$_extends2.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newModel[id], {
            [field]: (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2.default)(_newModel$id, [
                field
            ].map($28b053c97cee4bd6$var$_toPropertyKey2.default)); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $28b053c97cee4bd6$var$React.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $28b053c97cee4bd6$var$_extends2.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newEditingState[id], {
                [field]: (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $28b053c97cee4bd6$var$_extends2.default)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const startCellEditMode = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2.default)(params, $28b053c97cee4bd6$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, $jkRzp.GridCellModes.View);
        updateFieldInCellModesModel(id, field, (0, $28b053c97cee4bd6$var$_extends2.default)({
            mode: $jkRzp.GridCellModes.Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $28b053c97cee4bd6$var$_useEventCallback.default)(async (params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        const value = apiRef.current.getCellValue(id, field);
        let newValue = value;
        if (deleteValue) newValue = (0, $a4Ou4.getDefaultCellValue)(apiRef.current.getColumn(field));
        else if (initialValue) newValue = initialValue;
        const column = apiRef.current.getColumn(field);
        const shouldProcessEditCellProps = !!column.preProcessEditCellProps && deleteValue;
        let newProps = {
            value: newValue,
            error: false,
            isProcessingProps: shouldProcessEditCellProps
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
        if (shouldProcessEditCellProps) {
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: apiRef.current.getRow(id),
                props: newProps,
                hasChanged: newValue !== value
            }));
            // Check if still in edit mode before updating
            if (apiRef.current.getCellMode(id, field) === $jkRzp.GridCellModes.Edit) {
                const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
                updateOrDeleteFieldState(id, field, (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps, {
                    value: editingState[id][field].value,
                    isProcessingProps: false
                }));
            }
        }
    });
    const stopCellEditMode = $28b053c97cee4bd6$var$React.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $28b053c97cee4bd6$var$_objectWithoutPropertiesLoose2.default)(params, $28b053c97cee4bd6$var$_excluded2);
        throwIfNotInMode(id, field, $jkRzp.GridCellModes.Edit);
        updateFieldInCellModesModel(id, field, (0, $28b053c97cee4bd6$var$_extends2.default)({
            mode: $jkRzp.GridCellModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $28b053c97cee4bd6$var$_useEventCallback.default)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, $jkRzp.GridCellModes.Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        const row = apiRef.current.getRow(id);
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = $jkRzp.GridCellModes.Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: $jkRzp.GridCellModes.Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (props.dataSource?.updateRow) {
            if ((0, $e9lLm.isDeepEqual)(row, rowUpdate)) {
                finishCellEditMode();
                return;
            }
            const handleError = ()=>{
                prevCellModesModel.current[id][field].mode = $jkRzp.GridCellModes.Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: $jkRzp.GridCellModes.Edit
                });
            };
            const updateRowParams = {
                rowId: id,
                updatedRow: rowUpdate,
                previousRow: row
            };
            try {
                await apiRef.current.dataSource.editRow(updateRowParams);
                finishCellEditMode();
            } catch  {
                handleError();
            }
        } else if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = $jkRzp.GridCellModes.Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: $jkRzp.GridCellModes.Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else (0, $9Y8Cp.warnOnce)([
                    'MUI X: A call to `processRowUpdate()` threw an error which was not handled because `onProcessRowUpdateError()` is missing.',
                    'To handle the error pass a callback to the `onProcessRowUpdateError()` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
                    'For more detail, see https://mui.com/x/react-data-grid/editing/persistence/.'
                ], 'error');
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $28b053c97cee4bd6$var$React.useCallback(async (params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, $jkRzp.GridCellModes.Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        let newProps = (0, $28b053c97cee4bd6$var$_extends2.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === $jkRzp.GridCellModes.View) return false;
        editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        newProps = (0, $28b053c97cee4bd6$var$_extends2.default)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        return !editingState[id]?.[field]?.error;
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $28b053c97cee4bd6$var$React.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : (0, $28b053c97cee4bd6$var$_extends2.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $28b053c97cee4bd6$var$React.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $28b053c97cee4bd6$var$_useEnhancedEffect.default)(()=>{
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $lR3Vo.deepClone)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                const prevMode = copyOfPrevCellModes[id]?.[field]?.mode || $jkRzp.GridCellModes.View;
                const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
                if (params.mode === $jkRzp.GridCellModes.Edit && prevMode === $jkRzp.GridCellModes.View) updateStateToStartCellEditMode((0, $28b053c97cee4bd6$var$_extends2.default)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === $jkRzp.GridCellModes.View && prevMode === $jkRzp.GridCellModes.Edit) updateStateToStopCellEditMode((0, $28b053c97cee4bd6$var$_extends2.default)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};
module.exports.useGridCellEditing = $28b053c97cee4bd6$var$useGridCellEditing;

});
parcelRegister("a4Ou4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultCellValue = void 0;
const $7561702eaa720cf2$var$getDefaultCellValue = (colDef)=>{
    switch(colDef.type){
        case 'boolean':
            return false;
        case 'date':
        case 'dateTime':
        case 'number':
            return undefined;
        case 'singleSelect':
            return null;
        case 'string':
        default:
            return '';
    }
};
module.exports.getDefaultCellValue = $7561702eaa720cf2$var$getDefaultCellValue;

});


parcelRegister("h652i", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c726e745e154c244$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c726e745e154c244$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowEditing = void 0;

var $c726e745e154c244$var$_toPropertyKey2 = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("5DKOa")));

var $c726e745e154c244$var$_objectWithoutPropertiesLoose2 = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("c05no")));

var $c726e745e154c244$var$_extends2 = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c726e745e154c244$var$React = $c726e745e154c244$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c726e745e154c244$var$_useEventCallback = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $c726e745e154c244$var$_useEnhancedEffect = $c726e745e154c244$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $e9lLm = parcelRequire("e9lLm");

var $g8PwW = parcelRequire("g8PwW");

var $jkRzp = parcelRequire("jkRzp");

var $ivFej = parcelRequire("ivFej");

var $5Rfo7 = parcelRequire("5Rfo7");

var $dMF9H = parcelRequire("dMF9H");

var $jQEEt = parcelRequire("jQEEt");

var $goCyd = parcelRequire("goCyd");

var $lR3Vo = parcelRequire("lR3Vo");

var $jfE7J = parcelRequire("jfE7J");

var $ehhGY = parcelRequire("ehhGY");

var $a4Ou4 = parcelRequire("a4Ou4");
const $c726e745e154c244$var$_excluded = [
    "id"
], $c726e745e154c244$var$_excluded2 = [
    "id"
];
const $c726e745e154c244$var$useGridRowEditing = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $c726e745e154c244$var$React.useState({});
    const rowModesModelRef = $c726e745e154c244$var$React.useRef(rowModesModel);
    const prevRowModesModel = $c726e745e154c244$var$React.useRef({});
    const prevRowValuesLookup = $c726e745e154c244$var$React.useRef({});
    const focusTimeout = $c726e745e154c244$var$React.useRef(undefined);
    const nextFocusedCell = $c726e745e154c244$var$React.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === $jkRzp.GridEditModes.Row) callback(...args);
        };
    const throwIfNotEditable = $c726e745e154c244$var$React.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $c726e745e154c244$var$React.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI X: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const hasFieldsWithErrors = $c726e745e154c244$var$React.useCallback((rowId)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        return Object.values(editingState[rowId]).some((fieldProps)=>fieldProps.error);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $c726e745e154c244$var$React.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === $jkRzp.GridRowModes.Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, rowParams, {
            field: params.field,
            reason: $jfE7J.GridRowEditStartReasons.cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $c726e745e154c244$var$React.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $c726e745e154c244$var$React.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === $jkRzp.GridRowModes.View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            if (nextFocusedCell.current?.id !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === $jkRzp.GridRowModes.View) return;
                if (hasFieldsWithErrors(params.id)) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, rowParams, {
                    field: params.field,
                    reason: $jfE7J.GridRowEditStopReasons.rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    $c726e745e154c244$var$React.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $c726e745e154c244$var$React.useCallback((params, event)=>{
        if (params.cellMode === $jkRzp.GridRowModes.Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = $jfE7J.GridRowEditStopReasons.escapeKeyDown;
            else if (event.key === 'Enter') reason = $jfE7J.GridRowEditStopReasons.enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $jQEEt.gridVisibleColumnFieldsSelector)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === $ehhGY.GRID_ACTIONS_COLUMN_TYPE) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = $jfE7J.GridRowEditStopReasons.shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = $jfE7J.GridRowEditStopReasons.tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                if (reason !== $jfE7J.GridRowEditStopReasons.escapeKeyDown && hasFieldsWithErrors(params.id)) return;
                const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $dMF9H.isPrintableKey)(event)) reason = $jfE7J.GridRowEditStartReasons.printableKeyDown;
            else if ((0, $dMF9H.isPasteShortcut)(event)) reason = $jfE7J.GridRowEditStartReasons.printableKeyDown;
            else if (event.key === 'Enter') reason = $jfE7J.GridRowEditStartReasons.enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = $jfE7J.GridRowEditStartReasons.deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $c726e745e154c244$var$_extends2.default)({}, rowParams, {
                    field: params.field,
                    reason: reason,
                    // Only pass the pressed key when the row editing is controlled via `rowModesModel`.
                    // In uncontrolled mode, the default editor already inserts the character and passing it here would duplicate it.
                    key: rowModesModelProp && (0, $dMF9H.isPrintableKey)(event) ? event.key : undefined
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef,
        hasFieldsWithErrors,
        rowModesModelProp
    ]);
    const handleRowEditStart = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === $jfE7J.GridRowEditStartReasons.printableKeyDown || reason === $jfE7J.GridRowEditStartReasons.deleteKeyDown) {
            // If the user typed a printable key, initialize the value with that key
            // to avoid losing the first character when the component is controlled.
            if (rowModesModelProp && reason === $jfE7J.GridRowEditStartReasons.printableKeyDown && params.key && field) startRowEditModeParams.initialValue = params.key;
            else // For Delete / Backspace or for uncontrolled row editing we clear the value
            startRowEditModeParams.deleteValue = !!field;
        }
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef,
        rowModesModelProp
    ]);
    const handleRowEditStop = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === $jfE7J.GridRowEditStopReasons.enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === $jfE7J.GridRowEditStopReasons.tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === $jfE7J.GridRowEditStopReasons.shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $g8PwW.useGridEventPriority)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $c726e745e154c244$var$React.useCallback((id)=>{
        const isEditing = (0, $5Rfo7.gridRowIsEditingSelector)(apiRef, {
            rowId: id,
            editMode: props.editMode
        });
        return isEditing ? $jkRzp.GridRowModes.Edit : $jkRzp.GridRowModes.View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $c726e745e154c244$var$_useEventCallback.default)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $c726e745e154c244$var$React.useCallback((id, newProps)=>{
        const newModel = (0, $c726e745e154c244$var$_extends2.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $c726e745e154c244$var$_extends2.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $c726e745e154c244$var$React.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $c726e745e154c244$var$_extends2.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $c726e745e154c244$var$_extends2.default)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $c726e745e154c244$var$React.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $c726e745e154c244$var$_extends2.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $c726e745e154c244$var$_extends2.default)({}, newEditingState[id], {
                [field]: (0, $c726e745e154c244$var$_extends2.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $c726e745e154c244$var$_extends2.default)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const startRowEditMode = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id } = params, other = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(params, $c726e745e154c244$var$_excluded);
        throwIfNotInMode(id, $jkRzp.GridRowModes.View);
        updateRowInRowModesModel(id, (0, $c726e745e154c244$var$_extends2.default)({
            mode: $jkRzp.GridRowModes.Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $c726e745e154c244$var$_useEventCallback.default)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const row = apiRef.current.getRow(id);
        const columns = (0, $jQEEt.gridColumnDefinitionsSelector)(apiRef);
        const newProps = columns.reduce((acc, col)=>{
            const field = col.field;
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            const column = apiRef.current.getColumn(field);
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) {
                if (deleteValue) newValue = (0, $a4Ou4.getDefaultCellValue)(column);
                else if (initialValue) newValue = initialValue;
            }
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: column.editable && !!column.preProcessEditCellProps && deleteValue
            };
            return acc;
        }, {});
        prevRowValuesLookup.current[id] = row;
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
        columns.filter((column)=>{
            const isCellEditable = apiRef.current.getCellParams(id, column.field).isEditable;
            return isCellEditable && column.editable && !!column.preProcessEditCellProps && deleteValue;
        }).forEach((column)=>{
            const field = column.field;
            const value = apiRef.current.getCellValue(id, field);
            const newValue = deleteValue ? (0, $a4Ou4.getDefaultCellValue)(column) : initialValue ?? value;
            Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps[field],
                hasChanged: newValue !== value
            })).then((processedProps)=>{
                // Check if still in edit mode before updating
                if (apiRef.current.getRowMode(id) === $jkRzp.GridRowModes.Edit) {
                    const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
                    updateOrDeleteFieldState(id, field, (0, $c726e745e154c244$var$_extends2.default)({}, processedProps, {
                        value: editingState[id][field].value,
                        isProcessingProps: false
                    }));
                }
            });
        });
    });
    const stopRowEditMode = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id } = params, other = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(params, $c726e745e154c244$var$_excluded2);
        throwIfNotInMode(id, $jkRzp.GridRowModes.Edit);
        updateRowInRowModesModel(id, (0, $c726e745e154c244$var$_extends2.default)({
            mode: $jkRzp.GridRowModes.View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $c726e745e154c244$var$_useEventCallback.default)(async (params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
            delete prevRowValuesLookup.current[id];
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        const row = prevRowValuesLookup.current[id];
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = $jkRzp.GridRowModes.Edit;
            return;
        }
        if (hasFieldsWithErrors(id)) {
            prevRowModesModel.current[id].mode = $jkRzp.GridRowModes.Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: $jkRzp.GridRowModes.Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (props.dataSource?.updateRow) {
            if ((0, $e9lLm.isDeepEqual)(row, rowUpdate)) {
                finishRowEditMode();
                return;
            }
            const handleError = ()=>{
                prevRowModesModel.current[id].mode = $jkRzp.GridRowModes.Edit;
                // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: $jkRzp.GridRowModes.Edit
                });
            };
            const updateRowParams = {
                rowId: id,
                updatedRow: rowUpdate,
                previousRow: row
            };
            try {
                await apiRef.current.dataSource.editRow(updateRowParams);
                finishRowEditMode();
            } catch  {
                handleError();
            }
        } else if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                // The row might have been deleted
                if (prevRowModesModel.current[id]) {
                    prevRowModesModel.current[id].mode = $jkRzp.GridRowModes.Edit;
                    // Revert the mode in the rowModesModel prop back to "edit"
                    updateRowInRowModesModel(id, {
                        mode: $jkRzp.GridRowModes.Edit
                    });
                }
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else (0, $9Y8Cp.warnOnce)([
                    'MUI X: A call to `processRowUpdate()` threw an error which was not handled because `onProcessRowUpdateError()` is missing.',
                    'To handle the error pass a callback to the `onProcessRowUpdateError()` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.',
                    'For more detail, see https://mui.com/x/react-data-grid/editing/persistence/.'
                ], 'error');
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $c726e745e154c244$var$React.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        let newProps = (0, $c726e745e154c244$var$_extends2.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $c726e745e154c244$var$_extends2.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(_editingState$id, [
                    field
                ].map($c726e745e154c244$var$_toPropertyKey2.default));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === $jkRzp.GridRowModes.View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
                    processedProps = (0, $c726e745e154c244$var$_extends2.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $c726e745e154c244$var$_extends2.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $c726e745e154c244$var$_objectWithoutPropertiesLoose2.default)(_editingState$id2, [
                    thisField
                ].map($c726e745e154c244$var$_toPropertyKey2.default));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === $jkRzp.GridRowModes.View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $c726e745e154c244$var$_extends2.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === $jkRzp.GridRowModes.Edit) {
                    editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $c726e745e154c244$var$React.useCallback((id)=>{
        const editingState = (0, $5Rfo7.gridEditRowsStateSelector)(apiRef);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $c726e745e154c244$var$_extends2.default)({}, prevRowValuesLookup.current[id], row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            // Column might have been removed
            // see https://github.com/mui/mui-x/pull/16888
            if (column?.valueSetter) rowUpdate = column.valueSetter(fieldProps.value, rowUpdate, column, apiRef);
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $ivFej.useGridApiMethod)(apiRef, editingApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, editingPrivateApi, 'private');
    $c726e745e154c244$var$React.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $c726e745e154c244$var$_useEnhancedEffect.default)(()=>{
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $lR3Vo.deepClone)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        const ids = new Set([
            ...Object.keys(rowModesModel),
            ...Object.keys(copyOfPrevRowModesModel)
        ]);
        Array.from(ids).forEach((id)=>{
            const params = rowModesModel[id] ?? {
                mode: $jkRzp.GridRowModes.View
            };
            const prevMode = copyOfPrevRowModesModel[id]?.mode || $jkRzp.GridRowModes.View;
            const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
            if (params.mode === $jkRzp.GridRowModes.Edit && prevMode === $jkRzp.GridRowModes.View) updateStateToStartRowEditMode((0, $c726e745e154c244$var$_extends2.default)({
                id: originalId
            }, params));
            else if (params.mode === $jkRzp.GridRowModes.View && prevMode === $jkRzp.GridRowModes.Edit) updateStateToStopRowEditMode((0, $c726e745e154c244$var$_extends2.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};
module.exports.useGridRowEditing = $c726e745e154c244$var$useGridRowEditing;

});


parcelRegister("2MkZt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $206058c259ba36a5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $206058c259ba36a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRows = module.exports.rowsStateInitializer = void 0;

var $206058c259ba36a5$var$_extends2 = $206058c259ba36a5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $206058c259ba36a5$var$React = $206058c259ba36a5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $206058c259ba36a5$var$_useLazyRef = $206058c259ba36a5$require$_interopRequireDefault((parcelRequire("doV3C")));

var $7w6sa = parcelRequire("7w6sa");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $goCyd = parcelRequire("goCyd");

var $180lm = parcelRequire("180lm");

var $5oDOG = parcelRequire("5oDOG");

var $iVTh1 = parcelRequire("iVTh1");

var $g8PwW = parcelRequire("g8PwW");

var $aJApm = parcelRequire("aJApm");

var $iU3u2 = parcelRequire("iU3u2");

var $k278Q = parcelRequire("k278Q");

var $7sDf4 = parcelRequire("7sDf4");

var $2hRnp = parcelRequire("2hRnp");

var $5ErGu = parcelRequire("5ErGu");

var $3ULRg = parcelRequire("3ULRg");
const $206058c259ba36a5$var$rowsStateInitializer = (state, props, apiRef)=>{
    const isDataSourceAvailable = !!props.dataSource;
    apiRef.current.caches.rows = (0, $7sDf4.createRowsInternalCache)({
        rows: isDataSourceAvailable ? [] : props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $206058c259ba36a5$var$_extends2.default)({}, state, {
        rows: (0, $7sDf4.getRowsStateFromCache)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: isDataSourceAvailable ? true : props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
module.exports.rowsStateInitializer = $206058c259ba36a5$var$rowsStateInitializer;
const $206058c259ba36a5$var$useGridRows = (apiRef, props, configuration)=>{
    var error;
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridRows');
    const lastUpdateMs = $206058c259ba36a5$var$React.useRef(Date.now());
    const lastRowCount = $206058c259ba36a5$var$React.useRef(props.rowCount);
    const timeout = (0, $5oDOG.useTimeout)();
    // Get overridable methods from configuration
    const { setRowIndex: setRowIndex, setRowPosition: setRowPosition } = configuration.hooks.useGridRowsOverridableMethods(apiRef, props);
    const getRow = $206058c259ba36a5$var$React.useCallback((id)=>{
        const model = (0, $goCyd.gridRowsLookupSelector)(apiRef)[id];
        if (model) return model;
        const node = (0, $goCyd.gridRowNodeSelector)(apiRef, id);
        if (node && (0, $7sDf4.isAutogeneratedRowNode)(node)) return {
            [$7sDf4.GRID_ID_AUTOGENERATED]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowId = $206058c259ba36a5$var$React.useCallback((row)=>(0, $180lm.gridRowIdSelector)(apiRef, row), [
        apiRef
    ]);
    const throttledRowsChange = $206058c259ba36a5$var$React.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                    rows: (0, $7sDf4.getRowsStateFromCache)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $goCyd.gridRowTreeSelector)(apiRef),
                        previousTreeDepths: (0, $goCyd.gridRowTreeDepthsSelector)(apiRef),
                        previousGroupsToFetch: (0, $goCyd.gridRowGroupsToFetchSelector)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $206058c259ba36a5$var$React.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        if (!props.dataSource && (0, $3ULRg.gridPivotActiveSelector)(apiRef)) {
            apiRef.current.updateNonPivotRows(rows, false);
            return;
        }
        const cache = (0, $7sDf4.createRowsInternalCache)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.dataSource,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $206058c259ba36a5$var$React.useCallback((updates)=>{
        if (props.signature === $iVTh1.GridSignature.DataGrid && updates.length > 1) throw new Error([
            'MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (!props.dataSource && (0, $3ULRg.gridPivotActiveSelector)(apiRef)) {
            apiRef.current.updateNonPivotRows(updates);
            return;
        }
        const nonPinnedRowsUpdates = (0, $7sDf4.computeRowsUpdates)(apiRef, updates, props.getRowId);
        const cache = (0, $7sDf4.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.dataSource,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const updateNestedRows = $206058c259ba36a5$var$React.useCallback((updates, groupKeys)=>{
        const nonPinnedRowsUpdates = (0, $7sDf4.computeRowsUpdates)(apiRef, updates, props.getRowId);
        const cache = (0, $7sDf4.updateCacheWithNewRows)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows,
            groupKeys: groupKeys ?? []
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const setLoading = $206058c259ba36a5$var$React.useCallback((loading)=>{
        logger.debug(`Setting loading to ${loading}`);
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    loading: loading
                })
            }));
        apiRef.current.caches.rows.loadingPropBeforePartialUpdates = loading;
    }, [
        apiRef,
        logger
    ]);
    const getRowModels = $206058c259ba36a5$var$React.useCallback(()=>{
        const dataRows = (0, $goCyd.gridDataRowIdsSelector)(apiRef);
        const idRowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        return new Map(dataRows.map((id)=>[
                id,
                idRowsLookup[id] ?? {}
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = $206058c259ba36a5$var$React.useCallback(()=>(0, $goCyd.gridRowCountSelector)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $206058c259ba36a5$var$React.useCallback(()=>(0, $goCyd.gridDataRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $206058c259ba36a5$var$React.useCallback((id)=>{
        const { rowIdToIndexMap: rowIdToIndexMap } = (0, $aJApm.getVisibleRows)(apiRef);
        return rowIdToIndexMap.get(id);
    }, [
        apiRef
    ]);
    const setRowChildrenExpansion = $206058c259ba36a5$var$React.useCallback((id, isExpanded)=>{
        const currentNode = (0, $goCyd.gridRowNodeSelector)(apiRef, id);
        if (!currentNode) throw new Error(`MUI X: No row with id #${id} found.`);
        if (currentNode.type !== 'group') throw new Error('MUI X: Only group nodes can be expanded or collapsed.');
        const newNode = (0, $206058c259ba36a5$var$_extends2.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    tree: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const expandAllRows = $206058c259ba36a5$var$React.useCallback(()=>{
        const tree = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $goCyd.gridRowTreeSelector)(apiRef));
        const traverse = (nodeId)=>{
            const node = tree[nodeId];
            if (node?.type === 'group') {
                tree[nodeId] = (0, $206058c259ba36a5$var$_extends2.default)({}, node, {
                    childrenExpanded: true
                });
                node.children.forEach(traverse);
            }
        };
        traverse($7sDf4.GRID_ROOT_GROUP_ID);
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowExpansionChange', tree[$7sDf4.GRID_ROOT_GROUP_ID]);
    }, [
        apiRef
    ]);
    const collapseAllRows = $206058c259ba36a5$var$React.useCallback(()=>{
        const tree = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $goCyd.gridRowTreeSelector)(apiRef));
        const traverse = (nodeId)=>{
            const node = tree[nodeId];
            if (node?.type === 'group') {
                tree[nodeId] = (0, $206058c259ba36a5$var$_extends2.default)({}, node, {
                    childrenExpanded: false
                });
                node.children.forEach(traverse);
            }
        };
        traverse($7sDf4.GRID_ROOT_GROUP_ID);
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowExpansionChange', tree[$7sDf4.GRID_ROOT_GROUP_ID]);
    }, [
        apiRef
    ]);
    const getRowNode = $206058c259ba36a5$var$React.useCallback((id)=>(0, $goCyd.gridRowNodeSelector)(apiRef, id) ?? null, [
        apiRef
    ]);
    const getRowGroupChildren = $206058c259ba36a5$var$React.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering, directChildrenOnly: directChildrenOnly = false })=>{
        const tree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $iU3u2.gridSortedRowIdsSelector)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && (directChildrenOnly ? tree[sortedRowIds[index]].depth === groupNode.depth + 1 : tree[sortedRowIds[index]].depth > groupNode.depth); index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $7sDf4.isAutogeneratedRowNode)(tree[id])) children.push(id);
            }
        } else children = (0, $7sDf4.getTreeNodeDescendants)(tree, groupId, skipAutoGeneratedRows, directChildrenOnly);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
            children = (0, $7w6sa.isObjectEmpty)(filteredRowsLookup) ? children : children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const replaceRows = $206058c259ba36a5$var$React.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === $iVTh1.GridSignature.DataGrid && newRows.length > 1) throw new Error([
            'MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $goCyd.gridRowMaximumTreeDepthSelector)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $goCyd.gridRowTreeSelector)(apiRef));
        const dataRowIdToModelLookup = (0, $206058c259ba36a5$var$_extends2.default)({}, (0, $goCyd.gridRowsLookupSelector)(apiRef));
        const rootGroup = tree[$7sDf4.GRID_ROOT_GROUP_ID];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $7sDf4.getRowIdFromRowModel)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: $7sDf4.GRID_ROOT_GROUP_ID,
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[$7sDf4.GRID_ROOT_GROUP_ID] = (0, $206058c259ba36a5$var$_extends2.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId]?.type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                    loading: props.loading,
                    totalRowCount: Math.max(props.rowCount || 0, rootGroupChildren.length),
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId,
        props.loading,
        props.rowCount
    ]);
    const rowApi = {
        getRow: getRow,
        setLoading: setLoading,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowPosition: setRowPosition,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren,
        expandAllRows: expandAllRows,
        collapseAllRows: collapseAllRows
    };
    const rowProPrivateApi = {
        updateNestedRows: updateNestedRows
    };
    /**
   * EVENTS
   */ const groupRows = $206058c259ba36a5$var$React.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $206058c259ba36a5$var$_extends2.default)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $goCyd.gridDataRowIdsSelector)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $7sDf4.createRowsInternalCache)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const previousDataSource = (0, $206058c259ba36a5$var$_useLazyRef.default)(()=>props.dataSource);
    const handleStrategyProcessorChange = $206058c259ba36a5$var$React.useCallback((methodName)=>{
        if (props.dataSource && props.dataSource !== previousDataSource.current) {
            previousDataSource.current = props.dataSource;
            return;
        }
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows,
        previousDataSource,
        props.dataSource
    ]);
    const handleStrategyActivityChange = $206058c259ba36a5$var$React.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy($5ErGu.GridStrategyGroup.RowTree) !== (0, $goCyd.gridRowGroupingNameSelector)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $206058c259ba36a5$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $goCyd.gridRowTreeSelector)(apiRef),
                treeDepths: (0, $goCyd.gridRowTreeDepthsSelector)(apiRef),
                dataRowIds: (0, $goCyd.gridDataRowIdsSelector)(apiRef),
                dataRowIdToModelLookup: (0, $goCyd.gridRowsLookupSelector)(apiRef)
            });
            return (0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $7sDf4.getTopLevelRowCount)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $2hRnp.useGridRegisterPipeApplier)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $ivFej.useGridApiMethod)(apiRef, rowApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowProApi, props.signature === $iVTh1.GridSignature.DataGrid ? 'private' : 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, rowProPrivateApi, 'private');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $206058c259ba36a5$var$React.useRef(true);
    $206058c259ba36a5$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        let isRowCountPropUpdated = false;
        if (props.rowCount !== lastRowCount.current) {
            isRowCountPropUpdated = true;
            lastRowCount.current = props.rowCount;
        }
        const currentRows = props.dataSource ? (0, $goCyd.gridDataRowsSelector)(apiRef) : props.rows;
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === currentRows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                        rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $206058c259ba36a5$var$_extends2.default)({}, state, {
                        rows: (0, $206058c259ba36a5$var$_extends2.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
            }
            if (!isRowCountPropUpdated) return;
        }
        logger.debug(`Updating all rows, new length ${currentRows?.length}`);
        throttledRowsChange({
            cache: (0, $7sDf4.createRowsInternalCache)({
                rows: currentRows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        props.dataSource,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};
module.exports.useGridRows = $206058c259ba36a5$var$useGridRows;

});

parcelRegister("5lqAx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e4389cda192db48$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowsPreProcessors = void 0;

var $3e4389cda192db48$var$_extends2 = $3e4389cda192db48$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5ErGu = parcelRequire("5ErGu");

var $7sDf4 = parcelRequire("7sDf4");
const $3e4389cda192db48$var$createFlatRowTree = (rows)=>{
    const tree = {
        [$7sDf4.GRID_ROOT_GROUP_ID]: (0, $3e4389cda192db48$var$_extends2.default)({}, (0, $7sDf4.buildRootGroup)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: $7sDf4.GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: $5ErGu.GRID_DEFAULT_STRATEGY,
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $3e4389cda192db48$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $3e4389cda192db48$var$_extends2.default)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: $7sDf4.GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[$7sDf4.GRID_ROOT_GROUP_ID];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[$7sDf4.GRID_ROOT_GROUP_ID] = (0, $3e4389cda192db48$var$_extends2.default)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: $5ErGu.GRID_DEFAULT_STRATEGY,
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $3e4389cda192db48$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $3e4389cda192db48$var$createFlatRowTree(params.updates.rows);
    return $3e4389cda192db48$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $3e4389cda192db48$var$useGridRowsPreProcessors = (apiRef)=>{
    (0, $5ErGu.useGridRegisterStrategyProcessor)(apiRef, $5ErGu.GRID_DEFAULT_STRATEGY, 'rowTreeCreation', $3e4389cda192db48$var$flatRowTreeCreationMethod);
};
module.exports.useGridRowsPreProcessors = $3e4389cda192db48$var$useGridRowsPreProcessors;

});

parcelRegister("6p8lp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4a9b8ce6e6853f0a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingRowIdError = void 0;
module.exports.useGridParamsApi = $4a9b8ce6e6853f0a$var$useGridParamsApi;

var $4a9b8ce6e6853f0a$var$React = $4a9b8ce6e6853f0a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $KtEo5 = parcelRequire("KtEo5");

var $ivFej = parcelRequire("ivFej");

var $drCmI = parcelRequire("drCmI");

var $8BltG = parcelRequire("8BltG");

var $goCyd = parcelRequire("goCyd");
class $4a9b8ce6e6853f0a$var$MissingRowIdError extends Error {
}
/**
 * @requires useGridColumns (method)
 * @requires useGridRows (method)
 * @requires useGridFocus (state)
 * @requires useGridEditing (method)
 * TODO: Impossible priority - useGridEditing also needs to be after useGridParamsApi
 * TODO: Impossible priority - useGridFocus also needs to be after useGridParamsApi
 */ module.exports.MissingRowIdError = $4a9b8ce6e6853f0a$var$MissingRowIdError;
function $4a9b8ce6e6853f0a$var$useGridParamsApi(apiRef, props, configuration) {
    const getColumnHeaderParams = $4a9b8ce6e6853f0a$var$React.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $4a9b8ce6e6853f0a$var$React.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $4a9b8ce6e6853f0a$var$MissingRowIdError(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParamsForRow = $4a9b8ce6e6853f0a$var$React.useCallback((id, field, row, { cellMode: cellMode, colDef: colDef, hasFocus: hasFocus, rowNode: rowNode, tabIndex: tabIndex, value: forcedValue, formattedValue: forcedFormattedValue })=>{
        const value = forcedValue !== undefined ? forcedValue : apiRef.current.getRowValue(row, colDef);
        const formattedValue = forcedFormattedValue !== undefined ? forcedFormattedValue : apiRef.current.getRowFormattedValue(row, colDef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: cellMode,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            value: value,
            formattedValue: formattedValue,
            isEditable: false,
            api: apiRef.current
        };
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $4a9b8ce6e6853f0a$var$React.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = (0, $goCyd.gridRowNodeSelector)(apiRef, id);
        if (!row || !rowNode) throw new $4a9b8ce6e6853f0a$var$MissingRowIdError(`No row with id #${id} found`);
        const cellFocus = (0, $drCmI.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, $drCmI.gridTabIndexCellSelector)(apiRef);
        const cellMode = apiRef.current.getCellMode(id, field);
        return apiRef.current.getCellParamsForRow(id, field, row, {
            colDef: props.listView && props.listViewColumn?.field === field ? (0, $8BltG.gridListColumnSelector)(apiRef) : apiRef.current.getColumn(field),
            rowNode: rowNode,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            cellMode: cellMode
        });
    }, [
        apiRef,
        props.listView,
        props.listViewColumn?.field
    ]);
    const getColumnHeaderElement = $4a9b8ce6e6853f0a$var$React.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridColumnHeaderElement)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $4a9b8ce6e6853f0a$var$React.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridRowElement)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $4a9b8ce6e6853f0a$var$React.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $KtEo5.getGridCellElement)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const overridableParamsMethods = configuration.hooks.useGridParamsOverridableMethods(apiRef);
    const paramsApi = {
        getCellValue: overridableParamsMethods.getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: overridableParamsMethods.getRowValue,
        getRowFormattedValue: overridableParamsMethods.getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    const paramsPrivateApi = {
        getCellParamsForRow: getCellParamsForRow
    };
    (0, $ivFej.useGridApiMethod)(apiRef, paramsApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, paramsPrivateApi, 'private');
}

});

parcelRegister("cURqP", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9674296b6d32bca5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9674296b6d32bca5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowSelection = module.exports.rowSelectionStateInitializer = void 0;

var $9674296b6d32bca5$var$_extends2 = $9674296b6d32bca5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9674296b6d32bca5$var$React = $9674296b6d32bca5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9674296b6d32bca5$var$_useEventCallback = $9674296b6d32bca5$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $iVTh1 = parcelRequire("iVTh1");

var $g8PwW = parcelRequire("g8PwW");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $5sOMZ = parcelRequire("5sOMZ");

var $goCyd = parcelRequire("goCyd");

var $av74L = parcelRequire("av74L");

var $drCmI = parcelRequire("drCmI");

var $k278Q = parcelRequire("k278Q");

var $ehhGY = parcelRequire("ehhGY");

var $jkRzp = parcelRequire("jkRzp");

var $dMF9H = parcelRequire("dMF9H");

var $aJApm = parcelRequire("aJApm");

var $jZka4 = parcelRequire("jZka4");

var $5H1vo = parcelRequire("5H1vo");

var $KtEo5 = parcelRequire("KtEo5");

var $iN63z = parcelRequire("iN63z");

var $lR3Vo = parcelRequire("lR3Vo");

var $cgG30 = parcelRequire("cgG30");

var $b2EyI = parcelRequire("b2EyI");
const $9674296b6d32bca5$var$emptyModel = {
    type: 'include',
    ids: new Set()
};
const $9674296b6d32bca5$var$rowSelectionStateInitializer = (state, props)=>(0, $9674296b6d32bca5$var$_extends2.default)({}, state, {
        rowSelection: props.rowSelection ? props.rowSelectionModel ?? $9674296b6d32bca5$var$emptyModel : $9674296b6d32bca5$var$emptyModel
    });
/**
 * @requires useGridRows (state, method) - can be after
 * @requires useGridParamsApi (method) - can be after
 * @requires useGridFocus (state) - can be after
 * @requires useGridKeyboardNavigation (`cellKeyDown` event must first be consumed by it)
 */ module.exports.rowSelectionStateInitializer = $9674296b6d32bca5$var$rowSelectionStateInitializer;
const $9674296b6d32bca5$var$useGridRowSelection = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridSelection');
    const isNestedData = (0, $5sOMZ.useGridSelector)(apiRef, $goCyd.gridRowMaximumTreeDepthSelector) > 1;
    const applyAutoSelection = props.signature !== $iVTh1.GridSignature.DataGrid && (props.rowSelectionPropagation?.parents || props.rowSelectionPropagation?.descendants) && isNestedData;
    const propRowSelectionModel = $9674296b6d32bca5$var$React.useMemo(()=>{
        return props.rowSelectionModel;
    }, [
        props.rowSelectionModel
    ]);
    const lastRowToggled = $9674296b6d32bca5$var$React.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: $av74L.gridRowSelectionStateSelector,
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = (0, $iN63z.isMultipleRowSelectionEnabled)(props);
    const expandMouseRowRangeSelection = $9674296b6d32bca5$var$React.useCallback((id)=>{
        let endId = id;
        const startId = lastRowToggled.current ?? id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    const getRowsToBeSelected = (0, $9674296b6d32bca5$var$_useEventCallback.default)(()=>{
        const rowsToBeSelected = props.pagination && props.checkboxSelectionVisibleOnly && props.paginationMode === 'client' ? (0, $b2EyI.gridPaginatedVisibleSortedGridRowIdsSelector)(apiRef) : (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
        return rowsToBeSelected;
    });
    /*
   * API METHODS
   */ const setRowSelectionModel = $9674296b6d32bca5$var$React.useCallback((model, reason)=>{
        if (props.signature === $iVTh1.GridSignature.DataGrid && !canHaveMultipleSelection && (model.type !== 'include' || model.ids.size > 1)) throw new Error([
            'MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $av74L.gridRowSelectionStateSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            // clear the reference to the last selected row if that row is not in the model anymore
            if (lastRowToggled.current !== null) {
                const isInModel = model.ids.has(lastRowToggled.current);
                if (model.type === 'include' && !isInModel || model.type === 'exclude' && isInModel) lastRowToggled.current = null;
            }
            apiRef.current.setState((state)=>(0, $9674296b6d32bca5$var$_extends2.default)({}, state, {
                    rowSelection: props.rowSelection ? model : $9674296b6d32bca5$var$emptyModel
                }), reason);
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    const isRowSelected = $9674296b6d32bca5$var$React.useCallback((id)=>{
        const selectionManager = (0, $av74L.gridRowSelectionManagerSelector)(apiRef);
        return selectionManager.has(id);
    }, [
        apiRef
    ]);
    const isRowSelectable = $9674296b6d32bca5$var$React.useCallback((id)=>{
        if (props.rowSelection === false) return false;
        // If `keepNonExistentRowsSelected` is true, we might run in a case where row selectability is checked for a row that does not exist.
        // Since that row was previously selected (otherwise it would not be checked at this point), we return true.
        if (props.keepNonExistentRowsSelected && !apiRef.current.getRow(id)) return true;
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = (0, $goCyd.gridRowNodeSelector)(apiRef, id);
        if (rowNode?.type === 'footer' || rowNode?.type === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        props.rowSelection,
        props.keepNonExistentRowsSelected,
        propIsRowSelectable
    ]);
    const getSelectedRows = $9674296b6d32bca5$var$React.useCallback(()=>(0, $av74L.gridRowSelectionIdsSelector)(apiRef), [
        apiRef
    ]);
    const selectRow = $9674296b6d32bca5$var$React.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        const tree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        lastRowToggled.current = isSelected ? id : null;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            const newSelectionModel = {
                type: 'include',
                ids: new Set()
            };
            const addRow = (rowId)=>{
                newSelectionModel.ids.add(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            }
            apiRef.current.setRowSelectionModel(newSelectionModel, 'singleRowSelection');
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selectionModel = (0, $av74L.gridRowSelectionStateSelector)(apiRef);
            const newSelectionModel = {
                type: selectionModel.type,
                ids: new Set(selectionModel.ids)
            };
            const selectionManager = (0, $cgG30.createRowSelectionManager)(newSelectionModel);
            selectionManager.unselect(id);
            const addRow = (rowId)=>{
                selectionManager.select(rowId);
            };
            const removeRow = (rowId)=>{
                selectionManager.unselect(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else if (applyAutoSelection) (0, $iN63z.findRowsToDeselect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            const isSelectionValid = newSelectionModel.type === 'include' && newSelectionModel.ids.size < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelectionModel, 'singleRowSelection');
        }
    }, [
        apiRef,
        logger,
        applyAutoSelection,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        canHaveMultipleSelection
    ]);
    const selectRows = $9674296b6d32bca5$var$React.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        if (props.rowSelection === false) return;
        const tree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        const selectableIds = new Set();
        for(let i = 0; i < ids.length; i += 1){
            const id = ids[i];
            if (apiRef.current.isRowSelectable(id)) selectableIds.add(id);
        }
        const currentSelectionModel = (0, $av74L.gridRowSelectionStateSelector)(apiRef);
        let newSelectionModel;
        if (resetSelection) {
            newSelectionModel = {
                type: 'include',
                ids: selectableIds
            };
            if (isSelected) {
                const selectionManager = (0, $cgG30.createRowSelectionManager)(newSelectionModel);
                if (applyAutoSelection) {
                    const addRow = (rowId)=>{
                        selectionManager.select(rowId);
                    };
                    for (const id of selectableIds)(0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                }
            } else newSelectionModel.ids = new Set();
            if (currentSelectionModel.type === newSelectionModel.type && newSelectionModel.ids.size === currentSelectionModel.ids.size && Array.from(newSelectionModel.ids).every((id)=>currentSelectionModel.ids.has(id))) return;
        } else {
            newSelectionModel = {
                type: currentSelectionModel.type,
                ids: new Set(currentSelectionModel.ids)
            };
            const selectionManager = (0, $cgG30.createRowSelectionManager)(newSelectionModel);
            const addRow = (rowId)=>{
                selectionManager.select(rowId);
            };
            const removeRow = (rowId)=>{
                selectionManager.unselect(rowId);
            };
            for (const id of selectableIds)if (isSelected) {
                selectionManager.select(id);
                if (applyAutoSelection) (0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else {
                removeRow(id);
                if (applyAutoSelection) (0, $iN63z.findRowsToDeselect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            }
        }
        const isSelectionValid = newSelectionModel.type === 'include' && newSelectionModel.ids.size < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelectionModel, 'multipleRowsSelection');
    }, [
        logger,
        applyAutoSelection,
        canHaveMultipleSelection,
        apiRef,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        props.rowSelection
    ]);
    const getPropagatedRowSelectionModel = $9674296b6d32bca5$var$React.useCallback((inputSelectionModel)=>{
        if (!isNestedData || !applyAutoSelection || inputSelectionModel.type === 'exclude' || inputSelectionModel.ids.size === 0 && inputSelectionModel.type === 'include') return inputSelectionModel;
        const propagatedSelectionModel = {
            type: inputSelectionModel.type,
            ids: new Set(inputSelectionModel.ids)
        };
        const tree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        const selectionManager = (0, $cgG30.createRowSelectionManager)(propagatedSelectionModel);
        const addRow = (rowId)=>{
            selectionManager.select(rowId);
        };
        for (const id of inputSelectionModel.ids)(0, $iN63z.findRowsToSelect)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow, selectionManager);
        return propagatedSelectionModel;
    }, [
        apiRef,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        isNestedData,
        applyAutoSelection
    ]);
    const selectRowRange = $9674296b6d32bca5$var$React.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $k278Q.gridExpandedSortedRowIdsSelector)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange,
        getPropagatedRowSelectionModel: getPropagatedRowSelectionModel
    };
    (0, $ivFej.useGridApiMethod)(apiRef, selectionPublicApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, selectionPrivateApi, props.signature === $iVTh1.GridSignature.DataGrid ? 'private' : 'public');
    /*
   * EVENTS
   */ const isFirstRender = $9674296b6d32bca5$var$React.useRef(true);
    const removeOutdatedSelection = $9674296b6d32bca5$var$React.useCallback(()=>{
        if (isFirstRender.current) return;
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef);
        const rowsLookup = (0, $goCyd.gridRowsLookupSelector)(apiRef);
        const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
        const filteredRowsLookup = (0, $k278Q.gridFilteredRowsLookupSelector)(apiRef);
        const isNonExistent = (id)=>{
            if (props.filterMode === 'server') return !rowsLookup[id];
            return !rowTree[id] || filteredRowsLookup[id] === false;
        };
        const newSelectionModel = {
            type: currentSelection.type,
            ids: new Set(currentSelection.ids)
        };
        const selectionManager = (0, $cgG30.createRowSelectionManager)(newSelectionModel);
        let hasChanged = false;
        for (const id of currentSelection.ids){
            if (isNonExistent(id)) {
                if (props.keepNonExistentRowsSelected) continue;
                selectionManager.unselect(id);
                hasChanged = true;
                continue;
            }
            if (!props.rowSelectionPropagation?.parents) continue;
            const node = rowTree[id];
            if (node?.type === 'group') {
                const isAutoGenerated = node.isAutoGenerated;
                if (isAutoGenerated) {
                    selectionManager.unselect(id);
                    hasChanged = true;
                    continue;
                }
                // Keep previously selected tree data parents selected if all their children are filtered out
                if (!node.children.every((childId)=>filteredRowsLookup[childId] === false)) {
                    selectionManager.unselect(id);
                    hasChanged = true;
                }
            }
        }
        // For nested data, on row tree updation (filtering, adding rows, etc.) when the selection is
        // not empty, we need to re-run scanning of the tree to propagate the selection changes
        // Example: A parent whose de-selected children are filtered out should now be selected
        const shouldReapplyPropagation = isNestedData && props.rowSelectionPropagation?.parents && (newSelectionModel.ids.size > 0 || // In case of exclude selection, newSelectionModel.ids.size === 0 means all rows are selected
        newSelectionModel.type === 'exclude');
        if (hasChanged || shouldReapplyPropagation) {
            if (shouldReapplyPropagation) {
                if (newSelectionModel.type === 'exclude') {
                    const unfilteredSelectedRowIds = getRowsToBeSelected();
                    const selectedRowIds = [];
                    for(let i = 0; i < unfilteredSelectedRowIds.length; i += 1){
                        const rowId = unfilteredSelectedRowIds[i];
                        if ((props.keepNonExistentRowsSelected || !isNonExistent(rowId)) && selectionManager.has(rowId)) selectedRowIds.push(rowId);
                    }
                    apiRef.current.selectRows(selectedRowIds, true, true);
                } else apiRef.current.selectRows(Array.from(newSelectionModel.ids), true, true);
            } else apiRef.current.setRowSelectionModel(newSelectionModel, 'multipleRowsSelection');
        }
    }, [
        apiRef,
        isNestedData,
        props.rowSelectionPropagation?.parents,
        props.keepNonExistentRowsSelected,
        props.filterMode,
        getRowsToBeSelected
    ]);
    const handleSingleRowSelection = $9674296b6d32bca5$var$React.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $dMF9H.isKeyboardEvent)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        const selectedRowsCount = (0, $av74L.gridRowSelectionCountSelector)(apiRef);
        // Clicking on a row should toggle the selection except when a range of rows is already selected and the selection should reset
        // In that case, we want to keep the current row selected (https://github.com/mui/mui-x/pull/15509#discussion_r1878082687)
        const shouldStaySelected = selectedRowsCount > 1 && resetSelection;
        const newSelectionState = shouldStaySelected || !isSelected;
        apiRef.current.selectRow(id, newSelectionState, resetSelection);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        if (disableRowSelectionOnClick) return;
        const field = event.target.closest(`.${$5H1vo.gridClasses.cell}`)?.getAttribute('data-field');
        if (field === $ehhGY.GRID_CHECKBOX_SELECTION_COL_DEF.field) // click on checkbox should not trigger row selection
        return;
        if (field === $jZka4.GRID_DETAIL_PANEL_TOGGLE_FIELD) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column?.type === $ehhGY.GRID_ACTIONS_COLUMN_TYPE) return;
        }
        const rowNode = (0, $goCyd.gridRowNodeSelector)(apiRef, params.id);
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && canHaveMultipleSelection) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) window.getSelection()?.removeAllRanges();
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    const toggleAllRows = $9674296b6d32bca5$var$React.useCallback((value)=>{
        const filterModel = (0, $k278Q.gridFilterModelSelector)(apiRef);
        const quickFilterModel = (0, $k278Q.gridQuickFilterValuesSelector)(apiRef);
        const hasFilters = filterModel.items.length > 0 || quickFilterModel?.some((val)=>val.length);
        if (!props.isRowSelectable && !props.checkboxSelectionVisibleOnly && (!isNestedData || props.rowSelectionPropagation?.descendants) && !hasFilters && !props.disableRowSelectionExcludeModel) apiRef.current.setRowSelectionModel({
            type: value ? 'exclude' : 'include',
            ids: new Set()
        }, 'multipleRowsSelection');
        else apiRef.current.selectRows(getRowsToBeSelected(), value);
    }, [
        apiRef,
        getRowsToBeSelected,
        props.checkboxSelectionVisibleOnly,
        props.isRowSelectable,
        props.rowSelectionPropagation?.descendants,
        props.disableRowSelectionExcludeModel,
        isNestedData
    ]);
    const handleHeaderSelectionCheckboxChange = $9674296b6d32bca5$var$React.useCallback((params)=>{
        toggleAllRows(params.value);
    }, [
        toggleAllRows
    ]);
    const handleCellKeyDown = $9674296b6d32bca5$var$React.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === $jkRzp.GridCellModes.Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
        if ((0, $dMF9H.isNavigationKey)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $drCmI.gridFocusCellSelector)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const visibleRows = (0, $aJApm.getVisibleRows)(apiRef);
                const rowsBetweenStartAndEnd = [];
                for(let i = start; i <= end; i += 1)rowsBetweenStartAndEnd.push(visibleRows.rows[i].id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (String.fromCharCode(event.keyCode) === 'A' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            if (canHaveMultipleSelection) toggleAllRows(true);
        }
    }, [
        apiRef,
        canHaveMultipleSelection,
        handleSingleRowSelection,
        toggleAllRows
    ]);
    const syncControlledState = (0, $9674296b6d32bca5$var$_useEventCallback.default)(()=>{
        if (!props.rowSelection) {
            apiRef.current.setRowSelectionModel($9674296b6d32bca5$var$emptyModel);
            return;
        }
        if (propRowSelectionModel === undefined) return;
        if (!applyAutoSelection || !isNestedData || propRowSelectionModel.type === 'include' && propRowSelectionModel.ids.size === 0) {
            apiRef.current.setRowSelectionModel(propRowSelectionModel);
            return;
        }
        const newSelectionModel = apiRef.current.getPropagatedRowSelectionModel(propRowSelectionModel);
        if (newSelectionModel.type !== propRowSelectionModel.type || newSelectionModel.ids.size !== propRowSelectionModel.ids.size || !Array.from(propRowSelectionModel.ids).every((id)=>newSelectionModel.ids.has(id))) {
            apiRef.current.setRowSelectionModel(newSelectionModel);
            return;
        }
        apiRef.current.setRowSelectionModel(propRowSelectionModel);
    });
    (0, $g8PwW.useGridEvent)(apiRef, 'filteredRowsSet', (0, $lR3Vo.runIf)(props.rowSelection, removeOutdatedSelection));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowClick', (0, $lR3Vo.runIf)(props.rowSelection, handleRowClick));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowSelectionCheckboxChange', (0, $lR3Vo.runIf)(props.rowSelection, handleRowSelectionCheckboxChange));
    (0, $g8PwW.useGridEvent)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'cellMouseDown', (0, $lR3Vo.runIf)(props.rowSelection, preventSelectionOnShift));
    (0, $g8PwW.useGridEvent)(apiRef, 'cellKeyDown', (0, $lR3Vo.runIf)(props.rowSelection, handleCellKeyDown));
    /*
   * EFFECTS
   */ $9674296b6d32bca5$var$React.useEffect(()=>{
        syncControlledState();
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection,
        syncControlledState
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $9674296b6d32bca5$var$React.useEffect(()=>{
        if (isStateControlled || !props.rowSelection || typeof isRowSelectable !== 'function') return;
        // props.isRowSelectable changed
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef);
        if (currentSelection.type !== 'include') return;
        const selectableIds = new Set();
        for (const id of currentSelection.ids)if (isRowSelectable(id)) selectableIds.add(id);
        if (selectableIds.size < currentSelection.ids.size) apiRef.current.setRowSelectionModel({
            type: currentSelection.type,
            ids: selectableIds
        });
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $9674296b6d32bca5$var$React.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $av74L.gridRowSelectionStateSelector)(apiRef);
        if (!canHaveMultipleSelection && (currentSelection.type === 'include' && currentSelection.ids.size > 1 || currentSelection.type === 'exclude')) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel($9674296b6d32bca5$var$emptyModel);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
    $9674296b6d32bca5$var$React.useEffect(()=>{
        (0, $lR3Vo.runIf)(props.rowSelection, removeOutdatedSelection);
    }, [
        props.rowSelection,
        removeOutdatedSelection
    ]);
    $9674296b6d32bca5$var$React.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
    }, []);
};
module.exports.useGridRowSelection = $9674296b6d32bca5$var$useGridRowSelection;

});

parcelRegister("5WmMt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $45340a55c38c89d7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $45340a55c38c89d7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowSelectionPreProcessors = void 0;

var $45340a55c38c89d7$var$_extends2 = $45340a55c38c89d7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $45340a55c38c89d7$var$React = $45340a55c38c89d7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $45340a55c38c89d7$var$_composeClasses = $45340a55c38c89d7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2hRnp = parcelRequire("2hRnp");

var $7jHEF = parcelRequire("7jHEF");

var $ehhGY = parcelRequire("ehhGY");
const $45340a55c38c89d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $45340a55c38c89d7$var$React.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $45340a55c38c89d7$var$_composeClasses.default)(slots, $7jHEF.getDataGridUtilityClass, classes);
    }, [
        classes
    ]);
};
const $45340a55c38c89d7$var$useGridRowSelectionPreProcessors = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $45340a55c38c89d7$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $45340a55c38c89d7$var$React.useCallback((columnsState)=>{
        const selectionColumn = (0, $45340a55c38c89d7$var$_extends2.default)({}, $ehhGY.GRID_CHECKBOX_SELECTION_COL_DEF, {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const hasSelectionColumn = columnsState.lookup[$ehhGY.GRID_CHECKBOX_SELECTION_FIELD] != null;
        if (shouldHaveSelectionColumn && !hasSelectionColumn) {
            columnsState.lookup[$ehhGY.GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
            columnsState.orderedFields = [
                $ehhGY.GRID_CHECKBOX_SELECTION_FIELD,
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && hasSelectionColumn) {
            delete columnsState.lookup[$ehhGY.GRID_CHECKBOX_SELECTION_FIELD];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== $ehhGY.GRID_CHECKBOX_SELECTION_FIELD);
        } else if (shouldHaveSelectionColumn && hasSelectionColumn) {
            columnsState.lookup[$ehhGY.GRID_CHECKBOX_SELECTION_FIELD] = (0, $45340a55c38c89d7$var$_extends2.default)({}, selectionColumn, columnsState.lookup[$ehhGY.GRID_CHECKBOX_SELECTION_FIELD]);
            // If the column is not in the columns array (not a custom selection column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === $ehhGY.GRID_CHECKBOX_SELECTION_FIELD)) columnsState.orderedFields = [
                $ehhGY.GRID_CHECKBOX_SELECTION_FIELD,
                ...columnsState.orderedFields.filter((field)=>field !== $ehhGY.GRID_CHECKBOX_SELECTION_FIELD)
            ];
        }
        return columnsState;
    }, [
        apiRef,
        classes,
        props.columns,
        props.checkboxSelection
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'hydrateColumns', updateSelectionColumn);
};
module.exports.useGridRowSelectionPreProcessors = $45340a55c38c89d7$var$useGridRowSelectionPreProcessors;

});

parcelRegister("jOu9i", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e6ca12cabeac117a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e6ca12cabeac117a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridSorting = module.exports.sortingStateInitializer = void 0;

var $e6ca12cabeac117a$var$_extends2 = $e6ca12cabeac117a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e6ca12cabeac117a$var$React = $e6ca12cabeac117a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e6ca12cabeac117a$var$_useEnhancedEffect = $e6ca12cabeac117a$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $g8PwW = parcelRequire("g8PwW");

var $ivFej = parcelRequire("ivFej");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $iU3u2 = parcelRequire("iU3u2");

var $eFlT8 = parcelRequire("eFlT8");

var $bc8LN = parcelRequire("bc8LN");

var $5ErGu = parcelRequire("5ErGu");

var $h8fXG = parcelRequire("h8fXG");

var $2hRnp = parcelRequire("2hRnp");

var $7sDf4 = parcelRequire("7sDf4");
const $e6ca12cabeac117a$var$sortingStateInitializer = (state, props)=>{
    const sortModel = props.sortModel ?? props.initialState?.sorting?.sortModel ?? [];
    return (0, $e6ca12cabeac117a$var$_extends2.default)({}, state, {
        sorting: {
            sortModel: (0, $h8fXG.sanitizeSortModel)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
/**
 * @requires useGridRows (event)
 * @requires useGridColumns (event)
 */ module.exports.sortingStateInitializer = $e6ca12cabeac117a$var$sortingStateInitializer;
const $e6ca12cabeac117a$var$useGridSorting = (apiRef, props)=>{
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: $iU3u2.gridSortModelSelector,
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $e6ca12cabeac117a$var$React.useCallback((field, sortItem)=>{
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (sortItem?.sort == null) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $e6ca12cabeac117a$var$React.useCallback((col, directionOverride)=>{
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            const nextSort = directionOverride === undefined ? (0, $h8fXG.getNextGridSortDirection)(col.sortingOrder ?? props.sortingOrder, existing.sort) : directionOverride;
            return nextSort === undefined ? undefined : (0, $e6ca12cabeac117a$var$_extends2.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $h8fXG.getNextGridSortDirection)(col.sortingOrder ?? props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $e6ca12cabeac117a$var$React.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false || props.disableColumnSorting) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder,
        props.disableColumnSorting
    ]);
    /**
   * API METHODS
   */ const applySorting = $e6ca12cabeac117a$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $e6ca12cabeac117a$var$_extends2.default)({}, state, {
                    sorting: (0, $e6ca12cabeac117a$var$_extends2.default)({}, state.sorting, {
                        sortedRows: (0, $7sDf4.getTreeNodeDescendants)((0, $eFlT8.gridRowTreeSelector)(apiRef), $eFlT8.GRID_ROOT_GROUP_ID, false)
                    })
                });
            }
            const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
            const sortRowList = (0, $h8fXG.buildAggregatedSortingApplier)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $e6ca12cabeac117a$var$_extends2.default)({}, state, {
                sorting: (0, $e6ca12cabeac117a$var$_extends2.default)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $e6ca12cabeac117a$var$React.useCallback((model)=>{
        const currentModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $h8fXG.mergeStateWithSortModel)(model, props.disableMultipleColumnsSorting));
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $e6ca12cabeac117a$var$React.useCallback((field, direction, allowMultipleSorting)=>{
        const column = apiRef.current.getColumn(field);
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = sortItem?.sort == null ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $e6ca12cabeac117a$var$React.useCallback(()=>(0, $iU3u2.gridSortModelSelector)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $e6ca12cabeac117a$var$React.useCallback(()=>{
        const sortedRows = (0, $iU3u2.gridSortedRowEntriesSelector)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $e6ca12cabeac117a$var$React.useCallback(()=>(0, $iU3u2.gridSortedRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $e6ca12cabeac117a$var$React.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $ivFej.useGridApiMethod)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $e6ca12cabeac117a$var$React.useCallback((prevState, context)=>{
        const sortModelToExport = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        props.initialState?.sorting?.sortModel != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $e6ca12cabeac117a$var$_extends2.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        props.initialState?.sorting?.sortModel
    ]);
    const stateRestorePreProcessing = $e6ca12cabeac117a$var$React.useCallback((params, context)=>{
        const sortModel = context.stateToRestore.sorting?.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $h8fXG.mergeStateWithSortModel)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $e6ca12cabeac117a$var$_extends2.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $e6ca12cabeac117a$var$React.useCallback((params)=>{
        const rowTree = (0, $eFlT8.gridRowTreeSelector)(apiRef);
        const rootGroupNode = rowTree[$eFlT8.GRID_ROOT_GROUP_ID];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $5ErGu.useGridRegisterStrategyProcessor)(apiRef, $5ErGu.GRID_DEFAULT_STRATEGY, 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $e6ca12cabeac117a$var$React.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        const allowMultipleSorting = props.multipleColumnsSortingMode === 'always' || event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(field, undefined, allowMultipleSorting);
    }, [
        sortColumn,
        props.disableColumnSorting,
        props.multipleColumnsSortingMode
    ]);
    const handleColumnHeaderKeyDown = $e6ca12cabeac117a$var$React.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        // Ctrl + Enter opens the column menu
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) sortColumn(field, undefined, props.multipleColumnsSortingMode === 'always' || event.shiftKey);
    }, [
        sortColumn,
        props.disableColumnSorting,
        props.multipleColumnsSortingMode
    ]);
    const handleColumnsChange = $e6ca12cabeac117a$var$React.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $iU3u2.gridSortModelSelector)(apiRef);
        const latestColumns = (0, $jQEEt.gridColumnLookupSelector)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $e6ca12cabeac117a$var$React.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $2hRnp.useGridRegisterPipeProcessor)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $g8PwW.useGridEvent)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $bc8LN.useFirstRender)(()=>{
        if (props.signature === 'DataGrid') apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $e6ca12cabeac117a$var$_useEnhancedEffect.default)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};
module.exports.useGridSorting = $e6ca12cabeac117a$var$useGridSorting;

});

parcelRegister("gaDPW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bc5c7b440a851fd1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridScroll = void 0;

var $bc5c7b440a851fd1$var$React = $bc5c7b440a851fd1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $luu6e = parcelRequire("luu6e");

var $jQEEt = parcelRequire("jQEEt");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");

var $bdqIg = parcelRequire("bdqIg");

var $ivFej = parcelRequire("ivFej");

var $k278Q = parcelRequire("k278Q");

var $iGtHu = parcelRequire("iGtHu");
// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $bc5c7b440a851fd1$var$scrollIntoView(dimensions) {
    const { containerSize: containerSize, scrollPosition: scrollPosition, elementSize: elementSize, elementOffset: elementOffset } = dimensions;
    const elementEnd = elementOffset + elementSize;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (elementSize > containerSize) return elementOffset;
    if (elementEnd - containerSize > scrollPosition) return elementEnd - containerSize;
    if (elementOffset < scrollPosition) return elementOffset;
    return undefined;
}
/**
 * @requires useGridPagination (state) - can be after, async only
 * @requires useGridColumns (state) - can be after, async only
 * @requires useGridRows (state) - can be after, async only
 * @requires useGridRowsMeta (state) - can be after, async only
 * @requires useGridFilter (state)
 * @requires useGridColumnSpanning (method)
 */ const $bc5c7b440a851fd1$var$useGridScroll = (apiRef, props)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const logger = (0, $luu6e.useGridLogger)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersContainerRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const scrollToIndexes = $bc5c7b440a851fd1$var$React.useCallback((params)=>{
        const dimensions = (0, $iGtHu.gridDimensionsSelector)(apiRef);
        const totalRowCount = (0, $goCyd.gridRowCountSelector)(apiRef);
        const visibleColumns = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex !== undefined && visibleColumns[params.colIndex]) {
            const columnPositions = (0, $jQEEt.gridColumnPositionsSelector)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                const visibleSortedRows = (0, $k278Q.gridExpandedSortedRowEntriesSelector)(apiRef);
                const rowId = visibleSortedRows[params.rowIndex]?.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $bc5c7b440a851fd1$var$scrollIntoView({
                containerSize: dimensions.viewportOuterSize.width,
                scrollPosition: Math.abs(virtualScrollerRef.current?.scrollLeft ?? 0),
                elementSize: cellWidth,
                elementOffset: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex !== undefined) {
            const rowsMeta = (0, $bdqIg.gridRowsMetaSelector)(apiRef);
            const page = (0, $gPWuj.gridPageSelector)(apiRef);
            const pageSize = (0, $gPWuj.gridPageSizeSelector)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            scrollCoordinates.top = $bc5c7b440a851fd1$var$scrollIntoView({
                containerSize: dimensions.viewportInnerSize.height,
                scrollPosition: virtualScrollerRef.current?.scrollTop ?? 0,
                elementSize: targetOffsetHeight,
                elementOffset: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        if (typeof scrollCoordinates.left !== 'undefined' || typeof scrollCoordinates.top !== 'undefined') {
            apiRef.current.scroll(scrollCoordinates);
            return true;
        }
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination
    ]);
    const scroll = $bc5c7b440a851fd1$var$React.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left !== undefined && colRef.current) {
            const direction = isRtl ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top !== undefined) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        isRtl,
        colRef,
        logger
    ]);
    const getScrollPosition = $bc5c7b440a851fd1$var$React.useCallback(()=>{
        if (!virtualScrollerRef?.current) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $ivFej.useGridApiMethod)(apiRef, scrollApi, 'public');
};
module.exports.useGridScroll = $bc5c7b440a851fd1$var$useGridScroll;

});

parcelRegister("2oqux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridEvents = $1be25f585207520f$var$useGridEvents;

var $g8PwW = parcelRequire("g8PwW");
/**
 * @requires useGridFocus (event) - can be after, async only
 * @requires useGridColumns (event) - can be after, async only
 */ function $1be25f585207520f$var$useGridEvents(apiRef, props) {
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderContextMenu', props.onColumnHeaderContextMenu);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'cellClick', props.onCellClick);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'menuClose', props.onMenuClose);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'rowClick', props.onRowClick);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'stateChange', props.onStateChange);
}

});

parcelRegister("Anab1", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $06d554a00cf6d24e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $06d554a00cf6d24e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dimensionsStateInitializer = void 0;
module.exports.useGridDimensions = $06d554a00cf6d24e$var$useGridDimensions;

var $06d554a00cf6d24e$var$_extends2 = $06d554a00cf6d24e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $06d554a00cf6d24e$var$React = $06d554a00cf6d24e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8P0MD = parcelRequire("8P0MD");

var $g8PwW = parcelRequire("g8PwW");

var $ivFej = parcelRequire("ivFej");

var $cgQ4y = parcelRequire("cgQ4y");


var $jy68d = parcelRequire("jy68d");

var $61HyH = parcelRequire("61HyH");

var $h181e = parcelRequire("h181e");

var $7sDf4 = parcelRequire("7sDf4");

var $i0LyH = parcelRequire("i0LyH");

var $1kYRD = parcelRequire("1kYRD");

var $af8j6 = parcelRequire("af8j6");

const $06d554a00cf6d24e$var$EMPTY_SIZE = {
    width: 0,
    height: 0
};
const $06d554a00cf6d24e$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $06d554a00cf6d24e$var$EMPTY_SIZE,
    viewportOuterSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    viewportInnerSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    contentSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    minimumSize: $06d554a00cf6d24e$var$EMPTY_SIZE,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    headerHeight: 0,
    groupHeaderHeight: 0,
    headerFilterHeight: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    headersTotalHeight: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0,
    autoHeight: false,
    minimalContentHeight: undefined
};
const $06d554a00cf6d24e$var$dimensionsStateInitializer = (state, props, apiRef)=>{
    const dimensions = $06d554a00cf6d24e$var$EMPTY_DIMENSIONS;
    const density = (0, $h181e.gridDensityFactorSelector)(apiRef);
    const dimensionsWithStatic = (0, $06d554a00cf6d24e$var$_extends2.default)({}, dimensions, $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, density, (0, $jy68d.gridVisiblePinnedColumnDefinitionsSelector)(apiRef)));
    apiRef.current.store.state.dimensions = dimensionsWithStatic;
    return (0, $06d554a00cf6d24e$var$_extends2.default)({}, state, {
        dimensions: dimensionsWithStatic
    });
};
module.exports.dimensionsStateInitializer = $06d554a00cf6d24e$var$dimensionsStateInitializer;
const $06d554a00cf6d24e$var$columnsTotalWidthSelector = (0, $cgQ4y.createSelector)($jy68d.gridVisibleColumnDefinitionsSelector, $jy68d.gridColumnPositionsSelector, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $af8j6.roundToDecimalPlaces)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
function $06d554a00cf6d24e$var$useGridDimensions(apiRef, props) {
    const getRootDimensions = $06d554a00cf6d24e$var$React.useCallback(()=>(0, $61HyH.gridDimensionsSelector)(apiRef), [
        apiRef
    ]);
    const apiPublic = {
        getRootDimensions: getRootDimensions
    };
    const apiPrivate = {
        updateDimensions: ()=>{
            return apiRef.current.virtualizer.api.updateDimensions();
        },
        getViewportPageSize: ()=>{
            return apiRef.current.virtualizer.api.getViewportPageSize();
        }
    };
    (0, $ivFej.useGridApiMethod)(apiRef, apiPublic, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, apiPrivate, 'private');
    const handleRootMount = (root)=>{
        $06d554a00cf6d24e$var$setCSSVariables(root, (0, $61HyH.gridDimensionsSelector)(apiRef));
    };
    (0, $g8PwW.useGridEventPriority)(apiRef, 'rootMount', handleRootMount);
    (0, $g8PwW.useGridEventPriority)(apiRef, 'debouncedResize', props.onResize);
    var size;
    (0, $8P0MD.useStoreEffect)(apiRef.current.store, (s)=>s.dimensions, (previous, next)=>{
        if (!next.isReady) return;
        if (apiRef.current.rootElementRef.current) $06d554a00cf6d24e$var$setCSSVariables(apiRef.current.rootElementRef.current, next);
        if (!$06d554a00cf6d24e$var$areElementSizesEqual(next.viewportInnerSize, previous.viewportInnerSize)) apiRef.current.publishEvent('viewportInnerSizeChange', next.viewportInnerSize);
        apiRef.current.publishEvent('debouncedResize', next.root);
    });
}
function $06d554a00cf6d24e$var$setCSSVariables(root, dimensions) {
    const set = (k, v)=>root.style.setProperty(k, v);
    set('--DataGrid-hasScrollX', `${Number(dimensions.hasScrollX)}`);
    set('--DataGrid-hasScrollY', `${Number(dimensions.hasScrollY)}`);
    set('--DataGrid-scrollbarSize', `${dimensions.scrollbarSize}px`);
    set('--DataGrid-rowWidth', `${dimensions.rowWidth}px`);
    set('--DataGrid-columnsTotalWidth', `${dimensions.columnsTotalWidth}px`);
    set('--DataGrid-leftPinnedWidth', `${dimensions.leftPinnedWidth}px`);
    set('--DataGrid-rightPinnedWidth', `${dimensions.rightPinnedWidth}px`);
    set('--DataGrid-headerHeight', `${dimensions.headerHeight}px`);
    set('--DataGrid-headersTotalHeight', `${dimensions.headersTotalHeight}px`);
    set('--DataGrid-topContainerHeight', `${dimensions.topContainerHeight}px`);
    set('--DataGrid-bottomContainerHeight', `${dimensions.bottomContainerHeight}px`);
    set('--height', `${dimensions.rowHeight}px`);
}
function $06d554a00cf6d24e$var$getStaticDimensions(props, apiRef, density, pinnedColumnns) {
    const validRowHeight = (0, $7sDf4.getValidRowHeight)(props.rowHeight, $1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, $7sDf4.rowHeightWarning);
    return {
        rowHeight: Math.floor(validRowHeight * density),
        headerHeight: Math.floor(props.columnHeaderHeight * density),
        groupHeaderHeight: Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * density),
        headerFilterHeight: Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * density),
        columnsTotalWidth: $06d554a00cf6d24e$var$columnsTotalWidthSelector(apiRef),
        headersTotalHeight: (0, $i0LyH.getTotalHeaderHeight)(apiRef, props),
        leftPinnedWidth: pinnedColumnns.left.reduce((w, col)=>w + col.computedWidth, 0),
        rightPinnedWidth: pinnedColumnns.right.reduce((w, col)=>w + col.computedWidth, 0)
    };
}
function $06d554a00cf6d24e$var$areElementSizesEqual(a, b) {
    return a.width === b.width && a.height === b.height;
}

});
parcelRegister("af8j6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "roundToDecimalPlaces", {
    enumerable: true,
    get: function() {
        return $fCm8e.roundToDecimalPlaces;
    }
});

var $fCm8e = parcelRequire("fCm8e");

});


parcelRegister("lb6pq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f6af98c761dea48b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridStatePersistence = void 0;

var $f6af98c761dea48b$var$React = $f6af98c761dea48b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5LeoO = parcelRequire("5LeoO");
const $f6af98c761dea48b$var$useGridStatePersistence = (apiRef)=>{
    const exportState = $f6af98c761dea48b$var$React.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $f6af98c761dea48b$var$React.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $5LeoO.useGridApiMethod)(apiRef, statePersistenceApi, 'public');
};
module.exports.useGridStatePersistence = $f6af98c761dea48b$var$useGridStatePersistence;

});

parcelRegister("2H9Fl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridColumnSpanning = void 0;

var $ivFej = parcelRequire("ivFej");

var $g8PwW = parcelRequire("g8PwW");
/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */ const $1f67185743ff4f77$var$useGridColumnSpanning = (apiRef)=>{
    const resetColSpan = ()=>{
        return apiRef.current.virtualizer.api.resetColSpan();
    };
    const getCellColSpanInfo = (...params)=>{
        return apiRef.current.virtualizer.api.getCellColSpanInfo(...params);
    };
    const calculateColSpan = (...params)=>{
        apiRef.current.virtualizer.api.calculateColSpan(...params);
    };
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        resetColSpan: resetColSpan,
        calculateColSpan: calculateColSpan
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnSpanningPublicApi, 'public');
    (0, $ivFej.useGridApiMethod)(apiRef, columnSpanningPrivateApi, 'private');
    (0, $g8PwW.useGridEvent)(apiRef, 'columnOrderChange', resetColSpan);
};
module.exports.useGridColumnSpanning = $1f67185743ff4f77$var$useGridColumnSpanning;

});

parcelRegister("aFlgz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $7c3e3abbe30f48e1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7c3e3abbe30f48e1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridColumnGrouping = module.exports.columnGroupsStateInitializer = void 0;

var $7c3e3abbe30f48e1$var$_extends2 = $7c3e3abbe30f48e1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7c3e3abbe30f48e1$var$React = $7c3e3abbe30f48e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $hMyIf = parcelRequire("hMyIf");

var $ivFej = parcelRequire("ivFej");

var $vzN4X = parcelRequire("vzN4X");

var $g8PwW = parcelRequire("g8PwW");

var $jy68d = parcelRequire("jy68d");
const $7c3e3abbe30f48e1$var$columnGroupsStateInitializer = (state, props, apiRef)=>{
    apiRef.current.caches.columnGrouping = {
        lastColumnGroupingModel: props.columnGroupingModel
    };
    if (!props.columnGroupingModel) return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
        columnGrouping: undefined
    });
    const columnFields = (0, $jy68d.gridColumnFieldsSelector)(apiRef);
    const visibleColumnFields = (0, $jy68d.gridVisibleColumnFieldsSelector)(apiRef);
    const groupLookup = (0, $vzN4X.createGroupLookup)(props.columnGroupingModel ?? []);
    const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(props.columnGroupingModel ?? []);
    const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, apiRef.current.state.pinnedColumns ?? {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
    return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
/**
 * @requires useGridColumns (method, event)
 * @requires useGridParamsApi (method)
 */ module.exports.columnGroupsStateInitializer = $7c3e3abbe30f48e1$var$columnGroupsStateInitializer;
const $7c3e3abbe30f48e1$var$useGridColumnGrouping = (apiRef, props)=>{
    /**
   * API METHODS
   */ const getColumnGroupPath = $7c3e3abbe30f48e1$var$React.useCallback((field)=>{
        const unwrappedGroupingModel = (0, $hMyIf.gridColumnGroupsUnwrappedModelSelector)(apiRef);
        return unwrappedGroupingModel[field] ?? [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $7c3e3abbe30f48e1$var$React.useCallback(()=>{
        const columnGroupLookup = (0, $hMyIf.gridColumnGroupsLookupSelector)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    (0, $ivFej.useGridApiMethod)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $7c3e3abbe30f48e1$var$React.useCallback(()=>{
        const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(props.columnGroupingModel ?? []);
        apiRef.current.setState((state)=>{
            const orderedFields = state.columns?.orderedFields ?? [];
            const pinnedColumns = state.pinnedColumns ?? {};
            const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
                columnGrouping: (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $7c3e3abbe30f48e1$var$React.useCallback((columnGroupingModel)=>{
        if (!columnGroupingModel && !apiRef.current.caches.columnGrouping.lastColumnGroupingModel) return;
        apiRef.current.caches.columnGrouping.lastColumnGroupingModel = columnGroupingModel;
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = apiRef.current.getPinnedColumns?.() ?? {};
        const columnFields = (0, $jy68d.gridColumnFieldsSelector)(apiRef);
        const visibleColumnFields = (0, $jy68d.gridVisibleColumnFieldsSelector)(apiRef);
        const groupLookup = (0, $vzN4X.createGroupLookup)(columnGroupingModel ?? []);
        const unwrappedGroupingModel = (0, $vzN4X.unwrapGroupingColumnModel)(columnGroupingModel ?? []);
        const columnGroupsHeaderStructure = (0, $vzN4X.getColumnGroupsHeaderStructure)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
        apiRef.current.setState((state)=>{
            return (0, $7c3e3abbe30f48e1$var$_extends2.default)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $g8PwW.useGridEvent)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $7c3e3abbe30f48e1$var$React.useEffect(()=>{
        if (props.columnGroupingModel === apiRef.current.caches.columnGrouping.lastColumnGroupingModel) return;
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        apiRef,
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};
module.exports.useGridColumnGrouping = $7c3e3abbe30f48e1$var$useGridColumnGrouping;

});
parcelRegister("vzN4X", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05eea8a1c02f601e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unwrapGroupingColumnModel = module.exports.getColumnGroupsHeaderStructure = module.exports.createGroupLookup = void 0;

var $05eea8a1c02f601e$var$_extends2 = $05eea8a1c02f601e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $05eea8a1c02f601e$var$_objectWithoutPropertiesLoose2 = $05eea8a1c02f601e$require$_interopRequireDefault((parcelRequire("c05no")));

var $j57st = parcelRequire("j57st");
const $05eea8a1c02f601e$var$_excluded = [
    "groupId",
    "children"
];
const $05eea8a1c02f601e$var$createGroupLookup = (columnGroupingModel)=>{
    const groupLookup = {};
    for(let i = 0; i < columnGroupingModel.length; i += 1){
        const node = columnGroupingModel[i];
        if ((0, $j57st.isLeaf)(node)) continue;
        const { groupId: groupId, children: children } = node, other = (0, $05eea8a1c02f601e$var$_objectWithoutPropertiesLoose2.default)(node, $05eea8a1c02f601e$var$_excluded);
        if (!groupId) throw new Error('MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        const groupParam = (0, $05eea8a1c02f601e$var$_extends2.default)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $05eea8a1c02f601e$var$createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI X: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        Object.assign(groupLookup, subTreeLookup);
        groupLookup[groupId] = groupParam;
    }
    return groupLookup;
};
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
module.exports.createGroupLookup = $05eea8a1c02f601e$var$createGroupLookup;
const $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $j57st.isLeaf)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI X: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
/**
 * This is a function that provide for each column the array of its parents.
 * Parents are ordered from the root to the leaf.
 * @param columnGroupingModel The model such as provided in DataGrid props
 * @returns An object `{[field]: groupIds}` where `groupIds` is the parents of the column `field`
 */ const $05eea8a1c02f601e$var$unwrapGroupingColumnModel = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $05eea8a1c02f601e$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
module.exports.unwrapGroupingColumnModel = $05eea8a1c02f601e$var$unwrapGroupingColumnModel;
const $05eea8a1c02f601e$var$getColumnGroupsHeaderStructure = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>unwrappedGroupingModel[field] ?? [];
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(0, ...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>{
        const a = getParents(field1);
        const b = getParents(field2);
        for(let i = 0; i <= depth; i += 1){
            if (a[i] !== b[i]) return false;
        }
        return true;
    };
    const haveDifferentContainers = (field1, field2)=>{
        const left = pinnedFields?.left;
        const right = pinnedFields?.right;
        const inLeft1 = !!left?.includes(field1);
        const inLeft2 = !!left?.includes(field2);
        const inRight1 = !!right?.includes(field1);
        const inRight2 = !!right?.includes(field2);
        return inLeft1 !== inLeft2 || inRight1 !== inRight2;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = [];
        for(let i = 0; i < orderedColumns.length; i += 1){
            const field = orderedColumns[i];
            const groupId = getParents(field)[depth] ?? null;
            if (depthStructure.length === 0) {
                depthStructure.push({
                    columnFields: [
                        field
                    ],
                    groupId: groupId
                });
                continue;
            }
            const lastGroup = depthStructure[depthStructure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            if (lastGroup.groupId !== groupId || !haveSameParents(prevField, field, depth) || haveDifferentContainers(prevField, field)) depthStructure.push({
                columnFields: [
                    field
                ],
                groupId: groupId
            });
            else lastGroup.columnFields.push(field);
        }
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};
module.exports.getColumnGroupsHeaderStructure = $05eea8a1c02f601e$var$getColumnGroupsHeaderStructure;

});


parcelRegister("jDB9E", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e4be7afefd9a1627$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e4be7afefd9a1627$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridColumnResize = module.exports.columnResizeStateInitializer = void 0;

var $e4be7afefd9a1627$var$_extends2 = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e4be7afefd9a1627$var$React = $e4be7afefd9a1627$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e4be7afefd9a1627$var$_useEventCallback = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $e4be7afefd9a1627$var$_ownerDocument = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("43fuO")));

var $e4be7afefd9a1627$var$_useLazyRef = $e4be7afefd9a1627$require$_interopRequireDefault((parcelRequire("doV3C")));

var $9uEev = parcelRequire("9uEev");

var $KtEo5 = parcelRequire("KtEo5");

var $6lOsW = parcelRequire("6lOsW");

var $5H1vo = parcelRequire("5H1vo");

var $5LeoO = parcelRequire("5LeoO");

var $cMkcn = parcelRequire("cMkcn");

var $1SkXC = parcelRequire("1SkXC");

var $lR3Vo = parcelRequire("lR3Vo");

var $5oDOG = parcelRequire("5oDOG");

var $4ZMWQ = parcelRequire("4ZMWQ");

var $jy68d = parcelRequire("jy68d");

var $iGtHu = parcelRequire("iGtHu");

var $40Iyj = parcelRequire("40Iyj");

var $fh3fi = parcelRequire("fh3fi");
function $e4be7afefd9a1627$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === 'Right') newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return Math.round(newWidth);
}
function $e4be7afefd9a1627$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === 'Left') return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $e4be7afefd9a1627$var$flipResizeDirection(side) {
    if (side === 'Right') return 'Left';
    return 'Right';
}
function $e4be7afefd9a1627$var$getResizeDirection(separator, isRtl) {
    const side = separator.classList.contains($5H1vo.gridClasses['columnSeparator--sideRight']) ? 'Right' : 'Left';
    if (isRtl) // Resizing logic should be mirrored in the RTL case
    return $e4be7afefd9a1627$var$flipResizeDirection(side);
    return side;
}
function $e4be7afefd9a1627$var$getPinnedWidthProperty(isRtl, pinnedPosition) {
    if (pinnedPosition === $4ZMWQ.GridPinnedColumnPosition.LEFT) return isRtl ? '--DataGrid-rightPinnedWidth' : '--DataGrid-leftPinnedWidth';
    return isRtl ? '--DataGrid-leftPinnedWidth' : '--DataGrid-rightPinnedWidth';
}
function $e4be7afefd9a1627$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) {
    if (pinnedPosition === $4ZMWQ.GridPinnedColumnPosition.LEFT) return isRtl ? dimensions.rightPinnedWidth : dimensions.leftPinnedWidth;
    return isRtl ? dimensions.leftPinnedWidth : dimensions.rightPinnedWidth;
}
function $e4be7afefd9a1627$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $e4be7afefd9a1627$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $e4be7afefd9a1627$var$React.useRef(undefined);
    const selector = ()=>(0, $cMkcn.gridVirtualizationColumnEnabledSelector)(apiRef);
    const value = (0, $5LeoO.useGridSelector)(apiRef, selector);
    $e4be7afefd9a1627$var$React.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $1SkXC.createControllablePromise)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $e4be7afefd9a1627$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (for example zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $e4be7afefd9a1627$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add($5H1vo.gridClasses.autosizing);
    const includeHeaderFilters = options.includeHeaderFilters && (0, $40Iyj.gridHeaderFilteringEnabledSelector)(apiRef);
    columns.forEach((column)=>{
        const cells = (0, $KtEo5.findGridCells)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            return cell.getBoundingClientRect().width ?? 0;
        });
        const filteredWidths = options.includeOutliers ? widths : $e4be7afefd9a1627$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $KtEo5.findGridHeader)(apiRef.current, column.field);
            if (header) {
                const titleContainer = header.querySelector(`.${$5H1vo.gridClasses.columnHeaderTitleContainer}`);
                const children = Array.from(titleContainer.children);
                const menuContainer = header.querySelector(`.${$5H1vo.gridClasses.menuIcon}`);
                const titleContainerStyle = window.getComputedStyle(titleContainer, null);
                const gap = parseInt(titleContainerStyle.gap, 10) || 0;
                const headerStyle = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(headerStyle.paddingLeft, 10) + parseInt(headerStyle.paddingRight, 10);
                let totalChildren = 0;
                let childrenWidth = 0;
                for(let i = 0; i < children.length; i += 1){
                    const child = children[i];
                    if (child.clientWidth > 0) {
                        totalChildren += 1;
                        childrenWidth += child.scrollWidth;
                    }
                }
                childrenWidth += 1;
                const width = childrenWidth + gap * (totalChildren - 1) + paddingWidth + (menuContainer?.clientWidth ?? 0);
                filteredWidths.push(width);
            }
        }
        if (includeHeaderFilters) {
            const headerFilter = (0, $KtEo5.findGridHeaderFilter)(apiRef.current, column.field);
            if (headerFilter) {
                const style = window.getComputedStyle(headerFilter, null);
                const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
                const contentWidth = headerFilter.scrollWidth;
                const width = contentWidth + paddingWidth;
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $lR3Vo.clamp)(maxContent, min, max);
    });
    root.classList.remove($5H1vo.gridClasses.autosizing);
    return widthByField;
}
const $e4be7afefd9a1627$var$columnResizeStateInitializer = (state)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, state, {
        columnResize: {
            resizingColumnField: ''
        }
    });
module.exports.columnResizeStateInitializer = $e4be7afefd9a1627$var$columnResizeStateInitializer;
function $e4be7afefd9a1627$var$createResizeRefs() {
    return {
        colDef: undefined,
        initialColWidth: 0,
        initialTotalWidth: 0,
        previousMouseClickEvent: undefined,
        columnHeaderElement: undefined,
        headerFilterElement: undefined,
        groupHeaderElements: [],
        cellElements: [],
        leftPinnedCellsAfter: [],
        rightPinnedCellsBefore: [],
        fillerLeft: undefined,
        fillerRight: undefined,
        leftPinnedHeadersAfter: [],
        rightPinnedHeadersBefore: []
    };
}
/**
 * @requires useGridColumns (method, event)
 * TODO: improve experience for last column
 */ const $e4be7afefd9a1627$var$useGridColumnResize = (apiRef, props)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const logger = (0, $5LeoO.useGridLogger)(apiRef, 'useGridColumnResize');
    const refs = (0, $e4be7afefd9a1627$var$_useLazyRef.default)($e4be7afefd9a1627$var$createResizeRefs).current;
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $e4be7afefd9a1627$var$React.useRef(null);
    const resizeDirection = $e4be7afefd9a1627$var$React.useRef(null);
    const stopResizeEventTimeout = (0, $5oDOG.useTimeout)();
    const touchId = $e4be7afefd9a1627$var$React.useRef(undefined);
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${refs.colDef.field}`);
        const prevWidth = refs.columnHeaderElement.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        const columnWidthDiff = newWidth - refs.initialColWidth;
        if (columnWidthDiff > 0) {
            const newTotalWidth = refs.initialTotalWidth + columnWidthDiff;
            apiRef.current.rootElementRef?.current?.style.setProperty('--DataGrid-rowWidth', `${newTotalWidth}px`);
        }
        refs.colDef.computedWidth = newWidth;
        refs.colDef.width = newWidth;
        refs.colDef.flex = 0;
        refs.columnHeaderElement.style.width = `${newWidth}px`;
        const headerFilterElement = refs.headerFilterElement;
        if (headerFilterElement) headerFilterElement.style.width = `${newWidth}px`;
        refs.groupHeaderElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
        });
        refs.cellElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.setProperty('--width', finalWidth);
        });
        const dimensions = (0, $iGtHu.gridDimensionsSelector)(apiRef);
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        if (pinnedPosition === $4ZMWQ.GridPinnedColumnPosition.LEFT) {
            $e4be7afefd9a1627$var$updateProperty(refs.fillerLeft, 'width', widthDiff);
            refs.leftPinnedCellsAfter.forEach((cell)=>{
                $e4be7afefd9a1627$var$updateProperty(cell, 'left', widthDiff);
            });
            refs.leftPinnedHeadersAfter.forEach((header)=>{
                $e4be7afefd9a1627$var$updateProperty(header, 'left', widthDiff);
            });
            apiRef.current.rootElementRef?.current?.style.setProperty($e4be7afefd9a1627$var$getPinnedWidthProperty(isRtl, pinnedPosition), `${$e4be7afefd9a1627$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) + columnWidthDiff}px`);
        }
        if (pinnedPosition === $4ZMWQ.GridPinnedColumnPosition.RIGHT) {
            $e4be7afefd9a1627$var$updateProperty(refs.fillerRight, 'width', widthDiff);
            refs.rightPinnedCellsBefore.forEach((cell)=>{
                $e4be7afefd9a1627$var$updateProperty(cell, 'right', widthDiff);
            });
            refs.rightPinnedHeadersBefore.forEach((header)=>{
                $e4be7afefd9a1627$var$updateProperty(header, 'right', widthDiff);
            });
            apiRef.current.rootElementRef?.current?.style.setProperty($e4be7afefd9a1627$var$getPinnedWidthProperty(isRtl, pinnedPosition), `${$e4be7afefd9a1627$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) + columnWidthDiff}px`);
        }
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        // Prevent double-clicks from being interpreted as two separate clicks
        if (refs.previousMouseClickEvent) {
            const prevEvent = refs.previousMouseClickEvent;
            const prevTimeStamp = prevEvent.timeStamp;
            const prevClientX = prevEvent.clientX;
            const prevClientY = prevEvent.clientY;
            // Check if the current event is part of a double-click
            if (nativeEvent.timeStamp - prevTimeStamp < 300 && nativeEvent.clientX === prevClientX && nativeEvent.clientY === prevClientY) {
                refs.previousMouseClickEvent = undefined;
                apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
                return;
            }
        }
        if (refs.colDef) {
            apiRef.current.setColumnWidth(refs.colDef.field, refs.colDef.width);
            logger.debug(`Updating col ${refs.colDef.field} with new width: ${refs.colDef.width}`);
            // Since during resizing we update the columns width outside of React, React is unable to
            // reapply the right style properties. We need to sync the state manually.
            // So we reapply the same logic as in https://github.com/mui/mui-x/blob/0511bf65543ca05d2602a5a3e0a6156f2fc8e759/packages/x-data-grid/src/hooks/features/columnHeaders/useGridColumnHeaders.tsx#L405
            const columnsState = (0, $jy68d.gridColumnsStateSelector)(apiRef);
            refs.groupHeaderElements.forEach((element)=>{
                const fields = (0, $KtEo5.getFieldsFromGroupHeaderElem)(element);
                const div = element;
                const newWidth = fields.reduce((acc, field)=>{
                    if (columnsState.columnVisibilityModel[field] !== false) return acc + columnsState.lookup[field].computedWidth;
                    return acc;
                }, 0);
                const finalWidth = `${newWidth}px`;
                div.style.width = finalWidth;
            });
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
        });
    };
    const setCellElementsRef = ()=>{
        if (refs.columnHeaderElement) refs.cellElements = (0, $KtEo5.findGridCellElementsFromCol)(refs.columnHeaderElement, apiRef.current);
    };
    const storeReferences = (colDef, separator, xStart)=>{
        const root = apiRef.current.rootElementRef.current;
        refs.initialColWidth = colDef.computedWidth;
        refs.initialTotalWidth = apiRef.current.getRootDimensions().rowWidth;
        refs.colDef = colDef;
        refs.columnHeaderElement = (0, $KtEo5.findHeaderElementFromField)(apiRef.current.columnHeadersContainerRef.current, colDef.field);
        const headerFilterElement = root.querySelector(`.${$5H1vo.gridClasses.headerFilterRow} [data-field="${(0, $KtEo5.escapeOperandAttributeSelector)(colDef.field)}"]`);
        if (headerFilterElement) refs.headerFilterElement = headerFilterElement;
        refs.groupHeaderElements = (0, $KtEo5.findGroupHeaderElementsFromField)(apiRef.current.columnHeadersContainerRef?.current, colDef.field);
        setCellElementsRef();
        refs.fillerLeft = (0, $KtEo5.findGridElement)(apiRef.current, isRtl ? 'filler--pinnedRight' : 'filler--pinnedLeft');
        refs.fillerRight = (0, $KtEo5.findGridElement)(apiRef.current, isRtl ? 'filler--pinnedLeft' : 'filler--pinnedRight');
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        refs.leftPinnedCellsAfter = pinnedPosition !== $4ZMWQ.GridPinnedColumnPosition.LEFT ? [] : (0, $KtEo5.findLeftPinnedCellsAfterCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedCellsBefore = pinnedPosition !== $4ZMWQ.GridPinnedColumnPosition.RIGHT ? [] : (0, $KtEo5.findRightPinnedCellsBeforeCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.leftPinnedHeadersAfter = pinnedPosition !== $4ZMWQ.GridPinnedColumnPosition.LEFT ? [] : (0, $KtEo5.findLeftPinnedHeadersAfterCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedHeadersBefore = pinnedPosition !== $4ZMWQ.GridPinnedColumnPosition.RIGHT ? [] : (0, $KtEo5.findRightPinnedHeadersBeforeCol)(apiRef.current, refs.columnHeaderElement, isRtl);
        resizeDirection.current = $e4be7afefd9a1627$var$getResizeDirection(separator, isRtl);
        initialOffsetToSeparator.current = $e4be7afefd9a1627$var$computeOffsetToSeparator(xStart, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
    };
    const handleResizeMouseUp = (0, $e4be7afefd9a1627$var$_useEventCallback.default)(finishResize);
    const handleResizeMouseMove = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $lR3Vo.clamp)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchEnd = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $e4be7afefd9a1627$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $e4be7afefd9a1627$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $e4be7afefd9a1627$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $lR3Vo.clamp)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchStart = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((event)=>{
        const cellSeparator = (0, $KtEo5.findParentElementFromClassName)(event.target, $5H1vo.gridClasses['columnSeparator--resizable']);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const columnHeaderElement = (0, $KtEo5.findParentElementFromClassName)(event.target, $5H1vo.gridClasses.columnHeader);
        const field = (0, $KtEo5.getFieldFromHeaderElem)(columnHeaderElement);
        const colDef = apiRef.current.getColumn(field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: field
        }, event);
        storeReferences(colDef, cellSeparator, touch.clientX);
        const doc = (0, $e4be7afefd9a1627$var$_ownerDocument.default)(event.currentTarget);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    const stopListening = $e4be7afefd9a1627$var$React.useCallback(()=>{
        const doc = (0, $e4be7afefd9a1627$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty('cursor');
        doc.removeEventListener('mousemove', handleResizeMouseMove);
        doc.removeEventListener('mouseup', handleResizeMouseUp);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener('click', $e4be7afefd9a1627$var$preventClick, true);
        }, 100);
        if (refs.columnHeaderElement) refs.columnHeaderElement.style.pointerEvents = 'unset';
    }, [
        apiRef,
        refs,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $e4be7afefd9a1627$var$React.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, state, {
                columnResize: (0, $e4be7afefd9a1627$var$_extends2.default)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
    }, [
        apiRef
    ]);
    const handleResizeStop = $e4be7afefd9a1627$var$React.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, state, {
                columnResize: (0, $e4be7afefd9a1627$var$_extends2.default)({}, state.columnResize, {
                    resizingColumnField: ''
                })
            }));
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $e4be7afefd9a1627$var$_useEventCallback.default)(({ colDef: colDef }, event)=>{
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains($5H1vo.gridClasses['columnSeparator--resizable'])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: colDef.field
        }, event);
        storeReferences(colDef, event.currentTarget, event.clientX);
        const doc = (0, $e4be7afefd9a1627$var$_ownerDocument.default)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = 'col-resize';
        refs.previousMouseClickEvent = event.nativeEvent;
        doc.addEventListener('mousemove', handleResizeMouseMove);
        doc.addEventListener('mouseup', handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener('click', $e4be7afefd9a1627$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $e4be7afefd9a1627$var$_useEventCallback.default)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $e4be7afefd9a1627$var$_extends2.default)({}, props.autosizeOptions, {
            disableColumnVirtualization: false,
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $e4be7afefd9a1627$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $e4be7afefd9a1627$var$React.useRef(false);
    const autosizeColumns = $e4be7afefd9a1627$var$React.useCallback(async (userOptions)=>{
        const root = apiRef.current.rootElementRef?.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $jy68d.gridColumnsStateSelector)(apiRef);
        const options = (0, $e4be7afefd9a1627$var$_extends2.default)({}, $6lOsW.DEFAULT_GRID_AUTOSIZE_OPTIONS, userOptions, {
            columns: userOptions?.columns ?? state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            if (!props.disableVirtualization && options.disableColumnVirtualization) {
                apiRef.current.unstable_setColumnVirtualization(false);
                await columnVirtualizationDisabled();
            }
            const widthByField = $e4be7afefd9a1627$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $e4be7afefd9a1627$var$_extends2.default)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field],
                    flex: 0
                }));
            if (options.expand) {
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>total + (widthByField[column.field] ?? column.computedWidth ?? column.width), 0);
                const dimensions = apiRef.current.getRootDimensions();
                const availableWidth = dimensions.viewportInnerSize.width;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
            newColumns.forEach((newColumn, index)=>{
                if (newColumn.width !== columns[index].width) {
                    const width = newColumn.width;
                    apiRef.current.publishEvent('columnWidthChange', {
                        element: apiRef.current.getColumnHeaderElement(newColumn.field),
                        colDef: newColumn,
                        width: width
                    });
                }
            });
        } finally{
            if (!props.disableVirtualization) apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled,
        props.disableVirtualization
    ]);
    /**
   * EFFECTS
   */ $e4be7afefd9a1627$var$React.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $5LeoO.useOnMount)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $5LeoO.useGridNativeEventListener)(apiRef, ()=>apiRef.current.columnHeadersContainerRef?.current, 'touchstart', handleTouchStart, {
        passive: true
    });
    (0, $5LeoO.useGridApiMethod)(apiRef, {
        autosizeColumns: autosizeColumns
    }, 'public');
    (0, $5LeoO.useGridEvent)(apiRef, 'columnResizeStop', handleResizeStop);
    (0, $5LeoO.useGridEvent)(apiRef, 'columnResizeStart', handleResizeStart);
    (0, $5LeoO.useGridEvent)(apiRef, 'columnSeparatorMouseDown', handleColumnResizeMouseDown);
    (0, $5LeoO.useGridEvent)(apiRef, 'columnSeparatorDoubleClick', handleColumnSeparatorDoubleClick);
    (0, $5LeoO.useGridEvent)(apiRef, 'rowsSet', ()=>{
        // if the user is still resizing the column, update the cell references included in the resize action
        if ((0, $fh3fi.gridResizingColumnFieldSelector)(apiRef) !== '') // wait until the rows are in the DOM
        requestAnimationFrame(()=>{
            setCellElementsRef();
        });
    });
    (0, $5LeoO.useGridEventPriority)(apiRef, 'columnResize', props.onColumnResize);
    (0, $5LeoO.useGridEventPriority)(apiRef, 'columnWidthChange', props.onColumnWidthChange);
};
module.exports.useGridColumnResize = $e4be7afefd9a1627$var$useGridColumnResize;
function $e4be7afefd9a1627$var$updateProperty(element, property, delta) {
    if (!element) return;
    element.style[property] = `${Math.round(parseFloat(element.style[property])) + delta}px`;
}

});
parcelRegister("1SkXC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createControllablePromise = $15db17edb5d37fe8$var$createControllablePromise;
function $15db17edb5d37fe8$var$createControllablePromise() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}

});


parcelRegister("1n8rV", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0ffe7e50943bb4c1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0ffe7e50943bb4c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridRowSpanning = module.exports.rowSpanningStateInitializer = void 0;

var $0ffe7e50943bb4c1$var$_extends2 = $0ffe7e50943bb4c1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0ffe7e50943bb4c1$var$React = $0ffe7e50943bb4c1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $br5oA = parcelRequire("br5oA");

var $jQEEt = parcelRequire("jQEEt");

var $aJApm = parcelRequire("aJApm");

var $9upDV = parcelRequire("9upDV");

var $2QKlN = parcelRequire("2QKlN");

var $g8PwW = parcelRequire("g8PwW");

var $lR3Vo = parcelRequire("lR3Vo");

var $jukhl = parcelRequire("jukhl");
const $0ffe7e50943bb4c1$var$EMPTY_CACHES = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $0ffe7e50943bb4c1$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $0ffe7e50943bb4c1$var$EMPTY_STATE = {
    caches: $0ffe7e50943bb4c1$var$EMPTY_CACHES,
    processedRange: $0ffe7e50943bb4c1$var$EMPTY_RANGE
};
const $0ffe7e50943bb4c1$var$computeRowSpanningState = (apiRef, colDefs, visibleRows, range, rangeToProcess, resetState)=>{
    const virtualizer = apiRef.current.virtualizer;
    const previousState = resetState ? $0ffe7e50943bb4c1$var$EMPTY_STATE : $br5oA.Rowspan.selectors.state(virtualizer.store.state);
    const spannedCells = (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, previousState.caches.spannedCells);
    const hiddenCells = (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, previousState.caches.hiddenCells);
    const hiddenCellOriginMap = (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, previousState.caches.hiddenCellOriginMap);
    const processedRange = {
        firstRowIndex: Math.min(previousState.processedRange.firstRowIndex, rangeToProcess.firstRowIndex),
        lastRowIndex: Math.max(previousState.processedRange.lastRowIndex, rangeToProcess.lastRowIndex)
    };
    colDefs.forEach((colDef, columnIndex)=>{
        for(let index = rangeToProcess.firstRowIndex; index < rangeToProcess.lastRowIndex; index += 1){
            const row = visibleRows[index];
            if (hiddenCells[row.id]?.[columnIndex]) continue;
            const cellValue = (0, $2QKlN.getCellValue)(row.model, colDef, apiRef);
            if (cellValue == null) continue;
            let spannedRowId = row.id;
            let spannedRowIndex = index;
            let rowSpan = 0;
            // For first index, also scan in the previous rows to handle the reset state case e.g by sorting
            const backwardsHiddenCells = [];
            if (index === rangeToProcess.firstRowIndex) {
                let prevIndex = index - 1;
                let prevRowEntry = visibleRows[prevIndex];
                while(prevIndex >= range.firstRowIndex && prevRowEntry && (0, $2QKlN.getCellValue)(prevRowEntry.model, colDef, apiRef) === cellValue){
                    const currentRow = visibleRows[prevIndex + 1];
                    if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][columnIndex] = true;
                    else hiddenCells[currentRow.id] = {
                        [columnIndex]: true
                    };
                    backwardsHiddenCells.push(index);
                    rowSpan += 1;
                    spannedRowId = prevRowEntry.id;
                    spannedRowIndex = prevIndex;
                    prevIndex -= 1;
                    prevRowEntry = visibleRows[prevIndex];
                }
            }
            backwardsHiddenCells.forEach((hiddenCellIndex)=>{
                if (hiddenCellOriginMap[hiddenCellIndex]) hiddenCellOriginMap[hiddenCellIndex][columnIndex] = spannedRowIndex;
                else hiddenCellOriginMap[hiddenCellIndex] = {
                    [columnIndex]: spannedRowIndex
                };
            });
            // Scan the next rows
            let relativeIndex = index + 1;
            while(relativeIndex <= range.lastRowIndex && visibleRows[relativeIndex] && (0, $2QKlN.getCellValue)(visibleRows[relativeIndex].model, colDef, apiRef) === cellValue){
                const currentRow = visibleRows[relativeIndex];
                if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][columnIndex] = true;
                else hiddenCells[currentRow.id] = {
                    [columnIndex]: true
                };
                if (hiddenCellOriginMap[relativeIndex]) hiddenCellOriginMap[relativeIndex][columnIndex] = spannedRowIndex;
                else hiddenCellOriginMap[relativeIndex] = {
                    [columnIndex]: spannedRowIndex
                };
                relativeIndex += 1;
                rowSpan += 1;
            }
            if (rowSpan > 0) {
                if (spannedCells[spannedRowId]) spannedCells[spannedRowId][columnIndex] = rowSpan + 1;
                else spannedCells[spannedRowId] = {
                    [columnIndex]: rowSpan + 1
                };
            }
        }
    });
    return {
        caches: {
            spannedCells: spannedCells,
            hiddenCells: hiddenCells,
            hiddenCellOriginMap: hiddenCellOriginMap
        },
        processedRange: processedRange
    };
};
/**
 * @requires columnsStateInitializer (method) - should be initialized before
 * @requires rowsStateInitializer (method) - should be initialized before
 * @requires filterStateInitializer (method) - should be initialized before
 */ const $0ffe7e50943bb4c1$var$rowSpanningStateInitializer = (state)=>{
    return (0, $0ffe7e50943bb4c1$var$_extends2.default)({}, state, {
        rowSpanning: $0ffe7e50943bb4c1$var$EMPTY_STATE
    });
};
module.exports.rowSpanningStateInitializer = $0ffe7e50943bb4c1$var$rowSpanningStateInitializer;
const $0ffe7e50943bb4c1$var$useGridRowSpanning = (apiRef, props)=>{
    const updateRowSpanningState = $0ffe7e50943bb4c1$var$React.useCallback((renderContext, resetState = false)=>{
        const store = apiRef.current.virtualizer.store;
        const { range: range, rows: visibleRows } = (0, $aJApm.getVisibleRows)(apiRef);
        if (resetState) store.set('rowSpanning', $0ffe7e50943bb4c1$var$EMPTY_STATE);
        if (range === null || !(0, $2QKlN.isRowContextInitialized)(renderContext)) return;
        const previousState = resetState ? $0ffe7e50943bb4c1$var$EMPTY_STATE : $br5oA.Rowspan.selectors.state(store.state);
        const rangeToProcess = (0, $2QKlN.getUnprocessedRange)({
            firstRowIndex: renderContext.firstRowIndex,
            lastRowIndex: Math.min(renderContext.lastRowIndex, range.lastRowIndex - range.firstRowIndex + 1)
        }, previousState.processedRange);
        if (rangeToProcess === null) return;
        const colDefs = (0, $jQEEt.gridVisibleColumnDefinitionsSelector)(apiRef);
        const newState = $0ffe7e50943bb4c1$var$computeRowSpanningState(apiRef, colDefs, visibleRows, range, rangeToProcess, resetState);
        const newSpannedCellsCount = Object.keys(newState.caches.spannedCells).length;
        const newHiddenCellsCount = Object.keys(newState.caches.hiddenCells).length;
        const previousSpannedCellsCount = Object.keys(previousState.caches.spannedCells).length;
        const previousHiddenCellsCount = Object.keys(previousState.caches.hiddenCells).length;
        const shouldUpdateState = resetState || newSpannedCellsCount !== previousSpannedCellsCount || newHiddenCellsCount !== previousHiddenCellsCount;
        const hasNoSpannedCells = newSpannedCellsCount === 0 && previousSpannedCellsCount === 0;
        if (!shouldUpdateState || hasNoSpannedCells) return;
        store.set('rowSpanning', newState);
    }, [
        apiRef
    ]);
    // Reset events trigger a full re-computation of the row spanning state:
    // - The `rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    const { schedule: deferredUpdateRowSpanningState, cancel: cancel } = (0, $jukhl.useRunOncePerLoop)(updateRowSpanningState);
    const resetRowSpanningState = $0ffe7e50943bb4c1$var$React.useCallback(()=>{
        const renderContext = (0, $9upDV.gridRenderContextSelector)(apiRef);
        if (!(0, $2QKlN.isRowContextInitialized)(renderContext)) return;
        deferredUpdateRowSpanningState(renderContext, true);
    }, [
        apiRef,
        deferredUpdateRowSpanningState
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'renderedRowsIntervalChange', (0, $lR3Vo.runIf)(props.rowSpanning, (renderContext)=>{
        const didHavePendingReset = cancel();
        updateRowSpanningState(renderContext, didHavePendingReset);
    }));
    (0, $g8PwW.useGridEvent)(apiRef, 'sortedRowsSet', (0, $lR3Vo.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $g8PwW.useGridEvent)(apiRef, 'paginationModelChange', (0, $lR3Vo.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $g8PwW.useGridEvent)(apiRef, 'filteredRowsSet', (0, $lR3Vo.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $g8PwW.useGridEvent)(apiRef, 'columnsChange', (0, $lR3Vo.runIf)(props.rowSpanning, resetRowSpanningState));
    (0, $g8PwW.useGridEvent)(apiRef, 'rowExpansionChange', (0, $lR3Vo.runIf)(props.rowSpanning, resetRowSpanningState));
    $0ffe7e50943bb4c1$var$React.useEffect(()=>{
        const store = apiRef.current.virtualizer?.store;
        if (!store) return;
        if (!props.rowSpanning) {
            if (store.state.rowSpanning !== $0ffe7e50943bb4c1$var$EMPTY_STATE) store.set('rowSpanning', $0ffe7e50943bb4c1$var$EMPTY_STATE);
        } else if (store.state.rowSpanning === $0ffe7e50943bb4c1$var$EMPTY_STATE) updateRowSpanningState((0, $9upDV.gridRenderContextSelector)(apiRef));
    }, [
        apiRef,
        props.rowSpanning,
        updateRowSpanningState
    ]);
};
module.exports.useGridRowSpanning = $0ffe7e50943bb4c1$var$useGridRowSpanning;

});
parcelRegister("2QKlN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCellValue = void 0;
module.exports.getUnprocessedRange = $2134645d829cdaa1$var$getUnprocessedRange;
module.exports.isRowContextInitialized = $2134645d829cdaa1$var$isRowContextInitialized;
module.exports.isRowRangeUpdated = $2134645d829cdaa1$var$isRowRangeUpdated;

var $7sDf4 = parcelRequire("7sDf4");
function $2134645d829cdaa1$var$getUnprocessedRange(testRange, processedRange) {
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return null;
    // Overflowing at the end
    // Example: testRange={ firstRowIndex: 10, lastRowIndex: 20 }, processedRange={ firstRowIndex: 0, lastRowIndex: 15 }
    // Unprocessed Range={ firstRowIndex: 16, lastRowIndex: 20 }
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex > processedRange.lastRowIndex) return {
        firstRowIndex: processedRange.lastRowIndex,
        lastRowIndex: testRange.lastRowIndex
    };
    // Overflowing at the beginning
    // Example: testRange={ firstRowIndex: 0, lastRowIndex: 20 }, processedRange={ firstRowIndex: 16, lastRowIndex: 30 }
    // Unprocessed Range={ firstRowIndex: 0, lastRowIndex: 15 }
    if (testRange.firstRowIndex < processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return {
        firstRowIndex: testRange.firstRowIndex,
        lastRowIndex: processedRange.firstRowIndex - 1
    };
    // TODO: Should return two ranges handle overflowing at both ends ?
    return testRange;
}
function $2134645d829cdaa1$var$isRowContextInitialized(renderContext) {
    return renderContext.firstRowIndex !== 0 || renderContext.lastRowIndex !== 0;
}
function $2134645d829cdaa1$var$isRowRangeUpdated(range1, range2) {
    return range1.firstRowIndex !== range2.firstRowIndex || range1.lastRowIndex !== range2.lastRowIndex;
}
const $2134645d829cdaa1$var$getCellValue = (row, colDef, apiRef)=>{
    if (!row) return null;
    const cellValue = row[colDef.field];
    if (colDef.rowSpanValueGetter) return colDef.rowSpanValueGetter(cellValue, row, colDef, apiRef);
    // This util is also called during the state initialization
    // Use util method directly instead of calling apiRef.current.getRowValue
    return (0, $7sDf4.getRowValue)(row, colDef, apiRef);
};
module.exports.getCellValue = $2134645d829cdaa1$var$getCellValue;

});


parcelRegister("kbNad", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eb2af8a38b4a65a4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eb2af8a38b4a65a4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.listViewStateInitializer = void 0;
module.exports.useGridListView = $eb2af8a38b4a65a4$var$useGridListView;

var $eb2af8a38b4a65a4$var$_extends2 = $eb2af8a38b4a65a4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $eb2af8a38b4a65a4$var$React = $eb2af8a38b4a65a4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $eb2af8a38b4a65a4$var$_useEnhancedEffect = $eb2af8a38b4a65a4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $iGtHu = parcelRequire("iGtHu");

var $g8PwW = parcelRequire("g8PwW");
const $eb2af8a38b4a65a4$var$listViewStateInitializer = (state, props, apiRef)=>(0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state, {
        listViewColumn: props.listViewColumn ? (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, props.listViewColumn, {
            computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
        }) : undefined
    });
module.exports.listViewStateInitializer = $eb2af8a38b4a65a4$var$listViewStateInitializer;
function $eb2af8a38b4a65a4$var$useGridListView(apiRef, props) {
    /*
   * EVENTS
   */ const updateListColumnWidth = ()=>{
        apiRef.current.setState((state)=>{
            if (!state.listViewColumn) return state;
            return (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state, {
                listViewColumn: (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state.listViewColumn, {
                    computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
                })
            });
        });
    };
    const prevInnerWidth = $eb2af8a38b4a65a4$var$React.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            updateListColumnWidth();
        }
    };
    (0, $g8PwW.useGridEvent)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnVisibilityModelChange', updateListColumnWidth);
    /*
   * EFFECTS
   */ (0, $eb2af8a38b4a65a4$var$_useEnhancedEffect.default)(()=>{
        const listColumn = props.listViewColumn;
        if (listColumn) apiRef.current.setState((state)=>{
            return (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, state, {
                listViewColumn: (0, $eb2af8a38b4a65a4$var$_extends2.default)({}, listColumn, {
                    computedWidth: $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef)
                })
            });
        });
    }, [
        apiRef,
        props.listViewColumn
    ]);
    $eb2af8a38b4a65a4$var$React.useEffect(()=>{
        if (props.listView && !props.listViewColumn) (0, $9Y8Cp.warnOnce)([
            'MUI X: The `listViewColumn` prop must be set if `listView` is enabled.',
            'To fix, pass a column definition to the `listViewColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.',
            'For more details, see https://mui.com/x/react-data-grid/list-view/'
        ]);
    }, [
        props.listView,
        props.listViewColumn
    ]);
}
function $eb2af8a38b4a65a4$var$getListColumnWidth(apiRef) {
    return (0, $iGtHu.gridDimensionsSelector)(apiRef).viewportInnerSize.width;
}

});

parcelRegister("b7mzS", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8181dc9d16d4286d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridDataSource = void 0;

var $8181dc9d16d4286d$var$React = $8181dc9d16d4286d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivFej = parcelRequire("ivFej");

var $kmoo4 = parcelRequire("kmoo4");

var $g8PwW = parcelRequire("g8PwW");

var $aUtr8 = parcelRequire("aUtr8");
/**
 * Community version of the data source hook. Contains implementation of the `useGridDataSourceBase` hook.
 */ const $8181dc9d16d4286d$var$useGridDataSource = (apiRef, props)=>{
    const { api: api, strategyProcessor: strategyProcessor, events: events, setStrategyAvailability: setStrategyAvailability } = (0, $aUtr8.useGridDataSourceBase)(apiRef, props);
    (0, $ivFej.useGridApiMethod)(apiRef, api.public, 'public');
    (0, $kmoo4.useGridRegisterStrategyProcessor)(apiRef, strategyProcessor.strategyName, strategyProcessor.group, strategyProcessor.processor);
    Object.entries(events).forEach(([event, handler])=>{
        (0, $g8PwW.useGridEvent)(apiRef, event, handler);
    });
    $8181dc9d16d4286d$var$React.useEffect(()=>{
        setStrategyAvailability();
    }, [
        setStrategyAvailability
    ]);
};
module.exports.useGridDataSource = $8181dc9d16d4286d$var$useGridDataSource;

});
parcelRegister("aUtr8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7f15f7d4e3cc4be4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7f15f7d4e3cc4be4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridDataSourceBase = void 0;

var $7f15f7d4e3cc4be4$var$_extends2 = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7f15f7d4e3cc4be4$var$_objectWithoutPropertiesLoose2 = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("c05no")));

var $7f15f7d4e3cc4be4$var$React = $7f15f7d4e3cc4be4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7f15f7d4e3cc4be4$var$_useLazyRef = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("doV3C")));

var $7f15f7d4e3cc4be4$var$_useEventCallback = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $7f15f7d4e3cc4be4$var$_debounce = $7f15f7d4e3cc4be4$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $e9lLm = parcelRequire("e9lLm");

var $7sDf4 = parcelRequire("7sDf4");

var $lR3Vo = parcelRequire("lR3Vo");

var $5ErGu = parcelRequire("5ErGu");

var $5sOMZ = parcelRequire("5sOMZ");

var $gPWuj = parcelRequire("gPWuj");

var $goCyd = parcelRequire("goCyd");

var $6x4PY = parcelRequire("6x4PY");

var $lBPh6 = parcelRequire("lBPh6");

var $7eBdF = parcelRequire("7eBdF");

var $ehAc1 = parcelRequire("ehAc1");
const $7f15f7d4e3cc4be4$var$_excluded = [
    "skipCache",
    "keepChildrenExpanded"
];
const $7f15f7d4e3cc4be4$var$noopCache = {
    clear: ()=>{},
    get: ()=>undefined,
    set: ()=>{}
};
function $7f15f7d4e3cc4be4$var$getCache(cacheProp, options = {}) {
    if (cacheProp === null) return $7f15f7d4e3cc4be4$var$noopCache;
    return cacheProp ?? new $7eBdF.GridDataSourceCacheDefault(options);
}
const $7f15f7d4e3cc4be4$var$useGridDataSourceBase = (apiRef, props, options = {})=>{
    const setStrategyAvailability = $7f15f7d4e3cc4be4$var$React.useCallback(()=>{
        apiRef.current.setStrategyAvailability($5ErGu.GridStrategyGroup.DataSource, $lBPh6.DataSourceRowsUpdateStrategy.Default, props.dataSource ? ()=>true : ()=>false);
    }, [
        apiRef,
        props.dataSource
    ]);
    const [currentStrategy, setCurrentStrategy] = $7f15f7d4e3cc4be4$var$React.useState(apiRef.current.getActiveStrategy($5ErGu.GridStrategyGroup.DataSource));
    const standardRowsUpdateStrategyActive = $7f15f7d4e3cc4be4$var$React.useMemo(()=>{
        return currentStrategy === $lBPh6.DataSourceRowsUpdateStrategy.Default || currentStrategy === $lBPh6.DataSourceRowsUpdateStrategy.GroupedData;
    }, [
        currentStrategy
    ]);
    const paginationModel = (0, $5sOMZ.useGridSelector)(apiRef, $gPWuj.gridPaginationModelSelector);
    const lastRequestId = $7f15f7d4e3cc4be4$var$React.useRef(0);
    const pollingIntervalRef = $7f15f7d4e3cc4be4$var$React.useRef(null);
    const onDataSourceErrorProp = props.onDataSourceError;
    const revalidateMs = props.dataSourceRevalidateMs;
    const cacheChunkManager = (0, $7f15f7d4e3cc4be4$var$_useLazyRef.default)(()=>{
        if (!props.pagination) return new $lBPh6.CacheChunkManager(paginationModel.pageSize);
        const sortedPageSizeOptions = props.pageSizeOptions.map((option)=>typeof option === 'number' ? option : option.value).sort((a, b)=>a - b);
        const cacheChunkSize = Math.min(paginationModel.pageSize, sortedPageSizeOptions[0]);
        return new $lBPh6.CacheChunkManager(cacheChunkSize);
    }).current;
    const [cache, setCache] = $7f15f7d4e3cc4be4$var$React.useState(()=>$7f15f7d4e3cc4be4$var$getCache(props.dataSourceCache, options.cacheOptions));
    const fetchRows = $7f15f7d4e3cc4be4$var$React.useCallback(async (parentId, params)=>{
        const getRows = props.dataSource?.getRows;
        if (!getRows) return;
        if (parentId && parentId !== $7sDf4.GRID_ROOT_GROUP_ID && props.signature !== 'DataGrid') {
            options.fetchRowChildren?.([
                parentId
            ]);
            return;
        }
        options.clearDataSourceState?.();
        const _ref = params || {}, { skipCache: skipCache, keepChildrenExpanded: keepChildrenExpanded } = _ref, getRowsParams = (0, $7f15f7d4e3cc4be4$var$_objectWithoutPropertiesLoose2.default)(_ref, $7f15f7d4e3cc4be4$var$_excluded);
        const fetchParams = (0, $7f15f7d4e3cc4be4$var$_extends2.default)({}, (0, $6x4PY.gridGetRowsParamsSelector)(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}), getRowsParams);
        const cacheKeys = cacheChunkManager.getCacheKeys(fetchParams);
        const responses = cacheKeys.map((cacheKey)=>cache.get(cacheKey));
        if (!skipCache && responses.every((response)=>response !== undefined)) {
            apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: $lBPh6.CacheChunkManager.mergeResponses(responses),
                fetchParams: fetchParams,
                options: {
                    skipCache: skipCache,
                    keepChildrenExpanded: keepChildrenExpanded
                }
            });
            return;
        }
        // Manage loading state only for the default strategy
        if (standardRowsUpdateStrategyActive || apiRef.current.getRowsCount() === 0) apiRef.current.setLoading(true);
        const requestId = lastRequestId.current + 1;
        lastRequestId.current = requestId;
        try {
            const getRowsResponse = await getRows(fetchParams);
            const cacheResponses = cacheChunkManager.splitResponse(fetchParams, getRowsResponse);
            cacheResponses.forEach((response, key)=>cache.set(key, response));
            if (lastRequestId.current === requestId) apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: getRowsResponse,
                fetchParams: fetchParams,
                options: {
                    skipCache: skipCache,
                    keepChildrenExpanded: keepChildrenExpanded
                }
            });
        } catch (originalError) {
            if (lastRequestId.current === requestId) {
                apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                    error: originalError,
                    fetchParams: fetchParams,
                    options: {
                        skipCache: skipCache,
                        keepChildrenExpanded: keepChildrenExpanded
                    }
                });
                if (typeof onDataSourceErrorProp === 'function') onDataSourceErrorProp(new $ehAc1.GridGetRowsError({
                    message: originalError?.message,
                    params: fetchParams,
                    cause: originalError
                }));
                else (0, $9Y8Cp.warnOnce)([
                    'MUI X: A call to `dataSource.getRows()` threw an error which was not handled because `onDataSourceError()` is missing.',
                    'To handle the error pass a callback to the `onDataSourceError` prop, for example `<DataGrid onDataSourceError={(error) => ...} />`.',
                    'For more detail, see https://mui.com/x/react-data-grid/server-side-data/#error-handling.'
                ], 'error');
            }
        } finally{
            if (standardRowsUpdateStrategyActive && lastRequestId.current === requestId) apiRef.current.setLoading(false);
        }
    }, [
        cacheChunkManager,
        cache,
        apiRef,
        standardRowsUpdateStrategyActive,
        props.dataSource?.getRows,
        onDataSourceErrorProp,
        options,
        props.signature
    ]);
    const handleStrategyActivityChange = $7f15f7d4e3cc4be4$var$React.useCallback(()=>{
        setCurrentStrategy(apiRef.current.getActiveStrategy($5ErGu.GridStrategyGroup.DataSource));
    }, [
        apiRef
    ]);
    const fetchRowChildrenOption = options.fetchRowChildren;
    const revalidate = (0, $7f15f7d4e3cc4be4$var$_useEventCallback.default)(async ()=>{
        const getRows = props.dataSource?.getRows;
        if (!getRows || !standardRowsUpdateStrategyActive) return;
        const revalidateExpandedGroups = ()=>{
            if (currentStrategy !== $lBPh6.DataSourceRowsUpdateStrategy.GroupedData || !fetchRowChildrenOption) return;
            const rowTree = (0, $goCyd.gridRowTreeSelector)(apiRef);
            const visibleRows = (0, $gPWuj.gridVisibleRowsSelector)(apiRef).rows;
            const expandedGroupIds = visibleRows.reduce((acc, row)=>{
                const node = rowTree[row.id];
                if (node.type === 'group' && node.id !== $7sDf4.GRID_ROOT_GROUP_ID && node.childrenExpanded === true) acc.push(row.id);
                return acc;
            }, []);
            if (expandedGroupIds.length > 0) fetchRowChildrenOption(expandedGroupIds, {
                showChildrenLoading: false
            });
        };
        const fetchParams = (0, $7f15f7d4e3cc4be4$var$_extends2.default)({}, (0, $6x4PY.gridGetRowsParamsSelector)(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}));
        const cacheKeys = cacheChunkManager.getCacheKeys(fetchParams);
        const responses = cacheKeys.map((cacheKey)=>cache.get(cacheKey));
        if (responses.every((response)=>response !== undefined)) {
            revalidateExpandedGroups();
            return;
        }
        try {
            const response = await getRows(fetchParams);
            const currentParams = (0, $7f15f7d4e3cc4be4$var$_extends2.default)({}, (0, $6x4PY.gridGetRowsParamsSelector)(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}));
            if (!(0, $e9lLm.isDeepEqual)(fetchParams, currentParams)) return;
            const cacheResponses = cacheChunkManager.splitResponse(fetchParams, response);
            cacheResponses.forEach((cacheResponse, key)=>cache.set(key, cacheResponse));
            apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: response,
                fetchParams: fetchParams,
                options: {}
            });
            revalidateExpandedGroups();
        } catch  {
        // Ignore background revalidation errors.
        }
    });
    const stopPolling = $7f15f7d4e3cc4be4$var$React.useCallback(()=>{
        if (pollingIntervalRef.current !== null) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    }, []);
    const startPolling = (0, $7f15f7d4e3cc4be4$var$_useEventCallback.default)(()=>{
        stopPolling();
        if (revalidateMs <= 0 || !standardRowsUpdateStrategyActive) return;
        pollingIntervalRef.current = setInterval(revalidate, revalidateMs);
    });
    const handleDataUpdate = $7f15f7d4e3cc4be4$var$React.useCallback((params)=>{
        if ('error' in params) {
            apiRef.current.setRows([]);
            return;
        }
        const { response: response } = params;
        if (response.rowCount !== undefined) apiRef.current.setRowCount(response.rowCount);
        apiRef.current.setRows(response.rows);
        apiRef.current.unstable_applyPipeProcessors('processDataSourceRows', {
            params: params.fetchParams,
            response: response
        }, true);
        startPolling();
    }, [
        apiRef,
        startPolling
    ]);
    const dataSourceUpdateRow = props.dataSource?.updateRow;
    const handleEditRowOption = options.handleEditRow;
    const editRow = $7f15f7d4e3cc4be4$var$React.useCallback(async (params)=>{
        if (!dataSourceUpdateRow) return undefined;
        try {
            const finalRowUpdate = await dataSourceUpdateRow(params);
            if (typeof handleEditRowOption === 'function') {
                handleEditRowOption(params, finalRowUpdate);
                return finalRowUpdate;
            }
            if (finalRowUpdate && !(0, $e9lLm.isDeepEqual)(finalRowUpdate, params.previousRow)) // Reset the outdated cache, only if the row is _actually_ updated
            apiRef.current.dataSource.cache.clear();
            apiRef.current.updateNestedRows([
                finalRowUpdate
            ], []);
            return finalRowUpdate;
        } catch (errorThrown) {
            if (typeof onDataSourceErrorProp === 'function') onDataSourceErrorProp(new $ehAc1.GridUpdateRowError({
                message: errorThrown?.message,
                params: params,
                cause: errorThrown
            }));
            else (0, $9Y8Cp.warnOnce)([
                'MUI X: A call to `dataSource.updateRow()` threw an error which was not handled because `onDataSourceError()` is missing.',
                'To handle the error pass a callback to the `onDataSourceError` prop, for example `<DataGrid onDataSourceError={(error) => ...} />`.',
                'For more detail, see https://mui.com/x/react-data-grid/server-side-data/#error-handling.'
            ], 'error');
            throw errorThrown; // Let the caller handle the error further
        }
    }, [
        apiRef,
        dataSourceUpdateRow,
        onDataSourceErrorProp,
        handleEditRowOption
    ]);
    const dataSourceApi = {
        dataSource: {
            fetchRows: fetchRows,
            cache: cache,
            editRow: editRow
        }
    };
    const debouncedFetchRows = $7f15f7d4e3cc4be4$var$React.useMemo(()=>(0, $7f15f7d4e3cc4be4$var$_debounce.default)(fetchRows, 0), [
        fetchRows
    ]);
    const handleFetchRowsOnParamsChange = $7f15f7d4e3cc4be4$var$React.useCallback(()=>{
        stopPolling();
        debouncedFetchRows();
    }, [
        stopPolling,
        debouncedFetchRows
    ]);
    const isFirstRender = $7f15f7d4e3cc4be4$var$React.useRef(true);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (props.dataSourceCache === undefined) return;
        const newCache = $7f15f7d4e3cc4be4$var$getCache(props.dataSourceCache, options.cacheOptions);
        setCache((prevCache)=>prevCache !== newCache ? newCache : prevCache);
    }, [
        props.dataSourceCache,
        options.cacheOptions
    ]);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>{
        if (!standardRowsUpdateStrategyActive) stopPolling();
    }, [
        standardRowsUpdateStrategyActive,
        stopPolling
    ]);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>{
        if (revalidateMs <= 0) stopPolling();
    }, [
        revalidateMs,
        stopPolling
    ]);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>stopPolling, [
        stopPolling
    ]);
    $7f15f7d4e3cc4be4$var$React.useEffect(()=>{
        // Return early if the proper strategy isn't set yet
        // Context: https://github.com/mui/mui-x/issues/19650
        if (currentStrategy !== $lBPh6.DataSourceRowsUpdateStrategy.Default && currentStrategy !== $lBPh6.DataSourceRowsUpdateStrategy.LazyLoading && currentStrategy !== $lBPh6.DataSourceRowsUpdateStrategy.GroupedData) return undefined;
        if (props.dataSource) {
            stopPolling();
            apiRef.current.setRows([]);
            apiRef.current.dataSource.cache.clear();
            apiRef.current.dataSource.fetchRows();
        }
        return ()=>{
            // ignore the current request on unmount
            lastRequestId.current += 1;
        };
    }, [
        apiRef,
        props.dataSource,
        currentStrategy,
        stopPolling
    ]);
    return {
        api: {
            public: dataSourceApi
        },
        debouncedFetchRows: debouncedFetchRows,
        strategyProcessor: {
            strategyName: $lBPh6.DataSourceRowsUpdateStrategy.Default,
            group: 'dataSourceRowsUpdate',
            processor: handleDataUpdate
        },
        setStrategyAvailability: setStrategyAvailability,
        startPolling: startPolling,
        stopPolling: stopPolling,
        cacheChunkManager: cacheChunkManager,
        cache: cache,
        events: {
            strategyAvailabilityChange: handleStrategyActivityChange,
            sortModelChange: (0, $lR3Vo.runIf)(standardRowsUpdateStrategyActive, handleFetchRowsOnParamsChange),
            filterModelChange: (0, $lR3Vo.runIf)(standardRowsUpdateStrategyActive, handleFetchRowsOnParamsChange),
            paginationModelChange: (0, $lR3Vo.runIf)(standardRowsUpdateStrategyActive, handleFetchRowsOnParamsChange)
        }
    };
};
module.exports.useGridDataSourceBase = $7f15f7d4e3cc4be4$var$useGridDataSourceBase;

});
parcelRegister("6x4PY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gridGetRowsParamsSelector = void 0;

var $k278Q = parcelRequire("k278Q");

var $iU3u2 = parcelRequire("iU3u2");

var $gPWuj = parcelRequire("gPWuj");

var $cgQ4y = parcelRequire("cgQ4y");
const $4c1993bfb47621ad$var$gridGetRowsParamsSelector = module.exports.gridGetRowsParamsSelector = (0, $cgQ4y.createSelector)($k278Q.gridFilterModelSelector, $iU3u2.gridSortModelSelector, $gPWuj.gridPaginationModelSelector, (filterModel, sortModel, paginationModel)=>({
        groupKeys: [],
        paginationModel: paginationModel,
        sortModel: sortModel,
        filterModel: filterModel,
        start: paginationModel.page * paginationModel.pageSize,
        end: paginationModel.page * paginationModel.pageSize + paginationModel.pageSize - 1
    }));

});

parcelRegister("lBPh6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fbb4d3ca918c8598$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataSourceRowsUpdateStrategy = module.exports.CacheChunkManager = void 0;

var $fbb4d3ca918c8598$var$_extends2 = $fbb4d3ca918c8598$require$_interopRequireDefault((parcelRequire("3p9rK")));
let $fbb4d3ca918c8598$var$DataSourceRowsUpdateStrategy = module.exports.DataSourceRowsUpdateStrategy = /*#__PURE__*/ function(DataSourceRowsUpdateStrategy) {
    DataSourceRowsUpdateStrategy["Default"] = "set-flat-rows";
    DataSourceRowsUpdateStrategy["LazyLoading"] = "replace-row-range";
    DataSourceRowsUpdateStrategy["GroupedData"] = "set-grouped-rows";
    return DataSourceRowsUpdateStrategy;
}({});
/**
 * Provides better cache hit rate by:
 * 1. Splitting the data into smaller chunks to be stored in the cache (cache `set`)
 * 2. Merging multiple cache entries into a single response to get the required chunk (cache `get`)
 */ class $fbb4d3ca918c8598$var$CacheChunkManager {
    /**
   * @param chunkSize The number of rows to store in each cache entry.
   * If not set, the whole array will be stored in a single cache entry.
   * Setting this value to smallest page size will result in better cache hit rate.
   * Has no effect if cursor pagination is used.
   */ constructor(chunkSize){
        this.chunkSize = chunkSize;
    }
    getCacheKeys = (key)=>{
        if (this.chunkSize < 1 || typeof key.start !== 'number') return [
            key
        ];
        // split the range into chunks
        const chunkedKeys = [];
        for(let i = key.start; i <= key.end; i += this.chunkSize){
            const end = Math.min(i + this.chunkSize - 1, key.end);
            chunkedKeys.push((0, $fbb4d3ca918c8598$var$_extends2.default)({}, key, {
                start: i,
                end: end
            }));
        }
        return chunkedKeys;
    };
    splitResponse = (key, response)=>{
        const cacheKeys = this.getCacheKeys(key);
        if (cacheKeys.length === 1) return new Map([
            [
                key,
                response
            ]
        ]);
        const responses = new Map();
        cacheKeys.forEach((chunkKey)=>{
            const isLastChunk = chunkKey.end === key.end;
            const responseSlice = (0, $fbb4d3ca918c8598$var$_extends2.default)({}, response, {
                pageInfo: (0, $fbb4d3ca918c8598$var$_extends2.default)({}, response.pageInfo, {
                    // If the original response had page info, update that information for all but last chunk and keep the original value for the last chunk
                    hasNextPage: response.pageInfo?.hasNextPage !== undefined && !isLastChunk ? true : response.pageInfo?.hasNextPage,
                    nextCursor: response.pageInfo?.nextCursor !== undefined && !isLastChunk ? response.rows[chunkKey.end + 1].id : response.pageInfo?.nextCursor
                }),
                rows: typeof chunkKey.start !== 'number' || typeof key.start !== 'number' ? response.rows : response.rows.slice(chunkKey.start - key.start, chunkKey.end - key.start + 1)
            });
            responses.set(chunkKey, responseSlice);
        });
        return responses;
    };
    static mergeResponses = (responses)=>{
        if (responses.length === 1) return responses[0];
        return responses.reduce((acc, response)=>(0, $fbb4d3ca918c8598$var$_extends2.default)({}, response, {
                rows: [
                    ...acc.rows,
                    ...response.rows
                ]
            }), {
            rows: [],
            rowCount: 0,
            pageInfo: {}
        });
    };
}
module.exports.CacheChunkManager = $fbb4d3ca918c8598$var$CacheChunkManager;

});




parcelRegister("hiKx5", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c9883683c395e213$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c9883683c395e213$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDataGridProps = void 0;

var $c9883683c395e213$var$_extends2 = $c9883683c395e213$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c9883683c395e213$var$React = $c9883683c395e213$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $izOUK = parcelRequire("izOUK");

var $7jHEF = parcelRequire("7jHEF");

var $fCO8m = parcelRequire("fCO8m");

var $94sAG = parcelRequire("94sAG");

var $1kYRD = parcelRequire("1kYRD");
const $c9883683c395e213$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid',
    listView: false
};
const $c9883683c395e213$var$getDataGridForcedProps = (themedProps)=>(0, $c9883683c395e213$var$_extends2.default)({}, $c9883683c395e213$var$DATA_GRID_FORCED_PROPS, themedProps.dataSource ? {
        filterMode: 'server',
        sortingMode: 'server',
        paginationMode: 'server'
    } : {});
const $c9883683c395e213$var$defaultSlots = $fCO8m.DATA_GRID_DEFAULT_SLOTS_COMPONENTS;
const $c9883683c395e213$var$useDataGridProps = (inProps)=>{
    const theme = (0, $8xDHs.useTheme)();
    const themedProps = $c9883683c395e213$var$React.useMemo(()=>(0, $izOUK.getThemeProps)({
            props: inProps,
            theme: theme,
            name: 'MuiDataGrid'
        }), [
        theme,
        inProps
    ]);
    const localeText = $c9883683c395e213$var$React.useMemo(()=>(0, $c9883683c395e213$var$_extends2.default)({}, $7jHEF.GRID_DEFAULT_LOCALE_TEXT, themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $c9883683c395e213$var$React.useMemo(()=>(0, $94sAG.computeSlots)({
            defaultSlots: $c9883683c395e213$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    const injectDefaultProps = $c9883683c395e213$var$React.useMemo(()=>{
        return Object.keys($1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES).reduce((acc, key)=>{
            // @ts-ignore
            acc[key] = themedProps[key] ?? $1kYRD.DATA_GRID_PROPS_DEFAULT_VALUES[key];
            return acc;
        }, {});
    }, [
        themedProps
    ]);
    return $c9883683c395e213$var$React.useMemo(()=>(0, $c9883683c395e213$var$_extends2.default)({}, themedProps, injectDefaultProps, {
            localeText: localeText,
            slots: slots
        }, $c9883683c395e213$var$getDataGridForcedProps(themedProps)), [
        themedProps,
        localeText,
        slots,
        injectDefaultProps
    ]);
};
module.exports.useDataGridProps = $c9883683c395e213$var$useDataGridProps;

});
parcelRegister("fCO8m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b6014b2d4bf32573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DATA_GRID_DEFAULT_SLOTS_COMPONENTS = void 0;

var $b6014b2d4bf32573$var$_extends2 = $b6014b2d4bf32573$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $Lyax4 = parcelRequire("Lyax4");

var $6X2NG = parcelRequire("6X2NG");

var $sLaj5 = parcelRequire("sLaj5");

var $59mZx = parcelRequire("59mZx");

var $juiwS = parcelRequire("juiwS");

var $3sytP = parcelRequire("3sytP");

var $eaFJs = parcelRequire("eaFJs");

var $b6014b2d4bf32573$var$_material = $b6014b2d4bf32573$require$_interopRequireDefault((parcelRequire("9lhjy")));

var $1GTuR = parcelRequire("1GTuR");

var $dR2yi = parcelRequire("dR2yi");
// TODO: camelCase these key. It's a private helper now.
// Remove then need to call `uncapitalizeObjectKeys`.
const $b6014b2d4bf32573$var$DATA_GRID_DEFAULT_SLOTS_COMPONENTS = module.exports.DATA_GRID_DEFAULT_SLOTS_COMPONENTS = (0, $b6014b2d4bf32573$var$_extends2.default)({}, $b6014b2d4bf32573$var$_material.default, {
    cell: $6X2NG.GridCell,
    skeletonCell: $Lyax4.GridSkeletonCell,
    columnHeaderFilterIconButton: $Lyax4.GridColumnHeaderFilterIconButton,
    columnHeaderSortIcon: $Lyax4.GridColumnHeaderSortIcon,
    columnMenu: $59mZx.GridColumnMenu,
    columnHeaders: $sLaj5.GridColumnHeaders,
    detailPanels: $juiwS.GridDetailPanels,
    bottomContainer: $1GTuR.GridBottomContainer,
    footer: $Lyax4.GridFooter,
    footerRowCount: $Lyax4.GridRowCount,
    toolbar: $dR2yi.GridToolbar,
    pinnedRows: $3sytP.GridPinnedRows,
    loadingOverlay: $Lyax4.GridLoadingOverlay,
    noResultsOverlay: $eaFJs.GridNoResultsOverlay,
    noRowsOverlay: $Lyax4.GridNoRowsOverlay,
    noColumnsOverlay: $Lyax4.GridNoColumnsOverlay,
    pagination: $Lyax4.GridPagination,
    filterPanel: $Lyax4.GridFilterPanel,
    columnsPanel: $Lyax4.GridColumnsPanel,
    columnsManagement: $Lyax4.GridColumnsManagement,
    panel: $Lyax4.GridPanel,
    row: $Lyax4.GridRow
});

});
parcelRegister("sLaj5", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $056733ac91e6ea07$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $056733ac91e6ea07$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnHeaders = void 0;

var $056733ac91e6ea07$var$_extends2 = $056733ac91e6ea07$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $056733ac91e6ea07$var$_objectWithoutPropertiesLoose2 = $056733ac91e6ea07$require$_interopRequireDefault((parcelRequire("c05no")));

var $056733ac91e6ea07$var$React = $056733ac91e6ea07$require$_interopRequireWildcard((parcelRequire("acw62")));

var $056733ac91e6ea07$var$_propTypes = $056733ac91e6ea07$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2nKmT = parcelRequire("2nKmT");

var $fYxgT = parcelRequire("fYxgT");

var $hlKix = parcelRequire("hlKix");

var $2fAdp = parcelRequire("2fAdp");

var $ayMG0 = parcelRequire("ayMG0");
const $056733ac91e6ea07$var$_excluded = [
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $056733ac91e6ea07$var$GridColumnHeaders = (0, $fYxgT.forwardRef)(function GridColumnHeaders(props, ref) {
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $056733ac91e6ea07$var$_objectWithoutPropertiesLoose2.default)(props, $056733ac91e6ea07$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $hlKix.useGridColumnHeaders)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2fAdp.GridBaseColumnHeaders, (0, $056733ac91e6ea07$var$_extends2.default)({}, other, getInnerProps(), {
        ref: ref,
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow()
        ]
    }));
});
const $056733ac91e6ea07$var$MemoizedGridColumnHeaders = module.exports.GridColumnHeaders = (0, $2nKmT.fastMemo)($056733ac91e6ea07$var$GridColumnHeaders);

});
parcelRegister("hlKix", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ca184fa0bded5702$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ca184fa0bded5702$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useGridColumnHeaders = module.exports.GridColumnHeaderRow = void 0;

var $ca184fa0bded5702$var$_extends2 = $ca184fa0bded5702$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ca184fa0bded5702$var$React = $ca184fa0bded5702$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ca184fa0bded5702$var$_clsx = $ca184fa0bded5702$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $l8hgY = parcelRequire("l8hgY");

var $5LeoO = parcelRequire("5LeoO");

var $jDpXp = parcelRequire("jDpXp");

var $er55f = parcelRequire("er55f");

var $g8PwW = parcelRequire("g8PwW");

var $bfoLE = parcelRequire("bfoLE");

var $61HyH = parcelRequire("61HyH");

var $cMkcn = parcelRequire("cMkcn");

var $kAYrj = parcelRequire("kAYrj");

var $jy68d = parcelRequire("jy68d");

var $hMyIf = parcelRequire("hMyIf");

var $cunsT = parcelRequire("cunsT");

var $jWPPy = parcelRequire("jWPPy");

var $c0AIV = parcelRequire("c0AIV");

var $5H1vo = parcelRequire("5H1vo");

var $lbNvN = parcelRequire("lbNvN");

var $jZka4 = parcelRequire("jZka4");

var $ayMG0 = parcelRequire("ayMG0");
const $ca184fa0bded5702$var$GridColumnHeaderRow = module.exports.GridColumnHeaderRow = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow'
})({
    display: 'flex'
});
const $ca184fa0bded5702$var$useGridColumnHeaders = (props)=>{
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const [dragCol, setDragCol] = $ca184fa0bded5702$var$React.useState('');
    const [resizeCol, setResizeCol] = $ca184fa0bded5702$var$React.useState('');
    const apiRef = (0, $er55f.useGridPrivateApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const columnGroupsModel = (0, $5LeoO.useGridSelector)(apiRef, $hMyIf.gridColumnGroupsUnwrappedModelSelector);
    const columnPositions = (0, $5LeoO.useGridSelector)(apiRef, $jy68d.gridColumnPositionsSelector);
    const renderContext = (0, $5LeoO.useGridSelector)(apiRef, $cMkcn.gridRenderContextColumnsSelector);
    const pinnedColumns = (0, $5LeoO.useGridSelector)(apiRef, $jy68d.gridVisiblePinnedColumnDefinitionsSelector);
    const columnsLookup = (0, $5LeoO.useGridSelector)(apiRef, $jy68d.gridColumnLookupSelector);
    const offsetLeft = (0, $l8hgY.computeOffsetLeft)(columnPositions, renderContext, pinnedColumns.left.length);
    const columnsTotalWidth = (0, $5LeoO.useGridSelector)(apiRef, $61HyH.gridColumnsTotalWidthSelector);
    const gridHasFiller = (0, $5LeoO.useGridSelector)(apiRef, $61HyH.gridHasFillerSelector);
    const headerHeight = (0, $5LeoO.useGridSelector)(apiRef, $61HyH.gridHeaderHeightSelector);
    const groupHeaderHeight = (0, $5LeoO.useGridSelector)(apiRef, $61HyH.gridGroupHeaderHeightSelector);
    const scrollbarWidth = (0, $5LeoO.useGridSelector)(apiRef, $61HyH.gridVerticalScrollbarWidthSelector);
    const handleColumnResizeStart = $ca184fa0bded5702$var$React.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $ca184fa0bded5702$var$React.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $ca184fa0bded5702$var$React.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $ca184fa0bded5702$var$React.useCallback(()=>setDragCol(''), []);
    const leftRenderContext = $ca184fa0bded5702$var$React.useMemo(()=>{
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    const rightRenderContext = $ca184fa0bded5702$var$React.useMemo(()=>{
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $g8PwW.useGridEvent)(apiRef, 'columnHeaderDragEndNative', handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: currentContext = renderContext } = params || {};
        const firstColumnToRender = currentContext.firstColumnIndex;
        // HACK: renderContext ins't always synchronized, this should be handled properly.
        const lastColumnToRender = Math.min(currentContext.lastColumnIndex, visibleColumns.length);
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    const getFillers = (params, children, leftOverflow, borderBottom = false)=>{
        const isPinnedRight = params?.position === $jZka4.PinnedColumnPosition.RIGHT;
        const isNotPinned = params?.position === undefined;
        const hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        const leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$var$React.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "presentation",
                    className: (0, $ca184fa0bded5702$var$_clsx.default)($5H1vo.gridClasses.filler, borderBottom && $5H1vo.gridClasses['filler--borderBottom'])
                }),
                hasScrollbarFiller && /*#__PURE__*/ (0, $ayMG0.jsx)($cunsT.GridScrollbarFillerCell, {
                    pinnedRight: isPinnedRight
                })
            ]
        });
    };
    const getColumnHeaders = (params, other = {})=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            const pinnedPosition = params?.position;
            const pinnedOffset = (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            const siblingWithBorderingSeparator = pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT ? renderedColumns[i - 1] : renderedColumns[i + 1];
            const isSiblingFocused = siblingWithBorderingSeparator ? columnHeaderFocus !== null && columnHeaderFocus.field === siblingWithBorderingSeparator.field : false;
            const indexInSection = i;
            const sectionLength = renderedColumns.length;
            const showLeftBorder = (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, indexInSection, rootProps.showColumnVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
            const showRightBorder = (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
            columns.push(/*#__PURE__*/ (0, $ayMG0.jsx)($bfoLE.GridColumnHeaderItem, (0, $ca184fa0bded5702$var$_extends2.default)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                isSiblingFocused: isSiblingFocused,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    const getColumnHeadersRow = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$var$GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            className: $5H1vo.gridClasses['row--borderBottom'],
            style: {
                height: headerHeight
            },
            children: [
                leftRenderContext && getColumnHeaders({
                    position: $jZka4.PinnedColumnPosition.LEFT,
                    renderContext: leftRenderContext
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext
                }),
                rightRenderContext && getColumnHeaders({
                    position: $jZka4.PinnedColumnPosition.RIGHT,
                    renderContext: rightRenderContext
                }, {
                    disableReorder: true,
                    separatorSide: $c0AIV.GridColumnHeaderSeparatorSides.Left
                })
            ]
        });
    };
    const getColumnGroupHeaders = ({ depth: depth, params: params })=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const rowStructure = columnGroupsHeaderStructure[depth];
        const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        const firstGroupToRender = columnGroupsModel[firstColumnFieldToRender]?.[depth] ?? null;
        const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
        const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        const lastGroupToRender = columnGroupsModel[lastColumnFieldToRender]?.[depth] ?? null;
        const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
        const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
            return (0, $ca184fa0bded5702$var$_extends2.default)({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
            });
        }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
        const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
            const column = columnsLookup[field];
            return acc + (column.computedWidth ?? 0);
        }, 0);
        let columnIndex = firstColumnToRender;
        const children = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields }, index)=>{
            const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            const headerInfo = {
                groupId: groupId,
                width: columnFields.reduce((acc, field)=>acc + columnsLookup[field].computedWidth, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            const pinnedPosition = params.position;
            const pinnedOffset = (0, $jWPPy.getPinnedCellOffset)(pinnedPosition, headerInfo.width, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            columnIndex += columnFields.length;
            let indexInSection = index;
            if (pinnedPosition === $jZka4.PinnedColumnPosition.LEFT) // Group headers can expand to multiple columns, we need to adjust the index
            indexInSection = columnIndex - 1;
            return /*#__PURE__*/ (0, $ayMG0.jsx)($kAYrj.GridColumnGroupHeader, {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: index === visibleColumnGroupHeader.length - 1,
                maxDepth: headerGroupingMaxDepth,
                height: groupHeaderHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: (0, $lbNvN.shouldCellShowLeftBorder)(pinnedPosition, indexInSection, rootProps.showColumnVerticalBorder, rootProps.pinnedColumnsSectionSeparator),
                showRightBorder: (0, $lbNvN.shouldCellShowRightBorder)(pinnedPosition, indexInSection, visibleColumnGroupHeader.length, rootProps.showColumnVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator)
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    const getColumnGroupHeadersRows = ()=>{
        if (headerGroupingMaxDepth === 0) return null;
        const headerRows = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1)headerRows.push(/*#__PURE__*/ (0, $ayMG0.jsxs)($ca184fa0bded5702$var$GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": depth + 1,
            ownerState: rootProps,
            style: {
                height: groupHeaderHeight
            },
            children: [
                leftRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: $jZka4.PinnedColumnPosition.LEFT,
                        renderContext: leftRenderContext,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }
                }),
                getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        renderContext: renderContext
                    }
                }),
                rightRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: $jZka4.PinnedColumnPosition.RIGHT,
                        renderContext: rightRenderContext,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }
                })
            ]
        }, depth));
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        columnPositions: columnPositions,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        getPinnedCellOffset: $jWPPy.getPinnedCellOffset,
        isDragging: !!dragCol,
        getInnerProps: ()=>({
                role: 'rowgroup'
            })
    };
};
module.exports.useGridColumnHeaders = $ca184fa0bded5702$var$useGridColumnHeaders;

});
parcelRegister("kAYrj", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $efe60d7621886a65$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $efe60d7621886a65$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnGroupHeader = $efe60d7621886a65$var$GridColumnGroupHeader;

var $efe60d7621886a65$var$_extends2 = $efe60d7621886a65$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $efe60d7621886a65$var$React = $efe60d7621886a65$require$_interopRequireWildcard((parcelRequire("acw62")));

var $efe60d7621886a65$var$_useId = $efe60d7621886a65$require$_interopRequireDefault((parcelRequire("hwliF")));

var $efe60d7621886a65$var$_composeClasses = $efe60d7621886a65$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $g2vKb = parcelRequire("g2vKb");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $hMyIf = parcelRequire("hMyIf");

var $bDyDY = parcelRequire("bDyDY");

var $5sOMZ = parcelRequire("5sOMZ");

var $4cOaX = parcelRequire("4cOaX");

var $KtEo5 = parcelRequire("KtEo5");

var $jZka4 = parcelRequire("jZka4");

var $94sAG = parcelRequire("94sAG");

var $ayMG0 = parcelRequire("ayMG0");
const $efe60d7621886a65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, isLastColumn: isLastColumn, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, groupId: groupId, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup',
            pinnedPosition === $jZka4.PinnedColumnPosition.LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === $jZka4.PinnedColumnPosition.RIGHT && 'columnHeader--pinnedRight',
            isLastColumn && 'columnHeader--last'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $efe60d7621886a65$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
function $efe60d7621886a65$var$GridColumnGroupHeader(props) {
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const isRtl = (0, $9uEev.useRtl)();
    const headerCellRef = $efe60d7621886a65$var$React.useRef(null);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const columnGroupsLookup = (0, $5sOMZ.useGridSelector)(apiRef, $hMyIf.gridColumnGroupsLookupSelector);
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId ?? '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && columnGroupsLookup[groupId]?.renderHeaderGroup;
    const renderParams = $efe60d7621886a65$var$React.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const ownerState = (0, $efe60d7621886a65$var$_extends2.default)({}, props, {
        classes: rootProps.classes,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName ?? groupId;
    const id = (0, $efe60d7621886a65$var$_useId.default)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $efe60d7621886a65$var$useUtilityClasses(ownerState);
    $efe60d7621886a65$var$React.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $g2vKb.doesSupportPreventScroll)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $efe60d7621886a65$var$React.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $KtEo5.isEventTargetInPortal)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $efe60d7621886a65$var$React.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    const style = $efe60d7621886a65$var$React.useMemo(()=>(0, $94sAG.attachPinnedStyle)((0, $efe60d7621886a65$var$_extends2.default)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4cOaX.GridGenericColumnHeaderItem, (0, $efe60d7621886a65$var$_extends2.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`,
        style: style
    }, mouseEventsHandlers));
}

});

parcelRegister("cunsT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $917a7d0f9d31e9dd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridScrollbarFillerCell = $917a7d0f9d31e9dd$var$GridScrollbarFillerCell;

var $917a7d0f9d31e9dd$var$_clsx = $917a7d0f9d31e9dd$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7jHEF = parcelRequire("7jHEF");

var $ayMG0 = parcelRequire("ayMG0");
const $917a7d0f9d31e9dd$var$classes = {
    root: $7jHEF.gridClasses.scrollbarFiller,
    pinnedRight: $7jHEF.gridClasses['scrollbarFiller--pinnedRight']
};
function $917a7d0f9d31e9dd$var$GridScrollbarFillerCell({ pinnedRight: pinnedRight }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "presentation",
        className: (0, $917a7d0f9d31e9dd$var$_clsx.default)($917a7d0f9d31e9dd$var$classes.root, pinnedRight && $917a7d0f9d31e9dd$var$classes.pinnedRight)
    });
}

});


parcelRegister("2fAdp", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1a39131620112653$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1a39131620112653$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridBaseColumnHeaders = void 0;

var $1a39131620112653$var$_extends2 = $1a39131620112653$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1a39131620112653$var$_objectWithoutPropertiesLoose2 = $1a39131620112653$require$_interopRequireDefault((parcelRequire("c05no")));

var $1a39131620112653$var$React = $1a39131620112653$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1a39131620112653$var$_clsx = $1a39131620112653$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1a39131620112653$var$_composeClasses = $1a39131620112653$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $izOUK = parcelRequire("izOUK");

var $fYxgT = parcelRequire("fYxgT");

var $5H1vo = parcelRequire("5H1vo");

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $1a39131620112653$var$_excluded = [
    "className"
];
const $1a39131620112653$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders'
        ]
    };
    return (0, $1a39131620112653$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, classes);
};
const $1a39131620112653$var$GridColumnHeadersRoot = (0, $izOUK.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders'
})({
    display: 'flex',
    flexDirection: 'column',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $1a39131620112653$var$GridBaseColumnHeaders = module.exports.GridBaseColumnHeaders = (0, $fYxgT.forwardRef)(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $1a39131620112653$var$_objectWithoutPropertiesLoose2.default)(props, $1a39131620112653$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const classes = $1a39131620112653$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1a39131620112653$var$GridColumnHeadersRoot, (0, $1a39131620112653$var$_extends2.default)({
        className: (0, $1a39131620112653$var$_clsx.default)(classes.root, className),
        ownerState: rootProps
    }, other, {
        role: "presentation",
        ref: ref
    }));
});

});


parcelRegister("juiwS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridDetailPanels = $e2ff31365723feed$var$GridDetailPanels;
function $e2ff31365723feed$var$GridDetailPanels(_) {
    return null;
}

});

parcelRegister("3sytP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridPinnedRows = $284ebba9b1828a42$var$GridPinnedRows;
function $284ebba9b1828a42$var$GridPinnedRows(_) {
    return null;
}

});

parcelRegister("eaFJs", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a5125f04ce420a8f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridNoResultsOverlay = void 0;

var $a5125f04ce420a8f$var$_extends2 = $a5125f04ce420a8f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fYxgT = parcelRequire("fYxgT");

var $bDyDY = parcelRequire("bDyDY");

var $809Ep = parcelRequire("809Ep");

var $ayMG0 = parcelRequire("ayMG0");
const $a5125f04ce420a8f$var$GridNoResultsOverlay = module.exports.GridNoResultsOverlay = (0, $fYxgT.forwardRef)(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($809Ep.GridOverlay, (0, $a5125f04ce420a8f$var$_extends2.default)({}, props, {
        ref: ref,
        children: noResultsOverlayLabel
    }));
});

});

parcelRegister("9lhjy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6cd3818014b55356$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6cd3818014b55356$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "useMaterialCSSVariables", {
    enumerable: true,
    get: function() {
        return $5LM2M.useMaterialCSSVariables;
    }
});

var $6cd3818014b55356$var$_extends2 = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6cd3818014b55356$var$_objectWithoutPropertiesLoose2 = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("c05no")));

var $6cd3818014b55356$var$React = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6cd3818014b55356$var$_clsx = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("9QePP")));

var $6cd3818014b55356$var$_useForkRef = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $6cd3818014b55356$var$_useEventCallback = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $8xDHs = parcelRequire("8xDHs");

var $6cd3818014b55356$var$_Autocomplete = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("aBB4t")));

var $6cd3818014b55356$var$_Badge = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("lgIyK")));

var $6cd3818014b55356$var$_Checkbox = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("aGDqy")));

var $6cd3818014b55356$var$_Chip = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("6p5K7")));

var $6cd3818014b55356$var$_CircularProgress = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("1sBf1")));

var $6cd3818014b55356$var$_Divider = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("g6BeY")));

var $6cd3818014b55356$var$_InputBase = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $6cd3818014b55356$var$_Unstable_TrapFocus = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("c94Y8")));

var $6cd3818014b55356$var$_LinearProgress = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("2vsem")));

var $6cd3818014b55356$var$_ListItemIcon = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("2fe4K")));

var $6cd3818014b55356$var$_ListItemText = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("djLZl")));

var $6cd3818014b55356$var$_MenuList = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $6cd3818014b55356$var$_MenuItem = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $6cd3818014b55356$var$_TextField = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("hABDe")));

var $6cd3818014b55356$var$_TextareaAutosize = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("3vH0x")));

var $6cd3818014b55356$var$_FormControl = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("iA4iQ")));

var $6cd3818014b55356$var$_FormControlLabel = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("i48ne")));

var $6cd3818014b55356$var$_Select = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("dALxx")));

var $6cd3818014b55356$var$_Switch = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("5QQ7K")));

var $6cd3818014b55356$var$_Button = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("bBQKz")));

var $6cd3818014b55356$var$_IconButton = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("825Zh")));

var $6cd3818014b55356$var$_InputAdornment = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("9bswS")));

var $6cd3818014b55356$var$_Tooltip = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("tEWAm")));

var $6cd3818014b55356$var$_TablePagination = $6cd3818014b55356$require$_interopRequireWildcard((parcelRequire("b3HhA")));

var $6cd3818014b55356$var$_Popper = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $6cd3818014b55356$var$_ClickAwayListener = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("7Ke9B")));

var $6cd3818014b55356$var$_Grow = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $6cd3818014b55356$var$_Paper = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $6cd3818014b55356$var$_InputLabel = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("k9xmz")));

var $6cd3818014b55356$var$_Skeleton = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("eTbCT")));

var $6cd3818014b55356$var$_Tabs = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("dKcJh")));

var $6cd3818014b55356$var$_Tab = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("90blG")));

var $6cd3818014b55356$var$_ToggleButton = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("xwCPt")));

var $fYxgT = parcelRequire("fYxgT");

var $6cd3818014b55356$var$_useId = $6cd3818014b55356$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fWql6 = parcelRequire("fWql6");

var $i9HdC = parcelRequire("i9HdC");

var $bDyDY = parcelRequire("bDyDY");

var $jDpXp = parcelRequire("jDpXp");


var $ayMG0 = parcelRequire("ayMG0");

var $5LM2M = parcelRequire("5LM2M");
const $6cd3818014b55356$var$_excluded = [
    "id",
    "label",
    "labelId",
    "material",
    "disabled",
    "slotProps",
    "onChange",
    "onKeyDown",
    "onOpen",
    "onClose",
    "size",
    "style",
    "fullWidth"
], $6cd3818014b55356$var$_excluded2 = [
    "onRowsPerPageChange",
    "material",
    "disabled"
], $6cd3818014b55356$var$_excluded3 = [
    "material"
], $6cd3818014b55356$var$_excluded4 = [
    "autoFocus",
    "label",
    "fullWidth",
    "slotProps",
    "className",
    "material"
], $6cd3818014b55356$var$_excluded5 = [
    "material"
], $6cd3818014b55356$var$_excluded6 = [
    "material"
], $6cd3818014b55356$var$_excluded7 = [
    "material"
], $6cd3818014b55356$var$_excluded8 = [
    "material"
], $6cd3818014b55356$var$_excluded9 = [
    "material"
], $6cd3818014b55356$var$_excluded0 = [
    "material"
], $6cd3818014b55356$var$_excluded1 = [
    "material"
], $6cd3818014b55356$var$_excluded10 = [
    "material"
], $6cd3818014b55356$var$_excluded11 = [
    "material"
], $6cd3818014b55356$var$_excluded12 = [
    "material",
    "label",
    "className"
], $6cd3818014b55356$var$_excluded13 = [
    "material"
], $6cd3818014b55356$var$_excluded14 = [
    "inert",
    "iconStart",
    "iconEnd",
    "children",
    "material"
], $6cd3818014b55356$var$_excluded15 = [
    "slotProps",
    "material"
], $6cd3818014b55356$var$_excluded16 = [
    "id",
    "multiple",
    "freeSolo",
    "options",
    "getOptionLabel",
    "isOptionEqualToValue",
    "value",
    "onChange",
    "label",
    "placeholder",
    "slotProps",
    "material"
], $6cd3818014b55356$var$_excluded17 = [
    "key"
], $6cd3818014b55356$var$_excluded18 = [
    "inputProps",
    "InputProps",
    "InputLabelProps"
], $6cd3818014b55356$var$_excluded19 = [
    "slotProps",
    "material"
], $6cd3818014b55356$var$_excluded20 = [
    "material"
], $6cd3818014b55356$var$_excluded21 = [
    "ref",
    "open",
    "children",
    "className",
    "clickAwayTouchEvent",
    "clickAwayMouseEvent",
    "flip",
    "focusTrap",
    "onExited",
    "onClickAway",
    "onDidShow",
    "onDidHide",
    "id",
    "target",
    "transition",
    "placement",
    "material"
], $6cd3818014b55356$var$_excluded22 = [
    "native"
], $6cd3818014b55356$var$_excluded23 = [
    "children",
    "value",
    "active"
], $6cd3818014b55356$var$_excluded24 = [
    "items",
    "value",
    "material"
];
/* eslint-disable material-ui/disallow-react-api-in-server-components */ const $6cd3818014b55356$var$InputAdornment = (0, $8xDHs.styled)($6cd3818014b55356$var$_InputAdornment.default, {
    slot: 'internal'
})(({ theme: theme })=>({
        [`&.${$6cd3818014b55356$var$_InputAdornment.inputAdornmentClasses.positionEnd} .${$6cd3818014b55356$var$_IconButton.iconButtonClasses.sizeSmall}`]: {
            marginRight: theme.spacing(-0.75)
        }
    }));
const $6cd3818014b55356$var$FormControlLabel = (0, $8xDHs.styled)($6cd3818014b55356$var$_FormControlLabel.default, {
    slot: 'internal',
    shouldForwardProp: (prop)=>prop !== 'fullWidth'
})(({ theme: theme })=>({
        gap: theme.spacing(0.5),
        margin: 0,
        overflow: 'hidden',
        [`& .${$6cd3818014b55356$var$_FormControlLabel.formControlLabelClasses.label}`]: {
            fontSize: theme.typography.pxToRem(14),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $6cd3818014b55356$var$Checkbox = (0, $8xDHs.styled)($6cd3818014b55356$var$_Checkbox.default, {
    slot: 'internal',
    shouldForwardProp: (prop)=>prop !== 'density'
})(({ theme: theme })=>({
        variants: [
            {
                props: {
                    density: 'compact'
                },
                style: {
                    padding: theme.spacing(0.5)
                }
            }
        ]
    }));
const $6cd3818014b55356$var$ListItemText = (0, $8xDHs.styled)($6cd3818014b55356$var$_ListItemText.default, {
    slot: 'internal'
})({
    [`& .${$6cd3818014b55356$var$_ListItemText.listItemTextClasses.primary}`]: {
        overflowX: 'clip',
        textOverflow: 'ellipsis',
        maxWidth: '300px'
    }
});
const $6cd3818014b55356$var$BaseSelect = (0, $fYxgT.forwardRef)(function BaseSelect(props, ref) {
    const { id: id, label: label, labelId: labelId, material: material, disabled: disabled, slotProps: slotProps, onChange: onChange, onKeyDown: onKeyDown, onOpen: onOpen, onClose: onClose, size: size, style: style, fullWidth: fullWidth } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded);
    const theme = (0, $8xDHs.useTheme)();
    const textFieldDefaults = theme.components?.MuiTextField?.defaultProps ?? {};
    const computedSize = size ?? textFieldDefaults.size;
    const computedVariant = textFieldDefaults.variant ?? 'outlined';
    const menuProps = {
        PaperProps: {
            onKeyDown: onKeyDown
        }
    };
    if (onClose) menuProps.onClose = onClose;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6cd3818014b55356$var$_FormControl.default, {
        size: computedSize,
        fullWidth: fullWidth,
        style: style,
        disabled: disabled,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_InputLabel.default, {
                id: labelId,
                htmlFor: id,
                shrink: true,
                variant: computedVariant,
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Select.default, (0, $6cd3818014b55356$var$_extends2.default)({
                id: id,
                labelId: labelId,
                label: label,
                displayEmpty: true,
                onChange: onChange,
                variant: computedVariant
            }, other, {
                inputProps: slotProps?.htmlInput,
                onOpen: onOpen,
                MenuProps: menuProps,
                size: computedSize
            }, material))
        ]
    });
});
const $6cd3818014b55356$var$StyledPagination = (0, $8xDHs.styled)($6cd3818014b55356$var$_TablePagination.default, {
    slot: 'internal'
})(({ theme: theme })=>({
        [`& .${$6cd3818014b55356$var$_TablePagination.tablePaginationClasses.selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${$6cd3818014b55356$var$_TablePagination.tablePaginationClasses.input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const $6cd3818014b55356$var$BasePagination = (0, $fYxgT.forwardRef)(function BasePagination(props, ref) {
    const { onRowsPerPageChange: onRowsPerPageChange, material: material, disabled: disabled } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded2);
    const computedProps = $6cd3818014b55356$var$React.useMemo(()=>{
        if (!disabled) return undefined;
        return {
            backIconButtonProps: {
                disabled: true
            },
            nextIconButtonProps: {
                disabled: true
            }
        };
    }, [
        disabled
    ]);
    const apiRef = (0, $bDyDY.useGridApiContext)();
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { estimatedRowCount: estimatedRowCount } = rootProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledPagination, (0, $6cd3818014b55356$var$_extends2.default)({
        component: "div",
        onRowsPerPageChange: (0, $6cd3818014b55356$var$_useEventCallback.default)((event)=>{
            onRowsPerPageChange?.(Number(event.target.value));
        }),
        labelRowsPerPage: apiRef.current.getLocaleText('paginationRowsPerPage'),
        labelDisplayedRows: (params)=>apiRef.current.getLocaleText('paginationDisplayedRows')((0, $6cd3818014b55356$var$_extends2.default)({}, params, {
                estimated: estimatedRowCount
            })),
        getItemAriaLabel: apiRef.current.getLocaleText('paginationItemAriaLabel')
    }, computedProps, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseBadge = (0, $fYxgT.forwardRef)(function BaseBadge(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Badge.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseCheckbox = (0, $fYxgT.forwardRef)(function BaseCheckbox(props, ref) {
    const { autoFocus: autoFocus, label: label, fullWidth: fullWidth, slotProps: slotProps, className: className, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded4);
    const elementRef = $6cd3818014b55356$var$React.useRef(null);
    const handleRef = (0, $6cd3818014b55356$var$_useForkRef.default)(elementRef, ref);
    const rippleRef = $6cd3818014b55356$var$React.useRef(null);
    $6cd3818014b55356$var$React.useEffect(()=>{
        if (autoFocus) {
            const input = elementRef.current?.querySelector('input');
            input?.focus({
                preventScroll: true
            });
        } else if (autoFocus === false && rippleRef.current) // Only available in @mui/material v5.4.1 or later
        // @ts-ignore
        rippleRef.current.stop({});
    }, [
        autoFocus
    ]);
    if (!label) return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$Checkbox, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        className: (0, $6cd3818014b55356$var$_clsx.default)(className, material?.className),
        inputProps: slotProps?.htmlInput,
        ref: handleRef,
        touchRippleRef: rippleRef
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$FormControlLabel, {
        className: className,
        control: /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$Checkbox, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
            inputProps: slotProps?.htmlInput,
            ref: handleRef,
            touchRippleRef: rippleRef
        })),
        label: label,
        fullWidth: fullWidth
    });
});
const $6cd3818014b55356$var$BaseCircularProgress = (0, $fYxgT.forwardRef)(function BaseCircularProgress(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded5);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_CircularProgress.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseDivider = (0, $fYxgT.forwardRef)(function BaseDivider(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded6);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Divider.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseLinearProgress = (0, $fYxgT.forwardRef)(function BaseLinearProgress(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded7);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_LinearProgress.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseButton = (0, $fYxgT.forwardRef)(function BaseButton(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded8);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Button.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$StyledToggleButton = (0, $8xDHs.styled)($6cd3818014b55356$var$_ToggleButton.default, {
    slot: 'internal'
})(({ theme: theme })=>({
        gap: theme.spacing(1),
        border: 0
    }));
const $6cd3818014b55356$var$BaseToggleButton = (0, $fYxgT.forwardRef)(function BaseToggleButton(props, ref) {
    const { material: material } = props, rest = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded9);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledToggleButton, (0, $6cd3818014b55356$var$_extends2.default)({
        size: "small",
        color: "primary"
    }, rest, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseChip = (0, $fYxgT.forwardRef)(function BaseChip(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Chip.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseIconButton = (0, $fYxgT.forwardRef)(function BaseIconButton(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded1);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_IconButton.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseTooltip = (0, $fYxgT.forwardRef)(function BaseTooltip(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded10);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Tooltip.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseSkeleton = (0, $fYxgT.forwardRef)(function BaseSkeleton(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded11);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Skeleton.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$BaseSwitch = (0, $fYxgT.forwardRef)(function BaseSwitch(props, ref) {
    const { material: material, label: label, className: className } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded12);
    if (!label) return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Switch.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        className: className,
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$FormControlLabel, {
        className: className,
        control: /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Switch.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
            ref: ref
        })),
        label: label
    });
});
const $6cd3818014b55356$var$BaseMenuList = (0, $fYxgT.forwardRef)(function BaseMenuList(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded13);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_MenuList.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
function $6cd3818014b55356$var$BaseMenuItem(props) {
    const { inert: inert, iconStart: iconStart, iconEnd: iconEnd, children: children, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded14);
    if (inert) other.disableRipple = true;
    return /*#__PURE__*/ $6cd3818014b55356$var$React.createElement($6cd3818014b55356$var$_MenuItem.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material), [
        iconStart && /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_ListItemIcon.default, {
            children: iconStart
        }, "1"),
        /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$ListItemText, {
            children: children
        }, "2"),
        iconEnd && /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_ListItemIcon.default, {
            children: iconEnd
        }, "3")
    ]);
}
function $6cd3818014b55356$var$BaseTextField(props) {
    // MaterialUI v5 doesn't support slotProps, until we drop v5 support we need to
    // translate the pattern.
    const { slotProps: slotProps, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded15);
    const theme = (0, $8xDHs.useTheme)();
    const textFieldDefaults = theme.components?.MuiTextField?.defaultProps ?? {};
    const computedVariant = other.variant ?? textFieldDefaults.variant ?? 'outlined';
    const computedSize = other.size ?? textFieldDefaults.size;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_TextField.default, (0, $6cd3818014b55356$var$_extends2.default)({
        variant: computedVariant,
        size: computedSize
    }, other, material, {
        inputProps: slotProps?.htmlInput,
        InputProps: $6cd3818014b55356$var$transformInputProps(slotProps?.input),
        InputLabelProps: (0, $6cd3818014b55356$var$_extends2.default)({
            shrink: true
        }, slotProps?.inputLabel)
    }));
}
function $6cd3818014b55356$var$BaseAutocomplete(props) {
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const { id: id, multiple: multiple, freeSolo: freeSolo, options: options, getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, value: value, onChange: onChange, label: label, placeholder: placeholder, slotProps: slotProps, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded16);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Autocomplete.default, (0, $6cd3818014b55356$var$_extends2.default)({
        id: id,
        multiple: multiple,
        freeSolo: freeSolo,
        options: options,
        getOptionLabel: getOptionLabel,
        isOptionEqualToValue: isOptionEqualToValue,
        value: value,
        onChange: onChange,
        renderTags: (currentValue, getTagProps)=>currentValue.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(_getTagProps, $6cd3818014b55356$var$_excluded17);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Chip.default, (0, $6cd3818014b55356$var$_extends2.default)({
                    variant: "outlined",
                    size: "small",
                    label: typeof option === 'string' ? option : getOptionLabel?.(option)
                }, tagProps), key);
            }),
        renderInput: (params)=>{
            const { inputProps: inputProps, InputProps: InputProps, InputLabelProps: InputLabelProps } = params, inputRest = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(params, $6cd3818014b55356$var$_excluded18);
            return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_TextField.default, (0, $6cd3818014b55356$var$_extends2.default)({}, inputRest, {
                label: label,
                placeholder: placeholder,
                inputProps: inputProps,
                InputProps: $6cd3818014b55356$var$transformInputProps(InputProps, false),
                InputLabelProps: (0, $6cd3818014b55356$var$_extends2.default)({
                    shrink: true
                }, InputLabelProps)
            }, slotProps?.textField, rootProps.slotProps?.baseTextField));
        }
    }, other, material));
}
function $6cd3818014b55356$var$BaseInput(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_InputBase.default, (0, $6cd3818014b55356$var$_extends2.default)({}, $6cd3818014b55356$var$transformInputProps(props)));
}
function $6cd3818014b55356$var$transformInputProps(props, wrapAdornments = true) {
    if (!props) return undefined;
    const { slotProps: slotProps, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded19);
    const result = other;
    if (wrapAdornments) {
        if (result.startAdornment) result.startAdornment = /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$InputAdornment, {
            position: "start",
            children: result.startAdornment
        });
        if (result.endAdornment) result.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$InputAdornment, {
            position: "end",
            children: result.endAdornment
        });
    }
    for(const k in material)if (Object.hasOwn(material, k)) result[k] = material[k];
    if (slotProps?.htmlInput) {
        if (result.inputProps) result.inputProps = (0, $6cd3818014b55356$var$_extends2.default)({}, result.inputProps, slotProps?.htmlInput);
        else result.inputProps = slotProps?.htmlInput;
    }
    return result;
}
const $6cd3818014b55356$var$BaseTextarea = (0, $fYxgT.forwardRef)(function BaseTextarea(props, ref) {
    const { material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded20);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_TextareaAutosize.default, (0, $6cd3818014b55356$var$_extends2.default)({}, other, material, {
        ref: ref
    }));
});
const $6cd3818014b55356$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $6cd3818014b55356$var$BasePopper(props) {
    const { open: open, children: children, className: className, flip: flip, onExited: onExited, onDidShow: onDidShow, onDidHide: onDidHide, id: id, target: target, transition: transition, placement: placement, material: material } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded21);
    const modifiers = $6cd3818014b55356$var$React.useMemo(()=>{
        const result = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 8
                }
            }
        ];
        if (flip) result.push({
            name: 'flip',
            enabled: true
        });
        if (onDidShow || onDidHide) result.push({
            name: 'isPlaced',
            enabled: true,
            phase: 'main',
            fn: ()=>{
                onDidShow?.();
            },
            effect: ()=>()=>{
                    onDidHide?.();
                }
        });
        return result;
    }, [
        flip,
        onDidShow,
        onDidHide
    ]);
    let content;
    if (!transition) content = $6cd3818014b55356$var$wrappers(props, children);
    else {
        const handleExited = (popperOnExited)=>(node)=>{
                if (popperOnExited) popperOnExited();
                if (onExited) onExited(node);
            };
        content = (p)=>$6cd3818014b55356$var$wrappers(props, /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Grow.default, (0, $6cd3818014b55356$var$_extends2.default)({}, p.TransitionProps, {
                style: {
                    transformOrigin: $6cd3818014b55356$var$transformOrigin[p.placement]
                },
                onExited: handleExited(p.TransitionProps?.onExited),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Paper.default, {
                    children: children
                })
            })));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Popper.default, (0, $6cd3818014b55356$var$_extends2.default)({
        id: id,
        className: className,
        open: open,
        anchorEl: target,
        transition: transition,
        placement: placement,
        modifiers: modifiers
    }, other, material, {
        children: content
    }));
}
function $6cd3818014b55356$var$wrappers(props, content) {
    return $6cd3818014b55356$var$focusTrapWrapper(props, $6cd3818014b55356$var$clickAwayWrapper(props, content));
}
function $6cd3818014b55356$var$clickAwayWrapper(props, content) {
    if (props.onClickAway === undefined) return content;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_ClickAwayListener.default, {
        onClickAway: props.onClickAway,
        touchEvent: props.clickAwayTouchEvent,
        mouseEvent: props.clickAwayMouseEvent,
        children: content
    });
}
function $6cd3818014b55356$var$focusTrapWrapper(props, content) {
    if (props.focusTrap === undefined) return content;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_Unstable_TrapFocus.default, {
        open: true,
        disableEnforceFocus: true,
        disableAutoFocus: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            tabIndex: -1,
            children: content
        })
    });
}
function $6cd3818014b55356$var$BaseSelectOption(_ref) {
    let { native: native } = _ref, props = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(_ref, $6cd3818014b55356$var$_excluded22);
    if (native) return /*#__PURE__*/ (0, $ayMG0.jsx)("option", (0, $6cd3818014b55356$var$_extends2.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$_MenuItem.default, (0, $6cd3818014b55356$var$_extends2.default)({}, props));
}
const $6cd3818014b55356$var$StyledTabs = (0, $8xDHs.styled)($6cd3818014b55356$var$_Tabs.default, {
    name: 'MuiDataGrid',
    slot: 'Tabs'
})(({ theme: theme })=>({
        borderBottom: `1px solid ${theme.palette.divider}`
    }));
const $6cd3818014b55356$var$StyledTab = (0, $8xDHs.styled)($6cd3818014b55356$var$_Tab.default, {
    name: 'MuiDataGrid',
    slot: 'Tab'
})({
    flex: 1,
    minWidth: 'fit-content'
});
const $6cd3818014b55356$var$StyledTabPanel = (0, $8xDHs.styled)('div', {
    name: 'MuiDataGrid',
    slot: 'TabPanel'
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
});
function $6cd3818014b55356$var$TabPanel(props) {
    const { children: children, active: active } = props, other = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(props, $6cd3818014b55356$var$_excluded23);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledTabPanel, (0, $6cd3818014b55356$var$_extends2.default)({
        role: "tabpanel",
        style: {
            display: active ? 'flex' : 'none'
        }
    }, other, {
        children: children
    }));
}
function $6cd3818014b55356$var$BaseTabs(_ref2) {
    let { items: items, value: value, material: material } = _ref2, props = (0, $6cd3818014b55356$var$_objectWithoutPropertiesLoose2.default)(_ref2, $6cd3818014b55356$var$_excluded24);
    const id = (0, $6cd3818014b55356$var$_useId.default)();
    const labelId = `${id}-tab-${value}`;
    const panelId = `${id}-tabpanel-${value}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6cd3818014b55356$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledTabs, (0, $6cd3818014b55356$var$_extends2.default)({}, props, {
                value: value,
                variant: "scrollable",
                scrollButtons: "auto"
            }, material, {
                children: items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$StyledTab, {
                        value: item.value,
                        label: item.label,
                        id: labelId,
                        "aria-controls": panelId
                    }, item.value))
            })),
            items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6cd3818014b55356$var$TabPanel, {
                    value: item.value,
                    active: value === item.value,
                    id: panelId,
                    "aria-labelledby": labelId,
                    children: item.children
                }, item.value))
        ]
    });
}
const $6cd3818014b55356$var$iconSlots = {
    booleanCellTrueIcon: $fWql6.GridCheckIcon,
    booleanCellFalseIcon: $fWql6.GridCloseIcon,
    columnMenuIcon: $fWql6.GridTripleDotsVerticalIcon,
    openFilterButtonIcon: $fWql6.GridFilterListIcon,
    filterPanelDeleteIcon: $fWql6.GridCloseIcon,
    undoIcon: $fWql6.GridUndoIcon,
    redoIcon: $fWql6.GridRedoIcon,
    columnFilteredIcon: $fWql6.GridFilterAltIcon,
    columnSelectorIcon: $fWql6.GridColumnIcon,
    columnUnsortedIcon: $i9HdC.GridColumnUnsortedIcon,
    columnSortedAscendingIcon: $fWql6.GridArrowUpwardIcon,
    columnSortedDescendingIcon: $fWql6.GridArrowDownwardIcon,
    columnResizeIcon: $fWql6.GridSeparatorIcon,
    densityCompactIcon: $fWql6.GridViewHeadlineIcon,
    densityStandardIcon: $fWql6.GridTableRowsIcon,
    densityComfortableIcon: $fWql6.GridViewStreamIcon,
    exportIcon: $fWql6.GridDownloadIcon,
    moreActionsIcon: $fWql6.GridMoreVertIcon,
    treeDataCollapseIcon: $fWql6.GridExpandMoreIcon,
    treeDataExpandIcon: $fWql6.GridKeyboardArrowRight,
    groupingCriteriaCollapseIcon: $fWql6.GridExpandMoreIcon,
    groupingCriteriaExpandIcon: $fWql6.GridKeyboardArrowRight,
    detailPanelExpandIcon: $fWql6.GridAddIcon,
    detailPanelCollapseIcon: $fWql6.GridRemoveIcon,
    rowReorderIcon: $fWql6.GridDragIcon,
    quickFilterIcon: $fWql6.GridSearchIcon,
    quickFilterClearIcon: $fWql6.GridClearIcon,
    columnMenuHideIcon: $fWql6.GridVisibilityOffIcon,
    columnMenuSortAscendingIcon: $fWql6.GridArrowUpwardIcon,
    columnMenuSortDescendingIcon: $fWql6.GridArrowDownwardIcon,
    columnMenuUnsortIcon: null,
    columnMenuFilterIcon: $fWql6.GridFilterAltIcon,
    columnMenuManageColumnsIcon: $fWql6.GridViewColumnIcon,
    columnMenuClearIcon: $fWql6.GridClearIcon,
    loadIcon: $fWql6.GridLoadIcon,
    filterPanelAddIcon: $fWql6.GridAddIcon,
    filterPanelRemoveAllIcon: $fWql6.GridDeleteForeverIcon,
    columnReorderIcon: $fWql6.GridDragIcon,
    menuItemCheckIcon: $fWql6.GridCheckIcon,
    longTextCellExpandIcon: $fWql6.GridLongTextCellExpandIcon,
    longTextCellCollapseIcon: $fWql6.GridLongTextCellCollapseIcon
};
const $6cd3818014b55356$var$baseSlots = {
    baseAutocomplete: $6cd3818014b55356$var$BaseAutocomplete,
    baseBadge: $6cd3818014b55356$var$BaseBadge,
    baseCheckbox: $6cd3818014b55356$var$BaseCheckbox,
    baseChip: $6cd3818014b55356$var$BaseChip,
    baseCircularProgress: $6cd3818014b55356$var$BaseCircularProgress,
    baseDivider: $6cd3818014b55356$var$BaseDivider,
    baseInput: $6cd3818014b55356$var$BaseInput,
    baseTextarea: $6cd3818014b55356$var$BaseTextarea,
    baseLinearProgress: $6cd3818014b55356$var$BaseLinearProgress,
    baseMenuList: $6cd3818014b55356$var$BaseMenuList,
    baseMenuItem: $6cd3818014b55356$var$BaseMenuItem,
    baseTextField: $6cd3818014b55356$var$BaseTextField,
    baseButton: $6cd3818014b55356$var$BaseButton,
    baseIconButton: $6cd3818014b55356$var$BaseIconButton,
    baseToggleButton: $6cd3818014b55356$var$BaseToggleButton,
    baseTooltip: $6cd3818014b55356$var$BaseTooltip,
    baseTabs: $6cd3818014b55356$var$BaseTabs,
    basePagination: $6cd3818014b55356$var$BasePagination,
    basePopper: $6cd3818014b55356$var$BasePopper,
    baseSelect: $6cd3818014b55356$var$BaseSelect,
    baseSelectOption: $6cd3818014b55356$var$BaseSelectOption,
    baseSkeleton: $6cd3818014b55356$var$BaseSkeleton,
    baseSwitch: $6cd3818014b55356$var$BaseSwitch
};
const $6cd3818014b55356$var$materialSlots = (0, $6cd3818014b55356$var$_extends2.default)({}, $6cd3818014b55356$var$baseSlots, $6cd3818014b55356$var$iconSlots);
var $6cd3818014b55356$var$_default = module.exports.default = $6cd3818014b55356$var$materialSlots;

});
parcelRegister("aBB4t", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7b8a1da92f713a60$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7b8a1da92f713a60$var$_exportNames = {
    createFilterOptions: true,
    autocompleteClasses: true
};
Object.defineProperty(module.exports, "autocompleteClasses", {
    enumerable: true,
    get: function() {
        return $7b8a1da92f713a60$var$_autocompleteClasses.default;
    }
});
Object.defineProperty(module.exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return $7b8a1da92f713a60$var$_Autocomplete.createFilterOptions;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7b8a1da92f713a60$var$_Autocomplete.default;
    }
});

var $7b8a1da92f713a60$var$_Autocomplete = $7b8a1da92f713a60$require$_interopRequireWildcard((parcelRequire("cFBau")));

var $7b8a1da92f713a60$var$_autocompleteClasses = $7b8a1da92f713a60$require$_interopRequireWildcard((parcelRequire("9O25J")));
Object.keys($7b8a1da92f713a60$var$_autocompleteClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7b8a1da92f713a60$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7b8a1da92f713a60$var$_autocompleteClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7b8a1da92f713a60$var$_autocompleteClasses[key];
        }
    });
});

});
parcelRegister("cFBau", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9396253983985262$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9396253983985262$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return $9396253983985262$var$_useAutocomplete.createFilterOptions;
    }
});
module.exports.default = void 0;

var $9396253983985262$var$React = $9396253983985262$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9396253983985262$var$_propTypes = $9396253983985262$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9396253983985262$var$_clsx = $9396253983985262$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9396253983985262$var$_integerPropType = $9396253983985262$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $9396253983985262$var$_chainPropTypes = $9396253983985262$require$_interopRequireDefault((parcelRequire("abVWF")));

var $9396253983985262$var$_composeClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9396253983985262$var$_useAutocomplete = $9396253983985262$require$_interopRequireWildcard((parcelRequire("g924V")));

var $9396253983985262$var$_Popper = $9396253983985262$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $9396253983985262$var$_ListSubheader = $9396253983985262$require$_interopRequireDefault((parcelRequire("1hfjF")));

var $9396253983985262$var$_Paper = $9396253983985262$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $9396253983985262$var$_IconButton = $9396253983985262$require$_interopRequireDefault((parcelRequire("825Zh")));

var $9396253983985262$var$_Chip = $9396253983985262$require$_interopRequireDefault((parcelRequire("6p5K7")));

var $9396253983985262$var$_inputClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("b3ugU")));

var $9396253983985262$var$_inputBaseClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("dmljZ")));

var $9396253983985262$var$_outlinedInputClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("96QZi")));

var $9396253983985262$var$_filledInputClasses = $9396253983985262$require$_interopRequireDefault((parcelRequire("faAxf")));

var $9396253983985262$var$_Close = $9396253983985262$require$_interopRequireDefault((parcelRequire("ldBGF")));

var $9396253983985262$var$_ArrowDropDown = $9396253983985262$require$_interopRequireDefault((parcelRequire("7LRfY")));

var $aAbgT = parcelRequire("aAbgT");

var $9396253983985262$var$_memoTheme = $9396253983985262$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $9396253983985262$var$_autocompleteClasses = $9396253983985262$require$_interopRequireWildcard((parcelRequire("9O25J")));

var $9396253983985262$var$_capitalize = $9396253983985262$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $9396253983985262$var$_useSlot = $9396253983985262$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $9396253983985262$var$_capitalize.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $9396253983985262$var$_composeClasses.default)(slots, $9396253983985262$var$_autocompleteClasses.getAutocompleteUtilityClass, classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: styles.tag
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: styles[`tagSize${(0, $9396253983985262$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: styles.input
            },
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${$9396253983985262$var$_autocompleteClasses.default.focused} .${$9396253983985262$var$_autocompleteClasses.default.clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${$9396253983985262$var$_autocompleteClasses.default.clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${$9396253983985262$var$_autocompleteClasses.default.inputRoot}`]: {
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}&, .${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}.${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${$9396253983985262$var$_inputClasses.default.root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${$9396253983985262$var$_inputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        [`& .${$9396253983985262$var$_inputClasses.default.input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${$9396253983985262$var$_outlinedInputClasses.default.root}`]: {
        padding: 9,
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}&, .${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}.${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.endAdornment}`]: {
            right: 9
        }
    },
    [`& .${$9396253983985262$var$_outlinedInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}&, .${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${$9396253983985262$var$_autocompleteClasses.default.hasPopupIcon}.${$9396253983985262$var$_autocompleteClasses.default.hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${$9396253983985262$var$_filledInputClasses.default.input}`]: {
            padding: '7px 4px'
        },
        [`& .${$9396253983985262$var$_autocompleteClasses.default.endAdornment}`]: {
            right: 9
        }
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${$9396253983985262$var$_filledInputClasses.default.input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${$9396253983985262$var$_inputBaseClasses.default.hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${$9396253983985262$var$_filledInputClasses.default.root}.${$9396253983985262$var$_inputBaseClasses.default.hiddenLabel}.${$9396253983985262$var$_inputBaseClasses.default.sizeSmall}`]: {
        [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $aAbgT.styled)($9396253983985262$var$_IconButton.default, {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $aAbgT.styled)($9396253983985262$var$_IconButton.default, {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $aAbgT.styled)($9396253983985262$var$_Popper.default, {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$9396253983985262$var$_autocompleteClasses.default.option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $9396253983985262$var$AutocompletePaper = (0, $aAbgT.styled)($9396253983985262$var$_Paper.default, {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $9396253983985262$var$AutocompleteLoading = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteNoOptions = (0, $aAbgT.styled)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteListbox = (0, $aAbgT.styled)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${$9396253983985262$var$_autocompleteClasses.default.option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${$9396253983985262$var$_autocompleteClasses.default.focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${$9396253983985262$var$_autocompleteClasses.default.focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${$9396253983985262$var$_autocompleteClasses.default.focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${$9396253983985262$var$_autocompleteClasses.default.focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $aAbgT.styled)($9396253983985262$var$_ListSubheader.default, {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $9396253983985262$var$_memoTheme.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $9396253983985262$var$AutocompleteGroupUl = (0, $aAbgT.styled)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${$9396253983985262$var$_autocompleteClasses.default.option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $9396253983985262$var$React.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$_Close.default, {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$_ArrowDropDown.default, {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $9396253983985262$var$_useAutocomplete.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $9396253983985262$var$_useSlot.default)('listbox', {
        elementType: $9396253983985262$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $9396253983985262$var$_useSlot.default)('paper', {
        elementType: $9396253983985262$var$_Paper.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $9396253983985262$var$_useSlot.default)('popper', {
        elementType: $9396253983985262$var$_Popper.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled: disabled,
            ...getItemProps(params)
        });
    if (multiple) {
        if (value.length > 0) {
            if (renderTags) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
            else if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const { key: key, ...customItemProps } = getCustomizedItemProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$_Chip.default, {
                    label: getOptionLabel(option),
                    size: size,
                    ...customItemProps,
                    ...externalForwardedProps.slotProps.chip
                }, key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $9396253983985262$var$_clsx.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: props.fullWidth ?? true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $9396253983985262$var$_clsx.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $9396253983985262$var$_clsx.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $9396253983985262$var$_default = module.exports.default = $9396253983985262$var$Autocomplete;

});
parcelRegister("g924V", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bc0f195a4e4d09e0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createFilterOptions", {
    enumerable: true,
    get: function() {
        return $bc0f195a4e4d09e0$var$_useAutocomplete.createFilterOptions;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bc0f195a4e4d09e0$var$_useAutocomplete.default;
    }
});

var $bc0f195a4e4d09e0$var$_useAutocomplete = $bc0f195a4e4d09e0$require$_interopRequireWildcard((parcelRequire("33DpT")));

});
parcelRegister("33DpT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $23a03a376a300fc5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $23a03a376a300fc5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFilterOptions = $23a03a376a300fc5$var$createFilterOptions;
module.exports.default = void 0;

var $23a03a376a300fc5$var$React = $23a03a376a300fc5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $23a03a376a300fc5$var$_setRef = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("dGvj8")));

var $23a03a376a300fc5$var$_useEventCallback = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $23a03a376a300fc5$var$_useControlled = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $23a03a376a300fc5$var$_useId = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("hwliF")));

var $23a03a376a300fc5$var$_usePreviousProps = $23a03a376a300fc5$require$_interopRequireDefault((parcelRequire("54VdW")));
function $23a03a376a300fc5$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $23a03a376a300fc5$var$createFilterOptions(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$var$createFilterOptions();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $23a03a376a300fc5$var$_useId.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $23a03a376a300fc5$var$React.useRef(false);
    const firstFocus = $23a03a376a300fc5$var$React.useRef(true);
    const inputRef = $23a03a376a300fc5$var$React.useRef(null);
    const listboxRef = $23a03a376a300fc5$var$React.useRef(null);
    const [anchorEl, setAnchorEl] = $23a03a376a300fc5$var$React.useState(null);
    const [focusedItem, setFocusedItem] = $23a03a376a300fc5$var$React.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $23a03a376a300fc5$var$React.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $23a03a376a300fc5$var$React.useRef($23a03a376a300fc5$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $23a03a376a300fc5$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $23a03a376a300fc5$var$_useControlled.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $23a03a376a300fc5$var$React.useState(false);
    const resetInputValue = $23a03a376a300fc5$var$React.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $23a03a376a300fc5$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $23a03a376a300fc5$var$_useControlled.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $23a03a376a300fc5$var$React.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $23a03a376a300fc5$var$_usePreviousProps.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $23a03a376a300fc5$var$React.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $23a03a376a300fc5$var$_useEventCallback.default)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    $23a03a376a300fc5$var$React.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $23a03a376a300fc5$var$_useEventCallback.default)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $23a03a376a300fc5$var$_useEventCallback.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$23a03a376a300fc5$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$23a03a376a300fc5$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $23a03a376a300fc5$var$React.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $23a03a376a300fc5$var$_useEventCallback.default)((node)=>{
        (0, $23a03a376a300fc5$var$_setRef.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $23a03a376a300fc5$var$React.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen && !disableCloseOnSelect) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen,
        disableCloseOnSelect
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $23a03a376a300fc5$var$React.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        // When moving focus from the input to tags with ArrowLeft,
        // always jump to the last tag (if any) from the input.
        if (focusedItem === -1 && direction === 'previous') {
            nextItem = value.length - 1;
            // In freeSolo, clear any draft text so it doesn't "come back" later.
            if (freeSolo && inputValue !== '') {
                setInputValueState('');
                if (onInputChange) onInputChange(event, '', 'reset');
            }
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    {
                        const input = inputRef.current;
                        // Only handle ArrowLeft when the caret is at the start of the input.
                        // Otherwise let the browser move the caret normally.
                        const caretAtStart = input && input.selectionStart === 0 && input.selectionEnd === 0;
                        if (!caretAtStart) // Let the browser handle normal cursor movement
                        return;
                        // Single-value rendering: move focus from input to the single tag.
                        if (!multiple && renderValue && value != null) {
                            // Moving from input to single tag; clear freeSolo draft text,
                            // so it doesn't reappear when we move back.
                            if (freeSolo && inputValue !== '') {
                                setInputValueState('');
                                if (onInputChange) onInputChange(event, '', 'reset');
                            }
                            setFocusedItem(0);
                            focusItem(0);
                        } else // Multi-value: delegate to tag navigation helper.
                        handleFocusItem(event, 'previous');
                        break;
                    }
                case 'ArrowRight':
                    if (!multiple && renderValue) {
                        setFocusedItem(-1);
                        focusItem(-1);
                    } else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly && inputValue === '') // Single-value rendering: Delete on empty input removes
                    // the single rendered option, same "removeOption" reason as multiple.
                    handleValue(event, null, 'removeOption', {
                        option: value
                    });
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        // When focusing the input, ensure any previously focused item (chip)
        // is cleared so the input receives the visible caret and the
        // input-focused styling is applied.
        if (focusedItem !== -1) {
            setFocusedItem(-1);
            // Ensure DOM focus lands on the input
            focusItem(-1);
        }
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') // For normal single-select, clearing the input clears the value.
        // For renderValue (chip-style single), only Backspace/Delete clear the value.
        {
            if (!disableClearable && !multiple && !renderValue) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index: index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                'aria-multiselectable': multiple || undefined,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$var$_default = module.exports.default = $23a03a376a300fc5$var$useAutocomplete;

});
parcelRegister("54VdW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3b29b6eb56c6bf1d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3b29b6eb56c6bf1d$var$_usePreviousProps.default;
    }
});

var $3b29b6eb56c6bf1d$var$_usePreviousProps = $3b29b6eb56c6bf1d$require$_interopRequireDefault((parcelRequire("dofJB")));

});
parcelRegister("dofJB", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9bf9b8cfe28ce71f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bf9b8cfe28ce71f$var$React = $9bf9b8cfe28ce71f$require$_interopRequireWildcard((parcelRequire("acw62")));
function $9bf9b8cfe28ce71f$var$usePreviousProps(value) {
    const ref = $9bf9b8cfe28ce71f$var$React.useRef({});
    $9bf9b8cfe28ce71f$var$React.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $9bf9b8cfe28ce71f$var$_default = module.exports.default = $9bf9b8cfe28ce71f$var$usePreviousProps;

});




parcelRegister("1hfjF", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0ee342703d01369e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0ee342703d01369e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0ee342703d01369e$var$_exportNames = {
    listSubheaderClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0ee342703d01369e$var$_ListSubheader.default;
    }
});
Object.defineProperty(module.exports, "listSubheaderClasses", {
    enumerable: true,
    get: function() {
        return $0ee342703d01369e$var$_listSubheaderClasses.default;
    }
});

var $0ee342703d01369e$var$_ListSubheader = $0ee342703d01369e$require$_interopRequireDefault((parcelRequire("7djgP")));

var $0ee342703d01369e$var$_listSubheaderClasses = $0ee342703d01369e$require$_interopRequireWildcard((parcelRequire("ixwSf")));
Object.keys($0ee342703d01369e$var$_listSubheaderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0ee342703d01369e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0ee342703d01369e$var$_listSubheaderClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0ee342703d01369e$var$_listSubheaderClasses[key];
        }
    });
});

});
parcelRegister("7djgP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5408b2039b9d572c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5408b2039b9d572c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5408b2039b9d572c$var$React = $5408b2039b9d572c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5408b2039b9d572c$var$_propTypes = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5408b2039b9d572c$var$_clsx = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5408b2039b9d572c$var$_composeClasses = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $5408b2039b9d572c$var$_memoTheme = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $5408b2039b9d572c$var$_capitalize = $5408b2039b9d572c$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ixwSf = parcelRequire("ixwSf");

var $ayMG0 = parcelRequire("ayMG0");
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $5408b2039b9d572c$var$_capitalize.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $5408b2039b9d572c$var$_composeClasses.default)(slots, $ixwSf.getListSubheaderUtilityClass, classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $aAbgT.styled)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $5408b2039b9d572c$var$_capitalize.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $5408b2039b9d572c$var$_memoTheme.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $5408b2039b9d572c$var$React.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, {
        as: component,
        className: (0, $5408b2039b9d572c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($5408b2039b9d572c$var$ListSubheader) $5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$var$_default = module.exports.default = $5408b2039b9d572c$var$ListSubheader;

});
parcelRegister("ixwSf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d7f4cf29715b69dd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListSubheaderUtilityClass = $d7f4cf29715b69dd$var$getListSubheaderUtilityClass;

var $d7f4cf29715b69dd$var$_generateUtilityClasses = $d7f4cf29715b69dd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d7f4cf29715b69dd$var$_generateUtilityClass = $d7f4cf29715b69dd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d7f4cf29715b69dd$var$getListSubheaderUtilityClass(slot) {
    return (0, $d7f4cf29715b69dd$var$_generateUtilityClass.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $d7f4cf29715b69dd$var$_generateUtilityClasses.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$var$_default = module.exports.default = $d7f4cf29715b69dd$var$listSubheaderClasses;

});



parcelRegister("825Zh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5d932794c82c2fcf$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5d932794c82c2fcf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d932794c82c2fcf$var$_exportNames = {
    iconButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5d932794c82c2fcf$var$_IconButton.default;
    }
});
Object.defineProperty(module.exports, "iconButtonClasses", {
    enumerable: true,
    get: function() {
        return $5d932794c82c2fcf$var$_iconButtonClasses.default;
    }
});

var $5d932794c82c2fcf$var$_IconButton = $5d932794c82c2fcf$require$_interopRequireDefault((parcelRequire("9Lykx")));

var $5d932794c82c2fcf$var$_iconButtonClasses = $5d932794c82c2fcf$require$_interopRequireWildcard((parcelRequire("jzUw6")));
Object.keys($5d932794c82c2fcf$var$_iconButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d932794c82c2fcf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5d932794c82c2fcf$var$_iconButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5d932794c82c2fcf$var$_iconButtonClasses[key];
        }
    });
});

});
parcelRegister("9Lykx", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $71c322247f7fbf93$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $71c322247f7fbf93$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71c322247f7fbf93$var$React = $71c322247f7fbf93$require$_interopRequireWildcard((parcelRequire("acw62")));

var $71c322247f7fbf93$var$_propTypes = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $71c322247f7fbf93$var$_clsx = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("9QePP")));

var $71c322247f7fbf93$var$_chainPropTypes = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("abVWF")));

var $71c322247f7fbf93$var$_composeClasses = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hGPki = parcelRequire("hGPki");

var $aAbgT = parcelRequire("aAbgT");

var $71c322247f7fbf93$var$_memoTheme = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $71c322247f7fbf93$var$_createSimplePaletteValueFilter = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $71c322247f7fbf93$var$_ButtonBase = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $71c322247f7fbf93$var$_CircularProgress = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("1sBf1")));

var $71c322247f7fbf93$var$_capitalize = $71c322247f7fbf93$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $71c322247f7fbf93$var$_iconButtonClasses = $71c322247f7fbf93$require$_interopRequireWildcard((parcelRequire("jzUw6")));

var $ayMG0 = parcelRequire("ayMG0");
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $71c322247f7fbf93$var$_capitalize.default)(color)}`,
            edge && `edge${(0, $71c322247f7fbf93$var$_capitalize.default)(edge)}`,
            `size${(0, $71c322247f7fbf93$var$_capitalize.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $71c322247f7fbf93$var$_composeClasses.default)(slots, $71c322247f7fbf93$var$_iconButtonClasses.getIconButtonUtilityClass, classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $aAbgT.styled)($71c322247f7fbf93$var$_ButtonBase.default, {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $71c322247f7fbf93$var$_capitalize.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $71c322247f7fbf93$var$_capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, $71c322247f7fbf93$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $71c322247f7fbf93$var$_memoTheme.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $71c322247f7fbf93$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $71c322247f7fbf93$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $71c322247f7fbf93$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${$71c322247f7fbf93$var$_iconButtonClasses.default.disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${$71c322247f7fbf93$var$_iconButtonClasses.default.loading}`]: {
            color: 'transparent'
        }
    })));
const $71c322247f7fbf93$var$IconButtonLoadingIndicator = (0, $aAbgT.styled)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $71c322247f7fbf93$var$React.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $hGPki.unstable_useId)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$_CircularProgress.default, {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($71c322247f7fbf93$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $71c322247f7fbf93$var$_clsx.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $71c322247f7fbf93$var$_default = module.exports.default = $71c322247f7fbf93$var$IconButton;

});
parcelRegister("jzUw6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e40d2047b7c1e09d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getIconButtonUtilityClass = $e40d2047b7c1e09d$var$getIconButtonUtilityClass;

var $e40d2047b7c1e09d$var$_generateUtilityClasses = $e40d2047b7c1e09d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e40d2047b7c1e09d$var$_generateUtilityClass = $e40d2047b7c1e09d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e40d2047b7c1e09d$var$getIconButtonUtilityClass(slot) {
    return (0, $e40d2047b7c1e09d$var$_generateUtilityClass.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $e40d2047b7c1e09d$var$_generateUtilityClasses.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $e40d2047b7c1e09d$var$_default = module.exports.default = $e40d2047b7c1e09d$var$iconButtonClasses;

});



parcelRegister("6p5K7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4a998843df0ddc3a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4a998843df0ddc3a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4a998843df0ddc3a$var$_exportNames = {
    chipClasses: true
};
Object.defineProperty(module.exports, "chipClasses", {
    enumerable: true,
    get: function() {
        return $4a998843df0ddc3a$var$_chipClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4a998843df0ddc3a$var$_Chip.default;
    }
});

var $4a998843df0ddc3a$var$_Chip = $4a998843df0ddc3a$require$_interopRequireDefault((parcelRequire("6ami2")));

var $4a998843df0ddc3a$var$_chipClasses = $4a998843df0ddc3a$require$_interopRequireWildcard((parcelRequire("iNSYf")));
Object.keys($4a998843df0ddc3a$var$_chipClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a998843df0ddc3a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4a998843df0ddc3a$var$_chipClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4a998843df0ddc3a$var$_chipClasses[key];
        }
    });
});

});
parcelRegister("6ami2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $47d4f79319086dc5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $47d4f79319086dc5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47d4f79319086dc5$var$React = $47d4f79319086dc5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $47d4f79319086dc5$var$_propTypes = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $47d4f79319086dc5$var$_clsx = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $47d4f79319086dc5$var$_composeClasses = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $47d4f79319086dc5$var$_Cancel = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("8u0rE")));

var $47d4f79319086dc5$var$_useForkRef = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $47d4f79319086dc5$var$_unsupportedProp = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $47d4f79319086dc5$var$_capitalize = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $47d4f79319086dc5$var$_ButtonBase = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $aAbgT = parcelRequire("aAbgT");

var $47d4f79319086dc5$var$_memoTheme = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $47d4f79319086dc5$var$_createSimplePaletteValueFilter = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $47d4f79319086dc5$var$_chipClasses = $47d4f79319086dc5$require$_interopRequireWildcard((parcelRequire("iNSYf")));

var $47d4f79319086dc5$var$_useSlot = $47d4f79319086dc5$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            `${variant}${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `avatarColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `iconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`,
            `deleteIconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`,
            `deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(variant)}Color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`
        ]
    };
    return (0, $47d4f79319086dc5$var$_composeClasses.default)(slots, $47d4f79319086dc5$var$_chipClasses.getChipUtilityClass, classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: styles.avatar
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: styles[`avatar${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: styles[`avatarColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: styles.icon
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: styles[`icon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: styles[`iconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(iconColor)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles[`deleteIconColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
            },
            {
                [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, $47d4f79319086dc5$var$_capitalize.default)(variant)}Color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`],
            styles[`color${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $47d4f79319086dc5$var$_capitalize.default)(color)}`]
        ];
    }
})((0, $47d4f79319086dc5$var$_memoTheme.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${$47d4f79319086dc5$var$_chipClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $47d4f79319086dc5$var$_createSimplePaletteValueFilter.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${$47d4f79319086dc5$var$_chipClasses.default.clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${$47d4f79319086dc5$var$_chipClasses.default.focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${$47d4f79319086dc5$var$_chipClasses.default.deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $47d4f79319086dc5$var$ChipLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $47d4f79319086dc5$var$_capitalize.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $47d4f79319086dc5$var$React.forwardRef(function Chip(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const chipRef = $47d4f79319086dc5$var$React.useRef(null);
    const handleRef = (0, $47d4f79319086dc5$var$_useForkRef.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? $47d4f79319086dc5$var$_ButtonBase.default : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === $47d4f79319086dc5$var$_ButtonBase.default ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(deleteIconProp) ? /*#__PURE__*/ $47d4f79319086dc5$var$React.cloneElement(deleteIconProp, {
        className: (0, $47d4f79319086dc5$var$_clsx.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$_Cancel.default, {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $47d4f79319086dc5$var$React.cloneElement(avatarProp, {
        className: (0, $47d4f79319086dc5$var$_clsx.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $47d4f79319086dc5$var$React.isValidElement(iconProp)) icon = /*#__PURE__*/ $47d4f79319086dc5$var$React.cloneElement(iconProp, {
        className: (0, $47d4f79319086dc5$var$_clsx.default)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $47d4f79319086dc5$var$_useSlot.default)('root', {
        elementType: $47d4f79319086dc5$var$ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $47d4f79319086dc5$var$_clsx.default)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick?.(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $47d4f79319086dc5$var$_useSlot.default)('label', {
        elementType: $47d4f79319086dc5$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $47d4f79319086dc5$var$_default = module.exports.default = $47d4f79319086dc5$var$Chip;

});
parcelRegister("8u0rE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $62d1787512a69c15$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62d1787512a69c15$var$_createSvgIcon = $62d1787512a69c15$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $62d1787512a69c15$var$_default = module.exports.default = (0, $62d1787512a69c15$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("iNSYf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $db0771a9e6a32b1d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getChipUtilityClass = $db0771a9e6a32b1d$var$getChipUtilityClass;

var $db0771a9e6a32b1d$var$_generateUtilityClasses = $db0771a9e6a32b1d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $db0771a9e6a32b1d$var$_generateUtilityClass = $db0771a9e6a32b1d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $db0771a9e6a32b1d$var$getChipUtilityClass(slot) {
    return (0, $db0771a9e6a32b1d$var$_generateUtilityClass.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $db0771a9e6a32b1d$var$_generateUtilityClasses.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$var$_default = module.exports.default = $db0771a9e6a32b1d$var$chipClasses;

});



parcelRegister("b3ugU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $80c774dd7f29b734$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputUtilityClass = $80c774dd7f29b734$var$getInputUtilityClass;

var $80c774dd7f29b734$var$_generateUtilityClasses = $80c774dd7f29b734$require$_interopRequireDefault((parcelRequire("5nY49")));

var $80c774dd7f29b734$var$_generateUtilityClass = $80c774dd7f29b734$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $80c774dd7f29b734$var$getInputUtilityClass(slot) {
    return (0, $80c774dd7f29b734$var$_generateUtilityClass.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $80c774dd7f29b734$var$_generateUtilityClasses.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $80c774dd7f29b734$var$_default = module.exports.default = $80c774dd7f29b734$var$inputClasses;

});

parcelRegister("96QZi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a1dc6d1d7e1816a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getOutlinedInputUtilityClass = $6a1dc6d1d7e1816a$var$getOutlinedInputUtilityClass;

var $6a1dc6d1d7e1816a$var$_generateUtilityClasses = $6a1dc6d1d7e1816a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6a1dc6d1d7e1816a$var$_generateUtilityClass = $6a1dc6d1d7e1816a$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $6a1dc6d1d7e1816a$var$getOutlinedInputUtilityClass(slot) {
    return (0, $6a1dc6d1d7e1816a$var$_generateUtilityClass.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $6a1dc6d1d7e1816a$var$_generateUtilityClasses.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $6a1dc6d1d7e1816a$var$_default = module.exports.default = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});

parcelRegister("faAxf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b0b42157daacd8b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFilledInputUtilityClass = $b0b42157daacd8b1$var$getFilledInputUtilityClass;

var $b0b42157daacd8b1$var$_generateUtilityClasses = $b0b42157daacd8b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b0b42157daacd8b1$var$_generateUtilityClass = $b0b42157daacd8b1$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $b0b42157daacd8b1$var$getFilledInputUtilityClass(slot) {
    return (0, $b0b42157daacd8b1$var$_generateUtilityClass.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $b0b42157daacd8b1$var$_generateUtilityClasses.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $b0b42157daacd8b1$var$_default = module.exports.default = $b0b42157daacd8b1$var$filledInputClasses;

});

parcelRegister("ldBGF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f7280bbf95507cba$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7280bbf95507cba$var$_createSvgIcon = $f7280bbf95507cba$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var $f7280bbf95507cba$var$_default = module.exports.default = (0, $f7280bbf95507cba$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("7LRfY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5a863bd9b12ca76b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a863bd9b12ca76b$var$_createSvgIcon = $5a863bd9b12ca76b$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $5a863bd9b12ca76b$var$_default = module.exports.default = (0, $5a863bd9b12ca76b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("9O25J", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $723a67e53eb4dc4c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAutocompleteUtilityClass = $723a67e53eb4dc4c$var$getAutocompleteUtilityClass;

var $723a67e53eb4dc4c$var$_generateUtilityClasses = $723a67e53eb4dc4c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $723a67e53eb4dc4c$var$_generateUtilityClass = $723a67e53eb4dc4c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $723a67e53eb4dc4c$var$getAutocompleteUtilityClass(slot) {
    return (0, $723a67e53eb4dc4c$var$_generateUtilityClass.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $723a67e53eb4dc4c$var$_generateUtilityClasses.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$var$_default = module.exports.default = $723a67e53eb4dc4c$var$autocompleteClasses;

});



parcelRegister("lgIyK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f7bda82e26c407eb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f7bda82e26c407eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f7bda82e26c407eb$var$_exportNames = {
    badgeClasses: true
};
Object.defineProperty(module.exports, "badgeClasses", {
    enumerable: true,
    get: function() {
        return $f7bda82e26c407eb$var$_badgeClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f7bda82e26c407eb$var$_Badge.default;
    }
});

var $f7bda82e26c407eb$var$_Badge = $f7bda82e26c407eb$require$_interopRequireDefault((parcelRequire("fagfG")));

var $f7bda82e26c407eb$var$_badgeClasses = $f7bda82e26c407eb$require$_interopRequireWildcard((parcelRequire("8FqN6")));
Object.keys($f7bda82e26c407eb$var$_badgeClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f7bda82e26c407eb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f7bda82e26c407eb$var$_badgeClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f7bda82e26c407eb$var$_badgeClasses[key];
        }
    });
});

});
parcelRegister("fagfG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b0a465815ebe726f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b0a465815ebe726f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0a465815ebe726f$var$React = $b0a465815ebe726f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b0a465815ebe726f$var$_propTypes = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b0a465815ebe726f$var$_clsx = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b0a465815ebe726f$var$_usePreviousProps = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("54VdW")));

var $b0a465815ebe726f$var$_composeClasses = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $b0a465815ebe726f$var$_useBadge = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("17KyE")));

var $aAbgT = parcelRequire("aAbgT");

var $b0a465815ebe726f$var$_memoTheme = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $b0a465815ebe726f$var$_createSimplePaletteValueFilter = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $b0a465815ebe726f$var$_capitalize = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $b0a465815ebe726f$var$_badgeClasses = $b0a465815ebe726f$require$_interopRequireWildcard((parcelRequire("8FqN6")));

var $b0a465815ebe726f$var$_useSlot = $b0a465815ebe726f$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $b0a465815ebe726f$var$RADIUS_STANDARD = 10;
const $b0a465815ebe726f$var$RADIUS_DOT = 4;
const $b0a465815ebe726f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.vertical)}${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.vertical)}${(0, $b0a465815ebe726f$var$_capitalize.default)(anchorOrigin.horizontal)}${(0, $b0a465815ebe726f$var$_capitalize.default)(overlap)}`,
            `overlap${(0, $b0a465815ebe726f$var$_capitalize.default)(overlap)}`,
            color !== 'default' && `color${(0, $b0a465815ebe726f$var$_capitalize.default)(color)}`
        ]
    };
    return (0, $b0a465815ebe726f$var$_composeClasses.default)(slots, $b0a465815ebe726f$var$_badgeClasses.getBadgeUtilityClass, classes);
};
const $b0a465815ebe726f$var$BadgeRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $b0a465815ebe726f$var$BadgeBadge = (0, $aAbgT.styled)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.anchorOrigin.vertical)}${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.anchorOrigin.horizontal)}${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $b0a465815ebe726f$var$_capitalize.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $b0a465815ebe726f$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        borderRadius: $b0a465815ebe726f$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $b0a465815ebe726f$var$_createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $b0a465815ebe726f$var$RADIUS_DOT,
                    height: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    minWidth: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            },
            {
                style: ({ ownerState: ownerState })=>{
                    const { vertical: vertical, horizontal: horizontal } = ownerState.anchorOrigin;
                    const offset = ownerState.overlap === 'circular' ? '14%' : 0;
                    return {
                        '--Badge-translateX': horizontal === 'right' ? '50%' : '-50%',
                        '--Badge-translateY': vertical === 'top' ? '-50%' : '50%',
                        top: vertical === 'top' ? offset : 'initial',
                        bottom: vertical === 'bottom' ? offset : 'initial',
                        right: horizontal === 'right' ? offset : 'initial',
                        left: horizontal === 'left' ? offset : 'initial',
                        transform: 'scale(1) translate(var(--Badge-translateX), var(--Badge-translateY))',
                        transformOrigin: `${horizontal === 'right' ? '100%' : '0%'} ${vertical === 'top' ? '0%' : '100%'}`,
                        [`&.${$b0a465815ebe726f$var$_badgeClasses.default.invisible}`]: {
                            transform: 'scale(0) translate(var(--Badge-translateX), var(--Badge-translateY))'
                        }
                    };
                }
            }
        ]
    })));
function $b0a465815ebe726f$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $b0a465815ebe726f$var$Badge = /*#__PURE__*/ $b0a465815ebe726f$var$React.forwardRef(function Badge(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $b0a465815ebe726f$var$_useBadge.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $b0a465815ebe726f$var$_usePreviousProps.default)({
        anchorOrigin: $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $b0a465815ebe726f$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $b0a465815ebe726f$var$_useSlot.default)('root', {
        elementType: $b0a465815ebe726f$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $b0a465815ebe726f$var$_clsx.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $b0a465815ebe726f$var$_useSlot.default)('badge', {
        elementType: $b0a465815ebe726f$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $b0a465815ebe726f$var$_default = module.exports.default = $b0a465815ebe726f$var$Badge;

});
parcelRegister("17KyE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0d1a8f518d4ece30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d1a8f518d4ece30$var$_usePreviousProps = $0d1a8f518d4ece30$require$_interopRequireDefault((parcelRequire("54VdW")));
function $0d1a8f518d4ece30$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $0d1a8f518d4ece30$var$_usePreviousProps.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $0d1a8f518d4ece30$var$_default = module.exports.default = $0d1a8f518d4ece30$var$useBadge;

});

parcelRegister("8FqN6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $64f6ef338eb74fbc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBadgeUtilityClass = $64f6ef338eb74fbc$var$getBadgeUtilityClass;

var $64f6ef338eb74fbc$var$_generateUtilityClasses = $64f6ef338eb74fbc$require$_interopRequireDefault((parcelRequire("5nY49")));

var $64f6ef338eb74fbc$var$_generateUtilityClass = $64f6ef338eb74fbc$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $64f6ef338eb74fbc$var$getBadgeUtilityClass(slot) {
    return (0, $64f6ef338eb74fbc$var$_generateUtilityClass.default)('MuiBadge', slot);
}
const $64f6ef338eb74fbc$var$badgeClasses = (0, $64f6ef338eb74fbc$var$_generateUtilityClasses.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $64f6ef338eb74fbc$var$_default = module.exports.default = $64f6ef338eb74fbc$var$badgeClasses;

});



parcelRegister("aGDqy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7c7c690d35982c52$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7c7c690d35982c52$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7c7c690d35982c52$var$_exportNames = {
    checkboxClasses: true
};
Object.defineProperty(module.exports, "checkboxClasses", {
    enumerable: true,
    get: function() {
        return $7c7c690d35982c52$var$_checkboxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7c7c690d35982c52$var$_Checkbox.default;
    }
});

var $7c7c690d35982c52$var$_Checkbox = $7c7c690d35982c52$require$_interopRequireDefault((parcelRequire("1Aijw")));

var $7c7c690d35982c52$var$_checkboxClasses = $7c7c690d35982c52$require$_interopRequireWildcard((parcelRequire("9s7Sp")));
Object.keys($7c7c690d35982c52$var$_checkboxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7c7c690d35982c52$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7c7c690d35982c52$var$_checkboxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7c7c690d35982c52$var$_checkboxClasses[key];
        }
    });
});

});
parcelRegister("1Aijw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $12775c00f473d955$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $12775c00f473d955$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12775c00f473d955$var$React = $12775c00f473d955$require$_interopRequireWildcard((parcelRequire("acw62")));

var $12775c00f473d955$var$_propTypes = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12775c00f473d955$var$_clsx = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("9QePP")));

var $12775c00f473d955$var$_composeClasses = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $12775c00f473d955$var$_SwitchBase = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("kVqvD")));

var $12775c00f473d955$var$_CheckBoxOutlineBlank = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("1yHUZ")));

var $12775c00f473d955$var$_CheckBox = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("etWmn")));

var $12775c00f473d955$var$_IndeterminateCheckBox = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("2rW38")));

var $12775c00f473d955$var$_capitalize = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $12775c00f473d955$var$_rootShouldForwardProp = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $12775c00f473d955$var$_checkboxClasses = $12775c00f473d955$require$_interopRequireWildcard((parcelRequire("9s7Sp")));

var $aAbgT = parcelRequire("aAbgT");

var $12775c00f473d955$var$_memoTheme = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $12775c00f473d955$var$_createSimplePaletteValueFilter = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $hGPki = parcelRequire("hGPki");

var $12775c00f473d955$var$_useSlot = $12775c00f473d955$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $12775c00f473d955$var$_capitalize.default)(color)}`,
            `size${(0, $12775c00f473d955$var$_capitalize.default)(size)}`
        ]
    };
    const composedClasses = (0, $12775c00f473d955$var$_composeClasses.default)(slots, $12775c00f473d955$var$_checkboxClasses.getCheckboxUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $12775c00f473d955$var$CheckboxRoot = (0, $aAbgT.styled)($12775c00f473d955$var$_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, $12775c00f473d955$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $12775c00f473d955$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $12775c00f473d955$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $12775c00f473d955$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $12775c00f473d955$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $12775c00f473d955$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$12775c00f473d955$var$_checkboxClasses.default.checked}, &.${$12775c00f473d955$var$_checkboxClasses.default.indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${$12775c00f473d955$var$_checkboxClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$_CheckBox.default, {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$_CheckBoxOutlineBlank.default, {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$_IndeterminateCheckBox.default, {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $12775c00f473d955$var$React.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $12775c00f473d955$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $12775c00f473d955$var$CheckboxRoot,
        className: (0, $12775c00f473d955$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $12775c00f473d955$var$React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $12775c00f473d955$var$React.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $hGPki.mergeSlotProps)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $12775c00f473d955$var$_default = module.exports.default = $12775c00f473d955$var$Checkbox;

});
parcelRegister("kVqvD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f3bdb1b636c81735$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f3bdb1b636c81735$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3bdb1b636c81735$var$React = $f3bdb1b636c81735$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f3bdb1b636c81735$var$_propTypes = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f3bdb1b636c81735$var$_refType = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $f3bdb1b636c81735$var$_composeClasses = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $f3bdb1b636c81735$var$_capitalize = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $f3bdb1b636c81735$var$_rootShouldForwardProp = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $f3bdb1b636c81735$var$_useControlled = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("3yddg")));

var $f3bdb1b636c81735$var$_useFormControl = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $f3bdb1b636c81735$var$_ButtonBase = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $bxhip = parcelRequire("bxhip");

var $f3bdb1b636c81735$var$_useSlot = $f3bdb1b636c81735$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $f3bdb1b636c81735$var$_capitalize.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $f3bdb1b636c81735$var$_composeClasses.default)(slots, $bxhip.getSwitchBaseUtilityClass, classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $aAbgT.styled)($f3bdb1b636c81735$var$_ButtonBase.default, {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $aAbgT.styled)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: $f3bdb1b636c81735$var$_rootShouldForwardProp.default
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $f3bdb1b636c81735$var$React.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $f3bdb1b636c81735$var$_useControlled.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $f3bdb1b636c81735$var$_useFormControl.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented || readOnly) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $f3bdb1b636c81735$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $f3bdb1b636c81735$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $f3bdb1b636c81735$var$_useSlot.default)('input', {
        ref: inputRef,
        elementType: $f3bdb1b636c81735$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $f3bdb1b636c81735$var$_default = module.exports.default = $f3bdb1b636c81735$var$SwitchBase;

});
parcelRegister("bxhip", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $86603163591f910a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSwitchBaseUtilityClass = $86603163591f910a$var$getSwitchBaseUtilityClass;

var $86603163591f910a$var$_generateUtilityClasses = $86603163591f910a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $86603163591f910a$var$_generateUtilityClass = $86603163591f910a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $86603163591f910a$var$getSwitchBaseUtilityClass(slot) {
    return (0, $86603163591f910a$var$_generateUtilityClass.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $86603163591f910a$var$_generateUtilityClasses.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$var$_default = module.exports.default = $86603163591f910a$var$switchBaseClasses;

});


parcelRegister("1yHUZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $122b08a8ae2faae5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $122b08a8ae2faae5$var$_createSvgIcon = $122b08a8ae2faae5$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $122b08a8ae2faae5$var$_default = module.exports.default = (0, $122b08a8ae2faae5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("etWmn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a8b10b2b5aaa8e54$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8b10b2b5aaa8e54$var$_createSvgIcon = $a8b10b2b5aaa8e54$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $a8b10b2b5aaa8e54$var$_default = module.exports.default = (0, $a8b10b2b5aaa8e54$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("2rW38", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1c8b21cdbf539e4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c8b21cdbf539e4f$var$_createSvgIcon = $1c8b21cdbf539e4f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $1c8b21cdbf539e4f$var$_default = module.exports.default = (0, $1c8b21cdbf539e4f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("9s7Sp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e1cd6b997bc70d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCheckboxUtilityClass = $6e1cd6b997bc70d3$var$getCheckboxUtilityClass;

var $6e1cd6b997bc70d3$var$_generateUtilityClasses = $6e1cd6b997bc70d3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6e1cd6b997bc70d3$var$_generateUtilityClass = $6e1cd6b997bc70d3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6e1cd6b997bc70d3$var$getCheckboxUtilityClass(slot) {
    return (0, $6e1cd6b997bc70d3$var$_generateUtilityClass.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $6e1cd6b997bc70d3$var$_generateUtilityClasses.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$var$_default = module.exports.default = $6e1cd6b997bc70d3$var$checkboxClasses;

});



parcelRegister("2vsem", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1d34600829c15c5d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1d34600829c15c5d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1d34600829c15c5d$var$_exportNames = {
    linearProgressClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1d34600829c15c5d$var$_LinearProgress.default;
    }
});
Object.defineProperty(module.exports, "linearProgressClasses", {
    enumerable: true,
    get: function() {
        return $1d34600829c15c5d$var$_linearProgressClasses.default;
    }
});

var $1d34600829c15c5d$var$_LinearProgress = $1d34600829c15c5d$require$_interopRequireDefault((parcelRequire("1lfQl")));

var $1d34600829c15c5d$var$_linearProgressClasses = $1d34600829c15c5d$require$_interopRequireWildcard((parcelRequire("lJgAB")));
Object.keys($1d34600829c15c5d$var$_linearProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1d34600829c15c5d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1d34600829c15c5d$var$_linearProgressClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1d34600829c15c5d$var$_linearProgressClasses[key];
        }
    });
});

});
parcelRegister("1lfQl", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0fa40ac3f678fedb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0fa40ac3f678fedb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fa40ac3f678fedb$var$React = $0fa40ac3f678fedb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0fa40ac3f678fedb$var$_propTypes = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0fa40ac3f678fedb$var$_clsx = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0fa40ac3f678fedb$var$_composeClasses = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $aAbgT = parcelRequire("aAbgT");

var $0fa40ac3f678fedb$var$_memoTheme = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $0fa40ac3f678fedb$var$_capitalize = $0fa40ac3f678fedb$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $lJgAB = parcelRequire("lJgAB");

var $ayMG0 = parcelRequire("ayMG0");
const $0fa40ac3f678fedb$var$TRANSITION_DURATION = 4; // seconds
const $0fa40ac3f678fedb$var$indeterminate1Keyframe = (0, $aAbgT.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $0fa40ac3f678fedb$var$indeterminate1Animation = typeof $0fa40ac3f678fedb$var$indeterminate1Keyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $0fa40ac3f678fedb$var$indeterminate2Keyframe = (0, $aAbgT.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $0fa40ac3f678fedb$var$indeterminate2Animation = typeof $0fa40ac3f678fedb$var$indeterminate2Keyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $0fa40ac3f678fedb$var$bufferKeyframe = (0, $aAbgT.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $0fa40ac3f678fedb$var$bufferAnimation = typeof $0fa40ac3f678fedb$var$bufferKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $0fa40ac3f678fedb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            variant === 'buffer' && `color${(0, $0fa40ac3f678fedb$var$_capitalize.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $0fa40ac3f678fedb$var$_composeClasses.default)(slots, $lJgAB.getLinearProgressUtilityClass, classes);
};
const $0fa40ac3f678fedb$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $0fa40ac3f678fedb$var$LinearProgressRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressDashed = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>{
                const backgroundColor = $0fa40ac3f678fedb$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $0fa40ac3f678fedb$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear`
});
const $0fa40ac3f678fedb$var$LinearProgressBar1 = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate1Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressBar2 = (0, $aAbgT.styled)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $0fa40ac3f678fedb$var$_capitalize.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $0fa40ac3f678fedb$var$_memoTheme.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $0fa40ac3f678fedb$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color),
                        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate2Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $0fa40ac3f678fedb$var$LinearProgress = /*#__PURE__*/ $0fa40ac3f678fedb$var$React.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $0fa40ac3f678fedb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $9uEev.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0fa40ac3f678fedb$var$LinearProgressRoot, {
        className: (0, $0fa40ac3f678fedb$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $0fa40ac3f678fedb$var$_default = module.exports.default = $0fa40ac3f678fedb$var$LinearProgress;

});
parcelRegister("lJgAB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd1aab3db3503e90$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getLinearProgressUtilityClass = $fd1aab3db3503e90$var$getLinearProgressUtilityClass;

var $fd1aab3db3503e90$var$_generateUtilityClasses = $fd1aab3db3503e90$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fd1aab3db3503e90$var$_generateUtilityClass = $fd1aab3db3503e90$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fd1aab3db3503e90$var$getLinearProgressUtilityClass(slot) {
    return (0, $fd1aab3db3503e90$var$_generateUtilityClass.default)('MuiLinearProgress', slot);
}
const $fd1aab3db3503e90$var$linearProgressClasses = (0, $fd1aab3db3503e90$var$_generateUtilityClasses.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $fd1aab3db3503e90$var$_default = module.exports.default = $fd1aab3db3503e90$var$linearProgressClasses;

});



parcelRegister("8qqwQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6225548018c22e00$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6225548018c22e00$var$_MenuList.default;
    }
});

var $6225548018c22e00$var$_MenuList = $6225548018c22e00$require$_interopRequireDefault((parcelRequire("lBOb7")));

});
parcelRegister("lBOb7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fbb3fa0cdc277971$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fbb3fa0cdc277971$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbb3fa0cdc277971$var$React = $fbb3fa0cdc277971$require$_interopRequireWildcard((parcelRequire("acw62")));


var $fbb3fa0cdc277971$var$_propTypes = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fbb3fa0cdc277971$var$_ownerDocument = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $fbb3fa0cdc277971$var$_List = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("ib3g2")));

var $fbb3fa0cdc277971$var$_getActiveElement = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("6uU67")));

var $fbb3fa0cdc277971$var$_getScrollbarSize = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("19SuQ")));

var $fbb3fa0cdc277971$var$_useForkRef = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $fbb3fa0cdc277971$var$_useEnhancedEffect = $fbb3fa0cdc277971$require$_interopRequireDefault((parcelRequire("khjmj")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $fbb3fa0cdc277971$var$React.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $fbb3fa0cdc277971$var$React.useRef(null);
    const textCriteriaRef = $fbb3fa0cdc277971$var$React.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $fbb3fa0cdc277971$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $fbb3fa0cdc277971$var$React.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $fbb3fa0cdc277971$var$_getScrollbarSize.default)((0, $hGPki.ownerWindow)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $fbb3fa0cdc277971$var$_getActiveElement.default)((0, $fbb3fa0cdc277971$var$_ownerDocument.default)(list));
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $fbb3fa0cdc277971$var$_useForkRef.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $fbb3fa0cdc277971$var$React.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $fbb3fa0cdc277971$var$React.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $fbb3fa0cdc277971$var$React.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $fbb3fa0cdc277971$var$React.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fbb3fa0cdc277971$var$_List.default, {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $fbb3fa0cdc277971$var$_default = module.exports.default = $fbb3fa0cdc277971$var$MenuList;

});
parcelRegister("19SuQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0d80e79907b6bdbc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d80e79907b6bdbc$var$_getScrollbarSize = $0d80e79907b6bdbc$require$_interopRequireDefault((parcelRequire("71aFq")));
var $0d80e79907b6bdbc$var$_default = module.exports.default = $0d80e79907b6bdbc$var$_getScrollbarSize.default;

});



parcelRegister("iZ4W7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dd21c0ca7e345443$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dd21c0ca7e345443$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd21c0ca7e345443$var$_exportNames = {
    menuItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dd21c0ca7e345443$var$_MenuItem.default;
    }
});
Object.defineProperty(module.exports, "menuItemClasses", {
    enumerable: true,
    get: function() {
        return $dd21c0ca7e345443$var$_menuItemClasses.default;
    }
});

var $dd21c0ca7e345443$var$_MenuItem = $dd21c0ca7e345443$require$_interopRequireDefault((parcelRequire("2iAqv")));

var $dd21c0ca7e345443$var$_menuItemClasses = $dd21c0ca7e345443$require$_interopRequireWildcard((parcelRequire("eWb0W")));
Object.keys($dd21c0ca7e345443$var$_menuItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dd21c0ca7e345443$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dd21c0ca7e345443$var$_menuItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dd21c0ca7e345443$var$_menuItemClasses[key];
        }
    });
});

});
parcelRegister("2iAqv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1ac984bce84b2164$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1ac984bce84b2164$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overridesResolver = module.exports.default = void 0;

var $1ac984bce84b2164$var$React = $1ac984bce84b2164$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1ac984bce84b2164$var$_propTypes = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1ac984bce84b2164$var$_clsx = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1ac984bce84b2164$var$_composeClasses = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1ac984bce84b2164$var$_rootShouldForwardProp = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $1ac984bce84b2164$var$_memoTheme = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1ac984bce84b2164$var$_ListContext = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $1ac984bce84b2164$var$_ButtonBase = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $1ac984bce84b2164$var$_useEnhancedEffect = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("khjmj")));

var $1ac984bce84b2164$var$_useForkRef = $1ac984bce84b2164$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $g6BeY = parcelRequire("g6BeY");

var $2fe4K = parcelRequire("2fe4K");

var $djLZl = parcelRequire("djLZl");

var $1ac984bce84b2164$var$_menuItemClasses = $1ac984bce84b2164$require$_interopRequireWildcard((parcelRequire("eWb0W")));

var $ayMG0 = parcelRequire("ayMG0");
const $1ac984bce84b2164$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
module.exports.overridesResolver = $1ac984bce84b2164$var$overridesResolver;
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $1ac984bce84b2164$var$_composeClasses.default)(slots, $1ac984bce84b2164$var$_menuItemClasses.getMenuItemUtilityClass, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $aAbgT.styled)($1ac984bce84b2164$var$_ButtonBase.default, {
    shouldForwardProp: (prop)=>(0, $1ac984bce84b2164$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$var$overridesResolver
})((0, $1ac984bce84b2164$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$1ac984bce84b2164$var$_menuItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${$g6BeY.dividerClasses.root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${$g6BeY.dividerClasses.inset}`]: {
            marginLeft: 52
        },
        [`& .${$djLZl.listItemTextClasses.root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${$djLZl.listItemTextClasses.inset}`]: {
            paddingLeft: 36
        },
        [`& .${$2fe4K.listItemIconClasses.root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${$2fe4K.listItemIconClasses.root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $1ac984bce84b2164$var$React.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $1ac984bce84b2164$var$React.useContext($1ac984bce84b2164$var$_ListContext.default);
    const childContext = $1ac984bce84b2164$var$React.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $1ac984bce84b2164$var$React.useRef(null);
    (0, $1ac984bce84b2164$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $1ac984bce84b2164$var$_useForkRef.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $1ac984bce84b2164$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $1ac984bce84b2164$var$_clsx.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $1ac984bce84b2164$var$_default = module.exports.default = $1ac984bce84b2164$var$MenuItem;

});
parcelRegister("eWb0W", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adff06ac3b11e066$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMenuItemUtilityClass = $adff06ac3b11e066$var$getMenuItemUtilityClass;

var $adff06ac3b11e066$var$_generateUtilityClasses = $adff06ac3b11e066$require$_interopRequireDefault((parcelRequire("5nY49")));

var $adff06ac3b11e066$var$_generateUtilityClass = $adff06ac3b11e066$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $adff06ac3b11e066$var$getMenuItemUtilityClass(slot) {
    return (0, $adff06ac3b11e066$var$_generateUtilityClass.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $adff06ac3b11e066$var$_generateUtilityClasses.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$var$_default = module.exports.default = $adff06ac3b11e066$var$menuItemClasses;

});



parcelRegister("hABDe", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cce2fd59bc453dc9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cce2fd59bc453dc9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cce2fd59bc453dc9$var$_exportNames = {
    textFieldClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cce2fd59bc453dc9$var$_TextField.default;
    }
});
Object.defineProperty(module.exports, "textFieldClasses", {
    enumerable: true,
    get: function() {
        return $cce2fd59bc453dc9$var$_textFieldClasses.default;
    }
});

var $cce2fd59bc453dc9$var$_TextField = $cce2fd59bc453dc9$require$_interopRequireDefault((parcelRequire("iAtns")));

var $cce2fd59bc453dc9$var$_textFieldClasses = $cce2fd59bc453dc9$require$_interopRequireWildcard((parcelRequire("3epOE")));
Object.keys($cce2fd59bc453dc9$var$_textFieldClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cce2fd59bc453dc9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cce2fd59bc453dc9$var$_textFieldClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cce2fd59bc453dc9$var$_textFieldClasses[key];
        }
    });
});

});
parcelRegister("iAtns", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d8826083c5af4ea7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d8826083c5af4ea7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8826083c5af4ea7$var$React = $d8826083c5af4ea7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d8826083c5af4ea7$var$_propTypes = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d8826083c5af4ea7$var$_clsx = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d8826083c5af4ea7$var$_composeClasses = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d8826083c5af4ea7$var$_useId = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("hwliF")));

var $d8826083c5af4ea7$var$_refType = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $d8826083c5af4ea7$var$_Input = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("eAJp9")));

var $d8826083c5af4ea7$var$_FilledInput = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("hE2RV")));

var $d8826083c5af4ea7$var$_OutlinedInput = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("in82R")));

var $d8826083c5af4ea7$var$_InputLabel = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("k9xmz")));

var $d8826083c5af4ea7$var$_FormControl = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("iA4iQ")));

var $d8826083c5af4ea7$var$_FormHelperText = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("4xkW2")));

var $d8826083c5af4ea7$var$_Select = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("dALxx")));

var $3epOE = parcelRequire("3epOE");

var $d8826083c5af4ea7$var$_useSlot = $d8826083c5af4ea7$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $d8826083c5af4ea7$var$variantComponent = {
    standard: $d8826083c5af4ea7$var$_Input.default,
    filled: $d8826083c5af4ea7$var$_FilledInput.default,
    outlined: $d8826083c5af4ea7$var$_OutlinedInput.default
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $d8826083c5af4ea7$var$_composeClasses.default)(slots, $3epOE.getTextFieldUtilityClass, classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $aAbgT.styled)($d8826083c5af4ea7$var$_FormControl.default, {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $d8826083c5af4ea7$var$React.forwardRef(function TextField(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const id = (0, $d8826083c5af4ea7$var$_useId.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('root', {
        elementType: $d8826083c5af4ea7$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $d8826083c5af4ea7$var$_clsx.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('inputLabel', {
        elementType: $d8826083c5af4ea7$var$_InputLabel.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('formHelperText', {
        elementType: $d8826083c5af4ea7$var$_FormHelperText.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $d8826083c5af4ea7$var$_useSlot.default)('select', {
        elementType: $d8826083c5af4ea7$var$_Select.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $d8826083c5af4ea7$var$_default = module.exports.default = $d8826083c5af4ea7$var$TextField;

});
parcelRegister("eAJp9", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a9f7a5eb14f1ec4f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a9f7a5eb14f1ec4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a9f7a5eb14f1ec4f$var$_exportNames = {
    inputClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a9f7a5eb14f1ec4f$var$_Input.default;
    }
});
Object.defineProperty(module.exports, "inputClasses", {
    enumerable: true,
    get: function() {
        return $a9f7a5eb14f1ec4f$var$_inputClasses.default;
    }
});

var $a9f7a5eb14f1ec4f$var$_Input = $a9f7a5eb14f1ec4f$require$_interopRequireDefault((parcelRequire("ab7Se")));

var $a9f7a5eb14f1ec4f$var$_inputClasses = $a9f7a5eb14f1ec4f$require$_interopRequireWildcard((parcelRequire("b3ugU")));
Object.keys($a9f7a5eb14f1ec4f$var$_inputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a9f7a5eb14f1ec4f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a9f7a5eb14f1ec4f$var$_inputClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a9f7a5eb14f1ec4f$var$_inputClasses[key];
        }
    });
});

});
parcelRegister("ab7Se", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $76910a07fd4ac4fe$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $76910a07fd4ac4fe$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76910a07fd4ac4fe$var$React = $76910a07fd4ac4fe$require$_interopRequireWildcard((parcelRequire("acw62")));

var $76910a07fd4ac4fe$var$_propTypes = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $76910a07fd4ac4fe$var$_composeClasses = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $76910a07fd4ac4fe$var$_deepmerge = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $76910a07fd4ac4fe$var$_refType = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $76910a07fd4ac4fe$var$_InputBase = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $76910a07fd4ac4fe$var$_rootShouldForwardProp = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $76910a07fd4ac4fe$var$_memoTheme = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $76910a07fd4ac4fe$var$_createSimplePaletteValueFilter = $76910a07fd4ac4fe$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $76910a07fd4ac4fe$var$_inputClasses = $76910a07fd4ac4fe$require$_interopRequireWildcard((parcelRequire("b3ugU")));

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $76910a07fd4ac4fe$var$_composeClasses.default)(slots, $76910a07fd4ac4fe$var$_inputClasses.getInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $aAbgT.styled)($95gUw.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, $76910a07fd4ac4fe$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $76910a07fd4ac4fe$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$76910a07fd4ac4fe$var$_inputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$76910a07fd4ac4fe$var$_inputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$76910a07fd4ac4fe$var$_inputClasses.default.disabled}, .${$76910a07fd4ac4fe$var$_inputClasses.default.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${$76910a07fd4ac4fe$var$_inputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $76910a07fd4ac4fe$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $76910a07fd4ac4fe$var$InputInput = (0, $aAbgT.styled)($95gUw.InputBaseInput, {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: $95gUw.inputOverridesResolver
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $76910a07fd4ac4fe$var$React.forwardRef(function Input(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $76910a07fd4ac4fe$var$_deepmerge.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($76910a07fd4ac4fe$var$_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$var$_default = module.exports.default = $76910a07fd4ac4fe$var$Input;

});


parcelRegister("hE2RV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cd8865c776d8094c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cd8865c776d8094c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cd8865c776d8094c$var$_exportNames = {
    filledInputClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cd8865c776d8094c$var$_FilledInput.default;
    }
});
Object.defineProperty(module.exports, "filledInputClasses", {
    enumerable: true,
    get: function() {
        return $cd8865c776d8094c$var$_filledInputClasses.default;
    }
});

var $cd8865c776d8094c$var$_FilledInput = $cd8865c776d8094c$require$_interopRequireDefault((parcelRequire("g4sO2")));

var $cd8865c776d8094c$var$_filledInputClasses = $cd8865c776d8094c$require$_interopRequireWildcard((parcelRequire("faAxf")));
Object.keys($cd8865c776d8094c$var$_filledInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cd8865c776d8094c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cd8865c776d8094c$var$_filledInputClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cd8865c776d8094c$var$_filledInputClasses[key];
        }
    });
});

});
parcelRegister("g4sO2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bb335d5457c07f5b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bb335d5457c07f5b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb335d5457c07f5b$var$React = $bb335d5457c07f5b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bb335d5457c07f5b$var$_deepmerge = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $bb335d5457c07f5b$var$_refType = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $bb335d5457c07f5b$var$_propTypes = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bb335d5457c07f5b$var$_composeClasses = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bb335d5457c07f5b$var$_InputBase = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $bb335d5457c07f5b$var$_rootShouldForwardProp = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $bb335d5457c07f5b$var$_memoTheme = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $bb335d5457c07f5b$var$_createSimplePaletteValueFilter = $bb335d5457c07f5b$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $bb335d5457c07f5b$var$_filledInputClasses = $bb335d5457c07f5b$require$_interopRequireWildcard((parcelRequire("faAxf")));

var $95gUw = parcelRequire("95gUw");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $hGPki.capitalize)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $bb335d5457c07f5b$var$_composeClasses.default)(slots, $bb335d5457c07f5b$var$_filledInputClasses.getFilledInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $aAbgT.styled)($95gUw.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, $bb335d5457c07f5b$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $bb335d5457c07f5b$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$bb335d5457c07f5b$var$_filledInputClasses.default.disabled}, .${$bb335d5457c07f5b$var$_filledInputClasses.default.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${$bb335d5457c07f5b$var$_filledInputClasses.default.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $bb335d5457c07f5b$var$_createSimplePaletteValueFilter.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $bb335d5457c07f5b$var$FilledInputInput = (0, $aAbgT.styled)($95gUw.InputBaseInput, {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: $95gUw.inputOverridesResolver
})((0, $bb335d5457c07f5b$var$_memoTheme.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $bb335d5457c07f5b$var$React.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $bb335d5457c07f5b$var$_deepmerge.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bb335d5457c07f5b$var$_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$var$_default = module.exports.default = $bb335d5457c07f5b$var$FilledInput;

});


parcelRegister("in82R", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d6009d8f79a7cefd$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d6009d8f79a7cefd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d6009d8f79a7cefd$var$_exportNames = {
    outlinedInputClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d6009d8f79a7cefd$var$_OutlinedInput.default;
    }
});
Object.defineProperty(module.exports, "outlinedInputClasses", {
    enumerable: true,
    get: function() {
        return $d6009d8f79a7cefd$var$_outlinedInputClasses.default;
    }
});

var $d6009d8f79a7cefd$var$_OutlinedInput = $d6009d8f79a7cefd$require$_interopRequireDefault((parcelRequire("imehR")));

var $d6009d8f79a7cefd$var$_outlinedInputClasses = $d6009d8f79a7cefd$require$_interopRequireWildcard((parcelRequire("96QZi")));
Object.keys($d6009d8f79a7cefd$var$_outlinedInputClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d6009d8f79a7cefd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d6009d8f79a7cefd$var$_outlinedInputClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d6009d8f79a7cefd$var$_outlinedInputClasses[key];
        }
    });
});

});
parcelRegister("imehR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d5d55d2dd82639e9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d5d55d2dd82639e9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5d55d2dd82639e9$var$React = $d5d55d2dd82639e9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d5d55d2dd82639e9$var$_propTypes = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d5d55d2dd82639e9$var$_refType = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $d5d55d2dd82639e9$var$_composeClasses = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d5d55d2dd82639e9$var$_NotchedOutline = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("9ZwEw")));

var $d5d55d2dd82639e9$var$_useFormControl = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $d5d55d2dd82639e9$var$_formControlState = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("aaphR")));

var $d5d55d2dd82639e9$var$_rootShouldForwardProp = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $d5d55d2dd82639e9$var$_memoTheme = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $d5d55d2dd82639e9$var$_createSimplePaletteValueFilter = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $d5d55d2dd82639e9$var$_outlinedInputClasses = $d5d55d2dd82639e9$require$_interopRequireWildcard((parcelRequire("96QZi")));

var $d5d55d2dd82639e9$var$_InputBase = $d5d55d2dd82639e9$require$_interopRequireWildcard((parcelRequire("95gUw")));

var $d5d55d2dd82639e9$var$_useSlot = $d5d55d2dd82639e9$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $d5d55d2dd82639e9$var$_composeClasses.default)(slots, $d5d55d2dd82639e9$var$_outlinedInputClasses.getOutlinedInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $aAbgT.styled)($d5d55d2dd82639e9$var$_InputBase.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, $d5d55d2dd82639e9$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: $d5d55d2dd82639e9$var$_InputBase.rootOverridesResolver
})((0, $d5d55d2dd82639e9$var$_memoTheme.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.focused} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $d5d55d2dd82639e9$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.focused} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.error} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.disabled} .${$d5d55d2dd82639e9$var$_outlinedInputClasses.default.notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $aAbgT.styled)($d5d55d2dd82639e9$var$_NotchedOutline.default, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $d5d55d2dd82639e9$var$_memoTheme.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $aAbgT.styled)($d5d55d2dd82639e9$var$_InputBase.InputBaseInput, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: $d5d55d2dd82639e9$var$_InputBase.inputOverridesResolver
})((0, $d5d55d2dd82639e9$var$_memoTheme.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $d5d55d2dd82639e9$var$React.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $d5d55d2dd82639e9$var$_useFormControl.default)();
    const fcs = (0, $d5d55d2dd82639e9$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $d5d55d2dd82639e9$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $d5d55d2dd82639e9$var$_useSlot.default)('notchedOutline', {
        elementType: $d5d55d2dd82639e9$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($d5d55d2dd82639e9$var$React.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$var$_default = module.exports.default = $d5d55d2dd82639e9$var$OutlinedInput;

});
parcelRegister("9ZwEw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $746323a953600e78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $746323a953600e78$var$NotchedOutline;

var $746323a953600e78$var$_propTypes = $746323a953600e78$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $746323a953600e78$var$_rootShouldForwardProp = $746323a953600e78$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $746323a953600e78$var$_memoTheme = $746323a953600e78$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ayMG0 = parcelRequire("ayMG0");
var $746323a953600e78$var$_span;
const $746323a953600e78$var$NotchedOutlineRoot = (0, $aAbgT.styled)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: $746323a953600e78$var$_rootShouldForwardProp.default
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $aAbgT.styled)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: $746323a953600e78$var$_rootShouldForwardProp.default
})((0, $746323a953600e78$var$_memoTheme.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $746323a953600e78$var$NotchedOutline(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});



parcelRegister("k9xmz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $eabe871db5ab5d36$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eabe871db5ab5d36$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eabe871db5ab5d36$var$_exportNames = {
    inputLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eabe871db5ab5d36$var$_InputLabel.default;
    }
});
Object.defineProperty(module.exports, "inputLabelClasses", {
    enumerable: true,
    get: function() {
        return $eabe871db5ab5d36$var$_inputLabelClasses.default;
    }
});

var $eabe871db5ab5d36$var$_InputLabel = $eabe871db5ab5d36$require$_interopRequireDefault((parcelRequire("OEVqP")));

var $eabe871db5ab5d36$var$_inputLabelClasses = $eabe871db5ab5d36$require$_interopRequireWildcard((parcelRequire("cCThE")));
Object.keys($eabe871db5ab5d36$var$_inputLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eabe871db5ab5d36$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eabe871db5ab5d36$var$_inputLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eabe871db5ab5d36$var$_inputLabelClasses[key];
        }
    });
});

});
parcelRegister("OEVqP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $09846a8ab0aba36e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $09846a8ab0aba36e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09846a8ab0aba36e$var$React = $09846a8ab0aba36e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $09846a8ab0aba36e$var$_propTypes = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09846a8ab0aba36e$var$_composeClasses = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $09846a8ab0aba36e$var$_clsx = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $09846a8ab0aba36e$var$_formControlState = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("aaphR")));

var $09846a8ab0aba36e$var$_useFormControl = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $09846a8ab0aba36e$var$_FormLabel = $09846a8ab0aba36e$require$_interopRequireWildcard((parcelRequire("d7nZ1")));

var $09846a8ab0aba36e$var$_capitalize = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $09846a8ab0aba36e$var$_rootShouldForwardProp = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $09846a8ab0aba36e$var$_memoTheme = $09846a8ab0aba36e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $cCThE = parcelRequire("cCThE");

var $ayMG0 = parcelRequire("ayMG0");
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $09846a8ab0aba36e$var$_capitalize.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $09846a8ab0aba36e$var$_composeClasses.default)(slots, $cCThE.getInputLabelUtilityClasses, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $aAbgT.styled)($09846a8ab0aba36e$var$_FormLabel.default, {
    shouldForwardProp: (prop)=>(0, $09846a8ab0aba36e$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$09846a8ab0aba36e$var$_FormLabel.formLabelClasses.asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $09846a8ab0aba36e$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $09846a8ab0aba36e$var$React.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $09846a8ab0aba36e$var$_useFormControl.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $09846a8ab0aba36e$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $09846a8ab0aba36e$var$_clsx.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $09846a8ab0aba36e$var$_default = module.exports.default = $09846a8ab0aba36e$var$InputLabel;

});
parcelRegister("d7nZ1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $98ce88637df666c4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $98ce88637df666c4$var$_exportNames = {
    formLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $98ce88637df666c4$var$_FormLabel.default;
    }
});
Object.defineProperty(module.exports, "formLabelClasses", {
    enumerable: true,
    get: function() {
        return $98ce88637df666c4$var$_formLabelClasses.default;
    }
});

var $98ce88637df666c4$var$_FormLabel = $98ce88637df666c4$require$_interopRequireWildcard((parcelRequire("djhCy")));
Object.keys($98ce88637df666c4$var$_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($98ce88637df666c4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $98ce88637df666c4$var$_FormLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $98ce88637df666c4$var$_FormLabel[key];
        }
    });
});

var $98ce88637df666c4$var$_formLabelClasses = $98ce88637df666c4$require$_interopRequireWildcard((parcelRequire("h2sOW")));
Object.keys($98ce88637df666c4$var$_formLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($98ce88637df666c4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $98ce88637df666c4$var$_formLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $98ce88637df666c4$var$_formLabelClasses[key];
        }
    });
});

});
parcelRegister("djhCy", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9b0ab7de0d37835d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9b0ab7de0d37835d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.FormLabelRoot = void 0;

var $9b0ab7de0d37835d$var$React = $9b0ab7de0d37835d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9b0ab7de0d37835d$var$_propTypes = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9b0ab7de0d37835d$var$_clsx = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9b0ab7de0d37835d$var$_composeClasses = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9b0ab7de0d37835d$var$_formControlState = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("aaphR")));

var $9b0ab7de0d37835d$var$_useFormControl = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $9b0ab7de0d37835d$var$_capitalize = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $9b0ab7de0d37835d$var$_memoTheme = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $9b0ab7de0d37835d$var$_createSimplePaletteValueFilter = $9b0ab7de0d37835d$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $9b0ab7de0d37835d$var$_formLabelClasses = $9b0ab7de0d37835d$require$_interopRequireWildcard((parcelRequire("h2sOW")));

var $ayMG0 = parcelRequire("ayMG0");
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $9b0ab7de0d37835d$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $9b0ab7de0d37835d$var$_composeClasses.default)(slots, $9b0ab7de0d37835d$var$_formLabelClasses.getFormLabelUtilityClasses, classes);
};
const $9b0ab7de0d37835d$var$FormLabelRoot = module.exports.FormLabelRoot = (0, $aAbgT.styled)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $9b0ab7de0d37835d$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9b0ab7de0d37835d$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $aAbgT.styled)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $9b0ab7de0d37835d$var$_memoTheme.default)(({ theme: theme })=>({
        [`&.${$9b0ab7de0d37835d$var$_formLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $9b0ab7de0d37835d$var$React.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $9b0ab7de0d37835d$var$_useFormControl.default)();
    const fcs = (0, $9b0ab7de0d37835d$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$FormLabelRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $9b0ab7de0d37835d$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $9b0ab7de0d37835d$var$_default = module.exports.default = $9b0ab7de0d37835d$var$FormLabel;

});
parcelRegister("h2sOW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c678fac155df4fc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormLabelUtilityClasses = $c678fac155df4fc3$var$getFormLabelUtilityClasses;

var $c678fac155df4fc3$var$_generateUtilityClasses = $c678fac155df4fc3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c678fac155df4fc3$var$_generateUtilityClass = $c678fac155df4fc3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c678fac155df4fc3$var$getFormLabelUtilityClasses(slot) {
    return (0, $c678fac155df4fc3$var$_generateUtilityClass.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $c678fac155df4fc3$var$_generateUtilityClasses.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$var$_default = module.exports.default = $c678fac155df4fc3$var$formLabelClasses;

});



parcelRegister("cCThE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9313ead0c5e2e8ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputLabelUtilityClasses = $9313ead0c5e2e8ca$var$getInputLabelUtilityClasses;

var $9313ead0c5e2e8ca$var$_generateUtilityClasses = $9313ead0c5e2e8ca$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9313ead0c5e2e8ca$var$_generateUtilityClass = $9313ead0c5e2e8ca$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9313ead0c5e2e8ca$var$getInputLabelUtilityClasses(slot) {
    return (0, $9313ead0c5e2e8ca$var$_generateUtilityClass.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $9313ead0c5e2e8ca$var$_generateUtilityClasses.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$var$_default = module.exports.default = $9313ead0c5e2e8ca$var$inputLabelClasses;

});



parcelRegister("iA4iQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d86eed44238f23f0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d86eed44238f23f0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d86eed44238f23f0$var$_exportNames = {
    useFormControl: true,
    formControlClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d86eed44238f23f0$var$_FormControl.default;
    }
});
Object.defineProperty(module.exports, "formControlClasses", {
    enumerable: true,
    get: function() {
        return $d86eed44238f23f0$var$_formControlClasses.default;
    }
});
Object.defineProperty(module.exports, "useFormControl", {
    enumerable: true,
    get: function() {
        return $d86eed44238f23f0$var$_useFormControl.default;
    }
});

var $d86eed44238f23f0$var$_FormControl = $d86eed44238f23f0$require$_interopRequireDefault((parcelRequire("gd5y7")));

var $d86eed44238f23f0$var$_useFormControl = $d86eed44238f23f0$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $d86eed44238f23f0$var$_formControlClasses = $d86eed44238f23f0$require$_interopRequireWildcard((parcelRequire("hGBKj")));
Object.keys($d86eed44238f23f0$var$_formControlClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d86eed44238f23f0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d86eed44238f23f0$var$_formControlClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d86eed44238f23f0$var$_formControlClasses[key];
        }
    });
});

});
parcelRegister("gd5y7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bcd22a386c6068c0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bcd22a386c6068c0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bcd22a386c6068c0$var$React = $bcd22a386c6068c0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bcd22a386c6068c0$var$_propTypes = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bcd22a386c6068c0$var$_clsx = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $bcd22a386c6068c0$var$_composeClasses = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $2BbKU = parcelRequire("2BbKU");

var $bcd22a386c6068c0$var$_capitalize = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $bcd22a386c6068c0$var$_isMuiElement = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $bcd22a386c6068c0$var$_FormControlContext = $bcd22a386c6068c0$require$_interopRequireDefault((parcelRequire("blr6C")));

var $hGBKj = parcelRequire("hGBKj");

var $ayMG0 = parcelRequire("ayMG0");
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $bcd22a386c6068c0$var$_capitalize.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $bcd22a386c6068c0$var$_composeClasses.default)(slots, $hGBKj.getFormControlUtilityClasses, classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $bcd22a386c6068c0$var$_capitalize.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $bcd22a386c6068c0$var$React.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $bcd22a386c6068c0$var$React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $bcd22a386c6068c0$var$React.Children.forEach(children, (child)=>{
            if (!(0, $bcd22a386c6068c0$var$_isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $bcd22a386c6068c0$var$_isMuiElement.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $2BbKU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $bcd22a386c6068c0$var$React.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $bcd22a386c6068c0$var$React.Children.forEach(children, (child)=>{
            if (!(0, $bcd22a386c6068c0$var$_isMuiElement.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $2BbKU.isFilled)(child.props, true) || (0, $2BbKU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $bcd22a386c6068c0$var$React.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $bcd22a386c6068c0$var$React.useRef(false);
    const onFilled = $bcd22a386c6068c0$var$React.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $bcd22a386c6068c0$var$React.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $bcd22a386c6068c0$var$React.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$_FormControlContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $bcd22a386c6068c0$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $bcd22a386c6068c0$var$_default = module.exports.default = $bcd22a386c6068c0$var$FormControl;

});
parcelRegister("hGBKj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ce03a37a8cfb980d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormControlUtilityClasses = $ce03a37a8cfb980d$var$getFormControlUtilityClasses;

var $ce03a37a8cfb980d$var$_generateUtilityClasses = $ce03a37a8cfb980d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ce03a37a8cfb980d$var$_generateUtilityClass = $ce03a37a8cfb980d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ce03a37a8cfb980d$var$getFormControlUtilityClasses(slot) {
    return (0, $ce03a37a8cfb980d$var$_generateUtilityClass.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $ce03a37a8cfb980d$var$_generateUtilityClasses.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$var$_default = module.exports.default = $ce03a37a8cfb980d$var$formControlClasses;

});



parcelRegister("4xkW2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $34da7bc50263d1b5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $34da7bc50263d1b5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $34da7bc50263d1b5$var$_exportNames = {
    formHelperTextClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $34da7bc50263d1b5$var$_FormHelperText.default;
    }
});
Object.defineProperty(module.exports, "formHelperTextClasses", {
    enumerable: true,
    get: function() {
        return $34da7bc50263d1b5$var$_formHelperTextClasses.default;
    }
});

var $34da7bc50263d1b5$var$_FormHelperText = $34da7bc50263d1b5$require$_interopRequireDefault((parcelRequire("i32L9")));

var $34da7bc50263d1b5$var$_formHelperTextClasses = $34da7bc50263d1b5$require$_interopRequireWildcard((parcelRequire("e7ceb")));
Object.keys($34da7bc50263d1b5$var$_formHelperTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($34da7bc50263d1b5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $34da7bc50263d1b5$var$_formHelperTextClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $34da7bc50263d1b5$var$_formHelperTextClasses[key];
        }
    });
});

});
parcelRegister("i32L9", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d23aa5c3ca6913fb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d23aa5c3ca6913fb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d23aa5c3ca6913fb$var$React = $d23aa5c3ca6913fb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d23aa5c3ca6913fb$var$_propTypes = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d23aa5c3ca6913fb$var$_clsx = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d23aa5c3ca6913fb$var$_composeClasses = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d23aa5c3ca6913fb$var$_formControlState = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("aaphR")));

var $d23aa5c3ca6913fb$var$_useFormControl = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $aAbgT = parcelRequire("aAbgT");

var $d23aa5c3ca6913fb$var$_memoTheme = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $d23aa5c3ca6913fb$var$_capitalize = $d23aa5c3ca6913fb$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $d23aa5c3ca6913fb$var$_formHelperTextClasses = $d23aa5c3ca6913fb$require$_interopRequireWildcard((parcelRequire("e7ceb")));

var $ayMG0 = parcelRequire("ayMG0");
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $d23aa5c3ca6913fb$var$_capitalize.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $d23aa5c3ca6913fb$var$_composeClasses.default)(slots, $d23aa5c3ca6913fb$var$_formHelperTextClasses.getFormHelperTextUtilityClasses, classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $aAbgT.styled)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $d23aa5c3ca6913fb$var$_capitalize.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $d23aa5c3ca6913fb$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${$d23aa5c3ca6913fb$var$_formHelperTextClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${$d23aa5c3ca6913fb$var$_formHelperTextClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $d23aa5c3ca6913fb$var$React.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $d23aa5c3ca6913fb$var$_useFormControl.default)();
    const fcs = (0, $d23aa5c3ca6913fb$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, {
        as: component,
        className: (0, $d23aa5c3ca6913fb$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $d23aa5c3ca6913fb$var$_default = module.exports.default = $d23aa5c3ca6913fb$var$FormHelperText;

});
parcelRegister("e7ceb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a46b344d341d82c0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormHelperTextUtilityClasses = $a46b344d341d82c0$var$getFormHelperTextUtilityClasses;

var $a46b344d341d82c0$var$_generateUtilityClasses = $a46b344d341d82c0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a46b344d341d82c0$var$_generateUtilityClass = $a46b344d341d82c0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a46b344d341d82c0$var$getFormHelperTextUtilityClasses(slot) {
    return (0, $a46b344d341d82c0$var$_generateUtilityClass.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $a46b344d341d82c0$var$_generateUtilityClasses.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$var$_default = module.exports.default = $a46b344d341d82c0$var$formHelperTextClasses;

});



parcelRegister("dALxx", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9e53839d220648fc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9e53839d220648fc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9e53839d220648fc$var$_exportNames = {
    selectClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9e53839d220648fc$var$_Select.default;
    }
});
Object.defineProperty(module.exports, "selectClasses", {
    enumerable: true,
    get: function() {
        return $9e53839d220648fc$var$_selectClasses.default;
    }
});

var $9e53839d220648fc$var$_Select = $9e53839d220648fc$require$_interopRequireDefault((parcelRequire("cX7V2")));

var $9e53839d220648fc$var$_selectClasses = $9e53839d220648fc$require$_interopRequireWildcard((parcelRequire("bmfPX")));
Object.keys($9e53839d220648fc$var$_selectClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9e53839d220648fc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9e53839d220648fc$var$_selectClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9e53839d220648fc$var$_selectClasses[key];
        }
    });
});

});
parcelRegister("cX7V2", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $96e1233e8d06bb2d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $96e1233e8d06bb2d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96e1233e8d06bb2d$var$React = $96e1233e8d06bb2d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $96e1233e8d06bb2d$var$_propTypes = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $96e1233e8d06bb2d$var$_clsx = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $96e1233e8d06bb2d$var$_deepmerge = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $96e1233e8d06bb2d$var$_composeClasses = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $96e1233e8d06bb2d$var$_getReactElementRef = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $96e1233e8d06bb2d$var$_SelectInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("c0lH6")));

var $96e1233e8d06bb2d$var$_formControlState = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("aaphR")));

var $96e1233e8d06bb2d$var$_useFormControl = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $96e1233e8d06bb2d$var$_ArrowDropDown = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("7LRfY")));

var $96e1233e8d06bb2d$var$_Input = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("eAJp9")));

var $96e1233e8d06bb2d$var$_NativeSelectInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("iOErJ")));

var $96e1233e8d06bb2d$var$_FilledInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("hE2RV")));

var $96e1233e8d06bb2d$var$_OutlinedInput = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("in82R")));

var $hL1nr = parcelRequire("hL1nr");

var $96e1233e8d06bb2d$var$_useForkRef = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $aAbgT = parcelRequire("aAbgT");

var $96e1233e8d06bb2d$var$_rootShouldForwardProp = $96e1233e8d06bb2d$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $96e1233e8d06bb2d$var$_composeClasses.default)(slots, $bmfPX.getSelectUtilityClasses, classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $96e1233e8d06bb2d$var$_rootShouldForwardProp.default)(prop) && prop !== 'variant'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $aAbgT.styled)($96e1233e8d06bb2d$var$_Input.default, $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $aAbgT.styled)($96e1233e8d06bb2d$var$_OutlinedInput.default, $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $aAbgT.styled)($96e1233e8d06bb2d$var$_FilledInput.default, $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $96e1233e8d06bb2d$var$React.forwardRef(function Select(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = $96e1233e8d06bb2d$var$_ArrowDropDown.default, id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? $96e1233e8d06bb2d$var$_NativeSelectInput.default : $96e1233e8d06bb2d$var$_SelectInput.default;
    const muiFormControl = (0, $96e1233e8d06bb2d$var$_useFormControl.default)();
    const fcs = (0, $96e1233e8d06bb2d$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $96e1233e8d06bb2d$var$_useForkRef.default)(ref, (0, $96e1233e8d06bb2d$var$_getReactElementRef.default)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$React.Fragment, {
        children: /*#__PURE__*/ $96e1233e8d06bb2d$var$React.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $96e1233e8d06bb2d$var$_deepmerge.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $96e1233e8d06bb2d$var$_clsx.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$var$_default = module.exports.default = $96e1233e8d06bb2d$var$Select;

});
parcelRegister("c0lH6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8bd650259be885cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8bd650259be885cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bd650259be885cb$var$_formatMuiErrorMessage = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $8bd650259be885cb$var$React = $8bd650259be885cb$require$_interopRequireWildcard((parcelRequire("acw62")));


var $8bd650259be885cb$var$_propTypes = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8bd650259be885cb$var$_clsx = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8bd650259be885cb$var$_composeClasses = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8bd650259be885cb$var$_useId = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("hwliF")));

var $8bd650259be885cb$var$_refType = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $8bd650259be885cb$var$_ownerDocument = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $8bd650259be885cb$var$_capitalize = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $8bd650259be885cb$var$_Menu = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("4F5tJ")));

var $iOErJ = parcelRequire("iOErJ");

var $2BbKU = parcelRequire("2BbKU");

var $aAbgT = parcelRequire("aAbgT");

var $8bd650259be885cb$var$_slotShouldForwardProp = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $8bd650259be885cb$var$_useForkRef = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $8bd650259be885cb$var$_useControlled = $8bd650259be885cb$require$_interopRequireDefault((parcelRequire("3yddg")));

var $8bd650259be885cb$var$_selectClasses = $8bd650259be885cb$require$_interopRequireWildcard((parcelRequire("bmfPX")));

var $ayMG0 = parcelRequire("ayMG0");
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$SelectSelect = (0, $aAbgT.styled)($iOErJ.StyledSelectSelect, {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.select}`]: styles.select
            },
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.select}`]: styles[ownerState.variant]
            },
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.error}`]: styles.error
            },
            {
                [`&.${$8bd650259be885cb$var$_selectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${$8bd650259be885cb$var$_selectClasses.default.select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $aAbgT.styled)($iOErJ.StyledSelectIcon, {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $8bd650259be885cb$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $8bd650259be885cb$var$SelectNativeInput = (0, $aAbgT.styled)('input', {
    shouldForwardProp: (prop)=>(0, $8bd650259be885cb$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $8bd650259be885cb$var$_capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8bd650259be885cb$var$_composeClasses.default)(slots, $8bd650259be885cb$var$_selectClasses.getSelectUtilityClasses, classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $8bd650259be885cb$var$React.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onKeyDown: // eslint-disable-next-line react/prop-types
    onKeyDown, onMouseDown: // eslint-disable-next-line react/prop-types
    onMouseDown, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $8bd650259be885cb$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $8bd650259be885cb$var$_useControlled.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $8bd650259be885cb$var$React.useRef(null);
    const displayRef = $8bd650259be885cb$var$React.useRef(null);
    const [displayNode, setDisplayNode] = $8bd650259be885cb$var$React.useState(null);
    const { current: isOpenControlled } = $8bd650259be885cb$var$React.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $8bd650259be885cb$var$React.useState();
    const handleRef = (0, $8bd650259be885cb$var$_useForkRef.default)(ref, inputRefProp);
    const handleDisplayRef = $8bd650259be885cb$var$React.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $8bd650259be885cb$var$React.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    const open = displayNode !== null && openState;
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (!open || !anchorElement || autoWidth) return undefined;
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            setMenuMinWidthState(anchorElement.clientWidth);
        });
        observer.observe(anchorElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        open,
        anchorElement,
        autoWidth
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $8bd650259be885cb$var$React.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8bd650259be885cb$var$_ownerDocument.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (openParam, event)=>{
        if (openParam) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(openParam);
        }
    };
    const handleMouseDown = (event)=>{
        onMouseDown?.(event);
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $8bd650259be885cb$var$React.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
            onKeyDown?.(event);
        }
    };
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2BbKU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $8bd650259be885cb$var$React.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $8bd650259be885cb$var$_formatMuiErrorMessage.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $8bd650259be885cb$var$React.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $8bd650259be885cb$var$_useId.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8bd650259be885cb$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $8bd650259be885cb$var$_clsx.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$_Menu.default, {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...listProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $8bd650259be885cb$var$_default = module.exports.default = $8bd650259be885cb$var$SelectInput;

});
parcelRegister("4F5tJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $364f3db28d8d2e79$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $364f3db28d8d2e79$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.MenuPaper = void 0;

var $364f3db28d8d2e79$var$React = $364f3db28d8d2e79$require$_interopRequireWildcard((parcelRequire("acw62")));


var $364f3db28d8d2e79$var$_propTypes = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $364f3db28d8d2e79$var$_clsx = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("9QePP")));

var $364f3db28d8d2e79$var$_composeClasses = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $364f3db28d8d2e79$var$_HTMLElementType = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $9uEev = parcelRequire("9uEev");

var $364f3db28d8d2e79$var$_useSlotProps = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("839K0")));

var $364f3db28d8d2e79$var$_MenuList = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $364f3db28d8d2e79$var$_Popover = $364f3db28d8d2e79$require$_interopRequireWildcard((parcelRequire("32yuL")));

var $364f3db28d8d2e79$var$_rootShouldForwardProp = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $lyHsQ = parcelRequire("lyHsQ");

var $364f3db28d8d2e79$var$_useSlot = $364f3db28d8d2e79$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $364f3db28d8d2e79$var$_composeClasses.default)(slots, $lyHsQ.getMenuUtilityClass, classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $aAbgT.styled)($364f3db28d8d2e79$var$_Popover.default, {
    shouldForwardProp: (prop)=>(0, $364f3db28d8d2e79$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $364f3db28d8d2e79$var$MenuPaper = module.exports.MenuPaper = (0, $aAbgT.styled)($364f3db28d8d2e79$var$_Popover.PopoverPaper, {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $aAbgT.styled)($364f3db28d8d2e79$var$_MenuList.default, {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $364f3db28d8d2e79$var$React.forwardRef(function Menu(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $364f3db28d8d2e79$var$React.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $364f3db28d8d2e79$var$React.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $364f3db28d8d2e79$var$React.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $364f3db28d8d2e79$var$_useSlotProps.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $364f3db28d8d2e79$var$_useSlot.default)('paper', {
        className: classes.paper,
        elementType: $364f3db28d8d2e79$var$MenuPaper,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $364f3db28d8d2e79$var$_useSlot.default)('list', {
        className: (0, $364f3db28d8d2e79$var$_clsx.default)(classes.list, MenuListProps.className),
        elementType: $364f3db28d8d2e79$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $364f3db28d8d2e79$var$_default = module.exports.default = $364f3db28d8d2e79$var$Menu;

});
parcelRegister("32yuL", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $236c5104463510ad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $236c5104463510ad$var$_exportNames = {
    popoverClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $236c5104463510ad$var$_Popover.default;
    }
});
Object.defineProperty(module.exports, "popoverClasses", {
    enumerable: true,
    get: function() {
        return $236c5104463510ad$var$_popoverClasses.default;
    }
});

var $236c5104463510ad$var$_Popover = $236c5104463510ad$require$_interopRequireWildcard((parcelRequire("6el2W")));
Object.keys($236c5104463510ad$var$_Popover).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($236c5104463510ad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $236c5104463510ad$var$_Popover[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $236c5104463510ad$var$_Popover[key];
        }
    });
});

var $236c5104463510ad$var$_popoverClasses = $236c5104463510ad$require$_interopRequireWildcard((parcelRequire("k6uEG")));
Object.keys($236c5104463510ad$var$_popoverClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($236c5104463510ad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $236c5104463510ad$var$_popoverClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $236c5104463510ad$var$_popoverClasses[key];
        }
    });
});

});
parcelRegister("6el2W", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $012baef8dc9ae9d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $012baef8dc9ae9d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.PopoverRoot = module.exports.PopoverPaper = void 0;
module.exports.getOffsetLeft = $012baef8dc9ae9d0$var$getOffsetLeft;
module.exports.getOffsetTop = $012baef8dc9ae9d0$var$getOffsetTop;

var $012baef8dc9ae9d0$var$React = $012baef8dc9ae9d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $012baef8dc9ae9d0$var$_propTypes = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $012baef8dc9ae9d0$var$_clsx = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $012baef8dc9ae9d0$var$_composeClasses = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $012baef8dc9ae9d0$var$_HTMLElementType = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $012baef8dc9ae9d0$var$_refType = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $012baef8dc9ae9d0$var$_elementTypeAcceptingRef = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $012baef8dc9ae9d0$var$_integerPropType = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $012baef8dc9ae9d0$var$_chainPropTypes = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("abVWF")));

var $012baef8dc9ae9d0$var$_isHostComponent = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $012baef8dc9ae9d0$var$_isLayoutSupported = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("6toKj")));

var $012baef8dc9ae9d0$var$_debounce = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $012baef8dc9ae9d0$var$_ownerDocument = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $012baef8dc9ae9d0$var$_ownerWindow = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $012baef8dc9ae9d0$var$_Grow = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $012baef8dc9ae9d0$var$_Modal = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("8vVVd")));

var $012baef8dc9ae9d0$var$_Paper = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $k6uEG = parcelRequire("k6uEG");

var $012baef8dc9ae9d0$var$_useSlot = $012baef8dc9ae9d0$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
function $012baef8dc9ae9d0$var$getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$var$getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $012baef8dc9ae9d0$var$_composeClasses.default)(slots, $k6uEG.getPopoverUtilityClass, classes);
};
const $012baef8dc9ae9d0$var$PopoverRoot = module.exports.PopoverRoot = (0, $aAbgT.styled)($012baef8dc9ae9d0$var$_Modal.default, {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $012baef8dc9ae9d0$var$PopoverPaper = module.exports.PopoverPaper = (0, $aAbgT.styled)($012baef8dc9ae9d0$var$_Paper.default, {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $012baef8dc9ae9d0$var$React.forwardRef(function Popover(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $012baef8dc9ae9d0$var$React.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $012baef8dc9ae9d0$var$React.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $012baef8dc9ae9d0$var$_ownerDocument.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$var$getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$var$getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $012baef8dc9ae9d0$var$React.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$var$getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$var$getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $012baef8dc9ae9d0$var$React.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $012baef8dc9ae9d0$var$_ownerWindow.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $012baef8dc9ae9d0$var$React.useState(open);
    const setPositioningStyles = $012baef8dc9ae9d0$var$React.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $012baef8dc9ae9d0$var$React.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $012baef8dc9ae9d0$var$React.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $012baef8dc9ae9d0$var$React.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $012baef8dc9ae9d0$var$React.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $012baef8dc9ae9d0$var$_debounce.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $012baef8dc9ae9d0$var$_ownerWindow.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $012baef8dc9ae9d0$var$_useSlot.default)('transition', {
        elementType: $012baef8dc9ae9d0$var$_Grow.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $012baef8dc9ae9d0$var$_ownerDocument.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $012baef8dc9ae9d0$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $012baef8dc9ae9d0$var$PopoverRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $hGPki.mergeSlotProps)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $012baef8dc9ae9d0$var$_clsx.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $012baef8dc9ae9d0$var$_useSlot.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $012baef8dc9ae9d0$var$PopoverPaper,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $012baef8dc9ae9d0$var$_isHostComponent.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $012baef8dc9ae9d0$var$_default = module.exports.default = $012baef8dc9ae9d0$var$Popover;

});
parcelRegister("k6uEG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ea2c25a800e729b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPopoverUtilityClass = $ea2c25a800e729b1$var$getPopoverUtilityClass;

var $ea2c25a800e729b1$var$_generateUtilityClasses = $ea2c25a800e729b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ea2c25a800e729b1$var$_generateUtilityClass = $ea2c25a800e729b1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ea2c25a800e729b1$var$getPopoverUtilityClass(slot) {
    return (0, $ea2c25a800e729b1$var$_generateUtilityClass.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $ea2c25a800e729b1$var$_generateUtilityClasses.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$var$_default = module.exports.default = $ea2c25a800e729b1$var$popoverClasses;

});



parcelRegister("lyHsQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fb1e7d0ac8fac824$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMenuUtilityClass = $fb1e7d0ac8fac824$var$getMenuUtilityClass;

var $fb1e7d0ac8fac824$var$_generateUtilityClasses = $fb1e7d0ac8fac824$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fb1e7d0ac8fac824$var$_generateUtilityClass = $fb1e7d0ac8fac824$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fb1e7d0ac8fac824$var$getMenuUtilityClass(slot) {
    return (0, $fb1e7d0ac8fac824$var$_generateUtilityClass.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $fb1e7d0ac8fac824$var$_generateUtilityClasses.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$var$_default = module.exports.default = $fb1e7d0ac8fac824$var$menuClasses;

});


parcelRegister("iOErJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $db2c454fb2e8bc3c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $db2c454fb2e8bc3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.StyledSelectSelect = module.exports.StyledSelectIcon = void 0;

var $db2c454fb2e8bc3c$var$React = $db2c454fb2e8bc3c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $db2c454fb2e8bc3c$var$_propTypes = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $db2c454fb2e8bc3c$var$_clsx = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $db2c454fb2e8bc3c$var$_refType = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $db2c454fb2e8bc3c$var$_composeClasses = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $db2c454fb2e8bc3c$var$_capitalize = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $db2c454fb2e8bc3c$var$_nativeSelectClasses = $db2c454fb2e8bc3c$require$_interopRequireWildcard((parcelRequire("6jVRo")));

var $aAbgT = parcelRequire("aAbgT");

var $db2c454fb2e8bc3c$var$_rootShouldForwardProp = $db2c454fb2e8bc3c$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $ayMG0 = parcelRequire("ayMG0");
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $db2c454fb2e8bc3c$var$_capitalize.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $db2c454fb2e8bc3c$var$_composeClasses.default)(slots, $db2c454fb2e8bc3c$var$_nativeSelectClasses.getNativeSelectUtilityClasses, classes);
};
const $db2c454fb2e8bc3c$var$StyledSelectSelect = module.exports.StyledSelectSelect = (0, $aAbgT.styled)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${$db2c454fb2e8bc3c$var$_nativeSelectClasses.default.disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $aAbgT.styled)($db2c454fb2e8bc3c$var$StyledSelectSelect, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: $db2c454fb2e8bc3c$var$_rootShouldForwardProp.default,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${$db2c454fb2e8bc3c$var$_nativeSelectClasses.default.multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $db2c454fb2e8bc3c$var$StyledSelectIcon = module.exports.StyledSelectIcon = (0, $aAbgT.styled)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${$db2c454fb2e8bc3c$var$_nativeSelectClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $aAbgT.styled)($db2c454fb2e8bc3c$var$StyledSelectIcon, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $db2c454fb2e8bc3c$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $db2c454fb2e8bc3c$var$React.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($db2c454fb2e8bc3c$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $db2c454fb2e8bc3c$var$_clsx.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$var$_default = module.exports.default = $db2c454fb2e8bc3c$var$NativeSelectInput;

});
parcelRegister("6jVRo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $49a1663d7631a8fa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getNativeSelectUtilityClasses = $49a1663d7631a8fa$var$getNativeSelectUtilityClasses;

var $49a1663d7631a8fa$var$_generateUtilityClasses = $49a1663d7631a8fa$require$_interopRequireDefault((parcelRequire("5nY49")));

var $49a1663d7631a8fa$var$_generateUtilityClass = $49a1663d7631a8fa$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $49a1663d7631a8fa$var$getNativeSelectUtilityClasses(slot) {
    return (0, $49a1663d7631a8fa$var$_generateUtilityClass.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $49a1663d7631a8fa$var$_generateUtilityClasses.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$var$_default = module.exports.default = $49a1663d7631a8fa$var$nativeSelectClasses;

});


parcelRegister("bmfPX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $844e08aea9053c4b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSelectUtilityClasses = $844e08aea9053c4b$var$getSelectUtilityClasses;

var $844e08aea9053c4b$var$_generateUtilityClasses = $844e08aea9053c4b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $844e08aea9053c4b$var$_generateUtilityClass = $844e08aea9053c4b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $844e08aea9053c4b$var$getSelectUtilityClasses(slot) {
    return (0, $844e08aea9053c4b$var$_generateUtilityClass.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $844e08aea9053c4b$var$_generateUtilityClasses.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$var$_default = module.exports.default = $844e08aea9053c4b$var$selectClasses;

});




parcelRegister("3epOE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25a6b464d3ca38da$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTextFieldUtilityClass = $25a6b464d3ca38da$var$getTextFieldUtilityClass;

var $25a6b464d3ca38da$var$_generateUtilityClasses = $25a6b464d3ca38da$require$_interopRequireDefault((parcelRequire("5nY49")));

var $25a6b464d3ca38da$var$_generateUtilityClass = $25a6b464d3ca38da$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $25a6b464d3ca38da$var$getTextFieldUtilityClass(slot) {
    return (0, $25a6b464d3ca38da$var$_generateUtilityClass.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $25a6b464d3ca38da$var$_generateUtilityClasses.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$var$_default = module.exports.default = $25a6b464d3ca38da$var$textFieldClasses;

});



parcelRegister("i48ne", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d26f188d49f0430b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d26f188d49f0430b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d26f188d49f0430b$var$_exportNames = {
    formControlLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d26f188d49f0430b$var$_FormControlLabel.default;
    }
});
Object.defineProperty(module.exports, "formControlLabelClasses", {
    enumerable: true,
    get: function() {
        return $d26f188d49f0430b$var$_formControlLabelClasses.default;
    }
});

var $d26f188d49f0430b$var$_FormControlLabel = $d26f188d49f0430b$require$_interopRequireDefault((parcelRequire("2esSG")));

var $d26f188d49f0430b$var$_formControlLabelClasses = $d26f188d49f0430b$require$_interopRequireWildcard((parcelRequire("7Z1x5")));
Object.keys($d26f188d49f0430b$var$_formControlLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d26f188d49f0430b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d26f188d49f0430b$var$_formControlLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d26f188d49f0430b$var$_formControlLabelClasses[key];
        }
    });
});

});
parcelRegister("2esSG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1a034abd43bd8eee$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1a034abd43bd8eee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.FormControlLabelRoot = void 0;

var $1a034abd43bd8eee$var$React = $1a034abd43bd8eee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1a034abd43bd8eee$var$_propTypes = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1a034abd43bd8eee$var$_clsx = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1a034abd43bd8eee$var$_refType = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $1a034abd43bd8eee$var$_composeClasses = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $iA4iQ = parcelRequire("iA4iQ");

var $aAbgT = parcelRequire("aAbgT");

var $1a034abd43bd8eee$var$_memoTheme = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1a034abd43bd8eee$var$_Typography = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $1a034abd43bd8eee$var$_capitalize = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $1a034abd43bd8eee$var$_formControlLabelClasses = $1a034abd43bd8eee$require$_interopRequireWildcard((parcelRequire("7Z1x5")));

var $1a034abd43bd8eee$var$_formControlState = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("aaphR")));

var $1a034abd43bd8eee$var$_useSlot = $1a034abd43bd8eee$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $1a034abd43bd8eee$var$_capitalize.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $1a034abd43bd8eee$var$_composeClasses.default)(slots, $1a034abd43bd8eee$var$_formControlLabelClasses.getFormControlLabelUtilityClasses, classes);
};
const $1a034abd43bd8eee$var$FormControlLabelRoot = module.exports.FormControlLabelRoot = (0, $aAbgT.styled)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$1a034abd43bd8eee$var$_formControlLabelClasses.default.label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $1a034abd43bd8eee$var$_capitalize.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $1a034abd43bd8eee$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${$1a034abd43bd8eee$var$_formControlLabelClasses.default.disabled}`]: {
            cursor: 'default'
        },
        [`& .${$1a034abd43bd8eee$var$_formControlLabelClasses.default.label}`]: {
            [`&.${$1a034abd43bd8eee$var$_formControlLabelClasses.default.disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $aAbgT.styled)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $1a034abd43bd8eee$var$_memoTheme.default)(({ theme: theme })=>({
        [`&.${$1a034abd43bd8eee$var$_formControlLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $1a034abd43bd8eee$var$React.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $iA4iQ.useFormControl)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $1a034abd43bd8eee$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $1a034abd43bd8eee$var$_useSlot.default)('typography', {
        elementType: $1a034abd43bd8eee$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== $1a034abd43bd8eee$var$_Typography.default && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $1a034abd43bd8eee$var$_clsx.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$FormControlLabelRoot, {
        className: (0, $1a034abd43bd8eee$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $1a034abd43bd8eee$var$React.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $1a034abd43bd8eee$var$_default = module.exports.default = $1a034abd43bd8eee$var$FormControlLabel;

});
parcelRegister("7Z1x5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5cff6b4166fff27c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormControlLabelUtilityClasses = $5cff6b4166fff27c$var$getFormControlLabelUtilityClasses;

var $5cff6b4166fff27c$var$_generateUtilityClasses = $5cff6b4166fff27c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5cff6b4166fff27c$var$_generateUtilityClass = $5cff6b4166fff27c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5cff6b4166fff27c$var$getFormControlLabelUtilityClasses(slot) {
    return (0, $5cff6b4166fff27c$var$_generateUtilityClass.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $5cff6b4166fff27c$var$_generateUtilityClasses.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$var$_default = module.exports.default = $5cff6b4166fff27c$var$formControlLabelClasses;

});



parcelRegister("5QQ7K", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $442a3dd08ba79e73$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $442a3dd08ba79e73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $442a3dd08ba79e73$var$_exportNames = {
    switchClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $442a3dd08ba79e73$var$_Switch.default;
    }
});
Object.defineProperty(module.exports, "switchClasses", {
    enumerable: true,
    get: function() {
        return $442a3dd08ba79e73$var$_switchClasses.default;
    }
});

var $442a3dd08ba79e73$var$_Switch = $442a3dd08ba79e73$require$_interopRequireDefault((parcelRequire("7s24a")));

var $442a3dd08ba79e73$var$_switchClasses = $442a3dd08ba79e73$require$_interopRequireWildcard((parcelRequire("89Onw")));
Object.keys($442a3dd08ba79e73$var$_switchClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($442a3dd08ba79e73$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $442a3dd08ba79e73$var$_switchClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $442a3dd08ba79e73$var$_switchClasses[key];
        }
    });
});

});
parcelRegister("7s24a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $56ccc0421702a0be$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $56ccc0421702a0be$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56ccc0421702a0be$var$React = $56ccc0421702a0be$require$_interopRequireWildcard((parcelRequire("acw62")));

var $56ccc0421702a0be$var$_propTypes = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $56ccc0421702a0be$var$_clsx = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("9QePP")));

var $56ccc0421702a0be$var$_refType = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $56ccc0421702a0be$var$_composeClasses = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $56ccc0421702a0be$var$_capitalize = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $56ccc0421702a0be$var$_createSimplePaletteValueFilter = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $56ccc0421702a0be$var$_SwitchBase = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("kVqvD")));

var $aAbgT = parcelRequire("aAbgT");

var $56ccc0421702a0be$var$_memoTheme = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $56ccc0421702a0be$var$_switchClasses = $56ccc0421702a0be$require$_interopRequireWildcard((parcelRequire("89Onw")));

var $56ccc0421702a0be$var$_useSlot = $56ccc0421702a0be$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $56ccc0421702a0be$var$_capitalize.default)(edge)}`,
            `size${(0, $56ccc0421702a0be$var$_capitalize.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $56ccc0421702a0be$var$_capitalize.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $56ccc0421702a0be$var$_composeClasses.default)(slots, $56ccc0421702a0be$var$_switchClasses.getSwitchUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $56ccc0421702a0be$var$_capitalize.default)(ownerState.edge)}`],
            styles[`size${(0, $56ccc0421702a0be$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${$56ccc0421702a0be$var$_switchClasses.default.thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${$56ccc0421702a0be$var$_switchClasses.default.switchBase}`]: {
                    padding: 4,
                    [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $aAbgT.styled)($56ccc0421702a0be$var$_SwitchBase.default, {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${$56ccc0421702a0be$var$_switchClasses.default.input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $56ccc0421702a0be$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked} + .${$56ccc0421702a0be$var$_switchClasses.default.track}`]: {
            opacity: 0.5
        },
        [`&.${$56ccc0421702a0be$var$_switchClasses.default.disabled} + .${$56ccc0421702a0be$var$_switchClasses.default.track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${$56ccc0421702a0be$var$_switchClasses.default.input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $56ccc0421702a0be$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${$56ccc0421702a0be$var$_switchClasses.default.disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${$56ccc0421702a0be$var$_switchClasses.default.checked} + .${$56ccc0421702a0be$var$_switchClasses.default.track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $56ccc0421702a0be$var$SwitchTrack = (0, $aAbgT.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $56ccc0421702a0be$var$SwitchThumb = (0, $aAbgT.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $56ccc0421702a0be$var$_memoTheme.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $56ccc0421702a0be$var$React.forwardRef(function Switch(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $56ccc0421702a0be$var$_useSlot.default)('root', {
        className: (0, $56ccc0421702a0be$var$_clsx.default)(classes.root, className),
        elementType: $56ccc0421702a0be$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $56ccc0421702a0be$var$_useSlot.default)('thumb', {
        className: classes.thumb,
        elementType: $56ccc0421702a0be$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $56ccc0421702a0be$var$_useSlot.default)('track', {
        className: classes.track,
        elementType: $56ccc0421702a0be$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    input: {
                        role: 'switch'
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $56ccc0421702a0be$var$_default = module.exports.default = $56ccc0421702a0be$var$Switch;

});
parcelRegister("89Onw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5f063e1b0f6d278b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSwitchUtilityClass = $5f063e1b0f6d278b$var$getSwitchUtilityClass;

var $5f063e1b0f6d278b$var$_generateUtilityClasses = $5f063e1b0f6d278b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5f063e1b0f6d278b$var$_generateUtilityClass = $5f063e1b0f6d278b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5f063e1b0f6d278b$var$getSwitchUtilityClass(slot) {
    return (0, $5f063e1b0f6d278b$var$_generateUtilityClass.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $5f063e1b0f6d278b$var$_generateUtilityClasses.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$var$_default = module.exports.default = $5f063e1b0f6d278b$var$switchClasses;

});



parcelRegister("9bswS", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6afb4578ee9180cf$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6afb4578ee9180cf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6afb4578ee9180cf$var$_exportNames = {
    inputAdornmentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6afb4578ee9180cf$var$_InputAdornment.default;
    }
});
Object.defineProperty(module.exports, "inputAdornmentClasses", {
    enumerable: true,
    get: function() {
        return $6afb4578ee9180cf$var$_inputAdornmentClasses.default;
    }
});

var $6afb4578ee9180cf$var$_InputAdornment = $6afb4578ee9180cf$require$_interopRequireDefault((parcelRequire("hViLc")));

var $6afb4578ee9180cf$var$_inputAdornmentClasses = $6afb4578ee9180cf$require$_interopRequireWildcard((parcelRequire("kWfSh")));
Object.keys($6afb4578ee9180cf$var$_inputAdornmentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6afb4578ee9180cf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6afb4578ee9180cf$var$_inputAdornmentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6afb4578ee9180cf$var$_inputAdornmentClasses[key];
        }
    });
});

});
parcelRegister("hViLc", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d0c64ff513a9933f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d0c64ff513a9933f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0c64ff513a9933f$var$React = $d0c64ff513a9933f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d0c64ff513a9933f$var$_propTypes = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d0c64ff513a9933f$var$_clsx = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d0c64ff513a9933f$var$_composeClasses = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $d0c64ff513a9933f$var$_capitalize = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $d0c64ff513a9933f$var$_Typography = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $d0c64ff513a9933f$var$_FormControlContext = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("blr6C")));

var $d0c64ff513a9933f$var$_useFormControl = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $aAbgT = parcelRequire("aAbgT");

var $d0c64ff513a9933f$var$_memoTheme = $d0c64ff513a9933f$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $d0c64ff513a9933f$var$_inputAdornmentClasses = $d0c64ff513a9933f$require$_interopRequireWildcard((parcelRequire("kWfSh")));

var $ayMG0 = parcelRequire("ayMG0");
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $d0c64ff513a9933f$var$_capitalize.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $d0c64ff513a9933f$var$_capitalize.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $d0c64ff513a9933f$var$_capitalize.default)(size)}`
        ]
    };
    return (0, $d0c64ff513a9933f$var$_composeClasses.default)(slots, $d0c64ff513a9933f$var$_inputAdornmentClasses.getInputAdornmentUtilityClass, classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})((0, $d0c64ff513a9933f$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${$d0c64ff513a9933f$var$_inputAdornmentClasses.default.positionStart}&:not(.${$d0c64ff513a9933f$var$_inputAdornmentClasses.default.hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $d0c64ff513a9933f$var$React.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $d0c64ff513a9933f$var$_useFormControl.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$_FormControlContext.default.Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $d0c64ff513a9933f$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$_Typography.default, {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($d0c64ff513a9933f$var$React.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $d0c64ff513a9933f$var$_default = module.exports.default = $d0c64ff513a9933f$var$InputAdornment;

});
parcelRegister("kWfSh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f3e589c60baacdec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputAdornmentUtilityClass = $f3e589c60baacdec$var$getInputAdornmentUtilityClass;

var $f3e589c60baacdec$var$_generateUtilityClasses = $f3e589c60baacdec$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f3e589c60baacdec$var$_generateUtilityClass = $f3e589c60baacdec$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f3e589c60baacdec$var$getInputAdornmentUtilityClass(slot) {
    return (0, $f3e589c60baacdec$var$_generateUtilityClass.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $f3e589c60baacdec$var$_generateUtilityClasses.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$var$_default = module.exports.default = $f3e589c60baacdec$var$inputAdornmentClasses;

});



parcelRegister("b3HhA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80d18c8911cf744f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $80d18c8911cf744f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80d18c8911cf744f$var$_exportNames = {
    tablePaginationClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80d18c8911cf744f$var$_TablePagination.default;
    }
});
Object.defineProperty(module.exports, "tablePaginationClasses", {
    enumerable: true,
    get: function() {
        return $80d18c8911cf744f$var$_tablePaginationClasses.default;
    }
});

var $80d18c8911cf744f$var$_TablePagination = $80d18c8911cf744f$require$_interopRequireDefault((parcelRequire("kBtCg")));

var $80d18c8911cf744f$var$_tablePaginationClasses = $80d18c8911cf744f$require$_interopRequireWildcard((parcelRequire("inBkn")));
Object.keys($80d18c8911cf744f$var$_tablePaginationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80d18c8911cf744f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80d18c8911cf744f$var$_tablePaginationClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80d18c8911cf744f$var$_tablePaginationClasses[key];
        }
    });
});

});
parcelRegister("kBtCg", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $effe3c7e7b91170d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $effe3c7e7b91170d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $effe3c7e7b91170d$var$_react = $effe3c7e7b91170d$require$_interopRequireWildcard((parcelRequire("acw62")));
var $effe3c7e7b91170d$var$React = $effe3c7e7b91170d$var$_react;

var $effe3c7e7b91170d$var$_propTypes = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $effe3c7e7b91170d$var$_clsx = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $effe3c7e7b91170d$var$_integerPropType = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $effe3c7e7b91170d$var$_chainPropTypes = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("abVWF")));

var $effe3c7e7b91170d$var$_composeClasses = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $effe3c7e7b91170d$var$_memoTheme = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $effe3c7e7b91170d$var$_InputBase2 = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("9MvHs")));

var $effe3c7e7b91170d$var$_MenuItem = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $effe3c7e7b91170d$var$_Select = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("dALxx")));

var $effe3c7e7b91170d$var$_TableCell = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("hjoMW")));

var $effe3c7e7b91170d$var$_Toolbar = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("dfjP7")));

var $effe3c7e7b91170d$var$_TablePaginationActions = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("lqVz5")));

var $effe3c7e7b91170d$var$_useId = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $effe3c7e7b91170d$var$_tablePaginationClasses = $effe3c7e7b91170d$require$_interopRequireWildcard((parcelRequire("inBkn")));

var $effe3c7e7b91170d$var$_useSlot = $effe3c7e7b91170d$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_TableCell.default, {
    name: 'MuiTablePagination',
    slot: 'Root'
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_Toolbar.default, {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $aAbgT.styled)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer'
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $aAbgT.styled)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel'
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_Select.default, {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.selectIcon}`]: styles.selectIcon,
            [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${$effe3c7e7b91170d$var$_tablePaginationClasses.default.select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $aAbgT.styled)($effe3c7e7b91170d$var$_MenuItem.default, {
    name: 'MuiTablePagination',
    slot: 'MenuItem'
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $aAbgT.styled)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows'
})((0, $effe3c7e7b91170d$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $effe3c7e7b91170d$var$_composeClasses.default)(slots, $effe3c7e7b91170d$var$_tablePaginationClasses.getTablePaginationUtilityClass, classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $effe3c7e7b91170d$var$React.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = $effe3c7e7b91170d$var$_TablePaginationActions.default, backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = $effe3c7e7b91170d$var$_TableCell.default, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === $effe3c7e7b91170d$var$_TableCell.default || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $effe3c7e7b91170d$var$_useId.default)(selectProps.id);
    const labelId = (0, $effe3c7e7b91170d$var$_useId.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $effe3c7e7b91170d$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('toolbar', {
        className: classes.toolbar,
        elementType: $effe3c7e7b91170d$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('spacer', {
        className: classes.spacer,
        elementType: $effe3c7e7b91170d$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('selectLabel', {
        className: classes.selectLabel,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('select', {
        className: classes.select,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $effe3c7e7b91170d$var$_useSlot.default)('displayedRows', {
        className: classes.displayedRows,
        elementType: $effe3c7e7b91170d$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$_InputBase2.default, {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $effe3c7e7b91170d$var$_clsx.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $effe3c7e7b91170d$var$_clsx.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $effe3c7e7b91170d$var$_clsx.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $effe3c7e7b91170d$var$_react.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
var $effe3c7e7b91170d$var$_default = module.exports.default = $effe3c7e7b91170d$var$TablePagination;

});
parcelRegister("dfjP7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9a4c0d9ab6473dab$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9a4c0d9ab6473dab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9a4c0d9ab6473dab$var$_exportNames = {
    toolbarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a4c0d9ab6473dab$var$_Toolbar.default;
    }
});
Object.defineProperty(module.exports, "toolbarClasses", {
    enumerable: true,
    get: function() {
        return $9a4c0d9ab6473dab$var$_toolbarClasses.default;
    }
});

var $9a4c0d9ab6473dab$var$_Toolbar = $9a4c0d9ab6473dab$require$_interopRequireDefault((parcelRequire("kyRsi")));

var $9a4c0d9ab6473dab$var$_toolbarClasses = $9a4c0d9ab6473dab$require$_interopRequireWildcard((parcelRequire("iaUmy")));
Object.keys($9a4c0d9ab6473dab$var$_toolbarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9a4c0d9ab6473dab$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9a4c0d9ab6473dab$var$_toolbarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9a4c0d9ab6473dab$var$_toolbarClasses[key];
        }
    });
});

});
parcelRegister("kyRsi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ef8072c26f712b4c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ef8072c26f712b4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef8072c26f712b4c$var$React = $ef8072c26f712b4c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ef8072c26f712b4c$var$_propTypes = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ef8072c26f712b4c$var$_clsx = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ef8072c26f712b4c$var$_composeClasses = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $ef8072c26f712b4c$var$_memoTheme = $ef8072c26f712b4c$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $iaUmy = parcelRequire("iaUmy");

var $ayMG0 = parcelRequire("ayMG0");
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $ef8072c26f712b4c$var$_composeClasses.default)(slots, $iaUmy.getToolbarUtilityClass, classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $ef8072c26f712b4c$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $ef8072c26f712b4c$var$React.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, {
        as: component,
        className: (0, $ef8072c26f712b4c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $ef8072c26f712b4c$var$_default = module.exports.default = $ef8072c26f712b4c$var$Toolbar;

});
parcelRegister("iaUmy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d3b4e1a115786e57$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToolbarUtilityClass = $d3b4e1a115786e57$var$getToolbarUtilityClass;

var $d3b4e1a115786e57$var$_generateUtilityClasses = $d3b4e1a115786e57$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d3b4e1a115786e57$var$_generateUtilityClass = $d3b4e1a115786e57$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d3b4e1a115786e57$var$getToolbarUtilityClass(slot) {
    return (0, $d3b4e1a115786e57$var$_generateUtilityClass.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $d3b4e1a115786e57$var$_generateUtilityClasses.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$var$_default = module.exports.default = $d3b4e1a115786e57$var$toolbarClasses;

});



parcelRegister("lqVz5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f9a8adddd853f5c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f9a8adddd853f5c1$var$_TablePaginationActions.default;
    }
});
Object.defineProperty(module.exports, "tablePaginationActionsClasses", {
    enumerable: true,
    get: function() {
        return $f9a8adddd853f5c1$var$_tablePaginationActionsClasses.default;
    }
});

var $f9a8adddd853f5c1$var$_TablePaginationActions = $f9a8adddd853f5c1$require$_interopRequireDefault((parcelRequire("2uoZG")));

var $f9a8adddd853f5c1$var$_tablePaginationActionsClasses = $f9a8adddd853f5c1$require$_interopRequireDefault((parcelRequire("2u1Xb")));

});
parcelRegister("2uoZG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1d01c561014f714c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1d01c561014f714c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d01c561014f714c$var$React = $1d01c561014f714c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1d01c561014f714c$var$_propTypes = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9uEev = parcelRequire("9uEev");

var $1d01c561014f714c$var$_composeClasses = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1d01c561014f714c$var$_clsx = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $1d01c561014f714c$var$_KeyboardArrowLeft = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("frMNQ")));

var $1d01c561014f714c$var$_KeyboardArrowRight = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("f46un")));

var $1d01c561014f714c$var$_IconButton = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("825Zh")));

var $1d01c561014f714c$var$_LastPage = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("5izos")));

var $1d01c561014f714c$var$_FirstPage = $1d01c561014f714c$require$_interopRequireDefault((parcelRequire("21SL6")));

var $2u1Xb = parcelRequire("2u1Xb");

var $ayMG0 = parcelRequire("ayMG0");
const $1d01c561014f714c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1d01c561014f714c$var$_composeClasses.default)(slots, $2u1Xb.getTablePaginationActionsUtilityClass, classes);
};
const $1d01c561014f714c$var$TablePaginationActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiTablePaginationActions',
    slot: 'Root'
})({});
const $1d01c561014f714c$var$TablePaginationActions = /*#__PURE__*/ $1d01c561014f714c$var$React.forwardRef(function TablePaginationActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePaginationActions'
    });
    const { backIconButtonProps: backIconButtonProps, className: className, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = props;
    const classes = $1d01c561014f714c$var$useUtilityClasses(ownerState);
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? $1d01c561014f714c$var$_IconButton.default;
    const LastButton = slots.lastButton ?? $1d01c561014f714c$var$_IconButton.default;
    const NextButton = slots.nextButton ?? $1d01c561014f714c$var$_IconButton.default;
    const PreviousButton = slots.previousButton ?? $1d01c561014f714c$var$_IconButton.default;
    const FirstButtonIcon = slots.firstButtonIcon ?? $1d01c561014f714c$var$_FirstPage.default;
    const LastButtonIcon = slots.lastButtonIcon ?? $1d01c561014f714c$var$_LastPage.default;
    const NextButtonIcon = slots.nextButtonIcon ?? $1d01c561014f714c$var$_KeyboardArrowRight.default;
    const PreviousButtonIcon = slots.previousButtonIcon ?? $1d01c561014f714c$var$_KeyboardArrowLeft.default;
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1d01c561014f714c$var$TablePaginationActionsRoot, {
        ref: ref,
        className: (0, $1d01c561014f714c$var$_clsx.default)(classes.root, className),
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
var $1d01c561014f714c$var$_default = module.exports.default = $1d01c561014f714c$var$TablePaginationActions;

});
parcelRegister("frMNQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b3ef3be5c947a70a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3ef3be5c947a70a$var$_createSvgIcon = $b3ef3be5c947a70a$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $b3ef3be5c947a70a$var$_default = module.exports.default = (0, $b3ef3be5c947a70a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("f46un", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $02d495bb1a743bb2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d495bb1a743bb2$var$_createSvgIcon = $02d495bb1a743bb2$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $02d495bb1a743bb2$var$_default = module.exports.default = (0, $02d495bb1a743bb2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("5izos", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3dba169293b5f5f0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3dba169293b5f5f0$var$_createSvgIcon = $3dba169293b5f5f0$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $3dba169293b5f5f0$var$_default = module.exports.default = (0, $3dba169293b5f5f0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

});

parcelRegister("21SL6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $17a626ba35acf52f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17a626ba35acf52f$var$_createSvgIcon = $17a626ba35acf52f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $17a626ba35acf52f$var$_default = module.exports.default = (0, $17a626ba35acf52f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

});

parcelRegister("2u1Xb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1cefe60f2b4973e8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTablePaginationActionsUtilityClass = $1cefe60f2b4973e8$var$getTablePaginationActionsUtilityClass;

var $1cefe60f2b4973e8$var$_generateUtilityClasses = $1cefe60f2b4973e8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1cefe60f2b4973e8$var$_generateUtilityClass = $1cefe60f2b4973e8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1cefe60f2b4973e8$var$getTablePaginationActionsUtilityClass(slot) {
    return (0, $1cefe60f2b4973e8$var$_generateUtilityClass.default)('MuiTablePaginationActions', slot);
}
const $1cefe60f2b4973e8$var$tablePaginationActionsClasses = (0, $1cefe60f2b4973e8$var$_generateUtilityClasses.default)('MuiTablePaginationActions', [
    'root'
]);
var $1cefe60f2b4973e8$var$_default = module.exports.default = $1cefe60f2b4973e8$var$tablePaginationActionsClasses;

});



parcelRegister("inBkn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d6175477fd255470$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTablePaginationUtilityClass = $d6175477fd255470$var$getTablePaginationUtilityClass;

var $d6175477fd255470$var$_generateUtilityClasses = $d6175477fd255470$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d6175477fd255470$var$_generateUtilityClass = $d6175477fd255470$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d6175477fd255470$var$getTablePaginationUtilityClass(slot) {
    return (0, $d6175477fd255470$var$_generateUtilityClass.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $d6175477fd255470$var$_generateUtilityClasses.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$var$_default = module.exports.default = $d6175477fd255470$var$tablePaginationClasses;

});



parcelRegister("7Ke9B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $kGwBF.ClickAwayListener;
    }
});

var $kGwBF = parcelRequire("kGwBF");

});
parcelRegister("kGwBF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f0f105dbd8c07c9e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f0f105dbd8c07c9e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClickAwayListener = $f0f105dbd8c07c9e$var$ClickAwayListener;

var $f0f105dbd8c07c9e$var$React = $f0f105dbd8c07c9e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f0f105dbd8c07c9e$var$_propTypes = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f0f105dbd8c07c9e$var$_ownerDocument = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("43fuO")));

var $f0f105dbd8c07c9e$var$_useForkRef = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $f0f105dbd8c07c9e$var$_useEventCallback = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $f0f105dbd8c07c9e$var$_elementAcceptingRef = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("igTUE")));

var $f0f105dbd8c07c9e$var$_exactProp = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $f0f105dbd8c07c9e$var$_getReactElementRef = $f0f105dbd8c07c9e$require$_interopRequireDefault((parcelRequire("2B4J6")));
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$var$ClickAwayListener(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $f0f105dbd8c07c9e$var$React.useRef(false);
    const nodeRef = $f0f105dbd8c07c9e$var$React.useRef(null);
    const activatedRef = $f0f105dbd8c07c9e$var$React.useRef(false);
    const syntheticEventRef = $f0f105dbd8c07c9e$var$React.useRef(false);
    $f0f105dbd8c07c9e$var$React.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $f0f105dbd8c07c9e$var$_useForkRef.default)((0, $f0f105dbd8c07c9e$var$_getReactElementRef.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $f0f105dbd8c07c9e$var$_useEventCallback.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $f0f105dbd8c07c9e$var$_ownerDocument.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $f0f105dbd8c07c9e$var$React.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $f0f105dbd8c07c9e$var$_ownerDocument.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $f0f105dbd8c07c9e$var$React.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $f0f105dbd8c07c9e$var$_ownerDocument.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $f0f105dbd8c07c9e$var$React.cloneElement(children, childrenProps);
}

});


parcelRegister("eTbCT", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ad6f387c32d3bcf0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ad6f387c32d3bcf0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ad6f387c32d3bcf0$var$_exportNames = {
    skeletonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ad6f387c32d3bcf0$var$_Skeleton.default;
    }
});
Object.defineProperty(module.exports, "skeletonClasses", {
    enumerable: true,
    get: function() {
        return $ad6f387c32d3bcf0$var$_skeletonClasses.default;
    }
});

var $ad6f387c32d3bcf0$var$_Skeleton = $ad6f387c32d3bcf0$require$_interopRequireDefault((parcelRequire("5RIww")));

var $ad6f387c32d3bcf0$var$_skeletonClasses = $ad6f387c32d3bcf0$require$_interopRequireWildcard((parcelRequire("bWvDT")));
Object.keys($ad6f387c32d3bcf0$var$_skeletonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ad6f387c32d3bcf0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ad6f387c32d3bcf0$var$_skeletonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ad6f387c32d3bcf0$var$_skeletonClasses[key];
        }
    });
});

});
parcelRegister("5RIww", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $445470756a9ff70a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $445470756a9ff70a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $445470756a9ff70a$var$React = $445470756a9ff70a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $445470756a9ff70a$var$_clsx = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $445470756a9ff70a$var$_propTypes = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $445470756a9ff70a$var$_composeClasses = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $aAbgT = parcelRequire("aAbgT");

var $445470756a9ff70a$var$_memoTheme = $445470756a9ff70a$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $bWvDT = parcelRequire("bWvDT");

var $ayMG0 = parcelRequire("ayMG0");
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $445470756a9ff70a$var$_composeClasses.default)(slots, $bWvDT.getSkeletonUtilityClass, classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $aAbgT.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $445470756a9ff70a$var$waveKeyframe = (0, $aAbgT.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $445470756a9ff70a$var$pulseAnimation = typeof $445470756a9ff70a$var$pulseKeyframe !== 'string' ? (0, $aAbgT.css)`
        animation: ${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $445470756a9ff70a$var$waveAnimation = typeof $445470756a9ff70a$var$waveKeyframe !== 'string' ? (0, $aAbgT.css)`
        &::after {
          animation: ${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $445470756a9ff70a$var$SkeletonRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $445470756a9ff70a$var$_memoTheme.default)(({ theme: theme })=>{
    const radiusUnit = (0, $8xDHs.unstable_getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $8xDHs.unstable_toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $445470756a9ff70a$var$pulseAnimation || {
                    animation: `${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $445470756a9ff70a$var$waveAnimation || {
                    '&::after': {
                        animation: `${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $445470756a9ff70a$var$React.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $445470756a9ff70a$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $445470756a9ff70a$var$_default = module.exports.default = $445470756a9ff70a$var$Skeleton;

});
parcelRegister("bWvDT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8b1da808c4852549$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSkeletonUtilityClass = $8b1da808c4852549$var$getSkeletonUtilityClass;

var $8b1da808c4852549$var$_generateUtilityClasses = $8b1da808c4852549$require$_interopRequireDefault((parcelRequire("5nY49")));

var $8b1da808c4852549$var$_generateUtilityClass = $8b1da808c4852549$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $8b1da808c4852549$var$getSkeletonUtilityClass(slot) {
    return (0, $8b1da808c4852549$var$_generateUtilityClass.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $8b1da808c4852549$var$_generateUtilityClasses.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$var$_default = module.exports.default = $8b1da808c4852549$var$skeletonClasses;

});



parcelRegister("dKcJh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a019720230600cef$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a019720230600cef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a019720230600cef$var$_exportNames = {
    tabsClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a019720230600cef$var$_Tabs.default;
    }
});
Object.defineProperty(module.exports, "tabsClasses", {
    enumerable: true,
    get: function() {
        return $a019720230600cef$var$_tabsClasses.default;
    }
});

var $a019720230600cef$var$_Tabs = $a019720230600cef$require$_interopRequireDefault((parcelRequire("aDtBU")));

var $a019720230600cef$var$_tabsClasses = $a019720230600cef$require$_interopRequireWildcard((parcelRequire("bTm2Q")));
Object.keys($a019720230600cef$var$_tabsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a019720230600cef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a019720230600cef$var$_tabsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a019720230600cef$var$_tabsClasses[key];
        }
    });
});

});
parcelRegister("aDtBU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7be483edbed3b474$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7be483edbed3b474$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7be483edbed3b474$var$React = $7be483edbed3b474$require$_interopRequireWildcard((parcelRequire("acw62")));


var $7be483edbed3b474$var$_propTypes = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7be483edbed3b474$var$_clsx = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7be483edbed3b474$var$_refType = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $7be483edbed3b474$var$_composeClasses = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $7be483edbed3b474$var$_useSlotProps = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("839K0")));

var $aAbgT = parcelRequire("aAbgT");

var $7be483edbed3b474$var$_memoTheme = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $7be483edbed3b474$var$_debounce = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $7be483edbed3b474$var$_animate = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("kRsYK")));

var $7be483edbed3b474$var$_ScrollbarSize = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("l0ZbI")));

var $7be483edbed3b474$var$_TabScrollButton = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("b1hEL")));

var $7be483edbed3b474$var$_useEventCallback = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $7be483edbed3b474$var$_tabsClasses = $7be483edbed3b474$require$_interopRequireWildcard((parcelRequire("bTm2Q")));

var $7be483edbed3b474$var$_ownerDocument = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $7be483edbed3b474$var$_ownerWindow = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $7be483edbed3b474$var$_getActiveElement = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("6uU67")));

var $7be483edbed3b474$var$_isLayoutSupported = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("6toKj")));

var $7be483edbed3b474$var$_useSlot = $7be483edbed3b474$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $7be483edbed3b474$var$_composeClasses.default)(slots, $7be483edbed3b474$var$_tabsClasses.getTabsUtilityClass, classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$7be483edbed3b474$var$_tabsClasses.default.scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${$7be483edbed3b474$var$_tabsClasses.default.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $7be483edbed3b474$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${$7be483edbed3b474$var$_tabsClasses.default.scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScroller = (0, $aAbgT.styled)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $7be483edbed3b474$var$List = (0, $aAbgT.styled)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $7be483edbed3b474$var$TabsIndicator = (0, $aAbgT.styled)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $7be483edbed3b474$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $aAbgT.styled)($7be483edbed3b474$var$_ScrollbarSize.default)({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $7be483edbed3b474$var$React.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $aAbgT.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $7be483edbed3b474$var$_useSlotProps.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $7be483edbed3b474$var$_useSlotProps.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $7be483edbed3b474$var$React.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $7be483edbed3b474$var$React.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $7be483edbed3b474$var$React.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $7be483edbed3b474$var$React.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $7be483edbed3b474$var$React.useState(false);
    const [scrollerStyle, setScrollerStyle] = $7be483edbed3b474$var$React.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $7be483edbed3b474$var$React.useRef(null);
    const tabListRef = $7be483edbed3b474$var$React.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButtons: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $7be483edbed3b474$var$_useEventCallback.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $7be483edbed3b474$var$_animate.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $7be483edbed3b474$var$_useSlot.default)('scrollbar', {
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $7be483edbed3b474$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $7be483edbed3b474$var$React.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('scrollButtons', {
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: $7be483edbed3b474$var$_TabScrollButton.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $7be483edbed3b474$var$_useEventCallback.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $7be483edbed3b474$var$_useEventCallback.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $7be483edbed3b474$var$React.useEffect(()=>{
        const handleResize = (0, $7be483edbed3b474$var$_debounce.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $7be483edbed3b474$var$_ownerWindow.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $7be483edbed3b474$var$React.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $7be483edbed3b474$var$React.useEffect(()=>{
        setMounted(true);
    }, []);
    $7be483edbed3b474$var$React.useEffect(()=>{
        updateIndicatorState();
    });
    $7be483edbed3b474$var$React.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $7be483edbed3b474$var$React.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('indicator', {
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $7be483edbed3b474$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $7be483edbed3b474$var$React.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $7be483edbed3b474$var$React.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $7be483edbed3b474$var$React.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $7be483edbed3b474$var$_getActiveElement.default)((0, $7be483edbed3b474$var$_ownerDocument.default)(list));
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus?.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('root', {
        ref: ref,
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.root, className),
        elementType: $7be483edbed3b474$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $7be483edbed3b474$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $7be483edbed3b474$var$_useSlot.default)('list', {
        ref: tabListRef,
        className: (0, $7be483edbed3b474$var$_clsx.default)(classes.list, classes.flexContainer),
        elementType: $7be483edbed3b474$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $7be483edbed3b474$var$_default = module.exports.default = $7be483edbed3b474$var$Tabs;

});
parcelRegister("kRsYK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2ff3c73ed46b37c$var$animate;
function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$var$animate(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("l0ZbI", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f4c90fbbf54d23af$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f4c90fbbf54d23af$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4c90fbbf54d23af$var$ScrollbarSize;

var $f4c90fbbf54d23af$var$React = $f4c90fbbf54d23af$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f4c90fbbf54d23af$var$_propTypes = $f4c90fbbf54d23af$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f4c90fbbf54d23af$var$_debounce = $f4c90fbbf54d23af$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */ function $f4c90fbbf54d23af$var$ScrollbarSize(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $f4c90fbbf54d23af$var$React.useRef();
    const nodeRef = $f4c90fbbf54d23af$var$React.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $hGPki.unstable_useEnhancedEffect)(()=>{
        const handleResize = (0, $f4c90fbbf54d23af$var$_debounce.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $hGPki.ownerWindow)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $f4c90fbbf54d23af$var$React.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $f4c90fbbf54d23af$var$styles,
        ...other,
        ref: nodeRef
    });
}

});

parcelRegister("b1hEL", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $805d7bedd393d559$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $805d7bedd393d559$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $805d7bedd393d559$var$_exportNames = {
    tabScrollButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $805d7bedd393d559$var$_TabScrollButton.default;
    }
});
Object.defineProperty(module.exports, "tabScrollButtonClasses", {
    enumerable: true,
    get: function() {
        return $805d7bedd393d559$var$_tabScrollButtonClasses.default;
    }
});

var $805d7bedd393d559$var$_TabScrollButton = $805d7bedd393d559$require$_interopRequireDefault((parcelRequire("dz5QO")));

var $805d7bedd393d559$var$_tabScrollButtonClasses = $805d7bedd393d559$require$_interopRequireWildcard((parcelRequire("4CguH")));
Object.keys($805d7bedd393d559$var$_tabScrollButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($805d7bedd393d559$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $805d7bedd393d559$var$_tabScrollButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $805d7bedd393d559$var$_tabScrollButtonClasses[key];
        }
    });
});

});
parcelRegister("dz5QO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9e031514df70ea8e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9e031514df70ea8e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e031514df70ea8e$var$React = $9e031514df70ea8e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9e031514df70ea8e$var$_propTypes = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9e031514df70ea8e$var$_clsx = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9e031514df70ea8e$var$_composeClasses = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $9e031514df70ea8e$var$_useSlotProps = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("839K0")));

var $9e031514df70ea8e$var$_KeyboardArrowLeft = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("frMNQ")));

var $9e031514df70ea8e$var$_KeyboardArrowRight = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("f46un")));

var $9e031514df70ea8e$var$_ButtonBase = $9e031514df70ea8e$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $9e031514df70ea8e$var$_tabScrollButtonClasses = $9e031514df70ea8e$require$_interopRequireWildcard((parcelRequire("4CguH")));

var $ayMG0 = parcelRequire("ayMG0");
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $9e031514df70ea8e$var$_composeClasses.default)(slots, $9e031514df70ea8e$var$_tabScrollButtonClasses.getTabScrollButtonUtilityClass, classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $aAbgT.styled)($9e031514df70ea8e$var$_ButtonBase.default, {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${$9e031514df70ea8e$var$_tabScrollButtonClasses.default.disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $9e031514df70ea8e$var$React.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? $9e031514df70ea8e$var$_KeyboardArrowLeft.default;
    const EndButtonIcon = slots.EndScrollButtonIcon ?? $9e031514df70ea8e$var$_KeyboardArrowRight.default;
    const startButtonIconProps = (0, $9e031514df70ea8e$var$_useSlotProps.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $9e031514df70ea8e$var$_useSlotProps.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $9e031514df70ea8e$var$_clsx.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $9e031514df70ea8e$var$_default = module.exports.default = $9e031514df70ea8e$var$TabScrollButton;

});
parcelRegister("4CguH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $35c7816ebadb07c9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTabScrollButtonUtilityClass = $35c7816ebadb07c9$var$getTabScrollButtonUtilityClass;

var $35c7816ebadb07c9$var$_generateUtilityClasses = $35c7816ebadb07c9$require$_interopRequireDefault((parcelRequire("5nY49")));

var $35c7816ebadb07c9$var$_generateUtilityClass = $35c7816ebadb07c9$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $35c7816ebadb07c9$var$getTabScrollButtonUtilityClass(slot) {
    return (0, $35c7816ebadb07c9$var$_generateUtilityClass.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $35c7816ebadb07c9$var$_generateUtilityClasses.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$var$_default = module.exports.default = $35c7816ebadb07c9$var$tabScrollButtonClasses;

});



parcelRegister("bTm2Q", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8a85ee70c626268d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTabsUtilityClass = $8a85ee70c626268d$var$getTabsUtilityClass;

var $8a85ee70c626268d$var$_generateUtilityClasses = $8a85ee70c626268d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $8a85ee70c626268d$var$_generateUtilityClass = $8a85ee70c626268d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $8a85ee70c626268d$var$getTabsUtilityClass(slot) {
    return (0, $8a85ee70c626268d$var$_generateUtilityClass.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $8a85ee70c626268d$var$_generateUtilityClasses.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$var$_default = module.exports.default = $8a85ee70c626268d$var$tabsClasses;

});



parcelRegister("90blG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68dceac9a9a56312$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $68dceac9a9a56312$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68dceac9a9a56312$var$_exportNames = {
    tabClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68dceac9a9a56312$var$_Tab.default;
    }
});
Object.defineProperty(module.exports, "tabClasses", {
    enumerable: true,
    get: function() {
        return $68dceac9a9a56312$var$_tabClasses.default;
    }
});

var $68dceac9a9a56312$var$_Tab = $68dceac9a9a56312$require$_interopRequireDefault((parcelRequire("jNGAr")));

var $68dceac9a9a56312$var$_tabClasses = $68dceac9a9a56312$require$_interopRequireWildcard((parcelRequire("jHfLJ")));
Object.keys($68dceac9a9a56312$var$_tabClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68dceac9a9a56312$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68dceac9a9a56312$var$_tabClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68dceac9a9a56312$var$_tabClasses[key];
        }
    });
});

});
parcelRegister("jNGAr", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e6a3a0c577f6eee9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e6a3a0c577f6eee9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6a3a0c577f6eee9$var$React = $e6a3a0c577f6eee9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e6a3a0c577f6eee9$var$_propTypes = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e6a3a0c577f6eee9$var$_clsx = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e6a3a0c577f6eee9$var$_composeClasses = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $e6a3a0c577f6eee9$var$_ButtonBase = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $e6a3a0c577f6eee9$var$_capitalize = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $e6a3a0c577f6eee9$var$_memoTheme = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $e6a3a0c577f6eee9$var$_unsupportedProp = $e6a3a0c577f6eee9$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $e6a3a0c577f6eee9$var$_tabClasses = $e6a3a0c577f6eee9$require$_interopRequireWildcard((parcelRequire("jHfLJ")));

var $ayMG0 = parcelRequire("ayMG0");
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $e6a3a0c577f6eee9$var$_capitalize.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $e6a3a0c577f6eee9$var$_composeClasses.default)(slots, $e6a3a0c577f6eee9$var$_tabClasses.getTabUtilityClass, classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $aAbgT.styled)($e6a3a0c577f6eee9$var$_ButtonBase.default, {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $e6a3a0c577f6eee9$var$_capitalize.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${$e6a3a0c577f6eee9$var$_tabClasses.default.iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: styles.icon
            }
        ];
    }
})((0, $e6a3a0c577f6eee9$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${$e6a3a0c577f6eee9$var$_tabClasses.default.icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.selected}`]: {
                        opacity: 1
                    },
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${$e6a3a0c577f6eee9$var$_tabClasses.default.disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $e6a3a0c577f6eee9$var$React.forwardRef(function Tab(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $e6a3a0c577f6eee9$var$React.isValidElement(iconProp) ? /*#__PURE__*/ $e6a3a0c577f6eee9$var$React.cloneElement(iconProp, {
        className: (0, $e6a3a0c577f6eee9$var$_clsx.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $e6a3a0c577f6eee9$var$_clsx.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$React.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$React.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $e6a3a0c577f6eee9$var$_default = module.exports.default = $e6a3a0c577f6eee9$var$Tab;

});
parcelRegister("jHfLJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e56e43dd06ac0faa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTabUtilityClass = $e56e43dd06ac0faa$var$getTabUtilityClass;

var $e56e43dd06ac0faa$var$_generateUtilityClasses = $e56e43dd06ac0faa$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e56e43dd06ac0faa$var$_generateUtilityClass = $e56e43dd06ac0faa$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e56e43dd06ac0faa$var$getTabUtilityClass(slot) {
    return (0, $e56e43dd06ac0faa$var$_generateUtilityClass.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $e56e43dd06ac0faa$var$_generateUtilityClasses.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $e56e43dd06ac0faa$var$_default = module.exports.default = $e56e43dd06ac0faa$var$tabClasses;

});



parcelRegister("xwCPt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $064c63e1ed87913a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $064c63e1ed87913a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $064c63e1ed87913a$var$_exportNames = {
    toggleButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $064c63e1ed87913a$var$_ToggleButton.default;
    }
});
Object.defineProperty(module.exports, "toggleButtonClasses", {
    enumerable: true,
    get: function() {
        return $064c63e1ed87913a$var$_toggleButtonClasses.default;
    }
});

var $064c63e1ed87913a$var$_ToggleButton = $064c63e1ed87913a$require$_interopRequireDefault((parcelRequire("eJ0JC")));

var $064c63e1ed87913a$var$_toggleButtonClasses = $064c63e1ed87913a$require$_interopRequireWildcard((parcelRequire("3cuAs")));
Object.keys($064c63e1ed87913a$var$_toggleButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($064c63e1ed87913a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $064c63e1ed87913a$var$_toggleButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $064c63e1ed87913a$var$_toggleButtonClasses[key];
        }
    });
});

});
parcelRegister("eJ0JC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ab85d69438d76ec5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ab85d69438d76ec5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab85d69438d76ec5$var$React = $ab85d69438d76ec5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ab85d69438d76ec5$var$_propTypes = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ab85d69438d76ec5$var$_clsx = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ab85d69438d76ec5$var$_resolveProps = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ab85d69438d76ec5$var$_composeClasses = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ab85d69438d76ec5$var$_ButtonBase = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $ab85d69438d76ec5$var$_capitalize = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $ab85d69438d76ec5$var$_memoTheme = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ab85d69438d76ec5$var$_createSimplePaletteValueFilter = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $ab85d69438d76ec5$var$_toggleButtonClasses = $ab85d69438d76ec5$require$_interopRequireWildcard((parcelRequire("3cuAs")));

var $ab85d69438d76ec5$var$_ToggleButtonGroupContext = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("lOkLt")));

var $ab85d69438d76ec5$var$_ToggleButtonGroupButtonContext = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("jCUp4")));

var $ab85d69438d76ec5$var$_isValueSelected = $ab85d69438d76ec5$require$_interopRequireDefault((parcelRequire("d0d3x")));

var $ayMG0 = parcelRequire("ayMG0");
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $ab85d69438d76ec5$var$_capitalize.default)(size)}`,
            color
        ]
    };
    return (0, $ab85d69438d76ec5$var$_composeClasses.default)(slots, $ab85d69438d76ec5$var$_toggleButtonClasses.getToggleButtonUtilityClass, classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $aAbgT.styled)($ab85d69438d76ec5$var$_ButtonBase.default, {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $ab85d69438d76ec5$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $ab85d69438d76ec5$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${$ab85d69438d76ec5$var$_toggleButtonClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${$ab85d69438d76ec5$var$_toggleButtonClasses.default.selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $ab85d69438d76ec5$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$ab85d69438d76ec5$var$_toggleButtonClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $ab85d69438d76ec5$var$React.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $ab85d69438d76ec5$var$React.useContext($ab85d69438d76ec5$var$_ToggleButtonGroupContext.default);
    const toggleButtonGroupButtonContextPositionClassName = $ab85d69438d76ec5$var$React.useContext($ab85d69438d76ec5$var$_ToggleButtonGroupButtonContext.default);
    const resolvedProps = (0, $ab85d69438d76ec5$var$_resolveProps.default)({
        ...contextProps,
        selected: (0, $ab85d69438d76ec5$var$_isValueSelected.default)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $hL1nr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, {
        className: (0, $ab85d69438d76ec5$var$_clsx.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var $ab85d69438d76ec5$var$_default = module.exports.default = $ab85d69438d76ec5$var$ToggleButton;

});
parcelRegister("3cuAs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $254a3802f36599bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToggleButtonUtilityClass = $254a3802f36599bb$var$getToggleButtonUtilityClass;

var $254a3802f36599bb$var$_generateUtilityClasses = $254a3802f36599bb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $254a3802f36599bb$var$_generateUtilityClass = $254a3802f36599bb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $254a3802f36599bb$var$getToggleButtonUtilityClass(slot) {
    return (0, $254a3802f36599bb$var$_generateUtilityClass.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $254a3802f36599bb$var$_generateUtilityClasses.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$var$_default = module.exports.default = $254a3802f36599bb$var$toggleButtonClasses;

});

parcelRegister("lOkLt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fe0e5fe90030f3ad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe0e5fe90030f3ad$var$React = $fe0e5fe90030f3ad$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $fe0e5fe90030f3ad$var$React.createContext({});
var $fe0e5fe90030f3ad$var$_default = module.exports.default = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;

});

parcelRegister("jCUp4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e49d517bbbfb7eee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49d517bbbfb7eee$var$React = $e49d517bbbfb7eee$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $e49d517bbbfb7eee$var$React.createContext(undefined);
var $e49d517bbbfb7eee$var$_default = module.exports.default = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;

});

parcelRegister("d0d3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9775671ab3ebd2db$var$isValueSelected;
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$var$isValueSelected(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}

});



parcelRegister("i9HdC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d37a9791700d8c9e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d37a9791700d8c9e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridColumnUnsortedIcon = void 0;

var $d37a9791700d8c9e$var$_extends2 = $d37a9791700d8c9e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d37a9791700d8c9e$var$_objectWithoutPropertiesLoose2 = $d37a9791700d8c9e$require$_interopRequireDefault((parcelRequire("c05no")));

var $d37a9791700d8c9e$var$React = $d37a9791700d8c9e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jDpXp = parcelRequire("jDpXp");

var $ayMG0 = parcelRequire("ayMG0");
const $d37a9791700d8c9e$var$_excluded = [
    "sortingOrder"
];
const $d37a9791700d8c9e$var$GridColumnUnsortedIcon = module.exports.GridColumnUnsortedIcon = /*#__PURE__*/ $d37a9791700d8c9e$var$React.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $d37a9791700d8c9e$var$_objectWithoutPropertiesLoose2.default)(props, $d37a9791700d8c9e$var$_excluded);
    const rootProps = (0, $jDpXp.useGridRootProps)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, (0, $d37a9791700d8c9e$var$_extends2.default)({}, other)) : null;
});

});

parcelRegister("5LM2M", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $43369c0a919be7e4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMaterialCSSVariables = $43369c0a919be7e4$var$useMaterialCSSVariables;

var $43369c0a919be7e4$var$React = $43369c0a919be7e4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $7OhqI = parcelRequire("7OhqI");

var $hbuUJ = parcelRequire("hbuUJ");

var $aOz2q = parcelRequire("aOz2q");
function $43369c0a919be7e4$var$useMaterialCSSVariables() {
    const theme = (0, $8xDHs.useTheme)();
    return $43369c0a919be7e4$var$React.useMemo(()=>{
        const id = (0, $7OhqI.hash)($43369c0a919be7e4$var$stringifyTheme(theme));
        const variables = $43369c0a919be7e4$var$transformTheme(theme);
        return {
            id: id,
            variables: variables
        };
    }, [
        theme
    ]);
}
function $43369c0a919be7e4$var$transformTheme(t) {
    const borderColor = $43369c0a919be7e4$var$getBorderColor(t);
    const dataGridPalette = (t.vars || t).palette.DataGrid;
    const paperColor = (t.vars || t).palette.background.paper;
    const backgroundBase = dataGridPalette?.bg ?? (t.palette.mode === 'dark' ? (0, $aOz2q.colorMixIfSupported)(`color-mix(in srgb, ${paperColor} 95%, #fff)`, paperColor) : paperColor);
    const backgroundHeader = dataGridPalette?.headerBg ?? backgroundBase;
    const backgroundPinned = dataGridPalette?.pinnedBg ?? backgroundBase;
    const backgroundBackdrop = t.vars ? `rgba(${t.vars.palette.background.defaultChannel} / ${t.vars.palette.action.disabledOpacity})` : (0, $8xDHs.alpha)(t.palette.background.default, t.palette.action.disabledOpacity);
    const backgroundOverlay = t.palette.mode === 'dark' ? (0, $aOz2q.colorMixIfSupported)(`color-mix(in srgb, ${paperColor} 90%, #fff)`, paperColor) : paperColor;
    const selectedColor = t.vars ? `rgb(${t.vars.palette.primary.mainChannel})` : t.palette.primary.main;
    const radius = $43369c0a919be7e4$var$getRadius(t);
    const fontBody = t.vars?.font?.body2 ?? $43369c0a919be7e4$var$formatFont(t.typography.body2);
    const fontSmall = t.vars?.font?.caption ?? $43369c0a919be7e4$var$formatFont(t.typography.caption);
    const fontLarge = t.vars?.font?.body1 ?? $43369c0a919be7e4$var$formatFont(t.typography.body1);
    const k = $hbuUJ.vars.keys;
    return {
        [k.spacingUnit]: t.vars ? t.vars.spacing ?? t.spacing(1) : t.spacing(1),
        [k.colors.border.base]: borderColor,
        [k.colors.background.base]: backgroundBase,
        [k.colors.background.overlay]: backgroundOverlay,
        [k.colors.background.backdrop]: backgroundBackdrop,
        [k.colors.foreground.base]: (t.vars || t).palette.text.primary,
        [k.colors.foreground.muted]: (t.vars || t).palette.text.secondary,
        [k.colors.foreground.accent]: (t.vars || t).palette.primary.dark,
        [k.colors.foreground.disabled]: (t.vars || t).palette.text.disabled,
        [k.colors.foreground.error]: (t.vars || t).palette.error.dark,
        [k.colors.interactive.hover]: $aOz2q.supportsColorMix ? (t.vars || t).palette.action.hover : (t.vars || t).palette.grey[t.palette.mode === 'dark' ? 800 : 100],
        [k.colors.interactive.hoverOpacity]: (t.vars || t).palette.action.hoverOpacity,
        [k.colors.interactive.focus]: $43369c0a919be7e4$var$removeOpacity((t.vars || t).palette.primary.main),
        [k.colors.interactive.focusOpacity]: (t.vars || t).palette.action.focusOpacity,
        [k.colors.interactive.disabled]: $43369c0a919be7e4$var$removeOpacity((t.vars || t).palette.action.disabled),
        [k.colors.interactive.disabledOpacity]: (t.vars || t).palette.action.disabledOpacity,
        [k.colors.interactive.selected]: $aOz2q.supportsColorMix ? selectedColor : (t.vars || t).palette.grey[t.palette.mode === 'dark' ? 700 : 200],
        [k.colors.interactive.selectedOpacity]: (t.vars || t).palette.action.selectedOpacity,
        [k.header.background.base]: backgroundHeader,
        [k.cell.background.pinned]: backgroundPinned,
        [k.radius.base]: radius,
        [k.typography.fontFamily.base]: t.typography.fontFamily,
        [k.typography.fontWeight.light]: t.typography.fontWeightLight,
        [k.typography.fontWeight.regular]: t.typography.fontWeightRegular,
        [k.typography.fontWeight.medium]: t.typography.fontWeightMedium,
        [k.typography.fontWeight.bold]: t.typography.fontWeightBold,
        [k.typography.font.body]: fontBody,
        [k.typography.font.small]: fontSmall,
        [k.typography.font.large]: fontLarge,
        [k.transitions.easing.easeIn]: t.transitions.easing.easeIn,
        [k.transitions.easing.easeOut]: t.transitions.easing.easeOut,
        [k.transitions.easing.easeInOut]: t.transitions.easing.easeInOut,
        [k.transitions.duration.short]: `${t.transitions.duration.shorter}ms`,
        [k.transitions.duration.base]: `${t.transitions.duration.short}ms`,
        [k.transitions.duration.long]: `${t.transitions.duration.standard}ms`,
        [k.shadows.base]: (t.vars || t).shadows[2],
        [k.shadows.overlay]: (t.vars || t).shadows[8],
        [k.zIndex.panel]: (t.vars || t).zIndex.modal,
        [k.zIndex.menu]: (t.vars || t).zIndex.modal
    };
}
function $43369c0a919be7e4$var$getRadius(theme) {
    if (theme.vars) return theme.vars.shape.borderRadius;
    return typeof theme.shape.borderRadius === 'number' ? `${theme.shape.borderRadius}px` : theme.shape.borderRadius;
}
function $43369c0a919be7e4$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $8xDHs.lighten)((0, $8xDHs.alpha)(theme.palette.divider, 1), 0.88);
    return (0, $8xDHs.darken)((0, $8xDHs.alpha)(theme.palette.divider, 1), 0.68);
}
function $43369c0a919be7e4$var$setOpacity(color, opacity) {
    return `rgba(from ${color} r g b / ${opacity})`;
}
function $43369c0a919be7e4$var$removeOpacity(color) {
    return $43369c0a919be7e4$var$setOpacity(color, 1);
}
function $43369c0a919be7e4$var$formatFont(font) {
    // Accounts for disabled typography variants
    // See: https://github.com/mui/mui-x/issues/17812
    if (!font) return undefined;
    const fontSize = typeof font.fontSize === 'number' ? `${font.fontSize}px` : font.fontSize;
    return `${font.fontWeight} ${fontSize} / ${font.lineHeight} ${font.fontFamily}`;
}
/**
 * A version of JSON.stringify for theme objects.
 * Fixes: https://github.com/mui/mui-x/issues/17521
 * Source: https://www.30secondsofcode.org/js/s/stringify-circular-json/
 */ function $43369c0a919be7e4$var$stringifyTheme(input) {
    const seen = new WeakSet();
    return JSON.stringify(input, (_, v)=>{
        // https://github.com/mui/mui-x/issues/17855
        if (typeof window !== 'undefined' && v === window || typeof document !== 'undefined' && v === document) return v.toString();
        if (v !== null && typeof v === 'object') {
            // Do not attempt to serialize React elements due to performance concerns.
            // Fixes https://github.com/mui/mui-x/issues/19414
            if (/*#__PURE__*/ $43369c0a919be7e4$var$React.isValidElement(v)) return null;
            if (seen.has(v)) return null;
            seen.add(v);
        }
        return v;
    });
}

});
parcelRegister("7OhqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9jdiA = parcelRequire("9jdiA");
Object.keys($9jdiA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9jdiA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9jdiA[key];
        }
    });
});

});
parcelRegister("9jdiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hash = void 0;
const $6c703441990b201b$var$encoder = new TextEncoder();
// bufferLength must be a multiple of 4 to satisfy Int32Array constraints
let $6c703441990b201b$var$bufferLength = 2048;
let $6c703441990b201b$var$buffer = new ArrayBuffer($6c703441990b201b$var$bufferLength);
let $6c703441990b201b$var$uint8View = new Uint8Array($6c703441990b201b$var$buffer);
let $6c703441990b201b$var$int32View = new Int32Array($6c703441990b201b$var$buffer);
const $6c703441990b201b$var$hash = module.exports.hash = $6c703441990b201b$var$xxh;
/**
 * Returns an xxh hash of `input` formatted as a decimal string.
 */ // prettier-ignore
function $6c703441990b201b$var$xxh(input) {
    /* eslint-disable no-bitwise */ // Worst-case scenario: full string of 2-byte characters
    const requiredLength = input.length * 2;
    if (requiredLength > $6c703441990b201b$var$bufferLength) {
        // buffer.resize() is only available in recent browsers, so we re-allocate
        // a new and views
        $6c703441990b201b$var$bufferLength = requiredLength + (4 - requiredLength % 4);
        $6c703441990b201b$var$buffer = new ArrayBuffer($6c703441990b201b$var$bufferLength);
        $6c703441990b201b$var$uint8View = new Uint8Array($6c703441990b201b$var$buffer);
        $6c703441990b201b$var$int32View = new Int32Array($6c703441990b201b$var$buffer);
    }
    const length8 = $6c703441990b201b$var$encoder.encodeInto(input, $6c703441990b201b$var$uint8View).written;
    const seed = 0;
    const len = length8 | 0;
    let i = 0;
    let h = (seed + len | 0) + 0x165667B1 | 0;
    if (len < 16) for(; (i + 3 | 0) < len; i = i + 4 | 0)h = Math.imul($6c703441990b201b$var$rotl32(h + Math.imul($6c703441990b201b$var$int32View[i] | 0, 0xC2B2AE3D) | 0, 17) | 0, 0x27D4EB2F);
    else {
        let v0 = seed + 0x24234428 | 0;
        let v1 = seed + 0x85EBCA77 | 0;
        let v2 = seed;
        let v3 = seed - 0x9E3779B1 | 0;
        for(; (i + 15 | 0) < len; i = i + 16 | 0){
            v0 = Math.imul($6c703441990b201b$var$rotl32(v0 + Math.imul($6c703441990b201b$var$int32View[i + 0 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v1 = Math.imul($6c703441990b201b$var$rotl32(v1 + Math.imul($6c703441990b201b$var$int32View[i + 4 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v2 = Math.imul($6c703441990b201b$var$rotl32(v2 + Math.imul($6c703441990b201b$var$int32View[i + 8 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v3 = Math.imul($6c703441990b201b$var$rotl32(v3 + Math.imul($6c703441990b201b$var$int32View[i + 12 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
        }
        h = ((($6c703441990b201b$var$rotl32(v0, 1) | 0 + $6c703441990b201b$var$rotl32(v1, 7) | 0) + $6c703441990b201b$var$rotl32(v2, 12) | 0) + $6c703441990b201b$var$rotl32(v3, 18) | 0) + len | 0;
        for(; (i + 3 | 0) < len; i = i + 4 | 0)h = Math.imul($6c703441990b201b$var$rotl32(h + Math.imul($6c703441990b201b$var$int32View[i] | 0, 0xC2B2AE3D) | 0, 17) | 0, 0x27D4EB2F);
    }
    for(; i < len; i = i + 1 | 0)h = Math.imul($6c703441990b201b$var$rotl32(h + Math.imul($6c703441990b201b$var$uint8View[i] | 0, 0x165667B1) | 0, 11) | 0, 0x9E3779B1);
    h = Math.imul(h ^ h >>> 15, 0x85EBCA77);
    h = Math.imul(h ^ h >>> 13, 0xC2B2AE3D);
    return ((h ^ h >>> 16) >>> 0).toString();
}
function $6c703441990b201b$var$rotl32(x, r) {
    return x << r | x >>> 32 - r;
}

});




parcelRegister("1GTuR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $13b4c32d410c28d7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $13b4c32d410c28d7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridBottomContainer = $13b4c32d410c28d7$var$GridBottomContainer;

var $13b4c32d410c28d7$var$_extends2 = $13b4c32d410c28d7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $13b4c32d410c28d7$var$React = $13b4c32d410c28d7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $13b4c32d410c28d7$var$_clsx = $13b4c32d410c28d7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $13b4c32d410c28d7$var$_composeClasses = $13b4c32d410c28d7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5H1vo = parcelRequire("5H1vo");

var $ayMG0 = parcelRequire("ayMG0");
const $13b4c32d410c28d7$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'bottomContainer'
        ]
    };
    return (0, $13b4c32d410c28d7$var$_composeClasses.default)(slots, $5H1vo.getDataGridUtilityClass, {});
};
const $13b4c32d410c28d7$var$Element = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    position: 'sticky',
    zIndex: 40,
    bottom: 'calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))'
});
function $13b4c32d410c28d7$var$GridBottomContainer(props) {
    const classes = $13b4c32d410c28d7$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($13b4c32d410c28d7$var$Element, (0, $13b4c32d410c28d7$var$_extends2.default)({}, props, {
        className: (0, $13b4c32d410c28d7$var$_clsx.default)(classes.root, $5H1vo.gridClasses['container--bottom']),
        role: "presentation"
    }));
}

});



parcelRegister("30tkX", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $230820e73b0114fd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unwrapPrivateAPI = $230820e73b0114fd$var$unwrapPrivateAPI;
module.exports.useGridApiInitialization = $230820e73b0114fd$var$useGridApiInitialization;

var $230820e73b0114fd$var$React = $230820e73b0114fd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $les9K = parcelRequire("les9K");

var $8P0MD = parcelRequire("8P0MD");

var $ivFej = parcelRequire("ivFej");

var $iVTh1 = parcelRequire("iVTh1");
const $230820e73b0114fd$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $230820e73b0114fd$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $230820e73b0114fd$var$unwrapPrivateAPI(publicApi) {
    return publicApi[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
}
let $230820e73b0114fd$var$globalId = 0;
function $230820e73b0114fd$var$createPrivateAPI(publicApiRef) {
    const existingPrivateApi = publicApiRef.current?.[$230820e73b0114fd$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: $8P0MD.Store.create(state),
        instanceId: {
            id: $230820e73b0114fd$var$globalId
        }
    };
    $230820e73b0114fd$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if (currentPrivateMethod?.spying === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if (currentPublicMethod?.spying === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new $les9K.EventManager()
    });
    return privateApi;
}
function $230820e73b0114fd$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$230820e73b0114fd$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $230820e73b0114fd$var$useGridApiInitialization(inputApiRef, props) {
    const publicApiRef = $230820e73b0114fd$var$React.useRef(null);
    const privateApiRef = $230820e73b0114fd$var$React.useRef(null);
    if (!privateApiRef.current) privateApiRef.current = $230820e73b0114fd$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $230820e73b0114fd$var$createPublicAPI(privateApiRef);
    const publishEvent = $230820e73b0114fd$var$React.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($230820e73b0114fd$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === $iVTh1.GridSignature.DataGridPro || props.signature === $iVTh1.GridSignature.DataGridPremium ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $230820e73b0114fd$var$React.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $ivFej.useGridApiMethod)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    if (inputApiRef && !inputApiRef.current?.state) inputApiRef.current = publicApiRef.current;
    $230820e73b0114fd$var$React.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $230820e73b0114fd$var$React.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}

});
parcelRegister("les9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "EventManager", {
    enumerable: true,
    get: function() {
        return $kx4kk.EventManager;
    }
});

var $kx4kk = parcelRequire("kx4kk");

});
parcelRegister("kx4kk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventManager = void 0;
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $ef2a3ef580a6a077$var$EventManager {
    maxListeners = 20;
    warnOnce = false;
    events = {};
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}
module.exports.EventManager = $ef2a3ef580a6a077$var$EventManager;

});





parcelRegister("lHSlE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eu7ae = parcelRequire("eu7ae");
Object.keys($eu7ae).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eu7ae[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eu7ae[key];
        }
    });
});

});

parcelRegister("2W9i3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GridPortalWrapper", {
    enumerable: true,
    get: function() {
        return $3DWC3.GridPortalWrapper;
    }
});

var $3DWC3 = parcelRequire("3DWC3");

});

parcelRegister("4IPMC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GRID_COLUMN_MENU_SLOTS", {
    enumerable: true,
    get: function() {
        return $59mZx.GRID_COLUMN_MENU_SLOTS;
    }
});
Object.defineProperty(module.exports, "GRID_COLUMN_MENU_SLOT_PROPS", {
    enumerable: true,
    get: function() {
        return $59mZx.GRID_COLUMN_MENU_SLOT_PROPS;
    }
});
Object.defineProperty(module.exports, "GridColumnMenu", {
    enumerable: true,
    get: function() {
        return $59mZx.GridColumnMenu;
    }
});

var $59mZx = parcelRequire("59mZx");

});





parcelRegister("a8sxV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e33a58cbb7225a5f$var$AlertsPage;

var $e33a58cbb7225a5f$var$_Box = $e33a58cbb7225a5f$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $e33a58cbb7225a5f$var$_Typography = $e33a58cbb7225a5f$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $e33a58cbb7225a5f$var$_AlertStatusGrid = $e33a58cbb7225a5f$var$_interopRequireDefault((parcelRequire("7S9oB")));

var $e33a58cbb7225a5f$var$_DashboardLink = $e33a58cbb7225a5f$var$_interopRequireDefault((parcelRequire("4YUUk")));

var $ayMG0 = parcelRequire("ayMG0");
function $e33a58cbb7225a5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $e33a58cbb7225a5f$var$AlertsPage() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e33a58cbb7225a5f$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '75vw',
            height: '100vh',
            margin: '0 auto',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e33a58cbb7225a5f$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 3,
                    flexWrap: 'wrap',
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e33a58cbb7225a5f$var$_Typography.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 20,
                            fontWeight: 600,
                            color: '#1D9E75'
                        },
                        children: "Alerts"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($e33a58cbb7225a5f$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e33a58cbb7225a5f$var$_DashboardLink.default, {
                                title: "Alert Rules",
                                linkto: "alert-rules"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e33a58cbb7225a5f$var$_DashboardLink.default, {
                                title: "Manage Contacts",
                                linkto: "alert-contacts"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($e33a58cbb7225a5f$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.25rem',
                    height: '75vh'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e33a58cbb7225a5f$var$_AlertStatusGrid.default, {})
            })
        ]
    });
}

});
parcelRegister("7S9oB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc89100f35390323$var$AlertStatusGrid;

var $acw62 = parcelRequire("acw62");

var $bc89100f35390323$var$_Box = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $bc89100f35390323$var$_Button = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $bc89100f35390323$var$_Dialog = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("iZIMH")));

var $bc89100f35390323$var$_DialogActions = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("l5BZB")));

var $bc89100f35390323$var$_DialogContent = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("hJoSv")));

var $bc89100f35390323$var$_DialogTitle = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("lIycJ")));

var $bc89100f35390323$var$_MenuItem = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("iZ4W7")));

var $bc89100f35390323$var$_Select = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("dALxx")));

var $bc89100f35390323$var$_Typography = $bc89100f35390323$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $b2c6k = parcelRequire("b2c6k");

var $3u6kV = parcelRequire("3u6kV");

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $bc89100f35390323$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc89100f35390323$var$BRAND_GREEN = '#1D9E75';
const $bc89100f35390323$var$SILENCE_OPTIONS = [
    {
        value: 1,
        label: '1 hour'
    },
    {
        value: 4,
        label: '4 hours'
    },
    {
        value: 8,
        label: '8 hours'
    },
    {
        value: 24,
        label: '24 hours'
    },
    {
        value: 168,
        label: '1 week'
    }
];
function $bc89100f35390323$var$getStatus(alert) {
    if (!alert.is_active || alert.silenced_until && new Date(alert.silenced_until) > new Date()) return {
        label: 'Silenced',
        bg: 'rgba(186,117,23,0.25)',
        color: '#F0A030'
    };
    const state = alert.alert_state;
    if (!state?.breaching_since) return {
        label: 'Dormant',
        bg: 'rgba(29,158,117,0.25)',
        color: '#2DD4A0'
    };
    const breachDuration = (Date.now() - new Date(state.breaching_since).getTime()) / 60000;
    if (breachDuration < alert.duration_minutes) return {
        label: 'Evaluating',
        bg: 'rgba(186,117,23,0.25)',
        color: '#F0A030'
    };
    return {
        label: 'Breaching',
        bg: 'rgba(220,60,40,0.25)',
        color: '#F05030'
    };
}
function $bc89100f35390323$var$StatusChip({ alert: alert }) {
    const { label: label, bg: bg, color: color } = $bc89100f35390323$var$getStatus(alert);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Box.default, {
        sx: {
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'center',
            px: 1.25,
            py: 0.35,
            borderRadius: '6px',
            background: bg,
            border: `1px solid ${color}`,
            fontFamily: "'DM Mono', monospace",
            fontSize: 11,
            fontWeight: 600,
            color: color,
            letterSpacing: '0.04em',
            whiteSpace: 'nowrap',
            lineHeight: 1
        },
        children: label
    });
}
const $bc89100f35390323$var$actionBtnSx = (color)=>({
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        borderColor: color,
        color: color,
        borderRadius: 1.5,
        py: 0.4,
        '&:hover': {
            borderColor: color,
            background: `${color}18`
        }
    });
function $bc89100f35390323$var$AlertStatusGrid() {
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [silenceTarget, setSilenceTarget] = (0, $acw62.useState)(null);
    const [silenceHours, setSilenceHours] = (0, $acw62.useState)(1);
    const fetchRows = ()=>{
        (0, $3u6kV.getAlertStatuses)().then((data)=>{
            setRows(data.map((a)=>({
                    ...a,
                    measurement_name: $dOn5J.DESC_MAP[a.measurement?.name] ?? a.measurement?.name ?? "\u2014",
                    alert_state: Array.isArray(a.alert_state) ? a.alert_state[0] ?? null : a.alert_state
                })));
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchRows();
        const id = setInterval(fetchRows, 30000);
        return ()=>clearInterval(id);
    }, []);
    const handleSilenceConfirm = async ()=>{
        if (!silenceTarget) return;
        const until = new Date(Date.now() + silenceHours * 3600000).toISOString();
        await (0, $3u6kV.silenceAlert)(silenceTarget.id, until, false);
        setSilenceTarget(null);
        fetchRows();
    };
    const handleUnsilence = async (alert)=>{
        await (0, $3u6kV.silenceAlert)(alert.id, null, true);
        fetchRows();
    };
    const columns = [
        {
            field: 'name',
            headerName: 'Alert Name',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Typography.default, {
                    sx: {
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 13,
                        fontWeight: 500,
                        color: 'var(--color-text-primary)'
                    },
                    children: p.value
                })
        },
        {
            field: 'measurement_name',
            headerName: 'Parameter',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Typography.default, {
                    sx: {
                        fontFamily: "'DM Mono', monospace",
                        fontSize: 12,
                        color: 'var(--color-text-secondary)'
                    },
                    children: p.value
                })
        },
        {
            field: 'condition',
            headerName: 'Condition',
            flex: 0.75,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (_v, row)=>`${row.operator} ${row.threshold}`,
            renderCell: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Typography.default, {
                    sx: {
                        fontFamily: "'DM Mono', monospace",
                        fontSize: 12,
                        color: 'var(--color-text-secondary)'
                    },
                    children: p.value
                })
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.75,
            align: 'center',
            headerAlign: 'center',
            renderCell: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Box.default, {
                    sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$StatusChip, {
                        alert: p.row
                    })
                })
        },
        {
            field: 'silenced_until',
            headerName: 'Silenced Until',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Typography.default, {
                    sx: {
                        fontFamily: "'DM Mono', monospace",
                        fontSize: 12,
                        color: 'var(--color-text-secondary)'
                    },
                    children: p.value ? new Date(p.value).toLocaleString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        hour: '2-digit',
                        minute: '2-digit'
                    }) : "\u2014"
                })
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.75,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderCell: (p)=>{
                const isSilenced = !p.row.is_active || p.row.silenced_until && new Date(p.row.silenced_until) > new Date();
                return isSilenced ? /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Button.default, {
                    size: "small",
                    variant: "outlined",
                    onClick: ()=>handleUnsilence(p.row),
                    sx: $bc89100f35390323$var$actionBtnSx($bc89100f35390323$var$BRAND_GREEN),
                    children: "Unsilence"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Button.default, {
                    size: "small",
                    variant: "outlined",
                    onClick: ()=>setSilenceTarget(p.row),
                    sx: $bc89100f35390323$var$actionBtnSx('#BA7517'),
                    children: "Silence"
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b2c6k.DataGrid, {
                rows: rows,
                columns: columns,
                pageSizeOptions: [
                    10,
                    25,
                    {
                        value: -1,
                        label: 'All'
                    }
                ],
                initialState: {
                    pagination: {
                        paginationModel: {
                            pageSize: 10
                        }
                    }
                },
                disableRowSelectionOnClick: true,
                sx: {
                    border: 'none',
                    background: 'transparent',
                    '& .MuiDataGrid-columnHeader': {
                        background: `${$bc89100f35390323$var$BRAND_GREEN} !important`,
                        color: '#ffffff !important',
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 11,
                        fontWeight: 600,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase'
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#ffffff !important'
                    },
                    '& .MuiDataGrid-columnSeparator': {
                        display: 'none'
                    },
                    '& .MuiDataGrid-row': {
                        borderBottom: '1px solid rgba(255,255,255,0.04)',
                        background: 'transparent'
                    },
                    '& .MuiDataGrid-row:hover': {
                        background: 'rgba(255,255,255,0.02)'
                    },
                    '& .MuiDataGrid-cell': {
                        border: 'none',
                        background: 'transparent',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    '& .MuiDataGrid-columnHeaderTitleContainer': {
                        justifyContent: 'center'
                    },
                    '& .MuiDataGrid-footerContainer': {
                        borderTop: '1px solid rgba(255,255,255,0.06)',
                        background: 'transparent',
                        fontFamily: "'DM Mono', monospace",
                        fontSize: 11
                    },
                    '& .MuiTablePagination-root': {
                        fontFamily: "'DM Mono', monospace",
                        fontSize: 11,
                        color: 'var(--color-text-secondary)'
                    },
                    '& .MuiDataGrid-sortIcon': {
                        color: '#ffffff !important'
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        color: '#ffffff !important'
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($bc89100f35390323$var$_Dialog.default, {
                open: Boolean(silenceTarget),
                onClose: ()=>setSilenceTarget(null),
                PaperProps: {
                    sx: {
                        background: 'var(--color-bg-secondary)',
                        borderRadius: 3,
                        p: 1,
                        minWidth: 320
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($bc89100f35390323$var$_DialogTitle.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 16,
                            fontWeight: 600,
                            color: 'var(--color-text-primary)'
                        },
                        children: [
                            "Silence: ",
                            silenceTarget?.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($bc89100f35390323$var$_DialogContent.default, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 12,
                                    color: 'var(--color-text-secondary)',
                                    mb: 2
                                },
                                children: "Select how long to silence this alert:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Select.default, {
                                fullWidth: true,
                                size: "small",
                                value: silenceHours,
                                onChange: (e)=>setSilenceHours(Number(e.target.value)),
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 13,
                                    borderRadius: 2,
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'rgba(255,255,255,0.12)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: $bc89100f35390323$var$BRAND_GREEN
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: $bc89100f35390323$var$BRAND_GREEN
                                    }
                                },
                                children: $bc89100f35390323$var$SILENCE_OPTIONS.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_MenuItem.default, {
                                        value: o.value,
                                        sx: {
                                            fontFamily: "'DM Mono', monospace",
                                            fontSize: 13
                                        },
                                        children: o.label
                                    }, o.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($bc89100f35390323$var$_DialogActions.default, {
                        sx: {
                            px: 3,
                            pb: 2,
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Button.default, {
                                onClick: ()=>setSilenceTarget(null),
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    textTransform: 'uppercase',
                                    color: 'var(--color-text-secondary)',
                                    borderRadius: 2
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($bc89100f35390323$var$_Button.default, {
                                variant: "contained",
                                onClick: handleSilenceConfirm,
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    textTransform: 'uppercase',
                                    background: '#BA7517',
                                    borderRadius: 2,
                                    '&:hover': {
                                        background: '#9a5c10'
                                    }
                                },
                                children: "Silence"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("iZIMH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dd40a9c943ba05e0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dd40a9c943ba05e0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd40a9c943ba05e0$var$_exportNames = {
    dialogClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dd40a9c943ba05e0$var$_Dialog.default;
    }
});
Object.defineProperty(module.exports, "dialogClasses", {
    enumerable: true,
    get: function() {
        return $dd40a9c943ba05e0$var$_dialogClasses.default;
    }
});

var $dd40a9c943ba05e0$var$_Dialog = $dd40a9c943ba05e0$require$_interopRequireDefault((parcelRequire("6MV2p")));

var $dd40a9c943ba05e0$var$_dialogClasses = $dd40a9c943ba05e0$require$_interopRequireWildcard((parcelRequire("gX5bM")));
Object.keys($dd40a9c943ba05e0$var$_dialogClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dd40a9c943ba05e0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dd40a9c943ba05e0$var$_dialogClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dd40a9c943ba05e0$var$_dialogClasses[key];
        }
    });
});

});
parcelRegister("6MV2p", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4f13784bd714c44e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4f13784bd714c44e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f13784bd714c44e$var$React = $4f13784bd714c44e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4f13784bd714c44e$var$_propTypes = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4f13784bd714c44e$var$_clsx = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4f13784bd714c44e$var$_composeClasses = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $4f13784bd714c44e$var$_useId = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("hwliF")));

var $4f13784bd714c44e$var$_capitalize = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $4f13784bd714c44e$var$_Modal = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("8vVVd")));

var $4f13784bd714c44e$var$_Fade = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $4f13784bd714c44e$var$_Paper = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $4f13784bd714c44e$var$_dialogClasses = $4f13784bd714c44e$require$_interopRequireWildcard((parcelRequire("gX5bM")));

var $4f13784bd714c44e$var$_DialogContext = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("8W68d")));

var $4f13784bd714c44e$var$_Backdrop = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("bXwVR")));

var $aAbgT = parcelRequire("aAbgT");

var $4f13784bd714c44e$var$_memoTheme = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $4f13784bd714c44e$var$_useSlot = $4f13784bd714c44e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $4f13784bd714c44e$var$DialogBackdrop = (0, $aAbgT.styled)($4f13784bd714c44e$var$_Backdrop.default, {
    name: 'MuiDialog',
    slot: 'Backdrop'
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        backdrop: [
            'backdrop'
        ],
        container: [
            'container',
            `scroll${(0, $4f13784bd714c44e$var$_capitalize.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $4f13784bd714c44e$var$_capitalize.default)(scroll)}`,
            `paperWidth${(0, $4f13784bd714c44e$var$_capitalize.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $4f13784bd714c44e$var$_composeClasses.default)(slots, $4f13784bd714c44e$var$_dialogClasses.getDialogUtilityClass, classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $aAbgT.styled)($4f13784bd714c44e$var$_Modal.default, {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $aAbgT.styled)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $4f13784bd714c44e$var$_capitalize.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $4f13784bd714c44e$var$DialogPaper = (0, $aAbgT.styled)($4f13784bd714c44e$var$_Paper.default, {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $4f13784bd714c44e$var$_capitalize.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $4f13784bd714c44e$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $4f13784bd714c44e$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${$4f13784bd714c44e$var$_dialogClasses.default.paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${$4f13784bd714c44e$var$_dialogClasses.default.paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${$4f13784bd714c44e$var$_dialogClasses.default.paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $4f13784bd714c44e$var$React.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $aAbgT.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = $4f13784bd714c44e$var$_Paper.default, PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = $4f13784bd714c44e$var$_Fade.default, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $4f13784bd714c44e$var$React.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $4f13784bd714c44e$var$_useId.default)(ariaLabelledbyProp);
    const dialogContextValue = $4f13784bd714c44e$var$React.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('root', {
        elementType: $4f13784bd714c44e$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $4f13784bd714c44e$var$_clsx.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('backdrop', {
        elementType: $4f13784bd714c44e$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.backdrop
    });
    const [PaperSlot, paperSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('paper', {
        elementType: $4f13784bd714c44e$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $4f13784bd714c44e$var$_clsx.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('container', {
        elementType: $4f13784bd714c44e$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $4f13784bd714c44e$var$_useSlot.default)('transition', {
        elementType: $4f13784bd714c44e$var$_Fade.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$_DialogContext.default.Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $4f13784bd714c44e$var$_default = module.exports.default = $4f13784bd714c44e$var$Dialog;

});
parcelRegister("gX5bM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c5762e789acf7dcc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogUtilityClass = $c5762e789acf7dcc$var$getDialogUtilityClass;

var $c5762e789acf7dcc$var$_generateUtilityClasses = $c5762e789acf7dcc$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c5762e789acf7dcc$var$_generateUtilityClass = $c5762e789acf7dcc$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c5762e789acf7dcc$var$getDialogUtilityClass(slot) {
    return (0, $c5762e789acf7dcc$var$_generateUtilityClass.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $c5762e789acf7dcc$var$_generateUtilityClasses.default)('MuiDialog', [
    'root',
    'backdrop',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$var$_default = module.exports.default = $c5762e789acf7dcc$var$dialogClasses;

});

parcelRegister("8W68d", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $68187f174395cd28$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68187f174395cd28$var$React = $68187f174395cd28$require$_interopRequireWildcard((parcelRequire("acw62")));
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $68187f174395cd28$var$React.createContext({});
var $68187f174395cd28$var$_default = module.exports.default = $68187f174395cd28$var$DialogContext;

});



parcelRegister("l5BZB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f5a78922775ef422$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f5a78922775ef422$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f5a78922775ef422$var$_exportNames = {
    dialogActionsClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5a78922775ef422$var$_DialogActions.default;
    }
});
Object.defineProperty(module.exports, "dialogActionsClasses", {
    enumerable: true,
    get: function() {
        return $f5a78922775ef422$var$_dialogActionsClasses.default;
    }
});

var $f5a78922775ef422$var$_DialogActions = $f5a78922775ef422$require$_interopRequireDefault((parcelRequire("2MUlQ")));

var $f5a78922775ef422$var$_dialogActionsClasses = $f5a78922775ef422$require$_interopRequireWildcard((parcelRequire("4ZLz5")));
Object.keys($f5a78922775ef422$var$_dialogActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f5a78922775ef422$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f5a78922775ef422$var$_dialogActionsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f5a78922775ef422$var$_dialogActionsClasses[key];
        }
    });
});

});
parcelRegister("2MUlQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $207bc6ab7c60f4b2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $207bc6ab7c60f4b2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $207bc6ab7c60f4b2$var$React = $207bc6ab7c60f4b2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $207bc6ab7c60f4b2$var$_propTypes = $207bc6ab7c60f4b2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $207bc6ab7c60f4b2$var$_clsx = $207bc6ab7c60f4b2$require$_interopRequireDefault((parcelRequire("9QePP")));

var $207bc6ab7c60f4b2$var$_composeClasses = $207bc6ab7c60f4b2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4ZLz5 = parcelRequire("4ZLz5");

var $ayMG0 = parcelRequire("ayMG0");
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $207bc6ab7c60f4b2$var$_composeClasses.default)(slots, $4ZLz5.getDialogActionsUtilityClass, classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $207bc6ab7c60f4b2$var$React.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, {
        className: (0, $207bc6ab7c60f4b2$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $207bc6ab7c60f4b2$var$_default = module.exports.default = $207bc6ab7c60f4b2$var$DialogActions;

});
parcelRegister("4ZLz5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a31c1516a2c01e5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogActionsUtilityClass = $3a31c1516a2c01e5$var$getDialogActionsUtilityClass;

var $3a31c1516a2c01e5$var$_generateUtilityClasses = $3a31c1516a2c01e5$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3a31c1516a2c01e5$var$_generateUtilityClass = $3a31c1516a2c01e5$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3a31c1516a2c01e5$var$getDialogActionsUtilityClass(slot) {
    return (0, $3a31c1516a2c01e5$var$_generateUtilityClass.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $3a31c1516a2c01e5$var$_generateUtilityClasses.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$var$_default = module.exports.default = $3a31c1516a2c01e5$var$dialogActionsClasses;

});



parcelRegister("hJoSv", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ce89efe9ad487ed1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ce89efe9ad487ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ce89efe9ad487ed1$var$_exportNames = {
    dialogContentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ce89efe9ad487ed1$var$_DialogContent.default;
    }
});
Object.defineProperty(module.exports, "dialogContentClasses", {
    enumerable: true,
    get: function() {
        return $ce89efe9ad487ed1$var$_dialogContentClasses.default;
    }
});

var $ce89efe9ad487ed1$var$_DialogContent = $ce89efe9ad487ed1$require$_interopRequireDefault((parcelRequire("6Q1H5")));

var $ce89efe9ad487ed1$var$_dialogContentClasses = $ce89efe9ad487ed1$require$_interopRequireWildcard((parcelRequire("hd5xz")));
Object.keys($ce89efe9ad487ed1$var$_dialogContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ce89efe9ad487ed1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ce89efe9ad487ed1$var$_dialogContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ce89efe9ad487ed1$var$_dialogContentClasses[key];
        }
    });
});

});
parcelRegister("6Q1H5", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4fa8e9c420cdee0a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4fa8e9c420cdee0a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fa8e9c420cdee0a$var$React = $4fa8e9c420cdee0a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4fa8e9c420cdee0a$var$_propTypes = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4fa8e9c420cdee0a$var$_clsx = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4fa8e9c420cdee0a$var$_composeClasses = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $4fa8e9c420cdee0a$var$_memoTheme = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $hd5xz = parcelRequire("hd5xz");

var $4fa8e9c420cdee0a$var$_dialogTitleClasses = $4fa8e9c420cdee0a$require$_interopRequireDefault((parcelRequire("kQXVi")));

var $ayMG0 = parcelRequire("ayMG0");
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $4fa8e9c420cdee0a$var$_composeClasses.default)(slots, $hd5xz.getDialogContentUtilityClass, classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $4fa8e9c420cdee0a$var$_memoTheme.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${$4fa8e9c420cdee0a$var$_dialogTitleClasses.default.root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $4fa8e9c420cdee0a$var$React.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, {
        className: (0, $4fa8e9c420cdee0a$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $4fa8e9c420cdee0a$var$_default = module.exports.default = $4fa8e9c420cdee0a$var$DialogContent;

});
parcelRegister("hd5xz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c877f2cebcabf5cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogContentUtilityClass = $c877f2cebcabf5cb$var$getDialogContentUtilityClass;

var $c877f2cebcabf5cb$var$_generateUtilityClasses = $c877f2cebcabf5cb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c877f2cebcabf5cb$var$_generateUtilityClass = $c877f2cebcabf5cb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c877f2cebcabf5cb$var$getDialogContentUtilityClass(slot) {
    return (0, $c877f2cebcabf5cb$var$_generateUtilityClass.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $c877f2cebcabf5cb$var$_generateUtilityClasses.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$var$_default = module.exports.default = $c877f2cebcabf5cb$var$dialogContentClasses;

});

parcelRegister("kQXVi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f2e7257b2514744a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogTitleUtilityClass = $f2e7257b2514744a$var$getDialogTitleUtilityClass;

var $f2e7257b2514744a$var$_generateUtilityClasses = $f2e7257b2514744a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f2e7257b2514744a$var$_generateUtilityClass = $f2e7257b2514744a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f2e7257b2514744a$var$getDialogTitleUtilityClass(slot) {
    return (0, $f2e7257b2514744a$var$_generateUtilityClass.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $f2e7257b2514744a$var$_generateUtilityClasses.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$var$_default = module.exports.default = $f2e7257b2514744a$var$dialogTitleClasses;

});



parcelRegister("lIycJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fcf83d520808df6e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fcf83d520808df6e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fcf83d520808df6e$var$_exportNames = {
    dialogTitleClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fcf83d520808df6e$var$_DialogTitle.default;
    }
});
Object.defineProperty(module.exports, "dialogTitleClasses", {
    enumerable: true,
    get: function() {
        return $fcf83d520808df6e$var$_dialogTitleClasses.default;
    }
});

var $fcf83d520808df6e$var$_DialogTitle = $fcf83d520808df6e$require$_interopRequireDefault((parcelRequire("ejcfT")));

var $fcf83d520808df6e$var$_dialogTitleClasses = $fcf83d520808df6e$require$_interopRequireWildcard((parcelRequire("kQXVi")));
Object.keys($fcf83d520808df6e$var$_dialogTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fcf83d520808df6e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fcf83d520808df6e$var$_dialogTitleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fcf83d520808df6e$var$_dialogTitleClasses[key];
        }
    });
});

});
parcelRegister("ejcfT", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a6ac58aca374c76c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a6ac58aca374c76c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6ac58aca374c76c$var$React = $a6ac58aca374c76c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a6ac58aca374c76c$var$_propTypes = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a6ac58aca374c76c$var$_clsx = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a6ac58aca374c76c$var$_composeClasses = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a6ac58aca374c76c$var$_Typography = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $kQXVi = parcelRequire("kQXVi");

var $a6ac58aca374c76c$var$_DialogContext = $a6ac58aca374c76c$require$_interopRequireDefault((parcelRequire("8W68d")));

var $ayMG0 = parcelRequire("ayMG0");
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $a6ac58aca374c76c$var$_composeClasses.default)(slots, $kQXVi.getDialogTitleUtilityClass, classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $aAbgT.styled)($a6ac58aca374c76c$var$_Typography.default, {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $a6ac58aca374c76c$var$React.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $a6ac58aca374c76c$var$React.useContext($a6ac58aca374c76c$var$_DialogContext.default);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $a6ac58aca374c76c$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $a6ac58aca374c76c$var$_default = module.exports.default = $a6ac58aca374c76c$var$DialogTitle;

});



parcelRegister("4YUUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8430ef31b865e41$var$DashboardLink;

var $c8430ef31b865e41$var$_Box = $c8430ef31b865e41$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $c8430ef31b865e41$var$_Typography = $c8430ef31b865e41$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $gwjoH = parcelRequire("gwjoH");

var $c8430ef31b865e41$var$_Hub = $c8430ef31b865e41$var$_interopRequireDefault((parcelRequire("eNVql")));

var $c8430ef31b865e41$var$_Dashboard = $c8430ef31b865e41$var$_interopRequireDefault((parcelRequire("1kGp1")));

var $ayMG0 = parcelRequire("ayMG0");
function $c8430ef31b865e41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $c8430ef31b865e41$var$DashboardLink({ linkto: linkto, title: title }) {
    const isOverview = linkto === 'overview';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Link, {
        to: `/${linkto}`,
        style: {
            textDecoration: 'none'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($c8430ef31b865e41$var$_Box.default, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
                p: '8px 12px',
                borderRadius: 2,
                background: 'var(--color-bg-secondary)',
                borderLeft: '3px solid transparent',
                transition: 'all 0.18s ease',
                cursor: 'pointer',
                '&:hover': {
                    borderLeftColor: '#1D9E75',
                    background: 'var(--color-bg-tertiary)',
                    transform: 'translateX(3px)'
                }
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($c8430ef31b865e41$var$_Box.default, {
                    sx: {
                        color: '#1D9E75',
                        display: 'flex',
                        alignItems: 'center',
                        flexShrink: 0,
                        '& svg': {
                            fontSize: '16px !important',
                            padding: 0
                        }
                    },
                    children: isOverview ? /*#__PURE__*/ (0, $ayMG0.jsx)($c8430ef31b865e41$var$_Hub.default, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($c8430ef31b865e41$var$_Dashboard.default, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($c8430ef31b865e41$var$_Typography.default, {
                    sx: {
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 13,
                        fontWeight: 500,
                        color: 'var(--color-text-primary)',
                        lineHeight: 1.3
                    },
                    children: title
                })
            ]
        })
    });
}

});
parcelRegister("1kGp1", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $0f888cfd20c040d5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f888cfd20c040d5$var$_createSvgIcon = $0f888cfd20c040d5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $0f888cfd20c040d5$var$_default = module.exports.default = (0, $0f888cfd20c040d5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 13h8V3H3zm0 8h8v-6H3zm10 0h8V11h-8zm0-18v6h8V3z"
}), 'Dashboard');

});



parcelRegister("6peqI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d29904cf851bd4c5$var$AlertContacts;

var $d29904cf851bd4c5$var$_Box = $d29904cf851bd4c5$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $d29904cf851bd4c5$var$_Typography = $d29904cf851bd4c5$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $d29904cf851bd4c5$var$_Button = $d29904cf851bd4c5$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $d29904cf851bd4c5$var$_ArrowBack = $d29904cf851bd4c5$var$_interopRequireDefault((parcelRequire("1YLXO")));

var $gwjoH = parcelRequire("gwjoH");

var $d29904cf851bd4c5$var$_AlertContactsDataGrid = $d29904cf851bd4c5$var$_interopRequireDefault((parcelRequire("kiyS5")));

var $ayMG0 = parcelRequire("ayMG0");
function $d29904cf851bd4c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $d29904cf851bd4c5$var$AlertContacts() {
    const navigate = (0, $gwjoH.useNavigate)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d29904cf851bd4c5$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '75vw',
            margin: '0 auto',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d29904cf851bd4c5$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d29904cf851bd4c5$var$_Button.default, {
                        variant: "outlined",
                        size: "small",
                        onClick: ()=>navigate('/alerts'),
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($d29904cf851bd4c5$var$_ArrowBack.default, {
                            sx: {
                                fontSize: '14px !important',
                                padding: '0 !important'
                            }
                        }),
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 11,
                            textTransform: 'uppercase',
                            color: 'var(--color-text-secondary)',
                            borderColor: 'rgba(255,255,255,0.12)',
                            borderRadius: 2,
                            '&:hover': {
                                borderColor: '#1D9E75',
                                color: '#1D9E75'
                            }
                        },
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d29904cf851bd4c5$var$_Typography.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 20,
                            fontWeight: 600,
                            color: '#1D9E75'
                        },
                        children: "Contact Points"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d29904cf851bd4c5$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.25rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d29904cf851bd4c5$var$_AlertContactsDataGrid.default, {})
            })
        ]
    });
}

});
parcelRegister("1YLXO", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1710999fd8a821f2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1710999fd8a821f2$var$_createSvgIcon = $1710999fd8a821f2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1710999fd8a821f2$var$_default = module.exports.default = (0, $1710999fd8a821f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');

});

parcelRegister("kiyS5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0d5febded1dd5843$var$AlertContactsDataGrid;

var $acw62 = parcelRequire("acw62");

var $0d5febded1dd5843$var$_ReusableDataGrid = $0d5febded1dd5843$var$_interopRequireDefault((parcelRequire("16S3t")));

var $3u6kV = parcelRequire("3u6kV");

var $ayMG0 = parcelRequire("ayMG0");
function $0d5febded1dd5843$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d5febded1dd5843$var$FREQUENCY_OPTIONS = [
    {
        value: 0,
        label: 'Once'
    },
    {
        value: 1,
        label: 'Every hour'
    },
    {
        value: 4,
        label: 'Every 4 hours'
    },
    {
        value: 24,
        label: 'Every 24 hours'
    }
];
const $0d5febded1dd5843$var$defaultRow = {
    email: '',
    notify_every_hours: 24,
    isNew: true
};
const $0d5febded1dd5843$var$columns = [
    {
        field: 'email',
        headerName: 'Email',
        type: 'string',
        flex: 1,
        editable: true
    },
    {
        field: 'notify_every_hours',
        headerName: 'Notification Frequency',
        type: 'singleSelect',
        flex: 1,
        editable: true,
        valueOptions: $0d5febded1dd5843$var$FREQUENCY_OPTIONS
    }
];
function $0d5febded1dd5843$var$AlertContactsDataGrid() {
    const [initialRows, setInitialRows] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        (0, $3u6kV.getContactPoints)().then(setInitialRows);
    }, []);
    const handleSaveRow = async (row)=>{
        const { isNew: isNew, id: id, ...fields } = row;
        if (isNew) {
            const [created] = await (0, $3u6kV.createContactPoint)(fields);
            return {
                ...created,
                isNew: false
            };
        } else {
            const [updated] = await (0, $3u6kV.updateContactPoint)(id, fields);
            return {
                ...updated,
                isNew: false
            };
        }
    };
    const handleDeleteRow = async (row)=>{
        await (0, $3u6kV.deleteContactPoint)(row.id);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0d5febded1dd5843$var$_ReusableDataGrid.default, {
        defaultRow: $0d5febded1dd5843$var$defaultRow,
        columns: $0d5febded1dd5843$var$columns,
        height: "75vh",
        width: "100%",
        initialRows: initialRows,
        onSaveRow: handleSaveRow,
        onDeleteRow: handleDeleteRow
    });
}

});


parcelRegister("9NFlG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8acc08ce1a32cb03$var$AlertRules;

var $8acc08ce1a32cb03$var$_Box = $8acc08ce1a32cb03$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $8acc08ce1a32cb03$var$_Typography = $8acc08ce1a32cb03$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $8acc08ce1a32cb03$var$_Button = $8acc08ce1a32cb03$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $8acc08ce1a32cb03$var$_ArrowBack = $8acc08ce1a32cb03$var$_interopRequireDefault((parcelRequire("1YLXO")));

var $gwjoH = parcelRequire("gwjoH");

var $8acc08ce1a32cb03$var$_AlertDataGrid = $8acc08ce1a32cb03$var$_interopRequireDefault((parcelRequire("dqoNt")));

var $ayMG0 = parcelRequire("ayMG0");
function $8acc08ce1a32cb03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $8acc08ce1a32cb03$var$AlertRules() {
    const navigate = (0, $gwjoH.useNavigate)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8acc08ce1a32cb03$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '75vw',
            margin: '0 auto',
            height: '100vh',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($8acc08ce1a32cb03$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8acc08ce1a32cb03$var$_Button.default, {
                        variant: "outlined",
                        size: "small",
                        onClick: ()=>navigate('/alerts'),
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($8acc08ce1a32cb03$var$_ArrowBack.default, {
                            sx: {
                                fontSize: '14px !important',
                                padding: '0 !important'
                            }
                        }),
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 11,
                            textTransform: 'uppercase',
                            color: 'var(--color-text-secondary)',
                            borderColor: 'rgba(255,255,255,0.12)',
                            borderRadius: 2,
                            '&:hover': {
                                borderColor: '#1D9E75',
                                color: '#1D9E75'
                            }
                        },
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8acc08ce1a32cb03$var$_Typography.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 20,
                            fontWeight: 600,
                            color: '#1D9E75'
                        },
                        children: "Alert Rules"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8acc08ce1a32cb03$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.25rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8acc08ce1a32cb03$var$_AlertDataGrid.default, {})
            })
        ]
    });
}

});
parcelRegister("dqoNt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a9cd51a3ff243f48$var$AlertsDataGrid;

var $acw62 = parcelRequire("acw62");

var $b2c6k = parcelRequire("b2c6k");

var $cvg8Z = parcelRequire("cvg8Z");

var $a9cd51a3ff243f48$var$_ReusableDataGrid = $a9cd51a3ff243f48$var$_interopRequireDefault((parcelRequire("16S3t")));

var $3u6kV = parcelRequire("3u6kV");

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $a9cd51a3ff243f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9cd51a3ff243f48$var$OPERATOR_OPTIONS = [
    {
        value: '>',
        label: 'Above'
    },
    {
        value: '<',
        label: 'Below'
    },
    {
        value: '>=',
        label: 'Above or equal'
    },
    {
        value: '<=',
        label: 'Below or equal'
    }
];
const $a9cd51a3ff243f48$var$defaultRow = {
    name: '',
    measurement_id: null,
    osm_ids: [],
    operator: '>',
    threshold: 0,
    duration_minutes: 5,
    isNew: true
};
function $a9cd51a3ff243f48$var$OsmMultiSelectEdit({ id: id, field: field, value: value, osmOptions: osmOptions }) {
    const apiRef = (0, $b2c6k.useGridApiContext)();
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const cellRef = (0, $acw62.useRef)(null);
    const selected = Array.isArray(value) ? value : [];
    const locationOptions = osmOptions.filter((o)=>o.value !== null);
    const handleToggle = (optValue)=>{
        const newValue = selected.includes(optValue) ? selected.filter((v)=>v !== optValue) : [
            ...selected,
            optValue
        ];
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newValue
        });
    };
    const displayText = selected.length === 0 ? 'All' : selected.map((id)=>locationOptions.find((o)=>o.value === id)?.label ?? id).join(', ');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: cellRef,
                onClick: (e)=>setAnchorEl(e.currentTarget),
                style: {
                    width: '100%',
                    cursor: 'pointer',
                    padding: '0 8px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontFamily: "'DM Mono', monospace",
                    fontSize: 13
                },
                children: displayText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Popover, {
                open: Boolean(anchorEl),
                anchorEl: anchorEl,
                onClose: ()=>setAnchorEl(null),
                container: document.body,
                style: {
                    zIndex: 9999
                },
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                PaperProps: {
                    sx: {
                        background: 'var(--color-bg-secondary)',
                        borderRadius: 2,
                        minWidth: 220
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        maxHeight: 250,
                        overflowY: 'auto'
                    },
                    children: locationOptions.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.MenuItem, {
                            onClick: ()=>handleToggle(opt.value),
                            sx: {
                                py: 0.5,
                                fontSize: 13,
                                fontFamily: "'DM Mono', monospace"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Checkbox, {
                                    checked: selected.includes(opt.value),
                                    size: "small",
                                    sx: {
                                        color: 'rgba(255,255,255,0.2)',
                                        '&.Mui-checked': {
                                            color: '#1D9E75'
                                        },
                                        '& svg': {
                                            fontSize: '16px !important',
                                            padding: '0 !important'
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.ListItemText, {
                                    primary: opt.label,
                                    primaryTypographyProps: {
                                        fontSize: 13,
                                        fontFamily: "'DM Mono', monospace"
                                    }
                                })
                            ]
                        }, opt.value))
                })
            })
        ]
    });
}
function $a9cd51a3ff243f48$var$AlertsDataGrid() {
    const [initialRows, setInitialRows] = (0, $acw62.useState)([]);
    const [measurementOptions, setMeasurementOptions] = (0, $acw62.useState)([]);
    const [osmOptions, setOsmOptions] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        Promise.all([
            (0, $3u6kV.getAlerts)(),
            (0, $3u6kV.getMeasurements)(),
            (0, $3u6kV.getOsmLocations)()
        ]).then(([alerts, measurements, osms])=>{
            setInitialRows(alerts);
            setMeasurementOptions(measurements.filter((m)=>!m.name.endsWith('_min') && !m.name.endsWith('_max')).map((m)=>({
                    value: m.id,
                    label: $dOn5J.DESC_MAP[m.name] ?? m.name
                })));
            setOsmOptions([
                {
                    value: null,
                    label: 'All'
                },
                ...osms.map((o)=>({
                        value: o.id,
                        label: o.name
                    }))
            ]);
        });
    }, []);
    const handleSaveRow = async (row)=>{
        const { isNew: isNew, id: id, ...fields } = row;
        const payload = {
            ...fields,
            osm_ids: fields.osm_ids?.length ? fields.osm_ids : null
        };
        if (isNew) {
            const [created] = await (0, $3u6kV.createAlert)(payload);
            return {
                ...created,
                isNew: false
            };
        } else {
            const [updated] = await (0, $3u6kV.updateAlert)(id, payload);
            return {
                ...updated,
                isNew: false
            };
        }
    };
    const handleDeleteRow = async (row)=>{
        await (0, $3u6kV.deleteAlert)(row.id);
    };
    const columns = [
        {
            field: 'name',
            headerName: 'Alert Name',
            type: 'string',
            flex: 1,
            editable: true
        },
        {
            field: 'measurement_id',
            headerName: 'Parameter',
            type: 'singleSelect',
            flex: 1,
            editable: true,
            valueOptions: measurementOptions
        },
        {
            field: 'operator',
            headerName: 'Condition',
            type: 'singleSelect',
            flex: 0.75,
            editable: true,
            valueOptions: $a9cd51a3ff243f48$var$OPERATOR_OPTIONS
        },
        {
            field: 'threshold',
            headerName: 'Threshold Value',
            type: 'number',
            flex: 0.75,
            editable: true
        },
        {
            field: 'duration_minutes',
            headerName: 'Duration (mins)',
            type: 'number',
            flex: 0.75,
            editable: true
        },
        {
            field: 'osm_ids',
            headerName: 'Location',
            flex: 1,
            editable: true,
            valueFormatter: (value)=>{
                if (!value?.length) return 'All';
                return value.map((id)=>osmOptions.find((o)=>o.value === id)?.label ?? id).join(', ');
            },
            renderEditCell: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($a9cd51a3ff243f48$var$OsmMultiSelectEdit, {
                    id: params.id,
                    field: params.field,
                    value: params.value ?? [],
                    osmOptions: osmOptions
                })
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a9cd51a3ff243f48$var$_ReusableDataGrid.default, {
        defaultRow: $a9cd51a3ff243f48$var$defaultRow,
        columns: columns,
        height: "100%",
        width: "100%",
        initialRows: initialRows,
        onSaveRow: handleSaveRow,
        onDeleteRow: handleDeleteRow
    });
}

});
parcelRegister("cvg8Z", function(module, exports) {
/**
 * @mui/material v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $91a4e72629291447$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $91a4e72629291447$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $91a4e72629291447$var$_exportNames = {
    colors: true,
    Accordion: true,
    AccordionActions: true,
    AccordionDetails: true,
    AccordionSummary: true,
    Alert: true,
    AlertTitle: true,
    AppBar: true,
    Autocomplete: true,
    Avatar: true,
    AvatarGroup: true,
    Backdrop: true,
    Badge: true,
    BottomNavigation: true,
    BottomNavigationAction: true,
    Box: true,
    Breadcrumbs: true,
    Button: true,
    ButtonBase: true,
    ButtonGroup: true,
    Card: true,
    CardActionArea: true,
    CardActions: true,
    CardContent: true,
    CardHeader: true,
    CardMedia: true,
    Checkbox: true,
    Chip: true,
    CircularProgress: true,
    ClickAwayListener: true,
    Collapse: true,
    Container: true,
    CssBaseline: true,
    darkScrollbar: true,
    Dialog: true,
    DialogActions: true,
    DialogContent: true,
    DialogContentText: true,
    DialogTitle: true,
    Divider: true,
    Drawer: true,
    Fab: true,
    Fade: true,
    FilledInput: true,
    FormControl: true,
    FormControlLabel: true,
    FormGroup: true,
    FormHelperText: true,
    FormLabel: true,
    GridLegacy: true,
    Grid: true,
    Grow: true,
    Icon: true,
    IconButton: true,
    ImageList: true,
    ImageListItem: true,
    ImageListItemBar: true,
    Input: true,
    InputAdornment: true,
    InputBase: true,
    InputLabel: true,
    LinearProgress: true,
    Link: true,
    List: true,
    ListItem: true,
    ListItemAvatar: true,
    ListItemButton: true,
    ListItemIcon: true,
    ListItemSecondaryAction: true,
    ListItemText: true,
    ListSubheader: true,
    Menu: true,
    MenuItem: true,
    MenuList: true,
    MobileStepper: true,
    Modal: true,
    NativeSelect: true,
    NoSsr: true,
    OutlinedInput: true,
    Pagination: true,
    PaginationItem: true,
    Paper: true,
    Popover: true,
    Popper: true,
    Portal: true,
    Radio: true,
    RadioGroup: true,
    Rating: true,
    ScopedCssBaseline: true,
    Select: true,
    Skeleton: true,
    Slide: true,
    Slider: true,
    Snackbar: true,
    SnackbarContent: true,
    SpeedDial: true,
    SpeedDialAction: true,
    SpeedDialIcon: true,
    Stack: true,
    Step: true,
    StepButton: true,
    StepConnector: true,
    StepContent: true,
    StepIcon: true,
    StepLabel: true,
    Stepper: true,
    SvgIcon: true,
    SwipeableDrawer: true,
    Switch: true,
    Tab: true,
    Table: true,
    TableBody: true,
    TableCell: true,
    TableContainer: true,
    TableFooter: true,
    TableHead: true,
    TablePagination: true,
    TablePaginationActions: true,
    TableRow: true,
    TableSortLabel: true,
    Tabs: true,
    TabScrollButton: true,
    TextField: true,
    TextareaAutosize: true,
    ToggleButton: true,
    ToggleButtonGroup: true,
    Toolbar: true,
    Tooltip: true,
    Typography: true,
    useMediaQuery: true,
    usePagination: true,
    useScrollTrigger: true,
    Zoom: true,
    useAutocomplete: true,
    GlobalStyles: true,
    unstable_composeClasses: true,
    generateUtilityClass: true,
    generateUtilityClasses: true,
    Unstable_TrapFocus: true,
    InitColorSchemeScript: true
};
Object.defineProperty(module.exports, "Accordion", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Accordion.default;
    }
});
Object.defineProperty(module.exports, "AccordionActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AccordionActions.default;
    }
});
Object.defineProperty(module.exports, "AccordionDetails", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AccordionDetails.default;
    }
});
Object.defineProperty(module.exports, "AccordionSummary", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AccordionSummary.default;
    }
});
Object.defineProperty(module.exports, "Alert", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Alert.default;
    }
});
Object.defineProperty(module.exports, "AlertTitle", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AlertTitle.default;
    }
});
Object.defineProperty(module.exports, "AppBar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AppBar.default;
    }
});
Object.defineProperty(module.exports, "Autocomplete", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Autocomplete.default;
    }
});
Object.defineProperty(module.exports, "Avatar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Avatar.default;
    }
});
Object.defineProperty(module.exports, "AvatarGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_AvatarGroup.default;
    }
});
Object.defineProperty(module.exports, "Backdrop", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Backdrop.default;
    }
});
Object.defineProperty(module.exports, "Badge", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Badge.default;
    }
});
Object.defineProperty(module.exports, "BottomNavigation", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_BottomNavigation.default;
    }
});
Object.defineProperty(module.exports, "BottomNavigationAction", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_BottomNavigationAction.default;
    }
});
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Box.default;
    }
});
Object.defineProperty(module.exports, "Breadcrumbs", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Breadcrumbs.default;
    }
});
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Button.default;
    }
});
Object.defineProperty(module.exports, "ButtonBase", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ButtonBase.default;
    }
});
Object.defineProperty(module.exports, "ButtonGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ButtonGroup.default;
    }
});
Object.defineProperty(module.exports, "Card", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Card.default;
    }
});
Object.defineProperty(module.exports, "CardActionArea", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardActionArea.default;
    }
});
Object.defineProperty(module.exports, "CardActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardActions.default;
    }
});
Object.defineProperty(module.exports, "CardContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardContent.default;
    }
});
Object.defineProperty(module.exports, "CardHeader", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardHeader.default;
    }
});
Object.defineProperty(module.exports, "CardMedia", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CardMedia.default;
    }
});
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Checkbox.default;
    }
});
Object.defineProperty(module.exports, "Chip", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Chip.default;
    }
});
Object.defineProperty(module.exports, "CircularProgress", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CircularProgress.default;
    }
});
Object.defineProperty(module.exports, "ClickAwayListener", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ClickAwayListener.default;
    }
});
Object.defineProperty(module.exports, "Collapse", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Collapse.default;
    }
});
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Container.default;
    }
});
Object.defineProperty(module.exports, "CssBaseline", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_CssBaseline.default;
    }
});
Object.defineProperty(module.exports, "Dialog", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Dialog.default;
    }
});
Object.defineProperty(module.exports, "DialogActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogActions.default;
    }
});
Object.defineProperty(module.exports, "DialogContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogContent.default;
    }
});
Object.defineProperty(module.exports, "DialogContentText", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogContentText.default;
    }
});
Object.defineProperty(module.exports, "DialogTitle", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_DialogTitle.default;
    }
});
Object.defineProperty(module.exports, "Divider", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Divider.default;
    }
});
Object.defineProperty(module.exports, "Drawer", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Drawer.default;
    }
});
Object.defineProperty(module.exports, "Fab", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Fab.default;
    }
});
Object.defineProperty(module.exports, "Fade", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Fade.default;
    }
});
Object.defineProperty(module.exports, "FilledInput", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FilledInput.default;
    }
});
Object.defineProperty(module.exports, "FormControl", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormControl.default;
    }
});
Object.defineProperty(module.exports, "FormControlLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormControlLabel.default;
    }
});
Object.defineProperty(module.exports, "FormGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormGroup.default;
    }
});
Object.defineProperty(module.exports, "FormHelperText", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormHelperText.default;
    }
});
Object.defineProperty(module.exports, "FormLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_FormLabel.default;
    }
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "GridLegacy", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_GridLegacy.default;
    }
});
Object.defineProperty(module.exports, "Grow", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Grow.default;
    }
});
Object.defineProperty(module.exports, "Icon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Icon.default;
    }
});
Object.defineProperty(module.exports, "IconButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_IconButton.default;
    }
});
Object.defineProperty(module.exports, "ImageList", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ImageList.default;
    }
});
Object.defineProperty(module.exports, "ImageListItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ImageListItem.default;
    }
});
Object.defineProperty(module.exports, "ImageListItemBar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ImageListItemBar.default;
    }
});
Object.defineProperty(module.exports, "InitColorSchemeScript", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InitColorSchemeScript.default;
    }
});
Object.defineProperty(module.exports, "Input", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Input.default;
    }
});
Object.defineProperty(module.exports, "InputAdornment", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InputAdornment.default;
    }
});
Object.defineProperty(module.exports, "InputBase", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InputBase.default;
    }
});
Object.defineProperty(module.exports, "InputLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_InputLabel.default;
    }
});
Object.defineProperty(module.exports, "LinearProgress", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_LinearProgress.default;
    }
});
Object.defineProperty(module.exports, "Link", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Link.default;
    }
});
Object.defineProperty(module.exports, "List", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_List.default;
    }
});
Object.defineProperty(module.exports, "ListItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItem.default;
    }
});
Object.defineProperty(module.exports, "ListItemAvatar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemAvatar.default;
    }
});
Object.defineProperty(module.exports, "ListItemButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemButton.default;
    }
});
Object.defineProperty(module.exports, "ListItemIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemIcon.default;
    }
});
Object.defineProperty(module.exports, "ListItemSecondaryAction", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemSecondaryAction.default;
    }
});
Object.defineProperty(module.exports, "ListItemText", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListItemText.default;
    }
});
Object.defineProperty(module.exports, "ListSubheader", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ListSubheader.default;
    }
});
Object.defineProperty(module.exports, "Menu", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Menu.default;
    }
});
Object.defineProperty(module.exports, "MenuItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_MenuItem.default;
    }
});
Object.defineProperty(module.exports, "MenuList", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_MenuList.default;
    }
});
Object.defineProperty(module.exports, "MobileStepper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_MobileStepper.default;
    }
});
Object.defineProperty(module.exports, "Modal", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Modal.default;
    }
});
Object.defineProperty(module.exports, "NativeSelect", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_NativeSelect.default;
    }
});
Object.defineProperty(module.exports, "NoSsr", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_NoSsr.default;
    }
});
Object.defineProperty(module.exports, "OutlinedInput", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_OutlinedInput.default;
    }
});
Object.defineProperty(module.exports, "Pagination", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Pagination.default;
    }
});
Object.defineProperty(module.exports, "PaginationItem", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_PaginationItem.default;
    }
});
Object.defineProperty(module.exports, "Paper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Paper.default;
    }
});
Object.defineProperty(module.exports, "Popover", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Popover.default;
    }
});
Object.defineProperty(module.exports, "Popper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Popper.default;
    }
});
Object.defineProperty(module.exports, "Portal", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Portal.default;
    }
});
Object.defineProperty(module.exports, "Radio", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Radio.default;
    }
});
Object.defineProperty(module.exports, "RadioGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_RadioGroup.default;
    }
});
Object.defineProperty(module.exports, "Rating", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Rating.default;
    }
});
Object.defineProperty(module.exports, "ScopedCssBaseline", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ScopedCssBaseline.default;
    }
});
Object.defineProperty(module.exports, "Select", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Select.default;
    }
});
Object.defineProperty(module.exports, "Skeleton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Skeleton.default;
    }
});
Object.defineProperty(module.exports, "Slide", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Slide.default;
    }
});
Object.defineProperty(module.exports, "Slider", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Slider.default;
    }
});
Object.defineProperty(module.exports, "Snackbar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Snackbar.default;
    }
});
Object.defineProperty(module.exports, "SnackbarContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SnackbarContent.default;
    }
});
Object.defineProperty(module.exports, "SpeedDial", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SpeedDial.default;
    }
});
Object.defineProperty(module.exports, "SpeedDialAction", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SpeedDialAction.default;
    }
});
Object.defineProperty(module.exports, "SpeedDialIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SpeedDialIcon.default;
    }
});
Object.defineProperty(module.exports, "Stack", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "Step", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Step.default;
    }
});
Object.defineProperty(module.exports, "StepButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepButton.default;
    }
});
Object.defineProperty(module.exports, "StepConnector", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepConnector.default;
    }
});
Object.defineProperty(module.exports, "StepContent", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepContent.default;
    }
});
Object.defineProperty(module.exports, "StepIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepIcon.default;
    }
});
Object.defineProperty(module.exports, "StepLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_StepLabel.default;
    }
});
Object.defineProperty(module.exports, "Stepper", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Stepper.default;
    }
});
Object.defineProperty(module.exports, "SvgIcon", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SvgIcon.default;
    }
});
Object.defineProperty(module.exports, "SwipeableDrawer", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_SwipeableDrawer.default;
    }
});
Object.defineProperty(module.exports, "Switch", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Switch.default;
    }
});
Object.defineProperty(module.exports, "Tab", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Tab.default;
    }
});
Object.defineProperty(module.exports, "TabScrollButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TabScrollButton.default;
    }
});
Object.defineProperty(module.exports, "Table", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Table.default;
    }
});
Object.defineProperty(module.exports, "TableBody", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableBody.default;
    }
});
Object.defineProperty(module.exports, "TableCell", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableCell.default;
    }
});
Object.defineProperty(module.exports, "TableContainer", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableContainer.default;
    }
});
Object.defineProperty(module.exports, "TableFooter", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableFooter.default;
    }
});
Object.defineProperty(module.exports, "TableHead", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableHead.default;
    }
});
Object.defineProperty(module.exports, "TablePagination", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TablePagination.default;
    }
});
Object.defineProperty(module.exports, "TablePaginationActions", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TablePaginationActions.default;
    }
});
Object.defineProperty(module.exports, "TableRow", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableRow.default;
    }
});
Object.defineProperty(module.exports, "TableSortLabel", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TableSortLabel.default;
    }
});
Object.defineProperty(module.exports, "Tabs", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Tabs.default;
    }
});
Object.defineProperty(module.exports, "TextField", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TextField.default;
    }
});
Object.defineProperty(module.exports, "TextareaAutosize", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_TextareaAutosize.default;
    }
});
Object.defineProperty(module.exports, "ToggleButton", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ToggleButton.default;
    }
});
Object.defineProperty(module.exports, "ToggleButtonGroup", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_ToggleButtonGroup.default;
    }
});
Object.defineProperty(module.exports, "Toolbar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Toolbar.default;
    }
});
Object.defineProperty(module.exports, "Tooltip", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Tooltip.default;
    }
});
Object.defineProperty(module.exports, "Typography", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Typography.default;
    }
});
Object.defineProperty(module.exports, "Unstable_TrapFocus", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Unstable_TrapFocus.default;
    }
});
Object.defineProperty(module.exports, "Zoom", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_Zoom.default;
    }
});
module.exports.colors = void 0;
Object.defineProperty(module.exports, "darkScrollbar", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_darkScrollbar.default;
    }
});
Object.defineProperty(module.exports, "generateUtilityClass", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_generateUtilityClass.default;
    }
});
Object.defineProperty(module.exports, "generateUtilityClasses", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_generateUtilityClasses.default;
    }
});
Object.defineProperty(module.exports, "unstable_composeClasses", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_composeClasses.default;
    }
});
Object.defineProperty(module.exports, "useAutocomplete", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_useAutocomplete.default;
    }
});
Object.defineProperty(module.exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_useMediaQuery.default;
    }
});
Object.defineProperty(module.exports, "usePagination", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_usePagination.default;
    }
});
Object.defineProperty(module.exports, "useScrollTrigger", {
    enumerable: true,
    get: function() {
        return $91a4e72629291447$var$_useScrollTrigger.default;
    }
});

var $91a4e72629291447$var$colors = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2PSrq")));
module.exports.colors = $91a4e72629291447$var$colors;

var $8xDHs = parcelRequire("8xDHs");
Object.keys($8xDHs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8xDHs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8xDHs[key];
        }
    });
});

var $hGPki = parcelRequire("hGPki");
Object.keys($hGPki).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hGPki[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hGPki[key];
        }
    });
});

var $91a4e72629291447$var$_Accordion = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lH1DK")));
Object.keys($91a4e72629291447$var$_Accordion).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Accordion[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Accordion[key];
        }
    });
});

var $91a4e72629291447$var$_AccordionActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("qjHPG")));
Object.keys($91a4e72629291447$var$_AccordionActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_AccordionActions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AccordionActions[key];
        }
    });
});

var $91a4e72629291447$var$_AccordionDetails = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e5H02")));
Object.keys($91a4e72629291447$var$_AccordionDetails).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_AccordionDetails[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AccordionDetails[key];
        }
    });
});

var $91a4e72629291447$var$_AccordionSummary = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6QcED")));
Object.keys($91a4e72629291447$var$_AccordionSummary).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_AccordionSummary[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AccordionSummary[key];
        }
    });
});

var $91a4e72629291447$var$_Alert = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("16wD6")));
Object.keys($91a4e72629291447$var$_Alert).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Alert[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Alert[key];
        }
    });
});

var $91a4e72629291447$var$_AlertTitle = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bkkWw")));
Object.keys($91a4e72629291447$var$_AlertTitle).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_AlertTitle[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AlertTitle[key];
        }
    });
});

var $91a4e72629291447$var$_AppBar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kvdH6")));
Object.keys($91a4e72629291447$var$_AppBar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_AppBar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AppBar[key];
        }
    });
});

var $91a4e72629291447$var$_Autocomplete = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aBB4t")));
Object.keys($91a4e72629291447$var$_Autocomplete).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Autocomplete[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Autocomplete[key];
        }
    });
});

var $91a4e72629291447$var$_Avatar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kpeRy")));
Object.keys($91a4e72629291447$var$_Avatar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Avatar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Avatar[key];
        }
    });
});

var $91a4e72629291447$var$_AvatarGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aHDU0")));
Object.keys($91a4e72629291447$var$_AvatarGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_AvatarGroup[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_AvatarGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Backdrop = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bXwVR")));
Object.keys($91a4e72629291447$var$_Backdrop).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Backdrop[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Backdrop[key];
        }
    });
});

var $91a4e72629291447$var$_Badge = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lgIyK")));
Object.keys($91a4e72629291447$var$_Badge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Badge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Badge[key];
        }
    });
});

var $91a4e72629291447$var$_BottomNavigation = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("jIzBR")));
Object.keys($91a4e72629291447$var$_BottomNavigation).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_BottomNavigation[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_BottomNavigation[key];
        }
    });
});

var $91a4e72629291447$var$_BottomNavigationAction = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e9QPA")));
Object.keys($91a4e72629291447$var$_BottomNavigationAction).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_BottomNavigationAction[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_BottomNavigationAction[key];
        }
    });
});

var $91a4e72629291447$var$_Box = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e5o5x")));
Object.keys($91a4e72629291447$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Box[key];
        }
    });
});

var $91a4e72629291447$var$_Breadcrumbs = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("63l7x")));
Object.keys($91a4e72629291447$var$_Breadcrumbs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Breadcrumbs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Breadcrumbs[key];
        }
    });
});

var $91a4e72629291447$var$_Button = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bBQKz")));
Object.keys($91a4e72629291447$var$_Button).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Button[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Button[key];
        }
    });
});

var $91a4e72629291447$var$_ButtonBase = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hhs3r")));
Object.keys($91a4e72629291447$var$_ButtonBase).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ButtonBase[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ButtonBase[key];
        }
    });
});

var $91a4e72629291447$var$_ButtonGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8Jh2o")));
Object.keys($91a4e72629291447$var$_ButtonGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ButtonGroup[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ButtonGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Card = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3HHKi")));
Object.keys($91a4e72629291447$var$_Card).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Card[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Card[key];
        }
    });
});

var $91a4e72629291447$var$_CardActionArea = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kIb8C")));
Object.keys($91a4e72629291447$var$_CardActionArea).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CardActionArea[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardActionArea[key];
        }
    });
});

var $91a4e72629291447$var$_CardActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("Hi2UE")));
Object.keys($91a4e72629291447$var$_CardActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CardActions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardActions[key];
        }
    });
});

var $91a4e72629291447$var$_CardContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lQHMI")));
Object.keys($91a4e72629291447$var$_CardContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CardContent[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardContent[key];
        }
    });
});

var $91a4e72629291447$var$_CardHeader = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4DqKh")));
Object.keys($91a4e72629291447$var$_CardHeader).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CardHeader[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardHeader[key];
        }
    });
});

var $91a4e72629291447$var$_CardMedia = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("epQZV")));
Object.keys($91a4e72629291447$var$_CardMedia).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CardMedia[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CardMedia[key];
        }
    });
});

var $91a4e72629291447$var$_Checkbox = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aGDqy")));
Object.keys($91a4e72629291447$var$_Checkbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Checkbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Checkbox[key];
        }
    });
});

var $91a4e72629291447$var$_Chip = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6p5K7")));
Object.keys($91a4e72629291447$var$_Chip).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Chip[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Chip[key];
        }
    });
});

var $91a4e72629291447$var$_CircularProgress = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1sBf1")));
Object.keys($91a4e72629291447$var$_CircularProgress).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CircularProgress[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CircularProgress[key];
        }
    });
});

var $91a4e72629291447$var$_ClickAwayListener = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7Ke9B")));
Object.keys($91a4e72629291447$var$_ClickAwayListener).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ClickAwayListener[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ClickAwayListener[key];
        }
    });
});

var $91a4e72629291447$var$_Collapse = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("gsEuH")));
Object.keys($91a4e72629291447$var$_Collapse).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Collapse[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Collapse[key];
        }
    });
});

var $91a4e72629291447$var$_Container = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("9GQ55")));
Object.keys($91a4e72629291447$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Container[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Container[key];
        }
    });
});

var $91a4e72629291447$var$_CssBaseline = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bl1Nj")));
Object.keys($91a4e72629291447$var$_CssBaseline).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_CssBaseline[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_CssBaseline[key];
        }
    });
});

var $91a4e72629291447$var$_darkScrollbar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4tB5n")));
Object.keys($91a4e72629291447$var$_darkScrollbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_darkScrollbar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_darkScrollbar[key];
        }
    });
});

var $91a4e72629291447$var$_Dialog = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iZIMH")));
Object.keys($91a4e72629291447$var$_Dialog).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Dialog[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Dialog[key];
        }
    });
});

var $91a4e72629291447$var$_DialogActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("l5BZB")));
Object.keys($91a4e72629291447$var$_DialogActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_DialogActions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogActions[key];
        }
    });
});

var $91a4e72629291447$var$_DialogContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hJoSv")));
Object.keys($91a4e72629291447$var$_DialogContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_DialogContent[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogContent[key];
        }
    });
});

var $91a4e72629291447$var$_DialogContentText = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("aX9Qs")));
Object.keys($91a4e72629291447$var$_DialogContentText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_DialogContentText[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogContentText[key];
        }
    });
});

var $91a4e72629291447$var$_DialogTitle = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lIycJ")));
Object.keys($91a4e72629291447$var$_DialogTitle).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_DialogTitle[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_DialogTitle[key];
        }
    });
});

var $91a4e72629291447$var$_Divider = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("g6BeY")));
Object.keys($91a4e72629291447$var$_Divider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Divider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Divider[key];
        }
    });
});

var $91a4e72629291447$var$_Drawer = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cPtMf")));
Object.keys($91a4e72629291447$var$_Drawer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Drawer[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Drawer[key];
        }
    });
});

var $91a4e72629291447$var$_Fab = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2r6m0")));
Object.keys($91a4e72629291447$var$_Fab).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Fab[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Fab[key];
        }
    });
});

var $91a4e72629291447$var$_Fade = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5iZHj")));
Object.keys($91a4e72629291447$var$_Fade).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Fade[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Fade[key];
        }
    });
});

var $91a4e72629291447$var$_FilledInput = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hE2RV")));
Object.keys($91a4e72629291447$var$_FilledInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_FilledInput[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FilledInput[key];
        }
    });
});

var $91a4e72629291447$var$_FormControl = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iA4iQ")));
Object.keys($91a4e72629291447$var$_FormControl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_FormControl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormControl[key];
        }
    });
});

var $91a4e72629291447$var$_FormControlLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("i48ne")));
Object.keys($91a4e72629291447$var$_FormControlLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_FormControlLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormControlLabel[key];
        }
    });
});

var $91a4e72629291447$var$_FormGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("buuiu")));
Object.keys($91a4e72629291447$var$_FormGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_FormGroup[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormGroup[key];
        }
    });
});

var $91a4e72629291447$var$_FormHelperText = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4xkW2")));
Object.keys($91a4e72629291447$var$_FormHelperText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_FormHelperText[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormHelperText[key];
        }
    });
});

var $91a4e72629291447$var$_FormLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("d7nZ1")));
Object.keys($91a4e72629291447$var$_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_FormLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_FormLabel[key];
        }
    });
});

var $91a4e72629291447$var$_GridLegacy = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("jNkhK")));

var $91a4e72629291447$var$_Grid = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7Zchb")));
Object.keys($91a4e72629291447$var$_Grid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Grid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Grid[key];
        }
    });
});

var $91a4e72629291447$var$_Grow = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6dJ4n")));
Object.keys($91a4e72629291447$var$_Grow).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Grow[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Grow[key];
        }
    });
});

var $91a4e72629291447$var$_Icon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3IKLG")));
Object.keys($91a4e72629291447$var$_Icon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Icon[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Icon[key];
        }
    });
});

var $91a4e72629291447$var$_IconButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("825Zh")));
Object.keys($91a4e72629291447$var$_IconButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_IconButton[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_IconButton[key];
        }
    });
});

var $91a4e72629291447$var$_ImageList = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dGTe0")));
Object.keys($91a4e72629291447$var$_ImageList).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ImageList[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ImageList[key];
        }
    });
});

var $91a4e72629291447$var$_ImageListItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cJR6h")));
Object.keys($91a4e72629291447$var$_ImageListItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ImageListItem[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ImageListItem[key];
        }
    });
});

var $91a4e72629291447$var$_ImageListItemBar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2yXyU")));
Object.keys($91a4e72629291447$var$_ImageListItemBar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ImageListItemBar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ImageListItemBar[key];
        }
    });
});

var $91a4e72629291447$var$_Input = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("eAJp9")));
Object.keys($91a4e72629291447$var$_Input).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Input[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Input[key];
        }
    });
});

var $91a4e72629291447$var$_InputAdornment = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("9bswS")));
Object.keys($91a4e72629291447$var$_InputAdornment).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_InputAdornment[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_InputAdornment[key];
        }
    });
});

var $91a4e72629291447$var$_InputBase = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("9MvHs")));
Object.keys($91a4e72629291447$var$_InputBase).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_InputBase[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_InputBase[key];
        }
    });
});

var $91a4e72629291447$var$_InputLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("k9xmz")));
Object.keys($91a4e72629291447$var$_InputLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_InputLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_InputLabel[key];
        }
    });
});

var $91a4e72629291447$var$_LinearProgress = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2vsem")));
Object.keys($91a4e72629291447$var$_LinearProgress).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_LinearProgress[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_LinearProgress[key];
        }
    });
});

var $91a4e72629291447$var$_Link = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("fyPI4")));
Object.keys($91a4e72629291447$var$_Link).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Link[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Link[key];
        }
    });
});

var $91a4e72629291447$var$_List = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("ib3g2")));
Object.keys($91a4e72629291447$var$_List).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_List[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_List[key];
        }
    });
});

var $91a4e72629291447$var$_ListItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hOLYA")));
Object.keys($91a4e72629291447$var$_ListItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListItem[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItem[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemAvatar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6HgAC")));
Object.keys($91a4e72629291447$var$_ListItemAvatar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListItemAvatar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemAvatar[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iVzhN")));
Object.keys($91a4e72629291447$var$_ListItemButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListItemButton[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemButton[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2fe4K")));
Object.keys($91a4e72629291447$var$_ListItemIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListItemIcon[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemIcon[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemSecondaryAction = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("4LntB")));
Object.keys($91a4e72629291447$var$_ListItemSecondaryAction).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListItemSecondaryAction[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemSecondaryAction[key];
        }
    });
});

var $91a4e72629291447$var$_ListItemText = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("djLZl")));
Object.keys($91a4e72629291447$var$_ListItemText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListItemText[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListItemText[key];
        }
    });
});

var $91a4e72629291447$var$_ListSubheader = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1hfjF")));
Object.keys($91a4e72629291447$var$_ListSubheader).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ListSubheader[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ListSubheader[key];
        }
    });
});

var $91a4e72629291447$var$_Menu = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kCnQI")));
Object.keys($91a4e72629291447$var$_Menu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Menu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Menu[key];
        }
    });
});

var $91a4e72629291447$var$_MenuItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("iZ4W7")));
Object.keys($91a4e72629291447$var$_MenuItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_MenuItem[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_MenuItem[key];
        }
    });
});

var $91a4e72629291447$var$_MenuList = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8qqwQ")));
Object.keys($91a4e72629291447$var$_MenuList).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_MenuList[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_MenuList[key];
        }
    });
});

var $91a4e72629291447$var$_MobileStepper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1e1yc")));
Object.keys($91a4e72629291447$var$_MobileStepper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_MobileStepper[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_MobileStepper[key];
        }
    });
});

var $91a4e72629291447$var$_Modal = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8vVVd")));
Object.keys($91a4e72629291447$var$_Modal).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Modal[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Modal[key];
        }
    });
});

var $91a4e72629291447$var$_NativeSelect = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("24k8B")));
Object.keys($91a4e72629291447$var$_NativeSelect).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_NativeSelect[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_NativeSelect[key];
        }
    });
});

var $91a4e72629291447$var$_NoSsr = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cQC3m")));
Object.keys($91a4e72629291447$var$_NoSsr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_NoSsr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_NoSsr[key];
        }
    });
});

var $91a4e72629291447$var$_OutlinedInput = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("in82R")));
Object.keys($91a4e72629291447$var$_OutlinedInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_OutlinedInput[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_OutlinedInput[key];
        }
    });
});

var $91a4e72629291447$var$_Pagination = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lAj4Z")));
Object.keys($91a4e72629291447$var$_Pagination).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Pagination[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Pagination[key];
        }
    });
});

var $91a4e72629291447$var$_PaginationItem = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5SUZl")));
Object.keys($91a4e72629291447$var$_PaginationItem).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_PaginationItem[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_PaginationItem[key];
        }
    });
});

var $91a4e72629291447$var$_Paper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("juRJQ")));
Object.keys($91a4e72629291447$var$_Paper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Paper[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Paper[key];
        }
    });
});

var $91a4e72629291447$var$_Popover = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("32yuL")));
Object.keys($91a4e72629291447$var$_Popover).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Popover[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Popover[key];
        }
    });
});

var $91a4e72629291447$var$_Popper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("eWJe7")));
Object.keys($91a4e72629291447$var$_Popper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Popper[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Popper[key];
        }
    });
});

var $91a4e72629291447$var$_Portal = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cJgE8")));
Object.keys($91a4e72629291447$var$_Portal).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Portal[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Portal[key];
        }
    });
});

var $91a4e72629291447$var$_Radio = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5Gk0e")));
Object.keys($91a4e72629291447$var$_Radio).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Radio[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Radio[key];
        }
    });
});

var $91a4e72629291447$var$_RadioGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("31l3D")));
Object.keys($91a4e72629291447$var$_RadioGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_RadioGroup[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_RadioGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Rating = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lNr9b")));
Object.keys($91a4e72629291447$var$_Rating).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Rating[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Rating[key];
        }
    });
});

var $91a4e72629291447$var$_ScopedCssBaseline = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("ePchM")));
Object.keys($91a4e72629291447$var$_ScopedCssBaseline).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ScopedCssBaseline[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ScopedCssBaseline[key];
        }
    });
});

var $91a4e72629291447$var$_Select = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dALxx")));
Object.keys($91a4e72629291447$var$_Select).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Select[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Select[key];
        }
    });
});

var $91a4e72629291447$var$_Skeleton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("eTbCT")));
Object.keys($91a4e72629291447$var$_Skeleton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Skeleton[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Skeleton[key];
        }
    });
});

var $91a4e72629291447$var$_Slide = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bQRpD")));
Object.keys($91a4e72629291447$var$_Slide).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Slide[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Slide[key];
        }
    });
});

var $91a4e72629291447$var$_Slider = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("1WNCH")));
Object.keys($91a4e72629291447$var$_Slider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Slider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Slider[key];
        }
    });
});

var $91a4e72629291447$var$_Snackbar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b3tNC")));
Object.keys($91a4e72629291447$var$_Snackbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Snackbar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Snackbar[key];
        }
    });
});

var $91a4e72629291447$var$_SnackbarContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8BKxX")));
Object.keys($91a4e72629291447$var$_SnackbarContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_SnackbarContent[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SnackbarContent[key];
        }
    });
});

var $91a4e72629291447$var$_SpeedDial = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kqAaP")));
Object.keys($91a4e72629291447$var$_SpeedDial).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_SpeedDial[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SpeedDial[key];
        }
    });
});

var $91a4e72629291447$var$_SpeedDialAction = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2Pq3d")));
Object.keys($91a4e72629291447$var$_SpeedDialAction).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_SpeedDialAction[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SpeedDialAction[key];
        }
    });
});

var $91a4e72629291447$var$_SpeedDialIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6LxK9")));
Object.keys($91a4e72629291447$var$_SpeedDialIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_SpeedDialIcon[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SpeedDialIcon[key];
        }
    });
});

var $91a4e72629291447$var$_Stack = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("jkhql")));
Object.keys($91a4e72629291447$var$_Stack).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Stack[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Stack[key];
        }
    });
});

var $91a4e72629291447$var$_Step = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("fxSW4")));
Object.keys($91a4e72629291447$var$_Step).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Step[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Step[key];
        }
    });
});

var $91a4e72629291447$var$_StepButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("k1pY1")));
Object.keys($91a4e72629291447$var$_StepButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_StepButton[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepButton[key];
        }
    });
});

var $91a4e72629291447$var$_StepConnector = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("jjQoZ")));
Object.keys($91a4e72629291447$var$_StepConnector).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_StepConnector[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepConnector[key];
        }
    });
});

var $91a4e72629291447$var$_StepContent = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b3U7M")));
Object.keys($91a4e72629291447$var$_StepContent).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_StepContent[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepContent[key];
        }
    });
});

var $91a4e72629291447$var$_StepIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2K1qt")));
Object.keys($91a4e72629291447$var$_StepIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_StepIcon[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepIcon[key];
        }
    });
});

var $91a4e72629291447$var$_StepLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("cD4Pq")));
Object.keys($91a4e72629291447$var$_StepLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_StepLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_StepLabel[key];
        }
    });
});

var $91a4e72629291447$var$_Stepper = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5kBLW")));
Object.keys($91a4e72629291447$var$_Stepper).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Stepper[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Stepper[key];
        }
    });
});

var $91a4e72629291447$var$_SvgIcon = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("loOwp")));
Object.keys($91a4e72629291447$var$_SvgIcon).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_SvgIcon[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SvgIcon[key];
        }
    });
});

var $91a4e72629291447$var$_SwipeableDrawer = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("fuux0")));
Object.keys($91a4e72629291447$var$_SwipeableDrawer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_SwipeableDrawer[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_SwipeableDrawer[key];
        }
    });
});

var $91a4e72629291447$var$_Switch = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5QQ7K")));
Object.keys($91a4e72629291447$var$_Switch).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Switch[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Switch[key];
        }
    });
});

var $91a4e72629291447$var$_Tab = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("90blG")));
Object.keys($91a4e72629291447$var$_Tab).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Tab[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Tab[key];
        }
    });
});

var $91a4e72629291447$var$_Table = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("bGe9g")));
Object.keys($91a4e72629291447$var$_Table).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Table[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Table[key];
        }
    });
});

var $91a4e72629291447$var$_TableBody = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("5hLrb")));
Object.keys($91a4e72629291447$var$_TableBody).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableBody[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableBody[key];
        }
    });
});

var $91a4e72629291447$var$_TableCell = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hjoMW")));
Object.keys($91a4e72629291447$var$_TableCell).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableCell[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableCell[key];
        }
    });
});

var $91a4e72629291447$var$_TableContainer = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("12YAp")));
Object.keys($91a4e72629291447$var$_TableContainer).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableContainer[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableContainer[key];
        }
    });
});

var $91a4e72629291447$var$_TableFooter = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7fYtl")));
Object.keys($91a4e72629291447$var$_TableFooter).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableFooter[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableFooter[key];
        }
    });
});

var $91a4e72629291447$var$_TableHead = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("g2Lhl")));
Object.keys($91a4e72629291447$var$_TableHead).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableHead[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableHead[key];
        }
    });
});

var $91a4e72629291447$var$_TablePagination = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b3HhA")));
Object.keys($91a4e72629291447$var$_TablePagination).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TablePagination[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TablePagination[key];
        }
    });
});

var $91a4e72629291447$var$_TablePaginationActions = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("lqVz5")));
Object.keys($91a4e72629291447$var$_TablePaginationActions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TablePaginationActions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TablePaginationActions[key];
        }
    });
});

var $91a4e72629291447$var$_TableRow = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("7IILB")));
Object.keys($91a4e72629291447$var$_TableRow).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableRow[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableRow[key];
        }
    });
});

var $91a4e72629291447$var$_TableSortLabel = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("Zain6")));
Object.keys($91a4e72629291447$var$_TableSortLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TableSortLabel[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TableSortLabel[key];
        }
    });
});

var $91a4e72629291447$var$_Tabs = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dKcJh")));
Object.keys($91a4e72629291447$var$_Tabs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Tabs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Tabs[key];
        }
    });
});

var $91a4e72629291447$var$_TabScrollButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("b1hEL")));
Object.keys($91a4e72629291447$var$_TabScrollButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TabScrollButton[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TabScrollButton[key];
        }
    });
});

var $91a4e72629291447$var$_TextField = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("hABDe")));
Object.keys($91a4e72629291447$var$_TextField).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TextField[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TextField[key];
        }
    });
});

var $91a4e72629291447$var$_TextareaAutosize = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3vH0x")));
Object.keys($91a4e72629291447$var$_TextareaAutosize).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_TextareaAutosize[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_TextareaAutosize[key];
        }
    });
});

var $91a4e72629291447$var$_ToggleButton = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("xwCPt")));
Object.keys($91a4e72629291447$var$_ToggleButton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ToggleButton[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ToggleButton[key];
        }
    });
});

var $91a4e72629291447$var$_ToggleButtonGroup = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("6GVj6")));
Object.keys($91a4e72629291447$var$_ToggleButtonGroup).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_ToggleButtonGroup[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_ToggleButtonGroup[key];
        }
    });
});

var $91a4e72629291447$var$_Toolbar = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dfjP7")));
Object.keys($91a4e72629291447$var$_Toolbar).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Toolbar[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Toolbar[key];
        }
    });
});

var $91a4e72629291447$var$_Tooltip = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("tEWAm")));
Object.keys($91a4e72629291447$var$_Tooltip).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Tooltip[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Tooltip[key];
        }
    });
});

var $91a4e72629291447$var$_Typography = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("2dUd7")));
Object.keys($91a4e72629291447$var$_Typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Typography[key];
        }
    });
});

var $91a4e72629291447$var$_useMediaQuery = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("18tt9")));
Object.keys($91a4e72629291447$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_useMediaQuery[key];
        }
    });
});

var $91a4e72629291447$var$_usePagination = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("8WIPv")));
Object.keys($91a4e72629291447$var$_usePagination).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_usePagination[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_usePagination[key];
        }
    });
});

var $91a4e72629291447$var$_useScrollTrigger = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("dL2y2")));
Object.keys($91a4e72629291447$var$_useScrollTrigger).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_useScrollTrigger[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_useScrollTrigger[key];
        }
    });
});

var $91a4e72629291447$var$_Zoom = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("3uqi7")));
Object.keys($91a4e72629291447$var$_Zoom).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_Zoom[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_Zoom[key];
        }
    });
});

var $91a4e72629291447$var$_useAutocomplete = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("g924V")));

var $91a4e72629291447$var$_GlobalStyles = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("kjVW8")));
Object.keys($91a4e72629291447$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_GlobalStyles[key];
        }
    });
});

var $91a4e72629291447$var$_composeClasses = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $91a4e72629291447$var$_generateUtilityClass = $91a4e72629291447$require$_interopRequireWildcard((parcelRequire("e9Nv0")));
Object.keys($91a4e72629291447$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91a4e72629291447$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91a4e72629291447$var$_generateUtilityClass[key];
        }
    });
});

var $91a4e72629291447$var$_generateUtilityClasses = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("c2K5x")));

var $91a4e72629291447$var$_Unstable_TrapFocus = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("c94Y8")));

var $ePguI = parcelRequire("ePguI");
Object.keys($ePguI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91a4e72629291447$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ePguI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ePguI[key];
        }
    });
});

var $91a4e72629291447$var$_InitColorSchemeScript = $91a4e72629291447$require$_interopRequireDefault((parcelRequire("2bNdG")));

});
parcelRegister("2PSrq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $210a9320270ce251$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "amber", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_amber.default;
    }
});
Object.defineProperty(module.exports, "blue", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_blue.default;
    }
});
Object.defineProperty(module.exports, "blueGrey", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_blueGrey.default;
    }
});
Object.defineProperty(module.exports, "brown", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_brown.default;
    }
});
Object.defineProperty(module.exports, "common", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_common.default;
    }
});
Object.defineProperty(module.exports, "cyan", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_cyan.default;
    }
});
Object.defineProperty(module.exports, "deepOrange", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_deepOrange.default;
    }
});
Object.defineProperty(module.exports, "deepPurple", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_deepPurple.default;
    }
});
Object.defineProperty(module.exports, "green", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_green.default;
    }
});
Object.defineProperty(module.exports, "grey", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_grey.default;
    }
});
Object.defineProperty(module.exports, "indigo", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_indigo.default;
    }
});
Object.defineProperty(module.exports, "lightBlue", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_lightBlue.default;
    }
});
Object.defineProperty(module.exports, "lightGreen", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_lightGreen.default;
    }
});
Object.defineProperty(module.exports, "lime", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_lime.default;
    }
});
Object.defineProperty(module.exports, "orange", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_orange.default;
    }
});
Object.defineProperty(module.exports, "pink", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_pink.default;
    }
});
Object.defineProperty(module.exports, "purple", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_purple.default;
    }
});
Object.defineProperty(module.exports, "red", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_red.default;
    }
});
Object.defineProperty(module.exports, "teal", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_teal.default;
    }
});
Object.defineProperty(module.exports, "yellow", {
    enumerable: true,
    get: function() {
        return $210a9320270ce251$var$_yellow.default;
    }
});

var $210a9320270ce251$var$_common = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("dzxhF")));

var $210a9320270ce251$var$_red = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("ln9F4")));

var $210a9320270ce251$var$_pink = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("OnZ7a")));

var $210a9320270ce251$var$_purple = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("kSXRh")));

var $210a9320270ce251$var$_deepPurple = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("9XfLT")));

var $210a9320270ce251$var$_indigo = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("gnEXl")));

var $210a9320270ce251$var$_blue = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("bKnBV")));

var $210a9320270ce251$var$_lightBlue = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("iDVue")));

var $210a9320270ce251$var$_cyan = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("fv0vs")));

var $210a9320270ce251$var$_teal = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("cUmH8")));

var $210a9320270ce251$var$_green = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("e4nxq")));

var $210a9320270ce251$var$_lightGreen = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("jdv3V")));

var $210a9320270ce251$var$_lime = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("drMtO")));

var $210a9320270ce251$var$_yellow = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("2dr1n")));

var $210a9320270ce251$var$_amber = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("ffAWJ")));

var $210a9320270ce251$var$_orange = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("dMYym")));

var $210a9320270ce251$var$_deepOrange = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("5n8ns")));

var $210a9320270ce251$var$_brown = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("g9nNw")));

var $210a9320270ce251$var$_grey = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("eU5ou")));

var $210a9320270ce251$var$_blueGrey = $210a9320270ce251$require$_interopRequireDefault((parcelRequire("aZOS8")));

});
parcelRegister("OnZ7a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $0977467e0d52ba8b$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $0977467e0d52ba8b$var$_default = module.exports.default = $0977467e0d52ba8b$var$pink;

});

parcelRegister("9XfLT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $73f5dba4a86b7528$var$deepPurple = {
    50: '#ede7f6',
    100: '#d1c4e9',
    200: '#b39ddb',
    300: '#9575cd',
    400: '#7e57c2',
    500: '#673ab7',
    600: '#5e35b1',
    700: '#512da8',
    800: '#4527a0',
    900: '#311b92',
    A100: '#b388ff',
    A200: '#7c4dff',
    A400: '#651fff',
    A700: '#6200ea'
};
var $73f5dba4a86b7528$var$_default = module.exports.default = $73f5dba4a86b7528$var$deepPurple;

});

parcelRegister("gnEXl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $bece90587ed49c40$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $bece90587ed49c40$var$_default = module.exports.default = $bece90587ed49c40$var$indigo;

});

parcelRegister("fv0vs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b48a24d2f7b64288$var$cyan = {
    50: '#e0f7fa',
    100: '#b2ebf2',
    200: '#80deea',
    300: '#4dd0e1',
    400: '#26c6da',
    500: '#00bcd4',
    600: '#00acc1',
    700: '#0097a7',
    800: '#00838f',
    900: '#006064',
    A100: '#84ffff',
    A200: '#18ffff',
    A400: '#00e5ff',
    A700: '#00b8d4'
};
var $b48a24d2f7b64288$var$_default = module.exports.default = $b48a24d2f7b64288$var$cyan;

});

parcelRegister("cUmH8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $965c51b2111f81b0$var$teal = {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    A100: '#a7ffeb',
    A200: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5'
};
var $965c51b2111f81b0$var$_default = module.exports.default = $965c51b2111f81b0$var$teal;

});

parcelRegister("jdv3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $dfd7538e53c5578e$var$lightGreen = {
    50: '#f1f8e9',
    100: '#dcedc8',
    200: '#c5e1a5',
    300: '#aed581',
    400: '#9ccc65',
    500: '#8bc34a',
    600: '#7cb342',
    700: '#689f38',
    800: '#558b2f',
    900: '#33691e',
    A100: '#ccff90',
    A200: '#b2ff59',
    A400: '#76ff03',
    A700: '#64dd17'
};
var $dfd7538e53c5578e$var$_default = module.exports.default = $dfd7538e53c5578e$var$lightGreen;

});

parcelRegister("drMtO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9ca367113480e6b8$var$lime = {
    50: '#f9fbe7',
    100: '#f0f4c3',
    200: '#e6ee9c',
    300: '#dce775',
    400: '#d4e157',
    500: '#cddc39',
    600: '#c0ca33',
    700: '#afb42b',
    800: '#9e9d24',
    900: '#827717',
    A100: '#f4ff81',
    A200: '#eeff41',
    A400: '#c6ff00',
    A700: '#aeea00'
};
var $9ca367113480e6b8$var$_default = module.exports.default = $9ca367113480e6b8$var$lime;

});

parcelRegister("2dr1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $19d1c187b7554b9f$var$yellow = {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffeb3b',
    600: '#fdd835',
    700: '#fbc02d',
    800: '#f9a825',
    900: '#f57f17',
    A100: '#ffff8d',
    A200: '#ffff00',
    A400: '#ffea00',
    A700: '#ffd600'
};
var $19d1c187b7554b9f$var$_default = module.exports.default = $19d1c187b7554b9f$var$yellow;

});

parcelRegister("ffAWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $b1a4ea7d0e15a230$var$amber = {
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
    A100: '#ffe57f',
    A200: '#ffd740',
    A400: '#ffc400',
    A700: '#ffab00'
};
var $b1a4ea7d0e15a230$var$_default = module.exports.default = $b1a4ea7d0e15a230$var$amber;

});

parcelRegister("5n8ns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $3e959950983c409e$var$deepOrange = {
    50: '#fbe9e7',
    100: '#ffccbc',
    200: '#ffab91',
    300: '#ff8a65',
    400: '#ff7043',
    500: '#ff5722',
    600: '#f4511e',
    700: '#e64a19',
    800: '#d84315',
    900: '#bf360c',
    A100: '#ff9e80',
    A200: '#ff6e40',
    A400: '#ff3d00',
    A700: '#dd2c00'
};
var $3e959950983c409e$var$_default = module.exports.default = $3e959950983c409e$var$deepOrange;

});

parcelRegister("g9nNw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $bc1ff25570917fdc$var$brown = {
    50: '#efebe9',
    100: '#d7ccc8',
    200: '#bcaaa4',
    300: '#a1887f',
    400: '#8d6e63',
    500: '#795548',
    600: '#6d4c41',
    700: '#5d4037',
    800: '#4e342e',
    900: '#3e2723',
    A100: '#d7ccc8',
    A200: '#bcaaa4',
    A400: '#8d6e63',
    A700: '#5d4037'
};
var $bc1ff25570917fdc$var$_default = module.exports.default = $bc1ff25570917fdc$var$brown;

});

parcelRegister("aZOS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $801710099648f128$var$blueGrey = {
    50: '#eceff1',
    100: '#cfd8dc',
    200: '#b0bec5',
    300: '#90a4ae',
    400: '#78909c',
    500: '#607d8b',
    600: '#546e7a',
    700: '#455a64',
    800: '#37474f',
    900: '#263238',
    A100: '#cfd8dc',
    A200: '#b0bec5',
    A400: '#78909c',
    A700: '#455a64'
};
var $801710099648f128$var$_default = module.exports.default = $801710099648f128$var$blueGrey;

});


parcelRegister("lH1DK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fcaee2cf9d6d9c3f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fcaee2cf9d6d9c3f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fcaee2cf9d6d9c3f$var$_exportNames = {
    accordionClasses: true
};
Object.defineProperty(module.exports, "accordionClasses", {
    enumerable: true,
    get: function() {
        return $fcaee2cf9d6d9c3f$var$_accordionClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fcaee2cf9d6d9c3f$var$_Accordion.default;
    }
});

var $fcaee2cf9d6d9c3f$var$_Accordion = $fcaee2cf9d6d9c3f$require$_interopRequireDefault((parcelRequire("7UqNi")));

var $fcaee2cf9d6d9c3f$var$_accordionClasses = $fcaee2cf9d6d9c3f$require$_interopRequireWildcard((parcelRequire("jliMD")));
Object.keys($fcaee2cf9d6d9c3f$var$_accordionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fcaee2cf9d6d9c3f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fcaee2cf9d6d9c3f$var$_accordionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fcaee2cf9d6d9c3f$var$_accordionClasses[key];
        }
    });
});

});
parcelRegister("7UqNi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5c228c234852d575$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5c228c234852d575$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c228c234852d575$var$React = $5c228c234852d575$require$_interopRequireWildcard((parcelRequire("acw62")));


var $5c228c234852d575$var$_propTypes = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5c228c234852d575$var$_clsx = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5c228c234852d575$var$_chainPropTypes = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("abVWF")));

var $5c228c234852d575$var$_composeClasses = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $5c228c234852d575$var$_memoTheme = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $5c228c234852d575$var$_Collapse = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("gsEuH")));

var $5c228c234852d575$var$_Paper = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $5c228c234852d575$var$_AccordionContext = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("7Snug")));

var $5c228c234852d575$var$_useControlled = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("3yddg")));

var $5c228c234852d575$var$_useSlot = $5c228c234852d575$require$_interopRequireDefault((parcelRequire("6lpak")));

var $5c228c234852d575$var$_accordionClasses = $5c228c234852d575$require$_interopRequireWildcard((parcelRequire("jliMD")));

var $ayMG0 = parcelRequire("ayMG0");
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $5c228c234852d575$var$_composeClasses.default)(slots, $5c228c234852d575$var$_accordionClasses.getAccordionUtilityClass, classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $aAbgT.styled)($5c228c234852d575$var$_Paper.default, {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$5c228c234852d575$var$_accordionClasses.default.region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $5c228c234852d575$var$_memoTheme.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${$5c228c234852d575$var$_accordionClasses.default.expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${$5c228c234852d575$var$_accordionClasses.default.disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $5c228c234852d575$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${$5c228c234852d575$var$_accordionClasses.default.expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $5c228c234852d575$var$AccordionHeading = (0, $aAbgT.styled)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading'
})({
    all: 'unset'
});
const $5c228c234852d575$var$AccordionRegion = (0, $aAbgT.styled)('div', {
    name: 'MuiAccordion',
    slot: 'Region'
})({});
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $5c228c234852d575$var$React.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $5c228c234852d575$var$_useControlled.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $5c228c234852d575$var$React.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $5c228c234852d575$var$React.Children.toArray(childrenProp);
    const contextValue = $5c228c234852d575$var$React.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $5c228c234852d575$var$_useSlot.default)('root', {
        elementType: $5c228c234852d575$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $5c228c234852d575$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $5c228c234852d575$var$_useSlot.default)('heading', {
        elementType: $5c228c234852d575$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $5c228c234852d575$var$_useSlot.default)('transition', {
        elementType: $5c228c234852d575$var$_Collapse.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [AccordionRegionSlot, accordionRegionProps] = (0, $5c228c234852d575$var$_useSlot.default)('region', {
        elementType: $5c228c234852d575$var$AccordionRegion,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.region,
        additionalProps: {
            'aria-labelledby': summary.props.id,
            id: summary.props['aria-controls'],
            role: 'region'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5c228c234852d575$var$_AccordionContext.default.Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(AccordionRegionSlot, {
                    ...accordionRegionProps,
                    children: children
                })
            })
        ]
    });
});
var $5c228c234852d575$var$_default = module.exports.default = $5c228c234852d575$var$Accordion;

});
parcelRegister("gsEuH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $bfbeac2d30cd504d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bfbeac2d30cd504d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bfbeac2d30cd504d$var$_exportNames = {
    collapseClasses: true
};
Object.defineProperty(module.exports, "collapseClasses", {
    enumerable: true,
    get: function() {
        return $bfbeac2d30cd504d$var$_collapseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bfbeac2d30cd504d$var$_Collapse.default;
    }
});

var $bfbeac2d30cd504d$var$_Collapse = $bfbeac2d30cd504d$require$_interopRequireDefault((parcelRequire("bnA1h")));

var $bfbeac2d30cd504d$var$_collapseClasses = $bfbeac2d30cd504d$require$_interopRequireWildcard((parcelRequire("38bi6")));
Object.keys($bfbeac2d30cd504d$var$_collapseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bfbeac2d30cd504d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bfbeac2d30cd504d$var$_collapseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bfbeac2d30cd504d$var$_collapseClasses[key];
        }
    });
});

});
parcelRegister("bnA1h", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $848dc8709a4309c5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $848dc8709a4309c5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $848dc8709a4309c5$var$React = $848dc8709a4309c5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $848dc8709a4309c5$var$_clsx = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $848dc8709a4309c5$var$_propTypes = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $848dc8709a4309c5$var$_useTimeout = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("drY8V")));

var $848dc8709a4309c5$var$_elementTypeAcceptingRef = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $848dc8709a4309c5$var$_composeClasses = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $848dc8709a4309c5$var$_memoTheme = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $bmoVh = parcelRequire("bmoVh");

var $hweuE = parcelRequire("hweuE");

var $hGPki = parcelRequire("hGPki");

var $848dc8709a4309c5$var$_useSlot = $848dc8709a4309c5$require$_interopRequireDefault((parcelRequire("6lpak")));

var $38bi6 = parcelRequire("38bi6");

var $ayMG0 = parcelRequire("ayMG0");
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            orientation
        ],
        wrapperInner: [
            'wrapperInner',
            orientation
        ]
    };
    return (0, $848dc8709a4309c5$var$_composeClasses.default)(slots, $38bi6.getCollapseUtilityClass, classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $848dc8709a4309c5$var$_memoTheme.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $aAbgT.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $aAbgT.styled)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $848dc8709a4309c5$var$React.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', slots: slots = {}, slotProps: slotProps = {}, style: style, timeout: timeout = $bmoVh.duration.standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $1mPeS.default, ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $aAbgT.useTheme)();
    const timer = (0, $848dc8709a4309c5$var$_useTimeout.default)();
    const wrapperRef = $848dc8709a4309c5$var$React.useRef(null);
    const autoTransitionDuration = $848dc8709a4309c5$var$React.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $848dc8709a4309c5$var$React.useRef(null);
    const handleRef = (0, $hGPki.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps,
        component: component
    };
    const [RootSlot, rootSlotProps] = (0, $848dc8709a4309c5$var$_useSlot.default)('root', {
        ref: handleRef,
        className: (0, $848dc8709a4309c5$var$_clsx.default)(classes.root, className),
        elementType: $848dc8709a4309c5$var$CollapseRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                ...style
            }
        }
    });
    const [WrapperSlot, wrapperSlotProps] = (0, $848dc8709a4309c5$var$_useSlot.default)('wrapper', {
        ref: wrapperRef,
        className: classes.wrapper,
        elementType: $848dc8709a4309c5$var$CollapseWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [WrapperInnerSlot, wrapperInnerSlotProps] = (0, $848dc8709a4309c5$var$_useSlot.default)('wrapperInner', {
        className: classes.wrapperInner,
        elementType: $848dc8709a4309c5$var$CollapseWrapperInner,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>{
            const stateOwnerState = {
                ...ownerState,
                state: state
            };
            return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
                ...rootSlotProps,
                className: (0, $848dc8709a4309c5$var$_clsx.default)(rootSlotProps.className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                ownerState: stateOwnerState,
                ...restChildProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(WrapperSlot, {
                    ...wrapperSlotProps,
                    ownerState: stateOwnerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(WrapperInnerSlot, {
                        ...wrapperInnerSlotProps,
                        ownerState: stateOwnerState,
                        children: children
                    })
                })
            });
        }
    });
});
if ($848dc8709a4309c5$var$Collapse) $848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$var$_default = module.exports.default = $848dc8709a4309c5$var$Collapse;

});
parcelRegister("38bi6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $247ae09dccc3464c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCollapseUtilityClass = $247ae09dccc3464c$var$getCollapseUtilityClass;

var $247ae09dccc3464c$var$_generateUtilityClasses = $247ae09dccc3464c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $247ae09dccc3464c$var$_generateUtilityClass = $247ae09dccc3464c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $247ae09dccc3464c$var$getCollapseUtilityClass(slot) {
    return (0, $247ae09dccc3464c$var$_generateUtilityClass.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $247ae09dccc3464c$var$_generateUtilityClasses.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$var$_default = module.exports.default = $247ae09dccc3464c$var$collapseClasses;

});



parcelRegister("7Snug", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5bbfcb95732dc207$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bbfcb95732dc207$var$React = $5bbfcb95732dc207$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $5bbfcb95732dc207$var$React.createContext({});
var $5bbfcb95732dc207$var$_default = module.exports.default = $5bbfcb95732dc207$var$AccordionContext;

});

parcelRegister("jliMD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e14e8c767477d992$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionUtilityClass = $e14e8c767477d992$var$getAccordionUtilityClass;

var $e14e8c767477d992$var$_generateUtilityClasses = $e14e8c767477d992$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e14e8c767477d992$var$_generateUtilityClass = $e14e8c767477d992$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e14e8c767477d992$var$getAccordionUtilityClass(slot) {
    return (0, $e14e8c767477d992$var$_generateUtilityClass.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $e14e8c767477d992$var$_generateUtilityClasses.default)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$var$_default = module.exports.default = $e14e8c767477d992$var$accordionClasses;

});



parcelRegister("qjHPG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $04f1b704f2eaef84$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $04f1b704f2eaef84$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $04f1b704f2eaef84$var$_exportNames = {
    accordionActionsClasses: true
};
Object.defineProperty(module.exports, "accordionActionsClasses", {
    enumerable: true,
    get: function() {
        return $04f1b704f2eaef84$var$_accordionActionsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $04f1b704f2eaef84$var$_AccordionActions.default;
    }
});

var $04f1b704f2eaef84$var$_AccordionActions = $04f1b704f2eaef84$require$_interopRequireDefault((parcelRequire("5abSW")));

var $04f1b704f2eaef84$var$_accordionActionsClasses = $04f1b704f2eaef84$require$_interopRequireWildcard((parcelRequire("4nzbK")));
Object.keys($04f1b704f2eaef84$var$_accordionActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($04f1b704f2eaef84$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $04f1b704f2eaef84$var$_accordionActionsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $04f1b704f2eaef84$var$_accordionActionsClasses[key];
        }
    });
});

});
parcelRegister("5abSW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3c271b1069b6d28c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3c271b1069b6d28c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c271b1069b6d28c$var$React = $3c271b1069b6d28c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3c271b1069b6d28c$var$_propTypes = $3c271b1069b6d28c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3c271b1069b6d28c$var$_clsx = $3c271b1069b6d28c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3c271b1069b6d28c$var$_composeClasses = $3c271b1069b6d28c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $4nzbK = parcelRequire("4nzbK");

var $ayMG0 = parcelRequire("ayMG0");
const $3c271b1069b6d28c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $3c271b1069b6d28c$var$_composeClasses.default)(slots, $4nzbK.getAccordionActionsUtilityClass, classes);
};
const $3c271b1069b6d28c$var$AccordionActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAccordionActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    variants: [
        {
            props: (props)=>!props.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $3c271b1069b6d28c$var$AccordionActions = /*#__PURE__*/ $3c271b1069b6d28c$var$React.forwardRef(function AccordionActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $3c271b1069b6d28c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3c271b1069b6d28c$var$AccordionActionsRoot, {
        className: (0, $3c271b1069b6d28c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $3c271b1069b6d28c$var$_default = module.exports.default = $3c271b1069b6d28c$var$AccordionActions;

});
parcelRegister("4nzbK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $33049b15cd6d3df2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionActionsUtilityClass = $33049b15cd6d3df2$var$getAccordionActionsUtilityClass;

var $33049b15cd6d3df2$var$_generateUtilityClasses = $33049b15cd6d3df2$require$_interopRequireDefault((parcelRequire("5nY49")));

var $33049b15cd6d3df2$var$_generateUtilityClass = $33049b15cd6d3df2$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $33049b15cd6d3df2$var$getAccordionActionsUtilityClass(slot) {
    return (0, $33049b15cd6d3df2$var$_generateUtilityClass.default)('MuiAccordionActions', slot);
}
const $33049b15cd6d3df2$var$accordionActionsClasses = (0, $33049b15cd6d3df2$var$_generateUtilityClasses.default)('MuiAccordionActions', [
    'root',
    'spacing'
]);
var $33049b15cd6d3df2$var$_default = module.exports.default = $33049b15cd6d3df2$var$accordionActionsClasses;

});



parcelRegister("e5H02", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a422e3223044b655$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a422e3223044b655$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a422e3223044b655$var$_exportNames = {
    accordionDetailsClasses: true
};
Object.defineProperty(module.exports, "accordionDetailsClasses", {
    enumerable: true,
    get: function() {
        return $a422e3223044b655$var$_accordionDetailsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a422e3223044b655$var$_AccordionDetails.default;
    }
});

var $a422e3223044b655$var$_AccordionDetails = $a422e3223044b655$require$_interopRequireDefault((parcelRequire("2mdyF")));

var $a422e3223044b655$var$_accordionDetailsClasses = $a422e3223044b655$require$_interopRequireWildcard((parcelRequire("9t5XO")));
Object.keys($a422e3223044b655$var$_accordionDetailsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a422e3223044b655$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a422e3223044b655$var$_accordionDetailsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a422e3223044b655$var$_accordionDetailsClasses[key];
        }
    });
});

});
parcelRegister("2mdyF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1b78273c1c27a2e1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1b78273c1c27a2e1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b78273c1c27a2e1$var$React = $1b78273c1c27a2e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1b78273c1c27a2e1$var$_propTypes = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1b78273c1c27a2e1$var$_clsx = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1b78273c1c27a2e1$var$_composeClasses = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $1b78273c1c27a2e1$var$_memoTheme = $1b78273c1c27a2e1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $9t5XO = parcelRequire("9t5XO");

var $ayMG0 = parcelRequire("ayMG0");
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $1b78273c1c27a2e1$var$_composeClasses.default)(slots, $9t5XO.getAccordionDetailsUtilityClass, classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root'
})((0, $1b78273c1c27a2e1$var$_memoTheme.default)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $1b78273c1c27a2e1$var$React.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, {
        className: (0, $1b78273c1c27a2e1$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $1b78273c1c27a2e1$var$_default = module.exports.default = $1b78273c1c27a2e1$var$AccordionDetails;

});
parcelRegister("9t5XO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e4b72c3145e33d8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionDetailsUtilityClass = $6e4b72c3145e33d8$var$getAccordionDetailsUtilityClass;

var $6e4b72c3145e33d8$var$_generateUtilityClasses = $6e4b72c3145e33d8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6e4b72c3145e33d8$var$_generateUtilityClass = $6e4b72c3145e33d8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6e4b72c3145e33d8$var$getAccordionDetailsUtilityClass(slot) {
    return (0, $6e4b72c3145e33d8$var$_generateUtilityClass.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $6e4b72c3145e33d8$var$_generateUtilityClasses.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$var$_default = module.exports.default = $6e4b72c3145e33d8$var$accordionDetailsClasses;

});



parcelRegister("6QcED", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4fb16a516036be86$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4fb16a516036be86$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4fb16a516036be86$var$_exportNames = {
    accordionSummaryClasses: true
};
Object.defineProperty(module.exports, "accordionSummaryClasses", {
    enumerable: true,
    get: function() {
        return $4fb16a516036be86$var$_accordionSummaryClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4fb16a516036be86$var$_AccordionSummary.default;
    }
});

var $4fb16a516036be86$var$_AccordionSummary = $4fb16a516036be86$require$_interopRequireDefault((parcelRequire("2gURC")));

var $4fb16a516036be86$var$_accordionSummaryClasses = $4fb16a516036be86$require$_interopRequireWildcard((parcelRequire("ijHn9")));
Object.keys($4fb16a516036be86$var$_accordionSummaryClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4fb16a516036be86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4fb16a516036be86$var$_accordionSummaryClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4fb16a516036be86$var$_accordionSummaryClasses[key];
        }
    });
});

});
parcelRegister("2gURC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1a792f5a0c37e2ab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1a792f5a0c37e2ab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a792f5a0c37e2ab$var$React = $1a792f5a0c37e2ab$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1a792f5a0c37e2ab$var$_propTypes = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1a792f5a0c37e2ab$var$_clsx = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1a792f5a0c37e2ab$var$_composeClasses = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $1a792f5a0c37e2ab$var$_memoTheme = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1a792f5a0c37e2ab$var$_ButtonBase = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $1a792f5a0c37e2ab$var$_AccordionContext = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("7Snug")));

var $1a792f5a0c37e2ab$var$_accordionSummaryClasses = $1a792f5a0c37e2ab$require$_interopRequireWildcard((parcelRequire("ijHn9")));

var $1a792f5a0c37e2ab$var$_useSlot = $1a792f5a0c37e2ab$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $1a792f5a0c37e2ab$var$_composeClasses.default)(slots, $1a792f5a0c37e2ab$var$_accordionSummaryClasses.getAccordionSummaryUtilityClass, classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $aAbgT.styled)($1a792f5a0c37e2ab$var$_ButtonBase.default, {
    name: 'MuiAccordionSummary',
    slot: 'Root'
})((0, $1a792f5a0c37e2ab$var$_memoTheme.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $aAbgT.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content'
})((0, $1a792f5a0c37e2ab$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $aAbgT.styled)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper'
})((0, $1a792f5a0c37e2ab$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${$1a792f5a0c37e2ab$var$_accordionSummaryClasses.default.expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $1a792f5a0c37e2ab$var$React.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $1a792f5a0c37e2ab$var$React.useContext($1a792f5a0c37e2ab$var$_AccordionContext.default);
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $1a792f5a0c37e2ab$var$_useSlot.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $1a792f5a0c37e2ab$var$_clsx.default)(classes.root, className),
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $1a792f5a0c37e2ab$var$_clsx.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $1a792f5a0c37e2ab$var$_useSlot.default)('content', {
        className: classes.content,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $1a792f5a0c37e2ab$var$_useSlot.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var $1a792f5a0c37e2ab$var$_default = module.exports.default = $1a792f5a0c37e2ab$var$AccordionSummary;

});
parcelRegister("ijHn9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d55ba52db43b55df$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionSummaryUtilityClass = $d55ba52db43b55df$var$getAccordionSummaryUtilityClass;

var $d55ba52db43b55df$var$_generateUtilityClasses = $d55ba52db43b55df$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d55ba52db43b55df$var$_generateUtilityClass = $d55ba52db43b55df$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d55ba52db43b55df$var$getAccordionSummaryUtilityClass(slot) {
    return (0, $d55ba52db43b55df$var$_generateUtilityClass.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $d55ba52db43b55df$var$_generateUtilityClasses.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$var$_default = module.exports.default = $d55ba52db43b55df$var$accordionSummaryClasses;

});



parcelRegister("16wD6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0cdfa98b6f9a20c7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0cdfa98b6f9a20c7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0cdfa98b6f9a20c7$var$_exportNames = {
    alertClasses: true
};
Object.defineProperty(module.exports, "alertClasses", {
    enumerable: true,
    get: function() {
        return $0cdfa98b6f9a20c7$var$_alertClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0cdfa98b6f9a20c7$var$_Alert.default;
    }
});

var $0cdfa98b6f9a20c7$var$_Alert = $0cdfa98b6f9a20c7$require$_interopRequireDefault((parcelRequire("iwiZ3")));

var $0cdfa98b6f9a20c7$var$_alertClasses = $0cdfa98b6f9a20c7$require$_interopRequireWildcard((parcelRequire("2xI7c")));
Object.keys($0cdfa98b6f9a20c7$var$_alertClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0cdfa98b6f9a20c7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0cdfa98b6f9a20c7$var$_alertClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0cdfa98b6f9a20c7$var$_alertClasses[key];
        }
    });
});

});
parcelRegister("iwiZ3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d7b9f0ef25189a24$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d7b9f0ef25189a24$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7b9f0ef25189a24$var$React = $d7b9f0ef25189a24$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d7b9f0ef25189a24$var$_propTypes = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d7b9f0ef25189a24$var$_clsx = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d7b9f0ef25189a24$var$_composeClasses = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $d7b9f0ef25189a24$var$_memoTheme = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $d7b9f0ef25189a24$var$_useSlot = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("6lpak")));

var $d7b9f0ef25189a24$var$_capitalize = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $d7b9f0ef25189a24$var$_Paper = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $d7b9f0ef25189a24$var$_alertClasses = $d7b9f0ef25189a24$require$_interopRequireWildcard((parcelRequire("2xI7c")));

var $d7b9f0ef25189a24$var$_IconButton = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("825Zh")));

var $d7b9f0ef25189a24$var$_SuccessOutlined = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("1hqLn")));

var $d7b9f0ef25189a24$var$_ReportProblemOutlined = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("8kXp7")));

var $d7b9f0ef25189a24$var$_ErrorOutline = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("f42XJ")));

var $d7b9f0ef25189a24$var$_InfoOutlined = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("a8MtG")));

var $d7b9f0ef25189a24$var$_Close = $d7b9f0ef25189a24$require$_interopRequireDefault((parcelRequire("ldBGF")));

var $ayMG0 = parcelRequire("ayMG0");
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $d7b9f0ef25189a24$var$_capitalize.default)(color || severity)}`,
            `${variant}${(0, $d7b9f0ef25189a24$var$_capitalize.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $d7b9f0ef25189a24$var$_composeClasses.default)(slots, $d7b9f0ef25189a24$var$_alertClasses.getAlertUtilityClass, classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $aAbgT.styled)($d7b9f0ef25189a24$var$_Paper.default, {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $d7b9f0ef25189a24$var$_capitalize.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $d7b9f0ef25189a24$var$_memoTheme.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${$d7b9f0ef25189a24$var$_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${$d7b9f0ef25189a24$var$_alertClasses.default.icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d7b9f0ef25189a24$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $d7b9f0ef25189a24$var$AlertIcon = (0, $aAbgT.styled)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $aAbgT.styled)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $aAbgT.styled)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_SuccessOutlined.default, {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_ReportProblemOutlined.default, {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_ErrorOutline.default, {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)($d7b9f0ef25189a24$var$_InfoOutlined.default, {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $d7b9f0ef25189a24$var$React.forwardRef(function Alert(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $d7b9f0ef25189a24$var$_clsx.default)(classes.root, className),
        elementType: $d7b9f0ef25189a24$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('icon', {
        className: classes.icon,
        elementType: $d7b9f0ef25189a24$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('message', {
        className: classes.message,
        elementType: $d7b9f0ef25189a24$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('action', {
        className: classes.action,
        elementType: $d7b9f0ef25189a24$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('closeButton', {
        elementType: $d7b9f0ef25189a24$var$_IconButton.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $d7b9f0ef25189a24$var$_useSlot.default)('closeIcon', {
        elementType: $d7b9f0ef25189a24$var$_Close.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $d7b9f0ef25189a24$var$_default = module.exports.default = $d7b9f0ef25189a24$var$Alert;

});
parcelRegister("2xI7c", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1da0e229d53b4459$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAlertUtilityClass = $1da0e229d53b4459$var$getAlertUtilityClass;

var $1da0e229d53b4459$var$_generateUtilityClasses = $1da0e229d53b4459$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1da0e229d53b4459$var$_generateUtilityClass = $1da0e229d53b4459$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1da0e229d53b4459$var$getAlertUtilityClass(slot) {
    return (0, $1da0e229d53b4459$var$_generateUtilityClass.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $1da0e229d53b4459$var$_generateUtilityClasses.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$var$_default = module.exports.default = $1da0e229d53b4459$var$alertClasses;

});

parcelRegister("1hqLn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0eec239707c48bf2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0eec239707c48bf2$var$_createSvgIcon = $0eec239707c48bf2$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $0eec239707c48bf2$var$_default = module.exports.default = (0, $0eec239707c48bf2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("8kXp7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $611e456547a52fc7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $611e456547a52fc7$var$_createSvgIcon = $611e456547a52fc7$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $611e456547a52fc7$var$_default = module.exports.default = (0, $611e456547a52fc7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("f42XJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $af7987087272cca1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af7987087272cca1$var$_createSvgIcon = $af7987087272cca1$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $af7987087272cca1$var$_default = module.exports.default = (0, $af7987087272cca1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("a8MtG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $76204164d2201318$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76204164d2201318$var$_createSvgIcon = $76204164d2201318$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $76204164d2201318$var$_default = module.exports.default = (0, $76204164d2201318$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});



parcelRegister("bkkWw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $83f1cec610e0702c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $83f1cec610e0702c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $83f1cec610e0702c$var$_exportNames = {
    alertTitleClasses: true
};
Object.defineProperty(module.exports, "alertTitleClasses", {
    enumerable: true,
    get: function() {
        return $83f1cec610e0702c$var$_alertTitleClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $83f1cec610e0702c$var$_AlertTitle.default;
    }
});

var $83f1cec610e0702c$var$_AlertTitle = $83f1cec610e0702c$require$_interopRequireDefault((parcelRequire("hvpJ1")));

var $83f1cec610e0702c$var$_alertTitleClasses = $83f1cec610e0702c$require$_interopRequireWildcard((parcelRequire("cFmTX")));
Object.keys($83f1cec610e0702c$var$_alertTitleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($83f1cec610e0702c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $83f1cec610e0702c$var$_alertTitleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $83f1cec610e0702c$var$_alertTitleClasses[key];
        }
    });
});

});
parcelRegister("hvpJ1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cbe9496169f0560d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cbe9496169f0560d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbe9496169f0560d$var$React = $cbe9496169f0560d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cbe9496169f0560d$var$_propTypes = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cbe9496169f0560d$var$_clsx = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cbe9496169f0560d$var$_composeClasses = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $cbe9496169f0560d$var$_memoTheme = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $cbe9496169f0560d$var$_Typography = $cbe9496169f0560d$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $cFmTX = parcelRequire("cFmTX");

var $ayMG0 = parcelRequire("ayMG0");
const $cbe9496169f0560d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cbe9496169f0560d$var$_composeClasses.default)(slots, $cFmTX.getAlertTitleUtilityClass, classes);
};
const $cbe9496169f0560d$var$AlertTitleRoot = (0, $aAbgT.styled)($cbe9496169f0560d$var$_Typography.default, {
    name: 'MuiAlertTitle',
    slot: 'Root'
})((0, $cbe9496169f0560d$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
}));
const $cbe9496169f0560d$var$AlertTitle = /*#__PURE__*/ $cbe9496169f0560d$var$React.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $cbe9496169f0560d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cbe9496169f0560d$var$AlertTitleRoot, {
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $cbe9496169f0560d$var$_clsx.default)(classes.root, className),
        ...other
    });
});
var $cbe9496169f0560d$var$_default = module.exports.default = $cbe9496169f0560d$var$AlertTitle;

});
parcelRegister("cFmTX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $938b1427b9e9a19f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAlertTitleUtilityClass = $938b1427b9e9a19f$var$getAlertTitleUtilityClass;

var $938b1427b9e9a19f$var$_generateUtilityClasses = $938b1427b9e9a19f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $938b1427b9e9a19f$var$_generateUtilityClass = $938b1427b9e9a19f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $938b1427b9e9a19f$var$getAlertTitleUtilityClass(slot) {
    return (0, $938b1427b9e9a19f$var$_generateUtilityClass.default)('MuiAlertTitle', slot);
}
const $938b1427b9e9a19f$var$alertTitleClasses = (0, $938b1427b9e9a19f$var$_generateUtilityClasses.default)('MuiAlertTitle', [
    'root'
]);
var $938b1427b9e9a19f$var$_default = module.exports.default = $938b1427b9e9a19f$var$alertTitleClasses;

});



parcelRegister("kvdH6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $eed1534592dd796b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $eed1534592dd796b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eed1534592dd796b$var$_exportNames = {
    appBarClasses: true
};
Object.defineProperty(module.exports, "appBarClasses", {
    enumerable: true,
    get: function() {
        return $eed1534592dd796b$var$_appBarClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eed1534592dd796b$var$_AppBar.default;
    }
});

var $eed1534592dd796b$var$_AppBar = $eed1534592dd796b$require$_interopRequireDefault((parcelRequire("4M9OB")));

var $eed1534592dd796b$var$_appBarClasses = $eed1534592dd796b$require$_interopRequireWildcard((parcelRequire("6c6m6")));
Object.keys($eed1534592dd796b$var$_appBarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eed1534592dd796b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eed1534592dd796b$var$_appBarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eed1534592dd796b$var$_appBarClasses[key];
        }
    });
});

});
parcelRegister("4M9OB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $37a342382669398e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $37a342382669398e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a342382669398e$var$React = $37a342382669398e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $37a342382669398e$var$_propTypes = $37a342382669398e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $37a342382669398e$var$_clsx = $37a342382669398e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $37a342382669398e$var$_composeClasses = $37a342382669398e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $37a342382669398e$var$_memoTheme = $37a342382669398e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $37a342382669398e$var$_capitalize = $37a342382669398e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $37a342382669398e$var$_createSimplePaletteValueFilter = $37a342382669398e$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $37a342382669398e$var$_Paper = $37a342382669398e$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $6c6m6 = parcelRequire("6c6m6");

var $ayMG0 = parcelRequire("ayMG0");
const $37a342382669398e$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $37a342382669398e$var$_capitalize.default)(color)}`,
            `position${(0, $37a342382669398e$var$_capitalize.default)(position)}`
        ]
    };
    return (0, $37a342382669398e$var$_composeClasses.default)(slots, $6c6m6.getAppBarUtilityClass, classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $37a342382669398e$var$joinVars = (var1, var2)=>var1 ? `${var1.replace(')', '')}, ${var2})` : var2;
const $37a342382669398e$var$AppBarRoot = (0, $aAbgT.styled)($37a342382669398e$var$_Paper.default, {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $37a342382669398e$var$_capitalize.default)(ownerState.position)}`],
            styles[`color${(0, $37a342382669398e$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $37a342382669398e$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $37a342382669398e$var$_createSimplePaletteValueFilter.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $37a342382669398e$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $37a342382669398e$var$AppBar = /*#__PURE__*/ $37a342382669398e$var$React.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $37a342382669398e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($37a342382669398e$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $37a342382669398e$var$_clsx.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $37a342382669398e$var$_default = module.exports.default = $37a342382669398e$var$AppBar;

});
parcelRegister("6c6m6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4828cb1f30b841b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAppBarUtilityClass = $4828cb1f30b841b0$var$getAppBarUtilityClass;

var $4828cb1f30b841b0$var$_generateUtilityClasses = $4828cb1f30b841b0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4828cb1f30b841b0$var$_generateUtilityClass = $4828cb1f30b841b0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4828cb1f30b841b0$var$getAppBarUtilityClass(slot) {
    return (0, $4828cb1f30b841b0$var$_generateUtilityClass.default)('MuiAppBar', slot);
}
const $4828cb1f30b841b0$var$appBarClasses = (0, $4828cb1f30b841b0$var$_generateUtilityClasses.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $4828cb1f30b841b0$var$_default = module.exports.default = $4828cb1f30b841b0$var$appBarClasses;

});



parcelRegister("kpeRy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $edb1abe77b6ce3b3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $edb1abe77b6ce3b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $edb1abe77b6ce3b3$var$_exportNames = {
    avatarClasses: true
};
Object.defineProperty(module.exports, "avatarClasses", {
    enumerable: true,
    get: function() {
        return $edb1abe77b6ce3b3$var$_avatarClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edb1abe77b6ce3b3$var$_Avatar.default;
    }
});

var $edb1abe77b6ce3b3$var$_Avatar = $edb1abe77b6ce3b3$require$_interopRequireDefault((parcelRequire("26QC4")));

var $edb1abe77b6ce3b3$var$_avatarClasses = $edb1abe77b6ce3b3$require$_interopRequireWildcard((parcelRequire("68Vfr")));
Object.keys($edb1abe77b6ce3b3$var$_avatarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($edb1abe77b6ce3b3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $edb1abe77b6ce3b3$var$_avatarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $edb1abe77b6ce3b3$var$_avatarClasses[key];
        }
    });
});

});
parcelRegister("26QC4", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1894f4268467302e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1894f4268467302e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1894f4268467302e$var$React = $1894f4268467302e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1894f4268467302e$var$_propTypes = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1894f4268467302e$var$_clsx = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1894f4268467302e$var$_composeClasses = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $1894f4268467302e$var$_memoTheme = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $1894f4268467302e$var$_Person = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("df4uV")));

var $68Vfr = parcelRequire("68Vfr");

var $1894f4268467302e$var$_useSlot = $1894f4268467302e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $1894f4268467302e$var$_composeClasses.default)(slots, $68Vfr.getAvatarUtilityClass, classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})((0, $1894f4268467302e$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: {
                    color: (theme.vars || theme).palette.background.default,
                    ...theme.vars ? {
                        backgroundColor: theme.vars.palette.Avatar.defaultBg
                    } : {
                        backgroundColor: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            backgroundColor: theme.palette.grey[600]
                        })
                    }
                }
            }
        ]
    })));
const $1894f4268467302e$var$AvatarImg = (0, $aAbgT.styled)('img', {
    name: 'MuiAvatar',
    slot: 'Img'
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $aAbgT.styled)($1894f4268467302e$var$_Person.default, {
    name: 'MuiAvatar',
    slot: 'Fallback'
})({
    width: '75%',
    height: '75%'
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $1894f4268467302e$var$React.useState(false);
    $1894f4268467302e$var$React.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $1894f4268467302e$var$React.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular', ...other } = props;
    let children = null;
    const ownerState = {
        ...props,
        component: component,
        variant: variant
    };
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded({
        ...imgProps,
        ...typeof slotProps.img === 'function' ? slotProps.img(ownerState) : slotProps.img,
        src: src,
        srcSet: srcSet
    });
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    ownerState.colorDefault = !hasImgNotFailing;
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [RootSlot, rootSlotProps] = (0, $1894f4268467302e$var$_useSlot.default)('root', {
        ref: ref,
        className: (0, $1894f4268467302e$var$_clsx.default)(classes.root, className),
        elementType: $1894f4268467302e$var$AvatarRoot,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            component: component,
            ...other
        },
        ownerState: ownerState
    });
    const [ImgSlot, imgSlotProps] = (0, $1894f4268467302e$var$_useSlot.default)('img', {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: {
                    ...imgProps,
                    ...slotProps.img
                }
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    const [FallbackSlot, fallbackSlotProps] = (0, $1894f4268467302e$var$_useSlot.default)('fallback', {
        className: classes.fallback,
        elementType: $1894f4268467302e$var$AvatarFallback,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, {
        ...imgSlotProps
    });
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)(FallbackSlot, {
        ...fallbackSlotProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: children
    });
});
var $1894f4268467302e$var$_default = module.exports.default = $1894f4268467302e$var$Avatar;

});
parcelRegister("df4uV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9a402a389bd8b499$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a402a389bd8b499$var$_createSvgIcon = $9a402a389bd8b499$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $9a402a389bd8b499$var$_default = module.exports.default = (0, $9a402a389bd8b499$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

});

parcelRegister("68Vfr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $478fe5b437ab8d6f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAvatarUtilityClass = $478fe5b437ab8d6f$var$getAvatarUtilityClass;

var $478fe5b437ab8d6f$var$_generateUtilityClasses = $478fe5b437ab8d6f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $478fe5b437ab8d6f$var$_generateUtilityClass = $478fe5b437ab8d6f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $478fe5b437ab8d6f$var$getAvatarUtilityClass(slot) {
    return (0, $478fe5b437ab8d6f$var$_generateUtilityClass.default)('MuiAvatar', slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $478fe5b437ab8d6f$var$_generateUtilityClasses.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $478fe5b437ab8d6f$var$_default = module.exports.default = $478fe5b437ab8d6f$var$avatarClasses;

});



parcelRegister("aHDU0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7cacdf50dce7d54d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7cacdf50dce7d54d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7cacdf50dce7d54d$var$_exportNames = {
    avatarGroupClasses: true
};
Object.defineProperty(module.exports, "avatarGroupClasses", {
    enumerable: true,
    get: function() {
        return $7cacdf50dce7d54d$var$_avatarGroupClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7cacdf50dce7d54d$var$_AvatarGroup.default;
    }
});

var $7cacdf50dce7d54d$var$_AvatarGroup = $7cacdf50dce7d54d$require$_interopRequireDefault((parcelRequire("9CTjG")));

var $7cacdf50dce7d54d$var$_avatarGroupClasses = $7cacdf50dce7d54d$require$_interopRequireWildcard((parcelRequire("iFLib")));
Object.keys($7cacdf50dce7d54d$var$_avatarGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7cacdf50dce7d54d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7cacdf50dce7d54d$var$_avatarGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7cacdf50dce7d54d$var$_avatarGroupClasses[key];
        }
    });
});

});
parcelRegister("9CTjG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $70229258f609d599$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $70229258f609d599$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70229258f609d599$var$React = $70229258f609d599$require$_interopRequireWildcard((parcelRequire("acw62")));

var $70229258f609d599$var$_propTypes = $70229258f609d599$require$_interopRequireDefault((parcelRequire("c9Z8w")));


var $70229258f609d599$var$_clsx = $70229258f609d599$require$_interopRequireDefault((parcelRequire("9QePP")));

var $70229258f609d599$var$_chainPropTypes = $70229258f609d599$require$_interopRequireDefault((parcelRequire("abVWF")));

var $70229258f609d599$var$_composeClasses = $70229258f609d599$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $70229258f609d599$var$_memoTheme = $70229258f609d599$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $70229258f609d599$var$_Avatar = $70229258f609d599$require$_interopRequireWildcard((parcelRequire("kpeRy")));

var $70229258f609d599$var$_avatarGroupClasses = $70229258f609d599$require$_interopRequireWildcard((parcelRequire("iFLib")));

var $70229258f609d599$var$_useSlot = $70229258f609d599$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $70229258f609d599$var$SPACINGS = {
    small: -16,
    medium: -8
};
const $70229258f609d599$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ]
    };
    return (0, $70229258f609d599$var$_composeClasses.default)(slots, $70229258f609d599$var$_avatarGroupClasses.getAvatarGroupUtilityClass, classes);
};
const $70229258f609d599$var$AvatarGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiAvatarGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${$70229258f609d599$var$_avatarGroupClasses.default.avatar}`]: styles.avatar
            },
            styles.root
        ];
    }
})((0, $70229258f609d599$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row-reverse',
        [`& .${$70229258f609d599$var$_Avatar.avatarClasses.root}`]: {
            border: `2px solid ${(theme.vars || theme).palette.background.default}`,
            boxSizing: 'content-box',
            marginLeft: 'var(--AvatarGroup-spacing, -8px)',
            '&:last-child': {
                marginLeft: 0
            }
        }
    })));
const $70229258f609d599$var$AvatarGroup = /*#__PURE__*/ $70229258f609d599$var$React.forwardRef(function AvatarGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatarGroup'
    });
    const { children: childrenProp, className: className, component: component = 'div', componentsProps: componentsProps, max: max = 5, renderSurplus: renderSurplus, slotProps: slotProps = {}, slots: slots = {}, spacing: spacing = 'medium', total: total, variant: variant = 'circular', ...other } = props;
    let clampedMax = max < 2 ? 2 : max;
    const ownerState = {
        ...props,
        max: max,
        spacing: spacing,
        component: component,
        variant: variant
    };
    const classes = $70229258f609d599$var$useUtilityClasses(ownerState);
    const children = $70229258f609d599$var$React.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $70229258f609d599$var$React.isValidElement(child);
    });
    const totalAvatars = total || children.length;
    if (totalAvatars === clampedMax) clampedMax += 1;
    clampedMax = Math.min(totalAvatars + 1, clampedMax);
    const maxAvatars = Math.min(children.length, clampedMax - 1);
    const extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
    const extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : `+${extraAvatars}`;
    let marginValue;
    if (ownerState.spacing && $70229258f609d599$var$SPACINGS[ownerState.spacing] !== undefined) marginValue = $70229258f609d599$var$SPACINGS[ownerState.spacing];
    else if (ownerState.spacing === 0) marginValue = 0;
    else marginValue = -ownerState.spacing || $70229258f609d599$var$SPACINGS.medium;
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            surplus: slotProps.additionalAvatar ?? componentsProps?.additionalAvatar,
            ...componentsProps,
            ...slotProps
        }
    };
    const [SurplusSlot, surplusProps] = (0, $70229258f609d599$var$_useSlot.default)('surplus', {
        elementType: $70229258f609d599$var$_Avatar.default,
        externalForwardedProps: externalForwardedProps,
        className: classes.avatar,
        ownerState: ownerState,
        additionalProps: {
            variant: variant
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($70229258f609d599$var$AvatarGroupRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $70229258f609d599$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            '--AvatarGroup-spacing': `${marginValue}px`,
            // marginValue is always defined
            ...other.style
        },
        children: [
            extraAvatars ? /*#__PURE__*/ (0, $ayMG0.jsx)(SurplusSlot, {
                ...surplusProps,
                children: extraAvatarsElement
            }) : null,
            children.slice(0, maxAvatars).reverse().map((child)=>{
                return /*#__PURE__*/ $70229258f609d599$var$React.cloneElement(child, {
                    className: (0, $70229258f609d599$var$_clsx.default)(child.props.className, classes.avatar),
                    variant: child.props.variant || variant
                });
            })
        ]
    });
});
var $70229258f609d599$var$_default = module.exports.default = $70229258f609d599$var$AvatarGroup;

});
parcelRegister("iFLib", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d980bd9c21d06ae1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAvatarGroupUtilityClass = $d980bd9c21d06ae1$var$getAvatarGroupUtilityClass;

var $d980bd9c21d06ae1$var$_generateUtilityClasses = $d980bd9c21d06ae1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d980bd9c21d06ae1$var$_generateUtilityClass = $d980bd9c21d06ae1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d980bd9c21d06ae1$var$getAvatarGroupUtilityClass(slot) {
    return (0, $d980bd9c21d06ae1$var$_generateUtilityClass.default)('MuiAvatarGroup', slot);
}
const $d980bd9c21d06ae1$var$avatarGroupClasses = (0, $d980bd9c21d06ae1$var$_generateUtilityClasses.default)('MuiAvatarGroup', [
    'root',
    'avatar'
]);
var $d980bd9c21d06ae1$var$_default = module.exports.default = $d980bd9c21d06ae1$var$avatarGroupClasses;

});



parcelRegister("jIzBR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e5adbfb42ac1b374$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e5adbfb42ac1b374$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e5adbfb42ac1b374$var$_exportNames = {
    bottomNavigationClasses: true
};
Object.defineProperty(module.exports, "bottomNavigationClasses", {
    enumerable: true,
    get: function() {
        return $e5adbfb42ac1b374$var$_bottomNavigationClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e5adbfb42ac1b374$var$_BottomNavigation.default;
    }
});

var $e5adbfb42ac1b374$var$_BottomNavigation = $e5adbfb42ac1b374$require$_interopRequireDefault((parcelRequire("82v09")));

var $e5adbfb42ac1b374$var$_bottomNavigationClasses = $e5adbfb42ac1b374$require$_interopRequireWildcard((parcelRequire("2kzOn")));
Object.keys($e5adbfb42ac1b374$var$_bottomNavigationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e5adbfb42ac1b374$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e5adbfb42ac1b374$var$_bottomNavigationClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e5adbfb42ac1b374$var$_bottomNavigationClasses[key];
        }
    });
});

});
parcelRegister("82v09", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5da68ee03f6480a6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5da68ee03f6480a6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5da68ee03f6480a6$var$React = $5da68ee03f6480a6$require$_interopRequireWildcard((parcelRequire("acw62")));


var $5da68ee03f6480a6$var$_propTypes = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5da68ee03f6480a6$var$_clsx = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5da68ee03f6480a6$var$_composeClasses = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $5da68ee03f6480a6$var$_memoTheme = $5da68ee03f6480a6$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $2kzOn = parcelRequire("2kzOn");

var $ayMG0 = parcelRequire("ayMG0");
const $5da68ee03f6480a6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5da68ee03f6480a6$var$_composeClasses.default)(slots, $2kzOn.getBottomNavigationUtilityClass, classes);
};
const $5da68ee03f6480a6$var$BottomNavigationRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiBottomNavigation',
    slot: 'Root'
})((0, $5da68ee03f6480a6$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        height: 56,
        backgroundColor: (theme.vars || theme).palette.background.paper
    })));
const $5da68ee03f6480a6$var$BottomNavigation = /*#__PURE__*/ $5da68ee03f6480a6$var$React.forwardRef(function BottomNavigation(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigation'
    });
    const { children: children, className: className, component: component = 'div', onChange: onChange, showLabels: showLabels = false, value: value, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        showLabels: showLabels
    };
    const classes = $5da68ee03f6480a6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5da68ee03f6480a6$var$BottomNavigationRoot, {
        as: component,
        className: (0, $5da68ee03f6480a6$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: $5da68ee03f6480a6$var$React.Children.map(children, (child, childIndex)=>{
            if (!/*#__PURE__*/ $5da68ee03f6480a6$var$React.isValidElement(child)) return null;
            const childValue = child.props.value === undefined ? childIndex : child.props.value;
            return /*#__PURE__*/ $5da68ee03f6480a6$var$React.cloneElement(child, {
                selected: childValue === value,
                showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
                value: childValue,
                onChange: onChange
            });
        })
    });
});
var $5da68ee03f6480a6$var$_default = module.exports.default = $5da68ee03f6480a6$var$BottomNavigation;

});
parcelRegister("2kzOn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1b293a71daed0efc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBottomNavigationUtilityClass = $1b293a71daed0efc$var$getBottomNavigationUtilityClass;

var $1b293a71daed0efc$var$_generateUtilityClasses = $1b293a71daed0efc$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1b293a71daed0efc$var$_generateUtilityClass = $1b293a71daed0efc$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1b293a71daed0efc$var$getBottomNavigationUtilityClass(slot) {
    return (0, $1b293a71daed0efc$var$_generateUtilityClass.default)('MuiBottomNavigation', slot);
}
const $1b293a71daed0efc$var$bottomNavigationClasses = (0, $1b293a71daed0efc$var$_generateUtilityClasses.default)('MuiBottomNavigation', [
    'root'
]);
var $1b293a71daed0efc$var$_default = module.exports.default = $1b293a71daed0efc$var$bottomNavigationClasses;

});



parcelRegister("e9QPA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a4eae313114a1aef$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a4eae313114a1aef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a4eae313114a1aef$var$_exportNames = {
    bottomNavigationActionClasses: true
};
Object.defineProperty(module.exports, "bottomNavigationActionClasses", {
    enumerable: true,
    get: function() {
        return $a4eae313114a1aef$var$_bottomNavigationActionClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a4eae313114a1aef$var$_BottomNavigationAction.default;
    }
});

var $a4eae313114a1aef$var$_BottomNavigationAction = $a4eae313114a1aef$require$_interopRequireDefault((parcelRequire("lLgVd")));

var $a4eae313114a1aef$var$_bottomNavigationActionClasses = $a4eae313114a1aef$require$_interopRequireWildcard((parcelRequire("1AAR2")));
Object.keys($a4eae313114a1aef$var$_bottomNavigationActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a4eae313114a1aef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a4eae313114a1aef$var$_bottomNavigationActionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a4eae313114a1aef$var$_bottomNavigationActionClasses[key];
        }
    });
});

});
parcelRegister("lLgVd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fd7b1d1a8629ce6b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fd7b1d1a8629ce6b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd7b1d1a8629ce6b$var$React = $fd7b1d1a8629ce6b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fd7b1d1a8629ce6b$var$_propTypes = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fd7b1d1a8629ce6b$var$_clsx = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fd7b1d1a8629ce6b$var$_composeClasses = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $fd7b1d1a8629ce6b$var$_memoTheme = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $fd7b1d1a8629ce6b$var$_ButtonBase = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $fd7b1d1a8629ce6b$var$_unsupportedProp = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses = $fd7b1d1a8629ce6b$require$_interopRequireWildcard((parcelRequire("1AAR2")));

var $fd7b1d1a8629ce6b$var$_useSlot = $fd7b1d1a8629ce6b$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $fd7b1d1a8629ce6b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, showLabel: showLabel, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ],
        label: [
            'label',
            !showLabel && !selected && 'iconOnly',
            selected && 'selected'
        ]
    };
    return (0, $fd7b1d1a8629ce6b$var$_composeClasses.default)(slots, $fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses.getBottomNavigationActionUtilityClass, classes);
};
const $fd7b1d1a8629ce6b$var$BottomNavigationActionRoot = (0, $aAbgT.styled)($fd7b1d1a8629ce6b$var$_ButtonBase.default, {
    name: 'MuiBottomNavigationAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.showLabel && !ownerState.selected && styles.iconOnly
        ];
    }
})((0, $fd7b1d1a8629ce6b$var$_memoTheme.default)(({ theme: theme })=>({
        transition: theme.transitions.create([
            'color',
            'padding-top'
        ], {
            duration: theme.transitions.duration.short
        }),
        padding: '0px 12px',
        minWidth: 80,
        maxWidth: 168,
        color: (theme.vars || theme).palette.text.secondary,
        flexDirection: 'column',
        flex: '1',
        [`&.${$fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses.default.selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        variants: [
            {
                props: ({ showLabel: showLabel, selected: selected })=>!showLabel && !selected,
                style: {
                    paddingTop: 14
                }
            },
            {
                props: ({ showLabel: showLabel, selected: selected, label: label })=>!showLabel && !selected && !label,
                style: {
                    paddingTop: 0
                }
            }
        ]
    })));
const $fd7b1d1a8629ce6b$var$BottomNavigationActionLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiBottomNavigationAction',
    slot: 'Label'
})((0, $fd7b1d1a8629ce6b$var$_memoTheme.default)(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(12),
        opacity: 1,
        transition: 'font-size 0.2s, opacity 0.2s',
        transitionDelay: '0.1s',
        [`&.${$fd7b1d1a8629ce6b$var$_bottomNavigationActionClasses.default.selected}`]: {
            fontSize: theme.typography.pxToRem(14)
        },
        variants: [
            {
                props: ({ showLabel: showLabel, selected: selected })=>!showLabel && !selected,
                style: {
                    opacity: 0,
                    transitionDelay: '0s'
                }
            }
        ]
    })));
const $fd7b1d1a8629ce6b$var$BottomNavigationAction = /*#__PURE__*/ $fd7b1d1a8629ce6b$var$React.forwardRef(function BottomNavigationAction(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBottomNavigationAction'
    });
    const { className: className, icon: icon, label: label, onChange: onChange, onClick: onClick, selected: // eslint-disable-next-line react/prop-types -- private, always overridden by BottomNavigation
    selected, showLabel: showLabel, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = props;
    const classes = $fd7b1d1a8629ce6b$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $fd7b1d1a8629ce6b$var$_useSlot.default)('root', {
        elementType: $fd7b1d1a8629ce6b$var$BottomNavigationActionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        className: (0, $fd7b1d1a8629ce6b$var$_clsx.default)(classes.root, className),
        additionalProps: {
            focusRipple: true
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $fd7b1d1a8629ce6b$var$_useSlot.default)('label', {
        elementType: $fd7b1d1a8629ce6b$var$BottomNavigationActionLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            })
        ]
    });
});
var $fd7b1d1a8629ce6b$var$_default = module.exports.default = $fd7b1d1a8629ce6b$var$BottomNavigationAction;

});
parcelRegister("1AAR2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1285bdc0c1011b3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBottomNavigationActionUtilityClass = $1285bdc0c1011b3d$var$getBottomNavigationActionUtilityClass;

var $1285bdc0c1011b3d$var$_generateUtilityClasses = $1285bdc0c1011b3d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $1285bdc0c1011b3d$var$_generateUtilityClass = $1285bdc0c1011b3d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $1285bdc0c1011b3d$var$getBottomNavigationActionUtilityClass(slot) {
    return (0, $1285bdc0c1011b3d$var$_generateUtilityClass.default)('MuiBottomNavigationAction', slot);
}
const $1285bdc0c1011b3d$var$bottomNavigationActionClasses = (0, $1285bdc0c1011b3d$var$_generateUtilityClasses.default)('MuiBottomNavigationAction', [
    'root',
    'iconOnly',
    'selected',
    'label'
]);
var $1285bdc0c1011b3d$var$_default = module.exports.default = $1285bdc0c1011b3d$var$bottomNavigationActionClasses;

});



parcelRegister("63l7x", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $468368052d2ef018$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $468368052d2ef018$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $468368052d2ef018$var$_exportNames = {
    breadcrumbsClasses: true
};
Object.defineProperty(module.exports, "breadcrumbsClasses", {
    enumerable: true,
    get: function() {
        return $468368052d2ef018$var$_breadcrumbsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $468368052d2ef018$var$_Breadcrumbs.default;
    }
});

var $468368052d2ef018$var$_Breadcrumbs = $468368052d2ef018$require$_interopRequireDefault((parcelRequire("591qL")));

var $468368052d2ef018$var$_breadcrumbsClasses = $468368052d2ef018$require$_interopRequireWildcard((parcelRequire("4d25s")));
Object.keys($468368052d2ef018$var$_breadcrumbsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($468368052d2ef018$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $468368052d2ef018$var$_breadcrumbsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $468368052d2ef018$var$_breadcrumbsClasses[key];
        }
    });
});

});
parcelRegister("591qL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3beee71e1808c2fa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3beee71e1808c2fa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3beee71e1808c2fa$var$React = $3beee71e1808c2fa$require$_interopRequireWildcard((parcelRequire("acw62")));


var $3beee71e1808c2fa$var$_propTypes = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3beee71e1808c2fa$var$_clsx = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3beee71e1808c2fa$var$_integerPropType = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $3beee71e1808c2fa$var$_composeClasses = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $3beee71e1808c2fa$var$_useSlotProps = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("839K0")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $3beee71e1808c2fa$var$_Typography = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $3beee71e1808c2fa$var$_BreadcrumbCollapsed = $3beee71e1808c2fa$require$_interopRequireDefault((parcelRequire("eSNoo")));

var $3beee71e1808c2fa$var$_breadcrumbsClasses = $3beee71e1808c2fa$require$_interopRequireWildcard((parcelRequire("4d25s")));

var $ayMG0 = parcelRequire("ayMG0");
const $3beee71e1808c2fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $3beee71e1808c2fa$var$_composeClasses.default)(slots, $3beee71e1808c2fa$var$_breadcrumbsClasses.getBreadcrumbsUtilityClass, classes);
};
const $3beee71e1808c2fa$var$BreadcrumbsRoot = (0, $aAbgT.styled)($3beee71e1808c2fa$var$_Typography.default, {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${$3beee71e1808c2fa$var$_breadcrumbsClasses.default.li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $3beee71e1808c2fa$var$BreadcrumbsOl = (0, $aAbgT.styled)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $3beee71e1808c2fa$var$BreadcrumbsSeparator = (0, $aAbgT.styled)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator'
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $3beee71e1808c2fa$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $3beee71e1808c2fa$var$Breadcrumbs = /*#__PURE__*/ $3beee71e1808c2fa$var$React.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/', ...other } = props;
    const [expanded, setExpanded] = $3beee71e1808c2fa$var$React.useState(false);
    const ownerState = {
        ...props,
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    };
    const classes = $3beee71e1808c2fa$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $3beee71e1808c2fa$var$_useSlotProps.default)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $3beee71e1808c2fa$var$React.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$_BreadcrumbCollapsed.default, {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $3beee71e1808c2fa$var$React.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $3beee71e1808c2fa$var$React.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsRoot, {
        ref: ref,
        component: component,
        color: "textSecondary",
        className: (0, $3beee71e1808c2fa$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3beee71e1808c2fa$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $3beee71e1808c2fa$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    });
});
var $3beee71e1808c2fa$var$_default = module.exports.default = $3beee71e1808c2fa$var$Breadcrumbs;

});
parcelRegister("eSNoo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ad5c6c214f96507f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad5c6c214f96507f$var$_propTypes = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $ad5c6c214f96507f$var$_memoTheme = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ad5c6c214f96507f$var$_MoreHoriz = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("jYtEk")));

var $ad5c6c214f96507f$var$_ButtonBase = $ad5c6c214f96507f$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $ayMG0 = parcelRequire("ayMG0");
const $ad5c6c214f96507f$var$BreadcrumbCollapsedButton = (0, $aAbgT.styled)($ad5c6c214f96507f$var$_ButtonBase.default, {
    name: 'MuiBreadcrumbCollapsed'
})((0, $ad5c6c214f96507f$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`,
        ...theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[700]
        } : {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[100]
        },
        borderRadius: 2,
        '&:hover, &:focus': {
            ...theme.palette.mode === 'light' ? {
                backgroundColor: theme.palette.grey[200]
            } : {
                backgroundColor: theme.palette.grey[600]
            }
        },
        '&:active': {
            boxShadow: theme.shadows[0],
            ...theme.palette.mode === 'light' ? {
                backgroundColor: (0, $h61zw.emphasize)(theme.palette.grey[200], 0.12)
            } : {
                backgroundColor: (0, $h61zw.emphasize)(theme.palette.grey[600], 0.12)
            }
        }
    })));
const $ad5c6c214f96507f$var$BreadcrumbCollapsedIcon = (0, $aAbgT.styled)($ad5c6c214f96507f$var$_MoreHoriz.default)({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $ad5c6c214f96507f$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, ...otherProps } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedButton, {
            focusRipple: true,
            ...otherProps,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ad5c6c214f96507f$var$BreadcrumbCollapsedIcon, {
                as: slots.CollapsedIcon,
                ownerState: ownerState,
                ...slotProps.collapsedIcon
            })
        })
    });
}
var $ad5c6c214f96507f$var$_default = module.exports.default = $ad5c6c214f96507f$var$BreadcrumbCollapsed;

});
parcelRegister("jYtEk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e8aa9eabd3007a18$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8aa9eabd3007a18$var$_createSvgIcon = $e8aa9eabd3007a18$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $e8aa9eabd3007a18$var$_default = module.exports.default = (0, $e8aa9eabd3007a18$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

});


parcelRegister("4d25s", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3109febd55ba98e0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getBreadcrumbsUtilityClass = $3109febd55ba98e0$var$getBreadcrumbsUtilityClass;

var $3109febd55ba98e0$var$_generateUtilityClasses = $3109febd55ba98e0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3109febd55ba98e0$var$_generateUtilityClass = $3109febd55ba98e0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3109febd55ba98e0$var$getBreadcrumbsUtilityClass(slot) {
    return (0, $3109febd55ba98e0$var$_generateUtilityClass.default)('MuiBreadcrumbs', slot);
}
const $3109febd55ba98e0$var$breadcrumbsClasses = (0, $3109febd55ba98e0$var$_generateUtilityClasses.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $3109febd55ba98e0$var$_default = module.exports.default = $3109febd55ba98e0$var$breadcrumbsClasses;

});



parcelRegister("8Jh2o", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $65afbe095ccffd1e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $65afbe095ccffd1e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65afbe095ccffd1e$var$_exportNames = {
    buttonGroupClasses: true,
    ButtonGroupContext: true,
    ButtonGroupButtonContext: true
};
Object.defineProperty(module.exports, "ButtonGroupButtonContext", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_ButtonGroupButtonContext.default;
    }
});
Object.defineProperty(module.exports, "ButtonGroupContext", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_ButtonGroupContext.default;
    }
});
Object.defineProperty(module.exports, "buttonGroupClasses", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_buttonGroupClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $65afbe095ccffd1e$var$_ButtonGroup.default;
    }
});

var $65afbe095ccffd1e$var$_ButtonGroup = $65afbe095ccffd1e$require$_interopRequireDefault((parcelRequire("2p5OG")));

var $65afbe095ccffd1e$var$_buttonGroupClasses = $65afbe095ccffd1e$require$_interopRequireWildcard((parcelRequire("d8s3C")));
Object.keys($65afbe095ccffd1e$var$_buttonGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($65afbe095ccffd1e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $65afbe095ccffd1e$var$_buttonGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $65afbe095ccffd1e$var$_buttonGroupClasses[key];
        }
    });
});

var $65afbe095ccffd1e$var$_ButtonGroupContext = $65afbe095ccffd1e$require$_interopRequireDefault((parcelRequire("bwtSM")));

var $65afbe095ccffd1e$var$_ButtonGroupButtonContext = $65afbe095ccffd1e$require$_interopRequireDefault((parcelRequire("3eDio")));

});
parcelRegister("2p5OG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1c026d95d0d4d482$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1c026d95d0d4d482$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c026d95d0d4d482$var$React = $1c026d95d0d4d482$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1c026d95d0d4d482$var$_propTypes = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1c026d95d0d4d482$var$_clsx = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1c026d95d0d4d482$var$_composeClasses = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1c026d95d0d4d482$var$_getValidReactChildren = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("2jgfV")));

var $1c026d95d0d4d482$var$_capitalize = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $1c026d95d0d4d482$var$_memoTheme = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $1c026d95d0d4d482$var$_createSimplePaletteValueFilter = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $1c026d95d0d4d482$var$_buttonGroupClasses = $1c026d95d0d4d482$require$_interopRequireWildcard((parcelRequire("d8s3C")));

var $1c026d95d0d4d482$var$_ButtonGroupContext = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("bwtSM")));

var $1c026d95d0d4d482$var$_ButtonGroupButtonContext = $1c026d95d0d4d482$require$_interopRequireDefault((parcelRequire("3eDio")));

var $ayMG0 = parcelRequire("ayMG0");
const $1c026d95d0d4d482$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles.grouped
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.orientation)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.variant)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.orientation)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(ownerState.color)}`]
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton}`]: styles.firstButton
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton}`]: styles.lastButton
        },
        {
            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $1c026d95d0d4d482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $1c026d95d0d4d482$var$_capitalize.default)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(orientation)}`,
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(variant)}`,
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(orientation)}`,
            `grouped${(0, $1c026d95d0d4d482$var$_capitalize.default)(variant)}${(0, $1c026d95d0d4d482$var$_capitalize.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $1c026d95d0d4d482$var$_composeClasses.default)(slots, $1c026d95d0d4d482$var$_buttonGroupClasses.getButtonGroupUtilityClass, classes);
};
const $1c026d95d0d4d482$var$ButtonGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $1c026d95d0d4d482$var$overridesResolver
})((0, $1c026d95d0d4d482$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2],
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    }
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1c026d95d0d4d482$var$_createSimplePaletteValueFilter.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.lastButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${$1c026d95d0d4d482$var$_buttonGroupClasses.default.disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1c026d95d0d4d482$var$_createSimplePaletteValueFilter.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.firstButton},& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${$1c026d95d0d4d482$var$_buttonGroupClasses.default.grouped}`]: {
            minWidth: 40
        }
    })));
const $1c026d95d0d4d482$var$ButtonGroup = /*#__PURE__*/ $1c026d95d0d4d482$var$React.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $1c026d95d0d4d482$var$useUtilityClasses(ownerState);
    const context = $1c026d95d0d4d482$var$React.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $1c026d95d0d4d482$var$_getValidReactChildren.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $1c026d95d0d4d482$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$_ButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$_ButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $1c026d95d0d4d482$var$_default = module.exports.default = $1c026d95d0d4d482$var$ButtonGroup;

});
parcelRegister("2jgfV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1ae9f731a004cefb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ae9f731a004cefb$var$_getValidReactChildren.default;
    }
});

var $1ae9f731a004cefb$var$_getValidReactChildren = $1ae9f731a004cefb$require$_interopRequireDefault((parcelRequire("6I7Xt")));

});
parcelRegister("6I7Xt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4e2d0676303c0919$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e2d0676303c0919$var$getValidReactChildren;

var $4e2d0676303c0919$var$React = $4e2d0676303c0919$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */ function $4e2d0676303c0919$var$getValidReactChildren(children) {
    return $4e2d0676303c0919$var$React.Children.toArray(children).filter((child)=>/*#__PURE__*/ $4e2d0676303c0919$var$React.isValidElement(child));
}

});


parcelRegister("d8s3C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9901c9510940cf3a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonGroupUtilityClass = $9901c9510940cf3a$var$getButtonGroupUtilityClass;

var $9901c9510940cf3a$var$_generateUtilityClasses = $9901c9510940cf3a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9901c9510940cf3a$var$_generateUtilityClass = $9901c9510940cf3a$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9901c9510940cf3a$var$getButtonGroupUtilityClass(slot) {
    return (0, $9901c9510940cf3a$var$_generateUtilityClass.default)('MuiButtonGroup', slot);
}
const $9901c9510940cf3a$var$buttonGroupClasses = (0, $9901c9510940cf3a$var$_generateUtilityClasses.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $9901c9510940cf3a$var$_default = module.exports.default = $9901c9510940cf3a$var$buttonGroupClasses;

});



parcelRegister("3HHKi", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2b27523fd597460f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2b27523fd597460f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2b27523fd597460f$var$_exportNames = {
    cardClasses: true
};
Object.defineProperty(module.exports, "cardClasses", {
    enumerable: true,
    get: function() {
        return $2b27523fd597460f$var$_cardClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b27523fd597460f$var$_Card.default;
    }
});

var $2b27523fd597460f$var$_Card = $2b27523fd597460f$require$_interopRequireDefault((parcelRequire("5WjaY")));

var $2b27523fd597460f$var$_cardClasses = $2b27523fd597460f$require$_interopRequireWildcard((parcelRequire("bOBRq")));
Object.keys($2b27523fd597460f$var$_cardClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2b27523fd597460f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2b27523fd597460f$var$_cardClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2b27523fd597460f$var$_cardClasses[key];
        }
    });
});

});
parcelRegister("5WjaY", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $45313e7d506ce734$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $45313e7d506ce734$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45313e7d506ce734$var$React = $45313e7d506ce734$require$_interopRequireWildcard((parcelRequire("acw62")));

var $45313e7d506ce734$var$_propTypes = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $45313e7d506ce734$var$_clsx = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("9QePP")));

var $45313e7d506ce734$var$_chainPropTypes = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("abVWF")));

var $45313e7d506ce734$var$_composeClasses = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $45313e7d506ce734$var$_Paper = $45313e7d506ce734$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $bOBRq = parcelRequire("bOBRq");

var $ayMG0 = parcelRequire("ayMG0");
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $45313e7d506ce734$var$_composeClasses.default)(slots, $bOBRq.getCardUtilityClass, classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $aAbgT.styled)($45313e7d506ce734$var$_Paper.default, {
    name: 'MuiCard',
    slot: 'Root'
})({
    overflow: 'hidden'
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $45313e7d506ce734$var$React.forwardRef(function Card(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, {
        className: (0, $45313e7d506ce734$var$_clsx.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $45313e7d506ce734$var$_default = module.exports.default = $45313e7d506ce734$var$Card;

});
parcelRegister("bOBRq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $89a1bb9709695920$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardUtilityClass = $89a1bb9709695920$var$getCardUtilityClass;

var $89a1bb9709695920$var$_generateUtilityClasses = $89a1bb9709695920$require$_interopRequireDefault((parcelRequire("5nY49")));

var $89a1bb9709695920$var$_generateUtilityClass = $89a1bb9709695920$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $89a1bb9709695920$var$getCardUtilityClass(slot) {
    return (0, $89a1bb9709695920$var$_generateUtilityClass.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $89a1bb9709695920$var$_generateUtilityClasses.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$var$_default = module.exports.default = $89a1bb9709695920$var$cardClasses;

});



parcelRegister("kIb8C", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f1408e763033c57b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f1408e763033c57b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f1408e763033c57b$var$_exportNames = {
    cardActionAreaClasses: true
};
Object.defineProperty(module.exports, "cardActionAreaClasses", {
    enumerable: true,
    get: function() {
        return $f1408e763033c57b$var$_cardActionAreaClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f1408e763033c57b$var$_CardActionArea.default;
    }
});

var $f1408e763033c57b$var$_CardActionArea = $f1408e763033c57b$require$_interopRequireDefault((parcelRequire("c3ykc")));

var $f1408e763033c57b$var$_cardActionAreaClasses = $f1408e763033c57b$require$_interopRequireWildcard((parcelRequire("6apEP")));
Object.keys($f1408e763033c57b$var$_cardActionAreaClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f1408e763033c57b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f1408e763033c57b$var$_cardActionAreaClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f1408e763033c57b$var$_cardActionAreaClasses[key];
        }
    });
});

});
parcelRegister("c3ykc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8c7064036f0f2f9d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8c7064036f0f2f9d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c7064036f0f2f9d$var$React = $8c7064036f0f2f9d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8c7064036f0f2f9d$var$_propTypes = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8c7064036f0f2f9d$var$_clsx = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8c7064036f0f2f9d$var$_composeClasses = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $8c7064036f0f2f9d$var$_memoTheme = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $8c7064036f0f2f9d$var$_cardActionAreaClasses = $8c7064036f0f2f9d$require$_interopRequireWildcard((parcelRequire("6apEP")));

var $8c7064036f0f2f9d$var$_ButtonBase = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $8c7064036f0f2f9d$var$_useSlot = $8c7064036f0f2f9d$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $8c7064036f0f2f9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        focusHighlight: [
            'focusHighlight'
        ]
    };
    return (0, $8c7064036f0f2f9d$var$_composeClasses.default)(slots, $8c7064036f0f2f9d$var$_cardActionAreaClasses.getCardActionAreaUtilityClass, classes);
};
const $8c7064036f0f2f9d$var$CardActionAreaRoot = (0, $aAbgT.styled)($8c7064036f0f2f9d$var$_ButtonBase.default, {
    name: 'MuiCardActionArea',
    slot: 'Root'
})((0, $8c7064036f0f2f9d$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'block',
        textAlign: 'inherit',
        borderRadius: 'inherit',
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: '100%',
        [`&:hover .${$8c7064036f0f2f9d$var$_cardActionAreaClasses.default.focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            '@media (hover: none)': {
                opacity: 0
            }
        },
        [`&.${$8c7064036f0f2f9d$var$_cardActionAreaClasses.default.focusVisible} .${$8c7064036f0f2f9d$var$_cardActionAreaClasses.default.focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    })));
const $8c7064036f0f2f9d$var$CardActionAreaFocusHighlight = (0, $aAbgT.styled)('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight'
})((0, $8c7064036f0f2f9d$var$_memoTheme.default)(({ theme: theme })=>({
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        opacity: 0,
        backgroundColor: 'currentcolor',
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short
        })
    })));
const $8c7064036f0f2f9d$var$CardActionArea = /*#__PURE__*/ $8c7064036f0f2f9d$var$React.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActionArea'
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = props;
    const classes = $8c7064036f0f2f9d$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $8c7064036f0f2f9d$var$_useSlot.default)('root', {
        elementType: $8c7064036f0f2f9d$var$CardActionAreaRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        className: (0, $8c7064036f0f2f9d$var$_clsx.default)(classes.root, className),
        additionalProps: {
            focusVisibleClassName: (0, $8c7064036f0f2f9d$var$_clsx.default)(focusVisibleClassName, classes.focusVisible)
        }
    });
    const [FocusHighlightSlot, focusHighlightProps] = (0, $8c7064036f0f2f9d$var$_useSlot.default)('focusHighlight', {
        elementType: $8c7064036f0f2f9d$var$CardActionAreaFocusHighlight,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.focusHighlight
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(FocusHighlightSlot, {
                ...focusHighlightProps
            })
        ]
    });
});
var $8c7064036f0f2f9d$var$_default = module.exports.default = $8c7064036f0f2f9d$var$CardActionArea;

});
parcelRegister("6apEP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $47d794472d40adee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardActionAreaUtilityClass = $47d794472d40adee$var$getCardActionAreaUtilityClass;

var $47d794472d40adee$var$_generateUtilityClasses = $47d794472d40adee$require$_interopRequireDefault((parcelRequire("5nY49")));

var $47d794472d40adee$var$_generateUtilityClass = $47d794472d40adee$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $47d794472d40adee$var$getCardActionAreaUtilityClass(slot) {
    return (0, $47d794472d40adee$var$_generateUtilityClass.default)('MuiCardActionArea', slot);
}
const $47d794472d40adee$var$cardActionAreaClasses = (0, $47d794472d40adee$var$_generateUtilityClasses.default)('MuiCardActionArea', [
    'root',
    'focusVisible',
    'focusHighlight'
]);
var $47d794472d40adee$var$_default = module.exports.default = $47d794472d40adee$var$cardActionAreaClasses;

});



parcelRegister("Hi2UE", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $082203d287675024$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $082203d287675024$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $082203d287675024$var$_exportNames = {
    cardActionsClasses: true
};
Object.defineProperty(module.exports, "cardActionsClasses", {
    enumerable: true,
    get: function() {
        return $082203d287675024$var$_cardActionsClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $082203d287675024$var$_CardActions.default;
    }
});

var $082203d287675024$var$_CardActions = $082203d287675024$require$_interopRequireDefault((parcelRequire("fulwV")));

var $082203d287675024$var$_cardActionsClasses = $082203d287675024$require$_interopRequireWildcard((parcelRequire("6yuOx")));
Object.keys($082203d287675024$var$_cardActionsClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($082203d287675024$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $082203d287675024$var$_cardActionsClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $082203d287675024$var$_cardActionsClasses[key];
        }
    });
});

});
parcelRegister("fulwV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b46a5bcac23a5f99$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b46a5bcac23a5f99$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46a5bcac23a5f99$var$React = $b46a5bcac23a5f99$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b46a5bcac23a5f99$var$_propTypes = $b46a5bcac23a5f99$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b46a5bcac23a5f99$var$_clsx = $b46a5bcac23a5f99$require$_interopRequireDefault((parcelRequire("9QePP")));

var $b46a5bcac23a5f99$var$_composeClasses = $b46a5bcac23a5f99$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $6yuOx = parcelRequire("6yuOx");

var $ayMG0 = parcelRequire("ayMG0");
const $b46a5bcac23a5f99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $b46a5bcac23a5f99$var$_composeClasses.default)(slots, $6yuOx.getCardActionsUtilityClass, classes);
};
const $b46a5bcac23a5f99$var$CardActionsRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    variants: [
        {
            props: {
                disableSpacing: false
            },
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $b46a5bcac23a5f99$var$CardActions = /*#__PURE__*/ $b46a5bcac23a5f99$var$React.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActions'
    });
    const { disableSpacing: disableSpacing = false, className: className, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $b46a5bcac23a5f99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b46a5bcac23a5f99$var$CardActionsRoot, {
        className: (0, $b46a5bcac23a5f99$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $b46a5bcac23a5f99$var$_default = module.exports.default = $b46a5bcac23a5f99$var$CardActions;

});
parcelRegister("6yuOx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c5dd21dca115198$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardActionsUtilityClass = $4c5dd21dca115198$var$getCardActionsUtilityClass;

var $4c5dd21dca115198$var$_generateUtilityClasses = $4c5dd21dca115198$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4c5dd21dca115198$var$_generateUtilityClass = $4c5dd21dca115198$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4c5dd21dca115198$var$getCardActionsUtilityClass(slot) {
    return (0, $4c5dd21dca115198$var$_generateUtilityClass.default)('MuiCardActions', slot);
}
const $4c5dd21dca115198$var$cardActionsClasses = (0, $4c5dd21dca115198$var$_generateUtilityClasses.default)('MuiCardActions', [
    'root',
    'spacing'
]);
var $4c5dd21dca115198$var$_default = module.exports.default = $4c5dd21dca115198$var$cardActionsClasses;

});



parcelRegister("lQHMI", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fe806b09c0847150$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fe806b09c0847150$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fe806b09c0847150$var$_exportNames = {
    cardContentClasses: true
};
Object.defineProperty(module.exports, "cardContentClasses", {
    enumerable: true,
    get: function() {
        return $fe806b09c0847150$var$_cardContentClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fe806b09c0847150$var$_CardContent.default;
    }
});

var $fe806b09c0847150$var$_CardContent = $fe806b09c0847150$require$_interopRequireDefault((parcelRequire("3ulHf")));

var $fe806b09c0847150$var$_cardContentClasses = $fe806b09c0847150$require$_interopRequireWildcard((parcelRequire("3mVgJ")));
Object.keys($fe806b09c0847150$var$_cardContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fe806b09c0847150$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fe806b09c0847150$var$_cardContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fe806b09c0847150$var$_cardContentClasses[key];
        }
    });
});

});
parcelRegister("3ulHf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $28a500ea92f2665f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $28a500ea92f2665f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28a500ea92f2665f$var$React = $28a500ea92f2665f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $28a500ea92f2665f$var$_propTypes = $28a500ea92f2665f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $28a500ea92f2665f$var$_clsx = $28a500ea92f2665f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $28a500ea92f2665f$var$_composeClasses = $28a500ea92f2665f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $3mVgJ = parcelRequire("3mVgJ");

var $ayMG0 = parcelRequire("ayMG0");
const $28a500ea92f2665f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $28a500ea92f2665f$var$_composeClasses.default)(slots, $3mVgJ.getCardContentUtilityClass, classes);
};
const $28a500ea92f2665f$var$CardContentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardContent',
    slot: 'Root'
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $28a500ea92f2665f$var$CardContent = /*#__PURE__*/ $28a500ea92f2665f$var$React.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $28a500ea92f2665f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28a500ea92f2665f$var$CardContentRoot, {
        as: component,
        className: (0, $28a500ea92f2665f$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $28a500ea92f2665f$var$_default = module.exports.default = $28a500ea92f2665f$var$CardContent;

});
parcelRegister("3mVgJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $273fd99738f3adbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardContentUtilityClass = $273fd99738f3adbe$var$getCardContentUtilityClass;

var $273fd99738f3adbe$var$_generateUtilityClasses = $273fd99738f3adbe$require$_interopRequireDefault((parcelRequire("5nY49")));

var $273fd99738f3adbe$var$_generateUtilityClass = $273fd99738f3adbe$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $273fd99738f3adbe$var$getCardContentUtilityClass(slot) {
    return (0, $273fd99738f3adbe$var$_generateUtilityClass.default)('MuiCardContent', slot);
}
const $273fd99738f3adbe$var$cardContentClasses = (0, $273fd99738f3adbe$var$_generateUtilityClasses.default)('MuiCardContent', [
    'root'
]);
var $273fd99738f3adbe$var$_default = module.exports.default = $273fd99738f3adbe$var$cardContentClasses;

});



parcelRegister("4DqKh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $35ff8d0aba128694$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $35ff8d0aba128694$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $35ff8d0aba128694$var$_exportNames = {
    cardHeaderClasses: true
};
Object.defineProperty(module.exports, "cardHeaderClasses", {
    enumerable: true,
    get: function() {
        return $35ff8d0aba128694$var$_cardHeaderClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $35ff8d0aba128694$var$_CardHeader.default;
    }
});

var $35ff8d0aba128694$var$_CardHeader = $35ff8d0aba128694$require$_interopRequireDefault((parcelRequire("g9Cmg")));

var $35ff8d0aba128694$var$_cardHeaderClasses = $35ff8d0aba128694$require$_interopRequireWildcard((parcelRequire("TvS1j")));
Object.keys($35ff8d0aba128694$var$_cardHeaderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($35ff8d0aba128694$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $35ff8d0aba128694$var$_cardHeaderClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $35ff8d0aba128694$var$_cardHeaderClasses[key];
        }
    });
});

});
parcelRegister("g9Cmg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bc2b3dbd11553d00$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bc2b3dbd11553d00$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2b3dbd11553d00$var$React = $bc2b3dbd11553d00$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bc2b3dbd11553d00$var$_propTypes = $bc2b3dbd11553d00$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bc2b3dbd11553d00$var$_composeClasses = $bc2b3dbd11553d00$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bc2b3dbd11553d00$var$_Typography = $bc2b3dbd11553d00$require$_interopRequireWildcard((parcelRequire("2dUd7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $bc2b3dbd11553d00$var$_cardHeaderClasses = $bc2b3dbd11553d00$require$_interopRequireWildcard((parcelRequire("TvS1j")));

var $bc2b3dbd11553d00$var$_useSlot = $bc2b3dbd11553d00$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $bc2b3dbd11553d00$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $bc2b3dbd11553d00$var$_composeClasses.default)(slots, $bc2b3dbd11553d00$var$_cardHeaderClasses.getCardHeaderUtilityClass, classes);
};
const $bc2b3dbd11553d00$var$CardHeaderRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.title}`]: styles.title
            },
            {
                [`& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $bc2b3dbd11553d00$var$CardHeaderAvatar = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar'
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $bc2b3dbd11553d00$var$CardHeaderAction = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Action'
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $bc2b3dbd11553d00$var$CardHeaderContent = (0, $aAbgT.styled)('div', {
    name: 'MuiCardHeader',
    slot: 'Content'
})({
    flex: '1 1 auto',
    [`.${$bc2b3dbd11553d00$var$_Typography.typographyClasses.root}:where(& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.title}), .${$bc2b3dbd11553d00$var$_Typography.typographyClasses.root}:where(& .${$bc2b3dbd11553d00$var$_cardHeaderClasses.default.subheader})`]: {
        display: 'block'
    }
});
const $bc2b3dbd11553d00$var$CardHeader = /*#__PURE__*/ $bc2b3dbd11553d00$var$React.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableTypography: disableTypography
    };
    const classes = $bc2b3dbd11553d00$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            title: titleTypographyProps,
            subheader: subheaderTypographyProps,
            ...slotProps
        }
    };
    let title = titleProp;
    const [TitleSlot, titleSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('title', {
        className: classes.title,
        elementType: $bc2b3dbd11553d00$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    });
    if (title != null && title.type !== $bc2b3dbd11553d00$var$_Typography.default && !disableTypography) title = /*#__PURE__*/ (0, $ayMG0.jsx)(TitleSlot, {
        ...titleSlotProps,
        children: title
    });
    let subheader = subheaderProp;
    const [SubheaderSlot, subheaderSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('subheader', {
        className: classes.subheader,
        elementType: $bc2b3dbd11553d00$var$_Typography.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    });
    if (subheader != null && subheader.type !== $bc2b3dbd11553d00$var$_Typography.default && !disableTypography) subheader = /*#__PURE__*/ (0, $ayMG0.jsx)(SubheaderSlot, {
        ...subheaderSlotProps,
        children: subheader
    });
    const [RootSlot, rootSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $bc2b3dbd11553d00$var$CardHeaderRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [AvatarSlot, avatarSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('avatar', {
        className: classes.avatar,
        elementType: $bc2b3dbd11553d00$var$CardHeaderAvatar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('content', {
        className: classes.content,
        elementType: $bc2b3dbd11553d00$var$CardHeaderContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $bc2b3dbd11553d00$var$_useSlot.default)('action', {
        className: classes.action,
        elementType: $bc2b3dbd11553d00$var$CardHeaderAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            avatar && /*#__PURE__*/ (0, $ayMG0.jsx)(AvatarSlot, {
                ...avatarSlotProps,
                children: avatar
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ContentSlot, {
                ...contentSlotProps,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            })
        ]
    });
});
var $bc2b3dbd11553d00$var$_default = module.exports.default = $bc2b3dbd11553d00$var$CardHeader;

});
parcelRegister("TvS1j", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0a6ddbf21430a4ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardHeaderUtilityClass = $0a6ddbf21430a4ea$var$getCardHeaderUtilityClass;

var $0a6ddbf21430a4ea$var$_generateUtilityClasses = $0a6ddbf21430a4ea$require$_interopRequireDefault((parcelRequire("5nY49")));

var $0a6ddbf21430a4ea$var$_generateUtilityClass = $0a6ddbf21430a4ea$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $0a6ddbf21430a4ea$var$getCardHeaderUtilityClass(slot) {
    return (0, $0a6ddbf21430a4ea$var$_generateUtilityClass.default)('MuiCardHeader', slot);
}
const $0a6ddbf21430a4ea$var$cardHeaderClasses = (0, $0a6ddbf21430a4ea$var$_generateUtilityClasses.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $0a6ddbf21430a4ea$var$_default = module.exports.default = $0a6ddbf21430a4ea$var$cardHeaderClasses;

});



parcelRegister("epQZV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a7ec82c27a16d3bc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a7ec82c27a16d3bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a7ec82c27a16d3bc$var$_exportNames = {
    cardMediaClasses: true
};
Object.defineProperty(module.exports, "cardMediaClasses", {
    enumerable: true,
    get: function() {
        return $a7ec82c27a16d3bc$var$_cardMediaClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a7ec82c27a16d3bc$var$_CardMedia.default;
    }
});

var $a7ec82c27a16d3bc$var$_CardMedia = $a7ec82c27a16d3bc$require$_interopRequireDefault((parcelRequire("bLOCA")));

var $a7ec82c27a16d3bc$var$_cardMediaClasses = $a7ec82c27a16d3bc$require$_interopRequireWildcard((parcelRequire("9ROVq")));
Object.keys($a7ec82c27a16d3bc$var$_cardMediaClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a7ec82c27a16d3bc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a7ec82c27a16d3bc$var$_cardMediaClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a7ec82c27a16d3bc$var$_cardMediaClasses[key];
        }
    });
});

});
parcelRegister("bLOCA", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $891b59d4b36435bb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $891b59d4b36435bb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $891b59d4b36435bb$var$React = $891b59d4b36435bb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $891b59d4b36435bb$var$_propTypes = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $891b59d4b36435bb$var$_clsx = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $891b59d4b36435bb$var$_chainPropTypes = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("abVWF")));

var $891b59d4b36435bb$var$_composeClasses = $891b59d4b36435bb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $9ROVq = parcelRequire("9ROVq");

var $ayMG0 = parcelRequire("ayMG0");
const $891b59d4b36435bb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $891b59d4b36435bb$var$_composeClasses.default)(slots, $9ROVq.getCardMediaUtilityClass, classes);
};
const $891b59d4b36435bb$var$CardMediaRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})({
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    variants: [
        {
            props: {
                isMediaComponent: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                isImageComponent: true
            },
            style: {
                objectFit: 'cover'
            }
        }
    ]
});
const $891b59d4b36435bb$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $891b59d4b36435bb$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $891b59d4b36435bb$var$CardMedia = /*#__PURE__*/ $891b59d4b36435bb$var$React.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style, ...other } = props;
    const isMediaComponent = $891b59d4b36435bb$var$MEDIA_COMPONENTS.includes(component);
    const composedStyle = !isMediaComponent && image ? {
        backgroundImage: `url("${image}")`,
        ...style
    } : style;
    const ownerState = {
        ...props,
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $891b59d4b36435bb$var$IMAGE_COMPONENTS.includes(component)
    };
    const classes = $891b59d4b36435bb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($891b59d4b36435bb$var$CardMediaRoot, {
        className: (0, $891b59d4b36435bb$var$_clsx.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined,
        ...other,
        children: children
    });
});
var $891b59d4b36435bb$var$_default = module.exports.default = $891b59d4b36435bb$var$CardMedia;

});
parcelRegister("9ROVq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $72f090ff2322b6ae$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCardMediaUtilityClass = $72f090ff2322b6ae$var$getCardMediaUtilityClass;

var $72f090ff2322b6ae$var$_generateUtilityClasses = $72f090ff2322b6ae$require$_interopRequireDefault((parcelRequire("5nY49")));

var $72f090ff2322b6ae$var$_generateUtilityClass = $72f090ff2322b6ae$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $72f090ff2322b6ae$var$getCardMediaUtilityClass(slot) {
    return (0, $72f090ff2322b6ae$var$_generateUtilityClass.default)('MuiCardMedia', slot);
}
const $72f090ff2322b6ae$var$cardMediaClasses = (0, $72f090ff2322b6ae$var$_generateUtilityClasses.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $72f090ff2322b6ae$var$_default = module.exports.default = $72f090ff2322b6ae$var$cardMediaClasses;

});



parcelRegister("9GQ55", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $70e06f8560e22c27$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $70e06f8560e22c27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $70e06f8560e22c27$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $70e06f8560e22c27$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $70e06f8560e22c27$var$_Container.default;
    }
});

var $70e06f8560e22c27$var$_Container = $70e06f8560e22c27$require$_interopRequireDefault((parcelRequire("2Y0IO")));

var $70e06f8560e22c27$var$_containerClasses = $70e06f8560e22c27$require$_interopRequireWildcard((parcelRequire("grIpz")));
Object.keys($70e06f8560e22c27$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($70e06f8560e22c27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $70e06f8560e22c27$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $70e06f8560e22c27$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("2Y0IO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2291beb327d500f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2291beb327d500f8$var$_propTypes = $2291beb327d500f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $2291beb327d500f8$var$_capitalize = $2291beb327d500f8$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2291beb327d500f8$var$_styled = $2291beb327d500f8$require$_interopRequireDefault((parcelRequire("d8seH")));

var $hL1nr = parcelRequire("hL1nr");
const $2291beb327d500f8$var$Container = (0, $izOUK.createContainer)({
    createStyledComponent: (0, $2291beb327d500f8$var$_styled.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $2291beb327d500f8$var$_capitalize.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $hL1nr.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $2291beb327d500f8$var$_default = module.exports.default = $2291beb327d500f8$var$Container;

});

parcelRegister("grIpz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bf919e292c78caff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $bf919e292c78caff$var$getContainerUtilityClass;

var $bf919e292c78caff$var$_generateUtilityClasses = $bf919e292c78caff$require$_interopRequireDefault((parcelRequire("5nY49")));

var $bf919e292c78caff$var$_generateUtilityClass = $bf919e292c78caff$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $bf919e292c78caff$var$getContainerUtilityClass(slot) {
    return (0, $bf919e292c78caff$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $bf919e292c78caff$var$containerClasses = (0, $bf919e292c78caff$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $bf919e292c78caff$var$_default = module.exports.default = $bf919e292c78caff$var$containerClasses;

});


parcelRegister("bl1Nj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $84130c31a3f49bb6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $84130c31a3f49bb6$var$_CssBaseline.default;
    }
});

var $84130c31a3f49bb6$var$_CssBaseline = $84130c31a3f49bb6$require$_interopRequireDefault((parcelRequire("gODrq")));

});
parcelRegister("gODrq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c3dfe91526ac04a1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c3dfe91526ac04a1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styles = module.exports.html = module.exports.default = module.exports.body = void 0;

var $c3dfe91526ac04a1$var$React = $c3dfe91526ac04a1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c3dfe91526ac04a1$var$_propTypes = $c3dfe91526ac04a1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
// to determine if the global styles are static or dynamic
const $c3dfe91526ac04a1$var$isDynamicSupport = typeof (0, $aAbgT.globalCss)({}) === 'function';
const $c3dfe91526ac04a1$var$html = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
module.exports.html = $c3dfe91526ac04a1$var$html;
const $c3dfe91526ac04a1$var$body = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
module.exports.body = $c3dfe91526ac04a1$var$body;
const $c3dfe91526ac04a1$var$styles = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $c3dfe91526ac04a1$var$html(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$c3dfe91526ac04a1$var$body(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
module.exports.styles = $c3dfe91526ac04a1$var$styles;
const $c3dfe91526ac04a1$var$SELECTOR = 'mui-ecs';
const $c3dfe91526ac04a1$var$staticStyles = (theme)=>{
    const result = $c3dfe91526ac04a1$var$styles(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$c3dfe91526ac04a1$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $c3dfe91526ac04a1$var$GlobalStyles = (0, $aAbgT.globalCss)($c3dfe91526ac04a1$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$c3dfe91526ac04a1$var$styles(theme, enableColorScheme) : ({ theme: theme })=>$c3dfe91526ac04a1$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c3dfe91526ac04a1$var$React.Fragment, {
        children: [
            $c3dfe91526ac04a1$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($c3dfe91526ac04a1$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$c3dfe91526ac04a1$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $c3dfe91526ac04a1$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $c3dfe91526ac04a1$var$_default = module.exports.default = $c3dfe91526ac04a1$var$CssBaseline;

});


parcelRegister("4tB5n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3426a3520e69a38c$var$darkScrollbar;
// track, thumb and active are derived from macOS 10.15.7
const $3426a3520e69a38c$var$scrollBar = {
    track: '#2b2b2b',
    thumb: '#6b6b6b',
    active: '#959595'
};
function $3426a3520e69a38c$var$darkScrollbar(options = $3426a3520e69a38c$var$scrollBar) {
    return {
        scrollbarColor: `${options.thumb} ${options.track}`,
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            backgroundColor: options.track
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: options.thumb,
            minHeight: 24,
            border: `3px solid ${options.track}`
        },
        '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: options.active
        },
        '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: options.track
        }
    };
}

});

parcelRegister("aX9Qs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7f970d1ffd61b921$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7f970d1ffd61b921$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7f970d1ffd61b921$var$_exportNames = {
    dialogContentTextClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7f970d1ffd61b921$var$_DialogContentText.default;
    }
});
Object.defineProperty(module.exports, "dialogContentTextClasses", {
    enumerable: true,
    get: function() {
        return $7f970d1ffd61b921$var$_dialogContentTextClasses.default;
    }
});

var $7f970d1ffd61b921$var$_DialogContentText = $7f970d1ffd61b921$require$_interopRequireDefault((parcelRequire("eFqab")));

var $7f970d1ffd61b921$var$_dialogContentTextClasses = $7f970d1ffd61b921$require$_interopRequireWildcard((parcelRequire("8ANtp")));
Object.keys($7f970d1ffd61b921$var$_dialogContentTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7f970d1ffd61b921$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7f970d1ffd61b921$var$_dialogContentTextClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7f970d1ffd61b921$var$_dialogContentTextClasses[key];
        }
    });
});

});
parcelRegister("eFqab", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $aad93085434ac13f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $aad93085434ac13f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aad93085434ac13f$var$React = $aad93085434ac13f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aad93085434ac13f$var$_propTypes = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aad93085434ac13f$var$_clsx = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aad93085434ac13f$var$_composeClasses = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aad93085434ac13f$var$_rootShouldForwardProp = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $aad93085434ac13f$var$_Typography = $aad93085434ac13f$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $8ANtp = parcelRequire("8ANtp");

var $ayMG0 = parcelRequire("ayMG0");
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $aad93085434ac13f$var$_composeClasses.default)(slots, $8ANtp.getDialogContentTextUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $aAbgT.styled)($aad93085434ac13f$var$_Typography.default, {
    shouldForwardProp: (prop)=>(0, $aad93085434ac13f$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $aad93085434ac13f$var$React.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $aad93085434ac13f$var$_clsx.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $aad93085434ac13f$var$_default = module.exports.default = $aad93085434ac13f$var$DialogContentText;

});
parcelRegister("8ANtp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $64180fe1152829a7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getDialogContentTextUtilityClass = $64180fe1152829a7$var$getDialogContentTextUtilityClass;

var $64180fe1152829a7$var$_generateUtilityClasses = $64180fe1152829a7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $64180fe1152829a7$var$_generateUtilityClass = $64180fe1152829a7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $64180fe1152829a7$var$getDialogContentTextUtilityClass(slot) {
    return (0, $64180fe1152829a7$var$_generateUtilityClass.default)('MuiDialogContentText', slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $64180fe1152829a7$var$_generateUtilityClasses.default)('MuiDialogContentText', [
    'root'
]);
var $64180fe1152829a7$var$_default = module.exports.default = $64180fe1152829a7$var$dialogContentTextClasses;

});



parcelRegister("2r6m0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1c63081f73fd2072$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1c63081f73fd2072$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1c63081f73fd2072$var$_exportNames = {
    fabClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1c63081f73fd2072$var$_Fab.default;
    }
});
Object.defineProperty(module.exports, "fabClasses", {
    enumerable: true,
    get: function() {
        return $1c63081f73fd2072$var$_fabClasses.default;
    }
});

var $1c63081f73fd2072$var$_Fab = $1c63081f73fd2072$require$_interopRequireDefault((parcelRequire("36qXg")));

var $1c63081f73fd2072$var$_fabClasses = $1c63081f73fd2072$require$_interopRequireWildcard((parcelRequire("dUss3")));
Object.keys($1c63081f73fd2072$var$_fabClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1c63081f73fd2072$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1c63081f73fd2072$var$_fabClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1c63081f73fd2072$var$_fabClasses[key];
        }
    });
});

});
parcelRegister("36qXg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2426d7556721cbb6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2426d7556721cbb6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2426d7556721cbb6$var$React = $2426d7556721cbb6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2426d7556721cbb6$var$_propTypes = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2426d7556721cbb6$var$_clsx = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2426d7556721cbb6$var$_composeClasses = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2426d7556721cbb6$var$_ButtonBase = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $2426d7556721cbb6$var$_capitalize = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2426d7556721cbb6$var$_fabClasses = $2426d7556721cbb6$require$_interopRequireWildcard((parcelRequire("dUss3")));

var $2426d7556721cbb6$var$_rootShouldForwardProp = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $2426d7556721cbb6$var$_memoTheme = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $2426d7556721cbb6$var$_createSimplePaletteValueFilter = $2426d7556721cbb6$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $2426d7556721cbb6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $2426d7556721cbb6$var$_capitalize.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $2426d7556721cbb6$var$_composeClasses.default)(slots, $2426d7556721cbb6$var$_fabClasses.getFabUtilityClass, classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $2426d7556721cbb6$var$FabRoot = (0, $aAbgT.styled)($2426d7556721cbb6$var$_ButtonBase.default, {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $2426d7556721cbb6$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $2426d7556721cbb6$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $2426d7556721cbb6$var$_capitalize.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $2426d7556721cbb6$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.grey[900] : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${$2426d7556721cbb6$var$_fabClasses.default.focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $2426d7556721cbb6$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $2426d7556721cbb6$var$_createSimplePaletteValueFilter.default)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $2426d7556721cbb6$var$_memoTheme.default)(({ theme: theme })=>({
        [`&.${$2426d7556721cbb6$var$_fabClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $2426d7556721cbb6$var$Fab = /*#__PURE__*/ $2426d7556721cbb6$var$React.forwardRef(function Fab(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $2426d7556721cbb6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2426d7556721cbb6$var$FabRoot, {
        className: (0, $2426d7556721cbb6$var$_clsx.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $2426d7556721cbb6$var$_clsx.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: classes,
        children: children
    });
});
var $2426d7556721cbb6$var$_default = module.exports.default = $2426d7556721cbb6$var$Fab;

});
parcelRegister("dUss3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a206933548dacbdf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFabUtilityClass = $a206933548dacbdf$var$getFabUtilityClass;

var $a206933548dacbdf$var$_generateUtilityClasses = $a206933548dacbdf$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a206933548dacbdf$var$_generateUtilityClass = $a206933548dacbdf$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a206933548dacbdf$var$getFabUtilityClass(slot) {
    return (0, $a206933548dacbdf$var$_generateUtilityClass.default)('MuiFab', slot);
}
const $a206933548dacbdf$var$fabClasses = (0, $a206933548dacbdf$var$_generateUtilityClasses.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $a206933548dacbdf$var$_default = module.exports.default = $a206933548dacbdf$var$fabClasses;

});



parcelRegister("buuiu", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85d9ff6e52a65e06$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $85d9ff6e52a65e06$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85d9ff6e52a65e06$var$_exportNames = {
    formGroupClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85d9ff6e52a65e06$var$_FormGroup.default;
    }
});
Object.defineProperty(module.exports, "formGroupClasses", {
    enumerable: true,
    get: function() {
        return $85d9ff6e52a65e06$var$_formGroupClasses.default;
    }
});

var $85d9ff6e52a65e06$var$_FormGroup = $85d9ff6e52a65e06$require$_interopRequireDefault((parcelRequire("6Tegk")));

var $85d9ff6e52a65e06$var$_formGroupClasses = $85d9ff6e52a65e06$require$_interopRequireWildcard((parcelRequire("j5wWn")));
Object.keys($85d9ff6e52a65e06$var$_formGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85d9ff6e52a65e06$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85d9ff6e52a65e06$var$_formGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85d9ff6e52a65e06$var$_formGroupClasses[key];
        }
    });
});

});
parcelRegister("6Tegk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5042f159189dda87$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5042f159189dda87$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5042f159189dda87$var$React = $5042f159189dda87$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5042f159189dda87$var$_propTypes = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5042f159189dda87$var$_clsx = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5042f159189dda87$var$_composeClasses = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $j5wWn = parcelRequire("j5wWn");

var $5042f159189dda87$var$_useFormControl = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $5042f159189dda87$var$_formControlState = $5042f159189dda87$require$_interopRequireDefault((parcelRequire("aaphR")));

var $ayMG0 = parcelRequire("ayMG0");
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $5042f159189dda87$var$_composeClasses.default)(slots, $j5wWn.getFormGroupUtilityClass, classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $5042f159189dda87$var$React.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $5042f159189dda87$var$_useFormControl.default)();
    const fcs = (0, $5042f159189dda87$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, {
        className: (0, $5042f159189dda87$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $5042f159189dda87$var$_default = module.exports.default = $5042f159189dda87$var$FormGroup;

});
parcelRegister("j5wWn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $de580948e3d734b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormGroupUtilityClass = $de580948e3d734b1$var$getFormGroupUtilityClass;

var $de580948e3d734b1$var$_generateUtilityClasses = $de580948e3d734b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $de580948e3d734b1$var$_generateUtilityClass = $de580948e3d734b1$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $de580948e3d734b1$var$getFormGroupUtilityClass(slot) {
    return (0, $de580948e3d734b1$var$_generateUtilityClass.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $de580948e3d734b1$var$_generateUtilityClasses.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$var$_default = module.exports.default = $de580948e3d734b1$var$formGroupClasses;

});



parcelRegister("jNkhK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e692542356e1b3b3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e692542356e1b3b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e692542356e1b3b3$var$_exportNames = {
    gridLegacyClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e692542356e1b3b3$var$_GridLegacy.default;
    }
});
Object.defineProperty(module.exports, "gridLegacyClasses", {
    enumerable: true,
    get: function() {
        return $e692542356e1b3b3$var$_gridLegacyClasses.default;
    }
});

var $e692542356e1b3b3$var$_GridLegacy = $e692542356e1b3b3$require$_interopRequireDefault((parcelRequire("7PZ8a")));

var $e692542356e1b3b3$var$_gridLegacyClasses = $e692542356e1b3b3$require$_interopRequireWildcard((parcelRequire("6qE3E")));
Object.keys($e692542356e1b3b3$var$_gridLegacyClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e692542356e1b3b3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e692542356e1b3b3$var$_gridLegacyClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e692542356e1b3b3$var$_gridLegacyClasses[key];
        }
    });
});

});
parcelRegister("7PZ8a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5b4cb71c8460708a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5b4cb71c8460708a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.generateColumnGap = $5b4cb71c8460708a$var$generateColumnGap;
module.exports.generateDirection = $5b4cb71c8460708a$var$generateDirection;
module.exports.generateGridLegacy = $5b4cb71c8460708a$var$generateGridLegacy;
module.exports.generateRowGap = $5b4cb71c8460708a$var$generateRowGap;
module.exports.resolveSpacingClasses = $5b4cb71c8460708a$var$resolveSpacingClasses;
module.exports.resolveSpacingStyles = $5b4cb71c8460708a$var$resolveSpacingStyles;

var $5b4cb71c8460708a$var$React = $5b4cb71c8460708a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5b4cb71c8460708a$var$_propTypes = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5b4cb71c8460708a$var$_clsx = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $izOUK = parcelRequire("izOUK");

var $l6FST = parcelRequire("l6FST");

var $5b4cb71c8460708a$var$_composeClasses = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5b4cb71c8460708a$var$_requirePropFactory = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $5b4cb71c8460708a$var$_styled = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("d8seH")));

var $hL1nr = parcelRequire("hL1nr");

var $5b4cb71c8460708a$var$_useTheme = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("14H9o")));

var $5b4cb71c8460708a$var$_GridLegacyContext = $5b4cb71c8460708a$require$_interopRequireDefault((parcelRequire("8961s")));

var $5b4cb71c8460708a$var$_gridLegacyClasses = $5b4cb71c8460708a$require$_interopRequireWildcard((parcelRequire("6qE3E")));

var $ayMG0 = parcelRequire("ayMG0");
let $5b4cb71c8460708a$var$warnedOnce = false;
function $5b4cb71c8460708a$var$warnAboutDeprecatedGridLegacy() {
    $5b4cb71c8460708a$var$warnedOnce;
}
function $5b4cb71c8460708a$var$generateGridLegacy({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $izOUK.unstable_resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${themeSpacing})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = {
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width,
                ...more
            };
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $5b4cb71c8460708a$var$generateDirection({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $izOUK.unstable_resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $izOUK.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.startsWith('column')) output[`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $5b4cb71c8460708a$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $5b4cb71c8460708a$var$generateRowGap({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $izOUK.unstable_resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $5b4cb71c8460708a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $izOUK.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `calc(-1 * ${themeSpacing})`,
                [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                    paddingTop: themeSpacing
                }
            };
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $5b4cb71c8460708a$var$generateColumnGap({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $izOUK.unstable_resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $5b4cb71c8460708a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $izOUK.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') {
                const negativeValue = `calc(-1 * ${themeSpacing})`;
                return {
                    width: `calc(100% + ${themeSpacing})`,
                    marginLeft: negativeValue,
                    [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                        paddingLeft: themeSpacing
                    }
                };
            }
            if (zeroValueBreakpointKeys?.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${$5b4cb71c8460708a$var$_gridLegacyClasses.default.item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $5b4cb71c8460708a$var$resolveSpacingStyles(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $5b4cb71c8460708a$var$GridLegacyRoot = (0, $5b4cb71c8460708a$var$_styled.default)('div', {
    name: 'MuiGridLegacy',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $5b4cb71c8460708a$var$resolveSpacingStyles(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(// FIXME(romgrk): Can't use memoTheme here
({ ownerState: ownerState })=>({
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        ...ownerState.item && {
            margin: 0 // For instance, it's useful when used with a `figure` element.
        },
        ...ownerState.zeroMinWidth && {
            minWidth: 0
        },
        ...ownerState.wrap !== 'wrap' && {
            flexWrap: ownerState.wrap
        }
    }), $5b4cb71c8460708a$var$generateDirection, $5b4cb71c8460708a$var$generateRowGap, $5b4cb71c8460708a$var$generateColumnGap, $5b4cb71c8460708a$var$generateGridLegacy);
function $5b4cb71c8460708a$var$resolveSpacingClasses(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $5b4cb71c8460708a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $5b4cb71c8460708a$var$resolveSpacingClasses(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $5b4cb71c8460708a$var$_composeClasses.default)(slots, $5b4cb71c8460708a$var$_gridLegacyClasses.getGridLegacyUtilityClass, classes);
};
/**
 * @deprecated Use the [`Grid`](https://mui.com/material-ui/react-grid/) component instead.
 */ const $5b4cb71c8460708a$var$GridLegacy = /*#__PURE__*/ $5b4cb71c8460708a$var$React.forwardRef(function GridLegacy(inProps, ref) {
    const themeProps = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiGridLegacy'
    });
    const { breakpoints: breakpoints } = (0, $5b4cb71c8460708a$var$_useTheme.default)();
    const props = (0, $l6FST.extendSxProp)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false, ...other } = props;
    $5b4cb71c8460708a$var$React.useEffect(()=>{
        $5b4cb71c8460708a$var$warnAboutDeprecatedGridLegacy();
    }, []);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $5b4cb71c8460708a$var$React.useContext($5b4cb71c8460708a$var$_GridLegacyContext.default);
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = {
        ...other
    };
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = {
        ...props,
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing,
        ...breakpointsValues,
        breakpoints: breakpoints.keys
    };
    const classes = $5b4cb71c8460708a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5b4cb71c8460708a$var$_GridLegacyContext.default.Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5b4cb71c8460708a$var$GridLegacyRoot, {
            ownerState: ownerState,
            className: (0, $5b4cb71c8460708a$var$_clsx.default)(classes.root, className),
            as: component,
            ref: ref,
            ...otherFiltered
        })
    });
});
var $5b4cb71c8460708a$var$_default = module.exports.default = $5b4cb71c8460708a$var$GridLegacy;

});
parcelRegister("8961s", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5ee3d5f3a806867c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ee3d5f3a806867c$var$React = $5ee3d5f3a806867c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $5ee3d5f3a806867c$var$GridLegacyContext = /*#__PURE__*/ $5ee3d5f3a806867c$var$React.createContext();
var $5ee3d5f3a806867c$var$_default = module.exports.default = $5ee3d5f3a806867c$var$GridLegacyContext;

});

parcelRegister("6qE3E", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ae43e742e38e040$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridLegacyUtilityClass = $4ae43e742e38e040$var$getGridLegacyUtilityClass;

var $4ae43e742e38e040$var$_generateUtilityClasses = $4ae43e742e38e040$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4ae43e742e38e040$var$_generateUtilityClass = $4ae43e742e38e040$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ae43e742e38e040$var$getGridLegacyUtilityClass(slot) {
    return (0, $4ae43e742e38e040$var$_generateUtilityClass.default)('MuiGridLegacy', slot);
}
const $4ae43e742e38e040$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $4ae43e742e38e040$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $4ae43e742e38e040$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $4ae43e742e38e040$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $4ae43e742e38e040$var$gridClasses = (0, $4ae43e742e38e040$var$_generateUtilityClasses.default)('MuiGridLegacy', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$4ae43e742e38e040$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$4ae43e742e38e040$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$4ae43e742e38e040$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$4ae43e742e38e040$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $4ae43e742e38e040$var$_default = module.exports.default = $4ae43e742e38e040$var$gridClasses;

});



parcelRegister("7Zchb", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5d07c0b3a49e1daf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d07c0b3a49e1daf$var$_exportNames = {
    gridClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5d07c0b3a49e1daf$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $5d07c0b3a49e1daf$var$_gridClasses.default;
    }
});

var $5d07c0b3a49e1daf$var$_Grid = $5d07c0b3a49e1daf$require$_interopRequireWildcard((parcelRequire("cJu23")));
Object.keys($5d07c0b3a49e1daf$var$_Grid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d07c0b3a49e1daf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5d07c0b3a49e1daf$var$_Grid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5d07c0b3a49e1daf$var$_Grid[key];
        }
    });
});

var $5d07c0b3a49e1daf$var$_gridClasses = $5d07c0b3a49e1daf$require$_interopRequireWildcard((parcelRequire("kTnYy")));
Object.keys($5d07c0b3a49e1daf$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d07c0b3a49e1daf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5d07c0b3a49e1daf$var$_gridClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5d07c0b3a49e1daf$var$_gridClasses[key];
        }
    });
});

});
parcelRegister("cJu23", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9450fbc34cc5b2ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9450fbc34cc5b2ea$var$_propTypes = $9450fbc34cc5b2ea$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $gxueG = parcelRequire("gxueG");

var $9450fbc34cc5b2ea$var$_requirePropFactory = $9450fbc34cc5b2ea$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $8xDHs = parcelRequire("8xDHs");

var $hL1nr = parcelRequire("hL1nr");

var $9450fbc34cc5b2ea$var$_useTheme = $9450fbc34cc5b2ea$require$_interopRequireDefault((parcelRequire("14H9o")));
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $9450fbc34cc5b2ea$var$Grid = (0, $gxueG.createGrid)({
    createStyledComponent: (0, $8xDHs.styled)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $hL1nr.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $9450fbc34cc5b2ea$var$_useTheme.default
});
var $9450fbc34cc5b2ea$var$_default = module.exports.default = $9450fbc34cc5b2ea$var$Grid;

});

parcelRegister("kTnYy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f35b8acab3fc2f62$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $f35b8acab3fc2f62$var$getGridUtilityClass;

var $f35b8acab3fc2f62$var$_generateUtilityClasses = $f35b8acab3fc2f62$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f35b8acab3fc2f62$var$_generateUtilityClass = $f35b8acab3fc2f62$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f35b8acab3fc2f62$var$getGridUtilityClass(slot) {
    return (0, $f35b8acab3fc2f62$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $f35b8acab3fc2f62$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$var$_default = module.exports.default = $f35b8acab3fc2f62$var$gridClasses;

});


parcelRegister("3IKLG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2b59c24f9f8bf5b3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2b59c24f9f8bf5b3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2b59c24f9f8bf5b3$var$_exportNames = {
    iconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b59c24f9f8bf5b3$var$_Icon.default;
    }
});
Object.defineProperty(module.exports, "iconClasses", {
    enumerable: true,
    get: function() {
        return $2b59c24f9f8bf5b3$var$_iconClasses.default;
    }
});

var $2b59c24f9f8bf5b3$var$_Icon = $2b59c24f9f8bf5b3$require$_interopRequireDefault((parcelRequire("cGE4z")));

var $2b59c24f9f8bf5b3$var$_iconClasses = $2b59c24f9f8bf5b3$require$_interopRequireWildcard((parcelRequire("8vYwX")));
Object.keys($2b59c24f9f8bf5b3$var$_iconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2b59c24f9f8bf5b3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2b59c24f9f8bf5b3$var$_iconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2b59c24f9f8bf5b3$var$_iconClasses[key];
        }
    });
});

});
parcelRegister("cGE4z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $93c87ddcceadf9a1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $93c87ddcceadf9a1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93c87ddcceadf9a1$var$React = $93c87ddcceadf9a1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $93c87ddcceadf9a1$var$_propTypes = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $93c87ddcceadf9a1$var$_clsx = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("9QePP")));

var $93c87ddcceadf9a1$var$_composeClasses = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $93c87ddcceadf9a1$var$_capitalize = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $93c87ddcceadf9a1$var$_memoTheme = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $93c87ddcceadf9a1$var$_createSimplePaletteValueFilter = $93c87ddcceadf9a1$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $8vYwX = parcelRequire("8vYwX");

var $ayMG0 = parcelRequire("ayMG0");
const $93c87ddcceadf9a1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $93c87ddcceadf9a1$var$_capitalize.default)(color)}`,
            `fontSize${(0, $93c87ddcceadf9a1$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $93c87ddcceadf9a1$var$_composeClasses.default)(slots, $8vYwX.getIconUtilityClass, classes);
};
const $93c87ddcceadf9a1$var$IconRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $93c87ddcceadf9a1$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $93c87ddcceadf9a1$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $93c87ddcceadf9a1$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://issues.chromium.org/issues/41375697
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        variants: [
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(20)
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography.pxToRem(24)
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(36)
                }
            },
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars || theme).palette.action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            },
            ...Object.entries(theme.palette).filter((0, $93c87ddcceadf9a1$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $93c87ddcceadf9a1$var$Icon = /*#__PURE__*/ $93c87ddcceadf9a1$var$React.forwardRef(function Icon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    };
    const classes = $93c87ddcceadf9a1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($93c87ddcceadf9a1$var$IconRoot, {
        as: Component,
        className: (0, $93c87ddcceadf9a1$var$_clsx.default)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref,
        ...other
    });
});
$93c87ddcceadf9a1$var$Icon.muiName = 'Icon';
var $93c87ddcceadf9a1$var$_default = module.exports.default = $93c87ddcceadf9a1$var$Icon;

});
parcelRegister("8vYwX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $63302c123a5539bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getIconUtilityClass = $63302c123a5539bd$var$getIconUtilityClass;

var $63302c123a5539bd$var$_generateUtilityClasses = $63302c123a5539bd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $63302c123a5539bd$var$_generateUtilityClass = $63302c123a5539bd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $63302c123a5539bd$var$getIconUtilityClass(slot) {
    return (0, $63302c123a5539bd$var$_generateUtilityClass.default)('MuiIcon', slot);
}
const $63302c123a5539bd$var$iconClasses = (0, $63302c123a5539bd$var$_generateUtilityClasses.default)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $63302c123a5539bd$var$_default = module.exports.default = $63302c123a5539bd$var$iconClasses;

});



parcelRegister("dGTe0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9f7a092074edd6d0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9f7a092074edd6d0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9f7a092074edd6d0$var$_exportNames = {
    imageListClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9f7a092074edd6d0$var$_ImageList.default;
    }
});
Object.defineProperty(module.exports, "imageListClasses", {
    enumerable: true,
    get: function() {
        return $9f7a092074edd6d0$var$_imageListClasses.default;
    }
});

var $9f7a092074edd6d0$var$_ImageList = $9f7a092074edd6d0$require$_interopRequireDefault((parcelRequire("cZDSl")));

var $9f7a092074edd6d0$var$_imageListClasses = $9f7a092074edd6d0$require$_interopRequireWildcard((parcelRequire("cqVjf")));
Object.keys($9f7a092074edd6d0$var$_imageListClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9f7a092074edd6d0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9f7a092074edd6d0$var$_imageListClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9f7a092074edd6d0$var$_imageListClasses[key];
        }
    });
});

});
parcelRegister("cZDSl", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $975a1cffa46f382b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $975a1cffa46f382b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $975a1cffa46f382b$var$_composeClasses = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $975a1cffa46f382b$var$_integerPropType = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $975a1cffa46f382b$var$_clsx = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $975a1cffa46f382b$var$_propTypes = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $975a1cffa46f382b$var$React = $975a1cffa46f382b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $cqVjf = parcelRequire("cqVjf");

var $975a1cffa46f382b$var$_ImageListContext = $975a1cffa46f382b$require$_interopRequireDefault((parcelRequire("d1nkD")));

var $ayMG0 = parcelRequire("ayMG0");
const $975a1cffa46f382b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ]
    };
    return (0, $975a1cffa46f382b$var$_composeClasses.default)(slots, $cqVjf.getImageListUtilityClass, classes);
};
const $975a1cffa46f382b$var$ImageListRoot = (0, $aAbgT.styled)('ul', {
    name: 'MuiImageList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({
    display: 'grid',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch',
    variants: [
        {
            props: {
                variant: 'masonry'
            },
            style: {
                display: 'block'
            }
        }
    ]
});
const $975a1cffa46f382b$var$ImageList = /*#__PURE__*/ $975a1cffa46f382b$var$React.forwardRef(function ImageList(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiImageList'
    });
    const { children: children, className: className, cols: cols = 2, component: component = 'ul', rowHeight: rowHeight = 'auto', gap: gap = 4, style: styleProp, variant: variant = 'standard', ...other } = props;
    const contextValue = $975a1cffa46f382b$var$React.useMemo(()=>({
            rowHeight: rowHeight,
            gap: gap,
            variant: variant
        }), [
        rowHeight,
        gap,
        variant
    ]);
    const style = variant === 'masonry' ? {
        columnCount: cols,
        columnGap: gap,
        ...styleProp
    } : {
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: gap,
        ...styleProp
    };
    const ownerState = {
        ...props,
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        variant: variant
    };
    const classes = $975a1cffa46f382b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($975a1cffa46f382b$var$ImageListRoot, {
        as: component,
        className: (0, $975a1cffa46f382b$var$_clsx.default)(classes.root, classes[variant], className),
        ref: ref,
        style: style,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($975a1cffa46f382b$var$_ImageListContext.default.Provider, {
            value: contextValue,
            children: children
        })
    });
});
var $975a1cffa46f382b$var$_default = module.exports.default = $975a1cffa46f382b$var$ImageList;

});
parcelRegister("cqVjf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90d45e39fe6c23d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getImageListUtilityClass = $90d45e39fe6c23d3$var$getImageListUtilityClass;

var $90d45e39fe6c23d3$var$_generateUtilityClasses = $90d45e39fe6c23d3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $90d45e39fe6c23d3$var$_generateUtilityClass = $90d45e39fe6c23d3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $90d45e39fe6c23d3$var$getImageListUtilityClass(slot) {
    return (0, $90d45e39fe6c23d3$var$_generateUtilityClass.default)('MuiImageList', slot);
}
const $90d45e39fe6c23d3$var$imageListClasses = (0, $90d45e39fe6c23d3$var$_generateUtilityClasses.default)('MuiImageList', [
    'root',
    'masonry',
    'quilted',
    'standard',
    'woven'
]);
var $90d45e39fe6c23d3$var$_default = module.exports.default = $90d45e39fe6c23d3$var$imageListClasses;

});

parcelRegister("d1nkD", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $97ad778fce8cd0d8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97ad778fce8cd0d8$var$React = $97ad778fce8cd0d8$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $97ad778fce8cd0d8$var$ImageListContext = /*#__PURE__*/ $97ad778fce8cd0d8$var$React.createContext({});
var $97ad778fce8cd0d8$var$_default = module.exports.default = $97ad778fce8cd0d8$var$ImageListContext;

});



parcelRegister("cJR6h", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9462e0a2246915d8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9462e0a2246915d8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9462e0a2246915d8$var$_exportNames = {
    imageListItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9462e0a2246915d8$var$_ImageListItem.default;
    }
});
Object.defineProperty(module.exports, "imageListItemClasses", {
    enumerable: true,
    get: function() {
        return $9462e0a2246915d8$var$_imageListItemClasses.default;
    }
});

var $9462e0a2246915d8$var$_ImageListItem = $9462e0a2246915d8$require$_interopRequireDefault((parcelRequire("f0119")));

var $9462e0a2246915d8$var$_imageListItemClasses = $9462e0a2246915d8$require$_interopRequireWildcard((parcelRequire("4vKND")));
Object.keys($9462e0a2246915d8$var$_imageListItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9462e0a2246915d8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9462e0a2246915d8$var$_imageListItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9462e0a2246915d8$var$_imageListItemClasses[key];
        }
    });
});

});
parcelRegister("f0119", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $aeb7a529fa95e8e4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $aeb7a529fa95e8e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeb7a529fa95e8e4$var$_composeClasses = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aeb7a529fa95e8e4$var$_integerPropType = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $aeb7a529fa95e8e4$var$_clsx = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aeb7a529fa95e8e4$var$_propTypes = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aeb7a529fa95e8e4$var$React = $aeb7a529fa95e8e4$require$_interopRequireWildcard((parcelRequire("acw62")));


var $aeb7a529fa95e8e4$var$_ImageListContext = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("d1nkD")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $aeb7a529fa95e8e4$var$_isMuiElement = $aeb7a529fa95e8e4$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $aeb7a529fa95e8e4$var$_imageListItemClasses = $aeb7a529fa95e8e4$require$_interopRequireWildcard((parcelRequire("4vKND")));

var $ayMG0 = parcelRequire("ayMG0");
const $aeb7a529fa95e8e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        img: [
            'img'
        ]
    };
    return (0, $aeb7a529fa95e8e4$var$_composeClasses.default)(slots, $aeb7a529fa95e8e4$var$_imageListItemClasses.getImageListItemUtilityClass, classes);
};
const $aeb7a529fa95e8e4$var$ImageListItemRoot = (0, $aAbgT.styled)('li', {
    name: 'MuiImageListItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$aeb7a529fa95e8e4$var$_imageListItemClasses.default.img}`]: styles.img
            },
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({
    display: 'block',
    position: 'relative',
    [`& .${$aeb7a529fa95e8e4$var$_imageListItemClasses.default.img}`]: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        display: 'block'
    },
    variants: [
        {
            props: {
                variant: 'standard'
            },
            style: {
                // For titlebar under list item
                display: 'flex',
                flexDirection: 'column'
            }
        },
        {
            props: {
                variant: 'woven'
            },
            style: {
                height: '100%',
                alignSelf: 'center',
                '&:nth-of-type(even)': {
                    height: '70%'
                }
            }
        },
        {
            props: {
                variant: 'standard'
            },
            style: {
                [`& .${$aeb7a529fa95e8e4$var$_imageListItemClasses.default.img}`]: {
                    height: 'auto',
                    flexGrow: 1
                }
            }
        }
    ]
});
const $aeb7a529fa95e8e4$var$ImageListItem = /*#__PURE__*/ $aeb7a529fa95e8e4$var$React.forwardRef(function ImageListItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiImageListItem'
    });
    // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
    const { children: children, className: className, cols: cols = 1, component: component = 'li', rows: rows = 1, style: style, ...other } = props;
    const { rowHeight: rowHeight = 'auto', gap: gap, variant: variant } = $aeb7a529fa95e8e4$var$React.useContext($aeb7a529fa95e8e4$var$_ImageListContext.default);
    let height = 'auto';
    if (variant === 'woven') height = undefined;
    else if (rowHeight !== 'auto') height = rowHeight * rows + gap * (rows - 1);
    const ownerState = {
        ...props,
        cols: cols,
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        rows: rows,
        variant: variant
    };
    const classes = $aeb7a529fa95e8e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aeb7a529fa95e8e4$var$ImageListItemRoot, {
        as: component,
        className: (0, $aeb7a529fa95e8e4$var$_clsx.default)(classes.root, classes[variant], className),
        ref: ref,
        style: {
            height: height,
            gridColumnEnd: variant !== 'masonry' ? `span ${cols}` : undefined,
            gridRowEnd: variant !== 'masonry' ? `span ${rows}` : undefined,
            marginBottom: variant === 'masonry' ? gap : undefined,
            breakInside: variant === 'masonry' ? 'avoid' : undefined,
            ...style
        },
        ownerState: ownerState,
        ...other,
        children: $aeb7a529fa95e8e4$var$React.Children.map(children, (child)=>{
            if (!/*#__PURE__*/ $aeb7a529fa95e8e4$var$React.isValidElement(child)) return null;
            if (child.type === 'img' || (0, $aeb7a529fa95e8e4$var$_isMuiElement.default)(child, [
                'Image'
            ])) return /*#__PURE__*/ $aeb7a529fa95e8e4$var$React.cloneElement(child, {
                className: (0, $aeb7a529fa95e8e4$var$_clsx.default)(classes.img, child.props.className)
            });
            return child;
        })
    });
});
var $aeb7a529fa95e8e4$var$_default = module.exports.default = $aeb7a529fa95e8e4$var$ImageListItem;

});
parcelRegister("4vKND", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $348e5c185e9c1cc5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getImageListItemUtilityClass = $348e5c185e9c1cc5$var$getImageListItemUtilityClass;

var $348e5c185e9c1cc5$var$_generateUtilityClasses = $348e5c185e9c1cc5$require$_interopRequireDefault((parcelRequire("5nY49")));

var $348e5c185e9c1cc5$var$_generateUtilityClass = $348e5c185e9c1cc5$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $348e5c185e9c1cc5$var$getImageListItemUtilityClass(slot) {
    return (0, $348e5c185e9c1cc5$var$_generateUtilityClass.default)('MuiImageListItem', slot);
}
const $348e5c185e9c1cc5$var$imageListItemClasses = (0, $348e5c185e9c1cc5$var$_generateUtilityClasses.default)('MuiImageListItem', [
    'root',
    'img',
    'standard',
    'woven',
    'masonry',
    'quilted'
]);
var $348e5c185e9c1cc5$var$_default = module.exports.default = $348e5c185e9c1cc5$var$imageListItemClasses;

});



parcelRegister("2yXyU", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1ddcf58ca2045c53$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1ddcf58ca2045c53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1ddcf58ca2045c53$var$_exportNames = {
    imageListItemBarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ddcf58ca2045c53$var$_ImageListItemBar.default;
    }
});
Object.defineProperty(module.exports, "imageListItemBarClasses", {
    enumerable: true,
    get: function() {
        return $1ddcf58ca2045c53$var$_imageListItemBarClasses.default;
    }
});

var $1ddcf58ca2045c53$var$_ImageListItemBar = $1ddcf58ca2045c53$require$_interopRequireDefault((parcelRequire("lzxDz")));

var $1ddcf58ca2045c53$var$_imageListItemBarClasses = $1ddcf58ca2045c53$require$_interopRequireWildcard((parcelRequire("eMzfg")));
Object.keys($1ddcf58ca2045c53$var$_imageListItemBarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1ddcf58ca2045c53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1ddcf58ca2045c53$var$_imageListItemBarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1ddcf58ca2045c53$var$_imageListItemBarClasses[key];
        }
    });
});

});
parcelRegister("lzxDz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fb46f5873d57d468$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fb46f5873d57d468$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb46f5873d57d468$var$_composeClasses = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fb46f5873d57d468$var$_clsx = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fb46f5873d57d468$var$_propTypes = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fb46f5873d57d468$var$React = $fb46f5873d57d468$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aAbgT = parcelRequire("aAbgT");

var $fb46f5873d57d468$var$_memoTheme = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $fb46f5873d57d468$var$_capitalize = $fb46f5873d57d468$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $eMzfg = parcelRequire("eMzfg");

var $ayMG0 = parcelRequire("ayMG0");
const $fb46f5873d57d468$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position, actionIcon: actionIcon, actionPosition: actionPosition } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $fb46f5873d57d468$var$_capitalize.default)(position)}`,
            `actionPosition${(0, $fb46f5873d57d468$var$_capitalize.default)(actionPosition)}`
        ],
        titleWrap: [
            'titleWrap',
            `titleWrap${(0, $fb46f5873d57d468$var$_capitalize.default)(position)}`,
            actionIcon && `titleWrapActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(actionPosition)}`
        ],
        title: [
            'title'
        ],
        subtitle: [
            'subtitle'
        ],
        actionIcon: [
            'actionIcon',
            `actionIconActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(actionPosition)}`
        ]
    };
    return (0, $fb46f5873d57d468$var$_composeClasses.default)(slots, $eMzfg.getImageListItemBarUtilityClass, classes);
};
const $fb46f5873d57d468$var$ImageListItemBarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.position)}`]
        ];
    }
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        position: 'absolute',
        left: 0,
        right: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        fontFamily: theme.typography.fontFamily,
        variants: [
            {
                props: {
                    position: 'bottom'
                },
                style: {
                    bottom: 0
                }
            },
            {
                props: {
                    position: 'top'
                },
                style: {
                    top: 0
                }
            },
            {
                props: {
                    position: 'below'
                },
                style: {
                    position: 'relative',
                    background: 'transparent',
                    alignItems: 'normal'
                }
            }
        ]
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarTitleWrap = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'TitleWrap',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.titleWrap,
            styles[`titleWrap${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.position)}`],
            ownerState.actionIcon && styles[`titleWrapActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.actionPosition)}`]
        ];
    }
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        flexGrow: 1,
        padding: '12px 16px',
        color: (theme.vars || theme).palette.common.white,
        overflow: 'hidden',
        variants: [
            {
                props: {
                    position: 'below'
                },
                style: {
                    padding: '6px 0 12px',
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.actionIcon && ownerState.actionPosition === 'left',
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.actionIcon && ownerState.actionPosition === 'right',
                style: {
                    paddingRight: 0
                }
            }
        ]
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarTitle = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Title'
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: '24px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarSubtitle = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'Subtitle'
})((0, $fb46f5873d57d468$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}));
const $fb46f5873d57d468$var$ImageListItemBarActionIcon = (0, $aAbgT.styled)('div', {
    name: 'MuiImageListItemBar',
    slot: 'ActionIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actionIcon,
            styles[`actionIconActionPos${(0, $fb46f5873d57d468$var$_capitalize.default)(ownerState.actionPosition)}`]
        ];
    }
})({
    variants: [
        {
            props: {
                actionPosition: 'left'
            },
            style: {
                order: -1
            }
        }
    ]
});
const $fb46f5873d57d468$var$ImageListItemBar = /*#__PURE__*/ $fb46f5873d57d468$var$React.forwardRef(function ImageListItemBar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiImageListItemBar'
    });
    const { actionIcon: actionIcon, actionPosition: actionPosition = 'right', className: className, subtitle: subtitle, title: title, position: position = 'bottom', ...other } = props;
    const ownerState = {
        ...props,
        position: position,
        actionPosition: actionPosition
    };
    const classes = $fb46f5873d57d468$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($fb46f5873d57d468$var$ImageListItemBarRoot, {
        ownerState: ownerState,
        className: (0, $fb46f5873d57d468$var$_clsx.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($fb46f5873d57d468$var$ImageListItemBarTitleWrap, {
                ownerState: ownerState,
                className: classes.titleWrap,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarTitle, {
                        className: classes.title,
                        children: title
                    }),
                    subtitle ? /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarSubtitle, {
                        className: classes.subtitle,
                        children: subtitle
                    }) : null
                ]
            }),
            actionIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($fb46f5873d57d468$var$ImageListItemBarActionIcon, {
                ownerState: ownerState,
                className: classes.actionIcon,
                children: actionIcon
            }) : null
        ]
    });
});
var $fb46f5873d57d468$var$_default = module.exports.default = $fb46f5873d57d468$var$ImageListItemBar;

});
parcelRegister("eMzfg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ac30e3552d9f386c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getImageListItemBarUtilityClass = $ac30e3552d9f386c$var$getImageListItemBarUtilityClass;

var $ac30e3552d9f386c$var$_generateUtilityClasses = $ac30e3552d9f386c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ac30e3552d9f386c$var$_generateUtilityClass = $ac30e3552d9f386c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ac30e3552d9f386c$var$getImageListItemBarUtilityClass(slot) {
    return (0, $ac30e3552d9f386c$var$_generateUtilityClass.default)('MuiImageListItemBar', slot);
}
const $ac30e3552d9f386c$var$imageListItemBarClasses = (0, $ac30e3552d9f386c$var$_generateUtilityClasses.default)('MuiImageListItemBar', [
    'root',
    'positionBottom',
    'positionTop',
    'positionBelow',
    'actionPositionLeft',
    'actionPositionRight',
    'titleWrap',
    'titleWrapBottom',
    'titleWrapTop',
    'titleWrapBelow',
    'titleWrapActionPosLeft',
    'titleWrapActionPosRight',
    'title',
    'subtitle',
    'actionIcon',
    'actionIconActionPosLeft',
    'actionIconActionPosRight'
]);
var $ac30e3552d9f386c$var$_default = module.exports.default = $ac30e3552d9f386c$var$imageListItemBarClasses;

});



parcelRegister("fyPI4", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b542247f17114115$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b542247f17114115$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b542247f17114115$var$_exportNames = {
    linkClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b542247f17114115$var$_Link.default;
    }
});
Object.defineProperty(module.exports, "linkClasses", {
    enumerable: true,
    get: function() {
        return $b542247f17114115$var$_linkClasses.default;
    }
});

var $b542247f17114115$var$_Link = $b542247f17114115$require$_interopRequireDefault((parcelRequire("9SK5h")));

var $b542247f17114115$var$_linkClasses = $b542247f17114115$require$_interopRequireWildcard((parcelRequire("lLIcc")));
Object.keys($b542247f17114115$var$_linkClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b542247f17114115$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b542247f17114115$var$_linkClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b542247f17114115$var$_linkClasses[key];
        }
    });
});

});
parcelRegister("9SK5h", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $731ce78e0c47d0a7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $731ce78e0c47d0a7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $731ce78e0c47d0a7$var$React = $731ce78e0c47d0a7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $731ce78e0c47d0a7$var$_propTypes = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $731ce78e0c47d0a7$var$_clsx = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $731ce78e0c47d0a7$var$_elementTypeAcceptingRef = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $731ce78e0c47d0a7$var$_composeClasses = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $731ce78e0c47d0a7$var$_isFocusVisible = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("cS73m")));

var $731ce78e0c47d0a7$var$_capitalize = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $731ce78e0c47d0a7$var$_memoTheme = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $731ce78e0c47d0a7$var$_createSimplePaletteValueFilter = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $hL1nr = parcelRequire("hL1nr");

var $731ce78e0c47d0a7$var$_Typography = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $731ce78e0c47d0a7$var$_linkClasses = $731ce78e0c47d0a7$require$_interopRequireWildcard((parcelRequire("lLIcc")));

var $731ce78e0c47d0a7$var$_getTextDecoration = $731ce78e0c47d0a7$require$_interopRequireDefault((parcelRequire("2LVI8")));

var $ayMG0 = parcelRequire("ayMG0");
const $731ce78e0c47d0a7$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $731ce78e0c47d0a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $731ce78e0c47d0a7$var$_capitalize.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $731ce78e0c47d0a7$var$_composeClasses.default)(slots, $731ce78e0c47d0a7$var$_linkClasses.getLinkUtilityClass, classes);
};
const $731ce78e0c47d0a7$var$LinkRoot = (0, $aAbgT.styled)($731ce78e0c47d0a7$var$_Typography.default, {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $731ce78e0c47d0a7$var$_capitalize.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $731ce78e0c47d0a7$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $731ce78e0c47d0a7$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${$731ce78e0c47d0a7$var$_linkClasses.default.focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $731ce78e0c47d0a7$var$Link = /*#__PURE__*/ $731ce78e0c47d0a7$var$React.forwardRef(function Link(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $aAbgT.useTheme)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $731ce78e0c47d0a7$var$React.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $731ce78e0c47d0a7$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $731ce78e0c47d0a7$var$_isFocusVisible.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $731ce78e0c47d0a7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($731ce78e0c47d0a7$var$LinkRoot, {
        color: color,
        className: (0, $731ce78e0c47d0a7$var$_clsx.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$731ce78e0c47d0a7$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$731ce78e0c47d0a7$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $731ce78e0c47d0a7$var$_getTextDecoration.default)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $731ce78e0c47d0a7$var$_default = module.exports.default = $731ce78e0c47d0a7$var$Link;

});
parcelRegister("lLIcc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd904517f2a78af6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getLinkUtilityClass = $fd904517f2a78af6$var$getLinkUtilityClass;

var $fd904517f2a78af6$var$_generateUtilityClasses = $fd904517f2a78af6$require$_interopRequireDefault((parcelRequire("5nY49")));

var $fd904517f2a78af6$var$_generateUtilityClass = $fd904517f2a78af6$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $fd904517f2a78af6$var$getLinkUtilityClass(slot) {
    return (0, $fd904517f2a78af6$var$_generateUtilityClass.default)('MuiLink', slot);
}
const $fd904517f2a78af6$var$linkClasses = (0, $fd904517f2a78af6$var$_generateUtilityClasses.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $fd904517f2a78af6$var$_default = module.exports.default = $fd904517f2a78af6$var$linkClasses;

});

parcelRegister("2LVI8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fuavR = parcelRequire("fuavR");

var $h61zw = parcelRequire("h61zw");
const $204cbcbead979fad$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $fuavR.getPath)(theme, `palette.${transformedColor}.main`) || (0, $fuavR.getPath)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $fuavR.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, $fuavR.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $fuavR.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, $fuavR.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $h61zw.alpha)(color, 0.4);
};
var $204cbcbead979fad$var$_default = module.exports.default = $204cbcbead979fad$var$getTextDecoration;

});



parcelRegister("hOLYA", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cf8c523bf26d7f9a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cf8c523bf26d7f9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cf8c523bf26d7f9a$var$_exportNames = {
    listItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cf8c523bf26d7f9a$var$_ListItem.default;
    }
});
Object.defineProperty(module.exports, "listItemClasses", {
    enumerable: true,
    get: function() {
        return $cf8c523bf26d7f9a$var$_listItemClasses.default;
    }
});

var $cf8c523bf26d7f9a$var$_ListItem = $cf8c523bf26d7f9a$require$_interopRequireDefault((parcelRequire("lofVM")));

var $cf8c523bf26d7f9a$var$_listItemClasses = $cf8c523bf26d7f9a$require$_interopRequireWildcard((parcelRequire("fiKZz")));
Object.keys($cf8c523bf26d7f9a$var$_listItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cf8c523bf26d7f9a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cf8c523bf26d7f9a$var$_listItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cf8c523bf26d7f9a$var$_listItemClasses[key];
        }
    });
});

});
parcelRegister("lofVM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f92832698674c928$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f92832698674c928$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overridesResolver = module.exports.default = module.exports.ListItemRoot = void 0;

var $f92832698674c928$var$React = $f92832698674c928$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f92832698674c928$var$_propTypes = $f92832698674c928$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f92832698674c928$var$_clsx = $f92832698674c928$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f92832698674c928$var$_composeClasses = $f92832698674c928$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $f92832698674c928$var$_elementTypeAcceptingRef = $f92832698674c928$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $f92832698674c928$var$_chainPropTypes = $f92832698674c928$require$_interopRequireDefault((parcelRequire("abVWF")));

var $f92832698674c928$var$_isHostComponent = $f92832698674c928$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $aAbgT = parcelRequire("aAbgT");

var $f92832698674c928$var$_memoTheme = $f92832698674c928$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $f92832698674c928$var$_isMuiElement = $f92832698674c928$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $f92832698674c928$var$_useForkRef = $f92832698674c928$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $f92832698674c928$var$_useSlot = $f92832698674c928$require$_interopRequireDefault((parcelRequire("6lpak")));

var $f92832698674c928$var$_ListContext = $f92832698674c928$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $fiKZz = parcelRequire("fiKZz");

var $iVzhN = parcelRequire("iVzhN");

var $f92832698674c928$var$_ListItemSecondaryAction = $f92832698674c928$require$_interopRequireDefault((parcelRequire("4LntB")));

var $ayMG0 = parcelRequire("ayMG0");
const $f92832698674c928$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
module.exports.overridesResolver = $f92832698674c928$var$overridesResolver;
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ],
        secondaryAction: [
            'secondaryAction'
        ]
    };
    return (0, $f92832698674c928$var$_composeClasses.default)(slots, $fiKZz.getListItemUtilityClass, classes);
};
const $f92832698674c928$var$ListItemRoot = module.exports.ListItemRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$var$overridesResolver
})((0, $f92832698674c928$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${$iVzhN.listItemButtonClasses.root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $f92832698674c928$var$ListItemContainer = (0, $aAbgT.styled)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $f92832698674c928$var$React.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $f92832698674c928$var$React.useContext($f92832698674c928$var$_ListContext.default);
    const childContext = $f92832698674c928$var$React.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $f92832698674c928$var$React.useRef(null);
    const children = $f92832698674c928$var$React.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $f92832698674c928$var$_isMuiElement.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $f92832698674c928$var$_useForkRef.default)(listItemRef, ref);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [SecondaryActionSlot, secondaryActionSlotProps] = (0, $f92832698674c928$var$_useSlot.default)('secondaryAction', {
        elementType: $f92832698674c928$var$_ListItemSecondaryAction.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.secondaryAction
    });
    const Root = slots.root || components.Root || $f92832698674c928$var$ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $f92832698674c928$var$_clsx.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($f92832698674c928$var$_ListContext.default.Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $f92832698674c928$var$_clsx.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $f92832698674c928$var$_isHostComponent.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f92832698674c928$var$_ListContext.default.Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $f92832698674c928$var$_isHostComponent.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)(SecondaryActionSlot, {
                    ...secondaryActionSlotProps,
                    children: secondaryAction
                })
            ]
        })
    });
});
var $f92832698674c928$var$_default = module.exports.default = $f92832698674c928$var$ListItem;

});
parcelRegister("fiKZz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b23cfd2067550897$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemUtilityClass = $b23cfd2067550897$var$getListItemUtilityClass;

var $b23cfd2067550897$var$_generateUtilityClasses = $b23cfd2067550897$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b23cfd2067550897$var$_generateUtilityClass = $b23cfd2067550897$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $b23cfd2067550897$var$getListItemUtilityClass(slot) {
    return (0, $b23cfd2067550897$var$_generateUtilityClass.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $b23cfd2067550897$var$_generateUtilityClasses.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $b23cfd2067550897$var$_default = module.exports.default = $b23cfd2067550897$var$listItemClasses;

});

parcelRegister("4LntB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $377dc32070e7887f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $377dc32070e7887f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $377dc32070e7887f$var$_exportNames = {
    listItemSecondaryActionClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $377dc32070e7887f$var$_ListItemSecondaryAction.default;
    }
});
Object.defineProperty(module.exports, "listItemSecondaryActionClasses", {
    enumerable: true,
    get: function() {
        return $377dc32070e7887f$var$_listItemSecondaryActionClasses.default;
    }
});

var $377dc32070e7887f$var$_ListItemSecondaryAction = $377dc32070e7887f$require$_interopRequireDefault((parcelRequire("d9alg")));

var $377dc32070e7887f$var$_listItemSecondaryActionClasses = $377dc32070e7887f$require$_interopRequireWildcard((parcelRequire("7lon8")));
Object.keys($377dc32070e7887f$var$_listItemSecondaryActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($377dc32070e7887f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $377dc32070e7887f$var$_listItemSecondaryActionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $377dc32070e7887f$var$_listItemSecondaryActionClasses[key];
        }
    });
});

});
parcelRegister("d9alg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9924235485c5a222$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9924235485c5a222$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9924235485c5a222$var$React = $9924235485c5a222$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9924235485c5a222$var$_propTypes = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9924235485c5a222$var$_clsx = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9924235485c5a222$var$_composeClasses = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $9924235485c5a222$var$_ListContext = $9924235485c5a222$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $7lon8 = parcelRequire("7lon8");

var $ayMG0 = parcelRequire("ayMG0");
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $9924235485c5a222$var$_composeClasses.default)(slots, $7lon8.getListItemSecondaryActionClassesUtilityClass, classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $9924235485c5a222$var$React.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $9924235485c5a222$var$React.useContext($9924235485c5a222$var$_ListContext.default);
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, {
        className: (0, $9924235485c5a222$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$var$_default = module.exports.default = $9924235485c5a222$var$ListItemSecondaryAction;

});
parcelRegister("7lon8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $558d665a4b71ad4c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemSecondaryActionClassesUtilityClass = $558d665a4b71ad4c$var$getListItemSecondaryActionClassesUtilityClass;

var $558d665a4b71ad4c$var$_generateUtilityClasses = $558d665a4b71ad4c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $558d665a4b71ad4c$var$_generateUtilityClass = $558d665a4b71ad4c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $558d665a4b71ad4c$var$getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, $558d665a4b71ad4c$var$_generateUtilityClass.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $558d665a4b71ad4c$var$_generateUtilityClasses.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$var$_default = module.exports.default = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;

});





parcelRegister("6HgAC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4e03a092ccfc165d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4e03a092ccfc165d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4e03a092ccfc165d$var$_exportNames = {
    listItemAvatarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4e03a092ccfc165d$var$_ListItemAvatar.default;
    }
});
Object.defineProperty(module.exports, "listItemAvatarClasses", {
    enumerable: true,
    get: function() {
        return $4e03a092ccfc165d$var$_listItemAvatarClasses.default;
    }
});

var $4e03a092ccfc165d$var$_ListItemAvatar = $4e03a092ccfc165d$require$_interopRequireDefault((parcelRequire("84UsW")));

var $4e03a092ccfc165d$var$_listItemAvatarClasses = $4e03a092ccfc165d$require$_interopRequireWildcard((parcelRequire("cohVi")));
Object.keys($4e03a092ccfc165d$var$_listItemAvatarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4e03a092ccfc165d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4e03a092ccfc165d$var$_listItemAvatarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4e03a092ccfc165d$var$_listItemAvatarClasses[key];
        }
    });
});

});
parcelRegister("84UsW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5e1a7f5eff0ff3e8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5e1a7f5eff0ff3e8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e1a7f5eff0ff3e8$var$React = $5e1a7f5eff0ff3e8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5e1a7f5eff0ff3e8$var$_propTypes = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5e1a7f5eff0ff3e8$var$_clsx = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5e1a7f5eff0ff3e8$var$_composeClasses = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5e1a7f5eff0ff3e8$var$_ListContext = $5e1a7f5eff0ff3e8$require$_interopRequireDefault((parcelRequire("3W6ht")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $cohVi = parcelRequire("cohVi");

var $ayMG0 = parcelRequire("ayMG0");
const $5e1a7f5eff0ff3e8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $5e1a7f5eff0ff3e8$var$_composeClasses.default)(slots, $cohVi.getListItemAvatarUtilityClass, classes);
};
const $5e1a7f5eff0ff3e8$var$ListItemAvatarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiListItemAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})({
    minWidth: 56,
    flexShrink: 0,
    variants: [
        {
            props: {
                alignItems: 'flex-start'
            },
            style: {
                marginTop: 8
            }
        }
    ]
});
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ const $5e1a7f5eff0ff3e8$var$ListItemAvatar = /*#__PURE__*/ $5e1a7f5eff0ff3e8$var$React.forwardRef(function ListItemAvatar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemAvatar'
    });
    const { className: className, ...other } = props;
    const context = $5e1a7f5eff0ff3e8$var$React.useContext($5e1a7f5eff0ff3e8$var$_ListContext.default);
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $5e1a7f5eff0ff3e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5e1a7f5eff0ff3e8$var$ListItemAvatarRoot, {
        className: (0, $5e1a7f5eff0ff3e8$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $5e1a7f5eff0ff3e8$var$_default = module.exports.default = $5e1a7f5eff0ff3e8$var$ListItemAvatar;

});
parcelRegister("cohVi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9055a111c146fc9b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemAvatarUtilityClass = $9055a111c146fc9b$var$getListItemAvatarUtilityClass;

var $9055a111c146fc9b$var$_generateUtilityClasses = $9055a111c146fc9b$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9055a111c146fc9b$var$_generateUtilityClass = $9055a111c146fc9b$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9055a111c146fc9b$var$getListItemAvatarUtilityClass(slot) {
    return (0, $9055a111c146fc9b$var$_generateUtilityClass.default)('MuiListItemAvatar', slot);
}
const $9055a111c146fc9b$var$listItemAvatarClasses = (0, $9055a111c146fc9b$var$_generateUtilityClasses.default)('MuiListItemAvatar', [
    'root',
    'alignItemsFlexStart'
]);
var $9055a111c146fc9b$var$_default = module.exports.default = $9055a111c146fc9b$var$listItemAvatarClasses;

});



parcelRegister("kCnQI", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $03dfa491627f975c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $03dfa491627f975c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $03dfa491627f975c$var$_exportNames = {
    menuClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $03dfa491627f975c$var$_Menu.default;
    }
});
Object.defineProperty(module.exports, "menuClasses", {
    enumerable: true,
    get: function() {
        return $03dfa491627f975c$var$_menuClasses.default;
    }
});

var $03dfa491627f975c$var$_Menu = $03dfa491627f975c$require$_interopRequireDefault((parcelRequire("4F5tJ")));

var $03dfa491627f975c$var$_menuClasses = $03dfa491627f975c$require$_interopRequireWildcard((parcelRequire("lyHsQ")));
Object.keys($03dfa491627f975c$var$_menuClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($03dfa491627f975c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $03dfa491627f975c$var$_menuClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $03dfa491627f975c$var$_menuClasses[key];
        }
    });
});

});

parcelRegister("1e1yc", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0e484d2d1153e25c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0e484d2d1153e25c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0e484d2d1153e25c$var$_exportNames = {
    mobileStepperClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e484d2d1153e25c$var$_MobileStepper.default;
    }
});
Object.defineProperty(module.exports, "mobileStepperClasses", {
    enumerable: true,
    get: function() {
        return $0e484d2d1153e25c$var$_mobileStepperClasses.default;
    }
});

var $0e484d2d1153e25c$var$_MobileStepper = $0e484d2d1153e25c$require$_interopRequireDefault((parcelRequire("5moyV")));

var $0e484d2d1153e25c$var$_mobileStepperClasses = $0e484d2d1153e25c$require$_interopRequireWildcard((parcelRequire("50EKC")));
Object.keys($0e484d2d1153e25c$var$_mobileStepperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0e484d2d1153e25c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0e484d2d1153e25c$var$_mobileStepperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0e484d2d1153e25c$var$_mobileStepperClasses[key];
        }
    });
});

});
parcelRegister("5moyV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3e720f5cf13cfb0a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3e720f5cf13cfb0a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e720f5cf13cfb0a$var$React = $3e720f5cf13cfb0a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3e720f5cf13cfb0a$var$_propTypes = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3e720f5cf13cfb0a$var$_clsx = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3e720f5cf13cfb0a$var$_integerPropType = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $3e720f5cf13cfb0a$var$_composeClasses = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $3e720f5cf13cfb0a$var$_Paper = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $3e720f5cf13cfb0a$var$_capitalize = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $3e720f5cf13cfb0a$var$_LinearProgress = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("2vsem")));

var $aAbgT = parcelRequire("aAbgT");

var $3e720f5cf13cfb0a$var$_memoTheme = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $3e720f5cf13cfb0a$var$_slotShouldForwardProp = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $50EKC = parcelRequire("50EKC");

var $3e720f5cf13cfb0a$var$_useSlot = $3e720f5cf13cfb0a$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $3e720f5cf13cfb0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, $3e720f5cf13cfb0a$var$_capitalize.default)(position)}`
        ],
        dots: [
            'dots'
        ],
        dot: [
            'dot'
        ],
        dotActive: [
            'dotActive'
        ],
        progress: [
            'progress'
        ]
    };
    return (0, $3e720f5cf13cfb0a$var$_composeClasses.default)(slots, $50EKC.getMobileStepperUtilityClass, classes);
};
const $3e720f5cf13cfb0a$var$MobileStepperRoot = (0, $aAbgT.styled)($3e720f5cf13cfb0a$var$_Paper.default, {
    name: 'MuiMobileStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $3e720f5cf13cfb0a$var$_capitalize.default)(ownerState.position)}`]
        ];
    }
})((0, $3e720f5cf13cfb0a$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: (theme.vars || theme).palette.background.default,
        padding: 8,
        variants: [
            {
                props: ({ position: position })=>position === 'top' || position === 'bottom',
                style: {
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    zIndex: (theme.vars || theme).zIndex.mobileStepper
                }
            },
            {
                props: {
                    position: 'top'
                },
                style: {
                    top: 0
                }
            },
            {
                props: {
                    position: 'bottom'
                },
                style: {
                    bottom: 0
                }
            }
        ]
    })));
const $3e720f5cf13cfb0a$var$MobileStepperDots = (0, $aAbgT.styled)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dots'
})({
    variants: [
        {
            props: {
                variant: 'dots'
            },
            style: {
                display: 'flex',
                flexDirection: 'row'
            }
        }
    ]
});
const $3e720f5cf13cfb0a$var$MobileStepperDot = (0, $aAbgT.styled)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dot',
    shouldForwardProp: (prop)=>(0, $3e720f5cf13cfb0a$var$_slotShouldForwardProp.default)(prop) && prop !== 'dotActive',
    overridesResolver: (props, styles)=>{
        const { dotActive: dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})((0, $3e720f5cf13cfb0a$var$_memoTheme.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    variant: 'dots'
                },
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    backgroundColor: (theme.vars || theme).palette.action.disabled,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    margin: '0 2px'
                }
            },
            {
                props: {
                    variant: 'dots',
                    dotActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    })));
const $3e720f5cf13cfb0a$var$MobileStepperProgress = (0, $aAbgT.styled)($3e720f5cf13cfb0a$var$_LinearProgress.default, {
    name: 'MuiMobileStepper',
    slot: 'Progress'
})({
    variants: [
        {
            props: {
                variant: 'progress'
            },
            style: {
                width: '50%'
            }
        }
    ]
});
const $3e720f5cf13cfb0a$var$MobileStepper = /*#__PURE__*/ $3e720f5cf13cfb0a$var$React.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiMobileStepper'
    });
    const { activeStep: activeStep = 0, backButton: backButton, className: className, LinearProgressProps: LinearProgressProps, nextButton: nextButton, position: position = 'bottom', steps: steps, variant: variant = 'dots', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        activeStep: activeStep,
        position: position,
        variant: variant
    };
    let value;
    if (variant === 'progress') {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = $3e720f5cf13cfb0a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            progress: LinearProgressProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $3e720f5cf13cfb0a$var$MobileStepperRoot,
        shouldForwardComponentProp: true,
        className: (0, $3e720f5cf13cfb0a$var$_clsx.default)(classes.root, className),
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            square: true,
            elevation: 0
        }
    });
    const [DotsSlot, dotsSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('dots', {
        className: classes.dots,
        elementType: $3e720f5cf13cfb0a$var$MobileStepperDots,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DotSlot, dotSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('dot', {
        elementType: $3e720f5cf13cfb0a$var$MobileStepperDot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ProgressSlot, progressSlotProps] = (0, $3e720f5cf13cfb0a$var$_useSlot.default)('progress', {
        className: classes.progress,
        elementType: $3e720f5cf13cfb0a$var$MobileStepperProgress,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            value: value,
            variant: 'determinate'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            backButton,
            variant === 'text' && /*#__PURE__*/ (0, $ayMG0.jsxs)($3e720f5cf13cfb0a$var$React.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === 'dots' && /*#__PURE__*/ (0, $ayMG0.jsx)(DotsSlot, {
                ...dotsSlotProps,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(DotSlot, {
                        ...dotSlotProps,
                        className: (0, $3e720f5cf13cfb0a$var$_clsx.default)(classes.dot, dotSlotProps.className, index === activeStep && classes.dotActive),
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === 'progress' && /*#__PURE__*/ (0, $ayMG0.jsx)(ProgressSlot, {
                ...progressSlotProps
            }),
            nextButton
        ]
    });
});
var $3e720f5cf13cfb0a$var$_default = module.exports.default = $3e720f5cf13cfb0a$var$MobileStepper;

});
parcelRegister("50EKC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a5c9021f712a37c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMobileStepperUtilityClass = $3a5c9021f712a37c$var$getMobileStepperUtilityClass;

var $3a5c9021f712a37c$var$_generateUtilityClasses = $3a5c9021f712a37c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3a5c9021f712a37c$var$_generateUtilityClass = $3a5c9021f712a37c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $3a5c9021f712a37c$var$getMobileStepperUtilityClass(slot) {
    return (0, $3a5c9021f712a37c$var$_generateUtilityClass.default)('MuiMobileStepper', slot);
}
const $3a5c9021f712a37c$var$mobileStepperClasses = (0, $3a5c9021f712a37c$var$_generateUtilityClasses.default)('MuiMobileStepper', [
    'root',
    'positionBottom',
    'positionTop',
    'positionStatic',
    'dots',
    'dot',
    'dotActive',
    'progress'
]);
var $3a5c9021f712a37c$var$_default = module.exports.default = $3a5c9021f712a37c$var$mobileStepperClasses;

});



parcelRegister("24k8B", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $181b936a865fd5c4$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $181b936a865fd5c4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $181b936a865fd5c4$var$_exportNames = {
    nativeSelectClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $181b936a865fd5c4$var$_NativeSelect.default;
    }
});
Object.defineProperty(module.exports, "nativeSelectClasses", {
    enumerable: true,
    get: function() {
        return $181b936a865fd5c4$var$_nativeSelectClasses.default;
    }
});

var $181b936a865fd5c4$var$_NativeSelect = $181b936a865fd5c4$require$_interopRequireDefault((parcelRequire("5cKqR")));

var $181b936a865fd5c4$var$_nativeSelectClasses = $181b936a865fd5c4$require$_interopRequireWildcard((parcelRequire("6jVRo")));
Object.keys($181b936a865fd5c4$var$_nativeSelectClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($181b936a865fd5c4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $181b936a865fd5c4$var$_nativeSelectClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $181b936a865fd5c4$var$_nativeSelectClasses[key];
        }
    });
});

});
parcelRegister("5cKqR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3ca2173d4de87b59$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3ca2173d4de87b59$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ca2173d4de87b59$var$React = $3ca2173d4de87b59$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3ca2173d4de87b59$var$_clsx = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("9QePP")));

var $3ca2173d4de87b59$var$_propTypes = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3ca2173d4de87b59$var$_composeClasses = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $3ca2173d4de87b59$var$_NativeSelectInput = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("iOErJ")));

var $3ca2173d4de87b59$var$_formControlState = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("aaphR")));

var $3ca2173d4de87b59$var$_useFormControl = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $3ca2173d4de87b59$var$_ArrowDropDown = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("7LRfY")));

var $3ca2173d4de87b59$var$_Input = $3ca2173d4de87b59$require$_interopRequireDefault((parcelRequire("eAJp9")));

var $hL1nr = parcelRequire("hL1nr");

var $6jVRo = parcelRequire("6jVRo");

var $ayMG0 = parcelRequire("ayMG0");
const $3ca2173d4de87b59$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3ca2173d4de87b59$var$_composeClasses.default)(slots, $6jVRo.getNativeSelectUtilityClasses, classes);
};
const $3ca2173d4de87b59$var$defaultInput = /*#__PURE__*/ (0, $ayMG0.jsx)($3ca2173d4de87b59$var$_Input.default, {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ const $3ca2173d4de87b59$var$NativeSelect = /*#__PURE__*/ $3ca2173d4de87b59$var$React.forwardRef(function NativeSelect(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiNativeSelect',
        props: inProps
    });
    const { className: className, children: children, classes: classesProp = {}, IconComponent: IconComponent = $3ca2173d4de87b59$var$_ArrowDropDown.default, input: input = $3ca2173d4de87b59$var$defaultInput, inputProps: inputProps, variant: variant, ...other } = props;
    const muiFormControl = (0, $3ca2173d4de87b59$var$_useFormControl.default)();
    const fcs = (0, $3ca2173d4de87b59$var$_formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    const ownerState = {
        ...props,
        classes: classesProp
    };
    const classes = $3ca2173d4de87b59$var$useUtilityClasses(ownerState);
    const { root: root, ...otherClasses } = classesProp;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3ca2173d4de87b59$var$React.Fragment, {
        children: /*#__PURE__*/ $3ca2173d4de87b59$var$React.cloneElement(input, {
            // Most of the logic is implemented in `NativeSelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent: $3ca2173d4de87b59$var$_NativeSelectInput.default,
            inputProps: {
                children: children,
                classes: otherClasses,
                IconComponent: IconComponent,
                variant: fcs.variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                ...inputProps,
                ...input ? input.props.inputProps : {}
            },
            ref: ref,
            ...other,
            className: (0, $3ca2173d4de87b59$var$_clsx.default)(classes.root, input.props.className, className)
        })
    });
});
$3ca2173d4de87b59$var$NativeSelect.muiName = 'Select';
var $3ca2173d4de87b59$var$_default = module.exports.default = $3ca2173d4de87b59$var$NativeSelect;

});


parcelRegister("cQC3m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $95a7dbf177b90875$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $95a7dbf177b90875$var$_NoSsr.default;
    }
});

var $95a7dbf177b90875$var$_NoSsr = $95a7dbf177b90875$require$_interopRequireDefault((parcelRequire("4W06i")));

});
parcelRegister("4W06i", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $397ca82a6faac65f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $397ca82a6faac65f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $397ca82a6faac65f$var$React = $397ca82a6faac65f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $397ca82a6faac65f$var$_propTypes = $397ca82a6faac65f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $397ca82a6faac65f$var$_useEnhancedEffect = $397ca82a6faac65f$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $397ca82a6faac65f$var$_exactProp = $397ca82a6faac65f$require$_interopRequireDefault((parcelRequire("5S3aN")));
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * * Escape hatch for broken dependencies not supporting SSR.
 * * Improve the time-to-first paint on the client by only rendering above the fold.
 * * Reduce the rendering time on the server.
 * * Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/material-ui/api/no-ssr/)
 */ function $397ca82a6faac65f$var$NoSsr(props) {
    const { children: children, defer: defer = false, fallback: fallback = null } = props;
    const [mountedState, setMountedState] = $397ca82a6faac65f$var$React.useState(false);
    (0, $397ca82a6faac65f$var$_useEnhancedEffect.default)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $397ca82a6faac65f$var$React.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // TODO casting won't be needed at one point https://github.com/DefinitelyTyped/DefinitelyTyped/pull/65135
    return mountedState ? children : fallback;
}
var $397ca82a6faac65f$var$_default = module.exports.default = $397ca82a6faac65f$var$NoSsr;

});


parcelRegister("lAj4Z", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb6bc293e767dac6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fb6bc293e767dac6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb6bc293e767dac6$var$_exportNames = {
    paginationClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb6bc293e767dac6$var$_Pagination.default;
    }
});
Object.defineProperty(module.exports, "paginationClasses", {
    enumerable: true,
    get: function() {
        return $fb6bc293e767dac6$var$_paginationClasses.default;
    }
});

var $fb6bc293e767dac6$var$_Pagination = $fb6bc293e767dac6$require$_interopRequireDefault((parcelRequire("GXAmj")));

var $fb6bc293e767dac6$var$_paginationClasses = $fb6bc293e767dac6$require$_interopRequireWildcard((parcelRequire("jozOO")));
Object.keys($fb6bc293e767dac6$var$_paginationClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb6bc293e767dac6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb6bc293e767dac6$var$_paginationClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb6bc293e767dac6$var$_paginationClasses[key];
        }
    });
});

});
parcelRegister("GXAmj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $081224c8d3cb055f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $081224c8d3cb055f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $081224c8d3cb055f$var$React = $081224c8d3cb055f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $081224c8d3cb055f$var$_propTypes = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $081224c8d3cb055f$var$_clsx = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("9QePP")));

var $081224c8d3cb055f$var$_composeClasses = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $081224c8d3cb055f$var$_integerPropType = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $jozOO = parcelRequire("jozOO");

var $081224c8d3cb055f$var$_usePagination = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("8WIPv")));

var $081224c8d3cb055f$var$_PaginationItem = $081224c8d3cb055f$require$_interopRequireDefault((parcelRequire("5SUZl")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $081224c8d3cb055f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $081224c8d3cb055f$var$_composeClasses.default)(slots, $jozOO.getPaginationUtilityClass, classes);
};
const $081224c8d3cb055f$var$PaginationRoot = (0, $aAbgT.styled)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $081224c8d3cb055f$var$PaginationUl = (0, $aAbgT.styled)('ul', {
    name: 'MuiPagination',
    slot: 'Ul'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $081224c8d3cb055f$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $081224c8d3cb055f$var$Pagination = /*#__PURE__*/ $081224c8d3cb055f$var$React.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $081224c8d3cb055f$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: onChange, page: page, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$_PaginationItem.default, {
            ...item
        }), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text', ...other } = props;
    const { items: items } = (0, $081224c8d3cb055f$var$_usePagination.default)({
        ...props,
        componentName: 'Pagination'
    });
    const ownerState = {
        ...props,
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    };
    const classes = $081224c8d3cb055f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationRoot, {
        "aria-label": "pagination navigation",
        className: (0, $081224c8d3cb055f$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: renderItem({
                        ...item,
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    })
                }, index))
        })
    });
});
var $081224c8d3cb055f$var$_default = module.exports.default = $081224c8d3cb055f$var$Pagination;

});
parcelRegister("jozOO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e1ec0b0c4e143dec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaginationUtilityClass = $e1ec0b0c4e143dec$var$getPaginationUtilityClass;

var $e1ec0b0c4e143dec$var$_generateUtilityClasses = $e1ec0b0c4e143dec$require$_interopRequireDefault((parcelRequire("5nY49")));

var $e1ec0b0c4e143dec$var$_generateUtilityClass = $e1ec0b0c4e143dec$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $e1ec0b0c4e143dec$var$getPaginationUtilityClass(slot) {
    return (0, $e1ec0b0c4e143dec$var$_generateUtilityClass.default)('MuiPagination', slot);
}
const $e1ec0b0c4e143dec$var$paginationClasses = (0, $e1ec0b0c4e143dec$var$_generateUtilityClasses.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $e1ec0b0c4e143dec$var$_default = module.exports.default = $e1ec0b0c4e143dec$var$paginationClasses;

});

parcelRegister("8WIPv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $683683be0e6e5e52$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $683683be0e6e5e52$var$_usePagination.default;
    }
});

var $683683be0e6e5e52$var$_usePagination = $683683be0e6e5e52$require$_interopRequireDefault((parcelRequire("lIrIv")));

});
parcelRegister("lIrIv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fcf3350ab6dcf91e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fcf3350ab6dcf91e$var$usePagination;

var $fcf3350ab6dcf91e$var$_useControlled = $fcf3350ab6dcf91e$require$_interopRequireDefault((parcelRequire("iSpB2")));
function $fcf3350ab6dcf91e$var$usePagination(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, ...other } = props;
    const [page, setPageState] = (0, $fcf3350ab6dcf91e$var$_useControlled.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    count - boundaryCount - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'page' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || !item.includes('ellipsis') && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return {
        items: items,
        ...other
    };
}

});


parcelRegister("5SUZl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $448e339b1c87d651$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $448e339b1c87d651$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $448e339b1c87d651$var$_exportNames = {
    paginationItemClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $448e339b1c87d651$var$_PaginationItem.default;
    }
});
Object.defineProperty(module.exports, "paginationItemClasses", {
    enumerable: true,
    get: function() {
        return $448e339b1c87d651$var$_paginationItemClasses.default;
    }
});

var $448e339b1c87d651$var$_PaginationItem = $448e339b1c87d651$require$_interopRequireDefault((parcelRequire("973a9")));

var $448e339b1c87d651$var$_paginationItemClasses = $448e339b1c87d651$require$_interopRequireWildcard((parcelRequire("97hzb")));
Object.keys($448e339b1c87d651$var$_paginationItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($448e339b1c87d651$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $448e339b1c87d651$var$_paginationItemClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $448e339b1c87d651$var$_paginationItemClasses[key];
        }
    });
});

});
parcelRegister("973a9", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6a273894865f8b08$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6a273894865f8b08$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a273894865f8b08$var$React = $6a273894865f8b08$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6a273894865f8b08$var$_propTypes = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6a273894865f8b08$var$_clsx = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("9QePP")));

var $6a273894865f8b08$var$_composeClasses = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $6a273894865f8b08$var$_paginationItemClasses = $6a273894865f8b08$require$_interopRequireWildcard((parcelRequire("97hzb")));

var $6a273894865f8b08$var$_ButtonBase = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $6a273894865f8b08$var$_capitalize = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $6a273894865f8b08$var$_createSimplePaletteValueFilter = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $6a273894865f8b08$var$_FirstPage = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("21SL6")));

var $6a273894865f8b08$var$_LastPage = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("5izos")));

var $6a273894865f8b08$var$_NavigateBefore = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("3kz9M")));

var $6a273894865f8b08$var$_NavigateNext = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("89ow0")));

var $6a273894865f8b08$var$_useSlot = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("6lpak")));

var $aAbgT = parcelRequire("aAbgT");

var $6a273894865f8b08$var$_memoTheme = $6a273894865f8b08$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $6a273894865f8b08$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $6a273894865f8b08$var$_capitalize.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $6a273894865f8b08$var$_capitalize.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $6a273894865f8b08$var$_capitalize.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $6a273894865f8b08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $6a273894865f8b08$var$_capitalize.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $6a273894865f8b08$var$_capitalize.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $6a273894865f8b08$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $6a273894865f8b08$var$_composeClasses.default)(slots, $6a273894865f8b08$var$_paginationItemClasses.getPaginationItemUtilityClass, classes);
};
const $6a273894865f8b08$var$PaginationItemEllipsis = (0, $aAbgT.styled)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})((0, $6a273894865f8b08$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $6a273894865f8b08$var$PaginationItemPage = (0, $aAbgT.styled)($6a273894865f8b08$var$_ButtonBase.default, {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})((0, $6a273894865f8b08$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            },
            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    minWidth: 26,
                    height: 26,
                    borderRadius: 13,
                    margin: '0 1px',
                    padding: '0 4px'
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    minWidth: 40,
                    height: 40,
                    borderRadius: 20,
                    padding: '0 10px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    shape: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                    [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                            borderColor: (theme.vars || theme).palette.action.disabledBackground,
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $6a273894865f8b08$var$_createSimplePaletteValueFilter.default)([
                'dark',
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        variant: 'text',
                        color: color
                    },
                    style: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].contrastText,
                            backgroundColor: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: (theme.vars || theme).palette[color].dark,
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: (theme.vars || theme).palette[color].main
                                }
                            },
                            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
                                backgroundColor: (theme.vars || theme).palette[color].dark
                            },
                            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.disabled}`]: {
                                color: (theme.vars || theme).palette.action.disabled
                            }
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $6a273894865f8b08$var$_createSimplePaletteValueFilter.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.5)}`,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.activatedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${$6a273894865f8b08$var$_paginationItemClasses.default.focusVisible}`]: {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.activatedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                            }
                        }
                    }
                }))
        ]
    })));
const $6a273894865f8b08$var$PaginationItemPageIcon = (0, $aAbgT.styled)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon'
})((0, $6a273894865f8b08$var$_memoTheme.default)(({ theme: theme })=>({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px',
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(22)
                }
            }
        ]
    })));
const $6a273894865f8b08$var$PaginationItem = /*#__PURE__*/ $6a273894865f8b08$var$React.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, type: type = 'page', variant: variant = 'text', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    };
    const isRtl = (0, $9uEev.useRtl)();
    const classes = $6a273894865f8b08$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            previous: slots.previous ?? components.previous,
            next: slots.next ?? components.next,
            first: slots.first ?? components.first,
            last: slots.last ?? components.last
        },
        slotProps: slotProps
    };
    const [PreviousSlot, previousSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('previous', {
        elementType: $6a273894865f8b08$var$_NavigateBefore.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [NextSlot, nextSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('next', {
        elementType: $6a273894865f8b08$var$_NavigateNext.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FirstSlot, firstSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('first', {
        elementType: $6a273894865f8b08$var$_FirstPage.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [LastSlot, lastSlotProps] = (0, $6a273894865f8b08$var$_useSlot.default)('last', {
        elementType: $6a273894865f8b08$var$_LastPage.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const rtlAwareType = isRtl ? ({
        previous: 'next',
        next: 'previous',
        first: 'last',
        last: 'first'
    })[type] : type;
    const IconSlot = {
        previous: PreviousSlot,
        next: NextSlot,
        first: FirstSlot,
        last: LastSlot
    }[rtlAwareType];
    const iconSlotProps = {
        previous: previousSlotProps,
        next: nextSlotProps,
        first: firstSlotProps,
        last: lastSlotProps
    }[rtlAwareType];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $6a273894865f8b08$var$_clsx.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($6a273894865f8b08$var$PaginationItemPage, {
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $6a273894865f8b08$var$_clsx.default)(classes.root, className),
        ...other,
        children: [
            type === 'page' && page,
            IconSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemPageIcon, {
                ...iconSlotProps,
                className: classes.icon,
                as: IconSlot
            }) : null
        ]
    });
});
var $6a273894865f8b08$var$_default = module.exports.default = $6a273894865f8b08$var$PaginationItem;

});
parcelRegister("97hzb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a3264dc4d579370$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPaginationItemUtilityClass = $6a3264dc4d579370$var$getPaginationItemUtilityClass;

var $6a3264dc4d579370$var$_generateUtilityClasses = $6a3264dc4d579370$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6a3264dc4d579370$var$_generateUtilityClass = $6a3264dc4d579370$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6a3264dc4d579370$var$getPaginationItemUtilityClass(slot) {
    return (0, $6a3264dc4d579370$var$_generateUtilityClass.default)('MuiPaginationItem', slot);
}
const $6a3264dc4d579370$var$paginationItemClasses = (0, $6a3264dc4d579370$var$_generateUtilityClasses.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $6a3264dc4d579370$var$_default = module.exports.default = $6a3264dc4d579370$var$paginationItemClasses;

});

parcelRegister("3kz9M", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $26ce82c6cc8a75d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26ce82c6cc8a75d9$var$_createSvgIcon = $26ce82c6cc8a75d9$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $26ce82c6cc8a75d9$var$_default = module.exports.default = (0, $26ce82c6cc8a75d9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

});

parcelRegister("89ow0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5ef22e36056d1791$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef22e36056d1791$var$_createSvgIcon = $5ef22e36056d1791$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $5ef22e36056d1791$var$_default = module.exports.default = (0, $5ef22e36056d1791$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

});





parcelRegister("5Gk0e", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4230641a48862144$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4230641a48862144$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4230641a48862144$var$_exportNames = {
    radioClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4230641a48862144$var$_Radio.default;
    }
});
Object.defineProperty(module.exports, "radioClasses", {
    enumerable: true,
    get: function() {
        return $4230641a48862144$var$_radioClasses.default;
    }
});

var $4230641a48862144$var$_Radio = $4230641a48862144$require$_interopRequireDefault((parcelRequire("hrMZe")));

var $4230641a48862144$var$_radioClasses = $4230641a48862144$require$_interopRequireWildcard((parcelRequire("iHxWE")));
Object.keys($4230641a48862144$var$_radioClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4230641a48862144$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4230641a48862144$var$_radioClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4230641a48862144$var$_radioClasses[key];
        }
    });
});

});
parcelRegister("hrMZe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $cb3af4fea2cad44e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $cb3af4fea2cad44e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb3af4fea2cad44e$var$React = $cb3af4fea2cad44e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cb3af4fea2cad44e$var$_propTypes = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cb3af4fea2cad44e$var$_clsx = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cb3af4fea2cad44e$var$_refType = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $cb3af4fea2cad44e$var$_composeClasses = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $cb3af4fea2cad44e$var$_SwitchBase = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("kVqvD")));

var $cb3af4fea2cad44e$var$_RadioButtonIcon = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("9plBP")));

var $cb3af4fea2cad44e$var$_capitalize = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $cb3af4fea2cad44e$var$_createChainedFunction = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("5gbhl")));

var $cb3af4fea2cad44e$var$_useFormControl = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("cJQfW")));

var $cb3af4fea2cad44e$var$_useRadioGroup = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("k0Fx1")));

var $cb3af4fea2cad44e$var$_radioClasses = $cb3af4fea2cad44e$require$_interopRequireWildcard((parcelRequire("iHxWE")));

var $cb3af4fea2cad44e$var$_rootShouldForwardProp = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $cb3af4fea2cad44e$var$_memoTheme = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $cb3af4fea2cad44e$var$_createSimplePaletteValueFilter = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $cb3af4fea2cad44e$var$_useSlot = $cb3af4fea2cad44e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $cb3af4fea2cad44e$var$_capitalize.default)(color)}`,
            size !== 'medium' && `size${(0, $cb3af4fea2cad44e$var$_capitalize.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $cb3af4fea2cad44e$var$_composeClasses.default)(slots, $cb3af4fea2cad44e$var$_radioClasses.getRadioUtilityClass, classes)
    };
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $aAbgT.styled)($cb3af4fea2cad44e$var$_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, $cb3af4fea2cad44e$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $cb3af4fea2cad44e$var$_capitalize.default)(ownerState.size)}`],
            styles[`color${(0, $cb3af4fea2cad44e$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $cb3af4fea2cad44e$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${$cb3af4fea2cad44e$var$_radioClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $cb3af4fea2cad44e$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $cb3af4fea2cad44e$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${$cb3af4fea2cad44e$var$_radioClasses.default.checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$_RadioButtonIcon.default, {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($cb3af4fea2cad44e$var$_RadioButtonIcon.default, {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $cb3af4fea2cad44e$var$React.forwardRef(function Radio(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $cb3af4fea2cad44e$var$_useFormControl.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ?? (disabled = false);
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $cb3af4fea2cad44e$var$_useRadioGroup.default)();
    let checked = checkedProp;
    const onChange = (0, $cb3af4fea2cad44e$var$_createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $cb3af4fea2cad44e$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $cb3af4fea2cad44e$var$RadioRoot,
        className: (0, $cb3af4fea2cad44e$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $cb3af4fea2cad44e$var$React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $cb3af4fea2cad44e$var$React.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $cb3af4fea2cad44e$var$_default = module.exports.default = $cb3af4fea2cad44e$var$Radio;

});
parcelRegister("9plBP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6d9735fee3c00fe1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d9735fee3c00fe1$var$_propTypes = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6d9735fee3c00fe1$var$_RadioButtonUnchecked = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("k0iyu")));

var $6d9735fee3c00fe1$var$_RadioButtonChecked = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("jA2KS")));

var $6d9735fee3c00fe1$var$_rootShouldForwardProp = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $aAbgT = parcelRequire("aAbgT");

var $6d9735fee3c00fe1$var$_memoTheme = $6d9735fee3c00fe1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ayMG0 = parcelRequire("ayMG0");
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: $6d9735fee3c00fe1$var$_rootShouldForwardProp.default
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $aAbgT.styled)($6d9735fee3c00fe1$var$_RadioButtonUnchecked.default, {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $aAbgT.styled)($6d9735fee3c00fe1$var$_RadioButtonChecked.default, {
    name: 'MuiRadioButtonIcon'
})((0, $6d9735fee3c00fe1$var$_memoTheme.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $6d9735fee3c00fe1$var$_default = module.exports.default = $6d9735fee3c00fe1$var$RadioButtonIcon;

});
parcelRegister("k0iyu", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $03c2199a765ab5af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c2199a765ab5af$var$_createSvgIcon = $03c2199a765ab5af$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $03c2199a765ab5af$var$_default = module.exports.default = (0, $03c2199a765ab5af$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

});

parcelRegister("jA2KS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e413843d0810bb75$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e413843d0810bb75$var$_createSvgIcon = $e413843d0810bb75$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $e413843d0810bb75$var$_default = module.exports.default = (0, $e413843d0810bb75$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

});


parcelRegister("k0Fx1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e9140607eee18105$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e9140607eee18105$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9140607eee18105$var$useRadioGroup;

var $e9140607eee18105$var$React = $e9140607eee18105$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e9140607eee18105$var$_RadioGroupContext = $e9140607eee18105$require$_interopRequireDefault((parcelRequire("lsybK")));
function $e9140607eee18105$var$useRadioGroup() {
    return $e9140607eee18105$var$React.useContext($e9140607eee18105$var$_RadioGroupContext.default);
}

});
parcelRegister("lsybK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f9f6bb9b992d33b5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9f6bb9b992d33b5$var$React = $f9f6bb9b992d33b5$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $f9f6bb9b992d33b5$var$React.createContext(undefined);
var $f9f6bb9b992d33b5$var$_default = module.exports.default = $f9f6bb9b992d33b5$var$RadioGroupContext;

});


parcelRegister("iHxWE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d9d692e9561f6352$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRadioUtilityClass = $d9d692e9561f6352$var$getRadioUtilityClass;

var $d9d692e9561f6352$var$_generateUtilityClasses = $d9d692e9561f6352$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d9d692e9561f6352$var$_generateUtilityClass = $d9d692e9561f6352$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d9d692e9561f6352$var$getRadioUtilityClass(slot) {
    return (0, $d9d692e9561f6352$var$_generateUtilityClass.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $d9d692e9561f6352$var$_generateUtilityClasses.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$var$_default = module.exports.default = $d9d692e9561f6352$var$radioClasses;

});



parcelRegister("31l3D", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2331ccb4eb2af4bc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2331ccb4eb2af4bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2331ccb4eb2af4bc$var$_exportNames = {
    useRadioGroup: true,
    radioGroupClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2331ccb4eb2af4bc$var$_RadioGroup.default;
    }
});
Object.defineProperty(module.exports, "radioGroupClasses", {
    enumerable: true,
    get: function() {
        return $2331ccb4eb2af4bc$var$_radioGroupClasses.default;
    }
});
Object.defineProperty(module.exports, "useRadioGroup", {
    enumerable: true,
    get: function() {
        return $2331ccb4eb2af4bc$var$_useRadioGroup.default;
    }
});

var $2331ccb4eb2af4bc$var$_RadioGroup = $2331ccb4eb2af4bc$require$_interopRequireDefault((parcelRequire("8IWga")));

var $2331ccb4eb2af4bc$var$_useRadioGroup = $2331ccb4eb2af4bc$require$_interopRequireDefault((parcelRequire("k0Fx1")));

var $2331ccb4eb2af4bc$var$_radioGroupClasses = $2331ccb4eb2af4bc$require$_interopRequireWildcard((parcelRequire("gWj0r")));
Object.keys($2331ccb4eb2af4bc$var$_radioGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2331ccb4eb2af4bc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2331ccb4eb2af4bc$var$_radioGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2331ccb4eb2af4bc$var$_radioGroupClasses[key];
        }
    });
});

});
parcelRegister("8IWga", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $659f9ff12b4e3755$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $659f9ff12b4e3755$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659f9ff12b4e3755$var$React = $659f9ff12b4e3755$require$_interopRequireWildcard((parcelRequire("acw62")));

var $659f9ff12b4e3755$var$_propTypes = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $659f9ff12b4e3755$var$_clsx = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("9QePP")));

var $659f9ff12b4e3755$var$_composeClasses = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $659f9ff12b4e3755$var$_FormGroup = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("buuiu")));

var $gWj0r = parcelRequire("gWj0r");

var $659f9ff12b4e3755$var$_useForkRef = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $659f9ff12b4e3755$var$_useControlled = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("3yddg")));

var $659f9ff12b4e3755$var$_RadioGroupContext = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("lsybK")));

var $659f9ff12b4e3755$var$_useId = $659f9ff12b4e3755$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $ayMG0 = parcelRequire("ayMG0");
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $659f9ff12b4e3755$var$_composeClasses.default)(slots, $gWj0r.getRadioGroupUtilityClass, classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $659f9ff12b4e3755$var$React.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $659f9ff12b4e3755$var$React.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $659f9ff12b4e3755$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $659f9ff12b4e3755$var$React.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $659f9ff12b4e3755$var$_useForkRef.default)(ref, rootRef);
    const name = (0, $659f9ff12b4e3755$var$_useId.default)(nameProp);
    const contextValue = $659f9ff12b4e3755$var$React.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($659f9ff12b4e3755$var$_RadioGroupContext.default.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($659f9ff12b4e3755$var$_FormGroup.default, {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $659f9ff12b4e3755$var$_clsx.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $659f9ff12b4e3755$var$_default = module.exports.default = $659f9ff12b4e3755$var$RadioGroup;

});
parcelRegister("gWj0r", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c550ce5d3f5617f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRadioGroupUtilityClass = $c550ce5d3f5617f8$var$getRadioGroupUtilityClass;

var $c550ce5d3f5617f8$var$_generateUtilityClasses = $c550ce5d3f5617f8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c550ce5d3f5617f8$var$_generateUtilityClass = $c550ce5d3f5617f8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c550ce5d3f5617f8$var$getRadioGroupUtilityClass(slot) {
    return (0, $c550ce5d3f5617f8$var$_generateUtilityClass.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $c550ce5d3f5617f8$var$_generateUtilityClasses.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$var$_default = module.exports.default = $c550ce5d3f5617f8$var$radioGroupClasses;

});



parcelRegister("lNr9b", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fde33b68b1c0968e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $fde33b68b1c0968e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fde33b68b1c0968e$var$_exportNames = {
    ratingClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fde33b68b1c0968e$var$_Rating.default;
    }
});
Object.defineProperty(module.exports, "ratingClasses", {
    enumerable: true,
    get: function() {
        return $fde33b68b1c0968e$var$_ratingClasses.default;
    }
});

var $fde33b68b1c0968e$var$_Rating = $fde33b68b1c0968e$require$_interopRequireDefault((parcelRequire("dVqTC")));

var $fde33b68b1c0968e$var$_ratingClasses = $fde33b68b1c0968e$require$_interopRequireWildcard((parcelRequire("7ynaW")));
Object.keys($fde33b68b1c0968e$var$_ratingClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fde33b68b1c0968e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fde33b68b1c0968e$var$_ratingClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fde33b68b1c0968e$var$_ratingClasses[key];
        }
    });
});

});
parcelRegister("dVqTC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a235763b3a7014ab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a235763b3a7014ab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a235763b3a7014ab$var$_react = $a235763b3a7014ab$require$_interopRequireWildcard((parcelRequire("acw62")));
var $a235763b3a7014ab$var$React = $a235763b3a7014ab$var$_react;

var $a235763b3a7014ab$var$_propTypes = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a235763b3a7014ab$var$_clsx = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a235763b3a7014ab$var$_clamp = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("3zA0b")));

var $a235763b3a7014ab$var$_visuallyHidden = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("1YYSs")));

var $a235763b3a7014ab$var$_chainPropTypes = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("abVWF")));

var $a235763b3a7014ab$var$_composeClasses = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $a235763b3a7014ab$var$_isFocusVisible = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("cS73m")));

var $hGPki = parcelRequire("hGPki");

var $a235763b3a7014ab$var$_Star = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("k2Gvj")));

var $a235763b3a7014ab$var$_StarBorder = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("6TAtw")));

var $aAbgT = parcelRequire("aAbgT");

var $a235763b3a7014ab$var$_memoTheme = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a235763b3a7014ab$var$_slotShouldForwardProp = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $a235763b3a7014ab$var$_ratingClasses = $a235763b3a7014ab$require$_interopRequireWildcard((parcelRequire("7ynaW")));

var $a235763b3a7014ab$var$_useSlot = $a235763b3a7014ab$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
function $a235763b3a7014ab$var$getDecimalPrecision(num) {
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $a235763b3a7014ab$var$roundValueToPrecision(value, precision) {
    if (value == null) return value;
    const nearest = Math.round(value / precision) * precision;
    return Number(nearest.toFixed($a235763b3a7014ab$var$getDecimalPrecision(precision)));
}
const $a235763b3a7014ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, size: size, readOnly: readOnly, disabled: disabled, emptyValueFocused: emptyValueFocused, focusVisible: focusVisible } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $hGPki.capitalize)(size)}`,
            disabled && 'disabled',
            focusVisible && 'focusVisible',
            readOnly && 'readOnly'
        ],
        label: [
            'label',
            'pristine'
        ],
        labelEmptyValue: [
            emptyValueFocused && 'labelEmptyValueActive'
        ],
        icon: [
            'icon'
        ],
        iconEmpty: [
            'iconEmpty'
        ],
        iconFilled: [
            'iconFilled'
        ],
        iconHover: [
            'iconHover'
        ],
        iconFocus: [
            'iconFocus'
        ],
        iconActive: [
            'iconActive'
        ],
        decimal: [
            'decimal'
        ],
        visuallyHidden: [
            'visuallyHidden'
        ]
    };
    return (0, $a235763b3a7014ab$var$_composeClasses.default)(slots, $a235763b3a7014ab$var$_ratingClasses.getRatingUtilityClass, classes);
};
const $a235763b3a7014ab$var$RatingRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiRating',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$a235763b3a7014ab$var$_ratingClasses.default.visuallyHidden}`]: styles.visuallyHidden
            },
            styles.root,
            styles[`size${(0, $hGPki.capitalize)(ownerState.size)}`],
            ownerState.readOnly && styles.readOnly
        ];
    }
})((0, $a235763b3a7014ab$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        // Required to position the pristine input absolutely
        position: 'relative',
        fontSize: theme.typography.pxToRem(24),
        color: '#faaf00',
        cursor: 'pointer',
        textAlign: 'left',
        width: 'min-content',
        WebkitTapHighlightColor: 'transparent',
        [`&.${$a235763b3a7014ab$var$_ratingClasses.default.disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`&.${$a235763b3a7014ab$var$_ratingClasses.default.focusVisible} .${$a235763b3a7014ab$var$_ratingClasses.default.iconActive}`]: {
            outline: '1px solid #999'
        },
        [`& .${$a235763b3a7014ab$var$_ratingClasses.default.visuallyHidden}`]: $a235763b3a7014ab$var$_visuallyHidden.default,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(30)
                }
            },
            {
                // TODO v6: use the .Mui-readOnly global state class
                props: ({ ownerState: ownerState })=>ownerState.readOnly,
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $a235763b3a7014ab$var$RatingLabel = (0, $aAbgT.styled)('label', {
    name: 'MuiRating',
    slot: 'Label',
    overridesResolver: ({ ownerState: ownerState }, styles)=>[
            styles.label,
            ownerState.emptyValueFocused && styles.labelEmptyValueActive
        ]
})({
    cursor: 'inherit',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.emptyValueFocused,
            style: {
                top: 0,
                bottom: 0,
                position: 'absolute',
                outline: '1px solid #999',
                width: '100%'
            }
        }
    ]
});
const $a235763b3a7014ab$var$RatingIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiRating',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.iconEmpty && styles.iconEmpty,
            ownerState.iconFilled && styles.iconFilled,
            ownerState.iconHover && styles.iconHover,
            ownerState.iconFocus && styles.iconFocus,
            ownerState.iconActive && styles.iconActive
        ];
    }
})((0, $a235763b3a7014ab$var$_memoTheme.default)(({ theme: theme })=>({
        // Fit wrapper to actual icon size.
        display: 'flex',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        // Fix mouseLeave issue.
        // https://github.com/facebook/react/issues/4492
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.iconActive,
                style: {
                    transform: 'scale(1.2)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.iconEmpty,
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            }
        ]
    })));
const $a235763b3a7014ab$var$RatingDecimal = (0, $aAbgT.styled)('span', {
    name: 'MuiRating',
    slot: 'Decimal',
    shouldForwardProp: (prop)=>(0, $a235763b3a7014ab$var$_slotShouldForwardProp.default)(prop) && prop !== 'iconActive',
    overridesResolver: (props, styles)=>{
        const { iconActive: iconActive } = props;
        return [
            styles.decimal,
            iconActive && styles.iconActive
        ];
    }
})({
    position: 'relative',
    variants: [
        {
            props: ({ iconActive: iconActive })=>iconActive,
            style: {
                transform: 'scale(1.2)'
            }
        }
    ]
});
function $a235763b3a7014ab$var$IconContainer(props) {
    const { value: value, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        ...other
    });
}
function $a235763b3a7014ab$var$RatingItem(props) {
    const { classes: classes, disabled: disabled, emptyIcon: emptyIcon, focus: focus, getLabelText: getLabelText, highlightSelectedOnly: highlightSelectedOnly, hover: hover, icon: icon, IconContainerComponent: IconContainerComponent, isActive: isActive, itemValue: itemValue, labelProps: labelProps, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, readOnly: readOnly, ownerState: ownerState, ratingValue: ratingValue, ratingValueRounded: ratingValueRounded, slots: slots = {}, slotProps: slotProps = {} } = props;
    const isFilled = highlightSelectedOnly ? itemValue === ratingValue : itemValue <= ratingValue;
    const isHovered = itemValue <= hover;
    const isFocused = itemValue <= focus;
    const isChecked = itemValue === ratingValueRounded;
    // "name" ensures unique IDs across different Rating components in React 17,
    // preventing one component from affecting another. React 18's useId already handles this.
    // Update to const id = useId(); when React 17 support is dropped.
    // More details: https://github.com/mui/material-ui/issues/40997
    const id = `${name}-${(0, $hGPki.unstable_useId)()}`;
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [IconSlot, iconSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('icon', {
        elementType: $a235763b3a7014ab$var$RatingIcon,
        className: (0, $a235763b3a7014ab$var$_clsx.default)(classes.icon, isFilled ? classes.iconFilled : classes.iconEmpty, isHovered && classes.iconHover, isFocused && classes.iconFocus, isActive && classes.iconActive),
        externalForwardedProps: externalForwardedProps,
        ownerState: {
            ...ownerState,
            iconEmpty: !isFilled,
            iconFilled: isFilled,
            iconHover: isHovered,
            iconFocus: isFocused,
            iconActive: isActive
        },
        additionalProps: {
            value: itemValue
        },
        internalForwardedProps: {
            // TODO: remove this in v7 because `IconContainerComponent` is deprecated
            // only forward if `slots.icon` is NOT provided
            as: IconContainerComponent
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('label', {
        elementType: $a235763b3a7014ab$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: {
            ...ownerState,
            emptyValueFocused: undefined
        },
        additionalProps: {
            style: labelProps?.style,
            htmlFor: id
        }
    });
    const container = /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
        ...iconSlotProps,
        children: emptyIcon && !isFilled ? emptyIcon : icon
    });
    if (readOnly) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        ...labelProps,
        children: container
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a235763b3a7014ab$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)(LabelSlot, {
                ...labelSlotProps,
                children: [
                    container,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: getLabelText(itemValue)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                className: classes.visuallyHidden,
                onFocus: onFocus,
                onBlur: onBlur,
                onChange: onChange,
                onClick: onClick,
                disabled: disabled,
                value: itemValue,
                id: id,
                type: "radio",
                name: name,
                checked: isChecked
            })
        ]
    });
}
const $a235763b3a7014ab$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$_Star.default, {
    fontSize: "inherit"
});
const $a235763b3a7014ab$var$defaultEmptyIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$_StarBorder.default, {
    fontSize: "inherit"
});
function $a235763b3a7014ab$var$defaultLabelText(value) {
    return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
}
const $a235763b3a7014ab$var$Rating = /*#__PURE__*/ $a235763b3a7014ab$var$React.forwardRef(function Rating(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiRating',
        props: inProps
    });
    const { component: component = 'span', className: className, defaultValue: defaultValue = null, disabled: disabled = false, emptyIcon: emptyIcon = $a235763b3a7014ab$var$defaultEmptyIcon, emptyLabelText: emptyLabelText = 'Empty', getLabelText: getLabelText = $a235763b3a7014ab$var$defaultLabelText, highlightSelectedOnly: highlightSelectedOnly = false, icon: icon = $a235763b3a7014ab$var$defaultIcon, IconContainerComponent: IconContainerComponent = $a235763b3a7014ab$var$IconContainer, max: max = 5, name: nameProp, onChange: onChange, onChangeActive: onChangeActive, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, precision: precision = 1, readOnly: readOnly = false, size: size = 'medium', value: valueProp, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const name = (0, $hGPki.unstable_useId)(nameProp);
    const [valueDerived, setValueState] = (0, $hGPki.useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Rating'
    });
    const valueRounded = $a235763b3a7014ab$var$roundValueToPrecision(valueDerived, precision);
    const isRtl = (0, $9uEev.useRtl)();
    const [{ hover: hover, focus: focus }, setState] = $a235763b3a7014ab$var$React.useState({
        hover: -1,
        focus: -1
    });
    let value = valueRounded;
    if (hover !== -1) value = hover;
    if (focus !== -1) value = focus;
    const [focusVisible, setFocusVisible] = $a235763b3a7014ab$var$React.useState(false);
    const rootRef = $a235763b3a7014ab$var$React.useRef();
    const handleRef = (0, $hGPki.useForkRef)(rootRef, ref);
    const handleMouseMove = (event)=>{
        if (onMouseMove) onMouseMove(event);
        const rootNode = rootRef.current;
        const { right: right, left: left, width: containerWidth } = rootNode.getBoundingClientRect();
        let percent;
        if (isRtl) percent = (right - event.clientX) / containerWidth;
        else percent = (event.clientX - left) / containerWidth;
        let newHover = $a235763b3a7014ab$var$roundValueToPrecision(max * percent + precision / 2, precision);
        newHover = (0, $a235763b3a7014ab$var$_clamp.default)(newHover, precision, max);
        setState((prev)=>prev.hover === newHover && prev.focus === newHover ? prev : {
                hover: newHover,
                focus: newHover
            });
        setFocusVisible(false);
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        const newHover = -1;
        setState({
            hover: newHover,
            focus: newHover
        });
        if (onChangeActive && hover !== newHover) onChangeActive(event, newHover);
    };
    const handleChange = (event)=>{
        let newValue = event.target.value === '' ? null : parseFloat(event.target.value);
        // Give mouse priority over keyboard
        // Fix https://github.com/mui/material-ui/issues/22827
        if (hover !== -1) newValue = hover;
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    };
    const handleClear = (event)=>{
        // Ignore keyboard events
        // https://github.com/facebook/react/issues/7407
        if (event.clientX === 0 && event.clientY === 0) return;
        setState({
            hover: -1,
            focus: -1
        });
        setValueState(null);
        if (onChange && parseFloat(event.target.value) === valueRounded) onChange(event, null);
    };
    const handleFocus = (event)=>{
        if ((0, $a235763b3a7014ab$var$_isFocusVisible.default)(event.target)) setFocusVisible(true);
        const newFocus = parseFloat(event.target.value);
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const handleBlur = (event)=>{
        if (hover !== -1) return;
        if (!(0, $a235763b3a7014ab$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        const newFocus = -1;
        setState((prev)=>({
                hover: prev.hover,
                focus: newFocus
            }));
    };
    const [emptyValueFocused, setEmptyValueFocused] = $a235763b3a7014ab$var$React.useState(false);
    const ownerState = {
        ...props,
        component: component,
        defaultValue: defaultValue,
        disabled: disabled,
        emptyIcon: emptyIcon,
        emptyLabelText: emptyLabelText,
        emptyValueFocused: emptyValueFocused,
        focusVisible: focusVisible,
        getLabelText: getLabelText,
        icon: icon,
        IconContainerComponent: IconContainerComponent,
        max: max,
        precision: precision,
        readOnly: readOnly,
        size: size
    };
    const classes = $a235763b3a7014ab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('root', {
        ref: handleRef,
        className: (0, $a235763b3a7014ab$var$_clsx.default)(classes.root, className),
        elementType: $a235763b3a7014ab$var$RatingRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onMouseMove: (event)=>{
                    handleMouseMove(event);
                    handlers.onMouseMove?.(event);
                },
                onMouseLeave: (event)=>{
                    handleMouseLeave(event);
                    handlers.onMouseLeave?.(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            role: readOnly ? 'img' : null,
            'aria-label': readOnly ? getLabelText(value) : null
        }
    });
    const [LabelSlot, labelSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('label', {
        className: (0, $a235763b3a7014ab$var$_clsx.default)(classes.label, classes.labelEmptyValue),
        elementType: $a235763b3a7014ab$var$RatingLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DecimalSlot, decimalSlotProps] = (0, $a235763b3a7014ab$var$_useSlot.default)('decimal', {
        className: classes.decimal,
        elementType: $a235763b3a7014ab$var$RatingDecimal,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            Array.from(new Array(max)).map((_, index)=>{
                const itemValue = index + 1;
                const ratingItemProps = {
                    classes: classes,
                    disabled: disabled,
                    emptyIcon: emptyIcon,
                    focus: focus,
                    getLabelText: getLabelText,
                    highlightSelectedOnly: highlightSelectedOnly,
                    hover: hover,
                    icon: icon,
                    IconContainerComponent: IconContainerComponent,
                    name: name,
                    onBlur: handleBlur,
                    onChange: handleChange,
                    onClick: handleClear,
                    onFocus: handleFocus,
                    ratingValue: value,
                    ratingValueRounded: valueRounded,
                    readOnly: readOnly,
                    ownerState: ownerState,
                    slots: slots,
                    slotProps: slotProps
                };
                const isActive = itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1);
                if (precision < 1) {
                    const items = Array.from(new Array(1 / precision));
                    return /*#__PURE__*/ (0, $a235763b3a7014ab$var$_react.createElement)(DecimalSlot, {
                        ...decimalSlotProps,
                        key: itemValue,
                        className: (0, $a235763b3a7014ab$var$_clsx.default)(decimalSlotProps.className, isActive && classes.iconActive),
                        iconActive: isActive
                    }, items.map(($, indexDecimal)=>{
                        const itemDecimalValue = $a235763b3a7014ab$var$roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingItem, {
                            ...ratingItemProps,
                            // The icon is already displayed as active
                            isActive: false,
                            itemValue: itemDecimalValue,
                            labelProps: {
                                style: items.length - 1 === indexDecimal ? {} : {
                                    width: itemDecimalValue === value ? `${(indexDecimal + 1) * precision * 100}%` : '0%',
                                    overflow: 'hidden',
                                    position: 'absolute'
                                }
                            }
                        }, itemDecimalValue);
                    }));
                }
                return /*#__PURE__*/ (0, $ayMG0.jsx)($a235763b3a7014ab$var$RatingItem, {
                    ...ratingItemProps,
                    isActive: isActive,
                    itemValue: itemValue
                }, itemValue);
            }),
            !readOnly && !disabled && /*#__PURE__*/ (0, $ayMG0.jsxs)(LabelSlot, {
                ...labelSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: classes.visuallyHidden,
                        value: "",
                        id: `${name}-empty`,
                        type: "radio",
                        name: name,
                        checked: valueRounded == null,
                        onFocus: ()=>setEmptyValueFocused(true),
                        onBlur: ()=>setEmptyValueFocused(false),
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.visuallyHidden,
                        children: emptyLabelText
                    })
                ]
            })
        ]
    });
});
var $a235763b3a7014ab$var$_default = module.exports.default = $a235763b3a7014ab$var$Rating;

});
parcelRegister("1YYSs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $171a9e042ff90d6b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $171a9e042ff90d6b$var$_visuallyHidden.default;
    }
});

var $171a9e042ff90d6b$var$_visuallyHidden = $171a9e042ff90d6b$require$_interopRequireDefault((parcelRequire("8llzV")));

});
parcelRegister("8llzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $613105e9b38354c3$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $613105e9b38354c3$var$_default = module.exports.default = $613105e9b38354c3$var$visuallyHidden;

});


parcelRegister("k2Gvj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e974f6f757d51cd9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e974f6f757d51cd9$var$_createSvgIcon = $e974f6f757d51cd9$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $e974f6f757d51cd9$var$_default = module.exports.default = (0, $e974f6f757d51cd9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

});

parcelRegister("6TAtw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $50542c5736b6354f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50542c5736b6354f$var$_createSvgIcon = $50542c5736b6354f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $50542c5736b6354f$var$_default = module.exports.default = (0, $50542c5736b6354f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

});

parcelRegister("7ynaW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $57fdaf8fdc94de34$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRatingUtilityClass = $57fdaf8fdc94de34$var$getRatingUtilityClass;

var $57fdaf8fdc94de34$var$_generateUtilityClasses = $57fdaf8fdc94de34$require$_interopRequireDefault((parcelRequire("5nY49")));

var $57fdaf8fdc94de34$var$_generateUtilityClass = $57fdaf8fdc94de34$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $57fdaf8fdc94de34$var$getRatingUtilityClass(slot) {
    return (0, $57fdaf8fdc94de34$var$_generateUtilityClass.default)('MuiRating', slot);
}
const $57fdaf8fdc94de34$var$ratingClasses = (0, $57fdaf8fdc94de34$var$_generateUtilityClasses.default)('MuiRating', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'readOnly',
    'disabled',
    'focusVisible',
    'visuallyHidden',
    'pristine',
    'label',
    'labelEmptyValueActive',
    'icon',
    'iconEmpty',
    'iconFilled',
    'iconHover',
    'iconFocus',
    'iconActive',
    'decimal'
]);
var $57fdaf8fdc94de34$var$_default = module.exports.default = $57fdaf8fdc94de34$var$ratingClasses;

});



parcelRegister("ePchM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $acaf5bc8fc7510ef$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $acaf5bc8fc7510ef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $acaf5bc8fc7510ef$var$_exportNames = {
    scopedCssBaselineClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $acaf5bc8fc7510ef$var$_ScopedCssBaseline.default;
    }
});
Object.defineProperty(module.exports, "scopedCssBaselineClasses", {
    enumerable: true,
    get: function() {
        return $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses.default;
    }
});

var $acaf5bc8fc7510ef$var$_ScopedCssBaseline = $acaf5bc8fc7510ef$require$_interopRequireDefault((parcelRequire("ll3GB")));

var $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses = $acaf5bc8fc7510ef$require$_interopRequireWildcard((parcelRequire("hH8RP")));
Object.keys($acaf5bc8fc7510ef$var$_scopedCssBaselineClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($acaf5bc8fc7510ef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $acaf5bc8fc7510ef$var$_scopedCssBaselineClasses[key];
        }
    });
});

});
parcelRegister("ll3GB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f88e6b262a71acad$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f88e6b262a71acad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f88e6b262a71acad$var$React = $f88e6b262a71acad$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f88e6b262a71acad$var$_propTypes = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f88e6b262a71acad$var$_clsx = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f88e6b262a71acad$var$_composeClasses = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $f88e6b262a71acad$var$_memoTheme = $f88e6b262a71acad$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $gODrq = parcelRequire("gODrq");

var $hH8RP = parcelRequire("hH8RP");

var $ayMG0 = parcelRequire("ayMG0");
const $f88e6b262a71acad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f88e6b262a71acad$var$_composeClasses.default)(slots, $hH8RP.getScopedCssBaselineUtilityClass, classes);
};
const $f88e6b262a71acad$var$ScopedCssBaselineRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiScopedCssBaseline',
    slot: 'Root'
})((0, $f88e6b262a71acad$var$_memoTheme.default)(({ theme: theme })=>{
    const colorSchemeStyles = {};
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) colorSchemeStyles[selector] = {
            colorScheme: scheme.palette?.mode
        };
        else colorSchemeStyles[`&${selector.replace(/\s*&/, '')}`] = {
            colorScheme: scheme.palette?.mode
        };
    });
    return {
        ...(0, $gODrq.html)(theme, false),
        ...(0, $gODrq.body)(theme),
        '& *, & *::before, & *::after': {
            boxSizing: 'inherit'
        },
        '& strong, & b': {
            fontWeight: theme.typography.fontWeightBold
        },
        variants: [
            {
                props: {
                    enableColorScheme: true
                },
                style: theme.vars ? colorSchemeStyles : {
                    colorScheme: theme.palette.mode
                }
            }
        ]
    };
}));
const $f88e6b262a71acad$var$ScopedCssBaseline = /*#__PURE__*/ $f88e6b262a71acad$var$React.forwardRef(function ScopedCssBaseline(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiScopedCssBaseline'
    });
    const { className: className, component: component = 'div', enableColorScheme: enableColorScheme, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $f88e6b262a71acad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f88e6b262a71acad$var$ScopedCssBaselineRoot, {
        as: component,
        className: (0, $f88e6b262a71acad$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $f88e6b262a71acad$var$_default = module.exports.default = $f88e6b262a71acad$var$ScopedCssBaseline;

});
parcelRegister("hH8RP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ce1d54a938e4ef44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getScopedCssBaselineUtilityClass = $ce1d54a938e4ef44$var$getScopedCssBaselineUtilityClass;

var $ce1d54a938e4ef44$var$_generateUtilityClasses = $ce1d54a938e4ef44$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ce1d54a938e4ef44$var$_generateUtilityClass = $ce1d54a938e4ef44$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ce1d54a938e4ef44$var$getScopedCssBaselineUtilityClass(slot) {
    return (0, $ce1d54a938e4ef44$var$_generateUtilityClass.default)('MuiScopedCssBaseline', slot);
}
const $ce1d54a938e4ef44$var$scopedCssBaselineClasses = (0, $ce1d54a938e4ef44$var$_generateUtilityClasses.default)('MuiScopedCssBaseline', [
    'root'
]);
var $ce1d54a938e4ef44$var$_default = module.exports.default = $ce1d54a938e4ef44$var$scopedCssBaselineClasses;

});



parcelRegister("1WNCH", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $16b1b35b06ce5bdf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $16b1b35b06ce5bdf$var$_exportNames = {
    sliderClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $16b1b35b06ce5bdf$var$_Slider.default;
    }
});
Object.defineProperty(module.exports, "sliderClasses", {
    enumerable: true,
    get: function() {
        return $16b1b35b06ce5bdf$var$_sliderClasses.default;
    }
});

var $16b1b35b06ce5bdf$var$_Slider = $16b1b35b06ce5bdf$require$_interopRequireWildcard((parcelRequire("jU0bc")));
Object.keys($16b1b35b06ce5bdf$var$_Slider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($16b1b35b06ce5bdf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $16b1b35b06ce5bdf$var$_Slider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $16b1b35b06ce5bdf$var$_Slider[key];
        }
    });
});

var $16b1b35b06ce5bdf$var$_sliderClasses = $16b1b35b06ce5bdf$require$_interopRequireWildcard((parcelRequire("20dvU")));
Object.keys($16b1b35b06ce5bdf$var$_sliderClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($16b1b35b06ce5bdf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $16b1b35b06ce5bdf$var$_sliderClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $16b1b35b06ce5bdf$var$_sliderClasses[key];
        }
    });
});

});
parcelRegister("jU0bc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e7d362f04a4204f3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e7d362f04a4204f3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SliderValueLabel = module.exports.SliderTrack = module.exports.SliderThumb = module.exports.SliderRoot = module.exports.SliderRail = module.exports.SliderMarkLabel = module.exports.SliderMark = void 0;

var $e7d362f04a4204f3$var$React = $e7d362f04a4204f3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e7d362f04a4204f3$var$_propTypes = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e7d362f04a4204f3$var$_clsx = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e7d362f04a4204f3$var$_chainPropTypes = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("abVWF")));

var $e7d362f04a4204f3$var$_composeClasses = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $e7d362f04a4204f3$var$_useSlotProps = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("839K0")));

var $e7d362f04a4204f3$var$_isHostComponent = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $dBUOG = parcelRequire("dBUOG");

var $aAbgT = parcelRequire("aAbgT");

var $e7d362f04a4204f3$var$_memoTheme = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $e7d362f04a4204f3$var$_slotShouldForwardProp = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("PJRTc")));

var $e7d362f04a4204f3$var$_shouldSpreadAdditionalProps = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("lTbyd")));

var $e7d362f04a4204f3$var$_capitalize = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $e7d362f04a4204f3$var$_createSimplePaletteValueFilter = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("1Anyj")));

var $e7d362f04a4204f3$var$_SliderValueLabel = $e7d362f04a4204f3$require$_interopRequireDefault((parcelRequire("2xkal")));

var $e7d362f04a4204f3$var$_sliderClasses = $e7d362f04a4204f3$require$_interopRequireWildcard((parcelRequire("20dvU")));

var $ayMG0 = parcelRequire("ayMG0");
function $e7d362f04a4204f3$var$Identity(x) {
    return x;
}
const $e7d362f04a4204f3$var$SliderRoot = module.exports.SliderRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.dragging}`]: {
            [`& .${$e7d362f04a4204f3$var$_sliderClasses.default.thumb}, & .${$e7d362f04a4204f3$var$_sliderClasses.default.track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $e7d362f04a4204f3$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$SliderRail = module.exports.SliderRail = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $e7d362f04a4204f3$var$SliderTrack = module.exports.SliderTrack = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $e7d362f04a4204f3$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: theme.lighten(theme.palette[color].main, 0.62),
                            borderColor: theme.lighten(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: theme.darken(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: theme.darken(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $e7d362f04a4204f3$var$SliderThumb = module.exports.SliderThumb = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $e7d362f04a4204f3$var$_capitalize.default)(ownerState.size)}`]
        ];
    }
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $e7d362f04a4204f3$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${$e7d362f04a4204f3$var$_sliderClasses.default.focusVisible}`]: {
                            boxShadow: `0px 0px 0px 8px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`,
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.active}`]: {
                            boxShadow: `0px 0px 0px 14px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`
                        }
                    }
                }))
        ]
    })));
const $e7d362f04a4204f3$var$SliderValueLabel = module.exports.SliderValueLabel = (0, $aAbgT.styled)($e7d362f04a4204f3$var$_SliderValueLabel.default, {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${$e7d362f04a4204f3$var$_sliderClasses.default.valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$SliderMark = module.exports.SliderMark = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $e7d362f04a4204f3$var$_slotShouldForwardProp.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$SliderMarkLabel = module.exports.SliderMarkLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $e7d362f04a4204f3$var$_slotShouldForwardProp.default)(prop) && prop !== 'markLabelActive'
})((0, $e7d362f04a4204f3$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $e7d362f04a4204f3$var$_capitalize.default)(color)}`,
            size && `size${(0, $e7d362f04a4204f3$var$_capitalize.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $e7d362f04a4204f3$var$_capitalize.default)(size)}`,
            color && `thumbColor${(0, $e7d362f04a4204f3$var$_capitalize.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $e7d362f04a4204f3$var$_composeClasses.default)(slots, $e7d362f04a4204f3$var$_sliderClasses.getSliderUtilityClass, classes);
};
const $e7d362f04a4204f3$var$Forward = ({ children: children })=>children;
const $e7d362f04a4204f3$var$Slider = /*#__PURE__*/ $e7d362f04a4204f3$var$React.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $9uEev.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $e7d362f04a4204f3$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $e7d362f04a4204f3$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $dBUOG.useSlider)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $e7d362f04a4204f3$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $e7d362f04a4204f3$var$SliderRoot;
    const RailSlot = slots?.rail ?? components.Rail ?? $e7d362f04a4204f3$var$SliderRail;
    const TrackSlot = slots?.track ?? components.Track ?? $e7d362f04a4204f3$var$SliderTrack;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $e7d362f04a4204f3$var$SliderThumb;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $e7d362f04a4204f3$var$SliderValueLabel;
    const MarkSlot = slots?.mark ?? components.Mark ?? $e7d362f04a4204f3$var$SliderMark;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $e7d362f04a4204f3$var$SliderMarkLabel;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $e7d362f04a4204f3$var$_shouldSpreadAdditionalProps.default)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $e7d362f04a4204f3$var$_useSlotProps.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $dBUOG.valueToPercent)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($e7d362f04a4204f3$var$React.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $e7d362f04a4204f3$var$_isHostComponent.default)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $e7d362f04a4204f3$var$_clsx.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $e7d362f04a4204f3$var$_isHostComponent.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $e7d362f04a4204f3$var$_clsx.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $dBUOG.valueToPercent)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $e7d362f04a4204f3$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, {
                    ...!(0, $e7d362f04a4204f3$var$_isHostComponent.default)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $e7d362f04a4204f3$var$_clsx.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $e7d362f04a4204f3$var$_default = module.exports.default = $e7d362f04a4204f3$var$Slider;

});
parcelRegister("dBUOG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9e8acd9e5bad7cc4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9e8acd9e5bad7cc4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Identity = void 0;
module.exports.useSlider = $9e8acd9e5bad7cc4$var$useSlider;
module.exports.valueToPercent = $9e8acd9e5bad7cc4$var$valueToPercent;

var $9e8acd9e5bad7cc4$var$React = $9e8acd9e5bad7cc4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9e8acd9e5bad7cc4$var$_ownerDocument = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("43fuO")));

var $9e8acd9e5bad7cc4$var$_useControlled = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $9e8acd9e5bad7cc4$var$_useEnhancedEffect = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $9e8acd9e5bad7cc4$var$_useEventCallback = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9e8acd9e5bad7cc4$var$_useForkRef = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $9e8acd9e5bad7cc4$var$_isFocusVisible = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("cS73m")));

var $9e8acd9e5bad7cc4$var$_visuallyHidden = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("1YYSs")));

var $9e8acd9e5bad7cc4$var$_clamp = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("3zA0b")));

var $9e8acd9e5bad7cc4$var$_extractEventHandlers = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $9e8acd9e5bad7cc4$var$_areArraysEqual = $9e8acd9e5bad7cc4$require$_interopRequireDefault((parcelRequire("9r78y")));
const $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $9e8acd9e5bad7cc4$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $9e8acd9e5bad7cc4$var$asc(a, b) {
    return a - b;
}
function $9e8acd9e5bad7cc4$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $9e8acd9e5bad7cc4$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e8acd9e5bad7cc4$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e8acd9e5bad7cc4$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e8acd9e5bad7cc4$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e8acd9e5bad7cc4$var$getDecimalPrecision(step)));
}
function $9e8acd9e5bad7cc4$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($9e8acd9e5bad7cc4$var$asc);
}
function $9e8acd9e5bad7cc4$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $9e8acd9e5bad7cc4$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $9e8acd9e5bad7cc4$var$_areArraysEqual.default)(newValue, oldValue);
    return false;
}
const $9e8acd9e5bad7cc4$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $9e8acd9e5bad7cc4$var$Identity = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
module.exports.Identity = $9e8acd9e5bad7cc4$var$Identity;
let $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
function $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone() {
    if ($9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = true;
    }
    return $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
}
function $9e8acd9e5bad7cc4$var$useSlider(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $9e8acd9e5bad7cc4$var$Identity, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $9e8acd9e5bad7cc4$var$React.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $9e8acd9e5bad7cc4$var$React.useState(-1);
    const [open, setOpen] = $9e8acd9e5bad7cc4$var$React.useState(-1);
    const [dragging, setDragging] = $9e8acd9e5bad7cc4$var$React.useState(false);
    const moveCount = $9e8acd9e5bad7cc4$var$React.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $9e8acd9e5bad7cc4$var$React.useRef(null);
    const [valueDerived, setValueState] = (0, $9e8acd9e5bad7cc4$var$_useControlled.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($9e8acd9e5bad7cc4$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $9e8acd9e5bad7cc4$var$_clamp.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $9e8acd9e5bad7cc4$var$React.useState(-1);
    const sliderRef = $9e8acd9e5bad7cc4$var$React.useRef(null);
    const handleRef = (0, $9e8acd9e5bad7cc4$var$_useForkRef.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $9e8acd9e5bad7cc4$var$_isFocusVisible.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $9e8acd9e5bad7cc4$var$_isFocusVisible.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $9e8acd9e5bad7cc4$var$_useEnhancedEffect.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $9e8acd9e5bad7cc4$var$React.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max);
        if (step) newValue = $9e8acd9e5bad7cc4$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $9e8acd9e5bad7cc4$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e8acd9e5bad7cc4$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $9e8acd9e5bad7cc4$var$_clamp.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $9e8acd9e5bad7cc4$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $9e8acd9e5bad7cc4$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $9e8acd9e5bad7cc4$var$_useEventCallback.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $9e8acd9e5bad7cc4$var$_useEventCallback.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $9e8acd9e5bad7cc4$var$React.useCallback(()=>{
        const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $9e8acd9e5bad7cc4$var$React.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $9e8acd9e5bad7cc4$var$React.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $9e8acd9e5bad7cc4$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $9e8acd9e5bad7cc4$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $9e8acd9e5bad7cc4$var$_ownerDocument.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $9e8acd9e5bad7cc4$var$valueToPercent(range ? values[0] : min, min, max);
    const trackLeap = $9e8acd9e5bad7cc4$var$valueToPercent(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $9e8acd9e5bad7cc4$var$_extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $9e8acd9e5bad7cc4$var$_extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $9e8acd9e5bad7cc4$var$_extractEventHandlers.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...$9e8acd9e5bad7cc4$var$_visuallyHidden.default,
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $9e8acd9e5bad7cc4$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}

});
parcelRegister("9r78y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $6dec2bf07d6d333a$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $6dec2bf07d6d333a$var$_default = module.exports.default = $6dec2bf07d6d333a$var$areArraysEqual;

});


parcelRegister("lTbyd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fef7b1c426e97238$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fef7b1c426e97238$var$_isHostComponent = $fef7b1c426e97238$require$_interopRequireDefault((parcelRequire("7jqh1")));
const $fef7b1c426e97238$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $fef7b1c426e97238$var$_isHostComponent.default)(Slot);
};
var $fef7b1c426e97238$var$_default = module.exports.default = $fef7b1c426e97238$var$shouldSpreadAdditionalProps;

});

parcelRegister("2xkal", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1d8e4e584d12bd05$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1d8e4e584d12bd05$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d8e4e584d12bd05$var$SliderValueLabel;

var $1d8e4e584d12bd05$var$React = $1d8e4e584d12bd05$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1d8e4e584d12bd05$var$_propTypes = $1d8e4e584d12bd05$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1d8e4e584d12bd05$var$_clsx = $1d8e4e584d12bd05$require$_interopRequireDefault((parcelRequire("9QePP")));

var $1d8e4e584d12bd05$var$_sliderClasses = $1d8e4e584d12bd05$require$_interopRequireDefault((parcelRequire("20dvU")));

var $ayMG0 = parcelRequire("ayMG0");
const $1d8e4e584d12bd05$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $1d8e4e584d12bd05$var$_clsx.default)(open && $1d8e4e584d12bd05$var$_sliderClasses.default.valueLabelOpen),
        circle: $1d8e4e584d12bd05$var$_sliderClasses.default.valueLabelCircle,
        label: $1d8e4e584d12bd05$var$_sliderClasses.default.valueLabelLabel
    };
    return utilityClasses;
};
/**
 * @ignore - internal component.
 */ function $1d8e4e584d12bd05$var$SliderValueLabel(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $1d8e4e584d12bd05$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $1d8e4e584d12bd05$var$React.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($1d8e4e584d12bd05$var$React.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $1d8e4e584d12bd05$var$_clsx.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}

});
parcelRegister("20dvU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $175610683d4083b7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSliderUtilityClass = $175610683d4083b7$var$getSliderUtilityClass;

var $175610683d4083b7$var$_generateUtilityClasses = $175610683d4083b7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $175610683d4083b7$var$_generateUtilityClass = $175610683d4083b7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $175610683d4083b7$var$getSliderUtilityClass(slot) {
    return (0, $175610683d4083b7$var$_generateUtilityClass.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $175610683d4083b7$var$_generateUtilityClasses.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$var$_default = module.exports.default = $175610683d4083b7$var$sliderClasses;

});




parcelRegister("b3tNC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80c71705f119f7ad$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $80c71705f119f7ad$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80c71705f119f7ad$var$_exportNames = {
    snackbarClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80c71705f119f7ad$var$_Snackbar.default;
    }
});
Object.defineProperty(module.exports, "snackbarClasses", {
    enumerable: true,
    get: function() {
        return $80c71705f119f7ad$var$_snackbarClasses.default;
    }
});

var $80c71705f119f7ad$var$_Snackbar = $80c71705f119f7ad$require$_interopRequireDefault((parcelRequire("kybK6")));

var $80c71705f119f7ad$var$_snackbarClasses = $80c71705f119f7ad$require$_interopRequireWildcard((parcelRequire("kVqBB")));
Object.keys($80c71705f119f7ad$var$_snackbarClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80c71705f119f7ad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80c71705f119f7ad$var$_snackbarClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80c71705f119f7ad$var$_snackbarClasses[key];
        }
    });
});

});
parcelRegister("kybK6", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ef601776ba11bb1e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ef601776ba11bb1e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef601776ba11bb1e$var$React = $ef601776ba11bb1e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ef601776ba11bb1e$var$_propTypes = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ef601776ba11bb1e$var$_composeClasses = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ef601776ba11bb1e$var$_useSnackbar = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("3S0qO")));

var $ef601776ba11bb1e$var$_ClickAwayListener = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("7Ke9B")));

var $aAbgT = parcelRequire("aAbgT");

var $ef601776ba11bb1e$var$_memoTheme = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ef601776ba11bb1e$var$_capitalize = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ef601776ba11bb1e$var$_Grow = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("6dJ4n")));

var $ef601776ba11bb1e$var$_SnackbarContent = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("8BKxX")));

var $kVqBB = parcelRequire("kVqBB");

var $ef601776ba11bb1e$var$_useSlot = $ef601776ba11bb1e$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $ef601776ba11bb1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $ef601776ba11bb1e$var$_capitalize.default)(anchorOrigin.vertical)}${(0, $ef601776ba11bb1e$var$_capitalize.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $ef601776ba11bb1e$var$_composeClasses.default)(slots, $kVqBB.getSnackbarUtilityClass, classes);
};
const $ef601776ba11bb1e$var$SnackbarRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $ef601776ba11bb1e$var$_capitalize.default)(ownerState.anchorOrigin.vertical)}${(0, $ef601776ba11bb1e$var$_capitalize.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $ef601776ba11bb1e$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $ef601776ba11bb1e$var$Snackbar = /*#__PURE__*/ $ef601776ba11bb1e$var$React.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $aAbgT.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerPropsProp, ContentProps: ContentPropsProp, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited, ...TransitionPropsProp } = {}, ...other } = props;
    const ownerState = {
        ...props,
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    };
    const classes = $ef601776ba11bb1e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $ef601776ba11bb1e$var$_useSnackbar.default)(ownerState);
    const [exited, setExited] = $ef601776ba11bb1e$var$React.useState(true);
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponentProp,
            ...slots
        },
        slotProps: {
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp,
            ...slotProps
        }
    };
    const [Root, rootProps] = (0, $ef601776ba11bb1e$var$_useSlot.default)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $ef601776ba11bb1e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState
    });
    const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = (0, $ef601776ba11bb1e$var$_useSlot.default)('clickAwayListener', {
        elementType: $ef601776ba11bb1e$var$_ClickAwayListener.default,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    const event = params[0];
                    handlers.onClickAway?.(...params);
                    if (event?.defaultMuiPrevented) return;
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $ef601776ba11bb1e$var$_useSlot.default)('content', {
        elementType: $ef601776ba11bb1e$var$_SnackbarContent.default,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $ef601776ba11bb1e$var$_useSlot.default)('transition', {
        elementType: $ef601776ba11bb1e$var$_Grow.default,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    handlers.onEnter?.(...params);
                    handleEnter(...params);
                },
                onExited: (...params)=>{
                    handlers.onExited?.(...params);
                    handleExited(...params);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(ClickAwaySlot, {
        ...clickAwayListenerProps,
        ...slots.clickAwayListener && {
            ownerState: clickAwayOwnerStateProp
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
            ...rootProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                ...transitionProps,
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                    ...contentSlotProps
                })
            })
        })
    });
});
var $ef601776ba11bb1e$var$_default = module.exports.default = $ef601776ba11bb1e$var$Snackbar;

});
parcelRegister("3S0qO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2d16bff1157c299f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2d16bff1157c299f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d16bff1157c299f$var$React = $2d16bff1157c299f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2d16bff1157c299f$var$_useEventCallback = $2d16bff1157c299f$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $2d16bff1157c299f$var$_useTimeout = $2d16bff1157c299f$require$_interopRequireDefault((parcelRequire("drY8V")));

var $2d16bff1157c299f$var$_extractEventHandlers = $2d16bff1157c299f$require$_interopRequireDefault((parcelRequire("bhYgh")));
function $2d16bff1157c299f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $2d16bff1157c299f$var$_useTimeout.default)();
    $2d16bff1157c299f$var$React.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose?.(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $2d16bff1157c299f$var$_useEventCallback.default)((event, reason)=>{
        onClose?.(event, reason);
    });
    const setAutoHideTimer = (0, $2d16bff1157c299f$var$_useEventCallback.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $2d16bff1157c299f$var$React.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose?.(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $2d16bff1157c299f$var$React.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback?.(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback?.(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback?.(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback?.(event);
            handleResume();
        };
    $2d16bff1157c299f$var$React.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = {
            ...(0, $2d16bff1157c299f$var$_extractEventHandlers.default)(parameters),
            ...(0, $2d16bff1157c299f$var$_extractEventHandlers.default)(externalProps)
        };
        return {
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation',
            ...externalProps,
            ...externalEventHandlers,
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        };
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $2d16bff1157c299f$var$_default = module.exports.default = $2d16bff1157c299f$var$useSnackbar;

});

parcelRegister("8BKxX", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6445e2a5635b1c13$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6445e2a5635b1c13$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6445e2a5635b1c13$var$_exportNames = {
    snackbarContentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6445e2a5635b1c13$var$_SnackbarContent.default;
    }
});
Object.defineProperty(module.exports, "snackbarContentClasses", {
    enumerable: true,
    get: function() {
        return $6445e2a5635b1c13$var$_snackbarContentClasses.default;
    }
});

var $6445e2a5635b1c13$var$_SnackbarContent = $6445e2a5635b1c13$require$_interopRequireDefault((parcelRequire("iSsbN")));

var $6445e2a5635b1c13$var$_snackbarContentClasses = $6445e2a5635b1c13$require$_interopRequireWildcard((parcelRequire("6CRBu")));
Object.keys($6445e2a5635b1c13$var$_snackbarContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6445e2a5635b1c13$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6445e2a5635b1c13$var$_snackbarContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6445e2a5635b1c13$var$_snackbarContentClasses[key];
        }
    });
});

});
parcelRegister("iSsbN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $dbe322effc7340b4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $dbe322effc7340b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbe322effc7340b4$var$React = $dbe322effc7340b4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $dbe322effc7340b4$var$_propTypes = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $dbe322effc7340b4$var$_clsx = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $dbe322effc7340b4$var$_composeClasses = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $dbe322effc7340b4$var$_memoTheme = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $dbe322effc7340b4$var$_Paper = $dbe322effc7340b4$require$_interopRequireDefault((parcelRequire("juRJQ")));

var $6CRBu = parcelRequire("6CRBu");

var $ayMG0 = parcelRequire("ayMG0");
const $dbe322effc7340b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $dbe322effc7340b4$var$_composeClasses.default)(slots, $6CRBu.getSnackbarContentUtilityClass, classes);
};
const $dbe322effc7340b4$var$SnackbarContentRoot = (0, $aAbgT.styled)($dbe322effc7340b4$var$_Paper.default, {
    name: 'MuiSnackbarContent',
    slot: 'Root'
})((0, $dbe322effc7340b4$var$_memoTheme.default)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    return {
        ...theme.typography.body2,
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText((0, $h61zw.emphasize)(theme.palette.background.default, emphasis)),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : (0, $h61zw.emphasize)(theme.palette.background.default, emphasis),
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    };
}));
const $dbe322effc7340b4$var$SnackbarContentMessage = (0, $aAbgT.styled)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message'
})({
    padding: '8px 0'
});
const $dbe322effc7340b4$var$SnackbarContentAction = (0, $aAbgT.styled)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $dbe322effc7340b4$var$SnackbarContent = /*#__PURE__*/ $dbe322effc7340b4$var$React.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert', ...other } = props;
    const ownerState = props;
    const classes = $dbe322effc7340b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dbe322effc7340b4$var$SnackbarContentRoot, {
        role: role,
        elevation: 6,
        className: (0, $dbe322effc7340b4$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($dbe322effc7340b4$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    });
});
var $dbe322effc7340b4$var$_default = module.exports.default = $dbe322effc7340b4$var$SnackbarContent;

});
parcelRegister("6CRBu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4d2fdf4430378182$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSnackbarContentUtilityClass = $4d2fdf4430378182$var$getSnackbarContentUtilityClass;

var $4d2fdf4430378182$var$_generateUtilityClasses = $4d2fdf4430378182$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4d2fdf4430378182$var$_generateUtilityClass = $4d2fdf4430378182$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4d2fdf4430378182$var$getSnackbarContentUtilityClass(slot) {
    return (0, $4d2fdf4430378182$var$_generateUtilityClass.default)('MuiSnackbarContent', slot);
}
const $4d2fdf4430378182$var$snackbarContentClasses = (0, $4d2fdf4430378182$var$_generateUtilityClasses.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $4d2fdf4430378182$var$_default = module.exports.default = $4d2fdf4430378182$var$snackbarContentClasses;

});



parcelRegister("kVqBB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f3bdc4d25b715a88$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSnackbarUtilityClass = $f3bdc4d25b715a88$var$getSnackbarUtilityClass;

var $f3bdc4d25b715a88$var$_generateUtilityClasses = $f3bdc4d25b715a88$require$_interopRequireDefault((parcelRequire("5nY49")));

var $f3bdc4d25b715a88$var$_generateUtilityClass = $f3bdc4d25b715a88$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $f3bdc4d25b715a88$var$getSnackbarUtilityClass(slot) {
    return (0, $f3bdc4d25b715a88$var$_generateUtilityClass.default)('MuiSnackbar', slot);
}
const $f3bdc4d25b715a88$var$snackbarClasses = (0, $f3bdc4d25b715a88$var$_generateUtilityClasses.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $f3bdc4d25b715a88$var$_default = module.exports.default = $f3bdc4d25b715a88$var$snackbarClasses;

});



parcelRegister("kqAaP", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $edf24babb8f47c92$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $edf24babb8f47c92$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $edf24babb8f47c92$var$_exportNames = {
    speedDialClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edf24babb8f47c92$var$_SpeedDial.default;
    }
});
Object.defineProperty(module.exports, "speedDialClasses", {
    enumerable: true,
    get: function() {
        return $edf24babb8f47c92$var$_speedDialClasses.default;
    }
});

var $edf24babb8f47c92$var$_SpeedDial = $edf24babb8f47c92$require$_interopRequireDefault((parcelRequire("kzdtv")));

var $edf24babb8f47c92$var$_speedDialClasses = $edf24babb8f47c92$require$_interopRequireWildcard((parcelRequire("iwNBi")));
Object.keys($edf24babb8f47c92$var$_speedDialClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($edf24babb8f47c92$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $edf24babb8f47c92$var$_speedDialClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $edf24babb8f47c92$var$_speedDialClasses[key];
        }
    });
});

});
parcelRegister("kzdtv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ef91875cc443f344$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ef91875cc443f344$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef91875cc443f344$var$React = $ef91875cc443f344$require$_interopRequireWildcard((parcelRequire("acw62")));


var $ef91875cc443f344$var$_propTypes = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ef91875cc443f344$var$_clsx = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ef91875cc443f344$var$_composeClasses = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ef91875cc443f344$var$_useTimeout = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("drY8V")));

var $ef91875cc443f344$var$_clamp = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3zA0b")));

var $aAbgT = parcelRequire("aAbgT");

var $ef91875cc443f344$var$_memoTheme = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ef91875cc443f344$var$_Zoom = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3uqi7")));

var $ef91875cc443f344$var$_Fab = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("2r6m0")));

var $ef91875cc443f344$var$_capitalize = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ef91875cc443f344$var$_isMuiElement = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $ef91875cc443f344$var$_useForkRef = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ef91875cc443f344$var$_useControlled = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("3yddg")));

var $ef91875cc443f344$var$_speedDialClasses = $ef91875cc443f344$require$_interopRequireWildcard((parcelRequire("iwNBi")));

var $ef91875cc443f344$var$_useSlot = $ef91875cc443f344$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $ef91875cc443f344$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, direction: direction } = ownerState;
    const slots = {
        root: [
            'root',
            `direction${(0, $ef91875cc443f344$var$_capitalize.default)(direction)}`
        ],
        fab: [
            'fab'
        ],
        actions: [
            'actions',
            !open && 'actionsClosed'
        ]
    };
    return (0, $ef91875cc443f344$var$_composeClasses.default)(slots, $ef91875cc443f344$var$_speedDialClasses.getSpeedDialUtilityClass, classes);
};
function $ef91875cc443f344$var$getOrientation(direction) {
    if (direction === 'up' || direction === 'down') return 'vertical';
    if (direction === 'right' || direction === 'left') return 'horizontal';
    return undefined;
}
const $ef91875cc443f344$var$dialRadius = 32;
const $ef91875cc443f344$var$spacingActions = 16;
const $ef91875cc443f344$var$SpeedDialRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiSpeedDial',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`direction${(0, $ef91875cc443f344$var$_capitalize.default)(ownerState.direction)}`]
        ];
    }
})((0, $ef91875cc443f344$var$_memoTheme.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.speedDial,
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    direction: 'up'
                },
                style: {
                    flexDirection: 'column-reverse',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'column-reverse',
                        marginBottom: -$ef91875cc443f344$var$dialRadius,
                        paddingBottom: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'down'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'column',
                        marginTop: -$ef91875cc443f344$var$dialRadius,
                        paddingTop: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'left'
                },
                style: {
                    flexDirection: 'row-reverse',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'row-reverse',
                        marginRight: -$ef91875cc443f344$var$dialRadius,
                        paddingRight: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'right'
                },
                style: {
                    flexDirection: 'row',
                    [`& .${$ef91875cc443f344$var$_speedDialClasses.default.actions}`]: {
                        flexDirection: 'row',
                        marginLeft: -$ef91875cc443f344$var$dialRadius,
                        paddingLeft: $ef91875cc443f344$var$spacingActions + $ef91875cc443f344$var$dialRadius
                    }
                }
            }
        ]
    })));
const $ef91875cc443f344$var$SpeedDialFab = (0, $aAbgT.styled)($ef91875cc443f344$var$_Fab.default, {
    name: 'MuiSpeedDial',
    slot: 'Fab'
})({
    pointerEvents: 'auto'
});
const $ef91875cc443f344$var$SpeedDialActions = (0, $aAbgT.styled)('div', {
    name: 'MuiSpeedDial',
    slot: 'Actions',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actions,
            !ownerState.open && styles.actionsClosed
        ];
    }
})({
    display: 'flex',
    pointerEvents: 'auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.open,
            style: {
                transition: 'top 0s linear 0.2s',
                pointerEvents: 'none'
            }
        }
    ]
});
const $ef91875cc443f344$var$SpeedDial = /*#__PURE__*/ $ef91875cc443f344$var$React.forwardRef(function SpeedDial(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDial'
    });
    const theme = (0, $aAbgT.useTheme)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { ariaLabel: ariaLabel, FabProps: { ref: origDialButtonRef, ...FabProps } = {}, children: childrenProp, className: className, direction: direction = 'up', hidden: hidden = false, icon: icon, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onOpen: onOpen, open: openProp, openIcon: openIcon, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, transitionDuration: transitionDuration = defaultTransitionDuration, ...other } = props;
    const [open, setOpenState] = (0, $ef91875cc443f344$var$_useControlled.default)({
        controlled: openProp,
        default: false,
        name: 'SpeedDial',
        state: 'open'
    });
    const ownerState = {
        ...props,
        open: open,
        direction: direction
    };
    const classes = $ef91875cc443f344$var$useUtilityClasses(ownerState);
    const eventTimer = (0, $ef91875cc443f344$var$_useTimeout.default)();
    /**
   * an index in actions.current
   */ const focusedAction = $ef91875cc443f344$var$React.useRef(0);
    /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */ const nextItemArrowKey = $ef91875cc443f344$var$React.useRef();
    /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */ const actions = $ef91875cc443f344$var$React.useRef([]);
    actions.current = [
        actions.current[0]
    ];
    const handleOwnFabRef = $ef91875cc443f344$var$React.useCallback((fabFef)=>{
        actions.current[0] = fabFef;
    }, []);
    const handleFabRef = (0, $ef91875cc443f344$var$_useForkRef.default)(origDialButtonRef, handleOwnFabRef);
    /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   * @param fabSlotOrigButtonRef {React.RefObject?}
   */ const createHandleSpeedDialActionButtonRef = (dialActionIndex, origButtonRef, fabSlotOrigButtonRef)=>{
        return (buttonRef)=>{
            actions.current[dialActionIndex + 1] = buttonRef;
            if (origButtonRef) origButtonRef(buttonRef);
            if (fabSlotOrigButtonRef) fabSlotOrigButtonRef(buttonRef);
        };
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        const key = event.key.replace('Arrow', '').toLowerCase();
        const { current: nextItemArrowKeyCurrent = key } = nextItemArrowKey;
        if (event.key === 'Escape') {
            setOpenState(false);
            actions.current[0].focus();
            if (onClose) onClose(event, 'escapeKeyDown');
            return;
        }
        if ($ef91875cc443f344$var$getOrientation(key) === $ef91875cc443f344$var$getOrientation(nextItemArrowKeyCurrent) && $ef91875cc443f344$var$getOrientation(key) !== undefined) {
            event.preventDefault();
            const actionStep = key === nextItemArrowKeyCurrent ? 1 : -1;
            // stay within array indices
            const nextAction = (0, $ef91875cc443f344$var$_clamp.default)(focusedAction.current + actionStep, 0, actions.current.length - 1);
            actions.current[nextAction].focus();
            focusedAction.current = nextAction;
            nextItemArrowKey.current = nextItemArrowKeyCurrent;
        }
    };
    $ef91875cc443f344$var$React.useEffect(()=>{
        // actions were closed while navigation state was not reset
        if (!open) {
            focusedAction.current = 0;
            nextItemArrowKey.current = undefined;
        }
    }, [
        open
    ]);
    const handleClose = (event)=>{
        if (event.type === 'mouseleave' && onMouseLeave) onMouseLeave(event);
        if (event.type === 'blur' && onBlur) onBlur(event);
        eventTimer.clear();
        if (event.type === 'blur') eventTimer.start(0, ()=>{
            setOpenState(false);
            if (onClose) onClose(event, 'blur');
        });
        else {
            setOpenState(false);
            if (onClose) onClose(event, 'mouseLeave');
        }
    };
    const handleClick = (event)=>{
        if (FabProps.onClick) FabProps.onClick(event);
        eventTimer.clear();
        if (open) {
            setOpenState(false);
            if (onClose) onClose(event, 'toggle');
        } else {
            setOpenState(true);
            if (onOpen) onOpen(event, 'toggle');
        }
    };
    const handleOpen = (event)=>{
        if (event.type === 'mouseenter' && onMouseEnter) onMouseEnter(event);
        if (event.type === 'focus' && onFocus) onFocus(event);
        // When moving the focus between two items,
        // a chain if blur and focus event is triggered.
        // We only handle the last event.
        eventTimer.clear();
        if (!open) // Wait for a future focus or click event
        eventTimer.start(0, ()=>{
            setOpenState(true);
            if (onOpen) {
                const eventMap = {
                    focus: 'focus',
                    mouseenter: 'mouseEnter'
                };
                onOpen(event, eventMap[event.type]);
            }
        });
    };
    // Filter the label for valid id characters.
    const id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
    const allItems = $ef91875cc443f344$var$React.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $ef91875cc443f344$var$React.isValidElement(child);
    });
    const children = allItems.map((child, index)=>{
        const { FabProps: { ref: origButtonRef } = {}, slotProps: childSlotProps = {}, tooltipPlacement: tooltipPlacementProp } = child.props;
        const { fab: { ref: fabSlotOrigButtonRef, ...fabSlotProps } = {}, ...restOfSlotProps } = childSlotProps;
        const tooltipPlacement = tooltipPlacementProp || ($ef91875cc443f344$var$getOrientation(direction) === 'vertical' ? 'left' : 'top');
        return /*#__PURE__*/ $ef91875cc443f344$var$React.cloneElement(child, {
            slotProps: {
                fab: {
                    ...fabSlotProps,
                    ref: createHandleSpeedDialActionButtonRef(index, origButtonRef, fabSlotOrigButtonRef)
                },
                ...restOfSlotProps
            },
            delay: 30 * (open ? index : allItems.length - index),
            open: open,
            tooltipPlacement: tooltipPlacement,
            id: `${id}-action-${index}`
        });
    });
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $ef91875cc443f344$var$_useSlot.default)('root', {
        elementType: $ef91875cc443f344$var$SpeedDialRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref,
        className: (0, $ef91875cc443f344$var$_clsx.default)(classes.root, className),
        additionalProps: {
            role: 'presentation'
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleClose(event);
                },
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleOpen(event);
                },
                onMouseEnter: (event)=>{
                    handlers.onMouseEnter?.(event);
                    handleOpen(event);
                },
                onMouseLeave: (event)=>{
                    handlers.onMouseLeave?.(event);
                    handleClose(event);
                }
            })
    });
    const [TransitionSlot, transitionProps] = (0, $ef91875cc443f344$var$_useSlot.default)('transition', {
        elementType: $ef91875cc443f344$var$_Zoom.default,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                in: !hidden,
                timeout: transitionDuration,
                unmountOnExit: true,
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ef91875cc443f344$var$SpeedDialFab, {
                    color: "primary",
                    "aria-label": ariaLabel,
                    "aria-haspopup": "true",
                    "aria-expanded": open,
                    "aria-controls": `${id}-actions`,
                    ...FabProps,
                    onClick: handleClick,
                    className: (0, $ef91875cc443f344$var$_clsx.default)(classes.fab, FabProps.className),
                    ref: handleFabRef,
                    ownerState: ownerState,
                    children: /*#__PURE__*/ $ef91875cc443f344$var$React.isValidElement(icon) && (0, $ef91875cc443f344$var$_isMuiElement.default)(icon, [
                        'SpeedDialIcon'
                    ]) ? /*#__PURE__*/ $ef91875cc443f344$var$React.cloneElement(icon, {
                        open: open
                    }) : icon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ef91875cc443f344$var$SpeedDialActions, {
                id: `${id}-actions`,
                role: "menu",
                "aria-orientation": $ef91875cc443f344$var$getOrientation(direction),
                className: (0, $ef91875cc443f344$var$_clsx.default)(classes.actions, !open && classes.actionsClosed),
                ownerState: ownerState,
                children: children
            })
        ]
    });
});
var $ef91875cc443f344$var$_default = module.exports.default = $ef91875cc443f344$var$SpeedDial;

});
parcelRegister("3uqi7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28a89151afea75ff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $28a89151afea75ff$var$_Zoom.default;
    }
});

var $28a89151afea75ff$var$_Zoom = $28a89151afea75ff$require$_interopRequireDefault((parcelRequire("62Z1m")));

});
parcelRegister("62Z1m", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4672437388b729f6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4672437388b729f6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4672437388b729f6$var$React = $4672437388b729f6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4672437388b729f6$var$_propTypes = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1mPeS = parcelRequire("1mPeS");

var $4672437388b729f6$var$_elementAcceptingRef = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("igTUE")));

var $4672437388b729f6$var$_getReactElementRef = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("2B4J6")));

var $aAbgT = parcelRequire("aAbgT");

var $hweuE = parcelRequire("hweuE");

var $4672437388b729f6$var$_useForkRef = $4672437388b729f6$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ayMG0 = parcelRequire("ayMG0");
const $4672437388b729f6$var$styles = {
    entering: {
        transform: 'none'
    },
    entered: {
        transform: 'none'
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-floating-action-button/#animation) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4672437388b729f6$var$Zoom = /*#__PURE__*/ $4672437388b729f6$var$React.forwardRef(function Zoom(props, ref) {
    const theme = (0, $aAbgT.useTheme)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $1mPeS.default, ...other } = props;
    const nodeRef = $4672437388b729f6$var$React.useRef(null);
    const handleRef = (0, $4672437388b729f6$var$_useForkRef.default)(nodeRef, (0, $4672437388b729f6$var$_getReactElementRef.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $4672437388b729f6$var$React.cloneElement(children, {
                style: {
                    transform: 'scale(0)',
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$4672437388b729f6$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $4672437388b729f6$var$_default = module.exports.default = $4672437388b729f6$var$Zoom;

});


parcelRegister("iwNBi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d7d1b0c877edfc53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSpeedDialUtilityClass = $d7d1b0c877edfc53$var$getSpeedDialUtilityClass;

var $d7d1b0c877edfc53$var$_generateUtilityClasses = $d7d1b0c877edfc53$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d7d1b0c877edfc53$var$_generateUtilityClass = $d7d1b0c877edfc53$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d7d1b0c877edfc53$var$getSpeedDialUtilityClass(slot) {
    return (0, $d7d1b0c877edfc53$var$_generateUtilityClass.default)('MuiSpeedDial', slot);
}
const $d7d1b0c877edfc53$var$speedDialClasses = (0, $d7d1b0c877edfc53$var$_generateUtilityClasses.default)('MuiSpeedDial', [
    'root',
    'fab',
    'directionUp',
    'directionDown',
    'directionLeft',
    'directionRight',
    'actions',
    'actionsClosed'
]);
var $d7d1b0c877edfc53$var$_default = module.exports.default = $d7d1b0c877edfc53$var$speedDialClasses;

});



parcelRegister("2Pq3d", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $20f48d600d3ec25e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $20f48d600d3ec25e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $20f48d600d3ec25e$var$_exportNames = {
    speedDialActionClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $20f48d600d3ec25e$var$_SpeedDialAction.default;
    }
});
Object.defineProperty(module.exports, "speedDialActionClasses", {
    enumerable: true,
    get: function() {
        return $20f48d600d3ec25e$var$_speedDialActionClasses.default;
    }
});

var $20f48d600d3ec25e$var$_SpeedDialAction = $20f48d600d3ec25e$require$_interopRequireDefault((parcelRequire("hK7mH")));

var $20f48d600d3ec25e$var$_speedDialActionClasses = $20f48d600d3ec25e$require$_interopRequireWildcard((parcelRequire("iTcEP")));
Object.keys($20f48d600d3ec25e$var$_speedDialActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($20f48d600d3ec25e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $20f48d600d3ec25e$var$_speedDialActionClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $20f48d600d3ec25e$var$_speedDialActionClasses[key];
        }
    });
});

});
parcelRegister("hK7mH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ceac721f7000e3b1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ceac721f7000e3b1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ceac721f7000e3b1$var$React = $ceac721f7000e3b1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ceac721f7000e3b1$var$_propTypes = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ceac721f7000e3b1$var$_clsx = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ceac721f7000e3b1$var$_composeClasses = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $h61zw = parcelRequire("h61zw");

var $aAbgT = parcelRequire("aAbgT");

var $ceac721f7000e3b1$var$_memoTheme = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $ceac721f7000e3b1$var$_Fab = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("2r6m0")));

var $ceac721f7000e3b1$var$_Tooltip = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("tEWAm")));

var $ceac721f7000e3b1$var$_capitalize = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ceac721f7000e3b1$var$_speedDialActionClasses = $ceac721f7000e3b1$require$_interopRequireWildcard((parcelRequire("iTcEP")));

var $ceac721f7000e3b1$var$_useSlot = $ceac721f7000e3b1$require$_interopRequireDefault((parcelRequire("6lpak")));

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
const $ceac721f7000e3b1$var$useUtilityClasses = (ownerState)=>{
    const { open: open, tooltipPlacement: tooltipPlacement, classes: classes } = ownerState;
    const slots = {
        fab: [
            'fab',
            !open && 'fabClosed'
        ],
        staticTooltip: [
            'staticTooltip',
            `tooltipPlacement${(0, $ceac721f7000e3b1$var$_capitalize.default)(tooltipPlacement)}`,
            !open && 'staticTooltipClosed'
        ],
        staticTooltipLabel: [
            'staticTooltipLabel'
        ]
    };
    return (0, $ceac721f7000e3b1$var$_composeClasses.default)(slots, $ceac721f7000e3b1$var$_speedDialActionClasses.getSpeedDialActionUtilityClass, classes);
};
const $ceac721f7000e3b1$var$SpeedDialActionFab = (0, $aAbgT.styled)($ceac721f7000e3b1$var$_Fab.default, {
    name: 'MuiSpeedDialAction',
    slot: 'Fab',
    skipVariantsResolver: false,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.fab,
            !ownerState.open && styles.fabClosed
        ];
    }
})((0, $ceac721f7000e3b1$var$_memoTheme.default)(({ theme: theme })=>({
        margin: 8,
        color: (theme.vars || theme).palette.text.secondary,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.SpeedDialAction.fabHoverBg : (0, $h61zw.emphasize)(theme.palette.background.paper, 0.15)
        },
        transition: `${theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter
        })}, opacity 0.8s`,
        opacity: 1,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open,
                style: {
                    opacity: 0,
                    transform: 'scale(0)'
                }
            }
        ]
    })));
const $ceac721f7000e3b1$var$SpeedDialActionStaticTooltip = (0, $aAbgT.styled)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.staticTooltip,
            !ownerState.open && styles.staticTooltipClosed,
            styles[`tooltipPlacement${(0, $ceac721f7000e3b1$var$_capitalize.default)(ownerState.tooltipPlacement)}`]
        ];
    }
})((0, $ceac721f7000e3b1$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            }),
            opacity: 1
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open,
                style: {
                    [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
                        opacity: 0,
                        transform: 'scale(0.5)'
                    }
                }
            },
            {
                props: {
                    tooltipPlacement: 'left'
                },
                style: {
                    [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
                        transformOrigin: '100% 50%',
                        right: '100%',
                        marginRight: 8
                    }
                }
            },
            {
                props: {
                    tooltipPlacement: 'right'
                },
                style: {
                    [`& .${$ceac721f7000e3b1$var$_speedDialActionClasses.default.staticTooltipLabel}`]: {
                        transformOrigin: '0% 50%',
                        left: '100%',
                        marginLeft: 8
                    }
                }
            }
        ]
    })));
const $ceac721f7000e3b1$var$SpeedDialActionStaticTooltipLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltipLabel'
})((0, $ceac721f7000e3b1$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'absolute',
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        boxShadow: (theme.vars || theme).shadows[1],
        color: (theme.vars || theme).palette.text.secondary,
        padding: '4px 16px',
        wordBreak: 'keep-all'
    })));
const $ceac721f7000e3b1$var$SpeedDialAction = /*#__PURE__*/ $ceac721f7000e3b1$var$React.forwardRef(function SpeedDialAction(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialAction'
    });
    const { className: className, delay: delay = 0, FabProps: FabProps = {}, icon: icon, id: id, open: open, TooltipClasses: TooltipClasses, tooltipOpen: tooltipOpenProp = false, tooltipPlacement: tooltipPlacement = 'left', tooltipTitle: tooltipTitle, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        tooltipPlacement: tooltipPlacement
    };
    const classes = $ceac721f7000e3b1$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            fab: FabProps,
            ...slotProps,
            tooltip: (0, $hGPki.mergeSlotProps)(typeof slotProps.tooltip === 'function' ? slotProps.tooltip(ownerState) : slotProps.tooltip, {
                title: tooltipTitle,
                open: tooltipOpenProp,
                placement: tooltipPlacement,
                classes: TooltipClasses
            })
        }
    };
    const [tooltipOpen, setTooltipOpen] = $ceac721f7000e3b1$var$React.useState(externalForwardedProps.slotProps.tooltip?.open);
    const handleTooltipClose = ()=>{
        setTooltipOpen(false);
    };
    const handleTooltipOpen = ()=>{
        setTooltipOpen(true);
    };
    const transitionStyle = {
        transitionDelay: `${delay}ms`
    };
    const [FabSlot, fabSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('fab', {
        elementType: $ceac721f7000e3b1$var$SpeedDialActionFab,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        shouldForwardComponentProp: true,
        className: (0, $ceac721f7000e3b1$var$_clsx.default)(classes.fab, className),
        additionalProps: {
            style: transitionStyle,
            tabIndex: -1,
            role: 'menuitem',
            size: 'small'
        }
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('tooltip', {
        elementType: $ceac721f7000e3b1$var$_Tooltip.default,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ref: ref,
        additionalProps: {
            id: id
        },
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onClose: (event)=>{
                    handlers.onClose?.(event);
                    handleTooltipClose();
                },
                onOpen: (event)=>{
                    handlers.onOpen?.(event);
                    handleTooltipOpen();
                }
            })
    });
    const [StaticTooltipSlot, staticTooltipSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('staticTooltip', {
        elementType: $ceac721f7000e3b1$var$SpeedDialActionStaticTooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: ref,
        className: classes.staticTooltip,
        additionalProps: {
            id: id
        }
    });
    const [StaticTooltipLabelSlot, staticTooltipLabelSlotProps] = (0, $ceac721f7000e3b1$var$_useSlot.default)('staticTooltipLabel', {
        elementType: $ceac721f7000e3b1$var$SpeedDialActionStaticTooltipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.staticTooltipLabel,
        additionalProps: {
            style: transitionStyle,
            id: `${id}-label`
        }
    });
    const fab = /*#__PURE__*/ (0, $ayMG0.jsx)(FabSlot, {
        ...fabSlotProps,
        children: icon
    });
    if (tooltipSlotProps.open) return /*#__PURE__*/ (0, $ayMG0.jsxs)(StaticTooltipSlot, {
        ...staticTooltipSlotProps,
        ...other,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(StaticTooltipLabelSlot, {
                ...staticTooltipLabelSlotProps,
                children: tooltipSlotProps.title
            }),
            /*#__PURE__*/ $ceac721f7000e3b1$var$React.cloneElement(fab, {
                'aria-labelledby': `${id}-label`
            })
        ]
    });
    if (!open && tooltipOpen) setTooltipOpen(false);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TooltipSlot, {
        ...tooltipSlotProps,
        title: tooltipSlotProps.title,
        open: open && tooltipOpen,
        placement: tooltipSlotProps.placement,
        classes: tooltipSlotProps.classes,
        ...other,
        children: fab
    });
});
var $ceac721f7000e3b1$var$_default = module.exports.default = $ceac721f7000e3b1$var$SpeedDialAction;

});
parcelRegister("iTcEP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dc072e92edbac389$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSpeedDialActionUtilityClass = $dc072e92edbac389$var$getSpeedDialActionUtilityClass;

var $dc072e92edbac389$var$_generateUtilityClasses = $dc072e92edbac389$require$_interopRequireDefault((parcelRequire("5nY49")));

var $dc072e92edbac389$var$_generateUtilityClass = $dc072e92edbac389$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $dc072e92edbac389$var$getSpeedDialActionUtilityClass(slot) {
    return (0, $dc072e92edbac389$var$_generateUtilityClass.default)('MuiSpeedDialAction', slot);
}
const $dc072e92edbac389$var$speedDialActionClasses = (0, $dc072e92edbac389$var$_generateUtilityClasses.default)('MuiSpeedDialAction', [
    'fab',
    'fabClosed',
    'staticTooltip',
    'staticTooltipClosed',
    'staticTooltipLabel',
    'tooltipPlacementLeft',
    'tooltipPlacementRight'
]);
var $dc072e92edbac389$var$_default = module.exports.default = $dc072e92edbac389$var$speedDialActionClasses;

});



parcelRegister("6LxK9", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4ed14e9d13fe3bbe$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4ed14e9d13fe3bbe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4ed14e9d13fe3bbe$var$_exportNames = {
    speedDialIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ed14e9d13fe3bbe$var$_SpeedDialIcon.default;
    }
});
Object.defineProperty(module.exports, "speedDialIconClasses", {
    enumerable: true,
    get: function() {
        return $4ed14e9d13fe3bbe$var$_speedDialIconClasses.default;
    }
});

var $4ed14e9d13fe3bbe$var$_SpeedDialIcon = $4ed14e9d13fe3bbe$require$_interopRequireDefault((parcelRequire("l7RMX")));

var $4ed14e9d13fe3bbe$var$_speedDialIconClasses = $4ed14e9d13fe3bbe$require$_interopRequireWildcard((parcelRequire("ePWG5")));
Object.keys($4ed14e9d13fe3bbe$var$_speedDialIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4ed14e9d13fe3bbe$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4ed14e9d13fe3bbe$var$_speedDialIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4ed14e9d13fe3bbe$var$_speedDialIconClasses[key];
        }
    });
});

});
parcelRegister("l7RMX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f613f9bdcf68845e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f613f9bdcf68845e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f613f9bdcf68845e$var$React = $f613f9bdcf68845e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f613f9bdcf68845e$var$_propTypes = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f613f9bdcf68845e$var$_clsx = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $f613f9bdcf68845e$var$_composeClasses = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $f613f9bdcf68845e$var$_memoTheme = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $f613f9bdcf68845e$var$_Add = $f613f9bdcf68845e$require$_interopRequireDefault((parcelRequire("3nzbA")));

var $f613f9bdcf68845e$var$_speedDialIconClasses = $f613f9bdcf68845e$require$_interopRequireWildcard((parcelRequire("ePWG5")));

var $ayMG0 = parcelRequire("ayMG0");
const $f613f9bdcf68845e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, openIcon: openIcon } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        icon: [
            'icon',
            open && 'iconOpen',
            openIcon && open && 'iconWithOpenIconOpen'
        ],
        openIcon: [
            'openIcon',
            open && 'openIconOpen'
        ]
    };
    return (0, $f613f9bdcf68845e$var$_composeClasses.default)(slots, $f613f9bdcf68845e$var$_speedDialIconClasses.getSpeedDialIconUtilityClass, classes);
};
const $f613f9bdcf68845e$var$SpeedDialIconRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiSpeedDialIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: styles.icon
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: ownerState.open && styles.iconOpen
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: ownerState.open && ownerState.openIcon && styles.iconWithOpenIconOpen
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: styles.openIcon
            },
            {
                [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: ownerState.open && styles.openIconOpen
            },
            styles.root
        ];
    }
})((0, $f613f9bdcf68845e$var$_memoTheme.default)(({ theme: theme })=>({
        height: 24,
        [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: {
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            })
        },
        [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: {
            position: 'absolute',
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            transform: 'rotate(-45deg)'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: {
                        transform: 'rotate(45deg)'
                    },
                    [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.openIcon}`]: {
                        transform: 'rotate(0deg)',
                        opacity: 1
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.open && ownerState.openIcon,
                style: {
                    [`& .${$f613f9bdcf68845e$var$_speedDialIconClasses.default.icon}`]: {
                        opacity: 0
                    }
                }
            }
        ]
    })));
const $f613f9bdcf68845e$var$SpeedDialIcon = /*#__PURE__*/ $f613f9bdcf68845e$var$React.forwardRef(function SpeedDialIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialIcon'
    });
    const { className: className, icon: iconProp, open: open, openIcon: openIconProp, ...other } = props;
    const ownerState = props;
    const classes = $f613f9bdcf68845e$var$useUtilityClasses(ownerState);
    function formatIcon(icon, newClassName) {
        if (/*#__PURE__*/ $f613f9bdcf68845e$var$React.isValidElement(icon)) return /*#__PURE__*/ $f613f9bdcf68845e$var$React.cloneElement(icon, {
            className: newClassName
        });
        return icon;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f613f9bdcf68845e$var$SpeedDialIconRoot, {
        className: (0, $f613f9bdcf68845e$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: [
            openIconProp ? formatIcon(openIconProp, classes.openIcon) : null,
            iconProp ? formatIcon(iconProp, classes.icon) : /*#__PURE__*/ (0, $ayMG0.jsx)($f613f9bdcf68845e$var$_Add.default, {
                className: classes.icon
            })
        ]
    });
});
$f613f9bdcf68845e$var$SpeedDialIcon.muiName = 'SpeedDialIcon';
var $f613f9bdcf68845e$var$_default = module.exports.default = $f613f9bdcf68845e$var$SpeedDialIcon;

});
parcelRegister("3nzbA", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $275ed03e426ba761$var$_default = module.exports.default = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

});

parcelRegister("ePWG5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $acd358505730020e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSpeedDialIconUtilityClass = $acd358505730020e$var$getSpeedDialIconUtilityClass;

var $acd358505730020e$var$_generateUtilityClasses = $acd358505730020e$require$_interopRequireDefault((parcelRequire("5nY49")));

var $acd358505730020e$var$_generateUtilityClass = $acd358505730020e$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $acd358505730020e$var$getSpeedDialIconUtilityClass(slot) {
    return (0, $acd358505730020e$var$_generateUtilityClass.default)('MuiSpeedDialIcon', slot);
}
const $acd358505730020e$var$speedDialIconClasses = (0, $acd358505730020e$var$_generateUtilityClasses.default)('MuiSpeedDialIcon', [
    'root',
    'icon',
    'iconOpen',
    'iconWithOpenIconOpen',
    'openIcon',
    'openIconOpen'
]);
var $acd358505730020e$var$_default = module.exports.default = $acd358505730020e$var$speedDialIconClasses;

});



parcelRegister("jkhql", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e11d669415a30ea5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e11d669415a30ea5$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $e11d669415a30ea5$var$_stackClasses.default;
    }
});

var $e11d669415a30ea5$var$_Stack = $e11d669415a30ea5$require$_interopRequireDefault((parcelRequire("30UGG")));

var $e11d669415a30ea5$var$_stackClasses = $e11d669415a30ea5$require$_interopRequireDefault((parcelRequire("axvsV")));

});
parcelRegister("30UGG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $231d58234d437bc0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $231d58234d437bc0$var$_propTypes = $231d58234d437bc0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $231d58234d437bc0$var$_styled = $231d58234d437bc0$require$_interopRequireDefault((parcelRequire("d8seH")));

var $hL1nr = parcelRequire("hL1nr");
const $231d58234d437bc0$var$Stack = (0, $izOUK.createStack)({
    createStyledComponent: (0, $231d58234d437bc0$var$_styled.default)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $hL1nr.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$var$_default = module.exports.default = $231d58234d437bc0$var$Stack;

});

parcelRegister("axvsV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7ac564dc7b213020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $7ac564dc7b213020$var$getStackUtilityClass;

var $7ac564dc7b213020$var$_generateUtilityClasses = $7ac564dc7b213020$require$_interopRequireDefault((parcelRequire("5nY49")));

var $7ac564dc7b213020$var$_generateUtilityClass = $7ac564dc7b213020$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $7ac564dc7b213020$var$getStackUtilityClass(slot) {
    return (0, $7ac564dc7b213020$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $7ac564dc7b213020$var$stackClasses = (0, $7ac564dc7b213020$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $7ac564dc7b213020$var$_default = module.exports.default = $7ac564dc7b213020$var$stackClasses;

});


parcelRegister("fxSW4", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b5148d23ad5d90bb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b5148d23ad5d90bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b5148d23ad5d90bb$var$_exportNames = {
    stepClasses: true,
    StepContext: true
};
Object.defineProperty(module.exports, "StepContext", {
    enumerable: true,
    get: function() {
        return $b5148d23ad5d90bb$var$_StepContext.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b5148d23ad5d90bb$var$_Step.default;
    }
});
Object.defineProperty(module.exports, "stepClasses", {
    enumerable: true,
    get: function() {
        return $b5148d23ad5d90bb$var$_stepClasses.default;
    }
});

var $b5148d23ad5d90bb$var$_Step = $b5148d23ad5d90bb$require$_interopRequireDefault((parcelRequire("lttiO")));

var $b5148d23ad5d90bb$var$_stepClasses = $b5148d23ad5d90bb$require$_interopRequireWildcard((parcelRequire("bspH3")));
Object.keys($b5148d23ad5d90bb$var$_stepClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b5148d23ad5d90bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b5148d23ad5d90bb$var$_stepClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b5148d23ad5d90bb$var$_stepClasses[key];
        }
    });
});

var $b5148d23ad5d90bb$var$_StepContext = $b5148d23ad5d90bb$require$_interopRequireWildcard((parcelRequire("jrw2p")));
Object.keys($b5148d23ad5d90bb$var$_StepContext).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b5148d23ad5d90bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b5148d23ad5d90bb$var$_StepContext[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b5148d23ad5d90bb$var$_StepContext[key];
        }
    });
});

});
parcelRegister("lttiO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fa230948139f2492$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fa230948139f2492$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa230948139f2492$var$React = $fa230948139f2492$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fa230948139f2492$var$_propTypes = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fa230948139f2492$var$_clsx = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("9QePP")));

var $fa230948139f2492$var$_integerPropType = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $fa230948139f2492$var$_composeClasses = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $fa230948139f2492$var$_StepperContext = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $fa230948139f2492$var$_StepContext = $fa230948139f2492$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $bspH3 = parcelRequire("bspH3");

var $ayMG0 = parcelRequire("ayMG0");
const $fa230948139f2492$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $fa230948139f2492$var$_composeClasses.default)(slots, $bspH3.getStepUtilityClass, classes);
};
const $fa230948139f2492$var$StepRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})({
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                flex: 1,
                position: 'relative'
            }
        }
    ]
});
const $fa230948139f2492$var$Step = /*#__PURE__*/ $fa230948139f2492$var$React.forwardRef(function Step(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last, ...other } = props;
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $fa230948139f2492$var$React.useContext($fa230948139f2492$var$_StepperContext.default);
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $fa230948139f2492$var$React.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = {
        ...props,
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    };
    const classes = $fa230948139f2492$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $ayMG0.jsxs)($fa230948139f2492$var$StepRoot, {
        as: component,
        className: (0, $fa230948139f2492$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fa230948139f2492$var$_StepContext.default.Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)($fa230948139f2492$var$React.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $fa230948139f2492$var$_default = module.exports.default = $fa230948139f2492$var$Step;

});
parcelRegister("8c8ll", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5f75ea7f43c8474b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useStepperContext = $5f75ea7f43c8474b$var$useStepperContext;

var $5f75ea7f43c8474b$var$React = $5f75ea7f43c8474b$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Provides information about the current step in Stepper.
 */ const $5f75ea7f43c8474b$var$StepperContext = /*#__PURE__*/ $5f75ea7f43c8474b$var$React.createContext({});
/**
 * Returns the current StepperContext or an empty object if no StepperContext
 * has been defined in the component tree.
 */ function $5f75ea7f43c8474b$var$useStepperContext() {
    return $5f75ea7f43c8474b$var$React.useContext($5f75ea7f43c8474b$var$StepperContext);
}
var $5f75ea7f43c8474b$var$_default = module.exports.default = $5f75ea7f43c8474b$var$StepperContext;

});

parcelRegister("jrw2p", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e279640208208f42$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useStepContext = $e279640208208f42$var$useStepContext;

var $e279640208208f42$var$React = $e279640208208f42$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Provides information about the current step in Stepper.
 */ const $e279640208208f42$var$StepContext = /*#__PURE__*/ $e279640208208f42$var$React.createContext({});
/**
 * Returns the current StepContext or an empty object if no StepContext
 * has been defined in the component tree.
 */ function $e279640208208f42$var$useStepContext() {
    return $e279640208208f42$var$React.useContext($e279640208208f42$var$StepContext);
}
var $e279640208208f42$var$_default = module.exports.default = $e279640208208f42$var$StepContext;

});

parcelRegister("bspH3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $85763d6f4c7e74c7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepUtilityClass = $85763d6f4c7e74c7$var$getStepUtilityClass;

var $85763d6f4c7e74c7$var$_generateUtilityClasses = $85763d6f4c7e74c7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $85763d6f4c7e74c7$var$_generateUtilityClass = $85763d6f4c7e74c7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $85763d6f4c7e74c7$var$getStepUtilityClass(slot) {
    return (0, $85763d6f4c7e74c7$var$_generateUtilityClass.default)('MuiStep', slot);
}
const $85763d6f4c7e74c7$var$stepClasses = (0, $85763d6f4c7e74c7$var$_generateUtilityClasses.default)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $85763d6f4c7e74c7$var$_default = module.exports.default = $85763d6f4c7e74c7$var$stepClasses;

});



parcelRegister("k1pY1", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e9380b273cd6ee6d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e9380b273cd6ee6d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e9380b273cd6ee6d$var$_exportNames = {
    stepButtonClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e9380b273cd6ee6d$var$_StepButton.default;
    }
});
Object.defineProperty(module.exports, "stepButtonClasses", {
    enumerable: true,
    get: function() {
        return $e9380b273cd6ee6d$var$_stepButtonClasses.default;
    }
});

var $e9380b273cd6ee6d$var$_StepButton = $e9380b273cd6ee6d$require$_interopRequireDefault((parcelRequire("3s4fu")));

var $e9380b273cd6ee6d$var$_stepButtonClasses = $e9380b273cd6ee6d$require$_interopRequireWildcard((parcelRequire("3OtA2")));
Object.keys($e9380b273cd6ee6d$var$_stepButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e9380b273cd6ee6d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e9380b273cd6ee6d$var$_stepButtonClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e9380b273cd6ee6d$var$_stepButtonClasses[key];
        }
    });
});

});
parcelRegister("3s4fu", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2837485fb2fa495c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2837485fb2fa495c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2837485fb2fa495c$var$React = $2837485fb2fa495c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2837485fb2fa495c$var$_propTypes = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2837485fb2fa495c$var$_clsx = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2837485fb2fa495c$var$_composeClasses = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $2837485fb2fa495c$var$_ButtonBase = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $2837485fb2fa495c$var$_StepLabel = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("cD4Pq")));

var $2837485fb2fa495c$var$_isMuiElement = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $2837485fb2fa495c$var$_StepperContext = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $2837485fb2fa495c$var$_StepContext = $2837485fb2fa495c$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $2837485fb2fa495c$var$_stepButtonClasses = $2837485fb2fa495c$require$_interopRequireWildcard((parcelRequire("3OtA2")));

var $ayMG0 = parcelRequire("ayMG0");
const $2837485fb2fa495c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation } = ownerState;
    const slots = {
        root: [
            'root',
            orientation
        ],
        touchRipple: [
            'touchRipple'
        ]
    };
    return (0, $2837485fb2fa495c$var$_composeClasses.default)(slots, $2837485fb2fa495c$var$_stepButtonClasses.getStepButtonUtilityClass, classes);
};
const $2837485fb2fa495c$var$StepButtonRoot = (0, $aAbgT.styled)($2837485fb2fa495c$var$_ButtonBase.default, {
    name: 'MuiStepButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$2837485fb2fa495c$var$_stepButtonClasses.default.touchRipple}`]: styles.touchRipple
            },
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})({
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box',
    [`& .${$2837485fb2fa495c$var$_stepButtonClasses.default.touchRipple}`]: {
        color: 'rgba(0, 0, 0, 0.3)'
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                justifyContent: 'flex-start',
                padding: '8px',
                margin: '-8px'
            }
        }
    ]
});
const $2837485fb2fa495c$var$StepButton = /*#__PURE__*/ $2837485fb2fa495c$var$React.forwardRef(function StepButton(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepButton'
    });
    const { children: children, className: className, icon: icon, optional: optional, ...other } = props;
    const { disabled: disabled, active: active } = $2837485fb2fa495c$var$React.useContext($2837485fb2fa495c$var$_StepContext.default);
    const { orientation: orientation } = $2837485fb2fa495c$var$React.useContext($2837485fb2fa495c$var$_StepperContext.default);
    const ownerState = {
        ...props,
        orientation: orientation
    };
    const classes = $2837485fb2fa495c$var$useUtilityClasses(ownerState);
    const childProps = {
        icon: icon,
        optional: optional
    };
    const child = (0, $2837485fb2fa495c$var$_isMuiElement.default)(children, [
        'StepLabel'
    ]) ? /*#__PURE__*/ $2837485fb2fa495c$var$React.cloneElement(children, childProps) : /*#__PURE__*/ (0, $ayMG0.jsx)($2837485fb2fa495c$var$_StepLabel.default, {
        ...childProps,
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2837485fb2fa495c$var$StepButtonRoot, {
        focusRipple: true,
        disabled: disabled,
        TouchRippleProps: {
            className: classes.touchRipple
        },
        className: (0, $2837485fb2fa495c$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        "aria-current": active ? 'step' : undefined,
        ...other,
        children: child
    });
});
var $2837485fb2fa495c$var$_default = module.exports.default = $2837485fb2fa495c$var$StepButton;

});
parcelRegister("cD4Pq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $931cdf5c02131bb6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $931cdf5c02131bb6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $931cdf5c02131bb6$var$_exportNames = {
    stepLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $931cdf5c02131bb6$var$_StepLabel.default;
    }
});
Object.defineProperty(module.exports, "stepLabelClasses", {
    enumerable: true,
    get: function() {
        return $931cdf5c02131bb6$var$_stepLabelClasses.default;
    }
});

var $931cdf5c02131bb6$var$_StepLabel = $931cdf5c02131bb6$require$_interopRequireDefault((parcelRequire("e2Az3")));

var $931cdf5c02131bb6$var$_stepLabelClasses = $931cdf5c02131bb6$require$_interopRequireWildcard((parcelRequire("avvt2")));
Object.keys($931cdf5c02131bb6$var$_stepLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($931cdf5c02131bb6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $931cdf5c02131bb6$var$_stepLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $931cdf5c02131bb6$var$_stepLabelClasses[key];
        }
    });
});

});
parcelRegister("e2Az3", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a38d9d8360b02e78$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a38d9d8360b02e78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a38d9d8360b02e78$var$_composeClasses = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a38d9d8360b02e78$var$_clsx = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a38d9d8360b02e78$var$_propTypes = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a38d9d8360b02e78$var$React = $a38d9d8360b02e78$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a38d9d8360b02e78$var$_StepContext = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $a38d9d8360b02e78$var$_StepIcon = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("2K1qt")));

var $a38d9d8360b02e78$var$_StepperContext = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $aAbgT = parcelRequire("aAbgT");

var $a38d9d8360b02e78$var$_memoTheme = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a38d9d8360b02e78$var$_stepLabelClasses = $a38d9d8360b02e78$require$_interopRequireWildcard((parcelRequire("avvt2")));

var $a38d9d8360b02e78$var$_useSlot = $a38d9d8360b02e78$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $a38d9d8360b02e78$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $a38d9d8360b02e78$var$_composeClasses.default)(slots, $a38d9d8360b02e78$var$_stepLabelClasses.getStepLabelUtilityClass, classes);
};
const $a38d9d8360b02e78$var$StepLabelRoot = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
        flexDirection: 'column'
    },
    [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.disabled}`]: {
        cursor: 'default'
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                textAlign: 'left',
                padding: '8px 0'
            }
        }
    ]
});
const $a38d9d8360b02e78$var$StepLabelLabel = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'Label'
})((0, $a38d9d8360b02e78$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.active}, &.${$a38d9d8360b02e78$var$_stepLabelClasses.default.completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $a38d9d8360b02e78$var$StepLabelIconContainer = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer'
})({
    flexShrink: 0,
    display: 'flex',
    paddingRight: 8,
    [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
        paddingRight: 0
    }
});
const $a38d9d8360b02e78$var$StepLabelLabelContainer = (0, $aAbgT.styled)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer'
})((0, $a38d9d8360b02e78$var$_memoTheme.default)(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${$a38d9d8360b02e78$var$_stepLabelClasses.default.alternativeLabel}`]: {
            textAlign: 'center'
        }
    })));
const $a38d9d8360b02e78$var$StepLabel = /*#__PURE__*/ $a38d9d8360b02e78$var$React.forwardRef(function StepLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slots: slots = {}, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps, ...other } = props;
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $a38d9d8360b02e78$var$React.useContext($a38d9d8360b02e78$var$_StepperContext.default);
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $a38d9d8360b02e78$var$React.useContext($a38d9d8360b02e78$var$_StepContext.default);
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = $a38d9d8360b02e78$var$_StepIcon.default;
    const ownerState = {
        ...props,
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    };
    const classes = $a38d9d8360b02e78$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            stepIcon: StepIconProps,
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $a38d9d8360b02e78$var$_useSlot.default)('root', {
        elementType: $a38d9d8360b02e78$var$StepLabelRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref,
        className: (0, $a38d9d8360b02e78$var$_clsx.default)(classes.root, className)
    });
    const [LabelSlot, labelProps] = (0, $a38d9d8360b02e78$var$_useSlot.default)('label', {
        elementType: $a38d9d8360b02e78$var$StepLabelLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [StepIconSlot, stepIconProps] = (0, $a38d9d8360b02e78$var$_useSlot.default)('stepIcon', {
        elementType: StepIconComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            icon || StepIconSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($a38d9d8360b02e78$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(StepIconSlot, {
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon,
                    ...stepIconProps
                })
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($a38d9d8360b02e78$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                        ...labelProps,
                        className: (0, $a38d9d8360b02e78$var$_clsx.default)(classes.label, labelProps?.className),
                        children: children
                    }) : null,
                    optional
                ]
            })
        ]
    });
});
$a38d9d8360b02e78$var$StepLabel.muiName = 'StepLabel';
var $a38d9d8360b02e78$var$_default = module.exports.default = $a38d9d8360b02e78$var$StepLabel;

});
parcelRegister("2K1qt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1ff0fbd06d13ad2a$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1ff0fbd06d13ad2a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1ff0fbd06d13ad2a$var$_exportNames = {
    stepIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ff0fbd06d13ad2a$var$_StepIcon.default;
    }
});
Object.defineProperty(module.exports, "stepIconClasses", {
    enumerable: true,
    get: function() {
        return $1ff0fbd06d13ad2a$var$_stepIconClasses.default;
    }
});

var $1ff0fbd06d13ad2a$var$_StepIcon = $1ff0fbd06d13ad2a$require$_interopRequireDefault((parcelRequire("NklxQ")));

var $1ff0fbd06d13ad2a$var$_stepIconClasses = $1ff0fbd06d13ad2a$require$_interopRequireWildcard((parcelRequire("7f59P")));
Object.keys($1ff0fbd06d13ad2a$var$_stepIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1ff0fbd06d13ad2a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1ff0fbd06d13ad2a$var$_stepIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1ff0fbd06d13ad2a$var$_stepIconClasses[key];
        }
    });
});

});
parcelRegister("NklxQ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $09445c1bc5a83d17$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $09445c1bc5a83d17$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09445c1bc5a83d17$var$React = $09445c1bc5a83d17$require$_interopRequireWildcard((parcelRequire("acw62")));

var $09445c1bc5a83d17$var$_propTypes = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09445c1bc5a83d17$var$_clsx = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("9QePP")));

var $09445c1bc5a83d17$var$_composeClasses = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $09445c1bc5a83d17$var$_memoTheme = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $09445c1bc5a83d17$var$_CheckCircle = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("9uq0C")));

var $09445c1bc5a83d17$var$_Warning = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("7PGQc")));

var $09445c1bc5a83d17$var$_SvgIcon = $09445c1bc5a83d17$require$_interopRequireDefault((parcelRequire("loOwp")));

var $09445c1bc5a83d17$var$_stepIconClasses = $09445c1bc5a83d17$require$_interopRequireWildcard((parcelRequire("7f59P")));

var $ayMG0 = parcelRequire("ayMG0");
var $09445c1bc5a83d17$var$_circle;
const $09445c1bc5a83d17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $09445c1bc5a83d17$var$_composeClasses.default)(slots, $09445c1bc5a83d17$var$_stepIconClasses.getStepIconUtilityClass, classes);
};
const $09445c1bc5a83d17$var$StepIconRoot = (0, $aAbgT.styled)($09445c1bc5a83d17$var$_SvgIcon.default, {
    name: 'MuiStepIcon',
    slot: 'Root'
})((0, $09445c1bc5a83d17$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${$09445c1bc5a83d17$var$_stepIconClasses.default.completed}, &.${$09445c1bc5a83d17$var$_stepIconClasses.default.active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${$09445c1bc5a83d17$var$_stepIconClasses.default.error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $09445c1bc5a83d17$var$StepIconText = (0, $aAbgT.styled)('text', {
    name: 'MuiStepIcon',
    slot: 'Text'
})((0, $09445c1bc5a83d17$var$_memoTheme.default)(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    })));
const $09445c1bc5a83d17$var$StepIcon = /*#__PURE__*/ $09445c1bc5a83d17$var$React.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        completed: completed,
        error: error
    };
    const classes = $09445c1bc5a83d17$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $09445c1bc5a83d17$var$_clsx.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, {
            as: $09445c1bc5a83d17$var$_Warning.default,
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        if (completed) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, {
            as: $09445c1bc5a83d17$var$_CheckCircle.default,
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($09445c1bc5a83d17$var$StepIconRoot, {
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                $09445c1bc5a83d17$var$_circle || ($09445c1bc5a83d17$var$_circle = /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        });
    }
    return icon;
});
var $09445c1bc5a83d17$var$_default = module.exports.default = $09445c1bc5a83d17$var$StepIcon;

});
parcelRegister("9uq0C", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e8b174384ed5c4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e8b174384ed5c4f$var$_createSvgIcon = $6e8b174384ed5c4f$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $6e8b174384ed5c4f$var$_default = module.exports.default = (0, $6e8b174384ed5c4f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');

});

parcelRegister("7PGQc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5b3e87234e6d594a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b3e87234e6d594a$var$_createSvgIcon = $5b3e87234e6d594a$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $5b3e87234e6d594a$var$_default = module.exports.default = (0, $5b3e87234e6d594a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

});

parcelRegister("7f59P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $545def50b7760bec$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepIconUtilityClass = $545def50b7760bec$var$getStepIconUtilityClass;

var $545def50b7760bec$var$_generateUtilityClasses = $545def50b7760bec$require$_interopRequireDefault((parcelRequire("5nY49")));

var $545def50b7760bec$var$_generateUtilityClass = $545def50b7760bec$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $545def50b7760bec$var$getStepIconUtilityClass(slot) {
    return (0, $545def50b7760bec$var$_generateUtilityClass.default)('MuiStepIcon', slot);
}
const $545def50b7760bec$var$stepIconClasses = (0, $545def50b7760bec$var$_generateUtilityClasses.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $545def50b7760bec$var$_default = module.exports.default = $545def50b7760bec$var$stepIconClasses;

});



parcelRegister("avvt2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7a65356a062b77fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepLabelUtilityClass = $7a65356a062b77fd$var$getStepLabelUtilityClass;

var $7a65356a062b77fd$var$_generateUtilityClasses = $7a65356a062b77fd$require$_interopRequireDefault((parcelRequire("5nY49")));

var $7a65356a062b77fd$var$_generateUtilityClass = $7a65356a062b77fd$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $7a65356a062b77fd$var$getStepLabelUtilityClass(slot) {
    return (0, $7a65356a062b77fd$var$_generateUtilityClass.default)('MuiStepLabel', slot);
}
const $7a65356a062b77fd$var$stepLabelClasses = (0, $7a65356a062b77fd$var$_generateUtilityClasses.default)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $7a65356a062b77fd$var$_default = module.exports.default = $7a65356a062b77fd$var$stepLabelClasses;

});



parcelRegister("3OtA2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2c6cfca685d9c4a3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepButtonUtilityClass = $2c6cfca685d9c4a3$var$getStepButtonUtilityClass;

var $2c6cfca685d9c4a3$var$_generateUtilityClasses = $2c6cfca685d9c4a3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $2c6cfca685d9c4a3$var$_generateUtilityClass = $2c6cfca685d9c4a3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $2c6cfca685d9c4a3$var$getStepButtonUtilityClass(slot) {
    return (0, $2c6cfca685d9c4a3$var$_generateUtilityClass.default)('MuiStepButton', slot);
}
const $2c6cfca685d9c4a3$var$stepButtonClasses = (0, $2c6cfca685d9c4a3$var$_generateUtilityClasses.default)('MuiStepButton', [
    'root',
    'horizontal',
    'vertical',
    'touchRipple'
]);
var $2c6cfca685d9c4a3$var$_default = module.exports.default = $2c6cfca685d9c4a3$var$stepButtonClasses;

});



parcelRegister("jjQoZ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e108709a7cb36655$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e108709a7cb36655$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e108709a7cb36655$var$_exportNames = {
    stepConnectorClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e108709a7cb36655$var$_StepConnector.default;
    }
});
Object.defineProperty(module.exports, "stepConnectorClasses", {
    enumerable: true,
    get: function() {
        return $e108709a7cb36655$var$_stepConnectorClasses.default;
    }
});

var $e108709a7cb36655$var$_StepConnector = $e108709a7cb36655$require$_interopRequireDefault((parcelRequire("4r3Nm")));

var $e108709a7cb36655$var$_stepConnectorClasses = $e108709a7cb36655$require$_interopRequireWildcard((parcelRequire("6CCNL")));
Object.keys($e108709a7cb36655$var$_stepConnectorClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e108709a7cb36655$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e108709a7cb36655$var$_stepConnectorClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e108709a7cb36655$var$_stepConnectorClasses[key];
        }
    });
});

});
parcelRegister("4r3Nm", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $33aca0a7deb8d615$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $33aca0a7deb8d615$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33aca0a7deb8d615$var$React = $33aca0a7deb8d615$require$_interopRequireWildcard((parcelRequire("acw62")));

var $33aca0a7deb8d615$var$_propTypes = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $33aca0a7deb8d615$var$_clsx = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("9QePP")));

var $33aca0a7deb8d615$var$_composeClasses = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $33aca0a7deb8d615$var$_capitalize = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $33aca0a7deb8d615$var$_memoTheme = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $33aca0a7deb8d615$var$_StepperContext = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $33aca0a7deb8d615$var$_StepContext = $33aca0a7deb8d615$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $6CCNL = parcelRequire("6CCNL");

var $ayMG0 = parcelRequire("ayMG0");
const $33aca0a7deb8d615$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $33aca0a7deb8d615$var$_capitalize.default)(orientation)}`
        ]
    };
    return (0, $33aca0a7deb8d615$var$_composeClasses.default)(slots, $6CCNL.getStepConnectorUtilityClass, classes);
};
const $33aca0a7deb8d615$var$StepConnectorRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})({
    flex: '1 1 auto',
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                marginLeft: 12 // half icon
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                position: 'absolute',
                top: 12,
                left: 'calc(-50% + 20px)',
                right: 'calc(50% + 20px)'
            }
        }
    ]
});
const $33aca0a7deb8d615$var$StepConnectorLine = (0, $aAbgT.styled)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $33aca0a7deb8d615$var$_capitalize.default)(ownerState.orientation)}`]
        ];
    }
})((0, $33aca0a7deb8d615$var$_memoTheme.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return {
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor,
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    borderTopStyle: 'solid',
                    borderTopWidth: 1
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 1,
                    minHeight: 24
                }
            }
        ]
    };
}));
const $33aca0a7deb8d615$var$StepConnector = /*#__PURE__*/ $33aca0a7deb8d615$var$React.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className, ...other } = props;
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $33aca0a7deb8d615$var$React.useContext($33aca0a7deb8d615$var$_StepperContext.default);
    const { active: active, disabled: disabled, completed: completed } = $33aca0a7deb8d615$var$React.useContext($33aca0a7deb8d615$var$_StepContext.default);
    const ownerState = {
        ...props,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    };
    const classes = $33aca0a7deb8d615$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($33aca0a7deb8d615$var$StepConnectorRoot, {
        className: (0, $33aca0a7deb8d615$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($33aca0a7deb8d615$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    });
});
var $33aca0a7deb8d615$var$_default = module.exports.default = $33aca0a7deb8d615$var$StepConnector;

});
parcelRegister("6CCNL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4d2463e67e3000c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepConnectorUtilityClass = $4d2463e67e3000c3$var$getStepConnectorUtilityClass;

var $4d2463e67e3000c3$var$_generateUtilityClasses = $4d2463e67e3000c3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4d2463e67e3000c3$var$_generateUtilityClass = $4d2463e67e3000c3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4d2463e67e3000c3$var$getStepConnectorUtilityClass(slot) {
    return (0, $4d2463e67e3000c3$var$_generateUtilityClass.default)('MuiStepConnector', slot);
}
const $4d2463e67e3000c3$var$stepConnectorClasses = (0, $4d2463e67e3000c3$var$_generateUtilityClasses.default)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $4d2463e67e3000c3$var$_default = module.exports.default = $4d2463e67e3000c3$var$stepConnectorClasses;

});



parcelRegister("b3U7M", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80db82a861533602$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $80db82a861533602$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80db82a861533602$var$_exportNames = {
    stepContentClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80db82a861533602$var$_StepContent.default;
    }
});
Object.defineProperty(module.exports, "stepContentClasses", {
    enumerable: true,
    get: function() {
        return $80db82a861533602$var$_stepContentClasses.default;
    }
});

var $80db82a861533602$var$_StepContent = $80db82a861533602$require$_interopRequireDefault((parcelRequire("dNCDH")));

var $80db82a861533602$var$_stepContentClasses = $80db82a861533602$require$_interopRequireWildcard((parcelRequire("5A2Y1")));
Object.keys($80db82a861533602$var$_stepContentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80db82a861533602$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80db82a861533602$var$_stepContentClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80db82a861533602$var$_stepContentClasses[key];
        }
    });
});

});
parcelRegister("dNCDH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a0bdd2eb216e9220$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a0bdd2eb216e9220$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0bdd2eb216e9220$var$React = $a0bdd2eb216e9220$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a0bdd2eb216e9220$var$_propTypes = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a0bdd2eb216e9220$var$_clsx = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a0bdd2eb216e9220$var$_composeClasses = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $a0bdd2eb216e9220$var$_memoTheme = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $a0bdd2eb216e9220$var$_Collapse = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("gsEuH")));

var $a0bdd2eb216e9220$var$_StepperContext = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $a0bdd2eb216e9220$var$_StepContext = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("jrw2p")));

var $5A2Y1 = parcelRequire("5A2Y1");

var $a0bdd2eb216e9220$var$_useSlot = $a0bdd2eb216e9220$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $a0bdd2eb216e9220$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, last: last } = ownerState;
    const slots = {
        root: [
            'root',
            last && 'last'
        ],
        transition: [
            'transition'
        ]
    };
    return (0, $a0bdd2eb216e9220$var$_composeClasses.default)(slots, $5A2Y1.getStepContentUtilityClass, classes);
};
const $a0bdd2eb216e9220$var$StepContentRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStepContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.last && styles.last
        ];
    }
})((0, $a0bdd2eb216e9220$var$_memoTheme.default)(({ theme: theme })=>({
        marginLeft: 12,
        // half icon
        paddingLeft: 20,
        // margin + half icon
        paddingRight: 8,
        borderLeft: theme.vars ? `1px solid ${theme.vars.palette.StepContent.border}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]}`,
        variants: [
            {
                props: {
                    last: true
                },
                style: {
                    borderLeft: 'none'
                }
            }
        ]
    })));
const $a0bdd2eb216e9220$var$StepContentTransition = (0, $aAbgT.styled)($a0bdd2eb216e9220$var$_Collapse.default, {
    name: 'MuiStepContent',
    slot: 'Transition'
})({});
const $a0bdd2eb216e9220$var$StepContent = /*#__PURE__*/ $a0bdd2eb216e9220$var$React.forwardRef(function StepContent(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepContent'
    });
    const { children: children, className: className, TransitionComponent: TransitionComponent = $a0bdd2eb216e9220$var$_Collapse.default, transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { orientation: orientation } = $a0bdd2eb216e9220$var$React.useContext($a0bdd2eb216e9220$var$_StepperContext.default);
    const { active: active, last: last, expanded: expanded } = $a0bdd2eb216e9220$var$React.useContext($a0bdd2eb216e9220$var$_StepContext.default);
    const ownerState = {
        ...props,
        last: last
    };
    const classes = $a0bdd2eb216e9220$var$useUtilityClasses(ownerState);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            transition: TransitionProps,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionProps] = (0, $a0bdd2eb216e9220$var$_useSlot.default)('transition', {
        elementType: $a0bdd2eb216e9220$var$StepContentTransition,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.transition,
        additionalProps: {
            in: active || expanded,
            timeout: transitionDuration,
            unmountOnExit: true
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a0bdd2eb216e9220$var$StepContentRoot, {
        className: (0, $a0bdd2eb216e9220$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            as: TransitionComponent,
            ...transitionProps,
            children: children
        })
    });
});
var $a0bdd2eb216e9220$var$_default = module.exports.default = $a0bdd2eb216e9220$var$StepContent;

});
parcelRegister("5A2Y1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $41029dbb16e3c896$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepContentUtilityClass = $41029dbb16e3c896$var$getStepContentUtilityClass;

var $41029dbb16e3c896$var$_generateUtilityClasses = $41029dbb16e3c896$require$_interopRequireDefault((parcelRequire("5nY49")));

var $41029dbb16e3c896$var$_generateUtilityClass = $41029dbb16e3c896$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $41029dbb16e3c896$var$getStepContentUtilityClass(slot) {
    return (0, $41029dbb16e3c896$var$_generateUtilityClass.default)('MuiStepContent', slot);
}
const $41029dbb16e3c896$var$stepContentClasses = (0, $41029dbb16e3c896$var$_generateUtilityClasses.default)('MuiStepContent', [
    'root',
    'last',
    'transition'
]);
var $41029dbb16e3c896$var$_default = module.exports.default = $41029dbb16e3c896$var$stepContentClasses;

});



parcelRegister("5kBLW", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3e1c1ec9d9e33247$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3e1c1ec9d9e33247$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3e1c1ec9d9e33247$var$_exportNames = {
    stepperClasses: true,
    StepperContext: true
};
Object.defineProperty(module.exports, "StepperContext", {
    enumerable: true,
    get: function() {
        return $3e1c1ec9d9e33247$var$_StepperContext.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3e1c1ec9d9e33247$var$_Stepper.default;
    }
});
Object.defineProperty(module.exports, "stepperClasses", {
    enumerable: true,
    get: function() {
        return $3e1c1ec9d9e33247$var$_stepperClasses.default;
    }
});

var $3e1c1ec9d9e33247$var$_Stepper = $3e1c1ec9d9e33247$require$_interopRequireDefault((parcelRequire("RyhSp")));

var $3e1c1ec9d9e33247$var$_stepperClasses = $3e1c1ec9d9e33247$require$_interopRequireWildcard((parcelRequire("7qR9n")));
Object.keys($3e1c1ec9d9e33247$var$_stepperClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3e1c1ec9d9e33247$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3e1c1ec9d9e33247$var$_stepperClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3e1c1ec9d9e33247$var$_stepperClasses[key];
        }
    });
});

var $3e1c1ec9d9e33247$var$_StepperContext = $3e1c1ec9d9e33247$require$_interopRequireWildcard((parcelRequire("8c8ll")));
Object.keys($3e1c1ec9d9e33247$var$_StepperContext).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3e1c1ec9d9e33247$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3e1c1ec9d9e33247$var$_StepperContext[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3e1c1ec9d9e33247$var$_StepperContext[key];
        }
    });
});

});
parcelRegister("RyhSp", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0a0f8c19f5f3ee7a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0a0f8c19f5f3ee7a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a0f8c19f5f3ee7a$var$React = $0a0f8c19f5f3ee7a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0a0f8c19f5f3ee7a$var$_propTypes = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0a0f8c19f5f3ee7a$var$_clsx = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $0a0f8c19f5f3ee7a$var$_integerPropType = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("cxaSP")));

var $0a0f8c19f5f3ee7a$var$_composeClasses = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $7qR9n = parcelRequire("7qR9n");

var $0a0f8c19f5f3ee7a$var$_StepConnector = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("jjQoZ")));

var $0a0f8c19f5f3ee7a$var$_StepperContext = $0a0f8c19f5f3ee7a$require$_interopRequireDefault((parcelRequire("8c8ll")));

var $ayMG0 = parcelRequire("ayMG0");
const $0a0f8c19f5f3ee7a$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $0a0f8c19f5f3ee7a$var$_composeClasses.default)(slots, $7qR9n.getStepperUtilityClass, classes);
};
const $0a0f8c19f5f3ee7a$var$StepperRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                flexDirection: 'row',
                alignItems: 'center'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: {
                alternativeLabel: true
            },
            style: {
                alignItems: 'flex-start'
            }
        }
    ]
});
const $0a0f8c19f5f3ee7a$var$defaultConnector = /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$_StepConnector.default, {});
const $0a0f8c19f5f3ee7a$var$Stepper = /*#__PURE__*/ $0a0f8c19f5f3ee7a$var$React.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $0a0f8c19f5f3ee7a$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal', ...other } = props;
    const ownerState = {
        ...props,
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    };
    const classes = $0a0f8c19f5f3ee7a$var$useUtilityClasses(ownerState);
    const childrenArray = $0a0f8c19f5f3ee7a$var$React.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $0a0f8c19f5f3ee7a$var$React.cloneElement(step, {
            index: index,
            last: index + 1 === childrenArray.length,
            ...step.props
        });
    });
    const contextValue = $0a0f8c19f5f3ee7a$var$React.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$_StepperContext.default.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0a0f8c19f5f3ee7a$var$StepperRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $0a0f8c19f5f3ee7a$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other,
            children: steps
        })
    });
});
var $0a0f8c19f5f3ee7a$var$_default = module.exports.default = $0a0f8c19f5f3ee7a$var$Stepper;

});
parcelRegister("7qR9n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $569430a767235b4e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStepperUtilityClass = $569430a767235b4e$var$getStepperUtilityClass;

var $569430a767235b4e$var$_generateUtilityClasses = $569430a767235b4e$require$_interopRequireDefault((parcelRequire("5nY49")));

var $569430a767235b4e$var$_generateUtilityClass = $569430a767235b4e$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $569430a767235b4e$var$getStepperUtilityClass(slot) {
    return (0, $569430a767235b4e$var$_generateUtilityClass.default)('MuiStepper', slot);
}
const $569430a767235b4e$var$stepperClasses = (0, $569430a767235b4e$var$_generateUtilityClasses.default)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $569430a767235b4e$var$_default = module.exports.default = $569430a767235b4e$var$stepperClasses;

});



parcelRegister("fuux0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b471573c23b3da9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b471573c23b3da9a$var$_SwipeableDrawer.default;
    }
});

var $b471573c23b3da9a$var$_SwipeableDrawer = $b471573c23b3da9a$require$_interopRequireDefault((parcelRequire("ftPRU")));

});
parcelRegister("ftPRU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b451cc713fab7e92$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b451cc713fab7e92$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.reset = $b451cc713fab7e92$var$reset;

var $b451cc713fab7e92$var$React = $b451cc713fab7e92$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b451cc713fab7e92$var$ReactDOM = $b451cc713fab7e92$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $b451cc713fab7e92$var$_propTypes = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b451cc713fab7e92$var$_elementTypeAcceptingRef = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $b451cc713fab7e92$var$_NoSsr = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("cQC3m")));

var $b451cc713fab7e92$var$_Drawer = $b451cc713fab7e92$require$_interopRequireWildcard((parcelRequire("2Ed4H")));

var $b451cc713fab7e92$var$_useForkRef = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $b451cc713fab7e92$var$_ownerDocument = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $b451cc713fab7e92$var$_ownerWindow = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $b451cc713fab7e92$var$_useEventCallback = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $b451cc713fab7e92$var$_useEnhancedEffect = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("khjmj")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $hweuE = parcelRequire("hweuE");

var $hGPki = parcelRequire("hGPki");

var $b451cc713fab7e92$var$_useSlot = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("6lpak")));

var $b451cc713fab7e92$var$_SwipeArea = $b451cc713fab7e92$require$_interopRequireDefault((parcelRequire("gQeSR")));

var $ayMG0 = parcelRequire("ayMG0");
// This value is closed to what browsers are using internally to
// trigger a native scroll.
const $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD = 3; // px
// This is the part of the drawer displayed on touch start.
const $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL = 20; // px
// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let $b451cc713fab7e92$var$claimedSwipeInstance = null;
// Exported for test purposes.
function $b451cc713fab7e92$var$reset() {
    $b451cc713fab7e92$var$claimedSwipeInstance = null;
}
function $b451cc713fab7e92$var$calculateCurrentX(anchor, touches, doc) {
    return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function $b451cc713fab7e92$var$calculateCurrentY(anchor, touches, containerWindow) {
    return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperInstance) {
    return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function $b451cc713fab7e92$var$getTranslate(currentTranslate, startLocation, open, maxTranslate) {
    return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */ function $b451cc713fab7e92$var$getDomTreeShapes(element, rootNode) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
    const domTreeShapes = [];
    while(element && element !== rootNode.parentElement){
        const style = (0, $b451cc713fab7e92$var$_ownerWindow.default)(rootNode).getComputedStyle(element);
        if (// Ignore the scroll children if the element is absolute positioned.
        style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
        style.getPropertyValue('overflow-x') === 'hidden') ;
        else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) // Ignore the nodes that have no width.
        // Keep elements with a scroll
        domTreeShapes.push(element);
        element = element.parentElement;
    }
    return domTreeShapes;
}
/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */ function $b451cc713fab7e92$var$computeHasNativeHandler({ domTreeShapes: domTreeShapes, start: start, current: current, anchor: anchor }) {
    // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
    const axisProperties = {
        scrollPosition: {
            x: 'scrollLeft',
            y: 'scrollTop'
        },
        scrollLength: {
            x: 'scrollWidth',
            y: 'scrollHeight'
        },
        clientLength: {
            x: 'clientWidth',
            y: 'clientHeight'
        }
    };
    return domTreeShapes.some((shape)=>{
        // Determine if we are going backward or forward.
        let goingForward = current >= start;
        if (anchor === 'top' || anchor === 'left') goingForward = !goingForward;
        const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
        const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
        const areNotAtStart = scrollPosition > 0;
        const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
        if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) return true;
        return false;
    });
}
const $b451cc713fab7e92$var$iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const $b451cc713fab7e92$var$SwipeableDrawer = /*#__PURE__*/ $b451cc713fab7e92$var$React.forwardRef(function SwipeableDrawer(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        name: 'MuiSwipeableDrawer',
        props: inProps
    });
    const theme = (0, $aAbgT.useTheme)();
    const transitionDurationDefault = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchor = 'left', disableBackdropTransition: disableBackdropTransition = false, disableDiscovery: disableDiscovery = false, disableSwipeToOpen: disableSwipeToOpen = $b451cc713fab7e92$var$iOS, hideBackdrop: hideBackdrop, hysteresis: hysteresis = 0.52, allowSwipeInChildren: allowSwipeInChildren = false, minFlingVelocity: minFlingVelocity = 450, ModalProps: { BackdropProps: BackdropProps, ...ModalPropsProp } = {}, onClose: onClose, onOpen: onOpen, open: open = false, PaperProps: PaperProps = {}, SwipeAreaProps: SwipeAreaProps, swipeAreaWidth: swipeAreaWidth = 20, transitionDuration: transitionDuration = transitionDurationDefault, variant: variant = 'temporary', slots: // Mobile first.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [maybeSwiping, setMaybeSwiping] = $b451cc713fab7e92$var$React.useState(false);
    const swipeInstance = $b451cc713fab7e92$var$React.useRef({
        isSwiping: null
    });
    const swipeAreaRef = $b451cc713fab7e92$var$React.useRef();
    const backdropRef = $b451cc713fab7e92$var$React.useRef();
    const paperRef = $b451cc713fab7e92$var$React.useRef();
    const handleRef = (0, $b451cc713fab7e92$var$_useForkRef.default)(PaperProps.ref, paperRef);
    const touchDetected = $b451cc713fab7e92$var$React.useRef(false);
    // Ref for transition duration based on / to match swipe speed
    const calculatedDurationRef = $b451cc713fab7e92$var$React.useRef();
    // Use a ref so the open value used is always up to date inside useCallback.
    (0, $b451cc713fab7e92$var$_useEnhancedEffect.default)(()=>{
        calculatedDurationRef.current = null;
    }, [
        open
    ]);
    const setPosition = $b451cc713fab7e92$var$React.useCallback((translate, options = {})=>{
        const { mode: mode = null, changeTransition: changeTransition = true } = options;
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const rtlTranslateMultiplier = [
            'right',
            'bottom'
        ].includes(anchorRtl) ? 1 : -1;
        const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
        const drawerStyle = paperRef.current.style;
        drawerStyle.webkitTransform = transform;
        drawerStyle.transform = transform;
        let transition = '';
        if (mode) transition = theme.transitions.create('all', (0, $hweuE.getTransitionProps)({
            easing: undefined,
            style: undefined,
            timeout: transitionDuration
        }, {
            mode: mode
        }));
        if (changeTransition) {
            drawerStyle.webkitTransition = transition;
            drawerStyle.transition = transition;
        }
        if (!disableBackdropTransition && !hideBackdrop) {
            const backdropStyle = backdropRef.current.style;
            backdropStyle.opacity = 1 - translate / $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current);
            if (changeTransition) {
                backdropStyle.webkitTransition = transition;
                backdropStyle.transition = transition;
            }
        }
    }, [
        anchor,
        disableBackdropTransition,
        hideBackdrop,
        theme,
        transitionDuration
    ]);
    const handleBodyTouchEnd = (0, $b451cc713fab7e92$var$_useEventCallback.default)((nativeEvent)=>{
        if (!touchDetected.current) return;
        // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- claimedSwipeInstance is a singleton
        $b451cc713fab7e92$var$claimedSwipeInstance = null;
        touchDetected.current = false;
        $b451cc713fab7e92$var$ReactDOM.flushSync(()=>{
            setMaybeSwiping(false);
        });
        // The swipe wasn't started.
        if (!swipeInstance.current.isSwiping) {
            swipeInstance.current.isSwiping = null;
            return;
        }
        swipeInstance.current.isSwiping = null;
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const horizontal = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        let current;
        if (horizontal) current = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, $b451cc713fab7e92$var$_ownerDocument.default)(nativeEvent.currentTarget));
        else current = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, $b451cc713fab7e92$var$_ownerWindow.default)(nativeEvent.currentTarget));
        const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
        const maxTranslate = $b451cc713fab7e92$var$getMaxTranslate(horizontal, paperRef.current);
        const currentTranslate = $b451cc713fab7e92$var$getTranslate(current, startLocation, open, maxTranslate);
        const translateRatio = currentTranslate / maxTranslate;
        if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) // Calculate transition duration to match swipe speed
        calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
        if (open) {
            if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) onClose();
            else // Reset the position, the swipe was aborted.
            setPosition(0, {
                mode: 'exit'
            });
            return;
        }
        if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) onOpen();
        else // Reset the position, the swipe was aborted.
        setPosition($b451cc713fab7e92$var$getMaxTranslate(horizontal, paperRef.current), {
            mode: 'enter'
        });
    });
    const startMaybeSwiping = (force = false)=>{
        if (!maybeSwiping) {
            // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
            // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
            // so do this change on first touchmove instead of touchstart
            if (force || !(disableDiscovery && allowSwipeInChildren)) $b451cc713fab7e92$var$ReactDOM.flushSync(()=>{
                setMaybeSwiping(true);
            });
            const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
            if (!open && paperRef.current) // The ref may be null when a parent component updates while swiping.
            setPosition($b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -$b451cc713fab7e92$var$DRAG_STARTED_SIGNAL), {
                changeTransition: false
            });
            swipeInstance.current.velocity = 0;
            swipeInstance.current.lastTime = null;
            swipeInstance.current.lastTranslate = null;
            swipeInstance.current.paperHit = false;
            touchDetected.current = true;
        }
    };
    const handleBodyTouchMove = (0, $b451cc713fab7e92$var$_useEventCallback.default)((nativeEvent)=>{
        // the ref may be null when a parent component updates while swiping
        if (!paperRef.current || !touchDetected.current) return;
        // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
        if ($b451cc713fab7e92$var$claimedSwipeInstance !== null && $b451cc713fab7e92$var$claimedSwipeInstance !== swipeInstance.current) return;
        startMaybeSwiping(true);
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        const currentX = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerDocument.default)(nativeEvent.currentTarget));
        const currentY = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerWindow.default)(nativeEvent.currentTarget));
        if (open && paperRef.current.contains(nativeEvent.target) && $b451cc713fab7e92$var$claimedSwipeInstance === null) {
            const domTreeShapes = $b451cc713fab7e92$var$getDomTreeShapes(nativeEvent.target, paperRef.current);
            const hasNativeHandler = $b451cc713fab7e92$var$computeHasNativeHandler({
                domTreeShapes: domTreeShapes,
                start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
                current: horizontalSwipe ? currentX : currentY,
                anchor: anchor
            });
            if (hasNativeHandler) {
                $b451cc713fab7e92$var$claimedSwipeInstance = true;
                return;
            }
            $b451cc713fab7e92$var$claimedSwipeInstance = swipeInstance.current;
        }
        // We don't know yet.
        if (swipeInstance.current.isSwiping == null) {
            const dx = Math.abs(currentX - swipeInstance.current.startX);
            const dy = Math.abs(currentY - swipeInstance.current.startY);
            const definitelySwiping = horizontalSwipe ? dx > dy && dx > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD : dy > dx && dy > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD;
            if (definitelySwiping && nativeEvent.cancelable) nativeEvent.preventDefault();
            if (definitelySwiping === true || (horizontalSwipe ? dy > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD : dx > $b451cc713fab7e92$var$UNCERTAINTY_THRESHOLD)) {
                swipeInstance.current.isSwiping = definitelySwiping;
                if (!definitelySwiping) {
                    handleBodyTouchEnd(nativeEvent);
                    return;
                }
                // Shift the starting point.
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
                // Compensate for the part of the drawer displayed on touch start.
                if (!disableDiscovery && !open) {
                    if (horizontalSwipe) swipeInstance.current.startX -= $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL;
                    else swipeInstance.current.startY -= $b451cc713fab7e92$var$DRAG_STARTED_SIGNAL;
                }
            }
        }
        if (!swipeInstance.current.isSwiping) return;
        const maxTranslate = $b451cc713fab7e92$var$getMaxTranslate(horizontalSwipe, paperRef.current);
        let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
        if (open && !swipeInstance.current.paperHit) startLocation = Math.min(startLocation, maxTranslate);
        const translate = $b451cc713fab7e92$var$getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
        if (open) {
            if (!swipeInstance.current.paperHit) {
                const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
                if (paperHit) {
                    swipeInstance.current.paperHit = true;
                    swipeInstance.current.startX = currentX;
                    swipeInstance.current.startY = currentY;
                } else return;
            } else if (translate === 0) {
                swipeInstance.current.startX = currentX;
                swipeInstance.current.startY = currentY;
            }
        }
        if (swipeInstance.current.lastTranslate === null) {
            swipeInstance.current.lastTranslate = translate;
            swipeInstance.current.lastTime = performance.now() + 1;
        }
        const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
        // Low Pass filter.
        swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
        swipeInstance.current.lastTranslate = translate;
        swipeInstance.current.lastTime = performance.now();
        // We are swiping, let's prevent the scroll event on iOS.
        if (nativeEvent.cancelable) nativeEvent.preventDefault();
        setPosition(translate);
    });
    const handleBodyTouchStart = (0, $b451cc713fab7e92$var$_useEventCallback.default)((nativeEvent)=>{
        // We are not supposed to handle this touch move.
        // Example of use case: ignore the event if there is a Slider.
        if (nativeEvent.defaultPrevented) return;
        // We can only have one node at the time claiming ownership for handling the swipe.
        if (nativeEvent.defaultMuiPrevented) return;
        // At least one element clogs the drawer interaction zone.
        if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) return;
        const anchorRtl = (0, $b451cc713fab7e92$var$_Drawer.getAnchor)(theme, anchor);
        const horizontalSwipe = (0, $b451cc713fab7e92$var$_Drawer.isHorizontal)(anchor);
        const currentX = $b451cc713fab7e92$var$calculateCurrentX(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerDocument.default)(nativeEvent.currentTarget));
        const currentY = $b451cc713fab7e92$var$calculateCurrentY(anchorRtl, nativeEvent.touches, (0, $b451cc713fab7e92$var$_ownerWindow.default)(nativeEvent.currentTarget));
        if (!open) {
            // logic for if swipe should be ignored:
            // if disableSwipeToOpen
            // if target != swipeArea, and target is not a child of paper ref
            // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
            if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || paperRef.current?.contains(nativeEvent.target) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) return;
            if (horizontalSwipe) {
                if (currentX > swipeAreaWidth) return;
            } else if (currentY > swipeAreaWidth) return;
        }
        nativeEvent.defaultMuiPrevented = true;
        $b451cc713fab7e92$var$claimedSwipeInstance = null;
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        startMaybeSwiping();
    });
    $b451cc713fab7e92$var$React.useEffect(()=>{
        if (variant === 'temporary') {
            const doc = (0, $b451cc713fab7e92$var$_ownerDocument.default)(paperRef.current);
            doc.addEventListener('touchstart', handleBodyTouchStart);
            // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
            // It only needs to prevent scrolling on the drawer's content when open.
            // When closed, the overlay prevents scrolling.
            doc.addEventListener('touchmove', handleBodyTouchMove, {
                passive: !open
            });
            doc.addEventListener('touchend', handleBodyTouchEnd);
            return ()=>{
                doc.removeEventListener('touchstart', handleBodyTouchStart);
                doc.removeEventListener('touchmove', handleBodyTouchMove, {
                    passive: !open
                });
                doc.removeEventListener('touchend', handleBodyTouchEnd);
            };
        }
        return undefined;
    }, [
        variant,
        open,
        handleBodyTouchStart,
        handleBodyTouchMove,
        handleBodyTouchEnd
    ]);
    $b451cc713fab7e92$var$React.useEffect(()=>()=>{
            // We need to release the lock.
            if ($b451cc713fab7e92$var$claimedSwipeInstance === swipeInstance.current) $b451cc713fab7e92$var$claimedSwipeInstance = null;
        }, []);
    $b451cc713fab7e92$var$React.useEffect(()=>{
        if (!open) setMaybeSwiping(false);
    }, [
        open
    ]);
    const [SwipeAreaSlot, swipeAreaSlotProps] = (0, $b451cc713fab7e92$var$_useSlot.default)('swipeArea', {
        ref: swipeAreaRef,
        elementType: $b451cc713fab7e92$var$_SwipeArea.default,
        ownerState: props,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                swipeArea: SwipeAreaProps,
                ...slotProps
            }
        },
        additionalProps: {
            width: swipeAreaWidth,
            anchor: anchor
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b451cc713fab7e92$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b451cc713fab7e92$var$_Drawer.default, {
                open: variant === 'temporary' && maybeSwiping ? true : open,
                variant: variant,
                ModalProps: {
                    BackdropProps: {
                        ...BackdropProps,
                        ref: backdropRef
                    },
                    // Ensures that paperRef.current will be defined inside the touch start event handler
                    // See https://github.com/mui/material-ui/issues/30414 for more information
                    ...variant === 'temporary' && {
                        keepMounted: true
                    },
                    ...ModalPropsProp
                },
                hideBackdrop: hideBackdrop,
                anchor: anchor,
                transitionDuration: calculatedDurationRef.current || transitionDuration,
                onClose: onClose,
                ref: ref,
                slots: slots,
                slotProps: {
                    ...slotProps,
                    backdrop: (0, $hGPki.mergeSlotProps)(slotProps.backdrop ?? BackdropProps, {
                        ref: backdropRef
                    }),
                    paper: (0, $hGPki.mergeSlotProps)(slotProps.paper ?? PaperProps, {
                        style: {
                            pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
                        },
                        ref: handleRef
                    })
                },
                ...other
            }),
            !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/ (0, $ayMG0.jsx)($b451cc713fab7e92$var$_NoSsr.default, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(SwipeAreaSlot, {
                    ...swipeAreaSlotProps
                })
            })
        ]
    });
});
var $b451cc713fab7e92$var$_default = module.exports.default = $b451cc713fab7e92$var$SwipeableDrawer;

});
parcelRegister("gQeSR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c42d0c4e6d0277b4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c42d0c4e6d0277b4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c42d0c4e6d0277b4$var$React = $c42d0c4e6d0277b4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c42d0c4e6d0277b4$var$_propTypes = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c42d0c4e6d0277b4$var$_clsx = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("9QePP")));

var $aAbgT = parcelRequire("aAbgT");

var $c42d0c4e6d0277b4$var$_memoTheme = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $c42d0c4e6d0277b4$var$_rootShouldForwardProp = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $c42d0c4e6d0277b4$var$_capitalize = $c42d0c4e6d0277b4$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $2Ed4H = parcelRequire("2Ed4H");

var $ayMG0 = parcelRequire("ayMG0");
const $c42d0c4e6d0277b4$var$SwipeAreaRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiSwipeArea',
    shouldForwardProp: $c42d0c4e6d0277b4$var$_rootShouldForwardProp.default
})((0, $c42d0c4e6d0277b4$var$_memoTheme.default)(({ theme: theme })=>({
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.drawer - 1,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    right: 'auto'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    bottom: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    bottom: 0,
                    right: 0
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ const $c42d0c4e6d0277b4$var$SwipeArea = /*#__PURE__*/ $c42d0c4e6d0277b4$var$React.forwardRef(function SwipeArea(props, ref) {
    const { anchor: anchor, classes: classes = {}, className: className, width: width, style: style, ...other } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c42d0c4e6d0277b4$var$SwipeAreaRoot, {
        className: (0, $c42d0c4e6d0277b4$var$_clsx.default)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, $c42d0c4e6d0277b4$var$_capitalize.default)(anchor)}`], className),
        ref: ref,
        style: {
            [(0, $2Ed4H.isHorizontal)(anchor) ? 'width' : 'height']: width,
            ...style
        },
        ownerState: ownerState,
        ...other
    });
});
var $c42d0c4e6d0277b4$var$_default = module.exports.default = $c42d0c4e6d0277b4$var$SwipeArea;

});



parcelRegister("7fYtl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5488d7a1a9461c14$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5488d7a1a9461c14$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5488d7a1a9461c14$var$_exportNames = {
    tableFooterClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5488d7a1a9461c14$var$_TableFooter.default;
    }
});
Object.defineProperty(module.exports, "tableFooterClasses", {
    enumerable: true,
    get: function() {
        return $5488d7a1a9461c14$var$_tableFooterClasses.default;
    }
});

var $5488d7a1a9461c14$var$_TableFooter = $5488d7a1a9461c14$require$_interopRequireDefault((parcelRequire("lUd3q")));

var $5488d7a1a9461c14$var$_tableFooterClasses = $5488d7a1a9461c14$require$_interopRequireWildcard((parcelRequire("j1Zxr")));
Object.keys($5488d7a1a9461c14$var$_tableFooterClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5488d7a1a9461c14$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5488d7a1a9461c14$var$_tableFooterClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5488d7a1a9461c14$var$_tableFooterClasses[key];
        }
    });
});

});
parcelRegister("lUd3q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ff28f43fd0d3e223$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ff28f43fd0d3e223$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff28f43fd0d3e223$var$React = $ff28f43fd0d3e223$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ff28f43fd0d3e223$var$_propTypes = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ff28f43fd0d3e223$var$_clsx = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ff28f43fd0d3e223$var$_composeClasses = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ff28f43fd0d3e223$var$_Tablelvl2Context = $ff28f43fd0d3e223$require$_interopRequireDefault((parcelRequire("RbMj7")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $j1Zxr = parcelRequire("j1Zxr");

var $ayMG0 = parcelRequire("ayMG0");
const $ff28f43fd0d3e223$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $ff28f43fd0d3e223$var$_composeClasses.default)(slots, $j1Zxr.getTableFooterUtilityClass, classes);
};
const $ff28f43fd0d3e223$var$TableFooterRoot = (0, $aAbgT.styled)('tfoot', {
    name: 'MuiTableFooter',
    slot: 'Root'
})({
    display: 'table-footer-group'
});
const $ff28f43fd0d3e223$var$tablelvl2 = {
    variant: 'footer'
};
const $ff28f43fd0d3e223$var$defaultComponent = 'tfoot';
const $ff28f43fd0d3e223$var$TableFooter = /*#__PURE__*/ $ff28f43fd0d3e223$var$React.forwardRef(function TableFooter(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableFooter'
    });
    const { className: className, component: component = $ff28f43fd0d3e223$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $ff28f43fd0d3e223$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ff28f43fd0d3e223$var$_Tablelvl2Context.default.Provider, {
        value: $ff28f43fd0d3e223$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ff28f43fd0d3e223$var$TableFooterRoot, {
            as: component,
            className: (0, $ff28f43fd0d3e223$var$_clsx.default)(classes.root, className),
            ref: ref,
            role: component === $ff28f43fd0d3e223$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $ff28f43fd0d3e223$var$_default = module.exports.default = $ff28f43fd0d3e223$var$TableFooter;

});
parcelRegister("j1Zxr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ddadd89367698db0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableFooterUtilityClass = $ddadd89367698db0$var$getTableFooterUtilityClass;

var $ddadd89367698db0$var$_generateUtilityClasses = $ddadd89367698db0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ddadd89367698db0$var$_generateUtilityClass = $ddadd89367698db0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $ddadd89367698db0$var$getTableFooterUtilityClass(slot) {
    return (0, $ddadd89367698db0$var$_generateUtilityClass.default)('MuiTableFooter', slot);
}
const $ddadd89367698db0$var$tableFooterClasses = (0, $ddadd89367698db0$var$_generateUtilityClasses.default)('MuiTableFooter', [
    'root'
]);
var $ddadd89367698db0$var$_default = module.exports.default = $ddadd89367698db0$var$tableFooterClasses;

});



parcelRegister("Zain6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0b7daf0e3c2d5146$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0b7daf0e3c2d5146$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0b7daf0e3c2d5146$var$_exportNames = {
    tableSortLabelClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0b7daf0e3c2d5146$var$_TableSortLabel.default;
    }
});
Object.defineProperty(module.exports, "tableSortLabelClasses", {
    enumerable: true,
    get: function() {
        return $0b7daf0e3c2d5146$var$_tableSortLabelClasses.default;
    }
});

var $0b7daf0e3c2d5146$var$_TableSortLabel = $0b7daf0e3c2d5146$require$_interopRequireDefault((parcelRequire("gjoVE")));

var $0b7daf0e3c2d5146$var$_tableSortLabelClasses = $0b7daf0e3c2d5146$require$_interopRequireWildcard((parcelRequire("9NhvM")));
Object.keys($0b7daf0e3c2d5146$var$_tableSortLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0b7daf0e3c2d5146$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0b7daf0e3c2d5146$var$_tableSortLabelClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0b7daf0e3c2d5146$var$_tableSortLabelClasses[key];
        }
    });
});

});
parcelRegister("gjoVE", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $be01c206ebbcc5af$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $be01c206ebbcc5af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be01c206ebbcc5af$var$_composeClasses = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $be01c206ebbcc5af$var$_clsx = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("9QePP")));

var $be01c206ebbcc5af$var$_propTypes = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $be01c206ebbcc5af$var$React = $be01c206ebbcc5af$require$_interopRequireWildcard((parcelRequire("acw62")));

var $be01c206ebbcc5af$var$_ButtonBase = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $be01c206ebbcc5af$var$_ArrowDownward = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("5egRk")));

var $aAbgT = parcelRequire("aAbgT");

var $be01c206ebbcc5af$var$_memoTheme = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $be01c206ebbcc5af$var$_capitalize = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $be01c206ebbcc5af$var$_tableSortLabelClasses = $be01c206ebbcc5af$require$_interopRequireWildcard((parcelRequire("9NhvM")));

var $be01c206ebbcc5af$var$_useSlot = $be01c206ebbcc5af$require$_interopRequireDefault((parcelRequire("6lpak")));

var $ayMG0 = parcelRequire("ayMG0");
const $be01c206ebbcc5af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            `direction${(0, $be01c206ebbcc5af$var$_capitalize.default)(direction)}`
        ],
        icon: [
            'icon',
            `iconDirection${(0, $be01c206ebbcc5af$var$_capitalize.default)(direction)}`
        ]
    };
    return (0, $be01c206ebbcc5af$var$_composeClasses.default)(slots, $be01c206ebbcc5af$var$_tableSortLabelClasses.getTableSortLabelUtilityClass, classes);
};
const $be01c206ebbcc5af$var$TableSortLabelRoot = (0, $aAbgT.styled)($be01c206ebbcc5af$var$_ButtonBase.default, {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})((0, $be01c206ebbcc5af$var$_memoTheme.default)(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${$be01c206ebbcc5af$var$_tableSortLabelClasses.default.icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${$be01c206ebbcc5af$var$_tableSortLabelClasses.default.active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${$be01c206ebbcc5af$var$_tableSortLabelClasses.default.icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    })));
const $be01c206ebbcc5af$var$TableSortLabelIcon = (0, $aAbgT.styled)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $be01c206ebbcc5af$var$_capitalize.default)(ownerState.direction)}`]
        ];
    }
})((0, $be01c206ebbcc5af$var$_memoTheme.default)(({ theme: theme })=>({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none',
        variants: [
            {
                props: {
                    direction: 'desc'
                },
                style: {
                    transform: 'rotate(0deg)'
                }
            },
            {
                props: {
                    direction: 'asc'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $be01c206ebbcc5af$var$TableSortLabel = /*#__PURE__*/ $be01c206ebbcc5af$var$React.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = $be01c206ebbcc5af$var$_ArrowDownward.default, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    };
    const classes = $be01c206ebbcc5af$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $be01c206ebbcc5af$var$_useSlot.default)('root', {
        elementType: $be01c206ebbcc5af$var$TableSortLabelRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $be01c206ebbcc5af$var$_clsx.default)(classes.root, className),
        ref: ref
    });
    const [IconSlot, iconProps] = (0, $be01c206ebbcc5af$var$_useSlot.default)('icon', {
        elementType: $be01c206ebbcc5af$var$TableSortLabelIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.icon
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        disableRipple: true,
        component: "span",
        ...rootProps,
        ...other,
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                as: IconComponent,
                ...iconProps
            })
        ]
    });
});
var $be01c206ebbcc5af$var$_default = module.exports.default = $be01c206ebbcc5af$var$TableSortLabel;

});
parcelRegister("5egRk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3ceb567076b478bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ceb567076b478bc$var$_createSvgIcon = $3ceb567076b478bc$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ var $3ceb567076b478bc$var$_default = module.exports.default = (0, $3ceb567076b478bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

});

parcelRegister("9NhvM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $72164616b8f12725$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTableSortLabelUtilityClass = $72164616b8f12725$var$getTableSortLabelUtilityClass;

var $72164616b8f12725$var$_generateUtilityClasses = $72164616b8f12725$require$_interopRequireDefault((parcelRequire("5nY49")));

var $72164616b8f12725$var$_generateUtilityClass = $72164616b8f12725$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $72164616b8f12725$var$getTableSortLabelUtilityClass(slot) {
    return (0, $72164616b8f12725$var$_generateUtilityClass.default)('MuiTableSortLabel', slot);
}
const $72164616b8f12725$var$tableSortLabelClasses = (0, $72164616b8f12725$var$_generateUtilityClasses.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc',
    'directionDesc',
    'directionAsc'
]);
var $72164616b8f12725$var$_default = module.exports.default = $72164616b8f12725$var$tableSortLabelClasses;

});



parcelRegister("6GVj6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4df31e56c78281ac$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $4df31e56c78281ac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4df31e56c78281ac$var$_exportNames = {
    toggleButtonGroupClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4df31e56c78281ac$var$_ToggleButtonGroup.default;
    }
});
Object.defineProperty(module.exports, "toggleButtonGroupClasses", {
    enumerable: true,
    get: function() {
        return $4df31e56c78281ac$var$_toggleButtonGroupClasses.default;
    }
});

var $4df31e56c78281ac$var$_ToggleButtonGroup = $4df31e56c78281ac$require$_interopRequireDefault((parcelRequire("9ZYXn")));

var $4df31e56c78281ac$var$_toggleButtonGroupClasses = $4df31e56c78281ac$require$_interopRequireWildcard((parcelRequire("i9RU8")));
Object.keys($4df31e56c78281ac$var$_toggleButtonGroupClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4df31e56c78281ac$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4df31e56c78281ac$var$_toggleButtonGroupClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4df31e56c78281ac$var$_toggleButtonGroupClasses[key];
        }
    });
});

});
parcelRegister("9ZYXn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7479184c3cda7f5d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7479184c3cda7f5d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7479184c3cda7f5d$var$React = $7479184c3cda7f5d$require$_interopRequireWildcard((parcelRequire("acw62")));


var $7479184c3cda7f5d$var$_propTypes = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $7479184c3cda7f5d$var$_clsx = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $7479184c3cda7f5d$var$_composeClasses = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $7479184c3cda7f5d$var$_getValidReactChildren = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("2jgfV")));

var $aAbgT = parcelRequire("aAbgT");

var $7479184c3cda7f5d$var$_memoTheme = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $7479184c3cda7f5d$var$_capitalize = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $7479184c3cda7f5d$var$_toggleButtonGroupClasses = $7479184c3cda7f5d$require$_interopRequireWildcard((parcelRequire("i9RU8")));

var $7479184c3cda7f5d$var$_ToggleButtonGroupContext = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("lOkLt")));

var $7479184c3cda7f5d$var$_ToggleButtonGroupButtonContext = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("jCUp4")));

var $7479184c3cda7f5d$var$_toggleButtonClasses = $7479184c3cda7f5d$require$_interopRequireDefault((parcelRequire("3cuAs")));

var $ayMG0 = parcelRequire("ayMG0");
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $7479184c3cda7f5d$var$_capitalize.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $7479184c3cda7f5d$var$_composeClasses.default)(slots, $7479184c3cda7f5d$var$_toggleButtonGroupClasses.getToggleButtonGroupUtilityClass, classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: styles.grouped
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: styles[`grouped${(0, $7479184c3cda7f5d$var$_capitalize.default)(ownerState.orientation)}`]
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.firstButton}`]: styles.firstButton
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton}`]: styles.lastButton
            },
            {
                [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $7479184c3cda7f5d$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: {
                        [`&.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected} + .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.firstButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}`]: {
                        [`&.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected} + .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.grouped}.${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.firstButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.lastButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled},& .${$7479184c3cda7f5d$var$_toggleButtonGroupClasses.default.middleButton}.${$7479184c3cda7f5d$var$_toggleButtonClasses.default.disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $7479184c3cda7f5d$var$React.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    };
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $7479184c3cda7f5d$var$React.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $7479184c3cda7f5d$var$React.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $7479184c3cda7f5d$var$React.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $7479184c3cda7f5d$var$_getValidReactChildren.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, {
        role: "group",
        className: (0, $7479184c3cda7f5d$var$_clsx.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$_ToggleButtonGroupContext.default.Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$_ToggleButtonGroupButtonContext.default.Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $7479184c3cda7f5d$var$_default = module.exports.default = $7479184c3cda7f5d$var$ToggleButtonGroup;

});
parcelRegister("i9RU8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d382e18949ecbd32$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToggleButtonGroupUtilityClass = $d382e18949ecbd32$var$getToggleButtonGroupUtilityClass;

var $d382e18949ecbd32$var$_generateUtilityClasses = $d382e18949ecbd32$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d382e18949ecbd32$var$_generateUtilityClass = $d382e18949ecbd32$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d382e18949ecbd32$var$getToggleButtonGroupUtilityClass(slot) {
    return (0, $d382e18949ecbd32$var$_generateUtilityClass.default)('MuiToggleButtonGroup', slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $d382e18949ecbd32$var$_generateUtilityClasses.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $d382e18949ecbd32$var$_default = module.exports.default = $d382e18949ecbd32$var$toggleButtonGroupClasses;

});



parcelRegister("18tt9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0d3d65c0582fd03d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8h4LK = parcelRequire("8h4LK");

var $0d3d65c0582fd03d$var$_identifier = $0d3d65c0582fd03d$require$_interopRequireDefault((parcelRequire("4jPsi")));
const $0d3d65c0582fd03d$var$useMediaQuery = (0, $8h4LK.unstable_createUseMediaQuery)({
    themeId: $0d3d65c0582fd03d$var$_identifier.default
});
var $0d3d65c0582fd03d$var$_default = module.exports.default = $0d3d65c0582fd03d$var$useMediaQuery;

});

parcelRegister("dL2y2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a041a41a6f25c19c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a041a41a6f25c19c$var$_useScrollTrigger.default;
    }
});

var $a041a41a6f25c19c$var$_useScrollTrigger = $a041a41a6f25c19c$require$_interopRequireDefault((parcelRequire("e0QfK")));

});
parcelRegister("e0QfK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a3399924514ccab2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a3399924514ccab2$var$useScrollTrigger;

var $a3399924514ccab2$var$React = $a3399924514ccab2$require$_interopRequireWildcard((parcelRequire("acw62")));
function $a3399924514ccab2$var$defaultTrigger(store, options) {
    const { disableHysteresis: disableHysteresis = false, threshold: threshold = 100, target: target } = options;
    const previous = store.current;
    if (target) // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
    if (!disableHysteresis && previous !== undefined) {
        if (store.current < previous) return false;
    }
    return store.current > threshold;
}
const $a3399924514ccab2$var$defaultTarget = typeof window !== 'undefined' ? window : null;
function $a3399924514ccab2$var$useScrollTrigger(options = {}) {
    const { getTrigger: getTrigger = $a3399924514ccab2$var$defaultTrigger, target: target = $a3399924514ccab2$var$defaultTarget, ...other } = options;
    const store = $a3399924514ccab2$var$React.useRef();
    const [trigger, setTrigger] = $a3399924514ccab2$var$React.useState(()=>getTrigger(store, other));
    $a3399924514ccab2$var$React.useEffect(()=>{
        if (target === null) return setTrigger(false);
        const handleScroll = ()=>{
            setTrigger(getTrigger(store, {
                target: target,
                ...other
            }));
        };
        handleScroll(); // Re-evaluate trigger when dependencies change
        target.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return ()=>{
            target.removeEventListener('scroll', handleScroll, {
                passive: true
            });
        };
    // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        getTrigger,
        JSON.stringify(other)
    ]);
    return trigger;
}

});


parcelRegister("e9Nv0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a4e84d7603b01204$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a4e84d7603b01204$var$_generateUtilityClass.default;
    }
});

var $a4e84d7603b01204$var$_generateUtilityClass = $a4e84d7603b01204$require$_interopRequireDefault((parcelRequire("b14cZ")));

});

parcelRegister("c2K5x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8c496c244c450de4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8c496c244c450de4$var$_generateUtilityClasses.default;
    }
});

var $8c496c244c450de4$var$_generateUtilityClasses = $8c496c244c450de4$require$_interopRequireDefault((parcelRequire("5nY49")));

});

parcelRegister("ePguI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = module.exports.prerelease = module.exports.patch = module.exports.minor = module.exports.major = module.exports.default = void 0;
const $acb29f90a3f05c5b$var$version = module.exports.version = "7.3.9";
const $acb29f90a3f05c5b$var$major = module.exports.major = Number("7");
const $acb29f90a3f05c5b$var$minor = module.exports.minor = Number("3");
const $acb29f90a3f05c5b$var$patch = module.exports.patch = Number("9");
const $acb29f90a3f05c5b$var$prerelease = module.exports.prerelease = undefined;
var $acb29f90a3f05c5b$var$_default = module.exports.default = $acb29f90a3f05c5b$var$version;

});

parcelRegister("2bNdG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1982c9dba5dbf858$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1982c9dba5dbf858$var$_InitColorSchemeScript.default;
    }
});

var $1982c9dba5dbf858$var$_InitColorSchemeScript = $1982c9dba5dbf858$require$_interopRequireDefault((parcelRequire("3K3i6")));

});




parcelRegister("gxtOa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de278e44e570870a$var$SensorStatus;

var $de278e44e570870a$var$_Box = $de278e44e570870a$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $de278e44e570870a$var$_Typography = $de278e44e570870a$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $de278e44e570870a$var$_SensorStatusTable = $de278e44e570870a$var$_interopRequireDefault((parcelRequire("fRfYg")));

var $ayMG0 = parcelRequire("ayMG0");
function $de278e44e570870a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $de278e44e570870a$var$SensorStatus({ isAdmin: isAdmin }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($de278e44e570870a$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            height: '100vh',
            width: '75vw',
            margin: '0 auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($de278e44e570870a$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($de278e44e570870a$var$_Typography.default, {
                    sx: {
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 20,
                        fontWeight: 600,
                        color: 'var(--color-text-primary)'
                    },
                    children: "Sensor Status"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($de278e44e570870a$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.25rem 1.5rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($de278e44e570870a$var$_SensorStatusTable.default, {
                    isAdmin: isAdmin
                })
            })
        ]
    });
}

});
parcelRegister("fRfYg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9be048ca8a8e9d1a$var$SensorStatusTable;

var $9be048ca8a8e9d1a$var$React = $9be048ca8a8e9d1a$var$_interopRequireWildcard((parcelRequire("acw62")));

var $9be048ca8a8e9d1a$var$_Table = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("bGe9g")));

var $9be048ca8a8e9d1a$var$_TableBody = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("5hLrb")));

var $9be048ca8a8e9d1a$var$_TableCell = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("hjoMW")));

var $9be048ca8a8e9d1a$var$_TableContainer = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("12YAp")));

var $9be048ca8a8e9d1a$var$_TableHead = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("g2Lhl")));

var $9be048ca8a8e9d1a$var$_TableRow = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("7IILB")));

var $9be048ca8a8e9d1a$var$_CircularProgress = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("1sBf1")));

var $9be048ca8a8e9d1a$var$_Box = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $9be048ca8a8e9d1a$var$_Typography = $9be048ca8a8e9d1a$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $3u6kV = parcelRequire("3u6kV");

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $9be048ca8a8e9d1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $9be048ca8a8e9d1a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9be048ca8a8e9d1a$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const $9be048ca8a8e9d1a$var$headCellSx = {
    fontFamily: "'Syne', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: '#ffffff !important',
    background: '#1D9E75 !important',
    borderBottom: 'none',
    py: 1.25
};
const $9be048ca8a8e9d1a$var$bodyCellSx = {
    fontFamily: "'DM Mono', monospace",
    fontSize: 13,
    color: 'var(--color-text-primary)',
    borderBottom: '1px solid rgba(255,255,255,0.04)',
    py: 1.25,
    background: 'transparent'
};
function $9be048ca8a8e9d1a$var$StatusDot({ online: online }) {
    if (online === null) return /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_CircularProgress.default, {
        size: 12,
        sx: {
            color: '#1D9E75'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_Box.default, {
        sx: {
            display: 'inline-block',
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: online ? '#1D9E75' : '#993C1D',
            boxShadow: online ? '0 0 6px rgba(29,158,117,0.7)' : '0 0 6px rgba(153,60,29,0.5)'
        }
    });
}
function $9be048ca8a8e9d1a$var$SensorStatusTable({ isAdmin: isAdmin }) {
    const [rows, setRows] = $9be048ca8a8e9d1a$var$React.useState([]);
    const [loading, setLoading] = $9be048ca8a8e9d1a$var$React.useState(true);
    const [error, setError] = $9be048ca8a8e9d1a$var$React.useState(null);
    const [editingId, setEditingId] = $9be048ca8a8e9d1a$var$React.useState(null);
    const [editingDesc, setEditingDesc] = $9be048ca8a8e9d1a$var$React.useState('');
    $9be048ca8a8e9d1a$var$React.useEffect(()=>{
        async function load() {
            try {
                const configs = await (0, $3u6kV.getOsmNames)();
                setRows(configs.map((c)=>({
                        id: c.id,
                        unit_id: c.unit_id,
                        serial_number: c.serial_number,
                        osm_name: c.osm_name,
                        description: c.description,
                        online: null
                    })));
                setLoading(false);
                const now = (0, $dOn5J.nowISOString)();
                const thirtyAgo = (0, $dOn5J.subtractMinutes)('30');
                await Promise.all(configs.map(async (c, i)=>{
                    try {
                        const data = await (0, $3u6kV.getData)('pg_sf_ds', 'bucket', thirtyAgo, now, 'SND', c.osm_name);
                        const online = Array.isArray(data) && data.length > 0;
                        setRows((prev)=>prev.map((r, idx)=>idx === i ? {
                                    ...r,
                                    online: online
                                } : r));
                    } catch  {
                        setRows((prev)=>prev.map((r, idx)=>idx === i ? {
                                    ...r,
                                    online: false
                                } : r));
                    }
                }));
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        }
        load();
    }, []);
    async function handleDescriptionSave(row) {
        if (editingDesc === (row.description ?? '')) {
            setEditingId(null);
            return;
        }
        try {
            await (0, $3u6kV.updateDashboardConfig)(row.id, {
                description: editingDesc
            });
            setRows((prev)=>prev.map((r)=>r.id === row.id ? {
                        ...r,
                        description: editingDesc
                    } : r));
        } catch (err) {
            console.error('Failed to update description:', err.message);
        } finally{
            setEditingId(null);
        }
    }
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_Box.default, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 4
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_CircularProgress.default, {
            size: 24,
            sx: {
                color: '#1D9E75'
            }
        })
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Typography.default, {
        sx: {
            fontFamily: "'DM Mono', monospace",
            fontSize: 12,
            color: '#993C1D'
        },
        children: [
            "Error: ",
            error
        ]
    });
    const onlineCount = rows.filter((r)=>r.online === true).length;
    const offlineCount = rows.filter((r)=>r.online === false).length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Box.default, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Box.default, {
                sx: {
                    display: 'flex',
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_Box.default, {
                                sx: {
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#1D9E75'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    color: 'var(--color-text-secondary)'
                                },
                                children: [
                                    onlineCount,
                                    " online"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_Box.default, {
                                sx: {
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#993C1D'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Typography.default, {
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    color: 'var(--color-text-secondary)'
                                },
                                children: [
                                    offlineCount,
                                    " offline"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableContainer.default, {
                sx: {
                    background: 'transparent'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_Table.default, {
                    "aria-label": "sensor status table",
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableHead.default, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_TableRow.default, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                        align: "left",
                                        sx: $9be048ca8a8e9d1a$var$headCellSx,
                                        children: "Unit ID"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                        align: "left",
                                        sx: $9be048ca8a8e9d1a$var$headCellSx,
                                        children: "Serial Number"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                        align: "left",
                                        sx: $9be048ca8a8e9d1a$var$headCellSx,
                                        children: "Location"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                        align: "left",
                                        sx: $9be048ca8a8e9d1a$var$headCellSx,
                                        children: [
                                            "Description ",
                                            isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_Typography.default, {
                                                component: "span",
                                                sx: {
                                                    fontFamily: "'DM Mono', monospace",
                                                    fontSize: 9,
                                                    color: 'var(--color-text-secondary)',
                                                    ml: 0.5
                                                },
                                                children: "(click to edit)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                        align: "center",
                                        sx: $9be048ca8a8e9d1a$var$headCellSx,
                                        children: "Status"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableBody.default, {
                            children: rows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($9be048ca8a8e9d1a$var$_TableRow.default, {
                                    sx: {
                                        '&:last-child td': {
                                            border: 0
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                            align: "left",
                                            sx: {
                                                ...$9be048ca8a8e9d1a$var$bodyCellSx,
                                                color: 'var(--color-text-secondary)'
                                            },
                                            children: row.unit_id
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                            align: "left",
                                            sx: {
                                                ...$9be048ca8a8e9d1a$var$bodyCellSx,
                                                color: 'var(--color-text-secondary)'
                                            },
                                            children: row.serial_number.slice(-3)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                            align: "left",
                                            sx: {
                                                ...$9be048ca8a8e9d1a$var$bodyCellSx,
                                                fontFamily: "'Syne', sans-serif",
                                                fontWeight: 500,
                                                fontSize: 13
                                            },
                                            children: row.osm_name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                            align: "left",
                                            sx: $9be048ca8a8e9d1a$var$bodyCellSx,
                                            children: editingId === row.id ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                autoFocus: true,
                                                value: editingDesc,
                                                onChange: (e)=>setEditingDesc(e.target.value),
                                                onBlur: ()=>handleDescriptionSave(row),
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Enter') handleDescriptionSave(row);
                                                    if (e.key === 'Escape') setEditingId(null);
                                                },
                                                style: {
                                                    width: '100%',
                                                    background: 'transparent',
                                                    border: 'none',
                                                    borderBottom: '1px solid #1D9E75',
                                                    color: 'var(--color-text-primary)',
                                                    fontFamily: "'DM Mono', monospace",
                                                    fontSize: 13,
                                                    outline: 'none',
                                                    padding: '2px 0'
                                                }
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: isAdmin ? ()=>{
                                                    setEditingId(row.id);
                                                    setEditingDesc(row.description ?? '');
                                                } : undefined,
                                                title: isAdmin ? 'Click to edit' : undefined,
                                                style: {
                                                    cursor: isAdmin ? 'pointer' : 'default',
                                                    display: 'block',
                                                    minHeight: '1.5em',
                                                    color: row.description ? 'var(--color-text-primary)' : 'var(--color-text-secondary)'
                                                },
                                                children: row.description ?? "\u2014"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$_TableCell.default, {
                                            align: "center",
                                            sx: $9be048ca8a8e9d1a$var$bodyCellSx,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9be048ca8a8e9d1a$var$StatusDot, {
                                                online: row.online
                                            })
                                        })
                                    ]
                                }, row.serial_number))
                        })
                    ]
                })
            })
        ]
    });
}

});


parcelRegister("lGscg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2acf3abae22f8a4$var$DashboardList;

var $a2acf3abae22f8a4$var$_Box = $a2acf3abae22f8a4$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $a2acf3abae22f8a4$var$_Typography = $a2acf3abae22f8a4$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $a2acf3abae22f8a4$var$_DashboardNavigation = $a2acf3abae22f8a4$var$_interopRequireDefault((parcelRequire("aj05N")));

var $ayMG0 = parcelRequire("ayMG0");
function $a2acf3abae22f8a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $a2acf3abae22f8a4$var$DashboardList() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a2acf3abae22f8a4$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            height: '100vh',
            width: '75vw',
            margin: '0 auto'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a2acf3abae22f8a4$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a2acf3abae22f8a4$var$_Typography.default, {
                    sx: {
                        fontFamily: "'Syne', sans-serif",
                        fontSize: 20,
                        fontWeight: 600,
                        color: '#1D9E75',
                        mb: 3
                    },
                    children: "Dashboard List"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a2acf3abae22f8a4$var$_DashboardNavigation.default, {})
        ]
    });
}

});
parcelRegister("aj05N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e01735b24951478e$var$DashboardNavigation;

var $jYLYD = parcelRequire("jYLYD");

var $e01735b24951478e$var$_DashboardLink = $e01735b24951478e$var$_interopRequireDefault((parcelRequire("4YUUk")));

var $e01735b24951478e$var$_Box = $e01735b24951478e$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $e01735b24951478e$var$_CircularProgress = $e01735b24951478e$var$_interopRequireDefault((parcelRequire("1sBf1")));

var $ayMG0 = parcelRequire("ayMG0");
function $e01735b24951478e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $e01735b24951478e$var$DashboardNavigation() {
    const { data: sensorList, loading: loading } = (0, $jYLYD.useOsmNames)();
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($e01735b24951478e$var$_Box.default, {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 4
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e01735b24951478e$var$_CircularProgress.default, {
            size: 24,
            sx: {
                color: '#1D9E75'
            }
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e01735b24951478e$var$_Box.default, {
        className: "dl-grid",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($e01735b24951478e$var$_DashboardLink.default, {
                title: "Overview",
                linkto: "overview"
            }),
            sensorList.map((sensor)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e01735b24951478e$var$_DashboardLink.default, {
                    title: sensor.description?.trim() || sensor.osm_name,
                    linkto: sensor.osm_name
                }, sensor.osm_name))
        ]
    });
}

});
parcelRegister("jYLYD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOsmNames = $937b9f7168d1520a$var$useOsmNames;

var $acw62 = parcelRequire("acw62");

var $3u6kV = parcelRequire("3u6kV");
function $937b9f7168d1520a$var$useOsmNames() {
    const [data, setData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        async function load() {
            try {
                const result = await (0, $3u6kV.getOsmNames)();
                setData(result);
            } catch (err) {
                setError(err);
            } finally{
                setLoading(false);
            }
        }
        load();
    }, []);
    return {
        data: data,
        loading: loading,
        error: error
    };
}

});



parcelRegister("SqHyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e83a5aebfede85a4$var$OverviewDashboard;

var $acw62 = parcelRequire("acw62");

var $jYLYD = parcelRequire("jYLYD");

var $e83a5aebfede85a4$var$_OperationalOverview = $e83a5aebfede85a4$var$_interopRequireDefault((parcelRequire("bXkNT")));

var $ayMG0 = parcelRequire("ayMG0");
function $e83a5aebfede85a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $e83a5aebfede85a4$var$siteLabel(site) {
    if (site.description?.trim()) return site.description.trim();
    return site.osm_name;
}
const $e83a5aebfede85a4$var$DEFAULT_TARGETS = [
    {
        id: 'electricity',
        label: 'Electricity budget',
        current: 1024,
        target: 1400,
        unit: 'kWh',
        color: '#1D9E75'
    },
    {
        id: 'gas',
        label: 'Gas allowance',
        current: 486,
        target: 600,
        unit: "m\xb3",
        color: '#BA7517'
    },
    {
        id: 'cost',
        label: 'Total cost cap',
        current: 544,
        target: 800,
        unit: "\xa3",
        prefix: "\xa3",
        color: '#D4537E'
    },
    {
        id: 'carbon',
        label: 'Carbon reduction',
        current: 88,
        target: 200,
        unit: "kg CO\u2082 saved",
        color: '#378ADD'
    }
];
const $e83a5aebfede85a4$var$selectStyle = {
    fontFamily: "'DM Mono', monospace",
    fontSize: 12,
    padding: '5px 10px',
    borderRadius: 8,
    border: '0.5px solid var(--color-border-primary, rgba(0,0,0,0.2))',
    background: 'var(--color-bg-primary, #fff)',
    color: 'var(--color-text-primary, #2C2C2A)',
    cursor: 'pointer'
};
function $e83a5aebfede85a4$var$OverviewDashboard() {
    const { data: siteList, loading: sitesLoading } = (0, $jYLYD.useOsmNames)();
    const [selectedOsmName, setSelectedOsmName] = (0, $acw62.useState)('');
    const effectiveOsmName = selectedOsmName || siteList?.[0]?.osm_name || '';
    const config = (0, $acw62.useMemo)(()=>siteList?.find((s)=>s.osm_name === effectiveOsmName) ?? null, [
        siteList,
        effectiveOsmName
    ]);
    if (sitesLoading) return null;
    if (!siteList?.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                fontFamily: "'DM Mono', monospace",
                fontSize: 13,
                color: 'var(--color-text-secondary, #5F5E5A)'
            },
            children: "No sites configured. Add a site in Dashboard Config to get started."
        })
    });
    const siteSelector = siteList.length > 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
        value: effectiveOsmName,
        onChange: (e)=>setSelectedOsmName(e.target.value),
        style: $e83a5aebfede85a4$var$selectStyle,
        "aria-label": "Select site",
        children: siteList.map((site)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                value: site.osm_name,
                children: $e83a5aebfede85a4$var$siteLabel(site)
            }, site.osm_name))
    }) : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e83a5aebfede85a4$var$_OperationalOverview.default, {
        osmName: effectiveOsmName,
        config: config,
        siteSelector: siteSelector
    });
}

});
parcelRegister("bXkNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdfc2171f8318eea$var$OperationalOverview;

var $cdfc2171f8318eea$var$_react = $cdfc2171f8318eea$var$_interopRequireWildcard((parcelRequire("acw62")));

var $71dm2 = parcelRequire("71dm2");

var $cdfc2171f8318eea$var$_KpiCard = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("18InM")));

var $cdfc2171f8318eea$var$_EnergyChart = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("9X56V")));

var $cdfc2171f8318eea$var$_CostBreakdown = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("iSEYE")));

var $cdfc2171f8318eea$var$_AirQualityPanel = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("4xUFd")));

var $cdfc2171f8318eea$var$_VibrationPanel = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("3zuzE")));

var $cdfc2171f8318eea$var$_AlertsFeed = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("fN3T3")));

var $cdfc2171f8318eea$var$_TargetsPanel = $cdfc2171f8318eea$var$_interopRequireDefault((parcelRequire("aR930")));

var $ayMG0 = parcelRequire("ayMG0");
function $cdfc2171f8318eea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $cdfc2171f8318eea$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($cdfc2171f8318eea$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const $cdfc2171f8318eea$var$KPI_LABELS = {
    electricity: 'Electricity',
    gas: 'Gas',
    water: 'Water',
    cost: 'Cost'
};
function $cdfc2171f8318eea$var$LiveBadge() {
    const [time, setTime] = (0, $cdfc2171f8318eea$var$_react.useState)('');
    (0, $cdfc2171f8318eea$var$_react.useEffect)(()=>{
        const fmt = ()=>new Date().toLocaleString('en-GB', {
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                hour: '2-digit',
                minute: '2-digit'
            });
        setTime(fmt());
        const id = setInterval(()=>setTime(fmt()), 30000);
        return ()=>clearInterval(id);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("time", {
                style: $cdfc2171f8318eea$var$styles.liveTime,
                children: time
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                style: $cdfc2171f8318eea$var$styles.liveBadge,
                "aria-label": "Live data",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $cdfc2171f8318eea$var$styles.liveDot,
                        "aria-hidden": "true"
                    }),
                    "Live"
                ]
            })
        ]
    });
}
function $cdfc2171f8318eea$var$LoadingState() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $cdfc2171f8318eea$var$styles.stateWrap,
        "aria-busy": "true",
        "aria-label": "Loading dashboard",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: $cdfc2171f8318eea$var$styles.spinner
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $cdfc2171f8318eea$var$styles.stateText,
                children: "Loading dashboard\u2026"
            })
        ]
    });
}
function $cdfc2171f8318eea$var$ErrorState({ message: message, onRetry: onRetry }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $cdfc2171f8318eea$var$styles.stateWrap,
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                className: "ti ti-alert-triangle",
                "aria-hidden": "true",
                style: {
                    fontSize: 24,
                    color: '#BA7517'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $cdfc2171f8318eea$var$styles.stateText,
                children: message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: onRetry,
                style: $cdfc2171f8318eea$var$styles.retryBtn,
                children: "Retry"
            })
        ]
    });
}
function $cdfc2171f8318eea$var$OperationalOverview({ osmName: osmName, config: config, siteSelector: siteSelector }) {
    const { period: period, setPeriod: setPeriod, data: data, loading: loading, error: error, refetch: refetch } = (0, $71dm2.useDashboard)({
        osmName: osmName,
        config: config
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        style: $cdfc2171f8318eea$var$styles.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "sr-only",
                children: "Skylight \u2014 Operational Overview"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                style: $cdfc2171f8318eea$var$styles.header,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                style: $cdfc2171f8318eea$var$styles.heading,
                                children: "Overview"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$LiveBadge, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            siteSelector,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                value: period,
                                onChange: (e)=>setPeriod(e.target.value),
                                style: $cdfc2171f8318eea$var$styles.periodSelect,
                                "aria-label": "Select reporting period",
                                children: $71dm2.PERIODS.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: p,
                                        children: p
                                    }, p))
                            })
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$LoadingState, {}),
            error && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$ErrorState, {
                message: error,
                onRetry: refetch
            }),
            data && !loading && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "oo-kpi-grid",
                        role: "region",
                        "aria-label": "Key performance indicators",
                        children: data.kpis.map((kpi)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_KpiCard.default, {
                                ...kpi,
                                label: $cdfc2171f8318eea$var$KPI_LABELS[kpi.id] ?? kpi.id
                            }, kpi.id))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "oo-chart-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_EnergyChart.default, {
                                series: data.series,
                                buckets: data.series.buckets
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_CostBreakdown.default, {
                                breakdown: data.costBreakdown
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "oo-bottom-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_AirQualityPanel.default, {
                                airQuality: data.airQuality
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_VibrationPanel.default, {
                                vibration: data.vibration
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_AlertsFeed.default, {
                                alerts: data.alerts
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cdfc2171f8318eea$var$_TargetsPanel.default, {
                                comparison: data.comparison,
                                prevPeriodLabel: data.prevPeriodLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $cdfc2171f8318eea$var$styles = {
    root: {
        fontFamily: "'Syne', sans-serif",
        padding: '1.5rem 1.5rem 2.5rem',
        width: '75vw',
        margin: '0 auto',
        minHeight: '100vh'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '1.5rem',
        flexWrap: 'wrap',
        gap: '0.75rem'
    },
    heading: {
        fontSize: 20,
        fontWeight: 600,
        margin: 0,
        color: 'var(--color-text-primary, #2C2C2A)'
    },
    liveTime: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 12,
        color: 'var(--color-text-secondary, #5F5E5A)'
    },
    liveBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        background: '#E1F5EE',
        color: '#0F6E56',
        fontSize: 11,
        fontWeight: 600,
        padding: '3px 10px',
        borderRadius: 20,
        fontFamily: "'DM Mono', monospace"
    },
    liveDot: {
        display: 'inline-block',
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: '#1D9E75',
        animation: 'skylight-pulse 2s infinite'
    },
    periodSelect: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 12,
        padding: '5px 10px',
        borderRadius: 8,
        border: '0.5px solid var(--color-border-primary, rgba(0,0,0,0.2))',
        background: 'var(--color-bg-primary, #fff)',
        color: 'var(--color-text-primary, #2C2C2A)',
        cursor: 'pointer'
    },
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: 10,
        marginBottom: '1rem'
    },
    chartRow: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gap: 10,
        marginBottom: 10
    },
    bottomRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: 10
    },
    stateWrap: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '4rem 0'
    },
    stateText: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 13,
        color: 'var(--color-text-secondary, #5F5E5A)',
        margin: 0
    },
    spinner: {
        width: 28,
        height: 28,
        border: '2px solid rgba(0,0,0,0.1)',
        borderTopColor: '#1D9E75',
        borderRadius: '50%',
        animation: 'skylight-spin 0.8s linear infinite'
    },
    retryBtn: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 12,
        padding: '6px 16px',
        borderRadius: 8,
        border: '0.5px solid rgba(0,0,0,0.2)',
        background: 'transparent',
        color: 'var(--color-text-primary, #2C2C2A)',
        cursor: 'pointer'
    }
};

});
parcelRegister("71dm2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PERIODS = void 0;
module.exports.useDashboard = $aa64058c595bd070$var$useDashboard;

var $acw62 = parcelRequire("acw62");

var $3u6kV = parcelRequire("3u6kV");

var $7GFR6 = parcelRequire("7GFR6");
const $aa64058c595bd070$var$PERIODS = module.exports.PERIODS = [
    'Today',
    'This week',
    'This month',
    'This year'
];
// Daily Air Quality Index (DAQI) scale, 1–10.
// https://uk-air.defra.gov.uk/air-pollution/daqi
// Overall DAQI is the max across all available particulates.
const $aa64058c595bd070$var$PM25_BREAKPOINTS = [
    {
        daqi: 1,
        max: 11
    },
    {
        daqi: 2,
        max: 23
    },
    {
        daqi: 3,
        max: 35
    },
    {
        daqi: 4,
        max: 41
    },
    {
        daqi: 5,
        max: 47
    },
    {
        daqi: 6,
        max: 53
    },
    {
        daqi: 7,
        max: 58
    },
    {
        daqi: 8,
        max: 64
    },
    {
        daqi: 9,
        max: 70
    },
    {
        daqi: 10,
        max: Infinity
    }
];
const $aa64058c595bd070$var$PM10_BREAKPOINTS = [
    {
        daqi: 1,
        max: 16
    },
    {
        daqi: 2,
        max: 33
    },
    {
        daqi: 3,
        max: 50
    },
    {
        daqi: 4,
        max: 58
    },
    {
        daqi: 5,
        max: 66
    },
    {
        daqi: 6,
        max: 75
    },
    {
        daqi: 7,
        max: 83
    },
    {
        daqi: 8,
        max: 91
    },
    {
        daqi: 9,
        max: 100
    },
    {
        daqi: 10,
        max: Infinity
    }
];
function $aa64058c595bd070$var$toDaqi(value, breakpoints) {
    return breakpoints.find((b)=>value <= b.max)?.daqi ?? 10;
}
function $aa64058c595bd070$var$daqiMeta(daqi) {
    if (daqi <= 3) return {
        band: 'Low',
        color: '#1D9E75'
    };
    if (daqi <= 6) return {
        band: 'Moderate',
        color: '#BA7517'
    };
    if (daqi <= 9) return {
        band: 'High',
        color: '#D4537E'
    };
    return {
        band: 'Very High',
        color: '#993C1D'
    };
}
function $aa64058c595bd070$var$buildAqiSummary(points) {
    if (!points.length) return {
        aqi: 0,
        status: 'No data',
        statusColor: '#888780',
        particulates: []
    };
    const latest = points[points.length - 1];
    const daqiPm25 = $aa64058c595bd070$var$toDaqi(latest.pm25, $aa64058c595bd070$var$PM25_BREAKPOINTS);
    const daqiPm10 = $aa64058c595bd070$var$toDaqi(latest.pm10, $aa64058c595bd070$var$PM10_BREAKPOINTS);
    const daqi = Math.max(daqiPm25, daqiPm10);
    const { band: band, color: statusColor } = $aa64058c595bd070$var$daqiMeta(daqi);
    return {
        aqi: daqi,
        status: `${band} (DAQI ${daqi})`,
        statusColor: statusColor,
        particulates: [
            {
                name: 'PM2.5',
                value: Math.round(latest.pm25 * 10) / 10,
                unit: "\xb5g/m\xb3",
                pct: Math.min(Math.round(latest.pm25 / 70 * 100), 100),
                color: $aa64058c595bd070$var$daqiMeta(daqiPm25).color
            },
            {
                name: 'PM10',
                value: Math.round(latest.pm10 * 10) / 10,
                unit: "\xb5g/m\xb3",
                pct: Math.min(Math.round(latest.pm10 / 100 * 100), 100),
                color: $aa64058c595bd070$var$daqiMeta(daqiPm10).color
            },
            {
                name: 'PM1',
                value: Math.round(latest.pm1 * 10) / 10,
                unit: "\xb5g/m\xb3",
                pct: Math.min(Math.round(latest.pm1 / 30 * 100), 100),
                color: '#888780'
            },
            {
                name: 'PM4',
                value: Math.round(latest.pm4 * 10) / 10,
                unit: "\xb5g/m\xb3",
                pct: Math.min(Math.round(latest.pm4 / 50 * 100), 100),
                color: '#888780'
            }
        ]
    };
}
function $aa64058c595bd070$var$buildEnergySeries(elecConsumption, gasConsumption, waterConsumption, elecCost, period) {
    const primary = elecConsumption.length > 0 ? elecConsumption : gasConsumption.length > 0 ? gasConsumption : waterConsumption;
    const labels = primary.map((p)=>(0, $7GFR6.formatBucketLabel)(p.bucket, period));
    const buckets = primary.map((p)=>p.bucket);
    const floorToHour = (b)=>{
        const d = new Date(b);
        d.setMinutes(0, 0, 0);
        return d.toISOString().slice(0, 13);
    };
    const elecByBucket = new Map(elecConsumption.map((p)=>[
            floorToHour(p.bucket),
            Math.round(p.consumption * 10) / 10
        ]));
    const gasByBucket = new Map(gasConsumption.map((p)=>[
            floorToHour(p.bucket),
            Math.round(p.consumption * 10) / 10
        ]));
    const waterByBucket = new Map(waterConsumption.map((p)=>[
            floorToHour(p.bucket),
            Math.round(p.consumption * 10) / 10
        ]));
    const costByBucket = new Map(elecCost.map((p)=>[
            floorToHour(p.bucket),
            Math.round(p.cost_gbp * 100) / 100
        ]));
    const electricity = primary.map((p)=>elecByBucket.get(floorToHour(p.bucket)) ?? null);
    const gas = primary.map((p)=>gasByBucket.get(floorToHour(p.bucket)) ?? null);
    const water = primary.map((p)=>waterByBucket.get(floorToHour(p.bucket)) ?? null);
    const cost = primary.map((p)=>costByBucket.get(floorToHour(p.bucket)) ?? null);
    return {
        labels: labels,
        buckets: buckets,
        electricity: electricity,
        gas: gas,
        water: water,
        cost: cost
    };
}
function $aa64058c595bd070$var$totalCost(points) {
    return Math.round(points.reduce((s, p)=>s + p.cost_gbp, 0) * 100) / 100;
}
function $aa64058c595bd070$var$totalConsumption(points) {
    return Math.round(points.reduce((s, p)=>s + p.consumption, 0) * 10) / 10;
}
function $aa64058c595bd070$var$vibrationStatus(value) {
    if (value < 2.8) return {
        status: 'Good',
        color: '#1D9E75'
    };
    if (value < 7.1) return {
        status: 'Unsatisfactory',
        color: '#BA7517'
    };
    if (value < 18.0) return {
        status: 'Dangerous',
        color: '#D4537E'
    };
    return {
        status: 'Unacceptable',
        color: '#993C1D'
    };
}
function $aa64058c595bd070$var$buildVibrationSummary(points, period) {
    if (!points.length) return {
        hasData: false,
        gauges: [],
        series: {
            labels: [],
            buckets: [],
            zrv1: [],
            xrv1: [],
            zpv1: [],
            xpv1: []
        }
    };
    const latest = points[points.length - 1];
    const rnd = (v)=>Math.round(v * 100) / 100;
    const overallRms = rnd((latest.zrv1 + latest.xrv1) / 2);
    const peakVel = rnd(Math.max(latest.zpv1, latest.xpv1));
    const rmsStatus = $aa64058c595bd070$var$vibrationStatus(overallRms);
    const peakStatus = $aa64058c595bd070$var$vibrationStatus(peakVel);
    const gauges = [
        {
            label: 'Overall RMS',
            value: overallRms,
            max: 20,
            status: rmsStatus.status,
            statusColor: rmsStatus.color
        },
        {
            label: 'Peak Velocity',
            value: peakVel,
            max: 20,
            status: peakStatus.status,
            statusColor: peakStatus.color
        }
    ];
    const labels = points.map((p)=>(0, $7GFR6.formatBucketLabel)(p.bucket, period));
    const buckets = points.map((p)=>p.bucket);
    return {
        hasData: true,
        gauges: gauges,
        series: {
            labels: labels,
            buckets: buckets,
            zrv1: points.map((p)=>rnd(p.zrv1)),
            xrv1: points.map((p)=>rnd(p.xrv1)),
            zpv1: points.map((p)=>rnd(p.zpv1)),
            xpv1: points.map((p)=>rnd(p.xpv1))
        }
    };
}
function $aa64058c595bd070$var$mapAlerts(rawAlerts) {
    return rawAlerts.map((a)=>{
        const isBreaching = !!a.alert_state?.breaching_since;
        const isSilenced = a.silenced_until && new Date(a.silenced_until) > new Date();
        const type = !a.is_active || isSilenced ? 'ok' : isBreaching ? 'warn' : 'info';
        const breachingSince = a.alert_state?.breaching_since ? new Date(a.alert_state.breaching_since).toLocaleString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            day: 'numeric',
            month: 'short'
        }) : null;
        const message = isBreaching ? `${a.name} \u{2014} breaching` : isSilenced ? `${a.name} \u{2014} silenced until ${new Date(a.silenced_until).toLocaleString('en-GB', {
            hour: '2-digit',
            minute: '2-digit'
        })}` : `${a.name} \u{2014} dormant`;
        return {
            id: a.id,
            type: type,
            message: message,
            time: breachingSince ?? 'active'
        };
    });
}
function $aa64058c595bd070$var$useDashboard({ osmName: osmName, config: config, refreshMs: refreshMs = 60000 }) {
    const [period, setPeriod] = (0, $acw62.useState)('This week');
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const abortRef = (0, $acw62.useRef)(null);
    const fetchAll = (0, $acw62.useCallback)(async ()=>{
        if (!osmName) return;
        abortRef.current?.abort();
        abortRef.current = new AbortController();
        setLoading(true);
        setError(null);
        const { from: from, to: to } = (0, $7GFR6.getDateRange)(period);
        const { from: prevFrom, to: prevTo } = (0, $7GFR6.getPrevDateRange)(period);
        const prevLabel = (0, $7GFR6.prevPeriodLabel)(period);
        try {
            // Fetch channels for this site
            const channels = config?.id ? await (0, $3u6kV.getChannels)(config.id).catch(()=>[]) : [];
            const gasChannels = channels.filter((c)=>c.type === 'gas');
            const waterChannels = channels.filter((c)=>c.type === 'water');
            // Fetch electricity and common data
            const [elecCost, elecConsumptionRaw, airQualityPoints, vibrationPoints, rawAlerts, prevElecCost, prevElecConsumptionRaw] = await Promise.all([
                (0, $3u6kV.getElectricityCost)(osmName, from, to).catch(()=>[]),
                (0, $3u6kV.getImportConsumption)(osmName, from, to).catch(()=>[]),
                (0, $3u6kV.getAirQuality)(osmName, from, to).catch(()=>[]),
                (0, $3u6kV.getVibration)(osmName, from, to).catch(()=>[]),
                (0, $3u6kV.getAlertStatuses)().catch(()=>[]),
                (0, $3u6kV.getElectricityCost)(osmName, prevFrom, prevTo).catch(()=>[]),
                (0, $3u6kV.getImportConsumption)(osmName, prevFrom, prevTo).catch(()=>[])
            ]);
            // Fetch all gas channels and sum results
            const gasResults = await Promise.all(gasChannels.map((c)=>Promise.all([
                    (0, $3u6kV.getGasCost)(osmName, from, to, c.channel, c.pulse_div, c.calorific_kwh ?? 11.1354133333).catch(()=>[]),
                    (0, $3u6kV.getPulseConsumption)(osmName, from, to, c.channel, c.pulse_div).catch(()=>[]),
                    (0, $3u6kV.getGasCost)(osmName, prevFrom, prevTo, c.channel, c.pulse_div, c.calorific_kwh ?? 11.1354133333).catch(()=>[]),
                    (0, $3u6kV.getPulseConsumption)(osmName, prevFrom, prevTo, c.channel, c.pulse_div).catch(()=>[])
                ])));
            // Fetch all water channels and sum results
            const waterResults = await Promise.all(waterChannels.map((c)=>Promise.all([
                    (0, $3u6kV.getWaterCost)(osmName, from, to, c.channel, c.pulse_div).catch(()=>[]),
                    (0, $3u6kV.getPulseConsumption)(osmName, from, to, c.channel, c.pulse_div).catch(()=>[]),
                    (0, $3u6kV.getWaterCost)(osmName, prevFrom, prevTo, c.channel, c.pulse_div).catch(()=>[]),
                    (0, $3u6kV.getPulseConsumption)(osmName, prevFrom, prevTo, c.channel, c.pulse_div).catch(()=>[])
                ])));
            // Sum gas results across all channels
            const gasCostPoints = gasResults.flatMap((r)=>r[0]);
            const gasConsumption = gasResults.flatMap((r)=>r[1]);
            const prevGasCostPoints = gasResults.flatMap((r)=>r[2]);
            const prevGasConsumption = gasResults.flatMap((r)=>r[3]);
            // Sum water results across all channels
            const waterCostPoints = waterResults.flatMap((r)=>r[0]);
            const waterConsumption = waterResults.flatMap((r)=>r[1]);
            const prevWaterCostPoints = waterResults.flatMap((r)=>r[2]);
            const prevWaterConsumption = waterResults.flatMap((r)=>r[3]);
            // Fall back to getElectricityKwh if the sensor doesn't support import consumption
            const elecConsumption = elecConsumptionRaw.length > 0 ? elecConsumptionRaw : (await (0, $3u6kV.getElectricityKwh)(osmName, from, to).catch(()=>[])).map((p)=>({
                    bucket: p.bucket,
                    consumption: p.kwh ?? p.consumption ?? 0
                }));
            const prevElecConsumption = prevElecConsumptionRaw.length > 0 ? prevElecConsumptionRaw : (await (0, $3u6kV.getElectricityKwh)(osmName, prevFrom, prevTo).catch(()=>[])).map((p)=>({
                    bucket: p.bucket,
                    consumption: p.kwh ?? p.consumption ?? 0
                }));
            const elecTotal = $aa64058c595bd070$var$totalCost(elecCost);
            const gasTotal = $aa64058c595bd070$var$totalCost(gasCostPoints);
            const waterTotal = $aa64058c595bd070$var$totalCost(waterCostPoints);
            const grandTotal = Math.round((elecTotal + gasTotal + waterTotal) * 100) / 100;
            const prevElecTotal = $aa64058c595bd070$var$totalCost(prevElecCost);
            const prevGasTotal = $aa64058c595bd070$var$totalCost(prevGasCostPoints);
            const prevWaterTotal = $aa64058c595bd070$var$totalCost(prevWaterCostPoints);
            const prevGrandTotal = Math.round((prevElecTotal + prevGasTotal + prevWaterTotal) * 100) / 100;
            const aqiSummary = $aa64058c595bd070$var$buildAqiSummary(airQualityPoints);
            const vibSummary = $aa64058c595bd070$var$buildVibrationSummary(vibrationPoints, period);
            const kpis = [
                {
                    id: 'electricity',
                    value: String($aa64058c595bd070$var$totalConsumption(elecConsumption)),
                    subLabel: 'kWh used'
                },
                {
                    id: 'gas',
                    value: String($aa64058c595bd070$var$totalConsumption(gasConsumption)),
                    subLabel: "m\xb3 consumed"
                },
                {
                    id: 'water',
                    value: String($aa64058c595bd070$var$totalConsumption(waterConsumption)),
                    subLabel: "m\xb3 consumed"
                },
                {
                    id: 'cost',
                    value: `\xa3${grandTotal}`,
                    subLabel: `total ${period.toLowerCase()}`
                }
            ];
            const costBreakdown = [
                {
                    label: 'Electricity',
                    value: elecTotal,
                    color: '#1D9E75'
                },
                {
                    label: 'Gas',
                    value: gasTotal,
                    color: '#BA7517'
                },
                {
                    label: 'Water',
                    value: waterTotal,
                    color: '#378ADD'
                }
            ].filter((d)=>d.value > 0);
            const comparison = [
                {
                    id: 'electricity',
                    label: 'Electricity',
                    current: $aa64058c595bd070$var$totalConsumption(elecConsumption),
                    previous: $aa64058c595bd070$var$totalConsumption(prevElecConsumption),
                    unit: 'kWh',
                    color: '#1D9E75'
                },
                ...gasChannels.length > 0 ? [
                    {
                        id: 'gas',
                        label: 'Gas',
                        current: $aa64058c595bd070$var$totalConsumption(gasConsumption),
                        previous: $aa64058c595bd070$var$totalConsumption(prevGasConsumption),
                        unit: "m\xb3",
                        color: '#BA7517'
                    }
                ] : [],
                ...waterChannels.length > 0 ? [
                    {
                        id: 'water',
                        label: 'Water',
                        current: $aa64058c595bd070$var$totalConsumption(waterConsumption),
                        previous: $aa64058c595bd070$var$totalConsumption(prevWaterConsumption),
                        unit: "m\xb3",
                        color: '#378ADD'
                    }
                ] : [],
                {
                    id: 'cost',
                    label: 'Total cost',
                    current: grandTotal,
                    previous: prevGrandTotal,
                    unit: '',
                    prefix: "\xa3",
                    color: '#D4537E'
                }
            ];
            setData({
                kpis: kpis,
                series: $aa64058c595bd070$var$buildEnergySeries(elecConsumption, gasConsumption, waterConsumption, elecCost, period),
                costBreakdown: costBreakdown,
                airQuality: aqiSummary,
                vibration: vibSummary,
                alerts: $aa64058c595bd070$var$mapAlerts(rawAlerts),
                comparison: comparison,
                prevPeriodLabel: prevLabel
            });
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.error('[useDashboard]', err);
                setError(err.message ?? 'Failed to load dashboard data');
            }
        } finally{
            setLoading(false);
        }
    }, [
        osmName,
        config,
        period
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchAll();
    }, [
        fetchAll
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!refreshMs) return;
        const id = setInterval(fetchAll, refreshMs);
        return ()=>clearInterval(id);
    }, [
        fetchAll,
        refreshMs
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            abortRef.current?.abort();
        }, []);
    return {
        period: period,
        setPeriod: setPeriod,
        periods: $aa64058c595bd070$var$PERIODS,
        data: data,
        loading: loading,
        error: error,
        refetch: fetchAll
    };
}

});
parcelRegister("7GFR6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatBucketLabel = $942169b27d015c16$var$formatBucketLabel;
module.exports.getDateRange = $942169b27d015c16$var$getDateRange;
module.exports.getPrevDateRange = $942169b27d015c16$var$getPrevDateRange;
module.exports.prevPeriodLabel = $942169b27d015c16$var$prevPeriodLabel;
function $942169b27d015c16$var$getDateRange(period) {
    const now = new Date();
    const to = now.toISOString();
    let from;
    switch(period){
        case 'Today':
            from = new Date(now);
            from.setHours(0, 0, 0, 0);
            break;
        case 'This week':
            {
                from = new Date(now);
                const day = from.getDay() === 0 ? 6 : from.getDay() - 1;
                from.setDate(from.getDate() - day);
                from.setHours(0, 0, 0, 0);
                break;
            }
        case 'This month':
            from = new Date(now.getFullYear(), now.getMonth(), 1);
            break;
        case 'This year':
            from = new Date(now.getFullYear(), 0, 1);
            break;
        default:
            from = new Date(now);
            from.setDate(from.getDate() - 7);
    }
    return {
        from: from.toISOString(),
        to: to
    };
}
function $942169b27d015c16$var$formatBucketLabel(bucket, period) {
    const date = new Date(bucket);
    switch(period){
        case 'Today':
            return date.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit'
            });
        case 'This week':
            return date.toLocaleDateString('en-GB', {
                weekday: 'short'
            });
        case 'This month':
            return date.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short'
            });
        case 'This year':
            return date.toLocaleDateString('en-GB', {
                month: 'short'
            });
        default:
            return bucket;
    }
}
function $942169b27d015c16$var$prevPeriodLabel(period) {
    switch(period){
        case 'Today':
            return 'vs yesterday';
        case 'This week':
            return 'vs last week';
        case 'This month':
            return 'vs last month';
        case 'This year':
            return 'vs last year';
    }
}
function $942169b27d015c16$var$getPrevDateRange(period) {
    const now = new Date();
    switch(period){
        case 'Today':
            {
                const from = new Date(now);
                from.setDate(from.getDate() - 1);
                from.setHours(0, 0, 0, 0);
                const to = new Date(from);
                to.setHours(23, 59, 59, 999);
                return {
                    from: from.toISOString(),
                    to: to.toISOString()
                };
            }
        case 'This week':
            {
                const currentFrom = new Date(now);
                const day = currentFrom.getDay() === 0 ? 6 : currentFrom.getDay() - 1;
                currentFrom.setDate(currentFrom.getDate() - day);
                currentFrom.setHours(0, 0, 0, 0);
                const from = new Date(currentFrom);
                from.setDate(from.getDate() - 7);
                const to = new Date(currentFrom);
                to.setMilliseconds(-1);
                return {
                    from: from.toISOString(),
                    to: to.toISOString()
                };
            }
        case 'This month':
            {
                const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                const to = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
                return {
                    from: from.toISOString(),
                    to: to.toISOString()
                };
            }
        case 'This year':
            {
                const from = new Date(now.getFullYear() - 1, 0, 1);
                const to = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
                return {
                    from: from.toISOString(),
                    to: to.toISOString()
                };
            }
    }
}

});


parcelRegister("18InM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5acbea2bf178357f$var$KpiCard;

var $5acbea2bf178357f$var$_react = $5acbea2bf178357f$var$_interopRequireDefault((parcelRequire("acw62")));

var $5acbea2bf178357f$var$_Bolt = $5acbea2bf178357f$var$_interopRequireDefault((parcelRequire("2WBL0")));

var $5acbea2bf178357f$var$_LocalFireDepartment = $5acbea2bf178357f$var$_interopRequireDefault((parcelRequire("hBILp")));

var $5acbea2bf178357f$var$_WaterDrop = $5acbea2bf178357f$var$_interopRequireDefault((parcelRequire("7s5xd")));

var $5acbea2bf178357f$var$_Receipt = $5acbea2bf178357f$var$_interopRequireDefault((parcelRequire("bhPUt")));

var $ayMG0 = parcelRequire("ayMG0");
function $5acbea2bf178357f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5acbea2bf178357f$var$ACCENT_COLORS = {
    electricity: '#1D9E75',
    gas: '#BA7517',
    water: '#378ADD',
    cost: '#D4537E'
};
const $5acbea2bf178357f$var$TREND_COLORS = {
    down: '#0F6E56',
    up: '#993C1D',
    good: '#0F6E56'
};
const $5acbea2bf178357f$var$ICONS = {
    electricity: $5acbea2bf178357f$var$_Bolt.default,
    gas: $5acbea2bf178357f$var$_LocalFireDepartment.default,
    water: $5acbea2bf178357f$var$_WaterDrop.default,
    cost: $5acbea2bf178357f$var$_Receipt.default
};
function $5acbea2bf178357f$var$KpiCard({ id: id, label: label, value: value, subLabel: subLabel, trend: trend }) {
    const accentColor = $5acbea2bf178357f$var$ACCENT_COLORS[id] ?? '#1D9E75';
    const trendColor = trend ? $5acbea2bf178357f$var$TREND_COLORS[trend.direction] ?? '#888780' : undefined;
    const Icon = $5acbea2bf178357f$var$ICONS[id];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $5acbea2bf178357f$var$styles.card,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                style: $5acbea2bf178357f$var$styles.label,
                children: [
                    Icon && /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                        "aria-hidden": "true",
                        sx: {
                            fontSize: 14
                        }
                    }),
                    label
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $5acbea2bf178357f$var$styles.value,
                children: value
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $5acbea2bf178357f$var$styles.footer,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $5acbea2bf178357f$var$styles.subLabel,
                        children: subLabel
                    }),
                    trend && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            ...$5acbea2bf178357f$var$styles.trend,
                            color: trendColor
                        },
                        children: trend.label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    ...$5acbea2bf178357f$var$styles.accent,
                    background: accentColor
                }
            })
        ]
    });
}
const $5acbea2bf178357f$var$styles = {
    card: {
        position: 'relative',
        background: 'var(--color-bg-secondary, #f5f5f3)',
        borderRadius: 12,
        padding: '1rem 1.1rem 1.2rem',
        overflow: 'hidden',
        fontFamily: "'Syne', sans-serif"
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 11,
        fontWeight: 500,
        color: 'var(--color-text-secondary, #5F5E5A)',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        marginBottom: '0.5rem'
    },
    value: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 26,
        fontWeight: 400,
        color: 'var(--color-text-primary, #2C2C2A)',
        lineHeight: 1,
        margin: 0
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '0.45rem'
    },
    subLabel: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary, #5F5E5A)'
    },
    trend: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11
    },
    accent: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 3
    }
};

});
parcelRegister("2WBL0", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $224e49595dca9c4d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $224e49595dca9c4d$var$_createSvgIcon = $224e49595dca9c4d$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $224e49595dca9c4d$var$_default = module.exports.default = (0, $224e49595dca9c4d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66s.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21"
}), 'Bolt');

});

parcelRegister("hBILp", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $cd189d86ab9ed525$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd189d86ab9ed525$var$_createSvgIcon = $cd189d86ab9ed525$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $cd189d86ab9ed525$var$_default = module.exports.default = (0, $cd189d86ab9ed525$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"
    }, "1")
], 'LocalFireDepartment');

});

parcelRegister("7s5xd", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $56cf70fdec2b1333$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56cf70fdec2b1333$var$_createSvgIcon = $56cf70fdec2b1333$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $56cf70fdec2b1333$var$_default = module.exports.default = (0, $56cf70fdec2b1333$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8M7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12-.08-.45.28-.87.74-.87"
}), 'WaterDrop');

});

parcelRegister("bhPUt", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $83798c7b947566e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83798c7b947566e4$var$_createSvgIcon = $83798c7b947566e4$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $83798c7b947566e4$var$_default = module.exports.default = (0, $83798c7b947566e4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 17H6v-2h12zm0-4H6v-2h12zm0-4H6V7h12zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2z"
}), 'Receipt');

});


parcelRegister("9X56V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ea68b73084cf012$var$EnergyChart;

var $i1xAO = parcelRequire("i1xAO");

var $6ea68b73084cf012$var$_Box = $6ea68b73084cf012$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $6ea68b73084cf012$var$_Typography = $6ea68b73084cf012$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $ayMG0 = parcelRequire("ayMG0");
function $6ea68b73084cf012$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ea68b73084cf012$var$SERIES_COLORS = {
    'Electricity (kWh)': '#1D9E75',
    "Gas (m\xb3)": '#BA7517',
    "Cost (\xa3)": '#D4537E'
};
const $6ea68b73084cf012$var$LEGEND_ITEMS = [
    {
        label: 'Electricity (kWh)',
        color: '#1D9E75',
        dashed: false
    },
    {
        label: "Gas (m\xb3)",
        color: '#BA7517',
        dashed: false
    },
    {
        label: "Water (m\xb3)",
        color: '#378ADD',
        dashed: false
    },
    {
        label: "Cost (\xa3)",
        color: '#D4537E',
        dashed: true
    }
];
function $6ea68b73084cf012$var$EnergyChart({ series: series, buckets: buckets }) {
    const xData = series.labels.map((_, i)=>i);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6ea68b73084cf012$var$_Box.default, {
        sx: $6ea68b73084cf012$var$styles.panel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6ea68b73084cf012$var$_Typography.default, {
                sx: $6ea68b73084cf012$var$styles.title,
                children: "Energy consumption"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($i1xAO.LineChart, {
                xAxis: [
                    {
                        data: xData,
                        valueFormatter: (i, context)=>{
                            const bucket = series.labels[i] ?? '';
                            if (context.location === 'tooltip') {
                                const raw = buckets[i];
                                if (raw) return new Date(raw).toLocaleString('en-GB', {
                                    weekday: 'short',
                                    day: 'numeric',
                                    month: 'short',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                });
                            }
                            return bucket;
                        },
                        tickLabelStyle: {
                            fontSize: 11
                        },
                        scaleType: 'point'
                    }
                ],
                yAxis: [
                    {
                        id: 'energy',
                        tickLabelStyle: {
                            fontSize: 11
                        }
                    },
                    {
                        id: 'cost',
                        tickLabelStyle: {
                            fontSize: 11
                        }
                    }
                ],
                leftAxis: "energy",
                rightAxis: "cost",
                series: [
                    {
                        id: 'electricity',
                        label: 'Electricity (kWh)',
                        data: series.electricity,
                        color: '#1D9E75',
                        yAxisId: 'energy',
                        area: true,
                        showMark: series.electricity.length <= 14,
                        curve: 'catmullRom'
                    },
                    {
                        id: 'gas',
                        label: "Gas (m\xb3)",
                        data: series.gas,
                        color: '#BA7517',
                        yAxisId: 'energy',
                        area: true,
                        showMark: series.gas.length <= 14,
                        curve: 'catmullRom'
                    },
                    {
                        id: 'water',
                        label: "Water (m\xb3)",
                        data: series.water,
                        color: '#378ADD',
                        yAxisId: 'energy',
                        area: true,
                        showMark: series.water.length <= 14,
                        curve: 'catmullRom'
                    },
                    {
                        id: 'cost',
                        label: "Cost (\xa3)",
                        data: series.cost,
                        color: '#D4537E',
                        yAxisId: 'cost',
                        showMark: false,
                        curve: 'catmullRom'
                    }
                ],
                grid: {
                    horizontal: true
                },
                height: 210,
                margin: {
                    top: 10,
                    right: 48,
                    bottom: 30,
                    left: 44
                },
                slotProps: {
                    legend: {
                        hidden: true
                    }
                },
                sx: {
                    '& .MuiAreaElement-root[data-id="electricity"]': {
                        fill: 'rgba(29,158,117,0.08)'
                    },
                    '& .MuiAreaElement-root[data-id="gas"]': {
                        fill: 'rgba(186,117,23,0.06)'
                    },
                    '& .MuiAreaElement-root[data-id="water"]': {
                        fill: 'rgba(55,138,221,0.08)'
                    },
                    '& .MuiLineElement-root[data-id="cost"]': {
                        strokeDasharray: '4 3',
                        strokeWidth: 1.5
                    },
                    '& .MuiMarkElement-root': {
                        outline: 'none'
                    }
                }
            })
        ]
    });
}
const $6ea68b73084cf012$var$styles = {
    panel: {
        bgcolor: 'var(--color-bg-secondary)',
        borderRadius: 3,
        p: '1.1rem 1.25rem'
    },
    title: {
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--color-text-primary)',
        mb: '2px'
    },
    sub: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-primary)',
        mb: 1
    },
    legendLabel: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-primary)'
    }
};

});
parcelRegister("i1xAO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d1f260d103214f86$var$_exportNames = {
    getMarkElementUtilityClass: true,
    markElementClasses: true
};
Object.defineProperty(module.exports, "getMarkElementUtilityClass", {
    enumerable: true,
    get: function() {
        return $kIvwk.getMarkElementUtilityClass;
    }
});
Object.defineProperty(module.exports, "markElementClasses", {
    enumerable: true,
    get: function() {
        return $kIvwk.markElementClasses;
    }
});

var $4wBYx = parcelRequire("4wBYx");
Object.keys($4wBYx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4wBYx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4wBYx[key];
        }
    });
});

var $f0gHv = parcelRequire("f0gHv");
Object.keys($f0gHv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f0gHv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f0gHv[key];
        }
    });
});

var $frLZq = parcelRequire("frLZq");
Object.keys($frLZq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $frLZq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $frLZq[key];
        }
    });
});

var $cVPen = parcelRequire("cVPen");
Object.keys($cVPen).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cVPen[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cVPen[key];
        }
    });
});

var $jv2O3 = parcelRequire("jv2O3");
Object.keys($jv2O3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jv2O3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jv2O3[key];
        }
    });
});

var $4Cury = parcelRequire("4Cury");
Object.keys($4Cury).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4Cury[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4Cury[key];
        }
    });
});

var $e6rEy = parcelRequire("e6rEy");
Object.keys($e6rEy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e6rEy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e6rEy[key];
        }
    });
});

var $WFeaH = parcelRequire("WFeaH");
Object.keys($WFeaH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $WFeaH[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $WFeaH[key];
        }
    });
});

var $8xsIq = parcelRequire("8xsIq");
Object.keys($8xsIq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8xsIq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8xsIq[key];
        }
    });
});

var $kejZ3 = parcelRequire("kejZ3");
Object.keys($kejZ3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kejZ3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kejZ3[key];
        }
    });
});

var $lx7Fr = parcelRequire("lx7Fr");
Object.keys($lx7Fr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lx7Fr[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lx7Fr[key];
        }
    });
});

var $4T2aJ = parcelRequire("4T2aJ");
Object.keys($4T2aJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4T2aJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4T2aJ[key];
        }
    });
});

var $i2Vyg = parcelRequire("i2Vyg");
Object.keys($i2Vyg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d1f260d103214f86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $i2Vyg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i2Vyg[key];
        }
    });
});

var $kIvwk = parcelRequire("kIvwk");

});
parcelRegister("4wBYx", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $34b79bb6a82ebc69$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $34b79bb6a82ebc69$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineChart = void 0;

var $34b79bb6a82ebc69$var$_extends2 = $34b79bb6a82ebc69$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $34b79bb6a82ebc69$var$React = $34b79bb6a82ebc69$require$_interopRequireWildcard((parcelRequire("acw62")));

var $34b79bb6a82ebc69$var$_propTypes = $34b79bb6a82ebc69$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $frLZq = parcelRequire("frLZq");

var $f0gHv = parcelRequire("f0gHv");

var $cVPen = parcelRequire("cVPen");

var $dPTe0 = parcelRequire("dPTe0");

var $luY0B = parcelRequire("luY0B");

var $anK5t = parcelRequire("anK5t");

var $ad3Dp = parcelRequire("ad3Dp");

var $6WChQ = parcelRequire("6WChQ");

var $jv2O3 = parcelRequire("jv2O3");

var $2ppSP = parcelRequire("2ppSP");

var $hhc1V = parcelRequire("hhc1V");

var $ezmj9 = parcelRequire("ezmj9");

var $3jE6m = parcelRequire("3jE6m");

var $eSGGd = parcelRequire("eSGGd");

var $ezMKh = parcelRequire("ezMKh");

var $G4UB8 = parcelRequire("G4UB8");

var $lx7Fr = parcelRequire("lx7Fr");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineChart API](https://mui.com/x/api/charts/line-chart/)
 */ const $34b79bb6a82ebc69$var$LineChart = module.exports.LineChart = /*#__PURE__*/ $34b79bb6a82ebc69$var$React.forwardRef(function LineChart(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiLineChart'
    });
    const { chartsWrapperProps: chartsWrapperProps, chartContainerProps: chartContainerProps, gridProps: gridProps, clipPathProps: clipPathProps, clipPathGroupProps: clipPathGroupProps, areaPlotProps: areaPlotProps, linePlotProps: linePlotProps, markPlotProps: markPlotProps, overlayProps: overlayProps, chartsAxisProps: chartsAxisProps, axisHighlightProps: axisHighlightProps, lineHighlightPlotProps: lineHighlightPlotProps, legendProps: legendProps, children: children } = (0, $ezmj9.useLineChartProps)(props);
    const { chartDataProviderProps: chartDataProviderProps, chartsSurfaceProps: chartsSurfaceProps } = (0, $3jE6m.useChartContainerProps)(chartContainerProps, ref);
    const Tooltip = props.slots?.tooltip ?? $luY0B.ChartsTooltip;
    const Toolbar = props.slots?.toolbar;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eSGGd.ChartDataProvider, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, chartDataProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($G4UB8.ChartsWrapper, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, chartsWrapperProps, {
            children: [
                props.showToolbar && Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, props.slotProps?.toolbar)) : null,
                !props.hideLegend && /*#__PURE__*/ (0, $ayMG0.jsx)($anK5t.ChartsLegend, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, legendProps)),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ezMKh.ChartsSurface, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, chartsSurfaceProps, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($2ppSP.ChartsGrid, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, gridProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", (0, $34b79bb6a82ebc69$var$_extends2.default)({}, clipPathGroupProps, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($frLZq.AreaPlot, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, areaPlotProps)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($f0gHv.LinePlot, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, linePlotProps)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($hhc1V.ChartsOverlay, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, overlayProps)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($ad3Dp.ChartsAxisHighlight, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, axisHighlightProps))
                            ]
                        })),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($lx7Fr.FocusedLineMark, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($dPTe0.ChartsAxis, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, chartsAxisProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            "data-drawing-container": true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cVPen.MarkPlot, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, markPlotProps))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($jv2O3.LineHighlightPlot, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, lineHighlightPlotProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($6WChQ.ChartsClipPath, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, clipPathProps)),
                        children
                    ]
                })),
                !props.loading && /*#__PURE__*/ (0, $ayMG0.jsx)(Tooltip, (0, $34b79bb6a82ebc69$var$_extends2.default)({}, props.slotProps?.tooltip))
            ]
        }))
    }));
});

});
parcelRegister("frLZq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b3ee9a62b7a05664$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b3ee9a62b7a05664$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AreaPlot = $b3ee9a62b7a05664$var$AreaPlot;

var $b3ee9a62b7a05664$var$_extends2 = $b3ee9a62b7a05664$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b3ee9a62b7a05664$var$_objectWithoutPropertiesLoose2 = $b3ee9a62b7a05664$require$_interopRequireDefault((parcelRequire("c05no")));

var $b3ee9a62b7a05664$var$React = $b3ee9a62b7a05664$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b3ee9a62b7a05664$var$_propTypes = $b3ee9a62b7a05664$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $4Cury = parcelRequire("4Cury");

var $cfS2L = parcelRequire("cfS2L");

var $55Xcx = parcelRequire("55Xcx");

var $cFMyx = parcelRequire("cFMyx");

var $6yYO0 = parcelRequire("6yYO0");

var $32gdR = parcelRequire("32gdR");

var $ayMG0 = parcelRequire("ayMG0");
const $b3ee9a62b7a05664$var$_excluded = [
    "slots",
    "slotProps",
    "onItemClick",
    "skipAnimation"
];
const $b3ee9a62b7a05664$var$AreaPlotRoot = (0, $8xDHs.styled)('g', {
    name: 'MuiAreaPlot',
    slot: 'Root'
})({
    [`& .${$4Cury.areaElementClasses.root}`]: {
        transitionProperty: 'opacity, fill',
        transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
        transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION
    }
});
const $b3ee9a62b7a05664$var$useAggregatedData = ()=>{
    const { xAxis: xAxes } = (0, $55Xcx.useXAxes)();
    const { yAxis: yAxes } = (0, $55Xcx.useYAxes)();
    return (0, $6yYO0.useAreaPlotData)(xAxes, yAxes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Areas demonstration](https://mui.com/x/react-charts/areas-demo/)
 * - [Stacking](https://mui.com/x/react-charts/stacking/)
 *
 * API:
 *
 * - [AreaPlot API](https://mui.com/x/api/charts/area-plot/)
 */ function $b3ee9a62b7a05664$var$AreaPlot(props) {
    const { slots: slots, slotProps: slotProps, onItemClick: onItemClick, skipAnimation: inSkipAnimation } = props, other = (0, $b3ee9a62b7a05664$var$_objectWithoutPropertiesLoose2.default)(props, $b3ee9a62b7a05664$var$_excluded);
    const isZoomInteracting = (0, $cFMyx.useInternalIsZoomInteracting)();
    const skipAnimation = (0, $cfS2L.useSkipAnimation)(isZoomInteracting || inSkipAnimation);
    const completedData = $b3ee9a62b7a05664$var$useAggregatedData();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b3ee9a62b7a05664$var$AreaPlotRoot, (0, $b3ee9a62b7a05664$var$_extends2.default)({}, other, {
        children: completedData.map(({ d: d, seriesId: seriesId, color: color, area: area, gradientId: gradientId })=>!!area && /*#__PURE__*/ (0, $ayMG0.jsx)($4Cury.AreaElement, {
                id: seriesId,
                d: d,
                color: color,
                gradientId: gradientId,
                slots: slots,
                slotProps: slotProps,
                onClick: onItemClick && ((event)=>onItemClick(event, {
                        type: 'line',
                        seriesId: seriesId
                    })),
                skipAnimation: skipAnimation
            }, seriesId))
    }));
}

});
parcelRegister("4Cury", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $35d25370c95aa994$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $35d25370c95aa994$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AreaElement = $35d25370c95aa994$var$AreaElement;
module.exports.areaElementClasses = void 0;
module.exports.getAreaElementUtilityClass = $35d25370c95aa994$var$getAreaElementUtilityClass;

var $35d25370c95aa994$var$_extends2 = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $35d25370c95aa994$var$_objectWithoutPropertiesLoose2 = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("c05no")));

var $35d25370c95aa994$var$React = $35d25370c95aa994$require$_interopRequireWildcard((parcelRequire("acw62")));

var $35d25370c95aa994$var$_propTypes = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $35d25370c95aa994$var$_composeClasses = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $35d25370c95aa994$var$_useSlotProps = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("839K0")));

var $35d25370c95aa994$var$_generateUtilityClass = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $35d25370c95aa994$var$_generateUtilityClasses = $35d25370c95aa994$require$_interopRequireDefault((parcelRequire("5nY49")));

var $hdpx4 = parcelRequire("hdpx4");

var $3N2dU = parcelRequire("3N2dU");

var $e6rEy = parcelRequire("e6rEy");

var $ayMG0 = parcelRequire("ayMG0");
const $35d25370c95aa994$var$_excluded = [
    "id",
    "classes",
    "color",
    "gradientId",
    "slots",
    "slotProps",
    "onClick"
];
function $35d25370c95aa994$var$getAreaElementUtilityClass(slot) {
    return (0, $35d25370c95aa994$var$_generateUtilityClass.default)('MuiAreaElement', slot);
}
const $35d25370c95aa994$var$areaElementClasses = module.exports.areaElementClasses = (0, $35d25370c95aa994$var$_generateUtilityClasses.default)('MuiAreaElement', [
    'root',
    'highlighted',
    'faded',
    'series'
]);
const $35d25370c95aa994$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded'
        ]
    };
    return (0, $35d25370c95aa994$var$_composeClasses.default)(slots, $35d25370c95aa994$var$getAreaElementUtilityClass, classes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Areas demonstration](https://mui.com/x/react-charts/areas-demo/)
 *
 * API:
 *
 * - [AreaElement API](https://mui.com/x/api/charts/area-element/)
 */ function $35d25370c95aa994$var$AreaElement(props) {
    const { id: id, classes: innerClasses, color: color, gradientId: gradientId, slots: slots, slotProps: slotProps, onClick: onClick } = props, other = (0, $35d25370c95aa994$var$_objectWithoutPropertiesLoose2.default)(props, $35d25370c95aa994$var$_excluded);
    const interactionProps = (0, $hdpx4.useInteractionItemProps)({
        type: 'line',
        seriesId: id
    });
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $3N2dU.useItemHighlighted)({
        seriesId: id
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        color: color,
        gradientId: gradientId,
        isFaded: isFaded,
        isHighlighted: isHighlighted
    };
    const classes = $35d25370c95aa994$var$useUtilityClasses(ownerState);
    const Area = slots?.area ?? $e6rEy.AnimatedArea;
    const areaProps = (0, $35d25370c95aa994$var$_useSlotProps.default)({
        elementType: Area,
        externalSlotProps: slotProps?.area,
        additionalProps: (0, $35d25370c95aa994$var$_extends2.default)({}, interactionProps, {
            onClick: onClick,
            cursor: onClick ? 'pointer' : 'unset'
        }),
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Area, (0, $35d25370c95aa994$var$_extends2.default)({}, other, areaProps));
}

});
parcelRegister("hdpx4", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c88774c650943688$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c88774c650943688$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getInteractionItemProps = $c88774c650943688$var$getInteractionItemProps;
module.exports.useInteractionItemProps = void 0;

var $c88774c650943688$var$React = $c88774c650943688$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c88774c650943688$var$_useEventCallback = $c88774c650943688$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $6hQTT = parcelRequire("6hQTT");
function $c88774c650943688$var$onPointerDown(event) {
    if ('hasPointerCapture' in event.currentTarget && event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
}
const $c88774c650943688$var$useInteractionItemProps = (data, skip)=>{
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const interactionActive = $c88774c650943688$var$React.useRef(false);
    const onPointerEnter = (0, $c88774c650943688$var$_useEventCallback.default)(()=>{
        interactionActive.current = true;
        instance.setLastUpdateSource('pointer');
        instance.setTooltipItem(data);
        // TODO: uniformize sankey and other types to get a single plugin
        instance.setHighlight(// @ts-ignore
        data.type === 'sankey' ? data : {
            seriesId: data.seriesId,
            dataIndex: data.dataIndex
        });
    });
    const onPointerLeave = (0, $c88774c650943688$var$_useEventCallback.default)(()=>{
        interactionActive.current = false;
        instance.removeTooltipItem(data);
        instance.clearHighlight();
    });
    $c88774c650943688$var$React.useEffect(()=>{
        return ()=>{
            /* Clean up state if this item is unmounted while active. */ if (interactionActive.current) onPointerLeave();
        };
    }, [
        onPointerLeave
    ]);
    return $c88774c650943688$var$React.useMemo(()=>skip ? {} : {
            onPointerEnter: onPointerEnter,
            onPointerLeave: onPointerLeave,
            onPointerDown: $c88774c650943688$var$onPointerDown
        }, [
        skip,
        onPointerEnter,
        onPointerLeave
    ]);
};
module.exports.useInteractionItemProps = $c88774c650943688$var$useInteractionItemProps;
function $c88774c650943688$var$getInteractionItemProps(instance, item) {
    function onPointerEnter() {
        if (!item) return;
        instance.setLastUpdateSource('pointer');
        instance.setTooltipItem(item);
        instance.setHighlight(// @ts-ignore
        item.type === 'sankey' ? item : {
            seriesId: item.seriesId,
            dataIndex: item.dataIndex
        });
    }
    function onPointerLeave() {
        if (!item) return;
        instance.removeTooltipItem(item);
        instance.clearHighlight();
    }
    return {
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onPointerDown: $c88774c650943688$var$onPointerDown
    };
}

});
parcelRegister("6hQTT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ezP7S = parcelRequire("ezP7S");
Object.keys($ezP7S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ezP7S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ezP7S[key];
        }
    });
});

var $6JI31 = parcelRequire("6JI31");
Object.keys($6JI31).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6JI31[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6JI31[key];
        }
    });
});

var $1HhaP = parcelRequire("1HhaP");
Object.keys($1HhaP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1HhaP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1HhaP[key];
        }
    });
});

});
parcelRegister("ezP7S", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartProvider = void 0;

var $lqHBv = parcelRequire("lqHBv");
/**
 * @deprecated Use `ChartsProvider` instead. We added S to the charts prefix to align with other components.
 */ const $a9cbfe294740a2b5$var$ChartProvider = module.exports.ChartProvider = $lqHBv.ChartsProvider;

});
parcelRegister("lqHBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4UnXu = parcelRequire("4UnXu");
Object.keys($4UnXu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4UnXu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4UnXu[key];
        }
    });
});

var $62XIl = parcelRequire("62XIl");
Object.keys($62XIl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $62XIl[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $62XIl[key];
        }
    });
});

var $gyilZ = parcelRequire("gyilZ");
Object.keys($gyilZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $gyilZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gyilZ[key];
        }
    });
});

});
parcelRegister("4UnXu", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $392efa0e7b2dfaf2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsProvider = $392efa0e7b2dfaf2$var$ChartsProvider;
module.exports.defaultSeriesConfig = void 0;

var $392efa0e7b2dfaf2$var$React = $392efa0e7b2dfaf2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $dtgND = parcelRequire("dtgND");

var $8L2Vi = parcelRequire("8L2Vi");

var $a5Dpn = parcelRequire("a5Dpn");

var $d8Csh = parcelRequire("d8Csh");

var $8j56i = parcelRequire("8j56i");

var $d4cjJ = parcelRequire("d4cjJ");

var $d25l6 = parcelRequire("d25l6");

var $iVJ0y = parcelRequire("iVJ0y");

var $hWEs8 = parcelRequire("hWEs8");

var $4U5YD = parcelRequire("4U5YD");

var $3BMFO = parcelRequire("3BMFO");

var $ayMG0 = parcelRequire("ayMG0");
const $392efa0e7b2dfaf2$var$defaultSeriesConfig = module.exports.defaultSeriesConfig = {
    bar: $iVJ0y.barSeriesConfig,
    scatter: $3BMFO.scatterSeriesConfig,
    line: $hWEs8.lineSeriesConfig,
    pie: $4U5YD.pieSeriesConfig
};
// For consistency with the v7, the cartesian axes are set by default.
// To remove them, you can provide a `plugins` props.
const $392efa0e7b2dfaf2$var$defaultPlugins = [
    $d4cjJ.useChartZAxis,
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $a5Dpn.useChartCartesianAxis,
    $d25l6.useChartHighlight
];
function $392efa0e7b2dfaf2$var$ChartsProvider(props) {
    const { children: children, plugins: plugins = $392efa0e7b2dfaf2$var$defaultPlugins, pluginParams: pluginParams = {}, seriesConfig: seriesConfig = $392efa0e7b2dfaf2$var$defaultSeriesConfig } = props;
    const { contextValue: contextValue } = (0, $dtgND.useCharts)(plugins, pluginParams, seriesConfig);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8L2Vi.ChartsContext.Provider, {
        value: contextValue,
        children: children
    });
}

});
parcelRegister("dtgND", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9ceb03d84072c9fb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9ceb03d84072c9fb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartApiInitialization = $9ceb03d84072c9fb$var$useChartApiInitialization;
module.exports.useCharts = $9ceb03d84072c9fb$var$useCharts;

var $9ceb03d84072c9fb$var$React = $9ceb03d84072c9fb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9ceb03d84072c9fb$var$_useId = $9ceb03d84072c9fb$require$_interopRequireDefault((parcelRequire("hwliF")));

var $8P0MD = parcelRequire("8P0MD");

var $hTeTA = parcelRequire("hTeTA");

var $1HWkh = parcelRequire("1HWkh");
let $9ceb03d84072c9fb$var$globalId = 0;
/**
 * This is the main hook that setups the plugin system for the chart.
 *
 * It manages the data used to create the charts.
 *
 * @param inPlugins All the plugins that will be used in the chart.
 * @param props The props passed to the chart.
 * @param seriesConfig The set of helpers used for series-specific computation.
 */ function $9ceb03d84072c9fb$var$useCharts(inPlugins, props, seriesConfig) {
    const chartId = (0, $9ceb03d84072c9fb$var$_useId.default)();
    const plugins = $9ceb03d84072c9fb$var$React.useMemo(()=>[
            ...$hTeTA.CHART_CORE_PLUGINS,
            ...inPlugins
        ], [
        inPlugins
    ]);
    const pluginParams = (0, $1HWkh.extractPluginParamsFromProps)({
        plugins: plugins,
        props: props
    });
    pluginParams.id = pluginParams.id ?? chartId;
    const instanceRef = $9ceb03d84072c9fb$var$React.useRef({});
    const instance = instanceRef.current;
    const publicAPI = $9ceb03d84072c9fb$var$useChartApiInitialization(props.apiRef);
    const innerChartRootRef = $9ceb03d84072c9fb$var$React.useRef(null);
    const innerSvgRef = $9ceb03d84072c9fb$var$React.useRef(null);
    const storeRef = $9ceb03d84072c9fb$var$React.useRef(null);
    if (storeRef.current == null) {
        // eslint-disable-next-line react-compiler/react-compiler
        $9ceb03d84072c9fb$var$globalId += 1;
        const initialState = {
            cacheKey: {
                id: $9ceb03d84072c9fb$var$globalId
            }
        };
        plugins.forEach((plugin)=>{
            if (plugin.getInitialState) Object.assign(initialState, plugin.getInitialState(pluginParams, initialState, seriesConfig));
        });
        storeRef.current = new $8P0MD.Store(initialState);
    }
    const runPlugin = (plugin)=>{
        const pluginResponse = plugin({
            instance: instance,
            params: pluginParams,
            plugins: plugins,
            store: storeRef.current,
            svgRef: innerSvgRef,
            chartRootRef: innerChartRootRef,
            seriesConfig: seriesConfig
        });
        if (pluginResponse.publicAPI) Object.assign(publicAPI.current, pluginResponse.publicAPI);
        if (pluginResponse.instance) Object.assign(instance, pluginResponse.instance);
    };
    plugins.forEach(runPlugin);
    const contextValue = $9ceb03d84072c9fb$var$React.useMemo(()=>({
            store: storeRef.current,
            publicAPI: publicAPI.current,
            instance: instance,
            svgRef: innerSvgRef,
            chartRootRef: innerChartRootRef
        }), [
        instance,
        publicAPI
    ]);
    return {
        contextValue: contextValue
    };
}
function $9ceb03d84072c9fb$var$initializeInputApiRef(inputApiRef) {
    if (inputApiRef.current == null) inputApiRef.current = {};
    return inputApiRef;
}
function $9ceb03d84072c9fb$var$useChartApiInitialization(inputApiRef) {
    const fallbackPublicApiRef = $9ceb03d84072c9fb$var$React.useRef({});
    if (inputApiRef) return $9ceb03d84072c9fb$var$initializeInputApiRef(inputApiRef);
    return fallbackPublicApiRef;
}

});
parcelRegister("hTeTA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CHART_CORE_PLUGINS", {
    enumerable: true,
    get: function() {
        return $fh8AW.CHART_CORE_PLUGINS;
    }
});

var $fh8AW = parcelRequire("fh8AW");

});
parcelRegister("fh8AW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CHART_CORE_PLUGINS = void 0;

var $gzaK4 = parcelRequire("gzaK4");

var $eWN1p = parcelRequire("eWN1p");

var $1Vp4t = parcelRequire("1Vp4t");

var $8EIiG = parcelRequire("8EIiG");

var $1k3ob = parcelRequire("1k3ob");

var $dCdvY = parcelRequire("dCdvY");
/**
 * Internal plugins that create the tools used by the other plugins.
 * These plugins are used by the Charts components.
 */ const $b1ef1c4dcbeba705$var$CHART_CORE_PLUGINS = module.exports.CHART_CORE_PLUGINS = [
    $8EIiG.useChartId,
    $1Vp4t.useChartExperimentalFeatures,
    $eWN1p.useChartDimensions,
    $1k3ob.useChartSeries,
    $dCdvY.useChartInteractionListener,
    $gzaK4.useChartAnimation
];

});
parcelRegister("gzaK4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c0f83f62d5436c25$var$_exportNames = {
    useChartAnimation: true
};
Object.defineProperty(module.exports, "useChartAnimation", {
    enumerable: true,
    get: function() {
        return $9xG1N.useChartAnimation;
    }
});

var $9xG1N = parcelRequire("9xG1N");

var $iC50F = parcelRequire("iC50F");
Object.keys($iC50F).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0f83f62d5436c25$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iC50F[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iC50F[key];
        }
    });
});

});
parcelRegister("9xG1N", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6f27cc072f0877fd$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6f27cc072f0877fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartAnimation = void 0;

var $6f27cc072f0877fd$var$_extends2 = $6f27cc072f0877fd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6f27cc072f0877fd$var$React = $6f27cc072f0877fd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6f27cc072f0877fd$var$_useEnhancedEffect = $6f27cc072f0877fd$require$_interopRequireDefault((parcelRequire("jdWO4")));
const $6f27cc072f0877fd$var$useChartAnimation = ({ params: params, store: store })=>{
    $6f27cc072f0877fd$var$React.useEffect(()=>{
        store.set('animation', (0, $6f27cc072f0877fd$var$_extends2.default)({}, store.state.animation, {
            skip: params.skipAnimation
        }));
    }, [
        store,
        params.skipAnimation
    ]);
    const disableAnimation = $6f27cc072f0877fd$var$React.useCallback(()=>{
        let disableCalled = false;
        store.set('animation', (0, $6f27cc072f0877fd$var$_extends2.default)({}, store.state.animation, {
            skipAnimationRequests: store.state.animation.skipAnimationRequests + 1
        }));
        return ()=>{
            if (disableCalled) return;
            disableCalled = true;
            store.set('animation', (0, $6f27cc072f0877fd$var$_extends2.default)({}, store.state.animation, {
                skipAnimationRequests: store.state.animation.skipAnimationRequests - 1
            }));
        };
    }, [
        store
    ]);
    (0, $6f27cc072f0877fd$var$_useEnhancedEffect.default)(()=>{
        // Skip animation test/jsdom
        const isAnimationDisabledEnvironment = typeof window === 'undefined' || !window?.matchMedia;
        if (isAnimationDisabledEnvironment) return undefined;
        let disableAnimationCleanup;
        const handleMediaChange = (event)=>{
            if (event.matches) disableAnimationCleanup = disableAnimation();
            else disableAnimationCleanup?.();
        };
        const mql = window.matchMedia('(prefers-reduced-motion)');
        handleMediaChange(mql);
        mql.addEventListener('change', handleMediaChange);
        return ()=>{
            mql.removeEventListener('change', handleMediaChange);
        };
    }, [
        disableAnimation,
        store
    ]);
    return {
        instance: {
            disableAnimation: disableAnimation
        }
    };
};
module.exports.useChartAnimation = $6f27cc072f0877fd$var$useChartAnimation;
$6f27cc072f0877fd$var$useChartAnimation.params = {
    skipAnimation: true
};
$6f27cc072f0877fd$var$useChartAnimation.getDefaultizedParams = ({ params: params })=>(0, $6f27cc072f0877fd$var$_extends2.default)({}, params, {
        skipAnimation: params.skipAnimation ?? false
    });
$6f27cc072f0877fd$var$useChartAnimation.getInitialState = ({ skipAnimation: skipAnimation })=>{
    const isAnimationDisabledEnvironment = typeof window === 'undefined' || !window?.matchMedia;
    // We use the value of `isAnimationDisabledEnvironment` as the initial value of `skipAnimation` to avoid
    // re-rendering the component on environments where matchMedia is not supported, hence skipAnimation will always be true.
    const disableAnimations = false;
    return {
        animation: {
            skip: skipAnimation,
            // By initializing the skipAnimationRequests to 1, we ensure that the animation is always skipped
            skipAnimationRequests: disableAnimations ? 1 : 0
        }
    };
};

});

parcelRegister("iC50F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartSkipAnimation = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $d8cfa969fdb73487$var$selectorChartAnimationState = (state)=>state.animation;
const $d8cfa969fdb73487$var$selectorChartSkipAnimation = module.exports.selectorChartSkipAnimation = (0, $8P0MD.createSelector)($d8cfa969fdb73487$var$selectorChartAnimationState, (state)=>state.skip || state.skipAnimationRequests > 0);

});


parcelRegister("eWN1p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ae1c8229e1e7bd4b$var$_exportNames = {
    useChartDimensions: true
};
Object.defineProperty(module.exports, "useChartDimensions", {
    enumerable: true,
    get: function() {
        return $38RKk.useChartDimensions;
    }
});

var $38RKk = parcelRequire("38RKk");

var $kOdtM = parcelRequire("kOdtM");
Object.keys($kOdtM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ae1c8229e1e7bd4b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kOdtM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kOdtM[key];
        }
    });
});

});
parcelRegister("38RKk", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $249bcf54464ad813$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $249bcf54464ad813$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartDimensions = void 0;

var $249bcf54464ad813$var$_extends2 = $249bcf54464ad813$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $249bcf54464ad813$var$React = $249bcf54464ad813$require$_interopRequireWildcard((parcelRequire("acw62")));

var $oRPnP = parcelRequire("oRPnP");

var $249bcf54464ad813$var$_useEnhancedEffect = $249bcf54464ad813$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $249bcf54464ad813$var$_ownerWindow = $249bcf54464ad813$require$_interopRequireDefault((parcelRequire("4Rhws")));

var $fiXDv = parcelRequire("fiXDv");

var $kOdtM = parcelRequire("kOdtM");

var $fXrnQ = parcelRequire("fXrnQ");
const $249bcf54464ad813$var$MAX_COMPUTE_RUN = 10;
const $249bcf54464ad813$var$useChartDimensions = ({ params: params, store: store, svgRef: svgRef })=>{
    const hasInSize = params.width !== undefined && params.height !== undefined;
    const stateRef = $249bcf54464ad813$var$React.useRef({
        displayError: false,
        initialCompute: true,
        computeRun: 0
    });
    // States only used for the initialization of the size.
    const [innerWidth, setInnerWidth] = $249bcf54464ad813$var$React.useState(0);
    const [innerHeight, setInnerHeight] = $249bcf54464ad813$var$React.useState(0);
    const computeSize = $249bcf54464ad813$var$React.useCallback(()=>{
        const mainEl = svgRef?.current;
        if (!mainEl) return {};
        const win = (0, $249bcf54464ad813$var$_ownerWindow.default)(mainEl);
        const computedStyle = win.getComputedStyle(mainEl);
        const newHeight = Math.floor(parseFloat(computedStyle.height)) || 0;
        const newWidth = Math.floor(parseFloat(computedStyle.width)) || 0;
        if (store.state.dimensions.width !== newWidth || store.state.dimensions.height !== newHeight) store.set('dimensions', {
            margin: {
                top: params.margin.top,
                right: params.margin.right,
                bottom: params.margin.bottom,
                left: params.margin.left
            },
            width: params.width ?? newWidth,
            height: params.height ?? newHeight,
            propsWidth: params.width,
            propsHeight: params.height
        });
        return {
            height: newHeight,
            width: newWidth
        };
    }, [
        store,
        svgRef,
        params.height,
        params.width,
        // Margin is an object, so we need to include all the properties to prevent infinite loops.
        params.margin.left,
        params.margin.right,
        params.margin.top,
        params.margin.bottom
    ]);
    (0, $oRPnP.useEffectAfterFirstRender)(()=>{
        const width = params.width ?? store.state.dimensions.width;
        const height = params.height ?? store.state.dimensions.height;
        store.set('dimensions', {
            margin: {
                top: params.margin.top,
                right: params.margin.right,
                bottom: params.margin.bottom,
                left: params.margin.left
            },
            width: width,
            height: height,
            propsHeight: params.height,
            propsWidth: params.width
        });
    }, [
        store,
        params.height,
        params.width,
        // Margin is an object, so we need to include all the properties to prevent infinite loops.
        params.margin.left,
        params.margin.right,
        params.margin.top,
        params.margin.bottom
    ]);
    $249bcf54464ad813$var$React.useEffect(()=>{
        // Ensure the error detection occurs after the first rendering.
        stateRef.current.displayError = true;
    }, []);
    // This effect is used to compute the size of the container on the initial render.
    // It is not bound to the raf loop to avoid an unwanted "resize" event.
    // https://github.com/mui/mui-x/issues/13477#issuecomment-2336634785
    (0, $249bcf54464ad813$var$_useEnhancedEffect.default)(()=>{
        // computeRun is used to avoid infinite loops.
        if (hasInSize || !stateRef.current.initialCompute || stateRef.current.computeRun > $249bcf54464ad813$var$MAX_COMPUTE_RUN) return;
        const computedSize = computeSize();
        if (computedSize.width !== innerWidth || computedSize.height !== innerHeight) {
            stateRef.current.computeRun += 1;
            if (computedSize.width !== undefined) setInnerWidth(computedSize.width);
            if (computedSize.height !== undefined) setInnerHeight(computedSize.height);
        } else if (stateRef.current.initialCompute) stateRef.current.initialCompute = false;
    }, [
        innerHeight,
        innerWidth,
        computeSize,
        hasInSize
    ]);
    (0, $249bcf54464ad813$var$_useEnhancedEffect.default)(()=>{
        if (hasInSize) return ()=>{};
        computeSize();
        const elementToObserve = svgRef.current;
        if (typeof ResizeObserver === 'undefined') return ()=>{};
        let animationFrame;
        const observer = new ResizeObserver(()=>{
            // See https://github.com/mui/mui-x/issues/8733
            animationFrame = requestAnimationFrame(()=>{
                computeSize();
            });
        });
        if (elementToObserve) observer.observe(elementToObserve);
        return ()=>{
            if (animationFrame) cancelAnimationFrame(animationFrame);
            if (elementToObserve) observer.unobserve(elementToObserve);
        };
    }, [
        computeSize,
        hasInSize,
        svgRef
    ]);
    const drawingArea = store.use($kOdtM.selectorChartDrawingArea);
    const isXInside = $249bcf54464ad813$var$React.useCallback((x)=>x >= drawingArea.left - 1 && x <= drawingArea.left + drawingArea.width, [
        drawingArea.left,
        drawingArea.width
    ]);
    const isYInside = $249bcf54464ad813$var$React.useCallback((y)=>y >= drawingArea.top - 1 && y <= drawingArea.top + drawingArea.height, [
        drawingArea.height,
        drawingArea.top
    ]);
    const isPointInside = $249bcf54464ad813$var$React.useCallback((x, y, targetElement)=>{
        // For element allowed to overflow, wrapping them in <g data-drawing-container /> make them fully part of the drawing area.
        if (targetElement && 'closest' in targetElement && targetElement.closest('[data-drawing-container]')) return true;
        return isXInside(x) && isYInside(y);
    }, [
        isXInside,
        isYInside
    ]);
    return {
        instance: {
            isPointInside: isPointInside,
            isXInside: isXInside,
            isYInside: isYInside
        }
    };
};
module.exports.useChartDimensions = $249bcf54464ad813$var$useChartDimensions;
$249bcf54464ad813$var$useChartDimensions.params = {
    width: true,
    height: true,
    margin: true
};
$249bcf54464ad813$var$useChartDimensions.getDefaultizedParams = ({ params: params })=>(0, $249bcf54464ad813$var$_extends2.default)({}, params, {
        margin: (0, $fXrnQ.defaultizeMargin)(params.margin, $fiXDv.DEFAULT_MARGINS)
    });
$249bcf54464ad813$var$useChartDimensions.getInitialState = ({ width: width, height: height, margin: margin })=>{
    return {
        dimensions: {
            margin: margin,
            width: width ?? 0,
            height: height ?? 0,
            propsWidth: width,
            propsHeight: height
        }
    };
};

});
parcelRegister("oRPnP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kuTz9 = parcelRequire("kuTz9");
Object.keys($kuTz9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kuTz9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kuTz9[key];
        }
    });
});

});
parcelRegister("kuTz9", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eec1b640560346c8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useEffectAfterFirstRender = $eec1b640560346c8$var$useEffectAfterFirstRender;

var $eec1b640560346c8$var$React = $eec1b640560346c8$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Run an effect only after the first render.
 *
 * @param effect The effect to run after the first render
 * @param deps The dependencies for the effect
 */ function $eec1b640560346c8$var$useEffectAfterFirstRender(effect, deps) {
    const isFirstRender = $eec1b640560346c8$var$React.useRef(true);
    $eec1b640560346c8$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return undefined;
        }
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});


parcelRegister("fiXDv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_Y_AXIS_KEY = module.exports.DEFAULT_X_AXIS_KEY = module.exports.DEFAULT_ROTATION_AXIS_KEY = module.exports.DEFAULT_RADIUS_AXIS_KEY = module.exports.DEFAULT_MARGINS = module.exports.DEFAULT_AXIS_SIZE_WIDTH = module.exports.DEFAULT_AXIS_SIZE_HEIGHT = module.exports.AXIS_LABEL_DEFAULT_HEIGHT = void 0;
const $b246cbf650933002$var$DEFAULT_X_AXIS_KEY = module.exports.DEFAULT_X_AXIS_KEY = 'DEFAULT_X_AXIS_KEY';
const $b246cbf650933002$var$DEFAULT_Y_AXIS_KEY = module.exports.DEFAULT_Y_AXIS_KEY = 'DEFAULT_Y_AXIS_KEY';
const $b246cbf650933002$var$DEFAULT_ROTATION_AXIS_KEY = module.exports.DEFAULT_ROTATION_AXIS_KEY = 'DEFAULT_ROTATION_AXIS_KEY';
const $b246cbf650933002$var$DEFAULT_RADIUS_AXIS_KEY = module.exports.DEFAULT_RADIUS_AXIS_KEY = 'DEFAULT_RADIUS_AXIS_KEY';
const $b246cbf650933002$var$DEFAULT_MARGINS = module.exports.DEFAULT_MARGINS = {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20
};
const $b246cbf650933002$var$DEFAULT_AXIS_SIZE_WIDTH = module.exports.DEFAULT_AXIS_SIZE_WIDTH = 45;
const $b246cbf650933002$var$DEFAULT_AXIS_SIZE_HEIGHT = module.exports.DEFAULT_AXIS_SIZE_HEIGHT = 25;
// How many pixels to add to the default axis size if that axis has a label
const $b246cbf650933002$var$AXIS_LABEL_DEFAULT_HEIGHT = module.exports.AXIS_LABEL_DEFAULT_HEIGHT = 20;

});

parcelRegister("kOdtM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartSvgWidth = module.exports.selectorChartSvgHeight = module.exports.selectorChartPropsWidth = module.exports.selectorChartPropsHeight = module.exports.selectorChartMargin = module.exports.selectorChartDrawingArea = module.exports.selectorChartDimensionsState = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $cr9SB = parcelRequire("cr9SB");
const $f262eee51a49a4dd$var$selectorChartDimensionsState = (state)=>state.dimensions;
module.exports.selectorChartDimensionsState = $f262eee51a49a4dd$var$selectorChartDimensionsState;
const $f262eee51a49a4dd$var$selectorChartMargin = (state)=>state.dimensions.margin;
module.exports.selectorChartMargin = $f262eee51a49a4dd$var$selectorChartMargin;
const $f262eee51a49a4dd$var$selectorChartDrawingArea = module.exports.selectorChartDrawingArea = (0, $8P0MD.createSelectorMemoized)($f262eee51a49a4dd$var$selectorChartDimensionsState, $f262eee51a49a4dd$var$selectorChartMargin, $cr9SB.selectorChartAxisSizes, function selectorChartDrawingArea({ width: width, height: height }, { top: marginTop, right: marginRight, bottom: marginBottom, left: marginLeft }, { left: axisSizeLeft, right: axisSizeRight, top: axisSizeTop, bottom: axisSizeBottom }) {
    return {
        width: width - marginLeft - marginRight - axisSizeLeft - axisSizeRight,
        left: marginLeft + axisSizeLeft,
        right: marginRight + axisSizeRight,
        height: height - marginTop - marginBottom - axisSizeTop - axisSizeBottom,
        top: marginTop + axisSizeTop,
        bottom: marginBottom + axisSizeBottom
    };
});
const $f262eee51a49a4dd$var$selectorChartSvgWidth = module.exports.selectorChartSvgWidth = (0, $8P0MD.createSelector)($f262eee51a49a4dd$var$selectorChartDimensionsState, (dimensionsState)=>dimensionsState.width);
const $f262eee51a49a4dd$var$selectorChartSvgHeight = module.exports.selectorChartSvgHeight = (0, $8P0MD.createSelector)($f262eee51a49a4dd$var$selectorChartDimensionsState, (dimensionsState)=>dimensionsState.height);
const $f262eee51a49a4dd$var$selectorChartPropsWidth = module.exports.selectorChartPropsWidth = (0, $8P0MD.createSelector)($f262eee51a49a4dd$var$selectorChartDimensionsState, (dimensionsState)=>dimensionsState.propsWidth);
const $f262eee51a49a4dd$var$selectorChartPropsHeight = module.exports.selectorChartPropsHeight = (0, $8P0MD.createSelector)($f262eee51a49a4dd$var$selectorChartDimensionsState, (dimensionsState)=>dimensionsState.propsHeight);

});
parcelRegister("cr9SB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartTopAxisSize = module.exports.selectorChartRightAxisSize = module.exports.selectorChartLeftAxisSize = module.exports.selectorChartBottomAxisSize = module.exports.selectorChartAxisSizes = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $6ahCy = parcelRequire("6ahCy");
const $90dfab8a869e718d$var$selectorChartLeftAxisSize = module.exports.selectorChartLeftAxisSize = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawYAxis, function selectorChartLeftAxisSize(yAxis) {
    return (yAxis ?? []).reduce((acc, axis)=>axis.position === 'left' ? acc + (axis.width || 0) + (axis.zoom?.slider.enabled ? axis.zoom.slider.size : 0) : acc, 0);
});
const $90dfab8a869e718d$var$selectorChartRightAxisSize = module.exports.selectorChartRightAxisSize = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawYAxis, function selectorChartRightAxisSize(yAxis) {
    return (yAxis ?? []).reduce((acc, axis)=>axis.position === 'right' ? acc + (axis.width || 0) + (axis.zoom?.slider.enabled ? axis.zoom.slider.size : 0) : acc, 0);
});
const $90dfab8a869e718d$var$selectorChartTopAxisSize = module.exports.selectorChartTopAxisSize = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawXAxis, function selectorChartTopAxisSize(xAxis) {
    return (xAxis ?? []).reduce((acc, axis)=>axis.position === 'top' ? acc + (axis.height || 0) + (axis.zoom?.slider.enabled ? axis.zoom.slider.size : 0) : acc, 0);
});
const $90dfab8a869e718d$var$selectorChartBottomAxisSize = module.exports.selectorChartBottomAxisSize = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawXAxis, function selectorChartBottomAxisSize(xAxis) {
    return (xAxis ?? []).reduce((acc, axis)=>axis.position === 'bottom' ? acc + (axis.height || 0) + (axis.zoom?.slider.enabled ? axis.zoom.slider.size : 0) : acc, 0);
});
const $90dfab8a869e718d$var$selectorChartAxisSizes = module.exports.selectorChartAxisSizes = (0, $8P0MD.createSelectorMemoized)($90dfab8a869e718d$var$selectorChartLeftAxisSize, $90dfab8a869e718d$var$selectorChartRightAxisSize, $90dfab8a869e718d$var$selectorChartTopAxisSize, $90dfab8a869e718d$var$selectorChartBottomAxisSize, function selectorChartAxisSizes(left, right, top, bottom) {
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
});

});
parcelRegister("6ahCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartRawYAxis = module.exports.selectorChartRawXAxis = module.exports.selectorChartCartesianAxisState = void 0;
const $47d15865ff35e022$var$selectorChartCartesianAxisState = (state)=>state.cartesianAxis;
module.exports.selectorChartCartesianAxisState = $47d15865ff35e022$var$selectorChartCartesianAxisState;
const $47d15865ff35e022$var$selectorChartRawXAxis = (state)=>state.cartesianAxis?.x;
module.exports.selectorChartRawXAxis = $47d15865ff35e022$var$selectorChartRawXAxis;
const $47d15865ff35e022$var$selectorChartRawYAxis = (state)=>state.cartesianAxis?.y;
module.exports.selectorChartRawYAxis = $47d15865ff35e022$var$selectorChartRawYAxis;

});



parcelRegister("fXrnQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b9e19b7e5de88e30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultizeMargin = $b9e19b7e5de88e30$var$defaultizeMargin;

var $b9e19b7e5de88e30$var$_extends2 = $b9e19b7e5de88e30$require$_interopRequireDefault((parcelRequire("3p9rK")));
function $b9e19b7e5de88e30$var$defaultizeMargin(input, defaultMargin) {
    if (typeof input === 'number') return {
        top: input,
        bottom: input,
        left: input,
        right: input
    };
    if (defaultMargin) return (0, $b9e19b7e5de88e30$var$_extends2.default)({}, defaultMargin, input);
    return input;
}

});



parcelRegister("1Vp4t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $166e8fec5f471393$var$_exportNames = {
    useChartExperimentalFeatures: true
};
Object.defineProperty(module.exports, "useChartExperimentalFeatures", {
    enumerable: true,
    get: function() {
        return $3vG5o.useChartExperimentalFeatures;
    }
});

var $3vG5o = parcelRequire("3vG5o");

var $9CZNv = parcelRequire("9CZNv");
Object.keys($9CZNv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($166e8fec5f471393$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9CZNv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9CZNv[key];
        }
    });
});

});
parcelRegister("3vG5o", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $28e4e9b9d5aaeff9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartExperimentalFeatures = void 0;

var $28e4e9b9d5aaeff9$var$_useEnhancedEffect = $28e4e9b9d5aaeff9$require$_interopRequireDefault((parcelRequire("jdWO4")));
const $28e4e9b9d5aaeff9$var$useChartExperimentalFeatures = ({ params: params, store: store })=>{
    (0, $28e4e9b9d5aaeff9$var$_useEnhancedEffect.default)(()=>{
        store.set('experimentalFeatures', params.experimentalFeatures);
    }, [
        store,
        params.experimentalFeatures
    ]);
    return {};
};
module.exports.useChartExperimentalFeatures = $28e4e9b9d5aaeff9$var$useChartExperimentalFeatures;
$28e4e9b9d5aaeff9$var$useChartExperimentalFeatures.params = {
    experimentalFeatures: true
};
$28e4e9b9d5aaeff9$var$useChartExperimentalFeatures.getInitialState = ({ experimentalFeatures: experimentalFeatures })=>{
    return {
        experimentalFeatures: experimentalFeatures
    };
};

});

parcelRegister("9CZNv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorPreferStrictDomainInLineCharts = module.exports.selectorChartExperimentalFeaturesState = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $7027995c1097aba9$var$selectorChartExperimentalFeaturesState = (state)=>state.experimentalFeatures;
module.exports.selectorChartExperimentalFeaturesState = $7027995c1097aba9$var$selectorChartExperimentalFeaturesState;
const $7027995c1097aba9$var$selectorPreferStrictDomainInLineCharts = module.exports.selectorPreferStrictDomainInLineCharts = (0, $8P0MD.createSelector)($7027995c1097aba9$var$selectorChartExperimentalFeaturesState, (features)=>Boolean(features?.preferStrictDomainInLineCharts));

});


parcelRegister("8EIiG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $64d46c42d221be4d$var$_exportNames = {
    useChartId: true
};
Object.defineProperty(module.exports, "useChartId", {
    enumerable: true,
    get: function() {
        return $js3Pa.useChartId;
    }
});

var $js3Pa = parcelRequire("js3Pa");

var $2H3if = parcelRequire("2H3if");
Object.keys($2H3if).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($64d46c42d221be4d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2H3if[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2H3if[key];
        }
    });
});

});
parcelRegister("js3Pa", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e293994982a8724c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e293994982a8724c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartId = void 0;

var $e293994982a8724c$var$_extends2 = $e293994982a8724c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e293994982a8724c$var$React = $e293994982a8724c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5Yxyc = parcelRequire("5Yxyc");
const $e293994982a8724c$var$useChartId = ({ params: params, store: store })=>{
    $e293994982a8724c$var$React.useEffect(()=>{
        if (params.id === undefined || params.id === store.state.id.providedChartId && store.state.id.chartId !== undefined) return;
        store.set('id', (0, $e293994982a8724c$var$_extends2.default)({}, store.state.id, {
            chartId: params.id ?? (0, $5Yxyc.createChartDefaultId)()
        }));
    }, [
        store,
        params.id
    ]);
    return {};
};
module.exports.useChartId = $e293994982a8724c$var$useChartId;
$e293994982a8724c$var$useChartId.params = {
    id: true
};
$e293994982a8724c$var$useChartId.getInitialState = ({ id: id })=>({
        id: {
            chartId: id,
            providedChartId: id
        }
    });

});
parcelRegister("5Yxyc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createChartDefaultId = void 0;
let $459c94d29f2d4a2e$var$globalChartDefaultId = 0;
const $459c94d29f2d4a2e$var$createChartDefaultId = ()=>{
    $459c94d29f2d4a2e$var$globalChartDefaultId += 1;
    return `mui-chart-${$459c94d29f2d4a2e$var$globalChartDefaultId}`;
};
module.exports.createChartDefaultId = $459c94d29f2d4a2e$var$createChartDefaultId;

});


parcelRegister("2H3if", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartId = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $1f6226e21ca20e5e$var$selectorChartIdState = (state)=>state.id;
/**
 * Get the id attribute of the chart.
 * @param {ChartState<[UseChartIdSignature]>} state The state of the chart.
 * @returns {string} The id attribute of the chart.
 */ const $1f6226e21ca20e5e$var$selectorChartId = module.exports.selectorChartId = (0, $8P0MD.createSelector)($1f6226e21ca20e5e$var$selectorChartIdState, (idState)=>idState.chartId);

});


parcelRegister("1k3ob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0f6a49b78217d5d7$var$_exportNames = {
    useChartSeries: true
};
Object.defineProperty(module.exports, "useChartSeries", {
    enumerable: true,
    get: function() {
        return $kf1Oj.useChartSeries;
    }
});

var $kf1Oj = parcelRequire("kf1Oj");

var $6kle2 = parcelRequire("6kle2");
Object.keys($6kle2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0f6a49b78217d5d7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6kle2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6kle2[key];
        }
    });
});

});
parcelRegister("kf1Oj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ebc69ce130c5917d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartSeries = void 0;

var $ebc69ce130c5917d$var$_extends2 = $ebc69ce130c5917d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $oRPnP = parcelRequire("oRPnP");

var $ebc69ce130c5917d$var$_useEventCallback = $ebc69ce130c5917d$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $c2wlS = parcelRequire("c2wlS");

var $84xnb = parcelRequire("84xnb");

var $ebJxm = parcelRequire("ebJxm");
const $ebc69ce130c5917d$var$useChartSeries = ({ params: params, store: store, seriesConfig: seriesConfig })=>{
    const { series: series, dataset: dataset, theme: theme, colors: colors } = params;
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useChartSeries`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    (0, $oRPnP.useEffectAfterFirstRender)(()=>{
        store.set('series', (0, $ebc69ce130c5917d$var$_extends2.default)({}, store.state.series, {
            defaultizedSeries: (0, $84xnb.defaultizeSeries)({
                series: series,
                colors: typeof colors === 'function' ? colors(theme) : colors,
                seriesConfig: seriesConfig
            }),
            dataset: dataset
        }));
    }, [
        colors,
        dataset,
        series,
        theme,
        seriesConfig,
        store
    ]);
    const serializeIdentifier = (0, $ebc69ce130c5917d$var$_useEventCallback.default)((identifier)=>(0, $ebJxm.serializeIdentifier)(seriesConfig, identifier));
    return {
        instance: {
            serializeIdentifier: serializeIdentifier
        }
    };
};
module.exports.useChartSeries = $ebc69ce130c5917d$var$useChartSeries;
$ebc69ce130c5917d$var$useChartSeries.params = {
    dataset: true,
    series: true,
    colors: true,
    theme: true
};
const $ebc69ce130c5917d$var$EMPTY_ARRAY = [];
$ebc69ce130c5917d$var$useChartSeries.getDefaultizedParams = ({ params: params })=>(0, $ebc69ce130c5917d$var$_extends2.default)({}, params, {
        series: params.series?.length ? params.series : $ebc69ce130c5917d$var$EMPTY_ARRAY,
        colors: params.colors ?? $c2wlS.rainbowSurgePalette,
        theme: params.theme ?? 'light'
    });
$ebc69ce130c5917d$var$useChartSeries.getInitialState = ({ series: series = [], colors: colors, theme: theme, dataset: dataset }, _, seriesConfig)=>{
    return {
        series: {
            seriesConfig: seriesConfig,
            defaultizedSeries: (0, $84xnb.defaultizeSeries)({
                series: series,
                colors: typeof colors === 'function' ? colors(theme) : colors,
                seriesConfig: seriesConfig
            }),
            dataset: dataset
        }
    };
};

});
parcelRegister("c2wlS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dxpcW = parcelRequire("dxpcW");
Object.keys($dxpcW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dxpcW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dxpcW[key];
        }
    });
});

var $hKEdQ = parcelRequire("hKEdQ");
Object.keys($hKEdQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hKEdQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hKEdQ[key];
        }
    });
});

var $dr7we = parcelRequire("dr7we");
Object.keys($dr7we).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dr7we[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dr7we[key];
        }
    });
});

var $8XKmK = parcelRequire("8XKmK");
Object.keys($8XKmK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8XKmK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8XKmK[key];
        }
    });
});

var $6hspe = parcelRequire("6hspe");
Object.keys($6hspe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6hspe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6hspe[key];
        }
    });
});

var $hIruD = parcelRequire("hIruD");
Object.keys($hIruD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hIruD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hIruD[key];
        }
    });
});

var $j6Rmi = parcelRequire("j6Rmi");
Object.keys($j6Rmi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j6Rmi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j6Rmi[key];
        }
    });
});

var $9CXEv = parcelRequire("9CXEv");
Object.keys($9CXEv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9CXEv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9CXEv[key];
        }
    });
});

var $bhZ6O = parcelRequire("bhZ6O");
Object.keys($bhZ6O).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bhZ6O[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bhZ6O[key];
        }
    });
});

var $aIizb = parcelRequire("aIizb");
Object.keys($aIizb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aIizb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aIizb[key];
        }
    });
});

var $11Mis = parcelRequire("11Mis");
Object.keys($11Mis).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $11Mis[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $11Mis[key];
        }
    });
});

var $v5Qx8 = parcelRequire("v5Qx8");
Object.keys($v5Qx8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $v5Qx8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $v5Qx8[key];
        }
    });
});

var $jy6uK = parcelRequire("jy6uK");
Object.keys($jy6uK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jy6uK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jy6uK[key];
        }
    });
});

var $7hyIX = parcelRequire("7hyIX");
Object.keys($7hyIX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7hyIX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7hyIX[key];
        }
    });
});

});
parcelRegister("dxpcW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hKEdQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rainbowSurgePaletteLight = module.exports.rainbowSurgePaletteDark = module.exports.rainbowSurgePalette = void 0;
const $cec5eeda122ca2da$var$rainbowSurgePaletteLight = module.exports.rainbowSurgePaletteLight = [
    '#4254FB',
    '#FFB422',
    '#FA4F58',
    '#0DBEFF',
    '#22BF75',
    '#FA83B4',
    '#FF7511'
];
const $cec5eeda122ca2da$var$rainbowSurgePaletteDark = module.exports.rainbowSurgePaletteDark = [
    '#495AFB',
    '#FFC758',
    '#F35865',
    '#30C8FF',
    '#44CE8D',
    '#F286B3',
    '#FF8C39'
];
const $cec5eeda122ca2da$var$rainbowSurgePalette = (mode)=>mode === 'dark' ? $cec5eeda122ca2da$var$rainbowSurgePaletteDark : $cec5eeda122ca2da$var$rainbowSurgePaletteLight;
module.exports.rainbowSurgePalette = $cec5eeda122ca2da$var$rainbowSurgePalette;

});

parcelRegister("dr7we", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.blueberryTwilightPaletteLight = module.exports.blueberryTwilightPaletteDark = module.exports.blueberryTwilightPalette = void 0;
const $9c83a117d0cdc314$var$blueberryTwilightPaletteLight = module.exports.blueberryTwilightPaletteLight = [
    '#02B2AF',
    '#2E96FF',
    '#B800D8',
    '#60009B',
    '#2731C8',
    '#03008D'
];
const $9c83a117d0cdc314$var$blueberryTwilightPaletteDark = module.exports.blueberryTwilightPaletteDark = [
    '#02B2AF',
    '#72CCFF',
    '#DA00FF',
    '#9001CB',
    '#2E96FF',
    '#3B48E0'
];
const $9c83a117d0cdc314$var$blueberryTwilightPalette = (mode)=>mode === 'dark' ? $9c83a117d0cdc314$var$blueberryTwilightPaletteDark : $9c83a117d0cdc314$var$blueberryTwilightPaletteLight;
module.exports.blueberryTwilightPalette = $9c83a117d0cdc314$var$blueberryTwilightPalette;

});

parcelRegister("8XKmK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mangoFusionPaletteLight = module.exports.mangoFusionPaletteDark = module.exports.mangoFusionPalette = void 0;
const $6867ccb8938f3c24$var$mangoFusionPaletteLight = module.exports.mangoFusionPaletteLight = [
    '#173A5E',
    '#00A3A0',
    '#C91B63',
    '#EF5350',
    '#FFA726',
    '#B800D8',
    '#60009B',
    '#2E96FF',
    '#2731C8',
    '#03008D'
];
const $6867ccb8938f3c24$var$mangoFusionPaletteDark = module.exports.mangoFusionPaletteDark = [
    '#41698F',
    '#19D0CD',
    '#DE196B',
    '#FC5F5C',
    '#FFD771',
    '#DA00FF',
    '#9001CB',
    '#72CCFF',
    '#2E96FF',
    '#3B48E0'
];
const $6867ccb8938f3c24$var$mangoFusionPalette = (mode)=>mode === 'dark' ? $6867ccb8938f3c24$var$mangoFusionPaletteDark : $6867ccb8938f3c24$var$mangoFusionPaletteLight;
module.exports.mangoFusionPalette = $6867ccb8938f3c24$var$mangoFusionPalette;

});

parcelRegister("6hspe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cheerfulFiestaPaletteLight = module.exports.cheerfulFiestaPaletteDark = module.exports.cheerfulFiestaPalette = void 0;
const $492a5d75face8818$var$cheerfulFiestaPaletteDark = module.exports.cheerfulFiestaPaletteDark = [
    '#0059B2',
    '#2E96FF',
    '#FFC24C',
    '#FF9F0E',
    '#F38200',
    '#2ABFDE',
    '#1F94AD',
    '#BD2C38',
    '#FF3143',
    '#FF8282'
];
const $492a5d75face8818$var$cheerfulFiestaPaletteLight = module.exports.cheerfulFiestaPaletteLight = [
    '#003A75',
    '#007FFF',
    '#FFC24C',
    '#FF9D09',
    '#CA6C00',
    '#127D94',
    '#1F94AD',
    '#C82634',
    '#FF3143',
    '#FF7E7E'
];
const $492a5d75face8818$var$cheerfulFiestaPalette = (mode)=>mode === 'dark' ? $492a5d75face8818$var$cheerfulFiestaPaletteDark : $492a5d75face8818$var$cheerfulFiestaPaletteLight;
module.exports.cheerfulFiestaPalette = $492a5d75face8818$var$cheerfulFiestaPalette;

});

parcelRegister("hIruD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.strawberrySkyPaletteLight = module.exports.strawberrySkyPaletteDark = module.exports.strawberrySkyPalette = void 0;
const $ce5bdf43627db7b7$var$strawberrySkyPaletteLight = module.exports.strawberrySkyPaletteLight = [
    '#6877FF',
    '#694FFD',
    '#A94FFD',
    '#DA4FFD',
    '#F050A5',
    '#FF5E6C'
];
const $ce5bdf43627db7b7$var$strawberrySkyPaletteDark = module.exports.strawberrySkyPaletteDark = $ce5bdf43627db7b7$var$strawberrySkyPaletteLight;
const $ce5bdf43627db7b7$var$strawberrySkyPalette = (mode)=>mode === 'dark' ? $ce5bdf43627db7b7$var$strawberrySkyPaletteDark : $ce5bdf43627db7b7$var$strawberrySkyPaletteLight;
module.exports.strawberrySkyPalette = $ce5bdf43627db7b7$var$strawberrySkyPalette;

});

parcelRegister("j6Rmi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bluePaletteLight = module.exports.bluePaletteDark = module.exports.bluePalette = void 0;
// Blue sequential gradient palette based on the color scheme
const $de97f7c1c9c0827b$var$bluePaletteLight = module.exports.bluePaletteLight = [
    '#BDDEFF',
    '#99CCFF',
    '#66B2FF',
    '#2E96FF',
    '#0064D6',
    '#0D47A1',
    '#0A367B',
    '#072555'
];
const $de97f7c1c9c0827b$var$bluePaletteDark = module.exports.bluePaletteDark = $de97f7c1c9c0827b$var$bluePaletteLight;
const $de97f7c1c9c0827b$var$bluePalette = (mode)=>mode === 'dark' ? $de97f7c1c9c0827b$var$bluePaletteDark : $de97f7c1c9c0827b$var$bluePaletteLight;
module.exports.bluePalette = $de97f7c1c9c0827b$var$bluePalette;

});

parcelRegister("9CXEv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cyanPaletteLight = module.exports.cyanPaletteDark = module.exports.cyanPalette = void 0;
// Cyan sequential gradient palette based on the color scheme
const $7025ef5e63b8cc56$var$cyanPaletteLight = module.exports.cyanPaletteLight = [
    '#CFE9E8',
    '#A3DAD8',
    '#7ED0CE',
    '#44BDBA',
    '#299896',
    '#137370',
    '#0E5A58',
    '#073938'
];
const $7025ef5e63b8cc56$var$cyanPaletteDark = module.exports.cyanPaletteDark = $7025ef5e63b8cc56$var$cyanPaletteLight;
const $7025ef5e63b8cc56$var$cyanPalette = (mode)=>mode === 'dark' ? $7025ef5e63b8cc56$var$cyanPaletteDark : $7025ef5e63b8cc56$var$cyanPaletteLight;
module.exports.cyanPalette = $7025ef5e63b8cc56$var$cyanPalette;

});

parcelRegister("bhZ6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.greenPaletteLight = module.exports.greenPaletteDark = module.exports.greenPalette = void 0;
// Green sequential gradient palette based on the color scheme
const $8380af2fe6935aef$var$greenPaletteLight = module.exports.greenPaletteLight = [
    '#CDEBDD',
    '#B2E2CB',
    '#8FD8B5',
    '#54C690',
    '#31B375',
    '#359F6D',
    '#0F7746',
    '#065731'
];
const $8380af2fe6935aef$var$greenPaletteDark = module.exports.greenPaletteDark = $8380af2fe6935aef$var$greenPaletteLight;
const $8380af2fe6935aef$var$greenPalette = (mode)=>mode === 'dark' ? $8380af2fe6935aef$var$greenPaletteDark : $8380af2fe6935aef$var$greenPaletteLight;
module.exports.greenPalette = $8380af2fe6935aef$var$greenPalette;

});

parcelRegister("aIizb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.orangePaletteLight = module.exports.orangePaletteDark = module.exports.orangePalette = void 0;
// Orange sequential gradient palette based on the color scheme
const $7ccc6a5792889d31$var$orangePaletteLight = module.exports.orangePaletteLight = [
    '#FBDBC3',
    '#F9BD92',
    '#F99F5D',
    '#FF7A19',
    '#FD620B',
    '#E15100',
    '#AC3E00',
    '#822F00'
];
const $7ccc6a5792889d31$var$orangePaletteDark = module.exports.orangePaletteDark = $7ccc6a5792889d31$var$orangePaletteLight;
const $7ccc6a5792889d31$var$orangePalette = (mode)=>mode === 'dark' ? $7ccc6a5792889d31$var$orangePaletteDark : $7ccc6a5792889d31$var$orangePaletteLight;
module.exports.orangePalette = $7ccc6a5792889d31$var$orangePalette;

});

parcelRegister("11Mis", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pinkPaletteLight = module.exports.pinkPaletteDark = module.exports.pinkPalette = void 0;
// Pink sequential gradient palette based on the color scheme
const $0bfb5924df6711e4$var$pinkPaletteLight = module.exports.pinkPaletteLight = [
    '#F7D2E1',
    '#F6BED5',
    '#F4A0C3',
    '#F6619F',
    '#EE448B',
    '#E32977',
    '#B6215F',
    '#8B1F4C'
];
const $0bfb5924df6711e4$var$pinkPaletteDark = module.exports.pinkPaletteDark = $0bfb5924df6711e4$var$pinkPaletteLight;
const $0bfb5924df6711e4$var$pinkPalette = (mode)=>mode === 'dark' ? $0bfb5924df6711e4$var$pinkPaletteDark : $0bfb5924df6711e4$var$pinkPaletteLight;
module.exports.pinkPalette = $0bfb5924df6711e4$var$pinkPalette;

});

parcelRegister("v5Qx8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.purplePaletteLight = module.exports.purplePaletteDark = module.exports.purplePalette = void 0;
// Purple sequential gradient palette based on the color scheme
const $05d76e5237f8b625$var$purplePaletteLight = module.exports.purplePaletteLight = [
    '#CAD4EE',
    '#98ADE5',
    '#577EE3',
    '#4254FB',
    '#2638DF',
    '#222FA6',
    '#111C7F',
    '#091159'
];
const $05d76e5237f8b625$var$purplePaletteDark = module.exports.purplePaletteDark = $05d76e5237f8b625$var$purplePaletteLight;
const $05d76e5237f8b625$var$purplePalette = (mode)=>mode === 'dark' ? $05d76e5237f8b625$var$purplePaletteDark : $05d76e5237f8b625$var$purplePaletteLight;
module.exports.purplePalette = $05d76e5237f8b625$var$purplePalette;

});

parcelRegister("jy6uK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.redPaletteLight = module.exports.redPaletteDark = module.exports.redPalette = void 0;
// Red sequential gradient palette based on the color scheme
const $e3b63b0bf66c5405$var$redPaletteLight = module.exports.redPaletteLight = [
    '#FAE0E0',
    '#F7C0BF',
    '#F3A2A0',
    '#EF5350',
    '#E53935',
    '#DC2B27',
    '#860B08',
    '#560503 '
];
const $e3b63b0bf66c5405$var$redPaletteDark = module.exports.redPaletteDark = $e3b63b0bf66c5405$var$redPaletteLight;
const $e3b63b0bf66c5405$var$redPalette = (mode)=>mode === 'dark' ? $e3b63b0bf66c5405$var$redPaletteDark : $e3b63b0bf66c5405$var$redPaletteLight;
module.exports.redPalette = $e3b63b0bf66c5405$var$redPalette;

});

parcelRegister("7hyIX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.yellowPaletteLight = module.exports.yellowPaletteDark = module.exports.yellowPalette = void 0;
// Yellow sequential gradient palette based on the color scheme
const $54d50e71052b60fe$var$yellowPaletteLight = module.exports.yellowPaletteLight = [
    '#FBEFD6',
    '#F5DEB0',
    '#F3CD80',
    '#FAC14F',
    '#FFB219',
    '#EF9801',
    '#DA7D0B',
    '#AB6208'
];
const $54d50e71052b60fe$var$yellowPaletteDark = module.exports.yellowPaletteDark = $54d50e71052b60fe$var$yellowPaletteLight;
const $54d50e71052b60fe$var$yellowPalette = (mode)=>mode === 'dark' ? $54d50e71052b60fe$var$yellowPaletteDark : $54d50e71052b60fe$var$yellowPaletteLight;
module.exports.yellowPalette = $54d50e71052b60fe$var$yellowPalette;

});


parcelRegister("84xnb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultizeSeries = module.exports.applySeriesProcessors = module.exports.applySeriesLayout = void 0;
/**
 * This method groups series by type and adds defaultized values such as the ids and colors.
 * It does NOT apply the series processors - that happens in a selector.
 * @param series The array of series provided by the developer
 * @param colors The color palette used to defaultize series colors
 * @returns An object structuring all the series by type with default values.
 */ const $5e0895a180d0646d$var$defaultizeSeries = ({ series: series, colors: colors, seriesConfig: seriesConfig })=>{
    // Group series by type
    const seriesGroups = {};
    series.forEach((seriesData, seriesIndex)=>{
        const seriesWithDefaultValues = seriesConfig[seriesData.type].getSeriesWithDefaultValues(seriesData, seriesIndex, colors);
        const id = seriesWithDefaultValues.id;
        if (seriesGroups[seriesData.type] === undefined) seriesGroups[seriesData.type] = {
            series: {},
            seriesOrder: []
        };
        if (seriesGroups[seriesData.type]?.series[id] !== undefined) throw new Error(`MUI X Charts: series' id "${id}" is not unique.`);
        seriesGroups[seriesData.type].series[id] = seriesWithDefaultValues;
        seriesGroups[seriesData.type].seriesOrder.push(id);
    });
    return seriesGroups;
};
/**
 * Applies series processors to the defaultized series groups.
 * This should be called in a selector to compute processed series on-demand.
 * @param defaultizedSeries The defaultized series groups
 * @param seriesConfig The series configuration
 * @param dataset The optional dataset
 * @returns Processed series with all transformations applied
 */ module.exports.defaultizeSeries = $5e0895a180d0646d$var$defaultizeSeries;
const $5e0895a180d0646d$var$applySeriesProcessors = (defaultizedSeries, seriesConfig, dataset, isItemVisible)=>{
    const processedSeries = {};
    // Apply formatter on a type group
    Object.keys(seriesConfig).forEach((type)=>{
        const group = defaultizedSeries[type];
        if (group !== undefined) processedSeries[type] = seriesConfig[type]?.seriesProcessor?.(group, dataset, isItemVisible) ?? group;
    });
    return processedSeries;
};
/**
 * Applies series processors with drawing area to series if defined.
 * @param processedSeries The processed series groups
 * @param seriesConfig The series configuration
 * @param drawingArea The drawing area
 * @returns Processed series with all transformations applied
 */ module.exports.applySeriesProcessors = $5e0895a180d0646d$var$applySeriesProcessors;
const $5e0895a180d0646d$var$applySeriesLayout = (processedSeries, seriesConfig, drawingArea)=>{
    let processingDetected = false;
    const seriesLayout = {};
    // Apply processors on series type per group
    Object.keys(processedSeries).forEach((type)=>{
        const processor = seriesConfig[type]?.seriesLayout;
        const thisSeries = processedSeries[type];
        if (processor !== undefined && thisSeries !== undefined) {
            const newValue = processor(thisSeries, drawingArea);
            if (newValue && newValue !== processedSeries[type]) {
                processingDetected = true;
                seriesLayout[type] = newValue;
            }
        }
    });
    if (!processingDetected) return {};
    return seriesLayout;
};
module.exports.applySeriesLayout = $5e0895a180d0646d$var$applySeriesLayout;

});

parcelRegister("ebJxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeIdentifier = void 0;
/**
 * Serializes a series item identifier into a unique string using the appropriate serializer
 * from the provided series configuration.
 *
 * @param {ChartSeriesConfig<ChartSeriesType>} seriesConfig - The configuration object for chart series.
 * @param {SeriesItemIdentifier<ChartSeriesType>} identifier - The series item identifier to serialize.
 * @returns {string} A unique string representation of the identifier.
 * @throws Will throw an error if no serializer is found for the given series type.
 */ const $a5456a8098f9f391$var$serializeIdentifier = (seriesConfig, identifier)=>{
    const serializer = seriesConfig[identifier.type]?.identifierSerializer;
    if (!serializer) throw new Error(`MUI X Charts: No identifier serializer found for series type "${identifier.type}".`);
    // @ts-expect-error identifierSerializer expects the full object,
    // but this function accepts a partial one in order be able to serialize all identifiers.
    return serializer(identifier);
};
module.exports.serializeIdentifier = $a5456a8098f9f391$var$serializeIdentifier;

});


parcelRegister("6kle2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartSeriesState = module.exports.selectorChartSeriesProcessed = module.exports.selectorChartSeriesLayout = module.exports.selectorChartSeriesConfig = module.exports.selectorChartDefaultizedSeries = module.exports.selectorChartDataset = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $84xnb = parcelRequire("84xnb");

var $eWN1p = parcelRequire("eWN1p");

var $fgykb = parcelRequire("fgykb");
const $49b5133e5e7dc7f8$var$selectorChartSeriesState = (state)=>state.series;
module.exports.selectorChartSeriesState = $49b5133e5e7dc7f8$var$selectorChartSeriesState;
const $49b5133e5e7dc7f8$var$selectorChartDefaultizedSeries = module.exports.selectorChartDefaultizedSeries = (0, $8P0MD.createSelector)($49b5133e5e7dc7f8$var$selectorChartSeriesState, (seriesState)=>seriesState.defaultizedSeries);
const $49b5133e5e7dc7f8$var$selectorChartSeriesConfig = module.exports.selectorChartSeriesConfig = (0, $8P0MD.createSelector)($49b5133e5e7dc7f8$var$selectorChartSeriesState, (seriesState)=>seriesState.seriesConfig);
/**
 * Get the dataset from the series state.
 * @returns {DatasetType | undefined} The dataset.
 */ const $49b5133e5e7dc7f8$var$selectorChartDataset = module.exports.selectorChartDataset = (0, $8P0MD.createSelector)($49b5133e5e7dc7f8$var$selectorChartSeriesState, (seriesState)=>seriesState.dataset);
/**
 * Get the processed series after applying series processors.
 * This selector computes the processed series on-demand from the defaultized series.
 * @returns {ProcessedSeries} The processed series.
 */ const $49b5133e5e7dc7f8$var$selectorChartSeriesProcessed = module.exports.selectorChartSeriesProcessed = (0, $8P0MD.createSelectorMemoized)($49b5133e5e7dc7f8$var$selectorChartDefaultizedSeries, $49b5133e5e7dc7f8$var$selectorChartSeriesConfig, $49b5133e5e7dc7f8$var$selectorChartDataset, $fgykb.selectorIsItemVisibleGetter, function selectorChartSeriesProcessed(defaultizedSeries, seriesConfig, dataset, isItemVisible) {
    return (0, $84xnb.applySeriesProcessors)(defaultizedSeries, seriesConfig, dataset, (identifier)=>isItemVisible(seriesConfig, identifier));
});
/**
 * Get the processed series after applying series processors.
 * This selector computes the processed series on-demand from the defaultized series.
 * @returns {ProcessedSeries} The processed series.
 */ const $49b5133e5e7dc7f8$var$selectorChartSeriesLayout = module.exports.selectorChartSeriesLayout = (0, $8P0MD.createSelectorMemoized)($49b5133e5e7dc7f8$var$selectorChartSeriesProcessed, $49b5133e5e7dc7f8$var$selectorChartSeriesConfig, $eWN1p.selectorChartDrawingArea, function selectorChartSeriesLayout(processedSeries, seriesConfig, drawingArea) {
    return (0, $84xnb.applySeriesLayout)(processedSeries, seriesConfig, drawingArea);
});

});
parcelRegister("fgykb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b1d2f9c6906aa563$var$_exportNames = {
    useChartVisibilityManager: true
};
Object.defineProperty(module.exports, "useChartVisibilityManager", {
    enumerable: true,
    get: function() {
        return $2b4gV.useChartVisibilityManager;
    }
});

var $2b4gV = parcelRequire("2b4gV");

var $cT7s0 = parcelRequire("cT7s0");
Object.keys($cT7s0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b1d2f9c6906aa563$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cT7s0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cT7s0[key];
        }
    });
});

var $2bvGA = parcelRequire("2bvGA");
Object.keys($2bvGA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b1d2f9c6906aa563$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2bvGA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2bvGA[key];
        }
    });
});

});
parcelRegister("2b4gV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $195fec2d066d600e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartVisibilityManager = void 0;

var $195fec2d066d600e$var$_extends2 = $195fec2d066d600e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $195fec2d066d600e$var$_useEventCallback = $195fec2d066d600e$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $oRPnP = parcelRequire("oRPnP");

var $2bvGA = parcelRequire("2bvGA");

var $iosh5 = parcelRequire("iosh5");
const $195fec2d066d600e$var$useChartVisibilityManager = ({ store: store, params: params, seriesConfig: seriesConfig, instance: instance })=>{
    // Manage controlled state
    (0, $oRPnP.useEffectAfterFirstRender)(()=>{
        if (params.hiddenItems === undefined) return;
        store.set('visibilityManager', (0, $195fec2d066d600e$var$_extends2.default)({}, store.state.visibilityManager, {
            visibilityMap: (0, $iosh5.visibilityParamToMap)(params.hiddenItems, seriesConfig)
        }));
    }, [
        store,
        params.hiddenItems,
        seriesConfig
    ]);
    const hideItem = (0, $195fec2d066d600e$var$_useEventCallback.default)((identifier)=>{
        const visibilityMap = store.state.visibilityManager.visibilityMap;
        const id = instance.serializeIdentifier(identifier);
        if (visibilityMap.has(id)) return;
        const newVisibilityMap = new Map(visibilityMap);
        newVisibilityMap.set(id, identifier);
        store.set('visibilityManager', (0, $195fec2d066d600e$var$_extends2.default)({}, store.state.visibilityManager, {
            visibilityMap: newVisibilityMap
        }));
        params.onHiddenItemsChange?.(Array.from(newVisibilityMap.values()));
    });
    const showItem = (0, $195fec2d066d600e$var$_useEventCallback.default)((identifier)=>{
        const visibilityMap = store.state.visibilityManager.visibilityMap;
        const id = instance.serializeIdentifier(identifier);
        if (!visibilityMap.has(id)) return;
        const newVisibilityMap = new Map(visibilityMap);
        newVisibilityMap.delete(id);
        store.set('visibilityManager', (0, $195fec2d066d600e$var$_extends2.default)({}, store.state.visibilityManager, {
            visibilityMap: newVisibilityMap
        }));
        params.onHiddenItemsChange?.(Array.from(newVisibilityMap.values()));
    });
    const toggleItem = (0, $195fec2d066d600e$var$_useEventCallback.default)((identifier)=>{
        const visibilityMap = store.state.visibilityManager.visibilityMap;
        const id = instance.serializeIdentifier(identifier);
        if (visibilityMap.has(id)) showItem(identifier);
        else hideItem(identifier);
    });
    return {
        instance: {
            hideItem: hideItem,
            showItem: showItem,
            toggleItemVisibility: toggleItem
        }
    };
};
module.exports.useChartVisibilityManager = $195fec2d066d600e$var$useChartVisibilityManager;
$195fec2d066d600e$var$useChartVisibilityManager.getInitialState = (params, _, seriesConfig)=>{
    const initialItems = params.hiddenItems ?? params.initialHiddenItems;
    return {
        visibilityManager: {
            visibilityMap: initialItems ? (0, $iosh5.visibilityParamToMap)(initialItems, seriesConfig) : $2bvGA.EMPTY_VISIBILITY_MAP,
            isControlled: params.hiddenItems !== undefined
        }
    };
};
$195fec2d066d600e$var$useChartVisibilityManager.params = {
    onHiddenItemsChange: true,
    hiddenItems: true,
    initialHiddenItems: true
};

});
parcelRegister("2bvGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorVisibilityMap = module.exports.selectorIsItemVisibleGetter = module.exports.EMPTY_VISIBILITY_MAP = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $hLt3R = parcelRequire("hLt3R");
/**
 * Selector to get the visibility manager state.
 */ const $197530020501ecee$var$selectVisibilityManager = (state)=>state.visibilityManager;
const $197530020501ecee$var$EMPTY_VISIBILITY_MAP = module.exports.EMPTY_VISIBILITY_MAP = new Map();
/**
 * Selector to get the hidden identifiers from the visibility manager.
 */ const $197530020501ecee$var$selectorVisibilityMap = module.exports.selectorVisibilityMap = (0, $8P0MD.createSelector)($197530020501ecee$var$selectVisibilityManager, (visibilityManager)=>visibilityManager?.visibilityMap ?? $197530020501ecee$var$EMPTY_VISIBILITY_MAP);
/**
 * Selector that returns a function which returns whether an item is visible.
 */ const $197530020501ecee$var$selectorIsItemVisibleGetter = module.exports.selectorIsItemVisibleGetter = (0, $8P0MD.createSelectorMemoized)($197530020501ecee$var$selectorVisibilityMap, (visibilityMap)=>{
    return (seriesConfig, identifier)=>(0, $hLt3R.isIdentifierVisible)(visibilityMap, identifier, seriesConfig);
});

});
parcelRegister("hLt3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isIdentifierVisible = void 0;

var $ebJxm = parcelRequire("ebJxm");
const $ceed5e6854cdc0cc$var$isIdentifierVisible = (visibilityMap, identifier, seriesConfig)=>{
    const uniqueId = (0, $ebJxm.serializeIdentifier)(seriesConfig, identifier);
    return !visibilityMap.has(uniqueId);
};
module.exports.isIdentifierVisible = $ceed5e6854cdc0cc$var$isIdentifierVisible;

});


parcelRegister("iosh5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visibilityParamToMap = void 0;

var $ebJxm = parcelRequire("ebJxm");
const $d640669c27012645$var$visibilityParamToMap = (hiddenItems, seriesConfig)=>{
    const visibilityMap = new Map();
    if (hiddenItems) hiddenItems.forEach((identifier)=>{
        const uniqueId = (0, $ebJxm.serializeIdentifier)(seriesConfig, identifier);
        visibilityMap.set(uniqueId, identifier);
    });
    return visibilityMap;
};
module.exports.visibilityParamToMap = $d640669c27012645$var$visibilityParamToMap;

});


parcelRegister("cT7s0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("dCdvY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useChartInteractionListener", {
    enumerable: true,
    get: function() {
        return $8ISxP.useChartInteractionListener;
    }
});

var $8ISxP = parcelRequire("8ISxP");

});
parcelRegister("8ISxP", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $659cbe36f3395f22$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartInteractionListener = void 0;

var $659cbe36f3395f22$var$React = $659cbe36f3395f22$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fYdY0 = parcelRequire("fYdY0");
const $659cbe36f3395f22$var$preventDefault = (event)=>event.preventDefault();
const $659cbe36f3395f22$var$useChartInteractionListener = ({ svgRef: svgRef })=>{
    const gestureManagerRef = $659cbe36f3395f22$var$React.useRef(null);
    $659cbe36f3395f22$var$React.useEffect(()=>{
        const svg = svgRef.current;
        if (!gestureManagerRef.current) gestureManagerRef.current = new $fYdY0.GestureManager({
            gestures: [
                // We separate the zoom gestures from the gestures that are not zoom related
                // This allows us to configure the zoom gestures based on the zoom configuration.
                new $fYdY0.PanGesture({
                    name: 'pan',
                    threshold: 0,
                    maxPointers: 1
                }),
                new $fYdY0.MoveGesture({
                    name: 'move',
                    preventIf: [
                        'pan',
                        'zoomPinch',
                        'zoomPan'
                    ]
                }),
                new $fYdY0.TapGesture({
                    name: 'tap',
                    preventIf: [
                        'pan',
                        'zoomPinch',
                        'zoomPan'
                    ]
                }),
                new $fYdY0.PressGesture({
                    name: 'quickPress',
                    duration: 50
                }),
                new $fYdY0.PanGesture({
                    name: 'brush',
                    threshold: 0,
                    maxPointers: 1
                }),
                // Zoom gestures
                new $fYdY0.PanGesture({
                    name: 'zoomPan',
                    threshold: 0,
                    preventIf: [
                        'zoomTapAndDrag',
                        'zoomPressAndDrag'
                    ]
                }),
                new $fYdY0.PinchGesture({
                    name: 'zoomPinch',
                    threshold: 5
                }),
                new $fYdY0.TurnWheelGesture({
                    name: 'zoomTurnWheel',
                    sensitivity: 0.01,
                    initialDelta: 1
                }),
                new $fYdY0.TurnWheelGesture({
                    name: 'panTurnWheel',
                    sensitivity: 0.5
                }),
                new $fYdY0.TapAndDragGesture({
                    name: 'zoomTapAndDrag',
                    dragThreshold: 10
                }),
                new $fYdY0.PressAndDragGesture({
                    name: 'zoomPressAndDrag',
                    dragThreshold: 10,
                    preventIf: [
                        'zoomPinch'
                    ]
                }),
                new $fYdY0.TapGesture({
                    name: 'zoomDoubleTapReset',
                    taps: 2
                })
            ]
        });
        // Assign gesture manager after initialization
        const gestureManager = gestureManagerRef.current;
        if (!svg || !gestureManager) return undefined;
        gestureManager.registerElement([
            'pan',
            'move',
            'zoomPinch',
            'zoomPan',
            'zoomTurnWheel',
            'panTurnWheel',
            'tap',
            'quickPress',
            'zoomTapAndDrag',
            'zoomPressAndDrag',
            'zoomDoubleTapReset',
            'brush'
        ], svg);
        return ()=>{
            // Cleanup gesture manager
            gestureManager.unregisterAllGestures(svg);
        };
    }, [
        svgRef,
        gestureManagerRef
    ]);
    const addInteractionListener = $659cbe36f3395f22$var$React.useCallback((interaction, callback, options)=>{
        // Forcefully cast the svgRef to any, it is annoying to fix the types.
        const svg = svgRef.current;
        svg?.addEventListener(interaction, callback, options);
        return {
            cleanup: ()=>svg?.removeEventListener(interaction, callback)
        };
    }, [
        svgRef
    ]);
    const updateZoomInteractionListeners = $659cbe36f3395f22$var$React.useCallback((interaction, options)=>{
        const svg = svgRef.current;
        const gestureManager = gestureManagerRef.current;
        if (!gestureManager || !svg) return;
        gestureManager.setGestureOptions(interaction, svg, options ?? {});
    }, [
        svgRef,
        gestureManagerRef
    ]);
    $659cbe36f3395f22$var$React.useEffect(()=>{
        const svg = svgRef.current;
        // Disable gesture on safari
        // https://use-gesture.netlify.app/docs/gestures/#about-the-pinch-gesture
        svg?.addEventListener('gesturestart', $659cbe36f3395f22$var$preventDefault);
        svg?.addEventListener('gesturechange', $659cbe36f3395f22$var$preventDefault);
        svg?.addEventListener('gestureend', $659cbe36f3395f22$var$preventDefault);
        return ()=>{
            svg?.removeEventListener('gesturestart', $659cbe36f3395f22$var$preventDefault);
            svg?.removeEventListener('gesturechange', $659cbe36f3395f22$var$preventDefault);
            svg?.removeEventListener('gestureend', $659cbe36f3395f22$var$preventDefault);
        };
    }, [
        svgRef
    ]);
    return {
        instance: {
            addInteractionListener: addInteractionListener,
            updateZoomInteractionListeners: updateZoomInteractionListeners
        }
    };
};
module.exports.useChartInteractionListener = $659cbe36f3395f22$var$useChartInteractionListener;
$659cbe36f3395f22$var$useChartInteractionListener.params = {};
$659cbe36f3395f22$var$useChartInteractionListener.getInitialState = ()=>{
    return {};
};

});
parcelRegister("fYdY0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Gesture", {
    enumerable: true,
    get: function() {
        return $bpdfU.Gesture;
    }
});
Object.defineProperty(module.exports, "GestureManager", {
    enumerable: true,
    get: function() {
        return $69OGQ.GestureManager;
    }
});
Object.defineProperty(module.exports, "KeyboardManager", {
    enumerable: true,
    get: function() {
        return $8kFHI.KeyboardManager;
    }
});
Object.defineProperty(module.exports, "MoveGesture", {
    enumerable: true,
    get: function() {
        return $uRqHp.MoveGesture;
    }
});
Object.defineProperty(module.exports, "PanGesture", {
    enumerable: true,
    get: function() {
        return $3dKLO.PanGesture;
    }
});
Object.defineProperty(module.exports, "PinchGesture", {
    enumerable: true,
    get: function() {
        return $gsH76.PinchGesture;
    }
});
Object.defineProperty(module.exports, "PointerGesture", {
    enumerable: true,
    get: function() {
        return $55SKF.PointerGesture;
    }
});
Object.defineProperty(module.exports, "PointerManager", {
    enumerable: true,
    get: function() {
        return $3Xynv.PointerManager;
    }
});
Object.defineProperty(module.exports, "PressAndDragGesture", {
    enumerable: true,
    get: function() {
        return $gcXhr.PressAndDragGesture;
    }
});
Object.defineProperty(module.exports, "PressGesture", {
    enumerable: true,
    get: function() {
        return $8uQrn.PressGesture;
    }
});
Object.defineProperty(module.exports, "RotateGesture", {
    enumerable: true,
    get: function() {
        return $9xH2P.RotateGesture;
    }
});
Object.defineProperty(module.exports, "TapAndDragGesture", {
    enumerable: true,
    get: function() {
        return $11RrP.TapAndDragGesture;
    }
});
Object.defineProperty(module.exports, "TapGesture", {
    enumerable: true,
    get: function() {
        return $7pNPD.TapGesture;
    }
});
Object.defineProperty(module.exports, "TurnWheelGesture", {
    enumerable: true,
    get: function() {
        return $c3fSy.TurnWheelGesture;
    }
});

var $bpdfU = parcelRequire("bpdfU");

var $69OGQ = parcelRequire("69OGQ");

var $8kFHI = parcelRequire("8kFHI");

var $55SKF = parcelRequire("55SKF");

var $3Xynv = parcelRequire("3Xynv");

var $uRqHp = parcelRequire("uRqHp");

var $3dKLO = parcelRequire("3dKLO");

var $gsH76 = parcelRequire("gsH76");

var $gcXhr = parcelRequire("gcXhr");

var $8uQrn = parcelRequire("8uQrn");

var $9xH2P = parcelRequire("9xH2P");

var $11RrP = parcelRequire("11RrP");

var $7pNPD = parcelRequire("7pNPD");

var $c3fSy = parcelRequire("c3fSy");

});
parcelRegister("bpdfU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $84dc4fce8c3e42f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Gesture = void 0;

var $84dc4fce8c3e42f4$var$_extends2 = $84dc4fce8c3e42f4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bkfVk = parcelRequire("bkfVk");
/**
 * Base Gesture module that provides common functionality for all gesture implementations
 */ /**
 * The possible phases of a gesture during its lifecycle.
 *
 * - 'start': The gesture has been recognized and is beginning
 * - 'ongoing': The gesture is in progress (e.g., a finger is moving)
 * - 'end': The gesture has completed successfully
 * - 'cancel': The gesture was interrupted or terminated abnormally
 */ /**
 * Core data structure passed to gesture event handlers.
 * Contains all relevant information about a gesture event.
 */ /**
 * Defines the types of pointers that can trigger a gesture.
 */ /**
 * Base configuration options that can be overridden per pointer mode.
 */ /**
 * Configuration options for creating a gesture instance.
 */ // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention
/**
 * Type for the state of a gesture recognizer.
 */ /**
 * Base abstract class for all gestures. This class provides the fundamental structure
 * and functionality for handling gestures, including registering and unregistering
 * gesture handlers, creating emitters, and managing gesture state.
 *
 * Gesture is designed as an extensible base for implementing specific gesture recognizers.
 * Concrete gesture implementations should extend this class or one of its subclasses.
 *
 * To implement:
 * - Non-pointer gestures (like wheel events): extend this Gesture class directly
 * - Pointer-based gestures: extend the PointerGesture class instead
 *
 * @example
 * ```ts
 * import { Gesture } from './Gesture';
 *
 * class CustomGesture extends Gesture {
 *   constructor(options) {
 *     super(options);
 *   }
 *
 *   clone(overrides) {
 *     return new CustomGesture({
 *       name: this.name,
 *       // ... other options
 *       ...overrides,
 *     });
 *   }
 * }
 * ```
 */ class $84dc4fce8c3e42f4$var$Gesture {
    /** Unique name identifying this gesture type */ /** Whether to prevent default browser action for gesture events */ /** Whether to stop propagation of gesture events */ /**
   * List of gesture names that should prevent this gesture from activating when they are active.
   */ /**
   * Array of keyboard keys that must be pressed for the gesture to be recognized.
   */ /**
   * KeyboardManager instance for tracking key presses
   */ /**
   * List of pointer types that can trigger this gesture.
   * If undefined, all pointer types are allowed.
   */ /**
   * Pointer mode-specific configuration overrides.
   */ /**
   * User-mutable data object for sharing state between gesture events
   * This object is included in all events emitted by this gesture
   */ customData = {};
    /** Reference to the singleton PointerManager instance */ /** Reference to the singleton ActiveGesturesRegistry instance */ /** The DOM element this gesture is attached to */ /** Stores the active gesture state */ /** @internal For types. If false enables phases (xStart, x, xEnd) */ /** @internal For types. The event type this gesture is associated with */ /** @internal For types. The options type for this gesture */ /** @internal For types. The options that can be changed at runtime */ /** @internal For types. The state that can be changed at runtime */ /**
   * Create a new gesture instance with the specified options
   *
   * @param options - Configuration options for this gesture
   */ constructor(options){
        if (!options || !options.name) throw new Error('Gesture must be initialized with a valid name.');
        if (options.name in $bkfVk.eventList) throw new Error(`Gesture can't be created with a native event name. Tried to use "${options.name}". Please use a custom name instead.`);
        this.name = options.name;
        this.preventDefault = options.preventDefault ?? false;
        this.stopPropagation = options.stopPropagation ?? false;
        this.preventIf = options.preventIf ?? [];
        this.requiredKeys = options.requiredKeys ?? [];
        this.pointerMode = options.pointerMode ?? [];
        this.pointerOptions = options.pointerOptions ?? {};
    }
    /**
   * Initialize the gesture by acquiring the pointer manager and gestures registry
   * Must be called before the gesture can be used
   */ init(element, pointerManager, gestureRegistry, keyboardManager) {
        this.element = element;
        this.pointerManager = pointerManager;
        this.gesturesRegistry = gestureRegistry;
        this.keyboardManager = keyboardManager;
        const changeOptionsEventName = `${this.name}ChangeOptions`;
        this.element.addEventListener(changeOptionsEventName, this.handleOptionsChange);
        const changeStateEventName = `${this.name}ChangeState`;
        this.element.addEventListener(changeStateEventName, this.handleStateChange);
    }
    /**
   * Handle option change events
   * @param event Custom event with new options in the detail property
   */ handleOptionsChange = (event)=>{
        if (event && event.detail) this.updateOptions(event.detail);
    };
    /**
   * Update the gesture options with new values
   * @param options Object containing properties to update
   */ updateOptions(options) {
        // Update common options
        this.preventDefault = options.preventDefault ?? this.preventDefault;
        this.stopPropagation = options.stopPropagation ?? this.stopPropagation;
        this.preventIf = options.preventIf ?? this.preventIf;
        this.requiredKeys = options.requiredKeys ?? this.requiredKeys;
        this.pointerMode = options.pointerMode ?? this.pointerMode;
        this.pointerOptions = options.pointerOptions ?? this.pointerOptions;
    }
    /**
   * Get the default configuration for the pointer specific options.
   * Change this function in child classes to provide different defaults.
   */ getBaseConfig() {
        return {
            requiredKeys: this.requiredKeys
        };
    }
    /**
   * Get the effective configuration for a specific pointer mode.
   * This merges the base configuration with pointer mode-specific overrides.
   *
   * @param pointerType - The pointer type to get configuration for
   * @returns The effective configuration object
   */ getEffectiveConfig(pointerType, baseConfig) {
        if (pointerType !== 'mouse' && pointerType !== 'touch' && pointerType !== 'pen') // Unknown pointer type, return base config
        return baseConfig;
        // Apply pointer mode-specific overrides
        const pointerModeOverrides = this.pointerOptions[pointerType];
        if (pointerModeOverrides) return (0, $84dc4fce8c3e42f4$var$_extends2.default)({}, baseConfig, pointerModeOverrides);
        return baseConfig;
    }
    /**
   * Handle state change events
   * @param event Custom event with new state values in the detail property
   */ handleStateChange = (event)=>{
        if (event && event.detail) this.updateState(event.detail);
    };
    /**
   * Update the gesture state with new values
   * @param stateChanges Object containing state properties to update
   */ updateState(stateChanges) {
        // This is a base implementation - concrete gesture classes should override
        // to handle specific state updates based on their state structure
        Object.assign(this.state, stateChanges);
    }
    /**
   * Create a deep clone of this gesture for a new element
   *
   * @param overrides - Optional configuration options that override the defaults
   * @returns A new instance of this gesture with the same configuration and any overrides applied
   */ /**
   * Check if the event's target is or is contained within any of our registered elements
   *
   * @param event - The browser event to check
   * @returns The matching element or null if no match is found
   */ getTargetElement(event) {
        if (this.isActive || this.element === event.target || 'contains' in this.element && this.element.contains(event.target) || 'getRootNode' in this.element && this.element.getRootNode() instanceof ShadowRoot && event.composedPath().includes(this.element)) return this.element;
        return null;
    }
    /** Whether the gesture is currently active */ set isActive(isActive) {
        if (isActive) this.gesturesRegistry.registerActiveGesture(this.element, this);
        else this.gesturesRegistry.unregisterActiveGesture(this.element, this);
    }
    /** Whether the gesture is currently active */ get isActive() {
        return this.gesturesRegistry.isGestureActive(this.element, this) ?? false;
    }
    /**
   * Checks if this gesture should be prevented from activating.
   *
   * @param element - The DOM element to check against
   * @param pointerType - The type of pointer triggering the gesture
   * @returns true if the gesture should be prevented, false otherwise
   */ shouldPreventGesture(element, pointerType) {
        // Get effective configuration for this pointer type
        const effectiveConfig = this.getEffectiveConfig(pointerType, this.getBaseConfig());
        // First check if required keyboard keys are pressed
        if (!this.keyboardManager.areKeysPressed(effectiveConfig.requiredKeys)) return true; // Prevent the gesture if required keys are not pressed
        if (this.preventIf.length === 0) return false; // No prevention rules, allow the gesture
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        // Check if any of the gestures that would prevent this one are active
        return this.preventIf.some((gestureName)=>activeGestures[gestureName]);
    }
    /**
   * Checks if the given pointer type is allowed for this gesture based on the pointerMode setting.
   *
   * @param pointerType - The type of pointer to check.
   * @returns true if the pointer type is allowed, false otherwise.
   */ isPointerTypeAllowed(pointerType) {
        // If no pointer mode is specified, all pointer types are allowed
        if (!this.pointerMode || this.pointerMode.length === 0) return true;
        // Check if the pointer type is in the allowed types list
        return this.pointerMode.includes(pointerType);
    }
    /**
   * Clean up the gesture and unregister any listeners
   * Call this method when the gesture is no longer needed to prevent memory leaks
   */ destroy() {
        const changeOptionsEventName = `${this.name}ChangeOptions`;
        this.element.removeEventListener(changeOptionsEventName, this.handleOptionsChange);
        const changeStateEventName = `${this.name}ChangeState`;
        this.element.removeEventListener(changeStateEventName, this.handleStateChange);
    }
}
module.exports.Gesture = $84dc4fce8c3e42f4$var$Gesture;

});
parcelRegister("bkfVk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.eventList = void 0;
const $83edea1709ab20a8$var$eventList = module.exports.eventList = {
    abort: true,
    animationcancel: true,
    animationend: true,
    animationiteration: true,
    animationstart: true,
    auxclick: true,
    beforeinput: true,
    beforetoggle: true,
    blur: true,
    cancel: true,
    canplay: true,
    canplaythrough: true,
    change: true,
    click: true,
    close: true,
    compositionend: true,
    compositionstart: true,
    compositionupdate: true,
    contextlost: true,
    contextmenu: true,
    contextrestored: true,
    copy: true,
    cuechange: true,
    cut: true,
    dblclick: true,
    drag: true,
    dragend: true,
    dragenter: true,
    dragleave: true,
    dragover: true,
    dragstart: true,
    drop: true,
    durationchange: true,
    emptied: true,
    ended: true,
    error: true,
    focus: true,
    focusin: true,
    focusout: true,
    formdata: true,
    gotpointercapture: true,
    input: true,
    invalid: true,
    keydown: true,
    keypress: true,
    keyup: true,
    load: true,
    loadeddata: true,
    loadedmetadata: true,
    loadstart: true,
    lostpointercapture: true,
    mousedown: true,
    mouseenter: true,
    mouseleave: true,
    mousemove: true,
    mouseout: true,
    mouseover: true,
    mouseup: true,
    paste: true,
    pause: true,
    play: true,
    playing: true,
    pointercancel: true,
    pointerdown: true,
    pointerenter: true,
    pointerleave: true,
    pointermove: true,
    pointerout: true,
    pointerover: true,
    pointerup: true,
    progress: true,
    ratechange: true,
    reset: true,
    resize: true,
    scroll: true,
    scrollend: true,
    securitypolicyviolation: true,
    seeked: true,
    seeking: true,
    select: true,
    selectionchange: true,
    selectstart: true,
    slotchange: true,
    stalled: true,
    submit: true,
    suspend: true,
    timeupdate: true,
    toggle: true,
    touchcancel: true,
    touchend: true,
    touchmove: true,
    touchstart: true,
    transitioncancel: true,
    transitionend: true,
    transitionrun: true,
    transitionstart: true,
    volumechange: true,
    waiting: true,
    webkitanimationend: true,
    webkitanimationiteration: true,
    webkitanimationstart: true,
    webkittransitionend: true,
    wheel: true,
    beforematch: true,
    pointerrawupdate: true
};

});


parcelRegister("69OGQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GestureManager = void 0;

var $5XyY4 = parcelRequire("5XyY4");

var $8kFHI = parcelRequire("8kFHI");

var $3Xynv = parcelRequire("3Xynv");
/**
 * Configuration options for initializing the GestureManager
 */ /**
 * The primary class responsible for setting up and managing gestures across multiple elements.
 *
 * GestureManager maintains a collection of gesture templates that can be instantiated for
 * specific DOM elements. It handles lifecycle management, event dispatching, and cleanup.
 *
 * @example
 * ```typescript
 * // Basic setup with default gestures
 * const manager = new GestureManager({
 *   root: document.body,
 *   touchAction: 'none',
 *   gestures: [
 *     new PanGesture({ name: 'pan' }),
 *   ],
 * });
 *
 * // Register pan gestures on an element
 * const element = manager.registerElement('pan', document.querySelector('.draggable'));
 *
 * // Add event listeners with proper typing
 * element.addEventListener('panStart', (event) => {
 *   console.log('Pan started');
 * });
 *
 * element.addEventListener('pan', (event) => {
 *   console.log(`Pan delta: ${event.deltaX}, ${event.deltaY}`);
 * });
 *
 * // Custom gesture types
 * interface MyGestureEvents {
 *   custom: { x: number, y: number }
 * }
 * const customManager = new GestureManager<MyGestureEvents>({
 *   root: document.body
 *   gestures: [
 *     new CustomGesture({ name: 'custom' }),
 *   ],
 * });
 * ```
 */ class $47bae754026cda24$var$GestureManager {
    /** Repository of gesture templates that can be cloned for specific elements */ gestureTemplates = new Map();
    /** Maps DOM elements to their active gesture instances */ elementGestureMap = new Map();
    activeGesturesRegistry = new $5XyY4.ActiveGesturesRegistry();
    keyboardManager = new $8kFHI.KeyboardManager();
    /**
   * Create a new GestureManager instance to coordinate gesture recognition
   *
   * @param options - Configuration options for the gesture manager
   */ constructor(options){
        // Initialize the PointerManager
        this.pointerManager = new $3Xynv.PointerManager({
            root: options.root,
            touchAction: options.touchAction,
            passive: options.passive
        });
        // Add initial gestures as templates if provided
        if (options.gestures && options.gestures.length > 0) options.gestures.forEach((gesture)=>{
            this.addGestureTemplate(gesture);
        });
    }
    /**
   * Add a gesture template to the manager's template registry.
   * Templates serve as prototypes that can be cloned for individual elements.
   *
   * @param gesture - The gesture instance to use as a template
   */ addGestureTemplate(gesture) {
        if (this.gestureTemplates.has(gesture.name)) console.warn(`Gesture template with name "${gesture.name}" already exists. It will be overwritten.`);
        this.gestureTemplates.set(gesture.name, gesture);
    }
    /**
   * Updates the options for a specific gesture on a given element and emits a change event.
   *
   * @param gestureName - Name of the gesture whose options should be updated
   * @param element - The DOM element where the gesture is attached
   * @param options - New options to apply to the gesture
   * @returns True if the options were successfully updated, false if the gesture wasn't found
   *
   * @example
   * ```typescript
   * // Update pan gesture sensitivity on the fly
   * manager.setGestureOptions('pan', element, { threshold: 5 });
   * ```
   */ setGestureOptions(gestureName, element, options) {
        const elementGestures = this.elementGestureMap.get(element);
        if (!elementGestures || !elementGestures.has(gestureName)) {
            console.error(`Gesture "${gestureName}" not found on the provided element.`);
            return;
        }
        const event = new CustomEvent(`${gestureName}ChangeOptions`, {
            detail: options,
            bubbles: false,
            cancelable: false,
            composed: false
        });
        element.dispatchEvent(event);
    }
    /**
   * Updates the state for a specific gesture on a given element and emits a change event.
   *
   * @param gestureName - Name of the gesture whose state should be updated
   * @param element - The DOM element where the gesture is attached
   * @param state - New state to apply to the gesture
   * @returns True if the state was successfully updated, false if the gesture wasn't found
   *
   * @example
   * ```typescript
   * // Update total delta for a turnWheel gesture
   * manager.setGestureState('turnWheel', element, { totalDeltaX: 10 });
   * ```
   */ setGestureState(gestureName, element, state) {
        const elementGestures = this.elementGestureMap.get(element);
        if (!elementGestures || !elementGestures.has(gestureName)) {
            console.error(`Gesture "${gestureName}" not found on the provided element.`);
            return;
        }
        const event = new CustomEvent(`${gestureName}ChangeState`, {
            detail: state,
            bubbles: false,
            cancelable: false,
            composed: false
        });
        element.dispatchEvent(event);
    }
    /**
   * Register an element to recognize one or more gestures.
   *
   * This method clones the specified gesture template(s) and creates
   * gesture recognizer instance(s) specifically for the provided element.
   * The element is returned with enhanced TypeScript typing for gesture events.
   *
   * @param gestureNames - Name(s) of the gesture(s) to register (must match template names)
   * @param element - The DOM element to attach the gesture(s) to
   * @param options - Optional map of gesture-specific options to override when registering
   * @returns The same element with properly typed event listeners
   *
   * @example
   * ```typescript
   * // Register multiple gestures
   * const element = manager.registerElement(['pan', 'pinch'], myDiv);
   *
   * // Register a single gesture
   * const draggable = manager.registerElement('pan', dragHandle);
   *
   * // Register with customized options for each gesture
   * const customElement = manager.registerElement(
   *   ['pan', 'pinch', 'rotate'],
   *   myElement,
   *   {
   *     pan: { threshold: 20, direction: ['left', 'right'] },
   *     pinch: { threshold: 0.1 }
   *   }
   * );
   * ```
   */ registerElement(gestureNames, element, options) {
        // Handle array of gesture names
        if (!Array.isArray(gestureNames)) gestureNames = [
            gestureNames
        ];
        gestureNames.forEach((name)=>{
            const gestureOptions = options?.[name];
            this.registerSingleGesture(name, element, gestureOptions);
        });
        return element;
    }
    /**
   * Internal method to register a single gesture on an element.
   *
   * @param gestureName - Name of the gesture to register
   * @param element - DOM element to attach the gesture to
   * @param options - Optional options to override the gesture template configuration
   * @returns True if the registration was successful, false otherwise
   */ registerSingleGesture(gestureName, element, options) {
        // Find the gesture template
        const gestureTemplate = this.gestureTemplates.get(gestureName);
        if (!gestureTemplate) {
            console.error(`Gesture template "${gestureName}" not found.`);
            return false;
        }
        // Create element's gesture map if it doesn't exist
        if (!this.elementGestureMap.has(element)) this.elementGestureMap.set(element, new Map());
        // Check if this element already has this gesture registered
        const elementGestures = this.elementGestureMap.get(element);
        if (elementGestures.has(gestureName)) {
            console.warn(`Element already has gesture "${gestureName}" registered. It will be replaced.`);
            // Unregister the existing gesture first
            this.unregisterElement(gestureName, element);
        }
        // Clone the gesture template and create a new instance with optional overrides
        // This allows each element to have its own state, event listeners, and configuration
        const gestureInstance = gestureTemplate.clone(options);
        gestureInstance.init(element, this.pointerManager, this.activeGesturesRegistry, this.keyboardManager);
        // Store the gesture in the element's gesture map
        elementGestures.set(gestureName, gestureInstance);
        return true;
    }
    /**
   * Unregister a specific gesture from an element.
   * This removes the gesture recognizer and stops event emission for that gesture.
   *
   * @param gestureName - Name of the gesture to unregister
   * @param element - The DOM element to remove the gesture from
   * @returns True if the gesture was found and removed, false otherwise
   */ unregisterElement(gestureName, element) {
        const elementGestures = this.elementGestureMap.get(element);
        if (!elementGestures || !elementGestures.has(gestureName)) return false;
        // Destroy the gesture instance
        const gesture = elementGestures.get(gestureName);
        gesture.destroy();
        // Remove from the map
        elementGestures.delete(gestureName);
        this.activeGesturesRegistry.unregisterElement(element);
        // Remove the element from the map if it no longer has any gestures
        if (elementGestures.size === 0) this.elementGestureMap.delete(element);
        return true;
    }
    /**
   * Unregister all gestures from an element.
   * Completely removes the element from the gesture system.
   *
   * @param element - The DOM element to remove all gestures from
   */ unregisterAllGestures(element) {
        const elementGestures = this.elementGestureMap.get(element);
        if (elementGestures) {
            // Unregister all gestures for this element
            for (const [, gesture] of elementGestures){
                gesture.destroy();
                this.activeGesturesRegistry.unregisterElement(element);
            }
            // Clear the map
            this.elementGestureMap.delete(element);
        }
    }
    /**
   * Clean up all gestures and event listeners.
   * Call this method when the GestureManager is no longer needed to prevent memory leaks.
   */ destroy() {
        // Unregister all element gestures
        for (const [element] of this.elementGestureMap)this.unregisterAllGestures(element);
        // Clear all templates
        this.gestureTemplates.clear();
        this.elementGestureMap.clear();
        this.activeGesturesRegistry.destroy();
        this.keyboardManager.destroy();
        this.pointerManager.destroy();
    }
}
module.exports.GestureManager = $47bae754026cda24$var$GestureManager;

});
parcelRegister("5XyY4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActiveGesturesRegistry = void 0;
/**
 * ActiveGesturesRegistry - Centralized registry for tracking which gestures are active on elements
 *
 * This singleton class keeps track of all gesture instances that are currently in their active state,
 * allowing both the system and applications to query which gestures are active on specific elements.
 */ /**
 * Type for entries in the active gestures registry
 */ /**
 * Registry that maintains a record of all currently active gestures across elements
 */ class $456d9658aaf1d3a9$var$ActiveGesturesRegistry {
    /** Map of elements to their active gestures */ activeGestures = new Map();
    /**
   * Register a gesture as active on an element
   *
   * @param element - The DOM element on which the gesture is active
   * @param gesture - The gesture instance that is active
   */ registerActiveGesture(element, gesture) {
        if (!this.activeGestures.has(element)) this.activeGestures.set(element, new Set());
        const elementGestures = this.activeGestures.get(element);
        const entry = {
            gesture: gesture,
            element: element
        };
        elementGestures.add(entry);
    }
    /**
   * Remove a gesture from the active registry
   *
   * @param element - The DOM element on which the gesture was active
   * @param gesture - The gesture instance to deactivate
   */ unregisterActiveGesture(element, gesture) {
        const elementGestures = this.activeGestures.get(element);
        if (!elementGestures) return;
        // Find and remove the specific gesture entry
        elementGestures.forEach((entry)=>{
            if (entry.gesture === gesture) elementGestures.delete(entry);
        });
        // Remove the element from the map if it no longer has any active gestures
        if (elementGestures.size === 0) this.activeGestures.delete(element);
    }
    /**
   * Get all active gestures for a specific element
   *
   * @param element - The DOM element to query
   * @returns Array of active gesture names
   */ getActiveGestures(element) {
        const elementGestures = this.activeGestures.get(element);
        if (!elementGestures) return {};
        return Array.from(elementGestures).reduce((acc, entry)=>{
            acc[entry.gesture.name] = true;
            return acc;
        }, {});
    }
    /**
   * Check if a specific gesture is active on an element
   *
   * @param element - The DOM element to check
   * @param gesture - The gesture instance to check
   * @returns True if the gesture is active on the element, false otherwise
   */ isGestureActive(element, gesture) {
        const elementGestures = this.activeGestures.get(element);
        if (!elementGestures) return false;
        return Array.from(elementGestures).some((entry)=>entry.gesture === gesture);
    }
    /**
   * Clear all active gestures from the registry
   */ destroy() {
        this.activeGestures.clear();
    }
    /**
   * Clear all active gestures for a specific element
   *
   * @param element - The DOM element to clear
   */ unregisterElement(element) {
        this.activeGestures.delete(element);
    }
}
module.exports.ActiveGesturesRegistry = $456d9658aaf1d3a9$var$ActiveGesturesRegistry;

});

parcelRegister("8kFHI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyboardManager = void 0;
/**
 * KeyboardManager - Manager for keyboard events in the gesture recognition system
 *
 * This class tracks keyboard state:
 * 1. Capturing and tracking all pressed keys
 * 2. Providing methods to check if specific keys are pressed
 */ /**
 * Type definition for keyboard keys
 */ /**
 * Class responsible for tracking keyboard state
 */ class $61108a92a14014dd$var$KeyboardManager {
    pressedKeys = new Set();
    /**
   * Create a new KeyboardManager instance
   */ constructor(){
        this.initialize();
    }
    /**
   * Initialize the keyboard event listeners
   */ initialize() {
        if (typeof window === 'undefined') return;
        // Add keyboard event listeners
        window.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener('keyup', this.handleKeyUp);
        // Reset keys when window loses focus
        window.addEventListener('blur', this.clearKeys);
    }
    /**
   * Handle keydown events
   */ handleKeyDown = (event)=>{
        this.pressedKeys.add(event.key);
    };
    /**
   * Handle keyup events
   */ handleKeyUp = (event)=>{
        this.pressedKeys.delete(event.key);
    };
    /**
   * Clear all pressed keys
   */ clearKeys = ()=>{
        this.pressedKeys.clear();
    };
    /**
   * Check if a set of keys are all currently pressed
   * @param keys The keys to check
   * @returns True if all specified keys are pressed, false otherwise
   */ areKeysPressed(keys) {
        if (!keys || keys.length === 0) return true; // No keys required means the condition is satisfied
        return keys.every((key)=>{
            if (key === 'ControlOrMeta') // May be "deprecated" on types, but it is still the best option for cross-platform detection
            // https://stackoverflow.com/a/71785253/24269134
            return navigator.platform.includes('Mac') ? this.pressedKeys.has('Meta') : this.pressedKeys.has('Control');
            return this.pressedKeys.has(key);
        });
    }
    /**
   * Cleanup method to remove event listeners
   */ destroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('keydown', this.handleKeyDown);
            window.removeEventListener('keyup', this.handleKeyUp);
            window.removeEventListener('blur', this.clearKeys);
        }
        this.clearKeys();
    }
}
module.exports.KeyboardManager = $61108a92a14014dd$var$KeyboardManager;

});

parcelRegister("3Xynv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2e218c92dcdec837$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PointerManager = void 0;

var $2e218c92dcdec837$var$_extends2 = $2e218c92dcdec837$require$_interopRequireDefault((parcelRequire("3p9rK")));
/**
 * PointerManager - Centralized manager for pointer events in the gesture recognition system
 *
 * This singleton class abstracts the complexity of working with pointer events by:
 * 1. Capturing and tracking all active pointers (touch, mouse, pen)
 * 2. Normalizing pointer data into a consistent format
 * 3. Managing pointer capture for proper tracking across elements
 * 4. Distributing events to registered gesture recognizers
 */ /**
 * Normalized representation of a pointer, containing all relevant information
 * from the original PointerEvent plus additional tracking data.
 *
 * This data structure encapsulates everything gesture recognizers need to know
 * about a pointer's current state.
 */ /**
 * Configuration options for initializing the PointerManager.
 */ /**
 * Manager for handling pointer events across the application.
 *
 * PointerManager serves as the foundational layer for gesture recognition,
 * providing a centralized system for tracking active pointers and distributing
 * pointer events to gesture recognizers.
 *
 * It normalizes browser pointer events into a consistent format and simplifies
 * multi-touch handling by managing pointer capture and tracking multiple
 * simultaneous pointers.
 */ class $2e218c92dcdec837$var$PointerManager {
    /** Root element where pointer events are captured */ /** CSS touch-action property value applied to the root element */ /** Whether to use passive event listeners */ /** Whether to prevent interrupt events like blur or contextmenu */ preventEventInterruption = true;
    /** Map of all currently active pointers by their pointerId */ pointers = new Map();
    /** Set of registered gesture handlers that receive pointer events */ gestureHandlers = new Set();
    constructor(options){
        this.root = // User provided root element
        options.root ?? // Fallback to document root or body, this fixes shadow DOM scenarios
        document.getRootNode({
            composed: true
        }) ?? // Fallback to document body, for some testing environments
        document.body;
        this.touchAction = options.touchAction || 'auto';
        this.passive = options.passive ?? false;
        this.preventEventInterruption = options.preventEventInterruption ?? true;
        this.setupEventListeners();
    }
    /**
   * Register a handler function to receive pointer events.
   *
   * The handler will be called whenever pointer events occur within the root element.
   * It receives the current map of all active pointers and the original event.
   *
   * @param {Function} handler - Function to receive pointer events and current pointer state
   * @returns {Function} An unregister function that removes this handler when called
   */ registerGestureHandler(handler) {
        this.gestureHandlers.add(handler);
        // Return unregister function
        return ()=>{
            this.gestureHandlers.delete(handler);
        };
    }
    /**
   * Get a copy of the current active pointers map.
   *
   * Returns a new Map containing all currently active pointers.
   * Modifying the returned map will not affect the internal pointers state.
   *
   * @returns A new Map containing all active pointers
   */ getPointers() {
        return new Map(this.pointers);
    }
    /**
   * Set up event listeners for pointer events on the root element.
   *
   * This method attaches all necessary event listeners and configures
   * the CSS touch-action property on the root element.
   */ setupEventListeners() {
        // Set touch-action CSS property
        if (this.touchAction !== 'auto') this.root.style.touchAction = this.touchAction;
        // Add event listeners
        this.root.addEventListener('pointerdown', this.handlePointerEvent, {
            passive: this.passive
        });
        this.root.addEventListener('pointermove', this.handlePointerEvent, {
            passive: this.passive
        });
        this.root.addEventListener('pointerup', this.handlePointerEvent, {
            passive: this.passive
        });
        this.root.addEventListener('pointercancel', this.handlePointerEvent, {
            passive: this.passive
        });
        // @ts-expect-error, forceCancel is not a standard event, but used for custom handling
        this.root.addEventListener('forceCancel', this.handlePointerEvent, {
            passive: this.passive
        });
        // Add blur and contextmenu event listeners to interrupt all gestures
        this.root.addEventListener('blur', this.handleInterruptEvents);
        this.root.addEventListener('contextmenu', this.handleInterruptEvents);
    }
    /**
   * Handle events that should interrupt all gestures.
   * This clears all active pointers and notifies handlers with a pointercancel-like event.
   *
   * @param event - The event that triggered the interruption (blur or contextmenu)
   */ handleInterruptEvents = (event)=>{
        if (this.preventEventInterruption && 'pointerType' in event && event.pointerType === 'touch') {
            event.preventDefault();
            return;
        }
        // Create a synthetic pointer cancel event
        const cancelEvent = new PointerEvent('forceCancel', {
            bubbles: false,
            cancelable: false
        });
        const firstPointer = this.pointers.values().next().value;
        if (this.pointers.size > 0 && firstPointer) {
            // If there are active pointers, use the first one as a template for coordinates
            // Update the synthetic event with the pointer's coordinates
            Object.defineProperties(cancelEvent, {
                clientX: {
                    value: firstPointer.clientX
                },
                clientY: {
                    value: firstPointer.clientY
                },
                pointerId: {
                    value: firstPointer.pointerId
                },
                pointerType: {
                    value: firstPointer.pointerType
                }
            });
            // Force update of all pointers to have type 'forceCancel'
            for (const [pointerId, pointer] of this.pointers.entries()){
                const updatedPointer = (0, $2e218c92dcdec837$var$_extends2.default)({}, pointer, {
                    type: 'forceCancel'
                });
                this.pointers.set(pointerId, updatedPointer);
            }
        }
        // Notify all handlers about the interruption
        this.notifyHandlers(cancelEvent);
        // Clear all pointers
        this.pointers.clear();
    };
    /**
   * Event handler for all pointer events.
   *
   * This method:
   * 1. Updates the internal pointers map based on the event type
   * 2. Manages pointer capture for tracking pointers outside the root element
   * 3. Notifies all registered handlers with the current state
   *
   * @param event - The original pointer event from the browser
   */ handlePointerEvent = (event)=>{
        const { type: type, pointerId: pointerId } = event;
        // Create or update pointer data
        if (type === 'pointerdown' || type === 'pointermove') this.pointers.set(pointerId, this.createPointerData(event));
        else if (type === 'pointerup' || type === 'pointercancel' || type === 'forceCancel') {
            // Update one last time before removing
            this.pointers.set(pointerId, this.createPointerData(event));
            // Notify handlers with current state
            this.notifyHandlers(event);
            // Then remove the pointer
            this.pointers.delete(pointerId);
            return;
        }
        this.notifyHandlers(event);
    };
    /**
   * Notify all registered gesture handlers about a pointer event.
   *
   * Each handler receives the current map of active pointers and the original event.
   *
   * @param event - The original pointer event that triggered this notification
   */ notifyHandlers(event) {
        this.gestureHandlers.forEach((handler)=>handler(this.pointers, event));
    }
    /**
   * Create a normalized PointerData object from a browser PointerEvent.
   *
   * This method extracts all relevant information from the original event
   * and formats it in a consistent way for gesture recognizers to use.
   *
   * @param event - The original browser pointer event
   * @returns A new PointerData object representing this pointer
   */ createPointerData(event) {
        return {
            pointerId: event.pointerId,
            clientX: event.clientX,
            clientY: event.clientY,
            pageX: event.pageX,
            pageY: event.pageY,
            target: event.target,
            timeStamp: event.timeStamp,
            type: event.type,
            isPrimary: event.isPrimary,
            pressure: event.pressure,
            width: event.width,
            height: event.height,
            pointerType: event.pointerType,
            srcEvent: event
        };
    }
    /**
   * Clean up all event listeners and reset the PointerManager state.
   *
   * This method should be called when the PointerManager is no longer needed
   * to prevent memory leaks. It removes all event listeners, clears the
   * internal state, and resets the singleton instance.
   */ destroy() {
        this.root.removeEventListener('pointerdown', this.handlePointerEvent);
        this.root.removeEventListener('pointermove', this.handlePointerEvent);
        this.root.removeEventListener('pointerup', this.handlePointerEvent);
        this.root.removeEventListener('pointercancel', this.handlePointerEvent);
        // @ts-expect-error, forceCancel is not a standard event, but used for custom handling
        this.root.removeEventListener('forceCancel', this.handlePointerEvent);
        this.root.removeEventListener('blur', this.handleInterruptEvents);
        this.root.removeEventListener('contextmenu', this.handleInterruptEvents);
        this.pointers.clear();
        this.gestureHandlers.clear();
    }
}
module.exports.PointerManager = $2e218c92dcdec837$var$PointerManager;

});


parcelRegister("55SKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PointerGesture = void 0;

var $bpdfU = parcelRequire("bpdfU");
/**
 * Base configuration options that can be overridden per pointer mode.
 */ /**
 * Configuration options for pointer-based gestures, extending the base GestureOptions.
 *
 * These options provide fine-grained control over how pointer events are interpreted
 * and when the gesture should be recognized.
 */ /**
 * Base class for all pointer-based gestures.
 *
 * This class extends the base Gesture class with specialized functionality for
 * handling pointer events via the PointerManager. It provides common logic for
 * determining when a gesture should activate, tracking pointer movements, and
 * managing pointer thresholds.
 *
 * All pointer-based gesture implementations should extend this class rather than
 * the base Gesture class.
 *
 * @example
 * ```ts
 * import { PointerGesture } from './PointerGesture';
 *
 * class CustomGesture extends PointerGesture {
 *   constructor(options) {
 *     super(options);
 *   }
 *
 *   clone(overrides) {
 *     return new CustomGesture({
 *       name: this.name,
 *       // ... other options
 *       ...overrides,
 *     });
 *   }
 *
 *   handlePointerEvent = (pointers, event) => {
 *     // Handle pointer events here
 *   }
 * }
 * ```
 */ class $3b57e3f0ee20d858$var$PointerGesture extends $bpdfU.Gesture {
    /** Function to unregister from the PointerManager when destroying this gesture */ unregisterHandler = null;
    /** The original target element when the gesture began, used to prevent limbo state if target is removed */ originalTarget = null;
    /**
   * Minimum number of simultaneous pointers required to activate the gesture.
   * The gesture will not start until at least this many pointers are active.
   */ /**
   * Maximum number of simultaneous pointers allowed for this gesture.
   * If more than this many pointers are detected, the gesture may be canceled.
   */ constructor(options){
        super(options);
        this.minPointers = options.minPointers ?? 1;
        this.maxPointers = options.maxPointers ?? Infinity;
    }
    init(element, pointerManager, gestureRegistry, keyboardManager) {
        super.init(element, pointerManager, gestureRegistry, keyboardManager);
        this.unregisterHandler = this.pointerManager.registerGestureHandler(this.handlePointerEvent);
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.minPointers = options.minPointers ?? this.minPointers;
        this.maxPointers = options.maxPointers ?? this.maxPointers;
    }
    getBaseConfig() {
        return {
            requiredKeys: this.requiredKeys,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers
        };
    }
    isWithinPointerCount(pointers, pointerMode) {
        const config = this.getEffectiveConfig(pointerMode, this.getBaseConfig());
        return pointers.length >= config.minPointers && pointers.length <= config.maxPointers;
    }
    /**
   * Handler for pointer events from the PointerManager.
   * Concrete gesture implementations must override this method to provide
   * gesture-specific logic for recognizing and tracking the gesture.
   *
   * @param pointers - Map of active pointers by pointer ID
   * @param event - The original pointer event from the browser
   */ /**
   * Calculate the target element for the gesture based on the active pointers.
   *
   * It takes into account the original target element.
   *
   * @param pointers - Map of active pointers by pointer ID
   * @param calculatedTarget - The target element calculated from getTargetElement
   * @returns A list of relevant pointers for this gesture
   */ getRelevantPointers(pointers, calculatedTarget) {
        return pointers.filter((pointer)=>this.isPointerTypeAllowed(pointer.pointerType) && (calculatedTarget === pointer.target || pointer.target === this.originalTarget || calculatedTarget === this.originalTarget || 'contains' in calculatedTarget && calculatedTarget.contains(pointer.target)) || 'getRootNode' in calculatedTarget && calculatedTarget.getRootNode() instanceof ShadowRoot && pointer.srcEvent.composedPath().includes(calculatedTarget));
    }
    destroy() {
        if (this.unregisterHandler) {
            this.unregisterHandler();
            this.unregisterHandler = null;
        }
        super.destroy();
    }
}
module.exports.PointerGesture = $3b57e3f0ee20d858$var$PointerGesture;

});

parcelRegister("uRqHp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05cc3f77d1d5e1a2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MoveGesture = void 0;

var $05cc3f77d1d5e1a2$var$_extends2 = $05cc3f77d1d5e1a2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");
/**
 * MoveGesture - Detects when a pointer enters, moves within, and leaves an element
 *
 * This gesture tracks pointer movements over an element, firing events when:
 * - A pointer enters the element (start)
 * - A pointer moves within the element (ongoing)
 * - A pointer leaves the element (end)
 *
 * Unlike other gestures which often require specific actions to trigger,
 * the move gesture fires automatically when pointers interact with the target element.
 *
 * This gesture only works with mouse pointers, not touch or pen.
 */ /**
 * Configuration options for the MoveGesture
 * Extends the base PointerGestureOptions
 */ /**
 * Event data specific to move gesture events
 * Includes the source pointer event and standard gesture data
 */ /**
 * Type definition for the CustomEvent created by MoveGesture
 */ /**
 * State tracking for the MoveGesture
 */ /**
 * MoveGesture class for handling pointer movement over elements
 *
 * This gesture detects when pointers enter, move within, or leave target elements,
 * and dispatches corresponding custom events.
 *
 * This gesture only works with hovering mouse pointers, not touch.
 */ class $05cc3f77d1d5e1a2$var$MoveGesture extends $55SKF.PointerGesture {
    state = {
        lastPosition: null
    };
    /**
   * Movement threshold in pixels that must be exceeded before the gesture activates.
   * Higher values reduce false positive gesture detection for small movements.
   */ constructor(options){
        super(options);
        this.threshold = options.threshold || 0;
    }
    clone(overrides) {
        return new $05cc3f77d1d5e1a2$var$MoveGesture((0, $05cc3f77d1d5e1a2$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            threshold: this.threshold,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    init(element, pointerManager, gestureRegistry, keyboardManager) {
        super.init(element, pointerManager, gestureRegistry, keyboardManager);
        // Add event listeners for entering and leaving elements
        // These are different from pointer events handled by PointerManager
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener('pointerenter', this.handleElementEnter);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener('pointerleave', this.handleElementLeave);
    }
    destroy() {
        // Remove event listeners using the same function references
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener('pointerenter', this.handleElementEnter);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener('pointerleave', this.handleElementLeave);
        this.resetState();
        super.destroy();
    }
    updateOptions(options) {
        // Call parent method to handle common options
        super.updateOptions(options);
    }
    resetState() {
        this.isActive = false;
        this.state = {
            lastPosition: null
        };
    }
    /**
   * Handle pointer enter events for a specific element
   * @param event The original pointer event
   */ handleElementEnter = (event)=>{
        if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        // Get pointers from the PointerManager
        const pointers = this.pointerManager.getPointers() || new Map();
        const pointersArray = Array.from(pointers.values());
        // Only activate if we're within pointer count constraints
        if (this.isWithinPointerCount(pointersArray, event.pointerType)) {
            this.isActive = true;
            const currentPosition = {
                x: event.clientX,
                y: event.clientY
            };
            this.state.lastPosition = currentPosition;
            // Emit start event
            this.emitMoveEvent(this.element, 'start', pointersArray, event);
            this.emitMoveEvent(this.element, 'ongoing', pointersArray, event);
        }
    };
    /**
   * Handle pointer leave events for a specific element
   * @param event The original pointer event
   */ handleElementLeave = (event)=>{
        if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        if (!this.isActive) return;
        // Get pointers from the PointerManager
        const pointers = this.pointerManager.getPointers() || new Map();
        const pointersArray = Array.from(pointers.values());
        // Emit end event and reset state
        this.emitMoveEvent(this.element, 'end', pointersArray, event);
        this.resetState();
    };
    /**
   * Handle pointer events for the move gesture (only handles move events now)
   * @param pointers Map of active pointers
   * @param event The original pointer event
   */ handlePointerEvent = (pointers, event)=>{
        if (event.type !== 'pointermove' || event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
        const pointersArray = Array.from(pointers.values());
        // Find which element (if any) is being targeted
        const targetElement = this.getTargetElement(event);
        if (!targetElement) return;
        if (!this.isWithinPointerCount(pointersArray, event.pointerType)) return;
        if (this.shouldPreventGesture(targetElement, event.pointerType)) {
            if (!this.isActive) return;
            this.resetState();
            this.emitMoveEvent(targetElement, 'end', pointersArray, event);
            return;
        }
        // Update position
        const currentPosition = {
            x: event.clientX,
            y: event.clientY
        };
        this.state.lastPosition = currentPosition;
        if (!this.isActive) {
            this.isActive = true;
            this.emitMoveEvent(targetElement, 'start', pointersArray, event);
        }
        // Emit ongoing event
        this.emitMoveEvent(targetElement, 'ongoing', pointersArray, event);
    };
    /**
   * Emit move-specific events
   * @param element The DOM element the event is related to
   * @param phase The current phase of the gesture (start, ongoing, end)
   * @param pointers Array of active pointers
   * @param event The original pointer event
   */ emitMoveEvent(element, phase, pointers, event) {
        const currentPosition = this.state.lastPosition || (0, $lNJtn.calculateCentroid)(pointers);
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        // Create custom event data
        const customEventData = {
            gestureName: this.name,
            centroid: currentPosition,
            target: event.target,
            srcEvent: event,
            phase: phase,
            pointers: pointers,
            timeStamp: event.timeStamp,
            activeGestures: activeGestures,
            customData: this.customData
        };
        // Event names to trigger
        const eventName = (0, $lNJtn.createEventName)(this.name, phase);
        // Dispatch custom events on the element
        const domEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        element.dispatchEvent(domEvent);
    }
}
module.exports.MoveGesture = $05cc3f77d1d5e1a2$var$MoveGesture;

});
parcelRegister("lNJtn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "calculateAverageDistance", {
    enumerable: true,
    get: function() {
        return $9VLyu.calculateAverageDistance;
    }
});
Object.defineProperty(module.exports, "calculateCentroid", {
    enumerable: true,
    get: function() {
        return $d0skr.calculateCentroid;
    }
});
Object.defineProperty(module.exports, "calculateRotationAngle", {
    enumerable: true,
    get: function() {
        return $6Pnlk.calculateRotationAngle;
    }
});
Object.defineProperty(module.exports, "createEventName", {
    enumerable: true,
    get: function() {
        return $a2TId.createEventName;
    }
});
Object.defineProperty(module.exports, "getAngle", {
    enumerable: true,
    get: function() {
        return $gWItL.getAngle;
    }
});
Object.defineProperty(module.exports, "getDirection", {
    enumerable: true,
    get: function() {
        return $iKfOQ.getDirection;
    }
});
Object.defineProperty(module.exports, "getDistance", {
    enumerable: true,
    get: function() {
        return $3aGRq.getDistance;
    }
});
Object.defineProperty(module.exports, "getPinchDirection", {
    enumerable: true,
    get: function() {
        return $fwuBT.getPinchDirection;
    }
});
Object.defineProperty(module.exports, "getVelocity", {
    enumerable: true,
    get: function() {
        return $bXHsA.getVelocity;
    }
});
Object.defineProperty(module.exports, "isDirectionAllowed", {
    enumerable: true,
    get: function() {
        return $dF0VD.isDirectionAllowed;
    }
});
Object.defineProperty(module.exports, "preventDefault", {
    enumerable: true,
    get: function() {
        return $5dQuA.preventDefault;
    }
});

var $9VLyu = parcelRequire("9VLyu");

var $d0skr = parcelRequire("d0skr");

var $6Pnlk = parcelRequire("6Pnlk");

var $a2TId = parcelRequire("a2TId");

var $gWItL = parcelRequire("gWItL");

var $iKfOQ = parcelRequire("iKfOQ");

var $3aGRq = parcelRequire("3aGRq");

var $bXHsA = parcelRequire("bXHsA");

var $dF0VD = parcelRequire("dF0VD");

var $fwuBT = parcelRequire("fwuBT");

var $5dQuA = parcelRequire("5dQuA");

});
parcelRegister("9VLyu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateAverageDistance = $73ae536fcaccb893$var$calculateAverageDistance;

var $3aGRq = parcelRequire("3aGRq");
/**
 * Calculate the average distance between all pairs of pointers
 */ function $73ae536fcaccb893$var$calculateAverageDistance(pointers) {
    if (pointers.length < 2) return 0;
    let totalDistance = 0;
    let pairCount = 0;
    // Calculate distance between each pair of pointers
    for(let i = 0; i < pointers.length; i += 1)for(let j = i + 1; j < pointers.length; j += 1){
        totalDistance += (0, $3aGRq.getDistance)({
            x: pointers[i].clientX,
            y: pointers[i].clientY
        }, {
            x: pointers[j].clientX,
            y: pointers[j].clientY
        });
        pairCount += 1;
    }
    // Return average distance
    return pairCount > 0 ? totalDistance / pairCount : 0;
}

});
parcelRegister("3aGRq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDistance = $24f38d835369f9ae$var$getDistance;
/**
 * Calculate the distance between two points
 */ function $24f38d835369f9ae$var$getDistance(pointA, pointB) {
    const deltaX = pointB.x - pointA.x;
    const deltaY = pointB.y - pointA.y;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
}

});


parcelRegister("d0skr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateCentroid = $97813feb9ef7f6c3$var$calculateCentroid;
/**
 * Calculate the centroid (average position) of multiple pointers
 */ function $97813feb9ef7f6c3$var$calculateCentroid(pointers) {
    if (pointers.length === 0) return {
        x: 0,
        y: 0
    };
    const sum = pointers.reduce((acc, pointer)=>{
        acc.x += pointer.clientX;
        acc.y += pointer.clientY;
        return acc;
    }, {
        x: 0,
        y: 0
    });
    return {
        x: sum.x / pointers.length,
        y: sum.y / pointers.length
    };
}

});

parcelRegister("6Pnlk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateRotationAngle = $4f899cef1635e1fe$var$calculateRotationAngle;

var $gWItL = parcelRequire("gWItL");
/**
 * Calculate the rotation angle between pointers
 * This uses the angle between the first two pointers relative to the centroid
 */ function $4f899cef1635e1fe$var$calculateRotationAngle(pointers) {
    if (pointers.length < 2) return 0;
    // For rotation, we need exactly 2 pointers
    // Use first two since they're most likely the primary pointers
    const p1 = {
        x: pointers[0].clientX,
        y: pointers[0].clientY
    };
    const p2 = {
        x: pointers[1].clientX,
        y: pointers[1].clientY
    };
    return (0, $gWItL.getAngle)(p1, p2);
}

});
parcelRegister("gWItL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAngle = $c56490c005545ee3$var$getAngle;
/**
 * Calculate the angle between two points in degrees
 */ function $c56490c005545ee3$var$getAngle(p1, p2) {
    const angle = Math.atan2(p2.y - p1.y, p2.x - p1.x) * (180 / Math.PI);
    return (angle + 360) % 360;
}

});


parcelRegister("a2TId", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createEventName = $75054e92882efea2$var$createEventName;
/**
 * Creates the event name for a specific gesture and phase
 */ function $75054e92882efea2$var$createEventName(gesture, phase) {
    return `${gesture}${phase === 'ongoing' ? '' : phase.charAt(0).toUpperCase() + phase.slice(1)}`;
}

});

parcelRegister("iKfOQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDirection = $da58cb39a64505c9$var$getDirection;
const $da58cb39a64505c9$var$MAIN_THRESHOLD = 0.00001;
const $da58cb39a64505c9$var$ANGLE_THRESHOLD = 0.00001;
const $da58cb39a64505c9$var$SECONDARY_THRESHOLD = 0.15;
/**
 * Get the direction of movement based on the current and previous positions
 */ function $da58cb39a64505c9$var$getDirection(previous, current) {
    const deltaX = current.x - previous.x;
    const deltaY = current.y - previous.y;
    const direction = {
        vertical: null,
        horizontal: null,
        mainAxis: null
    };
    const isDiagonal = $da58cb39a64505c9$var$isDiagonalMovement(current, previous);
    const mainMovement = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
    // eslint-disable-next-line no-nested-ternary
    const horizontalThreshold = isDiagonal ? $da58cb39a64505c9$var$MAIN_THRESHOLD : mainMovement === 'horizontal' ? $da58cb39a64505c9$var$MAIN_THRESHOLD : $da58cb39a64505c9$var$SECONDARY_THRESHOLD;
    // eslint-disable-next-line no-nested-ternary
    const verticalThreshold = isDiagonal ? $da58cb39a64505c9$var$MAIN_THRESHOLD : mainMovement === 'horizontal' ? $da58cb39a64505c9$var$SECONDARY_THRESHOLD : $da58cb39a64505c9$var$MAIN_THRESHOLD;
    // Set horizontal direction if there's a significant movement horizontally
    if (Math.abs(deltaX) > horizontalThreshold) // Small threshold to avoid noise
    direction.horizontal = deltaX > 0 ? 'right' : 'left';
    // Set vertical direction if there's a significant movement vertically
    if (Math.abs(deltaY) > verticalThreshold) // Small threshold to avoid noise
    direction.vertical = deltaY > 0 ? 'down' : 'up';
    direction.mainAxis = isDiagonal ? 'diagonal' : mainMovement;
    return direction;
}
function $da58cb39a64505c9$var$isDiagonalMovement(previous, current) {
    const deltaX = current.x - previous.x;
    const deltaY = current.y - previous.y;
    // Calculate the angle of movement
    const angle = Math.atan2(deltaY, deltaX) * 180 / Math.PI;
    // Check if the angle is within the diagonal range
    return angle >= -45 + $da58cb39a64505c9$var$ANGLE_THRESHOLD && angle <= -22.5 + $da58cb39a64505c9$var$ANGLE_THRESHOLD || angle >= 22.5 + $da58cb39a64505c9$var$ANGLE_THRESHOLD && angle <= 45 + $da58cb39a64505c9$var$ANGLE_THRESHOLD || angle >= 135 + $da58cb39a64505c9$var$ANGLE_THRESHOLD && angle <= 157.5 + $da58cb39a64505c9$var$ANGLE_THRESHOLD || angle >= -157.5 + $da58cb39a64505c9$var$ANGLE_THRESHOLD && angle <= -135 + $da58cb39a64505c9$var$ANGLE_THRESHOLD;
}

});

parcelRegister("bXHsA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVelocity = $8b56eaae7400fe95$var$getVelocity;
/**
 * Calculate the velocity of movement between two points
 */ function $8b56eaae7400fe95$var$getVelocity(startPointer, endPointer) {
    const timeElapsed = (endPointer.timeStamp - startPointer.timeStamp) / 1000; // in seconds
    if (timeElapsed === 0) return {
        velocityX: 0,
        velocityY: 0,
        velocity: 0
    };
    const velocityX = (endPointer.clientX - startPointer.clientX) / timeElapsed;
    const velocityY = (endPointer.clientY - startPointer.clientY) / timeElapsed;
    const velocity = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
    return {
        velocityX: velocityX,
        velocityY: velocityY,
        velocity: velocity
    };
}

});

parcelRegister("dF0VD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDirectionAllowed = $9f1fd3145c25ed7e$var$isDirectionAllowed;
/**
 * Check if a direction matches one of the allowed directions
 */ function $9f1fd3145c25ed7e$var$isDirectionAllowed(direction, allowedDirections) {
    if (!direction.vertical && !direction.horizontal) return false;
    if (allowedDirections.length === 0) return true;
    // Check if the vertical direction is allowed (if it exists)
    const verticalAllowed = direction.vertical === null || allowedDirections.includes(direction.vertical);
    // Check if the horizontal direction is allowed (if it exists)
    const horizontalAllowed = direction.horizontal === null || allowedDirections.includes(direction.horizontal);
    // Both directions must be allowed
    return verticalAllowed && horizontalAllowed;
}

});

parcelRegister("fwuBT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPinchDirection = void 0;
const $b4d196bcaee479e3$var$DIRECTION_THRESHOLD = 0;
const $b4d196bcaee479e3$var$getPinchDirection = (velocity)=>{
    if (velocity > $b4d196bcaee479e3$var$DIRECTION_THRESHOLD) return 1; // Zooming in
    if (velocity < -$b4d196bcaee479e3$var$DIRECTION_THRESHOLD) return -1; // Zooming out
    return 0; // No significant movement
};
module.exports.getPinchDirection = $b4d196bcaee479e3$var$getPinchDirection;

});

parcelRegister("5dQuA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.preventDefault = void 0;
const $3cd6e2835093d3d5$var$preventDefault = (event)=>{
    if (event.cancelable) event.preventDefault();
};
module.exports.preventDefault = $3cd6e2835093d3d5$var$preventDefault;

});



parcelRegister("3dKLO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2586dd94d08a7713$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PanGesture = void 0;

var $2586dd94d08a7713$var$_extends2 = $2586dd94d08a7713$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");
/**
 * PanGesture - Detects panning (dragging) movements
 *
 * This gesture tracks pointer dragging movements across elements, firing events when:
 * - The drag movement begins and passes the threshold distance (start)
 * - The drag movement continues (ongoing)
 * - The drag movement ends (end)
 *
 * The gesture can be configured to recognize movement only in specific directions.
 */ /**
 * Configuration options for PanGesture
 * Extends PointerGestureOptions with direction constraints
 */ /**
 * Event data specific to pan gesture events
 * Contains information about movement distance, direction, and velocity
 */ /**
 * Type definition for the CustomEvent created by PanGesture
 */ /**
 * State tracking for the PanGesture
 */ /**
 * PanGesture class for handling panning/dragging interactions
 *
 * This gesture detects when users drag across elements with one or more pointers,
 * and dispatches directional movement events with delta and velocity information.
 */ class $2586dd94d08a7713$var$PanGesture extends $55SKF.PointerGesture {
    state = {
        startPointers: new Map(),
        startCentroid: null,
        lastCentroid: null,
        movementThresholdReached: false,
        totalDeltaX: 0,
        totalDeltaY: 0,
        activeDeltaX: 0,
        activeDeltaY: 0,
        lastDirection: {
            vertical: null,
            horizontal: null,
            mainAxis: null
        },
        lastDeltas: null
    };
    /**
   * Movement threshold in pixels that must be exceeded before the gesture activates.
   * Higher values reduce false positive gesture detection for small movements.
   */ /**
   * Allowed directions for the pan gesture
   * Default allows all directions
   */ constructor(options){
        super(options);
        this.direction = options.direction || [
            'up',
            'down',
            'left',
            'right'
        ];
        this.threshold = options.threshold || 0;
    }
    clone(overrides) {
        return new $2586dd94d08a7713$var$PanGesture((0, $2586dd94d08a7713$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            threshold: this.threshold,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            direction: [
                ...this.direction
            ],
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    destroy() {
        this.resetState();
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.direction = options.direction || this.direction;
        this.threshold = options.threshold ?? this.threshold;
    }
    resetState() {
        this.isActive = false;
        this.state = (0, $2586dd94d08a7713$var$_extends2.default)({}, this.state, {
            startPointers: new Map(),
            startCentroid: null,
            lastCentroid: null,
            lastDeltas: null,
            activeDeltaX: 0,
            activeDeltaY: 0,
            movementThresholdReached: false,
            lastDirection: {
                vertical: null,
                horizontal: null,
                mainAxis: null
            }
        });
    }
    /**
   * Handle pointer events for the pan gesture
   */ handlePointerEvent = (pointers, event)=>{
        const pointersArray = Array.from(pointers.values());
        // Check for our forceCancel event to handle interrupted gestures (from contextmenu, blur)
        if (event.type === 'forceCancel') {
            // Reset all active pan gestures when we get a force reset event
            this.cancel(event.target, pointersArray, event);
            return;
        }
        // Find which element (if any) is being targeted
        const targetElement = this.getTargetElement(event);
        if (!targetElement) return;
        // Check if this gesture should be prevented by active gestures
        if (this.shouldPreventGesture(targetElement, event.pointerType)) {
            // If the gesture was active but now should be prevented, cancel it gracefully
            this.cancel(targetElement, pointersArray, event);
            return;
        }
        // Filter pointers to only include those targeting our element or its children
        const relevantPointers = this.getRelevantPointers(pointersArray, targetElement);
        if (!this.isWithinPointerCount(relevantPointers, event.pointerType)) {
            // Cancel or end the gesture if it was active
            this.cancel(targetElement, relevantPointers, event);
            return;
        }
        switch(event.type){
            case 'pointerdown':
                if (!this.isActive && !this.state.startCentroid) {
                    // Store initial pointers
                    relevantPointers.forEach((pointer)=>{
                        this.state.startPointers.set(pointer.pointerId, pointer);
                    });
                    // Store the original target element
                    this.originalTarget = targetElement;
                    // Calculate and store the starting centroid
                    this.state.startCentroid = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    this.state.lastCentroid = (0, $2586dd94d08a7713$var$_extends2.default)({}, this.state.startCentroid);
                } else if (this.state.startCentroid && this.state.lastCentroid) {
                    // A new pointer was added during an active gesture
                    // Adjust the start centroid to prevent jumping
                    const oldCentroid = this.state.lastCentroid;
                    const newCentroid = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    // Calculate the offset that the new pointer would cause
                    const offsetX = newCentroid.x - oldCentroid.x;
                    const offsetY = newCentroid.y - oldCentroid.y;
                    // Adjust start centroid to compensate for the new pointer
                    this.state.startCentroid = {
                        x: this.state.startCentroid.x + offsetX,
                        y: this.state.startCentroid.y + offsetY
                    };
                    this.state.lastCentroid = newCentroid;
                    // Add the new pointer to tracked pointers
                    relevantPointers.forEach((pointer)=>{
                        if (!this.state.startPointers.has(pointer.pointerId)) this.state.startPointers.set(pointer.pointerId, pointer);
                    });
                }
                break;
            case 'pointermove':
                if (this.state.startCentroid && this.isWithinPointerCount(pointersArray, event.pointerType)) {
                    // Calculate current centroid
                    const currentCentroid = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    // Calculate delta from start
                    const distanceDeltaX = currentCentroid.x - this.state.startCentroid.x;
                    const distanceDeltaY = currentCentroid.y - this.state.startCentroid.y;
                    // Calculate movement distance
                    const distance = Math.sqrt(distanceDeltaX * distanceDeltaX + distanceDeltaY * distanceDeltaY);
                    // Determine movement direction
                    const moveDirection = (0, $lNJtn.getDirection)(this.state.lastCentroid ?? this.state.startCentroid, currentCentroid);
                    // Calculate change in position since last move
                    const lastDeltaX = this.state.lastCentroid ? currentCentroid.x - this.state.lastCentroid.x : 0;
                    const lastDeltaY = this.state.lastCentroid ? currentCentroid.y - this.state.lastCentroid.y : 0;
                    // Check if movement passes the threshold and is in an allowed direction
                    if (!this.state.movementThresholdReached && distance >= this.threshold && (0, $lNJtn.isDirectionAllowed)(moveDirection, this.direction)) {
                        this.state.movementThresholdReached = true;
                        this.isActive = true;
                        // Update total accumulated delta
                        this.state.lastDeltas = {
                            x: lastDeltaX,
                            y: lastDeltaY
                        };
                        this.state.totalDeltaX += lastDeltaX;
                        this.state.totalDeltaY += lastDeltaY;
                        this.state.activeDeltaX += lastDeltaX;
                        this.state.activeDeltaY += lastDeltaY;
                        // Emit start event
                        this.emitPanEvent(targetElement, 'start', relevantPointers, event, currentCentroid);
                        this.emitPanEvent(targetElement, 'ongoing', relevantPointers, event, currentCentroid);
                    } else if (this.state.movementThresholdReached && this.isActive) {
                        // Update total accumulated delta
                        this.state.lastDeltas = {
                            x: lastDeltaX,
                            y: lastDeltaY
                        };
                        this.state.totalDeltaX += lastDeltaX;
                        this.state.totalDeltaY += lastDeltaY;
                        this.state.activeDeltaX += lastDeltaX;
                        this.state.activeDeltaY += lastDeltaY;
                        // Emit ongoing event
                        this.emitPanEvent(targetElement, 'ongoing', relevantPointers, event, currentCentroid);
                    }
                    // Update last centroid
                    this.state.lastCentroid = currentCentroid;
                    this.state.lastDirection = moveDirection;
                }
                break;
            case 'pointerup':
            case 'pointercancel':
            case 'forceCancel':
                // If the gesture was active (threshold was reached), emit end event
                if (this.isActive && this.state.movementThresholdReached) {
                    const remainingPointers = relevantPointers.filter((p)=>p.type !== 'pointerup' && p.type !== 'pointercancel');
                    // If we no longer meet the pointer count requirements, end the gesture
                    if (!this.isWithinPointerCount(remainingPointers, event.pointerType)) {
                        // End the gesture
                        const currentCentroid = this.state.lastCentroid || this.state.startCentroid;
                        if (event.type === 'pointercancel') this.emitPanEvent(targetElement, 'cancel', relevantPointers, event, currentCentroid);
                        this.emitPanEvent(targetElement, 'end', relevantPointers, event, currentCentroid);
                        this.resetState();
                    } else if (remainingPointers.length >= 1 && this.state.lastCentroid) {
                        // If we still have enough pointers, adjust the centroid
                        // to prevent jumping when a finger is lifted
                        const newCentroid = (0, $lNJtn.calculateCentroid)(remainingPointers);
                        // Calculate the offset that removing the pointer would cause
                        const offsetX = newCentroid.x - this.state.lastCentroid.x;
                        const offsetY = newCentroid.y - this.state.lastCentroid.y;
                        // Adjust start centroid to compensate
                        this.state.startCentroid = {
                            x: this.state.startCentroid.x + offsetX,
                            y: this.state.startCentroid.y + offsetY
                        };
                        this.state.lastCentroid = newCentroid;
                        // Remove the pointer from tracked pointers
                        const removedPointerId = relevantPointers.find((p)=>p.type === 'pointerup' || p.type === 'pointercancel')?.pointerId;
                        if (removedPointerId !== undefined) this.state.startPointers.delete(removedPointerId);
                    }
                } else this.resetState();
                break;
            default:
                break;
        }
    };
    /**
   * Emit pan-specific events with additional data
   */ emitPanEvent(element, phase, pointers, event, currentCentroid) {
        if (!this.state.startCentroid) return;
        const deltaX = this.state.lastDeltas?.x ?? 0;
        const deltaY = this.state.lastDeltas?.y ?? 0;
        // Calculate velocity - time difference in seconds
        const firstPointer = this.state.startPointers.values().next().value;
        const timeElapsed = firstPointer ? (event.timeStamp - firstPointer.timeStamp) / 1000 : 0;
        const velocityX = timeElapsed > 0 ? deltaX / timeElapsed : 0;
        const velocityY = timeElapsed > 0 ? deltaY / timeElapsed : 0;
        const velocity = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        // Create custom event data
        const customEventData = {
            gestureName: this.name,
            initialCentroid: this.state.startCentroid,
            centroid: currentCentroid,
            target: event.target,
            srcEvent: event,
            phase: phase,
            pointers: pointers,
            timeStamp: event.timeStamp,
            deltaX: deltaX,
            deltaY: deltaY,
            direction: this.state.lastDirection,
            velocityX: velocityX,
            velocityY: velocityY,
            velocity: velocity,
            totalDeltaX: this.state.totalDeltaX,
            totalDeltaY: this.state.totalDeltaY,
            activeDeltaX: this.state.activeDeltaX,
            activeDeltaY: this.state.activeDeltaY,
            activeGestures: activeGestures,
            customData: this.customData
        };
        // Event names to trigger
        const eventName = (0, $lNJtn.createEventName)(this.name, phase);
        // Dispatch custom events on the element
        const domEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        element.dispatchEvent(domEvent);
        // Apply preventDefault/stopPropagation if configured
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
    }
    /**
   * Cancel the current gesture
   */ cancel(element, pointers, event) {
        if (this.isActive) {
            const el = element ?? this.element;
            this.emitPanEvent(el, 'cancel', pointers, event, this.state.lastCentroid);
            this.emitPanEvent(el, 'end', pointers, event, this.state.lastCentroid);
        }
        this.resetState();
    }
}
module.exports.PanGesture = $2586dd94d08a7713$var$PanGesture;

});

parcelRegister("gsH76", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bfc0b44f6d97e932$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PinchGesture = void 0;

var $bfc0b44f6d97e932$var$_extends2 = $bfc0b44f6d97e932$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");
/**
 * PinchGesture - Detects pinch (zoom) movements with two or more pointers
 *
 * This gesture tracks when multiple pointers move toward or away from each other, firing events when:
 * - Two or more pointers begin moving (start)
 * - The pointers continue changing distance (ongoing)
 * - One or more pointers are released or lifted (end)
 *
 * This gesture is commonly used to implement zoom functionality in touch interfaces.
 */ /**
 * Configuration options for the PinchGesture
 * Uses the same options as the base PointerGesture
 */ /**
 * Event data specific to pinch gesture events
 * Contains information about scale, distance, and velocity
 */ /**
 * Type definition for the CustomEvent created by PinchGesture
 */ /**
 * State tracking for the PinchGesture
 */ /**
 * PinchGesture class for handling pinch/zoom interactions
 *
 * This gesture detects when users move multiple pointers toward or away from each other,
 * and dispatches scale-related events with distance and velocity information.
 */ class $bfc0b44f6d97e932$var$PinchGesture extends $55SKF.PointerGesture {
    state = {
        startDistance: 0,
        lastDistance: 0,
        lastScale: 1,
        lastTime: 0,
        velocity: 0,
        totalScale: 1,
        deltaScale: 0
    };
    /**
   * Movement threshold in pixels that must be exceeded before the gesture activates.
   * Higher values reduce false positive gesture detection for small movements.
   */ constructor(options){
        super((0, $bfc0b44f6d97e932$var$_extends2.default)({}, options, {
            minPointers: options.minPointers ?? 2
        }));
        this.threshold = options.threshold ?? 0;
    }
    clone(overrides) {
        return new $bfc0b44f6d97e932$var$PinchGesture((0, $bfc0b44f6d97e932$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            threshold: this.threshold,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    destroy() {
        this.resetState();
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
    }
    resetState() {
        this.isActive = false;
        this.state = (0, $bfc0b44f6d97e932$var$_extends2.default)({}, this.state, {
            startDistance: 0,
            lastDistance: 0,
            lastScale: 1,
            lastTime: 0,
            velocity: 0,
            deltaScale: 0
        });
    }
    /**
   * Handle pointer events for the pinch gesture
   */ handlePointerEvent = (pointers, event)=>{
        const pointersArray = Array.from(pointers.values());
        // Find which element (if any) is being targeted
        const targetElement = this.getTargetElement(event);
        if (!targetElement) return;
        // Check if this gesture should be prevented by active gestures
        if (this.shouldPreventGesture(targetElement, event.pointerType)) {
            if (this.isActive) {
                // If the gesture was active but now should be prevented, end it gracefully
                this.emitPinchEvent(targetElement, 'cancel', pointersArray, event);
                this.resetState();
            }
            return;
        }
        // Filter pointers to only include those targeting our element or its children
        const relevantPointers = this.getRelevantPointers(pointersArray, targetElement);
        switch(event.type){
            case 'pointerdown':
                if (relevantPointers.length >= 2 && !this.isActive) {
                    // Calculate and store the starting distance between pointers
                    const initialDistance = (0, $lNJtn.calculateAverageDistance)(relevantPointers);
                    this.state.startDistance = initialDistance;
                    this.state.lastDistance = initialDistance;
                    this.state.lastTime = event.timeStamp;
                    // Store the original target element
                    this.originalTarget = targetElement;
                } else if (this.isActive && relevantPointers.length >= 2) {
                    // A new pointer was added during an active gesture
                    // Adjust the start distance to prevent jumping (similar to pointer removal logic)
                    const newDistance = (0, $lNJtn.calculateAverageDistance)(relevantPointers);
                    // Adjust startDistance so that the current scale is preserved
                    this.state.startDistance = newDistance / this.state.lastScale;
                    this.state.lastDistance = newDistance;
                    this.state.lastTime = event.timeStamp;
                }
                break;
            case 'pointermove':
                if (this.state.startDistance && this.isWithinPointerCount(relevantPointers, event.pointerType)) {
                    // Calculate current distance between pointers
                    const currentDistance = (0, $lNJtn.calculateAverageDistance)(relevantPointers);
                    // Calculate absolute distance change
                    const distanceChange = Math.abs(currentDistance - this.state.lastDistance);
                    // Only proceed if the distance between pointers has changed enough
                    if (distanceChange !== 0 && distanceChange >= this.threshold) {
                        // Calculate scale relative to starting distance
                        const scale = this.state.startDistance ? currentDistance / this.state.startDistance : 1;
                        // Calculate the relative scale change since last event
                        const scaleChange = scale / this.state.lastScale;
                        // Apply this change to the total accumulated scale
                        this.state.totalScale *= scaleChange;
                        // Calculate velocity (change in scale over time)
                        const deltaTime = (event.timeStamp - this.state.lastTime) / 1000; // convert to seconds
                        if (this.state.lastDistance) {
                            const deltaDistance = currentDistance - this.state.lastDistance;
                            const result = deltaDistance / deltaTime;
                            this.state.velocity = Number.isNaN(result) ? 0 : result;
                        }
                        // Update state
                        this.state.lastDistance = currentDistance;
                        this.state.deltaScale = scale - this.state.lastScale;
                        this.state.lastScale = scale;
                        this.state.lastTime = event.timeStamp;
                        if (!this.isActive) {
                            // Mark gesture as active
                            this.isActive = true;
                            // Emit start event
                            this.emitPinchEvent(targetElement, 'start', relevantPointers, event);
                            this.emitPinchEvent(targetElement, 'ongoing', relevantPointers, event);
                        } else // Emit ongoing event
                        this.emitPinchEvent(targetElement, 'ongoing', relevantPointers, event);
                    }
                }
                break;
            case 'pointerup':
            case 'pointercancel':
            case 'forceCancel':
                if (this.isActive) {
                    const remainingPointers = relevantPointers.filter((p)=>p.type !== 'pointerup' && p.type !== 'pointercancel');
                    // If we no longer meet the pointer count requirements, end the gesture
                    if (!this.isWithinPointerCount(remainingPointers, event.pointerType)) {
                        if (event.type === 'pointercancel') this.emitPinchEvent(targetElement, 'cancel', relevantPointers, event);
                        this.emitPinchEvent(targetElement, 'end', relevantPointers, event);
                        // Reset state
                        this.resetState();
                    } else if (remainingPointers.length >= 2) {
                        // If we still have enough pointers, update the start distance
                        // to prevent jumping when a finger is lifted
                        const newDistance = (0, $lNJtn.calculateAverageDistance)(remainingPointers);
                        this.state.startDistance = newDistance / this.state.lastScale;
                        this.state.lastDistance = newDistance;
                        this.state.lastTime = event.timeStamp;
                    }
                }
                break;
            default:
                break;
        }
    };
    /**
   * Emit pinch-specific events with additional data
   */ emitPinchEvent(element, phase, pointers, event) {
        // Calculate current centroid
        const centroid = (0, $lNJtn.calculateCentroid)(pointers);
        // Create custom event data
        const distance = this.state.lastDistance;
        const scale = this.state.lastScale;
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        const customEventData = {
            gestureName: this.name,
            centroid: centroid,
            target: event.target,
            srcEvent: event,
            phase: phase,
            pointers: pointers,
            timeStamp: event.timeStamp,
            scale: scale,
            deltaScale: this.state.deltaScale,
            totalScale: this.state.totalScale,
            distance: distance,
            velocity: this.state.velocity,
            activeGestures: activeGestures,
            direction: (0, $lNJtn.getPinchDirection)(this.state.velocity),
            customData: this.customData
        };
        // Handle default event behavior
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
        // Event names to trigger
        const eventName = (0, $lNJtn.createEventName)(this.name, phase);
        // Dispatch custom events on the element
        const domEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        element.dispatchEvent(domEvent);
    }
}
module.exports.PinchGesture = $bfc0b44f6d97e932$var$PinchGesture;

});

parcelRegister("gcXhr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bccbc030032a991f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PressAndDragGesture = void 0;

var $bccbc030032a991f$var$_extends2 = $bccbc030032a991f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");

var $3dKLO = parcelRequire("3dKLO");

var $8uQrn = parcelRequire("8uQrn");
/**
 * PressAndDragGesture - Detects press followed by drag gestures using composition
 *
 * This gesture uses internal PressGesture and PanGesture instances to:
 * 1. First, detect a press (hold for specified duration without movement)
 * 2. Then, track drag movements from the press position
 *
 * The gesture fires events when:
 * - A press is completed (press phase)
 * - Drag movement begins and passes threshold (dragStart)
 * - Drag movement continues (drag)
 * - Drag movement ends (dragEnd)
 * - The gesture is canceled at any point
 *
 * This is ideal for panning operations where you want to hold first, then drag.
 */ /**
 * Configuration options for PressAndDragGesture
 * Extends PointerGestureOptions with press and drag specific settings
 */ /**
 * Event data specific to press and drag gesture events
 * Contains information about the gesture state, position, and movement
 */ /**
 * Type definition for the CustomEvent created by PressAndDragGesture
 */ /**
 * Represents the current phase of the PressAndDrag gesture
 */ /**
 * State tracking for the PressAndDragGesture
 */ /**
 * PressAndDragGesture class for handling press followed by drag interactions
 *
 * This gesture composes press and drag logic patterns from PressGesture and PanGesture
 * into a single coordinated gesture that handles press-then-drag interactions.
 */ class $bccbc030032a991f$var$PressAndDragGesture extends $55SKF.PointerGesture {
    state = {
        phase: 'waitingForPress',
        dragTimeoutId: null
    };
    /**
   * Duration required for press recognition
   */ /**
   * Maximum distance a pointer can move during press for it to still be considered a press
   */ /**
   * Maximum time between press completion and drag start
   */ /**
   * Movement threshold for drag activation
   */ /**
   * Allowed directions for the drag gesture
   */ constructor(options){
        super(options);
        this.pressDuration = options.pressDuration ?? 500;
        this.pressMaxDistance = options.pressMaxDistance ?? 10;
        this.dragTimeout = options.dragTimeout ?? 1000;
        this.dragThreshold = options.dragThreshold ?? 0;
        this.dragDirection = options.dragDirection || [
            'up',
            'down',
            'left',
            'right'
        ];
        this.pressGesture = new $8uQrn.PressGesture({
            name: `${this.name}-press`,
            duration: this.pressDuration,
            maxDistance: this.pressMaxDistance,
            maxPointers: this.maxPointers,
            pointerMode: this.pointerMode,
            requiredKeys: this.requiredKeys,
            preventIf: this.preventIf,
            pointerOptions: structuredClone(this.pointerOptions)
        });
        this.panGesture = new $3dKLO.PanGesture({
            name: `${this.name}-pan`,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            threshold: this.dragThreshold,
            direction: this.dragDirection,
            pointerMode: this.pointerMode,
            requiredKeys: this.requiredKeys,
            preventIf: this.preventIf,
            pointerOptions: structuredClone(this.pointerOptions)
        });
    }
    clone(overrides) {
        return new $bccbc030032a991f$var$PressAndDragGesture((0, $bccbc030032a991f$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            pressDuration: this.pressDuration,
            pressMaxDistance: this.pressMaxDistance,
            dragTimeout: this.dragTimeout,
            dragThreshold: this.dragThreshold,
            dragDirection: [
                ...this.dragDirection
            ],
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    init(element, pointerManager, gestureRegistry, keyboardManager) {
        super.init(element, pointerManager, gestureRegistry, keyboardManager);
        this.pressGesture.init(element, pointerManager, gestureRegistry, keyboardManager);
        this.panGesture.init(element, pointerManager, gestureRegistry, keyboardManager);
        // Listen to press gesture events
        this.element.addEventListener(this.pressGesture.name, this.pressHandler);
        // Listen to pan gesture events for dragging
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(`${this.panGesture.name}Start`, this.dragStartHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(this.panGesture.name, this.dragMoveHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(`${this.panGesture.name}End`, this.dragEndHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(`${this.panGesture.name}Cancel`, this.dragEndHandler);
    }
    destroy() {
        this.resetState();
        this.pressGesture.destroy();
        this.panGesture.destroy();
        this.element.removeEventListener(this.pressGesture.name, this.pressHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(`${this.panGesture.name}Start`, this.dragStartHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(this.panGesture.name, this.dragMoveHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(`${this.panGesture.name}End`, this.dragEndHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(`${this.panGesture.name}Cancel`, this.dragEndHandler);
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.pressDuration = options.pressDuration ?? this.pressDuration;
        this.pressMaxDistance = options.pressMaxDistance ?? this.pressMaxDistance;
        this.dragTimeout = options.dragTimeout ?? this.dragTimeout;
        this.dragThreshold = options.dragThreshold ?? this.dragThreshold;
        this.dragDirection = options.dragDirection || this.dragDirection;
        // Update internal gesture options
        this.element.dispatchEvent(new CustomEvent(`${this.panGesture.name}ChangeOptions`, {
            detail: {
                minPointers: this.minPointers,
                maxPointers: this.maxPointers,
                threshold: this.dragThreshold,
                direction: this.dragDirection,
                pointerMode: this.pointerMode,
                requiredKeys: this.requiredKeys,
                preventIf: this.preventIf,
                pointerOptions: structuredClone(this.pointerOptions)
            }
        }));
        this.element.dispatchEvent(new CustomEvent(`${this.pressGesture.name}ChangeOptions`, {
            detail: {
                duration: this.pressDuration,
                maxDistance: this.pressMaxDistance,
                maxPointers: this.maxPointers,
                pointerMode: this.pointerMode,
                requiredKeys: this.requiredKeys,
                preventIf: this.preventIf,
                pointerOptions: structuredClone(this.pointerOptions)
            }
        }));
    }
    resetState() {
        if (this.state.dragTimeoutId !== null) clearTimeout(this.state.dragTimeoutId);
        this.restoreTouchAction();
        this.isActive = false;
        this.state = {
            phase: 'waitingForPress',
            dragTimeoutId: null
        };
    }
    /**
   * This can be empty because the PressAndDragGesture relies on PressGesture and PanGesture to handle pointer events
   * The internal gestures will manage their own state and events, while this class coordinates between them
   */ handlePointerEvent() {}
    pressHandler = ()=>{
        if (this.state.phase !== 'waitingForPress') return;
        this.state.phase = 'pressDetected';
        this.setTouchAction();
        // Start timeout to wait for drag start
        this.state.dragTimeoutId = setTimeout(()=>{
            // Timeout expired, reset gesture
            this.resetState();
        }, this.dragTimeout);
    };
    dragStartHandler = (event)=>{
        if (this.state.phase !== 'pressDetected') return;
        // Clear the drag timeout as drag has started
        if (this.state.dragTimeoutId !== null) {
            clearTimeout(this.state.dragTimeoutId);
            this.state.dragTimeoutId = null;
        }
        // Restore touch action since we're now dragging
        this.restoreTouchAction();
        this.state.phase = 'dragging';
        this.isActive = true;
        // Fire start event
        this.element.dispatchEvent(new CustomEvent((0, $lNJtn.createEventName)(this.name, event.detail.phase), event));
    };
    dragMoveHandler = (event)=>{
        if (this.state.phase !== 'dragging') return;
        // Fire move event
        this.element.dispatchEvent(new CustomEvent((0, $lNJtn.createEventName)(this.name, event.detail.phase), event));
    };
    dragEndHandler = (event)=>{
        if (this.state.phase !== 'dragging') return;
        this.resetState();
        // Fire end event
        this.element.dispatchEvent(new CustomEvent((0, $lNJtn.createEventName)(this.name, event.detail.phase), event));
    };
    setTouchAction() {
        this.element.addEventListener('touchstart', $lNJtn.preventDefault, {
            passive: false
        });
        this.element.addEventListener('touchmove', $lNJtn.preventDefault, {
            passive: false
        });
        this.element.addEventListener('touchend', $lNJtn.preventDefault, {
            passive: false
        });
    }
    restoreTouchAction() {
        this.element.removeEventListener('touchstart', $lNJtn.preventDefault);
        this.element.removeEventListener('touchmove', $lNJtn.preventDefault);
        this.element.removeEventListener('touchend', $lNJtn.preventDefault);
    }
}
module.exports.PressAndDragGesture = $bccbc030032a991f$var$PressAndDragGesture;

});
parcelRegister("8uQrn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $62f9cda929fee2ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PressGesture = void 0;

var $62f9cda929fee2ca$var$_extends2 = $62f9cda929fee2ca$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");
/**
 * PressGesture - Detects press and hold interactions
 *
 * This gesture tracks when users press and hold on an element for a specified duration, firing events when:
 * - The press begins and passes the holding threshold time (start, ongoing)
 * - The press ends (end)
 * - The press is canceled by movement beyond threshold (cancel)
 *
 * This gesture is commonly used for contextual menus, revealing additional options, or alternate actions.
 */ /**
 * Configuration options for PressGesture
 * Extends PointerGestureOptions with press-specific options
 */ /**
 * Event data specific to press gesture events
 * Contains information about the press location and duration
 */ /**
 * Type definition for the CustomEvent created by PressGesture
 */ /**
 * State tracking for the PressGesture
 */ /**
 * PressGesture class for handling press/hold interactions
 *
 * This gesture detects when users press and hold on an element for a specified duration,
 * and dispatches press-related events when the user holds long enough.
 *
 * The `start` and `ongoing` events are dispatched at the same time once the press threshold is reached.
 * If the press is canceled (event.g., by moving too far), a `cancel` event is dispatched before the `end` event.
 */ class $62f9cda929fee2ca$var$PressGesture extends $55SKF.PointerGesture {
    state = {
        startCentroid: null,
        lastPosition: null,
        timerId: null,
        startTime: 0,
        pressThresholdReached: false
    };
    /**
   * Duration in milliseconds required to hold before the press gesture is recognized
   */ /**
   * Maximum distance a pointer can move for a gesture to still be considered a press
   */ constructor(options){
        super(options);
        this.duration = options.duration ?? 500;
        this.maxDistance = options.maxDistance ?? 10;
    }
    clone(overrides) {
        return new $62f9cda929fee2ca$var$PressGesture((0, $62f9cda929fee2ca$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            duration: this.duration,
            maxDistance: this.maxDistance,
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    destroy() {
        this.clearPressTimer();
        this.resetState();
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.duration = options.duration ?? this.duration;
        this.maxDistance = options.maxDistance ?? this.maxDistance;
    }
    resetState() {
        this.clearPressTimer();
        this.isActive = false;
        this.state = (0, $62f9cda929fee2ca$var$_extends2.default)({}, this.state, {
            startCentroid: null,
            lastPosition: null,
            timerId: null,
            startTime: 0,
            pressThresholdReached: false
        });
    }
    /**
   * Clear the press timer if it's active
   */ clearPressTimer() {
        if (this.state.timerId !== null) {
            clearTimeout(this.state.timerId);
            this.state.timerId = null;
        }
    }
    /**
   * Handle pointer events for the press gesture
   */ handlePointerEvent = (pointers, event)=>{
        const pointersArray = Array.from(pointers.values());
        // Check for our forceCancel event to handle interrupted gestures (from contextmenu, blur)
        if (event.type === 'forceCancel') {
            // Reset all active press gestures when we get a force reset event
            this.cancelPress(event.target, pointersArray, event);
            return;
        }
        // Find which element (if any) is being targeted
        const targetElement = this.getTargetElement(event);
        if (!targetElement) return;
        // Check if this gesture should be prevented by active gestures
        if (this.shouldPreventGesture(targetElement, event.pointerType)) {
            if (this.isActive) // If the gesture was active but now should be prevented, cancel it gracefully
            this.cancelPress(targetElement, pointersArray, event);
            return;
        }
        // Filter pointers to only include those targeting our element or its children
        const relevantPointers = this.getRelevantPointers(pointersArray, targetElement);
        if (!this.isWithinPointerCount(relevantPointers, event.pointerType)) {
            if (this.isActive) // Cancel or end the gesture if it was active
            this.cancelPress(targetElement, relevantPointers, event);
            return;
        }
        switch(event.type){
            case 'pointerdown':
                if (!this.isActive && !this.state.startCentroid) {
                    // Calculate and store the starting centroid
                    this.state.startCentroid = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    this.state.lastPosition = (0, $62f9cda929fee2ca$var$_extends2.default)({}, this.state.startCentroid);
                    this.state.startTime = event.timeStamp;
                    this.isActive = true;
                    // Store the original target element
                    this.originalTarget = targetElement;
                    // Start the timer for press recognition
                    this.clearPressTimer(); // Clear any existing timer first
                    this.state.timerId = setTimeout(()=>{
                        if (this.isActive && this.state.startCentroid) {
                            this.state.pressThresholdReached = true;
                            const lastPosition = this.state.lastPosition;
                            // Emit press start event
                            this.emitPressEvent(targetElement, 'start', relevantPointers, event, lastPosition);
                            this.emitPressEvent(targetElement, 'ongoing', relevantPointers, event, lastPosition);
                        }
                    }, this.duration);
                }
                break;
            case 'pointermove':
                if (this.isActive && this.state.startCentroid) {
                    // Calculate current position
                    const currentPosition = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    this.state.lastPosition = currentPosition;
                    // Calculate distance from start position
                    const deltaX = currentPosition.x - this.state.startCentroid.x;
                    const deltaY = currentPosition.y - this.state.startCentroid.y;
                    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                    // If moved too far, cancel the press gesture
                    if (distance > this.maxDistance) this.cancelPress(targetElement, relevantPointers, event);
                }
                break;
            case 'pointerup':
                if (this.isActive) {
                    if (this.state.pressThresholdReached) {
                        // Complete the press gesture if we've held long enough
                        const position = this.state.lastPosition || this.state.startCentroid;
                        this.emitPressEvent(targetElement, 'end', relevantPointers, event, position);
                    }
                    // Reset state
                    this.resetState();
                }
                break;
            case 'pointercancel':
            case 'forceCancel':
                // Cancel the gesture
                this.cancelPress(targetElement, relevantPointers, event);
                break;
            default:
                break;
        }
    };
    /**
   * Emit press-specific events with additional data
   */ emitPressEvent(element, phase, pointers, event, position) {
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        // Calculate current duration of the press
        const currentDuration = event.timeStamp - this.state.startTime;
        // Create custom event data
        const customEventData = {
            gestureName: this.name,
            centroid: position,
            target: event.target,
            srcEvent: event,
            phase: phase,
            pointers: pointers,
            timeStamp: event.timeStamp,
            x: position.x,
            y: position.y,
            duration: currentDuration,
            activeGestures: activeGestures,
            customData: this.customData
        };
        // Event names to trigger
        const eventName = (0, $lNJtn.createEventName)(this.name, phase);
        // Dispatch custom events on the element
        const domEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        element.dispatchEvent(domEvent);
        // Apply preventDefault/stopPropagation if configured
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
    }
    /**
   * Cancel the current press gesture
   */ cancelPress(element, pointers, event) {
        if (this.isActive && this.state.pressThresholdReached) {
            const position = this.state.lastPosition || this.state.startCentroid;
            this.emitPressEvent(element ?? this.element, 'cancel', pointers, event, position);
            this.emitPressEvent(element ?? this.element, 'end', pointers, event, position);
        }
        this.resetState();
    }
}
module.exports.PressGesture = $62f9cda929fee2ca$var$PressGesture;

});


parcelRegister("9xH2P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6f2895dd984fb567$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RotateGesture = void 0;

var $6f2895dd984fb567$var$_extends2 = $6f2895dd984fb567$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");
/**
 * RotateGesture - Detects rotation movements between two or more pointers
 *
 * This gesture tracks when multiple pointers rotate around a common center point, firing events when:
 * - Two or more pointers begin a rotation motion (start)
 * - The pointers continue rotating (ongoing)
 * - One or more pointers are released or lifted (end)
 *
 * This gesture is commonly used for rotation controls in drawing or image manipulation interfaces.
 */ /**
 * Configuration options for the RotateGesture
 * Uses the same options as the base PointerGesture
 */ /**
 * Event data specific to rotate gesture events
 * Contains information about rotation angle, delta, and velocity
 */ /**
 * Type definition for the CustomEvent created by RotateGesture
 */ /**
 * State tracking for the RotateGesture
 */ /**
 * RotateGesture class for handling rotation interactions
 *
 * This gesture detects when users rotate multiple pointers around a central point,
 * and dispatches rotation-related events with angle and angular velocity information.
 */ class $6f2895dd984fb567$var$RotateGesture extends $55SKF.PointerGesture {
    state = {
        startAngle: 0,
        lastAngle: 0,
        totalRotation: 0,
        lastTime: 0,
        velocity: 0,
        lastDelta: 0
    };
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(options){
        super(options);
    }
    clone(overrides) {
        return new $6f2895dd984fb567$var$RotateGesture((0, $6f2895dd984fb567$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    destroy() {
        this.resetState();
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
    }
    resetState() {
        this.isActive = false;
        this.state = (0, $6f2895dd984fb567$var$_extends2.default)({}, this.state, {
            startAngle: 0,
            lastAngle: 0,
            lastTime: 0,
            velocity: 0,
            lastDelta: 0
        });
    }
    /**
   * Handle pointer events for the rotate gesture
   */ handlePointerEvent = (pointers, event)=>{
        const pointersArray = Array.from(pointers.values());
        // Find which element (if any) is being targeted
        const targetElement = this.getTargetElement(event);
        if (!targetElement) return;
        // Check if this gesture should be prevented by active gestures
        if (this.shouldPreventGesture(targetElement, event.pointerType)) {
            if (this.isActive) {
                // If the gesture was active but now should be prevented, end it gracefully
                this.emitRotateEvent(targetElement, 'cancel', pointersArray, event);
                this.resetState();
            }
            return;
        }
        // Filter pointers to only include those targeting our element or its children
        const relevantPointers = this.getRelevantPointers(pointersArray, targetElement);
        // Check if we have enough pointers for a rotation (at least 2)
        if (!this.isWithinPointerCount(relevantPointers, event.pointerType)) {
            if (this.isActive) {
                // End the gesture if it was active
                this.emitRotateEvent(targetElement, 'end', relevantPointers, event);
                this.resetState();
            }
            return;
        }
        switch(event.type){
            case 'pointerdown':
                if (relevantPointers.length >= 2 && !this.isActive) {
                    // Calculate and store the starting angle
                    const initialAngle = (0, $lNJtn.calculateRotationAngle)(relevantPointers);
                    this.state.startAngle = initialAngle;
                    this.state.lastAngle = initialAngle;
                    this.state.lastTime = event.timeStamp;
                    // Store the original target element
                    this.originalTarget = targetElement;
                } else if (this.isActive && relevantPointers.length >= 2) {
                    // A new pointer was added during an active gesture
                    // Adjust the start angle to prevent jumping (similar to pointer removal logic)
                    const newAngle = (0, $lNJtn.calculateRotationAngle)(relevantPointers);
                    // Adjust startAngle so that the total rotation is preserved
                    this.state.startAngle = newAngle - this.state.totalRotation;
                    this.state.lastAngle = newAngle;
                    this.state.lastTime = event.timeStamp;
                }
                break;
            case 'pointermove':
                if (relevantPointers.length >= 2) {
                    // Calculate current rotation angle
                    const currentAngle = (0, $lNJtn.calculateRotationAngle)(relevantPointers);
                    // Calculate rotation delta (change in angle)
                    let delta = currentAngle - this.state.lastAngle;
                    // Adjust for angle wrapping (event.g., from 359° to 0°)
                    if (delta > 180) delta -= 360;
                    if (delta < -180) delta += 360;
                    // Emit ongoing event if there's an actual rotation
                    // We don't want to emit events for tiny movements that might be just noise
                    if (Math.abs(delta) <= 0.1) return;
                    // Store the delta for use in emitRotateEvent
                    this.state.lastDelta = delta;
                    // Update rotation value (cumulative)
                    this.state.totalRotation += delta;
                    // Calculate angular velocity (degrees per second)
                    const deltaTime = (event.timeStamp - this.state.lastTime) / 1000; // convert to seconds
                    if (deltaTime > 0) this.state.velocity = delta / deltaTime;
                    // Update state
                    this.state.lastAngle = currentAngle;
                    this.state.lastTime = event.timeStamp;
                    if (!this.isActive) {
                        this.isActive = true;
                        // Emit start event
                        this.emitRotateEvent(targetElement, 'start', relevantPointers, event);
                        this.emitRotateEvent(targetElement, 'ongoing', relevantPointers, event);
                    } else this.emitRotateEvent(targetElement, 'ongoing', relevantPointers, event);
                }
                break;
            case 'pointerup':
            case 'pointercancel':
            case 'forceCancel':
                if (this.isActive) {
                    const remainingPointers = relevantPointers.filter((p)=>p.type !== 'pointerup' && p.type !== 'pointercancel');
                    // If we no longer meet the pointer count requirements, end the gesture
                    if (!this.isWithinPointerCount(remainingPointers, event.pointerType)) {
                        if (event.type === 'pointercancel') this.emitRotateEvent(targetElement, 'cancel', relevantPointers, event);
                        this.emitRotateEvent(targetElement, 'end', relevantPointers, event);
                        // Reset state
                        this.resetState();
                    } else if (remainingPointers.length >= 2) {
                        // If we still have enough pointers, update the start angle
                        // to prevent jumping when a finger is lifted
                        const newAngle = (0, $lNJtn.calculateRotationAngle)(remainingPointers);
                        this.state.startAngle = newAngle - this.state.totalRotation;
                        this.state.lastAngle = newAngle;
                    }
                }
                break;
            default:
                break;
        }
    };
    /**
   * Emit rotate-specific events with additional data
   */ emitRotateEvent(element, phase, pointers, event) {
        // Calculate current centroid
        const centroid = (0, $lNJtn.calculateCentroid)(pointers);
        // Create custom event data
        const rotation = this.state.totalRotation;
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        const customEventData = {
            gestureName: this.name,
            centroid: centroid,
            target: event.target,
            srcEvent: event,
            phase: phase,
            pointers: pointers,
            timeStamp: event.timeStamp,
            rotation: rotation,
            delta: this.state.lastDelta,
            totalRotation: this.state.totalRotation,
            velocity: this.state.velocity,
            activeGestures: activeGestures,
            customData: this.customData
        };
        // Handle default event behavior
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
        // Event names to trigger
        const eventName = (0, $lNJtn.createEventName)(this.name, phase);
        // Dispatch custom events on the element
        const domEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        element.dispatchEvent(domEvent);
    }
}
module.exports.RotateGesture = $6f2895dd984fb567$var$RotateGesture;

});

parcelRegister("11RrP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0bff580d8c189fe1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TapAndDragGesture = void 0;

var $0bff580d8c189fe1$var$_extends2 = $0bff580d8c189fe1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");

var $3dKLO = parcelRequire("3dKLO");

var $7pNPD = parcelRequire("7pNPD");
/**
 * TapAndDragGesture - Detects tap followed by drag gestures using composition
 *
 * This gesture uses internal TapGesture and PanGesture instances to:
 * 1. First, detect a tap (quick touch without movement)
 * 2. Then, track drag movements on the next pointer down
 *
 * The gesture fires events when:
 * - A tap is completed (tap phase)
 * - Drag movement begins and passes threshold (dragStart)
 * - Drag movement continues (drag)
 * - Drag movement ends (dragEnd)
 * - The gesture is canceled at any point
 */ /**
 * Configuration options for TapAndDragGesture
 * Extends PointerGestureOptions with tap and drag specific settings
 */ /**
 * Event data specific to tap and drag gesture events
 * Contains information about the gesture state, position, and movement
 */ /**
 * Type definition for the CustomEvent created by TapAndDragGesture
 */ /**
 * Represents the current phase of the TapAndDrag gesture
 */ /**
 * State tracking for the TapAndDragGesture
 */ /**
 * TapAndDragGesture class for handling tap followed by drag interactions
 *
 * This gesture composes tap and drag logic patterns from TapGesture and PanGesture
 * into a single coordinated gesture that handles tap-then-drag interactions.
 */ class $0bff580d8c189fe1$var$TapAndDragGesture extends $55SKF.PointerGesture {
    state = {
        phase: 'waitingForTap',
        dragTimeoutId: null
    };
    /**
   * Maximum distance a pointer can move during tap for it to still be considered a tap
   * (Following TapGesture pattern)
   */ /**
   * Maximum time between tap completion and drag start
   */ /**
   * Movement threshold for drag activation
   */ /**
   * Allowed directions for the drag gesture
   */ constructor(options){
        super(options);
        this.tapMaxDistance = options.tapMaxDistance ?? 10;
        this.dragTimeout = options.dragTimeout ?? 1000;
        this.dragThreshold = options.dragThreshold ?? 0;
        this.dragDirection = options.dragDirection || [
            'up',
            'down',
            'left',
            'right'
        ];
        this.tapGesture = new $7pNPD.TapGesture({
            name: `${this.name}-tap`,
            maxDistance: this.tapMaxDistance,
            maxPointers: this.maxPointers,
            pointerMode: this.pointerMode,
            requiredKeys: this.requiredKeys,
            preventIf: this.preventIf,
            pointerOptions: structuredClone(this.pointerOptions)
        });
        this.panGesture = new $3dKLO.PanGesture({
            name: `${this.name}-pan`,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            threshold: this.dragThreshold,
            direction: this.dragDirection,
            pointerMode: this.pointerMode,
            requiredKeys: this.requiredKeys,
            preventIf: this.preventIf,
            pointerOptions: structuredClone(this.pointerOptions)
        });
    }
    clone(overrides) {
        return new $0bff580d8c189fe1$var$TapAndDragGesture((0, $0bff580d8c189fe1$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            tapMaxDistance: this.tapMaxDistance,
            dragTimeout: this.dragTimeout,
            dragThreshold: this.dragThreshold,
            dragDirection: [
                ...this.dragDirection
            ],
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    init(element, pointerManager, gestureRegistry, keyboardManager) {
        super.init(element, pointerManager, gestureRegistry, keyboardManager);
        this.tapGesture.init(element, pointerManager, gestureRegistry, keyboardManager);
        this.panGesture.init(element, pointerManager, gestureRegistry, keyboardManager);
        this.element.addEventListener(this.tapGesture.name, this.tapHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(`${this.panGesture.name}Start`, this.dragStartHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(this.panGesture.name, this.dragMoveHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(`${this.panGesture.name}End`, this.dragEndHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.addEventListener(`${this.panGesture.name}Cancel`, this.dragEndHandler);
    }
    destroy() {
        this.resetState();
        this.tapGesture.destroy();
        this.panGesture.destroy();
        this.element.removeEventListener(this.tapGesture.name, this.tapHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(`${this.panGesture.name}Start`, this.dragStartHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(this.panGesture.name, this.dragMoveHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(`${this.panGesture.name}End`, this.dragEndHandler);
        // @ts-expect-error, PointerEvent is correct.
        this.element.removeEventListener(`${this.panGesture.name}Cancel`, this.dragEndHandler);
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.tapMaxDistance = options.tapMaxDistance ?? this.tapMaxDistance;
        this.dragTimeout = options.dragTimeout ?? this.dragTimeout;
        this.dragThreshold = options.dragThreshold ?? this.dragThreshold;
        this.dragDirection = options.dragDirection || this.dragDirection;
        this.element.dispatchEvent(new CustomEvent(`${this.panGesture.name}ChangeOptions`, {
            detail: {
                minPointers: this.minPointers,
                maxPointers: this.maxPointers,
                threshold: this.dragThreshold,
                direction: this.dragDirection,
                pointerMode: this.pointerMode,
                requiredKeys: this.requiredKeys,
                preventIf: this.preventIf,
                pointerOptions: structuredClone(this.pointerOptions)
            }
        }));
        this.element.dispatchEvent(new CustomEvent(`${this.tapGesture.name}ChangeOptions`, {
            detail: {
                maxDistance: this.tapMaxDistance,
                maxPointers: this.maxPointers,
                pointerMode: this.pointerMode,
                requiredKeys: this.requiredKeys,
                preventIf: this.preventIf,
                pointerOptions: structuredClone(this.pointerOptions)
            }
        }));
    }
    resetState() {
        if (this.state.dragTimeoutId !== null) clearTimeout(this.state.dragTimeoutId);
        this.restoreTouchAction();
        this.isActive = false;
        this.state = {
            phase: 'waitingForTap',
            dragTimeoutId: null
        };
    }
    /**
   * This can be empty because the TapAndDragGesture relies on TapGesture and PanGesture to handle pointer events
   * The internal gestures will manage their own state and events, while this class coordinates between them
   */ handlePointerEvent() {}
    tapHandler = ()=>{
        if (this.state.phase !== 'waitingForTap') return;
        this.state.phase = 'tapDetected';
        this.setTouchAction();
        // Start timeout to wait for drag start
        this.state.dragTimeoutId = setTimeout(()=>{
            // Timeout expired, reset gesture
            this.resetState();
        }, this.dragTimeout);
    };
    dragStartHandler = (event)=>{
        if (this.state.phase !== 'tapDetected') return;
        // Clear the drag timeout as drag has started
        if (this.state.dragTimeoutId !== null) {
            clearTimeout(this.state.dragTimeoutId);
            this.state.dragTimeoutId = null;
        }
        this.restoreTouchAction();
        this.state.phase = 'dragging';
        this.isActive = true;
        // Fire start event
        this.element.dispatchEvent(new CustomEvent((0, $lNJtn.createEventName)(this.name, event.detail.phase), event));
    };
    dragMoveHandler = (event)=>{
        if (this.state.phase !== 'dragging') return;
        // Fire move event
        this.element.dispatchEvent(new CustomEvent((0, $lNJtn.createEventName)(this.name, event.detail.phase), event));
    };
    dragEndHandler = (event)=>{
        if (this.state.phase !== 'dragging') return;
        this.resetState();
        // Fire end event
        this.element.dispatchEvent(new CustomEvent((0, $lNJtn.createEventName)(this.name, event.detail.phase), event));
    };
    setTouchAction() {
        this.element.addEventListener('touchstart', $lNJtn.preventDefault, {
            passive: false
        });
    }
    restoreTouchAction() {
        this.element.removeEventListener('touchstart', $lNJtn.preventDefault);
    }
}
module.exports.TapAndDragGesture = $0bff580d8c189fe1$var$TapAndDragGesture;

});
parcelRegister("7pNPD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $566185bef3a38946$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TapGesture = void 0;

var $566185bef3a38946$var$_extends2 = $566185bef3a38946$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $55SKF = parcelRequire("55SKF");

var $lNJtn = parcelRequire("lNJtn");
/**
 * TapGesture - Detects tap (quick touch without movement) gestures
 *
 * This gesture tracks simple tap interactions on elements, firing a single event when:
 * - A complete tap is detected (pointerup after brief touch without excessive movement)
 * - The tap is canceled (event.g., moved too far or held too long)
 */ /**
 * Configuration options for TapGesture
 * Extends PointerGestureOptions with tap-specific settings
 */ /**
 * Event data specific to tap gesture events
 * Contains information about the tap location and counts
 */ /**
 * Type definition for the CustomEvent created by TapGesture
 */ /**
 * State tracking for the TapGesture
 */ /**
 * TapGesture class for handling tap interactions
 *
 * This gesture detects when users tap on elements without significant movement,
 * and can recognize single taps, double taps, or other multi-tap sequences.
 */ class $566185bef3a38946$var$TapGesture extends $55SKF.PointerGesture {
    state = {
        startCentroid: null,
        currentTapCount: 0,
        lastTapTime: 0,
        lastPosition: null
    };
    /**
   * Maximum distance a pointer can move for a gesture to still be considered a tap
   */ /**
   * Number of consecutive taps to detect
   */ constructor(options){
        super(options);
        this.maxDistance = options.maxDistance ?? 10;
        this.taps = options.taps ?? 1;
    }
    clone(overrides) {
        return new $566185bef3a38946$var$TapGesture((0, $566185bef3a38946$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            minPointers: this.minPointers,
            maxPointers: this.maxPointers,
            maxDistance: this.maxDistance,
            taps: this.taps,
            requiredKeys: [
                ...this.requiredKeys
            ],
            pointerMode: [
                ...this.pointerMode
            ],
            preventIf: [
                ...this.preventIf
            ],
            pointerOptions: structuredClone(this.pointerOptions)
        }, overrides));
    }
    destroy() {
        this.resetState();
        super.destroy();
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.maxDistance = options.maxDistance ?? this.maxDistance;
        this.taps = options.taps ?? this.taps;
    }
    resetState() {
        this.isActive = false;
        this.state = {
            startCentroid: null,
            currentTapCount: 0,
            lastTapTime: 0,
            lastPosition: null
        };
    }
    /**
   * Handle pointer events for the tap gesture
   */ handlePointerEvent = (pointers, event)=>{
        const pointersArray = Array.from(pointers.values());
        // Find which element (if any) is being targeted
        const targetElement = this.getTargetElement(event);
        if (!targetElement) return;
        // Filter pointers to only include those targeting our element or its children
        const relevantPointers = this.getRelevantPointers(pointersArray, targetElement);
        if (this.shouldPreventGesture(targetElement, event.pointerType) || !this.isWithinPointerCount(relevantPointers, event.pointerType)) {
            if (this.isActive) // Cancel the gesture if it was active
            this.cancelTap(targetElement, relevantPointers, event);
            return;
        }
        switch(event.type){
            case 'pointerdown':
                if (!this.isActive) {
                    // Calculate and store the starting centroid
                    this.state.startCentroid = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    this.state.lastPosition = (0, $566185bef3a38946$var$_extends2.default)({}, this.state.startCentroid);
                    this.isActive = true;
                    // Store the original target element
                    this.originalTarget = targetElement;
                }
                break;
            case 'pointermove':
                if (this.isActive && this.state.startCentroid) {
                    // Calculate current position
                    const currentPosition = (0, $lNJtn.calculateCentroid)(relevantPointers);
                    this.state.lastPosition = currentPosition;
                    // Calculate distance from start position
                    const deltaX = currentPosition.x - this.state.startCentroid.x;
                    const deltaY = currentPosition.y - this.state.startCentroid.y;
                    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                    // If moved too far, cancel the tap gesture
                    if (distance > this.maxDistance) this.cancelTap(targetElement, relevantPointers, event);
                }
                break;
            case 'pointerup':
                if (this.isActive) {
                    // For valid tap: increment tap count
                    this.state.currentTapCount += 1;
                    // Make sure we have a valid position before firing the tap event
                    const position = this.state.lastPosition || this.state.startCentroid;
                    if (!position) {
                        this.cancelTap(targetElement, relevantPointers, event);
                        return;
                    }
                    // Check if we've reached the desired number of taps
                    if (this.state.currentTapCount >= this.taps) {
                        // The complete tap sequence has been detected - fire the tap event
                        this.fireTapEvent(targetElement, relevantPointers, event, position);
                        // Reset state after successful tap
                        this.resetState();
                    } else {
                        // Store the time of this tap for multi-tap detection
                        this.state.lastTapTime = event.timeStamp;
                        // Reset active state but keep the tap count for multi-tap detection
                        this.isActive = false;
                        // For multi-tap detection: keep track of the last tap position
                        // but clear the start centroid to prepare for next tap
                        this.state.startCentroid = null;
                        // Start a timeout to reset the tap count if the next tap doesn't come soon enough
                        setTimeout(()=>{
                            if (this.state && this.state.currentTapCount > 0 && this.state.currentTapCount < this.taps) this.state.currentTapCount = 0;
                        }, 300); // 300ms is a typical double-tap detection window
                    }
                }
                break;
            case 'pointercancel':
            case 'forceCancel':
                // Cancel the gesture
                this.cancelTap(targetElement, relevantPointers, event);
                break;
            default:
                break;
        }
    };
    /**
   * Fire the main tap event when a valid tap is detected
   */ fireTapEvent(element, pointers, event, position) {
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(element);
        // Create custom event data for the tap event
        const customEventData = {
            gestureName: this.name,
            centroid: position,
            target: event.target,
            srcEvent: event,
            phase: 'end',
            pointers: // The tap is complete, so we use 'end' state for the event data
            pointers,
            timeStamp: event.timeStamp,
            x: position.x,
            y: position.y,
            tapCount: this.state.currentTapCount,
            activeGestures: activeGestures,
            customData: this.customData
        };
        // Dispatch a single 'tap' event (not 'tapStart', 'tapEnd', etc.)
        const domEvent = new CustomEvent(this.name, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        element.dispatchEvent(domEvent);
        // Apply preventDefault/stopPropagation if configured
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
    }
    /**
   * Cancel the current tap gesture
   */ cancelTap(element, pointers, event) {
        if (this.state.startCentroid || this.state.lastPosition) {
            const position = this.state.lastPosition || this.state.startCentroid;
            // Get list of active gestures
            const activeGestures = this.gesturesRegistry.getActiveGestures(element);
            // Create custom event data for the cancel event
            const customEventData = {
                gestureName: this.name,
                centroid: position,
                target: event.target,
                srcEvent: event,
                phase: 'cancel',
                pointers: pointers,
                timeStamp: event.timeStamp,
                x: position.x,
                y: position.y,
                tapCount: this.state.currentTapCount,
                activeGestures: activeGestures,
                customData: this.customData
            };
            // Dispatch a 'tapCancel' event
            const eventName = (0, $lNJtn.createEventName)(this.name, 'cancel');
            const domEvent = new CustomEvent(eventName, {
                bubbles: true,
                cancelable: true,
                composed: true,
                detail: customEventData
            });
            element.dispatchEvent(domEvent);
        }
        this.resetState();
    }
}
module.exports.TapGesture = $566185bef3a38946$var$TapGesture;

});


parcelRegister("c3fSy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8c62150fb22b9f35$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TurnWheelGesture = void 0;

var $8c62150fb22b9f35$var$_extends2 = $8c62150fb22b9f35$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bpdfU = parcelRequire("bpdfU");

var $lNJtn = parcelRequire("lNJtn");
/**
 * TurnWheelGesture - Detects wheel events on an element
 *
 * This gesture tracks mouse wheel or touchpad scroll events on elements, firing events when:
 * - The user scrolls/wheels on the element (ongoing)
 *
 * Unlike other gestures which may have start/ongoing/end states,
 * wheel gestures are always considered "ongoing" since they are discrete events.
 */ /**
 * Configuration options for the TurnWheelGesture
 * Uses the base gesture options with additional wheel-specific options
 */ /**
 * Event data specific to wheel gesture events
 * Contains information about scroll delta amounts and mode
 */ /**
 * Type definition for the CustomEvent created by TurnWheelGesture
 */ /**
 * State tracking for the TurnWheelGesture
 */ /**
 * TurnWheelGesture class for handling wheel/scroll interactions
 *
 * This gesture detects when users scroll or use the mouse wheel on elements,
 * and dispatches corresponding scroll events with delta information.
 * Unlike most gestures, it extends directly from Gesture rather than PointerGesture.
 */ class $8c62150fb22b9f35$var$TurnWheelGesture extends $bpdfU.Gesture {
    state = {
        totalDeltaX: 0,
        totalDeltaY: 0,
        totalDeltaZ: 0
    };
    /**
   * Scaling factor for delta values
   * Values > 1 increase sensitivity, values < 1 decrease sensitivity
   */ /**
   * Maximum value for totalDelta values
   * Limits how large the accumulated wheel deltas can be
   */ /**
   * Minimum value for totalDelta values
   * Sets a lower bound for accumulated wheel deltas
   */ /**
   * Initial value for totalDelta values
   * Sets the starting value for delta trackers
   */ /**
   * Whether to invert the direction of delta changes
   * When true, reverses the sign of deltaX, deltaY, and deltaZ values
   */ constructor(options){
        super(options);
        this.sensitivity = options.sensitivity ?? 1;
        this.max = options.max ?? Number.MAX_SAFE_INTEGER;
        this.min = options.min ?? Number.MIN_SAFE_INTEGER;
        this.initialDelta = options.initialDelta ?? 0;
        this.invert = options.invert ?? false;
        this.state.totalDeltaX = this.initialDelta;
        this.state.totalDeltaY = this.initialDelta;
        this.state.totalDeltaZ = this.initialDelta;
    }
    clone(overrides) {
        return new $8c62150fb22b9f35$var$TurnWheelGesture((0, $8c62150fb22b9f35$var$_extends2.default)({
            name: this.name,
            preventDefault: this.preventDefault,
            stopPropagation: this.stopPropagation,
            sensitivity: this.sensitivity,
            max: this.max,
            min: this.min,
            initialDelta: this.initialDelta,
            invert: this.invert,
            requiredKeys: [
                ...this.requiredKeys
            ],
            preventIf: [
                ...this.preventIf
            ]
        }, overrides));
    }
    init(element, pointerManager, gestureRegistry, keyboardManager) {
        super.init(element, pointerManager, gestureRegistry, keyboardManager);
        // Add event listener directly to the element
        // @ts-expect-error, WheelEvent is correct.
        this.element.addEventListener('wheel', this.handleWheelEvent);
    }
    destroy() {
        // Remove the element-specific event listener
        // @ts-expect-error, WheelEvent is correct.
        this.element.removeEventListener('wheel', this.handleWheelEvent);
        this.resetState();
        super.destroy();
    }
    resetState() {
        this.isActive = false;
        this.state = {
            totalDeltaX: 0,
            totalDeltaY: 0,
            totalDeltaZ: 0
        };
    }
    updateOptions(options) {
        super.updateOptions(options);
        this.sensitivity = options.sensitivity ?? this.sensitivity;
        this.max = options.max ?? this.max;
        this.min = options.min ?? this.min;
        this.initialDelta = options.initialDelta ?? this.initialDelta;
        this.invert = options.invert ?? this.invert;
    }
    /**
   * Handle wheel events for a specific element
   * @param element The element that received the wheel event
   * @param event The original wheel event
   */ handleWheelEvent = (event)=>{
        // Check if this gesture should be prevented by active gestures
        if (this.shouldPreventGesture(this.element, 'mouse')) return;
        // Get pointers from the PointerManager to use for centroid calculation
        const pointers = this.pointerManager.getPointers() || new Map();
        const pointersArray = Array.from(pointers.values());
        // Update total deltas with scaled values
        this.state.totalDeltaX += event.deltaX * this.sensitivity * (this.invert ? -1 : 1);
        this.state.totalDeltaY += event.deltaY * this.sensitivity * (this.invert ? -1 : 1);
        this.state.totalDeltaZ += event.deltaZ * this.sensitivity * (this.invert ? -1 : 1);
        // Apply proper min/max clamping for each axis
        // Ensure values stay between min and max bounds
        [
            'totalDeltaX',
            'totalDeltaY',
            'totalDeltaZ'
        ].forEach((axis)=>{
            // First clamp at the minimum bound
            if (this.state[axis] < this.min) this.state[axis] = this.min;
            // Then clamp at the maximum bound
            if (this.state[axis] > this.max) this.state[axis] = this.max;
        });
        // Emit the wheel event
        this.emitWheelEvent(pointersArray, event);
    };
    /**
   * Emit wheel-specific events
   * @param pointers The current pointers on the element
   * @param event The original wheel event
   */ emitWheelEvent(pointers, event) {
        // Calculate centroid - either from existing pointers or from the wheel event position
        const centroid = pointers.length > 0 ? (0, $lNJtn.calculateCentroid)(pointers) : {
            x: event.clientX,
            y: event.clientY
        };
        // Get list of active gestures
        const activeGestures = this.gesturesRegistry.getActiveGestures(this.element);
        // Create custom event data
        const customEventData = {
            gestureName: this.name,
            centroid: centroid,
            target: event.target,
            srcEvent: event,
            phase: 'ongoing',
            pointers: // Wheel events are always in "ongoing" state
            pointers,
            timeStamp: event.timeStamp,
            deltaX: event.deltaX * this.sensitivity * (this.invert ? -1 : 1),
            deltaY: event.deltaY * this.sensitivity * (this.invert ? -1 : 1),
            deltaZ: event.deltaZ * this.sensitivity * (this.invert ? -1 : 1),
            deltaMode: event.deltaMode,
            totalDeltaX: this.state.totalDeltaX,
            totalDeltaY: this.state.totalDeltaY,
            totalDeltaZ: this.state.totalDeltaZ,
            activeGestures: activeGestures,
            customData: this.customData
        };
        // Apply default event behavior if configured
        if (this.preventDefault) event.preventDefault();
        if (this.stopPropagation) event.stopPropagation();
        // Event names to trigger
        const eventName = (0, $lNJtn.createEventName)(this.name, 'ongoing');
        // Dispatch custom events on the element
        const domEvent = new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: customEventData
        });
        this.element.dispatchEvent(domEvent);
    }
}
module.exports.TurnWheelGesture = $8c62150fb22b9f35$var$TurnWheelGesture;

});






parcelRegister("1HWkh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $13e70cf3a753fdc4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractPluginParamsFromProps = void 0;

var $13e70cf3a753fdc4$var$_objectWithoutPropertiesLoose2 = $13e70cf3a753fdc4$require$_interopRequireDefault((parcelRequire("c05no")));
const $13e70cf3a753fdc4$var$_excluded = [
    "apiRef"
];
const $13e70cf3a753fdc4$var$extractPluginParamsFromProps = (_ref)=>{
    let { plugins: plugins } = _ref, props = (0, $13e70cf3a753fdc4$var$_objectWithoutPropertiesLoose2.default)(_ref.props, $13e70cf3a753fdc4$var$_excluded);
    const paramsLookup = {};
    plugins.forEach((plugin)=>{
        Object.assign(paramsLookup, plugin.params);
    });
    const pluginParams = {};
    Object.keys(props).forEach((propName)=>{
        const prop = props[propName];
        if (paramsLookup[propName]) pluginParams[propName] = prop;
    });
    const defaultizedPluginParams = plugins.reduce((acc, plugin)=>{
        if (plugin.getDefaultizedParams) return plugin.getDefaultizedParams({
            params: acc
        });
        return acc;
    }, pluginParams);
    return defaultizedPluginParams;
};
module.exports.extractPluginParamsFromProps = $13e70cf3a753fdc4$var$extractPluginParamsFromProps;

});


parcelRegister("8L2Vi", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6604fafefa72156e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsContext = void 0;

var $6604fafefa72156e$var$React = $6604fafefa72156e$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $6604fafefa72156e$var$ChartsContext = module.exports.ChartsContext = /*#__PURE__*/ $6604fafefa72156e$var$React.createContext(null);

});

parcelRegister("a5Dpn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7588f0ad13001e88$var$_exportNames = {
    useChartCartesianAxis: true,
    defaultizeXAxis: true,
    defaultizeYAxis: true
};
Object.defineProperty(module.exports, "defaultizeXAxis", {
    enumerable: true,
    get: function() {
        return $hZ2Sq.defaultizeXAxis;
    }
});
Object.defineProperty(module.exports, "defaultizeYAxis", {
    enumerable: true,
    get: function() {
        return $hZ2Sq.defaultizeYAxis;
    }
});
Object.defineProperty(module.exports, "useChartCartesianAxis", {
    enumerable: true,
    get: function() {
        return $gpoBM.useChartCartesianAxis;
    }
});

var $gpoBM = parcelRequire("gpoBM");

var $i9lnd = parcelRequire("i9lnd");
Object.keys($i9lnd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $i9lnd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i9lnd[key];
        }
    });
});

var $6ahCy = parcelRequire("6ahCy");
Object.keys($6ahCy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6ahCy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6ahCy[key];
        }
    });
});

var $iFmOZ = parcelRequire("iFmOZ");
Object.keys($iFmOZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iFmOZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iFmOZ[key];
        }
    });
});

var $cIV2T = parcelRequire("cIV2T");
Object.keys($cIV2T).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cIV2T[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cIV2T[key];
        }
    });
});

var $3pq3w = parcelRequire("3pq3w");
Object.keys($3pq3w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3pq3w[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3pq3w[key];
        }
    });
});

var $hZ2Sq = parcelRequire("hZ2Sq");

var $8u8iR = parcelRequire("8u8iR");
Object.keys($8u8iR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8u8iR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8u8iR[key];
        }
    });
});

var $5klR3 = parcelRequire("5klR3");
Object.keys($5klR3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5klR3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5klR3[key];
        }
    });
});

var $8fLr2 = parcelRequire("8fLr2");
Object.keys($8fLr2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7588f0ad13001e88$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8fLr2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8fLr2[key];
        }
    });
});

});
parcelRegister("gpoBM", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $bf2211d631362140$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $bf2211d631362140$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartCartesianAxis = void 0;

var $bf2211d631362140$var$_extends2 = $bf2211d631362140$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bf2211d631362140$var$React = $bf2211d631362140$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bf2211d631362140$var$_useEnhancedEffect = $bf2211d631362140$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8P0MD = parcelRequire("8P0MD");

var $d7LOv = parcelRequire("d7LOv");


var $c2wlS = parcelRequire("c2wlS");

var $kOdtM = parcelRequire("kOdtM");

var $6kle2 = parcelRequire("6kle2");

var $hZ2Sq = parcelRequire("hZ2Sq");

var $i9lnd = parcelRequire("i9lnd");

var $k4wAF = parcelRequire("k4wAF");

var $g34sa = parcelRequire("g34sa");

var $8j56i = parcelRequire("8j56i");

var $iFmOZ = parcelRequire("iFmOZ");

var $cHKFL = parcelRequire("cHKFL");
const $bf2211d631362140$var$AXIS_CLICK_SERIES_TYPES = new Set([
    'bar',
    'rangeBar',
    'line'
]);
const $bf2211d631362140$var$useChartCartesianAxis = ({ params: params, store: store, seriesConfig: seriesConfig, svgRef: svgRef, instance: instance })=>{
    const { xAxis: xAxis, yAxis: yAxis, dataset: dataset, onHighlightedAxisChange: onHighlightedAxisChange } = params;
    const drawingArea = store.use($kOdtM.selectorChartDrawingArea);
    const processedSeries = store.use($6kle2.selectorChartSeriesProcessed);
    const isInteractionEnabled = store.use($8j56i.selectorChartsInteractionIsInitialized);
    const { axis: xAxisWithScale, axisIds: xAxisIds } = store.use($i9lnd.selectorChartXAxis);
    const { axis: yAxisWithScale, axisIds: yAxisIds } = store.use($i9lnd.selectorChartYAxis);
    (0, $d7LOv.useAssertModelConsistency)({
        warningPrefix: 'MUI X Charts',
        componentName: 'Chart',
        propName: 'highlightedAxis',
        controlled: params.highlightedAxis,
        defaultValue: undefined
    });
    (0, $bf2211d631362140$var$_useEnhancedEffect.default)(()=>{
        if (params.highlightedAxis !== undefined) store.set('controlledCartesianAxisHighlight', params.highlightedAxis);
    }, [
        store,
        params.highlightedAxis
    ]);
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useChartCartesianAxis`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $bf2211d631362140$var$React.useRef(true);
    $bf2211d631362140$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        store.set('cartesianAxis', {
            x: (0, $hZ2Sq.defaultizeXAxis)(xAxis, dataset),
            y: (0, $hZ2Sq.defaultizeYAxis)(yAxis, dataset)
        });
    }, [
        seriesConfig,
        drawingArea,
        xAxis,
        yAxis,
        dataset,
        store
    ]);
    const usedXAxis = xAxisIds[0];
    const usedYAxis = yAxisIds[0];
    (0, $8P0MD.useStoreEffect)(store, $iFmOZ.selectorChartAxisInteraction, (prevAxisInteraction, nextAxisInteraction)=>{
        if (!onHighlightedAxisChange) return;
        if (Object.is(prevAxisInteraction, nextAxisInteraction)) return;
        if (prevAxisInteraction.length !== nextAxisInteraction.length) {
            onHighlightedAxisChange(nextAxisInteraction);
            return;
        }
        if (prevAxisInteraction?.some(({ axisId: axisId, dataIndex: dataIndex }, itemIndex)=>nextAxisInteraction[itemIndex].axisId !== axisId || nextAxisInteraction[itemIndex].dataIndex !== dataIndex)) onHighlightedAxisChange(nextAxisInteraction);
    });
    const hasInteractionPlugin = (0, $cHKFL.checkHasInteractionPlugin)(instance);
    $bf2211d631362140$var$React.useEffect(()=>{
        const element = svgRef.current;
        if (!isInteractionEnabled || !hasInteractionPlugin || !element || params.disableAxisListener) return ()=>{};
        // Clean the interaction when the mouse leaves the chart.
        const moveEndHandler = instance.addInteractionListener('moveEnd', (event)=>{
            if (!event.detail.activeGestures.pan) instance.cleanInteraction();
        });
        const panEndHandler = instance.addInteractionListener('panEnd', (event)=>{
            if (!event.detail.activeGestures.move) instance.cleanInteraction();
        });
        const pressEndHandler = instance.addInteractionListener('quickPressEnd', (event)=>{
            if (!event.detail.activeGestures.move && !event.detail.activeGestures.pan) instance.cleanInteraction();
        });
        const gestureHandler = (event)=>{
            const srvEvent = event.detail.srcEvent;
            const target = event.detail.target;
            const svgPoint = (0, $g34sa.getSVGPoint)(element, srvEvent);
            // Release the pointer capture if we are panning, as this would cause the tooltip to
            // be locked to the first "section" it touches.
            if (event.detail.srcEvent.buttons >= 1 && target?.hasPointerCapture(event.detail.srcEvent.pointerId) && !target?.closest('[data-charts-zoom-slider]')) target?.releasePointerCapture(event.detail.srcEvent.pointerId);
            if (!instance.isPointInside(svgPoint.x, svgPoint.y, target)) {
                instance.cleanInteraction?.();
                return;
            }
            instance.setPointerCoordinate(svgPoint);
        };
        const moveHandler = instance.addInteractionListener('move', gestureHandler);
        const panHandler = instance.addInteractionListener('pan', gestureHandler);
        const pressHandler = instance.addInteractionListener('quickPress', gestureHandler);
        return ()=>{
            moveHandler.cleanup();
            moveEndHandler.cleanup();
            panHandler.cleanup();
            panEndHandler.cleanup();
            pressHandler.cleanup();
            pressEndHandler.cleanup();
        };
    }, [
        svgRef,
        store,
        xAxisWithScale,
        usedXAxis,
        yAxisWithScale,
        usedYAxis,
        instance,
        params.disableAxisListener,
        isInteractionEnabled,
        hasInteractionPlugin
    ]);
    $bf2211d631362140$var$React.useEffect(()=>{
        const element = svgRef.current;
        const onAxisClick = params.onAxisClick;
        if (element === null || !onAxisClick) return ()=>{};
        const axisClickHandler = instance.addInteractionListener('tap', (event)=>{
            let dataIndex = null;
            let isXAxis = false;
            const svgPoint = (0, $g34sa.getSVGPoint)(element, event.detail.srcEvent);
            const xIndex = (0, $k4wAF.getAxisIndex)(xAxisWithScale[usedXAxis], svgPoint.x);
            isXAxis = xIndex !== -1;
            dataIndex = isXAxis ? xIndex : (0, $k4wAF.getAxisIndex)(yAxisWithScale[usedYAxis], svgPoint.y);
            const USED_AXIS_ID = isXAxis ? xAxisIds[0] : yAxisIds[0];
            if (dataIndex == null || dataIndex === -1) return;
            // The .data exist because otherwise the dataIndex would be null or -1.
            const axisValue = (isXAxis ? xAxisWithScale : yAxisWithScale)[USED_AXIS_ID].data[dataIndex];
            const seriesValues = {};
            Object.keys(processedSeries).filter((seriesType)=>$bf2211d631362140$var$AXIS_CLICK_SERIES_TYPES.has(seriesType)).forEach((seriesType)=>{
                // @ts-ignore
                const seriesTypeConfig = processedSeries[seriesType];
                seriesTypeConfig?.seriesOrder.forEach((seriesId)=>{
                    const seriesItem = seriesTypeConfig.series[seriesId];
                    const providedXAxisId = seriesItem.xAxisId;
                    const providedYAxisId = seriesItem.yAxisId;
                    const axisKey = isXAxis ? providedXAxisId : providedYAxisId;
                    if (axisKey === undefined || axisKey === USED_AXIS_ID) // @ts-ignore This is safe because users need to opt in to use range bar series.
                    // In that case, they should import the module augmentation from `x-charts-pro/moduleAugmentation/rangeBarOnClick`
                    // Which adds the proper type to the series data.
                    // TODO(v9): Remove this ts-ignore when we can make the breaking change to ChartsAxisData.
                    seriesValues[seriesId] = seriesItem.data[dataIndex];
                });
            });
            onAxisClick(event.detail.srcEvent, {
                dataIndex: dataIndex,
                axisValue: axisValue,
                seriesValues: seriesValues
            });
        });
        return ()=>{
            axisClickHandler.cleanup();
        };
    }, [
        params.onAxisClick,
        processedSeries,
        svgRef,
        xAxisWithScale,
        xAxisIds,
        yAxisWithScale,
        yAxisIds,
        usedXAxis,
        usedYAxis,
        instance
    ]);
    return {};
};
module.exports.useChartCartesianAxis = $bf2211d631362140$var$useChartCartesianAxis;
$bf2211d631362140$var$useChartCartesianAxis.params = {
    xAxis: true,
    yAxis: true,
    dataset: true,
    onAxisClick: true,
    disableAxisListener: true,
    onHighlightedAxisChange: true,
    highlightedAxis: true
};
$bf2211d631362140$var$useChartCartesianAxis.getDefaultizedParams = ({ params: params })=>{
    return (0, $bf2211d631362140$var$_extends2.default)({}, params, {
        colors: params.colors ?? $c2wlS.rainbowSurgePalette,
        theme: params.theme ?? 'light',
        defaultizedXAxis: (0, $hZ2Sq.defaultizeXAxis)(params.xAxis, params.dataset),
        defaultizedYAxis: (0, $hZ2Sq.defaultizeYAxis)(params.yAxis, params.dataset)
    });
};
$bf2211d631362140$var$useChartCartesianAxis.getInitialState = (params)=>(0, $bf2211d631362140$var$_extends2.default)({
        cartesianAxis: {
            x: params.defaultizedXAxis,
            y: params.defaultizedYAxis
        }
    }, params.highlightedAxis === undefined ? {} : {
        controlledCartesianAxisHighlight: params.highlightedAxis
    });

});
parcelRegister("d7LOv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useAssertModelConsistency", {
    enumerable: true,
    get: function() {
        return $28Vau.useAssertModelConsistency;
    }
});

var $28Vau = parcelRequire("28Vau");

});
parcelRegister("28Vau", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $18f8ac8b715bae02$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAssertModelConsistency = void 0;

var $18f8ac8b715bae02$var$React = $18f8ac8b715bae02$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9Y8Cp = parcelRequire("9Y8Cp");
/**
 * Make sure a controlled prop is used correctly.
 * Logs errors if the prop either:
 *
 * - switch between controlled and uncontrolled
 * - modify it's default value
 * @param parameters
 */ function $18f8ac8b715bae02$var$useAssertModelConsistencyOutsideOfProduction(parameters) {
    const { componentName: componentName, propName: propName, controlled: controlled, defaultValue: defaultValue, warningPrefix: warningPrefix = 'MUI X' } = parameters;
    const [{ initialDefaultValue: initialDefaultValue, isControlled: isControlled }] = $18f8ac8b715bae02$var$React.useState({
        initialDefaultValue: defaultValue,
        isControlled: controlled !== undefined
    });
    if (isControlled !== (controlled !== undefined)) (0, $9Y8Cp.warnOnce)([
        `${warningPrefix}: A component is changing the ${isControlled ? '' : 'un'}controlled ${propName} state of ${componentName} to be ${isControlled ? 'un' : ''}controlled.`,
        'Elements should not switch from uncontrolled to controlled (or vice versa).',
        `Decide between using a controlled or uncontrolled ${propName} ` + 'element for the lifetime of the component.',
        "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
        'More info: https://fb.me/react-controlled-components'
    ], 'error');
    if (JSON.stringify(initialDefaultValue) !== JSON.stringify(defaultValue)) (0, $9Y8Cp.warnOnce)([
        `${warningPrefix}: A component is changing the default ${propName} state of an uncontrolled ${componentName} after being initialized. ` + `To suppress this warning opt to use a controlled ${componentName}.`
    ], 'error');
}
const $18f8ac8b715bae02$var$useAssertModelConsistency = module.exports.useAssertModelConsistency = ()=>{};

});


parcelRegister("hZ2Sq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d17a5d76c23ef26c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultizeXAxis = $d17a5d76c23ef26c$var$defaultizeXAxis;
module.exports.defaultizeYAxis = $d17a5d76c23ef26c$var$defaultizeYAxis;

var $d17a5d76c23ef26c$var$_extends2 = $d17a5d76c23ef26c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b4US8 = parcelRequire("b4US8");

var $fiXDv = parcelRequire("fiXDv");
function $d17a5d76c23ef26c$var$defaultizeXAxis(inAxes, dataset) {
    const offsets = {
        top: 0,
        bottom: 0,
        none: 0
    };
    const inputAxes = inAxes && inAxes.length > 0 ? inAxes : [
        {
            id: $fiXDv.DEFAULT_X_AXIS_KEY,
            scaleType: 'linear'
        }
    ];
    const parsedAxes = inputAxes.map((axisConfig, index)=>{
        const dataKey = axisConfig.dataKey;
        // The first x-axis is defaultized to the bottom
        const defaultPosition = index === 0 ? 'bottom' : 'none';
        const position = axisConfig.position ?? defaultPosition;
        const defaultHeight = $fiXDv.DEFAULT_AXIS_SIZE_HEIGHT + (axisConfig.label ? $fiXDv.AXIS_LABEL_DEFAULT_HEIGHT : 0);
        const id = axisConfig.id ?? `defaultized-x-axis-${index}`;
        const sharedConfig = (0, $d17a5d76c23ef26c$var$_extends2.default)({
            offset: offsets[position]
        }, axisConfig, {
            id: id,
            position: position,
            height: axisConfig.height ?? defaultHeight,
            zoom: (0, $b4US8.defaultizeZoom)(axisConfig.zoom, id, 'x', axisConfig.reverse)
        });
        // Increment the offset for the next axis
        if (position !== 'none') {
            offsets[position] += sharedConfig.height;
            if (sharedConfig.zoom?.slider.enabled) offsets[position] += sharedConfig.zoom.slider.size;
        }
        // If `dataKey` is NOT provided
        if (dataKey === undefined || axisConfig.data !== undefined) return sharedConfig;
        if (dataset === undefined) throw new Error(`MUI X Charts: x-axis uses \`dataKey\` but no \`dataset\` is provided.`);
        // If `dataKey` is provided
        return (0, $d17a5d76c23ef26c$var$_extends2.default)({}, sharedConfig, {
            data: dataset.map((d)=>d[dataKey])
        });
    });
    return parsedAxes;
}
function $d17a5d76c23ef26c$var$defaultizeYAxis(inAxes, dataset) {
    const offsets = {
        right: 0,
        left: 0,
        none: 0
    };
    const inputAxes = inAxes && inAxes.length > 0 ? inAxes : [
        {
            id: $fiXDv.DEFAULT_Y_AXIS_KEY,
            scaleType: 'linear'
        }
    ];
    const parsedAxes = inputAxes.map((axisConfig, index)=>{
        const dataKey = axisConfig.dataKey;
        // The first y-axis is defaultized to the left
        const defaultPosition = index === 0 ? 'left' : 'none';
        const position = axisConfig.position ?? defaultPosition;
        const defaultWidth = $fiXDv.DEFAULT_AXIS_SIZE_WIDTH + (axisConfig.label ? $fiXDv.AXIS_LABEL_DEFAULT_HEIGHT : 0);
        const id = axisConfig.id ?? `defaultized-y-axis-${index}`;
        const sharedConfig = (0, $d17a5d76c23ef26c$var$_extends2.default)({
            offset: offsets[position]
        }, axisConfig, {
            id: id,
            position: position,
            width: axisConfig.width ?? defaultWidth,
            zoom: (0, $b4US8.defaultizeZoom)(axisConfig.zoom, id, 'y', axisConfig.reverse)
        });
        // Increment the offset for the next axis
        if (position !== 'none') {
            offsets[position] += sharedConfig.width;
            if (sharedConfig.zoom?.slider.enabled) offsets[position] += sharedConfig.zoom.slider.size;
        }
        // If `dataKey` is NOT provided
        if (dataKey === undefined || axisConfig.data !== undefined) return sharedConfig;
        if (dataset === undefined) throw new Error(`MUI X Charts: y-axis uses \`dataKey\` but no \`dataset\` is provided.`);
        // If `dataKey` is provided
        return (0, $d17a5d76c23ef26c$var$_extends2.default)({}, sharedConfig, {
            data: dataset.map((d)=>d[dataKey])
        });
    });
    return parsedAxes;
}

});
parcelRegister("b4US8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $810c2f13d7151509$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultizeZoom = module.exports.defaultZoomOptions = void 0;

var $810c2f13d7151509$var$_extends2 = $810c2f13d7151509$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2xVLi = parcelRequire("2xVLi");
const $810c2f13d7151509$var$defaultZoomOptions = module.exports.defaultZoomOptions = {
    minStart: 0,
    maxEnd: 100,
    step: 5,
    minSpan: 10,
    maxSpan: 100,
    panning: true,
    filterMode: 'keep',
    reverse: false,
    slider: {
        enabled: false,
        preview: false,
        size: $2xVLi.DEFAULT_ZOOM_SLIDER_SIZE,
        showTooltip: $2xVLi.DEFAULT_ZOOM_SLIDER_SHOW_TOOLTIP
    }
};
const $810c2f13d7151509$var$defaultizeZoom = (zoom, axisId, axisDirection, reverse)=>{
    if (!zoom) return undefined;
    if (zoom === true) return (0, $810c2f13d7151509$var$_extends2.default)({
        axisId: axisId,
        axisDirection: axisDirection
    }, $810c2f13d7151509$var$defaultZoomOptions, {
        reverse: reverse ?? false
    });
    return (0, $810c2f13d7151509$var$_extends2.default)({
        axisId: axisId,
        axisDirection: axisDirection
    }, $810c2f13d7151509$var$defaultZoomOptions, {
        reverse: reverse ?? false
    }, zoom, {
        slider: (0, $810c2f13d7151509$var$_extends2.default)({}, $810c2f13d7151509$var$defaultZoomOptions.slider, {
            size: zoom.slider?.preview ?? $810c2f13d7151509$var$defaultZoomOptions.slider.preview ? $2xVLi.DEFAULT_ZOOM_SLIDER_PREVIEW_SIZE : $2xVLi.DEFAULT_ZOOM_SLIDER_SIZE
        }, zoom.slider)
    });
};
module.exports.defaultizeZoom = $810c2f13d7151509$var$defaultizeZoom;

});
parcelRegister("2xVLi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ZOOM_SLIDER_PREVIEW_SIZE = module.exports.ZOOM_SLIDER_MARGIN = module.exports.DEFAULT_ZOOM_SLIDER_SIZE = module.exports.DEFAULT_ZOOM_SLIDER_SHOW_TOOLTIP = module.exports.DEFAULT_ZOOM_SLIDER_PREVIEW_SIZE = module.exports.DEFAULT_PIE_CHART_MARGIN = void 0;
/** Margin in the opposite direction of the axis, i.e., horizontal if the axis is vertical and vice versa. */ const $1dab782412985a47$var$ZOOM_SLIDER_MARGIN = module.exports.ZOOM_SLIDER_MARGIN = 4;
/** Size of the zoom slider preview. */ const $1dab782412985a47$var$ZOOM_SLIDER_PREVIEW_SIZE = module.exports.ZOOM_SLIDER_PREVIEW_SIZE = 40;
/** Size reserved for the zoom slider. The actual size of the slider might be smaller. */ const $1dab782412985a47$var$DEFAULT_ZOOM_SLIDER_SIZE = module.exports.DEFAULT_ZOOM_SLIDER_SIZE = 20 + 2 * $1dab782412985a47$var$ZOOM_SLIDER_MARGIN;
const $1dab782412985a47$var$DEFAULT_ZOOM_SLIDER_PREVIEW_SIZE = module.exports.DEFAULT_ZOOM_SLIDER_PREVIEW_SIZE = 40 + 2 * $1dab782412985a47$var$ZOOM_SLIDER_MARGIN;
const $1dab782412985a47$var$DEFAULT_ZOOM_SLIDER_SHOW_TOOLTIP = module.exports.DEFAULT_ZOOM_SLIDER_SHOW_TOOLTIP = 'hover';
/** Default margin for pie charts. */ const $1dab782412985a47$var$DEFAULT_PIE_CHART_MARGIN = module.exports.DEFAULT_PIE_CHART_MARGIN = {
    top: 5,
    bottom: 5,
    left: 5,
    right: 5
};

});



parcelRegister("i9lnd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d369a594c584fab8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorDefaultYAxisTickNumber = module.exports.selectorDefaultXAxisTickNumber = module.exports.selectorChartZoomOptionsLookup = module.exports.selectorChartZoomMap = module.exports.selectorChartZoomIsInteracting = module.exports.selectorChartZoomAxisFilters = module.exports.selectorChartYScales = module.exports.selectorChartYAxisWithDomains = module.exports.selectorChartYAxis = module.exports.selectorChartXScales = module.exports.selectorChartXAxisWithDomains = module.exports.selectorChartXAxis = module.exports.selectorChartSeriesFlatbushMap = module.exports.selectorChartSeriesEmptyFlatbushMap = module.exports.selectorChartRawAxis = module.exports.selectorChartNormalizedYScales = module.exports.selectorChartNormalizedXScales = module.exports.selectorChartFilteredYDomains = module.exports.selectorChartFilteredXDomains = module.exports.selectorChartDefaultYAxisId = module.exports.selectorChartDefaultXAxisId = module.exports.selectorChartAxisZoomOptionsLookup = module.exports.selectorChartAxisZoomData = module.exports.selectorChartAxis = module.exports.createZoomMap = void 0;

var $d369a594c584fab8$var$_extends2 = $d369a594c584fab8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8P0MD = parcelRequire("8P0MD");

var $eWN1p = parcelRequire("eWN1p");

var $1k3ob = parcelRequire("1k3ob");

var $8u8iR = parcelRequire("8u8iR");

var $sJvPg = parcelRequire("sJvPg");

var $5klR3 = parcelRequire("5klR3");

var $lXwwj = parcelRequire("lXwwj");

var $6ahCy = parcelRequire("6ahCy");

var $1Vp4t = parcelRequire("1Vp4t");

var $6PfPa = parcelRequire("6PfPa");

var $kOBDb = parcelRequire("kOBDb");

var $2UPWB = parcelRequire("2UPWB");

var $Gls7F = parcelRequire("Gls7F");

var $c94Lk = parcelRequire("c94Lk");

var $5IXOU = parcelRequire("5IXOU");

var $3W3on = parcelRequire("3W3on");
const $d369a594c584fab8$var$createZoomMap = (zoom)=>{
    const zoomItemMap = new Map();
    zoom.forEach((zoomItem)=>{
        zoomItemMap.set(zoomItem.axisId, zoomItem);
    });
    return zoomItemMap;
};
module.exports.createZoomMap = $d369a594c584fab8$var$createZoomMap;
const $d369a594c584fab8$var$selectorChartZoomState = (state)=>state.zoom;
/**
 * Following selectors are not exported because they exist in the MIT chart only to ba able to reuse the Zoom state from the pro.
 */ const $d369a594c584fab8$var$selectorChartZoomIsInteracting = module.exports.selectorChartZoomIsInteracting = (0, $8P0MD.createSelector)($d369a594c584fab8$var$selectorChartZoomState, (zoom)=>zoom?.isInteracting);
const $d369a594c584fab8$var$selectorChartZoomMap = module.exports.selectorChartZoomMap = (0, $8P0MD.createSelectorMemoized)($d369a594c584fab8$var$selectorChartZoomState, function selectorChartZoomMap(zoom) {
    return zoom?.zoomData && $d369a594c584fab8$var$createZoomMap(zoom?.zoomData);
});
const $d369a594c584fab8$var$selectorChartAxisZoomData = module.exports.selectorChartAxisZoomData = (0, $8P0MD.createSelector)($d369a594c584fab8$var$selectorChartZoomMap, (zoomMap, axisId)=>zoomMap?.get(axisId));
const $d369a594c584fab8$var$selectorChartZoomOptionsLookup = module.exports.selectorChartZoomOptionsLookup = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawXAxis, $6ahCy.selectorChartRawYAxis, function selectorChartZoomOptionsLookup(xAxis, yAxis) {
    return (0, $d369a594c584fab8$var$_extends2.default)({}, (0, $5klR3.createZoomLookup)('x')(xAxis), (0, $5klR3.createZoomLookup)('y')(yAxis));
});
const $d369a594c584fab8$var$selectorChartAxisZoomOptionsLookup = module.exports.selectorChartAxisZoomOptionsLookup = (0, $8P0MD.createSelector)($d369a594c584fab8$var$selectorChartZoomOptionsLookup, (axisLookup, axisId)=>axisLookup[axisId]);
const $d369a594c584fab8$var$selectorDefaultXAxisTickNumber = module.exports.selectorDefaultXAxisTickNumber = (0, $8P0MD.createSelector)($eWN1p.selectorChartDrawingArea, function selectorDefaultXAxisTickNumber(drawingArea) {
    return (0, $6PfPa.getDefaultTickNumber)(drawingArea.width);
});
const $d369a594c584fab8$var$selectorDefaultYAxisTickNumber = module.exports.selectorDefaultYAxisTickNumber = (0, $8P0MD.createSelector)($eWN1p.selectorChartDrawingArea, function selectorDefaultYAxisTickNumber(drawingArea) {
    return (0, $6PfPa.getDefaultTickNumber)(drawingArea.height);
});
const $d369a594c584fab8$var$selectorChartXAxisWithDomains = module.exports.selectorChartXAxisWithDomains = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawXAxis, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $1Vp4t.selectorPreferStrictDomainInLineCharts, $d369a594c584fab8$var$selectorDefaultXAxisTickNumber, function selectorChartXAxisWithDomains(axes, formattedSeries, seriesConfig, preferStrictDomainInLineCharts, defaultTickNumber) {
    const axisDirection = 'x';
    const domains = {};
    axes?.forEach((eachAxis, axisIndex)=>{
        const axis = eachAxis;
        if ((0, $lXwwj.isBandScaleConfig)(axis) || (0, $lXwwj.isPointScaleConfig)(axis)) {
            domains[axis.id] = {
                domain: axis.data
            };
            if (axis.ordinalTimeTicks !== undefined) domains[axis.id].tickNumber = (0, $6PfPa.getTickNumber)(axis, [
                axis.data?.find((d)=>d !== null),
                axis.data?.findLast((d)=>d !== null)
            ], defaultTickNumber);
            return;
        }
        const axisExtrema = (0, $c94Lk.getAxisExtrema)(axis, axisDirection, seriesConfig, axisIndex, formattedSeries);
        domains[axis.id] = (0, $5IXOU.calculateInitialDomainAndTickNumber)(axis, 'x', axisIndex, formattedSeries, axisExtrema, defaultTickNumber, preferStrictDomainInLineCharts);
    });
    return {
        axes: axes,
        domains: domains
    };
});
const $d369a594c584fab8$var$selectorChartYAxisWithDomains = module.exports.selectorChartYAxisWithDomains = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawYAxis, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $1Vp4t.selectorPreferStrictDomainInLineCharts, $d369a594c584fab8$var$selectorDefaultYAxisTickNumber, function selectorChartYAxisWithDomains(axes, formattedSeries, seriesConfig, preferStrictDomainInLineCharts, defaultTickNumber) {
    const axisDirection = 'y';
    const domains = {};
    axes?.forEach((eachAxis, axisIndex)=>{
        const axis = eachAxis;
        if ((0, $lXwwj.isBandScaleConfig)(axis) || (0, $lXwwj.isPointScaleConfig)(axis)) {
            domains[axis.id] = {
                domain: axis.data
            };
            if (axis.ordinalTimeTicks !== undefined) domains[axis.id].tickNumber = (0, $6PfPa.getTickNumber)(axis, [
                axis.data?.find((d)=>d !== null),
                axis.data?.findLast((d)=>d !== null)
            ], defaultTickNumber);
            return;
        }
        const axisExtrema = (0, $c94Lk.getAxisExtrema)(axis, axisDirection, seriesConfig, axisIndex, formattedSeries);
        domains[axis.id] = (0, $5IXOU.calculateInitialDomainAndTickNumber)(axis, 'y', axisIndex, formattedSeries, axisExtrema, defaultTickNumber, preferStrictDomainInLineCharts);
    });
    return {
        axes: axes,
        domains: domains
    };
});
const $d369a594c584fab8$var$selectorChartZoomAxisFilters = module.exports.selectorChartZoomAxisFilters = (0, $8P0MD.createSelectorMemoized)($d369a594c584fab8$var$selectorChartZoomMap, $d369a594c584fab8$var$selectorChartZoomOptionsLookup, $d369a594c584fab8$var$selectorChartXAxisWithDomains, $d369a594c584fab8$var$selectorChartYAxisWithDomains, function selectorChartZoomAxisFilters(zoomMap, zoomOptions, { axes: xAxis, domains: xDomains }, { axes: yAxis, domains: yDomains }) {
    if (!zoomMap || !zoomOptions) return undefined;
    let hasFilter = false;
    const filters = {};
    const axes = [
        ...xAxis ?? [],
        ...yAxis ?? []
    ];
    for(let i = 0; i < axes.length; i += 1){
        const axis = axes[i];
        if (!zoomOptions[axis.id] || zoomOptions[axis.id].filterMode !== 'discard') continue;
        const zoom = zoomMap.get(axis.id);
        if (zoom === undefined || zoom.start <= 0 && zoom.end >= 100) continue;
        const axisDirection = i < (xAxis?.length ?? 0) ? 'x' : 'y';
        if (axis.scaleType === 'band' || axis.scaleType === 'point') filters[axis.id] = (0, $sJvPg.createDiscreteScaleGetAxisFilter)(axis.data, zoom.start, zoom.end, axisDirection);
        else {
            const { domain: domain } = axisDirection === 'x' ? xDomains[axis.id] : yDomains[axis.id];
            filters[axis.id] = (0, $sJvPg.createContinuousScaleGetAxisFilter)(// For continuous scales, the domain is always a two-value array.
            domain, zoom.start, zoom.end, axisDirection, axis.data);
        }
        hasFilter = true;
    }
    if (!hasFilter) return undefined;
    return (0, $sJvPg.createGetAxisFilters)(filters);
});
const $d369a594c584fab8$var$selectorChartFilteredXDomains = module.exports.selectorChartFilteredXDomains = (0, $8P0MD.createSelectorMemoized)($1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $d369a594c584fab8$var$selectorChartZoomMap, $d369a594c584fab8$var$selectorChartZoomOptionsLookup, $d369a594c584fab8$var$selectorChartZoomAxisFilters, $1Vp4t.selectorPreferStrictDomainInLineCharts, $d369a594c584fab8$var$selectorChartXAxisWithDomains, function selectorChartFilteredXDomains(formattedSeries, seriesConfig, zoomMap, zoomOptions, getFilters, preferStrictDomainInLineCharts, { axes: axes, domains: domains }) {
    const filteredDomains = {};
    axes?.forEach((axis, axisIndex)=>{
        const domain = domains[axis.id].domain;
        if ((0, $lXwwj.isBandScaleConfig)(axis) || (0, $lXwwj.isPointScaleConfig)(axis)) {
            filteredDomains[axis.id] = domain;
            return;
        }
        const zoom = zoomMap?.get(axis.id);
        const zoomOption = zoomOptions?.[axis.id];
        const filter = zoom === undefined && !zoomOption ? getFilters : undefined; // Do not apply filtering if zoom is already defined.
        if (!filter) {
            filteredDomains[axis.id] = domain;
            return;
        }
        const rawTickNumber = domains[axis.id].tickNumber;
        const axisExtrema = (0, $c94Lk.getAxisExtrema)(axis, 'x', seriesConfig, axisIndex, formattedSeries, filter);
        filteredDomains[axis.id] = (0, $5IXOU.calculateFinalDomain)(axis, 'x', axisIndex, formattedSeries, axisExtrema, rawTickNumber, preferStrictDomainInLineCharts);
    });
    return filteredDomains;
});
const $d369a594c584fab8$var$selectorChartFilteredYDomains = module.exports.selectorChartFilteredYDomains = (0, $8P0MD.createSelectorMemoized)($1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $d369a594c584fab8$var$selectorChartZoomMap, $d369a594c584fab8$var$selectorChartZoomOptionsLookup, $d369a594c584fab8$var$selectorChartZoomAxisFilters, $1Vp4t.selectorPreferStrictDomainInLineCharts, $d369a594c584fab8$var$selectorChartYAxisWithDomains, function selectorChartFilteredYDomains(formattedSeries, seriesConfig, zoomMap, zoomOptions, getFilters, preferStrictDomainInLineCharts, { axes: axes, domains: domains }) {
    const filteredDomains = {};
    axes?.forEach((axis, axisIndex)=>{
        const domain = domains[axis.id].domain;
        if ((0, $lXwwj.isBandScaleConfig)(axis) || (0, $lXwwj.isPointScaleConfig)(axis)) {
            filteredDomains[axis.id] = domain;
            return;
        }
        const zoom = zoomMap?.get(axis.id);
        const zoomOption = zoomOptions?.[axis.id];
        const filter = zoom === undefined && !zoomOption ? getFilters : undefined; // Do not apply filtering if zoom is already defined.
        if (!filter) {
            filteredDomains[axis.id] = domain;
            return;
        }
        const rawTickNumber = domains[axis.id].tickNumber;
        const axisExtrema = (0, $c94Lk.getAxisExtrema)(axis, 'y', seriesConfig, axisIndex, formattedSeries, filter);
        filteredDomains[axis.id] = (0, $5IXOU.calculateFinalDomain)(axis, 'y', axisIndex, formattedSeries, axisExtrema, rawTickNumber, preferStrictDomainInLineCharts);
    });
    return filteredDomains;
});
const $d369a594c584fab8$var$selectorChartNormalizedXScales = module.exports.selectorChartNormalizedXScales = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawXAxis, $d369a594c584fab8$var$selectorChartFilteredXDomains, function selectorChartNormalizedXScales(axes, filteredDomains) {
    const scales = {};
    axes?.forEach((eachAxis)=>{
        const axis = eachAxis;
        const domain = filteredDomains[axis.id];
        scales[axis.id] = (0, $kOBDb.getNormalizedAxisScale)(axis, domain);
    });
    return scales;
});
const $d369a594c584fab8$var$selectorChartNormalizedYScales = module.exports.selectorChartNormalizedYScales = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawYAxis, $d369a594c584fab8$var$selectorChartFilteredYDomains, function selectorChartNormalizedYScales(axes, filteredDomains) {
    const scales = {};
    axes?.forEach((eachAxis)=>{
        const axis = eachAxis;
        const domain = filteredDomains[axis.id];
        scales[axis.id] = (0, $kOBDb.getNormalizedAxisScale)(axis, domain);
    });
    return scales;
});
const $d369a594c584fab8$var$selectorChartXScales = module.exports.selectorChartXScales = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawXAxis, $d369a594c584fab8$var$selectorChartNormalizedXScales, $eWN1p.selectorChartDrawingArea, $d369a594c584fab8$var$selectorChartZoomMap, function selectorChartXScales(axes, normalizedScales, drawingArea, zoomMap) {
    const scales = {};
    axes?.forEach((eachAxis)=>{
        const axis = eachAxis;
        const zoom = zoomMap?.get(axis.id);
        const zoomRange = zoom ? [
            zoom.start,
            zoom.end
        ] : [
            0,
            100
        ];
        const range = (0, $kOBDb.getRange)(drawingArea, 'x', axis);
        const scale = normalizedScales[axis.id].copy();
        const zoomedRange = (0, $Gls7F.zoomScaleRange)(range, zoomRange);
        scale.range(zoomedRange);
        scales[axis.id] = scale;
    });
    return scales;
});
const $d369a594c584fab8$var$selectorChartYScales = module.exports.selectorChartYScales = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawYAxis, $d369a594c584fab8$var$selectorChartNormalizedYScales, $eWN1p.selectorChartDrawingArea, $d369a594c584fab8$var$selectorChartZoomMap, function selectorChartYScales(axes, normalizedScales, drawingArea, zoomMap) {
    const scales = {};
    axes?.forEach((eachAxis)=>{
        const axis = eachAxis;
        const zoom = zoomMap?.get(axis.id);
        const zoomRange = zoom ? [
            zoom.start,
            zoom.end
        ] : [
            0,
            100
        ];
        const range = (0, $kOBDb.getRange)(drawingArea, 'y', axis);
        const scale = normalizedScales[axis.id].copy();
        const scaleRange = (0, $2UPWB.isOrdinalScale)(scale) ? range.reverse() : range;
        const zoomedRange = (0, $Gls7F.zoomScaleRange)(scaleRange, zoomRange);
        scale.range(zoomedRange);
        scales[axis.id] = scale;
    });
    return scales;
});
/**
 * The only interesting selectors that merge axis data and zoom if provided.
 */ const $d369a594c584fab8$var$selectorChartXAxis = module.exports.selectorChartXAxis = (0, $8P0MD.createSelectorMemoized)($eWN1p.selectorChartDrawingArea, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $d369a594c584fab8$var$selectorChartZoomMap, $d369a594c584fab8$var$selectorChartXAxisWithDomains, $d369a594c584fab8$var$selectorChartXScales, function selectorChartXAxis(drawingArea, formattedSeries, seriesConfig, zoomMap, { axes: axes, domains: domains }, scales) {
    return (0, $8u8iR.computeAxisValue)({
        scales: scales,
        drawingArea: drawingArea,
        formattedSeries: formattedSeries,
        axis: axes,
        seriesConfig: seriesConfig,
        axisDirection: 'x',
        zoomMap: zoomMap,
        domains: domains
    });
});
const $d369a594c584fab8$var$selectorChartYAxis = module.exports.selectorChartYAxis = (0, $8P0MD.createSelectorMemoized)($eWN1p.selectorChartDrawingArea, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $d369a594c584fab8$var$selectorChartZoomMap, $d369a594c584fab8$var$selectorChartYAxisWithDomains, $d369a594c584fab8$var$selectorChartYScales, function selectorChartYAxis(drawingArea, formattedSeries, seriesConfig, zoomMap, { axes: axes, domains: domains }, scales) {
    return (0, $8u8iR.computeAxisValue)({
        scales: scales,
        drawingArea: drawingArea,
        formattedSeries: formattedSeries,
        axis: axes,
        seriesConfig: seriesConfig,
        axisDirection: 'y',
        zoomMap: zoomMap,
        domains: domains
    });
});
const $d369a594c584fab8$var$selectorChartAxis = module.exports.selectorChartAxis = (0, $8P0MD.createSelector)($d369a594c584fab8$var$selectorChartXAxis, $d369a594c584fab8$var$selectorChartYAxis, (xAxes, yAxes, axisId)=>xAxes?.axis[axisId] ?? yAxes?.axis[axisId]);
const $d369a594c584fab8$var$selectorChartRawAxis = module.exports.selectorChartRawAxis = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawXAxis, $6ahCy.selectorChartRawYAxis, (xAxes, yAxes, axisId)=>{
    const axis = xAxes?.find((a)=>a.id === axisId) ?? yAxes?.find((a)=>a.id === axisId) ?? null;
    if (!axis) return undefined;
    return axis;
});
const $d369a594c584fab8$var$selectorChartDefaultXAxisId = module.exports.selectorChartDefaultXAxisId = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawXAxis, (xAxes)=>xAxes[0].id);
const $d369a594c584fab8$var$selectorChartDefaultYAxisId = module.exports.selectorChartDefaultYAxisId = (0, $8P0MD.createSelector)($6ahCy.selectorChartRawYAxis, (yAxes)=>yAxes[0].id);
const $d369a594c584fab8$var$EMPTY_MAP = new Map();
const $d369a594c584fab8$var$selectorChartSeriesEmptyFlatbushMap = ()=>$d369a594c584fab8$var$EMPTY_MAP;
module.exports.selectorChartSeriesEmptyFlatbushMap = $d369a594c584fab8$var$selectorChartSeriesEmptyFlatbushMap;
const $d369a594c584fab8$var$selectorChartSeriesFlatbushMap = module.exports.selectorChartSeriesFlatbushMap = (0, $8P0MD.createSelectorMemoized)($1k3ob.selectorChartSeriesProcessed, $d369a594c584fab8$var$selectorChartNormalizedXScales, $d369a594c584fab8$var$selectorChartNormalizedYScales, $d369a594c584fab8$var$selectorChartDefaultXAxisId, $d369a594c584fab8$var$selectorChartDefaultYAxisId, function selectChartSeriesFlatbushMap(allSeries, xAxesScaleMap, yAxesScaleMap, defaultXAxisId, defaultYAxisId) {
    // FIXME: Do we want to support non-scatter series here?
    const validSeries = allSeries.scatter;
    const flatbushMap = new Map();
    if (!validSeries) return flatbushMap;
    validSeries.seriesOrder.forEach((seriesId)=>{
        const { data: data, xAxisId: xAxisId = defaultXAxisId, yAxisId: yAxisId = defaultYAxisId } = validSeries.series[seriesId];
        const flatbush = new $3W3on.Flatbush(data.length);
        const originalXScale = xAxesScaleMap[xAxisId];
        const originalYScale = yAxesScaleMap[yAxisId];
        for (const datum of data)// Add the points using a [0, 1] range so that we don't need to recreate the Flatbush structure when zooming.
        // This doesn't happen in practice, though, because currently the scales depend on the drawing area.
        flatbush.add(originalXScale(datum.x), originalYScale(datum.y));
        flatbush.finish();
        flatbushMap.set(seriesId, flatbush);
    });
    return flatbushMap;
});

});
parcelRegister("8u8iR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $62d790ed28c7b514$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeAxisValue = $62d790ed28c7b514$var$computeAxisValue;

var $62d790ed28c7b514$var$_extends2 = $62d790ed28c7b514$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8fmGy = parcelRequire("8fmGy");

var $lXwwj = parcelRequire("lXwwj");

var $jTrR8 = parcelRequire("jTrR8");

var $6PfPa = parcelRequire("6PfPa");

var $ar6SO = parcelRequire("ar6SO");

var $QqBso = parcelRequire("QqBso");

var $jcuKK = parcelRequire("jcuKK");

var $2UPWB = parcelRequire("2UPWB");
function $62d790ed28c7b514$var$getRange(drawingArea, axisDirection, // | 'rotation' | 'radius',
reverse) {
    const range = axisDirection === 'x' ? [
        drawingArea.left,
        drawingArea.left + drawingArea.width
    ] : [
        drawingArea.top + drawingArea.height,
        drawingArea.top
    ];
    return reverse ? [
        range[1],
        range[0]
    ] : range;
}
function $62d790ed28c7b514$var$shouldIgnoreGapRatios(scale, categoryGapRatio) {
    const step = scale.step();
    const paddingPx = step * categoryGapRatio;
    /* If the padding is less than 0.1px, we consider it negligible and ignore it.
   * This prevents issues where very small gaps cause rendering artifacts or unexpected layouts.
   * A threshold of 0.1px is chosen as it's generally below the perceptible limit for most displays.
   */ return paddingPx < 0.1;
}
const $62d790ed28c7b514$var$DEFAULT_CATEGORY_GAP_RATIO = 0.2;
const $62d790ed28c7b514$var$DEFAULT_BAR_GAP_RATIO = 0.1;
function $62d790ed28c7b514$var$computeAxisValue({ scales: scales, drawingArea: drawingArea, formattedSeries: formattedSeries, axis: allAxis, seriesConfig: seriesConfig, axisDirection: axisDirection, zoomMap: zoomMap, domains: domains }) {
    if (allAxis === undefined) return {
        axis: {},
        axisIds: []
    };
    const axisIdsTriggeringTooltip = (0, $jcuKK.getAxisTriggerTooltip)(axisDirection, seriesConfig, formattedSeries, allAxis[0].id);
    const completeAxis = {};
    allAxis.forEach((eachAxis)=>{
        const axis = eachAxis;
        const scale = scales[axis.id];
        const zoom = zoomMap?.get(axis.id);
        const zoomRange = zoom ? [
            zoom.start,
            zoom.end
        ] : [
            0,
            100
        ];
        const range = $62d790ed28c7b514$var$getRange(drawingArea, axisDirection, axis.reverse ?? false);
        const rawTickNumber = domains[axis.id].tickNumber;
        const triggerTooltip = !axis.ignoreTooltip && axisIdsTriggeringTooltip.has(axis.id);
        const tickNumber = (0, $6PfPa.scaleTickNumberByRange)(rawTickNumber, zoomRange);
        const data = axis.data ?? [];
        if ((0, $2UPWB.isOrdinalScale)(scale)) {
            // Reverse range because ordinal scales are presented from top to bottom on y-axis
            const scaleRange = axisDirection === 'y' ? [
                range[1],
                range[0]
            ] : range;
            if ((0, $2UPWB.isBandScale)(scale) && (0, $lXwwj.isBandScaleConfig)(axis)) {
                const desiredCategoryGapRatio = axis.categoryGapRatio ?? $62d790ed28c7b514$var$DEFAULT_CATEGORY_GAP_RATIO;
                const ignoreGapRatios = $62d790ed28c7b514$var$shouldIgnoreGapRatios(scale, desiredCategoryGapRatio);
                const categoryGapRatio = ignoreGapRatios ? 0 : desiredCategoryGapRatio;
                const barGapRatio = ignoreGapRatios ? 0 : axis.barGapRatio ?? $62d790ed28c7b514$var$DEFAULT_BAR_GAP_RATIO;
                completeAxis[axis.id] = (0, $62d790ed28c7b514$var$_extends2.default)({
                    offset: 0,
                    height: 0,
                    categoryGapRatio: categoryGapRatio,
                    barGapRatio: barGapRatio,
                    triggerTooltip: triggerTooltip
                }, axis, {
                    data: data,
                    /* Doing this here is technically wrong, but acceptable in practice.
           * In theory, this should be done in the normalized scale selector, but then we'd need that selector to depend
           * on the zoom range, which would void its goal (which is to be independent of zoom).
           * Since we only ignore gap ratios when they're practically invisible, the small errors caused by this
           * discrepancy will hopefully not be noticeable. */ scale: ignoreGapRatios ? scale.copy().padding(0) : scale,
                    tickNumber: tickNumber,
                    colorScale: axis.colorMap && (axis.colorMap.type === 'ordinal' ? (0, $jTrR8.getOrdinalColorScale)((0, $62d790ed28c7b514$var$_extends2.default)({
                        values: axis.data
                    }, axis.colorMap)) : (0, $jTrR8.getColorScale)(axis.colorMap))
                });
            }
            if ((0, $lXwwj.isPointScaleConfig)(axis)) completeAxis[axis.id] = (0, $62d790ed28c7b514$var$_extends2.default)({
                offset: 0,
                height: 0,
                triggerTooltip: triggerTooltip
            }, axis, {
                data: data,
                scale: scale,
                tickNumber: tickNumber,
                colorScale: axis.colorMap && (axis.colorMap.type === 'ordinal' ? (0, $jTrR8.getOrdinalColorScale)((0, $62d790ed28c7b514$var$_extends2.default)({
                    values: axis.data
                }, axis.colorMap)) : (0, $jTrR8.getColorScale)(axis.colorMap))
            });
            if ((0, $QqBso.isDateData)(axis.data)) {
                const dateFormatter = (0, $QqBso.createDateFormatter)(axis.data, scaleRange, axis.tickNumber);
                completeAxis[axis.id].valueFormatter = axis.valueFormatter ?? dateFormatter;
            }
            return;
        }
        if (axis.scaleType === 'band' || axis.scaleType === 'point') // Could be merged with the two previous "if conditions" but then TS does not get that `axis.scaleType` can't be `band` or `point`.
        return;
        const continuousAxis = axis;
        const scaleType = continuousAxis.scaleType ?? 'linear';
        completeAxis[axis.id] = (0, $62d790ed28c7b514$var$_extends2.default)({
            offset: 0,
            height: 0,
            triggerTooltip: triggerTooltip
        }, continuousAxis, {
            data: data,
            scaleType: scaleType,
            scale: scale,
            tickNumber: tickNumber,
            colorScale: continuousAxis.colorMap && (0, $jTrR8.getSequentialColorScale)(continuousAxis.colorMap),
            valueFormatter: axis.valueFormatter ?? (0, $8fmGy.createScalarFormatter)(tickNumber, (0, $ar6SO.getScale)(scaleType, range.map((v)=>scale.invert(v)), range))
        });
    });
    return {
        axis: completeAxis,
        axisIds: allAxis.map(({ id: id })=>id)
    };
}

});
parcelRegister("8fmGy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createScalarFormatter = $018caa9e2a64bc14$var$createScalarFormatter;
/**
 * Creates a default formatter function for continuous scales (e.g., linear, sqrt, log).
 * @returns A formatter function for continuous values.
 */ function $018caa9e2a64bc14$var$createScalarFormatter(tickNumber, zoomScale) {
    return function defaultScalarValueFormatter(value, context) {
        if (context.location === 'tick') {
            const domain = context.scale.domain();
            const zeroSizeDomain = domain[0] === domain[1];
            if (zeroSizeDomain) return context.scale.tickFormat(1)(value);
            return context.scale.tickFormat(tickNumber)(value);
        }
        if (context.location === 'zoom-slider-tooltip') return zoomScale.tickFormat(2)(value);
        return `${value}`;
    };
}

});

parcelRegister("lXwwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBandScaleConfig = $ffc8557edb85cfdc$var$isBandScaleConfig;
module.exports.isContinuousScaleConfig = $ffc8557edb85cfdc$var$isContinuousScaleConfig;
module.exports.isPointScaleConfig = $ffc8557edb85cfdc$var$isPointScaleConfig;
module.exports.isSymlogScaleConfig = $ffc8557edb85cfdc$var$isSymlogScaleConfig;
/**
 * Use this type instead of `AxisScaleConfig` when the values
 * shouldn't be provided by the user.
 */ /**
 * Config that is shared between cartesian and polar axes.
 */ /**
 * Use this type for advanced typing. For basic usage, use `XAxis`, `YAxis`, `RotationAxis` or `RadiusAxis`.
 */ function $ffc8557edb85cfdc$var$isBandScaleConfig(scaleConfig) {
    return scaleConfig.scaleType === 'band';
}
function $ffc8557edb85cfdc$var$isPointScaleConfig(scaleConfig) {
    return scaleConfig.scaleType === 'point';
}
function $ffc8557edb85cfdc$var$isContinuousScaleConfig(scaleConfig) {
    return scaleConfig.scaleType !== 'point' && scaleConfig.scaleType !== 'band';
}
function $ffc8557edb85cfdc$var$isSymlogScaleConfig(scaleConfig) {
    return scaleConfig.scaleType === 'symlog';
} /**
 * The data format returned by onAxisClick.
 */  /**
 * Identifies a data point within an axis.
 */  /**
 * The axis configuration with missing values filled with default values.
 */  /**
 * The x-axis configuration with missing values filled with default values.
 */  /**
 * The y-axis configuration with missing values filled with default values.
 */ 

});

parcelRegister("jTrR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getColorScale = $e7b8c30284648bc0$var$getColorScale;
module.exports.getOrdinalColorScale = $e7b8c30284648bc0$var$getOrdinalColorScale;
module.exports.getSequentialColorScale = $e7b8c30284648bc0$var$getSequentialColorScale;

var $9PbcQ = parcelRequire("9PbcQ");
function $e7b8c30284648bc0$var$getSequentialColorScale(config) {
    if (config.type === 'piecewise') return (0, $9PbcQ.scaleThreshold)(config.thresholds, config.colors);
    return (0, $9PbcQ.scaleSequential)([
        config.min ?? 0,
        config.max ?? 100
    ], config.color);
}
function $e7b8c30284648bc0$var$getOrdinalColorScale(config) {
    if (config.values) return (0, $9PbcQ.scaleOrdinal)(config.values, config.colors).unknown(config.unknownColor ?? null);
    return (0, $9PbcQ.scaleOrdinal)(config.colors.map((_, index)=>index), config.colors).unknown(config.unknownColor ?? null);
}
function $e7b8c30284648bc0$var$getColorScale(config) {
    return config.type === 'ordinal' ? $e7b8c30284648bc0$var$getOrdinalColorScale(config) : $e7b8c30284648bc0$var$getSequentialColorScale(config);
}

});
parcelRegister("9PbcQ", function(module, exports) {
// `x-charts-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("3eODf"));

});
parcelRegister("3eODf", function(module, exports) {
// `x-charts-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("NOzxr"));

});
parcelRegister("NOzxr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $095bce4dab3969f8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $095bce4dab3969f8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $095bce4dab3969f8$var$_tickFormat.default;
    }
});

var $095bce4dab3969f8$var$_band = $095bce4dab3969f8$require$_interopRequireWildcard((parcelRequire("dQG6k")));

var $095bce4dab3969f8$var$_identity = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("8vuqt")));

var $095bce4dab3969f8$var$_linear = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("8HRiH")));

var $095bce4dab3969f8$var$_log = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("cIUw0")));

var $095bce4dab3969f8$var$_symlog = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("3vuXg")));

var $095bce4dab3969f8$var$_ordinal = $095bce4dab3969f8$require$_interopRequireWildcard((parcelRequire("kCx4r")));

var $095bce4dab3969f8$var$_pow = $095bce4dab3969f8$require$_interopRequireWildcard((parcelRequire("hzaGs")));

var $095bce4dab3969f8$var$_radial = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("1UsRs")));

var $095bce4dab3969f8$var$_quantile = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("bJNHi")));

var $095bce4dab3969f8$var$_quantize = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("e6E3w")));

var $095bce4dab3969f8$var$_threshold = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("4gmja")));

var $095bce4dab3969f8$var$_time = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("l62ZM")));

var $095bce4dab3969f8$var$_utcTime = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("8cPDo")));

var $095bce4dab3969f8$var$_sequential = $095bce4dab3969f8$require$_interopRequireWildcard((parcelRequire("9PZF4")));

var $095bce4dab3969f8$var$_sequentialQuantile = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("kUZow")));

var $095bce4dab3969f8$var$_diverging = $095bce4dab3969f8$require$_interopRequireWildcard((parcelRequire("gJbJ0")));

var $095bce4dab3969f8$var$_tickFormat = $095bce4dab3969f8$require$_interopRequireDefault((parcelRequire("jvkAC")));

});
parcelRegister("dQG6k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a150ca1b8b68359c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a150ca1b8b68359c$var$band;
module.exports.point = $a150ca1b8b68359c$var$point;

var $dDi6U = parcelRequire("dDi6U");

var $5dOui = parcelRequire("5dOui");

var $a150ca1b8b68359c$var$_ordinal = $a150ca1b8b68359c$require$_interopRequireDefault((parcelRequire("kCx4r")));
function $a150ca1b8b68359c$var$band() {
    var scale = (0, $a150ca1b8b68359c$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $dDi6U.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $a150ca1b8b68359c$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $5dOui.initRange.apply(rescale(), arguments);
}
function $a150ca1b8b68359c$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $a150ca1b8b68359c$var$pointish(copy());
    };
    return scale;
}
function $a150ca1b8b68359c$var$point() {
    return $a150ca1b8b68359c$var$pointish($a150ca1b8b68359c$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("dDi6U", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9eccf73d57973b6a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9eccf73d57973b6a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $c4pPP.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $cXyFh.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $cXyFh.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "blur", {
    enumerable: true,
    get: function() {
        return $gklu7.blur;
    }
});
Object.defineProperty(module.exports, "blur2", {
    enumerable: true,
    get: function() {
        return $gklu7.blur2;
    }
});
Object.defineProperty(module.exports, "blurImage", {
    enumerable: true,
    get: function() {
        return $gklu7.blurImage;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $c4pPP.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $c4pPP.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_median.default;
    }
});
Object.defineProperty(module.exports, "medianIndex", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_median.medianIndex;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileIndex", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_quantile.quantileIndex;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $9eccf73d57973b6a$var$_zip.default;
    }
});

var $9eccf73d57973b6a$var$_bisect = $9eccf73d57973b6a$require$_interopRequireWildcard((parcelRequire("i1q4d")));

var $9eccf73d57973b6a$var$_ascending = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $9eccf73d57973b6a$var$_bisector = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("bZZwH")));

var $gklu7 = parcelRequire("gklu7");

var $9eccf73d57973b6a$var$_count = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("23Ym4")));

var $9eccf73d57973b6a$var$_cross = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("3UGUA")));

var $9eccf73d57973b6a$var$_cumsum = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("l5s5s")));

var $9eccf73d57973b6a$var$_descending = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("c3Ccd")));

var $9eccf73d57973b6a$var$_deviation = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("lbe3Y")));

var $9eccf73d57973b6a$var$_extent = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("3IPPV")));

var $c4pPP = parcelRequire("c4pPP");

var $9eccf73d57973b6a$var$_group = $9eccf73d57973b6a$require$_interopRequireWildcard((parcelRequire("fZTTo")));

var $9eccf73d57973b6a$var$_groupSort = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("aj3d7")));

var $9eccf73d57973b6a$var$_bin = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("cBYv0")));

var $9eccf73d57973b6a$var$_freedmanDiaconis = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("9ElAb")));

var $9eccf73d57973b6a$var$_scott = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("lWssu")));

var $9eccf73d57973b6a$var$_sturges = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("b8RLQ")));

var $9eccf73d57973b6a$var$_max = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("c9XSY")));

var $9eccf73d57973b6a$var$_maxIndex = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("aN7Eu")));

var $9eccf73d57973b6a$var$_mean = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("6bXpu")));

var $9eccf73d57973b6a$var$_median = $9eccf73d57973b6a$require$_interopRequireWildcard((parcelRequire("ic8v0")));

var $9eccf73d57973b6a$var$_merge = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("kb0Eh")));

var $9eccf73d57973b6a$var$_min = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("1KiwI")));

var $9eccf73d57973b6a$var$_minIndex = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("lHzrQ")));

var $9eccf73d57973b6a$var$_mode = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("gsR4Z")));

var $9eccf73d57973b6a$var$_nice = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("hHaTX")));

var $9eccf73d57973b6a$var$_pairs = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("8O5FB")));

var $9eccf73d57973b6a$var$_permute = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("gN8yc")));

var $9eccf73d57973b6a$var$_quantile = $9eccf73d57973b6a$require$_interopRequireWildcard((parcelRequire("2Hzmw")));

var $9eccf73d57973b6a$var$_quickselect = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("01D8e")));

var $9eccf73d57973b6a$var$_range = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("8pAr7")));

var $9eccf73d57973b6a$var$_rank = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("amlRt")));

var $9eccf73d57973b6a$var$_least = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("gsiOA")));

var $9eccf73d57973b6a$var$_leastIndex = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("ci651")));

var $9eccf73d57973b6a$var$_greatest = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("3B3AP")));

var $9eccf73d57973b6a$var$_greatestIndex = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("1Ltsx")));

var $9eccf73d57973b6a$var$_scan = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("coEkQ")));

var $9eccf73d57973b6a$var$_shuffle = $9eccf73d57973b6a$require$_interopRequireWildcard((parcelRequire("af3NC")));

var $9eccf73d57973b6a$var$_sum = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("jPMPG")));

var $9eccf73d57973b6a$var$_ticks = $9eccf73d57973b6a$require$_interopRequireWildcard((parcelRequire("4gfuH")));

var $9eccf73d57973b6a$var$_transpose = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("i5349")));

var $9eccf73d57973b6a$var$_variance = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("5Db0Q")));

var $9eccf73d57973b6a$var$_zip = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("7jp0n")));

var $9eccf73d57973b6a$var$_every = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("4ttVE")));

var $9eccf73d57973b6a$var$_some = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("11SZf")));

var $9eccf73d57973b6a$var$_filter = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("fc1E5")));

var $9eccf73d57973b6a$var$_map = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("gpN8m")));

var $9eccf73d57973b6a$var$_reduce = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("etyBW")));

var $9eccf73d57973b6a$var$_reverse = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("c3kJe")));

var $9eccf73d57973b6a$var$_sort = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("c0sf4")));

var $9eccf73d57973b6a$var$_difference = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("5xvGM")));

var $9eccf73d57973b6a$var$_disjoint = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("hyetQ")));

var $9eccf73d57973b6a$var$_intersection = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("dHsLX")));

var $9eccf73d57973b6a$var$_subset = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("3bXiP")));

var $9eccf73d57973b6a$var$_superset = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("lptJL")));

var $9eccf73d57973b6a$var$_union = $9eccf73d57973b6a$require$_interopRequireDefault((parcelRequire("al72V")));

var $cXyFh = parcelRequire("cXyFh");

});
parcelRegister("i1q4d", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1ec8a5643dcba75$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $d1ec8a5643dcba75$var$_ascending = $d1ec8a5643dcba75$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $d1ec8a5643dcba75$var$_bisector = $d1ec8a5643dcba75$require$_interopRequireDefault((parcelRequire("bZZwH")));

var $d1ec8a5643dcba75$var$_number = $d1ec8a5643dcba75$require$_interopRequireDefault((parcelRequire("ekh94")));
const $d1ec8a5643dcba75$var$ascendingBisect = (0, $d1ec8a5643dcba75$var$_bisector.default)($d1ec8a5643dcba75$var$_ascending.default);
const $d1ec8a5643dcba75$var$bisectRight = module.exports.bisectRight = $d1ec8a5643dcba75$var$ascendingBisect.right;
const $d1ec8a5643dcba75$var$bisectLeft = module.exports.bisectLeft = $d1ec8a5643dcba75$var$ascendingBisect.left;
const $d1ec8a5643dcba75$var$bisectCenter = module.exports.bisectCenter = (0, $d1ec8a5643dcba75$var$_bisector.default)($d1ec8a5643dcba75$var$_number.default).center;
var $d1ec8a5643dcba75$var$_default = module.exports.default = $d1ec8a5643dcba75$var$bisectRight;

});
parcelRegister("8RvqN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $673ba7861a99645e$var$ascending;
function $673ba7861a99645e$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("bZZwH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8bc51e18c03db150$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8bc51e18c03db150$var$bisector;

var $8bc51e18c03db150$var$_ascending = $8bc51e18c03db150$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $8bc51e18c03db150$var$_descending = $8bc51e18c03db150$require$_interopRequireDefault((parcelRequire("c3Ccd")));
function $8bc51e18c03db150$var$bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $8bc51e18c03db150$var$_ascending.default;
        compare2 = (d, x)=>(0, $8bc51e18c03db150$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $8bc51e18c03db150$var$_ascending.default || f === $8bc51e18c03db150$var$_descending.default ? f : $8bc51e18c03db150$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $8bc51e18c03db150$var$zero() {
    return 0;
}

});
parcelRegister("c3Ccd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c7364c238732e22$var$descending;
function $8c7364c238732e22$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("ekh94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6e03ba6667d597e$var$number;
module.exports.numbers = $a6e03ba6667d597e$var$numbers;
function $a6e03ba6667d597e$var$number(x) {
    return x === null ? NaN : +x;
}
function* $a6e03ba6667d597e$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("gklu7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.blur = $be2f2e02f3f2cf23$var$blur;
module.exports.blurImage = module.exports.blur2 = void 0;
function $be2f2e02f3f2cf23$var$blur(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = $be2f2e02f3f2cf23$var$blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const $be2f2e02f3f2cf23$var$blur2 = module.exports.blur2 = $be2f2e02f3f2cf23$var$Blur2($be2f2e02f3f2cf23$var$blurf);
const $be2f2e02f3f2cf23$var$blurImage = module.exports.blurImage = $be2f2e02f3f2cf23$var$Blur2($be2f2e02f3f2cf23$var$blurfImage);
function $be2f2e02f3f2cf23$var$Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width: width, height: height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            $be2f2e02f3f2cf23$var$blurh(blurx, temp, values, width, height);
            $be2f2e02f3f2cf23$var$blurh(blurx, values, temp, width, height);
            $be2f2e02f3f2cf23$var$blurh(blurx, temp, values, width, height);
            $be2f2e02f3f2cf23$var$blurv(blury, values, temp, width, height);
            $be2f2e02f3f2cf23$var$blurv(blury, temp, values, width, height);
            $be2f2e02f3f2cf23$var$blurv(blury, values, temp, width, height);
        } else if (blurx) {
            $be2f2e02f3f2cf23$var$blurh(blurx, values, temp, width, height);
            $be2f2e02f3f2cf23$var$blurh(blurx, temp, values, width, height);
            $be2f2e02f3f2cf23$var$blurh(blurx, values, temp, width, height);
        } else if (blury) {
            $be2f2e02f3f2cf23$var$blurv(blury, values, temp, width, height);
            $be2f2e02f3f2cf23$var$blurv(blury, temp, values, width, height);
            $be2f2e02f3f2cf23$var$blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function $be2f2e02f3f2cf23$var$blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function $be2f2e02f3f2cf23$var$blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function $be2f2e02f3f2cf23$var$blurfImage(radius) {
    const blur = $be2f2e02f3f2cf23$var$blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function $be2f2e02f3f2cf23$var$blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return $be2f2e02f3f2cf23$var$bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        // stop must be aligned!
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function $be2f2e02f3f2cf23$var$bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        // stop must be aligned!
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

});

parcelRegister("23Ym4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $180aadd955d19a2e$var$count;
function $180aadd955d19a2e$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("3UGUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d97e37321c0ed6a$var$cross;
function $2d97e37321c0ed6a$var$length(array) {
    return array.length | 0;
}
function $2d97e37321c0ed6a$var$empty(length) {
    return !(length > 0);
}
function $2d97e37321c0ed6a$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $2d97e37321c0ed6a$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $2d97e37321c0ed6a$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $2d97e37321c0ed6a$var$reducer(values.pop());
    values = values.map($2d97e37321c0ed6a$var$arrayify);
    const lengths = values.map($2d97e37321c0ed6a$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($2d97e37321c0ed6a$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("l5s5s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f59fda194c6f2763$var$cumsum;
function $f59fda194c6f2763$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("lbe3Y", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f6b588adc637ed3a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6b588adc637ed3a$var$deviation;

var $f6b588adc637ed3a$var$_variance = $f6b588adc637ed3a$require$_interopRequireDefault((parcelRequire("5Db0Q")));
function $f6b588adc637ed3a$var$deviation(values, valueof) {
    const v = (0, $f6b588adc637ed3a$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("5Db0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4199232a2b59e6dd$var$variance;
function $4199232a2b59e6dd$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("3IPPV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b5db0d10ac81c22$var$extent;
function $2b5db0d10ac81c22$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("c4pPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $8c99e60adf02e1cb$var$fcumsum;
module.exports.fsum = $8c99e60adf02e1cb$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $8c99e60adf02e1cb$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $8c99e60adf02e1cb$var$Adder;
function $8c99e60adf02e1cb$var$fsum(values, valueof) {
    const adder = new $8c99e60adf02e1cb$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $8c99e60adf02e1cb$var$fcumsum(values, valueof) {
    const adder = new $8c99e60adf02e1cb$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("fZTTo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ba57e89ba7ae1510$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba57e89ba7ae1510$var$group;
module.exports.flatGroup = $ba57e89ba7ae1510$var$flatGroup;
module.exports.flatRollup = $ba57e89ba7ae1510$var$flatRollup;
module.exports.groups = $ba57e89ba7ae1510$var$groups;
module.exports.index = $ba57e89ba7ae1510$var$index;
module.exports.indexes = $ba57e89ba7ae1510$var$indexes;
module.exports.rollup = $ba57e89ba7ae1510$var$rollup;
module.exports.rollups = $ba57e89ba7ae1510$var$rollups;

var $cXyFh = parcelRequire("cXyFh");

var $ba57e89ba7ae1510$var$_identity = $ba57e89ba7ae1510$require$_interopRequireDefault((parcelRequire("2oXOo")));
function $ba57e89ba7ae1510$var$group(values, ...keys) {
    return $ba57e89ba7ae1510$var$nest(values, $ba57e89ba7ae1510$var$_identity.default, $ba57e89ba7ae1510$var$_identity.default, keys);
}
function $ba57e89ba7ae1510$var$groups(values, ...keys) {
    return $ba57e89ba7ae1510$var$nest(values, Array.from, $ba57e89ba7ae1510$var$_identity.default, keys);
}
function $ba57e89ba7ae1510$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $ba57e89ba7ae1510$var$flatGroup(values, ...keys) {
    return $ba57e89ba7ae1510$var$flatten($ba57e89ba7ae1510$var$groups(values, ...keys), keys);
}
function $ba57e89ba7ae1510$var$flatRollup(values, reduce, ...keys) {
    return $ba57e89ba7ae1510$var$flatten($ba57e89ba7ae1510$var$rollups(values, reduce, ...keys), keys);
}
function $ba57e89ba7ae1510$var$rollup(values, reduce, ...keys) {
    return $ba57e89ba7ae1510$var$nest(values, $ba57e89ba7ae1510$var$_identity.default, reduce, keys);
}
function $ba57e89ba7ae1510$var$rollups(values, reduce, ...keys) {
    return $ba57e89ba7ae1510$var$nest(values, Array.from, reduce, keys);
}
function $ba57e89ba7ae1510$var$index(values, ...keys) {
    return $ba57e89ba7ae1510$var$nest(values, $ba57e89ba7ae1510$var$_identity.default, $ba57e89ba7ae1510$var$unique, keys);
}
function $ba57e89ba7ae1510$var$indexes(values, ...keys) {
    return $ba57e89ba7ae1510$var$nest(values, Array.from, $ba57e89ba7ae1510$var$unique, keys);
}
function $ba57e89ba7ae1510$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $ba57e89ba7ae1510$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $cXyFh.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("cXyFh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $96f5e273320f0eb0$var$InternMap extends Map {
    constructor(entries, key = $96f5e273320f0eb0$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($96f5e273320f0eb0$var$intern_get(this, key));
    }
    has(key) {
        return super.has($96f5e273320f0eb0$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($96f5e273320f0eb0$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($96f5e273320f0eb0$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $96f5e273320f0eb0$var$InternMap;
class $96f5e273320f0eb0$var$InternSet extends Set {
    constructor(values, key = $96f5e273320f0eb0$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($96f5e273320f0eb0$var$intern_get(this, value));
    }
    add(value) {
        return super.add($96f5e273320f0eb0$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($96f5e273320f0eb0$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $96f5e273320f0eb0$var$InternSet;
function $96f5e273320f0eb0$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $96f5e273320f0eb0$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $96f5e273320f0eb0$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $96f5e273320f0eb0$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("2oXOo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1bfc38052c9fb371$var$identity;
function $1bfc38052c9fb371$var$identity(x) {
    return x;
}

});


parcelRegister("aj3d7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $780e2b4c582ec74c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $780e2b4c582ec74c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $780e2b4c582ec74c$var$groupSort;

var $780e2b4c582ec74c$var$_ascending = $780e2b4c582ec74c$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $780e2b4c582ec74c$var$_group = $780e2b4c582ec74c$require$_interopRequireWildcard((parcelRequire("fZTTo")));

var $780e2b4c582ec74c$var$_sort = $780e2b4c582ec74c$require$_interopRequireDefault((parcelRequire("c0sf4")));
function $780e2b4c582ec74c$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $780e2b4c582ec74c$var$_sort.default)((0, $780e2b4c582ec74c$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $780e2b4c582ec74c$var$_ascending.default)(av, bv) || (0, $780e2b4c582ec74c$var$_ascending.default)(ak, bk)) : (0, $780e2b4c582ec74c$var$_sort.default)((0, $780e2b4c582ec74c$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $780e2b4c582ec74c$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("c0sf4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8bdb64679ee23743$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $8bdb64679ee23743$var$ascendingDefined;
module.exports.compareDefined = $8bdb64679ee23743$var$compareDefined;
module.exports.default = $8bdb64679ee23743$var$sort;

var $8bdb64679ee23743$var$_ascending = $8bdb64679ee23743$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $8bdb64679ee23743$var$_permute = $8bdb64679ee23743$require$_interopRequireDefault((parcelRequire("gN8yc")));
function $8bdb64679ee23743$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $8bdb64679ee23743$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$8bdb64679ee23743$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $8bdb64679ee23743$var$_permute.default)(values, index);
    }
    return values.sort($8bdb64679ee23743$var$compareDefined(f));
}
function $8bdb64679ee23743$var$compareDefined(compare = $8bdb64679ee23743$var$_ascending.default) {
    if (compare === $8bdb64679ee23743$var$_ascending.default) return $8bdb64679ee23743$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $8bdb64679ee23743$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("gN8yc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c397dae67b378442$var$permute;
function $c397dae67b378442$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("cBYv0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $92e7de92c9f89788$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $92e7de92c9f89788$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92e7de92c9f89788$var$bin;

var $hBnGJ = parcelRequire("hBnGJ");

var $92e7de92c9f89788$var$_bisect = $92e7de92c9f89788$require$_interopRequireDefault((parcelRequire("i1q4d")));

var $92e7de92c9f89788$var$_constant = $92e7de92c9f89788$require$_interopRequireDefault((parcelRequire("itMeI")));

var $92e7de92c9f89788$var$_extent = $92e7de92c9f89788$require$_interopRequireDefault((parcelRequire("3IPPV")));

var $92e7de92c9f89788$var$_identity = $92e7de92c9f89788$require$_interopRequireDefault((parcelRequire("2oXOo")));

var $92e7de92c9f89788$var$_nice = $92e7de92c9f89788$require$_interopRequireDefault((parcelRequire("hHaTX")));

var $92e7de92c9f89788$var$_ticks = $92e7de92c9f89788$require$_interopRequireWildcard((parcelRequire("4gfuH")));

var $92e7de92c9f89788$var$_sturges = $92e7de92c9f89788$require$_interopRequireDefault((parcelRequire("b8RLQ")));
function $92e7de92c9f89788$var$bin() {
    var value = $92e7de92c9f89788$var$_identity.default, domain = $92e7de92c9f89788$var$_extent.default, threshold = $92e7de92c9f89788$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $92e7de92c9f89788$var$_extent.default) [x0, x1] = (0, $92e7de92c9f89788$var$_nice.default)(x0, x1, tn);
            tz = (0, $92e7de92c9f89788$var$_ticks.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $92e7de92c9f89788$var$_ticks.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $92e7de92c9f89788$var$_extent.default) {
                    const step = (0, $92e7de92c9f89788$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $92e7de92c9f89788$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $92e7de92c9f89788$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $92e7de92c9f89788$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, $92e7de92c9f89788$var$_constant.default)(Array.isArray(_) ? $hBnGJ.slice.call(_) : _), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("hBnGJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $cd084461859bff2c$var$array = Array.prototype;
var $cd084461859bff2c$var$slice = module.exports.slice = $cd084461859bff2c$var$array.slice;
var $cd084461859bff2c$var$map = module.exports.map = $cd084461859bff2c$var$array.map;

});

parcelRegister("itMeI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7405a27e78aaa78$var$constant;
function $d7405a27e78aaa78$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("hHaTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce1ee8a09515b757$var$nice;

var $4gfuH = parcelRequire("4gfuH");
function $ce1ee8a09515b757$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $4gfuH.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("4gfuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31a4acda0718b19e$var$ticks;
module.exports.tickIncrement = $31a4acda0718b19e$var$tickIncrement;
module.exports.tickStep = $31a4acda0718b19e$var$tickStep;
const $31a4acda0718b19e$var$e10 = Math.sqrt(50), $31a4acda0718b19e$var$e5 = Math.sqrt(10), $31a4acda0718b19e$var$e2 = Math.sqrt(2);
function $31a4acda0718b19e$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $31a4acda0718b19e$var$e10 ? 10 : error >= $31a4acda0718b19e$var$e5 ? 5 : error >= $31a4acda0718b19e$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $31a4acda0718b19e$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $31a4acda0718b19e$var$ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $31a4acda0718b19e$var$tickSpec(stop, start, count) : $31a4acda0718b19e$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $31a4acda0718b19e$var$tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $31a4acda0718b19e$var$tickSpec(start, stop, count)[2];
}
function $31a4acda0718b19e$var$tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $31a4acda0718b19e$var$tickIncrement(stop, start, count) : $31a4acda0718b19e$var$tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});


parcelRegister("b8RLQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $81ca26ca2b43c200$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81ca26ca2b43c200$var$thresholdSturges;

var $81ca26ca2b43c200$var$_count = $81ca26ca2b43c200$require$_interopRequireDefault((parcelRequire("23Ym4")));
function $81ca26ca2b43c200$var$thresholdSturges(values) {
    return Math.max(1, Math.ceil(Math.log((0, $81ca26ca2b43c200$var$_count.default)(values)) / Math.LN2) + 1);
}

});


parcelRegister("9ElAb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $70689759d9a656f7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $70689759d9a656f7$var$thresholdFreedmanDiaconis;

var $70689759d9a656f7$var$_count = $70689759d9a656f7$require$_interopRequireDefault((parcelRequire("23Ym4")));

var $70689759d9a656f7$var$_quantile = $70689759d9a656f7$require$_interopRequireDefault((parcelRequire("2Hzmw")));
function $70689759d9a656f7$var$thresholdFreedmanDiaconis(values, min, max) {
    const c = (0, $70689759d9a656f7$var$_count.default)(values), d = (0, $70689759d9a656f7$var$_quantile.default)(values, 0.75) - (0, $70689759d9a656f7$var$_quantile.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

});
parcelRegister("2Hzmw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1f7b071ca18df6ea$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1f7b071ca18df6ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f7b071ca18df6ea$var$quantile;
module.exports.quantileIndex = $1f7b071ca18df6ea$var$quantileIndex;
module.exports.quantileSorted = $1f7b071ca18df6ea$var$quantileSorted;

var $1f7b071ca18df6ea$var$_max = $1f7b071ca18df6ea$require$_interopRequireDefault((parcelRequire("c9XSY")));

var $1f7b071ca18df6ea$var$_maxIndex = $1f7b071ca18df6ea$require$_interopRequireDefault((parcelRequire("aN7Eu")));

var $1f7b071ca18df6ea$var$_min = $1f7b071ca18df6ea$require$_interopRequireDefault((parcelRequire("1KiwI")));

var $1f7b071ca18df6ea$var$_minIndex = $1f7b071ca18df6ea$require$_interopRequireDefault((parcelRequire("lHzrQ")));

var $1f7b071ca18df6ea$var$_quickselect = $1f7b071ca18df6ea$require$_interopRequireDefault((parcelRequire("01D8e")));

var $1f7b071ca18df6ea$var$_number = $1f7b071ca18df6ea$require$_interopRequireWildcard((parcelRequire("ekh94")));

var $c0sf4 = parcelRequire("c0sf4");

var $1f7b071ca18df6ea$var$_greatest = $1f7b071ca18df6ea$require$_interopRequireDefault((parcelRequire("3B3AP")));
function $1f7b071ca18df6ea$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $1f7b071ca18df6ea$var$_number.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $1f7b071ca18df6ea$var$_min.default)(values);
    if (p >= 1) return (0, $1f7b071ca18df6ea$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $1f7b071ca18df6ea$var$_max.default)((0, $1f7b071ca18df6ea$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $1f7b071ca18df6ea$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $1f7b071ca18df6ea$var$quantileSorted(values, p, valueof = $1f7b071ca18df6ea$var$_number.default) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $1f7b071ca18df6ea$var$quantileIndex(values, p, valueof = $1f7b071ca18df6ea$var$_number.default) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $1f7b071ca18df6ea$var$_number.default)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $1f7b071ca18df6ea$var$_minIndex.default)(numbers);
    if (p >= 1) return (0, $1f7b071ca18df6ea$var$_maxIndex.default)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $1f7b071ca18df6ea$var$_quickselect.default)(index, i, 0, j, (i, j)=>(0, $c0sf4.ascendingDefined)(numbers[i], numbers[j]));
    i = (0, $1f7b071ca18df6ea$var$_greatest.default)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}

});
parcelRegister("c9XSY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8da4c7599c14cec1$var$max;
function $8da4c7599c14cec1$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("aN7Eu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7db46a8ba85378b3$var$maxIndex;
function $7db46a8ba85378b3$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("1KiwI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1458755893dd6c40$var$min;
function $1458755893dd6c40$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("lHzrQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fcc91c6429491c7a$var$minIndex;
function $fcc91c6429491c7a$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("01D8e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $004e72dbb8890db9$var$quickselect;

var $c0sf4 = parcelRequire("c0sf4");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $004e72dbb8890db9$var$quickselect(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? $c0sf4.ascendingDefined : (0, $c0sf4.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $004e72dbb8890db9$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $004e72dbb8890db9$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $004e72dbb8890db9$var$swap(array, left, right);
        while(i < j){
            $004e72dbb8890db9$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $004e72dbb8890db9$var$swap(array, left, j);
        else ++j, $004e72dbb8890db9$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $004e72dbb8890db9$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});

parcelRegister("3B3AP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29e79d51a5113ecb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $29e79d51a5113ecb$var$greatest;

var $29e79d51a5113ecb$var$_ascending = $29e79d51a5113ecb$require$_interopRequireDefault((parcelRequire("8RvqN")));
function $29e79d51a5113ecb$var$greatest(values, compare = $29e79d51a5113ecb$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $29e79d51a5113ecb$var$_ascending.default)(value, maxValue) > 0 : (0, $29e79d51a5113ecb$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});



parcelRegister("lWssu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ff9517002bb2d56d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ff9517002bb2d56d$var$thresholdScott;

var $ff9517002bb2d56d$var$_count = $ff9517002bb2d56d$require$_interopRequireDefault((parcelRequire("23Ym4")));

var $ff9517002bb2d56d$var$_deviation = $ff9517002bb2d56d$require$_interopRequireDefault((parcelRequire("lbe3Y")));
function $ff9517002bb2d56d$var$thresholdScott(values, min, max) {
    const c = (0, $ff9517002bb2d56d$var$_count.default)(values), d = (0, $ff9517002bb2d56d$var$_deviation.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

});

parcelRegister("6bXpu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4821dac82a8fcc50$var$mean;
function $4821dac82a8fcc50$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("ic8v0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d3eff0be0ccb0146$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d3eff0be0ccb0146$var$median;
module.exports.medianIndex = $d3eff0be0ccb0146$var$medianIndex;

var $d3eff0be0ccb0146$var$_quantile = $d3eff0be0ccb0146$require$_interopRequireWildcard((parcelRequire("2Hzmw")));
function $d3eff0be0ccb0146$var$median(values, valueof) {
    return (0, $d3eff0be0ccb0146$var$_quantile.default)(values, 0.5, valueof);
}
function $d3eff0be0ccb0146$var$medianIndex(values, valueof) {
    return (0, $d3eff0be0ccb0146$var$_quantile.quantileIndex)(values, 0.5, valueof);
}

});

parcelRegister("kb0Eh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb05568bfe39e1b4$var$merge;
function* $eb05568bfe39e1b4$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $eb05568bfe39e1b4$var$merge(arrays) {
    return Array.from($eb05568bfe39e1b4$var$flatten(arrays));
}

});

parcelRegister("gsR4Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfc86f58af5e635c$var$mode;

var $cXyFh = parcelRequire("cXyFh");
function $bfc86f58af5e635c$var$mode(values, valueof) {
    const counts = new $cXyFh.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("8O5FB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6697642a6e664037$var$pairs;
module.exports.pair = $6697642a6e664037$var$pair;
function $6697642a6e664037$var$pairs(values, pairof = $6697642a6e664037$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $6697642a6e664037$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("8pAr7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61fcec04056f5a43$var$range;
function $61fcec04056f5a43$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("amlRt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $78aceab66ca5e307$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78aceab66ca5e307$var$rank;

var $78aceab66ca5e307$var$_ascending = $78aceab66ca5e307$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $c0sf4 = parcelRequire("c0sf4");
function $78aceab66ca5e307$var$rank(values, valueof = $78aceab66ca5e307$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $78aceab66ca5e307$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === $78aceab66ca5e307$var$_ascending.default ? (i, j)=>(0, $c0sf4.ascendingDefined)(V[i], V[j]) : (0, $c0sf4.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("gsiOA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bfaddb1f184536fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfaddb1f184536fd$var$least;

var $bfaddb1f184536fd$var$_ascending = $bfaddb1f184536fd$require$_interopRequireDefault((parcelRequire("8RvqN")));
function $bfaddb1f184536fd$var$least(values, compare = $bfaddb1f184536fd$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $bfaddb1f184536fd$var$_ascending.default)(value, minValue) < 0 : (0, $bfaddb1f184536fd$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("ci651", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8f2be1d8d872b5b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f2be1d8d872b5b4$var$leastIndex;

var $8f2be1d8d872b5b4$var$_ascending = $8f2be1d8d872b5b4$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $8f2be1d8d872b5b4$var$_minIndex = $8f2be1d8d872b5b4$require$_interopRequireDefault((parcelRequire("lHzrQ")));
function $8f2be1d8d872b5b4$var$leastIndex(values, compare = $8f2be1d8d872b5b4$var$_ascending.default) {
    if (compare.length === 1) return (0, $8f2be1d8d872b5b4$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("1Ltsx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1491083688c77587$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1491083688c77587$var$greatestIndex;

var $1491083688c77587$var$_ascending = $1491083688c77587$require$_interopRequireDefault((parcelRequire("8RvqN")));

var $1491083688c77587$var$_maxIndex = $1491083688c77587$require$_interopRequireDefault((parcelRequire("aN7Eu")));
function $1491083688c77587$var$greatestIndex(values, compare = $1491083688c77587$var$_ascending.default) {
    if (compare.length === 1) return (0, $1491083688c77587$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("coEkQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $906703ae5676753a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $906703ae5676753a$var$scan;

var $906703ae5676753a$var$_leastIndex = $906703ae5676753a$require$_interopRequireDefault((parcelRequire("ci651")));
function $906703ae5676753a$var$scan(values, compare) {
    const index = (0, $906703ae5676753a$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("af3NC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $774e408ae3bfe1f6$var$shuffler;
var $774e408ae3bfe1f6$var$_default = module.exports.default = $774e408ae3bfe1f6$var$shuffler(Math.random);
function $774e408ae3bfe1f6$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("jPMPG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e708a8e590b95841$var$sum;
function $e708a8e590b95841$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("i5349", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d29b126fc2b18c51$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d29b126fc2b18c51$var$transpose;

var $d29b126fc2b18c51$var$_min = $d29b126fc2b18c51$require$_interopRequireDefault((parcelRequire("1KiwI")));
function $d29b126fc2b18c51$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $d29b126fc2b18c51$var$_min.default)(matrix, $d29b126fc2b18c51$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $d29b126fc2b18c51$var$length(d) {
    return d.length;
}

});

parcelRegister("7jp0n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $552db4395960c3ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $552db4395960c3ab$var$zip;

var $552db4395960c3ab$var$_transpose = $552db4395960c3ab$require$_interopRequireDefault((parcelRequire("i5349")));
function $552db4395960c3ab$var$zip() {
    return (0, $552db4395960c3ab$var$_transpose.default)(arguments);
}

});

parcelRegister("4ttVE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34211618cd658c2a$var$every;
function $34211618cd658c2a$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("11SZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c0089ae0dc2c839$var$some;
function $0c0089ae0dc2c839$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("fc1E5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0f940cc8d5ce8ea$var$filter;
function $b0f940cc8d5ce8ea$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("gpN8m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf351813652f4e52$var$map;
function $bf351813652f4e52$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("etyBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a89e9f29126b7356$var$reduce;
function $a89e9f29126b7356$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("c3kJe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c65d81a534d0a6e$var$reverse;
function $8c65d81a534d0a6e$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("5xvGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40889d9d6e08dfb6$var$difference;

var $cXyFh = parcelRequire("cXyFh");
function $40889d9d6e08dfb6$var$difference(values, ...others) {
    values = new $cXyFh.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("hyetQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc70d8283aa99fe2$var$disjoint;

var $cXyFh = parcelRequire("cXyFh");
function $cc70d8283aa99fe2$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $cXyFh.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("dHsLX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f959c1ef723d480$var$intersection;

var $cXyFh = parcelRequire("cXyFh");
function $9f959c1ef723d480$var$intersection(values, ...others) {
    values = new $cXyFh.InternSet(values);
    others = others.map($9f959c1ef723d480$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $9f959c1ef723d480$var$set(values) {
    return values instanceof $cXyFh.InternSet ? values : new $cXyFh.InternSet(values);
}

});

parcelRegister("3bXiP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25306677c68c29e0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25306677c68c29e0$var$subset;

var $25306677c68c29e0$var$_superset = $25306677c68c29e0$require$_interopRequireDefault((parcelRequire("lptJL")));
function $25306677c68c29e0$var$subset(values, other) {
    return (0, $25306677c68c29e0$var$_superset.default)(other, values);
}

});
parcelRegister("lptJL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f962ffec3f8d0230$var$superset;
function $f962ffec3f8d0230$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $f962ffec3f8d0230$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $f962ffec3f8d0230$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $f962ffec3f8d0230$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("al72V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $787154cbb92df701$var$union;

var $cXyFh = parcelRequire("cXyFh");
function $787154cbb92df701$var$union(...others) {
    const set = new $cXyFh.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("5dOui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $3cd5546f9675a682$var$initInterpolator;
module.exports.initRange = $3cd5546f9675a682$var$initRange;
function $3cd5546f9675a682$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $3cd5546f9675a682$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("kCx4r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f03102679daa6692$var$ordinal;
module.exports.implicit = void 0;

var $dDi6U = parcelRequire("dDi6U");

var $5dOui = parcelRequire("5dOui");
const $f03102679daa6692$var$implicit = module.exports.implicit = Symbol("implicit");
function $f03102679daa6692$var$ordinal() {
    var index = new $dDi6U.InternMap(), domain = [], range = [], unknown = $f03102679daa6692$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $f03102679daa6692$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $dDi6U.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $f03102679daa6692$var$ordinal(domain, range).unknown(unknown);
    };
    $5dOui.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("8vuqt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6318d1f6c51c7109$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6318d1f6c51c7109$var$identity;

var $8HRiH = parcelRequire("8HRiH");

var $6318d1f6c51c7109$var$_number = $6318d1f6c51c7109$require$_interopRequireDefault((parcelRequire("9JYVc")));
function $6318d1f6c51c7109$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $6318d1f6c51c7109$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $6318d1f6c51c7109$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $6318d1f6c51c7109$var$_number.default) : [
        0,
        1
    ];
    return (0, $8HRiH.linearish)(scale);
}

});
parcelRegister("8HRiH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $656baf495f00509a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $656baf495f00509a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $656baf495f00509a$var$linear;
module.exports.linearish = $656baf495f00509a$var$linearish;

var $dDi6U = parcelRequire("dDi6U");

var $656baf495f00509a$var$_continuous = $656baf495f00509a$require$_interopRequireWildcard((parcelRequire("izFby")));

var $5dOui = parcelRequire("5dOui");

var $656baf495f00509a$var$_tickFormat = $656baf495f00509a$require$_interopRequireDefault((parcelRequire("jvkAC")));
function $656baf495f00509a$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $dDi6U.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $656baf495f00509a$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $dDi6U.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $656baf495f00509a$var$linear() {
    var scale = (0, $656baf495f00509a$var$_continuous.default)();
    scale.copy = function() {
        return (0, $656baf495f00509a$var$_continuous.copy)(scale, $656baf495f00509a$var$linear());
    };
    $5dOui.initRange.apply(scale, arguments);
    return $656baf495f00509a$var$linearish(scale);
}

});
parcelRegister("izFby", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d85b716a3d2268ee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $d85b716a3d2268ee$var$copy;
module.exports.default = $d85b716a3d2268ee$var$continuous;
module.exports.identity = $d85b716a3d2268ee$var$identity;
module.exports.transformer = $d85b716a3d2268ee$var$transformer;

var $dDi6U = parcelRequire("dDi6U");

var $jipHj = parcelRequire("jipHj");

var $d85b716a3d2268ee$var$_constant = $d85b716a3d2268ee$require$_interopRequireDefault((parcelRequire("5C2v7")));

var $d85b716a3d2268ee$var$_number = $d85b716a3d2268ee$require$_interopRequireDefault((parcelRequire("9JYVc")));
var $d85b716a3d2268ee$var$unit = [
    0,
    1
];
function $d85b716a3d2268ee$var$identity(x) {
    return x;
}
function $d85b716a3d2268ee$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $d85b716a3d2268ee$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $d85b716a3d2268ee$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $d85b716a3d2268ee$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $d85b716a3d2268ee$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $d85b716a3d2268ee$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $d85b716a3d2268ee$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $d85b716a3d2268ee$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $dDi6U.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $d85b716a3d2268ee$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $d85b716a3d2268ee$var$transformer() {
    var domain = $d85b716a3d2268ee$var$unit, range = $d85b716a3d2268ee$var$unit, interpolate = $jipHj.interpolate, transform, untransform, unknown, clamp = $d85b716a3d2268ee$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $d85b716a3d2268ee$var$identity) clamp = $d85b716a3d2268ee$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $d85b716a3d2268ee$var$polymap : $d85b716a3d2268ee$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $jipHj.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $d85b716a3d2268ee$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $jipHj.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $d85b716a3d2268ee$var$identity, rescale()) : clamp !== $d85b716a3d2268ee$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $d85b716a3d2268ee$var$continuous() {
    return $d85b716a3d2268ee$var$transformer()($d85b716a3d2268ee$var$identity, $d85b716a3d2268ee$var$identity);
}

});
parcelRegister("jipHj", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e0c3a1c5820c71a8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e0c3a1c5820c71a8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $c9Rgv.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $c9Rgv.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $e0c3a1c5820c71a8$var$_quantize.default;
    }
});

var $e0c3a1c5820c71a8$var$_value = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("8zxdz")));

var $e0c3a1c5820c71a8$var$_array = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("5K0GI")));

var $e0c3a1c5820c71a8$var$_basis = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("hkCaB")));

var $e0c3a1c5820c71a8$var$_basisClosed = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("RIvCU")));

var $e0c3a1c5820c71a8$var$_date = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("1edxW")));

var $e0c3a1c5820c71a8$var$_discrete = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("eNtbJ")));

var $e0c3a1c5820c71a8$var$_hue = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("3QFck")));

var $e0c3a1c5820c71a8$var$_number = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("c2SMs")));

var $e0c3a1c5820c71a8$var$_numberArray = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("3XMWQ")));

var $e0c3a1c5820c71a8$var$_object = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("lgjis")));

var $e0c3a1c5820c71a8$var$_round = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("4fJtT")));

var $e0c3a1c5820c71a8$var$_string = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("hlvuM")));

var $c9Rgv = parcelRequire("c9Rgv");

var $e0c3a1c5820c71a8$var$_zoom = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("5BRpM")));

var $e0c3a1c5820c71a8$var$_rgb = $e0c3a1c5820c71a8$require$_interopRequireWildcard((parcelRequire("7Kioe")));

var $e0c3a1c5820c71a8$var$_hsl = $e0c3a1c5820c71a8$require$_interopRequireWildcard((parcelRequire("17oJt")));

var $e0c3a1c5820c71a8$var$_lab = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("kfdjM")));

var $e0c3a1c5820c71a8$var$_hcl = $e0c3a1c5820c71a8$require$_interopRequireWildcard((parcelRequire("aGPj2")));

var $e0c3a1c5820c71a8$var$_cubehelix = $e0c3a1c5820c71a8$require$_interopRequireWildcard((parcelRequire("iTw4Z")));

var $e0c3a1c5820c71a8$var$_piecewise = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("4i7Bg")));

var $e0c3a1c5820c71a8$var$_quantize = $e0c3a1c5820c71a8$require$_interopRequireDefault((parcelRequire("lygUS")));

});
parcelRegister("8zxdz", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $63db5bf93ae8aac7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $63db5bf93ae8aac7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63db5bf93ae8aac7$var$_default;

var $jYntD = parcelRequire("jYntD");

var $63db5bf93ae8aac7$var$_rgb = $63db5bf93ae8aac7$require$_interopRequireDefault((parcelRequire("7Kioe")));

var $5K0GI = parcelRequire("5K0GI");

var $63db5bf93ae8aac7$var$_date = $63db5bf93ae8aac7$require$_interopRequireDefault((parcelRequire("1edxW")));

var $63db5bf93ae8aac7$var$_number = $63db5bf93ae8aac7$require$_interopRequireDefault((parcelRequire("c2SMs")));

var $63db5bf93ae8aac7$var$_object = $63db5bf93ae8aac7$require$_interopRequireDefault((parcelRequire("lgjis")));

var $63db5bf93ae8aac7$var$_string = $63db5bf93ae8aac7$require$_interopRequireDefault((parcelRequire("hlvuM")));

var $63db5bf93ae8aac7$var$_constant = $63db5bf93ae8aac7$require$_interopRequireDefault((parcelRequire("lMk0t")));

var $63db5bf93ae8aac7$var$_numberArray = $63db5bf93ae8aac7$require$_interopRequireWildcard((parcelRequire("3XMWQ")));
function $63db5bf93ae8aac7$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $63db5bf93ae8aac7$var$_constant.default)(b) : (t === "number" ? $63db5bf93ae8aac7$var$_number.default : t === "string" ? (c = (0, $jYntD.color)(b)) ? (b = c, $63db5bf93ae8aac7$var$_rgb.default) : $63db5bf93ae8aac7$var$_string.default : b instanceof $jYntD.color ? $63db5bf93ae8aac7$var$_rgb.default : b instanceof Date ? $63db5bf93ae8aac7$var$_date.default : (0, $63db5bf93ae8aac7$var$_numberArray.isNumberArray)(b) ? $63db5bf93ae8aac7$var$_numberArray.default : Array.isArray(b) ? $5K0GI.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $63db5bf93ae8aac7$var$_object.default : $63db5bf93ae8aac7$var$_number.default)(a, b);
}

});
parcelRegister("jYntD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e8a5d4f8b9ae3954$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e8a5d4f8b9ae3954$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $e8a5d4f8b9ae3954$var$_color.rgb;
    }
});

var $e8a5d4f8b9ae3954$var$_color = $e8a5d4f8b9ae3954$require$_interopRequireWildcard((parcelRequire("hwLk8")));

var $e8a5d4f8b9ae3954$var$_lab = $e8a5d4f8b9ae3954$require$_interopRequireWildcard((parcelRequire("c3olk")));

var $e8a5d4f8b9ae3954$var$_cubehelix = $e8a5d4f8b9ae3954$require$_interopRequireDefault((parcelRequire("fNQlJ")));

});
parcelRegister("hwLk8", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $cc2a225b7bc3f5ba$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = $cc2a225b7bc3f5ba$require$_interopRequireWildcard((parcelRequire("4ibCJ")));
function Color() {}
var darker = exports.darker = 0.7;
var brighter = exports.brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("4ibCJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3201dc15a27159f2$var$_default;
module.exports.extend = $3201dc15a27159f2$var$extend;
function $3201dc15a27159f2$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $3201dc15a27159f2$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("c3olk", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8c68a5d6bb78ec29$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $8c68a5d6bb78ec29$var$Hcl;
module.exports.Lab = $8c68a5d6bb78ec29$var$Lab;
module.exports.default = $8c68a5d6bb78ec29$var$lab;
module.exports.gray = $8c68a5d6bb78ec29$var$gray;
module.exports.hcl = $8c68a5d6bb78ec29$var$hcl;
module.exports.lch = $8c68a5d6bb78ec29$var$lch;

var $8c68a5d6bb78ec29$var$_define = $8c68a5d6bb78ec29$require$_interopRequireWildcard((parcelRequire("4ibCJ")));

var $hwLk8 = parcelRequire("hwLk8");

var $34Eed = parcelRequire("34Eed");
// https://observablehq.com/@mbostock/lab-and-rgb
const $8c68a5d6bb78ec29$var$K = 18, $8c68a5d6bb78ec29$var$Xn = 0.96422, $8c68a5d6bb78ec29$var$Yn = 1, $8c68a5d6bb78ec29$var$Zn = 0.82521, $8c68a5d6bb78ec29$var$t0 = 4 / 29, $8c68a5d6bb78ec29$var$t1 = 6 / 29, $8c68a5d6bb78ec29$var$t2 = 3 * $8c68a5d6bb78ec29$var$t1 * $8c68a5d6bb78ec29$var$t1, $8c68a5d6bb78ec29$var$t3 = $8c68a5d6bb78ec29$var$t1 * $8c68a5d6bb78ec29$var$t1 * $8c68a5d6bb78ec29$var$t1;
function $8c68a5d6bb78ec29$var$labConvert(o) {
    if (o instanceof $8c68a5d6bb78ec29$var$Lab) return new $8c68a5d6bb78ec29$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $8c68a5d6bb78ec29$var$Hcl) return $8c68a5d6bb78ec29$var$hcl2lab(o);
    if (!(o instanceof $hwLk8.Rgb)) o = (0, $hwLk8.rgbConvert)(o);
    var r = $8c68a5d6bb78ec29$var$rgb2lrgb(o.r), g = $8c68a5d6bb78ec29$var$rgb2lrgb(o.g), b = $8c68a5d6bb78ec29$var$rgb2lrgb(o.b), y = $8c68a5d6bb78ec29$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $8c68a5d6bb78ec29$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $8c68a5d6bb78ec29$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $8c68a5d6bb78ec29$var$Xn);
        z = $8c68a5d6bb78ec29$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $8c68a5d6bb78ec29$var$Zn);
    }
    return new $8c68a5d6bb78ec29$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $8c68a5d6bb78ec29$var$gray(l, opacity) {
    return new $8c68a5d6bb78ec29$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $8c68a5d6bb78ec29$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $8c68a5d6bb78ec29$var$labConvert(l) : new $8c68a5d6bb78ec29$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $8c68a5d6bb78ec29$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $8c68a5d6bb78ec29$var$_define.default)($8c68a5d6bb78ec29$var$Lab, $8c68a5d6bb78ec29$var$lab, (0, $8c68a5d6bb78ec29$var$_define.extend)($hwLk8.Color, {
    brighter (k) {
        return new $8c68a5d6bb78ec29$var$Lab(this.l + $8c68a5d6bb78ec29$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $8c68a5d6bb78ec29$var$Lab(this.l - $8c68a5d6bb78ec29$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $8c68a5d6bb78ec29$var$Xn * $8c68a5d6bb78ec29$var$lab2xyz(x);
        y = $8c68a5d6bb78ec29$var$Yn * $8c68a5d6bb78ec29$var$lab2xyz(y);
        z = $8c68a5d6bb78ec29$var$Zn * $8c68a5d6bb78ec29$var$lab2xyz(z);
        return new $hwLk8.Rgb($8c68a5d6bb78ec29$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $8c68a5d6bb78ec29$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $8c68a5d6bb78ec29$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $8c68a5d6bb78ec29$var$xyz2lab(t) {
    return t > $8c68a5d6bb78ec29$var$t3 ? Math.pow(t, 1 / 3) : t / $8c68a5d6bb78ec29$var$t2 + $8c68a5d6bb78ec29$var$t0;
}
function $8c68a5d6bb78ec29$var$lab2xyz(t) {
    return t > $8c68a5d6bb78ec29$var$t1 ? t * t * t : $8c68a5d6bb78ec29$var$t2 * (t - $8c68a5d6bb78ec29$var$t0);
}
function $8c68a5d6bb78ec29$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $8c68a5d6bb78ec29$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $8c68a5d6bb78ec29$var$hclConvert(o) {
    if (o instanceof $8c68a5d6bb78ec29$var$Hcl) return new $8c68a5d6bb78ec29$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $8c68a5d6bb78ec29$var$Lab)) o = $8c68a5d6bb78ec29$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $8c68a5d6bb78ec29$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $34Eed.degrees;
    return new $8c68a5d6bb78ec29$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $8c68a5d6bb78ec29$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $8c68a5d6bb78ec29$var$hclConvert(l) : new $8c68a5d6bb78ec29$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $8c68a5d6bb78ec29$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $8c68a5d6bb78ec29$var$hclConvert(h) : new $8c68a5d6bb78ec29$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $8c68a5d6bb78ec29$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $8c68a5d6bb78ec29$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $8c68a5d6bb78ec29$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $34Eed.radians;
    return new $8c68a5d6bb78ec29$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $8c68a5d6bb78ec29$var$_define.default)($8c68a5d6bb78ec29$var$Hcl, $8c68a5d6bb78ec29$var$hcl, (0, $8c68a5d6bb78ec29$var$_define.extend)($hwLk8.Color, {
    brighter (k) {
        return new $8c68a5d6bb78ec29$var$Hcl(this.h, this.c, this.l + $8c68a5d6bb78ec29$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $8c68a5d6bb78ec29$var$Hcl(this.h, this.c, this.l - $8c68a5d6bb78ec29$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $8c68a5d6bb78ec29$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("34Eed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $23d0f35453d18983$var$radians = module.exports.radians = Math.PI / 180;
const $23d0f35453d18983$var$degrees = module.exports.degrees = 180 / Math.PI;

});


parcelRegister("fNQlJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b8140a223131503d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $b8140a223131503d$var$Cubehelix;
module.exports.default = $b8140a223131503d$var$cubehelix;

var $b8140a223131503d$var$_define = $b8140a223131503d$require$_interopRequireWildcard((parcelRequire("4ibCJ")));

var $hwLk8 = parcelRequire("hwLk8");

var $34Eed = parcelRequire("34Eed");
var $b8140a223131503d$var$A = -0.14861, $b8140a223131503d$var$B = 1.78277, $b8140a223131503d$var$C = -0.29227, $b8140a223131503d$var$D = -0.90649, $b8140a223131503d$var$E = 1.97294, $b8140a223131503d$var$ED = $b8140a223131503d$var$E * $b8140a223131503d$var$D, $b8140a223131503d$var$EB = $b8140a223131503d$var$E * $b8140a223131503d$var$B, $b8140a223131503d$var$BC_DA = $b8140a223131503d$var$B * $b8140a223131503d$var$C - $b8140a223131503d$var$D * $b8140a223131503d$var$A;
function $b8140a223131503d$var$cubehelixConvert(o) {
    if (o instanceof $b8140a223131503d$var$Cubehelix) return new $b8140a223131503d$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $hwLk8.Rgb)) o = (0, $hwLk8.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($b8140a223131503d$var$BC_DA * b + $b8140a223131503d$var$ED * r - $b8140a223131503d$var$EB * g) / ($b8140a223131503d$var$BC_DA + $b8140a223131503d$var$ED - $b8140a223131503d$var$EB), bl = b - l, k = ($b8140a223131503d$var$E * (g - l) - $b8140a223131503d$var$C * bl) / $b8140a223131503d$var$D, s = Math.sqrt(k * k + bl * bl) / ($b8140a223131503d$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $34Eed.degrees - 120 : NaN;
    return new $b8140a223131503d$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $b8140a223131503d$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $b8140a223131503d$var$cubehelixConvert(h) : new $b8140a223131503d$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $b8140a223131503d$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $b8140a223131503d$var$_define.default)($b8140a223131503d$var$Cubehelix, $b8140a223131503d$var$cubehelix, (0, $b8140a223131503d$var$_define.extend)($hwLk8.Color, {
    brighter (k) {
        k = k == null ? $hwLk8.brighter : Math.pow($hwLk8.brighter, k);
        return new $b8140a223131503d$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $hwLk8.darker : Math.pow($hwLk8.darker, k);
        return new $b8140a223131503d$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $34Eed.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $hwLk8.Rgb(255 * (l + a * ($b8140a223131503d$var$A * cosh + $b8140a223131503d$var$B * sinh)), 255 * (l + a * ($b8140a223131503d$var$C * cosh + $b8140a223131503d$var$D * sinh)), 255 * (l + a * ($b8140a223131503d$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("7Kioe", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5a3b181869039444$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5a3b181869039444$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $jYntD = parcelRequire("jYntD");

var $5a3b181869039444$var$_basis = $5a3b181869039444$require$_interopRequireDefault((parcelRequire("hkCaB")));

var $5a3b181869039444$var$_basisClosed = $5a3b181869039444$require$_interopRequireDefault((parcelRequire("RIvCU")));

var $5a3b181869039444$var$_color = $5a3b181869039444$require$_interopRequireWildcard((parcelRequire("3UjAA")));
var $5a3b181869039444$var$_default = module.exports.default = function rgbGamma(y) {
    var color = (0, $5a3b181869039444$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $jYntD.rgb)(start)).r, (end = (0, $jYntD.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $5a3b181869039444$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $5a3b181869039444$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $jYntD.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $5a3b181869039444$var$rgbBasis = module.exports.rgbBasis = $5a3b181869039444$var$rgbSpline($5a3b181869039444$var$_basis.default);
var $5a3b181869039444$var$rgbBasisClosed = module.exports.rgbBasisClosed = $5a3b181869039444$var$rgbSpline($5a3b181869039444$var$_basisClosed.default);

});
parcelRegister("hkCaB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $c9e1e9b74dc5081a$var$basis;
module.exports.default = $c9e1e9b74dc5081a$var$_default;
function $c9e1e9b74dc5081a$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $c9e1e9b74dc5081a$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $c9e1e9b74dc5081a$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("RIvCU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a1779eed46be573$var$_default;

var $hkCaB = parcelRequire("hkCaB");
function $0a1779eed46be573$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $hkCaB.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("3UjAA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2d85cc0dc085d1be$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d85cc0dc085d1be$var$nogamma;
module.exports.gamma = $2d85cc0dc085d1be$var$gamma;
module.exports.hue = $2d85cc0dc085d1be$var$hue;

var $2d85cc0dc085d1be$var$_constant = $2d85cc0dc085d1be$require$_interopRequireDefault((parcelRequire("lMk0t")));
function $2d85cc0dc085d1be$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $2d85cc0dc085d1be$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $2d85cc0dc085d1be$var$hue(a, b) {
    var d = b - a;
    return d ? $2d85cc0dc085d1be$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $2d85cc0dc085d1be$var$_constant.default)(isNaN(a) ? b : a);
}
function $2d85cc0dc085d1be$var$gamma(y) {
    return (y = +y) === 1 ? $2d85cc0dc085d1be$var$nogamma : function(a, b) {
        return b - a ? $2d85cc0dc085d1be$var$exponential(a, b, y) : (0, $2d85cc0dc085d1be$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $2d85cc0dc085d1be$var$nogamma(a, b) {
    var d = b - a;
    return d ? $2d85cc0dc085d1be$var$linear(a, d) : (0, $2d85cc0dc085d1be$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("lMk0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fdad9998582e4d4a$var$_default = (x)=>()=>x;
module.exports.default = $fdad9998582e4d4a$var$_default;

});



parcelRegister("5K0GI", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $42e1c83b53356a87$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $42e1c83b53356a87$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $42e1c83b53356a87$var$_default;
module.exports.genericArray = $42e1c83b53356a87$var$genericArray;

var $42e1c83b53356a87$var$_value = $42e1c83b53356a87$require$_interopRequireDefault((parcelRequire("8zxdz")));

var $42e1c83b53356a87$var$_numberArray = $42e1c83b53356a87$require$_interopRequireWildcard((parcelRequire("3XMWQ")));
function $42e1c83b53356a87$var$_default(a, b) {
    return ((0, $42e1c83b53356a87$var$_numberArray.isNumberArray)(b) ? $42e1c83b53356a87$var$_numberArray.default : $42e1c83b53356a87$var$genericArray)(a, b);
}
function $42e1c83b53356a87$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $42e1c83b53356a87$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("3XMWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e2cd9d67d0c5ff4$var$_default;
module.exports.isNumberArray = $2e2cd9d67d0c5ff4$var$isNumberArray;
function $2e2cd9d67d0c5ff4$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $2e2cd9d67d0c5ff4$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("1edxW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e519b4516cb3963$var$_default;
function $0e519b4516cb3963$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("c2SMs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c502a3cb49cedc5$var$_default;
function $8c502a3cb49cedc5$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("lgjis", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f7aa0f7f07a87469$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7aa0f7f07a87469$var$_default;

var $f7aa0f7f07a87469$var$_value = $f7aa0f7f07a87469$require$_interopRequireDefault((parcelRequire("8zxdz")));
function $f7aa0f7f07a87469$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $f7aa0f7f07a87469$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("hlvuM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ca0cd42df83b5f6b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca0cd42df83b5f6b$var$_default;

var $ca0cd42df83b5f6b$var$_number = $ca0cd42df83b5f6b$require$_interopRequireDefault((parcelRequire("c2SMs")));
var $ca0cd42df83b5f6b$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $ca0cd42df83b5f6b$var$reB = new RegExp($ca0cd42df83b5f6b$var$reA.source, "g");
function $ca0cd42df83b5f6b$var$zero(b) {
    return function() {
        return b;
    };
}
function $ca0cd42df83b5f6b$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $ca0cd42df83b5f6b$var$_default(a, b) {
    var bi = $ca0cd42df83b5f6b$var$reA.lastIndex = $ca0cd42df83b5f6b$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $ca0cd42df83b5f6b$var$reA.exec(a)) && (bm = $ca0cd42df83b5f6b$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $ca0cd42df83b5f6b$var$_number.default)(am, bm)
            });
        }
        bi = $ca0cd42df83b5f6b$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $ca0cd42df83b5f6b$var$one(q[0].x) : $ca0cd42df83b5f6b$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("eNtbJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac5c48789f3fc3e4$var$_default;
function $ac5c48789f3fc3e4$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("3QFck", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2cd62f744cdc9152$var$_default;

var $3UjAA = parcelRequire("3UjAA");
function $2cd62f744cdc9152$var$_default(a, b) {
    var i = (0, $3UjAA.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("4fJtT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $318bd7c47e91504a$var$_default;
function $318bd7c47e91504a$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("c9Rgv", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8d9fa4adf3d22298$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $8d9fa4adf3d22298$var$_number = $8d9fa4adf3d22298$require$_interopRequireDefault((parcelRequire("c2SMs")));

var $L9d7U = parcelRequire("L9d7U");
function $8d9fa4adf3d22298$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $8d9fa4adf3d22298$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $8d9fa4adf3d22298$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $8d9fa4adf3d22298$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $8d9fa4adf3d22298$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $8d9fa4adf3d22298$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $8d9fa4adf3d22298$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $8d9fa4adf3d22298$var$interpolateTransformCss = module.exports.interpolateTransformCss = $8d9fa4adf3d22298$var$interpolateTransform($L9d7U.parseCss, "px, ", "px)", "deg)");
var $8d9fa4adf3d22298$var$interpolateTransformSvg = module.exports.interpolateTransformSvg = $8d9fa4adf3d22298$var$interpolateTransform($L9d7U.parseSvg, ", ", ")", ")");

});
parcelRegister("L9d7U", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $08db88f55091a885$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $08db88f55091a885$var$parseCss;
module.exports.parseSvg = $08db88f55091a885$var$parseSvg;

var $08db88f55091a885$var$_decompose = $08db88f55091a885$require$_interopRequireWildcard((parcelRequire("aE8wS")));
var $08db88f55091a885$var$svgNode;
/* eslint-disable no-undef */ function $08db88f55091a885$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $08db88f55091a885$var$_decompose.identity : (0, $08db88f55091a885$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $08db88f55091a885$var$parseSvg(value) {
    if (value == null) return $08db88f55091a885$var$_decompose.identity;
    if (!$08db88f55091a885$var$svgNode) $08db88f55091a885$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $08db88f55091a885$var$svgNode.setAttribute("transform", value);
    if (!(value = $08db88f55091a885$var$svgNode.transform.baseVal.consolidate())) return $08db88f55091a885$var$_decompose.identity;
    value = value.matrix;
    return (0, $08db88f55091a885$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("aE8wS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c044191e8d8fc6f$var$_default;
module.exports.identity = void 0;
var $7c044191e8d8fc6f$var$degrees = 180 / Math.PI;
var $7c044191e8d8fc6f$var$identity = module.exports.identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $7c044191e8d8fc6f$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $7c044191e8d8fc6f$var$degrees,
        skewX: Math.atan(skewX) * $7c044191e8d8fc6f$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("5BRpM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4159d783495e7e69$var$epsilon2 = 1e-12;
function $4159d783495e7e69$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $4159d783495e7e69$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $4159d783495e7e69$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $4159d783495e7e69$var$_default = module.exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $4159d783495e7e69$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $4159d783495e7e69$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $4159d783495e7e69$var$tanh(rho * s + r0) - $4159d783495e7e69$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $4159d783495e7e69$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("17oJt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d09a1397851ff84$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $jYntD = parcelRequire("jYntD");

var $0d09a1397851ff84$var$_color = $0d09a1397851ff84$require$_interopRequireWildcard((parcelRequire("3UjAA")));
function $0d09a1397851ff84$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $jYntD.hsl)(start)).h, (end = (0, $jYntD.hsl)(end)).h), s = (0, $0d09a1397851ff84$var$_color.default)(start.s, end.s), l = (0, $0d09a1397851ff84$var$_color.default)(start.l, end.l), opacity = (0, $0d09a1397851ff84$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0d09a1397851ff84$var$_default = module.exports.default = $0d09a1397851ff84$var$hsl($0d09a1397851ff84$var$_color.hue);
var $0d09a1397851ff84$var$hslLong = module.exports.hslLong = $0d09a1397851ff84$var$hsl($0d09a1397851ff84$var$_color.default);

});

parcelRegister("kfdjM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ebcf8a087d4dd7e5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebcf8a087d4dd7e5$var$lab;

var $jYntD = parcelRequire("jYntD");

var $ebcf8a087d4dd7e5$var$_color = $ebcf8a087d4dd7e5$require$_interopRequireDefault((parcelRequire("3UjAA")));
function $ebcf8a087d4dd7e5$var$lab(start, end) {
    var l = (0, $ebcf8a087d4dd7e5$var$_color.default)((start = (0, $jYntD.lab)(start)).l, (end = (0, $jYntD.lab)(end)).l), a = (0, $ebcf8a087d4dd7e5$var$_color.default)(start.a, end.a), b = (0, $ebcf8a087d4dd7e5$var$_color.default)(start.b, end.b), opacity = (0, $ebcf8a087d4dd7e5$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("aGPj2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7c859febdcb8b685$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $jYntD = parcelRequire("jYntD");

var $7c859febdcb8b685$var$_color = $7c859febdcb8b685$require$_interopRequireWildcard((parcelRequire("3UjAA")));
function $7c859febdcb8b685$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $jYntD.hcl)(start)).h, (end = (0, $jYntD.hcl)(end)).h), c = (0, $7c859febdcb8b685$var$_color.default)(start.c, end.c), l = (0, $7c859febdcb8b685$var$_color.default)(start.l, end.l), opacity = (0, $7c859febdcb8b685$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $7c859febdcb8b685$var$_default = module.exports.default = $7c859febdcb8b685$var$hcl($7c859febdcb8b685$var$_color.hue);
var $7c859febdcb8b685$var$hclLong = module.exports.hclLong = $7c859febdcb8b685$var$hcl($7c859febdcb8b685$var$_color.default);

});

parcelRegister("iTw4Z", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dc163f5fc5259497$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $jYntD = parcelRequire("jYntD");

var $dc163f5fc5259497$var$_color = $dc163f5fc5259497$require$_interopRequireWildcard((parcelRequire("3UjAA")));
function $dc163f5fc5259497$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $jYntD.cubehelix)(start)).h, (end = (0, $jYntD.cubehelix)(end)).h), s = (0, $dc163f5fc5259497$var$_color.default)(start.s, end.s), l = (0, $dc163f5fc5259497$var$_color.default)(start.l, end.l), opacity = (0, $dc163f5fc5259497$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $dc163f5fc5259497$var$_default = module.exports.default = $dc163f5fc5259497$var$cubehelix($dc163f5fc5259497$var$_color.hue);
var $dc163f5fc5259497$var$cubehelixLong = module.exports.cubehelixLong = $dc163f5fc5259497$var$cubehelix($dc163f5fc5259497$var$_color.default);

});

parcelRegister("4i7Bg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $31febd0f8b53b79b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31febd0f8b53b79b$var$piecewise;

var $31febd0f8b53b79b$var$_value = $31febd0f8b53b79b$require$_interopRequireDefault((parcelRequire("8zxdz")));
function $31febd0f8b53b79b$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $31febd0f8b53b79b$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("lygUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb09e53614c03e83$var$_default;
function $fb09e53614c03e83$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("5C2v7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $416270fb3ce809d2$var$constants;
function $416270fb3ce809d2$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9JYVc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $717792c399badf70$var$number;
function $717792c399badf70$var$number(x) {
    return +x;
}

});


parcelRegister("jvkAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e330e23f904f1137$var$tickFormat;

var $dDi6U = parcelRequire("dDi6U");

var $4z18R = parcelRequire("4z18R");
function $e330e23f904f1137$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $dDi6U.tickStep)(start, stop, count), precision;
    specifier = (0, $4z18R.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $4z18R.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $4z18R.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $4z18R.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $4z18R.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $4z18R.format)(specifier);
}

});
parcelRegister("4z18R", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $352b5111389752cd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $352b5111389752cd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $352b5111389752cd$var$_precisionRound.default;
    }
});

var $352b5111389752cd$var$_defaultLocale = $352b5111389752cd$require$_interopRequireWildcard((parcelRequire("96bCN")));

var $352b5111389752cd$var$_locale = $352b5111389752cd$require$_interopRequireDefault((parcelRequire("hWkKJ")));

var $352b5111389752cd$var$_formatSpecifier = $352b5111389752cd$require$_interopRequireWildcard((parcelRequire("6HBxL")));

var $352b5111389752cd$var$_precisionFixed = $352b5111389752cd$require$_interopRequireDefault((parcelRequire("lS5Uz")));

var $352b5111389752cd$var$_precisionPrefix = $352b5111389752cd$require$_interopRequireDefault((parcelRequire("6TREp")));

var $352b5111389752cd$var$_precisionRound = $352b5111389752cd$require$_interopRequireDefault((parcelRequire("8m1R0")));

});
parcelRegister("96bCN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $69fdb10704ca342f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $69fdb10704ca342f$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $69fdb10704ca342f$var$_locale = $69fdb10704ca342f$require$_interopRequireDefault((parcelRequire("hWkKJ")));
var $69fdb10704ca342f$var$locale;
var $69fdb10704ca342f$var$format;
var $69fdb10704ca342f$var$formatPrefix;
$69fdb10704ca342f$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $69fdb10704ca342f$var$defaultLocale(definition) {
    $69fdb10704ca342f$var$locale = (0, $69fdb10704ca342f$var$_locale.default)(definition);
    module.exports.format = $69fdb10704ca342f$var$format = $69fdb10704ca342f$var$locale.format;
    module.exports.formatPrefix = $69fdb10704ca342f$var$formatPrefix = $69fdb10704ca342f$var$locale.formatPrefix;
    return $69fdb10704ca342f$var$locale;
}

});
parcelRegister("hWkKJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d0f7f384d7761c9c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0f7f384d7761c9c$var$_default;

var $d0f7f384d7761c9c$var$_exponent = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("34Ujy")));

var $d0f7f384d7761c9c$var$_formatGroup = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("9UtHL")));

var $d0f7f384d7761c9c$var$_formatNumerals = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("33nIq")));

var $d0f7f384d7761c9c$var$_formatSpecifier = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("6HBxL")));

var $d0f7f384d7761c9c$var$_formatTrim = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("9xLkk")));

var $d0f7f384d7761c9c$var$_formatTypes = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("eYnw6")));

var $aUNSY = parcelRequire("aUNSY");

var $d0f7f384d7761c9c$var$_identity = $d0f7f384d7761c9c$require$_interopRequireDefault((parcelRequire("3BzCe")));
var $d0f7f384d7761c9c$var$map = Array.prototype.map, $d0f7f384d7761c9c$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $d0f7f384d7761c9c$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $d0f7f384d7761c9c$var$_identity.default : (0, $d0f7f384d7761c9c$var$_formatGroup.default)($d0f7f384d7761c9c$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $d0f7f384d7761c9c$var$_identity.default : (0, $d0f7f384d7761c9c$var$_formatNumerals.default)($d0f7f384d7761c9c$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d0f7f384d7761c9c$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!$d0f7f384d7761c9c$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $d0f7f384d7761c9c$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $d0f7f384d7761c9c$var$_formatTrim.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $d0f7f384d7761c9c$var$prefixes[8 + $aUNSY.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d0f7f384d7761c9c$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $d0f7f384d7761c9c$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $d0f7f384d7761c9c$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("34Ujy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23dd6dac2f205ebe$var$_default;

var $lK273 = parcelRequire("lK273");
function $23dd6dac2f205ebe$var$_default(x) {
    return x = (0, $lK273.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("lK273", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd3f88683c825fa7$var$_default;
module.exports.formatDecimalParts = $fd3f88683c825fa7$var$formatDecimalParts;
function $fd3f88683c825fa7$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $fd3f88683c825fa7$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("9UtHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $737062ce532e9653$var$_default;
function $737062ce532e9653$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("33nIq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23940c5610bbe80e$var$_default;
function $23940c5610bbe80e$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("6HBxL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $4e13e1940a9e770f$var$FormatSpecifier;
module.exports.default = $4e13e1940a9e770f$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $4e13e1940a9e770f$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $4e13e1940a9e770f$var$formatSpecifier(specifier) {
    if (!(match = $4e13e1940a9e770f$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $4e13e1940a9e770f$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$4e13e1940a9e770f$var$formatSpecifier.prototype = $4e13e1940a9e770f$var$FormatSpecifier.prototype; // instanceof
function $4e13e1940a9e770f$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$4e13e1940a9e770f$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("9xLkk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f2be83bc0acdac5$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $6f2be83bc0acdac5$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("eYnw6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ae68e93880d1827e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae68e93880d1827e$var$_formatDecimal = $ae68e93880d1827e$require$_interopRequireDefault((parcelRequire("lK273")));

var $ae68e93880d1827e$var$_formatPrefixAuto = $ae68e93880d1827e$require$_interopRequireDefault((parcelRequire("aUNSY")));

var $ae68e93880d1827e$var$_formatRounded = $ae68e93880d1827e$require$_interopRequireDefault((parcelRequire("kDD0E")));
var $ae68e93880d1827e$var$_default = module.exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $ae68e93880d1827e$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $ae68e93880d1827e$var$_formatRounded.default)(x * 100, p),
    "r": $ae68e93880d1827e$var$_formatRounded.default,
    "s": $ae68e93880d1827e$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("aUNSY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f25d49d30e73538$var$_default;
module.exports.prefixExponent = void 0;

var $lK273 = parcelRequire("lK273");
var $7f25d49d30e73538$var$prefixExponent;
function $7f25d49d30e73538$var$_default(x, p) {
    var d = (0, $lK273.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $7f25d49d30e73538$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $lK273.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("kDD0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f065b5a9e7738366$var$_default;

var $lK273 = parcelRequire("lK273");
function $f065b5a9e7738366$var$_default(x, p) {
    var d = (0, $lK273.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("3BzCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a007450b2493eed$var$_default;
function $2a007450b2493eed$var$_default(x) {
    return x;
}

});



parcelRegister("lS5Uz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fec33a0500d10ee8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fec33a0500d10ee8$var$_default;

var $fec33a0500d10ee8$var$_exponent = $fec33a0500d10ee8$require$_interopRequireDefault((parcelRequire("34Ujy")));
function $fec33a0500d10ee8$var$_default(step) {
    return Math.max(0, -(0, $fec33a0500d10ee8$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("6TREp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $50617f10c8931156$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50617f10c8931156$var$_default;

var $50617f10c8931156$var$_exponent = $50617f10c8931156$require$_interopRequireDefault((parcelRequire("34Ujy")));
function $50617f10c8931156$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $50617f10c8931156$var$_exponent.default)(value) / 3))) * 3 - (0, $50617f10c8931156$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("8m1R0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6151d0f71c1c55af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6151d0f71c1c55af$var$_default;

var $6151d0f71c1c55af$var$_exponent = $6151d0f71c1c55af$require$_interopRequireDefault((parcelRequire("34Ujy")));
function $6151d0f71c1c55af$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $6151d0f71c1c55af$var$_exponent.default)(max) - (0, $6151d0f71c1c55af$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("cIUw0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $94356edb192e70c4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94356edb192e70c4$var$log;
module.exports.loggish = $94356edb192e70c4$var$loggish;

var $dDi6U = parcelRequire("dDi6U");

var $4z18R = parcelRequire("4z18R");

var $94356edb192e70c4$var$_nice = $94356edb192e70c4$require$_interopRequireDefault((parcelRequire("4AlMI")));

var $izFby = parcelRequire("izFby");

var $5dOui = parcelRequire("5dOui");
function $94356edb192e70c4$var$transformLog(x) {
    return Math.log(x);
}
function $94356edb192e70c4$var$transformExp(x) {
    return Math.exp(x);
}
function $94356edb192e70c4$var$transformLogn(x) {
    return -Math.log(-x);
}
function $94356edb192e70c4$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $94356edb192e70c4$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $94356edb192e70c4$var$powp(base) {
    return base === 10 ? $94356edb192e70c4$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $94356edb192e70c4$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $94356edb192e70c4$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $94356edb192e70c4$var$loggish(transform) {
    const scale = transform($94356edb192e70c4$var$transformLog, $94356edb192e70c4$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $94356edb192e70c4$var$logp(base), pows = $94356edb192e70c4$var$powp(base);
        if (domain()[0] < 0) {
            logs = $94356edb192e70c4$var$reflect(logs), pows = $94356edb192e70c4$var$reflect(pows);
            transform($94356edb192e70c4$var$transformLogn, $94356edb192e70c4$var$transformExpn);
        } else transform($94356edb192e70c4$var$transformLog, $94356edb192e70c4$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $dDi6U.ticks)(u, v, n);
        } else z = (0, $dDi6U.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $4z18R.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $4z18R.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $94356edb192e70c4$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $94356edb192e70c4$var$log() {
    const scale = $94356edb192e70c4$var$loggish((0, $izFby.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $izFby.copy)(scale, $94356edb192e70c4$var$log()).base(scale.base());
    $5dOui.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("4AlMI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $356b6c32c2c14000$var$nice;
function $356b6c32c2c14000$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("3vuXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28dc4758a5d11ad2$var$symlog;
module.exports.symlogish = $28dc4758a5d11ad2$var$symlogish;

var $8HRiH = parcelRequire("8HRiH");

var $izFby = parcelRequire("izFby");

var $5dOui = parcelRequire("5dOui");
function $28dc4758a5d11ad2$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $28dc4758a5d11ad2$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $28dc4758a5d11ad2$var$symlogish(transform) {
    var c = 1, scale = transform($28dc4758a5d11ad2$var$transformSymlog(c), $28dc4758a5d11ad2$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($28dc4758a5d11ad2$var$transformSymlog(c = +_), $28dc4758a5d11ad2$var$transformSymexp(c)) : c;
    };
    return (0, $8HRiH.linearish)(scale);
}
function $28dc4758a5d11ad2$var$symlog() {
    var scale = $28dc4758a5d11ad2$var$symlogish((0, $izFby.transformer)());
    scale.copy = function() {
        return (0, $izFby.copy)(scale, $28dc4758a5d11ad2$var$symlog()).constant(scale.constant());
    };
    return $5dOui.initRange.apply(scale, arguments);
}

});

parcelRegister("hzaGs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc9dfe1d9f6e2c61$var$pow;
module.exports.powish = $cc9dfe1d9f6e2c61$var$powish;
module.exports.sqrt = $cc9dfe1d9f6e2c61$var$sqrt;

var $8HRiH = parcelRequire("8HRiH");

var $izFby = parcelRequire("izFby");

var $5dOui = parcelRequire("5dOui");
function $cc9dfe1d9f6e2c61$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $cc9dfe1d9f6e2c61$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $cc9dfe1d9f6e2c61$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $cc9dfe1d9f6e2c61$var$powish(transform) {
    var scale = transform($izFby.identity, $izFby.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($izFby.identity, $izFby.identity) : exponent === 0.5 ? transform($cc9dfe1d9f6e2c61$var$transformSqrt, $cc9dfe1d9f6e2c61$var$transformSquare) : transform($cc9dfe1d9f6e2c61$var$transformPow(exponent), $cc9dfe1d9f6e2c61$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $8HRiH.linearish)(scale);
}
function $cc9dfe1d9f6e2c61$var$pow() {
    var scale = $cc9dfe1d9f6e2c61$var$powish((0, $izFby.transformer)());
    scale.copy = function() {
        return (0, $izFby.copy)(scale, $cc9dfe1d9f6e2c61$var$pow()).exponent(scale.exponent());
    };
    $5dOui.initRange.apply(scale, arguments);
    return scale;
}
function $cc9dfe1d9f6e2c61$var$sqrt() {
    return $cc9dfe1d9f6e2c61$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("1UsRs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $164168a3ada4824b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $164168a3ada4824b$var$radial;

var $164168a3ada4824b$var$_continuous = $164168a3ada4824b$require$_interopRequireDefault((parcelRequire("izFby")));

var $5dOui = parcelRequire("5dOui");

var $8HRiH = parcelRequire("8HRiH");

var $164168a3ada4824b$var$_number = $164168a3ada4824b$require$_interopRequireDefault((parcelRequire("9JYVc")));
function $164168a3ada4824b$var$square(x) {
    return Math.sign(x) * x * x;
}
function $164168a3ada4824b$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $164168a3ada4824b$var$radial() {
    var squared = (0, $164168a3ada4824b$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $164168a3ada4824b$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($164168a3ada4824b$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $164168a3ada4824b$var$_number.default)).map($164168a3ada4824b$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $164168a3ada4824b$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $5dOui.initRange.apply(scale, arguments);
    return (0, $8HRiH.linearish)(scale);
}

});

parcelRegister("bJNHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $88ba7281cd026f97$var$quantile;

var $dDi6U = parcelRequire("dDi6U");

var $5dOui = parcelRequire("5dOui");
function $88ba7281cd026f97$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $dDi6U.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $dDi6U.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dDi6U.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $88ba7281cd026f97$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $5dOui.initRange.apply(scale, arguments);
}

});

parcelRegister("e6E3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a450b27ed67d9a91$var$quantize;

var $dDi6U = parcelRequire("dDi6U");

var $8HRiH = parcelRequire("8HRiH");

var $5dOui = parcelRequire("5dOui");
function $a450b27ed67d9a91$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dDi6U.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $a450b27ed67d9a91$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $5dOui.initRange.apply((0, $8HRiH.linearish)(scale), arguments);
}

});

parcelRegister("4gmja", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31a9f5fa872dadb2$var$threshold;

var $dDi6U = parcelRequire("dDi6U");

var $5dOui = parcelRequire("5dOui");
function $31a9f5fa872dadb2$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dDi6U.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $31a9f5fa872dadb2$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $5dOui.initRange.apply(scale, arguments);
}

});

parcelRegister("l62ZM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5bc7b55feb54376$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5bc7b55feb54376$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $f5bc7b55feb54376$var$calendar;
module.exports.default = $f5bc7b55feb54376$var$time;

var $1Zgpe = parcelRequire("1Zgpe");

var $iIkem = parcelRequire("iIkem");

var $f5bc7b55feb54376$var$_continuous = $f5bc7b55feb54376$require$_interopRequireWildcard((parcelRequire("izFby")));

var $5dOui = parcelRequire("5dOui");

var $f5bc7b55feb54376$var$_nice = $f5bc7b55feb54376$require$_interopRequireDefault((parcelRequire("4AlMI")));
function $f5bc7b55feb54376$var$date(t) {
    return new Date(t);
}
function $f5bc7b55feb54376$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $f5bc7b55feb54376$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f5bc7b55feb54376$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $f5bc7b55feb54376$var$number)) : domain().map($f5bc7b55feb54376$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $f5bc7b55feb54376$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f5bc7b55feb54376$var$_continuous.copy)(scale, $f5bc7b55feb54376$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $f5bc7b55feb54376$var$time() {
    return $5dOui.initRange.apply($f5bc7b55feb54376$var$calendar($1Zgpe.timeTicks, $1Zgpe.timeTickInterval, $1Zgpe.timeYear, $1Zgpe.timeMonth, $1Zgpe.timeWeek, $1Zgpe.timeDay, $1Zgpe.timeHour, $1Zgpe.timeMinute, $1Zgpe.timeSecond, $iIkem.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("1Zgpe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $6dcAl.timeDay;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $6dcAl.timeDays;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeFriday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeFridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $7rKkx.timeHour;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $7rKkx.timeHours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $4uFdm.timeInterval;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $3C7IF.millisecond;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $3C7IF.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $cyzuK.timeMinute;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $cyzuK.timeMinutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeMonday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeMondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $ltlFG.timeMonth;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $ltlFG.timeMonths;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeSaturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeSaturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $hAhVL.second;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $hAhVL.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeSunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeSundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeThursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeThursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $1l25D.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $1l25D.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeTuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeTuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeWednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeWednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeSunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $lUXuF.timeSundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $hv0th.timeYear;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $hv0th.timeYears;
    }
});
Object.defineProperty(module.exports, "unixDay", {
    enumerable: true,
    get: function() {
        return $6dcAl.unixDay;
    }
});
Object.defineProperty(module.exports, "unixDays", {
    enumerable: true,
    get: function() {
        return $6dcAl.unixDays;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $6dcAl.utcDay;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $6dcAl.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $7rKkx.utcHour;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $7rKkx.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $3C7IF.millisecond;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $3C7IF.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $cyzuK.utcMinute;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $cyzuK.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $ltlFG.utcMonth;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $ltlFG.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $hAhVL.second;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $hAhVL.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $1l25D.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $1l25D.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $lUXuF.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $hv0th.utcYear;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $hv0th.utcYears;
    }
});

var $4uFdm = parcelRequire("4uFdm");

var $3C7IF = parcelRequire("3C7IF");

var $hAhVL = parcelRequire("hAhVL");

var $cyzuK = parcelRequire("cyzuK");

var $7rKkx = parcelRequire("7rKkx");

var $6dcAl = parcelRequire("6dcAl");

var $lUXuF = parcelRequire("lUXuF");

var $ltlFG = parcelRequire("ltlFG");

var $hv0th = parcelRequire("hv0th");

var $1l25D = parcelRequire("1l25D");

});
parcelRegister("4uFdm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeInterval = $3459ef17d781a101$var$timeInterval;
const $3459ef17d781a101$var$t0 = new Date(), $3459ef17d781a101$var$t1 = new Date();
function $3459ef17d781a101$var$timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $3459ef17d781a101$var$timeInterval((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $3459ef17d781a101$var$t0.setTime(+start), $3459ef17d781a101$var$t1.setTime(+end);
            floori($3459ef17d781a101$var$t0), floori($3459ef17d781a101$var$t1);
            return Math.floor(count($3459ef17d781a101$var$t0, $3459ef17d781a101$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("3C7IF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.millisecond = void 0;

var $4uFdm = parcelRequire("4uFdm");
const $2a1ae8a4eee0bdaf$var$millisecond = module.exports.millisecond = (0, $4uFdm.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$2a1ae8a4eee0bdaf$var$millisecond.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $2a1ae8a4eee0bdaf$var$millisecond;
    return (0, $4uFdm.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $2a1ae8a4eee0bdaf$var$milliseconds = module.exports.milliseconds = $2a1ae8a4eee0bdaf$var$millisecond.range;

});

parcelRegister("hAhVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.second = void 0;

var $4uFdm = parcelRequire("4uFdm");

var $2FTQl = parcelRequire("2FTQl");
const $ccd3b5217858c2b4$var$second = module.exports.second = (0, $4uFdm.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * $2FTQl.durationSecond);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationSecond;
}, (date)=>{
    return date.getUTCSeconds();
});
const $ccd3b5217858c2b4$var$seconds = module.exports.seconds = $ccd3b5217858c2b4$var$second.range;

});
parcelRegister("2FTQl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $1f2aba67bef4bb6d$var$durationSecond = module.exports.durationSecond = 1000;
const $1f2aba67bef4bb6d$var$durationMinute = module.exports.durationMinute = $1f2aba67bef4bb6d$var$durationSecond * 60;
const $1f2aba67bef4bb6d$var$durationHour = module.exports.durationHour = $1f2aba67bef4bb6d$var$durationMinute * 60;
const $1f2aba67bef4bb6d$var$durationDay = module.exports.durationDay = $1f2aba67bef4bb6d$var$durationHour * 24;
const $1f2aba67bef4bb6d$var$durationWeek = module.exports.durationWeek = $1f2aba67bef4bb6d$var$durationDay * 7;
const $1f2aba67bef4bb6d$var$durationMonth = module.exports.durationMonth = $1f2aba67bef4bb6d$var$durationDay * 30;
const $1f2aba67bef4bb6d$var$durationYear = module.exports.durationYear = $1f2aba67bef4bb6d$var$durationDay * 365;

});


parcelRegister("cyzuK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.utcMinute = module.exports.timeMinutes = module.exports.timeMinute = void 0;

var $4uFdm = parcelRequire("4uFdm");

var $2FTQl = parcelRequire("2FTQl");
const $92443196d5f349c3$var$timeMinute = module.exports.timeMinute = (0, $4uFdm.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $2FTQl.durationSecond);
}, (date, step)=>{
    date.setTime(+date + step * $2FTQl.durationMinute);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationMinute;
}, (date)=>{
    return date.getMinutes();
});
const $92443196d5f349c3$var$timeMinutes = module.exports.timeMinutes = $92443196d5f349c3$var$timeMinute.range;
const $92443196d5f349c3$var$utcMinute = module.exports.utcMinute = (0, $4uFdm.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * $2FTQl.durationMinute);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationMinute;
}, (date)=>{
    return date.getUTCMinutes();
});
const $92443196d5f349c3$var$utcMinutes = module.exports.utcMinutes = $92443196d5f349c3$var$utcMinute.range;

});

parcelRegister("7rKkx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.utcHour = module.exports.timeHours = module.exports.timeHour = void 0;

var $4uFdm = parcelRequire("4uFdm");

var $2FTQl = parcelRequire("2FTQl");
const $56befe41de8214f6$var$timeHour = module.exports.timeHour = (0, $4uFdm.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $2FTQl.durationSecond - date.getMinutes() * $2FTQl.durationMinute);
}, (date, step)=>{
    date.setTime(+date + step * $2FTQl.durationHour);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationHour;
}, (date)=>{
    return date.getHours();
});
const $56befe41de8214f6$var$timeHours = module.exports.timeHours = $56befe41de8214f6$var$timeHour.range;
const $56befe41de8214f6$var$utcHour = module.exports.utcHour = (0, $4uFdm.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * $2FTQl.durationHour);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationHour;
}, (date)=>{
    return date.getUTCHours();
});
const $56befe41de8214f6$var$utcHours = module.exports.utcHours = $56befe41de8214f6$var$utcHour.range;

});

parcelRegister("6dcAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.utcDay = module.exports.unixDays = module.exports.unixDay = module.exports.timeDays = module.exports.timeDay = void 0;

var $4uFdm = parcelRequire("4uFdm");

var $2FTQl = parcelRequire("2FTQl");
const $485db81e3b5be747$var$timeDay = module.exports.timeDay = (0, $4uFdm.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $2FTQl.durationMinute) / $2FTQl.durationDay, (date)=>date.getDate() - 1);
const $485db81e3b5be747$var$timeDays = module.exports.timeDays = $485db81e3b5be747$var$timeDay.range;
const $485db81e3b5be747$var$utcDay = module.exports.utcDay = (0, $4uFdm.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationDay;
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $485db81e3b5be747$var$utcDays = module.exports.utcDays = $485db81e3b5be747$var$utcDay.range;
const $485db81e3b5be747$var$unixDay = module.exports.unixDay = (0, $4uFdm.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / $2FTQl.durationDay;
}, (date)=>{
    return Math.floor(date / $2FTQl.durationDay);
});
const $485db81e3b5be747$var$unixDays = module.exports.unixDays = $485db81e3b5be747$var$unixDay.range;

});

parcelRegister("lUXuF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = module.exports.timeWednesdays = module.exports.timeWednesday = module.exports.timeTuesdays = module.exports.timeTuesday = module.exports.timeThursdays = module.exports.timeThursday = module.exports.timeSundays = module.exports.timeSunday = module.exports.timeSaturdays = module.exports.timeSaturday = module.exports.timeMondays = module.exports.timeMonday = module.exports.timeFridays = module.exports.timeFriday = void 0;

var $4uFdm = parcelRequire("4uFdm");

var $2FTQl = parcelRequire("2FTQl");
function $ff4cfa2352189490$var$timeWeekday(i) {
    return (0, $4uFdm.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $2FTQl.durationMinute) / $2FTQl.durationWeek;
    });
}
const $ff4cfa2352189490$var$timeSunday = module.exports.timeSunday = $ff4cfa2352189490$var$timeWeekday(0);
const $ff4cfa2352189490$var$timeMonday = module.exports.timeMonday = $ff4cfa2352189490$var$timeWeekday(1);
const $ff4cfa2352189490$var$timeTuesday = module.exports.timeTuesday = $ff4cfa2352189490$var$timeWeekday(2);
const $ff4cfa2352189490$var$timeWednesday = module.exports.timeWednesday = $ff4cfa2352189490$var$timeWeekday(3);
const $ff4cfa2352189490$var$timeThursday = module.exports.timeThursday = $ff4cfa2352189490$var$timeWeekday(4);
const $ff4cfa2352189490$var$timeFriday = module.exports.timeFriday = $ff4cfa2352189490$var$timeWeekday(5);
const $ff4cfa2352189490$var$timeSaturday = module.exports.timeSaturday = $ff4cfa2352189490$var$timeWeekday(6);
const $ff4cfa2352189490$var$timeSundays = module.exports.timeSundays = $ff4cfa2352189490$var$timeSunday.range;
const $ff4cfa2352189490$var$timeMondays = module.exports.timeMondays = $ff4cfa2352189490$var$timeMonday.range;
const $ff4cfa2352189490$var$timeTuesdays = module.exports.timeTuesdays = $ff4cfa2352189490$var$timeTuesday.range;
const $ff4cfa2352189490$var$timeWednesdays = module.exports.timeWednesdays = $ff4cfa2352189490$var$timeWednesday.range;
const $ff4cfa2352189490$var$timeThursdays = module.exports.timeThursdays = $ff4cfa2352189490$var$timeThursday.range;
const $ff4cfa2352189490$var$timeFridays = module.exports.timeFridays = $ff4cfa2352189490$var$timeFriday.range;
const $ff4cfa2352189490$var$timeSaturdays = module.exports.timeSaturdays = $ff4cfa2352189490$var$timeSaturday.range;
function $ff4cfa2352189490$var$utcWeekday(i) {
    return (0, $4uFdm.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / $2FTQl.durationWeek;
    });
}
const $ff4cfa2352189490$var$utcSunday = module.exports.utcSunday = $ff4cfa2352189490$var$utcWeekday(0);
const $ff4cfa2352189490$var$utcMonday = module.exports.utcMonday = $ff4cfa2352189490$var$utcWeekday(1);
const $ff4cfa2352189490$var$utcTuesday = module.exports.utcTuesday = $ff4cfa2352189490$var$utcWeekday(2);
const $ff4cfa2352189490$var$utcWednesday = module.exports.utcWednesday = $ff4cfa2352189490$var$utcWeekday(3);
const $ff4cfa2352189490$var$utcThursday = module.exports.utcThursday = $ff4cfa2352189490$var$utcWeekday(4);
const $ff4cfa2352189490$var$utcFriday = module.exports.utcFriday = $ff4cfa2352189490$var$utcWeekday(5);
const $ff4cfa2352189490$var$utcSaturday = module.exports.utcSaturday = $ff4cfa2352189490$var$utcWeekday(6);
const $ff4cfa2352189490$var$utcSundays = module.exports.utcSundays = $ff4cfa2352189490$var$utcSunday.range;
const $ff4cfa2352189490$var$utcMondays = module.exports.utcMondays = $ff4cfa2352189490$var$utcMonday.range;
const $ff4cfa2352189490$var$utcTuesdays = module.exports.utcTuesdays = $ff4cfa2352189490$var$utcTuesday.range;
const $ff4cfa2352189490$var$utcWednesdays = module.exports.utcWednesdays = $ff4cfa2352189490$var$utcWednesday.range;
const $ff4cfa2352189490$var$utcThursdays = module.exports.utcThursdays = $ff4cfa2352189490$var$utcThursday.range;
const $ff4cfa2352189490$var$utcFridays = module.exports.utcFridays = $ff4cfa2352189490$var$utcFriday.range;
const $ff4cfa2352189490$var$utcSaturdays = module.exports.utcSaturdays = $ff4cfa2352189490$var$utcSaturday.range;

});

parcelRegister("ltlFG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.utcMonth = module.exports.timeMonths = module.exports.timeMonth = void 0;

var $4uFdm = parcelRequire("4uFdm");
const $fa1d1ddd0d8bab13$var$timeMonth = module.exports.timeMonth = (0, $4uFdm.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $fa1d1ddd0d8bab13$var$timeMonths = module.exports.timeMonths = $fa1d1ddd0d8bab13$var$timeMonth.range;
const $fa1d1ddd0d8bab13$var$utcMonth = module.exports.utcMonth = (0, $4uFdm.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $fa1d1ddd0d8bab13$var$utcMonths = module.exports.utcMonths = $fa1d1ddd0d8bab13$var$utcMonth.range;

});

parcelRegister("hv0th", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.utcYear = module.exports.timeYears = module.exports.timeYear = void 0;

var $4uFdm = parcelRequire("4uFdm");
const $cbd5b285ecea7c05$var$timeYear = module.exports.timeYear = (0, $4uFdm.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$cbd5b285ecea7c05$var$timeYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4uFdm.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $cbd5b285ecea7c05$var$timeYears = module.exports.timeYears = $cbd5b285ecea7c05$var$timeYear.range;
const $cbd5b285ecea7c05$var$utcYear = module.exports.utcYear = (0, $4uFdm.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$cbd5b285ecea7c05$var$utcYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $4uFdm.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $cbd5b285ecea7c05$var$utcYears = module.exports.utcYears = $cbd5b285ecea7c05$var$utcYear.range;

});

parcelRegister("1l25D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $dDi6U = parcelRequire("dDi6U");

var $2FTQl = parcelRequire("2FTQl");

var $3C7IF = parcelRequire("3C7IF");

var $hAhVL = parcelRequire("hAhVL");

var $cyzuK = parcelRequire("cyzuK");

var $7rKkx = parcelRequire("7rKkx");

var $6dcAl = parcelRequire("6dcAl");

var $lUXuF = parcelRequire("lUXuF");

var $ltlFG = parcelRequire("ltlFG");

var $hv0th = parcelRequire("hv0th");
function $0f995f9eaef37600$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $hAhVL.second,
            1,
            $2FTQl.durationSecond
        ],
        [
            $hAhVL.second,
            5,
            5 * $2FTQl.durationSecond
        ],
        [
            $hAhVL.second,
            15,
            15 * $2FTQl.durationSecond
        ],
        [
            $hAhVL.second,
            30,
            30 * $2FTQl.durationSecond
        ],
        [
            minute,
            1,
            $2FTQl.durationMinute
        ],
        [
            minute,
            5,
            5 * $2FTQl.durationMinute
        ],
        [
            minute,
            15,
            15 * $2FTQl.durationMinute
        ],
        [
            minute,
            30,
            30 * $2FTQl.durationMinute
        ],
        [
            hour,
            1,
            $2FTQl.durationHour
        ],
        [
            hour,
            3,
            3 * $2FTQl.durationHour
        ],
        [
            hour,
            6,
            6 * $2FTQl.durationHour
        ],
        [
            hour,
            12,
            12 * $2FTQl.durationHour
        ],
        [
            day,
            1,
            $2FTQl.durationDay
        ],
        [
            day,
            2,
            2 * $2FTQl.durationDay
        ],
        [
            week,
            1,
            $2FTQl.durationWeek
        ],
        [
            month,
            1,
            $2FTQl.durationMonth
        ],
        [
            month,
            3,
            3 * $2FTQl.durationMonth
        ],
        [
            year,
            1,
            $2FTQl.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $dDi6U.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $dDi6U.tickStep)(start / $2FTQl.durationYear, stop / $2FTQl.durationYear, count));
        if (i === 0) return $3C7IF.millisecond.every(Math.max((0, $dDi6U.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$0f995f9eaef37600$var$utcTicks, $0f995f9eaef37600$var$utcTickInterval] = $0f995f9eaef37600$var$ticker($hv0th.utcYear, $ltlFG.utcMonth, $lUXuF.utcSunday, $6dcAl.unixDay, $7rKkx.utcHour, $cyzuK.utcMinute);
module.exports.utcTickInterval = $0f995f9eaef37600$var$utcTickInterval;
module.exports.utcTicks = $0f995f9eaef37600$var$utcTicks;
const [$0f995f9eaef37600$var$timeTicks, $0f995f9eaef37600$var$timeTickInterval] = $0f995f9eaef37600$var$ticker($hv0th.timeYear, $ltlFG.timeMonth, $lUXuF.timeSunday, $6dcAl.timeDay, $7rKkx.timeHour, $cyzuK.timeMinute);
module.exports.timeTickInterval = $0f995f9eaef37600$var$timeTickInterval;
module.exports.timeTicks = $0f995f9eaef37600$var$timeTicks;

});


parcelRegister("iIkem", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d9fc077147834241$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9fc077147834241$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $d9fc077147834241$var$_defaultLocale.utcParse;
    }
});

var $d9fc077147834241$var$_defaultLocale = $d9fc077147834241$require$_interopRequireWildcard((parcelRequire("2aiuo")));

var $d9fc077147834241$var$_locale = $d9fc077147834241$require$_interopRequireDefault((parcelRequire("djG6M")));

var $d9fc077147834241$var$_isoFormat = $d9fc077147834241$require$_interopRequireDefault((parcelRequire("5hjlc")));

var $d9fc077147834241$var$_isoParse = $d9fc077147834241$require$_interopRequireDefault((parcelRequire("b7N9x")));

});
parcelRegister("2aiuo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $193adb8577999a07$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $193adb8577999a07$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $193adb8577999a07$var$_locale = $193adb8577999a07$require$_interopRequireDefault((parcelRequire("djG6M")));
var $193adb8577999a07$var$locale;
var $193adb8577999a07$var$timeFormat;
var $193adb8577999a07$var$timeParse;
var $193adb8577999a07$var$utcFormat;
var $193adb8577999a07$var$utcParse;
$193adb8577999a07$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $193adb8577999a07$var$defaultLocale(definition) {
    $193adb8577999a07$var$locale = (0, $193adb8577999a07$var$_locale.default)(definition);
    module.exports.timeFormat = $193adb8577999a07$var$timeFormat = $193adb8577999a07$var$locale.format;
    module.exports.timeParse = $193adb8577999a07$var$timeParse = $193adb8577999a07$var$locale.parse;
    module.exports.utcFormat = $193adb8577999a07$var$utcFormat = $193adb8577999a07$var$locale.utcFormat;
    module.exports.utcParse = $193adb8577999a07$var$utcParse = $193adb8577999a07$var$locale.utcParse;
    return $193adb8577999a07$var$locale;
}

});
parcelRegister("djG6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b1db68e8b46b007$var$formatLocale;

var $1Zgpe = parcelRequire("1Zgpe");
function $9b1db68e8b46b007$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $9b1db68e8b46b007$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $9b1db68e8b46b007$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $9b1db68e8b46b007$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $9b1db68e8b46b007$var$formatRe(locale_periods), periodLookup = $9b1db68e8b46b007$var$formatLookup(locale_periods), weekdayRe = $9b1db68e8b46b007$var$formatRe(locale_weekdays), weekdayLookup = $9b1db68e8b46b007$var$formatLookup(locale_weekdays), shortWeekdayRe = $9b1db68e8b46b007$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $9b1db68e8b46b007$var$formatLookup(locale_shortWeekdays), monthRe = $9b1db68e8b46b007$var$formatRe(locale_months), monthLookup = $9b1db68e8b46b007$var$formatLookup(locale_months), shortMonthRe = $9b1db68e8b46b007$var$formatRe(locale_shortMonths), shortMonthLookup = $9b1db68e8b46b007$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $9b1db68e8b46b007$var$formatDayOfMonth,
        "e": $9b1db68e8b46b007$var$formatDayOfMonth,
        "f": $9b1db68e8b46b007$var$formatMicroseconds,
        "g": $9b1db68e8b46b007$var$formatYearISO,
        "G": $9b1db68e8b46b007$var$formatFullYearISO,
        "H": $9b1db68e8b46b007$var$formatHour24,
        "I": $9b1db68e8b46b007$var$formatHour12,
        "j": $9b1db68e8b46b007$var$formatDayOfYear,
        "L": $9b1db68e8b46b007$var$formatMilliseconds,
        "m": $9b1db68e8b46b007$var$formatMonthNumber,
        "M": $9b1db68e8b46b007$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $9b1db68e8b46b007$var$formatUnixTimestamp,
        "s": $9b1db68e8b46b007$var$formatUnixTimestampSeconds,
        "S": $9b1db68e8b46b007$var$formatSeconds,
        "u": $9b1db68e8b46b007$var$formatWeekdayNumberMonday,
        "U": $9b1db68e8b46b007$var$formatWeekNumberSunday,
        "V": $9b1db68e8b46b007$var$formatWeekNumberISO,
        "w": $9b1db68e8b46b007$var$formatWeekdayNumberSunday,
        "W": $9b1db68e8b46b007$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $9b1db68e8b46b007$var$formatYear,
        "Y": $9b1db68e8b46b007$var$formatFullYear,
        "Z": $9b1db68e8b46b007$var$formatZone,
        "%": $9b1db68e8b46b007$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $9b1db68e8b46b007$var$formatUTCDayOfMonth,
        "e": $9b1db68e8b46b007$var$formatUTCDayOfMonth,
        "f": $9b1db68e8b46b007$var$formatUTCMicroseconds,
        "g": $9b1db68e8b46b007$var$formatUTCYearISO,
        "G": $9b1db68e8b46b007$var$formatUTCFullYearISO,
        "H": $9b1db68e8b46b007$var$formatUTCHour24,
        "I": $9b1db68e8b46b007$var$formatUTCHour12,
        "j": $9b1db68e8b46b007$var$formatUTCDayOfYear,
        "L": $9b1db68e8b46b007$var$formatUTCMilliseconds,
        "m": $9b1db68e8b46b007$var$formatUTCMonthNumber,
        "M": $9b1db68e8b46b007$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $9b1db68e8b46b007$var$formatUnixTimestamp,
        "s": $9b1db68e8b46b007$var$formatUnixTimestampSeconds,
        "S": $9b1db68e8b46b007$var$formatUTCSeconds,
        "u": $9b1db68e8b46b007$var$formatUTCWeekdayNumberMonday,
        "U": $9b1db68e8b46b007$var$formatUTCWeekNumberSunday,
        "V": $9b1db68e8b46b007$var$formatUTCWeekNumberISO,
        "w": $9b1db68e8b46b007$var$formatUTCWeekdayNumberSunday,
        "W": $9b1db68e8b46b007$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $9b1db68e8b46b007$var$formatUTCYear,
        "Y": $9b1db68e8b46b007$var$formatUTCFullYear,
        "Z": $9b1db68e8b46b007$var$formatUTCZone,
        "%": $9b1db68e8b46b007$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $9b1db68e8b46b007$var$parseDayOfMonth,
        "e": $9b1db68e8b46b007$var$parseDayOfMonth,
        "f": $9b1db68e8b46b007$var$parseMicroseconds,
        "g": $9b1db68e8b46b007$var$parseYear,
        "G": $9b1db68e8b46b007$var$parseFullYear,
        "H": $9b1db68e8b46b007$var$parseHour24,
        "I": $9b1db68e8b46b007$var$parseHour24,
        "j": $9b1db68e8b46b007$var$parseDayOfYear,
        "L": $9b1db68e8b46b007$var$parseMilliseconds,
        "m": $9b1db68e8b46b007$var$parseMonthNumber,
        "M": $9b1db68e8b46b007$var$parseMinutes,
        "p": parsePeriod,
        "q": $9b1db68e8b46b007$var$parseQuarter,
        "Q": $9b1db68e8b46b007$var$parseUnixTimestamp,
        "s": $9b1db68e8b46b007$var$parseUnixTimestampSeconds,
        "S": $9b1db68e8b46b007$var$parseSeconds,
        "u": $9b1db68e8b46b007$var$parseWeekdayNumberMonday,
        "U": $9b1db68e8b46b007$var$parseWeekNumberSunday,
        "V": $9b1db68e8b46b007$var$parseWeekNumberISO,
        "w": $9b1db68e8b46b007$var$parseWeekdayNumberSunday,
        "W": $9b1db68e8b46b007$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $9b1db68e8b46b007$var$parseYear,
        "Y": $9b1db68e8b46b007$var$parseFullYear,
        "Z": $9b1db68e8b46b007$var$parseZone,
        "%": $9b1db68e8b46b007$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $9b1db68e8b46b007$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $9b1db68e8b46b007$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $9b1db68e8b46b007$var$utcDate($9b1db68e8b46b007$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $1Zgpe.utcMonday.ceil(week) : (0, $1Zgpe.utcMonday)(week);
                    week = $1Zgpe.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $9b1db68e8b46b007$var$localDate($9b1db68e8b46b007$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $1Zgpe.timeMonday.ceil(week) : (0, $1Zgpe.timeMonday)(week);
                    week = $1Zgpe.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $9b1db68e8b46b007$var$utcDate($9b1db68e8b46b007$var$newDate(d.y, 0, 1)).getUTCDay() : $9b1db68e8b46b007$var$localDate($9b1db68e8b46b007$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $9b1db68e8b46b007$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $9b1db68e8b46b007$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $9b1db68e8b46b007$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $9b1db68e8b46b007$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $9b1db68e8b46b007$var$numberRe = /^\s*\d+/, // note: ignores next directive
$9b1db68e8b46b007$var$percentRe = /^%/, $9b1db68e8b46b007$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $9b1db68e8b46b007$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $9b1db68e8b46b007$var$requote(s) {
    return s.replace($9b1db68e8b46b007$var$requoteRe, "\\$&");
}
function $9b1db68e8b46b007$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($9b1db68e8b46b007$var$requote).join("|") + ")", "i");
}
function $9b1db68e8b46b007$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $9b1db68e8b46b007$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseWeekNumberSunday(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseWeekNumberISO(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseWeekNumberMonday(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseFullYear(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseYear(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseQuarter(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseMonthNumber(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseDayOfMonth(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseDayOfYear(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseHour24(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseMinutes(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseSeconds(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseMilliseconds(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseMicroseconds(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseLiteralPercent(d, string, i) {
    var n = $9b1db68e8b46b007$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $9b1db68e8b46b007$var$parseUnixTimestamp(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $9b1db68e8b46b007$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $9b1db68e8b46b007$var$formatDayOfMonth(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getDate(), p, 2);
}
function $9b1db68e8b46b007$var$formatHour24(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getHours(), p, 2);
}
function $9b1db68e8b46b007$var$formatHour12(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $9b1db68e8b46b007$var$formatDayOfYear(d, p) {
    return $9b1db68e8b46b007$var$pad(1 + $1Zgpe.timeDay.count((0, $1Zgpe.timeYear)(d), d), p, 3);
}
function $9b1db68e8b46b007$var$formatMilliseconds(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getMilliseconds(), p, 3);
}
function $9b1db68e8b46b007$var$formatMicroseconds(d, p) {
    return $9b1db68e8b46b007$var$formatMilliseconds(d, p) + "000";
}
function $9b1db68e8b46b007$var$formatMonthNumber(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getMonth() + 1, p, 2);
}
function $9b1db68e8b46b007$var$formatMinutes(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getMinutes(), p, 2);
}
function $9b1db68e8b46b007$var$formatSeconds(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getSeconds(), p, 2);
}
function $9b1db68e8b46b007$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $9b1db68e8b46b007$var$formatWeekNumberSunday(d, p) {
    return $9b1db68e8b46b007$var$pad($1Zgpe.timeSunday.count((0, $1Zgpe.timeYear)(d) - 1, d), p, 2);
}
function $9b1db68e8b46b007$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $1Zgpe.timeThursday)(d) : $1Zgpe.timeThursday.ceil(d);
}
function $9b1db68e8b46b007$var$formatWeekNumberISO(d, p) {
    d = $9b1db68e8b46b007$var$dISO(d);
    return $9b1db68e8b46b007$var$pad($1Zgpe.timeThursday.count((0, $1Zgpe.timeYear)(d), d) + ((0, $1Zgpe.timeYear)(d).getDay() === 4), p, 2);
}
function $9b1db68e8b46b007$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $9b1db68e8b46b007$var$formatWeekNumberMonday(d, p) {
    return $9b1db68e8b46b007$var$pad($1Zgpe.timeMonday.count((0, $1Zgpe.timeYear)(d) - 1, d), p, 2);
}
function $9b1db68e8b46b007$var$formatYear(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getFullYear() % 100, p, 2);
}
function $9b1db68e8b46b007$var$formatYearISO(d, p) {
    d = $9b1db68e8b46b007$var$dISO(d);
    return $9b1db68e8b46b007$var$pad(d.getFullYear() % 100, p, 2);
}
function $9b1db68e8b46b007$var$formatFullYear(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getFullYear() % 10000, p, 4);
}
function $9b1db68e8b46b007$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $1Zgpe.timeThursday)(d) : $1Zgpe.timeThursday.ceil(d);
    return $9b1db68e8b46b007$var$pad(d.getFullYear() % 10000, p, 4);
}
function $9b1db68e8b46b007$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $9b1db68e8b46b007$var$pad(z / 60 | 0, "0", 2) + $9b1db68e8b46b007$var$pad(z % 60, "0", 2);
}
function $9b1db68e8b46b007$var$formatUTCDayOfMonth(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCDate(), p, 2);
}
function $9b1db68e8b46b007$var$formatUTCHour24(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCHours(), p, 2);
}
function $9b1db68e8b46b007$var$formatUTCHour12(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $9b1db68e8b46b007$var$formatUTCDayOfYear(d, p) {
    return $9b1db68e8b46b007$var$pad(1 + $1Zgpe.utcDay.count((0, $1Zgpe.utcYear)(d), d), p, 3);
}
function $9b1db68e8b46b007$var$formatUTCMilliseconds(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $9b1db68e8b46b007$var$formatUTCMicroseconds(d, p) {
    return $9b1db68e8b46b007$var$formatUTCMilliseconds(d, p) + "000";
}
function $9b1db68e8b46b007$var$formatUTCMonthNumber(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $9b1db68e8b46b007$var$formatUTCMinutes(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCMinutes(), p, 2);
}
function $9b1db68e8b46b007$var$formatUTCSeconds(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCSeconds(), p, 2);
}
function $9b1db68e8b46b007$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $9b1db68e8b46b007$var$formatUTCWeekNumberSunday(d, p) {
    return $9b1db68e8b46b007$var$pad($1Zgpe.utcSunday.count((0, $1Zgpe.utcYear)(d) - 1, d), p, 2);
}
function $9b1db68e8b46b007$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $1Zgpe.utcThursday)(d) : $1Zgpe.utcThursday.ceil(d);
}
function $9b1db68e8b46b007$var$formatUTCWeekNumberISO(d, p) {
    d = $9b1db68e8b46b007$var$UTCdISO(d);
    return $9b1db68e8b46b007$var$pad($1Zgpe.utcThursday.count((0, $1Zgpe.utcYear)(d), d) + ((0, $1Zgpe.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $9b1db68e8b46b007$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $9b1db68e8b46b007$var$formatUTCWeekNumberMonday(d, p) {
    return $9b1db68e8b46b007$var$pad($1Zgpe.utcMonday.count((0, $1Zgpe.utcYear)(d) - 1, d), p, 2);
}
function $9b1db68e8b46b007$var$formatUTCYear(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $9b1db68e8b46b007$var$formatUTCYearISO(d, p) {
    d = $9b1db68e8b46b007$var$UTCdISO(d);
    return $9b1db68e8b46b007$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $9b1db68e8b46b007$var$formatUTCFullYear(d, p) {
    return $9b1db68e8b46b007$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $9b1db68e8b46b007$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $1Zgpe.utcThursday)(d) : $1Zgpe.utcThursday.ceil(d);
    return $9b1db68e8b46b007$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $9b1db68e8b46b007$var$formatUTCZone() {
    return "+0000";
}
function $9b1db68e8b46b007$var$formatLiteralPercent() {
    return "%";
}
function $9b1db68e8b46b007$var$formatUnixTimestamp(d) {
    return +d;
}
function $9b1db68e8b46b007$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("5hjlc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $2aiuo = parcelRequire("2aiuo");
var $3d7d8afb839f8ee0$var$isoSpecifier = module.exports.isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function $3d7d8afb839f8ee0$var$formatIsoNative(date) {
    return date.toISOString();
}
var $3d7d8afb839f8ee0$var$formatIso = Date.prototype.toISOString ? $3d7d8afb839f8ee0$var$formatIsoNative : (0, $2aiuo.utcFormat)($3d7d8afb839f8ee0$var$isoSpecifier);
var $3d7d8afb839f8ee0$var$_default = module.exports.default = $3d7d8afb839f8ee0$var$formatIso;

});

parcelRegister("b7N9x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5hjlc = parcelRequire("5hjlc");

var $2aiuo = parcelRequire("2aiuo");
function $819679e36042b2a3$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $819679e36042b2a3$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $819679e36042b2a3$var$parseIsoNative : (0, $2aiuo.utcParse)($5hjlc.isoSpecifier);
var $819679e36042b2a3$var$_default = module.exports.default = $819679e36042b2a3$var$parseIso;

});



parcelRegister("8cPDo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f977f3de1c809b2$var$utcTime;

var $1Zgpe = parcelRequire("1Zgpe");

var $iIkem = parcelRequire("iIkem");

var $l62ZM = parcelRequire("l62ZM");

var $5dOui = parcelRequire("5dOui");
function $5f977f3de1c809b2$var$utcTime() {
    return $5dOui.initRange.apply((0, $l62ZM.calendar)($1Zgpe.utcTicks, $1Zgpe.utcTickInterval, $1Zgpe.utcYear, $1Zgpe.utcMonth, $1Zgpe.utcWeek, $1Zgpe.utcDay, $1Zgpe.utcHour, $1Zgpe.utcMinute, $1Zgpe.utcSecond, $iIkem.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("9PZF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $7298b52a1a4d5d8a$var$copy;
module.exports.default = $7298b52a1a4d5d8a$var$sequential;
module.exports.sequentialLog = $7298b52a1a4d5d8a$var$sequentialLog;
module.exports.sequentialPow = $7298b52a1a4d5d8a$var$sequentialPow;
module.exports.sequentialSqrt = $7298b52a1a4d5d8a$var$sequentialSqrt;
module.exports.sequentialSymlog = $7298b52a1a4d5d8a$var$sequentialSymlog;

var $jipHj = parcelRequire("jipHj");

var $izFby = parcelRequire("izFby");

var $5dOui = parcelRequire("5dOui");

var $8HRiH = parcelRequire("8HRiH");

var $cIUw0 = parcelRequire("cIUw0");

var $3vuXg = parcelRequire("3vuXg");

var $hzaGs = parcelRequire("hzaGs");
function $7298b52a1a4d5d8a$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $izFby.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($jipHj.interpolate);
    scale.rangeRound = range($jipHj.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $7298b52a1a4d5d8a$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $7298b52a1a4d5d8a$var$sequential() {
    var scale = (0, $8HRiH.linearish)($7298b52a1a4d5d8a$var$transformer()($izFby.identity));
    scale.copy = function() {
        return $7298b52a1a4d5d8a$var$copy(scale, $7298b52a1a4d5d8a$var$sequential());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $7298b52a1a4d5d8a$var$sequentialLog() {
    var scale = (0, $cIUw0.loggish)($7298b52a1a4d5d8a$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $7298b52a1a4d5d8a$var$copy(scale, $7298b52a1a4d5d8a$var$sequentialLog()).base(scale.base());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $7298b52a1a4d5d8a$var$sequentialSymlog() {
    var scale = (0, $3vuXg.symlogish)($7298b52a1a4d5d8a$var$transformer());
    scale.copy = function() {
        return $7298b52a1a4d5d8a$var$copy(scale, $7298b52a1a4d5d8a$var$sequentialSymlog()).constant(scale.constant());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $7298b52a1a4d5d8a$var$sequentialPow() {
    var scale = (0, $hzaGs.powish)($7298b52a1a4d5d8a$var$transformer());
    scale.copy = function() {
        return $7298b52a1a4d5d8a$var$copy(scale, $7298b52a1a4d5d8a$var$sequentialPow()).exponent(scale.exponent());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $7298b52a1a4d5d8a$var$sequentialSqrt() {
    return $7298b52a1a4d5d8a$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("kUZow", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3a8a94e903b7507$var$sequentialQuantile;

var $dDi6U = parcelRequire("dDi6U");

var $izFby = parcelRequire("izFby");

var $5dOui = parcelRequire("5dOui");
function $f3a8a94e903b7507$var$sequentialQuantile() {
    var domain = [], interpolator = $izFby.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $dDi6U.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dDi6U.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $dDi6U.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $f3a8a94e903b7507$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("gJbJ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2d9f1a0e02f624b$var$diverging;
module.exports.divergingLog = $c2d9f1a0e02f624b$var$divergingLog;
module.exports.divergingPow = $c2d9f1a0e02f624b$var$divergingPow;
module.exports.divergingSqrt = $c2d9f1a0e02f624b$var$divergingSqrt;
module.exports.divergingSymlog = $c2d9f1a0e02f624b$var$divergingSymlog;

var $jipHj = parcelRequire("jipHj");

var $izFby = parcelRequire("izFby");

var $5dOui = parcelRequire("5dOui");

var $8HRiH = parcelRequire("8HRiH");

var $cIUw0 = parcelRequire("cIUw0");

var $9PZF4 = parcelRequire("9PZF4");

var $3vuXg = parcelRequire("3vuXg");

var $hzaGs = parcelRequire("hzaGs");
function $c2d9f1a0e02f624b$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $izFby.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $jipHj.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($jipHj.interpolate);
    scale.rangeRound = range($jipHj.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $c2d9f1a0e02f624b$var$diverging() {
    var scale = (0, $8HRiH.linearish)($c2d9f1a0e02f624b$var$transformer()($izFby.identity));
    scale.copy = function() {
        return (0, $9PZF4.copy)(scale, $c2d9f1a0e02f624b$var$diverging());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $c2d9f1a0e02f624b$var$divergingLog() {
    var scale = (0, $cIUw0.loggish)($c2d9f1a0e02f624b$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $9PZF4.copy)(scale, $c2d9f1a0e02f624b$var$divergingLog()).base(scale.base());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $c2d9f1a0e02f624b$var$divergingSymlog() {
    var scale = (0, $3vuXg.symlogish)($c2d9f1a0e02f624b$var$transformer());
    scale.copy = function() {
        return (0, $9PZF4.copy)(scale, $c2d9f1a0e02f624b$var$divergingSymlog()).constant(scale.constant());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $c2d9f1a0e02f624b$var$divergingPow() {
    var scale = (0, $hzaGs.powish)($c2d9f1a0e02f624b$var$transformer());
    scale.copy = function() {
        return (0, $9PZF4.copy)(scale, $c2d9f1a0e02f624b$var$divergingPow()).exponent(scale.exponent());
    };
    return $5dOui.initInterpolator.apply(scale, arguments);
}
function $c2d9f1a0e02f624b$var$divergingSqrt() {
    return $c2d9f1a0e02f624b$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});





parcelRegister("6PfPa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultTickNumber = $4f83c7e3bbe0e35e$var$getDefaultTickNumber;
module.exports.getTickNumber = $4f83c7e3bbe0e35e$var$getTickNumber;
module.exports.scaleTickNumberByRange = $4f83c7e3bbe0e35e$var$scaleTickNumberByRange;
function $4f83c7e3bbe0e35e$var$getTickNumber(params, domain, defaultTickNumber) {
    const { tickMaxStep: tickMaxStep, tickMinStep: tickMinStep, tickNumber: tickNumber } = params;
    const maxTicks = tickMinStep === undefined ? 999 : Math.floor(Math.abs(domain[1] - domain[0]) / tickMinStep);
    const minTicks = tickMaxStep === undefined ? 2 : Math.ceil(Math.abs(domain[1] - domain[0]) / tickMaxStep);
    const defaultizedTickNumber = tickNumber ?? defaultTickNumber;
    return Math.min(maxTicks, Math.max(minTicks, defaultizedTickNumber));
}
function $4f83c7e3bbe0e35e$var$scaleTickNumberByRange(tickNumber, range) {
    const rangeGap = range[1] - range[0];
    /* If the range start and end are the same, `tickNumber` will become infinity, so we default to 1. */ if (rangeGap === 0) return 1;
    return tickNumber / ((range[1] - range[0]) / 100);
}
function $4f83c7e3bbe0e35e$var$getDefaultTickNumber(dimension) {
    return Math.floor(Math.abs(dimension) / 50);
}

});

parcelRegister("ar6SO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getScale = $7991c3d2c36fb35a$var$getScale;

var $9PbcQ = parcelRequire("9PbcQ");

var $6lJB1 = parcelRequire("6lJB1");
function $7991c3d2c36fb35a$var$getScale(scaleType, domain, range) {
    switch(scaleType){
        case 'log':
            return (0, $9PbcQ.scaleLog)(domain, range);
        case 'pow':
            return (0, $9PbcQ.scalePow)(domain, range);
        case 'sqrt':
            return (0, $9PbcQ.scaleSqrt)(domain, range);
        case 'time':
            return (0, $9PbcQ.scaleTime)(domain, range);
        case 'utc':
            return (0, $9PbcQ.scaleUtc)(domain, range);
        case 'symlog':
            return (0, $6lJB1.scaleSymlog)(domain, range);
        default:
            return (0, $9PbcQ.scaleLinear)(domain, range);
    }
}

});
parcelRegister("6lJB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $csU5h = parcelRequire("csU5h");
Object.keys($csU5h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $csU5h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $csU5h[key];
        }
    });
});

var $hP2Xe = parcelRequire("hP2Xe");
Object.keys($hP2Xe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hP2Xe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hP2Xe[key];
        }
    });
});

var $amjKO = parcelRequire("amjKO");
Object.keys($amjKO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $amjKO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $amjKO[key];
        }
    });
});

});
parcelRegister("csU5h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keyof = $91339ab97e854361$var$keyof;
module.exports.scaleBand = $91339ab97e854361$var$scaleBand;

var $hGII4 = parcelRequire("hGII4");
/* eslint-disable func-names */ // Adapted from d3-scale v4.0.2
// https://github.com/d3/d3-scale/blob/d6904a4bde09e16005e0ad8ca3e25b10ce54fa0d/src/band.js
function $91339ab97e854361$var$keyof(value) {
    if (Array.isArray(value)) return JSON.stringify(value);
    if (typeof value === 'object' && value !== null) return value.valueOf();
    return value;
}
/**
 * Constructs a new band scale with the specified range, no padding, no rounding and center alignment.
 * The domain defaults to the empty domain.
 * If range is not specified, it defaults to the unit range [0, 1].
 *
 * The generic corresponds to the data type of domain elements.
 *
 * @param range A two-element array of numeric values.
 */ /**
 * Constructs a new band scale with the specified domain and range, no padding, no rounding and center alignment.
 *
 * The generic corresponds to the data type of domain elements.
 *
 * @param domain Array of domain values.
 * @param range A two-element array of numeric values.
 */ function $91339ab97e854361$var$scaleBand(...args) {
    // @ts-expect-error, InternMap accepts two arguments, but its types are set as Map, which doesn't.
    let index = new $hGII4.InternMap(undefined, $91339ab97e854361$var$keyof);
    let domain = [];
    let ordinalRange = [];
    let r0 = 0;
    let r1 = 1;
    let step;
    let bandwidth;
    let isRound = false;
    let paddingInner = 0;
    let paddingOuter = 0;
    let align = 0.5;
    const scale = (d)=>{
        const i = index.get(d);
        if (i === undefined) return undefined;
        return ordinalRange[i % ordinalRange.length];
    };
    const rescale = ()=>{
        const n = domain.length;
        const reverse = r1 < r0;
        const start = reverse ? r1 : r0;
        const stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (isRound) step = Math.floor(step);
        const adjustedStart = start + (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        const finalStart = isRound ? Math.round(adjustedStart) : adjustedStart;
        const finalBandwidth = isRound ? Math.round(bandwidth) : bandwidth;
        bandwidth = finalBandwidth;
        const values = (0, $hGII4.range)(n).map((i)=>finalStart + step * i);
        ordinalRange = reverse ? values.reverse() : values;
        return scale;
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        // @ts-expect-error, InternMap accepts two arguments.
        index = new $hGII4.InternMap(undefined, $91339ab97e854361$var$keyof);
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return rescale();
    };
    scale.range = function(_) {
        if (!arguments.length) return [
            r0,
            r1
        ];
        const [v0, v1] = _;
        r0 = +v0;
        r1 = +v1;
        return rescale();
    };
    scale.rangeRound = function(_) {
        const [v0, v1] = _;
        r0 = +v0;
        r1 = +v1;
        isRound = true;
        return rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        if (!arguments.length) return isRound;
        isRound = !!_;
        return rescale();
    };
    scale.padding = function(_) {
        if (!arguments.length) return paddingInner;
        paddingInner = Math.min(1, paddingOuter = +_);
        return rescale();
    };
    scale.paddingInner = function(_) {
        if (!arguments.length) return paddingInner;
        paddingInner = Math.min(1, _);
        return rescale();
    };
    scale.paddingOuter = function(_) {
        if (!arguments.length) return paddingOuter;
        paddingOuter = +_;
        return rescale();
    };
    scale.align = function(_) {
        if (!arguments.length) return align;
        align = Math.max(0, Math.min(1, _));
        return rescale();
    };
    scale.copy = ()=>{
        return $91339ab97e854361$var$scaleBand(domain, [
            r0,
            r1
        ]).round(isRound).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    // Initialize from arguments
    const [arg0, arg1] = args;
    if (args.length > 1) {
        scale.domain(arg0);
        scale.range(arg1);
    } else if (arg0) scale.range(arg0);
    else rescale();
    return scale;
}

});
parcelRegister("hGII4", function(module, exports) {
// `x-charts-vendor/d3-array` (CommonJS)
// See upstream license: https://github.com/d3/d3-array/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("i6kT1"));

});
parcelRegister("i6kT1", function(module, exports) {
// `x-charts-vendor/d3-array` (CommonJS)
// See upstream license: https://github.com/d3/d3-array/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-array`

module.exports = (parcelRequire("dDi6U"));

});



parcelRegister("hP2Xe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scalePoint = $cf997dc4b15e8044$var$scalePoint;

var $csU5h = parcelRequire("csU5h");
/**
 * Constructs a new point scale with the specified range, no padding, no rounding and center alignment.
 * The domain defaults to the empty domain.
 * If range is not specified, it defaults to the unit range [0, 1].
 *
 * The generic corresponds to the data type of domain elements.
 *
 * @param range A two-element array of numeric values.
 */ /**
 * Constructs a new point scale with the specified domain and range, no padding, no rounding and center alignment.
 * The domain defaults to the empty domain.
 *
 * The generic corresponds to the data type of domain elements.
 *
 * @param domain Array of domain values.
 * @param range A two-element array of numeric values.
 */ function $cf997dc4b15e8044$var$scalePoint(...args) {
    // ScalePoint is essentially ScaleBand with paddingInner(1)
    const scale = (0, $csU5h.scaleBand)(...args).paddingInner(1);
    // Remove paddingInner method and make padding alias to paddingOuter
    const originalCopy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = ()=>{
        const copied = originalCopy();
        copied.padding = copied.paddingOuter;
        delete copied.paddingInner;
        delete copied.paddingOuter;
        copied.copy = scale.copy;
        return copied;
    };
    return scale;
}

});

parcelRegister("amjKO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scaleSymlog = $78ab4834d56d2cd5$var$scaleSymlog;

var $9PbcQ = parcelRequire("9PbcQ");
/**
 * Constructs a new continuous scale with the specified range, the constant 1, the default interpolator and clamping disabled.
 * The domain defaults to [0, 1].
 * If range is not specified, it defaults to [0, 1].
 *
 * The first generic corresponds to the data type of the range elements.
 * The second generic corresponds to the data type of the output elements generated by the scale.
 * The third generic corresponds to the data type of the unknown value.
 *
 * If range element and output element type differ, the interpolator factory used with the scale must match this behavior and
 * convert the interpolated range element to a corresponding output element.
 *
 * The range must be set in accordance with the range element type.
 *
 * The interpolator factory may be set using the interpolate(...) method of the scale.
 *
 * @param range Array of range values.
 */ /**
 * Constructs a new continuous scale with the specified domain and range, the constant 1, the default interpolator and clamping disabled.
 *
 * The first generic corresponds to the data type of the range elements.
 * The second generic corresponds to the data type of the output elements generated by the scale.
 * The third generic corresponds to the data type of the unknown value.
 *
 * If range element and output element type differ, the interpolator factory used with the scale must match this behavior and
 * convert the interpolated range element to a corresponding output element.
 *
 * The range must be set in accordance with the range element type.
 *
 * The interpolator factory may be set using the interpolate(...) method of the scale.
 *
 * @param domain Array of numeric domain values.
 * @param range Array of range values.
 */ function $78ab4834d56d2cd5$var$scaleSymlog(...args) {
    const scale = (0, $9PbcQ.scaleSymlog)(...args);
    const originalTicks = scale.ticks;
    const { negativeScale: negativeScale, linearScale: linearScale, positiveScale: positiveScale } = $78ab4834d56d2cd5$var$generateScales(scale);
    // Workaround for https://github.com/d3/d3-scale/issues/162
    scale.ticks = (count)=>{
        const ticks = originalTicks(count);
        const constant = scale.constant();
        let negativeLogTickCount = 0;
        let linearTickCount = 0;
        let positiveLogTickCount = 0;
        ticks.forEach((tick)=>{
            if (tick > -constant && tick < constant) linearTickCount += 1;
            if (tick <= -constant) negativeLogTickCount += 1;
            if (tick >= constant) positiveLogTickCount += 1;
        });
        const finalTicks = [];
        if (negativeLogTickCount > 0) finalTicks.push(...negativeScale.ticks(negativeLogTickCount));
        if (linearTickCount > 0) {
            const linearTicks = linearScale.ticks(linearTickCount);
            if (finalTicks.at(-1) === linearTicks[0]) finalTicks.push(...linearTicks.slice(1));
            else finalTicks.push(...linearTicks);
        }
        if (positiveLogTickCount > 0) {
            const positiveTicks = positiveScale.ticks(positiveLogTickCount);
            if (finalTicks.at(-1) === positiveTicks[0]) finalTicks.push(...positiveTicks.slice(1));
            else finalTicks.push(...positiveTicks);
        }
        return finalTicks;
    };
    scale.tickFormat = (count = 10, specifier)=>{
        // Calculates the proportion of the domain that each scale occupies, and use that ratio to determine the number of ticks for each scale.
        const constant = scale.constant();
        const [start, end] = scale.domain();
        const extent = end - start;
        const negativeScaleDomain = negativeScale.domain();
        const negativeScaleExtent = negativeScaleDomain[1] - negativeScaleDomain[0];
        const negativeScaleRatio = extent === 0 ? 0 : negativeScaleExtent / extent;
        const negativeScaleTickCount = negativeScaleRatio * count;
        const linearScaleDomain = linearScale.domain();
        const linearScaleExtent = linearScaleDomain[1] - linearScaleDomain[0];
        const linearScaleRatio = extent === 0 ? 0 : linearScaleExtent / extent;
        const linearScaleTickCount = linearScaleRatio * count;
        const positiveScaleDomain = positiveScale.domain();
        const positiveScaleExtent = positiveScaleDomain[1] - positiveScaleDomain[0];
        const positiveScaleRatio = extent === 0 ? 0 : positiveScaleExtent / extent;
        const positiveScaleTickCount = positiveScaleRatio * count;
        const negativeTickFormat = negativeScale.tickFormat(negativeScaleTickCount, specifier);
        const linearTickFormat = linearScale.tickFormat(linearScaleTickCount, specifier);
        const positiveTickFormat = positiveScale.tickFormat(positiveScaleTickCount, specifier);
        return (tick)=>{
            const tickFormat = // eslint-disable-next-line no-nested-ternary
            tick.valueOf() <= -constant ? negativeTickFormat : tick.valueOf() >= constant ? positiveTickFormat : linearTickFormat;
            return tickFormat(tick);
        };
    };
    /* Adaptation of https://github.com/d3/d3-scale/blob/d6904a4bde09e16005e0ad8ca3e25b10ce54fa0d/src/symlog.js#L30 */ scale.copy = ()=>{
        return $78ab4834d56d2cd5$var$scaleSymlog(scale.domain(), scale.range()).constant(scale.constant());
    };
    return scale;
}
function $78ab4834d56d2cd5$var$generateScales(scale) {
    const constant = scale.constant();
    const domain = scale.domain();
    const negativeDomain = [
        domain[0],
        Math.min(domain[1], -constant)
    ];
    const negativeLogScale = (0, $9PbcQ.scaleLog)(negativeDomain, scale.range());
    const linearDomain = [
        Math.max(domain[0], -constant),
        Math.min(domain[1], constant)
    ];
    const linearScale = (0, $9PbcQ.scaleLinear)(linearDomain, scale.range());
    const positiveDomain = [
        Math.max(domain[0], constant),
        domain[1]
    ];
    const positiveLogScale = (0, $9PbcQ.scaleLog)(positiveDomain, scale.range());
    return {
        negativeScale: negativeLogScale,
        linearScale: linearScale,
        positiveScale: positiveLogScale
    };
}

});



parcelRegister("QqBso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDateFormatter = $09d97e462497965c$var$createDateFormatter;
module.exports.isDateData = void 0;

var $9PbcQ = parcelRequire("9PbcQ");
/**
 * Checks if the provided data array contains Date objects.
 * @param data The data array to check.
 * @returns A type predicate indicating if the data is an array of Date objects.
 */ const $09d97e462497965c$var$isDateData = (data)=>data?.[0] instanceof Date;
/**
 * Creates a formatter function for date values.
 * @param data The data array containing Date or NumberValue objects.
 * @param range The range for the time scale.
 * @param tickNumber (Optional) The number of ticks for formatting.
 * @returns A formatter function for date values.
 */ module.exports.isDateData = $09d97e462497965c$var$isDateData;
function $09d97e462497965c$var$createDateFormatter(data, range, tickNumber) {
    const timeScale = (0, $9PbcQ.scaleTime)(data, range);
    return (v, { location: location })=>location === 'tick' ? timeScale.tickFormat(tickNumber)(v) : `${v.toLocaleString()}`;
}

});

parcelRegister("jcuKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisTriggerTooltip = void 0;

var $8e9Tj = parcelRequire("8e9Tj");
const $dfa6fe3927127d8b$var$getAxisTriggerTooltip = (axisDirection, seriesConfig, formattedSeries, defaultAxisId)=>{
    const tooltipAxesIds = new Set();
    const chartTypes = Object.keys(seriesConfig).filter($8e9Tj.isCartesianSeriesType);
    chartTypes.forEach((chartType)=>{
        const series = formattedSeries[chartType]?.series ?? {};
        const tooltipAxes = seriesConfig[chartType].axisTooltipGetter?.(series);
        if (tooltipAxes === undefined) return;
        tooltipAxes.forEach(({ axisId: axisId, direction: direction })=>{
            if (direction === axisDirection) tooltipAxesIds.add(axisId ?? defaultAxisId);
        });
    });
    return tooltipAxesIds;
};
module.exports.getAxisTriggerTooltip = $dfa6fe3927127d8b$var$getAxisTriggerTooltip;

});
parcelRegister("8e9Tj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCartesianSeries = $5fd74db305a92bef$var$isCartesianSeries;
module.exports.isCartesianSeriesType = $5fd74db305a92bef$var$isCartesianSeriesType;

var $hPkde = parcelRequire("hPkde");
function $5fd74db305a92bef$var$isCartesianSeriesType(seriesType) {
    return $hPkde.cartesianSeriesTypes.getTypes().has(seriesType);
}
function $5fd74db305a92bef$var$isCartesianSeries(series) {
    return $5fd74db305a92bef$var$isCartesianSeriesType(series.type);
}

});
parcelRegister("hPkde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.polarSeriesTypes = module.exports.cartesianSeriesTypes = void 0;
let $cfa6e0de0ed892c8$var$cartesianInstance;
let $cfa6e0de0ed892c8$var$polarInstance;
class $cfa6e0de0ed892c8$var$CartesianSeriesTypes {
    types = new Set();
    constructor(){
        if ($cfa6e0de0ed892c8$var$cartesianInstance) throw new Error('You can only create one instance!');
        $cfa6e0de0ed892c8$var$cartesianInstance = this.types;
    }
    addType(value) {
        this.types.add(value);
    }
    getTypes() {
        return this.types;
    }
}
class $cfa6e0de0ed892c8$var$PolarSeriesTypes {
    types = new Set();
    constructor(){
        if ($cfa6e0de0ed892c8$var$polarInstance) throw new Error('You can only create one instance!');
        $cfa6e0de0ed892c8$var$polarInstance = this.types;
    }
    addType(value) {
        this.types.add(value);
    }
    getTypes() {
        return this.types;
    }
}
const $cfa6e0de0ed892c8$var$cartesianSeriesTypes = module.exports.cartesianSeriesTypes = new $cfa6e0de0ed892c8$var$CartesianSeriesTypes();
$cfa6e0de0ed892c8$var$cartesianSeriesTypes.addType('bar');
$cfa6e0de0ed892c8$var$cartesianSeriesTypes.addType('line');
$cfa6e0de0ed892c8$var$cartesianSeriesTypes.addType('scatter');
const $cfa6e0de0ed892c8$var$polarSeriesTypes = module.exports.polarSeriesTypes = new $cfa6e0de0ed892c8$var$PolarSeriesTypes();
$cfa6e0de0ed892c8$var$polarSeriesTypes.addType('radar');

});



parcelRegister("2UPWB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBandScale = $21f91ac782b4b88b$var$isBandScale;
module.exports.isOrdinalScale = $21f91ac782b4b88b$var$isOrdinalScale;
module.exports.isPointScale = $21f91ac782b4b88b$var$isPointScale;
function $21f91ac782b4b88b$var$isOrdinalScale(scale) {
    return scale.bandwidth !== undefined;
}
function $21f91ac782b4b88b$var$isBandScale(scale) {
    return $21f91ac782b4b88b$var$isOrdinalScale(scale) && scale.paddingOuter !== undefined;
}
function $21f91ac782b4b88b$var$isPointScale(scale) {
    return $21f91ac782b4b88b$var$isOrdinalScale(scale) && !('paddingOuter' in scale);
}

});


parcelRegister("sJvPg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createContinuousScaleGetAxisFilter = $0565eb70397cf295$var$createContinuousScaleGetAxisFilter;
module.exports.createDiscreteScaleGetAxisFilter = $0565eb70397cf295$var$createDiscreteScaleGetAxisFilter;
module.exports.createGetAxisFilters = void 0;

var $6seV0 = parcelRequire("6seV0");
function $0565eb70397cf295$var$createDiscreteScaleGetAxisFilter(axisData, zoomStart, zoomEnd, direction) {
    const maxIndex = axisData?.length ?? 0;
    const minVal = Math.floor(zoomStart * maxIndex / 100);
    const maxVal = Math.ceil(zoomEnd * maxIndex / 100);
    return function filterAxis(value, dataIndex) {
        const val = value[direction] ?? axisData?.[dataIndex];
        if (val == null) // If the value does not exist because of missing data point, or out of range index, we just ignore.
        return true;
        return dataIndex >= minVal && dataIndex < maxVal;
    };
}
function $0565eb70397cf295$var$createContinuousScaleGetAxisFilter(domain, zoomStart, zoomEnd, direction, axisData) {
    const min = domain[0].valueOf();
    const max = domain[1].valueOf();
    const minVal = min + zoomStart * (max - min) / 100;
    const maxVal = min + zoomEnd * (max - min) / 100;
    return function filterAxis(value, dataIndex) {
        const val = value[direction] ?? axisData?.[dataIndex];
        if (val == null) // If the value does not exist because of missing data point, or out of range index, we just ignore.
        return true;
        return val >= minVal && val <= maxVal;
    };
}
const $0565eb70397cf295$var$createGetAxisFilters = (filters)=>({ currentAxisId: currentAxisId, seriesXAxisId: seriesXAxisId, seriesYAxisId: seriesYAxisId, isDefaultAxis: isDefaultAxis })=>{
        return (value, dataIndex)=>{
            const axisId = currentAxisId === seriesXAxisId ? seriesYAxisId : seriesXAxisId;
            if (!axisId || isDefaultAxis) return Object.values(filters ?? {})[0]?.(value, dataIndex) ?? true;
            const data = [
                seriesYAxisId,
                seriesXAxisId
            ].filter((id)=>id !== currentAxisId).map((id)=>filters[id ?? '']).filter($6seV0.isDefined);
            return data.every((f)=>f(value, dataIndex));
        };
    };
module.exports.createGetAxisFilters = $0565eb70397cf295$var$createGetAxisFilters;

});
parcelRegister("6seV0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefined = $4b30ee1735a660ea$var$isDefined;
function $4b30ee1735a660ea$var$isDefined(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("5klR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createZoomLookup = void 0;

var $b4US8 = parcelRequire("b4US8");
const $3e0fc5ec0bcbbe0f$var$createZoomLookup = (axisDirection)=>(axes = [])=>axes.reduce((acc, v)=>{
            // @ts-ignore
            const { zoom: zoom, id: axisId, reverse: reverse } = v;
            const defaultizedZoom = (0, $b4US8.defaultizeZoom)(zoom, axisId, axisDirection, reverse);
            if (defaultizedZoom) acc[axisId] = defaultizedZoom;
            return acc;
        }, {});
module.exports.createZoomLookup = $3e0fc5ec0bcbbe0f$var$createZoomLookup;

});

parcelRegister("kOBDb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNormalizedAxisScale = $f275aae72bea345a$var$getNormalizedAxisScale;
module.exports.getRange = $f275aae72bea345a$var$getRange;

var $lXwwj = parcelRequire("lXwwj");

var $ar6SO = parcelRequire("ar6SO");

var $6lJB1 = parcelRequire("6lJB1");
const $f275aae72bea345a$var$DEFAULT_CATEGORY_GAP_RATIO = 0.2;
function $f275aae72bea345a$var$getRange(drawingArea, axisDirection, axis) {
    const range = axisDirection === 'x' ? [
        drawingArea.left,
        drawingArea.left + drawingArea.width
    ] : [
        drawingArea.top + drawingArea.height,
        drawingArea.top
    ];
    return axis.reverse ? [
        range[1],
        range[0]
    ] : range;
}
function $f275aae72bea345a$var$getNormalizedAxisScale(axis, domain) {
    const range = [
        0,
        1
    ];
    if ((0, $lXwwj.isBandScaleConfig)(axis)) {
        const categoryGapRatio = axis.categoryGapRatio ?? $f275aae72bea345a$var$DEFAULT_CATEGORY_GAP_RATIO;
        return (0, $6lJB1.scaleBand)(domain, range).paddingInner(categoryGapRatio).paddingOuter(categoryGapRatio / 2);
    }
    if ((0, $lXwwj.isPointScaleConfig)(axis)) return (0, $6lJB1.scalePoint)(domain, range);
    const scaleType = axis.scaleType ?? 'linear';
    const scale = (0, $ar6SO.getScale)(scaleType, domain, range);
    if ((0, $lXwwj.isSymlogScaleConfig)(axis) && axis.constant != null) scale.constant(axis.constant);
    return scale;
}

});

parcelRegister("Gls7F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zoomScaleRange = void 0;
/**
 * Applies the zoom into the scale range.
 * It changes the screen coordinates that the scale covers.
 * Not the data that is displayed.
 *
 * @param scaleRange the original range in real screen coordinates.
 * @param zoomRange the zoom range in percentage.
 * @returns zoomed range in real screen coordinates.
 */ const $07f49065737709a6$var$zoomScaleRange = (scaleRange, zoomRange)=>{
    const rangeGap = scaleRange[1] - scaleRange[0];
    const zoomGap = zoomRange[1] - zoomRange[0];
    // If current zoom show the scale between p1 and p2 percents
    // The range should be extended by adding [0, p1] and [p2, 100] segments
    const min = scaleRange[0] - zoomRange[0] * rangeGap / zoomGap;
    const max = scaleRange[1] + (100 - zoomRange[1]) * rangeGap / zoomGap;
    return [
        min,
        max
    ];
};
module.exports.zoomScaleRange = $07f49065737709a6$var$zoomScaleRange;

});

parcelRegister("c94Lk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisExtrema = $8d7a0500194fb582$var$getAxisExtrema;

var $8e9Tj = parcelRequire("8e9Tj");
const $8d7a0500194fb582$var$axisExtremumCallback = (chartType, axis, axisDirection, seriesConfig, axisIndex, formattedSeries, getFilters)=>{
    const getter = axisDirection === 'x' ? seriesConfig[chartType].xExtremumGetter : seriesConfig[chartType].yExtremumGetter;
    const series = formattedSeries[chartType]?.series ?? {};
    return getter?.({
        series: series,
        axis: axis,
        axisIndex: axisIndex,
        isDefaultAxis: axisIndex === 0,
        getFilters: getFilters
    }) ?? [
        Infinity,
        -Infinity
    ];
};
function $8d7a0500194fb582$var$getAxisExtrema(axis, axisDirection, seriesConfig, axisIndex, formattedSeries, getFilters) {
    const cartesianChartTypes = Object.keys(seriesConfig).filter($8e9Tj.isCartesianSeriesType);
    let extrema = [
        Infinity,
        -Infinity
    ];
    for (const chartType of cartesianChartTypes){
        const [min, max] = $8d7a0500194fb582$var$axisExtremumCallback(chartType, axis, axisDirection, seriesConfig, axisIndex, formattedSeries, getFilters);
        extrema = [
            Math.min(extrema[0], min),
            Math.max(extrema[1], max)
        ];
    }
    if (Number.isNaN(extrema[0]) || Number.isNaN(extrema[1])) return [
        Infinity,
        -Infinity
    ];
    return extrema;
}

});

parcelRegister("5IXOU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateFinalDomain = $42af76dda6ca3ca5$var$calculateFinalDomain;
module.exports.calculateInitialDomainAndTickNumber = $42af76dda6ca3ca5$var$calculateInitialDomainAndTickNumber;

var $ar6SO = parcelRequire("ar6SO");

var $fNEyu = parcelRequire("fNEyu");

var $6PfPa = parcelRequire("6PfPa");
function $42af76dda6ca3ca5$var$niceDomain(scaleType, domain, tickNumber) {
    return (0, $ar6SO.getScale)(scaleType ?? 'linear', domain, [
        0,
        1
    ]).nice(tickNumber).domain();
}
/**
 * Calculates the initial domain and tick number for a given axis.
 * The domain should still run through the zoom filterMode after this step.
 */ function $42af76dda6ca3ca5$var$calculateInitialDomainAndTickNumber(axis, axisDirection, axisIndex, formattedSeries, [minData, maxData], defaultTickNumber, preferStrictDomainInLineCharts) {
    const domainLimit = $42af76dda6ca3ca5$var$getDomainLimit(axis, axisDirection, axisIndex, formattedSeries, preferStrictDomainInLineCharts);
    let axisExtrema = $42af76dda6ca3ca5$var$getActualAxisExtrema(axis, minData, maxData);
    if (typeof domainLimit === 'function') {
        const { min: min, max: max } = domainLimit(minData.valueOf(), maxData.valueOf());
        axisExtrema[0] = min;
        axisExtrema[1] = max;
    }
    const tickNumber = (0, $6PfPa.getTickNumber)(axis, axisExtrema, defaultTickNumber);
    if (domainLimit === 'nice') axisExtrema = $42af76dda6ca3ca5$var$niceDomain(axis.scaleType, axisExtrema, tickNumber);
    axisExtrema = [
        'min' in axis ? axis.min ?? axisExtrema[0] : axisExtrema[0],
        'max' in axis ? axis.max ?? axisExtrema[1] : axisExtrema[1]
    ];
    return {
        domain: axisExtrema,
        tickNumber: tickNumber
    };
}
/**
 * Calculates the final domain for an axis.
 * After this step, the domain can be used to create the axis scale.
 */ function $42af76dda6ca3ca5$var$calculateFinalDomain(axis, axisDirection, axisIndex, formattedSeries, [minData, maxData], tickNumber, preferStrictDomainInLineCharts) {
    const domainLimit = $42af76dda6ca3ca5$var$getDomainLimit(axis, axisDirection, axisIndex, formattedSeries, preferStrictDomainInLineCharts);
    let axisExtrema = $42af76dda6ca3ca5$var$getActualAxisExtrema(axis, minData, maxData);
    if (typeof domainLimit === 'function') {
        const { min: min, max: max } = domainLimit(minData.valueOf(), maxData.valueOf());
        axisExtrema[0] = min;
        axisExtrema[1] = max;
    }
    if (domainLimit === 'nice') axisExtrema = $42af76dda6ca3ca5$var$niceDomain(axis.scaleType, axisExtrema, tickNumber);
    return [
        axis.min ?? axisExtrema[0],
        axis.max ?? axisExtrema[1]
    ];
}
function $42af76dda6ca3ca5$var$getDomainLimit(axis, axisDirection, axisIndex, formattedSeries, preferStrictDomainInLineCharts) {
    return preferStrictDomainInLineCharts ? (0, $fNEyu.getAxisDomainLimit)(axis, axisDirection, axisIndex, formattedSeries) : axis.domainLimit ?? 'nice';
}
/**
 * Get the actual axis extrema considering the user defined min and max values.
 * @param axisExtrema User defined axis extrema.
 * @param minData Minimum value from the data.
 * @param maxData Maximum value from the data.
 */ function $42af76dda6ca3ca5$var$getActualAxisExtrema(axisExtrema, minData, maxData) {
    let min = minData;
    let max = maxData;
    if ('max' in axisExtrema && axisExtrema.max != null && axisExtrema.max < minData) min = axisExtrema.max;
    if ('min' in axisExtrema && axisExtrema.min != null && axisExtrema.min > minData) max = axisExtrema.min;
    if (!('min' in axisExtrema) && !('max' in axisExtrema)) return [
        min,
        max
    ];
    return [
        axisExtrema.min ?? min,
        axisExtrema.max ?? max
    ];
}

});
parcelRegister("fNEyu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisDomainLimit = void 0;
const $b80ae40ac09bde16$var$getAxisDomainLimit = (axis, axisDirection, axisIndex, formattedSeries)=>{
    if (axis.domainLimit !== undefined) return axis.domainLimit;
    if (axisDirection === 'x') for (const seriesId of formattedSeries.line?.seriesOrder ?? []){
        const series = formattedSeries.line.series[seriesId];
        if (series.xAxisId === axis.id || series.xAxisId === undefined && axisIndex === 0) return 'strict';
    }
    return 'nice';
};
module.exports.getAxisDomainLimit = $b80ae40ac09bde16$var$getAxisDomainLimit;

});


parcelRegister("3W3on", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2dd96b7c1b5a1f61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Flatbush = void 0;

var $2dd96b7c1b5a1f61$var$_flatqueue = $2dd96b7c1b5a1f61$require$_interopRequireDefault((parcelRequire("i8Mgz")));
// @ts-nocheck
/* eslint-disable */ const $2dd96b7c1b5a1f61$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
const $2dd96b7c1b5a1f61$var$VERSION = 3; // serialized format version
class $2dd96b7c1b5a1f61$var$Flatbush {
    /**
   * Recreate a Flatbush index from raw `ArrayBuffer` or `SharedArrayBuffer` data.
   * @param {ArrayBufferLike} data
   * @param {number} [byteOffset=0] byte offset to the start of the Flatbush buffer in the referenced ArrayBuffer.
   * @returns {Flatbush} index
   */ static from(data, byteOffset = 0) {
        if (byteOffset % 8 !== 0) throw new Error('byteOffset must be 8-byte aligned.');
        // @ts-expect-error duck typing array buffers
        if (!data || data.byteLength === undefined || data.buffer) throw new Error('Data must be an instance of ArrayBuffer or SharedArrayBuffer.');
        const [magic, versionAndType] = new Uint8Array(data, byteOffset + 0, 2);
        if (magic !== 0xfb) throw new Error('Data does not appear to be in a Flatbush format.');
        const version = versionAndType >> 4;
        if (version !== $2dd96b7c1b5a1f61$var$VERSION) throw new Error(`Got v${version} data when expected v${$2dd96b7c1b5a1f61$var$VERSION}.`);
        const ArrayType = $2dd96b7c1b5a1f61$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error('Unrecognized array type.');
        const [nodeSize] = new Uint16Array(data, byteOffset + 2, 1);
        const [numItems] = new Uint32Array(data, byteOffset + 4, 1);
        return new $2dd96b7c1b5a1f61$var$Flatbush(numItems, nodeSize, ArrayType, undefined, data, byteOffset);
    }
    /**
   * Create a Flatbush index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=16] Size of the tree node (16 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBufferConstructor | SharedArrayBufferConstructor} [ArrayBufferType=ArrayBuffer] The array buffer type used to store data (`ArrayBuffer` by default).
   * @param {ArrayBufferLike} [data] (Only used internally)
   * @param {number} [byteOffset=0] (Only used internally)
   */ constructor(numItems, nodeSize = 16, ArrayType = Float64Array, ArrayBufferType = ArrayBuffer, data, byteOffset = 0){
        if (numItems === undefined) throw new Error('Missing required argument: numItems.');
        if (isNaN(numItems) || numItems <= 0) throw new Error(`Unexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.byteOffset = byteOffset;
        // calculate the total number of nodes in the R-tree to allocate space for
        // and the index of each tree level (used in search later)
        let n = numItems;
        let numNodes = n;
        this._levelBounds = [
            n * 4
        ];
        do {
            n = Math.ceil(n / this.nodeSize);
            numNodes += n;
            this._levelBounds.push(numNodes * 4);
        }while (n !== 1);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numNodes < 16384 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $2dd96b7c1b5a1f61$var$ARRAY_TYPES.indexOf(ArrayType);
        const nodesByteSize = numNodes * 4 * ArrayType.BYTES_PER_ELEMENT;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data) {
            this.data = data;
            this._boxes = new ArrayType(data, byteOffset + 8, numNodes * 4);
            this._indices = new this.IndexArrayType(data, byteOffset + 8 + nodesByteSize, numNodes);
            this._pos = numNodes * 4;
            this.minX = this._boxes[this._pos - 4];
            this.minY = this._boxes[this._pos - 3];
            this.maxX = this._boxes[this._pos - 2];
            this.maxY = this._boxes[this._pos - 1];
        } else {
            const data = this.data = new ArrayBufferType(8 + nodesByteSize + numNodes * this.IndexArrayType.BYTES_PER_ELEMENT);
            this._boxes = new ArrayType(data, 8, numNodes * 4);
            this._indices = new this.IndexArrayType(data, 8 + nodesByteSize, numNodes);
            this._pos = 0;
            this.minX = Infinity;
            this.minY = Infinity;
            this.maxX = -Infinity;
            this.maxY = -Infinity;
            new Uint8Array(data, 0, 2).set([
                0xfb,
                ($2dd96b7c1b5a1f61$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(data, 2, 1)[0] = nodeSize;
            new Uint32Array(data, 4, 1)[0] = numItems;
        }
        // a priority queue for k-nearest-neighbors queries
        /** @type FlatQueue<number> */ this._queue = new $2dd96b7c1b5a1f61$var$_flatqueue.default();
    }
    /**
   * Add a given rectangle to the index.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number} A zero-based, incremental number that represents the newly added rectangle.
   */ add(minX, minY, maxX = minX, maxY = minY) {
        const index = this._pos >> 2;
        const boxes = this._boxes;
        this._indices[index] = index;
        boxes[this._pos++] = minX;
        boxes[this._pos++] = minY;
        boxes[this._pos++] = maxX;
        boxes[this._pos++] = maxY;
        if (minX < this.minX) this.minX = minX;
        if (minY < this.minY) this.minY = minY;
        if (maxX > this.maxX) this.maxX = maxX;
        if (maxY > this.maxY) this.maxY = maxY;
        return index;
    }
    /** Perform indexing of the added rectangles. */ finish() {
        if (this._pos >> 2 !== this.numItems) throw new Error(`Added ${this._pos >> 2} items when expected ${this.numItems}.`);
        const boxes = this._boxes;
        if (this.numItems <= this.nodeSize) {
            // only one node, skip sorting and just fill the root box
            boxes[this._pos++] = this.minX;
            boxes[this._pos++] = this.minY;
            boxes[this._pos++] = this.maxX;
            boxes[this._pos++] = this.maxY;
            return;
        }
        const width = this.maxX - this.minX || 1;
        const height = this.maxY - this.minY || 1;
        const hilbertValues = new Uint32Array(this.numItems);
        const hilbertMax = 65535;
        // map item centers into Hilbert coordinate space and calculate Hilbert values
        for(let i = 0, pos = 0; i < this.numItems; i++){
            const minX = boxes[pos++];
            const minY = boxes[pos++];
            const maxX = boxes[pos++];
            const maxY = boxes[pos++];
            const x = Math.floor(hilbertMax * ((minX + maxX) / 2 - this.minX) / width);
            const y = Math.floor(hilbertMax * ((minY + maxY) / 2 - this.minY) / height);
            hilbertValues[i] = $2dd96b7c1b5a1f61$var$hilbert(x, y);
        }
        // sort items by their Hilbert value (for packing later)
        $2dd96b7c1b5a1f61$var$sort(hilbertValues, boxes, this._indices, 0, this.numItems - 1, this.nodeSize);
        // generate nodes at each tree level, bottom-up
        for(let i = 0, pos = 0; i < this._levelBounds.length - 1; i++){
            const end = this._levelBounds[i];
            // generate a parent node for each block of consecutive <nodeSize> nodes
            while(pos < end){
                const nodeIndex = pos;
                // calculate bbox for the new node
                let nodeMinX = boxes[pos++];
                let nodeMinY = boxes[pos++];
                let nodeMaxX = boxes[pos++];
                let nodeMaxY = boxes[pos++];
                for(let j = 1; j < this.nodeSize && pos < end; j++){
                    nodeMinX = Math.min(nodeMinX, boxes[pos++]);
                    nodeMinY = Math.min(nodeMinY, boxes[pos++]);
                    nodeMaxX = Math.max(nodeMaxX, boxes[pos++]);
                    nodeMaxY = Math.max(nodeMaxY, boxes[pos++]);
                }
                // add the new node to the tree data
                this._indices[this._pos >> 2] = nodeIndex;
                boxes[this._pos++] = nodeMinX;
                boxes[this._pos++] = nodeMinY;
                boxes[this._pos++] = nodeMaxX;
                boxes[this._pos++] = nodeMaxY;
            }
        }
    }
    /**
   * Search the index by a bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @param {(index: number) => boolean} [filterFn] An optional function for filtering the results.
   * @returns {number[]} An array containing the index, the x coordinate and the y coordinate of the points intersecting or touching the given bounding box.
   */ search(minX, minY, maxX, maxY, filterFn) {
        if (this._pos !== this._boxes.length) throw new Error('Data not yet indexed - call index.finish().');
        /** @type number | undefined */ let nodeIndex = this._boxes.length - 4;
        const queue = [];
        const results = [];
        while(nodeIndex !== undefined){
            // find the end index of the node
            const end = Math.min(nodeIndex + this.nodeSize * 4, $2dd96b7c1b5a1f61$var$upperBound(nodeIndex, this._levelBounds));
            // search through child nodes
            for(let /** @type number */ pos = nodeIndex; pos < end; pos += 4){
                // check if node bbox intersects with query bbox
                if (maxX < this._boxes[pos]) continue;
                 // maxX < nodeMinX
                if (maxY < this._boxes[pos + 1]) continue;
                 // maxY < nodeMinY
                if (minX > this._boxes[pos + 2]) continue;
                 // minX > nodeMaxX
                if (minY > this._boxes[pos + 3]) continue;
                 // minY > nodeMaxY
                const index = this._indices[pos >> 2] | 0;
                if (nodeIndex >= this.numItems * 4) queue.push(index); // node; add it to the search queue
                else if (filterFn === undefined || filterFn(index)) {
                    results.push(index);
                    results.push(this._boxes[pos]); // leaf item
                    results.push(this._boxes[pos + 1]);
                }
            }
            nodeIndex = queue.pop();
        }
        return results;
    }
    /**
   * Search items in order of distance from the given point.
   * @param x
   * @param y
   * @param [maxResults=Infinity]
   * @param maxDistSq
   * @param [filterFn] An optional function for filtering the results.
   * @param [sqDistFn] An optional function to calculate squared distance from the point to the item.
   * @returns {number[]} An array of indices of items found.
   */ neighbors(x, y, maxResults = Infinity, maxDistSq = Infinity, filterFn, sqDistFn = $2dd96b7c1b5a1f61$var$sqDist) {
        if (this._pos !== this._boxes.length) throw new Error('Data not yet indexed - call index.finish().');
        /** @type number | undefined */ let nodeIndex = this._boxes.length - 4;
        const q = this._queue;
        const results = [];
        /* eslint-disable no-labels */ outer: while(nodeIndex !== undefined){
            // find the end index of the node
            const end = Math.min(nodeIndex + this.nodeSize * 4, $2dd96b7c1b5a1f61$var$upperBound(nodeIndex, this._levelBounds));
            // add child nodes to the queue
            for(let pos = nodeIndex; pos < end; pos += 4){
                const index = this._indices[pos >> 2] | 0;
                const minX = this._boxes[pos];
                const minY = this._boxes[pos + 1];
                const maxX = this._boxes[pos + 2];
                const maxY = this._boxes[pos + 3];
                const dx = x < minX ? minX - x : x > maxX ? x - maxX : 0;
                const dy = y < minY ? minY - y : y > maxY ? y - maxY : 0;
                const dist = sqDistFn(dx, dy);
                if (dist > maxDistSq) continue;
                if (nodeIndex >= this.numItems * 4) q.push(index << 1, dist); // node (use even id)
                else if (filterFn === undefined || filterFn(index)) q.push((index << 1) + 1, dist); // leaf item (use odd id)
            }
            // pop items from the queue
            // @ts-expect-error q.length check eliminates undefined values
            while(q.length && q.peek() & 1){
                const dist = q.peekValue();
                // @ts-expect-error
                if (dist > maxDistSq) break outer;
                // @ts-expect-error
                results.push(q.pop() >> 1);
                if (results.length === maxResults) break outer;
            }
            // @ts-expect-error
            nodeIndex = q.length ? q.pop() >> 1 : undefined;
        }
        q.clear();
        return results;
    }
}
module.exports.Flatbush = $2dd96b7c1b5a1f61$var$Flatbush;
function $2dd96b7c1b5a1f61$var$sqDist(dx, dy) {
    return dx * dx + dy * dy;
}
/**
 * Binary search for the first value in the array bigger than the given.
 * @param {number} value
 * @param {number[]} arr
 */ function $2dd96b7c1b5a1f61$var$upperBound(value, arr) {
    let i = 0;
    let j = arr.length - 1;
    while(i < j){
        const m = i + j >> 1;
        if (arr[m] > value) j = m;
        else i = m + 1;
    }
    return arr[i];
}
/**
 * Custom quicksort that partially sorts bbox data alongside the hilbert values.
 * @param {Uint32Array} values
 * @param {InstanceType<TypedArrayConstructor>} boxes
 * @param {Uint16Array | Uint32Array} indices
 * @param {number} left
 * @param {number} right
 * @param {number} nodeSize
 */ function $2dd96b7c1b5a1f61$var$sort(values, boxes, indices, left, right, nodeSize) {
    if (Math.floor(left / nodeSize) >= Math.floor(right / nodeSize)) return;
    // apply median of three method
    const start = values[left];
    const mid = values[left + right >> 1];
    const end = values[right];
    let pivot = end;
    const x = Math.max(start, mid);
    if (end > x) pivot = x;
    else if (x === start) pivot = Math.max(mid, end);
    else if (x === mid) pivot = Math.max(start, end);
    let i = left - 1;
    let j = right + 1;
    while(true){
        do i++;
        while (values[i] < pivot);
        do j--;
        while (values[j] > pivot);
        if (i >= j) break;
        $2dd96b7c1b5a1f61$var$swap(values, boxes, indices, i, j);
    }
    $2dd96b7c1b5a1f61$var$sort(values, boxes, indices, left, j, nodeSize);
    $2dd96b7c1b5a1f61$var$sort(values, boxes, indices, j + 1, right, nodeSize);
}
/**
 * Swap two values and two corresponding boxes.
 * @param {Uint32Array} values
 * @param {InstanceType<TypedArrayConstructor>} boxes
 * @param {Uint16Array | Uint32Array} indices
 * @param {number} i
 * @param {number} j
 */ function $2dd96b7c1b5a1f61$var$swap(values, boxes, indices, i, j) {
    const temp = values[i];
    values[i] = values[j];
    values[j] = temp;
    const k = 4 * i;
    const m = 4 * j;
    const a = boxes[k];
    const b = boxes[k + 1];
    const c = boxes[k + 2];
    const d = boxes[k + 3];
    boxes[k] = boxes[m];
    boxes[k + 1] = boxes[m + 1];
    boxes[k + 2] = boxes[m + 2];
    boxes[k + 3] = boxes[m + 3];
    boxes[m] = a;
    boxes[m + 1] = b;
    boxes[m + 2] = c;
    boxes[m + 3] = d;
    const e = indices[i];
    indices[i] = indices[j];
    indices[j] = e;
}
/**
 * Fast Hilbert curve algorithm by http://threadlocalmutex.com/
 * Ported from C++ https://github.com/rawrunprotected/hilbert_curves (public domain)
 * @param {number} x
 * @param {number} y
 */ function $2dd96b7c1b5a1f61$var$hilbert(x, y) {
    let a = x ^ y;
    let b = 0xffff ^ a;
    let c = 0xffff ^ (x | y);
    let d = x & (y ^ 0xffff);
    let A = a | b >> 1;
    let B = a >> 1 ^ a;
    let C = c >> 1 ^ b & d >> 1 ^ c;
    let D = a & c >> 1 ^ d >> 1 ^ d;
    a = A;
    b = B;
    c = C;
    d = D;
    A = a & a >> 2 ^ b & b >> 2;
    B = a & b >> 2 ^ b & (a ^ b) >> 2;
    C ^= a & c >> 2 ^ b & d >> 2;
    D ^= b & c >> 2 ^ (a ^ b) & d >> 2;
    a = A;
    b = B;
    c = C;
    d = D;
    A = a & a >> 4 ^ b & b >> 4;
    B = a & b >> 4 ^ b & (a ^ b) >> 4;
    C ^= a & c >> 4 ^ b & d >> 4;
    D ^= b & c >> 4 ^ (a ^ b) & d >> 4;
    a = A;
    b = B;
    c = C;
    d = D;
    C ^= a & c >> 8 ^ b & d >> 8;
    D ^= b & c >> 8 ^ (a ^ b) & d >> 8;
    a = C ^ C >> 1;
    b = D ^ D >> 1;
    let i0 = x ^ y;
    let i1 = b | 0xffff ^ (i0 | a);
    i0 = (i0 | i0 << 8) & 0x00ff00ff;
    i0 = (i0 | i0 << 4) & 0x0f0f0f0f;
    i0 = (i0 | i0 << 2) & 0x33333333;
    i0 = (i0 | i0 << 1) & 0x55555555;
    i1 = (i1 | i1 << 8) & 0x00ff00ff;
    i1 = (i1 | i1 << 4) & 0x0f0f0f0f;
    i1 = (i1 | i1 << 2) & 0x33333333;
    i1 = (i1 | i1 << 1) & 0x55555555;
    return (i1 << 1 | i0) >>> 0;
}

});
parcelRegister("i8Mgz", function(module, exports) {
// `x-charts-vendor/flatqueue` (CommonJS)
// See upstream license: git+https://github.com/mourner/flatqueue/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/flatqueue`

module.exports = (parcelRequire("ak24l"));

});
parcelRegister("ak24l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/** @template T */ class $783d60817c6614d0$var$FlatQueue {
    constructor(){
        /** @type T[] */ this.ids = [];
        /** @type number[] */ this.values = [];
        /** Number of items in the queue. */ this.length = 0;
    }
    /** Removes all items from the queue. */ clear() {
        this.length = 0;
    }
    /**
   * Adds `item` to the queue with the specified `priority`.
   *
   * `priority` must be a number. Items are sorted and returned from low to high priority. Multiple items
   * with the same priority value can be added to the queue, but there is no guaranteed order between these items.
   *
   * @param {T} item
   * @param {number} priority
   */ push(item, priority) {
        let pos = this.length++;
        while(pos > 0){
            const parent = pos - 1 >> 1;
            const parentValue = this.values[parent];
            if (priority >= parentValue) break;
            this.ids[pos] = this.ids[parent];
            this.values[pos] = parentValue;
            pos = parent;
        }
        this.ids[pos] = item;
        this.values[pos] = priority;
    }
    /**
   * Removes and returns the item from the head of this queue, which is one of
   * the items with the lowest priority. If this queue is empty, returns `undefined`.
   */ pop() {
        if (this.length === 0) return undefined;
        const ids = this.ids, values = this.values, top = ids[0], last = --this.length;
        if (last > 0) {
            const id = ids[last];
            const value = values[last];
            let pos = 0;
            const halfLen = last >> 1;
            while(pos < halfLen){
                const left = (pos << 1) + 1;
                const right = left + 1;
                const child = left + (+(right < last) & +(values[right] < values[left]));
                if (values[child] >= value) break;
                ids[pos] = ids[child];
                values[pos] = values[child];
                pos = child;
            }
            ids[pos] = id;
            values[pos] = value;
        }
        return top;
    }
    /** Returns the item from the head of this queue without removing it. If this queue is empty, returns `undefined`. */ peek() {
        return this.length > 0 ? this.ids[0] : undefined;
    }
    /**
   * Returns the priority value of the item at the head of this queue without
   * removing it. If this queue is empty, returns `undefined`.
   */ peekValue() {
        return this.length > 0 ? this.values[0] : undefined;
    }
    /**
   * Shrinks the internal arrays to `this.length`.
   *
   * `pop()` and `clear()` calls don't free memory automatically to avoid unnecessary resize operations.
   * This also means that items that have been added to the queue can't be garbage collected until
   * a new item is pushed in their place, or this method is called.
   */ shrink() {
        this.ids.length = this.values.length = this.length;
    }
}
module.exports.default = $783d60817c6614d0$var$FlatQueue;

});




parcelRegister("k4wAF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisIndex = $e9cd7621d66dfb0f$var$getAxisIndex;
module.exports.getAxisValue = $e9cd7621d66dfb0f$var$getAxisValue;

var $2UPWB = parcelRequire("2UPWB");
function $e9cd7621d66dfb0f$var$getAsANumber(value) {
    return value instanceof Date ? value.getTime() : value;
}
/**
 * For a pointer coordinate, this function returns the dataIndex associated.
 * Returns `-1` if no dataIndex matches.
 */ function $e9cd7621d66dfb0f$var$getAxisIndex(axisConfig, pointerValue) {
    const { scale: scale, data: axisData, reverse: reverse } = axisConfig;
    if (!(0, $2UPWB.isOrdinalScale)(scale)) {
        const value = scale.invert(pointerValue);
        if (axisData === undefined) return -1;
        const valueAsNumber = $e9cd7621d66dfb0f$var$getAsANumber(value);
        const closestIndex = axisData?.findIndex((pointValue, index)=>{
            const v = $e9cd7621d66dfb0f$var$getAsANumber(pointValue);
            if (v > valueAsNumber) {
                if (index === 0 || Math.abs(valueAsNumber - v) <= Math.abs(valueAsNumber - $e9cd7621d66dfb0f$var$getAsANumber(axisData[index - 1]))) return true;
            }
            if (v <= valueAsNumber) {
                if (index === axisData.length - 1 || Math.abs($e9cd7621d66dfb0f$var$getAsANumber(value) - v) < Math.abs($e9cd7621d66dfb0f$var$getAsANumber(value) - $e9cd7621d66dfb0f$var$getAsANumber(axisData[index + 1]))) return true;
            }
            return false;
        });
        return closestIndex;
    }
    const dataIndex = scale.bandwidth() === 0 ? Math.floor((pointerValue - Math.min(...scale.range()) + scale.step() / 2) / scale.step()) : Math.floor((pointerValue - Math.min(...scale.range())) / scale.step());
    if (dataIndex < 0 || dataIndex >= axisData.length) return -1;
    return reverse ? axisData.length - 1 - dataIndex : dataIndex;
}
/**
 * For a pointer coordinate, this function returns the value associated.
 * Returns `null` if the coordinate has no value associated.
 */ function $e9cd7621d66dfb0f$var$getAxisValue(scale, axisData, pointerValue, dataIndex) {
    if (!(0, $2UPWB.isOrdinalScale)(scale)) {
        if (dataIndex === null) {
            const invertedValue = scale.invert(pointerValue);
            return Number.isNaN(invertedValue) ? null : invertedValue;
        }
        return axisData[dataIndex];
    }
    if (dataIndex === null || dataIndex < 0 || dataIndex >= axisData.length) return null;
    return axisData[dataIndex];
}

});

parcelRegister("g34sa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSVGPoint = $baf06183b9cb0ed9$var$getSVGPoint;
/**
 * Transform mouse event position to coordinates inside the SVG.
 * @param svg The SVG element
 * @param event The mouseEvent to transform
 */ function $baf06183b9cb0ed9$var$getSVGPoint(svg, event) {
    const pt = svg.createSVGPoint();
    pt.x = event.clientX;
    pt.y = event.clientY;
    return pt.matrixTransform(svg.getScreenCTM().inverse());
}

});

parcelRegister("8j56i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $60c40df79ba0a60a$var$_exportNames = {
    useChartInteraction: true
};
Object.defineProperty(module.exports, "useChartInteraction", {
    enumerable: true,
    get: function() {
        return $5k2HZ.useChartInteraction;
    }
});

var $5k2HZ = parcelRequire("5k2HZ");

var $iqlkh = parcelRequire("iqlkh");
Object.keys($iqlkh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($60c40df79ba0a60a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iqlkh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iqlkh[key];
        }
    });
});

});
parcelRegister("5k2HZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e00ebdeaa178479$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartInteraction = void 0;

var $3e00ebdeaa178479$var$_extends2 = $3e00ebdeaa178479$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3e00ebdeaa178479$var$_useEventCallback = $3e00ebdeaa178479$require$_interopRequireDefault((parcelRequire("6Lbjo")));
const $3e00ebdeaa178479$var$useChartInteraction = ({ store: store })=>{
    const cleanInteraction = (0, $3e00ebdeaa178479$var$_useEventCallback.default)(function cleanInteraction() {
        store.update({
            interaction: (0, $3e00ebdeaa178479$var$_extends2.default)({}, store.state.interaction, {
                pointer: null
            })
        });
    });
    const setLastUpdateSource = (0, $3e00ebdeaa178479$var$_useEventCallback.default)(function setLastUpdateSource(interaction) {
        if (store.state.interaction.lastUpdate !== interaction) store.set('interaction', (0, $3e00ebdeaa178479$var$_extends2.default)({}, store.state.interaction, {
            lastUpdate: interaction
        }));
    });
    const setPointerCoordinate = (0, $3e00ebdeaa178479$var$_useEventCallback.default)(function setPointerCoordinate(coordinate) {
        store.set('interaction', (0, $3e00ebdeaa178479$var$_extends2.default)({}, store.state.interaction, {
            pointer: coordinate,
            lastUpdate: coordinate !== null ? 'pointer' : store.state.interaction.lastUpdate
        }));
    });
    const handlePointerEnter = (0, $3e00ebdeaa178479$var$_useEventCallback.default)(function handlePointerEnter(event) {
        store.set('interaction', (0, $3e00ebdeaa178479$var$_extends2.default)({}, store.state.interaction, {
            pointerType: event.pointerType
        }));
    });
    const handlePointerLeave = (0, $3e00ebdeaa178479$var$_useEventCallback.default)(function handlePointerLeave() {
        store.set('interaction', (0, $3e00ebdeaa178479$var$_extends2.default)({}, store.state.interaction, {
            pointerType: null
        }));
    });
    return {
        instance: {
            cleanInteraction: cleanInteraction,
            setLastUpdateSource: setLastUpdateSource,
            setPointerCoordinate: setPointerCoordinate,
            handlePointerEnter: handlePointerEnter,
            handlePointerLeave: handlePointerLeave
        }
    };
};
module.exports.useChartInteraction = $3e00ebdeaa178479$var$useChartInteraction;
$3e00ebdeaa178479$var$useChartInteraction.getInitialState = ()=>({
        interaction: {
            item: null,
            pointer: null,
            lastUpdate: 'pointer',
            pointerType: null
        }
    });
$3e00ebdeaa178479$var$useChartInteraction.params = {};

});

parcelRegister("iqlkh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsPointerType = module.exports.selectorChartsLastInteraction = module.exports.selectorChartsInteractionPointerY = module.exports.selectorChartsInteractionPointerX = module.exports.selectorChartsInteractionPointer = module.exports.selectorChartsInteractionIsInitialized = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $d69b32a3b34c166d$var$selectInteraction = (state)=>state.interaction;
const $d69b32a3b34c166d$var$selectorChartsInteractionIsInitialized = module.exports.selectorChartsInteractionIsInitialized = (0, $8P0MD.createSelector)($d69b32a3b34c166d$var$selectInteraction, (interaction)=>interaction !== undefined);
const $d69b32a3b34c166d$var$selectorChartsInteractionPointer = module.exports.selectorChartsInteractionPointer = (0, $8P0MD.createSelector)($d69b32a3b34c166d$var$selectInteraction, (interaction)=>interaction?.pointer ?? null);
const $d69b32a3b34c166d$var$selectorChartsInteractionPointerX = module.exports.selectorChartsInteractionPointerX = (0, $8P0MD.createSelector)($d69b32a3b34c166d$var$selectorChartsInteractionPointer, (pointer)=>pointer && pointer.x);
const $d69b32a3b34c166d$var$selectorChartsInteractionPointerY = module.exports.selectorChartsInteractionPointerY = (0, $8P0MD.createSelector)($d69b32a3b34c166d$var$selectorChartsInteractionPointer, (pointer)=>pointer && pointer.y);
const $d69b32a3b34c166d$var$selectorChartsLastInteraction = module.exports.selectorChartsLastInteraction = (0, $8P0MD.createSelector)($d69b32a3b34c166d$var$selectInteraction, (interaction)=>interaction?.lastUpdate);
const $d69b32a3b34c166d$var$selectorChartsPointerType = module.exports.selectorChartsPointerType = (0, $8P0MD.createSelector)($d69b32a3b34c166d$var$selectInteraction, (interaction)=>interaction?.pointerType ?? null);

});


parcelRegister("iFmOZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsInteractionYAxisValue = module.exports.selectorChartsInteractionYAxisIndex = module.exports.selectorChartsInteractionXAxisValue = module.exports.selectorChartsInteractionXAxisIndex = module.exports.selectorChartsInteractionTooltipYAxes = module.exports.selectorChartsInteractionTooltipXAxes = module.exports.selectorChartsInteractionAxisTooltip = module.exports.selectorChartAxisInteraction = module.exports.selectChartsInteractionAxisIndex = void 0;

var $e9lLm = parcelRequire("e9lLm");

var $8P0MD = parcelRequire("8P0MD");

var $iqlkh = parcelRequire("iqlkh");

var $k4wAF = parcelRequire("k4wAF");

var $i9lnd = parcelRequire("i9lnd");
/**
 * Get interaction indexes
 */ function $d96dc2323ddd8278$var$indexGetter(value, axes, ids = axes.axisIds[0]) {
    return Array.isArray(ids) ? ids.map((id)=>(0, $k4wAF.getAxisIndex)(axes.axis[id], value)) : (0, $k4wAF.getAxisIndex)(axes.axis[ids], value);
}
const $d96dc2323ddd8278$var$selectChartsInteractionAxisIndex = (value, axes, id)=>{
    if (value === null) return null;
    const index = $d96dc2323ddd8278$var$indexGetter(value, axes, id);
    return index === -1 ? null : index;
};
module.exports.selectChartsInteractionAxisIndex = $d96dc2323ddd8278$var$selectChartsInteractionAxisIndex;
const $d96dc2323ddd8278$var$selectorChartsInteractionXAxisIndex = module.exports.selectorChartsInteractionXAxisIndex = (0, $8P0MD.createSelector)($iqlkh.selectorChartsInteractionPointerX, $i9lnd.selectorChartXAxis, $d96dc2323ddd8278$var$selectChartsInteractionAxisIndex);
const $d96dc2323ddd8278$var$selectorChartsInteractionYAxisIndex = module.exports.selectorChartsInteractionYAxisIndex = (0, $8P0MD.createSelector)($iqlkh.selectorChartsInteractionPointerY, $i9lnd.selectorChartYAxis, $d96dc2323ddd8278$var$selectChartsInteractionAxisIndex);
const $d96dc2323ddd8278$var$selectorChartAxisInteraction = module.exports.selectorChartAxisInteraction = (0, $8P0MD.createSelector)($iqlkh.selectorChartsInteractionPointerX, $iqlkh.selectorChartsInteractionPointerY, $i9lnd.selectorChartXAxis, $i9lnd.selectorChartYAxis, (x, y, xAxis, yAxis)=>[
        ...x === null ? [] : xAxis.axisIds.map((axisId)=>({
                axisId: axisId,
                dataIndex: $d96dc2323ddd8278$var$indexGetter(x, xAxis, axisId)
            })),
        ...y === null ? [] : yAxis.axisIds.map((axisId)=>({
                axisId: axisId,
                dataIndex: $d96dc2323ddd8278$var$indexGetter(y, yAxis, axisId)
            }))
    ].filter((item)=>item.dataIndex !== null && item.dataIndex >= 0));
/**
 * Get interaction values
 */ function $d96dc2323ddd8278$var$valueGetter(value, axes, indexes, ids = axes.axisIds[0]) {
    return Array.isArray(ids) ? ids.map((id, axisIndex)=>{
        const axis = axes.axis[id];
        return (0, $k4wAF.getAxisValue)(axis.scale, axis.data, value, indexes[axisIndex]);
    }) : (0, $k4wAF.getAxisValue)(axes.axis[ids].scale, axes.axis[ids].data, value, indexes);
}
const $d96dc2323ddd8278$var$selectorChartsInteractionXAxisValue = module.exports.selectorChartsInteractionXAxisValue = (0, $8P0MD.createSelector)($iqlkh.selectorChartsInteractionPointerX, $i9lnd.selectorChartXAxis, $d96dc2323ddd8278$var$selectorChartsInteractionXAxisIndex, (x, xAxes, xIndex, id)=>{
    if (x === null || xAxes.axisIds.length === 0) return null;
    return $d96dc2323ddd8278$var$valueGetter(x, xAxes, xIndex, id);
});
const $d96dc2323ddd8278$var$selectorChartsInteractionYAxisValue = module.exports.selectorChartsInteractionYAxisValue = (0, $8P0MD.createSelector)($iqlkh.selectorChartsInteractionPointerY, $i9lnd.selectorChartYAxis, $d96dc2323ddd8278$var$selectorChartsInteractionYAxisIndex, (y, yAxes, yIndex, id)=>{
    if (y === null || yAxes.axisIds.length === 0) return null;
    return $d96dc2323ddd8278$var$valueGetter(y, yAxes, yIndex, id);
});
const $d96dc2323ddd8278$var$EMPTY_ARRAY = [];
/**
 * Get x-axis ids and corresponding data index that should be display in the tooltip.
 */ const $d96dc2323ddd8278$var$selectorChartsInteractionTooltipXAxes = module.exports.selectorChartsInteractionTooltipXAxes = (0, $8P0MD.createSelectorMemoizedWithOptions)({
    memoizeOptions: {
        // Keep the same reference if array content is the same.
        // If possible, avoid this pattern by creating selectors that
        // uses string/number as arguments.
        resultEqualityCheck: $e9lLm.isDeepEqual
    }
})($iqlkh.selectorChartsInteractionPointerX, $i9lnd.selectorChartXAxis, (value, axes)=>{
    if (value === null) return $d96dc2323ddd8278$var$EMPTY_ARRAY;
    return axes.axisIds.filter((id)=>axes.axis[id].triggerTooltip).map((axisId)=>({
            axisId: axisId,
            dataIndex: (0, $k4wAF.getAxisIndex)(axes.axis[axisId], value)
        })).filter(({ dataIndex: dataIndex })=>dataIndex >= 0);
});
/**
 * Get y-axis ids and corresponding data index that should be display in the tooltip.
 */ const $d96dc2323ddd8278$var$selectorChartsInteractionTooltipYAxes = module.exports.selectorChartsInteractionTooltipYAxes = (0, $8P0MD.createSelectorMemoizedWithOptions)({
    memoizeOptions: {
        // Keep the same reference if array content is the same.
        // If possible, avoid this pattern by creating selectors that
        // uses string/number as arguments.
        resultEqualityCheck: $e9lLm.isDeepEqual
    }
})($iqlkh.selectorChartsInteractionPointerY, $i9lnd.selectorChartYAxis, (value, axes)=>{
    if (value === null) return $d96dc2323ddd8278$var$EMPTY_ARRAY;
    return axes.axisIds.filter((id)=>axes.axis[id].triggerTooltip).map((axisId)=>({
            axisId: axisId,
            dataIndex: (0, $k4wAF.getAxisIndex)(axes.axis[axisId], value)
        })).filter(({ dataIndex: dataIndex })=>dataIndex >= 0);
});
/**
 * Return `true` if the axis tooltip has something to display.
 */ const $d96dc2323ddd8278$var$selectorChartsInteractionAxisTooltip = module.exports.selectorChartsInteractionAxisTooltip = (0, $8P0MD.createSelector)($d96dc2323ddd8278$var$selectorChartsInteractionTooltipXAxes, $d96dc2323ddd8278$var$selectorChartsInteractionTooltipYAxes, (xTooltip, yTooltip)=>xTooltip.length > 0 || yTooltip.length > 0);

});

parcelRegister("cHKFL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkHasInteractionPlugin = $93fdb46092105c1d$var$checkHasInteractionPlugin;
function $93fdb46092105c1d$var$checkHasInteractionPlugin(instance) {
    return instance.setPointerCoordinate !== undefined;
}

});


parcelRegister("cIV2T", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9435d82b286a6f72$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsHighlightYAxisValue = module.exports.selectorChartsHighlightYAxisIndex = module.exports.selectorChartsHighlightYAxis = module.exports.selectorChartsHighlightXAxisValue = module.exports.selectorChartsHighlightXAxisIndex = module.exports.selectorChartsHighlightXAxis = void 0;

var $9435d82b286a6f72$var$_extends2 = $9435d82b286a6f72$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8P0MD = parcelRequire("8P0MD");

var $i9lnd = parcelRequire("i9lnd");

var $iFmOZ = parcelRequire("iFmOZ");

var $8vGjK = parcelRequire("8vGjK");

var $iqlkh = parcelRequire("iqlkh");

var $b4u9m = parcelRequire("b4u9m");
/**
 * The return type of the `selectAxisHighlightWithValue`.
 */ function $9435d82b286a6f72$var$getAxisHighlight(lastInteractionUpdate, pointerHighlight, keyboardHighlight) {
    if (lastInteractionUpdate === 'pointer') {
        if (pointerHighlight) return [
            pointerHighlight
        ];
        if (keyboardHighlight) return [
            keyboardHighlight
        ];
    }
    if (lastInteractionUpdate === 'keyboard') {
        if (keyboardHighlight) return [
            keyboardHighlight
        ];
        if (pointerHighlight) return [
            pointerHighlight
        ];
    }
    return [];
}
const $9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight = (state)=>state.controlledCartesianAxisHighlight;
const $9435d82b286a6f72$var$selectAxisHighlight = (computedIndex, axis, controlledAxisItems, keyboardAxisItem, lastInteractionUpdate, isBrushSelectionActive)=>{
    if (isBrushSelectionActive) return [];
    if (controlledAxisItems !== undefined) return controlledAxisItems.filter((item)=>axis.axis[item.axisId] !== undefined).map((item)=>item);
    const pointerHighlight = computedIndex !== null && {
        axisId: axis.axisIds[0],
        dataIndex: computedIndex
    };
    const keyboardHighlight = keyboardAxisItem != null && keyboardAxisItem;
    return $9435d82b286a6f72$var$getAxisHighlight(lastInteractionUpdate, pointerHighlight, keyboardHighlight);
};
const $9435d82b286a6f72$var$selectorChartsHighlightXAxisIndex = module.exports.selectorChartsHighlightXAxisIndex = (0, $8P0MD.createSelectorMemoized)($iFmOZ.selectorChartsInteractionXAxisIndex, $i9lnd.selectorChartXAxis, $9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight, $8vGjK.selectorChartsKeyboardXAxisIndex, $iqlkh.selectorChartsLastInteraction, $b4u9m.selectorBrushShouldPreventAxisHighlight, $9435d82b286a6f72$var$selectAxisHighlight);
const $9435d82b286a6f72$var$selectorChartsHighlightYAxisIndex = module.exports.selectorChartsHighlightYAxisIndex = (0, $8P0MD.createSelectorMemoized)($iFmOZ.selectorChartsInteractionYAxisIndex, $i9lnd.selectorChartYAxis, $9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight, $8vGjK.selectorChartsKeyboardYAxisIndex, $iqlkh.selectorChartsLastInteraction, $b4u9m.selectorBrushShouldPreventAxisHighlight, $9435d82b286a6f72$var$selectAxisHighlight);
const $9435d82b286a6f72$var$selectAxisHighlightWithValue = (computedIndex, computedValue, axis, controlledAxisItems, keyboardAxisItem, lastInteractionUpdate, isBrushSelectionActive)=>{
    if (isBrushSelectionActive) return [];
    if (controlledAxisItems !== undefined) return controlledAxisItems.map((item)=>(0, $9435d82b286a6f72$var$_extends2.default)({}, item, {
            value: axis.axis[item.axisId]?.data?.[item.dataIndex]
        })).filter(({ value: value })=>value !== undefined);
    const pointerHighlight = computedValue != null && {
        axisId: axis.axisIds[0],
        value: computedValue
    };
    if (pointerHighlight && computedIndex != null) pointerHighlight.dataIndex = computedIndex;
    const keyboardValue = keyboardAxisItem != null && axis.axis[keyboardAxisItem.axisId]?.data?.[keyboardAxisItem.dataIndex];
    const keyboardHighlight = keyboardAxisItem != null && keyboardValue != null && (0, $9435d82b286a6f72$var$_extends2.default)({}, keyboardAxisItem, {
        value: keyboardValue
    });
    return $9435d82b286a6f72$var$getAxisHighlight(lastInteractionUpdate, pointerHighlight, keyboardHighlight);
};
const $9435d82b286a6f72$var$selectorChartsHighlightXAxisValue = module.exports.selectorChartsHighlightXAxisValue = (0, $8P0MD.createSelectorMemoized)($iFmOZ.selectorChartsInteractionXAxisIndex, $iFmOZ.selectorChartsInteractionXAxisValue, $i9lnd.selectorChartXAxis, $9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight, $8vGjK.selectorChartsKeyboardXAxisIndex, $iqlkh.selectorChartsLastInteraction, $b4u9m.selectorBrushShouldPreventAxisHighlight, $9435d82b286a6f72$var$selectAxisHighlightWithValue);
const $9435d82b286a6f72$var$selectorChartsHighlightYAxisValue = module.exports.selectorChartsHighlightYAxisValue = (0, $8P0MD.createSelectorMemoized)($iFmOZ.selectorChartsInteractionYAxisIndex, $iFmOZ.selectorChartsInteractionYAxisValue, $i9lnd.selectorChartYAxis, $9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight, $8vGjK.selectorChartsKeyboardYAxisIndex, $iqlkh.selectorChartsLastInteraction, $b4u9m.selectorBrushShouldPreventAxisHighlight, $9435d82b286a6f72$var$selectAxisHighlightWithValue);
/**
 * Get the scale of the axis with highlight if controlled. The default axis otherwise.
 * @param controlledItem The controlled value of highlightedAxis
 * @param axis The axis state after all the processing
 * @returns axis state
 */ const $9435d82b286a6f72$var$selectAxis = (axisItems, axis)=>{
    if (axisItems === undefined) return [
        axis.axis[axis.axisIds[0]]
    ];
    const filteredAxes = axisItems.map((item)=>axis.axis[item.axisId] ?? null).filter((item)=>item !== null);
    return filteredAxes;
};
const $9435d82b286a6f72$var$selectorChartsHighlightXAxis = module.exports.selectorChartsHighlightXAxis = (0, $8P0MD.createSelector)($9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight, $i9lnd.selectorChartXAxis, $9435d82b286a6f72$var$selectAxis);
const $9435d82b286a6f72$var$selectorChartsHighlightYAxis = module.exports.selectorChartsHighlightYAxis = (0, $8P0MD.createSelector)($9435d82b286a6f72$var$selectorChartControlledCartesianAxisHighlight, $i9lnd.selectorChartYAxis, $9435d82b286a6f72$var$selectAxis);

});
parcelRegister("8vGjK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsKeyboardYAxisIndex = module.exports.selectorChartsKeyboardXAxisIndex = module.exports.selectorChartsKeyboardItem = module.exports.selectorChartsItemIsFocused = module.exports.selectorChartsIsKeyboardNavigationEnabled = module.exports.selectorChartsHasFocusedItem = module.exports.selectorChartsFocusedItem = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $325pS = parcelRequire("325pS");

var $1k3ob = parcelRequire("1k3ob");

var $i9lnd = parcelRequire("i9lnd");
const $63220b5eb9b0be90$var$selectKeyboardNavigation = (state)=>state.keyboardNavigation;
const $63220b5eb9b0be90$var$selectorChartsItemIsFocused = module.exports.selectorChartsItemIsFocused = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectKeyboardNavigation, (keyboardNavigationState, item)=>keyboardNavigationState?.item != null && (0, $325pS.fastObjectShallowCompare)(keyboardNavigationState.item, item));
const $63220b5eb9b0be90$var$selectorChartsHasFocusedItem = module.exports.selectorChartsHasFocusedItem = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectKeyboardNavigation, (keyboardNavigationState)=>keyboardNavigationState?.item != null);
const $63220b5eb9b0be90$var$selectorChartsFocusedItem = module.exports.selectorChartsFocusedItem = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectKeyboardNavigation, (keyboardNavigationState)=>keyboardNavigationState?.item ?? null);
const $63220b5eb9b0be90$var$selectorChartsIsKeyboardNavigationEnabled = module.exports.selectorChartsIsKeyboardNavigationEnabled = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectKeyboardNavigation, (keyboardNavigationState)=>!!keyboardNavigationState?.enableKeyboardNavigation);
/**
 * Selectors to override highlight behavior.
 */ const $63220b5eb9b0be90$var$createSelectAxisHighlight = (direction)=>(item, axis, series)=>{
        if (item == null || !('dataIndex' in item) || item.dataIndex === undefined) return undefined;
        const seriesConfig = series[item.type]?.series[item.seriesId];
        if (!seriesConfig) return undefined;
        let axisId = direction === 'x' ? 'xAxisId' in seriesConfig && seriesConfig.xAxisId : 'yAxisId' in seriesConfig && seriesConfig.yAxisId;
        if (axisId === undefined || axisId === false) axisId = axis.axisIds[0];
        return {
            axisId: axisId,
            dataIndex: item.dataIndex
        };
    };
const $63220b5eb9b0be90$var$selectorChartsKeyboardXAxisIndex = module.exports.selectorChartsKeyboardXAxisIndex = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectorChartsFocusedItem, $i9lnd.selectorChartXAxis, $1k3ob.selectorChartSeriesProcessed, $63220b5eb9b0be90$var$createSelectAxisHighlight('x'));
const $63220b5eb9b0be90$var$selectorChartsKeyboardYAxisIndex = module.exports.selectorChartsKeyboardYAxisIndex = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectorChartsFocusedItem, $i9lnd.selectorChartYAxis, $1k3ob.selectorChartSeriesProcessed, $63220b5eb9b0be90$var$createSelectAxisHighlight('y'));
const $63220b5eb9b0be90$var$selectorChartsKeyboardItem = module.exports.selectorChartsKeyboardItem = (0, $8P0MD.createSelector)($63220b5eb9b0be90$var$selectKeyboardNavigation, function selectorChartsKeyboardItem(keyboardState) {
    if (keyboardState?.item == null) return null;
    const { type: type, seriesId: seriesId } = keyboardState.item;
    if (type === undefined || seriesId === undefined) return null;
    return keyboardState.item;
});

});

parcelRegister("b4u9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j5K8f = parcelRequire("j5K8f");
Object.keys($j5K8f).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $j5K8f[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j5K8f[key];
        }
    });
});

var $9z8Rg = parcelRequire("9z8Rg");
Object.keys($9z8Rg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9z8Rg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9z8Rg[key];
        }
    });
});

var $2cKKi = parcelRequire("2cKKi");
Object.keys($2cKKi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2cKKi[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2cKKi[key];
        }
    });
});

});
parcelRegister("j5K8f", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $de6244cf38851966$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $de6244cf38851966$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartBrush = void 0;

var $de6244cf38851966$var$_extends2 = $de6244cf38851966$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $de6244cf38851966$var$_useEventCallback = $de6244cf38851966$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $de6244cf38851966$var$React = $de6244cf38851966$require$_interopRequireWildcard((parcelRequire("acw62")));

var $de6244cf38851966$var$_useEnhancedEffect = $de6244cf38851966$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $g34sa = parcelRequire("g34sa");

var $2cKKi = parcelRequire("2cKKi");
const $de6244cf38851966$var$useChartBrush = ({ store: store, svgRef: svgRef, instance: instance, params: params })=>{
    const isEnabled = store.use($2cKKi.selectorIsBrushEnabled);
    (0, $de6244cf38851966$var$_useEnhancedEffect.default)(()=>{
        store.set('brush', (0, $de6244cf38851966$var$_extends2.default)({}, store.state.brush, {
            enabled: params.brushConfig.enabled,
            preventTooltip: params.brushConfig.preventTooltip,
            preventHighlight: params.brushConfig.preventHighlight
        }));
    }, [
        store,
        params.brushConfig.enabled,
        params.brushConfig.preventTooltip,
        params.brushConfig.preventHighlight
    ]);
    const setBrushCoordinates = (0, $de6244cf38851966$var$_useEventCallback.default)(function setBrushCoordinates(point) {
        store.set('brush', (0, $de6244cf38851966$var$_extends2.default)({}, store.state.brush, {
            start: store.state.brush.start ?? point,
            current: point
        }));
    });
    const clearBrush = (0, $de6244cf38851966$var$_useEventCallback.default)(function clearBrush() {
        store.set('brush', (0, $de6244cf38851966$var$_extends2.default)({}, store.state.brush, {
            start: null,
            current: null
        }));
    });
    const setZoomBrushEnabled = (0, $de6244cf38851966$var$_useEventCallback.default)(function setZoomBrushEnabled(enabled) {
        if (store.state.brush.isZoomBrushEnabled === enabled) return;
        store.set('brush', (0, $de6244cf38851966$var$_extends2.default)({}, store.state.brush, {
            isZoomBrushEnabled: enabled
        }));
    });
    $de6244cf38851966$var$React.useEffect(()=>{
        const element = svgRef.current;
        if (element === null || !isEnabled) return ()=>{};
        const handleBrushStart = (event)=>{
            if (event.detail.target?.closest('[data-charts-zoom-slider]')) return;
            const point = (0, $g34sa.getSVGPoint)(element, {
                clientX: event.detail.initialCentroid.x,
                clientY: event.detail.initialCentroid.y
            });
            setBrushCoordinates(point);
        };
        const handleBrush = (event)=>{
            const currentPoint = (0, $g34sa.getSVGPoint)(element, {
                clientX: event.detail.centroid.x,
                clientY: event.detail.centroid.y
            });
            setBrushCoordinates(currentPoint);
        };
        const brushStartHandler = instance.addInteractionListener('brushStart', handleBrushStart);
        const brushHandler = instance.addInteractionListener('brush', handleBrush);
        const brushCancelHandler = instance.addInteractionListener('brushCancel', clearBrush);
        const brushEndHandler = instance.addInteractionListener('brushEnd', clearBrush);
        return ()=>{
            brushStartHandler.cleanup();
            brushHandler.cleanup();
            brushEndHandler.cleanup();
            brushCancelHandler.cleanup();
        };
    }, [
        svgRef,
        instance,
        store,
        clearBrush,
        setBrushCoordinates,
        isEnabled
    ]);
    return {
        instance: {
            setBrushCoordinates: setBrushCoordinates,
            clearBrush: clearBrush,
            setZoomBrushEnabled: setZoomBrushEnabled
        }
    };
};
module.exports.useChartBrush = $de6244cf38851966$var$useChartBrush;
$de6244cf38851966$var$useChartBrush.params = {
    brushConfig: true
};
$de6244cf38851966$var$useChartBrush.getDefaultizedParams = ({ params: params })=>{
    return (0, $de6244cf38851966$var$_extends2.default)({}, params, {
        brushConfig: {
            enabled: params?.brushConfig?.enabled ?? false,
            preventTooltip: params?.brushConfig?.preventTooltip ?? true,
            preventHighlight: params?.brushConfig?.preventHighlight ?? true
        }
    });
};
$de6244cf38851966$var$useChartBrush.getInitialState = (params)=>{
    return {
        brush: {
            enabled: params.brushConfig.enabled,
            isZoomBrushEnabled: false,
            preventTooltip: params.brushConfig.preventTooltip,
            preventHighlight: params.brushConfig.preventHighlight,
            start: null,
            current: null
        }
    };
};

});
parcelRegister("2cKKi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorIsBrushSelectionActive = module.exports.selectorIsBrushEnabled = module.exports.selectorBrushState = module.exports.selectorBrushStartY = module.exports.selectorBrushStartX = module.exports.selectorBrushStart = module.exports.selectorBrushShouldPreventTooltip = module.exports.selectorBrushShouldPreventAxisHighlight = module.exports.selectorBrushCurrentY = module.exports.selectorBrushCurrentX = module.exports.selectorBrushCurrent = module.exports.selectorBrushConfigZoom = module.exports.selectorBrushConfigNoZoom = module.exports.selectorBrushConfig = module.exports.selectorBrush = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $i9lnd = parcelRequire("i9lnd");

var $1k3ob = parcelRequire("1k3ob");
const $19b0f675ddff76d0$var$selectorBrush = (state)=>state.brush;
module.exports.selectorBrush = $19b0f675ddff76d0$var$selectorBrush;
const $19b0f675ddff76d0$var$selectorBrushStart = module.exports.selectorBrushStart = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.start);
const $19b0f675ddff76d0$var$selectorBrushCurrent = module.exports.selectorBrushCurrent = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.current);
const $19b0f675ddff76d0$var$selectorBrushStartX = module.exports.selectorBrushStartX = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.start?.x ?? null);
const $19b0f675ddff76d0$var$selectorBrushStartY = module.exports.selectorBrushStartY = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.start?.y ?? null);
const $19b0f675ddff76d0$var$selectorBrushCurrentX = module.exports.selectorBrushCurrentX = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.current?.x ?? null);
const $19b0f675ddff76d0$var$selectorBrushCurrentY = module.exports.selectorBrushCurrentY = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.current?.y ?? null);
const $19b0f675ddff76d0$var$selectorBrushState = module.exports.selectorBrushState = (0, $8P0MD.createSelectorMemoized)($19b0f675ddff76d0$var$selectorBrushStartX, $19b0f675ddff76d0$var$selectorBrushStartY, $19b0f675ddff76d0$var$selectorBrushCurrentX, $19b0f675ddff76d0$var$selectorBrushCurrentY, (startX, startY, currentX, currentY)=>{
    if (startX === null || startY === null || currentX === null || currentY === null) return null;
    return {
        start: {
            x: startX,
            y: startY
        },
        current: {
            x: currentX,
            y: currentY
        }
    };
});
const $19b0f675ddff76d0$var$selectorBrushConfigNoZoom = module.exports.selectorBrushConfigNoZoom = (0, $8P0MD.createSelector)($1k3ob.selectorChartSeriesProcessed, (series)=>{
    let hasHorizontal = false;
    let isBothDirections = false;
    if (series) Object.entries(series).forEach(([seriesType, seriesData])=>{
        if (Object.values(seriesData.series).some((s)=>s.layout === 'horizontal')) hasHorizontal = true;
        if (seriesType === 'scatter' && seriesData.seriesOrder.length > 0) isBothDirections = true;
    });
    if (isBothDirections) return 'xy';
    if (hasHorizontal) return 'y';
    return 'x';
});
const $19b0f675ddff76d0$var$selectorBrushConfigZoom = module.exports.selectorBrushConfigZoom = (0, $8P0MD.createSelector)($i9lnd.selectorChartZoomOptionsLookup, function selectorBrushConfigZoom(optionsLookup) {
    let hasX = false;
    let hasY = false;
    Object.values(optionsLookup).forEach((options)=>{
        if (options.axisDirection === 'y') hasY = true;
        if (options.axisDirection === 'x') hasX = true;
    });
    if (hasX && hasY) return 'xy';
    if (hasY) return 'y';
    if (hasX) return 'x';
    return null;
});
const $19b0f675ddff76d0$var$selectorBrushConfig = module.exports.selectorBrushConfig = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrushConfigNoZoom, $19b0f675ddff76d0$var$selectorBrushConfigZoom, (configNoZoom, configZoom)=>configZoom ?? configNoZoom);
const $19b0f675ddff76d0$var$selectorIsBrushEnabled = module.exports.selectorIsBrushEnabled = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, (brush)=>brush?.enabled || brush?.isZoomBrushEnabled);
const $19b0f675ddff76d0$var$selectorIsBrushSelectionActive = module.exports.selectorIsBrushSelectionActive = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorIsBrushEnabled, $19b0f675ddff76d0$var$selectorBrush, (isBrushEnabled, brush)=>{
    return isBrushEnabled && brush?.start !== null && brush?.current !== null;
});
const $19b0f675ddff76d0$var$selectorBrushShouldPreventAxisHighlight = module.exports.selectorBrushShouldPreventAxisHighlight = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, $19b0f675ddff76d0$var$selectorIsBrushSelectionActive, (brush, isBrushSelectionActive)=>isBrushSelectionActive && brush?.preventHighlight);
const $19b0f675ddff76d0$var$selectorBrushShouldPreventTooltip = module.exports.selectorBrushShouldPreventTooltip = (0, $8P0MD.createSelector)($19b0f675ddff76d0$var$selectorBrush, $19b0f675ddff76d0$var$selectorIsBrushSelectionActive, (brush, isBrushSelectionActive)=>isBrushSelectionActive && brush?.preventTooltip);

});


parcelRegister("9z8Rg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("3pq3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartPreviewYScales = module.exports.selectorChartPreviewXScales = module.exports.selectorChartPreviewComputedYAxis = module.exports.selectorChartPreviewComputedXAxis = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $6ahCy = parcelRequire("6ahCy");

var $1k3ob = parcelRequire("1k3ob");

var $8u8iR = parcelRequire("8u8iR");

var $i9lnd = parcelRequire("i9lnd");

var $eWN1p = parcelRequire("eWN1p");

var $2xVLi = parcelRequire("2xVLi");

var $kOBDb = parcelRequire("kOBDb");

var $Gls7F = parcelRequire("Gls7F");

var $2UPWB = parcelRequire("2UPWB");
function $27b7eb058a6b8f38$var$createPreviewDrawingArea(axisDirection, mainChartDrawingArea) {
    return axisDirection === 'x' ? {
        left: 0,
        top: 0,
        width: mainChartDrawingArea.width,
        height: $2xVLi.ZOOM_SLIDER_PREVIEW_SIZE,
        right: mainChartDrawingArea.width,
        bottom: $2xVLi.ZOOM_SLIDER_PREVIEW_SIZE
    } : {
        left: 0,
        top: 0,
        width: $2xVLi.ZOOM_SLIDER_PREVIEW_SIZE,
        height: mainChartDrawingArea.height,
        right: $2xVLi.ZOOM_SLIDER_PREVIEW_SIZE,
        bottom: mainChartDrawingArea.height
    };
}
const $27b7eb058a6b8f38$var$selectorChartPreviewXScales = module.exports.selectorChartPreviewXScales = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawXAxis, $eWN1p.selectorChartDrawingArea, $i9lnd.selectorChartZoomOptionsLookup, $i9lnd.selectorChartNormalizedXScales, function selectorChartPreviewXScales(xAxes, chartDrawingArea, zoomOptions, normalizedXScales, axisId) {
    const hasAxis = xAxes?.some((axis)=>axis.id === axisId);
    const drawingArea = $27b7eb058a6b8f38$var$createPreviewDrawingArea(hasAxis ? 'x' : 'y', chartDrawingArea);
    const options = zoomOptions[axisId];
    const scales = {};
    xAxes?.forEach((eachAxis)=>{
        const axis = eachAxis;
        const scale = normalizedXScales[axis.id].copy();
        const range = (0, $kOBDb.getRange)(drawingArea, 'x', axis);
        const zoomedRange = (0, $Gls7F.zoomScaleRange)(range, [
            options.minStart,
            options.maxEnd
        ]);
        scale.range(zoomedRange);
        scales[axis.id] = scale;
    });
    return scales;
});
const $27b7eb058a6b8f38$var$selectorChartPreviewComputedXAxis = module.exports.selectorChartPreviewComputedXAxis = (0, $8P0MD.createSelectorMemoized)($1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $i9lnd.selectorChartZoomOptionsLookup, $eWN1p.selectorChartDrawingArea, $27b7eb058a6b8f38$var$selectorChartPreviewXScales, $i9lnd.selectorChartXAxisWithDomains, (formattedSeries, seriesConfig, zoomOptions, chartDrawingArea, scales, { axes: axes, domains: domains }, axisId)=>{
    const hasAxis = axes?.some((axis)=>axis.id === axisId);
    const drawingArea = $27b7eb058a6b8f38$var$createPreviewDrawingArea(hasAxis ? 'x' : 'y', chartDrawingArea);
    const options = zoomOptions[axisId];
    const zoomMap = new Map([
        [
            axisId,
            {
                axisId: axisId,
                start: options.minStart,
                end: options.maxEnd
            }
        ]
    ]);
    const computedAxes = (0, $8u8iR.computeAxisValue)({
        scales: scales,
        drawingArea: drawingArea,
        formattedSeries: formattedSeries,
        axis: axes,
        seriesConfig: seriesConfig,
        axisDirection: 'x',
        zoomMap: zoomMap,
        domains: domains
    });
    if (computedAxes.axis[axisId]) return {
        [axisId]: computedAxes.axis[axisId]
    };
    return computedAxes.axis;
});
const $27b7eb058a6b8f38$var$selectorChartPreviewYScales = module.exports.selectorChartPreviewYScales = (0, $8P0MD.createSelectorMemoized)($6ahCy.selectorChartRawYAxis, $eWN1p.selectorChartDrawingArea, $i9lnd.selectorChartZoomOptionsLookup, $i9lnd.selectorChartNormalizedYScales, function selectorChartPreviewYScales(yAxes, chartDrawingArea, zoomOptions, normalizedYScales, axisId) {
    const hasAxis = yAxes?.some((axis)=>axis.id === axisId);
    const drawingArea = $27b7eb058a6b8f38$var$createPreviewDrawingArea(hasAxis ? 'y' : 'x', chartDrawingArea);
    const options = zoomOptions[axisId];
    const scales = {};
    yAxes?.forEach((eachAxis)=>{
        const axis = eachAxis;
        const scale = normalizedYScales[axis.id].copy();
        let range = (0, $kOBDb.getRange)(drawingArea, 'y', axis);
        if ((0, $2UPWB.isOrdinalScale)(scale)) range = range.reverse();
        const zoomedRange = (0, $Gls7F.zoomScaleRange)(range, [
            options.minStart,
            options.maxEnd
        ]);
        scale.range(zoomedRange);
        scales[axis.id] = scale;
    });
    return scales;
});
const $27b7eb058a6b8f38$var$selectorChartPreviewComputedYAxis = module.exports.selectorChartPreviewComputedYAxis = (0, $8P0MD.createSelectorMemoized)($1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, $i9lnd.selectorChartZoomOptionsLookup, $eWN1p.selectorChartDrawingArea, $27b7eb058a6b8f38$var$selectorChartPreviewYScales, $i9lnd.selectorChartYAxisWithDomains, (formattedSeries, seriesConfig, zoomOptions, chartDrawingArea, scales, { axes: axes, domains: domains }, axisId)=>{
    const hasAxis = axes?.some((axis)=>axis.id === axisId);
    const drawingArea = $27b7eb058a6b8f38$var$createPreviewDrawingArea(hasAxis ? 'y' : 'x', chartDrawingArea);
    const options = zoomOptions[axisId];
    const zoomMap = new Map([
        [
            axisId,
            {
                axisId: axisId,
                start: options.minStart,
                end: options.maxEnd
            }
        ]
    ]);
    const computedAxes = (0, $8u8iR.computeAxisValue)({
        scales: scales,
        drawingArea: drawingArea,
        formattedSeries: formattedSeries,
        axis: axes,
        seriesConfig: seriesConfig,
        axisDirection: 'y',
        zoomMap: zoomMap,
        domains: domains
    });
    if (computedAxes.axis[axisId]) return {
        [axisId]: computedAxes.axis[axisId]
    };
    return computedAxes.axis;
});

});

parcelRegister("8fLr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("d8Csh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9909da1d7c41378c$var$_exportNames = {
    useChartTooltip: true
};
Object.defineProperty(module.exports, "useChartTooltip", {
    enumerable: true,
    get: function() {
        return $de4eg.useChartTooltip;
    }
});

var $de4eg = parcelRequire("de4eg");

var $g1Mb3 = parcelRequire("g1Mb3");
Object.keys($g1Mb3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9909da1d7c41378c$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $g1Mb3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g1Mb3[key];
        }
    });
});

});
parcelRegister("de4eg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a0fdcf4baca8dca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartTooltip = void 0;

var $9a0fdcf4baca8dca$var$_extends2 = $9a0fdcf4baca8dca$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d7LOv = parcelRequire("d7LOv");

var $9a0fdcf4baca8dca$var$_useEventCallback = $9a0fdcf4baca8dca$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9a0fdcf4baca8dca$var$_useEnhancedEffect = $9a0fdcf4baca8dca$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $325pS = parcelRequire("325pS");
const $9a0fdcf4baca8dca$var$useChartTooltip = ({ store: store, params: params })=>{
    (0, $d7LOv.useAssertModelConsistency)({
        warningPrefix: 'MUI X Charts',
        componentName: 'Chart',
        propName: 'tooltipItem',
        controlled: params.tooltipItem,
        defaultValue: null
    });
    (0, $9a0fdcf4baca8dca$var$_useEnhancedEffect.default)(()=>{
        if (store.state.tooltip.item !== params.tooltipItem) store.set('tooltip', (0, $9a0fdcf4baca8dca$var$_extends2.default)({}, store.state.tooltip, {
            item: params.tooltipItem
        }));
    }, [
        store,
        params.tooltipItem
    ]);
    const removeTooltipItem = (0, $9a0fdcf4baca8dca$var$_useEventCallback.default)(function removeTooltipItem(itemToRemove) {
        const prevItem = store.state.tooltip.item;
        if (prevItem === null) return; // Already null, nothing to do
        if (!itemToRemove || (0, $325pS.fastObjectShallowCompare)(prevItem, itemToRemove)) {
            // Remove the item is either
            // - no item provided, so we unconditionally remove it
            // - the provided item matches the current one
            params.onTooltipItemChange?.(null);
            if (!store.state.tooltip.itemIsControlled) store.set('tooltip', (0, $9a0fdcf4baca8dca$var$_extends2.default)({}, store.state.tooltip, {
                item: null
            }));
            return;
        }
    });
    const setTooltipItem = (0, $9a0fdcf4baca8dca$var$_useEventCallback.default)(function setTooltipItem(newItem) {
        if (!(0, $325pS.fastObjectShallowCompare)(store.state.tooltip.item, newItem)) {
            params.onTooltipItemChange?.(newItem);
            if (!store.state.tooltip.itemIsControlled) store.set('tooltip', (0, $9a0fdcf4baca8dca$var$_extends2.default)({}, store.state.tooltip, {
                item: newItem
            }));
        }
    });
    return {
        instance: {
            setTooltipItem: setTooltipItem,
            removeTooltipItem: removeTooltipItem
        }
    };
};
module.exports.useChartTooltip = $9a0fdcf4baca8dca$var$useChartTooltip;
$9a0fdcf4baca8dca$var$useChartTooltip.getInitialState = (params)=>({
        tooltip: {
            itemIsControlled: params.tooltipItem !== undefined,
            item: params.tooltipItem ?? null
        }
    });
$9a0fdcf4baca8dca$var$useChartTooltip.params = {
    tooltipItem: true,
    onTooltipItemChange: true
};

});

parcelRegister("g1Mb3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsTooltipPointerItemIsDefined = module.exports.selectorChartsTooltipPointerItem = module.exports.selectorChartsTooltipItemPosition = module.exports.selectorChartsTooltipItemIsDefined = module.exports.selectorChartsTooltipItem = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $1k3ob = parcelRequire("1k3ob");

var $i9lnd = parcelRequire("i9lnd");

var $cp50o = parcelRequire("cp50o");

var $iqlkh = parcelRequire("iqlkh");

var $kOdtM = parcelRequire("kOdtM");

var $8e9Tj = parcelRequire("8e9Tj");

var $50bTE = parcelRequire("50bTE");
const $bab21c5cfa0d153c$var$selectTooltip = (state)=>state.tooltip;
const $bab21c5cfa0d153c$var$selectorChartsTooltipPointerItem = module.exports.selectorChartsTooltipPointerItem = (0, $8P0MD.createSelector)($bab21c5cfa0d153c$var$selectTooltip, (tooltip)=>tooltip?.item ?? null);
const $bab21c5cfa0d153c$var$selectorChartsTooltipPointerItemIsDefined = module.exports.selectorChartsTooltipPointerItemIsDefined = (0, $8P0MD.createSelector)($bab21c5cfa0d153c$var$selectorChartsTooltipPointerItem, (item)=>item !== null);
const $bab21c5cfa0d153c$var$selectorChartsTooltipItem = module.exports.selectorChartsTooltipItem = (0, $8P0MD.createSelector)($iqlkh.selectorChartsLastInteraction, $bab21c5cfa0d153c$var$selectorChartsTooltipPointerItem, $cp50o.selectorChartsKeyboardItem, (lastInteraction, pointerItem, keyboardItem)=>lastInteraction === 'keyboard' ? keyboardItem : pointerItem ?? null);
const $bab21c5cfa0d153c$var$selectorChartsTooltipItemIsDefined = module.exports.selectorChartsTooltipItemIsDefined = (0, $8P0MD.createSelector)($iqlkh.selectorChartsLastInteraction, $bab21c5cfa0d153c$var$selectorChartsTooltipPointerItemIsDefined, $cp50o.selectorChartsHasFocusedItem, (lastInteraction, pointerItemIsDefined, keyboardItemIsDefined)=>lastInteraction === 'keyboard' ? keyboardItemIsDefined : pointerItemIsDefined);
const $bab21c5cfa0d153c$var$selectorChartsTooltipAxisConfig = (0, $8P0MD.createSelectorMemoized)($bab21c5cfa0d153c$var$selectorChartsTooltipItem, $i9lnd.selectorChartXAxis, $i9lnd.selectorChartYAxis, $50bTE.selectorChartRotationAxis, $50bTE.selectorChartRadiusAxis, $1k3ob.selectorChartSeriesProcessed, function selectorChartsTooltipAxisConfig(identifier, { axis: xAxis, axisIds: xAxisIds }, { axis: yAxis, axisIds: yAxisIds }, rotationAxes, radiusAxes, series) {
    if (!identifier) return {};
    const itemSeries = series[identifier.type]?.series[identifier.seriesId];
    if (!itemSeries) return {};
    const axesConfig = {
        rotationAxes: rotationAxes,
        radiusAxes: radiusAxes
    };
    const xAxisId = (0, $8e9Tj.isCartesianSeries)(itemSeries) ? itemSeries.xAxisId ?? xAxisIds[0] : undefined;
    const yAxisId = (0, $8e9Tj.isCartesianSeries)(itemSeries) ? itemSeries.yAxisId ?? yAxisIds[0] : undefined;
    if (xAxisId !== undefined) axesConfig.x = xAxis[xAxisId];
    if (yAxisId !== undefined) axesConfig.y = yAxis[yAxisId];
    return axesConfig;
});
const $bab21c5cfa0d153c$var$selectorChartsTooltipItemPosition = module.exports.selectorChartsTooltipItemPosition = (0, $8P0MD.createSelectorMemoized)($bab21c5cfa0d153c$var$selectorChartsTooltipItem, $kOdtM.selectorChartDrawingArea, $1k3ob.selectorChartSeriesConfig, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesLayout, $bab21c5cfa0d153c$var$selectorChartsTooltipAxisConfig, function selectorChartsTooltipItemPosition(identifier, drawingArea, seriesConfig, series, seriesLayout, axesConfig, placement = 'top') {
    if (!identifier) return null;
    const itemSeries = series[identifier.type]?.series[identifier.seriesId];
    if (!itemSeries) return null;
    return seriesConfig[itemSeries.type].tooltipItemPositionGetter?.({
        series: series,
        seriesLayout: seriesLayout,
        drawingArea: drawingArea,
        axesConfig: axesConfig,
        identifier: identifier,
        placement: placement
    }) ?? null;
});

});
parcelRegister("cp50o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $907bb3c5f6b89d84$var$_exportNames = {
    useChartKeyboardNavigation: true
};
Object.defineProperty(module.exports, "useChartKeyboardNavigation", {
    enumerable: true,
    get: function() {
        return $dGTG3.useChartKeyboardNavigation;
    }
});

var $dGTG3 = parcelRequire("dGTG3");

var $8vGjK = parcelRequire("8vGjK");
Object.keys($8vGjK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($907bb3c5f6b89d84$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8vGjK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8vGjK[key];
        }
    });
});

});
parcelRegister("dGTG3", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9f7a62f524fcf88b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9f7a62f524fcf88b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartKeyboardNavigation = void 0;

var $9f7a62f524fcf88b$var$_extends2 = $9f7a62f524fcf88b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9f7a62f524fcf88b$var$React = $9f7a62f524fcf88b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9f7a62f524fcf88b$var$_useEventCallback = $9f7a62f524fcf88b$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9f7a62f524fcf88b$var$_useEnhancedEffect = $9f7a62f524fcf88b$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $6kle2 = parcelRequire("6kle2");
const $9f7a62f524fcf88b$var$useChartKeyboardNavigation = ({ params: params, store: store, svgRef: svgRef })=>{
    const removeFocus = (0, $9f7a62f524fcf88b$var$_useEventCallback.default)(function removeFocus() {
        if (store.state.keyboardNavigation.item !== null) store.set('keyboardNavigation', (0, $9f7a62f524fcf88b$var$_extends2.default)({}, store.state.keyboardNavigation, {
            item: null
        }));
    });
    $9f7a62f524fcf88b$var$React.useEffect(()=>{
        const element = svgRef.current;
        if (!element || !params.enableKeyboardNavigation) return undefined;
        function keyboardHandler(event) {
            let newFocusedItem = store.state.keyboardNavigation.item;
            let seriesType = newFocusedItem?.type;
            if (!seriesType) {
                seriesType = Object.keys((0, $6kle2.selectorChartDefaultizedSeries)(store.state)).find((key)=>store.state.series.seriesConfig[key] !== undefined);
                if (seriesType === undefined) return;
            }
            const calculateFocusedItem = store.state.series.seriesConfig[seriesType]?.keyboardFocusHandler?.(event);
            if (!calculateFocusedItem) return;
            newFocusedItem = calculateFocusedItem(newFocusedItem, store.state);
            if (newFocusedItem !== store.state.keyboardNavigation.item) {
                event.preventDefault();
                store.update((0, $9f7a62f524fcf88b$var$_extends2.default)({}, store.state.highlight && {
                    highlight: (0, $9f7a62f524fcf88b$var$_extends2.default)({}, store.state.highlight, {
                        lastUpdate: 'keyboard'
                    })
                }, store.state.interaction && {
                    interaction: (0, $9f7a62f524fcf88b$var$_extends2.default)({}, store.state.interaction, {
                        lastUpdate: 'keyboard'
                    })
                }, {
                    keyboardNavigation: (0, $9f7a62f524fcf88b$var$_extends2.default)({}, store.state.keyboardNavigation, {
                        item: newFocusedItem
                    })
                }));
            }
        }
        element.addEventListener('keydown', keyboardHandler);
        element.addEventListener('blur', removeFocus);
        return ()=>{
            element.removeEventListener('keydown', keyboardHandler);
            element.removeEventListener('blur', removeFocus);
        };
    }, [
        svgRef,
        removeFocus,
        params.enableKeyboardNavigation,
        store
    ]);
    (0, $9f7a62f524fcf88b$var$_useEnhancedEffect.default)(()=>{
        if (store.state.keyboardNavigation.enableKeyboardNavigation !== params.enableKeyboardNavigation) store.set('keyboardNavigation', (0, $9f7a62f524fcf88b$var$_extends2.default)({}, store.state.keyboardNavigation, {
            enableKeyboardNavigation: !!params.enableKeyboardNavigation
        }));
    }, [
        store,
        params.enableKeyboardNavigation
    ]);
    return {};
};
module.exports.useChartKeyboardNavigation = $9f7a62f524fcf88b$var$useChartKeyboardNavigation;
$9f7a62f524fcf88b$var$useChartKeyboardNavigation.getInitialState = (params)=>({
        keyboardNavigation: {
            item: null,
            enableKeyboardNavigation: !!params.enableKeyboardNavigation
        }
    });
$9f7a62f524fcf88b$var$useChartKeyboardNavigation.params = {
    enableKeyboardNavigation: true
};

});


parcelRegister("50bTE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDrawingAreaCenter = $3a462e40fee6bfa6$var$getDrawingAreaCenter;
module.exports.selectorChartRotationAxis = module.exports.selectorChartRawRotationAxis = module.exports.selectorChartRawRadiusAxis = module.exports.selectorChartRadiusAxis = module.exports.selectorChartPolarCenter = module.exports.selectorChartPolarAxisState = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $eWN1p = parcelRequire("eWN1p");

var $1k3ob = parcelRequire("1k3ob");

var $g27qu = parcelRequire("g27qu");
const $3a462e40fee6bfa6$var$selectorChartPolarAxisState = (state)=>state.polarAxis;
module.exports.selectorChartPolarAxisState = $3a462e40fee6bfa6$var$selectorChartPolarAxisState;
const $3a462e40fee6bfa6$var$selectorChartRawRotationAxis = module.exports.selectorChartRawRotationAxis = (0, $8P0MD.createSelector)($3a462e40fee6bfa6$var$selectorChartPolarAxisState, (axis)=>axis?.rotation);
const $3a462e40fee6bfa6$var$selectorChartRawRadiusAxis = module.exports.selectorChartRawRadiusAxis = (0, $8P0MD.createSelector)($3a462e40fee6bfa6$var$selectorChartPolarAxisState, (axis)=>axis?.radius);
/**
 * The only interesting selectors that merge axis data and zoom if provided.
 */ const $3a462e40fee6bfa6$var$selectorChartRotationAxis = module.exports.selectorChartRotationAxis = (0, $8P0MD.createSelectorMemoized)($3a462e40fee6bfa6$var$selectorChartRawRotationAxis, $eWN1p.selectorChartDrawingArea, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, (axis, drawingArea, formattedSeries, seriesConfig)=>(0, $g27qu.computeAxisValue)({
        drawingArea: drawingArea,
        formattedSeries: formattedSeries,
        axis: axis,
        seriesConfig: seriesConfig,
        axisDirection: 'rotation'
    }));
const $3a462e40fee6bfa6$var$selectorChartRadiusAxis = module.exports.selectorChartRadiusAxis = (0, $8P0MD.createSelectorMemoized)($3a462e40fee6bfa6$var$selectorChartRawRadiusAxis, $eWN1p.selectorChartDrawingArea, $1k3ob.selectorChartSeriesProcessed, $1k3ob.selectorChartSeriesConfig, (axis, drawingArea, formattedSeries, seriesConfig)=>(0, $g27qu.computeAxisValue)({
        drawingArea: drawingArea,
        formattedSeries: formattedSeries,
        axis: axis,
        seriesConfig: seriesConfig,
        axisDirection: 'radius'
    }));
function $3a462e40fee6bfa6$var$getDrawingAreaCenter(drawingArea) {
    return {
        cx: drawingArea.left + drawingArea.width / 2,
        cy: drawingArea.top + drawingArea.height / 2
    };
}
const $3a462e40fee6bfa6$var$selectorChartPolarCenter = module.exports.selectorChartPolarCenter = (0, $8P0MD.createSelectorMemoized)($eWN1p.selectorChartDrawingArea, $3a462e40fee6bfa6$var$getDrawingAreaCenter);

});
parcelRegister("g27qu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bac297eef107321c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeAxisValue = $bac297eef107321c$var$computeAxisValue;

var $bac297eef107321c$var$_extends2 = $bac297eef107321c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $lXwwj = parcelRequire("lXwwj");

var $jTrR8 = parcelRequire("jTrR8");

var $6PfPa = parcelRequire("6PfPa");

var $ar6SO = parcelRequire("ar6SO");

var $QqBso = parcelRequire("QqBso");

var $59kTS = parcelRequire("59kTS");

var $1hcZZ = parcelRequire("1hcZZ");

var $l1PKY = parcelRequire("l1PKY");

var $6lJB1 = parcelRequire("6lJB1");
function $bac297eef107321c$var$getRange(drawingArea, axisDirection, axis) {
    if (axisDirection === 'rotation') {
        if (axis.scaleType === 'point') {
            const angles = [
                (0, $1hcZZ.deg2rad)(axis.startAngle, 0),
                (0, $1hcZZ.deg2rad)(axis.endAngle, 2 * Math.PI)
            ];
            const diff = angles[1] - angles[0];
            if (diff > Math.PI * 2 - 0.1) // If we cover a full circle, we remove a slice to avoid having data point at the same place.
            angles[1] -= diff / axis.data.length;
            return angles;
        }
        return [
            (0, $1hcZZ.deg2rad)(axis.startAngle, 0),
            (0, $1hcZZ.deg2rad)(axis.endAngle, 2 * Math.PI)
        ];
    }
    return [
        0,
        Math.min(drawingArea.height, drawingArea.width) / 2
    ];
}
const $bac297eef107321c$var$DEFAULT_CATEGORY_GAP_RATIO = 0.2;
const $bac297eef107321c$var$DEFAULT_BAR_GAP_RATIO = 0.1;
function $bac297eef107321c$var$computeAxisValue({ drawingArea: drawingArea, formattedSeries: formattedSeries, axis: allAxis, seriesConfig: seriesConfig, axisDirection: axisDirection }) {
    if (allAxis === undefined) return {
        axis: {},
        axisIds: []
    };
    const axisIdsTriggeringTooltip = (0, $l1PKY.getAxisTriggerTooltip)(axisDirection, seriesConfig, formattedSeries, allAxis[0].id);
    const completeAxis = {};
    allAxis.forEach((eachAxis, axisIndex)=>{
        const axis = eachAxis;
        const range = $bac297eef107321c$var$getRange(drawingArea, axisDirection, axis);
        const [minData, maxData] = (0, $59kTS.getAxisExtremum)(axis, axisDirection, seriesConfig, axisIndex, formattedSeries);
        const triggerTooltip = !axis.ignoreTooltip && axisIdsTriggeringTooltip.has(axis.id);
        const data = axis.data ?? [];
        if ((0, $lXwwj.isBandScaleConfig)(axis)) {
            const categoryGapRatio = axis.categoryGapRatio ?? $bac297eef107321c$var$DEFAULT_CATEGORY_GAP_RATIO;
            const barGapRatio = axis.barGapRatio ?? $bac297eef107321c$var$DEFAULT_BAR_GAP_RATIO;
            completeAxis[axis.id] = (0, $bac297eef107321c$var$_extends2.default)({
                offset: 0,
                categoryGapRatio: categoryGapRatio,
                barGapRatio: barGapRatio,
                triggerTooltip: triggerTooltip
            }, axis, {
                data: data,
                scale: (0, $6lJB1.scaleBand)(axis.data, range).paddingInner(categoryGapRatio).paddingOuter(categoryGapRatio / 2),
                tickNumber: axis.data.length,
                colorScale: axis.colorMap && (axis.colorMap.type === 'ordinal' ? (0, $jTrR8.getOrdinalColorScale)((0, $bac297eef107321c$var$_extends2.default)({
                    values: axis.data
                }, axis.colorMap)) : (0, $jTrR8.getColorScale)(axis.colorMap))
            });
            if ((0, $QqBso.isDateData)(axis.data)) {
                const dateFormatter = (0, $QqBso.createDateFormatter)(axis.data, range, axis.tickNumber);
                completeAxis[axis.id].valueFormatter = axis.valueFormatter ?? dateFormatter;
            }
        }
        if ((0, $lXwwj.isPointScaleConfig)(axis)) {
            completeAxis[axis.id] = (0, $bac297eef107321c$var$_extends2.default)({
                offset: 0,
                triggerTooltip: triggerTooltip
            }, axis, {
                data: data,
                scale: (0, $6lJB1.scalePoint)(axis.data, range),
                tickNumber: axis.data.length,
                colorScale: axis.colorMap && (axis.colorMap.type === 'ordinal' ? (0, $jTrR8.getOrdinalColorScale)((0, $bac297eef107321c$var$_extends2.default)({
                    values: axis.data
                }, axis.colorMap)) : (0, $jTrR8.getColorScale)(axis.colorMap))
            });
            if ((0, $QqBso.isDateData)(axis.data)) {
                const dateFormatter = (0, $QqBso.createDateFormatter)(axis.data, range, axis.tickNumber);
                completeAxis[axis.id].valueFormatter = axis.valueFormatter ?? dateFormatter;
            }
        }
        if (!(0, $lXwwj.isContinuousScaleConfig)(axis)) // Could be merged with the two previous "if conditions" but then TS does not get that `axis.scaleType` can't be `band` or `point`.
        return;
        const scaleType = axis.scaleType ?? 'linear';
        const domainLimit = axis.domainLimit ?? 'nice';
        const axisExtremums = [
            axis.min ?? minData,
            axis.max ?? maxData
        ];
        if (typeof domainLimit === 'function') {
            const { min: min, max: max } = domainLimit(minData, maxData);
            axisExtremums[0] = min;
            axisExtremums[1] = max;
        }
        const rawTickNumber = (0, $6PfPa.getTickNumber)(axis, axisExtremums, (0, $6PfPa.getDefaultTickNumber)(Math.abs(range[1] - range[0])));
        const tickNumber = (0, $6PfPa.scaleTickNumberByRange)(rawTickNumber, range);
        const scale = (0, $ar6SO.getScale)(scaleType, axisExtremums, range);
        const finalScale = domainLimit === 'nice' ? scale.nice(rawTickNumber) : scale;
        const [minDomain, maxDomain] = finalScale.domain();
        const domain = [
            axis.min ?? minDomain,
            axis.max ?? maxDomain
        ];
        completeAxis[axis.id] = (0, $bac297eef107321c$var$_extends2.default)({
            offset: 0,
            triggerTooltip: triggerTooltip
        }, axis, {
            data: data,
            scaleType: scaleType,
            scale: finalScale.domain(domain),
            tickNumber: tickNumber,
            colorScale: axis.colorMap && (0, $jTrR8.getColorScale)(axis.colorMap)
        });
    });
    return {
        axis: completeAxis,
        axisIds: allAxis.map(({ id: id })=>id)
    };
}

});
parcelRegister("59kTS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisExtremum = void 0;

var $jFd7Z = parcelRequire("jFd7Z");
const $3bfe015dc7f554d1$var$axisExtremumCallback = (acc, chartType, axis, axisDirection, seriesConfig, axisIndex, formattedSeries)=>{
    const getter = axisDirection === 'rotation' ? seriesConfig[chartType].rotationExtremumGetter : seriesConfig[chartType].radiusExtremumGetter;
    const series = formattedSeries[chartType]?.series ?? {};
    const [minChartTypeData, maxChartTypeData] = getter?.({
        series: series,
        axis: axis,
        axisIndex: axisIndex,
        isDefaultAxis: axisIndex === 0
    }) ?? [
        Infinity,
        -Infinity
    ];
    const [minData, maxData] = acc;
    return [
        Math.min(minChartTypeData, minData),
        Math.max(maxChartTypeData, maxData)
    ];
};
const $3bfe015dc7f554d1$var$getAxisExtremum = (axis, axisDirection, seriesConfig, axisIndex, formattedSeries)=>{
    const polarSeriesTypes = Object.keys(seriesConfig).filter($jFd7Z.isPolarSeriesType);
    const extremums = polarSeriesTypes.reduce((acc, charType)=>$3bfe015dc7f554d1$var$axisExtremumCallback(acc, charType, axis, axisDirection, seriesConfig, axisIndex, formattedSeries), [
        Infinity,
        -Infinity
    ]);
    if (Number.isNaN(extremums[0]) || Number.isNaN(extremums[1])) return [
        Infinity,
        -Infinity
    ];
    return extremums;
};
module.exports.getAxisExtremum = $3bfe015dc7f554d1$var$getAxisExtremum;

});
parcelRegister("jFd7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPolarSeriesType = $e50c0795d6862945$var$isPolarSeriesType;

var $hPkde = parcelRequire("hPkde");
function $e50c0795d6862945$var$isPolarSeriesType(seriesType) {
    return $hPkde.polarSeriesTypes.getTypes().has(seriesType);
}

});


parcelRegister("1hcZZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rad2deg = module.exports.deg2rad = void 0;
const $0ee1764869a04c89$var$deg2rad = (value, defaultRad)=>{
    if (value === undefined) return defaultRad;
    return Math.PI * value / 180;
};
module.exports.deg2rad = $0ee1764869a04c89$var$deg2rad;
const $0ee1764869a04c89$var$rad2deg = (value, defaultDeg)=>{
    if (value === undefined) return defaultDeg;
    return 180 * value / Math.PI;
};
module.exports.rad2deg = $0ee1764869a04c89$var$rad2deg;

});

parcelRegister("l1PKY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisTriggerTooltip = void 0;

var $jFd7Z = parcelRequire("jFd7Z");
const $f4f1d6bede5efd33$var$getAxisTriggerTooltip = (axisDirection, seriesConfig, formattedSeries, defaultAxisId)=>{
    const tooltipAxesIds = new Set();
    const chartTypes = Object.keys(seriesConfig).filter($jFd7Z.isPolarSeriesType);
    chartTypes.forEach((chartType)=>{
        const series = formattedSeries[chartType]?.series ?? {};
        const tooltipAxes = seriesConfig[chartType].axisTooltipGetter?.(series);
        if (tooltipAxes === undefined) return;
        tooltipAxes.forEach(({ axisId: axisId, direction: direction })=>{
            if (direction === axisDirection) tooltipAxesIds.add(axisId ?? defaultAxisId);
        });
    });
    return tooltipAxesIds;
};
module.exports.getAxisTriggerTooltip = $f4f1d6bede5efd33$var$getAxisTriggerTooltip;

});





parcelRegister("d4cjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9835340914f25b65$var$_exportNames = {
    useChartZAxis: true
};
Object.defineProperty(module.exports, "useChartZAxis", {
    enumerable: true,
    get: function() {
        return $fFAni.useChartZAxis;
    }
});

var $fFAni = parcelRequire("fFAni");

var $dwJn5 = parcelRequire("dwJn5");
Object.keys($dwJn5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9835340914f25b65$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dwJn5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dwJn5[key];
        }
    });
});

});
parcelRegister("fFAni", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b686e6a064228fee$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b686e6a064228fee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartZAxis = void 0;

var $b686e6a064228fee$var$_extends2 = $b686e6a064228fee$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b686e6a064228fee$var$React = $b686e6a064228fee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jTrR8 = parcelRequire("jTrR8");
function $b686e6a064228fee$var$addDefaultId(axisConfig, defaultId) {
    if (axisConfig.id !== undefined) return axisConfig;
    return (0, $b686e6a064228fee$var$_extends2.default)({
        id: defaultId
    }, axisConfig);
}
function $b686e6a064228fee$var$processColorMap(axisConfig) {
    if (!axisConfig.colorMap) return axisConfig;
    return (0, $b686e6a064228fee$var$_extends2.default)({}, axisConfig, {
        colorScale: axisConfig.colorMap.type === 'ordinal' && axisConfig.data ? (0, $jTrR8.getOrdinalColorScale)((0, $b686e6a064228fee$var$_extends2.default)({
            values: axisConfig.data
        }, axisConfig.colorMap)) : (0, $jTrR8.getColorScale)(axisConfig.colorMap.type === 'continuous' ? (0, $b686e6a064228fee$var$_extends2.default)({
            min: axisConfig.min,
            max: axisConfig.max
        }, axisConfig.colorMap) : axisConfig.colorMap)
    });
}
function $b686e6a064228fee$var$getZAxisState(zAxis, dataset) {
    if (!zAxis || zAxis.length === 0) return {
        axis: {},
        axisIds: []
    };
    const zAxisLookup = {};
    const axisIds = [];
    zAxis.forEach((axisConfig, index)=>{
        const dataKey = axisConfig.dataKey;
        const defaultizedId = axisConfig.id ?? `defaultized-z-axis-${index}`;
        if (dataKey === undefined || axisConfig.data !== undefined) {
            zAxisLookup[defaultizedId] = $b686e6a064228fee$var$processColorMap($b686e6a064228fee$var$addDefaultId(axisConfig, defaultizedId));
            axisIds.push(defaultizedId);
            return;
        }
        if (dataset === undefined) throw new Error('MUI X Charts: z-axis uses `dataKey` but no `dataset` is provided.');
        zAxisLookup[defaultizedId] = $b686e6a064228fee$var$processColorMap($b686e6a064228fee$var$addDefaultId((0, $b686e6a064228fee$var$_extends2.default)({}, axisConfig, {
            data: dataset.map((d)=>d[dataKey])
        }), defaultizedId));
        axisIds.push(defaultizedId);
    });
    return {
        axis: zAxisLookup,
        axisIds: axisIds
    };
}
const $b686e6a064228fee$var$useChartZAxis = ({ params: params, store: store })=>{
    const { zAxis: zAxis, dataset: dataset } = params;
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useChartZAxis`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $b686e6a064228fee$var$React.useRef(true);
    $b686e6a064228fee$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        store.set('zAxis', $b686e6a064228fee$var$getZAxisState(zAxis, dataset));
    }, [
        zAxis,
        dataset,
        store
    ]);
    return {};
};
module.exports.useChartZAxis = $b686e6a064228fee$var$useChartZAxis;
$b686e6a064228fee$var$useChartZAxis.params = {
    zAxis: true,
    dataset: true
};
$b686e6a064228fee$var$useChartZAxis.getInitialState = (params)=>({
        zAxis: $b686e6a064228fee$var$getZAxisState(params.zAxis, params.dataset)
    });

});

parcelRegister("dwJn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartZAxis = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $9d917555f9849345$var$selectRootState = (state)=>state;
const $9d917555f9849345$var$selectorChartZAxis = module.exports.selectorChartZAxis = (0, $8P0MD.createSelector)($9d917555f9849345$var$selectRootState, (state)=>state.zAxis);

});


parcelRegister("d25l6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $97cf9a8f2e058e2f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartHighlight = void 0;

var $97cf9a8f2e058e2f$var$_extends2 = $97cf9a8f2e058e2f$require$_interopRequireDefault((parcelRequire("3p9rK")));


var $d7LOv = parcelRequire("d7LOv");

var $97cf9a8f2e058e2f$var$_useEventCallback = $97cf9a8f2e058e2f$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $97cf9a8f2e058e2f$var$_useEnhancedEffect = $97cf9a8f2e058e2f$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $325pS = parcelRequire("325pS");
const $97cf9a8f2e058e2f$var$useChartHighlight = ({ store: store, params: params })=>{
    (0, $d7LOv.useAssertModelConsistency)({
        warningPrefix: 'MUI X Charts',
        componentName: 'Chart',
        propName: 'highlightedItem',
        controlled: params.highlightedItem,
        defaultValue: null
    });
    (0, $97cf9a8f2e058e2f$var$_useEnhancedEffect.default)(()=>{
        if (store.state.highlight.item !== params.highlightedItem) store.set('highlight', (0, $97cf9a8f2e058e2f$var$_extends2.default)({}, store.state.highlight, {
            item: params.highlightedItem
        }));
    }, [
        store,
        params.highlightedItem
    ]);
    const clearHighlight = (0, $97cf9a8f2e058e2f$var$_useEventCallback.default)(()=>{
        params.onHighlightChange?.(null);
        const prevHighlight = store.state.highlight;
        if (prevHighlight.item === null || prevHighlight.isControlled) return;
        store.set('highlight', {
            item: null,
            lastUpdate: 'pointer',
            isControlled: false
        });
    });
    const setHighlight = (0, $97cf9a8f2e058e2f$var$_useEventCallback.default)((newItem)=>{
        const prevHighlight = store.state.highlight;
        if ((0, $325pS.fastObjectShallowCompare)(prevHighlight.item, newItem)) return;
        params.onHighlightChange?.(newItem);
        if (prevHighlight.isControlled) return;
        store.set('highlight', {
            item: newItem,
            lastUpdate: 'pointer',
            isControlled: false
        });
    });
    return {
        instance: {
            clearHighlight: clearHighlight,
            setHighlight: setHighlight
        }
    };
};
module.exports.useChartHighlight = $97cf9a8f2e058e2f$var$useChartHighlight;
$97cf9a8f2e058e2f$var$useChartHighlight.getInitialState = (params)=>({
        highlight: {
            item: params.highlightedItem,
            lastUpdate: 'pointer',
            isControlled: params.highlightedItem !== undefined
        }
    });
$97cf9a8f2e058e2f$var$useChartHighlight.params = {
    highlightedItem: true,
    onHighlightChange: true
};

});

parcelRegister("iVJ0y", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dc80768267ea0dc8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dc80768267ea0dc8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.barSeriesConfig = void 0;

var $idrqd = parcelRequire("idrqd");

var $dc80768267ea0dc8$var$_seriesProcessor = $dc80768267ea0dc8$require$_interopRequireDefault((parcelRequire("7osLf")));

var $dc80768267ea0dc8$var$_legend = $dc80768267ea0dc8$require$_interopRequireDefault((parcelRequire("io7oO")));

var $dc80768267ea0dc8$var$_getColor = $dc80768267ea0dc8$require$_interopRequireDefault((parcelRequire("f25WF")));

var $dc80768267ea0dc8$var$_keyboardFocusHandler = $dc80768267ea0dc8$require$_interopRequireDefault((parcelRequire("kGKe6")));

var $dc80768267ea0dc8$var$_tooltip = $dc80768267ea0dc8$require$_interopRequireWildcard((parcelRequire("b2xBU")));

var $dc80768267ea0dc8$var$_tooltipPosition = $dc80768267ea0dc8$require$_interopRequireDefault((parcelRequire("fQPB8")));

var $9JLts = parcelRequire("9JLts");

var $jtEpx = parcelRequire("jtEpx");
const $dc80768267ea0dc8$var$barSeriesConfig = module.exports.barSeriesConfig = {
    seriesProcessor: $dc80768267ea0dc8$var$_seriesProcessor.default,
    colorProcessor: $dc80768267ea0dc8$var$_getColor.default,
    legendGetter: $dc80768267ea0dc8$var$_legend.default,
    tooltipGetter: $dc80768267ea0dc8$var$_tooltip.default,
    tooltipItemPositionGetter: $dc80768267ea0dc8$var$_tooltipPosition.default,
    axisTooltipGetter: $dc80768267ea0dc8$var$_tooltip.axisTooltipGetter,
    xExtremumGetter: $idrqd.getExtremumX,
    yExtremumGetter: $idrqd.getExtremumY,
    getSeriesWithDefaultValues: $9JLts.getSeriesWithDefaultValues,
    keyboardFocusHandler: $dc80768267ea0dc8$var$_keyboardFocusHandler.default,
    identifierSerializer: $jtEpx.identifierSerializerSeriesIdDataIndex
};

});
parcelRegister("idrqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getExtremumY = module.exports.getExtremumX = void 0;

var $42j0p = parcelRequire("42j0p");
const $d42eb64d2f5457fa$var$createResult = (data, direction)=>{
    if (direction === 'x') return {
        x: data,
        y: null
    };
    return {
        x: null,
        y: data
    };
};
const $d42eb64d2f5457fa$var$getBaseExtremum = (params)=>{
    const { axis: axis, getFilters: getFilters, isDefaultAxis: isDefaultAxis } = params;
    const filter = getFilters?.({
        currentAxisId: axis.id,
        isDefaultAxis: isDefaultAxis
    });
    const data = filter ? axis.data?.filter((_, i)=>filter({
            x: null,
            y: null
        }, i)) : axis.data;
    return (0, $42j0p.findMinMax)(data ?? []);
};
const $d42eb64d2f5457fa$var$getValueExtremum = (direction)=>(params)=>{
        const { series: series, axis: axis, getFilters: getFilters, isDefaultAxis: isDefaultAxis } = params;
        return Object.keys(series).filter((seriesId)=>{
            const axisId = direction === 'x' ? series[seriesId].xAxisId : series[seriesId].yAxisId;
            return axisId === axis.id || isDefaultAxis && axisId === undefined;
        }).reduce((acc, seriesId)=>{
            const { stackedData: stackedData } = series[seriesId];
            const filter = getFilters?.({
                currentAxisId: axis.id,
                isDefaultAxis: isDefaultAxis,
                seriesXAxisId: series[seriesId].xAxisId,
                seriesYAxisId: series[seriesId].yAxisId
            });
            const [seriesMin, seriesMax] = stackedData?.reduce((seriesAcc, values, index)=>{
                if (filter && (!filter($d42eb64d2f5457fa$var$createResult(values[0], direction), index) || !filter($d42eb64d2f5457fa$var$createResult(values[1], direction), index))) return seriesAcc;
                return [
                    Math.min(...values, seriesAcc[0]),
                    Math.max(...values, seriesAcc[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]) ?? [
                Infinity,
                -Infinity
            ];
            return [
                Math.min(seriesMin, acc[0]),
                Math.max(seriesMax, acc[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    };
const $d42eb64d2f5457fa$var$getExtremumX = (params)=>{
    // Notice that bar should be all horizontal or all vertical.
    // Don't think it's a problem for now
    const isHorizontal = Object.keys(params.series).some((seriesId)=>params.series[seriesId].layout === 'horizontal');
    if (isHorizontal) return $d42eb64d2f5457fa$var$getValueExtremum('x')(params);
    return $d42eb64d2f5457fa$var$getBaseExtremum(params);
};
module.exports.getExtremumX = $d42eb64d2f5457fa$var$getExtremumX;
const $d42eb64d2f5457fa$var$getExtremumY = (params)=>{
    const isHorizontal = Object.keys(params.series).some((seriesId)=>params.series[seriesId].layout === 'horizontal');
    if (isHorizontal) return $d42eb64d2f5457fa$var$getBaseExtremum(params);
    return $d42eb64d2f5457fa$var$getValueExtremum('y')(params);
};
module.exports.getExtremumY = $d42eb64d2f5457fa$var$getExtremumY;

});
parcelRegister("42j0p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findMinMax = $2f06177788c3ebc6$var$findMinMax;
/**
 * Efficiently finds the minimum and maximum values in an array of numbers.
 * This functions helps preventing maximum call stack errors when dealing with large datasets.
 *
 * @param data The array of numbers to evaluate
 * @returns [min, max] as numbers
 */ function $2f06177788c3ebc6$var$findMinMax(data) {
    let min = Infinity;
    let max = -Infinity;
    for (const value of data ?? []){
        if (value < min) min = value;
        if (value > max) max = value;
    }
    return [
        min,
        max
    ];
}

});


parcelRegister("7osLf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $562115a5abcf9771$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $562115a5abcf9771$var$_extends2 = $562115a5abcf9771$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6hlpT = parcelRequire("6hlpT");


var $8nfaR = parcelRequire("8nfaR");
const $562115a5abcf9771$var$barValueFormatter = (v)=>v == null ? '' : v.toLocaleString();
const $562115a5abcf9771$var$seriesProcessor = (params, dataset, isItemVisible)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    const stackingGroups = (0, $8nfaR.getStackingGroups)(params);
    // Create a data set with format adapted to d3
    const d3Dataset = dataset ?? [];
    seriesOrder.forEach((id)=>{
        const data = series[id].data;
        if (data !== undefined) data.forEach((value, index)=>{
            if (d3Dataset.length <= index) d3Dataset.push({
                [id]: value
            });
            else d3Dataset[index][id] = value;
        });
        else if (dataset === undefined) throw new Error([
            `MUI X Charts: bar series with id='${id}' has no data.`,
            'Either provide a data property to the series or use the dataset prop.'
        ].join('\n'));
        var entry, index;
    });
    const completedSeries = {};
    stackingGroups.forEach((stackingGroup)=>{
        const { ids: ids, stackingOffset: stackingOffset, stackingOrder: stackingOrder } = stackingGroup;
        const keys = ids.map((id)=>{
            // Use dataKey if needed and available
            const dataKey = series[id].dataKey;
            return series[id].data === undefined && dataKey !== undefined ? dataKey : id;
        });
        const stackedData = (0, $6hlpT.stack)().keys(keys).value((d, key)=>d[key] ?? 0) // defaultize null value to 0
        .order(stackingOrder).offset(stackingOffset)(d3Dataset);
        const idOrder = stackedData.map((s)=>s.index);
        const fixedOrder = ()=>idOrder;
        // Compute visible stacked data
        const visibleStackedData = (0, $6hlpT.stack)().keys(keys).value((d, key)=>{
            const keyIndex = keys.indexOf(key);
            const seriesId = ids[keyIndex];
            if (!isItemVisible?.({
                type: 'bar',
                seriesId: seriesId
            })) // For hidden series, return 0 so they don't contribute to the stack
            return 0;
            return d[key] ?? 0;
        }).order(fixedOrder).offset(stackingOffset)(d3Dataset);
        ids.forEach((id, index)=>{
            const dataKey = series[id].dataKey;
            const data = dataKey ? dataset.map((d)=>{
                const value = d[dataKey];
                return typeof value === 'number' ? value : null;
            }) : series[id].data;
            const hidden = !isItemVisible?.({
                type: 'bar',
                seriesId: id
            });
            completedSeries[id] = (0, $562115a5abcf9771$var$_extends2.default)({
                layout: 'vertical',
                labelMarkType: 'square',
                minBarSize: 0,
                valueFormatter: series[id].valueFormatter ?? $562115a5abcf9771$var$barValueFormatter
            }, series[id], {
                data: data,
                hidden: hidden,
                stackedData: stackedData[index],
                visibleStackedData: visibleStackedData[index]
            });
        });
    });
    return {
        seriesOrder: seriesOrder,
        stackingGroups: stackingGroups,
        series: completedSeries
    };
};
var $562115a5abcf9771$var$_default = module.exports.default = $562115a5abcf9771$var$seriesProcessor;

});
parcelRegister("6hlpT", function(module, exports) {
// `x-charts-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("k3pnV"));

});
parcelRegister("k3pnV", function(module, exports) {
// `x-charts-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("eq8aD"));

});
parcelRegister("eq8aD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a7f9d4e325881f4f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a7f9d4e325881f4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $cSNAn.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $cSNAn.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $kDsM0.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $kDsM0.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $6Np2U.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $6Np2U.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $6Np2U.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $6Np2U.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTimes", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_times.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_times.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $a7f9d4e325881f4f$var$_symbol.symbolsStroke;
    }
});

var $a7f9d4e325881f4f$var$_arc = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("1xawI")));

var $a7f9d4e325881f4f$var$_area = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("9CQRt")));

var $a7f9d4e325881f4f$var$_line = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("a6zNk")));

var $a7f9d4e325881f4f$var$_pie = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("cX7iV")));

var $a7f9d4e325881f4f$var$_areaRadial = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("lJcMj")));

var $a7f9d4e325881f4f$var$_lineRadial = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("j1mwJ")));

var $a7f9d4e325881f4f$var$_pointRadial = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("1rbQx")));

var $6Np2U = parcelRequire("6Np2U");

var $a7f9d4e325881f4f$var$_symbol = $a7f9d4e325881f4f$require$_interopRequireWildcard((parcelRequire("kSXHc")));

var $a7f9d4e325881f4f$var$_asterisk = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("gjYwJ")));

var $a7f9d4e325881f4f$var$_circle = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("d1aUr")));

var $a7f9d4e325881f4f$var$_cross = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("fbBVs")));

var $a7f9d4e325881f4f$var$_diamond = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("lkQ7E")));

var $a7f9d4e325881f4f$var$_diamond2 = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("3Shmn")));

var $a7f9d4e325881f4f$var$_plus = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("k6sw8")));

var $a7f9d4e325881f4f$var$_square = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("bwirU")));

var $a7f9d4e325881f4f$var$_square2 = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("k07qr")));

var $a7f9d4e325881f4f$var$_star = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("hkQfH")));

var $a7f9d4e325881f4f$var$_triangle = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("dORyw")));

var $a7f9d4e325881f4f$var$_triangle2 = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("cT6yo")));

var $a7f9d4e325881f4f$var$_wye = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("8q5zZ")));

var $a7f9d4e325881f4f$var$_times = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("hkaay")));

var $a7f9d4e325881f4f$var$_basisClosed = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("q0r9c")));

var $a7f9d4e325881f4f$var$_basisOpen = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("3aTzw")));

var $a7f9d4e325881f4f$var$_basis = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("ggnkV")));

var $cSNAn = parcelRequire("cSNAn");

var $a7f9d4e325881f4f$var$_bundle = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("4H5Yq")));

var $a7f9d4e325881f4f$var$_cardinalClosed = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("hTJCI")));

var $a7f9d4e325881f4f$var$_cardinalOpen = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("1NAMr")));

var $a7f9d4e325881f4f$var$_cardinal = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("jsXf0")));

var $a7f9d4e325881f4f$var$_catmullRomClosed = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("1OVfE")));

var $a7f9d4e325881f4f$var$_catmullRomOpen = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("1g5aj")));

var $a7f9d4e325881f4f$var$_catmullRom = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("3ObHE")));

var $a7f9d4e325881f4f$var$_linearClosed = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("hRoQJ")));

var $a7f9d4e325881f4f$var$_linear = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("8Rwga")));

var $kDsM0 = parcelRequire("kDsM0");

var $a7f9d4e325881f4f$var$_natural = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("e2ciD")));

var $a7f9d4e325881f4f$var$_step = $a7f9d4e325881f4f$require$_interopRequireWildcard((parcelRequire("co0q1")));

var $a7f9d4e325881f4f$var$_stack = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("khrvJ")));

var $a7f9d4e325881f4f$var$_expand = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("5SlZ9")));

var $a7f9d4e325881f4f$var$_diverging = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("3zxc9")));

var $a7f9d4e325881f4f$var$_none = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("9hblW")));

var $a7f9d4e325881f4f$var$_silhouette = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("iIOyC")));

var $a7f9d4e325881f4f$var$_wiggle = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("9Wz4a")));

var $a7f9d4e325881f4f$var$_appearance = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("hXbNK")));

var $a7f9d4e325881f4f$var$_ascending = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("4GmFJ")));

var $a7f9d4e325881f4f$var$_descending = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("dFs1Y")));

var $a7f9d4e325881f4f$var$_insideOut = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("lSvWx")));

var $a7f9d4e325881f4f$var$_none2 = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("5Sobv")));

var $a7f9d4e325881f4f$var$_reverse = $a7f9d4e325881f4f$require$_interopRequireDefault((parcelRequire("eUF0z")));

});
parcelRegister("1xawI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $11e109e44b8a4836$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11e109e44b8a4836$var$_default;

var $11e109e44b8a4836$var$_constant = $11e109e44b8a4836$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $lkXEB = parcelRequire("lkXEB");

var $ec4A3 = parcelRequire("ec4A3");
function $11e109e44b8a4836$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $11e109e44b8a4836$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $11e109e44b8a4836$var$arcStartAngle(d) {
    return d.startAngle;
}
function $11e109e44b8a4836$var$arcEndAngle(d) {
    return d.endAngle;
}
function $11e109e44b8a4836$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $11e109e44b8a4836$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $lkXEB.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $11e109e44b8a4836$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $lkXEB.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $lkXEB.sqrt)((0, $lkXEB.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $11e109e44b8a4836$var$_default() {
    var innerRadius = $11e109e44b8a4836$var$arcInnerRadius, outerRadius = $11e109e44b8a4836$var$arcOuterRadius, cornerRadius = (0, $11e109e44b8a4836$var$_constant.default)(0), padRadius = null, startAngle = $11e109e44b8a4836$var$arcStartAngle, endAngle = $11e109e44b8a4836$var$arcEndAngle, padAngle = $11e109e44b8a4836$var$arcPadAngle, context = null, path = (0, $ec4A3.withPath)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $lkXEB.halfPi, a1 = endAngle.apply(this, arguments) - $lkXEB.halfPi, da = (0, $lkXEB.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > $lkXEB.epsilon)) context.moveTo(0, 0);
        else if (da > $lkXEB.tau - $lkXEB.epsilon) {
            context.moveTo(r1 * (0, $lkXEB.cos)(a0), r1 * (0, $lkXEB.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $lkXEB.epsilon) {
                context.moveTo(r0 * (0, $lkXEB.cos)(a1), r0 * (0, $lkXEB.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $lkXEB.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $lkXEB.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $lkXEB.min)((0, $lkXEB.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $lkXEB.epsilon) {
                var p0 = (0, $lkXEB.asin)(rp / r0 * (0, $lkXEB.sin)(ap)), p1 = (0, $lkXEB.asin)(rp / r1 * (0, $lkXEB.sin)(ap));
                if ((da0 -= p0 * 2) > $lkXEB.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $lkXEB.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $lkXEB.cos)(a01), y01 = r1 * (0, $lkXEB.sin)(a01), x10 = r0 * (0, $lkXEB.cos)(a10), y10 = r0 * (0, $lkXEB.sin)(a10);
            // Apply rounded corners?
            if (rc > $lkXEB.epsilon) {
                var x11 = r1 * (0, $lkXEB.cos)(a11), y11 = r1 * (0, $lkXEB.sin)(a11), x00 = r0 * (0, $lkXEB.cos)(a00), y00 = r0 * (0, $lkXEB.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < $lkXEB.pi) {
                    if (oc = $11e109e44b8a4836$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $lkXEB.sin)((0, $lkXEB.acos)((ax * bx + ay * by) / ((0, $lkXEB.sqrt)(ax * ax + ay * ay) * (0, $lkXEB.sqrt)(bx * bx + by * by))) / 2), lc = (0, $lkXEB.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $lkXEB.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $lkXEB.min)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > $lkXEB.epsilon)) context.moveTo(x01, y01);
            else if (rc1 > $lkXEB.epsilon) {
                t0 = $11e109e44b8a4836$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $11e109e44b8a4836$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $lkXEB.atan2)(t0.y01, t0.x01), (0, $lkXEB.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $lkXEB.atan2)(t0.y01, t0.x01), (0, $lkXEB.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $lkXEB.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $lkXEB.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $lkXEB.atan2)(t1.y11, t1.x11), (0, $lkXEB.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $lkXEB.epsilon) || !(da0 > $lkXEB.epsilon)) context.lineTo(x10, y10);
            else if (rc0 > $lkXEB.epsilon) {
                t0 = $11e109e44b8a4836$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $11e109e44b8a4836$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $lkXEB.atan2)(t0.y01, t0.x01), (0, $lkXEB.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $lkXEB.atan2)(t0.y01, t0.x01), (0, $lkXEB.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $lkXEB.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $lkXEB.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $lkXEB.atan2)(t1.y11, t1.x11), (0, $lkXEB.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $lkXEB.pi / 2;
        return [
            (0, $lkXEB.cos)(a) * r,
            (0, $lkXEB.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $11e109e44b8a4836$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("kpbjR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edaeec3770b75026$var$_default;
function $edaeec3770b75026$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("lkXEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $f889bd409e5178fa$var$acos;
module.exports.asin = $f889bd409e5178fa$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $f889bd409e5178fa$var$abs = module.exports.abs = Math.abs;
const $f889bd409e5178fa$var$atan2 = module.exports.atan2 = Math.atan2;
const $f889bd409e5178fa$var$cos = module.exports.cos = Math.cos;
const $f889bd409e5178fa$var$max = module.exports.max = Math.max;
const $f889bd409e5178fa$var$min = module.exports.min = Math.min;
const $f889bd409e5178fa$var$sin = module.exports.sin = Math.sin;
const $f889bd409e5178fa$var$sqrt = module.exports.sqrt = Math.sqrt;
const $f889bd409e5178fa$var$epsilon = module.exports.epsilon = 1e-12;
const $f889bd409e5178fa$var$pi = module.exports.pi = Math.PI;
const $f889bd409e5178fa$var$halfPi = module.exports.halfPi = $f889bd409e5178fa$var$pi / 2;
const $f889bd409e5178fa$var$tau = module.exports.tau = 2 * $f889bd409e5178fa$var$pi;
function $f889bd409e5178fa$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $f889bd409e5178fa$var$pi : Math.acos(x);
}
function $f889bd409e5178fa$var$asin(x) {
    return x >= 1 ? $f889bd409e5178fa$var$halfPi : x <= -1 ? -$f889bd409e5178fa$var$halfPi : Math.asin(x);
}

});

parcelRegister("ec4A3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.withPath = $a555bd41f7f56eba$var$withPath;

var $h9anO = parcelRequire("h9anO");
function $a555bd41f7f56eba$var$withPath(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new $h9anO.Path(digits);
}

});
parcelRegister("h9anO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Path", {
    enumerable: true,
    get: function() {
        return $3K4jo.Path;
    }
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $3K4jo.path;
    }
});
Object.defineProperty(module.exports, "pathRound", {
    enumerable: true,
    get: function() {
        return $3K4jo.pathRound;
    }
});

var $3K4jo = parcelRequire("3K4jo");

});
parcelRegister("3K4jo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Path = void 0;
module.exports.path = $2b990333e02ce336$var$path;
module.exports.pathRound = $2b990333e02ce336$var$pathRound;
const $2b990333e02ce336$var$pi = Math.PI, $2b990333e02ce336$var$tau = 2 * $2b990333e02ce336$var$pi, $2b990333e02ce336$var$epsilon = 1e-6, $2b990333e02ce336$var$tauEpsilon = $2b990333e02ce336$var$tau - $2b990333e02ce336$var$epsilon;
function $2b990333e02ce336$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $2b990333e02ce336$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $2b990333e02ce336$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $2b990333e02ce336$var$Path {
    constructor(digits){
        this._x0 = this._y0 = // start of current subpath
        this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $2b990333e02ce336$var$append : $2b990333e02ce336$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $2b990333e02ce336$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $2b990333e02ce336$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($2b990333e02ce336$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $2b990333e02ce336$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $2b990333e02ce336$var$epsilon || Math.abs(this._y1 - y0) > $2b990333e02ce336$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $2b990333e02ce336$var$tau + $2b990333e02ce336$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $2b990333e02ce336$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $2b990333e02ce336$var$epsilon) this._append`A${r},${r},0,${+(da >= $2b990333e02ce336$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
module.exports.Path = $2b990333e02ce336$var$Path;
function $2b990333e02ce336$var$path() {
    return new $2b990333e02ce336$var$Path();
}
// Allow instanceof d3.path
$2b990333e02ce336$var$path.prototype = $2b990333e02ce336$var$Path.prototype;
function $2b990333e02ce336$var$pathRound(digits = 3) {
    return new $2b990333e02ce336$var$Path(+digits);
}

});




parcelRegister("9CQRt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7020aad8daa864d6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7020aad8daa864d6$var$_default;

var $7020aad8daa864d6$var$_array = $7020aad8daa864d6$require$_interopRequireDefault((parcelRequire("krVkC")));

var $7020aad8daa864d6$var$_constant = $7020aad8daa864d6$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $7020aad8daa864d6$var$_linear = $7020aad8daa864d6$require$_interopRequireDefault((parcelRequire("8Rwga")));

var $7020aad8daa864d6$var$_line = $7020aad8daa864d6$require$_interopRequireDefault((parcelRequire("a6zNk")));

var $ec4A3 = parcelRequire("ec4A3");

var $ld7X3 = parcelRequire("ld7X3");
function $7020aad8daa864d6$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $7020aad8daa864d6$var$_constant.default)(true), context = null, curve = $7020aad8daa864d6$var$_linear.default, output = null, path = (0, $ec4A3.withPath)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ld7X3.x : (0, $7020aad8daa864d6$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $7020aad8daa864d6$var$_constant.default)(0) : (0, $7020aad8daa864d6$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ld7X3.y : (0, $7020aad8daa864d6$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $7020aad8daa864d6$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $7020aad8daa864d6$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7020aad8daa864d6$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("krVkC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee32cd1f3af8c5b2$var$_default;
module.exports.slice = void 0;
var $ee32cd1f3af8c5b2$var$slice = module.exports.slice = Array.prototype.slice;
function $ee32cd1f3af8c5b2$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("8Rwga", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $673c4c11d25442f0$var$_default;
function $673c4c11d25442f0$var$Linear(context) {
    this._context = context;
}
$673c4c11d25442f0$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $673c4c11d25442f0$var$_default(context) {
    return new $673c4c11d25442f0$var$Linear(context);
}

});

parcelRegister("a6zNk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $75b63af765cdd158$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75b63af765cdd158$var$_default;

var $75b63af765cdd158$var$_array = $75b63af765cdd158$require$_interopRequireDefault((parcelRequire("krVkC")));

var $75b63af765cdd158$var$_constant = $75b63af765cdd158$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $75b63af765cdd158$var$_linear = $75b63af765cdd158$require$_interopRequireDefault((parcelRequire("8Rwga")));

var $ec4A3 = parcelRequire("ec4A3");

var $ld7X3 = parcelRequire("ld7X3");
function $75b63af765cdd158$var$_default(x, y) {
    var defined = (0, $75b63af765cdd158$var$_constant.default)(true), context = null, curve = $75b63af765cdd158$var$_linear.default, output = null, path = (0, $ec4A3.withPath)(line);
    x = typeof x === "function" ? x : x === undefined ? $ld7X3.x : (0, $75b63af765cdd158$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ld7X3.y : (0, $75b63af765cdd158$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $75b63af765cdd158$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $75b63af765cdd158$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $75b63af765cdd158$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $75b63af765cdd158$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ld7X3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $f710fae102969e22$var$x;
module.exports.y = $f710fae102969e22$var$y;
function $f710fae102969e22$var$x(p) {
    return p[0];
}
function $f710fae102969e22$var$y(p) {
    return p[1];
}

});



parcelRegister("cX7iV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $96e0a936bcb0bb00$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $96e0a936bcb0bb00$var$_default;

var $96e0a936bcb0bb00$var$_array = $96e0a936bcb0bb00$require$_interopRequireDefault((parcelRequire("krVkC")));

var $96e0a936bcb0bb00$var$_constant = $96e0a936bcb0bb00$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $96e0a936bcb0bb00$var$_descending = $96e0a936bcb0bb00$require$_interopRequireDefault((parcelRequire("fi5P5")));

var $96e0a936bcb0bb00$var$_identity = $96e0a936bcb0bb00$require$_interopRequireDefault((parcelRequire("6gLzQ")));

var $lkXEB = parcelRequire("lkXEB");
function $96e0a936bcb0bb00$var$_default() {
    var value = $96e0a936bcb0bb00$var$_identity.default, sortValues = $96e0a936bcb0bb00$var$_descending.default, sort = null, startAngle = (0, $96e0a936bcb0bb00$var$_constant.default)(0), endAngle = (0, $96e0a936bcb0bb00$var$_constant.default)($lkXEB.tau), padAngle = (0, $96e0a936bcb0bb00$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $96e0a936bcb0bb00$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($lkXEB.tau, Math.max(-$lkXEB.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $96e0a936bcb0bb00$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $96e0a936bcb0bb00$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $96e0a936bcb0bb00$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $96e0a936bcb0bb00$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("fi5P5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b21d0dcaeaa02058$var$_default;
function $b21d0dcaeaa02058$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("6gLzQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49092489d7270203$var$_default;
function $49092489d7270203$var$_default(d) {
    return d;
}

});


parcelRegister("lJcMj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd17b6756a3c12f0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fd17b6756a3c12f0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd17b6756a3c12f0$var$_default;

var $fd17b6756a3c12f0$var$_radial = $fd17b6756a3c12f0$require$_interopRequireWildcard((parcelRequire("kejeL")));

var $fd17b6756a3c12f0$var$_area = $fd17b6756a3c12f0$require$_interopRequireDefault((parcelRequire("9CQRt")));

var $j1mwJ = parcelRequire("j1mwJ");
function $fd17b6756a3c12f0$var$_default() {
    var a = (0, $fd17b6756a3c12f0$var$_area.default)().curve($fd17b6756a3c12f0$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $j1mwJ.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $j1mwJ.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $j1mwJ.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $j1mwJ.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $fd17b6756a3c12f0$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("kejeL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $eba40988ab035da9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $eba40988ab035da9$var$curveRadial;

var $eba40988ab035da9$var$_linear = $eba40988ab035da9$require$_interopRequireDefault((parcelRequire("8Rwga")));
var $eba40988ab035da9$var$curveRadialLinear = module.exports.curveRadialLinear = $eba40988ab035da9$var$curveRadial($eba40988ab035da9$var$_linear.default);
function $eba40988ab035da9$var$Radial(curve) {
    this._curve = curve;
}
$eba40988ab035da9$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $eba40988ab035da9$var$curveRadial(curve) {
    function radial(context) {
        return new $eba40988ab035da9$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("j1mwJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dd8f95b756fecc18$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $dd8f95b756fecc18$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd8f95b756fecc18$var$_default;
module.exports.lineRadial = $dd8f95b756fecc18$var$lineRadial;

var $dd8f95b756fecc18$var$_radial = $dd8f95b756fecc18$require$_interopRequireWildcard((parcelRequire("kejeL")));

var $dd8f95b756fecc18$var$_line = $dd8f95b756fecc18$require$_interopRequireDefault((parcelRequire("a6zNk")));
function $dd8f95b756fecc18$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $dd8f95b756fecc18$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $dd8f95b756fecc18$var$_default() {
    return $dd8f95b756fecc18$var$lineRadial((0, $dd8f95b756fecc18$var$_line.default)().curve($dd8f95b756fecc18$var$_radial.curveRadialLinear));
}

});


parcelRegister("1rbQx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $10c1807ef56e8358$var$_default;
function $10c1807ef56e8358$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("6Np2U", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4f2abf48e6f986e6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $4f2abf48e6f986e6$var$link;
module.exports.linkHorizontal = $4f2abf48e6f986e6$var$linkHorizontal;
module.exports.linkRadial = $4f2abf48e6f986e6$var$linkRadial;
module.exports.linkVertical = $4f2abf48e6f986e6$var$linkVertical;

var $krVkC = parcelRequire("krVkC");

var $4f2abf48e6f986e6$var$_constant = $4f2abf48e6f986e6$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $cSNAn = parcelRequire("cSNAn");

var $ec4A3 = parcelRequire("ec4A3");

var $ld7X3 = parcelRequire("ld7X3");
function $4f2abf48e6f986e6$var$linkSource(d) {
    return d.source;
}
function $4f2abf48e6f986e6$var$linkTarget(d) {
    return d.target;
}
function $4f2abf48e6f986e6$var$link(curve) {
    let source = $4f2abf48e6f986e6$var$linkSource, target = $4f2abf48e6f986e6$var$linkTarget, x = $ld7X3.x, y = $ld7X3.y, context = null, output = null, path = (0, $ec4A3.withPath)(link);
    function link() {
        let buffer;
        const argv = $krVkC.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $4f2abf48e6f986e6$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $4f2abf48e6f986e6$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $4f2abf48e6f986e6$var$linkHorizontal() {
    return $4f2abf48e6f986e6$var$link($cSNAn.bumpX);
}
function $4f2abf48e6f986e6$var$linkVertical() {
    return $4f2abf48e6f986e6$var$link($cSNAn.bumpY);
}
function $4f2abf48e6f986e6$var$linkRadial() {
    const l = $4f2abf48e6f986e6$var$link($cSNAn.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("cSNAn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9610fde0489b1809$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $9610fde0489b1809$var$bumpRadial;
module.exports.bumpX = $9610fde0489b1809$var$bumpX;
module.exports.bumpY = $9610fde0489b1809$var$bumpY;

var $9610fde0489b1809$var$_pointRadial = $9610fde0489b1809$require$_interopRequireDefault((parcelRequire("1rbQx")));
class $9610fde0489b1809$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $9610fde0489b1809$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $9610fde0489b1809$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $9610fde0489b1809$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $9610fde0489b1809$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $9610fde0489b1809$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $9610fde0489b1809$var$bumpX(context) {
    return new $9610fde0489b1809$var$Bump(context, true);
}
function $9610fde0489b1809$var$bumpY(context) {
    return new $9610fde0489b1809$var$Bump(context, false);
}
function $9610fde0489b1809$var$bumpRadial(context) {
    return new $9610fde0489b1809$var$BumpRadial(context);
}

});


parcelRegister("kSXHc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f3472826caaf11c4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3472826caaf11c4$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $f3472826caaf11c4$var$_constant = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $ec4A3 = parcelRequire("ec4A3");

var $f3472826caaf11c4$var$_asterisk = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("gjYwJ")));

var $f3472826caaf11c4$var$_circle = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("d1aUr")));

var $f3472826caaf11c4$var$_cross = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("fbBVs")));

var $f3472826caaf11c4$var$_diamond = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("lkQ7E")));

var $f3472826caaf11c4$var$_diamond2 = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("3Shmn")));

var $f3472826caaf11c4$var$_plus = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("k6sw8")));

var $f3472826caaf11c4$var$_square = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("bwirU")));

var $f3472826caaf11c4$var$_square2 = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("k07qr")));

var $f3472826caaf11c4$var$_star = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("hkQfH")));

var $f3472826caaf11c4$var$_triangle = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("dORyw")));

var $f3472826caaf11c4$var$_triangle2 = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("cT6yo")));

var $f3472826caaf11c4$var$_wye = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("8q5zZ")));

var $f3472826caaf11c4$var$_times = $f3472826caaf11c4$require$_interopRequireDefault((parcelRequire("hkaay")));
// These symbols are designed to be filled.
const $f3472826caaf11c4$var$symbolsFill = module.exports.symbolsFill = [
    $f3472826caaf11c4$var$_circle.default,
    $f3472826caaf11c4$var$_cross.default,
    $f3472826caaf11c4$var$_diamond.default,
    $f3472826caaf11c4$var$_square.default,
    $f3472826caaf11c4$var$_star.default,
    $f3472826caaf11c4$var$_triangle.default,
    $f3472826caaf11c4$var$_wye.default
];
// These symbols are designed to be stroked (with a width of 1.5px and round caps).
const $f3472826caaf11c4$var$symbolsStroke = module.exports.symbolsStroke = [
    $f3472826caaf11c4$var$_circle.default,
    $f3472826caaf11c4$var$_plus.default,
    $f3472826caaf11c4$var$_times.default,
    $f3472826caaf11c4$var$_triangle2.default,
    $f3472826caaf11c4$var$_asterisk.default,
    $f3472826caaf11c4$var$_square2.default,
    $f3472826caaf11c4$var$_diamond2.default
];
function $f3472826caaf11c4$var$Symbol(type, size) {
    let context = null, path = (0, $ec4A3.withPath)(symbol);
    type = typeof type === "function" ? type : (0, $f3472826caaf11c4$var$_constant.default)(type || $f3472826caaf11c4$var$_circle.default);
    size = typeof size === "function" ? size : (0, $f3472826caaf11c4$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $f3472826caaf11c4$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $f3472826caaf11c4$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("gjYwJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
const $be1d5f19505e69af$var$sqrt3 = (0, $lkXEB.sqrt)(3);
var $be1d5f19505e69af$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size + (0, $lkXEB.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $be1d5f19505e69af$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

});

parcelRegister("d1aUr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $97a3d4b3e29cc324$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size / $lkXEB.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $lkXEB.tau);
    }
};

});

parcelRegister("fbBVs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $b0e54d5eebe49b88$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("lkQ7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
const $f883e5ad729ec42d$var$tan30 = (0, $lkXEB.sqrt)(1 / 3);
const $f883e5ad729ec42d$var$tan30_2 = $f883e5ad729ec42d$var$tan30 * 2;
var $f883e5ad729ec42d$var$_default = module.exports.default = {
    draw (context, size) {
        const y = (0, $lkXEB.sqrt)(size / $f883e5ad729ec42d$var$tan30_2);
        const x = y * $f883e5ad729ec42d$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("3Shmn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $2d23e193a8c0bc84$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

});

parcelRegister("k6sw8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $ea2a7d2552db1a32$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size - (0, $lkXEB.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

});

parcelRegister("bwirU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $8630fe816ffe3b6e$var$_default = module.exports.default = {
    draw (context, size) {
        const w = (0, $lkXEB.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("k07qr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $e8f99142f22a09d7$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

});

parcelRegister("hkQfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
const $c9ecd6226b61ca0e$var$ka = 0.89081309152928522810;
const $c9ecd6226b61ca0e$var$kr = (0, $lkXEB.sin)($lkXEB.pi / 10) / (0, $lkXEB.sin)(7 * $lkXEB.pi / 10);
const $c9ecd6226b61ca0e$var$kx = (0, $lkXEB.sin)($lkXEB.tau / 10) * $c9ecd6226b61ca0e$var$kr;
const $c9ecd6226b61ca0e$var$ky = -(0, $lkXEB.cos)($lkXEB.tau / 10) * $c9ecd6226b61ca0e$var$kr;
var $c9ecd6226b61ca0e$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size * $c9ecd6226b61ca0e$var$ka);
        const x = $c9ecd6226b61ca0e$var$kx * r;
        const y = $c9ecd6226b61ca0e$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $lkXEB.tau * i / 5;
            const c = (0, $lkXEB.cos)(a);
            const s = (0, $lkXEB.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("dORyw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
const $a0f97cf5b2e4f2c7$var$sqrt3 = (0, $lkXEB.sqrt)(3);
var $a0f97cf5b2e4f2c7$var$_default = module.exports.default = {
    draw (context, size) {
        const y = -(0, $lkXEB.sqrt)(size / ($a0f97cf5b2e4f2c7$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$a0f97cf5b2e4f2c7$var$sqrt3 * y, -y);
        context.lineTo($a0f97cf5b2e4f2c7$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("cT6yo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
const $961fb48bdb557f97$var$sqrt3 = (0, $lkXEB.sqrt)(3);
var $961fb48bdb557f97$var$_default = module.exports.default = {
    draw (context, size) {
        const s = (0, $lkXEB.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $961fb48bdb557f97$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

});

parcelRegister("8q5zZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
const $62151467eeae253b$var$c = -0.5;
const $62151467eeae253b$var$s = (0, $lkXEB.sqrt)(3) / 2;
const $62151467eeae253b$var$k = 1 / (0, $lkXEB.sqrt)(12);
const $62151467eeae253b$var$a = ($62151467eeae253b$var$k / 2 + 1) * 3;
var $62151467eeae253b$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size / $62151467eeae253b$var$a);
        const x0 = r / 2, y0 = r * $62151467eeae253b$var$k;
        const x1 = x0, y1 = r * $62151467eeae253b$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($62151467eeae253b$var$c * x0 - $62151467eeae253b$var$s * y0, $62151467eeae253b$var$s * x0 + $62151467eeae253b$var$c * y0);
        context.lineTo($62151467eeae253b$var$c * x1 - $62151467eeae253b$var$s * y1, $62151467eeae253b$var$s * x1 + $62151467eeae253b$var$c * y1);
        context.lineTo($62151467eeae253b$var$c * x2 - $62151467eeae253b$var$s * y2, $62151467eeae253b$var$s * x2 + $62151467eeae253b$var$c * y2);
        context.lineTo($62151467eeae253b$var$c * x0 + $62151467eeae253b$var$s * y0, $62151467eeae253b$var$c * y0 - $62151467eeae253b$var$s * x0);
        context.lineTo($62151467eeae253b$var$c * x1 + $62151467eeae253b$var$s * y1, $62151467eeae253b$var$c * y1 - $62151467eeae253b$var$s * x1);
        context.lineTo($62151467eeae253b$var$c * x2 + $62151467eeae253b$var$s * y2, $62151467eeae253b$var$c * y2 - $62151467eeae253b$var$s * x2);
        context.closePath();
    }
};

});

parcelRegister("hkaay", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $lkXEB = parcelRequire("lkXEB");
var $c9cc31500139d868$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $lkXEB.sqrt)(size - (0, $lkXEB.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

});


parcelRegister("q0r9c", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $04e2c49304e4c619$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $04e2c49304e4c619$var$_default;

var $04e2c49304e4c619$var$_noop = $04e2c49304e4c619$require$_interopRequireDefault((parcelRequire("3aya2")));

var $ggnkV = parcelRequire("ggnkV");
function $04e2c49304e4c619$var$BasisClosed(context) {
    this._context = context;
}
$04e2c49304e4c619$var$BasisClosed.prototype = {
    areaStart: $04e2c49304e4c619$var$_noop.default,
    areaEnd: $04e2c49304e4c619$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $ggnkV.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $04e2c49304e4c619$var$_default(context) {
    return new $04e2c49304e4c619$var$BasisClosed(context);
}

});
parcelRegister("3aya2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24eccdef05889051$var$_default;
function $24eccdef05889051$var$_default() {}

});

parcelRegister("ggnkV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $bd703e1e63cdb1b2$var$Basis;
module.exports.default = $bd703e1e63cdb1b2$var$_default;
module.exports.point = $bd703e1e63cdb1b2$var$point;
function $bd703e1e63cdb1b2$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $bd703e1e63cdb1b2$var$Basis(context) {
    this._context = context;
}
$bd703e1e63cdb1b2$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $bd703e1e63cdb1b2$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $bd703e1e63cdb1b2$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $bd703e1e63cdb1b2$var$_default(context) {
    return new $bd703e1e63cdb1b2$var$Basis(context);
}

});


parcelRegister("3aTzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24fd69ae60dfe1af$var$_default;

var $ggnkV = parcelRequire("ggnkV");
function $24fd69ae60dfe1af$var$BasisOpen(context) {
    this._context = context;
}
$24fd69ae60dfe1af$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $ggnkV.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $24fd69ae60dfe1af$var$_default(context) {
    return new $24fd69ae60dfe1af$var$BasisOpen(context);
}

});

parcelRegister("4H5Yq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ggnkV = parcelRequire("ggnkV");
function $36afcfd36e1ac810$var$Bundle(context, beta) {
    this._basis = new $ggnkV.Basis(context);
    this._beta = beta;
}
$36afcfd36e1ac810$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $36afcfd36e1ac810$var$_default = module.exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $ggnkV.Basis(context) : new $36afcfd36e1ac810$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("hTJCI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d07af69049d58235$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $d07af69049d58235$var$CardinalClosed;
module.exports.default = void 0;

var $d07af69049d58235$var$_noop = $d07af69049d58235$require$_interopRequireDefault((parcelRequire("3aya2")));

var $jsXf0 = parcelRequire("jsXf0");
function $d07af69049d58235$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d07af69049d58235$var$CardinalClosed.prototype = {
    areaStart: $d07af69049d58235$var$_noop.default,
    areaEnd: $d07af69049d58235$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $jsXf0.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d07af69049d58235$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $d07af69049d58235$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("jsXf0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $e2be95e65c6950f5$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $e2be95e65c6950f5$var$point;
function $e2be95e65c6950f5$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $e2be95e65c6950f5$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e2be95e65c6950f5$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $e2be95e65c6950f5$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $e2be95e65c6950f5$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e2be95e65c6950f5$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $e2be95e65c6950f5$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("1NAMr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $14f6e5ddbf4ab307$var$CardinalOpen;
module.exports.default = void 0;

var $jsXf0 = parcelRequire("jsXf0");
function $14f6e5ddbf4ab307$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$14f6e5ddbf4ab307$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $jsXf0.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $14f6e5ddbf4ab307$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $14f6e5ddbf4ab307$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("1OVfE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1536dee184801b42$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hTJCI = parcelRequire("hTJCI");

var $1536dee184801b42$var$_noop = $1536dee184801b42$require$_interopRequireDefault((parcelRequire("3aya2")));

var $3ObHE = parcelRequire("3ObHE");
function $1536dee184801b42$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$1536dee184801b42$var$CatmullRomClosed.prototype = {
    areaStart: $1536dee184801b42$var$_noop.default,
    areaEnd: $1536dee184801b42$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $3ObHE.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $1536dee184801b42$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $1536dee184801b42$var$CatmullRomClosed(context, alpha) : new $hTJCI.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("3ObHE", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $lkXEB = parcelRequire("lkXEB");

var $jsXf0 = parcelRequire("jsXf0");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $lkXEB.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $lkXEB.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $jsXf0.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("1g5aj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1NAMr = parcelRequire("1NAMr");

var $3ObHE = parcelRequire("3ObHE");
function $0eab4aca2d91221d$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$0eab4aca2d91221d$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $3ObHE.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0eab4aca2d91221d$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $0eab4aca2d91221d$var$CatmullRomOpen(context, alpha) : new $1NAMr.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("hRoQJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d00aa97a77682be3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d00aa97a77682be3$var$_default;

var $d00aa97a77682be3$var$_noop = $d00aa97a77682be3$require$_interopRequireDefault((parcelRequire("3aya2")));
function $d00aa97a77682be3$var$LinearClosed(context) {
    this._context = context;
}
$d00aa97a77682be3$var$LinearClosed.prototype = {
    areaStart: $d00aa97a77682be3$var$_noop.default,
    areaEnd: $d00aa97a77682be3$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $d00aa97a77682be3$var$_default(context) {
    return new $d00aa97a77682be3$var$LinearClosed(context);
}

});

parcelRegister("kDsM0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $f05dc4f72e707db0$var$monotoneX;
module.exports.monotoneY = $f05dc4f72e707db0$var$monotoneY;
function $f05dc4f72e707db0$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $f05dc4f72e707db0$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($f05dc4f72e707db0$var$sign(s0) + $f05dc4f72e707db0$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $f05dc4f72e707db0$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $f05dc4f72e707db0$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $f05dc4f72e707db0$var$MonotoneX(context) {
    this._context = context;
}
$f05dc4f72e707db0$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $f05dc4f72e707db0$var$point(this, this._t0, $f05dc4f72e707db0$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $f05dc4f72e707db0$var$point(this, $f05dc4f72e707db0$var$slope2(this, t1 = $f05dc4f72e707db0$var$slope3(this, x, y)), t1);
                break;
            default:
                $f05dc4f72e707db0$var$point(this, this._t0, t1 = $f05dc4f72e707db0$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $f05dc4f72e707db0$var$MonotoneY(context) {
    this._context = new $f05dc4f72e707db0$var$ReflectContext(context);
}
($f05dc4f72e707db0$var$MonotoneY.prototype = Object.create($f05dc4f72e707db0$var$MonotoneX.prototype)).point = function(x, y) {
    $f05dc4f72e707db0$var$MonotoneX.prototype.point.call(this, y, x);
};
function $f05dc4f72e707db0$var$ReflectContext(context) {
    this._context = context;
}
$f05dc4f72e707db0$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $f05dc4f72e707db0$var$monotoneX(context) {
    return new $f05dc4f72e707db0$var$MonotoneX(context);
}
function $f05dc4f72e707db0$var$monotoneY(context) {
    return new $f05dc4f72e707db0$var$MonotoneY(context);
}

});

parcelRegister("e2ciD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a37acb0a4aa9e7a9$var$_default;
function $a37acb0a4aa9e7a9$var$Natural(context) {
    this._context = context;
}
$a37acb0a4aa9e7a9$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a37acb0a4aa9e7a9$var$controlPoints(x), py = $a37acb0a4aa9e7a9$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a37acb0a4aa9e7a9$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a37acb0a4aa9e7a9$var$_default(context) {
    return new $a37acb0a4aa9e7a9$var$Natural(context);
}

});

parcelRegister("co0q1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90480d110e50ecd8$var$_default;
module.exports.stepAfter = $90480d110e50ecd8$var$stepAfter;
module.exports.stepBefore = $90480d110e50ecd8$var$stepBefore;
function $90480d110e50ecd8$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$90480d110e50ecd8$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $90480d110e50ecd8$var$_default(context) {
    return new $90480d110e50ecd8$var$Step(context, 0.5);
}
function $90480d110e50ecd8$var$stepBefore(context) {
    return new $90480d110e50ecd8$var$Step(context, 0);
}
function $90480d110e50ecd8$var$stepAfter(context) {
    return new $90480d110e50ecd8$var$Step(context, 1);
}

});

parcelRegister("khrvJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ec3abc3f955cd9ff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec3abc3f955cd9ff$var$_default;

var $ec3abc3f955cd9ff$var$_array = $ec3abc3f955cd9ff$require$_interopRequireDefault((parcelRequire("krVkC")));

var $ec3abc3f955cd9ff$var$_constant = $ec3abc3f955cd9ff$require$_interopRequireDefault((parcelRequire("kpbjR")));

var $ec3abc3f955cd9ff$var$_none = $ec3abc3f955cd9ff$require$_interopRequireDefault((parcelRequire("9hblW")));

var $ec3abc3f955cd9ff$var$_none2 = $ec3abc3f955cd9ff$require$_interopRequireDefault((parcelRequire("5Sobv")));
function $ec3abc3f955cd9ff$var$stackValue(d, key) {
    return d[key];
}
function $ec3abc3f955cd9ff$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $ec3abc3f955cd9ff$var$_default() {
    var keys = (0, $ec3abc3f955cd9ff$var$_constant.default)([]), order = $ec3abc3f955cd9ff$var$_none2.default, offset = $ec3abc3f955cd9ff$var$_none.default, value = $ec3abc3f955cd9ff$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $ec3abc3f955cd9ff$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $ec3abc3f955cd9ff$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $ec3abc3f955cd9ff$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ec3abc3f955cd9ff$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $ec3abc3f955cd9ff$var$_none2.default : typeof _ === "function" ? _ : (0, $ec3abc3f955cd9ff$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $ec3abc3f955cd9ff$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("9hblW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c0e820d621db502$var$_default;
function $6c0e820d621db502$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("5Sobv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4474c1743f66adde$var$_default;
function $4474c1743f66adde$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("5SlZ9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44730cbeb152ac37$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44730cbeb152ac37$var$_default;

var $44730cbeb152ac37$var$_none = $44730cbeb152ac37$require$_interopRequireDefault((parcelRequire("9hblW")));
function $44730cbeb152ac37$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $44730cbeb152ac37$var$_none.default)(series, order);
}

});

parcelRegister("3zxc9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $299e63cdce9a5ca8$var$_default;
function $299e63cdce9a5ca8$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("iIOyC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $da138dac91c39749$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da138dac91c39749$var$_default;

var $da138dac91c39749$var$_none = $da138dac91c39749$require$_interopRequireDefault((parcelRequire("9hblW")));
function $da138dac91c39749$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $da138dac91c39749$var$_none.default)(series, order);
}

});

parcelRegister("9Wz4a", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $73d4bb460b6b1291$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73d4bb460b6b1291$var$_default;

var $73d4bb460b6b1291$var$_none = $73d4bb460b6b1291$require$_interopRequireDefault((parcelRequire("9hblW")));
function $73d4bb460b6b1291$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $73d4bb460b6b1291$var$_none.default)(series, order);
}

});

parcelRegister("hXbNK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d12119e083f52727$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d12119e083f52727$var$_default;

var $d12119e083f52727$var$_none = $d12119e083f52727$require$_interopRequireDefault((parcelRequire("5Sobv")));
function $d12119e083f52727$var$_default(series) {
    var peaks = series.map($d12119e083f52727$var$peak);
    return (0, $d12119e083f52727$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $d12119e083f52727$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("4GmFJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $368cabe36adaf86b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $368cabe36adaf86b$var$_default;
module.exports.sum = $368cabe36adaf86b$var$sum;

var $368cabe36adaf86b$var$_none = $368cabe36adaf86b$require$_interopRequireDefault((parcelRequire("5Sobv")));
function $368cabe36adaf86b$var$_default(series) {
    var sums = series.map($368cabe36adaf86b$var$sum);
    return (0, $368cabe36adaf86b$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $368cabe36adaf86b$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("dFs1Y", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9f34d904346d7bf0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f34d904346d7bf0$var$_default;

var $9f34d904346d7bf0$var$_ascending = $9f34d904346d7bf0$require$_interopRequireDefault((parcelRequire("4GmFJ")));
function $9f34d904346d7bf0$var$_default(series) {
    return (0, $9f34d904346d7bf0$var$_ascending.default)(series).reverse();
}

});

parcelRegister("lSvWx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fed76b5ee029c26e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fed76b5ee029c26e$var$_default;

var $fed76b5ee029c26e$var$_appearance = $fed76b5ee029c26e$require$_interopRequireDefault((parcelRequire("hXbNK")));

var $4GmFJ = parcelRequire("4GmFJ");
function $fed76b5ee029c26e$var$_default(series) {
    var n = series.length, i, j, sums = series.map($4GmFJ.sum), order = (0, $fed76b5ee029c26e$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("eUF0z", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adb61b03b3466b9f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adb61b03b3466b9f$var$_default;

var $adb61b03b3466b9f$var$_none = $adb61b03b3466b9f$require$_interopRequireDefault((parcelRequire("5Sobv")));
function $adb61b03b3466b9f$var$_default(series) {
    return (0, $adb61b03b3466b9f$var$_none.default)(series).reverse();
}

});




parcelRegister("8nfaR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aPOGZ = parcelRequire("aPOGZ");
Object.keys($aPOGZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aPOGZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aPOGZ[key];
        }
    });
});

});
parcelRegister("aPOGZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getStackingGroups = module.exports.StackOrder = module.exports.StackOffset = void 0;

var $6hlpT = parcelRequire("6hlpT");

var $dmMaf = parcelRequire("dmMaf");
const $7e35fd4404bc43e3$var$StackOrder = module.exports.StackOrder = {
    /**
   * Series order such that the earliest series (according to the maximum value) is at the bottom.
   * */ appearance: $6hlpT.stackOrderAppearance,
    /**
   *  Series order such that the smallest series (according to the sum of values) is at the bottom.
   * */ ascending: $6hlpT.stackOrderAscending,
    /**
   * Series order such that the largest series (according to the sum of values) is at the bottom.
   */ descending: $6hlpT.stackOrderDescending,
    /**
   * Series order such that the earliest series (according to the maximum value) are on the inside and the later series are on the outside. This order is recommended for streamgraphs in conjunction with the wiggle offset. See Stacked Graphs—Geometry & Aesthetics by Byron & Wattenberg for more information.
   */ insideOut: $6hlpT.stackOrderInsideOut,
    /**
   * Given series order [0, 1, … n - 1] where n is the number of elements in series. Thus, the stack order is given by the key accessor.
   */ none: $6hlpT.stackOrderNone,
    /**
   * Reverse of the given series order [n - 1, n - 2, … 0] where n is the number of elements in series. Thus, the stack order is given by the reverse of the key accessor.
   */ reverse: $6hlpT.stackOrderReverse
};
const $7e35fd4404bc43e3$var$StackOffset = module.exports.StackOffset = {
    /**
   * Applies a zero baseline and normalizes the values for each point such that the topline is always one.
   * */ expand: $6hlpT.stackOffsetExpand,
    /**
   * Positive values are stacked above zero, negative values are stacked below zero, and zero values are stacked at zero.
   * */ // @ts-expect-error, d3 types are wrong, our custom function implements the correct signature
    diverging: $dmMaf.offsetDiverging,
    /**
   * Applies a zero baseline.
   * */ none: $6hlpT.stackOffsetNone,
    /**
   * Shifts the baseline down such that the center of the streamgraph is always at zero.
   * */ silhouette: $6hlpT.stackOffsetSilhouette,
    /**
   * Shifts the baseline so as to minimize the weighted wiggle of layers. This offset is recommended for streamgraphs in conjunction with the inside-out order. See Stacked Graphs—Geometry & Aesthetics by Bryon & Wattenberg for more information.
   * */ wiggle: $6hlpT.stackOffsetWiggle
};
/**
 * Takes a set of series and groups their ids
 * @param series the object of all bars series
 * @returns an array of groups, including the ids, the stacking order, and the stacking offset.
 */ const $7e35fd4404bc43e3$var$getStackingGroups = (params)=>{
    const { series: series, seriesOrder: seriesOrder, defaultStrategy: defaultStrategy } = params;
    const stackingGroups = [];
    const stackIndex = {};
    seriesOrder.forEach((id)=>{
        const { stack: stack, stackOrder: stackOrder, stackOffset: stackOffset } = series[id];
        if (stack === undefined) stackingGroups.push({
            ids: [
                id
            ],
            stackingOrder: $7e35fd4404bc43e3$var$StackOrder.none,
            stackingOffset: $7e35fd4404bc43e3$var$StackOffset.none
        });
        else if (stackIndex[stack] === undefined) {
            stackIndex[stack] = stackingGroups.length;
            stackingGroups.push({
                ids: [
                    id
                ],
                stackingOrder: $7e35fd4404bc43e3$var$StackOrder[stackOrder ?? defaultStrategy?.stackOrder ?? 'none'],
                stackingOffset: $7e35fd4404bc43e3$var$StackOffset[stackOffset ?? defaultStrategy?.stackOffset ?? 'diverging']
            });
        } else {
            stackingGroups[stackIndex[stack]].ids.push(id);
            if (stackOrder !== undefined) stackingGroups[stackIndex[stack]].stackingOrder = $7e35fd4404bc43e3$var$StackOrder[stackOrder];
            if (stackOffset !== undefined) stackingGroups[stackIndex[stack]].stackingOffset = $7e35fd4404bc43e3$var$StackOffset[stackOffset];
        }
    });
    return stackingGroups;
};
module.exports.getStackingGroups = $7e35fd4404bc43e3$var$getStackingGroups;

});
parcelRegister("dmMaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9ZomN = parcelRequire("9ZomN");
Object.keys($9ZomN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9ZomN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9ZomN[key];
        }
    });
});

});
parcelRegister("9ZomN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.offsetDiverging = $745cb6446aa82677$var$offsetDiverging;
// Adapted from D3.js's offsetDiverging function https://github.com/d3/d3-shape/blob/main/src/offset/diverging.js
// Hidden series (with all zero values) affect the stacking in a different way in our implementation compared to the D3 behavior.
// The D3 stacking keep those values at the 0 "line", which creates issues when animating between hidden and visible states.
// In our modification, we stack them on top/below already stacked items according to the sign of their original value.
// A hidden negative value will be placed below all the already stacked negative values
/**
 * Positive values are stacked above zero, while negative values are stacked below zero.
 *
 * @param series A series generated by a stack generator.
 * @param order An array of numeric indexes representing the stack order.
 */ function $745cb6446aa82677$var$offsetDiverging(series, order) {
    if (series.length === 0) return;
    const seriesCount = series.length;
    const numericOrder = order;
    const pointCount = series[numericOrder[0]].length;
    for(let pointIndex = 0; pointIndex < pointCount; pointIndex += 1){
        let positiveSum = 0;
        let negativeSum = 0;
        for(let seriesIndex = 0; seriesIndex < seriesCount; seriesIndex += 1){
            const currentSeries = series[numericOrder[seriesIndex]];
            const dataPoint = currentSeries[pointIndex];
            const difference = dataPoint[1] - dataPoint[0];
            if (difference > 0) {
                dataPoint[0] = positiveSum;
                positiveSum += difference;
                dataPoint[1] = positiveSum;
            } else if (difference < 0) {
                dataPoint[1] = negativeSum;
                negativeSum += difference;
                dataPoint[0] = negativeSum;
            } else if (dataPoint.data[currentSeries.key] > 0) {
                dataPoint[0] = positiveSum;
                dataPoint[1] = positiveSum;
            } else if (dataPoint.data[currentSeries.key] < 0) {
                dataPoint[1] = negativeSum;
                dataPoint[0] = negativeSum;
            } else {
                dataPoint[0] = 0;
                dataPoint[1] = 0;
            }
        }
    }
}

});





parcelRegister("io7oO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $erYIG = parcelRequire("erYIG");
const $d6303530bbdde136$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $erYIG.getLabel)(series[seriesId].label, 'legend');
        if (formattedLabel === undefined) return acc;
        acc.push({
            type: 'bar',
            markType: series[seriesId].labelMarkType,
            id: seriesId,
            seriesId: seriesId,
            color: series[seriesId].color,
            label: formattedLabel
        });
        return acc;
    }, []);
};
var $d6303530bbdde136$var$_default = module.exports.default = $d6303530bbdde136$var$legendGetter;

});
parcelRegister("erYIG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLabel = $a852aff5b0ebe13c$var$getLabel;
function $a852aff5b0ebe13c$var$getLabel(value, location) {
    return typeof value === 'function' ? value(location) : value;
}

});


parcelRegister("f25WF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fAIz6 = parcelRequire("fAIz6");
const $af1ba7827712fbf6$var$getColor = (series, xAxis, yAxis)=>{
    const verticalLayout = series.layout === 'vertical';
    const bandColorScale = verticalLayout ? xAxis?.colorScale : yAxis?.colorScale;
    const valueColorScale = verticalLayout ? yAxis?.colorScale : xAxis?.colorScale;
    const bandValues = verticalLayout ? xAxis?.data : yAxis?.data;
    const getSeriesColor = (0, $fAIz6.getSeriesColorFn)(series);
    if (valueColorScale) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : valueColorScale(value);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    if (bandColorScale && bandValues) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = bandValues[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : bandColorScale(value);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
    };
};
var $af1ba7827712fbf6$var$_default = module.exports.default = $af1ba7827712fbf6$var$getColor;

});
parcelRegister("fAIz6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSeriesColorFn = $b59cc9813d7d74cc$var$getSeriesColorFn;
function $b59cc9813d7d74cc$var$getSeriesColorFn(series) {
    return series.colorGetter ? series.colorGetter : ()=>series.color;
}

});


parcelRegister("kGKe6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fWTNT = parcelRequire("fWTNT");
const $f0fb9682a5ea6693$var$outSeriesTypes = new Set([
    'bar',
    'line',
    'scatter'
]);
const $f0fb9682a5ea6693$var$keyboardFocusHandler = (event)=>{
    switch(event.key){
        case 'ArrowRight':
            return (0, $fWTNT.createGetNextIndexFocusedItem)($f0fb9682a5ea6693$var$outSeriesTypes);
        case 'ArrowLeft':
            return (0, $fWTNT.createGetPreviousIndexFocusedItem)($f0fb9682a5ea6693$var$outSeriesTypes);
        case 'ArrowDown':
            return (0, $fWTNT.createGetPreviousSeriesFocusedItem)($f0fb9682a5ea6693$var$outSeriesTypes);
        case 'ArrowUp':
            return (0, $fWTNT.createGetNextSeriesFocusedItem)($f0fb9682a5ea6693$var$outSeriesTypes);
        default:
            return null;
    }
};
var $f0fb9682a5ea6693$var$_default = module.exports.default = $f0fb9682a5ea6693$var$keyboardFocusHandler;

});
parcelRegister("fWTNT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetNextIndexFocusedItem = $b9c78f3ec662981d$var$createGetNextIndexFocusedItem;
module.exports.createGetNextSeriesFocusedItem = $b9c78f3ec662981d$var$createGetNextSeriesFocusedItem;
module.exports.createGetPreviousIndexFocusedItem = $b9c78f3ec662981d$var$createGetPreviousIndexFocusedItem;
module.exports.createGetPreviousSeriesFocusedItem = $b9c78f3ec662981d$var$createGetPreviousSeriesFocusedItem;

var $cwtqr = parcelRequire("cwtqr");

var $ftObm = parcelRequire("ftObm");

var $1k3ob = parcelRequire("1k3ob");

var $hRLVU = parcelRequire("hRLVU");

var $d69u7 = parcelRequire("d69u7");
function $b9c78f3ec662981d$var$createGetNextIndexFocusedItem(/**
 * The set of series types compatible with this navigation action.
 */ compatibleSeriesTypes, /**
 * If true, allows cycling from the last item to the first one.
 */ allowCycles = false) {
    return function getNextIndexFocusedItem(currentItem, state) {
        const processedSeries = (0, $1k3ob.selectorChartSeriesProcessed)(state);
        let seriesId = currentItem?.seriesId;
        let type = currentItem?.type;
        if (!type || seriesId == null || !(0, $d69u7.seriesHasData)(processedSeries, type, seriesId)) {
            const nextSeries = (0, $hRLVU.getNextNonEmptySeries)(processedSeries, compatibleSeriesTypes, type, seriesId);
            if (nextSeries === null) return null;
            type = nextSeries.type;
            seriesId = nextSeries.seriesId;
        }
        const maxLength = (0, $ftObm.getMaxSeriesLength)(processedSeries, compatibleSeriesTypes);
        let dataIndex = currentItem?.dataIndex == null ? 0 : currentItem.dataIndex + 1;
        if (allowCycles) dataIndex = dataIndex % maxLength;
        else dataIndex = Math.min(maxLength - 1, dataIndex);
        return {
            type: type,
            seriesId: seriesId,
            dataIndex: dataIndex
        };
    };
}
function $b9c78f3ec662981d$var$createGetPreviousIndexFocusedItem(/**
 * The set of series types compatible with this navigation action.
 */ compatibleSeriesTypes, /**
 * If true, allows cycling from the last item to the first one.
 */ allowCycles = false) {
    return function getPreviousIndexFocusedItem(currentItem, state) {
        const processedSeries = (0, $1k3ob.selectorChartSeriesProcessed)(state);
        let seriesId = currentItem?.seriesId;
        let type = currentItem?.type;
        if (!type || seriesId == null || !(0, $d69u7.seriesHasData)(processedSeries, type, seriesId)) {
            const previousSeries = (0, $cwtqr.getPreviousNonEmptySeries)(processedSeries, compatibleSeriesTypes, type, seriesId);
            if (previousSeries === null) return null;
            type = previousSeries.type;
            seriesId = previousSeries.seriesId;
        }
        const maxLength = (0, $ftObm.getMaxSeriesLength)(processedSeries, compatibleSeriesTypes);
        let dataIndex = currentItem?.dataIndex == null ? maxLength - 1 : currentItem.dataIndex - 1;
        if (allowCycles) dataIndex = (maxLength + dataIndex) % maxLength;
        else dataIndex = Math.max(0, dataIndex);
        return {
            type: type,
            seriesId: seriesId,
            dataIndex: dataIndex
        };
    };
}
function $b9c78f3ec662981d$var$createGetNextSeriesFocusedItem(/**
 * The set of series types compatible with this navigation action.
 */ compatibleSeriesTypes) {
    return function getNextSeriesFocusedItem(currentItem, state) {
        const processedSeries = (0, $1k3ob.selectorChartSeriesProcessed)(state);
        let seriesId = currentItem?.seriesId;
        let type = currentItem?.type;
        const nextSeries = (0, $hRLVU.getNextNonEmptySeries)(processedSeries, compatibleSeriesTypes, type, seriesId);
        if (nextSeries === null) return null; // No series to move the focus to.
        type = nextSeries.type;
        seriesId = nextSeries.seriesId;
        const dataIndex = currentItem?.dataIndex == null ? 0 : currentItem.dataIndex;
        return {
            type: type,
            seriesId: seriesId,
            dataIndex: dataIndex
        };
    };
}
function $b9c78f3ec662981d$var$createGetPreviousSeriesFocusedItem(/**
 * The set of series types compatible with this navigation action.
 */ compatibleSeriesTypes) {
    return function getPreviousSeriesFocusedItem(currentItem, state) {
        const processedSeries = (0, $1k3ob.selectorChartSeriesProcessed)(state);
        let seriesId = currentItem?.seriesId;
        let type = currentItem?.type;
        const previousSeries = (0, $cwtqr.getPreviousNonEmptySeries)(processedSeries, compatibleSeriesTypes, type, seriesId);
        if (previousSeries === null) return null; // No series to move the focus to.
        type = previousSeries.type;
        seriesId = previousSeries.seriesId;
        const data = processedSeries[type].series[seriesId].data;
        const dataIndex = currentItem?.dataIndex == null ? data.length - 1 : currentItem.dataIndex;
        return {
            type: type,
            seriesId: seriesId,
            dataIndex: dataIndex
        };
    };
}

});
parcelRegister("cwtqr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPreviousNonEmptySeries = $91df4c7960bbe07f$var$getPreviousNonEmptySeries;

var $5Nvsk = parcelRequire("5Nvsk");
/**
 * Returns the previous series type and id that contains some data.
 * Returns `null` if no other series have data.
 */ function $91df4c7960bbe07f$var$getPreviousNonEmptySeries(series, availableSeriesTypes, type, seriesId) {
    const nonEmptySeries = (0, $5Nvsk.getNonEmptySeriesArray)(series, availableSeriesTypes);
    if (nonEmptySeries.length === 0) return null;
    const currentSeriesIndex = type !== undefined && seriesId !== undefined ? nonEmptySeries.findIndex((seriesItem)=>seriesItem.type === type && seriesItem.seriesId === seriesId) : -1;
    if (currentSeriesIndex <= 0) // If no current series, or if it's the first series
    return nonEmptySeries[nonEmptySeries.length - 1];
    return nonEmptySeries[(currentSeriesIndex - 1 + nonEmptySeries.length) % nonEmptySeries.length];
}

});
parcelRegister("5Nvsk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNonEmptySeriesArray = $4389edd4aa527c3e$var$getNonEmptySeriesArray;
function $4389edd4aa527c3e$var$getNonEmptySeriesArray(series, availableSeriesTypes) {
    return Object.keys(series).filter((type)=>availableSeriesTypes.has(type)).flatMap((type)=>{
        const seriesOfType = series[type];
        return seriesOfType.seriesOrder.filter((seriesId)=>seriesOfType.series[seriesId].data.length > 0 && seriesOfType.series[seriesId].data.some((value)=>value != null)).map((seriesId)=>({
                type: type,
                seriesId: seriesId
            }));
    });
}

});


parcelRegister("ftObm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMaxSeriesLength = $b4507d99e625b3e9$var$getMaxSeriesLength;
function $b4507d99e625b3e9$var$getMaxSeriesLength(series, availableSeriesTypes) {
    return Object.keys(series).filter((type)=>availableSeriesTypes.has(type)).flatMap((type)=>{
        const seriesOfType = series[type];
        return seriesOfType.seriesOrder.filter((seriesId)=>seriesOfType.series[seriesId].data.length > 0 && seriesOfType.series[seriesId].data.some((value)=>value != null)).map((seriesId)=>seriesOfType.series[seriesId].data.length);
    }).reduce((maxLengths, length)=>Math.max(maxLengths, length), 0);
}

});

parcelRegister("hRLVU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNextNonEmptySeries = $d01c9165afc33630$var$getNextNonEmptySeries;

var $5Nvsk = parcelRequire("5Nvsk");
/**
 * Returns the next series type and id that contains some data.
 * Returns `null` if no other series have data.
 * @param series - The processed series from the store.
 * @param availableSeriesTypes - The set of series types that can be focused.
 * @param type - The current series type.
 * @param seriesId - The current series id.
 */ function $d01c9165afc33630$var$getNextNonEmptySeries(series, availableSeriesTypes, type, seriesId) {
    const nonEmptySeries = (0, $5Nvsk.getNonEmptySeriesArray)(series, availableSeriesTypes);
    if (nonEmptySeries.length === 0) return null;
    const currentSeriesIndex = type !== undefined && seriesId !== undefined ? nonEmptySeries.findIndex((seriesItem)=>seriesItem.type === type && seriesItem.seriesId === seriesId) : -1;
    return nonEmptySeries[(currentSeriesIndex + 1) % nonEmptySeries.length];
}

});

parcelRegister("d69u7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seriesHasData = $989331660531853a$var$seriesHasData;
function $989331660531853a$var$seriesHasData(series, type, seriesId) {
    // @ts-ignore sankey is not in MIT version
    if (type === 'sankey') return false;
    const data = series[type]?.series[seriesId]?.data;
    return data != null && data.length > 0;
}

});



parcelRegister("b2xBU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.axisTooltipGetter = void 0;

var $erYIG = parcelRequire("erYIG");
const $8099f3ed26795f4f$var$tooltipGetter = (params)=>{
    const { series: series, getColor: getColor, identifier: identifier } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const label = (0, $erYIG.getLabel)(series.label, 'tooltip');
    const value = series.data[identifier.dataIndex];
    if (value == null) return null;
    const formattedValue = series.valueFormatter(value, {
        dataIndex: identifier.dataIndex
    });
    return {
        identifier: identifier,
        color: getColor(identifier.dataIndex),
        label: label,
        value: value,
        formattedValue: formattedValue,
        markType: series.labelMarkType
    };
};
const $8099f3ed26795f4f$var$axisTooltipGetter = (series)=>{
    return Object.values(series).map((s)=>s.layout === 'horizontal' ? {
            direction: 'y',
            axisId: s.yAxisId
        } : {
            direction: 'x',
            axisId: s.xAxisId
        });
};
module.exports.axisTooltipGetter = $8099f3ed26795f4f$var$axisTooltipGetter;
var $8099f3ed26795f4f$var$_default = module.exports.default = $8099f3ed26795f4f$var$tooltipGetter;

});

parcelRegister("fQPB8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $g5ldX = parcelRequire("g5ldX");
const $b8a3bc9f3f560057$var$tooltipItemPositionGetter = (params)=>{
    const { series: series, identifier: identifier, axesConfig: axesConfig, placement: placement } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const itemSeries = series.bar?.series[identifier.seriesId];
    if (series.bar == null || itemSeries == null) return null;
    if (axesConfig.x === undefined || axesConfig.y === undefined) return null;
    const dimensions = (0, $g5ldX.getBarDimensions)({
        verticalLayout: itemSeries.layout === 'vertical',
        xAxisConfig: axesConfig.x,
        yAxisConfig: axesConfig.y,
        series: itemSeries,
        dataIndex: identifier.dataIndex,
        numberOfGroups: series.bar.stackingGroups.length,
        groupIndex: series.bar.stackingGroups.findIndex((group)=>group.ids.includes(itemSeries.id))
    });
    if (dimensions == null) return null;
    const { x: x, y: y, width: width, height: height } = dimensions;
    switch(placement){
        case 'right':
            return {
                x: x + width,
                y: y + height / 2
            };
        case 'bottom':
            return {
                x: x + width / 2,
                y: y + height
            };
        case 'left':
            return {
                x: x,
                y: y + height / 2
            };
        case 'top':
        default:
            return {
                x: x + width / 2,
                y: y
            };
    }
};
var $b8a3bc9f3f560057$var$_default = module.exports.default = $b8a3bc9f3f560057$var$tooltipItemPositionGetter;

});
parcelRegister("g5ldX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBarDimensions = $bb5d939ff7ce5c9e$var$getBarDimensions;

var $42j0p = parcelRequire("42j0p");

var $6upLo = parcelRequire("6upLo");
function $bb5d939ff7ce5c9e$var$shouldInvertStartCoordinate(verticalLayout, baseValue, reverse) {
    const isVerticalAndPositive = verticalLayout && baseValue > 0;
    const isHorizontalAndNegative = !verticalLayout && baseValue < 0;
    const invertStartCoordinate = isVerticalAndPositive || isHorizontalAndNegative;
    return reverse ? !invertStartCoordinate : invertStartCoordinate;
}
function $bb5d939ff7ce5c9e$var$getBarDimensions(params) {
    const { verticalLayout: verticalLayout, xAxisConfig: xAxisConfig, yAxisConfig: yAxisConfig, series: series, dataIndex: dataIndex, numberOfGroups: numberOfGroups, groupIndex: groupIndex } = params;
    const baseScaleConfig = verticalLayout ? xAxisConfig : yAxisConfig;
    const reverse = (verticalLayout ? yAxisConfig.reverse : xAxisConfig.reverse) ?? false;
    const { barWidth: barWidth, offset: offset } = (0, $6upLo.getBandSize)(baseScaleConfig.scale.bandwidth(), numberOfGroups, baseScaleConfig.barGapRatio);
    const barOffset = groupIndex * (barWidth + offset);
    const xScale = xAxisConfig.scale;
    const yScale = yAxisConfig.scale;
    const baseValue = baseScaleConfig.data[dataIndex];
    const seriesValue = series.data[dataIndex];
    if (seriesValue == null) return null;
    const values = series.visibleStackedData[dataIndex];
    const valueCoordinates = values.map((v)=>verticalLayout ? yScale(v) : xScale(v));
    const [minValueCoord, maxValueCoord] = (0, $42j0p.findMinMax)(valueCoordinates).map((v)=>Math.round(v));
    let barSize = 0;
    if (seriesValue !== 0) {
        if (!series.hidden) barSize = Math.max(series.minBarSize, maxValueCoord - minValueCoord);
    }
    const shouldInvert = $bb5d939ff7ce5c9e$var$shouldInvertStartCoordinate(verticalLayout, seriesValue, reverse);
    let startCoordinate = 0;
    if (shouldInvert) startCoordinate = maxValueCoord - barSize;
    else startCoordinate = minValueCoord;
    return {
        x: verticalLayout ? xScale(baseValue) + barOffset : startCoordinate,
        y: verticalLayout ? startCoordinate : yScale(baseValue) + barOffset,
        height: verticalLayout ? barSize : barWidth,
        width: verticalLayout ? barWidth : barSize
    };
}

});
parcelRegister("6upLo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBandSize = $4b99877ba628ae1e$var$getBandSize;
/**
 * Solution of the equations
 * W = barWidth * N + offset * (N-1)
 * offset / (offset + barWidth) = r
 * @param bandWidth (W) The width available to place bars.
 * @param groupCount (N) The number of bars to place in that space.
 * @param gapRatio (r) The ratio of the gap between bars over the bar width.
 * @returns The bar width and the offset between bars.
 */ function $4b99877ba628ae1e$var$getBandSize(bandWidth, groupCount, gapRatio) {
    if (gapRatio === 0) return {
        barWidth: bandWidth / groupCount,
        offset: 0
    };
    const barWidth = bandWidth / (groupCount + (groupCount - 1) * gapRatio);
    const offset = gapRatio * barWidth;
    return {
        barWidth: barWidth,
        offset: offset
    };
}

});



parcelRegister("9JLts", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $716d246225839291$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSeriesWithDefaultValues = $716d246225839291$var$getSeriesWithDefaultValues;

var $716d246225839291$var$_extends2 = $716d246225839291$require$_interopRequireDefault((parcelRequire("3p9rK")));
function $716d246225839291$var$getSeriesWithDefaultValues(seriesData, seriesIndex, colors) {
    return (0, $716d246225839291$var$_extends2.default)({}, seriesData, {
        id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
        color: seriesData.color ?? colors[seriesIndex % colors.length]
    });
}

});

parcelRegister("jtEpx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typeSerializer = module.exports.seriesIdSerializer = module.exports.identifierSerializerSeriesIdDataIndex = module.exports.dataIndexSerializer = void 0;
const $e2e01282a81b14f0$var$typeSerializer = (type)=>`Type(${type})`;
module.exports.typeSerializer = $e2e01282a81b14f0$var$typeSerializer;
const $e2e01282a81b14f0$var$seriesIdSerializer = (id)=>`Series(${id})`;
module.exports.seriesIdSerializer = $e2e01282a81b14f0$var$seriesIdSerializer;
const $e2e01282a81b14f0$var$dataIndexSerializer = (dataIndex)=>dataIndex === undefined ? '' : `Index(${dataIndex})`;
module.exports.dataIndexSerializer = $e2e01282a81b14f0$var$dataIndexSerializer;
const $e2e01282a81b14f0$var$identifierSerializerSeriesIdDataIndex = (identifier)=>{
    return `${$e2e01282a81b14f0$var$typeSerializer(identifier.type)}${$e2e01282a81b14f0$var$seriesIdSerializer(identifier.seriesId)}${$e2e01282a81b14f0$var$dataIndexSerializer(identifier.dataIndex)}`;
};
module.exports.identifierSerializerSeriesIdDataIndex = $e2e01282a81b14f0$var$identifierSerializerSeriesIdDataIndex;

});


parcelRegister("hWEs8", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d1073b86744d37d3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d1073b86744d37d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lineSeriesConfig = void 0;

var $7pSdY = parcelRequire("7pSdY");

var $d1073b86744d37d3$var$_seriesProcessor = $d1073b86744d37d3$require$_interopRequireDefault((parcelRequire("LGZiO")));

var $d1073b86744d37d3$var$_getColor = $d1073b86744d37d3$require$_interopRequireDefault((parcelRequire("2tsDz")));

var $d1073b86744d37d3$var$_legend = $d1073b86744d37d3$require$_interopRequireDefault((parcelRequire("224EP")));

var $d1073b86744d37d3$var$_tooltip = $d1073b86744d37d3$require$_interopRequireWildcard((parcelRequire("csX4a")));

var $d1073b86744d37d3$var$_getSeriesWithDefaultValues = $d1073b86744d37d3$require$_interopRequireDefault((parcelRequire("ey5fi")));

var $d1073b86744d37d3$var$_tooltipPosition = $d1073b86744d37d3$require$_interopRequireDefault((parcelRequire("lPoDq")));

var $d1073b86744d37d3$var$_keyboardFocusHandler = $d1073b86744d37d3$require$_interopRequireDefault((parcelRequire("aLeuk")));

var $jtEpx = parcelRequire("jtEpx");
const $d1073b86744d37d3$var$lineSeriesConfig = module.exports.lineSeriesConfig = {
    colorProcessor: $d1073b86744d37d3$var$_getColor.default,
    seriesProcessor: $d1073b86744d37d3$var$_seriesProcessor.default,
    legendGetter: $d1073b86744d37d3$var$_legend.default,
    tooltipGetter: $d1073b86744d37d3$var$_tooltip.default,
    tooltipItemPositionGetter: $d1073b86744d37d3$var$_tooltipPosition.default,
    axisTooltipGetter: $d1073b86744d37d3$var$_tooltip.axisTooltipGetter,
    xExtremumGetter: $7pSdY.getExtremumX,
    yExtremumGetter: $7pSdY.getExtremumY,
    getSeriesWithDefaultValues: $d1073b86744d37d3$var$_getSeriesWithDefaultValues.default,
    keyboardFocusHandler: $d1073b86744d37d3$var$_keyboardFocusHandler.default,
    identifierSerializer: $jtEpx.identifierSerializerSeriesIdDataIndex
};

});
parcelRegister("7pSdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getExtremumY = module.exports.getExtremumX = void 0;

var $42j0p = parcelRequire("42j0p");
const $5664ee05e79d69d5$var$getExtremumX = (params)=>{
    const { axis: axis } = params;
    return (0, $42j0p.findMinMax)(axis.data ?? []);
};
module.exports.getExtremumX = $5664ee05e79d69d5$var$getExtremumX;
function $5664ee05e79d69d5$var$getSeriesExtremums(getValues, data, stackedData, filter) {
    return stackedData.reduce((seriesAcc, stackedValue, index)=>{
        if (data[index] === null) return seriesAcc;
        const [base, value] = getValues(stackedValue);
        if (filter && (!filter({
            y: base,
            x: null
        }, index) || !filter({
            y: value,
            x: null
        }, index))) return seriesAcc;
        return [
            Math.min(base, value, seriesAcc[0]),
            Math.max(base, value, seriesAcc[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
}
const $5664ee05e79d69d5$var$getExtremumY = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis, getFilters: getFilters } = params;
    return Object.keys(series).filter((seriesId)=>{
        const yAxisId = series[seriesId].yAxisId;
        return yAxisId === axis.id || isDefaultAxis && yAxisId === undefined;
    }).reduce((acc, seriesId)=>{
        const { area: area, stackedData: stackedData, data: data } = series[seriesId];
        const isArea = area !== undefined;
        const filter = getFilters?.({
            currentAxisId: axis.id,
            isDefaultAxis: isDefaultAxis,
            seriesXAxisId: series[seriesId].xAxisId,
            seriesYAxisId: series[seriesId].yAxisId
        });
        // Since this series is not used to display an area, we do not consider the base (the d[0]).
        const getValues = isArea && axis.scaleType !== 'log' && typeof series[seriesId].baseline !== 'string' ? (d)=>d : (d)=>[
                d[1],
                d[1]
            ];
        const seriesExtremums = $5664ee05e79d69d5$var$getSeriesExtremums(getValues, data, stackedData, filter);
        const [seriesMin, seriesMax] = seriesExtremums;
        return [
            Math.min(seriesMin, acc[0]),
            Math.max(seriesMax, acc[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
module.exports.getExtremumY = $5664ee05e79d69d5$var$getExtremumY;

});

parcelRegister("LGZiO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $08f5bc5f55345673$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08f5bc5f55345673$var$_extends2 = $08f5bc5f55345673$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6hlpT = parcelRequire("6hlpT");


var $8nfaR = parcelRequire("8nfaR");
const $08f5bc5f55345673$var$lineValueFormatter = (v)=>v == null ? '' : v.toLocaleString();
const $08f5bc5f55345673$var$seriesProcessor = (params, dataset, isItemVisible)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    const stackingGroups = (0, $8nfaR.getStackingGroups)((0, $08f5bc5f55345673$var$_extends2.default)({}, params, {
        defaultStrategy: {
            stackOffset: 'none'
        }
    }));
    // Create a data set with format adapted to d3
    const d3Dataset = dataset ?? [];
    seriesOrder.forEach((id)=>{
        const data = series[id].data;
        if (data !== undefined) data.forEach((value, index)=>{
            if (d3Dataset.length <= index) d3Dataset.push({
                [id]: value
            });
            else d3Dataset[index][id] = value;
        });
        var entry, index;
    });
    const completedSeries = {};
    stackingGroups.forEach((stackingGroup)=>{
        const { ids: ids, stackingOffset: stackingOffset, stackingOrder: stackingOrder } = stackingGroup;
        const keys = ids.map((id)=>{
            // Use dataKey if needed and available
            const dataKey = series[id].dataKey;
            return series[id].data === undefined && dataKey !== undefined ? dataKey : id;
        });
        const stackedData = (0, $6hlpT.stack)().keys(keys).value((d, key)=>d[key] ?? 0) // defaultize null value to 0
        .order(stackingOrder).offset(stackingOffset)(d3Dataset);
        const idOrder = stackedData.map((s)=>s.index);
        const fixedOrder = ()=>idOrder;
        // Compute visible stacked data
        const visibleStackedData = (0, $6hlpT.stack)().keys(keys).value((d, key)=>{
            const keyIndex = keys.indexOf(key);
            const seriesId = ids[keyIndex];
            if (!isItemVisible?.({
                type: 'line',
                seriesId: seriesId
            })) // For hidden series, return 0 so they don't contribute to the stack
            return 0;
            return d[key] ?? 0;
        }).order(fixedOrder).offset(stackingOffset)(d3Dataset);
        ids.forEach((id, index)=>{
            const dataKey = series[id].dataKey;
            const data = dataKey ? dataset.map((d)=>{
                const value = d[dataKey];
                return typeof value === 'number' ? value : null;
            }) : series[id].data;
            const hidden = !isItemVisible?.({
                type: 'line',
                seriesId: id
            });
            completedSeries[id] = (0, $08f5bc5f55345673$var$_extends2.default)({
                labelMarkType: 'line'
            }, series[id], {
                data: data,
                valueFormatter: series[id].valueFormatter ?? $08f5bc5f55345673$var$lineValueFormatter,
                hidden: hidden,
                stackedData: stackedData[index],
                visibleStackedData: visibleStackedData[index]
            });
        });
    });
    return {
        seriesOrder: seriesOrder,
        stackingGroups: stackingGroups,
        series: completedSeries
    };
};
var $08f5bc5f55345673$var$_default = module.exports.default = $08f5bc5f55345673$var$seriesProcessor;

});

parcelRegister("2tsDz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fAIz6 = parcelRequire("fAIz6");
const $1cd480fbe8d1cdf5$var$getColor = (series, xAxis, yAxis)=>{
    const yColorScale = yAxis?.colorScale;
    const xColorScale = xAxis?.colorScale;
    const getSeriesColor = (0, $fAIz6.getSeriesColorFn)(series);
    if (yColorScale) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : yColorScale(value);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    if (xColorScale) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = xAxis.data?.[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : xColorScale(value);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
    };
};
var $1cd480fbe8d1cdf5$var$_default = module.exports.default = $1cd480fbe8d1cdf5$var$getColor;

});

parcelRegister("224EP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $erYIG = parcelRequire("erYIG");
const $17af618cfc07b7f3$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $erYIG.getLabel)(series[seriesId].label, 'legend');
        if (formattedLabel === undefined) return acc;
        acc.push({
            type: 'line',
            markType: series[seriesId].labelMarkType,
            id: seriesId,
            seriesId: seriesId,
            color: series[seriesId].color,
            label: formattedLabel
        });
        return acc;
    }, []);
};
var $17af618cfc07b7f3$var$_default = module.exports.default = $17af618cfc07b7f3$var$legendGetter;

});

parcelRegister("csX4a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.axisTooltipGetter = void 0;

var $erYIG = parcelRequire("erYIG");
const $9135eae2a5627062$var$tooltipGetter = (params)=>{
    const { series: series, getColor: getColor, identifier: identifier } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const label = (0, $erYIG.getLabel)(series.label, 'tooltip');
    const value = series.data[identifier.dataIndex];
    const formattedValue = series.valueFormatter(value, {
        dataIndex: identifier.dataIndex
    });
    return {
        identifier: identifier,
        color: getColor(identifier.dataIndex),
        label: label,
        value: value,
        formattedValue: formattedValue,
        markType: series.labelMarkType
    };
};
const $9135eae2a5627062$var$axisTooltipGetter = (series)=>{
    return Object.values(series).map((s)=>({
            direction: 'x',
            axisId: s.xAxisId
        }));
};
module.exports.axisTooltipGetter = $9135eae2a5627062$var$axisTooltipGetter;
var $9135eae2a5627062$var$_default = module.exports.default = $9135eae2a5627062$var$tooltipGetter;

});

parcelRegister("ey5fi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a9784f5d8e37c6d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9784f5d8e37c6d9$var$_extends2 = $a9784f5d8e37c6d9$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $a9784f5d8e37c6d9$var$getSeriesWithDefaultValues = (seriesData, seriesIndex, colors)=>{
    return (0, $a9784f5d8e37c6d9$var$_extends2.default)({}, seriesData, {
        id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
        color: seriesData.color ?? colors[seriesIndex % colors.length]
    });
};
var $a9784f5d8e37c6d9$var$_default = module.exports.default = $a9784f5d8e37c6d9$var$getSeriesWithDefaultValues;

});

parcelRegister("lPoDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $fe4178619676b0e6$var$tooltipItemPositionGetter = (params)=>{
    const { series: series, identifier: identifier, axesConfig: axesConfig } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const itemSeries = series.line?.series[identifier.seriesId];
    if (itemSeries == null) return null;
    if (axesConfig.x === undefined || axesConfig.y === undefined) return null;
    const xValue = axesConfig.x.data?.[identifier.dataIndex];
    const yValue = itemSeries.data[identifier.dataIndex] == null ? null : itemSeries.visibleStackedData[identifier.dataIndex][1];
    if (xValue == null || yValue == null) return null;
    return {
        x: axesConfig.x.scale(xValue),
        y: axesConfig.y.scale(yValue)
    };
};
var $fe4178619676b0e6$var$_default = module.exports.default = $fe4178619676b0e6$var$tooltipItemPositionGetter;

});

parcelRegister("aLeuk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fWTNT = parcelRequire("fWTNT");
const $7d5988333b60ec58$var$outSeriesTypes = new Set([
    'bar',
    'line',
    'scatter'
]);
const $7d5988333b60ec58$var$keyboardFocusHandler = (event)=>{
    switch(event.key){
        case 'ArrowRight':
            return (0, $fWTNT.createGetNextIndexFocusedItem)($7d5988333b60ec58$var$outSeriesTypes);
        case 'ArrowLeft':
            return (0, $fWTNT.createGetPreviousIndexFocusedItem)($7d5988333b60ec58$var$outSeriesTypes);
        case 'ArrowDown':
            return (0, $fWTNT.createGetPreviousSeriesFocusedItem)($7d5988333b60ec58$var$outSeriesTypes);
        case 'ArrowUp':
            return (0, $fWTNT.createGetNextSeriesFocusedItem)($7d5988333b60ec58$var$outSeriesTypes);
        default:
            return null;
    }
};
var $7d5988333b60ec58$var$_default = module.exports.default = $7d5988333b60ec58$var$keyboardFocusHandler;

});


parcelRegister("4U5YD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3921074c2a275435$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pieSeriesConfig = void 0;

var $3921074c2a275435$var$_seriesProcessor = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("91euH")));

var $3921074c2a275435$var$_getColor = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("ld0pP")));

var $3921074c2a275435$var$_legend = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("coCQz")));

var $3921074c2a275435$var$_tooltip = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("jQftc")));

var $3921074c2a275435$var$_seriesLayout = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("iyrqm")));

var $3921074c2a275435$var$_getSeriesWithDefaultValues = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("lW0LZ")));

var $3921074c2a275435$var$_tooltipPosition = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("lMOFZ")));

var $3921074c2a275435$var$_keyboardFocusHandler = $3921074c2a275435$require$_interopRequireDefault((parcelRequire("7rcuE")));

var $jtEpx = parcelRequire("jtEpx");
const $3921074c2a275435$var$pieSeriesConfig = module.exports.pieSeriesConfig = {
    colorProcessor: $3921074c2a275435$var$_getColor.default,
    seriesProcessor: $3921074c2a275435$var$_seriesProcessor.default,
    seriesLayout: $3921074c2a275435$var$_seriesLayout.default,
    legendGetter: $3921074c2a275435$var$_legend.default,
    tooltipGetter: $3921074c2a275435$var$_tooltip.default,
    tooltipItemPositionGetter: $3921074c2a275435$var$_tooltipPosition.default,
    getSeriesWithDefaultValues: $3921074c2a275435$var$_getSeriesWithDefaultValues.default,
    keyboardFocusHandler: $3921074c2a275435$var$_keyboardFocusHandler.default,
    identifierSerializer: $jtEpx.identifierSerializerSeriesIdDataIndex
};

});
parcelRegister("91euH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $690f73496551747b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $690f73496551747b$var$_extends2 = $690f73496551747b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6hlpT = parcelRequire("6hlpT");

var $erYIG = parcelRequire("erYIG");

var $1hcZZ = parcelRequire("1hcZZ");
const $690f73496551747b$var$getSortingComparator = (comparator = 'none')=>{
    if (typeof comparator === 'function') return comparator;
    switch(comparator){
        case 'none':
            return null;
        case 'desc':
            return (a, b)=>b - a;
        case 'asc':
            return (a, b)=>a - b;
        default:
            return null;
    }
};
const $690f73496551747b$var$seriesProcessor = (params, dataset, isItemVisible)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    const defaultizedSeries = {};
    seriesOrder.forEach((seriesId)=>{
        // Filter out hidden data points for arc calculation
        const visibleData = series[seriesId].data.filter((_, index)=>{
            return isItemVisible?.({
                type: 'pie',
                seriesId: seriesId,
                dataIndex: index
            });
        });
        const visibleArcs = (0, $6hlpT.pie)().startAngle((0, $1hcZZ.deg2rad)(series[seriesId].startAngle ?? 0)).endAngle((0, $1hcZZ.deg2rad)(series[seriesId].endAngle ?? 360)).padAngle((0, $1hcZZ.deg2rad)(series[seriesId].paddingAngle ?? 0)).sortValues($690f73496551747b$var$getSortingComparator(series[seriesId].sortingValues ?? 'none'))(visibleData.map((piePoint)=>piePoint.value));
        // Map arcs back to original data, maintaining original indices
        let visibleIndex = 0;
        defaultizedSeries[seriesId] = (0, $690f73496551747b$var$_extends2.default)({
            labelMarkType: 'circle',
            valueFormatter: (item)=>item.value.toLocaleString()
        }, series[seriesId], {
            data: series[seriesId].data.map((item, index)=>{
                const itemId = item.id ?? `auto-generated-pie-id-${seriesId}-${index}`;
                const isHidden = !isItemVisible?.({
                    type: 'pie',
                    seriesId: seriesId,
                    dataIndex: index
                });
                let arcData;
                if (isHidden) {
                    // For hidden items, create a zero-size arc starting at the previous visible arc's end angle
                    // and ending at the same angle
                    const startAngle = visibleIndex > 0 ? visibleArcs[visibleIndex - 1].endAngle : (0, $1hcZZ.deg2rad)(series[seriesId].startAngle ?? 0);
                    arcData = {
                        startAngle: startAngle,
                        endAngle: startAngle,
                        padAngle: 0,
                        value: item.value,
                        index: index
                    };
                } else {
                    arcData = visibleArcs[visibleIndex];
                    visibleIndex += 1;
                }
                const processedItem = (0, $690f73496551747b$var$_extends2.default)({}, item, {
                    id: itemId,
                    hidden: isHidden
                }, arcData);
                return (0, $690f73496551747b$var$_extends2.default)({
                    labelMarkType: 'circle'
                }, processedItem, {
                    formattedValue: series[seriesId].valueFormatter?.((0, $690f73496551747b$var$_extends2.default)({}, processedItem, {
                        label: (0, $erYIG.getLabel)(processedItem.label, 'arc')
                    }), {
                        dataIndex: index
                    }) ?? processedItem.value.toLocaleString()
                });
            })
        });
    });
    return {
        seriesOrder: seriesOrder,
        series: defaultizedSeries
    };
};
var $690f73496551747b$var$_default = module.exports.default = $690f73496551747b$var$seriesProcessor;

});

parcelRegister("ld0pP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f70b226104d330d5$var$getColor = (series)=>{
    return (dataIndex)=>{
        return series.data[dataIndex].color;
    };
};
var $f70b226104d330d5$var$_default = module.exports.default = $f70b226104d330d5$var$getColor;

});

parcelRegister("coCQz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $erYIG = parcelRequire("erYIG");
const $9065dc1862e53573$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        series[seriesId].data.forEach((item, dataIndex)=>{
            const formattedLabel = (0, $erYIG.getLabel)(item.label, 'legend');
            if (formattedLabel === undefined) return;
            const id = item.id ?? dataIndex;
            acc.push({
                type: 'pie',
                markType: item.labelMarkType ?? series[seriesId].labelMarkType,
                seriesId: seriesId,
                id: id,
                itemId: id,
                dataIndex: dataIndex,
                color: item.color,
                label: formattedLabel
            });
        });
        return acc;
    }, []);
};
var $9065dc1862e53573$var$_default = module.exports.default = $9065dc1862e53573$var$legendGetter;

});

parcelRegister("jQftc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e71edfa81059ddd2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e71edfa81059ddd2$var$_extends2 = $e71edfa81059ddd2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $erYIG = parcelRequire("erYIG");
const $e71edfa81059ddd2$var$tooltipGetter = (params)=>{
    const { series: series, getColor: getColor, identifier: identifier } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const point = series.data[identifier.dataIndex];
    if (point == null) return null;
    const label = (0, $erYIG.getLabel)(point.label, 'tooltip');
    const value = (0, $e71edfa81059ddd2$var$_extends2.default)({}, point, {
        label: label
    });
    const formattedValue = series.valueFormatter(value, {
        dataIndex: identifier.dataIndex
    });
    return {
        identifier: identifier,
        color: getColor(identifier.dataIndex),
        label: label,
        value: value,
        formattedValue: formattedValue,
        markType: point.labelMarkType ?? series.labelMarkType
    };
};
var $e71edfa81059ddd2$var$_default = module.exports.default = $e71edfa81059ddd2$var$tooltipGetter;

});

parcelRegister("iyrqm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fINgK = parcelRequire("fINgK");

var $iM0Bo = parcelRequire("iM0Bo");
const $d820acdb085b376b$var$seriesLayout = (series, drawingArea)=>{
    const seriesLayoutRecord = {};
    for (const seriesId of series.seriesOrder){
        const { innerRadius: innerRadius, outerRadius: outerRadius, arcLabelRadius: arcLabelRadius, cx: cxParam, cy: cyParam } = series.series[seriesId];
        const { cx: cx, cy: cy, availableRadius: availableRadius } = (0, $iM0Bo.getPieCoordinates)({
            cx: cxParam,
            cy: cyParam
        }, {
            width: drawingArea.width,
            height: drawingArea.height
        });
        const outer = (0, $fINgK.getPercentageValue)(outerRadius ?? availableRadius, availableRadius);
        const inner = (0, $fINgK.getPercentageValue)(innerRadius ?? 0, availableRadius);
        const label = arcLabelRadius === undefined ? (inner + outer) / 2 : (0, $fINgK.getPercentageValue)(arcLabelRadius, availableRadius);
        seriesLayoutRecord[seriesId] = {
            radius: {
                available: availableRadius,
                inner: inner,
                outer: outer,
                label: label
            },
            center: {
                x: drawingArea.left + cx,
                y: drawingArea.top + cy
            }
        };
    }
    return seriesLayoutRecord;
};
var $d820acdb085b376b$var$_default = module.exports.default = $d820acdb085b376b$var$seriesLayout;

});
parcelRegister("fINgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPercentageValue = $b7212ee1d212e396$var$getPercentageValue;
/**
 * Helper that converts values and percentages into values.
 * @param value The value provided by the developer. Can either be a number or a string with '%' or 'px'.
 * @param refValue The numerical value associated to 100%.
 * @returns The numerical value associated to the provided value.
 */ function $b7212ee1d212e396$var$getPercentageValue(value, refValue) {
    if (typeof value === 'number') return value;
    if (value === '100%') // Avoid potential rounding issues
    return refValue;
    if (value.endsWith('%')) {
        const percentage = Number.parseFloat(value.slice(0, value.length - 1));
        if (!Number.isNaN(percentage)) return percentage * refValue / 100;
    }
    if (value.endsWith('px')) {
        const val = Number.parseFloat(value.slice(0, value.length - 2));
        if (!Number.isNaN(val)) return val;
    }
    throw new Error(`MUI X Charts: Received an unknown value "${value}". It should be a number, or a string with a percentage value.`);
}

});

parcelRegister("iM0Bo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPieCoordinates = $daad2d41b4637128$var$getPieCoordinates;

var $fINgK = parcelRequire("fINgK");
function $daad2d41b4637128$var$getPieCoordinates(series, drawing) {
    const { height: height, width: width } = drawing;
    const { cx: cxParam, cy: cyParam } = series;
    const availableRadius = Math.min(width, height) / 2;
    const cx = (0, $fINgK.getPercentageValue)(cxParam ?? '50%', width);
    const cy = (0, $fINgK.getPercentageValue)(cyParam ?? '50%', height);
    return {
        cx: cx,
        cy: cy,
        availableRadius: availableRadius
    };
}

});


parcelRegister("lW0LZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ff7f9d3d0557fd43$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff7f9d3d0557fd43$var$_extends2 = $ff7f9d3d0557fd43$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $ff7f9d3d0557fd43$var$getSeriesWithDefaultValues = (seriesData, seriesIndex, colors)=>{
    return (0, $ff7f9d3d0557fd43$var$_extends2.default)({}, seriesData, {
        id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
        data: seriesData.data.map((d, index)=>(0, $ff7f9d3d0557fd43$var$_extends2.default)({}, d, {
                color: d.color ?? colors[index % colors.length]
            }))
    });
};
var $ff7f9d3d0557fd43$var$_default = module.exports.default = $ff7f9d3d0557fd43$var$getSeriesWithDefaultValues;

});

parcelRegister("lMOFZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42j0p = parcelRequire("42j0p");
const $fdc563ef22454614$var$tooltipItemPositionGetter = (params)=>{
    const { series: series, identifier: identifier, placement: placement, seriesLayout: seriesLayout } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const itemSeries = series.pie?.series[identifier.seriesId];
    const layout = seriesLayout.pie?.[identifier.seriesId];
    if (itemSeries == null || layout == null) return null;
    const { center: center, radius: radius } = layout;
    const { data: data } = itemSeries;
    const dataItem = data[identifier.dataIndex];
    if (!dataItem) return null;
    // Compute the 4 corner points of the arc to get the bounding box.
    const points = [
        [
            radius.inner,
            dataItem.startAngle
        ],
        [
            radius.inner,
            dataItem.endAngle
        ],
        [
            radius.outer,
            dataItem.startAngle
        ],
        [
            radius.outer,
            dataItem.endAngle
        ]
    ].map(([r, angle])=>({
            x: center.x + r * Math.sin(angle),
            y: center.y - r * Math.cos(angle)
        }));
    const [x0, x1] = (0, $42j0p.findMinMax)(points.map((p)=>p.x));
    const [y0, y1] = (0, $42j0p.findMinMax)(points.map((p)=>p.y));
    switch(placement){
        case 'bottom':
            return {
                x: (x1 + x0) / 2,
                y: y1
            };
        case 'left':
            return {
                x: x0,
                y: (y1 + y0) / 2
            };
        case 'right':
            return {
                x: x1,
                y: (y1 + y0) / 2
            };
        case 'top':
        default:
            return {
                x: (x1 + x0) / 2,
                y: y0
            };
    }
};
var $fdc563ef22454614$var$_default = module.exports.default = $fdc563ef22454614$var$tooltipItemPositionGetter;

});

parcelRegister("7rcuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fWTNT = parcelRequire("fWTNT");
const $56a4beeb6bef9e3c$var$outSeriesTypes = new Set([
    'pie'
]);
const $56a4beeb6bef9e3c$var$keyboardFocusHandler = (event)=>{
    switch(event.key){
        case 'ArrowRight':
            return (0, $fWTNT.createGetNextIndexFocusedItem)($56a4beeb6bef9e3c$var$outSeriesTypes);
        case 'ArrowLeft':
            return (0, $fWTNT.createGetPreviousIndexFocusedItem)($56a4beeb6bef9e3c$var$outSeriesTypes);
        case 'ArrowDown':
            return (0, $fWTNT.createGetPreviousSeriesFocusedItem)($56a4beeb6bef9e3c$var$outSeriesTypes);
        case 'ArrowUp':
            return (0, $fWTNT.createGetNextSeriesFocusedItem)($56a4beeb6bef9e3c$var$outSeriesTypes);
        default:
            return null;
    }
};
var $56a4beeb6bef9e3c$var$_default = module.exports.default = $56a4beeb6bef9e3c$var$keyboardFocusHandler;

});


parcelRegister("3BMFO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2a0a95547d115ac5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.scatterSeriesConfig = void 0;

var $3nzA5 = parcelRequire("3nzA5");

var $2a0a95547d115ac5$var$_seriesProcessor = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("wS3cP")));

var $2a0a95547d115ac5$var$_getColor = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("6GHiE")));

var $2a0a95547d115ac5$var$_legend = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("cDsUQ")));

var $2a0a95547d115ac5$var$_tooltip = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("eL5aV")));

var $2a0a95547d115ac5$var$_getSeriesWithDefaultValues = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("1taDj")));

var $2a0a95547d115ac5$var$_tooltipPosition = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("bFPpb")));

var $2a0a95547d115ac5$var$_keyboardFocusHandler = $2a0a95547d115ac5$require$_interopRequireDefault((parcelRequire("ap6mZ")));

var $jtEpx = parcelRequire("jtEpx");
const $2a0a95547d115ac5$var$scatterSeriesConfig = module.exports.scatterSeriesConfig = {
    seriesProcessor: $2a0a95547d115ac5$var$_seriesProcessor.default,
    colorProcessor: $2a0a95547d115ac5$var$_getColor.default,
    legendGetter: $2a0a95547d115ac5$var$_legend.default,
    tooltipGetter: $2a0a95547d115ac5$var$_tooltip.default,
    tooltipItemPositionGetter: $2a0a95547d115ac5$var$_tooltipPosition.default,
    xExtremumGetter: $3nzA5.getExtremumX,
    yExtremumGetter: $3nzA5.getExtremumY,
    getSeriesWithDefaultValues: $2a0a95547d115ac5$var$_getSeriesWithDefaultValues.default,
    keyboardFocusHandler: $2a0a95547d115ac5$var$_keyboardFocusHandler.default,
    identifierSerializer: $jtEpx.identifierSerializerSeriesIdDataIndex
};

});
parcelRegister("3nzA5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getExtremumY = module.exports.getExtremumX = void 0;
const $275f1ebc895dbea4$var$getExtremumX = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis, getFilters: getFilters } = params;
    let min = Infinity;
    let max = -Infinity;
    for(const seriesId in series){
        if (!Object.hasOwn(series, seriesId)) continue;
        const axisId = series[seriesId].xAxisId;
        if (!(axisId === axis.id || axisId === undefined && isDefaultAxis)) continue;
        const filter = getFilters?.({
            currentAxisId: axis.id,
            isDefaultAxis: isDefaultAxis,
            seriesXAxisId: series[seriesId].xAxisId,
            seriesYAxisId: series[seriesId].yAxisId
        });
        const seriesData = series[seriesId].data ?? [];
        for(let i = 0; i < seriesData.length; i += 1){
            const d = seriesData[i];
            if (filter && !filter(d, i)) continue;
            if (d.x !== null) {
                if (d.x < min) min = d.x;
                if (d.x > max) max = d.x;
            }
        }
    }
    return [
        min,
        max
    ];
};
module.exports.getExtremumX = $275f1ebc895dbea4$var$getExtremumX;
const $275f1ebc895dbea4$var$getExtremumY = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis, getFilters: getFilters } = params;
    let min = Infinity;
    let max = -Infinity;
    for(const seriesId in series){
        if (!Object.hasOwn(series, seriesId)) continue;
        const axisId = series[seriesId].yAxisId;
        if (!(axisId === axis.id || axisId === undefined && isDefaultAxis)) continue;
        const filter = getFilters?.({
            currentAxisId: axis.id,
            isDefaultAxis: isDefaultAxis,
            seriesXAxisId: series[seriesId].xAxisId,
            seriesYAxisId: series[seriesId].yAxisId
        });
        const seriesData = series[seriesId].data ?? [];
        for(let i = 0; i < seriesData.length; i += 1){
            const d = seriesData[i];
            if (filter && !filter(d, i)) continue;
            if (d.y !== null) {
                if (d.y < min) min = d.y;
                if (d.y > max) max = d.y;
            }
        }
    }
    return [
        min,
        max
    ];
};
module.exports.getExtremumY = $275f1ebc895dbea4$var$getExtremumY;

});

parcelRegister("wS3cP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $062cea9e5f4c567a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $062cea9e5f4c567a$var$_extends2 = $062cea9e5f4c567a$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $062cea9e5f4c567a$var$seriesProcessor = ({ series: series, seriesOrder: seriesOrder }, dataset, isItemVisible)=>{
    const completeSeries = Object.fromEntries(Object.entries(series).map(([seriesId, seriesData])=>{
        const datasetKeys = seriesData?.datasetKeys;
        const missingKeys = [
            'x',
            'y'
        ].filter((key)=>typeof datasetKeys?.[key] !== 'string');
        if (seriesData?.datasetKeys && missingKeys.length > 0) throw new Error([
            `MUI X Charts: scatter series with id='${seriesId}' has incomplete datasetKeys.`,
            `Properties ${missingKeys.map((key)=>`"${key}"`).join(', ')} are missing.`
        ].join('\n'));
        const data = !datasetKeys ? seriesData.data ?? [] : dataset?.map((d)=>{
            return {
                x: d[datasetKeys.x] ?? null,
                y: d[datasetKeys.y] ?? null,
                z: datasetKeys.z && d[datasetKeys.z],
                id: datasetKeys.id && d[datasetKeys.id]
            };
        }) ?? [];
        return [
            seriesId,
            (0, $062cea9e5f4c567a$var$_extends2.default)({
                labelMarkType: 'circle',
                markerSize: 4
            }, seriesData, {
                preview: (0, $062cea9e5f4c567a$var$_extends2.default)({
                    markerSize: 1
                }, seriesData?.preview),
                data: data,
                hidden: !isItemVisible?.({
                    type: 'scatter',
                    seriesId: seriesId
                }),
                valueFormatter: seriesData.valueFormatter ?? ((v)=>v && `(${v.x}, ${v.y})`)
            })
        ];
    }));
    return {
        series: completeSeries,
        seriesOrder: seriesOrder
    };
};
var $062cea9e5f4c567a$var$_default = module.exports.default = $062cea9e5f4c567a$var$seriesProcessor;

});

parcelRegister("6GHiE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fAIz6 = parcelRequire("fAIz6");
const $4de840c0a2b0b422$var$getColor = (series, xAxis, yAxis, zAxis)=>{
    const zColorScale = zAxis?.colorScale;
    const yColorScale = yAxis?.colorScale;
    const xColorScale = xAxis?.colorScale;
    const getSeriesColor = (0, $fAIz6.getSeriesColorFn)(series);
    if (zColorScale) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        if (zAxis?.data?.[dataIndex] !== undefined) {
            const color = zColorScale(zAxis?.data?.[dataIndex]);
            if (color !== null) return color;
        }
        const value = series.data[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : zColorScale(value.z);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    if (yColorScale) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : yColorScale(value.y);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    if (xColorScale) return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        const color = value === null ? getSeriesColor({
            value: value,
            dataIndex: dataIndex
        }) : xColorScale(value.x);
        if (color === null) return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
        return color;
    };
    return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
    };
};
var $4de840c0a2b0b422$var$_default = module.exports.default = $4de840c0a2b0b422$var$getColor;

});

parcelRegister("cDsUQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $erYIG = parcelRequire("erYIG");
const $932f8ea1c0a3c67d$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $erYIG.getLabel)(series[seriesId].label, 'legend');
        if (formattedLabel === undefined) return acc;
        acc.push({
            type: 'scatter',
            markType: series[seriesId].labelMarkType,
            id: seriesId,
            seriesId: seriesId,
            color: series[seriesId].color,
            label: formattedLabel
        });
        return acc;
    }, []);
};
var $932f8ea1c0a3c67d$var$_default = module.exports.default = $932f8ea1c0a3c67d$var$legendGetter;

});

parcelRegister("eL5aV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $erYIG = parcelRequire("erYIG");
const $abe97826a3a3dbe7$var$tooltipGetter = (params)=>{
    const { series: series, getColor: getColor, identifier: identifier } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const label = (0, $erYIG.getLabel)(series.label, 'tooltip');
    const value = series.data[identifier.dataIndex];
    const formattedValue = series.valueFormatter(value, {
        dataIndex: identifier.dataIndex
    });
    return {
        identifier: identifier,
        color: getColor(identifier.dataIndex),
        label: label,
        value: value,
        formattedValue: formattedValue,
        markType: series.labelMarkType
    };
};
var $abe97826a3a3dbe7$var$_default = module.exports.default = $abe97826a3a3dbe7$var$tooltipGetter;

});

parcelRegister("1taDj", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1120bf5f930d422a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1120bf5f930d422a$var$_extends2 = $1120bf5f930d422a$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $1120bf5f930d422a$var$getSeriesWithDefaultValues = (seriesData, seriesIndex, colors)=>{
    return (0, $1120bf5f930d422a$var$_extends2.default)({}, seriesData, {
        id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
        color: seriesData.color ?? colors[seriesIndex % colors.length]
    });
};
var $1120bf5f930d422a$var$_default = module.exports.default = $1120bf5f930d422a$var$getSeriesWithDefaultValues;

});

parcelRegister("bFPpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $87fb66068e69386f$var$tooltipItemPositionGetter = (params)=>{
    const { series: series, identifier: identifier, axesConfig: axesConfig } = params;
    if (!identifier || identifier.dataIndex === undefined) return null;
    const itemSeries = series.scatter?.series[identifier.seriesId];
    if (itemSeries == null) return null;
    if (axesConfig.x === undefined || axesConfig.y === undefined) return null;
    const xValue = itemSeries.data?.[identifier.dataIndex].x;
    const yValue = itemSeries.data?.[identifier.dataIndex].y;
    if (xValue == null || yValue == null) return null;
    return {
        x: axesConfig.x.scale(xValue),
        y: axesConfig.y.scale(yValue)
    };
};
var $87fb66068e69386f$var$_default = module.exports.default = $87fb66068e69386f$var$tooltipItemPositionGetter;

});

parcelRegister("ap6mZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fWTNT = parcelRequire("fWTNT");
const $79312e19cd39f241$var$outSeriesTypes = new Set([
    'bar',
    'line',
    'scatter'
]);
const $79312e19cd39f241$var$keyboardFocusHandler = (event)=>{
    switch(event.key){
        case 'ArrowRight':
            return (0, $fWTNT.createGetNextIndexFocusedItem)($79312e19cd39f241$var$outSeriesTypes);
        case 'ArrowLeft':
            return (0, $fWTNT.createGetPreviousIndexFocusedItem)($79312e19cd39f241$var$outSeriesTypes);
        case 'ArrowDown':
            return (0, $fWTNT.createGetPreviousSeriesFocusedItem)($79312e19cd39f241$var$outSeriesTypes);
        case 'ArrowUp':
            return (0, $fWTNT.createGetNextSeriesFocusedItem)($79312e19cd39f241$var$outSeriesTypes);
        default:
            return null;
    }
};
var $79312e19cd39f241$var$_default = module.exports.default = $79312e19cd39f241$var$keyboardFocusHandler;

});



parcelRegister("62XIl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gyilZ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c0ce0ef6891461fc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartsContext = void 0;

var $c0ce0ef6891461fc$var$React = $c0ce0ef6891461fc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8L2Vi = parcelRequire("8L2Vi");
const $c0ce0ef6891461fc$var$useChartsContext = ()=>{
    const context = $c0ce0ef6891461fc$var$React.useContext($8L2Vi.ChartsContext);
    if (context == null) throw new Error("MUI X Charts: Could not find the Charts context. This happens when the component is rendered outside of a ChartsDataProvider or ChartsContainer parent component, which means the required context is not available. Wrap your component in a ChartsDataProvider or ChartsContainer. This can also happen if you are bundling multiple versions of the library.");
    return context;
};
module.exports.useChartsContext = $c0ce0ef6891461fc$var$useChartsContext;

});



parcelRegister("6JI31", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1HhaP", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartContext = void 0;

var $gyilZ = parcelRequire("gyilZ");
/**
 * @deprecated Use `useChartsContext` instead. We added S to the charts prefix to align with other components.
 */ const $13c720eadf119439$var$useChartContext = module.exports.useChartContext = $gyilZ.useChartsContext;

});



parcelRegister("3N2dU", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useItemHighlighted = $2c27ac3bbfa80121$var$useItemHighlighted;

var $d3mgr = parcelRequire("d3mgr");

var $cZLDK = parcelRequire("cZLDK");
/**
 * A hook to check the highlighted state of the item.
 * This function already calculates that an item is not faded if it is highlighted.
 *
 * If you need fine control over the state, use the `useItemHighlightedGetter` hook instead.
 *
 * @param {HighlightItemData | null} item is the item to check
 * @returns {UseItemHighlightedReturnType} the state of the item
 */ function $2c27ac3bbfa80121$var$useItemHighlighted(item) {
    const store = (0, $d3mgr.useStore)();
    const isHighlighted = store.use($cZLDK.selectorChartsIsHighlighted, item);
    const isFaded = store.use($cZLDK.selectorChartsIsFaded, item);
    return {
        isHighlighted: isHighlighted,
        isFaded: !isHighlighted && isFaded
    };
}

});
parcelRegister("d3mgr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useStore = $980cd35b94a8543b$var$useStore;

var $6hQTT = parcelRequire("6hQTT");
// This hook should be removed because user and us should not interact with the store directly, but with public/private APIs
function $980cd35b94a8543b$var$useStore() {
    const context = (0, $6hQTT.useChartContext)();
    if (!context) throw new Error("MUI X Charts: Could not find the Charts context. This happens when the component is rendered outside of a ChartsContainer parent component. Wrap your component in a ChartsContainer or ChartsDataProvider.");
    return context.store;
}

});

parcelRegister("cZLDK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $976022df2a83b840$var$_exportNames = {
    useChartHighlight: true
};
Object.defineProperty(module.exports, "useChartHighlight", {
    enumerable: true,
    get: function() {
        return $d25l6.useChartHighlight;
    }
});

var $d25l6 = parcelRequire("d25l6");

var $2Kjnj = parcelRequire("2Kjnj");
Object.keys($2Kjnj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($976022df2a83b840$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2Kjnj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Kjnj[key];
        }
    });
});

});
parcelRegister("2Kjnj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsIsHighlightedCallback = module.exports.selectorChartsIsHighlighted = module.exports.selectorChartsIsFadedCallback = module.exports.selectorChartsIsFaded = module.exports.selectorChartsHighlightedItem = module.exports.selectorChartsHighlightScopePerSeriesId = module.exports.selectorChartsHighlightScope = module.exports.selectorChartSeriesUnfadedItem = module.exports.selectorChartSeriesHighlightedItem = module.exports.selectorChartIsSeriesHighlighted = module.exports.selectorChartIsSeriesFaded = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $1RHnr = parcelRequire("1RHnr");

var $65gj9 = parcelRequire("65gj9");

var $3dmcn = parcelRequire("3dmcn");

var $cp50o = parcelRequire("cp50o");

var $6kle2 = parcelRequire("6kle2");
const $1ffee81edf7b1eba$var$selectHighlight = (state)=>state.highlight;
const $1ffee81edf7b1eba$var$selectorChartsHighlightScopePerSeriesId = module.exports.selectorChartsHighlightScopePerSeriesId = (0, $8P0MD.createSelector)($6kle2.selectorChartSeriesProcessed, (processedSeries)=>{
    const map = new Map();
    Object.keys(processedSeries).forEach((seriesType)=>{
        const seriesData = processedSeries[seriesType];
        seriesData?.seriesOrder?.forEach((seriesId)=>{
            const seriesItem = seriesData?.series[seriesId];
            map.set(seriesId, seriesItem?.highlightScope);
        });
    });
    return map;
});
const $1ffee81edf7b1eba$var$selectorChartsHighlightedItem = module.exports.selectorChartsHighlightedItem = (0, $8P0MD.createSelectorMemoized)($1ffee81edf7b1eba$var$selectHighlight, $cp50o.selectorChartsKeyboardItem, function selectorChartsHighlightedItem(highlight, keyboardItem) {
    return highlight.isControlled || highlight.lastUpdate === 'pointer' ? highlight.item : keyboardItem;
});
const $1ffee81edf7b1eba$var$selectorChartsHighlightScope = module.exports.selectorChartsHighlightScope = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScopePerSeriesId, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, function selectorChartsHighlightScope(seriesIdToHighlightScope, highlightedItem) {
    if (!highlightedItem) return null;
    const highlightScope = seriesIdToHighlightScope.get(highlightedItem.seriesId);
    if (highlightScope === undefined) return null;
    return highlightScope;
});
const $1ffee81edf7b1eba$var$selectorChartsIsHighlightedCallback = module.exports.selectorChartsIsHighlightedCallback = (0, $8P0MD.createSelectorMemoized)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, $1RHnr.createIsHighlighted);
const $1ffee81edf7b1eba$var$selectorChartsIsFadedCallback = module.exports.selectorChartsIsFadedCallback = (0, $8P0MD.createSelectorMemoized)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, $65gj9.createIsFaded);
const $1ffee81edf7b1eba$var$selectorChartsIsHighlighted = module.exports.selectorChartsIsHighlighted = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, function selectorChartsIsHighlighted(highlightScope, highlightedItem, item) {
    return (0, $1RHnr.createIsHighlighted)(highlightScope, highlightedItem)(item);
});
const $1ffee81edf7b1eba$var$selectorChartIsSeriesHighlighted = module.exports.selectorChartIsSeriesHighlighted = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, $3dmcn.isSeriesHighlighted);
const $1ffee81edf7b1eba$var$selectorChartIsSeriesFaded = module.exports.selectorChartIsSeriesFaded = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, $3dmcn.isSeriesFaded);
const $1ffee81edf7b1eba$var$selectorChartSeriesUnfadedItem = module.exports.selectorChartSeriesUnfadedItem = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, $3dmcn.getSeriesUnfadedItem);
const $1ffee81edf7b1eba$var$selectorChartSeriesHighlightedItem = module.exports.selectorChartSeriesHighlightedItem = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, $3dmcn.getSeriesHighlightedItem);
const $1ffee81edf7b1eba$var$selectorChartsIsFaded = module.exports.selectorChartsIsFaded = (0, $8P0MD.createSelector)($1ffee81edf7b1eba$var$selectorChartsHighlightScope, $1ffee81edf7b1eba$var$selectorChartsHighlightedItem, function selectorChartsIsFaded(highlightScope, highlightedItem, item) {
    return (0, $65gj9.createIsFaded)(highlightScope, highlightedItem)(item);
});

});
parcelRegister("1RHnr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIsHighlighted = $15bc63716a75e398$var$createIsHighlighted;
function $15bc63716a75e398$var$alwaysFalse() {
    return false;
}
function $15bc63716a75e398$var$createIsHighlighted(highlightScope, highlightedItem) {
    if (!highlightScope || !highlightedItem) return $15bc63716a75e398$var$alwaysFalse;
    return function isHighlighted(item) {
        if (!item) return false;
        if (highlightScope.highlight === 'series') return item.seriesId === highlightedItem.seriesId;
        if (highlightScope.highlight === 'item') return item.dataIndex === highlightedItem.dataIndex && item.seriesId === highlightedItem.seriesId;
        return false;
    };
}

});

parcelRegister("65gj9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIsFaded = $46dfdc21210067c3$var$createIsFaded;
function $46dfdc21210067c3$var$alwaysFalse() {
    return false;
}
function $46dfdc21210067c3$var$createIsFaded(highlightScope, highlightedItem) {
    if (!highlightScope || !highlightedItem) return $46dfdc21210067c3$var$alwaysFalse;
    return function isFaded(item) {
        if (!item) return false;
        if (highlightScope.fade === 'series') return item.seriesId === highlightedItem.seriesId && item.dataIndex !== highlightedItem.dataIndex;
        if (highlightScope.fade === 'global') return item.seriesId !== highlightedItem.seriesId || item.dataIndex !== highlightedItem.dataIndex;
        return false;
    };
}

});

parcelRegister("3dmcn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSeriesHighlightedItem = $2573ce27c14c5896$var$getSeriesHighlightedItem;
module.exports.getSeriesUnfadedItem = $2573ce27c14c5896$var$getSeriesUnfadedItem;
module.exports.isSeriesFaded = $2573ce27c14c5896$var$isSeriesFaded;
module.exports.isSeriesHighlighted = $2573ce27c14c5896$var$isSeriesHighlighted;
function $2573ce27c14c5896$var$isSeriesHighlighted(scope, item, seriesId) {
    return scope?.highlight === 'series' && item?.seriesId === seriesId;
}
function $2573ce27c14c5896$var$isSeriesFaded(scope, item, seriesId) {
    if ($2573ce27c14c5896$var$isSeriesHighlighted(scope, item, seriesId)) return false;
    return scope?.fade === 'global' && item != null || scope?.fade === 'series' && item?.seriesId === seriesId;
}
/**
 * Returns the data index of the highlighted item for a specific series.
 * If the item is not highlighted, it returns `null`.
 */ function $2573ce27c14c5896$var$getSeriesHighlightedItem(scope, item, seriesId) {
    return scope?.highlight === 'item' && item?.seriesId === seriesId ? item.dataIndex : null;
}
/**
 * Returns the data index of the "unfaded item" for a specific series.
 * An "unfaded item" is the only item of a faded series that shouldn't be faded.
 * If the series is not faded or if there is no highlighted item, it returns `null`.
 */ function $2573ce27c14c5896$var$getSeriesUnfadedItem(scope, item, seriesId) {
    if ($2573ce27c14c5896$var$isSeriesHighlighted(scope, item, seriesId)) return null;
    if ($2573ce27c14c5896$var$getSeriesHighlightedItem(scope, item, seriesId) === item?.dataIndex) return null;
    return (scope?.fade === 'series' || scope?.fade === 'global') && item?.seriesId === seriesId ? item.dataIndex : null;
}

});




parcelRegister("e6rEy", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a44713938ed7b77c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a44713938ed7b77c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimatedArea = $a44713938ed7b77c$var$AnimatedArea;

var $a44713938ed7b77c$var$_extends2 = $a44713938ed7b77c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a44713938ed7b77c$var$_objectWithoutPropertiesLoose2 = $a44713938ed7b77c$require$_interopRequireDefault((parcelRequire("c05no")));

var $a44713938ed7b77c$var$React = $a44713938ed7b77c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a44713938ed7b77c$var$_propTypes = $a44713938ed7b77c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $hBRQb = parcelRequire("hBRQb");

var $SyUaR = parcelRequire("SyUaR");

var $ayMG0 = parcelRequire("ayMG0");
const $a44713938ed7b77c$var$_excluded = [
    "skipAnimation",
    "ownerState"
];
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Areas demonstration](https://mui.com/x/react-charts/areas-demo/)
 *
 * API:
 *
 * - [AreaElement API](https://mui.com/x/api/charts/animated-area/)
 */ function $a44713938ed7b77c$var$AnimatedArea(props) {
    const { skipAnimation: skipAnimation, ownerState: ownerState } = props, other = (0, $a44713938ed7b77c$var$_objectWithoutPropertiesLoose2.default)(props, $a44713938ed7b77c$var$_excluded);
    const animatedProps = (0, $hBRQb.useAnimateArea)(props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($SyUaR.AppearingMask, {
        skipAnimation: skipAnimation,
        id: `${ownerState.id}-area-clip`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", (0, $a44713938ed7b77c$var$_extends2.default)({
            fill: ownerState.gradientId ? `url(#${ownerState.gradientId})` : ownerState.color,
            filter: // eslint-disable-next-line no-nested-ternary
            ownerState.isHighlighted ? 'brightness(140%)' : ownerState.gradientId ? undefined : 'brightness(120%)',
            opacity: ownerState.isFaded ? 0.3 : 1,
            stroke: "none",
            "data-series": ownerState.id,
            "data-highlighted": ownerState.isHighlighted || undefined,
            "data-faded": ownerState.isFaded || undefined
        }, other, animatedProps))
    });
}

});
parcelRegister("hBRQb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimateArea = $cd1fa7fed1a1e10b$var$useAnimateArea;

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
/** Animates an area of a line chart using a `path` element.
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called.
 */ function $cd1fa7fed1a1e10b$var$useAnimateArea(props) {
    return (0, $aQEJ4.useAnimate)({
        d: props.d
    }, {
        createInterpolator: (lastProps, newProps)=>{
            const interpolate = (0, $iNRFO.interpolateString)(lastProps.d, newProps.d);
            return (t)=>({
                    d: interpolate(t)
                });
        },
        applyProps: (element, { d: d })=>element.setAttribute('d', d),
        transformProps: (p)=>p,
        skip: props.skipAnimation,
        ref: props.ref
    });
}

});
parcelRegister("iNRFO", function(module, exports) {
// `x-charts-vendor/d3-interpolate` (CommonJS)
// See upstream license: https://github.com/d3/d3-interpolate/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("38URU"));

});
parcelRegister("38URU", function(module, exports) {
// `x-charts-vendor/d3-interpolate` (CommonJS)
// See upstream license: https://github.com/d3/d3-interpolate/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-interpolate`

module.exports = (parcelRequire("jipHj"));

});


parcelRegister("aQEJ4", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7e5e5a0d2188fb05$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimate = $7e5e5a0d2188fb05$var$useAnimate;

var $7e5e5a0d2188fb05$var$_extends2 = $7e5e5a0d2188fb05$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7e5e5a0d2188fb05$var$_useForkRef = $7e5e5a0d2188fb05$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $1VZj8 = parcelRequire("1VZj8");
/**
 * Hook to customize the animation of an element.
 * Animates a ref from `initialProps` to `props`.
 *
 * @param {object} props The props to animate to.
 *
 * @returns an object containing a ref that should be passed to the element to animate and the transformed props.
 * If `skip` is true, the transformed props are the `props` to animate to; if it is false, the transformed props are the
 * `initialProps`.
 *
 * The animated props are only accessible in `applyProps`. The props returned from this hook are not animated.
 *
 * When an animation starts, an interpolator is created using `createInterpolator`.
 * On every animation frame:
 * 1. The interpolator is called to get the interpolated props;
 * 2. `transformProps` is called to transform the interpolated props;
 * 3. `applyProps` is called to apply the transformed props to the element.
 *
 * If `props` change while an animation is progress, the animation will continue towards the new `props`.
 *
 * The animation can be skipped by setting `skip` to true. If a transition is in progress, it will immediately end
 * and `applyProps` be called with the final value. If there isn't a transition in progress, a new one won't be
 * started and `applyProps` will not be called.
 * */ function $7e5e5a0d2188fb05$var$useAnimate(props, { createInterpolator: createInterpolator, transformProps: transformProps, applyProps: applyProps, skip: skip, initialProps: initialProps = props, ref: ref }) {
    const transform = transformProps ?? ((p)=>p);
    const [animateRef, lastInterpolatedProps] = (0, $1VZj8.useAnimateInternal)(props, {
        initialProps: initialProps,
        createInterpolator: createInterpolator,
        applyProps: (element, animatedProps)=>applyProps(element, transform(animatedProps)),
        skip: skip
    });
    const usedProps = skip ? transformProps(props) : transformProps(lastInterpolatedProps);
    return (0, $7e5e5a0d2188fb05$var$_extends2.default)({}, usedProps, {
        ref: (0, $7e5e5a0d2188fb05$var$_useForkRef.default)(animateRef, ref)
    });
}

});
parcelRegister("1VZj8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $168aabbcec148cca$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $168aabbcec148cca$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimateInternal = $168aabbcec148cca$var$useAnimateInternal;

var $168aabbcec148cca$var$React = $168aabbcec148cca$require$_interopRequireWildcard((parcelRequire("acw62")));

var $168aabbcec148cca$var$_useEnhancedEffect = $168aabbcec148cca$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $32gdR = parcelRequire("32gdR");

var $hMJ21 = parcelRequire("hMJ21");

var $81urP = parcelRequire("81urP");
/** Animates a ref. The animation can be skipped by setting {@link skip} to true.
 *
 * If possible, prefer {@link useAnimate}.
 *
 * - If {@link skip} is false, a transition will be started.
 * - If {@link skip} is true and no transition is in progress, no transition will be started and {@link applyProps} will
 *   never be called.
 * - If {@link skip} becomes true and a transition is in progress, the transition will immediately end and
 *   {@link applyProps} be called with the final value.
 * */ function $168aabbcec148cca$var$useAnimateInternal(props, { createInterpolator: createInterpolator, applyProps: applyProps, skip: skip, initialProps: initialProps = props }) {
    const lastInterpolatedPropsRef = $168aabbcec148cca$var$React.useRef(initialProps);
    const transitionRef = $168aabbcec148cca$var$React.useRef(null);
    const elementRef = $168aabbcec148cca$var$React.useRef(null);
    const lastPropsRef = $168aabbcec148cca$var$React.useRef(props);
    (0, $168aabbcec148cca$var$_useEnhancedEffect.default)(()=>{
        lastPropsRef.current = props;
    }, [
        props
    ]);
    (0, $168aabbcec148cca$var$_useEnhancedEffect.default)(()=>{
        if (skip) {
            transitionRef.current?.finish();
            transitionRef.current = null;
            elementRef.current = null;
            lastInterpolatedPropsRef.current = props;
        }
    }, [
        props,
        skip
    ]);
    const animate = $168aabbcec148cca$var$React.useCallback((element)=>{
        const lastInterpolatedProps = lastInterpolatedPropsRef.current;
        const interpolate = createInterpolator(lastInterpolatedProps, props);
        transitionRef.current = new $hMJ21.Transition($32gdR.ANIMATION_DURATION_MS, $32gdR.ANIMATION_TIMING_FUNCTION_JS, (t)=>{
            const interpolatedProps = interpolate(t);
            lastInterpolatedPropsRef.current = interpolatedProps;
            applyProps(element, interpolatedProps);
        });
    }, [
        applyProps,
        createInterpolator,
        props
    ]);
    const setRef = $168aabbcec148cca$var$React.useCallback((element)=>{
        if (element === null) {
            transitionRef.current?.stop();
            return;
        }
        const lastElement = elementRef.current;
        if (lastElement === element) {
            // If it's the same element and same props, resume the transition.
            if ((0, $81urP.shallowEqual)(lastPropsRef.current, props)) {
                transitionRef.current?.resume();
                return;
            }
            // If props aren't the same, stop the transition and start a new animation.
            transitionRef.current?.stop();
        }
        // If it's a different element, stop the transition of the last element and start a new animation.
        if (lastElement) transitionRef.current?.stop();
        elementRef.current = element;
        if (transitionRef.current || !skip) animate(element);
    }, [
        animate,
        props,
        skip
    ]);
    return [
        setRef,
        lastInterpolatedPropsRef.current
    ];
}

});
parcelRegister("32gdR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $235e2478cadf35f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANIMATION_TIMING_FUNCTION_JS = module.exports.ANIMATION_TIMING_FUNCTION = module.exports.ANIMATION_DURATION_MS = void 0;

var $235e2478cadf35f4$var$_bezierEasing = $235e2478cadf35f4$require$_interopRequireDefault((parcelRequire("4GoXZ")));
const $235e2478cadf35f4$var$ANIMATION_DURATION_MS = module.exports.ANIMATION_DURATION_MS = 300;
const $235e2478cadf35f4$var$ANIMATION_TIMING_FUNCTION = module.exports.ANIMATION_TIMING_FUNCTION = 'cubic-bezier(0.66, 0, 0.34, 1)';
const $235e2478cadf35f4$var$ANIMATION_TIMING_FUNCTION_JS = module.exports.ANIMATION_TIMING_FUNCTION_JS = (0, $235e2478cadf35f4$var$_bezierEasing.default)(0.66, 0, 0.34, 1);

});
parcelRegister("4GoXZ", function(module, exports) {
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $368e738781e188a9$var$NEWTON_ITERATIONS = 4;
var $368e738781e188a9$var$NEWTON_MIN_SLOPE = 0.001;
var $368e738781e188a9$var$SUBDIVISION_PRECISION = 0.0000001;
var $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $368e738781e188a9$var$kSplineTableSize = 11;
var $368e738781e188a9$var$kSampleStepSize = 1.0 / ($368e738781e188a9$var$kSplineTableSize - 1.0);
var $368e738781e188a9$var$float32ArraySupported = typeof Float32Array === 'function';
function $368e738781e188a9$var$A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function $368e738781e188a9$var$B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function $368e738781e188a9$var$C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function $368e738781e188a9$var$calcBezier(aT, aA1, aA2) {
    return (($368e738781e188a9$var$A(aA1, aA2) * aT + $368e738781e188a9$var$B(aA1, aA2)) * aT + $368e738781e188a9$var$C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function $368e738781e188a9$var$getSlope(aT, aA1, aA2) {
    return 3.0 * $368e738781e188a9$var$A(aA1, aA2) * aT * aT + 2.0 * $368e738781e188a9$var$B(aA1, aA2) * aT + $368e738781e188a9$var$C(aA1);
}
function $368e738781e188a9$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $368e738781e188a9$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $368e738781e188a9$var$SUBDIVISION_PRECISION && ++i < $368e738781e188a9$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function $368e738781e188a9$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $368e738781e188a9$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $368e738781e188a9$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $368e738781e188a9$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function $368e738781e188a9$var$LinearEasing(x) {
    return x;
}
module.exports = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
    if (mX1 === mY1 && mX2 === mY2) return $368e738781e188a9$var$LinearEasing;
    // Precompute samples table
    var sampleValues = $368e738781e188a9$var$float32ArraySupported ? new Float32Array($368e738781e188a9$var$kSplineTableSize) : new Array($368e738781e188a9$var$kSplineTableSize);
    for(var i = 0; i < $368e738781e188a9$var$kSplineTableSize; ++i)sampleValues[i] = $368e738781e188a9$var$calcBezier(i * $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $368e738781e188a9$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $368e738781e188a9$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $368e738781e188a9$var$kSampleStepSize;
        var initialSlope = $368e738781e188a9$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $368e738781e188a9$var$NEWTON_MIN_SLOPE) return $368e738781e188a9$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $368e738781e188a9$var$binarySubdivide(aX, intervalStart, intervalStart + $368e738781e188a9$var$kSampleStepSize, mX1, mX2);
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $368e738781e188a9$var$calcBezier(getTForX(x), mY1, mY2);
    };
};

});


parcelRegister("hMJ21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $2V7SS = parcelRequire("2V7SS");
/**
 * A resumable transition class inspired by d3-transition.
 * Allows for starting, and stopping and resuming transitions.
 *
 * The transition is started automatically.
 * A transition cannot be restarted after it has finished.
 * Resuming a transition will continue from the point it was stopped, i.e., easing will continue from the point it was
 * stopped.
 */ class $cf29d9b5055351c5$var$Transition {
    elapsed = 0;
    timer = null;
    /**
   * Create a new ResumableTransition.
   * @param duration Duration in milliseconds
   * @param easingFn The easing function
   * @param onTick Callback function called on each animation frame with the eased time in range [0, 1].
   */ constructor(duration, easingFn, onTick){
        this.duration = duration;
        this.easingFn = easingFn;
        this.onTickCallback = onTick;
        this.resume();
    }
    get running() {
        return this.timer !== null;
    }
    timerCallback(elapsed) {
        this.elapsed = Math.min(elapsed, this.duration);
        const t = this.duration === 0 ? 1 : this.elapsed / this.duration;
        const easedT = this.easingFn(t);
        // Call the tick callback with the current value
        this.onTickCallback(easedT);
        if (this.elapsed >= this.duration) this.stop();
    }
    /**
   * Resume the transition
   */ resume() {
        if (this.running || this.elapsed >= this.duration) return this;
        /* If we're resuming the transition, then subtract elapsed to continue the easing. */ const time = (0, $2V7SS.now)() - this.elapsed;
        this.timer = (0, $2V7SS.timer)((elapsed)=>this.timerCallback(elapsed), 0, time);
        return this;
    }
    /**
   * Stops the transition.
   */ stop() {
        if (!this.running) return this;
        if (this.timer) {
            this.timer.stop();
            this.timer = null;
        }
        return this;
    }
    /**
   * Immediately finishes the transition and calls the tick callback with the final value.
   */ finish() {
        this.stop();
        (0, $2V7SS.timeout)(()=>this.timerCallback(this.duration));
        return this;
    }
}
module.exports.Transition = $cf29d9b5055351c5$var$Transition;

});
parcelRegister("2V7SS", function(module, exports) {
// `x-charts-vendor/d3-timer` (CommonJS)
// See upstream license: https://github.com/d3/d3-timer/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

module.exports = (parcelRequire("ehlyG"));

});
parcelRegister("ehlyG", function(module, exports) {
// `x-charts-vendor/d3-timer` (CommonJS)
// See upstream license: https://github.com/d3/d3-timer/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-timer`

module.exports = (parcelRequire("esjg0"));

});
parcelRegister("esjg0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8629e4433841715$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interval", {
    enumerable: true,
    get: function() {
        return $a8629e4433841715$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "now", {
    enumerable: true,
    get: function() {
        return $0adNC.now;
    }
});
Object.defineProperty(module.exports, "timeout", {
    enumerable: true,
    get: function() {
        return $a8629e4433841715$var$_timeout.default;
    }
});
Object.defineProperty(module.exports, "timer", {
    enumerable: true,
    get: function() {
        return $0adNC.timer;
    }
});
Object.defineProperty(module.exports, "timerFlush", {
    enumerable: true,
    get: function() {
        return $0adNC.timerFlush;
    }
});

var $0adNC = parcelRequire("0adNC");

var $a8629e4433841715$var$_timeout = $a8629e4433841715$require$_interopRequireDefault((parcelRequire("8aFkY")));

var $a8629e4433841715$var$_interval = $a8629e4433841715$require$_interopRequireDefault((parcelRequire("WP9jA")));

});
parcelRegister("0adNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timer = $0007edfe2b29a862$var$Timer;
module.exports.now = $0007edfe2b29a862$var$now;
module.exports.timer = $0007edfe2b29a862$var$timer;
module.exports.timerFlush = $0007edfe2b29a862$var$timerFlush;
var $0007edfe2b29a862$var$frame = 0, // is an animation frame pending?
$0007edfe2b29a862$var$timeout = 0, // is a timeout pending?
$0007edfe2b29a862$var$interval = 0, // are any timers active?
$0007edfe2b29a862$var$pokeDelay = 1000, // how frequently we check for clock skew
$0007edfe2b29a862$var$taskHead, $0007edfe2b29a862$var$taskTail, $0007edfe2b29a862$var$clockLast = 0, $0007edfe2b29a862$var$clockNow = 0, $0007edfe2b29a862$var$clockSkew = 0, $0007edfe2b29a862$var$clock = typeof performance === "object" && performance.now ? performance : Date, $0007edfe2b29a862$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $0007edfe2b29a862$var$now() {
    return $0007edfe2b29a862$var$clockNow || ($0007edfe2b29a862$var$setFrame($0007edfe2b29a862$var$clearNow), $0007edfe2b29a862$var$clockNow = $0007edfe2b29a862$var$clock.now() + $0007edfe2b29a862$var$clockSkew);
}
function $0007edfe2b29a862$var$clearNow() {
    $0007edfe2b29a862$var$clockNow = 0;
}
function $0007edfe2b29a862$var$Timer() {
    this._call = this._time = this._next = null;
}
$0007edfe2b29a862$var$Timer.prototype = $0007edfe2b29a862$var$timer.prototype = {
    constructor: $0007edfe2b29a862$var$Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $0007edfe2b29a862$var$now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $0007edfe2b29a862$var$taskTail !== this) {
            if ($0007edfe2b29a862$var$taskTail) $0007edfe2b29a862$var$taskTail._next = this;
            else $0007edfe2b29a862$var$taskHead = this;
            $0007edfe2b29a862$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $0007edfe2b29a862$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $0007edfe2b29a862$var$sleep();
        }
    }
};
function $0007edfe2b29a862$var$timer(callback, delay, time) {
    var t = new $0007edfe2b29a862$var$Timer();
    t.restart(callback, delay, time);
    return t;
}
function $0007edfe2b29a862$var$timerFlush() {
    $0007edfe2b29a862$var$now(); // Get the current time, if not already set.
    ++$0007edfe2b29a862$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $0007edfe2b29a862$var$taskHead, e;
    while(t){
        if ((e = $0007edfe2b29a862$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$0007edfe2b29a862$var$frame;
}
function $0007edfe2b29a862$var$wake() {
    $0007edfe2b29a862$var$clockNow = ($0007edfe2b29a862$var$clockLast = $0007edfe2b29a862$var$clock.now()) + $0007edfe2b29a862$var$clockSkew;
    $0007edfe2b29a862$var$frame = $0007edfe2b29a862$var$timeout = 0;
    try {
        $0007edfe2b29a862$var$timerFlush();
    } finally{
        $0007edfe2b29a862$var$frame = 0;
        $0007edfe2b29a862$var$nap();
        $0007edfe2b29a862$var$clockNow = 0;
    }
}
function $0007edfe2b29a862$var$poke() {
    var now = $0007edfe2b29a862$var$clock.now(), delay = now - $0007edfe2b29a862$var$clockLast;
    if (delay > $0007edfe2b29a862$var$pokeDelay) $0007edfe2b29a862$var$clockSkew -= delay, $0007edfe2b29a862$var$clockLast = now;
}
function $0007edfe2b29a862$var$nap() {
    var t0, t1 = $0007edfe2b29a862$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $0007edfe2b29a862$var$taskHead = t2;
    }
    $0007edfe2b29a862$var$taskTail = t0;
    $0007edfe2b29a862$var$sleep(time);
}
function $0007edfe2b29a862$var$sleep(time) {
    if ($0007edfe2b29a862$var$frame) return; // Soonest alarm already set, or will be.
    if ($0007edfe2b29a862$var$timeout) $0007edfe2b29a862$var$timeout = clearTimeout($0007edfe2b29a862$var$timeout);
    var delay = time - $0007edfe2b29a862$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $0007edfe2b29a862$var$timeout = setTimeout($0007edfe2b29a862$var$wake, time - $0007edfe2b29a862$var$clock.now() - $0007edfe2b29a862$var$clockSkew);
        if ($0007edfe2b29a862$var$interval) $0007edfe2b29a862$var$interval = clearInterval($0007edfe2b29a862$var$interval);
    } else {
        if (!$0007edfe2b29a862$var$interval) $0007edfe2b29a862$var$clockLast = $0007edfe2b29a862$var$clock.now(), $0007edfe2b29a862$var$interval = setInterval($0007edfe2b29a862$var$poke, $0007edfe2b29a862$var$pokeDelay);
        $0007edfe2b29a862$var$frame = 1, $0007edfe2b29a862$var$setFrame($0007edfe2b29a862$var$wake);
    }
}

});

parcelRegister("8aFkY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f2f52a153f54e0e$var$_default;

var $0adNC = parcelRequire("0adNC");
function $5f2f52a153f54e0e$var$_default(callback, delay, time) {
    var t = new $0adNC.Timer();
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});

parcelRegister("WP9jA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b0d181185e3b97b$var$_default;

var $0adNC = parcelRequire("0adNC");
function $0b0d181185e3b97b$var$_default(callback, delay, time) {
    var t = new $0adNC.Timer(), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;
    t.restart = function(callback, delay, time) {
        delay = +delay, time = time == null ? (0, $0adNC.now)() : +time;
        t._restart(function tick(elapsed) {
            elapsed += total;
            t._restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
    };
    t.restart(callback, delay, time);
    return t;
}

});





parcelRegister("81urP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shallowEqual = $5d760902365ad1a6$var$shallowEqual;
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 *
 * Source: https://github.com/facebook/react/blob/c2a196174763e0b4f16ed1c512ed4442b062395e/packages/shared/shallowEqual.js#L18
 */ function $5d760902365ad1a6$var$shallowEqual(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i += 1){
        const currentKey = keysA[i];
        if (!Object.prototype.hasOwnProperty.call(objB, currentKey) || // @ts-ignore
        !Object.is(objA[currentKey], objB[currentKey])) return false;
    }
    return true;
}

});




parcelRegister("SyUaR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0a401eac623a357f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0a401eac623a357f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppearingMask = $0a401eac623a357f$var$AppearingMask;
module.exports.appearingMaskClasses = void 0;

var $0a401eac623a357f$var$React = $0a401eac623a357f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $0a401eac623a357f$var$_generateUtilityClasses = $0a401eac623a357f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $32gdR = parcelRequire("32gdR");

var $kLHgj = parcelRequire("kLHgj");

var $55quD = parcelRequire("55quD");

var $ayMG0 = parcelRequire("ayMG0");
const $0a401eac623a357f$var$appearingMaskClasses = module.exports.appearingMaskClasses = (0, $0a401eac623a357f$var$_generateUtilityClasses.default)('MuiAppearingMask', [
    'animate'
]);
const $0a401eac623a357f$var$AnimatedRect = (0, $8xDHs.styled)('rect', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    animationName: 'animate-width',
    animationTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION,
    animationDuration: '0s',
    [`&.${$0a401eac623a357f$var$appearingMaskClasses.animate}`]: {
        animationDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`
    },
    '@keyframes animate-width': {
        from: {
            width: 0
        }
    }
});
/**
 * @ignore - internal component.
 */ function $0a401eac623a357f$var$AppearingMask(props) {
    const drawingArea = (0, $55quD.useDrawingArea)();
    const chartId = (0, $55quD.useChartId)();
    const clipId = (0, $kLHgj.cleanId)(`${chartId}-${props.id}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0a401eac623a357f$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                id: clipId,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($0a401eac623a357f$var$AnimatedRect, {
                    className: props.skipAnimation ? '' : $0a401eac623a357f$var$appearingMaskClasses.animate,
                    x: 0,
                    y: 0,
                    width: drawingArea.left + drawingArea.width + drawingArea.right,
                    height: drawingArea.top + drawingArea.height + drawingArea.bottom
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: `url(#${clipId})`,
                children: props.children
            })
        ]
    });
}

});
parcelRegister("kLHgj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cleanId = $f1e9c1606c1d1184$var$cleanId;
/**
 * Remove spaces to have viable ids
 */ function $f1e9c1606c1d1184$var$cleanId(id) {
    return id.replace(' ', '_');
}

});

parcelRegister("55quD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3b41f856d68e5521$var$_exportNames = {
    usePieSeries: true,
    usePieSeriesContext: true,
    useChartGradientId: true,
    useChartGradientIdObjectBound: true
};
Object.defineProperty(module.exports, "useChartGradientId", {
    enumerable: true,
    get: function() {
        return $eq62P.useChartGradientId;
    }
});
Object.defineProperty(module.exports, "useChartGradientIdObjectBound", {
    enumerable: true,
    get: function() {
        return $eq62P.useChartGradientIdObjectBound;
    }
});
Object.defineProperty(module.exports, "usePieSeries", {
    enumerable: true,
    get: function() {
        return $kEOtY.usePieSeries;
    }
});
Object.defineProperty(module.exports, "usePieSeriesContext", {
    enumerable: true,
    get: function() {
        return $kEOtY.usePieSeriesContext;
    }
});

var $gxvLm = parcelRequire("gxvLm");
Object.keys($gxvLm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gxvLm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxvLm[key];
        }
    });
});

var $iHjed = parcelRequire("iHjed");
Object.keys($iHjed).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iHjed[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iHjed[key];
        }
    });
});

var $kzIRL = parcelRequire("kzIRL");
Object.keys($kzIRL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kzIRL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kzIRL[key];
        }
    });
});

var $55Xcx = parcelRequire("55Xcx");
Object.keys($55Xcx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $55Xcx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $55Xcx[key];
        }
    });
});

var $9qhH3 = parcelRequire("9qhH3");
Object.keys($9qhH3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9qhH3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9qhH3[key];
        }
    });
});

var $52Uh8 = parcelRequire("52Uh8");
Object.keys($52Uh8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $52Uh8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $52Uh8[key];
        }
    });
});

var $j3Fic = parcelRequire("j3Fic");
Object.keys($j3Fic).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $j3Fic[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j3Fic[key];
        }
    });
});

var $cGXUp = parcelRequire("cGXUp");
Object.keys($cGXUp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cGXUp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cGXUp[key];
        }
    });
});

var $leTX9 = parcelRequire("leTX9");
Object.keys($leTX9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $leTX9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $leTX9[key];
        }
    });
});

var $974Y3 = parcelRequire("974Y3");
Object.keys($974Y3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $974Y3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $974Y3[key];
        }
    });
});

var $kEOtY = parcelRequire("kEOtY");

var $1Gldq = parcelRequire("1Gldq");
Object.keys($1Gldq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1Gldq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1Gldq[key];
        }
    });
});

var $949YJ = parcelRequire("949YJ");
Object.keys($949YJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $949YJ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $949YJ[key];
        }
    });
});

var $g21ve = parcelRequire("g21ve");
Object.keys($g21ve).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $g21ve[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g21ve[key];
        }
    });
});

var $3N2dU = parcelRequire("3N2dU");
Object.keys($3N2dU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3N2dU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3N2dU[key];
        }
    });
});

var $jjapK = parcelRequire("jjapK");
Object.keys($jjapK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jjapK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jjapK[key];
        }
    });
});

var $8su7q = parcelRequire("8su7q");
Object.keys($8su7q).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8su7q[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8su7q[key];
        }
    });
});

var $eq62P = parcelRequire("eq62P");

var $gHoRz = parcelRequire("gHoRz");
Object.keys($gHoRz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gHoRz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gHoRz[key];
        }
    });
});

var $1D4Lb = parcelRequire("1D4Lb");
Object.keys($1D4Lb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1D4Lb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1D4Lb[key];
        }
    });
});

var $aEQiL = parcelRequire("aEQiL");
Object.keys($aEQiL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $aEQiL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aEQiL[key];
        }
    });
});

var $60FVb = parcelRequire("60FVb");
Object.keys($60FVb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $60FVb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $60FVb[key];
        }
    });
});

var $7ccUh = parcelRequire("7ccUh");
Object.keys($7ccUh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3b41f856d68e5521$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7ccUh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7ccUh[key];
        }
    });
});

});
parcelRegister("gxvLm", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDrawingArea = $c0a85dd7629543fa$var$useDrawingArea;

var $d3mgr = parcelRequire("d3mgr");

var $kOdtM = parcelRequire("kOdtM");
/**
 * Get the drawing area dimensions and coordinates. The drawing area is the area where the chart is rendered.
 *
 * It includes the left, top, width, height, bottom, and right dimensions.
 *
 * @returns The drawing area dimensions.
 */ function $c0a85dd7629543fa$var$useDrawingArea() {
    const store = (0, $d3mgr.useStore)();
    return store.use($kOdtM.selectorChartDrawingArea);
}

});

parcelRegister("iHjed", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartId = $d9cb287d9c20e7dc$var$useChartId;

var $d3mgr = parcelRequire("d3mgr");

var $2H3if = parcelRequire("2H3if");
/**
 * Get the unique identifier of the chart.
 * @returns chartId if it exists.
 */ function $d9cb287d9c20e7dc$var$useChartId() {
    const store = (0, $d3mgr.useStore)();
    return store.use($2H3if.selectorChartId);
}

});

parcelRegister("kzIRL", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getValueToPositionMapper = $efa9e109d4b03255$var$getValueToPositionMapper;
module.exports.useRadiusScale = $efa9e109d4b03255$var$useRadiusScale;
module.exports.useRotationScale = $efa9e109d4b03255$var$useRotationScale;
module.exports.useXScale = $efa9e109d4b03255$var$useXScale;
module.exports.useYScale = $efa9e109d4b03255$var$useYScale;

var $2UPWB = parcelRequire("2UPWB");

var $55Xcx = parcelRequire("55Xcx");
/**
 * For a given scale return a function that map value to their position.
 * Useful when dealing with specific scale such as band.
 * @param {D3Scale} scale The scale to use
 * @returns {(value: any) => number} A function that map value to their position
 */ function $efa9e109d4b03255$var$getValueToPositionMapper(scale) {
    if ((0, $2UPWB.isOrdinalScale)(scale)) return (value)=>(scale(value) ?? 0) + scale.bandwidth() / 2;
    const domain = scale.domain();
    // Fixes https://github.com/mui/mui-x/issues/18999#issuecomment-3173787401
    if (domain[0] === domain[1]) return (value)=>value === domain[0] ? scale(value) : NaN;
    return (value)=>scale(value);
}
/**
 * Get the X scale.
 *
 * @param axisId - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's `xAxis` prop
 *   - Undefined to get the default (first) X axis
 * @returns The X axis scale
 */ function $efa9e109d4b03255$var$useXScale(axisId) {
    const axis = (0, $55Xcx.useXAxis)(axisId);
    return axis.scale;
}
/**
 * Get the Y scale.
 *
 * @param axisId - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's `yAxis` prop
 *   - Undefined to get the default (first) Y axis
 * @returns The Y axis scale
 */ function $efa9e109d4b03255$var$useYScale(axisId) {
    const axis = (0, $55Xcx.useYAxis)(axisId);
    return axis.scale;
}
/**
 * Get the rotation scale.
 *
 * @param axisId - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's `rotationAxis` prop
 *   - Undefined to get the default rotation axis
 * @returns The rotation axis scale, or undefined if not found
 */ function $efa9e109d4b03255$var$useRotationScale(axisId) {
    const axis = (0, $55Xcx.useRotationAxis)(axisId);
    return axis?.scale;
}
/**
 * Get the radius scale.
 * @param axisId - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's `radiusAxis` prop
 *   - Undefined to get the default radius axis
 * @returns The radius axis scale, or undefined if not found
 */ function $efa9e109d4b03255$var$useRadiusScale(axisId) {
    const axis = (0, $55Xcx.useRadiusAxis)(axisId);
    return axis?.scale;
}

});
parcelRegister("55Xcx", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadiusAxes = $3b5b577cf55daedf$var$useRadiusAxes;
module.exports.useRadiusAxis = $3b5b577cf55daedf$var$useRadiusAxis;
module.exports.useRotationAxes = $3b5b577cf55daedf$var$useRotationAxes;
module.exports.useRotationAxis = $3b5b577cf55daedf$var$useRotationAxis;
module.exports.useXAxes = $3b5b577cf55daedf$var$useXAxes;
module.exports.useXAxis = $3b5b577cf55daedf$var$useXAxis;
module.exports.useYAxes = $3b5b577cf55daedf$var$useYAxes;
module.exports.useYAxis = $3b5b577cf55daedf$var$useYAxis;

var $i9lnd = parcelRequire("i9lnd");

var $j98pQ = parcelRequire("j98pQ");

var $d3mgr = parcelRequire("d3mgr");
/**
 * Get all the x-axes.
 *
 * Returns all X axes configured in the chart along with their IDs.
 * This is useful when you need to iterate over multiple axes or access all axis configurations at once.
 *
 * @returns An object containing:
 *   - `xAxis`: An object mapping axis IDs to their configurations `{ [axisId]: axis }`
 *   - `xAxisIds`: An array of all X axis IDs in the chart
 *
 * @example
 * const { xAxis, xAxisIds } = useXAxes();
 *
 * @see `useXAxis` for accessing a single X axis
 */ function $3b5b577cf55daedf$var$useXAxes() {
    const store = (0, $d3mgr.useStore)();
    const { axis: xAxis, axisIds: xAxisIds } = store.use($i9lnd.selectorChartXAxis);
    return {
        xAxis: xAxis,
        xAxisIds: xAxisIds
    };
}
/**
 * Get all the y-axes.
 *
 * Returns all Y axes configured in the chart along with their IDs.
 * This is useful when you need to iterate over multiple axes or access all axis configurations at once.
 *
 * @returns An object containing:
 *   - `yAxis`: An object mapping axis IDs to their configurations `{ [axisId]: axis }`
 *   - `yAxisIds`: An array of all Y axis IDs in the chart
 *
 * @example
 * const { yAxis, yAxisIds } = useYAxes();
 *
 * @see `useYAxis` for accessing a single Y axis
 */ function $3b5b577cf55daedf$var$useYAxes() {
    const store = (0, $d3mgr.useStore)();
    const { axis: yAxis, axisIds: yAxisIds } = store.use($i9lnd.selectorChartYAxis);
    return {
        yAxis: yAxis,
        yAxisIds: yAxisIds
    };
}
/**
 * Get a specific X axis or the default X axis.
 *
 * @param {AxisId} [axisId] - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's `xAxis` prop
 *   - Undefined to get the default (first) X axis
 * @returns The configuration for a single X axis.
 *
 * @example
 * // Get the default X axis
 * const xAxis = useXAxis();
 *
 * @example
 * // Get a specific X axis by string ID
 * const xAxis = useXAxis('revenue');
 */ function $3b5b577cf55daedf$var$useXAxis(axisId) {
    const store = (0, $d3mgr.useStore)();
    const { axis: xAxis, axisIds: xAxisIds } = store.use($i9lnd.selectorChartXAxis);
    const id = axisId ?? xAxisIds[0];
    return xAxis[id];
}
/**
 * Get a specific Y axis or the default Y axis.
 *
 * @param {AxisId} [axisId] - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's `yAxis` prop
 *   - Undefined to get the default (first) Y axis
 * @returns The configuration for a single Y axis.
 *
 * @example
 * // Get the default Y axis
 * const yAxis = useYAxis();
 *
 * @example
 * // Get a specific Y axis by string ID
 * const yAxis = useYAxis('temperature');
 */ function $3b5b577cf55daedf$var$useYAxis(axisId) {
    const store = (0, $d3mgr.useStore)();
    const { axis: yAxis, axisIds: yAxisIds } = store.use($i9lnd.selectorChartYAxis);
    const id = axisId ?? yAxisIds[0];
    return yAxis[id];
}
/**
 * Get all the rotation axes for polar charts.
 *
 * Returns all rotation axes configured in polar charts along with their IDs.
 * Rotation axes are used in charts like `RadarChart` to define angular positioning.
 *
 * @returns An object containing:
 *   - `rotationAxis`: An object mapping axis IDs to their configurations `{ [axisId]: axis }`
 *   - `rotationAxisIds`: An array of all rotation axis IDs in the chart
 *
 * @example
 * const { rotationAxis, rotationAxisIds } = useRotationAxes();
 *
 * @see `useRotationAxis` for accessing a single rotation axis
 */ function $3b5b577cf55daedf$var$useRotationAxes() {
    const store = (0, $d3mgr.useStore)();
    const { axis: rotationAxis, axisIds: rotationAxisIds } = store.use($j98pQ.selectorChartRotationAxis);
    return {
        rotationAxis: rotationAxis,
        rotationAxisIds: rotationAxisIds
    };
}
/**
 * Get all the radius axes for polar charts.
 *
 * Returns all radial axes configured in polar charts along with their IDs.
 * Radius axes are used in charts like `RadarChart` to define radial positioning and scaling.
 *
 * @returns An object containing:
 *   - `radiusAxis`: An object mapping axis IDs to their configurations `{ [axisId]: axis }`
 *   - `radiusAxisIds`: An array of all radius axis IDs in the chart
 *
 * @example
 * const { radiusAxis, radiusAxisIds } = useRadiusAxes();
 *
 * @see `useRadiusAxis` for accessing a single radius axis
 */ function $3b5b577cf55daedf$var$useRadiusAxes() {
    const store = (0, $d3mgr.useStore)();
    const { axis: radiusAxis, axisIds: radiusAxisIds } = store.use($j98pQ.selectorChartRadiusAxis);
    return {
        radiusAxis: radiusAxis,
        radiusAxisIds: radiusAxisIds
    };
}
/**
 * Get a specific rotation axis or the default rotation axis for polar charts.
 *
 * Returns the configuration and scale for a rotation axis in polar charts.
 * The rotation axis controls the angular positioning of data points around the circle.
 *
 * @param {AxisId} [axisId] - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's rotation axis configuration
 *   - Undefined to get the default (first) rotation axis
 * @returns The rotation axis configuration, or undefined if not found
 *
 * @example
 * // Get the default rotation axis
 * const rotationAxis = useRotationAxis();
 *
 * @example
 * // Get a specific rotation axis by string ID
 * const rotationAxis = useRotationAxis('categories');
 */ function $3b5b577cf55daedf$var$useRotationAxis(axisId) {
    const store = (0, $d3mgr.useStore)();
    const { axis: rotationAxis, axisIds: rotationAxisIds } = store.use($j98pQ.selectorChartRotationAxis);
    const id = axisId ?? rotationAxisIds[0];
    return rotationAxis[id];
}
/**
 * Get a specific radius axis or the default radius axis for polar charts.
 *
 * Returns the configuration and scale for a radial axis in polar charts.
 * The radius axis controls the radial distance of data points from the center of the circle.
 *
 * @param {AxisId} [axisId] - The axis identifier. Can be:
 *   - A string or number matching the axis ID defined in the chart's radius axis configuration
 *   - Undefined to get the default (first) radius axis
 * @returns The radius axis configuration, or undefined if not found
 *
 * @example
 * // Get the default radius axis
 * const radiusAxis = useRadiusAxis();
 *
 * @example
 * // Get a specific radius axis by string ID
 * const radiusAxis = useRadiusAxis('magnitude');
 */ function $3b5b577cf55daedf$var$useRadiusAxis(axisId) {
    const store = (0, $d3mgr.useStore)();
    const { axis: radiusAxis, axisIds: radiusAxisIds } = store.use($j98pQ.selectorChartRadiusAxis);
    const id = axisId ?? radiusAxisIds[0];
    return radiusAxis[id];
}

});
parcelRegister("j98pQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $df0562d0f024dd7e$var$_exportNames = {
    useChartPolarAxis: true
};
Object.defineProperty(module.exports, "useChartPolarAxis", {
    enumerable: true,
    get: function() {
        return $972Qz.useChartPolarAxis;
    }
});

var $972Qz = parcelRequire("972Qz");

var $50bTE = parcelRequire("50bTE");
Object.keys($50bTE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($df0562d0f024dd7e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $50bTE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $50bTE[key];
        }
    });
});

});
parcelRegister("972Qz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6a26f9d30b902eeb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6a26f9d30b902eeb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartPolarAxis = void 0;

var $6a26f9d30b902eeb$var$_extends2 = $6a26f9d30b902eeb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6a26f9d30b902eeb$var$React = $6a26f9d30b902eeb$require$_interopRequireWildcard((parcelRequire("acw62")));


var $kOdtM = parcelRequire("kOdtM");

var $9Etqx = parcelRequire("9Etqx");

var $8j56i = parcelRequire("8j56i");

var $50bTE = parcelRequire("50bTE");

var $g34sa = parcelRequire("g34sa");

var $ahtwU = parcelRequire("ahtwU");

var $8oJqY = parcelRequire("8oJqY");

var $1k3ob = parcelRequire("1k3ob");

var $cHKFL = parcelRequire("cHKFL");
const $6a26f9d30b902eeb$var$useChartPolarAxis = ({ params: params, store: store, seriesConfig: seriesConfig, svgRef: svgRef, instance: instance })=>{
    const { rotationAxis: rotationAxis, radiusAxis: radiusAxis, dataset: dataset } = params;
    const drawingArea = store.use($kOdtM.selectorChartDrawingArea);
    const processedSeries = store.use($1k3ob.selectorChartSeriesProcessed);
    const center = store.use($50bTE.selectorChartPolarCenter);
    const isInteractionEnabled = store.use($8j56i.selectorChartsInteractionIsInitialized);
    const { axis: rotationAxisWithScale, axisIds: rotationAxisIds } = store.use($50bTE.selectorChartRotationAxis);
    const { axis: radiusAxisWithScale, axisIds: radiusAxisIds } = store.use($50bTE.selectorChartRadiusAxis);
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useChartPolarAxis`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $6a26f9d30b902eeb$var$React.useRef(true);
    $6a26f9d30b902eeb$var$React.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        store.set('polarAxis', (0, $6a26f9d30b902eeb$var$_extends2.default)({}, store.state.polarAxis, {
            rotation: (0, $9Etqx.defaultizeAxis)(rotationAxis, dataset, 'rotation'),
            radius: (0, $9Etqx.defaultizeAxis)(radiusAxis, dataset, 'radius')
        }));
    }, [
        seriesConfig,
        drawingArea,
        rotationAxis,
        radiusAxis,
        dataset,
        store
    ]);
    const svg2rotation = $6a26f9d30b902eeb$var$React.useMemo(()=>(0, $ahtwU.generateSvg2rotation)({
            cx: center.cx,
            cy: center.cy
        }), [
        center.cx,
        center.cy
    ]);
    const svg2polar = $6a26f9d30b902eeb$var$React.useMemo(()=>(0, $ahtwU.generateSvg2polar)({
            cx: center.cx,
            cy: center.cy
        }), [
        center.cx,
        center.cy
    ]);
    const polar2svg = $6a26f9d30b902eeb$var$React.useMemo(()=>(0, $ahtwU.generatePolar2svg)({
            cx: center.cx,
            cy: center.cy
        }), [
        center.cx,
        center.cy
    ]);
    const usedRotationAxisId = rotationAxisIds[0];
    const usedRadiusAxisId = radiusAxisIds[0];
    // Use a ref to avoid rerendering on every mousemove event.
    const mousePosition = $6a26f9d30b902eeb$var$React.useRef({
        isInChart: false
    });
    const hasInteractionPlugin = (0, $cHKFL.checkHasInteractionPlugin)(instance);
    $6a26f9d30b902eeb$var$React.useEffect(()=>{
        const element = svgRef.current;
        if (!isInteractionEnabled || !hasInteractionPlugin || element === null || params.disableAxisListener) return ()=>{};
        // Clean the interaction when the mouse leaves the chart.
        const moveEndHandler = instance.addInteractionListener('moveEnd', (event)=>{
            if (!event.detail.activeGestures.pan) {
                mousePosition.current.isInChart = false;
                instance.cleanInteraction();
            }
        });
        const panEndHandler = instance.addInteractionListener('panEnd', (event)=>{
            if (!event.detail.activeGestures.move) {
                mousePosition.current.isInChart = false;
                instance.cleanInteraction?.();
            }
        });
        const pressEndHandler = instance.addInteractionListener('quickPressEnd', (event)=>{
            if (!event.detail.activeGestures.move && !event.detail.activeGestures.pan) {
                mousePosition.current.isInChart = false;
                instance.cleanInteraction?.();
            }
        });
        const gestureHandler = (event)=>{
            const srcEvent = event.detail.srcEvent;
            // On touch, we want to allow user to interact with the entire svg area in
            // order to better display the tooltip.
            if (event.detail.srcEvent.pointerType === 'touch') {
                const svgRect = element.getBoundingClientRect();
                if (srcEvent.clientX < svgRect.left || srcEvent.clientX > svgRect.right || srcEvent.clientY < svgRect.top || srcEvent.clientY > svgRect.bottom) {
                    mousePosition.current.isInChart = false;
                    instance.cleanInteraction?.();
                    return;
                }
                const svgPoint = (0, $g34sa.getSVGPoint)(element, srcEvent);
                mousePosition.current.isInChart = true;
                instance.setPointerCoordinate?.(svgPoint);
                return;
            }
            // On mouse, we want to restrict the interaction to the drawing area and radar circle.
            const svgPoint = (0, $g34sa.getSVGPoint)(element, srcEvent);
            // Test if it's in the drawing area
            if (!instance.isPointInside(svgPoint.x, svgPoint.y, event.detail.target)) {
                if (mousePosition.current.isInChart) {
                    instance.cleanInteraction?.();
                    mousePosition.current.isInChart = false;
                }
                return;
            }
            // Test if it's in the radar circle
            const radiusSquare = (center.cx - svgPoint.x) ** 2 + (center.cy - svgPoint.y) ** 2;
            const maxRadius = radiusAxisWithScale[usedRadiusAxisId].scale.range()[1];
            if (radiusSquare > maxRadius ** 2) {
                if (mousePosition.current.isInChart) {
                    instance.cleanInteraction?.();
                    mousePosition.current.isInChart = false;
                }
                return;
            }
            mousePosition.current.isInChart = true;
            instance.setPointerCoordinate?.(svgPoint);
        };
        const moveHandler = instance.addInteractionListener('move', gestureHandler);
        const panHandler = instance.addInteractionListener('pan', gestureHandler);
        const pressHandler = instance.addInteractionListener('quickPress', gestureHandler);
        return ()=>{
            moveHandler.cleanup();
            moveEndHandler.cleanup();
            panHandler.cleanup();
            panEndHandler.cleanup();
            pressHandler.cleanup();
            pressEndHandler.cleanup();
        };
    }, [
        svgRef,
        store,
        center,
        radiusAxisWithScale,
        usedRadiusAxisId,
        rotationAxisWithScale,
        usedRotationAxisId,
        instance,
        params.disableAxisListener,
        isInteractionEnabled,
        svg2rotation,
        hasInteractionPlugin
    ]);
    $6a26f9d30b902eeb$var$React.useEffect(()=>{
        const element = svgRef.current;
        const onAxisClick = params.onAxisClick;
        if (element === null || !onAxisClick) return ()=>{};
        const axisClickHandler = instance.addInteractionListener('tap', (event)=>{
            let dataIndex = null;
            let isRotationAxis = false;
            const svgPoint = (0, $g34sa.getSVGPoint)(element, event.detail.srcEvent);
            const rotation = (0, $ahtwU.generateSvg2rotation)(center)(svgPoint.x, svgPoint.y);
            const rotationIndex = (0, $8oJqY.getAxisIndex)(rotationAxisWithScale[usedRotationAxisId], rotation);
            isRotationAxis = rotationIndex !== -1;
            dataIndex = isRotationAxis ? rotationIndex : null; // radius index is not yet implemented.
            const USED_AXIS_ID = isRotationAxis ? usedRotationAxisId : usedRadiusAxisId;
            if (dataIndex == null || dataIndex === -1) return;
            // The .data exist because otherwise the dataIndex would be null or -1.
            const axisValue = (isRotationAxis ? rotationAxisWithScale : radiusAxisWithScale)[USED_AXIS_ID].data[dataIndex];
            const seriesValues = {};
            Object.keys(processedSeries).filter((seriesType)=>seriesType === 'radar').forEach((seriesType)=>{
                processedSeries[seriesType]?.seriesOrder.forEach((seriesId)=>{
                    const seriesItem = processedSeries[seriesType].series[seriesId];
                    seriesValues[seriesId] = seriesItem.data[dataIndex];
                });
            });
            onAxisClick(event.detail.srcEvent, {
                dataIndex: dataIndex,
                axisValue: axisValue,
                seriesValues: seriesValues
            });
        });
        return ()=>{
            axisClickHandler.cleanup();
        };
    }, [
        center,
        instance,
        params.onAxisClick,
        processedSeries,
        radiusAxisWithScale,
        rotationAxisWithScale,
        svgRef,
        usedRadiusAxisId,
        usedRotationAxisId
    ]);
    return {
        instance: {
            svg2polar: svg2polar,
            svg2rotation: svg2rotation,
            polar2svg: polar2svg
        }
    };
};
module.exports.useChartPolarAxis = $6a26f9d30b902eeb$var$useChartPolarAxis;
$6a26f9d30b902eeb$var$useChartPolarAxis.params = {
    rotationAxis: true,
    radiusAxis: true,
    dataset: true,
    disableAxisListener: true,
    onAxisClick: true
};
$6a26f9d30b902eeb$var$useChartPolarAxis.getInitialState = (params)=>({
        polarAxis: {
            rotation: (0, $9Etqx.defaultizeAxis)(params.rotationAxis, params.dataset, 'rotation'),
            radius: (0, $9Etqx.defaultizeAxis)(params.radiusAxis, params.dataset, 'radius')
        }
    });

});
parcelRegister("9Etqx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $706ead12b03d8454$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultizeAxis = $706ead12b03d8454$var$defaultizeAxis;

var $706ead12b03d8454$var$_extends2 = $706ead12b03d8454$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fiXDv = parcelRequire("fiXDv");
function $706ead12b03d8454$var$defaultizeAxis(inAxis, dataset, axisName) {
    const DEFAULT_AXIS_KEY = axisName === 'rotation' ? $fiXDv.DEFAULT_ROTATION_AXIS_KEY : $fiXDv.DEFAULT_RADIUS_AXIS_KEY;
    const inputAxes = inAxis && inAxis.length > 0 ? inAxis : [
        {
            id: DEFAULT_AXIS_KEY
        }
    ];
    return inputAxes.map((axisConfig, index)=>{
        const id = `defaultized-${axisName}-axis-${index}`;
        const dataKey = axisConfig.dataKey;
        if (dataKey === undefined || axisConfig.data !== undefined) return (0, $706ead12b03d8454$var$_extends2.default)({
            id: id
        }, axisConfig);
        if (dataset === undefined) throw new Error(`MUI X Charts: ${axisName}-axis uses \`dataKey\` but no \`dataset\` is provided.`);
        return (0, $706ead12b03d8454$var$_extends2.default)({
            id: id,
            data: dataset.map((d)=>d[dataKey])
        }, axisConfig);
    });
}

});

parcelRegister("ahtwU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSvg2rotation = module.exports.generateSvg2polar = module.exports.generatePolar2svg = void 0;
const $77c265e7cbbf97de$var$generateSvg2rotation = (center)=>(x, y)=>Math.atan2(x - center.cx, center.cy - y);
module.exports.generateSvg2rotation = $77c265e7cbbf97de$var$generateSvg2rotation;
const $77c265e7cbbf97de$var$generateSvg2polar = (center)=>(x, y)=>{
        const angle = Math.atan2(x - center.cx, center.cy - y);
        return [
            Math.sqrt((x - center.cx) ** 2 + (center.cy - y) ** 2),
            angle
        ];
    };
module.exports.generateSvg2polar = $77c265e7cbbf97de$var$generateSvg2polar;
const $77c265e7cbbf97de$var$generatePolar2svg = (center)=>(radius, rotation)=>{
        return [
            center.cx + radius * Math.sin(rotation),
            center.cy - radius * Math.cos(rotation)
        ];
    };
module.exports.generatePolar2svg = $77c265e7cbbf97de$var$generatePolar2svg;

});

parcelRegister("8oJqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAxisIndex = $61d3cede924d4d30$var$getAxisIndex;

var $2UPWB = parcelRequire("2UPWB");

var $bCsNZ = parcelRequire("bCsNZ");
/**
 * For a pointer coordinate, this function returns the value and dataIndex associated.
 * Returns `-1` if the coordinate does not match a value.
 */ function $61d3cede924d4d30$var$getAxisIndex(axisConfig, pointerValue) {
    const { scale: scale, data: axisData, reverse: reverse } = axisConfig;
    if (!(0, $2UPWB.isOrdinalScale)(scale)) throw new Error('MUI X Charts: getAxisValue is not implemented for polare continuous axes.');
    if (!axisData) return -1;
    const angleGap = (0, $bCsNZ.clampAngleRad)(pointerValue - Math.min(...scale.range()));
    const dataIndex = scale.bandwidth() === 0 ? Math.floor((angleGap + scale.step() / 2) / scale.step()) % axisData.length : Math.floor(angleGap / scale.step());
    if (dataIndex < 0 || dataIndex >= axisData.length) return -1;
    return reverse ? axisData.length - 1 - dataIndex : dataIndex;
}

});
parcelRegister("bCsNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clampAngle = $8759967209b3f9c5$var$clampAngle;
module.exports.clampAngleRad = $8759967209b3f9c5$var$clampAngleRad;
/**
 * Clamp angle to [0, 360[.
 */ function $8759967209b3f9c5$var$clampAngle(angle) {
    return (angle % 360 + 360) % 360;
}
const $8759967209b3f9c5$var$TWO_PI = 2 * Math.PI;
/** Clamp angle to [0, 2 * Math.PI[. */ function $8759967209b3f9c5$var$clampAngleRad(angle) {
    return (angle % $8759967209b3f9c5$var$TWO_PI + $8759967209b3f9c5$var$TWO_PI) % $8759967209b3f9c5$var$TWO_PI;
}

});






parcelRegister("9qhH3", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useZAxes = $6dc44453dc6efa08$var$useZAxes;
module.exports.useZAxis = $6dc44453dc6efa08$var$useZAxis;

var $d3mgr = parcelRequire("d3mgr");

var $d4cjJ = parcelRequire("d4cjJ");
function $6dc44453dc6efa08$var$useZAxes() {
    const store = (0, $d3mgr.useStore)();
    const { axis: zAxis, axisIds: zAxisIds } = store.use($d4cjJ.selectorChartZAxis) ?? {
        axis: {},
        axisIds: []
    };
    return {
        zAxis: zAxis,
        zAxisIds: zAxisIds
    };
}
function $6dc44453dc6efa08$var$useZAxis(identifier) {
    const { zAxis: zAxis, zAxisIds: zAxisIds } = $6dc44453dc6efa08$var$useZAxes();
    const id = typeof identifier === 'string' ? identifier : zAxisIds[identifier ?? 0];
    return zAxis[id];
}

});

parcelRegister("52Uh8", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useXColorScale = $3ac8cac5d117814a$var$useXColorScale;
module.exports.useYColorScale = $3ac8cac5d117814a$var$useYColorScale;
module.exports.useZColorScale = $3ac8cac5d117814a$var$useZColorScale;

var $55Xcx = parcelRequire("55Xcx");

var $9qhH3 = parcelRequire("9qhH3");
/**
 * Get the X axis color scale.
 *
 * @param {AxisId | undefined} axisId - If provided returns color scale for axisId, else returns the values for the default axis.
 * @returns {AxisScaleComputedConfig[S]['colorScale'] | undefined} The color scale for the specified X axis, or undefined if not found.
 */ function $3ac8cac5d117814a$var$useXColorScale(axisId) {
    const axis = (0, $55Xcx.useXAxis)(axisId);
    return axis.colorScale;
}
/**
 * Get the Y axis color scale.
 *
 * @param {AxisId | undefined} axisId - If provided returns color scale for axisId, else returns the values for the default axis.
 * @returns {AxisScaleComputedConfig[S]['colorScale'] | undefined} The color scale for the specified Y axis, or undefined if not found.
 */ function $3ac8cac5d117814a$var$useYColorScale(axisId) {
    const axis = (0, $55Xcx.useYAxis)(axisId);
    return axis.colorScale;
}
/**
 * Get the Z axis color scale.
 *
 * @param {AxisId | undefined} axisId - If provided returns color scale for axisId, else returns the values for the default axis.
 * @returns {AxisScaleComputedConfig[S]['colorScale'] | undefined} The color scale for the specified Z axis, or undefined if not found.
 */ function $3ac8cac5d117814a$var$useZColorScale(axisId) {
    const axis = (0, $9qhH3.useZAxis)(axisId);
    return axis.colorScale;
}

});

parcelRegister("j3Fic", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSvgRef = $ddfe53f71e609b19$var$useSvgRef;

var $6hQTT = parcelRequire("6hQTT");
/**
 * Get the ref for the SVG element.
 * @returns The SVG ref.
 */ function $ddfe53f71e609b19$var$useSvgRef() {
    const context = (0, $6hQTT.useChartContext)();
    if (!context) throw new Error([
        'MUI X Charts: Could not find the svg ref context.',
        'It looks like you rendered your component outside of a ChartContainer parent component.'
    ].join('\n'));
    return context.svgRef;
}

});

parcelRegister("cGXUp", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSeries = $93d7e0e725d8cc1e$var$useSeries;

var $d3mgr = parcelRequire("d3mgr");

var $6kle2 = parcelRequire("6kle2");
/**
 * Get access to the internal state of series.
 * Structured by type of series:
 * { seriesType?: { series: { id1: precessedValue, ... }, seriesOrder: [id1, ...] } }
 * @returns FormattedSeries series
 */ function $93d7e0e725d8cc1e$var$useSeries() {
    const store = (0, $d3mgr.useStore)();
    return store.use($6kle2.selectorChartSeriesProcessed);
}

});

parcelRegister("leTX9", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDataset = $f7664ee8cfa0b1a0$var$useDataset;

var $d3mgr = parcelRequire("d3mgr");

var $6kle2 = parcelRequire("6kle2");
/**
 * Get access to the dataset used to populate series and axes data.
 * @returns {DatasetType | undefined} The dataset array if provided, otherwise undefined.
 */ function $f7664ee8cfa0b1a0$var$useDataset() {
    const store = (0, $d3mgr.useStore)();
    return store.use($6kle2.selectorChartDataset);
}

});

parcelRegister("974Y3", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useScatterSeries = $6a289ef911bf3e6a$var$useScatterSeries;
module.exports.useScatterSeriesContext = $6a289ef911bf3e6a$var$useScatterSeriesContext;

var $4JrrG = parcelRequire("4JrrG");
/**
 * Get access to the internal state of scatter series.
 *
 * @param {SeriesId} seriesId The id of the series to get.
 * @returns {UseScatterSeriesReturnValue} the scatter series
 */ /**
 * Get access to the internal state of scatter series.
 *
 * When called without arguments, it returns all scatter series.
 *
 * @returns {UseScatterSeriesReturnValue[]} the scatter series
 */ /**
 * Get access to the internal state of scatter series.
 *
 * @param {SeriesId[]} seriesIds The ids of the series to get. Order is preserved.
 * @returns {UseScatterSeriesReturnValue[]} the scatter series
 */ function $6a289ef911bf3e6a$var$useScatterSeries(seriesIds) {
    return (0, $4JrrG.useSeriesOfType)('scatter', seriesIds);
}
/**
 * Get access to the internal state of scatter series.
 * The returned object contains:
 * - series: a mapping from ids to series attributes.
 * - seriesOrder: the array of series ids.
 * @returns the scatter series
 */ function $6a289ef911bf3e6a$var$useScatterSeriesContext() {
    return (0, $4JrrG.useAllSeriesOfType)('scatter');
}

});
parcelRegister("4JrrG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSeriesOfType = module.exports.useAllSeriesOfType = module.exports.selectorSeriesOfType = module.exports.selectorAllSeriesOfType = void 0;


var $8P0MD = parcelRequire("8P0MD");

var $6kle2 = parcelRequire("6kle2");

var $d3mgr = parcelRequire("d3mgr");
const $3720a77a7a36fe12$var$selectorAllSeriesOfType = module.exports.selectorAllSeriesOfType = (0, $8P0MD.createSelector)($6kle2.selectorChartSeriesProcessed, (processedSeries, seriesType)=>processedSeries[seriesType]);
const $3720a77a7a36fe12$var$selectorSeriesOfType = module.exports.selectorSeriesOfType = (0, $8P0MD.createSelectorMemoized)($6kle2.selectorChartSeriesProcessed, (processedSeries, seriesType, ids)=>{
    if (ids === undefined || Array.isArray(ids) && ids.length === 0) return processedSeries[seriesType]?.seriesOrder?.map((seriesId)=>processedSeries[seriesType]?.series[seriesId]) ?? [];
    if (!Array.isArray(ids)) return processedSeries[seriesType]?.series?.[ids];
    const result = [];
    const failedIds = [];
    for (const id of ids){
        const series = processedSeries[seriesType]?.series?.[id];
        if (series) result.push(series);
        else failedIds.push(id);
    }
    return result;
});
const $3720a77a7a36fe12$var$useAllSeriesOfType = (seriesType)=>{
    const store = (0, $d3mgr.useStore)();
    return store.use($3720a77a7a36fe12$var$selectorAllSeriesOfType, seriesType);
};
module.exports.useAllSeriesOfType = $3720a77a7a36fe12$var$useAllSeriesOfType;
const $3720a77a7a36fe12$var$useSeriesOfType = (seriesType, seriesId)=>{
    const store = (0, $d3mgr.useStore)();
    return store.use($3720a77a7a36fe12$var$selectorSeriesOfType, seriesType, seriesId);
};
module.exports.useSeriesOfType = $3720a77a7a36fe12$var$useSeriesOfType;

});


parcelRegister("kEOtY", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePieSeries = $f09eb3d966ecbed9$var$usePieSeries;
module.exports.usePieSeriesContext = $f09eb3d966ecbed9$var$usePieSeriesContext;
module.exports.usePieSeriesLayout = $f09eb3d966ecbed9$var$usePieSeriesLayout;

var $4JrrG = parcelRequire("4JrrG");

var $d3mgr = parcelRequire("d3mgr");

var $1k3ob = parcelRequire("1k3ob");
/**
 * Get access to the internal state of pie series.
 *
 * @param {SeriesId} seriesId The id of the series to get.
 * @returns {UsePieSeriesReturnValue} the pie series
 */ /**
 * Get access to the internal state of pie series.
 *
 * When called without arguments, it returns all pie series.
 *
 * @returns {UsePieSeriesReturnValue[]} the pie series
 */ /**
 * Get access to the internal state of pie series.
 *
 * @param {SeriesId[]} seriesIds The ids of the series to get. Order is preserved.
 * @returns {UsePieSeriesReturnValue[]} the pie series
 */ function $f09eb3d966ecbed9$var$usePieSeries(seriesIds) {
    return (0, $4JrrG.useSeriesOfType)('pie', seriesIds);
}
/**
 * Get access to the internal state of pie series.
 * The returned object contains:
 * - series: a mapping from ids to series attributes.
 * - seriesOrder: the array of series ids.
 * @returns the pie series
 */ function $f09eb3d966ecbed9$var$usePieSeriesContext() {
    return (0, $4JrrG.useAllSeriesOfType)('pie');
}
/**
 * Get access to the pie layout.
 * @returns {Record<SeriesId, PieSeriesLayout>} the pie layout
 */ function $f09eb3d966ecbed9$var$usePieSeriesLayout() {
    const store = (0, $d3mgr.useStore)();
    const seriesLayout = store.use($1k3ob.selectorChartSeriesLayout);
    return seriesLayout.pie ?? {};
}

});

parcelRegister("1Gldq", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useBarSeries = $139a2ba5566a459a$var$useBarSeries;
module.exports.useBarSeriesContext = $139a2ba5566a459a$var$useBarSeriesContext;

var $4JrrG = parcelRequire("4JrrG");
/**
 * Get access to the internal state of bar series.
 *
 * @param {SeriesId} seriesId The id of the series to get.
 * @returns {UseBarSeriesReturnValue} the bar series
 */ /**
 * Get access to the internal state of bar series.
 *
 * When called without arguments, it returns all bar series.
 *
 * @returns {UseBarSeriesReturnValue[]} the bar series
 */ /**
 * Get access to the internal state of bar series.
 *
 * @param {SeriesId[]} seriesIds The ids of the series to get. Order is preserved.
 * @returns {UseBarSeriesReturnValue[]} the bar series
 */ function $139a2ba5566a459a$var$useBarSeries(seriesIds) {
    return (0, $4JrrG.useSeriesOfType)('bar', seriesIds);
}
/**
 * Get access to the internal state of bar series.
 * The returned object contains:
 * - series: a mapping from ids to series attributes.
 * - seriesOrder: the array of series ids.
 * - stackingGroups: the array of stacking groups. Each group contains the series ids stacked and the strategy to use.
 * @returns the bar series
 */ function $139a2ba5566a459a$var$useBarSeriesContext() {
    return (0, $4JrrG.useAllSeriesOfType)('bar');
}

});

parcelRegister("949YJ", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLineSeries = $699c3a5083ad2522$var$useLineSeries;
module.exports.useLineSeriesContext = $699c3a5083ad2522$var$useLineSeriesContext;

var $4JrrG = parcelRequire("4JrrG");
/**
 * Get access to the internal state of line series.
 *
 * @param {SeriesId} seriesId The id of the series to get.
 * @returns {UseLineSeriesReturnValue} the line series
 */ /**
 * Get access to the internal state of line series.
 *
 * When called without arguments, it returns all line series.
 *
 * @returns {UseLineSeriesReturnValue[]} the line series
 */ /**
 * Get access to the internal state of line series.
 *
 * @param {SeriesId[]} seriesIds The ids of the series to get. Order is preserved.
 * @returns {UseLineSeriesReturnValue[]} the line series
 */ function $699c3a5083ad2522$var$useLineSeries(seriesIds) {
    return (0, $4JrrG.useSeriesOfType)('line', seriesIds);
}
/**
 * Get access to the internal state of line series.
 * The returned object contains:
 * - series: a mapping from ids to series attributes.
 * - seriesOrder: the array of series ids.
 * - stackingGroups: the array of stacking groups. Each group contains the series ids stacked and the strategy to use.
 * @returns the line series
 */ function $699c3a5083ad2522$var$useLineSeriesContext() {
    return (0, $4JrrG.useAllSeriesOfType)('line');
}

});

parcelRegister("g21ve", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarSeries = $babdffaed5d17e9d$var$useRadarSeries;
module.exports.useRadarSeriesContext = $babdffaed5d17e9d$var$useRadarSeriesContext;

var $4JrrG = parcelRequire("4JrrG");
/**
 * Get access to the internal state of radar series.
 *
 * @param {SeriesId} seriesId The id of the series to get.
 * @returns {UseRadarSeriesReturnValue} the radar series
 */ /**
 * Get access to the internal state of radar series.
 *
 * When called without arguments, it returns all radar series.
 *
 * @returns {UseRadarSeriesReturnValue[]} the radar series
 */ /**
 * Get access to the internal state of radar series.
 *
 * @param {SeriesId[]} seriesIds The ids of the series to get. Order is preserved.
 * @returns {UseRadarSeriesReturnValue[]} the radar series
 */ function $babdffaed5d17e9d$var$useRadarSeries(seriesIds) {
    return (0, $4JrrG.useSeriesOfType)('radar', seriesIds);
}
/**
 * Get access to the internal state of radar series.
 * The returned object contains:
 * - series: a mapping from ids to series attributes.
 * - seriesOrder: the array of series ids.
 * @returns the radar series
 */ function $babdffaed5d17e9d$var$useRadarSeriesContext() {
    return (0, $4JrrG.useAllSeriesOfType)('radar');
}

});

parcelRegister("jjapK", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useItemHighlightedGetter = $e0e7deb4566c189c$var$useItemHighlightedGetter;

var $d3mgr = parcelRequire("d3mgr");

var $2Kjnj = parcelRequire("2Kjnj");
/**
 * A hook to check the highlighted state of multiple items.
 * If you're interested by a single one, consider using `useItemHighlighted`.
 *
 * Warning: highlighted and faded can both be true at the same time.
 * We recommend to first test if item is highlighted: `const faded = !highlighted && isFaded(item)`
 * @returns {{ isHighlighted, isFaded }} callbacks to get the state of the item.
 */ function $e0e7deb4566c189c$var$useItemHighlightedGetter() {
    const store = (0, $d3mgr.useStore)();
    const isHighlighted = store.use($2Kjnj.selectorChartsIsHighlightedCallback);
    const isFaded = store.use($2Kjnj.selectorChartsIsFadedCallback);
    return {
        isHighlighted: isHighlighted,
        isFaded: isFaded
    };
}

});

parcelRegister("8su7q", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLegend = $62884d3993098bc3$var$useLegend;

var $1k3ob = parcelRequire("1k3ob");

var $cGXUp = parcelRequire("cGXUp");

var $d3mgr = parcelRequire("d3mgr");
function $62884d3993098bc3$var$getSeriesToDisplay(series, seriesConfig) {
    return Object.keys(series).flatMap((seriesType)=>{
        const getter = seriesConfig[seriesType].legendGetter;
        return getter === undefined ? [] : getter(series[seriesType]);
    });
}
/**
 * Get the legend items to display.
 *
 * This hook is used by the `ChartsLegend` component. And will return the legend items formatted for display.
 *
 * An alternative is to use the `useSeries` hook and format the legend items yourself.
 *
 * @returns legend data
 */ function $62884d3993098bc3$var$useLegend() {
    const series = (0, $cGXUp.useSeries)();
    const store = (0, $d3mgr.useStore)();
    const seriesConfig = store.use($1k3ob.selectorChartSeriesConfig);
    return {
        items: $62884d3993098bc3$var$getSeriesToDisplay(series, seriesConfig)
    };
}

});

parcelRegister("eq62P", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a7f82ebf54344d93$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartGradientId = $a7f82ebf54344d93$var$useChartGradientId;
module.exports.useChartGradientIdBuilder = $a7f82ebf54344d93$var$useChartGradientIdBuilder;
module.exports.useChartGradientIdObjectBound = $a7f82ebf54344d93$var$useChartGradientIdObjectBound;
module.exports.useChartGradientIdObjectBoundBuilder = $a7f82ebf54344d93$var$useChartGradientIdObjectBoundBuilder;

var $a7f82ebf54344d93$var$React = $a7f82ebf54344d93$require$_interopRequireWildcard((parcelRequire("acw62")));

var $iHjed = parcelRequire("iHjed");
/**
 * Returns a function that generates a gradient id for the given axis id.
 */ function $a7f82ebf54344d93$var$useChartGradientIdBuilder() {
    const chartId = (0, $iHjed.useChartId)();
    return $a7f82ebf54344d93$var$React.useCallback((axisId)=>`${chartId}-gradient-${axisId}`, [
        chartId
    ]);
}
/**
 * Returns a function that generates a gradient id for the given axis id.
 */ function $a7f82ebf54344d93$var$useChartGradientIdObjectBoundBuilder() {
    const chartId = (0, $iHjed.useChartId)();
    return $a7f82ebf54344d93$var$React.useCallback((axisId)=>`${chartId}-gradient-${axisId}-object-bound`, [
        chartId
    ]);
}
/**
 * Returns a gradient id for the given axis id.
 *
 * Can be useful when reusing the same gradient on custom components.
 *
 * For a gradient that respects the coordinates of the object on which it is applied, use `useChartGradientIdObjectBound` instead.
 *
 * @param axisId the axis id
 * @returns the gradient id
 */ function $a7f82ebf54344d93$var$useChartGradientId(axisId) {
    return $a7f82ebf54344d93$var$useChartGradientIdBuilder()(axisId);
}
/**
 * Returns a gradient id for the given axis id.
 *
 * Can be useful when reusing the same gradient on custom components.
 *
 * This gradient differs from `useChartGradientId` in that it respects the coordinates of the object on which it is applied.
 *
 * @param axisId the axis id
 * @returns the gradient id
 */ function $a7f82ebf54344d93$var$useChartGradientIdObjectBound(axisId) {
    return $a7f82ebf54344d93$var$useChartGradientIdObjectBoundBuilder()(axisId);
}

});

parcelRegister("gHoRz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aQEJ4 = parcelRequire("aQEJ4");
Object.keys($aQEJ4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aQEJ4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aQEJ4[key];
        }
    });
});

var $hBRQb = parcelRequire("hBRQb");
Object.keys($hBRQb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hBRQb[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hBRQb[key];
        }
    });
});

var $3EXcU = parcelRequire("3EXcU");
Object.keys($3EXcU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3EXcU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3EXcU[key];
        }
    });
});

var $1a1OT = parcelRequire("1a1OT");
Object.keys($1a1OT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1a1OT[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1a1OT[key];
        }
    });
});

var $dr0Kg = parcelRequire("dr0Kg");
Object.keys($dr0Kg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dr0Kg[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dr0Kg[key];
        }
    });
});

var $6f2fL = parcelRequire("6f2fL");
Object.keys($6f2fL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6f2fL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6f2fL[key];
        }
    });
});

var $kWO2K = parcelRequire("kWO2K");
Object.keys($kWO2K).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $kWO2K[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kWO2K[key];
        }
    });
});

});
parcelRegister("3EXcU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimateBar = $2aa308db88c3c5dc$var$useAnimateBar;

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
function $2aa308db88c3c5dc$var$barPropsInterpolator(from, to) {
    const interpolateX = (0, $iNRFO.interpolateNumber)(from.x, to.x);
    const interpolateY = (0, $iNRFO.interpolateNumber)(from.y, to.y);
    const interpolateWidth = (0, $iNRFO.interpolateNumber)(from.width, to.width);
    const interpolateHeight = (0, $iNRFO.interpolateNumber)(from.height, to.height);
    return (t)=>{
        return {
            x: interpolateX(t),
            y: interpolateY(t),
            width: interpolateWidth(t),
            height: interpolateHeight(t)
        };
    };
}
/**
 * Animates a bar from the start of the axis (x-axis for vertical layout, y-axis for horizontal layout) to its
 * final position.
 *
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called.
 */ function $2aa308db88c3c5dc$var$useAnimateBar(props) {
    const initialProps = {
        x: props.layout === 'vertical' ? props.x : props.xOrigin,
        y: props.layout === 'vertical' ? props.yOrigin : props.y,
        width: props.layout === 'vertical' ? props.width : 0,
        height: props.layout === 'vertical' ? 0 : props.height
    };
    return (0, $aQEJ4.useAnimate)({
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height
    }, {
        createInterpolator: $2aa308db88c3c5dc$var$barPropsInterpolator,
        applyProps (element, animatedProps) {
            element.setAttribute('x', animatedProps.x.toString());
            element.setAttribute('y', animatedProps.y.toString());
            element.setAttribute('width', animatedProps.width.toString());
            element.setAttribute('height', animatedProps.height.toString());
        },
        transformProps: (p)=>p,
        initialProps: initialProps,
        skip: props.skipAnimation,
        ref: props.ref
    });
}

});

parcelRegister("1a1OT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimateBarLabel = $0d882303a49272ff$var$useAnimateBarLabel;

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
function $0d882303a49272ff$var$barLabelPropsInterpolator(from, to) {
    const interpolateX = (0, $iNRFO.interpolateNumber)(from.x, to.x);
    const interpolateY = (0, $iNRFO.interpolateNumber)(from.y, to.y);
    const interpolateWidth = (0, $iNRFO.interpolateNumber)(from.width, to.width);
    const interpolateHeight = (0, $iNRFO.interpolateNumber)(from.height, to.height);
    return (t)=>({
            x: interpolateX(t),
            y: interpolateY(t),
            width: interpolateWidth(t),
            height: interpolateHeight(t)
        });
}
/**
 * Animates a bar label from the start of the axis (x-axis for vertical layout, y-axis for horizontal layout) to the
 * center of the bar it belongs to.
 * The label is horizontally centered within the bar when the layout is vertical, and vertically centered for laid out
 * horizontally.
 *
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called.
 */ function $0d882303a49272ff$var$useAnimateBarLabel(props) {
    const { initialX: initialX, currentX: currentX, initialY: initialY, currentY: currentY } = props.placement === 'outside' ? $0d882303a49272ff$var$getOutsidePlacement(props) : $0d882303a49272ff$var$getCenterPlacement(props);
    const initialProps = {
        x: initialX,
        y: initialY,
        width: props.width,
        height: props.height
    };
    const currentProps = {
        x: currentX,
        y: currentY,
        width: props.width,
        height: props.height
    };
    return (0, $aQEJ4.useAnimate)(currentProps, {
        createInterpolator: $0d882303a49272ff$var$barLabelPropsInterpolator,
        transformProps: (p)=>p,
        applyProps (element, animatedProps) {
            element.setAttribute('x', animatedProps.x.toString());
            element.setAttribute('y', animatedProps.y.toString());
            element.setAttribute('width', animatedProps.width.toString());
            element.setAttribute('height', animatedProps.height.toString());
        },
        initialProps: initialProps,
        skip: props.skipAnimation,
        ref: props.ref
    });
}
const $0d882303a49272ff$var$LABEL_OFFSET = 4;
function $0d882303a49272ff$var$getCenterPlacement(props) {
    return {
        initialX: props.layout === 'vertical' ? props.x + props.width / 2 : props.xOrigin,
        initialY: props.layout === 'vertical' ? props.yOrigin : props.y + props.height / 2,
        currentX: props.x + props.width / 2,
        currentY: props.y + props.height / 2
    };
}
function $0d882303a49272ff$var$getOutsidePlacement(props) {
    let initialY = 0;
    let currentY = 0;
    let initialX = 0;
    let currentX = 0;
    if (props.layout === 'vertical') {
        const shouldPlaceAbove = props.y < props.yOrigin;
        if (shouldPlaceAbove) {
            initialY = props.yOrigin - $0d882303a49272ff$var$LABEL_OFFSET;
            currentY = props.y - $0d882303a49272ff$var$LABEL_OFFSET;
        } else {
            initialY = props.yOrigin + $0d882303a49272ff$var$LABEL_OFFSET;
            currentY = props.y + props.height + $0d882303a49272ff$var$LABEL_OFFSET;
        }
        return {
            initialX: props.x + props.width / 2,
            currentX: props.x + props.width / 2,
            initialY: initialY,
            currentY: currentY
        };
    }
    const shouldPlaceToTheLeft = props.x < props.xOrigin;
    if (shouldPlaceToTheLeft) {
        initialX = props.xOrigin;
        currentX = props.x - $0d882303a49272ff$var$LABEL_OFFSET;
    } else {
        initialX = props.xOrigin;
        currentX = props.x + props.width + $0d882303a49272ff$var$LABEL_OFFSET;
    }
    return {
        initialX: initialX,
        currentX: currentX,
        initialY: props.y + props.height / 2,
        currentY: props.y + props.height / 2
    };
}

});

parcelRegister("dr0Kg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimateLine = $9c7e5ff0c60895af$var$useAnimateLine;

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
/** Animates a line of a line chart using a `path` element.
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called. */ function $9c7e5ff0c60895af$var$useAnimateLine(props) {
    return (0, $aQEJ4.useAnimate)({
        d: props.d
    }, {
        createInterpolator: (lastProps, newProps)=>{
            const interpolate = (0, $iNRFO.interpolateString)(lastProps.d, newProps.d);
            return (t)=>({
                    d: interpolate(t)
                });
        },
        applyProps: (element, { d: d })=>element.setAttribute('d', d),
        skip: props.skipAnimation,
        transformProps: (p)=>p,
        ref: props.ref
    });
}

});

parcelRegister("6f2fL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimatePieArc = $48b5e43845c34960$var$useAnimatePieArc;

var $6hlpT = parcelRequire("6hlpT");

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
function $48b5e43845c34960$var$pieArcPropsInterpolator(from, to) {
    const interpolateStartAngle = (0, $iNRFO.interpolateNumber)(from.startAngle, to.startAngle);
    const interpolateEndAngle = (0, $iNRFO.interpolateNumber)(from.endAngle, to.endAngle);
    const interpolateInnerRadius = (0, $iNRFO.interpolateNumber)(from.innerRadius, to.innerRadius);
    const interpolateOuterRadius = (0, $iNRFO.interpolateNumber)(from.outerRadius, to.outerRadius);
    const interpolatePaddingAngle = (0, $iNRFO.interpolateNumber)(from.paddingAngle, to.paddingAngle);
    const interpolateCornerRadius = (0, $iNRFO.interpolateNumber)(from.cornerRadius, to.cornerRadius);
    return (t)=>{
        return {
            startAngle: interpolateStartAngle(t),
            endAngle: interpolateEndAngle(t),
            innerRadius: interpolateInnerRadius(t),
            outerRadius: interpolateOuterRadius(t),
            paddingAngle: interpolatePaddingAngle(t),
            cornerRadius: interpolateCornerRadius(t)
        };
    };
}
/** Animates a slice of a pie chart by increasing the start and end angles from the middle angle to their final values.
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called. */ function $48b5e43845c34960$var$useAnimatePieArc(props) {
    const initialProps = {
        startAngle: (props.startAngle + props.endAngle) / 2,
        endAngle: (props.startAngle + props.endAngle) / 2,
        innerRadius: props.innerRadius,
        outerRadius: props.outerRadius,
        paddingAngle: props.paddingAngle,
        cornerRadius: props.cornerRadius
    };
    return (0, $aQEJ4.useAnimate)({
        startAngle: props.startAngle,
        endAngle: props.endAngle,
        innerRadius: props.innerRadius,
        outerRadius: props.outerRadius,
        paddingAngle: props.paddingAngle,
        cornerRadius: props.cornerRadius
    }, {
        createInterpolator: $48b5e43845c34960$var$pieArcPropsInterpolator,
        transformProps: (p)=>({
                d: (0, $6hlpT.arc)().cornerRadius(p.cornerRadius)({
                    padAngle: p.paddingAngle,
                    innerRadius: p.innerRadius,
                    outerRadius: p.outerRadius,
                    startAngle: p.startAngle,
                    endAngle: p.endAngle
                }),
                visibility: p.startAngle === p.endAngle ? 'hidden' : 'visible'
            }),
        applyProps (element, p) {
            element.setAttribute('d', p.d);
            element.setAttribute('visibility', p.visibility);
        },
        initialProps: initialProps,
        skip: props.skipAnimation,
        ref: props.ref
    });
}

});

parcelRegister("kWO2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimatePieArcLabel = $f4000b02aab03b2e$var$useAnimatePieArcLabel;

var $6hlpT = parcelRequire("6hlpT");

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
function $f4000b02aab03b2e$var$pieArcLabelPropsInterpolator(from, to) {
    const interpolateStartAngle = (0, $iNRFO.interpolateNumber)(from.startAngle, to.startAngle);
    const interpolateEndAngle = (0, $iNRFO.interpolateNumber)(from.endAngle, to.endAngle);
    const interpolateInnerRadius = (0, $iNRFO.interpolateNumber)(from.innerRadius, to.innerRadius);
    const interpolateOuterRadius = (0, $iNRFO.interpolateNumber)(from.outerRadius, to.outerRadius);
    const interpolatePaddingAngle = (0, $iNRFO.interpolateNumber)(from.paddingAngle, to.paddingAngle);
    const interpolateCornerRadius = (0, $iNRFO.interpolateNumber)(from.cornerRadius, to.cornerRadius);
    return (t)=>{
        return {
            startAngle: interpolateStartAngle(t),
            endAngle: interpolateEndAngle(t),
            innerRadius: interpolateInnerRadius(t),
            outerRadius: interpolateOuterRadius(t),
            paddingAngle: interpolatePaddingAngle(t),
            cornerRadius: interpolateCornerRadius(t)
        };
    };
}
/** Animates the label of pie slice from its middle point to the centroid of the slice.
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called. */ function $f4000b02aab03b2e$var$useAnimatePieArcLabel(props) {
    const initialProps = {
        startAngle: (props.startAngle + props.endAngle) / 2,
        endAngle: (props.startAngle + props.endAngle) / 2,
        innerRadius: props.arcLabelRadius ?? props.innerRadius,
        outerRadius: props.arcLabelRadius ?? props.outerRadius,
        paddingAngle: props.paddingAngle,
        cornerRadius: props.cornerRadius
    };
    return (0, $aQEJ4.useAnimate)({
        startAngle: props.startAngle,
        endAngle: props.endAngle,
        innerRadius: props.arcLabelRadius ?? props.innerRadius,
        outerRadius: props.arcLabelRadius ?? props.outerRadius,
        paddingAngle: props.paddingAngle,
        cornerRadius: props.cornerRadius
    }, {
        createInterpolator: $f4000b02aab03b2e$var$pieArcLabelPropsInterpolator,
        transformProps: (animatedProps)=>{
            const [x, y] = (0, $6hlpT.arc)().cornerRadius(animatedProps.cornerRadius).centroid({
                padAngle: animatedProps.paddingAngle,
                startAngle: animatedProps.startAngle,
                endAngle: animatedProps.endAngle,
                innerRadius: animatedProps.innerRadius,
                outerRadius: animatedProps.outerRadius
            });
            return {
                x: x,
                y: y
            };
        },
        applyProps (element, { x: x, y: y }) {
            element.setAttribute('x', x.toString());
            element.setAttribute('y', y.toString());
        },
        initialProps: initialProps,
        skip: props.skipAnimation,
        ref: props.ref
    });
}

});


parcelRegister("1D4Lb", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartRootRef = $12fd203a7ae6e405$var$useChartRootRef;

var $6hQTT = parcelRequire("6hQTT");
/**
 * Get the ref for the root chart element.
 * @returns The root chart element ref.
 */ function $12fd203a7ae6e405$var$useChartRootRef() {
    const context = (0, $6hQTT.useChartContext)();
    return context.chartRootRef;
}

});

parcelRegister("aEQiL", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $7c2635d49029d335$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartsLocalization = void 0;

var $7c2635d49029d335$var$React = $7c2635d49029d335$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bKuOB = parcelRequire("bKuOB");
const $7c2635d49029d335$var$useChartsLocalization = ()=>{
    const localization = $7c2635d49029d335$var$React.useContext($bKuOB.ChartsLocalizationContext);
    if (localization === null) throw new Error([
        'MUI X Charts: Can not find the charts localization context.',
        'It looks like you forgot to wrap your component in ChartsLocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-charts` package'
    ].join('\n'));
    return localization;
};
module.exports.useChartsLocalization = $7c2635d49029d335$var$useChartsLocalization;

});
parcelRegister("bKuOB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $88dbe4d48422578c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $88dbe4d48422578c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsLocalizationContext = void 0;
module.exports.ChartsLocalizationProvider = $88dbe4d48422578c$var$ChartsLocalizationProvider;

var $88dbe4d48422578c$var$_extends2 = $88dbe4d48422578c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $88dbe4d48422578c$var$_objectWithoutPropertiesLoose2 = $88dbe4d48422578c$require$_interopRequireDefault((parcelRequire("c05no")));

var $88dbe4d48422578c$var$React = $88dbe4d48422578c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $88dbe4d48422578c$var$_propTypes = $88dbe4d48422578c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $e4fxU = parcelRequire("e4fxU");

var $ayMG0 = parcelRequire("ayMG0");
const $88dbe4d48422578c$var$_excluded = [
    "localeText"
];
const $88dbe4d48422578c$var$ChartsLocalizationContext = module.exports.ChartsLocalizationContext = /*#__PURE__*/ $88dbe4d48422578c$var$React.createContext(null);
/**
 * Demos:
 *
 * - [localization](https://mui.com/x/react-charts/localization/)
 *
 * API:
 *
 * - [ChartsLocalizationProvider API](https://mui.com/x/api/charts/charts-localization-provider/)
 */ function $88dbe4d48422578c$var$ChartsLocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, other = (0, $88dbe4d48422578c$var$_objectWithoutPropertiesLoose2.default)(inProps, $88dbe4d48422578c$var$_excluded);
    const { localeText: parentLocaleText } = $88dbe4d48422578c$var$React.useContext($88dbe4d48422578c$var$ChartsLocalizationContext) ?? {
        localeText: undefined
    };
    const props = (0, $8xDHs.useThemeProps)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: other,
        name: 'MuiChartsLocalizationProvider'
    });
    const { children: children, localeText: themeLocaleText } = props;
    const localeText = $88dbe4d48422578c$var$React.useMemo(()=>(0, $88dbe4d48422578c$var$_extends2.default)({}, $e4fxU.DEFAULT_LOCALE, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const contextValue = $88dbe4d48422578c$var$React.useMemo(()=>{
        return {
            localeText: localeText
        };
    }, [
        localeText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($88dbe4d48422578c$var$ChartsLocalizationContext.Provider, {
        value: contextValue,
        children: children
    });
}

});
parcelRegister("e4fxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.enUSLocaleText = module.exports.enUS = module.exports.DEFAULT_LOCALE = void 0;

var $d4dkr = parcelRequire("d4dkr");

var $jDiBl = parcelRequire("jDiBl");
// This object is not Partial<ChartsLocaleText> because it is the default values
const $a3dd7f7f9632e2f4$var$enUSLocaleText = module.exports.enUSLocaleText = {
    // Overlay
    loading: "Loading data\u2026",
    noData: 'No data to display',
    // Toolbar
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    toolbarExport: 'Export',
    // Toolbar Export Menu
    toolbarExportPrint: 'Print',
    toolbarExportImage: (mimeType)=>`Export as ${$d4dkr.imageMimeTypes[mimeType] ?? mimeType}`,
    // Charts renderer configuration
    chartTypeBar: 'Bar',
    chartTypeColumn: 'Column',
    chartTypeLine: 'Line',
    chartTypeArea: 'Area',
    chartTypePie: 'Pie',
    chartPaletteLabel: 'Color palette',
    chartPaletteNameRainbowSurge: 'Rainbow Surge',
    chartPaletteNameBlueberryTwilight: 'Blueberry Twilight',
    chartPaletteNameMangoFusion: 'Mango Fusion',
    chartPaletteNameCheerfulFiesta: 'Cheerful Fiesta',
    chartPaletteNameStrawberrySky: 'Strawberry Sky',
    chartPaletteNameBlue: 'Blue',
    chartPaletteNameGreen: 'Green',
    chartPaletteNamePurple: 'Purple',
    chartPaletteNameRed: 'Red',
    chartPaletteNameOrange: 'Orange',
    chartPaletteNameYellow: 'Yellow',
    chartPaletteNameCyan: 'Cyan',
    chartPaletteNamePink: 'Pink',
    chartConfigurationSectionChart: 'Chart',
    chartConfigurationSectionColumns: 'Columns',
    chartConfigurationSectionBars: 'Bars',
    chartConfigurationSectionAxes: 'Axes',
    chartConfigurationGrid: 'Grid',
    chartConfigurationBorderRadius: 'Border radius',
    chartConfigurationCategoryGapRatio: 'Category gap ratio',
    chartConfigurationBarGapRatio: 'Series gap ratio',
    chartConfigurationStacked: 'Stacked',
    chartConfigurationShowToolbar: 'Show toolbar',
    chartConfigurationSkipAnimation: 'Skip animation',
    chartConfigurationInnerRadius: 'Inner radius',
    chartConfigurationOuterRadius: 'Outer radius',
    chartConfigurationColors: 'Colors',
    chartConfigurationHideLegend: 'Hide legend',
    chartConfigurationShowMark: 'Show mark',
    chartConfigurationHeight: 'Height',
    chartConfigurationWidth: 'Width',
    chartConfigurationSeriesGap: 'Series gap',
    chartConfigurationTickPlacement: 'Tick placement',
    chartConfigurationTickLabelPlacement: 'Tick label placement',
    chartConfigurationCategoriesAxisLabel: 'Categories axis label',
    chartConfigurationSeriesAxisLabel: 'Series axis label',
    chartConfigurationXAxisPosition: 'X-axis position',
    chartConfigurationYAxisPosition: 'Y-axis position',
    chartConfigurationSeriesAxisReverse: 'Reverse series axis',
    chartConfigurationTooltipPlacement: 'Placement',
    chartConfigurationTooltipTrigger: 'Trigger',
    chartConfigurationLegendPosition: 'Position',
    chartConfigurationLegendDirection: 'Direction',
    chartConfigurationBarLabels: 'Bar labels',
    chartConfigurationColumnLabels: 'Column labels',
    chartConfigurationInterpolation: 'Interpolation',
    chartConfigurationSectionTooltip: 'Tooltip',
    chartConfigurationSectionLegend: 'Legend',
    chartConfigurationSectionLines: 'Lines',
    chartConfigurationSectionAreas: 'Areas',
    chartConfigurationSectionArcs: 'Arcs',
    chartConfigurationPaddingAngle: 'Padding angle',
    chartConfigurationCornerRadius: 'Corner radius',
    chartConfigurationArcLabels: 'Arc labels',
    chartConfigurationStartAngle: 'Start angle',
    chartConfigurationEndAngle: 'End angle',
    chartConfigurationPieTooltipTrigger: 'Trigger',
    chartConfigurationPieLegendPosition: 'Position',
    chartConfigurationPieLegendDirection: 'Direction',
    // Common option labels
    chartConfigurationOptionNone: 'None',
    chartConfigurationOptionValue: 'Value',
    chartConfigurationOptionAuto: 'Auto',
    chartConfigurationOptionTop: 'Top',
    chartConfigurationOptionTopLeft: 'Top Left',
    chartConfigurationOptionTopRight: 'Top Right',
    chartConfigurationOptionBottom: 'Bottom',
    chartConfigurationOptionBottomLeft: 'Bottom Left',
    chartConfigurationOptionBottomRight: 'Bottom Right',
    chartConfigurationOptionLeft: 'Left',
    chartConfigurationOptionRight: 'Right',
    chartConfigurationOptionAxis: 'Axis',
    chartConfigurationOptionItem: 'Item',
    chartConfigurationOptionHorizontal: 'Horizontal',
    chartConfigurationOptionVertical: 'Vertical',
    chartConfigurationOptionBoth: 'Both',
    chartConfigurationOptionStart: 'Start',
    chartConfigurationOptionMiddle: 'Middle',
    chartConfigurationOptionEnd: 'End',
    chartConfigurationOptionExtremities: 'Extremities',
    chartConfigurationOptionTick: 'Tick',
    chartConfigurationOptionMonotoneX: 'Monotone X',
    chartConfigurationOptionMonotoneY: 'Monotone Y',
    chartConfigurationOptionCatmullRom: 'Catmull-Rom',
    chartConfigurationOptionLinear: 'Linear',
    chartConfigurationOptionNatural: 'Natural',
    chartConfigurationOptionStep: 'Step',
    chartConfigurationOptionStepBefore: 'Step Before',
    chartConfigurationOptionStepAfter: 'Step After',
    chartConfigurationOptionBumpX: 'Bump X',
    chartConfigurationOptionBumpY: 'Bump Y'
};
const $a3dd7f7f9632e2f4$var$DEFAULT_LOCALE = module.exports.DEFAULT_LOCALE = $a3dd7f7f9632e2f4$var$enUSLocaleText;
const $a3dd7f7f9632e2f4$var$enUS = module.exports.enUS = (0, $jDiBl.getChartsLocalization)($a3dd7f7f9632e2f4$var$enUSLocaleText);

});
parcelRegister("d4dkr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.imageMimeTypes = void 0;
const $9835fce6a92a1c00$var$imageMimeTypes = module.exports.imageMimeTypes = {
    'image/png': 'PNG',
    'image/jpeg': 'JPEG',
    'image/webp': 'WebP'
};

});

parcelRegister("jDiBl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e4b016b32ed16ffb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getChartsLocalization = void 0;

var $e4b016b32ed16ffb$var$_extends2 = $e4b016b32ed16ffb$require$_interopRequireDefault((parcelRequire("3p9rK")));
/**
 * Helper to pass translation to all charts thanks to the MUI theme.
 * @param chartsTranslations The translation object.
 * @returns an object to pass the translation by using the MUI theme default props
 */ const $e4b016b32ed16ffb$var$getChartsLocalization = (chartsTranslations)=>{
    return {
        components: {
            MuiChartsLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $e4b016b32ed16ffb$var$_extends2.default)({}, chartsTranslations)
                }
            }
        }
    };
};
module.exports.getChartsLocalization = $e4b016b32ed16ffb$var$getChartsLocalization;

});




parcelRegister("60FVb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useBrush = $460342d98486c00f$var$useBrush;

var $b4u9m = parcelRequire("b4u9m");

var $d3mgr = parcelRequire("d3mgr");
/**
 * Get the current brush state.
 *
 * - `start` is the starting point of the brush selection.
 * - `current` is the current point of the brush selection.
 *
 * @returns `{ start, current }` - The brush state.
 */ function $460342d98486c00f$var$useBrush() {
    const store = (0, $d3mgr.useStore)();
    return store.use($b4u9m.selectorBrushState);
}

});

parcelRegister("7ccUh", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFocusedItem = $53d3aa6872d61650$var$useFocusedItem;

var $d3mgr = parcelRequire("d3mgr");

var $cp50o = parcelRequire("cp50o");
/**
 * Get the focused item from keyboard navigation.
 */ function $53d3aa6872d61650$var$useFocusedItem() {
    const store = (0, $d3mgr.useStore)();
    return store.use($cp50o.selectorChartsFocusedItem);
}

});





parcelRegister("cfS2L", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSkipAnimation = $8ec0cea77265c84a$var$useSkipAnimation;

var $gzaK4 = parcelRequire("gzaK4");

var $d3mgr = parcelRequire("d3mgr");
/**
 * A hook to get if chart animations should be skipped.
 *
 * @returns {boolean} whether to skip animations
 */ function $8ec0cea77265c84a$var$useSkipAnimation(skipAnimation) {
    const store = (0, $d3mgr.useStore)();
    const storeSkipAnimation = store.use($gzaK4.selectorChartSkipAnimation);
    return skipAnimation || storeSkipAnimation;
}

});

parcelRegister("cFMyx", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInternalIsZoomInteracting = $939efa9632cfcdd2$var$useInternalIsZoomInteracting;

var $d3mgr = parcelRequire("d3mgr");

var $i9lnd = parcelRequire("i9lnd");
/**
 * Check if the zoom is interacting.
 *
 * This should probably be moved/merged to the AnimationContext when we move it to the new API.
 *
 * @ignore Internal hook, similar to the PRO one.
 *
 * @returns {boolean} Inform the zoom is interacting.
 */ function $939efa9632cfcdd2$var$useInternalIsZoomInteracting() {
    const store = (0, $d3mgr.useStore)();
    const isInteracting = store.use($i9lnd.selectorChartZoomIsInteracting);
    return isInteracting;
}

});

parcelRegister("6yYO0", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $4c7515c6feeba898$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAreaPlotData = $4c7515c6feeba898$var$useAreaPlotData;

var $4c7515c6feeba898$var$React = $4c7515c6feeba898$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6hlpT = parcelRequire("6hlpT");

var $eq62P = parcelRequire("eq62P");

var $2UPWB = parcelRequire("2UPWB");

var $i94Sl = parcelRequire("i94Sl");

var $55quD = parcelRequire("55quD");

function $4c7515c6feeba898$var$useAreaPlotData(xAxes, yAxes) {
    const seriesData = (0, $55quD.useLineSeriesContext)();
    const defaultXAxisId = (0, $55quD.useXAxes)().xAxisIds[0];
    const defaultYAxisId = (0, $55quD.useYAxes)().yAxisIds[0];
    const getGradientId = (0, $eq62P.useChartGradientIdBuilder)();
    // This memo prevents odd line chart behavior when hydrating.
    const allData = $4c7515c6feeba898$var$React.useMemo(()=>{
        if (seriesData === undefined) return [];
        const { series: series, stackingGroups: stackingGroups } = seriesData;
        const areaPlotData = [];
        for (const stackingGroup of stackingGroups){
            const groupIds = stackingGroup.ids;
            for(let i = groupIds.length - 1; i >= 0; i -= 1){
                const seriesId = groupIds[i];
                const { xAxisId: xAxisId = defaultXAxisId, yAxisId: yAxisId = defaultYAxisId, visibleStackedData: visibleStackedData, stackedData: stackedData, data: data, connectNulls: connectNulls, baseline: baseline, curve: curve, strictStepCurve: strictStepCurve, area: area } = series[seriesId];
                if (!area || !(xAxisId in xAxes) || !(yAxisId in yAxes)) continue;
                const xScale = xAxes[xAxisId].scale;
                const xPosition = (0, $55quD.getValueToPositionMapper)(xScale);
                const yScale = yAxes[yAxisId].scale;
                const xData = xAxes[xAxisId].data;
                const gradientId = yAxes[yAxisId].colorScale && getGradientId(yAxisId) || xAxes[xAxisId].colorScale && getGradientId(xAxisId) || undefined;
                const shouldExpand = curve?.includes('step') && !strictStepCurve && (0, $2UPWB.isOrdinalScale)(xScale);
                const formattedData = xData?.flatMap((x, index)=>{
                    const nullData = data[index] == null;
                    if (shouldExpand) {
                        const rep = [
                            {
                                x: x,
                                y: visibleStackedData[index],
                                nullData: nullData,
                                isExtension: false
                            }
                        ];
                        if (!nullData && (index === 0 || data[index - 1] == null)) rep.unshift({
                            x: (xScale(x) ?? 0) - (xScale.step() - xScale.bandwidth()) / 2,
                            y: visibleStackedData[index],
                            nullData: nullData,
                            isExtension: true
                        });
                        if (!nullData && (index === data.length - 1 || data[index + 1] == null)) rep.push({
                            x: (xScale(x) ?? 0) + (xScale.step() + xScale.bandwidth()) / 2,
                            y: visibleStackedData[index],
                            nullData: nullData,
                            isExtension: true
                        });
                        return rep;
                    }
                    return {
                        x: x,
                        y: visibleStackedData[index],
                        nullData: nullData
                    };
                }) ?? [];
                const d3Data = connectNulls ? formattedData.filter((d)=>!d.nullData) : formattedData;
                const areaPath = (0, $6hlpT.area)().x((d)=>d.isExtension ? d.x : xPosition(d.x)).defined((d)=>connectNulls || !d.nullData || !!d.isExtension).y0((d)=>{
                    if (typeof baseline === 'number') return yScale(baseline);
                    if (baseline === 'max') return yScale.range()[1];
                    if (baseline === 'min') return yScale.range()[0];
                    const value = d.y && yScale(d.y[0]);
                    if (Number.isNaN(value)) return yScale.range()[0];
                    return value;
                }).y1((d)=>d.y && yScale(d.y[1]));
                const d = areaPath.curve((0, $i94Sl.getCurveFactory)(curve))(d3Data) || '';
                areaPlotData.push({
                    area: series[seriesId].area,
                    color: series[seriesId].color,
                    gradientId: gradientId,
                    d: d,
                    seriesId: seriesId
                });
            }
        }
        return areaPlotData;
    }, [
        seriesData,
        defaultXAxisId,
        defaultYAxisId,
        xAxes,
        yAxes,
        getGradientId
    ]);
    return allData;
}

});
parcelRegister("i94Sl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCurveFactory = $d35cd96e04b79c38$var$getCurveFactory;

var $6hlpT = parcelRequire("6hlpT");
function $d35cd96e04b79c38$var$getCurveFactory(curveType) {
    switch(curveType){
        case 'catmullRom':
            return $6hlpT.curveCatmullRom.alpha(0.5);
        case 'linear':
            return $6hlpT.curveLinear;
        case 'monotoneX':
            return $6hlpT.curveMonotoneX;
        case 'monotoneY':
            return $6hlpT.curveMonotoneY;
        case 'natural':
            return $6hlpT.curveNatural;
        case 'step':
            return $6hlpT.curveStep;
        case 'stepBefore':
            return $6hlpT.curveStepBefore;
        case 'stepAfter':
            return $6hlpT.curveStepAfter;
        case 'bumpY':
            return $6hlpT.curveBumpY;
        case 'bumpX':
            return $6hlpT.curveBumpX;
        default:
            return $6hlpT.curveMonotoneX;
    }
}

});



parcelRegister("f0gHv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $aec3cf861f116b57$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $aec3cf861f116b57$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinePlot = $aec3cf861f116b57$var$LinePlot;

var $aec3cf861f116b57$var$_extends2 = $aec3cf861f116b57$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $aec3cf861f116b57$var$_objectWithoutPropertiesLoose2 = $aec3cf861f116b57$require$_interopRequireDefault((parcelRequire("c05no")));

var $aec3cf861f116b57$var$React = $aec3cf861f116b57$require$_interopRequireWildcard((parcelRequire("acw62")));

var $aec3cf861f116b57$var$_propTypes = $aec3cf861f116b57$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $WFeaH = parcelRequire("WFeaH");

var $cfS2L = parcelRequire("cfS2L");

var $55quD = parcelRequire("55quD");

var $cFMyx = parcelRequire("cFMyx");

var $9Ncej = parcelRequire("9Ncej");

var $32gdR = parcelRequire("32gdR");

var $ayMG0 = parcelRequire("ayMG0");
const $aec3cf861f116b57$var$_excluded = [
    "slots",
    "slotProps",
    "skipAnimation",
    "onItemClick"
];
const $aec3cf861f116b57$var$LinePlotRoot = (0, $8xDHs.styled)('g', {
    name: 'MuiAreaPlot',
    slot: 'Root'
})({
    [`& .${$WFeaH.lineElementClasses.root}`]: {
        transitionProperty: 'opacity, fill',
        transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
        transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION
    }
});
const $aec3cf861f116b57$var$useAggregatedData = ()=>{
    const { xAxis: xAxes } = (0, $55quD.useXAxes)();
    const { yAxis: yAxes } = (0, $55quD.useYAxes)();
    return (0, $9Ncej.useLinePlotData)(xAxes, yAxes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LinePlot API](https://mui.com/x/api/charts/line-plot/)
 */ function $aec3cf861f116b57$var$LinePlot(props) {
    const { slots: slots, slotProps: slotProps, skipAnimation: inSkipAnimation, onItemClick: onItemClick } = props, other = (0, $aec3cf861f116b57$var$_objectWithoutPropertiesLoose2.default)(props, $aec3cf861f116b57$var$_excluded);
    const isZoomInteracting = (0, $cFMyx.useInternalIsZoomInteracting)();
    const skipAnimation = (0, $cfS2L.useSkipAnimation)(isZoomInteracting || inSkipAnimation);
    const completedData = $aec3cf861f116b57$var$useAggregatedData();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aec3cf861f116b57$var$LinePlotRoot, (0, $aec3cf861f116b57$var$_extends2.default)({}, other, {
        children: completedData.map(({ d: d, seriesId: seriesId, color: color, gradientId: gradientId, hidden: hidden })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)($WFeaH.LineElement, {
                id: seriesId,
                d: d,
                color: color,
                gradientId: gradientId,
                hidden: hidden,
                skipAnimation: skipAnimation,
                slots: slots,
                slotProps: slotProps,
                onClick: onItemClick && ((event)=>onItemClick(event, {
                        type: 'line',
                        seriesId: seriesId
                    }))
            }, seriesId);
        })
    }));
}

});
parcelRegister("WFeaH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0b0565d4e2e95971$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0b0565d4e2e95971$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineElement = $0b0565d4e2e95971$var$LineElement;
module.exports.getLineElementUtilityClass = $0b0565d4e2e95971$var$getLineElementUtilityClass;
module.exports.lineElementClasses = void 0;

var $0b0565d4e2e95971$var$_extends2 = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0b0565d4e2e95971$var$_objectWithoutPropertiesLoose2 = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("c05no")));

var $0b0565d4e2e95971$var$React = $0b0565d4e2e95971$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0b0565d4e2e95971$var$_propTypes = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0b0565d4e2e95971$var$_composeClasses = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0b0565d4e2e95971$var$_useSlotProps = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("839K0")));

var $0b0565d4e2e95971$var$_generateUtilityClass = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $0b0565d4e2e95971$var$_generateUtilityClasses = $0b0565d4e2e95971$require$_interopRequireDefault((parcelRequire("5nY49")));

var $hdpx4 = parcelRequire("hdpx4");

var $8xsIq = parcelRequire("8xsIq");

var $3N2dU = parcelRequire("3N2dU");

var $ayMG0 = parcelRequire("ayMG0");
const $0b0565d4e2e95971$var$_excluded = [
    "id",
    "classes",
    "color",
    "gradientId",
    "slots",
    "slotProps",
    "onClick",
    "hidden"
];
function $0b0565d4e2e95971$var$getLineElementUtilityClass(slot) {
    return (0, $0b0565d4e2e95971$var$_generateUtilityClass.default)('MuiLineElement', slot);
}
const $0b0565d4e2e95971$var$lineElementClasses = module.exports.lineElementClasses = (0, $0b0565d4e2e95971$var$_generateUtilityClasses.default)('MuiLineElement', [
    'root',
    'highlighted',
    'faded',
    'series'
]);
const $0b0565d4e2e95971$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded'
        ]
    };
    return (0, $0b0565d4e2e95971$var$_composeClasses.default)(slots, $0b0565d4e2e95971$var$getLineElementUtilityClass, classes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineElement API](https://mui.com/x/api/charts/line-element/)
 */ function $0b0565d4e2e95971$var$LineElement(props) {
    const { id: id, classes: innerClasses, color: color, gradientId: gradientId, slots: slots, slotProps: slotProps, onClick: onClick, hidden: hidden } = props, other = (0, $0b0565d4e2e95971$var$_objectWithoutPropertiesLoose2.default)(props, $0b0565d4e2e95971$var$_excluded);
    const interactionProps = (0, $hdpx4.useInteractionItemProps)({
        type: 'line',
        seriesId: id
    });
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $3N2dU.useItemHighlighted)({
        seriesId: id
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        color: color,
        gradientId: gradientId,
        isFaded: isFaded,
        isHighlighted: isHighlighted,
        hidden: hidden
    };
    const classes = $0b0565d4e2e95971$var$useUtilityClasses(ownerState);
    const Line = slots?.line ?? $8xsIq.AnimatedLine;
    const lineProps = (0, $0b0565d4e2e95971$var$_useSlotProps.default)({
        elementType: Line,
        externalSlotProps: slotProps?.line,
        additionalProps: (0, $0b0565d4e2e95971$var$_extends2.default)({}, interactionProps, {
            onClick: onClick,
            cursor: onClick ? 'pointer' : 'unset'
        }),
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Line, (0, $0b0565d4e2e95971$var$_extends2.default)({}, other, lineProps));
}

});
parcelRegister("8xsIq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6377ae1fd268aeec$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6377ae1fd268aeec$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimatedLine = void 0;

var $6377ae1fd268aeec$var$_extends2 = $6377ae1fd268aeec$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6377ae1fd268aeec$var$_objectWithoutPropertiesLoose2 = $6377ae1fd268aeec$require$_interopRequireDefault((parcelRequire("c05no")));

var $6377ae1fd268aeec$var$React = $6377ae1fd268aeec$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6377ae1fd268aeec$var$_propTypes = $6377ae1fd268aeec$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $55quD = parcelRequire("55quD");

var $SyUaR = parcelRequire("SyUaR");

var $ayMG0 = parcelRequire("ayMG0");
const $6377ae1fd268aeec$var$_excluded = [
    "skipAnimation",
    "ownerState"
];
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [AnimatedLine API](https://mui.com/x/api/charts/animated-line/)
 */ const $6377ae1fd268aeec$var$AnimatedLine = module.exports.AnimatedLine = /*#__PURE__*/ $6377ae1fd268aeec$var$React.forwardRef(function AnimatedLine(props, ref) {
    const { skipAnimation: skipAnimation, ownerState: ownerState } = props, other = (0, $6377ae1fd268aeec$var$_objectWithoutPropertiesLoose2.default)(props, $6377ae1fd268aeec$var$_excluded);
    const animateProps = (0, $55quD.useAnimateLine)({
        d: props.d,
        skipAnimation: skipAnimation,
        ref: ref
    });
    const fadedOpacity = ownerState.isFaded ? 0.3 : 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($SyUaR.AppearingMask, {
        skipAnimation: skipAnimation,
        id: `${ownerState.id}-line-clip`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", (0, $6377ae1fd268aeec$var$_extends2.default)({
            stroke: ownerState.gradientId ? `url(#${ownerState.gradientId})` : ownerState.color,
            strokeWidth: 2,
            strokeLinejoin: "round",
            fill: "none",
            filter: ownerState.isHighlighted ? 'brightness(120%)' : undefined,
            opacity: ownerState.hidden ? 0 : fadedOpacity,
            "data-series": ownerState.id,
            "data-highlighted": ownerState.isHighlighted || undefined,
            "data-faded": ownerState.isFaded || undefined
        }, other, animateProps))
    });
});

});


parcelRegister("9Ncej", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $72122d3f0a3af81b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLinePlotData = $72122d3f0a3af81b$var$useLinePlotData;

var $72122d3f0a3af81b$var$React = $72122d3f0a3af81b$require$_interopRequireWildcard((parcelRequire("acw62")));


var $6hlpT = parcelRequire("6hlpT");

var $eq62P = parcelRequire("eq62P");

var $2UPWB = parcelRequire("2UPWB");

var $i94Sl = parcelRequire("i94Sl");

var $55quD = parcelRequire("55quD");

function $72122d3f0a3af81b$var$useLinePlotData(xAxes, yAxes) {
    const seriesData = (0, $55quD.useLineSeriesContext)();
    const defaultXAxisId = (0, $55quD.useXAxes)().xAxisIds[0];
    const defaultYAxisId = (0, $55quD.useYAxes)().yAxisIds[0];
    const getGradientId = (0, $eq62P.useChartGradientIdBuilder)();
    // This memo prevents odd line chart behavior when hydrating.
    const allData = $72122d3f0a3af81b$var$React.useMemo(()=>{
        if (seriesData === undefined) return [];
        const { series: series, stackingGroups: stackingGroups } = seriesData;
        const linePlotData = [];
        for (const stackingGroup of stackingGroups){
            const groupIds = stackingGroup.ids;
            for (const seriesId of groupIds){
                const { xAxisId: xAxisId = defaultXAxisId, yAxisId: yAxisId = defaultYAxisId, stackedData: stackedData, visibleStackedData: visibleStackedData, data: data, connectNulls: connectNulls, curve: curve, strictStepCurve: strictStepCurve } = series[seriesId];
                if (!(xAxisId in xAxes) || !(yAxisId in yAxes)) continue;
                const xScale = xAxes[xAxisId].scale;
                const xPosition = (0, $55quD.getValueToPositionMapper)(xScale);
                const yScale = yAxes[yAxisId].scale;
                const xData = xAxes[xAxisId].data;
                const gradientId = yAxes[yAxisId].colorScale && getGradientId(yAxisId) || xAxes[xAxisId].colorScale && getGradientId(xAxisId) || undefined;
                const shouldExpand = curve?.includes('step') && !strictStepCurve && (0, $2UPWB.isOrdinalScale)(xScale);
                const formattedData = xData?.flatMap((x, index)=>{
                    const nullData = data[index] == null;
                    if (shouldExpand) {
                        const rep = [
                            {
                                x: x,
                                y: visibleStackedData[index],
                                nullData: nullData,
                                isExtension: false
                            }
                        ];
                        if (!nullData && (index === 0 || data[index - 1] == null)) rep.unshift({
                            x: (xScale(x) ?? 0) - (xScale.step() - xScale.bandwidth()) / 2,
                            y: visibleStackedData[index],
                            nullData: nullData,
                            isExtension: true
                        });
                        if (!nullData && (index === data.length - 1 || data[index + 1] == null)) rep.push({
                            x: (xScale(x) ?? 0) + (xScale.step() + xScale.bandwidth()) / 2,
                            y: visibleStackedData[index],
                            nullData: nullData,
                            isExtension: true
                        });
                        return rep;
                    }
                    return {
                        x: x,
                        y: visibleStackedData[index],
                        nullData: nullData
                    };
                }) ?? [];
                const d3Data = connectNulls ? formattedData.filter((d)=>!d.nullData) : formattedData;
                const hidden = series[seriesId].hidden;
                const linePath = (0, $6hlpT.line)().x((d)=>d.isExtension ? d.x : xPosition(d.x)).defined((d)=>connectNulls || !d.nullData || !!d.isExtension).y((d)=>{
                    if (hidden) return yScale(yScale.domain()[0]);
                    return yScale(d.y[1]);
                });
                const d = linePath.curve((0, $i94Sl.getCurveFactory)(curve))(d3Data) || '';
                linePlotData.push({
                    color: series[seriesId].color,
                    gradientId: gradientId,
                    d: d,
                    seriesId: seriesId,
                    hidden: series[seriesId].hidden
                });
            }
        }
        return linePlotData;
    }, [
        seriesData,
        defaultXAxisId,
        defaultYAxisId,
        xAxes,
        yAxes,
        getGradientId
    ]);
    return allData;
}

});


parcelRegister("cVPen", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $96a28c5066d893ad$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $96a28c5066d893ad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MarkPlot = $96a28c5066d893ad$var$MarkPlot;

var $96a28c5066d893ad$var$_extends2 = $96a28c5066d893ad$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $96a28c5066d893ad$var$_objectWithoutPropertiesLoose2 = $96a28c5066d893ad$require$_interopRequireDefault((parcelRequire("c05no")));

var $96a28c5066d893ad$var$_propTypes = $96a28c5066d893ad$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $96a28c5066d893ad$var$React = $96a28c5066d893ad$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cfS2L = parcelRequire("cfS2L");

var $gJGEo = parcelRequire("gJGEo");

var $kejZ3 = parcelRequire("kejZ3");

var $55quD = parcelRequire("55quD");

var $cFMyx = parcelRequire("cFMyx");

var $a5Dpn = parcelRequire("a5Dpn");

var $6hQTT = parcelRequire("6hQTT");

var $5i2aK = parcelRequire("5i2aK");

var $ayMG0 = parcelRequire("ayMG0");
const $96a28c5066d893ad$var$_excluded = [
    "slots",
    "slotProps",
    "skipAnimation",
    "onItemClick"
];
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [MarkPlot API](https://mui.com/x/api/charts/mark-plot/)
 */ function $96a28c5066d893ad$var$MarkPlot(props) {
    const { slots: slots, slotProps: slotProps, skipAnimation: inSkipAnimation, onItemClick: onItemClick } = props, other = (0, $96a28c5066d893ad$var$_objectWithoutPropertiesLoose2.default)(props, $96a28c5066d893ad$var$_excluded);
    const isZoomInteracting = (0, $cFMyx.useInternalIsZoomInteracting)();
    const skipAnimation = (0, $cfS2L.useSkipAnimation)(isZoomInteracting || inSkipAnimation);
    const { xAxis: xAxis } = (0, $55quD.useXAxes)();
    const { yAxis: yAxis } = (0, $55quD.useYAxes)();
    const { store: store } = (0, $6hQTT.useChartContext)();
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $55quD.useItemHighlightedGetter)();
    const xAxisHighlightIndexes = store.use($a5Dpn.selectorChartsHighlightXAxisIndex);
    const highlightedItems = $96a28c5066d893ad$var$React.useMemo(()=>{
        const rep = {};
        for (const { dataIndex: dataIndex, axisId: axisId } of xAxisHighlightIndexes)if (rep[axisId] === undefined) rep[axisId] = new Set([
            dataIndex
        ]);
        else rep[axisId].add(dataIndex);
        return rep;
    }, [
        xAxisHighlightIndexes
    ]);
    const completedData = (0, $5i2aK.useMarkPlotData)(xAxis, yAxis);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", (0, $96a28c5066d893ad$var$_extends2.default)({}, other, {
        children: completedData.map(({ seriesId: seriesId, clipId: clipId, shape: shape, xAxisId: xAxisId, marks: marks, hidden: hidden })=>{
            const Mark = slots?.mark ?? (shape === 'circle' ? $gJGEo.CircleMarkElement : $kejZ3.MarkElement);
            const isSeriesHighlighted = isHighlighted({
                seriesId: seriesId
            });
            const isSeriesFaded = !isSeriesHighlighted && isFaded({
                seriesId: seriesId
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: `url(#${clipId})`,
                "data-series": seriesId,
                children: marks.map(({ x: x, y: y, index: index, color: color })=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)(Mark, (0, $96a28c5066d893ad$var$_extends2.default)({
                        id: seriesId,
                        dataIndex: index,
                        shape: shape,
                        color: color,
                        x: x,
                        y: y,
                        skipAnimation: skipAnimation,
                        onClick: onItemClick && ((event)=>onItemClick(event, {
                                type: 'line',
                                seriesId: seriesId,
                                dataIndex: index
                            })),
                        isHighlighted: highlightedItems[xAxisId]?.has(index) || isSeriesHighlighted,
                        isFaded: isSeriesFaded,
                        hidden: hidden
                    }, slotProps?.mark), `${seriesId}-${index}`);
                })
            }, seriesId);
        })
    }));
}

});
parcelRegister("gJGEo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c2f1eecdeb2758b0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c2f1eecdeb2758b0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CircleMarkElement = $c2f1eecdeb2758b0$var$CircleMarkElement;

var $c2f1eecdeb2758b0$var$_extends2 = $c2f1eecdeb2758b0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c2f1eecdeb2758b0$var$_objectWithoutPropertiesLoose2 = $c2f1eecdeb2758b0$require$_interopRequireDefault((parcelRequire("c05no")));

var $c2f1eecdeb2758b0$var$React = $c2f1eecdeb2758b0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c2f1eecdeb2758b0$var$_propTypes = $c2f1eecdeb2758b0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $32gdR = parcelRequire("32gdR");

var $hdpx4 = parcelRequire("hdpx4");

var $kIvwk = parcelRequire("kIvwk");

var $ayMG0 = parcelRequire("ayMG0");
const $c2f1eecdeb2758b0$var$_excluded = [
    "x",
    "y",
    "id",
    "classes",
    "color",
    "dataIndex",
    "onClick",
    "skipAnimation",
    "isFaded",
    "isHighlighted",
    "shape",
    "hidden"
];
const $c2f1eecdeb2758b0$var$Circle = (0, $8xDHs.styled)('circle', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    [`&.${$kIvwk.markElementClasses.animate}`]: {
        transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
        transitionProperty: 'cx, cy, opacity',
        transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION
    }
});
/**
 * The line mark element that only render circle for performance improvement.
 *
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [CircleMarkElement API](https://mui.com/x/api/charts/circle-mark-element/)
 */ function $c2f1eecdeb2758b0$var$CircleMarkElement(props) {
    const { x: x, y: y, id: id, classes: innerClasses, color: color, dataIndex: dataIndex, onClick: onClick, skipAnimation: skipAnimation, isFaded: isFaded = false, isHighlighted: isHighlighted = false, hidden: hidden } = props, other = (0, $c2f1eecdeb2758b0$var$_objectWithoutPropertiesLoose2.default)(props, $c2f1eecdeb2758b0$var$_excluded);
    const theme = (0, $8xDHs.useTheme)();
    const interactionProps = (0, $hdpx4.useInteractionItemProps)({
        type: 'line',
        seriesId: id,
        dataIndex: dataIndex
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        isHighlighted: isHighlighted,
        isFaded: isFaded,
        skipAnimation: skipAnimation
    };
    const classes = (0, $kIvwk.useUtilityClasses)(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c2f1eecdeb2758b0$var$Circle, (0, $c2f1eecdeb2758b0$var$_extends2.default)({}, other, {
        cx: x,
        cy: y,
        r: 5,
        fill: (theme.vars || theme).palette.background.paper,
        stroke: color,
        strokeWidth: 2,
        className: classes.root,
        onClick: onClick,
        cursor: onClick ? 'pointer' : 'unset',
        pointerEvents: hidden ? 'none' : undefined
    }, interactionProps, {
        "data-highlighted": isHighlighted || undefined,
        "data-faded": isFaded || undefined,
        opacity: hidden ? 0 : 1
    }));
}

});
parcelRegister("kIvwk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f1505e059108d095$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMarkElementUtilityClass = $f1505e059108d095$var$getMarkElementUtilityClass;
module.exports.useUtilityClasses = module.exports.markElementClasses = void 0;

var $f1505e059108d095$var$_composeClasses = $f1505e059108d095$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $f1505e059108d095$var$_generateUtilityClass = $f1505e059108d095$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $f1505e059108d095$var$_generateUtilityClasses = $f1505e059108d095$require$_interopRequireDefault((parcelRequire("5nY49")));
function $f1505e059108d095$var$getMarkElementUtilityClass(slot) {
    return (0, $f1505e059108d095$var$_generateUtilityClass.default)('MuiMarkElement', slot);
}
const $f1505e059108d095$var$markElementClasses = module.exports.markElementClasses = (0, $f1505e059108d095$var$_generateUtilityClasses.default)('MuiMarkElement', [
    'root',
    'highlighted',
    'faded',
    'animate',
    'series'
]);
const $f1505e059108d095$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted, skipAnimation: skipAnimation } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded',
            skipAnimation ? undefined : 'animate'
        ]
    };
    return (0, $f1505e059108d095$var$_composeClasses.default)(slots, $f1505e059108d095$var$getMarkElementUtilityClass, classes);
};
module.exports.useUtilityClasses = $f1505e059108d095$var$useUtilityClasses;

});


parcelRegister("kejZ3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $eba49dd0f1b1a893$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $eba49dd0f1b1a893$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MarkElement = $eba49dd0f1b1a893$var$MarkElement;

var $eba49dd0f1b1a893$var$_extends2 = $eba49dd0f1b1a893$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $eba49dd0f1b1a893$var$_objectWithoutPropertiesLoose2 = $eba49dd0f1b1a893$require$_interopRequireDefault((parcelRequire("c05no")));

var $eba49dd0f1b1a893$var$React = $eba49dd0f1b1a893$require$_interopRequireWildcard((parcelRequire("acw62")));

var $eba49dd0f1b1a893$var$_propTypes = $eba49dd0f1b1a893$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $6hlpT = parcelRequire("6hlpT");

var $32gdR = parcelRequire("32gdR");

var $iUrbd = parcelRequire("iUrbd");

var $hdpx4 = parcelRequire("hdpx4");

var $kIvwk = parcelRequire("kIvwk");

var $ayMG0 = parcelRequire("ayMG0");
const $eba49dd0f1b1a893$var$_excluded = [
    "x",
    "y",
    "id",
    "classes",
    "color",
    "shape",
    "dataIndex",
    "onClick",
    "skipAnimation",
    "isFaded",
    "isHighlighted",
    "hidden",
    "style"
];
const $eba49dd0f1b1a893$var$MarkElementPath = (0, $8xDHs.styled)('path', {
    name: 'MuiMarkElement',
    slot: 'Root'
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.background.paper,
        [`&.${$kIvwk.markElementClasses.animate}`]: {
            transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
            transitionProperty: 'transform, transform-origin, opacity',
            transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION
        }
    }));
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [MarkElement API](https://mui.com/x/api/charts/mark-element/)
 */ function $eba49dd0f1b1a893$var$MarkElement(props) {
    const { x: x, y: y, id: id, classes: innerClasses, color: color, shape: shape, dataIndex: dataIndex, onClick: onClick, skipAnimation: skipAnimation, isFaded: isFaded = false, isHighlighted: isHighlighted = false, hidden: hidden, style: style } = props, other = (0, $eba49dd0f1b1a893$var$_objectWithoutPropertiesLoose2.default)(props, $eba49dd0f1b1a893$var$_excluded);
    const interactionProps = (0, $hdpx4.useInteractionItemProps)({
        type: 'line',
        seriesId: id,
        dataIndex: dataIndex
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        isHighlighted: isHighlighted,
        isFaded: isFaded,
        skipAnimation: skipAnimation
    };
    const classes = (0, $kIvwk.useUtilityClasses)(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eba49dd0f1b1a893$var$MarkElementPath, (0, $eba49dd0f1b1a893$var$_extends2.default)({}, other, {
        style: (0, $eba49dd0f1b1a893$var$_extends2.default)({}, style, {
            transform: `translate(${x}px, ${y}px)`,
            transformOrigin: `${x}px ${y}px`
        }),
        ownerState: ownerState,
        className: classes.root,
        d: (0, $6hlpT.symbol)($6hlpT.symbolsFill[(0, $iUrbd.getSymbol)(shape)])(),
        onClick: onClick,
        cursor: onClick ? 'pointer' : 'unset',
        pointerEvents: hidden ? 'none' : undefined
    }, interactionProps, {
        "data-highlighted": isHighlighted || undefined,
        "data-faded": isFaded || undefined,
        opacity: hidden ? 0 : 1,
        strokeWidth: 2,
        stroke: color
    }));
}

});
parcelRegister("iUrbd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSymbol = $dc428a56465b096d$var$getSymbol;
function $dc428a56465b096d$var$getSymbol(shape) {
    // prettier-ignore
    switch(shape){
        case 'circle':
            return 0;
        case 'cross':
            return 1;
        case 'diamond':
            return 2;
        case 'square':
            return 3;
        case 'star':
            return 4;
        case 'triangle':
            return 5;
        case 'wye':
            return 6;
        default:
            return 0;
    }
}

});


parcelRegister("5i2aK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3da0518e065af562$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3da0518e065af562$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMarkPlotData = $3da0518e065af562$var$useMarkPlotData;

var $3da0518e065af562$var$React = $3da0518e065af562$require$_interopRequireWildcard((parcelRequire("acw62")));

var $iHjed = parcelRequire("iHjed");

var $55quD = parcelRequire("55quD");

var $kLHgj = parcelRequire("kLHgj");


var $3da0518e065af562$var$_getColor = $3da0518e065af562$require$_interopRequireDefault((parcelRequire("2tsDz")));

var $6hQTT = parcelRequire("6hQTT");
function $3da0518e065af562$var$useMarkPlotData(xAxes, yAxes) {
    const seriesData = (0, $55quD.useLineSeriesContext)();
    const defaultXAxisId = (0, $55quD.useXAxes)().xAxisIds[0];
    const defaultYAxisId = (0, $55quD.useYAxes)().yAxisIds[0];
    const chartId = (0, $iHjed.useChartId)();
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const allData = $3da0518e065af562$var$React.useMemo(()=>{
        if (seriesData === undefined) return [];
        const { series: series, stackingGroups: stackingGroups } = seriesData;
        const markPlotData = [];
        for (const stackingGroup of stackingGroups){
            const groupIds = stackingGroup.ids;
            for (const seriesId of groupIds){
                const { xAxisId: xAxisId = defaultXAxisId, yAxisId: yAxisId = defaultYAxisId, visibleStackedData: visibleStackedData, data: data, showMark: showMark = true, shape: shape = 'circle', hidden: hidden } = series[seriesId];
                if (showMark === false) continue;
                if (!(xAxisId in xAxes) || !(yAxisId in yAxes)) continue;
                const xScale = (0, $55quD.getValueToPositionMapper)(xAxes[xAxisId].scale);
                const yScale = yAxes[yAxisId].scale;
                const xData = xAxes[xAxisId].data;
                const clipId = (0, $kLHgj.cleanId)(`${chartId}-${seriesId}-line-clip`);
                const colorGetter = (0, $3da0518e065af562$var$_getColor.default)(series[seriesId], xAxes[xAxisId], yAxes[yAxisId]);
                const marks = [];
                if (xData) for(let index = 0; index < xData.length; index += 1){
                    const x = xData[index];
                    const value = data[index] == null ? null : visibleStackedData[index][1];
                    if (value === null) continue;
                    // The line fade animation move all the values to the min.
                    // So we need to do the same with mark in order for it to look nice.
                    const y = yScale(hidden ? yScale.domain()[0] : value);
                    const xPos = xScale(x);
                    if (!instance.isPointInside(xPos, y)) continue;
                    if (showMark !== true) {
                        const shouldInclude = showMark({
                            x: xPos,
                            y: y,
                            index: index,
                            position: x,
                            value: value
                        });
                        if (!shouldInclude) continue;
                    }
                    marks.push({
                        x: xPos,
                        y: y,
                        index: index,
                        color: colorGetter(index)
                    });
                }
                markPlotData.push({
                    seriesId: seriesId,
                    clipId: clipId,
                    shape: shape,
                    xAxisId: xAxisId,
                    marks: marks,
                    hidden: hidden
                });
            }
        }
        return markPlotData;
    }, [
        seriesData,
        defaultXAxisId,
        defaultYAxisId,
        chartId,
        xAxes,
        yAxes,
        instance
    ]);
    return allData;
}

});


parcelRegister("dPTe0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a12ae0475263da14$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a12ae0475263da14$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsAxis = $a12ae0475263da14$var$ChartsAxis;

var $a12ae0475263da14$var$React = $a12ae0475263da14$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a12ae0475263da14$var$_propTypes = $a12ae0475263da14$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fMBQY = parcelRequire("fMBQY");

var $dxqK3 = parcelRequire("dxqK3");

var $55quD = parcelRequire("55quD");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsAxis API](https://mui.com/x/api/charts/charts-axis/)
 */ function $a12ae0475263da14$var$ChartsAxis(props) {
    const { slots: slots, slotProps: slotProps } = props;
    const { xAxisIds: xAxisIds, xAxis: xAxis } = (0, $55quD.useXAxes)();
    const { yAxisIds: yAxisIds, yAxis: yAxis } = (0, $55quD.useYAxes)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a12ae0475263da14$var$React.Fragment, {
        children: [
            xAxisIds.map((axisId)=>{
                if (!xAxis[axisId].position || xAxis[axisId].position === 'none') return null;
                return /*#__PURE__*/ (0, $ayMG0.jsx)($fMBQY.ChartsXAxis, {
                    slots: slots,
                    slotProps: slotProps,
                    axisId: axisId
                }, axisId);
            }),
            yAxisIds.map((axisId)=>{
                if (!yAxis[axisId].position || yAxis[axisId].position === 'none') return null;
                return /*#__PURE__*/ (0, $ayMG0.jsx)($dxqK3.ChartsYAxis, {
                    slots: slots,
                    slotProps: slotProps,
                    axisId: axisId
                }, axisId);
            })
        ]
    });
}

});
parcelRegister("fMBQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $690ag = parcelRequire("690ag");
Object.keys($690ag).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $690ag[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $690ag[key];
        }
    });
});

});
parcelRegister("690ag", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4793b607f5976fef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsXAxis = $4793b607f5976fef$var$ChartsXAxis;

var $4793b607f5976fef$var$_extends2 = $4793b607f5976fef$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4793b607f5976fef$var$_propTypes = $4793b607f5976fef$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $55Xcx = parcelRequire("55Xcx");

var $7OGJn = parcelRequire("7OGJn");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsXAxis API](https://mui.com/x/api/charts/charts-x-axis/)
 */ function $4793b607f5976fef$var$ChartsXAxis(inProps) {
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55Xcx.useXAxes)();
    const axis = xAxis[inProps.axisId ?? xAxisIds[0]];
    if (!axis) {
        (0, $9Y8Cp.warnOnce)(`MUI X Charts: No axis found. The axisId "${inProps.axisId}" is probably invalid.`);
        return null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7OGJn.ChartsXAxisImpl, (0, $4793b607f5976fef$var$_extends2.default)({}, inProps, {
        axis: axis
    }));
}

});
parcelRegister("7OGJn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5b0e5960a1dbbf0c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5b0e5960a1dbbf0c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsXAxisImpl = $5b0e5960a1dbbf0c$var$ChartsXAxisImpl;

var $5b0e5960a1dbbf0c$var$_extends2 = $5b0e5960a1dbbf0c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5b0e5960a1dbbf0c$var$_objectWithoutPropertiesLoose2 = $5b0e5960a1dbbf0c$require$_interopRequireDefault((parcelRequire("c05no")));

var $5b0e5960a1dbbf0c$var$React = $5b0e5960a1dbbf0c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5b0e5960a1dbbf0c$var$_useSlotProps = $5b0e5960a1dbbf0c$require$_interopRequireDefault((parcelRequire("839K0")));

var $8xDHs = parcelRequire("8xDHs");

var $iMWqw = parcelRequire("iMWqw");

var $h3ypm = parcelRequire("h3ypm");

var $41V8S = parcelRequire("41V8S");

var $2UPWB = parcelRequire("2UPWB");

var $blYHO = parcelRequire("blYHO");

var $gshSM = parcelRequire("gshSM");

var $55quD = parcelRequire("55quD");

var $7dlGc = parcelRequire("7dlGc");

var $zmHmw = parcelRequire("zmHmw");

var $ayMG0 = parcelRequire("ayMG0");
const $5b0e5960a1dbbf0c$var$_excluded = [
    "axis"
], $5b0e5960a1dbbf0c$var$_excluded2 = [
    "scale",
    "tickNumber",
    "reverse",
    "ordinalTimeTicks"
];
const $5b0e5960a1dbbf0c$var$XAxisRoot = (0, $8xDHs.styled)($zmHmw.AxisRoot, {
    name: 'MuiChartsXAxis',
    slot: 'Root'
})({});
/**
 * @ignore - internal component. Use `ChartsXAxis` instead.
 */ function $5b0e5960a1dbbf0c$var$ChartsXAxisImpl(_ref) {
    let { axis: axis } = _ref, inProps = (0, $5b0e5960a1dbbf0c$var$_objectWithoutPropertiesLoose2.default)(_ref, $5b0e5960a1dbbf0c$var$_excluded);
    // @ts-expect-error ordinalTimeTicks may not be present on all axis types
    // Should be set to never, but this causes other issues with proptypes generator.
    const { scale: xScale, ordinalTimeTicks: ordinalTimeTicks } = axis, settings = (0, $5b0e5960a1dbbf0c$var$_objectWithoutPropertiesLoose2.default)(axis, $5b0e5960a1dbbf0c$var$_excluded2);
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    const themedProps = (0, $8xDHs.useThemeProps)({
        props: (0, $5b0e5960a1dbbf0c$var$_extends2.default)({}, settings, inProps),
        name: 'MuiChartsXAxis'
    });
    const defaultizedProps = (0, $5b0e5960a1dbbf0c$var$_extends2.default)({}, $gshSM.defaultProps, themedProps);
    const { position: position, labelStyle: labelStyle, offset: offset, slots: slots, slotProps: slotProps, sx: sx, disableLine: disableLine, label: label, height: axisHeight } = defaultizedProps;
    const theme = (0, $8xDHs.useTheme)();
    const classes = (0, $gshSM.useUtilityClasses)(defaultizedProps);
    const { left: left, top: top, width: width, height: height } = (0, $55quD.useDrawingArea)();
    const positionSign = position === 'bottom' ? 1 : -1;
    const Line = slots?.axisLine ?? 'line';
    const Label = slots?.axisLabel ?? $41V8S.ChartsText;
    const axisLabelProps = (0, $5b0e5960a1dbbf0c$var$_useSlotProps.default)({
        elementType: Label,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        externalSlotProps: slotProps?.axisLabel,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        additionalProps: {
            style: (0, $5b0e5960a1dbbf0c$var$_extends2.default)({}, theme.typography.body1, {
                lineHeight: 1,
                fontSize: 14,
                textAnchor: 'middle',
                dominantBaseline: position === 'bottom' ? 'text-after-edge' : 'text-before-edge'
            }, labelStyle)
        },
        ownerState: {}
    });
    if (position === 'none') return null;
    const labelHeight = label ? (0, $7dlGc.getStringSize)(label, axisLabelProps.style).height : 0;
    const domain = xScale.domain();
    const isScaleOrdinal = (0, $2UPWB.isOrdinalScale)(xScale);
    const skipTickRendering = isScaleOrdinal ? domain.length === 0 : domain.some($blYHO.isInfinity);
    let children = null;
    if (!skipTickRendering) children = 'groups' in axis && Array.isArray(axis.groups) ? /*#__PURE__*/ (0, $ayMG0.jsx)($h3ypm.ChartsGroupedXAxisTicks, (0, $5b0e5960a1dbbf0c$var$_extends2.default)({}, inProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)($iMWqw.ChartsSingleXAxisTicks, (0, $5b0e5960a1dbbf0c$var$_extends2.default)({}, inProps, {
        axisLabelHeight: labelHeight,
        ordinalTimeTicks: ordinalTimeTicks
    }));
    const labelRefPoint = {
        x: left + width / 2,
        y: positionSign * axisHeight
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5b0e5960a1dbbf0c$var$XAxisRoot, {
        transform: `translate(0, ${position === 'bottom' ? top + height + offset : top - offset})`,
        className: classes.root,
        "data-axis-id": defaultizedProps.id,
        sx: sx,
        children: [
            !disableLine && /*#__PURE__*/ (0, $ayMG0.jsx)(Line, (0, $5b0e5960a1dbbf0c$var$_extends2.default)({
                x1: left,
                x2: left + width,
                className: classes.line
            }, slotProps?.axisLine)),
            children,
            label && /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: classes.label,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Label, (0, $5b0e5960a1dbbf0c$var$_extends2.default)({}, labelRefPoint, axisLabelProps, {
                    text: label
                }))
            })
        ]
    });
}

});
parcelRegister("iMWqw", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $dada08050723776b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $dada08050723776b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsSingleXAxisTicks = $dada08050723776b$var$ChartsSingleXAxisTicks;

var $dada08050723776b$var$_extends2 = $dada08050723776b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $dada08050723776b$var$React = $dada08050723776b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $fMRnF = parcelRequire("fMRnF");

var $gWDH1 = parcelRequire("gWDH1");

var $l5xri = parcelRequire("l5xri");

var $gxvLm = parcelRequire("gxvLm");

var $1HhaP = parcelRequire("1HhaP");

var $6P3Ti = parcelRequire("6P3Ti");

var $ipb4Q = parcelRequire("ipb4Q");

var $gshSM = parcelRequire("gshSM");

var $7TiTk = parcelRequire("7TiTk");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $dada08050723776b$var$ChartsSingleXAxisTicks(inProps) {
    const { axisLabelHeight: axisLabelHeight, ordinalTimeTicks: ordinalTimeTicks } = inProps;
    const { xScale: xScale, defaultizedProps: defaultizedProps, tickNumber: tickNumber, positionSign: positionSign, classes: classes, Tick: Tick, TickLabel: TickLabel, axisTickLabelProps: axisTickLabelProps, reverse: reverse } = (0, $7TiTk.useAxisTicksProps)(inProps);
    const isRtl = (0, $9uEev.useRtl)();
    const isMounted = (0, $l5xri.useMounted)();
    const { disableTicks: disableTicks, tickSize: tickSizeProp, valueFormatter: valueFormatter, slotProps: slotProps, tickInterval: tickInterval, tickLabelInterval: tickLabelInterval, tickPlacement: tickPlacement, tickLabelPlacement: tickLabelPlacement, tickLabelMinGap: tickLabelMinGap, tickSpacing: tickSpacing, height: axisHeight } = defaultizedProps;
    const drawingArea = (0, $gxvLm.useDrawingArea)();
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const isHydrated = (0, $fMRnF.useIsHydrated)();
    const tickSize = disableTicks ? 4 : tickSizeProp;
    const xTicks = (0, $gWDH1.useTicks)({
        scale: xScale,
        tickNumber: tickNumber,
        valueFormatter: valueFormatter,
        tickInterval: tickInterval,
        tickPlacement: tickPlacement,
        tickLabelPlacement: tickLabelPlacement,
        tickSpacing: tickSpacing,
        direction: 'x',
        ordinalTimeTicks: ordinalTimeTicks
    });
    const visibleLabels = (0, $ipb4Q.getVisibleLabels)(xTicks, {
        tickLabelStyle: axisTickLabelProps.style,
        tickLabelInterval: tickLabelInterval,
        tickLabelMinGap: tickLabelMinGap,
        reverse: reverse,
        isMounted: isMounted,
        isXInside: instance.isXInside
    });
    /* If there's an axis title, the tick labels have less space to render  */ const tickLabelsMaxHeight = Math.max(0, axisHeight - (axisLabelHeight > 0 ? axisLabelHeight + $gshSM.AXIS_LABEL_TICK_LABEL_GAP : 0) - tickSize - $gshSM.TICK_LABEL_GAP);
    const tickLabels = isHydrated ? (0, $6P3Ti.shortenLabels)(visibleLabels, drawingArea, tickLabelsMaxHeight, isRtl, axisTickLabelProps.style) : new Map(Array.from(visibleLabels).map((item)=>[
            item,
            item.formattedValue
        ]));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($dada08050723776b$var$React.Fragment, {
        children: xTicks.map((item, index)=>{
            const { offset: tickOffset, labelOffset: labelOffset } = item;
            const xTickLabel = labelOffset ?? 0;
            const yTickLabel = positionSign * (tickSize + $gshSM.TICK_LABEL_GAP);
            const showTick = instance.isXInside(tickOffset);
            const tickLabel = tickLabels.get(item);
            const showTickLabel = visibleLabels.has(item);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                transform: `translate(${tickOffset}, 0)`,
                className: classes.tickContainer,
                children: [
                    !disableTicks && showTick && /*#__PURE__*/ (0, $ayMG0.jsx)(Tick, (0, $dada08050723776b$var$_extends2.default)({
                        y2: positionSign * tickSize,
                        className: classes.tick
                    }, slotProps?.axisTick)),
                    tickLabel !== undefined && showTickLabel && /*#__PURE__*/ (0, $ayMG0.jsx)(TickLabel, (0, $dada08050723776b$var$_extends2.default)({
                        x: xTickLabel,
                        y: yTickLabel
                    }, axisTickLabelProps, {
                        text: tickLabel
                    }))
                ]
            }, index);
        })
    });
}

});
parcelRegister("fMRnF", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b7e4bf02cfb19e4c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsHydrated = $b7e4bf02cfb19e4c$var$useIsHydrated;

var $b7e4bf02cfb19e4c$var$React = $b7e4bf02cfb19e4c$require$_interopRequireWildcard((parcelRequire("acw62")));
/** Returns true after hydration is done on the client.
 *
 * Basically a implementation of Option 2 of this gist: https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85#option-2-lazily-show-component-with-uselayouteffect. */ function $b7e4bf02cfb19e4c$var$useIsHydrated() {
    const [isHydrated, setIsHydrated] = $b7e4bf02cfb19e4c$var$React.useState(false);
    $b7e4bf02cfb19e4c$var$React.useEffect(()=>{
        setIsHydrated(true);
    }, []);
    return isHydrated;
}

});

parcelRegister("gWDH1", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c560da48ed5046a7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyTickSpacing = $c560da48ed5046a7$var$applyTickSpacing;
module.exports.getTicks = $c560da48ed5046a7$var$getTicks;
module.exports.useTicks = $c560da48ed5046a7$var$useTicks;

var $c560da48ed5046a7$var$React = $c560da48ed5046a7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2UPWB = parcelRequire("2UPWB");

var $blYHO = parcelRequire("blYHO");

var $7XaaK = parcelRequire("7XaaK");

var $QqBso = parcelRequire("QqBso");

var $1HhaP = parcelRequire("1HhaP");
const $c560da48ed5046a7$var$offsetRatio = {
    start: 0,
    extremities: 0,
    end: 1,
    middle: 0.5
};
function $c560da48ed5046a7$var$getTickPosition(scale, value, placement) {
    return scale(value) - (scale.step() - scale.bandwidth()) / 2 + $c560da48ed5046a7$var$offsetRatio[placement] * scale.step();
}
/**
 * Returns a new domain where each tick is at least {@link tickSpacing}px from the next one.
 * Assumes tick spacing is greater than 0.
 * @param domain Domain of the scale.
 * @param range Range of the scale.
 * @param tickSpacing Spacing in pixels.
 */ function $c560da48ed5046a7$var$applyTickSpacing(domain, range, tickSpacing) {
    const rangeSpan = Math.abs(range[1] - range[0]);
    const every = Math.ceil(domain.length / (rangeSpan / tickSpacing));
    if (Number.isNaN(every) || every <= 1) return domain;
    return domain.filter((_, index)=>index % every === 0);
}
function $c560da48ed5046a7$var$getTimeTicks(domain, tickNumber, ticksFrequencies, scale, isInside) {
    if (ticksFrequencies.length === 0) return [];
    const isReversed = scale.range()[0] > scale.range()[1];
    // Indexes are inclusive regarding the entire band.
    const startIndex = domain.findIndex((value)=>{
        return isInside($c560da48ed5046a7$var$getTickPosition(scale, value, isReversed ? 'start' : 'end'));
    });
    const endIndex = domain.findLastIndex((value)=>isInside($c560da48ed5046a7$var$getTickPosition(scale, value, isReversed ? 'end' : 'start')));
    const start = domain[0];
    const end = domain[domain.length - 1];
    if (!(start instanceof Date) || !(end instanceof Date)) return [];
    let startFrequencyIndex = 0;
    for(let i = 0; i < ticksFrequencies.length; i += 1)if (ticksFrequencies[i].getTickNumber(start, end) !== 0) {
        startFrequencyIndex = i;
        break;
    }
    let endFrequencyIndex = startFrequencyIndex;
    for(let i = startFrequencyIndex; i < ticksFrequencies.length; i += 1){
        if (i === ticksFrequencies.length - 1) {
            // If we reached the end, use the last tick frequency
            endFrequencyIndex = i;
            break;
        }
        const prevTickCount = ticksFrequencies[i].getTickNumber(start, end);
        const nextTickCount = ticksFrequencies[i + 1].getTickNumber(start, end);
        // Smooth ratio between ticks steps: ticksNumber[i]*ticksNumber[i+1] <= targetTickNumber^2
        if (nextTickCount > tickNumber || tickNumber / prevTickCount < nextTickCount / tickNumber) {
            endFrequencyIndex = i;
            break;
        }
    }
    const ticks = [];
    for(let tickIndex = Math.max(1, startIndex); tickIndex <= endIndex; tickIndex += 1)for(let i = startFrequencyIndex; i <= endFrequencyIndex; i += 1){
        const prevDate = domain[tickIndex - 1];
        const currentDate = domain[tickIndex];
        if (prevDate instanceof Date && currentDate instanceof Date && ticksFrequencies[i].isTick(prevDate, currentDate)) {
            ticks.push({
                index: tickIndex,
                formatter: ticksFrequencies[i].format
            });
            break;
        }
    }
    return ticks;
}
function $c560da48ed5046a7$var$getTicks(options) {
    const { scale: scale, tickNumber: tickNumber, valueFormatter: valueFormatter, tickInterval: tickInterval, tickPlacement: tickPlacementProp, tickLabelPlacement: tickLabelPlacementProp, tickSpacing: tickSpacing, isInside: isInside, ordinalTimeTicks: ordinalTimeTicks } = options;
    if (ordinalTimeTicks !== undefined && (0, $QqBso.isDateData)(scale.domain()) && (0, $2UPWB.isOrdinalScale)(scale)) {
        // ordinal scale with spaced ticks.
        const domain = scale.domain();
        if (domain.length === 0 || domain.length === 1) return [];
        const tickPlacement = 'middle';
        const ticksIndexes = $c560da48ed5046a7$var$getTimeTicks(domain, tickNumber, ordinalTimeTicks.map((tickDef)=>typeof tickDef === 'string' ? $7XaaK.tickFrequencies[tickDef] : tickDef), scale, isInside);
        return ticksIndexes.map(({ index: index, formatter: formatter })=>{
            const value = domain[index];
            const formattedValue = formatter(value);
            return {
                value: value,
                formattedValue: formattedValue,
                offset: $c560da48ed5046a7$var$getTickPosition(scale, value, tickPlacement),
                labelOffset: 0
            };
        });
    }
    const tickPlacement = tickPlacementProp ?? 'extremities';
    // Standard ordinal scale: 1 item =1 tick
    if ((0, $2UPWB.isOrdinalScale)(scale)) {
        const domain = scale.domain();
        const tickLabelPlacement = tickLabelPlacementProp ?? 'middle';
        let filteredDomain = domain;
        if (typeof tickInterval === 'object' && tickInterval != null) filteredDomain = tickInterval;
        else {
            if (typeof tickInterval === 'function') filteredDomain = filteredDomain.filter(tickInterval);
            if (tickSpacing !== undefined && tickSpacing > 0) filteredDomain = $c560da48ed5046a7$var$applyTickSpacing(filteredDomain, scale.range(), tickSpacing);
        }
        if (filteredDomain.length === 0) return [];
        if (scale.bandwidth() > 0) {
            // scale type = 'band'
            const isReversed = scale.range()[0] > scale.range()[1];
            // Indexes are inclusive regarding the entire band.
            const startIndex = filteredDomain.findIndex((value)=>{
                return isInside($c560da48ed5046a7$var$getTickPosition(scale, value, isReversed ? 'start' : 'end'));
            });
            const endIndex = filteredDomain.findLastIndex((value)=>isInside($c560da48ed5046a7$var$getTickPosition(scale, value, isReversed ? 'end' : 'start')));
            return [
                ...filteredDomain.slice(startIndex, endIndex + 1).map((value)=>{
                    const defaultTickLabel = `${value}`;
                    return {
                        value: value,
                        formattedValue: valueFormatter?.(value, {
                            location: 'tick',
                            scale: scale,
                            tickNumber: tickNumber,
                            defaultTickLabel: defaultTickLabel
                        }) ?? defaultTickLabel,
                        offset: $c560da48ed5046a7$var$getTickPosition(scale, value, tickPlacement),
                        labelOffset: tickLabelPlacement === 'tick' ? 0 : scale.step() * ($c560da48ed5046a7$var$offsetRatio[tickLabelPlacement] - $c560da48ed5046a7$var$offsetRatio[tickPlacement])
                    };
                }),
                ...tickPlacement === 'extremities' && endIndex === domain.length - 1 && isInside(scale.range()[1]) ? [
                    {
                        formattedValue: undefined,
                        offset: scale.range()[1],
                        labelOffset: 0
                    }
                ] : []
            ];
        }
        // scale type = 'point'
        return filteredDomain.map((value)=>{
            const defaultTickLabel = `${value}`;
            return {
                value: value,
                formattedValue: valueFormatter?.(value, {
                    location: 'tick',
                    scale: scale,
                    tickNumber: tickNumber,
                    defaultTickLabel: defaultTickLabel
                }) ?? defaultTickLabel,
                offset: scale(value),
                labelOffset: 0
            };
        });
    }
    const domain = scale.domain();
    // Skip axis rendering if no data is available
    // - The domains contains Infinity for continuous scales.
    if (domain.some($blYHO.isInfinity)) return [];
    const tickLabelPlacement = tickLabelPlacementProp;
    const ticks = typeof tickInterval === 'object' ? tickInterval : $c560da48ed5046a7$var$getDefaultTicks(scale, tickNumber);
    // Ticks inside the drawing area
    const visibleTicks = [];
    for(let i = 0; i < ticks.length; i += 1){
        const value = ticks[i];
        const offset = scale(value);
        if (isInside(offset)) {
            /* If d3 returns an empty string, it means that a tick should be shown, but its label shouldn't.
       * This is especially useful in a log scale where we want to show ticks to demonstrate it's a log
       * scale, but don't want to show labels because they would overlap.
       * https://github.com/mui/mui-x/issues/18239 */ const defaultTickLabel = scale.tickFormat(tickNumber)(value);
            visibleTicks.push({
                value: value,
                formattedValue: valueFormatter?.(value, {
                    location: 'tick',
                    scale: scale,
                    tickNumber: tickNumber,
                    defaultTickLabel: defaultTickLabel
                }) ?? defaultTickLabel,
                offset: offset,
                // Allowing the label to be placed in the middle of a continuous scale is weird.
                // But it is useful in some cases, like funnel categories with a linear scale.
                labelOffset: tickLabelPlacement === 'middle' ? scale(ticks[i - 1] ?? 0) - (offset + scale(ticks[i - 1] ?? 0)) / 2 : 0
            });
        }
    }
    return visibleTicks;
}
function $c560da48ed5046a7$var$getDefaultTicks(scale, tickNumber) {
    const domain = scale.domain();
    if (domain[0] === domain[1]) return [
        domain[0]
    ];
    return scale.ticks(tickNumber);
}
function $c560da48ed5046a7$var$useTicks(options) {
    const { scale: scale, tickNumber: tickNumber, valueFormatter: valueFormatter, tickInterval: tickInterval, tickPlacement: tickPlacement = 'extremities', tickLabelPlacement: tickLabelPlacement, tickSpacing: tickSpacing, direction: direction, ordinalTimeTicks: ordinalTimeTicks } = options;
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const isInside = direction === 'x' ? instance.isXInside : instance.isYInside;
    return $c560da48ed5046a7$var$React.useMemo(()=>$c560da48ed5046a7$var$getTicks({
            scale: scale,
            tickNumber: tickNumber,
            tickPlacement: tickPlacement,
            tickInterval: tickInterval,
            tickLabelPlacement: tickLabelPlacement,
            tickSpacing: tickSpacing,
            valueFormatter: valueFormatter,
            isInside: isInside,
            ordinalTimeTicks: ordinalTimeTicks
        }), [
        scale,
        tickNumber,
        tickPlacement,
        tickInterval,
        tickLabelPlacement,
        tickSpacing,
        valueFormatter,
        isInside,
        ordinalTimeTicks
    ]);
}

});
parcelRegister("blYHO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInfinity = $8440bebf1e88bf3a$var$isInfinity;
function $8440bebf1e88bf3a$var$isInfinity(v) {
    return typeof v === 'number' && !Number.isFinite(v);
}

});

parcelRegister("7XaaK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tickFrequencies = void 0;
function $5ca5ef1aad97e8b5$var$yearNumber(from, to) {
    return Math.abs(to.getFullYear() - from.getFullYear());
}
function $5ca5ef1aad97e8b5$var$monthNumber(from, to) {
    return Math.abs(to.getFullYear() * 12 + to.getMonth() - 12 * from.getFullYear() - from.getMonth());
}
function $5ca5ef1aad97e8b5$var$dayNumber(from, to) {
    return Math.abs(to.getTime() - from.getTime()) / 86400000;
}
function $5ca5ef1aad97e8b5$var$hourNumber(from, to) {
    return Math.abs(to.getTime() - from.getTime()) / 3600000;
}
const $5ca5ef1aad97e8b5$var$tickFrequencies = module.exports.tickFrequencies = {
    years: {
        getTickNumber: $5ca5ef1aad97e8b5$var$yearNumber,
        isTick: (prev, value)=>value.getFullYear() !== prev.getFullYear(),
        format: (d)=>d.getFullYear().toString()
    },
    quarterly: {
        getTickNumber: (from, to)=>Math.floor($5ca5ef1aad97e8b5$var$monthNumber(from, to) / 3),
        isTick: (prev, value)=>value.getMonth() !== prev.getMonth() && value.getMonth() % 3 === 0,
        format: new Intl.DateTimeFormat('default', {
            month: 'short'
        }).format
    },
    months: {
        getTickNumber: $5ca5ef1aad97e8b5$var$monthNumber,
        isTick: (prev, value)=>value.getMonth() !== prev.getMonth(),
        format: new Intl.DateTimeFormat('default', {
            month: 'short'
        }).format
    },
    biweekly: {
        getTickNumber: (from, to)=>$5ca5ef1aad97e8b5$var$dayNumber(from, to) / 14,
        isTick: (prev, value)=>(value.getDay() < prev.getDay() || $5ca5ef1aad97e8b5$var$dayNumber(value, prev) > 7) && Math.floor(value.getDate() / 7) % 2 === 1,
        format: new Intl.DateTimeFormat('default', {
            day: 'numeric'
        }).format
    },
    weeks: {
        getTickNumber: (from, to)=>$5ca5ef1aad97e8b5$var$dayNumber(from, to) / 7,
        isTick: (prev, value)=>value.getDay() < prev.getDay() || $5ca5ef1aad97e8b5$var$dayNumber(value, prev) >= 7,
        format: new Intl.DateTimeFormat('default', {
            day: 'numeric'
        }).format
    },
    days: {
        getTickNumber: $5ca5ef1aad97e8b5$var$dayNumber,
        isTick: (prev, value)=>value.getDate() !== prev.getDate(),
        format: new Intl.DateTimeFormat('default', {
            day: 'numeric'
        }).format
    },
    hours: {
        getTickNumber: $5ca5ef1aad97e8b5$var$hourNumber,
        isTick: (prev, value)=>value.getHours() !== prev.getHours(),
        format: new Intl.DateTimeFormat('default', {
            hour: '2-digit',
            minute: '2-digit'
        }).format
    }
};

});


parcelRegister("l5xri", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f5a400f77090cd24$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5a400f77090cd24$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMounted = $f5a400f77090cd24$var$useMounted;

var $f5a400f77090cd24$var$React = $f5a400f77090cd24$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f5a400f77090cd24$var$_useEnhancedEffect = $f5a400f77090cd24$require$_interopRequireDefault((parcelRequire("jdWO4")));
function $f5a400f77090cd24$var$useMounted(defer = false) {
    const [mountedState, setMountedState] = $f5a400f77090cd24$var$React.useState(false);
    (0, $f5a400f77090cd24$var$_useEnhancedEffect.default)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $f5a400f77090cd24$var$React.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    return mountedState;
}

});

parcelRegister("6P3Ti", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shortenLabels = $4f7a862088c6b42e$var$shortenLabels;

var $bCsNZ = parcelRequire("bCsNZ");

var $04SGx = parcelRequire("04SGx");

var $7dlGc = parcelRequire("7dlGc");
function $4f7a862088c6b42e$var$shortenLabels(visibleLabels, drawingArea, maxHeight, isRtl, tickLabelStyle) {
    const shortenedLabels = new Map();
    const angle = (0, $bCsNZ.clampAngle)(tickLabelStyle?.angle ?? 0);
    // Multiplying the space available to the left of the text position by leftBoundFactor returns the max width of the text.
    // Same for rightBoundFactor
    let leftBoundFactor = 1;
    let rightBoundFactor = 1;
    if (tickLabelStyle?.textAnchor === 'start') {
        leftBoundFactor = Infinity;
        rightBoundFactor = 1;
    } else if (tickLabelStyle?.textAnchor === 'end') {
        leftBoundFactor = 1;
        rightBoundFactor = Infinity;
    } else {
        leftBoundFactor = 2;
        rightBoundFactor = 2;
    }
    if (angle > 90 && angle < 270) [leftBoundFactor, rightBoundFactor] = [
        rightBoundFactor,
        leftBoundFactor
    ];
    if (isRtl) [leftBoundFactor, rightBoundFactor] = [
        rightBoundFactor,
        leftBoundFactor
    ];
    for (const item of visibleLabels)if (item.formattedValue) {
        // That maximum width of the tick depends on its proximity to the axis bounds.
        const width = Math.min((item.offset + item.labelOffset) * leftBoundFactor, (drawingArea.left + drawingArea.width + drawingArea.right - item.offset - item.labelOffset) * rightBoundFactor);
        const doesTextFit = (text)=>(0, $04SGx.doesTextFitInRect)(text, {
                width: width,
                height: maxHeight,
                angle: angle,
                measureText: (string)=>(0, $7dlGc.getStringSize)(string, tickLabelStyle)
            });
        shortenedLabels.set(item, (0, $04SGx.ellipsize)(item.formattedValue.toString(), doesTextFit));
    }
    return shortenedLabels;
}

});
parcelRegister("04SGx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesTextFitInRect = $00eacb29a1769f54$var$doesTextFitInRect;
module.exports.ellipsize = $00eacb29a1769f54$var$ellipsize;

var $iLJzM = parcelRequire("iLJzM");

var $1Vg3M = parcelRequire("1Vg3M");

var $66a83 = parcelRequire("66a83");
const $00eacb29a1769f54$var$ELLIPSIS = "\u2026";
function $00eacb29a1769f54$var$doesTextFitInRect(text, config) {
    const { width: width, height: height, measureText: measureText } = config;
    const angle = (0, $1Vg3M.degToRad)(config.angle);
    const textSize = measureText(text);
    const angledWidth = Math.abs(textSize.width * Math.cos(angle)) + Math.abs(textSize.height * Math.sin(angle));
    const angledHeight = Math.abs(textSize.width * Math.sin(angle)) + Math.abs(textSize.height * Math.cos(angle));
    return angledWidth <= width && angledHeight <= height;
}
/** This function finds the best place to clip the text to add an ellipsis.
 *  This function assumes that the {@link doesTextFit} never returns true for longer text after returning false for
 *  shorter text.
 *
 *  @param text Text to ellipsize if needed
 *  @param doesTextFit a function that returns whether a string fits inside a container.
 */ function $00eacb29a1769f54$var$ellipsize(text, doesTextFit) {
    if (doesTextFit(text)) return text;
    let shortenedText = text;
    let step = 1;
    let by = 0.5;
    const graphemeCount = (0, $iLJzM.getGraphemeCount)(text);
    let newLength = graphemeCount;
    let lastLength = graphemeCount;
    let longestFittingText = null;
    do {
        lastLength = newLength;
        newLength = Math.floor(graphemeCount * by);
        if (newLength === 0) break;
        shortenedText = (0, $66a83.sliceUntil)(text, newLength).trim();
        const fits = doesTextFit(shortenedText + $00eacb29a1769f54$var$ELLIPSIS);
        step += 1;
        if (fits) {
            longestFittingText = shortenedText;
            by += 1 / 2 ** step;
        } else by -= 1 / 2 ** step;
    }while (Math.abs(newLength - lastLength) !== 1);
    return longestFittingText ? longestFittingText + $00eacb29a1769f54$var$ELLIPSIS : '';
}

});
parcelRegister("iLJzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getGraphemeCount = void 0;
const $da9ff83b5c50385a$var$segmenter = typeof window !== 'undefined' && 'Intl' in window && 'Segmenter' in Intl ? new Intl.Segmenter(undefined, {
    granularity: 'grapheme'
}) : null;
function $da9ff83b5c50385a$var$getGraphemeCountFallback(text) {
    return text.length;
}
function $da9ff83b5c50385a$var$getGraphemeCountModern(text) {
    const segments = $da9ff83b5c50385a$var$segmenter.segment(text);
    let count = 0;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/naming-convention,no-underscore-dangle
    for (const _unused of segments)count += 1;
    return count;
}
/** Returns the number of graphemes (basically characters) present in {@link text}. */ const $da9ff83b5c50385a$var$getGraphemeCount = module.exports.getGraphemeCount = $da9ff83b5c50385a$var$segmenter ? $da9ff83b5c50385a$var$getGraphemeCountModern : $da9ff83b5c50385a$var$getGraphemeCountFallback;

});

parcelRegister("1Vg3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.degToRad = $1667927de1d08392$var$degToRad;
/** Converts degrees to radians. */ function $1667927de1d08392$var$degToRad(degrees) {
    return degrees * (Math.PI / 180);
}

});

parcelRegister("66a83", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sliceUntil = void 0;
const $470b28fc74ab090b$var$segmenter = typeof window !== 'undefined' && 'Intl' in window && 'Segmenter' in Intl ? new Intl.Segmenter(undefined, {
    granularity: 'grapheme'
}) : null;
function $470b28fc74ab090b$var$sliceUntilFallback(text, endIndex) {
    return text.slice(0, endIndex);
}
function $470b28fc74ab090b$var$sliceUntilModern(text, endIndex) {
    const segments = $470b28fc74ab090b$var$segmenter.segment(text);
    let newText = '';
    let i = 0;
    for (const segment of segments){
        newText += segment.segment;
        i += 1;
        if (i >= endIndex) break;
    }
    return newText;
}
/** Creates a slice of {@link text} from the start until the {@link endIndex}th grapheme (basically character). */ const $470b28fc74ab090b$var$sliceUntil = module.exports.sliceUntil = $470b28fc74ab090b$var$segmenter ? $470b28fc74ab090b$var$sliceUntilModern : $470b28fc74ab090b$var$sliceUntilFallback;

});


parcelRegister("7dlGc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $540a9068df2ba726$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchMeasureStrings = $540a9068df2ba726$var$batchMeasureStrings;
module.exports.clearStringMeasurementCache = $540a9068df2ba726$var$clearStringMeasurementCache;
module.exports.getStringSize = void 0;
module.exports.getStyleString = $540a9068df2ba726$var$getStyleString;

var $540a9068df2ba726$var$_extends2 = $540a9068df2ba726$require$_interopRequireDefault((parcelRequire("3p9rK")));
// DOM utils adapted from
// https://github.com/recharts/recharts/blob/master/src/util/DOMUtils.ts
function $540a9068df2ba726$var$isSsr() {
    return typeof window === 'undefined';
}
const $540a9068df2ba726$var$stringCache = new Map();
function $540a9068df2ba726$var$clearStringMeasurementCache() {
    $540a9068df2ba726$var$stringCache.clear();
}
const $540a9068df2ba726$var$MAX_CACHE_NUM = 2000;
const $540a9068df2ba726$var$PIXEL_STYLES = new Set([
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
]);
/**
 * Convert number value to pixel value for certain CSS properties
 * @param name CSS property name
 * @param value
 * @returns add 'px' for distance properties
 */ function $540a9068df2ba726$var$convertPixelValue(name, value) {
    if ($540a9068df2ba726$var$PIXEL_STYLES.has(name) && value === +value) return `${value}px`;
    return value;
}
/**
 * Converts camelcase to dash-case
 * @param text camelcase css property
 */ const $540a9068df2ba726$var$AZ = /([A-Z])/g;
function $540a9068df2ba726$var$camelCaseToDashCase(text) {
    return String(text).replace($540a9068df2ba726$var$AZ, (match)=>`-${match.toLowerCase()}`);
}
/**
 * Converts a style object into a string to be used as a cache key
 * @param style React style object
 * @returns CSS styling string
 */ function $540a9068df2ba726$var$getStyleString(style) {
    let result = '';
    for(const key in style)if (Object.hasOwn(style, key)) {
        const k = key;
        const value = style[k];
        if (value === undefined) continue;
        result += `${$540a9068df2ba726$var$camelCaseToDashCase(k)}:${$540a9068df2ba726$var$convertPixelValue(k, value)};`;
    }
    return result;
}
/**
 *
 * @param text The string to estimate
 * @param style The style applied
 * @returns width and height of the text
 */ const $540a9068df2ba726$var$getStringSize = (text, style = {})=>{
    if (text === undefined || text === null || $540a9068df2ba726$var$isSsr()) return {
        width: 0,
        height: 0
    };
    const str = String(text);
    const styleString = $540a9068df2ba726$var$getStyleString(style);
    const cacheKey = `${str}-${styleString}`;
    const size = $540a9068df2ba726$var$stringCache.get(cacheKey);
    if (size) return size;
    try {
        const measurementSpanContainer = $540a9068df2ba726$var$getMeasurementContainer();
        const measurementElem = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        Object.keys(style).map((styleKey)=>{
            measurementElem.style[$540a9068df2ba726$var$camelCaseToDashCase(styleKey)] = $540a9068df2ba726$var$convertPixelValue(styleKey, style[styleKey]);
            return styleKey;
        });
        measurementElem.textContent = str;
        measurementSpanContainer.replaceChildren(measurementElem);
        const result = $540a9068df2ba726$var$measureSVGTextElement(measurementElem);
        $540a9068df2ba726$var$stringCache.set(cacheKey, result);
        if ($540a9068df2ba726$var$stringCache.size + 1 > $540a9068df2ba726$var$MAX_CACHE_NUM) $540a9068df2ba726$var$stringCache.clear();
        return result;
    } catch  {
        return {
            width: 0,
            height: 0
        };
    }
};
module.exports.getStringSize = $540a9068df2ba726$var$getStringSize;
function $540a9068df2ba726$var$batchMeasureStrings(texts, style = {}) {
    if ($540a9068df2ba726$var$isSsr()) return new Map(Array.from(texts).map((text)=>[
            text,
            {
                width: 0,
                height: 0
            }
        ]));
    const sizeMap = new Map();
    const textToMeasure = [];
    const styleString = $540a9068df2ba726$var$getStyleString(style);
    for (const text of texts){
        const cacheKey = `${text}-${styleString}`;
        const size = $540a9068df2ba726$var$stringCache.get(cacheKey);
        if (size) sizeMap.set(text, size);
        else textToMeasure.push(text);
    }
    const measurementContainer = $540a9068df2ba726$var$getMeasurementContainer();
    // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
    // https://en.wikipedia.org/wiki/Content_Security_Policy
    const measurementSpanStyle = (0, $540a9068df2ba726$var$_extends2.default)({}, style);
    Object.keys(measurementSpanStyle).map((styleKey)=>{
        measurementContainer.style[$540a9068df2ba726$var$camelCaseToDashCase(styleKey)] = $540a9068df2ba726$var$convertPixelValue(styleKey, measurementSpanStyle[styleKey]);
        return styleKey;
    });
    const measurementElements = [];
    for (const string of textToMeasure){
        const measurementElem = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        measurementElem.textContent = `${string}`;
        measurementElements.push(measurementElem);
    }
    measurementContainer.replaceChildren(...measurementElements);
    for(let i = 0; i < textToMeasure.length; i += 1){
        const text = textToMeasure[i];
        const measurementElem = measurementContainer.children[i];
        const result = $540a9068df2ba726$var$measureSVGTextElement(measurementElem);
        const cacheKey = `${text}-${styleString}`;
        $540a9068df2ba726$var$stringCache.set(cacheKey, result);
        sizeMap.set(text, result);
    }
    if ($540a9068df2ba726$var$stringCache.size + 1 > $540a9068df2ba726$var$MAX_CACHE_NUM) $540a9068df2ba726$var$stringCache.clear();
    return sizeMap;
}
/**
 * Measures an SVG text element using getBBox() with fallback to getBoundingClientRect()
 * @param element SVG text element to measure
 * @returns width and height of the text element
 */ function $540a9068df2ba726$var$measureSVGTextElement(element) {
    // getBBox() is more reliable across browsers for SVG elements
    try {
        const result = element.getBBox();
        return {
            width: result.width,
            height: result.height
        };
    } catch  {
        // Fallback to getBoundingClientRect if getBBox fails
        // This can happen in tests
        const result = element.getBoundingClientRect();
        return {
            width: result.width,
            height: result.height
        };
    }
}
let $540a9068df2ba726$var$measurementContainer = null;
/**
 * Get (or create) a hidden span element to measure text size.
 */ function $540a9068df2ba726$var$getMeasurementContainer() {
    if ($540a9068df2ba726$var$measurementContainer === null) {
        $540a9068df2ba726$var$measurementContainer = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        $540a9068df2ba726$var$measurementContainer.setAttribute('aria-hidden', 'true');
        $540a9068df2ba726$var$measurementContainer.style.position = 'absolute';
        $540a9068df2ba726$var$measurementContainer.style.top = '-20000px';
        $540a9068df2ba726$var$measurementContainer.style.left = '0';
        $540a9068df2ba726$var$measurementContainer.style.padding = '0';
        $540a9068df2ba726$var$measurementContainer.style.margin = '0';
        $540a9068df2ba726$var$measurementContainer.style.border = 'none';
        $540a9068df2ba726$var$measurementContainer.style.pointerEvents = 'none';
        $540a9068df2ba726$var$measurementContainer.style.visibility = 'hidden';
        $540a9068df2ba726$var$measurementContainer.style.contain = 'strict';
        document.body.appendChild($540a9068df2ba726$var$measurementContainer);
    }
    return $540a9068df2ba726$var$measurementContainer;
}

});


parcelRegister("ipb4Q", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getVisibleLabels = $03753650715c75c3$var$getVisibleLabels;

var $fSkNS = parcelRequire("fSkNS");

var $7dlGc = parcelRequire("7dlGc");
/* Returns a set of indices of the tick labels that should be visible.  */ function $03753650715c75c3$var$getVisibleLabels(xTicks, { tickLabelStyle: style, tickLabelInterval: tickLabelInterval, tickLabelMinGap: tickLabelMinGap, reverse: reverse, isMounted: isMounted, isXInside: isXInside }) {
    if (typeof tickLabelInterval === 'function') return new Set(xTicks.filter((item, index)=>tickLabelInterval(item.value, index)));
    // Filter label to avoid overlap
    let previousTextLimit = 0;
    const direction = reverse ? -1 : 1;
    const candidateTickLabels = xTicks.filter((item)=>{
        const { offset: offset, labelOffset: labelOffset, formattedValue: formattedValue } = item;
        if (formattedValue === '') return false;
        const textPosition = offset + labelOffset;
        return isXInside(textPosition);
    });
    const sizeMap = $03753650715c75c3$var$measureTickLabels(candidateTickLabels, style);
    return new Set(candidateTickLabels.filter((item, labelIndex)=>{
        const { offset: offset, labelOffset: labelOffset } = item;
        const textPosition = offset + labelOffset;
        if (labelIndex > 0 && direction * textPosition < direction * (previousTextLimit + tickLabelMinGap)) return false;
        const { width: width, height: height } = isMounted ? $03753650715c75c3$var$getTickLabelSize(sizeMap, item) : {
            width: 0,
            height: 0
        };
        const distance = (0, $fSkNS.getMinXTranslation)(width, height, style?.angle);
        const currentTextLimit = textPosition - direction * distance / 2;
        if (labelIndex > 0 && direction * currentTextLimit < direction * (previousTextLimit + tickLabelMinGap)) // Except for the first label, we skip all label that overlap with the last accepted.
        // Notice that the early return prevents `previousTextLimit` from being updated.
        return false;
        previousTextLimit = textPosition + direction * distance / 2;
        return true;
    }));
}
function $03753650715c75c3$var$getTickLabelSize(sizeMap, tick) {
    if (tick.formattedValue === undefined) return {
        width: 0,
        height: 0
    };
    let width = 0;
    let height = 0;
    for (const line of tick.formattedValue.split('\n')){
        const lineSize = sizeMap.get(line);
        if (lineSize) {
            width = Math.max(width, lineSize.width);
            height += lineSize.height;
        }
    }
    return {
        width: width,
        height: height
    };
}
function $03753650715c75c3$var$measureTickLabels(ticks, style) {
    const strings = new Set();
    for (const tick of ticks)if (tick.formattedValue) tick.formattedValue.split('\n').forEach((line)=>strings.add(line));
    return (0, $7dlGc.batchMeasureStrings)(strings, style);
}

});
parcelRegister("fSkNS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMinXTranslation = $b8ec094984ffb8e0$var$getMinXTranslation;


var $1hcZZ = parcelRequire("1hcZZ");
const $b8ec094984ffb8e0$var$ANGLE_APPROX = 5; // Angle (in deg) for which we approximate the rectangle as perfectly horizontal/vertical
/**
 * Return the minimal translation along the x-axis to avoid overflow of a rectangle of a given width, height, and rotation.
 * This assumes that all rectangles have the same height and angle between -90 and 90.
 * Otherwise it would be problematic because you need the height/width of the next rectangle to do the correct computation.
 * @param width the side along the x-axis.
 * @param height the side along the y-axis.
 * @param angle the rotation in degrees.
 */ function $b8ec094984ffb8e0$var$getMinXTranslation(width, height, angle = 0) {
    const standardAngle = Math.min(Math.abs(angle) % 180, Math.abs(Math.abs(angle) % 180 - 180) % 180); // Map from R to [0, 90]
    if (standardAngle < $b8ec094984ffb8e0$var$ANGLE_APPROX) // It's nearly horizontal
    return width;
    if (standardAngle > 90 - $b8ec094984ffb8e0$var$ANGLE_APPROX) // It's nearly vertical
    return height;
    const radAngle = (0, $1hcZZ.deg2rad)(standardAngle);
    const angleSwich = Math.atan2(height, width);
    if (radAngle < angleSwich) return width / Math.cos(radAngle);
    return height / Math.sin(radAngle);
}

});


parcelRegister("gshSM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bfad21f17f0497f0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useUtilityClasses = module.exports.defaultProps = module.exports.TICK_LABEL_GAP = module.exports.AXIS_LABEL_TICK_LABEL_GAP = void 0;

var $bfad21f17f0497f0$var$_composeClasses = $bfad21f17f0497f0$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aMZmt = parcelRequire("aMZmt");
const $bfad21f17f0497f0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position, id: id } = ownerState;
    const slots = {
        root: [
            'root',
            'directionX',
            position,
            `id-${id}`
        ],
        line: [
            'line'
        ],
        tickContainer: [
            'tickContainer'
        ],
        tick: [
            'tick'
        ],
        tickLabel: [
            'tickLabel'
        ],
        label: [
            'label'
        ]
    };
    return (0, $bfad21f17f0497f0$var$_composeClasses.default)(slots, $aMZmt.getAxisUtilityClass, classes);
};
/* Gap between a tick and its label. */ module.exports.useUtilityClasses = $bfad21f17f0497f0$var$useUtilityClasses;
const $bfad21f17f0497f0$var$TICK_LABEL_GAP = module.exports.TICK_LABEL_GAP = 3;
/* Gap between the axis label and tick labels. */ const $bfad21f17f0497f0$var$AXIS_LABEL_TICK_LABEL_GAP = module.exports.AXIS_LABEL_TICK_LABEL_GAP = 4;
const $bfad21f17f0497f0$var$defaultProps = module.exports.defaultProps = {
    disableLine: false,
    disableTicks: false,
    tickSize: 6,
    tickLabelMinGap: 4
};

});
parcelRegister("aMZmt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7dadfc316312570d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.axisClasses = void 0;
module.exports.getAxisUtilityClass = $7dadfc316312570d$var$getAxisUtilityClass;

var $7dadfc316312570d$var$_generateUtilityClass = $7dadfc316312570d$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $7dadfc316312570d$var$_generateUtilityClasses = $7dadfc316312570d$require$_interopRequireDefault((parcelRequire("5nY49")));
function $7dadfc316312570d$var$getAxisUtilityClass(slot) {
    return (0, $7dadfc316312570d$var$_generateUtilityClass.default)('MuiChartsAxis', slot);
}
const $7dadfc316312570d$var$axisClasses = module.exports.axisClasses = (0, $7dadfc316312570d$var$_generateUtilityClasses.default)('MuiChartsAxis', [
    'root',
    'line',
    'tickContainer',
    'tick',
    'tickLabel',
    'label',
    'directionX',
    'directionY',
    'top',
    'bottom',
    'left',
    'right',
    'id'
]);

});


parcelRegister("7TiTk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5bec52e31599cfee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAxisTicksProps = $5bec52e31599cfee$var$useAxisTicksProps;

var $5bec52e31599cfee$var$_extends2 = $5bec52e31599cfee$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5bec52e31599cfee$var$_objectWithoutPropertiesLoose2 = $5bec52e31599cfee$require$_interopRequireDefault((parcelRequire("c05no")));

var $5bec52e31599cfee$var$_useSlotProps = $5bec52e31599cfee$require$_interopRequireDefault((parcelRequire("839K0")));

var $8xDHs = parcelRequire("8xDHs");

var $9uEev = parcelRequire("9uEev");

var $41V8S = parcelRequire("41V8S");

var $55Xcx = parcelRequire("55Xcx");

var $1UYzZ = parcelRequire("1UYzZ");

var $d6dcG = parcelRequire("d6dcG");

var $gshSM = parcelRequire("gshSM");
const $5bec52e31599cfee$var$_excluded = [
    "scale",
    "tickNumber",
    "reverse"
];
function $5bec52e31599cfee$var$useAxisTicksProps(inProps) {
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55Xcx.useXAxes)();
    const _xAxis = xAxis[inProps.axisId ?? xAxisIds[0]], { scale: xScale, tickNumber: tickNumber, reverse: reverse } = _xAxis, settings = (0, $5bec52e31599cfee$var$_objectWithoutPropertiesLoose2.default)(_xAxis, $5bec52e31599cfee$var$_excluded);
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    const themedProps = (0, $8xDHs.useThemeProps)({
        props: (0, $5bec52e31599cfee$var$_extends2.default)({}, settings, inProps),
        name: 'MuiChartsXAxis'
    });
    const defaultizedProps = (0, $5bec52e31599cfee$var$_extends2.default)({}, $gshSM.defaultProps, themedProps);
    const { position: position, tickLabelStyle: tickLabelStyle, slots: slots, slotProps: slotProps } = defaultizedProps;
    const theme = (0, $8xDHs.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const classes = (0, $gshSM.useUtilityClasses)(defaultizedProps);
    const positionSign = position === 'bottom' ? 1 : -1;
    const Tick = slots?.axisTick ?? 'line';
    const TickLabel = slots?.axisTickLabel ?? $41V8S.ChartsText;
    const defaultTextAnchor = (0, $1UYzZ.getDefaultTextAnchor)((position === 'bottom' ? 0 : 180) - (tickLabelStyle?.angle ?? 0));
    const defaultDominantBaseline = (0, $1UYzZ.getDefaultBaseline)((position === 'bottom' ? 0 : 180) - (tickLabelStyle?.angle ?? 0));
    const axisTickLabelProps = (0, $5bec52e31599cfee$var$_useSlotProps.default)({
        elementType: TickLabel,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        externalSlotProps: slotProps?.axisTickLabel,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        additionalProps: {
            style: (0, $5bec52e31599cfee$var$_extends2.default)({}, theme.typography.caption, {
                fontSize: 12,
                lineHeight: 1.25,
                textAnchor: isRtl ? (0, $d6dcG.invertTextAnchor)(defaultTextAnchor) : defaultTextAnchor,
                dominantBaseline: defaultDominantBaseline
            }, tickLabelStyle)
        },
        className: classes.tickLabel,
        ownerState: {}
    });
    return {
        xScale: xScale,
        defaultizedProps: defaultizedProps,
        tickNumber: tickNumber,
        positionSign: positionSign,
        classes: classes,
        Tick: Tick,
        TickLabel: TickLabel,
        axisTickLabelProps: axisTickLabelProps,
        reverse: reverse
    };
}

});
parcelRegister("41V8S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ChartsText", {
    enumerable: true,
    get: function() {
        return $40xWj.ChartsText;
    }
});

var $40xWj = parcelRequire("40xWj");

});
parcelRegister("40xWj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2eb17d34c53e515e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2eb17d34c53e515e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsText = $2eb17d34c53e515e$var$ChartsText;

var $2eb17d34c53e515e$var$_extends2 = $2eb17d34c53e515e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2eb17d34c53e515e$var$_objectWithoutPropertiesLoose2 = $2eb17d34c53e515e$require$_interopRequireDefault((parcelRequire("c05no")));

var $2eb17d34c53e515e$var$React = $2eb17d34c53e515e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2eb17d34c53e515e$var$_propTypes = $2eb17d34c53e515e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8Wq99 = parcelRequire("8Wq99");

var $fMRnF = parcelRequire("fMRnF");

var $ayMG0 = parcelRequire("ayMG0");
const $2eb17d34c53e515e$var$_excluded = [
    "x",
    "y",
    "style",
    "text",
    "ownerState"
], $2eb17d34c53e515e$var$_excluded2 = [
    "angle",
    "textAnchor",
    "dominantBaseline"
];
/**
 * Helper component to manage multiline text in SVG
 */ function $2eb17d34c53e515e$var$ChartsText(props) {
    const { x: x, y: y, style: styleProps, text: text } = props, textProps = (0, $2eb17d34c53e515e$var$_objectWithoutPropertiesLoose2.default)(props, $2eb17d34c53e515e$var$_excluded);
    const _ref = styleProps ?? {}, { angle: angle, textAnchor: textAnchor, dominantBaseline: dominantBaseline } = _ref, style = (0, $2eb17d34c53e515e$var$_objectWithoutPropertiesLoose2.default)(_ref, $2eb17d34c53e515e$var$_excluded2);
    const isHydrated = (0, $fMRnF.useIsHydrated)();
    const wordsByLines = $2eb17d34c53e515e$var$React.useMemo(()=>(0, $8Wq99.getWordsByLines)({
            style: style,
            needsComputation: isHydrated && text.includes('\n'),
            text: text
        }), [
        style,
        text,
        isHydrated
    ]);
    let startDy;
    switch(dominantBaseline){
        case 'hanging':
        case 'text-before-edge':
            startDy = 0;
            break;
        case 'central':
            startDy = (wordsByLines.length - 1) / 2 * -wordsByLines[0].height;
            break;
        default:
            startDy = (wordsByLines.length - 1) * -wordsByLines[0].height;
            break;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("text", (0, $2eb17d34c53e515e$var$_extends2.default)({}, textProps, {
        transform: angle ? `rotate(${angle}, ${x}, ${y})` : undefined,
        x: x,
        y: y,
        textAnchor: textAnchor,
        dominantBaseline: dominantBaseline,
        style: style,
        children: wordsByLines.map((line, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("tspan", {
                x: x,
                dy: `${index === 0 ? startDy : wordsByLines[0].height}px`,
                dominantBaseline: dominantBaseline // Propagated to fix Safari issue: https://github.com/mui/mui-x/issues/10808
                ,
                children: line.text
            }, index))
    }));
}

});
parcelRegister("8Wq99", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $682805a98ad54370$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWordsByLines = $682805a98ad54370$var$getWordsByLines;

var $682805a98ad54370$var$_extends2 = $682805a98ad54370$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7dlGc = parcelRequire("7dlGc");
function $682805a98ad54370$var$getWordsByLines({ style: style, needsComputation: needsComputation, text: text }) {
    return text.split('\n').map((subText)=>(0, $682805a98ad54370$var$_extends2.default)({
            text: subText
        }, needsComputation ? (0, $7dlGc.getStringSize)(subText, style) : {
            width: 0,
            height: 0
        }));
}

});



parcelRegister("1UYzZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultBaseline = $165a033cddd65af1$var$getDefaultBaseline;
module.exports.getDefaultTextAnchor = $165a033cddd65af1$var$getDefaultTextAnchor;

var $bCsNZ = parcelRequire("bCsNZ");
/**
 * Provide the text-anchor based on the angle between the text and the associated element.
 * - 0 means the element is on top of the text, 180 bellow, and 90 on the right of the text.
 * @param {number} angle The angle between the text and the element.
 * @returns
 */ function $165a033cddd65af1$var$getDefaultTextAnchor(angle) {
    const adjustedAngle = (0, $bCsNZ.clampAngle)(angle);
    if (adjustedAngle <= 30 || adjustedAngle >= 330) // +/-30° around 0°
    return 'middle';
    if (adjustedAngle <= 210 && adjustedAngle >= 150) // +/-30° around 180°
    return 'middle';
    if (adjustedAngle <= 180) return 'end';
    return 'start';
}
function $165a033cddd65af1$var$getDefaultBaseline(angle) {
    const adjustedAngle = (0, $bCsNZ.clampAngle)(angle);
    if (adjustedAngle <= 30 || adjustedAngle >= 330) // +/-60° around 0°
    return 'hanging';
    if (adjustedAngle <= 210 && adjustedAngle >= 150) // +/-60° around 180°
    return 'auto';
    return 'central';
}

});

parcelRegister("d6dcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invertTextAnchor = $989613de4263e5ca$var$invertTextAnchor;
function $989613de4263e5ca$var$invertTextAnchor(textAnchor) {
    switch(textAnchor){
        case 'start':
            return 'end';
        case 'end':
            return 'start';
        default:
            return textAnchor;
    }
}

});



parcelRegister("h3ypm", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $c6ad682ddecfd9d9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c6ad682ddecfd9d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsGroupedXAxisTicks = $c6ad682ddecfd9d9$var$ChartsGroupedXAxisTicks;

var $c6ad682ddecfd9d9$var$_extends2 = $c6ad682ddecfd9d9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c6ad682ddecfd9d9$var$React = $c6ad682ddecfd9d9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2UPWB = parcelRequire("2UPWB");

var $1HhaP = parcelRequire("1HhaP");

var $gshSM = parcelRequire("gshSM");

var $5RzFz = parcelRequire("5RzFz");

var $7TiTk = parcelRequire("7TiTk");

var $ayMG0 = parcelRequire("ayMG0");
const $c6ad682ddecfd9d9$var$DEFAULT_GROUPING_CONFIG = {
    tickSize: 6
};
const $c6ad682ddecfd9d9$var$getGroupingConfig = (groups, groupIndex, tickSize)=>{
    const config = groups[groupIndex] ?? {};
    const defaultTickSize = tickSize ?? $c6ad682ddecfd9d9$var$DEFAULT_GROUPING_CONFIG.tickSize;
    const calculatedTickSize = defaultTickSize * groupIndex * 2 + defaultTickSize;
    return (0, $c6ad682ddecfd9d9$var$_extends2.default)({}, $c6ad682ddecfd9d9$var$DEFAULT_GROUPING_CONFIG, config, {
        tickSize: config.tickSize ?? calculatedTickSize
    });
};
/**
 * @ignore - internal component.
 */ function $c6ad682ddecfd9d9$var$ChartsGroupedXAxisTicks(inProps) {
    const { xScale: xScale, defaultizedProps: defaultizedProps, tickNumber: tickNumber, positionSign: positionSign, classes: classes, Tick: Tick, TickLabel: TickLabel, axisTickLabelProps: axisTickLabelProps } = (0, $7TiTk.useAxisTicksProps)(inProps);
    if (!(0, $2UPWB.isOrdinalScale)(xScale)) throw new Error('MUI X Charts: ChartsGroupedXAxis only supports the `band` and `point` scale types.');
    const { disableTicks: disableTicks, tickSize: tickSize, valueFormatter: valueFormatter, slotProps: slotProps, tickInterval: tickInterval, tickPlacement: tickPlacement, tickLabelPlacement: tickLabelPlacement } = defaultizedProps;
    const groups = defaultizedProps.groups;
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const xTicks = (0, $5RzFz.useTicksGrouped)({
        scale: xScale,
        tickNumber: tickNumber,
        valueFormatter: valueFormatter,
        tickInterval: tickInterval,
        tickPlacement: tickPlacement,
        tickLabelPlacement: tickLabelPlacement,
        direction: 'x',
        groups: groups
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c6ad682ddecfd9d9$var$React.Fragment, {
        children: xTicks.map((item, index)=>{
            const { offset: tickOffset, labelOffset: labelOffset } = item;
            const xTickLabel = labelOffset ?? 0;
            const showTick = instance.isXInside(tickOffset);
            const tickLabel = item.formattedValue;
            const ignoreTick = item.ignoreTick ?? false;
            const groupIndex = item.groupIndex ?? 0;
            const groupConfig = $c6ad682ddecfd9d9$var$getGroupingConfig(groups, groupIndex, tickSize);
            const tickYSize = positionSign * groupConfig.tickSize;
            const labelPositionY = positionSign * (groupConfig.tickSize + $gshSM.TICK_LABEL_GAP);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                transform: `translate(${tickOffset}, 0)`,
                className: classes.tickContainer,
                "data-group-index": groupIndex,
                children: [
                    !disableTicks && !ignoreTick && showTick && /*#__PURE__*/ (0, $ayMG0.jsx)(Tick, (0, $c6ad682ddecfd9d9$var$_extends2.default)({
                        y2: tickYSize,
                        className: classes.tick
                    }, slotProps?.axisTick)),
                    tickLabel !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)(TickLabel, (0, $c6ad682ddecfd9d9$var$_extends2.default)({
                        x: xTickLabel,
                        y: labelPositionY
                    }, axisTickLabelProps, {
                        style: (0, $c6ad682ddecfd9d9$var$_extends2.default)({}, axisTickLabelProps.style, groupConfig.tickLabelStyle),
                        text: tickLabel
                    }))
                ]
            }, index);
        })
    });
}

});
parcelRegister("5RzFz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $444d922f24a00c48$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useTicksGrouped = $444d922f24a00c48$var$useTicksGrouped;

var $444d922f24a00c48$var$React = $444d922f24a00c48$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2UPWB = parcelRequire("2UPWB");
const $444d922f24a00c48$var$offsetRatio = {
    start: 0,
    extremities: 0,
    end: 1,
    middle: 0.5,
    tick: 0
};
function $444d922f24a00c48$var$useTicksGrouped(options) {
    const { scale: scale, tickInterval: tickInterval, tickLabelPlacement: tickLabelPlacement = 'middle', tickPlacement: tickPlacement = 'extremities', groups: groups } = options;
    return $444d922f24a00c48$var$React.useMemo(()=>{
        const domain = scale.domain();
        const filteredDomain = typeof tickInterval === 'function' && domain.filter(tickInterval) || typeof tickInterval === 'object' && tickInterval || domain;
        if (scale.bandwidth() > 0) {
            // scale type = 'band'
            const entries = $444d922f24a00c48$var$mapToGrouping(filteredDomain, groups, tickPlacement, tickLabelPlacement, scale);
            if (entries[0]) entries[0].ignoreTick = true;
            return [
                {
                    formattedValue: undefined,
                    offset: scale.range()[0],
                    labelOffset: 0,
                    groupIndex: groups.length - 1
                },
                ...entries,
                // Last tick
                {
                    formattedValue: undefined,
                    offset: scale.range()[1],
                    labelOffset: 0,
                    groupIndex: groups.length - 1
                }
            ];
        }
        // scale type = 'point'
        return $444d922f24a00c48$var$mapToGrouping(filteredDomain, groups, tickPlacement, tickLabelPlacement, scale);
    }, [
        scale,
        tickInterval,
        groups,
        tickPlacement,
        tickLabelPlacement
    ]);
}
function $444d922f24a00c48$var$mapToGrouping(tickValues, groups, tickPlacement, tickLabelPlacement, scale) {
    const allTickItems = [];
    // Map to keep track of offsets and their corresponding tick indexes
    // Used to remove redundant ticks when they are in the same position
    const dataIndexToTickIndex = new Map();
    let currentValueCount = 0;
    for(let groupIndex = 0; groupIndex < groups.length; groupIndex += 1)for(let dataIndex = 0; dataIndex < tickValues.length; dataIndex += 1){
        const tickValue = tickValues[dataIndex];
        const groupValue = groups[groupIndex].getValue(tickValue, dataIndex);
        const lastItem = allTickItems[allTickItems.length - 1];
        // Check if this is a new unique value for this group
        const isNew = lastItem?.value !== groupValue || lastItem?.groupIndex !== groupIndex;
        if (isNew) {
            currentValueCount = 1;
            // Calculate tick offset
            const tickOffset = (0, $2UPWB.isOrdinalScale)(scale) ? scale(tickValue) - (scale.step() - scale.bandwidth()) / 2 + $444d922f24a00c48$var$offsetRatio[tickPlacement] * scale.step() : scale(tickValue);
            // Calculate the label offset
            const labelOffset = scale.step() * currentValueCount * ($444d922f24a00c48$var$offsetRatio[tickLabelPlacement] - $444d922f24a00c48$var$offsetRatio[tickPlacement]);
            // Add a new item
            allTickItems.push({
                value: groupValue,
                formattedValue: `${groupValue}`,
                offset: tickOffset,
                groupIndex: groupIndex,
                dataIndex: dataIndex,
                ignoreTick: false,
                labelOffset: labelOffset
            });
            if (!dataIndexToTickIndex.has(dataIndex)) dataIndexToTickIndex.set(dataIndex, new Set());
            const tickIndexes = dataIndexToTickIndex.get(dataIndex);
            for (const previousIndex of tickIndexes.values())allTickItems[previousIndex].ignoreTick = true;
            tickIndexes.add(allTickItems.length - 1);
        } else {
            currentValueCount += 1;
            // Calculate the label offset
            const labelOffset = scale.step() * currentValueCount * ($444d922f24a00c48$var$offsetRatio[tickLabelPlacement] - $444d922f24a00c48$var$offsetRatio[tickPlacement]);
            lastItem.labelOffset = labelOffset;
        }
    }
    return allTickItems;
}

});


parcelRegister("zmHmw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $06a4e06d37a133be$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AxisRoot = void 0;

var $06a4e06d37a133be$var$_extends2 = $06a4e06d37a133be$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8xDHs = parcelRequire("8xDHs");

var $aMZmt = parcelRequire("aMZmt");
const $06a4e06d37a133be$var$AxisRoot = module.exports.AxisRoot = (0, $8xDHs.styled)('g', {
    name: 'MuiChartsAxis',
    slot: 'Root'
})(({ theme: theme })=>({
        [`& .${$aMZmt.axisClasses.tickLabel}`]: (0, $06a4e06d37a133be$var$_extends2.default)({}, theme.typography.caption, {
            fill: (theme.vars || theme).palette.text.primary
        }),
        [`& .${$aMZmt.axisClasses.label}`]: {
            fill: (theme.vars || theme).palette.text.primary
        },
        [`& .${$aMZmt.axisClasses.line}`]: {
            stroke: (theme.vars || theme).palette.text.primary,
            shapeRendering: 'crispEdges',
            strokeWidth: 1
        },
        [`& .${$aMZmt.axisClasses.tick}`]: {
            stroke: (theme.vars || theme).palette.text.primary,
            shapeRendering: 'crispEdges'
        }
    }));

});




parcelRegister("dxqK3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aoMva = parcelRequire("aoMva");
Object.keys($aoMva).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aoMva[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aoMva[key];
        }
    });
});

});
parcelRegister("aoMva", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7921c4b0aeb57390$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsYAxis = $7921c4b0aeb57390$var$ChartsYAxis;

var $7921c4b0aeb57390$var$_extends2 = $7921c4b0aeb57390$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7921c4b0aeb57390$var$_propTypes = $7921c4b0aeb57390$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9Y8Cp = parcelRequire("9Y8Cp");

var $55quD = parcelRequire("55quD");

var $fSgYu = parcelRequire("fSgYu");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsYAxis API](https://mui.com/x/api/charts/charts-y-axis/)
 */ function $7921c4b0aeb57390$var$ChartsYAxis(inProps) {
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55quD.useYAxes)();
    const axis = yAxis[inProps.axisId ?? yAxisIds[0]];
    if (!axis) {
        (0, $9Y8Cp.warnOnce)(`MUI X Charts: No axis found. The axisId "${inProps.axisId}" is probably invalid.`);
        return null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fSgYu.ChartsYAxisImpl, (0, $7921c4b0aeb57390$var$_extends2.default)({}, inProps, {
        axis: axis
    }));
}

});
parcelRegister("fSgYu", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b8e910fb35455394$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b8e910fb35455394$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsYAxisImpl = $b8e910fb35455394$var$ChartsYAxisImpl;

var $b8e910fb35455394$var$_extends2 = $b8e910fb35455394$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b8e910fb35455394$var$_objectWithoutPropertiesLoose2 = $b8e910fb35455394$require$_interopRequireDefault((parcelRequire("c05no")));

var $b8e910fb35455394$var$React = $b8e910fb35455394$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b8e910fb35455394$var$_useSlotProps = $b8e910fb35455394$require$_interopRequireDefault((parcelRequire("839K0")));

var $8xDHs = parcelRequire("8xDHs");

var $hwZtA = parcelRequire("hwZtA");

var $bWARI = parcelRequire("bWARI");

var $41V8S = parcelRequire("41V8S");

var $938Fb = parcelRequire("938Fb");

var $blYHO = parcelRequire("blYHO");

var $gxvLm = parcelRequire("gxvLm");

var $fMRnF = parcelRequire("fMRnF");

var $2UPWB = parcelRequire("2UPWB");

var $7dlGc = parcelRequire("7dlGc");

var $zmHmw = parcelRequire("zmHmw");

var $ayMG0 = parcelRequire("ayMG0");
const $b8e910fb35455394$var$_excluded = [
    "axis"
], $b8e910fb35455394$var$_excluded2 = [
    "scale",
    "tickNumber",
    "reverse",
    "ordinalTimeTicks"
];
const $b8e910fb35455394$var$YAxisRoot = (0, $8xDHs.styled)($zmHmw.AxisRoot, {
    name: 'MuiChartsYAxis',
    slot: 'Root'
})({});
/**
 * @ignore - internal component. Use `ChartsYAxis` instead.
 */ function $b8e910fb35455394$var$ChartsYAxisImpl(_ref) {
    let { axis: axis } = _ref, inProps = (0, $b8e910fb35455394$var$_objectWithoutPropertiesLoose2.default)(_ref, $b8e910fb35455394$var$_excluded);
    // @ts-expect-error ordinalTimeTicks may not be present on all axis types
    // Should be set to never, but this causes other issues with proptypes generator.
    const { scale: yScale, ordinalTimeTicks: ordinalTimeTicks } = axis, settings = (0, $b8e910fb35455394$var$_objectWithoutPropertiesLoose2.default)(axis, $b8e910fb35455394$var$_excluded2);
    const isHydrated = (0, $fMRnF.useIsHydrated)();
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    const themedProps = (0, $8xDHs.useThemeProps)({
        props: (0, $b8e910fb35455394$var$_extends2.default)({}, settings, inProps),
        name: 'MuiChartsYAxis'
    });
    const defaultizedProps = (0, $b8e910fb35455394$var$_extends2.default)({}, $938Fb.defaultProps, themedProps);
    const { position: position, disableLine: disableLine, label: label, labelStyle: labelStyle, offset: offset, width: axisWidth, sx: sx, slots: slots, slotProps: slotProps } = defaultizedProps;
    const theme = (0, $8xDHs.useTheme)();
    const classes = (0, $938Fb.useUtilityClasses)(defaultizedProps);
    const { left: left, top: top, width: width, height: height } = (0, $gxvLm.useDrawingArea)();
    const positionSign = position === 'right' ? 1 : -1;
    const Line = slots?.axisLine ?? 'line';
    const Label = slots?.axisLabel ?? $41V8S.ChartsText;
    const lineProps = (0, $b8e910fb35455394$var$_useSlotProps.default)({
        elementType: Line,
        externalSlotProps: slotProps?.axisLine,
        additionalProps: {
            strokeLinecap: 'square'
        },
        ownerState: {}
    });
    const axisLabelProps = (0, $b8e910fb35455394$var$_useSlotProps.default)({
        elementType: Label,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        externalSlotProps: slotProps?.axisLabel,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        additionalProps: {
            style: (0, $b8e910fb35455394$var$_extends2.default)({}, theme.typography.body1, {
                lineHeight: 1,
                fontSize: 14,
                angle: positionSign * 90,
                textAnchor: 'middle',
                dominantBaseline: 'text-before-edge'
            }, labelStyle)
        },
        ownerState: {}
    });
    // Skip axis rendering if no data is available
    // - The domain is an empty array for band/point scales.
    // - The domains contains Infinity for continuous scales.
    // - The position is set to 'none'.
    if (position === 'none') return null;
    const labelRefPoint = {
        x: positionSign * axisWidth,
        y: top + height / 2
    };
    const axisLabelHeight = label == null ? 0 : (0, $7dlGc.getStringSize)(label, axisLabelProps.style).height;
    const domain = yScale.domain();
    const isScaleOrdinal = (0, $2UPWB.isOrdinalScale)(yScale);
    const skipTickRendering = isScaleOrdinal ? domain.length === 0 : domain.some($blYHO.isInfinity);
    let children = null;
    if (!skipTickRendering) children = 'groups' in axis && Array.isArray(axis.groups) ? /*#__PURE__*/ (0, $ayMG0.jsx)($bWARI.ChartsGroupedYAxisTicks, (0, $b8e910fb35455394$var$_extends2.default)({}, inProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)($hwZtA.ChartsSingleYAxisTicks, (0, $b8e910fb35455394$var$_extends2.default)({}, inProps, {
        axisLabelHeight: axisLabelHeight,
        ordinalTimeTicks: ordinalTimeTicks
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b8e910fb35455394$var$YAxisRoot, {
        transform: `translate(${position === 'right' ? left + width + offset : left - offset}, 0)`,
        className: classes.root,
        "data-axis-id": defaultizedProps.id,
        sx: sx,
        children: [
            !disableLine && /*#__PURE__*/ (0, $ayMG0.jsx)(Line, (0, $b8e910fb35455394$var$_extends2.default)({
                y1: top,
                y2: top + height,
                className: classes.line
            }, lineProps)),
            children,
            label && isHydrated && /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                className: classes.label,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Label, (0, $b8e910fb35455394$var$_extends2.default)({}, labelRefPoint, axisLabelProps, {
                    text: label
                }))
            })
        ]
    });
}

});
parcelRegister("hwZtA", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $cc351cbc4d8953a0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $cc351cbc4d8953a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsSingleYAxisTicks = $cc351cbc4d8953a0$var$ChartsSingleYAxisTicks;

var $cc351cbc4d8953a0$var$_extends2 = $cc351cbc4d8953a0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $cc351cbc4d8953a0$var$React = $cc351cbc4d8953a0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $fMRnF = parcelRequire("fMRnF");

var $gWDH1 = parcelRequire("gWDH1");

var $gxvLm = parcelRequire("gxvLm");

var $6hQTT = parcelRequire("6hQTT");

var $6s2Oh = parcelRequire("6s2Oh");

var $938Fb = parcelRequire("938Fb");

var $6DR69 = parcelRequire("6DR69");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $cc351cbc4d8953a0$var$ChartsSingleYAxisTicks(inProps) {
    const { axisLabelHeight: axisLabelHeight, ordinalTimeTicks: ordinalTimeTicks } = inProps;
    const { yScale: yScale, defaultizedProps: defaultizedProps, tickNumber: tickNumber, positionSign: positionSign, classes: classes, Tick: Tick, TickLabel: TickLabel, axisTickLabelProps: axisTickLabelProps } = (0, $6DR69.useAxisTicksProps)(inProps);
    const isRtl = (0, $9uEev.useRtl)();
    const { disableTicks: disableTicks, tickSize: tickSizeProp, valueFormatter: valueFormatter, slotProps: slotProps, tickPlacement: tickPlacement, tickLabelPlacement: tickLabelPlacement, tickInterval: tickInterval, tickLabelInterval: tickLabelInterval, tickSpacing: tickSpacing, width: axisWidth } = defaultizedProps;
    const drawingArea = (0, $gxvLm.useDrawingArea)();
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const isHydrated = (0, $fMRnF.useIsHydrated)();
    const tickSize = disableTicks ? 4 : tickSizeProp;
    const yTicks = (0, $gWDH1.useTicks)({
        scale: yScale,
        tickNumber: tickNumber,
        valueFormatter: valueFormatter,
        tickPlacement: tickPlacement,
        tickLabelPlacement: tickLabelPlacement,
        tickInterval: tickInterval,
        tickSpacing: tickSpacing,
        direction: 'y',
        ordinalTimeTicks: ordinalTimeTicks
    });
    /* If there's an axis title, the tick labels have less space to render  */ const tickLabelsMaxWidth = Math.max(0, axisWidth - (axisLabelHeight > 0 ? axisLabelHeight + $938Fb.AXIS_LABEL_TICK_LABEL_GAP : 0) - tickSize - $938Fb.TICK_LABEL_GAP);
    const tickLabels = isHydrated ? (0, $6s2Oh.shortenLabels)(yTicks, drawingArea, tickLabelsMaxWidth, isRtl, axisTickLabelProps.style) : new Map(Array.from(yTicks).map((item)=>[
            item,
            item.formattedValue
        ]));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cc351cbc4d8953a0$var$React.Fragment, {
        children: yTicks.map((item, index)=>{
            const { offset: tickOffset, labelOffset: labelOffset, value: value } = item;
            const xTickLabel = positionSign * (tickSize + $938Fb.TICK_LABEL_GAP);
            const yTickLabel = labelOffset;
            const skipLabel = typeof tickLabelInterval === 'function' && !tickLabelInterval?.(value, index);
            const showLabel = instance.isYInside(tickOffset);
            const tickLabel = tickLabels.get(item);
            if (!showLabel) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                transform: `translate(0, ${tickOffset})`,
                className: classes.tickContainer,
                children: [
                    !disableTicks && /*#__PURE__*/ (0, $ayMG0.jsx)(Tick, (0, $cc351cbc4d8953a0$var$_extends2.default)({
                        x2: positionSign * tickSize,
                        className: classes.tick
                    }, slotProps?.axisTick)),
                    tickLabel !== undefined && !skipLabel && /*#__PURE__*/ (0, $ayMG0.jsx)(TickLabel, (0, $cc351cbc4d8953a0$var$_extends2.default)({
                        x: xTickLabel,
                        y: yTickLabel,
                        text: tickLabel
                    }, axisTickLabelProps))
                ]
            }, index);
        })
    });
}

});
parcelRegister("6s2Oh", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shortenLabels = $4b27899fb4909368$var$shortenLabels;

var $bCsNZ = parcelRequire("bCsNZ");

var $04SGx = parcelRequire("04SGx");

var $7dlGc = parcelRequire("7dlGc");
function $4b27899fb4909368$var$shortenLabels(visibleLabels, drawingArea, maxWidth, isRtl, tickLabelStyle) {
    const shortenedLabels = new Map();
    const angle = (0, $bCsNZ.clampAngle)(tickLabelStyle?.angle ?? 0);
    let topBoundFactor = 1;
    let bottomBoundFactor = 1;
    if (tickLabelStyle?.textAnchor === 'start') {
        topBoundFactor = Infinity;
        bottomBoundFactor = 1;
    } else if (tickLabelStyle?.textAnchor === 'end') {
        topBoundFactor = 1;
        bottomBoundFactor = Infinity;
    } else {
        topBoundFactor = 2;
        bottomBoundFactor = 2;
    }
    if (angle > 180) [topBoundFactor, bottomBoundFactor] = [
        bottomBoundFactor,
        topBoundFactor
    ];
    if (isRtl) [topBoundFactor, bottomBoundFactor] = [
        bottomBoundFactor,
        topBoundFactor
    ];
    for (const item of visibleLabels)if (item.formattedValue) {
        // That maximum height of the tick depends on its proximity to the axis bounds.
        const height = Math.min((item.offset + item.labelOffset) * topBoundFactor, (drawingArea.top + drawingArea.height + drawingArea.bottom - item.offset - item.labelOffset) * bottomBoundFactor);
        const doesTextFit = (text)=>(0, $04SGx.doesTextFitInRect)(text, {
                width: maxWidth,
                height: height,
                angle: angle,
                measureText: (string)=>(0, $7dlGc.getStringSize)(string, tickLabelStyle)
            });
        shortenedLabels.set(item, (0, $04SGx.ellipsize)(item.formattedValue.toString(), doesTextFit));
    }
    return shortenedLabels;
}

});

parcelRegister("938Fb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $696b1d32bc52f3db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useUtilityClasses = module.exports.defaultProps = module.exports.TICK_LABEL_GAP = module.exports.AXIS_LABEL_TICK_LABEL_GAP = void 0;

var $696b1d32bc52f3db$var$_composeClasses = $696b1d32bc52f3db$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $aMZmt = parcelRequire("aMZmt");
const $696b1d32bc52f3db$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position, id: id } = ownerState;
    const slots = {
        root: [
            'root',
            'directionY',
            position,
            `id-${id}`
        ],
        line: [
            'line'
        ],
        tickContainer: [
            'tickContainer'
        ],
        tick: [
            'tick'
        ],
        tickLabel: [
            'tickLabel'
        ],
        label: [
            'label'
        ]
    };
    return (0, $696b1d32bc52f3db$var$_composeClasses.default)(slots, $aMZmt.getAxisUtilityClass, classes);
};
/* Gap between a tick and its label. */ module.exports.useUtilityClasses = $696b1d32bc52f3db$var$useUtilityClasses;
const $696b1d32bc52f3db$var$TICK_LABEL_GAP = module.exports.TICK_LABEL_GAP = 2;
/* Gap between the axis label and tick labels. */ const $696b1d32bc52f3db$var$AXIS_LABEL_TICK_LABEL_GAP = module.exports.AXIS_LABEL_TICK_LABEL_GAP = 2;
const $696b1d32bc52f3db$var$defaultProps = module.exports.defaultProps = {
    disableLine: false,
    disableTicks: false,
    tickSize: 6
};

});

parcelRegister("6DR69", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4d5f92c9d7b09941$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAxisTicksProps = $4d5f92c9d7b09941$var$useAxisTicksProps;

var $4d5f92c9d7b09941$var$_extends2 = $4d5f92c9d7b09941$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4d5f92c9d7b09941$var$_objectWithoutPropertiesLoose2 = $4d5f92c9d7b09941$require$_interopRequireDefault((parcelRequire("c05no")));

var $4d5f92c9d7b09941$var$_useSlotProps = $4d5f92c9d7b09941$require$_interopRequireDefault((parcelRequire("839K0")));

var $8xDHs = parcelRequire("8xDHs");

var $9uEev = parcelRequire("9uEev");

var $41V8S = parcelRequire("41V8S");

var $55Xcx = parcelRequire("55Xcx");

var $1UYzZ = parcelRequire("1UYzZ");

var $d6dcG = parcelRequire("d6dcG");

var $938Fb = parcelRequire("938Fb");
const $4d5f92c9d7b09941$var$_excluded = [
    "scale",
    "tickNumber",
    "reverse"
];
function $4d5f92c9d7b09941$var$useAxisTicksProps(inProps) {
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55Xcx.useYAxes)();
    const _yAxis = yAxis[inProps.axisId ?? yAxisIds[0]], { scale: yScale, tickNumber: tickNumber } = _yAxis, settings = (0, $4d5f92c9d7b09941$var$_objectWithoutPropertiesLoose2.default)(_yAxis, $4d5f92c9d7b09941$var$_excluded);
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    const themedProps = (0, $8xDHs.useThemeProps)({
        props: (0, $4d5f92c9d7b09941$var$_extends2.default)({}, settings, inProps),
        name: 'MuiChartsYAxis'
    });
    const defaultizedProps = (0, $4d5f92c9d7b09941$var$_extends2.default)({}, $938Fb.defaultProps, themedProps);
    const { position: position, tickLabelStyle: tickLabelStyle, slots: slots, slotProps: slotProps } = defaultizedProps;
    const theme = (0, $8xDHs.useTheme)();
    const isRtl = (0, $9uEev.useRtl)();
    const classes = (0, $938Fb.useUtilityClasses)(defaultizedProps);
    const positionSign = position === 'right' ? 1 : -1;
    const tickFontSize = typeof tickLabelStyle?.fontSize === 'number' ? tickLabelStyle.fontSize : 12;
    const Tick = slots?.axisTick ?? 'line';
    const TickLabel = slots?.axisTickLabel ?? $41V8S.ChartsText;
    const defaultTextAnchor = (0, $1UYzZ.getDefaultTextAnchor)((position === 'right' ? -90 : 90) - (tickLabelStyle?.angle ?? 0));
    const defaultDominantBaseline = (0, $1UYzZ.getDefaultBaseline)((position === 'right' ? -90 : 90) - (tickLabelStyle?.angle ?? 0));
    const axisTickLabelProps = (0, $4d5f92c9d7b09941$var$_useSlotProps.default)({
        elementType: TickLabel,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        externalSlotProps: slotProps?.axisTickLabel,
        // @ts-expect-error `useSlotProps` applies `WithCommonProps` with adds a `style: React.CSSProperties` prop automatically.
        additionalProps: {
            style: (0, $4d5f92c9d7b09941$var$_extends2.default)({}, theme.typography.caption, {
                fontSize: tickFontSize,
                textAnchor: isRtl ? (0, $d6dcG.invertTextAnchor)(defaultTextAnchor) : defaultTextAnchor,
                dominantBaseline: defaultDominantBaseline
            }, tickLabelStyle)
        },
        className: classes.tickLabel,
        ownerState: {}
    });
    return {
        yScale: yScale,
        defaultizedProps: defaultizedProps,
        tickNumber: tickNumber,
        positionSign: positionSign,
        classes: classes,
        Tick: Tick,
        TickLabel: TickLabel,
        axisTickLabelProps: axisTickLabelProps
    };
}

});


parcelRegister("bWARI", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8b21b5349f9c7a98$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8b21b5349f9c7a98$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsGroupedYAxisTicks = $8b21b5349f9c7a98$var$ChartsGroupedYAxisTicks;

var $8b21b5349f9c7a98$var$_extends2 = $8b21b5349f9c7a98$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8b21b5349f9c7a98$var$React = $8b21b5349f9c7a98$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2UPWB = parcelRequire("2UPWB");

var $1HhaP = parcelRequire("1HhaP");

var $938Fb = parcelRequire("938Fb");

var $5RzFz = parcelRequire("5RzFz");

var $6DR69 = parcelRequire("6DR69");

var $ayMG0 = parcelRequire("ayMG0");
const $8b21b5349f9c7a98$var$DEFAULT_GROUPING_CONFIG = {
    tickSize: 6
};
const $8b21b5349f9c7a98$var$getGroupingConfig = (groups, groupIndex, tickSize)=>{
    const config = groups[groupIndex] ?? {};
    const defaultTickSize = tickSize ?? $8b21b5349f9c7a98$var$DEFAULT_GROUPING_CONFIG.tickSize;
    const calculatedTickSize = defaultTickSize * groupIndex * 2 + defaultTickSize;
    return (0, $8b21b5349f9c7a98$var$_extends2.default)({}, $8b21b5349f9c7a98$var$DEFAULT_GROUPING_CONFIG, config, {
        tickSize: config.tickSize ?? calculatedTickSize
    });
};
/**
 * @ignore - internal component.
 */ function $8b21b5349f9c7a98$var$ChartsGroupedYAxisTicks(inProps) {
    const { yScale: yScale, defaultizedProps: defaultizedProps, tickNumber: tickNumber, positionSign: positionSign, classes: classes, Tick: Tick, TickLabel: TickLabel, axisTickLabelProps: axisTickLabelProps } = (0, $6DR69.useAxisTicksProps)(inProps);
    if (!(0, $2UPWB.isOrdinalScale)(yScale)) throw new Error('MUI X Charts: ChartsGroupedYAxis only supports the `band` and `point` scale types.');
    const { disableTicks: disableTicks, tickSize: tickSize, valueFormatter: valueFormatter, slotProps: slotProps, tickInterval: tickInterval, tickPlacement: tickPlacement, tickLabelPlacement: tickLabelPlacement } = defaultizedProps;
    const groups = defaultizedProps.groups;
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const yTicks = (0, $5RzFz.useTicksGrouped)({
        scale: yScale,
        tickNumber: tickNumber,
        valueFormatter: valueFormatter,
        tickInterval: tickInterval,
        tickPlacement: tickPlacement,
        tickLabelPlacement: tickLabelPlacement,
        direction: 'y',
        groups: groups
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8b21b5349f9c7a98$var$React.Fragment, {
        children: yTicks.map((item, index)=>{
            const { offset: tickOffset, labelOffset: labelOffset } = item;
            const yTickLabel = labelOffset ?? 0;
            const showTick = instance.isYInside(tickOffset);
            const tickLabel = item.formattedValue;
            const ignoreTick = item.ignoreTick ?? false;
            const groupIndex = item.groupIndex ?? 0;
            const groupConfig = $8b21b5349f9c7a98$var$getGroupingConfig(groups, groupIndex, tickSize);
            const tickXSize = positionSign * groupConfig.tickSize;
            const labelPositionX = positionSign * (groupConfig.tickSize + $938Fb.TICK_LABEL_GAP);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                transform: `translate(0, ${tickOffset})`,
                className: classes.tickContainer,
                "data-group-index": groupIndex,
                children: [
                    !disableTicks && !ignoreTick && showTick && /*#__PURE__*/ (0, $ayMG0.jsx)(Tick, (0, $8b21b5349f9c7a98$var$_extends2.default)({
                        x2: tickXSize,
                        className: classes.tick
                    }, slotProps?.axisTick)),
                    tickLabel !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)(TickLabel, (0, $8b21b5349f9c7a98$var$_extends2.default)({
                        x: labelPositionX,
                        y: yTickLabel
                    }, axisTickLabelProps, {
                        style: (0, $8b21b5349f9c7a98$var$_extends2.default)({}, axisTickLabelProps.style, groupConfig.tickLabelStyle),
                        text: tickLabel
                    }))
                ]
            }, index);
        })
    });
}

});





parcelRegister("luY0B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fa6af2d084329347$var$_exportNames = {
    getChartsTooltipUtilityClass: true,
    chartsTooltipClasses: true,
    useItemTooltip: true,
    useRadarItemTooltip: true,
    useMouseTracker: true
};
Object.defineProperty(module.exports, "chartsTooltipClasses", {
    enumerable: true,
    get: function() {
        return $i1NCK.chartsTooltipClasses;
    }
});
Object.defineProperty(module.exports, "getChartsTooltipUtilityClass", {
    enumerable: true,
    get: function() {
        return $i1NCK.getChartsTooltipUtilityClass;
    }
});
Object.defineProperty(module.exports, "useItemTooltip", {
    enumerable: true,
    get: function() {
        return $1JXjN.useItemTooltip;
    }
});
Object.defineProperty(module.exports, "useMouseTracker", {
    enumerable: true,
    get: function() {
        return $jIxx0.useMouseTracker;
    }
});
Object.defineProperty(module.exports, "useRadarItemTooltip", {
    enumerable: true,
    get: function() {
        return $1JXjN.useRadarItemTooltip;
    }
});

var $7TCdI = parcelRequire("7TCdI");
Object.keys($7TCdI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7TCdI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7TCdI[key];
        }
    });
});

var $gZnkU = parcelRequire("gZnkU");
Object.keys($gZnkU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gZnkU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gZnkU[key];
        }
    });
});

var $i1NCK = parcelRequire("i1NCK");

var $3WQ6P = parcelRequire("3WQ6P");
Object.keys($3WQ6P).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3WQ6P[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3WQ6P[key];
        }
    });
});

var $ir7SE = parcelRequire("ir7SE");
Object.keys($ir7SE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ir7SE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ir7SE[key];
        }
    });
});

var $1OcZs = parcelRequire("1OcZs");
Object.keys($1OcZs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1OcZs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1OcZs[key];
        }
    });
});

var $1JXjN = parcelRequire("1JXjN");

var $hkxtM = parcelRequire("hkxtM");
Object.keys($hkxtM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hkxtM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hkxtM[key];
        }
    });
});

var $lJoYM = parcelRequire("lJoYM");
Object.keys($lJoYM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lJoYM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lJoYM[key];
        }
    });
});

var $jIxx0 = parcelRequire("jIxx0");

var $eoo8B = parcelRequire("eoo8B");
Object.keys($eoo8B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fa6af2d084329347$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eoo8B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eoo8B[key];
        }
    });
});

});
parcelRegister("7TCdI", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5bfb5132796e4528$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsTooltip = $5bfb5132796e4528$var$ChartsTooltip;

var $5bfb5132796e4528$var$_extends2 = $5bfb5132796e4528$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5bfb5132796e4528$var$_propTypes = $5bfb5132796e4528$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5bfb5132796e4528$var$_HTMLElementType = $5bfb5132796e4528$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $ir7SE = parcelRequire("ir7SE");

var $3WQ6P = parcelRequire("3WQ6P");

var $gZnkU = parcelRequire("gZnkU");

var $i1NCK = parcelRequire("i1NCK");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [ChartsTooltip](https://mui.com/x/react-charts/tooltip/)
 *
 * API:
 *
 * - [ChartsTooltip API](https://mui.com/x/api/charts/charts-tool-tip/)
 */ function $5bfb5132796e4528$var$ChartsTooltip(props) {
    const { classes: propClasses, trigger: trigger = 'axis' } = props;
    const classes = (0, $i1NCK.useUtilityClasses)(propClasses);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($gZnkU.ChartsTooltipContainer, (0, $5bfb5132796e4528$var$_extends2.default)({}, props, {
        classes: propClasses,
        children: trigger === 'axis' ? /*#__PURE__*/ (0, $ayMG0.jsx)($3WQ6P.ChartsAxisTooltipContent, {
            classes: classes
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($ir7SE.ChartsItemTooltipContent, {
            classes: classes
        })
    }));
}

});
parcelRegister("ir7SE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d6c0dc82a909267c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsItemTooltipContent = $d6c0dc82a909267c$var$ChartsItemTooltipContent;

var $d6c0dc82a909267c$var$_propTypes = $d6c0dc82a909267c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d6c0dc82a909267c$var$_clsx = $d6c0dc82a909267c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $d6c0dc82a909267c$var$_Typography = $d6c0dc82a909267c$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $i1NCK = parcelRequire("i1NCK");

var $1JXjN = parcelRequire("1JXjN");

var $1OcZs = parcelRequire("1OcZs");

var $ip5yP = parcelRequire("ip5yP");

var $ayMG0 = parcelRequire("ayMG0");
function $d6c0dc82a909267c$var$ChartsItemTooltipContent(props) {
    const { classes: propClasses, sx: sx } = props;
    const tooltipData = (0, $1JXjN.useInternalItemTooltip)();
    const classes = (0, $i1NCK.useUtilityClasses)(propClasses);
    if (!tooltipData) return null;
    if ('values' in tooltipData) {
        const { label: seriesLabel, color: color, markType: markType } = tooltipData;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipPaper, {
            sx: sx,
            className: classes.paper,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipTable, {
                className: classes.table,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d6c0dc82a909267c$var$_Typography.default, {
                        component: "caption",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: classes.markContainer,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ip5yP.ChartsLabelMark, {
                                    type: markType,
                                    color: color,
                                    className: classes.mark
                                })
                            }),
                            seriesLabel
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: tooltipData.values.map(({ formattedValue: formattedValue, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipRow, {
                                className: classes.row,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipCell, {
                                        className: (0, $d6c0dc82a909267c$var$_clsx.default)(classes.labelCell, classes.cell),
                                        component: "th",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipCell, {
                                        className: (0, $d6c0dc82a909267c$var$_clsx.default)(classes.valueCell, classes.cell),
                                        component: "td",
                                        children: formattedValue
                                    })
                                ]
                            }, label))
                    })
                ]
            })
        });
    }
    const { color: color, label: label, formattedValue: formattedValue, markType: markType } = tooltipData;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipPaper, {
        sx: sx,
        className: classes.paper,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipTable, {
            className: classes.table,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipRow, {
                    className: classes.row,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipCell, {
                            className: (0, $d6c0dc82a909267c$var$_clsx.default)(classes.labelCell, classes.cell),
                            component: "th",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: classes.markContainer,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($ip5yP.ChartsLabelMark, {
                                        type: markType,
                                        color: color,
                                        className: classes.mark
                                    })
                                }),
                                label
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipCell, {
                            className: (0, $d6c0dc82a909267c$var$_clsx.default)(classes.valueCell, classes.cell),
                            component: "td",
                            children: formattedValue
                        })
                    ]
                })
            })
        })
    });
}

});
parcelRegister("i1NCK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1fed041c1dd4685$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsTooltipClasses = void 0;
module.exports.getChartsTooltipUtilityClass = $d1fed041c1dd4685$var$getChartsTooltipUtilityClass;
module.exports.useUtilityClasses = void 0;

var $d1fed041c1dd4685$var$_generateUtilityClass = $d1fed041c1dd4685$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $d1fed041c1dd4685$var$_generateUtilityClasses = $d1fed041c1dd4685$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d1fed041c1dd4685$var$_composeClasses = $d1fed041c1dd4685$require$_interopRequireDefault((parcelRequire("3Hg1x")));
function $d1fed041c1dd4685$var$getChartsTooltipUtilityClass(slot) {
    return (0, $d1fed041c1dd4685$var$_generateUtilityClass.default)('MuiChartsTooltip', slot);
}
const $d1fed041c1dd4685$var$chartsTooltipClasses = module.exports.chartsTooltipClasses = (0, $d1fed041c1dd4685$var$_generateUtilityClasses.default)('MuiChartsTooltip', [
    'root',
    'paper',
    'table',
    'row',
    'cell',
    'mark',
    'markContainer',
    'labelCell',
    'valueCell',
    'axisValueCell'
]);
const $d1fed041c1dd4685$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        table: [
            'table'
        ],
        row: [
            'row'
        ],
        cell: [
            'cell'
        ],
        mark: [
            'mark'
        ],
        markContainer: [
            'markContainer'
        ],
        labelCell: [
            'labelCell'
        ],
        valueCell: [
            'valueCell'
        ],
        axisValueCell: [
            'axisValueCell'
        ]
    };
    return (0, $d1fed041c1dd4685$var$_composeClasses.default)(slots, $d1fed041c1dd4685$var$getChartsTooltipUtilityClass, classes);
};
module.exports.useUtilityClasses = $d1fed041c1dd4685$var$useUtilityClasses;

});

parcelRegister("1JXjN", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInternalItemTooltip = $144801c43c2891bc$var$useInternalItemTooltip;
module.exports.useRadarItemTooltip = module.exports.useItemTooltip = void 0;

var $cGXUp = parcelRequire("cGXUp");

var $d8Csh = parcelRequire("d8Csh");

var $d3mgr = parcelRequire("d3mgr");

var $55Xcx = parcelRequire("55Xcx");

var $9qhH3 = parcelRequire("9qhH3");

var $6kle2 = parcelRequire("6kle2");

var $8e9Tj = parcelRequire("8e9Tj");
function $144801c43c2891bc$var$useInternalItemTooltip() {
    const store = (0, $d3mgr.useStore)();
    const identifier = store.use($d8Csh.selectorChartsTooltipItem);
    const seriesConfig = store.use($6kle2.selectorChartSeriesConfig);
    const series = (0, $cGXUp.useSeries)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55Xcx.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55Xcx.useYAxes)();
    const { zAxis: zAxis, zAxisIds: zAxisIds } = (0, $9qhH3.useZAxes)();
    const { rotationAxis: rotationAxis, rotationAxisIds: rotationAxisIds } = (0, $55Xcx.useRotationAxes)();
    if (!identifier) return null;
    const itemSeries = series[identifier.type]?.series[identifier.seriesId];
    if (!itemSeries) return null;
    const xAxisId = (0, $8e9Tj.isCartesianSeries)(itemSeries) ? itemSeries.xAxisId ?? xAxisIds[0] : undefined;
    const yAxisId = (0, $8e9Tj.isCartesianSeries)(itemSeries) ? itemSeries.yAxisId ?? yAxisIds[0] : undefined;
    const zAxisId = 'zAxisId' in itemSeries ? itemSeries.zAxisId ?? zAxisIds[0] : zAxisIds[0];
    const rotationAxisId = rotationAxisIds[0];
    const getColor = seriesConfig[itemSeries.type].colorProcessor?.(itemSeries, xAxisId !== undefined ? xAxis[xAxisId] : undefined, yAxisId !== undefined ? yAxis[yAxisId] : undefined, zAxisId !== undefined ? zAxis[zAxisId] : undefined) ?? (()=>'');
    const axesConfig = {};
    if (xAxisId !== undefined) axesConfig.x = xAxis[xAxisId];
    if (yAxisId !== undefined) axesConfig.y = yAxis[yAxisId];
    if (rotationAxisId !== undefined) axesConfig.rotation = rotationAxis[rotationAxisId];
    return seriesConfig[itemSeries.type].tooltipGetter({
        series: itemSeries,
        axesConfig: axesConfig,
        getColor: getColor,
        identifier: identifier
    });
}
/**
 * Returns a config object when the tooltip contains a single item to display.
 * Some specific charts like radar need more complex structure. Use specific hook like `useRadarItemTooltip` for them.
 * @returns The tooltip item config
 */ const $144801c43c2891bc$var$useItemTooltip = ()=>{
    return $144801c43c2891bc$var$useInternalItemTooltip();
};
/**
 * Contains an object per value with their content and the label of the associated metric.
 * @returns The tooltip item configs
 */ module.exports.useItemTooltip = $144801c43c2891bc$var$useItemTooltip;
const $144801c43c2891bc$var$useRadarItemTooltip = ()=>{
    return $144801c43c2891bc$var$useInternalItemTooltip();
};
module.exports.useRadarItemTooltip = $144801c43c2891bc$var$useRadarItemTooltip;

});

parcelRegister("1OcZs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1514898e3b12c33a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsTooltipTable = module.exports.ChartsTooltipRow = module.exports.ChartsTooltipPaper = module.exports.ChartsTooltipCell = void 0;

var $8xDHs = parcelRequire("8xDHs");

var $1514898e3b12c33a$var$_Typography = $1514898e3b12c33a$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $i1NCK = parcelRequire("i1NCK");
/**
 * @ignore - internal component.
 */ const $1514898e3b12c33a$var$ChartsTooltipPaper = module.exports.ChartsTooltipPaper = (0, $8xDHs.styled)('div', {
    name: 'MuiChartsTooltip',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.paper // FIXME: Inconsistent naming with slot
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        borderRadius: (theme.vars || theme).shape?.borderRadius,
        border: `solid ${(theme.vars || theme).palette.divider} 1px`
    }));
/**
 * @ignore - internal component.
 */ const $1514898e3b12c33a$var$ChartsTooltipTable = module.exports.ChartsTooltipTable = (0, $8xDHs.styled)('table', {
    name: 'MuiChartsTooltip',
    slot: 'Table'
})(({ theme: theme })=>({
        borderSpacing: 0,
        [`& .${$i1NCK.chartsTooltipClasses.markContainer}`]: {
            display: 'inline-block',
            width: `calc(20px + ${theme.spacing(1.5)})`,
            verticalAlign: 'middle'
        },
        '& caption': {
            borderBottom: `solid ${(theme.vars || theme).palette.divider} 1px`,
            padding: theme.spacing(0.5, 1.5),
            textAlign: 'start',
            whiteSpace: 'nowrap',
            '& span': {
                marginRight: theme.spacing(1.5)
            }
        }
    }));
/**
 * @ignore - internal component.
 */ const $1514898e3b12c33a$var$ChartsTooltipRow = module.exports.ChartsTooltipRow = (0, $8xDHs.styled)('tr', {
    name: 'MuiChartsTooltip',
    slot: 'Row'
})(({ theme: theme })=>({
        'tr:first-of-type& td': {
            paddingTop: theme.spacing(0.5)
        },
        'tr:last-of-type& td': {
            paddingBottom: theme.spacing(0.5)
        }
    }));
/**
 * @ignore - internal component.
 */ const $1514898e3b12c33a$var$ChartsTooltipCell = module.exports.ChartsTooltipCell = (0, $8xDHs.styled)($1514898e3b12c33a$var$_Typography.default, {
    name: 'MuiChartsTooltip',
    slot: 'Cell'
})(({ theme: theme })=>({
        verticalAlign: 'middle',
        color: (theme.vars || theme).palette.text.secondary,
        textAlign: 'start',
        [`&.${$i1NCK.chartsTooltipClasses.cell}`]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        },
        [`&.${$i1NCK.chartsTooltipClasses.labelCell}`]: {
            whiteSpace: 'nowrap',
            fontWeight: theme.typography.fontWeightRegular
        },
        [`&.${$i1NCK.chartsTooltipClasses.valueCell}, &.${$i1NCK.chartsTooltipClasses.axisValueCell}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium
        },
        [`&.${$i1NCK.chartsTooltipClasses.valueCell}`]: {
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5)
        },
        'td:first-of-type&, th:first-of-type&': {
            paddingLeft: theme.spacing(1.5)
        },
        'td:last-of-type&, th:last-of-type&': {
            paddingRight: theme.spacing(1.5)
        }
    }));

});

parcelRegister("ip5yP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d65ee00de0adefbf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d65ee00de0adefbf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsLabelMark = void 0;

var $d65ee00de0adefbf$var$_extends2 = $d65ee00de0adefbf$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d65ee00de0adefbf$var$_objectWithoutPropertiesLoose2 = $d65ee00de0adefbf$require$_interopRequireDefault((parcelRequire("c05no")));

var $d65ee00de0adefbf$var$React = $d65ee00de0adefbf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d65ee00de0adefbf$var$_propTypes = $d65ee00de0adefbf$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $d65ee00de0adefbf$var$_clsx = $d65ee00de0adefbf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9Cvbh = parcelRequire("9Cvbh");

var $7Ry4U = parcelRequire("7Ry4U");

var $ayMG0 = parcelRequire("ayMG0");
const $d65ee00de0adefbf$var$_excluded = [
    "type",
    "color",
    "className",
    "classes"
];
const $d65ee00de0adefbf$var$Root = (0, $8xDHs.styled)('div', {
    name: 'MuiChartsLabelMark',
    slot: 'Root'
})(()=>{
    return {
        display: 'flex',
        width: 14,
        height: 14,
        [`&.${$9Cvbh.labelMarkClasses.line}`]: {
            width: 16,
            height: 'unset',
            alignItems: 'center',
            [`.${$9Cvbh.labelMarkClasses.mask}`]: {
                height: 4,
                width: '100%',
                borderRadius: 1,
                overflow: 'hidden'
            }
        },
        [`&.${$9Cvbh.labelMarkClasses.square}`]: {
            height: 13,
            width: 13,
            borderRadius: 2,
            overflow: 'hidden'
        },
        [`&.${$9Cvbh.labelMarkClasses.circle}`]: {
            height: 15,
            width: 15
        },
        svg: {
            display: 'block'
        },
        [`& .${$9Cvbh.labelMarkClasses.mask} > *`]: {
            height: '100%',
            width: '100%'
        },
        [`& .${$9Cvbh.labelMarkClasses.mask}`]: {
            height: '100%',
            width: '100%'
        }
    };
});
/**
 * Generates the label mark for the tooltip and legend.
 * @ignore - internal component.
 */ const $d65ee00de0adefbf$var$ChartsLabelMark = module.exports.ChartsLabelMark = (0, $7Ry4U.consumeThemeProps)('MuiChartsLabelMark', {
    defaultProps: {
        type: 'square'
    },
    classesResolver: $9Cvbh.useUtilityClasses
}, function ChartsLabelMark(props, ref) {
    const { type: type, color: color, className: className, classes: classes } = props, other = (0, $d65ee00de0adefbf$var$_objectWithoutPropertiesLoose2.default)(props, $d65ee00de0adefbf$var$_excluded);
    const Component = type;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d65ee00de0adefbf$var$Root, (0, $d65ee00de0adefbf$var$_extends2.default)({
        className: (0, $d65ee00de0adefbf$var$_clsx.default)(classes?.root, className),
        ownerState: props,
        "aria-hidden": "true",
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: classes?.mask,
            children: typeof Component === 'function' ? /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                className: classes?.fill,
                color: color
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                preserveAspectRatio: type === 'line' ? 'none' : undefined,
                children: type === 'circle' ? /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    className: classes?.fill,
                    r: "12",
                    cx: "12",
                    cy: "12",
                    fill: color
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    className: classes?.fill,
                    width: "24",
                    height: "24",
                    fill: color
                })
            })
        })
    }));
});

});
parcelRegister("9Cvbh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $700fd992ece9e595$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLabelMarkUtilityClass = $700fd992ece9e595$var$getLabelMarkUtilityClass;
module.exports.useUtilityClasses = module.exports.labelMarkClasses = void 0;

var $700fd992ece9e595$var$_composeClasses = $700fd992ece9e595$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $700fd992ece9e595$var$_generateUtilityClass = $700fd992ece9e595$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $700fd992ece9e595$var$_generateUtilityClasses = $700fd992ece9e595$require$_interopRequireDefault((parcelRequire("5nY49")));
function $700fd992ece9e595$var$getLabelMarkUtilityClass(slot) {
    return (0, $700fd992ece9e595$var$_generateUtilityClass.default)('MuiChartsLabelMark', slot);
}
const $700fd992ece9e595$var$labelMarkClasses = module.exports.labelMarkClasses = (0, $700fd992ece9e595$var$_generateUtilityClasses.default)('MuiChartsLabelMark', [
    'root',
    'line',
    'square',
    'circle',
    'mask',
    'fill'
]);
const $700fd992ece9e595$var$useUtilityClasses = (props)=>{
    const { type: type } = props;
    const slots = {
        root: typeof type === 'function' ? [
            'root'
        ] : [
            'root',
            type
        ],
        mask: [
            'mask'
        ],
        fill: [
            'fill'
        ]
    };
    return (0, $700fd992ece9e595$var$_composeClasses.default)(slots, $700fd992ece9e595$var$getLabelMarkUtilityClass, props.classes);
};
module.exports.useUtilityClasses = $700fd992ece9e595$var$useUtilityClasses;

});

parcelRegister("7Ry4U", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5b97eadf6f25e530$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $5b97eadf6f25e530$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.consumeThemeProps = void 0;

var $5b97eadf6f25e530$var$_extends2 = $5b97eadf6f25e530$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8xDHs = parcelRequire("8xDHs");

var $5b97eadf6f25e530$var$_resolveProps = $5b97eadf6f25e530$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $5b97eadf6f25e530$var$React = $5b97eadf6f25e530$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * A higher order component that consumes and merges the theme `defaultProps` and handles the `classes` and renders the component.
 *
 * This HOC will wrap a single component.
 * If you need to render multiple components, you can manually consume the theme and render them in your component instead of using this HOC.
 *
 * In the example below, `MyComponent` will render the `DefaultComponent` with the `direction` prop set to `'row'` and the className set to `'my-custom-root'`.
 *
 * @example
 * ```tsx
 * createTheme({
 *   components: {
 *     MuiMyComponent: {
 *       defaultProps: {
 *         direction: 'row',
 *       },
 *     },
 *   },
 * })
 *
 * type MyComponentProps = {
 *   direction: 'row' | 'column';
 *   classes?: Record<'root', string>;
 * };
 *
 * const MyComponent = consumeThemeProps(
 *   'MuiMyComponent',
 *   function DefaultComponent(props: MyComponentProps) {
 *     return (
 *       <div className={props.classes.root}>
 *         {props.direction}
 *       </div>
 *     );
 *   }
 * );
 *
 * render(<MyComponent classes={{ root: 'my-custom-root' }} />);
 * ```
 *
 * @param {string} name The mui component name.
 * @param {object} options Options for the HOC.
 * @param {Record<string, any>} options.defaultProps A set of defaults for the component, will be deep merged with the props.
 * @param {Function} options.classesResolver A function that returns the classes for the component. It receives the props, after theme props and defaults have been applied. And the theme object as the second argument.
 * @param InComponent The component to render if the slot is not provided.
 */ const $5b97eadf6f25e530$var$consumeThemeProps = (name, options, InComponent)=>/*#__PURE__*/ $5b97eadf6f25e530$var$React.forwardRef(function ConsumeThemeInternal(props, ref) {
        const themedProps = (0, $8xDHs.useThemeProps)({
            props: props,
            name: // eslint-disable-next-line material-ui/mui-name-matches-component-name
            name
        });
        const defaultProps = typeof options.defaultProps === 'function' ? options.defaultProps(themedProps) : options.defaultProps ?? {};
        const outProps = (0, $5b97eadf6f25e530$var$_resolveProps.default)(defaultProps, themedProps);
        const theme = (0, $8xDHs.useTheme)();
        const classes = options.classesResolver?.(outProps, theme);
        const OutComponent = /*#__PURE__*/ $5b97eadf6f25e530$var$React.forwardRef(InComponent);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(OutComponent, (0, $5b97eadf6f25e530$var$_extends2.default)({}, outProps, {
            classes: classes,
            ref: ref
        }));
    });
module.exports.consumeThemeProps = $5b97eadf6f25e530$var$consumeThemeProps;

});



parcelRegister("3WQ6P", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2dff35ab6813fb7d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsAxisTooltipContent = $2dff35ab6813fb7d$var$ChartsAxisTooltipContent;

var $2dff35ab6813fb7d$var$_propTypes = $2dff35ab6813fb7d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2dff35ab6813fb7d$var$_Typography = $2dff35ab6813fb7d$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $2dff35ab6813fb7d$var$_clsx = $2dff35ab6813fb7d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $i1NCK = parcelRequire("i1NCK");

var $1OcZs = parcelRequire("1OcZs");

var $lJoYM = parcelRequire("lJoYM");

var $ip5yP = parcelRequire("ip5yP");

var $ayMG0 = parcelRequire("ayMG0");
function $2dff35ab6813fb7d$var$ChartsAxisTooltipContent(props) {
    const classes = (0, $i1NCK.useUtilityClasses)(props.classes);
    const tooltipData = (0, $lJoYM.useAxesTooltip)();
    if (tooltipData === null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipPaper, {
        sx: props.sx,
        className: classes.paper,
        children: tooltipData.map(({ axisId: axisId, mainAxis: mainAxis, axisValue: axisValue, axisFormattedValue: axisFormattedValue, seriesItems: seriesItems })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipTable, {
                className: classes.table,
                children: [
                    axisValue != null && !mainAxis.hideTooltip && /*#__PURE__*/ (0, $ayMG0.jsx)($2dff35ab6813fb7d$var$_Typography.default, {
                        component: "caption",
                        children: axisFormattedValue
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: seriesItems.map(({ seriesId: seriesId, color: color, formattedValue: formattedValue, formattedLabel: formattedLabel, markType: markType })=>{
                            if (formattedValue == null) return null;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipRow, {
                                className: classes.row,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1OcZs.ChartsTooltipCell, {
                                        className: (0, $2dff35ab6813fb7d$var$_clsx.default)(classes.labelCell, classes.cell),
                                        component: "th",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: classes.markContainer,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ip5yP.ChartsLabelMark, {
                                                    type: markType,
                                                    color: color,
                                                    className: classes.mark
                                                })
                                            }),
                                            formattedLabel || null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1OcZs.ChartsTooltipCell, {
                                        className: (0, $2dff35ab6813fb7d$var$_clsx.default)(classes.valueCell, classes.cell),
                                        component: "td",
                                        children: formattedValue
                                    })
                                ]
                            }, seriesId);
                        })
                    })
                ]
            }, axisId);
        })
    });
}

});
parcelRegister("lJoYM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fd212d54afb92a44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAxesTooltip = $fd212d54afb92a44$var$useAxesTooltip;

var $fd212d54afb92a44$var$_extends2 = $fd212d54afb92a44$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $hkxtM = parcelRequire("hkxtM");
/**
 * Returns the axes to display in the tooltip and the series item related to them.
 */ function $fd212d54afb92a44$var$useAxesTooltip(params) {
    return (0, $hkxtM.useAxisTooltip)((0, $fd212d54afb92a44$var$_extends2.default)({}, params, {
        multipleAxes: true
    }));
}

});
parcelRegister("hkxtM", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAxisTooltip = $c9de463b63476008$var$useAxisTooltip;

var $cGXUp = parcelRequire("cGXUp");

var $lor3V = parcelRequire("lor3V");

var $d3mgr = parcelRequire("d3mgr");

var $erYIG = parcelRequire("erYIG");

var $8e9Tj = parcelRequire("8e9Tj");

var $jIxx0 = parcelRequire("jIxx0");

var $55Xcx = parcelRequire("55Xcx");

var $9qhH3 = parcelRequire("9qhH3");

var $a5Dpn = parcelRequire("a5Dpn");

var $bLygF = parcelRequire("bLygF");

var $jFd7Z = parcelRequire("jFd7Z");
function $c9de463b63476008$var$defaultAxisTooltipConfig(axis, dataIndex, axisDirection) {
    const axisValue = axis.data?.[dataIndex] ?? null;
    const axisFormatter = axis.valueFormatter ?? ((v)=>axis.scaleType === 'utc' ? (0, $jIxx0.utcFormatter)(v) : v.toLocaleString());
    const axisFormattedValue = axisFormatter(axisValue, {
        location: 'tooltip',
        scale: axis.scale
    });
    return {
        axisDirection: axisDirection,
        axisId: axis.id,
        mainAxis: axis,
        dataIndex: dataIndex,
        axisValue: axisValue,
        axisFormattedValue: axisFormattedValue,
        seriesItems: []
    };
}
/**
 * @deprecated Use `useAxesTooltip` instead.
 */ function $c9de463b63476008$var$useAxisTooltip(params = {}) {
    const { multipleAxes: multipleAxes, directions: directions } = params;
    const defaultXAxis = (0, $55Xcx.useXAxis)();
    const defaultYAxis = (0, $55Xcx.useYAxis)();
    const defaultRotationAxis = (0, $55Xcx.useRotationAxis)();
    const store = (0, $d3mgr.useStore)();
    const tooltipXAxes = store.use($a5Dpn.selectorChartsInteractionTooltipXAxes);
    const tooltipYAxes = store.use($a5Dpn.selectorChartsInteractionTooltipYAxes);
    const tooltipRotationAxes = store.use($bLygF.selectorChartsInteractionTooltipRotationAxes);
    const series = (0, $cGXUp.useSeries)();
    const { xAxis: xAxis } = (0, $55Xcx.useXAxes)();
    const { yAxis: yAxis } = (0, $55Xcx.useYAxes)();
    const { zAxis: zAxis, zAxisIds: zAxisIds } = (0, $9qhH3.useZAxes)();
    const { rotationAxis: rotationAxis } = (0, $55Xcx.useRotationAxes)();
    const colorProcessors = (0, $lor3V.useColorProcessor)();
    if (tooltipXAxes.length === 0 && tooltipYAxes.length === 0 && tooltipRotationAxes.length === 0) return null;
    const tooltipAxes = [];
    if (directions === undefined || directions.includes('x')) tooltipXAxes.forEach(({ axisId: axisId, dataIndex: dataIndex })=>{
        if (!multipleAxes && tooltipAxes.length > 1) return;
        tooltipAxes.push($c9de463b63476008$var$defaultAxisTooltipConfig(xAxis[axisId], dataIndex, 'x'));
    });
    if (directions === undefined || directions.includes('y')) tooltipYAxes.forEach(({ axisId: axisId, dataIndex: dataIndex })=>{
        if (!multipleAxes && tooltipAxes.length > 1) return;
        tooltipAxes.push($c9de463b63476008$var$defaultAxisTooltipConfig(yAxis[axisId], dataIndex, 'y'));
    });
    if (directions === undefined || directions.includes('rotation')) tooltipRotationAxes.forEach(({ axisId: axisId, dataIndex: dataIndex })=>{
        if (!multipleAxes && tooltipAxes.length > 1) return;
        tooltipAxes.push($c9de463b63476008$var$defaultAxisTooltipConfig(rotationAxis[axisId], dataIndex, 'rotation'));
    });
    Object.keys(series).filter($8e9Tj.isCartesianSeriesType).forEach((seriesType)=>{
        const seriesOfType = series[seriesType];
        if (!seriesOfType) return [];
        return seriesOfType.seriesOrder.forEach((seriesId)=>{
            const seriesToAdd = seriesOfType.series[seriesId];
            const providedXAxisId = seriesToAdd.xAxisId ?? defaultXAxis.id;
            const providedYAxisId = seriesToAdd.yAxisId ?? defaultYAxis.id;
            const tooltipItemIndex = tooltipAxes.findIndex(({ axisDirection: axisDirection, axisId: axisId })=>axisDirection === 'x' && axisId === providedXAxisId || axisDirection === 'y' && axisId === providedYAxisId);
            // Test if the series uses the default axis
            if (tooltipItemIndex >= 0) {
                const zAxisId = 'zAxisId' in seriesToAdd ? seriesToAdd.zAxisId : zAxisIds[0];
                const { dataIndex: dataIndex } = tooltipAxes[tooltipItemIndex];
                const color = colorProcessors[seriesType]?.(seriesToAdd, xAxis[providedXAxisId], yAxis[providedYAxisId], zAxisId ? zAxis[zAxisId] : undefined)(dataIndex) ?? '';
                const value = seriesToAdd.data[dataIndex] ?? null;
                const formattedValue = seriesToAdd.valueFormatter(value, {
                    dataIndex: dataIndex
                });
                const formattedLabel = (0, $erYIG.getLabel)(seriesToAdd.label, 'tooltip') ?? null;
                tooltipAxes[tooltipItemIndex].seriesItems.push({
                    seriesId: seriesId,
                    color: color,
                    value: value,
                    formattedValue: formattedValue,
                    formattedLabel: formattedLabel,
                    markType: seriesToAdd.labelMarkType
                });
            }
        });
    });
    Object.keys(series).filter($jFd7Z.isPolarSeriesType).forEach((seriesType)=>{
        const seriesOfType = series[seriesType];
        if (!seriesOfType) return [];
        return seriesOfType.seriesOrder.forEach((seriesId)=>{
            const seriesToAdd = seriesOfType.series[seriesId];
            const providedRotationAxisId = // @ts-expect-error Should be fixed when we introduce a polar series with a rotationAxisId
            seriesToAdd.rotationAxisId ?? defaultRotationAxis?.id;
            const tooltipItemIndex = tooltipAxes.findIndex(({ axisDirection: axisDirection, axisId: axisId })=>axisDirection === 'rotation' && axisId === providedRotationAxisId);
            // Test if the series uses the default axis
            if (tooltipItemIndex >= 0) {
                const { dataIndex: dataIndex } = tooltipAxes[tooltipItemIndex];
                const color = colorProcessors[seriesType]?.(seriesToAdd)(dataIndex) ?? '';
                const value = seriesToAdd.data[dataIndex] ?? null;
                const formattedValue = seriesToAdd.valueFormatter(value, {
                    dataIndex: dataIndex
                });
                const formattedLabel = (0, $erYIG.getLabel)(seriesToAdd.label, 'tooltip') ?? null;
                tooltipAxes[tooltipItemIndex].seriesItems.push({
                    seriesId: seriesId,
                    color: color,
                    value: value,
                    formattedValue: formattedValue,
                    formattedLabel: formattedLabel,
                    markType: seriesToAdd.labelMarkType
                });
            }
        });
    });
    if (!multipleAxes) return tooltipAxes.length === 0 ? tooltipAxes[0] : null;
    return tooltipAxes;
}

});
parcelRegister("lor3V", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f930d4ddf4cb6c26$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useColorProcessor = $f930d4ddf4cb6c26$var$useColorProcessor;

var $f930d4ddf4cb6c26$var$React = $f930d4ddf4cb6c26$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d3mgr = parcelRequire("d3mgr");

var $6kle2 = parcelRequire("6kle2");
function $f930d4ddf4cb6c26$var$useColorProcessor(seriesType) {
    const store = (0, $d3mgr.useStore)();
    const seriesConfig = store.use($6kle2.selectorChartSeriesConfig);
    const colorProcessors = $f930d4ddf4cb6c26$var$React.useMemo(()=>{
        const rep = {};
        Object.keys(seriesConfig).forEach((seriesT)=>{
            // @ts-expect-error https://github.com/microsoft/TypeScript/issues/61555
            rep[seriesT] = seriesConfig[seriesT].colorProcessor;
        });
        return rep;
    }, [
        seriesConfig
    ]);
    if (!seriesType) return colorProcessors;
    return colorProcessors[seriesType];
}

});

parcelRegister("jIxx0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e5ac22fee642519c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e5ac22fee642519c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsFineMainPointer = void 0;
module.exports.useMouseTracker = $e5ac22fee642519c$var$useMouseTracker;
module.exports.utcFormatter = $e5ac22fee642519c$var$utcFormatter;

var $e5ac22fee642519c$var$React = $e5ac22fee642519c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e5ac22fee642519c$var$_useMediaQuery = $e5ac22fee642519c$require$_interopRequireDefault((parcelRequire("18tt9")));

var $6hQTT = parcelRequire("6hQTT");
/**
 * @deprecated We recommend using vanilla JS to let popper track mouse position.
 */ function $e5ac22fee642519c$var$useMouseTracker() {
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    // Use a ref to avoid rerendering on every mousemove event.
    const [mousePosition, setMousePosition] = $e5ac22fee642519c$var$React.useState(null);
    $e5ac22fee642519c$var$React.useEffect(()=>{
        const moveEndHandler = instance.addInteractionListener('moveEnd', (event)=>{
            if (!event.detail.activeGestures.pan) setMousePosition(null);
        });
        const gestureHandler = (event)=>{
            setMousePosition({
                x: event.detail.centroid.x,
                y: event.detail.centroid.y,
                height: event.detail.srcEvent.height,
                pointerType: event.detail.srcEvent.pointerType
            });
        };
        const moveHandler = instance.addInteractionListener('move', gestureHandler);
        const panHandler = instance.addInteractionListener('pan', gestureHandler);
        return ()=>{
            moveHandler.cleanup();
            panHandler.cleanup();
            moveEndHandler.cleanup();
        };
    }, [
        instance
    ]);
    return mousePosition;
}
function $e5ac22fee642519c$var$utcFormatter(v) {
    if (v instanceof Date) return v.toUTCString();
    return v.toLocaleString();
}
// Taken from @mui/x-date-time-pickers
const $e5ac22fee642519c$var$mainPointerFineMediaQuery = '@media (pointer: fine)';
/**
 * Returns true if the main pointer is fine (e.g. mouse).
 * This is useful for determining how to position tooltips or other UI elements based on the type of input device.
 * @returns true if the main pointer is fine, false otherwise.
 */ const $e5ac22fee642519c$var$useIsFineMainPointer = ()=>{
    return (0, $e5ac22fee642519c$var$_useMediaQuery.default)($e5ac22fee642519c$var$mainPointerFineMediaQuery, {
        defaultMatches: true
    });
};
module.exports.useIsFineMainPointer = $e5ac22fee642519c$var$useIsFineMainPointer;

});

parcelRegister("bLygF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsInteractionTooltipRotationAxes = module.exports.selectorChartsInteractionTooltipRadiusAxes = module.exports.selectorChartsInteractionRotationAxisValues = module.exports.selectorChartsInteractionRotationAxisValue = module.exports.selectorChartsInteractionRotationAxisIndexes = module.exports.selectorChartsInteractionRotationAxisIndex = module.exports.selectorChartsInteractionPolarAxisTooltip = void 0;

var $e9lLm = parcelRequire("e9lLm");

var $8P0MD = parcelRequire("8P0MD");

var $iqlkh = parcelRequire("iqlkh");

var $ahtwU = parcelRequire("ahtwU");

var $8oJqY = parcelRequire("8oJqY");

var $50bTE = parcelRequire("50bTE");
const $890eaa6467fa3b41$var$optionalGetAxisId = (_, id)=>id;
const $890eaa6467fa3b41$var$optionalGetAxisIds = (_, ids)=>ids;
/**
 * Get interaction indexes
 */ function $890eaa6467fa3b41$var$indexGetter(value, axes, ids) {
    return Array.isArray(ids) ? ids.map((id)=>(0, $8oJqY.getAxisIndex)(axes.axis[id], value)) : (0, $8oJqY.getAxisIndex)(axes.axis[ids], value);
}
/**
 * Helper to get the rotation associated to the interaction coordinate.
 */ const $890eaa6467fa3b41$var$selectorChartsInteractionRotationAngle = (0, $8P0MD.createSelector)($iqlkh.selectorChartsInteractionPointerX, $iqlkh.selectorChartsInteractionPointerY, $50bTE.selectorChartPolarCenter, (x, y, center)=>{
    if (x === null || y === null) return null;
    return (0, $ahtwU.generateSvg2rotation)(center)(x, y);
});
const $890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisIndex = module.exports.selectorChartsInteractionRotationAxisIndex = (0, $8P0MD.createSelector)($890eaa6467fa3b41$var$selectorChartsInteractionRotationAngle, $50bTE.selectorChartRotationAxis, $890eaa6467fa3b41$var$optionalGetAxisId, (rotation, rotationAxis, id = rotationAxis.axisIds[0])=>rotation === null ? null : $890eaa6467fa3b41$var$indexGetter(rotation, rotationAxis, id));
const $890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisIndexes = module.exports.selectorChartsInteractionRotationAxisIndexes = (0, $8P0MD.createSelector)($890eaa6467fa3b41$var$selectorChartsInteractionRotationAngle, $50bTE.selectorChartRotationAxis, $890eaa6467fa3b41$var$optionalGetAxisIds, (rotation, rotationAxis, ids = rotationAxis.axisIds)=>rotation === null ? null : $890eaa6467fa3b41$var$indexGetter(rotation, rotationAxis, ids));
const $890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisValue = module.exports.selectorChartsInteractionRotationAxisValue = (0, $8P0MD.createSelector)($50bTE.selectorChartRotationAxis, $890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisIndex, $890eaa6467fa3b41$var$optionalGetAxisId, (rotationAxis, rotationIndex, id = rotationAxis.axisIds[0])=>{
    if (rotationIndex === null || rotationIndex === -1 || rotationAxis.axisIds.length === 0) return null;
    const data = rotationAxis.axis[id]?.data;
    if (!data) return null;
    return data[rotationIndex];
});
const $890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisValues = module.exports.selectorChartsInteractionRotationAxisValues = (0, $8P0MD.createSelector)($50bTE.selectorChartRotationAxis, $890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisIndexes, $890eaa6467fa3b41$var$optionalGetAxisIds, (rotationAxis, rotationIndexes, ids = rotationAxis.axisIds)=>{
    if (rotationIndexes === null) return null;
    return ids.map((id, axisIndex)=>{
        const rotationIndex = rotationIndexes[axisIndex];
        if (rotationIndex === -1) return null;
        return rotationAxis.axis[id].data?.[rotationIndex];
    });
});
/**
 * Get rotation-axis ids and corresponding data index that should be display in the tooltip.
 */ const $890eaa6467fa3b41$var$selectorChartsInteractionTooltipRotationAxes = module.exports.selectorChartsInteractionTooltipRotationAxes = (0, $8P0MD.createSelectorMemoizedWithOptions)({
    memoizeOptions: {
        // Keep the same reference if array content is the same.
        // If possible, avoid this pattern by creating selectors that
        // uses string/number as arguments.
        resultEqualityCheck: $e9lLm.isDeepEqual
    }
})($890eaa6467fa3b41$var$selectorChartsInteractionRotationAxisIndexes, $50bTE.selectorChartRotationAxis, (indexes, axes)=>{
    if (indexes === null) return [];
    return axes.axisIds.map((axisId, axisIndex)=>({
            axisId: axisId,
            dataIndex: indexes[axisIndex]
        })).filter(({ axisId: axisId, dataIndex: dataIndex })=>axes.axis[axisId].triggerTooltip && dataIndex >= 0);
});
/**
 * Get radius-axis ids and corresponding data index that should be displayed in the tooltip.
 */ const $890eaa6467fa3b41$var$selectorChartsInteractionTooltipRadiusAxes = ()=>{
    // TODO implement this selector and add it to the `selectorChartsInteractionPolarAxisTooltip`
    return [];
};
/**
 * Return `true` if the axis tooltip has something to display.
 */ module.exports.selectorChartsInteractionTooltipRadiusAxes = $890eaa6467fa3b41$var$selectorChartsInteractionTooltipRadiusAxes;
const $890eaa6467fa3b41$var$selectorChartsInteractionPolarAxisTooltip = module.exports.selectorChartsInteractionPolarAxisTooltip = (0, $8P0MD.createSelector)($890eaa6467fa3b41$var$selectorChartsInteractionTooltipRotationAxes, (rotationTooltip)=>rotationTooltip.length > 0);

});




parcelRegister("gZnkU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c5e471f286341d56$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c5e471f286341d56$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsTooltipContainer = $c5e471f286341d56$var$ChartsTooltipContainer;

var $c5e471f286341d56$var$_extends2 = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c5e471f286341d56$var$_objectWithoutPropertiesLoose2 = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("c05no")));

var $c5e471f286341d56$var$React = $c5e471f286341d56$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c5e471f286341d56$var$ReactDOM = $c5e471f286341d56$require$_interopRequireWildcard((parcelRequire("1u0KT")));

var $c5e471f286341d56$var$_propTypes = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c5e471f286341d56$var$_HTMLElementType = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("cIfK5")));

var $c5e471f286341d56$var$_useLazyRef = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("doV3C")));

var $8xDHs = parcelRequire("8xDHs");

var $c5e471f286341d56$var$_Popper = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("eWJe7")));

var $c5e471f286341d56$var$_NoSsr = $c5e471f286341d56$require$_interopRequireDefault((parcelRequire("cQC3m")));

var $eFfpr = parcelRequire("eFfpr");

var $jIxx0 = parcelRequire("jIxx0");

var $i1NCK = parcelRequire("i1NCK");

var $d3mgr = parcelRequire("d3mgr");

var $8j56i = parcelRequire("8j56i");

var $d8Csh = parcelRequire("d8Csh");

var $a5Dpn = parcelRequire("a5Dpn");

var $bLygF = parcelRequire("bLygF");

var $bG11B = parcelRequire("bG11B");

var $55quD = parcelRequire("55quD");

var $b4u9m = parcelRequire("b4u9m");

var $ayMG0 = parcelRequire("ayMG0");
const $c5e471f286341d56$var$_excluded = [
    "trigger",
    "position",
    "anchor",
    "classes",
    "children"
];
const $c5e471f286341d56$var$selectorReturnFalse = ()=>false;
const $c5e471f286341d56$var$selectorReturnNull = ()=>null;
function $c5e471f286341d56$var$getIsOpenSelector(trigger, axisSystem, shouldPreventBecauseOfBrush) {
    if (shouldPreventBecauseOfBrush) return $c5e471f286341d56$var$selectorReturnFalse;
    if (trigger === 'item') return $d8Csh.selectorChartsTooltipItemIsDefined;
    if (axisSystem === 'polar') return $bLygF.selectorChartsInteractionPolarAxisTooltip;
    if (axisSystem === 'cartesian') return $a5Dpn.selectorChartsInteractionAxisTooltip;
    return $c5e471f286341d56$var$selectorReturnFalse;
}
const $c5e471f286341d56$var$ChartsTooltipRoot = (0, $8xDHs.styled)($c5e471f286341d56$var$_Popper.default, {
    name: 'MuiChartsTooltip',
    slot: 'Root'
})(({ theme: theme })=>({
        pointerEvents: 'none',
        zIndex: theme.zIndex.modal
    }));
/**
 * Demos:
 *
 * - [ChartsTooltip](https://mui.com/x/react-charts/tooltip/)
 *
 * API:
 *
 * - [ChartsTooltip API](https://mui.com/x/api/charts/charts-tool-tip/)
 */ function $c5e471f286341d56$var$ChartsTooltipContainer(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiChartsTooltipContainer'
    });
    const { trigger: trigger = 'axis', position: position, anchor: anchor = 'pointer', classes: propClasses, children: children } = props, other = (0, $c5e471f286341d56$var$_objectWithoutPropertiesLoose2.default)(props, $c5e471f286341d56$var$_excluded);
    const store = (0, $d3mgr.useStore)();
    const svgRef = (0, $55quD.useSvgRef)();
    const anchorRef = $c5e471f286341d56$var$React.useRef(null);
    const classes = (0, $i1NCK.useUtilityClasses)(propClasses);
    const pointerType = store.use($8j56i.selectorChartsPointerType);
    const isFineMainPointer = (0, $jIxx0.useIsFineMainPointer)();
    const popperRef = $c5e471f286341d56$var$React.useRef(null);
    const positionRef = (0, $c5e471f286341d56$var$_useLazyRef.default)(()=>({
            x: 0,
            y: 0
        }));
    const axisSystem = (0, $bG11B.useAxisSystem)();
    const shouldPreventBecauseOfBrush = store.use($b4u9m.selectorBrushShouldPreventTooltip);
    const isOpen = store.use($c5e471f286341d56$var$getIsOpenSelector(trigger, axisSystem, shouldPreventBecauseOfBrush));
    const lastInteraction = store.use($8j56i.selectorChartsLastInteraction);
    const computedAnchor = lastInteraction === 'keyboard' || pointerType === null ? 'node' : anchor;
    const itemPosition = store.use(trigger === 'item' && computedAnchor === 'node' ? $d8Csh.selectorChartsTooltipItemPosition : $c5e471f286341d56$var$selectorReturnNull, position);
    const isTooltipNodeAnchored = itemPosition !== null;
    $c5e471f286341d56$var$React.useEffect(()=>{
        const svgElement = svgRef.current;
        if (svgElement === null) return ()=>{};
        if (isTooltipNodeAnchored) // Tooltip position is already handled by the anchor element
        return undefined;
        const pointerUpdate = (0, $eFfpr.rafThrottle)((x, y)=>{
            // eslint-disable-next-line react-compiler/react-compiler
            positionRef.current = {
                x: x,
                y: y
            };
            popperRef.current?.update();
        });
        const handlePointerEvent = (event)=>{
            pointerUpdate(event.clientX, event.clientY);
        };
        svgElement.addEventListener('pointermove', handlePointerEvent);
        svgElement.addEventListener('pointerenter', handlePointerEvent);
        return ()=>{
            svgElement.removeEventListener('pointermove', handlePointerEvent);
            svgElement.removeEventListener('pointerenter', handlePointerEvent);
            pointerUpdate.clear();
        };
    }, [
        svgRef,
        positionRef,
        isTooltipNodeAnchored
    ]);
    const pointerAnchorEl = $c5e471f286341d56$var$React.useMemo(()=>({
            getBoundingClientRect: ()=>({
                    x: positionRef.current.x,
                    y: positionRef.current.y,
                    top: positionRef.current.y,
                    left: positionRef.current.x,
                    right: positionRef.current.x,
                    bottom: positionRef.current.y,
                    width: 0,
                    height: 0,
                    toJSON: ()=>''
                })
        }), [
        positionRef
    ]);
    const isMouse = pointerType === 'mouse' || isFineMainPointer;
    const isTouch = pointerType === 'touch' || !isFineMainPointer;
    const modifiers = $c5e471f286341d56$var$React.useMemo(()=>[
            {
                name: 'offset',
                options: {
                    offset: ()=>{
                        if (isTouch && !isTooltipNodeAnchored) return [
                            0,
                            64
                        ];
                        // The popper offset: [skidding, distance]
                        return [
                            0,
                            8
                        ];
                    }
                }
            },
            ...!isMouse ? [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: [
                            'top-end',
                            'top-start',
                            'bottom-end',
                            'bottom'
                        ]
                    }
                }
            ] : [],
            // Keep default behavior
            {
                name: 'preventOverflow',
                options: {
                    altAxis: true
                }
            }
        ], [
        isMouse,
        isTooltipNodeAnchored,
        isTouch
    ]);
    if (trigger === 'none') return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c5e471f286341d56$var$React.Fragment, {
        children: [
            svgRef.current && /*#__PURE__*/ $c5e471f286341d56$var$ReactDOM.createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("rect", (0, $c5e471f286341d56$var$_extends2.default)({
                ref: anchorRef
            }, itemPosition, {
                display: "hidden",
                pointerEvents: "none",
                opacity: 0,
                width: 1,
                height: 1
            })), svgRef.current),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c5e471f286341d56$var$_NoSsr.default, {
                children: isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)($c5e471f286341d56$var$ChartsTooltipRoot, (0, $c5e471f286341d56$var$_extends2.default)({}, other, {
                    className: classes?.root,
                    open: isOpen,
                    placement: other.placement ?? position ?? (!isTooltipNodeAnchored && isMouse ? 'right-start' : 'top'),
                    popperRef: popperRef,
                    anchorEl: itemPosition ? anchorRef.current : pointerAnchorEl,
                    modifiers: modifiers,
                    children: children
                }))
            })
        ]
    });
}

});
parcelRegister("eFfpr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7n78B = parcelRequire("7n78B");
Object.keys($7n78B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7n78B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7n78B[key];
        }
    });
});

});
parcelRegister("7n78B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rafThrottle = $55e037cc4178a6f5$var$rafThrottle;
/**
 *  Creates a throttled function that only invokes `fn` at most once per animation frame.
 *
 * @example
 * ```ts
 * const throttled = rafThrottle((value: number) => console.log(value));
 * window.addEventListener('scroll', (e) => throttled(e.target.scrollTop));
 * ```
 *
 * @param fn Callback function
 * @return The `requestAnimationFrame` throttled function
 */ function $55e037cc4178a6f5$var$rafThrottle(fn) {
    let lastArgs;
    let rafRef;
    const later = ()=>{
        rafRef = null;
        fn(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (!rafRef) rafRef = requestAnimationFrame(later);
    }
    throttled.clear = ()=>{
        if (rafRef) {
            cancelAnimationFrame(rafRef);
            rafRef = null;
        }
    };
    return throttled;
}

});


parcelRegister("bG11B", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAxisSystem = $88046979e5ba90f1$var$useAxisSystem;

var $a5Dpn = parcelRequire("a5Dpn");

var $j98pQ = parcelRequire("j98pQ");

var $d3mgr = parcelRequire("d3mgr");
/**
 * @internals
 *
 * Get the coordinate system implemented.
 * The hook assumes polar and cartesian are never implemented at the same time.
 * @returns The coordinate system
 */ function $88046979e5ba90f1$var$useAxisSystem() {
    const store = (0, $d3mgr.useStore)();
    const rawRotationAxis = store.use($j98pQ.selectorChartRawRotationAxis);
    const rawXAxis = store.use($a5Dpn.selectorChartRawXAxis);
    if (rawRotationAxis !== undefined) return 'polar';
    if (rawXAxis !== undefined) return 'cartesian';
    return 'none';
}

});



parcelRegister("eoo8B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("anK5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $78efcd5779895972$var$_exportNames = {
    legendClasses: true,
    continuousColorLegendClasses: true,
    piecewiseColorLegendClasses: true,
    piecewiseColorDefaultLabelFormatter: true
};
Object.defineProperty(module.exports, "continuousColorLegendClasses", {
    enumerable: true,
    get: function() {
        return $kiBdc.continuousColorLegendClasses;
    }
});
Object.defineProperty(module.exports, "legendClasses", {
    enumerable: true,
    get: function() {
        return $60bWu.legendClasses;
    }
});
Object.defineProperty(module.exports, "piecewiseColorDefaultLabelFormatter", {
    enumerable: true,
    get: function() {
        return $81lIb.piecewiseColorDefaultLabelFormatter;
    }
});
Object.defineProperty(module.exports, "piecewiseColorLegendClasses", {
    enumerable: true,
    get: function() {
        return $4QdBg.piecewiseColorLegendClasses;
    }
});

var $4TJB9 = parcelRequire("4TJB9");
Object.keys($4TJB9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4TJB9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4TJB9[key];
        }
    });
});

var $cODcX = parcelRequire("cODcX");
Object.keys($cODcX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cODcX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cODcX[key];
        }
    });
});

var $lpz6h = parcelRequire("lpz6h");
Object.keys($lpz6h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lpz6h[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lpz6h[key];
        }
    });
});

var $31rFk = parcelRequire("31rFk");
Object.keys($31rFk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $31rFk[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $31rFk[key];
        }
    });
});

var $60bWu = parcelRequire("60bWu");

var $5UbQc = parcelRequire("5UbQc");
Object.keys($5UbQc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5UbQc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5UbQc[key];
        }
    });
});

var $gOzFG = parcelRequire("gOzFG");
Object.keys($gOzFG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gOzFG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gOzFG[key];
        }
    });
});

var $kiBdc = parcelRequire("kiBdc");

var $4jbBo = parcelRequire("4jbBo");
Object.keys($4jbBo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4jbBo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4jbBo[key];
        }
    });
});

var $4QdBg = parcelRequire("4QdBg");

var $81lIb = parcelRequire("81lIb");

var $4tc9H = parcelRequire("4tc9H");
Object.keys($4tc9H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($78efcd5779895972$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4tc9H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4tc9H[key];
        }
    });
});

});
parcelRegister("4TJB9", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $390fab4fbdc15873$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $390fab4fbdc15873$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsLegend = void 0;

var $390fab4fbdc15873$var$_objectWithoutPropertiesLoose2 = $390fab4fbdc15873$require$_interopRequireDefault((parcelRequire("c05no")));

var $390fab4fbdc15873$var$_extends2 = $390fab4fbdc15873$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $390fab4fbdc15873$var$React = $390fab4fbdc15873$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $390fab4fbdc15873$var$_propTypes = $390fab4fbdc15873$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $390fab4fbdc15873$var$_clsx = $390fab4fbdc15873$require$_interopRequireDefault((parcelRequire("9QePP")));

var $390fab4fbdc15873$var$_useEventCallback = $390fab4fbdc15873$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $8su7q = parcelRequire("8su7q");

var $ip5yP = parcelRequire("ip5yP");

var $eN2yV = parcelRequire("eN2yV");

var $60bWu = parcelRequire("60bWu");

var $o7DH0 = parcelRequire("o7DH0");

var $kUHUZ = parcelRequire("kUHUZ");

var $6hQTT = parcelRequire("6hQTT");

var $fgykb = parcelRequire("fgykb");

var $d3mgr = parcelRequire("d3mgr");

var $1k3ob = parcelRequire("1k3ob");

var $ayMG0 = parcelRequire("ayMG0");
const $390fab4fbdc15873$var$_excluded = [
    "direction",
    "onItemClick",
    "className",
    "classes",
    "toggleVisibilityOnClick"
];
const $390fab4fbdc15873$var$RootElement = (0, $8xDHs.styled)('ul', {
    name: 'MuiChartsLegend',
    slot: 'Root'
})(({ ownerState: ownerState, theme: theme })=>(0, $390fab4fbdc15873$var$_extends2.default)({}, theme.typography.caption, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '100%',
        display: 'flex',
        flexDirection: ownerState.direction === 'vertical' ? 'column' : 'row',
        alignItems: ownerState.direction === 'vertical' ? undefined : 'center',
        flexShrink: 0,
        gap: theme.spacing(2),
        listStyleType: 'none',
        paddingInlineStart: 0,
        marginBlock: theme.spacing(1),
        marginInline: theme.spacing(1),
        flexWrap: 'wrap',
        li: {
            display: ownerState.direction === 'horizontal' ? 'inline-flex' : undefined
        },
        [`button.${$60bWu.legendClasses.series}`]: {
            // Reset button styles
            background: 'none',
            border: 'none',
            padding: 0,
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            letterSpacing: 'inherit',
            color: 'inherit'
        },
        [`& .${$60bWu.legendClasses.series}`]: {
            display: ownerState.direction === 'vertical' ? 'flex' : 'inline-flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            cursor: ownerState.onItemClick || ownerState.toggleVisibilityOnClick ? 'pointer' : 'default',
            [`&.${$60bWu.legendClasses.hidden}`]: {
                opacity: 0.5
            }
        },
        gridArea: 'legend'
    }));
const $390fab4fbdc15873$var$ChartsLegend = module.exports.ChartsLegend = (0, $o7DH0.consumeSlots)('MuiChartsLegend', 'legend', {
    defaultProps: {
        direction: 'horizontal'
    },
    // @ts-expect-error position is used only in the slots, but it is passed to the SVG wrapper.
    // We omit it here to avoid passing to slots.
    omitProps: [
        'position'
    ],
    classesResolver: $60bWu.useUtilityClasses
}, /*#__PURE__*/ $390fab4fbdc15873$var$React.forwardRef(function ChartsLegend(props, ref) {
    const data = (0, $8su7q.useLegend)();
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const store = (0, $d3mgr.useStore)();
    const seriesConfig = store.use($1k3ob.selectorChartSeriesConfig);
    const isItemVisible = store.use($fgykb.selectorIsItemVisibleGetter);
    const { onItemClick: onItemClick, className: className, classes: classes, toggleVisibilityOnClick: toggleVisibilityOnClick } = props, other = (0, $390fab4fbdc15873$var$_objectWithoutPropertiesLoose2.default)(props, $390fab4fbdc15873$var$_excluded);
    const isButton = Boolean(onItemClick || toggleVisibilityOnClick);
    const Element = isButton ? 'button' : 'div';
    const handleClick = (0, $390fab4fbdc15873$var$_useEventCallback.default)((item, i)=>(event)=>{
            if (onItemClick && item) onItemClick(event, (0, $eN2yV.seriesContextBuilder)(item), i);
            if (toggleVisibilityOnClick) instance.toggleItemVisibility({
                // TODO: Remove in v9
                // @ts-expect-error item always has type defined.
                type: item.type,
                seriesId: item.seriesId,
                dataIndex: item.dataIndex
            });
        });
    if (data.items.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($390fab4fbdc15873$var$RootElement, (0, $390fab4fbdc15873$var$_extends2.default)({
        className: (0, $390fab4fbdc15873$var$_clsx.default)(classes?.root, className),
        ref: ref
    }, other, {
        ownerState: props,
        children: data.items.map((item, i)=>{
            const isVisible = isItemVisible(seriesConfig, {
                // TODO: Remove in v9
                // @ts-expect-error item always has type defined.
                type: item.type,
                seriesId: item.seriesId,
                dataIndex: item.dataIndex
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: classes?.item,
                "data-series": item.seriesId,
                "data-index": item.dataIndex,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Element, {
                    className: (0, $390fab4fbdc15873$var$_clsx.default)(classes?.series, !isVisible && classes?.hidden),
                    role: isButton ? 'button' : undefined,
                    type: isButton ? 'button' : undefined,
                    onClick: isButton ? handleClick(item, i) : undefined,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ip5yP.ChartsLabelMark, {
                            className: classes?.mark,
                            color: item.color,
                            type: item.markType
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($kUHUZ.ChartsLabel, {
                            className: classes?.label,
                            children: item.label
                        })
                    ]
                })
            }, `${item.seriesId}-${item.dataIndex}`);
        })
    }));
}));

});
parcelRegister("eN2yV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seriesContextBuilder = void 0;
const $ac47a118c8aed9c9$var$seriesContextBuilder = (context)=>({
        type: 'series',
        color: context.color,
        label: context.label,
        seriesId: context.seriesId,
        itemId: context.itemId,
        dataIndex: context.dataIndex
    });
module.exports.seriesContextBuilder = $ac47a118c8aed9c9$var$seriesContextBuilder;

});

parcelRegister("60bWu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $45ec01a60ad4ef64$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useUtilityClasses = module.exports.legendClasses = void 0;

var $45ec01a60ad4ef64$var$_generateUtilityClass = $45ec01a60ad4ef64$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $45ec01a60ad4ef64$var$_generateUtilityClasses = $45ec01a60ad4ef64$require$_interopRequireDefault((parcelRequire("5nY49")));

var $45ec01a60ad4ef64$var$_composeClasses = $45ec01a60ad4ef64$require$_interopRequireDefault((parcelRequire("3Hg1x")));
function $45ec01a60ad4ef64$var$getLegendUtilityClass(slot) {
    return (0, $45ec01a60ad4ef64$var$_generateUtilityClass.default)('MuiChartsLegend', slot);
}
const $45ec01a60ad4ef64$var$useUtilityClasses = (props)=>{
    const { classes: classes, direction: direction } = props;
    const slots = {
        root: [
            'root',
            direction
        ],
        item: [
            'item'
        ],
        mark: [
            'mark'
        ],
        label: [
            'label'
        ],
        series: [
            'series'
        ],
        hidden: [
            'hidden'
        ]
    };
    return (0, $45ec01a60ad4ef64$var$_composeClasses.default)(slots, $45ec01a60ad4ef64$var$getLegendUtilityClass, classes);
};
module.exports.useUtilityClasses = $45ec01a60ad4ef64$var$useUtilityClasses;
const $45ec01a60ad4ef64$var$legendClasses = module.exports.legendClasses = (0, $45ec01a60ad4ef64$var$_generateUtilityClasses.default)('MuiChartsLegend', [
    'root',
    'item',
    'series',
    'mark',
    'label',
    'vertical',
    'horizontal',
    'hidden'
]);

});

parcelRegister("o7DH0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $04882afe218b2722$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $04882afe218b2722$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.consumeSlots = void 0;

var $04882afe218b2722$var$_extends2 = $04882afe218b2722$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $04882afe218b2722$var$_objectWithoutPropertiesLoose2 = $04882afe218b2722$require$_interopRequireDefault((parcelRequire("c05no")));

var $8xDHs = parcelRequire("8xDHs");

var $04882afe218b2722$var$_resolveProps = $04882afe218b2722$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $04882afe218b2722$var$_useSlotProps2 = $04882afe218b2722$require$_interopRequireDefault((parcelRequire("839K0")));

var $04882afe218b2722$var$React = $04882afe218b2722$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $04882afe218b2722$var$_excluded = [
    "slots",
    "slotProps"
], $04882afe218b2722$var$_excluded2 = [
    "ownerState"
];
/**
 * A higher order component that consumes a slot from the props and renders the component provided in the slot.
 *
 * This HOC will wrap a single component, and will render the component provided in the slot, if it exists.
 *
 * If you need to render multiple components, you can manually consume the slots from the props and render them in your component instead of using this HOC.
 *
 * In the example below, `MyComponent` will render the component provided in `mySlot` slot, if it exists. Otherwise, it will render the `DefaultComponent`.
 *
 * @example
 *
 * ```tsx
 * type MyComponentProps = {
 *   direction: 'row' | 'column';
 *   slots?: {
 *     mySlot?: React.JSXElementConstructor<{ direction: 'row' | 'column' }>;
 *   }
 * };
 *
 * const MyComponent = consumeSlots(
 *   'MuiMyComponent',
 *   'mySlot',
 *   function DefaultComponent(props: MyComponentProps) {
 *     return (
 *       <div className={props.classes.root}>
 *         {props.direction}
 *       </div>
 *     );
 *   }
 * );
 * ```
 *
 * @param {string} name The mui component name.
 * @param {string} slotPropName The name of the prop to retrieve the slot from.
 * @param {object} options Options for the HOC.
 * @param {boolean} options.propagateSlots Whether to propagate the slots to the component, this is always false if the slot is provided.
 * @param {Record<string, any>} options.defaultProps A set of defaults for the component, will be deep merged with the props.
 * @param {Array<keyof Props>} options.omitProps An array of props to omit from the component.
 * @param {Function} options.classesResolver A function that returns the classes for the component. It receives the props, after theme props and defaults have been applied. And the theme object as the second argument.
 * @param InComponent The component to render if the slot is not provided.
 */ const $04882afe218b2722$var$consumeSlots = (name, slotPropName, options, InComponent)=>{
    function ConsumeSlotsInternal(props, ref) {
        const themedProps = (0, $8xDHs.useThemeProps)({
            props: props,
            name: // eslint-disable-next-line material-ui/mui-name-matches-component-name
            name
        });
        const defaultProps = typeof options.defaultProps === 'function' ? options.defaultProps(themedProps) : options.defaultProps ?? {};
        const defaultizedProps = (0, $04882afe218b2722$var$_resolveProps.default)(defaultProps, themedProps);
        const _ref = defaultizedProps, { slots: slots, slotProps: slotProps } = _ref, other = (0, $04882afe218b2722$var$_objectWithoutPropertiesLoose2.default)(_ref, $04882afe218b2722$var$_excluded);
        const theme = (0, $8xDHs.useTheme)();
        const classes = options.classesResolver?.(defaultizedProps, theme);
        // Can be a function component or a forward ref component.
        const Component = slots?.[slotPropName] ?? InComponent;
        const propagateSlots = options.propagateSlots && !slots?.[slotPropName];
        const _useSlotProps = (0, $04882afe218b2722$var$_useSlotProps2.default)({
            elementType: Component,
            externalSlotProps: slotProps?.[slotPropName],
            additionalProps: (0, $04882afe218b2722$var$_extends2.default)({}, other, {
                classes: classes
            }, propagateSlots && {
                slots: slots,
                slotProps: slotProps
            }),
            ownerState: {}
        }), originalOutProps = (0, $04882afe218b2722$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $04882afe218b2722$var$_excluded2);
        const outProps = (0, $04882afe218b2722$var$_extends2.default)({}, originalOutProps);
        for (const prop of options.omitProps ?? [])delete outProps[prop];
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $04882afe218b2722$var$_extends2.default)({}, outProps, {
            ref: ref
        }));
    }
    return /*#__PURE__*/ $04882afe218b2722$var$React.forwardRef(ConsumeSlotsInternal);
};
module.exports.consumeSlots = $04882afe218b2722$var$consumeSlots;

});

parcelRegister("kUHUZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f39b1adaa5c24991$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f39b1adaa5c24991$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsLabel = void 0;

var $f39b1adaa5c24991$var$_extends2 = $f39b1adaa5c24991$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f39b1adaa5c24991$var$_objectWithoutPropertiesLoose2 = $f39b1adaa5c24991$require$_interopRequireDefault((parcelRequire("c05no")));

var $f39b1adaa5c24991$var$React = $f39b1adaa5c24991$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f39b1adaa5c24991$var$_propTypes = $f39b1adaa5c24991$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f39b1adaa5c24991$var$_clsx = $f39b1adaa5c24991$require$_interopRequireDefault((parcelRequire("9QePP")));

var $kNQif = parcelRequire("kNQif");

var $7Ry4U = parcelRequire("7Ry4U");

var $ayMG0 = parcelRequire("ayMG0");
const $f39b1adaa5c24991$var$_excluded = [
    "children",
    "className",
    "classes"
];
/**
 * Generates the label mark for the tooltip and legend.
 * @ignore - internal component.
 */ const $f39b1adaa5c24991$var$ChartsLabel = module.exports.ChartsLabel = (0, $7Ry4U.consumeThemeProps)('MuiChartsLabel', {
    classesResolver: $kNQif.useUtilityClasses
}, function ChartsLabel(props, ref) {
    const { children: children, className: className, classes: classes } = props, other = (0, $f39b1adaa5c24991$var$_objectWithoutPropertiesLoose2.default)(props, $f39b1adaa5c24991$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", (0, $f39b1adaa5c24991$var$_extends2.default)({
        className: (0, $f39b1adaa5c24991$var$_clsx.default)(classes?.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});

});
parcelRegister("kNQif", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f250f299f62a65ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLabelUtilityClass = $f250f299f62a65ab$var$getLabelUtilityClass;
module.exports.useUtilityClasses = module.exports.labelClasses = void 0;

var $f250f299f62a65ab$var$_composeClasses = $f250f299f62a65ab$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $f250f299f62a65ab$var$_generateUtilityClass = $f250f299f62a65ab$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $f250f299f62a65ab$var$_generateUtilityClasses = $f250f299f62a65ab$require$_interopRequireDefault((parcelRequire("5nY49")));
function $f250f299f62a65ab$var$getLabelUtilityClass(slot) {
    return (0, $f250f299f62a65ab$var$_generateUtilityClass.default)('MuiChartsLabel', slot);
}
const $f250f299f62a65ab$var$labelClasses = module.exports.labelClasses = (0, $f250f299f62a65ab$var$_generateUtilityClasses.default)('MuiChartsLabel', [
    'root'
]);
const $f250f299f62a65ab$var$useUtilityClasses = (props)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $f250f299f62a65ab$var$_composeClasses.default)(slots, $f250f299f62a65ab$var$getLabelUtilityClass, props.classes);
};
module.exports.useUtilityClasses = $f250f299f62a65ab$var$useUtilityClasses;

});



parcelRegister("cODcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lpz6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("31rFk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5UbQc", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $44cb5e11fad23971$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $44cb5e11fad23971$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContinuousColorLegend = void 0;

var $44cb5e11fad23971$var$_objectWithoutPropertiesLoose2 = $44cb5e11fad23971$require$_interopRequireDefault((parcelRequire("c05no")));

var $44cb5e11fad23971$var$_extends2 = $44cb5e11fad23971$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $44cb5e11fad23971$var$React = $44cb5e11fad23971$require$_interopRequireWildcard((parcelRequire("acw62")));

var $44cb5e11fad23971$var$_propTypes = $44cb5e11fad23971$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $44cb5e11fad23971$var$_clsx = $44cb5e11fad23971$require$_interopRequireDefault((parcelRequire("9QePP")));

var $apPa9 = parcelRequire("apPa9");

var $kUHUZ = parcelRequire("kUHUZ");

var $llVQO = parcelRequire("llVQO");

var $7Ry4U = parcelRequire("7Ry4U");

var $kiBdc = parcelRequire("kiBdc");

var $eq62P = parcelRequire("eq62P");

var $ayMG0 = parcelRequire("ayMG0");
const $44cb5e11fad23971$var$_excluded = [
    "minLabel",
    "maxLabel",
    "direction",
    "axisDirection",
    "axisId",
    "rotateGradient",
    "reverse",
    "classes",
    "className",
    "gradientId",
    "labelPosition",
    "thickness"
];
const $44cb5e11fad23971$var$templateAreas = (reverse)=>{
    const startLabel = reverse ? 'max-label' : 'min-label';
    const endLabel = reverse ? 'min-label' : 'max-label';
    return {
        row: {
            start: `
    '${startLabel} . ${endLabel}'
    'gradient gradient gradient'
  `,
            end: `
      'gradient gradient gradient'
      '${startLabel} . ${endLabel}'
    `,
            extremes: `
      '${startLabel} gradient ${endLabel}'
    `
        },
        column: {
            start: `
      '${endLabel} gradient'
      '. gradient'
      '${startLabel} gradient'
    `,
            end: `
      'gradient ${endLabel}'
      'gradient .'
      'gradient ${startLabel}'
    `,
            extremes: `
      '${endLabel}'
      'gradient'
      '${startLabel}'
    `
        }
    };
};
const $44cb5e11fad23971$var$RootElement = (0, $8xDHs.styled)('ul', {
    name: 'MuiContinuousColorLegend',
    slot: 'Root'
})(({ theme: theme, ownerState: ownerState })=>(0, $44cb5e11fad23971$var$_extends2.default)({}, theme.typography.caption, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '100%',
        display: 'grid',
        flexShrink: 0,
        gap: theme.spacing(0.5),
        listStyleType: 'none',
        paddingInlineStart: 0,
        marginBlock: theme.spacing(1),
        marginInline: theme.spacing(1),
        gridArea: 'legend',
        [`&.${$kiBdc.continuousColorLegendClasses.horizontal}`]: {
            gridTemplateRows: 'min-content min-content',
            gridTemplateColumns: 'min-content auto min-content',
            [`&.${$kiBdc.continuousColorLegendClasses.start}`]: {
                gridTemplateAreas: $44cb5e11fad23971$var$templateAreas(ownerState.reverse).row.start
            },
            [`&.${$kiBdc.continuousColorLegendClasses.end}`]: {
                gridTemplateAreas: $44cb5e11fad23971$var$templateAreas(ownerState.reverse).row.end
            },
            [`&.${$kiBdc.continuousColorLegendClasses.extremes}`]: {
                gridTemplateAreas: $44cb5e11fad23971$var$templateAreas(ownerState.reverse).row.extremes,
                gridTemplateRows: 'min-content',
                alignItems: 'center'
            }
        },
        [`&.${$kiBdc.continuousColorLegendClasses.vertical}`]: {
            gridTemplateRows: 'min-content auto min-content',
            gridTemplateColumns: 'min-content min-content',
            [`&.${$kiBdc.continuousColorLegendClasses.start}`]: {
                gridTemplateAreas: $44cb5e11fad23971$var$templateAreas(ownerState.reverse).column.start,
                [`.${$kiBdc.continuousColorLegendClasses.maxLabel}, .${$kiBdc.continuousColorLegendClasses.minLabel}`]: {
                    justifySelf: 'end'
                }
            },
            [`&.${$kiBdc.continuousColorLegendClasses.end}`]: {
                gridTemplateAreas: $44cb5e11fad23971$var$templateAreas(ownerState.reverse).column.end,
                [`.${$kiBdc.continuousColorLegendClasses.maxLabel}, .${$kiBdc.continuousColorLegendClasses.minLabel}`]: {
                    justifySelf: 'start'
                }
            },
            [`&.${$kiBdc.continuousColorLegendClasses.extremes}`]: {
                gridTemplateAreas: $44cb5e11fad23971$var$templateAreas(ownerState.reverse).column.extremes,
                gridTemplateColumns: 'min-content',
                [`.${$kiBdc.continuousColorLegendClasses.maxLabel}, .${$kiBdc.continuousColorLegendClasses.minLabel}`]: {
                    justifySelf: 'center'
                }
            }
        },
        [`.${$kiBdc.continuousColorLegendClasses.gradient}`]: {
            gridArea: 'gradient'
        },
        [`.${$kiBdc.continuousColorLegendClasses.maxLabel}`]: {
            gridArea: 'max-label'
        },
        [`.${$kiBdc.continuousColorLegendClasses.minLabel}`]: {
            gridArea: 'min-label'
        }
    }));
const $44cb5e11fad23971$var$getText = (label, value, formattedValue)=>{
    if (typeof label === 'string') return label;
    return label?.({
        value: value,
        formattedValue: formattedValue
    }) ?? formattedValue;
};
const $44cb5e11fad23971$var$isZAxis = (axis)=>axis.scale === undefined;
const $44cb5e11fad23971$var$ContinuousColorLegend = module.exports.ContinuousColorLegend = (0, $7Ry4U.consumeThemeProps)('MuiContinuousColorLegend', {
    defaultProps: {
        direction: 'horizontal',
        labelPosition: 'end',
        axisDirection: 'z'
    },
    classesResolver: $kiBdc.useUtilityClasses
}, function ContinuousColorLegend(props, ref) {
    const { minLabel: minLabel, maxLabel: maxLabel, direction: direction, axisDirection: axisDirection, axisId: axisId, rotateGradient: rotateGradient, reverse: reverse, classes: classes, className: className, gradientId: gradientId, thickness: thickness } = props, other = (0, $44cb5e11fad23971$var$_objectWithoutPropertiesLoose2.default)(props, $44cb5e11fad23971$var$_excluded);
    const generateGradientId = (0, $eq62P.useChartGradientIdObjectBoundBuilder)();
    const axisItem = (0, $apPa9.useAxis)({
        axisDirection: axisDirection,
        axisId: axisId
    });
    const colorMap = axisItem?.colorMap;
    if (!colorMap || !colorMap.type || colorMap.type !== 'continuous') return null;
    const minValue = colorMap.min ?? 0;
    const maxValue = colorMap.max ?? 100;
    // Get texts to display
    const valueFormatter = $44cb5e11fad23971$var$isZAxis(axisItem) ? undefined : axisItem.valueFormatter;
    const formattedMin = valueFormatter ? valueFormatter(minValue, {
        location: 'legend'
    }) : minValue.toLocaleString();
    const formattedMax = valueFormatter ? valueFormatter(maxValue, {
        location: 'legend'
    }) : maxValue.toLocaleString();
    const minText = $44cb5e11fad23971$var$getText(minLabel, minValue, formattedMin);
    const maxText = $44cb5e11fad23971$var$getText(maxLabel, maxValue, formattedMax);
    const minComponent = /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: classes?.minLabel,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($kUHUZ.ChartsLabel, {
            className: classes?.label,
            children: minText
        })
    });
    const maxComponent = /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        className: classes?.maxLabel,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($kUHUZ.ChartsLabel, {
            className: classes?.label,
            children: maxText
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($44cb5e11fad23971$var$RootElement, (0, $44cb5e11fad23971$var$_extends2.default)({
        className: (0, $44cb5e11fad23971$var$_clsx.default)(classes?.root, className),
        ref: ref
    }, other, {
        ownerState: props,
        children: [
            reverse ? maxComponent : minComponent,
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: classes?.gradient,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($llVQO.ChartsLabelGradient, {
                    direction: direction,
                    rotate: rotateGradient,
                    reverse: reverse,
                    thickness: thickness,
                    gradientId: gradientId ?? generateGradientId(axisItem.id)
                })
            }),
            reverse ? minComponent : maxComponent
        ]
    }));
});

});
parcelRegister("apPa9", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAxis = $7953ed050e2616bf$var$useAxis;

var $9qhH3 = parcelRequire("9qhH3");

var $55Xcx = parcelRequire("55Xcx");
/**
 * Helper to select an axis definition according to its direction and id.
 */ function $7953ed050e2616bf$var$useAxis({ axisDirection: axisDirection, axisId: axisId }) {
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55Xcx.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55Xcx.useYAxes)();
    const { zAxis: zAxis, zAxisIds: zAxisIds } = (0, $9qhH3.useZAxes)();
    switch(axisDirection){
        case 'x':
            {
                const id = typeof axisId === 'string' ? axisId : xAxisIds[axisId ?? 0];
                return xAxis[id];
            }
        case 'y':
            {
                const id = typeof axisId === 'string' ? axisId : yAxisIds[axisId ?? 0];
                return yAxis[id];
            }
        case 'z':
        default:
            {
                const id = typeof axisId === 'string' ? axisId : zAxisIds[axisId ?? 0];
                return zAxis[id];
            }
    }
}

});

parcelRegister("llVQO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f8b86f1d58de482d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f8b86f1d58de482d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsLabelGradient = void 0;

var $f8b86f1d58de482d$var$_extends2 = $f8b86f1d58de482d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f8b86f1d58de482d$var$_objectWithoutPropertiesLoose2 = $f8b86f1d58de482d$require$_interopRequireDefault((parcelRequire("c05no")));

var $f8b86f1d58de482d$var$React = $f8b86f1d58de482d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f8b86f1d58de482d$var$_propTypes = $f8b86f1d58de482d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $f8b86f1d58de482d$var$_clsx = $f8b86f1d58de482d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9uEev = parcelRequire("9uEev");

var $gnhSB = parcelRequire("gnhSB");

var $7Ry4U = parcelRequire("7Ry4U");

var $ayMG0 = parcelRequire("ayMG0");
const $f8b86f1d58de482d$var$_excluded = [
    "gradientId",
    "direction",
    "classes",
    "className",
    "rotate",
    "reverse",
    "thickness"
];
const $f8b86f1d58de482d$var$getRotation = (direction, reverse, rotate, isRtl)=>{
    const angle = (direction === 'vertical' ? -90 : 0) + (rotate ? 90 : 0) + (reverse ? 180 : 0);
    if (isRtl && direction !== 'vertical') return angle + 180;
    return angle;
};
const $f8b86f1d58de482d$var$Root = (0, $8xDHs.styled)('div', {
    name: 'MuiChartsLabelGradient',
    slot: 'Root'
})(({ ownerState: ownerState })=>{
    const rotation = $f8b86f1d58de482d$var$getRotation(ownerState.direction, ownerState.reverse, ownerState.rotate, ownerState.isRtl);
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [`.${$gnhSB.labelGradientClasses.mask}`]: {
            borderRadius: 2,
            overflow: 'hidden'
        },
        [`&.${$gnhSB.labelGradientClasses.horizontal}`]: {
            width: '100%',
            [`.${$gnhSB.labelGradientClasses.mask}`]: {
                height: ownerState.thickness,
                width: '100%'
            }
        },
        [`&.${$gnhSB.labelGradientClasses.vertical}`]: {
            height: '100%',
            [`.${$gnhSB.labelGradientClasses.mask}`]: {
                width: ownerState.thickness,
                height: '100%',
                '> svg': {
                    height: '100%'
                }
            }
        },
        svg: {
            transform: `rotate(${rotation}deg)`,
            display: 'block'
        }
    };
});
/**
 * Generates the label Gradient for the tooltip and legend.
 * @ignore - internal component.
 */ const $f8b86f1d58de482d$var$ChartsLabelGradient = module.exports.ChartsLabelGradient = (0, $7Ry4U.consumeThemeProps)('MuiChartsLabelGradient', {
    defaultProps: {
        direction: 'horizontal',
        thickness: 12
    },
    classesResolver: $gnhSB.useUtilityClasses
}, function ChartsLabelGradient(props, ref) {
    const { gradientId: gradientId, classes: classes, className: className } = props, other = (0, $f8b86f1d58de482d$var$_objectWithoutPropertiesLoose2.default)(props, $f8b86f1d58de482d$var$_excluded);
    const isRtl = (0, $9uEev.useRtl)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f8b86f1d58de482d$var$Root, (0, $f8b86f1d58de482d$var$_extends2.default)({
        className: (0, $f8b86f1d58de482d$var$_clsx.default)(classes?.root, className),
        ownerState: (0, $f8b86f1d58de482d$var$_extends2.default)({}, props, {
            isRtl: isRtl
        }),
        "aria-hidden": "true",
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: classes?.mask,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    className: classes?.fill,
                    width: "24",
                    height: "24",
                    fill: `url(#${gradientId})`
                })
            })
        })
    }));
});

});
parcelRegister("gnhSB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bebca9dfc098b49e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLabelGradientUtilityClass = $bebca9dfc098b49e$var$getLabelGradientUtilityClass;
module.exports.useUtilityClasses = module.exports.labelGradientClasses = void 0;

var $bebca9dfc098b49e$var$_composeClasses = $bebca9dfc098b49e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bebca9dfc098b49e$var$_generateUtilityClass = $bebca9dfc098b49e$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $bebca9dfc098b49e$var$_generateUtilityClasses = $bebca9dfc098b49e$require$_interopRequireDefault((parcelRequire("5nY49")));
function $bebca9dfc098b49e$var$getLabelGradientUtilityClass(slot) {
    return (0, $bebca9dfc098b49e$var$_generateUtilityClass.default)('MuiChartsLabelGradient', slot);
}
const $bebca9dfc098b49e$var$labelGradientClasses = module.exports.labelGradientClasses = (0, $bebca9dfc098b49e$var$_generateUtilityClasses.default)('MuiChartsLabelGradient', [
    'root',
    'vertical',
    'horizontal',
    'mask',
    'fill'
]);
const $bebca9dfc098b49e$var$useUtilityClasses = (props)=>{
    const { direction: direction } = props;
    const slots = {
        root: [
            'root',
            direction
        ],
        mask: [
            'mask'
        ],
        fill: [
            'fill'
        ]
    };
    return (0, $bebca9dfc098b49e$var$_composeClasses.default)(slots, $bebca9dfc098b49e$var$getLabelGradientUtilityClass, props.classes);
};
module.exports.useUtilityClasses = $bebca9dfc098b49e$var$useUtilityClasses;

});


parcelRegister("kiBdc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ec725a92f100ded2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useUtilityClasses = module.exports.continuousColorLegendClasses = void 0;

var $ec725a92f100ded2$var$_generateUtilityClass = $ec725a92f100ded2$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $ec725a92f100ded2$var$_generateUtilityClasses = $ec725a92f100ded2$require$_interopRequireDefault((parcelRequire("5nY49")));

var $ec725a92f100ded2$var$_composeClasses = $ec725a92f100ded2$require$_interopRequireDefault((parcelRequire("3Hg1x")));
function $ec725a92f100ded2$var$getLegendUtilityClass(slot) {
    return (0, $ec725a92f100ded2$var$_generateUtilityClass.default)('MuiContinuousColorLegend', slot);
}
const $ec725a92f100ded2$var$useUtilityClasses = (props)=>{
    const { classes: classes, direction: direction, labelPosition: labelPosition } = props;
    const slots = {
        root: [
            'root',
            direction,
            labelPosition
        ],
        minLabel: [
            'minLabel'
        ],
        maxLabel: [
            'maxLabel'
        ],
        gradient: [
            'gradient'
        ],
        mark: [
            'mark'
        ],
        label: [
            'label'
        ]
    };
    return (0, $ec725a92f100ded2$var$_composeClasses.default)(slots, $ec725a92f100ded2$var$getLegendUtilityClass, classes);
};
module.exports.useUtilityClasses = $ec725a92f100ded2$var$useUtilityClasses;
const $ec725a92f100ded2$var$continuousColorLegendClasses = module.exports.continuousColorLegendClasses = (0, $ec725a92f100ded2$var$_generateUtilityClasses.default)('MuiContinuousColorLegend', [
    'root',
    'minLabel',
    'maxLabel',
    'gradient',
    'vertical',
    'horizontal',
    'start',
    'end',
    'extremes',
    'label'
]);

});


parcelRegister("gOzFG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4jbBo", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $3231efb28228257a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $3231efb28228257a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PiecewiseColorLegend = void 0;

var $3231efb28228257a$var$_objectWithoutPropertiesLoose2 = $3231efb28228257a$require$_interopRequireDefault((parcelRequire("c05no")));

var $3231efb28228257a$var$_extends2 = $3231efb28228257a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3231efb28228257a$var$React = $3231efb28228257a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3231efb28228257a$var$_propTypes = $3231efb28228257a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $3231efb28228257a$var$_clsx = $3231efb28228257a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $kUHUZ = parcelRequire("kUHUZ");

var $ip5yP = parcelRequire("ip5yP");

var $7Ry4U = parcelRequire("7Ry4U");

var $4QdBg = parcelRequire("4QdBg");

var $apPa9 = parcelRequire("apPa9");

var $81lIb = parcelRequire("81lIb");

var $ayMG0 = parcelRequire("ayMG0");
const $3231efb28228257a$var$_excluded = [
    "direction",
    "classes",
    "className",
    "markType",
    "labelPosition",
    "axisDirection",
    "axisId",
    "labelFormatter",
    "onItemClick"
];
const $3231efb28228257a$var$RootElement = (0, $8xDHs.styled)('ul', {
    name: 'MuiPiecewiseColorLegend',
    slot: 'Root'
})(({ theme: theme, ownerState: ownerState })=>{
    const classes = $4QdBg.piecewiseColorLegendClasses;
    return (0, $3231efb28228257a$var$_extends2.default)({}, theme.typography.caption, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '100%',
        display: 'flex',
        flexDirection: ownerState.direction === 'vertical' ? 'column' : 'row',
        flexShrink: 0,
        gap: theme.spacing(0.5),
        listStyleType: 'none',
        paddingInlineStart: 0,
        marginBlock: theme.spacing(1),
        marginInline: theme.spacing(1),
        width: 'fit-content',
        gridArea: 'legend',
        [`button.${classes.item}`]: {
            // Reset button styles
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: ownerState.onItemClick ? 'pointer' : 'unset',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            letterSpacing: 'inherit',
            color: 'inherit'
        },
        [`.${classes.item}`]: {
            display: 'flex',
            gap: theme.spacing(0.5)
        },
        [`li :not(.${classes.minLabel}, .${classes.maxLabel}) .${classes?.mark}`]: {
            alignSelf: 'center'
        },
        [`&.${classes.start}`]: {
            alignItems: 'end'
        },
        [`&.${classes.end}`]: {
            alignItems: 'start'
        },
        [`&.${classes.horizontal}`]: {
            alignItems: 'center',
            [`.${classes.item}`]: {
                flexDirection: 'column'
            },
            [`&.${classes.inlineStart}, &.${classes.inlineEnd}`]: {
                gap: theme.spacing(1.5),
                flexWrap: 'wrap',
                [`.${classes.item}`]: {
                    flexDirection: 'row'
                }
            },
            [`&.${classes.start}`]: {
                alignItems: 'end'
            },
            [`&.${classes.end}`]: {
                alignItems: 'start'
            },
            [`.${classes.minLabel}`]: {
                alignItems: 'end'
            },
            [`&.${classes.extremes}`]: {
                [`.${classes.minLabel}, .${classes.maxLabel}`]: {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row'
                }
            }
        },
        [`&.${classes.vertical}`]: {
            [`.${classes.item}`]: {
                flexDirection: 'row',
                alignItems: 'center'
            },
            [`&.${classes.start}, &.${classes.inlineStart}`]: {
                alignItems: 'end'
            },
            [`&.${classes.end}, &.${classes.inlineEnd}`]: {
                alignItems: 'start'
            },
            [`&.${classes.extremes}`]: {
                alignItems: 'center',
                [`.${classes.minLabel}, .${classes.maxLabel}`]: {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }
        }
    });
});
const $3231efb28228257a$var$PiecewiseColorLegend = module.exports.PiecewiseColorLegend = (0, $7Ry4U.consumeThemeProps)('MuiPiecewiseColorLegend', {
    defaultProps: {
        direction: 'horizontal',
        labelPosition: 'extremes',
        labelFormatter: $81lIb.piecewiseColorDefaultLabelFormatter
    },
    classesResolver: $4QdBg.useUtilityClasses
}, function PiecewiseColorLegend(props, ref) {
    const { direction: direction, classes: classes, className: className, markType: markType, labelPosition: labelPosition, axisDirection: axisDirection, axisId: axisId, labelFormatter: labelFormatter, onItemClick: onItemClick } = props, other = (0, $3231efb28228257a$var$_objectWithoutPropertiesLoose2.default)(props, $3231efb28228257a$var$_excluded);
    const isVertical = direction === 'vertical';
    const isReverse = isVertical;
    const axisItem = (0, $apPa9.useAxis)({
        axisDirection: axisDirection,
        axisId: axisId
    });
    const colorMap = axisItem?.colorMap;
    if (!colorMap || !colorMap.type || colorMap.type !== 'piecewise') return null;
    const valueFormatter = (v)=>axisItem.valueFormatter?.(v, {
            location: 'legend'
        }) ?? v.toLocaleString();
    const formattedLabels = colorMap.thresholds.map(valueFormatter);
    const startClass = isReverse ? classes?.maxLabel : classes?.minLabel;
    const endClass = isReverse ? classes?.minLabel : classes?.maxLabel;
    const colors = colorMap.colors.map((color, colorIndex)=>({
            color: color,
            colorIndex: colorIndex
        }));
    const orderedColors = isReverse ? colors.reverse() : colors;
    const isStart = labelPosition === 'start';
    const isEnd = labelPosition === 'end';
    const isExtremes = labelPosition === 'extremes';
    const isInlineStart = labelPosition === 'inline-start';
    const isInlineEnd = labelPosition === 'inline-end';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3231efb28228257a$var$RootElement, (0, $3231efb28228257a$var$_extends2.default)({
        className: (0, $3231efb28228257a$var$_clsx.default)(classes?.root, className),
        ref: ref
    }, other, {
        ownerState: props,
        children: orderedColors.map(({ color: color, colorIndex: colorIndex }, index)=>{
            const isFirst = index === 0;
            const isLast = index === colorMap.colors.length - 1;
            const isFirstColor = colorIndex === 0;
            const isLastColor = colorIndex === colorMap.colors.length - 1;
            const data = (0, $3231efb28228257a$var$_extends2.default)({
                index: colorIndex,
                length: formattedLabels.length
            }, isFirstColor ? {
                min: null,
                formattedMin: null
            } : {
                min: colorMap.thresholds[colorIndex - 1],
                formattedMin: formattedLabels[colorIndex - 1]
            }, isLastColor ? {
                max: null,
                formattedMax: null
            } : {
                max: colorMap.thresholds[colorIndex],
                formattedMax: formattedLabels[colorIndex]
            });
            const label = labelFormatter?.(data);
            if (label === null || label === undefined) return null;
            const isTextBefore = isStart || isExtremes && isFirst || isInlineStart;
            const isTextAfter = isEnd || isExtremes && isLast || isInlineEnd;
            const clickObject = {
                type: 'piecewiseColor',
                color: color,
                label: label,
                minValue: data.min,
                maxValue: data.max
            };
            const Element = onItemClick ? 'button' : 'div';
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Element, {
                    role: onItemClick ? 'button' : undefined,
                    type: onItemClick ? 'button' : undefined,
                    onClick: // @ts-ignore onClick is only attached to a button
                    onItemClick ? (event)=>onItemClick(event, clickObject, index) : undefined,
                    className: (0, $3231efb28228257a$var$_clsx.default)(classes?.item, index === 0 && `${startClass}`, index === orderedColors.length - 1 && `${endClass}`),
                    children: [
                        isTextBefore && /*#__PURE__*/ (0, $ayMG0.jsx)($kUHUZ.ChartsLabel, {
                            className: classes?.label,
                            children: label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ip5yP.ChartsLabelMark, {
                            className: classes?.mark,
                            type: markType,
                            color: color
                        }),
                        isTextAfter && /*#__PURE__*/ (0, $ayMG0.jsx)($kUHUZ.ChartsLabel, {
                            className: classes?.label,
                            children: label
                        })
                    ]
                })
            }, colorIndex);
        })
    }));
});

});
parcelRegister("4QdBg", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $38669172fea1fa7e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useUtilityClasses = module.exports.piecewiseColorLegendClasses = void 0;

var $38669172fea1fa7e$var$_generateUtilityClass = $38669172fea1fa7e$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $38669172fea1fa7e$var$_generateUtilityClasses = $38669172fea1fa7e$require$_interopRequireDefault((parcelRequire("5nY49")));

var $38669172fea1fa7e$var$_composeClasses = $38669172fea1fa7e$require$_interopRequireDefault((parcelRequire("3Hg1x")));
function $38669172fea1fa7e$var$getLegendUtilityClass(slot) {
    return (0, $38669172fea1fa7e$var$_generateUtilityClass.default)('MuiPiecewiseColorLegendClasses', slot);
}
const $38669172fea1fa7e$var$useUtilityClasses = (props)=>{
    const { classes: classes, direction: direction, labelPosition: labelPosition } = props;
    const slots = {
        root: [
            'root',
            direction,
            labelPosition?.replaceAll(/-(\w)/g, (match)=>match[1].toUpperCase())
        ],
        minLabel: [
            'minLabel'
        ],
        maxLabel: [
            'maxLabel'
        ],
        item: [
            'item'
        ],
        mark: [
            'mark'
        ],
        label: [
            'label'
        ]
    };
    return (0, $38669172fea1fa7e$var$_composeClasses.default)(slots, $38669172fea1fa7e$var$getLegendUtilityClass, classes);
};
module.exports.useUtilityClasses = $38669172fea1fa7e$var$useUtilityClasses;
const $38669172fea1fa7e$var$piecewiseColorLegendClasses = module.exports.piecewiseColorLegendClasses = (0, $38669172fea1fa7e$var$_generateUtilityClasses.default)('MuiPiecewiseColorLegendClasses', [
    'root',
    'minLabel',
    'maxLabel',
    'item',
    'vertical',
    'horizontal',
    'start',
    'end',
    'extremes',
    'inlineStart',
    'inlineEnd',
    'mark',
    'label'
]);

});

parcelRegister("81lIb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.piecewiseColorDefaultLabelFormatter = $5d6f42323df10c23$var$piecewiseColorDefaultLabelFormatter;
function $5d6f42323df10c23$var$piecewiseColorDefaultLabelFormatter(params) {
    if (params.min === null) return `<${params.formattedMax}`;
    if (params.max === null) return `>${params.formattedMin}`;
    return `${params.formattedMin}-${params.formattedMax}`;
}

});


parcelRegister("4tc9H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("ad3Dp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fVqHv = parcelRequire("fVqHv");
Object.keys($fVqHv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fVqHv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fVqHv[key];
        }
    });
});

var $jQK7J = parcelRequire("jQK7J");
Object.keys($jQK7J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jQK7J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jQK7J[key];
        }
    });
});

var $eyrV4 = parcelRequire("eyrV4");
Object.keys($eyrV4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $eyrV4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eyrV4[key];
        }
    });
});

var $4mjjX = parcelRequire("4mjjX");
Object.keys($4mjjX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4mjjX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4mjjX[key];
        }
    });
});

});
parcelRegister("fVqHv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b980e41a2a8180e1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b980e41a2a8180e1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsAxisHighlight = $b980e41a2a8180e1$var$ChartsAxisHighlight;

var $b980e41a2a8180e1$var$React = $b980e41a2a8180e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b980e41a2a8180e1$var$_propTypes = $b980e41a2a8180e1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b980e41a2a8180e1$var$_composeClasses = $b980e41a2a8180e1$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $jQK7J = parcelRequire("jQK7J");

var $b980e41a2a8180e1$var$_ChartsYAxisHighlight = $b980e41a2a8180e1$require$_interopRequireDefault((parcelRequire("eWCdW")));

var $b980e41a2a8180e1$var$_ChartsXAxisHighlight = $b980e41a2a8180e1$require$_interopRequireDefault((parcelRequire("jlnOJ")));

var $ayMG0 = parcelRequire("ayMG0");
const $b980e41a2a8180e1$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $b980e41a2a8180e1$var$_composeClasses.default)(slots, $jQK7J.getAxisHighlightUtilityClass);
};
/**
 * Demos:
 *
 * - [Custom components](https://mui.com/x/react-charts/components/)
 *
 * API:
 *
 * - [ChartsAxisHighlight API](https://mui.com/x/api/charts/charts-axis-highlight/)
 */ function $b980e41a2a8180e1$var$ChartsAxisHighlight(props) {
    const { x: xAxisHighlight, y: yAxisHighlight } = props;
    const classes = $b980e41a2a8180e1$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b980e41a2a8180e1$var$React.Fragment, {
        children: [
            xAxisHighlight && xAxisHighlight !== 'none' && /*#__PURE__*/ (0, $ayMG0.jsx)($b980e41a2a8180e1$var$_ChartsXAxisHighlight.default, {
                type: xAxisHighlight,
                classes: classes
            }),
            yAxisHighlight && yAxisHighlight !== 'none' && /*#__PURE__*/ (0, $ayMG0.jsx)($b980e41a2a8180e1$var$_ChartsYAxisHighlight.default, {
                type: yAxisHighlight,
                classes: classes
            })
        ]
    });
}

});
parcelRegister("jQK7J", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e736a6deccddca4f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsAxisHighlightClasses = void 0;
module.exports.getAxisHighlightUtilityClass = $e736a6deccddca4f$var$getAxisHighlightUtilityClass;

var $e736a6deccddca4f$var$_generateUtilityClass = $e736a6deccddca4f$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $e736a6deccddca4f$var$_generateUtilityClasses = $e736a6deccddca4f$require$_interopRequireDefault((parcelRequire("5nY49")));
function $e736a6deccddca4f$var$getAxisHighlightUtilityClass(slot) {
    return (0, $e736a6deccddca4f$var$_generateUtilityClass.default)('MuiChartsAxisHighlight', slot);
}
const $e736a6deccddca4f$var$chartsAxisHighlightClasses = module.exports.chartsAxisHighlightClasses = (0, $e736a6deccddca4f$var$_generateUtilityClasses.default)('MuiChartsAxisHighlight', [
    'root'
]);

});

parcelRegister("eWCdW", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ae1421eac282ae13$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae1421eac282ae13$var$ChartsYHighlight;

var $ae1421eac282ae13$var$React = $ae1421eac282ae13$require$_interopRequireWildcard((parcelRequire("acw62")));

var $kzIRL = parcelRequire("kzIRL");

var $2UPWB = parcelRequire("2UPWB");

var $d3mgr = parcelRequire("d3mgr");

var $a5Dpn = parcelRequire("a5Dpn");

var $55quD = parcelRequire("55quD");

var $4mjjX = parcelRequire("4mjjX");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $ae1421eac282ae13$var$ChartsYHighlight(props) {
    const { type: type, classes: classes } = props;
    const { left: left, width: width } = (0, $55quD.useDrawingArea)();
    const store = (0, $d3mgr.useStore)();
    const axisYValues = store.use($a5Dpn.selectorChartsHighlightYAxisValue);
    const yAxes = store.use($a5Dpn.selectorChartYAxis);
    if (axisYValues.length === 0) return null;
    return axisYValues.map(({ axisId: axisId, value: value })=>{
        const yAxis = yAxes.axis[axisId];
        const yScale = yAxis.scale;
        const getYPosition = (0, $kzIRL.getValueToPositionMapper)(yScale);
        const isYScaleOrdinal = type === 'band' && value !== null && (0, $2UPWB.isOrdinalScale)(yScale);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ae1421eac282ae13$var$React.Fragment, {
            children: [
                isYScaleOrdinal && yScale(value) !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)($4mjjX.ChartsAxisHighlightPath, {
                    d: `M ${left} ${yScale(value) - (yScale.step() - yScale.bandwidth()) / 2} l 0 ${yScale.step()} l ${width} 0 l 0 ${-yScale.step()} Z`,
                    className: classes.root,
                    ownerState: {
                        axisHighlight: 'band'
                    }
                }),
                type === 'line' && value !== null && /*#__PURE__*/ (0, $ayMG0.jsx)($4mjjX.ChartsAxisHighlightPath, {
                    d: `M ${left} ${getYPosition(value)} L ${left + width} ${getYPosition(value)}`,
                    className: classes.root,
                    ownerState: {
                        axisHighlight: 'line'
                    }
                })
            ]
        }, `${axisId}-${value}`);
    });
}

});
parcelRegister("4mjjX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $32c83439b7900c48$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsAxisHighlightPath = void 0;

var $32c83439b7900c48$var$_extends2 = $32c83439b7900c48$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8xDHs = parcelRequire("8xDHs");
const $32c83439b7900c48$var$ChartsAxisHighlightPath = module.exports.ChartsAxisHighlightPath = (0, $8xDHs.styled)('path', {
    name: 'MuiChartsAxisHighlight',
    slot: 'Root'
})(({ theme: theme })=>({
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    axisHighlight: 'band'
                },
                style: (0, $32c83439b7900c48$var$_extends2.default)({
                    fill: 'white',
                    fillOpacity: 0.1
                }, theme.applyStyles('light', {
                    fill: 'gray'
                }))
            },
            {
                props: {
                    axisHighlight: 'line'
                },
                style: (0, $32c83439b7900c48$var$_extends2.default)({
                    strokeDasharray: '5 2',
                    stroke: '#ffffff'
                }, theme.applyStyles('light', {
                    stroke: '#000000'
                }))
            }
        ]
    }));

});


parcelRegister("jlnOJ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e1527412f40c1f09$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1527412f40c1f09$var$ChartsXHighlight;

var $e1527412f40c1f09$var$React = $e1527412f40c1f09$require$_interopRequireWildcard((parcelRequire("acw62")));

var $kzIRL = parcelRequire("kzIRL");

var $2UPWB = parcelRequire("2UPWB");

var $d3mgr = parcelRequire("d3mgr");

var $a5Dpn = parcelRequire("a5Dpn");

var $55quD = parcelRequire("55quD");

var $4mjjX = parcelRequire("4mjjX");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $e1527412f40c1f09$var$ChartsXHighlight(props) {
    const { type: type, classes: classes } = props;
    const { top: top, height: height } = (0, $55quD.useDrawingArea)();
    const store = (0, $d3mgr.useStore)();
    const axisXValues = store.use($a5Dpn.selectorChartsHighlightXAxisValue);
    const xAxes = store.use($a5Dpn.selectorChartXAxis);
    if (axisXValues.length === 0) return null;
    return axisXValues.map(({ axisId: axisId, value: value })=>{
        const xAxis = xAxes.axis[axisId];
        const xScale = xAxis.scale;
        const getXPosition = (0, $kzIRL.getValueToPositionMapper)(xScale);
        const isXScaleOrdinal = type === 'band' && value !== null && (0, $2UPWB.isOrdinalScale)(xScale);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($e1527412f40c1f09$var$React.Fragment, {
            children: [
                isXScaleOrdinal && xScale(value) !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)($4mjjX.ChartsAxisHighlightPath, {
                    d: `M ${xScale(value) - (xScale.step() - xScale.bandwidth()) / 2} ${top} l ${xScale.step()} 0 l 0 ${height} l ${-xScale.step()} 0 Z`,
                    className: classes.root,
                    ownerState: {
                        axisHighlight: 'band'
                    }
                }),
                type === 'line' && value !== null && /*#__PURE__*/ (0, $ayMG0.jsx)($4mjjX.ChartsAxisHighlightPath, {
                    d: `M ${getXPosition(value)} ${top} L ${getXPosition(value)} ${top + height}`,
                    className: classes.root,
                    ownerState: {
                        axisHighlight: 'line'
                    }
                })
            ]
        }, `${axisId}-${value}`);
    });
}

});


parcelRegister("eyrV4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("6WChQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $82Bpe = parcelRequire("82Bpe");
Object.keys($82Bpe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $82Bpe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $82Bpe[key];
        }
    });
});

});
parcelRegister("82Bpe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5dab86a90138392b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsClipPath = $5dab86a90138392b$var$ChartsClipPath;

var $5dab86a90138392b$var$_extends2 = $5dab86a90138392b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5dab86a90138392b$var$_propTypes = $5dab86a90138392b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $gxvLm = parcelRequire("gxvLm");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * API:
 *
 * - [ChartsClipPath API](https://mui.com/x/api/charts/charts-clip-path/)
 */ function $5dab86a90138392b$var$ChartsClipPath(props) {
    const { id: id, offset: offsetProps } = props;
    const { left: left, top: top, width: width, height: height } = (0, $gxvLm.useDrawingArea)();
    const offset = (0, $5dab86a90138392b$var$_extends2.default)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, offsetProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
        id: id,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
            x: left - offset.left,
            y: top - offset.top,
            width: width + offset.left + offset.right,
            height: height + offset.top + offset.bottom
        })
    });
}

});


parcelRegister("jv2O3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e32316da1041c763$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e32316da1041c763$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineHighlightPlot = $e32316da1041c763$var$LineHighlightPlot;

var $e32316da1041c763$var$_extends2 = $e32316da1041c763$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e32316da1041c763$var$_objectWithoutPropertiesLoose2 = $e32316da1041c763$require$_interopRequireDefault((parcelRequire("c05no")));

var $e32316da1041c763$var$React = $e32316da1041c763$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e32316da1041c763$var$_propTypes = $e32316da1041c763$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d3mgr = parcelRequire("d3mgr");

var $4T2aJ = parcelRequire("4T2aJ");

var $kzIRL = parcelRequire("kzIRL");

var $fiXDv = parcelRequire("fiXDv");

var $949YJ = parcelRequire("949YJ");

var $e32316da1041c763$var$_getColor = $e32316da1041c763$require$_interopRequireDefault((parcelRequire("2tsDz")));

var $6hQTT = parcelRequire("6hQTT");

var $a5Dpn = parcelRequire("a5Dpn");

var $55Xcx = parcelRequire("55Xcx");

var $ayMG0 = parcelRequire("ayMG0");
const $e32316da1041c763$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineHighlightPlot API](https://mui.com/x/api/charts/line-highlight-plot/)
 */ function $e32316da1041c763$var$LineHighlightPlot(props) {
    const { slots: slots, slotProps: slotProps } = props, other = (0, $e32316da1041c763$var$_objectWithoutPropertiesLoose2.default)(props, $e32316da1041c763$var$_excluded);
    const seriesData = (0, $949YJ.useLineSeriesContext)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55Xcx.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55Xcx.useYAxes)();
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const store = (0, $d3mgr.useStore)();
    const highlightedIndexes = store.use($a5Dpn.selectorChartsHighlightXAxisIndex);
    if (highlightedIndexes.length === 0) return null;
    if (seriesData === undefined) return null;
    const { series: series, stackingGroups: stackingGroups } = seriesData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    const Element = slots?.lineHighlight ?? $4T2aJ.LineHighlightElement;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", (0, $e32316da1041c763$var$_extends2.default)({}, other, {
        children: highlightedIndexes.flatMap(({ dataIndex: highlightedIndex, axisId: highlightedAxisId })=>stackingGroups.flatMap(({ ids: groupIds })=>{
                return groupIds.flatMap((seriesId)=>{
                    const { xAxisId: xAxisId = defaultXAxisId, yAxisId: yAxisId = defaultYAxisId, visibleStackedData: visibleStackedData, data: data, disableHighlight: disableHighlight, shape: shape = 'circle' } = series[seriesId];
                    if (disableHighlight || data[highlightedIndex] == null) return null;
                    if (highlightedAxisId !== xAxisId) return null;
                    const xScale = (0, $kzIRL.getValueToPositionMapper)(xAxis[xAxisId].scale);
                    const yScale = yAxis[yAxisId].scale;
                    const xData = xAxis[xAxisId].data;
                    if (xData === undefined) throw new Error(`MUI X Charts: ${xAxisId === $fiXDv.DEFAULT_X_AXIS_KEY ? 'The first `xAxis`' : `The x-axis with id "${xAxisId}"`} should have data property to be able to display a line plot.`);
                    const x = xScale(xData[highlightedIndex]);
                    const y = yScale(visibleStackedData[highlightedIndex][1]); // This should not be undefined since y should not be a band scale
                    if (!instance.isPointInside(x, y)) return null;
                    const colorGetter = (0, $e32316da1041c763$var$_getColor.default)(series[seriesId], xAxis[xAxisId], yAxis[yAxisId]);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)(Element, (0, $e32316da1041c763$var$_extends2.default)({
                        id: seriesId,
                        color: colorGetter(highlightedIndex),
                        x: x,
                        y: y,
                        shape: shape
                    }, slotProps?.lineHighlight), `${seriesId}`);
                });
            }))
    }));
}

});
parcelRegister("4T2aJ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $38edfbd3556e5e78$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $38edfbd3556e5e78$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineHighlightElement = $38edfbd3556e5e78$var$LineHighlightElement;
module.exports.getHighlightElementUtilityClass = $38edfbd3556e5e78$var$getHighlightElementUtilityClass;
module.exports.lineHighlightElementClasses = void 0;

var $38edfbd3556e5e78$var$_extends2 = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $38edfbd3556e5e78$var$_objectWithoutPropertiesLoose2 = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("c05no")));

var $38edfbd3556e5e78$var$React = $38edfbd3556e5e78$require$_interopRequireWildcard((parcelRequire("acw62")));

var $38edfbd3556e5e78$var$_propTypes = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $38edfbd3556e5e78$var$_reactMajor = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("eKs5z")));

var $6hlpT = parcelRequire("6hlpT");

var $38edfbd3556e5e78$var$_composeClasses = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $38edfbd3556e5e78$var$_generateUtilityClass = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $38edfbd3556e5e78$var$_generateUtilityClasses = $38edfbd3556e5e78$require$_interopRequireDefault((parcelRequire("5nY49")));

var $iUrbd = parcelRequire("iUrbd");

var $ayMG0 = parcelRequire("ayMG0");
const $38edfbd3556e5e78$var$_excluded = [
    "x",
    "y",
    "id",
    "classes",
    "color",
    "shape"
];
function $38edfbd3556e5e78$var$getHighlightElementUtilityClass(slot) {
    return (0, $38edfbd3556e5e78$var$_generateUtilityClass.default)('MuiHighlightElement', slot);
}
const $38edfbd3556e5e78$var$lineHighlightElementClasses = module.exports.lineHighlightElementClasses = (0, $38edfbd3556e5e78$var$_generateUtilityClasses.default)('MuiHighlightElement', [
    'root'
]);
const $38edfbd3556e5e78$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`
        ]
    };
    return (0, $38edfbd3556e5e78$var$_composeClasses.default)(slots, $38edfbd3556e5e78$var$getHighlightElementUtilityClass, classes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineHighlightElement API](https://mui.com/x/api/charts/line-highlight-element/)
 */ function $38edfbd3556e5e78$var$LineHighlightElement(props) {
    const { x: x, y: y, color: color, shape: shape } = props, other = (0, $38edfbd3556e5e78$var$_objectWithoutPropertiesLoose2.default)(props, $38edfbd3556e5e78$var$_excluded);
    const classes = $38edfbd3556e5e78$var$useUtilityClasses(props);
    const Element = shape === 'circle' ? 'circle' : 'path';
    const additionalProps = shape === 'circle' ? {
        cx: 0,
        cy: 0,
        r: other.r === undefined ? 5 : other.r
    } : {
        d: (0, $6hlpT.symbol)($6hlpT.symbolsFill[(0, $iUrbd.getSymbol)(shape)])()
    };
    // React 18 does not recognize `transformOrigin` and React 19 does not recognize `transform-origin`
    const transformOrigin = $38edfbd3556e5e78$var$_reactMajor.default > 18 ? {
        transformOrigin: `${x} ${y}`
    } : {
        'transform-origin': `${x} ${y}`
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Element, (0, $38edfbd3556e5e78$var$_extends2.default)({
        pointerEvents: "none",
        className: classes.root,
        transform: `translate(${x} ${y})`,
        fill: color
    }, transformOrigin, additionalProps, other));
}

});


parcelRegister("2ppSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d7nVB = parcelRequire("d7nVB");
Object.keys($d7nVB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d7nVB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d7nVB[key];
        }
    });
});

var $9g6Zf = parcelRequire("9g6Zf");
Object.keys($9g6Zf).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9g6Zf[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9g6Zf[key];
        }
    });
});

});
parcelRegister("d7nVB", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $98ce7d6ff86e7be2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsGrid = $98ce7d6ff86e7be2$var$ChartsGrid;

var $98ce7d6ff86e7be2$var$_extends2 = $98ce7d6ff86e7be2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $98ce7d6ff86e7be2$var$_objectWithoutPropertiesLoose2 = $98ce7d6ff86e7be2$require$_interopRequireDefault((parcelRequire("c05no")));

var $98ce7d6ff86e7be2$var$_propTypes = $98ce7d6ff86e7be2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $98ce7d6ff86e7be2$var$_composeClasses = $98ce7d6ff86e7be2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8xDHs = parcelRequire("8xDHs");

var $9g6Zf = parcelRequire("9g6Zf");

var $gxvLm = parcelRequire("gxvLm");

var $4RMb8 = parcelRequire("4RMb8");

var $ddM8n = parcelRequire("ddM8n");

var $3PKjs = parcelRequire("3PKjs");

var $55Xcx = parcelRequire("55Xcx");

var $ayMG0 = parcelRequire("ayMG0");
const $98ce7d6ff86e7be2$var$_excluded = [
    "vertical",
    "horizontal"
];
const $98ce7d6ff86e7be2$var$useUtilityClasses = ({ classes: classes })=>{
    const slots = {
        root: [
            'root'
        ],
        verticalLine: [
            'line',
            'verticalLine'
        ],
        horizontalLine: [
            'line',
            'horizontalLine'
        ]
    };
    return (0, $98ce7d6ff86e7be2$var$_composeClasses.default)(slots, $9g6Zf.getChartsGridUtilityClass, classes);
};
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsGrid API](https://mui.com/x/api/charts/charts-axis/)
 */ function $98ce7d6ff86e7be2$var$ChartsGrid(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiChartsGrid'
    });
    const drawingArea = (0, $gxvLm.useDrawingArea)();
    const { vertical: vertical, horizontal: horizontal } = props, other = (0, $98ce7d6ff86e7be2$var$_objectWithoutPropertiesLoose2.default)(props, $98ce7d6ff86e7be2$var$_excluded);
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55Xcx.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55Xcx.useYAxes)();
    const classes = $98ce7d6ff86e7be2$var$useUtilityClasses(props);
    const horizontalAxis = yAxis[yAxisIds[0]];
    const verticalAxis = xAxis[xAxisIds[0]];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4RMb8.GridRoot, (0, $98ce7d6ff86e7be2$var$_extends2.default)({}, other, {
        className: classes.root,
        children: [
            vertical && /*#__PURE__*/ (0, $ayMG0.jsx)($ddM8n.ChartsGridVertical, {
                axis: verticalAxis,
                start: drawingArea.top,
                end: drawingArea.height + drawingArea.top,
                classes: classes
            }),
            horizontal && /*#__PURE__*/ (0, $ayMG0.jsx)($3PKjs.ChartsGridHorizontal, {
                axis: horizontalAxis,
                start: drawingArea.left,
                end: drawingArea.width + drawingArea.left,
                classes: classes
            })
        ]
    }));
}

});
parcelRegister("9g6Zf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6bdb071f0119d805$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsGridClasses = void 0;
module.exports.getChartsGridUtilityClass = $6bdb071f0119d805$var$getChartsGridUtilityClass;

var $6bdb071f0119d805$var$_generateUtilityClass = $6bdb071f0119d805$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $6bdb071f0119d805$var$_generateUtilityClasses = $6bdb071f0119d805$require$_interopRequireDefault((parcelRequire("5nY49")));
function $6bdb071f0119d805$var$getChartsGridUtilityClass(slot) {
    return (0, $6bdb071f0119d805$var$_generateUtilityClass.default)('MuiChartsGrid', slot);
}
const $6bdb071f0119d805$var$chartsGridClasses = module.exports.chartsGridClasses = (0, $6bdb071f0119d805$var$_generateUtilityClasses.default)('MuiChartsGrid', [
    'root',
    'line',
    'horizontalLine',
    'verticalLine'
]);

});

parcelRegister("4RMb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GridRoot = module.exports.GridLine = void 0;

var $8xDHs = parcelRequire("8xDHs");

var $9g6Zf = parcelRequire("9g6Zf");
const $38b17be8f008ec70$var$GridRoot = module.exports.GridRoot = (0, $8xDHs.styled)('g', {
    name: 'MuiChartsGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            {
                [`&.${$9g6Zf.chartsGridClasses.verticalLine}`]: styles.verticalLine
            },
            {
                [`&.${$9g6Zf.chartsGridClasses.horizontalLine}`]: styles.horizontalLine
            },
            styles.root
        ]
})({});
const $38b17be8f008ec70$var$GridLine = module.exports.GridLine = (0, $8xDHs.styled)('line', {
    name: 'MuiChartsGrid',
    slot: 'Line'
})(({ theme: theme })=>({
        stroke: (theme.vars || theme).palette.divider,
        shapeRendering: 'crispEdges',
        strokeWidth: 1
    }));

});

parcelRegister("ddM8n", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9a01d3ac0d593a59$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsGridVertical = $9a01d3ac0d593a59$var$ChartsGridVertical;

var $9a01d3ac0d593a59$var$React = $9a01d3ac0d593a59$require$_interopRequireWildcard((parcelRequire("acw62")));

var $gWDH1 = parcelRequire("gWDH1");

var $4RMb8 = parcelRequire("4RMb8");

var $6hQTT = parcelRequire("6hQTT");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $9a01d3ac0d593a59$var$ChartsGridVertical(props) {
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const { axis: axis, start: start, end: end, classes: classes } = props;
    const { scale: scale, tickNumber: tickNumber, tickInterval: tickInterval, tickSpacing: tickSpacing } = axis;
    const xTicks = (0, $gWDH1.useTicks)({
        scale: scale,
        tickNumber: tickNumber,
        tickInterval: tickInterval,
        tickSpacing: tickSpacing,
        direction: 'x',
        ordinalTimeTicks: 'ordinalTimeTicks' in axis ? axis.ordinalTimeTicks : undefined
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9a01d3ac0d593a59$var$React.Fragment, {
        children: xTicks.map(({ value: value, offset: offset })=>!instance.isXInside(offset) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($4RMb8.GridLine, {
                y1: start,
                y2: end,
                x1: offset,
                x2: offset,
                className: classes.verticalLine
            }, `vertical-${value?.getTime?.() ?? value}`))
    });
}

});

parcelRegister("3PKjs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2caa0f4dcdcaf019$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsGridHorizontal = $2caa0f4dcdcaf019$var$ChartsGridHorizontal;

var $2caa0f4dcdcaf019$var$React = $2caa0f4dcdcaf019$require$_interopRequireWildcard((parcelRequire("acw62")));

var $gWDH1 = parcelRequire("gWDH1");

var $4RMb8 = parcelRequire("4RMb8");

var $6hQTT = parcelRequire("6hQTT");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $2caa0f4dcdcaf019$var$ChartsGridHorizontal(props) {
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const { axis: axis, start: start, end: end, classes: classes } = props;
    const { scale: scale, tickNumber: tickNumber, tickInterval: tickInterval, tickSpacing: tickSpacing } = axis;
    const yTicks = (0, $gWDH1.useTicks)({
        scale: scale,
        tickNumber: tickNumber,
        tickInterval: tickInterval,
        tickSpacing: tickSpacing,
        direction: 'y',
        ordinalTimeTicks: 'ordinalTimeTicks' in axis ? axis.ordinalTimeTicks : undefined
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2caa0f4dcdcaf019$var$React.Fragment, {
        children: yTicks.map(({ value: value, offset: offset })=>!instance.isYInside(offset) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($4RMb8.GridLine, {
                y1: offset,
                y2: offset,
                x1: start,
                x2: end,
                className: classes.horizontalLine
            }, `horizontal-${value?.getTime?.() ?? value}`))
    });
}

});



parcelRegister("hhc1V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ChartsLoadingOverlay", {
    enumerable: true,
    get: function() {
        return $fzI2B.ChartsLoadingOverlay;
    }
});
Object.defineProperty(module.exports, "ChartsNoDataOverlay", {
    enumerable: true,
    get: function() {
        return $4I47i.ChartsNoDataOverlay;
    }
});
Object.defineProperty(module.exports, "ChartsOverlay", {
    enumerable: true,
    get: function() {
        return $53stl.ChartsOverlay;
    }
});

var $53stl = parcelRequire("53stl");

var $fzI2B = parcelRequire("fzI2B");

var $4I47i = parcelRequire("4I47i");

});
parcelRegister("53stl", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3ae3518e9b1f0136$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3ae3518e9b1f0136$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsOverlay = $3ae3518e9b1f0136$var$ChartsOverlay;
module.exports.useNoData = $3ae3518e9b1f0136$var$useNoData;

var $3ae3518e9b1f0136$var$_extends2 = $3ae3518e9b1f0136$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3ae3518e9b1f0136$var$React = $3ae3518e9b1f0136$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fzI2B = parcelRequire("fzI2B");

var $cGXUp = parcelRequire("cGXUp");

var $4I47i = parcelRequire("4I47i");

var $ayMG0 = parcelRequire("ayMG0");
function $3ae3518e9b1f0136$var$useNoData() {
    const seriesPerType = (0, $cGXUp.useSeries)();
    return Object.values(seriesPerType).every((seriesOfGivenType)=>{
        if (!seriesOfGivenType) return true;
        const { series: series, seriesOrder: seriesOrder } = seriesOfGivenType;
        return seriesOrder.every((seriesId)=>{
            const seriesItem = series[seriesId];
            // These prevent a type error when building the package.
            // @ts-ignore, sankey type is not declared in the base package
            if (seriesItem.type === 'sankey') // @ts-ignore, sankey type is not declared in the base package
            return seriesItem.data.links.length === 0;
            return seriesItem.data.length === 0;
        });
    });
}
function $3ae3518e9b1f0136$var$ChartsOverlay(props) {
    const noData = $3ae3518e9b1f0136$var$useNoData();
    if (props.loading) {
        const LoadingOverlay = props.slots?.loadingOverlay ?? $fzI2B.ChartsLoadingOverlay;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(LoadingOverlay, (0, $3ae3518e9b1f0136$var$_extends2.default)({}, props.slotProps?.loadingOverlay));
    }
    if (noData) {
        const NoDataOverlay = props.slots?.noDataOverlay ?? $4I47i.ChartsNoDataOverlay;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(NoDataOverlay, (0, $3ae3518e9b1f0136$var$_extends2.default)({}, props.slotProps?.noDataOverlay));
    }
    return null;
}

});
parcelRegister("fzI2B", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b56c498110e17986$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsLoadingOverlay = $b56c498110e17986$var$ChartsLoadingOverlay;

var $b56c498110e17986$var$_objectWithoutPropertiesLoose2 = $b56c498110e17986$require$_interopRequireDefault((parcelRequire("c05no")));

var $b56c498110e17986$var$_extends2 = $b56c498110e17986$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8xDHs = parcelRequire("8xDHs");

var $gxvLm = parcelRequire("gxvLm");

var $aEQiL = parcelRequire("aEQiL");

var $ayMG0 = parcelRequire("ayMG0");
const $b56c498110e17986$var$_excluded = [
    "message"
];
const $b56c498110e17986$var$StyledText = (0, $8xDHs.styled)('text', {
    slot: 'internal',
    shouldForwardProp: undefined
})(({ theme: theme })=>(0, $b56c498110e17986$var$_extends2.default)({}, theme.typography.body2, {
        stroke: 'none',
        fill: (theme.vars || theme).palette.text.primary,
        shapeRendering: 'crispEdges',
        textAnchor: 'middle',
        dominantBaseline: 'middle'
    }));
function $b56c498110e17986$var$ChartsLoadingOverlay(props) {
    const { message: message } = props, other = (0, $b56c498110e17986$var$_objectWithoutPropertiesLoose2.default)(props, $b56c498110e17986$var$_excluded);
    const { top: top, left: left, height: height, width: width } = (0, $gxvLm.useDrawingArea)();
    const { localeText: localeText } = (0, $aEQiL.useChartsLocalization)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b56c498110e17986$var$StyledText, (0, $b56c498110e17986$var$_extends2.default)({
        x: left + width / 2,
        y: top + height / 2
    }, other, {
        children: message ?? localeText.loading
    }));
}

});

parcelRegister("4I47i", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $36de76f8ca89bba5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsNoDataOverlay = $36de76f8ca89bba5$var$ChartsNoDataOverlay;

var $36de76f8ca89bba5$var$_objectWithoutPropertiesLoose2 = $36de76f8ca89bba5$require$_interopRequireDefault((parcelRequire("c05no")));

var $36de76f8ca89bba5$var$_extends2 = $36de76f8ca89bba5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8xDHs = parcelRequire("8xDHs");

var $gxvLm = parcelRequire("gxvLm");

var $aEQiL = parcelRequire("aEQiL");

var $ayMG0 = parcelRequire("ayMG0");
const $36de76f8ca89bba5$var$_excluded = [
    "message"
];
const $36de76f8ca89bba5$var$StyledText = (0, $8xDHs.styled)('text', {
    slot: 'internal',
    shouldForwardProp: undefined
})(({ theme: theme })=>(0, $36de76f8ca89bba5$var$_extends2.default)({}, theme.typography.body2, {
        stroke: 'none',
        fill: (theme.vars || theme).palette.text.primary,
        shapeRendering: 'crispEdges',
        textAnchor: 'middle',
        dominantBaseline: 'middle'
    }));
function $36de76f8ca89bba5$var$ChartsNoDataOverlay(props) {
    const { message: message } = props, other = (0, $36de76f8ca89bba5$var$_objectWithoutPropertiesLoose2.default)(props, $36de76f8ca89bba5$var$_excluded);
    const { top: top, left: left, height: height, width: width } = (0, $gxvLm.useDrawingArea)();
    const { localeText: localeText } = (0, $aEQiL.useChartsLocalization)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($36de76f8ca89bba5$var$StyledText, (0, $36de76f8ca89bba5$var$_extends2.default)({
        x: left + width / 2,
        y: top + height / 2
    }, other, {
        children: message ?? localeText.noData
    }));
}

});



parcelRegister("ezmj9", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a9b5a3710096560f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a9b5a3710096560f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useLineChartProps = void 0;

var $a9b5a3710096560f$var$_extends2 = $a9b5a3710096560f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a9b5a3710096560f$var$_objectWithoutPropertiesLoose2 = $a9b5a3710096560f$require$_interopRequireDefault((parcelRequire("c05no")));

var $a9b5a3710096560f$var$React = $a9b5a3710096560f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a9b5a3710096560f$var$_useId = $a9b5a3710096560f$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fiXDv = parcelRequire("fiXDv");

var $i2Vyg = parcelRequire("i2Vyg");
const $a9b5a3710096560f$var$_excluded = [
    "xAxis",
    "yAxis",
    "series",
    "width",
    "height",
    "margin",
    "colors",
    "dataset",
    "sx",
    "onAreaClick",
    "onLineClick",
    "onMarkClick",
    "axisHighlight",
    "disableLineItemHighlight",
    "hideLegend",
    "grid",
    "children",
    "slots",
    "slotProps",
    "skipAnimation",
    "loading",
    "highlightedItem",
    "onHighlightChange",
    "className",
    "showToolbar",
    "brushConfig"
];
/**
 * A helper function that extracts LineChartProps from the input props
 * and returns an object with props for the children components of LineChart.
 *
 * @param props The input props for LineChart
 * @returns An object with props for the children components of LineChart
 */ const $a9b5a3710096560f$var$useLineChartProps = (props)=>{
    const { xAxis: xAxis, yAxis: yAxis, series: series, width: width, height: height, margin: margin, colors: colors, dataset: dataset, sx: sx, onAreaClick: onAreaClick, onLineClick: onLineClick, onMarkClick: onMarkClick, axisHighlight: axisHighlight, disableLineItemHighlight: disableLineItemHighlight, grid: grid, children: children, slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, loading: loading, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, className: className, brushConfig: brushConfig } = props, other = (0, $a9b5a3710096560f$var$_objectWithoutPropertiesLoose2.default)(props, $a9b5a3710096560f$var$_excluded);
    const id = (0, $a9b5a3710096560f$var$_useId.default)();
    const clipPathId = `${id}-clip-path`;
    const seriesWithDefault = $a9b5a3710096560f$var$React.useMemo(()=>series.map((s)=>(0, $a9b5a3710096560f$var$_extends2.default)({
                disableHighlight: !!disableLineItemHighlight,
                type: 'line'
            }, s)), [
        disableLineItemHighlight,
        series
    ]);
    const chartContainerProps = (0, $a9b5a3710096560f$var$_extends2.default)({}, other, {
        series: seriesWithDefault,
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        dataset: dataset,
        xAxis: xAxis ?? [
            {
                id: $fiXDv.DEFAULT_X_AXIS_KEY,
                scaleType: 'point',
                data: Array.from({
                    length: Math.max(...series.map((s)=>(s.data ?? dataset ?? []).length))
                }, (_, index)=>index)
            }
        ],
        yAxis: yAxis,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        disableAxisListener: slotProps?.tooltip?.trigger !== 'axis' && axisHighlight?.x === 'none' && axisHighlight?.y === 'none',
        className: className,
        skipAnimation: skipAnimation,
        brushConfig: brushConfig,
        plugins: $i2Vyg.LINE_CHART_PLUGINS
    });
    const gridProps = {
        vertical: grid?.vertical,
        horizontal: grid?.horizontal
    };
    const clipPathGroupProps = {
        clipPath: `url(#${clipPathId})`
    };
    const clipPathProps = {
        id: clipPathId
    };
    const areaPlotProps = {
        slots: slots,
        slotProps: slotProps,
        onItemClick: onAreaClick
    };
    const linePlotProps = {
        slots: slots,
        slotProps: slotProps,
        onItemClick: onLineClick
    };
    const markPlotProps = {
        slots: slots,
        slotProps: slotProps,
        onItemClick: onMarkClick,
        skipAnimation: skipAnimation
    };
    const overlayProps = {
        slots: slots,
        slotProps: slotProps,
        loading: loading
    };
    const chartsAxisProps = {
        slots: slots,
        slotProps: slotProps
    };
    const axisHighlightProps = (0, $a9b5a3710096560f$var$_extends2.default)({
        x: 'line'
    }, axisHighlight);
    const lineHighlightPlotProps = {
        slots: slots,
        slotProps: slotProps
    };
    const legendProps = {
        slots: slots,
        slotProps: slotProps
    };
    const chartsWrapperProps = {
        sx: sx,
        legendPosition: props.slotProps?.legend?.position,
        legendDirection: props.slotProps?.legend?.direction,
        hideLegend: props.hideLegend ?? false
    };
    return {
        chartsWrapperProps: chartsWrapperProps,
        chartContainerProps: chartContainerProps,
        gridProps: gridProps,
        clipPathProps: clipPathProps,
        clipPathGroupProps: clipPathGroupProps,
        areaPlotProps: areaPlotProps,
        linePlotProps: linePlotProps,
        markPlotProps: markPlotProps,
        overlayProps: overlayProps,
        chartsAxisProps: chartsAxisProps,
        axisHighlightProps: axisHighlightProps,
        lineHighlightPlotProps: lineHighlightPlotProps,
        legendProps: legendProps,
        children: children
    };
};
module.exports.useLineChartProps = $a9b5a3710096560f$var$useLineChartProps;

});
parcelRegister("i2Vyg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LINE_CHART_PLUGINS = void 0;

var $d4cjJ = parcelRequire("d4cjJ");

var $a5Dpn = parcelRequire("a5Dpn");

var $d8Csh = parcelRequire("d8Csh");

var $8j56i = parcelRequire("8j56i");

var $cZLDK = parcelRequire("cZLDK");

var $cp50o = parcelRequire("cp50o");

var $b4u9m = parcelRequire("b4u9m");

var $fgykb = parcelRequire("fgykb");
const $d2350e770cbaef26$var$LINE_CHART_PLUGINS = module.exports.LINE_CHART_PLUGINS = [
    $d4cjJ.useChartZAxis,
    $b4u9m.useChartBrush,
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $a5Dpn.useChartCartesianAxis,
    $cZLDK.useChartHighlight,
    $fgykb.useChartVisibilityManager,
    $cp50o.useChartKeyboardNavigation
];

});


parcelRegister("3jE6m", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartContainerProps = void 0;

var $hJcWr = parcelRequire("hJcWr");
/**
 * @deprecated Use `UseChartsContainerPropsReturnValue` instead.
 */ /**
 * @deprecated Use `useChartsContainerProps` instead.
 */ const $26a240cc880cd4d3$var$useChartContainerProps = (props, ref)=>{
    return (0, $hJcWr.useChartsContainerProps)(props, ref);
};
module.exports.useChartContainerProps = $26a240cc880cd4d3$var$useChartContainerProps;

});
parcelRegister("hJcWr", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ce80ad93e935c5bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartsContainerProps = void 0;

var $ce80ad93e935c5bb$var$_extends2 = $ce80ad93e935c5bb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ce80ad93e935c5bb$var$_objectWithoutPropertiesLoose2 = $ce80ad93e935c5bb$require$_interopRequireDefault((parcelRequire("c05no")));

var $PHTHy = parcelRequire("PHTHy");
const $ce80ad93e935c5bb$var$_excluded = [
    "width",
    "height",
    "margin",
    "children",
    "series",
    "colors",
    "dataset",
    "desc",
    "onAxisClick",
    "highlightedAxis",
    "onHighlightedAxisChange",
    "tooltipItem",
    "onTooltipItemChange",
    "disableVoronoi",
    "voronoiMaxRadius",
    "onItemClick",
    "disableAxisListener",
    "highlightedItem",
    "onHighlightChange",
    "sx",
    "title",
    "xAxis",
    "yAxis",
    "zAxis",
    "rotationAxis",
    "radiusAxis",
    "skipAnimation",
    "seriesConfig",
    "plugins",
    "localeText",
    "slots",
    "slotProps",
    "experimentalFeatures",
    "enableKeyboardNavigation",
    "brushConfig",
    "onHiddenItemsChange",
    "hiddenItems",
    "initialHiddenItems"
];
const $ce80ad93e935c5bb$var$useChartsContainerProps = (props, ref)=>{
    const _ref = props, { width: width, height: height, margin: margin, children: children, series: series, colors: colors, dataset: dataset, desc: desc, onAxisClick: onAxisClick, highlightedAxis: highlightedAxis, onHighlightedAxisChange: onHighlightedAxisChange, tooltipItem: tooltipItem, onTooltipItemChange: onTooltipItemChange, disableVoronoi: disableVoronoi, voronoiMaxRadius: voronoiMaxRadius, onItemClick: onItemClick, disableAxisListener: disableAxisListener, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, sx: sx, title: title, xAxis: xAxis, yAxis: yAxis, zAxis: zAxis, rotationAxis: rotationAxis, radiusAxis: radiusAxis, skipAnimation: skipAnimation, seriesConfig: seriesConfig, plugins: plugins, localeText: localeText, slots: slots, slotProps: slotProps, experimentalFeatures: experimentalFeatures, enableKeyboardNavigation: enableKeyboardNavigation, brushConfig: brushConfig, onHiddenItemsChange: onHiddenItemsChange, hiddenItems: hiddenItems, initialHiddenItems: initialHiddenItems } = _ref, other = (0, $ce80ad93e935c5bb$var$_objectWithoutPropertiesLoose2.default)(_ref, $ce80ad93e935c5bb$var$_excluded);
    const chartsSurfaceProps = (0, $ce80ad93e935c5bb$var$_extends2.default)({
        title: title,
        desc: desc,
        sx: sx,
        ref: ref
    }, other);
    const chartDataProviderProps = {
        margin: margin,
        series: series,
        colors: colors,
        dataset: dataset,
        disableAxisListener: disableAxisListener,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        onAxisClick: onAxisClick,
        highlightedAxis: highlightedAxis,
        onHighlightedAxisChange: onHighlightedAxisChange,
        tooltipItem: tooltipItem,
        onTooltipItemChange: onTooltipItemChange,
        disableVoronoi: disableVoronoi,
        voronoiMaxRadius: voronoiMaxRadius,
        onItemClick: onItemClick,
        xAxis: xAxis,
        yAxis: yAxis,
        zAxis: zAxis,
        rotationAxis: rotationAxis,
        radiusAxis: radiusAxis,
        skipAnimation: skipAnimation,
        width: width,
        height: height,
        localeText: localeText,
        seriesConfig: seriesConfig,
        experimentalFeatures: experimentalFeatures,
        enableKeyboardNavigation: enableKeyboardNavigation,
        brushConfig: brushConfig,
        onHiddenItemsChange: onHiddenItemsChange,
        hiddenItems: hiddenItems,
        initialHiddenItems: initialHiddenItems,
        plugins: plugins ?? $PHTHy.DEFAULT_PLUGINS,
        slots: slots,
        slotProps: slotProps
    };
    return {
        chartDataProviderProps: chartDataProviderProps,
        chartsSurfaceProps: chartsSurfaceProps,
        children: children
    };
};
module.exports.useChartsContainerProps = $ce80ad93e935c5bb$var$useChartsContainerProps;

});
parcelRegister("PHTHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_PLUGINS = void 0;

var $a5Dpn = parcelRequire("a5Dpn");

var $cZLDK = parcelRequire("cZLDK");

var $8j56i = parcelRequire("8j56i");

var $cp50o = parcelRequire("cp50o");

var $dzF8X = parcelRequire("dzF8X");

var $d4cjJ = parcelRequire("d4cjJ");

var $b4u9m = parcelRequire("b4u9m");

var $fgykb = parcelRequire("fgykb");

var $d8Csh = parcelRequire("d8Csh");
// This file should be removed after creating all plugins in favor of a file per chart type.
const $09b6d0a58cb0b7e1$var$DEFAULT_PLUGINS = module.exports.DEFAULT_PLUGINS = [
    $d4cjJ.useChartZAxis,
    $b4u9m.useChartBrush,
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $a5Dpn.useChartCartesianAxis,
    $cZLDK.useChartHighlight,
    $fgykb.useChartVisibilityManager,
    $dzF8X.useChartClosestPoint,
    $cp50o.useChartKeyboardNavigation
];

});
parcelRegister("dzF8X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9e1e75754a4f2d81$var$_exportNames = {
    useChartClosestPoint: true
};
Object.defineProperty(module.exports, "useChartClosestPoint", {
    enumerable: true,
    get: function() {
        return $bY2aR.useChartClosestPoint;
    }
});

var $bY2aR = parcelRequire("bY2aR");

var $2iqn9 = parcelRequire("2iqn9");
Object.keys($2iqn9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9e1e75754a4f2d81$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2iqn9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2iqn9[key];
        }
    });
});

});
parcelRegister("bY2aR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8b66fc0818e2a382$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $8b66fc0818e2a382$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartClosestPoint = void 0;

var $8b66fc0818e2a382$var$_extends2 = $8b66fc0818e2a382$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8b66fc0818e2a382$var$React = $8b66fc0818e2a382$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8b66fc0818e2a382$var$_useEnhancedEffect = $8b66fc0818e2a382$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $8b66fc0818e2a382$var$_useEventCallback = $8b66fc0818e2a382$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $g34sa = parcelRequire("g34sa");

var $a5Dpn = parcelRequire("a5Dpn");

var $6kle2 = parcelRequire("6kle2");

var $iA4pc = parcelRequire("iA4pc");
const $8b66fc0818e2a382$var$useChartClosestPoint = ({ svgRef: svgRef, params: params, store: store, instance: instance })=>{
    const { disableVoronoi: disableVoronoi, voronoiMaxRadius: voronoiMaxRadius, onItemClick: onItemClick } = params;
    const { axis: xAxis, axisIds: xAxisIds } = store.use($a5Dpn.selectorChartXAxis);
    const { axis: yAxis, axisIds: yAxisIds } = store.use($a5Dpn.selectorChartYAxis);
    const zoomIsInteracting = store.use($a5Dpn.selectorChartZoomIsInteracting);
    const { series: series, seriesOrder: seriesOrder } = store.use($6kle2.selectorChartSeriesProcessed)?.scatter ?? {};
    const flatbushMap = store.use(zoomIsInteracting ? $a5Dpn.selectorChartSeriesEmptyFlatbushMap : $a5Dpn.selectorChartSeriesFlatbushMap);
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    (0, $8b66fc0818e2a382$var$_useEnhancedEffect.default)(()=>{
        store.set('voronoi', {
            isVoronoiEnabled: !disableVoronoi
        });
    }, [
        store,
        disableVoronoi
    ]);
    $8b66fc0818e2a382$var$React.useEffect(()=>{
        if (svgRef.current === null || disableVoronoi) return undefined;
        const element = svgRef.current;
        function getClosestPoint(event) {
            // Get mouse coordinate in global SVG space
            const svgPoint = (0, $g34sa.getSVGPoint)(element, event);
            if (!instance.isPointInside(svgPoint.x, svgPoint.y)) return 'outside-chart';
            let closestPoint = undefined;
            for (const seriesId of seriesOrder ?? []){
                const aSeries = (series ?? {})[seriesId];
                const flatbush = flatbushMap.get(seriesId);
                if (!flatbush) continue;
                const xAxisId = aSeries.xAxisId ?? defaultXAxisId;
                const yAxisId = aSeries.yAxisId ?? defaultYAxisId;
                const xAxisZoom = (0, $a5Dpn.selectorChartAxisZoomData)(store.state, xAxisId);
                const yAxisZoom = (0, $a5Dpn.selectorChartAxisZoomData)(store.state, yAxisId);
                const maxRadius = voronoiMaxRadius === 'item' ? aSeries.markerSize : voronoiMaxRadius;
                const xZoomStart = (xAxisZoom?.start ?? 0) / 100;
                const xZoomEnd = (xAxisZoom?.end ?? 100) / 100;
                const yZoomStart = (yAxisZoom?.start ?? 0) / 100;
                const yZoomEnd = (yAxisZoom?.end ?? 100) / 100;
                const xScale = xAxis[xAxisId].scale;
                const yScale = yAxis[yAxisId].scale;
                const closestPointIndex = (0, $iA4pc.findClosestPoints)(flatbush, aSeries.data, xScale, yScale, xZoomStart, xZoomEnd, yZoomStart, yZoomEnd, svgPoint.x, svgPoint.y, maxRadius)[0];
                if (closestPointIndex === undefined) continue;
                const point = aSeries.data[closestPointIndex];
                const scaledX = xScale(point.x);
                const scaledY = yScale(point.y);
                const distSq = (scaledX - svgPoint.x) ** 2 + (scaledY - svgPoint.y) ** 2;
                if (closestPoint === undefined || distSq < closestPoint.distanceSq) closestPoint = {
                    dataIndex: closestPointIndex,
                    seriesId: seriesId,
                    distanceSq: distSq
                };
            }
            if (closestPoint === undefined) return 'no-point-found';
            return {
                seriesId: closestPoint.seriesId,
                dataIndex: closestPoint.dataIndex
            };
        }
        // Clean the interaction when the mouse leaves the chart.
        const moveEndHandler = instance.addInteractionListener('moveEnd', (event)=>{
            if (!event.detail.activeGestures.pan) {
                instance.cleanInteraction?.();
                instance.clearHighlight?.();
                instance.removeTooltipItem?.();
            }
        });
        const panEndHandler = instance.addInteractionListener('panEnd', (event)=>{
            if (!event.detail.activeGestures.move) {
                instance.cleanInteraction?.();
                instance.clearHighlight?.();
                instance.removeTooltipItem?.();
            }
        });
        const pressEndHandler = instance.addInteractionListener('quickPressEnd', (event)=>{
            if (!event.detail.activeGestures.move && !event.detail.activeGestures.pan) {
                instance.cleanInteraction?.();
                instance.clearHighlight?.();
                instance.removeTooltipItem?.();
            }
        });
        const gestureHandler = (event)=>{
            const closestPoint = getClosestPoint(event.detail.srcEvent);
            if (closestPoint === 'outside-chart') {
                instance.cleanInteraction?.();
                instance.clearHighlight?.();
                instance.removeTooltipItem?.();
                return;
            }
            if (closestPoint === 'outside-voronoi-max-radius' || closestPoint === 'no-point-found') {
                instance.removeTooltipItem?.();
                instance.clearHighlight?.();
                instance.removeTooltipItem?.();
                return;
            }
            const { seriesId: seriesId, dataIndex: dataIndex } = closestPoint;
            instance.setTooltipItem?.({
                type: 'scatter',
                seriesId: seriesId,
                dataIndex: dataIndex
            });
            instance.setLastUpdateSource?.('pointer');
            instance.setHighlight?.({
                seriesId: seriesId,
                dataIndex: dataIndex
            });
        };
        const tapHandler = instance.addInteractionListener('tap', (event)=>{
            const closestPoint = getClosestPoint(event.detail.srcEvent);
            if (typeof closestPoint !== 'string' && onItemClick) {
                const { seriesId: seriesId, dataIndex: dataIndex } = closestPoint;
                onItemClick(event.detail.srcEvent, {
                    type: 'scatter',
                    seriesId: seriesId,
                    dataIndex: dataIndex
                });
            }
        });
        const moveHandler = instance.addInteractionListener('move', gestureHandler);
        const panHandler = instance.addInteractionListener('pan', gestureHandler);
        const pressHandler = instance.addInteractionListener('quickPress', gestureHandler);
        return ()=>{
            tapHandler.cleanup();
            moveHandler.cleanup();
            moveEndHandler.cleanup();
            panHandler.cleanup();
            panEndHandler.cleanup();
            pressHandler.cleanup();
            pressEndHandler.cleanup();
        };
    }, [
        svgRef,
        yAxis,
        xAxis,
        voronoiMaxRadius,
        onItemClick,
        disableVoronoi,
        instance,
        seriesOrder,
        series,
        flatbushMap,
        defaultXAxisId,
        defaultYAxisId,
        store
    ]);
    // Instance implementation
    const enableVoronoiCallback = (0, $8b66fc0818e2a382$var$_useEventCallback.default)(()=>{
        store.set('voronoi', {
            isVoronoiEnabled: true
        });
    });
    const disableVoronoiCallback = (0, $8b66fc0818e2a382$var$_useEventCallback.default)(()=>{
        store.set('voronoi', {
            isVoronoiEnabled: false
        });
    });
    return {
        instance: {
            enableVoronoi: enableVoronoiCallback,
            disableVoronoi: disableVoronoiCallback
        }
    };
};
module.exports.useChartClosestPoint = $8b66fc0818e2a382$var$useChartClosestPoint;
$8b66fc0818e2a382$var$useChartClosestPoint.getDefaultizedParams = ({ params: params })=>(0, $8b66fc0818e2a382$var$_extends2.default)({}, params, {
        disableVoronoi: params.disableVoronoi ?? !params.series.some((item)=>item.type === 'scatter')
    });
$8b66fc0818e2a382$var$useChartClosestPoint.getInitialState = (params)=>({
        voronoi: {
            isVoronoiEnabled: !params.disableVoronoi
        }
    });
$8b66fc0818e2a382$var$useChartClosestPoint.params = {
    disableVoronoi: true,
    voronoiMaxRadius: true,
    onItemClick: true
};

});
parcelRegister("iA4pc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findClosestPoints = $d86f019ceb5da3d2$var$findClosestPoints;

var $2UPWB = parcelRequire("2UPWB");
function $d86f019ceb5da3d2$var$findClosestPoints(flatbush, seriesData, xScale, yScale, xZoomStart, xZoomEnd, yZoomStart, yZoomEnd, svgPointX, svgPointY, maxRadius = Infinity, maxResults = 1) {
    const originalXScale = xScale.copy();
    const originalYScale = yScale.copy();
    originalXScale.range([
        0,
        1
    ]);
    originalYScale.range([
        0,
        1
    ]);
    const excludeIfOutsideDrawingArea = function excludeIfOutsideDrawingArea(index) {
        const x = originalXScale(seriesData[index].x);
        const y = originalYScale(seriesData[index].y);
        return x >= xZoomStart && x <= xZoomEnd && y >= yZoomStart && y <= yZoomEnd;
    };
    // We need to convert the distance from the original range [0, 1] to the current drawing area
    // so the comparison is done on pixels instead of normalized values.
    // fx and fy are the factors to convert the distance from [0, 1] to the current drawing area.
    const fx = xScale.range()[1] - xScale.range()[0];
    const fy = yScale.range()[1] - yScale.range()[0];
    const fxSq = fx * fx;
    const fySq = fy * fy;
    function sqDistFn(dx, dy) {
        return fxSq * dx * dx + fySq * dy * dy;
    }
    const pointX = originalXScale($d86f019ceb5da3d2$var$invertScale(xScale, svgPointX, (dataIndex)=>seriesData[dataIndex]?.x));
    const pointY = originalYScale($d86f019ceb5da3d2$var$invertScale(yScale, svgPointY, (dataIndex)=>seriesData[dataIndex]?.y));
    return flatbush.neighbors(pointX, pointY, maxResults, maxRadius != null ? maxRadius * maxRadius : Infinity, excludeIfOutsideDrawingArea, sqDistFn);
}
function $d86f019ceb5da3d2$var$invertScale(scale, value, getDataPoint) {
    if ((0, $2UPWB.isOrdinalScale)(scale)) {
        const dataIndex = scale.bandwidth() === 0 ? Math.floor((value - Math.min(...scale.range()) + scale.step() / 2) / scale.step()) : Math.floor((value - Math.min(...scale.range())) / scale.step());
        return getDataPoint(dataIndex);
    }
    return scale.invert(value);
}

});


parcelRegister("2iqn9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorChartsIsVoronoiEnabled = void 0;

var $8P0MD = parcelRequire("8P0MD");
const $1ac1b83c4b2e4432$var$selectVoronoi = (state)=>state.voronoi;
const $1ac1b83c4b2e4432$var$selectorChartsIsVoronoiEnabled = module.exports.selectorChartsIsVoronoiEnabled = (0, $8P0MD.createSelector)($1ac1b83c4b2e4432$var$selectVoronoi, (voronoi)=>voronoi?.isVoronoiEnabled);

});





parcelRegister("eSGGd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3zRWI = parcelRequire("3zRWI");
Object.keys($3zRWI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3zRWI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3zRWI[key];
        }
    });
});

});
parcelRegister("3zRWI", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartDataProvider = void 0;

var $kZwzL = parcelRequire("kZwzL");
/**
 * @deprecated Use `ChartsDataProviderSlots` instead. We added S to the charts prefix to align with other components.
 */ /**
 * @deprecated Use `ChartsDataProviderSlotProps` instead. We added S to the charts prefix to align with other components.
 */ /**
 * @deprecated Use `ChartsDataProviderProps` instead. We added S to the charts prefix to align with other components.
 */ /**
 * @deprecated Use `ChartsDataProvider` instead. We added S to the charts prefix to align with other components.
 */ const $29ae7c9077ab43eb$var$ChartDataProvider = module.exports.ChartDataProvider = $kZwzL.ChartsDataProvider;

});
parcelRegister("kZwzL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9BvFN = parcelRequire("9BvFN");
Object.keys($9BvFN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9BvFN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9BvFN[key];
        }
    });
});

});
parcelRegister("9BvFN", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6fe02365ddce8526$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6fe02365ddce8526$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsDataProvider = $6fe02365ddce8526$var$ChartsDataProvider;

var $6fe02365ddce8526$var$_extends2 = $6fe02365ddce8526$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6fe02365ddce8526$var$React = $6fe02365ddce8526$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6fe02365ddce8526$var$_propTypes = $6fe02365ddce8526$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5Ap7k = parcelRequire("5Ap7k");

var $dsjdj = parcelRequire("dsjdj");

var $915M7 = parcelRequire("915M7");

var $lqHBv = parcelRequire("lqHBv");

var $i8uFX = parcelRequire("i8uFX");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Orchestrates the data providers for the chart components and hooks.
 *
 * Use this component if you have custom HTML components that need to access the chart data.
 *
 * Demos:
 *
 * - [Composition](https://mui.com/x/react-charts/composition/)
 *
 * API:
 *
 * - [ChartsDataProvider API](https://mui.com/x/api/charts/charts-data-provider/)
 *
 * @example
 * ```jsx
 * <ChartsDataProvider
 *   series={[{ label: "Label", type: "bar", data: [10, 20] }]}
 *   xAxis={[{ data: ["A", "B"], scaleType: "band", id: "x-axis" }]}
 * >
 *   <ChartsSurface>
 *      <BarPlot />
 *      <ChartsXAxis axisId="x-axis" />
 *   </ChartsSurface>
 *   {'Custom Legend Component'}
 * </ChartsDataProvider>
 * ```
 */ function $6fe02365ddce8526$var$ChartsDataProvider(props) {
    const { children: children, localeText: localeText, chartProviderProps: chartProviderProps, slots: slots, slotProps: slotProps } = (0, $915M7.useChartsDataProviderProps)(props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($lqHBv.ChartsProvider, (0, $6fe02365ddce8526$var$_extends2.default)({}, chartProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($i8uFX.ChartsLocalizationProvider, {
            localeText: localeText,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($dsjdj.ChartsSlotsProvider, {
                slots: slots,
                slotProps: slotProps,
                defaultSlots: $5Ap7k.defaultSlotsMaterial,
                children: children
            })
        })
    }));
}

});
parcelRegister("5Ap7k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4113cc4ff8451f4c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultSlotsMaterial = void 0;

var $4113cc4ff8451f4c$var$_extends2 = $4113cc4ff8451f4c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4113cc4ff8451f4c$var$_IconButton = $4113cc4ff8451f4c$require$_interopRequireDefault((parcelRequire("825Zh")));

var $4113cc4ff8451f4c$var$_Button = $4113cc4ff8451f4c$require$_interopRequireDefault((parcelRequire("bBQKz")));
const $4113cc4ff8451f4c$var$baseSlots = {
    baseButton: $4113cc4ff8451f4c$var$_Button.default,
    baseIconButton: $4113cc4ff8451f4c$var$_IconButton.default
};
const $4113cc4ff8451f4c$var$iconSlots = {};
const $4113cc4ff8451f4c$var$defaultSlotsMaterial = module.exports.defaultSlotsMaterial = (0, $4113cc4ff8451f4c$var$_extends2.default)({}, $4113cc4ff8451f4c$var$baseSlots, $4113cc4ff8451f4c$var$iconSlots);

});

parcelRegister("dsjdj", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9cbccb54aaa69e6e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9cbccb54aaa69e6e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsSlotsContext = void 0;
module.exports.ChartsSlotsProvider = $9cbccb54aaa69e6e$var$ChartsSlotsProvider;
module.exports.useChartsSlots = $9cbccb54aaa69e6e$var$useChartsSlots;

var $9cbccb54aaa69e6e$var$_extends2 = $9cbccb54aaa69e6e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9cbccb54aaa69e6e$var$React = $9cbccb54aaa69e6e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $9cbccb54aaa69e6e$var$ChartsSlotsContext = module.exports.ChartsSlotsContext = /*#__PURE__*/ $9cbccb54aaa69e6e$var$React.createContext(null);
function $9cbccb54aaa69e6e$var$useChartsSlots() {
    const context = $9cbccb54aaa69e6e$var$React.useContext($9cbccb54aaa69e6e$var$ChartsSlotsContext);
    if (context == null) throw new Error([
        'MUI X Charts: Could not find the Charts Slots context.',
        'It looks like you rendered your component outside of a ChartDataProvider.',
        'This can also happen if you are bundling multiple versions of the library.'
    ].join('\n'));
    return context;
}
function $9cbccb54aaa69e6e$var$ChartsSlotsProvider(props) {
    const { slots: slots, slotProps: slotProps = {}, defaultSlots: defaultSlots, children: children } = props;
    const value = $9cbccb54aaa69e6e$var$React.useMemo(()=>({
            slots: (0, $9cbccb54aaa69e6e$var$_extends2.default)({}, defaultSlots, slots),
            slotProps: slotProps
        }), [
        defaultSlots,
        slots,
        slotProps
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9cbccb54aaa69e6e$var$ChartsSlotsContext.Provider, {
        value: value,
        children: children
    });
}

});

parcelRegister("915M7", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6908afd81e081a80$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartsDataProviderProps = void 0;

var $6908afd81e081a80$var$_extends2 = $6908afd81e081a80$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6908afd81e081a80$var$_objectWithoutPropertiesLoose2 = $6908afd81e081a80$require$_interopRequireDefault((parcelRequire("c05no")));

var $8xDHs = parcelRequire("8xDHs");

var $PHTHy = parcelRequire("PHTHy");
const $6908afd81e081a80$var$_excluded = [
    "children",
    "localeText",
    "plugins",
    "slots",
    "slotProps",
    "seriesConfig"
];
const $6908afd81e081a80$var$useChartsDataProviderProps = (inProps)=>{
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiChartDataProvider'
    });
    const { children: children, localeText: localeText, plugins: plugins = $PHTHy.DEFAULT_PLUGINS, slots: slots, slotProps: slotProps, seriesConfig: seriesConfig } = props, other = (0, $6908afd81e081a80$var$_objectWithoutPropertiesLoose2.default)(props, $6908afd81e081a80$var$_excluded);
    const theme = (0, $8xDHs.useTheme)();
    const chartProviderProps = {
        plugins: plugins,
        seriesConfig: seriesConfig,
        pluginParams: (0, $6908afd81e081a80$var$_extends2.default)({
            theme: theme.palette.mode
        }, other)
    };
    return {
        children: children,
        localeText: localeText,
        chartProviderProps: chartProviderProps,
        slots: slots,
        slotProps: slotProps
    };
};
module.exports.useChartsDataProviderProps = $6908afd81e081a80$var$useChartsDataProviderProps;

});

parcelRegister("i8uFX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ChartsLocalizationProvider", {
    enumerable: true,
    get: function() {
        return $bKuOB.ChartsLocalizationProvider;
    }
});

var $bKuOB = parcelRequire("bKuOB");

});





parcelRegister("ezMKh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a9ca2561494cf05a$var$_exportNames = {
    chartsSurfaceClasses: true
};
Object.defineProperty(module.exports, "chartsSurfaceClasses", {
    enumerable: true,
    get: function() {
        return $k9zJi.chartsSurfaceClasses;
    }
});

var $j9fKs = parcelRequire("j9fKs");
Object.keys($j9fKs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a9ca2561494cf05a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $j9fKs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j9fKs[key];
        }
    });
});

var $k9zJi = parcelRequire("k9zJi");

});
parcelRegister("j9fKs", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $df0b12dac715991a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $df0b12dac715991a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsSurface = void 0;

var $df0b12dac715991a$var$_extends2 = $df0b12dac715991a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $df0b12dac715991a$var$_objectWithoutPropertiesLoose2 = $df0b12dac715991a$require$_interopRequireDefault((parcelRequire("c05no")));

var $8xDHs = parcelRequire("8xDHs");

var $df0b12dac715991a$var$_propTypes = $df0b12dac715991a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $df0b12dac715991a$var$React = $df0b12dac715991a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $df0b12dac715991a$var$_useForkRef = $df0b12dac715991a$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $df0b12dac715991a$var$_clsx = $df0b12dac715991a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $dKNMq = parcelRequire("dKNMq");

var $j3Fic = parcelRequire("j3Fic");

var $6hQTT = parcelRequire("6hQTT");

var $kOdtM = parcelRequire("kOdtM");

var $cp50o = parcelRequire("cp50o");

var $k9zJi = parcelRequire("k9zJi");

var $ayMG0 = parcelRequire("ayMG0");
const $df0b12dac715991a$var$_excluded = [
    "children",
    "className",
    "title",
    "desc"
];
const $df0b12dac715991a$var$ChartsSurfaceStyles = (0, $8xDHs.styled)('svg', {
    name: 'MuiChartsSurface',
    slot: 'Root'
})(({ ownerState: ownerState })=>({
        width: ownerState.width ?? '100%',
        height: ownerState.height ?? '100%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        touchAction: 'pan-y',
        userSelect: 'none',
        gridArea: 'chart',
        '&:focus': {
            outline: 'none' // By default don't show focus on the SVG container
        }
    }));
/**
 * It provides the drawing area for the chart elements.
 * It is the root `<svg>` of all the chart elements.
 *
 * It also provides the `title` and `desc` elements for the chart.
 *
 * Demos:
 *
 * - [Composition](https://mui.com/x/api/charts/composition/)
 *
 * API:
 *
 * - [ChartsSurface API](https://mui.com/x/api/charts/charts-surface/)
 */ const $df0b12dac715991a$var$ChartsSurface = module.exports.ChartsSurface = /*#__PURE__*/ $df0b12dac715991a$var$React.forwardRef(function ChartsSurface(inProps, ref) {
    const { store: store, instance: instance } = (0, $6hQTT.useChartContext)();
    const svgWidth = store.use($kOdtM.selectorChartSvgWidth);
    const svgHeight = store.use($kOdtM.selectorChartSvgHeight);
    const propsWidth = store.use($kOdtM.selectorChartPropsWidth);
    const propsHeight = store.use($kOdtM.selectorChartPropsHeight);
    const isKeyboardNavigationEnabled = store.use($cp50o.selectorChartsIsKeyboardNavigationEnabled);
    const hasFocusedItem = store.use($cp50o.selectorChartsHasFocusedItem);
    const svgRef = (0, $j3Fic.useSvgRef)();
    const handleRef = (0, $df0b12dac715991a$var$_useForkRef.default)(svgRef, ref);
    const themeProps = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiChartsSurface'
    });
    const { children: children, className: className, title: title, desc: desc } = themeProps, other = (0, $df0b12dac715991a$var$_objectWithoutPropertiesLoose2.default)(themeProps, $df0b12dac715991a$var$_excluded);
    const classes = (0, $k9zJi.useUtilityClasses)();
    const hasIntrinsicSize = svgHeight > 0 && svgWidth > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($df0b12dac715991a$var$ChartsSurfaceStyles, (0, $df0b12dac715991a$var$_extends2.default)({
        ownerState: {
            width: propsWidth,
            height: propsHeight
        },
        viewBox: `${0} ${0} ${svgWidth} ${svgHeight}`,
        className: (0, $df0b12dac715991a$var$_clsx.default)(classes.root, className),
        tabIndex: isKeyboardNavigationEnabled ? 0 : undefined,
        "data-has-focused-item": hasFocusedItem || undefined
    }, other, {
        onPointerEnter: (event)=>{
            other.onPointerEnter?.(event);
            instance.handlePointerEnter?.(event);
        },
        onPointerLeave: (event)=>{
            other.onPointerLeave?.(event);
            instance.handlePointerLeave?.(event);
        },
        onClick: (event)=>{
            other.onClick?.(event);
            instance.handleClick?.(event);
        },
        ref: handleRef,
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: title
            }),
            desc && /*#__PURE__*/ (0, $ayMG0.jsx)("desc", {
                children: desc
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($dKNMq.ChartsAxesGradients, {}),
            hasIntrinsicSize && children
        ]
    }));
});

});
parcelRegister("dKNMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $doMlS = parcelRequire("doMlS");
Object.keys($doMlS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $doMlS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $doMlS[key];
        }
    });
});

});
parcelRegister("doMlS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c1305e8eeaa6d35$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9c1305e8eeaa6d35$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsAxesGradients = $9c1305e8eeaa6d35$var$ChartsAxesGradients;

var $9c1305e8eeaa6d35$var$React = $9c1305e8eeaa6d35$require$_interopRequireWildcard((parcelRequire("acw62")));

var $55quD = parcelRequire("55quD");

var $9c1305e8eeaa6d35$var$_ChartsPiecewiseGradient = $9c1305e8eeaa6d35$require$_interopRequireDefault((parcelRequire("d7RiS")));

var $9c1305e8eeaa6d35$var$_ChartsContinuousGradient = $9c1305e8eeaa6d35$require$_interopRequireDefault((parcelRequire("5Xb6g")));

var $9c1305e8eeaa6d35$var$_ChartsContinuousGradientObjectBound = $9c1305e8eeaa6d35$require$_interopRequireDefault((parcelRequire("lthJo")));

var $9qhH3 = parcelRequire("9qhH3");

var $eq62P = parcelRequire("eq62P");

var $ayMG0 = parcelRequire("ayMG0");
function $9c1305e8eeaa6d35$var$ChartsAxesGradients() {
    const { top: top, height: height, bottom: bottom, left: left, width: width, right: right } = (0, $55quD.useDrawingArea)();
    const svgHeight = top + height + bottom;
    const svgWidth = left + width + right;
    const getGradientId = (0, $eq62P.useChartGradientIdBuilder)();
    const getObjectBoundGradientId = (0, $eq62P.useChartGradientIdObjectBoundBuilder)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55quD.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55quD.useYAxes)();
    const { zAxis: zAxis, zAxisIds: zAxisIds } = (0, $9qhH3.useZAxes)();
    const filteredYAxisIds = yAxisIds.filter((axisId)=>yAxis[axisId].colorMap !== undefined);
    const filteredXAxisIds = xAxisIds.filter((axisId)=>xAxis[axisId].colorMap !== undefined);
    const filteredZAxisIds = zAxisIds.filter((axisId)=>zAxis[axisId].colorMap !== undefined);
    if (filteredYAxisIds.length === 0 && filteredXAxisIds.length === 0 && filteredZAxisIds.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
        children: [
            filteredYAxisIds.map((axisId)=>{
                const gradientId = getGradientId(axisId);
                const objectBoundGradientId = getObjectBoundGradientId(axisId);
                const { colorMap: colorMap, scale: scale, colorScale: colorScale, reverse: reverse } = yAxis[axisId];
                if (colorMap?.type === 'piecewise') return /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsPiecewiseGradient.default, {
                    isReversed: !reverse,
                    scale: scale,
                    colorMap: colorMap,
                    size: svgHeight,
                    gradientId: gradientId,
                    direction: "y"
                }, gradientId);
                if (colorMap?.type === 'continuous') return /*#__PURE__*/ (0, $ayMG0.jsxs)($9c1305e8eeaa6d35$var$React.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsContinuousGradient.default, {
                            isReversed: !reverse,
                            scale: scale,
                            colorScale: colorScale,
                            colorMap: colorMap,
                            size: svgHeight,
                            gradientId: gradientId,
                            direction: "y"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsContinuousGradientObjectBound.default, {
                            isReversed: reverse,
                            colorScale: colorScale,
                            colorMap: colorMap,
                            gradientId: objectBoundGradientId
                        })
                    ]
                }, gradientId);
                return null;
            }),
            filteredXAxisIds.map((axisId)=>{
                const gradientId = getGradientId(axisId);
                const objectBoundGradientId = getObjectBoundGradientId(axisId);
                const { colorMap: colorMap, scale: scale, reverse: reverse, colorScale: colorScale } = xAxis[axisId];
                if (colorMap?.type === 'piecewise') return /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsPiecewiseGradient.default, {
                    isReversed: reverse,
                    scale: scale,
                    colorMap: colorMap,
                    size: svgWidth,
                    gradientId: gradientId,
                    direction: "x"
                }, gradientId);
                if (colorMap?.type === 'continuous') return /*#__PURE__*/ (0, $ayMG0.jsxs)($9c1305e8eeaa6d35$var$React.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsContinuousGradient.default, {
                            isReversed: reverse,
                            scale: scale,
                            colorScale: colorScale,
                            colorMap: colorMap,
                            size: svgWidth,
                            gradientId: gradientId,
                            direction: "x"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsContinuousGradientObjectBound.default, {
                            isReversed: reverse,
                            colorScale: colorScale,
                            colorMap: colorMap,
                            gradientId: objectBoundGradientId
                        })
                    ]
                }, gradientId);
                return null;
            }),
            filteredZAxisIds.map((axisId)=>{
                const objectBoundGradientId = getObjectBoundGradientId(axisId);
                const { colorMap: colorMap, colorScale: colorScale } = zAxis[axisId];
                if (colorMap?.type === 'continuous') return /*#__PURE__*/ (0, $ayMG0.jsx)($9c1305e8eeaa6d35$var$_ChartsContinuousGradientObjectBound.default, {
                    colorScale: colorScale,
                    colorMap: colorMap,
                    gradientId: objectBoundGradientId
                }, objectBoundGradientId);
                return null;
            })
        ]
    });
}

});
parcelRegister("d7RiS", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $98e546c0f47e7b06$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98e546c0f47e7b06$var$ChartsPiecewiseGradient;

var $98e546c0f47e7b06$var$React = $98e546c0f47e7b06$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
function $98e546c0f47e7b06$var$ChartsPiecewiseGradient(props) {
    const { isReversed: isReversed, gradientId: gradientId, size: size, direction: direction, scale: scale, colorMap: colorMap } = props;
    if (size <= 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("linearGradient", {
        id: gradientId,
        x1: "0",
        x2: "0",
        y1: "0",
        y2: "0",
        [`${direction}${isReversed ? 1 : 2}`]: `${size}px`,
        gradientUnits: "userSpaceOnUse" // Use the SVG coordinate instead of the component ones.
        ,
        children: colorMap.thresholds.map((threshold, index)=>{
            const x = scale(threshold);
            if (x === undefined) return null;
            const offset = isReversed ? 1 - x / size : x / size;
            if (Number.isNaN(offset)) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($98e546c0f47e7b06$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                        offset: offset,
                        stopColor: colorMap.colors[index],
                        stopOpacity: 1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                        offset: offset,
                        stopColor: colorMap.colors[index + 1],
                        stopOpacity: 1
                    })
                ]
            }, threshold.toString() + index);
        })
    });
}

});

parcelRegister("5Xb6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $455b12ab6ffb6bff$var$ChartsContinuousGradient;

var $iNRFO = parcelRequire("iNRFO");

var $ayMG0 = parcelRequire("ayMG0");
const $455b12ab6ffb6bff$var$PX_PRECISION = 10;
function $455b12ab6ffb6bff$var$ChartsContinuousGradient(props) {
    const { gradientUnits: gradientUnits, isReversed: isReversed, gradientId: gradientId, size: size, direction: direction, scale: scale, colorScale: colorScale, colorMap: colorMap } = props;
    const extremumValues = [
        colorMap.min ?? 0,
        colorMap.max ?? 100
    ];
    const extremumPositions = extremumValues.map(scale).filter((p)=>p !== undefined);
    if (extremumPositions.length !== 2) return null;
    const interpolator = typeof extremumValues[0] === 'number' ? (0, $iNRFO.interpolateNumber)(extremumValues[0], extremumValues[1]) : (0, $iNRFO.interpolateDate)(extremumValues[0], extremumValues[1]);
    const numberOfPoints = Math.round((Math.max(...extremumPositions) - Math.min(...extremumPositions)) / $455b12ab6ffb6bff$var$PX_PRECISION);
    const keyPrefix = `${extremumValues[0]}-${extremumValues[1]}-`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("linearGradient", {
        id: gradientId,
        x1: "0",
        x2: "0",
        y1: "0",
        y2: "0",
        [`${direction}${isReversed ? 1 : 2}`]: gradientUnits === 'objectBoundingBox' ? 1 : `${size}px`,
        gradientUnits: gradientUnits ?? 'userSpaceOnUse' // Use the SVG coordinate instead of the component ones.
        ,
        children: Array.from({
            length: numberOfPoints + 1
        }, (_, index)=>{
            const value = interpolator(index / numberOfPoints);
            if (value === undefined) return null;
            const x = scale(value);
            if (x === undefined) return null;
            const offset = isReversed ? 1 - x / size : x / size;
            const color = colorScale(value);
            if (color === null) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                offset: offset,
                stopColor: color,
                stopOpacity: 1
            }, keyPrefix + index);
        })
    });
}

});

parcelRegister("lthJo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fa1a0f75ad301f69$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fa1a0f75ad301f69$var$ChartsContinuousGradientObjectBound;

var $fa1a0f75ad301f69$var$_extends2 = $fa1a0f75ad301f69$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $iNRFO = parcelRequire("iNRFO");

var $ayMG0 = parcelRequire("ayMG0");
const $fa1a0f75ad301f69$var$PX_PRECISION = 10;
const $fa1a0f75ad301f69$var$getDirection = (isReversed)=>{
    if (isReversed) return {
        x1: '1',
        x2: '0',
        y1: '0',
        y2: '0'
    };
    return {
        x1: '0',
        x2: '1',
        y1: '0',
        y2: '0'
    };
};
/**
 * Generates gradients to be used in tooltips and legends.
 */ function $fa1a0f75ad301f69$var$ChartsContinuousGradientObjectBound(props) {
    const { isReversed: isReversed, gradientId: gradientId, colorScale: colorScale, colorMap: colorMap } = props;
    const extremumValues = [
        colorMap.min ?? 0,
        colorMap.max ?? 100
    ];
    const interpolator = typeof extremumValues[0] === 'number' ? (0, $iNRFO.interpolateNumber)(extremumValues[0], extremumValues[1]) : (0, $iNRFO.interpolateDate)(extremumValues[0], extremumValues[1]);
    const numberOfPoints = $fa1a0f75ad301f69$var$PX_PRECISION;
    const keyPrefix = `${extremumValues[0]}-${extremumValues[1]}-`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("linearGradient", (0, $fa1a0f75ad301f69$var$_extends2.default)({
        id: gradientId
    }, $fa1a0f75ad301f69$var$getDirection(isReversed), {
        gradientUnits: 'objectBoundingBox' // Use the SVG coordinate instead of the component ones.
        ,
        children: Array.from({
            length: numberOfPoints + 1
        }, (_, index)=>{
            const offset = index / numberOfPoints;
            const value = interpolator(offset);
            if (value === undefined) return null;
            const color = colorScale(value);
            if (color === null) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                offset: offset,
                stopColor: color,
                stopOpacity: 1
            }, keyPrefix + index);
        })
    }));
}

});



parcelRegister("k9zJi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $eac05d0e30bd7f7c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useUtilityClasses = module.exports.chartsSurfaceClasses = void 0;

var $eac05d0e30bd7f7c$var$_generateUtilityClass = $eac05d0e30bd7f7c$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $eac05d0e30bd7f7c$var$_generateUtilityClasses = $eac05d0e30bd7f7c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $eac05d0e30bd7f7c$var$_composeClasses = $eac05d0e30bd7f7c$require$_interopRequireDefault((parcelRequire("3Hg1x")));
function $eac05d0e30bd7f7c$var$getSurfaceUtilityClass(slot) {
    return (0, $eac05d0e30bd7f7c$var$_generateUtilityClass.default)('MuiChartsSurface', slot);
}
const $eac05d0e30bd7f7c$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $eac05d0e30bd7f7c$var$_composeClasses.default)(slots, $eac05d0e30bd7f7c$var$getSurfaceUtilityClass);
};
module.exports.useUtilityClasses = $eac05d0e30bd7f7c$var$useUtilityClasses;
const $eac05d0e30bd7f7c$var$chartsSurfaceClasses = module.exports.chartsSurfaceClasses = (0, $eac05d0e30bd7f7c$var$_generateUtilityClasses.default)('MuiChartsSurface', [
    'root'
]);

});



parcelRegister("G4UB8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $91y17 = parcelRequire("91y17");
Object.keys($91y17).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $91y17[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91y17[key];
        }
    });
});

});
parcelRegister("91y17", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $691e98263f2672e0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $691e98263f2672e0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsWrapper = $691e98263f2672e0$var$ChartsWrapper;

var $691e98263f2672e0$var$React = $691e98263f2672e0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $691e98263f2672e0$var$_propTypes = $691e98263f2672e0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $bbeCr = parcelRequire("bbeCr");

var $1D4Lb = parcelRequire("1D4Lb");

var $d3mgr = parcelRequire("d3mgr");

var $eWN1p = parcelRequire("eWN1p");

var $bZEfF = parcelRequire("bZEfF");

var $ayMG0 = parcelRequire("ayMG0");
const $691e98263f2672e0$var$getJustifyItems = (position)=>{
    if (position?.horizontal === 'start') return 'start';
    if (position?.horizontal === 'end') return 'end';
    return 'center';
};
const $691e98263f2672e0$var$getAlignItems = (position)=>{
    if (position?.vertical === 'top') return 'flex-start';
    if (position?.vertical === 'bottom') return 'flex-end';
    return 'center';
};
const $691e98263f2672e0$var$getGridTemplateAreas = (hideLegend, direction, position)=>{
    if (hideLegend) return `"chart"`;
    if (direction === 'vertical') {
        if (position?.horizontal === 'start') return `"legend chart"`;
        return `"chart legend"`;
    }
    if (position?.vertical === 'bottom') return `"chart"
            "legend"`;
    return `"legend"
          "chart"`;
};
const $691e98263f2672e0$var$getTemplateColumns = (hideLegend = false, direction = 'horizontal', horizontalPosition = 'end', width)=>{
    const drawingAreaColumn = width ? 'auto' : '1fr';
    if (direction === 'horizontal') return drawingAreaColumn;
    if (hideLegend) return drawingAreaColumn;
    return horizontalPosition === 'start' ? `auto ${drawingAreaColumn}` : `${drawingAreaColumn} auto`;
};
const $691e98263f2672e0$var$getTemplateRows = (hideLegend = false, direction = 'horizontal', verticalPosition = 'top')=>{
    const drawingAreaRow = '1fr';
    if (direction === 'vertical') return drawingAreaRow;
    if (hideLegend) return drawingAreaRow;
    return verticalPosition === 'bottom' ? `${drawingAreaRow} auto` : `auto ${drawingAreaRow}`;
};
const $691e98263f2672e0$var$Root = (0, $8xDHs.styled)('div', {
    name: 'MuiChartsWrapper',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'extendVertically' && prop !== 'width'
})(({ ownerState: ownerState, width: width })=>{
    const gridTemplateColumns = $691e98263f2672e0$var$getTemplateColumns(ownerState.hideLegend, ownerState.legendDirection, ownerState.legendPosition?.horizontal, width);
    const gridTemplateRows = $691e98263f2672e0$var$getTemplateRows(ownerState.hideLegend, ownerState.legendDirection, ownerState.legendPosition?.vertical);
    const gridTemplateAreas = $691e98263f2672e0$var$getGridTemplateAreas(ownerState.hideLegend, ownerState.legendDirection, ownerState.legendPosition);
    return {
        variants: [
            {
                props: {
                    extendVertically: true
                },
                style: {
                    height: '100%',
                    minHeight: 0
                }
            }
        ],
        flex: 1,
        display: 'grid',
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows,
        gridTemplateAreas: gridTemplateAreas,
        [`&:has(.${$bZEfF.chartsToolbarClasses.root})`]: {
            // Add a row for toolbar if there is one.
            gridTemplateRows: `auto ${gridTemplateRows}`,
            gridTemplateAreas: `"${gridTemplateColumns.split(' ').map(()=>'toolbar').join(' ')}"
        ${gridTemplateAreas}`
        },
        [`& .${$bZEfF.chartsToolbarClasses.root}`]: {
            gridArea: 'toolbar',
            justifySelf: 'center'
        },
        justifyContent: 'safe center',
        justifyItems: $691e98263f2672e0$var$getJustifyItems(ownerState.legendPosition),
        alignItems: $691e98263f2672e0$var$getAlignItems(ownerState.legendPosition)
    };
});
/**
 * Wrapper for the charts components.
 * Its main purpose is to position the HTML legend in the correct place.
 */ function $691e98263f2672e0$var$ChartsWrapper(props) {
    const { children: children, sx: sx, extendVertically: extendVertically } = props;
    const chartRootRef = (0, $1D4Lb.useChartRootRef)();
    const store = (0, $d3mgr.useStore)();
    const propsWidth = store.use($eWN1p.selectorChartPropsWidth);
    const propsHeight = store.use($eWN1p.selectorChartPropsHeight);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($691e98263f2672e0$var$Root, {
        ref: chartRootRef,
        ownerState: props,
        sx: sx,
        extendVertically: extendVertically ?? propsHeight === undefined,
        width: propsWidth,
        children: children
    });
}

});
parcelRegister("bZEfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9Rel9 = parcelRequire("9Rel9");
Object.keys($9Rel9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9Rel9[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9Rel9[key];
        }
    });
});

var $jKq9J = parcelRequire("jKq9J");
Object.keys($jKq9J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jKq9J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jKq9J[key];
        }
    });
});

var $4qQgh = parcelRequire("4qQgh");
Object.keys($4qQgh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4qQgh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4qQgh[key];
        }
    });
});

var $hwB1M = parcelRequire("hwB1M");
Object.keys($hwB1M).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hwB1M[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hwB1M[key];
        }
    });
});

});
parcelRegister("9Rel9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $72d42ff61cb3378a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $72d42ff61cb3378a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Toolbar = void 0;

var $72d42ff61cb3378a$var$_extends2 = $72d42ff61cb3378a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $72d42ff61cb3378a$var$_objectWithoutPropertiesLoose2 = $72d42ff61cb3378a$require$_interopRequireDefault((parcelRequire("c05no")));

var $72d42ff61cb3378a$var$React = $72d42ff61cb3378a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $72d42ff61cb3378a$var$_propTypes = $72d42ff61cb3378a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $72d42ff61cb3378a$var$_clsx = $72d42ff61cb3378a$require$_interopRequireDefault((parcelRequire("9QePP")));

var $QvFCk = parcelRequire("QvFCk");

var $7Cbni = parcelRequire("7Cbni");

var $hwB1M = parcelRequire("hwB1M");

var $ayMG0 = parcelRequire("ayMG0");
const $72d42ff61cb3378a$var$_excluded = [
    "className",
    "render"
];
const $72d42ff61cb3378a$var$ToolbarRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiChartsToolbar',
    slot: 'Root'
})(({ theme: theme })=>({
        flex: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        gap: theme.spacing(0.25),
        padding: theme.spacing(0.5),
        marginBottom: theme.spacing(1.5),
        minHeight: 44,
        boxSizing: 'border-box',
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderRadius: 4
    }));
const $72d42ff61cb3378a$var$Toolbar = module.exports.Toolbar = /*#__PURE__*/ $72d42ff61cb3378a$var$React.forwardRef(function Toolbar(_ref, ref) {
    let { className: className, render: render } = _ref, other = (0, $72d42ff61cb3378a$var$_objectWithoutPropertiesLoose2.default)(_ref, $72d42ff61cb3378a$var$_excluded);
    const element = (0, $QvFCk.useComponentRenderer)($72d42ff61cb3378a$var$ToolbarRoot, render, (0, $72d42ff61cb3378a$var$_extends2.default)({
        role: 'toolbar',
        'aria-orientation': 'horizontal',
        className: (0, $72d42ff61cb3378a$var$_clsx.default)($hwB1M.chartsToolbarClasses.root, className)
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7Cbni.ToolbarContextProvider, {
        children: element
    });
});

});
parcelRegister("7Cbni", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ki8WA = parcelRequire("ki8WA");
Object.keys($ki8WA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ki8WA[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ki8WA[key];
        }
    });
});

var $bu0j8 = parcelRequire("bu0j8");
Object.keys($bu0j8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bu0j8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bu0j8[key];
        }
    });
});

});
parcelRegister("ki8WA", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ec5c6d26ce49ba4a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToolbarContext = void 0;
module.exports.ToolbarContextProvider = $ec5c6d26ce49ba4a$var$ToolbarContextProvider;
module.exports.useToolbarContext = $ec5c6d26ce49ba4a$var$useToolbarContext;

var $ec5c6d26ce49ba4a$var$React = $ec5c6d26ce49ba4a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $ec5c6d26ce49ba4a$var$ToolbarContext = module.exports.ToolbarContext = /*#__PURE__*/ $ec5c6d26ce49ba4a$var$React.createContext(undefined);
function $ec5c6d26ce49ba4a$var$useToolbarContext() {
    const context = $ec5c6d26ce49ba4a$var$React.useContext($ec5c6d26ce49ba4a$var$ToolbarContext);
    if (context === undefined) throw new Error('MUI X: Missing context. Toolbar subcomponents must be placed within a <Toolbar /> component.');
    return context;
}
function $ec5c6d26ce49ba4a$var$ToolbarContextProvider({ children: children }) {
    const [focusableItemId, setFocusableItemId] = $ec5c6d26ce49ba4a$var$React.useState(null);
    const focusableItemIdRef = $ec5c6d26ce49ba4a$var$React.useRef(focusableItemId);
    const [items, setItems] = $ec5c6d26ce49ba4a$var$React.useState([]);
    const getSortedItems = $ec5c6d26ce49ba4a$var$React.useCallback(()=>items.sort($ec5c6d26ce49ba4a$var$sortByDocumentPosition), [
        items
    ]);
    const findEnabledItem = $ec5c6d26ce49ba4a$var$React.useCallback((startIndex, step, wrap = true)=>{
        let index = startIndex;
        const sortedItems = getSortedItems();
        const itemCount = sortedItems.length;
        // Look for enabled items in the specified direction
        for(let i = 0; i < itemCount; i += 1){
            index += step;
            // Handle wrapping around the ends
            if (index >= itemCount) {
                if (!wrap) return -1;
                index = 0;
            } else if (index < 0) {
                if (!wrap) return -1;
                index = itemCount - 1;
            }
            // Return if we found an enabled item
            if (!sortedItems[index].ref.current?.disabled && sortedItems[index].ref.current?.ariaDisabled !== 'true') return index;
        }
        // If we've checked all items and found none enabled
        return -1;
    }, [
        getSortedItems
    ]);
    const registerItem = $ec5c6d26ce49ba4a$var$React.useCallback((id, itemRef)=>{
        setItems((prevItems)=>[
                ...prevItems,
                {
                    id: id,
                    ref: itemRef
                }
            ]);
    }, []);
    const unregisterItem = $ec5c6d26ce49ba4a$var$React.useCallback((id)=>{
        setItems((prevItems)=>prevItems.filter((i)=>i.id !== id));
    }, []);
    const onItemKeyDown = $ec5c6d26ce49ba4a$var$React.useCallback((event)=>{
        if (!focusableItemId) return;
        const sortedItems = getSortedItems();
        const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
        let newIndex = -1;
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, 1);
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, -1);
        } else if (event.key === 'Home') {
            event.preventDefault();
            newIndex = findEnabledItem(-1, 1, false);
        } else if (event.key === 'End') {
            event.preventDefault();
            newIndex = findEnabledItem(sortedItems.length, -1, false);
        }
        // TODO: Check why this is necessary
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        focusableItemId,
        findEnabledItem
    ]);
    const onItemFocus = $ec5c6d26ce49ba4a$var$React.useCallback((id)=>{
        if (focusableItemId !== id) setFocusableItemId(id);
    }, [
        focusableItemId,
        setFocusableItemId
    ]);
    const onItemDisabled = $ec5c6d26ce49ba4a$var$React.useCallback((id)=>{
        const sortedItems = getSortedItems();
        const currentIndex = sortedItems.findIndex((item)=>item.id === id);
        const newIndex = findEnabledItem(currentIndex, 1);
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    $ec5c6d26ce49ba4a$var$React.useEffect(()=>{
        focusableItemIdRef.current = focusableItemId;
    }, [
        focusableItemId
    ]);
    $ec5c6d26ce49ba4a$var$React.useEffect(()=>{
        const sortedItems = getSortedItems();
        if (sortedItems.length > 0) {
            // Set initial focusable item
            if (!focusableItemIdRef.current) {
                setFocusableItemId(sortedItems[0].id);
                return;
            }
            const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemIdRef.current);
            if (!sortedItems[focusableItemIndex]) {
                // Last item has been removed from the items array
                const item = sortedItems[sortedItems.length - 1];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            } else if (focusableItemIndex === -1) {
                // Focused item has been removed from the items array
                const item = sortedItems[focusableItemIndex];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            }
        }
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    const contextValue = $ec5c6d26ce49ba4a$var$React.useMemo(()=>({
            focusableItemId: focusableItemId,
            registerItem: registerItem,
            unregisterItem: unregisterItem,
            onItemKeyDown: onItemKeyDown,
            onItemFocus: onItemFocus,
            onItemDisabled: onItemDisabled
        }), [
        focusableItemId,
        registerItem,
        unregisterItem,
        onItemKeyDown,
        onItemFocus,
        onItemDisabled
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ec5c6d26ce49ba4a$var$ToolbarContext.Provider, {
        value: contextValue,
        children: children
    });
}
/* eslint-disable no-bitwise */ function $ec5c6d26ce49ba4a$var$sortByDocumentPosition(a, b) {
    if (!a.ref.current || !b.ref.current) return 0;
    const position = a.ref.current.compareDocumentPosition(b.ref.current);
    if (!position) return 0;
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}

});

parcelRegister("bu0j8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $85c2bc299b4d11cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $85c2bc299b4d11cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRegisterToolbarButton = $85c2bc299b4d11cb$var$useRegisterToolbarButton;

var $85c2bc299b4d11cb$var$React = $85c2bc299b4d11cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $85c2bc299b4d11cb$var$_useId = $85c2bc299b4d11cb$require$_interopRequireDefault((parcelRequire("hwliF")));

var $ki8WA = parcelRequire("ki8WA");
function $85c2bc299b4d11cb$var$useRegisterToolbarButton(props, ref) {
    const { onKeyDown: onKeyDown, onFocus: onFocus, disabled: disabled, 'aria-disabled': ariaDisabled } = props;
    const id = (0, $85c2bc299b4d11cb$var$_useId.default)();
    const { focusableItemId: focusableItemId, registerItem: registerItem, unregisterItem: unregisterItem, onItemKeyDown: onItemKeyDown, onItemFocus: onItemFocus, onItemDisabled: onItemDisabled } = (0, $ki8WA.useToolbarContext)();
    const handleKeyDown = (event)=>{
        onItemKeyDown(event);
        onKeyDown?.(event);
    };
    const handleFocus = (event)=>{
        onItemFocus(id);
        onFocus?.(event);
    };
    $85c2bc299b4d11cb$var$React.useEffect(()=>{
        registerItem(id, ref);
        return ()=>unregisterItem(id);
    }, [
        id,
        ref,
        registerItem,
        unregisterItem
    ]);
    const previousDisabled = $85c2bc299b4d11cb$var$React.useRef(disabled);
    $85c2bc299b4d11cb$var$React.useEffect(()=>{
        if (previousDisabled.current !== disabled && disabled === true) onItemDisabled(id, disabled);
        previousDisabled.current = disabled;
    }, [
        disabled,
        id,
        onItemDisabled
    ]);
    const previousAriaDisabled = $85c2bc299b4d11cb$var$React.useRef(ariaDisabled);
    $85c2bc299b4d11cb$var$React.useEffect(()=>{
        if (previousAriaDisabled.current !== ariaDisabled && ariaDisabled === true) onItemDisabled(id, true);
        previousAriaDisabled.current = ariaDisabled;
    }, [
        ariaDisabled,
        id,
        onItemDisabled
    ]);
    return {
        tabIndex: focusableItemId === id ? 0 : -1,
        disabled: disabled,
        'aria-disabled': ariaDisabled,
        onKeyDown: handleKeyDown,
        onFocus: handleFocus
    };
}

});


parcelRegister("hwB1M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cc2225c06ddf398b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsToolbarClasses = void 0;

var $cc2225c06ddf398b$var$_generateUtilityClasses = $cc2225c06ddf398b$require$_interopRequireDefault((parcelRequire("5nY49")));
const $cc2225c06ddf398b$var$chartsToolbarClasses = module.exports.chartsToolbarClasses = (0, $cc2225c06ddf398b$var$_generateUtilityClasses.default)('MuiChartsToolbar', [
    'root'
]);

});


parcelRegister("jKq9J", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e6069a379f20a3dd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e6069a379f20a3dd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToolbarButton = void 0;

var $e6069a379f20a3dd$var$_extends2 = $e6069a379f20a3dd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e6069a379f20a3dd$var$_objectWithoutPropertiesLoose2 = $e6069a379f20a3dd$require$_interopRequireDefault((parcelRequire("c05no")));

var $e6069a379f20a3dd$var$_propTypes = $e6069a379f20a3dd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e6069a379f20a3dd$var$React = $e6069a379f20a3dd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $QvFCk = parcelRequire("QvFCk");

var $e6069a379f20a3dd$var$_useForkRef = $e6069a379f20a3dd$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $7Cbni = parcelRequire("7Cbni");

var $dsjdj = parcelRequire("dsjdj");

var $ayMG0 = parcelRequire("ayMG0");
const $e6069a379f20a3dd$var$_excluded = [
    "render",
    "onKeyDown",
    "onFocus",
    "disabled",
    "aria-disabled"
], $e6069a379f20a3dd$var$_excluded2 = [
    "tabIndex"
];
const $e6069a379f20a3dd$var$ToolbarButton = module.exports.ToolbarButton = /*#__PURE__*/ $e6069a379f20a3dd$var$React.forwardRef(function ToolbarButton(props, ref) {
    const { render: render } = props, other = (0, $e6069a379f20a3dd$var$_objectWithoutPropertiesLoose2.default)(props, $e6069a379f20a3dd$var$_excluded);
    const { slots: slots, slotProps: slotProps } = (0, $dsjdj.useChartsSlots)();
    const buttonRef = $e6069a379f20a3dd$var$React.useRef(null);
    const handleRef = (0, $e6069a379f20a3dd$var$_useForkRef.default)(buttonRef, ref);
    const _useRegisterToolbarBu = (0, $7Cbni.useRegisterToolbarButton)(props, buttonRef), { tabIndex: tabIndex } = _useRegisterToolbarBu, toolbarButtonProps = (0, $e6069a379f20a3dd$var$_objectWithoutPropertiesLoose2.default)(_useRegisterToolbarBu, $e6069a379f20a3dd$var$_excluded2);
    const element = (0, $QvFCk.useComponentRenderer)(slots.baseIconButton, render, (0, $e6069a379f20a3dd$var$_extends2.default)({}, slotProps?.baseIconButton, {
        tabIndex: tabIndex
    }, other, toolbarButtonProps, {
        ref: handleRef
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e6069a379f20a3dd$var$React.Fragment, {
        children: element
    });
});

});

parcelRegister("4qQgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("lx7Fr", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FocusedLineMark = $fad2a0a66436380c$var$FocusedLineMark;

var $8xDHs = parcelRequire("8xDHs");

var $7ccUh = parcelRequire("7ccUh");

var $55quD = parcelRequire("55quD");

var $ayMG0 = parcelRequire("ayMG0");
const $fad2a0a66436380c$var$RADIUS = 6;
function $fad2a0a66436380c$var$FocusedLineMark() {
    const theme = (0, $8xDHs.useTheme)();
    const focusedItem = (0, $7ccUh.useFocusedItem)();
    const lineSeries = (0, $55quD.useLineSeriesContext)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55quD.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55quD.useYAxes)();
    if (focusedItem === null || focusedItem.type !== 'line' || !lineSeries) return null;
    const series = lineSeries.series[focusedItem.seriesId];
    if (series.data[focusedItem.dataIndex] == null) // Handle missing data
    return null;
    const xAxisId = series.xAxisId ?? xAxisIds[0];
    const yAxisId = series.yAxisId ?? yAxisIds[0];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
        fill: "none",
        stroke: (theme.vars ?? theme).palette.text.primary,
        strokeWidth: 2,
        x: xAxis[xAxisId].scale(xAxis[xAxisId].data[focusedItem.dataIndex]) - $fad2a0a66436380c$var$RADIUS,
        y: yAxis[yAxisId].scale(series.visibleStackedData[focusedItem.dataIndex][1]) - $fad2a0a66436380c$var$RADIUS,
        width: 2 * $fad2a0a66436380c$var$RADIUS,
        height: 2 * $fad2a0a66436380c$var$RADIUS,
        rx: 3,
        ry: 3
    });
}

});




parcelRegister("iSEYE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $591c1a6c7b6a6225$var$CostBreakdown;

var $j8a65 = parcelRequire("j8a65");

var $591c1a6c7b6a6225$var$_Box = $591c1a6c7b6a6225$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $591c1a6c7b6a6225$var$_Typography = $591c1a6c7b6a6225$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $591c1a6c7b6a6225$var$_Stack = $591c1a6c7b6a6225$var$_interopRequireDefault((parcelRequire("jkhql")));

var $ayMG0 = parcelRequire("ayMG0");
function $591c1a6c7b6a6225$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $591c1a6c7b6a6225$var$CostBreakdown({ breakdown: breakdown }) {
    const total = Math.round(breakdown.reduce((s, d)=>s + d.value, 0) * 100) / 100;
    if (!breakdown.length) return /*#__PURE__*/ (0, $ayMG0.jsxs)($591c1a6c7b6a6225$var$_Box.default, {
        sx: $591c1a6c7b6a6225$var$styles.panel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($591c1a6c7b6a6225$var$_Typography.default, {
                sx: $591c1a6c7b6a6225$var$styles.title,
                children: "Cost breakdown"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($591c1a6c7b6a6225$var$_Typography.default, {
                sx: $591c1a6c7b6a6225$var$styles.sub,
                children: "No data for this period"
            })
        ]
    });
    const pieData = breakdown.map((d)=>({
            id: d.label,
            label: d.label,
            value: d.value,
            color: d.color
        }));
    const pieSettings = {
        width: 200,
        height: 170,
        hideLegend: true
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($591c1a6c7b6a6225$var$_Box.default, {
        sx: $591c1a6c7b6a6225$var$styles.panel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($591c1a6c7b6a6225$var$_Typography.default, {
                sx: $591c1a6c7b6a6225$var$styles.title,
                children: "Cost breakdown"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($591c1a6c7b6a6225$var$_Typography.default, {
                sx: $591c1a6c7b6a6225$var$styles.sub,
                children: [
                    "This period \xB7 \xA3",
                    total,
                    " total"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($591c1a6c7b6a6225$var$_Box.default, {
                sx: {
                    display: 'flex',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($j8a65.PieChart, {
                    series: [
                        {
                            data: pieData,
                            innerRadius: 52,
                            outerRadius: 80,
                            paddingAngle: 2,
                            cornerRadius: 3,
                            highlightScope: {
                                fade: 'global',
                                highlight: 'item'
                            },
                            valueFormatter: (item)=>`\xa3${item.value} (${total > 0 ? Math.round(item.value / total * 100) : 0}%)`
                        }
                    ],
                    sx: {
                        '& .MuiChartsTooltip-root': {
                            fontSize: 12
                        }
                    },
                    ...pieSettings
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($591c1a6c7b6a6225$var$_Stack.default, {
                direction: "row",
                spacing: 1.5,
                sx: {
                    mt: 1,
                    flexWrap: 'wrap'
                },
                role: "list",
                "aria-label": "Cost breakdown legend",
                children: breakdown.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($591c1a6c7b6a6225$var$_Stack.default, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 0.6,
                        role: "listitem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($591c1a6c7b6a6225$var$_Box.default, {
                                sx: {
                                    width: 8,
                                    height: 8,
                                    borderRadius: '2px',
                                    flexShrink: 0,
                                    background: item.color
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($591c1a6c7b6a6225$var$_Typography.default, {
                                sx: $591c1a6c7b6a6225$var$styles.legendLabel,
                                children: [
                                    item.label,
                                    " \xA3",
                                    item.value
                                ]
                            })
                        ]
                    }, item.label))
            })
        ]
    });
}
const $591c1a6c7b6a6225$var$styles = {
    panel: {
        bgcolor: 'var(--color-bg-secondary)',
        borderRadius: 3,
        p: '1.1rem 1.25rem'
    },
    title: {
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--color-text-primary)',
        mb: '2px'
    },
    sub: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary)',
        mb: '0.75rem'
    },
    legendLabel: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary)'
    }
};

});
parcelRegister("j8a65", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ded698c791d90cd7$var$_exportNames = {
    pieClasses: true
};
Object.defineProperty(module.exports, "pieClasses", {
    enumerable: true,
    get: function() {
        return $3fLTI.pieClasses;
    }
});

var $lxigQ = parcelRequire("lxigQ");
Object.keys($lxigQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lxigQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lxigQ[key];
        }
    });
});

var $ggu3K = parcelRequire("ggu3K");
Object.keys($ggu3K).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ggu3K[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ggu3K[key];
        }
    });
});

var $lRW7J = parcelRequire("lRW7J");
Object.keys($lRW7J).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lRW7J[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lRW7J[key];
        }
    });
});

var $3yLQq = parcelRequire("3yLQq");
Object.keys($3yLQq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3yLQq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3yLQq[key];
        }
    });
});

var $5GmZm = parcelRequire("5GmZm");
Object.keys($5GmZm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5GmZm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5GmZm[key];
        }
    });
});

var $cF1d0 = parcelRequire("cF1d0");
Object.keys($cF1d0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cF1d0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cF1d0[key];
        }
    });
});

var $iM0Bo = parcelRequire("iM0Bo");
Object.keys($iM0Bo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iM0Bo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iM0Bo[key];
        }
    });
});

var $5ul2D = parcelRequire("5ul2D");
Object.keys($5ul2D).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ded698c791d90cd7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5ul2D[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5ul2D[key];
        }
    });
});

var $3fLTI = parcelRequire("3fLTI");

});
parcelRegister("lxigQ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fadada33685b4c45$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fadada33685b4c45$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PieChart = void 0;

var $fadada33685b4c45$var$_extends2 = $fadada33685b4c45$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fadada33685b4c45$var$_objectWithoutPropertiesLoose2 = $fadada33685b4c45$require$_interopRequireDefault((parcelRequire("c05no")));

var $fadada33685b4c45$var$React = $fadada33685b4c45$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fadada33685b4c45$var$_propTypes = $fadada33685b4c45$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $2xVLi = parcelRequire("2xVLi");

var $luY0B = parcelRequire("luY0B");

var $anK5t = parcelRequire("anK5t");

var $ggu3K = parcelRequire("ggu3K");

var $hhc1V = parcelRequire("hhc1V");

var $ezMKh = parcelRequire("ezMKh");

var $eSGGd = parcelRequire("eSGGd");

var $3jE6m = parcelRequire("3jE6m");

var $G4UB8 = parcelRequire("G4UB8");

var $5ul2D = parcelRequire("5ul2D");

var $fXrnQ = parcelRequire("fXrnQ");

var $cIYIz = parcelRequire("cIYIz");

var $ayMG0 = parcelRequire("ayMG0");
const $fadada33685b4c45$var$_excluded = [
    "series",
    "width",
    "height",
    "margin",
    "colors",
    "sx",
    "skipAnimation",
    "hideLegend",
    "children",
    "slots",
    "slotProps",
    "onItemClick",
    "loading",
    "highlightedItem",
    "onHighlightChange",
    "className",
    "showToolbar"
];
/**
 * Demos:
 *
 * - [Pie](https://mui.com/x/react-charts/pie/)
 * - [Pie demonstration](https://mui.com/x/react-charts/pie-demo/)
 *
 * API:
 *
 * - [PieChart API](https://mui.com/x/api/charts/pie-chart/)
 */ const $fadada33685b4c45$var$PieChart = module.exports.PieChart = /*#__PURE__*/ $fadada33685b4c45$var$React.forwardRef(function PieChart(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPieChart'
    });
    const { series: series, width: width, height: height, margin: marginProps, colors: colors, sx: sx, skipAnimation: skipAnimation, hideLegend: hideLegend, children: children, slots: slots, slotProps: slotProps, onItemClick: onItemClick, loading: loading, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, className: className, showToolbar: showToolbar } = props, other = (0, $fadada33685b4c45$var$_objectWithoutPropertiesLoose2.default)(props, $fadada33685b4c45$var$_excluded);
    const margin = (0, $fXrnQ.defaultizeMargin)(marginProps, $2xVLi.DEFAULT_PIE_CHART_MARGIN);
    const { chartDataProviderProps: chartDataProviderProps, chartsSurfaceProps: chartsSurfaceProps } = (0, $3jE6m.useChartContainerProps)((0, $fadada33685b4c45$var$_extends2.default)({}, other, {
        series: series.map((s)=>(0, $fadada33685b4c45$var$_extends2.default)({
                type: 'pie'
            }, s)),
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        className: className,
        skipAnimation: skipAnimation,
        plugins: $5ul2D.PIE_CHART_PLUGINS
    }), ref);
    const Tooltip = slots?.tooltip ?? $luY0B.ChartsTooltip;
    const Toolbar = slots?.toolbar;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eSGGd.ChartDataProvider, (0, $fadada33685b4c45$var$_extends2.default)({}, chartDataProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($G4UB8.ChartsWrapper, {
            legendPosition: slotProps?.legend?.position,
            legendDirection: slotProps?.legend?.direction ?? 'vertical',
            sx: sx,
            hideLegend: hideLegend ?? false,
            children: [
                showToolbar && Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $fadada33685b4c45$var$_extends2.default)({}, slotProps?.toolbar)) : null,
                !hideLegend && /*#__PURE__*/ (0, $ayMG0.jsx)($anK5t.ChartsLegend, {
                    direction: slotProps?.legend?.direction ?? 'vertical',
                    slots: slots,
                    slotProps: slotProps
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ezMKh.ChartsSurface, (0, $fadada33685b4c45$var$_extends2.default)({}, chartsSurfaceProps, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ggu3K.PiePlot, {
                            slots: slots,
                            slotProps: slotProps,
                            onItemClick: onItemClick
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cIYIz.FocusedPieArc, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hhc1V.ChartsOverlay, {
                            loading: loading,
                            slots: slots,
                            slotProps: slotProps
                        }),
                        children
                    ]
                })),
                !loading && /*#__PURE__*/ (0, $ayMG0.jsx)(Tooltip, (0, $fadada33685b4c45$var$_extends2.default)({
                    trigger: "item"
                }, slotProps?.tooltip))
            ]
        })
    }));
});

});
parcelRegister("ggu3K", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bd75752a7b6ca857$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PiePlot = $bd75752a7b6ca857$var$PiePlot;

var $bd75752a7b6ca857$var$_propTypes = $bd75752a7b6ca857$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $lRW7J = parcelRequire("lRW7J");

var $3yLQq = parcelRequire("3yLQq");

var $kEOtY = parcelRequire("kEOtY");

var $cfS2L = parcelRequire("cfS2L");

var $3fLTI = parcelRequire("3fLTI");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Pie](https://mui.com/x/react-charts/pie/)
 * - [Pie demonstration](https://mui.com/x/react-charts/pie-demo/)
 *
 * API:
 *
 * - [PiePlot API](https://mui.com/x/api/charts/pie-plot/)
 */ function $bd75752a7b6ca857$var$PiePlot(props) {
    const { skipAnimation: inSkipAnimation, slots: slots, slotProps: slotProps, onItemClick: onItemClick } = props;
    const seriesData = (0, $kEOtY.usePieSeriesContext)();
    const seriesLayout = (0, $kEOtY.usePieSeriesLayout)();
    const skipAnimation = (0, $cfS2L.useSkipAnimation)(inSkipAnimation);
    const classes = (0, $3fLTI.useUtilityClasses)();
    if (seriesData === undefined) return null;
    const { series: series, seriesOrder: seriesOrder } = seriesData;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        children: [
            seriesOrder.map((seriesId)=>{
                const { cornerRadius: cornerRadius, paddingAngle: paddingAngle, data: data, highlighted: highlighted, faded: faded } = series[seriesId];
                return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    className: classes.series,
                    transform: `translate(${seriesLayout[seriesId].center.x}, ${seriesLayout[seriesId].center.y})`,
                    "data-series": seriesId,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($lRW7J.PieArcPlot, {
                        innerRadius: seriesLayout[seriesId].radius.inner,
                        outerRadius: seriesLayout[seriesId].radius.outer,
                        cornerRadius: cornerRadius,
                        paddingAngle: paddingAngle,
                        id: seriesId,
                        data: data,
                        skipAnimation: skipAnimation,
                        highlighted: highlighted,
                        faded: faded,
                        onItemClick: onItemClick,
                        slots: slots,
                        slotProps: slotProps
                    })
                }, seriesId);
            }),
            seriesOrder.map((seriesId)=>{
                const { cornerRadius: cornerRadius, paddingAngle: paddingAngle, arcLabel: arcLabel, arcLabelMinAngle: arcLabelMinAngle, data: data } = series[seriesId];
                return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    className: classes.seriesLabels,
                    transform: `translate(${seriesLayout[seriesId].center.x}, ${seriesLayout[seriesId].center.y})`,
                    "data-series": seriesId,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3yLQq.PieArcLabelPlot, {
                        innerRadius: seriesLayout[seriesId].radius.inner,
                        outerRadius: seriesLayout[seriesId].radius.outer,
                        arcLabelRadius: seriesLayout[seriesId].radius.label,
                        cornerRadius: cornerRadius,
                        paddingAngle: paddingAngle,
                        id: seriesId,
                        data: data,
                        skipAnimation: skipAnimation,
                        arcLabel: arcLabel,
                        arcLabelMinAngle: arcLabelMinAngle,
                        slots: slots,
                        slotProps: slotProps
                    })
                }, seriesId);
            })
        ]
    });
}

});
parcelRegister("lRW7J", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $febba263569ce47d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $febba263569ce47d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PieArcPlot = $febba263569ce47d$var$PieArcPlot;

var $febba263569ce47d$var$_extends2 = $febba263569ce47d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $febba263569ce47d$var$_objectWithoutPropertiesLoose2 = $febba263569ce47d$require$_interopRequireDefault((parcelRequire("c05no")));

var $febba263569ce47d$var$React = $febba263569ce47d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $febba263569ce47d$var$_propTypes = $febba263569ce47d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5GmZm = parcelRequire("5GmZm");

var $kmk64 = parcelRequire("kmk64");

var $ayMG0 = parcelRequire("ayMG0");
const $febba263569ce47d$var$_excluded = [
    "slots",
    "slotProps",
    "innerRadius",
    "outerRadius",
    "cornerRadius",
    "paddingAngle",
    "id",
    "highlighted",
    "faded",
    "data",
    "onItemClick",
    "skipAnimation"
];
function $febba263569ce47d$var$PieArcPlot(props) {
    const { slots: slots, slotProps: slotProps, innerRadius: innerRadius = 0, outerRadius: outerRadius, cornerRadius: cornerRadius = 0, paddingAngle: paddingAngle = 0, id: id, highlighted: highlighted, faded: faded = {
        additionalRadius: -5
    }, data: data, onItemClick: onItemClick, skipAnimation: skipAnimation } = props, other = (0, $febba263569ce47d$var$_objectWithoutPropertiesLoose2.default)(props, $febba263569ce47d$var$_excluded);
    const transformedData = (0, $kmk64.useTransformData)({
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: cornerRadius,
        paddingAngle: paddingAngle,
        id: id,
        highlighted: highlighted,
        faded: faded,
        data: data
    });
    if (data.length === 0) return null;
    const Arc = slots?.pieArc ?? $5GmZm.PieArc;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", (0, $febba263569ce47d$var$_extends2.default)({}, other, {
        children: transformedData.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Arc, (0, $febba263569ce47d$var$_extends2.default)({
                startAngle: item.startAngle,
                endAngle: item.endAngle,
                paddingAngle: item.paddingAngle,
                innerRadius: item.innerRadius,
                outerRadius: item.outerRadius,
                cornerRadius: item.cornerRadius,
                skipAnimation: skipAnimation ?? false,
                id: id,
                color: item.color,
                dataIndex: index,
                isFaded: item.isFaded,
                isHighlighted: item.isHighlighted,
                isFocused: item.isFocused,
                onClick: onItemClick && ((event)=>{
                    onItemClick(event, {
                        type: 'pie',
                        seriesId: id,
                        dataIndex: index
                    }, item);
                })
            }, slotProps?.pieArc), item.dataIndex))
    }));
}

});
parcelRegister("5GmZm", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4232b513080046aa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4232b513080046aa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PieArc = void 0;
module.exports.getPieArcUtilityClass = $4232b513080046aa$var$getPieArcUtilityClass;
module.exports.pieArcClasses = void 0;

var $4232b513080046aa$var$_extends2 = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4232b513080046aa$var$_objectWithoutPropertiesLoose2 = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("c05no")));

var $4232b513080046aa$var$React = $4232b513080046aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4232b513080046aa$var$_propTypes = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4232b513080046aa$var$_clsx = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("9QePP")));

var $4232b513080046aa$var$_composeClasses = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $4232b513080046aa$var$_generateUtilityClass = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $8xDHs = parcelRequire("8xDHs");

var $4232b513080046aa$var$_generateUtilityClasses = $4232b513080046aa$require$_interopRequireDefault((parcelRequire("5nY49")));

var $55quD = parcelRequire("55quD");

var $32gdR = parcelRequire("32gdR");

var $hdpx4 = parcelRequire("hdpx4");

var $ayMG0 = parcelRequire("ayMG0");
const $4232b513080046aa$var$_excluded = [
    "className",
    "classes",
    "color",
    "dataIndex",
    "id",
    "isFaded",
    "isHighlighted",
    "isFocused",
    "onClick",
    "cornerRadius",
    "startAngle",
    "endAngle",
    "innerRadius",
    "outerRadius",
    "paddingAngle",
    "skipAnimation",
    "stroke",
    "skipInteraction"
];
function $4232b513080046aa$var$getPieArcUtilityClass(slot) {
    return (0, $4232b513080046aa$var$_generateUtilityClass.default)('MuiPieArc', slot);
}
const $4232b513080046aa$var$pieArcClasses = module.exports.pieArcClasses = (0, $4232b513080046aa$var$_generateUtilityClasses.default)('MuiPieArc', [
    'root',
    'highlighted',
    'faded',
    'series',
    'focusIndicator'
]);
const $4232b513080046aa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted, dataIndex: dataIndex } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`,
            `data-index-${dataIndex}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded'
        ]
    };
    return (0, $4232b513080046aa$var$_composeClasses.default)(slots, $4232b513080046aa$var$getPieArcUtilityClass, classes);
};
const $4232b513080046aa$var$PieArcRoot = (0, $8xDHs.styled)('path', {
    name: 'MuiPieArc',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.arc // FIXME: Inconsistent naming with slot
})({
    transitionProperty: 'opacity, fill, filter',
    transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
    transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION
});
const $4232b513080046aa$var$PieArc = module.exports.PieArc = /*#__PURE__*/ $4232b513080046aa$var$React.forwardRef(function PieArc(props, ref) {
    const { className: className, classes: innerClasses, color: color, dataIndex: dataIndex, id: id, isFaded: isFaded, isHighlighted: isHighlighted, isFocused: isFocused, onClick: onClick, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, paddingAngle: paddingAngle, skipAnimation: skipAnimation, stroke: strokeProp, skipInteraction: skipInteraction } = props, other = (0, $4232b513080046aa$var$_objectWithoutPropertiesLoose2.default)(props, $4232b513080046aa$var$_excluded);
    const theme = (0, $8xDHs.useTheme)();
    const stroke = strokeProp ?? (theme.vars || theme).palette.background.paper;
    const ownerState = {
        id: id,
        dataIndex: dataIndex,
        classes: innerClasses,
        color: color,
        isFaded: isFaded,
        isHighlighted: isHighlighted,
        isFocused: isFocused
    };
    const classes = $4232b513080046aa$var$useUtilityClasses(ownerState);
    const interactionProps = (0, $hdpx4.useInteractionItemProps)({
        type: 'pie',
        seriesId: id,
        dataIndex: dataIndex
    }, skipInteraction);
    const animatedProps = (0, $55quD.useAnimatePieArc)({
        cornerRadius: cornerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        paddingAngle: paddingAngle,
        skipAnimation: skipAnimation,
        ref: ref
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4232b513080046aa$var$PieArcRoot, (0, $4232b513080046aa$var$_extends2.default)({
        onClick: onClick,
        cursor: onClick ? 'pointer' : 'unset',
        ownerState: ownerState,
        className: (0, $4232b513080046aa$var$_clsx.default)(classes.root, className),
        fill: ownerState.color,
        opacity: ownerState.isFaded ? 0.3 : 1,
        filter: ownerState.isHighlighted ? 'brightness(120%)' : 'none',
        stroke: stroke,
        strokeWidth: 1,
        strokeLinejoin: "round",
        "data-highlighted": ownerState.isHighlighted || undefined,
        "data-faded": ownerState.isFaded || undefined
    }, other, interactionProps, animatedProps));
});

});

parcelRegister("kmk64", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $ed25738c06148f8b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ed25738c06148f8b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useTransformData = $ed25738c06148f8b$var$useTransformData;

var $ed25738c06148f8b$var$_extends2 = $ed25738c06148f8b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ed25738c06148f8b$var$React = $ed25738c06148f8b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jjapK = parcelRequire("jjapK");

var $gtDed = parcelRequire("gtDed");

var $lBby3 = parcelRequire("lBby3");
function $ed25738c06148f8b$var$useTransformData(series) {
    const { id: seriesId, data: data, faded: faded, highlighted: highlighted } = series;
    const { isFaded: isItemFaded, isHighlighted: isItemHighlighted } = (0, $jjapK.useItemHighlightedGetter)();
    const isItemFocused = (0, $gtDed.useIsItemFocusedGetter)();
    const dataWithHighlight = $ed25738c06148f8b$var$React.useMemo(()=>data.map((item, itemIndex)=>{
            const currentItem = {
                seriesId: seriesId,
                dataIndex: itemIndex
            };
            const isHighlighted = isItemHighlighted(currentItem);
            const isFaded = !isHighlighted && isItemFaded(currentItem);
            const isFocused = isItemFocused({
                type: 'pie',
                seriesId: seriesId,
                dataIndex: itemIndex
            });
            // TODO v9: Replace the second argument with the result of useSeriesLayout
            const arcSizes = (0, $lBby3.getModifiedArcProperties)(series, {
                radius: {
                    inner: series.innerRadius ?? 0,
                    outer: series.outerRadius,
                    label: series.arcLabelRadius ?? 0,
                    available: 0
                }
            }, isHighlighted, isFaded);
            const attributesOverride = (0, $ed25738c06148f8b$var$_extends2.default)({
                additionalRadius: 0
            }, isFaded && faded || isHighlighted && highlighted || {});
            return (0, $ed25738c06148f8b$var$_extends2.default)({}, item, attributesOverride, {
                dataIndex: itemIndex,
                isFaded: isFaded,
                isHighlighted: isHighlighted,
                isFocused: isFocused
            }, arcSizes);
        }), [
        data,
        seriesId,
        isItemHighlighted,
        isItemFaded,
        isItemFocused,
        series,
        faded,
        highlighted
    ]);
    return dataWithHighlight;
}

});
parcelRegister("gtDed", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsItemFocusedGetter = $bfedc8ad09c792e7$var$useIsItemFocusedGetter;

var $325pS = parcelRequire("325pS");

var $7ccUh = parcelRequire("7ccUh");
/**
 * A hook to check focus state of multiple items.
 * If you're interested by a single one, consider using `useIsItemFocused`.
 *
 * @returns {(item: FocusedItemData) => boolean} callback to get the state of the item.
 */ function $bfedc8ad09c792e7$var$useIsItemFocusedGetter() {
    const focusedItem = (0, $7ccUh.useFocusedItem)();
    return (item)=>focusedItem !== null && (0, $325pS.fastObjectShallowCompare)(focusedItem, item);
}

});

parcelRegister("lBby3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fb9602ed50e6f97e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getModifiedArcProperties = $fb9602ed50e6f97e$var$getModifiedArcProperties;

var $fb9602ed50e6f97e$var$_extends2 = $fb9602ed50e6f97e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1hcZZ = parcelRequire("1hcZZ");
/**
 * Function that returns arc properties after applying transformation from highlight/fade states.
 */ function $fb9602ed50e6f97e$var$getModifiedArcProperties(seriesDef, seriesLayout, isHighlighted, isFaded) {
    const { faded: faded, highlighted: highlighted, paddingAngle: basePaddingAngle = 0, cornerRadius: baseCornerRadius = 0 } = seriesDef;
    const { radius: { inner: baseInnerRadius = 0, label: baseArcLabelRadius, outer: baseOuterRadius } } = seriesLayout;
    const attributesOverride = (0, $fb9602ed50e6f97e$var$_extends2.default)({
        additionalRadius: 0
    }, isFaded && faded || isHighlighted && highlighted || {});
    const paddingAngle = Math.max(0, (0, $1hcZZ.deg2rad)(attributesOverride.paddingAngle ?? basePaddingAngle));
    const innerRadius = Math.max(0, attributesOverride.innerRadius ?? baseInnerRadius);
    const outerRadius = Math.max(0, attributesOverride.outerRadius ?? baseOuterRadius + attributesOverride.additionalRadius);
    const cornerRadius = attributesOverride.cornerRadius ?? baseCornerRadius;
    const arcLabelRadius = attributesOverride.arcLabelRadius ?? baseArcLabelRadius ?? (innerRadius + outerRadius) / 2;
    return {
        paddingAngle: paddingAngle,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: cornerRadius,
        arcLabelRadius: arcLabelRadius
    };
}

});



parcelRegister("3yLQq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2979a905cd59dd6c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2979a905cd59dd6c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PieArcLabelPlot = $2979a905cd59dd6c$var$PieArcLabelPlot;

var $2979a905cd59dd6c$var$_objectWithoutPropertiesLoose2 = $2979a905cd59dd6c$require$_interopRequireDefault((parcelRequire("c05no")));

var $2979a905cd59dd6c$var$_extends2 = $2979a905cd59dd6c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2979a905cd59dd6c$var$React = $2979a905cd59dd6c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2979a905cd59dd6c$var$_propTypes = $2979a905cd59dd6c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $kmk64 = parcelRequire("kmk64");

var $cF1d0 = parcelRequire("cF1d0");

var $erYIG = parcelRequire("erYIG");

var $ayMG0 = parcelRequire("ayMG0");
const $2979a905cd59dd6c$var$_excluded = [
    "arcLabel",
    "arcLabelMinAngle",
    "arcLabelRadius",
    "cornerRadius",
    "data",
    "faded",
    "highlighted",
    "id",
    "innerRadius",
    "outerRadius",
    "paddingAngle",
    "skipAnimation",
    "slotProps",
    "slots"
];
const $2979a905cd59dd6c$var$RATIO = 180 / Math.PI;
function $2979a905cd59dd6c$var$getItemLabel(arcLabel, arcLabelMinAngle, item) {
    if (!arcLabel) return null;
    const angle = (item.endAngle - item.startAngle) * $2979a905cd59dd6c$var$RATIO;
    if (angle < arcLabelMinAngle) return null;
    switch(arcLabel){
        case 'label':
            return (0, $erYIG.getLabel)(item.label, 'arc');
        case 'value':
            return item.value?.toString();
        case 'formattedValue':
            return item.formattedValue;
        default:
            return arcLabel((0, $2979a905cd59dd6c$var$_extends2.default)({}, item, {
                label: (0, $erYIG.getLabel)(item.label, 'arc')
            }));
    }
}
function $2979a905cd59dd6c$var$PieArcLabelPlot(props) {
    const { arcLabel: arcLabel, arcLabelMinAngle: arcLabelMinAngle = 0, arcLabelRadius: arcLabelRadius, cornerRadius: cornerRadius = 0, data: data, faded: faded = {
        additionalRadius: -5
    }, highlighted: highlighted, id: id, innerRadius: innerRadius, outerRadius: outerRadius, paddingAngle: paddingAngle = 0, skipAnimation: skipAnimation, slotProps: slotProps, slots: slots } = props, other = (0, $2979a905cd59dd6c$var$_objectWithoutPropertiesLoose2.default)(props, $2979a905cd59dd6c$var$_excluded);
    const transformedData = (0, $kmk64.useTransformData)({
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        arcLabelRadius: arcLabelRadius,
        cornerRadius: cornerRadius,
        paddingAngle: paddingAngle,
        id: id,
        highlighted: highlighted,
        faded: faded,
        data: data
    });
    if (data.length === 0) return null;
    const ArcLabel = slots?.pieArcLabel ?? $cF1d0.PieArcLabel;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", (0, $2979a905cd59dd6c$var$_extends2.default)({}, other, {
        children: transformedData.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)(ArcLabel, (0, $2979a905cd59dd6c$var$_extends2.default)({
                startAngle: item.startAngle,
                endAngle: item.endAngle,
                paddingAngle: item.paddingAngle,
                innerRadius: item.innerRadius,
                outerRadius: item.outerRadius,
                arcLabelRadius: item.arcLabelRadius,
                cornerRadius: item.cornerRadius,
                hidden: item.hidden,
                id: id,
                color: item.color,
                isFaded: item.isFaded,
                isHighlighted: item.isHighlighted,
                formattedArcLabel: $2979a905cd59dd6c$var$getItemLabel(arcLabel, arcLabelMinAngle, item),
                skipAnimation: skipAnimation ?? false
            }, slotProps?.pieArcLabel), item.id ?? item.dataIndex))
    }));
}

});
parcelRegister("cF1d0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $937a40620eee78ac$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $937a40620eee78ac$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PieArcLabel = void 0;
module.exports.getPieArcLabelUtilityClass = $937a40620eee78ac$var$getPieArcLabelUtilityClass;
module.exports.pieArcLabelClasses = void 0;

var $937a40620eee78ac$var$_extends2 = $937a40620eee78ac$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $937a40620eee78ac$var$_objectWithoutPropertiesLoose2 = $937a40620eee78ac$require$_interopRequireDefault((parcelRequire("c05no")));

var $937a40620eee78ac$var$React = $937a40620eee78ac$require$_interopRequireWildcard((parcelRequire("acw62")));

var $937a40620eee78ac$var$_propTypes = $937a40620eee78ac$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $937a40620eee78ac$var$_composeClasses = $937a40620eee78ac$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $937a40620eee78ac$var$_generateUtilityClass = $937a40620eee78ac$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $8xDHs = parcelRequire("8xDHs");

var $937a40620eee78ac$var$_generateUtilityClasses = $937a40620eee78ac$require$_interopRequireDefault((parcelRequire("5nY49")));

var $32gdR = parcelRequire("32gdR");

var $kWO2K = parcelRequire("kWO2K");

var $ayMG0 = parcelRequire("ayMG0");
const $937a40620eee78ac$var$_excluded = [
    "id",
    "classes",
    "color",
    "startAngle",
    "endAngle",
    "paddingAngle",
    "arcLabelRadius",
    "innerRadius",
    "outerRadius",
    "cornerRadius",
    "formattedArcLabel",
    "isHighlighted",
    "isFaded",
    "skipAnimation",
    "hidden"
];
function $937a40620eee78ac$var$getPieArcLabelUtilityClass(slot) {
    return (0, $937a40620eee78ac$var$_generateUtilityClass.default)('MuiPieArcLabel', slot);
}
const $937a40620eee78ac$var$pieArcLabelClasses = module.exports.pieArcLabelClasses = (0, $937a40620eee78ac$var$_generateUtilityClasses.default)('MuiPieArcLabel', [
    'root',
    'highlighted',
    'faded',
    'animate',
    'series'
]);
const $937a40620eee78ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted, skipAnimation: skipAnimation } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded',
            !skipAnimation && 'animate'
        ]
    };
    return (0, $937a40620eee78ac$var$_composeClasses.default)(slots, $937a40620eee78ac$var$getPieArcLabelUtilityClass, classes);
};
const $937a40620eee78ac$var$PieArcLabelRoot = (0, $8xDHs.styled)('text', {
    name: 'MuiPieArcLabel',
    slot: 'Root'
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.text.primary,
        textAnchor: 'middle',
        dominantBaseline: 'middle',
        pointerEvents: 'none',
        animationName: 'animate-opacity',
        animationDuration: '0s',
        animationTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION,
        transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
        transitionProperty: 'opacity',
        transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION,
        [`&.${$937a40620eee78ac$var$pieArcLabelClasses.animate}`]: {
            animationDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`
        },
        '@keyframes animate-opacity': {
            from: {
                opacity: 0
            }
        }
    }));
const $937a40620eee78ac$var$PieArcLabel = module.exports.PieArcLabel = /*#__PURE__*/ $937a40620eee78ac$var$React.forwardRef(function PieArcLabel(props, ref) {
    const { id: id, classes: innerClasses, color: color, startAngle: startAngle, endAngle: endAngle, paddingAngle: paddingAngle, arcLabelRadius: arcLabelRadius, cornerRadius: cornerRadius, formattedArcLabel: formattedArcLabel, isHighlighted: isHighlighted, isFaded: isFaded, skipAnimation: skipAnimation, hidden: hidden } = props, other = (0, $937a40620eee78ac$var$_objectWithoutPropertiesLoose2.default)(props, $937a40620eee78ac$var$_excluded);
    const ownerState = {
        id: id,
        classes: innerClasses,
        color: color,
        isFaded: isFaded,
        isHighlighted: isHighlighted,
        skipAnimation: skipAnimation
    };
    const classes = $937a40620eee78ac$var$useUtilityClasses(ownerState);
    const animatedProps = (0, $kWO2K.useAnimatePieArcLabel)({
        cornerRadius: cornerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: arcLabelRadius,
        outerRadius: arcLabelRadius,
        paddingAngle: paddingAngle,
        skipAnimation: skipAnimation,
        ref: ref
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($937a40620eee78ac$var$PieArcLabelRoot, (0, $937a40620eee78ac$var$_extends2.default)({
        className: classes.root
    }, other, animatedProps, {
        opacity: hidden ? 0 : 1,
        children: formattedArcLabel
    }));
});

});


parcelRegister("3fLTI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25e7ed4bf8a05ef2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPieUtilityClass = $25e7ed4bf8a05ef2$var$getPieUtilityClass;
module.exports.useUtilityClasses = module.exports.pieClasses = void 0;

var $25e7ed4bf8a05ef2$var$_generateUtilityClass = $25e7ed4bf8a05ef2$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $25e7ed4bf8a05ef2$var$_composeClasses = $25e7ed4bf8a05ef2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $25e7ed4bf8a05ef2$var$_generateUtilityClasses = $25e7ed4bf8a05ef2$require$_interopRequireDefault((parcelRequire("5nY49")));
function $25e7ed4bf8a05ef2$var$getPieUtilityClass(slot) {
    return (0, $25e7ed4bf8a05ef2$var$_generateUtilityClass.default)('MuiPieChart', slot);
}
const $25e7ed4bf8a05ef2$var$pieClasses = module.exports.pieClasses = (0, $25e7ed4bf8a05ef2$var$_generateUtilityClasses.default)('MuiPieChart', [
    'root',
    'series',
    'seriesLabels'
]);
const $25e7ed4bf8a05ef2$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        series: [
            'series'
        ],
        seriesLabels: [
            'seriesLabels'
        ]
    };
    return (0, $25e7ed4bf8a05ef2$var$_composeClasses.default)(slots, $25e7ed4bf8a05ef2$var$getPieUtilityClass, classes);
};
module.exports.useUtilityClasses = $25e7ed4bf8a05ef2$var$useUtilityClasses;

});


parcelRegister("5ul2D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PIE_CHART_PLUGINS = void 0;

var $8j56i = parcelRequire("8j56i");

var $d8Csh = parcelRequire("d8Csh");

var $cZLDK = parcelRequire("cZLDK");

var $cp50o = parcelRequire("cp50o");

var $fgykb = parcelRequire("fgykb");
const $3ff013790e6fe1eb$var$PIE_CHART_PLUGINS = module.exports.PIE_CHART_PLUGINS = [
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $cZLDK.useChartHighlight,
    $fgykb.useChartVisibilityManager,
    $cp50o.useChartKeyboardNavigation
];

});

parcelRegister("cIYIz", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9438b164724d3344$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9438b164724d3344$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FocusedPieArc = $9438b164724d3344$var$FocusedPieArc;

var $9438b164724d3344$var$_extends2 = $9438b164724d3344$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9438b164724d3344$var$_objectWithoutPropertiesLoose2 = $9438b164724d3344$require$_interopRequireDefault((parcelRequire("c05no")));

var $9438b164724d3344$var$React = $9438b164724d3344$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $7ccUh = parcelRequire("7ccUh");

var $kEOtY = parcelRequire("kEOtY");

var $5GmZm = parcelRequire("5GmZm");

var $3N2dU = parcelRequire("3N2dU");

var $lBby3 = parcelRequire("lBby3");

var $ayMG0 = parcelRequire("ayMG0");
const $9438b164724d3344$var$_excluded = [
    "arcLabelRadius"
];
function $9438b164724d3344$var$FocusedPieArc(props) {
    const theme = (0, $8xDHs.useTheme)();
    const focusedItem = (0, $7ccUh.useFocusedItem)();
    const pieSeriesLayout = (0, $kEOtY.usePieSeriesLayout)();
    const { isHighlighted: isHighlighted, isFaded: isFaded } = (0, $3N2dU.useItemHighlighted)(focusedItem);
    const pieSeries = (0, $kEOtY.usePieSeriesContext)();
    if (focusedItem === null || focusedItem.type !== 'pie' || !pieSeries) return null;
    const series = pieSeries?.series[focusedItem.seriesId];
    const { center: center, radius: radius } = pieSeriesLayout[focusedItem.seriesId];
    if (!series || !center || !radius) return null;
    const item = series.data[focusedItem.dataIndex];
    const _getModifiedArcProper = (0, $lBby3.getModifiedArcProperties)(series, pieSeriesLayout[focusedItem.seriesId], isHighlighted, isFaded), arcSizes = (0, $9438b164724d3344$var$_objectWithoutPropertiesLoose2.default)(_getModifiedArcProper, $9438b164724d3344$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5GmZm.PieArc, (0, $9438b164724d3344$var$_extends2.default)({
        transform: `translate(${pieSeriesLayout[series.id].center.x}, ${pieSeriesLayout[series.id].center.y})`,
        startAngle: item.startAngle,
        endAngle: item.endAngle,
        color: "transparent",
        pointerEvents: "none",
        skipInteraction: true,
        skipAnimation: true,
        stroke: (theme.vars ?? theme).palette.text.primary,
        id: series.id,
        className: $5GmZm.pieArcClasses.focusIndicator,
        dataIndex: focusedItem.dataIndex,
        isFaded: false,
        isHighlighted: false,
        isFocused: false,
        strokeWidth: 3
    }, arcSizes, props));
}

});




parcelRegister("4xUFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67f92d41907a04b7$var$AirQualityPanel;

var $67f92d41907a04b7$var$_react = $67f92d41907a04b7$var$_interopRequireDefault((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
function $67f92d41907a04b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $67f92d41907a04b7$var$RADIUS = 44;
const $67f92d41907a04b7$var$CIRCUMFERENCE = 2 * Math.PI * $67f92d41907a04b7$var$RADIUS;
function $67f92d41907a04b7$var$aqiToOffset(aqi, max = 200) {
    return $67f92d41907a04b7$var$CIRCUMFERENCE * (1 - Math.min(aqi / max, 1));
}
function $67f92d41907a04b7$var$AirQualityPanel({ airQuality: airQuality }) {
    const { aqi: aqi, status: status, statusColor: statusColor, particulates: particulates } = airQuality;
    const offset = $67f92d41907a04b7$var$aqiToOffset(aqi);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $67f92d41907a04b7$var$styles.panel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $67f92d41907a04b7$var$styles.title,
                children: "Air Pollution"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $67f92d41907a04b7$var$styles.sub,
                children: "Realtime"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "air-quality-index-panel",
                style: $67f92d41907a04b7$var$styles.gaugeWrap,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $67f92d41907a04b7$var$styles.ringWrap,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                viewBox: "0 0 110 110",
                                width: 110,
                                height: 110,
                                role: "img",
                                "aria-label": `Air quality index ${aqi} \u{2014} ${status}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: 55,
                                        cy: 55,
                                        r: $67f92d41907a04b7$var$RADIUS,
                                        stroke: "var(--color-border-tertiary, rgba(0,0,0,0.1))",
                                        strokeWidth: 8,
                                        fill: "none"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: 55,
                                        cy: 55,
                                        r: $67f92d41907a04b7$var$RADIUS,
                                        stroke: statusColor,
                                        strokeWidth: 8,
                                        fill: "none",
                                        strokeDasharray: $67f92d41907a04b7$var$CIRCUMFERENCE,
                                        strokeDashoffset: offset,
                                        strokeLinecap: "round",
                                        transform: "rotate(-90 55 55)",
                                        style: {
                                            transition: 'stroke-dashoffset 0.8s ease'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $67f92d41907a04b7$var$styles.ringCenter,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $67f92d41907a04b7$var$styles.aqiNum,
                                        children: aqi
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            ...$67f92d41907a04b7$var$styles.aqiStatus,
                                            color: statusColor
                                        },
                                        children: status.toUpperCase()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $67f92d41907a04b7$var$styles.particulateList,
                        children: particulates.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $67f92d41907a04b7$var$styles.particulateRow,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: $67f92d41907a04b7$var$styles.particulateName,
                                        children: p.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: $67f92d41907a04b7$var$styles.barTrack,
                                        role: "progressbar",
                                        "aria-valuenow": p.pct,
                                        "aria-valuemin": 0,
                                        "aria-valuemax": 100,
                                        "aria-label": `${p.name} ${p.value} ${p.unit}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                ...$67f92d41907a04b7$var$styles.barFill,
                                                width: `${p.pct}%`,
                                                background: p.color
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: $67f92d41907a04b7$var$styles.particulateVal,
                                        children: [
                                            p.value,
                                            " ",
                                            p.unit
                                        ]
                                    })
                                ]
                            }, p.name))
                    })
                ]
            })
        ]
    });
}
const $67f92d41907a04b7$var$styles = {
    panel: {
        background: 'var(--color-bg-secondary, #f5f5f3)',
        borderRadius: 12,
        padding: '1.1rem 1.25rem',
        fontFamily: "'Syne', sans-serif"
    },
    title: {
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--color-text-primary, #2C2C2A)',
        margin: '0 0 0.15rem'
    },
    sub: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary, #5F5E5A)',
        margin: '0 0 1rem'
    },
    gaugeWrap: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.75rem'
    },
    ringWrap: {
        position: 'relative',
        width: 110,
        height: 110,
        flexShrink: 0
    },
    ringCenter: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    aqiNum: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 24,
        fontWeight: 400,
        color: 'var(--color-text-primary, #2C2C2A)',
        lineHeight: 1
    },
    aqiStatus: {
        fontSize: 10,
        fontWeight: 600,
        marginTop: 2,
        letterSpacing: '0.04em'
    },
    particulateList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 7,
        width: '100%'
    },
    particulateRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    particulateName: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary, #5F5E5A)',
        width: 48,
        flexShrink: 0
    },
    barTrack: {
        flex: 1,
        height: 4,
        background: 'var(--color-border-tertiary, rgba(0,0,0,0.1))',
        borderRadius: 2,
        overflow: 'hidden'
    },
    barFill: {
        height: '100%',
        borderRadius: 2,
        transition: 'width 0.6s ease'
    },
    particulateVal: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-primary, #2C2C2A)',
        fontWeight: 500,
        width: 72,
        textAlign: 'right',
        flexShrink: 0
    }
};

});

parcelRegister("3zuzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7e938fc100daa24$var$VibrationPanel;

var $c7e938fc100daa24$var$_Box = $c7e938fc100daa24$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $c7e938fc100daa24$var$_Typography = $c7e938fc100daa24$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $i1xAO = parcelRequire("i1xAO");

var $8xDHs = parcelRequire("8xDHs");

var $hZOCy = parcelRequire("hZOCy");

var $ayMG0 = parcelRequire("ayMG0");
function $c7e938fc100daa24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7e938fc100daa24$var$SERIES_COLORS = {
    zrv1: '#1D9E75',
    xrv1: '#378ADD',
    zpv1: '#BA7517',
    xpv1: '#D4537E'
};
const $c7e938fc100daa24$var$LEGEND_ITEMS = [
    {
        key: 'zrv1',
        label: 'Z-Axis RMS',
        color: $c7e938fc100daa24$var$SERIES_COLORS.zrv1
    },
    {
        key: 'xrv1',
        label: 'X-Axis RMS',
        color: $c7e938fc100daa24$var$SERIES_COLORS.xrv1
    },
    {
        key: 'zpv1',
        label: 'Z-Axis Peak',
        color: $c7e938fc100daa24$var$SERIES_COLORS.zpv1
    },
    {
        key: 'xpv1',
        label: 'X-Axis Peak',
        color: $c7e938fc100daa24$var$SERIES_COLORS.xpv1
    }
];
function $c7e938fc100daa24$var$VibrationPanel({ vibration: vibration }) {
    const theme = (0, $8xDHs.useTheme)();
    const tickColor = theme.palette.text.secondary;
    const { hasData: hasData, gauges: gauges, series: series } = vibration;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c7e938fc100daa24$var$_Box.default, {
        style: {
            background: 'var(--color-bg-secondary)',
            borderRadius: 12,
            padding: '1.1rem 1.25rem',
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Typography.default, {
                style: {
                    fontFamily: "'Syne', sans-serif",
                    fontSize: 13,
                    fontWeight: 600,
                    color: 'var(--color-text-primary)'
                },
                children: "Vibration Monitoring"
            }),
            !hasData ? /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                    py: 4
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Typography.default, {
                    sx: {
                        fontFamily: "'DM Mono', monospace",
                        fontSize: 12,
                        color: 'var(--color-text-secondary)'
                    },
                    children: "No vibration data for this period"
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'center',
                            mb: 1
                        },
                        children: gauges.map((gauge)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($c7e938fc100daa24$var$_Box.default, {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 0.5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                                        sx: {
                                            width: 110,
                                            height: 110
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($hZOCy.Gauge, {
                                            value: gauge.value,
                                            valueMin: 0,
                                            valueMax: gauge.max,
                                            cornerRadius: "50%",
                                            sx: {
                                                [`& .${$hZOCy.gaugeClasses.valueText}`]: {
                                                    fontSize: 14,
                                                    fontFamily: "'DM Mono', monospace",
                                                    fill: 'var(--color-text-primary)'
                                                },
                                                [`& .${$hZOCy.gaugeClasses.valueArc}`]: {
                                                    fill: gauge.statusColor
                                                },
                                                [`& .${$hZOCy.gaugeClasses.referenceArc}`]: {
                                                    fill: 'rgba(128,128,128,0.15)'
                                                }
                                            },
                                            text: `${gauge.value.toFixed(4)}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Typography.default, {
                                        sx: {
                                            fontFamily: "'Syne', sans-serif",
                                            fontSize: 11,
                                            fontWeight: 600,
                                            color: 'var(--color-text-primary)',
                                            textAlign: 'center'
                                        },
                                        children: gauge.label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                                        sx: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            px: 1,
                                            py: 0.2,
                                            borderRadius: '4px',
                                            background: `${gauge.statusColor}25`,
                                            border: `1px solid ${gauge.statusColor}`
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Typography.default, {
                                            sx: {
                                                fontFamily: "'DM Mono', monospace",
                                                fontSize: 10,
                                                fontWeight: 600,
                                                color: gauge.statusColor
                                            },
                                            children: gauge.status
                                        })
                                    })
                                ]
                            }, gauge.label))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            gap: 1.5,
                            flexWrap: 'wrap',
                            mb: 0.5,
                            justifyContent: 'center'
                        },
                        children: $c7e938fc100daa24$var$LEGEND_ITEMS.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($c7e938fc100daa24$var$_Box.default, {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                                        sx: {
                                            width: 8,
                                            height: 8,
                                            borderRadius: '2px',
                                            background: item.color,
                                            flexShrink: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Typography.default, {
                                        sx: {
                                            fontFamily: "'DM Mono', monospace",
                                            fontSize: 11,
                                            color: 'var(--color-text-secondary)'
                                        },
                                        children: item.label
                                    })
                                ]
                            }, item.key))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c7e938fc100daa24$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($i1xAO.LineChart, {
                            xAxis: [
                                {
                                    data: series.labels.map((_, i)=>i),
                                    valueFormatter: (i, ctx)=>{
                                        if (ctx.location === 'tooltip') {
                                            const raw = series.buckets[i];
                                            if (raw) return new Date(raw).toLocaleString('en-GB', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            });
                                        }
                                        return series.labels[i] ?? '';
                                    },
                                    tickLabelStyle: {
                                        fontSize: 10,
                                        fill: tickColor
                                    },
                                    scaleType: 'point'
                                }
                            ],
                            yAxis: [
                                {
                                    tickLabelStyle: {
                                        fontSize: 10,
                                        fill: tickColor
                                    },
                                    label: 'mm/s'
                                }
                            ],
                            series: [
                                {
                                    id: 'zrv1',
                                    label: 'Z-Axis RMS',
                                    data: series.zrv1,
                                    color: $c7e938fc100daa24$var$SERIES_COLORS.zrv1,
                                    showMark: false,
                                    curve: 'catmullRom'
                                },
                                {
                                    id: 'xrv1',
                                    label: 'X-Axis RMS',
                                    data: series.xrv1,
                                    color: $c7e938fc100daa24$var$SERIES_COLORS.xrv1,
                                    showMark: false,
                                    curve: 'catmullRom'
                                },
                                {
                                    id: 'zpv1',
                                    label: 'Z-Axis Peak',
                                    data: series.zpv1,
                                    color: $c7e938fc100daa24$var$SERIES_COLORS.zpv1,
                                    showMark: false,
                                    curve: 'catmullRom'
                                },
                                {
                                    id: 'xpv1',
                                    label: 'X-Axis Peak',
                                    data: series.xpv1,
                                    color: $c7e938fc100daa24$var$SERIES_COLORS.xpv1,
                                    showMark: false,
                                    curve: 'catmullRom'
                                }
                            ],
                            grid: {
                                horizontal: true
                            },
                            height: 180,
                            margin: {
                                top: 8,
                                right: 16,
                                bottom: 30,
                                left: 44
                            },
                            slotProps: {
                                legend: {
                                    hidden: true
                                }
                            },
                            slots: {
                                legend: ()=>null
                            },
                            sx: {
                                '& .MuiMarkElement-root': {
                                    outline: 'none'
                                },
                                '& .MuiChartsLegend-root': {
                                    display: 'none'
                                }
                            }
                        })
                    })
                ]
            })
        ]
    });
}
const $c7e938fc100daa24$var$styles = {
    panel: {
        background: 'var(--color-bg-secondary)',
        borderRadius: 3,
        p: '1.1rem 1.25rem',
        display: 'flex',
        flexDirection: 'column',
        gap: 1
    },
    title: {
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--color-text-primary)',
        mb: '2px'
    },
    sub: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary)',
        mb: 0.5
    }
};

});
parcelRegister("hZOCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d19f666e9d842118$var$_exportNames = {
    useGaugeState: true
};
Object.defineProperty(module.exports, "useGaugeState", {
    enumerable: true,
    get: function() {
        return $idClk.useGaugeState;
    }
});

var $k2Z0a = parcelRequire("k2Z0a");
Object.keys($k2Z0a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d19f666e9d842118$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $k2Z0a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $k2Z0a[key];
        }
    });
});

var $25lqW = parcelRequire("25lqW");
Object.keys($25lqW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d19f666e9d842118$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $25lqW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $25lqW[key];
        }
    });
});

var $4C62e = parcelRequire("4C62e");
Object.keys($4C62e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d19f666e9d842118$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4C62e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4C62e[key];
        }
    });
});

var $fBxsU = parcelRequire("fBxsU");
Object.keys($fBxsU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d19f666e9d842118$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fBxsU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fBxsU[key];
        }
    });
});

var $bLrAv = parcelRequire("bLrAv");
Object.keys($bLrAv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d19f666e9d842118$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bLrAv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bLrAv[key];
        }
    });
});

var $5GSMX = parcelRequire("5GSMX");
Object.keys($5GSMX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d19f666e9d842118$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5GSMX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5GSMX[key];
        }
    });
});

var $idClk = parcelRequire("idClk");

});
parcelRegister("k2Z0a", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e98350379dfc71a6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e98350379dfc71a6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Gauge = void 0;

var $e98350379dfc71a6$var$_extends2 = $e98350379dfc71a6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e98350379dfc71a6$var$_objectWithoutPropertiesLoose2 = $e98350379dfc71a6$require$_interopRequireDefault((parcelRequire("c05no")));

var $e98350379dfc71a6$var$React = $e98350379dfc71a6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e98350379dfc71a6$var$_propTypes = $e98350379dfc71a6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e98350379dfc71a6$var$_composeClasses = $e98350379dfc71a6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $e98350379dfc71a6$var$_clsx = $e98350379dfc71a6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $25lqW = parcelRequire("25lqW");

var $fBxsU = parcelRequire("fBxsU");

var $bLrAv = parcelRequire("bLrAv");

var $5GSMX = parcelRequire("5GSMX");

var $4C62e = parcelRequire("4C62e");

var $ayMG0 = parcelRequire("ayMG0");
const $e98350379dfc71a6$var$_excluded = [
    "text",
    "children",
    "classes",
    "className",
    "skipAnimation"
];
const $e98350379dfc71a6$var$useUtilityClasses = (props)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $e98350379dfc71a6$var$_composeClasses.default)(slots, $5GSMX.getGaugeUtilityClass, classes);
};
const $e98350379dfc71a6$var$Gauge = module.exports.Gauge = /*#__PURE__*/ $e98350379dfc71a6$var$React.forwardRef(function Gauge(props, ref) {
    const { text: text, children: children, className: className, skipAnimation: skipAnimation } = props, other = (0, $e98350379dfc71a6$var$_objectWithoutPropertiesLoose2.default)(props, $e98350379dfc71a6$var$_excluded);
    const classes = $e98350379dfc71a6$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($25lqW.GaugeContainer, (0, $e98350379dfc71a6$var$_extends2.default)({}, other, {
        className: (0, $e98350379dfc71a6$var$_clsx.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($bLrAv.GaugeReferenceArc, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fBxsU.GaugeValueArc, {
                skipAnimation: skipAnimation
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($4C62e.GaugeValueText, {
                text: text
            }),
            children
        ]
    }));
});

});
parcelRegister("25lqW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $184caca532a50919$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $184caca532a50919$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GaugeContainer = void 0;

var $184caca532a50919$var$_extends2 = $184caca532a50919$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $184caca532a50919$var$_objectWithoutPropertiesLoose2 = $184caca532a50919$require$_interopRequireDefault((parcelRequire("c05no")));

var $184caca532a50919$var$React = $184caca532a50919$require$_interopRequireWildcard((parcelRequire("acw62")));

var $184caca532a50919$var$_propTypes = $184caca532a50919$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $ezMKh = parcelRequire("ezMKh");

var $idClk = parcelRequire("idClk");

var $6hQTT = parcelRequire("6hQTT");

var $fXrnQ = parcelRequire("fXrnQ");

var $ayMG0 = parcelRequire("ayMG0");
const $184caca532a50919$var$_excluded = [
    "width",
    "height",
    "margin",
    "title",
    "desc",
    "value",
    "valueMin",
    "valueMax",
    "startAngle",
    "endAngle",
    "outerRadius",
    "innerRadius",
    "cornerRadius",
    "cx",
    "cy",
    "children"
];
const $184caca532a50919$var$GStyled = (0, $8xDHs.styled)('g', {
    slot: 'internal',
    shouldForwardProp: undefined
})(({ theme: theme })=>({
        '& text': {
            fill: (theme.vars || theme).palette.text.primary
        }
    }));
const $184caca532a50919$var$GaugeContainer = module.exports.GaugeContainer = /*#__PURE__*/ $184caca532a50919$var$React.forwardRef(function GaugeContainer(props, ref) {
    const { width: inWidth, height: inHeight, margin: margin, title: title, desc: desc, value: value, valueMin: valueMin = 0, valueMax: valueMax = 100, startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius, innerRadius: innerRadius, cornerRadius: cornerRadius, cx: cx, cy: cy, children: children } = props, other = (0, $184caca532a50919$var$_objectWithoutPropertiesLoose2.default)(props, $184caca532a50919$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6hQTT.ChartProvider, {
        pluginParams: {
            width: inWidth,
            height: inHeight,
            margin: (0, $fXrnQ.defaultizeMargin)(margin, {
                left: 10,
                right: 10,
                top: 10,
                bottom: 10
            })
        },
        plugins: [],
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($idClk.GaugeProvider, {
            value: value,
            valueMin: valueMin,
            valueMax: valueMax,
            startAngle: startAngle,
            endAngle: endAngle,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            cornerRadius: cornerRadius,
            cx: cx,
            cy: cy,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ezMKh.ChartsSurface, (0, $184caca532a50919$var$_extends2.default)({
                title: title,
                desc: desc,
                role: "meter",
                "aria-valuenow": value === null ? undefined : value,
                "aria-valuemin": valueMin,
                "aria-valuemax": valueMax
            }, other, {
                ref: ref,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($184caca532a50919$var$GStyled, {
                    "aria-hidden": "true",
                    children: children
                })
            }))
        })
    });
});

});
parcelRegister("idClk", function(module, exports) {
"use strict";
// @ignore - do not document.
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $d4372f0372850679$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GaugeContext = void 0;
module.exports.GaugeProvider = $d4372f0372850679$var$GaugeProvider;
module.exports.useGaugeState = $d4372f0372850679$var$useGaugeState;

var $d4372f0372850679$var$React = $d4372f0372850679$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fINgK = parcelRequire("fINgK");

var $5PiE5 = parcelRequire("5PiE5");

var $gxvLm = parcelRequire("gxvLm");

var $1hcZZ = parcelRequire("1hcZZ");

var $ayMG0 = parcelRequire("ayMG0");
const $d4372f0372850679$var$GaugeContext = module.exports.GaugeContext = /*#__PURE__*/ $d4372f0372850679$var$React.createContext({
    value: null,
    valueMin: 0,
    valueMax: 0,
    startAngle: 0,
    endAngle: 0,
    innerRadius: 0,
    outerRadius: 0,
    cornerRadius: 0,
    cx: 0,
    cy: 0,
    maxRadius: 0,
    valueAngle: null
});
function $d4372f0372850679$var$GaugeProvider(props) {
    const { value: value = null, valueMin: valueMin = 0, valueMax: valueMax = 100, startAngle: startAngle = 0, endAngle: endAngle = 360, outerRadius: outerRadiusParam, innerRadius: innerRadiusParam, cornerRadius: cornerRadiusParam, cx: cxParam, cy: cyParam, children: children } = props;
    const { left: left, top: top, width: width, height: height } = (0, $gxvLm.useDrawingArea)();
    const ratios = (0, $5PiE5.getArcRatios)(startAngle, endAngle);
    const innerCx = cxParam ? (0, $fINgK.getPercentageValue)(cxParam, width) : ratios.cx * width;
    const innerCy = cyParam ? (0, $fINgK.getPercentageValue)(cyParam, height) : ratios.cy * height;
    let cx = left + innerCx;
    let cy = top + innerCy;
    const maxRadius = (0, $5PiE5.getAvailableRadius)(innerCx, innerCy, width, height, ratios);
    // If the center is not defined, after computation of the available radius, update the center to use the remaining space.
    if (cxParam === undefined) {
        const usedWidth = maxRadius * (ratios.maxX - ratios.minX);
        cx = left + (width - usedWidth) / 2 + ratios.cx * usedWidth;
    }
    if (cyParam === undefined) {
        const usedHeight = maxRadius * (ratios.maxY - ratios.minY);
        cy = top + (height - usedHeight) / 2 + ratios.cy * usedHeight;
    }
    const outerRadius = (0, $fINgK.getPercentageValue)(outerRadiusParam ?? maxRadius, maxRadius);
    const innerRadius = (0, $fINgK.getPercentageValue)(innerRadiusParam ?? '80%', maxRadius);
    const cornerRadius = (0, $fINgK.getPercentageValue)(cornerRadiusParam ?? 0, outerRadius - innerRadius);
    const contextValue = $d4372f0372850679$var$React.useMemo(()=>{
        const startAngleRad = (0, $1hcZZ.deg2rad)(startAngle);
        const endAngleRad = (0, $1hcZZ.deg2rad)(endAngle);
        return {
            value: value,
            valueMin: valueMin,
            valueMax: valueMax,
            startAngle: startAngleRad,
            endAngle: endAngleRad,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            cornerRadius: cornerRadius,
            cx: cx,
            cy: cy,
            maxRadius: maxRadius,
            valueAngle: value === null ? null : startAngleRad + (endAngleRad - startAngleRad) * (value - valueMin) / (valueMax - valueMin)
        };
    }, [
        value,
        valueMin,
        valueMax,
        startAngle,
        endAngle,
        outerRadius,
        innerRadius,
        cornerRadius,
        cx,
        cy,
        maxRadius
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d4372f0372850679$var$GaugeContext.Provider, {
        value: contextValue,
        children: children
    });
}
function $d4372f0372850679$var$useGaugeState() {
    return $d4372f0372850679$var$React.useContext($d4372f0372850679$var$GaugeContext);
}

});
parcelRegister("5PiE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArcRatios = $43e02dceee75ff08$var$getArcRatios;
module.exports.getAvailableRadius = $43e02dceee75ff08$var$getAvailableRadius;

var $1hcZZ = parcelRequire("1hcZZ");
function $43e02dceee75ff08$var$getPoint(angle) {
    const radAngle = (0, $1hcZZ.deg2rad)(angle);
    return [
        Math.sin(radAngle),
        -Math.cos(radAngle)
    ];
}
/**
 * Returns the ratio of the arc bounding box and its center.
 * @param startAngle The start angle (in deg)
 * @param endAngle The end angle (in deg)
 */ function $43e02dceee75ff08$var$getArcRatios(startAngle, endAngle) {
    // Set the start, end and center point.
    const points = [
        [
            0,
            0
        ],
        $43e02dceee75ff08$var$getPoint(startAngle),
        $43e02dceee75ff08$var$getPoint(endAngle)
    ];
    // Add cardinal points included in the arc
    const minAngle = Math.min(startAngle, endAngle);
    const maxAngle = Math.max(startAngle, endAngle);
    const initialAngle = Math.floor(minAngle / 90) * 90;
    for(let step = 1; step <= 4; step += 1){
        const cardinalAngle = initialAngle + step * 90;
        if (cardinalAngle < maxAngle) points.push($43e02dceee75ff08$var$getPoint(cardinalAngle));
    }
    const minX = Math.min(...points.map(([x])=>x));
    const maxX = Math.max(...points.map(([x])=>x));
    const minY = Math.min(...points.map(([, y])=>y));
    const maxY = Math.max(...points.map(([, y])=>y));
    return {
        cx: -minX / (maxX - minX),
        cy: -minY / (maxY - minY),
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}
function $43e02dceee75ff08$var$getAvailableRadius(cx, cy, width, height, { minX: minX, maxX: maxX, minY: minY, maxY: maxY }) {
    return Math.min(...[
        {
            ratio: Math.abs(minX),
            space: cx
        },
        {
            ratio: Math.abs(maxX),
            space: width - cx
        },
        {
            ratio: Math.abs(minY),
            space: cy
        },
        {
            ratio: Math.abs(maxY),
            space: height - cy
        }
    ].map(({ ratio: ratio, space: space })=>{
        if (ratio < 0.00001) return Infinity;
        return space / ratio;
    }));
}

});



parcelRegister("fBxsU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b5c4453a7d6d3c0c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b5c4453a7d6d3c0c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GaugeValueArc = $b5c4453a7d6d3c0c$var$GaugeValueArc;

var $b5c4453a7d6d3c0c$var$_extends2 = $b5c4453a7d6d3c0c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b5c4453a7d6d3c0c$var$_objectWithoutPropertiesLoose2 = $b5c4453a7d6d3c0c$require$_interopRequireDefault((parcelRequire("c05no")));

var $b5c4453a7d6d3c0c$var$React = $b5c4453a7d6d3c0c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b5c4453a7d6d3c0c$var$_propTypes = $b5c4453a7d6d3c0c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $b5c4453a7d6d3c0c$var$_clsx = $b5c4453a7d6d3c0c$require$_interopRequireDefault((parcelRequire("9QePP")));

var $cfS2L = parcelRequire("cfS2L");

var $kUjlE = parcelRequire("kUjlE");

var $idClk = parcelRequire("idClk");

var $5GSMX = parcelRequire("5GSMX");

var $ayMG0 = parcelRequire("ayMG0");
const $b5c4453a7d6d3c0c$var$_excluded = [
    "className"
], $b5c4453a7d6d3c0c$var$_excluded2 = [
    "cx",
    "cy",
    "startAngle",
    "endAngle",
    "cornerRadius",
    "innerRadius",
    "outerRadius",
    "skipAnimation"
];
const $b5c4453a7d6d3c0c$var$StyledPath = (0, $8xDHs.styled)('path', {
    name: 'MuiGauge',
    slot: 'ValueArc'
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.main
    }));
function $b5c4453a7d6d3c0c$var$GaugeValueArc(_ref) {
    let { className: className } = _ref, other = (0, $b5c4453a7d6d3c0c$var$_objectWithoutPropertiesLoose2.default)(_ref, $b5c4453a7d6d3c0c$var$_excluded);
    const { value: value, valueMin: valueMin, valueMax: valueMax, startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius, innerRadius: innerRadius, cornerRadius: cornerRadius, cx: cx, cy: cy } = (0, $idClk.useGaugeState)();
    if (value === null) return null;
    const valueAngle = startAngle + (value - valueMin) / (valueMax - valueMin) * (endAngle - startAngle);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b5c4453a7d6d3c0c$var$AnimatedGaugeValueArc, (0, $b5c4453a7d6d3c0c$var$_extends2.default)({}, other, {
        className: (0, $b5c4453a7d6d3c0c$var$_clsx.default)($5GSMX.gaugeClasses.valueArc, className),
        cx: cx,
        cy: cy,
        startAngle: startAngle,
        endAngle: valueAngle,
        cornerRadius: cornerRadius,
        innerRadius: innerRadius,
        outerRadius: outerRadius
    }));
}
function $b5c4453a7d6d3c0c$var$AnimatedGaugeValueArc(_ref2) {
    let { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, cornerRadius: cornerRadius, innerRadius: innerRadius, outerRadius: outerRadius, skipAnimation: inSkipAnimation } = _ref2, other = (0, $b5c4453a7d6d3c0c$var$_objectWithoutPropertiesLoose2.default)(_ref2, $b5c4453a7d6d3c0c$var$_excluded2);
    const skipAnimation = (0, $cfS2L.useSkipAnimation)(inSkipAnimation);
    const animatedProps = (0, $kUjlE.useAnimateGaugeValueArc)({
        startAngle: startAngle,
        endAngle: endAngle,
        cornerRadius: cornerRadius,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        skipAnimation: skipAnimation
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b5c4453a7d6d3c0c$var$StyledPath, (0, $b5c4453a7d6d3c0c$var$_extends2.default)({}, animatedProps, {
        transform: `translate(${cx}, ${cy})`
    }, other));
}

});
parcelRegister("kUjlE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useAnimateGaugeValueArc = $f3880bc8b6eb0bd2$var$useAnimateGaugeValueArc;

var $6hlpT = parcelRequire("6hlpT");

var $iNRFO = parcelRequire("iNRFO");

var $aQEJ4 = parcelRequire("aQEJ4");
function $f3880bc8b6eb0bd2$var$gaugeValueArcPropsInterpolator(from, to) {
    const interpolateStartAngle = (0, $iNRFO.interpolateNumber)(from.startAngle, to.startAngle);
    const interpolateEndAngle = (0, $iNRFO.interpolateNumber)(from.endAngle, to.endAngle);
    const interpolateInnerRadius = (0, $iNRFO.interpolateNumber)(from.innerRadius, to.innerRadius);
    const interpolateOuterRadius = (0, $iNRFO.interpolateNumber)(from.outerRadius, to.outerRadius);
    const interpolateCornerRadius = (0, $iNRFO.interpolateNumber)(from.cornerRadius, to.cornerRadius);
    return (t)=>{
        return {
            startAngle: interpolateStartAngle(t),
            endAngle: interpolateEndAngle(t),
            innerRadius: interpolateInnerRadius(t),
            outerRadius: interpolateOuterRadius(t),
            cornerRadius: interpolateCornerRadius(t)
        };
    };
}
/** Animates a arc of a gauge chart by increasing the `endAngle` from the start angle to the end angle.
 * The props object also accepts a `ref` which will be merged with the ref returned from this hook. This means you can
 * pass the ref returned by this hook to the `path` element and the `ref` provided as argument will also be called. */ function $f3880bc8b6eb0bd2$var$useAnimateGaugeValueArc(props) {
    return (0, $aQEJ4.useAnimate)({
        startAngle: props.startAngle,
        endAngle: props.endAngle,
        innerRadius: props.innerRadius,
        outerRadius: props.outerRadius,
        cornerRadius: props.cornerRadius
    }, {
        createInterpolator: $f3880bc8b6eb0bd2$var$gaugeValueArcPropsInterpolator,
        transformProps: (p)=>({
                d: (0, $6hlpT.arc)().cornerRadius(p.cornerRadius)({
                    innerRadius: p.innerRadius,
                    outerRadius: p.outerRadius,
                    startAngle: p.startAngle,
                    endAngle: p.endAngle
                })
            }),
        applyProps (element, p) {
            element.setAttribute('d', p.d);
        },
        initialProps: {
            startAngle: props.startAngle,
            endAngle: props.startAngle,
            innerRadius: props.innerRadius,
            outerRadius: props.outerRadius,
            cornerRadius: props.cornerRadius
        },
        skip: props.skipAnimation,
        ref: props.ref
    });
}

});

parcelRegister("5GSMX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $424b5fe135c176a6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gaugeClasses = void 0;
module.exports.getGaugeUtilityClass = $424b5fe135c176a6$var$getGaugeUtilityClass;

var $424b5fe135c176a6$var$_generateUtilityClasses = $424b5fe135c176a6$require$_interopRequireDefault((parcelRequire("5nY49")));

var $424b5fe135c176a6$var$_generateUtilityClass = $424b5fe135c176a6$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $424b5fe135c176a6$var$getGaugeUtilityClass(slot) {
    return (0, $424b5fe135c176a6$var$_generateUtilityClass.default)('MuiGauge', slot);
}
const $424b5fe135c176a6$var$gaugeClasses = module.exports.gaugeClasses = (0, $424b5fe135c176a6$var$_generateUtilityClasses.default)('MuiGauge', [
    'root',
    'valueArc',
    'referenceArc',
    'valueText'
]);

});


parcelRegister("bLrAv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $89097bd86862fd70$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $89097bd86862fd70$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GaugeReferenceArc = $89097bd86862fd70$var$GaugeReferenceArc;

var $89097bd86862fd70$var$_extends2 = $89097bd86862fd70$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $89097bd86862fd70$var$_objectWithoutPropertiesLoose2 = $89097bd86862fd70$require$_interopRequireDefault((parcelRequire("c05no")));

var $89097bd86862fd70$var$React = $89097bd86862fd70$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6hlpT = parcelRequire("6hlpT");

var $8xDHs = parcelRequire("8xDHs");

var $89097bd86862fd70$var$_clsx = $89097bd86862fd70$require$_interopRequireDefault((parcelRequire("9QePP")));

var $idClk = parcelRequire("idClk");

var $5GSMX = parcelRequire("5GSMX");

var $ayMG0 = parcelRequire("ayMG0");
const $89097bd86862fd70$var$_excluded = [
    "className"
];
const $89097bd86862fd70$var$StyledPath = (0, $8xDHs.styled)('path', {
    name: 'MuiGauge',
    slot: 'ReferenceArc'
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.divider
    }));
function $89097bd86862fd70$var$GaugeReferenceArc(_ref) {
    let { className: className } = _ref, other = (0, $89097bd86862fd70$var$_objectWithoutPropertiesLoose2.default)(_ref, $89097bd86862fd70$var$_excluded);
    const { startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius, innerRadius: innerRadius, cornerRadius: cornerRadius, cx: cx, cy: cy } = (0, $idClk.useGaugeState)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($89097bd86862fd70$var$StyledPath, (0, $89097bd86862fd70$var$_extends2.default)({
        className: (0, $89097bd86862fd70$var$_clsx.default)($5GSMX.gaugeClasses.referenceArc, className),
        transform: `translate(${cx}, ${cy})`,
        d: (0, $6hlpT.arc)().cornerRadius(cornerRadius)({
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius
        })
    }, other));
}

});

parcelRegister("4C62e", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $35bf6470024e2ab7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GaugeValueText = $35bf6470024e2ab7$var$GaugeValueText;

var $35bf6470024e2ab7$var$_extends2 = $35bf6470024e2ab7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $35bf6470024e2ab7$var$_objectWithoutPropertiesLoose2 = $35bf6470024e2ab7$require$_interopRequireDefault((parcelRequire("c05no")));

var $35bf6470024e2ab7$var$_propTypes = $35bf6470024e2ab7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $35bf6470024e2ab7$var$_clsx = $35bf6470024e2ab7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $idClk = parcelRequire("idClk");

var $41V8S = parcelRequire("41V8S");

var $5GSMX = parcelRequire("5GSMX");

var $ayMG0 = parcelRequire("ayMG0");
const $35bf6470024e2ab7$var$_excluded = [
    "text",
    "className"
];
function $35bf6470024e2ab7$var$defaultFormatter({ value: value }) {
    return value === null ? null : value.toLocaleString();
}
function $35bf6470024e2ab7$var$GaugeValueText(props) {
    const { text: text = $35bf6470024e2ab7$var$defaultFormatter, className: className } = props, other = (0, $35bf6470024e2ab7$var$_objectWithoutPropertiesLoose2.default)(props, $35bf6470024e2ab7$var$_excluded);
    const { value: value, valueMin: valueMin, valueMax: valueMax, cx: cx, cy: cy } = (0, $idClk.useGaugeState)();
    const formattedText = typeof text === 'function' ? text({
        value: value,
        valueMin: valueMin,
        valueMax: valueMax
    }) : text;
    if (formattedText === null) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        className: (0, $35bf6470024e2ab7$var$_clsx.default)($5GSMX.gaugeClasses.valueText, className),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($41V8S.ChartsText, (0, $35bf6470024e2ab7$var$_extends2.default)({
            x: cx,
            y: cy,
            text: formattedText,
            style: {
                textAnchor: 'middle',
                dominantBaseline: 'central'
            }
        }, other))
    });
}

});




parcelRegister("fN3T3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71e78cb395816b96$var$AlertsFeed;

var $71e78cb395816b96$var$_react = $71e78cb395816b96$var$_interopRequireDefault((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
function $71e78cb395816b96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $71e78cb395816b96$var$TYPE_CONFIG = {
    info: {
        background: '#E6F1FB',
        dotColor: '#378ADD'
    },
    warn: {
        background: '#FAEEDA',
        dotColor: '#BA7517'
    },
    ok: {
        background: '#E1F5EE',
        dotColor: '#1D9E75'
    }
};
function $71e78cb395816b96$var$AlertsFeed({ alerts: alerts }) {
    const isEmpty = !alerts.length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $71e78cb395816b96$var$styles.panel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $71e78cb395816b96$var$styles.title,
                children: "Alerts"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $71e78cb395816b96$var$styles.sub,
                children: isEmpty ? 'No active alerts' : `${alerts.length} alert${alerts.length > 1 ? 's' : ''}`
            }),
            isEmpty ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $71e78cb395816b96$var$styles.empty,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        className: "ti ti-circle-check",
                        "aria-hidden": "true",
                        style: {
                            fontSize: 20,
                            color: '#1D9E75'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $71e78cb395816b96$var$styles.emptyText,
                        children: "All clear"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                style: $71e78cb395816b96$var$styles.list,
                "aria-label": "Operational alerts",
                children: alerts.map((alert)=>{
                    const config = $71e78cb395816b96$var$TYPE_CONFIG[alert.type];
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        style: {
                            ...$71e78cb395816b96$var$styles.item,
                            background: 'var(--color-bg-primary)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...$71e78cb395816b96$var$styles.dot,
                                    background: config.dotColor
                                },
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: $71e78cb395816b96$var$styles.message,
                                        children: alert.message
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: $71e78cb395816b96$var$styles.time,
                                        children: alert.time
                                    })
                                ]
                            })
                        ]
                    }, alert.id);
                })
            })
        ]
    });
}
const $71e78cb395816b96$var$styles = {
    panel: {
        background: 'var(--color-bg-secondary, #f5f5f3)',
        borderRadius: 12,
        padding: '1.1rem 1.25rem',
        fontFamily: "'Syne', sans-serif"
    },
    title: {
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--color-text-primary, #2C2C2A)',
        margin: '0 0 0.15rem'
    },
    sub: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary, #5F5E5A)',
        margin: '0 0 0.85rem'
    },
    list: {
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: 0,
        margin: 0
    },
    item: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        padding: '8px 10px',
        borderRadius: 8
    },
    dot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        marginTop: 4,
        flexShrink: 0
    },
    message: {
        fontSize: 12,
        color: 'var(--color-text-primary, #2C2C2A)',
        lineHeight: 1.4,
        margin: 0
    },
    time: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 10,
        color: 'var(--color-text-secondary, #5F5E5A)',
        margin: '2px 0 0'
    },
    empty: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: '1.5rem 0'
    },
    emptyText: {
        fontSize: 12,
        color: 'var(--color-text-secondary, #5F5E5A)',
        fontFamily: "'DM Mono', monospace"
    }
};

});

parcelRegister("aR930", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8db0ae36809de1c4$var$TargetsPanel;

var $8db0ae36809de1c4$var$_react = $8db0ae36809de1c4$var$_interopRequireDefault((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
function $8db0ae36809de1c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $8db0ae36809de1c4$var$pctChange(current, previous) {
    if (previous === 0) return null;
    return Math.round((current - previous) / previous * 100);
}
function $8db0ae36809de1c4$var$TrendChip({ pct: pct }) {
    if (pct === null) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: $8db0ae36809de1c4$var$styles.noData,
        children: "No prev. data"
    });
    const improved = pct < 0;
    const neutral = pct === 0;
    const bg = neutral ? 'rgba(128,128,128,0.12)' : improved ? '#E1F5EE' : '#FAEEDA';
    const color = neutral ? '#888780' : improved ? '#0F6E56' : '#993C1D';
    const arrow = neutral ? "\u2192" : improved ? "\u2193" : "\u2191";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        style: {
            ...$8db0ae36809de1c4$var$styles.chip,
            background: bg,
            color: color
        },
        children: [
            arrow,
            " ",
            Math.abs(pct),
            "%"
        ]
    });
}
function $8db0ae36809de1c4$var$ComparisonRow({ item: item, prevPeriodLabel: prevPeriodLabel }) {
    const pct = $8db0ae36809de1c4$var$pctChange(item.current, item.previous);
    const fmt = (v)=>`${item.prefix ?? ''}${v.toLocaleString('en-GB')} ${item.unit}`.trim();
    const barWidth = item.previous > 0 ? Math.min(Math.round(item.current / Math.max(item.current, item.previous) * 100), 100) : 100;
    const prevBarWidth = item.previous > 0 ? Math.min(Math.round(item.previous / Math.max(item.current, item.previous) * 100), 100) : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $8db0ae36809de1c4$var$styles.row,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $8db0ae36809de1c4$var$styles.rowHeader,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: $8db0ae36809de1c4$var$styles.rowLeft,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    ...$8db0ae36809de1c4$var$styles.colorDot,
                                    background: item.color
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: $8db0ae36809de1c4$var$styles.rowLabel,
                                children: item.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8db0ae36809de1c4$var$TrendChip, {
                        pct: pct
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $8db0ae36809de1c4$var$styles.barGroup,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $8db0ae36809de1c4$var$styles.barLabel,
                        children: "Now"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $8db0ae36809de1c4$var$styles.barTrack,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                ...$8db0ae36809de1c4$var$styles.barFill,
                                width: `${barWidth}%`,
                                background: item.color
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $8db0ae36809de1c4$var$styles.barValue,
                        children: fmt(item.current)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: $8db0ae36809de1c4$var$styles.barGroup,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: $8db0ae36809de1c4$var$styles.barLabel,
                        children: prevPeriodLabel.replace('vs ', '')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: $8db0ae36809de1c4$var$styles.barTrack,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                ...$8db0ae36809de1c4$var$styles.barFill,
                                width: `${prevBarWidth}%`,
                                background: item.color,
                                opacity: 0.3
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            ...$8db0ae36809de1c4$var$styles.barValue,
                            opacity: 0.6
                        },
                        children: fmt(item.previous)
                    })
                ]
            })
        ]
    });
}
function $8db0ae36809de1c4$var$TargetsPanel({ comparison: comparison, prevPeriodLabel: prevPeriodLabel }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: $8db0ae36809de1c4$var$styles.panel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $8db0ae36809de1c4$var$styles.title,
                children: "Period comparison"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $8db0ae36809de1c4$var$styles.sub,
                children: prevPeriodLabel
            }),
            !comparison.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                style: $8db0ae36809de1c4$var$styles.empty,
                children: "No data available"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: $8db0ae36809de1c4$var$styles.list,
                children: comparison.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8db0ae36809de1c4$var$ComparisonRow, {
                        item: item,
                        prevPeriodLabel: prevPeriodLabel
                    }, item.id))
            })
        ]
    });
}
const $8db0ae36809de1c4$var$styles = {
    panel: {
        background: 'var(--color-bg-secondary, #f5f5f3)',
        borderRadius: 12,
        padding: '1.1rem 1.25rem',
        fontFamily: "'Syne', sans-serif"
    },
    title: {
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--color-text-primary, #2C2C2A)',
        margin: '0 0 0.15rem'
    },
    sub: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary, #5F5E5A)',
        margin: '0 0 1rem',
        textTransform: 'capitalize'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    row: {},
    rowHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 6
    },
    rowLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 6
    },
    colorDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        flexShrink: 0
    },
    rowLabel: {
        fontSize: 12,
        fontWeight: 500,
        color: 'var(--color-text-primary, #2C2C2A)'
    },
    chip: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        fontWeight: 600,
        padding: '2px 7px',
        borderRadius: 20
    },
    barGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 3
    },
    barLabel: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 10,
        color: 'var(--color-text-secondary, #5F5E5A)',
        width: 48,
        flexShrink: 0,
        textAlign: 'right'
    },
    barTrack: {
        flex: 1,
        height: 5,
        background: 'rgba(128,128,128,0.12)',
        borderRadius: 3,
        overflow: 'hidden'
    },
    barFill: {
        height: '100%',
        borderRadius: 3,
        transition: 'width 0.6s cubic-bezier(0.4,0,0.2,1)'
    },
    barValue: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-primary, #2C2C2A)',
        width: 80,
        flexShrink: 0,
        textAlign: 'right'
    },
    noData: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 10,
        color: 'var(--color-text-secondary, #5F5E5A)'
    },
    empty: {
        fontFamily: "'DM Mono', monospace",
        fontSize: 12,
        color: 'var(--color-text-secondary, #5F5E5A)',
        margin: 0
    }
};

});



parcelRegister("c1Ui0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $165ae47d2768a11c$var$UnauthorisedPage;

var $165ae47d2768a11c$var$_react = $165ae47d2768a11c$var$_interopRequireDefault((parcelRequire("acw62")));

var $gwjoH = parcelRequire("gwjoH");

var $cvg8Z = parcelRequire("cvg8Z");

var $165ae47d2768a11c$var$_WarningAmber = $165ae47d2768a11c$var$_interopRequireDefault((parcelRequire("3LBtW")));

var $ayMG0 = parcelRequire("ayMG0");
function $165ae47d2768a11c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $165ae47d2768a11c$var$UnauthorisedPage() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        textAlign: "center",
        gap: 2,
        p: 3,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($165ae47d2768a11c$var$_WarningAmber.default, {
                color: "warning",
                sx: {
                    fontSize: 80
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "h3",
                color: "textPrimary",
                children: "Access Denied"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "body1",
                color: "textSecondary",
                children: "You do not have permission to view this page."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Button, {
                variant: "outlined",
                sx: {
                    borderColor: '#357a38',
                    color: '#357a38'
                },
                component: $gwjoH.Link,
                to: "/",
                children: "Go Back Home"
            })
        ]
    });
}

});
parcelRegister("3LBtW", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2be2d5fda6f09cee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2be2d5fda6f09cee$var$_createSvgIcon = $2be2d5fda6f09cee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2be2d5fda6f09cee$var$_default = module.exports.default = (0, $2be2d5fda6f09cee$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');

});


parcelRegister("TUODY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b3139ff00950597$var$UsersPage;

var $acw62 = parcelRequire("acw62");

var $3Ai54 = parcelRequire("3Ai54");

var $7b3139ff00950597$var$_Box = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $7b3139ff00950597$var$_Typography = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $7b3139ff00950597$var$_TextField = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("hABDe")));

var $7b3139ff00950597$var$_Button = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $7b3139ff00950597$var$_IconButton = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("825Zh")));

var $7b3139ff00950597$var$_Table = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("bGe9g")));

var $7b3139ff00950597$var$_TableBody = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("5hLrb")));

var $7b3139ff00950597$var$_TableCell = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("hjoMW")));

var $7b3139ff00950597$var$_TableContainer = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("12YAp")));

var $7b3139ff00950597$var$_TableHead = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("g2Lhl")));

var $7b3139ff00950597$var$_TableRow = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("7IILB")));

var $7b3139ff00950597$var$_TablePagination = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("b3HhA")));

var $7b3139ff00950597$var$_Dialog = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("iZIMH")));

var $7b3139ff00950597$var$_DialogTitle = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("lIycJ")));

var $7b3139ff00950597$var$_DialogContent = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("hJoSv")));

var $7b3139ff00950597$var$_DialogActions = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("l5BZB")));

var $7b3139ff00950597$var$_Delete = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("1MdOk")));

var $7b3139ff00950597$var$_Edit = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("c3r8Q")));

var $7b3139ff00950597$var$_PersonAdd = $7b3139ff00950597$var$_interopRequireDefault((parcelRequire("hZr2Q")));

var $gwjoH = parcelRequire("gwjoH");

var $ayMG0 = parcelRequire("ayMG0");
function $7b3139ff00950597$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b3139ff00950597$var$BRAND_GREEN = '#1D9E75';
const $7b3139ff00950597$var$bodyCellSx = {
    fontFamily: "'DM Mono', monospace",
    fontSize: 13,
    color: 'var(--color-text-primary)',
    borderBottom: '1px solid rgba(255,255,255,0.04)',
    background: 'transparent',
    py: 2
};
function $7b3139ff00950597$var$UsersPage() {
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [search, setSearch] = (0, $acw62.useState)('');
    const [page, setPage] = (0, $acw62.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(10);
    const [deleteUserId, setDeleteUserId] = (0, $acw62.useState)(null);
    const loadUsers = async ()=>{
        try {
            const res = await (0, $3Ai54.listUsers)(search);
            setUsers(res);
        } catch (err) {
            console.error('Failed to load users:', err);
        }
    };
    (0, $acw62.useEffect)(()=>{
        loadUsers();
    }, [
        search
    ]);
    const handleDelete = async ()=>{
        if (!deleteUserId) return;
        try {
            const res = await (0, $3Ai54.deleteUser)(deleteUserId);
            if (!res) throw new Error('Failed to delete user');
            setDeleteUserId(null);
            loadUsers();
        } catch (err) {
            console.error('Failed to delete user:', err.message);
        }
    };
    const paginated = users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '75vw',
            height: '100vh',
            margin: '0 auto',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Box.default, {
                sx: {
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 3,
                    flexWrap: 'wrap',
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Typography.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 20,
                            fontWeight: 600,
                            color: $7b3139ff00950597$var$BRAND_GREEN
                        },
                        children: "User Management"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TextField.default, {
                                placeholder: "Search users",
                                size: "small",
                                value: search,
                                onChange: (e)=>setSearch(e.target.value),
                                sx: {
                                    '& .MuiOutlinedInput-root': {
                                        fontFamily: "'DM Mono', monospace",
                                        fontSize: 12,
                                        borderRadius: 2,
                                        '& fieldset': {
                                            borderColor: 'rgba(255,255,255,0.12)'
                                        },
                                        '&:hover fieldset': {
                                            borderColor: $7b3139ff00950597$var$BRAND_GREEN
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: $7b3139ff00950597$var$BRAND_GREEN
                                        }
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Button.default, {
                                variant: "outlined",
                                size: "small",
                                component: $gwjoH.Link,
                                to: "/users/create",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_PersonAdd.default, {
                                    sx: {
                                        fontSize: '14px !important',
                                        padding: '0 !important'
                                    }
                                }),
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    fontWeight: 500,
                                    letterSpacing: '0.04em',
                                    textTransform: 'uppercase',
                                    borderColor: $7b3139ff00950597$var$BRAND_GREEN,
                                    color: $7b3139ff00950597$var$BRAND_GREEN,
                                    borderRadius: 2,
                                    px: 1.5,
                                    '&:hover': {
                                        borderColor: $7b3139ff00950597$var$BRAND_GREEN,
                                        background: 'rgba(29,158,117,0.08)'
                                    }
                                },
                                children: "Add User"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    height: '85%',
                    borderRadius: 3,
                    p: '0.5rem 1.25rem 0',
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableContainer.default, {
                        sx: {
                            background: 'transparent',
                            height: '100%'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Table.default, {
                            "aria-label": "users table",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableHead.default, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_TableRow.default, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                sx: {
                                                    py: 2
                                                },
                                                children: "Username"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                sx: {
                                                    py: 2
                                                },
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                sx: {
                                                    py: 2
                                                },
                                                children: "Role"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                sx: {
                                                    py: 2,
                                                    width: 100
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableBody.default, {
                                    children: paginated.map((user)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_TableRow.default, {
                                            sx: {
                                                '&:last-child td': {
                                                    border: 0
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                    sx: {
                                                        ...$7b3139ff00950597$var$bodyCellSx,
                                                        fontFamily: "'Syne', sans-serif",
                                                        fontWeight: 500
                                                    },
                                                    children: user.username
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                    sx: {
                                                        ...$7b3139ff00950597$var$bodyCellSx,
                                                        color: 'var(--color-text-secondary)'
                                                    },
                                                    children: user.email
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                    sx: $7b3139ff00950597$var$bodyCellSx,
                                                    children: user.groups
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TableCell.default, {
                                                    sx: $7b3139ff00950597$var$bodyCellSx,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Box.default, {
                                                        sx: {
                                                            display: 'flex',
                                                            gap: 0.5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_IconButton.default, {
                                                                component: $gwjoH.Link,
                                                                to: `/users/edit/${user.id}`,
                                                                size: "small",
                                                                sx: {
                                                                    color: $7b3139ff00950597$var$BRAND_GREEN,
                                                                    '& svg': {
                                                                        fontSize: '16px !important',
                                                                        padding: '0 !important'
                                                                    },
                                                                    '&:hover': {
                                                                        background: 'rgba(29,158,117,0.1)'
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Edit.default, {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_IconButton.default, {
                                                                size: "small",
                                                                onClick: ()=>setDeleteUserId(user.id),
                                                                sx: {
                                                                    color: '#993C1D',
                                                                    '& svg': {
                                                                        fontSize: '16px !important',
                                                                        padding: '0 !important'
                                                                    },
                                                                    '&:hover': {
                                                                        background: 'rgba(153,60,29,0.1)'
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Delete.default, {})
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, user.id))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_TablePagination.default, {
                        component: "div",
                        count: users.length,
                        page: page,
                        rowsPerPage: rowsPerPage,
                        onPageChange: (_, newPage)=>setPage(newPage),
                        onRowsPerPageChange: (e)=>setRowsPerPage(parseInt(e.target.value, 10)),
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 12,
                            color: 'var(--color-text-secondary)',
                            borderTop: '1px solid rgba(255,255,255,0.04)',
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                fontFamily: "'DM Mono', monospace",
                                fontSize: 11
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_Dialog.default, {
                open: !!deleteUserId,
                onClose: ()=>setDeleteUserId(null),
                PaperProps: {
                    sx: {
                        background: 'var(--color-bg-secondary)',
                        borderRadius: 3,
                        p: 1,
                        minWidth: 320
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_DialogTitle.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 16,
                            fontWeight: 600,
                            color: 'var(--color-text-primary)'
                        },
                        children: "Delete User"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_DialogContent.default, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Typography.default, {
                            sx: {
                                fontFamily: "'DM Mono', monospace",
                                fontSize: 13,
                                color: 'var(--color-text-secondary)'
                            },
                            children: "Are you sure you want to delete this user? This action cannot be undone."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($7b3139ff00950597$var$_DialogActions.default, {
                        sx: {
                            px: 3,
                            pb: 2,
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Button.default, {
                                onClick: ()=>setDeleteUserId(null),
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    textTransform: 'uppercase',
                                    color: 'var(--color-text-secondary)',
                                    borderRadius: 2
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($7b3139ff00950597$var$_Button.default, {
                                variant: "contained",
                                onClick: handleDelete,
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 11,
                                    textTransform: 'uppercase',
                                    background: '#993C1D',
                                    borderRadius: 2,
                                    '&:hover': {
                                        background: '#7a2e15'
                                    }
                                },
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("3Ai54", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUser = $b2aef02409473534$var$createUser;
module.exports.deleteUser = $b2aef02409473534$var$deleteUser;
module.exports.getUser = $b2aef02409473534$var$getUser;
module.exports.listUsers = $b2aef02409473534$var$listUsers;
module.exports.updateUser = $b2aef02409473534$var$updateUser;

var $9xY2t = parcelRequire("9xY2t");

var $b2aef02409473534$var$_config = $b2aef02409473534$var$_interopRequireDefault((parcelRequire("cWZn2")));
function $b2aef02409473534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2aef02409473534$var$API_URL = $b2aef02409473534$var$_config.default.apiUrl;
async function $b2aef02409473534$var$authHeaders() {
    const token = await (0, $9xY2t.getToken)();
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
}
async function $b2aef02409473534$var$listUsers(search = '') {
    const res = await fetch(`${$b2aef02409473534$var$API_URL}/users?search=${search}`, {
        headers: await $b2aef02409473534$var$authHeaders()
    });
    return res.json();
}
async function $b2aef02409473534$var$getUser(id) {
    const res = await fetch(`${$b2aef02409473534$var$API_URL}/users/${id}`, {
        headers: await $b2aef02409473534$var$authHeaders()
    });
    return res.json();
}
async function $b2aef02409473534$var$createUser(username, email, password, group) {
    const res = await fetch(`${$b2aef02409473534$var$API_URL}/users`, {
        method: 'POST',
        headers: await $b2aef02409473534$var$authHeaders(),
        body: JSON.stringify({
            username: username,
            email: email,
            password: password,
            group: group
        })
    });
    return res.ok;
}
async function $b2aef02409473534$var$updateUser(id, data) {
    const res = await fetch(`${$b2aef02409473534$var$API_URL}/users/${id}`, {
        method: 'PUT',
        headers: await $b2aef02409473534$var$authHeaders(),
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`Failed to update user: ${res.status}`);
    return true;
}
async function $b2aef02409473534$var$deleteUser(id) {
    const res = await fetch(`${$b2aef02409473534$var$API_URL}/users/${id}`, {
        method: 'DELETE',
        headers: await $b2aef02409473534$var$authHeaders()
    });
    return res.ok;
}

});

parcelRegister("1MdOk", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $14b4fcb0e549e7b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $14b4fcb0e549e7b0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = module.exports.default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');

});

parcelRegister("hZr2Q", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d18d1cbd35f5a198$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d18d1cbd35f5a198$var$_createSvgIcon = $d18d1cbd35f5a198$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d18d1cbd35f5a198$var$_default = module.exports.default = (0, $d18d1cbd35f5a198$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m-9-2V7H4v3H1v2h3v3h2v-3h3v-2zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'PersonAdd');

});


parcelRegister("jLuHz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79a0d5f5d13f93cd$var$CreateUserPage;

var $acw62 = parcelRequire("acw62");

var $gwjoH = parcelRequire("gwjoH");

var $79a0d5f5d13f93cd$var$_Box = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $79a0d5f5d13f93cd$var$_Typography = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $79a0d5f5d13f93cd$var$_TextField = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("hABDe")));

var $79a0d5f5d13f93cd$var$_Button = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $79a0d5f5d13f93cd$var$_Alert = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("16wD6")));

var $79a0d5f5d13f93cd$var$_FormControlLabel = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("i48ne")));

var $79a0d5f5d13f93cd$var$_Checkbox = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("aGDqy")));

var $79a0d5f5d13f93cd$var$_ArrowBack = $79a0d5f5d13f93cd$var$_interopRequireDefault((parcelRequire("1YLXO")));

var $3Ai54 = parcelRequire("3Ai54");

var $ayMG0 = parcelRequire("ayMG0");
function $79a0d5f5d13f93cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79a0d5f5d13f93cd$var$BRAND_GREEN = '#1D9E75';
const $79a0d5f5d13f93cd$var$fieldSx = {
    '& .MuiOutlinedInput-root': {
        fontFamily: "'DM Mono', monospace",
        fontSize: 13,
        borderRadius: 2,
        '& fieldset': {
            borderColor: 'rgba(255,255,255,0.12)'
        },
        '&:hover fieldset': {
            borderColor: $79a0d5f5d13f93cd$var$BRAND_GREEN
        },
        '&.Mui-focused fieldset': {
            borderColor: $79a0d5f5d13f93cd$var$BRAND_GREEN
        }
    },
    '& .MuiInputLabel-root': {
        fontFamily: "'DM Mono', monospace",
        fontSize: 13,
        '&.Mui-focused': {
            color: $79a0d5f5d13f93cd$var$BRAND_GREEN
        }
    }
};
function $79a0d5f5d13f93cd$var$CreateUserPage() {
    const navigate = (0, $gwjoH.useNavigate)();
    const [username, setUsername] = (0, $acw62.useState)('');
    const [email, setEmail] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [isAdmin, setIsAdmin] = (0, $acw62.useState)(false);
    const [message, setMessage] = (0, $acw62.useState)(null);
    const handleBack = ()=>navigate('/users');
    const handleSubmit = async ()=>{
        try {
            const data = await (0, $3Ai54.createUser)(username, email, password, isAdmin ? 'admin' : undefined);
            if (data) {
                setMessage({
                    type: 'success',
                    text: 'User created successfully.'
                });
                setUsername('');
                setEmail('');
                setPassword('');
                setIsAdmin(false);
                setTimeout(handleBack, 1000);
            } else setMessage({
                type: 'error',
                text: 'Failed to create user.'
            });
        } catch (err) {
            setMessage({
                type: 'error',
                text: err.message || 'Failed to create user.'
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($79a0d5f5d13f93cd$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '100%',
            height: '100vh',
            boxSizing: 'border-box',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($79a0d5f5d13f93cd$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_Button.default, {
                        size: "small",
                        onClick: handleBack,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_ArrowBack.default, {
                            sx: {
                                fontSize: '14px !important',
                                padding: '0 !important'
                            }
                        }),
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 11,
                            textTransform: 'uppercase',
                            color: 'var(--color-text-secondary)',
                            borderColor: 'rgba(255,255,255,0.12)',
                            borderRadius: 2,
                            '&:hover': {
                                borderColor: $79a0d5f5d13f93cd$var$BRAND_GREEN,
                                color: $79a0d5f5d13f93cd$var$BRAND_GREEN
                            }
                        },
                        variant: "outlined",
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_Typography.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 20,
                            fontWeight: 600,
                            color: $79a0d5f5d13f93cd$var$BRAND_GREEN
                        },
                        children: "Create User"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($79a0d5f5d13f93cd$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.5rem 2rem',
                    maxWidth: 480
                },
                children: [
                    message && /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_Alert.default, {
                        severity: message.type,
                        sx: {
                            mb: 2.5,
                            borderRadius: 2,
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 12
                        },
                        children: message.text
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($79a0d5f5d13f93cd$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_TextField.default, {
                                label: "Username",
                                value: username,
                                onChange: (e)=>setUsername(e.target.value),
                                fullWidth: true,
                                size: "small",
                                sx: $79a0d5f5d13f93cd$var$fieldSx
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_TextField.default, {
                                label: "Email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                fullWidth: true,
                                size: "small",
                                sx: $79a0d5f5d13f93cd$var$fieldSx
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_TextField.default, {
                                label: "Password",
                                type: "password",
                                value: password,
                                onChange: (e)=>setPassword(e.target.value),
                                fullWidth: true,
                                size: "small",
                                sx: $79a0d5f5d13f93cd$var$fieldSx
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_FormControlLabel.default, {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_Checkbox.default, {
                                    checked: isAdmin,
                                    onChange: (e)=>setIsAdmin(e.target.checked),
                                    sx: {
                                        color: 'rgba(255,255,255,0.2)',
                                        '&.Mui-checked': {
                                            color: $79a0d5f5d13f93cd$var$BRAND_GREEN
                                        },
                                        '& svg': {
                                            fontSize: '18px !important',
                                            padding: '0 !important'
                                        }
                                    }
                                }),
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_Typography.default, {
                                    sx: {
                                        fontFamily: "'DM Mono', monospace",
                                        fontSize: 13,
                                        color: 'var(--color-text-primary)'
                                    },
                                    children: "Admin user"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($79a0d5f5d13f93cd$var$_Button.default, {
                                variant: "contained",
                                onClick: handleSubmit,
                                fullWidth: true,
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    letterSpacing: '0.06em',
                                    textTransform: 'uppercase',
                                    background: $79a0d5f5d13f93cd$var$BRAND_GREEN,
                                    borderRadius: 2,
                                    py: 1.25,
                                    mt: 0.5,
                                    '&:hover': {
                                        background: '#17876A'
                                    }
                                },
                                children: "Create User"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("lTDJM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5913ac5ef0d68a7$var$EditUserPage;

var $acw62 = parcelRequire("acw62");

var $gwjoH = parcelRequire("gwjoH");

var $b5913ac5ef0d68a7$var$_Box = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("e5o5x")));

var $b5913ac5ef0d68a7$var$_Typography = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("2dUd7")));

var $b5913ac5ef0d68a7$var$_TextField = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("hABDe")));

var $b5913ac5ef0d68a7$var$_Button = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("bBQKz")));

var $b5913ac5ef0d68a7$var$_Alert = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("16wD6")));

var $b5913ac5ef0d68a7$var$_FormControlLabel = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("i48ne")));

var $b5913ac5ef0d68a7$var$_Checkbox = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("aGDqy")));

var $b5913ac5ef0d68a7$var$_ArrowBack = $b5913ac5ef0d68a7$var$_interopRequireDefault((parcelRequire("1YLXO")));

var $3Ai54 = parcelRequire("3Ai54");

var $9xY2t = parcelRequire("9xY2t");

var $ayMG0 = parcelRequire("ayMG0");
function $b5913ac5ef0d68a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b5913ac5ef0d68a7$var$BRAND_GREEN = '#1D9E75';
const $b5913ac5ef0d68a7$var$fieldSx = {
    '& .MuiOutlinedInput-root': {
        fontFamily: "'DM Mono', monospace",
        fontSize: 13,
        borderRadius: 2,
        '& fieldset': {
            borderColor: 'rgba(255,255,255,0.12)'
        },
        '&:hover fieldset': {
            borderColor: $b5913ac5ef0d68a7$var$BRAND_GREEN
        },
        '&.Mui-focused fieldset': {
            borderColor: $b5913ac5ef0d68a7$var$BRAND_GREEN
        }
    },
    '& .MuiInputLabel-root': {
        fontFamily: "'DM Mono', monospace",
        fontSize: 13,
        '&.Mui-focused': {
            color: $b5913ac5ef0d68a7$var$BRAND_GREEN
        }
    },
    '& .MuiFormHelperText-root': {
        fontFamily: "'DM Mono', monospace",
        fontSize: 11,
        color: 'var(--color-text-secondary)'
    }
};
function $b5913ac5ef0d68a7$var$EditUserPage() {
    const { id: id } = (0, $gwjoH.useParams)();
    const navigate = (0, $gwjoH.useNavigate)();
    const [username, setUsername] = (0, $acw62.useState)('');
    const [email, setEmail] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [isAdmin, setIsAdmin] = (0, $acw62.useState)(false);
    const [message, setMessage] = (0, $acw62.useState)(null);
    const [currentUserId, setCurrentUserId] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!id) return;
        const loadUser = async ()=>{
            try {
                const user = await (0, $3Ai54.getUser)(id);
                setUsername(user.username);
                setEmail(user.email);
                setIsAdmin(user.groups?.includes('admin') ?? false);
            } catch (err) {
                setMessage({
                    type: 'error',
                    text: 'Failed to load user.'
                });
            }
        };
        loadUser();
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        const loadCurrentUser = async ()=>{
            const authUser = await (0, $9xY2t.getUser)();
            if (!authUser?.profile?.preferred_username) return;
            const users = await (0, $3Ai54.listUsers)(authUser.profile.preferred_username);
            if (users.length > 0) setCurrentUserId(users[0].id);
        };
        loadCurrentUser();
    }, []);
    const handleBack = ()=>navigate('/users');
    const handleUpdate = async ()=>{
        if (!id) return;
        try {
            await (0, $3Ai54.updateUser)(id, {
                username: username,
                email: email,
                password: password || undefined,
                group: isAdmin ? 'admin' : undefined
            });
            if (currentUserId === id) {
                setMessage({
                    type: 'success',
                    text: "User updated. Logging out\u2026"
                });
                setTimeout(()=>(0, $9xY2t.logout)(), 1500);
                return;
            }
            setMessage({
                type: 'success',
                text: 'User updated successfully.'
            });
            setTimeout(handleBack, 1000);
        } catch (err) {
            setMessage({
                type: 'error',
                text: err.message || 'Failed to update user.'
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b5913ac5ef0d68a7$var$_Box.default, {
        sx: {
            p: '0 1.5rem 2.5rem',
            width: '100%',
            height: '100vh',
            alignItems: 'center',
            boxSizing: 'border-box'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($b5913ac5ef0d68a7$var$_Box.default, {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_Button.default, {
                        variant: "outlined",
                        size: "small",
                        onClick: handleBack,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_ArrowBack.default, {
                            sx: {
                                fontSize: '14px !important',
                                padding: '0 !important'
                            }
                        }),
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 11,
                            textTransform: 'uppercase',
                            color: 'var(--color-text-secondary)',
                            borderColor: 'rgba(255,255,255,0.12)',
                            borderRadius: 2,
                            '&:hover': {
                                borderColor: $b5913ac5ef0d68a7$var$BRAND_GREEN,
                                color: $b5913ac5ef0d68a7$var$BRAND_GREEN
                            }
                        },
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_Typography.default, {
                        sx: {
                            fontFamily: "'Syne', sans-serif",
                            fontSize: 20,
                            fontWeight: 600,
                            color: $b5913ac5ef0d68a7$var$BRAND_GREEN
                        },
                        children: "Edit User"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($b5913ac5ef0d68a7$var$_Box.default, {
                sx: {
                    background: 'var(--color-bg-secondary)',
                    borderRadius: 3,
                    p: '1.5rem 2rem',
                    maxWidth: 480
                },
                children: [
                    message && /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_Alert.default, {
                        severity: message.type,
                        sx: {
                            mb: 2.5,
                            borderRadius: 2,
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 12
                        },
                        children: message.text
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($b5913ac5ef0d68a7$var$_Box.default, {
                        sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_TextField.default, {
                                label: "Username",
                                value: username,
                                onChange: (e)=>setUsername(e.target.value),
                                fullWidth: true,
                                size: "small",
                                sx: $b5913ac5ef0d68a7$var$fieldSx
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_TextField.default, {
                                label: "Email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                fullWidth: true,
                                size: "small",
                                sx: $b5913ac5ef0d68a7$var$fieldSx
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_TextField.default, {
                                label: "Password",
                                type: "password",
                                value: password,
                                onChange: (e)=>setPassword(e.target.value),
                                fullWidth: true,
                                size: "small",
                                helperText: "Leave blank to keep existing password",
                                sx: $b5913ac5ef0d68a7$var$fieldSx
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_FormControlLabel.default, {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_Checkbox.default, {
                                    checked: isAdmin,
                                    onChange: (e)=>setIsAdmin(e.target.checked),
                                    sx: {
                                        color: 'rgba(255,255,255,0.2)',
                                        '&.Mui-checked': {
                                            color: $b5913ac5ef0d68a7$var$BRAND_GREEN
                                        },
                                        '& svg': {
                                            fontSize: '18px !important',
                                            padding: '0 !important'
                                        }
                                    }
                                }),
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_Typography.default, {
                                    sx: {
                                        fontFamily: "'DM Mono', monospace",
                                        fontSize: 13,
                                        color: 'var(--color-text-primary)'
                                    },
                                    children: "Admin user"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b5913ac5ef0d68a7$var$_Button.default, {
                                variant: "contained",
                                onClick: handleUpdate,
                                fullWidth: true,
                                sx: {
                                    fontFamily: "'DM Mono', monospace",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    letterSpacing: '0.06em',
                                    textTransform: 'uppercase',
                                    background: $b5913ac5ef0d68a7$var$BRAND_GREEN,
                                    borderRadius: 2,
                                    py: 1.25,
                                    mt: 0.5,
                                    '&:hover': {
                                        background: '#17876A'
                                    }
                                },
                                children: "Update User"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("7fZw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ffdda810d185003$var$Callback;

var $acw62 = parcelRequire("acw62");

var $gwjoH = parcelRequire("gwjoH");

var $9ffdda810d185003$var$_auth = $9ffdda810d185003$var$_interopRequireDefault((parcelRequire("ca6gO")));

var $ayMG0 = parcelRequire("ayMG0");
function $9ffdda810d185003$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $9ffdda810d185003$var$Callback() {
    const navigate = (0, $gwjoH.useNavigate)();
    const handled = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (handled.current) return;
        handled.current = true;
        $9ffdda810d185003$var$_auth.default.signinRedirectCallback().then(async (user)=>{
            await $9ffdda810d185003$var$_auth.default.storeUser(user);
            navigate('/', {
                replace: true
            });
        }).catch((err)=>{
            console.error('Auth callback error:', err);
            navigate('/unauthorised', {
                replace: true
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        children: "Signing in..."
    });
}

});

parcelRegister("iG1hL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9aa081910ed2f81c$var$DynamicDashboard;

var $9aa081910ed2f81c$var$React = $9aa081910ed2f81c$var$_interopRequireWildcard((parcelRequire("acw62")));

var $9aa081910ed2f81c$var$_dayjs = $9aa081910ed2f81c$var$_interopRequireDefault((parcelRequire("gngdn")));

var $cvg8Z = parcelRequire("cvg8Z");

var $9aa081910ed2f81c$var$_Edit = $9aa081910ed2f81c$var$_interopRequireDefault((parcelRequire("c3r8Q")));

var $9aa081910ed2f81c$var$_Add = $9aa081910ed2f81c$var$_interopRequireDefault((parcelRequire("7tqxO")));

var $9aa081910ed2f81c$var$_Restore = $9aa081910ed2f81c$var$_interopRequireDefault((parcelRequire("6UW4c")));

var $9aa081910ed2f81c$var$_BaseDashboard = $9aa081910ed2f81c$var$_interopRequireDefault((parcelRequire("79FK2")));

var $9aa081910ed2f81c$var$_DashboardHeader = $9aa081910ed2f81c$var$_interopRequireDefault((parcelRequire("hzHhz")));

var $dOn5J = parcelRequire("dOn5J");

var $3u6kV = parcelRequire("3u6kV");

var $8zTdY = parcelRequire("8zTdY");

var $28goj = parcelRequire("28goj");

var $ayMG0 = parcelRequire("ayMG0");
function $9aa081910ed2f81c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $9aa081910ed2f81c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($9aa081910ed2f81c$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const $9aa081910ed2f81c$var$EMPTY_WIDGET = {
    osm_name: '',
    widget_type_id: 'sensor_gauge',
    chart_type: 'gauge',
    title: null,
    colour: null,
    min_value: null,
    max_value: null,
    layout_order: 0,
    measurement: null,
    config: null
};
function $9aa081910ed2f81c$var$toDbPayload(w) {
    const { measurement: measurement, ...rest } = w;
    return rest;
}
function $9aa081910ed2f81c$var$DynamicDashboard({ osmName: osmName, isAdmin: isAdmin = false }) {
    const [rangeMinutes, setRangeMinutes] = $9aa081910ed2f81c$var$React.useState(1440);
    const [dateFromValue, setDateFromValue] = $9aa081910ed2f81c$var$React.useState((0, $9aa081910ed2f81c$var$_dayjs.default)((0, $dOn5J.subtractMinutes)(rangeMinutes)));
    const [dateToValue, setDateToValue] = $9aa081910ed2f81c$var$React.useState((0, $9aa081910ed2f81c$var$_dayjs.default)((0, $dOn5J.nowISOString)()));
    const [widgets, setWidgets] = $9aa081910ed2f81c$var$React.useState([]);
    const [loading, setLoading] = $9aa081910ed2f81c$var$React.useState(true);
    const [editMode, setEditMode] = $9aa081910ed2f81c$var$React.useState(false);
    const [dialogOpen, setDialogOpen] = $9aa081910ed2f81c$var$React.useState(false);
    const [dialogWidget, setDialogWidget] = $9aa081910ed2f81c$var$React.useState($9aa081910ed2f81c$var$EMPTY_WIDGET);
    $9aa081910ed2f81c$var$React.useEffect(()=>{
        setDateFromValue((0, $9aa081910ed2f81c$var$_dayjs.default)((0, $dOn5J.subtractMinutes)(rangeMinutes)));
    }, [
        rangeMinutes
    ]);
    const fetchWidgets = $9aa081910ed2f81c$var$React.useCallback(()=>{
        setLoading(true);
        (0, $3u6kV.getDashboardWidgets)(osmName).then((rows)=>setWidgets(rows)).catch((err)=>console.error('Failed to fetch widgets:', err)).finally(()=>setLoading(false));
    }, [
        osmName
    ]);
    $9aa081910ed2f81c$var$React.useEffect(()=>{
        fetchWidgets();
    }, [
        fetchWidgets
    ]);
    const handleAdd = ()=>{
        setDialogWidget({
            ...$9aa081910ed2f81c$var$EMPTY_WIDGET,
            osm_name: osmName,
            layout_order: widgets.length
        });
        setDialogOpen(true);
    };
    const handleEdit = (widget)=>{
        setDialogWidget(widget);
        setDialogOpen(true);
    };
    const handleSaveDialog = async (w)=>{
        const payload = $9aa081910ed2f81c$var$toDbPayload({
            ...w,
            osm_name: osmName
        });
        if (w.id) await (0, $3u6kV.updateDashboardWidget)(w.id, payload);
        else await (0, $3u6kV.createDashboardWidget)(payload);
        fetchWidgets();
    };
    const handleDelete = async (id)=>{
        await (0, $3u6kV.deleteDashboardWidget)(id);
        setWidgets((prev)=>prev.filter((w)=>w.id !== id));
    };
    const handleMove = async (index, direction)=>{
        const swapIndex = direction === 'up' ? index - 1 : index + 1;
        if (swapIndex < 0 || swapIndex >= widgets.length) return;
        const updated = [
            ...widgets
        ];
        [updated[index], updated[swapIndex]] = [
            updated[swapIndex],
            updated[index]
        ];
        const reordered = updated.map((w, i)=>({
                ...w,
                layout_order: i
            }));
        setWidgets(reordered);
        await (0, $3u6kV.reorderDashboardWidgets)(reordered.map(({ id: id, layout_order: layout_order })=>({
                id: id,
                layout_order: layout_order
            })));
    };
    const handleResetToDefaults = async ()=>{
        if (!confirm('Reset to default? This will overwrite existing widgets.')) return;
        await (0, $3u6kV.resetWidgetsToDefault)(osmName);
        fetchWidgets();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9aa081910ed2f81c$var$_BaseDashboard.default, {
                dashboard_header: /*#__PURE__*/ (0, $ayMG0.jsx)($9aa081910ed2f81c$var$_DashboardHeader.default, {
                    title: osmName,
                    rangeMinutes: rangeMinutes,
                    setRangeMinutes: setRangeMinutes,
                    dateFromValue: dateFromValue,
                    setDateFromValue: setDateFromValue,
                    dateToValue: dateToValue,
                    setDateToValue: setDateToValue
                }),
                dashboard_content: /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                    sx: {
                        gridColumn: '1 / -1',
                        minHeight: '100vh',
                        overflowY: 'auto'
                    },
                    children: [
                        isAdmin && /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                            sx: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 1,
                                px: 2,
                                pt: 1
                            },
                            children: [
                                editMode && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                                            title: "Reset to defaults",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                                                onClick: handleResetToDefaults,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($9aa081910ed2f81c$var$_Restore.default, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                                            title: "Add widget",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                                                onClick: handleAdd,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($9aa081910ed2f81c$var$_Add.default, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                                    title: editMode ? 'Done editing' : 'Edit dashboard',
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                                        onClick: ()=>setEditMode((p)=>!p),
                                        color: editMode ? 'primary' : 'default',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9aa081910ed2f81c$var$_Edit.default, {})
                                    })
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {
                            sx: {
                                m: 2
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($28goj.DashboardContent, {
                            widgets: widgets,
                            osmName: osmName,
                            dateFromValue: dateFromValue,
                            dateToValue: dateToValue,
                            editMode: editMode,
                            onEdit: handleEdit,
                            onDelete: handleDelete,
                            onMove: handleMove
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8zTdY.WidgetDialog, {
                open: dialogOpen,
                initial: dialogWidget,
                osmName: osmName,
                onClose: ()=>setDialogOpen(false),
                onSave: handleSaveDialog
            })
        ]
    });
}

});
parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("6UW4c", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $509503e2b8074619$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $509503e2b8074619$var$_createSvgIcon = $509503e2b8074619$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $509503e2b8074619$var$_default = module.exports.default = (0, $509503e2b8074619$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), 'Restore');

});

parcelRegister("79FK2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6de053601fe507fc$var$BaseDashboard;

var $6de053601fe507fc$var$React = $6de053601fe507fc$var$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
function $6de053601fe507fc$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6de053601fe507fc$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $6de053601fe507fc$var$BaseDashboard({ dashboard_header: dashboard_header, dashboard_content: dashboard_content }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "sensor-dashboard",
        children: [
            dashboard_header,
            dashboard_content
        ]
    });
}

});

parcelRegister("hzHhz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $701783d06e05bf87$var$DashboardHeader;

var $l0Lh3 = parcelRequire("l0Lh3");

var $5bAd0 = parcelRequire("5bAd0");

var $uaXRK = parcelRequire("uaXRK");

var $701783d06e05bf87$var$_ShorthandTimePicker = $701783d06e05bf87$var$_interopRequireDefault((parcelRequire("6vZDy")));

var $ayMG0 = parcelRequire("ayMG0");
function $701783d06e05bf87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $701783d06e05bf87$var$DashboardHeader({ title: title, rangeMinutes: rangeMinutes, setRangeMinutes: setRangeMinutes, dateFromValue: dateFromValue, dateToValue: dateToValue, setDateFromValue: setDateFromValue, setDateToValue: setDateToValue }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                className: "sensor-dashboard-header",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-testid": "time-range-picker-div",
                    className: "time-range-picker-div",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($uaXRK.LocalizationProvider, {
                        dateAdapter: $5bAd0.AdapterDayjs,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($701783d06e05bf87$var$_ShorthandTimePicker.default, {
                                rangeMinutes: rangeMinutes,
                                setRangeMinutes: setRangeMinutes
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($l0Lh3.MobileDateTimePicker, {
                                label: "Date From",
                                value: dateFromValue,
                                onChange: setDateFromValue
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($l0Lh3.MobileDateTimePicker, {
                                label: "Date To",
                                value: dateToValue,
                                onChange: setDateToValue
                            })
                        ]
                    })
                })
            })
        ]
    });
}

});
parcelRegister("l0Lh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MobileDateTimePicker", {
    enumerable: true,
    get: function() {
        return $frD2Q.MobileDateTimePicker;
    }
});

var $frD2Q = parcelRequire("frD2Q");

});
parcelRegister("frD2Q", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b3e7aa1da004c619$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b3e7aa1da004c619$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MobileDateTimePicker = void 0;

var $b3e7aa1da004c619$var$_extends2 = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b3e7aa1da004c619$var$React = $b3e7aa1da004c619$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b3e7aa1da004c619$var$_propTypes = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b3e7aa1da004c619$var$_resolveComponentProps = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("jzekU")));

var $b3e7aa1da004c619$var$_refType = $b3e7aa1da004c619$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $1M3bL = parcelRequire("1M3bL");

var $2EpWj = parcelRequire("2EpWj");

var $jHZPa = parcelRequire("jHZPa");

var $3nE24 = parcelRequire("3nE24");

var $5UoGz = parcelRequire("5UoGz");

var $cLPus = parcelRequire("cLPus");

var $5TrXg = parcelRequire("5TrXg");

var $l5kHo = parcelRequire("l5kHo");

var $3eed6 = parcelRequire("3eed6");

var $99eO4 = parcelRequire("99eO4");

var $2QxZ0 = parcelRequire("2QxZ0");

var $l16rr = parcelRequire("l16rr");

var $hOsJb = parcelRequire("hOsJb");

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");
const $b3e7aa1da004c619$var$STEPS = [
    {
        views: $NRNex.DATE_VIEWS
    },
    {
        views: $cElCc.EXPORTED_TIME_VIEWS
    }
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const $b3e7aa1da004c619$var$MobileDateTimePicker = module.exports.MobileDateTimePicker = /*#__PURE__*/ $b3e7aa1da004c619$var$React.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $jHZPa.useDateTimePickerDefaultizedProps)(inProps, 'MuiMobileDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? $l5kHo.renderDigitalClockTimeView : $l5kHo.renderMultiSectionDigitalClockTimeView;
    const viewRenderers = (0, $b3e7aa1da004c619$var$_extends2.default)({
        day: $5TrXg.renderDateViewCalendar,
        month: $5TrXg.renderDateViewCalendar,
        year: $5TrXg.renderDateViewCalendar,
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === $l5kHo.renderMultiSectionDigitalClockTimeView.name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the mobile variant
    const props = (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $3eed6.resolveDateTimeFormat)(adapter, (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps, {
            views: defaultizedProps.viewsForFormatting
        })),
        views: views,
        ampmInClock: ampmInClock,
        slots: (0, $b3e7aa1da004c619$var$_extends2.default)({
            field: $2EpWj.DateTimeField
        }, defaultizedProps.slots),
        slotProps: (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $b3e7aa1da004c619$var$_extends2.default)({}, (0, $b3e7aa1da004c619$var$_resolveComponentProps.default)(defaultizedProps.slotProps?.field, ownerState), (0, $5UoGz.extractValidationProps)(defaultizedProps)),
            toolbar: (0, $b3e7aa1da004c619$var$_extends2.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $b3e7aa1da004c619$var$_extends2.default)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs),
            layout: (0, $b3e7aa1da004c619$var$_extends2.default)({}, defaultizedProps.slotProps?.layout, {
                sx: (0, $l16rr.mergeSx)([
                    {
                        [`& .${$2QxZ0.multiSectionDigitalClockClasses.root}`]: {
                            width: $99eO4.DIALOG_WIDTH
                        },
                        [`& .${$2QxZ0.multiSectionDigitalClockSectionClasses.root}`]: {
                            flex: 1,
                            // account for the border on `MultiSectionDigitalClock`
                            maxHeight: $99eO4.VIEW_HEIGHT - 1,
                            [`.${$2QxZ0.multiSectionDigitalClockSectionClasses.item}`]: {
                                width: 'auto'
                            }
                        },
                        [`& .${$hOsJb.digitalClockClasses.root}`]: {
                            width: $99eO4.DIALOG_WIDTH,
                            maxHeight: $99eO4.VIEW_HEIGHT,
                            flex: 1,
                            [`.${$hOsJb.digitalClockClasses.item}`]: {
                                justifyContent: 'center'
                            }
                        }
                    }
                ], defaultizedProps.slotProps?.layout?.sx)
            })
        })
    });
    const { renderPicker: renderPicker } = (0, $cLPus.useMobilePicker)({
        ref: ref,
        props: props,
        valueManager: $1M3bL.singleItemValueManager,
        valueType: 'date-time',
        validator: $5UoGz.validateDateTime,
        steps: $b3e7aa1da004c619$var$STEPS
    });
    return renderPicker();
});
$b3e7aa1da004c619$var$MobileDateTimePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default adapter.is12HourCycleInCurrentLocale()
   */ ampm: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: $b3e7aa1da004c619$var$_propTypes.default.bool,
    className: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: $b3e7aa1da004c619$var$_propTypes.default.any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: $b3e7aa1da004c619$var$_propTypes.default.number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: $b3e7aa1da004c619$var$_refType.default,
    /**
   * The label content.
   */ label: $b3e7aa1da004c619$var$_propTypes.default.node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: $b3e7aa1da004c619$var$_propTypes.default.number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context Context about this acceptance:
   * - `validationError`: validation result of the current value
   * - `source`: source of the acceptance. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the value was accepted via a shortcut selection
   */ onAccept: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context Context about this change:
   * - `validationError`: validation result of the current value
   * - `source`: source of the change. One of 'field' | 'view' | 'unknown'
   * - `shortcut` (optional): the shortcut metadata if the change was triggered by a shortcut selection
   */ onChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: $b3e7aa1da004c619$var$_propTypes.default.oneOfType([
        $b3e7aa1da004c619$var$_propTypes.default.oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        $b3e7aa1da004c619$var$_propTypes.default.number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: $b3e7aa1da004c619$var$_propTypes.default.func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: $b3e7aa1da004c619$var$_propTypes.default.bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: $b3e7aa1da004c619$var$_propTypes.default.oneOfType([
        $b3e7aa1da004c619$var$_propTypes.default.arrayOf($b3e7aa1da004c619$var$_propTypes.default.oneOfType([
            $b3e7aa1da004c619$var$_propTypes.default.func,
            $b3e7aa1da004c619$var$_propTypes.default.object,
            $b3e7aa1da004c619$var$_propTypes.default.bool
        ])),
        $b3e7aa1da004c619$var$_propTypes.default.func,
        $b3e7aa1da004c619$var$_propTypes.default.object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: $b3e7aa1da004c619$var$_propTypes.default.number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeSteps.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeSteps.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: $b3e7aa1da004c619$var$_propTypes.default.shape({
        hours: $b3e7aa1da004c619$var$_propTypes.default.number,
        minutes: $b3e7aa1da004c619$var$_propTypes.default.number,
        seconds: $b3e7aa1da004c619$var$_propTypes.default.number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: $b3e7aa1da004c619$var$_propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: $b3e7aa1da004c619$var$_propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: $b3e7aa1da004c619$var$_propTypes.default.shape({
        day: $b3e7aa1da004c619$var$_propTypes.default.func,
        hours: $b3e7aa1da004c619$var$_propTypes.default.func,
        meridiem: $b3e7aa1da004c619$var$_propTypes.default.func,
        minutes: $b3e7aa1da004c619$var$_propTypes.default.func,
        month: $b3e7aa1da004c619$var$_propTypes.default.func,
        seconds: $b3e7aa1da004c619$var$_propTypes.default.func,
        year: $b3e7aa1da004c619$var$_propTypes.default.func
    }),
    /**
   * Available views.
   */ views: $b3e7aa1da004c619$var$_propTypes.default.arrayOf($b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: $b3e7aa1da004c619$var$_propTypes.default.oneOf([
        3,
        4
    ])
};

});
parcelRegister("1M3bL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $14acbf5609fff29c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.singleItemValueManager = module.exports.singleItemFieldValueManager = void 0;

var $14acbf5609fff29c$var$_extends2 = $14acbf5609fff29c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $14acbf5609fff29c$var$_objectWithoutPropertiesLoose2 = $14acbf5609fff29c$require$_interopRequireDefault((parcelRequire("c05no")));

var $NRNex = parcelRequire("NRNex");

var $gUrai = parcelRequire("gUrai");

var $l9aHF = parcelRequire("l9aHF");
const $14acbf5609fff29c$var$_excluded = [
    "value",
    "referenceDate"
];
const $14acbf5609fff29c$var$singleItemValueManager = module.exports.singleItemValueManager = {
    emptyValue: null,
    getTodayValue: $NRNex.getTodayDate,
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $14acbf5609fff29c$var$_objectWithoutPropertiesLoose2.default)(_ref, $14acbf5609fff29c$var$_excluded);
        if (params.adapter.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $gUrai.getDefaultReferenceDate)(params);
    },
    cleanValue: $NRNex.replaceInvalidDateByNull,
    areValuesEqual: $NRNex.areDatesEqual,
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (adapter, value)=>adapter.isValid(value) ? adapter.getTimezone(value) : null,
    setTimezone: (adapter, timezone, value)=>value == null ? null : adapter.setTimezone(value, timezone)
};
const $14acbf5609fff29c$var$singleItemFieldValueManager = module.exports.singleItemFieldValueManager = {
    updateReferenceValue: (adapter, value, prevReferenceValue)=>adapter.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getV7HiddenInputValueFromSections: $l9aHF.createDateStrForV7HiddenInputFromSections,
    getV6InputValueFromSections: $l9aHF.createDateStrForV6InputFromSections,
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, $14acbf5609fff29c$var$_extends2.default)({}, section, {
                value: ''
            }))
};

});
parcelRegister("NRNex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDateFormat = module.exports.replaceInvalidDateByNull = module.exports.mergeDateAndTime = module.exports.isDatePickerView = module.exports.getWeekdays = module.exports.getTodayDate = module.exports.getMonthsInYear = module.exports.formatMeridiem = module.exports.findClosestEnabledDate = module.exports.areDatesEqual = module.exports.applyDefaultDate = module.exports.DATE_VIEWS = void 0;

var $kqIjR = parcelRequire("kqIjR");
const $095e4de7afe66795$var$mergeDateAndTime = (adapter, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
    mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
    mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
    mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
    return mergedDate;
};
module.exports.mergeDateAndTime = $095e4de7afe66795$var$mergeDateAndTime;
const $095e4de7afe66795$var$findClosestEnabledDate = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, adapter: adapter, timezone: timezone })=>{
    const today = $095e4de7afe66795$var$mergeDateAndTime(adapter, adapter.date(undefined, timezone), date);
    if (disablePast && adapter.isBefore(minDate, today)) minDate = today;
    if (disableFuture && adapter.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (adapter.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (adapter.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && adapter.isAfter(forward, maxDate)) forward = null;
        if (backward && adapter.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = adapter.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = adapter.addDays(backward, -1);
        }
    }
    return null;
};
module.exports.findClosestEnabledDate = $095e4de7afe66795$var$findClosestEnabledDate;
const $095e4de7afe66795$var$replaceInvalidDateByNull = (adapter, value)=>!adapter.isValid(value) ? null : value;
module.exports.replaceInvalidDateByNull = $095e4de7afe66795$var$replaceInvalidDateByNull;
const $095e4de7afe66795$var$applyDefaultDate = (adapter, value, defaultValue)=>{
    if (value == null || !adapter.isValid(value)) return defaultValue;
    return value;
};
module.exports.applyDefaultDate = $095e4de7afe66795$var$applyDefaultDate;
const $095e4de7afe66795$var$areDatesEqual = (adapter, a, b)=>{
    if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) return true;
    return adapter.isEqual(a, b);
};
module.exports.areDatesEqual = $095e4de7afe66795$var$areDatesEqual;
const $095e4de7afe66795$var$getMonthsInYear = (adapter, year)=>{
    const firstMonth = adapter.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(adapter.addMonths(prevMonth, 1));
    }
    return months;
};
module.exports.getMonthsInYear = $095e4de7afe66795$var$getMonthsInYear;
const $095e4de7afe66795$var$getTodayDate = (adapter, timezone, valueType)=>valueType === 'date' ? adapter.startOfDay(adapter.date(undefined, timezone)) : adapter.date(undefined, timezone);
module.exports.getTodayDate = $095e4de7afe66795$var$getTodayDate;
const $095e4de7afe66795$var$formatMeridiem = (adapter, meridiem)=>{
    const date = adapter.setHours(adapter.date(), meridiem === 'am' ? 2 : 14);
    return adapter.format(date, 'meridiem');
};
module.exports.formatMeridiem = $095e4de7afe66795$var$formatMeridiem;
const $095e4de7afe66795$var$DATE_VIEWS = module.exports.DATE_VIEWS = [
    'year',
    'month',
    'day'
];
const $095e4de7afe66795$var$isDatePickerView = (view)=>$095e4de7afe66795$var$DATE_VIEWS.includes(view);
module.exports.isDatePickerView = $095e4de7afe66795$var$isDatePickerView;
const $095e4de7afe66795$var$resolveDateFormat = (adapter, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'year'
    ])) return formats.year;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'month'
    ])) return formats.month;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
module.exports.resolveDateFormat = $095e4de7afe66795$var$resolveDateFormat;
const $095e4de7afe66795$var$getWeekdays = (adapter, date)=>{
    const start = adapter.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>adapter.addDays(start, diff));
};
module.exports.getWeekdays = $095e4de7afe66795$var$getWeekdays;

});
parcelRegister("kqIjR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.areViewsEqual = module.exports.applyDefaultViewProps = void 0;
const $edf89d3e5f97447f$var$areViewsEqual = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
module.exports.areViewsEqual = $edf89d3e5f97447f$var$areViewsEqual;
const $edf89d3e5f97447f$var$applyDefaultViewProps = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};
module.exports.applyDefaultViewProps = $edf89d3e5f97447f$var$applyDefaultViewProps;

});


parcelRegister("gUrai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSectionTypeGranularity = module.exports.getDefaultReferenceDate = module.exports.SECTION_TYPE_GRANULARITY = void 0;

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");
const $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY = module.exports.SECTION_TYPE_GRANULARITY = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $c4f6f2b8fcbb5fe9$var$getSectionTypeGranularity = (sections)=>Math.max(...sections.map((section)=>$c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY[section.type] ?? 1));
module.exports.getSectionTypeGranularity = $c4f6f2b8fcbb5fe9$var$getSectionTypeGranularity;
const $c4f6f2b8fcbb5fe9$var$roundDate = (adapter, granularity, date)=>{
    if (granularity === $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.year) return adapter.startOfYear(date);
    if (granularity === $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.month) return adapter.startOfMonth(date);
    if (granularity === $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.day) return adapter.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.minutes) roundedDate = adapter.setMinutes(roundedDate, 0);
    if (granularity < $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.seconds) roundedDate = adapter.setSeconds(roundedDate, 0);
    if (granularity < $c4f6f2b8fcbb5fe9$var$SECTION_TYPE_GRANULARITY.milliseconds) roundedDate = adapter.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $c4f6f2b8fcbb5fe9$var$getDefaultReferenceDate = ({ props: props, adapter: adapter, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, (0, $NRNex.getTodayDate)(adapter, timezone));
    if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.minDate);
    if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.maxDate);
    const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(props.disableIgnoringDatePartForTimeValidation ?? false, adapter);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $NRNex.mergeDateAndTime)(adapter, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $NRNex.mergeDateAndTime)(adapter, referenceDate, props.maxTime));
    return referenceDate;
};
module.exports.getDefaultReferenceDate = $c4f6f2b8fcbb5fe9$var$getDefaultReferenceDate;

});
parcelRegister("cElCc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveTimeFormat = module.exports.isTimeView = module.exports.isInternalTimeView = module.exports.getSecondsInDay = module.exports.getMeridiem = module.exports.createIsAfterIgnoreDatePart = module.exports.convertValueToMeridiem = module.exports.convertToMeridiem = module.exports.TIME_VIEWS = module.exports.EXPORTED_TIME_VIEWS = void 0;

var $kqIjR = parcelRequire("kqIjR");
const $9359fccca2daa962$var$EXPORTED_TIME_VIEWS = module.exports.EXPORTED_TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds'
];
const $9359fccca2daa962$var$TIME_VIEWS = module.exports.TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const $9359fccca2daa962$var$isTimeView = (view)=>$9359fccca2daa962$var$EXPORTED_TIME_VIEWS.includes(view);
module.exports.isTimeView = $9359fccca2daa962$var$isTimeView;
const $9359fccca2daa962$var$isInternalTimeView = (view)=>$9359fccca2daa962$var$TIME_VIEWS.includes(view);
module.exports.isInternalTimeView = $9359fccca2daa962$var$isInternalTimeView;
const $9359fccca2daa962$var$getMeridiem = (date, adapter)=>{
    if (!date) return null;
    return adapter.getHours(date) >= 12 ? 'pm' : 'am';
};
module.exports.getMeridiem = $9359fccca2daa962$var$getMeridiem;
const $9359fccca2daa962$var$convertValueToMeridiem = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
module.exports.convertValueToMeridiem = $9359fccca2daa962$var$convertValueToMeridiem;
const $9359fccca2daa962$var$convertToMeridiem = (time, meridiem, ampm, adapter)=>{
    const newHoursAmount = $9359fccca2daa962$var$convertValueToMeridiem(adapter.getHours(time), meridiem, ampm);
    return adapter.setHours(time, newHoursAmount);
};
module.exports.convertToMeridiem = $9359fccca2daa962$var$convertToMeridiem;
const $9359fccca2daa962$var$getSecondsInDay = (date, adapter)=>{
    return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
module.exports.getSecondsInDay = $9359fccca2daa962$var$getSecondsInDay;
const $9359fccca2daa962$var$createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, adapter)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return adapter.isAfter(dateLeft, dateRight);
        return $9359fccca2daa962$var$getSecondsInDay(dateLeft, adapter) > $9359fccca2daa962$var$getSecondsInDay(dateRight, adapter);
    };
module.exports.createIsAfterIgnoreDatePart = $9359fccca2daa962$var$createIsAfterIgnoreDatePart;
const $9359fccca2daa962$var$resolveTimeFormat = (adapter, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $kqIjR.areViewsEqual)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};
module.exports.resolveTimeFormat = $9359fccca2daa962$var$resolveTimeFormat;

});


parcelRegister("l9aHF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSections = module.exports.removeLocalizedDigits = module.exports.parseSelectedSections = module.exports.mergeDateIntoReferenceDate = module.exports.isStringNumber = module.exports.isAndroid = module.exports.getSectionsBoundaries = module.exports.getSectionVisibleValue = module.exports.getSectionOrder = module.exports.getLocalizedDigits = module.exports.getLetterEditingOptions = module.exports.getDaysInWeekStr = module.exports.getDateSectionConfigFromFormatToken = module.exports.getDateFromDateSections = module.exports.doesSectionFormatHaveLeadingZeros = module.exports.createDateStrForV7HiddenInputFromSections = module.exports.createDateStrForV6InputFromSections = module.exports.cleanLeadingZeros = module.exports.cleanDigitSectionValue = module.exports.changeSectionValueFormat = module.exports.applyLocalizedDigits = module.exports.FORMAT_SECONDS_NO_LEADING_ZEROS = void 0;

var $NRNex = parcelRequire("NRNex");
const $f652bdb72e319cb0$var$getDateSectionConfigFromFormatToken = (adapter, formatToken)=>{
    const config = adapter.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
module.exports.getDateSectionConfigFromFormatToken = $f652bdb72e319cb0$var$getDateSectionConfigFromFormatToken;
const $f652bdb72e319cb0$var$getDaysInWeekStr = (adapter, format)=>{
    const elements = [];
    const now = adapter.date(undefined, 'default');
    const startDate = adapter.startOfWeek(now);
    const endDate = adapter.endOfWeek(now);
    let current = startDate;
    while(adapter.isBefore(current, endDate)){
        elements.push(current);
        current = adapter.addDays(current, 1);
    }
    return elements.map((weekDay)=>adapter.formatByString(weekDay, format));
};
module.exports.getDaysInWeekStr = $f652bdb72e319cb0$var$getDaysInWeekStr;
const $f652bdb72e319cb0$var$getLetterEditingOptions = (adapter, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $NRNex.getMonthsInYear)(adapter, adapter.date(undefined, timezone)).map((month)=>adapter.formatByString(month, format));
        case 'weekDay':
            return $f652bdb72e319cb0$var$getDaysInWeekStr(adapter, format);
        case 'meridiem':
            {
                const now = adapter.date(undefined, timezone);
                return [
                    adapter.startOfDay(now),
                    adapter.endOfDay(now)
                ].map((date)=>adapter.formatByString(date, format));
            }
        default:
            return [];
    }
};
// This format should be the same on all the adapters
// If some adapter does not respect this convention, then we will need to hardcode the format on each adapter.
module.exports.getLetterEditingOptions = $f652bdb72e319cb0$var$getLetterEditingOptions;
const $f652bdb72e319cb0$var$FORMAT_SECONDS_NO_LEADING_ZEROS = module.exports.FORMAT_SECONDS_NO_LEADING_ZEROS = 's';
const $f652bdb72e319cb0$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $f652bdb72e319cb0$var$getLocalizedDigits = (adapter)=>{
    const today = adapter.date(undefined);
    const formattedZero = adapter.formatByString(adapter.setSeconds(today, 0), $f652bdb72e319cb0$var$FORMAT_SECONDS_NO_LEADING_ZEROS);
    if (formattedZero === '0') return $f652bdb72e319cb0$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>adapter.formatByString(adapter.setSeconds(today, index), $f652bdb72e319cb0$var$FORMAT_SECONDS_NO_LEADING_ZEROS));
};
module.exports.getLocalizedDigits = $f652bdb72e319cb0$var$getLocalizedDigits;
const $f652bdb72e319cb0$var$removeLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
module.exports.removeLocalizedDigits = $f652bdb72e319cb0$var$removeLocalizedDigits;
const $f652bdb72e319cb0$var$applyLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
module.exports.applyLocalizedDigits = $f652bdb72e319cb0$var$applyLocalizedDigits;
const $f652bdb72e319cb0$var$isStringNumber = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $f652bdb72e319cb0$var$removeLocalizedDigits(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
/**
 * Make sure the value of a digit section have the right amount of leading zeros.
 * E.g.: `03` => `3`
 * Warning: Should only be called with non-localized digits. Call `removeLocalizedDigits` with your value if needed.
 */ module.exports.isStringNumber = $f652bdb72e319cb0$var$isStringNumber;
const $f652bdb72e319cb0$var$cleanLeadingZeros = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
module.exports.cleanLeadingZeros = $f652bdb72e319cb0$var$cleanLeadingZeros;
const $f652bdb72e319cb0$var$cleanDigitSectionValue = (adapter, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = adapter.setDate(sectionBoundaries.longestMonth, value);
        return adapter.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $f652bdb72e319cb0$var$cleanLeadingZeros(valueStr, section.maxLength);
    return $f652bdb72e319cb0$var$applyLocalizedDigits(valueStr, localizedDigits);
};
module.exports.cleanDigitSectionValue = $f652bdb72e319cb0$var$cleanDigitSectionValue;
const $f652bdb72e319cb0$var$getSectionVisibleValue = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($f652bdb72e319cb0$var$removeLocalizedDigits(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
module.exports.getSectionVisibleValue = $f652bdb72e319cb0$var$getSectionVisibleValue;
const $f652bdb72e319cb0$var$changeSectionValueFormat = (adapter, valueStr, currentFormat, newFormat)=>{
    return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
module.exports.changeSectionValueFormat = $f652bdb72e319cb0$var$changeSectionValueFormat;
const $f652bdb72e319cb0$var$isFourDigitYearFormat = (adapter, format)=>adapter.formatByString(adapter.date(undefined, 'system'), format).length === 4;
const $f652bdb72e319cb0$var$doesSectionFormatHaveLeadingZeros = (adapter, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = adapter.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (adapter.lib === 'dayjs' && format === 'YY') return true;
            return adapter.formatByString(adapter.setYear(now, 1), format).startsWith('0');
        case 'month':
            return adapter.formatByString(adapter.startOfYear(now), format).length > 1;
        case 'day':
            return adapter.formatByString(adapter.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return adapter.formatByString(adapter.startOfWeek(now), format).length > 1;
        case 'hours':
            return adapter.formatByString(adapter.setHours(now, 1), format).length > 1;
        case 'minutes':
            return adapter.formatByString(adapter.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return adapter.formatByString(adapter.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
/**
 * Some date libraries like `dayjs` don't support parsing from date with escaped characters.
 * To make sure that the parsing works, we are building a format and a date without any separator.
 */ module.exports.doesSectionFormatHaveLeadingZeros = $f652bdb72e319cb0$var$doesSectionFormatHaveLeadingZeros;
const $f652bdb72e319cb0$var$getDateFromDateSections = (adapter, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($f652bdb72e319cb0$var$getSectionVisibleValue(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
module.exports.getDateFromDateSections = $f652bdb72e319cb0$var$getDateFromDateSections;
const $f652bdb72e319cb0$var$createDateStrForV7HiddenInputFromSections = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
module.exports.createDateStrForV7HiddenInputFromSections = $f652bdb72e319cb0$var$createDateStrForV7HiddenInputFromSections;
const $f652bdb72e319cb0$var$createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $f652bdb72e319cb0$var$getSectionVisibleValue(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
module.exports.createDateStrForV6InputFromSections = $f652bdb72e319cb0$var$createDateStrForV6InputFromSections;
const $f652bdb72e319cb0$var$getSectionsBoundaries = (adapter, localizedDigits, timezone)=>{
    const today = adapter.date(undefined, timezone);
    const endOfYear = adapter.endOfYear(today);
    const endOfDay = adapter.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $NRNex.getMonthsInYear)(adapter, today).reduce((acc, month)=>{
        const daysInMonth = adapter.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $f652bdb72e319cb0$var$isFourDigitYearFormat(adapter, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: adapter.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $f652bdb72e319cb0$var$getDaysInWeekStr(adapter, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = adapter.getHours(endOfDay);
            const hasMeridiem = $f652bdb72e319cb0$var$removeLocalizedDigits(adapter.formatByString(adapter.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($f652bdb72e319cb0$var$removeLocalizedDigits(adapter.formatByString(adapter.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: adapter.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: adapter.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
module.exports.getSectionsBoundaries = $f652bdb72e319cb0$var$getSectionsBoundaries;
let $f652bdb72e319cb0$var$warnedOnceInvalidSection = false;
const $f652bdb72e319cb0$var$validateSections = (sections, valueType)=>{};
module.exports.validateSections = $f652bdb72e319cb0$var$validateSections;
const $f652bdb72e319cb0$var$transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
        case 'month':
            return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = $f652bdb72e319cb0$var$cleanLeadingZeros(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = $f652bdb72e319cb0$var$getDaysInWeekStr(adapter, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return adapter.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = adapter.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = adapter.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return adapter.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return adapter.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
        case 'minutes':
            return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
        case 'seconds':
            return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $f652bdb72e319cb0$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $f652bdb72e319cb0$var$mergeDateIntoReferenceDate = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$f652bdb72e319cb0$var$reliableSectionModificationOrder[a.type] - $f652bdb72e319cb0$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $f652bdb72e319cb0$var$transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
module.exports.mergeDateIntoReferenceDate = $f652bdb72e319cb0$var$mergeDateIntoReferenceDate;
const $f652bdb72e319cb0$var$isAndroid = ()=>navigator.userAgent.toLowerCase().includes('android');
// TODO v9: Remove
module.exports.isAndroid = $f652bdb72e319cb0$var$isAndroid;
const $f652bdb72e319cb0$var$getSectionOrder = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
module.exports.getSectionOrder = $f652bdb72e319cb0$var$getSectionOrder;
const $f652bdb72e319cb0$var$parseSelectedSections = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};
module.exports.parseSelectedSections = $f652bdb72e319cb0$var$parseSelectedSections;

});


parcelRegister("2EpWj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DateTimeField", {
    enumerable: true,
    get: function() {
        return $jRanZ.DateTimeField;
    }
});
Object.defineProperty(module.exports, "unstable_useDateTimeField", {
    enumerable: true,
    get: function() {
        return $dtG8S.useDateTimeField;
    }
});

var $jRanZ = parcelRequire("jRanZ");

var $dtG8S = parcelRequire("dtG8S");

});
parcelRegister("jRanZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e74b05fedf1e5845$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e74b05fedf1e5845$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimeField = void 0;

var $e74b05fedf1e5845$var$_objectWithoutPropertiesLoose2 = $e74b05fedf1e5845$require$_interopRequireDefault((parcelRequire("c05no")));

var $e74b05fedf1e5845$var$React = $e74b05fedf1e5845$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e74b05fedf1e5845$var$_propTypes = $e74b05fedf1e5845$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $e74b05fedf1e5845$var$_refType = $e74b05fedf1e5845$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $dtG8S = parcelRequire("dtG8S");

var $w6zXP = parcelRequire("w6zXP");

var $1SVAo = parcelRequire("1SVAo");

var $ayMG0 = parcelRequire("ayMG0");
const $e74b05fedf1e5845$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const $e74b05fedf1e5845$var$DateTimeField = module.exports.DateTimeField = /*#__PURE__*/ $e74b05fedf1e5845$var$React.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimeField'
    });
    const { slots: slots, slotProps: slotProps } = themeProps, other = (0, $e74b05fedf1e5845$var$_objectWithoutPropertiesLoose2.default)(themeProps, $e74b05fedf1e5845$var$_excluded);
    const textFieldProps = (0, $w6zXP.useFieldTextFieldProps)({
        slotProps: slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, $dtG8S.useDateTimeField)(textFieldProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($w6zXP.PickerFieldUIContextProvider, {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($w6zXP.PickerFieldUI, {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: $1SVAo.CalendarIcon
        })
    });
});

});
parcelRegister("dtG8S", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDateTimeField = void 0;

var $g3v6z = parcelRequire("g3v6z");

var $8tpPE = parcelRequire("8tpPE");
const $9cfeac5d7b0a3dba$var$useDateTimeField = (props)=>{
    const manager = (0, $8tpPE.useDateTimeManager)(props);
    return (0, $g3v6z.useField)({
        manager: manager,
        props: props
    });
};
module.exports.useDateTimeField = $9cfeac5d7b0a3dba$var$useDateTimeField;

});
parcelRegister("g3v6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createDateStrForV6InputFromSections", {
    enumerable: true,
    get: function() {
        return $l9aHF.createDateStrForV6InputFromSections;
    }
});
Object.defineProperty(module.exports, "createDateStrForV7HiddenInputFromSections", {
    enumerable: true,
    get: function() {
        return $l9aHF.createDateStrForV7HiddenInputFromSections;
    }
});
Object.defineProperty(module.exports, "useField", {
    enumerable: true,
    get: function() {
        return $j9lLh.useField;
    }
});
Object.defineProperty(module.exports, "useFieldInternalPropsWithDefaults", {
    enumerable: true,
    get: function() {
        return $8wNUU.useFieldInternalPropsWithDefaults;
    }
});

var $j9lLh = parcelRequire("j9lLh");

var $l9aHF = parcelRequire("l9aHF");

var $8wNUU = parcelRequire("8wNUU");

});
parcelRegister("j9lLh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useField = void 0;

var $fgmlt = parcelRequire("fgmlt");

var $3Pdrd = parcelRequire("3Pdrd");

var $6zwRZ = parcelRequire("6zwRZ");
const $df0fbd014072b490$var$useField = (parameters)=>{
    const fieldPrivateContext = (0, $6zwRZ.useNullableFieldPrivateContext)();
    const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
    const useFieldTextField = enableAccessibleFieldDOMStructure ? $fgmlt.useFieldV7TextField : $3Pdrd.useFieldV6TextField;
    return useFieldTextField(parameters);
};
module.exports.useField = $df0fbd014072b490$var$useField;

});
parcelRegister("fgmlt", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b1c9aeef70035656$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b1c9aeef70035656$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldV7TextField = void 0;

var $b1c9aeef70035656$var$_extends2 = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b1c9aeef70035656$var$React = $b1c9aeef70035656$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b1c9aeef70035656$var$_useForkRef = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $b1c9aeef70035656$var$_useEventCallback = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $b1c9aeef70035656$var$_useEnhancedEffect = $b1c9aeef70035656$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $l9aHF = parcelRequire("l9aHF");

var $l16rr = parcelRequire("l16rr");

var $BKARN = parcelRequire("BKARN");

var $LYmdu = parcelRequire("LYmdu");

var $b1YwV = parcelRequire("b1YwV");

var $8wNUU = parcelRequire("8wNUU");

var $aUKcB = parcelRequire("aUKcB");

var $e0rC1 = parcelRequire("e0rC1");

var $13xsf = parcelRequire("13xsf");

var $cb1pF = parcelRequire("cb1pF");

var $uhMTw = parcelRequire("uhMTw");
const $b1c9aeef70035656$var$useFieldV7TextField = (parameters)=>{
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $BKARN.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, $8wNUU.useFieldInternalPropsWithDefaults)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable } = forwardedProps;
    const { disabled: disabled = false, readOnly: readOnly = false, autoFocus: autoFocus = false, focused: focusedProp, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const sectionListRef = $b1c9aeef70035656$var$React.useRef(null);
    const handleSectionListRef = (0, $b1c9aeef70035656$var$_useForkRef.default)(sectionListRefProp, sectionListRef);
    const domGetters = $b1c9aeef70035656$var$React.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, $b1YwV.useFieldState)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, error: error, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, setSelectedSections: setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, $LYmdu.useFieldCharacterEditing)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = $b1c9aeef70035656$var$React.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        $b1c9aeef70035656$var$getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, $l9aHF.parseSelectedSections)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, $e0rC1.useFieldRootProps)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        focused: focused,
        setFocused: setFocused,
        domGetters: domGetters
    });
    const hiddenInputProps = (0, $13xsf.useFieldHiddenInputProps)({
        manager: manager,
        stateResponse: stateResponse
    });
    const createSectionContainerProps = (0, $cb1pF.useFieldSectionContainerProps)({
        stateResponse: stateResponse,
        internalPropsWithDefaults: internalPropsWithDefaults
    });
    const createSectionContentProps = (0, $uhMTw.useFieldSectionContentProps)({
        manager: manager,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        internalPropsWithDefaults: internalPropsWithDefaults,
        domGetters: domGetters,
        focused: focused
    });
    const handleRootKeyDown = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onKeyDown?.(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onBlur?.(event);
        rootProps.onBlur(event);
    });
    const handleRootFocus = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onFocus?.(event);
        rootProps.onFocus(event);
    });
    const handleRootClick = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick?.(event);
        rootProps.onClick(event);
    });
    const handleRootPaste = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onPaste?.(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event)=>{
        onInput?.(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, $b1c9aeef70035656$var$_useEventCallback.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$b1c9aeef70035656$var$isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = $b1c9aeef70035656$var$React.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: createSectionContentProps(section, sectionIndex),
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    $b1c9aeef70035656$var$React.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:',
            '',
            '<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && !disabled && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $b1c9aeef70035656$var$_useEnhancedEffect.default)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, $b1c9aeef70035656$var$_useEnhancedEffect.default)(()=>{
        (0, $aUKcB.syncSelectionToDOM)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    $b1c9aeef70035656$var$React.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>$b1c9aeef70035656$var$getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, $l9aHF.parseSelectedSections)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField: focusField,
            isFieldFocused: ()=>$b1c9aeef70035656$var$isFieldFocused(sectionListRef)
        }));
    return (0, $b1c9aeef70035656$var$_extends2.default)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp ?? focused,
        sectionListRef: handleSectionListRef,
        // Additional
        enableAccessibleFieldDOMStructure: true,
        elements: elements,
        areAllSectionsEmpty: areAllSectionsEmpty,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
module.exports.useFieldV7TextField = $b1c9aeef70035656$var$useFieldV7TextField;
function $b1c9aeef70035656$var$getActiveSectionIndex(sectionListRef) {
    const activeElement = (0, $l16rr.getActiveElement)(sectionListRef.current?.getRoot());
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function $b1c9aeef70035656$var$isFieldFocused(sectionListRef) {
    const activeElement = (0, $l16rr.getActiveElement)(sectionListRef.current?.getRoot());
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}

});
parcelRegister("l16rr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f4ceb023c3ba7bf1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_DESKTOP_MODE_MEDIA_QUERY = void 0;
module.exports.arrayIncludes = $f4ceb023c3ba7bf1$var$arrayIncludes;
module.exports.getFocusedListItemIndex = module.exports.getActiveElement = module.exports.executeInTheNextEventLoopTick = void 0;
module.exports.mergeSx = $f4ceb023c3ba7bf1$var$mergeSx;
module.exports.onSpaceOrEnter = void 0;

var $f4ceb023c3ba7bf1$var$_ownerDocument = $f4ceb023c3ba7bf1$require$_interopRequireDefault((parcelRequire("43fuO")));
/* Use it instead of .includes method for IE support */ function $f4ceb023c3ba7bf1$var$arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $f4ceb023c3ba7bf1$var$onSpaceOrEnter = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
module.exports.onSpaceOrEnter = $f4ceb023c3ba7bf1$var$onSpaceOrEnter;
const $f4ceb023c3ba7bf1$var$executeInTheNextEventLoopTick = (fn)=>{
    setTimeout(fn, 0);
};
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
module.exports.executeInTheNextEventLoopTick = $f4ceb023c3ba7bf1$var$executeInTheNextEventLoopTick;
const $f4ceb023c3ba7bf1$var$getActiveElementInternal = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $f4ceb023c3ba7bf1$var$getActiveElementInternal(activeEl.shadowRoot);
    return activeEl;
};
/**
 * Gets the currently active element within a given node's document.
 * This function traverses shadow DOM if necessary.
 * @param node - The node from which to get the active element.
 * @returns The currently active element, or null if none is found.
 */ const $f4ceb023c3ba7bf1$var$getActiveElement = (node)=>{
    return $f4ceb023c3ba7bf1$var$getActiveElementInternal((0, $f4ceb023c3ba7bf1$var$_ownerDocument.default)(node));
};
/**
 * Gets the index of the focused list item in a given ul list element.
 *
 * @param {HTMLUListElement} listElement - The list element to search within.
 * @returns {number} The index of the focused list item, or -1 if none is focused.
 */ module.exports.getActiveElement = $f4ceb023c3ba7bf1$var$getActiveElement;
const $f4ceb023c3ba7bf1$var$getFocusedListItemIndex = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($f4ceb023c3ba7bf1$var$getActiveElement(listElement));
};
module.exports.getFocusedListItemIndex = $f4ceb023c3ba7bf1$var$getFocusedListItemIndex;
const $f4ceb023c3ba7bf1$var$DEFAULT_DESKTOP_MODE_MEDIA_QUERY = module.exports.DEFAULT_DESKTOP_MODE_MEDIA_QUERY = '@media (pointer: fine)';
function $f4ceb023c3ba7bf1$var$mergeSx(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}

});

parcelRegister("BKARN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useIsValidValue", {
    enumerable: true,
    get: function() {
        return $eg515.useIsValidValue;
    }
});
Object.defineProperty(module.exports, "useParsedFormat", {
    enumerable: true,
    get: function() {
        return $hszez.useParsedFormat;
    }
});
Object.defineProperty(module.exports, "usePickerActionsContext", {
    enumerable: true,
    get: function() {
        return $20yLR.usePickerActionsContext;
    }
});
Object.defineProperty(module.exports, "usePickerAdapter", {
    enumerable: true,
    get: function() {
        return $3nE24.usePickerAdapter;
    }
});
Object.defineProperty(module.exports, "usePickerContext", {
    enumerable: true,
    get: function() {
        return $6DVo4.usePickerContext;
    }
});
Object.defineProperty(module.exports, "usePickerTranslations", {
    enumerable: true,
    get: function() {
        return $83GPg.usePickerTranslations;
    }
});
Object.defineProperty(module.exports, "useSplitFieldProps", {
    enumerable: true,
    get: function() {
        return $5pN9w.useSplitFieldProps;
    }
});

var $83GPg = parcelRequire("83GPg");

var $5pN9w = parcelRequire("5pN9w");

var $hszez = parcelRequire("hszez");

var $6DVo4 = parcelRequire("6DVo4");

var $20yLR = parcelRequire("20yLR");

var $eg515 = parcelRequire("eg515");

var $3nE24 = parcelRequire("3nE24");

});
parcelRegister("83GPg", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerTranslations = void 0;

var $3nE24 = parcelRequire("3nE24");
const $5ddfd2dd7a45f0f3$var$usePickerTranslations = ()=>(0, $3nE24.useLocalizationContext)().localeText;
module.exports.usePickerTranslations = $5ddfd2dd7a45f0f3$var$usePickerTranslations;

});
parcelRegister("3nE24", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $276292a7c4ad1718$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $276292a7c4ad1718$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerAdapter = module.exports.useLocalizationContext = void 0;

var $276292a7c4ad1718$var$_extends2 = $276292a7c4ad1718$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $276292a7c4ad1718$var$React = $276292a7c4ad1718$require$_interopRequireWildcard((parcelRequire("acw62")));

var $eXXn3 = parcelRequire("eXXn3");

var $luD6R = parcelRequire("luD6R");
const $276292a7c4ad1718$var$useLocalizationContext = ()=>{
    const localization = $276292a7c4ad1718$var$React.useContext($luD6R.PickerAdapterContext);
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.adapter === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $276292a7c4ad1718$var$React.useMemo(()=>(0, $276292a7c4ad1718$var$_extends2.default)({}, $eXXn3.DEFAULT_LOCALE, localization.localeText), [
        localization.localeText
    ]);
    return $276292a7c4ad1718$var$React.useMemo(()=>(0, $276292a7c4ad1718$var$_extends2.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
module.exports.useLocalizationContext = $276292a7c4ad1718$var$useLocalizationContext;
const $276292a7c4ad1718$var$usePickerAdapter = ()=>$276292a7c4ad1718$var$useLocalizationContext().adapter;
module.exports.usePickerAdapter = $276292a7c4ad1718$var$usePickerAdapter;

});
parcelRegister("eXXn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.enUS = module.exports.DEFAULT_LOCALE = void 0;

var $gwyDC = parcelRequire("gwyDC");
// This object is not Partial<PickersLocaleText> because it is the default values
const $ae54a135ca8b48bd$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $ae54a135ca8b48bd$var$DEFAULT_LOCALE = module.exports.DEFAULT_LOCALE = $ae54a135ca8b48bd$var$enUSPickers;
const $ae54a135ca8b48bd$var$enUS = module.exports.enUS = (0, $gwyDC.getPickersLocalization)($ae54a135ca8b48bd$var$enUSPickers);

});
parcelRegister("gwyDC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c07a80e9c07fbe5a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersLocalization = void 0;

var $c07a80e9c07fbe5a$var$_extends2 = $c07a80e9c07fbe5a$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $c07a80e9c07fbe5a$var$getPickersLocalization = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $c07a80e9c07fbe5a$var$_extends2.default)({}, pickersTranslations)
                }
            }
        }
    };
};
module.exports.getPickersLocalization = $c07a80e9c07fbe5a$var$getPickersLocalization;

});


parcelRegister("luD6R", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fa5abcb204c6ca4b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fa5abcb204c6ca4b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerAdapterContext = module.exports.MuiPickersAdapterContext = module.exports.LocalizationProvider = void 0;

var $fa5abcb204c6ca4b$var$_extends2 = $fa5abcb204c6ca4b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fa5abcb204c6ca4b$var$_objectWithoutPropertiesLoose2 = $fa5abcb204c6ca4b$require$_interopRequireDefault((parcelRequire("c05no")));

var $fa5abcb204c6ca4b$var$React = $fa5abcb204c6ca4b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fa5abcb204c6ca4b$var$_propTypes = $fa5abcb204c6ca4b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $ayMG0 = parcelRequire("ayMG0");
const $fa5abcb204c6ca4b$var$_excluded = [
    "localeText"
];
const $fa5abcb204c6ca4b$var$PickerAdapterContext = module.exports.PickerAdapterContext = /*#__PURE__*/ $fa5abcb204c6ca4b$var$React.createContext(null);
const $fa5abcb204c6ca4b$var$MuiPickersAdapterContext = module.exports.MuiPickersAdapterContext = $fa5abcb204c6ca4b$var$PickerAdapterContext;
/**
 * Demos:
 *
 * - [Date format and localization](https://mui.com/x/react-date-pickers/adapters-locale/)
 * - [Calendar systems](https://mui.com/x/react-date-pickers/calendar-systems/)
 * - [Translated components](https://mui.com/x/react-date-pickers/localization/)
 * - [UTC and timezones](https://mui.com/x/react-date-pickers/timezone/)
 *
 * API:
 *
 * - [LocalizationProvider API](https://mui.com/x/api/date-pickers/localization-provider/)
 */ const $fa5abcb204c6ca4b$var$LocalizationProvider = module.exports.LocalizationProvider = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $fa5abcb204c6ca4b$var$_objectWithoutPropertiesLoose2.default)(inProps, $fa5abcb204c6ca4b$var$_excluded);
    const { adapter: parentAdapter, localeText: parentLocaleText } = $fa5abcb204c6ca4b$var$React.useContext($fa5abcb204c6ca4b$var$PickerAdapterContext) ?? {
        utils: undefined,
        adapter: undefined,
        localeText: undefined
    };
    const props = (0, $8xDHs.useThemeProps)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $fa5abcb204c6ca4b$var$React.useMemo(()=>(0, $fa5abcb204c6ca4b$var$_extends2.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const adapter = $fa5abcb204c6ca4b$var$React.useMemo(()=>{
        if (!DateAdapter) {
            if (parentAdapter) return parentAdapter;
            return null;
        }
        const dateAdapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!dateAdapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation'
        ].join(`\n`));
        return dateAdapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentAdapter
    ]);
    const defaultDates = $fa5abcb204c6ca4b$var$React.useMemo(()=>{
        if (!adapter) return null;
        return {
            minDate: adapter.date('1900-01-01T00:00:00.000'),
            maxDate: adapter.date('2099-12-31T00:00:00.000')
        };
    }, [
        adapter
    ]);
    const contextValue = $fa5abcb204c6ca4b$var$React.useMemo(()=>{
        return {
            utils: adapter,
            adapter: adapter,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        adapter,
        localeText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fa5abcb204c6ca4b$var$PickerAdapterContext.Provider, {
        value: contextValue,
        children: children
    });
};

});



parcelRegister("5pN9w", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3f156a3b21b74a46$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3f156a3b21b74a46$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSplitFieldProps = void 0;

var $3f156a3b21b74a46$var$_extends2 = $3f156a3b21b74a46$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3f156a3b21b74a46$var$React = $3f156a3b21b74a46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6vW2j = parcelRequire("6vW2j");
const $3f156a3b21b74a46$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'unstableStartFieldRef',
    'unstableEndFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
/**
 * Split the props received by the field component into:
 * - `internalProps` which are used by the various hooks called by the field component.
 * - `forwardedProps` which are passed to the underlying component.
 * Note that some forwarded props might be used by the hooks as well.
 * For instance, hooks like `useDateField` need props like `onKeyDown` to merge the default event handler and the one provided by the application.
 * @template TProps, TValueType
 * @param {TProps} props The props received by the field component.
 * @param {TValueType} valueType The type of the field value ('date', 'time', or 'date-time').
 */ const $3f156a3b21b74a46$var$useSplitFieldProps = (props, valueType)=>{
    return $3f156a3b21b74a46$var$React.useMemo(()=>{
        const forwardedProps = (0, $3f156a3b21b74a46$var$_extends2.default)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $3f156a3b21b74a46$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') $6vW2j.DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
        else if (valueType === 'time') $6vW2j.TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        else if (valueType === 'date-time') {
            $6vW2j.DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
            $6vW2j.TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
            $6vW2j.DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
};
/**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ module.exports.useSplitFieldProps = $3f156a3b21b74a46$var$useSplitFieldProps;

});
parcelRegister("6vW2j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractValidationProps = module.exports.TIME_VALIDATION_PROP_NAMES = module.exports.DATE_VALIDATION_PROP_NAMES = module.exports.DATE_TIME_VALIDATION_PROP_NAMES = void 0;
const $4be2a81b5d2111e4$var$DATE_VALIDATION_PROP_NAMES = module.exports.DATE_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $4be2a81b5d2111e4$var$TIME_VALIDATION_PROP_NAMES = module.exports.TIME_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $4be2a81b5d2111e4$var$DATE_TIME_VALIDATION_PROP_NAMES = module.exports.DATE_TIME_VALIDATION_PROP_NAMES = [
    'minDateTime',
    'maxDateTime'
];
const $4be2a81b5d2111e4$var$VALIDATION_PROP_NAMES = [
    ...$4be2a81b5d2111e4$var$DATE_VALIDATION_PROP_NAMES,
    ...$4be2a81b5d2111e4$var$TIME_VALIDATION_PROP_NAMES,
    ...$4be2a81b5d2111e4$var$DATE_TIME_VALIDATION_PROP_NAMES
];
/**
 * Extract the validation props for the props received by a component.
 * Limit the risk of forgetting some of them and reduce the bundle size.
 */ const $4be2a81b5d2111e4$var$extractValidationProps = (props)=>$4be2a81b5d2111e4$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});
module.exports.extractValidationProps = $4be2a81b5d2111e4$var$extractValidationProps;

});


parcelRegister("hszez", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $cb6061e890b8c017$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useParsedFormat = void 0;

var $cb6061e890b8c017$var$React = $cb6061e890b8c017$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $3nE24 = parcelRequire("3nE24");

var $iq4Gd = parcelRequire("iq4Gd");

var $l9aHF = parcelRequire("l9aHF");

var $83GPg = parcelRequire("83GPg");

var $yCVZs = parcelRequire("yCVZs");
/**
 * Returns the parsed format to be rendered in the field when there is no value or in other parts of the Picker.
 * This format is localized (for example `AAAA` for the year with the French locale) and cannot be parsed by your date library.
 * @param {object} The parameters needed to build the placeholder.
 * @param {string} params.format Format to parse.
 * @returns
 */ const $cb6061e890b8c017$var$useParsedFormat = (parameters = {})=>{
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const isRtl = (0, $9uEev.useRtl)();
    const translations = (0, $83GPg.usePickerTranslations)();
    const localizedDigits = $cb6061e890b8c017$var$React.useMemo(()=>(0, $l9aHF.getLocalizedDigits)(adapter), [
        adapter
    ]);
    const { format: format = pickerContext?.fieldFormat ?? adapter.formats.fullDate } = parameters;
    return $cb6061e890b8c017$var$React.useMemo(()=>{
        const sections = (0, $iq4Gd.buildSectionsFromFormat)({
            adapter: adapter,
            format: format,
            formatDensity: 'dense',
            isRtl: isRtl,
            shouldRespectLeadingZeros: true,
            localeText: translations,
            localizedDigits: localizedDigits,
            date: null,
            // TODO v9: Make sure we still don't reverse in `buildSectionsFromFormat` when using `useParsedFormat`.
            enableAccessibleFieldDOMStructure: false
        });
        return sections.map((section)=>`${section.startSeparator}${section.placeholder}${section.endSeparator}`).join('');
    }, [
        adapter,
        isRtl,
        translations,
        localizedDigits,
        format
    ]);
};
module.exports.useParsedFormat = $cb6061e890b8c017$var$useParsedFormat;

});
parcelRegister("iq4Gd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d68e490b4aa36330$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildSectionsFromFormat = void 0;

var $d68e490b4aa36330$var$_extends2 = $d68e490b4aa36330$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $l9aHF = parcelRequire("l9aHF");
const $d68e490b4aa36330$var$expandFormat = ({ adapter: adapter, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = adapter.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = adapter.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.');
    }
    return nextFormat;
};
const $d68e490b4aa36330$var$getEscapedPartsFromFormat = ({ adapter: adapter, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = adapter.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $d68e490b4aa36330$var$getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: adapter.formatByString(adapter.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $d68e490b4aa36330$var$createSection = ({ adapter: adapter, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, $l9aHF.getDateSectionConfigFromFormatToken)(adapter, token);
    const hasLeadingZerosInFormat = (0, $l9aHF.doesSectionFormatHaveLeadingZeros)(adapter, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = adapter.isValid(date);
    let sectionValue = isValidDate ? adapter.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? adapter.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxLength' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $l9aHF.applyLocalizedDigits)((0, $l9aHF.cleanLeadingZeros)((0, $l9aHF.removeLocalizedDigits)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $d68e490b4aa36330$var$_extends2.default)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $d68e490b4aa36330$var$getSectionPlaceholder(adapter, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $d68e490b4aa36330$var$buildSections = (parameters)=>{
    const { adapter: adapter, expandedFormat: expandedFormat, escapedParts: escapedParts } = parameters;
    const now = adapter.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($d68e490b4aa36330$var$createSection((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $d68e490b4aa36330$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $d68e490b4aa36330$var$buildSectionsFromFormat = (parameters)=>{
    let expandedFormat = $d68e490b4aa36330$var$expandFormat(parameters);
    if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $d68e490b4aa36330$var$getEscapedPartsFromFormat((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
        expandedFormat: expandedFormat
    }));
    const sections = $d68e490b4aa36330$var$buildSections((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $d68e490b4aa36330$var$postProcessSections((0, $d68e490b4aa36330$var$_extends2.default)({}, parameters, {
        sections: sections
    }));
};
module.exports.buildSectionsFromFormat = $d68e490b4aa36330$var$buildSectionsFromFormat;

});

parcelRegister("yCVZs", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $068160a30ef67ebd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useNullablePickerContext = void 0;

var $068160a30ef67ebd$var$React = $068160a30ef67ebd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6DVo4 = parcelRequire("6DVo4");
/**
 * Returns the context passed by the Picker wrapping the current component.
 * If the context is not found, returns `null`.
 */ const $068160a30ef67ebd$var$useNullablePickerContext = ()=>$068160a30ef67ebd$var$React.useContext($6DVo4.PickerContext);
module.exports.useNullablePickerContext = $068160a30ef67ebd$var$useNullablePickerContext;

});
parcelRegister("6DVo4", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4d62e685733303de$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerContext = module.exports.PickerContext = void 0;

var $4d62e685733303de$var$React = $4d62e685733303de$require$_interopRequireWildcard((parcelRequire("acw62")));
const $4d62e685733303de$var$PickerContext = module.exports.PickerContext = /*#__PURE__*/ $4d62e685733303de$var$React.createContext(null);
const $4d62e685733303de$var$usePickerContext = ()=>{
    const value = $4d62e685733303de$var$React.useContext($4d62e685733303de$var$PickerContext);
    if (value == null) throw new Error('MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component');
    return value;
};
module.exports.usePickerContext = $4d62e685733303de$var$usePickerContext;

});



parcelRegister("20yLR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $17668da305eabda2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerActionsContext = void 0;

var $17668da305eabda2$var$React = $17668da305eabda2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jk6Bf = parcelRequire("jk6Bf");
/**
 * Returns a subset of the context passed by the Picker wrapping the current component.
 * It only contains the actions and never causes a re-render of the component using it.
 */ const $17668da305eabda2$var$usePickerActionsContext = ()=>{
    const value = $17668da305eabda2$var$React.useContext($jk6Bf.PickerActionsContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component'
    ].join('\n'));
    return value;
};
module.exports.usePickerActionsContext = $17668da305eabda2$var$usePickerActionsContext;

});
parcelRegister("jk6Bf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e1150121cdd65ad2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerPrivateContext = module.exports.PickerActionsContext = void 0;
module.exports.PickerProvider = $e1150121cdd65ad2$var$PickerProvider;

var $e1150121cdd65ad2$var$React = $e1150121cdd65ad2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $uaXRK = parcelRequire("uaXRK");

var $eg515 = parcelRequire("eg515");

var $6zwRZ = parcelRequire("6zwRZ");

var $6DVo4 = parcelRequire("6DVo4");

var $ayMG0 = parcelRequire("ayMG0");
const $e1150121cdd65ad2$var$PickerActionsContext = module.exports.PickerActionsContext = /*#__PURE__*/ $e1150121cdd65ad2$var$React.createContext(null);
const $e1150121cdd65ad2$var$PickerPrivateContext = module.exports.PickerPrivateContext = /*#__PURE__*/ $e1150121cdd65ad2$var$React.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function $e1150121cdd65ad2$var$PickerProvider(props) {
    const { contextValue: contextValue, actionsContextValue: actionsContextValue, privateContextValue: privateContextValue, fieldPrivateContextValue: fieldPrivateContextValue, isValidContextValue: isValidContextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6DVo4.PickerContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e1150121cdd65ad2$var$PickerActionsContext.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($e1150121cdd65ad2$var$PickerPrivateContext.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6zwRZ.PickerFieldPrivateContext.Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($eg515.IsValidValueContext.Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($uaXRK.LocalizationProvider, {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("uaXRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "LocalizationProvider", {
    enumerable: true,
    get: function() {
        return $luD6R.LocalizationProvider;
    }
});
Object.defineProperty(module.exports, "MuiPickersAdapterContext", {
    enumerable: true,
    get: function() {
        return $luD6R.MuiPickersAdapterContext;
    }
});

var $luD6R = parcelRequire("luD6R");

});

parcelRegister("eg515", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a6167378c591e0ae$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsValidValueContext = void 0;
module.exports.useIsValidValue = $a6167378c591e0ae$var$useIsValidValue;

var $a6167378c591e0ae$var$React = $a6167378c591e0ae$require$_interopRequireWildcard((parcelRequire("acw62")));
const $a6167378c591e0ae$var$IsValidValueContext = module.exports.IsValidValueContext = /*#__PURE__*/ $a6167378c591e0ae$var$React.createContext(()=>true);
function $a6167378c591e0ae$var$useIsValidValue() {
    return $a6167378c591e0ae$var$React.useContext($a6167378c591e0ae$var$IsValidValueContext);
}

});

parcelRegister("6zwRZ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4c8f82354f487b58$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerFieldPrivateContext = void 0;
module.exports.useNullableFieldPrivateContext = $4c8f82354f487b58$var$useNullableFieldPrivateContext;

var $4c8f82354f487b58$var$React = $4c8f82354f487b58$require$_interopRequireWildcard((parcelRequire("acw62")));
const $4c8f82354f487b58$var$PickerFieldPrivateContext = module.exports.PickerFieldPrivateContext = /*#__PURE__*/ $4c8f82354f487b58$var$React.createContext(null);
function $4c8f82354f487b58$var$useNullableFieldPrivateContext() {
    return $4c8f82354f487b58$var$React.useContext($4c8f82354f487b58$var$PickerFieldPrivateContext);
}

});




parcelRegister("LYmdu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0903359c0c4ccba9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldCharacterEditing = void 0;

var $0903359c0c4ccba9$var$_extends2 = $0903359c0c4ccba9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0903359c0c4ccba9$var$_useEventCallback = $0903359c0c4ccba9$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $l9aHF = parcelRequire("l9aHF");

var $3nE24 = parcelRequire("3nE24");
const $0903359c0c4ccba9$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
/**
 * Update the active section value when the user pressed a key that is not a navigation key (arrow key for example).
 * This hook has two main editing behaviors
 *
 * 1. The numeric editing when the user presses a digit
 * 2. The letter editing when the user presses another key
 */ const $0903359c0c4ccba9$var$useFieldCharacterEditing = ({ stateResponse: { localizedDigits: // States and derived states
localizedDigits, sectionsValueBoundaries: sectionsValueBoundaries, state: state, timezone: timezone, setCharacterQuery: // Methods to update the states
setCharacterQuery, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue } })=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $l9aHF.getLetterEditingOptions)(adapter, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $l9aHF.getDateSectionConfigFromFormatToken)(adapter, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $0903359c0c4ccba9$var$_extends2.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $l9aHF.changeSectionValueFormat)(adapter, fallbackValue, adapter.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue: queryValue, skipIfBelowMinimum: skipIfBelowMinimum, section: section })=>{
            const cleanQueryValue = (0, $l9aHF.removeLocalizedDigits)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $l9aHF.cleanDigitSectionValue)(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue: queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $l9aHF.doesSectionFormatHaveLeadingZeros)(adapter, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $l9aHF.changeSectionValueFormat)(adapter, response.sectionValue, 'MM', activeSection.format);
                return (0, $0903359c0c4ccba9$var$_extends2.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $l9aHF.getDaysInWeekStr)(adapter, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $0903359c0c4ccba9$var$_extends2.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $l9aHF.isStringNumber)(queryValue, localizedDigits));
    };
    return (0, $0903359c0c4ccba9$var$_useEventCallback.default)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, $l9aHF.isStringNumber)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $0903359c0c4ccba9$var$_extends2.default)({}, params, {
            keyPressed: (0, $l9aHF.applyLocalizedDigits)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section: section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
};
/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ module.exports.useFieldCharacterEditing = $0903359c0c4ccba9$var$useFieldCharacterEditing;

});

parcelRegister("b1YwV", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $807ebdbb6685e382$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $807ebdbb6685e382$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldState = void 0;

var $807ebdbb6685e382$var$_extends2 = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $807ebdbb6685e382$var$React = $807ebdbb6685e382$require$_interopRequireWildcard((parcelRequire("acw62")));

var $807ebdbb6685e382$var$_useControlled = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $807ebdbb6685e382$var$_useTimeout = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("drY8V")));

var $807ebdbb6685e382$var$_useEventCallback = $807ebdbb6685e382$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $9uEev = parcelRequire("9uEev");

var $BKARN = parcelRequire("BKARN");

var $l9aHF = parcelRequire("l9aHF");

var $iq4Gd = parcelRequire("iq4Gd");

var $5UoGz = parcelRequire("5UoGz");

var $hagTn = parcelRequire("hagTn");

var $gUrai = parcelRequire("gUrai");
const $807ebdbb6685e382$var$QUERY_LIFE_DURATION_MS = 5000;
const $807ebdbb6685e382$var$useFieldState = (parameters)=>{
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const isRtl = (0, $9uEev.useRtl)();
    const { manager: { validator: validator, valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true }, forwardedProps: { error: errorProp } } = parameters;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const valueRef = $807ebdbb6685e382$var$React.useRef(value);
    $807ebdbb6685e382$var$React.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError: hasValidationError } = (0, $5UoGz.useValidation)({
        props: internalPropsWithDefaults,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: internalPropsWithDefaults.onError
    });
    const localizedDigits = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.getLocalizedDigits)(adapter), [
        adapter
    ]);
    const sectionsValueBoundaries = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.getSectionsBoundaries)(adapter, localizedDigits, timezone), [
        adapter,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $807ebdbb6685e382$var$React.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, $iq4Gd.buildSectionsFromFormat)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        adapter,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $807ebdbb6685e382$var$React.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, $l9aHF.validateSections)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format: format,
                isRtl: isRtl,
                locale: adapter.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, $gUrai.getSectionTypeGranularity)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: value,
            adapter: adapter,
            props: internalPropsWithDefaults,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $807ebdbb6685e382$var$_extends2.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $807ebdbb6685e382$var$_useControlled.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.parseSelectedSections)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = $807ebdbb6685e382$var$React.useMemo(()=>(0, $l9aHF.getSectionOrder)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const areAllSectionsEmpty = $807ebdbb6685e382$var$React.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    // When the field loses focus (no active section), consider partially filled sections as invalid.
    // This enforces that the field must be entirely filled or entirely empty on blur.
    const hasPartiallyFilledSectionsOnBlur = $807ebdbb6685e382$var$React.useMemo(()=>{
        if (activeSectionIndex != null) return false;
        const filledSections = state.sections.filter((s)=>s.value !== '');
        return filledSections.length > 0 && state.sections.length - filledSections.length > 0;
    }, [
        state.sections,
        activeSectionIndex
    ]);
    const error = $807ebdbb6685e382$var$React.useMemo(()=>{
        if (errorProp !== undefined) return errorProp;
        return hasValidationError || hasPartiallyFilledSectionsOnBlur;
    }, [
        hasValidationError,
        hasPartiallyFilledSectionsOnBlur,
        errorProp
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter: adapter,
                value: newValue,
                timezone: timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $807ebdbb6685e382$var$_extends2.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = $807ebdbb6685e382$var$React.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, $807ebdbb6685e382$var$_useTimeout.default)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = adapter.parse(dateStr, format);
            if (!adapter.isValid(date)) return null;
            const sections = (0, $iq4Gd.buildSectionsFromFormat)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $l9aHF.mergeDateIntoReferenceDate)(adapter, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, $807ebdbb6685e382$var$_useTimeout.default)();
    const updateSectionValue = ({ section: section, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, $l9aHF.getDateFromDateSections)(adapter, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (adapter.isValid(newActiveDate)) {
            const mergedDate = (0, $l9aHF.mergeDateIntoReferenceDate)(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || adapter.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `newActiveDate to prevent error state oscillation`.
     * @link: https://github.com/mui/mui-x/issues/17967
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    const setCharacterQuery = (0, $807ebdbb6685e382$var$_useEventCallback.default)((newCharacterQuery)=>{
        setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        const isActiveDateInvalid = sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]));
        let sections;
        if (isActiveDateInvalid) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                lastExternalValue: value,
                sections: sections,
                sectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                referenceValue: isActiveDateInvalid ? prevState.referenceValue : fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, $l9aHF.validateSections)(sections, valueType);
        setState((prevState)=>(0, $807ebdbb6685e382$var$_extends2.default)({}, prevState, {
                lastSectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                sections: sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) setCharacterQuery(null);
    $807ebdbb6685e382$var$React.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, $807ebdbb6685e382$var$_useTimeout.default)();
    $807ebdbb6685e382$var$React.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start($807ebdbb6685e382$var$QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $807ebdbb6685e382$var$React.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        activeSectionIndex: // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty: areAllSectionsEmpty,
        error: error,
        localizedDigits: localizedDigits,
        parsedSelectedSections: parsedSelectedSections,
        sectionOrder: sectionOrder,
        sectionsValueBoundaries: sectionsValueBoundaries,
        state: state,
        timezone: timezone,
        value: value,
        clearValue: // Methods to update the states
        clearValue,
        clearActiveSection: clearActiveSection,
        setCharacterQuery: setCharacterQuery,
        setSelectedSections: setSelectedSections,
        setTempAndroidValueStr: setTempAndroidValueStr,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        getSectionsFromValue: // Utilities methods
        getSectionsFromValue
    };
};
module.exports.useFieldState = $807ebdbb6685e382$var$useFieldState;

});
parcelRegister("5UoGz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "extractValidationProps", {
    enumerable: true,
    get: function() {
        return $6vW2j.extractValidationProps;
    }
});
Object.defineProperty(module.exports, "useValidation", {
    enumerable: true,
    get: function() {
        return $9frIG.useValidation;
    }
});
Object.defineProperty(module.exports, "validateDate", {
    enumerable: true,
    get: function() {
        return $clUaJ.validateDate;
    }
});
Object.defineProperty(module.exports, "validateDateTime", {
    enumerable: true,
    get: function() {
        return $32d8x.validateDateTime;
    }
});
Object.defineProperty(module.exports, "validateTime", {
    enumerable: true,
    get: function() {
        return $9l9jb.validateTime;
    }
});

var $clUaJ = parcelRequire("clUaJ");

var $9l9jb = parcelRequire("9l9jb");

var $32d8x = parcelRequire("32d8x");

var $6vW2j = parcelRequire("6vW2j");

var $9frIG = parcelRequire("9frIG");

});
parcelRegister("clUaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDate = void 0;

var $1M3bL = parcelRequire("1M3bL");
/**
 * Validation props used by the Date Picker, Date Field and Date Calendar components.
 */ /**
 * Validation props as received by the validateDate method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateDate method.
 */ const $8fe304ca4ba155e2$var$validateDate = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate } = props;
    const now = adapter.date(undefined, timezone);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
module.exports.validateDate = $8fe304ca4ba155e2$var$validateDate;
$8fe304ca4ba155e2$var$validateDate.valueManager = $1M3bL.singleItemValueManager;

});

parcelRegister("9l9jb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTime = void 0;

var $cElCc = parcelRequire("cElCc");

var $1M3bL = parcelRequire("1M3bL");
/**
 * Validation props used by the Time Picker, Time Field and Clock components.
 */ /**
 * Validation props as received by the validateTime method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateTime method.
 */ const $6ccd4ba717e38ef2$var$validateTime = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.date(undefined, timezone);
    const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
module.exports.validateTime = $6ccd4ba717e38ef2$var$validateTime;
$6ccd4ba717e38ef2$var$validateTime.valueManager = $1M3bL.singleItemValueManager;

});

parcelRegister("32d8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateDateTime = void 0;

var $clUaJ = parcelRequire("clUaJ");

var $9l9jb = parcelRequire("9l9jb");

var $1M3bL = parcelRequire("1M3bL");
/**
 * Validation props used by the Date Time Picker and Date Time Field components.
 */ /**
 * Validation props as received by the validateDateTime method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateDateTime method.
 */ const $235bbfad3f014fc4$var$validateDateTime = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const dateValidationResult = (0, $clUaJ.validateDate)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $9l9jb.validateTime)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
};
module.exports.validateDateTime = $235bbfad3f014fc4$var$validateDateTime;
$235bbfad3f014fc4$var$validateDateTime.valueManager = $1M3bL.singleItemValueManager;

});

parcelRegister("9frIG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $01bcd2a693711309$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $01bcd2a693711309$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useValidation = $01bcd2a693711309$var$useValidation;

var $01bcd2a693711309$var$React = $01bcd2a693711309$require$_interopRequireWildcard((parcelRequire("acw62")));

var $01bcd2a693711309$var$_useEventCallback = $01bcd2a693711309$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $BKARN = parcelRequire("BKARN");
/**
 * Utility hook to check if a given value is valid based on the provided validation props.
 * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
 * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
 * @param {UseValidationOptions<TValue, TError, TValidationProps>} options The options to configure the hook.
 * @param {TValue} options.value The value to validate.
 * @param {PickersTimezone} options.timezone The timezone to use for the validation.
 * @param {Validator<TValue, TError, TValidationProps>} options.validator The validator function to use.
 * @param {TValidationProps} options.props The validation props, they differ depending on the component.
 * @param {(error: TError, value: TValue) => void} options.onError Callback fired when the error associated with the current value changes.
 */ function $01bcd2a693711309$var$useValidation(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $BKARN.usePickerAdapter)();
    const previousValidationErrorRef = $01bcd2a693711309$var$React.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $01bcd2a693711309$var$React.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $01bcd2a693711309$var$_useEventCallback.default)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}

});


parcelRegister("hagTn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c7f0794a849d6845$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c7f0794a849d6845$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useControlledValue = void 0;

var $c7f0794a849d6845$var$React = $c7f0794a849d6845$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c7f0794a849d6845$var$_useEventCallback = $c7f0794a849d6845$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $c7f0794a849d6845$var$_useControlled = $c7f0794a849d6845$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $3nE24 = parcelRequire("3nE24");
/**
 * Hooks controlling the value while making sure that:
 * - The value returned by `onChange` always have the timezone of `props.value` or `props.defaultValue` if defined
 * - The value rendered is always the one from `props.timezone` if defined
 */ const $c7f0794a849d6845$var$useControlledValue = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    const [valueWithInputTimezone, setValue] = (0, $c7f0794a849d6845$var$_useControlled.default)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const inputTimezone = $c7f0794a849d6845$var$React.useMemo(()=>valueManager.getTimezone(adapter, valueWithInputTimezone), [
        adapter,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, $c7f0794a849d6845$var$_useEventCallback.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(adapter, inputTimezone, newValue);
    });
    const timezoneToRender = $c7f0794a849d6845$var$React.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        adapter
    ]);
    const valueWithTimezoneToRender = $c7f0794a849d6845$var$React.useMemo(()=>valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        adapter,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, $c7f0794a849d6845$var$_useEventCallback.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
module.exports.useControlledValue = $c7f0794a849d6845$var$useControlledValue;

});


parcelRegister("8wNUU", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6358085614f491c6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6358085614f491c6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldInternalPropsWithDefaults = $6358085614f491c6$var$useFieldInternalPropsWithDefaults;

var $6358085614f491c6$var$_extends2 = $6358085614f491c6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6358085614f491c6$var$React = $6358085614f491c6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6358085614f491c6$var$_useForkRef = $6358085614f491c6$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $yCVZs = parcelRequire("yCVZs");

var $6zwRZ = parcelRequire("6zwRZ");
/**
 * Applies the default values to the field internal props.
 * This is a temporary hook that will be removed during a follow up when `useField` will receive the internal props without the defaults.
 * It is only here to allow the migration to be done in smaller steps.
 */ function $6358085614f491c6$var$useFieldInternalPropsWithDefaults(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps: internalProps, skipContextFieldRefAssignment: skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const fieldPrivateContext = (0, $6zwRZ.useNullableFieldPrivateContext)();
    const handleFieldRef = (0, $6358085614f491c6$var$_useForkRef.default)(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
    const setValue = pickerContext?.setValue;
    const handleChangeFromPicker = $6358085614f491c6$var$React.useCallback((newValue, ctx)=>{
        return setValue?.(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = $6358085614f491c6$var$React.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, $6358085614f491c6$var$_extends2.default)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            unstableFieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}

});

parcelRegister("aUKcB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7f22f924f94e9ae4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.syncSelectionToDOM = $7f22f924f94e9ae4$var$syncSelectionToDOM;

var $7f22f924f94e9ae4$var$_ownerDocument = $7f22f924f94e9ae4$require$_interopRequireDefault((parcelRequire("43fuO")));

var $l16rr = parcelRequire("l16rr");
function $7f22f924f94e9ae4$var$syncSelectionToDOM(parameters) {
    const { focused: focused, domGetters: domGetters, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, state: state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = (0, $7f22f924f94e9ae4$var$_ownerDocument.default)(domGetters.getRoot()).getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
        selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, $l16rr.getActiveElement)(domGetters.getRoot()))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}

});

parcelRegister("e0rC1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a3267c01476ba616$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldRootProps = $a3267c01476ba616$var$useFieldRootProps;

var $a3267c01476ba616$var$_useEventCallback = $a3267c01476ba616$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $a3267c01476ba616$var$_useTimeout = $a3267c01476ba616$require$_interopRequireDefault((parcelRequire("drY8V")));

var $erM5F = parcelRequire("erM5F");

var $l16rr = parcelRequire("l16rr");

var $aUKcB = parcelRequire("aUKcB");
/**
 * Generate the props to pass to the root element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the root element of the field.
 */ function $a3267c01476ba616$var$useFieldRootProps(parameters) {
    const { manager: manager, focused: focused, setFocused: setFocused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, internalPropsWithDefaults: internalPropsWithDefaults, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionOrder: sectionOrder, state: state, clearValue: // Methods to update the states
    clearValue, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    // TODO: Inline onContainerKeyDown once the old DOM structure is removed
    const handleKeyDown = (0, $erM5F.useFieldRootHandleKeyDown)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const containerClickTimeout = (0, $a3267c01476ba616$var$_useTimeout.default)();
    const handleClick = (0, $a3267c01476ba616$var$_useEventCallback.default)((event)=>{
        if (disabled || !domGetters.isReady()) return;
        setFocused(true);
        if (parsedSelectedSections === 'all') containerClickTimeout.start(0, ()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = domGetters.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleInput = (0, $a3267c01476ba616$var$_useEventCallback.default)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, $aUKcB.syncSelectionToDOM)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, $a3267c01476ba616$var$_useEventCallback.default)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, $a3267c01476ba616$var$_useEventCallback.default)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, $l16rr.getActiveElement)(domGetters.getRoot());
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, $a3267c01476ba616$var$_useEventCallback.default)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, $l16rr.getActiveElement)(domGetters.getRoot());
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: internalPropsWithDefaults.disabled || parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}

});
parcelRegister("erM5F", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a848e40bec4af3b9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldRootHandleKeyDown = $a848e40bec4af3b9$var$useFieldRootHandleKeyDown;

var $a848e40bec4af3b9$var$_useEventCallback = $a848e40bec4af3b9$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $l9aHF = parcelRequire("l9aHF");

var $3nE24 = parcelRequire("3nE24");
/**
 * Returns the `onKeyDown` handler to pass to the root element of the field.
 */ function $a848e40bec4af3b9$var$useFieldRootHandleKeyDown(parameters) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { manager: { internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: { minutesStep: minutesStep, disabled: disabled, readOnly: readOnly }, stateResponse: { state: // States and derived states
    state, value: value, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone, sectionOrder: sectionOrder, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue } } = parameters;
    return (0, $a848e40bec4af3b9$var$_useEventCallback.default)((event)=>{
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = $a848e40bec4af3b9$var$adjustSectionValue(adapter, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
}
function $a848e40bec4af3b9$var$getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function $a848e40bec4af3b9$var$adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = $a848e40bec4af3b9$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, $l9aHF.cleanDigitSectionValue)(adapter, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return adapter.formatByString(adapter.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, $l9aHF.removeLocalizedDigits)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, $l9aHF.getLetterEditingOptions)(adapter, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}

});


parcelRegister("13xsf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0c5005a788847ea8$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0c5005a788847ea8$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldHiddenInputProps = $0c5005a788847ea8$var$useFieldHiddenInputProps;

var $0c5005a788847ea8$var$React = $0c5005a788847ea8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0c5005a788847ea8$var$_useEventCallback = $0c5005a788847ea8$require$_interopRequireDefault((parcelRequire("6Lbjo")));
/**
 * Generate the props to pass to the hidden input element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldHiddenInputPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldHiddenInputPropsReturnValue} The props to forward to the hidden input element of the field.
 */ function $0c5005a788847ea8$var$useFieldHiddenInputProps(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, state: state, updateValueFromValueStr: // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, $0c5005a788847ea8$var$_useEventCallback.default)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $0c5005a788847ea8$var$React.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}

});

parcelRegister("cb1pF", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8dd79bb441a37a9b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldSectionContainerProps = $8dd79bb441a37a9b$var$useFieldSectionContainerProps;

var $8dd79bb441a37a9b$var$React = $8dd79bb441a37a9b$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Generate the props to pass to the container element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the container element of each section of the field.
 */ function $8dd79bb441a37a9b$var$useFieldSectionContainerProps(parameters) {
    const { stateResponse: { setSelectedSections: // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled: disabled = false } } = parameters;
    const createHandleClick = $8dd79bb441a37a9b$var$React.useCallback((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (disabled || event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $8dd79bb441a37a9b$var$React.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: createHandleClick(sectionIndex)
        }), [
        createHandleClick
    ]);
}

});

parcelRegister("uhMTw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $05b099b5410563cd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $05b099b5410563cd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldSectionContentProps = $05b099b5410563cd$var$useFieldSectionContentProps;

var $05b099b5410563cd$var$React = $05b099b5410563cd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $05b099b5410563cd$var$_useEventCallback = $05b099b5410563cd$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $BKARN = parcelRequire("BKARN");

var $aUKcB = parcelRequire("aUKcB");
/**
 * Generate the props to pass to the content element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the content element of each section of the field.
 */ function $05b099b5410563cd$var$useFieldSectionContentProps(parameters) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const { focused: focused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, state: state, value: value, clearActiveSection: // Methods to update the states
    clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $05b099b5410563cd$var$_useEventCallback.default)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, $aUKcB.syncSelectionToDOM)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    const handleInput = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, $05b099b5410563cd$var$_useEventCallback.default)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = $05b099b5410563cd$var$React.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $05b099b5410563cd$var$React.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-readonly': readOnly,
            'aria-valuenow': $05b099b5410563cd$var$getSectionValueNow(section, adapter),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? $05b099b5410563cd$var$getSectionValueText(section, adapter) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: !isEditable || isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            // Firefox hydrates this as `'none`' instead of `'off'`. No problems in chromium with both values.
            // For reference https://github.com/mui/mui-x/issues/19012
            autoCapitalize: isEditable ? 'none' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        adapter,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function $05b099b5410563cd$var$getSectionValueText(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') {
                    const dateWithMonth = adapter.setMonth(adapter.date(), Number(section.value) - 1);
                    return adapter.isValid(dateWithMonth) ? adapter.format(dateWithMonth, 'month') : '';
                }
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate && adapter.isValid(parsedDate) ? adapter.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            if (section.contentType === 'digit') {
                const dateWithDay = adapter.setDate(adapter.startOfYear(adapter.date()), Number(section.value));
                return adapter.isValid(dateWithDay) ? adapter.format(dateWithDay, 'dayOfMonthFull') : '';
            }
            return section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function $05b099b5410563cd$var$getSectionValueNow(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
                if (parsedDate) return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
}

});


parcelRegister("3Pdrd", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $2c908f051ecf8b71$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2c908f051ecf8b71$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldV6TextField = module.exports.addPositionPropertiesToSections = void 0;

var $2c908f051ecf8b71$var$_extends2 = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2c908f051ecf8b71$var$React = $2c908f051ecf8b71$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $2c908f051ecf8b71$var$_useEnhancedEffect = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2c908f051ecf8b71$var$_useEventCallback = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $2c908f051ecf8b71$var$_useTimeout = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("drY8V")));

var $2c908f051ecf8b71$var$_useForkRef = $2c908f051ecf8b71$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $BKARN = parcelRequire("BKARN");

var $l16rr = parcelRequire("l16rr");

var $l9aHF = parcelRequire("l9aHF");

var $LYmdu = parcelRequire("LYmdu");

var $erM5F = parcelRequire("erM5F");

var $b1YwV = parcelRequire("b1YwV");

var $8wNUU = parcelRequire("8wNUU");
const $2c908f051ecf8b71$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $2c908f051ecf8b71$var$addPositionPropertiesToSections = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $l9aHF.getSectionVisibleValue)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $2c908f051ecf8b71$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $2c908f051ecf8b71$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $2c908f051ecf8b71$var$_extends2.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
module.exports.addPositionPropertiesToSections = $2c908f051ecf8b71$var$addPositionPropertiesToSections;
const $2c908f051ecf8b71$var$useFieldV6TextField = (parameters)=>{
    const isRtl = (0, $9uEev.useRtl)();
    const focusTimeout = (0, $2c908f051ecf8b71$var$_useTimeout.default)();
    const selectionSyncTimeout = (0, $2c908f051ecf8b71$var$_useTimeout.default)();
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $BKARN.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, $8wNUU.useFieldInternalPropsWithDefaults)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable, inputRef: inputRefProp, placeholder: inPlaceholder } = forwardedProps;
    const { readOnly: readOnly = false, disabled: disabled = false, autoFocus: autoFocus = false, focused: focused, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const inputRef = $2c908f051ecf8b71$var$React.useRef(null);
    const handleRef = (0, $2c908f051ecf8b71$var$_useForkRef.default)(inputRefProp, inputRef);
    const stateResponse = (0, $b1YwV.useFieldState)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { activeSectionIndex: // States and derived states
    activeSectionIndex, areAllSectionsEmpty: areAllSectionsEmpty, error: error, localizedDigits: localizedDigits, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, getSectionsFromValue: // Utilities methods
    getSectionsFromValue } = stateResponse;
    const applyCharacterEditing = (0, $LYmdu.useFieldCharacterEditing)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const sections = $2c908f051ecf8b71$var$React.useMemo(()=>$2c908f051ecf8b71$var$addPositionPropertiesToSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    function syncSelectionFromDOM() {
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    }
    function focusField(newSelectedSection = 0) {
        if ((0, $l16rr.getActiveElement)(inputRef.current) === inputRef.current) return;
        inputRef.current?.focus();
        setSelectedSections(newSelectedSection);
    }
    const handleInputFocus = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onFocus?.(event);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        focusTimeout.start(0, ()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                setCharacterQuery(null);
                updateSectionValue({
                    section: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onBlur?.(event);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $2c908f051ecf8b71$var$cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $2c908f051ecf8b71$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $2c908f051ecf8b71$var$cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + $2c908f051ecf8b71$var$cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $l9aHF.isAndroid)()) setTempAndroidValueStr(valueStr);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const handleClear = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$2c908f051ecf8b71$var$isFieldFocused(inputRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerKeyDown = (0, $erM5F.useFieldRootHandleKeyDown)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const wrappedHandleContainerKeyDown = (0, $2c908f051ecf8b71$var$_useEventCallback.default)((event)=>{
        onKeyDown?.(event);
        handleContainerKeyDown(event);
    });
    const placeholder = $2c908f051ecf8b71$var$React.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $2c908f051ecf8b71$var$React.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $2c908f051ecf8b71$var$React.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current)) setSelectedSections('all');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $2c908f051ecf8b71$var$_useEnhancedEffect.default)(()=>{
        function syncSelectionToDOM() {
            if (!inputRef.current) return;
            if (parsedSelectedSections == null) {
                if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                // setting selection range to 0 causes issues in Safari.
                // https://bugs.webkit.org/show_bug.cgi?id=224425
                inputRef.current.scrollLeft = 0;
                return;
            }
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current !== (0, $l16rr.getActiveElement)(inputRef.current)) return;
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            if (parsedSelectedSections === 'all') inputRef.current.select();
            else {
                const selectedSection = sections[parsedSelectedSections];
                const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                    if (inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                }
                selectionSyncTimeout.start(0, ()=>{
                    // handle case when the selection is not updated correctly
                    // could happen on Android
                    if (inputRef.current && inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
                    // https://github.com/mui/mui-x/pull/13652
                    inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) syncSelectionToDOM();
                });
            }
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
        syncSelectionToDOM();
    });
    const inputMode = $2c908f051ecf8b71$var$React.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $2c908f051ecf8b71$var$React.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            focusField: focusField,
            isFieldFocused: ()=>$2c908f051ecf8b71$var$isFieldFocused(inputRef)
        }));
    return (0, $2c908f051ecf8b71$var$_extends2.default)({}, forwardedProps, {
        error: error,
        'aria-invalid': error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        onBlur: handleContainerBlur,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onPaste: handleInputPaste,
        onKeyDown: wrappedHandleContainerKeyDown,
        onClear: handleClear,
        inputRef: handleRef,
        // Additional
        enableAccessibleFieldDOMStructure: false,
        placeholder: placeholder,
        inputMode: inputMode,
        autoComplete: 'off',
        value: shouldShowPlaceholder ? '' : valueStr,
        onChange: handleInputChange,
        focused: focused,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
module.exports.useFieldV6TextField = $2c908f051ecf8b71$var$useFieldV6TextField;
function $2c908f051ecf8b71$var$isFieldFocused(inputRef) {
    return inputRef.current === (0, $l16rr.getActiveElement)(inputRef.current);
}

});



parcelRegister("8tpPE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useDateManager", {
    enumerable: true,
    get: function() {
        return $1aSwN.useDateManager;
    }
});
Object.defineProperty(module.exports, "useDateTimeManager", {
    enumerable: true,
    get: function() {
        return $2wsa0.useDateTimeManager;
    }
});
Object.defineProperty(module.exports, "useTimeManager", {
    enumerable: true,
    get: function() {
        return $dWSXy.useTimeManager;
    }
});

var $1aSwN = parcelRequire("1aSwN");

var $dWSXy = parcelRequire("dWSXy");

var $2wsa0 = parcelRequire("2wsa0");

});
parcelRegister("1aSwN", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0db105bf1f5518e9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0db105bf1f5518e9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useApplyDefaultValuesToDateValidationProps = $0db105bf1f5518e9$var$useApplyDefaultValuesToDateValidationProps;
module.exports.useDateManager = $0db105bf1f5518e9$var$useDateManager;

var $0db105bf1f5518e9$var$_extends2 = $0db105bf1f5518e9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0db105bf1f5518e9$var$React = $0db105bf1f5518e9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $NRNex = parcelRequire("NRNex");

var $1M3bL = parcelRequire("1M3bL");

var $5UoGz = parcelRequire("5UoGz");

var $3vagl = parcelRequire("3vagl");

var $BKARN = parcelRequire("BKARN");
function $0db105bf1f5518e9$var$useDateManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $0db105bf1f5518e9$var$React.useMemo(()=>({
            valueType: 'date',
            validator: $5UoGz.validateDate,
            internal_valueManager: $1M3bL.singleItemValueManager,
            internal_fieldValueManager: $1M3bL.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $0db105bf1f5518e9$var$useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $0db105bf1f5518e9$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $0db105bf1f5518e9$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    return $0db105bf1f5518e9$var$React.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $0db105bf1f5518e9$var$useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const validationProps = $0db105bf1f5518e9$var$useApplyDefaultValuesToDateValidationProps(internalProps);
    return $0db105bf1f5518e9$var$React.useMemo(()=>(0, $0db105bf1f5518e9$var$_extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? adapter.formats.keyboardDate
        }), [
        internalProps,
        validationProps,
        adapter
    ]);
}
function $0db105bf1f5518e9$var$useApplyDefaultValuesToDateValidationProps(props) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const defaultDates = (0, $3vagl.useDefaultDates)();
    return $0db105bf1f5518e9$var$React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            minDate: (0, $NRNex.applyDefaultDate)(adapter, props.minDate, defaultDates.minDate),
            maxDate: (0, $NRNex.applyDefaultDate)(adapter, props.maxDate, defaultDates.maxDate)
        }), [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}

});
parcelRegister("3vagl", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $28cc3a450bd9076f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useNow = module.exports.useDefaultDates = void 0;

var $28cc3a450bd9076f$var$React = $28cc3a450bd9076f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3nE24 = parcelRequire("3nE24");
const $28cc3a450bd9076f$var$useDefaultDates = ()=>(0, $3nE24.useLocalizationContext)().defaultDates;
module.exports.useDefaultDates = $28cc3a450bd9076f$var$useDefaultDates;
const $28cc3a450bd9076f$var$useNow = (timezone)=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    const now = $28cc3a450bd9076f$var$React.useRef(undefined);
    if (now.current === undefined) now.current = adapter.date(undefined, timezone);
    return now.current;
};
module.exports.useNow = $28cc3a450bd9076f$var$useNow;

});


parcelRegister("dWSXy", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $a27b52f65f4c000d$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $a27b52f65f4c000d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useApplyDefaultValuesToTimeValidationProps = $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeValidationProps;
module.exports.useTimeManager = $a27b52f65f4c000d$var$useTimeManager;

var $a27b52f65f4c000d$var$_extends2 = $a27b52f65f4c000d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a27b52f65f4c000d$var$React = $a27b52f65f4c000d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1M3bL = parcelRequire("1M3bL");

var $5UoGz = parcelRequire("5UoGz");

var $BKARN = parcelRequire("BKARN");
function $a27b52f65f4c000d$var$useTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true, ampm: ampm } = parameters;
    return $a27b52f65f4c000d$var$React.useMemo(()=>({
            valueType: 'time',
            validator: $5UoGz.validateTime,
            internal_valueManager: $1M3bL.singleItemValueManager,
            internal_fieldValueManager: $1M3bL.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $a27b52f65f4c000d$var$createUseOpenPickerButtonAriaLabel(ampm)
        }), [
        ampm,
        enableAccessibleFieldDOMStructure
    ]);
}
function $a27b52f65f4c000d$var$createUseOpenPickerButtonAriaLabel(ampm) {
    return function useOpenPickerButtonAriaLabel(value) {
        const adapter = (0, $BKARN.usePickerAdapter)();
        const translations = (0, $BKARN.usePickerTranslations)();
        return $a27b52f65f4c000d$var$React.useMemo(()=>{
            const formatKey = ampm ?? adapter.is12HourCycleInCurrentLocale() ? 'fullTime12h' : 'fullTime24h';
            const formattedValue = adapter.isValid(value) ? adapter.format(value, formatKey) : null;
            return translations.openTimePickerDialogue(formattedValue);
        }, [
            value,
            translations,
            adapter
        ]);
    };
}
function $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeFieldInternalProps(internalProps) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const validationProps = $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeValidationProps(internalProps);
    const ampm = $a27b52f65f4c000d$var$React.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return $a27b52f65f4c000d$var$React.useMemo(()=>(0, $a27b52f65f4c000d$var$_extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.fullTime12h : adapter.formats.fullTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function $a27b52f65f4c000d$var$useApplyDefaultValuesToTimeValidationProps(props) {
    return $a27b52f65f4c000d$var$React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false
        }), [
        props.disablePast,
        props.disableFuture
    ]);
}

});

parcelRegister("2wsa0", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $1d6469ff6cf05a6f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $1d6469ff6cf05a6f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useApplyDefaultValuesToDateTimeValidationProps = $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeValidationProps;
module.exports.useDateTimeManager = $1d6469ff6cf05a6f$var$useDateTimeManager;

var $1d6469ff6cf05a6f$var$_extends2 = $1d6469ff6cf05a6f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $1d6469ff6cf05a6f$var$React = $1d6469ff6cf05a6f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $NRNex = parcelRequire("NRNex");

var $1M3bL = parcelRequire("1M3bL");

var $5UoGz = parcelRequire("5UoGz");

var $3vagl = parcelRequire("3vagl");

var $BKARN = parcelRequire("BKARN");
function $1d6469ff6cf05a6f$var$useDateTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>({
            valueType: 'date-time',
            validator: $5UoGz.validateDateTime,
            internal_valueManager: $1M3bL.singleItemValueManager,
            internal_fieldValueManager: $1M3bL.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $1d6469ff6cf05a6f$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $1d6469ff6cf05a6f$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeFieldInternalProps(internalProps) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const validationProps = $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeValidationProps(internalProps);
    const ampm = $1d6469ff6cf05a6f$var$React.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>(0, $1d6469ff6cf05a6f$var$_extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.keyboardDateTime12h : adapter.formats.keyboardDateTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function $1d6469ff6cf05a6f$var$useApplyDefaultValuesToDateTimeValidationProps(props) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const defaultDates = (0, $3vagl.useDefaultDates)();
    return $1d6469ff6cf05a6f$var$React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            // TODO: Explore if we can remove it from the public API
            disableIgnoringDatePartForTimeValidation: !!props.minDateTime || !!props.maxDateTime || !!props.disableFuture || !!props.disablePast,
            minDate: (0, $NRNex.applyDefaultDate)(adapter, props.minDateTime ?? props.minDate, defaultDates.minDate),
            maxDate: (0, $NRNex.applyDefaultDate)(adapter, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
            minTime: props.minDateTime ?? props.minTime,
            maxTime: props.maxDateTime ?? props.maxTime
        }), [
        props.minDateTime,
        props.maxDateTime,
        props.minTime,
        props.maxTime,
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}

});



parcelRegister("w6zXP", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $060817bd35ed0d61$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $060817bd35ed0d61$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerFieldUI = $060817bd35ed0d61$var$PickerFieldUI;
module.exports.PickerFieldUIContext = void 0;
module.exports.PickerFieldUIContextProvider = $060817bd35ed0d61$var$PickerFieldUIContextProvider;
module.exports.cleanFieldResponse = void 0;
module.exports.mergeSlotProps = $060817bd35ed0d61$var$mergeSlotProps;
module.exports.useFieldTextFieldProps = $060817bd35ed0d61$var$useFieldTextFieldProps;

var $060817bd35ed0d61$var$_extends2 = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2 = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("c05no")));

var $060817bd35ed0d61$var$React = $060817bd35ed0d61$require$_interopRequireWildcard((parcelRequire("acw62")));

var $060817bd35ed0d61$var$_useEventCallback = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $060817bd35ed0d61$var$_useForkRef = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $060817bd35ed0d61$var$_resolveComponentProps = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("jzekU")));

var $060817bd35ed0d61$var$_TextField = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("hABDe")));

var $060817bd35ed0d61$var$_IconButton = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("825Zh")));

var $060817bd35ed0d61$var$_InputAdornment = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("9bswS")));

var $ePguI = parcelRequire("ePguI");

var $060817bd35ed0d61$var$_useSlotProps5 = $060817bd35ed0d61$require$_interopRequireDefault((parcelRequire("839K0")));

var $d51Yx = parcelRequire("d51Yx");

var $BKARN = parcelRequire("BKARN");

var $1SVAo = parcelRequire("1SVAo");

var $yCVZs = parcelRequire("yCVZs");

var $3Gp0b = parcelRequire("3Gp0b");

var $ayMG0 = parcelRequire("ayMG0");
const $060817bd35ed0d61$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $060817bd35ed0d61$var$_excluded2 = [
    "InputProps",
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $060817bd35ed0d61$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $060817bd35ed0d61$var$_excluded4 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded5 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded6 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded7 = [
    "ownerState"
], $060817bd35ed0d61$var$_excluded8 = [
    "InputProps",
    "inputProps"
];
const $060817bd35ed0d61$var$noop = ()=>{};
const $060817bd35ed0d61$var$cleanFieldResponse = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_ref, $060817bd35ed0d61$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(fieldResponse, $060817bd35ed0d61$var$_excluded2);
        const mergedInputProps = $ePguI.major >= 6 && other?.slotProps?.input ? $060817bd35ed0d61$var$mergeSlotProps(other?.slotProps?.input, InputProps) : $060817bd35ed0d61$var$noop;
        return {
            clearable: clearable,
            onClear: onClear,
            clearButtonPosition: clearButtonPosition,
            openPickerButtonPosition: openPickerButtonPosition,
            openPickerAriaLabel: openPickerAriaLabel,
            textFieldProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, other, $ePguI.major >= 6 && other?.slotProps?.input ? {
                slotProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, other?.slotProps, {
                    input: (ownerState)=>(0, $060817bd35ed0d61$var$_extends2.default)({}, (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(mergedInputProps, ownerState), {
                            readOnly: readOnly
                        })
                })
            } : {
                InputProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, InputProps ?? {}, {
                    readOnly: readOnly
                })
            })
        };
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(fieldResponse, $060817bd35ed0d61$var$_excluded3);
    const mergedInputProps = $ePguI.major >= 6 && other?.slotProps?.input ? $060817bd35ed0d61$var$mergeSlotProps(other?.slotProps?.input, InputProps) : $060817bd35ed0d61$var$noop;
    const mergedHtmlInputProps = $ePguI.major >= 6 && other?.slotProps?.htmlInput ? $060817bd35ed0d61$var$mergeSlotProps(other?.slotProps?.htmlInput, inputProps) : $060817bd35ed0d61$var$noop;
    return {
        clearable: clearable,
        onClear: onClear,
        clearButtonPosition: clearButtonPosition,
        openPickerButtonPosition: openPickerButtonPosition,
        openPickerAriaLabel: openPickerAriaLabel,
        textFieldProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, other, $ePguI.major >= 6 && (other?.slotProps?.input || other?.slotProps?.htmlInput) ? {
            slotProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, other?.slotProps, {
                input: (ownerState)=>(0, $060817bd35ed0d61$var$_extends2.default)({}, (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(mergedInputProps, ownerState), {
                        readOnly: readOnly
                    }),
                htmlInput: (ownerState)=>(0, $060817bd35ed0d61$var$_extends2.default)({}, (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(mergedHtmlInputProps, ownerState), {
                        inputMode: inputMode,
                        onPaste: onPaste,
                        onKeyDown: onKeyDown,
                        ref: inputRef
                    })
            })
        } : {
            InputProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, InputProps ?? {}, {
                readOnly: readOnly
            }),
            inputProps: (0, $060817bd35ed0d61$var$_extends2.default)({}, inputProps ?? {}, {
                inputMode: inputMode,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                ref: inputRef
            })
        })
    };
};
module.exports.cleanFieldResponse = $060817bd35ed0d61$var$cleanFieldResponse;
const $060817bd35ed0d61$var$PickerFieldUIContext = module.exports.PickerFieldUIContext = /*#__PURE__*/ $060817bd35ed0d61$var$React.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function $060817bd35ed0d61$var$PickerFieldUI(props) {
    const { fieldResponse: fieldResponse, defaultOpenPickerIcon: defaultOpenPickerIcon } = props;
    const translations = (0, $BKARN.usePickerTranslations)();
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const pickerFieldUIContext = $060817bd35ed0d61$var$React.useContext($060817bd35ed0d61$var$PickerFieldUIContext);
    const { textFieldProps: textFieldProps, onClear: onClear, clearable: clearable, openPickerAriaLabel: openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = $060817bd35ed0d61$var$cleanFieldResponse(fieldResponse);
    const ownerState = (0, $d51Yx.useFieldOwnerState)(textFieldProps);
    const handleClickOpeningButton = (0, $060817bd35ed0d61$var$_useEventCallback.default)((event)=>{
        event.preventDefault();
        pickerContext?.setOpen((prev)=>!prev);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    const TextField = pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? $060817bd35ed0d61$var$_TextField.default : $3Gp0b.PickersTextField);
    const InputAdornment = pickerFieldUIContext.slots.inputAdornment ?? $060817bd35ed0d61$var$_InputAdornment.default;
    const _useSlotProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, $060817bd35ed0d61$var$_extends2.default)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $060817bd35ed0d61$var$_excluded4);
    const _useSlotProps2 = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, $060817bd35ed0d61$var$_extends2.default)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps2, $060817bd35ed0d61$var$_excluded5);
    const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? $060817bd35ed0d61$var$_IconButton.default;
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState: ownerState
    }), openPickerButtonProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps3, $060817bd35ed0d61$var$_excluded6);
    const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
    const openPickerIconProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState: ownerState
    });
    const ClearButton = pickerFieldUIContext.slots.clearButton ?? $060817bd35ed0d61$var$_IconButton.default;
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: ClearButton,
        externalSlotProps: pickerFieldUIContext.slotProps.clearButton,
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState: ownerState
    }), clearButtonProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps4, $060817bd35ed0d61$var$_excluded7);
    const ClearIcon = pickerFieldUIContext.slots.clearIcon ?? $1SVAo.ClearIcon;
    const clearIconProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: ClearIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.clearIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    textFieldProps.ref = (0, $060817bd35ed0d61$var$_useForkRef.default)(textFieldProps.ref, pickerContext?.rootRef);
    const additionalTextFieldInputProps = {};
    const textFieldInputProps = (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(($ePguI.major >= 6 && textFieldProps?.slotProps?.input) ?? textFieldProps.InputProps, ownerState);
    if (pickerContext) additionalTextFieldInputProps.ref = pickerContext.triggerRef;
    if (!textFieldInputProps?.startAdornment && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) additionalTextFieldInputProps.startAdornment = /*#__PURE__*/ (0, $ayMG0.jsxs)(InputAdornment, (0, $060817bd35ed0d61$var$_extends2.default)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, $ayMG0.jsx)(ClearButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearIconProps))
            }))
        ]
    }));
    if (!textFieldInputProps?.endAdornment && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsxs)(InputAdornment, (0, $060817bd35ed0d61$var$_extends2.default)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, $ayMG0.jsx)(ClearButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $060817bd35ed0d61$var$_extends2.default)({}, openPickerIconProps))
            }))
        ]
    }));
    // handle the case of showing custom `inputAdornment` for Field components
    if (!additionalTextFieldInputProps?.endAdornment && !additionalTextFieldInputProps?.startAdornment && pickerFieldUIContext.slots.inputAdornment) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsx)(InputAdornment, (0, $060817bd35ed0d61$var$_extends2.default)({}, endInputAdornmentProps));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    const resolvedTextFieldInputProps = $ePguI.major >= 6 && textFieldProps?.slotProps?.input ? (0, $060817bd35ed0d61$var$_resolveComponentProps.default)($060817bd35ed0d61$var$mergeSlotProps(textFieldInputProps, additionalTextFieldInputProps), ownerState) : (0, $060817bd35ed0d61$var$_extends2.default)({}, textFieldInputProps, additionalTextFieldInputProps);
    // We need to resolve the `inputProps` since we are messing with those props in this component.
    textFieldProps.inputProps = $ePguI.major >= 6 && textFieldProps?.slotProps?.htmlInput ? (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(textFieldProps.slotProps.htmlInput, ownerState) : textFieldProps.inputProps;
    // Remove the `input` slotProps to avoid them overriding the manually resolved `InputProps`.
    // Relevant on `materialMajor >= 6` since `slotProps` would take precedence.
    delete textFieldProps?.slotProps?.input;
    if (fieldResponse.enableAccessibleFieldDOMStructure) // Remove the `slotProps` on `PickersTextField` as they are not supported.
    delete textFieldProps?.slotProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TextField, (0, $060817bd35ed0d61$var$_extends2.default)({}, textFieldProps, {
        InputProps: resolvedTextFieldInputProps
    }));
}
function $060817bd35ed0d61$var$mergeSlotProps(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, $060817bd35ed0d61$var$_extends2.default)({}, (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(slotPropsB, ownerState), (0, $060817bd35ed0d61$var$_resolveComponentProps.default)(slotPropsA, ownerState));
    };
}
/**
 * The `textField` slot props cannot be handled inside `PickerFieldUI` because it would be a breaking change to not pass the enriched props to `useField`.
 * Once the non-accessible DOM structure will be removed, we will be able to remove the `textField` slot and clean this logic.
 */ function $060817bd35ed0d61$var$useFieldTextFieldProps(parameters) {
    const { ref: ref, externalForwardedProps: externalForwardedProps, slotProps: slotProps } = parameters;
    const pickerFieldUIContext = $060817bd35ed0d61$var$React.useContext($060817bd35ed0d61$var$PickerFieldUIContext);
    const pickerContext = (0, $yCVZs.useNullablePickerContext)();
    const ownerState = (0, $d51Yx.useFieldOwnerState)(externalForwardedProps);
    const { InputProps: InputProps, inputProps: inputProps } = externalForwardedProps, otherExternalForwardedProps = (0, $060817bd35ed0d61$var$_objectWithoutPropertiesLoose2.default)(externalForwardedProps, $060817bd35ed0d61$var$_excluded8);
    const textFieldProps = (0, $060817bd35ed0d61$var$_useSlotProps5.default)({
        elementType: $3Gp0b.PickersTextField,
        externalSlotProps: $060817bd35ed0d61$var$mergeSlotProps(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
        externalForwardedProps: otherExternalForwardedProps,
        additionalProps: {
            ref: ref,
            sx: pickerContext?.rootSx,
            label: pickerContext?.label,
            name: pickerContext?.name,
            className: pickerContext?.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $060817bd35ed0d61$var$_extends2.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $060817bd35ed0d61$var$_extends2.default)({}, InputProps, textFieldProps.InputProps);
    return textFieldProps;
}
function $060817bd35ed0d61$var$PickerFieldUIContextProvider(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, inputRef: inputRef, children: children } = props;
    const contextValue = $060817bd35ed0d61$var$React.useMemo(()=>({
            inputRef: inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($060817bd35ed0d61$var$PickerFieldUIContext.Provider, {
        value: contextValue,
        children: children
    });
}

});
parcelRegister("d51Yx", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $985d464b7bb70bde$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $985d464b7bb70bde$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFieldOwnerState = $985d464b7bb70bde$var$useFieldOwnerState;

var $985d464b7bb70bde$var$_extends2 = $985d464b7bb70bde$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $985d464b7bb70bde$var$React = $985d464b7bb70bde$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $7OOd8 = parcelRequire("7OOd8");
function $985d464b7bb70bde$var$useFieldOwnerState(parameters) {
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const isRtl = (0, $9uEev.useRtl)();
    return $985d464b7bb70bde$var$React.useMemo(()=>(0, $985d464b7bb70bde$var$_extends2.default)({}, pickerOwnerState, {
            isFieldDisabled: parameters.disabled ?? false,
            isFieldReadOnly: parameters.readOnly ?? false,
            isFieldRequired: parameters.required ?? false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}

});
parcelRegister("7OOd8", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5b1426c0e5210fae$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerPrivateContext = void 0;

var $5b1426c0e5210fae$var$React = $5b1426c0e5210fae$require$_interopRequireWildcard((parcelRequire("acw62")));

var $jk6Bf = parcelRequire("jk6Bf");
/**
 * Returns the private context passed by the Picker wrapping the current component.
 */ const $5b1426c0e5210fae$var$usePickerPrivateContext = ()=>$5b1426c0e5210fae$var$React.useContext($jk6Bf.PickerPrivateContext);
module.exports.usePickerPrivateContext = $5b1426c0e5210fae$var$usePickerPrivateContext;

});


parcelRegister("1SVAo", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $15f780f59fa32b0f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeIcon = module.exports.DateRangeIcon = module.exports.ClockIcon = module.exports.ClearIcon = module.exports.CalendarIcon = module.exports.ArrowRightIcon = module.exports.ArrowLeftIcon = module.exports.ArrowDropDownIcon = void 0;

var $hGPki = parcelRequire("hGPki");

var $15f780f59fa32b0f$var$React = $15f780f59fa32b0f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ArrowDropDownIcon = module.exports.ArrowDropDownIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ArrowLeftIcon = module.exports.ArrowLeftIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ArrowRightIcon = module.exports.ArrowRightIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$CalendarIcon = module.exports.CalendarIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ClockIcon = module.exports.ClockIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsxs)($15f780f59fa32b0f$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$DateRangeIcon = module.exports.DateRangeIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$TimeIcon = module.exports.TimeIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsxs)($15f780f59fa32b0f$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
/**
 * @ignore - internal component.
 */ const $15f780f59fa32b0f$var$ClearIcon = module.exports.ClearIcon = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

});

parcelRegister("3Gp0b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2ae8b0334fa2115e$var$_exportNames = {
    PickersTextField: true,
    pickersTextFieldClasses: true,
    getPickersTextFieldUtilityClass: true
};
Object.defineProperty(module.exports, "PickersTextField", {
    enumerable: true,
    get: function() {
        return $xZ8Ea.PickersTextField;
    }
});
Object.defineProperty(module.exports, "getPickersTextFieldUtilityClass", {
    enumerable: true,
    get: function() {
        return $5rDth.getPickersTextFieldUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersTextFieldClasses", {
    enumerable: true,
    get: function() {
        return $5rDth.pickersTextFieldClasses;
    }
});

var $xZ8Ea = parcelRequire("xZ8Ea");

var $5rDth = parcelRequire("5rDth");

var $aaK30 = parcelRequire("aaK30");
Object.keys($aaK30).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $aaK30[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aaK30[key];
        }
    });
});

var $2CiZK = parcelRequire("2CiZK");
Object.keys($2CiZK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2CiZK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2CiZK[key];
        }
    });
});

var $3KixP = parcelRequire("3KixP");
Object.keys($3KixP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3KixP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3KixP[key];
        }
    });
});

var $id0az = parcelRequire("id0az");
Object.keys($id0az).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ae8b0334fa2115e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $id0az[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $id0az[key];
        }
    });
});

});
parcelRegister("xZ8Ea", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $06628201f2cc4505$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $06628201f2cc4505$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersTextField = void 0;

var $06628201f2cc4505$var$_extends2 = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $06628201f2cc4505$var$_objectWithoutPropertiesLoose2 = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("c05no")));

var $06628201f2cc4505$var$React = $06628201f2cc4505$require$_interopRequireWildcard((parcelRequire("acw62")));

var $06628201f2cc4505$var$_propTypes = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $06628201f2cc4505$var$_clsx = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $06628201f2cc4505$var$_refType = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $06628201f2cc4505$var$_useForkRef = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $06628201f2cc4505$var$_composeClasses = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $06628201f2cc4505$var$_useId = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("hwliF")));

var $06628201f2cc4505$var$_InputLabel = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("k9xmz")));

var $06628201f2cc4505$var$_FormHelperText = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("4xkW2")));

var $06628201f2cc4505$var$_FormControl = $06628201f2cc4505$require$_interopRequireDefault((parcelRequire("iA4iQ")));

var $5rDth = parcelRequire("5rDth");

var $3KixP = parcelRequire("3KixP");

var $2CiZK = parcelRequire("2CiZK");

var $aaK30 = parcelRequire("aaK30");

var $d51Yx = parcelRequire("d51Yx");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $06628201f2cc4505$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "hiddenLabel",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps",
    "data-active-range-position"
];
const $06628201f2cc4505$var$VARIANT_COMPONENT = {
    standard: $aaK30.PickersInput,
    filled: $2CiZK.PickersFilledInput,
    outlined: $3KixP.PickersOutlinedInput
};
const $06628201f2cc4505$var$PickersTextFieldRoot = (0, $8xDHs.styled)($06628201f2cc4505$var$_FormControl.default, {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const $06628201f2cc4505$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldRequired: isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, $06628201f2cc4505$var$_composeClasses.default)(slots, $5rDth.getPickersTextFieldUtilityClass, classes);
};
const $06628201f2cc4505$var$PickersTextField = module.exports.PickersTextField = /*#__PURE__*/ $06628201f2cc4505$var$React.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, classes: classesProp, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, hiddenLabel: hiddenLabel = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, $06628201f2cc4505$var$_objectWithoutPropertiesLoose2.default)(props, $06628201f2cc4505$var$_excluded);
    const rootRef = $06628201f2cc4505$var$React.useRef(null);
    const handleRootRef = (0, $06628201f2cc4505$var$_useForkRef.default)(ref, rootRef);
    const id = (0, $06628201f2cc4505$var$_useId.default)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const fieldOwnerState = (0, $d51Yx.useFieldOwnerState)({
        disabled: props.disabled,
        required: props.required,
        readOnly: InputProps?.readOnly
    });
    const ownerState = $06628201f2cc4505$var$React.useMemo(()=>(0, $06628201f2cc4505$var$_extends2.default)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused ?? false,
            hasFieldError: error ?? false,
            inputSize: props.size ?? 'medium',
            inputColor: color ?? 'primary',
            isInputInFullWidth: fullWidth ?? false,
            hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
            hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
            inputHasLabel: !!label,
            isLabelShrunk: Boolean(InputLabelProps?.shrink)
        }), [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        InputProps?.startAdornment,
        InputProps?.endAdornment,
        label,
        InputLabelProps?.shrink
    ]);
    const classes = $06628201f2cc4505$var$useUtilityClasses(classesProp, ownerState);
    const PickersInputComponent = $06628201f2cc4505$var$VARIANT_COMPONENT[variant];
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') inputAdditionalProps.notched = InputLabelProps.shrink;
        inputAdditionalProps.label = label;
    } else if (variant === 'filled') inputAdditionalProps.hiddenLabel = hiddenLabel;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8COFU.PickerTextFieldOwnerStateContext.Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($06628201f2cc4505$var$PickersTextFieldRoot, (0, $06628201f2cc4505$var$_extends2.default)({
            className: (0, $06628201f2cc4505$var$_clsx.default)(classes.root, className),
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required,
            ownerState: ownerState
        }, other, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)($06628201f2cc4505$var$_InputLabel.default, (0, $06628201f2cc4505$var$_extends2.default)({
                    htmlFor: id,
                    id: inputLabelId
                }, InputLabelProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)(PickersInputComponent, (0, $06628201f2cc4505$var$_extends2.default)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputProps: inputProps,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, InputProps)),
                helperText && /*#__PURE__*/ (0, $ayMG0.jsx)($06628201f2cc4505$var$_FormHelperText.default, (0, $06628201f2cc4505$var$_extends2.default)({
                    id: helperTextId
                }, FormHelperTextProps, {
                    children: helperText
                }))
            ]
        }))
    });
});

});
parcelRegister("5rDth", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3f6e178f64e28835$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersTextFieldUtilityClass = $3f6e178f64e28835$var$getPickersTextFieldUtilityClass;
module.exports.pickersTextFieldClasses = void 0;

var $3f6e178f64e28835$var$_generateUtilityClass = $3f6e178f64e28835$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $3f6e178f64e28835$var$_generateUtilityClasses = $3f6e178f64e28835$require$_interopRequireDefault((parcelRequire("5nY49")));
function $3f6e178f64e28835$var$getPickersTextFieldUtilityClass(slot) {
    return (0, $3f6e178f64e28835$var$_generateUtilityClass.default)('MuiPickersTextField', slot);
}
const $3f6e178f64e28835$var$pickersTextFieldClasses = module.exports.pickersTextFieldClasses = (0, $3f6e178f64e28835$var$_generateUtilityClasses.default)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);

});

parcelRegister("3KixP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersOutlinedInput", {
    enumerable: true,
    get: function() {
        return $2ONZk.PickersOutlinedInput;
    }
});
Object.defineProperty(module.exports, "getPickersOutlinedInputUtilityClass", {
    enumerable: true,
    get: function() {
        return $1lpfw.getPickersOutlinedInputUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersOutlinedInputClasses", {
    enumerable: true,
    get: function() {
        return $1lpfw.pickersOutlinedInputClasses;
    }
});

var $2ONZk = parcelRequire("2ONZk");

var $1lpfw = parcelRequire("1lpfw");

});
parcelRegister("2ONZk", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $20d706e29be2fff2$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $20d706e29be2fff2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersOutlinedInput = void 0;

var $20d706e29be2fff2$var$_objectWithoutPropertiesLoose2 = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("c05no")));

var $20d706e29be2fff2$var$_extends2 = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $20d706e29be2fff2$var$React = $20d706e29be2fff2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $20d706e29be2fff2$var$_propTypes = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $iA4iQ = parcelRequire("iA4iQ");

var $8xDHs = parcelRequire("8xDHs");

var $20d706e29be2fff2$var$_refType = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $20d706e29be2fff2$var$_composeClasses = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1lpfw = parcelRequire("1lpfw");

var $20d706e29be2fff2$var$_Outline = $20d706e29be2fff2$require$_interopRequireDefault((parcelRequire("3f6Ua")));

var $id0az = parcelRequire("id0az");

var $f9pWD = parcelRequire("f9pWD");

var $ayMG0 = parcelRequire("ayMG0");
const $20d706e29be2fff2$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched"
];
const $20d706e29be2fff2$var$PickersOutlinedInputRoot = (0, $8xDHs.styled)($f9pWD.PickersInputBaseRoot, {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${$1lpfw.pickersOutlinedInputClasses.focused} .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${$1lpfw.pickersOutlinedInputClasses.disabled}`]: {
            [`& .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${$1lpfw.pickersOutlinedInputClasses.error} .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${$1lpfw.pickersOutlinedInputClasses.focused}:not(.${$1lpfw.pickersOutlinedInputClasses.error}) .${$1lpfw.pickersOutlinedInputClasses.notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $20d706e29be2fff2$var$PickersOutlinedInputSectionsContainer = (0, $8xDHs.styled)($f9pWD.PickersInputBaseSectionsContainer, {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $20d706e29be2fff2$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $20d706e29be2fff2$var$_composeClasses.default)(slots, $1lpfw.getPickersOutlinedInputUtilityClass, classes);
    return (0, $20d706e29be2fff2$var$_extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $20d706e29be2fff2$var$PickersOutlinedInput = module.exports.PickersOutlinedInput = /*#__PURE__*/ $20d706e29be2fff2$var$React.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, classes: classesProp, notched: notched } = props, other = (0, $20d706e29be2fff2$var$_objectWithoutPropertiesLoose2.default)(props, $20d706e29be2fff2$var$_excluded);
    const muiFormControl = (0, $iA4iQ.useFormControl)();
    const classes = $20d706e29be2fff2$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($id0az.PickersInputBase, (0, $20d706e29be2fff2$var$_extends2.default)({
        slots: {
            root: $20d706e29be2fff2$var$PickersOutlinedInputRoot,
            input: $20d706e29be2fff2$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($20d706e29be2fff2$var$_Outline.default, {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($20d706e29be2fff2$var$React.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$20d706e29be2fff2$var$PickersOutlinedInput.muiName = 'Input';

});
parcelRegister("1lpfw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0fab569a23858f12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersOutlinedInputUtilityClass = $0fab569a23858f12$var$getPickersOutlinedInputUtilityClass;
module.exports.pickersOutlinedInputClasses = void 0;

var $0fab569a23858f12$var$_extends2 = $0fab569a23858f12$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0fab569a23858f12$var$_generateUtilityClasses = $0fab569a23858f12$require$_interopRequireDefault((parcelRequire("5nY49")));

var $0fab569a23858f12$var$_generateUtilityClass = $0fab569a23858f12$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $id0az = parcelRequire("id0az");
function $0fab569a23858f12$var$getPickersOutlinedInputUtilityClass(slot) {
    return (0, $0fab569a23858f12$var$_generateUtilityClass.default)('MuiPickersOutlinedInput', slot);
}
const $0fab569a23858f12$var$pickersOutlinedInputClasses = module.exports.pickersOutlinedInputClasses = (0, $0fab569a23858f12$var$_extends2.default)({}, $id0az.pickersInputBaseClasses, (0, $0fab569a23858f12$var$_generateUtilityClasses.default)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));

});
parcelRegister("id0az", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersInputBase", {
    enumerable: true,
    get: function() {
        return $f9pWD.PickersInputBase;
    }
});
Object.defineProperty(module.exports, "getPickersInputBaseUtilityClass", {
    enumerable: true,
    get: function() {
        return $acVM5.getPickersInputBaseUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersInputBaseClasses", {
    enumerable: true,
    get: function() {
        return $acVM5.pickersInputBaseClasses;
    }
});

var $f9pWD = parcelRequire("f9pWD");

var $acVM5 = parcelRequire("acVM5");

});
parcelRegister("f9pWD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b07bd25b455bc147$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b07bd25b455bc147$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersInputBaseSectionsContainer = module.exports.PickersInputBaseRoot = module.exports.PickersInputBase = void 0;

var $b07bd25b455bc147$var$_objectWithoutPropertiesLoose2 = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("c05no")));

var $b07bd25b455bc147$var$_extends2 = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b07bd25b455bc147$var$React = $b07bd25b455bc147$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b07bd25b455bc147$var$_propTypes = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $iA4iQ = parcelRequire("iA4iQ");

var $8xDHs = parcelRequire("8xDHs");

var $b07bd25b455bc147$var$_useForkRef = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $b07bd25b455bc147$var$_refType = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $b07bd25b455bc147$var$_composeClasses = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $b07bd25b455bc147$var$_capitalize = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("4O6za")));

var $b07bd25b455bc147$var$_useSlotProps = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("839K0")));

var $b07bd25b455bc147$var$_visuallyHidden = $b07bd25b455bc147$require$_interopRequireDefault((parcelRequire("1YYSs")));

var $acVM5 = parcelRequire("acVM5");

var $c07gn = parcelRequire("c07gn");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $b07bd25b455bc147$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
];
const $b07bd25b455bc147$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $b07bd25b455bc147$var$PickersInputBaseRoot = module.exports.PickersInputBaseRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme: theme })=>(0, $b07bd25b455bc147$var$_extends2.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$b07bd25b455bc147$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionsContainer = module.exports.PickersInputBaseSectionsContainer = (0, $8xDHs.styled)($c07gn.Unstable_PickersSectionListRoot, {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    justifyContent: 'end'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: false
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: true,
                    isLabelShrunk: true
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const $b07bd25b455bc147$var$PickersInputBaseSection = (0, $8xDHs.styled)($c07gn.Unstable_PickersSectionListSection, {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionContent = (0, $8xDHs.styled)($c07gn.Unstable_PickersSectionListSectionContent, {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionSeparator = (0, $8xDHs.styled)($c07gn.Unstable_PickersSectionListSectionSeparator, {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $b07bd25b455bc147$var$PickersInputBaseInput = (0, $8xDHs.styled)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, $b07bd25b455bc147$var$_extends2.default)({}, $b07bd25b455bc147$var$_visuallyHidden.default));
const $b07bd25b455bc147$var$PickersInputBaseActiveBar = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const $b07bd25b455bc147$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldReadOnly: isFieldReadOnly, hasFieldError: hasFieldError, inputSize: inputSize, isInputInFullWidth: isInputInFullWidth, inputColor: inputColor, hasStartAdornment: hasStartAdornment, hasEndAdornment: hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, $b07bd25b455bc147$var$_capitalize.default)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, $b07bd25b455bc147$var$_composeClasses.default)(slots, $acVM5.getPickersInputBaseUtilityClass, classes);
};
function $b07bd25b455bc147$var$resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    if (sectionElement.content.id) {
        const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function $b07bd25b455bc147$var$resolveSectionWidthAndOffsets(elements, rootRef) {
    let activeBarWidth = 0;
    const activeRangePosition = rootRef.current?.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += $b07bd25b455bc147$var$resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += $b07bd25b455bc147$var$resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth: activeBarWidth,
        sectionOffsets: [
            rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0,
            rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const $b07bd25b455bc147$var$PickersInputBase = module.exports.PickersInputBase = /*#__PURE__*/ $b07bd25b455bc147$var$React.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, onFocus: onFocus, onBlur: onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, $b07bd25b455bc147$var$_objectWithoutPropertiesLoose2.default)(props, $b07bd25b455bc147$var$_excluded);
    const ownerStateContext = (0, $8COFU.usePickerTextFieldOwnerState)();
    const rootRef = $b07bd25b455bc147$var$React.useRef(null);
    const activeBarRef = $b07bd25b455bc147$var$React.useRef(null);
    const sectionOffsetsRef = $b07bd25b455bc147$var$React.useRef([]);
    const handleRootRef = (0, $b07bd25b455bc147$var$_useForkRef.default)(ref, rootRef);
    const handleInputRef = (0, $b07bd25b455bc147$var$_useForkRef.default)(inputProps?.ref, inputRef);
    const muiFormControl = (0, $iA4iQ.useFormControl)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const ownerState = ownerStateProp ?? ownerStateContext;
    const handleInputFocus = (event)=>{
        muiFormControl.onFocus?.(event);
        onFocus?.(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            // Do nothing if it's a multi input field
            if (rootRef.current?.dataset.multiInput) return;
            const closestForm = rootRef.current?.closest('form');
            const submitTrigger = closestForm?.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        muiFormControl.onBlur?.(event);
        onBlur?.(event);
    };
    $b07bd25b455bc147$var$React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $b07bd25b455bc147$var$React.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = $b07bd25b455bc147$var$useUtilityClasses(classesProp, ownerState);
    const InputRoot = slots?.root || $b07bd25b455bc147$var$PickersInputBaseRoot;
    const inputRootProps = (0, $b07bd25b455bc147$var$_useSlotProps.default)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $b07bd25b455bc147$var$PickersInputBaseSectionsContainer;
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    $b07bd25b455bc147$var$React.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth: activeBarWidth, sectionOffsets: sectionOffsets } = $b07bd25b455bc147$var$resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(InputRoot, (0, $b07bd25b455bc147$var$_extends2.default)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $ayMG0.jsx)($c07gn.Unstable_PickersSectionList, {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $b07bd25b455bc147$var$PickersInputBaseSection,
                    sectionContent: $b07bd25b455bc147$var$PickersInputBaseSectionContent,
                    sectionSeparator: $b07bd25b455bc147$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, $b07bd25b455bc147$var$_extends2.default)({}, slotProps?.input, {
                        ownerState: ownerState
                    }),
                    sectionContent: {
                        className: $acVM5.pickersInputBaseClasses.sectionContent
                    },
                    sectionSeparator: ({ separatorPosition: separatorPosition })=>({
                            className: separatorPosition === 'before' ? $acVM5.pickersInputBaseClasses.sectionBefore : $acVM5.pickersInputBaseClasses.sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $b07bd25b455bc147$var$_extends2.default)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($b07bd25b455bc147$var$PickersInputBaseInput, (0, $b07bd25b455bc147$var$_extends2.default)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, inputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, $ayMG0.jsx)($b07bd25b455bc147$var$PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});

});
parcelRegister("acVM5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $76e7d735dfe68a88$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersInputBaseUtilityClass = $76e7d735dfe68a88$var$getPickersInputBaseUtilityClass;
module.exports.pickersInputBaseClasses = void 0;

var $76e7d735dfe68a88$var$_generateUtilityClass = $76e7d735dfe68a88$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $76e7d735dfe68a88$var$_generateUtilityClasses = $76e7d735dfe68a88$require$_interopRequireDefault((parcelRequire("5nY49")));
function $76e7d735dfe68a88$var$getPickersInputBaseUtilityClass(slot) {
    return (0, $76e7d735dfe68a88$var$_generateUtilityClass.default)('MuiPickersInputBase', slot);
}
const $76e7d735dfe68a88$var$pickersInputBaseClasses = module.exports.pickersInputBaseClasses = (0, $76e7d735dfe68a88$var$_generateUtilityClasses.default)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'inputSizeSmall',
    'activeBar'
]);

});

parcelRegister("c07gn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Unstable_PickersSectionList", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionList;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListRoot", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListRoot;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListSection", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListSection;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListSectionContent", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListSectionContent;
    }
});
Object.defineProperty(module.exports, "Unstable_PickersSectionListSectionSeparator", {
    enumerable: true,
    get: function() {
        return $8STD8.PickersSectionListSectionSeparator;
    }
});
Object.defineProperty(module.exports, "getPickersSectionListUtilityClass", {
    enumerable: true,
    get: function() {
        return $1v8a2.getPickersSectionListUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersSectionListClasses", {
    enumerable: true,
    get: function() {
        return $1v8a2.pickersSectionListClasses;
    }
});

var $8STD8 = parcelRequire("8STD8");

var $1v8a2 = parcelRequire("1v8a2");

});
parcelRegister("8STD8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $677e84dab89c4abd$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $677e84dab89c4abd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersSectionListSectionSeparator = module.exports.PickersSectionListSectionContent = module.exports.PickersSectionListSection = module.exports.PickersSectionListRoot = module.exports.PickersSectionList = void 0;

var $677e84dab89c4abd$var$_objectWithoutPropertiesLoose2 = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("c05no")));

var $677e84dab89c4abd$var$_extends2 = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $677e84dab89c4abd$var$React = $677e84dab89c4abd$require$_interopRequireWildcard((parcelRequire("acw62")));

var $677e84dab89c4abd$var$_propTypes = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $677e84dab89c4abd$var$_useSlotProps = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("839K0")));

var $677e84dab89c4abd$var$_composeClasses = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $677e84dab89c4abd$var$_useForkRef = $677e84dab89c4abd$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $8xDHs = parcelRequire("8xDHs");

var $1v8a2 = parcelRequire("1v8a2");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $677e84dab89c4abd$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const $677e84dab89c4abd$var$PickersSectionListRoot = module.exports.PickersSectionListRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $677e84dab89c4abd$var$PickersSectionListSection = module.exports.PickersSectionListSection = (0, $8xDHs.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const $677e84dab89c4abd$var$PickersSectionListSectionSeparator = module.exports.PickersSectionListSectionSeparator = (0, $8xDHs.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const $677e84dab89c4abd$var$PickersSectionListSectionContent = module.exports.PickersSectionListSectionContent = (0, $8xDHs.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const $677e84dab89c4abd$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $677e84dab89c4abd$var$_composeClasses.default)(slots, $1v8a2.getPickersSectionListUtilityClass, classes);
};
function $677e84dab89c4abd$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const Section = slots?.section ?? $677e84dab89c4abd$var$PickersSectionListSection;
    const sectionProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: ownerState
    });
    const SectionContent = slots?.sectionContent ?? $677e84dab89c4abd$var$PickersSectionListSectionContent;
    const sectionContentProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: ownerState
    });
    const SectionSeparator = slots?.sectionSeparator ?? $677e84dab89c4abd$var$PickersSectionListSectionSeparator;
    const sectionSeparatorBeforeProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, $677e84dab89c4abd$var$_extends2.default)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, $677e84dab89c4abd$var$_extends2.default)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    // Only propagate blur when focus leaves the SectionContent entirely.
    const sectionContentRef = $677e84dab89c4abd$var$React.useRef(null);
    const handleSectionContentRef = (0, $677e84dab89c4abd$var$_useForkRef.default)(sectionContentProps.ref, sectionContentRef);
    const handleContentBlur = (event)=>{
        const next = event.relatedTarget;
        // If the next focused element stays within the whole field (root),
        // do not propagate blur. We only want blur when leaving the field entirely.
        const root = event.currentTarget.closest(`.${$1v8a2.pickersSectionListClasses.root}`);
        if (root && next instanceof Node && root.contains(next)) {
            event.stopPropagation();
            return;
        }
    // Otherwise, focus left the whole field; allow propagation.
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Section, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionContent, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionContentProps, {
                ref: handleSectionContentRef,
                onBlur: handleContentBlur
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $677e84dab89c4abd$var$_extends2.default)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $677e84dab89c4abd$var$PickersSectionList = module.exports.PickersSectionList = /*#__PURE__*/ $677e84dab89c4abd$var$React.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef, classes: classesProp } = props, other = (0, $677e84dab89c4abd$var$_objectWithoutPropertiesLoose2.default)(props, $677e84dab89c4abd$var$_excluded);
    const classes = $677e84dab89c4abd$var$useUtilityClasses(classesProp);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const rootRef = $677e84dab89c4abd$var$React.useRef(null);
    const handleRootRef = (0, $677e84dab89c4abd$var$_useForkRef.default)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $677e84dab89c4abd$var$React.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${$1v8a2.pickersSectionListClasses.section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${$1v8a2.pickersSectionListClasses.section}[data-sectionindex="${index}"] .${$1v8a2.pickersSectionListClasses.sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains($1v8a2.pickersSectionListClasses.section)) sectionContainer = element;
                else if (element.classList.contains($1v8a2.pickersSectionListClasses.sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $677e84dab89c4abd$var$PickersSectionListRoot;
    const rootProps = (0, $677e84dab89c4abd$var$_useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $677e84dab89c4abd$var$_extends2.default)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $ayMG0.jsx)($677e84dab89c4abd$var$React.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($677e84dab89c4abd$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});

});
parcelRegister("1v8a2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $117f0443ae3d158a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersSectionListUtilityClass = $117f0443ae3d158a$var$getPickersSectionListUtilityClass;
module.exports.pickersSectionListClasses = void 0;

var $117f0443ae3d158a$var$_generateUtilityClass = $117f0443ae3d158a$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $117f0443ae3d158a$var$_generateUtilityClasses = $117f0443ae3d158a$require$_interopRequireDefault((parcelRequire("5nY49")));
function $117f0443ae3d158a$var$getPickersSectionListUtilityClass(slot) {
    return (0, $117f0443ae3d158a$var$_generateUtilityClass.default)('MuiPickersSectionList', slot);
}
const $117f0443ae3d158a$var$pickersSectionListClasses = module.exports.pickersSectionListClasses = (0, $117f0443ae3d158a$var$_generateUtilityClasses.default)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);

});



parcelRegister("8COFU", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $64792e4f229a7d73$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerTextFieldOwnerState = module.exports.PickerTextFieldOwnerStateContext = void 0;

var $64792e4f229a7d73$var$React = $64792e4f229a7d73$require$_interopRequireWildcard((parcelRequire("acw62")));
const $64792e4f229a7d73$var$PickerTextFieldOwnerStateContext = module.exports.PickerTextFieldOwnerStateContext = /*#__PURE__*/ $64792e4f229a7d73$var$React.createContext(null);
const $64792e4f229a7d73$var$usePickerTextFieldOwnerState = ()=>{
    const value = $64792e4f229a7d73$var$React.useContext($64792e4f229a7d73$var$PickerTextFieldOwnerStateContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component'
    ].join('\n'));
    return value;
};
module.exports.usePickerTextFieldOwnerState = $64792e4f229a7d73$var$usePickerTextFieldOwnerState;

});




parcelRegister("3f6Ua", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25c820f8a71a2e52$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $25c820f8a71a2e52$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25c820f8a71a2e52$var$Outline;

var $25c820f8a71a2e52$var$_extends2 = $25c820f8a71a2e52$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $25c820f8a71a2e52$var$_objectWithoutPropertiesLoose2 = $25c820f8a71a2e52$require$_interopRequireDefault((parcelRequire("c05no")));

var $25c820f8a71a2e52$var$React = $25c820f8a71a2e52$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $bbeCr = parcelRequire("bbeCr");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $25c820f8a71a2e52$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $25c820f8a71a2e52$var$OutlineRoot = (0, $8xDHs.styled)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $25c820f8a71a2e52$var$OutlineLabel = (0, $8xDHs.styled)('span', {
    slot: 'internal',
    shouldForwardProp: undefined
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $25c820f8a71a2e52$var$OutlineLegend = (0, $8xDHs.styled)('legend', {
    slot: 'internal',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'notched'
})(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function $25c820f8a71a2e52$var$Outline(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $25c820f8a71a2e52$var$_objectWithoutPropertiesLoose2.default)(props, $25c820f8a71a2e52$var$_excluded);
    const ownerState = (0, $8COFU.usePickerTextFieldOwnerState)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineRoot, (0, $25c820f8a71a2e52$var$_extends2.default)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}

});



parcelRegister("2CiZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersFilledInput", {
    enumerable: true,
    get: function() {
        return $6dR0p.PickersFilledInput;
    }
});
Object.defineProperty(module.exports, "getPickersFilledInputUtilityClass", {
    enumerable: true,
    get: function() {
        return $gapTW.getPickersFilledInputUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersFilledInputClasses", {
    enumerable: true,
    get: function() {
        return $gapTW.pickersFilledInputClasses;
    }
});

var $6dR0p = parcelRequire("6dR0p");

var $gapTW = parcelRequire("gapTW");

});
parcelRegister("6dR0p", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $487d12cb311e9418$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $487d12cb311e9418$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersFilledInput = void 0;

var $487d12cb311e9418$var$_objectWithoutPropertiesLoose2 = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("c05no")));

var $487d12cb311e9418$var$_extends2 = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $487d12cb311e9418$var$React = $487d12cb311e9418$require$_interopRequireWildcard((parcelRequire("acw62")));

var $487d12cb311e9418$var$_propTypes = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $izOUK = parcelRequire("izOUK");

var $487d12cb311e9418$var$_refType = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $487d12cb311e9418$var$_composeClasses = $487d12cb311e9418$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $gapTW = parcelRequire("gapTW");

var $id0az = parcelRequire("id0az");

var $f9pWD = parcelRequire("f9pWD");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $487d12cb311e9418$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes"
];
const $487d12cb311e9418$var$PickersFilledInputRoot = (0, $8xDHs.styled)($f9pWD.PickersInputBaseRoot, {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $izOUK.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${$gapTW.pickersFilledInputClasses.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${$gapTW.pickersFilledInputClasses.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$gapTW.pickersFilledInputClasses.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$gapTW.pickersFilledInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$gapTW.pickersFilledInputClasses.disabled}, .${$gapTW.pickersFilledInputClasses.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${$gapTW.pickersFilledInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $487d12cb311e9418$var$PickersFilledSectionsContainer = (0, $8xDHs.styled)($f9pWD.PickersInputBaseSectionsContainer, {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, $izOUK.shouldForwardProp)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $487d12cb311e9418$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $487d12cb311e9418$var$_composeClasses.default)(slots, $gapTW.getPickersFilledInputUtilityClass, classes);
    return (0, $487d12cb311e9418$var$_extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $487d12cb311e9418$var$PickersFilledInput = module.exports.PickersFilledInput = /*#__PURE__*/ $487d12cb311e9418$var$React.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, hiddenLabel: hiddenLabel = false, classes: classesProp } = props, other = (0, $487d12cb311e9418$var$_objectWithoutPropertiesLoose2.default)(props, $487d12cb311e9418$var$_excluded);
    const pickerTextFieldOwnerState = (0, $8COFU.usePickerTextFieldOwnerState)();
    const ownerState = (0, $487d12cb311e9418$var$_extends2.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $487d12cb311e9418$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($id0az.PickersInputBase, (0, $487d12cb311e9418$var$_extends2.default)({
        slots: {
            root: $487d12cb311e9418$var$PickersFilledInputRoot,
            input: $487d12cb311e9418$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            },
            input: {
                hiddenLabel: hiddenLabel
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
$487d12cb311e9418$var$PickersFilledInput.muiName = 'Input';

});
parcelRegister("gapTW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bc51abfce30b7e59$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersFilledInputUtilityClass = $bc51abfce30b7e59$var$getPickersFilledInputUtilityClass;
module.exports.pickersFilledInputClasses = void 0;

var $bc51abfce30b7e59$var$_extends2 = $bc51abfce30b7e59$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bc51abfce30b7e59$var$_generateUtilityClasses = $bc51abfce30b7e59$require$_interopRequireDefault((parcelRequire("5nY49")));

var $bc51abfce30b7e59$var$_generateUtilityClass = $bc51abfce30b7e59$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $id0az = parcelRequire("id0az");
function $bc51abfce30b7e59$var$getPickersFilledInputUtilityClass(slot) {
    return (0, $bc51abfce30b7e59$var$_generateUtilityClass.default)('MuiPickersFilledInput', slot);
}
const $bc51abfce30b7e59$var$pickersFilledInputClasses = module.exports.pickersFilledInputClasses = (0, $bc51abfce30b7e59$var$_extends2.default)({}, $id0az.pickersInputBaseClasses, (0, $bc51abfce30b7e59$var$_generateUtilityClasses.default)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));

});



parcelRegister("aaK30", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersInput", {
    enumerable: true,
    get: function() {
        return $e5z90.PickersInput;
    }
});
Object.defineProperty(module.exports, "getPickersInputUtilityClass", {
    enumerable: true,
    get: function() {
        return $5dqa3.getPickersInputUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersInputClasses", {
    enumerable: true,
    get: function() {
        return $5dqa3.pickersInputClasses;
    }
});

var $e5z90 = parcelRequire("e5z90");

var $5dqa3 = parcelRequire("5dqa3");

});
parcelRegister("e5z90", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a41ccb38ff41e328$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a41ccb38ff41e328$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersInput = void 0;

var $a41ccb38ff41e328$var$_objectWithoutPropertiesLoose2 = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("c05no")));

var $a41ccb38ff41e328$var$_extends2 = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a41ccb38ff41e328$var$React = $a41ccb38ff41e328$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a41ccb38ff41e328$var$_propTypes = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $bbeCr = parcelRequire("bbeCr");

var $a41ccb38ff41e328$var$_refType = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $a41ccb38ff41e328$var$_composeClasses = $a41ccb38ff41e328$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5dqa3 = parcelRequire("5dqa3");

var $id0az = parcelRequire("id0az");

var $f9pWD = parcelRequire("f9pWD");

var $8COFU = parcelRequire("8COFU");

var $ayMG0 = parcelRequire("ayMG0");
const $a41ccb38ff41e328$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes"
];
const $a41ccb38ff41e328$var$PickersInputRoot = (0, $8xDHs.styled)($f9pWD.PickersInputBaseRoot, {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        inputHasUnderline: true
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    inputHasUnderline: true
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${$5dqa3.pickersInputClasses.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${$5dqa3.pickersInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${$5dqa3.pickersInputClasses.disabled}, .${$5dqa3.pickersInputClasses.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${$5dqa3.pickersInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $a41ccb38ff41e328$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $a41ccb38ff41e328$var$_composeClasses.default)(slots, $5dqa3.getPickersInputUtilityClass, classes);
    return (0, $a41ccb38ff41e328$var$_extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $a41ccb38ff41e328$var$PickersInput = module.exports.PickersInput = /*#__PURE__*/ $a41ccb38ff41e328$var$React.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, classes: classesProp } = props, other = (0, $a41ccb38ff41e328$var$_objectWithoutPropertiesLoose2.default)(props, $a41ccb38ff41e328$var$_excluded);
    const pickerTextFieldOwnerState = (0, $8COFU.usePickerTextFieldOwnerState)();
    const ownerState = (0, $a41ccb38ff41e328$var$_extends2.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $a41ccb38ff41e328$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($id0az.PickersInputBase, (0, $a41ccb38ff41e328$var$_extends2.default)({
        slots: {
            root: $a41ccb38ff41e328$var$PickersInputRoot
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        ownerState: ownerState,
        label: label,
        classes: classes,
        ref: ref
    }));
});
$a41ccb38ff41e328$var$PickersInput.muiName = 'Input';

});
parcelRegister("5dqa3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3cc275b483512649$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersInputUtilityClass = $3cc275b483512649$var$getPickersInputUtilityClass;
module.exports.pickersInputClasses = void 0;

var $3cc275b483512649$var$_extends2 = $3cc275b483512649$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3cc275b483512649$var$_generateUtilityClasses = $3cc275b483512649$require$_interopRequireDefault((parcelRequire("5nY49")));

var $3cc275b483512649$var$_generateUtilityClass = $3cc275b483512649$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $id0az = parcelRequire("id0az");
function $3cc275b483512649$var$getPickersInputUtilityClass(slot) {
    return (0, $3cc275b483512649$var$_generateUtilityClass.default)('MuiPickersFilledInput', slot);
}
const $3cc275b483512649$var$pickersInputClasses = module.exports.pickersInputClasses = (0, $3cc275b483512649$var$_extends2.default)({}, $id0az.pickersInputBaseClasses, (0, $3cc275b483512649$var$_generateUtilityClasses.default)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));

});








parcelRegister("jHZPa", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e591fd7cb660b8e1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e591fd7cb660b8e1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDateTimePickerDefaultizedProps = $e591fd7cb660b8e1$var$useDateTimePickerDefaultizedProps;

var $e591fd7cb660b8e1$var$_extends2 = $e591fd7cb660b8e1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e591fd7cb660b8e1$var$React = $e591fd7cb660b8e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $3nE24 = parcelRequire("3nE24");

var $dzkyd = parcelRequire("dzkyd");

var $gZb82 = parcelRequire("gZb82");

var $kqIjR = parcelRequire("kqIjR");

var $3eed6 = parcelRequire("3eed6");

var $2wsa0 = parcelRequire("2wsa0");
function $e591fd7cb660b8e1$var$useDateTimePickerDefaultizedProps(props, name) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const themeProps = (0, $8xDHs.useThemeProps)({
        props: props,
        name: name
    });
    const validationProps = (0, $2wsa0.useApplyDefaultValuesToDateTimeValidationProps)(themeProps);
    const ampm = themeProps.ampm ?? adapter.is12HourCycleInCurrentLocale();
    const localeText = $e591fd7cb660b8e1$var$React.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $e591fd7cb660b8e1$var$_extends2.default)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const { openTo: openTo, views: defaultViews } = (0, $kqIjR.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day',
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'day'
    });
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn, views: views, timeSteps: timeSteps } = (0, $3eed6.resolveTimeViewsResponse)({
        thresholdToRenderTimeInASingleColumn: themeProps.thresholdToRenderTimeInASingleColumn,
        ampm: ampm,
        timeSteps: themeProps.timeSteps,
        views: defaultViews
    });
    // Keep the original views for format calculation (before filtering)
    const viewsForFormatting = ampm ? [
        ...defaultViews,
        'meridiem'
    ] : defaultViews;
    return (0, $e591fd7cb660b8e1$var$_extends2.default)({}, themeProps, validationProps, {
        timeSteps: timeSteps,
        openTo: openTo,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        views: views,
        viewsForFormatting: viewsForFormatting,
        ampm: ampm,
        localeText: localeText,
        orientation: themeProps.orientation ?? 'portrait',
        slots: (0, $e591fd7cb660b8e1$var$_extends2.default)({
            toolbar: $gZb82.DateTimePickerToolbar,
            tabs: $dzkyd.DateTimePickerTabs
        }, themeProps.slots),
        slotProps: (0, $e591fd7cb660b8e1$var$_extends2.default)({}, themeProps.slotProps, {
            toolbar: (0, $e591fd7cb660b8e1$var$_extends2.default)({
                ampm: ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}

});
parcelRegister("dzkyd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9e0e7c3eb94e4e22$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9e0e7c3eb94e4e22$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimePickerTabs = void 0;

var $9e0e7c3eb94e4e22$var$React = $9e0e7c3eb94e4e22$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9e0e7c3eb94e4e22$var$_clsx = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9e0e7c3eb94e4e22$var$_propTypes = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9e0e7c3eb94e4e22$var$_Tab = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("90blG")));

var $9e0e7c3eb94e4e22$var$_Tabs = $9e0e7c3eb94e4e22$require$_interopRequireWildcard((parcelRequire("dKcJh")));

var $8xDHs = parcelRequire("8xDHs");

var $9e0e7c3eb94e4e22$var$_composeClasses = $9e0e7c3eb94e4e22$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $1SVAo = parcelRequire("1SVAo");

var $83GPg = parcelRequire("83GPg");

var $an26n = parcelRequire("an26n");

var $NRNex = parcelRequire("NRNex");

var $7OOd8 = parcelRequire("7OOd8");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $9e0e7c3eb94e4e22$var$viewToTab = (view)=>{
    if ((0, $NRNex.isDatePickerView)(view)) return 'date';
    return 'time';
};
const $9e0e7c3eb94e4e22$var$tabToView = (tab)=>{
    if (tab === 'date') return 'day';
    return 'hours';
};
const $9e0e7c3eb94e4e22$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $9e0e7c3eb94e4e22$var$_composeClasses.default)(slots, $an26n.getDateTimePickerTabsUtilityClass, classes);
};
const $9e0e7c3eb94e4e22$var$DateTimePickerTabsRoot = (0, $8xDHs.styled)($9e0e7c3eb94e4e22$var$_Tabs.default, {
    name: 'MuiDateTimePickerTabs',
    slot: 'Root'
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        '&:last-child': {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${$9e0e7c3eb94e4e22$var$_Tabs.tabsClasses.indicator}`]: {
                bottom: 'auto',
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const $9e0e7c3eb94e4e22$var$DateTimePickerTabs = module.exports.DateTimePickerTabs = function DateTimePickerTabs(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePickerTabs'
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($1SVAo.DateRangeIcon, {}), timeIcon: timeIcon = /*#__PURE__*/ (0, $ayMG0.jsx)($1SVAo.TimeIcon, {}), hidden: hidden = typeof window === 'undefined' || window.innerHeight < 667, className: className, classes: classesProp, sx: sx } = props;
    const translations = (0, $83GPg.usePickerTranslations)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const { view: view, setView: setView } = (0, $BKARN.usePickerContext)();
    const classes = $9e0e7c3eb94e4e22$var$useUtilityClasses(classesProp);
    const handleChange = (event, value)=>{
        setView($9e0e7c3eb94e4e22$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9e0e7c3eb94e4e22$var$DateTimePickerTabsRoot, {
        ownerState: ownerState,
        variant: "fullWidth",
        value: $9e0e7c3eb94e4e22$var$viewToTab(view),
        onChange: handleChange,
        className: (0, $9e0e7c3eb94e4e22$var$_clsx.default)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$_Tab.default, {
                value: "date",
                "aria-label": translations.dateTableLabel,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$React.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$_Tab.default, {
                value: "time",
                "aria-label": translations.timeTableLabel,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($9e0e7c3eb94e4e22$var$React.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};

});
parcelRegister("an26n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $78cdaec54bb38039$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateTimePickerTabsClasses = void 0;
module.exports.getDateTimePickerTabsUtilityClass = $78cdaec54bb38039$var$getDateTimePickerTabsUtilityClass;

var $78cdaec54bb38039$var$_generateUtilityClass = $78cdaec54bb38039$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $78cdaec54bb38039$var$_generateUtilityClasses = $78cdaec54bb38039$require$_interopRequireDefault((parcelRequire("5nY49")));
function $78cdaec54bb38039$var$getDateTimePickerTabsUtilityClass(slot) {
    return (0, $78cdaec54bb38039$var$_generateUtilityClass.default)('MuiDateTimePickerTabs', slot);
}
const $78cdaec54bb38039$var$dateTimePickerTabsClasses = module.exports.dateTimePickerTabsClasses = (0, $78cdaec54bb38039$var$_generateUtilityClasses.default)('MuiDateTimePickerTabs', [
    'root'
]);

});


parcelRegister("gZb82", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c5daf9c8f6912bf3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c5daf9c8f6912bf3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTimePickerToolbar = $c5daf9c8f6912bf3$var$DateTimePickerToolbar;
module.exports.DateTimePickerToolbarOverrideContext = void 0;

var $c5daf9c8f6912bf3$var$_extends2 = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c5daf9c8f6912bf3$var$_objectWithoutPropertiesLoose2 = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("c05no")));

var $c5daf9c8f6912bf3$var$React = $c5daf9c8f6912bf3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c5daf9c8f6912bf3$var$_clsx = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c5daf9c8f6912bf3$var$_propTypes = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $c5daf9c8f6912bf3$var$_composeClasses = $c5daf9c8f6912bf3$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bbeCr = parcelRequire("bbeCr");

var $oSSgR = parcelRequire("oSSgR");

var $1YoVy = parcelRequire("1YoVy");

var $8RLZv = parcelRequire("8RLZv");

var $BKARN = parcelRequire("BKARN");

var $frSrH = parcelRequire("frSrH");

var $lfVfV = parcelRequire("lfVfV");

var $99eO4 = parcelRequire("99eO4");

var $NRNex = parcelRequire("NRNex");

var $lCT63 = parcelRequire("lCT63");

var $igERR = parcelRequire("igERR");

var $6DVo4 = parcelRequire("6DVo4");

var $1IRkN = parcelRequire("1IRkN");

var $ayMG0 = parcelRequire("ayMG0");
const $c5daf9c8f6912bf3$var$_excluded = [
    "ampm",
    "ampmInClock",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "className",
    "classes"
];
const $c5daf9c8f6912bf3$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation, toolbarDirection: toolbarDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        dateContainer: [
            'dateContainer'
        ],
        timeContainer: [
            'timeContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        timeDigitsContainer: [
            'timeDigitsContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        separator: [
            'separator'
        ],
        ampmSelection: [
            'ampmSelection',
            pickerOrientation === 'landscape' && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, $c5daf9c8f6912bf3$var$_composeClasses.default)(slots, $frSrH.getDateTimePickerToolbarUtilityClass, classes);
};
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarRoot = (0, $8xDHs.styled)($1YoVy.PickersToolbar, {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})(({ theme: theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'space-around',
        position: 'relative',
        variants: [
            {
                props: {
                    toolbarVariant: 'desktop'
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${$igERR.pickersToolbarClasses.content} .${$lCT63.pickersToolbarTextClasses.root}[data-selected]`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'landscape'
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'portrait'
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarDateContainer = (0, $8xDHs.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'DateContainer'
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
});
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeContainer = (0, $8xDHs.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeContainer',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    flexDirection: 'row',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop',
                pickerOrientation: 'portrait'
            },
            style: {
                gap: 9,
                marginRight: 4,
                alignSelf: 'flex-end'
            }
        },
        {
            props: ({ pickerOrientation: pickerOrientation, toolbarVariant: toolbarVariant })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop',
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ pickerOrientation: pickerOrientation, toolbarVariant: toolbarVariant, toolbarDirection: toolbarDirection })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop' && toolbarDirection === 'rtl',
            style: {
                flexDirection: 'column-reverse'
            }
        }
    ]
});
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeDigitsContainer = (0, $8xDHs.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeDigitsContainer',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                gap: 1.5
            }
        }
    ]
});
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarSeparator = (0, $8xDHs.styled)($oSSgR.PickersToolbarText, {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Separator',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    margin: '0 4px 0 2px',
    cursor: 'default',
    variants: [
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const $c5daf9c8f6912bf3$var$DateTimePickerToolbarAmPmSelection = (0, $8xDHs.styled)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${$frSrH.dateTimePickerToolbarClasses.ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${$frSrH.dateTimePickerToolbarClasses.ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12,
    [`& .${$frSrH.dateTimePickerToolbarClasses.ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: '4px 0 auto',
                flexDirection: 'row',
                justifyContent: 'space-around',
                width: '100%'
            }
        }
    ]
});
/**
 * If `forceDesktopVariant` is set to `true`, the toolbar will always be rendered in the desktop mode.
 * If `onViewChange` is defined, the toolbar will call it instead of calling the default handler from `usePickerContext`.
 * This is used by the Date Time Range Picker Toolbar.
 */ const $c5daf9c8f6912bf3$var$DateTimePickerToolbarOverrideContext = module.exports.DateTimePickerToolbarOverrideContext = /*#__PURE__*/ $c5daf9c8f6912bf3$var$React.createContext(null);
function $c5daf9c8f6912bf3$var$DateTimePickerToolbar(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiDateTimePickerToolbar'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", toolbarTitle: inToolbarTitle, className: className, classes: classesProp } = props, other = (0, $c5daf9c8f6912bf3$var$_objectWithoutPropertiesLoose2.default)(props, $c5daf9c8f6912bf3$var$_excluded);
    const { value: valueContext, setValue: setValueContext, disabled: disabled, readOnly: readOnly, variant: variant, orientation: orientation, view: viewContext, setView: setViewContext, views: views } = (0, $6DVo4.usePickerContext)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const ownerState = (0, $1IRkN.useToolbarOwnerState)();
    const classes = $c5daf9c8f6912bf3$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $BKARN.usePickerAdapter)();
    const overrides = $c5daf9c8f6912bf3$var$React.useContext($c5daf9c8f6912bf3$var$DateTimePickerToolbarOverrideContext);
    const value = overrides ? overrides.value : valueContext;
    const setValue = overrides ? overrides.setValue : setValueContext;
    const view = overrides ? overrides.view : viewContext;
    const setView = overrides ? overrides.setView : setViewContext;
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $lfVfV.useMeridiemMode)(value, ampm, (newValue)=>setValue(newValue, {
            changeImportance: 'set',
            source: 'view'
        }));
    const toolbarVariant = overrides?.forceDesktopVariant ? 'desktop' : variant;
    const isDesktop = toolbarVariant === 'desktop';
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const toolbarTitle = inToolbarTitle ?? translations.dateTimePickerToolbarTitle;
    const dateText = $c5daf9c8f6912bf3$var$React.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        if (toolbarFormat) return adapter.formatByString(value, toolbarFormat);
        return adapter.format(value, 'shortDate');
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter
    ]);
    const formatSection = (format, fallback)=>{
        if (!adapter.isValid(value)) return fallback;
        return adapter.format(value, format);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarRoot, (0, $c5daf9c8f6912bf3$var$_extends2.default)({
        className: (0, $c5daf9c8f6912bf3$var$_clsx.default)(classes.root, className),
        toolbarTitle: toolbarTitle,
        toolbarVariant: toolbarVariant
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes('year') && /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>setView('year'),
                        selected: view === 'year',
                        value: formatSection('year', "\u2013")
                    }),
                    views.includes('day') && /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                        tabIndex: -1,
                        variant: isDesktop ? 'h5' : 'h4',
                        onClick: ()=>setView('day'),
                        selected: view === 'day',
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                toolbarVariant: toolbarVariant,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        toolbarVariant: toolbarVariant,
                        children: [
                            views.includes('hours') && /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$React.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH : undefined,
                                        onClick: ()=>setView('hours'),
                                        selected: view === 'hours',
                                        value: formatSection(ampm ? 'hours12h' : 'hours24h', '--')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c5daf9c8f6912bf3$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH : undefined,
                                        onClick: ()=>setView('minutes'),
                                        selected: view === 'minutes' || !views.includes('minutes') && view === 'hours',
                                        value: formatSection('minutes', '--'),
                                        disabled: !views.includes('minutes')
                                    })
                                ]
                            }),
                            views.includes('seconds') && /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$React.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c5daf9c8f6912bf3$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH : undefined,
                                        onClick: ()=>setView('seconds'),
                                        selected: view === 'seconds',
                                        value: formatSection('seconds', '--')
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $ayMG0.jsxs)($c5daf9c8f6912bf3$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                variant: "subtitle2",
                                selected: meridiemMode === 'am',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $NRNex.formatMeridiem)(adapter, 'am'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                                variant: "subtitle2",
                                selected: meridiemMode === 'pm',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $NRNex.formatMeridiem)(adapter, 'pm'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $ayMG0.jsx)($8RLZv.PickersToolbarButton, {
                        variant: "h5",
                        onClick: ()=>setView('meridiem'),
                        selected: view === 'meridiem',
                        value: value && meridiemMode ? (0, $NRNex.formatMeridiem)(adapter, meridiemMode) : '--',
                        width: $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH
                    })
                ]
            })
        ]
    }));
}

});
parcelRegister("oSSgR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $04accee7e7bec8c5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $04accee7e7bec8c5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersToolbarText = void 0;

var $04accee7e7bec8c5$var$_extends2 = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $04accee7e7bec8c5$var$_objectWithoutPropertiesLoose2 = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("c05no")));

var $04accee7e7bec8c5$var$React = $04accee7e7bec8c5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $04accee7e7bec8c5$var$_clsx = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("9QePP")));

var $04accee7e7bec8c5$var$_Typography = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $8xDHs = parcelRequire("8xDHs");

var $04accee7e7bec8c5$var$_composeClasses = $04accee7e7bec8c5$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $lCT63 = parcelRequire("lCT63");

var $ayMG0 = parcelRequire("ayMG0");
const $04accee7e7bec8c5$var$_excluded = [
    "className",
    "classes",
    "selected",
    "value"
];
const $04accee7e7bec8c5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $04accee7e7bec8c5$var$_composeClasses.default)(slots, $lCT63.getPickersToolbarTextUtilityClass, classes);
};
const $04accee7e7bec8c5$var$PickersToolbarTextRoot = (0, $8xDHs.styled)($04accee7e7bec8c5$var$_Typography.default, {
    name: 'MuiPickersToolbarText',
    slot: 'Root'
})(({ theme: theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&[data-selected]`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $04accee7e7bec8c5$var$PickersToolbarText = module.exports.PickersToolbarText = /*#__PURE__*/ $04accee7e7bec8c5$var$React.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className: className, classes: classesProp, selected: selected, value: value } = props, other = (0, $04accee7e7bec8c5$var$_objectWithoutPropertiesLoose2.default)(props, $04accee7e7bec8c5$var$_excluded);
    const classes = $04accee7e7bec8c5$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($04accee7e7bec8c5$var$PickersToolbarTextRoot, (0, $04accee7e7bec8c5$var$_extends2.default)({
        ref: ref,
        className: (0, $04accee7e7bec8c5$var$_clsx.default)(classes.root, className),
        component: "span",
        ownerState: props
    }, selected && {
        'data-selected': true
    }, other, {
        children: value
    }));
});

});
parcelRegister("lCT63", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fbe7e2a463bd8c2a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersToolbarTextUtilityClass = $fbe7e2a463bd8c2a$var$getPickersToolbarTextUtilityClass;
module.exports.pickersToolbarTextClasses = void 0;

var $fbe7e2a463bd8c2a$var$_generateUtilityClass = $fbe7e2a463bd8c2a$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $fbe7e2a463bd8c2a$var$_generateUtilityClasses = $fbe7e2a463bd8c2a$require$_interopRequireDefault((parcelRequire("5nY49")));
function $fbe7e2a463bd8c2a$var$getPickersToolbarTextUtilityClass(slot) {
    return (0, $fbe7e2a463bd8c2a$var$_generateUtilityClass.default)('MuiPickersToolbarText', slot);
}
const $fbe7e2a463bd8c2a$var$pickersToolbarTextClasses = module.exports.pickersToolbarTextClasses = (0, $fbe7e2a463bd8c2a$var$_generateUtilityClasses.default)('MuiPickersToolbarText', [
    'root'
]);

});


parcelRegister("1YoVy", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $16febb16e5b74478$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $16febb16e5b74478$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersToolbar = void 0;

var $16febb16e5b74478$var$_extends2 = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $16febb16e5b74478$var$_objectWithoutPropertiesLoose2 = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("c05no")));

var $16febb16e5b74478$var$React = $16febb16e5b74478$require$_interopRequireWildcard((parcelRequire("acw62")));

var $16febb16e5b74478$var$_clsx = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("9QePP")));

var $16febb16e5b74478$var$_Typography = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $8xDHs = parcelRequire("8xDHs");

var $16febb16e5b74478$var$_composeClasses = $16febb16e5b74478$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $bbeCr = parcelRequire("bbeCr");

var $igERR = parcelRequire("igERR");

var $1IRkN = parcelRequire("1IRkN");

var $ayMG0 = parcelRequire("ayMG0");
const $16febb16e5b74478$var$_excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const $16febb16e5b74478$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, $16febb16e5b74478$var$_composeClasses.default)(slots, $igERR.getPickersToolbarUtilityClass, classes);
};
const $16febb16e5b74478$var$PickersToolbarRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $16febb16e5b74478$var$PickersToolbarContent = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $16febb16e5b74478$var$PickersToolbar = module.exports.PickersToolbar = /*#__PURE__*/ $16febb16e5b74478$var$React.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, classes: classesProp, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId, landscapeDirection: landscapeDirection } = props, other = (0, $16febb16e5b74478$var$_objectWithoutPropertiesLoose2.default)(props, $16febb16e5b74478$var$_excluded);
    const ownerState = (0, $1IRkN.useToolbarOwnerState)();
    const classes = $16febb16e5b74478$var$useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($16febb16e5b74478$var$PickersToolbarRoot, (0, $16febb16e5b74478$var$_extends2.default)({
        ref: ref,
        className: (0, $16febb16e5b74478$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($16febb16e5b74478$var$_Typography.default, {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                className: classes.title,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($16febb16e5b74478$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});

});
parcelRegister("igERR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d4c96c197d3f31f2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersToolbarUtilityClass = $d4c96c197d3f31f2$var$getPickersToolbarUtilityClass;
module.exports.pickersToolbarClasses = void 0;

var $d4c96c197d3f31f2$var$_generateUtilityClass = $d4c96c197d3f31f2$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $d4c96c197d3f31f2$var$_generateUtilityClasses = $d4c96c197d3f31f2$require$_interopRequireDefault((parcelRequire("5nY49")));
function $d4c96c197d3f31f2$var$getPickersToolbarUtilityClass(slot) {
    return (0, $d4c96c197d3f31f2$var$_generateUtilityClass.default)('MuiPickersToolbar', slot);
}
const $d4c96c197d3f31f2$var$pickersToolbarClasses = module.exports.pickersToolbarClasses = (0, $d4c96c197d3f31f2$var$_generateUtilityClasses.default)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);

});

parcelRegister("1IRkN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $14134597d325236b$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $14134597d325236b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useToolbarOwnerState = $14134597d325236b$var$useToolbarOwnerState;

var $14134597d325236b$var$_extends2 = $14134597d325236b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $14134597d325236b$var$React = $14134597d325236b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9uEev = parcelRequire("9uEev");

var $7OOd8 = parcelRequire("7OOd8");
function $14134597d325236b$var$useToolbarOwnerState() {
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const isRtl = (0, $9uEev.useRtl)();
    return $14134597d325236b$var$React.useMemo(()=>(0, $14134597d325236b$var$_extends2.default)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}

});


parcelRegister("8RLZv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $67487ff97c20054e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $67487ff97c20054e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersToolbarButton = void 0;

var $67487ff97c20054e$var$_extends2 = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $67487ff97c20054e$var$_objectWithoutPropertiesLoose2 = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("c05no")));

var $67487ff97c20054e$var$React = $67487ff97c20054e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $67487ff97c20054e$var$_clsx = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("9QePP")));

var $67487ff97c20054e$var$_Button = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("bBQKz")));

var $8xDHs = parcelRequire("8xDHs");

var $67487ff97c20054e$var$_composeClasses = $67487ff97c20054e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $oSSgR = parcelRequire("oSSgR");

var $igERR = parcelRequire("igERR");

var $ayMG0 = parcelRequire("ayMG0");
const $67487ff97c20054e$var$_excluded = [
    "align",
    "className",
    "classes",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $67487ff97c20054e$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $67487ff97c20054e$var$_composeClasses.default)(slots, $igERR.getPickersToolbarUtilityClass, classes);
};
const $67487ff97c20054e$var$PickersToolbarButtonRoot = (0, $8xDHs.styled)($67487ff97c20054e$var$_Button.default, {
    name: 'MuiPickersToolbarButton',
    slot: 'Root'
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const $67487ff97c20054e$var$PickersToolbarButton = module.exports.PickersToolbarButton = /*#__PURE__*/ $67487ff97c20054e$var$React.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align: align, className: className, classes: classesProp, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $67487ff97c20054e$var$_objectWithoutPropertiesLoose2.default)(props, $67487ff97c20054e$var$_excluded);
    const classes = $67487ff97c20054e$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($67487ff97c20054e$var$PickersToolbarButtonRoot, (0, $67487ff97c20054e$var$_extends2.default)({
        variant: "text",
        ref: ref,
        className: (0, $67487ff97c20054e$var$_clsx.default)(classes.root, className),
        ownerState: props
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($oSSgR.PickersToolbarText, {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

});

parcelRegister("frSrH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b3f39c6baf320405$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dateTimePickerToolbarClasses = void 0;
module.exports.getDateTimePickerToolbarUtilityClass = $b3f39c6baf320405$var$getDateTimePickerToolbarUtilityClass;

var $b3f39c6baf320405$var$_generateUtilityClass = $b3f39c6baf320405$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $b3f39c6baf320405$var$_generateUtilityClasses = $b3f39c6baf320405$require$_interopRequireDefault((parcelRequire("5nY49")));
function $b3f39c6baf320405$var$getDateTimePickerToolbarUtilityClass(slot) {
    return (0, $b3f39c6baf320405$var$_generateUtilityClass.default)('MuiDateTimePickerToolbar', slot);
}
const $b3f39c6baf320405$var$dateTimePickerToolbarClasses = module.exports.dateTimePickerToolbarClasses = (0, $b3f39c6baf320405$var$_generateUtilityClasses.default)('MuiDateTimePickerToolbar', [
    'root',
    'dateContainer',
    'timeContainer',
    'timeDigitsContainer',
    'separator',
    'timeLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);

});

parcelRegister("lfVfV", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f797697c3611afd3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMeridiemMode = $f797697c3611afd3$var$useMeridiemMode;
module.exports.useNextMonthDisabled = $f797697c3611afd3$var$useNextMonthDisabled;
module.exports.usePreviousMonthDisabled = $f797697c3611afd3$var$usePreviousMonthDisabled;

var $f797697c3611afd3$var$React = $f797697c3611afd3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $cElCc = parcelRequire("cElCc");

var $3nE24 = parcelRequire("3nE24");
function $f797697c3611afd3$var$useNextMonthDisabled(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    return $f797697c3611afd3$var$React.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        return !adapter.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        adapter,
        timezone
    ]);
}
function $f797697c3611afd3$var$usePreviousMonthDisabled(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    return $f797697c3611afd3$var$React.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        return !adapter.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        adapter,
        timezone
    ]);
}
function $f797697c3611afd3$var$useMeridiemMode(date, ampm, onChange, selectionState) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const cleanDate = $f797697c3611afd3$var$React.useMemo(()=>!adapter.isValid(date) ? null : date, [
        adapter,
        date
    ]);
    const meridiemMode = (0, $cElCc.getMeridiem)(cleanDate, adapter);
    const handleMeridiemChange = $f797697c3611afd3$var$React.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, $cElCc.convertToMeridiem)(cleanDate, mode, Boolean(ampm), adapter);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        adapter
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}

});

parcelRegister("99eO4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VIEW_HEIGHT = module.exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = module.exports.MAX_CALENDAR_HEIGHT = module.exports.DIGITAL_CLOCK_VIEW_HEIGHT = module.exports.DIALOG_WIDTH = module.exports.DAY_SIZE = module.exports.DAY_MARGIN = void 0;
const $6a907094a8780175$var$DAY_SIZE = module.exports.DAY_SIZE = 36;
const $6a907094a8780175$var$DAY_MARGIN = module.exports.DAY_MARGIN = 2;
const $6a907094a8780175$var$DIALOG_WIDTH = module.exports.DIALOG_WIDTH = 320;
const $6a907094a8780175$var$MAX_CALENDAR_HEIGHT = module.exports.MAX_CALENDAR_HEIGHT = 280;
const $6a907094a8780175$var$VIEW_HEIGHT = module.exports.VIEW_HEIGHT = 336;
const $6a907094a8780175$var$DIGITAL_CLOCK_VIEW_HEIGHT = module.exports.DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const $6a907094a8780175$var$MULTI_SECTION_CLOCK_SECTION_WIDTH = module.exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;

});


parcelRegister("3eed6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $259db3c2f1b14ed0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDateTimeFormat = void 0;
module.exports.resolveTimeViewsResponse = $259db3c2f1b14ed0$var$resolveTimeViewsResponse;

var $259db3c2f1b14ed0$var$_extends2 = $259db3c2f1b14ed0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $259db3c2f1b14ed0$var$_objectWithoutPropertiesLoose2 = $259db3c2f1b14ed0$require$_interopRequireDefault((parcelRequire("c05no")));

var $cElCc = parcelRequire("cElCc");

var $NRNex = parcelRequire("NRNex");
const $259db3c2f1b14ed0$var$_excluded = [
    "views",
    "format"
];
const $259db3c2f1b14ed0$var$resolveDateTimeFormat = (adapter, _ref, ignoreDateResolving)=>{
    let { views: views, format: format } = _ref, other = (0, $259db3c2f1b14ed0$var$_objectWithoutPropertiesLoose2.default)(_ref, $259db3c2f1b14ed0$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $cElCc.isTimeView)(view)) timeViews.push(view);
        else if ((0, $NRNex.isDatePickerView)(view)) dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $NRNex.resolveDateFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $cElCc.resolveTimeFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, $cElCc.resolveTimeFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: timeViews
    }, other));
    const dateFormat = ignoreDateResolving ? adapter.formats.keyboardDate : (0, $NRNex.resolveDateFormat)(adapter, (0, $259db3c2f1b14ed0$var$_extends2.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
module.exports.resolveDateTimeFormat = $259db3c2f1b14ed0$var$resolveDateTimeFormat;
const $259db3c2f1b14ed0$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $cElCc.isInternalTimeView)(view) || view === 'hours');
    return ampm ? [
        ...views,
        'meridiem'
    ] : views;
};
const $259db3c2f1b14ed0$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function $259db3c2f1b14ed0$var$resolveTimeViewsResponse({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, $259db3c2f1b14ed0$var$_extends2.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $259db3c2f1b14ed0$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $259db3c2f1b14ed0$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}

});


parcelRegister("cLPus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useMobilePicker", {
    enumerable: true,
    get: function() {
        return $7a3Ek.useMobilePicker;
    }
});

var $7a3Ek = parcelRequire("7a3Ek");

});
parcelRegister("7a3Ek", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $536c4c4d895120f2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMobilePicker = void 0;

var $536c4c4d895120f2$var$_extends2 = $536c4c4d895120f2$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $536c4c4d895120f2$var$_objectWithoutPropertiesLoose2 = $536c4c4d895120f2$require$_interopRequireDefault((parcelRequire("c05no")));

var $536c4c4d895120f2$var$_useSlotProps2 = $536c4c4d895120f2$require$_interopRequireDefault((parcelRequire("839K0")));

var $fpltD = parcelRequire("fpltD");

var $hz59J = parcelRequire("hz59J");

var $g0CIC = parcelRequire("g0CIC");

var $jk6Bf = parcelRequire("jk6Bf");

var $a2Tw3 = parcelRequire("a2Tw3");

var $ayMG0 = parcelRequire("ayMG0");
const $536c4c4d895120f2$var$_excluded = [
    "props",
    "steps"
], $536c4c4d895120f2$var$_excluded2 = [
    "ownerState"
];
/**
 * Hook managing all the single-date mobile pickers:
 * - MobileDatePicker
 * - MobileDateTimePicker
 * - MobileTimePicker
 */ const $536c4c4d895120f2$var$useMobilePicker = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $536c4c4d895120f2$var$_objectWithoutPropertiesLoose2.default)(_ref, $536c4c4d895120f2$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $a2Tw3.createNonRangePickerStepNavigation)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $hz59J.usePicker)((0, $536c4c4d895120f2$var$_extends2.default)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $536c4c4d895120f2$var$_useSlotProps2.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $536c4c4d895120f2$var$_extends2.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $536c4c4d895120f2$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $536c4c4d895120f2$var$_excluded2);
    const Layout = slots.layout ?? $g0CIC.PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $536c4c4d895120f2$var$_extends2.default)({}, innerSlotProps, {
        toolbar: (0, $536c4c4d895120f2$var$_extends2.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $536c4c4d895120f2$var$_extends2.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)($jk6Bf.PickerProvider, (0, $536c4c4d895120f2$var$_extends2.default)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $536c4c4d895120f2$var$_extends2.default)({}, fieldProps, {
                    slots: (0, $536c4c4d895120f2$var$_extends2.default)({}, slots, fieldProps.slots),
                    slotProps: (0, $536c4c4d895120f2$var$_extends2.default)({}, slotProps, fieldProps.slotProps),
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($fpltD.PickersModalDialog, {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $536c4c4d895120f2$var$_extends2.default)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};
module.exports.useMobilePicker = $536c4c4d895120f2$var$useMobilePicker;

});
parcelRegister("fpltD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b379d9b00a13e481$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $b379d9b00a13e481$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersModalDialog = $b379d9b00a13e481$var$PickersModalDialog;

var $b379d9b00a13e481$var$_extends2 = $b379d9b00a13e481$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b379d9b00a13e481$var$React = $b379d9b00a13e481$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b379d9b00a13e481$var$_DialogContent = $b379d9b00a13e481$require$_interopRequireDefault((parcelRequire("hJoSv")));

var $b379d9b00a13e481$var$_Fade = $b379d9b00a13e481$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $b379d9b00a13e481$var$_Dialog = $b379d9b00a13e481$require$_interopRequireWildcard((parcelRequire("iZIMH")));

var $8xDHs = parcelRequire("8xDHs");

var $99eO4 = parcelRequire("99eO4");

var $BKARN = parcelRequire("BKARN");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $b379d9b00a13e481$var$PickersModalDialogRoot = (0, $8xDHs.styled)($b379d9b00a13e481$var$_Dialog.default, {
    slot: 'internal'
})({
    [`& .${$b379d9b00a13e481$var$_Dialog.dialogClasses.container}`]: {
        outline: 0
    },
    [`& .${$b379d9b00a13e481$var$_Dialog.dialogClasses.paper}`]: {
        outline: 0,
        minWidth: $99eO4.DIALOG_WIDTH
    }
});
const $b379d9b00a13e481$var$PickersModalDialogContent = (0, $8xDHs.styled)($b379d9b00a13e481$var$_DialogContent.default, {
    slot: 'internal'
})({
    '&:first-of-type': {
        padding: 0
    }
});
function $b379d9b00a13e481$var$PickersModalDialog(props) {
    const { children: children, slots: slots, slotProps: slotProps } = props;
    const { open: open } = (0, $BKARN.usePickerContext)();
    const { dismissViews: dismissViews, onPopperExited: onPopperExited } = (0, $7OOd8.usePickerPrivateContext)();
    const Dialog = slots?.dialog ?? $b379d9b00a13e481$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? $b379d9b00a13e481$var$_Fade.default;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Dialog, (0, $b379d9b00a13e481$var$_extends2.default)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited?.();
        }
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b379d9b00a13e481$var$PickersModalDialogContent, {
            children: children
        })
    }));
}

});

parcelRegister("hz59J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "usePicker", {
    enumerable: true,
    get: function() {
        return $9QI1Q.usePicker;
    }
});

var $9QI1Q = parcelRequire("9QI1Q");

});
parcelRegister("9QI1Q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $72bb1f98949e4fd5$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $72bb1f98949e4fd5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePicker = void 0;

var $72bb1f98949e4fd5$var$_extends2 = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $72bb1f98949e4fd5$var$_objectWithoutPropertiesLoose2 = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("c05no")));

var $72bb1f98949e4fd5$var$React = $72bb1f98949e4fd5$require$_interopRequireWildcard((parcelRequire("acw62")));

var $72bb1f98949e4fd5$var$_useEnhancedEffect = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $72bb1f98949e4fd5$var$_useEventCallback = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $72bb1f98949e4fd5$var$_useForkRef = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $72bb1f98949e4fd5$var$_useId = $72bb1f98949e4fd5$require$_interopRequireDefault((parcelRequire("hwliF")));

var $3nE24 = parcelRequire("3nE24");

var $4eUCS = parcelRequire("4eUCS");

var $cElCc = parcelRequire("cElCc");

var $3cW2G = parcelRequire("3cW2G");

var $9iyk0 = parcelRequire("9iyk0");

var $kZzZK = parcelRequire("kZzZK");

var $ayMG0 = parcelRequire("ayMG0");
const $72bb1f98949e4fd5$var$_excluded = [
    "className",
    "sx"
];
const $72bb1f98949e4fd5$var$usePicker = ({ ref: ref, props: props, valueManager: valueManager, valueType: valueType, variant: variant, validator: validator, onPopperExited: onPopperExited, autoFocusView: autoFocusView, rendererInterceptor: RendererInterceptor, localeText: localeText, viewContainerRole: viewContainerRole, getStepNavigation: getStepNavigation })=>{
    const { views: // View props
    views, view: viewProp, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker: disableOpenPicker, closeOnSelect: closeOnSelect, disabled: // Form props
    disabled, readOnly: readOnly, formatDensity: // Field props
    formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, format: format, label: label, autoFocus: // Other props
    autoFocus, name: name } = props;
    const { className: className, sx: sx } = props, propsToForwardToView = (0, $72bb1f98949e4fd5$var$_objectWithoutPropertiesLoose2.default)(props, $72bb1f98949e4fd5$var$_excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, $72bb1f98949e4fd5$var$_useId.default)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const reduceAnimations = (0, $4eUCS.useReduceAnimations)(reduceAnimationsProp);
    const orientation = (0, $9iyk0.useOrientation)(views, orientationProp);
    const { current: initialView } = $72bb1f98949e4fd5$var$React.useRef(openTo ?? null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = $72bb1f98949e4fd5$var$React.useState(null);
    const popupRef = $72bb1f98949e4fd5$var$React.useRef(null);
    const fieldRef = $72bb1f98949e4fd5$var$React.useRef(null);
    const rootRefObject = $72bb1f98949e4fd5$var$React.useRef(null);
    const rootRef = (0, $72bb1f98949e4fd5$var$_useForkRef.default)(ref, rootRefObject);
    const { timezone: timezone, state: state, setOpen: setOpen, setValue: setValue, setValueFromView: setValueFromView, value: value, viewValue: viewValue } = (0, $kZzZK.useValueAndOpenStates)({
        props: props,
        valueManager: valueManager,
        validator: validator
    });
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView, goToNextStep: goToNextStep, hasNextStep: hasNextStep, hasSeveralSteps: hasSeveralSteps } = (0, $3cW2G.useViews)({
        view: viewProp,
        views: views,
        openTo: openTo,
        onChange: setValueFromView,
        onViewChange: onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation: getStepNavigation
    });
    const clearValue = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(valueManager.emptyValue, {
            source: 'view'
        }));
    const setValueToToday = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(valueManager.getTodayValue(adapter, timezone, valueType), {
            source: 'view'
        }));
    const acceptValueChanges = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(value, {
            source: 'view'
        }));
    const cancelValueChanges = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true,
            source: 'view'
        }));
    const dismissViews = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true,
            source: 'view'
        });
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup, timeViewsCount: timeViewsCount } = $72bb1f98949e4fd5$var$React.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, $cElCc.isTimeView)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(()=>currentViewMode);
    const [popperView, setPopperView] = $72bb1f98949e4fd5$var$React.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $72bb1f98949e4fd5$var$_useEnhancedEffect.default)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $72bb1f98949e4fd5$var$_useEnhancedEffect.default)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: props.disabled ?? false,
            isPickerReadOnly: props.readOnly ?? false,
            pickerOrientation: orientation,
            pickerVariant: variant
        }), [
        adapter,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = $72bb1f98949e4fd5$var$React.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, $72bb1f98949e4fd5$var$_useEventCallback.default)(goToNextStep);
    const defaultActionBarActions = $72bb1f98949e4fd5$var$React.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            setValue: setValue,
            setOpen: setOpen,
            clearValue: clearValue,
            setValueToToday: setValueToToday,
            acceptValueChanges: acceptValueChanges,
            cancelValueChanges: cancelValueChanges,
            setView: setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>(0, $72bb1f98949e4fd5$var$_extends2.default)({}, actionsContextValue, {
            value: value,
            timezone: timezone,
            open: state.open,
            views: views,
            view: popperView,
            initialView: initialView,
            disabled: disabled ?? false,
            readOnly: readOnly ?? false,
            autoFocus: autoFocus ?? false,
            variant: variant,
            orientation: orientation,
            popupRef: popupRef,
            reduceAnimations: reduceAnimations,
            triggerRef: triggerRef,
            triggerStatus: triggerStatus,
            hasNextStep: hasNextStep,
            fieldFormat: format ?? '',
            name: name,
            label: label,
            rootSx: sx,
            rootRef: rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            dismissViews: dismissViews,
            ownerState: ownerState,
            hasUIView: hasUIView,
            getCurrentViewMode: getCurrentViewMode,
            rootRefObject: rootRefObject,
            labelId: labelId,
            triggerElement: triggerElement,
            viewContainerRole: viewContainerRole,
            defaultActionBarActions: defaultActionBarActions,
            onPopperExited: onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = $72bb1f98949e4fd5$var$React.useMemo(()=>({
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            fieldRef: fieldRef
        }), [
        formatDensity,
        enableAccessibleFieldDOMStructure,
        selectedSections,
        onSelectedSectionsChange,
        fieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, $72bb1f98949e4fd5$var$_extends2.default)({}, propsToForwardToView, {
            views: views,
            timezone: timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount: timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView: focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, $ayMG0.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText: localeText,
            contextValue: contextValue,
            privateContextValue: privateContextValue,
            actionsContextValue: actionsContextValue,
            fieldPrivateContextValue: fieldPrivateContextValue,
            isValidContextValue: isValidContextValue
        },
        renderCurrentView: renderCurrentView,
        ownerState: ownerState
    };
};
module.exports.usePicker = $72bb1f98949e4fd5$var$usePicker;

});
parcelRegister("4eUCS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $316464f7737d959f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slowAnimationDevices = void 0;
module.exports.useReduceAnimations = $316464f7737d959f$var$useReduceAnimations;

var $316464f7737d959f$var$_useMediaQuery = $316464f7737d959f$require$_interopRequireDefault((parcelRequire("18tt9")));
const $316464f7737d959f$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $316464f7737d959f$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $316464f7737d959f$var$androidVersion = $316464f7737d959f$var$mobileVersionMatches && $316464f7737d959f$var$mobileVersionMatches[1] ? parseInt($316464f7737d959f$var$mobileVersionMatches[1], 10) : null;
const $316464f7737d959f$var$iOSVersion = $316464f7737d959f$var$mobileVersionMatches && $316464f7737d959f$var$mobileVersionMatches[2] ? parseInt($316464f7737d959f$var$mobileVersionMatches[2], 10) : null;
const $316464f7737d959f$var$slowAnimationDevices = module.exports.slowAnimationDevices = $316464f7737d959f$var$androidVersion && $316464f7737d959f$var$androidVersion < 10 || $316464f7737d959f$var$iOSVersion && $316464f7737d959f$var$iOSVersion < 13 || false;
function $316464f7737d959f$var$useReduceAnimations(customReduceAnimations) {
    const prefersReduced = (0, $316464f7737d959f$var$_useMediaQuery.default)($316464f7737d959f$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || $316464f7737d959f$var$slowAnimationDevices;
}

});

parcelRegister("3cW2G", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $255f841782d21111$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $255f841782d21111$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useViews = $255f841782d21111$var$useViews;

var $255f841782d21111$var$_extends2 = $255f841782d21111$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $255f841782d21111$var$React = $255f841782d21111$require$_interopRequireWildcard((parcelRequire("acw62")));

var $255f841782d21111$var$_useEventCallback = $255f841782d21111$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $255f841782d21111$var$_useControlled = $255f841782d21111$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $kHgod = parcelRequire("kHgod");
let $255f841782d21111$var$warnedOnceNotValidView = false;
function $255f841782d21111$var$useViews({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, getStepNavigation: getStepNavigation }) {
    const previousOpenTo = $255f841782d21111$var$React.useRef(openTo);
    const previousViews = $255f841782d21111$var$React.useRef(views);
    const defaultView = $255f841782d21111$var$React.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $255f841782d21111$var$_useControlled.default)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $255f841782d21111$var$React.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $255f841782d21111$var$_useControlled.default)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView: setView,
        view: view,
        defaultView: defaultView.current,
        views: views
    }) : $kHgod.DEFAULT_STEP_NAVIGATION;
    $255f841782d21111$var$React.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $255f841782d21111$var$_useEventCallback.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $255f841782d21111$var$_useEventCallback.default)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $255f841782d21111$var$_useEventCallback.default)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $255f841782d21111$var$_useEventCallback.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, $255f841782d21111$var$_extends2.default)({}, stepNavigation, {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    });
}

});
parcelRegister("kHgod", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f114897171fbb236$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_STEP_NAVIGATION = void 0;
module.exports.createStepNavigation = $f114897171fbb236$var$createStepNavigation;

var $f114897171fbb236$var$_extends2 = $f114897171fbb236$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $f114897171fbb236$var$DEFAULT_STEP_NAVIGATION = module.exports.DEFAULT_STEP_NAVIGATION = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
/**
 * Create an object that determines whether there is a next step and allows to go to the next step.
 * @param {CreateStepNavigationParameters<TStep>} parameters The parameters of the createStepNavigation function
 * @returns {CreateStepNavigationReturnValue} The return value of the createStepNavigation function
 */ function $f114897171fbb236$var$createStepNavigation(parameters) {
    const { steps: steps, isViewMatchingStep: isViewMatchingStep, onStepChange: onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return $f114897171fbb236$var$DEFAULT_STEP_NAVIGATION;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, $f114897171fbb236$var$_extends2.default)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}

});


parcelRegister("9iyk0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6c506b1759d68a5d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6c506b1759d68a5d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOrientation = $6c506b1759d68a5d$var$useOrientation;

var $6c506b1759d68a5d$var$React = $6c506b1759d68a5d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6c506b1759d68a5d$var$_useEnhancedEffect = $6c506b1759d68a5d$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $l16rr = parcelRequire("l16rr");
function $6c506b1759d68a5d$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function $6c506b1759d68a5d$var$useOrientation(views, customOrientation) {
    const [orientation, setOrientation] = $6c506b1759d68a5d$var$React.useState($6c506b1759d68a5d$var$getOrientation);
    (0, $6c506b1759d68a5d$var$_useEnhancedEffect.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($6c506b1759d68a5d$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $l16rr.arrayIncludes)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation ?? orientation;
}

});

parcelRegister("kZzZK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f4856cf9dd817ed8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f4856cf9dd817ed8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useValueAndOpenStates = $f4856cf9dd817ed8$var$useValueAndOpenStates;

var $f4856cf9dd817ed8$var$_extends2 = $f4856cf9dd817ed8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f4856cf9dd817ed8$var$React = $f4856cf9dd817ed8$require$_interopRequireWildcard((parcelRequire("acw62")));


var $f4856cf9dd817ed8$var$_useEventCallback = $f4856cf9dd817ed8$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $hagTn = parcelRequire("hagTn");

var $3nE24 = parcelRequire("3nE24");

var $5UoGz = parcelRequire("5UoGz");
function $f4856cf9dd817ed8$var$useValueAndOpenStates(parameters) {
    const { props: props, valueManager: valueManager, validator: validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange: onChange, referenceDate: referenceDate, timezone: timezoneProp, onAccept: onAccept, closeOnSelect: closeOnSelect, open: openProp, onOpen: onOpen, onClose: onClose } = props;
    const { current: defaultValue } = $f4856cf9dd817ed8$var$React.useRef(defaultValueProp);
    const { current: isValueControlled } = $f4856cf9dd817ed8$var$React.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = $f4856cf9dd817ed8$var$React.useRef(openProp !== undefined);
    const adapter = (0, $3nE24.usePickerAdapter)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone: timezone, value: value, handleValueChange: handleValueChange } = (0, $hagTn.useControlledValue)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [state, setState] = $f4856cf9dd817ed8$var$React.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $5UoGz.useValidation)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: props.onError
    });
    const setOpen = (0, $f4856cf9dd817ed8$var$_useEventCallback.default)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose?.();
    });
    const setValue = (0, $f4856cf9dd817ed8$var$_useEventCallback.default)((newValue, options)=>{
        const { changeImportance: changeImportance = 'accept', skipPublicationIfPristine: skipPublicationIfPristine = false, validationError: validationError, shortcut: shortcut, source: source, shouldClose: shouldClose = changeImportance === 'accept' } = options ?? {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                let inferredSource;
                if (source) inferredSource = source;
                else if (shortcut) inferredSource = 'view';
                else // Default to unknown when not explicitly tagged by a picker call site
                inferredSource = 'unknown';
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError,
                    source: inferredSource
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, $f4856cf9dd817ed8$var$_useEventCallback.default)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set',
            source: 'view'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $f4856cf9dd817ed8$var$React.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setState((prevState)=>(0, $f4856cf9dd817ed8$var$_extends2.default)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = $f4856cf9dd817ed8$var$React.useMemo(()=>valueManager.cleanValue(adapter, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        adapter,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone: timezone,
        state: state,
        setValue: setValue,
        setValueFromView: setValueFromView,
        setOpen: setOpen,
        value: value,
        viewValue: viewValue
    };
}

});



parcelRegister("g0CIC", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ba7aae28ccdef24f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersLayout", {
    enumerable: true,
    get: function() {
        return $cj57l.PickersLayout;
    }
});
Object.defineProperty(module.exports, "PickersLayoutContentWrapper", {
    enumerable: true,
    get: function() {
        return $cj57l.PickersLayoutContentWrapper;
    }
});
Object.defineProperty(module.exports, "PickersLayoutRoot", {
    enumerable: true,
    get: function() {
        return $cj57l.PickersLayoutRoot;
    }
});
Object.defineProperty(module.exports, "pickersLayoutClasses", {
    enumerable: true,
    get: function() {
        return $9k6Dk.pickersLayoutClasses;
    }
});
Object.defineProperty(module.exports, "usePickerLayout", {
    enumerable: true,
    get: function() {
        return $ba7aae28ccdef24f$var$_usePickerLayout.default;
    }
});

var $cj57l = parcelRequire("cj57l");

var $ba7aae28ccdef24f$var$_usePickerLayout = $ba7aae28ccdef24f$require$_interopRequireDefault((parcelRequire("ECdxX")));

var $9k6Dk = parcelRequire("9k6Dk");

});
parcelRegister("cj57l", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8f5b3a99831a0c63$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8f5b3a99831a0c63$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersLayoutRoot = module.exports.PickersLayoutContentWrapper = module.exports.PickersLayout = void 0;

var $8f5b3a99831a0c63$var$React = $8f5b3a99831a0c63$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8f5b3a99831a0c63$var$_propTypes = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8f5b3a99831a0c63$var$_clsx = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $8f5b3a99831a0c63$var$_composeClasses = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9k6Dk = parcelRequire("9k6Dk");

var $8f5b3a99831a0c63$var$_usePickerLayout = $8f5b3a99831a0c63$require$_interopRequireDefault((parcelRequire("ECdxX")));

var $6DVo4 = parcelRequire("6DVo4");

var $ayMG0 = parcelRequire("ayMG0");
const $8f5b3a99831a0c63$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $8f5b3a99831a0c63$var$_composeClasses.default)(slots, $9k6Dk.getPickersLayoutUtilityClass, classes);
};
const $8f5b3a99831a0c63$var$PickersLayoutRoot = module.exports.PickersLayoutRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${$9k6Dk.pickersLayoutClasses.actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: false
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '1 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: true
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1,
                    maxWidth: 'max-content'
                },
                [`& .${$9k6Dk.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: 2
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${$9k6Dk.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                hasShortcuts: true,
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${$9k6Dk.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 4
                }
            }
        }
    ]
});
const $8f5b3a99831a0c63$var$PickersLayoutContentWrapper = module.exports.PickersLayoutContentWrapper = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $8f5b3a99831a0c63$var$PickersLayout = module.exports.PickersLayout = /*#__PURE__*/ $8f5b3a99831a0c63$var$React.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $8f5b3a99831a0c63$var$_usePickerLayout.default)(props);
    const { orientation: orientation, variant: variant } = (0, $6DVo4.usePickerContext)();
    const { sx: sx, className: className, classes: classesProp } = props;
    const classes = $8f5b3a99831a0c63$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$var$PickersLayoutRoot, {
        ref: ref,
        sx: sx,
        className: (0, $8f5b3a99831a0c63$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $ayMG0.jsx)($8f5b3a99831a0c63$var$PickersLayoutContentWrapper, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$var$React.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$var$React.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});

});
parcelRegister("9k6Dk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6c9b2087702d19e3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersLayoutUtilityClass = $6c9b2087702d19e3$var$getPickersLayoutUtilityClass;
module.exports.pickersLayoutClasses = void 0;

var $6c9b2087702d19e3$var$_generateUtilityClass = $6c9b2087702d19e3$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $6c9b2087702d19e3$var$_generateUtilityClasses = $6c9b2087702d19e3$require$_interopRequireDefault((parcelRequire("5nY49")));
function $6c9b2087702d19e3$var$getPickersLayoutUtilityClass(slot) {
    return (0, $6c9b2087702d19e3$var$_generateUtilityClass.default)('MuiPickersLayout', slot);
}
const $6c9b2087702d19e3$var$pickersLayoutClasses = module.exports.pickersLayoutClasses = (0, $6c9b2087702d19e3$var$_generateUtilityClasses.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);

});

parcelRegister("ECdxX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $07a161bd56d089a9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $07a161bd56d089a9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07a161bd56d089a9$var$_objectWithoutPropertiesLoose2 = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("c05no")));

var $07a161bd56d089a9$var$_extends2 = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $07a161bd56d089a9$var$React = $07a161bd56d089a9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $07a161bd56d089a9$var$_useSlotProps2 = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("839K0")));

var $07a161bd56d089a9$var$_composeClasses = $07a161bd56d089a9$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9uEev = parcelRequire("9uEev");

var $97UU8 = parcelRequire("97UU8");

var $9k6Dk = parcelRequire("9k6Dk");

var $aT4uh = parcelRequire("aT4uh");

var $7OOd8 = parcelRequire("7OOd8");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $07a161bd56d089a9$var$_excluded = [
    "ownerState"
];
function $07a161bd56d089a9$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $07a161bd56d089a9$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $07a161bd56d089a9$var$_composeClasses.default)(slots, $9k6Dk.getPickersLayoutUtilityClass, classes);
};
const $07a161bd56d089a9$var$usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions: defaultActionBarActions } = (0, $7OOd8.usePickerPrivateContext)();
    const { view: view } = (0, $BKARN.usePickerContext)();
    const isRtl = (0, $9uEev.useRtl)();
    const { children: children, slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const ownerState = $07a161bd56d089a9$var$React.useMemo(()=>(0, $07a161bd56d089a9$var$_extends2.default)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr',
            hasShortcuts: false
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = $07a161bd56d089a9$var$useUtilityClasses(classesProp, ownerState);
    // Action bar
    const ActionBar = slots?.actionBar ?? $97UU8.PickersActionBar;
    const _useSlotProps = (0, $07a161bd56d089a9$var$_useSlotProps2.default)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState: ownerState
    }), actionBarProps = (0, $07a161bd56d089a9$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $07a161bd56d089a9$var$_excluded);
    const actionBar = /*#__PURE__*/ (0, $ayMG0.jsx)(ActionBar, (0, $07a161bd56d089a9$var$_extends2.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $07a161bd56d089a9$var$_useSlotProps2.default)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        className: classes.toolbar,
        ownerState: ownerState
    });
    const toolbar = $07a161bd56d089a9$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $07a161bd56d089a9$var$_extends2.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $ayMG0.jsx)(Tabs, (0, $07a161bd56d089a9$var$_extends2.default)({
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? $aT4uh.PickersShortcuts;
    const shortcutsProps = (0, $07a161bd56d089a9$var$_useSlotProps2.default)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        className: classes.shortcuts,
        ownerState: ownerState
    });
    const hasShortcuts = Array.isArray(shortcutsProps?.items) && shortcutsProps.items.length > 0;
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $ayMG0.jsx)(Shortcuts, (0, $07a161bd56d089a9$var$_extends2.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts,
        ownerState: (0, $07a161bd56d089a9$var$_extends2.default)({}, ownerState, {
            hasShortcuts: hasShortcuts
        })
    };
};
var $07a161bd56d089a9$var$_default = module.exports.default = $07a161bd56d089a9$var$usePickerLayout;

});
parcelRegister("97UU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersActionBar", {
    enumerable: true,
    get: function() {
        return $iHEnb.PickersActionBar;
    }
});

var $iHEnb = parcelRequire("iHEnb");

});
parcelRegister("iHEnb", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d9db8f61ff28a432$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9db8f61ff28a432$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersActionBar = void 0;

var $d9db8f61ff28a432$var$_extends2 = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d9db8f61ff28a432$var$_objectWithoutPropertiesLoose2 = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("c05no")));

var $d9db8f61ff28a432$var$React = $d9db8f61ff28a432$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d9db8f61ff28a432$var$_propTypes = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $d9db8f61ff28a432$var$_Button = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("bBQKz")));

var $d9db8f61ff28a432$var$_DialogActions = $d9db8f61ff28a432$require$_interopRequireDefault((parcelRequire("l5BZB")));

var $83GPg = parcelRequire("83GPg");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $d9db8f61ff28a432$var$_excluded = [
    "actions"
];
const $d9db8f61ff28a432$var$PickersActionBarRoot = (0, $8xDHs.styled)($d9db8f61ff28a432$var$_DialogActions.default, {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $d9db8f61ff28a432$var$PickersActionBarComponent(props) {
    const { actions: actions } = props, other = (0, $d9db8f61ff28a432$var$_objectWithoutPropertiesLoose2.default)(props, $d9db8f61ff28a432$var$_excluded);
    const translations = (0, $83GPg.usePickerTranslations)();
    const { clearValue: clearValue, setValueToToday: setValueToToday, acceptValueChanges: acceptValueChanges, cancelValueChanges: cancelValueChanges, goToNextStep: goToNextStep, hasNextStep: hasNextStep } = (0, $BKARN.usePickerContext)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$_Button.default, {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d9db8f61ff28a432$var$PickersActionBarRoot, (0, $d9db8f61ff28a432$var$_extends2.default)({}, other, {
        children: buttons
    }));
}
const $d9db8f61ff28a432$var$PickersActionBar = module.exports.PickersActionBar = /*#__PURE__*/ $d9db8f61ff28a432$var$React.memo($d9db8f61ff28a432$var$PickersActionBarComponent);

});


parcelRegister("aT4uh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersShortcuts", {
    enumerable: true,
    get: function() {
        return $g9DEN.PickersShortcuts;
    }
});

var $g9DEN = parcelRequire("g9DEN");

});
parcelRegister("g9DEN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bc2c3fa74ca71715$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersShortcuts = $bc2c3fa74ca71715$var$PickersShortcuts;

var $bc2c3fa74ca71715$var$_extends2 = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bc2c3fa74ca71715$var$_objectWithoutPropertiesLoose2 = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("c05no")));

var $8xDHs = parcelRequire("8xDHs");

var $bc2c3fa74ca71715$var$_propTypes = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bc2c3fa74ca71715$var$_List = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("ib3g2")));

var $bc2c3fa74ca71715$var$_ListItem = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("hOLYA")));

var $bc2c3fa74ca71715$var$_Chip = $bc2c3fa74ca71715$require$_interopRequireDefault((parcelRequire("6p5K7")));

var $99eO4 = parcelRequire("99eO4");

var $BKARN = parcelRequire("BKARN");

var $ayMG0 = parcelRequire("ayMG0");
const $bc2c3fa74ca71715$var$_excluded = [
    "items",
    "changeImportance"
], $bc2c3fa74ca71715$var$_excluded2 = [
    "getValue"
];
const $bc2c3fa74ca71715$var$PickersShortcutsRoot = (0, $8xDHs.styled)($bc2c3fa74ca71715$var$_List.default, {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $bc2c3fa74ca71715$var$PickersShortcuts(props) {
    const { items: items, changeImportance: changeImportance = 'accept' } = props, other = (0, $bc2c3fa74ca71715$var$_objectWithoutPropertiesLoose2.default)(props, $bc2c3fa74ca71715$var$_excluded);
    const { setValue: setValue } = (0, $BKARN.usePickerActionsContext)();
    const isValidValue = (0, $BKARN.useIsValidValue)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $bc2c3fa74ca71715$var$_objectWithoutPropertiesLoose2.default)(_ref, $bc2c3fa74ca71715$var$_excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, $bc2c3fa74ca71715$var$_extends2.default)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance: changeImportance,
                    shortcut: item,
                    source: 'view'
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bc2c3fa74ca71715$var$PickersShortcutsRoot, (0, $bc2c3fa74ca71715$var$_extends2.default)({
        dense: true,
        sx: [
            {
                maxHeight: $99eO4.VIEW_HEIGHT,
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)($bc2c3fa74ca71715$var$_ListItem.default, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($bc2c3fa74ca71715$var$_Chip.default, (0, $bc2c3fa74ca71715$var$_extends2.default)({}, item))
            }, item.id ?? item.label);
        })
    }));
}

});





parcelRegister("a2Tw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNonRangePickerStepNavigation = $7505279b16728fc6$var$createNonRangePickerStepNavigation;

var $kHgod = parcelRequire("kHgod");
function $7505279b16728fc6$var$createNonRangePickerStepNavigation(parameters) {
    const { steps: steps } = parameters;
    return (0, $kHgod.createStepNavigation)({
        steps: steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step: step, defaultView: defaultView, setView: setView, view: view, views: views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}

});



parcelRegister("5TrXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "renderDateViewCalendar", {
    enumerable: true,
    get: function() {
        return $8uN0h.renderDateViewCalendar;
    }
});

var $8uN0h = parcelRequire("8uN0h");

});
parcelRegister("8uN0h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderDateViewCalendar = void 0;

var $6BOGh = parcelRequire("6BOGh");

var $NRNex = parcelRequire("NRNex");

var $ayMG0 = parcelRequire("ayMG0");
const $62f723267dd87cd0$var$renderDateViewCalendar = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($6BOGh.DateCalendar, {
        view: view,
        onViewChange: onViewChange,
        views: views.filter($NRNex.isDatePickerView),
        focusedView: focusedView && (0, $NRNex.isDatePickerView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });
module.exports.renderDateViewCalendar = $62f723267dd87cd0$var$renderDateViewCalendar;

});
parcelRegister("6BOGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DateCalendar", {
    enumerable: true,
    get: function() {
        return $gvmDt.DateCalendar;
    }
});
Object.defineProperty(module.exports, "dateCalendarClasses", {
    enumerable: true,
    get: function() {
        return $e7rSK.dateCalendarClasses;
    }
});
Object.defineProperty(module.exports, "dayCalendarClasses", {
    enumerable: true,
    get: function() {
        return $66c8j.dayCalendarClasses;
    }
});
Object.defineProperty(module.exports, "getDateCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return $e7rSK.getDateCalendarUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersFadeTransitionGroupClasses", {
    enumerable: true,
    get: function() {
        return $hj2cL.pickersFadeTransitionGroupClasses;
    }
});
Object.defineProperty(module.exports, "pickersSlideTransitionClasses", {
    enumerable: true,
    get: function() {
        return $ha1fF.pickersSlideTransitionClasses;
    }
});

var $gvmDt = parcelRequire("gvmDt");

var $e7rSK = parcelRequire("e7rSK");

var $66c8j = parcelRequire("66c8j");

var $hj2cL = parcelRequire("hj2cL");

var $ha1fF = parcelRequire("ha1fF");

});
parcelRegister("gvmDt", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c041198f38a260e6$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c041198f38a260e6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateCalendar = void 0;

var $c041198f38a260e6$var$_objectWithoutPropertiesLoose2 = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("c05no")));

var $c041198f38a260e6$var$_extends2 = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c041198f38a260e6$var$React = $c041198f38a260e6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c041198f38a260e6$var$_propTypes = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c041198f38a260e6$var$_clsx = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c041198f38a260e6$var$_useSlotProps = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("839K0")));

var $8xDHs = parcelRequire("8xDHs");

var $c041198f38a260e6$var$_composeClasses = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $c041198f38a260e6$var$_useId = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("hwliF")));

var $c041198f38a260e6$var$_useEventCallback = $c041198f38a260e6$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $580ir = parcelRequire("580ir");

var $eW408 = parcelRequire("eW408");

var $3UaqM = parcelRequire("3UaqM");

var $gYuM1 = parcelRequire("gYuM1");

var $haVKB = parcelRequire("haVKB");

var $3cW2G = parcelRequire("3cW2G");

var $dAsZ9 = parcelRequire("dAsZ9");

var $NRNex = parcelRequire("NRNex");

var $fQ7ML = parcelRequire("fQ7ML");

var $4eUCS = parcelRequire("4eUCS");

var $e7rSK = parcelRequire("e7rSK");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $99eO4 = parcelRequire("99eO4");

var $7OOd8 = parcelRequire("7OOd8");

var $1aSwN = parcelRequire("1aSwN");

var $3nE24 = parcelRequire("3nE24");

var $ayMG0 = parcelRequire("ayMG0");
const $c041198f38a260e6$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $c041198f38a260e6$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $c041198f38a260e6$var$_composeClasses.default)(slots, $e7rSK.getDateCalendarUtilityClass, classes);
};
function $c041198f38a260e6$var$useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $8xDHs.useThemeProps)({
        props: props,
        name: name
    });
    const reduceAnimations = (0, $4eUCS.useReduceAnimations)(themeProps.reduceAnimations);
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, $c041198f38a260e6$var$_extends2.default)({}, themeProps, validationProps, {
        loading: themeProps.loading ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: reduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "..."
            }))
    });
}
const $c041198f38a260e6$var$DateCalendarRoot = (0, $8xDHs.styled)($fQ7ML.PickerViewRoot, {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: $99eO4.VIEW_HEIGHT
});
const $c041198f38a260e6$var$DateCalendarViewTransitionContainer = (0, $8xDHs.styled)($eW408.PickersFadeTransitionGroup, {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateCalendar API](https://mui.com/x/api/date-pickers/date-calendar/)
 */ const $c041198f38a260e6$var$DateCalendar = module.exports.DateCalendar = /*#__PURE__*/ $c041198f38a260e6$var$React.forwardRef(function DateCalendar(inProps, ref) {
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const id = (0, $c041198f38a260e6$var$_useId.default)();
    const props = $c041198f38a260e6$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $c041198f38a260e6$var$_objectWithoutPropertiesLoose2.default)(props, $c041198f38a260e6$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, setVisibleDate: setVisibleDate, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $580ir.useCalendarState)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (adapter.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return adapter.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? $dAsZ9.PickersCalendarHeader;
    const calendarHeaderProps = (0, $c041198f38a260e6$var$_useSlotProps.default)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: ownerState
    });
    const handleDateMonthChange = (0, $c041198f38a260e6$var$_useEventCallback.default)((newDate)=>{
        const startOfMonth = adapter.startOfMonth(newDate);
        const endOfMonth = adapter.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $NRNex.findClosestEnabledDate)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, $c041198f38a260e6$var$_useEventCallback.default)((newDate)=>{
        const startOfYear = adapter.startOfYear(newDate);
        const endOfYear = adapter.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $NRNex.findClosestEnabledDate)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, $c041198f38a260e6$var$_useEventCallback.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $NRNex.mergeDateAndTime)(adapter, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $c041198f38a260e6$var$React.useEffect(()=>{
        if (adapter.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = $c041198f38a260e6$var$useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $c041198f38a260e6$var$React.useRef(view);
    $c041198f38a260e6$var$React.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $c041198f38a260e6$var$React.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c041198f38a260e6$var$DateCalendarRoot, (0, $c041198f38a260e6$var$_extends2.default)({
        ref: ref,
        className: (0, $c041198f38a260e6$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(CalendarHeader, (0, $c041198f38a260e6$var$_extends2.default)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c041198f38a260e6$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $ayMG0.jsx)($haVKB.YearCalendar, (0, $c041198f38a260e6$var$_extends2.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $ayMG0.jsx)($gYuM1.MonthCalendar, (0, $c041198f38a260e6$var$_extends2.default)({}, baseDateValidationProps, commonViewProps, {
                            currentMonth: calendarState.currentMonth,
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $ayMG0.jsx)($3UaqM.DayCalendar, (0, $c041198f38a260e6$var$_extends2.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});

});
parcelRegister("580ir", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3bbdedfd37de0fee$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3bbdedfd37de0fee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useCalendarState = void 0;

var $3bbdedfd37de0fee$var$_extends2 = $3bbdedfd37de0fee$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3bbdedfd37de0fee$var$React = $3bbdedfd37de0fee$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3bbdedfd37de0fee$var$_useEventCallback = $3bbdedfd37de0fee$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $d9zNj = parcelRequire("d9zNj");

var $1M3bL = parcelRequire("1M3bL");

var $gUrai = parcelRequire("gUrai");

var $NRNex = parcelRequire("NRNex");

var $3nE24 = parcelRequire("3nE24");
const $3bbdedfd37de0fee$var$createCalendarStateReducer = (reduceAnimations, adapter)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, $3bbdedfd37de0fee$var$_extends2.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (adapter.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
                    if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
                    return (0, $3bbdedfd37de0fee$var$_extends2.default)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $3bbdedfd37de0fee$var$_extends2.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw new Error('missing support');
        }
    };
const $3bbdedfd37de0fee$var$useCalendarState = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onYearChange: onYearChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone, getCurrentMonthFromVisibleDate: getCurrentMonthFromVisibleDate } = params;
    const adapter = (0, $3nE24.usePickerAdapter)();
    const reducerFn = $3bbdedfd37de0fee$var$React.useRef($3bbdedfd37de0fee$var$createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
    const referenceDate = $3bbdedfd37de0fee$var$React.useMemo(()=>{
        return $1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $3bbdedfd37de0fee$var$React.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        // Keep the time from the reference date when computing the current month anchor.
        // Using startOfMonth would reset the time to 00:00 which breaks expectations
        // that month selections preserve the referenceDate time when no value is provided.
        // See tests: "should use `referenceDate` when no value defined".
        currentMonth: adapter.setDate(referenceDate, 1),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, $d9zNj.useIsDateDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $3bbdedfd37de0fee$var$React.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: adapter.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        adapter
    ]);
    const setVisibleDate = (0, $3bbdedfd37de0fee$var$_useEventCallback.default)(({ target: target, reason: reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = adapter.startOfMonth(target);
                const endOfMonth = adapter.endOfMonth(target);
                focusedDay = (0, $NRNex.findClosestEnabledDate)({
                    adapter: adapter,
                    date: focusedDay,
                    minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast: disablePast,
                    disableFuture: disableFuture,
                    isDateDisabled: isDateDisabled,
                    timezone: timezone
                });
            }
        }
        const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange?.(month);
        if (hasChangedYear) onYearChange?.(adapter.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month: month,
            direction: adapter.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation: skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = $3bbdedfd37de0fee$var$React.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        setVisibleDate: setVisibleDate,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd
    };
};
module.exports.useCalendarState = $3bbdedfd37de0fee$var$useCalendarState;

});
parcelRegister("d9zNj", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9937e1a8ba43913d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsDateDisabled = void 0;

var $9937e1a8ba43913d$var$React = $9937e1a8ba43913d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5UoGz = parcelRequire("5UoGz");

var $3nE24 = parcelRequire("3nE24");
const $9937e1a8ba43913d$var$useIsDateDisabled = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $3nE24.usePickerAdapter)();
    return $9937e1a8ba43913d$var$React.useCallback((day)=>(0, $5UoGz.validateDate)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};
module.exports.useIsDateDisabled = $9937e1a8ba43913d$var$useIsDateDisabled;

});


parcelRegister("eW408", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adf9960a2516beaf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $adf9960a2516beaf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersFadeTransitionGroup = $adf9960a2516beaf$var$PickersFadeTransitionGroup;

var $adf9960a2516beaf$var$_objectWithoutPropertiesLoose2 = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("c05no")));

var $adf9960a2516beaf$var$React = $adf9960a2516beaf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $adf9960a2516beaf$var$_clsx = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $jEvxL = parcelRequire("jEvxL");

var $adf9960a2516beaf$var$_Fade = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $8xDHs = parcelRequire("8xDHs");

var $adf9960a2516beaf$var$_composeClasses = $adf9960a2516beaf$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $hj2cL = parcelRequire("hj2cL");

var $ayMG0 = parcelRequire("ayMG0");
const $adf9960a2516beaf$var$_excluded = [
    "children"
];
const $adf9960a2516beaf$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $adf9960a2516beaf$var$_composeClasses.default)(slots, $hj2cL.getPickersFadeTransitionGroupUtilityClass, classes);
};
const $adf9960a2516beaf$var$PickersFadeTransitionGroupRoot = (0, $8xDHs.styled)($jEvxL.default, {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
/**
 * @ignore - do not document.
 */ function $adf9960a2516beaf$var$PickersFadeTransitionGroup(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className: className, reduceAnimations: reduceAnimations, transKey: transKey, classes: classesProp } = props;
    const { children: children } = props, other = (0, $adf9960a2516beaf$var$_objectWithoutPropertiesLoose2.default)(props, $adf9960a2516beaf$var$_excluded);
    const classes = $adf9960a2516beaf$var$useUtilityClasses(classesProp);
    const theme = (0, $8xDHs.useTheme)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($adf9960a2516beaf$var$PickersFadeTransitionGroupRoot, {
        className: (0, $adf9960a2516beaf$var$_clsx.default)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($adf9960a2516beaf$var$_Fade.default, {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

});
parcelRegister("hj2cL", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c995ebd7b0d30b08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pickersFadeTransitionGroupClasses = module.exports.getPickersFadeTransitionGroupUtilityClass = void 0;

var $c995ebd7b0d30b08$var$_generateUtilityClass = $c995ebd7b0d30b08$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $c995ebd7b0d30b08$var$_generateUtilityClasses = $c995ebd7b0d30b08$require$_interopRequireDefault((parcelRequire("5nY49")));
const $c995ebd7b0d30b08$var$getPickersFadeTransitionGroupUtilityClass = (slot)=>(0, $c995ebd7b0d30b08$var$_generateUtilityClass.default)('MuiPickersFadeTransitionGroup', slot);
module.exports.getPickersFadeTransitionGroupUtilityClass = $c995ebd7b0d30b08$var$getPickersFadeTransitionGroupUtilityClass;
const $c995ebd7b0d30b08$var$pickersFadeTransitionGroupClasses = module.exports.pickersFadeTransitionGroupClasses = (0, $c995ebd7b0d30b08$var$_generateUtilityClasses.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);

});


parcelRegister("3UaqM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2d7eb168b763dabb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2d7eb168b763dabb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DayCalendar = $2d7eb168b763dabb$var$DayCalendar;

var $2d7eb168b763dabb$var$_objectWithoutPropertiesLoose2 = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("c05no")));

var $2d7eb168b763dabb$var$_extends2 = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $2d7eb168b763dabb$var$React = $2d7eb168b763dabb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2d7eb168b763dabb$var$_useEventCallback = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $2d7eb168b763dabb$var$_Typography = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $2d7eb168b763dabb$var$_useSlotProps2 = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("839K0")));

var $9uEev = parcelRequire("9uEev");

var $8xDHs = parcelRequire("8xDHs");

var $2d7eb168b763dabb$var$_composeClasses = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2d7eb168b763dabb$var$_clsx = $2d7eb168b763dabb$require$_interopRequireDefault((parcelRequire("9QePP")));

var $5XNc8 = parcelRequire("5XNc8");

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $99eO4 = parcelRequire("99eO4");

var $3wpx4 = parcelRequire("3wpx4");

var $d9zNj = parcelRequire("d9zNj");

var $NRNex = parcelRequire("NRNex");

var $66c8j = parcelRequire("66c8j");

var $iFeOh = parcelRequire("iFeOh");

var $ayMG0 = parcelRequire("ayMG0");
const $2d7eb168b763dabb$var$_excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $2d7eb168b763dabb$var$_excluded2 = [
    "ownerState"
];
const $2d7eb168b763dabb$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $2d7eb168b763dabb$var$_composeClasses.default)(slots, $66c8j.getDayCalendarUtilityClass, classes);
};
const $2d7eb168b763dabb$var$weeksContainerHeight = ($99eO4.DAY_SIZE + $99eO4.DAY_MARGIN * 2) * 6;
const $2d7eb168b763dabb$var$PickersCalendarDayRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const $2d7eb168b763dabb$var$PickersCalendarDayHeader = (0, $8xDHs.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $2d7eb168b763dabb$var$PickersCalendarWeekDayLabel = (0, $8xDHs.styled)($2d7eb168b763dabb$var$_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $2d7eb168b763dabb$var$PickersCalendarWeekNumberLabel = (0, $8xDHs.styled)($2d7eb168b763dabb$var$_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const $2d7eb168b763dabb$var$PickersCalendarWeekNumber = (0, $8xDHs.styled)($2d7eb168b763dabb$var$_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme: theme })=>(0, $2d7eb168b763dabb$var$_extends2.default)({}, theme.typography.caption, {
        width: $99eO4.DAY_SIZE,
        height: $99eO4.DAY_SIZE,
        padding: 0,
        margin: `0 ${$99eO4.DAY_MARGIN}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $2d7eb168b763dabb$var$PickersCalendarLoadingContainer = (0, $8xDHs.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $2d7eb168b763dabb$var$weeksContainerHeight
});
const $2d7eb168b763dabb$var$PickersCalendarSlideTransition = (0, $8xDHs.styled)($3wpx4.PickersSlideTransition, {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: $2d7eb168b763dabb$var$weeksContainerHeight
});
const $2d7eb168b763dabb$var$PickersCalendarWeekContainer = (0, $8xDHs.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const $2d7eb168b763dabb$var$PickersCalendarWeek = (0, $8xDHs.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${$99eO4.DAY_MARGIN}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $2d7eb168b763dabb$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusedDay: focusedDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $2d7eb168b763dabb$var$_objectWithoutPropertiesLoose2.default)(_ref, $2d7eb168b763dabb$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const adapter = (0, $BKARN.usePickerAdapter)();
    const now = (0, $3vagl.useNow)(timezone);
    const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>adapter.isSameDay(selectedDay, day));
    const isToday = adapter.isSameDay(day, now);
    const isDisabled = $2d7eb168b763dabb$var$React.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = $2d7eb168b763dabb$var$React.useMemo(()=>adapter.getMonth(day) !== currentMonthNumber, [
        adapter,
        day,
        currentMonthNumber
    ]);
    const ownerState = (0, $iFeOh.usePickerDayOwnerState)({
        day: day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableMargin: undefined,
        disableHighlightToday: // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
        disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const Day = slots?.day ?? $5XNc8.PickersDay;
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $2d7eb168b763dabb$var$_useSlotProps2.default)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $2d7eb168b763dabb$var$_extends2.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': adapter.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $2d7eb168b763dabb$var$_extends2.default)({}, ownerState, {
            day: day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, $2d7eb168b763dabb$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $2d7eb168b763dabb$var$_excluded2);
    const isFirstVisibleCell = $2d7eb168b763dabb$var$React.useMemo(()=>{
        const startOfMonth = adapter.startOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, startOfMonth);
        return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    const isLastVisibleCell = $2d7eb168b763dabb$var$React.useMemo(()=>{
        const endOfMonth = adapter.endOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, endOfMonth);
        return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Day, (0, $2d7eb168b763dabb$var$_extends2.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
/**
 * @ignore - do not document.
 */ function $2d7eb168b763dabb$var$DayCalendar(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const adapter = (0, $BKARN.usePickerAdapter)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, classes: classesProp, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>adapter.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, timezone: timezone } = props;
    const now = (0, $3vagl.useNow)(timezone);
    const classes = $2d7eb168b763dabb$var$useUtilityClasses(classesProp);
    const isRtl = (0, $9uEev.useRtl)();
    const isDateDisabled = (0, $d9zNj.useIsDateDisabled)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const handleDaySelect = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange?.(true);
        }
    };
    const handleKeyDown = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(adapter.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(adapter.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $NRNex.findClosestEnabledDate)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $NRNex.findClosestEnabledDate)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(adapter.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(adapter.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(adapter.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(adapter.addMonths(day, -1));
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleDaySelect(day);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((event, day)=>focusDay(day));
    const handleBlur = (0, $2d7eb168b763dabb$var$_useEventCallback.default)((event, day)=>{
        if (focusedDay != null && adapter.isSameDay(focusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = adapter.getMonth(currentMonth);
    const currentYearNumber = adapter.getYear(currentMonth);
    const validSelectedDays = $2d7eb168b763dabb$var$React.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>adapter.startOfDay(day)), [
        adapter,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $2d7eb168b763dabb$var$React.useMemo(()=>/*#__PURE__*/ $2d7eb168b763dabb$var$React.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = $2d7eb168b763dabb$var$React.useMemo(()=>{
        const toDisplay = adapter.getWeekArray(currentMonth);
        let nextMonth = adapter.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = adapter.getWeekArray(nextMonth);
            const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = adapter.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        adapter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $NRNex.getWeekdays)(adapter, now).map((weekday, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": adapter.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarSlideTransition, (0, $2d7eb168b763dabb$var$_extends2.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $2d7eb168b763dabb$var$_clsx.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

});
parcelRegister("5XNc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersDay", {
    enumerable: true,
    get: function() {
        return $dULUG.PickersDay;
    }
});
Object.defineProperty(module.exports, "getPickersDayUtilityClass", {
    enumerable: true,
    get: function() {
        return $baaJf.getPickersDayUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersDayClasses", {
    enumerable: true,
    get: function() {
        return $baaJf.pickersDayClasses;
    }
});

var $dULUG = parcelRequire("dULUG");

var $baaJf = parcelRequire("baaJf");

});
parcelRegister("dULUG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a215abe4b2054e88$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a215abe4b2054e88$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersDay = void 0;

var $a215abe4b2054e88$var$_objectWithoutPropertiesLoose2 = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("c05no")));

var $a215abe4b2054e88$var$_extends2 = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a215abe4b2054e88$var$React = $a215abe4b2054e88$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a215abe4b2054e88$var$_propTypes = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a215abe4b2054e88$var$_clsx = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a215abe4b2054e88$var$_ButtonBase = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("hhs3r")));

var $a215abe4b2054e88$var$_useEnhancedEffect = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $a215abe4b2054e88$var$_composeClasses = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a215abe4b2054e88$var$_useForkRef = $a215abe4b2054e88$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $8xDHs = parcelRequire("8xDHs");

var $3nE24 = parcelRequire("3nE24");

var $99eO4 = parcelRequire("99eO4");

var $baaJf = parcelRequire("baaJf");

var $iFeOh = parcelRequire("iFeOh");

var $ayMG0 = parcelRequire("ayMG0");
const $a215abe4b2054e88$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableMargin",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth"
];
const $a215abe4b2054e88$var$useUtilityClasses = (classes, ownerState)=>{
    const { isDaySelected: isDaySelected, isDayDisabled: isDayDisabled, isDayCurrent: isDayCurrent, isDayOutsideMonth: isDayOutsideMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = ownerState;
    const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            isDaySelected && !isHiddenDaySpacingFiller && 'selected',
            isDayDisabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && isDayCurrent && 'today',
            isDayOutsideMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $a215abe4b2054e88$var$_composeClasses.default)(slots, $baaJf.getPickersDayUtilityClass, classes);
};
const $a215abe4b2054e88$var$styleArg = ({ theme: theme })=>(0, $a215abe4b2054e88$var$_extends2.default)({}, theme.typography.caption, {
        width: $99eO4.DAY_SIZE,
        height: $99eO4.DAY_SIZE,
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8xDHs.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8xDHs.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${$baaJf.pickersDayClasses.selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${$baaJf.pickersDayClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${$baaJf.pickersDayClasses.disabled}:not(.${$baaJf.pickersDayClasses.selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${$baaJf.pickersDayClasses.disabled}&.${$baaJf.pickersDayClasses.selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${$99eO4.DAY_MARGIN}px`
                }
            },
            {
                props: {
                    isDayOutsideMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    isDayCurrent: true
                },
                style: {
                    [`&:not(.${$baaJf.pickersDayClasses.selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $a215abe4b2054e88$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
        ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $a215abe4b2054e88$var$PickersDayRoot = (0, $8xDHs.styled)($a215abe4b2054e88$var$_ButtonBase.default, {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a215abe4b2054e88$var$overridesResolver
})($a215abe4b2054e88$var$styleArg);
const $a215abe4b2054e88$var$PickersDayFiller = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a215abe4b2054e88$var$overridesResolver
})(({ theme: theme })=>(0, $a215abe4b2054e88$var$_extends2.default)({}, $a215abe4b2054e88$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $a215abe4b2054e88$var$noop = ()=>{};
const $a215abe4b2054e88$var$PickersDayRaw = /*#__PURE__*/ $a215abe4b2054e88$var$React.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, classes: classesProp, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $a215abe4b2054e88$var$noop, onBlur: onBlur = $a215abe4b2054e88$var$noop, onKeyDown: onKeyDown = $a215abe4b2054e88$var$noop, onMouseDown: onMouseDown = $a215abe4b2054e88$var$noop, onMouseEnter: onMouseEnter = $a215abe4b2054e88$var$noop, children: children, day: day, selected: selected, disabled: disabled, today: today, outsideCurrentMonth: outsideCurrentMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = props, other = (0, $a215abe4b2054e88$var$_objectWithoutPropertiesLoose2.default)(props, $a215abe4b2054e88$var$_excluded);
    const ownerState = (0, $iFeOh.usePickerDayOwnerState)({
        day: day,
        selected: selected,
        disabled: disabled,
        today: today,
        outsideCurrentMonth: outsideCurrentMonth,
        disableMargin: disableMargin,
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const classes = $a215abe4b2054e88$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $3nE24.usePickerAdapter)();
    const ref = $a215abe4b2054e88$var$React.useRef(null);
    const handleRef = (0, $a215abe4b2054e88$var$_useForkRef.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $a215abe4b2054e88$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        event.defaultMuiPrevented = true;
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $ayMG0.jsx)($a215abe4b2054e88$var$PickersDayFiller, {
        className: (0, $a215abe4b2054e88$var$_clsx.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a215abe4b2054e88$var$PickersDayRoot, (0, $a215abe4b2054e88$var$_extends2.default)({
        className: (0, $a215abe4b2054e88$var$_clsx.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: children ?? adapter.format(day, 'dayOfMonth')
    }));
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * API:
 *
 * - [PickersDay API](https://mui.com/x/api/date-pickers/pickers-day/)
 */ const $a215abe4b2054e88$var$PickersDay = module.exports.PickersDay = /*#__PURE__*/ $a215abe4b2054e88$var$React.memo($a215abe4b2054e88$var$PickersDayRaw);

});
parcelRegister("baaJf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8208f360828d6fb0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersDayUtilityClass = $8208f360828d6fb0$var$getPickersDayUtilityClass;
module.exports.pickersDayClasses = void 0;

var $8208f360828d6fb0$var$_generateUtilityClass = $8208f360828d6fb0$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $8208f360828d6fb0$var$_generateUtilityClasses = $8208f360828d6fb0$require$_interopRequireDefault((parcelRequire("5nY49")));
function $8208f360828d6fb0$var$getPickersDayUtilityClass(slot) {
    return (0, $8208f360828d6fb0$var$_generateUtilityClass.default)('MuiPickersDay', slot);
}
const $8208f360828d6fb0$var$pickersDayClasses = module.exports.pickersDayClasses = (0, $8208f360828d6fb0$var$_generateUtilityClasses.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);

});

parcelRegister("iFeOh", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d9678b4949009dc3$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d9678b4949009dc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usePickerDayOwnerState = $d9678b4949009dc3$var$usePickerDayOwnerState;

var $d9678b4949009dc3$var$_extends2 = $d9678b4949009dc3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d9678b4949009dc3$var$React = $d9678b4949009dc3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7OOd8 = parcelRequire("7OOd8");

var $3nE24 = parcelRequire("3nE24");
function $d9678b4949009dc3$var$usePickerDayOwnerState(parameters) {
    const { disabled: disabled, selected: selected, today: today, outsideCurrentMonth: outsideCurrentMonth, day: day, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = parameters;
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    return $d9678b4949009dc3$var$React.useMemo(()=>(0, $d9678b4949009dc3$var$_extends2.default)({}, pickerOwnerState, {
            day: day,
            isDaySelected: selected ?? false,
            isDayDisabled: disabled ?? false,
            isDayCurrent: today ?? false,
            isDayOutsideMonth: outsideCurrentMonth ?? false,
            isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
            isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
            disableMargin: disableMargin ?? false,
            disableHighlightToday: disableHighlightToday ?? false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
        }), [
        adapter,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}

});



parcelRegister("3wpx4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29082a754ce64855$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $29082a754ce64855$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersSlideTransition = $29082a754ce64855$var$PickersSlideTransition;

var $29082a754ce64855$var$_extends2 = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $29082a754ce64855$var$_objectWithoutPropertiesLoose2 = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("c05no")));

var $29082a754ce64855$var$React = $29082a754ce64855$require$_interopRequireWildcard((parcelRequire("acw62")));

var $29082a754ce64855$var$_clsx = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $29082a754ce64855$var$_composeClasses = $29082a754ce64855$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $jEvxL = parcelRequire("jEvxL");
var $krPIU = parcelRequire("krPIU");

var $ha1fF = parcelRequire("ha1fF");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $29082a754ce64855$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $29082a754ce64855$var$useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $29082a754ce64855$var$_composeClasses.default)(slots, $ha1fF.getPickersSlideTransitionUtilityClass, classes);
};
const $29082a754ce64855$var$PickersSlideTransitionRoot = (0, $8xDHs.styled)($jEvxL.default, {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses.slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses.slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${$ha1fF.pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
/**
 * @ignore - do not document.
 */ function $29082a754ce64855$var$PickersSlideTransition(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey, classes: classesProp } = props, other = (0, $29082a754ce64855$var$_objectWithoutPropertiesLoose2.default)(props, $29082a754ce64855$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $29082a754ce64855$var$_extends2.default)({}, pickerOwnerState, {
        slideDirection: slideDirection
    });
    const classes = $29082a754ce64855$var$useUtilityClasses(classesProp, ownerState);
    const theme = (0, $8xDHs.useTheme)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $29082a754ce64855$var$_clsx.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($29082a754ce64855$var$PickersSlideTransitionRoot, {
        className: (0, $29082a754ce64855$var$_clsx.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $29082a754ce64855$var$React.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($krPIU.default, (0, $29082a754ce64855$var$_extends2.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}

});
parcelRegister("krPIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2e736fe07a2c40$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $8pZ1o = parcelRequire("8pZ1o");

var $gFyrF = parcelRequire("gFyrF");

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");


var $4NYRH = parcelRequire("4NYRH");
var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8pZ1o.default)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $gFyrF.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $4NYRH.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $1En50.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1mPeS.default), (0, $8nd05.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;

});
parcelRegister("8pZ1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $620ffe1c3bcccf8e$export$2e2bcd8739ae039);

var $59GJ0 = parcelRequire("59GJ0");
function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $59GJ0.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("59GJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0eef4e7b8d3866$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("gFyrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22b31c675df16bf$export$2e2bcd8739ae039);
function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});


parcelRegister("ha1fF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c7e4576059c0fe7a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pickersSlideTransitionClasses = module.exports.getPickersSlideTransitionUtilityClass = void 0;

var $c7e4576059c0fe7a$var$_generateUtilityClass = $c7e4576059c0fe7a$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $c7e4576059c0fe7a$var$_generateUtilityClasses = $c7e4576059c0fe7a$require$_interopRequireDefault((parcelRequire("5nY49")));
const $c7e4576059c0fe7a$var$getPickersSlideTransitionUtilityClass = (slot)=>(0, $c7e4576059c0fe7a$var$_generateUtilityClass.default)('MuiPickersSlideTransition', slot);
module.exports.getPickersSlideTransitionUtilityClass = $c7e4576059c0fe7a$var$getPickersSlideTransitionUtilityClass;
const $c7e4576059c0fe7a$var$pickersSlideTransitionClasses = module.exports.pickersSlideTransitionClasses = (0, $c7e4576059c0fe7a$var$_generateUtilityClasses.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);

});


parcelRegister("66c8j", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $01255dca2f143194$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDayCalendarUtilityClass = module.exports.dayCalendarClasses = void 0;

var $01255dca2f143194$var$_generateUtilityClass = $01255dca2f143194$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $01255dca2f143194$var$_generateUtilityClasses = $01255dca2f143194$require$_interopRequireDefault((parcelRequire("5nY49")));
const $01255dca2f143194$var$getDayCalendarUtilityClass = (slot)=>(0, $01255dca2f143194$var$_generateUtilityClass.default)('MuiDayCalendar', slot);
module.exports.getDayCalendarUtilityClass = $01255dca2f143194$var$getDayCalendarUtilityClass;
const $01255dca2f143194$var$dayCalendarClasses = module.exports.dayCalendarClasses = (0, $01255dca2f143194$var$_generateUtilityClasses.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);

});


parcelRegister("gYuM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MonthCalendar", {
    enumerable: true,
    get: function() {
        return $7aXUm.MonthCalendar;
    }
});
Object.defineProperty(module.exports, "getMonthCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return $yRsP7.getMonthCalendarUtilityClass;
    }
});
Object.defineProperty(module.exports, "monthCalendarClasses", {
    enumerable: true,
    get: function() {
        return $yRsP7.monthCalendarClasses;
    }
});

var $7aXUm = parcelRequire("7aXUm");

var $yRsP7 = parcelRequire("yRsP7");

});
parcelRegister("7aXUm", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $5397f01707da67a7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $5397f01707da67a7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonthCalendar = void 0;
module.exports.useMonthCalendarDefaultizedProps = $5397f01707da67a7$var$useMonthCalendarDefaultizedProps;

var $5397f01707da67a7$var$_objectWithoutPropertiesLoose2 = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("c05no")));

var $5397f01707da67a7$var$_extends2 = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $5397f01707da67a7$var$React = $5397f01707da67a7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5397f01707da67a7$var$_propTypes = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5397f01707da67a7$var$_clsx = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9uEev = parcelRequire("9uEev");

var $bbeCr = parcelRequire("bbeCr");

var $8xDHs = parcelRequire("8xDHs");

var $5397f01707da67a7$var$_useControlled = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $5397f01707da67a7$var$_composeClasses = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5397f01707da67a7$var$_useEventCallback = $5397f01707da67a7$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $cm4Q0 = parcelRequire("cm4Q0");

var $3vagl = parcelRequire("3vagl");

var $yRsP7 = parcelRequire("yRsP7");

var $NRNex = parcelRequire("NRNex");

var $1M3bL = parcelRequire("1M3bL");

var $gUrai = parcelRequire("gUrai");

var $hagTn = parcelRequire("hagTn");

var $99eO4 = parcelRequire("99eO4");

var $7OOd8 = parcelRequire("7OOd8");

var $1aSwN = parcelRequire("1aSwN");

var $3nE24 = parcelRequire("3nE24");

var $ayMG0 = parcelRequire("ayMG0");
const $5397f01707da67a7$var$_excluded = [
    "autoFocus",
    "className",
    "currentMonth",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $5397f01707da67a7$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $5397f01707da67a7$var$_composeClasses.default)(slots, $yRsP7.getMonthCalendarUtilityClass, classes);
};
function $5397f01707da67a7$var$useMonthCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $8xDHs.useThemeProps)({
        props: props,
        name: name
    });
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, $5397f01707da67a7$var$_extends2.default)({}, themeProps, validationProps, {
        monthsPerRow: themeProps.monthsPerRow ?? 3
    });
}
const $5397f01707da67a7$var$isSameMonth = (monthA, monthB, yearA, yearB, adapter)=>Boolean(monthA === monthB && yearB && adapter.isSameYear(yearA, yearB));
const $5397f01707da67a7$var$MonthCalendarRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: $99eO4.DIALOG_WIDTH,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [MonthCalendar API](https://mui.com/x/api/date-pickers/month-calendar/)
 */ const $5397f01707da67a7$var$MonthCalendar = module.exports.MonthCalendar = /*#__PURE__*/ $5397f01707da67a7$var$React.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $5397f01707da67a7$var$useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
    const { autoFocus: autoFocus, className: className, currentMonth: currentMonth, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $5397f01707da67a7$var$_objectWithoutPropertiesLoose2.default)(props, $5397f01707da67a7$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const now = (0, $3vagl.useNow)(timezone);
    const isRtl = (0, $9uEev.useRtl)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const referenceDate = $5397f01707da67a7$var$React.useMemo(()=>$1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $5397f01707da67a7$var$useUtilityClasses(classesProp);
    const todayMonth = $5397f01707da67a7$var$React.useMemo(()=>adapter.getMonth(now), [
        adapter,
        now
    ]);
    const selectedMonth = $5397f01707da67a7$var$React.useMemo(()=>{
        if (value != null) return adapter.getMonth(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedMonth, setFocusedMonth] = $5397f01707da67a7$var$React.useState(()=>selectedMonth || adapter.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $5397f01707da67a7$var$_useControlled.default)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $5397f01707da67a7$var$_useEventCallback.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $5397f01707da67a7$var$React.useCallback((dateToValidate)=>{
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = adapter.startOfMonth(dateToValidate);
        if (adapter.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (adapter.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        adapter
    ]);
    const handleMonthSelection = (0, $5397f01707da67a7$var$_useEventCallback.default)((_event, month)=>{
        if (readOnly) return;
        const currentValue = value && currentMonth && !adapter.isSameYear(value, currentMonth) ? adapter.setYear(value, adapter.getYear(currentMonth)) : value;
        // When no value is selected yet but a year was chosen (via YearCalendar),
        // prefer using currentMonth (which carries the selected year) over the initial referenceDate.
        // Fix for: https://github.com/mui/mui-x/issues/20624
        const baseDateForMonth = currentValue ?? currentMonth ?? referenceDate;
        const newDate = adapter.setMonth(baseDateForMonth, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $5397f01707da67a7$var$_useEventCallback.default)((month)=>{
        if (!isMonthDisabled(adapter.setMonth(value ?? currentMonth ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $5397f01707da67a7$var$React.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleMonthSelection(event, month);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $5397f01707da67a7$var$_useEventCallback.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5397f01707da67a7$var$MonthCalendarRoot, (0, $5397f01707da67a7$var$_extends2.default)({
        ref: ref,
        className: (0, $5397f01707da67a7$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, $NRNex.getMonthsInYear)(adapter, currentMonth ?? value ?? referenceDate).map((month)=>{
            const monthNumber = adapter.getMonth(month);
            const monthText = adapter.format(month, 'monthShort');
            const monthLabel = adapter.format(month, 'month');
            const isSelected = $5397f01707da67a7$var$isSameMonth(monthNumber, selectedMonth, month, value, adapter);
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $ayMG0.jsx)($cm4Q0.MonthCalendarButton, {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": $5397f01707da67a7$var$isSameMonth(monthNumber, todayMonth, month, now, adapter) ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});

});
parcelRegister("cm4Q0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8feb4accebf80a5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8feb4accebf80a5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonthCalendarButton = void 0;

var $8feb4accebf80a5e$var$_objectWithoutPropertiesLoose2 = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("c05no")));

var $8feb4accebf80a5e$var$_extends2 = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8feb4accebf80a5e$var$React = $8feb4accebf80a5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $8feb4accebf80a5e$var$_useSlotProps = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("839K0")));

var $8feb4accebf80a5e$var$_composeClasses = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8feb4accebf80a5e$var$_useEnhancedEffect = $8feb4accebf80a5e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $7OOd8 = parcelRequire("7OOd8");

var $yRsP7 = parcelRequire("yRsP7");

var $ayMG0 = parcelRequire("ayMG0");
const $8feb4accebf80a5e$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $8feb4accebf80a5e$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, $8feb4accebf80a5e$var$_composeClasses.default)(slots, $yRsP7.getMonthCalendarUtilityClass, classes);
};
const $8feb4accebf80a5e$var$DefaultMonthButton = (0, $8xDHs.styled)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${$yRsP7.monthCalendarClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${$yRsP7.monthCalendarClasses.selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $8feb4accebf80a5e$var$_extends2.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8xDHs.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8xDHs.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${$yRsP7.monthCalendarClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${$yRsP7.monthCalendarClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
/**
 * @ignore - do not document.
 */ const $8feb4accebf80a5e$var$MonthCalendarButton = module.exports.MonthCalendarButton = /*#__PURE__*/ $8feb4accebf80a5e$var$React.memo(function MonthCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $8feb4accebf80a5e$var$_objectWithoutPropertiesLoose2.default)(props, $8feb4accebf80a5e$var$_excluded);
    const ref = $8feb4accebf80a5e$var$React.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $8feb4accebf80a5e$var$_extends2.default)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = $8feb4accebf80a5e$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $8feb4accebf80a5e$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $8feb4accebf80a5e$var$DefaultMonthButton;
    const monthButtonProps = (0, $8feb4accebf80a5e$var$_useSlotProps.default)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(MonthButton, (0, $8feb4accebf80a5e$var$_extends2.default)({}, monthButtonProps));
});

});
parcelRegister("yRsP7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $068ca5e81320aff6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMonthCalendarUtilityClass = $068ca5e81320aff6$var$getMonthCalendarUtilityClass;
module.exports.monthCalendarClasses = void 0;

var $068ca5e81320aff6$var$_generateUtilityClass = $068ca5e81320aff6$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $068ca5e81320aff6$var$_generateUtilityClasses = $068ca5e81320aff6$require$_interopRequireDefault((parcelRequire("5nY49")));
function $068ca5e81320aff6$var$getMonthCalendarUtilityClass(slot) {
    return (0, $068ca5e81320aff6$var$_generateUtilityClass.default)('MuiMonthCalendar', slot);
}
const $068ca5e81320aff6$var$monthCalendarClasses = module.exports.monthCalendarClasses = (0, $068ca5e81320aff6$var$_generateUtilityClasses.default)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

});




parcelRegister("haVKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "YearCalendar", {
    enumerable: true,
    get: function() {
        return $18Z8C.YearCalendar;
    }
});
Object.defineProperty(module.exports, "getYearCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return $7vcQG.getYearCalendarUtilityClass;
    }
});
Object.defineProperty(module.exports, "yearCalendarClasses", {
    enumerable: true,
    get: function() {
        return $7vcQG.yearCalendarClasses;
    }
});

var $18Z8C = parcelRequire("18Z8C");

var $7vcQG = parcelRequire("7vcQG");

});
parcelRegister("18Z8C", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0d55f68b977aee64$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0d55f68b977aee64$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.YearCalendar = void 0;

var $0d55f68b977aee64$var$_objectWithoutPropertiesLoose2 = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("c05no")));

var $0d55f68b977aee64$var$_extends2 = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $0d55f68b977aee64$var$React = $0d55f68b977aee64$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0d55f68b977aee64$var$_propTypes = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0d55f68b977aee64$var$_clsx = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("9QePP")));

var $9uEev = parcelRequire("9uEev");

var $bbeCr = parcelRequire("bbeCr");

var $8xDHs = parcelRequire("8xDHs");

var $0d55f68b977aee64$var$_useForkRef = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $0d55f68b977aee64$var$_composeClasses = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0d55f68b977aee64$var$_useControlled = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("iSpB2")));

var $0d55f68b977aee64$var$_useEventCallback = $0d55f68b977aee64$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $dpAAI = parcelRequire("dpAAI");

var $3vagl = parcelRequire("3vagl");

var $7vcQG = parcelRequire("7vcQG");

var $1M3bL = parcelRequire("1M3bL");

var $gUrai = parcelRequire("gUrai");

var $hagTn = parcelRequire("hagTn");

var $99eO4 = parcelRequire("99eO4");

var $7OOd8 = parcelRequire("7OOd8");

var $1aSwN = parcelRequire("1aSwN");

var $3nE24 = parcelRequire("3nE24");

var $ayMG0 = parcelRequire("ayMG0");
const $0d55f68b977aee64$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $0d55f68b977aee64$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $0d55f68b977aee64$var$_composeClasses.default)(slots, $7vcQG.getYearCalendarUtilityClass, classes);
};
function $0d55f68b977aee64$var$useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $8xDHs.useThemeProps)({
        props: props,
        name: name
    });
    const validationProps = (0, $1aSwN.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, $0d55f68b977aee64$var$_extends2.default)({}, themeProps, validationProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        yearsOrder: themeProps.yearsOrder ?? 'asc'
    });
}
const $0d55f68b977aee64$var$YearCalendarRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $bbeCr.shouldForwardProp)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: $99eO4.DIALOG_WIDTH,
    maxHeight: $99eO4.MAX_CALENDAR_HEIGHT,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const $0d55f68b977aee64$var$YearCalendarButtonFiller = (0, $8xDHs.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [YearCalendar API](https://mui.com/x/api/date-pickers/year-calendar/)
 */ const $0d55f68b977aee64$var$YearCalendar = module.exports.YearCalendar = /*#__PURE__*/ $0d55f68b977aee64$var$React.forwardRef(function YearCalendar(inProps, ref) {
    const props = $0d55f68b977aee64$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $0d55f68b977aee64$var$_objectWithoutPropertiesLoose2.default)(props, $0d55f68b977aee64$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const now = (0, $3vagl.useNow)(timezone);
    const isRtl = (0, $9uEev.useRtl)();
    const adapter = (0, $3nE24.usePickerAdapter)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const referenceDate = $0d55f68b977aee64$var$React.useMemo(()=>$1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $0d55f68b977aee64$var$useUtilityClasses(classesProp);
    const todayYear = $0d55f68b977aee64$var$React.useMemo(()=>adapter.getYear(now), [
        adapter,
        now
    ]);
    const selectedYear = $0d55f68b977aee64$var$React.useMemo(()=>{
        if (value != null) return adapter.getYear(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedYear, setFocusedYear] = $0d55f68b977aee64$var$React.useState(()=>selectedYear || adapter.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $0d55f68b977aee64$var$_useControlled.default)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $0d55f68b977aee64$var$_useEventCallback.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $0d55f68b977aee64$var$React.useCallback((dateToValidate)=>{
        if (disablePast && adapter.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && adapter.isAfterYear(dateToValidate, now)) return true;
        if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = adapter.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        adapter
    ]);
    const handleYearSelection = (0, $0d55f68b977aee64$var$_useEventCallback.default)((_event, year)=>{
        if (readOnly) return;
        const newDate = adapter.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $0d55f68b977aee64$var$_useEventCallback.default)((year)=>{
        if (!isYearDisabled(adapter.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $0d55f68b977aee64$var$React.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleYearSelection(event, year);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $0d55f68b977aee64$var$_useEventCallback.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $0d55f68b977aee64$var$React.useRef(null);
    const handleRef = (0, $0d55f68b977aee64$var$_useForkRef.default)(ref, scrollerRef);
    $0d55f68b977aee64$var$React.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = adapter.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d55f68b977aee64$var$YearCalendarRoot, (0, $0d55f68b977aee64$var$_extends2.default)({
        ref: handleRef,
        className: (0, $0d55f68b977aee64$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = adapter.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($dpAAI.YearCalendarButton, {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: adapter.format(year, 'year')
                }, adapter.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0d55f68b977aee64$var$YearCalendarButtonFiller, {}, index))
        ]
    }));
});

});
parcelRegister("dpAAI", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9c39fe654796b109$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9c39fe654796b109$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.YearCalendarButton = void 0;

var $9c39fe654796b109$var$_objectWithoutPropertiesLoose2 = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("c05no")));

var $9c39fe654796b109$var$_extends2 = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9c39fe654796b109$var$React = $9c39fe654796b109$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $9c39fe654796b109$var$_useSlotProps = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("839K0")));

var $9c39fe654796b109$var$_composeClasses = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $9c39fe654796b109$var$_useEnhancedEffect = $9c39fe654796b109$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $7OOd8 = parcelRequire("7OOd8");

var $7vcQG = parcelRequire("7vcQG");

var $ayMG0 = parcelRequire("ayMG0");
const $9c39fe654796b109$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $9c39fe654796b109$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, $9c39fe654796b109$var$_composeClasses.default)(slots, $7vcQG.getYearCalendarUtilityClass, classes);
};
const $9c39fe654796b109$var$DefaultYearButton = (0, $8xDHs.styled)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${$7vcQG.yearCalendarClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${$7vcQG.yearCalendarClasses.selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $9c39fe654796b109$var$_extends2.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8xDHs.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8xDHs.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${$7vcQG.yearCalendarClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${$7vcQG.yearCalendarClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
/**
 * @ignore - internal component.
 */ const $9c39fe654796b109$var$YearCalendarButton = module.exports.YearCalendarButton = /*#__PURE__*/ $9c39fe654796b109$var$React.memo(function YearCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $9c39fe654796b109$var$_objectWithoutPropertiesLoose2.default)(props, $9c39fe654796b109$var$_excluded);
    const ref = $9c39fe654796b109$var$React.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $9c39fe654796b109$var$_extends2.default)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = $9c39fe654796b109$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $9c39fe654796b109$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $9c39fe654796b109$var$DefaultYearButton;
    const yearButtonProps = (0, $9c39fe654796b109$var$_useSlotProps.default)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(YearButton, (0, $9c39fe654796b109$var$_extends2.default)({}, yearButtonProps));
});

});
parcelRegister("7vcQG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5765652a82ee3360$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getYearCalendarUtilityClass = $5765652a82ee3360$var$getYearCalendarUtilityClass;
module.exports.yearCalendarClasses = void 0;

var $5765652a82ee3360$var$_generateUtilityClass = $5765652a82ee3360$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $5765652a82ee3360$var$_generateUtilityClasses = $5765652a82ee3360$require$_interopRequireDefault((parcelRequire("5nY49")));
function $5765652a82ee3360$var$getYearCalendarUtilityClass(slot) {
    return (0, $5765652a82ee3360$var$_generateUtilityClass.default)('MuiYearCalendar', slot);
}
const $5765652a82ee3360$var$yearCalendarClasses = module.exports.yearCalendarClasses = (0, $5765652a82ee3360$var$_generateUtilityClasses.default)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

});




parcelRegister("dAsZ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersCalendarHeader", {
    enumerable: true,
    get: function() {
        return $91SiU.PickersCalendarHeader;
    }
});
Object.defineProperty(module.exports, "pickersCalendarHeaderClasses", {
    enumerable: true,
    get: function() {
        return $1YeNp.pickersCalendarHeaderClasses;
    }
});

var $1YeNp = parcelRequire("1YeNp");

var $91SiU = parcelRequire("91SiU");

});
parcelRegister("1YeNp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $16f6df38d2155e06$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pickersCalendarHeaderClasses = module.exports.getPickersCalendarHeaderUtilityClass = void 0;

var $16f6df38d2155e06$var$_generateUtilityClass = $16f6df38d2155e06$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $16f6df38d2155e06$var$_generateUtilityClasses = $16f6df38d2155e06$require$_interopRequireDefault((parcelRequire("5nY49")));
const $16f6df38d2155e06$var$getPickersCalendarHeaderUtilityClass = (slot)=>(0, $16f6df38d2155e06$var$_generateUtilityClass.default)('MuiPickersCalendarHeader', slot);
module.exports.getPickersCalendarHeaderUtilityClass = $16f6df38d2155e06$var$getPickersCalendarHeaderUtilityClass;
const $16f6df38d2155e06$var$pickersCalendarHeaderClasses = module.exports.pickersCalendarHeaderClasses = (0, $16f6df38d2155e06$var$_generateUtilityClasses.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);

});

parcelRegister("91SiU", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $692e54af110ba23d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $692e54af110ba23d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersCalendarHeader = void 0;

var $692e54af110ba23d$var$_objectWithoutPropertiesLoose2 = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("c05no")));

var $692e54af110ba23d$var$_extends2 = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $692e54af110ba23d$var$React = $692e54af110ba23d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $692e54af110ba23d$var$_propTypes = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $692e54af110ba23d$var$_clsx = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("9QePP")));

var $692e54af110ba23d$var$_Fade = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("5iZHj")));

var $8xDHs = parcelRequire("8xDHs");

var $692e54af110ba23d$var$_useSlotProps2 = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("839K0")));

var $692e54af110ba23d$var$_composeClasses = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $692e54af110ba23d$var$_IconButton = $692e54af110ba23d$require$_interopRequireDefault((parcelRequire("825Zh")));

var $BKARN = parcelRequire("BKARN");

var $eW408 = parcelRequire("eW408");

var $1SVAo = parcelRequire("1SVAo");

var $ecN6O = parcelRequire("ecN6O");

var $lfVfV = parcelRequire("lfVfV");

var $1YeNp = parcelRequire("1YeNp");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $692e54af110ba23d$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], $692e54af110ba23d$var$_excluded2 = [
    "ownerState"
];
const $692e54af110ba23d$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $692e54af110ba23d$var$_composeClasses.default)(slots, $1YeNp.getPickersCalendarHeaderUtilityClass, classes);
};
const $692e54af110ba23d$var$PickersCalendarHeaderRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $692e54af110ba23d$var$PickersCalendarHeaderLabelContainer = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme: theme })=>(0, $692e54af110ba23d$var$_extends2.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $692e54af110ba23d$var$PickersCalendarHeaderLabel = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewButton = (0, $8xDHs.styled)($692e54af110ba23d$var$_IconButton.default, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${$1YeNp.pickersCalendarHeaderClasses.switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewIcon = (0, $8xDHs.styled)($1SVAo.ArrowDropDownIcon, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $692e54af110ba23d$var$PickersCalendarHeader = module.exports.PickersCalendarHeader = /*#__PURE__*/ $692e54af110ba23d$var$React.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $BKARN.usePickerTranslations)();
    const adapter = (0, $BKARN.usePickerAdapter)();
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, classes: classesProp, timezone: timezone, format: format = `${adapter.formats.month} ${adapter.formats.year}` } = props, other = (0, $692e54af110ba23d$var$_objectWithoutPropertiesLoose2.default)(props, $692e54af110ba23d$var$_excluded);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const classes = $692e54af110ba23d$var$useUtilityClasses(classesProp);
    const SwitchViewButton = slots?.switchViewButton ?? $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $692e54af110ba23d$var$_useSlotProps2.default)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: (0, $692e54af110ba23d$var$_extends2.default)({}, ownerState, {
            view: view
        }),
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $692e54af110ba23d$var$_useSlotProps2.default)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $692e54af110ba23d$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $692e54af110ba23d$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(adapter.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(adapter.addMonths(month, -1));
    const isNextMonthDisabled = (0, $lfVfV.useNextMonthDisabled)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $lfVfV.usePreviousMonthDisabled)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = adapter.formatByString(month, format);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($692e54af110ba23d$var$PickersCalendarHeaderRoot, (0, $692e54af110ba23d$var$_extends2.default)({}, other, {
        ownerState: ownerState,
        className: (0, $692e54af110ba23d$var$_clsx.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($692e54af110ba23d$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($eW408.PickersFadeTransitionGroup, {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($692e54af110ba23d$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewButton, (0, $692e54af110ba23d$var$_extends2.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewIcon, (0, $692e54af110ba23d$var$_extends2.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($692e54af110ba23d$var$_Fade.default, {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ecN6O.PickersArrowSwitcher, {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});

});
parcelRegister("ecN6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickersArrowSwitcher", {
    enumerable: true,
    get: function() {
        return $b1I5K.PickersArrowSwitcher;
    }
});
Object.defineProperty(module.exports, "getPickersArrowSwitcherUtilityClass", {
    enumerable: true,
    get: function() {
        return $7cGQb.getPickersArrowSwitcherUtilityClass;
    }
});
Object.defineProperty(module.exports, "pickersArrowSwitcherClasses", {
    enumerable: true,
    get: function() {
        return $7cGQb.pickersArrowSwitcherClasses;
    }
});

var $b1I5K = parcelRequire("b1I5K");

var $7cGQb = parcelRequire("7cGQb");

});
parcelRegister("b1I5K", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8071fd6781eab512$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8071fd6781eab512$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickersArrowSwitcher = void 0;

var $8071fd6781eab512$var$_extends2 = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8071fd6781eab512$var$_objectWithoutPropertiesLoose2 = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("c05no")));

var $8071fd6781eab512$var$React = $8071fd6781eab512$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8071fd6781eab512$var$_clsx = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8071fd6781eab512$var$_Typography = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $9uEev = parcelRequire("9uEev");

var $8xDHs = parcelRequire("8xDHs");

var $8071fd6781eab512$var$_composeClasses = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $8071fd6781eab512$var$_useSlotProps3 = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("839K0")));

var $8071fd6781eab512$var$_IconButton = $8071fd6781eab512$require$_interopRequireDefault((parcelRequire("825Zh")));

var $1SVAo = parcelRequire("1SVAo");

var $7cGQb = parcelRequire("7cGQb");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $8071fd6781eab512$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], $8071fd6781eab512$var$_excluded2 = [
    "ownerState"
], $8071fd6781eab512$var$_excluded3 = [
    "ownerState"
];
const $8071fd6781eab512$var$PickersArrowSwitcherRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const $8071fd6781eab512$var$PickersArrowSwitcherSpacer = (0, $8xDHs.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $8071fd6781eab512$var$PickersArrowSwitcherButton = (0, $8xDHs.styled)($8071fd6781eab512$var$_IconButton.default, {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $8071fd6781eab512$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $8071fd6781eab512$var$_composeClasses.default)(slots, $7cGQb.getPickersArrowSwitcherUtilityClass, classes);
};
const $8071fd6781eab512$var$PickersArrowSwitcher = module.exports.PickersArrowSwitcher = /*#__PURE__*/ $8071fd6781eab512$var$React.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $9uEev.useRtl)();
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId, classes: classesProp } = props, other = (0, $8071fd6781eab512$var$_objectWithoutPropertiesLoose2.default)(props, $8071fd6781eab512$var$_excluded);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const classes = $8071fd6781eab512$var$useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $8071fd6781eab512$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $8071fd6781eab512$var$_extends2.default)({}, ownerState, {
            isButtonHidden: previousProps.isHidden ?? false
        }),
        className: (0, $8071fd6781eab512$var$_clsx.default)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $8071fd6781eab512$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $8071fd6781eab512$var$_extends2.default)({}, ownerState, {
            isButtonHidden: nextProps.isHidden ?? false
        }),
        className: (0, $8071fd6781eab512$var$_clsx.default)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? $1SVAo.ArrowLeftIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $8071fd6781eab512$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $8071fd6781eab512$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? $1SVAo.ArrowRightIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $8071fd6781eab512$var$_useSlotProps3.default)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $8071fd6781eab512$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps2, $8071fd6781eab512$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8071fd6781eab512$var$PickersArrowSwitcherRoot, (0, $8071fd6781eab512$var$_extends2.default)({
        ref: ref,
        className: (0, $8071fd6781eab512$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousIconButton, (0, $8071fd6781eab512$var$_extends2.default)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $ayMG0.jsx)($8071fd6781eab512$var$_Typography.default, {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($8071fd6781eab512$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextIconButton, (0, $8071fd6781eab512$var$_extends2.default)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $8071fd6781eab512$var$_extends2.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});

});
parcelRegister("7cGQb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $015a7f86ee044f5d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPickersArrowSwitcherUtilityClass = $015a7f86ee044f5d$var$getPickersArrowSwitcherUtilityClass;
module.exports.pickersArrowSwitcherClasses = void 0;

var $015a7f86ee044f5d$var$_generateUtilityClass = $015a7f86ee044f5d$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $015a7f86ee044f5d$var$_generateUtilityClasses = $015a7f86ee044f5d$require$_interopRequireDefault((parcelRequire("5nY49")));
function $015a7f86ee044f5d$var$getPickersArrowSwitcherUtilityClass(slot) {
    return (0, $015a7f86ee044f5d$var$_generateUtilityClass.default)('MuiPickersArrowSwitcher', slot);
}
const $015a7f86ee044f5d$var$pickersArrowSwitcherClasses = module.exports.pickersArrowSwitcherClasses = (0, $015a7f86ee044f5d$var$_generateUtilityClasses.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);

});





parcelRegister("fQ7ML", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "PickerViewRoot", {
    enumerable: true,
    get: function() {
        return $ghKQ9.PickerViewRoot;
    }
});

var $ghKQ9 = parcelRequire("ghKQ9");

});
parcelRegister("ghKQ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PickerViewRoot = void 0;

var $8xDHs = parcelRequire("8xDHs");

var $99eO4 = parcelRequire("99eO4");
const $bdb2915bd58d0724$var$PickerViewRoot = module.exports.PickerViewRoot = (0, $8xDHs.styled)('div', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    overflow: 'hidden',
    width: $99eO4.DIALOG_WIDTH,
    maxHeight: $99eO4.VIEW_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});

});


parcelRegister("e7rSK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a47758ea7aed0899$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDateCalendarUtilityClass = module.exports.dateCalendarClasses = void 0;

var $a47758ea7aed0899$var$_generateUtilityClass = $a47758ea7aed0899$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $a47758ea7aed0899$var$_generateUtilityClasses = $a47758ea7aed0899$require$_interopRequireDefault((parcelRequire("5nY49")));
const $a47758ea7aed0899$var$getDateCalendarUtilityClass = (slot)=>(0, $a47758ea7aed0899$var$_generateUtilityClass.default)('MuiDateCalendar', slot);
module.exports.getDateCalendarUtilityClass = $a47758ea7aed0899$var$getDateCalendarUtilityClass;
const $a47758ea7aed0899$var$dateCalendarClasses = module.exports.dateCalendarClasses = (0, $a47758ea7aed0899$var$_generateUtilityClasses.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);

});





parcelRegister("l5kHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "renderDigitalClockTimeView", {
    enumerable: true,
    get: function() {
        return $etqB7.renderDigitalClockTimeView;
    }
});
Object.defineProperty(module.exports, "renderMultiSectionDigitalClockTimeView", {
    enumerable: true,
    get: function() {
        return $etqB7.renderMultiSectionDigitalClockTimeView;
    }
});
Object.defineProperty(module.exports, "renderTimeViewClock", {
    enumerable: true,
    get: function() {
        return $etqB7.renderTimeViewClock;
    }
});

var $etqB7 = parcelRequire("etqB7");

});
parcelRegister("etqB7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderTimeViewClock = module.exports.renderMultiSectionDigitalClockTimeView = module.exports.renderDigitalClockTimeView = void 0;

var $c4qm5 = parcelRequire("c4qm5");

var $hOsJb = parcelRequire("hOsJb");

var $2QxZ0 = parcelRequire("2QxZ0");

var $cElCc = parcelRequire("cElCc");

var $ayMG0 = parcelRequire("ayMG0");
const $a89867de13b97115$var$renderTimeViewClock = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($c4qm5.TimeClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $cElCc.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter($cElCc.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
module.exports.renderTimeViewClock = $a89867de13b97115$var$renderTimeViewClock;
const $a89867de13b97115$var$renderDigitalClockTimeView = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($hOsJb.DigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $cElCc.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter($cElCc.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
module.exports.renderDigitalClockTimeView = $a89867de13b97115$var$renderDigitalClockTimeView;
const $a89867de13b97115$var$renderMultiSectionDigitalClockTimeView = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)($2QxZ0.MultiSectionDigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $cElCc.isInternalTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter($cElCc.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
module.exports.renderMultiSectionDigitalClockTimeView = $a89867de13b97115$var$renderMultiSectionDigitalClockTimeView;

});
parcelRegister("c4qm5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "TimeClock", {
    enumerable: true,
    get: function() {
        return $j3vom.TimeClock;
    }
});
Object.defineProperty(module.exports, "clockClasses", {
    enumerable: true,
    get: function() {
        return $87p9A.clockClasses;
    }
});
Object.defineProperty(module.exports, "clockNumberClasses", {
    enumerable: true,
    get: function() {
        return $3qpqB.clockNumberClasses;
    }
});
Object.defineProperty(module.exports, "clockPointerClasses", {
    enumerable: true,
    get: function() {
        return $jzIlH.clockPointerClasses;
    }
});
Object.defineProperty(module.exports, "getTimeClockUtilityClass", {
    enumerable: true,
    get: function() {
        return $dYrN2.getTimeClockUtilityClass;
    }
});
Object.defineProperty(module.exports, "timeClockClasses", {
    enumerable: true,
    get: function() {
        return $dYrN2.timeClockClasses;
    }
});

var $j3vom = parcelRequire("j3vom");

var $87p9A = parcelRequire("87p9A");

var $3qpqB = parcelRequire("3qpqB");

var $dYrN2 = parcelRequire("dYrN2");

var $jzIlH = parcelRequire("jzIlH");

});
parcelRegister("j3vom", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ddf6a5e91208f965$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ddf6a5e91208f965$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeClock = void 0;

var $ddf6a5e91208f965$var$_extends2 = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ddf6a5e91208f965$var$_objectWithoutPropertiesLoose2 = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("c05no")));

var $ddf6a5e91208f965$var$React = $ddf6a5e91208f965$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ddf6a5e91208f965$var$_clsx = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ddf6a5e91208f965$var$_propTypes = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $ddf6a5e91208f965$var$_composeClasses = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ddf6a5e91208f965$var$_useId = $ddf6a5e91208f965$require$_interopRequireDefault((parcelRequire("hwliF")));

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $ecN6O = parcelRequire("ecN6O");

var $cElCc = parcelRequire("cElCc");

var $3cW2G = parcelRequire("3cW2G");

var $lfVfV = parcelRequire("lfVfV");

var $fQ7ML = parcelRequire("fQ7ML");

var $dYrN2 = parcelRequire("dYrN2");

var $jHpqT = parcelRequire("jHpqT");

var $dRi4s = parcelRequire("dRi4s");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $gBP5e = parcelRequire("gBP5e");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $ddf6a5e91208f965$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "timezone"
];
const $ddf6a5e91208f965$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $ddf6a5e91208f965$var$_composeClasses.default)(slots, $dYrN2.getTimeClockUtilityClass, classes);
};
const $ddf6a5e91208f965$var$TimeClockRoot = (0, $8xDHs.styled)($fQ7ML.PickerViewRoot, {
    name: 'MuiTimeClock',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const $ddf6a5e91208f965$var$TimeClockArrowSwitcher = (0, $8xDHs.styled)($ecN6O.PickersArrowSwitcher, {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher'
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $ddf6a5e91208f965$var$TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [TimeClock](https://mui.com/x/react-date-pickers/time-clock/)
 *
 * API:
 *
 * - [TimeClock API](https://mui.com/x/api/date-pickers/time-clock/)
 */ const $ddf6a5e91208f965$var$TimeClock = module.exports.TimeClock = /*#__PURE__*/ $ddf6a5e91208f965$var$React.forwardRef(function TimeClock(inProps, ref) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $ddf6a5e91208f965$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $ddf6a5e91208f965$var$_objectWithoutPropertiesLoose2.default)(props, $ddf6a5e91208f965$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const valueOrReferenceDate = (0, $gBP5e.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const now = (0, $3vagl.useNow)(timezone);
    const selectedId = (0, $ddf6a5e91208f965$var$_useId.default)();
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $lfVfV.useMeridiemMode)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $ddf6a5e91208f965$var$React.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const viewProps = $ddf6a5e91208f965$var$React.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, 'hours');
                    };
                    const viewValue = adapter.getHours(valueOrReferenceDate);
                    let viewRange;
                    if (ampm) {
                        if (viewValue > 12) viewRange = [
                            12,
                            23
                        ];
                        else viewRange = [
                            0,
                            11
                        ];
                    } else viewRange = [
                        0,
                        23
                    ];
                    return {
                        onChange: handleHoursChange,
                        viewValue: viewValue,
                        children: (0, $dRi4s.getHourNumbers)({
                            value: value,
                            adapter: adapter,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId: selectedId
                        }),
                        viewRange: viewRange
                    };
                }
            case 'minutes':
                {
                    const minutesValue = adapter.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minuteValue), isFinish, 'minutes');
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $dRi4s.getMinutesNumbers)({
                            adapter: adapter,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId: selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            case 'seconds':
                {
                    const secondsValue = adapter.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, secondValue), isFinish, 'seconds');
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $dRi4s.getMinutesNumbers)({
                            adapter: adapter,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId: selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        adapter,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const classes = $ddf6a5e91208f965$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ddf6a5e91208f965$var$TimeClockRoot, (0, $ddf6a5e91208f965$var$_extends2.default)({
        ref: ref,
        className: (0, $ddf6a5e91208f965$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($jHpqT.Clock, (0, $ddf6a5e91208f965$var$_extends2.default)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $ayMG0.jsx)($ddf6a5e91208f965$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});

});
parcelRegister("dYrN2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a2c66f75362e3156$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTimeClockUtilityClass = $a2c66f75362e3156$var$getTimeClockUtilityClass;
module.exports.timeClockClasses = void 0;

var $a2c66f75362e3156$var$_generateUtilityClass = $a2c66f75362e3156$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $a2c66f75362e3156$var$_generateUtilityClasses = $a2c66f75362e3156$require$_interopRequireDefault((parcelRequire("5nY49")));
function $a2c66f75362e3156$var$getTimeClockUtilityClass(slot) {
    return (0, $a2c66f75362e3156$var$_generateUtilityClass.default)('MuiTimeClock', slot);
}
const $a2c66f75362e3156$var$timeClockClasses = module.exports.timeClockClasses = (0, $a2c66f75362e3156$var$_generateUtilityClasses.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);

});

parcelRegister("jHpqT", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $e575c2e563c85584$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e575c2e563c85584$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Clock = $e575c2e563c85584$var$Clock;

var $e575c2e563c85584$var$_extends2 = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e575c2e563c85584$var$React = $e575c2e563c85584$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e575c2e563c85584$var$_clsx = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("9QePP")));

var $e575c2e563c85584$var$_IconButton = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("825Zh")));

var $e575c2e563c85584$var$_Typography = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("2dUd7")));

var $8xDHs = parcelRequire("8xDHs");

var $e575c2e563c85584$var$_useEnhancedEffect = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $e575c2e563c85584$var$_composeClasses = $e575c2e563c85584$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $5Nqk8 = parcelRequire("5Nqk8");

var $BKARN = parcelRequire("BKARN");

var $2aAi1 = parcelRequire("2aAi1");

var $87p9A = parcelRequire("87p9A");

var $NRNex = parcelRequire("NRNex");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $e575c2e563c85584$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton',
            ownerState.clockMeridiemMode === 'am' && 'selected'
        ],
        pmButton: [
            'pmButton',
            ownerState.clockMeridiemMode === 'pm' && 'selected'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, $e575c2e563c85584$var$_composeClasses.default)(slots, $87p9A.getClockUtilityClass, classes);
};
const $e575c2e563c85584$var$ClockRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiClock',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $e575c2e563c85584$var$ClockClock = (0, $8xDHs.styled)('div', {
    name: 'MuiClock',
    slot: 'Clock'
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $e575c2e563c85584$var$ClockWrapper = (0, $8xDHs.styled)('div', {
    name: 'MuiClock',
    slot: 'Wrapper'
})({
    '&:focus': {
        outline: 'none'
    }
});
const $e575c2e563c85584$var$ClockSquareMask = (0, $8xDHs.styled)('div', {
    name: 'MuiClock',
    slot: 'SquareMask'
})({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    variants: [
        {
            props: {
                isClockDisabled: false
            },
            style: {
                '@media (pointer: fine)': {
                    cursor: 'pointer',
                    borderRadius: '50%'
                },
                '&:active': {
                    cursor: 'move'
                }
            }
        }
    ]
});
const $e575c2e563c85584$var$ClockPin = (0, $8xDHs.styled)('div', {
    name: 'MuiClock',
    slot: 'Pin'
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $e575c2e563c85584$var$meridiemButtonCommonStyles = (theme, clockMeridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: $2aAi1.CLOCK_HOUR_WIDTH,
        variants: [
            {
                props: {
                    clockMeridiemMode: clockMeridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const $e575c2e563c85584$var$ClockAmButton = (0, $8xDHs.styled)($e575c2e563c85584$var$_IconButton.default, {
    name: 'MuiClock',
    slot: 'AmButton'
})(({ theme: theme })=>(0, $e575c2e563c85584$var$_extends2.default)({}, $e575c2e563c85584$var$meridiemButtonCommonStyles(theme, 'am'), {
        // keeping it here to make TS happy
        position: 'absolute',
        left: 8
    }));
const $e575c2e563c85584$var$ClockPmButton = (0, $8xDHs.styled)($e575c2e563c85584$var$_IconButton.default, {
    name: 'MuiClock',
    slot: 'PmButton'
})(({ theme: theme })=>(0, $e575c2e563c85584$var$_extends2.default)({}, $e575c2e563c85584$var$meridiemButtonCommonStyles(theme, 'pm'), {
        // keeping it here to make TS happy
        position: 'absolute',
        right: 8
    }));
const $e575c2e563c85584$var$ClockMeridiemText = (0, $8xDHs.styled)($e575c2e563c85584$var$_Typography.default, {
    name: 'MuiClock',
    slot: 'MeridiemText'
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
/**
 * @ignore - internal component.
 */ function $e575c2e563c85584$var$Clock(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, viewRange: [minViewValue, maxViewValue], disabled: disabled = false, readOnly: readOnly, className: className, classes: classesProp } = props;
    const adapter = (0, $BKARN.usePickerAdapter)();
    const translations = (0, $BKARN.usePickerTranslations)();
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $e575c2e563c85584$var$_extends2.default)({}, pickerOwnerState, {
        isClockDisabled: disabled,
        clockMeridiemMode: meridiemMode
    });
    const isMoving = $e575c2e563c85584$var$React.useRef(false);
    const classes = $e575c2e563c85584$var$useUtilityClasses(classesProp, ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $2aAi1.getMinutes)(offsetX, offsetY, minutesStep) : (0, $2aAi1.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
        event.preventDefault();
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const isPointerBetweenTwoClockValues = type === 'hours' ? false : viewValue % 5 !== 0;
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $e575c2e563c85584$var$React.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $e575c2e563c85584$var$_useEnhancedEffect.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const clampValue = (newValue)=>Math.max(minViewValue, Math.min(maxViewValue, newValue));
    const circleValue = (newValue)=>(newValue + (maxViewValue + 1)) % (maxViewValue + 1);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // reset both hours and minutes
                handleValueChange(minViewValue, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(maxViewValue, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(circleValue(viewValue + keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(circleValue(viewValue - keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'PageUp':
                handleValueChange(clampValue(viewValue + 5), 'partial');
                event.preventDefault();
                break;
            case 'PageDown':
                handleValueChange(clampValue(viewValue - 5), 'partial');
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleValueChange(viewValue, 'finish');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$ClockRoot, {
        className: (0, $e575c2e563c85584$var$_clsx.default)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: ownerState,
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$React.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $ayMG0.jsx)($5Nqk8.ClockPointer, {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                isBetweenTwoClockValues: isPointerBetweenTwoClockValues
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value == null ? null : adapter.format(value, ampm ? 'fullTime12h' : 'fullTime24h')),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $ayMG0.jsxs)($e575c2e563c85584$var$React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $NRNex.formatMeridiem)(adapter, 'am'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $NRNex.formatMeridiem)(adapter, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $NRNex.formatMeridiem)(adapter, 'pm'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e575c2e563c85584$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $NRNex.formatMeridiem)(adapter, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("5Nqk8", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4385f2b113626448$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4385f2b113626448$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClockPointer = $4385f2b113626448$var$ClockPointer;

var $4385f2b113626448$var$_extends2 = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $4385f2b113626448$var$_objectWithoutPropertiesLoose2 = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("c05no")));

var $4385f2b113626448$var$React = $4385f2b113626448$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4385f2b113626448$var$_clsx = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $4385f2b113626448$var$_composeClasses = $4385f2b113626448$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2aAi1 = parcelRequire("2aAi1");

var $jzIlH = parcelRequire("jzIlH");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $4385f2b113626448$var$_excluded = [
    "className",
    "classes",
    "isBetweenTwoClockValues",
    "isInner",
    "type",
    "viewValue"
];
const $4385f2b113626448$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $4385f2b113626448$var$_composeClasses.default)(slots, $jzIlH.getClockPointerUtilityClass, classes);
};
const $4385f2b113626448$var$ClockPointerRoot = (0, $8xDHs.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Root'
})(({ theme: theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px',
        variants: [
            {
                props: {
                    isClockPointerAnimated: true
                },
                style: {
                    transition: theme.transitions.create([
                        'transform',
                        'height'
                    ])
                }
            }
        ]
    }));
const $4385f2b113626448$var$ClockPointerThumb = (0, $8xDHs.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb'
})(({ theme: theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${$2aAi1.CLOCK_HOUR_WIDTH / 2}px)`,
        border: `${($2aAi1.CLOCK_HOUR_WIDTH - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box',
        variants: [
            {
                props: {
                    isClockPointerBetweenTwoValues: false
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function $4385f2b113626448$var$ClockPointer(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, classes: classesProp, isBetweenTwoClockValues: isBetweenTwoClockValues, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $4385f2b113626448$var$_objectWithoutPropertiesLoose2.default)(props, $4385f2b113626448$var$_excluded);
    const previousType = $4385f2b113626448$var$React.useRef(type);
    $4385f2b113626448$var$React.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $4385f2b113626448$var$_extends2.default)({}, pickerOwnerState, {
        isClockPointerAnimated: previousType.current !== type,
        isClockPointerBetweenTwoValues: isBetweenTwoClockValues
    });
    const classes = $4385f2b113626448$var$useUtilityClasses(classesProp);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * $2aAi1.CLOCK_WIDTH),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4385f2b113626448$var$ClockPointerRoot, (0, $4385f2b113626448$var$_extends2.default)({
        style: getAngleStyle(),
        className: (0, $4385f2b113626448$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4385f2b113626448$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

});
parcelRegister("2aAi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMinutes = module.exports.getHours = module.exports.CLOCK_WIDTH = module.exports.CLOCK_HOUR_WIDTH = void 0;
const $1948aa4fa91b9e03$var$CLOCK_WIDTH = module.exports.CLOCK_WIDTH = 220;
const $1948aa4fa91b9e03$var$CLOCK_HOUR_WIDTH = module.exports.CLOCK_HOUR_WIDTH = 36;
const $1948aa4fa91b9e03$var$clockCenter = {
    x: $1948aa4fa91b9e03$var$CLOCK_WIDTH / 2,
    y: $1948aa4fa91b9e03$var$CLOCK_WIDTH / 2
};
const $1948aa4fa91b9e03$var$baseClockPoint = {
    x: $1948aa4fa91b9e03$var$clockCenter.x,
    y: 0
};
const $1948aa4fa91b9e03$var$cx = $1948aa4fa91b9e03$var$baseClockPoint.x - $1948aa4fa91b9e03$var$clockCenter.x;
const $1948aa4fa91b9e03$var$cy = $1948aa4fa91b9e03$var$baseClockPoint.y - $1948aa4fa91b9e03$var$clockCenter.y;
const $1948aa4fa91b9e03$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $1948aa4fa91b9e03$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $1948aa4fa91b9e03$var$clockCenter.x;
    const y = offsetY - $1948aa4fa91b9e03$var$clockCenter.y;
    const atan = Math.atan2($1948aa4fa91b9e03$var$cx, $1948aa4fa91b9e03$var$cy) - Math.atan2(x, y);
    let deg = $1948aa4fa91b9e03$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $1948aa4fa91b9e03$var$getMinutes = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $1948aa4fa91b9e03$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
module.exports.getMinutes = $1948aa4fa91b9e03$var$getMinutes;
const $1948aa4fa91b9e03$var$getHours = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $1948aa4fa91b9e03$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $1948aa4fa91b9e03$var$CLOCK_WIDTH / 2 - $1948aa4fa91b9e03$var$CLOCK_HOUR_WIDTH) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};
module.exports.getHours = $1948aa4fa91b9e03$var$getHours;

});

parcelRegister("jzIlH", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e403b003f661ed3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clockPointerClasses = void 0;
module.exports.getClockPointerUtilityClass = $e403b003f661ed3d$var$getClockPointerUtilityClass;

var $e403b003f661ed3d$var$_generateUtilityClass = $e403b003f661ed3d$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $e403b003f661ed3d$var$_generateUtilityClasses = $e403b003f661ed3d$require$_interopRequireDefault((parcelRequire("5nY49")));
function $e403b003f661ed3d$var$getClockPointerUtilityClass(slot) {
    return (0, $e403b003f661ed3d$var$_generateUtilityClass.default)('MuiClockPointer', slot);
}
const $e403b003f661ed3d$var$clockPointerClasses = module.exports.clockPointerClasses = (0, $e403b003f661ed3d$var$_generateUtilityClasses.default)('MuiClockPointer', [
    'root',
    'thumb'
]);

});


parcelRegister("87p9A", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5e927d23a0de1f23$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clockClasses = void 0;
module.exports.getClockUtilityClass = $5e927d23a0de1f23$var$getClockUtilityClass;

var $5e927d23a0de1f23$var$_generateUtilityClass = $5e927d23a0de1f23$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $5e927d23a0de1f23$var$_generateUtilityClasses = $5e927d23a0de1f23$require$_interopRequireDefault((parcelRequire("5nY49")));
function $5e927d23a0de1f23$var$getClockUtilityClass(slot) {
    return (0, $5e927d23a0de1f23$var$_generateUtilityClass.default)('MuiClock', slot);
}
const $5e927d23a0de1f23$var$clockClasses = module.exports.clockClasses = (0, $5e927d23a0de1f23$var$_generateUtilityClasses.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText',
    'selected'
]);

});


parcelRegister("dRi4s", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $a16e3e169e75b2e9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMinutesNumbers = module.exports.getHourNumbers = void 0;

var $a16e3e169e75b2e9$var$React = $a16e3e169e75b2e9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $dvTuG = parcelRequire("dvTuG");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ const $a16e3e169e75b2e9$var$getHourNumbers = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, adapter: adapter })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = adapter.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $ayMG0.jsx)($dvTuG.ClockNumber, {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
module.exports.getHourNumbers = $a16e3e169e75b2e9$var$getHourNumbers;
const $a16e3e169e75b2e9$var$getMinutesNumbers = ({ adapter: adapter, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = adapter.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($dvTuG.ClockNumber, {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};
module.exports.getMinutesNumbers = $a16e3e169e75b2e9$var$getMinutesNumbers;

});
parcelRegister("dvTuG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9d69378f413baf58$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9d69378f413baf58$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClockNumber = $9d69378f413baf58$var$ClockNumber;

var $9d69378f413baf58$var$_objectWithoutPropertiesLoose2 = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("c05no")));

var $9d69378f413baf58$var$_extends2 = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9d69378f413baf58$var$React = $9d69378f413baf58$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9d69378f413baf58$var$_clsx = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $9d69378f413baf58$var$_composeClasses = $9d69378f413baf58$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2aAi1 = parcelRequire("2aAi1");

var $3qpqB = parcelRequire("3qpqB");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $9d69378f413baf58$var$_excluded = [
    "className",
    "classes",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $9d69378f413baf58$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root',
            ownerState.isClockNumberSelected && 'selected',
            ownerState.isClockNumberDisabled && 'disabled'
        ]
    };
    return (0, $9d69378f413baf58$var$_composeClasses.default)(slots, $3qpqB.getClockNumberUtilityClass, classes);
};
const $9d69378f413baf58$var$ClockNumberRoot = (0, $8xDHs.styled)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${$3qpqB.clockNumberClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${$3qpqB.clockNumberClasses.selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        height: $2aAi1.CLOCK_HOUR_WIDTH,
        width: $2aAi1.CLOCK_HOUR_WIDTH,
        position: 'absolute',
        left: `calc((100% - ${$2aAi1.CLOCK_HOUR_WIDTH}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${$3qpqB.clockNumberClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${$3qpqB.clockNumberClasses.disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    isClockNumberInInnerRing: true
                },
                style: (0, $9d69378f413baf58$var$_extends2.default)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function $9d69378f413baf58$var$ClockNumber(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, classes: classesProp, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $9d69378f413baf58$var$_objectWithoutPropertiesLoose2.default)(props, $9d69378f413baf58$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $9d69378f413baf58$var$_extends2.default)({}, pickerOwnerState, {
        isClockNumberInInnerRing: inner,
        isClockNumberSelected: selected,
        isClockNumberDisabled: disabled
    });
    const classes = $9d69378f413baf58$var$useUtilityClasses(classesProp, ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ($2aAi1.CLOCK_WIDTH - $2aAi1.CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9d69378f413baf58$var$ClockNumberRoot, (0, $9d69378f413baf58$var$_extends2.default)({
        className: (0, $9d69378f413baf58$var$_clsx.default)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ($2aAi1.CLOCK_WIDTH - $2aAi1.CLOCK_HOUR_WIDTH) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

});
parcelRegister("3qpqB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $27e7864e7261f573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clockNumberClasses = void 0;
module.exports.getClockNumberUtilityClass = $27e7864e7261f573$var$getClockNumberUtilityClass;

var $27e7864e7261f573$var$_generateUtilityClass = $27e7864e7261f573$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $27e7864e7261f573$var$_generateUtilityClasses = $27e7864e7261f573$require$_interopRequireDefault((parcelRequire("5nY49")));
function $27e7864e7261f573$var$getClockNumberUtilityClass(slot) {
    return (0, $27e7864e7261f573$var$_generateUtilityClass.default)('MuiClockNumber', slot);
}
const $27e7864e7261f573$var$clockNumberClasses = module.exports.clockNumberClasses = (0, $27e7864e7261f573$var$_generateUtilityClasses.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);

});



parcelRegister("gBP5e", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c177ba245e259df4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useClockReferenceDate = void 0;

var $c177ba245e259df4$var$React = $c177ba245e259df4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1M3bL = parcelRequire("1M3bL");

var $NRNex = parcelRequire("NRNex");

var $gUrai = parcelRequire("gUrai");
const $c177ba245e259df4$var$useClockReferenceDate = ({ value: value, referenceDate: referenceDateProp, adapter: adapter, props: props, timezone: timezone })=>{
    const referenceDate = $c177ba245e259df4$var$React.useMemo(()=>$1M3bL.singleItemValueManager.getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            referenceDate: referenceDateProp,
            granularity: $gUrai.SECTION_TYPE_GRANULARITY.day,
            timezone: timezone,
            getTodayDate: ()=>(0, $NRNex.getTodayDate)(adapter, timezone, 'date')
        }), // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    [
        referenceDateProp,
        timezone
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};
module.exports.useClockReferenceDate = $c177ba245e259df4$var$useClockReferenceDate;

});



parcelRegister("hOsJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DigitalClock", {
    enumerable: true,
    get: function() {
        return $exqUd.DigitalClock;
    }
});
Object.defineProperty(module.exports, "DigitalClockItem", {
    enumerable: true,
    get: function() {
        return $exqUd.DigitalClockItem;
    }
});
Object.defineProperty(module.exports, "digitalClockClasses", {
    enumerable: true,
    get: function() {
        return $dYkom.digitalClockClasses;
    }
});
Object.defineProperty(module.exports, "getDigitalClockUtilityClass", {
    enumerable: true,
    get: function() {
        return $dYkom.getDigitalClockUtilityClass;
    }
});

var $exqUd = parcelRequire("exqUd");

var $dYkom = parcelRequire("dYkom");

});
parcelRegister("exqUd", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a95904b0c8aa06aa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a95904b0c8aa06aa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DigitalClockItem = module.exports.DigitalClock = void 0;

var $a95904b0c8aa06aa$var$_extends2 = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a95904b0c8aa06aa$var$_objectWithoutPropertiesLoose2 = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("c05no")));

var $a95904b0c8aa06aa$var$React = $a95904b0c8aa06aa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a95904b0c8aa06aa$var$_clsx = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("9QePP")));

var $a95904b0c8aa06aa$var$_propTypes = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a95904b0c8aa06aa$var$_useSlotProps = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("839K0")));

var $8xDHs = parcelRequire("8xDHs");

var $a95904b0c8aa06aa$var$_useEventCallback = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $a95904b0c8aa06aa$var$_composeClasses = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a95904b0c8aa06aa$var$_MenuItem = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $a95904b0c8aa06aa$var$_MenuList = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $a95904b0c8aa06aa$var$_useForkRef = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $a95904b0c8aa06aa$var$_useEnhancedEffect = $a95904b0c8aa06aa$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $cElCc = parcelRequire("cElCc");

var $fQ7ML = parcelRequire("fQ7ML");

var $dYkom = parcelRequire("dYkom");

var $3cW2G = parcelRequire("3cW2G");

var $99eO4 = parcelRequire("99eO4");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $gBP5e = parcelRequire("gBP5e");

var $l16rr = parcelRequire("l16rr");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $a95904b0c8aa06aa$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $a95904b0c8aa06aa$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, $a95904b0c8aa06aa$var$_composeClasses.default)(slots, $dYkom.getDigitalClockUtilityClass, classes);
};
const $a95904b0c8aa06aa$var$DigitalClockRoot = (0, $8xDHs.styled)($fQ7ML.PickerViewRoot, {
    name: 'MuiDigitalClock',
    slot: 'Root'
})({
    overflowY: 'auto',
    width: '100%',
    scrollbarWidth: 'thin',
    '@media (prefers-reduced-motion: no-preference)': {
        scrollBehavior: 'auto'
    },
    maxHeight: $99eO4.DIGITAL_CLOCK_VIEW_HEIGHT,
    variants: [
        {
            props: {
                hasDigitalClockAlreadyBeenRendered: true
            },
            style: {
                '@media (prefers-reduced-motion: no-preference)': {
                    scrollBehavior: 'smooth'
                }
            }
        }
    ]
});
const $a95904b0c8aa06aa$var$DigitalClockList = (0, $8xDHs.styled)($a95904b0c8aa06aa$var$_MenuList.default, {
    name: 'MuiDigitalClock',
    slot: 'List'
})({
    padding: 0
});
const $a95904b0c8aa06aa$var$DigitalClockItem = module.exports.DigitalClockItem = (0, $8xDHs.styled)($a95904b0c8aa06aa$var$_MenuItem.default, {
    name: 'MuiDigitalClock',
    slot: 'Item',
    shouldForwardProp: (prop)=>prop !== 'itemValue' && prop !== 'formattedValue'
})(({ theme: theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8xDHs.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8xDHs.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [DigitalClock](https://mui.com/x/react-date-pickers/digital-clock/)
 *
 * API:
 *
 * - [DigitalClock API](https://mui.com/x/api/date-pickers/digital-clock/)
 */ const $a95904b0c8aa06aa$var$DigitalClock = module.exports.DigitalClock = /*#__PURE__*/ $a95904b0c8aa06aa$var$React.forwardRef(function DigitalClock(inProps, ref) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const containerRef = $a95904b0c8aa06aa$var$React.useRef(null);
    const handleRef = (0, $a95904b0c8aa06aa$var$_useForkRef.default)(ref, containerRef);
    const listRef = $a95904b0c8aa06aa$var$React.useRef(null);
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, views: views = [
        'hours'
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $a95904b0c8aa06aa$var$_objectWithoutPropertiesLoose2.default)(props, $a95904b0c8aa06aa$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const now = (0, $3vagl.useNow)(timezone);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $a95904b0c8aa06aa$var$_extends2.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = $a95904b0c8aa06aa$var$useUtilityClasses(classesProp);
    const ClockItem = slots?.digitalClockItem ?? $a95904b0c8aa06aa$var$DigitalClockItem;
    const clockItemProps = (0, $a95904b0c8aa06aa$var$_useSlotProps.default)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: ownerState,
        className: classes.item
    });
    const valueOrReferenceDate = (0, $gBP5e.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $a95904b0c8aa06aa$var$_useEventCallback.default)((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $a95904b0c8aa06aa$var$_useEventCallback.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    (0, $a95904b0c8aa06aa$var$_useEnhancedEffect.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $a95904b0c8aa06aa$var$React.useCallback((valueToCheck)=>{
        const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (adapter.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        adapter,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = $a95904b0c8aa06aa$var$React.useMemo(()=>{
        const result = [];
        const startOfDay = adapter.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(adapter.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = adapter.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        adapter
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>adapter.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a95904b0c8aa06aa$var$DigitalClockRoot, (0, $a95904b0c8aa06aa$var$_extends2.default)({
        ref: handleRef,
        className: (0, $a95904b0c8aa06aa$var$_clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a95904b0c8aa06aa$var$DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                const optionDisabled = isTimeDisabled(option);
                if (skipDisabled && optionDisabled) return null;
                const isSelected = adapter.isEqual(option, value);
                const formattedValue = adapter.format(option, ampm ? 'fullTime12h' : 'fullTime24h');
                const isFocused = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0;
                const tabIndex = isFocused ? 0 : -1;
                return /*#__PURE__*/ (0, $ayMG0.jsx)(ClockItem, (0, $a95904b0c8aa06aa$var$_extends2.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || optionDisabled,
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex,
                    itemValue: option,
                    formattedValue: formattedValue
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});

});
parcelRegister("dYkom", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a2c0b25d5f0c5c41$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.digitalClockClasses = void 0;
module.exports.getDigitalClockUtilityClass = $a2c0b25d5f0c5c41$var$getDigitalClockUtilityClass;

var $a2c0b25d5f0c5c41$var$_generateUtilityClass = $a2c0b25d5f0c5c41$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $a2c0b25d5f0c5c41$var$_generateUtilityClasses = $a2c0b25d5f0c5c41$require$_interopRequireDefault((parcelRequire("5nY49")));
function $a2c0b25d5f0c5c41$var$getDigitalClockUtilityClass(slot) {
    return (0, $a2c0b25d5f0c5c41$var$_generateUtilityClass.default)('MuiDigitalClock', slot);
}
const $a2c0b25d5f0c5c41$var$digitalClockClasses = module.exports.digitalClockClasses = (0, $a2c0b25d5f0c5c41$var$_generateUtilityClasses.default)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);

});



parcelRegister("2QxZ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "MultiSectionDigitalClock", {
    enumerable: true,
    get: function() {
        return $eGsTL.MultiSectionDigitalClock;
    }
});
Object.defineProperty(module.exports, "getMultiSectionDigitalClockUtilityClass", {
    enumerable: true,
    get: function() {
        return $idkVD.getMultiSectionDigitalClockUtilityClass;
    }
});
Object.defineProperty(module.exports, "multiSectionDigitalClockClasses", {
    enumerable: true,
    get: function() {
        return $idkVD.multiSectionDigitalClockClasses;
    }
});
Object.defineProperty(module.exports, "multiSectionDigitalClockSectionClasses", {
    enumerable: true,
    get: function() {
        return $6fquT.multiSectionDigitalClockSectionClasses;
    }
});

var $eGsTL = parcelRequire("eGsTL");

var $6fquT = parcelRequire("6fquT");

var $idkVD = parcelRequire("idkVD");

});
parcelRegister("eGsTL", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ab0b678aa6d5d752$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ab0b678aa6d5d752$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultiSectionDigitalClock = void 0;

var $ab0b678aa6d5d752$var$_extends2 = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ab0b678aa6d5d752$var$_objectWithoutPropertiesLoose2 = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("c05no")));

var $ab0b678aa6d5d752$var$React = $ab0b678aa6d5d752$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ab0b678aa6d5d752$var$_clsx = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("9QePP")));

var $ab0b678aa6d5d752$var$_propTypes = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9uEev = parcelRequire("9uEev");

var $8xDHs = parcelRequire("8xDHs");

var $ab0b678aa6d5d752$var$_useEventCallback = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $ab0b678aa6d5d752$var$_composeClasses = $ab0b678aa6d5d752$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $BKARN = parcelRequire("BKARN");

var $3vagl = parcelRequire("3vagl");

var $cElCc = parcelRequire("cElCc");

var $3cW2G = parcelRequire("3cW2G");

var $lfVfV = parcelRequire("lfVfV");

var $fQ7ML = parcelRequire("fQ7ML");

var $idkVD = parcelRequire("idkVD");

var $eynvO = parcelRequire("eynvO");

var $lPzno = parcelRequire("lPzno");

var $hagTn = parcelRequire("hagTn");

var $1M3bL = parcelRequire("1M3bL");

var $gBP5e = parcelRequire("gBP5e");

var $NRNex = parcelRequire("NRNex");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $ab0b678aa6d5d752$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $ab0b678aa6d5d752$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $ab0b678aa6d5d752$var$_composeClasses.default)(slots, $idkVD.getMultiSectionDigitalClockUtilityClass, classes);
};
const $ab0b678aa6d5d752$var$MultiSectionDigitalClockRoot = (0, $8xDHs.styled)($fQ7ML.PickerViewRoot, {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root'
})(({ theme: theme })=>({
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [DigitalClock](https://mui.com/x/react-date-pickers/digital-clock/)
 *
 * API:
 *
 * - [MultiSectionDigitalClock API](https://mui.com/x/api/date-pickers/multi-section-digital-clock/)
 */ const $ab0b678aa6d5d752$var$MultiSectionDigitalClock = module.exports.MultiSectionDigitalClock = /*#__PURE__*/ $ab0b678aa6d5d752$var$React.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const adapter = (0, $BKARN.usePickerAdapter)();
    const isRtl = (0, $9uEev.useRtl)();
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $ab0b678aa6d5d752$var$_objectWithoutPropertiesLoose2.default)(props, $ab0b678aa6d5d752$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $hagTn.useControlledValue)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: $1M3bL.singleItemValueManager
    });
    const translations = (0, $BKARN.usePickerTranslations)();
    const now = (0, $3vagl.useNow)(timezone);
    const timeSteps = $ab0b678aa6d5d752$var$React.useMemo(()=>(0, $ab0b678aa6d5d752$var$_extends2.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $gBP5e.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $ab0b678aa6d5d752$var$_useEventCallback.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $ab0b678aa6d5d752$var$React.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $3cW2G.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $ab0b678aa6d5d752$var$_useEventCallback.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $lfVfV.useMeridiemMode)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = $ab0b678aa6d5d752$var$React.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $cElCc.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $ab0b678aa6d5d752$var$React.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $cElCc.convertValueToMeridiem)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: (0, $lPzno.getHourSectionOptions)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        adapter: adapter,
                        isDisabled: (hours)=>isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate: valueOrReferenceDate
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: (0, $lPzno.getTimeSectionOptions)({
                        value: adapter.getMinutes(valueOrReferenceDate),
                        adapter: adapter,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>adapter.format(adapter.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: (0, $lPzno.getTimeSectionOptions)({
                        value: adapter.getSeconds(valueOrReferenceDate),
                        adapter: adapter,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>adapter.format(adapter.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, $NRNex.formatMeridiem)(adapter, 'am');
                    const pmLabel = (0, $NRNex.formatMeridiem)(adapter, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        adapter,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = $ab0b678aa6d5d752$var$React.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== 'meridiem');
        digitViews.reverse();
        if (views.includes('meridiem')) digitViews.push('meridiem');
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = $ab0b678aa6d5d752$var$React.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $ab0b678aa6d5d752$var$_extends2.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const { ownerState: ownerState } = (0, $7OOd8.usePickerPrivateContext)();
    const classes = $ab0b678aa6d5d752$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab0b678aa6d5d752$var$MultiSectionDigitalClockRoot, (0, $ab0b678aa6d5d752$var$_extends2.default)({
        ref: ref,
        className: (0, $ab0b678aa6d5d752$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eynvO.MultiSectionDigitalClockSection, {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus || focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});

});
parcelRegister("idkVD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d429acda3bdcbd14$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMultiSectionDigitalClockUtilityClass = $d429acda3bdcbd14$var$getMultiSectionDigitalClockUtilityClass;
module.exports.multiSectionDigitalClockClasses = void 0;

var $d429acda3bdcbd14$var$_generateUtilityClass = $d429acda3bdcbd14$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $d429acda3bdcbd14$var$_generateUtilityClasses = $d429acda3bdcbd14$require$_interopRequireDefault((parcelRequire("5nY49")));
function $d429acda3bdcbd14$var$getMultiSectionDigitalClockUtilityClass(slot) {
    return (0, $d429acda3bdcbd14$var$_generateUtilityClass.default)('MuiMultiSectionDigitalClock', slot);
}
const $d429acda3bdcbd14$var$multiSectionDigitalClockClasses = module.exports.multiSectionDigitalClockClasses = (0, $d429acda3bdcbd14$var$_generateUtilityClasses.default)('MuiMultiSectionDigitalClock', [
    'root'
]);

});

parcelRegister("eynvO", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a9867aae4b0582f7$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a9867aae4b0582f7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultiSectionDigitalClockSection = void 0;

var $a9867aae4b0582f7$var$_extends2 = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a9867aae4b0582f7$var$_objectWithoutPropertiesLoose2 = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("c05no")));

var $a9867aae4b0582f7$var$React = $a9867aae4b0582f7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a9867aae4b0582f7$var$_clsx = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $a9867aae4b0582f7$var$_composeClasses = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a9867aae4b0582f7$var$_MenuList = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("8qqwQ")));

var $a9867aae4b0582f7$var$_MenuItem = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("iZ4W7")));

var $a9867aae4b0582f7$var$_useForkRef = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $a9867aae4b0582f7$var$_useEnhancedEffect = $a9867aae4b0582f7$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $6fquT = parcelRequire("6fquT");

var $99eO4 = parcelRequire("99eO4");

var $l16rr = parcelRequire("l16rr");

var $7OOd8 = parcelRequire("7OOd8");

var $ayMG0 = parcelRequire("ayMG0");
const $a9867aae4b0582f7$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $a9867aae4b0582f7$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, $a9867aae4b0582f7$var$_composeClasses.default)(slots, $6fquT.getMultiSectionDigitalClockSectionUtilityClass, classes);
};
const $a9867aae4b0582f7$var$MultiSectionDigitalClockSectionRoot = (0, $8xDHs.styled)($a9867aae4b0582f7$var$_MenuList.default, {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root'
})(({ theme: theme })=>({
        maxHeight: $99eO4.DIGITAL_CLOCK_VIEW_HEIGHT,
        width: 56,
        padding: 0,
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        variants: [
            {
                props: {
                    hasDigitalClockAlreadyBeenRendered: true
                },
                style: {
                    '@media (prefers-reduced-motion: no-preference)': {
                        scrollBehavior: 'smooth'
                    }
                }
            }
        ]
    }));
const $a9867aae4b0582f7$var$MultiSectionDigitalClockSectionItem = (0, $8xDHs.styled)($a9867aae4b0582f7$var$_MenuItem.default, {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item'
})(({ theme: theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: $99eO4.MULTI_SECTION_CLOCK_SECTION_WIDTH,
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8xDHs.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8xDHs.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
/**
 * @ignore - internal component.
 */ const $a9867aae4b0582f7$var$MultiSectionDigitalClockSection = module.exports.MultiSectionDigitalClockSection = /*#__PURE__*/ $a9867aae4b0582f7$var$React.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = $a9867aae4b0582f7$var$React.useRef(null);
    const handleRef = (0, $a9867aae4b0582f7$var$_useForkRef.default)(ref, containerRef);
    const previousActive = $a9867aae4b0582f7$var$React.useRef(null);
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $a9867aae4b0582f7$var$_objectWithoutPropertiesLoose2.default)(props, $a9867aae4b0582f7$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $7OOd8.usePickerPrivateContext)();
    const ownerState = (0, $a9867aae4b0582f7$var$_extends2.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = $a9867aae4b0582f7$var$useUtilityClasses(classesProp);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? $a9867aae4b0582f7$var$MultiSectionDigitalClockSectionItem;
    (0, $a9867aae4b0582f7$var$_useEnhancedEffect.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        const itemHeight = activeItem.offsetHeight;
        const containerHeight = containerRef.current.clientHeight;
        const scrollableHeight = containerRef.current.scrollHeight;
        // Calculate the ideal centered position
        const centeredPosition = offsetTop - containerHeight / 2 + itemHeight / 2;
        // Calculate the maximum scroll position that would show content at the bottom
        const maxScrollTop = scrollableHeight - containerHeight;
        // If centering would create empty space at the bottom, align the last items to the bottom instead
        const scrollPosition = Math.min(centeredPosition, maxScrollTop);
        // Ensure we don't scroll past the top
        containerRef.current.scrollTop = Math.max(0, scrollPosition);
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, $l16rr.getFocusedListItemIndex)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a9867aae4b0582f7$var$MultiSectionDigitalClockSectionRoot, (0, $a9867aae4b0582f7$var$_extends2.default)({
        ref: handleRef,
        className: (0, $a9867aae4b0582f7$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(DigitalClockSectionItem, (0, $a9867aae4b0582f7$var$_extends2.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});

});
parcelRegister("6fquT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $48c8b29a513664e2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMultiSectionDigitalClockSectionUtilityClass = $48c8b29a513664e2$var$getMultiSectionDigitalClockSectionUtilityClass;
module.exports.multiSectionDigitalClockSectionClasses = void 0;

var $48c8b29a513664e2$var$_generateUtilityClass = $48c8b29a513664e2$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $48c8b29a513664e2$var$_generateUtilityClasses = $48c8b29a513664e2$require$_interopRequireDefault((parcelRequire("5nY49")));
function $48c8b29a513664e2$var$getMultiSectionDigitalClockSectionUtilityClass(slot) {
    return (0, $48c8b29a513664e2$var$_generateUtilityClass.default)('MuiMultiSectionDigitalClockSection', slot);
}
const $48c8b29a513664e2$var$multiSectionDigitalClockSectionClasses = module.exports.multiSectionDigitalClockSectionClasses = (0, $48c8b29a513664e2$var$_generateUtilityClasses.default)('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);

});


parcelRegister("lPzno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTimeSectionOptions = module.exports.getHourSectionOptions = void 0;
const $fe49cd62fa638160$var$getHourSectionOptions = ({ now: now, value: value, adapter: adapter, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep, valueOrReferenceDate: valueOrReferenceDate })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, adapter.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = adapter.format(adapter.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = adapter.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
module.exports.getHourSectionOptions = $fe49cd62fa638160$var$getHourSectionOptions;
const $fe49cd62fa638160$var$getTimeSectionOptions = ({ value: value, adapter: adapter, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: adapter.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};
module.exports.getTimeSectionOptions = $fe49cd62fa638160$var$getTimeSectionOptions;

});







parcelRegister("5bAd0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AdapterDayjs", {
    enumerable: true,
    get: function() {
        return $cyblR.AdapterDayjs;
    }
});

var $cyblR = parcelRequire("cyblR");

});
parcelRegister("cyblR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9231773518718bc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdapterDayjs = void 0;

var $9231773518718bc3$var$_extends2 = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9231773518718bc3$var$_dayjs = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("gngdn")));

var $9231773518718bc3$var$_weekOfYear = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("ccPny")));

var $9231773518718bc3$var$_customParseFormat = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("lHTSI")));

var $9231773518718bc3$var$_localizedFormat = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("egN1l")));

var $9231773518718bc3$var$_isBetween = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("6HkVm")));

var $9231773518718bc3$var$_advancedFormat = $9231773518718bc3$require$_interopRequireDefault((parcelRequire("f6zku")));

/* v8 ignore start */ // dayjs has no exports field defined
// See https://github.com/iamkun/dayjs/issues/2562
/* eslint-disable import/extensions */ /* v8 ignore stop */ /* eslint-enable import/extensions */ $9231773518718bc3$var$_dayjs.default.extend($9231773518718bc3$var$_localizedFormat.default);
$9231773518718bc3$var$_dayjs.default.extend($9231773518718bc3$var$_weekOfYear.default);
$9231773518718bc3$var$_dayjs.default.extend($9231773518718bc3$var$_isBetween.default);
$9231773518718bc3$var$_dayjs.default.extend($9231773518718bc3$var$_advancedFormat.default);
const $9231773518718bc3$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $9231773518718bc3$var$defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    dayOfMonthFull: 'Do',
    weekday: 'dddd',
    weekdayShort: 'dd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const $9231773518718bc3$var$MISSING_UTC_PLUGIN = [
    'Missing UTC plugin',
    'To be able to use UTC or timezones, you have to enable the `utc` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'
].join('\n');
const $9231773518718bc3$var$MISSING_TIMEZONE_PLUGIN = [
    'Missing timezone plugin',
    'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'
].join('\n');
/**
 * Based on `@date-io/dayjs`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class $9231773518718bc3$var$AdapterDayjs {
    isMUIAdapter = true;
    isTimezoneCompatible = true;
    lib = 'dayjs';
    escapedCharacters = {
        start: '[',
        end: ']'
    };
    formatTokenMap = $9231773518718bc3$var$formatTokenMap;
    constructor({ locale: locale, formats: formats } = {}){
        this.locale = locale;
        this.formats = (0, $9231773518718bc3$var$_extends2.default)({}, $9231773518718bc3$var$defaultFormats, formats);
        // Moved plugins to the constructor to allow for users to use options on the library
        // for reference: https://github.com/mui/mui-x/pull/11151
        $9231773518718bc3$var$_dayjs.default.extend($9231773518718bc3$var$_customParseFormat.default);
    }
    setLocaleToValue = (value)=>{
        const expectedLocale = this.getCurrentLocaleCode();
        if (expectedLocale === value.locale()) return value;
        return value.locale(expectedLocale);
    };
    hasUTCPlugin = ()=>typeof $9231773518718bc3$var$_dayjs.default.utc !== 'undefined';
    hasTimezonePlugin = ()=>typeof $9231773518718bc3$var$_dayjs.default.tz !== 'undefined';
    isSame = (value, comparing, comparisonTemplate)=>{
        const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
        return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
    };
    /**
   * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
   */ cleanTimezone = (timezone)=>{
        switch(timezone){
            case 'default':
                return undefined;
            case 'system':
                return $9231773518718bc3$var$_dayjs.default.tz.guess();
            default:
                return timezone;
        }
    };
    createSystemDate = (value)=>{
        let date;
        if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
            const timezone = $9231773518718bc3$var$_dayjs.default.tz.guess();
            if (timezone === 'UTC') date = (0, $9231773518718bc3$var$_dayjs.default)(value);
            else // We can't change the system timezone in the tests
            date = $9231773518718bc3$var$_dayjs.default.tz(value, timezone);
        } else date = (0, $9231773518718bc3$var$_dayjs.default)(value);
        return this.setLocaleToValue(date);
    };
    createUTCDate = (value)=>{
        /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) throw new Error($9231773518718bc3$var$MISSING_UTC_PLUGIN);
        return this.setLocaleToValue($9231773518718bc3$var$_dayjs.default.utc(value));
    };
    createTZDate = (value, timezone)=>{
        /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) throw new Error($9231773518718bc3$var$MISSING_UTC_PLUGIN);
        /* v8 ignore next 3 */ if (!this.hasTimezonePlugin()) throw new Error($9231773518718bc3$var$MISSING_TIMEZONE_PLUGIN);
        const keepLocalTime = value !== undefined && !value.endsWith('Z');
        return this.setLocaleToValue((0, $9231773518718bc3$var$_dayjs.default)(value).tz(this.cleanTimezone(timezone), keepLocalTime));
    };
    getLocaleFormats = ()=>{
        const locales = $9231773518718bc3$var$_dayjs.default.Ls;
        const locale = this.locale || 'en';
        let localeObject = locales[locale];
        if (localeObject === undefined) /* v8 ignore stop */ localeObject = locales.en;
        return localeObject.formats;
    };
    /**
   * If the new day does not have the same offset as the old one (when switching to summer day time for example),
   * Then dayjs will not automatically adjust the offset (moment does).
   * We have to parse again the value to make sure the `fixOffset` method is applied.
   * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
   */ adjustOffset = (value)=>{
        if (!this.hasTimezonePlugin()) return value;
        const timezone = this.getTimezone(value);
        if (timezone !== 'UTC') {
            const fixedValue = value.tz(this.cleanTimezone(timezone), true);
            // TODO: Simplify the case when we raise the `dayjs` peer dep to 1.11.12 (https://github.com/iamkun/dayjs/releases/tag/v1.11.12)
            /* v8 ignore next 3 */ // @ts-ignore
            if (fixedValue.$offset === (value.$offset ?? 0)) return value;
            // Change only what is needed to avoid creating a new object with unwanted data
            // Especially important when used in an environment where utc or timezone dates are used only in some places
            // Reference: https://github.com/mui/mui-x/issues/13290
            // @ts-ignore
            value.$offset = fixedValue.$offset;
        }
        return value;
    };
    date = (value, timezone = 'default')=>{
        if (value === null) return null;
        if (timezone === 'UTC') return this.createUTCDate(value);
        if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) return this.createSystemDate(value);
        return this.createTZDate(value, timezone);
    };
    getInvalidDate = ()=>(0, $9231773518718bc3$var$_dayjs.default)(new Date('Invalid date'));
    getTimezone = (value)=>{
        if (this.hasTimezonePlugin()) {
            // @ts-ignore
            const zone = value.$x?.$timezone;
            if (zone) return zone;
        }
        if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
        return 'system';
    };
    setTimezone = (value, timezone)=>{
        if (this.getTimezone(value) === timezone) return value;
        if (timezone === 'UTC') {
            /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) throw new Error($9231773518718bc3$var$MISSING_UTC_PLUGIN);
            return value.utc();
        }
        // We know that we have the UTC plugin.
        // Otherwise, the value timezone would always equal "system".
        // And it would be caught by the first "if" of this method.
        if (timezone === 'system') return value.local();
        if (!this.hasTimezonePlugin()) {
            if (timezone === 'default') return value;
            /* v8 ignore next */ throw new Error($9231773518718bc3$var$MISSING_TIMEZONE_PLUGIN);
        }
        return this.setLocaleToValue($9231773518718bc3$var$_dayjs.default.tz(value, this.cleanTimezone(timezone)));
    };
    toJsDate = (value)=>{
        return value.toDate();
    };
    parse = (value, format)=>{
        if (value === '') return null;
        return (0, $9231773518718bc3$var$_dayjs.default)(value, format, this.locale, true);
    };
    getCurrentLocaleCode = ()=>{
        return this.locale || 'en';
    };
    is12HourCycleInCurrentLocale = ()=>{
        /* v8 ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
    };
    expandFormat = (format)=>{
        const localeFormats = this.getLocaleFormats();
        // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
        const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
        return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
            const B = b && b.toUpperCase();
            return a || localeFormats[b] || t(localeFormats[B]);
        });
    };
    isValid = (value)=>{
        if (value == null) return false;
        return value.isValid();
    };
    format = (value, formatKey)=>{
        return this.formatByString(value, this.formats[formatKey]);
    };
    formatByString = (value, formatString)=>{
        return this.setLocaleToValue(value).format(formatString);
    };
    formatNumber = (numberToFormat)=>{
        return numberToFormat;
    };
    isEqual = (value, comparing)=>{
        if (value === null && comparing === null) return true;
        if (value === null || comparing === null) return false;
        return value.toDate().getTime() === comparing.toDate().getTime();
    };
    isSameYear = (value, comparing)=>{
        return this.isSame(value, comparing, 'YYYY');
    };
    isSameMonth = (value, comparing)=>{
        return this.isSame(value, comparing, 'YYYY-MM');
    };
    isSameDay = (value, comparing)=>{
        return this.isSame(value, comparing, 'YYYY-MM-DD');
    };
    isSameHour = (value, comparing)=>{
        return value.isSame(comparing, 'hour');
    };
    isAfter = (value, comparing)=>{
        return value > comparing;
    };
    isAfterYear = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
        return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
    };
    isAfterDay = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
        return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
    };
    isBefore = (value, comparing)=>{
        return value < comparing;
    };
    isBeforeYear = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
        return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
    };
    isBeforeDay = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
        return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
    };
    isWithinRange = (value, [start, end])=>{
        return value >= start && value <= end;
    };
    startOfYear = (value)=>{
        return this.adjustOffset(value.startOf('year'));
    };
    startOfMonth = (value)=>{
        return this.adjustOffset(value.startOf('month'));
    };
    startOfWeek = (value)=>{
        return this.adjustOffset(this.setLocaleToValue(value).startOf('week'));
    };
    startOfDay = (value)=>{
        return this.adjustOffset(value.startOf('day'));
    };
    endOfYear = (value)=>{
        return this.adjustOffset(value.endOf('year'));
    };
    endOfMonth = (value)=>{
        return this.adjustOffset(value.endOf('month'));
    };
    endOfWeek = (value)=>{
        return this.adjustOffset(this.setLocaleToValue(value).endOf('week'));
    };
    endOfDay = (value)=>{
        return this.adjustOffset(value.endOf('day'));
    };
    addYears = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'year'));
    };
    addMonths = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'month'));
    };
    addWeeks = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'week'));
    };
    addDays = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'day'));
    };
    addHours = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'hour'));
    };
    addMinutes = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'minute'));
    };
    addSeconds = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'second'));
    };
    getYear = (value)=>{
        return value.year();
    };
    getMonth = (value)=>{
        return value.month();
    };
    getDate = (value)=>{
        return value.date();
    };
    getHours = (value)=>{
        return value.hour();
    };
    getMinutes = (value)=>{
        return value.minute();
    };
    getSeconds = (value)=>{
        return value.second();
    };
    getMilliseconds = (value)=>{
        return value.millisecond();
    };
    setYear = (value, year)=>{
        return this.adjustOffset(value.set('year', year));
    };
    setMonth = (value, month)=>{
        return this.adjustOffset(value.set('month', month));
    };
    setDate = (value, date)=>{
        return this.adjustOffset(value.set('date', date));
    };
    setHours = (value, hours)=>{
        return this.adjustOffset(value.set('hour', hours));
    };
    setMinutes = (value, minutes)=>{
        return this.adjustOffset(value.set('minute', minutes));
    };
    setSeconds = (value, seconds)=>{
        return this.adjustOffset(value.set('second', seconds));
    };
    setMilliseconds = (value, milliseconds)=>{
        return this.adjustOffset(value.set('millisecond', milliseconds));
    };
    getDaysInMonth = (value)=>{
        return value.daysInMonth();
    };
    getWeekArray = (value)=>{
        const start = this.startOfWeek(this.startOfMonth(value));
        const end = this.endOfWeek(this.endOfMonth(value));
        let count = 0;
        let current = start;
        const nestedWeeks = [];
        while(current < end){
            const weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = this.addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    getWeekNumber = (value)=>{
        return value.week();
    };
    getDayOfWeek(value) {
        return value.day() + 1;
    }
    getYearRange = ([start, end])=>{
        const startDate = this.startOfYear(start);
        const endDate = this.endOfYear(end);
        const years = [];
        let current = startDate;
        while(this.isBefore(current, endDate)){
            years.push(current);
            current = this.addYears(current, 1);
        }
        return years;
    };
}
module.exports.AdapterDayjs = $9231773518718bc3$var$AdapterDayjs;

});
parcelRegister("ccPny", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

});

parcelRegister("lHTSI", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("egN1l", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

});

parcelRegister("6HkVm", function(module, exports) {
!function(e, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});

});

parcelRegister("f6zku", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

});



parcelRegister("6vZDy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4cc92a48f230c1ff$var$ShorthandTimePicker;

var $4cc92a48f230c1ff$var$React = $4cc92a48f230c1ff$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4cc92a48f230c1ff$var$_InputLabel = $4cc92a48f230c1ff$var$_interopRequireDefault((parcelRequire("k9xmz")));

var $4cc92a48f230c1ff$var$_MenuItem = $4cc92a48f230c1ff$var$_interopRequireDefault((parcelRequire("iZ4W7")));

var $4cc92a48f230c1ff$var$_FormControl = $4cc92a48f230c1ff$var$_interopRequireDefault((parcelRequire("iA4iQ")));

var $4cc92a48f230c1ff$var$_Select = $4cc92a48f230c1ff$var$_interopRequireDefault((parcelRequire("dALxx")));

var $ayMG0 = parcelRequire("ayMG0");
function $4cc92a48f230c1ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $4cc92a48f230c1ff$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($4cc92a48f230c1ff$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $4cc92a48f230c1ff$var$ShorthandTimePicker({ rangeMinutes: rangeMinutes, setRangeMinutes: setRangeMinutes }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($4cc92a48f230c1ff$var$_FormControl.default, {
            sx: {
                m: 1,
                width: 134
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_InputLabel.default, {
                    id: "time-range-label-helper",
                    children: "Time Range"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($4cc92a48f230c1ff$var$_Select.default, {
                    labelId: "time-range-label-helper",
                    id: "time-range-label",
                    value: rangeMinutes,
                    label: "Time Range",
                    onChange: (event)=>setRangeMinutes(Number(event.target.value)),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 1,
                            children: "1 Minute"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 5,
                            children: "5 Minutes"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 30,
                            children: "30 Minutes"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 60,
                            children: "1 Hour"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 1440,
                            children: "24 Hours"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 10080,
                            children: "7 Days"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 20160,
                            children: "14 Days"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 43830,
                            children: "1 Month"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 131490,
                            children: "3 Months"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 262980,
                            children: "6 Months"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 525960,
                            children: "1 Year"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 1051920,
                            children: "2 Years"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4cc92a48f230c1ff$var$_MenuItem.default, {
                            value: 2629800,
                            children: "5 Years"
                        })
                    ]
                })
            ]
        })
    });
}

});


parcelRegister("8zTdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WidgetDialog = $e4eb233155746f87$var$WidgetDialog;

var $e4eb233155746f87$var$React = $e4eb233155746f87$var$_interopRequireWildcard((parcelRequire("acw62")));

var $aLhH4 = parcelRequire("aLhH4");

var $cvg8Z = parcelRequire("cvg8Z");

var $e4eb233155746f87$var$_Check = $e4eb233155746f87$var$_interopRequireDefault((parcelRequire("fZSPM")));

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $e4eb233155746f87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $e4eb233155746f87$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($e4eb233155746f87$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $e4eb233155746f87$var$WidgetDialog({ open: open, initial: initial, osmName: osmName, onClose: onClose, onSave: onSave }) {
    const [form, setForm] = $e4eb233155746f87$var$React.useState(initial);
    const [saving, setSaving] = $e4eb233155746f87$var$React.useState(false);
    $e4eb233155746f87$var$React.useEffect(()=>setForm(initial), [
        initial
    ]);
    const set = (field, value)=>setForm((prev)=>({
                ...prev,
                [field]: value
            }));
    const setConfig = (key, value)=>setForm((prev)=>({
                ...prev,
                config: {
                    ...prev.config ?? {},
                    [key]: value
                }
            }));
    const widgetDef = $aLhH4.WIDGET_REGISTRY.find((w)=>w.id === form.widget_type_id);
    const handleSave = async ()=>{
        setSaving(true);
        try {
            await onSave({
                ...form,
                osm_name: osmName
            });
            onClose();
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.DialogTitle, {
                children: form.id ? 'Edit Widget' : 'Add Widget'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.DialogContent, {
                sx: {
                    overflowY: 'auto',
                    maxHeight: '70vh'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        pt: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.TextField, {
                            select: true,
                            label: "Widget Type",
                            value: form.widget_type_id ?? 'sensor_gauge',
                            onChange: (e)=>{
                                const def = $aLhH4.WIDGET_REGISTRY.find((w)=>w.id === e.target.value);
                                set('widget_type_id', e.target.value);
                                set('chart_type', def?.chartTypes[0] ?? 'gauge');
                                set('config', null);
                            },
                            children: $aLhH4.WIDGET_REGISTRY.map((w)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.MenuItem, {
                                    value: w.id,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                                                variant: "body1",
                                                children: w.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                                                variant: "caption",
                                                color: "text.secondary",
                                                children: w.description
                                            })
                                        ]
                                    })
                                }, w.id))
                        }),
                        widgetDef && /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.TextField, {
                            select: true,
                            label: "Chart Type",
                            value: form.chart_type ?? widgetDef.chartTypes[0],
                            onChange: (e)=>set('chart_type', e.target.value),
                            children: widgetDef.chartTypes.map((ct)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.MenuItem, {
                                    value: ct,
                                    children: ct.charAt(0).toUpperCase() + ct.slice(1)
                                }, ct))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.TextField, {
                            label: "Title (optional)",
                            value: form.title ?? '',
                            onChange: (e)=>set('title', e.target.value || null)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.TextField, {
                            label: "Colour",
                            type: "color",
                            value: form.colour ?? '#1976d2',
                            onChange: (e)=>set('colour', e.target.value),
                            InputLabelProps: {
                                shrink: true
                            },
                            sx: {
                                width: 80
                            }
                        }),
                        widgetDef?.configFields.map((field)=>{
                            const value = form.config?.[field.key] ?? field.default ?? '';
                            if (field.type === 'measurement') return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 0.5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Typography, {
                                        variant: "caption",
                                        color: "text.secondary",
                                        children: [
                                            field.label,
                                            field.required ? ' *' : ''
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                        value: value,
                                        required: field.required,
                                        onChange: (e)=>setConfig(field.key, e.target.value),
                                        style: {
                                            padding: '12px',
                                            borderRadius: '4px',
                                            border: '1px solid rgba(255,255,255,0.23)',
                                            backgroundColor: 'transparent',
                                            color: 'inherit',
                                            fontSize: '16px',
                                            width: '100%',
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: "",
                                                disabled: true,
                                                children: "Select measurement"
                                            }),
                                            Object.entries($dOn5J.DESC_MAP).map(([k, label])=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: k,
                                                    children: label
                                                }, k))
                                        ]
                                    })
                                ]
                            }, field.key);
                            if (field.type === 'select') return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.TextField, {
                                select: true,
                                label: field.label,
                                value: value,
                                onChange: (e)=>setConfig(field.key, e.target.value),
                                required: field.required,
                                children: field.options?.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.MenuItem, {
                                        value: opt.value,
                                        children: opt.label
                                    }, opt.value))
                            }, field.key);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.TextField, {
                                label: field.label,
                                type: field.type === 'number' ? 'number' : 'text',
                                value: value,
                                onChange: (e)=>setConfig(field.key, field.type === 'number' ? Number(e.target.value) : e.target.value),
                                required: field.required
                            }, field.key);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.DialogActions, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Button, {
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Button, {
                        variant: "contained",
                        onClick: handleSave,
                        disabled: saving || !form.widget_type_id,
                        startIcon: saving ? /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {
                            size: 16
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($e4eb233155746f87$var$_Check.default, {}),
                        children: "Save"
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("aLhH4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWidgetDef = module.exports.WIDGET_REGISTRY = void 0;
const $db2c8505258f149e$var$WIDGET_REGISTRY = module.exports.WIDGET_REGISTRY = [
    {
        id: 'sensor_gauge',
        label: 'Gauge',
        description: 'Displays the average value of a single sensor measurement.',
        chartTypes: [
            'gauge',
            'stat'
        ],
        configFields: [
            {
                key: 'measurement',
                label: 'Measurement',
                type: 'measurement',
                required: true
            },
            {
                key: 'min',
                label: 'Min value',
                type: 'number',
                default: 0
            },
            {
                key: 'max',
                label: 'Max value',
                type: 'number',
                default: 100
            }
        ]
    },
    {
        id: 'sensor_chart',
        label: 'Chart',
        description: 'Plots raw values for any single measurement over time.',
        chartTypes: [
            'line',
            'bar'
        ],
        configFields: [
            {
                key: 'measurement',
                label: 'Measurement',
                type: 'measurement',
                required: true
            }
        ]
    },
    {
        id: 'electricity_cost',
        label: 'Electricity Cost',
        description: 'Calculates running electricity cost using 3-phase current and tariff rates.',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: []
    },
    {
        id: 'gas_consumption',
        label: 'Gas Consumption',
        description: 'Calculates gas consumption from pulse counter readings.',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: [
            {
                key: 'channel',
                label: 'Pulse channel',
                type: 'select',
                required: true,
                options: [
                    {
                        value: 'CNT1',
                        label: 'CNT1'
                    },
                    {
                        value: 'CNT2',
                        label: 'CNT2'
                    }
                ]
            },
            {
                key: 'pulseDiv',
                label: "M\xb3 per pulse",
                type: 'number',
                default: 0.01
            },
            {
                key: 'unit',
                label: 'Display unit',
                type: 'text',
                default: "m\xb3"
            }
        ]
    },
    {
        id: 'water_consumption',
        label: 'Water Consumption',
        description: 'Calculates water consumption from pulse counter readings.',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: [
            {
                key: 'channel',
                label: 'Pulse channel',
                type: 'select',
                required: true,
                options: [
                    {
                        value: 'CNT1',
                        label: 'CNT1'
                    },
                    {
                        value: 'CNT2',
                        label: 'CNT2'
                    }
                ]
            },
            {
                key: 'pulseDiv',
                label: 'Litres per pulse',
                type: 'number',
                default: 1.0
            },
            {
                key: 'unit',
                label: 'Display unit',
                type: 'text',
                default: 'L'
            }
        ]
    },
    {
        id: 'gas_cost',
        label: 'Gas Cost',
        description: 'Calculates gas cost using pulse counter readings and tariff rates.',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: [
            {
                key: 'channel',
                label: 'Pulse channel',
                type: 'select',
                required: true,
                options: [
                    {
                        value: 'CNT1',
                        label: 'CNT1'
                    },
                    {
                        value: 'CNT2',
                        label: 'CNT2'
                    }
                ]
            },
            {
                key: 'pulseDiv',
                label: "Pulses per m\xb3",
                type: 'number',
                default: 100
            }
        ]
    },
    {
        id: 'water_cost',
        label: 'Water Cost',
        description: 'Calculates water cost using pulse counter readings and tariff rates.',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: [
            {
                key: 'channel',
                label: 'Pulse channel',
                type: 'select',
                required: true,
                options: [
                    {
                        value: 'CNT1',
                        label: 'CNT1'
                    },
                    {
                        value: 'CNT2',
                        label: 'CNT2'
                    }
                ]
            },
            {
                key: 'pulseDiv',
                label: "Pulses per m\xb3",
                type: 'number',
                default: 100
            }
        ]
    },
    {
        id: 'vibration',
        label: 'Vibration',
        description: 'Plots Z/X RMS and peak velocity from vibration sensor.',
        chartTypes: [
            'line',
            'bar'
        ],
        configFields: []
    },
    {
        id: 'import_cost',
        label: 'Imported Power Cost',
        description: 'Calculates cumulative electricity cost from imported kWh via main incomer (MODBUS).',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: []
    },
    {
        id: 'import_consumption',
        label: 'Imported Power Consumption',
        description: 'Calculates cumulative kWh consumption from imported energy via main incomer (MODBUS).',
        chartTypes: [
            'line',
            'bar',
            'stat'
        ],
        configFields: []
    },
    {
        id: 'air_quality',
        label: 'Air Quality',
        description: 'Plots PM1, PM4, PM10 and PM2.5 particulate levels.',
        chartTypes: [
            'line',
            'bar'
        ],
        configFields: []
    },
    {
        id: 'three_phase_current',
        label: 'Three Phase Current',
        description: 'Plots CC1, CC2 and CC3 phase current readings.',
        chartTypes: [
            'line',
            'bar'
        ],
        configFields: []
    }
];
const $db2c8505258f149e$var$getWidgetDef = (id)=>$db2c8505258f149e$var$WIDGET_REGISTRY.find((w)=>w.id === id);
module.exports.getWidgetDef = $db2c8505258f149e$var$getWidgetDef;

});

parcelRegister("fZSPM", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ba571672f7b8a33c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba571672f7b8a33c$var$_createSvgIcon = $ba571672f7b8a33c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ba571672f7b8a33c$var$_default = module.exports.default = (0, $ba571672f7b8a33c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

});


parcelRegister("28goj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DashboardContent = $d375fecbdc1fbbff$var$DashboardContent;

var $XfSM9 = parcelRequire("XfSM9");

var $cvg8Z = parcelRequire("cvg8Z");

var $ayMG0 = parcelRequire("ayMG0");
function $d375fecbdc1fbbff$var$DashboardContent({ widgets: widgets, osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, editMode: editMode, onEdit: onEdit, onDelete: onDelete, onMove: onMove }) {
    if (!widgets.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "text.secondary",
        sx: {
            p: 2
        },
        children: editMode ? "No widgets yet \u2014 click + to add some." : 'No dashboard configured.'
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 2,
            p: 2
        },
        children: widgets.map((widget, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($XfSM9.WidgetCard, {
                widget: widget,
                osmName: osmName,
                dateFromValue: dateFromValue,
                dateToValue: dateToValue,
                editMode: editMode,
                index: index,
                total: widgets.length,
                onEdit: onEdit,
                onDelete: onDelete,
                onMove: onMove
            }, `${widget.id}-${dateFromValue?.toISOString()}-${dateToValue?.toISOString()}`))
    });
}

});
parcelRegister("XfSM9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WidgetCard = $0e937163dc99c697$var$WidgetCard;

var $8G34F = parcelRequire("8G34F");

var $0e937163dc99c697$var$_DeleteOutlined = $0e937163dc99c697$var$_interopRequireDefault((parcelRequire("a1rcD")));

var $0e937163dc99c697$var$_ArrowUpward = $0e937163dc99c697$var$_interopRequireDefault((parcelRequire("f1nIu")));

var $0e937163dc99c697$var$_ArrowDownward = $0e937163dc99c697$var$_interopRequireDefault((parcelRequire("2mYIR")));

var $cvg8Z = parcelRequire("cvg8Z");

var $0e937163dc99c697$var$_Edit = $0e937163dc99c697$var$_interopRequireDefault((parcelRequire("c3r8Q")));

var $ayMG0 = parcelRequire("ayMG0");
function $0e937163dc99c697$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $0e937163dc99c697$var$WidgetCard({ widget: widget, osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, editMode: editMode, index: index, total: total, onEdit: onEdit, onDelete: onDelete, onMove: onMove }) {
    const WidgetComponent = $8G34F.WIDGET_COMPONENT_MAP[widget.widget_type_id];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            position: 'relative',
            border: editMode ? '2px dashed' : '1px solid',
            borderColor: editMode ? 'primary.light' : 'divider',
            borderRadius: 2,
            p: 1,
            height: 'fit-content',
            minHeight: 350,
            width: '100%',
            boxSizing: 'border-box'
        },
        children: [
            widget.title && /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "subtitle2",
                align: "center",
                gutterBottom: true,
                children: widget.title
            }),
            WidgetComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(WidgetComponent, {
                osmName: osmName,
                dateFromValue: dateFromValue,
                dateToValue: dateToValue,
                chartType: widget.chart_type,
                title: widget.title,
                config: widget.config,
                colour: widget.colour ?? undefined,
                min: widget.min_value ?? undefined,
                max: widget.max_value ?? undefined,
                measurement: widget.measurement ?? undefined
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Typography, {
                color: "error",
                children: [
                    "Unknown widget type: ",
                    widget.widget_type_id
                ]
            }),
            editMode && /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 0.5,
                    mt: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                        title: "Move left",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                                size: "small",
                                onClick: ()=>onMove(index, 'up'),
                                disabled: index === 0,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($0e937163dc99c697$var$_ArrowUpward.default, {
                                    fontSize: "small"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                        title: "Move right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                                size: "small",
                                onClick: ()=>onMove(index, 'down'),
                                disabled: index === total - 1,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($0e937163dc99c697$var$_ArrowDownward.default, {
                                    fontSize: "small"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                        title: "Edit",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                            size: "small",
                            onClick: ()=>onEdit(widget),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($0e937163dc99c697$var$_Edit.default, {
                                fontSize: "small"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Tooltip, {
                        title: "Delete",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.IconButton, {
                            size: "small",
                            color: "error",
                            onClick: ()=>onDelete(widget.id),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($0e937163dc99c697$var$_DeleteOutlined.default, {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("8G34F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AirQualityWidget = $55e047b1b19e7667$var$AirQualityWidget;
module.exports.ChartWidget = $55e047b1b19e7667$var$ChartWidget;
module.exports.ElectricityCostWidget = $55e047b1b19e7667$var$ElectricityCostWidget;
module.exports.GasConsumptionWidget = $55e047b1b19e7667$var$GasConsumptionWidget;
module.exports.GasCostWidget = $55e047b1b19e7667$var$GasCostWidget;
module.exports.GaugeWidget = $55e047b1b19e7667$var$GaugeWidget;
module.exports.ImportConsumptionWidget = $55e047b1b19e7667$var$ImportConsumptionWidget;
module.exports.ImportCostWidget = $55e047b1b19e7667$var$ImportCostWidget;
module.exports.ThreePhaseCurrentWidget = $55e047b1b19e7667$var$ThreePhaseCurrentWidget;
module.exports.VibrationWidget = $55e047b1b19e7667$var$VibrationWidget;
module.exports.WIDGET_COMPONENT_MAP = void 0;
module.exports.WaterConsumptionWidget = $55e047b1b19e7667$var$WaterConsumptionWidget;
module.exports.WaterCostWidget = $55e047b1b19e7667$var$WaterCostWidget;

var $55e047b1b19e7667$var$React = $55e047b1b19e7667$var$_interopRequireWildcard((parcelRequire("acw62")));

var $cvg8Z = parcelRequire("cvg8Z");

var $4gFfv = parcelRequire("4gFfv");

var $hZOCy = parcelRequire("hZOCy");

var $3u6kV = parcelRequire("3u6kV");

var $55e047b1b19e7667$var$_basechart = $55e047b1b19e7667$var$_interopRequireDefault((parcelRequire("d8hK4")));

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $55e047b1b19e7667$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $55e047b1b19e7667$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($55e047b1b19e7667$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $55e047b1b19e7667$var$renderChart(chartType, data, label, unit, colour, min, max) {
    if (!data.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    const xLabels = data.map((d)=>new Date(d.bucket).toLocaleString());
    const values = data.map((d)=>d.value);
    const total = values.reduce((s, v)=>s + v, 0);
    const avg = total / values.length;
    if (chartType === 'stat') return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            textAlign: 'center',
            py: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "h3",
                fontWeight: "bold",
                color: colour,
                children: total.toFixed(2)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Typography, {
                variant: "body2",
                color: "text.secondary",
                children: [
                    label,
                    " (total ",
                    unit,
                    ")"
                ]
            })
        ]
    });
    if (chartType === 'gauge') return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($hZOCy.Gauge, {
                value: avg,
                valueMin: min ?? 0,
                valueMax: max ?? Math.max(...values) * 1.2,
                cornerRadius: "50%",
                sx: {
                    [`& .${$hZOCy.gaugeClasses.valueText}`]: {
                        fontSize: 20,
                        fontWeight: 'bold'
                    },
                    [`& .${$hZOCy.gaugeClasses.valueArc}`]: {
                        fill: colour
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "body2",
                color: "text.secondary",
                children: label
            })
        ]
    });
    const series = [
        {
            data: values,
            label: label,
            color: colour,
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} ${unit}` : ''
        }
    ];
    if (chartType === 'bar') return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.BarChart, {
            series: series,
            xAxis: [
                {
                    data: xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: unit
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.LineChart, {
            series: series,
            xAxis: [
                {
                    scaleType: 'point',
                    data: xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: unit
                }
            ],
            margin: {
                left: 70,
                right: 30,
                top: 20,
                bottom: 50
            }
        })
    });
}
function $55e047b1b19e7667$var$ElectricityCostWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, colour: colour }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    const fillColor = colour ?? '#f59e0b';
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getElectricityCost)(osmName, dateFromValue.toISOString(), dateToValue.toISOString()).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    const points = data.map((d)=>({
            bucket: d.bucket,
            value: d.cost_gbp
        }));
    return $55e047b1b19e7667$var$renderChart(chartType, points, 'Electricity Cost', "\xa3", fillColor);
}
function $55e047b1b19e7667$var$PulseConsumptionWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, config: config, colour: colour, label: label, defaultUnit: defaultUnit, fillColor: defaultColor }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    const cfg = config;
    const channel = cfg?.channel ?? 'CNT1';
    const pulseDiv = cfg?.pulseDiv ?? 1.0;
    const unit = cfg?.unit ?? defaultUnit;
    const fillColor = colour ?? defaultColor;
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getPulseConsumption)(osmName, dateFromValue.toISOString(), dateToValue.toISOString(), channel, pulseDiv).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue,
        channel,
        pulseDiv
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    const points = data.map((d)=>({
            bucket: d.bucket,
            value: d.consumption
        }));
    return $55e047b1b19e7667$var$renderChart(chartType, points, label, unit, fillColor);
}
function $55e047b1b19e7667$var$GasConsumptionWidget(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($55e047b1b19e7667$var$PulseConsumptionWidget, {
        ...props,
        label: "Gas Consumption",
        defaultUnit: "m\xB3",
        fillColor: "#3b82f6"
    });
}
function $55e047b1b19e7667$var$WaterConsumptionWidget(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($55e047b1b19e7667$var$PulseConsumptionWidget, {
        ...props,
        label: "Water Consumption",
        defaultUnit: "L",
        fillColor: "#06b6d4"
    });
}
function $55e047b1b19e7667$var$PulseCostWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, config: config, colour: colour, label: label, defaultColor: defaultColor, fetchFn: fetchFn }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    const cfg = config;
    const channel = cfg?.channel ?? 'CNT1';
    const pulseDiv = cfg?.pulseDiv ?? 100;
    const fillColor = colour ?? defaultColor;
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        fetchFn(osmName, dateFromValue.toISOString(), dateToValue.toISOString(), channel, pulseDiv).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue,
        channel,
        pulseDiv
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    const points = data.map((d)=>({
            bucket: d.bucket,
            value: d.cost_gbp
        }));
    return $55e047b1b19e7667$var$renderChart(chartType, points, label, "\xa3", fillColor);
}
function $55e047b1b19e7667$var$GasCostWidget(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($55e047b1b19e7667$var$PulseCostWidget, {
        ...props,
        label: "Gas Cost",
        defaultColor: "#f97316",
        fetchFn: $3u6kV.getGasCost
    });
}
function $55e047b1b19e7667$var$WaterCostWidget(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($55e047b1b19e7667$var$PulseCostWidget, {
        ...props,
        label: "Water Cost",
        defaultColor: "#06b6d4",
        fetchFn: $3u6kV.getWaterCost
    });
}
function $55e047b1b19e7667$var$VibrationWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, colour: colour }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getVibration)(osmName, dateFromValue.toISOString(), dateToValue.toISOString()).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    if (!data.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    // ISO 10816 thresholds (mm/s RMS)
    const ISO_LINES = [
        {
            value: 2.8,
            label: 'Good',
            color: '#1D9E75'
        },
        {
            value: 4.5,
            label: 'Unsatisfactory',
            color: '#BA7517'
        },
        {
            value: 7.1,
            label: 'Dangerous',
            color: '#D4537E'
        }
    ];
    const xLabels = data.map((d)=>new Date(d.bucket).toLocaleString('en-GB', {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
        }));
    const allValues = data.flatMap((d)=>[
            d.zrv1,
            d.xrv1,
            d.zpv1,
            d.xpv1
        ]);
    const yMax = Math.max(Math.max(...allValues) * 1.1, 3);
    const series = [
        {
            data: data.map((d)=>d.zrv1),
            label: 'Z-Axis RMS',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(4)} mm/s` : ''
        },
        {
            data: data.map((d)=>d.xrv1),
            label: 'X-Axis RMS',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(4)} mm/s` : ''
        },
        {
            data: data.map((d)=>d.zpv1),
            label: 'Z-Axis Peak',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(4)} mm/s` : ''
        },
        {
            data: data.map((d)=>d.xpv1),
            label: 'X-Axis Peak',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(4)} mm/s` : ''
        }
    ];
    if (chartType === 'bar') return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.BarChart, {
            colors: [
                '#1D9E75',
                '#378ADD',
                '#BA7517',
                '#D4537E'
            ],
            series: series,
            xAxis: [
                {
                    data: xLabels
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: 'mm/s'
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300,
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.LineChart, {
                colors: [
                    '#1D9E75',
                    '#378ADD',
                    '#BA7517',
                    '#D4537E'
                ],
                series: series,
                xAxis: [
                    {
                        scaleType: 'point',
                        data: xLabels
                    }
                ],
                yAxis: [
                    {
                        width: 50,
                        label: 'mm/s',
                        min: 0,
                        max: yMax
                    }
                ],
                margin: {
                    left: 60,
                    right: 30,
                    top: 20,
                    bottom: 50
                },
                sx: {
                    '& .MuiMarkElement-root': {
                        display: 'none'
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                sx: {
                    position: 'absolute',
                    top: 24,
                    right: 36,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px',
                    background: 'rgba(0,0,0,0.5)',
                    borderRadius: 1,
                    p: '4px 8px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 9,
                            color: 'rgba(255,255,255,0.5)',
                            letterSpacing: '0.05em',
                            mb: '2px'
                        },
                        children: "ISO 10816 Limits"
                    }),
                    ISO_LINES.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
                                    sx: {
                                        width: 16,
                                        height: 2,
                                        background: l.color,
                                        borderRadius: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Typography, {
                                    sx: {
                                        fontFamily: "'DM Mono', monospace",
                                        fontSize: 9,
                                        color: 'rgba(255,255,255,0.7)'
                                    },
                                    children: [
                                        l.label,
                                        " (",
                                        l.value,
                                        ")"
                                    ]
                                })
                            ]
                        }, l.label))
                ]
            })
        ]
    });
}
function $55e047b1b19e7667$var$ImportCostWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, config: config, colour: colour }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    const cfg = config;
    const tag = cfg?.tag ?? 'elec';
    const fillColor = colour ?? '#a855f7';
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getImportCost)(osmName, dateFromValue.toISOString(), dateToValue.toISOString(), tag).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue,
        tag
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    const points = data.map((d)=>({
            bucket: d.bucket,
            value: d.cost_gbp
        }));
    return $55e047b1b19e7667$var$renderChart(chartType, points, 'Imported Power Cost', "\xa3", fillColor);
}
function $55e047b1b19e7667$var$ImportConsumptionWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, colour: colour }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    const fillColor = colour ?? '#6366f1';
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getImportConsumption)(osmName, dateFromValue.toISOString(), dateToValue.toISOString()).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    const points = data.map((d)=>({
            bucket: d.bucket,
            value: d.consumption
        }));
    return $55e047b1b19e7667$var$renderChart(chartType, points, 'Power Consumption', 'kWh', fillColor);
}
function $55e047b1b19e7667$var$AirQualityWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getAirQuality)(osmName, dateFromValue.toISOString(), dateToValue.toISOString()).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    if (!data.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    const DAQI_LINES = [
        {
            value: 11,
            label: 'Low',
            color: '#1D9E75'
        },
        {
            value: 35,
            label: 'Moderate',
            color: '#BA7517'
        },
        {
            value: 53,
            label: 'High',
            color: '#D4537E'
        },
        {
            value: 70,
            label: 'Very High',
            color: '#993C1D'
        }
    ];
    const xLabels = data.map((d)=>new Date(d.bucket).toLocaleString());
    const allValues = data.flatMap((d)=>[
            d.pm1,
            d.pm4,
            d.pm10,
            d.pm25
        ]);
    const yMax = Math.max(Math.max(...allValues) * 1.1, 75);
    if (chartType === 'bar') return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.BarChart, {
            series: [
                {
                    data: data.map((d)=>d.pm1),
                    label: 'PM1',
                    color: '#378ADD',
                    showMark: false,
                    valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                },
                {
                    data: data.map((d)=>d.pm4),
                    label: 'PM4',
                    color: '#BA7517',
                    showMark: false,
                    valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                },
                {
                    data: data.map((d)=>d.pm10),
                    label: 'PM10',
                    color: '#D4537E',
                    showMark: false,
                    valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                },
                {
                    data: data.map((d)=>d.pm25),
                    label: 'PM2.5',
                    color: '#993C1D',
                    showMark: false,
                    valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                }
            ],
            xAxis: [
                {
                    data: xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: "\u03BCg/m\xb3"
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.LineChart, {
                colors: [
                    '#378ADD',
                    '#BA7517',
                    '#D4537E',
                    '#993C1D'
                ],
                series: [
                    {
                        data: data.map((d)=>d.pm1),
                        label: 'PM1',
                        showMark: false,
                        valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                    },
                    {
                        data: data.map((d)=>d.pm4),
                        label: 'PM4',
                        showMark: false,
                        valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                    },
                    {
                        data: data.map((d)=>d.pm10),
                        label: 'PM10',
                        showMark: false,
                        valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                    },
                    {
                        data: data.map((d)=>d.pm25),
                        label: 'PM2.5',
                        showMark: false,
                        valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} \u{3BC}g/m\xb3` : ''
                    }
                ],
                xAxis: [
                    {
                        scaleType: 'point',
                        data: xLabels
                    }
                ],
                yAxis: [
                    {
                        width: 50,
                        label: "\u03BCg/m\xb3",
                        min: 0,
                        max: yMax
                    }
                ],
                margin: {
                    left: 60,
                    right: 30,
                    top: 20,
                    bottom: 50
                },
                sx: {
                    '& .MuiMarkElement-root': {
                        display: 'none'
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                sx: {
                    position: 'absolute',
                    top: 24,
                    right: 36,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px',
                    background: 'rgba(0,0,0,0.5)',
                    borderRadius: 1,
                    p: '4px 8px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                        sx: {
                            fontFamily: "'DM Mono', monospace",
                            fontSize: 9,
                            color: 'rgba(255,255,255,0.5)',
                            letterSpacing: '0.05em',
                            mb: '2px'
                        },
                        children: "DAQI"
                    }),
                    DAQI_LINES.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
                                    sx: {
                                        width: 16,
                                        height: 2,
                                        background: l.color,
                                        borderRadius: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Typography, {
                                    sx: {
                                        fontFamily: "'DM Mono', monospace",
                                        fontSize: 9,
                                        color: 'rgba(255,255,255,0.7)'
                                    },
                                    children: [
                                        l.label,
                                        " (",
                                        l.value,
                                        ")"
                                    ]
                                })
                            ]
                        }, l.label))
                ]
            })
        ]
    });
}
function $55e047b1b19e7667$var$ThreePhaseCurrentWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType }) {
    const [data, setData] = $55e047b1b19e7667$var$React.useState([]);
    const [loading, setLoading] = $55e047b1b19e7667$var$React.useState(true);
    const [error, setError] = $55e047b1b19e7667$var$React.useState(null);
    $55e047b1b19e7667$var$React.useEffect(()=>{
        if (!dateFromValue || !dateToValue) return;
        setLoading(true);
        (0, $3u6kV.getThreePhaseCurrent)(osmName, dateFromValue.toISOString(), dateToValue.toISOString()).then(setData).catch((e)=>setError(e.message)).finally(()=>setLoading(false));
    }, [
        osmName,
        dateFromValue,
        dateToValue
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.CircularProgress, {});
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    if (!data.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    const xLabels = data.map((d)=>new Date(d.bucket).toLocaleString());
    const series = [
        {
            data: data.map((d)=>d.cc1),
            label: 'Phase 1 (CC1)',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} mA` : ''
        },
        {
            data: data.map((d)=>d.cc2),
            label: 'Phase 2 (CC2)',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} mA` : ''
        },
        {
            data: data.map((d)=>d.cc3),
            label: 'Phase 3 (CC3)',
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} mA` : ''
        }
    ];
    if (chartType === 'bar') return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.BarChart, {
            series: series,
            xAxis: [
                {
                    data: xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: 'mA'
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.LineChart, {
            series: series,
            xAxis: [
                {
                    scaleType: 'point',
                    data: xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: 'mA'
                }
            ],
            margin: {
                left: 70,
                right: 30,
                top: 20,
                bottom: 50
            }
        })
    });
}
function $55e047b1b19e7667$var$GaugeWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, config: config, colour: colour, min: min, max: max, measurement: measurement }) {
    const cfg = config;
    const meas = cfg?.measurement ?? measurement ?? '';
    const minVal = cfg?.min ?? min ?? 0;
    const maxVal = cfg?.max ?? max ?? 100;
    const fillColor = cfg?.colour ?? colour ?? '#1976d2';
    const measurements = $55e047b1b19e7667$var$React.useMemo(()=>[
            meas
        ], [
        meas
    ]);
    const data = (0, $55e047b1b19e7667$var$_basechart.default)({
        table: 'pg_sf_ds',
        valuename: 'ds_val',
        timeField: 'bucket',
        measurements: measurements,
        timeFrom: dateFromValue,
        timeTo: dateToValue,
        unit: '',
        osmName: osmName
    });
    if (!data || !data.series?.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    const values = data.series[0].data.map(Number).filter((n)=>!isNaN(n));
    const avg = values.reduce((s, v)=>s + v, 0) / values.length;
    if (chartType === 'stat') return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            textAlign: 'center',
            py: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "h3",
                fontWeight: "bold",
                color: fillColor,
                children: avg.toFixed(2)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "body2",
                color: "text.secondary",
                children: $dOn5J.DESC_MAP[meas] ?? meas
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cvg8Z.Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($hZOCy.Gauge, {
                value: avg,
                valueMin: minVal,
                valueMax: maxVal,
                cornerRadius: "50%",
                sx: {
                    [`& .${$hZOCy.gaugeClasses.valueText}`]: {
                        fontSize: 20,
                        fontWeight: 'bold'
                    },
                    [`& .${$hZOCy.gaugeClasses.valueArc}`]: {
                        fill: fillColor
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
                variant: "body2",
                color: "text.secondary",
                children: $dOn5J.DESC_MAP[meas] ?? meas
            })
        ]
    });
}
function $55e047b1b19e7667$var$ChartWidget({ osmName: osmName, dateFromValue: dateFromValue, dateToValue: dateToValue, chartType: chartType, config: config, colour: colour }) {
    const cfg = config;
    const meas = cfg?.measurement ?? '';
    const fillColor = colour ?? '#1976d2';
    const label = $dOn5J.DESC_MAP[meas] ?? meas;
    const measurements = $55e047b1b19e7667$var$React.useMemo(()=>[
            meas
        ], [
        meas
    ]);
    const data = (0, $55e047b1b19e7667$var$_basechart.default)({
        table: 'pg_sf_ds',
        valuename: 'ds_val',
        timeField: 'bucket',
        measurements: measurements,
        timeFrom: dateFromValue,
        timeTo: dateToValue,
        unit: '',
        osmName: osmName
    });
    if (!data || !data.series?.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    const series = data.series.map((s)=>({
            ...s,
            color: fillColor,
            showMark: false
        }));
    if (chartType === 'bar') return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.BarChart, {
            series: series,
            xAxis: [
                {
                    data: data.xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: label
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Box, {
        sx: {
            width: '100%',
            height: 300
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4gFfv.LineChart, {
            series: series,
            xAxis: [
                {
                    scaleType: 'point',
                    data: data.xLabels,
                    label: 'Time'
                }
            ],
            yAxis: [
                {
                    width: 60,
                    label: label
                }
            ],
            margin: {
                left: 70,
                right: 30,
                top: 20,
                bottom: 50
            }
        })
    });
}
const $55e047b1b19e7667$var$WIDGET_COMPONENT_MAP = module.exports.WIDGET_COMPONENT_MAP = {
    electricity_cost: $55e047b1b19e7667$var$ElectricityCostWidget,
    gas_consumption: $55e047b1b19e7667$var$GasConsumptionWidget,
    water_consumption: $55e047b1b19e7667$var$WaterConsumptionWidget,
    gas_cost: $55e047b1b19e7667$var$GasCostWidget,
    water_cost: $55e047b1b19e7667$var$WaterCostWidget,
    vibration: $55e047b1b19e7667$var$VibrationWidget,
    import_cost: $55e047b1b19e7667$var$ImportCostWidget,
    import_consumption: $55e047b1b19e7667$var$ImportConsumptionWidget,
    air_quality: $55e047b1b19e7667$var$AirQualityWidget,
    three_phase_current: $55e047b1b19e7667$var$ThreePhaseCurrentWidget,
    sensor_gauge: $55e047b1b19e7667$var$GaugeWidget,
    sensor_chart: $55e047b1b19e7667$var$ChartWidget
};

});
parcelRegister("4gFfv", function(module, exports) {
/**
 * @mui/x-charts v8.27.4
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $31b8a7469854e9ec$var$_exportNames = {
    ChartsContainer: true,
    ChartContainer: true
};
Object.defineProperty(module.exports, "ChartContainer", {
    enumerable: true,
    get: function() {
        return $auEOm.ChartContainer;
    }
});
Object.defineProperty(module.exports, "ChartsContainer", {
    enumerable: true,
    get: function() {
        return $foeof.ChartsContainer;
    }
});

var $fiXDv = parcelRequire("fiXDv");
Object.keys($fiXDv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fiXDv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fiXDv[key];
        }
    });
});

var $6ZOZW = parcelRequire("6ZOZW");
Object.keys($6ZOZW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6ZOZW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6ZOZW[key];
        }
    });
});

var $55quD = parcelRequire("55quD");
Object.keys($55quD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $55quD[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $55quD[key];
        }
    });
});

var $fcFWs = parcelRequire("fcFWs");
Object.keys($fcFWs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fcFWs[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fcFWs[key];
        }
    });
});

var $c2wlS = parcelRequire("c2wlS");
Object.keys($c2wlS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c2wlS[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c2wlS[key];
        }
    });
});

var $8d4MF = parcelRequire("8d4MF");
Object.keys($8d4MF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8d4MF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8d4MF[key];
        }
    });
});

var $6WChQ = parcelRequire("6WChQ");
Object.keys($6WChQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6WChQ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6WChQ[key];
        }
    });
});

var $7XBLa = parcelRequire("7XBLa");
Object.keys($7XBLa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7XBLa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7XBLa[key];
        }
    });
});

var $aiEgN = parcelRequire("aiEgN");
Object.keys($aiEgN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $aiEgN[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aiEgN[key];
        }
    });
});

var $fMBQY = parcelRequire("fMBQY");
Object.keys($fMBQY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fMBQY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fMBQY[key];
        }
    });
});

var $dxqK3 = parcelRequire("dxqK3");
Object.keys($dxqK3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dxqK3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dxqK3[key];
        }
    });
});

var $2ppSP = parcelRequire("2ppSP");
Object.keys($2ppSP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2ppSP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ppSP[key];
        }
    });
});

var $41V8S = parcelRequire("41V8S");
Object.keys($41V8S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $41V8S[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $41V8S[key];
        }
    });
});

var $luY0B = parcelRequire("luY0B");
Object.keys($luY0B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $luY0B[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $luY0B[key];
        }
    });
});

var $2xwmx = parcelRequire("2xwmx");
Object.keys($2xwmx).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2xwmx[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2xwmx[key];
        }
    });
});

var $anK5t = parcelRequire("anK5t");
Object.keys($anK5t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $anK5t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $anK5t[key];
        }
    });
});

var $i8uFX = parcelRequire("i8uFX");
Object.keys($i8uFX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $i8uFX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i8uFX[key];
        }
    });
});

var $ad3Dp = parcelRequire("ad3Dp");
Object.keys($ad3Dp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ad3Dp[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ad3Dp[key];
        }
    });
});

var $1R6Wm = parcelRequire("1R6Wm");
Object.keys($1R6Wm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1R6Wm[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1R6Wm[key];
        }
    });
});

var $i1xAO = parcelRequire("i1xAO");
Object.keys($i1xAO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $i1xAO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i1xAO[key];
        }
    });
});

var $j8a65 = parcelRequire("j8a65");
Object.keys($j8a65).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $j8a65[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $j8a65[key];
        }
    });
});

var $1Dyr6 = parcelRequire("1Dyr6");
Object.keys($1Dyr6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1Dyr6[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1Dyr6[key];
        }
    });
});

var $ki9mB = parcelRequire("ki9mB");
Object.keys($ki9mB).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ki9mB[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ki9mB[key];
        }
    });
});

var $hZOCy = parcelRequire("hZOCy");
Object.keys($hZOCy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hZOCy[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hZOCy[key];
        }
    });
});

var $81UtU = parcelRequire("81UtU");
Object.keys($81UtU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $81UtU[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $81UtU[key];
        }
    });
});

var $ezMKh = parcelRequire("ezMKh");
Object.keys($ezMKh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ezMKh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ezMKh[key];
        }
    });
});

var $foeof = parcelRequire("foeof");

var $auEOm = parcelRequire("auEOm");

var $kZwzL = parcelRequire("kZwzL");
Object.keys($kZwzL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kZwzL[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kZwzL[key];
        }
    });
});

var $eSGGd = parcelRequire("eSGGd");
Object.keys($eSGGd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eSGGd[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eSGGd[key];
        }
    });
});

var $bZEfF = parcelRequire("bZEfF");
Object.keys($bZEfF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bZEfF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bZEfF[key];
        }
    });
});

var $G4UB8 = parcelRequire("G4UB8");
Object.keys($G4UB8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $G4UB8[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $G4UB8[key];
        }
    });
});

var $ii0sh = parcelRequire("ii0sh");
Object.keys($ii0sh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ii0sh[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ii0sh[key];
        }
    });
});

var $2YiER = parcelRequire("2YiER");
Object.keys($2YiER).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($31b8a7469854e9ec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2YiER[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2YiER[key];
        }
    });
});

});
parcelRegister("6ZOZW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1jcVZ = parcelRequire("1jcVZ");
Object.keys($1jcVZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1jcVZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1jcVZ[key];
        }
    });
});

});
parcelRegister("1jcVZ", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $0f419943812d433a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useChartApiContext = $0f419943812d433a$var$useChartApiContext;

var $0f419943812d433a$var$React = $0f419943812d433a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6hQTT = parcelRequire("6hQTT");
/**
 * The `useChartApiContext` hook provides access to the chart API.
 * This is only available when the chart is rendered within a chart or a `ChartDataProvider` component.
 * If you want to access the chart API outside those components, you should use the `apiRef` prop instead.
 * @example
 * const apiRef = useChartApiContext<ChartApi<'bar'>>();
 */ function $0f419943812d433a$var$useChartApiContext() {
    const { publicAPI: publicAPI } = (0, $6hQTT.useChartContext)();
    const apiRef = $0f419943812d433a$var$React.useRef(publicAPI);
    $0f419943812d433a$var$React.useEffect(()=>{
        apiRef.current = publicAPI;
    }, [
        publicAPI
    ]);
    return apiRef;
}

});


parcelRegister("fcFWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useChartCartesianAxis", {
    enumerable: true,
    get: function() {
        return $a5Dpn.useChartCartesianAxis;
    }
});
Object.defineProperty(module.exports, "useChartClosestPoint", {
    enumerable: true,
    get: function() {
        return $dzF8X.useChartClosestPoint;
    }
});
Object.defineProperty(module.exports, "useChartHighlight", {
    enumerable: true,
    get: function() {
        return $cZLDK.useChartHighlight;
    }
});
Object.defineProperty(module.exports, "useChartInteraction", {
    enumerable: true,
    get: function() {
        return $8j56i.useChartInteraction;
    }
});
Object.defineProperty(module.exports, "useChartPolarAxis", {
    enumerable: true,
    get: function() {
        return $j98pQ.useChartPolarAxis;
    }
});
Object.defineProperty(module.exports, "useChartTooltip", {
    enumerable: true,
    get: function() {
        return $d8Csh.useChartTooltip;
    }
});
Object.defineProperty(module.exports, "useChartVisibilityManager", {
    enumerable: true,
    get: function() {
        return $fgykb.useChartVisibilityManager;
    }
});
Object.defineProperty(module.exports, "useChartZAxis", {
    enumerable: true,
    get: function() {
        return $d4cjJ.useChartZAxis;
    }
});

var $a5Dpn = parcelRequire("a5Dpn");

var $cZLDK = parcelRequire("cZLDK");

var $d8Csh = parcelRequire("d8Csh");

var $8j56i = parcelRequire("8j56i");

var $j98pQ = parcelRequire("j98pQ");

var $dzF8X = parcelRequire("dzF8X");

var $d4cjJ = parcelRequire("d4cjJ");

var $fgykb = parcelRequire("fgykb");

});

parcelRegister("8d4MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6pcPE = parcelRequire("6pcPE");
Object.keys($6pcPE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6pcPE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6pcPE[key];
        }
    });
});

var $19jso = parcelRequire("19jso");
Object.keys($19jso).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $19jso[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19jso[key];
        }
    });
});

var $bLPGR = parcelRequire("bLPGR");
Object.keys($bLPGR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $bLPGR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bLPGR[key];
        }
    });
});

var $iNj5E = parcelRequire("iNj5E");
Object.keys($iNj5E).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $iNj5E[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iNj5E[key];
        }
    });
});

});
parcelRegister("6pcPE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4a9f0814ea3c9873$var$_exportNames = {
    isDefaultizedBarSeries: true,
    isBarSeries: true
};
module.exports.isBarSeries = $4a9f0814ea3c9873$var$isBarSeries;
module.exports.isDefaultizedBarSeries = $4a9f0814ea3c9873$var$isDefaultizedBarSeries;

var $5gBs3 = parcelRequire("5gBs3");
Object.keys($5gBs3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a9f0814ea3c9873$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5gBs3[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5gBs3[key];
        }
    });
});

var $4eU64 = parcelRequire("4eU64");
Object.keys($4eU64).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a9f0814ea3c9873$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4eU64[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4eU64[key];
        }
    });
});

var $heMC4 = parcelRequire("heMC4");
Object.keys($heMC4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a9f0814ea3c9873$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $heMC4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $heMC4[key];
        }
    });
});

var $fuM6I = parcelRequire("fuM6I");
Object.keys($fuM6I).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a9f0814ea3c9873$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fuM6I[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fuM6I[key];
        }
    });
});

var $kLaYo = parcelRequire("kLaYo");
Object.keys($kLaYo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a9f0814ea3c9873$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kLaYo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kLaYo[key];
        }
    });
});
// Series definition
/**
 * @deprecated We do not use this type in v8. If it's useful for you use case, please open an issue explaining why.
 * Otherwise, it will be removed in next major.
 */ /**
 * @deprecated We do not use this type in v8. If it's useful for you use case, please open an issue explaining why.
 * Otherwise, it will be removed in next major.
 */ /**
 * @deprecated We do not use this type in v8. If it's useful for you use case, please open an issue explaining why.
 * Otherwise, it will be removed in next major.
 */ // item identifier
// Helpers
/**
 * @deprecated We do not use this function in v8. If it's useful for you use case, please open an issue explaining why.
 * Otherwise, it will be removed in next major.
 */ function $4a9f0814ea3c9873$var$isDefaultizedBarSeries(series) {
    return series.type === 'bar';
}
/**
 * @deprecated We do not use this function in v8. If it's useful for you use case, please open an issue explaining why.
 * Otherwise, it will be removed in next major.
 */ function $4a9f0814ea3c9873$var$isBarSeries(series) {
    return series.type === 'bar';
}

});
parcelRegister("5gBs3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4eU64", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("heMC4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fuM6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kLaYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("19jso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bLPGR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hjEf7 = parcelRequire("hjEf7");
Object.keys($hjEf7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hjEf7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hjEf7[key];
        }
    });
});

var $9ExkI = parcelRequire("9ExkI");
Object.keys($9ExkI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9ExkI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9ExkI[key];
        }
    });
});

var $486r2 = parcelRequire("486r2");
Object.keys($486r2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $486r2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $486r2[key];
        }
    });
});

});
parcelRegister("hjEf7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9ExkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("486r2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("iNj5E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("7XBLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g7sWX = parcelRequire("g7sWX");
Object.keys($g7sWX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g7sWX[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $g7sWX[key];
        }
    });
});

var $lpn87 = parcelRequire("lpn87");
Object.keys($lpn87).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lpn87[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lpn87[key];
        }
    });
});

});
parcelRegister("g7sWX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bbc3c1a07468fa9d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsReferenceLine = $bbc3c1a07468fa9d$var$ChartsReferenceLine;

var $bbc3c1a07468fa9d$var$_extends2 = $bbc3c1a07468fa9d$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bbc3c1a07468fa9d$var$_propTypes = $bbc3c1a07468fa9d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $92e88 = parcelRequire("92e88");

var $fec3B = parcelRequire("fec3B");

var $ayMG0 = parcelRequire("ayMG0");
function $bbc3c1a07468fa9d$var$ChartsReferenceLine(props) {
    const { x: x, y: y } = props;
    if (x !== undefined && y !== undefined) throw new Error('MUI X Charts: The ChartsReferenceLine cannot have both `x` and `y` props set.');
    if (x === undefined && y === undefined) throw new Error('MUI X Charts: The ChartsReferenceLine should have a value in `x` or `y` prop.');
    if (x !== undefined) return /*#__PURE__*/ (0, $ayMG0.jsx)($92e88.ChartsXReferenceLine, (0, $bbc3c1a07468fa9d$var$_extends2.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fec3B.ChartsYReferenceLine, (0, $bbc3c1a07468fa9d$var$_extends2.default)({}, props));
}

});
parcelRegister("92e88", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $693f42e7bf9cc88b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsXReferenceLine = $693f42e7bf9cc88b$var$ChartsXReferenceLine;
module.exports.getXReferenceLineClasses = $693f42e7bf9cc88b$var$getXReferenceLineClasses;

var $693f42e7bf9cc88b$var$_extends2 = $693f42e7bf9cc88b$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $693f42e7bf9cc88b$var$_propTypes = $693f42e7bf9cc88b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $693f42e7bf9cc88b$var$_composeClasses = $693f42e7bf9cc88b$require$_interopRequireDefault((parcelRequire("3Hg1x")));


var $55quD = parcelRequire("55quD");

var $7teXR = parcelRequire("7teXR");

var $41V8S = parcelRequire("41V8S");

var $lpn87 = parcelRequire("lpn87");

var $ayMG0 = parcelRequire("ayMG0");
const $693f42e7bf9cc88b$var$getTextParams = ({ top: top, height: height, spacing: spacing, position: position, labelAlign: labelAlign = 'middle' })=>{
    const defaultSpacingOtherAxis = labelAlign === 'middle' ? $7teXR.DEFAULT_SPACING_MIDDLE_OTHER_AXIS : $7teXR.DEFAULT_SPACING;
    const spacingX = (typeof spacing === 'object' ? spacing.x : spacing) ?? $7teXR.DEFAULT_SPACING;
    const spacingY = (typeof spacing === 'object' ? spacing.y : defaultSpacingOtherAxis) ?? defaultSpacingOtherAxis;
    switch(labelAlign){
        case 'start':
            return {
                x: position + spacingX,
                y: top + spacingY,
                style: {
                    dominantBaseline: 'hanging',
                    textAnchor: 'start'
                }
            };
        case 'end':
            return {
                x: position + spacingX,
                y: top + height - spacingY,
                style: {
                    dominantBaseline: 'auto',
                    textAnchor: 'start'
                }
            };
        default:
            return {
                x: position + spacingX,
                y: top + height / 2 + spacingY,
                style: {
                    dominantBaseline: 'central',
                    textAnchor: 'start'
                }
            };
    }
};
function $693f42e7bf9cc88b$var$getXReferenceLineClasses(classes) {
    return (0, $693f42e7bf9cc88b$var$_composeClasses.default)({
        root: [
            'root',
            'vertical'
        ],
        line: [
            'line'
        ],
        label: [
            'label'
        ]
    }, $lpn87.getReferenceLineUtilityClass, classes);
}
function $693f42e7bf9cc88b$var$ChartsXReferenceLine(props) {
    const { x: x, label: label = '', spacing: spacing, classes: inClasses, labelAlign: labelAlign = 'middle', lineStyle: lineStyle, labelStyle: labelStyle, axisId: axisId } = props;
    const { top: top, height: height } = (0, $55quD.useDrawingArea)();
    const xAxisScale = (0, $55quD.useXScale)(axisId);
    const xPosition = xAxisScale(x);
    if (xPosition === undefined) return null;
    const d = `M ${xPosition} ${top} l 0 ${height}`;
    const classes = $693f42e7bf9cc88b$var$getXReferenceLineClasses(inClasses);
    const textParams = (0, $693f42e7bf9cc88b$var$_extends2.default)({
        text: label,
        fontSize: 12
    }, $693f42e7bf9cc88b$var$getTextParams({
        top: top,
        height: height,
        spacing: spacing,
        position: xPosition,
        labelAlign: labelAlign
    }), {
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7teXR.ReferenceLineRoot, {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: d,
                className: classes.line,
                style: lineStyle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($41V8S.ChartsText, (0, $693f42e7bf9cc88b$var$_extends2.default)({}, textParams, {
                style: (0, $693f42e7bf9cc88b$var$_extends2.default)({}, textParams.style, labelStyle)
            }))
        ]
    });
}

});
parcelRegister("7teXR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5706d97850f7c287$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReferenceLineRoot = module.exports.DEFAULT_SPACING_MIDDLE_OTHER_AXIS = module.exports.DEFAULT_SPACING = void 0;

var $5706d97850f7c287$var$_extends2 = $5706d97850f7c287$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8xDHs = parcelRequire("8xDHs");

var $lpn87 = parcelRequire("lpn87");
const $5706d97850f7c287$var$DEFAULT_SPACING = module.exports.DEFAULT_SPACING = 5;
const $5706d97850f7c287$var$DEFAULT_SPACING_MIDDLE_OTHER_AXIS = module.exports.DEFAULT_SPACING_MIDDLE_OTHER_AXIS = 0;
const $5706d97850f7c287$var$ReferenceLineRoot = module.exports.ReferenceLineRoot = (0, $8xDHs.styled)('g', {
    slot: 'internal',
    shouldForwardProp: undefined
})(({ theme: theme })=>({
        [`& .${$lpn87.referenceLineClasses.line}`]: {
            fill: 'none',
            stroke: (theme.vars || theme).palette.text.primary,
            shapeRendering: 'crispEdges',
            strokeWidth: 1,
            pointerEvents: 'none'
        },
        [`& .${$lpn87.referenceLineClasses.label}`]: (0, $5706d97850f7c287$var$_extends2.default)({
            fill: (theme.vars || theme).palette.text.primary,
            stroke: 'none',
            pointerEvents: 'none',
            fontSize: 12
        }, theme.typography.body1)
    }));

});
parcelRegister("lpn87", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f95ddfe9e6636845$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getReferenceLineUtilityClass = $f95ddfe9e6636845$var$getReferenceLineUtilityClass;
module.exports.referenceLineClasses = void 0;

var $f95ddfe9e6636845$var$_generateUtilityClass = $f95ddfe9e6636845$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $f95ddfe9e6636845$var$_generateUtilityClasses = $f95ddfe9e6636845$require$_interopRequireDefault((parcelRequire("5nY49")));
function $f95ddfe9e6636845$var$getReferenceLineUtilityClass(slot) {
    return (0, $f95ddfe9e6636845$var$_generateUtilityClass.default)('MuiChartsReferenceLine', slot);
}
const $f95ddfe9e6636845$var$referenceLineClasses = module.exports.referenceLineClasses = (0, $f95ddfe9e6636845$var$_generateUtilityClasses.default)('MuiChartsReferenceLine', [
    'root',
    'vertical',
    'horizontal',
    'line',
    'label'
]);

});



parcelRegister("fec3B", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b161842013009a84$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsYReferenceLine = $b161842013009a84$var$ChartsYReferenceLine;
module.exports.getYReferenceLineClasses = $b161842013009a84$var$getYReferenceLineClasses;

var $b161842013009a84$var$_extends2 = $b161842013009a84$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b161842013009a84$var$_propTypes = $b161842013009a84$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b161842013009a84$var$_composeClasses = $b161842013009a84$require$_interopRequireDefault((parcelRequire("3Hg1x")));


var $55quD = parcelRequire("55quD");

var $7teXR = parcelRequire("7teXR");

var $41V8S = parcelRequire("41V8S");

var $lpn87 = parcelRequire("lpn87");

var $ayMG0 = parcelRequire("ayMG0");
const $b161842013009a84$var$getTextParams = ({ left: left, width: width, spacing: spacing, position: position, labelAlign: labelAlign = 'middle' })=>{
    const defaultSpacingOtherAxis = labelAlign === 'middle' ? $7teXR.DEFAULT_SPACING_MIDDLE_OTHER_AXIS : $7teXR.DEFAULT_SPACING;
    const spacingX = (typeof spacing === 'object' ? spacing.x : defaultSpacingOtherAxis) ?? defaultSpacingOtherAxis;
    const spacingY = (typeof spacing === 'object' ? spacing.y : spacing) ?? $7teXR.DEFAULT_SPACING;
    switch(labelAlign){
        case 'start':
            return {
                y: position - spacingY,
                x: left + spacingX,
                style: {
                    dominantBaseline: 'auto',
                    textAnchor: 'start'
                }
            };
        case 'end':
            return {
                y: position - spacingY,
                x: left + width - spacingX,
                style: {
                    dominantBaseline: 'auto',
                    textAnchor: 'end'
                }
            };
        default:
            return {
                y: position - spacingY,
                x: left + width / 2 + spacingX,
                style: {
                    dominantBaseline: 'auto',
                    textAnchor: 'middle'
                }
            };
    }
};
function $b161842013009a84$var$getYReferenceLineClasses(classes) {
    return (0, $b161842013009a84$var$_composeClasses.default)({
        root: [
            'root',
            'horizontal'
        ],
        line: [
            'line'
        ],
        label: [
            'label'
        ]
    }, $lpn87.getReferenceLineUtilityClass, classes);
}
function $b161842013009a84$var$ChartsYReferenceLine(props) {
    const { y: y, label: label = '', spacing: spacing, classes: inClasses, labelAlign: labelAlign = 'middle', lineStyle: lineStyle, labelStyle: labelStyle, axisId: axisId } = props;
    const { left: left, width: width } = (0, $55quD.useDrawingArea)();
    const yAxisScale = (0, $55quD.useYScale)(axisId);
    const yPosition = yAxisScale(y);
    if (yPosition === undefined) return null;
    const d = `M ${left} ${yPosition} l ${width} 0`;
    const classes = $b161842013009a84$var$getYReferenceLineClasses(inClasses);
    const textParams = (0, $b161842013009a84$var$_extends2.default)({
        text: label,
        fontSize: 12
    }, $b161842013009a84$var$getTextParams({
        left: left,
        width: width,
        spacing: spacing,
        position: yPosition,
        labelAlign: labelAlign
    }), {
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7teXR.ReferenceLineRoot, {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: d,
                className: classes.line,
                style: lineStyle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($41V8S.ChartsText, (0, $b161842013009a84$var$_extends2.default)({}, textParams, {
                style: (0, $b161842013009a84$var$_extends2.default)({}, textParams.style, labelStyle)
            }))
        ]
    });
}

});



parcelRegister("aiEgN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dPTe0 = parcelRequire("dPTe0");
Object.keys($dPTe0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dPTe0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dPTe0[key];
        }
    });
});

var $aMZmt = parcelRequire("aMZmt");
Object.keys($aMZmt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aMZmt[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aMZmt[key];
        }
    });
});

});

parcelRegister("2xwmx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1d97c45ea7c65423$var$_exportNames = {
    ChartsLabelMark: true,
    labelClasses: true,
    labelMarkClasses: true,
    labelGradientClasses: true
};
Object.defineProperty(module.exports, "ChartsLabelMark", {
    enumerable: true,
    get: function() {
        return $ip5yP.ChartsLabelMark;
    }
});
Object.defineProperty(module.exports, "labelClasses", {
    enumerable: true,
    get: function() {
        return $kNQif.labelClasses;
    }
});
Object.defineProperty(module.exports, "labelGradientClasses", {
    enumerable: true,
    get: function() {
        return $gnhSB.labelGradientClasses;
    }
});
Object.defineProperty(module.exports, "labelMarkClasses", {
    enumerable: true,
    get: function() {
        return $9Cvbh.labelMarkClasses;
    }
});

var $kUHUZ = parcelRequire("kUHUZ");
Object.keys($kUHUZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1d97c45ea7c65423$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $kUHUZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $kUHUZ[key];
        }
    });
});

var $ip5yP = parcelRequire("ip5yP");

var $kNQif = parcelRequire("kNQif");

var $9Cvbh = parcelRequire("9Cvbh");

var $gnhSB = parcelRequire("gnhSB");

});

parcelRegister("1R6Wm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $15a01fe532f1e356$var$_exportNames = {
    barClasses: true,
    getBarUtilityClass: true
};
Object.defineProperty(module.exports, "barClasses", {
    enumerable: true,
    get: function() {
        return $6qDbs.barClasses;
    }
});
Object.defineProperty(module.exports, "getBarUtilityClass", {
    enumerable: true,
    get: function() {
        return $6qDbs.getBarUtilityClass;
    }
});

var $5lYAK = parcelRequire("5lYAK");
Object.keys($5lYAK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5lYAK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5lYAK[key];
        }
    });
});

var $2Ngip = parcelRequire("2Ngip");
Object.keys($2Ngip).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2Ngip[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2Ngip[key];
        }
    });
});

var $chHrn = parcelRequire("chHrn");
Object.keys($chHrn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $chHrn[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $chHrn[key];
        }
    });
});

var $htjGO = parcelRequire("htjGO");
Object.keys($htjGO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $htjGO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $htjGO[key];
        }
    });
});

var $vuSuv = parcelRequire("vuSuv");
Object.keys($vuSuv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $vuSuv[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $vuSuv[key];
        }
    });
});

var $knZgE = parcelRequire("knZgE");
Object.keys($knZgE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $knZgE[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $knZgE[key];
        }
    });
});

var $9ZwHu = parcelRequire("9ZwHu");
Object.keys($9ZwHu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($15a01fe532f1e356$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9ZwHu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9ZwHu[key];
        }
    });
});

var $6qDbs = parcelRequire("6qDbs");

});
parcelRegister("5lYAK", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $3e5dea2c4eac73e1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $3e5dea2c4eac73e1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarChart = void 0;

var $3e5dea2c4eac73e1$var$_extends2 = $3e5dea2c4eac73e1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $3e5dea2c4eac73e1$var$React = $3e5dea2c4eac73e1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3e5dea2c4eac73e1$var$_propTypes = $3e5dea2c4eac73e1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $2Ngip = parcelRequire("2Ngip");

var $aiEgN = parcelRequire("aiEgN");

var $luY0B = parcelRequire("luY0B");

var $anK5t = parcelRequire("anK5t");

var $ad3Dp = parcelRequire("ad3Dp");

var $6WChQ = parcelRequire("6WChQ");

var $2ppSP = parcelRequire("2ppSP");

var $53stl = parcelRequire("53stl");

var $ldQXI = parcelRequire("ldQXI");

var $eSGGd = parcelRequire("eSGGd");

var $ezMKh = parcelRequire("ezMKh");

var $3jE6m = parcelRequire("3jE6m");

var $G4UB8 = parcelRequire("G4UB8");

var $vuSuv = parcelRequire("vuSuv");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Bars](https://mui.com/x/react-charts/bars/)
 * - [Bar demonstration](https://mui.com/x/react-charts/bar-demo/)
 * - [Stacking](https://mui.com/x/react-charts/stacking/)
 *
 * API:
 *
 * - [BarChart API](https://mui.com/x/api/charts/bar-chart/)
 */ const $3e5dea2c4eac73e1$var$BarChart = module.exports.BarChart = /*#__PURE__*/ $3e5dea2c4eac73e1$var$React.forwardRef(function BarChart(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiBarChart'
    });
    const { chartsWrapperProps: chartsWrapperProps, chartContainerProps: chartContainerProps, barPlotProps: barPlotProps, gridProps: gridProps, clipPathProps: clipPathProps, clipPathGroupProps: clipPathGroupProps, overlayProps: overlayProps, chartsAxisProps: chartsAxisProps, axisHighlightProps: axisHighlightProps, legendProps: legendProps, children: children } = (0, $ldQXI.useBarChartProps)(props);
    const { chartDataProviderProps: chartDataProviderProps, chartsSurfaceProps: chartsSurfaceProps } = (0, $3jE6m.useChartContainerProps)(chartContainerProps, ref);
    const Tooltip = props.slots?.tooltip ?? $luY0B.ChartsTooltip;
    const Toolbar = props.slots?.toolbar;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eSGGd.ChartDataProvider, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, chartDataProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($G4UB8.ChartsWrapper, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, chartsWrapperProps, {
            children: [
                props.showToolbar && Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, props.slotProps?.toolbar)) : null,
                !props.hideLegend && /*#__PURE__*/ (0, $ayMG0.jsx)($anK5t.ChartsLegend, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, legendProps)),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ezMKh.ChartsSurface, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, chartsSurfaceProps, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($2ppSP.ChartsGrid, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, gridProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, clipPathGroupProps, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($2Ngip.BarPlot, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, barPlotProps)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($53stl.ChartsOverlay, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, overlayProps)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($ad3Dp.ChartsAxisHighlight, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, axisHighlightProps)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($vuSuv.FocusedBar, {})
                            ]
                        })),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($aiEgN.ChartsAxis, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, chartsAxisProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($6WChQ.ChartsClipPath, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, clipPathProps)),
                        children
                    ]
                })),
                !props.loading && /*#__PURE__*/ (0, $ayMG0.jsx)(Tooltip, (0, $3e5dea2c4eac73e1$var$_extends2.default)({}, props.slotProps?.tooltip))
            ]
        }))
    }));
});

});
parcelRegister("2Ngip", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $208ccc67061b9e9a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $208ccc67061b9e9a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarPlot = $208ccc67061b9e9a$var$BarPlot;

var $208ccc67061b9e9a$var$_extends2 = $208ccc67061b9e9a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $208ccc67061b9e9a$var$_objectWithoutPropertiesLoose2 = $208ccc67061b9e9a$require$_interopRequireDefault((parcelRequire("c05no")));

var $208ccc67061b9e9a$var$React = $208ccc67061b9e9a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $208ccc67061b9e9a$var$_propTypes = $208ccc67061b9e9a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $knZgE = parcelRequire("knZgE");

var $55quD = parcelRequire("55quD");

var $ijd9d = parcelRequire("ijd9d");

var $cfS2L = parcelRequire("cfS2L");

var $cFMyx = parcelRequire("cFMyx");

var $c3RKB = parcelRequire("c3RKB");

var $6qDbs = parcelRequire("6qDbs");

var $32gdR = parcelRequire("32gdR");

var $gye18 = parcelRequire("gye18");

var $8gRk5 = parcelRequire("8gRk5");

var $ayMG0 = parcelRequire("ayMG0");
const $208ccc67061b9e9a$var$_excluded = [
    "skipAnimation",
    "onItemClick",
    "borderRadius",
    "barLabel",
    "renderer"
];
const $208ccc67061b9e9a$var$BarPlotRoot = (0, $8xDHs.styled)('g', {
    name: 'MuiBarPlot',
    slot: 'Root'
})({
    [`& .${$knZgE.barElementClasses.root}`]: {
        transitionProperty: 'opacity, fill',
        transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
        transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION
    }
});
/**
 * Demos:
 *
 * - [Bars](https://mui.com/x/react-charts/bars/)
 * - [Bar demonstration](https://mui.com/x/react-charts/bar-demo/)
 * - [Stacking](https://mui.com/x/react-charts/stacking/)
 *
 * API:
 *
 * - [BarPlot API](https://mui.com/x/api/charts/bar-plot/)
 */ function $208ccc67061b9e9a$var$BarPlot(props) {
    const { skipAnimation: inSkipAnimation, onItemClick: onItemClick, borderRadius: borderRadius, barLabel: barLabel, renderer: renderer } = props, other = (0, $208ccc67061b9e9a$var$_objectWithoutPropertiesLoose2.default)(props, $208ccc67061b9e9a$var$_excluded);
    const isZoomInteracting = (0, $cFMyx.useInternalIsZoomInteracting)();
    const skipAnimation = (0, $cfS2L.useSkipAnimation)(isZoomInteracting || inSkipAnimation);
    const batchSkipAnimation = (0, $cfS2L.useSkipAnimation)(inSkipAnimation);
    const { xAxis: xAxes } = (0, $55quD.useXAxes)();
    const { yAxis: yAxes } = (0, $55quD.useYAxes)();
    const { completedData: completedData, masksData: masksData } = (0, $c3RKB.useBarPlotData)((0, $55quD.useDrawingArea)(), xAxes, yAxes);
    const classes = (0, $6qDbs.useUtilityClasses)();
    const BarElementPlot = renderer === 'svg-batch' ? $8gRk5.BatchBarPlot : $gye18.IndividualBarPlot;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($208ccc67061b9e9a$var$BarPlotRoot, {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(BarElementPlot, (0, $208ccc67061b9e9a$var$_extends2.default)({
                completedData: completedData,
                masksData: masksData,
                skipAnimation: renderer === 'svg-batch' ? batchSkipAnimation : skipAnimation,
                onItemClick: /* `onItemClick` accepts a `MouseEvent` when the renderer is "svg-batch" and a `React.MouseEvent` otherwise,
       * so we need this cast to prevent TypeScript from complaining. */ onItemClick,
                borderRadius: borderRadius
            }, other)),
            completedData.map((processedSeries)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ijd9d.BarLabelPlot, (0, $208ccc67061b9e9a$var$_extends2.default)({
                    className: classes.seriesLabels,
                    processedSeries: processedSeries,
                    skipAnimation: skipAnimation,
                    barLabel: barLabel
                }, other), processedSeries.seriesId))
        ]
    });
}

});
parcelRegister("knZgE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ed757b17922a02af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.barElementClasses = void 0;
module.exports.getBarElementUtilityClass = $ed757b17922a02af$var$getBarElementUtilityClass;
module.exports.useUtilityClasses = void 0;

var $ed757b17922a02af$var$_generateUtilityClass = $ed757b17922a02af$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $ed757b17922a02af$var$_composeClasses = $ed757b17922a02af$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ed757b17922a02af$var$_generateUtilityClasses = $ed757b17922a02af$require$_interopRequireDefault((parcelRequire("5nY49")));
function $ed757b17922a02af$var$getBarElementUtilityClass(slot) {
    return (0, $ed757b17922a02af$var$_generateUtilityClass.default)('MuiBarElement', slot);
}
const $ed757b17922a02af$var$barElementClasses = module.exports.barElementClasses = (0, $ed757b17922a02af$var$_generateUtilityClasses.default)('MuiBarElement', [
    'root',
    'highlighted',
    'faded',
    'series'
]);
const $ed757b17922a02af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isHighlighted: isHighlighted, isFaded: isFaded } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${id}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded'
        ]
    };
    return (0, $ed757b17922a02af$var$_composeClasses.default)(slots, $ed757b17922a02af$var$getBarElementUtilityClass, classes);
};
module.exports.useUtilityClasses = $ed757b17922a02af$var$useUtilityClasses;

});

parcelRegister("ijd9d", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d544332c9e4b3173$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d544332c9e4b3173$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarLabelPlot = $d544332c9e4b3173$var$BarLabelPlot;

var $d544332c9e4b3173$var$_extends2 = $d544332c9e4b3173$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d544332c9e4b3173$var$_objectWithoutPropertiesLoose2 = $d544332c9e4b3173$require$_interopRequireDefault((parcelRequire("c05no")));

var $d544332c9e4b3173$var$React = $d544332c9e4b3173$require$_interopRequireWildcard((parcelRequire("acw62")));

var $du3sE = parcelRequire("du3sE");

var $ayMG0 = parcelRequire("ayMG0");
const $d544332c9e4b3173$var$_excluded = [
    "processedSeries",
    "className",
    "skipAnimation"
];
/**
 * @ignore - internal component.
 */ function $d544332c9e4b3173$var$BarLabelPlot(props) {
    const { processedSeries: processedSeries, className: className, skipAnimation: skipAnimation } = props, other = (0, $d544332c9e4b3173$var$_objectWithoutPropertiesLoose2.default)(props, $d544332c9e4b3173$var$_excluded);
    const { seriesId: seriesId, data: data, layout: layout, xOrigin: xOrigin, yOrigin: yOrigin } = processedSeries;
    const barLabel = processedSeries.barLabel ?? props.barLabel;
    if (!barLabel) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        className: className,
        "data-series": seriesId,
        children: data.map(({ x: x, y: y, dataIndex: dataIndex, color: color, value: value, width: width, height: height, hidden: hidden })=>/*#__PURE__*/ (0, $ayMG0.jsx)($du3sE.BarLabelItem, (0, $d544332c9e4b3173$var$_extends2.default)({
                seriesId: seriesId,
                dataIndex: dataIndex,
                value: value,
                color: color,
                xOrigin: xOrigin,
                yOrigin: yOrigin,
                x: x,
                y: y,
                width: width,
                height: height,
                skipAnimation: skipAnimation ?? false,
                layout: layout ?? 'vertical',
                hidden: hidden
            }, other, {
                barLabel: barLabel,
                barLabelPlacement: processedSeries.barLabelPlacement || 'center'
            }), dataIndex))
    }, seriesId);
}

});
parcelRegister("du3sE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9d10c2fc122e7d5f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $9d10c2fc122e7d5f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarLabelItem = $9d10c2fc122e7d5f$var$BarLabelItem;

var $9d10c2fc122e7d5f$var$_extends2 = $9d10c2fc122e7d5f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9d10c2fc122e7d5f$var$_objectWithoutPropertiesLoose2 = $9d10c2fc122e7d5f$require$_interopRequireDefault((parcelRequire("c05no")));

var $9d10c2fc122e7d5f$var$React = $9d10c2fc122e7d5f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9d10c2fc122e7d5f$var$_useSlotProps2 = $9d10c2fc122e7d5f$require$_interopRequireDefault((parcelRequire("839K0")));

var $9d10c2fc122e7d5f$var$_propTypes = $9d10c2fc122e7d5f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6nIA5 = parcelRequire("6nIA5");

var $4Ct9e = parcelRequire("4Ct9e");

var $e087c = parcelRequire("e087c");

var $3N2dU = parcelRequire("3N2dU");

var $ayMG0 = parcelRequire("ayMG0");
const $9d10c2fc122e7d5f$var$_excluded = [
    "seriesId",
    "classes",
    "color",
    "dataIndex",
    "barLabel",
    "slots",
    "slotProps",
    "xOrigin",
    "yOrigin",
    "x",
    "y",
    "width",
    "height",
    "value",
    "skipAnimation",
    "layout",
    "barLabelPlacement",
    "hidden"
], $9d10c2fc122e7d5f$var$_excluded2 = [
    "ownerState"
];
/**
 * @ignore - internal component.
 */ function $9d10c2fc122e7d5f$var$BarLabelItem(props) {
    const { seriesId: seriesId, classes: innerClasses, color: color, dataIndex: dataIndex, barLabel: barLabel, slots: slots, slotProps: slotProps, xOrigin: xOrigin, yOrigin: yOrigin, x: x, y: y, width: width, height: height, value: value, skipAnimation: skipAnimation, layout: layout, barLabelPlacement: barLabelPlacement, hidden: hidden } = props, other = (0, $9d10c2fc122e7d5f$var$_objectWithoutPropertiesLoose2.default)(props, $9d10c2fc122e7d5f$var$_excluded);
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $3N2dU.useItemHighlighted)({
        seriesId: seriesId,
        dataIndex: dataIndex
    });
    const ownerState = {
        seriesId: seriesId,
        classes: innerClasses,
        color: color,
        isFaded: isFaded,
        isHighlighted: isHighlighted,
        dataIndex: dataIndex,
        skipAnimation: skipAnimation,
        layout: layout
    };
    const classes = (0, $6nIA5.useUtilityClasses)(ownerState);
    const Component = slots?.barLabel ?? $e087c.BarLabel;
    const _useSlotProps = (0, $9d10c2fc122e7d5f$var$_useSlotProps2.default)({
        elementType: Component,
        externalSlotProps: slotProps?.barLabel,
        additionalProps: (0, $9d10c2fc122e7d5f$var$_extends2.default)({}, other, {
            xOrigin: xOrigin,
            yOrigin: yOrigin,
            x: x,
            y: y,
            width: width,
            height: height,
            placement: barLabelPlacement,
            className: classes.root
        }),
        ownerState: ownerState
    }), { ownerState: barLabelOwnerState } = _useSlotProps, barLabelProps = (0, $9d10c2fc122e7d5f$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $9d10c2fc122e7d5f$var$_excluded2);
    if (!barLabel) return null;
    const formattedLabelText = (0, $4Ct9e.getBarLabel)({
        barLabel: barLabel,
        value: value,
        dataIndex: dataIndex,
        seriesId: seriesId,
        height: height,
        width: width
    });
    if (!formattedLabelText) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, (0, $9d10c2fc122e7d5f$var$_extends2.default)({}, barLabelProps, barLabelOwnerState, {
        hidden: hidden,
        children: formattedLabelText
    }));
}

});
parcelRegister("6nIA5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4a5778f2eb255f41$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.barLabelClasses = void 0;
module.exports.getBarLabelUtilityClass = $4a5778f2eb255f41$var$getBarLabelUtilityClass;
module.exports.useUtilityClasses = void 0;

var $4a5778f2eb255f41$var$_generateUtilityClass = $4a5778f2eb255f41$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $4a5778f2eb255f41$var$_generateUtilityClasses = $4a5778f2eb255f41$require$_interopRequireDefault((parcelRequire("5nY49")));

var $4a5778f2eb255f41$var$_composeClasses = $4a5778f2eb255f41$require$_interopRequireDefault((parcelRequire("3Hg1x")));
function $4a5778f2eb255f41$var$getBarLabelUtilityClass(slot) {
    return (0, $4a5778f2eb255f41$var$_generateUtilityClass.default)('MuiBarLabel', slot);
}
const $4a5778f2eb255f41$var$barLabelClasses = module.exports.barLabelClasses = (0, $4a5778f2eb255f41$var$_generateUtilityClasses.default)('MuiBarLabel', [
    'root',
    'highlighted',
    'faded',
    'animate'
]);
const $4a5778f2eb255f41$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, seriesId: seriesId, isFaded: isFaded, isHighlighted: isHighlighted, skipAnimation: skipAnimation } = ownerState;
    const slots = {
        root: [
            'root',
            `series-${seriesId}`,
            isHighlighted && 'highlighted',
            isFaded && 'faded',
            !skipAnimation && 'animate'
        ]
    };
    return (0, $4a5778f2eb255f41$var$_composeClasses.default)(slots, $4a5778f2eb255f41$var$getBarLabelUtilityClass, classes);
};
module.exports.useUtilityClasses = $4a5778f2eb255f41$var$useUtilityClasses;

});

parcelRegister("4Ct9e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBarLabel = $35d1522cb7111cf4$var$getBarLabel;
function $35d1522cb7111cf4$var$getBarLabel(options) {
    const { barLabel: barLabel, value: value, dataIndex: dataIndex, seriesId: seriesId, height: height, width: width } = options;
    if (barLabel === 'value') // We don't want to show the label if the value is 0
    return value ? value?.toString() : null;
    return barLabel({
        seriesId: seriesId,
        dataIndex: dataIndex,
        value: value
    }, {
        bar: {
            height: height,
            width: width
        }
    });
}

});

parcelRegister("e087c", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $a3175c3feeee1175$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $a3175c3feeee1175$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarLabel = $a3175c3feeee1175$var$BarLabel;
module.exports.BarLabelComponent = void 0;

var $a3175c3feeee1175$var$_objectWithoutPropertiesLoose2 = $a3175c3feeee1175$require$_interopRequireDefault((parcelRequire("c05no")));

var $a3175c3feeee1175$var$_extends2 = $a3175c3feeee1175$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $a3175c3feeee1175$var$React = $a3175c3feeee1175$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $a3175c3feeee1175$var$_propTypes = $a3175c3feeee1175$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1a1OT = parcelRequire("1a1OT");

var $6nIA5 = parcelRequire("6nIA5");

var $32gdR = parcelRequire("32gdR");

var $ayMG0 = parcelRequire("ayMG0");
const $a3175c3feeee1175$var$_excluded = [
    "seriesId",
    "dataIndex",
    "color",
    "isFaded",
    "isHighlighted",
    "classes",
    "skipAnimation",
    "layout",
    "xOrigin",
    "yOrigin",
    "placement",
    "hidden"
];
const $a3175c3feeee1175$var$BarLabelComponent = module.exports.BarLabelComponent = (0, $8xDHs.styled)('text', {
    name: 'MuiBarLabel',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            {
                [`&.${$6nIA5.barLabelClasses.faded}`]: styles.faded
            },
            {
                [`&.${$6nIA5.barLabelClasses.highlighted}`]: styles.highlighted
            },
            styles.root
        ]
})(({ theme: theme })=>(0, $a3175c3feeee1175$var$_extends2.default)({}, theme?.typography?.body2, {
        stroke: 'none',
        fill: (theme.vars || theme)?.palette?.text?.primary,
        transitionProperty: 'opacity, fill',
        transitionDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
        transitionTimingFunction: $32gdR.ANIMATION_TIMING_FUNCTION,
        pointerEvents: 'none'
    }));
function $a3175c3feeee1175$var$BarLabel(inProps) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiBarLabel'
    });
    const { isFaded: isFaded, hidden: hidden } = props, otherProps = (0, $a3175c3feeee1175$var$_objectWithoutPropertiesLoose2.default)(props, $a3175c3feeee1175$var$_excluded);
    const animatedProps = (0, $1a1OT.useAnimateBarLabel)(props);
    const textAnchor = $a3175c3feeee1175$var$getTextAnchor(props);
    const dominantBaseline = $a3175c3feeee1175$var$getDominantBaseline(props);
    const fadedOpacity = isFaded ? 0.3 : 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a3175c3feeee1175$var$BarLabelComponent, (0, $a3175c3feeee1175$var$_extends2.default)({
        textAnchor: textAnchor,
        dominantBaseline: dominantBaseline,
        opacity: hidden ? 0 : fadedOpacity
    }, otherProps, animatedProps));
}
function $a3175c3feeee1175$var$getTextAnchor({ placement: placement, layout: layout, xOrigin: xOrigin, x: x }) {
    if (placement === 'outside') {
        if (layout === 'horizontal') return x < xOrigin ? 'end' : 'start';
        return 'middle';
    }
    return 'middle';
}
function $a3175c3feeee1175$var$getDominantBaseline({ placement: placement, layout: layout, yOrigin: yOrigin, y: y }) {
    if (placement === 'outside') {
        if (layout === 'horizontal') return 'central';
        return y < yOrigin ? 'auto' : 'hanging';
    }
    return 'central';
}

});



parcelRegister("c3RKB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $8c7f759af9e09c76$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.processBarDataForPlot = $8c7f759af9e09c76$var$processBarDataForPlot;
module.exports.useBarPlotData = $8c7f759af9e09c76$var$useBarPlotData;

var $8c7f759af9e09c76$var$_extends2 = $8c7f759af9e09c76$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8c7f759af9e09c76$var$_getColor = $8c7f759af9e09c76$require$_interopRequireDefault((parcelRequire("f25WF")));

var $55Xcx = parcelRequire("55Xcx");

var $aUQK5 = parcelRequire("aUQK5");

var $1Gldq = parcelRequire("1Gldq");

var $g5ldX = parcelRequire("g5ldX");

var $iHjed = parcelRequire("iHjed");
function $8c7f759af9e09c76$var$useBarPlotData(drawingArea, xAxes, yAxes) {
    const seriesData = (0, $1Gldq.useBarSeriesContext)() ?? {
        series: {},
        stackingGroups: [],
        seriesOrder: []
    };
    const defaultXAxisId = (0, $55Xcx.useXAxes)().xAxisIds[0];
    const defaultYAxisId = (0, $55Xcx.useYAxes)().yAxisIds[0];
    const chartId = (0, $iHjed.useChartId)();
    return $8c7f759af9e09c76$var$processBarDataForPlot(drawingArea, chartId, seriesData.stackingGroups, seriesData.series, xAxes, yAxes, defaultXAxisId, defaultYAxisId);
}
function $8c7f759af9e09c76$var$processBarDataForPlot(drawingArea, chartId, stackingGroups, series, xAxes, yAxes, defaultXAxisId, defaultYAxisId) {
    const masks = {};
    const data = stackingGroups.flatMap(({ ids: seriesIds }, groupIndex)=>{
        const xMin = drawingArea.left;
        const xMax = drawingArea.left + drawingArea.width;
        const yMin = drawingArea.top;
        const yMax = drawingArea.top + drawingArea.height;
        const lastNegativePerIndex = new Map();
        const lastPositivePerIndex = new Map();
        return seriesIds.map((seriesId)=>{
            const xAxisId = series[seriesId].xAxisId ?? defaultXAxisId;
            const yAxisId = series[seriesId].yAxisId ?? defaultYAxisId;
            const layout = series[seriesId].layout;
            const xAxisConfig = xAxes[xAxisId];
            const yAxisConfig = yAxes[yAxisId];
            const verticalLayout = series[seriesId].layout === 'vertical';
            const reverse = (verticalLayout ? yAxisConfig.reverse : xAxisConfig.reverse) ?? false;
            (0, $aUQK5.checkBarChartScaleErrors)(verticalLayout, seriesId, series[seriesId].stackedData.length, xAxisId, xAxes, yAxisId, yAxes);
            const baseScaleConfig = verticalLayout ? xAxisConfig : yAxisConfig;
            const xScale = xAxisConfig.scale;
            const yScale = yAxisConfig.scale;
            const xOrigin = Math.round(xScale(0) ?? 0);
            const yOrigin = Math.round(yScale(0) ?? 0);
            const colorGetter = (0, $8c7f759af9e09c76$var$_getColor.default)(series[seriesId], xAxes[xAxisId], yAxes[yAxisId]);
            const seriesDataPoints = [];
            for(let dataIndex = 0; dataIndex < baseScaleConfig.data.length; dataIndex += 1){
                const barDimensions = (0, $g5ldX.getBarDimensions)({
                    verticalLayout: verticalLayout,
                    xAxisConfig: xAxisConfig,
                    yAxisConfig: yAxisConfig,
                    series: series[seriesId],
                    dataIndex: dataIndex,
                    numberOfGroups: stackingGroups.length,
                    groupIndex: groupIndex
                });
                if (barDimensions == null) continue;
                const stackId = series[seriesId].stack;
                const result = (0, $8c7f759af9e09c76$var$_extends2.default)({
                    seriesId: seriesId,
                    dataIndex: dataIndex,
                    hidden: series[seriesId].hidden
                }, barDimensions, {
                    color: colorGetter(dataIndex),
                    value: series[seriesId].data[dataIndex],
                    maskId: `${chartId}_${stackId || seriesId}_${groupIndex}_${dataIndex}`
                });
                if (result.x > xMax || result.x + result.width < xMin || result.y > yMax || result.y + result.height < yMin) continue;
                const lastNegative = lastNegativePerIndex.get(dataIndex);
                const lastPositive = lastPositivePerIndex.get(dataIndex);
                const sign = (reverse ? -1 : 1) * Math.sign(result.value ?? 0);
                if (sign > 0) {
                    if (lastPositive) delete lastPositive.borderRadiusSide;
                    result.borderRadiusSide = verticalLayout ? 'top' : 'right';
                    lastPositivePerIndex.set(dataIndex, result);
                } else if (sign < 0) {
                    if (lastNegative) delete lastNegative.borderRadiusSide;
                    result.borderRadiusSide = verticalLayout ? 'bottom' : 'left';
                    lastNegativePerIndex.set(dataIndex, result);
                }
                if (!masks[result.maskId]) masks[result.maskId] = {
                    id: result.maskId,
                    width: 0,
                    height: 0,
                    hasNegative: false,
                    hasPositive: false,
                    layout: layout,
                    xOrigin: xOrigin,
                    yOrigin: yOrigin,
                    x: 0,
                    y: 0
                };
                const mask = masks[result.maskId];
                mask.width = layout === 'vertical' ? result.width : mask.width + result.width;
                mask.height = layout === 'vertical' ? mask.height + result.height : result.height;
                mask.x = Math.min(mask.x === 0 ? Infinity : mask.x, result.x);
                mask.y = Math.min(mask.y === 0 ? Infinity : mask.y, result.y);
                const value = result.value ?? 0;
                mask.hasNegative = mask.hasNegative || (reverse ? value > 0 : value < 0);
                mask.hasPositive = mask.hasPositive || (reverse ? value < 0 : value > 0);
                seriesDataPoints.push(result);
            }
            return {
                seriesId: seriesId,
                barLabel: series[seriesId].barLabel,
                barLabelPlacement: series[seriesId].barLabelPlacement,
                data: seriesDataPoints,
                layout: layout,
                xOrigin: xOrigin,
                yOrigin: yOrigin
            };
        });
    });
    return {
        completedData: data,
        masksData: Object.values(masks)
    };
}

});
parcelRegister("aUQK5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkBarChartScaleErrors = $7f280be59411d457$var$checkBarChartScaleErrors;


var $fiXDv = parcelRequire("fiXDv");
const $7f280be59411d457$var$getAxisMessage = (axisDirection, axisId)=>{
    const axisName = `${axisDirection}-axis`;
    const axisIdName = `${axisDirection}Axis`;
    const axisDefaultKey = axisDirection === 'x' ? $fiXDv.DEFAULT_X_AXIS_KEY : $fiXDv.DEFAULT_Y_AXIS_KEY;
    return axisId === axisDefaultKey ? `The first \`${axisIdName}\`` : `The ${axisName} with id "${axisId}"`;
};
function $7f280be59411d457$var$checkBarChartScaleErrors(verticalLayout, seriesId, seriesDataLength, xAxisId, xAxis, yAxisId, yAxis) {
    const xAxisConfig = xAxis[xAxisId];
    const yAxisConfig = yAxis[yAxisId];
    const discreteAxisConfig = verticalLayout ? xAxisConfig : yAxisConfig;
    const continuousAxisConfig = verticalLayout ? yAxisConfig : xAxisConfig;
    const discreteAxisId = verticalLayout ? xAxisId : yAxisId;
    const continuousAxisId = verticalLayout ? yAxisId : xAxisId;
    const discreteAxisDirection = verticalLayout ? 'x' : 'y';
    const continuousAxisDirection = verticalLayout ? 'y' : 'x';
    if (discreteAxisConfig.scaleType !== 'band') throw new Error(`MUI X Charts: ${$7f280be59411d457$var$getAxisMessage(discreteAxisDirection, discreteAxisId)} should be of type "band" to display the bar series of id "${seriesId}".`);
    if (discreteAxisConfig.data === undefined) throw new Error(`MUI X Charts: ${$7f280be59411d457$var$getAxisMessage(discreteAxisDirection, discreteAxisId)} should have data property.`);
    if (continuousAxisConfig.scaleType === 'band' || continuousAxisConfig.scaleType === 'point') throw new Error(`MUI X Charts: ${$7f280be59411d457$var$getAxisMessage(continuousAxisDirection, continuousAxisId)} should be a continuous type to display the bar series of id "${seriesId}".`);
}

});


parcelRegister("6qDbs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ae390dda2e3f263$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.barClasses = void 0;
module.exports.getBarUtilityClass = $4ae390dda2e3f263$var$getBarUtilityClass;
module.exports.useUtilityClasses = void 0;

var $4ae390dda2e3f263$var$_generateUtilityClass = $4ae390dda2e3f263$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $4ae390dda2e3f263$var$_composeClasses = $4ae390dda2e3f263$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $4ae390dda2e3f263$var$_generateUtilityClasses = $4ae390dda2e3f263$require$_interopRequireDefault((parcelRequire("5nY49")));
function $4ae390dda2e3f263$var$getBarUtilityClass(slot) {
    return (0, $4ae390dda2e3f263$var$_generateUtilityClass.default)('MuiBar', slot);
}
const $4ae390dda2e3f263$var$barClasses = module.exports.barClasses = (0, $4ae390dda2e3f263$var$_generateUtilityClasses.default)('MuiBar', [
    'root',
    'series',
    'seriesLabels'
]);
const $4ae390dda2e3f263$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        series: [
            'series'
        ],
        seriesLabels: [
            'seriesLabels'
        ]
    };
    return (0, $4ae390dda2e3f263$var$_composeClasses.default)(slots, $4ae390dda2e3f263$var$getBarUtilityClass, classes);
};
module.exports.useUtilityClasses = $4ae390dda2e3f263$var$useUtilityClasses;

});

parcelRegister("gye18", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c0cab1d856ac46ad$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c0cab1d856ac46ad$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IndividualBarPlot = $c0cab1d856ac46ad$var$IndividualBarPlot;

var $c0cab1d856ac46ad$var$_extends2 = $c0cab1d856ac46ad$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $c0cab1d856ac46ad$var$_objectWithoutPropertiesLoose2 = $c0cab1d856ac46ad$require$_interopRequireDefault((parcelRequire("c05no")));

var $c0cab1d856ac46ad$var$React = $c0cab1d856ac46ad$require$_interopRequireWildcard((parcelRequire("acw62")));

var $chHrn = parcelRequire("chHrn");

var $6qDbs = parcelRequire("6qDbs");

var $6OKv3 = parcelRequire("6OKv3");

var $ayMG0 = parcelRequire("ayMG0");
const $c0cab1d856ac46ad$var$_excluded = [
    "completedData",
    "masksData",
    "borderRadius",
    "onItemClick",
    "skipAnimation"
];
function $c0cab1d856ac46ad$var$IndividualBarPlot(_ref) {
    let { completedData: completedData, masksData: masksData, borderRadius: borderRadius, onItemClick: onItemClick, skipAnimation: skipAnimation } = _ref, other = (0, $c0cab1d856ac46ad$var$_objectWithoutPropertiesLoose2.default)(_ref, $c0cab1d856ac46ad$var$_excluded);
    const classes = (0, $6qDbs.useUtilityClasses)();
    const withoutBorderRadius = !borderRadius || borderRadius <= 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c0cab1d856ac46ad$var$React.Fragment, {
        children: [
            !withoutBorderRadius && masksData.map(({ id: id, x: x, y: y, xOrigin: xOrigin, yOrigin: yOrigin, width: width, height: height, hasPositive: hasPositive, hasNegative: hasNegative, layout: layout })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($6OKv3.BarClipPath, {
                    maskId: id,
                    borderRadius: borderRadius,
                    hasNegative: hasNegative,
                    hasPositive: hasPositive,
                    layout: layout,
                    x: x,
                    y: y,
                    xOrigin: xOrigin,
                    yOrigin: yOrigin,
                    width: width,
                    height: height,
                    skipAnimation: skipAnimation ?? false
                }, id);
            }),
            completedData.map(({ seriesId: seriesId, layout: layout, xOrigin: xOrigin, yOrigin: yOrigin, data: data })=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    "data-series": seriesId,
                    className: classes.series,
                    children: data.map(({ dataIndex: dataIndex, color: color, maskId: maskId, x: x, y: y, width: width, height: height })=>{
                        const barElement = /*#__PURE__*/ (0, $ayMG0.jsx)($chHrn.BarElement, (0, $c0cab1d856ac46ad$var$_extends2.default)({
                            id: seriesId,
                            dataIndex: dataIndex,
                            color: color,
                            skipAnimation: skipAnimation ?? false,
                            layout: layout ?? 'vertical',
                            x: x,
                            xOrigin: xOrigin,
                            y: y,
                            yOrigin: yOrigin,
                            width: width,
                            height: height
                        }, other, {
                            onClick: onItemClick && ((event)=>{
                                onItemClick(event, {
                                    type: 'bar',
                                    seriesId: seriesId,
                                    dataIndex: dataIndex
                                });
                            })
                        }), dataIndex);
                        if (withoutBorderRadius) return barElement;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            clipPath: `url(#${maskId})`,
                            children: barElement
                        }, dataIndex);
                    })
                }, seriesId);
            })
        ]
    });
}

});
parcelRegister("chHrn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8f18c4f21fa85faa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8f18c4f21fa85faa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarElement = $8f18c4f21fa85faa$var$BarElement;

var $8f18c4f21fa85faa$var$_extends2 = $8f18c4f21fa85faa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $8f18c4f21fa85faa$var$_objectWithoutPropertiesLoose2 = $8f18c4f21fa85faa$require$_interopRequireDefault((parcelRequire("c05no")));

var $8f18c4f21fa85faa$var$React = $8f18c4f21fa85faa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8f18c4f21fa85faa$var$_propTypes = $8f18c4f21fa85faa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8f18c4f21fa85faa$var$_useSlotProps = $8f18c4f21fa85faa$require$_interopRequireDefault((parcelRequire("839K0")));

var $knZgE = parcelRequire("knZgE");

var $hdpx4 = parcelRequire("hdpx4");

var $3N2dU = parcelRequire("3N2dU");

var $ig0cb = parcelRequire("ig0cb");

var $khajx = parcelRequire("khajx");

var $ayMG0 = parcelRequire("ayMG0");
const $8f18c4f21fa85faa$var$_excluded = [
    "id",
    "dataIndex",
    "classes",
    "color",
    "slots",
    "slotProps",
    "style",
    "onClick",
    "skipAnimation",
    "layout",
    "x",
    "xOrigin",
    "y",
    "yOrigin",
    "width",
    "height",
    "hidden"
];
function $8f18c4f21fa85faa$var$BarElement(props) {
    const { id: id, dataIndex: dataIndex, classes: innerClasses, color: color, slots: slots, slotProps: slotProps, style: style, onClick: onClick, skipAnimation: skipAnimation, layout: layout, x: x, xOrigin: xOrigin, y: y, yOrigin: yOrigin, width: width, height: height, hidden: hidden } = props, other = (0, $8f18c4f21fa85faa$var$_objectWithoutPropertiesLoose2.default)(props, $8f18c4f21fa85faa$var$_excluded);
    const itemIdentifier = $8f18c4f21fa85faa$var$React.useMemo(()=>({
            type: 'bar',
            seriesId: id,
            dataIndex: dataIndex
        }), [
        id,
        dataIndex
    ]);
    const interactionProps = (0, $hdpx4.useInteractionItemProps)(itemIdentifier);
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $3N2dU.useItemHighlighted)(itemIdentifier);
    const isFocused = (0, $khajx.useIsItemFocused)($8f18c4f21fa85faa$var$React.useMemo(()=>({
            type: 'bar',
            seriesId: id,
            dataIndex: dataIndex
        }), [
        id,
        dataIndex
    ]));
    const ownerState = {
        id: id,
        dataIndex: dataIndex,
        classes: innerClasses,
        color: color,
        isFaded: isFaded,
        isHighlighted: isHighlighted,
        isFocused: isFocused
    };
    const classes = (0, $knZgE.useUtilityClasses)(ownerState);
    const Bar = slots?.bar ?? $ig0cb.AnimatedBarElement;
    const barProps = (0, $8f18c4f21fa85faa$var$_useSlotProps.default)({
        elementType: Bar,
        externalSlotProps: slotProps?.bar,
        externalForwardedProps: other,
        additionalProps: (0, $8f18c4f21fa85faa$var$_extends2.default)({}, interactionProps, {
            id: id,
            dataIndex: dataIndex,
            color: color,
            x: x,
            xOrigin: xOrigin,
            y: y,
            yOrigin: yOrigin,
            width: width,
            height: height,
            style: style,
            onClick: onClick,
            cursor: onClick ? 'pointer' : 'unset',
            stroke: 'none',
            fill: color,
            skipAnimation: skipAnimation,
            layout: layout,
            hidden: hidden
        }),
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Bar, (0, $8f18c4f21fa85faa$var$_extends2.default)({}, barProps));
}

});
parcelRegister("ig0cb", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d4a9df6c4d5623b1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d4a9df6c4d5623b1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimatedBarElement = $d4a9df6c4d5623b1$var$AnimatedBarElement;

var $d4a9df6c4d5623b1$var$_extends2 = $d4a9df6c4d5623b1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $d4a9df6c4d5623b1$var$_objectWithoutPropertiesLoose2 = $d4a9df6c4d5623b1$require$_interopRequireDefault((parcelRequire("c05no")));

var $d4a9df6c4d5623b1$var$React = $d4a9df6c4d5623b1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3EXcU = parcelRequire("3EXcU");

var $ayMG0 = parcelRequire("ayMG0");
const $d4a9df6c4d5623b1$var$_excluded = [
    "ownerState",
    "skipAnimation",
    "id",
    "dataIndex",
    "xOrigin",
    "yOrigin"
];
function $d4a9df6c4d5623b1$var$AnimatedBarElement(props) {
    const { ownerState: ownerState } = props, other = (0, $d4a9df6c4d5623b1$var$_objectWithoutPropertiesLoose2.default)(props, $d4a9df6c4d5623b1$var$_excluded);
    const animatedProps = (0, $3EXcU.useAnimateBar)(props);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", (0, $d4a9df6c4d5623b1$var$_extends2.default)({}, other, {
        filter: ownerState.isHighlighted ? 'brightness(120%)' : undefined,
        opacity: ownerState.isFaded ? 0.3 : 1,
        "data-highlighted": ownerState.isHighlighted || undefined,
        "data-faded": ownerState.isFaded || undefined
    }, animatedProps));
}

});

parcelRegister("khajx", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsItemFocused = $ec2d655575ba823c$var$useIsItemFocused;

var $d3mgr = parcelRequire("d3mgr");

var $cp50o = parcelRequire("cp50o");
/**
 * A hook to check if an item has the focus.
 *
 * If you need to process multiple points, use the `useIsItemFocusedGetter` hook instead.
 *
 * @param {FocusedItemIdentifier} item is the item to check
 * @returns {boolean} the focus state
 */ function $ec2d655575ba823c$var$useIsItemFocused(item) {
    const store = (0, $d3mgr.useStore)();
    return store.use($cp50o.selectorChartsItemIsFocused, item);
}

});


parcelRegister("6OKv3", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $4f6b7b7cf59b5494$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarClipPath = $4f6b7b7cf59b5494$var$BarClipPath;
module.exports.useAnimateBarClipPath = $4f6b7b7cf59b5494$var$useAnimateBarClipPath;

var $4f6b7b7cf59b5494$var$React = $4f6b7b7cf59b5494$require$_interopRequireWildcard((parcelRequire("acw62")));

var $iNRFO = parcelRequire("iNRFO");

var $gHoRz = parcelRequire("gHoRz");

var $ayMG0 = parcelRequire("ayMG0");
function $4f6b7b7cf59b5494$var$barClipPathPropsInterpolator(from, to) {
    const interpolateX = (0, $iNRFO.interpolateNumber)(from.x, to.x);
    const interpolateY = (0, $iNRFO.interpolateNumber)(from.y, to.y);
    const interpolateWidth = (0, $iNRFO.interpolateNumber)(from.width, to.width);
    const interpolateHeight = (0, $iNRFO.interpolateNumber)(from.height, to.height);
    const interpolateBorderRadius = (0, $iNRFO.interpolateNumber)(from.borderRadius, to.borderRadius);
    return (t)=>{
        return {
            x: interpolateX(t),
            y: interpolateY(t),
            width: interpolateWidth(t),
            height: interpolateHeight(t),
            borderRadius: interpolateBorderRadius(t)
        };
    };
}
function $4f6b7b7cf59b5494$var$useAnimateBarClipPath(props) {
    const initialProps = {
        x: props.layout === 'vertical' ? props.x : props.xOrigin,
        y: props.layout === 'vertical' ? props.yOrigin : props.y,
        width: props.layout === 'vertical' ? props.width : 0,
        height: props.layout === 'vertical' ? 0 : props.height,
        borderRadius: props.borderRadius
    };
    return (0, $gHoRz.useAnimate)({
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        borderRadius: props.borderRadius
    }, {
        createInterpolator: $4f6b7b7cf59b5494$var$barClipPathPropsInterpolator,
        transformProps: (p)=>({
                d: $4f6b7b7cf59b5494$var$generateClipPath(props.hasNegative, props.hasPositive, props.layout, p.x, p.y, p.width, p.height, props.xOrigin, props.yOrigin, p.borderRadius)
            }),
        applyProps (element, { d: d }) {
            if (d) element.setAttribute('d', d);
        },
        initialProps: initialProps,
        skip: props.skipAnimation,
        ref: props.ref
    });
}
/**
 * @ignore - internal component.
 */ function $4f6b7b7cf59b5494$var$BarClipPath(props) {
    const { maskId: maskId, x: x, y: y, width: width, height: height, skipAnimation: skipAnimation } = props;
    const { ref: ref, d: d } = $4f6b7b7cf59b5494$var$useAnimateBarClipPath({
        layout: props.layout ?? 'vertical',
        hasNegative: props.hasNegative,
        hasPositive: props.hasPositive,
        xOrigin: props.xOrigin,
        yOrigin: props.yOrigin,
        x: x,
        y: y,
        width: width,
        height: height,
        borderRadius: props.borderRadius ?? 0,
        skipAnimation: skipAnimation
    });
    if (!props.borderRadius || props.borderRadius <= 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
        id: maskId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            ref: ref,
            d: d
        })
    });
}
function $4f6b7b7cf59b5494$var$generateClipPath(hasNegative, hasPositive, layout, x, y, width, height, xOrigin, yOrigin, borderRadius) {
    if (layout === 'vertical') {
        if (hasPositive && hasNegative) {
            const bR = Math.min(borderRadius, width / 2, height / 2);
            return `M${x},${y + height / 2} v${-(height / 2 - bR)} a${bR},${bR} 0 0 1 ${bR},${-bR} h${width - bR * 2} a${bR},${bR} 0 0 1 ${bR},${bR} v${height - 2 * bR} a${bR},${bR} 0 0 1 ${-bR},${bR} h${-(width - bR * 2)} a${bR},${bR} 0 0 1 ${-bR},${-bR} v${-(height / 2 - bR)}`;
        }
        const bR = Math.min(borderRadius, width / 2);
        if (hasPositive) return `M${x},${Math.max(yOrigin, y + bR)} v${Math.min(0, -(yOrigin - y - bR))} a${bR},${bR} 0 0 1 ${bR},${-bR} h${width - bR * 2} a${bR},${bR} 0 0 1 ${bR},${bR} v${Math.max(0, yOrigin - y - bR)} Z`;
        if (hasNegative) return `M${x},${Math.min(yOrigin, y + height - bR)} v${Math.max(0, height - bR)} a${bR},${bR} 0 0 0 ${bR},${bR} h${width - bR * 2} a${bR},${bR} 0 0 0 ${bR},${-bR} v${-Math.max(0, height - bR)} Z`;
    }
    if (layout === 'horizontal') {
        if (hasPositive && hasNegative) {
            const bR = Math.min(borderRadius, width / 2, height / 2);
            return `M${x + width / 2},${y} h${width / 2 - bR} a${bR},${bR} 0 0 1 ${bR},${bR} v${height - bR * 2} a${bR},${bR} 0 0 1 ${-bR},${bR} h${-(width - 2 * bR)} a${bR},${bR} 0 0 1 ${-bR},${-bR} v${-(height - bR * 2)} a${bR},${bR} 0 0 1 ${bR},${-bR} h${width / 2 - bR}`;
        }
        const bR = Math.min(borderRadius, height / 2);
        if (hasPositive) return `M${Math.min(xOrigin, x - bR)},${y} h${width} a${bR},${bR} 0 0 1 ${bR},${bR} v${height - bR * 2} a${bR},${bR} 0 0 1 ${-bR},${bR} h${-width} Z`;
        if (hasNegative) return `M${Math.max(xOrigin, x + width + bR)},${y} h${-width} a${bR},${bR} 0 0 0 ${-bR},${bR} v${height - bR * 2} a${bR},${bR} 0 0 0 ${bR},${bR} h${width} Z`;
    }
    return undefined;
}

});


parcelRegister("8gRk5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "BatchBarPlot", {
    enumerable: true,
    get: function() {
        return $cZU0O.BatchBarPlot;
    }
});

var $cZU0O = parcelRequire("cZU0O");

});
parcelRegister("cZU0O", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $9766a166d9625de2$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchBarPlot = $9766a166d9625de2$var$BatchBarPlot;

var $9766a166d9625de2$var$React = $9766a166d9625de2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $55quD = parcelRequire("55quD");

var $6qDbs = parcelRequire("6qDbs");

var $1HhaP = parcelRequire("1HhaP");

var $cZLDK = parcelRequire("cZLDK");

var $lJkF0 = parcelRequire("lJkF0");

var $g5sos = parcelRequire("g5sos");

var $7CrXA = parcelRequire("7CrXA");

var $aPGZn = parcelRequire("aPGZn");

var $58imO = parcelRequire("58imO");

var $ayMG0 = parcelRequire("ayMG0");
function $9766a166d9625de2$var$BatchBarPlot({ completedData: completedData, borderRadius: borderRadius = 0, onItemClick: onItemClick, skipAnimation: skipAnimation = false }) {
    const prevCursorRef = $9766a166d9625de2$var$React.useRef(null);
    const svgRef = (0, $55quD.useSvgRef)();
    const onItemEnter = onItemClick ? ()=>{
        const svg = svgRef.current;
        if (!svg) return;
        if (prevCursorRef.current == null) {
            prevCursorRef.current = svg.style.cursor;
            // eslint-disable-next-line react-compiler/react-compiler
            svg.style.cursor = 'pointer';
        }
    } : undefined;
    const onItemLeave = onItemClick ? ()=>{
        const svg = svgRef.current;
        if (!svg) return;
        if (prevCursorRef.current != null) {
            svg.style.cursor = prevCursorRef.current;
            prevCursorRef.current = null;
        }
    } : undefined;
    (0, $aPGZn.useRegisterPointerInteractions)($58imO.selectorBarItemAtPosition, onItemEnter, onItemLeave);
    (0, $lJkF0.useRegisterItemClickHandlers)(onItemClick);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9766a166d9625de2$var$React.Fragment, {
        children: completedData.map((series)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9766a166d9625de2$var$SeriesBatchPlot, {
                series: series,
                borderRadius: borderRadius,
                skipAnimation: skipAnimation
            }, series.seriesId))
    });
}
const $9766a166d9625de2$var$MemoFadedHighlightedBars = /*#__PURE__*/ $9766a166d9625de2$var$React.memo($9766a166d9625de2$var$FadedHighlightedBars);
function $9766a166d9625de2$var$SeriesBatchPlot({ series: series, borderRadius: borderRadius, skipAnimation: skipAnimation }) {
    const classes = (0, $6qDbs.useUtilityClasses)();
    const { store: store } = (0, $1HhaP.useChartContext)();
    const isSeriesHighlighted = store.use($cZLDK.selectorChartIsSeriesHighlighted, series.seriesId);
    const isSeriesFaded = store.use($cZLDK.selectorChartIsSeriesFaded, series.seriesId);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9766a166d9625de2$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($7CrXA.BarGroup, {
                className: classes.series,
                "data-series": series.seriesId,
                layout: series.layout,
                xOrigin: series.xOrigin,
                yOrigin: series.yOrigin,
                skipAnimation: skipAnimation,
                "data-faded": isSeriesFaded || undefined,
                "data-highlighted": isSeriesHighlighted || undefined,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($9766a166d9625de2$var$BatchBarSeriesPlot, {
                    processedSeries: series,
                    borderRadius: borderRadius
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($9766a166d9625de2$var$MemoFadedHighlightedBars, {
                processedSeries: series,
                borderRadius: borderRadius
            })
        ]
    });
}
function $9766a166d9625de2$var$BatchBarSeriesPlot({ processedSeries: processedSeries, borderRadius: borderRadius }) {
    const paths = (0, $g5sos.useCreateBarPaths)(processedSeries, borderRadius);
    const children = [];
    let i = 0;
    for (const [fill, dArray] of paths.entries())for (const d of dArray){
        children.push(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fill: fill,
            d: d
        }, i));
        i += 1;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9766a166d9625de2$var$React.Fragment, {
        children: children
    });
}
function $9766a166d9625de2$var$FadedHighlightedBars({ processedSeries: processedSeries, borderRadius: borderRadius }) {
    const { store: store } = (0, $1HhaP.useChartContext)();
    const seriesHighlightedDataIndex = store.use($cZLDK.selectorChartSeriesHighlightedItem, processedSeries.seriesId);
    const seriesUnfadedDataIndex = store.use($cZLDK.selectorChartSeriesUnfadedItem, processedSeries.seriesId);
    const seriesHighlightedItem = seriesHighlightedDataIndex != null ? processedSeries.data.find((v)=>v.dataIndex === seriesHighlightedDataIndex) || null : null;
    const seriesUnfadedItem = seriesUnfadedDataIndex != null ? processedSeries.data.find((v)=>v.dataIndex === seriesUnfadedDataIndex) || null : null;
    const siblings = [];
    if (seriesHighlightedItem != null) siblings.push(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        fill: seriesHighlightedItem.color,
        filter: "brightness(120%)",
        "data-highlighted": true,
        d: (0, $g5sos.createPath)(seriesHighlightedItem, borderRadius)
    }, `highlighted-${processedSeries.seriesId}`));
    if (seriesUnfadedItem != null) siblings.push(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        fill: seriesUnfadedItem.color,
        d: (0, $g5sos.createPath)(seriesUnfadedItem, borderRadius)
    }, `unfaded-${seriesUnfadedItem.seriesId}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9766a166d9625de2$var$React.Fragment, {
        children: siblings
    });
}

});
parcelRegister("lJkF0", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $fd1dd3aff158b889$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRegisterItemClickHandlers = $fd1dd3aff158b889$var$useRegisterItemClickHandlers;

var $fd1dd3aff158b889$var$React = $fd1dd3aff158b889$require$_interopRequireWildcard((parcelRequire("acw62")));

var $j3Fic = parcelRequire("j3Fic");

var $6hQTT = parcelRequire("6hQTT");

var $g34sa = parcelRequire("g34sa");

var $d3mgr = parcelRequire("d3mgr");

var $58imO = parcelRequire("58imO");
/**
 * Hook that registers pointer event handlers for chart item clicking.
 * @param onItemClick Callback for item click events.
 */ function $fd1dd3aff158b889$var$useRegisterItemClickHandlers(onItemClick) {
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const svgRef = (0, $j3Fic.useSvgRef)();
    const store = (0, $d3mgr.useStore)();
    $fd1dd3aff158b889$var$React.useEffect(()=>{
        const element = svgRef.current;
        if (!element || !onItemClick) return undefined;
        let lastPointerUp = null;
        const onClick = function onClick(event) {
            let point = event;
            /* The click event doesn't contain decimal values in clientX/Y, but the pointermove does.
       * This caused a problem when rendering many bars that were thinner than a pixel where the tooltip or the highlight
       * would refer to a different bar than the click since those rely on the pointermove event.
       * As a fix, we use the pointerup event to get the decimal values and check if the pointer up event was close enough
       * to the click event (1px difference in each direction); if so, then we can use the pointerup's clientX/Y; if not,
       * we default to the click event's clientX/Y. */ if (lastPointerUp) {
                if (Math.abs(event.clientX - lastPointerUp.clientX) <= 1 && Math.abs(event.clientY - lastPointerUp.clientY) <= 1) point = {
                    clientX: lastPointerUp.clientX,
                    clientY: lastPointerUp.clientY
                };
            }
            lastPointerUp = null;
            const svgPoint = (0, $g34sa.getSVGPoint)(element, point);
            if (!instance.isPointInside(svgPoint.x, svgPoint.y)) return;
            const item = (0, $58imO.selectorBarItemAtPosition)(store.state, svgPoint);
            if (item) onItemClick(event, {
                type: 'bar',
                seriesId: item.seriesId,
                dataIndex: item.dataIndex
            });
        };
        const onPointerUp = function onPointerUp(event) {
            lastPointerUp = event;
        };
        element.addEventListener('click', onClick);
        element.addEventListener('pointerup', onPointerUp);
        return ()=>{
            element.removeEventListener('click', onClick);
            element.removeEventListener('pointerup', onPointerUp);
        };
    }, [
        instance,
        onItemClick,
        store,
        svgRef
    ]);
}

});
parcelRegister("58imO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.selectorBarItemAtPosition = void 0;

var $8P0MD = parcelRequire("8P0MD");

var $i9lnd = parcelRequire("i9lnd");

var $1k3ob = parcelRequire("1k3ob");

var $6upLo = parcelRequire("6upLo");

var $2UPWB = parcelRequire("2UPWB");

var $eV4n7 = parcelRequire("eV4n7");
const $3bcbf25fc7ba2fac$var$selectorBarItemAtPosition = module.exports.selectorBarItemAtPosition = (0, $8P0MD.createSelector)($i9lnd.selectorChartXAxis, $i9lnd.selectorChartYAxis, $1k3ob.selectorChartSeriesProcessed, function selectorBarItemAtPosition({ axis: xAxes, axisIds: xAxisIds }, { axis: yAxes, axisIds: yAxisIds }, processedSeries, svgPoint) {
    const { series: series, stackingGroups: stackingGroups = [] } = processedSeries?.bar ?? {};
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    let item = undefined;
    for(let stackIndex = 0; stackIndex < stackingGroups.length; stackIndex += 1){
        const group = stackingGroups[stackIndex];
        const seriesIds = group.ids;
        for (const seriesId of seriesIds){
            const aSeries = (series ?? {})[seriesId];
            const xAxisId = aSeries.xAxisId ?? defaultXAxisId;
            const yAxisId = aSeries.yAxisId ?? defaultYAxisId;
            const xAxis = xAxes[xAxisId];
            const yAxis = yAxes[yAxisId];
            const bandAxis = aSeries.layout === 'horizontal' ? yAxis : xAxis;
            const continuousAxis = aSeries.layout === 'horizontal' ? xAxis : yAxis;
            const bandScale = bandAxis.scale;
            const svgPointBandCoordinate = aSeries.layout === 'horizontal' ? svgPoint.y : svgPoint.x;
            if (!(0, $2UPWB.isBandScale)(bandScale)) continue;
            const dataIndex = (0, $eV4n7.getDataIndexForOrdinalScaleValue)(bandScale, svgPointBandCoordinate);
            const { barWidth: barWidth, offset: offset } = (0, $6upLo.getBandSize)(bandScale.bandwidth(), stackingGroups.length, bandAxis.barGapRatio);
            const barOffset = stackIndex * (barWidth + offset);
            const bandValue = bandAxis.data?.[dataIndex];
            if (bandValue == null) continue;
            const bandStart = bandScale(bandValue);
            if (bandStart == null) continue;
            const bandBarStart = bandStart + barOffset;
            const bandBarEnd = bandBarStart + barWidth;
            const bandBarMin = Math.min(bandBarStart, bandBarEnd);
            const bandBarMax = Math.max(bandBarStart, bandBarEnd);
            if (svgPointBandCoordinate >= bandBarMin && svgPointBandCoordinate <= bandBarMax) {
                // The point is inside the band for this series
                const svgPointContinuousCoordinate = aSeries.layout === 'horizontal' ? svgPoint.x : svgPoint.y;
                const bar = aSeries.visibleStackedData[dataIndex];
                const start = continuousAxis.scale(bar[0]);
                const end = continuousAxis.scale(bar[1]);
                if (start == null || end == null) continue;
                const continuousMin = Math.min(start, end);
                const continuousMax = Math.max(start, end);
                if (svgPointContinuousCoordinate >= continuousMin && svgPointContinuousCoordinate <= continuousMax) item = {
                    seriesId: seriesId,
                    dataIndex: dataIndex
                };
            }
        }
    }
    if (item) return {
        type: 'bar',
        seriesId: item.seriesId,
        dataIndex: item.dataIndex
    };
    return undefined;
});

});
parcelRegister("eV4n7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDataIndexForOrdinalScaleValue = $adc9c7ba238600ad$var$getDataIndexForOrdinalScaleValue;
module.exports.invertScale = $adc9c7ba238600ad$var$invertScale;

var $2UPWB = parcelRequire("2UPWB");
function $adc9c7ba238600ad$var$invertScale(scale, data, value) {
    if ((0, $2UPWB.isOrdinalScale)(scale)) {
        const dataIndex = $adc9c7ba238600ad$var$getDataIndexForOrdinalScaleValue(scale, value);
        return data[dataIndex];
    }
    return scale.invert(value);
}
/**
 * Get the data index for a given value on an ordinal scale.
 */ function $adc9c7ba238600ad$var$getDataIndexForOrdinalScaleValue(scale, value) {
    const dataIndex = scale.bandwidth() === 0 ? Math.floor((value - Math.min(...scale.range()) + scale.step() / 2) / scale.step()) : Math.floor((value - Math.min(...scale.range())) / scale.step());
    return dataIndex;
}

});



parcelRegister("g5sos", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createPath = $bb63235057205d96$var$createPath;
module.exports.useCreateBarPaths = $bb63235057205d96$var$useCreateBarPaths;

var $iY6q5 = parcelRequire("iY6q5");
const $bb63235057205d96$var$MAX_POINTS_PER_PATH = 1000;
function $bb63235057205d96$var$generateBarPath(x, y, width, height, topLeftBorderRadius, topRightBorderRadius, bottomRightBorderRadius, bottomLeftBorderRadius) {
    const tLBR = Math.min(topLeftBorderRadius, width / 2, height / 2);
    const tRBR = Math.min(topRightBorderRadius, width / 2, height / 2);
    const bRBR = Math.min(bottomRightBorderRadius, width / 2, height / 2);
    const bLBR = Math.min(bottomLeftBorderRadius, width / 2, height / 2);
    return `M${x + tLBR},${y}
   h${width - tLBR - tRBR}
   a${tRBR},${tRBR} 0 0 1 ${tRBR},${tRBR}
   v${height - tRBR - bRBR}
   a${bRBR},${bRBR} 0 0 1 -${bRBR},${bRBR}
   h-${width - bRBR - bLBR}
   a${bLBR},${bLBR} 0 0 1 -${bLBR},-${bLBR}
   v-${height - bLBR - tLBR}
   a${tLBR},${tLBR} 0 0 1 ${tLBR},-${tLBR}
   Z`;
}
function $bb63235057205d96$var$createPath(barData, borderRadius) {
    return $bb63235057205d96$var$generateBarPath(barData.x, barData.y, barData.width, barData.height, barData.borderRadiusSide === 'left' || barData.borderRadiusSide === 'top' ? borderRadius : 0, barData.borderRadiusSide === 'right' || barData.borderRadiusSide === 'top' ? borderRadius : 0, barData.borderRadiusSide === 'right' || barData.borderRadiusSide === 'bottom' ? borderRadius : 0, barData.borderRadiusSide === 'left' || barData.borderRadiusSide === 'bottom' ? borderRadius : 0);
}
/**
 * Hook that creates bar paths for a given series data. Used by the batch bar renderer.
 * @param seriesData
 * @param borderRadius
 */ function $bb63235057205d96$var$useCreateBarPaths(seriesData, borderRadius) {
    const paths = new Map();
    const temporaryPaths = new Map();
    for(let j = 0; j < seriesData.data.length; j += 1){
        const barData = seriesData.data[j];
        const pathString = $bb63235057205d96$var$createPath(barData, borderRadius);
        const tempPath = (0, $iY6q5.appendAtKey)(temporaryPaths, barData.color, pathString);
        if (tempPath.length >= $bb63235057205d96$var$MAX_POINTS_PER_PATH) {
            (0, $iY6q5.appendAtKey)(paths, barData.color, tempPath.join(''));
            temporaryPaths.delete(barData.color);
        }
    }
    for (const [fill, tempPath] of temporaryPaths.entries())if (tempPath.length > 0) (0, $iY6q5.appendAtKey)(paths, fill, tempPath.join(''));
    return paths;
}

});
parcelRegister("iY6q5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.appendAtKey = $dcf2cf6c4b44c3e7$var$appendAtKey;
/**
 * Given a map of arrays, appends a value to the array at the given key.
 * If no array exists at that key, one is created and the value appended.
 * @param map Map of arrays
 * @param key Key to append the value at
 * @param value Value to append
 */ function $dcf2cf6c4b44c3e7$var$appendAtKey(map, key, value) {
    let bucket = map.get(key);
    if (!bucket) {
        bucket = [
            value
        ];
        map.set(key, bucket);
    } else bucket.push(value);
    return bucket;
}

});


parcelRegister("7CrXA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $58c1c54a0c410e2f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $58c1c54a0c410e2f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BarGroup = $58c1c54a0c410e2f$var$BarGroup;

var $58c1c54a0c410e2f$var$_extends2 = $58c1c54a0c410e2f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $58c1c54a0c410e2f$var$_objectWithoutPropertiesLoose2 = $58c1c54a0c410e2f$require$_interopRequireDefault((parcelRequire("c05no")));

var $8xDHs = parcelRequire("8xDHs");

var $58c1c54a0c410e2f$var$React = $58c1c54a0c410e2f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $58c1c54a0c410e2f$var$_useId = $58c1c54a0c410e2f$require$_interopRequireDefault((parcelRequire("hwliF")));

var $d3mgr = parcelRequire("d3mgr");

var $eWN1p = parcelRequire("eWN1p");

var $32gdR = parcelRequire("32gdR");

var $ayMG0 = parcelRequire("ayMG0");
const $58c1c54a0c410e2f$var$_excluded = [
    "skipAnimation",
    "layout",
    "xOrigin",
    "yOrigin"
], $58c1c54a0c410e2f$var$_excluded2 = [
    "children",
    "layout",
    "xOrigin",
    "yOrigin"
];
const $58c1c54a0c410e2f$var$PathGroup = (0, $8xDHs.styled)('g')({
    '&[data-faded="true"]': {
        opacity: 0.3
    },
    '& path': {
        /* The browser must do hit testing to know which element a pointer is interacting with.
     * With many data points, we create many paths causing significant time to be spent in the hit test phase.
     * To fix this issue, we disable pointer events for the descendant paths.
     *
     * Ideally, users should be able to override this in case they need pointer events to be enabled,
     * but it can affect performance negatively, especially with many data points. */ pointerEvents: 'none'
    }
});
function $58c1c54a0c410e2f$var$BarGroup(_ref) {
    let { skipAnimation: skipAnimation, layout: layout, xOrigin: xOrigin, yOrigin: yOrigin } = _ref, props = (0, $58c1c54a0c410e2f$var$_objectWithoutPropertiesLoose2.default)(_ref, $58c1c54a0c410e2f$var$_excluded);
    if (skipAnimation) return /*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$PathGroup, (0, $58c1c54a0c410e2f$var$_extends2.default)({}, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$AnimatedGroup, (0, $58c1c54a0c410e2f$var$_extends2.default)({}, props, {
        layout: layout,
        xOrigin: xOrigin,
        yOrigin: yOrigin
    }));
}
const $58c1c54a0c410e2f$var$AnimatedRect = (0, $8xDHs.styled)('rect')({
    '@keyframes scaleInX': {
        from: {
            transform: 'scaleX(0)'
        },
        to: {
            transform: 'scaleX(1)'
        }
    },
    '@keyframes scaleInY': {
        from: {
            transform: 'scaleY(0)'
        },
        to: {
            transform: 'scaleY(1)'
        }
    },
    animationDuration: `${$32gdR.ANIMATION_DURATION_MS}ms`,
    animationFillMode: 'forwards',
    '&[data-orientation="horizontal"]': {
        animationName: 'scaleInX'
    },
    '&[data-orientation="vertical"]': {
        animationName: 'scaleInY'
    }
});
function $58c1c54a0c410e2f$var$AnimatedGroup(_ref2) {
    let { children: children, layout: layout, xOrigin: xOrigin, yOrigin: yOrigin } = _ref2, props = (0, $58c1c54a0c410e2f$var$_objectWithoutPropertiesLoose2.default)(_ref2, $58c1c54a0c410e2f$var$_excluded2);
    const store = (0, $d3mgr.useStore)();
    const drawingArea = store.use($eWN1p.selectorChartDrawingArea);
    const clipPathId = (0, $58c1c54a0c410e2f$var$_useId.default)();
    const animateChildren = [];
    if (layout === 'horizontal') {
        animateChildren.push(/*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$AnimatedRect, {
            "data-orientation": "horizontal",
            x: drawingArea.left,
            width: xOrigin - drawingArea.left,
            y: drawingArea.top,
            height: drawingArea.height,
            style: {
                transformOrigin: `${xOrigin}px ${drawingArea.top + drawingArea.height / 2}px`
            }
        }, "left"));
        animateChildren.push(/*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$AnimatedRect, {
            "data-orientation": "horizontal",
            x: xOrigin,
            width: drawingArea.left + drawingArea.width - xOrigin,
            y: drawingArea.top,
            height: drawingArea.height,
            style: {
                transformOrigin: `${xOrigin}px ${drawingArea.top + drawingArea.height / 2}px`
            }
        }, "right"));
    } else {
        animateChildren.push(/*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$AnimatedRect, {
            "data-orientation": "vertical",
            x: drawingArea.left,
            width: drawingArea.width,
            y: drawingArea.top,
            height: yOrigin - drawingArea.top,
            style: {
                transformOrigin: `${drawingArea.left + drawingArea.width / 2}px ${yOrigin}px`
            }
        }, "top"));
        animateChildren.push(/*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$AnimatedRect, {
            "data-orientation": "vertical",
            x: drawingArea.left,
            width: drawingArea.width,
            y: yOrigin,
            height: drawingArea.top + drawingArea.height - yOrigin,
            style: {
                transformOrigin: `${drawingArea.left + drawingArea.width / 2}px ${yOrigin}px`
            }
        }, "bottom"));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($58c1c54a0c410e2f$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                id: clipPathId,
                children: animateChildren
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($58c1c54a0c410e2f$var$PathGroup, (0, $58c1c54a0c410e2f$var$_extends2.default)({
                clipPath: `url(#${clipPathId})`
            }, props, {
                children: children
            }))
        ]
    });
}

});

parcelRegister("aPGZn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $7e3003855e1e55c4$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7e3003855e1e55c4$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRegisterPointerInteractions = $7e3003855e1e55c4$var$useRegisterPointerInteractions;

var $7e3003855e1e55c4$var$React = $7e3003855e1e55c4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $7e3003855e1e55c4$var$_useEventCallback = $7e3003855e1e55c4$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $55quD = parcelRequire("55quD");

var $d3mgr = parcelRequire("d3mgr");

var $6hQTT = parcelRequire("6hQTT");

var $g34sa = parcelRequire("g34sa");
/**
 * Hook to get pointer interaction props for chart items.
 */ function $7e3003855e1e55c4$var$useRegisterPointerInteractions(getItemAtPosition, onItemEnter, onItemLeave) {
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const svgRef = (0, $55quD.useSvgRef)();
    const store = (0, $d3mgr.useStore)();
    const interactionActive = $7e3003855e1e55c4$var$React.useRef(false);
    const lastItemRef = $7e3003855e1e55c4$var$React.useRef(undefined);
    const onItemEnterRef = (0, $7e3003855e1e55c4$var$_useEventCallback.default)(()=>onItemEnter?.());
    const onItemLeaveRef = (0, $7e3003855e1e55c4$var$_useEventCallback.default)(()=>onItemLeave?.());
    $7e3003855e1e55c4$var$React.useEffect(()=>{
        const svg = svgRef.current;
        if (!svg) return undefined;
        function onPointerEnter() {
            interactionActive.current = true;
        }
        function reset() {
            const lastItem = lastItemRef.current;
            if (lastItem) {
                lastItemRef.current = undefined;
                instance.removeTooltipItem(lastItem);
                instance.clearHighlight();
                onItemLeaveRef();
            }
        }
        function onPointerLeave() {
            interactionActive.current = false;
            reset();
        }
        const onPointerMove = function onPointerMove(event) {
            const svgPoint = (0, $g34sa.getSVGPoint)(svg, event);
            if (!instance.isPointInside(svgPoint.x, svgPoint.y)) {
                reset();
                return;
            }
            const item = getItemAtPosition(store.state, svgPoint);
            if (item) {
                instance.setLastUpdateSource('pointer');
                instance.setTooltipItem(item);
                instance.setHighlight(item);
                onItemEnterRef();
                lastItemRef.current = item;
            } else reset();
        };
        svg.addEventListener('pointerleave', onPointerLeave);
        svg.addEventListener('pointermove', onPointerMove);
        svg.addEventListener('pointerenter', onPointerEnter);
        return ()=>{
            svg.removeEventListener('pointerenter', onPointerEnter);
            svg.removeEventListener('pointermove', onPointerMove);
            svg.removeEventListener('pointerleave', onPointerLeave);
            /* Clean up state if this item is unmounted while active. */ if (interactionActive.current) onPointerLeave();
        };
    }, [
        getItemAtPosition,
        instance,
        onItemEnterRef,
        onItemLeaveRef,
        store,
        svgRef
    ]);
}

});




parcelRegister("ldQXI", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f733e50e2b45eea9$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f733e50e2b45eea9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useBarChartProps = void 0;

var $f733e50e2b45eea9$var$_extends2 = $f733e50e2b45eea9$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f733e50e2b45eea9$var$_objectWithoutPropertiesLoose2 = $f733e50e2b45eea9$require$_interopRequireDefault((parcelRequire("c05no")));

var $f733e50e2b45eea9$var$React = $f733e50e2b45eea9$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f733e50e2b45eea9$var$_useId = $f733e50e2b45eea9$require$_interopRequireDefault((parcelRequire("hwliF")));

var $fiXDv = parcelRequire("fiXDv");

var $9ZwHu = parcelRequire("9ZwHu");
const $f733e50e2b45eea9$var$_excluded = [
    "xAxis",
    "yAxis",
    "series",
    "width",
    "height",
    "margin",
    "colors",
    "dataset",
    "sx",
    "axisHighlight",
    "grid",
    "children",
    "slots",
    "slotProps",
    "skipAnimation",
    "loading",
    "layout",
    "onItemClick",
    "highlightedItem",
    "onHighlightChange",
    "borderRadius",
    "barLabel",
    "className",
    "hideLegend",
    "showToolbar",
    "brushConfig",
    "renderer"
];
/**
 * A helper function that extracts BarChartProps from the input props
 * and returns an object with props for the children components of BarChart.
 *
 * @param props The input props for BarChart
 * @returns An object with props for the children components of BarChart
 */ const $f733e50e2b45eea9$var$useBarChartProps = (props)=>{
    const { xAxis: xAxis, yAxis: yAxis, series: series, width: width, height: height, margin: margin, colors: colors, dataset: dataset, sx: sx, axisHighlight: axisHighlight, grid: grid, children: children, slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, loading: loading, layout: layout, onItemClick: onItemClick, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, borderRadius: borderRadius, barLabel: barLabel, className: className, brushConfig: brushConfig, renderer: renderer } = props, other = (0, $f733e50e2b45eea9$var$_objectWithoutPropertiesLoose2.default)(props, $f733e50e2b45eea9$var$_excluded);
    const id = (0, $f733e50e2b45eea9$var$_useId.default)();
    const clipPathId = `${id}-clip-path`;
    const hasHorizontalSeries = layout === 'horizontal' || layout === undefined && series.some((item)=>item.layout === 'horizontal');
    const defaultBandXAxis = $f733e50e2b45eea9$var$React.useMemo(()=>[
            {
                id: $fiXDv.DEFAULT_X_AXIS_KEY,
                scaleType: 'band',
                data: Array.from({
                    length: Math.max(...series.map((s)=>(s.data ?? dataset ?? []).length))
                }, (_, index)=>index)
            }
        ], [
        dataset,
        series
    ]);
    const defaultBandYAxis = $f733e50e2b45eea9$var$React.useMemo(()=>[
            {
                id: $fiXDv.DEFAULT_Y_AXIS_KEY,
                scaleType: 'band',
                data: Array.from({
                    length: Math.max(...series.map((s)=>(s.data ?? dataset ?? []).length))
                }, (_, index)=>index)
            }
        ], [
        dataset,
        series
    ]);
    const seriesWithDefault = $f733e50e2b45eea9$var$React.useMemo(()=>series.map((s)=>(0, $f733e50e2b45eea9$var$_extends2.default)({
                type: 'bar'
            }, s, {
                layout: hasHorizontalSeries ? 'horizontal' : 'vertical'
            })), [
        hasHorizontalSeries,
        series
    ]);
    const defaultXAxis = hasHorizontalSeries ? undefined : defaultBandXAxis;
    const processedXAxis = $f733e50e2b45eea9$var$React.useMemo(()=>{
        if (!xAxis) return defaultXAxis;
        return hasHorizontalSeries ? xAxis : xAxis.map((axis)=>(0, $f733e50e2b45eea9$var$_extends2.default)({
                scaleType: 'band'
            }, axis));
    }, [
        defaultXAxis,
        hasHorizontalSeries,
        xAxis
    ]);
    const defaultYAxis = hasHorizontalSeries ? defaultBandYAxis : undefined;
    const processedYAxis = $f733e50e2b45eea9$var$React.useMemo(()=>{
        if (!yAxis) return defaultYAxis;
        return hasHorizontalSeries ? yAxis.map((axis)=>(0, $f733e50e2b45eea9$var$_extends2.default)({
                scaleType: 'band'
            }, axis)) : yAxis;
    }, [
        defaultYAxis,
        hasHorizontalSeries,
        yAxis
    ]);
    const chartContainerProps = (0, $f733e50e2b45eea9$var$_extends2.default)({}, other, {
        series: seriesWithDefault,
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        dataset: dataset,
        xAxis: processedXAxis,
        yAxis: processedYAxis,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        disableAxisListener: slotProps?.tooltip?.trigger !== 'axis' && axisHighlight?.x === 'none' && axisHighlight?.y === 'none',
        className: className,
        skipAnimation: skipAnimation,
        brushConfig: brushConfig,
        plugins: $9ZwHu.BAR_CHART_PLUGINS
    });
    const barPlotProps = {
        onItemClick: onItemClick,
        slots: slots,
        slotProps: slotProps,
        borderRadius: borderRadius,
        renderer: renderer,
        barLabel: barLabel
    };
    const gridProps = {
        vertical: grid?.vertical,
        horizontal: grid?.horizontal
    };
    const clipPathGroupProps = {
        clipPath: `url(#${clipPathId})`
    };
    const clipPathProps = {
        id: clipPathId
    };
    const overlayProps = {
        slots: slots,
        slotProps: slotProps,
        loading: loading
    };
    const chartsAxisProps = {
        slots: slots,
        slotProps: slotProps
    };
    const axisHighlightProps = (0, $f733e50e2b45eea9$var$_extends2.default)({}, hasHorizontalSeries ? {
        y: 'band'
    } : {
        x: 'band'
    }, axisHighlight);
    const legendProps = {
        slots: slots,
        slotProps: slotProps
    };
    const chartsWrapperProps = {
        sx: sx,
        legendPosition: props.slotProps?.legend?.position,
        legendDirection: props.slotProps?.legend?.direction,
        hideLegend: props.hideLegend ?? false
    };
    return {
        chartsWrapperProps: chartsWrapperProps,
        chartContainerProps: chartContainerProps,
        barPlotProps: barPlotProps,
        gridProps: gridProps,
        clipPathProps: clipPathProps,
        clipPathGroupProps: clipPathGroupProps,
        overlayProps: overlayProps,
        chartsAxisProps: chartsAxisProps,
        axisHighlightProps: axisHighlightProps,
        legendProps: legendProps,
        children: children
    };
};
module.exports.useBarChartProps = $f733e50e2b45eea9$var$useBarChartProps;

});
parcelRegister("9ZwHu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BAR_CHART_PLUGINS = void 0;

var $d4cjJ = parcelRequire("d4cjJ");

var $a5Dpn = parcelRequire("a5Dpn");

var $d8Csh = parcelRequire("d8Csh");

var $8j56i = parcelRequire("8j56i");

var $cZLDK = parcelRequire("cZLDK");

var $cp50o = parcelRequire("cp50o");

var $b4u9m = parcelRequire("b4u9m");

var $fgykb = parcelRequire("fgykb");
const $74632d2bc3a5290b$var$BAR_CHART_PLUGINS = module.exports.BAR_CHART_PLUGINS = [
    $d4cjJ.useChartZAxis,
    $b4u9m.useChartBrush,
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $a5Dpn.useChartCartesianAxis,
    $cZLDK.useChartHighlight,
    $fgykb.useChartVisibilityManager,
    $cp50o.useChartKeyboardNavigation
];

});


parcelRegister("vuSuv", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $05ead911f21e4194$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $05ead911f21e4194$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FocusedBar = $05ead911f21e4194$var$FocusedBar;

var $05ead911f21e4194$var$_extends2 = $05ead911f21e4194$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $05ead911f21e4194$var$React = $05ead911f21e4194$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $7ccUh = parcelRequire("7ccUh");

var $55quD = parcelRequire("55quD");

var $g5ldX = parcelRequire("g5ldX");

var $ayMG0 = parcelRequire("ayMG0");
function $05ead911f21e4194$var$FocusedBar(props) {
    const theme = (0, $8xDHs.useTheme)();
    const focusedItem = (0, $7ccUh.useFocusedItem)();
    const barSeries = (0, $55quD.useBarSeriesContext)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55quD.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55quD.useYAxes)();
    if (focusedItem === null || focusedItem.type !== 'bar' || !barSeries) return null;
    const series = barSeries.series[focusedItem.seriesId];
    if (series.data[focusedItem.dataIndex] == null) // Handle missing data
    return null;
    const xAxisId = series.xAxisId ?? xAxisIds[0];
    const yAxisId = series.yAxisId ?? yAxisIds[0];
    const xAxisConfig = xAxis[xAxisId];
    const yAxisConfig = yAxis[yAxisId];
    const verticalLayout = barSeries.series[focusedItem.seriesId].layout === 'vertical';
    const groupIndex = barSeries.stackingGroups.findIndex((group)=>group.ids.includes(focusedItem.seriesId));
    const barDimensions = (0, $g5ldX.getBarDimensions)({
        verticalLayout: verticalLayout,
        xAxisConfig: xAxisConfig,
        yAxisConfig: yAxisConfig,
        series: series,
        dataIndex: focusedItem.dataIndex,
        numberOfGroups: barSeries.stackingGroups.length,
        groupIndex: groupIndex
    });
    if (barDimensions === null) return null;
    const { x: x, y: y, height: height, width: width } = barDimensions;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", (0, $05ead911f21e4194$var$_extends2.default)({
        fill: "none",
        stroke: (theme.vars ?? theme).palette.text.primary,
        strokeWidth: 2,
        x: x - 3,
        y: y - 3,
        width: width + 6,
        height: height + 6,
        rx: 3,
        ry: 3
    }, props));
}

});


parcelRegister("htjGO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "BarLabel", {
    enumerable: true,
    get: function() {
        return $e087c.BarLabel;
    }
});
Object.defineProperty(module.exports, "barLabelClasses", {
    enumerable: true,
    get: function() {
        return $6nIA5.barLabelClasses;
    }
});
Object.defineProperty(module.exports, "getBarLabelUtilityClass", {
    enumerable: true,
    get: function() {
        return $6nIA5.getBarLabelUtilityClass;
    }
});

var $e087c = parcelRequire("e087c");

var $6nIA5 = parcelRequire("6nIA5");

});


parcelRegister("1Dyr6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $13142540c0e5eae3$var$_exportNames = {
    scatterClasses: true
};
Object.defineProperty(module.exports, "scatterClasses", {
    enumerable: true,
    get: function() {
        return $eYj1Q.scatterClasses;
    }
});

var $8hJw1 = parcelRequire("8hJw1");
Object.keys($8hJw1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8hJw1[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8hJw1[key];
        }
    });
});

var $4jAkz = parcelRequire("4jAkz");
Object.keys($4jAkz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4jAkz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4jAkz[key];
        }
    });
});

var $lCzUz = parcelRequire("lCzUz");
Object.keys($lCzUz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $lCzUz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $lCzUz[key];
        }
    });
});

var $IL0ps = parcelRequire("IL0ps");
Object.keys($IL0ps).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $IL0ps[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $IL0ps[key];
        }
    });
});

var $fjqRM = parcelRequire("fjqRM");
Object.keys($fjqRM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fjqRM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fjqRM[key];
        }
    });
});

var $7DI2Y = parcelRequire("7DI2Y");
Object.keys($7DI2Y).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7DI2Y[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7DI2Y[key];
        }
    });
});

var $3gOxF = parcelRequire("3gOxF");
Object.keys($3gOxF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13142540c0e5eae3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3gOxF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3gOxF[key];
        }
    });
});

var $eYj1Q = parcelRequire("eYj1Q");

});
parcelRegister("8hJw1", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $608337b41c11ae72$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $608337b41c11ae72$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScatterChart = void 0;

var $608337b41c11ae72$var$_extends2 = $608337b41c11ae72$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $608337b41c11ae72$var$React = $608337b41c11ae72$require$_interopRequireWildcard((parcelRequire("acw62")));

var $608337b41c11ae72$var$_propTypes = $608337b41c11ae72$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $4jAkz = parcelRequire("4jAkz");

var $aiEgN = parcelRequire("aiEgN");

var $luY0B = parcelRequire("luY0B");

var $anK5t = parcelRequire("anK5t");

var $hhc1V = parcelRequire("hhc1V");

var $ad3Dp = parcelRequire("ad3Dp");

var $2ppSP = parcelRequire("2ppSP");

var $ggDlF = parcelRequire("ggDlF");

var $3jE6m = parcelRequire("3jE6m");

var $eSGGd = parcelRequire("eSGGd");

var $ezMKh = parcelRequire("ezMKh");

var $G4UB8 = parcelRequire("G4UB8");

var $7DI2Y = parcelRequire("7DI2Y");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Scatter](https://mui.com/x/react-charts/scatter/)
 * - [Scatter demonstration](https://mui.com/x/react-charts/scatter-demo/)
 *
 * API:
 *
 * - [ScatterChart API](https://mui.com/x/api/charts/scatter-chart/)
 */ const $608337b41c11ae72$var$ScatterChart = module.exports.ScatterChart = /*#__PURE__*/ $608337b41c11ae72$var$React.forwardRef(function ScatterChart(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiScatterChart'
    });
    const { chartsWrapperProps: chartsWrapperProps, chartContainerProps: chartContainerProps, chartsAxisProps: chartsAxisProps, gridProps: gridProps, scatterPlotProps: scatterPlotProps, overlayProps: overlayProps, legendProps: legendProps, axisHighlightProps: axisHighlightProps, children: children } = (0, $ggDlF.useScatterChartProps)(props);
    const { chartDataProviderProps: chartDataProviderProps, chartsSurfaceProps: chartsSurfaceProps } = (0, $3jE6m.useChartContainerProps)(chartContainerProps, ref);
    const Tooltip = props.slots?.tooltip ?? $luY0B.ChartsTooltip;
    const Toolbar = props.slots?.toolbar;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eSGGd.ChartDataProvider, (0, $608337b41c11ae72$var$_extends2.default)({}, chartDataProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($G4UB8.ChartsWrapper, (0, $608337b41c11ae72$var$_extends2.default)({}, chartsWrapperProps, {
            children: [
                props.showToolbar && Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $608337b41c11ae72$var$_extends2.default)({}, props.slotProps?.toolbar)) : null,
                !props.hideLegend && /*#__PURE__*/ (0, $ayMG0.jsx)($anK5t.ChartsLegend, (0, $608337b41c11ae72$var$_extends2.default)({}, legendProps)),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ezMKh.ChartsSurface, (0, $608337b41c11ae72$var$_extends2.default)({}, chartsSurfaceProps, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($aiEgN.ChartsAxis, (0, $608337b41c11ae72$var$_extends2.default)({}, chartsAxisProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($2ppSP.ChartsGrid, (0, $608337b41c11ae72$var$_extends2.default)({}, gridProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            "data-drawing-container": true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4jAkz.ScatterPlot, (0, $608337b41c11ae72$var$_extends2.default)({}, scatterPlotProps))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hhc1V.ChartsOverlay, (0, $608337b41c11ae72$var$_extends2.default)({}, overlayProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ad3Dp.ChartsAxisHighlight, (0, $608337b41c11ae72$var$_extends2.default)({}, axisHighlightProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($7DI2Y.FocusedScatterMark, {}),
                        children
                    ]
                })),
                !props.loading && /*#__PURE__*/ (0, $ayMG0.jsx)(Tooltip, (0, $608337b41c11ae72$var$_extends2.default)({
                    trigger: "item"
                }, props.slotProps?.tooltip))
            ]
        }))
    }));
});

});
parcelRegister("4jAkz", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $32451e49e12e07d0$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $32451e49e12e07d0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScatterPlot = $32451e49e12e07d0$var$ScatterPlot;

var $32451e49e12e07d0$var$_extends2 = $32451e49e12e07d0$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $32451e49e12e07d0$var$React = $32451e49e12e07d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $32451e49e12e07d0$var$_propTypes = $32451e49e12e07d0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $lCzUz = parcelRequire("lCzUz");

var $974Y3 = parcelRequire("974Y3");

var $55quD = parcelRequire("55quD");

var $9qhH3 = parcelRequire("9qhH3");

var $3BMFO = parcelRequire("3BMFO");

var $lk5Nf = parcelRequire("lk5Nf");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Scatter](https://mui.com/x/react-charts/scatter/)
 * - [Scatter demonstration](https://mui.com/x/react-charts/scatter-demo/)
 *
 * API:
 *
 * - [ScatterPlot API](https://mui.com/x/api/charts/scatter-plot/)
 */ function $32451e49e12e07d0$var$ScatterPlot(props) {
    const { slots: slots, slotProps: slotProps, onItemClick: onItemClick, renderer: renderer } = props;
    const seriesData = (0, $974Y3.useScatterSeriesContext)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55quD.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55quD.useYAxes)();
    const { zAxis: zAxis, zAxisIds: zAxisIds } = (0, $9qhH3.useZAxes)();
    if (seriesData === undefined) return null;
    const { series: series, seriesOrder: seriesOrder } = seriesData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    const defaultZAxisId = zAxisIds[0];
    const DefaultScatterItems = renderer === 'svg-batch' ? $lk5Nf.BatchScatter : $lCzUz.Scatter;
    const ScatterItems = slots?.scatter ?? DefaultScatterItems;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($32451e49e12e07d0$var$React.Fragment, {
        children: seriesOrder.map((seriesId)=>{
            const { id: id, xAxisId: xAxisId, yAxisId: yAxisId, zAxisId: zAxisId, color: color, hidden: hidden } = series[seriesId];
            if (hidden) return null;
            const colorGetter = $3BMFO.scatterSeriesConfig.colorProcessor(series[seriesId], xAxis[xAxisId ?? defaultXAxisId], yAxis[yAxisId ?? defaultYAxisId], zAxis[zAxisId ?? defaultZAxisId]);
            const xScale = xAxis[xAxisId ?? defaultXAxisId].scale;
            const yScale = yAxis[yAxisId ?? defaultYAxisId].scale;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(ScatterItems, (0, $32451e49e12e07d0$var$_extends2.default)({
                xScale: xScale,
                yScale: yScale,
                color: color,
                colorGetter: colorGetter,
                series: series[seriesId],
                onItemClick: onItemClick,
                slots: slots,
                slotProps: slotProps
            }, slotProps?.scatter), id);
        })
    });
}

});
parcelRegister("lCzUz", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fbd900d44e453fac$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fbd900d44e453fac$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scatter = $fbd900d44e453fac$var$Scatter;

var $fbd900d44e453fac$var$_extends2 = $fbd900d44e453fac$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $fbd900d44e453fac$var$_objectWithoutPropertiesLoose2 = $fbd900d44e453fac$require$_interopRequireDefault((parcelRequire("c05no")));

var $fbd900d44e453fac$var$React = $fbd900d44e453fac$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fbd900d44e453fac$var$_propTypes = $fbd900d44e453fac$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fbd900d44e453fac$var$_useSlotProps2 = $fbd900d44e453fac$require$_interopRequireDefault((parcelRequire("839K0")));

var $hdpx4 = parcelRequire("hdpx4");

var $d3mgr = parcelRequire("d3mgr");

var $jjapK = parcelRequire("jjapK");

var $dzF8X = parcelRequire("dzF8X");

var $fjqRM = parcelRequire("fjqRM");

var $eYj1Q = parcelRequire("eYj1Q");

var $dfNCu = parcelRequire("dfNCu");

var $6hQTT = parcelRequire("6hQTT");

var $ayMG0 = parcelRequire("ayMG0");
const $fbd900d44e453fac$var$_excluded = [
    "ownerState"
];
/**
 * Demos:
 *
 * - [Scatter](https://mui.com/x/react-charts/scatter/)
 * - [Scatter demonstration](https://mui.com/x/react-charts/scatter-demo/)
 *
 * API:
 *
 * - [Scatter API](https://mui.com/x/api/charts/scatter/)
 */ function $fbd900d44e453fac$var$Scatter(props) {
    const { series: series, xScale: xScale, yScale: yScale, colorGetter: colorGetter, onItemClick: onItemClick, classes: inClasses, slots: slots, slotProps: slotProps } = props;
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const store = (0, $d3mgr.useStore)();
    const isVoronoiEnabled = store.use($dzF8X.selectorChartsIsVoronoiEnabled);
    const skipInteractionHandlers = isVoronoiEnabled || series.disableHover;
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $jjapK.useItemHighlightedGetter)();
    const scatterPlotData = (0, $dfNCu.useScatterPlotData)(series, xScale, yScale, instance.isPointInside);
    const Marker = slots?.marker ?? $fjqRM.ScatterMarker;
    const _useSlotProps = (0, $fbd900d44e453fac$var$_useSlotProps2.default)({
        elementType: Marker,
        externalSlotProps: slotProps?.marker,
        additionalProps: {
            seriesId: series.id,
            size: series.markerSize
        },
        ownerState: {}
    }), markerProps = (0, $fbd900d44e453fac$var$_objectWithoutPropertiesLoose2.default)(_useSlotProps, $fbd900d44e453fac$var$_excluded);
    const classes = (0, $eYj1Q.useUtilityClasses)(inClasses);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        "data-series": series.id,
        className: classes.root,
        children: scatterPlotData.map((dataPoint)=>{
            const isItemHighlighted = isHighlighted(dataPoint);
            const isItemFaded = !isItemHighlighted && isFaded(dataPoint);
            return /*#__PURE__*/ (0, $ayMG0.jsx)(Marker, (0, $fbd900d44e453fac$var$_extends2.default)({
                dataIndex: dataPoint.dataIndex,
                color: colorGetter(dataPoint.dataIndex),
                isHighlighted: isItemHighlighted,
                isFaded: isItemFaded,
                x: dataPoint.x,
                y: dataPoint.y,
                onClick: onItemClick && ((event)=>onItemClick(event, {
                        type: 'scatter',
                        seriesId: series.id,
                        dataIndex: dataPoint.dataIndex
                    })),
                "data-highlighted": isItemHighlighted || undefined,
                "data-faded": isItemFaded || undefined
            }, skipInteractionHandlers ? undefined : (0, $hdpx4.getInteractionItemProps)(instance, dataPoint), markerProps), dataPoint.id ?? dataPoint.dataIndex);
        })
    });
}

});
parcelRegister("fjqRM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b25d7878cadf375c$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b25d7878cadf375c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScatterMarker = $b25d7878cadf375c$var$ScatterMarker;

var $b25d7878cadf375c$var$_extends2 = $b25d7878cadf375c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b25d7878cadf375c$var$_objectWithoutPropertiesLoose2 = $b25d7878cadf375c$require$_interopRequireDefault((parcelRequire("c05no")));

var $b25d7878cadf375c$var$React = $b25d7878cadf375c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b25d7878cadf375c$var$_propTypes = $b25d7878cadf375c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $b25d7878cadf375c$var$_excluded = [
    "seriesId",
    "isFaded",
    "isHighlighted",
    "x",
    "y",
    "color",
    "size",
    "dataIndex"
];
function $b25d7878cadf375c$var$ScatterMarker(props) {
    const { isFaded: isFaded, isHighlighted: isHighlighted, x: x, y: y, color: color, size: size } = props, other = (0, $b25d7878cadf375c$var$_objectWithoutPropertiesLoose2.default)(props, $b25d7878cadf375c$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("circle", (0, $b25d7878cadf375c$var$_extends2.default)({
        cx: 0,
        cy: 0,
        r: (isHighlighted ? 1.2 : 1) * size,
        transform: `translate(${x}, ${y})`,
        fill: color,
        opacity: isFaded ? 0.3 : 1,
        cursor: other.onClick ? 'pointer' : 'unset'
    }, other));
}

});

parcelRegister("eYj1Q", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ae656e01433c1609$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getScatterUtilityClass = $ae656e01433c1609$var$getScatterUtilityClass;
module.exports.useUtilityClasses = module.exports.scatterClasses = void 0;

var $ae656e01433c1609$var$_generateUtilityClass = $ae656e01433c1609$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $ae656e01433c1609$var$_composeClasses = $ae656e01433c1609$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $ae656e01433c1609$var$_generateUtilityClasses = $ae656e01433c1609$require$_interopRequireDefault((parcelRequire("5nY49")));
function $ae656e01433c1609$var$getScatterUtilityClass(slot) {
    return (0, $ae656e01433c1609$var$_generateUtilityClass.default)('MuiScatter', slot);
}
const $ae656e01433c1609$var$scatterClasses = module.exports.scatterClasses = (0, $ae656e01433c1609$var$_generateUtilityClasses.default)('MuiScatter', [
    'root'
]);
const $ae656e01433c1609$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $ae656e01433c1609$var$_composeClasses.default)(slots, $ae656e01433c1609$var$getScatterUtilityClass, classes);
};
module.exports.useUtilityClasses = $ae656e01433c1609$var$useUtilityClasses;

});

parcelRegister("dfNCu", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9a632a836645f374$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useScatterPlotData = $9a632a836645f374$var$useScatterPlotData;

var $9a632a836645f374$var$React = $9a632a836645f374$require$_interopRequireWildcard((parcelRequire("acw62")));

var $55quD = parcelRequire("55quD");
function $9a632a836645f374$var$useScatterPlotData(series, xScale, yScale, isPointInside) {
    return $9a632a836645f374$var$React.useMemo(()=>{
        const getXPosition = (0, $55quD.getValueToPositionMapper)(xScale);
        const getYPosition = (0, $55quD.getValueToPositionMapper)(yScale);
        const temp = [];
        for(let i = 0; i < series.data.length; i += 1){
            const scatterPoint = series.data[i];
            const x = getXPosition(scatterPoint.x);
            const y = getYPosition(scatterPoint.y);
            const isInRange = isPointInside(x, y);
            if (isInRange) temp.push({
                x: x,
                y: y,
                id: scatterPoint.id,
                seriesId: series.id,
                type: 'scatter',
                dataIndex: i
            });
        }
        return temp;
    }, [
        xScale,
        yScale,
        series.data,
        series.id,
        isPointInside
    ]);
}

});


parcelRegister("lk5Nf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f85ff5ab150c0318$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchScatter = $f85ff5ab150c0318$var$BatchScatter;

var $f85ff5ab150c0318$var$React = $f85ff5ab150c0318$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $eYj1Q = parcelRequire("eYj1Q");

var $6hQTT = parcelRequire("6hQTT");

var $kzIRL = parcelRequire("kzIRL");

var $cZLDK = parcelRequire("cZLDK");

var $iY6q5 = parcelRequire("iY6q5");

var $ayMG0 = parcelRequire("ayMG0");
const $f85ff5ab150c0318$var$MAX_POINTS_PER_PATH = 1000;
/* In an SVG arc, if the arc starts and ends at the same point, it is not rendered, so we add a tiny
 * value to one of the coordinates to ensure that the arc is rendered. */ const $f85ff5ab150c0318$var$ALMOST_ZERO = 0.01;
function $f85ff5ab150c0318$var$createPath(x, y, markerSize) {
    return `M${x - markerSize} ${y} a${markerSize} ${markerSize} 0 1 1 0 ${$f85ff5ab150c0318$var$ALMOST_ZERO}`;
}
function $f85ff5ab150c0318$var$useCreatePaths(seriesData, markerSize, xScale, yScale, color, colorGetter) {
    const { instance: instance } = (0, $6hQTT.useChartContext)();
    const getXPosition = (0, $kzIRL.getValueToPositionMapper)(xScale);
    const getYPosition = (0, $kzIRL.getValueToPositionMapper)(yScale);
    const paths = new Map();
    const temporaryPaths = new Map();
    for(let i = 0; i < seriesData.length; i += 1){
        const scatterPoint = seriesData[i];
        const x = getXPosition(scatterPoint.x);
        const y = getYPosition(scatterPoint.y);
        if (!instance.isPointInside(x, y)) continue;
        const path = $f85ff5ab150c0318$var$createPath(x, y, markerSize);
        const fill = colorGetter ? colorGetter(i) : color;
        const tempPath = (0, $iY6q5.appendAtKey)(temporaryPaths, fill, path);
        if (tempPath.length >= $f85ff5ab150c0318$var$MAX_POINTS_PER_PATH) {
            (0, $iY6q5.appendAtKey)(paths, fill, tempPath.join(''));
            temporaryPaths.delete(fill);
        }
    }
    for (const [fill, tempPath] of temporaryPaths.entries())if (tempPath.length > 0) (0, $iY6q5.appendAtKey)(paths, fill, tempPath.join(''));
    return paths;
}
function $f85ff5ab150c0318$var$BatchScatterPaths(props) {
    const { series: series, xScale: xScale, yScale: yScale, color: color, colorGetter: colorGetter, markerSize: markerSize } = props;
    const paths = $f85ff5ab150c0318$var$useCreatePaths(series.data, markerSize, xScale, yScale, color, colorGetter);
    const children = [];
    let i = 0;
    for (const [fill, dArray] of paths.entries())for (const d of dArray){
        children.push(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fill: fill,
            d: d
        }, i));
        i += 1;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f85ff5ab150c0318$var$React.Fragment, {
        children: children
    });
}
const $f85ff5ab150c0318$var$MemoBatchScatterPaths = /*#__PURE__*/ $f85ff5ab150c0318$var$React.memo($f85ff5ab150c0318$var$BatchScatterPaths);
const $f85ff5ab150c0318$var$Group = (0, $8xDHs.styled)('g', {
    slot: 'internal',
    shouldForwardProp: undefined
})({
    '&[data-faded="true"]': {
        opacity: 0.3
    },
    '& path': {
        /* The browser must do hit testing to know which element a pointer is interacting with.
     * With many data points, we create many paths causing significant time to be spent in the hit test phase.
     * To fix this issue, we disable pointer events for the descendant paths.
     *
     * Ideally, users should be able to override this in case they need pointer events to be enabled,
     * but it can affect performance negatively, especially with many data points. */ pointerEvents: 'none'
    }
});
/**
 * @internal
 * A batch version of the Scatter component that uses SVG paths to render points.
 * This component is optimized for performance and is suitable for rendering large datasets, but has limitations. Some of the limitations include:
 * - Limited CSS styling;
 * - Overriding the `marker` slot is not supported;
 * - Highlight style must not contain opacity.
 *
 * You can read about all the limitations [here](https://mui.com/x/react-charts/scatter/#performance).
 */ function $f85ff5ab150c0318$var$BatchScatter(props) {
    const { series: series, xScale: xScale, yScale: yScale, color: color, colorGetter: colorGetter, classes: inClasses } = props;
    const { store: store } = (0, $6hQTT.useChartContext)();
    const isSeriesHighlighted = store.use($cZLDK.selectorChartIsSeriesHighlighted, series.id);
    const isSeriesFaded = store.use($cZLDK.selectorChartIsSeriesFaded, series.id);
    const seriesHighlightedItem = store.use($cZLDK.selectorChartSeriesHighlightedItem, series.id);
    const seriesUnfadedItem = store.use($cZLDK.selectorChartSeriesUnfadedItem, series.id);
    const highlightedModifier = 1.2;
    const markerSize = series.markerSize * (isSeriesHighlighted ? highlightedModifier : 1);
    const classes = (0, $eYj1Q.useUtilityClasses)(inClasses);
    const siblings = [];
    if (seriesHighlightedItem != null) {
        const datum = series.data[seriesHighlightedItem];
        const getXPosition = (0, $kzIRL.getValueToPositionMapper)(xScale);
        const getYPosition = (0, $kzIRL.getValueToPositionMapper)(yScale);
        siblings.push(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fill: colorGetter ? colorGetter(seriesHighlightedItem) : color,
            "data-highlighted": true,
            d: $f85ff5ab150c0318$var$createPath(getXPosition(datum.x), getYPosition(datum.y), markerSize * highlightedModifier)
        }, `highlighted-${series.id}`));
    }
    if (seriesUnfadedItem != null) {
        const datum = series.data[seriesUnfadedItem];
        const getXPosition = (0, $kzIRL.getValueToPositionMapper)(xScale);
        const getYPosition = (0, $kzIRL.getValueToPositionMapper)(yScale);
        siblings.push(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fill: colorGetter ? colorGetter(seriesUnfadedItem) : color,
            d: $f85ff5ab150c0318$var$createPath(getXPosition(datum.x), getYPosition(datum.y), markerSize)
        }, `unfaded-${series.id}`));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f85ff5ab150c0318$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f85ff5ab150c0318$var$Group, {
                className: classes.root,
                "data-series": series.id,
                "data-faded": isSeriesFaded || undefined,
                "data-highlighted": isSeriesHighlighted || undefined,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($f85ff5ab150c0318$var$MemoBatchScatterPaths, {
                    series: series,
                    xScale: xScale,
                    yScale: yScale,
                    color: color,
                    colorGetter: colorGetter,
                    markerSize: markerSize
                })
            }),
            siblings
        ]
    });
}

});


parcelRegister("ggDlF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $bd7ca9bcf2f6ec68$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $bd7ca9bcf2f6ec68$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useScatterChartProps = void 0;

var $bd7ca9bcf2f6ec68$var$_extends2 = $bd7ca9bcf2f6ec68$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $bd7ca9bcf2f6ec68$var$_objectWithoutPropertiesLoose2 = $bd7ca9bcf2f6ec68$require$_interopRequireDefault((parcelRequire("c05no")));

var $bd7ca9bcf2f6ec68$var$React = $bd7ca9bcf2f6ec68$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3gOxF = parcelRequire("3gOxF");
const $bd7ca9bcf2f6ec68$var$_excluded = [
    "xAxis",
    "yAxis",
    "zAxis",
    "series",
    "axisHighlight",
    "voronoiMaxRadius",
    "disableVoronoi",
    "hideLegend",
    "width",
    "height",
    "margin",
    "colors",
    "sx",
    "grid",
    "onItemClick",
    "children",
    "slots",
    "slotProps",
    "loading",
    "highlightedItem",
    "onHighlightChange",
    "className",
    "showToolbar",
    "renderer",
    "brushConfig"
];
/**
 * A helper function that extracts ScatterChartProps from the input props
 * and returns an object with props for the children components of ScatterChart.
 *
 * @param props The input props for ScatterChart
 * @returns An object with props for the children components of ScatterChart
 */ const $bd7ca9bcf2f6ec68$var$useScatterChartProps = (props)=>{
    const { xAxis: xAxis, yAxis: yAxis, zAxis: zAxis, series: series, axisHighlight: axisHighlight, voronoiMaxRadius: voronoiMaxRadius, disableVoronoi: disableVoronoi, width: width, height: height, margin: margin, colors: colors, sx: sx, grid: grid, onItemClick: onItemClick, children: children, slots: slots, slotProps: slotProps, loading: loading, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, className: className, renderer: renderer, brushConfig: brushConfig } = props, other = (0, $bd7ca9bcf2f6ec68$var$_objectWithoutPropertiesLoose2.default)(props, $bd7ca9bcf2f6ec68$var$_excluded);
    const seriesWithDefault = $bd7ca9bcf2f6ec68$var$React.useMemo(()=>series.map((s)=>(0, $bd7ca9bcf2f6ec68$var$_extends2.default)({
                type: 'scatter'
            }, s)), [
        series
    ]);
    const useVoronoiOnItemClick = disableVoronoi !== true || renderer === 'svg-batch';
    const chartContainerProps = (0, $bd7ca9bcf2f6ec68$var$_extends2.default)({}, other, {
        series: seriesWithDefault,
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        xAxis: xAxis,
        yAxis: yAxis,
        zAxis: zAxis,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        disableVoronoi: disableVoronoi,
        voronoiMaxRadius: voronoiMaxRadius,
        onItemClick: useVoronoiOnItemClick ? onItemClick : undefined,
        className: className,
        plugins: $3gOxF.SCATTER_CHART_PLUGINS,
        slots: slots,
        slotProps: slotProps,
        brushConfig: brushConfig
    });
    const chartsAxisProps = {
        slots: slots,
        slotProps: slotProps
    };
    const gridProps = {
        vertical: grid?.vertical,
        horizontal: grid?.horizontal
    };
    const scatterPlotProps = {
        onItemClick: useVoronoiOnItemClick ? undefined : onItemClick,
        slots: slots,
        slotProps: slotProps,
        renderer: renderer
    };
    const overlayProps = {
        loading: loading,
        slots: slots,
        slotProps: slotProps
    };
    const legendProps = {
        slots: slots,
        slotProps: slotProps
    };
    const axisHighlightProps = (0, $bd7ca9bcf2f6ec68$var$_extends2.default)({
        y: 'none',
        x: 'none'
    }, axisHighlight);
    const chartsWrapperProps = {
        sx: sx,
        legendPosition: props.slotProps?.legend?.position,
        legendDirection: props.slotProps?.legend?.direction,
        hideLegend: props.hideLegend ?? false
    };
    return {
        chartsWrapperProps: chartsWrapperProps,
        chartContainerProps: chartContainerProps,
        chartsAxisProps: chartsAxisProps,
        gridProps: gridProps,
        scatterPlotProps: scatterPlotProps,
        overlayProps: overlayProps,
        legendProps: legendProps,
        axisHighlightProps: axisHighlightProps,
        children: children
    };
};
module.exports.useScatterChartProps = $bd7ca9bcf2f6ec68$var$useScatterChartProps;

});
parcelRegister("3gOxF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCATTER_CHART_PLUGINS = void 0;

var $d4cjJ = parcelRequire("d4cjJ");

var $a5Dpn = parcelRequire("a5Dpn");

var $d8Csh = parcelRequire("d8Csh");

var $8j56i = parcelRequire("8j56i");

var $cZLDK = parcelRequire("cZLDK");

var $dzF8X = parcelRequire("dzF8X");

var $cp50o = parcelRequire("cp50o");

var $b4u9m = parcelRequire("b4u9m");

var $fgykb = parcelRequire("fgykb");
const $261a125250396dfd$var$SCATTER_CHART_PLUGINS = module.exports.SCATTER_CHART_PLUGINS = [
    $d4cjJ.useChartZAxis,
    $b4u9m.useChartBrush,
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $a5Dpn.useChartCartesianAxis,
    $cZLDK.useChartHighlight,
    $fgykb.useChartVisibilityManager,
    $dzF8X.useChartClosestPoint,
    $cp50o.useChartKeyboardNavigation
];

});


parcelRegister("7DI2Y", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $58fe57bcd519d29f$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $58fe57bcd519d29f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FocusedScatterMark = $58fe57bcd519d29f$var$FocusedScatterMark;

var $58fe57bcd519d29f$var$_extends2 = $58fe57bcd519d29f$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $58fe57bcd519d29f$var$React = $58fe57bcd519d29f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $7ccUh = parcelRequire("7ccUh");

var $55quD = parcelRequire("55quD");

var $ayMG0 = parcelRequire("ayMG0");
function $58fe57bcd519d29f$var$FocusedScatterMark(props) {
    const theme = (0, $8xDHs.useTheme)();
    const focusedItem = (0, $7ccUh.useFocusedItem)();
    const scatterSeries = (0, $55quD.useScatterSeriesContext)();
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $55quD.useXAxes)();
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $55quD.useYAxes)();
    if (focusedItem === null || focusedItem.type !== 'scatter' || !scatterSeries) return null;
    const series = scatterSeries?.series[focusedItem.seriesId];
    const xAxisId = series.xAxisId ?? xAxisIds[0];
    const yAxisId = series.yAxisId ?? yAxisIds[0];
    const getXPosition = (0, $55quD.getValueToPositionMapper)(xAxis[xAxisId].scale);
    const getYPosition = (0, $55quD.getValueToPositionMapper)(yAxis[yAxisId].scale);
    const scatterPoint = series.data[focusedItem.dataIndex];
    const x = getXPosition(scatterPoint.x);
    const y = getYPosition(scatterPoint.y);
    const size = series.markerSize + 3;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", (0, $58fe57bcd519d29f$var$_extends2.default)({
        fill: "none",
        stroke: (theme.vars ?? theme).palette.text.primary,
        strokeWidth: 2,
        x: x - size,
        y: y - size,
        width: 2 * size,
        height: 2 * size,
        rx: 3,
        ry: 3
    }, props));
}

});


parcelRegister("IL0ps", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("ki9mB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fw3q0 = parcelRequire("fw3q0");
Object.keys($fw3q0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fw3q0[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fw3q0[key];
        }
    });
});

});
parcelRegister("fw3q0", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b4bc7f0132f5fa22$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $b4bc7f0132f5fa22$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparkLineChart = void 0;

var $b4bc7f0132f5fa22$var$_extends2 = $b4bc7f0132f5fa22$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $b4bc7f0132f5fa22$var$_objectWithoutPropertiesLoose2 = $b4bc7f0132f5fa22$require$_interopRequireDefault((parcelRequire("c05no")));

var $b4bc7f0132f5fa22$var$React = $b4bc7f0132f5fa22$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b4bc7f0132f5fa22$var$_propTypes = $b4bc7f0132f5fa22$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b4bc7f0132f5fa22$var$_useId = $b4bc7f0132f5fa22$require$_interopRequireDefault((parcelRequire("hwliF")));

var $6WChQ = parcelRequire("6WChQ");

var $1R6Wm = parcelRequire("1R6Wm");

var $i1xAO = parcelRequire("i1xAO");

var $eSGGd = parcelRequire("eSGGd");

var $ezMKh = parcelRequire("ezMKh");

var $fiXDv = parcelRequire("fiXDv");

var $luY0B = parcelRequire("luY0B");

var $ad3Dp = parcelRequire("ad3Dp");

var $lx7Fr = parcelRequire("lx7Fr");

var $ayMG0 = parcelRequire("ayMG0");
const $b4bc7f0132f5fa22$var$_excluded = [
    "xAxis",
    "yAxis",
    "width",
    "height",
    "margin",
    "color",
    "baseline",
    "sx",
    "showTooltip",
    "showHighlight",
    "axisHighlight",
    "children",
    "slots",
    "slotProps",
    "data",
    "plotType",
    "valueFormatter",
    "area",
    "curve",
    "className",
    "disableClipping",
    "clipAreaOffset",
    "onHighlightChange",
    "onHighlightedAxisChange",
    "highlightedAxis",
    "highlightedItem"
];
const $b4bc7f0132f5fa22$var$SPARK_LINE_DEFAULT_MARGIN = 5;
/**
 * Demos:
 *
 * - [SparkLine](https://mui.com/x/react-charts/sparkline/)
 *
 * API:
 *
 * - [SparkLineChart API](https://mui.com/x/api/charts/spark-line-chart/)
 */ const $b4bc7f0132f5fa22$var$SparkLineChart = module.exports.SparkLineChart = /*#__PURE__*/ $b4bc7f0132f5fa22$var$React.forwardRef(function SparkLineChart(props, ref) {
    const { xAxis: xAxisProps, yAxis: yAxisProps, width: width, height: height, margin: margin = $b4bc7f0132f5fa22$var$SPARK_LINE_DEFAULT_MARGIN, color: color, baseline: baseline, sx: sx, showTooltip: showTooltip, showHighlight: showHighlight, axisHighlight: inAxisHighlight, children: children, slots: slots, slotProps: slotProps, data: data, plotType: plotType = 'line', valueFormatter: valueFormatter = (value)=>value === null ? '' : value.toString(), area: area, curve: curve = 'linear', className: className, disableClipping: disableClipping, clipAreaOffset: clipAreaOffset, onHighlightChange: onHighlightChange, onHighlightedAxisChange: onHighlightedAxisChange, highlightedAxis: highlightedAxis, highlightedItem: highlightedItem } = props, other = (0, $b4bc7f0132f5fa22$var$_objectWithoutPropertiesLoose2.default)(props, $b4bc7f0132f5fa22$var$_excluded);
    const id = (0, $b4bc7f0132f5fa22$var$_useId.default)();
    const clipPathId = `${id}-clip-path`;
    const clipPathOffset = $b4bc7f0132f5fa22$var$React.useMemo(()=>({
            top: clipAreaOffset?.top ?? 1,
            right: clipAreaOffset?.right ?? 1,
            bottom: clipAreaOffset?.bottom ?? 1,
            left: clipAreaOffset?.left ?? 1
        }), [
        clipAreaOffset?.bottom,
        clipAreaOffset?.left,
        clipAreaOffset?.right,
        clipAreaOffset?.top
    ]);
    const defaultXHighlight = $b4bc7f0132f5fa22$var$React.useMemo(()=>showHighlight && plotType === 'bar' ? {
            x: 'band'
        } : {
            x: 'none'
        }, [
        plotType,
        showHighlight
    ]);
    const axisHighlight = $b4bc7f0132f5fa22$var$React.useMemo(()=>(0, $b4bc7f0132f5fa22$var$_extends2.default)({}, defaultXHighlight, inAxisHighlight), [
        defaultXHighlight,
        inAxisHighlight
    ]);
    const Tooltip = props.slots?.tooltip ?? $luY0B.ChartsTooltip;
    const colors = $b4bc7f0132f5fa22$var$React.useMemo(()=>{
        if (color == null) return undefined;
        return typeof color === 'function' ? (mode)=>[
                color(mode)
            ] : [
            color
        ];
    }, [
        color
    ]);
    const series = $b4bc7f0132f5fa22$var$React.useMemo(()=>[
            (0, $b4bc7f0132f5fa22$var$_extends2.default)({
                type: plotType,
                data: data,
                valueFormatter: valueFormatter
            }, plotType === 'bar' ? {} : {
                area: area,
                curve: curve,
                baseline: baseline,
                disableHighlight: !showHighlight
            })
        ], [
        area,
        baseline,
        curve,
        data,
        plotType,
        showHighlight,
        valueFormatter
    ]);
    const xAxis = $b4bc7f0132f5fa22$var$React.useMemo(()=>[
            (0, $b4bc7f0132f5fa22$var$_extends2.default)({
                id: $fiXDv.DEFAULT_X_AXIS_KEY,
                scaleType: plotType === 'bar' ? 'band' : 'point',
                hideTooltip: xAxisProps === undefined
            }, xAxisProps, {
                data: xAxisProps?.data ?? Array.from({
                    length: data.length
                }, (_, index)=>index),
                position: 'none'
            })
        ], [
        data.length,
        plotType,
        xAxisProps
    ]);
    const yAxis = $b4bc7f0132f5fa22$var$React.useMemo(()=>[
            (0, $b4bc7f0132f5fa22$var$_extends2.default)({
                id: $fiXDv.DEFAULT_Y_AXIS_KEY
            }, yAxisProps, {
                position: 'none'
            })
        ], [
        yAxisProps
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($eSGGd.ChartDataProvider, {
        series: series,
        width: width,
        height: height,
        margin: margin,
        xAxis: xAxis,
        yAxis: yAxis,
        colors: colors,
        disableAxisListener: onHighlightedAxisChange === undefined && (!showTooltip || slotProps?.tooltip?.trigger !== 'axis') && axisHighlight?.x === 'none' && axisHighlight?.y === 'none',
        onHighlightChange: onHighlightChange,
        onHighlightedAxisChange: onHighlightedAxisChange,
        highlightedAxis: highlightedAxis,
        highlightedItem: highlightedItem,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($ezMKh.ChartsSurface, (0, $b4bc7f0132f5fa22$var$_extends2.default)({
                className: className,
                ref: ref,
                sx: sx
            }, other, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: `url(#${clipPathId})`,
                        children: [
                            plotType === 'bar' && /*#__PURE__*/ (0, $ayMG0.jsx)($1R6Wm.BarPlot, {
                                skipAnimation: true,
                                slots: slots,
                                slotProps: slotProps
                            }),
                            plotType === 'line' && /*#__PURE__*/ (0, $ayMG0.jsxs)($b4bc7f0132f5fa22$var$React.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($i1xAO.AreaPlot, {
                                        skipAnimation: true,
                                        slots: slots,
                                        slotProps: slotProps
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($i1xAO.LinePlot, {
                                        skipAnimation: true,
                                        slots: slots,
                                        slotProps: slotProps
                                    })
                                ]
                            })
                        ]
                    }),
                    plotType === 'line' && /*#__PURE__*/ (0, $ayMG0.jsxs)($b4bc7f0132f5fa22$var$React.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($i1xAO.LineHighlightPlot, {
                                slots: slots,
                                slotProps: slotProps
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($lx7Fr.FocusedLineMark, {})
                        ]
                    }),
                    disableClipping ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($6WChQ.ChartsClipPath, {
                        id: clipPathId,
                        offset: clipPathOffset
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ad3Dp.ChartsAxisHighlight, (0, $b4bc7f0132f5fa22$var$_extends2.default)({}, axisHighlight)),
                    children
                ]
            })),
            showTooltip && /*#__PURE__*/ (0, $ayMG0.jsx)(Tooltip, (0, $b4bc7f0132f5fa22$var$_extends2.default)({}, props.slotProps?.tooltip))
        ]
    });
});

});


parcelRegister("81UtU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d8a3ac4523a97f8$var$_exportNames = {
    Unstable_RadarChart: true,
    Unstable_RadarDataProvider: true,
    RadarChart: true,
    RadarDataProvider: true
};
Object.defineProperty(module.exports, "RadarChart", {
    enumerable: true,
    get: function() {
        return $cSeBH.RadarChart;
    }
});
Object.defineProperty(module.exports, "RadarDataProvider", {
    enumerable: true,
    get: function() {
        return $bkgAl.RadarDataProvider;
    }
});
module.exports.Unstable_RadarDataProvider = module.exports.Unstable_RadarChart = void 0;

var $cSeBH = parcelRequire("cSeBH");

var $bkgAl = parcelRequire("bkgAl");

var $7GmPu = parcelRequire("7GmPu");
Object.keys($7GmPu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7GmPu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7GmPu[key];
        }
    });
});

var $jzP41 = parcelRequire("jzP41");
Object.keys($jzP41).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $jzP41[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jzP41[key];
        }
    });
});

var $iZhwM = parcelRequire("iZhwM");
Object.keys($iZhwM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $iZhwM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $iZhwM[key];
        }
    });
});

var $7gf72 = parcelRequire("7gf72");
Object.keys($7gf72).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7gf72[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7gf72[key];
        }
    });
});

var $cXfJK = parcelRequire("cXfJK");
Object.keys($cXfJK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cXfJK[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cXfJK[key];
        }
    });
});

var $hSWRc = parcelRequire("hSWRc");
Object.keys($hSWRc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $hSWRc[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $hSWRc[key];
        }
    });
});

var $5y1rj = parcelRequire("5y1rj");
Object.keys($5y1rj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5d8a3ac4523a97f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5y1rj[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5y1rj[key];
        }
    });
});
/**
 * @deprecated radar chart is now stable, import `RadarChart` instead
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $5d8a3ac4523a97f8$var$Unstable_RadarChart = module.exports.Unstable_RadarChart = $cSeBH.RadarChart;
/**
 * @deprecated radar data provider is now stable, import `RadarDataProvider` instead
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $5d8a3ac4523a97f8$var$Unstable_RadarDataProvider = module.exports.Unstable_RadarDataProvider = $bkgAl.RadarDataProvider;

});
parcelRegister("cSeBH", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $95f5dbd9bc0618f6$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $95f5dbd9bc0618f6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarChart = void 0;

var $95f5dbd9bc0618f6$var$_extends2 = $95f5dbd9bc0618f6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $95f5dbd9bc0618f6$var$React = $95f5dbd9bc0618f6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $95f5dbd9bc0618f6$var$_propTypes = $95f5dbd9bc0618f6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $anK5t = parcelRequire("anK5t");

var $53stl = parcelRequire("53stl");

var $gTq3z = parcelRequire("gTq3z");

var $ezMKh = parcelRequire("ezMKh");

var $G4UB8 = parcelRequire("G4UB8");

var $jzP41 = parcelRequire("jzP41");

var $8K04b = parcelRequire("8K04b");

var $hSWRc = parcelRequire("hSWRc");

var $7gf72 = parcelRequire("7gf72");

var $cXfJK = parcelRequire("cXfJK");

var $luY0B = parcelRequire("luY0B");

var $7GmPu = parcelRequire("7GmPu");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Demos:
 *
 * - [Radar Chart](https://mui.com/x/react-charts/radar/)
 *
 * API:
 *
 * - [RadarChart API](https://mui.com/x/api/charts/radar-chart/)
 */ const $95f5dbd9bc0618f6$var$RadarChart = module.exports.RadarChart = /*#__PURE__*/ $95f5dbd9bc0618f6$var$React.forwardRef(function RadarChart(inProps, ref) {
    const props = (0, $8xDHs.useThemeProps)({
        props: inProps,
        name: 'MuiRadarChart'
    });
    const { chartsWrapperProps: chartsWrapperProps, chartsSurfaceProps: chartsSurfaceProps, radarDataProviderProps: radarDataProviderProps, radarGrid: radarGrid, radarSeriesAreaProps: radarSeriesAreaProps, radarSeriesMarksProps: radarSeriesMarksProps, overlayProps: overlayProps, legendProps: legendProps, highlight: highlight, children: children } = (0, $gTq3z.useRadarChartProps)(props);
    const Tooltip = props.slots?.tooltip ?? $luY0B.ChartsTooltip;
    const Toolbar = props.slots?.toolbar;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8K04b.RadarDataProvider, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, radarDataProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($G4UB8.ChartsWrapper, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, chartsWrapperProps, {
            children: [
                props.showToolbar && Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, props.slotProps?.toolbar)) : null,
                !props.hideLegend && /*#__PURE__*/ (0, $ayMG0.jsx)($anK5t.ChartsLegend, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, legendProps)),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ezMKh.ChartsSurface, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, chartsSurfaceProps, {
                    ref: ref,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($jzP41.RadarGrid, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, radarGrid)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cXfJK.RadarMetricLabels, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hSWRc.RadarSeriesArea, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, radarSeriesAreaProps)),
                        highlight === 'axis' && /*#__PURE__*/ (0, $ayMG0.jsx)($7gf72.RadarAxisHighlight, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hSWRc.RadarSeriesMarks, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, radarSeriesMarksProps)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($7GmPu.FocusedRadarMark, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($53stl.ChartsOverlay, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, overlayProps)),
                        children
                    ]
                })),
                !props.loading && /*#__PURE__*/ (0, $ayMG0.jsx)(Tooltip, (0, $95f5dbd9bc0618f6$var$_extends2.default)({}, props.slotProps?.tooltip))
            ]
        }))
    }));
});

});
parcelRegister("gTq3z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c4c5feafbe67fb15$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarChartProps = void 0;

var $c4c5feafbe67fb15$var$_objectWithoutPropertiesLoose2 = $c4c5feafbe67fb15$require$_interopRequireDefault((parcelRequire("c05no")));

var $5y1rj = parcelRequire("5y1rj");
const $c4c5feafbe67fb15$var$_excluded = [
    "apiRef",
    "series",
    "radar",
    "width",
    "height",
    "margin",
    "colors",
    "sx",
    "children",
    "slots",
    "slotProps",
    "skipAnimation",
    "loading",
    "highlightedItem",
    "onHighlightChange",
    "hideLegend",
    "divisions",
    "shape",
    "stripeColor",
    "highlight",
    "showToolbar",
    "onAxisClick",
    "onAreaClick",
    "onMarkClick",
    "enableKeyboardNavigation"
];
/**
 * A helper function that extracts RadarChartProps from the input props
 * and returns an object with props for the children components of RadarChart.
 *
 * @param props The input props for RadarChart
 * @returns An object with props for the children components of RadarChart
 */ const $c4c5feafbe67fb15$var$useRadarChartProps = (props)=>{
    const { apiRef: apiRef, series: series, radar: radar, width: width, height: height, margin: margin, colors: colors, sx: sx, children: children, slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, loading: loading, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, divisions: divisions, shape: shape, stripeColor: stripeColor, highlight: highlight = 'axis', onAxisClick: onAxisClick, onAreaClick: onAreaClick, onMarkClick: onMarkClick, enableKeyboardNavigation: enableKeyboardNavigation } = props, other = (0, $c4c5feafbe67fb15$var$_objectWithoutPropertiesLoose2.default)(props, $c4c5feafbe67fb15$var$_excluded);
    const radarDataProviderProps = {
        apiRef: apiRef,
        series: series,
        radar: radar,
        highlight: highlight,
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        skipAnimation: skipAnimation,
        onAxisClick: onAxisClick,
        enableKeyboardNavigation: enableKeyboardNavigation,
        plugins: $5y1rj.RADAR_PLUGINS
    };
    const overlayProps = {
        slots: slots,
        slotProps: slotProps,
        loading: loading
    };
    const legendProps = {
        slots: slots,
        slotProps: slotProps
    };
    const chartsWrapperProps = {
        sx: sx,
        hideLegend: props.hideLegend ?? false
    };
    const radarGrid = {
        divisions: divisions,
        shape: shape,
        stripeColor: stripeColor
    };
    const radarSeriesAreaProps = {
        onItemClick: onAreaClick
    };
    const radarSeriesMarksProps = {
        onItemClick: onMarkClick
    };
    const chartsSurfaceProps = other;
    return {
        highlight: highlight,
        chartsWrapperProps: chartsWrapperProps,
        chartsSurfaceProps: chartsSurfaceProps,
        radarDataProviderProps: radarDataProviderProps,
        radarGrid: radarGrid,
        radarSeriesAreaProps: radarSeriesAreaProps,
        radarSeriesMarksProps: radarSeriesMarksProps,
        overlayProps: overlayProps,
        legendProps: legendProps,
        children: children
    };
};
module.exports.useRadarChartProps = $c4c5feafbe67fb15$var$useRadarChartProps;

});
parcelRegister("5y1rj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RADAR_PLUGINS = void 0;

var $j98pQ = parcelRequire("j98pQ");

var $d8Csh = parcelRequire("d8Csh");

var $8j56i = parcelRequire("8j56i");

var $cZLDK = parcelRequire("cZLDK");

var $cp50o = parcelRequire("cp50o");

var $fgykb = parcelRequire("fgykb");
const $40a13e94483800e6$var$RADAR_PLUGINS = module.exports.RADAR_PLUGINS = [
    $d8Csh.useChartTooltip,
    $8j56i.useChartInteraction,
    $j98pQ.useChartPolarAxis,
    $cZLDK.useChartHighlight,
    $cp50o.useChartKeyboardNavigation,
    $fgykb.useChartVisibilityManager
];

});


parcelRegister("jzP41", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h8Un5 = parcelRequire("h8Un5");
Object.keys($h8Un5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $h8Un5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h8Un5[key];
        }
    });
});

});
parcelRegister("h8Un5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c7aee933dd7a3bb3$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c7aee933dd7a3bb3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarGrid = $c7aee933dd7a3bb3$var$RadarGrid;

var $c7aee933dd7a3bb3$var$React = $c7aee933dd7a3bb3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c7aee933dd7a3bb3$var$_propTypes = $c7aee933dd7a3bb3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $7VHMS = parcelRequire("7VHMS");

var $gVsWq = parcelRequire("gVsWq");

var $ePGUj = parcelRequire("ePGUj");

var $cdWaK = parcelRequire("cdWaK");

var $6eQKn = parcelRequire("6eQKn");

var $SYMkA = parcelRequire("SYMkA");

var $ayMG0 = parcelRequire("ayMG0");
function $c7aee933dd7a3bb3$var$RadarGrid(props) {
    const theme = (0, $8xDHs.useTheme)();
    const { divisions: divisions = 5, shape: shape = 'sharp', stripeColor: stripeColor = (index)=>index % 2 === 1 ? (theme.vars || theme).palette.text.secondary : 'none' } = props;
    const gridData = (0, $7VHMS.useRadarGridData)();
    const classes = (0, $SYMkA.useUtilityClasses)(props.classes);
    if (gridData === null) return null;
    const { center: center, corners: corners, radius: radius } = gridData;
    return shape === 'sharp' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($c7aee933dd7a3bb3$var$React.Fragment, {
        children: [
            stripeColor && /*#__PURE__*/ (0, $ayMG0.jsx)($cdWaK.SharpRadarStripes, {
                divisions: divisions,
                corners: corners,
                center: center,
                radius: radius,
                stripeColor: stripeColor,
                classes: classes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($gVsWq.SharpRadarGrid, {
                divisions: divisions,
                corners: corners,
                center: center,
                radius: radius,
                strokeColor: (theme.vars || theme).palette.text.primary,
                classes: classes
            })
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($c7aee933dd7a3bb3$var$React.Fragment, {
        children: [
            stripeColor && /*#__PURE__*/ (0, $ayMG0.jsx)($6eQKn.CircularRadarStripes, {
                divisions: divisions,
                corners: corners,
                center: center,
                radius: radius,
                stripeColor: stripeColor,
                classes: classes
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ePGUj.CircularRadarGrid, {
                divisions: divisions,
                corners: corners,
                center: center,
                radius: radius,
                strokeColor: (theme.vars || theme).palette.text.primary,
                classes: classes
            })
        ]
    });
}

});
parcelRegister("7VHMS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarGridData = $5c5fd2825dfcbcbe$var$useRadarGridData;

var $kzIRL = parcelRequire("kzIRL");

var $55quD = parcelRequire("55quD");

var $j98pQ = parcelRequire("j98pQ");

var $1HhaP = parcelRequire("1HhaP");
function $5c5fd2825dfcbcbe$var$useRadarGridData() {
    const { instance: instance, store: store } = (0, $1HhaP.useChartContext)();
    const rotationScale = (0, $kzIRL.useRotationScale)();
    const { radiusAxis: radiusAxis } = (0, $55quD.useRadiusAxes)();
    const { cx: cx, cy: cy } = store.use($j98pQ.selectorChartPolarCenter);
    if (!rotationScale || rotationScale.domain().length === 0) return null;
    const metrics = rotationScale.domain();
    const angles = metrics.map((key)=>rotationScale(key));
    return {
        center: {
            x: cx,
            y: cy
        },
        corners: metrics.map((metric, dataIndex)=>{
            const radiusScale = radiusAxis[metric].scale;
            const r = radiusScale.range()[1];
            const angle = angles[dataIndex];
            const [x, y] = instance.polar2svg(r, angle);
            return {
                x: x,
                y: y
            };
        }),
        radius: radiusAxis[metrics[0]].scale.range()[1]
    };
}

});

parcelRegister("gVsWq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c5286b5a8ed5b539$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SharpRadarGrid = $c5286b5a8ed5b539$var$SharpRadarGrid;

var $c5286b5a8ed5b539$var$React = $c5286b5a8ed5b539$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $c5286b5a8ed5b539$var$SharpRadarGrid(props) {
    const { center: center, corners: corners, divisions: divisions, strokeColor: strokeColor, classes: classes } = props;
    const divisionRatio = Array.from({
        length: divisions
    }, (_, index)=>(index + 1) / divisions);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c5286b5a8ed5b539$var$React.Fragment, {
        children: [
            corners.map(({ x: x, y: y }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: `M ${center.x} ${center.y} L ${x} ${y}`,
                    stroke: strokeColor,
                    strokeWidth: 1,
                    strokeOpacity: 0.3,
                    fill: "none",
                    className: classes?.radial
                }, i)),
            divisionRatio.map((ratio)=>/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: `M ${corners.map(({ x: x, y: y })=>`${center.x * (1 - ratio) + ratio * x} ${center.y * (1 - ratio) + ratio * y}`).join(' L ')} Z`,
                    stroke: strokeColor,
                    strokeWidth: 1,
                    strokeOpacity: 0.3,
                    fill: "none",
                    className: classes?.divider
                }, ratio))
        ]
    });
}

});

parcelRegister("ePGUj", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $acc71c9f1973e930$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CircularRadarGrid = $acc71c9f1973e930$var$CircularRadarGrid;

var $acc71c9f1973e930$var$React = $acc71c9f1973e930$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ function $acc71c9f1973e930$var$CircularRadarGrid(props) {
    const { center: center, corners: corners, divisions: divisions, radius: radius, strokeColor: strokeColor, classes: classes } = props;
    const divisionRadius = Array.from({
        length: divisions
    }, (_, index)=>radius * (index + 1) / divisions);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acc71c9f1973e930$var$React.Fragment, {
        children: [
            corners.map(({ x: x, y: y }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: `M ${center.x} ${center.y} L ${x} ${y}`,
                    stroke: strokeColor,
                    strokeWidth: 1,
                    strokeOpacity: 0.3,
                    fill: "none",
                    className: classes?.radial
                }, i)),
            divisionRadius.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: center.x,
                    cy: center.y,
                    r: r,
                    stroke: strokeColor,
                    strokeWidth: 1,
                    strokeOpacity: 0.3,
                    fill: "none",
                    className: classes?.divider
                }, r))
        ]
    });
}

});

parcelRegister("cdWaK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $8e63d2c36d5e2a36$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SharpRadarStripes = $8e63d2c36d5e2a36$var$SharpRadarStripes;

var $8e63d2c36d5e2a36$var$React = $8e63d2c36d5e2a36$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $8e63d2c36d5e2a36$var$getPath = (corners, center, outerRatio, innerRatio)=>[
        'M',
        [
            ...corners,
            corners[0]
        ].map(({ x: x, y: y })=>`${center.x * (1 - outerRatio) + outerRatio * x} ${center.y * (1 - outerRatio) + outerRatio * y}`).join(' L '),
        'L',
        [
            ...corners,
            corners[0]
        ].reverse().map(({ x: x, y: y })=>`${center.x * (1 - innerRatio) + innerRatio * x} ${center.y * (1 - innerRatio) + innerRatio * y}`).join(' L '),
        'Z'
    ].join(' ');
/**
 * @ignore - internal component.
 */ function $8e63d2c36d5e2a36$var$SharpRadarStripes(props) {
    const { center: center, corners: corners, divisions: divisions, stripeColor: stripeColor, classes: classes } = props;
    const divisionRatio = Array.from({
        length: divisions
    }, (_, index)=>(index + 1) / divisions);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8e63d2c36d5e2a36$var$React.Fragment, {
        children: divisionRatio.map((ratio, index)=>{
            const smallerRatio = divisionRatio[index - 1] ?? 0;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: $8e63d2c36d5e2a36$var$getPath(corners, center, ratio, smallerRatio),
                stroke: "none",
                fill: stripeColor?.(index) ?? 'none',
                fillOpacity: 0.1,
                className: classes?.stripe
            }, ratio);
        })
    });
}

});

parcelRegister("6eQKn", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $48acf759801ccc40$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CircularRadarStripes = $48acf759801ccc40$var$CircularRadarStripes;

var $48acf759801ccc40$var$React = $48acf759801ccc40$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $48acf759801ccc40$var$getPath = (center, outerRadius, innerRadius)=>[
        `M ${center.x - outerRadius} ${center.y}`,
        `A ${outerRadius} ${outerRadius} 0 1 0 ${center.x + outerRadius} ${center.y}`,
        `A ${outerRadius} ${outerRadius} 0 1 0 ${center.x - outerRadius} ${center.y} Z`,
        `M ${center.x - innerRadius} ${center.y}`,
        `A ${innerRadius} ${innerRadius} 0 1 0 ${center.x + innerRadius} ${center.y}`,
        `A ${innerRadius} ${innerRadius} 0 1 0 ${center.x - innerRadius} ${center.y} Z`
    ].join('');
/**
 * @ignore - internal component.
 */ function $48acf759801ccc40$var$CircularRadarStripes(props) {
    const { center: center, divisions: divisions, radius: radius, stripeColor: stripeColor, classes: classes } = props;
    const divisionRadius = Array.from({
        length: divisions
    }, (_, index)=>radius * (index + 1) / divisions);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($48acf759801ccc40$var$React.Fragment, {
        children: divisionRadius.map((r, index)=>{
            const smallerRadius = divisionRadius[index - 1] ?? 0;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: $48acf759801ccc40$var$getPath(center, r, smallerRadius),
                fillRule: "evenodd",
                fill: stripeColor?.(index) ?? 'none',
                fillOpacity: 0.1,
                className: classes?.stripe
            }, r);
        })
    });
}

});

parcelRegister("SYMkA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0a54309c56e98459$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsGridClasses = void 0;
module.exports.getRadarGridUtilityClass = $0a54309c56e98459$var$getRadarGridUtilityClass;
module.exports.useUtilityClasses = void 0;

var $0a54309c56e98459$var$_composeClasses = $0a54309c56e98459$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $0a54309c56e98459$var$_generateUtilityClass = $0a54309c56e98459$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $0a54309c56e98459$var$_generateUtilityClasses = $0a54309c56e98459$require$_interopRequireDefault((parcelRequire("5nY49")));
function $0a54309c56e98459$var$getRadarGridUtilityClass(slot) {
    return (0, $0a54309c56e98459$var$_generateUtilityClass.default)('MuiRadarGrid', slot);
}
const $0a54309c56e98459$var$chartsGridClasses = module.exports.chartsGridClasses = (0, $0a54309c56e98459$var$_generateUtilityClasses.default)('MuiRadarGrid', [
    'radial',
    'divider',
    'stripe'
]);
const $0a54309c56e98459$var$useUtilityClasses = (classes)=>{
    const slots = {
        radial: [
            'radial'
        ],
        divider: [
            'divider'
        ],
        stripe: [
            'stripe'
        ]
    };
    return (0, $0a54309c56e98459$var$_composeClasses.default)(slots, $0a54309c56e98459$var$getRadarGridUtilityClass, classes);
};
module.exports.useUtilityClasses = $0a54309c56e98459$var$useUtilityClasses;

});



parcelRegister("8K04b", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $65d2abcd036e7e88$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $65d2abcd036e7e88$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarDataProvider = $65d2abcd036e7e88$var$RadarDataProvider;

var $65d2abcd036e7e88$var$_extends2 = $65d2abcd036e7e88$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $65d2abcd036e7e88$var$_objectWithoutPropertiesLoose2 = $65d2abcd036e7e88$require$_interopRequireDefault((parcelRequire("c05no")));

var $65d2abcd036e7e88$var$React = $65d2abcd036e7e88$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5y1rj = parcelRequire("5y1rj");

var $eSGGd = parcelRequire("eSGGd");

var $fXrnQ = parcelRequire("fXrnQ");

var $3JX2r = parcelRequire("3JX2r");

var $ayMG0 = parcelRequire("ayMG0");
const $65d2abcd036e7e88$var$_excluded = [
    "series",
    "children",
    "width",
    "height",
    "colors",
    "skipAnimation",
    "margin",
    "radar",
    "highlight",
    "plugins"
];
const $65d2abcd036e7e88$var$RADAR_SERIES_CONFIG = {
    radar: $3JX2r.radarSeriesConfig
};
const $65d2abcd036e7e88$var$DEFAULT_RADAR_MARGIN = {
    top: 30,
    bottom: 30,
    left: 50,
    right: 50
};
function $65d2abcd036e7e88$var$RadarDataProvider(props) {
    const { series: series, children: children, width: width, height: height, colors: colors, skipAnimation: skipAnimation, margin: margin, radar: radar, highlight: highlight, plugins: plugins } = props, other = (0, $65d2abcd036e7e88$var$_objectWithoutPropertiesLoose2.default)(props, $65d2abcd036e7e88$var$_excluded);
    const rotationAxes = $65d2abcd036e7e88$var$React.useMemo(()=>[
            {
                id: 'radar-rotation-axis',
                scaleType: 'point',
                data: radar.metrics.map((metric)=>typeof metric === 'string' ? metric : metric.name),
                startAngle: radar.startAngle,
                endAngle: radar.startAngle !== undefined ? radar.startAngle + 360 : undefined,
                labelGap: radar.labelGap,
                valueFormatter: (name, { location: location })=>radar.labelFormatter?.(name, {
                        location: location
                    }) ?? name
            }
        ], [
        radar
    ]);
    const radiusAxis = $65d2abcd036e7e88$var$React.useMemo(()=>radar.metrics.map((m)=>{
            const { name: name, min: min = 0, max: max = radar.max } = typeof m === 'string' ? {
                name: m
            } : m;
            return {
                id: name,
                label: name,
                scaleType: 'linear',
                min: min,
                max: max
            };
        }), [
        radar
    ]);
    const defaultizedSeries = $65d2abcd036e7e88$var$React.useMemo(()=>series.map((s)=>(0, $65d2abcd036e7e88$var$_extends2.default)({
                type: 'radar',
                highlightScope: s.highlightScope ?? (highlight === 'series' ? {
                    highlight: 'series',
                    fade: 'global'
                } : undefined)
            }, s)), [
        series,
        highlight
    ]);
    const defaultizedMargin = $65d2abcd036e7e88$var$React.useMemo(()=>(0, $fXrnQ.defaultizeMargin)(margin, $65d2abcd036e7e88$var$DEFAULT_RADAR_MARGIN), [
        margin
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eSGGd.ChartDataProvider, (0, $65d2abcd036e7e88$var$_extends2.default)({}, other, {
        series: defaultizedSeries,
        width: width,
        height: height,
        margin: defaultizedMargin,
        colors: colors,
        skipAnimation: skipAnimation,
        plugins: plugins ?? $5y1rj.RADAR_PLUGINS,
        rotationAxis: rotationAxes,
        radiusAxis: radiusAxis,
        seriesConfig: $65d2abcd036e7e88$var$RADAR_SERIES_CONFIG,
        children: children
    }));
}

});
parcelRegister("3JX2r", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $2b935edf6c67b911$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $2b935edf6c67b911$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radarSeriesConfig = void 0;

var $2b935edf6c67b911$var$_seriesProcessor = $2b935edf6c67b911$require$_interopRequireDefault((parcelRequire("2a9Zo")));

var $2b935edf6c67b911$var$_getColor = $2b935edf6c67b911$require$_interopRequireDefault((parcelRequire("bvb1v")));

var $8qhi3 = parcelRequire("8qhi3");

var $2b935edf6c67b911$var$_legend = $2b935edf6c67b911$require$_interopRequireDefault((parcelRequire("aNW0n")));

var $2b935edf6c67b911$var$_tooltip = $2b935edf6c67b911$require$_interopRequireWildcard((parcelRequire("kLRgx")));

var $2b935edf6c67b911$var$_getSeriesWithDefaultValues = $2b935edf6c67b911$require$_interopRequireDefault((parcelRequire("8Aiws")));

var $2b935edf6c67b911$var$_tooltipPosition = $2b935edf6c67b911$require$_interopRequireDefault((parcelRequire("9EgUh")));

var $2b935edf6c67b911$var$_keyboardFocusHandler = $2b935edf6c67b911$require$_interopRequireDefault((parcelRequire("blM8i")));

var $jtEpx = parcelRequire("jtEpx");
const $2b935edf6c67b911$var$radarSeriesConfig = module.exports.radarSeriesConfig = {
    colorProcessor: $2b935edf6c67b911$var$_getColor.default,
    seriesProcessor: $2b935edf6c67b911$var$_seriesProcessor.default,
    legendGetter: $2b935edf6c67b911$var$_legend.default,
    tooltipGetter: $2b935edf6c67b911$var$_tooltip.default,
    tooltipItemPositionGetter: $2b935edf6c67b911$var$_tooltipPosition.default,
    axisTooltipGetter: $2b935edf6c67b911$var$_tooltip.axisTooltipGetter,
    getSeriesWithDefaultValues: $2b935edf6c67b911$var$_getSeriesWithDefaultValues.default,
    radiusExtremumGetter: $8qhi3.radiusExtremumGetter,
    rotationExtremumGetter: $8qhi3.rotationExtremumGetter,
    keyboardFocusHandler: $2b935edf6c67b911$var$_keyboardFocusHandler.default,
    identifierSerializer: $jtEpx.identifierSerializerSeriesIdDataIndex
};

});
parcelRegister("2a9Zo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1934439493b6090c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1934439493b6090c$var$_extends2 = $1934439493b6090c$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $1934439493b6090c$var$defaultRadarValueFormatter = (v)=>v == null ? '' : v.toLocaleString();
const $1934439493b6090c$var$seriesProcessor = (params, _, isItemVisible)=>{
    const { seriesOrder: seriesOrder, series: seriesMap } = params;
    const completedSeries = {};
    seriesOrder.forEach((seriesId)=>{
        const series = seriesMap[seriesId];
        const hidden = !isItemVisible?.({
            type: 'radar',
            seriesId: seriesId
        });
        completedSeries[seriesId] = (0, $1934439493b6090c$var$_extends2.default)({
            labelMarkType: 'square'
        }, series, {
            valueFormatter: series.valueFormatter ?? $1934439493b6090c$var$defaultRadarValueFormatter,
            hidden: hidden
        });
    });
    return {
        seriesOrder: seriesOrder,
        series: completedSeries
    };
};
var $1934439493b6090c$var$_default = module.exports.default = $1934439493b6090c$var$seriesProcessor;

});

parcelRegister("bvb1v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fAIz6 = parcelRequire("fAIz6");
const $85fb23f73e6ad765$var$getColor = (series)=>{
    const getSeriesColor = (0, $fAIz6.getSeriesColorFn)(series);
    return (dataIndex)=>{
        if (dataIndex === undefined) return series.color;
        const value = series.data[dataIndex];
        return getSeriesColor({
            value: value,
            dataIndex: dataIndex
        });
    };
};
var $85fb23f73e6ad765$var$_default = module.exports.default = $85fb23f73e6ad765$var$getColor;

});

parcelRegister("8qhi3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rotationExtremumGetter = module.exports.radiusExtremumGetter = void 0;
const $621e29ef5077a643$var$radiusExtremumGetter = ({ series: series, axisIndex: axisIndex })=>{
    return Object.keys(series).filter((seriesId)=>series[seriesId].type === 'radar').reduce((acc, seriesId)=>{
        const { data: data } = series[seriesId];
        return [
            Math.min(data[axisIndex], acc[0]),
            Math.max(data[axisIndex], acc[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
module.exports.radiusExtremumGetter = $621e29ef5077a643$var$radiusExtremumGetter;
const $621e29ef5077a643$var$rotationExtremumGetter = ({ axis: axis })=>{
    const min = Math.min(...axis.data ?? []);
    const max = Math.max(...axis.data ?? []);
    return [
        min,
        max
    ];
};
module.exports.rotationExtremumGetter = $621e29ef5077a643$var$rotationExtremumGetter;

});

parcelRegister("aNW0n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $erYIG = parcelRequire("erYIG");
const $7ddb7996d9949055$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $erYIG.getLabel)(series[seriesId].label, 'legend');
        if (formattedLabel === undefined) return acc;
        acc.push({
            type: 'radar',
            id: seriesId,
            seriesId: seriesId,
            color: series[seriesId].color,
            label: formattedLabel,
            markType: series[seriesId].labelMarkType ?? 'square'
        });
        return acc;
    }, []);
};
var $7ddb7996d9949055$var$_default = module.exports.default = $7ddb7996d9949055$var$legendGetter;

});

parcelRegister("kLRgx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.axisTooltipGetter = void 0;

var $erYIG = parcelRequire("erYIG");
const $f1f183e6b19dc4d2$var$tooltipGetter = (params)=>{
    const { series: series, axesConfig: axesConfig, getColor: getColor, identifier: identifier } = params;
    const rotationAxis = axesConfig.rotation;
    if (!identifier || !rotationAxis) return null;
    const label = (0, $erYIG.getLabel)(series.label, 'tooltip');
    const formatter = (v)=>rotationAxis.valueFormatter?.(v, {
            location: 'tooltip',
            scale: rotationAxis.scale
        }) ?? (v == null ? '' : v.toLocaleString());
    return {
        identifier: identifier,
        color: getColor(),
        label: label,
        markType: series.labelMarkType,
        values: series.data.filter((_, index)=>identifier.dataIndex == null || identifier.dataIndex === index).map((value, dataIndex)=>({
                value: value,
                formattedValue: series.valueFormatter(value, {
                    dataIndex: dataIndex
                }),
                markType: series.labelMarkType,
                label: formatter(rotationAxis?.data?.[dataIndex])
            }))
    };
};
const $f1f183e6b19dc4d2$var$axisTooltipGetter = (series)=>{
    return Object.values(series).map(()=>({
            direction: 'rotation',
            axisId: undefined
        }));
};
module.exports.axisTooltipGetter = $f1f183e6b19dc4d2$var$axisTooltipGetter;
var $f1f183e6b19dc4d2$var$_default = module.exports.default = $f1f183e6b19dc4d2$var$tooltipGetter;

});

parcelRegister("8Aiws", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $64000db2cb9a1812$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64000db2cb9a1812$var$_extends2 = $64000db2cb9a1812$require$_interopRequireDefault((parcelRequire("3p9rK")));
const $64000db2cb9a1812$var$getSeriesWithDefaultValues = (seriesData, seriesIndex, colors)=>{
    return (0, $64000db2cb9a1812$var$_extends2.default)({}, seriesData, {
        id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
        color: seriesData.color ?? colors[seriesIndex % colors.length]
    });
};
var $64000db2cb9a1812$var$_default = module.exports.default = $64000db2cb9a1812$var$getSeriesWithDefaultValues;

});

parcelRegister("9EgUh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ahtwU = parcelRequire("ahtwU");

var $j98pQ = parcelRequire("j98pQ");
const $7064f6d370bf5a80$var$tooltipItemPositionGetter = (params)=>{
    const { series: series, identifier: identifier, axesConfig: axesConfig, drawingArea: drawingArea, placement: placement } = params;
    if (!identifier) return null;
    const itemSeries = series.radar?.series[identifier.seriesId];
    if (itemSeries == null) return null;
    const { radiusAxes: radiusAxes, rotationAxes: rotationAxes } = axesConfig;
    if (radiusAxes === undefined || rotationAxes === undefined) return null;
    // Only one rotation axis is supported for radar charts
    const rotationAxis = rotationAxes.axis[rotationAxes.axisIds[0]];
    const metrics = rotationAxis.scale.domain() ?? [];
    const angles = metrics.map((key)=>rotationAxis.scale(key));
    const { cx: cx, cy: cy } = (0, $j98pQ.getDrawingAreaCenter)(drawingArea);
    const polar2svg = (0, $ahtwU.generatePolar2svg)({
        cx: cx,
        cy: cy
    });
    const points = itemSeries.data.map((value, dataIndex)=>{
        const rId = radiusAxes.axisIds[dataIndex];
        const r = radiusAxes.axis[rId].scale(value);
        const angle = angles[dataIndex];
        return polar2svg(r, angle);
    });
    if (points.length === 0) return null;
    if (identifier.dataIndex != null) {
        const point = points[identifier.dataIndex];
        switch(placement){
            case 'right':
                return {
                    x: point[0] + 4,
                    y: point[1]
                };
            case 'bottom':
                return {
                    x: point[0],
                    y: point[1] + 4
                };
            case 'left':
                return {
                    x: point[0] - 4,
                    y: point[1]
                };
            case 'top':
            default:
                return {
                    x: point[0],
                    y: point[1] - 4
                };
        }
    }
    const [top, right, bottom, left] = points.reduce((acc, [x, y])=>{
        return [
            Math.min(y, acc[0]),
            Math.max(x, acc[1]),
            Math.max(y, acc[2]),
            Math.min(x, acc[3])
        ];
    }, [
        Infinity,
        -Infinity,
        -Infinity,
        Infinity
    ]);
    switch(placement){
        case 'right':
            return {
                x: right,
                y: (top + bottom) / 2
            };
        case 'bottom':
            return {
                x: (left + right) / 2,
                y: bottom
            };
        case 'left':
            return {
                x: left,
                y: (top + bottom) / 2
            };
        case 'top':
        default:
            return {
                x: (left + right) / 2,
                y: top
            };
    }
};
var $7064f6d370bf5a80$var$_default = module.exports.default = $7064f6d370bf5a80$var$tooltipItemPositionGetter;

});

parcelRegister("blM8i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fWTNT = parcelRequire("fWTNT");
const $8436fe09ad3ff98e$var$outSeriesTypes = new Set([
    'radar'
]);
const $8436fe09ad3ff98e$var$keyboardFocusHandler = (event)=>{
    switch(event.key){
        case 'ArrowRight':
            return (0, $fWTNT.createGetNextIndexFocusedItem)($8436fe09ad3ff98e$var$outSeriesTypes, true);
        case 'ArrowLeft':
            return (0, $fWTNT.createGetPreviousIndexFocusedItem)($8436fe09ad3ff98e$var$outSeriesTypes, true);
        case 'ArrowDown':
            return (0, $fWTNT.createGetPreviousSeriesFocusedItem)($8436fe09ad3ff98e$var$outSeriesTypes);
        case 'ArrowUp':
            return (0, $fWTNT.createGetNextSeriesFocusedItem)($8436fe09ad3ff98e$var$outSeriesTypes);
        default:
            return null;
    }
};
var $8436fe09ad3ff98e$var$_default = module.exports.default = $8436fe09ad3ff98e$var$keyboardFocusHandler;

});



parcelRegister("hSWRc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d055229366dd6fce$var$_exportNames = {
    RadarSeriesArea: true,
    RadarSeriesMarks: true,
    radarSeriesPlotClasses: true
};
Object.defineProperty(module.exports, "RadarSeriesArea", {
    enumerable: true,
    get: function() {
        return $kiOfZ.RadarSeriesArea;
    }
});
Object.defineProperty(module.exports, "RadarSeriesMarks", {
    enumerable: true,
    get: function() {
        return $kMVFb.RadarSeriesMarks;
    }
});
Object.defineProperty(module.exports, "radarSeriesPlotClasses", {
    enumerable: true,
    get: function() {
        return $cqnsn.radarSeriesPlotClasses;
    }
});

var $4CoQY = parcelRequire("4CoQY");
Object.keys($4CoQY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d055229366dd6fce$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4CoQY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4CoQY[key];
        }
    });
});

var $kiOfZ = parcelRequire("kiOfZ");

var $kMVFb = parcelRequire("kMVFb");

var $cqnsn = parcelRequire("cqnsn");

});
parcelRegister("4CoQY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $35cdfd649ab6b44a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarSeriesPlot = $35cdfd649ab6b44a$var$RadarSeriesPlot;

var $35cdfd649ab6b44a$var$_extends2 = $35cdfd649ab6b44a$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $35cdfd649ab6b44a$var$_propTypes = $35cdfd649ab6b44a$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $759ui = parcelRequire("759ui");

var $2q0L7 = parcelRequire("2q0L7");

var $jjapK = parcelRequire("jjapK");

var $cqnsn = parcelRequire("cqnsn");

var $kiOfZ = parcelRequire("kiOfZ");

var $kMVFb = parcelRequire("kMVFb");

var $EBmLM = parcelRequire("EBmLM");

var $ayMG0 = parcelRequire("ayMG0");
function $35cdfd649ab6b44a$var$RadarSeriesPlot(props) {
    const { seriesId: inSeriesId, classes: inClasses, onAreaClick: onAreaClick, onMarkClick: onMarkClick } = props;
    const seriesCoordinates = (0, $759ui.useRadarSeriesData)(inSeriesId);
    const getRotationIndex = (0, $EBmLM.useRadarRotationIndex)();
    const interactionProps = (0, $2q0L7.useInteractionAllItemProps)(seriesCoordinates);
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $jjapK.useItemHighlightedGetter)();
    const classes = (0, $cqnsn.useUtilityClasses)(inClasses);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        className: classes.root,
        children: seriesCoordinates?.map(({ seriesId: seriesId, points: points, color: color, hideMark: hideMark, fillArea: fillArea, hidden: hidden }, seriesIndex)=>{
            if (hidden) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", (0, $35cdfd649ab6b44a$var$_extends2.default)({}, (0, $kiOfZ.getPathProps)({
                        seriesId: seriesId,
                        points: points,
                        color: color,
                        fillArea: fillArea,
                        isFaded: isFaded,
                        isHighlighted: isHighlighted,
                        classes: classes
                    }), {
                        onClick: (event)=>onAreaClick?.(event, {
                                type: 'radar',
                                seriesId: seriesId,
                                dataIndex: getRotationIndex(event)
                            }),
                        cursor: onAreaClick ? 'pointer' : 'unset'
                    }, interactionProps[seriesIndex]), seriesId),
                    !hideMark && points.map((point, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("circle", (0, $35cdfd649ab6b44a$var$_extends2.default)({}, (0, $kMVFb.getCircleProps)({
                            seriesId: seriesId,
                            point: point,
                            color: point.color,
                            fillArea: fillArea,
                            isFaded: isFaded,
                            isHighlighted: isHighlighted,
                            classes: classes
                        }), {
                            onClick: (event)=>onMarkClick?.(event, {
                                    type: 'radar',
                                    seriesId: seriesId,
                                    dataIndex: index
                                }),
                            cursor: onMarkClick ? 'pointer' : 'unset'
                        }), index))
                ]
            }, seriesId);
        })
    });
}

});
parcelRegister("759ui", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $52805c1194ec95e6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarSeriesData = $52805c1194ec95e6$var$useRadarSeriesData;

var $52805c1194ec95e6$var$_extends2 = $52805c1194ec95e6$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $kzIRL = parcelRequire("kzIRL");

var $g21ve = parcelRequire("g21ve");

var $55Xcx = parcelRequire("55Xcx");

var $jjapK = parcelRequire("jjapK");

var $1HhaP = parcelRequire("1HhaP");

var $fAIz6 = parcelRequire("fAIz6");
/**
 * This hook provides all the data needed to display radar series.
 * @param querySeriesId The id of the series to display
 * @returns
 */ function $52805c1194ec95e6$var$useRadarSeriesData(querySeriesId) {
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const rotationScale = (0, $kzIRL.useRotationScale)();
    const { radiusAxis: radiusAxis } = (0, $55Xcx.useRadiusAxes)();
    const radarSeries = (0, $g21ve.useRadarSeries)(querySeriesId === undefined ? undefined : [
        querySeriesId
    ]);
    const { isFaded: isItemFaded, isHighlighted: isItemHighlighted } = (0, $jjapK.useItemHighlightedGetter)();
    const metrics = rotationScale?.domain() ?? [];
    const angles = metrics.map((key)=>rotationScale(key));
    return radarSeries.map((series)=>{
        const seriesId = series.id;
        const isSeriesHighlighted = isItemHighlighted({
            seriesId: seriesId
        });
        const isSeriesFaded = !isSeriesHighlighted && isItemFaded({
            seriesId: seriesId
        });
        const getColor = (0, $fAIz6.getSeriesColorFn)(series);
        return (0, $52805c1194ec95e6$var$_extends2.default)({}, series, {
            seriesId: series.id,
            isSeriesHighlighted: isSeriesHighlighted,
            isSeriesFaded: isSeriesFaded,
            points: series.data.map((value, dataIndex)=>{
                const highlighted = isItemHighlighted({
                    seriesId: seriesId,
                    dataIndex: dataIndex
                });
                const faded = !highlighted && isItemFaded({
                    seriesId: seriesId,
                    dataIndex: dataIndex
                });
                const r = radiusAxis[metrics[dataIndex]].scale(value);
                const angle = angles[dataIndex];
                const [x, y] = instance.polar2svg(r, angle);
                return {
                    x: x,
                    y: y,
                    isItemHighlighted: highlighted,
                    isItemFaded: faded,
                    dataIndex: dataIndex,
                    value: value,
                    color: getColor({
                        value: value,
                        dataIndex: dataIndex
                    })
                };
            })
        });
    });
}

});

parcelRegister("2q0L7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $1c2e993551a321c3$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInteractionAllItemProps = void 0;

var $1c2e993551a321c3$var$React = $1c2e993551a321c3$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1HhaP = parcelRequire("1HhaP");

var $hdpx4 = parcelRequire("hdpx4");
const $1c2e993551a321c3$var$useInteractionAllItemProps = (data, skip)=>{
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const results = $1c2e993551a321c3$var$React.useMemo(()=>{
        return data.map((item)=>{
            return skip ? {} : (0, $hdpx4.getInteractionItemProps)(instance, {
                type: 'radar',
                seriesId: item.seriesId,
                dataIndex: item.dataIndex
            });
        });
    }, [
        data,
        instance,
        skip
    ]);
    return results;
};
module.exports.useInteractionAllItemProps = $1c2e993551a321c3$var$useInteractionAllItemProps;

});

parcelRegister("cqnsn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90ba1bc5296a4572$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRadarSeriesPlotUtilityClass = $90ba1bc5296a4572$var$getRadarSeriesPlotUtilityClass;
module.exports.useUtilityClasses = module.exports.radarSeriesPlotClasses = void 0;

var $90ba1bc5296a4572$var$_composeClasses = $90ba1bc5296a4572$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $90ba1bc5296a4572$var$_generateUtilityClass = $90ba1bc5296a4572$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $90ba1bc5296a4572$var$_generateUtilityClasses = $90ba1bc5296a4572$require$_interopRequireDefault((parcelRequire("5nY49")));
function $90ba1bc5296a4572$var$getRadarSeriesPlotUtilityClass(slot) {
    return (0, $90ba1bc5296a4572$var$_generateUtilityClass.default)('MuiRadarSeriesPlot', slot);
}
const $90ba1bc5296a4572$var$radarSeriesPlotClasses = module.exports.radarSeriesPlotClasses = (0, $90ba1bc5296a4572$var$_generateUtilityClasses.default)('MuiRadarSeriesPlot', [
    'root',
    'area',
    'mark',
    'highlighted',
    'faded'
]);
const $90ba1bc5296a4572$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        area: [
            'area'
        ],
        mark: [
            'mark'
        ],
        highlighted: [
            'highlighted'
        ],
        faded: [
            'faded'
        ]
    };
    return (0, $90ba1bc5296a4572$var$_composeClasses.default)(slots, $90ba1bc5296a4572$var$getRadarSeriesPlotUtilityClass, classes);
};
module.exports.useUtilityClasses = $90ba1bc5296a4572$var$useUtilityClasses;

});

parcelRegister("kiOfZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ec7c7909781e9bfa$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $ec7c7909781e9bfa$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarSeriesArea = $ec7c7909781e9bfa$var$RadarSeriesArea;
module.exports.getPathProps = $ec7c7909781e9bfa$var$getPathProps;

var $ec7c7909781e9bfa$var$_extends2 = $ec7c7909781e9bfa$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $ec7c7909781e9bfa$var$_objectWithoutPropertiesLoose2 = $ec7c7909781e9bfa$require$_interopRequireDefault((parcelRequire("c05no")));

var $ec7c7909781e9bfa$var$React = $ec7c7909781e9bfa$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ec7c7909781e9bfa$var$_propTypes = $ec7c7909781e9bfa$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ec7c7909781e9bfa$var$_clsx = $ec7c7909781e9bfa$require$_interopRequireDefault((parcelRequire("9QePP")));

var $759ui = parcelRequire("759ui");

var $el4De = parcelRequire("el4De");

var $cqnsn = parcelRequire("cqnsn");

var $jjapK = parcelRequire("jjapK");

var $2q0L7 = parcelRequire("2q0L7");

var $EBmLM = parcelRequire("EBmLM");

var $ayMG0 = parcelRequire("ayMG0");
const $ec7c7909781e9bfa$var$_excluded = [
    "seriesId",
    "onItemClick"
];
function $ec7c7909781e9bfa$var$getPathProps(params) {
    const { isHighlighted: isHighlighted, isFaded: isFaded, seriesId: seriesId, classes: classes, points: points, fillArea: fillArea, color: color } = params;
    const isItemHighlighted = isHighlighted({
        seriesId: seriesId
    });
    const isItemFaded = !isItemHighlighted && isFaded({
        seriesId: seriesId
    });
    return {
        d: (0, $el4De.getAreaPath)(points),
        fill: fillArea ? color : 'transparent',
        stroke: color,
        className: (0, $ec7c7909781e9bfa$var$_clsx.default)(classes.area, isItemHighlighted && classes.highlighted || isItemFaded && classes.faded),
        strokeOpacity: isItemFaded ? 0.5 : 1,
        fillOpacity: isItemHighlighted && 0.4 || isItemFaded && 0.1 || 0.2,
        strokeWidth: !fillArea && isItemHighlighted ? 2 : 1
    };
}
function $ec7c7909781e9bfa$var$RadarSeriesArea(props) {
    const { seriesId: seriesId, onItemClick: onItemClick } = props, other = (0, $ec7c7909781e9bfa$var$_objectWithoutPropertiesLoose2.default)(props, $ec7c7909781e9bfa$var$_excluded);
    const seriesCoordinates = (0, $759ui.useRadarSeriesData)(seriesId);
    const getRotationIndex = (0, $EBmLM.useRadarRotationIndex)();
    const interactionProps = (0, $2q0L7.useInteractionAllItemProps)(seriesCoordinates);
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $jjapK.useItemHighlightedGetter)();
    const classes = (0, $cqnsn.useUtilityClasses)(props.classes);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ec7c7909781e9bfa$var$React.Fragment, {
        children: seriesCoordinates?.map(({ seriesId: id, points: points, color: color, fillArea: fillArea, hidden: hidden }, seriesIndex)=>{
            if (hidden) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("path", (0, $ec7c7909781e9bfa$var$_extends2.default)({}, $ec7c7909781e9bfa$var$getPathProps({
                seriesId: id,
                points: points,
                color: color,
                fillArea: fillArea,
                isFaded: isFaded,
                isHighlighted: isHighlighted,
                classes: classes
            }), {
                onClick: (event)=>onItemClick?.(event, {
                        type: 'radar',
                        seriesId: id,
                        dataIndex: getRotationIndex(event)
                    }),
                cursor: onItemClick ? 'pointer' : 'unset'
            }, interactionProps[seriesIndex], other), id);
        })
    });
}

});
parcelRegister("el4De", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAreaPath = $a7069e9edc2fa4ad$var$getAreaPath;
function $a7069e9edc2fa4ad$var$getAreaPath(points) {
    return `M ${points.map((p)=>`${p.x} ${p.y}`).join('L')} Z`;
}

});

parcelRegister("EBmLM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $07a0b8b3711b71fc$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarRotationIndex = $07a0b8b3711b71fc$var$useRadarRotationIndex;

var $07a0b8b3711b71fc$var$React = $07a0b8b3711b71fc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $j98pQ = parcelRequire("j98pQ");

var $g34sa = parcelRequire("g34sa");

var $ahtwU = parcelRequire("ahtwU");

var $8oJqY = parcelRequire("8oJqY");

var $d3mgr = parcelRequire("d3mgr");

var $j3Fic = parcelRequire("j3Fic");

var $55Xcx = parcelRequire("55Xcx");
/**
 * This hook provides a function that from pointer event returns the rotation index.
 * @return {(event: { clientX: number; clientY: number }) => number | null} rotationIndexGetter Returns the rotation data index.
 */ function $07a0b8b3711b71fc$var$useRadarRotationIndex() {
    const svgRef = (0, $j3Fic.useSvgRef)();
    const store = (0, $d3mgr.useStore)();
    const rotationAxis = (0, $55Xcx.useRotationAxis)();
    const center = store.use($j98pQ.selectorChartPolarCenter);
    const rotationIndexGetter = $07a0b8b3711b71fc$var$React.useCallback(function rotationIndexGetter(event) {
        const element = svgRef.current;
        if (!element || !rotationAxis) // Should never append
        throw new Error(`MUI X Charts: The ${!element ? 'SVG' : 'rotation axis'} was not found to compute radar dataIndex.`);
        const svgPoint = (0, $g34sa.getSVGPoint)(element, event);
        const rotation = (0, $ahtwU.generateSvg2rotation)(center)(svgPoint.x, svgPoint.y);
        const rotationIndex = (0, $8oJqY.getAxisIndex)(rotationAxis, rotation);
        return rotationIndex;
    }, [
        center,
        rotationAxis,
        svgRef
    ]);
    return rotationIndexGetter;
}

});


parcelRegister("kMVFb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f225050ab4e8564e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f225050ab4e8564e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarSeriesMarks = $f225050ab4e8564e$var$RadarSeriesMarks;
module.exports.getCircleProps = $f225050ab4e8564e$var$getCircleProps;

var $f225050ab4e8564e$var$_extends2 = $f225050ab4e8564e$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $f225050ab4e8564e$var$_objectWithoutPropertiesLoose2 = $f225050ab4e8564e$require$_interopRequireDefault((parcelRequire("c05no")));

var $f225050ab4e8564e$var$React = $f225050ab4e8564e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9QePP = parcelRequire("9QePP");

var $f225050ab4e8564e$var$_propTypes = $f225050ab4e8564e$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $759ui = parcelRequire("759ui");

var $jjapK = parcelRequire("jjapK");

var $cqnsn = parcelRequire("cqnsn");

var $ayMG0 = parcelRequire("ayMG0");
const $f225050ab4e8564e$var$_excluded = [
    "seriesId",
    "onItemClick"
];
function $f225050ab4e8564e$var$getCircleProps(params) {
    const { isHighlighted: isHighlighted, isFaded: isFaded, seriesId: seriesId, classes: classes, point: point, fillArea: fillArea, color: color } = params;
    const isItemHighlighted = isHighlighted({
        seriesId: seriesId
    });
    const isItemFaded = !isItemHighlighted && isFaded({
        seriesId: seriesId
    });
    return {
        cx: point.x,
        cy: point.y,
        r: 3,
        fill: color,
        stroke: color,
        opacity: fillArea && isItemFaded ? 0.5 : 1,
        className: (0, $9QePP.clsx)(classes.mark, isItemHighlighted && classes.highlighted || isItemFaded && classes.faded)
    };
}
function $f225050ab4e8564e$var$RadarSeriesMarks(props) {
    const { onItemClick: onItemClick } = props, other = (0, $f225050ab4e8564e$var$_objectWithoutPropertiesLoose2.default)(props, $f225050ab4e8564e$var$_excluded);
    const seriesCoordinates = (0, $759ui.useRadarSeriesData)(props.seriesId);
    const classes = (0, $cqnsn.useUtilityClasses)(props.classes);
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $jjapK.useItemHighlightedGetter)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f225050ab4e8564e$var$React.Fragment, {
        children: seriesCoordinates?.map(({ seriesId: id, points: points, hideMark: hideMark, fillArea: fillArea, hidden: hidden })=>{
            if (hideMark || hidden) return null;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                children: points.map((point, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("circle", (0, $f225050ab4e8564e$var$_extends2.default)({}, $f225050ab4e8564e$var$getCircleProps({
                        seriesId: id,
                        point: point,
                        color: point.color,
                        fillArea: fillArea,
                        isFaded: isFaded,
                        isHighlighted: isHighlighted,
                        classes: classes
                    }), {
                        pointerEvents: onItemClick ? undefined : 'none',
                        onClick: (event)=>onItemClick?.(event, {
                                type: 'radar',
                                seriesId: id,
                                dataIndex: index
                            }),
                        cursor: onItemClick ? 'pointer' : 'unset'
                    }, other), index))
            }, id);
        })
    });
}

});



parcelRegister("7gf72", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jQrcW = parcelRequire("jQrcW");
Object.keys($jQrcW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jQrcW[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $jQrcW[key];
        }
    });
});

});
parcelRegister("jQrcW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e727fa8eb39212b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarAxisHighlight = $e727fa8eb39212b4$var$RadarAxisHighlight;

var $e727fa8eb39212b4$var$_extends2 = $e727fa8eb39212b4$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $e727fa8eb39212b4$var$_propTypes = $e727fa8eb39212b4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $e727fa8eb39212b4$var$_composeClasses = $e727fa8eb39212b4$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $6yit6 = parcelRequire("6yit6");

var $g5miI = parcelRequire("g5miI");

var $fAIz6 = parcelRequire("fAIz6");

var $ayMG0 = parcelRequire("ayMG0");
const $e727fa8eb39212b4$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        line: [
            'line'
        ],
        dot: [
            'dot'
        ]
    };
    return (0, $e727fa8eb39212b4$var$_composeClasses.default)(slots, $g5miI.getRadarAxisHighlightUtilityClass, classes);
};
/**
 * Attributes to display a shadow around a mark.
 */ const $e727fa8eb39212b4$var$highlightMarkShadow = {
    r: 7,
    opacity: 0.3
};
/**
 * Attributes to display a mark.
 */ const $e727fa8eb39212b4$var$highlightMark = {
    r: 3,
    opacity: 1
};
function $e727fa8eb39212b4$var$RadarAxisHighlight(props) {
    const classes = $e727fa8eb39212b4$var$useUtilityClasses(props.classes);
    const theme = (0, $8xDHs.useTheme)();
    const data = (0, $6yit6.useRadarAxisHighlight)();
    if (data === null) return null;
    const { center: center, series: series, points: points, radius: radius, highlightedAngle: highlightedAngle, highlightedIndex: highlightedIndex, instance: instance } = data;
    const [x, y] = instance.polar2svg(radius, highlightedAngle);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: `M ${center.cx} ${center.cy} L ${x} ${y}`,
                stroke: (theme.vars || theme).palette.text.primary,
                strokeWidth: 1,
                className: classes.line,
                pointerEvents: "none",
                strokeDasharray: "4 4"
            }),
            points.map((point, seriesIndex)=>{
                const colorGetter = (0, $fAIz6.getSeriesColorFn)(series[seriesIndex]);
                return /*#__PURE__*/ (0, $ayMG0.jsx)("circle", (0, $e727fa8eb39212b4$var$_extends2.default)({
                    fill: colorGetter({
                        value: point.value,
                        dataIndex: highlightedIndex
                    }),
                    cx: point.x,
                    cy: point.y,
                    className: classes.dot,
                    pointerEvents: "none"
                }, series[seriesIndex].hideMark ? $e727fa8eb39212b4$var$highlightMark : $e727fa8eb39212b4$var$highlightMarkShadow), series[seriesIndex].id);
            })
        ]
    });
}

});
parcelRegister("6yit6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarAxisHighlight = $4c543e7ddc701dcb$var$useRadarAxisHighlight;

var $55Xcx = parcelRequire("55Xcx");

var $g21ve = parcelRequire("g21ve");

var $kzIRL = parcelRequire("kzIRL");

var $d3mgr = parcelRequire("d3mgr");

var $1HhaP = parcelRequire("1HhaP");

var $j98pQ = parcelRequire("j98pQ");

var $bLygF = parcelRequire("bLygF");
function $4c543e7ddc701dcb$var$useRadarAxisHighlight() {
    const radarSeries = (0, $g21ve.useRadarSeries)();
    const rotationScale = (0, $kzIRL.useRotationScale)();
    const { radiusAxis: radiusAxis, radiusAxisIds: radiusAxisIds } = (0, $55Xcx.useRadiusAxes)();
    const { instance: instance } = (0, $1HhaP.useChartContext)();
    const store = (0, $d3mgr.useStore)();
    const rotationAxisIndex = store.use($bLygF.selectorChartsInteractionRotationAxisIndex);
    const rotationAxisValue = store.use($bLygF.selectorChartsInteractionRotationAxisValue);
    const center = store.use($j98pQ.selectorChartPolarCenter);
    const highlightedIndex = rotationAxisIndex;
    if (!rotationScale) return null;
    if (highlightedIndex === null || highlightedIndex === -1) return null;
    if (radarSeries === undefined || radarSeries.length === 0) return null;
    const metric = radiusAxisIds[highlightedIndex];
    const radiusScale = radiusAxis[metric].scale;
    const angle = rotationScale(rotationAxisValue);
    const radius = radiusScale.range()[1];
    return {
        center: center,
        radius: radius,
        instance: instance,
        highlightedIndex: highlightedIndex,
        highlightedMetric: metric,
        highlightedAngle: angle,
        series: radarSeries,
        points: radarSeries.map((series)=>{
            const value = series.data[highlightedIndex];
            const r = radiusScale(value);
            const [x, y] = instance.polar2svg(r, angle);
            const returnedValue = {
                x: x,
                y: y,
                r: r,
                angle: angle,
                value: value
            };
            return returnedValue;
        })
    };
}

});

parcelRegister("g5miI", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bb5e6972102ba813$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsAxisHighlightClasses = void 0;
module.exports.getRadarAxisHighlightUtilityClass = $bb5e6972102ba813$var$getRadarAxisHighlightUtilityClass;

var $bb5e6972102ba813$var$_generateUtilityClass = $bb5e6972102ba813$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $bb5e6972102ba813$var$_generateUtilityClasses = $bb5e6972102ba813$require$_interopRequireDefault((parcelRequire("5nY49")));
function $bb5e6972102ba813$var$getRadarAxisHighlightUtilityClass(slot) {
    return (0, $bb5e6972102ba813$var$_generateUtilityClass.default)('MuiRadarAxisHighlight', slot);
}
const $bb5e6972102ba813$var$chartsAxisHighlightClasses = module.exports.chartsAxisHighlightClasses = (0, $bb5e6972102ba813$var$_generateUtilityClasses.default)('MuiRadarAxisHighlight', [
    'root',
    'line',
    'dot'
]);

});



parcelRegister("cXfJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aPQl4 = parcelRequire("aPQl4");
Object.keys($aPQl4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aPQl4[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $aPQl4[key];
        }
    });
});

});
parcelRegister("aPQl4", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $7e37443bbbcee5db$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $7e37443bbbcee5db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarMetricLabels = $7e37443bbbcee5db$var$RadarMetricLabels;

var $7e37443bbbcee5db$var$_extends2 = $7e37443bbbcee5db$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $7e37443bbbcee5db$var$React = $7e37443bbbcee5db$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $2HN9m = parcelRequire("2HN9m");

var $1UYzZ = parcelRequire("1UYzZ");

var $41V8S = parcelRequire("41V8S");

var $ayMG0 = parcelRequire("ayMG0");
function $7e37443bbbcee5db$var$RadarMetricLabels() {
    const { corners: corners } = (0, $2HN9m.useRadarMetricData)();
    const theme = (0, $8xDHs.useTheme)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7e37443bbbcee5db$var$React.Fragment, {
        children: corners.map(({ x: x, y: y, angle: angle, label: label }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($41V8S.ChartsText, {
                x: x,
                y: y,
                fontSize: 14,
                fill: (theme.vars || theme).palette.text.primary,
                stroke: "none",
                text: label,
                style: (0, $7e37443bbbcee5db$var$_extends2.default)({}, theme.typography.caption, {
                    fontSize: 12,
                    lineHeight: 1.25,
                    textAnchor: (0, $1UYzZ.getDefaultTextAnchor)(180 + angle),
                    dominantBaseline: (0, $1UYzZ.getDefaultBaseline)(180 + angle)
                })
            }, i))
    });
}

});
parcelRegister("2HN9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarMetricData = $1f85b91843064aa8$var$useRadarMetricData;

var $gxvLm = parcelRequire("gxvLm");

var $55Xcx = parcelRequire("55Xcx");

var $1hcZZ = parcelRequire("1hcZZ");
function $1f85b91843064aa8$var$useRadarMetricData() {
    const rotationAxis = (0, $55Xcx.useRotationAxis)();
    const { scale: rotationScale, valueFormatter: valueFormatter, labelGap: labelGap = 10 } = rotationAxis;
    const { radiusAxis: radiusAxis } = (0, $55Xcx.useRadiusAxes)();
    const drawingArea = (0, $gxvLm.useDrawingArea)();
    const cx = drawingArea.left + drawingArea.width / 2;
    const cy = drawingArea.top + drawingArea.height / 2;
    const metrics = rotationScale.domain();
    const angles = metrics.map((key)=>rotationScale(key));
    return {
        corners: metrics.map((metric, dataIndex)=>{
            const radiusScale = radiusAxis[metric].scale;
            const r = radiusScale.range()[1] + labelGap;
            const angle = angles[dataIndex];
            const defaultTickLabel = metric;
            return {
                x: cx + r * Math.sin(angle),
                y: cy - r * Math.cos(angle),
                angle: (0, $1hcZZ.rad2deg)(angle),
                label: valueFormatter?.(metric, {
                    location: 'tick',
                    scale: rotationScale,
                    defaultTickLabel: defaultTickLabel
                }) ?? defaultTickLabel
            };
        })
    };
}

});



parcelRegister("7GmPu", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $597e2a209548309c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $597e2a209548309c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FocusedRadarMark = $597e2a209548309c$var$FocusedRadarMark;

var $597e2a209548309c$var$_extends2 = $597e2a209548309c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $597e2a209548309c$var$React = $597e2a209548309c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8xDHs = parcelRequire("8xDHs");

var $7ccUh = parcelRequire("7ccUh");

var $759ui = parcelRequire("759ui");

var $ayMG0 = parcelRequire("ayMG0");
function $597e2a209548309c$var$FocusedRadarMark(props) {
    const theme = (0, $8xDHs.useTheme)();
    const focusedItem = (0, $7ccUh.useFocusedItem)();
    const seriesCoordinates = (0, $759ui.useRadarSeriesData)(focusedItem?.seriesId);
    if (!focusedItem || focusedItem.type !== 'radar' || seriesCoordinates.length === 0) return null;
    const point = seriesCoordinates[0].points[focusedItem.dataIndex];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", (0, $597e2a209548309c$var$_extends2.default)({
        fill: "none",
        stroke: (theme.vars ?? theme).palette.text.primary,
        strokeWidth: 2,
        x: point.x - 6,
        y: point.y - 6,
        width: 12,
        height: 12,
        rx: 3,
        ry: 3
    }, props));
}

});


parcelRegister("bkgAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8K04b = parcelRequire("8K04b");
Object.keys($8K04b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8K04b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8K04b[key];
        }
    });
});

});

parcelRegister("iZhwM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd2b8525dc888d5f$var$_exportNames = {
    chartsAxisClasses: true
};
Object.defineProperty(module.exports, "chartsAxisClasses", {
    enumerable: true,
    get: function() {
        return $dZ0Du.chartsAxisClasses;
    }
});

var $ctVcM = parcelRequire("ctVcM");
Object.keys($ctVcM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dd2b8525dc888d5f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ctVcM[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ctVcM[key];
        }
    });
});

var $fNe8W = parcelRequire("fNe8W");
Object.keys($fNe8W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dd2b8525dc888d5f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fNe8W[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fNe8W[key];
        }
    });
});

var $dZ0Du = parcelRequire("dZ0Du");

});
parcelRegister("ctVcM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9164913bb3788be1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $9164913bb3788be1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RadarAxis = $9164913bb3788be1$var$RadarAxis;

var $9164913bb3788be1$var$_extends2 = $9164913bb3788be1$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $9164913bb3788be1$var$React = $9164913bb3788be1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $9164913bb3788be1$var$_propTypes = $9164913bb3788be1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $8xDHs = parcelRequire("8xDHs");

var $fNe8W = parcelRequire("fNe8W");

var $g4KRW = parcelRequire("g4KRW");

var $dZ0Du = parcelRequire("dZ0Du");

var $ayMG0 = parcelRequire("ayMG0");
function $9164913bb3788be1$var$RadarAxis(props) {
    const { labelOrientation: labelOrientation = 'horizontal', textAnchor: textAnchor, dominantBaseline: dominantBaseline } = props;
    const classes = (0, $dZ0Du.useUtilityClasses)(props.classes);
    const theme = (0, $8xDHs.useTheme)();
    const data = (0, $fNe8W.useRadarAxis)(props);
    if (data === null) return null;
    const { center: center, angle: angle, labels: labels } = data;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: `M ${center.x} ${center.y} L ${labels[labels.length - 1].x} ${labels[labels.length - 1].y}`,
                stroke: (theme.vars ?? theme).palette.text.primary,
                strokeOpacity: 0.3,
                className: classes.line
            }),
            labels.map(({ x: x, y: y, formattedValue: formattedValue })=>/*#__PURE__*/ (0, $ayMG0.jsx)("text", (0, $9164913bb3788be1$var$_extends2.default)({
                    fontSize: 12,
                    fill: (theme.vars ?? theme).palette.text.primary,
                    stroke: "none",
                    className: classes.label
                }, (0, $g4KRW.getLabelAttributes)({
                    labelOrientation: labelOrientation,
                    x: x,
                    y: y,
                    angle: angle,
                    textAnchor: textAnchor,
                    dominantBaseline: dominantBaseline
                }), {
                    children: formattedValue
                }), formattedValue))
        ]
    });
}

});
parcelRegister("fNe8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRadarAxis = $b7f6672ccbd4eb8a$var$useRadarAxis;

var $9Y8Cp = parcelRequire("9Y8Cp");

var $55Xcx = parcelRequire("55Xcx");

var $kzIRL = parcelRequire("kzIRL");

var $1HhaP = parcelRequire("1HhaP");

var $j98pQ = parcelRequire("j98pQ");

var $2UPWB = parcelRequire("2UPWB");

var $1Vg3M = parcelRequire("1Vg3M");

var $bCsNZ = parcelRequire("bCsNZ");

var $1hcZZ = parcelRequire("1hcZZ");
/**
 * Returns an array with on item par metrics with the different point to label.
 */ function $b7f6672ccbd4eb8a$var$useRadarAxis(params) {
    const { metric: metric, angle: angle, divisions: divisions = 1 } = params;
    const { instance: instance, store: store } = (0, $1HhaP.useChartContext)();
    const rotationScale = (0, $kzIRL.useRotationScale)();
    const { radiusAxis: radiusAxis } = (0, $55Xcx.useRadiusAxes)();
    const { cx: cx, cy: cy } = store.use($j98pQ.selectorChartPolarCenter);
    if (metric === undefined || !rotationScale || rotationScale.domain().length === 0) return null;
    const existingMetrics = rotationScale.domain();
    if (!existingMetrics.includes(metric)) (0, $9Y8Cp.warnOnce)([
        `MUI X Charts: You radar axis try displaying values for the metric "${metric}" which does nto exist.`,
        `either add this metric to your radar, or pick one from the existing metrics: ${existingMetrics.join(', ')}`
    ]);
    const anglesWithDefault = angle !== undefined ? (0, $1Vg3M.degToRad)(angle) : rotationScale(metric) ?? 0;
    const radiusRatio = Array.from({
        length: divisions
    }, (_, index)=>(index + 1) / divisions);
    const radiusScale = radiusAxis[metric].scale;
    const R = radiusScale.range()[1];
    if ((0, $2UPWB.isOrdinalScale)(radiusScale)) return null;
    return {
        metric: metric,
        angle: (0, $bCsNZ.clampAngle)((0, $1hcZZ.rad2deg)(anglesWithDefault)),
        center: {
            x: cx,
            y: cy
        },
        labels: radiusRatio.map((ratio)=>{
            const radius = ratio * R;
            const [x, y] = instance.polar2svg(radius, anglesWithDefault);
            const value = radiusScale.invert(radius);
            const defaultTickLabel = value.toString();
            return {
                x: x,
                y: y,
                value: value,
                formattedValue: radiusAxis[metric].valueFormatter?.(radiusScale.invert(radius), {
                    location: 'tick',
                    scale: radiusScale,
                    defaultTickLabel: defaultTickLabel,
                    tickNumber: divisions
                }) ?? defaultTickLabel
            };
        })
    };
}

});

parcelRegister("g4KRW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLabelAttributes = $bb41604c1dcc0481$var$getLabelAttributes;
/**
 * Return text anchor of labels.
 * @param angle The axis angle (in rad) with clock direction and 0 at the top
 */ function $bb41604c1dcc0481$var$getTextAnchor(angle) {
    if (angle < 20) return 'start';
    if (angle < 80) return 'end';
    if (angle < 260) return 'start';
    if (angle < 340) return 'end';
    return 'start';
}
function $bb41604c1dcc0481$var$getDominantBaseline(angle) {
    if (angle < 160) return 'auto';
    if (angle < 340) return 'hanging';
    return 'auto';
}
const $bb41604c1dcc0481$var$LABEL_MARGIN = 2;
function $bb41604c1dcc0481$var$getLabelAttributes(params) {
    const { x: x, y: y, angle: angle } = params;
    if (params.labelOrientation === 'horizontal') {
        const textAnchor = typeof params.textAnchor === 'function' ? params.textAnchor(angle) : params.textAnchor ?? $bb41604c1dcc0481$var$getTextAnchor(angle);
        const dominantBaseline = typeof params.dominantBaseline === 'function' ? params.dominantBaseline(angle) : params.dominantBaseline ?? $bb41604c1dcc0481$var$getDominantBaseline(angle);
        const marginX = textAnchor === 'start' ? $bb41604c1dcc0481$var$LABEL_MARGIN : -$bb41604c1dcc0481$var$LABEL_MARGIN;
        const marginY = dominantBaseline === 'auto' ? -$bb41604c1dcc0481$var$LABEL_MARGIN : $bb41604c1dcc0481$var$LABEL_MARGIN;
        return {
            x: x + marginX,
            y: y + marginY,
            textAnchor: textAnchor,
            dominantBaseline: dominantBaseline
        };
    }
    // orientation='rotated'
    const textAnchor = typeof params.textAnchor === 'function' ? params.textAnchor(angle) : params.textAnchor ?? 'start';
    const dominantBaseline = typeof params.dominantBaseline === 'function' ? params.dominantBaseline(angle) : params.dominantBaseline ?? 'auto';
    return {
        x: x,
        y: y,
        textAnchor: textAnchor,
        dominantBaseline: dominantBaseline,
        transform: `rotate(${angle}, ${x}, ${y})`
    };
}

});

parcelRegister("dZ0Du", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a2e1772216e9a268$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chartsAxisClasses = void 0;
module.exports.getRadarAxisUtilityClass = $a2e1772216e9a268$var$getRadarAxisUtilityClass;
module.exports.useUtilityClasses = void 0;

var $a2e1772216e9a268$var$_composeClasses = $a2e1772216e9a268$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $a2e1772216e9a268$var$_generateUtilityClass = $a2e1772216e9a268$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $a2e1772216e9a268$var$_generateUtilityClasses = $a2e1772216e9a268$require$_interopRequireDefault((parcelRequire("5nY49")));
function $a2e1772216e9a268$var$getRadarAxisUtilityClass(slot) {
    return (0, $a2e1772216e9a268$var$_generateUtilityClass.default)('MuiRadarAxis', slot);
}
const $a2e1772216e9a268$var$chartsAxisClasses = module.exports.chartsAxisClasses = (0, $a2e1772216e9a268$var$_generateUtilityClasses.default)('MuiRadarAxis', [
    'root',
    'line',
    'label'
]);
const $a2e1772216e9a268$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        line: [
            'line'
        ],
        label: [
            'label'
        ]
    };
    return (0, $a2e1772216e9a268$var$_composeClasses.default)(slots, $a2e1772216e9a268$var$getRadarAxisUtilityClass, classes);
};
module.exports.useUtilityClasses = $a2e1772216e9a268$var$useUtilityClasses;

});




parcelRegister("foeof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9iSlu = parcelRequire("9iSlu");
Object.keys($9iSlu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $9iSlu[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9iSlu[key];
        }
    });
});

});
parcelRegister("9iSlu", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $6c5ff36301f67b3c$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6c5ff36301f67b3c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsContainer = void 0;

var $6c5ff36301f67b3c$var$_extends2 = $6c5ff36301f67b3c$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $6c5ff36301f67b3c$var$React = $6c5ff36301f67b3c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6c5ff36301f67b3c$var$_propTypes = $6c5ff36301f67b3c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $kZwzL = parcelRequire("kZwzL");

var $hJcWr = parcelRequire("hJcWr");

var $ezMKh = parcelRequire("ezMKh");

var $ayMG0 = parcelRequire("ayMG0");
/**
 * It sets up the data providers as well as the `<svg>` for the chart.
 *
 * This is a combination of both the `ChartsDataProvider` and `ChartsSurface` components.
 *
 * Demos:
 *
 * - [Composition](https://mui.com/x/api/charts/composition/)
 *
 * API:
 *
 * - [ChartsContainer API](https://mui.com/x/api/charts/charts-container/)
 *
 * @example
 * ```jsx
 * <ChartsContainer
 *   series={[{ label: "Label", type: "bar", data: [10, 20] }]}
 *   xAxis={[{ data: ["A", "B"], scaleType: "band", id: "x-axis" }]}
 * >
 *    <BarPlot />
 *    <ChartsXAxis axisId="x-axis" />
 * </ChartsContainer>
 * ```
 */ const $6c5ff36301f67b3c$var$ChartsContainer = module.exports.ChartsContainer = /*#__PURE__*/ $6c5ff36301f67b3c$var$React.forwardRef(function ChartsContainer(props, ref) {
    const { chartDataProviderProps: chartDataProviderProps, children: children, chartsSurfaceProps: chartsSurfaceProps } = (0, $hJcWr.useChartsContainerProps)(props, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($kZwzL.ChartsDataProvider, (0, $6c5ff36301f67b3c$var$_extends2.default)({}, chartDataProviderProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ezMKh.ChartsSurface, (0, $6c5ff36301f67b3c$var$_extends2.default)({}, chartsSurfaceProps, {
            ref: ref,
            children: children
        }))
    }));
});

});


parcelRegister("auEOm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cfVEP = parcelRequire("cfVEP");
Object.keys($cfVEP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $cfVEP[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cfVEP[key];
        }
    });
});

});
parcelRegister("cfVEP", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartContainer = void 0;

var $foeof = parcelRequire("foeof");
/**
 * @deprecated Use `ChartsContainerSlots` instead. We added S to the charts prefix to align with other components.
 */ /**
 * @deprecated Use `ChartsContainerSlotProps` instead. We added S to the charts prefix to align with other components.
 */ /**
 * @deprecated Use `ChartsContainerProps` instead. We added S to the charts prefix to align with other components.
 */ /**
 * @deprecated Use `ChartsContainer` instead. We added S to the charts prefix to align with other components.
 */ const $8ec39c5226dcb4b9$var$ChartContainer = module.exports.ChartContainer = $foeof.ChartsContainer;

});


parcelRegister("ii0sh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ChartsBrushOverlay", {
    enumerable: true,
    get: function() {
        return $6dYOO.ChartsBrushOverlay;
    }
});
Object.defineProperty(module.exports, "brushOverlayClasses", {
    enumerable: true,
    get: function() {
        return $ekUQq.brushOverlayClasses;
    }
});

var $6dYOO = parcelRequire("6dYOO");

var $ekUQq = parcelRequire("ekUQq");

});
parcelRegister("6dYOO", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $48832244900f3ef8$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $48832244900f3ef8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChartsBrushOverlay = $48832244900f3ef8$var$ChartsBrushOverlay;

var $48832244900f3ef8$var$_extends2 = $48832244900f3ef8$require$_interopRequireDefault((parcelRequire("3p9rK")));

var $48832244900f3ef8$var$React = $48832244900f3ef8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $48832244900f3ef8$var$_clsx = $48832244900f3ef8$require$_interopRequireDefault((parcelRequire("9QePP")));

var $8xDHs = parcelRequire("8xDHs");

var $ekUQq = parcelRequire("ekUQq");

var $eWN1p = parcelRequire("eWN1p");

var $b4u9m = parcelRequire("b4u9m");

var $d3mgr = parcelRequire("d3mgr");

var $ayMG0 = parcelRequire("ayMG0");
function $48832244900f3ef8$var$BrushRect(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("rect", (0, $48832244900f3ef8$var$_extends2.default)({
        className: $ekUQq.brushOverlayClasses.rect,
        strokeWidth: 1,
        fillOpacity: 0.2,
        pointerEvents: 'none'
    }, props));
}
/**
 * Component that renders visual feedback during brush interaction
 */ function $48832244900f3ef8$var$ChartsBrushOverlay(props) {
    const store = (0, $d3mgr.useStore)();
    const drawingArea = store.use($eWN1p.selectorChartDrawingArea);
    const theme = (0, $8xDHs.useTheme)();
    const brushStartX = store.use($b4u9m.selectorBrushStartX);
    const brushStartY = store.use($b4u9m.selectorBrushStartY);
    const brushCurrentX = store.use($b4u9m.selectorBrushCurrentX);
    const brushCurrentY = store.use($b4u9m.selectorBrushCurrentY);
    const brushConfig = store.use($b4u9m.selectorBrushConfig);
    if (brushStartX === null || brushStartY === null || brushCurrentX === null || brushCurrentY === null) return null;
    const { left: left, top: top, width: width, height: height } = drawingArea;
    // Clamp coordinates to drawing area
    const clampX = (x)=>Math.max(left, Math.min(left + width, x));
    const clampY = (y)=>Math.max(top, Math.min(top + height, y));
    const startX = clampX(brushStartX);
    const startY = clampY(brushStartY);
    const currentX = clampX(brushCurrentX);
    const currentY = clampY(brushCurrentY);
    const rectColor = theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white;
    // For scatter charts, show only the rectangle without guide lines
    if (brushConfig === 'xy') {
        const rectWidth = currentX - startX;
        const rectHeight = currentY - startY;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            className: (0, $48832244900f3ef8$var$_clsx.default)($ekUQq.brushOverlayClasses.root, $ekUQq.brushOverlayClasses.x, $ekUQq.brushOverlayClasses.y),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($48832244900f3ef8$var$BrushRect, (0, $48832244900f3ef8$var$_extends2.default)({
                fill: rectColor,
                x: rectWidth >= 0 ? startX : currentX,
                y: rectHeight >= 0 ? startY : currentY,
                width: Math.abs(rectWidth),
                height: Math.abs(rectHeight)
            }, props))
        });
    }
    if (brushConfig === 'y') {
        const minY = Math.min(startY, currentY);
        const maxY = Math.max(startY, currentY);
        const rectHeight = maxY - minY;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            className: (0, $48832244900f3ef8$var$_clsx.default)($ekUQq.brushOverlayClasses.root, $ekUQq.brushOverlayClasses.y),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($48832244900f3ef8$var$BrushRect, (0, $48832244900f3ef8$var$_extends2.default)({
                fill: rectColor,
                x: left,
                y: minY,
                width: width,
                height: rectHeight
            }, props))
        });
    }
    const minX = Math.min(startX, currentX);
    const maxX = Math.max(startX, currentX);
    const rectWidth = maxX - minX;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
        className: (0, $48832244900f3ef8$var$_clsx.default)($ekUQq.brushOverlayClasses.root, $ekUQq.brushOverlayClasses.x),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($48832244900f3ef8$var$BrushRect, (0, $48832244900f3ef8$var$_extends2.default)({
            fill: rectColor,
            x: minX,
            y: top,
            width: rectWidth,
            height: height
        }, props))
    });
}

});
parcelRegister("ekUQq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a6ff0712a9867dfa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.brushOverlayClasses = void 0;

var $a6ff0712a9867dfa$var$_generateUtilityClasses = $a6ff0712a9867dfa$require$_interopRequireDefault((parcelRequire("5nY49")));
const $a6ff0712a9867dfa$var$brushOverlayClasses = module.exports.brushOverlayClasses = (0, $a6ff0712a9867dfa$var$_generateUtilityClasses.default)('MuiChartsBrushOverlay', [
    'root',
    'rect',
    'x',
    'y'
]);

});



parcelRegister("2YiER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $229fa875b3f5c8cf$var$_exportNames = {
    tickFrequencies: true
};
Object.defineProperty(module.exports, "tickFrequencies", {
    enumerable: true,
    get: function() {
        return $7XaaK.tickFrequencies;
    }
});

var $dbHoa = parcelRequire("dbHoa");
Object.keys($dbHoa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($229fa875b3f5c8cf$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dbHoa[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dbHoa[key];
        }
    });
});

var $7XaaK = parcelRequire("7XaaK");

});
parcelRegister("dbHoa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.niceDomain = $999df58cff0c1f49$var$niceDomain;

var $ar6SO = parcelRequire("ar6SO");
/**
 * Returns a nice domain for the given scale type and domain.
 * Does not modify the original domain.
 *
 * Providing a count improves the nice domain calculation by trying to align tick values to round
 * numbers or dates.
 *
 * For example, if you have a domain of [29, 72] and there are 5 ticks, the nice domain will be
 * [20, 80] so that the ticks can be at [20, 35, 50, 65, 80].
 * However, if there are 11 ticks, the nice domain will be [25, 75] so that the ticks can be at
 * [25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75].
 *
 * @param scaleType The type of the scale (e.g., 'linear', 'log', 'time', etc.).
 * @param domain The domain to be made nicer.
 * @param count An optional number of ticks to improve the nice domain calculation. Defaults to 5.
 */ function $999df58cff0c1f49$var$niceDomain(scaleType, domain, count = 5) {
    const scale = (0, $ar6SO.getScale)(scaleType, domain, [
        0,
        1
    ]);
    scale.nice(count);
    return scale.domain();
}

});



parcelRegister("d8hK4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eac43774031e509f$var$BaseChartVisualization;

var $eac43774031e509f$var$_react = $eac43774031e509f$var$_interopRequireWildcard((parcelRequire("acw62")));
var $eac43774031e509f$var$React = $eac43774031e509f$var$_react;

var $cvg8Z = parcelRequire("cvg8Z");

var $3u6kV = parcelRequire("3u6kV");

var $dOn5J = parcelRequire("dOn5J");

var $ayMG0 = parcelRequire("ayMG0");
function $eac43774031e509f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($eac43774031e509f$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $eac43774031e509f$var$BaseChartVisualization({ table: table, valuename: valuename, timeField: timeField, measurements: measurements, timeFrom: timeFrom, timeTo: timeTo, unit: unit, osmName: osmName }) {
    const [sensorData, setSensorData] = (0, $eac43774031e509f$var$_react.useState)({});
    const [loading, setLoading] = (0, $eac43774031e509f$var$_react.useState)(true);
    const [error, setError] = (0, $eac43774031e509f$var$_react.useState)(null);
    const shortUnit = (0, $dOn5J.extractUnit)(unit);
    (0, $eac43774031e509f$var$_react.useEffect)(()=>{
        Promise.all(measurements.map((name)=>(0, $3u6kV.getData)(table, timeField, timeFrom, timeTo, name, osmName).then((data)=>({
                    name: name,
                    data: data
                })))).then((results)=>{
            const mappedData = {};
            results.forEach(({ name: name, data: data })=>{
                mappedData[name] = data;
            });
            setSensorData(mappedData);
            setLoading(false);
        }).catch((err)=>{
            setError(err.message);
            setLoading(false);
        });
    }, [
        table,
        timeField,
        timeFrom,
        timeTo,
        measurements,
        osmName
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "Loading..."
    });
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        color: "error",
        children: error
    });
    const firstDataset = sensorData[measurements[0]];
    if (!firstDataset || !firstDataset.length) return /*#__PURE__*/ (0, $ayMG0.jsx)($cvg8Z.Typography, {
        children: "No data found"
    });
    const xLabels = firstDataset.map((item)=>new Date(item.bucket).toLocaleString());
    const series = measurements.filter((name)=>sensorData[name]?.length).map((name)=>{
        const data = sensorData[name].map((item)=>parseFloat(item[valuename]));
        const rawName = sensorData[name][0]?.name || name;
        const osmName = sensorData[name][0]?.osm_name || '';
        const label = `${$dOn5J.DESC_MAP[rawName] ?? rawName}${osmName ? ` (${osmName})` : ''}`;
        return {
            data: data,
            label: label,
            showMark: false,
            valueFormatter: (v)=>v !== null ? `${v.toFixed(2)} ${shortUnit}` : ''
        };
    });
    return {
        series: series,
        xLabels: xLabels,
        shortUnit: shortUnit
    };
}

});


parcelRegister("f1nIu", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $02d2792bdcdb4d5e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d2792bdcdb4d5e$var$_createSvgIcon = $02d2792bdcdb4d5e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $02d2792bdcdb4d5e$var$_default = module.exports.default = (0, $02d2792bdcdb4d5e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), 'ArrowUpward');

});

parcelRegister("2mYIR", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1b9cbd143c520a8e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b9cbd143c520a8e$var$_createSvgIcon = $1b9cbd143c520a8e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1b9cbd143c520a8e$var$_default = module.exports.default = (0, $1b9cbd143c520a8e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), 'ArrowDownward');

});




"use strict";

var $70fc9a727fa662ae$var$_react = $70fc9a727fa662ae$var$_interopRequireDefault((parcelRequire("acw62")));
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $cd93687958c8007e$exports = {};
"use strict";
Object.defineProperty($cd93687958c8007e$exports, "__esModule", {
    value: true
});
$cd93687958c8007e$exports.App = $cd93687958c8007e$var$App;

var $acw62 = parcelRequire("acw62");






var $cd93687958c8007e$var$_TemporaryDrawer = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("bKtXt")));

var $cd93687958c8007e$var$_Home = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("01ZMx")));

var $cd93687958c8007e$var$_Dashboard = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("1dmEI")));

var $cd93687958c8007e$var$_TariffPage = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("d74V5")));

var $cd93687958c8007e$var$_AlertsPage = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("a8sxV")));

var $cd93687958c8007e$var$_AlertContacts = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("6peqI")));

var $cd93687958c8007e$var$_AlertRules = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("9NFlG")));

var $cd93687958c8007e$var$_SensorStatus = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("gxtOa")));

var $cd93687958c8007e$var$_DashboardList = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("lGscg")));

var $cd93687958c8007e$var$_OverviewDashboard = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("SqHyZ")));

var $gwjoH = parcelRequire("gwjoH");

var $jYLYD = parcelRequire("jYLYD");
var $39ed6cda71bc273d$exports = {};
"use strict";
Object.defineProperty($39ed6cda71bc273d$exports, "__esModule", {
    value: true
});
$39ed6cda71bc273d$exports.ProtectedRoute = $39ed6cda71bc273d$var$ProtectedRoute;

var $gwjoH = parcelRequire("gwjoH");

var $ayMG0 = parcelRequire("ayMG0");
function $39ed6cda71bc273d$var$ProtectedRoute({ user: user, isAdmin: isAdmin, role: role, children: children }) {
    const isAuthenticated = !!user && !user.expired;
    const hasRole = role === 'admin' ? !!isAdmin : true;
    if (!isAuthenticated) return /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Navigate, {
        to: "/unauthorised",
        replace: true
    });
    if (!hasRole) return /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Navigate, {
        to: "/unauthorised",
        replace: true
    });
    return children;
}



var $cd93687958c8007e$var$_unauthorisedPage = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("c1Ui0")));

var $cd93687958c8007e$var$_userManagementPage = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("TUODY")));

var $cd93687958c8007e$var$_createUserPage = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("jLuHz")));

var $cd93687958c8007e$var$_editUserPage = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("lTDJM")));

var $cd93687958c8007e$var$_callback = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("7fZw0")));

var $9xY2t = parcelRequire("9xY2t");

var $cd93687958c8007e$var$_auth = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("ca6gO")));

var $cd93687958c8007e$var$_DynamicDashboard = $cd93687958c8007e$var$_interopRequireDefault((parcelRequire("iG1hL")));

var $ayMG0 = parcelRequire("ayMG0");
function $cd93687958c8007e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $cd93687958c8007e$var$App({ initialUser: initialUser }) {
    const { data: routeList, loading: loading } = (0, $jYLYD.useOsmNames)();
    const [user, setUser] = (0, $acw62.useState)(initialUser);
    const [groups, setGroups] = (0, $acw62.useState)([]);
    const [authLoading, setAuthLoading] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        const loadAuth = async ()=>{
            const u = await $cd93687958c8007e$var$_auth.default.getUser();
            if (u) {
                setUser(u);
                const g = await (0, $9xY2t.getUserGroups)();
                setGroups(g);
            }
            setAuthLoading(false);
        };
        loadAuth();
        $cd93687958c8007e$var$_auth.default.events.addUserLoaded(async (u)=>{
            setUser(u);
            const g = await (0, $9xY2t.getUserGroups)();
            setGroups(g);
            setAuthLoading(false);
        });
        return ()=>{
            $cd93687958c8007e$var$_auth.default.events.removeUserLoaded(()=>{});
        };
    }, []);
    const admin = groups.includes('admin');
    if (authLoading) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.StrictMode, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("center", {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "main-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_TemporaryDrawer.default, {
                        user: user,
                        isAdmin: admin
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($gwjoH.Routes, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                path: "/callback",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_callback.default, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($gwjoH.Route, {
                                path: "/",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_Dashboard.default, {}),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_Home.default, {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "sensor-status",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_SensorStatus.default, {
                                            isAdmin: admin
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "dashboard-list",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_DashboardList.default, {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "tariffs",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_TariffPage.default, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "overview",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_OverviewDashboard.default, {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "alerts",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_AlertsPage.default, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "alert-rules",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_AlertRules.default, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "alert-contacts",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_AlertContacts.default, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "users",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_userManagementPage.default, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "users/create",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_createUserPage.default, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "users/edit/:id",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($39ed6cda71bc273d$exports.ProtectedRoute, {
                                            user: user,
                                            isAdmin: admin,
                                            role: "admin",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_editUserPage.default, {})
                                        })
                                    }),
                                    routeList.map((route)=>/*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                            path: route.osm_name,
                                            element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_DynamicDashboard.default, {
                                                osmName: route.osm_name,
                                                isAdmin: admin
                                            })
                                        }, route.osm_name)),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                                        path: "unauthorised",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$_unauthorisedPage.default, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}



var $gwjoH = parcelRequire("gwjoH");

var $70fc9a727fa662ae$var$_auth = $70fc9a727fa662ae$var$_interopRequireDefault((parcelRequire("ca6gO")));

var $9xY2t = parcelRequire("9xY2t");

var $ayMG0 = parcelRequire("ayMG0");
function $70fc9a727fa662ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $70fc9a727fa662ae$var$container = document.getElementById('app');
async function $70fc9a727fa662ae$var$main() {
    const isCallback = window.location.pathname === '/callback';
    if (isCallback) {
        $70fc9a727fa662ae$var$renderApp(null);
        return;
    }
    const user = await $70fc9a727fa662ae$var$_auth.default.getUser();
    if (!user || user.expired) {
        await (0, $9xY2t.login)();
        return;
    }
    $70fc9a727fa662ae$var$renderApp(user);
}
function $70fc9a727fa662ae$var$renderApp(user) {
    const root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($70fc9a727fa662ae$var$_react.default.StrictMode, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.BrowserRouter, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Routes, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($gwjoH.Route, {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$exports.App, {
                        initialUser: user
                    })
                })
            })
        })
    }));
}
$70fc9a727fa662ae$var$main();


//# sourceMappingURL=skylight.543fa716.js.map
